var $se = Object.defineProperty;
var Ose = (e, t, n) => t in e ? $se(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n;
var ye = (e, t, n) => (Ose(e, typeof t != "symbol" ? t + "" : t, n), n);
import { O as Pse, i as Cz, M as yN, B as Vs, A as Mse, _ as Z$, U as kse, S as Tz, m as Nse, D as Dse, a as Kd, C as Lse, c as km, g as pn, L as jse, b as Fse, d as Vse, P as Bse, e as zse, f as Iz, h as ir, j as Wn, k as Az, l as Hse, u as wa, n as ui, o as Rz, w as Use, p as Wse, q as Ts, r as bc, s as O2, t as dI, v as qse, x as Gse, y as Kse } from "./text-6655b9ca.mjs";
import { E as gSt, G as pSt, H as mSt, I as vSt, F as ySt, z as bSt, J as _St } from "./text-6655b9ca.mjs";
import * as I from "react";
import D, { useContext as St, useRef as Me, useCallback as mn, useDebugValue as Yse, version as Xse, isValidElement as eO, createContext as Is, useLayoutEffect as Nv, useEffect as gt, useState as Lt, forwardRef as ta, useMemo as At, Children as Qse, createRef as Jse, useImperativeHandle as tO, cloneElement as $z, memo as hi, createElement as Yd, Fragment as Oz } from "react";
import * as Zse from "react-dom";
import bN, { unstable_batchedUpdates as nO, createPortal as rO, flushSync as fI } from "react-dom";
import Ce, { StyleSheetManager as ece, keyframes as iO, css as tce, styled as nce } from "styled-components";
var hI = { exports: {} }, im = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var _N;
function rce() {
  if (_N)
    return im;
  _N = 1;
  var e = D, t = Symbol.for("react.element"), n = Symbol.for("react.fragment"), r = Object.prototype.hasOwnProperty, i = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function a(s, c, l) {
    var u, d = {}, f = null, h = null;
    l !== void 0 && (f = "" + l), c.key !== void 0 && (f = "" + c.key), c.ref !== void 0 && (h = c.ref);
    for (u in c)
      r.call(c, u) && !o.hasOwnProperty(u) && (d[u] = c[u]);
    if (s && s.defaultProps)
      for (u in c = s.defaultProps, c)
        d[u] === void 0 && (d[u] = c[u]);
    return { $$typeof: t, type: s, key: f, ref: h, props: d, _owner: i.current };
  }
  return im.Fragment = n, im.jsx = a, im.jsxs = a, im;
}
var om = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var SN;
function ice() {
  return SN || (SN = 1, process.env.NODE_ENV !== "production" && function() {
    var e = D, t = Symbol.for("react.element"), n = Symbol.for("react.portal"), r = Symbol.for("react.fragment"), i = Symbol.for("react.strict_mode"), o = Symbol.for("react.profiler"), a = Symbol.for("react.provider"), s = Symbol.for("react.context"), c = Symbol.for("react.forward_ref"), l = Symbol.for("react.suspense"), u = Symbol.for("react.suspense_list"), d = Symbol.for("react.memo"), f = Symbol.for("react.lazy"), h = Symbol.for("react.offscreen"), p = Symbol.iterator, g = "@@iterator";
    function m(ne) {
      if (ne === null || typeof ne != "object")
        return null;
      var _e = p && ne[p] || ne[g];
      return typeof _e == "function" ? _e : null;
    }
    var v = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function y(ne) {
      {
        for (var _e = arguments.length, $e = new Array(_e > 1 ? _e - 1 : 0), qe = 1; qe < _e; qe++)
          $e[qe - 1] = arguments[qe];
        S("error", ne, $e);
      }
    }
    function S(ne, _e, $e) {
      {
        var qe = v.ReactDebugCurrentFrame, xt = qe.getStackAddendum();
        xt !== "" && (_e += "%s", $e = $e.concat([xt]));
        var bt = $e.map(function(st) {
          return String(st);
        });
        bt.unshift("Warning: " + _e), Function.prototype.apply.call(console[ne], console, bt);
      }
    }
    var _ = !1, w = !1, T = !1, x = !1, C = !1, E;
    E = Symbol.for("react.module.reference");
    function R(ne) {
      return !!(typeof ne == "string" || typeof ne == "function" || ne === r || ne === o || C || ne === i || ne === l || ne === u || x || ne === h || _ || w || T || typeof ne == "object" && ne !== null && (ne.$$typeof === f || ne.$$typeof === d || ne.$$typeof === a || ne.$$typeof === s || ne.$$typeof === c || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      ne.$$typeof === E || ne.getModuleId !== void 0));
    }
    function A(ne, _e, $e) {
      var qe = ne.displayName;
      if (qe)
        return qe;
      var xt = _e.displayName || _e.name || "";
      return xt !== "" ? $e + "(" + xt + ")" : $e;
    }
    function O(ne) {
      return ne.displayName || "Context";
    }
    function $(ne) {
      if (ne == null)
        return null;
      if (typeof ne.tag == "number" && y("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof ne == "function")
        return ne.displayName || ne.name || null;
      if (typeof ne == "string")
        return ne;
      switch (ne) {
        case r:
          return "Fragment";
        case n:
          return "Portal";
        case o:
          return "Profiler";
        case i:
          return "StrictMode";
        case l:
          return "Suspense";
        case u:
          return "SuspenseList";
      }
      if (typeof ne == "object")
        switch (ne.$$typeof) {
          case s:
            var _e = ne;
            return O(_e) + ".Consumer";
          case a:
            var $e = ne;
            return O($e._context) + ".Provider";
          case c:
            return A(ne, ne.render, "ForwardRef");
          case d:
            var qe = ne.displayName || null;
            return qe !== null ? qe : $(ne.type) || "Memo";
          case f: {
            var xt = ne, bt = xt._payload, st = xt._init;
            try {
              return $(st(bt));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var N = Object.assign, z = 0, k, F, V, j, B, U, Q;
    function K() {
    }
    K.__reactDisabledLog = !0;
    function q() {
      {
        if (z === 0) {
          k = console.log, F = console.info, V = console.warn, j = console.error, B = console.group, U = console.groupCollapsed, Q = console.groupEnd;
          var ne = {
            configurable: !0,
            enumerable: !0,
            value: K,
            writable: !0
          };
          Object.defineProperties(console, {
            info: ne,
            log: ne,
            warn: ne,
            error: ne,
            group: ne,
            groupCollapsed: ne,
            groupEnd: ne
          });
        }
        z++;
      }
    }
    function X() {
      {
        if (z--, z === 0) {
          var ne = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: N({}, ne, {
              value: k
            }),
            info: N({}, ne, {
              value: F
            }),
            warn: N({}, ne, {
              value: V
            }),
            error: N({}, ne, {
              value: j
            }),
            group: N({}, ne, {
              value: B
            }),
            groupCollapsed: N({}, ne, {
              value: U
            }),
            groupEnd: N({}, ne, {
              value: Q
            })
          });
        }
        z < 0 && y("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var ie = v.ReactCurrentDispatcher, te;
    function J(ne, _e, $e) {
      {
        if (te === void 0)
          try {
            throw Error();
          } catch (xt) {
            var qe = xt.stack.trim().match(/\n( *(at )?)/);
            te = qe && qe[1] || "";
          }
        return `
` + te + ne;
      }
    }
    var Y = !1, ee;
    {
      var Z = typeof WeakMap == "function" ? WeakMap : Map;
      ee = new Z();
    }
    function H(ne, _e) {
      if (!ne || Y)
        return "";
      {
        var $e = ee.get(ne);
        if ($e !== void 0)
          return $e;
      }
      var qe;
      Y = !0;
      var xt = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var bt;
      bt = ie.current, ie.current = null, q();
      try {
        if (_e) {
          var st = function() {
            throw Error();
          };
          if (Object.defineProperty(st.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(st, []);
            } catch (It) {
              qe = It;
            }
            Reflect.construct(ne, [], st);
          } else {
            try {
              st.call();
            } catch (It) {
              qe = It;
            }
            ne.call(st.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (It) {
            qe = It;
          }
          ne();
        }
      } catch (It) {
        if (It && qe && typeof It.stack == "string") {
          for (var Rt = It.stack.split(`
`), Ke = qe.stack.split(`
`), ke = Rt.length - 1, Xe = Ke.length - 1; ke >= 1 && Xe >= 0 && Rt[ke] !== Ke[Xe]; )
            Xe--;
          for (; ke >= 1 && Xe >= 0; ke--, Xe--)
            if (Rt[ke] !== Ke[Xe]) {
              if (ke !== 1 || Xe !== 1)
                do
                  if (ke--, Xe--, Xe < 0 || Rt[ke] !== Ke[Xe]) {
                    var ct = `
` + Rt[ke].replace(" at new ", " at ");
                    return ne.displayName && ct.includes("<anonymous>") && (ct = ct.replace("<anonymous>", ne.displayName)), typeof ne == "function" && ee.set(ne, ct), ct;
                  }
                while (ke >= 1 && Xe >= 0);
              break;
            }
        }
      } finally {
        Y = !1, ie.current = bt, X(), Error.prepareStackTrace = xt;
      }
      var Ue = ne ? ne.displayName || ne.name : "", Dt = Ue ? J(Ue) : "";
      return typeof ne == "function" && ee.set(ne, Dt), Dt;
    }
    function oe(ne, _e, $e) {
      return H(ne, !1);
    }
    function W(ne) {
      var _e = ne.prototype;
      return !!(_e && _e.isReactComponent);
    }
    function se(ne, _e, $e) {
      if (ne == null)
        return "";
      if (typeof ne == "function")
        return H(ne, W(ne));
      if (typeof ne == "string")
        return J(ne);
      switch (ne) {
        case l:
          return J("Suspense");
        case u:
          return J("SuspenseList");
      }
      if (typeof ne == "object")
        switch (ne.$$typeof) {
          case c:
            return oe(ne.render);
          case d:
            return se(ne.type, _e, $e);
          case f: {
            var qe = ne, xt = qe._payload, bt = qe._init;
            try {
              return se(bt(xt), _e, $e);
            } catch {
            }
          }
        }
      return "";
    }
    var ce = Object.prototype.hasOwnProperty, ge = {}, he = v.ReactDebugCurrentFrame;
    function ue(ne) {
      if (ne) {
        var _e = ne._owner, $e = se(ne.type, ne._source, _e ? _e.type : null);
        he.setExtraStackFrame($e);
      } else
        he.setExtraStackFrame(null);
    }
    function Ee(ne, _e, $e, qe, xt) {
      {
        var bt = Function.call.bind(ce);
        for (var st in ne)
          if (bt(ne, st)) {
            var Rt = void 0;
            try {
              if (typeof ne[st] != "function") {
                var Ke = Error((qe || "React class") + ": " + $e + " type `" + st + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof ne[st] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw Ke.name = "Invariant Violation", Ke;
              }
              Rt = ne[st](_e, st, qe, $e, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (ke) {
              Rt = ke;
            }
            Rt && !(Rt instanceof Error) && (ue(xt), y("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", qe || "React class", $e, st, typeof Rt), ue(null)), Rt instanceof Error && !(Rt.message in ge) && (ge[Rt.message] = !0, ue(xt), y("Failed %s type: %s", $e, Rt.message), ue(null));
          }
      }
    }
    var pe = Array.isArray;
    function Oe(ne) {
      return pe(ne);
    }
    function de(ne) {
      {
        var _e = typeof Symbol == "function" && Symbol.toStringTag, $e = _e && ne[Symbol.toStringTag] || ne.constructor.name || "Object";
        return $e;
      }
    }
    function be(ne) {
      try {
        return Ie(ne), !1;
      } catch {
        return !0;
      }
    }
    function Ie(ne) {
      return "" + ne;
    }
    function Ve(ne) {
      if (be(ne))
        return y("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", de(ne)), Ie(ne);
    }
    var Fe = v.ReactCurrentOwner, Pe = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, ot, dt, ft;
    ft = {};
    function wt(ne) {
      if (ce.call(ne, "ref")) {
        var _e = Object.getOwnPropertyDescriptor(ne, "ref").get;
        if (_e && _e.isReactWarning)
          return !1;
      }
      return ne.ref !== void 0;
    }
    function Ge(ne) {
      if (ce.call(ne, "key")) {
        var _e = Object.getOwnPropertyDescriptor(ne, "key").get;
        if (_e && _e.isReactWarning)
          return !1;
      }
      return ne.key !== void 0;
    }
    function at(ne, _e) {
      if (typeof ne.ref == "string" && Fe.current && _e && Fe.current.stateNode !== _e) {
        var $e = $(Fe.current.type);
        ft[$e] || (y('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', $(Fe.current.type), ne.ref), ft[$e] = !0);
      }
    }
    function Nt(ne, _e) {
      {
        var $e = function() {
          ot || (ot = !0, y("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", _e));
        };
        $e.isReactWarning = !0, Object.defineProperty(ne, "key", {
          get: $e,
          configurable: !0
        });
      }
    }
    function zt(ne, _e) {
      {
        var $e = function() {
          dt || (dt = !0, y("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", _e));
        };
        $e.isReactWarning = !0, Object.defineProperty(ne, "ref", {
          get: $e,
          configurable: !0
        });
      }
    }
    var kt = function(ne, _e, $e, qe, xt, bt, st) {
      var Rt = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: t,
        // Built-in properties that belong on the element
        type: ne,
        key: _e,
        ref: $e,
        props: st,
        // Record the component responsible for creating this element.
        _owner: bt
      };
      return Rt._store = {}, Object.defineProperty(Rt._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(Rt, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: qe
      }), Object.defineProperty(Rt, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: xt
      }), Object.freeze && (Object.freeze(Rt.props), Object.freeze(Rt)), Rt;
    };
    function Ct(ne, _e, $e, qe, xt) {
      {
        var bt, st = {}, Rt = null, Ke = null;
        $e !== void 0 && (Ve($e), Rt = "" + $e), Ge(_e) && (Ve(_e.key), Rt = "" + _e.key), wt(_e) && (Ke = _e.ref, at(_e, xt));
        for (bt in _e)
          ce.call(_e, bt) && !Pe.hasOwnProperty(bt) && (st[bt] = _e[bt]);
        if (ne && ne.defaultProps) {
          var ke = ne.defaultProps;
          for (bt in ke)
            st[bt] === void 0 && (st[bt] = ke[bt]);
        }
        if (Rt || Ke) {
          var Xe = typeof ne == "function" ? ne.displayName || ne.name || "Unknown" : ne;
          Rt && Nt(st, Xe), Ke && zt(st, Xe);
        }
        return kt(ne, Rt, Ke, xt, qe, Fe.current, st);
      }
    }
    var yt = v.ReactCurrentOwner, Mn = v.ReactDebugCurrentFrame;
    function Pt(ne) {
      if (ne) {
        var _e = ne._owner, $e = se(ne.type, ne._source, _e ? _e.type : null);
        Mn.setExtraStackFrame($e);
      } else
        Mn.setExtraStackFrame(null);
    }
    var Ze;
    Ze = !1;
    function Le(ne) {
      return typeof ne == "object" && ne !== null && ne.$$typeof === t;
    }
    function rt() {
      {
        if (yt.current) {
          var ne = $(yt.current.type);
          if (ne)
            return `

Check the render method of \`` + ne + "`.";
        }
        return "";
      }
    }
    function ut(ne) {
      {
        if (ne !== void 0) {
          var _e = ne.fileName.replace(/^.*[\\\/]/, ""), $e = ne.lineNumber;
          return `

Check your code at ` + _e + ":" + $e + ".";
        }
        return "";
      }
    }
    var vt = {};
    function We(ne) {
      {
        var _e = rt();
        if (!_e) {
          var $e = typeof ne == "string" ? ne : ne.displayName || ne.name;
          $e && (_e = `

Check the top-level render call using <` + $e + ">.");
        }
        return _e;
      }
    }
    function et(ne, _e) {
      {
        if (!ne._store || ne._store.validated || ne.key != null)
          return;
        ne._store.validated = !0;
        var $e = We(_e);
        if (vt[$e])
          return;
        vt[$e] = !0;
        var qe = "";
        ne && ne._owner && ne._owner !== yt.current && (qe = " It was passed a child from " + $(ne._owner.type) + "."), Pt(ne), y('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', $e, qe), Pt(null);
      }
    }
    function Ne(ne, _e) {
      {
        if (typeof ne != "object")
          return;
        if (Oe(ne))
          for (var $e = 0; $e < ne.length; $e++) {
            var qe = ne[$e];
            Le(qe) && et(qe, _e);
          }
        else if (Le(ne))
          ne._store && (ne._store.validated = !0);
        else if (ne) {
          var xt = m(ne);
          if (typeof xt == "function" && xt !== ne.entries)
            for (var bt = xt.call(ne), st; !(st = bt.next()).done; )
              Le(st.value) && et(st.value, _e);
        }
      }
    }
    function Yt(ne) {
      {
        var _e = ne.type;
        if (_e == null || typeof _e == "string")
          return;
        var $e;
        if (typeof _e == "function")
          $e = _e.propTypes;
        else if (typeof _e == "object" && (_e.$$typeof === c || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        _e.$$typeof === d))
          $e = _e.propTypes;
        else
          return;
        if ($e) {
          var qe = $(_e);
          Ee($e, ne.props, "prop", qe, ne);
        } else if (_e.PropTypes !== void 0 && !Ze) {
          Ze = !0;
          var xt = $(_e);
          y("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", xt || "Unknown");
        }
        typeof _e.getDefaultProps == "function" && !_e.getDefaultProps.isReactClassApproved && y("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Ht(ne) {
      {
        for (var _e = Object.keys(ne.props), $e = 0; $e < _e.length; $e++) {
          var qe = _e[$e];
          if (qe !== "children" && qe !== "key") {
            Pt(ne), y("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", qe), Pt(null);
            break;
          }
        }
        ne.ref !== null && (Pt(ne), y("Invalid attribute `ref` supplied to `React.Fragment`."), Pt(null));
      }
    }
    var Be = {};
    function ze(ne, _e, $e, qe, xt, bt) {
      {
        var st = R(ne);
        if (!st) {
          var Rt = "";
          (ne === void 0 || typeof ne == "object" && ne !== null && Object.keys(ne).length === 0) && (Rt += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var Ke = ut(xt);
          Ke ? Rt += Ke : Rt += rt();
          var ke;
          ne === null ? ke = "null" : Oe(ne) ? ke = "array" : ne !== void 0 && ne.$$typeof === t ? (ke = "<" + ($(ne.type) || "Unknown") + " />", Rt = " Did you accidentally export a JSX literal instead of a component?") : ke = typeof ne, y("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", ke, Rt);
        }
        var Xe = Ct(ne, _e, $e, xt, bt);
        if (Xe == null)
          return Xe;
        if (st) {
          var ct = _e.children;
          if (ct !== void 0)
            if (qe)
              if (Oe(ct)) {
                for (var Ue = 0; Ue < ct.length; Ue++)
                  Ne(ct[Ue], ne);
                Object.freeze && Object.freeze(ct);
              } else
                y("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              Ne(ct, ne);
        }
        if (ce.call(_e, "key")) {
          var Dt = $(ne), It = Object.keys(_e).filter(function(Gn) {
            return Gn !== "key";
          }), wn = It.length > 0 ? "{key: someKey, " + It.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!Be[Dt + wn]) {
            var gr = It.length > 0 ? "{" + It.join(": ..., ") + ": ...}" : "{}";
            y(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, wn, Dt, gr, Dt), Be[Dt + wn] = !0;
          }
        }
        return ne === r ? Ht(Xe) : Yt(Xe), Xe;
      }
    }
    function it(ne, _e, $e) {
      return ze(ne, _e, $e, !0);
    }
    function lt(ne, _e, $e) {
      return ze(ne, _e, $e, !1);
    }
    var Tt = lt, jt = it;
    om.Fragment = r, om.jsx = Tt, om.jsxs = jt;
  }()), om;
}
process.env.NODE_ENV === "production" ? hI.exports = rce() : hI.exports = ice();
var M = hI.exports, gI = { exports: {} }, P2 = {};
/**
 * @license React
 * use-sync-external-store-shim.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var wN;
function oce() {
  if (wN)
    return P2;
  wN = 1;
  var e = D;
  function t(d, f) {
    return d === f && (d !== 0 || 1 / d === 1 / f) || d !== d && f !== f;
  }
  var n = typeof Object.is == "function" ? Object.is : t, r = e.useState, i = e.useEffect, o = e.useLayoutEffect, a = e.useDebugValue;
  function s(d, f) {
    var h = f(), p = r({ inst: { value: h, getSnapshot: f } }), g = p[0].inst, m = p[1];
    return o(function() {
      g.value = h, g.getSnapshot = f, c(g) && m({ inst: g });
    }, [d, h, f]), i(function() {
      return c(g) && m({ inst: g }), d(function() {
        c(g) && m({ inst: g });
      });
    }, [d]), a(h), h;
  }
  function c(d) {
    var f = d.getSnapshot;
    d = d.value;
    try {
      var h = f();
      return !n(d, h);
    } catch {
      return !0;
    }
  }
  function l(d, f) {
    return f();
  }
  var u = typeof window > "u" || typeof window.document > "u" || typeof window.document.createElement > "u" ? l : s;
  return P2.useSyncExternalStore = e.useSyncExternalStore !== void 0 ? e.useSyncExternalStore : u, P2;
}
var M2 = {};
/**
 * @license React
 * use-sync-external-store-shim.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var xN;
function ace() {
  return xN || (xN = 1, process.env.NODE_ENV !== "production" && function() {
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(new Error());
    var e = D, t = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function n(S) {
      {
        for (var _ = arguments.length, w = new Array(_ > 1 ? _ - 1 : 0), T = 1; T < _; T++)
          w[T - 1] = arguments[T];
        r("error", S, w);
      }
    }
    function r(S, _, w) {
      {
        var T = t.ReactDebugCurrentFrame, x = T.getStackAddendum();
        x !== "" && (_ += "%s", w = w.concat([x]));
        var C = w.map(function(E) {
          return String(E);
        });
        C.unshift("Warning: " + _), Function.prototype.apply.call(console[S], console, C);
      }
    }
    function i(S, _) {
      return S === _ && (S !== 0 || 1 / S === 1 / _) || S !== S && _ !== _;
    }
    var o = typeof Object.is == "function" ? Object.is : i, a = e.useState, s = e.useEffect, c = e.useLayoutEffect, l = e.useDebugValue, u = !1, d = !1;
    function f(S, _, w) {
      u || e.startTransition !== void 0 && (u = !0, n("You are using an outdated, pre-release alpha of React 18 that does not support useSyncExternalStore. The use-sync-external-store shim will not work correctly. Upgrade to a newer pre-release."));
      var T = _();
      if (!d) {
        var x = _();
        o(T, x) || (n("The result of getSnapshot should be cached to avoid an infinite loop"), d = !0);
      }
      var C = a({
        inst: {
          value: T,
          getSnapshot: _
        }
      }), E = C[0].inst, R = C[1];
      return c(function() {
        E.value = T, E.getSnapshot = _, h(E) && R({
          inst: E
        });
      }, [S, T, _]), s(function() {
        h(E) && R({
          inst: E
        });
        var A = function() {
          h(E) && R({
            inst: E
          });
        };
        return S(A);
      }, [S]), l(T), T;
    }
    function h(S) {
      var _ = S.getSnapshot, w = S.value;
      try {
        var T = _();
        return !o(w, T);
      } catch {
        return !0;
      }
    }
    function p(S, _, w) {
      return _();
    }
    var g = typeof window < "u" && typeof window.document < "u" && typeof window.document.createElement < "u", m = !g, v = m ? p : f, y = e.useSyncExternalStore !== void 0 ? e.useSyncExternalStore : v;
    M2.useSyncExternalStore = y, typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(new Error());
  }()), M2;
}
process.env.NODE_ENV === "production" ? gI.exports = oce() : gI.exports = ace();
var Pz = gI.exports, pI = { exports: {} }, k2 = {};
/**
 * @license React
 * use-sync-external-store-shim/with-selector.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var EN;
function sce() {
  if (EN)
    return k2;
  EN = 1;
  var e = D, t = Pz;
  function n(l, u) {
    return l === u && (l !== 0 || 1 / l === 1 / u) || l !== l && u !== u;
  }
  var r = typeof Object.is == "function" ? Object.is : n, i = t.useSyncExternalStore, o = e.useRef, a = e.useEffect, s = e.useMemo, c = e.useDebugValue;
  return k2.useSyncExternalStoreWithSelector = function(l, u, d, f, h) {
    var p = o(null);
    if (p.current === null) {
      var g = { hasValue: !1, value: null };
      p.current = g;
    } else
      g = p.current;
    p = s(function() {
      function v(T) {
        if (!y) {
          if (y = !0, S = T, T = f(T), h !== void 0 && g.hasValue) {
            var x = g.value;
            if (h(x, T))
              return _ = x;
          }
          return _ = T;
        }
        if (x = _, r(S, T))
          return x;
        var C = f(T);
        return h !== void 0 && h(x, C) ? x : (S = T, _ = C);
      }
      var y = !1, S, _, w = d === void 0 ? null : d;
      return [function() {
        return v(u());
      }, w === null ? void 0 : function() {
        return v(w());
      }];
    }, [u, d, f, h]);
    var m = i(l, p[0], p[1]);
    return a(function() {
      g.hasValue = !0, g.value = m;
    }, [m]), c(m), m;
  }, k2;
}
var N2 = {};
/**
 * @license React
 * use-sync-external-store-shim/with-selector.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var CN;
function cce() {
  return CN || (CN = 1, process.env.NODE_ENV !== "production" && function() {
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(new Error());
    var e = D, t = Pz;
    function n(u, d) {
      return u === d && (u !== 0 || 1 / u === 1 / d) || u !== u && d !== d;
    }
    var r = typeof Object.is == "function" ? Object.is : n, i = t.useSyncExternalStore, o = e.useRef, a = e.useEffect, s = e.useMemo, c = e.useDebugValue;
    function l(u, d, f, h, p) {
      var g = o(null), m;
      g.current === null ? (m = {
        hasValue: !1,
        value: null
      }, g.current = m) : m = g.current;
      var v = s(function() {
        var w = !1, T, x, C = function(O) {
          if (!w) {
            w = !0, T = O;
            var $ = h(O);
            if (p !== void 0 && m.hasValue) {
              var N = m.value;
              if (p(N, $))
                return x = N, N;
            }
            return x = $, $;
          }
          var z = T, k = x;
          if (r(z, O))
            return k;
          var F = h(O);
          return p !== void 0 && p(k, F) ? k : (T = O, x = F, F);
        }, E = f === void 0 ? null : f, R = function() {
          return C(d());
        }, A = E === null ? void 0 : function() {
          return C(E());
        };
        return [R, A];
      }, [d, f, h, p]), y = v[0], S = v[1], _ = i(u, y, S);
      return a(function() {
        m.hasValue = !0, m.value = _;
      }, [_]), c(_), _;
    }
    N2.useSyncExternalStoreWithSelector = l, typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(new Error());
  }()), N2;
}
process.env.NODE_ENV === "production" ? pI.exports = sce() : pI.exports = cce();
var lce = pI.exports;
function uce(e) {
  e();
}
let Mz = uce;
const dce = (e) => Mz = e, fce = () => Mz, TN = Symbol.for("react-redux-context"), IN = typeof globalThis < "u" ? globalThis : (
  /* fall back to a per-module scope (pre-8.1 behaviour) if `globalThis` is not available */
  {}
);
function hce() {
  var e;
  if (!I.createContext)
    return {};
  const t = (e = IN[TN]) != null ? e : IN[TN] = /* @__PURE__ */ new Map();
  let n = t.get(I.createContext);
  return n || (n = I.createContext(null), process.env.NODE_ENV !== "production" && (n.displayName = "ReactRedux"), t.set(I.createContext, n)), n;
}
const hu = /* @__PURE__ */ hce();
function oO(e = hu) {
  return function() {
    const n = St(e);
    if (process.env.NODE_ENV !== "production" && !n)
      throw new Error("could not find react-redux context value; please ensure the component is wrapped in a <Provider>");
    return n;
  };
}
const kz = /* @__PURE__ */ oO(), gce = () => {
  throw new Error("uSES not initialized!");
};
let Nz = gce;
const pce = (e) => {
  Nz = e;
}, mce = (e, t) => e === t;
function vce(e = hu) {
  const t = e === hu ? kz : oO(e);
  return function(r, i = {}) {
    const {
      equalityFn: o = mce,
      stabilityCheck: a = void 0,
      noopCheck: s = void 0
    } = typeof i == "function" ? {
      equalityFn: i
    } : i;
    if (process.env.NODE_ENV !== "production") {
      if (!r)
        throw new Error("You must pass a selector to useSelector");
      if (typeof r != "function")
        throw new Error("You must pass a function as a selector to useSelector");
      if (typeof o != "function")
        throw new Error("You must pass a function as an equality function to useSelector");
    }
    const {
      store: c,
      subscription: l,
      getServerState: u,
      stabilityCheck: d,
      noopCheck: f
    } = t(), h = Me(!0), p = mn({
      [r.name](m) {
        const v = r(m);
        if (process.env.NODE_ENV !== "production") {
          const y = typeof a > "u" ? d : a;
          if (y === "always" || y === "once" && h.current) {
            const _ = r(m);
            if (!o(v, _)) {
              let w;
              try {
                throw new Error();
              } catch (T) {
                ({
                  stack: w
                } = T);
              }
              console.warn("Selector " + (r.name || "unknown") + ` returned a different result when called with the same parameters. This can lead to unnecessary rerenders.
Selectors that return a new reference (such as an object or an array) should be memoized: https://redux.js.org/usage/deriving-data-selectors#optimizing-selectors-with-memoization`, {
                state: m,
                selected: v,
                selected2: _,
                stack: w
              });
            }
          }
          const S = typeof s > "u" ? f : s;
          if ((S === "always" || S === "once" && h.current) && v === m) {
            let _;
            try {
              throw new Error();
            } catch (w) {
              ({
                stack: _
              } = w);
            }
            console.warn("Selector " + (r.name || "unknown") + ` returned the root state when called. This can lead to unnecessary rerenders.
Selectors that return the entire state are almost certainly a mistake, as they will cause a rerender whenever *anything* in state changes.`, {
              stack: _
            });
          }
          h.current && (h.current = !1);
        }
        return v;
      }
    }[r.name], [r, d, a]), g = Nz(l.addNestedSub, c.getState, u || c.getState, p, o);
    return Yse(g), g;
  };
}
const aO = /* @__PURE__ */ vce();
function mt() {
  return mt = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        ({}).hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, mt.apply(null, arguments);
}
function yce(e, t) {
  if (e == null)
    return {};
  var n = {};
  for (var r in e)
    if ({}.hasOwnProperty.call(e, r)) {
      if (t.includes(r))
        continue;
      n[r] = e[r];
    }
  return n;
}
var mI = { exports: {} }, Fn = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var AN;
function bce() {
  if (AN)
    return Fn;
  AN = 1;
  var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, n = e ? Symbol.for("react.portal") : 60106, r = e ? Symbol.for("react.fragment") : 60107, i = e ? Symbol.for("react.strict_mode") : 60108, o = e ? Symbol.for("react.profiler") : 60114, a = e ? Symbol.for("react.provider") : 60109, s = e ? Symbol.for("react.context") : 60110, c = e ? Symbol.for("react.async_mode") : 60111, l = e ? Symbol.for("react.concurrent_mode") : 60111, u = e ? Symbol.for("react.forward_ref") : 60112, d = e ? Symbol.for("react.suspense") : 60113, f = e ? Symbol.for("react.suspense_list") : 60120, h = e ? Symbol.for("react.memo") : 60115, p = e ? Symbol.for("react.lazy") : 60116, g = e ? Symbol.for("react.block") : 60121, m = e ? Symbol.for("react.fundamental") : 60117, v = e ? Symbol.for("react.responder") : 60118, y = e ? Symbol.for("react.scope") : 60119;
  function S(w) {
    if (typeof w == "object" && w !== null) {
      var T = w.$$typeof;
      switch (T) {
        case t:
          switch (w = w.type, w) {
            case c:
            case l:
            case r:
            case o:
            case i:
            case d:
              return w;
            default:
              switch (w = w && w.$$typeof, w) {
                case s:
                case u:
                case p:
                case h:
                case a:
                  return w;
                default:
                  return T;
              }
          }
        case n:
          return T;
      }
    }
  }
  function _(w) {
    return S(w) === l;
  }
  return Fn.AsyncMode = c, Fn.ConcurrentMode = l, Fn.ContextConsumer = s, Fn.ContextProvider = a, Fn.Element = t, Fn.ForwardRef = u, Fn.Fragment = r, Fn.Lazy = p, Fn.Memo = h, Fn.Portal = n, Fn.Profiler = o, Fn.StrictMode = i, Fn.Suspense = d, Fn.isAsyncMode = function(w) {
    return _(w) || S(w) === c;
  }, Fn.isConcurrentMode = _, Fn.isContextConsumer = function(w) {
    return S(w) === s;
  }, Fn.isContextProvider = function(w) {
    return S(w) === a;
  }, Fn.isElement = function(w) {
    return typeof w == "object" && w !== null && w.$$typeof === t;
  }, Fn.isForwardRef = function(w) {
    return S(w) === u;
  }, Fn.isFragment = function(w) {
    return S(w) === r;
  }, Fn.isLazy = function(w) {
    return S(w) === p;
  }, Fn.isMemo = function(w) {
    return S(w) === h;
  }, Fn.isPortal = function(w) {
    return S(w) === n;
  }, Fn.isProfiler = function(w) {
    return S(w) === o;
  }, Fn.isStrictMode = function(w) {
    return S(w) === i;
  }, Fn.isSuspense = function(w) {
    return S(w) === d;
  }, Fn.isValidElementType = function(w) {
    return typeof w == "string" || typeof w == "function" || w === r || w === l || w === o || w === i || w === d || w === f || typeof w == "object" && w !== null && (w.$$typeof === p || w.$$typeof === h || w.$$typeof === a || w.$$typeof === s || w.$$typeof === u || w.$$typeof === m || w.$$typeof === v || w.$$typeof === y || w.$$typeof === g);
  }, Fn.typeOf = S, Fn;
}
var Vn = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var RN;
function _ce() {
  return RN || (RN = 1, process.env.NODE_ENV !== "production" && function() {
    var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, n = e ? Symbol.for("react.portal") : 60106, r = e ? Symbol.for("react.fragment") : 60107, i = e ? Symbol.for("react.strict_mode") : 60108, o = e ? Symbol.for("react.profiler") : 60114, a = e ? Symbol.for("react.provider") : 60109, s = e ? Symbol.for("react.context") : 60110, c = e ? Symbol.for("react.async_mode") : 60111, l = e ? Symbol.for("react.concurrent_mode") : 60111, u = e ? Symbol.for("react.forward_ref") : 60112, d = e ? Symbol.for("react.suspense") : 60113, f = e ? Symbol.for("react.suspense_list") : 60120, h = e ? Symbol.for("react.memo") : 60115, p = e ? Symbol.for("react.lazy") : 60116, g = e ? Symbol.for("react.block") : 60121, m = e ? Symbol.for("react.fundamental") : 60117, v = e ? Symbol.for("react.responder") : 60118, y = e ? Symbol.for("react.scope") : 60119;
    function S(H) {
      return typeof H == "string" || typeof H == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      H === r || H === l || H === o || H === i || H === d || H === f || typeof H == "object" && H !== null && (H.$$typeof === p || H.$$typeof === h || H.$$typeof === a || H.$$typeof === s || H.$$typeof === u || H.$$typeof === m || H.$$typeof === v || H.$$typeof === y || H.$$typeof === g);
    }
    function _(H) {
      if (typeof H == "object" && H !== null) {
        var oe = H.$$typeof;
        switch (oe) {
          case t:
            var W = H.type;
            switch (W) {
              case c:
              case l:
              case r:
              case o:
              case i:
              case d:
                return W;
              default:
                var se = W && W.$$typeof;
                switch (se) {
                  case s:
                  case u:
                  case p:
                  case h:
                  case a:
                    return se;
                  default:
                    return oe;
                }
            }
          case n:
            return oe;
        }
      }
    }
    var w = c, T = l, x = s, C = a, E = t, R = u, A = r, O = p, $ = h, N = n, z = o, k = i, F = d, V = !1;
    function j(H) {
      return V || (V = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), B(H) || _(H) === c;
    }
    function B(H) {
      return _(H) === l;
    }
    function U(H) {
      return _(H) === s;
    }
    function Q(H) {
      return _(H) === a;
    }
    function K(H) {
      return typeof H == "object" && H !== null && H.$$typeof === t;
    }
    function q(H) {
      return _(H) === u;
    }
    function X(H) {
      return _(H) === r;
    }
    function ie(H) {
      return _(H) === p;
    }
    function te(H) {
      return _(H) === h;
    }
    function J(H) {
      return _(H) === n;
    }
    function Y(H) {
      return _(H) === o;
    }
    function ee(H) {
      return _(H) === i;
    }
    function Z(H) {
      return _(H) === d;
    }
    Vn.AsyncMode = w, Vn.ConcurrentMode = T, Vn.ContextConsumer = x, Vn.ContextProvider = C, Vn.Element = E, Vn.ForwardRef = R, Vn.Fragment = A, Vn.Lazy = O, Vn.Memo = $, Vn.Portal = N, Vn.Profiler = z, Vn.StrictMode = k, Vn.Suspense = F, Vn.isAsyncMode = j, Vn.isConcurrentMode = B, Vn.isContextConsumer = U, Vn.isContextProvider = Q, Vn.isElement = K, Vn.isForwardRef = q, Vn.isFragment = X, Vn.isLazy = ie, Vn.isMemo = te, Vn.isPortal = J, Vn.isProfiler = Y, Vn.isStrictMode = ee, Vn.isSuspense = Z, Vn.isValidElementType = S, Vn.typeOf = _;
  }()), Vn;
}
process.env.NODE_ENV === "production" ? mI.exports = bce() : mI.exports = _ce();
var sO = mI.exports, Dz = sO, Sce = {
  $$typeof: !0,
  render: !0,
  defaultProps: !0,
  displayName: !0,
  propTypes: !0
}, wce = {
  $$typeof: !0,
  compare: !0,
  defaultProps: !0,
  displayName: !0,
  propTypes: !0,
  type: !0
}, Lz = {};
Lz[Dz.ForwardRef] = Sce;
Lz[Dz.Memo] = wce;
var Bn = {};
/**
 * @license React
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var $N;
function xce() {
  if ($N)
    return Bn;
  $N = 1;
  var e = Symbol.for("react.element"), t = Symbol.for("react.portal"), n = Symbol.for("react.fragment"), r = Symbol.for("react.strict_mode"), i = Symbol.for("react.profiler"), o = Symbol.for("react.provider"), a = Symbol.for("react.context"), s = Symbol.for("react.server_context"), c = Symbol.for("react.forward_ref"), l = Symbol.for("react.suspense"), u = Symbol.for("react.suspense_list"), d = Symbol.for("react.memo"), f = Symbol.for("react.lazy"), h = Symbol.for("react.offscreen"), p;
  p = Symbol.for("react.module.reference");
  function g(m) {
    if (typeof m == "object" && m !== null) {
      var v = m.$$typeof;
      switch (v) {
        case e:
          switch (m = m.type, m) {
            case n:
            case i:
            case r:
            case l:
            case u:
              return m;
            default:
              switch (m = m && m.$$typeof, m) {
                case s:
                case a:
                case c:
                case f:
                case d:
                case o:
                  return m;
                default:
                  return v;
              }
          }
        case t:
          return v;
      }
    }
  }
  return Bn.ContextConsumer = a, Bn.ContextProvider = o, Bn.Element = e, Bn.ForwardRef = c, Bn.Fragment = n, Bn.Lazy = f, Bn.Memo = d, Bn.Portal = t, Bn.Profiler = i, Bn.StrictMode = r, Bn.Suspense = l, Bn.SuspenseList = u, Bn.isAsyncMode = function() {
    return !1;
  }, Bn.isConcurrentMode = function() {
    return !1;
  }, Bn.isContextConsumer = function(m) {
    return g(m) === a;
  }, Bn.isContextProvider = function(m) {
    return g(m) === o;
  }, Bn.isElement = function(m) {
    return typeof m == "object" && m !== null && m.$$typeof === e;
  }, Bn.isForwardRef = function(m) {
    return g(m) === c;
  }, Bn.isFragment = function(m) {
    return g(m) === n;
  }, Bn.isLazy = function(m) {
    return g(m) === f;
  }, Bn.isMemo = function(m) {
    return g(m) === d;
  }, Bn.isPortal = function(m) {
    return g(m) === t;
  }, Bn.isProfiler = function(m) {
    return g(m) === i;
  }, Bn.isStrictMode = function(m) {
    return g(m) === r;
  }, Bn.isSuspense = function(m) {
    return g(m) === l;
  }, Bn.isSuspenseList = function(m) {
    return g(m) === u;
  }, Bn.isValidElementType = function(m) {
    return typeof m == "string" || typeof m == "function" || m === n || m === i || m === r || m === l || m === u || m === h || typeof m == "object" && m !== null && (m.$$typeof === f || m.$$typeof === d || m.$$typeof === o || m.$$typeof === a || m.$$typeof === c || m.$$typeof === p || m.getModuleId !== void 0);
  }, Bn.typeOf = g, Bn;
}
var zn = {};
/**
 * @license React
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var ON;
function Ece() {
  return ON || (ON = 1, process.env.NODE_ENV !== "production" && function() {
    var e = Symbol.for("react.element"), t = Symbol.for("react.portal"), n = Symbol.for("react.fragment"), r = Symbol.for("react.strict_mode"), i = Symbol.for("react.profiler"), o = Symbol.for("react.provider"), a = Symbol.for("react.context"), s = Symbol.for("react.server_context"), c = Symbol.for("react.forward_ref"), l = Symbol.for("react.suspense"), u = Symbol.for("react.suspense_list"), d = Symbol.for("react.memo"), f = Symbol.for("react.lazy"), h = Symbol.for("react.offscreen"), p = !1, g = !1, m = !1, v = !1, y = !1, S;
    S = Symbol.for("react.module.reference");
    function _(W) {
      return !!(typeof W == "string" || typeof W == "function" || W === n || W === i || y || W === r || W === l || W === u || v || W === h || p || g || m || typeof W == "object" && W !== null && (W.$$typeof === f || W.$$typeof === d || W.$$typeof === o || W.$$typeof === a || W.$$typeof === c || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      W.$$typeof === S || W.getModuleId !== void 0));
    }
    function w(W) {
      if (typeof W == "object" && W !== null) {
        var se = W.$$typeof;
        switch (se) {
          case e:
            var ce = W.type;
            switch (ce) {
              case n:
              case i:
              case r:
              case l:
              case u:
                return ce;
              default:
                var ge = ce && ce.$$typeof;
                switch (ge) {
                  case s:
                  case a:
                  case c:
                  case f:
                  case d:
                  case o:
                    return ge;
                  default:
                    return se;
                }
            }
          case t:
            return se;
        }
      }
    }
    var T = a, x = o, C = e, E = c, R = n, A = f, O = d, $ = t, N = i, z = r, k = l, F = u, V = !1, j = !1;
    function B(W) {
      return V || (V = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 18+.")), !1;
    }
    function U(W) {
      return j || (j = !0, console.warn("The ReactIs.isConcurrentMode() alias has been deprecated, and will be removed in React 18+.")), !1;
    }
    function Q(W) {
      return w(W) === a;
    }
    function K(W) {
      return w(W) === o;
    }
    function q(W) {
      return typeof W == "object" && W !== null && W.$$typeof === e;
    }
    function X(W) {
      return w(W) === c;
    }
    function ie(W) {
      return w(W) === n;
    }
    function te(W) {
      return w(W) === f;
    }
    function J(W) {
      return w(W) === d;
    }
    function Y(W) {
      return w(W) === t;
    }
    function ee(W) {
      return w(W) === i;
    }
    function Z(W) {
      return w(W) === r;
    }
    function H(W) {
      return w(W) === l;
    }
    function oe(W) {
      return w(W) === u;
    }
    zn.ContextConsumer = T, zn.ContextProvider = x, zn.Element = C, zn.ForwardRef = E, zn.Fragment = R, zn.Lazy = A, zn.Memo = O, zn.Portal = $, zn.Profiler = N, zn.StrictMode = z, zn.Suspense = k, zn.SuspenseList = F, zn.isAsyncMode = B, zn.isConcurrentMode = U, zn.isContextConsumer = Q, zn.isContextProvider = K, zn.isElement = q, zn.isForwardRef = X, zn.isFragment = ie, zn.isLazy = te, zn.isMemo = J, zn.isPortal = Y, zn.isProfiler = ee, zn.isStrictMode = Z, zn.isSuspense = H, zn.isSuspenseList = oe, zn.isValidElementType = _, zn.typeOf = w;
  }()), zn;
}
process.env.NODE_ENV === "production" ? xce() : Ece();
function Cce() {
  const e = fce();
  let t = null, n = null;
  return {
    clear() {
      t = null, n = null;
    },
    notify() {
      e(() => {
        let r = t;
        for (; r; )
          r.callback(), r = r.next;
      });
    },
    get() {
      let r = [], i = t;
      for (; i; )
        r.push(i), i = i.next;
      return r;
    },
    subscribe(r) {
      let i = !0, o = n = {
        callback: r,
        next: null,
        prev: n
      };
      return o.prev ? o.prev.next = o : t = o, function() {
        !i || t === null || (i = !1, o.next ? o.next.prev = o.prev : n = o.prev, o.prev ? o.prev.next = o.next : t = o.next);
      };
    }
  };
}
const PN = {
  notify() {
  },
  get: () => []
};
function Tce(e, t) {
  let n, r = PN, i = 0, o = !1;
  function a(g) {
    u();
    const m = r.subscribe(g);
    let v = !1;
    return () => {
      v || (v = !0, m(), d());
    };
  }
  function s() {
    r.notify();
  }
  function c() {
    p.onStateChange && p.onStateChange();
  }
  function l() {
    return o;
  }
  function u() {
    i++, n || (n = t ? t.addNestedSub(c) : e.subscribe(c), r = Cce());
  }
  function d() {
    i--, n && i === 0 && (n(), n = void 0, r.clear(), r = PN);
  }
  function f() {
    o || (o = !0, u());
  }
  function h() {
    o && (o = !1, d());
  }
  const p = {
    addNestedSub: a,
    notifyNestedSubs: s,
    handleChangeWrapper: c,
    isSubscribed: l,
    trySubscribe: f,
    tryUnsubscribe: h,
    getListeners: () => r
  };
  return p;
}
const Ice = typeof window < "u" && typeof window.document < "u" && typeof window.document.createElement < "u", Ace = Ice ? I.useLayoutEffect : I.useEffect;
function Rce({
  store: e,
  context: t,
  children: n,
  serverState: r,
  stabilityCheck: i = "once",
  noopCheck: o = "once"
}) {
  const a = I.useMemo(() => {
    const l = Tce(e);
    return {
      store: e,
      subscription: l,
      getServerState: r ? () => r : void 0,
      stabilityCheck: i,
      noopCheck: o
    };
  }, [e, r, i, o]), s = I.useMemo(() => e.getState(), [e]);
  Ace(() => {
    const {
      subscription: l
    } = a;
    return l.onStateChange = l.notifyNestedSubs, l.trySubscribe(), s !== e.getState() && l.notifyNestedSubs(), () => {
      l.tryUnsubscribe(), l.onStateChange = void 0;
    };
  }, [a, s]);
  const c = t || hu;
  return /* @__PURE__ */ I.createElement(c.Provider, {
    value: a
  }, n);
}
function jz(e = hu) {
  const t = (
    // @ts-ignore
    e === hu ? kz : (
      // @ts-ignore
      oO(e)
    )
  );
  return function() {
    const {
      store: r
    } = t();
    return r;
  };
}
const $ce = /* @__PURE__ */ jz();
function Oce(e = hu) {
  const t = (
    // @ts-ignore
    e === hu ? $ce : jz(e)
  );
  return function() {
    return t().dispatch;
  };
}
const Pce = /* @__PURE__ */ Oce();
pce(lce.useSyncExternalStoreWithSelector);
dce(nO);
function $i(e) {
  for (var t = arguments.length, n = Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++)
    n[r - 1] = arguments[r];
  if (process.env.NODE_ENV !== "production") {
    var i = Bce[e], o = i ? typeof i == "function" ? i.apply(null, n) : i : "unknown error nr: " + e;
    throw Error("[Immer] " + o);
  }
  throw Error("[Immer] minified error nr: " + e + (n.length ? " " + n.map(function(a) {
    return "'" + a + "'";
  }).join(",") : "") + ". Find the full error at: https://bit.ly/3cXEKWf");
}
function gu(e) {
  return !!e && !!e[Ar];
}
function el(e) {
  var t;
  return !!e && (function(n) {
    if (!n || typeof n != "object")
      return !1;
    var r = Object.getPrototypeOf(n);
    if (r === null)
      return !0;
    var i = Object.hasOwnProperty.call(r, "constructor") && r.constructor;
    return i === Object || typeof i == "function" && Function.toString.call(i) === zce;
  }(e) || Array.isArray(e) || !!e[FN] || !!(!((t = e.constructor) === null || t === void 0) && t[FN]) || cO(e) || lO(e));
}
function Xd(e, t, n) {
  n === void 0 && (n = !1), op(e) === 0 ? (n ? Object.keys : Bh)(e).forEach(function(r) {
    n && typeof r == "symbol" || t(r, e[r], e);
  }) : e.forEach(function(r, i) {
    return t(i, r, e);
  });
}
function op(e) {
  var t = e[Ar];
  return t ? t.i > 3 ? t.i - 4 : t.i : Array.isArray(e) ? 1 : cO(e) ? 2 : lO(e) ? 3 : 0;
}
function Vh(e, t) {
  return op(e) === 2 ? e.has(t) : Object.prototype.hasOwnProperty.call(e, t);
}
function Mce(e, t) {
  return op(e) === 2 ? e.get(t) : e[t];
}
function Fz(e, t, n) {
  var r = op(e);
  r === 2 ? e.set(t, n) : r === 3 ? e.add(n) : e[t] = n;
}
function Vz(e, t) {
  return e === t ? e !== 0 || 1 / e == 1 / t : e != e && t != t;
}
function cO(e) {
  return Fce && e instanceof Map;
}
function lO(e) {
  return Vce && e instanceof Set;
}
function Pl(e) {
  return e.o || e.t;
}
function uO(e) {
  if (Array.isArray(e))
    return Array.prototype.slice.call(e);
  var t = zz(e);
  delete t[Ar];
  for (var n = Bh(t), r = 0; r < n.length; r++) {
    var i = n[r], o = t[i];
    o.writable === !1 && (o.writable = !0, o.configurable = !0), (o.get || o.set) && (t[i] = { configurable: !0, writable: !0, enumerable: o.enumerable, value: e[i] });
  }
  return Object.create(Object.getPrototypeOf(e), t);
}
function dO(e, t) {
  return t === void 0 && (t = !1), fO(e) || gu(e) || !el(e) || (op(e) > 1 && (e.set = e.add = e.clear = e.delete = kce), Object.freeze(e), t && Xd(e, function(n, r) {
    return dO(r, !0);
  }, !0)), e;
}
function kce() {
  $i(2);
}
function fO(e) {
  return e == null || typeof e != "object" || Object.isFrozen(e);
}
function Js(e) {
  var t = _I[e];
  return t || $i(18, e), t;
}
function Nce(e, t) {
  _I[e] || (_I[e] = t);
}
function vI() {
  return process.env.NODE_ENV === "production" || sg || $i(0), sg;
}
function D2(e, t) {
  t && (Js("Patches"), e.u = [], e.s = [], e.v = t);
}
function c_(e) {
  yI(e), e.p.forEach(Dce), e.p = null;
}
function yI(e) {
  e === sg && (sg = e.l);
}
function MN(e) {
  return sg = { p: [], l: sg, h: e, m: !0, _: 0 };
}
function Dce(e) {
  var t = e[Ar];
  t.i === 0 || t.i === 1 ? t.j() : t.g = !0;
}
function L2(e, t) {
  t._ = t.p.length;
  var n = t.p[0], r = e !== void 0 && e !== n;
  return t.h.O || Js("ES5").S(t, e, r), r ? (n[Ar].P && (c_(t), $i(4)), el(e) && (e = l_(t, e), t.l || u_(t, e)), t.u && Js("Patches").M(n[Ar].t, e, t.u, t.s)) : e = l_(t, n, []), c_(t), t.u && t.v(t.u, t.s), e !== Bz ? e : void 0;
}
function l_(e, t, n) {
  if (fO(t))
    return t;
  var r = t[Ar];
  if (!r)
    return Xd(t, function(s, c) {
      return kN(e, r, t, s, c, n);
    }, !0), t;
  if (r.A !== e)
    return t;
  if (!r.P)
    return u_(e, r.t, !0), r.t;
  if (!r.I) {
    r.I = !0, r.A._--;
    var i = r.i === 4 || r.i === 5 ? r.o = uO(r.k) : r.o, o = i, a = !1;
    r.i === 3 && (o = new Set(i), i.clear(), a = !0), Xd(o, function(s, c) {
      return kN(e, r, i, s, c, n, a);
    }), u_(e, i, !1), n && e.u && Js("Patches").N(r, n, e.u, e.s);
  }
  return r.o;
}
function kN(e, t, n, r, i, o, a) {
  if (process.env.NODE_ENV !== "production" && i === n && $i(5), gu(i)) {
    var s = l_(e, i, o && t && t.i !== 3 && !Vh(t.R, r) ? o.concat(r) : void 0);
    if (Fz(n, r, s), !gu(s))
      return;
    e.m = !1;
  } else
    a && n.add(i);
  if (el(i) && !fO(i)) {
    if (!e.h.D && e._ < 1)
      return;
    l_(e, i), t && t.A.l || u_(e, i);
  }
}
function u_(e, t, n) {
  n === void 0 && (n = !1), !e.l && e.h.D && e.m && dO(t, n);
}
function j2(e, t) {
  var n = e[Ar];
  return (n ? Pl(n) : e)[t];
}
function NN(e, t) {
  if (t in e)
    for (var n = Object.getPrototypeOf(e); n; ) {
      var r = Object.getOwnPropertyDescriptor(n, t);
      if (r)
        return r;
      n = Object.getPrototypeOf(n);
    }
}
function jl(e) {
  e.P || (e.P = !0, e.l && jl(e.l));
}
function F2(e) {
  e.o || (e.o = uO(e.t));
}
function bI(e, t, n) {
  var r = cO(t) ? Js("MapSet").F(t, n) : lO(t) ? Js("MapSet").T(t, n) : e.O ? function(i, o) {
    var a = Array.isArray(i), s = { i: a ? 1 : 0, A: o ? o.A : vI(), P: !1, I: !1, R: {}, l: o, t: i, k: null, o: null, j: null, C: !1 }, c = s, l = k0;
    a && (c = [s], l = Nm);
    var u = Proxy.revocable(c, l), d = u.revoke, f = u.proxy;
    return s.k = f, s.j = d, f;
  }(t, n) : Js("ES5").J(t, n);
  return (n ? n.A : vI()).p.push(r), r;
}
function Lce(e) {
  return gu(e) || $i(22, e), function t(n) {
    if (!el(n))
      return n;
    var r, i = n[Ar], o = op(n);
    if (i) {
      if (!i.P && (i.i < 4 || !Js("ES5").K(i)))
        return i.t;
      i.I = !0, r = DN(n, o), i.I = !1;
    } else
      r = DN(n, o);
    return Xd(r, function(a, s) {
      i && Mce(i.t, a) === s || Fz(r, a, t(s));
    }), o === 3 ? new Set(r) : r;
  }(e);
}
function DN(e, t) {
  switch (t) {
    case 2:
      return new Map(e);
    case 3:
      return Array.from(e);
  }
  return uO(e);
}
function jce() {
  function e(a, s) {
    var c = o[a];
    return c ? c.enumerable = s : o[a] = c = { configurable: !0, enumerable: s, get: function() {
      var l = this[Ar];
      return process.env.NODE_ENV !== "production" && i(l), k0.get(l, a);
    }, set: function(l) {
      var u = this[Ar];
      process.env.NODE_ENV !== "production" && i(u), k0.set(u, a, l);
    } }, c;
  }
  function t(a) {
    for (var s = a.length - 1; s >= 0; s--) {
      var c = a[s][Ar];
      if (!c.P)
        switch (c.i) {
          case 5:
            r(c) && jl(c);
            break;
          case 4:
            n(c) && jl(c);
        }
    }
  }
  function n(a) {
    for (var s = a.t, c = a.k, l = Bh(c), u = l.length - 1; u >= 0; u--) {
      var d = l[u];
      if (d !== Ar) {
        var f = s[d];
        if (f === void 0 && !Vh(s, d))
          return !0;
        var h = c[d], p = h && h[Ar];
        if (p ? p.t !== f : !Vz(h, f))
          return !0;
      }
    }
    var g = !!s[Ar];
    return l.length !== Bh(s).length + (g ? 0 : 1);
  }
  function r(a) {
    var s = a.k;
    if (s.length !== a.t.length)
      return !0;
    var c = Object.getOwnPropertyDescriptor(s, s.length - 1);
    if (c && !c.get)
      return !0;
    for (var l = 0; l < s.length; l++)
      if (!s.hasOwnProperty(l))
        return !0;
    return !1;
  }
  function i(a) {
    a.g && $i(3, JSON.stringify(Pl(a)));
  }
  var o = {};
  Nce("ES5", { J: function(a, s) {
    var c = Array.isArray(a), l = function(d, f) {
      if (d) {
        for (var h = Array(f.length), p = 0; p < f.length; p++)
          Object.defineProperty(h, "" + p, e(p, !0));
        return h;
      }
      var g = zz(f);
      delete g[Ar];
      for (var m = Bh(g), v = 0; v < m.length; v++) {
        var y = m[v];
        g[y] = e(y, d || !!g[y].enumerable);
      }
      return Object.create(Object.getPrototypeOf(f), g);
    }(c, a), u = { i: c ? 5 : 4, A: s ? s.A : vI(), P: !1, I: !1, R: {}, l: s, t: a, k: l, o: null, g: !1, C: !1 };
    return Object.defineProperty(l, Ar, { value: u, writable: !0 }), l;
  }, S: function(a, s, c) {
    c ? gu(s) && s[Ar].A === a && t(a.p) : (a.u && function l(u) {
      if (u && typeof u == "object") {
        var d = u[Ar];
        if (d) {
          var f = d.t, h = d.k, p = d.R, g = d.i;
          if (g === 4)
            Xd(h, function(_) {
              _ !== Ar && (f[_] !== void 0 || Vh(f, _) ? p[_] || l(h[_]) : (p[_] = !0, jl(d)));
            }), Xd(f, function(_) {
              h[_] !== void 0 || Vh(h, _) || (p[_] = !1, jl(d));
            });
          else if (g === 5) {
            if (r(d) && (jl(d), p.length = !0), h.length < f.length)
              for (var m = h.length; m < f.length; m++)
                p[m] = !1;
            else
              for (var v = f.length; v < h.length; v++)
                p[v] = !0;
            for (var y = Math.min(h.length, f.length), S = 0; S < y; S++)
              h.hasOwnProperty(S) || (p[S] = !0), p[S] === void 0 && l(h[S]);
          }
        }
      }
    }(a.p[0]), t(a.p));
  }, K: function(a) {
    return a.i === 4 ? n(a) : r(a);
  } });
}
var LN, sg, hO = typeof Symbol < "u" && typeof Symbol("x") == "symbol", Fce = typeof Map < "u", Vce = typeof Set < "u", jN = typeof Proxy < "u" && Proxy.revocable !== void 0 && typeof Reflect < "u", Bz = hO ? Symbol.for("immer-nothing") : ((LN = {})["immer-nothing"] = !0, LN), FN = hO ? Symbol.for("immer-draftable") : "__$immer_draftable", Ar = hO ? Symbol.for("immer-state") : "__$immer_state", Bce = { 0: "Illegal state", 1: "Immer drafts cannot have computed properties", 2: "This object has been frozen and should not be mutated", 3: function(e) {
  return "Cannot use a proxy that has been revoked. Did you pass an object from inside an immer function to an async process? " + e;
}, 4: "An immer producer returned a new value *and* modified its draft. Either return a new value *or* modify the draft.", 5: "Immer forbids circular references", 6: "The first or second argument to `produce` must be a function", 7: "The third argument to `produce` must be a function or undefined", 8: "First argument to `createDraft` must be a plain object, an array, or an immerable object", 9: "First argument to `finishDraft` must be a draft returned by `createDraft`", 10: "The given draft is already finalized", 11: "Object.defineProperty() cannot be used on an Immer draft", 12: "Object.setPrototypeOf() cannot be used on an Immer draft", 13: "Immer only supports deleting array indices", 14: "Immer only supports setting array indices and the 'length' property", 15: function(e) {
  return "Cannot apply patch, path doesn't resolve: " + e;
}, 16: 'Sets cannot have "replace" patches.', 17: function(e) {
  return "Unsupported patch operation: " + e;
}, 18: function(e) {
  return "The plugin for '" + e + "' has not been loaded into Immer. To enable the plugin, import and call `enable" + e + "()` when initializing your application.";
}, 20: "Cannot use proxies if Proxy, Proxy.revocable or Reflect are not available", 21: function(e) {
  return "produce can only be called on things that are draftable: plain objects, arrays, Map, Set or classes that are marked with '[immerable]: true'. Got '" + e + "'";
}, 22: function(e) {
  return "'current' expects a draft, got: " + e;
}, 23: function(e) {
  return "'original' expects a draft, got: " + e;
}, 24: "Patching reserved attributes like __proto__, prototype and constructor is not allowed" }, zce = "" + Object.prototype.constructor, Bh = typeof Reflect < "u" && Reflect.ownKeys ? Reflect.ownKeys : Object.getOwnPropertySymbols !== void 0 ? function(e) {
  return Object.getOwnPropertyNames(e).concat(Object.getOwnPropertySymbols(e));
} : Object.getOwnPropertyNames, zz = Object.getOwnPropertyDescriptors || function(e) {
  var t = {};
  return Bh(e).forEach(function(n) {
    t[n] = Object.getOwnPropertyDescriptor(e, n);
  }), t;
}, _I = {}, k0 = { get: function(e, t) {
  if (t === Ar)
    return e;
  var n = Pl(e);
  if (!Vh(n, t))
    return function(i, o, a) {
      var s, c = NN(o, a);
      return c ? "value" in c ? c.value : (s = c.get) === null || s === void 0 ? void 0 : s.call(i.k) : void 0;
    }(e, n, t);
  var r = n[t];
  return e.I || !el(r) ? r : r === j2(e.t, t) ? (F2(e), e.o[t] = bI(e.A.h, r, e)) : r;
}, has: function(e, t) {
  return t in Pl(e);
}, ownKeys: function(e) {
  return Reflect.ownKeys(Pl(e));
}, set: function(e, t, n) {
  var r = NN(Pl(e), t);
  if (r != null && r.set)
    return r.set.call(e.k, n), !0;
  if (!e.P) {
    var i = j2(Pl(e), t), o = i == null ? void 0 : i[Ar];
    if (o && o.t === n)
      return e.o[t] = n, e.R[t] = !1, !0;
    if (Vz(n, i) && (n !== void 0 || Vh(e.t, t)))
      return !0;
    F2(e), jl(e);
  }
  return e.o[t] === n && (n !== void 0 || t in e.o) || Number.isNaN(n) && Number.isNaN(e.o[t]) || (e.o[t] = n, e.R[t] = !0), !0;
}, deleteProperty: function(e, t) {
  return j2(e.t, t) !== void 0 || t in e.t ? (e.R[t] = !1, F2(e), jl(e)) : delete e.R[t], e.o && delete e.o[t], !0;
}, getOwnPropertyDescriptor: function(e, t) {
  var n = Pl(e), r = Reflect.getOwnPropertyDescriptor(n, t);
  return r && { writable: !0, configurable: e.i !== 1 || t !== "length", enumerable: r.enumerable, value: n[t] };
}, defineProperty: function() {
  $i(11);
}, getPrototypeOf: function(e) {
  return Object.getPrototypeOf(e.t);
}, setPrototypeOf: function() {
  $i(12);
} }, Nm = {};
Xd(k0, function(e, t) {
  Nm[e] = function() {
    return arguments[0] = arguments[0][0], t.apply(this, arguments);
  };
}), Nm.deleteProperty = function(e, t) {
  return process.env.NODE_ENV !== "production" && isNaN(parseInt(t)) && $i(13), Nm.set.call(this, e, t, void 0);
}, Nm.set = function(e, t, n) {
  return process.env.NODE_ENV !== "production" && t !== "length" && isNaN(parseInt(t)) && $i(14), k0.set.call(this, e[0], t, n, e[0]);
};
var Hce = function() {
  function e(n) {
    var r = this;
    this.O = jN, this.D = !0, this.produce = function(i, o, a) {
      if (typeof i == "function" && typeof o != "function") {
        var s = o;
        o = i;
        var c = r;
        return function(g) {
          var m = this;
          g === void 0 && (g = s);
          for (var v = arguments.length, y = Array(v > 1 ? v - 1 : 0), S = 1; S < v; S++)
            y[S - 1] = arguments[S];
          return c.produce(g, function(_) {
            var w;
            return (w = o).call.apply(w, [m, _].concat(y));
          });
        };
      }
      var l;
      if (typeof o != "function" && $i(6), a !== void 0 && typeof a != "function" && $i(7), el(i)) {
        var u = MN(r), d = bI(r, i, void 0), f = !0;
        try {
          l = o(d), f = !1;
        } finally {
          f ? c_(u) : yI(u);
        }
        return typeof Promise < "u" && l instanceof Promise ? l.then(function(g) {
          return D2(u, a), L2(g, u);
        }, function(g) {
          throw c_(u), g;
        }) : (D2(u, a), L2(l, u));
      }
      if (!i || typeof i != "object") {
        if ((l = o(i)) === void 0 && (l = i), l === Bz && (l = void 0), r.D && dO(l, !0), a) {
          var h = [], p = [];
          Js("Patches").M(i, l, h, p), a(h, p);
        }
        return l;
      }
      $i(21, i);
    }, this.produceWithPatches = function(i, o) {
      if (typeof i == "function")
        return function(l) {
          for (var u = arguments.length, d = Array(u > 1 ? u - 1 : 0), f = 1; f < u; f++)
            d[f - 1] = arguments[f];
          return r.produceWithPatches(l, function(h) {
            return i.apply(void 0, [h].concat(d));
          });
        };
      var a, s, c = r.produce(i, o, function(l, u) {
        a = l, s = u;
      });
      return typeof Promise < "u" && c instanceof Promise ? c.then(function(l) {
        return [l, a, s];
      }) : [c, a, s];
    }, typeof (n == null ? void 0 : n.useProxies) == "boolean" && this.setUseProxies(n.useProxies), typeof (n == null ? void 0 : n.autoFreeze) == "boolean" && this.setAutoFreeze(n.autoFreeze);
  }
  var t = e.prototype;
  return t.createDraft = function(n) {
    el(n) || $i(8), gu(n) && (n = Lce(n));
    var r = MN(this), i = bI(this, n, void 0);
    return i[Ar].C = !0, yI(r), i;
  }, t.finishDraft = function(n, r) {
    var i = n && n[Ar];
    process.env.NODE_ENV !== "production" && (i && i.C || $i(9), i.I && $i(10));
    var o = i.A;
    return D2(o, r), L2(void 0, o);
  }, t.setAutoFreeze = function(n) {
    this.D = n;
  }, t.setUseProxies = function(n) {
    n && !jN && $i(20), this.O = n;
  }, t.applyPatches = function(n, r) {
    var i;
    for (i = r.length - 1; i >= 0; i--) {
      var o = r[i];
      if (o.path.length === 0 && o.op === "replace") {
        n = o.value;
        break;
      }
    }
    i > -1 && (r = r.slice(i + 1));
    var a = Js("Patches").$;
    return gu(n) ? a(n, r) : this.produce(n, function(s) {
      return a(s, r);
    });
  }, e;
}(), ya = new Hce(), Hz = ya.produce;
ya.produceWithPatches.bind(ya);
ya.setAutoFreeze.bind(ya);
ya.setUseProxies.bind(ya);
ya.applyPatches.bind(ya);
ya.createDraft.bind(ya);
ya.finishDraft.bind(ya);
function _t(e) {
  "@babel/helpers - typeof";
  return _t = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, _t(e);
}
function Uce(e, t) {
  if (_t(e) != "object" || !e)
    return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t || "default");
    if (_t(r) != "object")
      return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function Uz(e) {
  var t = Uce(e, "string");
  return _t(t) == "symbol" ? t : t + "";
}
function re(e, t, n) {
  return (t = Uz(t)) in e ? Object.defineProperty(e, t, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = n, e;
}
function VN(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function ae(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? VN(Object(n), !0).forEach(function(r) {
      re(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : VN(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function no(e) {
  return "Minified Redux error #" + e + "; visit https://redux.js.org/Errors?code=" + e + " for the full message or use the non-minified dev environment for full errors. ";
}
var BN = function() {
  return typeof Symbol == "function" && Symbol.observable || "@@observable";
}(), V2 = function() {
  return Math.random().toString(36).substring(7).split("").join(".");
}, Pd = {
  INIT: "@@redux/INIT" + V2(),
  REPLACE: "@@redux/REPLACE" + V2(),
  PROBE_UNKNOWN_ACTION: function() {
    return "@@redux/PROBE_UNKNOWN_ACTION" + V2();
  }
};
function Wz(e) {
  if (typeof e != "object" || e === null)
    return !1;
  for (var t = e; Object.getPrototypeOf(t) !== null; )
    t = Object.getPrototypeOf(t);
  return Object.getPrototypeOf(e) === t;
}
function Wce(e) {
  if (e === void 0)
    return "undefined";
  if (e === null)
    return "null";
  var t = typeof e;
  switch (t) {
    case "boolean":
    case "string":
    case "number":
    case "symbol":
    case "function":
      return t;
  }
  if (Array.isArray(e))
    return "array";
  if (Kce(e))
    return "date";
  if (Gce(e))
    return "error";
  var n = qce(e);
  switch (n) {
    case "Symbol":
    case "Promise":
    case "WeakMap":
    case "WeakSet":
    case "Map":
    case "Set":
      return n;
  }
  return t.slice(8, -1).toLowerCase().replace(/\s/g, "");
}
function qce(e) {
  return typeof e.constructor == "function" ? e.constructor.name : null;
}
function Gce(e) {
  return e instanceof Error || typeof e.message == "string" && e.constructor && typeof e.constructor.stackTraceLimit == "number";
}
function Kce(e) {
  return e instanceof Date ? !0 : typeof e.toDateString == "function" && typeof e.getDate == "function" && typeof e.setDate == "function";
}
function ld(e) {
  var t = typeof e;
  return process.env.NODE_ENV !== "production" && (t = Wce(e)), t;
}
function qz(e, t, n) {
  var r;
  if (typeof t == "function" && typeof n == "function" || typeof n == "function" && typeof arguments[3] == "function")
    throw new Error(process.env.NODE_ENV === "production" ? no(0) : "It looks like you are passing several store enhancers to createStore(). This is not supported. Instead, compose them together to a single function. See https://redux.js.org/tutorials/fundamentals/part-4-store#creating-a-store-with-enhancers for an example.");
  if (typeof t == "function" && typeof n > "u" && (n = t, t = void 0), typeof n < "u") {
    if (typeof n != "function")
      throw new Error(process.env.NODE_ENV === "production" ? no(1) : "Expected the enhancer to be a function. Instead, received: '" + ld(n) + "'");
    return n(qz)(e, t);
  }
  if (typeof e != "function")
    throw new Error(process.env.NODE_ENV === "production" ? no(2) : "Expected the root reducer to be a function. Instead, received: '" + ld(e) + "'");
  var i = e, o = t, a = [], s = a, c = !1;
  function l() {
    s === a && (s = a.slice());
  }
  function u() {
    if (c)
      throw new Error(process.env.NODE_ENV === "production" ? no(3) : "You may not call store.getState() while the reducer is executing. The reducer has already received the state as an argument. Pass it down from the top reducer instead of reading it from the store.");
    return o;
  }
  function d(g) {
    if (typeof g != "function")
      throw new Error(process.env.NODE_ENV === "production" ? no(4) : "Expected the listener to be a function. Instead, received: '" + ld(g) + "'");
    if (c)
      throw new Error(process.env.NODE_ENV === "production" ? no(5) : "You may not call store.subscribe() while the reducer is executing. If you would like to be notified after the store has been updated, subscribe from a component and invoke store.getState() in the callback to access the latest state. See https://redux.js.org/api/store#subscribelistener for more details.");
    var m = !0;
    return l(), s.push(g), function() {
      if (m) {
        if (c)
          throw new Error(process.env.NODE_ENV === "production" ? no(6) : "You may not unsubscribe from a store listener while the reducer is executing. See https://redux.js.org/api/store#subscribelistener for more details.");
        m = !1, l();
        var y = s.indexOf(g);
        s.splice(y, 1), a = null;
      }
    };
  }
  function f(g) {
    if (!Wz(g))
      throw new Error(process.env.NODE_ENV === "production" ? no(7) : "Actions must be plain objects. Instead, the actual type was: '" + ld(g) + "'. You may need to add middleware to your store setup to handle dispatching other values, such as 'redux-thunk' to handle dispatching functions. See https://redux.js.org/tutorials/fundamentals/part-4-store#middleware and https://redux.js.org/tutorials/fundamentals/part-6-async-logic#using-the-redux-thunk-middleware for examples.");
    if (typeof g.type > "u")
      throw new Error(process.env.NODE_ENV === "production" ? no(8) : 'Actions may not have an undefined "type" property. You may have misspelled an action type string constant.');
    if (c)
      throw new Error(process.env.NODE_ENV === "production" ? no(9) : "Reducers may not dispatch actions.");
    try {
      c = !0, o = i(o, g);
    } finally {
      c = !1;
    }
    for (var m = a = s, v = 0; v < m.length; v++) {
      var y = m[v];
      y();
    }
    return g;
  }
  function h(g) {
    if (typeof g != "function")
      throw new Error(process.env.NODE_ENV === "production" ? no(10) : "Expected the nextReducer to be a function. Instead, received: '" + ld(g));
    i = g, f({
      type: Pd.REPLACE
    });
  }
  function p() {
    var g, m = d;
    return g = {
      /**
       * The minimal observable subscription method.
       * @param {Object} observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns {subscription} An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */
      subscribe: function(y) {
        if (typeof y != "object" || y === null)
          throw new Error(process.env.NODE_ENV === "production" ? no(11) : "Expected the observer to be an object. Instead, received: '" + ld(y) + "'");
        function S() {
          y.next && y.next(u());
        }
        S();
        var _ = m(S);
        return {
          unsubscribe: _
        };
      }
    }, g[BN] = function() {
      return this;
    }, g;
  }
  return f({
    type: Pd.INIT
  }), r = {
    dispatch: f,
    subscribe: d,
    getState: u,
    replaceReducer: h
  }, r[BN] = p, r;
}
function zN(e) {
  typeof console < "u" && typeof console.error == "function" && console.error(e);
  try {
    throw new Error(e);
  } catch {
  }
}
function Yce(e, t, n, r) {
  var i = Object.keys(t), o = n && n.type === Pd.INIT ? "preloadedState argument passed to createStore" : "previous state received by the reducer";
  if (i.length === 0)
    return "Store does not have a valid reducer. Make sure the argument passed to combineReducers is an object whose values are reducers.";
  if (!Wz(e))
    return "The " + o + ' has unexpected type of "' + ld(e) + '". Expected argument to be an object with the following ' + ('keys: "' + i.join('", "') + '"');
  var a = Object.keys(e).filter(function(s) {
    return !t.hasOwnProperty(s) && !r[s];
  });
  if (a.forEach(function(s) {
    r[s] = !0;
  }), !(n && n.type === Pd.REPLACE) && a.length > 0)
    return "Unexpected " + (a.length > 1 ? "keys" : "key") + " " + ('"' + a.join('", "') + '" found in ' + o + ". ") + "Expected to find one of the known reducer keys instead: " + ('"' + i.join('", "') + '". Unexpected keys will be ignored.');
}
function Xce(e) {
  Object.keys(e).forEach(function(t) {
    var n = e[t], r = n(void 0, {
      type: Pd.INIT
    });
    if (typeof r > "u")
      throw new Error(process.env.NODE_ENV === "production" ? no(12) : 'The slice reducer for key "' + t + `" returned undefined during initialization. If the state passed to the reducer is undefined, you must explicitly return the initial state. The initial state may not be undefined. If you don't want to set a value for this reducer, you can use null instead of undefined.`);
    if (typeof n(void 0, {
      type: Pd.PROBE_UNKNOWN_ACTION()
    }) > "u")
      throw new Error(process.env.NODE_ENV === "production" ? no(13) : 'The slice reducer for key "' + t + '" returned undefined when probed with a random type. ' + ("Don't try to handle '" + Pd.INIT + `' or other actions in "redux/*" `) + "namespace. They are considered private. Instead, you must return the current state for any unknown actions, unless it is undefined, in which case you must return the initial state, regardless of the action type. The initial state may not be undefined, but can be null.");
  });
}
function Gz(e) {
  for (var t = Object.keys(e), n = {}, r = 0; r < t.length; r++) {
    var i = t[r];
    process.env.NODE_ENV !== "production" && typeof e[i] > "u" && zN('No reducer provided for key "' + i + '"'), typeof e[i] == "function" && (n[i] = e[i]);
  }
  var o = Object.keys(n), a;
  process.env.NODE_ENV !== "production" && (a = {});
  var s;
  try {
    Xce(n);
  } catch (c) {
    s = c;
  }
  return function(l, u) {
    if (l === void 0 && (l = {}), s)
      throw s;
    if (process.env.NODE_ENV !== "production") {
      var d = Yce(l, n, u, a);
      d && zN(d);
    }
    for (var f = !1, h = {}, p = 0; p < o.length; p++) {
      var g = o[p], m = n[g], v = l[g], y = m(v, u);
      if (typeof y > "u") {
        var S = u && u.type;
        throw new Error(process.env.NODE_ENV === "production" ? no(14) : "When called with an action of type " + (S ? '"' + String(S) + '"' : "(unknown type)") + ', the slice reducer for key "' + g + '" returned undefined. To ignore an action, you must explicitly return the previous state. If you want this reducer to hold no value, you can return null instead of undefined.');
      }
      h[g] = y, f = f || y !== v;
    }
    return f = f || o.length !== Object.keys(l).length, f ? h : l;
  };
}
function d_() {
  for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
    t[n] = arguments[n];
  return t.length === 0 ? function(r) {
    return r;
  } : t.length === 1 ? t[0] : t.reduce(function(r, i) {
    return function() {
      return r(i.apply(void 0, arguments));
    };
  });
}
function Qce() {
  for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
    t[n] = arguments[n];
  return function(r) {
    return function() {
      var i = r.apply(void 0, arguments), o = function() {
        throw new Error(process.env.NODE_ENV === "production" ? no(15) : "Dispatching while constructing your middleware is not allowed. Other middleware would not be applied to this dispatch.");
      }, a = {
        getState: i.getState,
        dispatch: function() {
          return o.apply(void 0, arguments);
        }
      }, s = t.map(function(c) {
        return c(a);
      });
      return o = d_.apply(void 0, s)(i.dispatch), ae(ae({}, i), {}, {
        dispatch: o
      });
    };
  };
}
function Kz(e) {
  var t = function(r) {
    var i = r.dispatch, o = r.getState;
    return function(a) {
      return function(s) {
        return typeof s == "function" ? s(i, o, e) : a(s);
      };
    };
  };
  return t;
}
var Yz = Kz();
Yz.withExtraArgument = Kz;
const HN = Yz;
var Xz = globalThis && globalThis.__extends || function() {
  var e = function(t, n) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, i) {
      r.__proto__ = i;
    } || function(r, i) {
      for (var o in i)
        Object.prototype.hasOwnProperty.call(i, o) && (r[o] = i[o]);
    }, e(t, n);
  };
  return function(t, n) {
    if (typeof n != "function" && n !== null)
      throw new TypeError("Class extends value " + String(n) + " is not a constructor or null");
    e(t, n);
    function r() {
      this.constructor = t;
    }
    t.prototype = n === null ? Object.create(n) : (r.prototype = n.prototype, new r());
  };
}(), Jce = globalThis && globalThis.__generator || function(e, t) {
  var n = { label: 0, sent: function() {
    if (o[0] & 1)
      throw o[1];
    return o[1];
  }, trys: [], ops: [] }, r, i, o, a;
  return a = { next: s(0), throw: s(1), return: s(2) }, typeof Symbol == "function" && (a[Symbol.iterator] = function() {
    return this;
  }), a;
  function s(l) {
    return function(u) {
      return c([l, u]);
    };
  }
  function c(l) {
    if (r)
      throw new TypeError("Generator is already executing.");
    for (; n; )
      try {
        if (r = 1, i && (o = l[0] & 2 ? i.return : l[0] ? i.throw || ((o = i.return) && o.call(i), 0) : i.next) && !(o = o.call(i, l[1])).done)
          return o;
        switch (i = 0, o && (l = [l[0] & 2, o.value]), l[0]) {
          case 0:
          case 1:
            o = l;
            break;
          case 4:
            return n.label++, { value: l[1], done: !1 };
          case 5:
            n.label++, i = l[1], l = [0];
            continue;
          case 7:
            l = n.ops.pop(), n.trys.pop();
            continue;
          default:
            if (o = n.trys, !(o = o.length > 0 && o[o.length - 1]) && (l[0] === 6 || l[0] === 2)) {
              n = 0;
              continue;
            }
            if (l[0] === 3 && (!o || l[1] > o[0] && l[1] < o[3])) {
              n.label = l[1];
              break;
            }
            if (l[0] === 6 && n.label < o[1]) {
              n.label = o[1], o = l;
              break;
            }
            if (o && n.label < o[2]) {
              n.label = o[2], n.ops.push(l);
              break;
            }
            o[2] && n.ops.pop(), n.trys.pop();
            continue;
        }
        l = t.call(e, n);
      } catch (u) {
        l = [6, u], i = 0;
      } finally {
        r = o = 0;
      }
    if (l[0] & 5)
      throw l[1];
    return { value: l[0] ? l[1] : void 0, done: !0 };
  }
}, cg = globalThis && globalThis.__spreadArray || function(e, t) {
  for (var n = 0, r = t.length, i = e.length; n < r; n++, i++)
    e[i] = t[n];
  return e;
}, Zce = Object.defineProperty, ele = Object.defineProperties, tle = Object.getOwnPropertyDescriptors, UN = Object.getOwnPropertySymbols, nle = Object.prototype.hasOwnProperty, rle = Object.prototype.propertyIsEnumerable, WN = function(e, t, n) {
  return t in e ? Zce(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n;
}, tu = function(e, t) {
  for (var n in t || (t = {}))
    nle.call(t, n) && WN(e, n, t[n]);
  if (UN)
    for (var r = 0, i = UN(t); r < i.length; r++) {
      var n = i[r];
      rle.call(t, n) && WN(e, n, t[n]);
    }
  return e;
}, B2 = function(e, t) {
  return ele(e, tle(t));
}, ile = function(e, t, n) {
  return new Promise(function(r, i) {
    var o = function(c) {
      try {
        s(n.next(c));
      } catch (l) {
        i(l);
      }
    }, a = function(c) {
      try {
        s(n.throw(c));
      } catch (l) {
        i(l);
      }
    }, s = function(c) {
      return c.done ? r(c.value) : Promise.resolve(c.value).then(o, a);
    };
    s((n = n.apply(e, t)).next());
  });
}, ole = typeof window < "u" && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ : function() {
  if (arguments.length !== 0)
    return typeof arguments[0] == "object" ? d_ : d_.apply(null, arguments);
};
function Qz(e) {
  if (typeof e != "object" || e === null)
    return !1;
  var t = Object.getPrototypeOf(e);
  if (t === null)
    return !0;
  for (var n = t; Object.getPrototypeOf(n) !== null; )
    n = Object.getPrototypeOf(n);
  return t === n;
}
var ale = function(e) {
  return e && typeof e.match == "function";
};
function nu(e, t) {
  function n() {
    for (var r = [], i = 0; i < arguments.length; i++)
      r[i] = arguments[i];
    if (t) {
      var o = t.apply(void 0, r);
      if (!o)
        throw new Error("prepareAction did not return an object");
      return tu(tu({
        type: e,
        payload: o.payload
      }, "meta" in o && { meta: o.meta }), "error" in o && { error: o.error });
    }
    return { type: e, payload: r[0] };
  }
  return n.toString = function() {
    return "" + e;
  }, n.type = e, n.match = function(r) {
    return r.type === e;
  }, n;
}
function sle(e) {
  return typeof e == "function" && "type" in e && ale(e);
}
function cle(e) {
  var t = e ? ("" + e).split("/") : [], n = t[t.length - 1] || "actionCreator";
  return 'Detected an action creator with type "' + (e || "unknown") + `" being dispatched. 
Make sure you're calling the action creator before dispatching, i.e. \`dispatch(` + n + "())` instead of `dispatch(" + n + ")`. This is necessary even if the action has no payload.";
}
function lle(e) {
  if (e === void 0 && (e = {}), process.env.NODE_ENV === "production")
    return function() {
      return function(r) {
        return function(i) {
          return r(i);
        };
      };
    };
  var t = e.isActionCreator, n = t === void 0 ? sle : t;
  return function() {
    return function(r) {
      return function(i) {
        return n(i) && console.warn(cle(i.type)), r(i);
      };
    };
  };
}
function Jz(e, t) {
  var n = 0;
  return {
    measureTime: function(r) {
      var i = Date.now();
      try {
        return r();
      } finally {
        var o = Date.now();
        n += o - i;
      }
    },
    warnIfExceeded: function() {
      n > e && console.warn(t + " took " + n + "ms, which is more than the warning threshold of " + e + `ms. 
If your state or actions are very large, you may want to disable the middleware as it might cause too much of a slowdown in development mode. See https://redux-toolkit.js.org/api/getDefaultMiddleware for instructions.
It is disabled in production builds, so you don't need to worry about that.`);
    }
  };
}
var ule = (
  /** @class */
  function(e) {
    Xz(t, e);
    function t() {
      for (var n = [], r = 0; r < arguments.length; r++)
        n[r] = arguments[r];
      var i = e.apply(this, n) || this;
      return Object.setPrototypeOf(i, t.prototype), i;
    }
    return Object.defineProperty(t, Symbol.species, {
      get: function() {
        return t;
      },
      enumerable: !1,
      configurable: !0
    }), t.prototype.concat = function() {
      for (var n = [], r = 0; r < arguments.length; r++)
        n[r] = arguments[r];
      return e.prototype.concat.apply(this, n);
    }, t.prototype.prepend = function() {
      for (var n = [], r = 0; r < arguments.length; r++)
        n[r] = arguments[r];
      return n.length === 1 && Array.isArray(n[0]) ? new (t.bind.apply(t, cg([void 0], n[0].concat(this))))() : new (t.bind.apply(t, cg([void 0], n.concat(this))))();
    }, t;
  }(Array)
), dle = (
  /** @class */
  function(e) {
    Xz(t, e);
    function t() {
      for (var n = [], r = 0; r < arguments.length; r++)
        n[r] = arguments[r];
      var i = e.apply(this, n) || this;
      return Object.setPrototypeOf(i, t.prototype), i;
    }
    return Object.defineProperty(t, Symbol.species, {
      get: function() {
        return t;
      },
      enumerable: !1,
      configurable: !0
    }), t.prototype.concat = function() {
      for (var n = [], r = 0; r < arguments.length; r++)
        n[r] = arguments[r];
      return e.prototype.concat.apply(this, n);
    }, t.prototype.prepend = function() {
      for (var n = [], r = 0; r < arguments.length; r++)
        n[r] = arguments[r];
      return n.length === 1 && Array.isArray(n[0]) ? new (t.bind.apply(t, cg([void 0], n[0].concat(this))))() : new (t.bind.apply(t, cg([void 0], n.concat(this))))();
    }, t;
  }(Array)
);
function SI(e) {
  return el(e) ? Hz(e, function() {
  }) : e;
}
var fle = process.env.NODE_ENV === "production", qN = "Invariant failed";
function GN(e, t) {
  if (!e)
    throw fle ? new Error(qN) : new Error(qN + ": " + (t || ""));
}
function hle(e, t, n, r) {
  return JSON.stringify(e, gle(t, r), n);
}
function gle(e, t) {
  var n = [], r = [];
  return t || (t = function(i, o) {
    return n[0] === o ? "[Circular ~]" : "[Circular ~." + r.slice(0, n.indexOf(o)).join(".") + "]";
  }), function(i, o) {
    if (n.length > 0) {
      var a = n.indexOf(this);
      ~a ? n.splice(a + 1) : n.push(this), ~a ? r.splice(a, 1 / 0, i) : r.push(i), ~n.indexOf(o) && (o = t.call(this, i, o));
    } else
      n.push(o);
    return e == null ? o : e.call(this, i, o);
  };
}
function ple(e) {
  return typeof e != "object" || e == null || Object.isFrozen(e);
}
function mle(e, t, n) {
  var r = Zz(e, t, n);
  return {
    detectMutations: function() {
      return eH(e, t, r, n);
    }
  };
}
function Zz(e, t, n, r, i) {
  t === void 0 && (t = []), r === void 0 && (r = ""), i === void 0 && (i = /* @__PURE__ */ new Set());
  var o = { value: n };
  if (!e(n) && !i.has(n)) {
    i.add(n), o.children = {};
    for (var a in n) {
      var s = r ? r + "." + a : a;
      t.length && t.indexOf(s) !== -1 || (o.children[a] = Zz(e, t, n[a], s));
    }
  }
  return o;
}
function eH(e, t, n, r, i, o) {
  t === void 0 && (t = []), i === void 0 && (i = !1), o === void 0 && (o = "");
  var a = n ? n.value : void 0, s = a === r;
  if (i && !s && !Number.isNaN(r))
    return { wasMutated: !0, path: o };
  if (e(a) || e(r))
    return { wasMutated: !1 };
  var c = {};
  for (var l in n.children)
    c[l] = !0;
  for (var l in r)
    c[l] = !0;
  var u = t.length > 0, d = function(h) {
    var p = o ? o + "." + h : h;
    if (u) {
      var g = t.some(function(v) {
        return v instanceof RegExp ? v.test(p) : p === v;
      });
      if (g)
        return "continue";
    }
    var m = eH(e, t, n.children[h], r[h], s, p);
    if (m.wasMutated)
      return { value: m };
  };
  for (var l in c) {
    var f = d(l);
    if (typeof f == "object")
      return f.value;
  }
  return { wasMutated: !1 };
}
function vle(e) {
  if (e === void 0 && (e = {}), process.env.NODE_ENV === "production")
    return function() {
      return function(c) {
        return function(l) {
          return c(l);
        };
      };
    };
  var t = e.isImmutable, n = t === void 0 ? ple : t, r = e.ignoredPaths, i = e.warnAfter, o = i === void 0 ? 32 : i, a = e.ignore;
  r = r || a;
  var s = mle.bind(null, n, r);
  return function(c) {
    var l = c.getState, u = l(), d = s(u), f;
    return function(h) {
      return function(p) {
        var g = Jz(o, "ImmutableStateInvariantMiddleware");
        g.measureTime(function() {
          u = l(), f = d.detectMutations(), d = s(u), GN(!f.wasMutated, "A state mutation was detected between dispatches, in the path '" + (f.path || "") + "'.  This may cause incorrect behavior. (https://redux.js.org/style-guide/style-guide#do-not-mutate-state)");
        });
        var m = h(p);
        return g.measureTime(function() {
          u = l(), f = d.detectMutations(), d = s(u), f.wasMutated && GN(!f.wasMutated, "A state mutation was detected inside a dispatch, in the path: " + (f.path || "") + ". Take a look at the reducer(s) handling the action " + hle(p) + ". (https://redux.js.org/style-guide/style-guide#do-not-mutate-state)");
        }), g.warnIfExceeded(), m;
      };
    };
  };
}
function tH(e) {
  var t = typeof e;
  return e == null || t === "string" || t === "boolean" || t === "number" || Array.isArray(e) || Qz(e);
}
function wI(e, t, n, r, i, o) {
  t === void 0 && (t = ""), n === void 0 && (n = tH), i === void 0 && (i = []);
  var a;
  if (!n(e))
    return {
      keyPath: t || "<root>",
      value: e
    };
  if (typeof e != "object" || e === null || o != null && o.has(e))
    return !1;
  for (var s = r != null ? r(e) : Object.entries(e), c = i.length > 0, l = function(m, v) {
    var y = t ? t + "." + m : m;
    if (c) {
      var S = i.some(function(_) {
        return _ instanceof RegExp ? _.test(y) : y === _;
      });
      if (S)
        return "continue";
    }
    if (!n(v))
      return { value: {
        keyPath: y,
        value: v
      } };
    if (typeof v == "object" && (a = wI(v, y, n, r, i, o), a))
      return { value: a };
  }, u = 0, d = s; u < d.length; u++) {
    var f = d[u], h = f[0], p = f[1], g = l(h, p);
    if (typeof g == "object")
      return g.value;
  }
  return o && nH(e) && o.add(e), !1;
}
function nH(e) {
  if (!Object.isFrozen(e))
    return !1;
  for (var t = 0, n = Object.values(e); t < n.length; t++) {
    var r = n[t];
    if (!(typeof r != "object" || r === null) && !nH(r))
      return !1;
  }
  return !0;
}
function yle(e) {
  if (e === void 0 && (e = {}), process.env.NODE_ENV === "production")
    return function() {
      return function(S) {
        return function(_) {
          return S(_);
        };
      };
    };
  var t = e.isSerializable, n = t === void 0 ? tH : t, r = e.getEntries, i = e.ignoredActions, o = i === void 0 ? [] : i, a = e.ignoredActionPaths, s = a === void 0 ? ["meta.arg", "meta.baseQueryMeta"] : a, c = e.ignoredPaths, l = c === void 0 ? [] : c, u = e.warnAfter, d = u === void 0 ? 32 : u, f = e.ignoreState, h = f === void 0 ? !1 : f, p = e.ignoreActions, g = p === void 0 ? !1 : p, m = e.disableCache, v = m === void 0 ? !1 : m, y = !v && WeakSet ? /* @__PURE__ */ new WeakSet() : void 0;
  return function(S) {
    return function(_) {
      return function(w) {
        var T = _(w), x = Jz(d, "SerializableStateInvariantMiddleware");
        return !g && !(o.length && o.indexOf(w.type) !== -1) && x.measureTime(function() {
          var C = wI(w, "", n, r, s, y);
          if (C) {
            var E = C.keyPath, R = C.value;
            console.error("A non-serializable value was detected in an action, in the path: `" + E + "`. Value:", R, `
Take a look at the logic that dispatched this action: `, w, `
(See https://redux.js.org/faq/actions#why-should-type-be-a-string-or-at-least-serializable-why-should-my-action-types-be-constants)`, `
(To allow non-serializable values see: https://redux-toolkit.js.org/usage/usage-guide#working-with-non-serializable-data)`);
          }
        }), h || (x.measureTime(function() {
          var C = S.getState(), E = wI(C, "", n, r, l, y);
          if (E) {
            var R = E.keyPath, A = E.value;
            console.error("A non-serializable value was detected in the state, in the path: `" + R + "`. Value:", A, `
Take a look at the reducer(s) handling this action type: ` + w.type + `.
(See https://redux.js.org/faq/organizing-state#can-i-put-functions-promises-or-other-non-serializable-items-in-my-store-state)`);
          }
        }), x.warnIfExceeded()), T;
      };
    };
  };
}
function hb(e) {
  return typeof e == "boolean";
}
function ble() {
  return function(t) {
    return _le(t);
  };
}
function _le(e) {
  e === void 0 && (e = {});
  var t = e.thunk, n = t === void 0 ? !0 : t, r = e.immutableCheck, i = r === void 0 ? !0 : r, o = e.serializableCheck, a = o === void 0 ? !0 : o, s = e.actionCreatorCheck, c = s === void 0 ? !0 : s, l = new ule();
  if (n && (hb(n) ? l.push(HN) : l.push(HN.withExtraArgument(n.extraArgument))), process.env.NODE_ENV !== "production") {
    if (i) {
      var u = {};
      hb(i) || (u = i), l.unshift(vle(u));
    }
    if (a) {
      var d = {};
      hb(a) || (d = a), l.push(yle(d));
    }
    if (c) {
      var f = {};
      hb(c) || (f = c), l.unshift(lle(f));
    }
  }
  return l;
}
var z2 = process.env.NODE_ENV === "production";
function Sle(e) {
  var t = ble(), n = e || {}, r = n.reducer, i = r === void 0 ? void 0 : r, o = n.middleware, a = o === void 0 ? t() : o, s = n.devTools, c = s === void 0 ? !0 : s, l = n.preloadedState, u = l === void 0 ? void 0 : l, d = n.enhancers, f = d === void 0 ? void 0 : d, h;
  if (typeof i == "function")
    h = i;
  else if (Qz(i))
    h = Gz(i);
  else
    throw new Error('"reducer" is a required argument, and must be a function or an object of functions that can be passed to combineReducers');
  var p = a;
  if (typeof p == "function" && (p = p(t), !z2 && !Array.isArray(p)))
    throw new Error("when using a middleware builder function, an array of middleware must be returned");
  if (!z2 && p.some(function(_) {
    return typeof _ != "function";
  }))
    throw new Error("each middleware provided to configureStore must be a function");
  var g = Qce.apply(void 0, p), m = d_;
  c && (m = ole(tu({
    trace: !z2
  }, typeof c == "object" && c)));
  var v = new dle(g), y = v;
  Array.isArray(f) ? y = cg([g], f) : typeof f == "function" && (y = f(v));
  var S = m.apply(void 0, y);
  return qz(h, u, S);
}
function rH(e) {
  var t = {}, n = [], r, i = {
    addCase: function(o, a) {
      if (process.env.NODE_ENV !== "production") {
        if (n.length > 0)
          throw new Error("`builder.addCase` should only be called before calling `builder.addMatcher`");
        if (r)
          throw new Error("`builder.addCase` should only be called before calling `builder.addDefaultCase`");
      }
      var s = typeof o == "string" ? o : o.type;
      if (!s)
        throw new Error("`builder.addCase` cannot be called with an empty action type");
      if (s in t)
        throw new Error("`builder.addCase` cannot be called with two reducers for the same action type");
      return t[s] = a, i;
    },
    addMatcher: function(o, a) {
      if (process.env.NODE_ENV !== "production" && r)
        throw new Error("`builder.addMatcher` should only be called before calling `builder.addDefaultCase`");
      return n.push({ matcher: o, reducer: a }), i;
    },
    addDefaultCase: function(o) {
      if (process.env.NODE_ENV !== "production" && r)
        throw new Error("`builder.addDefaultCase` can only be called once");
      return r = o, i;
    }
  };
  return e(i), [t, n, r];
}
function wle(e) {
  return typeof e == "function";
}
var KN = !1;
function xle(e, t, n, r) {
  n === void 0 && (n = []), process.env.NODE_ENV !== "production" && typeof t == "object" && (KN || (KN = !0, console.warn("The object notation for `createReducer` is deprecated, and will be removed in RTK 2.0. Please use the 'builder callback' notation instead: https://redux-toolkit.js.org/api/createReducer")));
  var i = typeof t == "function" ? rH(t) : [t, n, r], o = i[0], a = i[1], s = i[2], c;
  if (wle(e))
    c = function() {
      return SI(e());
    };
  else {
    var l = SI(e);
    c = function() {
      return l;
    };
  }
  function u(d, f) {
    d === void 0 && (d = c());
    var h = cg([
      o[f.type]
    ], a.filter(function(p) {
      var g = p.matcher;
      return g(f);
    }).map(function(p) {
      var g = p.reducer;
      return g;
    }));
    return h.filter(function(p) {
      return !!p;
    }).length === 0 && (h = [s]), h.reduce(function(p, g) {
      if (g)
        if (gu(p)) {
          var m = p, v = g(m, f);
          return v === void 0 ? p : v;
        } else {
          if (el(p))
            return Hz(p, function(y) {
              return g(y, f);
            });
          var v = g(p, f);
          if (v === void 0) {
            if (p === null)
              return p;
            throw Error("A case reducer on a non-draftable value must not return undefined");
          }
          return v;
        }
      return p;
    }, d);
  }
  return u.getInitialState = c, u;
}
var YN = !1;
function Ele(e, t) {
  return e + "/" + t;
}
function Cle(e) {
  var t = e.name;
  if (!t)
    throw new Error("`name` is a required option for createSlice");
  typeof process < "u" && process.env.NODE_ENV === "development" && e.initialState === void 0 && console.error("You must provide an `initialState` value that is not `undefined`. You may have misspelled `initialState`");
  var n = typeof e.initialState == "function" ? e.initialState : SI(e.initialState), r = e.reducers || {}, i = Object.keys(r), o = {}, a = {}, s = {};
  i.forEach(function(u) {
    var d = r[u], f = Ele(t, u), h, p;
    "reducer" in d ? (h = d.reducer, p = d.prepare) : h = d, o[u] = h, a[f] = h, s[u] = p ? nu(f, p) : nu(f);
  });
  function c() {
    process.env.NODE_ENV !== "production" && typeof e.extraReducers == "object" && (YN || (YN = !0, console.warn("The object notation for `createSlice.extraReducers` is deprecated, and will be removed in RTK 2.0. Please use the 'builder callback' notation instead: https://redux-toolkit.js.org/api/createSlice")));
    var u = typeof e.extraReducers == "function" ? rH(e.extraReducers) : [e.extraReducers], d = u[0], f = d === void 0 ? {} : d, h = u[1], p = h === void 0 ? [] : h, g = u[2], m = g === void 0 ? void 0 : g, v = tu(tu({}, f), a);
    return xle(n, function(y) {
      for (var S in v)
        y.addCase(S, v[S]);
      for (var _ = 0, w = p; _ < w.length; _++) {
        var T = w[_];
        y.addMatcher(T.matcher, T.reducer);
      }
      m && y.addDefaultCase(m);
    });
  }
  var l;
  return {
    name: t,
    reducer: function(u, d) {
      return l || (l = c()), l(u, d);
    },
    actions: s,
    caseReducers: o,
    getInitialState: function() {
      return l || (l = c()), l.getInitialState();
    }
  };
}
var Tle = "ModuleSymbhasOwnPr-0123456789ABCDEFGHNRVfgctiUvz_KqYTJkLxpZXIjQW", Ile = function(e) {
  e === void 0 && (e = 21);
  for (var t = "", n = e; n--; )
    t += Tle[Math.random() * 64 | 0];
  return t;
}, Ale = [
  "name",
  "message",
  "stack",
  "code"
], H2 = (
  /** @class */
  function() {
    function e(t, n) {
      this.payload = t, this.meta = n;
    }
    return e;
  }()
), XN = (
  /** @class */
  function() {
    function e(t, n) {
      this.payload = t, this.meta = n;
    }
    return e;
  }()
), Rle = function(e) {
  if (typeof e == "object" && e !== null) {
    for (var t = {}, n = 0, r = Ale; n < r.length; n++) {
      var i = r[n];
      typeof e[i] == "string" && (t[i] = e[i]);
    }
    return t;
  }
  return { message: String(e) };
};
(function() {
  function e(t, n, r) {
    var i = nu(t + "/fulfilled", function(u, d, f, h) {
      return {
        payload: u,
        meta: B2(tu({}, h || {}), {
          arg: f,
          requestId: d,
          requestStatus: "fulfilled"
        })
      };
    }), o = nu(t + "/pending", function(u, d, f) {
      return {
        payload: void 0,
        meta: B2(tu({}, f || {}), {
          arg: d,
          requestId: u,
          requestStatus: "pending"
        })
      };
    }), a = nu(t + "/rejected", function(u, d, f, h, p) {
      return {
        payload: h,
        error: (r && r.serializeError || Rle)(u || "Rejected"),
        meta: B2(tu({}, p || {}), {
          arg: f,
          requestId: d,
          rejectedWithValue: !!h,
          requestStatus: "rejected",
          aborted: (u == null ? void 0 : u.name) === "AbortError",
          condition: (u == null ? void 0 : u.name) === "ConditionError"
        })
      };
    }), s = !1, c = typeof AbortController < "u" ? AbortController : (
      /** @class */
      function() {
        function u() {
          this.signal = {
            aborted: !1,
            addEventListener: function() {
            },
            dispatchEvent: function() {
              return !1;
            },
            onabort: function() {
            },
            removeEventListener: function() {
            },
            reason: void 0,
            throwIfAborted: function() {
            }
          };
        }
        return u.prototype.abort = function() {
          process.env.NODE_ENV !== "production" && (s || (s = !0, console.info("This platform does not implement AbortController. \nIf you want to use the AbortController to react to `abort` events, please consider importing a polyfill like 'abortcontroller-polyfill/dist/abortcontroller-polyfill-only'.")));
        }, u;
      }()
    );
    function l(u) {
      return function(d, f, h) {
        var p = r != null && r.idGenerator ? r.idGenerator(u) : Ile(), g = new c(), m;
        function v(S) {
          m = S, g.abort();
        }
        var y = function() {
          return ile(this, null, function() {
            var S, _, w, T, x, C, E;
            return Jce(this, function(R) {
              switch (R.label) {
                case 0:
                  return R.trys.push([0, 4, , 5]), T = (S = r == null ? void 0 : r.condition) == null ? void 0 : S.call(r, u, { getState: f, extra: h }), Ole(T) ? [4, T] : [3, 2];
                case 1:
                  T = R.sent(), R.label = 2;
                case 2:
                  if (T === !1 || g.signal.aborted)
                    throw {
                      name: "ConditionError",
                      message: "Aborted due to condition callback returning false."
                    };
                  return x = new Promise(function(A, O) {
                    return g.signal.addEventListener("abort", function() {
                      return O({
                        name: "AbortError",
                        message: m || "Aborted"
                      });
                    });
                  }), d(o(p, u, (_ = r == null ? void 0 : r.getPendingMeta) == null ? void 0 : _.call(r, { requestId: p, arg: u }, { getState: f, extra: h }))), [4, Promise.race([
                    x,
                    Promise.resolve(n(u, {
                      dispatch: d,
                      getState: f,
                      extra: h,
                      requestId: p,
                      signal: g.signal,
                      abort: v,
                      rejectWithValue: function(A, O) {
                        return new H2(A, O);
                      },
                      fulfillWithValue: function(A, O) {
                        return new XN(A, O);
                      }
                    })).then(function(A) {
                      if (A instanceof H2)
                        throw A;
                      return A instanceof XN ? i(A.payload, p, u, A.meta) : i(A, p, u);
                    })
                  ])];
                case 3:
                  return w = R.sent(), [3, 5];
                case 4:
                  return C = R.sent(), w = C instanceof H2 ? a(null, p, u, C.payload, C.meta) : a(C, p, u), [3, 5];
                case 5:
                  return E = r && !r.dispatchConditionRejection && a.match(w) && w.meta.condition, E || d(w), [2, w];
              }
            });
          });
        }();
        return Object.assign(y, {
          abort: v,
          requestId: p,
          arg: u,
          unwrap: function() {
            return y.then($le);
          }
        });
      };
    }
    return Object.assign(l, {
      pending: o,
      rejected: a,
      fulfilled: i,
      typePrefix: t
    });
  }
  return e.withTypes = function() {
    return e;
  }, e;
})();
function $le(e) {
  if (e.meta && e.meta.rejectedWithValue)
    throw e.payload;
  if (e.error)
    throw e.error;
  return e.payload;
}
function Ole(e) {
  return e !== null && typeof e == "object" && typeof e.then == "function";
}
var gO = "listenerMiddleware";
nu(gO + "/add");
nu(gO + "/removeAll");
nu(gO + "/remove");
var QN;
typeof queueMicrotask == "function" && queueMicrotask.bind(typeof window < "u" ? window : typeof global < "u" ? global : globalThis);
jce();
var Ple = new Pse(function(e) {
  return e.complete();
});
const V_t = (e) => e.replace(/[^A-ZA-z]/g, ""), B_t = (e, t) => e.substring(0, t), z_t = (e, t) => e && e.trim().length <= t, H_t = (e) => /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(e), JN = (e, t) => {
  if (e === void 0)
    return 0;
  const n = new Date(e), i = new Date(t).getTime() - n.getTime();
  return isNaN(i) ? 0 : i / 1e3;
}, Mle = () => {
  const e = navigator.userAgent;
  return /(tablet|ipad|playbook|silk)|(android(?!.*mobi))/i.test(e) ? "tablet" : /Mobile|iP(hone|od)|Android|BlackBerry|IEMobile|Kindle|Silk-Accelerated|(hpw|web)OS|Opera M(obi|ini)/.test(
    e
  ) ? "mobile" : "desktop";
};
class Dv {
  constructor(t, n) {
    ye(this, "_answer");
    ye(this, "log");
    this._answer = t, this.log = n;
  }
  convertedToQuestionType(t) {
    return this._answer.questionType === t ? this : new Dv(
      {
        ...this._answer,
        questionType: t
      },
      this.log
    );
  }
  getAnswer() {
    return this._answer;
  }
  getValue(t) {
    return t !== this._answer.questionType && this.log.error(
      `Question type ${t} does not match answer type ${this._answer.questionType}`
    ), this._answer.value === null ? null : this._answer.value;
  }
  hasId(t, n) {
    const r = this.getValue(n);
    return r === null ? !1 : this._findNestedValue(t, r) !== null;
  }
  getNestedValueAsNumber(t, n) {
    const r = this.getNestedValue(t, n);
    if (r === null)
      return null;
    const i = Number(r.value);
    return Number.isNaN(i) ? null : i;
  }
  isValid(t) {
    var n;
    switch (t) {
      case "multiInput":
      case "matrix":
        return ((n = this._answer.validity) == null ? void 0 : n.valid) ?? !1;
      default:
        return !0;
    }
  }
  invalidMessages(t) {
    var n;
    return ((n = this._answer.validity) == null ? void 0 : n.messages) ?? ["This question requires an answer"];
  }
  getNestedValue(t, n) {
    const r = this.getValue(n);
    return r === null ? null : this._findNestedValue(t, r);
  }
  _findNestedValue(t, n) {
    return Array.isArray(n) ? n.find((r) => r.id === t) || null : Cz(n) ? n.id === t ? n : null : this._findNestedValue(t, n ? n[t] : null);
  }
}
class xI {
  constructor(t, n) {
    ye(this, "_surveyAnswers");
    ye(this, "log");
    this._surveyAnswers = t, this.log = n;
  }
  get(t) {
    const n = this._surveyAnswers[t];
    return n ? new Dv(n, this.log) : null;
  }
  raw() {
    return this._surveyAnswers;
  }
}
const ZN = {
  surveyId: null,
  submissionId: null,
  currentQuestionId: null,
  currentQuestionType: void 0,
  userAnswers: {},
  currentAnswer: void 0,
  questionHistory: [],
  timeOnCurrentQuestion: "",
  // error: () => ({ type: ERROR }),
  // log: services.loggingService,
  isSubmitClicked: !1,
  direction: "forwards",
  isHydrated: !1,
  initialised: !1
}, kle = (e) => ({
  qid: e.currentQuestionId,
  questionType: e.currentQuestionType
});
function eD(e) {
  return e === null ? "" : e;
}
const iH = Cle({
  name: "survey",
  initialState: ZN,
  reducers: {
    initialise: (e, t) => {
      var c;
      let n;
      const { questions: r, startQuestionId: i, surveyId: o, existingState: a } = t.payload;
      if (a && a.initialised) {
        let l;
        return a.currentQuestionId && a.currentQuestionType && (l = ((c = a.userAnswers) == null ? void 0 : c[a.currentQuestionId]) ?? {
          questionId: a.currentQuestionId,
          questionType: a.currentQuestionType,
          value: null,
          qStartTime: (/* @__PURE__ */ new Date()).toUTCString()
        }), {
          ...e,
          ...a,
          surveyId: o,
          currentAnswer: l,
          isHydrated: !0
        };
      }
      if (!a || !a.initialised)
        return n = i && r.find((l) => l.id === i) || r[0], {
          ...ZN,
          surveyId: o,
          currentQuestionId: n.id,
          currentQuestionType: n.type,
          currentAnswer: {
            questionId: n.id,
            questionType: n.type,
            value: null,
            qStartTime: (/* @__PURE__ */ new Date()).toUTCString()
          },
          isHydrated: !0
        };
      e.currentQuestionId !== null ? n = r.find((l) => l.id === e.currentQuestionId) || r[0] : i ? n = r.find((l) => l.id === i) || r[0] : n = r[0];
      const s = e.currentAnswer ?? {
        questionId: n.id,
        questionType: n.type,
        value: null,
        qStartTime: (/* @__PURE__ */ new Date()).toUTCString()
      };
      return {
        ...e,
        surveyId: o,
        currentQuestionId: n.id,
        currentQuestionType: n.type,
        currentAnswer: s,
        isHydrated: !0
      };
    },
    setSubmissionId: (e, t) => ({
      ...e,
      submissionId: t.payload
    }),
    goToNextQuestion: (e, t) => {
      var s;
      let n;
      const r = t.payload.find((c) => c.id === e.currentQuestionId);
      if (!r)
        return e;
      if (r.next)
        n = r.next({
          answers: new xI(e.userAnswers, new yN())
        });
      else {
        const c = t.payload.findIndex((l) => l.id === e.currentQuestionId) + 1;
        c >= t.payload.length ? n = e.currentQuestionId : n = t.payload[c].id;
      }
      const i = r.type === "hidden" ? e.questionHistory : [kle(e)].concat(e.questionHistory);
      let o = t.payload.find((c) => c.id === n), a = 0;
      for (; o != null && o.skip && o.skip({
        answers: new xI(e.userAnswers, new yN())
      }); ) {
        if (a = t.payload.findIndex((c) => c.id === n) + 1, a >= t.payload.length)
          break;
        o = t.payload[a], n = o.id;
      }
      return {
        ...e,
        currentQuestionId: n,
        currentQuestionType: (s = t.payload.find((c) => c.id === n)) == null ? void 0 : s.type,
        questionHistory: i,
        currentAnswer: void 0,
        direction: "forwards"
      };
    },
    goToPreviousQuestion: (e) => e.questionHistory.length > 0 ? {
      ...e,
      currentQuestionId: e.questionHistory[0].qid,
      currentQuestionType: e.questionHistory[0].questionType,
      questionHistory: e.questionHistory.slice(1),
      currentAnswer: void 0,
      direction: "backwards"
    } : e,
    updateAnswer: (e) => {
      var t, n, r;
      if (e.currentAnswer) {
        const i = (/* @__PURE__ */ new Date()).toUTCString(), o = JN((t = e.currentAnswer) == null ? void 0 : t.qStartTime, i), a = {
          ...e.currentAnswer,
          qEndTime: i,
          timeTaken: (n = e.currentAnswer) != null && n.timeTaken ? ((r = e.currentAnswer) == null ? void 0 : r.timeTaken) + o : o
        }, s = eD(e.currentQuestionId);
        return {
          ...e,
          userAnswers: {
            ...e.userAnswers,
            [s]: a
          },
          currentAnswer: void 0
        };
      }
      return e;
    },
    recordAnswer: (e) => {
      var t, n, r;
      if (e.currentAnswer && e.currentQuestionId !== null) {
        const i = (/* @__PURE__ */ new Date()).toUTCString(), o = JN((t = e.currentAnswer) == null ? void 0 : t.qStartTime, i), a = {
          ...e.currentAnswer,
          qEndTime: i,
          timeTaken: (n = e.currentAnswer) != null && n.timeTaken ? ((r = e.currentAnswer) == null ? void 0 : r.timeTaken) + o : o
        };
        return {
          ...e,
          userAnswers: {
            ...e.userAnswers,
            [e.currentQuestionId]: a
          }
        };
      }
      return e;
    },
    retrieveAnswer: (e, t) => {
      const n = eD(e.currentQuestionId);
      if (n in e.userAnswers) {
        const r = e.userAnswers[n];
        return {
          ...e,
          currentAnswer: {
            ...r,
            qStartTime: (/* @__PURE__ */ new Date()).toUTCString()
          }
        };
      } else {
        const r = t.payload.find((i) => i.id === e.currentQuestionId);
        if (r)
          return {
            ...e,
            currentAnswer: {
              questionId: r.id,
              questionType: r.type,
              value: null,
              qStartTime: (/* @__PURE__ */ new Date()).toUTCString()
            }
          };
      }
      return e;
    },
    injectCurrent: (e, t) => e.currentAnswer ? {
      ...e,
      currentAnswer: { ...e.currentAnswer, ...t.payload }
    } : e,
    updateCurrent: (e, t) => ({
      ...e,
      currentAnswer: t.payload,
      currentQuestionId: t.payload.questionId
    }),
    onSubmitClicked: (e) => ({
      ...e,
      isSubmitClicked: !0
    })
  }
}), {
  initialise: U_t,
  setSubmissionId: oH,
  goToNextQuestion: Nle,
  goToPreviousQuestion: Dle,
  updateAnswer: tD,
  retrieveAnswer: nD,
  injectCurrent: Lle,
  updateCurrent: aH,
  recordAnswer: sH,
  onSubmitClicked: jle
} = iH.actions, Fle = iH.reducer;
class Vle {
  constructor(t) {
    ye(this, "store");
    ye(this, "user");
    ye(this, "userSubscription");
    ye(this, "databaseManager");
    ye(this, "userManager");
    ye(this, "readySubject", new Vs(!1));
    ye(this, "log");
    ye(this, "initialised", !1);
    this.store = Sle({
      reducer: this.rootReducer(),
      middleware: (n) => this.getMiddleware(n)
    }), this.log = t;
  }
  rootReducer() {
    return Gz({
      survey: Fle
    });
  }
  async initialise(t, n, r, i, o, a) {
    if (this.log.info("ReduxStoreManager", "initialise"), this.initialised) {
      this.log.info("ReduxStoreManager already initialized, skippping");
      return;
    }
    this.initialised = !0, this.databaseManager = n, this.store.dispatch(oH(i));
    const s = {
      surveyId: t.settings.surveyName,
      questions: t.questions,
      startQuestionId: t.settings.startQuestionId
    };
    a && (s.existingState = a), this.store.dispatch({ type: "survey/initialise", payload: s }), this.userManager = r, this.userSubscription = this.userManager.observeUser().subscribe({
      next: (c) => {
        c.user && c.initialised && this.subscribeDatabase(c.user, t, i, o);
      },
      error: (c) => {
        const l = c;
        this.log.error("Error observing current user", { error: l }), this.readySubject.error(l);
      }
    }), this.log.info("ReduxStoreManager", "initialised");
  }
  dispose() {
    var t;
    (t = this.userSubscription) == null || t.unsubscribe();
  }
  observeReady() {
    return this.readySubject;
  }
  async subscribeDatabase(t, n, r, i) {
    var o;
    if (this.log.info("subscribeDatabase", t, n.settings.surveyName, r, i), !t) {
      this.readySubject.next(!1);
      return;
    }
    try {
      await ((o = this.databaseManager) == null ? void 0 : o.subscribeToStore(
        this.store,
        n.settings.surveyName,
        t,
        r
      )), this.log.info("ReduxStoreManager", "subscribeDatabase", "database subscribed"), this.readySubject.next(!0);
    } catch (a) {
      const s = a;
      this.log.error("Error connecting database to redux store.", { error: s }), this.readySubject.next(!1);
    }
  }
  getStore() {
    return this.store;
  }
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  getMiddleware(t) {
    return t({
      serializableCheck: {
        // Ignore these action types
        ignoredActions: ["survey/goToNextQuestion", "survey/retrieveAnswer", "survey/initialise"],
        // Ignore these field paths in all actions
        ignoredActionPaths: [
          "payload.choices",
          "payload.defaultValues",
          "payload.header",
          "payload.text",
          "payload.outputs"
        ]
      }
    });
  }
}
const cH = Pce, f_ = aO, Ble = () => {
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const lH = function(e) {
  const t = [];
  let n = 0;
  for (let r = 0; r < e.length; r++) {
    let i = e.charCodeAt(r);
    i < 128 ? t[n++] = i : i < 2048 ? (t[n++] = i >> 6 | 192, t[n++] = i & 63 | 128) : (i & 64512) === 55296 && r + 1 < e.length && (e.charCodeAt(r + 1) & 64512) === 56320 ? (i = 65536 + ((i & 1023) << 10) + (e.charCodeAt(++r) & 1023), t[n++] = i >> 18 | 240, t[n++] = i >> 12 & 63 | 128, t[n++] = i >> 6 & 63 | 128, t[n++] = i & 63 | 128) : (t[n++] = i >> 12 | 224, t[n++] = i >> 6 & 63 | 128, t[n++] = i & 63 | 128);
  }
  return t;
}, zle = function(e) {
  const t = [];
  let n = 0, r = 0;
  for (; n < e.length; ) {
    const i = e[n++];
    if (i < 128)
      t[r++] = String.fromCharCode(i);
    else if (i > 191 && i < 224) {
      const o = e[n++];
      t[r++] = String.fromCharCode((i & 31) << 6 | o & 63);
    } else if (i > 239 && i < 365) {
      const o = e[n++], a = e[n++], s = e[n++], c = ((i & 7) << 18 | (o & 63) << 12 | (a & 63) << 6 | s & 63) - 65536;
      t[r++] = String.fromCharCode(55296 + (c >> 10)), t[r++] = String.fromCharCode(56320 + (c & 1023));
    } else {
      const o = e[n++], a = e[n++];
      t[r++] = String.fromCharCode((i & 15) << 12 | (o & 63) << 6 | a & 63);
    }
  }
  return t.join("");
}, uH = {
  /**
   * Maps bytes to characters.
   */
  byteToCharMap_: null,
  /**
   * Maps characters to bytes.
   */
  charToByteMap_: null,
  /**
   * Maps bytes to websafe characters.
   * @private
   */
  byteToCharMapWebSafe_: null,
  /**
   * Maps websafe characters to bytes.
   * @private
   */
  charToByteMapWebSafe_: null,
  /**
   * Our default alphabet, shared between
   * ENCODED_VALS and ENCODED_VALS_WEBSAFE
   */
  ENCODED_VALS_BASE: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789",
  /**
   * Our default alphabet. Value 64 (=) is special; it means "nothing."
   */
  get ENCODED_VALS() {
    return this.ENCODED_VALS_BASE + "+/=";
  },
  /**
   * Our websafe alphabet.
   */
  get ENCODED_VALS_WEBSAFE() {
    return this.ENCODED_VALS_BASE + "-_.";
  },
  /**
   * Whether this browser supports the atob and btoa functions. This extension
   * started at Mozilla but is now implemented by many browsers. We use the
   * ASSUME_* variables to avoid pulling in the full useragent detection library
   * but still allowing the standard per-browser compilations.
   *
   */
  HAS_NATIVE_SUPPORT: typeof atob == "function",
  /**
   * Base64-encode an array of bytes.
   *
   * @param input An array of bytes (numbers with
   *     value in [0, 255]) to encode.
   * @param webSafe Boolean indicating we should use the
   *     alternative alphabet.
   * @return The base64 encoded string.
   */
  encodeByteArray(e, t) {
    if (!Array.isArray(e))
      throw Error("encodeByteArray takes an array as a parameter");
    this.init_();
    const n = t ? this.byteToCharMapWebSafe_ : this.byteToCharMap_, r = [];
    for (let i = 0; i < e.length; i += 3) {
      const o = e[i], a = i + 1 < e.length, s = a ? e[i + 1] : 0, c = i + 2 < e.length, l = c ? e[i + 2] : 0, u = o >> 2, d = (o & 3) << 4 | s >> 4;
      let f = (s & 15) << 2 | l >> 6, h = l & 63;
      c || (h = 64, a || (f = 64)), r.push(n[u], n[d], n[f], n[h]);
    }
    return r.join("");
  },
  /**
   * Base64-encode a string.
   *
   * @param input A string to encode.
   * @param webSafe If true, we should use the
   *     alternative alphabet.
   * @return The base64 encoded string.
   */
  encodeString(e, t) {
    return this.HAS_NATIVE_SUPPORT && !t ? btoa(e) : this.encodeByteArray(lH(e), t);
  },
  /**
   * Base64-decode a string.
   *
   * @param input to decode.
   * @param webSafe True if we should use the
   *     alternative alphabet.
   * @return string representing the decoded value.
   */
  decodeString(e, t) {
    return this.HAS_NATIVE_SUPPORT && !t ? atob(e) : zle(this.decodeStringToByteArray(e, t));
  },
  /**
   * Base64-decode a string.
   *
   * In base-64 decoding, groups of four characters are converted into three
   * bytes.  If the encoder did not apply padding, the input length may not
   * be a multiple of 4.
   *
   * In this case, the last group will have fewer than 4 characters, and
   * padding will be inferred.  If the group has one or two characters, it decodes
   * to one byte.  If the group has three characters, it decodes to two bytes.
   *
   * @param input Input to decode.
   * @param webSafe True if we should use the web-safe alphabet.
   * @return bytes representing the decoded value.
   */
  decodeStringToByteArray(e, t) {
    this.init_();
    const n = t ? this.charToByteMapWebSafe_ : this.charToByteMap_, r = [];
    for (let i = 0; i < e.length; ) {
      const o = n[e.charAt(i++)], s = i < e.length ? n[e.charAt(i)] : 0;
      ++i;
      const l = i < e.length ? n[e.charAt(i)] : 64;
      ++i;
      const d = i < e.length ? n[e.charAt(i)] : 64;
      if (++i, o == null || s == null || l == null || d == null)
        throw new Hle();
      const f = o << 2 | s >> 4;
      if (r.push(f), l !== 64) {
        const h = s << 4 & 240 | l >> 2;
        if (r.push(h), d !== 64) {
          const p = l << 6 & 192 | d;
          r.push(p);
        }
      }
    }
    return r;
  },
  /**
   * Lazy static initialization function. Called before
   * accessing any of the static map variables.
   * @private
   */
  init_() {
    if (!this.byteToCharMap_) {
      this.byteToCharMap_ = {}, this.charToByteMap_ = {}, this.byteToCharMapWebSafe_ = {}, this.charToByteMapWebSafe_ = {};
      for (let e = 0; e < this.ENCODED_VALS.length; e++)
        this.byteToCharMap_[e] = this.ENCODED_VALS.charAt(e), this.charToByteMap_[this.byteToCharMap_[e]] = e, this.byteToCharMapWebSafe_[e] = this.ENCODED_VALS_WEBSAFE.charAt(e), this.charToByteMapWebSafe_[this.byteToCharMapWebSafe_[e]] = e, e >= this.ENCODED_VALS_BASE.length && (this.charToByteMap_[this.ENCODED_VALS_WEBSAFE.charAt(e)] = e, this.charToByteMapWebSafe_[this.ENCODED_VALS.charAt(e)] = e);
    }
  }
};
class Hle extends Error {
  constructor() {
    super(...arguments), this.name = "DecodeBase64StringError";
  }
}
const Ule = function(e) {
  const t = lH(e);
  return uH.encodeByteArray(t, !0);
}, h_ = function(e) {
  return Ule(e).replace(/\./g, "");
}, dH = function(e) {
  try {
    return uH.decodeString(e, !0);
  } catch (t) {
    console.error("base64Decode failed: ", t);
  }
  return null;
};
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function Wle() {
  if (typeof self < "u")
    return self;
  if (typeof window < "u")
    return window;
  if (typeof global < "u")
    return global;
  throw new Error("Unable to locate global object.");
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const qle = () => Wle().__FIREBASE_DEFAULTS__, Gle = () => {
  if (typeof process > "u" || typeof process.env > "u")
    return;
  const e = process.env.__FIREBASE_DEFAULTS__;
  if (e)
    return JSON.parse(e);
}, Kle = () => {
  if (typeof document > "u")
    return;
  let e;
  try {
    e = document.cookie.match(/__FIREBASE_DEFAULTS__=([^;]+)/);
  } catch {
    return;
  }
  const t = e && dH(e[1]);
  return t && JSON.parse(t);
}, Ww = () => {
  try {
    return Ble() || qle() || Gle() || Kle();
  } catch (e) {
    console.info(`Unable to get __FIREBASE_DEFAULTS__ due to: ${e}`);
    return;
  }
}, fH = (e) => {
  var t, n;
  return (n = (t = Ww()) === null || t === void 0 ? void 0 : t.emulatorHosts) === null || n === void 0 ? void 0 : n[e];
}, hH = (e) => {
  const t = fH(e);
  if (!t)
    return;
  const n = t.lastIndexOf(":");
  if (n <= 0 || n + 1 === t.length)
    throw new Error(`Invalid host ${t} with no separate hostname and port!`);
  const r = parseInt(t.substring(n + 1), 10);
  return t[0] === "[" ? [t.substring(1, n - 1), r] : [t.substring(0, n), r];
}, gH = () => {
  var e;
  return (e = Ww()) === null || e === void 0 ? void 0 : e.config;
}, pH = (e) => {
  var t;
  return (t = Ww()) === null || t === void 0 ? void 0 : t[`_${e}`];
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class Yle {
  constructor() {
    this.reject = () => {
    }, this.resolve = () => {
    }, this.promise = new Promise((t, n) => {
      this.resolve = t, this.reject = n;
    });
  }
  /**
   * Our API internals are not promisified and cannot because our callback APIs have subtle expectations around
   * invoking promises inline, which Promises are forbidden to do. This method accepts an optional node-style callback
   * and returns a node-style callback which will resolve or reject the Deferred's promise.
   */
  wrapCallback(t) {
    return (n, r) => {
      n ? this.reject(n) : this.resolve(r), typeof t == "function" && (this.promise.catch(() => {
      }), t.length === 1 ? t(n) : t(n, r));
    };
  }
}
/**
 * @license
 * Copyright 2025 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function ku(e) {
  try {
    return (e.startsWith("http://") || e.startsWith("https://") ? new URL(e).hostname : e).endsWith(".cloudworkstations.dev");
  } catch {
    return !1;
  }
}
async function qw(e) {
  return (await fetch(e, {
    credentials: "include"
  })).ok;
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function Xle(e, t) {
  if (e.uid)
    throw new Error('The "uid" field is no longer supported by mockUserToken. Please use "sub" instead for Firebase Auth User ID.');
  const n = {
    alg: "none",
    type: "JWT"
  }, r = t || "demo-project", i = e.iat || 0, o = e.sub || e.user_id;
  if (!o)
    throw new Error("mockUserToken must contain 'sub' or 'user_id' field!");
  const a = Object.assign({
    // Set all required fields to decent defaults
    iss: `https://securetoken.google.com/${r}`,
    aud: r,
    iat: i,
    exp: i + 3600,
    auth_time: i,
    sub: o,
    user_id: o,
    firebase: {
      sign_in_provider: "custom",
      identities: {}
    }
  }, e), s = "";
  return [
    h_(JSON.stringify(n)),
    h_(JSON.stringify(a)),
    s
  ].join(".");
}
const i0 = {};
function Qle() {
  const e = {
    prod: [],
    emulator: []
  };
  for (const t of Object.keys(i0))
    i0[t] ? e.emulator.push(t) : e.prod.push(t);
  return e;
}
function Jle(e) {
  let t = document.getElementById(e), n = !1;
  return t || (t = document.createElement("div"), t.setAttribute("id", e), n = !0), { created: n, element: t };
}
let rD = !1;
function pO(e, t) {
  if (typeof window > "u" || typeof document > "u" || !ku(window.location.host) || i0[e] === t || i0[e] || // If already set to use emulator, can't go back to prod.
  rD)
    return;
  i0[e] = t;
  function n(f) {
    return `__firebase__banner__${f}`;
  }
  const r = "__firebase__banner", o = Qle().prod.length > 0;
  function a() {
    const f = document.getElementById(r);
    f && f.remove();
  }
  function s(f) {
    f.style.display = "flex", f.style.background = "#7faaf0", f.style.position = "fixed", f.style.bottom = "5px", f.style.left = "5px", f.style.padding = ".5em", f.style.borderRadius = "5px", f.style.alignItems = "center";
  }
  function c(f, h) {
    f.setAttribute("width", "24"), f.setAttribute("id", h), f.setAttribute("height", "24"), f.setAttribute("viewBox", "0 0 24 24"), f.setAttribute("fill", "none"), f.style.marginLeft = "-6px";
  }
  function l() {
    const f = document.createElement("span");
    return f.style.cursor = "pointer", f.style.marginLeft = "16px", f.style.fontSize = "24px", f.innerHTML = " &times;", f.onclick = () => {
      rD = !0, a();
    }, f;
  }
  function u(f, h) {
    f.setAttribute("id", h), f.innerText = "Learn more", f.href = "https://firebase.google.com/docs/studio/preview-apps#preview-backend", f.setAttribute("target", "__blank"), f.style.paddingLeft = "5px", f.style.textDecoration = "underline";
  }
  function d() {
    const f = Jle(r), h = n("text"), p = document.getElementById(h) || document.createElement("span"), g = n("learnmore"), m = document.getElementById(g) || document.createElement("a"), v = n("preprendIcon"), y = document.getElementById(v) || document.createElementNS("http://www.w3.org/2000/svg", "svg");
    if (f.created) {
      const S = f.element;
      s(S), u(m, g);
      const _ = l();
      c(y, v), S.append(y, p, m, _), document.body.appendChild(S);
    }
    o ? (p.innerText = "Preview backend disconnected.", y.innerHTML = `<g clip-path="url(#clip0_6013_33858)">
<path d="M4.8 17.6L12 5.6L19.2 17.6H4.8ZM6.91667 16.4H17.0833L12 7.93333L6.91667 16.4ZM12 15.6C12.1667 15.6 12.3056 15.5444 12.4167 15.4333C12.5389 15.3111 12.6 15.1667 12.6 15C12.6 14.8333 12.5389 14.6944 12.4167 14.5833C12.3056 14.4611 12.1667 14.4 12 14.4C11.8333 14.4 11.6889 14.4611 11.5667 14.5833C11.4556 14.6944 11.4 14.8333 11.4 15C11.4 15.1667 11.4556 15.3111 11.5667 15.4333C11.6889 15.5444 11.8333 15.6 12 15.6ZM11.4 13.6H12.6V10.4H11.4V13.6Z" fill="#212121"/>
</g>
<defs>
<clipPath id="clip0_6013_33858">
<rect width="24" height="24" fill="white"/>
</clipPath>
</defs>`) : (y.innerHTML = `<g clip-path="url(#clip0_6083_34804)">
<path d="M11.4 15.2H12.6V11.2H11.4V15.2ZM12 10C12.1667 10 12.3056 9.94444 12.4167 9.83333C12.5389 9.71111 12.6 9.56667 12.6 9.4C12.6 9.23333 12.5389 9.09444 12.4167 8.98333C12.3056 8.86111 12.1667 8.8 12 8.8C11.8333 8.8 11.6889 8.86111 11.5667 8.98333C11.4556 9.09444 11.4 9.23333 11.4 9.4C11.4 9.56667 11.4556 9.71111 11.5667 9.83333C11.6889 9.94444 11.8333 10 12 10ZM12 18.4C11.1222 18.4 10.2944 18.2333 9.51667 17.9C8.73889 17.5667 8.05556 17.1111 7.46667 16.5333C6.88889 15.9444 6.43333 15.2611 6.1 14.4833C5.76667 13.7056 5.6 12.8778 5.6 12C5.6 11.1111 5.76667 10.2833 6.1 9.51667C6.43333 8.73889 6.88889 8.06111 7.46667 7.48333C8.05556 6.89444 8.73889 6.43333 9.51667 6.1C10.2944 5.76667 11.1222 5.6 12 5.6C12.8889 5.6 13.7167 5.76667 14.4833 6.1C15.2611 6.43333 15.9389 6.89444 16.5167 7.48333C17.1056 8.06111 17.5667 8.73889 17.9 9.51667C18.2333 10.2833 18.4 11.1111 18.4 12C18.4 12.8778 18.2333 13.7056 17.9 14.4833C17.5667 15.2611 17.1056 15.9444 16.5167 16.5333C15.9389 17.1111 15.2611 17.5667 14.4833 17.9C13.7167 18.2333 12.8889 18.4 12 18.4ZM12 17.2C13.4444 17.2 14.6722 16.6944 15.6833 15.6833C16.6944 14.6722 17.2 13.4444 17.2 12C17.2 10.5556 16.6944 9.32778 15.6833 8.31667C14.6722 7.30555 13.4444 6.8 12 6.8C10.5556 6.8 9.32778 7.30555 8.31667 8.31667C7.30556 9.32778 6.8 10.5556 6.8 12C6.8 13.4444 7.30556 14.6722 8.31667 15.6833C9.32778 16.6944 10.5556 17.2 12 17.2Z" fill="#212121"/>
</g>
<defs>
<clipPath id="clip0_6083_34804">
<rect width="24" height="24" fill="white"/>
</clipPath>
</defs>`, p.innerText = "Preview backend running in this workspace."), p.setAttribute("id", h);
  }
  document.readyState === "loading" ? window.addEventListener("DOMContentLoaded", d) : d();
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function co() {
  return typeof navigator < "u" && typeof navigator.userAgent == "string" ? navigator.userAgent : "";
}
function Zle() {
  return typeof window < "u" && // @ts-ignore Setting up an broadly applicable index signature for Window
  // just to deal with this case would probably be a bad idea.
  !!(window.cordova || window.phonegap || window.PhoneGap) && /ios|iphone|ipod|ipad|android|blackberry|iemobile/i.test(co());
}
function eue() {
  var e;
  const t = (e = Ww()) === null || e === void 0 ? void 0 : e.forceEnvironment;
  if (t === "node")
    return !0;
  if (t === "browser")
    return !1;
  try {
    return Object.prototype.toString.call(global.process) === "[object process]";
  } catch {
    return !1;
  }
}
function tue() {
  return typeof navigator < "u" && navigator.userAgent === "Cloudflare-Workers";
}
function mH() {
  const e = typeof chrome == "object" ? chrome.runtime : typeof browser == "object" ? browser.runtime : void 0;
  return typeof e == "object" && e.id !== void 0;
}
function nue() {
  return typeof navigator == "object" && navigator.product === "ReactNative";
}
function rue() {
  const e = co();
  return e.indexOf("MSIE ") >= 0 || e.indexOf("Trident/") >= 0;
}
function iue() {
  return !eue() && !!navigator.userAgent && navigator.userAgent.includes("Safari") && !navigator.userAgent.includes("Chrome");
}
function vH() {
  try {
    return typeof indexedDB == "object";
  } catch {
    return !1;
  }
}
function yH() {
  return new Promise((e, t) => {
    try {
      let n = !0;
      const r = "validate-browser-context-for-indexeddb-analytics-module", i = self.indexedDB.open(r);
      i.onsuccess = () => {
        i.result.close(), n || self.indexedDB.deleteDatabase(r), e(!0);
      }, i.onupgradeneeded = () => {
        n = !1;
      }, i.onerror = () => {
        var o;
        t(((o = i.error) === null || o === void 0 ? void 0 : o.message) || "");
      };
    } catch (n) {
      t(n);
    }
  });
}
function oue() {
  return !(typeof navigator > "u" || !navigator.cookieEnabled);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const aue = "FirebaseError";
class Ua extends Error {
  constructor(t, n, r) {
    super(n), this.code = t, this.customData = r, this.name = aue, Object.setPrototypeOf(this, Ua.prototype), Error.captureStackTrace && Error.captureStackTrace(this, Sf.prototype.create);
  }
}
class Sf {
  constructor(t, n, r) {
    this.service = t, this.serviceName = n, this.errors = r;
  }
  create(t, ...n) {
    const r = n[0] || {}, i = `${this.service}/${t}`, o = this.errors[t], a = o ? sue(o, r) : "Error", s = `${this.serviceName}: ${a} (${i}).`;
    return new Ua(i, s, r);
  }
}
function sue(e, t) {
  return e.replace(cue, (n, r) => {
    const i = t[r];
    return i != null ? String(i) : `<${r}?>`;
  });
}
const cue = /\{\$([^}]+)}/g;
function lue(e) {
  for (const t in e)
    if (Object.prototype.hasOwnProperty.call(e, t))
      return !1;
  return !0;
}
function tl(e, t) {
  if (e === t)
    return !0;
  const n = Object.keys(e), r = Object.keys(t);
  for (const i of n) {
    if (!r.includes(i))
      return !1;
    const o = e[i], a = t[i];
    if (iD(o) && iD(a)) {
      if (!tl(o, a))
        return !1;
    } else if (o !== a)
      return !1;
  }
  for (const i of r)
    if (!n.includes(i))
      return !1;
  return !0;
}
function iD(e) {
  return e !== null && typeof e == "object";
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function Lv(e) {
  const t = [];
  for (const [n, r] of Object.entries(e))
    Array.isArray(r) ? r.forEach((i) => {
      t.push(encodeURIComponent(n) + "=" + encodeURIComponent(i));
    }) : t.push(encodeURIComponent(n) + "=" + encodeURIComponent(r));
  return t.length ? "&" + t.join("&") : "";
}
function Dm(e) {
  const t = {};
  return e.replace(/^\?/, "").split("&").forEach((r) => {
    if (r) {
      const [i, o] = r.split("=");
      t[decodeURIComponent(i)] = decodeURIComponent(o);
    }
  }), t;
}
function Lm(e) {
  const t = e.indexOf("?");
  if (!t)
    return "";
  const n = e.indexOf("#", t);
  return e.substring(t, n > 0 ? n : void 0);
}
function uue(e, t) {
  const n = new due(e, t);
  return n.subscribe.bind(n);
}
class due {
  /**
   * @param executor Function which can make calls to a single Observer
   *     as a proxy.
   * @param onNoObservers Callback when count of Observers goes to zero.
   */
  constructor(t, n) {
    this.observers = [], this.unsubscribes = [], this.observerCount = 0, this.task = Promise.resolve(), this.finalized = !1, this.onNoObservers = n, this.task.then(() => {
      t(this);
    }).catch((r) => {
      this.error(r);
    });
  }
  next(t) {
    this.forEachObserver((n) => {
      n.next(t);
    });
  }
  error(t) {
    this.forEachObserver((n) => {
      n.error(t);
    }), this.close(t);
  }
  complete() {
    this.forEachObserver((t) => {
      t.complete();
    }), this.close();
  }
  /**
   * Subscribe function that can be used to add an Observer to the fan-out list.
   *
   * - We require that no event is sent to a subscriber synchronously to their
   *   call to subscribe().
   */
  subscribe(t, n, r) {
    let i;
    if (t === void 0 && n === void 0 && r === void 0)
      throw new Error("Missing Observer.");
    fue(t, [
      "next",
      "error",
      "complete"
    ]) ? i = t : i = {
      next: t,
      error: n,
      complete: r
    }, i.next === void 0 && (i.next = U2), i.error === void 0 && (i.error = U2), i.complete === void 0 && (i.complete = U2);
    const o = this.unsubscribeOne.bind(this, this.observers.length);
    return this.finalized && this.task.then(() => {
      try {
        this.finalError ? i.error(this.finalError) : i.complete();
      } catch {
      }
    }), this.observers.push(i), o;
  }
  // Unsubscribe is synchronous - we guarantee that no events are sent to
  // any unsubscribed Observer.
  unsubscribeOne(t) {
    this.observers === void 0 || this.observers[t] === void 0 || (delete this.observers[t], this.observerCount -= 1, this.observerCount === 0 && this.onNoObservers !== void 0 && this.onNoObservers(this));
  }
  forEachObserver(t) {
    if (!this.finalized)
      for (let n = 0; n < this.observers.length; n++)
        this.sendOne(n, t);
  }
  // Call the Observer via one of it's callback function. We are careful to
  // confirm that the observe has not been unsubscribed since this asynchronous
  // function had been queued.
  sendOne(t, n) {
    this.task.then(() => {
      if (this.observers !== void 0 && this.observers[t] !== void 0)
        try {
          n(this.observers[t]);
        } catch (r) {
          typeof console < "u" && console.error && console.error(r);
        }
    });
  }
  close(t) {
    this.finalized || (this.finalized = !0, t !== void 0 && (this.finalError = t), this.task.then(() => {
      this.observers = void 0, this.onNoObservers = void 0;
    }));
  }
}
function fue(e, t) {
  if (typeof e != "object" || e === null)
    return !1;
  for (const n of t)
    if (n in e && typeof e[n] == "function")
      return !0;
  return !1;
}
function U2() {
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const hue = 1e3, gue = 2, pue = 4 * 60 * 60 * 1e3, mue = 0.5;
function oD(e, t = hue, n = gue) {
  const r = t * Math.pow(n, e), i = Math.round(
    // A fraction of the backoff value to add/subtract.
    // Deviation: changes multiplication order to improve readability.
    mue * r * // A random float (rounded to int by Math.round above) in the range [-1, 1]. Determines
    // if we add or subtract.
    (Math.random() - 0.5) * 2
  );
  return Math.min(pue, r + i);
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function $r(e) {
  return e && e._delegate ? e._delegate : e;
}
class Fa {
  /**
   *
   * @param name The public service name, e.g. app, auth, firestore, database
   * @param instanceFactory Service factory responsible for creating the public interface
   * @param type whether the service provided by the component is public or private
   */
  constructor(t, n, r) {
    this.name = t, this.instanceFactory = n, this.type = r, this.multipleInstances = !1, this.serviceProps = {}, this.instantiationMode = "LAZY", this.onInstanceCreated = null;
  }
  setInstantiationMode(t) {
    return this.instantiationMode = t, this;
  }
  setMultipleInstances(t) {
    return this.multipleInstances = t, this;
  }
  setServiceProps(t) {
    return this.serviceProps = t, this;
  }
  setInstanceCreatedCallback(t) {
    return this.onInstanceCreated = t, this;
  }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const ud = "[DEFAULT]";
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class vue {
  constructor(t, n) {
    this.name = t, this.container = n, this.component = null, this.instances = /* @__PURE__ */ new Map(), this.instancesDeferred = /* @__PURE__ */ new Map(), this.instancesOptions = /* @__PURE__ */ new Map(), this.onInitCallbacks = /* @__PURE__ */ new Map();
  }
  /**
   * @param identifier A provider can provide multiple instances of a service
   * if this.component.multipleInstances is true.
   */
  get(t) {
    const n = this.normalizeInstanceIdentifier(t);
    if (!this.instancesDeferred.has(n)) {
      const r = new Yle();
      if (this.instancesDeferred.set(n, r), this.isInitialized(n) || this.shouldAutoInitialize())
        try {
          const i = this.getOrInitializeService({
            instanceIdentifier: n
          });
          i && r.resolve(i);
        } catch {
        }
    }
    return this.instancesDeferred.get(n).promise;
  }
  getImmediate(t) {
    var n;
    const r = this.normalizeInstanceIdentifier(t == null ? void 0 : t.identifier), i = (n = t == null ? void 0 : t.optional) !== null && n !== void 0 ? n : !1;
    if (this.isInitialized(r) || this.shouldAutoInitialize())
      try {
        return this.getOrInitializeService({
          instanceIdentifier: r
        });
      } catch (o) {
        if (i)
          return null;
        throw o;
      }
    else {
      if (i)
        return null;
      throw Error(`Service ${this.name} is not available`);
    }
  }
  getComponent() {
    return this.component;
  }
  setComponent(t) {
    if (t.name !== this.name)
      throw Error(`Mismatching Component ${t.name} for Provider ${this.name}.`);
    if (this.component)
      throw Error(`Component for ${this.name} has already been provided`);
    if (this.component = t, !!this.shouldAutoInitialize()) {
      if (bue(t))
        try {
          this.getOrInitializeService({ instanceIdentifier: ud });
        } catch {
        }
      for (const [n, r] of this.instancesDeferred.entries()) {
        const i = this.normalizeInstanceIdentifier(n);
        try {
          const o = this.getOrInitializeService({
            instanceIdentifier: i
          });
          r.resolve(o);
        } catch {
        }
      }
    }
  }
  clearInstance(t = ud) {
    this.instancesDeferred.delete(t), this.instancesOptions.delete(t), this.instances.delete(t);
  }
  // app.delete() will call this method on every provider to delete the services
  // TODO: should we mark the provider as deleted?
  async delete() {
    const t = Array.from(this.instances.values());
    await Promise.all([
      ...t.filter((n) => "INTERNAL" in n).map((n) => n.INTERNAL.delete()),
      ...t.filter((n) => "_delete" in n).map((n) => n._delete())
    ]);
  }
  isComponentSet() {
    return this.component != null;
  }
  isInitialized(t = ud) {
    return this.instances.has(t);
  }
  getOptions(t = ud) {
    return this.instancesOptions.get(t) || {};
  }
  initialize(t = {}) {
    const { options: n = {} } = t, r = this.normalizeInstanceIdentifier(t.instanceIdentifier);
    if (this.isInitialized(r))
      throw Error(`${this.name}(${r}) has already been initialized`);
    if (!this.isComponentSet())
      throw Error(`Component ${this.name} has not been registered yet`);
    const i = this.getOrInitializeService({
      instanceIdentifier: r,
      options: n
    });
    for (const [o, a] of this.instancesDeferred.entries()) {
      const s = this.normalizeInstanceIdentifier(o);
      r === s && a.resolve(i);
    }
    return i;
  }
  /**
   *
   * @param callback - a function that will be invoked  after the provider has been initialized by calling provider.initialize().
   * The function is invoked SYNCHRONOUSLY, so it should not execute any longrunning tasks in order to not block the program.
   *
   * @param identifier An optional instance identifier
   * @returns a function to unregister the callback
   */
  onInit(t, n) {
    var r;
    const i = this.normalizeInstanceIdentifier(n), o = (r = this.onInitCallbacks.get(i)) !== null && r !== void 0 ? r : /* @__PURE__ */ new Set();
    o.add(t), this.onInitCallbacks.set(i, o);
    const a = this.instances.get(i);
    return a && t(a, i), () => {
      o.delete(t);
    };
  }
  /**
   * Invoke onInit callbacks synchronously
   * @param instance the service instance`
   */
  invokeOnInitCallbacks(t, n) {
    const r = this.onInitCallbacks.get(n);
    if (r)
      for (const i of r)
        try {
          i(t, n);
        } catch {
        }
  }
  getOrInitializeService({ instanceIdentifier: t, options: n = {} }) {
    let r = this.instances.get(t);
    if (!r && this.component && (r = this.component.instanceFactory(this.container, {
      instanceIdentifier: yue(t),
      options: n
    }), this.instances.set(t, r), this.instancesOptions.set(t, n), this.invokeOnInitCallbacks(r, t), this.component.onInstanceCreated))
      try {
        this.component.onInstanceCreated(this.container, t, r);
      } catch {
      }
    return r || null;
  }
  normalizeInstanceIdentifier(t = ud) {
    return this.component ? this.component.multipleInstances ? t : ud : t;
  }
  shouldAutoInitialize() {
    return !!this.component && this.component.instantiationMode !== "EXPLICIT";
  }
}
function yue(e) {
  return e === ud ? void 0 : e;
}
function bue(e) {
  return e.instantiationMode === "EAGER";
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class _ue {
  constructor(t) {
    this.name = t, this.providers = /* @__PURE__ */ new Map();
  }
  /**
   *
   * @param component Component being added
   * @param overwrite When a component with the same name has already been registered,
   * if overwrite is true: overwrite the existing component with the new component and create a new
   * provider with the new component. It can be useful in tests where you want to use different mocks
   * for different tests.
   * if overwrite is false: throw an exception
   */
  addComponent(t) {
    const n = this.getProvider(t.name);
    if (n.isComponentSet())
      throw new Error(`Component ${t.name} has already been registered with ${this.name}`);
    n.setComponent(t);
  }
  addOrOverwriteComponent(t) {
    this.getProvider(t.name).isComponentSet() && this.providers.delete(t.name), this.addComponent(t);
  }
  /**
   * getProvider provides a type safe interface where it can only be called with a field name
   * present in NameServiceMapping interface.
   *
   * Firebase SDKs providing services should extend NameServiceMapping interface to register
   * themselves.
   */
  getProvider(t) {
    if (this.providers.has(t))
      return this.providers.get(t);
    const n = new vue(t, this);
    return this.providers.set(t, n), n;
  }
  getProviders() {
    return Array.from(this.providers.values());
  }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var bn;
(function(e) {
  e[e.DEBUG = 0] = "DEBUG", e[e.VERBOSE = 1] = "VERBOSE", e[e.INFO = 2] = "INFO", e[e.WARN = 3] = "WARN", e[e.ERROR = 4] = "ERROR", e[e.SILENT = 5] = "SILENT";
})(bn || (bn = {}));
const Sue = {
  debug: bn.DEBUG,
  verbose: bn.VERBOSE,
  info: bn.INFO,
  warn: bn.WARN,
  error: bn.ERROR,
  silent: bn.SILENT
}, wue = bn.INFO, xue = {
  [bn.DEBUG]: "log",
  [bn.VERBOSE]: "log",
  [bn.INFO]: "info",
  [bn.WARN]: "warn",
  [bn.ERROR]: "error"
}, Eue = (e, t, ...n) => {
  if (t < e.logLevel)
    return;
  const r = (/* @__PURE__ */ new Date()).toISOString(), i = xue[t];
  if (i)
    console[i](`[${r}]  ${e.name}:`, ...n);
  else
    throw new Error(`Attempted to log a message with an invalid logType (value: ${t})`);
};
class Gw {
  /**
   * Gives you an instance of a Logger to capture messages according to
   * Firebase's logging scheme.
   *
   * @param name The name that the logs will be associated with
   */
  constructor(t) {
    this.name = t, this._logLevel = wue, this._logHandler = Eue, this._userLogHandler = null;
  }
  get logLevel() {
    return this._logLevel;
  }
  set logLevel(t) {
    if (!(t in bn))
      throw new TypeError(`Invalid value "${t}" assigned to \`logLevel\``);
    this._logLevel = t;
  }
  // Workaround for setter/getter having to be the same type.
  setLogLevel(t) {
    this._logLevel = typeof t == "string" ? Sue[t] : t;
  }
  get logHandler() {
    return this._logHandler;
  }
  set logHandler(t) {
    if (typeof t != "function")
      throw new TypeError("Value assigned to `logHandler` must be a function");
    this._logHandler = t;
  }
  get userLogHandler() {
    return this._userLogHandler;
  }
  set userLogHandler(t) {
    this._userLogHandler = t;
  }
  /**
   * The functions below are all based on the `console` interface
   */
  debug(...t) {
    this._userLogHandler && this._userLogHandler(this, bn.DEBUG, ...t), this._logHandler(this, bn.DEBUG, ...t);
  }
  log(...t) {
    this._userLogHandler && this._userLogHandler(this, bn.VERBOSE, ...t), this._logHandler(this, bn.VERBOSE, ...t);
  }
  info(...t) {
    this._userLogHandler && this._userLogHandler(this, bn.INFO, ...t), this._logHandler(this, bn.INFO, ...t);
  }
  warn(...t) {
    this._userLogHandler && this._userLogHandler(this, bn.WARN, ...t), this._logHandler(this, bn.WARN, ...t);
  }
  error(...t) {
    this._userLogHandler && this._userLogHandler(this, bn.ERROR, ...t), this._logHandler(this, bn.ERROR, ...t);
  }
}
const Cue = (e, t) => t.some((n) => e instanceof n);
let aD, sD;
function Tue() {
  return aD || (aD = [
    IDBDatabase,
    IDBObjectStore,
    IDBIndex,
    IDBCursor,
    IDBTransaction
  ]);
}
function Iue() {
  return sD || (sD = [
    IDBCursor.prototype.advance,
    IDBCursor.prototype.continue,
    IDBCursor.prototype.continuePrimaryKey
  ]);
}
const bH = /* @__PURE__ */ new WeakMap(), EI = /* @__PURE__ */ new WeakMap(), _H = /* @__PURE__ */ new WeakMap(), W2 = /* @__PURE__ */ new WeakMap(), mO = /* @__PURE__ */ new WeakMap();
function Aue(e) {
  const t = new Promise((n, r) => {
    const i = () => {
      e.removeEventListener("success", o), e.removeEventListener("error", a);
    }, o = () => {
      n(ru(e.result)), i();
    }, a = () => {
      r(e.error), i();
    };
    e.addEventListener("success", o), e.addEventListener("error", a);
  });
  return t.then((n) => {
    n instanceof IDBCursor && bH.set(n, e);
  }).catch(() => {
  }), mO.set(t, e), t;
}
function Rue(e) {
  if (EI.has(e))
    return;
  const t = new Promise((n, r) => {
    const i = () => {
      e.removeEventListener("complete", o), e.removeEventListener("error", a), e.removeEventListener("abort", a);
    }, o = () => {
      n(), i();
    }, a = () => {
      r(e.error || new DOMException("AbortError", "AbortError")), i();
    };
    e.addEventListener("complete", o), e.addEventListener("error", a), e.addEventListener("abort", a);
  });
  EI.set(e, t);
}
let CI = {
  get(e, t, n) {
    if (e instanceof IDBTransaction) {
      if (t === "done")
        return EI.get(e);
      if (t === "objectStoreNames")
        return e.objectStoreNames || _H.get(e);
      if (t === "store")
        return n.objectStoreNames[1] ? void 0 : n.objectStore(n.objectStoreNames[0]);
    }
    return ru(e[t]);
  },
  set(e, t, n) {
    return e[t] = n, !0;
  },
  has(e, t) {
    return e instanceof IDBTransaction && (t === "done" || t === "store") ? !0 : t in e;
  }
};
function $ue(e) {
  CI = e(CI);
}
function Oue(e) {
  return e === IDBDatabase.prototype.transaction && !("objectStoreNames" in IDBTransaction.prototype) ? function(t, ...n) {
    const r = e.call(q2(this), t, ...n);
    return _H.set(r, t.sort ? t.sort() : [t]), ru(r);
  } : Iue().includes(e) ? function(...t) {
    return e.apply(q2(this), t), ru(bH.get(this));
  } : function(...t) {
    return ru(e.apply(q2(this), t));
  };
}
function Pue(e) {
  return typeof e == "function" ? Oue(e) : (e instanceof IDBTransaction && Rue(e), Cue(e, Tue()) ? new Proxy(e, CI) : e);
}
function ru(e) {
  if (e instanceof IDBRequest)
    return Aue(e);
  if (W2.has(e))
    return W2.get(e);
  const t = Pue(e);
  return t !== e && (W2.set(e, t), mO.set(t, e)), t;
}
const q2 = (e) => mO.get(e);
function SH(e, t, { blocked: n, upgrade: r, blocking: i, terminated: o } = {}) {
  const a = indexedDB.open(e, t), s = ru(a);
  return r && a.addEventListener("upgradeneeded", (c) => {
    r(ru(a.result), c.oldVersion, c.newVersion, ru(a.transaction), c);
  }), n && a.addEventListener("blocked", (c) => n(
    // Casting due to https://github.com/microsoft/TypeScript-DOM-lib-generator/pull/1405
    c.oldVersion,
    c.newVersion,
    c
  )), s.then((c) => {
    o && c.addEventListener("close", () => o()), i && c.addEventListener("versionchange", (l) => i(l.oldVersion, l.newVersion, l));
  }).catch(() => {
  }), s;
}
const Mue = ["get", "getKey", "getAll", "getAllKeys", "count"], kue = ["put", "add", "delete", "clear"], G2 = /* @__PURE__ */ new Map();
function cD(e, t) {
  if (!(e instanceof IDBDatabase && !(t in e) && typeof t == "string"))
    return;
  if (G2.get(t))
    return G2.get(t);
  const n = t.replace(/FromIndex$/, ""), r = t !== n, i = kue.includes(n);
  if (
    // Bail if the target doesn't exist on the target. Eg, getAll isn't in Edge.
    !(n in (r ? IDBIndex : IDBObjectStore).prototype) || !(i || Mue.includes(n))
  )
    return;
  const o = async function(a, ...s) {
    const c = this.transaction(a, i ? "readwrite" : "readonly");
    let l = c.store;
    return r && (l = l.index(s.shift())), (await Promise.all([
      l[n](...s),
      i && c.done
    ]))[0];
  };
  return G2.set(t, o), o;
}
$ue((e) => ({
  ...e,
  get: (t, n, r) => cD(t, n) || e.get(t, n, r),
  has: (t, n) => !!cD(t, n) || e.has(t, n)
}));
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class Nue {
  constructor(t) {
    this.container = t;
  }
  // In initial implementation, this will be called by installations on
  // auth token refresh, and installations will send this string.
  getPlatformInfoString() {
    return this.container.getProviders().map((n) => {
      if (Due(n)) {
        const r = n.getImmediate();
        return `${r.library}/${r.version}`;
      } else
        return null;
    }).filter((n) => n).join(" ");
  }
}
function Due(e) {
  const t = e.getComponent();
  return (t == null ? void 0 : t.type) === "VERSION";
}
const TI = "@firebase/app", lD = "0.13.2";
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const nl = new Gw("@firebase/app"), Lue = "@firebase/app-compat", jue = "@firebase/analytics-compat", Fue = "@firebase/analytics", Vue = "@firebase/app-check-compat", Bue = "@firebase/app-check", zue = "@firebase/auth", Hue = "@firebase/auth-compat", Uue = "@firebase/database", Wue = "@firebase/data-connect", que = "@firebase/database-compat", Gue = "@firebase/functions", Kue = "@firebase/functions-compat", Yue = "@firebase/installations", Xue = "@firebase/installations-compat", Que = "@firebase/messaging", Jue = "@firebase/messaging-compat", Zue = "@firebase/performance", ede = "@firebase/performance-compat", tde = "@firebase/remote-config", nde = "@firebase/remote-config-compat", rde = "@firebase/storage", ide = "@firebase/storage-compat", ode = "@firebase/firestore", ade = "@firebase/ai", sde = "@firebase/firestore-compat", cde = "firebase", lde = "11.10.0";
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const II = "[DEFAULT]", ude = {
  [TI]: "fire-core",
  [Lue]: "fire-core-compat",
  [Fue]: "fire-analytics",
  [jue]: "fire-analytics-compat",
  [Bue]: "fire-app-check",
  [Vue]: "fire-app-check-compat",
  [zue]: "fire-auth",
  [Hue]: "fire-auth-compat",
  [Uue]: "fire-rtdb",
  [Wue]: "fire-data-connect",
  [que]: "fire-rtdb-compat",
  [Gue]: "fire-fn",
  [Kue]: "fire-fn-compat",
  [Yue]: "fire-iid",
  [Xue]: "fire-iid-compat",
  [Que]: "fire-fcm",
  [Jue]: "fire-fcm-compat",
  [Zue]: "fire-perf",
  [ede]: "fire-perf-compat",
  [tde]: "fire-rc",
  [nde]: "fire-rc-compat",
  [rde]: "fire-gcs",
  [ide]: "fire-gcs-compat",
  [ode]: "fire-fst",
  [sde]: "fire-fst-compat",
  [ade]: "fire-vertex",
  "fire-js": "fire-js",
  // Platform identifier for JS SDK.
  [cde]: "fire-js-all"
};
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const g_ = /* @__PURE__ */ new Map(), dde = /* @__PURE__ */ new Map(), AI = /* @__PURE__ */ new Map();
function uD(e, t) {
  try {
    e.container.addComponent(t);
  } catch (n) {
    nl.debug(`Component ${t.name} failed to register with FirebaseApp ${e.name}`, n);
  }
}
function Ss(e) {
  const t = e.name;
  if (AI.has(t))
    return nl.debug(`There were multiple attempts to register component ${t}.`), !1;
  AI.set(t, e);
  for (const n of g_.values())
    uD(n, e);
  for (const n of dde.values())
    uD(n, e);
  return !0;
}
function gl(e, t) {
  const n = e.container.getProvider("heartbeat").getImmediate({ optional: !0 });
  return n && n.triggerHeartbeat(), e.container.getProvider(t);
}
function Eo(e) {
  return e == null ? !1 : e.settings !== void 0;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const fde = {
  "no-app": "No Firebase App '{$appName}' has been created - call initializeApp() first",
  "bad-app-name": "Illegal App name: '{$appName}'",
  "duplicate-app": "Firebase App named '{$appName}' already exists with different options or config",
  "app-deleted": "Firebase App named '{$appName}' already deleted",
  "server-app-deleted": "Firebase Server App has been deleted",
  "no-options": "Need to provide options, when not being deployed to hosting via source.",
  "invalid-app-argument": "firebase.{$appName}() takes either no argument or a Firebase App instance.",
  "invalid-log-argument": "First argument to `onLog` must be null or a function.",
  "idb-open": "Error thrown when opening IndexedDB. Original error: {$originalErrorMessage}.",
  "idb-get": "Error thrown when reading from IndexedDB. Original error: {$originalErrorMessage}.",
  "idb-set": "Error thrown when writing to IndexedDB. Original error: {$originalErrorMessage}.",
  "idb-delete": "Error thrown when deleting from IndexedDB. Original error: {$originalErrorMessage}.",
  "finalization-registry-not-supported": "FirebaseServerApp deleteOnDeref field defined but the JS runtime does not support FinalizationRegistry.",
  "invalid-server-app-environment": "FirebaseServerApp is not for use in browser environments."
}, iu = new Sf("app", "Firebase", fde);
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class hde {
  constructor(t, n, r) {
    this._isDeleted = !1, this._options = Object.assign({}, t), this._config = Object.assign({}, n), this._name = n.name, this._automaticDataCollectionEnabled = n.automaticDataCollectionEnabled, this._container = r, this.container.addComponent(new Fa(
      "app",
      () => this,
      "PUBLIC"
      /* ComponentType.PUBLIC */
    ));
  }
  get automaticDataCollectionEnabled() {
    return this.checkDestroyed(), this._automaticDataCollectionEnabled;
  }
  set automaticDataCollectionEnabled(t) {
    this.checkDestroyed(), this._automaticDataCollectionEnabled = t;
  }
  get name() {
    return this.checkDestroyed(), this._name;
  }
  get options() {
    return this.checkDestroyed(), this._options;
  }
  get config() {
    return this.checkDestroyed(), this._config;
  }
  get container() {
    return this._container;
  }
  get isDeleted() {
    return this._isDeleted;
  }
  set isDeleted(t) {
    this._isDeleted = t;
  }
  /**
   * This function will throw an Error if the App has already been deleted -
   * use before performing API actions on the App.
   */
  checkDestroyed() {
    if (this.isDeleted)
      throw iu.create("app-deleted", { appName: this._name });
  }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const ap = lde;
function wH(e, t = {}) {
  let n = e;
  typeof t != "object" && (t = { name: t });
  const r = Object.assign({ name: II, automaticDataCollectionEnabled: !0 }, t), i = r.name;
  if (typeof i != "string" || !i)
    throw iu.create("bad-app-name", {
      appName: String(i)
    });
  if (n || (n = gH()), !n)
    throw iu.create(
      "no-options"
      /* AppError.NO_OPTIONS */
    );
  const o = g_.get(i);
  if (o) {
    if (tl(n, o.options) && tl(r, o.config))
      return o;
    throw iu.create("duplicate-app", { appName: i });
  }
  const a = new _ue(i);
  for (const c of AI.values())
    a.addComponent(c);
  const s = new hde(n, r, a);
  return g_.set(i, s), s;
}
function Kw(e = II) {
  const t = g_.get(e);
  if (!t && e === II && gH())
    return wH();
  if (!t)
    throw iu.create("no-app", { appName: e });
  return t;
}
function Jo(e, t, n) {
  var r;
  let i = (r = ude[e]) !== null && r !== void 0 ? r : e;
  n && (i += `-${n}`);
  const o = i.match(/\s|\//), a = t.match(/\s|\//);
  if (o || a) {
    const s = [
      `Unable to register library "${i}" with version "${t}":`
    ];
    o && s.push(`library name "${i}" contains illegal characters (whitespace or "/")`), o && a && s.push("and"), a && s.push(`version name "${t}" contains illegal characters (whitespace or "/")`), nl.warn(s.join(" "));
    return;
  }
  Ss(new Fa(
    `${i}-version`,
    () => ({ library: i, version: t }),
    "VERSION"
    /* ComponentType.VERSION */
  ));
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const gde = "firebase-heartbeat-database", pde = 1, N0 = "firebase-heartbeat-store";
let K2 = null;
function xH() {
  return K2 || (K2 = SH(gde, pde, {
    upgrade: (e, t) => {
      switch (t) {
        case 0:
          try {
            e.createObjectStore(N0);
          } catch (n) {
            console.warn(n);
          }
      }
    }
  }).catch((e) => {
    throw iu.create("idb-open", {
      originalErrorMessage: e.message
    });
  })), K2;
}
async function mde(e) {
  try {
    const n = (await xH()).transaction(N0), r = await n.objectStore(N0).get(EH(e));
    return await n.done, r;
  } catch (t) {
    if (t instanceof Ua)
      nl.warn(t.message);
    else {
      const n = iu.create("idb-get", {
        originalErrorMessage: t == null ? void 0 : t.message
      });
      nl.warn(n.message);
    }
  }
}
async function dD(e, t) {
  try {
    const r = (await xH()).transaction(N0, "readwrite");
    await r.objectStore(N0).put(t, EH(e)), await r.done;
  } catch (n) {
    if (n instanceof Ua)
      nl.warn(n.message);
    else {
      const r = iu.create("idb-set", {
        originalErrorMessage: n == null ? void 0 : n.message
      });
      nl.warn(r.message);
    }
  }
}
function EH(e) {
  return `${e.name}!${e.options.appId}`;
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const vde = 1024, yde = 30;
class bde {
  constructor(t) {
    this.container = t, this._heartbeatsCache = null;
    const n = this.container.getProvider("app").getImmediate();
    this._storage = new Sde(n), this._heartbeatsCachePromise = this._storage.read().then((r) => (this._heartbeatsCache = r, r));
  }
  /**
   * Called to report a heartbeat. The function will generate
   * a HeartbeatsByUserAgent object, update heartbeatsCache, and persist it
   * to IndexedDB.
   * Note that we only store one heartbeat per day. So if a heartbeat for today is
   * already logged, subsequent calls to this function in the same day will be ignored.
   */
  async triggerHeartbeat() {
    var t, n;
    try {
      const i = this.container.getProvider("platform-logger").getImmediate().getPlatformInfoString(), o = fD();
      if (((t = this._heartbeatsCache) === null || t === void 0 ? void 0 : t.heartbeats) == null && (this._heartbeatsCache = await this._heartbeatsCachePromise, ((n = this._heartbeatsCache) === null || n === void 0 ? void 0 : n.heartbeats) == null) || this._heartbeatsCache.lastSentHeartbeatDate === o || this._heartbeatsCache.heartbeats.some((a) => a.date === o))
        return;
      if (this._heartbeatsCache.heartbeats.push({ date: o, agent: i }), this._heartbeatsCache.heartbeats.length > yde) {
        const a = wde(this._heartbeatsCache.heartbeats);
        this._heartbeatsCache.heartbeats.splice(a, 1);
      }
      return this._storage.overwrite(this._heartbeatsCache);
    } catch (r) {
      nl.warn(r);
    }
  }
  /**
   * Returns a base64 encoded string which can be attached to the heartbeat-specific header directly.
   * It also clears all heartbeats from memory as well as in IndexedDB.
   *
   * NOTE: Consuming product SDKs should not send the header if this method
   * returns an empty string.
   */
  async getHeartbeatsHeader() {
    var t;
    try {
      if (this._heartbeatsCache === null && await this._heartbeatsCachePromise, ((t = this._heartbeatsCache) === null || t === void 0 ? void 0 : t.heartbeats) == null || this._heartbeatsCache.heartbeats.length === 0)
        return "";
      const n = fD(), { heartbeatsToSend: r, unsentEntries: i } = _de(this._heartbeatsCache.heartbeats), o = h_(JSON.stringify({ version: 2, heartbeats: r }));
      return this._heartbeatsCache.lastSentHeartbeatDate = n, i.length > 0 ? (this._heartbeatsCache.heartbeats = i, await this._storage.overwrite(this._heartbeatsCache)) : (this._heartbeatsCache.heartbeats = [], this._storage.overwrite(this._heartbeatsCache)), o;
    } catch (n) {
      return nl.warn(n), "";
    }
  }
}
function fD() {
  return (/* @__PURE__ */ new Date()).toISOString().substring(0, 10);
}
function _de(e, t = vde) {
  const n = [];
  let r = e.slice();
  for (const i of e) {
    const o = n.find((a) => a.agent === i.agent);
    if (o) {
      if (o.dates.push(i.date), hD(n) > t) {
        o.dates.pop();
        break;
      }
    } else if (n.push({
      agent: i.agent,
      dates: [i.date]
    }), hD(n) > t) {
      n.pop();
      break;
    }
    r = r.slice(1);
  }
  return {
    heartbeatsToSend: n,
    unsentEntries: r
  };
}
class Sde {
  constructor(t) {
    this.app = t, this._canUseIndexedDBPromise = this.runIndexedDBEnvironmentCheck();
  }
  async runIndexedDBEnvironmentCheck() {
    return vH() ? yH().then(() => !0).catch(() => !1) : !1;
  }
  /**
   * Read all heartbeats.
   */
  async read() {
    if (await this._canUseIndexedDBPromise) {
      const n = await mde(this.app);
      return n != null && n.heartbeats ? n : { heartbeats: [] };
    } else
      return { heartbeats: [] };
  }
  // overwrite the storage with the provided heartbeats
  async overwrite(t) {
    var n;
    if (await this._canUseIndexedDBPromise) {
      const i = await this.read();
      return dD(this.app, {
        lastSentHeartbeatDate: (n = t.lastSentHeartbeatDate) !== null && n !== void 0 ? n : i.lastSentHeartbeatDate,
        heartbeats: t.heartbeats
      });
    } else
      return;
  }
  // add heartbeats
  async add(t) {
    var n;
    if (await this._canUseIndexedDBPromise) {
      const i = await this.read();
      return dD(this.app, {
        lastSentHeartbeatDate: (n = t.lastSentHeartbeatDate) !== null && n !== void 0 ? n : i.lastSentHeartbeatDate,
        heartbeats: [
          ...i.heartbeats,
          ...t.heartbeats
        ]
      });
    } else
      return;
  }
}
function hD(e) {
  return h_(
    // heartbeatsCache wrapper properties
    JSON.stringify({ version: 2, heartbeats: e })
  ).length;
}
function wde(e) {
  if (e.length === 0)
    return -1;
  let t = 0, n = e[0].date;
  for (let r = 1; r < e.length; r++)
    e[r].date < n && (n = e[r].date, t = r);
  return t;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function xde(e) {
  Ss(new Fa(
    "platform-logger",
    (t) => new Nue(t),
    "PRIVATE"
    /* ComponentType.PRIVATE */
  )), Ss(new Fa(
    "heartbeat",
    (t) => new bde(t),
    "PRIVATE"
    /* ComponentType.PRIVATE */
  )), Jo(TI, lD, e), Jo(TI, lD, "esm2017"), Jo("fire-js", "");
}
xde("");
const CH = "@firebase/installations", vO = "0.6.18";
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const TH = 1e4, IH = `w:${vO}`, AH = "FIS_v2", Ede = "https://firebaseinstallations.googleapis.com/v1", Cde = 60 * 60 * 1e3, Tde = "installations", Ide = "Installations";
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const Ade = {
  "missing-app-config-values": 'Missing App configuration value: "{$valueName}"',
  "not-registered": "Firebase Installation is not registered.",
  "installation-not-found": "Firebase Installation not found.",
  "request-failed": '{$requestName} request failed with error "{$serverCode} {$serverStatus}: {$serverMessage}"',
  "app-offline": "Could not process request. Application offline.",
  "delete-pending-registration": "Can't delete installation while there is a pending registration request."
}, Qd = new Sf(Tde, Ide, Ade);
function RH(e) {
  return e instanceof Ua && e.code.includes(
    "request-failed"
    /* ErrorCode.REQUEST_FAILED */
  );
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function $H({ projectId: e }) {
  return `${Ede}/projects/${e}/installations`;
}
function OH(e) {
  return {
    token: e.token,
    requestStatus: 2,
    expiresIn: $de(e.expiresIn),
    creationTime: Date.now()
  };
}
async function PH(e, t) {
  const r = (await t.json()).error;
  return Qd.create("request-failed", {
    requestName: e,
    serverCode: r.code,
    serverMessage: r.message,
    serverStatus: r.status
  });
}
function MH({ apiKey: e }) {
  return new Headers({
    "Content-Type": "application/json",
    Accept: "application/json",
    "x-goog-api-key": e
  });
}
function Rde(e, { refreshToken: t }) {
  const n = MH(e);
  return n.append("Authorization", Ode(t)), n;
}
async function kH(e) {
  const t = await e();
  return t.status >= 500 && t.status < 600 ? e() : t;
}
function $de(e) {
  return Number(e.replace("s", "000"));
}
function Ode(e) {
  return `${AH} ${e}`;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
async function Pde({ appConfig: e, heartbeatServiceProvider: t }, { fid: n }) {
  const r = $H(e), i = MH(e), o = t.getImmediate({
    optional: !0
  });
  if (o) {
    const l = await o.getHeartbeatsHeader();
    l && i.append("x-firebase-client", l);
  }
  const a = {
    fid: n,
    authVersion: AH,
    appId: e.appId,
    sdkVersion: IH
  }, s = {
    method: "POST",
    headers: i,
    body: JSON.stringify(a)
  }, c = await kH(() => fetch(r, s));
  if (c.ok) {
    const l = await c.json();
    return {
      fid: l.fid || n,
      registrationStatus: 2,
      refreshToken: l.refreshToken,
      authToken: OH(l.authToken)
    };
  } else
    throw await PH("Create Installation", c);
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function NH(e) {
  return new Promise((t) => {
    setTimeout(t, e);
  });
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function Mde(e) {
  return btoa(String.fromCharCode(...e)).replace(/\+/g, "-").replace(/\//g, "_");
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const kde = /^[cdef][\w-]{21}$/, RI = "";
function Nde() {
  try {
    const e = new Uint8Array(17);
    (self.crypto || self.msCrypto).getRandomValues(e), e[0] = 112 + e[0] % 16;
    const n = Dde(e);
    return kde.test(n) ? n : RI;
  } catch {
    return RI;
  }
}
function Dde(e) {
  return Mde(e).substr(0, 22);
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function Yw(e) {
  return `${e.appName}!${e.appId}`;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const DH = /* @__PURE__ */ new Map();
function LH(e, t) {
  const n = Yw(e);
  jH(n, t), Lde(n, t);
}
function jH(e, t) {
  const n = DH.get(e);
  if (n)
    for (const r of n)
      r(t);
}
function Lde(e, t) {
  const n = jde();
  n && n.postMessage({ key: e, fid: t }), Fde();
}
let yd = null;
function jde() {
  return !yd && "BroadcastChannel" in self && (yd = new BroadcastChannel("[Firebase] FID Change"), yd.onmessage = (e) => {
    jH(e.data.key, e.data.fid);
  }), yd;
}
function Fde() {
  DH.size === 0 && yd && (yd.close(), yd = null);
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const Vde = "firebase-installations-database", Bde = 1, Jd = "firebase-installations-store";
let Y2 = null;
function yO() {
  return Y2 || (Y2 = SH(Vde, Bde, {
    upgrade: (e, t) => {
      switch (t) {
        case 0:
          e.createObjectStore(Jd);
      }
    }
  })), Y2;
}
async function p_(e, t) {
  const n = Yw(e), i = (await yO()).transaction(Jd, "readwrite"), o = i.objectStore(Jd), a = await o.get(n);
  return await o.put(t, n), await i.done, (!a || a.fid !== t.fid) && LH(e, t.fid), t;
}
async function FH(e) {
  const t = Yw(e), r = (await yO()).transaction(Jd, "readwrite");
  await r.objectStore(Jd).delete(t), await r.done;
}
async function Xw(e, t) {
  const n = Yw(e), i = (await yO()).transaction(Jd, "readwrite"), o = i.objectStore(Jd), a = await o.get(n), s = t(a);
  return s === void 0 ? await o.delete(n) : await o.put(s, n), await i.done, s && (!a || a.fid !== s.fid) && LH(e, s.fid), s;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
async function bO(e) {
  let t;
  const n = await Xw(e.appConfig, (r) => {
    const i = zde(r), o = Hde(e, i);
    return t = o.registrationPromise, o.installationEntry;
  });
  return n.fid === RI ? { installationEntry: await t } : {
    installationEntry: n,
    registrationPromise: t
  };
}
function zde(e) {
  const t = e || {
    fid: Nde(),
    registrationStatus: 0
    /* RequestStatus.NOT_STARTED */
  };
  return VH(t);
}
function Hde(e, t) {
  if (t.registrationStatus === 0) {
    if (!navigator.onLine) {
      const i = Promise.reject(Qd.create(
        "app-offline"
        /* ErrorCode.APP_OFFLINE */
      ));
      return {
        installationEntry: t,
        registrationPromise: i
      };
    }
    const n = {
      fid: t.fid,
      registrationStatus: 1,
      registrationTime: Date.now()
    }, r = Ude(e, n);
    return { installationEntry: n, registrationPromise: r };
  } else
    return t.registrationStatus === 1 ? {
      installationEntry: t,
      registrationPromise: Wde(e)
    } : { installationEntry: t };
}
async function Ude(e, t) {
  try {
    const n = await Pde(e, t);
    return p_(e.appConfig, n);
  } catch (n) {
    throw RH(n) && n.customData.serverCode === 409 ? await FH(e.appConfig) : await p_(e.appConfig, {
      fid: t.fid,
      registrationStatus: 0
      /* RequestStatus.NOT_STARTED */
    }), n;
  }
}
async function Wde(e) {
  let t = await gD(e.appConfig);
  for (; t.registrationStatus === 1; )
    await NH(100), t = await gD(e.appConfig);
  if (t.registrationStatus === 0) {
    const { installationEntry: n, registrationPromise: r } = await bO(e);
    return r || n;
  }
  return t;
}
function gD(e) {
  return Xw(e, (t) => {
    if (!t)
      throw Qd.create(
        "installation-not-found"
        /* ErrorCode.INSTALLATION_NOT_FOUND */
      );
    return VH(t);
  });
}
function VH(e) {
  return qde(e) ? {
    fid: e.fid,
    registrationStatus: 0
    /* RequestStatus.NOT_STARTED */
  } : e;
}
function qde(e) {
  return e.registrationStatus === 1 && e.registrationTime + TH < Date.now();
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
async function Gde({ appConfig: e, heartbeatServiceProvider: t }, n) {
  const r = Kde(e, n), i = Rde(e, n), o = t.getImmediate({
    optional: !0
  });
  if (o) {
    const l = await o.getHeartbeatsHeader();
    l && i.append("x-firebase-client", l);
  }
  const a = {
    installation: {
      sdkVersion: IH,
      appId: e.appId
    }
  }, s = {
    method: "POST",
    headers: i,
    body: JSON.stringify(a)
  }, c = await kH(() => fetch(r, s));
  if (c.ok) {
    const l = await c.json();
    return OH(l);
  } else
    throw await PH("Generate Auth Token", c);
}
function Kde(e, { fid: t }) {
  return `${$H(e)}/${t}/authTokens:generate`;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
async function _O(e, t = !1) {
  let n;
  const r = await Xw(e.appConfig, (o) => {
    if (!BH(o))
      throw Qd.create(
        "not-registered"
        /* ErrorCode.NOT_REGISTERED */
      );
    const a = o.authToken;
    if (!t && Qde(a))
      return o;
    if (a.requestStatus === 1)
      return n = Yde(e, t), o;
    {
      if (!navigator.onLine)
        throw Qd.create(
          "app-offline"
          /* ErrorCode.APP_OFFLINE */
        );
      const s = Zde(o);
      return n = Xde(e, s), s;
    }
  });
  return n ? await n : r.authToken;
}
async function Yde(e, t) {
  let n = await pD(e.appConfig);
  for (; n.authToken.requestStatus === 1; )
    await NH(100), n = await pD(e.appConfig);
  const r = n.authToken;
  return r.requestStatus === 0 ? _O(e, t) : r;
}
function pD(e) {
  return Xw(e, (t) => {
    if (!BH(t))
      throw Qd.create(
        "not-registered"
        /* ErrorCode.NOT_REGISTERED */
      );
    const n = t.authToken;
    return efe(n) ? Object.assign(Object.assign({}, t), { authToken: {
      requestStatus: 0
      /* RequestStatus.NOT_STARTED */
    } }) : t;
  });
}
async function Xde(e, t) {
  try {
    const n = await Gde(e, t), r = Object.assign(Object.assign({}, t), { authToken: n });
    return await p_(e.appConfig, r), n;
  } catch (n) {
    if (RH(n) && (n.customData.serverCode === 401 || n.customData.serverCode === 404))
      await FH(e.appConfig);
    else {
      const r = Object.assign(Object.assign({}, t), { authToken: {
        requestStatus: 0
        /* RequestStatus.NOT_STARTED */
      } });
      await p_(e.appConfig, r);
    }
    throw n;
  }
}
function BH(e) {
  return e !== void 0 && e.registrationStatus === 2;
}
function Qde(e) {
  return e.requestStatus === 2 && !Jde(e);
}
function Jde(e) {
  const t = Date.now();
  return t < e.creationTime || e.creationTime + e.expiresIn < t + Cde;
}
function Zde(e) {
  const t = {
    requestStatus: 1,
    requestTime: Date.now()
  };
  return Object.assign(Object.assign({}, e), { authToken: t });
}
function efe(e) {
  return e.requestStatus === 1 && e.requestTime + TH < Date.now();
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
async function tfe(e) {
  const t = e, { installationEntry: n, registrationPromise: r } = await bO(t);
  return r ? r.catch(console.error) : _O(t).catch(console.error), n.fid;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
async function nfe(e, t = !1) {
  const n = e;
  return await rfe(n), (await _O(n, t)).token;
}
async function rfe(e) {
  const { registrationPromise: t } = await bO(e);
  t && await t;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function ife(e) {
  if (!e || !e.options)
    throw X2("App Configuration");
  if (!e.name)
    throw X2("App Name");
  const t = [
    "projectId",
    "apiKey",
    "appId"
  ];
  for (const n of t)
    if (!e.options[n])
      throw X2(n);
  return {
    appName: e.name,
    projectId: e.options.projectId,
    apiKey: e.options.apiKey,
    appId: e.options.appId
  };
}
function X2(e) {
  return Qd.create("missing-app-config-values", {
    valueName: e
  });
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const zH = "installations", ofe = "installations-internal", afe = (e) => {
  const t = e.getProvider("app").getImmediate(), n = ife(t), r = gl(t, "heartbeat");
  return {
    app: t,
    appConfig: n,
    heartbeatServiceProvider: r,
    _delete: () => Promise.resolve()
  };
}, sfe = (e) => {
  const t = e.getProvider("app").getImmediate(), n = gl(t, zH).getImmediate();
  return {
    getId: () => tfe(n),
    getToken: (i) => nfe(n, i)
  };
};
function cfe() {
  Ss(new Fa(
    zH,
    afe,
    "PUBLIC"
    /* ComponentType.PUBLIC */
  )), Ss(new Fa(
    ofe,
    sfe,
    "PRIVATE"
    /* ComponentType.PRIVATE */
  ));
}
cfe();
Jo(CH, vO);
Jo(CH, vO, "esm2017");
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const m_ = "analytics", lfe = "firebase_id", ufe = "origin", dfe = 60 * 1e3, ffe = "https://firebase.googleapis.com/v1alpha/projects/-/apps/{app-id}/webConfig", SO = "https://www.googletagmanager.com/gtag/js";
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const Zo = new Gw("@firebase/analytics");
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const hfe = {
  "already-exists": "A Firebase Analytics instance with the appId {$id}  already exists. Only one Firebase Analytics instance can be created for each appId.",
  "already-initialized": "initializeAnalytics() cannot be called again with different options than those it was initially called with. It can be called again with the same options to return the existing instance, or getAnalytics() can be used to get a reference to the already-initialized instance.",
  "already-initialized-settings": "Firebase Analytics has already been initialized.settings() must be called before initializing any Analytics instanceor it will have no effect.",
  "interop-component-reg-failed": "Firebase Analytics Interop Component failed to instantiate: {$reason}",
  "invalid-analytics-context": "Firebase Analytics is not supported in this environment. Wrap initialization of analytics in analytics.isSupported() to prevent initialization in unsupported environments. Details: {$errorInfo}",
  "indexeddb-unavailable": "IndexedDB unavailable or restricted in this environment. Wrap initialization of analytics in analytics.isSupported() to prevent initialization in unsupported environments. Details: {$errorInfo}",
  "fetch-throttle": "The config fetch request timed out while in an exponential backoff state. Unix timestamp in milliseconds when fetch request throttling ends: {$throttleEndTimeMillis}.",
  "config-fetch-failed": "Dynamic config fetch failed: [{$httpStatus}] {$responseMessage}",
  "no-api-key": 'The "apiKey" field is empty in the local Firebase config. Firebase Analytics requires this field tocontain a valid API key.',
  "no-app-id": 'The "appId" field is empty in the local Firebase config. Firebase Analytics requires this field tocontain a valid app ID.',
  "no-client-id": 'The "client_id" field is empty.',
  "invalid-gtag-resource": "Trusted Types detected an invalid gtag resource: {$gtagURL}."
}, ma = new Sf("analytics", "Analytics", hfe);
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function gfe(e) {
  if (!e.startsWith(SO)) {
    const t = ma.create("invalid-gtag-resource", {
      gtagURL: e
    });
    return Zo.warn(t.message), "";
  }
  return e;
}
function HH(e) {
  return Promise.all(e.map((t) => t.catch((n) => n)));
}
function pfe(e, t) {
  let n;
  return window.trustedTypes && (n = window.trustedTypes.createPolicy(e, t)), n;
}
function mfe(e, t) {
  const n = pfe("firebase-js-sdk-policy", {
    createScriptURL: gfe
  }), r = document.createElement("script"), i = `${SO}?l=${e}&id=${t}`;
  r.src = n ? n == null ? void 0 : n.createScriptURL(i) : i, r.async = !0, document.head.appendChild(r);
}
function vfe(e) {
  let t = [];
  return Array.isArray(window[e]) ? t = window[e] : window[e] = t, t;
}
async function yfe(e, t, n, r, i, o) {
  const a = r[i];
  try {
    if (a)
      await t[a];
    else {
      const c = (await HH(n)).find((l) => l.measurementId === i);
      c && await t[c.appId];
    }
  } catch (s) {
    Zo.error(s);
  }
  e("config", i, o);
}
async function bfe(e, t, n, r, i) {
  try {
    let o = [];
    if (i && i.send_to) {
      let a = i.send_to;
      Array.isArray(a) || (a = [a]);
      const s = await HH(n);
      for (const c of a) {
        const l = s.find((d) => d.measurementId === c), u = l && t[l.appId];
        if (u)
          o.push(u);
        else {
          o = [];
          break;
        }
      }
    }
    o.length === 0 && (o = Object.values(t)), await Promise.all(o), e("event", r, i || {});
  } catch (o) {
    Zo.error(o);
  }
}
function _fe(e, t, n, r) {
  async function i(o, ...a) {
    try {
      if (o === "event") {
        const [s, c] = a;
        await bfe(e, t, n, s, c);
      } else if (o === "config") {
        const [s, c] = a;
        await yfe(e, t, n, r, s, c);
      } else if (o === "consent") {
        const [s, c] = a;
        e("consent", s, c);
      } else if (o === "get") {
        const [s, c, l] = a;
        e("get", s, c, l);
      } else if (o === "set") {
        const [s] = a;
        e("set", s);
      } else
        e(o, ...a);
    } catch (s) {
      Zo.error(s);
    }
  }
  return i;
}
function Sfe(e, t, n, r, i) {
  let o = function(...a) {
    window[r].push(arguments);
  };
  return window[i] && typeof window[i] == "function" && (o = window[i]), window[i] = _fe(o, e, t, n), {
    gtagCore: o,
    wrappedGtag: window[i]
  };
}
function wfe(e) {
  const t = window.document.getElementsByTagName("script");
  for (const n of Object.values(t))
    if (n.src && n.src.includes(SO) && n.src.includes(e))
      return n;
  return null;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const xfe = 30, Efe = 1e3;
class Cfe {
  constructor(t = {}, n = Efe) {
    this.throttleMetadata = t, this.intervalMillis = n;
  }
  getThrottleMetadata(t) {
    return this.throttleMetadata[t];
  }
  setThrottleMetadata(t, n) {
    this.throttleMetadata[t] = n;
  }
  deleteThrottleMetadata(t) {
    delete this.throttleMetadata[t];
  }
}
const UH = new Cfe();
function Tfe(e) {
  return new Headers({
    Accept: "application/json",
    "x-goog-api-key": e
  });
}
async function Ife(e) {
  var t;
  const { appId: n, apiKey: r } = e, i = {
    method: "GET",
    headers: Tfe(r)
  }, o = ffe.replace("{app-id}", n), a = await fetch(o, i);
  if (a.status !== 200 && a.status !== 304) {
    let s = "";
    try {
      const c = await a.json();
      !((t = c.error) === null || t === void 0) && t.message && (s = c.error.message);
    } catch {
    }
    throw ma.create("config-fetch-failed", {
      httpStatus: a.status,
      responseMessage: s
    });
  }
  return a.json();
}
async function Afe(e, t = UH, n) {
  const { appId: r, apiKey: i, measurementId: o } = e.options;
  if (!r)
    throw ma.create(
      "no-app-id"
      /* AnalyticsError.NO_APP_ID */
    );
  if (!i) {
    if (o)
      return {
        measurementId: o,
        appId: r
      };
    throw ma.create(
      "no-api-key"
      /* AnalyticsError.NO_API_KEY */
    );
  }
  const a = t.getThrottleMetadata(r) || {
    backoffCount: 0,
    throttleEndTimeMillis: Date.now()
  }, s = new Ofe();
  return setTimeout(async () => {
    s.abort();
  }, n !== void 0 ? n : dfe), WH({ appId: r, apiKey: i, measurementId: o }, a, s, t);
}
async function WH(e, { throttleEndTimeMillis: t, backoffCount: n }, r, i = UH) {
  var o;
  const { appId: a, measurementId: s } = e;
  try {
    await Rfe(r, t);
  } catch (c) {
    if (s)
      return Zo.warn(`Timed out fetching this Firebase app's measurement ID from the server. Falling back to the measurement ID ${s} provided in the "measurementId" field in the local Firebase config. [${c == null ? void 0 : c.message}]`), { appId: a, measurementId: s };
    throw c;
  }
  try {
    const c = await Ife(e);
    return i.deleteThrottleMetadata(a), c;
  } catch (c) {
    const l = c;
    if (!$fe(l)) {
      if (i.deleteThrottleMetadata(a), s)
        return Zo.warn(`Failed to fetch this Firebase app's measurement ID from the server. Falling back to the measurement ID ${s} provided in the "measurementId" field in the local Firebase config. [${l == null ? void 0 : l.message}]`), { appId: a, measurementId: s };
      throw c;
    }
    const u = Number((o = l == null ? void 0 : l.customData) === null || o === void 0 ? void 0 : o.httpStatus) === 503 ? oD(n, i.intervalMillis, xfe) : oD(n, i.intervalMillis), d = {
      throttleEndTimeMillis: Date.now() + u,
      backoffCount: n + 1
    };
    return i.setThrottleMetadata(a, d), Zo.debug(`Calling attemptFetch again in ${u} millis`), WH(e, d, r, i);
  }
}
function Rfe(e, t) {
  return new Promise((n, r) => {
    const i = Math.max(t - Date.now(), 0), o = setTimeout(n, i);
    e.addEventListener(() => {
      clearTimeout(o), r(ma.create("fetch-throttle", {
        throttleEndTimeMillis: t
      }));
    });
  });
}
function $fe(e) {
  if (!(e instanceof Ua) || !e.customData)
    return !1;
  const t = Number(e.customData.httpStatus);
  return t === 429 || t === 500 || t === 503 || t === 504;
}
class Ofe {
  constructor() {
    this.listeners = [];
  }
  addEventListener(t) {
    this.listeners.push(t);
  }
  abort() {
    this.listeners.forEach((t) => t());
  }
}
async function Pfe(e, t, n, r, i) {
  if (i && i.global) {
    e("event", n, r);
    return;
  } else {
    const o = await t, a = Object.assign(Object.assign({}, r), { send_to: o });
    e("event", n, a);
  }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
async function Mfe() {
  if (vH())
    try {
      await yH();
    } catch (e) {
      return Zo.warn(ma.create("indexeddb-unavailable", {
        errorInfo: e == null ? void 0 : e.toString()
      }).message), !1;
    }
  else
    return Zo.warn(ma.create("indexeddb-unavailable", {
      errorInfo: "IndexedDB is not available in this environment."
    }).message), !1;
  return !0;
}
async function kfe(e, t, n, r, i, o, a) {
  var s;
  const c = Afe(e);
  c.then((h) => {
    n[h.measurementId] = h.appId, e.options.measurementId && h.measurementId !== e.options.measurementId && Zo.warn(`The measurement ID in the local Firebase config (${e.options.measurementId}) does not match the measurement ID fetched from the server (${h.measurementId}). To ensure analytics events are always sent to the correct Analytics property, update the measurement ID field in the local config or remove it from the local config.`);
  }).catch((h) => Zo.error(h)), t.push(c);
  const l = Mfe().then((h) => {
    if (h)
      return r.getId();
  }), [u, d] = await Promise.all([
    c,
    l
  ]);
  wfe(o) || mfe(o, u.measurementId), i("js", /* @__PURE__ */ new Date());
  const f = (s = a == null ? void 0 : a.config) !== null && s !== void 0 ? s : {};
  return f[ufe] = "firebase", f.update = !0, d != null && (f[lfe] = d), i("config", u.measurementId, f), u.measurementId;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class Nfe {
  constructor(t) {
    this.app = t;
  }
  _delete() {
    return delete o0[this.app.options.appId], Promise.resolve();
  }
}
let o0 = {}, mD = [];
const vD = {};
let Q2 = "dataLayer", Dfe = "gtag", yD, qH, bD = !1;
function Lfe() {
  const e = [];
  if (mH() && e.push("This is a browser extension environment."), oue() || e.push("Cookies are not available."), e.length > 0) {
    const t = e.map((r, i) => `(${i + 1}) ${r}`).join(" "), n = ma.create("invalid-analytics-context", {
      errorInfo: t
    });
    Zo.warn(n.message);
  }
}
function jfe(e, t, n) {
  Lfe();
  const r = e.options.appId;
  if (!r)
    throw ma.create(
      "no-app-id"
      /* AnalyticsError.NO_APP_ID */
    );
  if (!e.options.apiKey)
    if (e.options.measurementId)
      Zo.warn(`The "apiKey" field is empty in the local Firebase config. This is needed to fetch the latest measurement ID for this Firebase app. Falling back to the measurement ID ${e.options.measurementId} provided in the "measurementId" field in the local Firebase config.`);
    else
      throw ma.create(
        "no-api-key"
        /* AnalyticsError.NO_API_KEY */
      );
  if (o0[r] != null)
    throw ma.create("already-exists", {
      id: r
    });
  if (!bD) {
    vfe(Q2);
    const { wrappedGtag: o, gtagCore: a } = Sfe(o0, mD, vD, Q2, Dfe);
    qH = o, yD = a, bD = !0;
  }
  return o0[r] = kfe(e, mD, vD, t, yD, Q2, n), new Nfe(e);
}
function Ffe(e = Kw()) {
  e = $r(e);
  const t = gl(e, m_);
  return t.isInitialized() ? t.getImmediate() : Vfe(e);
}
function Vfe(e, t = {}) {
  const n = gl(e, m_);
  if (n.isInitialized()) {
    const i = n.getImmediate();
    if (tl(t, n.getOptions()))
      return i;
    throw ma.create(
      "already-initialized"
      /* AnalyticsError.ALREADY_INITIALIZED */
    );
  }
  return n.initialize({ options: t });
}
function GH(e, t, n, r) {
  e = $r(e), Pfe(qH, o0[e.app.options.appId], t, n, r).catch((i) => Zo.error(i));
}
const _D = "@firebase/analytics", SD = "0.10.17";
function Bfe() {
  Ss(new Fa(
    m_,
    (t, { options: n }) => {
      const r = t.getProvider("app").getImmediate(), i = t.getProvider("installations-internal").getImmediate();
      return jfe(r, i, n);
    },
    "PUBLIC"
    /* ComponentType.PUBLIC */
  )), Ss(new Fa(
    "analytics-internal",
    e,
    "PRIVATE"
    /* ComponentType.PRIVATE */
  )), Jo(_D, SD), Jo(_D, SD, "esm2017");
  function e(t) {
    try {
      const n = t.getProvider(m_).getImmediate();
      return {
        logEvent: (r, i, o) => GH(n, r, i, o)
      };
    } catch (n) {
      throw ma.create("interop-component-reg-failed", {
        reason: n
      });
    }
  }
}
Bfe();
class W_t extends Mse {
  constructor(n, r) {
    super();
    ye(this, "analytics");
    ye(this, "log");
    this.analytics = Ffe(n), this.log = r;
  }
  async initialise() {
  }
  dispose() {
  }
  logEvent(n, r) {
    this.log.info("FirebaseAnalyticsService", "logEvent", n, r), GH(this.analytics, n, r);
  }
}
function KH() {
  return {
    "dependent-sdk-initialized-before-auth": "Another Firebase SDK was initialized and is trying to use Auth before Auth is initialized. Please be sure to call `initializeAuth` or `getAuth` before starting any other Firebase SDK."
  };
}
const zfe = KH, YH = new Sf("auth", "Firebase", KH());
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const v_ = new Gw("@firebase/auth");
function Hfe(e, ...t) {
  v_.logLevel <= bn.WARN && v_.warn(`Auth (${ap}): ${e}`, ...t);
}
function T1(e, ...t) {
  v_.logLevel <= bn.ERROR && v_.error(`Auth (${ap}): ${e}`, ...t);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function Va(e, ...t) {
  throw xO(e, ...t);
}
function gs(e, ...t) {
  return xO(e, ...t);
}
function wO(e, t, n) {
  const r = Object.assign(Object.assign({}, zfe()), { [t]: n });
  return new Sf("auth", "Firebase", r).create(t, {
    appName: e.name
  });
}
function Zs(e) {
  return wO(e, "operation-not-supported-in-this-environment", "Operations that alter the current user are not supported in conjunction with FirebaseServerApp");
}
function XH(e, t, n) {
  const r = n;
  if (!(t instanceof r))
    throw r.name !== t.constructor.name && Va(
      e,
      "argument-error"
      /* AuthErrorCode.ARGUMENT_ERROR */
    ), wO(e, "argument-error", `Type of ${t.constructor.name} does not match expected instance.Did you pass a reference from a different Auth SDK?`);
}
function xO(e, ...t) {
  if (typeof e != "string") {
    const n = t[0], r = [...t.slice(1)];
    return r[0] && (r[0].appName = e.name), e._errorFactory.create(n, ...r);
  }
  return YH.create(e, ...t);
}
function Ft(e, t, ...n) {
  if (!e)
    throw xO(t, ...n);
}
function zc(e) {
  const t = "INTERNAL ASSERTION FAILED: " + e;
  throw T1(t), new Error(t);
}
function rl(e, t) {
  e || zc(t);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function $I() {
  var e;
  return typeof self < "u" && ((e = self.location) === null || e === void 0 ? void 0 : e.href) || "";
}
function Ufe() {
  return wD() === "http:" || wD() === "https:";
}
function wD() {
  var e;
  return typeof self < "u" && ((e = self.location) === null || e === void 0 ? void 0 : e.protocol) || null;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function Wfe() {
  return typeof navigator < "u" && navigator && "onLine" in navigator && typeof navigator.onLine == "boolean" && // Apply only for traditional web apps and Chrome extensions.
  // This is especially true for Cordova apps which have unreliable
  // navigator.onLine behavior unless cordova-plugin-network-information is
  // installed which overwrites the native navigator.onLine value and
  // defines navigator.connection.
  (Ufe() || mH() || "connection" in navigator) ? navigator.onLine : !0;
}
function qfe() {
  if (typeof navigator > "u")
    return null;
  const e = navigator;
  return (
    // Most reliable, but only supported in Chrome/Firefox.
    e.languages && e.languages[0] || // Supported in most browsers, but returns the language of the browser
    // UI, not the language set in browser settings.
    e.language || // Couldn't determine language.
    null
  );
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class jv {
  constructor(t, n) {
    this.shortDelay = t, this.longDelay = n, rl(n > t, "Short delay should be less than long delay!"), this.isMobile = Zle() || nue();
  }
  get() {
    return Wfe() ? this.isMobile ? this.longDelay : this.shortDelay : Math.min(5e3, this.shortDelay);
  }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function EO(e, t) {
  rl(e.emulator, "Emulator should always be set here");
  const { url: n } = e.emulator;
  return t ? `${n}${t.startsWith("/") ? t.slice(1) : t}` : n;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class QH {
  static initialize(t, n, r) {
    this.fetchImpl = t, n && (this.headersImpl = n), r && (this.responseImpl = r);
  }
  static fetch() {
    if (this.fetchImpl)
      return this.fetchImpl;
    if (typeof self < "u" && "fetch" in self)
      return self.fetch;
    if (typeof globalThis < "u" && globalThis.fetch)
      return globalThis.fetch;
    if (typeof fetch < "u")
      return fetch;
    zc("Could not find fetch implementation, make sure you call FetchProvider.initialize() with an appropriate polyfill");
  }
  static headers() {
    if (this.headersImpl)
      return this.headersImpl;
    if (typeof self < "u" && "Headers" in self)
      return self.Headers;
    if (typeof globalThis < "u" && globalThis.Headers)
      return globalThis.Headers;
    if (typeof Headers < "u")
      return Headers;
    zc("Could not find Headers implementation, make sure you call FetchProvider.initialize() with an appropriate polyfill");
  }
  static response() {
    if (this.responseImpl)
      return this.responseImpl;
    if (typeof self < "u" && "Response" in self)
      return self.Response;
    if (typeof globalThis < "u" && globalThis.Response)
      return globalThis.Response;
    if (typeof Response < "u")
      return Response;
    zc("Could not find Response implementation, make sure you call FetchProvider.initialize() with an appropriate polyfill");
  }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const Gfe = {
  // Custom token errors.
  CREDENTIAL_MISMATCH: "custom-token-mismatch",
  // This can only happen if the SDK sends a bad request.
  MISSING_CUSTOM_TOKEN: "internal-error",
  // Create Auth URI errors.
  INVALID_IDENTIFIER: "invalid-email",
  // This can only happen if the SDK sends a bad request.
  MISSING_CONTINUE_URI: "internal-error",
  // Sign in with email and password errors (some apply to sign up too).
  INVALID_PASSWORD: "wrong-password",
  // This can only happen if the SDK sends a bad request.
  MISSING_PASSWORD: "missing-password",
  // Thrown if Email Enumeration Protection is enabled in the project and the email or password is
  // invalid.
  INVALID_LOGIN_CREDENTIALS: "invalid-credential",
  // Sign up with email and password errors.
  EMAIL_EXISTS: "email-already-in-use",
  PASSWORD_LOGIN_DISABLED: "operation-not-allowed",
  // Verify assertion for sign in with credential errors:
  INVALID_IDP_RESPONSE: "invalid-credential",
  INVALID_PENDING_TOKEN: "invalid-credential",
  FEDERATED_USER_ID_ALREADY_LINKED: "credential-already-in-use",
  // This can only happen if the SDK sends a bad request.
  MISSING_REQ_TYPE: "internal-error",
  // Send Password reset email errors:
  EMAIL_NOT_FOUND: "user-not-found",
  RESET_PASSWORD_EXCEED_LIMIT: "too-many-requests",
  EXPIRED_OOB_CODE: "expired-action-code",
  INVALID_OOB_CODE: "invalid-action-code",
  // This can only happen if the SDK sends a bad request.
  MISSING_OOB_CODE: "internal-error",
  // Operations that require ID token in request:
  CREDENTIAL_TOO_OLD_LOGIN_AGAIN: "requires-recent-login",
  INVALID_ID_TOKEN: "invalid-user-token",
  TOKEN_EXPIRED: "user-token-expired",
  USER_NOT_FOUND: "user-token-expired",
  // Other errors.
  TOO_MANY_ATTEMPTS_TRY_LATER: "too-many-requests",
  PASSWORD_DOES_NOT_MEET_REQUIREMENTS: "password-does-not-meet-requirements",
  // Phone Auth related errors.
  INVALID_CODE: "invalid-verification-code",
  INVALID_SESSION_INFO: "invalid-verification-id",
  INVALID_TEMPORARY_PROOF: "invalid-credential",
  MISSING_SESSION_INFO: "missing-verification-id",
  SESSION_EXPIRED: "code-expired",
  // Other action code errors when additional settings passed.
  // MISSING_CONTINUE_URI is getting mapped to INTERNAL_ERROR above.
  // This is OK as this error will be caught by client side validation.
  MISSING_ANDROID_PACKAGE_NAME: "missing-android-pkg-name",
  UNAUTHORIZED_DOMAIN: "unauthorized-continue-uri",
  // getProjectConfig errors when clientId is passed.
  INVALID_OAUTH_CLIENT_ID: "invalid-oauth-client-id",
  // User actions (sign-up or deletion) disabled errors.
  ADMIN_ONLY_OPERATION: "admin-restricted-operation",
  // Multi factor related errors.
  INVALID_MFA_PENDING_CREDENTIAL: "invalid-multi-factor-session",
  MFA_ENROLLMENT_NOT_FOUND: "multi-factor-info-not-found",
  MISSING_MFA_ENROLLMENT_ID: "missing-multi-factor-info",
  MISSING_MFA_PENDING_CREDENTIAL: "missing-multi-factor-session",
  SECOND_FACTOR_EXISTS: "second-factor-already-in-use",
  SECOND_FACTOR_LIMIT_EXCEEDED: "maximum-second-factor-count-exceeded",
  // Blocking functions related errors.
  BLOCKING_FUNCTION_ERROR_RESPONSE: "internal-error",
  // Recaptcha related errors.
  RECAPTCHA_NOT_ENABLED: "recaptcha-not-enabled",
  MISSING_RECAPTCHA_TOKEN: "missing-recaptcha-token",
  INVALID_RECAPTCHA_TOKEN: "invalid-recaptcha-token",
  INVALID_RECAPTCHA_ACTION: "invalid-recaptcha-action",
  MISSING_CLIENT_TYPE: "missing-client-type",
  MISSING_RECAPTCHA_VERSION: "missing-recaptcha-version",
  INVALID_RECAPTCHA_VERSION: "invalid-recaptcha-version",
  INVALID_REQ_TYPE: "invalid-req-type"
  /* AuthErrorCode.INVALID_REQ_TYPE */
};
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const Kfe = [
  "/v1/accounts:signInWithCustomToken",
  "/v1/accounts:signInWithEmailLink",
  "/v1/accounts:signInWithIdp",
  "/v1/accounts:signInWithPassword",
  "/v1/accounts:signInWithPhoneNumber",
  "/v1/token"
  /* Endpoint.TOKEN */
], Yfe = new jv(3e4, 6e4);
function Nu(e, t) {
  return e.tenantId && !t.tenantId ? Object.assign(Object.assign({}, t), { tenantId: e.tenantId }) : t;
}
async function Du(e, t, n, r, i = {}) {
  return JH(e, i, async () => {
    let o = {}, a = {};
    r && (t === "GET" ? a = r : o = {
      body: JSON.stringify(r)
    });
    const s = Lv(Object.assign({ key: e.config.apiKey }, a)).slice(1), c = await e._getAdditionalHeaders();
    c[
      "Content-Type"
      /* HttpHeader.CONTENT_TYPE */
    ] = "application/json", e.languageCode && (c[
      "X-Firebase-Locale"
      /* HttpHeader.X_FIREBASE_LOCALE */
    ] = e.languageCode);
    const l = Object.assign({
      method: t,
      headers: c
    }, o);
    return tue() || (l.referrerPolicy = "no-referrer"), e.emulatorConfig && ku(e.emulatorConfig.host) && (l.credentials = "include"), QH.fetch()(await ZH(e, e.config.apiHost, n, s), l);
  });
}
async function JH(e, t, n) {
  e._canInitEmulator = !1;
  const r = Object.assign(Object.assign({}, Gfe), t);
  try {
    const i = new Qfe(e), o = await Promise.race([
      n(),
      i.promise
    ]);
    i.clearNetworkTimeout();
    const a = await o.json();
    if ("needConfirmation" in a)
      throw gb(e, "account-exists-with-different-credential", a);
    if (o.ok && !("errorMessage" in a))
      return a;
    {
      const s = o.ok ? a.errorMessage : a.error.message, [c, l] = s.split(" : ");
      if (c === "FEDERATED_USER_ID_ALREADY_LINKED")
        throw gb(e, "credential-already-in-use", a);
      if (c === "EMAIL_EXISTS")
        throw gb(e, "email-already-in-use", a);
      if (c === "USER_DISABLED")
        throw gb(e, "user-disabled", a);
      const u = r[c] || c.toLowerCase().replace(/[_\s]+/g, "-");
      if (l)
        throw wO(e, u, l);
      Va(e, u);
    }
  } catch (i) {
    if (i instanceof Ua)
      throw i;
    Va(e, "network-request-failed", { message: String(i) });
  }
}
async function Fv(e, t, n, r, i = {}) {
  const o = await Du(e, t, n, r, i);
  return "mfaPendingCredential" in o && Va(e, "multi-factor-auth-required", {
    _serverResponse: o
  }), o;
}
async function ZH(e, t, n, r) {
  const i = `${t}${n}?${r}`, o = e, a = o.config.emulator ? EO(e.config, i) : `${e.config.apiScheme}://${i}`;
  return Kfe.includes(n) && (await o._persistenceManagerAvailable, o._getPersistenceType() === "COOKIE") ? o._getPersistence()._getFinalTarget(a).toString() : a;
}
function Xfe(e) {
  switch (e) {
    case "ENFORCE":
      return "ENFORCE";
    case "AUDIT":
      return "AUDIT";
    case "OFF":
      return "OFF";
    default:
      return "ENFORCEMENT_STATE_UNSPECIFIED";
  }
}
class Qfe {
  clearNetworkTimeout() {
    clearTimeout(this.timer);
  }
  constructor(t) {
    this.auth = t, this.timer = null, this.promise = new Promise((n, r) => {
      this.timer = setTimeout(() => r(gs(
        this.auth,
        "network-request-failed"
        /* AuthErrorCode.NETWORK_REQUEST_FAILED */
      )), Yfe.get());
    });
  }
}
function gb(e, t, n) {
  const r = {
    appName: e.name
  };
  n.email && (r.email = n.email), n.phoneNumber && (r.phoneNumber = n.phoneNumber);
  const i = gs(e, t, r);
  return i.customData._tokenResponse = n, i;
}
function xD(e) {
  return e !== void 0 && e.enterprise !== void 0;
}
class Jfe {
  constructor(t) {
    if (this.siteKey = "", this.recaptchaEnforcementState = [], t.recaptchaKey === void 0)
      throw new Error("recaptchaKey undefined");
    this.siteKey = t.recaptchaKey.split("/")[3], this.recaptchaEnforcementState = t.recaptchaEnforcementState;
  }
  /**
   * Returns the reCAPTCHA Enterprise enforcement state for the given provider.
   *
   * @param providerStr - The provider whose enforcement state is to be returned.
   * @returns The reCAPTCHA Enterprise enforcement state for the given provider.
   */
  getProviderEnforcementState(t) {
    if (!this.recaptchaEnforcementState || this.recaptchaEnforcementState.length === 0)
      return null;
    for (const n of this.recaptchaEnforcementState)
      if (n.provider && n.provider === t)
        return Xfe(n.enforcementState);
    return null;
  }
  /**
   * Returns true if the reCAPTCHA Enterprise enforcement state for the provider is set to ENFORCE or AUDIT.
   *
   * @param providerStr - The provider whose enablement state is to be returned.
   * @returns Whether or not reCAPTCHA Enterprise protection is enabled for the given provider.
   */
  isProviderEnabled(t) {
    return this.getProviderEnforcementState(t) === "ENFORCE" || this.getProviderEnforcementState(t) === "AUDIT";
  }
  /**
   * Returns true if reCAPTCHA Enterprise protection is enabled in at least one provider, otherwise
   * returns false.
   *
   * @returns Whether or not reCAPTCHA Enterprise protection is enabled for at least one provider.
   */
  isAnyProviderEnabled() {
    return this.isProviderEnabled(
      "EMAIL_PASSWORD_PROVIDER"
      /* RecaptchaAuthProvider.EMAIL_PASSWORD_PROVIDER */
    ) || this.isProviderEnabled(
      "PHONE_PROVIDER"
      /* RecaptchaAuthProvider.PHONE_PROVIDER */
    );
  }
}
async function Zfe(e, t) {
  return Du(e, "GET", "/v2/recaptchaConfig", Nu(e, t));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
async function ehe(e, t) {
  return Du(e, "POST", "/v1/accounts:delete", t);
}
async function y_(e, t) {
  return Du(e, "POST", "/v1/accounts:lookup", t);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function a0(e) {
  if (e)
    try {
      const t = new Date(Number(e));
      if (!isNaN(t.getTime()))
        return t.toUTCString();
    } catch {
    }
}
async function the(e, t = !1) {
  const n = $r(e), r = await n.getIdToken(t), i = CO(r);
  Ft(
    i && i.exp && i.auth_time && i.iat,
    n.auth,
    "internal-error"
    /* AuthErrorCode.INTERNAL_ERROR */
  );
  const o = typeof i.firebase == "object" ? i.firebase : void 0, a = o == null ? void 0 : o.sign_in_provider;
  return {
    claims: i,
    token: r,
    authTime: a0(J2(i.auth_time)),
    issuedAtTime: a0(J2(i.iat)),
    expirationTime: a0(J2(i.exp)),
    signInProvider: a || null,
    signInSecondFactor: (o == null ? void 0 : o.sign_in_second_factor) || null
  };
}
function J2(e) {
  return Number(e) * 1e3;
}
function CO(e) {
  const [t, n, r] = e.split(".");
  if (t === void 0 || n === void 0 || r === void 0)
    return T1("JWT malformed, contained fewer than 3 sections"), null;
  try {
    const i = dH(n);
    return i ? JSON.parse(i) : (T1("Failed to decode base64 JWT payload"), null);
  } catch (i) {
    return T1("Caught error parsing JWT payload as JSON", i == null ? void 0 : i.toString()), null;
  }
}
function ED(e) {
  const t = CO(e);
  return Ft(
    t,
    "internal-error"
    /* AuthErrorCode.INTERNAL_ERROR */
  ), Ft(
    typeof t.exp < "u",
    "internal-error"
    /* AuthErrorCode.INTERNAL_ERROR */
  ), Ft(
    typeof t.iat < "u",
    "internal-error"
    /* AuthErrorCode.INTERNAL_ERROR */
  ), Number(t.exp) - Number(t.iat);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
async function D0(e, t, n = !1) {
  if (n)
    return t;
  try {
    return await t;
  } catch (r) {
    throw r instanceof Ua && nhe(r) && e.auth.currentUser === e && await e.auth.signOut(), r;
  }
}
function nhe({ code: e }) {
  return e === "auth/user-disabled" || e === "auth/user-token-expired";
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class rhe {
  constructor(t) {
    this.user = t, this.isRunning = !1, this.timerId = null, this.errorBackoff = 3e4;
  }
  _start() {
    this.isRunning || (this.isRunning = !0, this.schedule());
  }
  _stop() {
    this.isRunning && (this.isRunning = !1, this.timerId !== null && clearTimeout(this.timerId));
  }
  getInterval(t) {
    var n;
    if (t) {
      const r = this.errorBackoff;
      return this.errorBackoff = Math.min(
        this.errorBackoff * 2,
        96e4
        /* Duration.RETRY_BACKOFF_MAX */
      ), r;
    } else {
      this.errorBackoff = 3e4;
      const i = ((n = this.user.stsTokenManager.expirationTime) !== null && n !== void 0 ? n : 0) - Date.now() - 3e5;
      return Math.max(0, i);
    }
  }
  schedule(t = !1) {
    if (!this.isRunning)
      return;
    const n = this.getInterval(t);
    this.timerId = setTimeout(async () => {
      await this.iteration();
    }, n);
  }
  async iteration() {
    try {
      await this.user.getIdToken(!0);
    } catch (t) {
      (t == null ? void 0 : t.code) === "auth/network-request-failed" && this.schedule(
        /* wasError */
        !0
      );
      return;
    }
    this.schedule();
  }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class OI {
  constructor(t, n) {
    this.createdAt = t, this.lastLoginAt = n, this._initializeTime();
  }
  _initializeTime() {
    this.lastSignInTime = a0(this.lastLoginAt), this.creationTime = a0(this.createdAt);
  }
  _copy(t) {
    this.createdAt = t.createdAt, this.lastLoginAt = t.lastLoginAt, this._initializeTime();
  }
  toJSON() {
    return {
      createdAt: this.createdAt,
      lastLoginAt: this.lastLoginAt
    };
  }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
async function b_(e) {
  var t;
  const n = e.auth, r = await e.getIdToken(), i = await D0(e, y_(n, { idToken: r }));
  Ft(
    i == null ? void 0 : i.users.length,
    n,
    "internal-error"
    /* AuthErrorCode.INTERNAL_ERROR */
  );
  const o = i.users[0];
  e._notifyReloadListener(o);
  const a = !((t = o.providerUserInfo) === null || t === void 0) && t.length ? eU(o.providerUserInfo) : [], s = ohe(e.providerData, a), c = e.isAnonymous, l = !(e.email && o.passwordHash) && !(s != null && s.length), u = c ? l : !1, d = {
    uid: o.localId,
    displayName: o.displayName || null,
    photoURL: o.photoUrl || null,
    email: o.email || null,
    emailVerified: o.emailVerified || !1,
    phoneNumber: o.phoneNumber || null,
    tenantId: o.tenantId || null,
    providerData: s,
    metadata: new OI(o.createdAt, o.lastLoginAt),
    isAnonymous: u
  };
  Object.assign(e, d);
}
async function ihe(e) {
  const t = $r(e);
  await b_(t), await t.auth._persistUserIfCurrent(t), t.auth._notifyListenersIfCurrent(t);
}
function ohe(e, t) {
  return [...e.filter((r) => !t.some((i) => i.providerId === r.providerId)), ...t];
}
function eU(e) {
  return e.map((t) => {
    var { providerId: n } = t, r = Z$(t, ["providerId"]);
    return {
      providerId: n,
      uid: r.rawId || "",
      displayName: r.displayName || null,
      email: r.email || null,
      phoneNumber: r.phoneNumber || null,
      photoURL: r.photoUrl || null
    };
  });
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
async function ahe(e, t) {
  const n = await JH(e, {}, async () => {
    const r = Lv({
      grant_type: "refresh_token",
      refresh_token: t
    }).slice(1), { tokenApiHost: i, apiKey: o } = e.config, a = await ZH(e, i, "/v1/token", `key=${o}`), s = await e._getAdditionalHeaders();
    s[
      "Content-Type"
      /* HttpHeader.CONTENT_TYPE */
    ] = "application/x-www-form-urlencoded";
    const c = {
      method: "POST",
      headers: s,
      body: r
    };
    return e.emulatorConfig && ku(e.emulatorConfig.host) && (c.credentials = "include"), QH.fetch()(a, c);
  });
  return {
    accessToken: n.access_token,
    expiresIn: n.expires_in,
    refreshToken: n.refresh_token
  };
}
async function she(e, t) {
  return Du(e, "POST", "/v2/accounts:revokeToken", Nu(e, t));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class zh {
  constructor() {
    this.refreshToken = null, this.accessToken = null, this.expirationTime = null;
  }
  get isExpired() {
    return !this.expirationTime || Date.now() > this.expirationTime - 3e4;
  }
  updateFromServerResponse(t) {
    Ft(
      t.idToken,
      "internal-error"
      /* AuthErrorCode.INTERNAL_ERROR */
    ), Ft(
      typeof t.idToken < "u",
      "internal-error"
      /* AuthErrorCode.INTERNAL_ERROR */
    ), Ft(
      typeof t.refreshToken < "u",
      "internal-error"
      /* AuthErrorCode.INTERNAL_ERROR */
    );
    const n = "expiresIn" in t && typeof t.expiresIn < "u" ? Number(t.expiresIn) : ED(t.idToken);
    this.updateTokensAndExpiration(t.idToken, t.refreshToken, n);
  }
  updateFromIdToken(t) {
    Ft(
      t.length !== 0,
      "internal-error"
      /* AuthErrorCode.INTERNAL_ERROR */
    );
    const n = ED(t);
    this.updateTokensAndExpiration(t, null, n);
  }
  async getToken(t, n = !1) {
    return !n && this.accessToken && !this.isExpired ? this.accessToken : (Ft(
      this.refreshToken,
      t,
      "user-token-expired"
      /* AuthErrorCode.TOKEN_EXPIRED */
    ), this.refreshToken ? (await this.refresh(t, this.refreshToken), this.accessToken) : null);
  }
  clearRefreshToken() {
    this.refreshToken = null;
  }
  async refresh(t, n) {
    const { accessToken: r, refreshToken: i, expiresIn: o } = await ahe(t, n);
    this.updateTokensAndExpiration(r, i, Number(o));
  }
  updateTokensAndExpiration(t, n, r) {
    this.refreshToken = n || null, this.accessToken = t || null, this.expirationTime = Date.now() + r * 1e3;
  }
  static fromJSON(t, n) {
    const { refreshToken: r, accessToken: i, expirationTime: o } = n, a = new zh();
    return r && (Ft(typeof r == "string", "internal-error", {
      appName: t
    }), a.refreshToken = r), i && (Ft(typeof i == "string", "internal-error", {
      appName: t
    }), a.accessToken = i), o && (Ft(typeof o == "number", "internal-error", {
      appName: t
    }), a.expirationTime = o), a;
  }
  toJSON() {
    return {
      refreshToken: this.refreshToken,
      accessToken: this.accessToken,
      expirationTime: this.expirationTime
    };
  }
  _assign(t) {
    this.accessToken = t.accessToken, this.refreshToken = t.refreshToken, this.expirationTime = t.expirationTime;
  }
  _clone() {
    return Object.assign(new zh(), this.toJSON());
  }
  _performRefresh() {
    return zc("not implemented");
  }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function Cl(e, t) {
  Ft(typeof e == "string" || typeof e > "u", "internal-error", { appName: t });
}
class ls {
  constructor(t) {
    var { uid: n, auth: r, stsTokenManager: i } = t, o = Z$(t, ["uid", "auth", "stsTokenManager"]);
    this.providerId = "firebase", this.proactiveRefresh = new rhe(this), this.reloadUserInfo = null, this.reloadListener = null, this.uid = n, this.auth = r, this.stsTokenManager = i, this.accessToken = i.accessToken, this.displayName = o.displayName || null, this.email = o.email || null, this.emailVerified = o.emailVerified || !1, this.phoneNumber = o.phoneNumber || null, this.photoURL = o.photoURL || null, this.isAnonymous = o.isAnonymous || !1, this.tenantId = o.tenantId || null, this.providerData = o.providerData ? [...o.providerData] : [], this.metadata = new OI(o.createdAt || void 0, o.lastLoginAt || void 0);
  }
  async getIdToken(t) {
    const n = await D0(this, this.stsTokenManager.getToken(this.auth, t));
    return Ft(
      n,
      this.auth,
      "internal-error"
      /* AuthErrorCode.INTERNAL_ERROR */
    ), this.accessToken !== n && (this.accessToken = n, await this.auth._persistUserIfCurrent(this), this.auth._notifyListenersIfCurrent(this)), n;
  }
  getIdTokenResult(t) {
    return the(this, t);
  }
  reload() {
    return ihe(this);
  }
  _assign(t) {
    this !== t && (Ft(
      this.uid === t.uid,
      this.auth,
      "internal-error"
      /* AuthErrorCode.INTERNAL_ERROR */
    ), this.displayName = t.displayName, this.photoURL = t.photoURL, this.email = t.email, this.emailVerified = t.emailVerified, this.phoneNumber = t.phoneNumber, this.isAnonymous = t.isAnonymous, this.tenantId = t.tenantId, this.providerData = t.providerData.map((n) => Object.assign({}, n)), this.metadata._copy(t.metadata), this.stsTokenManager._assign(t.stsTokenManager));
  }
  _clone(t) {
    const n = new ls(Object.assign(Object.assign({}, this), { auth: t, stsTokenManager: this.stsTokenManager._clone() }));
    return n.metadata._copy(this.metadata), n;
  }
  _onReload(t) {
    Ft(
      !this.reloadListener,
      this.auth,
      "internal-error"
      /* AuthErrorCode.INTERNAL_ERROR */
    ), this.reloadListener = t, this.reloadUserInfo && (this._notifyReloadListener(this.reloadUserInfo), this.reloadUserInfo = null);
  }
  _notifyReloadListener(t) {
    this.reloadListener ? this.reloadListener(t) : this.reloadUserInfo = t;
  }
  _startProactiveRefresh() {
    this.proactiveRefresh._start();
  }
  _stopProactiveRefresh() {
    this.proactiveRefresh._stop();
  }
  async _updateTokensIfNecessary(t, n = !1) {
    let r = !1;
    t.idToken && t.idToken !== this.stsTokenManager.accessToken && (this.stsTokenManager.updateFromServerResponse(t), r = !0), n && await b_(this), await this.auth._persistUserIfCurrent(this), r && this.auth._notifyListenersIfCurrent(this);
  }
  async delete() {
    if (Eo(this.auth.app))
      return Promise.reject(Zs(this.auth));
    const t = await this.getIdToken();
    return await D0(this, ehe(this.auth, { idToken: t })), this.stsTokenManager.clearRefreshToken(), this.auth.signOut();
  }
  toJSON() {
    return Object.assign(Object.assign({
      uid: this.uid,
      email: this.email || void 0,
      emailVerified: this.emailVerified,
      displayName: this.displayName || void 0,
      isAnonymous: this.isAnonymous,
      photoURL: this.photoURL || void 0,
      phoneNumber: this.phoneNumber || void 0,
      tenantId: this.tenantId || void 0,
      providerData: this.providerData.map((t) => Object.assign({}, t)),
      stsTokenManager: this.stsTokenManager.toJSON(),
      // Redirect event ID must be maintained in case there is a pending
      // redirect event.
      _redirectEventId: this._redirectEventId
    }, this.metadata.toJSON()), {
      // Required for compatibility with the legacy SDK (go/firebase-auth-sdk-persistence-parsing):
      apiKey: this.auth.config.apiKey,
      appName: this.auth.name
    });
  }
  get refreshToken() {
    return this.stsTokenManager.refreshToken || "";
  }
  static _fromJSON(t, n) {
    var r, i, o, a, s, c, l, u;
    const d = (r = n.displayName) !== null && r !== void 0 ? r : void 0, f = (i = n.email) !== null && i !== void 0 ? i : void 0, h = (o = n.phoneNumber) !== null && o !== void 0 ? o : void 0, p = (a = n.photoURL) !== null && a !== void 0 ? a : void 0, g = (s = n.tenantId) !== null && s !== void 0 ? s : void 0, m = (c = n._redirectEventId) !== null && c !== void 0 ? c : void 0, v = (l = n.createdAt) !== null && l !== void 0 ? l : void 0, y = (u = n.lastLoginAt) !== null && u !== void 0 ? u : void 0, { uid: S, emailVerified: _, isAnonymous: w, providerData: T, stsTokenManager: x } = n;
    Ft(
      S && x,
      t,
      "internal-error"
      /* AuthErrorCode.INTERNAL_ERROR */
    );
    const C = zh.fromJSON(this.name, x);
    Ft(
      typeof S == "string",
      t,
      "internal-error"
      /* AuthErrorCode.INTERNAL_ERROR */
    ), Cl(d, t.name), Cl(f, t.name), Ft(
      typeof _ == "boolean",
      t,
      "internal-error"
      /* AuthErrorCode.INTERNAL_ERROR */
    ), Ft(
      typeof w == "boolean",
      t,
      "internal-error"
      /* AuthErrorCode.INTERNAL_ERROR */
    ), Cl(h, t.name), Cl(p, t.name), Cl(g, t.name), Cl(m, t.name), Cl(v, t.name), Cl(y, t.name);
    const E = new ls({
      uid: S,
      auth: t,
      email: f,
      emailVerified: _,
      displayName: d,
      isAnonymous: w,
      photoURL: p,
      phoneNumber: h,
      tenantId: g,
      stsTokenManager: C,
      createdAt: v,
      lastLoginAt: y
    });
    return T && Array.isArray(T) && (E.providerData = T.map((R) => Object.assign({}, R))), m && (E._redirectEventId = m), E;
  }
  /**
   * Initialize a User from an idToken server response
   * @param auth
   * @param idTokenResponse
   */
  static async _fromIdTokenResponse(t, n, r = !1) {
    const i = new zh();
    i.updateFromServerResponse(n);
    const o = new ls({
      uid: n.localId,
      auth: t,
      stsTokenManager: i,
      isAnonymous: r
    });
    return await b_(o), o;
  }
  /**
   * Initialize a User from an idToken server response
   * @param auth
   * @param idTokenResponse
   */
  static async _fromGetAccountInfoResponse(t, n, r) {
    const i = n.users[0];
    Ft(
      i.localId !== void 0,
      "internal-error"
      /* AuthErrorCode.INTERNAL_ERROR */
    );
    const o = i.providerUserInfo !== void 0 ? eU(i.providerUserInfo) : [], a = !(i.email && i.passwordHash) && !(o != null && o.length), s = new zh();
    s.updateFromIdToken(r);
    const c = new ls({
      uid: i.localId,
      auth: t,
      stsTokenManager: s,
      isAnonymous: a
    }), l = {
      uid: i.localId,
      displayName: i.displayName || null,
      photoURL: i.photoUrl || null,
      email: i.email || null,
      emailVerified: i.emailVerified || !1,
      phoneNumber: i.phoneNumber || null,
      tenantId: i.tenantId || null,
      providerData: o,
      metadata: new OI(i.createdAt, i.lastLoginAt),
      isAnonymous: !(i.email && i.passwordHash) && !(o != null && o.length)
    };
    return Object.assign(c, l), c;
  }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const CD = /* @__PURE__ */ new Map();
function Hc(e) {
  rl(e instanceof Function, "Expected a class definition");
  let t = CD.get(e);
  return t ? (rl(t instanceof e, "Instance stored in cache mismatched with class"), t) : (t = new e(), CD.set(e, t), t);
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class tU {
  constructor() {
    this.type = "NONE", this.storage = {};
  }
  async _isAvailable() {
    return !0;
  }
  async _set(t, n) {
    this.storage[t] = n;
  }
  async _get(t) {
    const n = this.storage[t];
    return n === void 0 ? null : n;
  }
  async _remove(t) {
    delete this.storage[t];
  }
  _addListener(t, n) {
  }
  _removeListener(t, n) {
  }
}
tU.type = "NONE";
const TD = tU;
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function I1(e, t, n) {
  return `firebase:${e}:${t}:${n}`;
}
class Hh {
  constructor(t, n, r) {
    this.persistence = t, this.auth = n, this.userKey = r;
    const { config: i, name: o } = this.auth;
    this.fullUserKey = I1(this.userKey, i.apiKey, o), this.fullPersistenceKey = I1("persistence", i.apiKey, o), this.boundEventHandler = n._onStorageEvent.bind(n), this.persistence._addListener(this.fullUserKey, this.boundEventHandler);
  }
  setCurrentUser(t) {
    return this.persistence._set(this.fullUserKey, t.toJSON());
  }
  async getCurrentUser() {
    const t = await this.persistence._get(this.fullUserKey);
    if (!t)
      return null;
    if (typeof t == "string") {
      const n = await y_(this.auth, { idToken: t }).catch(() => {
      });
      return n ? ls._fromGetAccountInfoResponse(this.auth, n, t) : null;
    }
    return ls._fromJSON(this.auth, t);
  }
  removeCurrentUser() {
    return this.persistence._remove(this.fullUserKey);
  }
  savePersistenceForRedirect() {
    return this.persistence._set(this.fullPersistenceKey, this.persistence.type);
  }
  async setPersistence(t) {
    if (this.persistence === t)
      return;
    const n = await this.getCurrentUser();
    if (await this.removeCurrentUser(), this.persistence = t, n)
      return this.setCurrentUser(n);
  }
  delete() {
    this.persistence._removeListener(this.fullUserKey, this.boundEventHandler);
  }
  static async create(t, n, r = "authUser") {
    if (!n.length)
      return new Hh(Hc(TD), t, r);
    const i = (await Promise.all(n.map(async (l) => {
      if (await l._isAvailable())
        return l;
    }))).filter((l) => l);
    let o = i[0] || Hc(TD);
    const a = I1(r, t.config.apiKey, t.name);
    let s = null;
    for (const l of n)
      try {
        const u = await l._get(a);
        if (u) {
          let d;
          if (typeof u == "string") {
            const f = await y_(t, {
              idToken: u
            }).catch(() => {
            });
            if (!f)
              break;
            d = await ls._fromGetAccountInfoResponse(t, f, u);
          } else
            d = ls._fromJSON(t, u);
          l !== o && (s = d), o = l;
          break;
        }
      } catch {
      }
    const c = i.filter((l) => l._shouldAllowMigration);
    return !o._shouldAllowMigration || !c.length ? new Hh(o, t, r) : (o = c[0], s && await o._set(a, s.toJSON()), await Promise.all(n.map(async (l) => {
      if (l !== o)
        try {
          await l._remove(a);
        } catch {
        }
    })), new Hh(o, t, r));
  }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function ID(e) {
  const t = e.toLowerCase();
  if (t.includes("opera/") || t.includes("opr/") || t.includes("opios/"))
    return "Opera";
  if (oU(t))
    return "IEMobile";
  if (t.includes("msie") || t.includes("trident/"))
    return "IE";
  if (t.includes("edge/"))
    return "Edge";
  if (nU(t))
    return "Firefox";
  if (t.includes("silk/"))
    return "Silk";
  if (sU(t))
    return "Blackberry";
  if (cU(t))
    return "Webos";
  if (rU(t))
    return "Safari";
  if ((t.includes("chrome/") || iU(t)) && !t.includes("edge/"))
    return "Chrome";
  if (aU(t))
    return "Android";
  {
    const n = /([a-zA-Z\d\.]+)\/[a-zA-Z\d\.]*$/, r = e.match(n);
    if ((r == null ? void 0 : r.length) === 2)
      return r[1];
  }
  return "Other";
}
function nU(e = co()) {
  return /firefox\//i.test(e);
}
function rU(e = co()) {
  const t = e.toLowerCase();
  return t.includes("safari/") && !t.includes("chrome/") && !t.includes("crios/") && !t.includes("android");
}
function iU(e = co()) {
  return /crios\//i.test(e);
}
function oU(e = co()) {
  return /iemobile/i.test(e);
}
function aU(e = co()) {
  return /android/i.test(e);
}
function sU(e = co()) {
  return /blackberry/i.test(e);
}
function cU(e = co()) {
  return /webos/i.test(e);
}
function TO(e = co()) {
  return /iphone|ipad|ipod/i.test(e) || /macintosh/i.test(e) && /mobile/i.test(e);
}
function che(e = co()) {
  var t;
  return TO(e) && !!(!((t = window.navigator) === null || t === void 0) && t.standalone);
}
function lhe() {
  return rue() && document.documentMode === 10;
}
function lU(e = co()) {
  return TO(e) || aU(e) || cU(e) || sU(e) || /windows phone/i.test(e) || oU(e);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function uU(e, t = []) {
  let n;
  switch (e) {
    case "Browser":
      n = ID(co());
      break;
    case "Worker":
      n = `${ID(co())}-${e}`;
      break;
    default:
      n = e;
  }
  const r = t.length ? t.join(",") : "FirebaseCore-web";
  return `${n}/JsCore/${ap}/${r}`;
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class uhe {
  constructor(t) {
    this.auth = t, this.queue = [];
  }
  pushCallback(t, n) {
    const r = (o) => new Promise((a, s) => {
      try {
        const c = t(o);
        a(c);
      } catch (c) {
        s(c);
      }
    });
    r.onAbort = n, this.queue.push(r);
    const i = this.queue.length - 1;
    return () => {
      this.queue[i] = () => Promise.resolve();
    };
  }
  async runMiddleware(t) {
    if (this.auth.currentUser === t)
      return;
    const n = [];
    try {
      for (const r of this.queue)
        await r(t), r.onAbort && n.push(r.onAbort);
    } catch (r) {
      n.reverse();
      for (const i of n)
        try {
          i();
        } catch {
        }
      throw this.auth._errorFactory.create("login-blocked", {
        originalMessage: r == null ? void 0 : r.message
      });
    }
  }
}
/**
 * @license
 * Copyright 2023 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
async function dhe(e, t = {}) {
  return Du(e, "GET", "/v2/passwordPolicy", Nu(e, t));
}
/**
 * @license
 * Copyright 2023 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const fhe = 6;
class hhe {
  constructor(t) {
    var n, r, i, o;
    const a = t.customStrengthOptions;
    this.customStrengthOptions = {}, this.customStrengthOptions.minPasswordLength = (n = a.minPasswordLength) !== null && n !== void 0 ? n : fhe, a.maxPasswordLength && (this.customStrengthOptions.maxPasswordLength = a.maxPasswordLength), a.containsLowercaseCharacter !== void 0 && (this.customStrengthOptions.containsLowercaseLetter = a.containsLowercaseCharacter), a.containsUppercaseCharacter !== void 0 && (this.customStrengthOptions.containsUppercaseLetter = a.containsUppercaseCharacter), a.containsNumericCharacter !== void 0 && (this.customStrengthOptions.containsNumericCharacter = a.containsNumericCharacter), a.containsNonAlphanumericCharacter !== void 0 && (this.customStrengthOptions.containsNonAlphanumericCharacter = a.containsNonAlphanumericCharacter), this.enforcementState = t.enforcementState, this.enforcementState === "ENFORCEMENT_STATE_UNSPECIFIED" && (this.enforcementState = "OFF"), this.allowedNonAlphanumericCharacters = (i = (r = t.allowedNonAlphanumericCharacters) === null || r === void 0 ? void 0 : r.join("")) !== null && i !== void 0 ? i : "", this.forceUpgradeOnSignin = (o = t.forceUpgradeOnSignin) !== null && o !== void 0 ? o : !1, this.schemaVersion = t.schemaVersion;
  }
  validatePassword(t) {
    var n, r, i, o, a, s;
    const c = {
      isValid: !0,
      passwordPolicy: this
    };
    return this.validatePasswordLengthOptions(t, c), this.validatePasswordCharacterOptions(t, c), c.isValid && (c.isValid = (n = c.meetsMinPasswordLength) !== null && n !== void 0 ? n : !0), c.isValid && (c.isValid = (r = c.meetsMaxPasswordLength) !== null && r !== void 0 ? r : !0), c.isValid && (c.isValid = (i = c.containsLowercaseLetter) !== null && i !== void 0 ? i : !0), c.isValid && (c.isValid = (o = c.containsUppercaseLetter) !== null && o !== void 0 ? o : !0), c.isValid && (c.isValid = (a = c.containsNumericCharacter) !== null && a !== void 0 ? a : !0), c.isValid && (c.isValid = (s = c.containsNonAlphanumericCharacter) !== null && s !== void 0 ? s : !0), c;
  }
  /**
   * Validates that the password meets the length options for the policy.
   *
   * @param password Password to validate.
   * @param status Validation status.
   */
  validatePasswordLengthOptions(t, n) {
    const r = this.customStrengthOptions.minPasswordLength, i = this.customStrengthOptions.maxPasswordLength;
    r && (n.meetsMinPasswordLength = t.length >= r), i && (n.meetsMaxPasswordLength = t.length <= i);
  }
  /**
   * Validates that the password meets the character options for the policy.
   *
   * @param password Password to validate.
   * @param status Validation status.
   */
  validatePasswordCharacterOptions(t, n) {
    this.updatePasswordCharacterOptionsStatuses(
      n,
      /* containsLowercaseCharacter= */
      !1,
      /* containsUppercaseCharacter= */
      !1,
      /* containsNumericCharacter= */
      !1,
      /* containsNonAlphanumericCharacter= */
      !1
    );
    let r;
    for (let i = 0; i < t.length; i++)
      r = t.charAt(i), this.updatePasswordCharacterOptionsStatuses(
        n,
        /* containsLowercaseCharacter= */
        r >= "a" && r <= "z",
        /* containsUppercaseCharacter= */
        r >= "A" && r <= "Z",
        /* containsNumericCharacter= */
        r >= "0" && r <= "9",
        /* containsNonAlphanumericCharacter= */
        this.allowedNonAlphanumericCharacters.includes(r)
      );
  }
  /**
   * Updates the running validation status with the statuses for the character options.
   * Expected to be called each time a character is processed to update each option status
   * based on the current character.
   *
   * @param status Validation status.
   * @param containsLowercaseCharacter Whether the character is a lowercase letter.
   * @param containsUppercaseCharacter Whether the character is an uppercase letter.
   * @param containsNumericCharacter Whether the character is a numeric character.
   * @param containsNonAlphanumericCharacter Whether the character is a non-alphanumeric character.
   */
  updatePasswordCharacterOptionsStatuses(t, n, r, i, o) {
    this.customStrengthOptions.containsLowercaseLetter && (t.containsLowercaseLetter || (t.containsLowercaseLetter = n)), this.customStrengthOptions.containsUppercaseLetter && (t.containsUppercaseLetter || (t.containsUppercaseLetter = r)), this.customStrengthOptions.containsNumericCharacter && (t.containsNumericCharacter || (t.containsNumericCharacter = i)), this.customStrengthOptions.containsNonAlphanumericCharacter && (t.containsNonAlphanumericCharacter || (t.containsNonAlphanumericCharacter = o));
  }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class ghe {
  constructor(t, n, r, i) {
    this.app = t, this.heartbeatServiceProvider = n, this.appCheckServiceProvider = r, this.config = i, this.currentUser = null, this.emulatorConfig = null, this.operations = Promise.resolve(), this.authStateSubscription = new AD(this), this.idTokenSubscription = new AD(this), this.beforeStateQueue = new uhe(this), this.redirectUser = null, this.isProactiveRefreshEnabled = !1, this.EXPECTED_PASSWORD_POLICY_SCHEMA_VERSION = 1, this._canInitEmulator = !0, this._isInitialized = !1, this._deleted = !1, this._initializationPromise = null, this._popupRedirectResolver = null, this._errorFactory = YH, this._agentRecaptchaConfig = null, this._tenantRecaptchaConfigs = {}, this._projectPasswordPolicy = null, this._tenantPasswordPolicies = {}, this._resolvePersistenceManagerAvailable = void 0, this.lastNotifiedUid = void 0, this.languageCode = null, this.tenantId = null, this.settings = { appVerificationDisabledForTesting: !1 }, this.frameworks = [], this.name = t.name, this.clientVersion = i.sdkClientVersion, this._persistenceManagerAvailable = new Promise((o) => this._resolvePersistenceManagerAvailable = o);
  }
  _initializeWithPersistence(t, n) {
    return n && (this._popupRedirectResolver = Hc(n)), this._initializationPromise = this.queue(async () => {
      var r, i, o;
      if (!this._deleted && (this.persistenceManager = await Hh.create(this, t), (r = this._resolvePersistenceManagerAvailable) === null || r === void 0 || r.call(this), !this._deleted)) {
        if (!((i = this._popupRedirectResolver) === null || i === void 0) && i._shouldInitProactively)
          try {
            await this._popupRedirectResolver._initialize(this);
          } catch {
          }
        await this.initializeCurrentUser(n), this.lastNotifiedUid = ((o = this.currentUser) === null || o === void 0 ? void 0 : o.uid) || null, !this._deleted && (this._isInitialized = !0);
      }
    }), this._initializationPromise;
  }
  /**
   * If the persistence is changed in another window, the user manager will let us know
   */
  async _onStorageEvent() {
    if (this._deleted)
      return;
    const t = await this.assertedPersistence.getCurrentUser();
    if (!(!this.currentUser && !t)) {
      if (this.currentUser && t && this.currentUser.uid === t.uid) {
        this._currentUser._assign(t), await this.currentUser.getIdToken();
        return;
      }
      await this._updateCurrentUser(
        t,
        /* skipBeforeStateCallbacks */
        !0
      );
    }
  }
  async initializeCurrentUserFromIdToken(t) {
    try {
      const n = await y_(this, { idToken: t }), r = await ls._fromGetAccountInfoResponse(this, n, t);
      await this.directlySetCurrentUser(r);
    } catch (n) {
      console.warn("FirebaseServerApp could not login user with provided authIdToken: ", n), await this.directlySetCurrentUser(null);
    }
  }
  async initializeCurrentUser(t) {
    var n;
    if (Eo(this.app)) {
      const a = this.app.settings.authIdToken;
      return a ? new Promise((s) => {
        setTimeout(() => this.initializeCurrentUserFromIdToken(a).then(s, s));
      }) : this.directlySetCurrentUser(null);
    }
    const r = await this.assertedPersistence.getCurrentUser();
    let i = r, o = !1;
    if (t && this.config.authDomain) {
      await this.getOrInitRedirectPersistenceManager();
      const a = (n = this.redirectUser) === null || n === void 0 ? void 0 : n._redirectEventId, s = i == null ? void 0 : i._redirectEventId, c = await this.tryRedirectSignIn(t);
      (!a || a === s) && (c != null && c.user) && (i = c.user, o = !0);
    }
    if (!i)
      return this.directlySetCurrentUser(null);
    if (!i._redirectEventId) {
      if (o)
        try {
          await this.beforeStateQueue.runMiddleware(i);
        } catch (a) {
          i = r, this._popupRedirectResolver._overrideRedirectResult(this, () => Promise.reject(a));
        }
      return i ? this.reloadAndSetCurrentUserOrClear(i) : this.directlySetCurrentUser(null);
    }
    return Ft(
      this._popupRedirectResolver,
      this,
      "argument-error"
      /* AuthErrorCode.ARGUMENT_ERROR */
    ), await this.getOrInitRedirectPersistenceManager(), this.redirectUser && this.redirectUser._redirectEventId === i._redirectEventId ? this.directlySetCurrentUser(i) : this.reloadAndSetCurrentUserOrClear(i);
  }
  async tryRedirectSignIn(t) {
    let n = null;
    try {
      n = await this._popupRedirectResolver._completeRedirectFn(this, t, !0);
    } catch {
      await this._setRedirectUser(null);
    }
    return n;
  }
  async reloadAndSetCurrentUserOrClear(t) {
    try {
      await b_(t);
    } catch (n) {
      if ((n == null ? void 0 : n.code) !== "auth/network-request-failed")
        return this.directlySetCurrentUser(null);
    }
    return this.directlySetCurrentUser(t);
  }
  useDeviceLanguage() {
    this.languageCode = qfe();
  }
  async _delete() {
    this._deleted = !0;
  }
  async updateCurrentUser(t) {
    if (Eo(this.app))
      return Promise.reject(Zs(this));
    const n = t ? $r(t) : null;
    return n && Ft(
      n.auth.config.apiKey === this.config.apiKey,
      this,
      "invalid-user-token"
      /* AuthErrorCode.INVALID_AUTH */
    ), this._updateCurrentUser(n && n._clone(this));
  }
  async _updateCurrentUser(t, n = !1) {
    if (!this._deleted)
      return t && Ft(
        this.tenantId === t.tenantId,
        this,
        "tenant-id-mismatch"
        /* AuthErrorCode.TENANT_ID_MISMATCH */
      ), n || await this.beforeStateQueue.runMiddleware(t), this.queue(async () => {
        await this.directlySetCurrentUser(t), this.notifyAuthListeners();
      });
  }
  async signOut() {
    return Eo(this.app) ? Promise.reject(Zs(this)) : (await this.beforeStateQueue.runMiddleware(null), (this.redirectPersistenceManager || this._popupRedirectResolver) && await this._setRedirectUser(null), this._updateCurrentUser(
      null,
      /* skipBeforeStateCallbacks */
      !0
    ));
  }
  setPersistence(t) {
    return Eo(this.app) ? Promise.reject(Zs(this)) : this.queue(async () => {
      await this.assertedPersistence.setPersistence(Hc(t));
    });
  }
  _getRecaptchaConfig() {
    return this.tenantId == null ? this._agentRecaptchaConfig : this._tenantRecaptchaConfigs[this.tenantId];
  }
  async validatePassword(t) {
    this._getPasswordPolicyInternal() || await this._updatePasswordPolicy();
    const n = this._getPasswordPolicyInternal();
    return n.schemaVersion !== this.EXPECTED_PASSWORD_POLICY_SCHEMA_VERSION ? Promise.reject(this._errorFactory.create("unsupported-password-policy-schema-version", {})) : n.validatePassword(t);
  }
  _getPasswordPolicyInternal() {
    return this.tenantId === null ? this._projectPasswordPolicy : this._tenantPasswordPolicies[this.tenantId];
  }
  async _updatePasswordPolicy() {
    const t = await dhe(this), n = new hhe(t);
    this.tenantId === null ? this._projectPasswordPolicy = n : this._tenantPasswordPolicies[this.tenantId] = n;
  }
  _getPersistenceType() {
    return this.assertedPersistence.persistence.type;
  }
  _getPersistence() {
    return this.assertedPersistence.persistence;
  }
  _updateErrorMap(t) {
    this._errorFactory = new Sf("auth", "Firebase", t());
  }
  onAuthStateChanged(t, n, r) {
    return this.registerStateListener(this.authStateSubscription, t, n, r);
  }
  beforeAuthStateChanged(t, n) {
    return this.beforeStateQueue.pushCallback(t, n);
  }
  onIdTokenChanged(t, n, r) {
    return this.registerStateListener(this.idTokenSubscription, t, n, r);
  }
  authStateReady() {
    return new Promise((t, n) => {
      if (this.currentUser)
        t();
      else {
        const r = this.onAuthStateChanged(() => {
          r(), t();
        }, n);
      }
    });
  }
  /**
   * Revokes the given access token. Currently only supports Apple OAuth access tokens.
   */
  async revokeAccessToken(t) {
    if (this.currentUser) {
      const n = await this.currentUser.getIdToken(), r = {
        providerId: "apple.com",
        tokenType: "ACCESS_TOKEN",
        token: t,
        idToken: n
      };
      this.tenantId != null && (r.tenantId = this.tenantId), await she(this, r);
    }
  }
  toJSON() {
    var t;
    return {
      apiKey: this.config.apiKey,
      authDomain: this.config.authDomain,
      appName: this.name,
      currentUser: (t = this._currentUser) === null || t === void 0 ? void 0 : t.toJSON()
    };
  }
  async _setRedirectUser(t, n) {
    const r = await this.getOrInitRedirectPersistenceManager(n);
    return t === null ? r.removeCurrentUser() : r.setCurrentUser(t);
  }
  async getOrInitRedirectPersistenceManager(t) {
    if (!this.redirectPersistenceManager) {
      const n = t && Hc(t) || this._popupRedirectResolver;
      Ft(
        n,
        this,
        "argument-error"
        /* AuthErrorCode.ARGUMENT_ERROR */
      ), this.redirectPersistenceManager = await Hh.create(
        this,
        [Hc(n._redirectPersistence)],
        "redirectUser"
        /* KeyName.REDIRECT_USER */
      ), this.redirectUser = await this.redirectPersistenceManager.getCurrentUser();
    }
    return this.redirectPersistenceManager;
  }
  async _redirectUserForId(t) {
    var n, r;
    return this._isInitialized && await this.queue(async () => {
    }), ((n = this._currentUser) === null || n === void 0 ? void 0 : n._redirectEventId) === t ? this._currentUser : ((r = this.redirectUser) === null || r === void 0 ? void 0 : r._redirectEventId) === t ? this.redirectUser : null;
  }
  async _persistUserIfCurrent(t) {
    if (t === this.currentUser)
      return this.queue(async () => this.directlySetCurrentUser(t));
  }
  /** Notifies listeners only if the user is current */
  _notifyListenersIfCurrent(t) {
    t === this.currentUser && this.notifyAuthListeners();
  }
  _key() {
    return `${this.config.authDomain}:${this.config.apiKey}:${this.name}`;
  }
  _startProactiveRefresh() {
    this.isProactiveRefreshEnabled = !0, this.currentUser && this._currentUser._startProactiveRefresh();
  }
  _stopProactiveRefresh() {
    this.isProactiveRefreshEnabled = !1, this.currentUser && this._currentUser._stopProactiveRefresh();
  }
  /** Returns the current user cast as the internal type */
  get _currentUser() {
    return this.currentUser;
  }
  notifyAuthListeners() {
    var t, n;
    if (!this._isInitialized)
      return;
    this.idTokenSubscription.next(this.currentUser);
    const r = (n = (t = this.currentUser) === null || t === void 0 ? void 0 : t.uid) !== null && n !== void 0 ? n : null;
    this.lastNotifiedUid !== r && (this.lastNotifiedUid = r, this.authStateSubscription.next(this.currentUser));
  }
  registerStateListener(t, n, r, i) {
    if (this._deleted)
      return () => {
      };
    const o = typeof n == "function" ? n : n.next.bind(n);
    let a = !1;
    const s = this._isInitialized ? Promise.resolve() : this._initializationPromise;
    if (Ft(
      s,
      this,
      "internal-error"
      /* AuthErrorCode.INTERNAL_ERROR */
    ), s.then(() => {
      a || o(this.currentUser);
    }), typeof n == "function") {
      const c = t.addObserver(n, r, i);
      return () => {
        a = !0, c();
      };
    } else {
      const c = t.addObserver(n);
      return () => {
        a = !0, c();
      };
    }
  }
  /**
   * Unprotected (from race conditions) method to set the current user. This
   * should only be called from within a queued callback. This is necessary
   * because the queue shouldn't rely on another queued callback.
   */
  async directlySetCurrentUser(t) {
    this.currentUser && this.currentUser !== t && this._currentUser._stopProactiveRefresh(), t && this.isProactiveRefreshEnabled && t._startProactiveRefresh(), this.currentUser = t, t ? await this.assertedPersistence.setCurrentUser(t) : await this.assertedPersistence.removeCurrentUser();
  }
  queue(t) {
    return this.operations = this.operations.then(t, t), this.operations;
  }
  get assertedPersistence() {
    return Ft(
      this.persistenceManager,
      this,
      "internal-error"
      /* AuthErrorCode.INTERNAL_ERROR */
    ), this.persistenceManager;
  }
  _logFramework(t) {
    !t || this.frameworks.includes(t) || (this.frameworks.push(t), this.frameworks.sort(), this.clientVersion = uU(this.config.clientPlatform, this._getFrameworks()));
  }
  _getFrameworks() {
    return this.frameworks;
  }
  async _getAdditionalHeaders() {
    var t;
    const n = {
      "X-Client-Version": this.clientVersion
    };
    this.app.options.appId && (n[
      "X-Firebase-gmpid"
      /* HttpHeader.X_FIREBASE_GMPID */
    ] = this.app.options.appId);
    const r = await ((t = this.heartbeatServiceProvider.getImmediate({
      optional: !0
    })) === null || t === void 0 ? void 0 : t.getHeartbeatsHeader());
    r && (n[
      "X-Firebase-Client"
      /* HttpHeader.X_FIREBASE_CLIENT */
    ] = r);
    const i = await this._getAppCheckToken();
    return i && (n[
      "X-Firebase-AppCheck"
      /* HttpHeader.X_FIREBASE_APP_CHECK */
    ] = i), n;
  }
  async _getAppCheckToken() {
    var t;
    if (Eo(this.app) && this.app.settings.appCheckToken)
      return this.app.settings.appCheckToken;
    const n = await ((t = this.appCheckServiceProvider.getImmediate({ optional: !0 })) === null || t === void 0 ? void 0 : t.getToken());
    return n != null && n.error && Hfe(`Error while retrieving App Check token: ${n.error}`), n == null ? void 0 : n.token;
  }
}
function pl(e) {
  return $r(e);
}
class AD {
  constructor(t) {
    this.auth = t, this.observer = null, this.addObserver = uue((n) => this.observer = n);
  }
  get next() {
    return Ft(
      this.observer,
      this.auth,
      "internal-error"
      /* AuthErrorCode.INTERNAL_ERROR */
    ), this.observer.next.bind(this.observer);
  }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
let Qw = {
  async loadJS() {
    throw new Error("Unable to load external scripts");
  },
  recaptchaV2Script: "",
  recaptchaEnterpriseScript: "",
  gapiScript: ""
};
function phe(e) {
  Qw = e;
}
function dU(e) {
  return Qw.loadJS(e);
}
function mhe() {
  return Qw.recaptchaEnterpriseScript;
}
function vhe() {
  return Qw.gapiScript;
}
function yhe(e) {
  return `__${e}${Math.floor(Math.random() * 1e6)}`;
}
class bhe {
  constructor() {
    this.enterprise = new _he();
  }
  ready(t) {
    t();
  }
  execute(t, n) {
    return Promise.resolve("token");
  }
  render(t, n) {
    return "";
  }
}
class _he {
  ready(t) {
    t();
  }
  execute(t, n) {
    return Promise.resolve("token");
  }
  render(t, n) {
    return "";
  }
}
const She = "recaptcha-enterprise", fU = "NO_RECAPTCHA";
class whe {
  /**
   *
   * @param authExtern - The corresponding Firebase {@link Auth} instance.
   *
   */
  constructor(t) {
    this.type = She, this.auth = pl(t);
  }
  /**
   * Executes the verification process.
   *
   * @returns A Promise for a token that can be used to assert the validity of a request.
   */
  async verify(t = "verify", n = !1) {
    async function r(o) {
      if (!n) {
        if (o.tenantId == null && o._agentRecaptchaConfig != null)
          return o._agentRecaptchaConfig.siteKey;
        if (o.tenantId != null && o._tenantRecaptchaConfigs[o.tenantId] !== void 0)
          return o._tenantRecaptchaConfigs[o.tenantId].siteKey;
      }
      return new Promise(async (a, s) => {
        Zfe(o, {
          clientType: "CLIENT_TYPE_WEB",
          version: "RECAPTCHA_ENTERPRISE"
          /* RecaptchaVersion.ENTERPRISE */
        }).then((c) => {
          if (c.recaptchaKey === void 0)
            s(new Error("recaptcha Enterprise site key undefined"));
          else {
            const l = new Jfe(c);
            return o.tenantId == null ? o._agentRecaptchaConfig = l : o._tenantRecaptchaConfigs[o.tenantId] = l, a(l.siteKey);
          }
        }).catch((c) => {
          s(c);
        });
      });
    }
    function i(o, a, s) {
      const c = window.grecaptcha;
      xD(c) ? c.enterprise.ready(() => {
        c.enterprise.execute(o, { action: t }).then((l) => {
          a(l);
        }).catch(() => {
          a(fU);
        });
      }) : s(Error("No reCAPTCHA enterprise script loaded."));
    }
    return this.auth.settings.appVerificationDisabledForTesting ? new bhe().execute("siteKey", { action: "verify" }) : new Promise((o, a) => {
      r(this.auth).then((s) => {
        if (!n && xD(window.grecaptcha))
          i(s, o, a);
        else {
          if (typeof window > "u") {
            a(new Error("RecaptchaVerifier is only supported in browser"));
            return;
          }
          let c = mhe();
          c.length !== 0 && (c += s), dU(c).then(() => {
            i(s, o, a);
          }).catch((l) => {
            a(l);
          });
        }
      }).catch((s) => {
        a(s);
      });
    });
  }
}
async function am(e, t, n, r = !1, i = !1) {
  const o = new whe(e);
  let a;
  if (i)
    a = fU;
  else
    try {
      a = await o.verify(n);
    } catch {
      a = await o.verify(n, !0);
    }
  const s = Object.assign({}, t);
  if (n === "mfaSmsEnrollment" || n === "mfaSmsSignIn") {
    if ("phoneEnrollmentInfo" in s) {
      const c = s.phoneEnrollmentInfo.phoneNumber, l = s.phoneEnrollmentInfo.recaptchaToken;
      Object.assign(s, {
        phoneEnrollmentInfo: {
          phoneNumber: c,
          recaptchaToken: l,
          captchaResponse: a,
          clientType: "CLIENT_TYPE_WEB",
          recaptchaVersion: "RECAPTCHA_ENTERPRISE"
          /* RecaptchaVersion.ENTERPRISE */
        }
      });
    } else if ("phoneSignInInfo" in s) {
      const c = s.phoneSignInInfo.recaptchaToken;
      Object.assign(s, {
        phoneSignInInfo: {
          recaptchaToken: c,
          captchaResponse: a,
          clientType: "CLIENT_TYPE_WEB",
          recaptchaVersion: "RECAPTCHA_ENTERPRISE"
          /* RecaptchaVersion.ENTERPRISE */
        }
      });
    }
    return s;
  }
  return r ? Object.assign(s, { captchaResp: a }) : Object.assign(s, { captchaResponse: a }), Object.assign(s, {
    clientType: "CLIENT_TYPE_WEB"
    /* RecaptchaClientType.WEB */
  }), Object.assign(s, {
    recaptchaVersion: "RECAPTCHA_ENTERPRISE"
    /* RecaptchaVersion.ENTERPRISE */
  }), s;
}
async function RD(e, t, n, r, i) {
  var o, a;
  if (i === "EMAIL_PASSWORD_PROVIDER")
    if (!((o = e._getRecaptchaConfig()) === null || o === void 0) && o.isProviderEnabled(
      "EMAIL_PASSWORD_PROVIDER"
      /* RecaptchaAuthProvider.EMAIL_PASSWORD_PROVIDER */
    )) {
      const s = await am(
        e,
        t,
        n,
        n === "getOobCode"
        /* RecaptchaActionName.GET_OOB_CODE */
      );
      return r(e, s);
    } else
      return r(e, t).catch(async (s) => {
        if (s.code === "auth/missing-recaptcha-token") {
          console.log(`${n} is protected by reCAPTCHA Enterprise for this project. Automatically triggering the reCAPTCHA flow and restarting the flow.`);
          const c = await am(
            e,
            t,
            n,
            n === "getOobCode"
            /* RecaptchaActionName.GET_OOB_CODE */
          );
          return r(e, c);
        } else
          return Promise.reject(s);
      });
  else if (i === "PHONE_PROVIDER")
    if (!((a = e._getRecaptchaConfig()) === null || a === void 0) && a.isProviderEnabled(
      "PHONE_PROVIDER"
      /* RecaptchaAuthProvider.PHONE_PROVIDER */
    )) {
      const s = await am(e, t, n);
      return r(e, s).catch(async (c) => {
        var l;
        if (((l = e._getRecaptchaConfig()) === null || l === void 0 ? void 0 : l.getProviderEnforcementState(
          "PHONE_PROVIDER"
          /* RecaptchaAuthProvider.PHONE_PROVIDER */
        )) === "AUDIT" && (c.code === "auth/missing-recaptcha-token" || c.code === "auth/invalid-app-credential")) {
          console.log(`Failed to verify with reCAPTCHA Enterprise. Automatically triggering the reCAPTCHA v2 flow to complete the ${n} flow.`);
          const u = await am(
            e,
            t,
            n,
            !1,
            // isCaptchaResp
            !0
            // isFakeToken
          );
          return r(e, u);
        }
        return Promise.reject(c);
      });
    } else {
      const s = await am(
        e,
        t,
        n,
        !1,
        // isCaptchaResp
        !0
        // isFakeToken
      );
      return r(e, s);
    }
  else
    return Promise.reject(i + " provider is not supported.");
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function xhe(e, t) {
  const n = gl(e, "auth");
  if (n.isInitialized()) {
    const i = n.getImmediate(), o = n.getOptions();
    if (tl(o, t ?? {}))
      return i;
    Va(
      i,
      "already-initialized"
      /* AuthErrorCode.ALREADY_INITIALIZED */
    );
  }
  return n.initialize({ options: t });
}
function Ehe(e, t) {
  const n = (t == null ? void 0 : t.persistence) || [], r = (Array.isArray(n) ? n : [n]).map(Hc);
  t != null && t.errorMap && e._updateErrorMap(t.errorMap), e._initializeWithPersistence(r, t == null ? void 0 : t.popupRedirectResolver);
}
function hU(e, t, n) {
  const r = pl(e);
  Ft(
    /^https?:\/\//.test(t),
    r,
    "invalid-emulator-scheme"
    /* AuthErrorCode.INVALID_EMULATOR_SCHEME */
  );
  const i = !!(n != null && n.disableWarnings), o = gU(t), { host: a, port: s } = Che(t), c = s === null ? "" : `:${s}`, l = { url: `${o}//${a}${c}/` }, u = Object.freeze({
    host: a,
    port: s,
    protocol: o.replace(":", ""),
    options: Object.freeze({ disableWarnings: i })
  });
  if (!r._canInitEmulator) {
    Ft(
      r.config.emulator && r.emulatorConfig,
      r,
      "emulator-config-failed"
      /* AuthErrorCode.EMULATOR_CONFIG_FAILED */
    ), Ft(
      tl(l, r.config.emulator) && tl(u, r.emulatorConfig),
      r,
      "emulator-config-failed"
      /* AuthErrorCode.EMULATOR_CONFIG_FAILED */
    );
    return;
  }
  r.config.emulator = l, r.emulatorConfig = u, r.settings.appVerificationDisabledForTesting = !0, ku(a) ? (qw(`${o}//${a}${c}`), pO("Auth", !0)) : i || The();
}
function gU(e) {
  const t = e.indexOf(":");
  return t < 0 ? "" : e.substr(0, t + 1);
}
function Che(e) {
  const t = gU(e), n = /(\/\/)?([^?#/]+)/.exec(e.substr(t.length));
  if (!n)
    return { host: "", port: null };
  const r = n[2].split("@").pop() || "", i = /^(\[[^\]]+\])(:|$)/.exec(r);
  if (i) {
    const o = i[1];
    return { host: o, port: $D(r.substr(o.length + 1)) };
  } else {
    const [o, a] = r.split(":");
    return { host: o, port: $D(a) };
  }
}
function $D(e) {
  if (!e)
    return null;
  const t = Number(e);
  return isNaN(t) ? null : t;
}
function The() {
  function e() {
    const t = document.createElement("p"), n = t.style;
    t.innerText = "Running in emulator mode. Do not use with production credentials.", n.position = "fixed", n.width = "100%", n.backgroundColor = "#ffffff", n.border = ".1em solid #000000", n.color = "#b50000", n.bottom = "0px", n.left = "0px", n.margin = "0px", n.zIndex = "10000", n.textAlign = "center", t.classList.add("firebase-emulator-warning"), document.body.appendChild(t);
  }
  typeof console < "u" && typeof console.info == "function" && console.info("WARNING: You are using the Auth Emulator, which is intended for local testing only.  Do not use with production credentials."), typeof window < "u" && typeof document < "u" && (document.readyState === "loading" ? window.addEventListener("DOMContentLoaded", e) : e());
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class IO {
  /** @internal */
  constructor(t, n) {
    this.providerId = t, this.signInMethod = n;
  }
  /**
   * Returns a JSON-serializable representation of this object.
   *
   * @returns a JSON-serializable representation of this object.
   */
  toJSON() {
    return zc("not implemented");
  }
  /** @internal */
  _getIdTokenResponse(t) {
    return zc("not implemented");
  }
  /** @internal */
  _linkToIdToken(t, n) {
    return zc("not implemented");
  }
  /** @internal */
  _getReauthenticationResolver(t) {
    return zc("not implemented");
  }
}
async function Ihe(e, t) {
  return Du(e, "POST", "/v1/accounts:signUp", t);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
async function Ahe(e, t) {
  return Fv(e, "POST", "/v1/accounts:signInWithPassword", Nu(e, t));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
async function Rhe(e, t) {
  return Fv(e, "POST", "/v1/accounts:signInWithEmailLink", Nu(e, t));
}
async function $he(e, t) {
  return Fv(e, "POST", "/v1/accounts:signInWithEmailLink", Nu(e, t));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class L0 extends IO {
  /** @internal */
  constructor(t, n, r, i = null) {
    super("password", r), this._email = t, this._password = n, this._tenantId = i;
  }
  /** @internal */
  static _fromEmailAndPassword(t, n) {
    return new L0(
      t,
      n,
      "password"
      /* SignInMethod.EMAIL_PASSWORD */
    );
  }
  /** @internal */
  static _fromEmailAndCode(t, n, r = null) {
    return new L0(t, n, "emailLink", r);
  }
  /** {@inheritdoc AuthCredential.toJSON} */
  toJSON() {
    return {
      email: this._email,
      password: this._password,
      signInMethod: this.signInMethod,
      tenantId: this._tenantId
    };
  }
  /**
   * Static method to deserialize a JSON representation of an object into an {@link  AuthCredential}.
   *
   * @param json - Either `object` or the stringified representation of the object. When string is
   * provided, `JSON.parse` would be called first.
   *
   * @returns If the JSON input does not represent an {@link AuthCredential}, null is returned.
   */
  static fromJSON(t) {
    const n = typeof t == "string" ? JSON.parse(t) : t;
    if (n != null && n.email && (n != null && n.password)) {
      if (n.signInMethod === "password")
        return this._fromEmailAndPassword(n.email, n.password);
      if (n.signInMethod === "emailLink")
        return this._fromEmailAndCode(n.email, n.password, n.tenantId);
    }
    return null;
  }
  /** @internal */
  async _getIdTokenResponse(t) {
    switch (this.signInMethod) {
      case "password":
        const n = {
          returnSecureToken: !0,
          email: this._email,
          password: this._password,
          clientType: "CLIENT_TYPE_WEB"
          /* RecaptchaClientType.WEB */
        };
        return RD(
          t,
          n,
          "signInWithPassword",
          Ahe,
          "EMAIL_PASSWORD_PROVIDER"
          /* RecaptchaAuthProvider.EMAIL_PASSWORD_PROVIDER */
        );
      case "emailLink":
        return Rhe(t, {
          email: this._email,
          oobCode: this._password
        });
      default:
        Va(
          t,
          "internal-error"
          /* AuthErrorCode.INTERNAL_ERROR */
        );
    }
  }
  /** @internal */
  async _linkToIdToken(t, n) {
    switch (this.signInMethod) {
      case "password":
        const r = {
          idToken: n,
          returnSecureToken: !0,
          email: this._email,
          password: this._password,
          clientType: "CLIENT_TYPE_WEB"
          /* RecaptchaClientType.WEB */
        };
        return RD(
          t,
          r,
          "signUpPassword",
          Ihe,
          "EMAIL_PASSWORD_PROVIDER"
          /* RecaptchaAuthProvider.EMAIL_PASSWORD_PROVIDER */
        );
      case "emailLink":
        return $he(t, {
          idToken: n,
          email: this._email,
          oobCode: this._password
        });
      default:
        Va(
          t,
          "internal-error"
          /* AuthErrorCode.INTERNAL_ERROR */
        );
    }
  }
  /** @internal */
  _getReauthenticationResolver(t) {
    return this._getIdTokenResponse(t);
  }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
async function Uh(e, t) {
  return Fv(e, "POST", "/v1/accounts:signInWithIdp", Nu(e, t));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const Ohe = "http://localhost";
class il extends IO {
  constructor() {
    super(...arguments), this.pendingToken = null;
  }
  /** @internal */
  static _fromParams(t) {
    const n = new il(t.providerId, t.signInMethod);
    return t.idToken || t.accessToken ? (t.idToken && (n.idToken = t.idToken), t.accessToken && (n.accessToken = t.accessToken), t.nonce && !t.pendingToken && (n.nonce = t.nonce), t.pendingToken && (n.pendingToken = t.pendingToken)) : t.oauthToken && t.oauthTokenSecret ? (n.accessToken = t.oauthToken, n.secret = t.oauthTokenSecret) : Va(
      "argument-error"
      /* AuthErrorCode.ARGUMENT_ERROR */
    ), n;
  }
  /** {@inheritdoc AuthCredential.toJSON}  */
  toJSON() {
    return {
      idToken: this.idToken,
      accessToken: this.accessToken,
      secret: this.secret,
      nonce: this.nonce,
      pendingToken: this.pendingToken,
      providerId: this.providerId,
      signInMethod: this.signInMethod
    };
  }
  /**
   * Static method to deserialize a JSON representation of an object into an
   * {@link  AuthCredential}.
   *
   * @param json - Input can be either Object or the stringified representation of the object.
   * When string is provided, JSON.parse would be called first.
   *
   * @returns If the JSON input does not represent an {@link  AuthCredential}, null is returned.
   */
  static fromJSON(t) {
    const n = typeof t == "string" ? JSON.parse(t) : t, { providerId: r, signInMethod: i } = n, o = Z$(n, ["providerId", "signInMethod"]);
    if (!r || !i)
      return null;
    const a = new il(r, i);
    return a.idToken = o.idToken || void 0, a.accessToken = o.accessToken || void 0, a.secret = o.secret, a.nonce = o.nonce, a.pendingToken = o.pendingToken || null, a;
  }
  /** @internal */
  _getIdTokenResponse(t) {
    const n = this.buildRequest();
    return Uh(t, n);
  }
  /** @internal */
  _linkToIdToken(t, n) {
    const r = this.buildRequest();
    return r.idToken = n, Uh(t, r);
  }
  /** @internal */
  _getReauthenticationResolver(t) {
    const n = this.buildRequest();
    return n.autoCreate = !1, Uh(t, n);
  }
  buildRequest() {
    const t = {
      requestUri: Ohe,
      returnSecureToken: !0
    };
    if (this.pendingToken)
      t.pendingToken = this.pendingToken;
    else {
      const n = {};
      this.idToken && (n.id_token = this.idToken), this.accessToken && (n.access_token = this.accessToken), this.secret && (n.oauth_token_secret = this.secret), n.providerId = this.providerId, this.nonce && !this.pendingToken && (n.nonce = this.nonce), t.postBody = Lv(n);
    }
    return t;
  }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function Phe(e) {
  switch (e) {
    case "recoverEmail":
      return "RECOVER_EMAIL";
    case "resetPassword":
      return "PASSWORD_RESET";
    case "signIn":
      return "EMAIL_SIGNIN";
    case "verifyEmail":
      return "VERIFY_EMAIL";
    case "verifyAndChangeEmail":
      return "VERIFY_AND_CHANGE_EMAIL";
    case "revertSecondFactorAddition":
      return "REVERT_SECOND_FACTOR_ADDITION";
    default:
      return null;
  }
}
function Mhe(e) {
  const t = Dm(Lm(e)).link, n = t ? Dm(Lm(t)).deep_link_id : null, r = Dm(Lm(e)).deep_link_id;
  return (r ? Dm(Lm(r)).link : null) || r || n || t || e;
}
class AO {
  /**
   * @param actionLink - The link from which to extract the URL.
   * @returns The {@link ActionCodeURL} object, or null if the link is invalid.
   *
   * @internal
   */
  constructor(t) {
    var n, r, i, o, a, s;
    const c = Dm(Lm(t)), l = (n = c.apiKey) !== null && n !== void 0 ? n : null, u = (r = c.oobCode) !== null && r !== void 0 ? r : null, d = Phe((i = c.mode) !== null && i !== void 0 ? i : null);
    Ft(
      l && u && d,
      "argument-error"
      /* AuthErrorCode.ARGUMENT_ERROR */
    ), this.apiKey = l, this.operation = d, this.code = u, this.continueUrl = (o = c.continueUrl) !== null && o !== void 0 ? o : null, this.languageCode = (a = c.lang) !== null && a !== void 0 ? a : null, this.tenantId = (s = c.tenantId) !== null && s !== void 0 ? s : null;
  }
  /**
   * Parses the email action link string and returns an {@link ActionCodeURL} if the link is valid,
   * otherwise returns null.
   *
   * @param link  - The email action link string.
   * @returns The {@link ActionCodeURL} object, or null if the link is invalid.
   *
   * @public
   */
  static parseLink(t) {
    const n = Mhe(t);
    try {
      return new AO(n);
    } catch {
      return null;
    }
  }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class sp {
  constructor() {
    this.providerId = sp.PROVIDER_ID;
  }
  /**
   * Initialize an {@link AuthCredential} using an email and password.
   *
   * @example
   * ```javascript
   * const authCredential = EmailAuthProvider.credential(email, password);
   * const userCredential = await signInWithCredential(auth, authCredential);
   * ```
   *
   * @example
   * ```javascript
   * const userCredential = await signInWithEmailAndPassword(auth, email, password);
   * ```
   *
   * @param email - Email address.
   * @param password - User account password.
   * @returns The auth provider credential.
   */
  static credential(t, n) {
    return L0._fromEmailAndPassword(t, n);
  }
  /**
   * Initialize an {@link AuthCredential} using an email and an email link after a sign in with
   * email link operation.
   *
   * @example
   * ```javascript
   * const authCredential = EmailAuthProvider.credentialWithLink(auth, email, emailLink);
   * const userCredential = await signInWithCredential(auth, authCredential);
   * ```
   *
   * @example
   * ```javascript
   * await sendSignInLinkToEmail(auth, email);
   * // Obtain emailLink from user.
   * const userCredential = await signInWithEmailLink(auth, email, emailLink);
   * ```
   *
   * @param auth - The {@link Auth} instance used to verify the link.
   * @param email - Email address.
   * @param emailLink - Sign-in email link.
   * @returns - The auth provider credential.
   */
  static credentialWithLink(t, n) {
    const r = AO.parseLink(n);
    return Ft(
      r,
      "argument-error"
      /* AuthErrorCode.ARGUMENT_ERROR */
    ), L0._fromEmailAndCode(t, r.code, r.tenantId);
  }
}
sp.PROVIDER_ID = "password";
sp.EMAIL_PASSWORD_SIGN_IN_METHOD = "password";
sp.EMAIL_LINK_SIGN_IN_METHOD = "emailLink";
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class Jw {
  /**
   * Constructor for generic OAuth providers.
   *
   * @param providerId - Provider for which credentials should be generated.
   */
  constructor(t) {
    this.providerId = t, this.defaultLanguageCode = null, this.customParameters = {};
  }
  /**
   * Set the language gode.
   *
   * @param languageCode - language code
   */
  setDefaultLanguage(t) {
    this.defaultLanguageCode = t;
  }
  /**
   * Sets the OAuth custom parameters to pass in an OAuth request for popup and redirect sign-in
   * operations.
   *
   * @remarks
   * For a detailed list, check the reserved required OAuth 2.0 parameters such as `client_id`,
   * `redirect_uri`, `scope`, `response_type`, and `state` are not allowed and will be ignored.
   *
   * @param customOAuthParameters - The custom OAuth parameters to pass in the OAuth request.
   */
  setCustomParameters(t) {
    return this.customParameters = t, this;
  }
  /**
   * Retrieve the current list of {@link CustomParameters}.
   */
  getCustomParameters() {
    return this.customParameters;
  }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class cp extends Jw {
  constructor() {
    super(...arguments), this.scopes = [];
  }
  /**
   * Add an OAuth scope to the credential.
   *
   * @param scope - Provider OAuth scope to add.
   */
  addScope(t) {
    return this.scopes.includes(t) || this.scopes.push(t), this;
  }
  /**
   * Retrieve the current list of OAuth scopes.
   */
  getScopes() {
    return [...this.scopes];
  }
}
class s0 extends cp {
  /**
   * Creates an {@link OAuthCredential} from a JSON string or a plain object.
   * @param json - A plain object or a JSON string
   */
  static credentialFromJSON(t) {
    const n = typeof t == "string" ? JSON.parse(t) : t;
    return Ft(
      "providerId" in n && "signInMethod" in n,
      "argument-error"
      /* AuthErrorCode.ARGUMENT_ERROR */
    ), il._fromParams(n);
  }
  /**
   * Creates a {@link OAuthCredential} from a generic OAuth provider's access token or ID token.
   *
   * @remarks
   * The raw nonce is required when an ID token with a nonce field is provided. The SHA-256 hash of
   * the raw nonce must match the nonce field in the ID token.
   *
   * @example
   * ```javascript
   * // `googleUser` from the onsuccess Google Sign In callback.
   * // Initialize a generate OAuth provider with a `google.com` providerId.
   * const provider = new OAuthProvider('google.com');
   * const credential = provider.credential({
   *   idToken: googleUser.getAuthResponse().id_token,
   * });
   * const result = await signInWithCredential(credential);
   * ```
   *
   * @param params - Either the options object containing the ID token, access token and raw nonce
   * or the ID token string.
   */
  credential(t) {
    return this._credential(Object.assign(Object.assign({}, t), { nonce: t.rawNonce }));
  }
  /** An internal credential method that accepts more permissive options */
  _credential(t) {
    return Ft(
      t.idToken || t.accessToken,
      "argument-error"
      /* AuthErrorCode.ARGUMENT_ERROR */
    ), il._fromParams(Object.assign(Object.assign({}, t), { providerId: this.providerId, signInMethod: this.providerId }));
  }
  /**
   * Used to extract the underlying {@link OAuthCredential} from a {@link UserCredential}.
   *
   * @param userCredential - The user credential.
   */
  static credentialFromResult(t) {
    return s0.oauthCredentialFromTaggedObject(t);
  }
  /**
   * Used to extract the underlying {@link OAuthCredential} from a {@link AuthError} which was
   * thrown during a sign-in, link, or reauthenticate operation.
   *
   * @param userCredential - The user credential.
   */
  static credentialFromError(t) {
    return s0.oauthCredentialFromTaggedObject(t.customData || {});
  }
  static oauthCredentialFromTaggedObject({ _tokenResponse: t }) {
    if (!t)
      return null;
    const { oauthIdToken: n, oauthAccessToken: r, oauthTokenSecret: i, pendingToken: o, nonce: a, providerId: s } = t;
    if (!r && !i && !n && !o || !s)
      return null;
    try {
      return new s0(s)._credential({
        idToken: n,
        accessToken: r,
        nonce: a,
        pendingToken: o
      });
    } catch {
      return null;
    }
  }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class Fl extends cp {
  constructor() {
    super(
      "facebook.com"
      /* ProviderId.FACEBOOK */
    );
  }
  /**
   * Creates a credential for Facebook.
   *
   * @example
   * ```javascript
   * // `event` from the Facebook auth.authResponseChange callback.
   * const credential = FacebookAuthProvider.credential(event.authResponse.accessToken);
   * const result = await signInWithCredential(credential);
   * ```
   *
   * @param accessToken - Facebook access token.
   */
  static credential(t) {
    return il._fromParams({
      providerId: Fl.PROVIDER_ID,
      signInMethod: Fl.FACEBOOK_SIGN_IN_METHOD,
      accessToken: t
    });
  }
  /**
   * Used to extract the underlying {@link OAuthCredential} from a {@link UserCredential}.
   *
   * @param userCredential - The user credential.
   */
  static credentialFromResult(t) {
    return Fl.credentialFromTaggedObject(t);
  }
  /**
   * Used to extract the underlying {@link OAuthCredential} from a {@link AuthError} which was
   * thrown during a sign-in, link, or reauthenticate operation.
   *
   * @param userCredential - The user credential.
   */
  static credentialFromError(t) {
    return Fl.credentialFromTaggedObject(t.customData || {});
  }
  static credentialFromTaggedObject({ _tokenResponse: t }) {
    if (!t || !("oauthAccessToken" in t) || !t.oauthAccessToken)
      return null;
    try {
      return Fl.credential(t.oauthAccessToken);
    } catch {
      return null;
    }
  }
}
Fl.FACEBOOK_SIGN_IN_METHOD = "facebook.com";
Fl.PROVIDER_ID = "facebook.com";
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class Vl extends cp {
  constructor() {
    super(
      "google.com"
      /* ProviderId.GOOGLE */
    ), this.addScope("profile");
  }
  /**
   * Creates a credential for Google. At least one of ID token and access token is required.
   *
   * @example
   * ```javascript
   * // \`googleUser\` from the onsuccess Google Sign In callback.
   * const credential = GoogleAuthProvider.credential(googleUser.getAuthResponse().id_token);
   * const result = await signInWithCredential(credential);
   * ```
   *
   * @param idToken - Google ID token.
   * @param accessToken - Google access token.
   */
  static credential(t, n) {
    return il._fromParams({
      providerId: Vl.PROVIDER_ID,
      signInMethod: Vl.GOOGLE_SIGN_IN_METHOD,
      idToken: t,
      accessToken: n
    });
  }
  /**
   * Used to extract the underlying {@link OAuthCredential} from a {@link UserCredential}.
   *
   * @param userCredential - The user credential.
   */
  static credentialFromResult(t) {
    return Vl.credentialFromTaggedObject(t);
  }
  /**
   * Used to extract the underlying {@link OAuthCredential} from a {@link AuthError} which was
   * thrown during a sign-in, link, or reauthenticate operation.
   *
   * @param userCredential - The user credential.
   */
  static credentialFromError(t) {
    return Vl.credentialFromTaggedObject(t.customData || {});
  }
  static credentialFromTaggedObject({ _tokenResponse: t }) {
    if (!t)
      return null;
    const { oauthIdToken: n, oauthAccessToken: r } = t;
    if (!n && !r)
      return null;
    try {
      return Vl.credential(n, r);
    } catch {
      return null;
    }
  }
}
Vl.GOOGLE_SIGN_IN_METHOD = "google.com";
Vl.PROVIDER_ID = "google.com";
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class Bl extends cp {
  constructor() {
    super(
      "github.com"
      /* ProviderId.GITHUB */
    );
  }
  /**
   * Creates a credential for GitHub.
   *
   * @param accessToken - GitHub access token.
   */
  static credential(t) {
    return il._fromParams({
      providerId: Bl.PROVIDER_ID,
      signInMethod: Bl.GITHUB_SIGN_IN_METHOD,
      accessToken: t
    });
  }
  /**
   * Used to extract the underlying {@link OAuthCredential} from a {@link UserCredential}.
   *
   * @param userCredential - The user credential.
   */
  static credentialFromResult(t) {
    return Bl.credentialFromTaggedObject(t);
  }
  /**
   * Used to extract the underlying {@link OAuthCredential} from a {@link AuthError} which was
   * thrown during a sign-in, link, or reauthenticate operation.
   *
   * @param userCredential - The user credential.
   */
  static credentialFromError(t) {
    return Bl.credentialFromTaggedObject(t.customData || {});
  }
  static credentialFromTaggedObject({ _tokenResponse: t }) {
    if (!t || !("oauthAccessToken" in t) || !t.oauthAccessToken)
      return null;
    try {
      return Bl.credential(t.oauthAccessToken);
    } catch {
      return null;
    }
  }
}
Bl.GITHUB_SIGN_IN_METHOD = "github.com";
Bl.PROVIDER_ID = "github.com";
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class zl extends cp {
  constructor() {
    super(
      "twitter.com"
      /* ProviderId.TWITTER */
    );
  }
  /**
   * Creates a credential for Twitter.
   *
   * @param token - Twitter access token.
   * @param secret - Twitter secret.
   */
  static credential(t, n) {
    return il._fromParams({
      providerId: zl.PROVIDER_ID,
      signInMethod: zl.TWITTER_SIGN_IN_METHOD,
      oauthToken: t,
      oauthTokenSecret: n
    });
  }
  /**
   * Used to extract the underlying {@link OAuthCredential} from a {@link UserCredential}.
   *
   * @param userCredential - The user credential.
   */
  static credentialFromResult(t) {
    return zl.credentialFromTaggedObject(t);
  }
  /**
   * Used to extract the underlying {@link OAuthCredential} from a {@link AuthError} which was
   * thrown during a sign-in, link, or reauthenticate operation.
   *
   * @param userCredential - The user credential.
   */
  static credentialFromError(t) {
    return zl.credentialFromTaggedObject(t.customData || {});
  }
  static credentialFromTaggedObject({ _tokenResponse: t }) {
    if (!t)
      return null;
    const { oauthAccessToken: n, oauthTokenSecret: r } = t;
    if (!n || !r)
      return null;
    try {
      return zl.credential(n, r);
    } catch {
      return null;
    }
  }
}
zl.TWITTER_SIGN_IN_METHOD = "twitter.com";
zl.PROVIDER_ID = "twitter.com";
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
async function khe(e, t) {
  return Fv(e, "POST", "/v1/accounts:signUp", Nu(e, t));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class pu {
  constructor(t) {
    this.user = t.user, this.providerId = t.providerId, this._tokenResponse = t._tokenResponse, this.operationType = t.operationType;
  }
  static async _fromIdTokenResponse(t, n, r, i = !1) {
    const o = await ls._fromIdTokenResponse(t, r, i), a = OD(r);
    return new pu({
      user: o,
      providerId: a,
      _tokenResponse: r,
      operationType: n
    });
  }
  static async _forOperation(t, n, r) {
    await t._updateTokensIfNecessary(
      r,
      /* reload */
      !0
    );
    const i = OD(r);
    return new pu({
      user: t,
      providerId: i,
      _tokenResponse: r,
      operationType: n
    });
  }
}
function OD(e) {
  return e.providerId ? e.providerId : "phoneNumber" in e ? "phone" : null;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
async function Nhe(e) {
  var t;
  if (Eo(e.app))
    return Promise.reject(Zs(e));
  const n = pl(e);
  if (await n._initializationPromise, !((t = n.currentUser) === null || t === void 0) && t.isAnonymous)
    return new pu({
      user: n.currentUser,
      providerId: null,
      operationType: "signIn"
      /* OperationType.SIGN_IN */
    });
  const r = await khe(n, {
    returnSecureToken: !0
  }), i = await pu._fromIdTokenResponse(n, "signIn", r, !0);
  return await n._updateCurrentUser(i.user), i;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class __ extends Ua {
  constructor(t, n, r, i) {
    var o;
    super(n.code, n.message), this.operationType = r, this.user = i, Object.setPrototypeOf(this, __.prototype), this.customData = {
      appName: t.name,
      tenantId: (o = t.tenantId) !== null && o !== void 0 ? o : void 0,
      _serverResponse: n.customData._serverResponse,
      operationType: r
    };
  }
  static _fromErrorAndOperation(t, n, r, i) {
    return new __(t, n, r, i);
  }
}
function pU(e, t, n, r) {
  return (t === "reauthenticate" ? n._getReauthenticationResolver(e) : n._getIdTokenResponse(e)).catch((o) => {
    throw o.code === "auth/multi-factor-auth-required" ? __._fromErrorAndOperation(e, o, t, r) : o;
  });
}
async function Dhe(e, t, n = !1) {
  const r = await D0(e, t._linkToIdToken(e.auth, await e.getIdToken()), n);
  return pu._forOperation(e, "link", r);
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
async function Lhe(e, t, n = !1) {
  const { auth: r } = e;
  if (Eo(r.app))
    return Promise.reject(Zs(r));
  const i = "reauthenticate";
  try {
    const o = await D0(e, pU(r, i, t, e), n);
    Ft(
      o.idToken,
      r,
      "internal-error"
      /* AuthErrorCode.INTERNAL_ERROR */
    );
    const a = CO(o.idToken);
    Ft(
      a,
      r,
      "internal-error"
      /* AuthErrorCode.INTERNAL_ERROR */
    );
    const { sub: s } = a;
    return Ft(
      e.uid === s,
      r,
      "user-mismatch"
      /* AuthErrorCode.USER_MISMATCH */
    ), pu._forOperation(e, i, o);
  } catch (o) {
    throw (o == null ? void 0 : o.code) === "auth/user-not-found" && Va(
      r,
      "user-mismatch"
      /* AuthErrorCode.USER_MISMATCH */
    ), o;
  }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
async function mU(e, t, n = !1) {
  if (Eo(e.app))
    return Promise.reject(Zs(e));
  const r = "signIn", i = await pU(e, r, t), o = await pu._fromIdTokenResponse(e, r, i);
  return n || await e._updateCurrentUser(o.user), o;
}
async function jhe(e, t) {
  return mU(pl(e), t);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
async function Fhe(e) {
  const t = pl(e);
  t._getPasswordPolicyInternal() && await t._updatePasswordPolicy();
}
function Vhe(e, t, n) {
  return Eo(e.app) ? Promise.reject(Zs(e)) : jhe($r(e), sp.credential(t, n)).catch(async (r) => {
    throw r.code === "auth/password-does-not-meet-requirements" && Fhe(e), r;
  });
}
function Bhe(e, t, n, r) {
  return $r(e).onIdTokenChanged(t, n, r);
}
function zhe(e, t, n) {
  return $r(e).beforeAuthStateChanged(t, n);
}
function Hhe(e) {
  return $r(e).signOut();
}
const S_ = "__sak";
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class vU {
  constructor(t, n) {
    this.storageRetriever = t, this.type = n;
  }
  _isAvailable() {
    try {
      return this.storage ? (this.storage.setItem(S_, "1"), this.storage.removeItem(S_), Promise.resolve(!0)) : Promise.resolve(!1);
    } catch {
      return Promise.resolve(!1);
    }
  }
  _set(t, n) {
    return this.storage.setItem(t, JSON.stringify(n)), Promise.resolve();
  }
  _get(t) {
    const n = this.storage.getItem(t);
    return Promise.resolve(n ? JSON.parse(n) : null);
  }
  _remove(t) {
    return this.storage.removeItem(t), Promise.resolve();
  }
  get storage() {
    return this.storageRetriever();
  }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const Uhe = 1e3, Whe = 10;
class yU extends vU {
  constructor() {
    super(
      () => window.localStorage,
      "LOCAL"
      /* PersistenceType.LOCAL */
    ), this.boundEventHandler = (t, n) => this.onStorageEvent(t, n), this.listeners = {}, this.localCache = {}, this.pollTimer = null, this.fallbackToPolling = lU(), this._shouldAllowMigration = !0;
  }
  forAllChangedKeys(t) {
    for (const n of Object.keys(this.listeners)) {
      const r = this.storage.getItem(n), i = this.localCache[n];
      r !== i && t(n, i, r);
    }
  }
  onStorageEvent(t, n = !1) {
    if (!t.key) {
      this.forAllChangedKeys((a, s, c) => {
        this.notifyListeners(a, c);
      });
      return;
    }
    const r = t.key;
    n ? this.detachListener() : this.stopPolling();
    const i = () => {
      const a = this.storage.getItem(r);
      !n && this.localCache[r] === a || this.notifyListeners(r, a);
    }, o = this.storage.getItem(r);
    lhe() && o !== t.newValue && t.newValue !== t.oldValue ? setTimeout(i, Whe) : i();
  }
  notifyListeners(t, n) {
    this.localCache[t] = n;
    const r = this.listeners[t];
    if (r)
      for (const i of Array.from(r))
        i(n && JSON.parse(n));
  }
  startPolling() {
    this.stopPolling(), this.pollTimer = setInterval(() => {
      this.forAllChangedKeys((t, n, r) => {
        this.onStorageEvent(
          new StorageEvent("storage", {
            key: t,
            oldValue: n,
            newValue: r
          }),
          /* poll */
          !0
        );
      });
    }, Uhe);
  }
  stopPolling() {
    this.pollTimer && (clearInterval(this.pollTimer), this.pollTimer = null);
  }
  attachListener() {
    window.addEventListener("storage", this.boundEventHandler);
  }
  detachListener() {
    window.removeEventListener("storage", this.boundEventHandler);
  }
  _addListener(t, n) {
    Object.keys(this.listeners).length === 0 && (this.fallbackToPolling ? this.startPolling() : this.attachListener()), this.listeners[t] || (this.listeners[t] = /* @__PURE__ */ new Set(), this.localCache[t] = this.storage.getItem(t)), this.listeners[t].add(n);
  }
  _removeListener(t, n) {
    this.listeners[t] && (this.listeners[t].delete(n), this.listeners[t].size === 0 && delete this.listeners[t]), Object.keys(this.listeners).length === 0 && (this.detachListener(), this.stopPolling());
  }
  // Update local cache on base operations:
  async _set(t, n) {
    await super._set(t, n), this.localCache[t] = JSON.stringify(n);
  }
  async _get(t) {
    const n = await super._get(t);
    return this.localCache[t] = JSON.stringify(n), n;
  }
  async _remove(t) {
    await super._remove(t), delete this.localCache[t];
  }
}
yU.type = "LOCAL";
const qhe = yU;
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class bU extends vU {
  constructor() {
    super(
      () => window.sessionStorage,
      "SESSION"
      /* PersistenceType.SESSION */
    );
  }
  _addListener(t, n) {
  }
  _removeListener(t, n) {
  }
}
bU.type = "SESSION";
const _U = bU;
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function Ghe(e) {
  return Promise.all(e.map(async (t) => {
    try {
      return {
        fulfilled: !0,
        value: await t
      };
    } catch (n) {
      return {
        fulfilled: !1,
        reason: n
      };
    }
  }));
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class Zw {
  constructor(t) {
    this.eventTarget = t, this.handlersMap = {}, this.boundEventHandler = this.handleEvent.bind(this);
  }
  /**
   * Obtain an instance of a Receiver for a given event target, if none exists it will be created.
   *
   * @param eventTarget - An event target (such as window or self) through which the underlying
   * messages will be received.
   */
  static _getInstance(t) {
    const n = this.receivers.find((i) => i.isListeningto(t));
    if (n)
      return n;
    const r = new Zw(t);
    return this.receivers.push(r), r;
  }
  isListeningto(t) {
    return this.eventTarget === t;
  }
  /**
   * Fans out a MessageEvent to the appropriate listeners.
   *
   * @remarks
   * Sends an {@link Status.ACK} upon receipt and a {@link Status.DONE} once all handlers have
   * finished processing.
   *
   * @param event - The MessageEvent.
   *
   */
  async handleEvent(t) {
    const n = t, { eventId: r, eventType: i, data: o } = n.data, a = this.handlersMap[i];
    if (!(a != null && a.size))
      return;
    n.ports[0].postMessage({
      status: "ack",
      eventId: r,
      eventType: i
    });
    const s = Array.from(a).map(async (l) => l(n.origin, o)), c = await Ghe(s);
    n.ports[0].postMessage({
      status: "done",
      eventId: r,
      eventType: i,
      response: c
    });
  }
  /**
   * Subscribe an event handler for a particular event.
   *
   * @param eventType - Event name to subscribe to.
   * @param eventHandler - The event handler which should receive the events.
   *
   */
  _subscribe(t, n) {
    Object.keys(this.handlersMap).length === 0 && this.eventTarget.addEventListener("message", this.boundEventHandler), this.handlersMap[t] || (this.handlersMap[t] = /* @__PURE__ */ new Set()), this.handlersMap[t].add(n);
  }
  /**
   * Unsubscribe an event handler from a particular event.
   *
   * @param eventType - Event name to unsubscribe from.
   * @param eventHandler - Optional event handler, if none provided, unsubscribe all handlers on this event.
   *
   */
  _unsubscribe(t, n) {
    this.handlersMap[t] && n && this.handlersMap[t].delete(n), (!n || this.handlersMap[t].size === 0) && delete this.handlersMap[t], Object.keys(this.handlersMap).length === 0 && this.eventTarget.removeEventListener("message", this.boundEventHandler);
  }
}
Zw.receivers = [];
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function RO(e = "", t = 10) {
  let n = "";
  for (let r = 0; r < t; r++)
    n += Math.floor(Math.random() * 10);
  return e + n;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class Khe {
  constructor(t) {
    this.target = t, this.handlers = /* @__PURE__ */ new Set();
  }
  /**
   * Unsubscribe the handler and remove it from our tracking Set.
   *
   * @param handler - The handler to unsubscribe.
   */
  removeMessageHandler(t) {
    t.messageChannel && (t.messageChannel.port1.removeEventListener("message", t.onMessage), t.messageChannel.port1.close()), this.handlers.delete(t);
  }
  /**
   * Send a message to the Receiver located at {@link target}.
   *
   * @remarks
   * We'll first wait a bit for an ACK , if we get one we will wait significantly longer until the
   * receiver has had a chance to fully process the event.
   *
   * @param eventType - Type of event to send.
   * @param data - The payload of the event.
   * @param timeout - Timeout for waiting on an ACK from the receiver.
   *
   * @returns An array of settled promises from all the handlers that were listening on the receiver.
   */
  async _send(t, n, r = 50) {
    const i = typeof MessageChannel < "u" ? new MessageChannel() : null;
    if (!i)
      throw new Error(
        "connection_unavailable"
        /* _MessageError.CONNECTION_UNAVAILABLE */
      );
    let o, a;
    return new Promise((s, c) => {
      const l = RO("", 20);
      i.port1.start();
      const u = setTimeout(() => {
        c(new Error(
          "unsupported_event"
          /* _MessageError.UNSUPPORTED_EVENT */
        ));
      }, r);
      a = {
        messageChannel: i,
        onMessage(d) {
          const f = d;
          if (f.data.eventId === l)
            switch (f.data.status) {
              case "ack":
                clearTimeout(u), o = setTimeout(
                  () => {
                    c(new Error(
                      "timeout"
                      /* _MessageError.TIMEOUT */
                    ));
                  },
                  3e3
                  /* _TimeoutDuration.COMPLETION */
                );
                break;
              case "done":
                clearTimeout(o), s(f.data.response);
                break;
              default:
                clearTimeout(u), clearTimeout(o), c(new Error(
                  "invalid_response"
                  /* _MessageError.INVALID_RESPONSE */
                ));
                break;
            }
        }
      }, this.handlers.add(a), i.port1.addEventListener("message", a.onMessage), this.target.postMessage({
        eventType: t,
        eventId: l,
        data: n
      }, [i.port2]);
    }).finally(() => {
      a && this.removeMessageHandler(a);
    });
  }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function ec() {
  return window;
}
function Yhe(e) {
  ec().location.href = e;
}
/**
 * @license
 * Copyright 2020 Google LLC.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function SU() {
  return typeof ec().WorkerGlobalScope < "u" && typeof ec().importScripts == "function";
}
async function Xhe() {
  if (!(navigator != null && navigator.serviceWorker))
    return null;
  try {
    return (await navigator.serviceWorker.ready).active;
  } catch {
    return null;
  }
}
function Qhe() {
  var e;
  return ((e = navigator == null ? void 0 : navigator.serviceWorker) === null || e === void 0 ? void 0 : e.controller) || null;
}
function Jhe() {
  return SU() ? self : null;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const wU = "firebaseLocalStorageDb", Zhe = 1, w_ = "firebaseLocalStorage", xU = "fbase_key";
class Vv {
  constructor(t) {
    this.request = t;
  }
  toPromise() {
    return new Promise((t, n) => {
      this.request.addEventListener("success", () => {
        t(this.request.result);
      }), this.request.addEventListener("error", () => {
        n(this.request.error);
      });
    });
  }
}
function ex(e, t) {
  return e.transaction([w_], t ? "readwrite" : "readonly").objectStore(w_);
}
function ege() {
  const e = indexedDB.deleteDatabase(wU);
  return new Vv(e).toPromise();
}
function PI() {
  const e = indexedDB.open(wU, Zhe);
  return new Promise((t, n) => {
    e.addEventListener("error", () => {
      n(e.error);
    }), e.addEventListener("upgradeneeded", () => {
      const r = e.result;
      try {
        r.createObjectStore(w_, { keyPath: xU });
      } catch (i) {
        n(i);
      }
    }), e.addEventListener("success", async () => {
      const r = e.result;
      r.objectStoreNames.contains(w_) ? t(r) : (r.close(), await ege(), t(await PI()));
    });
  });
}
async function PD(e, t, n) {
  const r = ex(e, !0).put({
    [xU]: t,
    value: n
  });
  return new Vv(r).toPromise();
}
async function tge(e, t) {
  const n = ex(e, !1).get(t), r = await new Vv(n).toPromise();
  return r === void 0 ? null : r.value;
}
function MD(e, t) {
  const n = ex(e, !0).delete(t);
  return new Vv(n).toPromise();
}
const nge = 800, rge = 3;
class EU {
  constructor() {
    this.type = "LOCAL", this._shouldAllowMigration = !0, this.listeners = {}, this.localCache = {}, this.pollTimer = null, this.pendingWrites = 0, this.receiver = null, this.sender = null, this.serviceWorkerReceiverAvailable = !1, this.activeServiceWorker = null, this._workerInitializationPromise = this.initializeServiceWorkerMessaging().then(() => {
    }, () => {
    });
  }
  async _openDb() {
    return this.db ? this.db : (this.db = await PI(), this.db);
  }
  async _withRetries(t) {
    let n = 0;
    for (; ; )
      try {
        const r = await this._openDb();
        return await t(r);
      } catch (r) {
        if (n++ > rge)
          throw r;
        this.db && (this.db.close(), this.db = void 0);
      }
  }
  /**
   * IndexedDB events do not propagate from the main window to the worker context.  We rely on a
   * postMessage interface to send these events to the worker ourselves.
   */
  async initializeServiceWorkerMessaging() {
    return SU() ? this.initializeReceiver() : this.initializeSender();
  }
  /**
   * As the worker we should listen to events from the main window.
   */
  async initializeReceiver() {
    this.receiver = Zw._getInstance(Jhe()), this.receiver._subscribe("keyChanged", async (t, n) => ({
      keyProcessed: (await this._poll()).includes(n.key)
    })), this.receiver._subscribe("ping", async (t, n) => [
      "keyChanged"
      /* _EventType.KEY_CHANGED */
    ]);
  }
  /**
   * As the main window, we should let the worker know when keys change (set and remove).
   *
   * @remarks
   * {@link https://developer.mozilla.org/en-US/docs/Web/API/ServiceWorkerContainer/ready | ServiceWorkerContainer.ready}
   * may not resolve.
   */
  async initializeSender() {
    var t, n;
    if (this.activeServiceWorker = await Xhe(), !this.activeServiceWorker)
      return;
    this.sender = new Khe(this.activeServiceWorker);
    const r = await this.sender._send(
      "ping",
      {},
      800
      /* _TimeoutDuration.LONG_ACK */
    );
    r && !((t = r[0]) === null || t === void 0) && t.fulfilled && !((n = r[0]) === null || n === void 0) && n.value.includes(
      "keyChanged"
      /* _EventType.KEY_CHANGED */
    ) && (this.serviceWorkerReceiverAvailable = !0);
  }
  /**
   * Let the worker know about a changed key, the exact key doesn't technically matter since the
   * worker will just trigger a full sync anyway.
   *
   * @remarks
   * For now, we only support one service worker per page.
   *
   * @param key - Storage key which changed.
   */
  async notifyServiceWorker(t) {
    if (!(!this.sender || !this.activeServiceWorker || Qhe() !== this.activeServiceWorker))
      try {
        await this.sender._send(
          "keyChanged",
          { key: t },
          // Use long timeout if receiver has previously responded to a ping from us.
          this.serviceWorkerReceiverAvailable ? 800 : 50
          /* _TimeoutDuration.ACK */
        );
      } catch {
      }
  }
  async _isAvailable() {
    try {
      if (!indexedDB)
        return !1;
      const t = await PI();
      return await PD(t, S_, "1"), await MD(t, S_), !0;
    } catch {
    }
    return !1;
  }
  async _withPendingWrite(t) {
    this.pendingWrites++;
    try {
      await t();
    } finally {
      this.pendingWrites--;
    }
  }
  async _set(t, n) {
    return this._withPendingWrite(async () => (await this._withRetries((r) => PD(r, t, n)), this.localCache[t] = n, this.notifyServiceWorker(t)));
  }
  async _get(t) {
    const n = await this._withRetries((r) => tge(r, t));
    return this.localCache[t] = n, n;
  }
  async _remove(t) {
    return this._withPendingWrite(async () => (await this._withRetries((n) => MD(n, t)), delete this.localCache[t], this.notifyServiceWorker(t)));
  }
  async _poll() {
    const t = await this._withRetries((i) => {
      const o = ex(i, !1).getAll();
      return new Vv(o).toPromise();
    });
    if (!t)
      return [];
    if (this.pendingWrites !== 0)
      return [];
    const n = [], r = /* @__PURE__ */ new Set();
    if (t.length !== 0)
      for (const { fbase_key: i, value: o } of t)
        r.add(i), JSON.stringify(this.localCache[i]) !== JSON.stringify(o) && (this.notifyListeners(i, o), n.push(i));
    for (const i of Object.keys(this.localCache))
      this.localCache[i] && !r.has(i) && (this.notifyListeners(i, null), n.push(i));
    return n;
  }
  notifyListeners(t, n) {
    this.localCache[t] = n;
    const r = this.listeners[t];
    if (r)
      for (const i of Array.from(r))
        i(n);
  }
  startPolling() {
    this.stopPolling(), this.pollTimer = setInterval(async () => this._poll(), nge);
  }
  stopPolling() {
    this.pollTimer && (clearInterval(this.pollTimer), this.pollTimer = null);
  }
  _addListener(t, n) {
    Object.keys(this.listeners).length === 0 && this.startPolling(), this.listeners[t] || (this.listeners[t] = /* @__PURE__ */ new Set(), this._get(t)), this.listeners[t].add(n);
  }
  _removeListener(t, n) {
    this.listeners[t] && (this.listeners[t].delete(n), this.listeners[t].size === 0 && delete this.listeners[t]), Object.keys(this.listeners).length === 0 && this.stopPolling();
  }
}
EU.type = "LOCAL";
const ige = EU;
new jv(3e4, 6e4);
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function $O(e, t) {
  return t ? Hc(t) : (Ft(
    e._popupRedirectResolver,
    e,
    "argument-error"
    /* AuthErrorCode.ARGUMENT_ERROR */
  ), e._popupRedirectResolver);
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class OO extends IO {
  constructor(t) {
    super(
      "custom",
      "custom"
      /* ProviderId.CUSTOM */
    ), this.params = t;
  }
  _getIdTokenResponse(t) {
    return Uh(t, this._buildIdpRequest());
  }
  _linkToIdToken(t, n) {
    return Uh(t, this._buildIdpRequest(n));
  }
  _getReauthenticationResolver(t) {
    return Uh(t, this._buildIdpRequest());
  }
  _buildIdpRequest(t) {
    const n = {
      requestUri: this.params.requestUri,
      sessionId: this.params.sessionId,
      postBody: this.params.postBody,
      tenantId: this.params.tenantId,
      pendingToken: this.params.pendingToken,
      returnSecureToken: !0,
      returnIdpCredential: !0
    };
    return t && (n.idToken = t), n;
  }
}
function oge(e) {
  return mU(e.auth, new OO(e), e.bypassAuthState);
}
function age(e) {
  const { auth: t, user: n } = e;
  return Ft(
    n,
    t,
    "internal-error"
    /* AuthErrorCode.INTERNAL_ERROR */
  ), Lhe(n, new OO(e), e.bypassAuthState);
}
async function sge(e) {
  const { auth: t, user: n } = e;
  return Ft(
    n,
    t,
    "internal-error"
    /* AuthErrorCode.INTERNAL_ERROR */
  ), Dhe(n, new OO(e), e.bypassAuthState);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class CU {
  constructor(t, n, r, i, o = !1) {
    this.auth = t, this.resolver = r, this.user = i, this.bypassAuthState = o, this.pendingPromise = null, this.eventManager = null, this.filter = Array.isArray(n) ? n : [n];
  }
  execute() {
    return new Promise(async (t, n) => {
      this.pendingPromise = { resolve: t, reject: n };
      try {
        this.eventManager = await this.resolver._initialize(this.auth), await this.onExecution(), this.eventManager.registerConsumer(this);
      } catch (r) {
        this.reject(r);
      }
    });
  }
  async onAuthEvent(t) {
    const { urlResponse: n, sessionId: r, postBody: i, tenantId: o, error: a, type: s } = t;
    if (a) {
      this.reject(a);
      return;
    }
    const c = {
      auth: this.auth,
      requestUri: n,
      sessionId: r,
      tenantId: o || void 0,
      postBody: i || void 0,
      user: this.user,
      bypassAuthState: this.bypassAuthState
    };
    try {
      this.resolve(await this.getIdpTask(s)(c));
    } catch (l) {
      this.reject(l);
    }
  }
  onError(t) {
    this.reject(t);
  }
  getIdpTask(t) {
    switch (t) {
      case "signInViaPopup":
      case "signInViaRedirect":
        return oge;
      case "linkViaPopup":
      case "linkViaRedirect":
        return sge;
      case "reauthViaPopup":
      case "reauthViaRedirect":
        return age;
      default:
        Va(
          this.auth,
          "internal-error"
          /* AuthErrorCode.INTERNAL_ERROR */
        );
    }
  }
  resolve(t) {
    rl(this.pendingPromise, "Pending promise was never set"), this.pendingPromise.resolve(t), this.unregisterAndCleanUp();
  }
  reject(t) {
    rl(this.pendingPromise, "Pending promise was never set"), this.pendingPromise.reject(t), this.unregisterAndCleanUp();
  }
  unregisterAndCleanUp() {
    this.eventManager && this.eventManager.unregisterConsumer(this), this.pendingPromise = null, this.cleanUp();
  }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const cge = new jv(2e3, 1e4);
async function lge(e, t, n) {
  if (Eo(e.app))
    return Promise.reject(gs(
      e,
      "operation-not-supported-in-this-environment"
      /* AuthErrorCode.OPERATION_NOT_SUPPORTED */
    ));
  const r = pl(e);
  XH(e, t, Jw);
  const i = $O(r, n);
  return new bd(r, "signInViaPopup", t, i).executeNotNull();
}
class bd extends CU {
  constructor(t, n, r, i, o) {
    super(t, n, i, o), this.provider = r, this.authWindow = null, this.pollId = null, bd.currentPopupAction && bd.currentPopupAction.cancel(), bd.currentPopupAction = this;
  }
  async executeNotNull() {
    const t = await this.execute();
    return Ft(
      t,
      this.auth,
      "internal-error"
      /* AuthErrorCode.INTERNAL_ERROR */
    ), t;
  }
  async onExecution() {
    rl(this.filter.length === 1, "Popup operations only handle one event");
    const t = RO();
    this.authWindow = await this.resolver._openPopup(
      this.auth,
      this.provider,
      this.filter[0],
      // There's always one, see constructor
      t
    ), this.authWindow.associatedEvent = t, this.resolver._originValidation(this.auth).catch((n) => {
      this.reject(n);
    }), this.resolver._isIframeWebStorageSupported(this.auth, (n) => {
      n || this.reject(gs(
        this.auth,
        "web-storage-unsupported"
        /* AuthErrorCode.WEB_STORAGE_UNSUPPORTED */
      ));
    }), this.pollUserCancellation();
  }
  get eventId() {
    var t;
    return ((t = this.authWindow) === null || t === void 0 ? void 0 : t.associatedEvent) || null;
  }
  cancel() {
    this.reject(gs(
      this.auth,
      "cancelled-popup-request"
      /* AuthErrorCode.EXPIRED_POPUP_REQUEST */
    ));
  }
  cleanUp() {
    this.authWindow && this.authWindow.close(), this.pollId && window.clearTimeout(this.pollId), this.authWindow = null, this.pollId = null, bd.currentPopupAction = null;
  }
  pollUserCancellation() {
    const t = () => {
      var n, r;
      if (!((r = (n = this.authWindow) === null || n === void 0 ? void 0 : n.window) === null || r === void 0) && r.closed) {
        this.pollId = window.setTimeout(
          () => {
            this.pollId = null, this.reject(gs(
              this.auth,
              "popup-closed-by-user"
              /* AuthErrorCode.POPUP_CLOSED_BY_USER */
            ));
          },
          8e3
          /* _Timeout.AUTH_EVENT */
        );
        return;
      }
      this.pollId = window.setTimeout(t, cge.get());
    };
    t();
  }
}
bd.currentPopupAction = null;
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const uge = "pendingRedirect", A1 = /* @__PURE__ */ new Map();
class dge extends CU {
  constructor(t, n, r = !1) {
    super(t, [
      "signInViaRedirect",
      "linkViaRedirect",
      "reauthViaRedirect",
      "unknown"
      /* AuthEventType.UNKNOWN */
    ], n, void 0, r), this.eventId = null;
  }
  /**
   * Override the execute function; if we already have a redirect result, then
   * just return it.
   */
  async execute() {
    let t = A1.get(this.auth._key());
    if (!t) {
      try {
        const r = await fge(this.resolver, this.auth) ? await super.execute() : null;
        t = () => Promise.resolve(r);
      } catch (n) {
        t = () => Promise.reject(n);
      }
      A1.set(this.auth._key(), t);
    }
    return this.bypassAuthState || A1.set(this.auth._key(), () => Promise.resolve(null)), t();
  }
  async onAuthEvent(t) {
    if (t.type === "signInViaRedirect")
      return super.onAuthEvent(t);
    if (t.type === "unknown") {
      this.resolve(null);
      return;
    }
    if (t.eventId) {
      const n = await this.auth._redirectUserForId(t.eventId);
      if (n)
        return this.user = n, super.onAuthEvent(t);
      this.resolve(null);
    }
  }
  async onExecution() {
  }
  cleanUp() {
  }
}
async function fge(e, t) {
  const n = IU(t), r = TU(e);
  if (!await r._isAvailable())
    return !1;
  const i = await r._get(n) === "true";
  return await r._remove(n), i;
}
async function hge(e, t) {
  return TU(e)._set(IU(t), "true");
}
function gge(e, t) {
  A1.set(e._key(), t);
}
function TU(e) {
  return Hc(e._redirectPersistence);
}
function IU(e) {
  return I1(uge, e.config.apiKey, e.name);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function pge(e, t, n) {
  return mge(e, t, n);
}
async function mge(e, t, n) {
  if (Eo(e.app))
    return Promise.reject(Zs(e));
  const r = pl(e);
  XH(e, t, Jw), await r._initializationPromise;
  const i = $O(r, n);
  return await hge(i, r), i._openRedirect(
    r,
    t,
    "signInViaRedirect"
    /* AuthEventType.SIGN_IN_VIA_REDIRECT */
  );
}
async function vge(e, t, n = !1) {
  if (Eo(e.app))
    return Promise.reject(Zs(e));
  const r = pl(e), i = $O(r, t), a = await new dge(r, i, n).execute();
  return a && !n && (delete a.user._redirectEventId, await r._persistUserIfCurrent(a.user), await r._setRedirectUser(null, t)), a;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const yge = 10 * 60 * 1e3;
class bge {
  constructor(t) {
    this.auth = t, this.cachedEventUids = /* @__PURE__ */ new Set(), this.consumers = /* @__PURE__ */ new Set(), this.queuedRedirectEvent = null, this.hasHandledPotentialRedirect = !1, this.lastProcessedEventTime = Date.now();
  }
  registerConsumer(t) {
    this.consumers.add(t), this.queuedRedirectEvent && this.isEventForConsumer(this.queuedRedirectEvent, t) && (this.sendToConsumer(this.queuedRedirectEvent, t), this.saveEventToCache(this.queuedRedirectEvent), this.queuedRedirectEvent = null);
  }
  unregisterConsumer(t) {
    this.consumers.delete(t);
  }
  onEvent(t) {
    if (this.hasEventBeenHandled(t))
      return !1;
    let n = !1;
    return this.consumers.forEach((r) => {
      this.isEventForConsumer(t, r) && (n = !0, this.sendToConsumer(t, r), this.saveEventToCache(t));
    }), this.hasHandledPotentialRedirect || !_ge(t) || (this.hasHandledPotentialRedirect = !0, n || (this.queuedRedirectEvent = t, n = !0)), n;
  }
  sendToConsumer(t, n) {
    var r;
    if (t.error && !AU(t)) {
      const i = ((r = t.error.code) === null || r === void 0 ? void 0 : r.split("auth/")[1]) || "internal-error";
      n.onError(gs(this.auth, i));
    } else
      n.onAuthEvent(t);
  }
  isEventForConsumer(t, n) {
    const r = n.eventId === null || !!t.eventId && t.eventId === n.eventId;
    return n.filter.includes(t.type) && r;
  }
  hasEventBeenHandled(t) {
    return Date.now() - this.lastProcessedEventTime >= yge && this.cachedEventUids.clear(), this.cachedEventUids.has(kD(t));
  }
  saveEventToCache(t) {
    this.cachedEventUids.add(kD(t)), this.lastProcessedEventTime = Date.now();
  }
}
function kD(e) {
  return [e.type, e.eventId, e.sessionId, e.tenantId].filter((t) => t).join("-");
}
function AU({ type: e, error: t }) {
  return e === "unknown" && (t == null ? void 0 : t.code) === "auth/no-auth-event";
}
function _ge(e) {
  switch (e.type) {
    case "signInViaRedirect":
    case "linkViaRedirect":
    case "reauthViaRedirect":
      return !0;
    case "unknown":
      return AU(e);
    default:
      return !1;
  }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
async function Sge(e, t = {}) {
  return Du(e, "GET", "/v1/projects", t);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const wge = /^\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}$/, xge = /^https?/;
async function Ege(e) {
  if (e.config.emulator)
    return;
  const { authorizedDomains: t } = await Sge(e);
  for (const n of t)
    try {
      if (Cge(n))
        return;
    } catch {
    }
  Va(
    e,
    "unauthorized-domain"
    /* AuthErrorCode.INVALID_ORIGIN */
  );
}
function Cge(e) {
  const t = $I(), { protocol: n, hostname: r } = new URL(t);
  if (e.startsWith("chrome-extension://")) {
    const a = new URL(e);
    return a.hostname === "" && r === "" ? n === "chrome-extension:" && e.replace("chrome-extension://", "") === t.replace("chrome-extension://", "") : n === "chrome-extension:" && a.hostname === r;
  }
  if (!xge.test(n))
    return !1;
  if (wge.test(e))
    return r === e;
  const i = e.replace(/\./g, "\\.");
  return new RegExp("^(.+\\." + i + "|" + i + ")$", "i").test(r);
}
/**
 * @license
 * Copyright 2020 Google LLC.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const Tge = new jv(3e4, 6e4);
function ND() {
  const e = ec().___jsl;
  if (e != null && e.H) {
    for (const t of Object.keys(e.H))
      if (e.H[t].r = e.H[t].r || [], e.H[t].L = e.H[t].L || [], e.H[t].r = [...e.H[t].L], e.CP)
        for (let n = 0; n < e.CP.length; n++)
          e.CP[n] = null;
  }
}
function Ige(e) {
  return new Promise((t, n) => {
    var r, i, o;
    function a() {
      ND(), gapi.load("gapi.iframes", {
        callback: () => {
          t(gapi.iframes.getContext());
        },
        ontimeout: () => {
          ND(), n(gs(
            e,
            "network-request-failed"
            /* AuthErrorCode.NETWORK_REQUEST_FAILED */
          ));
        },
        timeout: Tge.get()
      });
    }
    if (!((i = (r = ec().gapi) === null || r === void 0 ? void 0 : r.iframes) === null || i === void 0) && i.Iframe)
      t(gapi.iframes.getContext());
    else if (!((o = ec().gapi) === null || o === void 0) && o.load)
      a();
    else {
      const s = yhe("iframefcb");
      return ec()[s] = () => {
        gapi.load ? a() : n(gs(
          e,
          "network-request-failed"
          /* AuthErrorCode.NETWORK_REQUEST_FAILED */
        ));
      }, dU(`${vhe()}?onload=${s}`).catch((c) => n(c));
    }
  }).catch((t) => {
    throw R1 = null, t;
  });
}
let R1 = null;
function Age(e) {
  return R1 = R1 || Ige(e), R1;
}
/**
 * @license
 * Copyright 2020 Google LLC.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const Rge = new jv(5e3, 15e3), $ge = "__/auth/iframe", Oge = "emulator/auth/iframe", Pge = {
  style: {
    position: "absolute",
    top: "-100px",
    width: "1px",
    height: "1px"
  },
  "aria-hidden": "true",
  tabindex: "-1"
}, Mge = /* @__PURE__ */ new Map([
  ["identitytoolkit.googleapis.com", "p"],
  // production
  ["staging-identitytoolkit.sandbox.googleapis.com", "s"],
  // staging
  ["test-identitytoolkit.sandbox.googleapis.com", "t"]
  // test
]);
function kge(e) {
  const t = e.config;
  Ft(
    t.authDomain,
    e,
    "auth-domain-config-required"
    /* AuthErrorCode.MISSING_AUTH_DOMAIN */
  );
  const n = t.emulator ? EO(t, Oge) : `https://${e.config.authDomain}/${$ge}`, r = {
    apiKey: t.apiKey,
    appName: e.name,
    v: ap
  }, i = Mge.get(e.config.apiHost);
  i && (r.eid = i);
  const o = e._getFrameworks();
  return o.length && (r.fw = o.join(",")), `${n}?${Lv(r).slice(1)}`;
}
async function Nge(e) {
  const t = await Age(e), n = ec().gapi;
  return Ft(
    n,
    e,
    "internal-error"
    /* AuthErrorCode.INTERNAL_ERROR */
  ), t.open({
    where: document.body,
    url: kge(e),
    messageHandlersFilter: n.iframes.CROSS_ORIGIN_IFRAMES_FILTER,
    attributes: Pge,
    dontclear: !0
  }, (r) => new Promise(async (i, o) => {
    await r.restyle({
      // Prevent iframe from closing on mouse out.
      setHideOnLeave: !1
    });
    const a = gs(
      e,
      "network-request-failed"
      /* AuthErrorCode.NETWORK_REQUEST_FAILED */
    ), s = ec().setTimeout(() => {
      o(a);
    }, Rge.get());
    function c() {
      ec().clearTimeout(s), i(r);
    }
    r.ping(c).then(c, () => {
      o(a);
    });
  }));
}
/**
 * @license
 * Copyright 2020 Google LLC.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const Dge = {
  location: "yes",
  resizable: "yes",
  statusbar: "yes",
  toolbar: "no"
}, Lge = 500, jge = 600, Fge = "_blank", Vge = "http://localhost";
class DD {
  constructor(t) {
    this.window = t, this.associatedEvent = null;
  }
  close() {
    if (this.window)
      try {
        this.window.close();
      } catch {
      }
  }
}
function Bge(e, t, n, r = Lge, i = jge) {
  const o = Math.max((window.screen.availHeight - i) / 2, 0).toString(), a = Math.max((window.screen.availWidth - r) / 2, 0).toString();
  let s = "";
  const c = Object.assign(Object.assign({}, Dge), {
    width: r.toString(),
    height: i.toString(),
    top: o,
    left: a
  }), l = co().toLowerCase();
  n && (s = iU(l) ? Fge : n), nU(l) && (t = t || Vge, c.scrollbars = "yes");
  const u = Object.entries(c).reduce((f, [h, p]) => `${f}${h}=${p},`, "");
  if (che(l) && s !== "_self")
    return zge(t || "", s), new DD(null);
  const d = window.open(t || "", s, u);
  Ft(
    d,
    e,
    "popup-blocked"
    /* AuthErrorCode.POPUP_BLOCKED */
  );
  try {
    d.focus();
  } catch {
  }
  return new DD(d);
}
function zge(e, t) {
  const n = document.createElement("a");
  n.href = e, n.target = t;
  const r = document.createEvent("MouseEvent");
  r.initMouseEvent("click", !0, !0, window, 1, 0, 0, 0, 0, !1, !1, !1, !1, 1, null), n.dispatchEvent(r);
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const Hge = "__/auth/handler", Uge = "emulator/auth/handler", Wge = encodeURIComponent("fac");
async function LD(e, t, n, r, i, o) {
  Ft(
    e.config.authDomain,
    e,
    "auth-domain-config-required"
    /* AuthErrorCode.MISSING_AUTH_DOMAIN */
  ), Ft(
    e.config.apiKey,
    e,
    "invalid-api-key"
    /* AuthErrorCode.INVALID_API_KEY */
  );
  const a = {
    apiKey: e.config.apiKey,
    appName: e.name,
    authType: n,
    redirectUrl: r,
    v: ap,
    eventId: i
  };
  if (t instanceof Jw) {
    t.setDefaultLanguage(e.languageCode), a.providerId = t.providerId || "", lue(t.getCustomParameters()) || (a.customParameters = JSON.stringify(t.getCustomParameters()));
    for (const [u, d] of Object.entries(o || {}))
      a[u] = d;
  }
  if (t instanceof cp) {
    const u = t.getScopes().filter((d) => d !== "");
    u.length > 0 && (a.scopes = u.join(","));
  }
  e.tenantId && (a.tid = e.tenantId);
  const s = a;
  for (const u of Object.keys(s))
    s[u] === void 0 && delete s[u];
  const c = await e._getAppCheckToken(), l = c ? `#${Wge}=${encodeURIComponent(c)}` : "";
  return `${qge(e)}?${Lv(s).slice(1)}${l}`;
}
function qge({ config: e }) {
  return e.emulator ? EO(e, Uge) : `https://${e.authDomain}/${Hge}`;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const Z2 = "webStorageSupport";
class Gge {
  constructor() {
    this.eventManagers = {}, this.iframes = {}, this.originValidationPromises = {}, this._redirectPersistence = _U, this._completeRedirectFn = vge, this._overrideRedirectResult = gge;
  }
  // Wrapping in async even though we don't await anywhere in order
  // to make sure errors are raised as promise rejections
  async _openPopup(t, n, r, i) {
    var o;
    rl((o = this.eventManagers[t._key()]) === null || o === void 0 ? void 0 : o.manager, "_initialize() not called before _openPopup()");
    const a = await LD(t, n, r, $I(), i);
    return Bge(t, a, RO());
  }
  async _openRedirect(t, n, r, i) {
    await this._originValidation(t);
    const o = await LD(t, n, r, $I(), i);
    return Yhe(o), new Promise(() => {
    });
  }
  _initialize(t) {
    const n = t._key();
    if (this.eventManagers[n]) {
      const { manager: i, promise: o } = this.eventManagers[n];
      return i ? Promise.resolve(i) : (rl(o, "If manager is not set, promise should be"), o);
    }
    const r = this.initAndGetManager(t);
    return this.eventManagers[n] = { promise: r }, r.catch(() => {
      delete this.eventManagers[n];
    }), r;
  }
  async initAndGetManager(t) {
    const n = await Nge(t), r = new bge(t);
    return n.register("authEvent", (i) => (Ft(
      i == null ? void 0 : i.authEvent,
      t,
      "invalid-auth-event"
      /* AuthErrorCode.INVALID_AUTH_EVENT */
    ), {
      status: r.onEvent(i.authEvent) ? "ACK" : "ERROR"
      /* GapiOutcome.ERROR */
    }), gapi.iframes.CROSS_ORIGIN_IFRAMES_FILTER), this.eventManagers[t._key()] = { manager: r }, this.iframes[t._key()] = n, r;
  }
  _isIframeWebStorageSupported(t, n) {
    this.iframes[t._key()].send(Z2, { type: Z2 }, (i) => {
      var o;
      const a = (o = i == null ? void 0 : i[0]) === null || o === void 0 ? void 0 : o[Z2];
      a !== void 0 && n(!!a), Va(
        t,
        "internal-error"
        /* AuthErrorCode.INTERNAL_ERROR */
      );
    }, gapi.iframes.CROSS_ORIGIN_IFRAMES_FILTER);
  }
  _originValidation(t) {
    const n = t._key();
    return this.originValidationPromises[n] || (this.originValidationPromises[n] = Ege(t)), this.originValidationPromises[n];
  }
  get _shouldInitProactively() {
    return lU() || rU() || TO();
  }
}
const Kge = Gge;
var jD = "@firebase/auth", FD = "1.10.8";
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class Yge {
  constructor(t) {
    this.auth = t, this.internalListeners = /* @__PURE__ */ new Map();
  }
  getUid() {
    var t;
    return this.assertAuthConfigured(), ((t = this.auth.currentUser) === null || t === void 0 ? void 0 : t.uid) || null;
  }
  async getToken(t) {
    return this.assertAuthConfigured(), await this.auth._initializationPromise, this.auth.currentUser ? { accessToken: await this.auth.currentUser.getIdToken(t) } : null;
  }
  addAuthTokenListener(t) {
    if (this.assertAuthConfigured(), this.internalListeners.has(t))
      return;
    const n = this.auth.onIdTokenChanged((r) => {
      t((r == null ? void 0 : r.stsTokenManager.accessToken) || null);
    });
    this.internalListeners.set(t, n), this.updateProactiveRefresh();
  }
  removeAuthTokenListener(t) {
    this.assertAuthConfigured();
    const n = this.internalListeners.get(t);
    n && (this.internalListeners.delete(t), n(), this.updateProactiveRefresh());
  }
  assertAuthConfigured() {
    Ft(
      this.auth._initializationPromise,
      "dependent-sdk-initialized-before-auth"
      /* AuthErrorCode.DEPENDENT_SDK_INIT_BEFORE_AUTH */
    );
  }
  updateProactiveRefresh() {
    this.internalListeners.size > 0 ? this.auth._startProactiveRefresh() : this.auth._stopProactiveRefresh();
  }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function Xge(e) {
  switch (e) {
    case "Node":
      return "node";
    case "ReactNative":
      return "rn";
    case "Worker":
      return "webworker";
    case "Cordova":
      return "cordova";
    case "WebExtension":
      return "web-extension";
    default:
      return;
  }
}
function Qge(e) {
  Ss(new Fa(
    "auth",
    (t, { options: n }) => {
      const r = t.getProvider("app").getImmediate(), i = t.getProvider("heartbeat"), o = t.getProvider("app-check-internal"), { apiKey: a, authDomain: s } = r.options;
      Ft(a && !a.includes(":"), "invalid-api-key", { appName: r.name });
      const c = {
        apiKey: a,
        authDomain: s,
        clientPlatform: e,
        apiHost: "identitytoolkit.googleapis.com",
        tokenApiHost: "securetoken.googleapis.com",
        apiScheme: "https",
        sdkClientVersion: uU(e)
      }, l = new ghe(r, i, o, c);
      return Ehe(l, n), l;
    },
    "PUBLIC"
    /* ComponentType.PUBLIC */
  ).setInstantiationMode(
    "EXPLICIT"
    /* InstantiationMode.EXPLICIT */
  ).setInstanceCreatedCallback((t, n, r) => {
    t.getProvider(
      "auth-internal"
      /* _ComponentName.AUTH_INTERNAL */
    ).initialize();
  })), Ss(new Fa(
    "auth-internal",
    (t) => {
      const n = pl(t.getProvider(
        "auth"
        /* _ComponentName.AUTH */
      ).getImmediate());
      return ((r) => new Yge(r))(n);
    },
    "PRIVATE"
    /* ComponentType.PRIVATE */
  ).setInstantiationMode(
    "EXPLICIT"
    /* InstantiationMode.EXPLICIT */
  )), Jo(jD, FD, Xge(e)), Jo(jD, FD, "esm2017");
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const Jge = 5 * 60, Zge = pH("authIdTokenMaxAge") || Jge;
let VD = null;
const epe = (e) => async (t) => {
  const n = t && await t.getIdTokenResult(), r = n && ((/* @__PURE__ */ new Date()).getTime() - Date.parse(n.issuedAtTime)) / 1e3;
  if (r && r > Zge)
    return;
  const i = n == null ? void 0 : n.token;
  VD !== i && (VD = i, await fetch(e, {
    method: i ? "POST" : "DELETE",
    headers: i ? {
      Authorization: `Bearer ${i}`
    } : {}
  }));
};
function tpe(e = Kw()) {
  const t = gl(e, "auth");
  if (t.isInitialized())
    return t.getImmediate();
  const n = xhe(e, {
    popupRedirectResolver: Kge,
    persistence: [
      ige,
      qhe,
      _U
    ]
  }), r = pH("authTokenSyncURL");
  if (r && typeof isSecureContext == "boolean" && isSecureContext) {
    const o = new URL(r, location.origin);
    if (location.origin === o.origin) {
      const a = epe(o.toString());
      zhe(n, a, () => a(n.currentUser)), Bhe(n, (s) => a(s));
    }
  }
  const i = fH("auth");
  return i && hU(n, `http://${i}`), n;
}
function npe() {
  var e, t;
  return (t = (e = document.getElementsByTagName("head")) === null || e === void 0 ? void 0 : e[0]) !== null && t !== void 0 ? t : document;
}
phe({
  loadJS(e) {
    return new Promise((t, n) => {
      const r = document.createElement("script");
      r.setAttribute("src", e), r.onload = t, r.onerror = (i) => {
        const o = gs(
          "internal-error"
          /* AuthErrorCode.INTERNAL_ERROR */
        );
        o.customData = i, n(o);
      }, r.type = "text/javascript", r.charset = "UTF-8", npe().appendChild(r);
    });
  },
  gapiScript: "https://apis.google.com/js/api.js",
  recaptchaV2Script: "https://www.google.com/recaptcha/api.js",
  recaptchaEnterpriseScript: "https://www.google.com/recaptcha/enterprise.js?render="
});
Qge(
  "Browser"
  /* ClientPlatform.BROWSER */
);
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const rpe = "type.googleapis.com/google.protobuf.Int64Value", ipe = "type.googleapis.com/google.protobuf.UInt64Value";
function RU(e, t) {
  const n = {};
  for (const r in e)
    e.hasOwnProperty(r) && (n[r] = t(e[r]));
  return n;
}
function x_(e) {
  if (e == null)
    return null;
  if (e instanceof Number && (e = e.valueOf()), typeof e == "number" && isFinite(e) || e === !0 || e === !1 || Object.prototype.toString.call(e) === "[object String]")
    return e;
  if (e instanceof Date)
    return e.toISOString();
  if (Array.isArray(e))
    return e.map((t) => x_(t));
  if (typeof e == "function" || typeof e == "object")
    return RU(e, (t) => x_(t));
  throw new Error("Data cannot be encoded in JSON: " + e);
}
function lg(e) {
  if (e == null)
    return e;
  if (e["@type"])
    switch (e["@type"]) {
      case rpe:
      case ipe: {
        const t = Number(e.value);
        if (isNaN(t))
          throw new Error("Data cannot be decoded from JSON: " + e);
        return t;
      }
      default:
        throw new Error("Data cannot be decoded from JSON: " + e);
    }
  return Array.isArray(e) ? e.map((t) => lg(t)) : typeof e == "function" || typeof e == "object" ? RU(e, (t) => lg(t)) : e;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const PO = "functions";
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const BD = {
  OK: "ok",
  CANCELLED: "cancelled",
  UNKNOWN: "unknown",
  INVALID_ARGUMENT: "invalid-argument",
  DEADLINE_EXCEEDED: "deadline-exceeded",
  NOT_FOUND: "not-found",
  ALREADY_EXISTS: "already-exists",
  PERMISSION_DENIED: "permission-denied",
  UNAUTHENTICATED: "unauthenticated",
  RESOURCE_EXHAUSTED: "resource-exhausted",
  FAILED_PRECONDITION: "failed-precondition",
  ABORTED: "aborted",
  OUT_OF_RANGE: "out-of-range",
  UNIMPLEMENTED: "unimplemented",
  INTERNAL: "internal",
  UNAVAILABLE: "unavailable",
  DATA_LOSS: "data-loss"
};
class Xo extends Ua {
  /**
   * Constructs a new instance of the `FunctionsError` class.
   */
  constructor(t, n, r) {
    super(`${PO}/${t}`, n || ""), this.details = r, Object.setPrototypeOf(this, Xo.prototype);
  }
}
function ope(e) {
  if (e >= 200 && e < 300)
    return "ok";
  switch (e) {
    case 0:
      return "internal";
    case 400:
      return "invalid-argument";
    case 401:
      return "unauthenticated";
    case 403:
      return "permission-denied";
    case 404:
      return "not-found";
    case 409:
      return "aborted";
    case 429:
      return "resource-exhausted";
    case 499:
      return "cancelled";
    case 500:
      return "internal";
    case 501:
      return "unimplemented";
    case 503:
      return "unavailable";
    case 504:
      return "deadline-exceeded";
  }
  return "unknown";
}
function E_(e, t) {
  let n = ope(e), r = n, i;
  try {
    const o = t && t.error;
    if (o) {
      const a = o.status;
      if (typeof a == "string") {
        if (!BD[a])
          return new Xo("internal", "internal");
        n = BD[a], r = a;
      }
      const s = o.message;
      typeof s == "string" && (r = s), i = o.details, i !== void 0 && (i = lg(i));
    }
  } catch {
  }
  return n === "ok" ? null : new Xo(n, r, i);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class ape {
  constructor(t, n, r, i) {
    this.app = t, this.auth = null, this.messaging = null, this.appCheck = null, this.serverAppAppCheckToken = null, Eo(t) && t.settings.appCheckToken && (this.serverAppAppCheckToken = t.settings.appCheckToken), this.auth = n.getImmediate({ optional: !0 }), this.messaging = r.getImmediate({
      optional: !0
    }), this.auth || n.get().then((o) => this.auth = o, () => {
    }), this.messaging || r.get().then((o) => this.messaging = o, () => {
    }), this.appCheck || i == null || i.get().then((o) => this.appCheck = o, () => {
    });
  }
  async getAuthToken() {
    if (this.auth)
      try {
        const t = await this.auth.getToken();
        return t == null ? void 0 : t.accessToken;
      } catch {
        return;
      }
  }
  async getMessagingToken() {
    if (!(!this.messaging || !("Notification" in self) || Notification.permission !== "granted"))
      try {
        return await this.messaging.getToken();
      } catch {
        return;
      }
  }
  async getAppCheckToken(t) {
    if (this.serverAppAppCheckToken)
      return this.serverAppAppCheckToken;
    if (this.appCheck) {
      const n = t ? await this.appCheck.getLimitedUseToken() : await this.appCheck.getToken();
      return n.error ? null : n.token;
    }
    return null;
  }
  async getContext(t) {
    const n = await this.getAuthToken(), r = await this.getMessagingToken(), i = await this.getAppCheckToken(t);
    return { authToken: n, messagingToken: r, appCheckToken: i };
  }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const MI = "us-central1", spe = /^data: (.*?)(?:\n|$)/;
function cpe(e) {
  let t = null;
  return {
    promise: new Promise((n, r) => {
      t = setTimeout(() => {
        r(new Xo("deadline-exceeded", "deadline-exceeded"));
      }, e);
    }),
    cancel: () => {
      t && clearTimeout(t);
    }
  };
}
class lpe {
  /**
   * Creates a new Functions service for the given app.
   * @param app - The FirebaseApp to use.
   */
  constructor(t, n, r, i, o = MI, a = (...s) => fetch(...s)) {
    this.app = t, this.fetchImpl = a, this.emulatorOrigin = null, this.contextProvider = new ape(t, n, r, i), this.cancelAllRequests = new Promise((s) => {
      this.deleteService = () => Promise.resolve(s());
    });
    try {
      const s = new URL(o);
      this.customDomain = s.origin + (s.pathname === "/" ? "" : s.pathname), this.region = MI;
    } catch {
      this.customDomain = null, this.region = o;
    }
  }
  _delete() {
    return this.deleteService();
  }
  /**
   * Returns the URL for a callable with the given name.
   * @param name - The name of the callable.
   * @internal
   */
  _url(t) {
    const n = this.app.options.projectId;
    return this.emulatorOrigin !== null ? `${this.emulatorOrigin}/${n}/${this.region}/${t}` : this.customDomain !== null ? `${this.customDomain}/${t}` : `https://${this.region}-${n}.cloudfunctions.net/${t}`;
  }
}
function upe(e, t, n) {
  const r = ku(t);
  e.emulatorOrigin = `http${r ? "s" : ""}://${t}:${n}`, r && (qw(e.emulatorOrigin), pO("Functions", !0));
}
function dpe(e, t, n) {
  const r = (i) => hpe(e, t, i, n || {});
  return r.stream = (i, o) => ppe(e, t, i, o), r;
}
async function fpe(e, t, n, r) {
  n["Content-Type"] = "application/json";
  let i;
  try {
    i = await r(e, {
      method: "POST",
      body: JSON.stringify(t),
      headers: n
    });
  } catch {
    return {
      status: 0,
      json: null
    };
  }
  let o = null;
  try {
    o = await i.json();
  } catch {
  }
  return {
    status: i.status,
    json: o
  };
}
async function $U(e, t) {
  const n = {}, r = await e.contextProvider.getContext(t.limitedUseAppCheckTokens);
  return r.authToken && (n.Authorization = "Bearer " + r.authToken), r.messagingToken && (n["Firebase-Instance-ID-Token"] = r.messagingToken), r.appCheckToken !== null && (n["X-Firebase-AppCheck"] = r.appCheckToken), n;
}
function hpe(e, t, n, r) {
  const i = e._url(t);
  return gpe(e, i, n, r);
}
async function gpe(e, t, n, r) {
  n = x_(n);
  const i = { data: n }, o = await $U(e, r), a = r.timeout || 7e4, s = cpe(a), c = await Promise.race([
    fpe(t, i, o, e.fetchImpl),
    s.promise,
    e.cancelAllRequests
  ]);
  if (s.cancel(), !c)
    throw new Xo("cancelled", "Firebase Functions instance was deleted.");
  const l = E_(c.status, c.json);
  if (l)
    throw l;
  if (!c.json)
    throw new Xo("internal", "Response is not valid JSON object.");
  let u = c.json.data;
  if (typeof u > "u" && (u = c.json.result), typeof u > "u")
    throw new Xo("internal", "Response is missing data field.");
  return { data: lg(u) };
}
function ppe(e, t, n, r) {
  const i = e._url(t);
  return mpe(e, i, n, r || {});
}
async function mpe(e, t, n, r) {
  var i;
  n = x_(n);
  const o = { data: n }, a = await $U(e, r);
  a["Content-Type"] = "application/json", a.Accept = "text/event-stream";
  let s;
  try {
    s = await e.fetchImpl(t, {
      method: "POST",
      body: JSON.stringify(o),
      headers: a,
      signal: r == null ? void 0 : r.signal
    });
  } catch (h) {
    if (h instanceof Error && h.name === "AbortError") {
      const g = new Xo("cancelled", "Request was cancelled.");
      return {
        data: Promise.reject(g),
        stream: {
          [Symbol.asyncIterator]() {
            return {
              next() {
                return Promise.reject(g);
              }
            };
          }
        }
      };
    }
    const p = E_(0, null);
    return {
      data: Promise.reject(p),
      // Return an empty async iterator
      stream: {
        [Symbol.asyncIterator]() {
          return {
            next() {
              return Promise.reject(p);
            }
          };
        }
      }
    };
  }
  let c, l;
  const u = new Promise((h, p) => {
    c = h, l = p;
  });
  (i = r == null ? void 0 : r.signal) === null || i === void 0 || i.addEventListener("abort", () => {
    const h = new Xo("cancelled", "Request was cancelled.");
    l(h);
  });
  const d = s.body.getReader(), f = vpe(d, c, l, r == null ? void 0 : r.signal);
  return {
    stream: {
      [Symbol.asyncIterator]() {
        const h = f.getReader();
        return {
          async next() {
            const { value: p, done: g } = await h.read();
            return { value: p, done: g };
          },
          async return() {
            return await h.cancel(), { done: !0, value: void 0 };
          }
        };
      }
    },
    data: u
  };
}
function vpe(e, t, n, r) {
  const i = (a, s) => {
    const c = a.match(spe);
    if (!c)
      return;
    const l = c[1];
    try {
      const u = JSON.parse(l);
      if ("result" in u) {
        t(lg(u.result));
        return;
      }
      if ("message" in u) {
        s.enqueue(lg(u.message));
        return;
      }
      if ("error" in u) {
        const d = E_(0, u);
        s.error(d), n(d);
        return;
      }
    } catch (u) {
      if (u instanceof Xo) {
        s.error(u), n(u);
        return;
      }
    }
  }, o = new TextDecoder();
  return new ReadableStream({
    start(a) {
      let s = "";
      return c();
      async function c() {
        if (r != null && r.aborted) {
          const l = new Xo("cancelled", "Request was cancelled");
          return a.error(l), n(l), Promise.resolve();
        }
        try {
          const { value: l, done: u } = await e.read();
          if (u) {
            s.trim() && i(s.trim(), a), a.close();
            return;
          }
          if (r != null && r.aborted) {
            const f = new Xo("cancelled", "Request was cancelled");
            a.error(f), n(f), await e.cancel();
            return;
          }
          s += o.decode(l, { stream: !0 });
          const d = s.split(`
`);
          s = d.pop() || "";
          for (const f of d)
            f.trim() && i(f.trim(), a);
          return c();
        } catch (l) {
          const u = l instanceof Xo ? l : E_(0, null);
          a.error(u), n(u);
        }
      }
    },
    cancel() {
      return e.cancel();
    }
  });
}
const zD = "@firebase/functions", HD = "0.12.9";
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const ype = "auth-internal", bpe = "app-check-internal", _pe = "messaging-internal";
function Spe(e) {
  const t = (n, { instanceIdentifier: r }) => {
    const i = n.getProvider("app").getImmediate(), o = n.getProvider(ype), a = n.getProvider(_pe), s = n.getProvider(bpe);
    return new lpe(i, o, a, s, r);
  };
  Ss(new Fa(
    PO,
    t,
    "PUBLIC"
    /* ComponentType.PUBLIC */
  ).setMultipleInstances(!0)), Jo(zD, HD, e), Jo(zD, HD, "esm2017");
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function OU(e = Kw(), t = MI) {
  const r = gl($r(e), PO).getImmediate({
    identifier: t
  }), i = hH("functions");
  return i && PU(r, ...i), r;
}
function PU(e, t, n) {
  upe($r(e), t, n);
}
function Bv(e, t, n) {
  return dpe($r(e), t, n);
}
Spe();
var UD = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
/** @license
Copyright The Closure Library Authors.
SPDX-License-Identifier: Apache-2.0
*/
var ou, MU;
(function() {
  var e;
  /** @license
  
   Copyright The Closure Library Authors.
   SPDX-License-Identifier: Apache-2.0
  */
  function t(x, C) {
    function E() {
    }
    E.prototype = C.prototype, x.D = C.prototype, x.prototype = new E(), x.prototype.constructor = x, x.C = function(R, A, O) {
      for (var $ = Array(arguments.length - 2), N = 2; N < arguments.length; N++)
        $[N - 2] = arguments[N];
      return C.prototype[A].apply(R, $);
    };
  }
  function n() {
    this.blockSize = -1;
  }
  function r() {
    this.blockSize = -1, this.blockSize = 64, this.g = Array(4), this.B = Array(this.blockSize), this.o = this.h = 0, this.s();
  }
  t(r, n), r.prototype.s = function() {
    this.g[0] = 1732584193, this.g[1] = 4023233417, this.g[2] = 2562383102, this.g[3] = 271733878, this.o = this.h = 0;
  };
  function i(x, C, E) {
    E || (E = 0);
    var R = Array(16);
    if (typeof C == "string")
      for (var A = 0; 16 > A; ++A)
        R[A] = C.charCodeAt(E++) | C.charCodeAt(E++) << 8 | C.charCodeAt(E++) << 16 | C.charCodeAt(E++) << 24;
    else
      for (A = 0; 16 > A; ++A)
        R[A] = C[E++] | C[E++] << 8 | C[E++] << 16 | C[E++] << 24;
    C = x.g[0], E = x.g[1], A = x.g[2];
    var O = x.g[3], $ = C + (O ^ E & (A ^ O)) + R[0] + 3614090360 & 4294967295;
    C = E + ($ << 7 & 4294967295 | $ >>> 25), $ = O + (A ^ C & (E ^ A)) + R[1] + 3905402710 & 4294967295, O = C + ($ << 12 & 4294967295 | $ >>> 20), $ = A + (E ^ O & (C ^ E)) + R[2] + 606105819 & 4294967295, A = O + ($ << 17 & 4294967295 | $ >>> 15), $ = E + (C ^ A & (O ^ C)) + R[3] + 3250441966 & 4294967295, E = A + ($ << 22 & 4294967295 | $ >>> 10), $ = C + (O ^ E & (A ^ O)) + R[4] + 4118548399 & 4294967295, C = E + ($ << 7 & 4294967295 | $ >>> 25), $ = O + (A ^ C & (E ^ A)) + R[5] + 1200080426 & 4294967295, O = C + ($ << 12 & 4294967295 | $ >>> 20), $ = A + (E ^ O & (C ^ E)) + R[6] + 2821735955 & 4294967295, A = O + ($ << 17 & 4294967295 | $ >>> 15), $ = E + (C ^ A & (O ^ C)) + R[7] + 4249261313 & 4294967295, E = A + ($ << 22 & 4294967295 | $ >>> 10), $ = C + (O ^ E & (A ^ O)) + R[8] + 1770035416 & 4294967295, C = E + ($ << 7 & 4294967295 | $ >>> 25), $ = O + (A ^ C & (E ^ A)) + R[9] + 2336552879 & 4294967295, O = C + ($ << 12 & 4294967295 | $ >>> 20), $ = A + (E ^ O & (C ^ E)) + R[10] + 4294925233 & 4294967295, A = O + ($ << 17 & 4294967295 | $ >>> 15), $ = E + (C ^ A & (O ^ C)) + R[11] + 2304563134 & 4294967295, E = A + ($ << 22 & 4294967295 | $ >>> 10), $ = C + (O ^ E & (A ^ O)) + R[12] + 1804603682 & 4294967295, C = E + ($ << 7 & 4294967295 | $ >>> 25), $ = O + (A ^ C & (E ^ A)) + R[13] + 4254626195 & 4294967295, O = C + ($ << 12 & 4294967295 | $ >>> 20), $ = A + (E ^ O & (C ^ E)) + R[14] + 2792965006 & 4294967295, A = O + ($ << 17 & 4294967295 | $ >>> 15), $ = E + (C ^ A & (O ^ C)) + R[15] + 1236535329 & 4294967295, E = A + ($ << 22 & 4294967295 | $ >>> 10), $ = C + (A ^ O & (E ^ A)) + R[1] + 4129170786 & 4294967295, C = E + ($ << 5 & 4294967295 | $ >>> 27), $ = O + (E ^ A & (C ^ E)) + R[6] + 3225465664 & 4294967295, O = C + ($ << 9 & 4294967295 | $ >>> 23), $ = A + (C ^ E & (O ^ C)) + R[11] + 643717713 & 4294967295, A = O + ($ << 14 & 4294967295 | $ >>> 18), $ = E + (O ^ C & (A ^ O)) + R[0] + 3921069994 & 4294967295, E = A + ($ << 20 & 4294967295 | $ >>> 12), $ = C + (A ^ O & (E ^ A)) + R[5] + 3593408605 & 4294967295, C = E + ($ << 5 & 4294967295 | $ >>> 27), $ = O + (E ^ A & (C ^ E)) + R[10] + 38016083 & 4294967295, O = C + ($ << 9 & 4294967295 | $ >>> 23), $ = A + (C ^ E & (O ^ C)) + R[15] + 3634488961 & 4294967295, A = O + ($ << 14 & 4294967295 | $ >>> 18), $ = E + (O ^ C & (A ^ O)) + R[4] + 3889429448 & 4294967295, E = A + ($ << 20 & 4294967295 | $ >>> 12), $ = C + (A ^ O & (E ^ A)) + R[9] + 568446438 & 4294967295, C = E + ($ << 5 & 4294967295 | $ >>> 27), $ = O + (E ^ A & (C ^ E)) + R[14] + 3275163606 & 4294967295, O = C + ($ << 9 & 4294967295 | $ >>> 23), $ = A + (C ^ E & (O ^ C)) + R[3] + 4107603335 & 4294967295, A = O + ($ << 14 & 4294967295 | $ >>> 18), $ = E + (O ^ C & (A ^ O)) + R[8] + 1163531501 & 4294967295, E = A + ($ << 20 & 4294967295 | $ >>> 12), $ = C + (A ^ O & (E ^ A)) + R[13] + 2850285829 & 4294967295, C = E + ($ << 5 & 4294967295 | $ >>> 27), $ = O + (E ^ A & (C ^ E)) + R[2] + 4243563512 & 4294967295, O = C + ($ << 9 & 4294967295 | $ >>> 23), $ = A + (C ^ E & (O ^ C)) + R[7] + 1735328473 & 4294967295, A = O + ($ << 14 & 4294967295 | $ >>> 18), $ = E + (O ^ C & (A ^ O)) + R[12] + 2368359562 & 4294967295, E = A + ($ << 20 & 4294967295 | $ >>> 12), $ = C + (E ^ A ^ O) + R[5] + 4294588738 & 4294967295, C = E + ($ << 4 & 4294967295 | $ >>> 28), $ = O + (C ^ E ^ A) + R[8] + 2272392833 & 4294967295, O = C + ($ << 11 & 4294967295 | $ >>> 21), $ = A + (O ^ C ^ E) + R[11] + 1839030562 & 4294967295, A = O + ($ << 16 & 4294967295 | $ >>> 16), $ = E + (A ^ O ^ C) + R[14] + 4259657740 & 4294967295, E = A + ($ << 23 & 4294967295 | $ >>> 9), $ = C + (E ^ A ^ O) + R[1] + 2763975236 & 4294967295, C = E + ($ << 4 & 4294967295 | $ >>> 28), $ = O + (C ^ E ^ A) + R[4] + 1272893353 & 4294967295, O = C + ($ << 11 & 4294967295 | $ >>> 21), $ = A + (O ^ C ^ E) + R[7] + 4139469664 & 4294967295, A = O + ($ << 16 & 4294967295 | $ >>> 16), $ = E + (A ^ O ^ C) + R[10] + 3200236656 & 4294967295, E = A + ($ << 23 & 4294967295 | $ >>> 9), $ = C + (E ^ A ^ O) + R[13] + 681279174 & 4294967295, C = E + ($ << 4 & 4294967295 | $ >>> 28), $ = O + (C ^ E ^ A) + R[0] + 3936430074 & 4294967295, O = C + ($ << 11 & 4294967295 | $ >>> 21), $ = A + (O ^ C ^ E) + R[3] + 3572445317 & 4294967295, A = O + ($ << 16 & 4294967295 | $ >>> 16), $ = E + (A ^ O ^ C) + R[6] + 76029189 & 4294967295, E = A + ($ << 23 & 4294967295 | $ >>> 9), $ = C + (E ^ A ^ O) + R[9] + 3654602809 & 4294967295, C = E + ($ << 4 & 4294967295 | $ >>> 28), $ = O + (C ^ E ^ A) + R[12] + 3873151461 & 4294967295, O = C + ($ << 11 & 4294967295 | $ >>> 21), $ = A + (O ^ C ^ E) + R[15] + 530742520 & 4294967295, A = O + ($ << 16 & 4294967295 | $ >>> 16), $ = E + (A ^ O ^ C) + R[2] + 3299628645 & 4294967295, E = A + ($ << 23 & 4294967295 | $ >>> 9), $ = C + (A ^ (E | ~O)) + R[0] + 4096336452 & 4294967295, C = E + ($ << 6 & 4294967295 | $ >>> 26), $ = O + (E ^ (C | ~A)) + R[7] + 1126891415 & 4294967295, O = C + ($ << 10 & 4294967295 | $ >>> 22), $ = A + (C ^ (O | ~E)) + R[14] + 2878612391 & 4294967295, A = O + ($ << 15 & 4294967295 | $ >>> 17), $ = E + (O ^ (A | ~C)) + R[5] + 4237533241 & 4294967295, E = A + ($ << 21 & 4294967295 | $ >>> 11), $ = C + (A ^ (E | ~O)) + R[12] + 1700485571 & 4294967295, C = E + ($ << 6 & 4294967295 | $ >>> 26), $ = O + (E ^ (C | ~A)) + R[3] + 2399980690 & 4294967295, O = C + ($ << 10 & 4294967295 | $ >>> 22), $ = A + (C ^ (O | ~E)) + R[10] + 4293915773 & 4294967295, A = O + ($ << 15 & 4294967295 | $ >>> 17), $ = E + (O ^ (A | ~C)) + R[1] + 2240044497 & 4294967295, E = A + ($ << 21 & 4294967295 | $ >>> 11), $ = C + (A ^ (E | ~O)) + R[8] + 1873313359 & 4294967295, C = E + ($ << 6 & 4294967295 | $ >>> 26), $ = O + (E ^ (C | ~A)) + R[15] + 4264355552 & 4294967295, O = C + ($ << 10 & 4294967295 | $ >>> 22), $ = A + (C ^ (O | ~E)) + R[6] + 2734768916 & 4294967295, A = O + ($ << 15 & 4294967295 | $ >>> 17), $ = E + (O ^ (A | ~C)) + R[13] + 1309151649 & 4294967295, E = A + ($ << 21 & 4294967295 | $ >>> 11), $ = C + (A ^ (E | ~O)) + R[4] + 4149444226 & 4294967295, C = E + ($ << 6 & 4294967295 | $ >>> 26), $ = O + (E ^ (C | ~A)) + R[11] + 3174756917 & 4294967295, O = C + ($ << 10 & 4294967295 | $ >>> 22), $ = A + (C ^ (O | ~E)) + R[2] + 718787259 & 4294967295, A = O + ($ << 15 & 4294967295 | $ >>> 17), $ = E + (O ^ (A | ~C)) + R[9] + 3951481745 & 4294967295, x.g[0] = x.g[0] + C & 4294967295, x.g[1] = x.g[1] + (A + ($ << 21 & 4294967295 | $ >>> 11)) & 4294967295, x.g[2] = x.g[2] + A & 4294967295, x.g[3] = x.g[3] + O & 4294967295;
  }
  r.prototype.u = function(x, C) {
    C === void 0 && (C = x.length);
    for (var E = C - this.blockSize, R = this.B, A = this.h, O = 0; O < C; ) {
      if (A == 0)
        for (; O <= E; )
          i(this, x, O), O += this.blockSize;
      if (typeof x == "string") {
        for (; O < C; )
          if (R[A++] = x.charCodeAt(O++), A == this.blockSize) {
            i(this, R), A = 0;
            break;
          }
      } else
        for (; O < C; )
          if (R[A++] = x[O++], A == this.blockSize) {
            i(this, R), A = 0;
            break;
          }
    }
    this.h = A, this.o += C;
  }, r.prototype.v = function() {
    var x = Array((56 > this.h ? this.blockSize : 2 * this.blockSize) - this.h);
    x[0] = 128;
    for (var C = 1; C < x.length - 8; ++C)
      x[C] = 0;
    var E = 8 * this.o;
    for (C = x.length - 8; C < x.length; ++C)
      x[C] = E & 255, E /= 256;
    for (this.u(x), x = Array(16), C = E = 0; 4 > C; ++C)
      for (var R = 0; 32 > R; R += 8)
        x[E++] = this.g[C] >>> R & 255;
    return x;
  };
  function o(x, C) {
    var E = s;
    return Object.prototype.hasOwnProperty.call(E, x) ? E[x] : E[x] = C(x);
  }
  function a(x, C) {
    this.h = C;
    for (var E = [], R = !0, A = x.length - 1; 0 <= A; A--) {
      var O = x[A] | 0;
      R && O == C || (E[A] = O, R = !1);
    }
    this.g = E;
  }
  var s = {};
  function c(x) {
    return -128 <= x && 128 > x ? o(x, function(C) {
      return new a([C | 0], 0 > C ? -1 : 0);
    }) : new a([x | 0], 0 > x ? -1 : 0);
  }
  function l(x) {
    if (isNaN(x) || !isFinite(x))
      return d;
    if (0 > x)
      return m(l(-x));
    for (var C = [], E = 1, R = 0; x >= E; R++)
      C[R] = x / E | 0, E *= 4294967296;
    return new a(C, 0);
  }
  function u(x, C) {
    if (x.length == 0)
      throw Error("number format error: empty string");
    if (C = C || 10, 2 > C || 36 < C)
      throw Error("radix out of range: " + C);
    if (x.charAt(0) == "-")
      return m(u(x.substring(1), C));
    if (0 <= x.indexOf("-"))
      throw Error('number format error: interior "-" character');
    for (var E = l(Math.pow(C, 8)), R = d, A = 0; A < x.length; A += 8) {
      var O = Math.min(8, x.length - A), $ = parseInt(x.substring(A, A + O), C);
      8 > O ? (O = l(Math.pow(C, O)), R = R.j(O).add(l($))) : (R = R.j(E), R = R.add(l($)));
    }
    return R;
  }
  var d = c(0), f = c(1), h = c(16777216);
  e = a.prototype, e.m = function() {
    if (g(this))
      return -m(this).m();
    for (var x = 0, C = 1, E = 0; E < this.g.length; E++) {
      var R = this.i(E);
      x += (0 <= R ? R : 4294967296 + R) * C, C *= 4294967296;
    }
    return x;
  }, e.toString = function(x) {
    if (x = x || 10, 2 > x || 36 < x)
      throw Error("radix out of range: " + x);
    if (p(this))
      return "0";
    if (g(this))
      return "-" + m(this).toString(x);
    for (var C = l(Math.pow(x, 6)), E = this, R = ""; ; ) {
      var A = _(E, C).g;
      E = v(E, A.j(C));
      var O = ((0 < E.g.length ? E.g[0] : E.h) >>> 0).toString(x);
      if (E = A, p(E))
        return O + R;
      for (; 6 > O.length; )
        O = "0" + O;
      R = O + R;
    }
  }, e.i = function(x) {
    return 0 > x ? 0 : x < this.g.length ? this.g[x] : this.h;
  };
  function p(x) {
    if (x.h != 0)
      return !1;
    for (var C = 0; C < x.g.length; C++)
      if (x.g[C] != 0)
        return !1;
    return !0;
  }
  function g(x) {
    return x.h == -1;
  }
  e.l = function(x) {
    return x = v(this, x), g(x) ? -1 : p(x) ? 0 : 1;
  };
  function m(x) {
    for (var C = x.g.length, E = [], R = 0; R < C; R++)
      E[R] = ~x.g[R];
    return new a(E, ~x.h).add(f);
  }
  e.abs = function() {
    return g(this) ? m(this) : this;
  }, e.add = function(x) {
    for (var C = Math.max(this.g.length, x.g.length), E = [], R = 0, A = 0; A <= C; A++) {
      var O = R + (this.i(A) & 65535) + (x.i(A) & 65535), $ = (O >>> 16) + (this.i(A) >>> 16) + (x.i(A) >>> 16);
      R = $ >>> 16, O &= 65535, $ &= 65535, E[A] = $ << 16 | O;
    }
    return new a(E, E[E.length - 1] & -2147483648 ? -1 : 0);
  };
  function v(x, C) {
    return x.add(m(C));
  }
  e.j = function(x) {
    if (p(this) || p(x))
      return d;
    if (g(this))
      return g(x) ? m(this).j(m(x)) : m(m(this).j(x));
    if (g(x))
      return m(this.j(m(x)));
    if (0 > this.l(h) && 0 > x.l(h))
      return l(this.m() * x.m());
    for (var C = this.g.length + x.g.length, E = [], R = 0; R < 2 * C; R++)
      E[R] = 0;
    for (R = 0; R < this.g.length; R++)
      for (var A = 0; A < x.g.length; A++) {
        var O = this.i(R) >>> 16, $ = this.i(R) & 65535, N = x.i(A) >>> 16, z = x.i(A) & 65535;
        E[2 * R + 2 * A] += $ * z, y(E, 2 * R + 2 * A), E[2 * R + 2 * A + 1] += O * z, y(E, 2 * R + 2 * A + 1), E[2 * R + 2 * A + 1] += $ * N, y(E, 2 * R + 2 * A + 1), E[2 * R + 2 * A + 2] += O * N, y(E, 2 * R + 2 * A + 2);
      }
    for (R = 0; R < C; R++)
      E[R] = E[2 * R + 1] << 16 | E[2 * R];
    for (R = C; R < 2 * C; R++)
      E[R] = 0;
    return new a(E, 0);
  };
  function y(x, C) {
    for (; (x[C] & 65535) != x[C]; )
      x[C + 1] += x[C] >>> 16, x[C] &= 65535, C++;
  }
  function S(x, C) {
    this.g = x, this.h = C;
  }
  function _(x, C) {
    if (p(C))
      throw Error("division by zero");
    if (p(x))
      return new S(d, d);
    if (g(x))
      return C = _(m(x), C), new S(m(C.g), m(C.h));
    if (g(C))
      return C = _(x, m(C)), new S(m(C.g), C.h);
    if (30 < x.g.length) {
      if (g(x) || g(C))
        throw Error("slowDivide_ only works with positive integers.");
      for (var E = f, R = C; 0 >= R.l(x); )
        E = w(E), R = w(R);
      var A = T(E, 1), O = T(R, 1);
      for (R = T(R, 2), E = T(E, 2); !p(R); ) {
        var $ = O.add(R);
        0 >= $.l(x) && (A = A.add(E), O = $), R = T(R, 1), E = T(E, 1);
      }
      return C = v(x, A.j(C)), new S(A, C);
    }
    for (A = d; 0 <= x.l(C); ) {
      for (E = Math.max(1, Math.floor(x.m() / C.m())), R = Math.ceil(Math.log(E) / Math.LN2), R = 48 >= R ? 1 : Math.pow(2, R - 48), O = l(E), $ = O.j(C); g($) || 0 < $.l(x); )
        E -= R, O = l(E), $ = O.j(C);
      p(O) && (O = f), A = A.add(O), x = v(x, $);
    }
    return new S(A, x);
  }
  e.A = function(x) {
    return _(this, x).h;
  }, e.and = function(x) {
    for (var C = Math.max(this.g.length, x.g.length), E = [], R = 0; R < C; R++)
      E[R] = this.i(R) & x.i(R);
    return new a(E, this.h & x.h);
  }, e.or = function(x) {
    for (var C = Math.max(this.g.length, x.g.length), E = [], R = 0; R < C; R++)
      E[R] = this.i(R) | x.i(R);
    return new a(E, this.h | x.h);
  }, e.xor = function(x) {
    for (var C = Math.max(this.g.length, x.g.length), E = [], R = 0; R < C; R++)
      E[R] = this.i(R) ^ x.i(R);
    return new a(E, this.h ^ x.h);
  };
  function w(x) {
    for (var C = x.g.length + 1, E = [], R = 0; R < C; R++)
      E[R] = x.i(R) << 1 | x.i(R - 1) >>> 31;
    return new a(E, x.h);
  }
  function T(x, C) {
    var E = C >> 5;
    C %= 32;
    for (var R = x.g.length - E, A = [], O = 0; O < R; O++)
      A[O] = 0 < C ? x.i(O + E) >>> C | x.i(O + E + 1) << 32 - C : x.i(O + E);
    return new a(A, x.h);
  }
  r.prototype.digest = r.prototype.v, r.prototype.reset = r.prototype.s, r.prototype.update = r.prototype.u, MU = r, a.prototype.add = a.prototype.add, a.prototype.multiply = a.prototype.j, a.prototype.modulo = a.prototype.A, a.prototype.compare = a.prototype.l, a.prototype.toNumber = a.prototype.m, a.prototype.toString = a.prototype.toString, a.prototype.getBits = a.prototype.i, a.fromNumber = l, a.fromString = u, ou = a;
}).apply(typeof UD < "u" ? UD : typeof self < "u" ? self : typeof window < "u" ? window : {});
var pb = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
/** @license
Copyright The Closure Library Authors.
SPDX-License-Identifier: Apache-2.0
*/
var kU, jm, NU, $1, kI, DU, LU, jU;
(function() {
  var e, t = typeof Object.defineProperties == "function" ? Object.defineProperty : function(b, P, L) {
    return b == Array.prototype || b == Object.prototype || (b[P] = L.value), b;
  };
  function n(b) {
    b = [typeof globalThis == "object" && globalThis, b, typeof window == "object" && window, typeof self == "object" && self, typeof pb == "object" && pb];
    for (var P = 0; P < b.length; ++P) {
      var L = b[P];
      if (L && L.Math == Math)
        return L;
    }
    throw Error("Cannot find global object");
  }
  var r = n(this);
  function i(b, P) {
    if (P)
      e: {
        var L = r;
        b = b.split(".");
        for (var G = 0; G < b.length - 1; G++) {
          var le = b[G];
          if (!(le in L))
            break e;
          L = L[le];
        }
        b = b[b.length - 1], G = L[b], P = P(G), P != G && P != null && t(L, b, { configurable: !0, writable: !0, value: P });
      }
  }
  function o(b, P) {
    b instanceof String && (b += "");
    var L = 0, G = !1, le = { next: function() {
      if (!G && L < b.length) {
        var ve = L++;
        return { value: P(ve, b[ve]), done: !1 };
      }
      return G = !0, { done: !0, value: void 0 };
    } };
    return le[Symbol.iterator] = function() {
      return le;
    }, le;
  }
  i("Array.prototype.values", function(b) {
    return b || function() {
      return o(this, function(P, L) {
        return L;
      });
    };
  });
  /** @license
  
   Copyright The Closure Library Authors.
   SPDX-License-Identifier: Apache-2.0
  */
  var a = a || {}, s = this || self;
  function c(b) {
    var P = typeof b;
    return P = P != "object" ? P : b ? Array.isArray(b) ? "array" : P : "null", P == "array" || P == "object" && typeof b.length == "number";
  }
  function l(b) {
    var P = typeof b;
    return P == "object" && b != null || P == "function";
  }
  function u(b, P, L) {
    return b.call.apply(b.bind, arguments);
  }
  function d(b, P, L) {
    if (!b)
      throw Error();
    if (2 < arguments.length) {
      var G = Array.prototype.slice.call(arguments, 2);
      return function() {
        var le = Array.prototype.slice.call(arguments);
        return Array.prototype.unshift.apply(le, G), b.apply(P, le);
      };
    }
    return function() {
      return b.apply(P, arguments);
    };
  }
  function f(b, P, L) {
    return f = Function.prototype.bind && Function.prototype.bind.toString().indexOf("native code") != -1 ? u : d, f.apply(null, arguments);
  }
  function h(b, P) {
    var L = Array.prototype.slice.call(arguments, 1);
    return function() {
      var G = L.slice();
      return G.push.apply(G, arguments), b.apply(this, G);
    };
  }
  function p(b, P) {
    function L() {
    }
    L.prototype = P.prototype, b.aa = P.prototype, b.prototype = new L(), b.prototype.constructor = b, b.Qb = function(G, le, ve) {
      for (var nt = Array(arguments.length - 2), Jn = 2; Jn < arguments.length; Jn++)
        nt[Jn - 2] = arguments[Jn];
      return P.prototype[le].apply(G, nt);
    };
  }
  function g(b) {
    const P = b.length;
    if (0 < P) {
      const L = Array(P);
      for (let G = 0; G < P; G++)
        L[G] = b[G];
      return L;
    }
    return [];
  }
  function m(b, P) {
    for (let L = 1; L < arguments.length; L++) {
      const G = arguments[L];
      if (c(G)) {
        const le = b.length || 0, ve = G.length || 0;
        b.length = le + ve;
        for (let nt = 0; nt < ve; nt++)
          b[le + nt] = G[nt];
      } else
        b.push(G);
    }
  }
  class v {
    constructor(P, L) {
      this.i = P, this.j = L, this.h = 0, this.g = null;
    }
    get() {
      let P;
      return 0 < this.h ? (this.h--, P = this.g, this.g = P.next, P.next = null) : P = this.i(), P;
    }
  }
  function y(b) {
    return /^[\s\xa0]*$/.test(b);
  }
  function S() {
    var b = s.navigator;
    return b && (b = b.userAgent) ? b : "";
  }
  function _(b) {
    return _[" "](b), b;
  }
  _[" "] = function() {
  };
  var w = S().indexOf("Gecko") != -1 && !(S().toLowerCase().indexOf("webkit") != -1 && S().indexOf("Edge") == -1) && !(S().indexOf("Trident") != -1 || S().indexOf("MSIE") != -1) && S().indexOf("Edge") == -1;
  function T(b, P, L) {
    for (const G in b)
      P.call(L, b[G], G, b);
  }
  function x(b, P) {
    for (const L in b)
      P.call(void 0, b[L], L, b);
  }
  function C(b) {
    const P = {};
    for (const L in b)
      P[L] = b[L];
    return P;
  }
  const E = "constructor hasOwnProperty isPrototypeOf propertyIsEnumerable toLocaleString toString valueOf".split(" ");
  function R(b, P) {
    let L, G;
    for (let le = 1; le < arguments.length; le++) {
      G = arguments[le];
      for (L in G)
        b[L] = G[L];
      for (let ve = 0; ve < E.length; ve++)
        L = E[ve], Object.prototype.hasOwnProperty.call(G, L) && (b[L] = G[L]);
    }
  }
  function A(b) {
    var P = 1;
    b = b.split(":");
    const L = [];
    for (; 0 < P && b.length; )
      L.push(b.shift()), P--;
    return b.length && L.push(b.join(":")), L;
  }
  function O(b) {
    s.setTimeout(() => {
      throw b;
    }, 0);
  }
  function $() {
    var b = j;
    let P = null;
    return b.g && (P = b.g, b.g = b.g.next, b.g || (b.h = null), P.next = null), P;
  }
  class N {
    constructor() {
      this.h = this.g = null;
    }
    add(P, L) {
      const G = z.get();
      G.set(P, L), this.h ? this.h.next = G : this.g = G, this.h = G;
    }
  }
  var z = new v(() => new k(), (b) => b.reset());
  class k {
    constructor() {
      this.next = this.g = this.h = null;
    }
    set(P, L) {
      this.h = P, this.g = L, this.next = null;
    }
    reset() {
      this.next = this.g = this.h = null;
    }
  }
  let F, V = !1, j = new N(), B = () => {
    const b = s.Promise.resolve(void 0);
    F = () => {
      b.then(U);
    };
  };
  var U = () => {
    for (var b; b = $(); ) {
      try {
        b.h.call(b.g);
      } catch (L) {
        O(L);
      }
      var P = z;
      P.j(b), 100 > P.h && (P.h++, b.next = P.g, P.g = b);
    }
    V = !1;
  };
  function Q() {
    this.s = this.s, this.C = this.C;
  }
  Q.prototype.s = !1, Q.prototype.ma = function() {
    this.s || (this.s = !0, this.N());
  }, Q.prototype.N = function() {
    if (this.C)
      for (; this.C.length; )
        this.C.shift()();
  };
  function K(b, P) {
    this.type = b, this.g = this.target = P, this.defaultPrevented = !1;
  }
  K.prototype.h = function() {
    this.defaultPrevented = !0;
  };
  var q = function() {
    if (!s.addEventListener || !Object.defineProperty)
      return !1;
    var b = !1, P = Object.defineProperty({}, "passive", { get: function() {
      b = !0;
    } });
    try {
      const L = () => {
      };
      s.addEventListener("test", L, P), s.removeEventListener("test", L, P);
    } catch {
    }
    return b;
  }();
  function X(b, P) {
    if (K.call(this, b ? b.type : ""), this.relatedTarget = this.g = this.target = null, this.button = this.screenY = this.screenX = this.clientY = this.clientX = 0, this.key = "", this.metaKey = this.shiftKey = this.altKey = this.ctrlKey = !1, this.state = null, this.pointerId = 0, this.pointerType = "", this.i = null, b) {
      var L = this.type = b.type, G = b.changedTouches && b.changedTouches.length ? b.changedTouches[0] : null;
      if (this.target = b.target || b.srcElement, this.g = P, P = b.relatedTarget) {
        if (w) {
          e: {
            try {
              _(P.nodeName);
              var le = !0;
              break e;
            } catch {
            }
            le = !1;
          }
          le || (P = null);
        }
      } else
        L == "mouseover" ? P = b.fromElement : L == "mouseout" && (P = b.toElement);
      this.relatedTarget = P, G ? (this.clientX = G.clientX !== void 0 ? G.clientX : G.pageX, this.clientY = G.clientY !== void 0 ? G.clientY : G.pageY, this.screenX = G.screenX || 0, this.screenY = G.screenY || 0) : (this.clientX = b.clientX !== void 0 ? b.clientX : b.pageX, this.clientY = b.clientY !== void 0 ? b.clientY : b.pageY, this.screenX = b.screenX || 0, this.screenY = b.screenY || 0), this.button = b.button, this.key = b.key || "", this.ctrlKey = b.ctrlKey, this.altKey = b.altKey, this.shiftKey = b.shiftKey, this.metaKey = b.metaKey, this.pointerId = b.pointerId || 0, this.pointerType = typeof b.pointerType == "string" ? b.pointerType : ie[b.pointerType] || "", this.state = b.state, this.i = b, b.defaultPrevented && X.aa.h.call(this);
    }
  }
  p(X, K);
  var ie = { 2: "touch", 3: "pen", 4: "mouse" };
  X.prototype.h = function() {
    X.aa.h.call(this);
    var b = this.i;
    b.preventDefault ? b.preventDefault() : b.returnValue = !1;
  };
  var te = "closure_listenable_" + (1e6 * Math.random() | 0), J = 0;
  function Y(b, P, L, G, le) {
    this.listener = b, this.proxy = null, this.src = P, this.type = L, this.capture = !!G, this.ha = le, this.key = ++J, this.da = this.fa = !1;
  }
  function ee(b) {
    b.da = !0, b.listener = null, b.proxy = null, b.src = null, b.ha = null;
  }
  function Z(b) {
    this.src = b, this.g = {}, this.h = 0;
  }
  Z.prototype.add = function(b, P, L, G, le) {
    var ve = b.toString();
    b = this.g[ve], b || (b = this.g[ve] = [], this.h++);
    var nt = oe(b, P, G, le);
    return -1 < nt ? (P = b[nt], L || (P.fa = !1)) : (P = new Y(P, this.src, ve, !!G, le), P.fa = L, b.push(P)), P;
  };
  function H(b, P) {
    var L = P.type;
    if (L in b.g) {
      var G = b.g[L], le = Array.prototype.indexOf.call(G, P, void 0), ve;
      (ve = 0 <= le) && Array.prototype.splice.call(G, le, 1), ve && (ee(P), b.g[L].length == 0 && (delete b.g[L], b.h--));
    }
  }
  function oe(b, P, L, G) {
    for (var le = 0; le < b.length; ++le) {
      var ve = b[le];
      if (!ve.da && ve.listener == P && ve.capture == !!L && ve.ha == G)
        return le;
    }
    return -1;
  }
  var W = "closure_lm_" + (1e6 * Math.random() | 0), se = {};
  function ce(b, P, L, G, le) {
    if (G && G.once)
      return ue(b, P, L, G, le);
    if (Array.isArray(P)) {
      for (var ve = 0; ve < P.length; ve++)
        ce(b, P[ve], L, G, le);
      return null;
    }
    return L = Ve(L), b && b[te] ? b.K(P, L, l(G) ? !!G.capture : !!G, le) : ge(b, P, L, !1, G, le);
  }
  function ge(b, P, L, G, le, ve) {
    if (!P)
      throw Error("Invalid event type");
    var nt = l(le) ? !!le.capture : !!le, Jn = be(b);
    if (Jn || (b[W] = Jn = new Z(b)), L = Jn.add(P, L, G, nt, ve), L.proxy)
      return L;
    if (G = he(), L.proxy = G, G.src = b, G.listener = L, b.addEventListener)
      q || (le = nt), le === void 0 && (le = !1), b.addEventListener(P.toString(), G, le);
    else if (b.attachEvent)
      b.attachEvent(Oe(P.toString()), G);
    else if (b.addListener && b.removeListener)
      b.addListener(G);
    else
      throw Error("addEventListener and attachEvent are unavailable.");
    return L;
  }
  function he() {
    function b(L) {
      return P.call(b.src, b.listener, L);
    }
    const P = de;
    return b;
  }
  function ue(b, P, L, G, le) {
    if (Array.isArray(P)) {
      for (var ve = 0; ve < P.length; ve++)
        ue(b, P[ve], L, G, le);
      return null;
    }
    return L = Ve(L), b && b[te] ? b.L(P, L, l(G) ? !!G.capture : !!G, le) : ge(b, P, L, !0, G, le);
  }
  function Ee(b, P, L, G, le) {
    if (Array.isArray(P))
      for (var ve = 0; ve < P.length; ve++)
        Ee(b, P[ve], L, G, le);
    else
      G = l(G) ? !!G.capture : !!G, L = Ve(L), b && b[te] ? (b = b.i, P = String(P).toString(), P in b.g && (ve = b.g[P], L = oe(ve, L, G, le), -1 < L && (ee(ve[L]), Array.prototype.splice.call(ve, L, 1), ve.length == 0 && (delete b.g[P], b.h--)))) : b && (b = be(b)) && (P = b.g[P.toString()], b = -1, P && (b = oe(P, L, G, le)), (L = -1 < b ? P[b] : null) && pe(L));
  }
  function pe(b) {
    if (typeof b != "number" && b && !b.da) {
      var P = b.src;
      if (P && P[te])
        H(P.i, b);
      else {
        var L = b.type, G = b.proxy;
        P.removeEventListener ? P.removeEventListener(L, G, b.capture) : P.detachEvent ? P.detachEvent(Oe(L), G) : P.addListener && P.removeListener && P.removeListener(G), (L = be(P)) ? (H(L, b), L.h == 0 && (L.src = null, P[W] = null)) : ee(b);
      }
    }
  }
  function Oe(b) {
    return b in se ? se[b] : se[b] = "on" + b;
  }
  function de(b, P) {
    if (b.da)
      b = !0;
    else {
      P = new X(P, this);
      var L = b.listener, G = b.ha || b.src;
      b.fa && pe(b), b = L.call(G, P);
    }
    return b;
  }
  function be(b) {
    return b = b[W], b instanceof Z ? b : null;
  }
  var Ie = "__closure_events_fn_" + (1e9 * Math.random() >>> 0);
  function Ve(b) {
    return typeof b == "function" ? b : (b[Ie] || (b[Ie] = function(P) {
      return b.handleEvent(P);
    }), b[Ie]);
  }
  function Fe() {
    Q.call(this), this.i = new Z(this), this.M = this, this.F = null;
  }
  p(Fe, Q), Fe.prototype[te] = !0, Fe.prototype.removeEventListener = function(b, P, L, G) {
    Ee(this, b, P, L, G);
  };
  function Pe(b, P) {
    var L, G = b.F;
    if (G)
      for (L = []; G; G = G.F)
        L.push(G);
    if (b = b.M, G = P.type || P, typeof P == "string")
      P = new K(P, b);
    else if (P instanceof K)
      P.target = P.target || b;
    else {
      var le = P;
      P = new K(G, b), R(P, le);
    }
    if (le = !0, L)
      for (var ve = L.length - 1; 0 <= ve; ve--) {
        var nt = P.g = L[ve];
        le = ot(nt, G, !0, P) && le;
      }
    if (nt = P.g = b, le = ot(nt, G, !0, P) && le, le = ot(nt, G, !1, P) && le, L)
      for (ve = 0; ve < L.length; ve++)
        nt = P.g = L[ve], le = ot(nt, G, !1, P) && le;
  }
  Fe.prototype.N = function() {
    if (Fe.aa.N.call(this), this.i) {
      var b = this.i, P;
      for (P in b.g) {
        for (var L = b.g[P], G = 0; G < L.length; G++)
          ee(L[G]);
        delete b.g[P], b.h--;
      }
    }
    this.F = null;
  }, Fe.prototype.K = function(b, P, L, G) {
    return this.i.add(String(b), P, !1, L, G);
  }, Fe.prototype.L = function(b, P, L, G) {
    return this.i.add(String(b), P, !0, L, G);
  };
  function ot(b, P, L, G) {
    if (P = b.i.g[String(P)], !P)
      return !0;
    P = P.concat();
    for (var le = !0, ve = 0; ve < P.length; ++ve) {
      var nt = P[ve];
      if (nt && !nt.da && nt.capture == L) {
        var Jn = nt.listener, Ni = nt.ha || nt.src;
        nt.fa && H(b.i, nt), le = Jn.call(Ni, G) !== !1 && le;
      }
    }
    return le && !G.defaultPrevented;
  }
  function dt(b, P, L) {
    if (typeof b == "function")
      L && (b = f(b, L));
    else if (b && typeof b.handleEvent == "function")
      b = f(b.handleEvent, b);
    else
      throw Error("Invalid listener argument");
    return 2147483647 < Number(P) ? -1 : s.setTimeout(b, P || 0);
  }
  function ft(b) {
    b.g = dt(() => {
      b.g = null, b.i && (b.i = !1, ft(b));
    }, b.l);
    const P = b.h;
    b.h = null, b.m.apply(null, P);
  }
  class wt extends Q {
    constructor(P, L) {
      super(), this.m = P, this.l = L, this.h = null, this.i = !1, this.g = null;
    }
    j(P) {
      this.h = arguments, this.g ? this.i = !0 : ft(this);
    }
    N() {
      super.N(), this.g && (s.clearTimeout(this.g), this.g = null, this.i = !1, this.h = null);
    }
  }
  function Ge(b) {
    Q.call(this), this.h = b, this.g = {};
  }
  p(Ge, Q);
  var at = [];
  function Nt(b) {
    T(b.g, function(P, L) {
      this.g.hasOwnProperty(L) && pe(P);
    }, b), b.g = {};
  }
  Ge.prototype.N = function() {
    Ge.aa.N.call(this), Nt(this);
  }, Ge.prototype.handleEvent = function() {
    throw Error("EventHandler.handleEvent not implemented");
  };
  var zt = s.JSON.stringify, kt = s.JSON.parse, Ct = class {
    stringify(b) {
      return s.JSON.stringify(b, void 0);
    }
    parse(b) {
      return s.JSON.parse(b, void 0);
    }
  };
  function yt() {
  }
  yt.prototype.h = null;
  function Mn(b) {
    return b.h || (b.h = b.i());
  }
  function Pt() {
  }
  var Ze = { OPEN: "a", kb: "b", Ja: "c", wb: "d" };
  function Le() {
    K.call(this, "d");
  }
  p(Le, K);
  function rt() {
    K.call(this, "c");
  }
  p(rt, K);
  var ut = {}, vt = null;
  function We() {
    return vt = vt || new Fe();
  }
  ut.La = "serverreachability";
  function et(b) {
    K.call(this, ut.La, b);
  }
  p(et, K);
  function Ne(b) {
    const P = We();
    Pe(P, new et(P));
  }
  ut.STAT_EVENT = "statevent";
  function Yt(b, P) {
    K.call(this, ut.STAT_EVENT, b), this.stat = P;
  }
  p(Yt, K);
  function Ht(b) {
    const P = We();
    Pe(P, new Yt(P, b));
  }
  ut.Ma = "timingevent";
  function Be(b, P) {
    K.call(this, ut.Ma, b), this.size = P;
  }
  p(Be, K);
  function ze(b, P) {
    if (typeof b != "function")
      throw Error("Fn must not be null and must be a function");
    return s.setTimeout(function() {
      b();
    }, P);
  }
  function it() {
    this.g = !0;
  }
  it.prototype.xa = function() {
    this.g = !1;
  };
  function lt(b, P, L, G, le, ve) {
    b.info(function() {
      if (b.g)
        if (ve)
          for (var nt = "", Jn = ve.split("&"), Ni = 0; Ni < Jn.length; Ni++) {
            var kn = Jn[Ni].split("=");
            if (1 < kn.length) {
              var Yi = kn[0];
              kn = kn[1];
              var Xi = Yi.split("_");
              nt = 2 <= Xi.length && Xi[1] == "type" ? nt + (Yi + "=" + kn + "&") : nt + (Yi + "=redacted&");
            }
          }
        else
          nt = null;
      else
        nt = ve;
      return "XMLHTTP REQ (" + G + ") [attempt " + le + "]: " + P + `
` + L + `
` + nt;
    });
  }
  function Tt(b, P, L, G, le, ve, nt) {
    b.info(function() {
      return "XMLHTTP RESP (" + G + ") [ attempt " + le + "]: " + P + `
` + L + `
` + ve + " " + nt;
    });
  }
  function jt(b, P, L, G) {
    b.info(function() {
      return "XMLHTTP TEXT (" + P + "): " + _e(b, L) + (G ? " " + G : "");
    });
  }
  function ne(b, P) {
    b.info(function() {
      return "TIMEOUT: " + P;
    });
  }
  it.prototype.info = function() {
  };
  function _e(b, P) {
    if (!b.g)
      return P;
    if (!P)
      return null;
    try {
      var L = JSON.parse(P);
      if (L) {
        for (b = 0; b < L.length; b++)
          if (Array.isArray(L[b])) {
            var G = L[b];
            if (!(2 > G.length)) {
              var le = G[1];
              if (Array.isArray(le) && !(1 > le.length)) {
                var ve = le[0];
                if (ve != "noop" && ve != "stop" && ve != "close")
                  for (var nt = 1; nt < le.length; nt++)
                    le[nt] = "";
              }
            }
          }
      }
      return zt(L);
    } catch {
      return P;
    }
  }
  var $e = { NO_ERROR: 0, gb: 1, tb: 2, sb: 3, nb: 4, rb: 5, ub: 6, Ia: 7, TIMEOUT: 8, xb: 9 }, qe = { lb: "complete", Hb: "success", Ja: "error", Ia: "abort", zb: "ready", Ab: "readystatechange", TIMEOUT: "timeout", vb: "incrementaldata", yb: "progress", ob: "downloadprogress", Pb: "uploadprogress" }, xt;
  function bt() {
  }
  p(bt, yt), bt.prototype.g = function() {
    return new XMLHttpRequest();
  }, bt.prototype.i = function() {
    return {};
  }, xt = new bt();
  function st(b, P, L, G) {
    this.j = b, this.i = P, this.l = L, this.R = G || 1, this.U = new Ge(this), this.I = 45e3, this.H = null, this.o = !1, this.m = this.A = this.v = this.L = this.F = this.S = this.B = null, this.D = [], this.g = null, this.C = 0, this.s = this.u = null, this.X = -1, this.J = !1, this.O = 0, this.M = null, this.W = this.K = this.T = this.P = !1, this.h = new Rt();
  }
  function Rt() {
    this.i = null, this.g = "", this.h = !1;
  }
  var Ke = {}, ke = {};
  function Xe(b, P, L) {
    b.L = 1, b.v = ni(Jt(P)), b.m = L, b.P = !0, ct(b, null);
  }
  function ct(b, P) {
    b.F = Date.now(), It(b), b.A = Jt(b.v);
    var L = b.A, G = b.R;
    Array.isArray(G) || (G = [String(G)]), Yf(L.i, "t", G), b.C = 0, L = b.j.J, b.h = new Rt(), b.g = gN(b.j, L ? P : null, !b.m), 0 < b.O && (b.M = new wt(f(b.Y, b, b.g), b.O)), P = b.U, L = b.g, G = b.ca;
    var le = "readystatechange";
    Array.isArray(le) || (le && (at[0] = le.toString()), le = at);
    for (var ve = 0; ve < le.length; ve++) {
      var nt = ce(L, le[ve], G || P.handleEvent, !1, P.h || P);
      if (!nt)
        break;
      P.g[nt.key] = nt;
    }
    P = b.H ? C(b.H) : {}, b.m ? (b.u || (b.u = "POST"), P["Content-Type"] = "application/x-www-form-urlencoded", b.g.ea(
      b.A,
      b.u,
      b.m,
      P
    )) : (b.u = "GET", b.g.ea(b.A, b.u, null, P)), Ne(), lt(b.i, b.u, b.A, b.l, b.R, b.m);
  }
  st.prototype.ca = function(b) {
    b = b.target;
    const P = this.M;
    P && Ec(b) == 3 ? P.j() : this.Y(b);
  }, st.prototype.Y = function(b) {
    try {
      if (b == this.g)
        e: {
          const Xi = Ec(this.g);
          var P = this.g.Ba();
          const Qf = this.g.Z();
          if (!(3 > Xi) && (Xi != 3 || this.g && (this.h.h || this.g.oa() || rN(this.g)))) {
            this.J || Xi != 4 || P == 7 || (P == 8 || 0 >= Qf ? Ne(3) : Ne(2)), gr(this);
            var L = this.g.Z();
            this.X = L;
            t:
              if (Ue(this)) {
                var G = rN(this.g);
                b = "";
                var le = G.length, ve = Ec(this.g) == 4;
                if (!this.h.i) {
                  if (typeof TextDecoder > "u") {
                    Cn(this), Gn(this);
                    var nt = "";
                    break t;
                  }
                  this.h.i = new s.TextDecoder();
                }
                for (P = 0; P < le; P++)
                  this.h.h = !0, b += this.h.i.decode(G[P], { stream: !(ve && P == le - 1) });
                G.length = 0, this.h.g += b, this.C = 0, nt = this.h.g;
              } else
                nt = this.g.oa();
            if (this.o = L == 200, Tt(this.i, this.u, this.A, this.l, this.R, Xi, L), this.o) {
              if (this.T && !this.K) {
                t: {
                  if (this.g) {
                    var Jn, Ni = this.g;
                    if ((Jn = Ni.g ? Ni.g.getResponseHeader("X-HTTP-Initial-Response") : null) && !y(Jn)) {
                      var kn = Jn;
                      break t;
                    }
                  }
                  kn = null;
                }
                if (L = kn)
                  jt(this.i, this.l, L, "Initial handshake response via X-HTTP-Initial-Response"), this.K = !0, Fr(this, L);
                else {
                  this.o = !1, this.s = 3, Ht(12), Cn(this), Gn(this);
                  break e;
                }
              }
              if (this.P) {
                L = !0;
                let Ja;
                for (; !this.J && this.C < nt.length; )
                  if (Ja = Dt(this, nt), Ja == ke) {
                    Xi == 4 && (this.s = 4, Ht(14), L = !1), jt(this.i, this.l, null, "[Incomplete Response]");
                    break;
                  } else if (Ja == Ke) {
                    this.s = 4, Ht(15), jt(this.i, this.l, nt, "[Invalid Chunk]"), L = !1;
                    break;
                  } else
                    jt(this.i, this.l, Ja, null), Fr(this, Ja);
                if (Ue(this) && this.C != 0 && (this.h.g = this.h.g.slice(this.C), this.C = 0), Xi != 4 || nt.length != 0 || this.h.h || (this.s = 1, Ht(16), L = !1), this.o = this.o && L, !L)
                  jt(this.i, this.l, nt, "[Invalid Chunked Response]"), Cn(this), Gn(this);
                else if (0 < nt.length && !this.W) {
                  this.W = !0;
                  var Yi = this.j;
                  Yi.g == this && Yi.ba && !Yi.M && (Yi.j.info("Great, no buffering proxy detected. Bytes received: " + nt.length), R2(Yi), Yi.M = !0, Ht(11));
                }
              } else
                jt(this.i, this.l, nt, null), Fr(this, nt);
              Xi == 4 && Cn(this), this.o && !this.J && (Xi == 4 ? uN(this.j, this) : (this.o = !1, It(this)));
            } else
              Ase(this.g), L == 400 && 0 < nt.indexOf("Unknown SID") ? (this.s = 3, Ht(12)) : (this.s = 0, Ht(13)), Cn(this), Gn(this);
          }
        }
    } catch {
    } finally {
    }
  };
  function Ue(b) {
    return b.g ? b.u == "GET" && b.L != 2 && b.j.Ca : !1;
  }
  function Dt(b, P) {
    var L = b.C, G = P.indexOf(`
`, L);
    return G == -1 ? ke : (L = Number(P.substring(L, G)), isNaN(L) ? Ke : (G += 1, G + L > P.length ? ke : (P = P.slice(G, G + L), b.C = G + L, P)));
  }
  st.prototype.cancel = function() {
    this.J = !0, Cn(this);
  };
  function It(b) {
    b.S = Date.now() + b.I, wn(b, b.I);
  }
  function wn(b, P) {
    if (b.B != null)
      throw Error("WatchDog timer not null");
    b.B = ze(f(b.ba, b), P);
  }
  function gr(b) {
    b.B && (s.clearTimeout(b.B), b.B = null);
  }
  st.prototype.ba = function() {
    this.B = null;
    const b = Date.now();
    0 <= b - this.S ? (ne(this.i, this.A), this.L != 2 && (Ne(), Ht(17)), Cn(this), this.s = 2, Gn(this)) : wn(this, this.S - b);
  };
  function Gn(b) {
    b.j.G == 0 || b.J || uN(b.j, b);
  }
  function Cn(b) {
    gr(b);
    var P = b.M;
    P && typeof P.ma == "function" && P.ma(), b.M = null, Nt(b.U), b.g && (P = b.g, b.g = null, P.abort(), P.ma());
  }
  function Fr(b, P) {
    try {
      var L = b.j;
      if (L.G != 0 && (L.g == b || Er(L.h, b))) {
        if (!b.K && Er(L.h, b) && L.G == 3) {
          try {
            var G = L.Da.g.parse(P);
          } catch {
            G = null;
          }
          if (Array.isArray(G) && G.length == 3) {
            var le = G;
            if (le[0] == 0) {
              e:
                if (!L.u) {
                  if (L.g)
                    if (L.g.F + 3e3 < b.F)
                      ub(L), cb(L);
                    else
                      break e;
                  A2(L), Ht(18);
                }
            } else
              L.za = le[1], 0 < L.za - L.T && 37500 > le[2] && L.F && L.v == 0 && !L.C && (L.C = ze(f(L.Za, L), 6e3));
            if (1 >= Yr(L.h) && L.ca) {
              try {
                L.ca();
              } catch {
              }
              L.ca = void 0;
            }
          } else
            td(L, 11);
        } else if ((b.K || L.g == b) && ub(L), !y(P))
          for (le = L.Da.g.parse(P), P = 0; P < le.length; P++) {
            let kn = le[P];
            if (L.T = kn[0], kn = kn[1], L.G == 2)
              if (kn[0] == "c") {
                L.K = kn[1], L.ia = kn[2];
                const Yi = kn[3];
                Yi != null && (L.la = Yi, L.j.info("VER=" + L.la));
                const Xi = kn[4];
                Xi != null && (L.Aa = Xi, L.j.info("SVER=" + L.Aa));
                const Qf = kn[5];
                Qf != null && typeof Qf == "number" && 0 < Qf && (G = 1.5 * Qf, L.L = G, L.j.info("backChannelRequestTimeoutMs_=" + G)), G = L;
                const Ja = b.g;
                if (Ja) {
                  const fb = Ja.g ? Ja.g.getResponseHeader("X-Client-Wire-Protocol") : null;
                  if (fb) {
                    var ve = G.h;
                    ve.g || fb.indexOf("spdy") == -1 && fb.indexOf("quic") == -1 && fb.indexOf("h2") == -1 || (ve.j = ve.l, ve.g = /* @__PURE__ */ new Set(), ve.h && (Xr(ve, ve.h), ve.h = null));
                  }
                  if (G.D) {
                    const $2 = Ja.g ? Ja.g.getResponseHeader("X-HTTP-Session-Id") : null;
                    $2 && (G.ya = $2, ln(G.I, G.D, $2));
                  }
                }
                L.G = 3, L.l && L.l.ua(), L.ba && (L.R = Date.now() - b.F, L.j.info("Handshake RTT: " + L.R + "ms")), G = L;
                var nt = b;
                if (G.qa = hN(G, G.J ? G.ia : null, G.W), nt.K) {
                  Ci(G.h, nt);
                  var Jn = nt, Ni = G.L;
                  Ni && (Jn.I = Ni), Jn.B && (gr(Jn), It(Jn)), G.g = nt;
                } else
                  cN(G);
                0 < L.i.length && lb(L);
              } else
                kn[0] != "stop" && kn[0] != "close" || td(L, 7);
            else
              L.G == 3 && (kn[0] == "stop" || kn[0] == "close" ? kn[0] == "stop" ? td(L, 7) : I2(L) : kn[0] != "noop" && L.l && L.l.ta(kn), L.v = 0);
          }
      }
      Ne(4);
    } catch {
    }
  }
  var Kr = class {
    constructor(b, P) {
      this.g = b, this.map = P;
    }
  };
  function pr(b) {
    this.l = b || 10, s.PerformanceNavigationTiming ? (b = s.performance.getEntriesByType("navigation"), b = 0 < b.length && (b[0].nextHopProtocol == "hq" || b[0].nextHopProtocol == "h2")) : b = !!(s.chrome && s.chrome.loadTimes && s.chrome.loadTimes() && s.chrome.loadTimes().wasFetchedViaSpdy), this.j = b ? this.l : 1, this.g = null, 1 < this.j && (this.g = /* @__PURE__ */ new Set()), this.h = null, this.i = [];
  }
  function xr(b) {
    return b.h ? !0 : b.g ? b.g.size >= b.j : !1;
  }
  function Yr(b) {
    return b.h ? 1 : b.g ? b.g.size : 0;
  }
  function Er(b, P) {
    return b.h ? b.h == P : b.g ? b.g.has(P) : !1;
  }
  function Xr(b, P) {
    b.g ? b.g.add(P) : b.h = P;
  }
  function Ci(b, P) {
    b.h && b.h == P ? b.h = null : b.g && b.g.has(P) && b.g.delete(P);
  }
  pr.prototype.cancel = function() {
    if (this.i = Ti(this), this.h)
      this.h.cancel(), this.h = null;
    else if (this.g && this.g.size !== 0) {
      for (const b of this.g.values())
        b.cancel();
      this.g.clear();
    }
  };
  function Ti(b) {
    if (b.h != null)
      return b.i.concat(b.h.D);
    if (b.g != null && b.g.size !== 0) {
      let P = b.i;
      for (const L of b.g.values())
        P = P.concat(L.D);
      return P;
    }
    return g(b.i);
  }
  function Mi(b) {
    if (b.V && typeof b.V == "function")
      return b.V();
    if (typeof Map < "u" && b instanceof Map || typeof Set < "u" && b instanceof Set)
      return Array.from(b.values());
    if (typeof b == "string")
      return b.split("");
    if (c(b)) {
      for (var P = [], L = b.length, G = 0; G < L; G++)
        P.push(b[G]);
      return P;
    }
    P = [], L = 0;
    for (G in b)
      P[L++] = b[G];
    return P;
  }
  function Qn(b) {
    if (b.na && typeof b.na == "function")
      return b.na();
    if (!b.V || typeof b.V != "function") {
      if (typeof Map < "u" && b instanceof Map)
        return Array.from(b.keys());
      if (!(typeof Set < "u" && b instanceof Set)) {
        if (c(b) || typeof b == "string") {
          var P = [];
          b = b.length;
          for (var L = 0; L < b; L++)
            P.push(L);
          return P;
        }
        P = [], L = 0;
        for (const G in b)
          P[L++] = G;
        return P;
      }
    }
  }
  function Xt(b, P) {
    if (b.forEach && typeof b.forEach == "function")
      b.forEach(P, void 0);
    else if (c(b) || typeof b == "string")
      Array.prototype.forEach.call(b, P, void 0);
    else
      for (var L = Qn(b), G = Mi(b), le = G.length, ve = 0; ve < le; ve++)
        P.call(void 0, G[ve], L && L[ve], b);
  }
  var Vt = RegExp("^(?:([^:/?#.]+):)?(?://(?:([^\\\\/?#]*)@)?([^\\\\/?#]*?)(?::([0-9]+))?(?=[\\\\/?#]|$))?([^?#]+)?(?:\\?([^#]*))?(?:#([\\s\\S]*))?$");
  function tn(b, P) {
    if (b) {
      b = b.split("&");
      for (var L = 0; L < b.length; L++) {
        var G = b[L].indexOf("="), le = null;
        if (0 <= G) {
          var ve = b[L].substring(0, G);
          le = b[L].substring(G + 1);
        } else
          ve = b[L];
        P(ve, le ? decodeURIComponent(le.replace(/\+/g, " ")) : "");
      }
    }
  }
  function Qt(b) {
    if (this.g = this.o = this.j = "", this.s = null, this.m = this.l = "", this.h = !1, b instanceof Qt) {
      this.h = b.h, vn(this, b.j), this.o = b.o, this.g = b.g, Cr(this, b.s), this.l = b.l;
      var P = b.i, L = new jo();
      L.i = P.i, P.g && (L.g = new Map(P.g), L.h = P.h), pi(this, L), this.m = b.m;
    } else
      b && (P = String(b).match(Vt)) ? (this.h = !1, vn(this, P[1] || "", !0), this.o = ri(P[2] || ""), this.g = ri(P[3] || "", !0), Cr(this, P[4]), this.l = ri(P[5] || "", !0), pi(this, P[6] || "", !0), this.m = ri(P[7] || "")) : (this.h = !1, this.i = new jo(null, this.h));
  }
  Qt.prototype.toString = function() {
    var b = [], P = this.j;
    P && b.push(Ki(P, po, !0), ":");
    var L = this.g;
    return (L || P == "file") && (b.push("//"), (P = this.o) && b.push(Ki(P, po, !0), "@"), b.push(encodeURIComponent(String(L)).replace(/%25([0-9a-fA-F]{2})/g, "%$1")), L = this.s, L != null && b.push(":", String(L))), (L = this.l) && (this.g && L.charAt(0) != "/" && b.push("/"), b.push(Ki(L, L.charAt(0) == "/" ? Lo : mo, !0))), (L = this.i.toString()) && b.push("?", L), (L = this.m) && b.push("#", Ki(L, wl)), b.join("");
  };
  function Jt(b) {
    return new Qt(b);
  }
  function vn(b, P, L) {
    b.j = L ? ri(P, !0) : P, b.j && (b.j = b.j.replace(/:$/, ""));
  }
  function Cr(b, P) {
    if (P) {
      if (P = Number(P), isNaN(P) || 0 > P)
        throw Error("Bad port number " + P);
      b.s = P;
    } else
      b.s = null;
  }
  function pi(b, P, L) {
    P instanceof jo ? (b.i = P, Zp(b.i, b.h)) : (L || (P = Ki(P, Kf)), b.i = new jo(P, b.h));
  }
  function ln(b, P, L) {
    b.i.set(P, L);
  }
  function ni(b) {
    return ln(b, "zx", Math.floor(2147483648 * Math.random()).toString(36) + Math.abs(Math.floor(2147483648 * Math.random()) ^ Date.now()).toString(36)), b;
  }
  function ri(b, P) {
    return b ? P ? decodeURI(b.replace(/%25/g, "%2525")) : decodeURIComponent(b) : "";
  }
  function Ki(b, P, L) {
    return typeof b == "string" ? (b = encodeURI(b).replace(P, Do), L && (b = b.replace(/%25([0-9a-fA-F]{2})/g, "%$1")), b) : null;
  }
  function Do(b) {
    return b = b.charCodeAt(0), "%" + (b >> 4 & 15).toString(16) + (b & 15).toString(16);
  }
  var po = /[#\/\?@]/g, mo = /[#\?:]/g, Lo = /[#\?]/g, Kf = /[#\?@]/g, wl = /#/g;
  function jo(b, P) {
    this.h = this.g = null, this.i = b || null, this.j = !!P;
  }
  function ki(b) {
    b.g || (b.g = /* @__PURE__ */ new Map(), b.h = 0, b.i && tn(b.i, function(P, L) {
      b.add(decodeURIComponent(P.replace(/\+/g, " ")), L);
    }));
  }
  e = jo.prototype, e.add = function(b, P) {
    ki(this), this.i = null, b = Ps(this, b);
    var L = this.g.get(b);
    return L || this.g.set(b, L = []), L.push(P), this.h += 1, this;
  };
  function xl(b, P) {
    ki(b), P = Ps(b, P), b.g.has(P) && (b.i = null, b.h -= b.g.get(P).length, b.g.delete(P));
  }
  function ed(b, P) {
    return ki(b), P = Ps(b, P), b.g.has(P);
  }
  e.forEach = function(b, P) {
    ki(this), this.g.forEach(function(L, G) {
      L.forEach(function(le) {
        b.call(P, le, G, this);
      }, this);
    }, this);
  }, e.na = function() {
    ki(this);
    const b = Array.from(this.g.values()), P = Array.from(this.g.keys()), L = [];
    for (let G = 0; G < P.length; G++) {
      const le = b[G];
      for (let ve = 0; ve < le.length; ve++)
        L.push(P[G]);
    }
    return L;
  }, e.V = function(b) {
    ki(this);
    let P = [];
    if (typeof b == "string")
      ed(this, b) && (P = P.concat(this.g.get(Ps(this, b))));
    else {
      b = Array.from(this.g.values());
      for (let L = 0; L < b.length; L++)
        P = P.concat(b[L]);
    }
    return P;
  }, e.set = function(b, P) {
    return ki(this), this.i = null, b = Ps(this, b), ed(this, b) && (this.h -= this.g.get(b).length), this.g.set(b, [P]), this.h += 1, this;
  }, e.get = function(b, P) {
    return b ? (b = this.V(b), 0 < b.length ? String(b[0]) : P) : P;
  };
  function Yf(b, P, L) {
    xl(b, P), 0 < L.length && (b.i = null, b.g.set(Ps(b, P), g(L)), b.h += L.length);
  }
  e.toString = function() {
    if (this.i)
      return this.i;
    if (!this.g)
      return "";
    const b = [], P = Array.from(this.g.keys());
    for (var L = 0; L < P.length; L++) {
      var G = P[L];
      const ve = encodeURIComponent(String(G)), nt = this.V(G);
      for (G = 0; G < nt.length; G++) {
        var le = ve;
        nt[G] !== "" && (le += "=" + encodeURIComponent(String(nt[G]))), b.push(le);
      }
    }
    return this.i = b.join("&");
  };
  function Ps(b, P) {
    return P = String(P), b.j && (P = P.toLowerCase()), P;
  }
  function Zp(b, P) {
    P && !b.j && (ki(b), b.i = null, b.g.forEach(function(L, G) {
      var le = G.toLowerCase();
      G != le && (xl(this, G), Yf(this, le, L));
    }, b)), b.j = P;
  }
  function pt(b, P) {
    const L = new it();
    if (s.Image) {
      const G = new Image();
      G.onload = h(On, L, "TestLoadImage: loaded", !0, P, G), G.onerror = h(On, L, "TestLoadImage: error", !1, P, G), G.onabort = h(On, L, "TestLoadImage: abort", !1, P, G), G.ontimeout = h(On, L, "TestLoadImage: timeout", !1, P, G), s.setTimeout(function() {
        G.ontimeout && G.ontimeout();
      }, 1e4), G.src = b;
    } else
      P(!1);
  }
  function Bt(b, P) {
    const L = new it(), G = new AbortController(), le = setTimeout(() => {
      G.abort(), On(L, "TestPingServer: timeout", !1, P);
    }, 1e4);
    fetch(b, { signal: G.signal }).then((ve) => {
      clearTimeout(le), ve.ok ? On(L, "TestPingServer: ok", !0, P) : On(L, "TestPingServer: server error", !1, P);
    }).catch(() => {
      clearTimeout(le), On(L, "TestPingServer: error", !1, P);
    });
  }
  function On(b, P, L, G, le) {
    try {
      le && (le.onload = null, le.onerror = null, le.onabort = null, le.ontimeout = null), G(L);
    } catch {
    }
  }
  function Qr() {
    this.g = new Ct();
  }
  function Tr(b, P, L) {
    const G = L || "";
    try {
      Xt(b, function(le, ve) {
        let nt = le;
        l(le) && (nt = zt(le)), P.push(G + ve + "=" + encodeURIComponent(nt));
      });
    } catch (le) {
      throw P.push(G + "type=" + encodeURIComponent("_badmap")), le;
    }
  }
  function xc(b) {
    this.l = b.Ub || null, this.j = b.eb || !1;
  }
  p(xc, yt), xc.prototype.g = function() {
    return new El(this.l, this.j);
  }, xc.prototype.i = function(b) {
    return function() {
      return b;
    };
  }({});
  function El(b, P) {
    Fe.call(this), this.D = b, this.o = P, this.m = void 0, this.status = this.readyState = 0, this.responseType = this.responseText = this.response = this.statusText = "", this.onreadystatechange = null, this.u = new Headers(), this.h = null, this.B = "GET", this.A = "", this.g = !1, this.v = this.j = this.l = null;
  }
  p(El, Fe), e = El.prototype, e.open = function(b, P) {
    if (this.readyState != 0)
      throw this.abort(), Error("Error reopening a connection");
    this.B = b, this.A = P, this.readyState = 1, tm(this);
  }, e.send = function(b) {
    if (this.readyState != 1)
      throw this.abort(), Error("need to call open() first. ");
    this.g = !0;
    const P = { headers: this.u, method: this.B, credentials: this.m, cache: void 0 };
    b && (P.body = b), (this.D || s).fetch(new Request(this.A, P)).then(this.Sa.bind(this), this.ga.bind(this));
  }, e.abort = function() {
    this.response = this.responseText = "", this.u = new Headers(), this.status = 0, this.j && this.j.cancel("Request was aborted.").catch(() => {
    }), 1 <= this.readyState && this.g && this.readyState != 4 && (this.g = !1, Ms(this)), this.readyState = 0;
  }, e.Sa = function(b) {
    if (this.g && (this.l = b, this.h || (this.status = this.l.status, this.statusText = this.l.statusText, this.h = b.headers, this.readyState = 2, tm(this)), this.g && (this.readyState = 3, tm(this), this.g)))
      if (this.responseType === "arraybuffer")
        b.arrayBuffer().then(this.Qa.bind(this), this.ga.bind(this));
      else if (typeof s.ReadableStream < "u" && "body" in b) {
        if (this.j = b.body.getReader(), this.o) {
          if (this.responseType)
            throw Error('responseType must be empty for "streamBinaryChunks" mode responses.');
          this.response = [];
        } else
          this.response = this.responseText = "", this.v = new TextDecoder();
        em(this);
      } else
        b.text().then(this.Ra.bind(this), this.ga.bind(this));
  };
  function em(b) {
    b.j.read().then(b.Pa.bind(b)).catch(b.ga.bind(b));
  }
  e.Pa = function(b) {
    if (this.g) {
      if (this.o && b.value)
        this.response.push(b.value);
      else if (!this.o) {
        var P = b.value ? b.value : new Uint8Array(0);
        (P = this.v.decode(P, { stream: !b.done })) && (this.response = this.responseText += P);
      }
      b.done ? Ms(this) : tm(this), this.readyState == 3 && em(this);
    }
  }, e.Ra = function(b) {
    this.g && (this.response = this.responseText = b, Ms(this));
  }, e.Qa = function(b) {
    this.g && (this.response = b, Ms(this));
  }, e.ga = function() {
    this.g && Ms(this);
  };
  function Ms(b) {
    b.readyState = 4, b.l = null, b.j = null, b.v = null, tm(b);
  }
  e.setRequestHeader = function(b, P) {
    this.u.append(b, P);
  }, e.getResponseHeader = function(b) {
    return this.h && this.h.get(b.toLowerCase()) || "";
  }, e.getAllResponseHeaders = function() {
    if (!this.h)
      return "";
    const b = [], P = this.h.entries();
    for (var L = P.next(); !L.done; )
      L = L.value, b.push(L[0] + ": " + L[1]), L = P.next();
    return b.join(`\r
`);
  };
  function tm(b) {
    b.onreadystatechange && b.onreadystatechange.call(b);
  }
  Object.defineProperty(El.prototype, "withCredentials", { get: function() {
    return this.m === "include";
  }, set: function(b) {
    this.m = b ? "include" : "same-origin";
  } });
  function Jk(b) {
    let P = "";
    return T(b, function(L, G) {
      P += G, P += ":", P += L, P += `\r
`;
    }), P;
  }
  function T2(b, P, L) {
    e: {
      for (G in L) {
        var G = !1;
        break e;
      }
      G = !0;
    }
    G || (L = Jk(L), typeof b == "string" ? L != null && encodeURIComponent(String(L)) : ln(b, P, L));
  }
  function Vr(b) {
    Fe.call(this), this.headers = /* @__PURE__ */ new Map(), this.o = b || null, this.h = !1, this.v = this.g = null, this.D = "", this.m = 0, this.l = "", this.j = this.B = this.u = this.A = !1, this.I = null, this.H = "", this.J = !1;
  }
  p(Vr, Fe);
  var Tse = /^https?$/i, Ise = ["POST", "PUT"];
  e = Vr.prototype, e.Ha = function(b) {
    this.J = b;
  }, e.ea = function(b, P, L, G) {
    if (this.g)
      throw Error("[goog.net.XhrIo] Object is active with another request=" + this.D + "; newUri=" + b);
    P = P ? P.toUpperCase() : "GET", this.D = b, this.l = "", this.m = 0, this.A = !1, this.h = !0, this.g = this.o ? this.o.g() : xt.g(), this.v = this.o ? Mn(this.o) : Mn(xt), this.g.onreadystatechange = f(this.Ea, this);
    try {
      this.B = !0, this.g.open(P, String(b), !0), this.B = !1;
    } catch (ve) {
      Zk(this, ve);
      return;
    }
    if (b = L || "", L = new Map(this.headers), G)
      if (Object.getPrototypeOf(G) === Object.prototype)
        for (var le in G)
          L.set(le, G[le]);
      else if (typeof G.keys == "function" && typeof G.get == "function")
        for (const ve of G.keys())
          L.set(ve, G.get(ve));
      else
        throw Error("Unknown input type for opt_headers: " + String(G));
    G = Array.from(L.keys()).find((ve) => ve.toLowerCase() == "content-type"), le = s.FormData && b instanceof s.FormData, !(0 <= Array.prototype.indexOf.call(Ise, P, void 0)) || G || le || L.set("Content-Type", "application/x-www-form-urlencoded;charset=utf-8");
    for (const [ve, nt] of L)
      this.g.setRequestHeader(ve, nt);
    this.H && (this.g.responseType = this.H), "withCredentials" in this.g && this.g.withCredentials !== this.J && (this.g.withCredentials = this.J);
    try {
      nN(this), this.u = !0, this.g.send(b), this.u = !1;
    } catch (ve) {
      Zk(this, ve);
    }
  };
  function Zk(b, P) {
    b.h = !1, b.g && (b.j = !0, b.g.abort(), b.j = !1), b.l = P, b.m = 5, eN(b), sb(b);
  }
  function eN(b) {
    b.A || (b.A = !0, Pe(b, "complete"), Pe(b, "error"));
  }
  e.abort = function(b) {
    this.g && this.h && (this.h = !1, this.j = !0, this.g.abort(), this.j = !1, this.m = b || 7, Pe(this, "complete"), Pe(this, "abort"), sb(this));
  }, e.N = function() {
    this.g && (this.h && (this.h = !1, this.j = !0, this.g.abort(), this.j = !1), sb(this, !0)), Vr.aa.N.call(this);
  }, e.Ea = function() {
    this.s || (this.B || this.u || this.j ? tN(this) : this.bb());
  }, e.bb = function() {
    tN(this);
  };
  function tN(b) {
    if (b.h && typeof a < "u" && (!b.v[1] || Ec(b) != 4 || b.Z() != 2)) {
      if (b.u && Ec(b) == 4)
        dt(b.Ea, 0, b);
      else if (Pe(b, "readystatechange"), Ec(b) == 4) {
        b.h = !1;
        try {
          const nt = b.Z();
          e:
            switch (nt) {
              case 200:
              case 201:
              case 202:
              case 204:
              case 206:
              case 304:
              case 1223:
                var P = !0;
                break e;
              default:
                P = !1;
            }
          var L;
          if (!(L = P)) {
            var G;
            if (G = nt === 0) {
              var le = String(b.D).match(Vt)[1] || null;
              !le && s.self && s.self.location && (le = s.self.location.protocol.slice(0, -1)), G = !Tse.test(le ? le.toLowerCase() : "");
            }
            L = G;
          }
          if (L)
            Pe(b, "complete"), Pe(b, "success");
          else {
            b.m = 6;
            try {
              var ve = 2 < Ec(b) ? b.g.statusText : "";
            } catch {
              ve = "";
            }
            b.l = ve + " [" + b.Z() + "]", eN(b);
          }
        } finally {
          sb(b);
        }
      }
    }
  }
  function sb(b, P) {
    if (b.g) {
      nN(b);
      const L = b.g, G = b.v[0] ? () => {
      } : null;
      b.g = null, b.v = null, P || Pe(b, "ready");
      try {
        L.onreadystatechange = G;
      } catch {
      }
    }
  }
  function nN(b) {
    b.I && (s.clearTimeout(b.I), b.I = null);
  }
  e.isActive = function() {
    return !!this.g;
  };
  function Ec(b) {
    return b.g ? b.g.readyState : 0;
  }
  e.Z = function() {
    try {
      return 2 < Ec(this) ? this.g.status : -1;
    } catch {
      return -1;
    }
  }, e.oa = function() {
    try {
      return this.g ? this.g.responseText : "";
    } catch {
      return "";
    }
  }, e.Oa = function(b) {
    if (this.g) {
      var P = this.g.responseText;
      return b && P.indexOf(b) == 0 && (P = P.substring(b.length)), kt(P);
    }
  };
  function rN(b) {
    try {
      if (!b.g)
        return null;
      if ("response" in b.g)
        return b.g.response;
      switch (b.H) {
        case "":
        case "text":
          return b.g.responseText;
        case "arraybuffer":
          if ("mozResponseArrayBuffer" in b.g)
            return b.g.mozResponseArrayBuffer;
      }
      return null;
    } catch {
      return null;
    }
  }
  function Ase(b) {
    const P = {};
    b = (b.g && 2 <= Ec(b) && b.g.getAllResponseHeaders() || "").split(`\r
`);
    for (let G = 0; G < b.length; G++) {
      if (y(b[G]))
        continue;
      var L = A(b[G]);
      const le = L[0];
      if (L = L[1], typeof L != "string")
        continue;
      L = L.trim();
      const ve = P[le] || [];
      P[le] = ve, ve.push(L);
    }
    x(P, function(G) {
      return G.join(", ");
    });
  }
  e.Ba = function() {
    return this.m;
  }, e.Ka = function() {
    return typeof this.l == "string" ? this.l : String(this.l);
  };
  function nm(b, P, L) {
    return L && L.internalChannelParams && L.internalChannelParams[b] || P;
  }
  function iN(b) {
    this.Aa = 0, this.i = [], this.j = new it(), this.ia = this.qa = this.I = this.W = this.g = this.ya = this.D = this.H = this.m = this.S = this.o = null, this.Ya = this.U = 0, this.Va = nm("failFast", !1, b), this.F = this.C = this.u = this.s = this.l = null, this.X = !0, this.za = this.T = -1, this.Y = this.v = this.B = 0, this.Ta = nm("baseRetryDelayMs", 5e3, b), this.cb = nm("retryDelaySeedMs", 1e4, b), this.Wa = nm("forwardChannelMaxRetries", 2, b), this.wa = nm("forwardChannelRequestTimeoutMs", 2e4, b), this.pa = b && b.xmlHttpFactory || void 0, this.Xa = b && b.Tb || void 0, this.Ca = b && b.useFetchStreams || !1, this.L = void 0, this.J = b && b.supportsCrossDomainXhr || !1, this.K = "", this.h = new pr(b && b.concurrentRequestLimit), this.Da = new Qr(), this.P = b && b.fastHandshake || !1, this.O = b && b.encodeInitMessageHeaders || !1, this.P && this.O && (this.O = !1), this.Ua = b && b.Rb || !1, b && b.xa && this.j.xa(), b && b.forceLongPolling && (this.X = !1), this.ba = !this.P && this.X && b && b.detectBufferingProxy || !1, this.ja = void 0, b && b.longPollingTimeout && 0 < b.longPollingTimeout && (this.ja = b.longPollingTimeout), this.ca = void 0, this.R = 0, this.M = !1, this.ka = this.A = null;
  }
  e = iN.prototype, e.la = 8, e.G = 1, e.connect = function(b, P, L, G) {
    Ht(0), this.W = b, this.H = P || {}, L && G !== void 0 && (this.H.OSID = L, this.H.OAID = G), this.F = this.X, this.I = hN(this, null, this.W), lb(this);
  };
  function I2(b) {
    if (oN(b), b.G == 3) {
      var P = b.U++, L = Jt(b.I);
      if (ln(L, "SID", b.K), ln(L, "RID", P), ln(L, "TYPE", "terminate"), rm(b, L), P = new st(b, b.j, P), P.L = 2, P.v = ni(Jt(L)), L = !1, s.navigator && s.navigator.sendBeacon)
        try {
          L = s.navigator.sendBeacon(P.v.toString(), "");
        } catch {
        }
      !L && s.Image && (new Image().src = P.v, L = !0), L || (P.g = gN(P.j, null), P.g.ea(P.v)), P.F = Date.now(), It(P);
    }
    fN(b);
  }
  function cb(b) {
    b.g && (R2(b), b.g.cancel(), b.g = null);
  }
  function oN(b) {
    cb(b), b.u && (s.clearTimeout(b.u), b.u = null), ub(b), b.h.cancel(), b.s && (typeof b.s == "number" && s.clearTimeout(b.s), b.s = null);
  }
  function lb(b) {
    if (!xr(b.h) && !b.s) {
      b.s = !0;
      var P = b.Ga;
      F || B(), V || (F(), V = !0), j.add(P, b), b.B = 0;
    }
  }
  function Rse(b, P) {
    return Yr(b.h) >= b.h.j - (b.s ? 1 : 0) ? !1 : b.s ? (b.i = P.D.concat(b.i), !0) : b.G == 1 || b.G == 2 || b.B >= (b.Va ? 0 : b.Wa) ? !1 : (b.s = ze(f(b.Ga, b, P), dN(b, b.B)), b.B++, !0);
  }
  e.Ga = function(b) {
    if (this.s)
      if (this.s = null, this.G == 1) {
        if (!b) {
          this.U = Math.floor(1e5 * Math.random()), b = this.U++;
          const le = new st(this, this.j, b);
          let ve = this.o;
          if (this.S && (ve ? (ve = C(ve), R(ve, this.S)) : ve = this.S), this.m !== null || this.O || (le.H = ve, ve = null), this.P)
            e: {
              for (var P = 0, L = 0; L < this.i.length; L++) {
                t: {
                  var G = this.i[L];
                  if ("__data__" in G.map && (G = G.map.__data__, typeof G == "string")) {
                    G = G.length;
                    break t;
                  }
                  G = void 0;
                }
                if (G === void 0)
                  break;
                if (P += G, 4096 < P) {
                  P = L;
                  break e;
                }
                if (P === 4096 || L === this.i.length - 1) {
                  P = L + 1;
                  break e;
                }
              }
              P = 1e3;
            }
          else
            P = 1e3;
          P = sN(this, le, P), L = Jt(this.I), ln(L, "RID", b), ln(L, "CVER", 22), this.D && ln(L, "X-HTTP-Session-Id", this.D), rm(this, L), ve && (this.O ? P = "headers=" + encodeURIComponent(String(Jk(ve))) + "&" + P : this.m && T2(L, this.m, ve)), Xr(this.h, le), this.Ua && ln(L, "TYPE", "init"), this.P ? (ln(L, "$req", P), ln(L, "SID", "null"), le.T = !0, Xe(le, L, null)) : Xe(le, L, P), this.G = 2;
        }
      } else
        this.G == 3 && (b ? aN(this, b) : this.i.length == 0 || xr(this.h) || aN(this));
  };
  function aN(b, P) {
    var L;
    P ? L = P.l : L = b.U++;
    const G = Jt(b.I);
    ln(G, "SID", b.K), ln(G, "RID", L), ln(G, "AID", b.T), rm(b, G), b.m && b.o && T2(G, b.m, b.o), L = new st(b, b.j, L, b.B + 1), b.m === null && (L.H = b.o), P && (b.i = P.D.concat(b.i)), P = sN(b, L, 1e3), L.I = Math.round(0.5 * b.wa) + Math.round(0.5 * b.wa * Math.random()), Xr(b.h, L), Xe(L, G, P);
  }
  function rm(b, P) {
    b.H && T(b.H, function(L, G) {
      ln(P, G, L);
    }), b.l && Xt({}, function(L, G) {
      ln(P, G, L);
    });
  }
  function sN(b, P, L) {
    L = Math.min(b.i.length, L);
    var G = b.l ? f(b.l.Na, b.l, b) : null;
    e: {
      var le = b.i;
      let ve = -1;
      for (; ; ) {
        const nt = ["count=" + L];
        ve == -1 ? 0 < L ? (ve = le[0].g, nt.push("ofs=" + ve)) : ve = 0 : nt.push("ofs=" + ve);
        let Jn = !0;
        for (let Ni = 0; Ni < L; Ni++) {
          let kn = le[Ni].g;
          const Yi = le[Ni].map;
          if (kn -= ve, 0 > kn)
            ve = Math.max(0, le[Ni].g - 100), Jn = !1;
          else
            try {
              Tr(Yi, nt, "req" + kn + "_");
            } catch {
              G && G(Yi);
            }
        }
        if (Jn) {
          G = nt.join("&");
          break e;
        }
      }
    }
    return b = b.i.splice(0, L), P.D = b, G;
  }
  function cN(b) {
    if (!b.g && !b.u) {
      b.Y = 1;
      var P = b.Fa;
      F || B(), V || (F(), V = !0), j.add(P, b), b.v = 0;
    }
  }
  function A2(b) {
    return b.g || b.u || 3 <= b.v ? !1 : (b.Y++, b.u = ze(f(b.Fa, b), dN(b, b.v)), b.v++, !0);
  }
  e.Fa = function() {
    if (this.u = null, lN(this), this.ba && !(this.M || this.g == null || 0 >= this.R)) {
      var b = 2 * this.R;
      this.j.info("BP detection timer enabled: " + b), this.A = ze(f(this.ab, this), b);
    }
  }, e.ab = function() {
    this.A && (this.A = null, this.j.info("BP detection timeout reached."), this.j.info("Buffering proxy detected and switch to long-polling!"), this.F = !1, this.M = !0, Ht(10), cb(this), lN(this));
  };
  function R2(b) {
    b.A != null && (s.clearTimeout(b.A), b.A = null);
  }
  function lN(b) {
    b.g = new st(b, b.j, "rpc", b.Y), b.m === null && (b.g.H = b.o), b.g.O = 0;
    var P = Jt(b.qa);
    ln(P, "RID", "rpc"), ln(P, "SID", b.K), ln(P, "AID", b.T), ln(P, "CI", b.F ? "0" : "1"), !b.F && b.ja && ln(P, "TO", b.ja), ln(P, "TYPE", "xmlhttp"), rm(b, P), b.m && b.o && T2(P, b.m, b.o), b.L && (b.g.I = b.L);
    var L = b.g;
    b = b.ia, L.L = 1, L.v = ni(Jt(P)), L.m = null, L.P = !0, ct(L, b);
  }
  e.Za = function() {
    this.C != null && (this.C = null, cb(this), A2(this), Ht(19));
  };
  function ub(b) {
    b.C != null && (s.clearTimeout(b.C), b.C = null);
  }
  function uN(b, P) {
    var L = null;
    if (b.g == P) {
      ub(b), R2(b), b.g = null;
      var G = 2;
    } else if (Er(b.h, P))
      L = P.D, Ci(b.h, P), G = 1;
    else
      return;
    if (b.G != 0) {
      if (P.o)
        if (G == 1) {
          L = P.m ? P.m.length : 0, P = Date.now() - P.F;
          var le = b.B;
          G = We(), Pe(G, new Be(G, L)), lb(b);
        } else
          cN(b);
      else if (le = P.s, le == 3 || le == 0 && 0 < P.X || !(G == 1 && Rse(b, P) || G == 2 && A2(b)))
        switch (L && 0 < L.length && (P = b.h, P.i = P.i.concat(L)), le) {
          case 1:
            td(b, 5);
            break;
          case 4:
            td(b, 10);
            break;
          case 3:
            td(b, 6);
            break;
          default:
            td(b, 2);
        }
    }
  }
  function dN(b, P) {
    let L = b.Ta + Math.floor(Math.random() * b.cb);
    return b.isActive() || (L *= 2), L * P;
  }
  function td(b, P) {
    if (b.j.info("Error code " + P), P == 2) {
      var L = f(b.fb, b), G = b.Xa;
      const le = !G;
      G = new Qt(G || "//www.google.com/images/cleardot.gif"), s.location && s.location.protocol == "http" || vn(G, "https"), ni(G), le ? pt(G.toString(), L) : Bt(G.toString(), L);
    } else
      Ht(2);
    b.G = 0, b.l && b.l.sa(P), fN(b), oN(b);
  }
  e.fb = function(b) {
    b ? (this.j.info("Successfully pinged google.com"), Ht(2)) : (this.j.info("Failed to ping google.com"), Ht(1));
  };
  function fN(b) {
    if (b.G = 0, b.ka = [], b.l) {
      const P = Ti(b.h);
      (P.length != 0 || b.i.length != 0) && (m(b.ka, P), m(b.ka, b.i), b.h.i.length = 0, g(b.i), b.i.length = 0), b.l.ra();
    }
  }
  function hN(b, P, L) {
    var G = L instanceof Qt ? Jt(L) : new Qt(L);
    if (G.g != "")
      P && (G.g = P + "." + G.g), Cr(G, G.s);
    else {
      var le = s.location;
      G = le.protocol, P = P ? P + "." + le.hostname : le.hostname, le = +le.port;
      var ve = new Qt(null);
      G && vn(ve, G), P && (ve.g = P), le && Cr(ve, le), L && (ve.l = L), G = ve;
    }
    return L = b.D, P = b.ya, L && P && ln(G, L, P), ln(G, "VER", b.la), rm(b, G), G;
  }
  function gN(b, P, L) {
    if (P && !b.J)
      throw Error("Can't create secondary domain capable XhrIo object.");
    return P = b.Ca && !b.pa ? new Vr(new xc({ eb: L })) : new Vr(b.pa), P.Ha(b.J), P;
  }
  e.isActive = function() {
    return !!this.l && this.l.isActive(this);
  };
  function pN() {
  }
  e = pN.prototype, e.ua = function() {
  }, e.ta = function() {
  }, e.sa = function() {
  }, e.ra = function() {
  }, e.isActive = function() {
    return !0;
  }, e.Na = function() {
  };
  function db() {
  }
  db.prototype.g = function(b, P) {
    return new ra(b, P);
  };
  function ra(b, P) {
    Fe.call(this), this.g = new iN(P), this.l = b, this.h = P && P.messageUrlParams || null, b = P && P.messageHeaders || null, P && P.clientProtocolHeaderRequired && (b ? b["X-Client-Protocol"] = "webchannel" : b = { "X-Client-Protocol": "webchannel" }), this.g.o = b, b = P && P.initMessageHeaders || null, P && P.messageContentType && (b ? b["X-WebChannel-Content-Type"] = P.messageContentType : b = { "X-WebChannel-Content-Type": P.messageContentType }), P && P.va && (b ? b["X-WebChannel-Client-Profile"] = P.va : b = { "X-WebChannel-Client-Profile": P.va }), this.g.S = b, (b = P && P.Sb) && !y(b) && (this.g.m = b), this.v = P && P.supportsCrossDomainXhr || !1, this.u = P && P.sendRawJson || !1, (P = P && P.httpSessionIdParam) && !y(P) && (this.g.D = P, b = this.h, b !== null && P in b && (b = this.h, P in b && delete b[P])), this.j = new Xf(this);
  }
  p(ra, Fe), ra.prototype.m = function() {
    this.g.l = this.j, this.v && (this.g.J = !0), this.g.connect(this.l, this.h || void 0);
  }, ra.prototype.close = function() {
    I2(this.g);
  }, ra.prototype.o = function(b) {
    var P = this.g;
    if (typeof b == "string") {
      var L = {};
      L.__data__ = b, b = L;
    } else
      this.u && (L = {}, L.__data__ = zt(b), b = L);
    P.i.push(new Kr(P.Ya++, b)), P.G == 3 && lb(P);
  }, ra.prototype.N = function() {
    this.g.l = null, delete this.j, I2(this.g), delete this.g, ra.aa.N.call(this);
  };
  function mN(b) {
    Le.call(this), b.__headers__ && (this.headers = b.__headers__, this.statusCode = b.__status__, delete b.__headers__, delete b.__status__);
    var P = b.__sm__;
    if (P) {
      e: {
        for (const L in P) {
          b = L;
          break e;
        }
        b = void 0;
      }
      (this.i = b) && (b = this.i, P = P !== null && b in P ? P[b] : void 0), this.data = P;
    } else
      this.data = b;
  }
  p(mN, Le);
  function vN() {
    rt.call(this), this.status = 1;
  }
  p(vN, rt);
  function Xf(b) {
    this.g = b;
  }
  p(Xf, pN), Xf.prototype.ua = function() {
    Pe(this.g, "a");
  }, Xf.prototype.ta = function(b) {
    Pe(this.g, new mN(b));
  }, Xf.prototype.sa = function(b) {
    Pe(this.g, new vN());
  }, Xf.prototype.ra = function() {
    Pe(this.g, "b");
  }, db.prototype.createWebChannel = db.prototype.g, ra.prototype.send = ra.prototype.o, ra.prototype.open = ra.prototype.m, ra.prototype.close = ra.prototype.close, jU = function() {
    return new db();
  }, LU = function() {
    return We();
  }, DU = ut, kI = { mb: 0, pb: 1, qb: 2, Jb: 3, Ob: 4, Lb: 5, Mb: 6, Kb: 7, Ib: 8, Nb: 9, PROXY: 10, NOPROXY: 11, Gb: 12, Cb: 13, Db: 14, Bb: 15, Eb: 16, Fb: 17, ib: 18, hb: 19, jb: 20 }, $e.NO_ERROR = 0, $e.TIMEOUT = 8, $e.HTTP_ERROR = 6, $1 = $e, qe.COMPLETE = "complete", NU = qe, Pt.EventType = Ze, Ze.OPEN = "a", Ze.CLOSE = "b", Ze.ERROR = "c", Ze.MESSAGE = "d", Fe.prototype.listen = Fe.prototype.K, jm = Pt, Vr.prototype.listenOnce = Vr.prototype.L, Vr.prototype.getLastError = Vr.prototype.Ka, Vr.prototype.getLastErrorCode = Vr.prototype.Ba, Vr.prototype.getStatus = Vr.prototype.Z, Vr.prototype.getResponseJson = Vr.prototype.Oa, Vr.prototype.getResponseText = Vr.prototype.oa, Vr.prototype.send = Vr.prototype.ea, Vr.prototype.setWithCredentials = Vr.prototype.Ha, kU = Vr;
}).apply(typeof pb < "u" ? pb : typeof self < "u" ? self : typeof window < "u" ? window : {});
const WD = "@firebase/firestore", qD = "4.8.0";
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class ro {
  constructor(t) {
    this.uid = t;
  }
  isAuthenticated() {
    return this.uid != null;
  }
  /**
   * Returns a key representing this user, suitable for inclusion in a
   * dictionary.
   */
  toKey() {
    return this.isAuthenticated() ? "uid:" + this.uid : "anonymous-user";
  }
  isEqual(t) {
    return t.uid === this.uid;
  }
}
ro.UNAUTHENTICATED = new ro(null), // TODO(mikelehen): Look into getting a proper uid-equivalent for
// non-FirebaseAuth providers.
ro.GOOGLE_CREDENTIALS = new ro("google-credentials-uid"), ro.FIRST_PARTY = new ro("first-party-uid"), ro.MOCK_USER = new ro("mock-user");
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
let lp = "11.10.0";
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const Zd = new Gw("@firebase/firestore");
function Sh() {
  return Zd.logLevel;
}
function ht(e, ...t) {
  if (Zd.logLevel <= bn.DEBUG) {
    const n = t.map(MO);
    Zd.debug(`Firestore (${lp}): ${e}`, ...n);
  }
}
function ol(e, ...t) {
  if (Zd.logLevel <= bn.ERROR) {
    const n = t.map(MO);
    Zd.error(`Firestore (${lp}): ${e}`, ...n);
  }
}
function mu(e, ...t) {
  if (Zd.logLevel <= bn.WARN) {
    const n = t.map(MO);
    Zd.warn(`Firestore (${lp}): ${e}`, ...n);
  }
}
function MO(e) {
  if (typeof e == "string")
    return e;
  try {
    /**
    * @license
    * Copyright 2020 Google LLC
    *
    * Licensed under the Apache License, Version 2.0 (the "License");
    * you may not use this file except in compliance with the License.
    * You may obtain a copy of the License at
    *
    *   http://www.apache.org/licenses/LICENSE-2.0
    *
    * Unless required by applicable law or agreed to in writing, software
    * distributed under the License is distributed on an "AS IS" BASIS,
    * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
    * See the License for the specific language governing permissions and
    * limitations under the License.
    */
    return function(n) {
      return JSON.stringify(n);
    }(e);
  } catch {
    return e;
  }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function Wt(e, t, n) {
  let r = "Unexpected state";
  typeof t == "string" ? r = t : n = t, FU(e, r, n);
}
function FU(e, t, n) {
  let r = `FIRESTORE (${lp}) INTERNAL ASSERTION FAILED: ${t} (ID: ${e.toString(16)})`;
  if (n !== void 0)
    try {
      r += " CONTEXT: " + JSON.stringify(n);
    } catch {
      r += " CONTEXT: " + n;
    }
  throw ol(r), new Error(r);
}
function jn(e, t, n, r) {
  let i = "Unexpected state";
  typeof n == "string" ? i = n : r = n, e || FU(t, i, r);
}
function qt(e, t) {
  return e;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const Se = {
  // Causes are copied from:
  // https://github.com/grpc/grpc/blob/bceec94ea4fc5f0085d81235d8e1c06798dc341a/include/grpc%2B%2B/impl/codegen/status_code_enum.h
  /** Not an error; returned on success. */
  OK: "ok",
  /** The operation was cancelled (typically by the caller). */
  CANCELLED: "cancelled",
  /** Unknown error or an error from a different error domain. */
  UNKNOWN: "unknown",
  /**
   * Client specified an invalid argument. Note that this differs from
   * FAILED_PRECONDITION. INVALID_ARGUMENT indicates arguments that are
   * problematic regardless of the state of the system (e.g., a malformed file
   * name).
   */
  INVALID_ARGUMENT: "invalid-argument",
  /**
   * Deadline expired before operation could complete. For operations that
   * change the state of the system, this error may be returned even if the
   * operation has completed successfully. For example, a successful response
   * from a server could have been delayed long enough for the deadline to
   * expire.
   */
  DEADLINE_EXCEEDED: "deadline-exceeded",
  /** Some requested entity (e.g., file or directory) was not found. */
  NOT_FOUND: "not-found",
  /**
   * Some entity that we attempted to create (e.g., file or directory) already
   * exists.
   */
  ALREADY_EXISTS: "already-exists",
  /**
   * The caller does not have permission to execute the specified operation.
   * PERMISSION_DENIED must not be used for rejections caused by exhausting
   * some resource (use RESOURCE_EXHAUSTED instead for those errors).
   * PERMISSION_DENIED must not be used if the caller cannot be identified
   * (use UNAUTHENTICATED instead for those errors).
   */
  PERMISSION_DENIED: "permission-denied",
  /**
   * The request does not have valid authentication credentials for the
   * operation.
   */
  UNAUTHENTICATED: "unauthenticated",
  /**
   * Some resource has been exhausted, perhaps a per-user quota, or perhaps the
   * entire file system is out of space.
   */
  RESOURCE_EXHAUSTED: "resource-exhausted",
  /**
   * Operation was rejected because the system is not in a state required for
   * the operation's execution. For example, directory to be deleted may be
   * non-empty, an rmdir operation is applied to a non-directory, etc.
   *
   * A litmus test that may help a service implementor in deciding
   * between FAILED_PRECONDITION, ABORTED, and UNAVAILABLE:
   *  (a) Use UNAVAILABLE if the client can retry just the failing call.
   *  (b) Use ABORTED if the client should retry at a higher-level
   *      (e.g., restarting a read-modify-write sequence).
   *  (c) Use FAILED_PRECONDITION if the client should not retry until
   *      the system state has been explicitly fixed. E.g., if an "rmdir"
   *      fails because the directory is non-empty, FAILED_PRECONDITION
   *      should be returned since the client should not retry unless
   *      they have first fixed up the directory by deleting files from it.
   *  (d) Use FAILED_PRECONDITION if the client performs conditional
   *      REST Get/Update/Delete on a resource and the resource on the
   *      server does not match the condition. E.g., conflicting
   *      read-modify-write on the same resource.
   */
  FAILED_PRECONDITION: "failed-precondition",
  /**
   * The operation was aborted, typically due to a concurrency issue like
   * sequencer check failures, transaction aborts, etc.
   *
   * See litmus test above for deciding between FAILED_PRECONDITION, ABORTED,
   * and UNAVAILABLE.
   */
  ABORTED: "aborted",
  /**
   * Operation was attempted past the valid range. E.g., seeking or reading
   * past end of file.
   *
   * Unlike INVALID_ARGUMENT, this error indicates a problem that may be fixed
   * if the system state changes. For example, a 32-bit file system will
   * generate INVALID_ARGUMENT if asked to read at an offset that is not in the
   * range [0,2^32-1], but it will generate OUT_OF_RANGE if asked to read from
   * an offset past the current file size.
   *
   * There is a fair bit of overlap between FAILED_PRECONDITION and
   * OUT_OF_RANGE. We recommend using OUT_OF_RANGE (the more specific error)
   * when it applies so that callers who are iterating through a space can
   * easily look for an OUT_OF_RANGE error to detect when they are done.
   */
  OUT_OF_RANGE: "out-of-range",
  /** Operation is not implemented or not supported/enabled in this service. */
  UNIMPLEMENTED: "unimplemented",
  /**
   * Internal errors. Means some invariants expected by underlying System has
   * been broken. If you see one of these errors, Something is very broken.
   */
  INTERNAL: "internal",
  /**
   * The service is currently unavailable. This is a most likely a transient
   * condition and may be corrected by retrying with a backoff.
   *
   * See litmus test above for deciding between FAILED_PRECONDITION, ABORTED,
   * and UNAVAILABLE.
   */
  UNAVAILABLE: "unavailable",
  /** Unrecoverable data loss or corruption. */
  DATA_LOSS: "data-loss"
};
class Ye extends Ua {
  /** @hideconstructor */
  constructor(t, n) {
    super(t, n), this.code = t, this.message = n, // HACK: We write a toString property directly because Error is not a real
    // class and so inheritance does not work correctly. We could alternatively
    // do the same "back-door inheritance" trick that FirebaseError does.
    this.toString = () => `${this.name}: [code=${this.code}]: ${this.message}`;
  }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class tc {
  constructor() {
    this.promise = new Promise((t, n) => {
      this.resolve = t, this.reject = n;
    });
  }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class VU {
  constructor(t, n) {
    this.user = n, this.type = "OAuth", this.headers = /* @__PURE__ */ new Map(), this.headers.set("Authorization", `Bearer ${t}`);
  }
}
class wpe {
  getToken() {
    return Promise.resolve(null);
  }
  invalidateToken() {
  }
  start(t, n) {
    t.enqueueRetryable(() => n(ro.UNAUTHENTICATED));
  }
  shutdown() {
  }
}
class xpe {
  constructor(t) {
    this.token = t, /**
     * Stores the listener registered with setChangeListener()
     * This isn't actually necessary since the UID never changes, but we use this
     * to verify the listen contract is adhered to in tests.
     */
    this.changeListener = null;
  }
  getToken() {
    return Promise.resolve(this.token);
  }
  invalidateToken() {
  }
  start(t, n) {
    this.changeListener = n, // Fire with initial user.
    t.enqueueRetryable(() => n(this.token.user));
  }
  shutdown() {
    this.changeListener = null;
  }
}
class Epe {
  constructor(t) {
    this.t = t, /** Tracks the current User. */
    this.currentUser = ro.UNAUTHENTICATED, /**
     * Counter used to detect if the token changed while a getToken request was
     * outstanding.
     */
    this.i = 0, this.forceRefresh = !1, this.auth = null;
  }
  start(t, n) {
    jn(this.o === void 0, 42304);
    let r = this.i;
    const i = (c) => this.i !== r ? (r = this.i, n(c)) : Promise.resolve();
    let o = new tc();
    this.o = () => {
      this.i++, this.currentUser = this.u(), o.resolve(), o = new tc(), t.enqueueRetryable(() => i(this.currentUser));
    };
    const a = () => {
      const c = o;
      t.enqueueRetryable(async () => {
        await c.promise, await i(this.currentUser);
      });
    }, s = (c) => {
      ht("FirebaseAuthCredentialsProvider", "Auth detected"), this.auth = c, this.o && (this.auth.addAuthTokenListener(this.o), a());
    };
    this.t.onInit((c) => s(c)), // Our users can initialize Auth right after Firestore, so we give it
    // a chance to register itself with the component framework before we
    // determine whether to start up in unauthenticated mode.
    setTimeout(() => {
      if (!this.auth) {
        const c = this.t.getImmediate({
          optional: !0
        });
        c ? s(c) : (
          // If auth is still not available, proceed with `null` user
          (ht("FirebaseAuthCredentialsProvider", "Auth not yet detected"), o.resolve(), o = new tc())
        );
      }
    }, 0), a();
  }
  getToken() {
    const t = this.i, n = this.forceRefresh;
    return this.forceRefresh = !1, this.auth ? this.auth.getToken(n).then((r) => (
      // Cancel the request since the token changed while the request was
      // outstanding so the response is potentially for a previous user (which
      // user, we can't be sure).
      this.i !== t ? (ht("FirebaseAuthCredentialsProvider", "getToken aborted due to token change."), this.getToken()) : r ? (jn(typeof r.accessToken == "string", 31837, {
        l: r
      }), new VU(r.accessToken, this.currentUser)) : null
    )) : Promise.resolve(null);
  }
  invalidateToken() {
    this.forceRefresh = !0;
  }
  shutdown() {
    this.auth && this.o && this.auth.removeAuthTokenListener(this.o), this.o = void 0;
  }
  // Auth.getUid() can return null even with a user logged in. It is because
  // getUid() is synchronous, but the auth code populating Uid is asynchronous.
  // This method should only be called in the AuthTokenListener callback
  // to guarantee to get the actual user.
  u() {
    const t = this.auth && this.auth.getUid();
    return jn(t === null || typeof t == "string", 2055, {
      h: t
    }), new ro(t);
  }
}
class Cpe {
  constructor(t, n, r) {
    this.P = t, this.T = n, this.I = r, this.type = "FirstParty", this.user = ro.FIRST_PARTY, this.A = /* @__PURE__ */ new Map();
  }
  /**
   * Gets an authorization token, using a provided factory function, or return
   * null.
   */
  R() {
    return this.I ? this.I() : null;
  }
  get headers() {
    this.A.set("X-Goog-AuthUser", this.P);
    const t = this.R();
    return t && this.A.set("Authorization", t), this.T && this.A.set("X-Goog-Iam-Authorization-Token", this.T), this.A;
  }
}
class Tpe {
  constructor(t, n, r) {
    this.P = t, this.T = n, this.I = r;
  }
  getToken() {
    return Promise.resolve(new Cpe(this.P, this.T, this.I));
  }
  start(t, n) {
    t.enqueueRetryable(() => n(ro.FIRST_PARTY));
  }
  shutdown() {
  }
  invalidateToken() {
  }
}
class GD {
  constructor(t) {
    this.value = t, this.type = "AppCheck", this.headers = /* @__PURE__ */ new Map(), t && t.length > 0 && this.headers.set("x-firebase-appcheck", this.value);
  }
}
class Ipe {
  constructor(t, n) {
    this.V = n, this.forceRefresh = !1, this.appCheck = null, this.m = null, this.p = null, Eo(t) && t.settings.appCheckToken && (this.p = t.settings.appCheckToken);
  }
  start(t, n) {
    jn(this.o === void 0, 3512);
    const r = (o) => {
      o.error != null && ht("FirebaseAppCheckTokenProvider", `Error getting App Check token; using placeholder token instead. Error: ${o.error.message}`);
      const a = o.token !== this.m;
      return this.m = o.token, ht("FirebaseAppCheckTokenProvider", `Received ${a ? "new" : "existing"} token.`), a ? n(o.token) : Promise.resolve();
    };
    this.o = (o) => {
      t.enqueueRetryable(() => r(o));
    };
    const i = (o) => {
      ht("FirebaseAppCheckTokenProvider", "AppCheck detected"), this.appCheck = o, this.o && this.appCheck.addTokenListener(this.o);
    };
    this.V.onInit((o) => i(o)), // Our users can initialize AppCheck after Firestore, so we give it
    // a chance to register itself with the component framework.
    setTimeout(() => {
      if (!this.appCheck) {
        const o = this.V.getImmediate({
          optional: !0
        });
        o ? i(o) : (
          // If AppCheck is still not available, proceed without it.
          ht("FirebaseAppCheckTokenProvider", "AppCheck not yet detected")
        );
      }
    }, 0);
  }
  getToken() {
    if (this.p)
      return Promise.resolve(new GD(this.p));
    const t = this.forceRefresh;
    return this.forceRefresh = !1, this.appCheck ? this.appCheck.getToken(t).then((n) => n ? (jn(typeof n.token == "string", 44558, {
      tokenResult: n
    }), this.m = n.token, new GD(n.token)) : null) : Promise.resolve(null);
  }
  invalidateToken() {
    this.forceRefresh = !0;
  }
  shutdown() {
    this.appCheck && this.o && this.appCheck.removeTokenListener(this.o), this.o = void 0;
  }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function Ape(e) {
  const t = (
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    typeof self < "u" && (self.crypto || self.msCrypto)
  ), n = new Uint8Array(e);
  if (t && typeof t.getRandomValues == "function")
    t.getRandomValues(n);
  else
    for (let r = 0; r < e; r++)
      n[r] = Math.floor(256 * Math.random());
  return n;
}
/**
 * @license
 * Copyright 2023 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function BU() {
  return new TextEncoder();
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class kO {
  static newId() {
    const t = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789", n = 62 * Math.floor(4.129032258064516);
    let r = "";
    for (; r.length < 20; ) {
      const i = Ape(40);
      for (let o = 0; o < i.length; ++o)
        r.length < 20 && i[o] < n && (r += t.charAt(i[o] % 62));
    }
    return r;
  }
}
function hn(e, t) {
  return e < t ? -1 : e > t ? 1 : 0;
}
function NI(e, t) {
  let n = 0;
  for (; n < e.length && n < t.length; ) {
    const r = e.codePointAt(n), i = t.codePointAt(n);
    if (r !== i) {
      if (r < 128 && i < 128)
        return hn(r, i);
      {
        const o = BU(), a = Rpe(o.encode(KD(e, n)), o.encode(KD(t, n)));
        return a !== 0 ? a : hn(r, i);
      }
    }
    n += r > 65535 ? 2 : 1;
  }
  return hn(e.length, t.length);
}
function KD(e, t) {
  return e.codePointAt(t) > 65535 ? e.substring(t, t + 2) : e.substring(t, t + 1);
}
function Rpe(e, t) {
  for (let n = 0; n < e.length && n < t.length; ++n)
    if (e[n] !== t[n])
      return hn(e[n], t[n]);
  return hn(e.length, t.length);
}
function ug(e, t, n) {
  return e.length === t.length && e.every((r, i) => n(r, t[i]));
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const YD = "__name__";
class Bs {
  constructor(t, n, r) {
    n === void 0 ? n = 0 : n > t.length && Wt(637, {
      offset: n,
      range: t.length
    }), r === void 0 ? r = t.length - n : r > t.length - n && Wt(1746, {
      length: r,
      range: t.length - n
    }), this.segments = t, this.offset = n, this.len = r;
  }
  get length() {
    return this.len;
  }
  isEqual(t) {
    return Bs.comparator(this, t) === 0;
  }
  child(t) {
    const n = this.segments.slice(this.offset, this.limit());
    return t instanceof Bs ? t.forEach((r) => {
      n.push(r);
    }) : n.push(t), this.construct(n);
  }
  /** The index of one past the last segment of the path. */
  limit() {
    return this.offset + this.length;
  }
  popFirst(t) {
    return t = t === void 0 ? 1 : t, this.construct(this.segments, this.offset + t, this.length - t);
  }
  popLast() {
    return this.construct(this.segments, this.offset, this.length - 1);
  }
  firstSegment() {
    return this.segments[this.offset];
  }
  lastSegment() {
    return this.get(this.length - 1);
  }
  get(t) {
    return this.segments[this.offset + t];
  }
  isEmpty() {
    return this.length === 0;
  }
  isPrefixOf(t) {
    if (t.length < this.length)
      return !1;
    for (let n = 0; n < this.length; n++)
      if (this.get(n) !== t.get(n))
        return !1;
    return !0;
  }
  isImmediateParentOf(t) {
    if (this.length + 1 !== t.length)
      return !1;
    for (let n = 0; n < this.length; n++)
      if (this.get(n) !== t.get(n))
        return !1;
    return !0;
  }
  forEach(t) {
    for (let n = this.offset, r = this.limit(); n < r; n++)
      t(this.segments[n]);
  }
  toArray() {
    return this.segments.slice(this.offset, this.limit());
  }
  /**
   * Compare 2 paths segment by segment, prioritizing numeric IDs
   * (e.g., "__id123__") in numeric ascending order, followed by string
   * segments in lexicographical order.
   */
  static comparator(t, n) {
    const r = Math.min(t.length, n.length);
    for (let i = 0; i < r; i++) {
      const o = Bs.compareSegments(t.get(i), n.get(i));
      if (o !== 0)
        return o;
    }
    return hn(t.length, n.length);
  }
  static compareSegments(t, n) {
    const r = Bs.isNumericId(t), i = Bs.isNumericId(n);
    return r && !i ? -1 : !r && i ? 1 : r && i ? Bs.extractNumericId(t).compare(Bs.extractNumericId(n)) : NI(t, n);
  }
  // Checks if a segment is a numeric ID (starts with "__id" and ends with "__").
  static isNumericId(t) {
    return t.startsWith("__id") && t.endsWith("__");
  }
  static extractNumericId(t) {
    return ou.fromString(t.substring(4, t.length - 2));
  }
}
class tr extends Bs {
  construct(t, n, r) {
    return new tr(t, n, r);
  }
  canonicalString() {
    return this.toArray().join("/");
  }
  toString() {
    return this.canonicalString();
  }
  /**
   * Returns a string representation of this path
   * where each path segment has been encoded with
   * `encodeURIComponent`.
   */
  toUriEncodedString() {
    return this.toArray().map(encodeURIComponent).join("/");
  }
  /**
   * Creates a resource path from the given slash-delimited string. If multiple
   * arguments are provided, all components are combined. Leading and trailing
   * slashes from all components are ignored.
   */
  static fromString(...t) {
    const n = [];
    for (const r of t) {
      if (r.indexOf("//") >= 0)
        throw new Ye(Se.INVALID_ARGUMENT, `Invalid segment (${r}). Paths must not contain // in them.`);
      n.push(...r.split("/").filter((i) => i.length > 0));
    }
    return new tr(n);
  }
  static emptyPath() {
    return new tr([]);
  }
}
const $pe = /^[_a-zA-Z][_a-zA-Z0-9]*$/;
class Vi extends Bs {
  construct(t, n, r) {
    return new Vi(t, n, r);
  }
  /**
   * Returns true if the string could be used as a segment in a field path
   * without escaping.
   */
  static isValidIdentifier(t) {
    return $pe.test(t);
  }
  canonicalString() {
    return this.toArray().map((t) => (t = t.replace(/\\/g, "\\\\").replace(/`/g, "\\`"), Vi.isValidIdentifier(t) || (t = "`" + t + "`"), t)).join(".");
  }
  toString() {
    return this.canonicalString();
  }
  /**
   * Returns true if this field references the key of a document.
   */
  isKeyField() {
    return this.length === 1 && this.get(0) === YD;
  }
  /**
   * The field designating the key of a document.
   */
  static keyField() {
    return new Vi([YD]);
  }
  /**
   * Parses a field string from the given server-formatted string.
   *
   * - Splitting the empty string is not allowed (for now at least).
   * - Empty segments within the string (e.g. if there are two consecutive
   *   separators) are not allowed.
   *
   * TODO(b/37244157): we should make this more strict. Right now, it allows
   * non-identifier path components, even if they aren't escaped.
   */
  static fromServerFormat(t) {
    const n = [];
    let r = "", i = 0;
    const o = () => {
      if (r.length === 0)
        throw new Ye(Se.INVALID_ARGUMENT, `Invalid field path (${t}). Paths must not be empty, begin with '.', end with '.', or contain '..'`);
      n.push(r), r = "";
    };
    let a = !1;
    for (; i < t.length; ) {
      const s = t[i];
      if (s === "\\") {
        if (i + 1 === t.length)
          throw new Ye(Se.INVALID_ARGUMENT, "Path has trailing escape character: " + t);
        const c = t[i + 1];
        if (c !== "\\" && c !== "." && c !== "`")
          throw new Ye(Se.INVALID_ARGUMENT, "Path has invalid escape sequence: " + t);
        r += c, i += 2;
      } else
        s === "`" ? (a = !a, i++) : s !== "." || a ? (r += s, i++) : (o(), i++);
    }
    if (o(), a)
      throw new Ye(Se.INVALID_ARGUMENT, "Unterminated ` in path: " + t);
    return new Vi(n);
  }
  static emptyPath() {
    return new Vi([]);
  }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class $t {
  constructor(t) {
    this.path = t;
  }
  static fromPath(t) {
    return new $t(tr.fromString(t));
  }
  static fromName(t) {
    return new $t(tr.fromString(t).popFirst(5));
  }
  static empty() {
    return new $t(tr.emptyPath());
  }
  get collectionGroup() {
    return this.path.popLast().lastSegment();
  }
  /** Returns true if the document is in the specified collectionId. */
  hasCollectionId(t) {
    return this.path.length >= 2 && this.path.get(this.path.length - 2) === t;
  }
  /** Returns the collection group (i.e. the name of the parent collection) for this key. */
  getCollectionGroup() {
    return this.path.get(this.path.length - 2);
  }
  /** Returns the fully qualified path to the parent collection. */
  getCollectionPath() {
    return this.path.popLast();
  }
  isEqual(t) {
    return t !== null && tr.comparator(this.path, t.path) === 0;
  }
  toString() {
    return this.path.toString();
  }
  static comparator(t, n) {
    return tr.comparator(t.path, n.path);
  }
  static isDocumentKey(t) {
    return t.length % 2 == 0;
  }
  /**
   * Creates and returns a new document key with the given segments.
   *
   * @param segments - The segments of the path to the document
   * @returns A new instance of DocumentKey
   */
  static fromSegments(t) {
    return new $t(new tr(t.slice()));
  }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function zU(e, t, n) {
  if (!n)
    throw new Ye(Se.INVALID_ARGUMENT, `Function ${e}() cannot be called with an empty ${t}.`);
}
function Ope(e, t, n, r) {
  if (t === !0 && r === !0)
    throw new Ye(Se.INVALID_ARGUMENT, `${e} and ${n} cannot be used together.`);
}
function XD(e) {
  if (!$t.isDocumentKey(e))
    throw new Ye(Se.INVALID_ARGUMENT, `Invalid document reference. Document references must have an even number of segments, but ${e} has ${e.length}.`);
}
function QD(e) {
  if ($t.isDocumentKey(e))
    throw new Ye(Se.INVALID_ARGUMENT, `Invalid collection reference. Collection references must have an odd number of segments, but ${e} has ${e.length}.`);
}
function HU(e) {
  return typeof e == "object" && e !== null && (Object.getPrototypeOf(e) === Object.prototype || Object.getPrototypeOf(e) === null);
}
function tx(e) {
  if (e === void 0)
    return "undefined";
  if (e === null)
    return "null";
  if (typeof e == "string")
    return e.length > 20 && (e = `${e.substring(0, 20)}...`), JSON.stringify(e);
  if (typeof e == "number" || typeof e == "boolean")
    return "" + e;
  if (typeof e == "object") {
    if (e instanceof Array)
      return "an array";
    {
      const t = (
        /** try to get the constructor name for an object. */
        function(r) {
          return r.constructor ? r.constructor.name : null;
        }(e)
      );
      return t ? `a custom ${t} object` : "an object";
    }
  }
  return typeof e == "function" ? "a function" : Wt(12329, {
    type: typeof e
  });
}
function Oo(e, t) {
  if ("_delegate" in e && // Unwrap Compat types
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  (e = e._delegate), !(e instanceof t)) {
    if (t.name === e.constructor.name)
      throw new Ye(Se.INVALID_ARGUMENT, "Type does not match the expected instance. Did you pass a reference from a different Firestore SDK?");
    {
      const n = tx(e);
      throw new Ye(Se.INVALID_ARGUMENT, `Expected type '${t.name}', but it was: ${n}`);
    }
  }
  return e;
}
function UU(e, t) {
  if (t <= 0)
    throw new Ye(Se.INVALID_ARGUMENT, `Function ${e}() requires a positive number, but it was: ${t}.`);
}
/**
 * @license
 * Copyright 2025 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function li(e, t) {
  const n = {
    typeString: e
  };
  return t && (n.value = t), n;
}
function zv(e, t) {
  if (!HU(e))
    throw new Ye(Se.INVALID_ARGUMENT, "JSON must be an object");
  let n;
  for (const r in t)
    if (t[r]) {
      const i = t[r].typeString, o = "value" in t[r] ? {
        value: t[r].value
      } : void 0;
      if (!(r in e)) {
        n = `JSON missing required field: '${r}'`;
        break;
      }
      const a = e[r];
      if (i && typeof a !== i) {
        n = `JSON field '${r}' must be a ${i}.`;
        break;
      }
      if (o !== void 0 && a !== o.value) {
        n = `Expected '${r}' field to equal '${o.value}'`;
        break;
      }
    }
  if (n)
    throw new Ye(Se.INVALID_ARGUMENT, n);
  return !0;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const JD = -62135596800, ZD = 1e6;
class qn {
  /**
   * Creates a new timestamp with the current date, with millisecond precision.
   *
   * @returns a new timestamp representing the current date.
   */
  static now() {
    return qn.fromMillis(Date.now());
  }
  /**
   * Creates a new timestamp from the given date.
   *
   * @param date - The date to initialize the `Timestamp` from.
   * @returns A new `Timestamp` representing the same point in time as the given
   *     date.
   */
  static fromDate(t) {
    return qn.fromMillis(t.getTime());
  }
  /**
   * Creates a new timestamp from the given number of milliseconds.
   *
   * @param milliseconds - Number of milliseconds since Unix epoch
   *     1970-01-01T00:00:00Z.
   * @returns A new `Timestamp` representing the same point in time as the given
   *     number of milliseconds.
   */
  static fromMillis(t) {
    const n = Math.floor(t / 1e3), r = Math.floor((t - 1e3 * n) * ZD);
    return new qn(n, r);
  }
  /**
   * Creates a new timestamp.
   *
   * @param seconds - The number of seconds of UTC time since Unix epoch
   *     1970-01-01T00:00:00Z. Must be from 0001-01-01T00:00:00Z to
   *     9999-12-31T23:59:59Z inclusive.
   * @param nanoseconds - The non-negative fractions of a second at nanosecond
   *     resolution. Negative second values with fractions must still have
   *     non-negative nanoseconds values that count forward in time. Must be
   *     from 0 to 999,999,999 inclusive.
   */
  constructor(t, n) {
    if (this.seconds = t, this.nanoseconds = n, n < 0)
      throw new Ye(Se.INVALID_ARGUMENT, "Timestamp nanoseconds out of range: " + n);
    if (n >= 1e9)
      throw new Ye(Se.INVALID_ARGUMENT, "Timestamp nanoseconds out of range: " + n);
    if (t < JD)
      throw new Ye(Se.INVALID_ARGUMENT, "Timestamp seconds out of range: " + t);
    if (t >= 253402300800)
      throw new Ye(Se.INVALID_ARGUMENT, "Timestamp seconds out of range: " + t);
  }
  /**
   * Converts a `Timestamp` to a JavaScript `Date` object. This conversion
   * causes a loss of precision since `Date` objects only support millisecond
   * precision.
   *
   * @returns JavaScript `Date` object representing the same point in time as
   *     this `Timestamp`, with millisecond precision.
   */
  toDate() {
    return new Date(this.toMillis());
  }
  /**
   * Converts a `Timestamp` to a numeric timestamp (in milliseconds since
   * epoch). This operation causes a loss of precision.
   *
   * @returns The point in time corresponding to this timestamp, represented as
   *     the number of milliseconds since Unix epoch 1970-01-01T00:00:00Z.
   */
  toMillis() {
    return 1e3 * this.seconds + this.nanoseconds / ZD;
  }
  _compareTo(t) {
    return this.seconds === t.seconds ? hn(this.nanoseconds, t.nanoseconds) : hn(this.seconds, t.seconds);
  }
  /**
   * Returns true if this `Timestamp` is equal to the provided one.
   *
   * @param other - The `Timestamp` to compare against.
   * @returns true if this `Timestamp` is equal to the provided one.
   */
  isEqual(t) {
    return t.seconds === this.seconds && t.nanoseconds === this.nanoseconds;
  }
  /** Returns a textual representation of this `Timestamp`. */
  toString() {
    return "Timestamp(seconds=" + this.seconds + ", nanoseconds=" + this.nanoseconds + ")";
  }
  /**
   * Returns a JSON-serializable representation of this `Timestamp`.
   */
  toJSON() {
    return {
      type: qn._jsonSchemaVersion,
      seconds: this.seconds,
      nanoseconds: this.nanoseconds
    };
  }
  /**
   * Builds a `Timestamp` instance from a JSON object created by {@link Timestamp.toJSON}.
   */
  static fromJSON(t) {
    if (zv(t, qn._jsonSchema))
      return new qn(t.seconds, t.nanoseconds);
  }
  /**
   * Converts this object to a primitive string, which allows `Timestamp` objects
   * to be compared using the `>`, `<=`, `>=` and `>` operators.
   */
  valueOf() {
    const t = this.seconds - JD;
    return String(t).padStart(12, "0") + "." + String(this.nanoseconds).padStart(9, "0");
  }
}
qn._jsonSchemaVersion = "firestore/timestamp/1.0", qn._jsonSchema = {
  type: li("string", qn._jsonSchemaVersion),
  seconds: li("number"),
  nanoseconds: li("number")
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class Gt {
  static fromTimestamp(t) {
    return new Gt(t);
  }
  static min() {
    return new Gt(new qn(0, 0));
  }
  static max() {
    return new Gt(new qn(253402300799, 999999999));
  }
  constructor(t) {
    this.timestamp = t;
  }
  compareTo(t) {
    return this.timestamp._compareTo(t.timestamp);
  }
  isEqual(t) {
    return this.timestamp.isEqual(t.timestamp);
  }
  /** Returns a number representation of the version for use in spec tests. */
  toMicroseconds() {
    return 1e6 * this.timestamp.seconds + this.timestamp.nanoseconds / 1e3;
  }
  toString() {
    return "SnapshotVersion(" + this.timestamp.toString() + ")";
  }
  toTimestamp() {
    return this.timestamp;
  }
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const j0 = -1;
function Ppe(e, t) {
  const n = e.toTimestamp().seconds, r = e.toTimestamp().nanoseconds + 1, i = Gt.fromTimestamp(r === 1e9 ? new qn(n + 1, 0) : new qn(n, r));
  return new vu(i, $t.empty(), t);
}
function Mpe(e) {
  return new vu(e.readTime, e.key, j0);
}
class vu {
  constructor(t, n, r) {
    this.readTime = t, this.documentKey = n, this.largestBatchId = r;
  }
  /** Returns an offset that sorts before all regular offsets. */
  static min() {
    return new vu(Gt.min(), $t.empty(), j0);
  }
  /** Returns an offset that sorts after all regular offsets. */
  static max() {
    return new vu(Gt.max(), $t.empty(), j0);
  }
}
function kpe(e, t) {
  let n = e.readTime.compareTo(t.readTime);
  return n !== 0 ? n : (n = $t.comparator(e.documentKey, t.documentKey), n !== 0 ? n : hn(e.largestBatchId, t.largestBatchId));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const Npe = "The current tab is not in the required state to perform this operation. It might be necessary to refresh the browser tab.";
class Dpe {
  constructor() {
    this.onCommittedListeners = [];
  }
  addOnCommittedListener(t) {
    this.onCommittedListeners.push(t);
  }
  raiseOnCommittedEvent() {
    this.onCommittedListeners.forEach((t) => t());
  }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
async function up(e) {
  if (e.code !== Se.FAILED_PRECONDITION || e.message !== Npe)
    throw e;
  ht("LocalStore", "Unexpectedly lost primary lease");
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class Te {
  constructor(t) {
    this.nextCallback = null, this.catchCallback = null, // When the operation resolves, we'll set result or error and mark isDone.
    this.result = void 0, this.error = void 0, this.isDone = !1, // Set to true when .then() or .catch() are called and prevents additional
    // chaining.
    this.callbackAttached = !1, t((n) => {
      this.isDone = !0, this.result = n, this.nextCallback && // value should be defined unless T is Void, but we can't express
      // that in the type system.
      this.nextCallback(n);
    }, (n) => {
      this.isDone = !0, this.error = n, this.catchCallback && this.catchCallback(n);
    });
  }
  catch(t) {
    return this.next(void 0, t);
  }
  next(t, n) {
    return this.callbackAttached && Wt(59440), this.callbackAttached = !0, this.isDone ? this.error ? this.wrapFailure(n, this.error) : this.wrapSuccess(t, this.result) : new Te((r, i) => {
      this.nextCallback = (o) => {
        this.wrapSuccess(t, o).next(r, i);
      }, this.catchCallback = (o) => {
        this.wrapFailure(n, o).next(r, i);
      };
    });
  }
  toPromise() {
    return new Promise((t, n) => {
      this.next(t, n);
    });
  }
  wrapUserFunction(t) {
    try {
      const n = t();
      return n instanceof Te ? n : Te.resolve(n);
    } catch (n) {
      return Te.reject(n);
    }
  }
  wrapSuccess(t, n) {
    return t ? this.wrapUserFunction(() => t(n)) : Te.resolve(n);
  }
  wrapFailure(t, n) {
    return t ? this.wrapUserFunction(() => t(n)) : Te.reject(n);
  }
  static resolve(t) {
    return new Te((n, r) => {
      n(t);
    });
  }
  static reject(t) {
    return new Te((n, r) => {
      r(t);
    });
  }
  static waitFor(t) {
    return new Te((n, r) => {
      let i = 0, o = 0, a = !1;
      t.forEach((s) => {
        ++i, s.next(() => {
          ++o, a && o === i && n();
        }, (c) => r(c));
      }), a = !0, o === i && n();
    });
  }
  /**
   * Given an array of predicate functions that asynchronously evaluate to a
   * boolean, implements a short-circuiting `or` between the results. Predicates
   * will be evaluated until one of them returns `true`, then stop. The final
   * result will be whether any of them returned `true`.
   */
  static or(t) {
    let n = Te.resolve(!1);
    for (const r of t)
      n = n.next((i) => i ? Te.resolve(i) : r());
    return n;
  }
  static forEach(t, n) {
    const r = [];
    return t.forEach((i, o) => {
      r.push(n.call(this, i, o));
    }), this.waitFor(r);
  }
  /**
   * Concurrently map all array elements through asynchronous function.
   */
  static mapArray(t, n) {
    return new Te((r, i) => {
      const o = t.length, a = new Array(o);
      let s = 0;
      for (let c = 0; c < o; c++) {
        const l = c;
        n(t[l]).next((u) => {
          a[l] = u, ++s, s === o && r(a);
        }, (u) => i(u));
      }
    });
  }
  /**
   * An alternative to recursive PersistencePromise calls, that avoids
   * potential memory problems from unbounded chains of promises.
   *
   * The `action` will be called repeatedly while `condition` is true.
   */
  static doWhile(t, n) {
    return new Te((r, i) => {
      const o = () => {
        t() === !0 ? n().next(() => {
          o();
        }, i) : r();
      };
      o();
    });
  }
}
function Lpe(e) {
  const t = e.match(/Android ([\d.]+)/i), n = t ? t[1].split(".").slice(0, 2).join(".") : "-1";
  return Number(n);
}
function dp(e) {
  return e.name === "IndexedDbTransactionError";
}
/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class nx {
  constructor(t, n) {
    this.previousValue = t, n && (n.sequenceNumberHandler = (r) => this._e(r), this.ae = (r) => n.writeSequenceNumber(r));
  }
  _e(t) {
    return this.previousValue = Math.max(t, this.previousValue), this.previousValue;
  }
  next() {
    const t = ++this.previousValue;
    return this.ae && this.ae(t), t;
  }
}
nx.ue = -1;
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const NO = -1;
function rx(e) {
  return e == null;
}
function C_(e) {
  return e === 0 && 1 / e == -1 / 0;
}
function jpe(e) {
  return typeof e == "number" && Number.isInteger(e) && !C_(e) && e <= Number.MAX_SAFE_INTEGER && e >= Number.MIN_SAFE_INTEGER;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const WU = "";
function Fpe(e) {
  let t = "";
  for (let n = 0; n < e.length; n++)
    t.length > 0 && (t = e7(t)), t = Vpe(e.get(n), t);
  return e7(t);
}
function Vpe(e, t) {
  let n = t;
  const r = e.length;
  for (let i = 0; i < r; i++) {
    const o = e.charAt(i);
    switch (o) {
      case "\0":
        n += "";
        break;
      case WU:
        n += "";
        break;
      default:
        n += o;
    }
  }
  return n;
}
function e7(e) {
  return e + WU + "";
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function t7(e) {
  let t = 0;
  for (const n in e)
    Object.prototype.hasOwnProperty.call(e, n) && t++;
  return t;
}
function Lu(e, t) {
  for (const n in e)
    Object.prototype.hasOwnProperty.call(e, n) && t(n, e[n]);
}
function Bpe(e, t) {
  const n = [];
  for (const r in e)
    Object.prototype.hasOwnProperty.call(e, r) && n.push(t(e[r], r, e));
  return n;
}
function qU(e) {
  for (const t in e)
    if (Object.prototype.hasOwnProperty.call(e, t))
      return !1;
  return !0;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class jr {
  constructor(t, n) {
    this.comparator = t, this.root = n || Fi.EMPTY;
  }
  // Returns a copy of the map, with the specified key/value added or replaced.
  insert(t, n) {
    return new jr(this.comparator, this.root.insert(t, n, this.comparator).copy(null, null, Fi.BLACK, null, null));
  }
  // Returns a copy of the map, with the specified key removed.
  remove(t) {
    return new jr(this.comparator, this.root.remove(t, this.comparator).copy(null, null, Fi.BLACK, null, null));
  }
  // Returns the value of the node with the given key, or null.
  get(t) {
    let n = this.root;
    for (; !n.isEmpty(); ) {
      const r = this.comparator(t, n.key);
      if (r === 0)
        return n.value;
      r < 0 ? n = n.left : r > 0 && (n = n.right);
    }
    return null;
  }
  // Returns the index of the element in this sorted map, or -1 if it doesn't
  // exist.
  indexOf(t) {
    let n = 0, r = this.root;
    for (; !r.isEmpty(); ) {
      const i = this.comparator(t, r.key);
      if (i === 0)
        return n + r.left.size;
      i < 0 ? r = r.left : (
        // Count all nodes left of the node plus the node itself
        (n += r.left.size + 1, r = r.right)
      );
    }
    return -1;
  }
  isEmpty() {
    return this.root.isEmpty();
  }
  // Returns the total number of nodes in the map.
  get size() {
    return this.root.size;
  }
  // Returns the minimum key in the map.
  minKey() {
    return this.root.minKey();
  }
  // Returns the maximum key in the map.
  maxKey() {
    return this.root.maxKey();
  }
  // Traverses the map in key order and calls the specified action function
  // for each key/value pair. If action returns true, traversal is aborted.
  // Returns the first truthy value returned by action, or the last falsey
  // value returned by action.
  inorderTraversal(t) {
    return this.root.inorderTraversal(t);
  }
  forEach(t) {
    this.inorderTraversal((n, r) => (t(n, r), !1));
  }
  toString() {
    const t = [];
    return this.inorderTraversal((n, r) => (t.push(`${n}:${r}`), !1)), `{${t.join(", ")}}`;
  }
  // Traverses the map in reverse key order and calls the specified action
  // function for each key/value pair. If action returns true, traversal is
  // aborted.
  // Returns the first truthy value returned by action, or the last falsey
  // value returned by action.
  reverseTraversal(t) {
    return this.root.reverseTraversal(t);
  }
  // Returns an iterator over the SortedMap.
  getIterator() {
    return new mb(this.root, null, this.comparator, !1);
  }
  getIteratorFrom(t) {
    return new mb(this.root, t, this.comparator, !1);
  }
  getReverseIterator() {
    return new mb(this.root, null, this.comparator, !0);
  }
  getReverseIteratorFrom(t) {
    return new mb(this.root, t, this.comparator, !0);
  }
}
class mb {
  constructor(t, n, r, i) {
    this.isReverse = i, this.nodeStack = [];
    let o = 1;
    for (; !t.isEmpty(); )
      if (o = n ? r(t.key, n) : 1, // flip the comparison if we're going in reverse
      n && i && (o *= -1), o < 0)
        t = this.isReverse ? t.left : t.right;
      else {
        if (o === 0) {
          this.nodeStack.push(t);
          break;
        }
        this.nodeStack.push(t), t = this.isReverse ? t.right : t.left;
      }
  }
  getNext() {
    let t = this.nodeStack.pop();
    const n = {
      key: t.key,
      value: t.value
    };
    if (this.isReverse)
      for (t = t.left; !t.isEmpty(); )
        this.nodeStack.push(t), t = t.right;
    else
      for (t = t.right; !t.isEmpty(); )
        this.nodeStack.push(t), t = t.left;
    return n;
  }
  hasNext() {
    return this.nodeStack.length > 0;
  }
  peek() {
    if (this.nodeStack.length === 0)
      return null;
    const t = this.nodeStack[this.nodeStack.length - 1];
    return {
      key: t.key,
      value: t.value
    };
  }
}
class Fi {
  constructor(t, n, r, i, o) {
    this.key = t, this.value = n, this.color = r ?? Fi.RED, this.left = i ?? Fi.EMPTY, this.right = o ?? Fi.EMPTY, this.size = this.left.size + 1 + this.right.size;
  }
  // Returns a copy of the current node, optionally replacing pieces of it.
  copy(t, n, r, i, o) {
    return new Fi(t ?? this.key, n ?? this.value, r ?? this.color, i ?? this.left, o ?? this.right);
  }
  isEmpty() {
    return !1;
  }
  // Traverses the tree in key order and calls the specified action function
  // for each node. If action returns true, traversal is aborted.
  // Returns the first truthy value returned by action, or the last falsey
  // value returned by action.
  inorderTraversal(t) {
    return this.left.inorderTraversal(t) || t(this.key, this.value) || this.right.inorderTraversal(t);
  }
  // Traverses the tree in reverse key order and calls the specified action
  // function for each node. If action returns true, traversal is aborted.
  // Returns the first truthy value returned by action, or the last falsey
  // value returned by action.
  reverseTraversal(t) {
    return this.right.reverseTraversal(t) || t(this.key, this.value) || this.left.reverseTraversal(t);
  }
  // Returns the minimum node in the tree.
  min() {
    return this.left.isEmpty() ? this : this.left.min();
  }
  // Returns the maximum key in the tree.
  minKey() {
    return this.min().key;
  }
  // Returns the maximum key in the tree.
  maxKey() {
    return this.right.isEmpty() ? this.key : this.right.maxKey();
  }
  // Returns new tree, with the key/value added.
  insert(t, n, r) {
    let i = this;
    const o = r(t, i.key);
    return i = o < 0 ? i.copy(null, null, null, i.left.insert(t, n, r), null) : o === 0 ? i.copy(null, n, null, null, null) : i.copy(null, null, null, null, i.right.insert(t, n, r)), i.fixUp();
  }
  removeMin() {
    if (this.left.isEmpty())
      return Fi.EMPTY;
    let t = this;
    return t.left.isRed() || t.left.left.isRed() || (t = t.moveRedLeft()), t = t.copy(null, null, null, t.left.removeMin(), null), t.fixUp();
  }
  // Returns new tree, with the specified item removed.
  remove(t, n) {
    let r, i = this;
    if (n(t, i.key) < 0)
      i.left.isEmpty() || i.left.isRed() || i.left.left.isRed() || (i = i.moveRedLeft()), i = i.copy(null, null, null, i.left.remove(t, n), null);
    else {
      if (i.left.isRed() && (i = i.rotateRight()), i.right.isEmpty() || i.right.isRed() || i.right.left.isRed() || (i = i.moveRedRight()), n(t, i.key) === 0) {
        if (i.right.isEmpty())
          return Fi.EMPTY;
        r = i.right.min(), i = i.copy(r.key, r.value, null, null, i.right.removeMin());
      }
      i = i.copy(null, null, null, null, i.right.remove(t, n));
    }
    return i.fixUp();
  }
  isRed() {
    return this.color;
  }
  // Returns new tree after performing any needed rotations.
  fixUp() {
    let t = this;
    return t.right.isRed() && !t.left.isRed() && (t = t.rotateLeft()), t.left.isRed() && t.left.left.isRed() && (t = t.rotateRight()), t.left.isRed() && t.right.isRed() && (t = t.colorFlip()), t;
  }
  moveRedLeft() {
    let t = this.colorFlip();
    return t.right.left.isRed() && (t = t.copy(null, null, null, null, t.right.rotateRight()), t = t.rotateLeft(), t = t.colorFlip()), t;
  }
  moveRedRight() {
    let t = this.colorFlip();
    return t.left.left.isRed() && (t = t.rotateRight(), t = t.colorFlip()), t;
  }
  rotateLeft() {
    const t = this.copy(null, null, Fi.RED, null, this.right.left);
    return this.right.copy(null, null, this.color, t, null);
  }
  rotateRight() {
    const t = this.copy(null, null, Fi.RED, this.left.right, null);
    return this.left.copy(null, null, this.color, null, t);
  }
  colorFlip() {
    const t = this.left.copy(null, null, !this.left.color, null, null), n = this.right.copy(null, null, !this.right.color, null, null);
    return this.copy(null, null, !this.color, t, n);
  }
  // For testing.
  checkMaxDepth() {
    const t = this.check();
    return Math.pow(2, t) <= this.size + 1;
  }
  // In a balanced RB tree, the black-depth (number of black nodes) from root to
  // leaves is equal on both sides.  This function verifies that or asserts.
  check() {
    if (this.isRed() && this.left.isRed())
      throw Wt(43730, {
        key: this.key,
        value: this.value
      });
    if (this.right.isRed())
      throw Wt(14113, {
        key: this.key,
        value: this.value
      });
    const t = this.left.check();
    if (t !== this.right.check())
      throw Wt(27949);
    return t + (this.isRed() ? 0 : 1);
  }
}
Fi.EMPTY = null, Fi.RED = !0, Fi.BLACK = !1;
Fi.EMPTY = new // Represents an empty node (a leaf node in the Red-Black Tree).
class {
  constructor() {
    this.size = 0;
  }
  get key() {
    throw Wt(57766);
  }
  get value() {
    throw Wt(16141);
  }
  get color() {
    throw Wt(16727);
  }
  get left() {
    throw Wt(29726);
  }
  get right() {
    throw Wt(36894);
  }
  // Returns a copy of the current node.
  copy(t, n, r, i, o) {
    return this;
  }
  // Returns a copy of the tree, with the specified key/value added.
  insert(t, n, r) {
    return new Fi(t, n);
  }
  // Returns a copy of the tree, with the specified key removed.
  remove(t, n) {
    return this;
  }
  isEmpty() {
    return !0;
  }
  inorderTraversal(t) {
    return !1;
  }
  reverseTraversal(t) {
    return !1;
  }
  minKey() {
    return null;
  }
  maxKey() {
    return null;
  }
  isRed() {
    return !1;
  }
  // For testing.
  checkMaxDepth() {
    return !0;
  }
  check() {
    return 0;
  }
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class Si {
  constructor(t) {
    this.comparator = t, this.data = new jr(this.comparator);
  }
  has(t) {
    return this.data.get(t) !== null;
  }
  first() {
    return this.data.minKey();
  }
  last() {
    return this.data.maxKey();
  }
  get size() {
    return this.data.size;
  }
  indexOf(t) {
    return this.data.indexOf(t);
  }
  /** Iterates elements in order defined by "comparator" */
  forEach(t) {
    this.data.inorderTraversal((n, r) => (t(n), !1));
  }
  /** Iterates over `elem`s such that: range[0] &lt;= elem &lt; range[1]. */
  forEachInRange(t, n) {
    const r = this.data.getIteratorFrom(t[0]);
    for (; r.hasNext(); ) {
      const i = r.getNext();
      if (this.comparator(i.key, t[1]) >= 0)
        return;
      n(i.key);
    }
  }
  /**
   * Iterates over `elem`s such that: start &lt;= elem until false is returned.
   */
  forEachWhile(t, n) {
    let r;
    for (r = n !== void 0 ? this.data.getIteratorFrom(n) : this.data.getIterator(); r.hasNext(); )
      if (!t(r.getNext().key))
        return;
  }
  /** Finds the least element greater than or equal to `elem`. */
  firstAfterOrEqual(t) {
    const n = this.data.getIteratorFrom(t);
    return n.hasNext() ? n.getNext().key : null;
  }
  getIterator() {
    return new n7(this.data.getIterator());
  }
  getIteratorFrom(t) {
    return new n7(this.data.getIteratorFrom(t));
  }
  /** Inserts or updates an element */
  add(t) {
    return this.copy(this.data.remove(t).insert(t, !0));
  }
  /** Deletes an element */
  delete(t) {
    return this.has(t) ? this.copy(this.data.remove(t)) : this;
  }
  isEmpty() {
    return this.data.isEmpty();
  }
  unionWith(t) {
    let n = this;
    return n.size < t.size && (n = t, t = this), t.forEach((r) => {
      n = n.add(r);
    }), n;
  }
  isEqual(t) {
    if (!(t instanceof Si) || this.size !== t.size)
      return !1;
    const n = this.data.getIterator(), r = t.data.getIterator();
    for (; n.hasNext(); ) {
      const i = n.getNext().key, o = r.getNext().key;
      if (this.comparator(i, o) !== 0)
        return !1;
    }
    return !0;
  }
  toArray() {
    const t = [];
    return this.forEach((n) => {
      t.push(n);
    }), t;
  }
  toString() {
    const t = [];
    return this.forEach((n) => t.push(n)), "SortedSet(" + t.toString() + ")";
  }
  copy(t) {
    const n = new Si(this.comparator);
    return n.data = t, n;
  }
}
class n7 {
  constructor(t) {
    this.iter = t;
  }
  getNext() {
    return this.iter.getNext().key;
  }
  hasNext() {
    return this.iter.hasNext();
  }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class ga {
  constructor(t) {
    this.fields = t, // TODO(dimond): validation of FieldMask
    // Sort the field mask to support `FieldMask.isEqual()` and assert below.
    t.sort(Vi.comparator);
  }
  static empty() {
    return new ga([]);
  }
  /**
   * Returns a new FieldMask object that is the result of adding all the given
   * fields paths to this field mask.
   */
  unionWith(t) {
    let n = new Si(Vi.comparator);
    for (const r of this.fields)
      n = n.add(r);
    for (const r of t)
      n = n.add(r);
    return new ga(n.toArray());
  }
  /**
   * Verifies that `fieldPath` is included by at least one field in this field
   * mask.
   *
   * This is an O(n) operation, where `n` is the size of the field mask.
   */
  covers(t) {
    for (const n of this.fields)
      if (n.isPrefixOf(t))
        return !0;
    return !1;
  }
  isEqual(t) {
    return ug(this.fields, t.fields, (n, r) => n.isEqual(r));
  }
}
/**
 * @license
 * Copyright 2023 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class GU extends Error {
  constructor() {
    super(...arguments), this.name = "Base64DecodeError";
  }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class Hi {
  constructor(t) {
    this.binaryString = t;
  }
  static fromBase64String(t) {
    const n = function(i) {
      try {
        return atob(i);
      } catch (o) {
        throw typeof DOMException < "u" && o instanceof DOMException ? new GU("Invalid base64 string: " + o) : o;
      }
    }(t);
    return new Hi(n);
  }
  static fromUint8Array(t) {
    const n = (
      /**
      * Helper function to convert an Uint8array to a binary string.
      */
      function(i) {
        let o = "";
        for (let a = 0; a < i.length; ++a)
          o += String.fromCharCode(i[a]);
        return o;
      }(t)
    );
    return new Hi(n);
  }
  [Symbol.iterator]() {
    let t = 0;
    return {
      next: () => t < this.binaryString.length ? {
        value: this.binaryString.charCodeAt(t++),
        done: !1
      } : {
        value: void 0,
        done: !0
      }
    };
  }
  toBase64() {
    return function(n) {
      return btoa(n);
    }(this.binaryString);
  }
  toUint8Array() {
    return function(n) {
      const r = new Uint8Array(n.length);
      for (let i = 0; i < n.length; i++)
        r[i] = n.charCodeAt(i);
      return r;
    }(this.binaryString);
  }
  approximateByteSize() {
    return 2 * this.binaryString.length;
  }
  compareTo(t) {
    return hn(this.binaryString, t.binaryString);
  }
  isEqual(t) {
    return this.binaryString === t.binaryString;
  }
}
Hi.EMPTY_BYTE_STRING = new Hi("");
const zpe = new RegExp(/^\d{4}-\d\d-\d\dT\d\d:\d\d:\d\d(?:\.(\d+))?Z$/);
function yu(e) {
  if (jn(!!e, 39018), typeof e == "string") {
    let t = 0;
    const n = zpe.exec(e);
    if (jn(!!n, 46558, {
      timestamp: e
    }), n[1]) {
      let i = n[1];
      i = (i + "000000000").substr(0, 9), t = Number(i);
    }
    const r = new Date(e);
    return {
      seconds: Math.floor(r.getTime() / 1e3),
      nanos: t
    };
  }
  return {
    seconds: ei(e.seconds),
    nanos: ei(e.nanos)
  };
}
function ei(e) {
  return typeof e == "number" ? e : typeof e == "string" ? Number(e) : 0;
}
function bu(e) {
  return typeof e == "string" ? Hi.fromBase64String(e) : Hi.fromUint8Array(e);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const KU = "server_timestamp", YU = "__type__", XU = "__previous_value__", QU = "__local_write_time__";
function ix(e) {
  var t, n;
  return ((n = (((t = e == null ? void 0 : e.mapValue) === null || t === void 0 ? void 0 : t.fields) || {})[YU]) === null || n === void 0 ? void 0 : n.stringValue) === KU;
}
function ox(e) {
  const t = e.mapValue.fields[XU];
  return ix(t) ? ox(t) : t;
}
function F0(e) {
  const t = yu(e.mapValue.fields[QU].timestampValue);
  return new qn(t.seconds, t.nanos);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class Hpe {
  /**
   * Constructs a DatabaseInfo using the provided host, databaseId and
   * persistenceKey.
   *
   * @param databaseId - The database to use.
   * @param appId - The Firebase App Id.
   * @param persistenceKey - A unique identifier for this Firestore's local
   * storage (used in conjunction with the databaseId).
   * @param host - The Firestore backend host to connect to.
   * @param ssl - Whether to use SSL when connecting.
   * @param forceLongPolling - Whether to use the forceLongPolling option
   * when using WebChannel as the network transport.
   * @param autoDetectLongPolling - Whether to use the detectBufferingProxy
   * option when using WebChannel as the network transport.
   * @param longPollingOptions Options that configure long-polling.
   * @param useFetchStreams Whether to use the Fetch API instead of
   * XMLHTTPRequest
   */
  constructor(t, n, r, i, o, a, s, c, l, u) {
    this.databaseId = t, this.appId = n, this.persistenceKey = r, this.host = i, this.ssl = o, this.forceLongPolling = a, this.autoDetectLongPolling = s, this.longPollingOptions = c, this.useFetchStreams = l, this.isUsingEmulator = u;
  }
}
const V0 = "(default)";
class B0 {
  constructor(t, n) {
    this.projectId = t, this.database = n || V0;
  }
  static empty() {
    return new B0("", "");
  }
  get isDefaultDatabase() {
    return this.database === V0;
  }
  isEqual(t) {
    return t instanceof B0 && t.projectId === this.projectId && t.database === this.database;
  }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const JU = "__type__", ZU = "__max__", vb = {
  mapValue: {
    fields: {
      __type__: {
        stringValue: ZU
      }
    }
  }
}, eW = "__vector__", T_ = "value";
function _u(e) {
  return "nullValue" in e ? 0 : "booleanValue" in e ? 1 : "integerValue" in e || "doubleValue" in e ? 2 : "timestampValue" in e ? 3 : "stringValue" in e ? 5 : "bytesValue" in e ? 6 : "referenceValue" in e ? 7 : "geoPointValue" in e ? 8 : "arrayValue" in e ? 9 : "mapValue" in e ? ix(e) ? 4 : Wpe(e) ? 9007199254740991 : Upe(e) ? 10 : 11 : Wt(28295, {
    value: e
  });
}
function fc(e, t) {
  if (e === t)
    return !0;
  const n = _u(e);
  if (n !== _u(t))
    return !1;
  switch (n) {
    case 0:
    case 9007199254740991:
      return !0;
    case 1:
      return e.booleanValue === t.booleanValue;
    case 4:
      return F0(e).isEqual(F0(t));
    case 3:
      return function(i, o) {
        if (typeof i.timestampValue == "string" && typeof o.timestampValue == "string" && i.timestampValue.length === o.timestampValue.length)
          return i.timestampValue === o.timestampValue;
        const a = yu(i.timestampValue), s = yu(o.timestampValue);
        return a.seconds === s.seconds && a.nanos === s.nanos;
      }(e, t);
    case 5:
      return e.stringValue === t.stringValue;
    case 6:
      return function(i, o) {
        return bu(i.bytesValue).isEqual(bu(o.bytesValue));
      }(e, t);
    case 7:
      return e.referenceValue === t.referenceValue;
    case 8:
      return function(i, o) {
        return ei(i.geoPointValue.latitude) === ei(o.geoPointValue.latitude) && ei(i.geoPointValue.longitude) === ei(o.geoPointValue.longitude);
      }(e, t);
    case 2:
      return function(i, o) {
        if ("integerValue" in i && "integerValue" in o)
          return ei(i.integerValue) === ei(o.integerValue);
        if ("doubleValue" in i && "doubleValue" in o) {
          const a = ei(i.doubleValue), s = ei(o.doubleValue);
          return a === s ? C_(a) === C_(s) : isNaN(a) && isNaN(s);
        }
        return !1;
      }(e, t);
    case 9:
      return ug(e.arrayValue.values || [], t.arrayValue.values || [], fc);
    case 10:
    case 11:
      return function(i, o) {
        const a = i.mapValue.fields || {}, s = o.mapValue.fields || {};
        if (t7(a) !== t7(s))
          return !1;
        for (const c in a)
          if (a.hasOwnProperty(c) && (s[c] === void 0 || !fc(a[c], s[c])))
            return !1;
        return !0;
      }(e, t);
    default:
      return Wt(52216, {
        left: e
      });
  }
}
function z0(e, t) {
  return (e.values || []).find((n) => fc(n, t)) !== void 0;
}
function dg(e, t) {
  if (e === t)
    return 0;
  const n = _u(e), r = _u(t);
  if (n !== r)
    return hn(n, r);
  switch (n) {
    case 0:
    case 9007199254740991:
      return 0;
    case 1:
      return hn(e.booleanValue, t.booleanValue);
    case 2:
      return function(o, a) {
        const s = ei(o.integerValue || o.doubleValue), c = ei(a.integerValue || a.doubleValue);
        return s < c ? -1 : s > c ? 1 : s === c ? 0 : (
          // one or both are NaN.
          isNaN(s) ? isNaN(c) ? 0 : -1 : 1
        );
      }(e, t);
    case 3:
      return r7(e.timestampValue, t.timestampValue);
    case 4:
      return r7(F0(e), F0(t));
    case 5:
      return NI(e.stringValue, t.stringValue);
    case 6:
      return function(o, a) {
        const s = bu(o), c = bu(a);
        return s.compareTo(c);
      }(e.bytesValue, t.bytesValue);
    case 7:
      return function(o, a) {
        const s = o.split("/"), c = a.split("/");
        for (let l = 0; l < s.length && l < c.length; l++) {
          const u = hn(s[l], c[l]);
          if (u !== 0)
            return u;
        }
        return hn(s.length, c.length);
      }(e.referenceValue, t.referenceValue);
    case 8:
      return function(o, a) {
        const s = hn(ei(o.latitude), ei(a.latitude));
        return s !== 0 ? s : hn(ei(o.longitude), ei(a.longitude));
      }(e.geoPointValue, t.geoPointValue);
    case 9:
      return i7(e.arrayValue, t.arrayValue);
    case 10:
      return function(o, a) {
        var s, c, l, u;
        const d = o.fields || {}, f = a.fields || {}, h = (s = d[T_]) === null || s === void 0 ? void 0 : s.arrayValue, p = (c = f[T_]) === null || c === void 0 ? void 0 : c.arrayValue, g = hn(((l = h == null ? void 0 : h.values) === null || l === void 0 ? void 0 : l.length) || 0, ((u = p == null ? void 0 : p.values) === null || u === void 0 ? void 0 : u.length) || 0);
        return g !== 0 ? g : i7(h, p);
      }(e.mapValue, t.mapValue);
    case 11:
      return function(o, a) {
        if (o === vb.mapValue && a === vb.mapValue)
          return 0;
        if (o === vb.mapValue)
          return 1;
        if (a === vb.mapValue)
          return -1;
        const s = o.fields || {}, c = Object.keys(s), l = a.fields || {}, u = Object.keys(l);
        c.sort(), u.sort();
        for (let d = 0; d < c.length && d < u.length; ++d) {
          const f = NI(c[d], u[d]);
          if (f !== 0)
            return f;
          const h = dg(s[c[d]], l[u[d]]);
          if (h !== 0)
            return h;
        }
        return hn(c.length, u.length);
      }(e.mapValue, t.mapValue);
    default:
      throw Wt(23264, {
        le: n
      });
  }
}
function r7(e, t) {
  if (typeof e == "string" && typeof t == "string" && e.length === t.length)
    return hn(e, t);
  const n = yu(e), r = yu(t), i = hn(n.seconds, r.seconds);
  return i !== 0 ? i : hn(n.nanos, r.nanos);
}
function i7(e, t) {
  const n = e.values || [], r = t.values || [];
  for (let i = 0; i < n.length && i < r.length; ++i) {
    const o = dg(n[i], r[i]);
    if (o)
      return o;
  }
  return hn(n.length, r.length);
}
function fg(e) {
  return DI(e);
}
function DI(e) {
  return "nullValue" in e ? "null" : "booleanValue" in e ? "" + e.booleanValue : "integerValue" in e ? "" + e.integerValue : "doubleValue" in e ? "" + e.doubleValue : "timestampValue" in e ? function(n) {
    const r = yu(n);
    return `time(${r.seconds},${r.nanos})`;
  }(e.timestampValue) : "stringValue" in e ? e.stringValue : "bytesValue" in e ? function(n) {
    return bu(n).toBase64();
  }(e.bytesValue) : "referenceValue" in e ? function(n) {
    return $t.fromName(n).toString();
  }(e.referenceValue) : "geoPointValue" in e ? function(n) {
    return `geo(${n.latitude},${n.longitude})`;
  }(e.geoPointValue) : "arrayValue" in e ? function(n) {
    let r = "[", i = !0;
    for (const o of n.values || [])
      i ? i = !1 : r += ",", r += DI(o);
    return r + "]";
  }(e.arrayValue) : "mapValue" in e ? function(n) {
    const r = Object.keys(n.fields || {}).sort();
    let i = "{", o = !0;
    for (const a of r)
      o ? o = !1 : i += ",", i += `${a}:${DI(n.fields[a])}`;
    return i + "}";
  }(e.mapValue) : Wt(61005, {
    value: e
  });
}
function O1(e) {
  switch (_u(e)) {
    case 0:
    case 1:
      return 4;
    case 2:
      return 8;
    case 3:
    case 8:
      return 16;
    case 4:
      const t = ox(e);
      return t ? 16 + O1(t) : 16;
    case 5:
      return 2 * e.stringValue.length;
    case 6:
      return bu(e.bytesValue).approximateByteSize();
    case 7:
      return e.referenceValue.length;
    case 9:
      return function(r) {
        return (r.values || []).reduce((i, o) => i + O1(o), 0);
      }(e.arrayValue);
    case 10:
    case 11:
      return function(r) {
        let i = 0;
        return Lu(r.fields, (o, a) => {
          i += o.length + O1(a);
        }), i;
      }(e.mapValue);
    default:
      throw Wt(13486, {
        value: e
      });
  }
}
function I_(e, t) {
  return {
    referenceValue: `projects/${e.projectId}/databases/${e.database}/documents/${t.path.canonicalString()}`
  };
}
function LI(e) {
  return !!e && "integerValue" in e;
}
function DO(e) {
  return !!e && "arrayValue" in e;
}
function o7(e) {
  return !!e && "nullValue" in e;
}
function a7(e) {
  return !!e && "doubleValue" in e && isNaN(Number(e.doubleValue));
}
function P1(e) {
  return !!e && "mapValue" in e;
}
function Upe(e) {
  var t, n;
  return ((n = (((t = e == null ? void 0 : e.mapValue) === null || t === void 0 ? void 0 : t.fields) || {})[JU]) === null || n === void 0 ? void 0 : n.stringValue) === eW;
}
function c0(e) {
  if (e.geoPointValue)
    return {
      geoPointValue: Object.assign({}, e.geoPointValue)
    };
  if (e.timestampValue && typeof e.timestampValue == "object")
    return {
      timestampValue: Object.assign({}, e.timestampValue)
    };
  if (e.mapValue) {
    const t = {
      mapValue: {
        fields: {}
      }
    };
    return Lu(e.mapValue.fields, (n, r) => t.mapValue.fields[n] = c0(r)), t;
  }
  if (e.arrayValue) {
    const t = {
      arrayValue: {
        values: []
      }
    };
    for (let n = 0; n < (e.arrayValue.values || []).length; ++n)
      t.arrayValue.values[n] = c0(e.arrayValue.values[n]);
    return t;
  }
  return Object.assign({}, e);
}
function Wpe(e) {
  return (((e.mapValue || {}).fields || {}).__type__ || {}).stringValue === ZU;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class Yo {
  constructor(t) {
    this.value = t;
  }
  static empty() {
    return new Yo({
      mapValue: {}
    });
  }
  /**
   * Returns the value at the given path or null.
   *
   * @param path - the path to search
   * @returns The value at the path or null if the path is not set.
   */
  field(t) {
    if (t.isEmpty())
      return this.value;
    {
      let n = this.value;
      for (let r = 0; r < t.length - 1; ++r)
        if (n = (n.mapValue.fields || {})[t.get(r)], !P1(n))
          return null;
      return n = (n.mapValue.fields || {})[t.lastSegment()], n || null;
    }
  }
  /**
   * Sets the field to the provided value.
   *
   * @param path - The field path to set.
   * @param value - The value to set.
   */
  set(t, n) {
    this.getFieldsMap(t.popLast())[t.lastSegment()] = c0(n);
  }
  /**
   * Sets the provided fields to the provided values.
   *
   * @param data - A map of fields to values (or null for deletes).
   */
  setAll(t) {
    let n = Vi.emptyPath(), r = {}, i = [];
    t.forEach((a, s) => {
      if (!n.isImmediateParentOf(s)) {
        const c = this.getFieldsMap(n);
        this.applyChanges(c, r, i), r = {}, i = [], n = s.popLast();
      }
      a ? r[s.lastSegment()] = c0(a) : i.push(s.lastSegment());
    });
    const o = this.getFieldsMap(n);
    this.applyChanges(o, r, i);
  }
  /**
   * Removes the field at the specified path. If there is no field at the
   * specified path, nothing is changed.
   *
   * @param path - The field path to remove.
   */
  delete(t) {
    const n = this.field(t.popLast());
    P1(n) && n.mapValue.fields && delete n.mapValue.fields[t.lastSegment()];
  }
  isEqual(t) {
    return fc(this.value, t.value);
  }
  /**
   * Returns the map that contains the leaf element of `path`. If the parent
   * entry does not yet exist, or if it is not a map, a new map will be created.
   */
  getFieldsMap(t) {
    let n = this.value;
    n.mapValue.fields || (n.mapValue = {
      fields: {}
    });
    for (let r = 0; r < t.length; ++r) {
      let i = n.mapValue.fields[t.get(r)];
      P1(i) && i.mapValue.fields || (i = {
        mapValue: {
          fields: {}
        }
      }, n.mapValue.fields[t.get(r)] = i), n = i;
    }
    return n.mapValue.fields;
  }
  /**
   * Modifies `fieldsMap` by adding, replacing or deleting the specified
   * entries.
   */
  applyChanges(t, n, r) {
    Lu(n, (i, o) => t[i] = o);
    for (const i of r)
      delete t[i];
  }
  clone() {
    return new Yo(c0(this.value));
  }
}
function tW(e) {
  const t = [];
  return Lu(e.fields, (n, r) => {
    const i = new Vi([n]);
    if (P1(r)) {
      const o = tW(r.mapValue).fields;
      if (o.length === 0)
        t.push(i);
      else
        for (const a of o)
          t.push(i.child(a));
    } else
      t.push(i);
  }), new ga(t);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class io {
  constructor(t, n, r, i, o, a, s) {
    this.key = t, this.documentType = n, this.version = r, this.readTime = i, this.createTime = o, this.data = a, this.documentState = s;
  }
  /**
   * Creates a document with no known version or data, but which can serve as
   * base document for mutations.
   */
  static newInvalidDocument(t) {
    return new io(
      t,
      0,
      /* version */
      Gt.min(),
      /* readTime */
      Gt.min(),
      /* createTime */
      Gt.min(),
      Yo.empty(),
      0
      /* DocumentState.SYNCED */
    );
  }
  /**
   * Creates a new document that is known to exist with the given data at the
   * given version.
   */
  static newFoundDocument(t, n, r, i) {
    return new io(
      t,
      1,
      /* version */
      n,
      /* readTime */
      Gt.min(),
      /* createTime */
      r,
      i,
      0
      /* DocumentState.SYNCED */
    );
  }
  /** Creates a new document that is known to not exist at the given version. */
  static newNoDocument(t, n) {
    return new io(
      t,
      2,
      /* version */
      n,
      /* readTime */
      Gt.min(),
      /* createTime */
      Gt.min(),
      Yo.empty(),
      0
      /* DocumentState.SYNCED */
    );
  }
  /**
   * Creates a new document that is known to exist at the given version but
   * whose data is not known (e.g. a document that was updated without a known
   * base document).
   */
  static newUnknownDocument(t, n) {
    return new io(
      t,
      3,
      /* version */
      n,
      /* readTime */
      Gt.min(),
      /* createTime */
      Gt.min(),
      Yo.empty(),
      2
      /* DocumentState.HAS_COMMITTED_MUTATIONS */
    );
  }
  /**
   * Changes the document type to indicate that it exists and that its version
   * and data are known.
   */
  convertToFoundDocument(t, n) {
    return !this.createTime.isEqual(Gt.min()) || this.documentType !== 2 && this.documentType !== 0 || (this.createTime = t), this.version = t, this.documentType = 1, this.data = n, this.documentState = 0, this;
  }
  /**
   * Changes the document type to indicate that it doesn't exist at the given
   * version.
   */
  convertToNoDocument(t) {
    return this.version = t, this.documentType = 2, this.data = Yo.empty(), this.documentState = 0, this;
  }
  /**
   * Changes the document type to indicate that it exists at a given version but
   * that its data is not known (e.g. a document that was updated without a known
   * base document).
   */
  convertToUnknownDocument(t) {
    return this.version = t, this.documentType = 3, this.data = Yo.empty(), this.documentState = 2, this;
  }
  setHasCommittedMutations() {
    return this.documentState = 2, this;
  }
  setHasLocalMutations() {
    return this.documentState = 1, this.version = Gt.min(), this;
  }
  setReadTime(t) {
    return this.readTime = t, this;
  }
  get hasLocalMutations() {
    return this.documentState === 1;
  }
  get hasCommittedMutations() {
    return this.documentState === 2;
  }
  get hasPendingWrites() {
    return this.hasLocalMutations || this.hasCommittedMutations;
  }
  isValidDocument() {
    return this.documentType !== 0;
  }
  isFoundDocument() {
    return this.documentType === 1;
  }
  isNoDocument() {
    return this.documentType === 2;
  }
  isUnknownDocument() {
    return this.documentType === 3;
  }
  isEqual(t) {
    return t instanceof io && this.key.isEqual(t.key) && this.version.isEqual(t.version) && this.documentType === t.documentType && this.documentState === t.documentState && this.data.isEqual(t.data);
  }
  mutableCopy() {
    return new io(this.key, this.documentType, this.version, this.readTime, this.createTime, this.data.clone(), this.documentState);
  }
  toString() {
    return `Document(${this.key}, ${this.version}, ${JSON.stringify(this.data.value)}, {createTime: ${this.createTime}}), {documentType: ${this.documentType}}), {documentState: ${this.documentState}})`;
  }
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class hg {
  constructor(t, n) {
    this.position = t, this.inclusive = n;
  }
}
function s7(e, t, n) {
  let r = 0;
  for (let i = 0; i < e.position.length; i++) {
    const o = t[i], a = e.position[i];
    if (o.field.isKeyField() ? r = $t.comparator($t.fromName(a.referenceValue), n.key) : r = dg(a, n.data.field(o.field)), o.dir === "desc" && (r *= -1), r !== 0)
      break;
  }
  return r;
}
function c7(e, t) {
  if (e === null)
    return t === null;
  if (t === null || e.inclusive !== t.inclusive || e.position.length !== t.position.length)
    return !1;
  for (let n = 0; n < e.position.length; n++)
    if (!fc(e.position[n], t.position[n]))
      return !1;
  return !0;
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class H0 {
  constructor(t, n = "asc") {
    this.field = t, this.dir = n;
  }
}
function qpe(e, t) {
  return e.dir === t.dir && e.field.isEqual(t.field);
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class nW {
}
class ci extends nW {
  constructor(t, n, r) {
    super(), this.field = t, this.op = n, this.value = r;
  }
  /**
   * Creates a filter based on the provided arguments.
   */
  static create(t, n, r) {
    return t.isKeyField() ? n === "in" || n === "not-in" ? this.createKeyFieldInFilter(t, n, r) : new Kpe(t, n, r) : n === "array-contains" ? new Qpe(t, r) : n === "in" ? new Jpe(t, r) : n === "not-in" ? new Zpe(t, r) : n === "array-contains-any" ? new eme(t, r) : new ci(t, n, r);
  }
  static createKeyFieldInFilter(t, n, r) {
    return n === "in" ? new Ype(t, r) : new Xpe(t, r);
  }
  matches(t) {
    const n = t.data.field(this.field);
    return this.op === "!=" ? n !== null && n.nullValue === void 0 && this.matchesComparison(dg(n, this.value)) : n !== null && _u(this.value) === _u(n) && this.matchesComparison(dg(n, this.value));
  }
  matchesComparison(t) {
    switch (this.op) {
      case "<":
        return t < 0;
      case "<=":
        return t <= 0;
      case "==":
        return t === 0;
      case "!=":
        return t !== 0;
      case ">":
        return t > 0;
      case ">=":
        return t >= 0;
      default:
        return Wt(47266, {
          operator: this.op
        });
    }
  }
  isInequality() {
    return [
      "<",
      "<=",
      ">",
      ">=",
      "!=",
      "not-in"
      /* Operator.NOT_IN */
    ].indexOf(this.op) >= 0;
  }
  getFlattenedFilters() {
    return [this];
  }
  getFilters() {
    return [this];
  }
}
class ws extends nW {
  constructor(t, n) {
    super(), this.filters = t, this.op = n, this.he = null;
  }
  /**
   * Creates a filter based on the provided arguments.
   */
  static create(t, n) {
    return new ws(t, n);
  }
  matches(t) {
    return rW(this) ? this.filters.find((n) => !n.matches(t)) === void 0 : this.filters.find((n) => n.matches(t)) !== void 0;
  }
  getFlattenedFilters() {
    return this.he !== null || (this.he = this.filters.reduce((t, n) => t.concat(n.getFlattenedFilters()), [])), this.he;
  }
  // Returns a mutable copy of `this.filters`
  getFilters() {
    return Object.assign([], this.filters);
  }
}
function rW(e) {
  return e.op === "and";
}
function iW(e) {
  return Gpe(e) && rW(e);
}
function Gpe(e) {
  for (const t of e.filters)
    if (t instanceof ws)
      return !1;
  return !0;
}
function jI(e) {
  if (e instanceof ci)
    return e.field.canonicalString() + e.op.toString() + fg(e.value);
  if (iW(e))
    return e.filters.map((t) => jI(t)).join(",");
  {
    const t = e.filters.map((n) => jI(n)).join(",");
    return `${e.op}(${t})`;
  }
}
function oW(e, t) {
  return e instanceof ci ? function(r, i) {
    return i instanceof ci && r.op === i.op && r.field.isEqual(i.field) && fc(r.value, i.value);
  }(e, t) : e instanceof ws ? function(r, i) {
    return i instanceof ws && r.op === i.op && r.filters.length === i.filters.length ? r.filters.reduce((o, a, s) => o && oW(a, i.filters[s]), !0) : !1;
  }(e, t) : void Wt(19439);
}
function aW(e) {
  return e instanceof ci ? function(n) {
    return `${n.field.canonicalString()} ${n.op} ${fg(n.value)}`;
  }(e) : e instanceof ws ? function(n) {
    return n.op.toString() + " {" + n.getFilters().map(aW).join(" ,") + "}";
  }(e) : "Filter";
}
class Kpe extends ci {
  constructor(t, n, r) {
    super(t, n, r), this.key = $t.fromName(r.referenceValue);
  }
  matches(t) {
    const n = $t.comparator(t.key, this.key);
    return this.matchesComparison(n);
  }
}
class Ype extends ci {
  constructor(t, n) {
    super(t, "in", n), this.keys = sW("in", n);
  }
  matches(t) {
    return this.keys.some((n) => n.isEqual(t.key));
  }
}
class Xpe extends ci {
  constructor(t, n) {
    super(t, "not-in", n), this.keys = sW("not-in", n);
  }
  matches(t) {
    return !this.keys.some((n) => n.isEqual(t.key));
  }
}
function sW(e, t) {
  var n;
  return (((n = t.arrayValue) === null || n === void 0 ? void 0 : n.values) || []).map((r) => $t.fromName(r.referenceValue));
}
class Qpe extends ci {
  constructor(t, n) {
    super(t, "array-contains", n);
  }
  matches(t) {
    const n = t.data.field(this.field);
    return DO(n) && z0(n.arrayValue, this.value);
  }
}
class Jpe extends ci {
  constructor(t, n) {
    super(t, "in", n);
  }
  matches(t) {
    const n = t.data.field(this.field);
    return n !== null && z0(this.value.arrayValue, n);
  }
}
class Zpe extends ci {
  constructor(t, n) {
    super(t, "not-in", n);
  }
  matches(t) {
    if (z0(this.value.arrayValue, {
      nullValue: "NULL_VALUE"
    }))
      return !1;
    const n = t.data.field(this.field);
    return n !== null && n.nullValue === void 0 && !z0(this.value.arrayValue, n);
  }
}
class eme extends ci {
  constructor(t, n) {
    super(t, "array-contains-any", n);
  }
  matches(t) {
    const n = t.data.field(this.field);
    return !(!DO(n) || !n.arrayValue.values) && n.arrayValue.values.some((r) => z0(this.value.arrayValue, r));
  }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class tme {
  constructor(t, n = null, r = [], i = [], o = null, a = null, s = null) {
    this.path = t, this.collectionGroup = n, this.orderBy = r, this.filters = i, this.limit = o, this.startAt = a, this.endAt = s, this.Pe = null;
  }
}
function l7(e, t = null, n = [], r = [], i = null, o = null, a = null) {
  return new tme(e, t, n, r, i, o, a);
}
function LO(e) {
  const t = qt(e);
  if (t.Pe === null) {
    let n = t.path.canonicalString();
    t.collectionGroup !== null && (n += "|cg:" + t.collectionGroup), n += "|f:", n += t.filters.map((r) => jI(r)).join(","), n += "|ob:", n += t.orderBy.map((r) => function(o) {
      return o.field.canonicalString() + o.dir;
    }(r)).join(","), rx(t.limit) || (n += "|l:", n += t.limit), t.startAt && (n += "|lb:", n += t.startAt.inclusive ? "b:" : "a:", n += t.startAt.position.map((r) => fg(r)).join(",")), t.endAt && (n += "|ub:", n += t.endAt.inclusive ? "a:" : "b:", n += t.endAt.position.map((r) => fg(r)).join(",")), t.Pe = n;
  }
  return t.Pe;
}
function jO(e, t) {
  if (e.limit !== t.limit || e.orderBy.length !== t.orderBy.length)
    return !1;
  for (let n = 0; n < e.orderBy.length; n++)
    if (!qpe(e.orderBy[n], t.orderBy[n]))
      return !1;
  if (e.filters.length !== t.filters.length)
    return !1;
  for (let n = 0; n < e.filters.length; n++)
    if (!oW(e.filters[n], t.filters[n]))
      return !1;
  return e.collectionGroup === t.collectionGroup && !!e.path.isEqual(t.path) && !!c7(e.startAt, t.startAt) && c7(e.endAt, t.endAt);
}
function FI(e) {
  return $t.isDocumentKey(e.path) && e.collectionGroup === null && e.filters.length === 0;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class ju {
  /**
   * Initializes a Query with a path and optional additional query constraints.
   * Path must currently be empty if this is a collection group query.
   */
  constructor(t, n = null, r = [], i = [], o = null, a = "F", s = null, c = null) {
    this.path = t, this.collectionGroup = n, this.explicitOrderBy = r, this.filters = i, this.limit = o, this.limitType = a, this.startAt = s, this.endAt = c, this.Te = null, // The corresponding `Target` of this `Query` instance, for use with
    // non-aggregate queries.
    this.Ie = null, // The corresponding `Target` of this `Query` instance, for use with
    // aggregate queries. Unlike targets for non-aggregate queries,
    // aggregate query targets do not contain normalized order-bys, they only
    // contain explicit order-bys.
    this.de = null, this.startAt, this.endAt;
  }
}
function nme(e, t, n, r, i, o, a, s) {
  return new ju(e, t, n, r, i, o, a, s);
}
function ax(e) {
  return new ju(e);
}
function u7(e) {
  return e.filters.length === 0 && e.limit === null && e.startAt == null && e.endAt == null && (e.explicitOrderBy.length === 0 || e.explicitOrderBy.length === 1 && e.explicitOrderBy[0].field.isKeyField());
}
function FO(e) {
  return e.collectionGroup !== null;
}
function Wh(e) {
  const t = qt(e);
  if (t.Te === null) {
    t.Te = [];
    const n = /* @__PURE__ */ new Set();
    for (const o of t.explicitOrderBy)
      t.Te.push(o), n.add(o.field.canonicalString());
    const r = t.explicitOrderBy.length > 0 ? t.explicitOrderBy[t.explicitOrderBy.length - 1].dir : "asc";
    (function(a) {
      let s = new Si(Vi.comparator);
      return a.filters.forEach((c) => {
        c.getFlattenedFilters().forEach((l) => {
          l.isInequality() && (s = s.add(l.field));
        });
      }), s;
    })(t).forEach((o) => {
      n.has(o.canonicalString()) || o.isKeyField() || t.Te.push(new H0(o, r));
    }), // Add the document key field to the last if it is not explicitly ordered.
    n.has(Vi.keyField().canonicalString()) || t.Te.push(new H0(Vi.keyField(), r));
  }
  return t.Te;
}
function nc(e) {
  const t = qt(e);
  return t.Ie || (t.Ie = cW(t, Wh(e))), t.Ie;
}
function rme(e) {
  const t = qt(e);
  return t.de || // Do not include implicit order-bys for aggregate queries.
  (t.de = cW(t, e.explicitOrderBy)), t.de;
}
function cW(e, t) {
  if (e.limitType === "F")
    return l7(e.path, e.collectionGroup, t, e.filters, e.limit, e.startAt, e.endAt);
  {
    t = t.map((i) => {
      const o = i.dir === "desc" ? "asc" : "desc";
      return new H0(i.field, o);
    });
    const n = e.endAt ? new hg(e.endAt.position, e.endAt.inclusive) : null, r = e.startAt ? new hg(e.startAt.position, e.startAt.inclusive) : null;
    return l7(e.path, e.collectionGroup, t, e.filters, e.limit, n, r);
  }
}
function VI(e, t) {
  const n = e.filters.concat([t]);
  return new ju(e.path, e.collectionGroup, e.explicitOrderBy.slice(), n, e.limit, e.limitType, e.startAt, e.endAt);
}
function A_(e, t, n) {
  return new ju(e.path, e.collectionGroup, e.explicitOrderBy.slice(), e.filters.slice(), t, n, e.startAt, e.endAt);
}
function sx(e, t) {
  return jO(nc(e), nc(t)) && e.limitType === t.limitType;
}
function lW(e) {
  return `${LO(nc(e))}|lt:${e.limitType}`;
}
function wh(e) {
  return `Query(target=${function(n) {
    let r = n.path.canonicalString();
    return n.collectionGroup !== null && (r += " collectionGroup=" + n.collectionGroup), n.filters.length > 0 && (r += `, filters: [${n.filters.map((i) => aW(i)).join(", ")}]`), rx(n.limit) || (r += ", limit: " + n.limit), n.orderBy.length > 0 && (r += `, orderBy: [${n.orderBy.map((i) => function(a) {
      return `${a.field.canonicalString()} (${a.dir})`;
    }(i)).join(", ")}]`), n.startAt && (r += ", startAt: ", r += n.startAt.inclusive ? "b:" : "a:", r += n.startAt.position.map((i) => fg(i)).join(",")), n.endAt && (r += ", endAt: ", r += n.endAt.inclusive ? "a:" : "b:", r += n.endAt.position.map((i) => fg(i)).join(",")), `Target(${r})`;
  }(nc(e))}; limitType=${e.limitType})`;
}
function cx(e, t) {
  return t.isFoundDocument() && function(r, i) {
    const o = i.key.path;
    return r.collectionGroup !== null ? i.key.hasCollectionId(r.collectionGroup) && r.path.isPrefixOf(o) : $t.isDocumentKey(r.path) ? r.path.isEqual(o) : r.path.isImmediateParentOf(o);
  }(e, t) && function(r, i) {
    for (const o of Wh(r))
      if (!o.field.isKeyField() && i.data.field(o.field) === null)
        return !1;
    return !0;
  }(e, t) && function(r, i) {
    for (const o of r.filters)
      if (!o.matches(i))
        return !1;
    return !0;
  }(e, t) && function(r, i) {
    return !(r.startAt && !/**
    * Returns true if a document sorts before a bound using the provided sort
    * order.
    */
    function(a, s, c) {
      const l = s7(a, s, c);
      return a.inclusive ? l <= 0 : l < 0;
    }(r.startAt, Wh(r), i) || r.endAt && !function(a, s, c) {
      const l = s7(a, s, c);
      return a.inclusive ? l >= 0 : l > 0;
    }(r.endAt, Wh(r), i));
  }(e, t);
}
function ime(e) {
  return e.collectionGroup || (e.path.length % 2 == 1 ? e.path.lastSegment() : e.path.get(e.path.length - 2));
}
function uW(e) {
  return (t, n) => {
    let r = !1;
    for (const i of Wh(e)) {
      const o = ome(i, t, n);
      if (o !== 0)
        return o;
      r = r || i.field.isKeyField();
    }
    return 0;
  };
}
function ome(e, t, n) {
  const r = e.field.isKeyField() ? $t.comparator(t.key, n.key) : function(o, a, s) {
    const c = a.data.field(o), l = s.data.field(o);
    return c !== null && l !== null ? dg(c, l) : Wt(42886);
  }(e.field, t, n);
  switch (e.dir) {
    case "asc":
      return r;
    case "desc":
      return -1 * r;
    default:
      return Wt(19790, {
        direction: e.dir
      });
  }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class wf {
  constructor(t, n) {
    this.mapKeyFn = t, this.equalsFn = n, /**
     * The inner map for a key/value pair. Due to the possibility of collisions we
     * keep a list of entries that we do a linear search through to find an actual
     * match. Note that collisions should be rare, so we still expect near
     * constant time lookups in practice.
     */
    this.inner = {}, /** The number of entries stored in the map */
    this.innerSize = 0;
  }
  /** Get a value for this key, or undefined if it does not exist. */
  get(t) {
    const n = this.mapKeyFn(t), r = this.inner[n];
    if (r !== void 0) {
      for (const [i, o] of r)
        if (this.equalsFn(i, t))
          return o;
    }
  }
  has(t) {
    return this.get(t) !== void 0;
  }
  /** Put this key and value in the map. */
  set(t, n) {
    const r = this.mapKeyFn(t), i = this.inner[r];
    if (i === void 0)
      return this.inner[r] = [[t, n]], void this.innerSize++;
    for (let o = 0; o < i.length; o++)
      if (this.equalsFn(i[o][0], t))
        return void (i[o] = [t, n]);
    i.push([t, n]), this.innerSize++;
  }
  /**
   * Remove this key from the map. Returns a boolean if anything was deleted.
   */
  delete(t) {
    const n = this.mapKeyFn(t), r = this.inner[n];
    if (r === void 0)
      return !1;
    for (let i = 0; i < r.length; i++)
      if (this.equalsFn(r[i][0], t))
        return r.length === 1 ? delete this.inner[n] : r.splice(i, 1), this.innerSize--, !0;
    return !1;
  }
  forEach(t) {
    Lu(this.inner, (n, r) => {
      for (const [i, o] of r)
        t(i, o);
    });
  }
  isEmpty() {
    return qU(this.inner);
  }
  size() {
    return this.innerSize;
  }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const ame = new jr($t.comparator);
function al() {
  return ame;
}
const dW = new jr($t.comparator);
function Fm(...e) {
  let t = dW;
  for (const n of e)
    t = t.insert(n.key, n);
  return t;
}
function fW(e) {
  let t = dW;
  return e.forEach((n, r) => t = t.insert(n, r.overlayedDocument)), t;
}
function _d() {
  return l0();
}
function hW() {
  return l0();
}
function l0() {
  return new wf((e) => e.toString(), (e, t) => e.isEqual(t));
}
const sme = new jr($t.comparator), cme = new Si($t.comparator);
function _n(...e) {
  let t = cme;
  for (const n of e)
    t = t.add(n);
  return t;
}
const lme = new Si(hn);
function ume() {
  return lme;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function VO(e, t) {
  if (e.useProto3Json) {
    if (isNaN(t))
      return {
        doubleValue: "NaN"
      };
    if (t === 1 / 0)
      return {
        doubleValue: "Infinity"
      };
    if (t === -1 / 0)
      return {
        doubleValue: "-Infinity"
      };
  }
  return {
    doubleValue: C_(t) ? "-0" : t
  };
}
function gW(e) {
  return {
    integerValue: "" + e
  };
}
function dme(e, t) {
  return jpe(t) ? gW(t) : VO(e, t);
}
/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class lx {
  constructor() {
    this._ = void 0;
  }
}
function fme(e, t, n) {
  return e instanceof R_ ? function(i, o) {
    const a = {
      fields: {
        [YU]: {
          stringValue: KU
        },
        [QU]: {
          timestampValue: {
            seconds: i.seconds,
            nanos: i.nanoseconds
          }
        }
      }
    };
    return o && ix(o) && (o = ox(o)), o && (a.fields[XU] = o), {
      mapValue: a
    };
  }(n, t) : e instanceof U0 ? mW(e, t) : e instanceof W0 ? vW(e, t) : function(i, o) {
    const a = pW(i, o), s = d7(a) + d7(i.Ee);
    return LI(a) && LI(i.Ee) ? gW(s) : VO(i.serializer, s);
  }(e, t);
}
function hme(e, t, n) {
  return e instanceof U0 ? mW(e, t) : e instanceof W0 ? vW(e, t) : n;
}
function pW(e, t) {
  return e instanceof $_ ? (
    /** Returns true if `value` is either an IntegerValue or a DoubleValue. */
    function(r) {
      return LI(r) || function(o) {
        return !!o && "doubleValue" in o;
      }(r);
    }(t) ? t : {
      integerValue: 0
    }
  ) : null;
}
class R_ extends lx {
}
class U0 extends lx {
  constructor(t) {
    super(), this.elements = t;
  }
}
function mW(e, t) {
  const n = yW(t);
  for (const r of e.elements)
    n.some((i) => fc(i, r)) || n.push(r);
  return {
    arrayValue: {
      values: n
    }
  };
}
class W0 extends lx {
  constructor(t) {
    super(), this.elements = t;
  }
}
function vW(e, t) {
  let n = yW(t);
  for (const r of e.elements)
    n = n.filter((i) => !fc(i, r));
  return {
    arrayValue: {
      values: n
    }
  };
}
class $_ extends lx {
  constructor(t, n) {
    super(), this.serializer = t, this.Ee = n;
  }
}
function d7(e) {
  return ei(e.integerValue || e.doubleValue);
}
function yW(e) {
  return DO(e) && e.arrayValue.values ? e.arrayValue.values.slice() : [];
}
function gme(e, t) {
  return e.field.isEqual(t.field) && function(r, i) {
    return r instanceof U0 && i instanceof U0 || r instanceof W0 && i instanceof W0 ? ug(r.elements, i.elements, fc) : r instanceof $_ && i instanceof $_ ? fc(r.Ee, i.Ee) : r instanceof R_ && i instanceof R_;
  }(e.transform, t.transform);
}
class pme {
  constructor(t, n) {
    this.version = t, this.transformResults = n;
  }
}
class rc {
  constructor(t, n) {
    this.updateTime = t, this.exists = n;
  }
  /** Creates a new empty Precondition. */
  static none() {
    return new rc();
  }
  /** Creates a new Precondition with an exists flag. */
  static exists(t) {
    return new rc(void 0, t);
  }
  /** Creates a new Precondition based on a version a document exists at. */
  static updateTime(t) {
    return new rc(t);
  }
  /** Returns whether this Precondition is empty. */
  get isNone() {
    return this.updateTime === void 0 && this.exists === void 0;
  }
  isEqual(t) {
    return this.exists === t.exists && (this.updateTime ? !!t.updateTime && this.updateTime.isEqual(t.updateTime) : !t.updateTime);
  }
}
function M1(e, t) {
  return e.updateTime !== void 0 ? t.isFoundDocument() && t.version.isEqual(e.updateTime) : e.exists === void 0 || e.exists === t.isFoundDocument();
}
class ux {
}
function bW(e, t) {
  if (!e.hasLocalMutations || t && t.fields.length === 0)
    return null;
  if (t === null)
    return e.isNoDocument() ? new SW(e.key, rc.none()) : new Hv(e.key, e.data, rc.none());
  {
    const n = e.data, r = Yo.empty();
    let i = new Si(Vi.comparator);
    for (let o of t.fields)
      if (!i.has(o)) {
        let a = n.field(o);
        a === null && o.length > 1 && (o = o.popLast(), a = n.field(o)), a === null ? r.delete(o) : r.set(o, a), i = i.add(o);
      }
    return new Fu(e.key, r, new ga(i.toArray()), rc.none());
  }
}
function mme(e, t, n) {
  e instanceof Hv ? function(i, o, a) {
    const s = i.value.clone(), c = h7(i.fieldTransforms, o, a.transformResults);
    s.setAll(c), o.convertToFoundDocument(a.version, s).setHasCommittedMutations();
  }(e, t, n) : e instanceof Fu ? function(i, o, a) {
    if (!M1(i.precondition, o))
      return void o.convertToUnknownDocument(a.version);
    const s = h7(i.fieldTransforms, o, a.transformResults), c = o.data;
    c.setAll(_W(i)), c.setAll(s), o.convertToFoundDocument(a.version, c).setHasCommittedMutations();
  }(e, t, n) : function(i, o, a) {
    o.convertToNoDocument(a.version).setHasCommittedMutations();
  }(0, t, n);
}
function u0(e, t, n, r) {
  return e instanceof Hv ? function(o, a, s, c) {
    if (!M1(o.precondition, a))
      return s;
    const l = o.value.clone(), u = g7(o.fieldTransforms, c, a);
    return l.setAll(u), a.convertToFoundDocument(a.version, l).setHasLocalMutations(), null;
  }(e, t, n, r) : e instanceof Fu ? function(o, a, s, c) {
    if (!M1(o.precondition, a))
      return s;
    const l = g7(o.fieldTransforms, c, a), u = a.data;
    return u.setAll(_W(o)), u.setAll(l), a.convertToFoundDocument(a.version, u).setHasLocalMutations(), s === null ? null : s.unionWith(o.fieldMask.fields).unionWith(o.fieldTransforms.map((d) => d.field));
  }(e, t, n, r) : function(o, a, s) {
    return M1(o.precondition, a) ? (a.convertToNoDocument(a.version).setHasLocalMutations(), null) : s;
  }(e, t, n);
}
function vme(e, t) {
  let n = null;
  for (const r of e.fieldTransforms) {
    const i = t.data.field(r.field), o = pW(r.transform, i || null);
    o != null && (n === null && (n = Yo.empty()), n.set(r.field, o));
  }
  return n || null;
}
function f7(e, t) {
  return e.type === t.type && !!e.key.isEqual(t.key) && !!e.precondition.isEqual(t.precondition) && !!function(r, i) {
    return r === void 0 && i === void 0 || !(!r || !i) && ug(r, i, (o, a) => gme(o, a));
  }(e.fieldTransforms, t.fieldTransforms) && (e.type === 0 ? e.value.isEqual(t.value) : e.type !== 1 || e.data.isEqual(t.data) && e.fieldMask.isEqual(t.fieldMask));
}
class Hv extends ux {
  constructor(t, n, r, i = []) {
    super(), this.key = t, this.value = n, this.precondition = r, this.fieldTransforms = i, this.type = 0;
  }
  getFieldMask() {
    return null;
  }
}
class Fu extends ux {
  constructor(t, n, r, i, o = []) {
    super(), this.key = t, this.data = n, this.fieldMask = r, this.precondition = i, this.fieldTransforms = o, this.type = 1;
  }
  getFieldMask() {
    return this.fieldMask;
  }
}
function _W(e) {
  const t = /* @__PURE__ */ new Map();
  return e.fieldMask.fields.forEach((n) => {
    if (!n.isEmpty()) {
      const r = e.data.field(n);
      t.set(n, r);
    }
  }), t;
}
function h7(e, t, n) {
  const r = /* @__PURE__ */ new Map();
  jn(e.length === n.length, 32656, {
    Ae: n.length,
    Re: e.length
  });
  for (let i = 0; i < n.length; i++) {
    const o = e[i], a = o.transform, s = t.data.field(o.field);
    r.set(o.field, hme(a, s, n[i]));
  }
  return r;
}
function g7(e, t, n) {
  const r = /* @__PURE__ */ new Map();
  for (const i of e) {
    const o = i.transform, a = n.data.field(i.field);
    r.set(i.field, fme(o, a, t));
  }
  return r;
}
class SW extends ux {
  constructor(t, n) {
    super(), this.key = t, this.precondition = n, this.type = 2, this.fieldTransforms = [];
  }
  getFieldMask() {
    return null;
  }
}
class yme extends ux {
  constructor(t, n) {
    super(), this.key = t, this.precondition = n, this.type = 3, this.fieldTransforms = [];
  }
  getFieldMask() {
    return null;
  }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class bme {
  /**
   * @param batchId - The unique ID of this mutation batch.
   * @param localWriteTime - The original write time of this mutation.
   * @param baseMutations - Mutations that are used to populate the base
   * values when this mutation is applied locally. This can be used to locally
   * overwrite values that are persisted in the remote document cache. Base
   * mutations are never sent to the backend.
   * @param mutations - The user-provided mutations in this mutation batch.
   * User-provided mutations are applied both locally and remotely on the
   * backend.
   */
  constructor(t, n, r, i) {
    this.batchId = t, this.localWriteTime = n, this.baseMutations = r, this.mutations = i;
  }
  /**
   * Applies all the mutations in this MutationBatch to the specified document
   * to compute the state of the remote document
   *
   * @param document - The document to apply mutations to.
   * @param batchResult - The result of applying the MutationBatch to the
   * backend.
   */
  applyToRemoteDocument(t, n) {
    const r = n.mutationResults;
    for (let i = 0; i < this.mutations.length; i++) {
      const o = this.mutations[i];
      o.key.isEqual(t.key) && mme(o, t, r[i]);
    }
  }
  /**
   * Computes the local view of a document given all the mutations in this
   * batch.
   *
   * @param document - The document to apply mutations to.
   * @param mutatedFields - Fields that have been updated before applying this mutation batch.
   * @returns A `FieldMask` representing all the fields that are mutated.
   */
  applyToLocalView(t, n) {
    for (const r of this.baseMutations)
      r.key.isEqual(t.key) && (n = u0(r, t, n, this.localWriteTime));
    for (const r of this.mutations)
      r.key.isEqual(t.key) && (n = u0(r, t, n, this.localWriteTime));
    return n;
  }
  /**
   * Computes the local view for all provided documents given the mutations in
   * this batch. Returns a `DocumentKey` to `Mutation` map which can be used to
   * replace all the mutation applications.
   */
  applyToLocalDocumentSet(t, n) {
    const r = hW();
    return this.mutations.forEach((i) => {
      const o = t.get(i.key), a = o.overlayedDocument;
      let s = this.applyToLocalView(a, o.mutatedFields);
      s = n.has(i.key) ? null : s;
      const c = bW(a, s);
      c !== null && r.set(i.key, c), a.isValidDocument() || a.convertToNoDocument(Gt.min());
    }), r;
  }
  keys() {
    return this.mutations.reduce((t, n) => t.add(n.key), _n());
  }
  isEqual(t) {
    return this.batchId === t.batchId && ug(this.mutations, t.mutations, (n, r) => f7(n, r)) && ug(this.baseMutations, t.baseMutations, (n, r) => f7(n, r));
  }
}
class BO {
  constructor(t, n, r, i) {
    this.batch = t, this.commitVersion = n, this.mutationResults = r, this.docVersions = i;
  }
  /**
   * Creates a new MutationBatchResult for the given batch and results. There
   * must be one result for each mutation in the batch. This static factory
   * caches a document=&gt;version mapping (docVersions).
   */
  static from(t, n, r) {
    jn(t.mutations.length === r.length, 58842, {
      Ve: t.mutations.length,
      me: r.length
    });
    let i = function() {
      return sme;
    }();
    const o = t.mutations;
    for (let a = 0; a < o.length; a++)
      i = i.insert(o[a].key, r[a].version);
    return new BO(t, n, r, i);
  }
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
let _me = class {
  constructor(t, n) {
    this.largestBatchId = t, this.mutation = n;
  }
  getKey() {
    return this.mutation.key;
  }
  isEqual(t) {
    return t !== null && this.mutation === t.mutation;
  }
  toString() {
    return `Overlay{
      largestBatchId: ${this.largestBatchId},
      mutation: ${this.mutation.toString()}
    }`;
  }
};
/**
 * @license
 * Copyright 2023 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class Sme {
  constructor(t, n, r) {
    this.alias = t, this.aggregateType = n, this.fieldPath = r;
  }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class wme {
  constructor(t, n) {
    this.count = t, this.unchangedNames = n;
  }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var ii, Tn;
function xme(e) {
  switch (e) {
    case Se.OK:
      return Wt(64938);
    case Se.CANCELLED:
    case Se.UNKNOWN:
    case Se.DEADLINE_EXCEEDED:
    case Se.RESOURCE_EXHAUSTED:
    case Se.INTERNAL:
    case Se.UNAVAILABLE:
    case Se.UNAUTHENTICATED:
      return !1;
    case Se.INVALID_ARGUMENT:
    case Se.NOT_FOUND:
    case Se.ALREADY_EXISTS:
    case Se.PERMISSION_DENIED:
    case Se.FAILED_PRECONDITION:
    case Se.ABORTED:
    case Se.OUT_OF_RANGE:
    case Se.UNIMPLEMENTED:
    case Se.DATA_LOSS:
      return !0;
    default:
      return Wt(15467, {
        code: e
      });
  }
}
function wW(e) {
  if (e === void 0)
    return ol("GRPC error has no .code"), Se.UNKNOWN;
  switch (e) {
    case ii.OK:
      return Se.OK;
    case ii.CANCELLED:
      return Se.CANCELLED;
    case ii.UNKNOWN:
      return Se.UNKNOWN;
    case ii.DEADLINE_EXCEEDED:
      return Se.DEADLINE_EXCEEDED;
    case ii.RESOURCE_EXHAUSTED:
      return Se.RESOURCE_EXHAUSTED;
    case ii.INTERNAL:
      return Se.INTERNAL;
    case ii.UNAVAILABLE:
      return Se.UNAVAILABLE;
    case ii.UNAUTHENTICATED:
      return Se.UNAUTHENTICATED;
    case ii.INVALID_ARGUMENT:
      return Se.INVALID_ARGUMENT;
    case ii.NOT_FOUND:
      return Se.NOT_FOUND;
    case ii.ALREADY_EXISTS:
      return Se.ALREADY_EXISTS;
    case ii.PERMISSION_DENIED:
      return Se.PERMISSION_DENIED;
    case ii.FAILED_PRECONDITION:
      return Se.FAILED_PRECONDITION;
    case ii.ABORTED:
      return Se.ABORTED;
    case ii.OUT_OF_RANGE:
      return Se.OUT_OF_RANGE;
    case ii.UNIMPLEMENTED:
      return Se.UNIMPLEMENTED;
    case ii.DATA_LOSS:
      return Se.DATA_LOSS;
    default:
      return Wt(39323, {
        code: e
      });
  }
}
(Tn = ii || (ii = {}))[Tn.OK = 0] = "OK", Tn[Tn.CANCELLED = 1] = "CANCELLED", Tn[Tn.UNKNOWN = 2] = "UNKNOWN", Tn[Tn.INVALID_ARGUMENT = 3] = "INVALID_ARGUMENT", Tn[Tn.DEADLINE_EXCEEDED = 4] = "DEADLINE_EXCEEDED", Tn[Tn.NOT_FOUND = 5] = "NOT_FOUND", Tn[Tn.ALREADY_EXISTS = 6] = "ALREADY_EXISTS", Tn[Tn.PERMISSION_DENIED = 7] = "PERMISSION_DENIED", Tn[Tn.UNAUTHENTICATED = 16] = "UNAUTHENTICATED", Tn[Tn.RESOURCE_EXHAUSTED = 8] = "RESOURCE_EXHAUSTED", Tn[Tn.FAILED_PRECONDITION = 9] = "FAILED_PRECONDITION", Tn[Tn.ABORTED = 10] = "ABORTED", Tn[Tn.OUT_OF_RANGE = 11] = "OUT_OF_RANGE", Tn[Tn.UNIMPLEMENTED = 12] = "UNIMPLEMENTED", Tn[Tn.INTERNAL = 13] = "INTERNAL", Tn[Tn.UNAVAILABLE = 14] = "UNAVAILABLE", Tn[Tn.DATA_LOSS = 15] = "DATA_LOSS";
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const Eme = new ou([4294967295, 4294967295], 0);
function p7(e) {
  const t = BU().encode(e), n = new MU();
  return n.update(t), new Uint8Array(n.digest());
}
function m7(e) {
  const t = new DataView(e.buffer), n = t.getUint32(
    0,
    /* littleEndian= */
    !0
  ), r = t.getUint32(
    4,
    /* littleEndian= */
    !0
  ), i = t.getUint32(
    8,
    /* littleEndian= */
    !0
  ), o = t.getUint32(
    12,
    /* littleEndian= */
    !0
  );
  return [new ou([n, r], 0), new ou([i, o], 0)];
}
class zO {
  constructor(t, n, r) {
    if (this.bitmap = t, this.padding = n, this.hashCount = r, n < 0 || n >= 8)
      throw new Vm(`Invalid padding: ${n}`);
    if (r < 0)
      throw new Vm(`Invalid hash count: ${r}`);
    if (t.length > 0 && this.hashCount === 0)
      throw new Vm(`Invalid hash count: ${r}`);
    if (t.length === 0 && n !== 0)
      throw new Vm(`Invalid padding when bitmap length is 0: ${n}`);
    this.fe = 8 * t.length - n, // Set the bit count in Integer to avoid repetition in mightContain().
    this.ge = ou.fromNumber(this.fe);
  }
  // Calculate the ith hash value based on the hashed 64bit integers,
  // and calculate its corresponding bit index in the bitmap to be checked.
  pe(t, n, r) {
    let i = t.add(n.multiply(ou.fromNumber(r)));
    return i.compare(Eme) === 1 && (i = new ou([i.getBits(0), i.getBits(1)], 0)), i.modulo(this.ge).toNumber();
  }
  // Return whether the bit on the given index in the bitmap is set to 1.
  ye(t) {
    return !!(this.bitmap[Math.floor(t / 8)] & 1 << t % 8);
  }
  mightContain(t) {
    if (this.fe === 0)
      return !1;
    const n = p7(t), [r, i] = m7(n);
    for (let o = 0; o < this.hashCount; o++) {
      const a = this.pe(r, i, o);
      if (!this.ye(a))
        return !1;
    }
    return !0;
  }
  /** Create bloom filter for testing purposes only. */
  static create(t, n, r) {
    const i = t % 8 == 0 ? 0 : 8 - t % 8, o = new Uint8Array(Math.ceil(t / 8)), a = new zO(o, i, n);
    return r.forEach((s) => a.insert(s)), a;
  }
  insert(t) {
    if (this.fe === 0)
      return;
    const n = p7(t), [r, i] = m7(n);
    for (let o = 0; o < this.hashCount; o++) {
      const a = this.pe(r, i, o);
      this.we(a);
    }
  }
  we(t) {
    const n = Math.floor(t / 8), r = t % 8;
    this.bitmap[n] |= 1 << r;
  }
}
class Vm extends Error {
  constructor() {
    super(...arguments), this.name = "BloomFilterError";
  }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class dx {
  constructor(t, n, r, i, o) {
    this.snapshotVersion = t, this.targetChanges = n, this.targetMismatches = r, this.documentUpdates = i, this.resolvedLimboDocuments = o;
  }
  /**
   * HACK: Views require RemoteEvents in order to determine whether the view is
   * CURRENT, but secondary tabs don't receive remote events. So this method is
   * used to create a synthesized RemoteEvent that can be used to apply a
   * CURRENT status change to a View, for queries executed in a different tab.
   */
  // PORTING NOTE: Multi-tab only
  static createSynthesizedRemoteEventForCurrentChange(t, n, r) {
    const i = /* @__PURE__ */ new Map();
    return i.set(t, Uv.createSynthesizedTargetChangeForCurrentChange(t, n, r)), new dx(Gt.min(), i, new jr(hn), al(), _n());
  }
}
class Uv {
  constructor(t, n, r, i, o) {
    this.resumeToken = t, this.current = n, this.addedDocuments = r, this.modifiedDocuments = i, this.removedDocuments = o;
  }
  /**
   * This method is used to create a synthesized TargetChanges that can be used to
   * apply a CURRENT status change to a View (for queries executed in a different
   * tab) or for new queries (to raise snapshots with correct CURRENT status).
   */
  static createSynthesizedTargetChangeForCurrentChange(t, n, r) {
    return new Uv(r, n, _n(), _n(), _n());
  }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class k1 {
  constructor(t, n, r, i) {
    this.Se = t, this.removedTargetIds = n, this.key = r, this.be = i;
  }
}
class xW {
  constructor(t, n) {
    this.targetId = t, this.De = n;
  }
}
class EW {
  constructor(t, n, r = Hi.EMPTY_BYTE_STRING, i = null) {
    this.state = t, this.targetIds = n, this.resumeToken = r, this.cause = i;
  }
}
class v7 {
  constructor() {
    this.ve = 0, /**
     * Keeps track of the document changes since the last raised snapshot.
     *
     * These changes are continuously updated as we receive document updates and
     * always reflect the current set of changes against the last issued snapshot.
     */
    this.Ce = y7(), /** See public getters for explanations of these fields. */
    this.Fe = Hi.EMPTY_BYTE_STRING, this.Me = !1, /**
     * Whether this target state should be included in the next snapshot. We
     * initialize to true so that newly-added targets are included in the next
     * RemoteEvent.
     */
    this.xe = !0;
  }
  /**
   * Whether this target has been marked 'current'.
   *
   * 'Current' has special meaning in the RPC protocol: It implies that the
   * Watch backend has sent us all changes up to the point at which the target
   * was added and that the target is consistent with the rest of the watch
   * stream.
   */
  get current() {
    return this.Me;
  }
  /** The last resume token sent to us for this target. */
  get resumeToken() {
    return this.Fe;
  }
  /** Whether this target has pending target adds or target removes. */
  get Oe() {
    return this.ve !== 0;
  }
  /** Whether we have modified any state that should trigger a snapshot. */
  get Ne() {
    return this.xe;
  }
  /**
   * Applies the resume token to the TargetChange, but only when it has a new
   * value. Empty resumeTokens are discarded.
   */
  Be(t) {
    t.approximateByteSize() > 0 && (this.xe = !0, this.Fe = t);
  }
  /**
   * Creates a target change from the current set of changes.
   *
   * To reset the document changes after raising this snapshot, call
   * `clearPendingChanges()`.
   */
  Le() {
    let t = _n(), n = _n(), r = _n();
    return this.Ce.forEach((i, o) => {
      switch (o) {
        case 0:
          t = t.add(i);
          break;
        case 2:
          n = n.add(i);
          break;
        case 1:
          r = r.add(i);
          break;
        default:
          Wt(38017, {
            changeType: o
          });
      }
    }), new Uv(this.Fe, this.Me, t, n, r);
  }
  /**
   * Resets the document changes and sets `hasPendingChanges` to false.
   */
  ke() {
    this.xe = !1, this.Ce = y7();
  }
  qe(t, n) {
    this.xe = !0, this.Ce = this.Ce.insert(t, n);
  }
  Qe(t) {
    this.xe = !0, this.Ce = this.Ce.remove(t);
  }
  $e() {
    this.ve += 1;
  }
  Ue() {
    this.ve -= 1, jn(this.ve >= 0, 3241, {
      ve: this.ve
    });
  }
  Ke() {
    this.xe = !0, this.Me = !0;
  }
}
class Cme {
  constructor(t) {
    this.We = t, /** The internal state of all tracked targets. */
    this.Ge = /* @__PURE__ */ new Map(), /** Keeps track of the documents to update since the last raised snapshot. */
    this.ze = al(), this.je = yb(), /** A mapping of document keys to their set of target IDs. */
    this.Je = yb(), /**
     * A map of targets with existence filter mismatches. These targets are
     * known to be inconsistent and their listens needs to be re-established by
     * RemoteStore.
     */
    this.He = new jr(hn);
  }
  /**
   * Processes and adds the DocumentWatchChange to the current set of changes.
   */
  Ye(t) {
    for (const n of t.Se)
      t.be && t.be.isFoundDocument() ? this.Ze(n, t.be) : this.Xe(n, t.key, t.be);
    for (const n of t.removedTargetIds)
      this.Xe(n, t.key, t.be);
  }
  /** Processes and adds the WatchTargetChange to the current set of changes. */
  et(t) {
    this.forEachTarget(t, (n) => {
      const r = this.tt(n);
      switch (t.state) {
        case 0:
          this.nt(n) && r.Be(t.resumeToken);
          break;
        case 1:
          r.Ue(), r.Oe || // We have a freshly added target, so we need to reset any state
          // that we had previously. This can happen e.g. when remove and add
          // back a target for existence filter mismatches.
          r.ke(), r.Be(t.resumeToken);
          break;
        case 2:
          r.Ue(), r.Oe || this.removeTarget(n);
          break;
        case 3:
          this.nt(n) && (r.Ke(), r.Be(t.resumeToken));
          break;
        case 4:
          this.nt(n) && // Reset the target and synthesizes removes for all existing
          // documents. The backend will re-add any documents that still
          // match the target before it sends the next global snapshot.
          (this.rt(n), r.Be(t.resumeToken));
          break;
        default:
          Wt(56790, {
            state: t.state
          });
      }
    });
  }
  /**
   * Iterates over all targetIds that the watch change applies to: either the
   * targetIds explicitly listed in the change or the targetIds of all currently
   * active targets.
   */
  forEachTarget(t, n) {
    t.targetIds.length > 0 ? t.targetIds.forEach(n) : this.Ge.forEach((r, i) => {
      this.nt(i) && n(i);
    });
  }
  /**
   * Handles existence filters and synthesizes deletes for filter mismatches.
   * Targets that are invalidated by filter mismatches are added to
   * `pendingTargetResets`.
   */
  it(t) {
    const n = t.targetId, r = t.De.count, i = this.st(n);
    if (i) {
      const o = i.target;
      if (FI(o))
        if (r === 0) {
          const a = new $t(o.path);
          this.Xe(n, a, io.newNoDocument(a, Gt.min()));
        } else
          jn(r === 1, 20013, {
            expectedCount: r
          });
      else {
        const a = this.ot(n);
        if (a !== r) {
          const s = this._t(t), c = s ? this.ut(s, t, a) : 1;
          if (c !== 0) {
            this.rt(n);
            const l = c === 2 ? "TargetPurposeExistenceFilterMismatchBloom" : "TargetPurposeExistenceFilterMismatch";
            this.He = this.He.insert(n, l);
          }
        }
      }
    }
  }
  /**
   * Parse the bloom filter from the "unchanged_names" field of an existence
   * filter.
   */
  _t(t) {
    const n = t.De.unchangedNames;
    if (!n || !n.bits)
      return null;
    const { bits: { bitmap: r = "", padding: i = 0 }, hashCount: o = 0 } = n;
    let a, s;
    try {
      a = bu(r).toUint8Array();
    } catch (c) {
      if (c instanceof GU)
        return mu("Decoding the base64 bloom filter in existence filter failed (" + c.message + "); ignoring the bloom filter and falling back to full re-query."), null;
      throw c;
    }
    try {
      s = new zO(a, i, o);
    } catch (c) {
      return mu(c instanceof Vm ? "BloomFilter error: " : "Applying bloom filter failed: ", c), null;
    }
    return s.fe === 0 ? null : s;
  }
  /**
   * Apply bloom filter to remove the deleted documents, and return the
   * application status.
   */
  ut(t, n, r) {
    return n.De.count === r - this.ht(t, n.targetId) ? 0 : 2;
  }
  /**
   * Filter out removed documents based on bloom filter membership result and
   * return number of documents removed.
   */
  ht(t, n) {
    const r = this.We.getRemoteKeysForTarget(n);
    let i = 0;
    return r.forEach((o) => {
      const a = this.We.lt(), s = `projects/${a.projectId}/databases/${a.database}/documents/${o.path.canonicalString()}`;
      t.mightContain(s) || (this.Xe(
        n,
        o,
        /*updatedDocument=*/
        null
      ), i++);
    }), i;
  }
  /**
   * Converts the currently accumulated state into a remote event at the
   * provided snapshot version. Resets the accumulated changes before returning.
   */
  Pt(t) {
    const n = /* @__PURE__ */ new Map();
    this.Ge.forEach((o, a) => {
      const s = this.st(a);
      if (s) {
        if (o.current && FI(s.target)) {
          const c = new $t(s.target.path);
          this.Tt(c).has(a) || this.It(a, c) || this.Xe(a, c, io.newNoDocument(c, t));
        }
        o.Ne && (n.set(a, o.Le()), o.ke());
      }
    });
    let r = _n();
    this.Je.forEach((o, a) => {
      let s = !0;
      a.forEachWhile((c) => {
        const l = this.st(c);
        return !l || l.purpose === "TargetPurposeLimboResolution" || (s = !1, !1);
      }), s && (r = r.add(o));
    }), this.ze.forEach((o, a) => a.setReadTime(t));
    const i = new dx(t, n, this.He, this.ze, r);
    return this.ze = al(), this.je = yb(), this.Je = yb(), this.He = new jr(hn), i;
  }
  /**
   * Adds the provided document to the internal list of document updates and
   * its document key to the given target's mapping.
   */
  // Visible for testing.
  Ze(t, n) {
    if (!this.nt(t))
      return;
    const r = this.It(t, n.key) ? 2 : 0;
    this.tt(t).qe(n.key, r), this.ze = this.ze.insert(n.key, n), this.je = this.je.insert(n.key, this.Tt(n.key).add(t)), this.Je = this.Je.insert(n.key, this.dt(n.key).add(t));
  }
  /**
   * Removes the provided document from the target mapping. If the
   * document no longer matches the target, but the document's state is still
   * known (e.g. we know that the document was deleted or we received the change
   * that caused the filter mismatch), the new document can be provided
   * to update the remote document cache.
   */
  // Visible for testing.
  Xe(t, n, r) {
    if (!this.nt(t))
      return;
    const i = this.tt(t);
    this.It(t, n) ? i.qe(
      n,
      1
      /* ChangeType.Removed */
    ) : (
      // The document may have entered and left the target before we raised a
      // snapshot, so we can just ignore the change.
      i.Qe(n)
    ), this.Je = this.Je.insert(n, this.dt(n).delete(t)), this.Je = this.Je.insert(n, this.dt(n).add(t)), r && (this.ze = this.ze.insert(n, r));
  }
  removeTarget(t) {
    this.Ge.delete(t);
  }
  /**
   * Returns the current count of documents in the target. This includes both
   * the number of documents that the LocalStore considers to be part of the
   * target as well as any accumulated changes.
   */
  ot(t) {
    const n = this.tt(t).Le();
    return this.We.getRemoteKeysForTarget(t).size + n.addedDocuments.size - n.removedDocuments.size;
  }
  /**
   * Increment the number of acks needed from watch before we can consider the
   * server to be 'in-sync' with the client's active targets.
   */
  $e(t) {
    this.tt(t).$e();
  }
  tt(t) {
    let n = this.Ge.get(t);
    return n || (n = new v7(), this.Ge.set(t, n)), n;
  }
  dt(t) {
    let n = this.Je.get(t);
    return n || (n = new Si(hn), this.Je = this.Je.insert(t, n)), n;
  }
  Tt(t) {
    let n = this.je.get(t);
    return n || (n = new Si(hn), this.je = this.je.insert(t, n)), n;
  }
  /**
   * Verifies that the user is still interested in this target (by calling
   * `getTargetDataForTarget()`) and that we are not waiting for pending ADDs
   * from watch.
   */
  nt(t) {
    const n = this.st(t) !== null;
    return n || ht("WatchChangeAggregator", "Detected inactive target", t), n;
  }
  /**
   * Returns the TargetData for an active target (i.e. a target that the user
   * is still interested in that has no outstanding target change requests).
   */
  st(t) {
    const n = this.Ge.get(t);
    return n && n.Oe ? null : this.We.Et(t);
  }
  /**
   * Resets the state of a Watch target to its initial state (e.g. sets
   * 'current' to false, clears the resume token and removes its target mapping
   * from all documents).
   */
  rt(t) {
    this.Ge.set(t, new v7()), this.We.getRemoteKeysForTarget(t).forEach((n) => {
      this.Xe(
        t,
        n,
        /*updatedDocument=*/
        null
      );
    });
  }
  /**
   * Returns whether the LocalStore considers the document to be part of the
   * specified target.
   */
  It(t, n) {
    return this.We.getRemoteKeysForTarget(t).has(n);
  }
}
function yb() {
  return new jr($t.comparator);
}
function y7() {
  return new jr($t.comparator);
}
const Tme = (() => ({
  asc: "ASCENDING",
  desc: "DESCENDING"
}))(), Ime = (() => ({
  "<": "LESS_THAN",
  "<=": "LESS_THAN_OR_EQUAL",
  ">": "GREATER_THAN",
  ">=": "GREATER_THAN_OR_EQUAL",
  "==": "EQUAL",
  "!=": "NOT_EQUAL",
  "array-contains": "ARRAY_CONTAINS",
  in: "IN",
  "not-in": "NOT_IN",
  "array-contains-any": "ARRAY_CONTAINS_ANY"
}))(), Ame = (() => ({
  and: "AND",
  or: "OR"
}))();
class Rme {
  constructor(t, n) {
    this.databaseId = t, this.useProto3Json = n;
  }
}
function BI(e, t) {
  return e.useProto3Json || rx(t) ? t : {
    value: t
  };
}
function O_(e, t) {
  return e.useProto3Json ? `${new Date(1e3 * t.seconds).toISOString().replace(/\.\d*/, "").replace("Z", "")}.${("000000000" + t.nanoseconds).slice(-9)}Z` : {
    seconds: "" + t.seconds,
    nanos: t.nanoseconds
  };
}
function CW(e, t) {
  return e.useProto3Json ? t.toBase64() : t.toUint8Array();
}
function $me(e, t) {
  return O_(e, t.toTimestamp());
}
function ic(e) {
  return jn(!!e, 49232), Gt.fromTimestamp(function(n) {
    const r = yu(n);
    return new qn(r.seconds, r.nanos);
  }(e));
}
function HO(e, t) {
  return zI(e, t).canonicalString();
}
function zI(e, t) {
  const n = function(i) {
    return new tr(["projects", i.projectId, "databases", i.database]);
  }(e).child("documents");
  return t === void 0 ? n : n.child(t);
}
function TW(e) {
  const t = tr.fromString(e);
  return jn(PW(t), 10190, {
    key: t.toString()
  }), t;
}
function HI(e, t) {
  return HO(e.databaseId, t.path);
}
function e5(e, t) {
  const n = TW(t);
  if (n.get(1) !== e.databaseId.projectId)
    throw new Ye(Se.INVALID_ARGUMENT, "Tried to deserialize key from different project: " + n.get(1) + " vs " + e.databaseId.projectId);
  if (n.get(3) !== e.databaseId.database)
    throw new Ye(Se.INVALID_ARGUMENT, "Tried to deserialize key from different database: " + n.get(3) + " vs " + e.databaseId.database);
  return new $t(AW(n));
}
function IW(e, t) {
  return HO(e.databaseId, t);
}
function Ome(e) {
  const t = TW(e);
  return t.length === 4 ? tr.emptyPath() : AW(t);
}
function UI(e) {
  return new tr(["projects", e.databaseId.projectId, "databases", e.databaseId.database]).canonicalString();
}
function AW(e) {
  return jn(e.length > 4 && e.get(4) === "documents", 29091, {
    key: e.toString()
  }), e.popFirst(5);
}
function b7(e, t, n) {
  return {
    name: HI(e, t),
    fields: n.value.mapValue.fields
  };
}
function Pme(e, t) {
  let n;
  if ("targetChange" in t) {
    t.targetChange;
    const r = function(l) {
      return l === "NO_CHANGE" ? 0 : l === "ADD" ? 1 : l === "REMOVE" ? 2 : l === "CURRENT" ? 3 : l === "RESET" ? 4 : Wt(39313, {
        state: l
      });
    }(t.targetChange.targetChangeType || "NO_CHANGE"), i = t.targetChange.targetIds || [], o = function(l, u) {
      return l.useProto3Json ? (jn(u === void 0 || typeof u == "string", 58123), Hi.fromBase64String(u || "")) : (jn(u === void 0 || // Check if the value is an instance of both Buffer and Uint8Array,
      // despite the fact that Buffer extends Uint8Array. In some
      // environments, such as jsdom, the prototype chain of Buffer
      // does not indicate that it extends Uint8Array.
      u instanceof Buffer || u instanceof Uint8Array, 16193), Hi.fromUint8Array(u || new Uint8Array()));
    }(e, t.targetChange.resumeToken), a = t.targetChange.cause, s = a && function(l) {
      const u = l.code === void 0 ? Se.UNKNOWN : wW(l.code);
      return new Ye(u, l.message || "");
    }(a);
    n = new EW(r, i, o, s || null);
  } else if ("documentChange" in t) {
    t.documentChange;
    const r = t.documentChange;
    r.document, r.document.name, r.document.updateTime;
    const i = e5(e, r.document.name), o = ic(r.document.updateTime), a = r.document.createTime ? ic(r.document.createTime) : Gt.min(), s = new Yo({
      mapValue: {
        fields: r.document.fields
      }
    }), c = io.newFoundDocument(i, o, a, s), l = r.targetIds || [], u = r.removedTargetIds || [];
    n = new k1(l, u, c.key, c);
  } else if ("documentDelete" in t) {
    t.documentDelete;
    const r = t.documentDelete;
    r.document;
    const i = e5(e, r.document), o = r.readTime ? ic(r.readTime) : Gt.min(), a = io.newNoDocument(i, o), s = r.removedTargetIds || [];
    n = new k1([], s, a.key, a);
  } else if ("documentRemove" in t) {
    t.documentRemove;
    const r = t.documentRemove;
    r.document;
    const i = e5(e, r.document), o = r.removedTargetIds || [];
    n = new k1([], o, i, null);
  } else {
    if (!("filter" in t))
      return Wt(11601, {
        At: t
      });
    {
      t.filter;
      const r = t.filter;
      r.targetId;
      const { count: i = 0, unchangedNames: o } = r, a = new wme(i, o), s = r.targetId;
      n = new xW(s, a);
    }
  }
  return n;
}
function Mme(e, t) {
  let n;
  if (t instanceof Hv)
    n = {
      update: b7(e, t.key, t.value)
    };
  else if (t instanceof SW)
    n = {
      delete: HI(e, t.key)
    };
  else if (t instanceof Fu)
    n = {
      update: b7(e, t.key, t.data),
      updateMask: zme(t.fieldMask)
    };
  else {
    if (!(t instanceof yme))
      return Wt(16599, {
        Rt: t.type
      });
    n = {
      verify: HI(e, t.key)
    };
  }
  return t.fieldTransforms.length > 0 && (n.updateTransforms = t.fieldTransforms.map((r) => function(o, a) {
    const s = a.transform;
    if (s instanceof R_)
      return {
        fieldPath: a.field.canonicalString(),
        setToServerValue: "REQUEST_TIME"
      };
    if (s instanceof U0)
      return {
        fieldPath: a.field.canonicalString(),
        appendMissingElements: {
          values: s.elements
        }
      };
    if (s instanceof W0)
      return {
        fieldPath: a.field.canonicalString(),
        removeAllFromArray: {
          values: s.elements
        }
      };
    if (s instanceof $_)
      return {
        fieldPath: a.field.canonicalString(),
        increment: s.Ee
      };
    throw Wt(20930, {
      transform: a.transform
    });
  }(0, r))), t.precondition.isNone || (n.currentDocument = function(i, o) {
    return o.updateTime !== void 0 ? {
      updateTime: $me(i, o.updateTime)
    } : o.exists !== void 0 ? {
      exists: o.exists
    } : Wt(27497);
  }(e, t.precondition)), n;
}
function kme(e, t) {
  return e && e.length > 0 ? (jn(t !== void 0, 14353), e.map((n) => function(i, o) {
    let a = i.updateTime ? ic(i.updateTime) : ic(o);
    return a.isEqual(Gt.min()) && // The Firestore Emulator currently returns an update time of 0 for
    // deletes of non-existing documents (rather than null). This breaks the
    // test "get deleted doc while offline with source=cache" as NoDocuments
    // with version 0 are filtered by IndexedDb's RemoteDocumentCache.
    // TODO(#2149): Remove this when Emulator is fixed
    (a = ic(o)), new pme(a, i.transformResults || []);
  }(n, t))) : [];
}
function Nme(e, t) {
  return {
    documents: [IW(e, t.path)]
  };
}
function RW(e, t) {
  const n = {
    structuredQuery: {}
  }, r = t.path;
  let i;
  t.collectionGroup !== null ? (i = r, n.structuredQuery.from = [{
    collectionId: t.collectionGroup,
    allDescendants: !0
  }]) : (i = r.popLast(), n.structuredQuery.from = [{
    collectionId: r.lastSegment()
  }]), n.parent = IW(e, i);
  const o = function(l) {
    if (l.length !== 0)
      return OW(ws.create(
        l,
        "and"
        /* CompositeOperator.AND */
      ));
  }(t.filters);
  o && (n.structuredQuery.where = o);
  const a = function(l) {
    if (l.length !== 0)
      return l.map((u) => (
        // visible for testing
        function(f) {
          return {
            field: Hl(f.field),
            direction: Fme(f.dir)
          };
        }(u)
      ));
  }(t.orderBy);
  a && (n.structuredQuery.orderBy = a);
  const s = BI(e, t.limit);
  return s !== null && (n.structuredQuery.limit = s), t.startAt && (n.structuredQuery.startAt = function(l) {
    return {
      before: l.inclusive,
      values: l.position
    };
  }(t.startAt)), t.endAt && (n.structuredQuery.endAt = function(l) {
    return {
      before: !l.inclusive,
      values: l.position
    };
  }(t.endAt)), {
    Vt: n,
    parent: i
  };
}
function Dme(e, t, n, r) {
  const { Vt: i, parent: o } = RW(e, t), a = {}, s = [];
  let c = 0;
  return n.forEach((l) => {
    const u = r ? l.alias : "aggregate_" + c++;
    a[u] = l.alias, l.aggregateType === "count" ? s.push({
      alias: u,
      count: {}
    }) : l.aggregateType === "avg" ? s.push({
      alias: u,
      avg: {
        field: Hl(l.fieldPath)
      }
    }) : l.aggregateType === "sum" && s.push({
      alias: u,
      sum: {
        field: Hl(l.fieldPath)
      }
    });
  }), {
    request: {
      structuredAggregationQuery: {
        aggregations: s,
        structuredQuery: i.structuredQuery
      },
      parent: i.parent
    },
    ft: a,
    parent: o
  };
}
function Lme(e) {
  let t = Ome(e.parent);
  const n = e.structuredQuery, r = n.from ? n.from.length : 0;
  let i = null;
  if (r > 0) {
    jn(r === 1, 65062);
    const u = n.from[0];
    u.allDescendants ? i = u.collectionId : t = t.child(u.collectionId);
  }
  let o = [];
  n.where && (o = function(d) {
    const f = $W(d);
    return f instanceof ws && iW(f) ? f.getFilters() : [f];
  }(n.where));
  let a = [];
  n.orderBy && (a = function(d) {
    return d.map((f) => function(p) {
      return new H0(
        xh(p.field),
        // visible for testing
        function(m) {
          switch (m) {
            case "ASCENDING":
              return "asc";
            case "DESCENDING":
              return "desc";
            default:
              return;
          }
        }(p.direction)
      );
    }(f));
  }(n.orderBy));
  let s = null;
  n.limit && (s = function(d) {
    let f;
    return f = typeof d == "object" ? d.value : d, rx(f) ? null : f;
  }(n.limit));
  let c = null;
  n.startAt && (c = function(d) {
    const f = !!d.before, h = d.values || [];
    return new hg(h, f);
  }(n.startAt));
  let l = null;
  return n.endAt && (l = function(d) {
    const f = !d.before, h = d.values || [];
    return new hg(h, f);
  }(n.endAt)), nme(t, i, a, o, s, "F", c, l);
}
function jme(e, t) {
  const n = function(i) {
    switch (i) {
      case "TargetPurposeListen":
        return null;
      case "TargetPurposeExistenceFilterMismatch":
        return "existence-filter-mismatch";
      case "TargetPurposeExistenceFilterMismatchBloom":
        return "existence-filter-mismatch-bloom";
      case "TargetPurposeLimboResolution":
        return "limbo-document";
      default:
        return Wt(28987, {
          purpose: i
        });
    }
  }(t.purpose);
  return n == null ? null : {
    "goog-listen-tags": n
  };
}
function $W(e) {
  return e.unaryFilter !== void 0 ? function(n) {
    switch (n.unaryFilter.op) {
      case "IS_NAN":
        const r = xh(n.unaryFilter.field);
        return ci.create(r, "==", {
          doubleValue: NaN
        });
      case "IS_NULL":
        const i = xh(n.unaryFilter.field);
        return ci.create(i, "==", {
          nullValue: "NULL_VALUE"
        });
      case "IS_NOT_NAN":
        const o = xh(n.unaryFilter.field);
        return ci.create(o, "!=", {
          doubleValue: NaN
        });
      case "IS_NOT_NULL":
        const a = xh(n.unaryFilter.field);
        return ci.create(a, "!=", {
          nullValue: "NULL_VALUE"
        });
      case "OPERATOR_UNSPECIFIED":
        return Wt(61313);
      default:
        return Wt(60726);
    }
  }(e) : e.fieldFilter !== void 0 ? function(n) {
    return ci.create(xh(n.fieldFilter.field), function(i) {
      switch (i) {
        case "EQUAL":
          return "==";
        case "NOT_EQUAL":
          return "!=";
        case "GREATER_THAN":
          return ">";
        case "GREATER_THAN_OR_EQUAL":
          return ">=";
        case "LESS_THAN":
          return "<";
        case "LESS_THAN_OR_EQUAL":
          return "<=";
        case "ARRAY_CONTAINS":
          return "array-contains";
        case "IN":
          return "in";
        case "NOT_IN":
          return "not-in";
        case "ARRAY_CONTAINS_ANY":
          return "array-contains-any";
        case "OPERATOR_UNSPECIFIED":
          return Wt(58110);
        default:
          return Wt(50506);
      }
    }(n.fieldFilter.op), n.fieldFilter.value);
  }(e) : e.compositeFilter !== void 0 ? function(n) {
    return ws.create(n.compositeFilter.filters.map((r) => $W(r)), function(i) {
      switch (i) {
        case "AND":
          return "and";
        case "OR":
          return "or";
        default:
          return Wt(1026);
      }
    }(n.compositeFilter.op));
  }(e) : Wt(30097, {
    filter: e
  });
}
function Fme(e) {
  return Tme[e];
}
function Vme(e) {
  return Ime[e];
}
function Bme(e) {
  return Ame[e];
}
function Hl(e) {
  return {
    fieldPath: e.canonicalString()
  };
}
function xh(e) {
  return Vi.fromServerFormat(e.fieldPath);
}
function OW(e) {
  return e instanceof ci ? function(n) {
    if (n.op === "==") {
      if (a7(n.value))
        return {
          unaryFilter: {
            field: Hl(n.field),
            op: "IS_NAN"
          }
        };
      if (o7(n.value))
        return {
          unaryFilter: {
            field: Hl(n.field),
            op: "IS_NULL"
          }
        };
    } else if (n.op === "!=") {
      if (a7(n.value))
        return {
          unaryFilter: {
            field: Hl(n.field),
            op: "IS_NOT_NAN"
          }
        };
      if (o7(n.value))
        return {
          unaryFilter: {
            field: Hl(n.field),
            op: "IS_NOT_NULL"
          }
        };
    }
    return {
      fieldFilter: {
        field: Hl(n.field),
        op: Vme(n.op),
        value: n.value
      }
    };
  }(e) : e instanceof ws ? function(n) {
    const r = n.getFilters().map((i) => OW(i));
    return r.length === 1 ? r[0] : {
      compositeFilter: {
        op: Bme(n.op),
        filters: r
      }
    };
  }(e) : Wt(54877, {
    filter: e
  });
}
function zme(e) {
  const t = [];
  return e.fields.forEach((n) => t.push(n.canonicalString())), {
    fieldPaths: t
  };
}
function PW(e) {
  return e.length >= 4 && e.get(0) === "projects" && e.get(2) === "databases";
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class ql {
  constructor(t, n, r, i, o = Gt.min(), a = Gt.min(), s = Hi.EMPTY_BYTE_STRING, c = null) {
    this.target = t, this.targetId = n, this.purpose = r, this.sequenceNumber = i, this.snapshotVersion = o, this.lastLimboFreeSnapshotVersion = a, this.resumeToken = s, this.expectedCount = c;
  }
  /** Creates a new target data instance with an updated sequence number. */
  withSequenceNumber(t) {
    return new ql(this.target, this.targetId, this.purpose, t, this.snapshotVersion, this.lastLimboFreeSnapshotVersion, this.resumeToken, this.expectedCount);
  }
  /**
   * Creates a new target data instance with an updated resume token and
   * snapshot version.
   */
  withResumeToken(t, n) {
    return new ql(
      this.target,
      this.targetId,
      this.purpose,
      this.sequenceNumber,
      n,
      this.lastLimboFreeSnapshotVersion,
      t,
      /* expectedCount= */
      null
    );
  }
  /**
   * Creates a new target data instance with an updated expected count.
   */
  withExpectedCount(t) {
    return new ql(this.target, this.targetId, this.purpose, this.sequenceNumber, this.snapshotVersion, this.lastLimboFreeSnapshotVersion, this.resumeToken, t);
  }
  /**
   * Creates a new target data instance with an updated last limbo free
   * snapshot version number.
   */
  withLastLimboFreeSnapshotVersion(t) {
    return new ql(this.target, this.targetId, this.purpose, this.sequenceNumber, this.snapshotVersion, t, this.resumeToken, this.expectedCount);
  }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class Hme {
  constructor(t) {
    this.gt = t;
  }
}
function Ume(e) {
  const t = Lme({
    parent: e.parent,
    structuredQuery: e.structuredQuery
  });
  return e.limitType === "LAST" ? A_(
    t,
    t.limit,
    "L"
    /* LimitType.Last */
  ) : t;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class Wme {
  constructor() {
    this.Dn = new qme();
  }
  addToCollectionParentIndex(t, n) {
    return this.Dn.add(n), Te.resolve();
  }
  getCollectionParents(t, n) {
    return Te.resolve(this.Dn.getEntries(n));
  }
  addFieldIndex(t, n) {
    return Te.resolve();
  }
  deleteFieldIndex(t, n) {
    return Te.resolve();
  }
  deleteAllFieldIndexes(t) {
    return Te.resolve();
  }
  createTargetIndexes(t, n) {
    return Te.resolve();
  }
  getDocumentsMatchingTarget(t, n) {
    return Te.resolve(null);
  }
  getIndexType(t, n) {
    return Te.resolve(
      0
      /* IndexType.NONE */
    );
  }
  getFieldIndexes(t, n) {
    return Te.resolve([]);
  }
  getNextCollectionGroupToUpdate(t) {
    return Te.resolve(null);
  }
  getMinOffset(t, n) {
    return Te.resolve(vu.min());
  }
  getMinOffsetFromCollectionGroup(t, n) {
    return Te.resolve(vu.min());
  }
  updateCollectionGroup(t, n, r) {
    return Te.resolve();
  }
  updateIndexEntries(t, n) {
    return Te.resolve();
  }
}
class qme {
  constructor() {
    this.index = {};
  }
  // Returns false if the entry already existed.
  add(t) {
    const n = t.lastSegment(), r = t.popLast(), i = this.index[n] || new Si(tr.comparator), o = !i.has(r);
    return this.index[n] = i.add(r), o;
  }
  has(t) {
    const n = t.lastSegment(), r = t.popLast(), i = this.index[n];
    return i && i.has(r);
  }
  getEntries(t) {
    return (this.index[t] || new Si(tr.comparator)).toArray();
  }
}
/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const _7 = {
  didRun: !1,
  sequenceNumbersCollected: 0,
  targetsRemoved: 0,
  documentsRemoved: 0
}, MW = 41943040;
class Wo {
  static withCacheSize(t) {
    return new Wo(t, Wo.DEFAULT_COLLECTION_PERCENTILE, Wo.DEFAULT_MAX_SEQUENCE_NUMBERS_TO_COLLECT);
  }
  constructor(t, n, r) {
    this.cacheSizeCollectionThreshold = t, this.percentileToCollect = n, this.maximumSequenceNumbersToCollect = r;
  }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
Wo.DEFAULT_COLLECTION_PERCENTILE = 10, Wo.DEFAULT_MAX_SEQUENCE_NUMBERS_TO_COLLECT = 1e3, Wo.DEFAULT = new Wo(MW, Wo.DEFAULT_COLLECTION_PERCENTILE, Wo.DEFAULT_MAX_SEQUENCE_NUMBERS_TO_COLLECT), Wo.DISABLED = new Wo(-1, 0, 0);
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class gg {
  constructor(t) {
    this._r = t;
  }
  next() {
    return this._r += 2, this._r;
  }
  static ar() {
    return new gg(0);
  }
  static ur() {
    return new gg(-1);
  }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const S7 = "LruGarbageCollector", kW = 1048576;
function w7([e, t], [n, r]) {
  const i = hn(e, n);
  return i === 0 ? hn(t, r) : i;
}
class Gme {
  constructor(t) {
    this.Tr = t, this.buffer = new Si(w7), this.Ir = 0;
  }
  dr() {
    return ++this.Ir;
  }
  Er(t) {
    const n = [t, this.dr()];
    if (this.buffer.size < this.Tr)
      this.buffer = this.buffer.add(n);
    else {
      const r = this.buffer.last();
      w7(n, r) < 0 && (this.buffer = this.buffer.delete(r).add(n));
    }
  }
  get maxValue() {
    return this.buffer.last()[0];
  }
}
class Kme {
  constructor(t, n, r) {
    this.garbageCollector = t, this.asyncQueue = n, this.localStore = r, this.Ar = null;
  }
  start() {
    this.garbageCollector.params.cacheSizeCollectionThreshold !== -1 && this.Rr(6e4);
  }
  stop() {
    this.Ar && (this.Ar.cancel(), this.Ar = null);
  }
  get started() {
    return this.Ar !== null;
  }
  Rr(t) {
    ht(S7, `Garbage collection scheduled in ${t}ms`), this.Ar = this.asyncQueue.enqueueAfterDelay("lru_garbage_collection", t, async () => {
      this.Ar = null;
      try {
        await this.localStore.collectGarbage(this.garbageCollector);
      } catch (n) {
        dp(n) ? ht(S7, "Ignoring IndexedDB error during garbage collection: ", n) : await up(n);
      }
      await this.Rr(3e5);
    });
  }
}
class Yme {
  constructor(t, n) {
    this.Vr = t, this.params = n;
  }
  calculateTargetCount(t, n) {
    return this.Vr.mr(t).next((r) => Math.floor(n / 100 * r));
  }
  nthSequenceNumber(t, n) {
    if (n === 0)
      return Te.resolve(nx.ue);
    const r = new Gme(n);
    return this.Vr.forEachTarget(t, (i) => r.Er(i.sequenceNumber)).next(() => this.Vr.gr(t, (i) => r.Er(i))).next(() => r.maxValue);
  }
  removeTargets(t, n, r) {
    return this.Vr.removeTargets(t, n, r);
  }
  removeOrphanedDocuments(t, n) {
    return this.Vr.removeOrphanedDocuments(t, n);
  }
  collect(t, n) {
    return this.params.cacheSizeCollectionThreshold === -1 ? (ht("LruGarbageCollector", "Garbage collection skipped; disabled"), Te.resolve(_7)) : this.getCacheSize(t).next((r) => r < this.params.cacheSizeCollectionThreshold ? (ht("LruGarbageCollector", `Garbage collection skipped; Cache size ${r} is lower than threshold ${this.params.cacheSizeCollectionThreshold}`), _7) : this.pr(t, n));
  }
  getCacheSize(t) {
    return this.Vr.getCacheSize(t);
  }
  pr(t, n) {
    let r, i, o, a, s, c, l;
    const u = Date.now();
    return this.calculateTargetCount(t, this.params.percentileToCollect).next((d) => (
      // Cap at the configured max
      (d > this.params.maximumSequenceNumbersToCollect ? (ht("LruGarbageCollector", `Capping sequence numbers to collect down to the maximum of ${this.params.maximumSequenceNumbersToCollect} from ${d}`), i = this.params.maximumSequenceNumbersToCollect) : i = d, a = Date.now(), this.nthSequenceNumber(t, i))
    )).next((d) => (r = d, s = Date.now(), this.removeTargets(t, r, n))).next((d) => (o = d, c = Date.now(), this.removeOrphanedDocuments(t, r))).next((d) => (l = Date.now(), Sh() <= bn.DEBUG && ht("LruGarbageCollector", `LRU Garbage Collection
	Counted targets in ${a - u}ms
	Determined least recently used ${i} in ` + (s - a) + `ms
	Removed ${o} targets in ` + (c - s) + `ms
	Removed ${d} documents in ` + (l - c) + `ms
Total Duration: ${l - u}ms`), Te.resolve({
      didRun: !0,
      sequenceNumbersCollected: i,
      targetsRemoved: o,
      documentsRemoved: d
    })));
  }
}
function Xme(e, t) {
  return new Yme(e, t);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class Qme {
  constructor() {
    this.changes = new wf((t) => t.toString(), (t, n) => t.isEqual(n)), this.changesApplied = !1;
  }
  /**
   * Buffers a `RemoteDocumentCache.addEntry()` call.
   *
   * You can only modify documents that have already been retrieved via
   * `getEntry()/getEntries()` (enforced via IndexedDbs `apply()`).
   */
  addEntry(t) {
    this.assertNotApplied(), this.changes.set(t.key, t);
  }
  /**
   * Buffers a `RemoteDocumentCache.removeEntry()` call.
   *
   * You can only remove documents that have already been retrieved via
   * `getEntry()/getEntries()` (enforced via IndexedDbs `apply()`).
   */
  removeEntry(t, n) {
    this.assertNotApplied(), this.changes.set(t, io.newInvalidDocument(t).setReadTime(n));
  }
  /**
   * Looks up an entry in the cache. The buffered changes will first be checked,
   * and if no buffered change applies, this will forward to
   * `RemoteDocumentCache.getEntry()`.
   *
   * @param transaction - The transaction in which to perform any persistence
   *     operations.
   * @param documentKey - The key of the entry to look up.
   * @returns The cached document or an invalid document if we have nothing
   * cached.
   */
  getEntry(t, n) {
    this.assertNotApplied();
    const r = this.changes.get(n);
    return r !== void 0 ? Te.resolve(r) : this.getFromCache(t, n);
  }
  /**
   * Looks up several entries in the cache, forwarding to
   * `RemoteDocumentCache.getEntry()`.
   *
   * @param transaction - The transaction in which to perform any persistence
   *     operations.
   * @param documentKeys - The keys of the entries to look up.
   * @returns A map of cached documents, indexed by key. If an entry cannot be
   *     found, the corresponding key will be mapped to an invalid document.
   */
  getEntries(t, n) {
    return this.getAllFromCache(t, n);
  }
  /**
   * Applies buffered changes to the underlying RemoteDocumentCache, using
   * the provided transaction.
   */
  apply(t) {
    return this.assertNotApplied(), this.changesApplied = !0, this.applyChanges(t);
  }
  /** Helper to assert this.changes is not null  */
  assertNotApplied() {
  }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class Jme {
  constructor(t, n) {
    this.overlayedDocument = t, this.mutatedFields = n;
  }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class Zme {
  constructor(t, n, r, i) {
    this.remoteDocumentCache = t, this.mutationQueue = n, this.documentOverlayCache = r, this.indexManager = i;
  }
  /**
   * Get the local view of the document identified by `key`.
   *
   * @returns Local view of the document or null if we don't have any cached
   * state for it.
   */
  getDocument(t, n) {
    let r = null;
    return this.documentOverlayCache.getOverlay(t, n).next((i) => (r = i, this.remoteDocumentCache.getEntry(t, n))).next((i) => (r !== null && u0(r.mutation, i, ga.empty(), qn.now()), i));
  }
  /**
   * Gets the local view of the documents identified by `keys`.
   *
   * If we don't have cached state for a document in `keys`, a NoDocument will
   * be stored for that key in the resulting set.
   */
  getDocuments(t, n) {
    return this.remoteDocumentCache.getEntries(t, n).next((r) => this.getLocalViewOfDocuments(t, r, _n()).next(() => r));
  }
  /**
   * Similar to `getDocuments`, but creates the local view from the given
   * `baseDocs` without retrieving documents from the local store.
   *
   * @param transaction - The transaction this operation is scoped to.
   * @param docs - The documents to apply local mutations to get the local views.
   * @param existenceStateChanged - The set of document keys whose existence state
   *   is changed. This is useful to determine if some documents overlay needs
   *   to be recalculated.
   */
  getLocalViewOfDocuments(t, n, r = _n()) {
    const i = _d();
    return this.populateOverlays(t, i, n).next(() => this.computeViews(t, n, i, r).next((o) => {
      let a = Fm();
      return o.forEach((s, c) => {
        a = a.insert(s, c.overlayedDocument);
      }), a;
    }));
  }
  /**
   * Gets the overlayed documents for the given document map, which will include
   * the local view of those documents and a `FieldMask` indicating which fields
   * are mutated locally, `null` if overlay is a Set or Delete mutation.
   */
  getOverlayedDocuments(t, n) {
    const r = _d();
    return this.populateOverlays(t, r, n).next(() => this.computeViews(t, n, r, _n()));
  }
  /**
   * Fetches the overlays for {@code docs} and adds them to provided overlay map
   * if the map does not already contain an entry for the given document key.
   */
  populateOverlays(t, n, r) {
    const i = [];
    return r.forEach((o) => {
      n.has(o) || i.push(o);
    }), this.documentOverlayCache.getOverlays(t, i).next((o) => {
      o.forEach((a, s) => {
        n.set(a, s);
      });
    });
  }
  /**
   * Computes the local view for the given documents.
   *
   * @param docs - The documents to compute views for. It also has the base
   *   version of the documents.
   * @param overlays - The overlays that need to be applied to the given base
   *   version of the documents.
   * @param existenceStateChanged - A set of documents whose existence states
   *   might have changed. This is used to determine if we need to re-calculate
   *   overlays from mutation queues.
   * @return A map represents the local documents view.
   */
  computeViews(t, n, r, i) {
    let o = al();
    const a = l0(), s = function() {
      return l0();
    }();
    return n.forEach((c, l) => {
      const u = r.get(l.key);
      i.has(l.key) && (u === void 0 || u.mutation instanceof Fu) ? o = o.insert(l.key, l) : u !== void 0 ? (a.set(l.key, u.mutation.getFieldMask()), u0(u.mutation, l, u.mutation.getFieldMask(), qn.now())) : (
        // no overlay exists
        // Using EMPTY to indicate there is no overlay for the document.
        a.set(l.key, ga.empty())
      );
    }), this.recalculateAndSaveOverlays(t, o).next((c) => (c.forEach((l, u) => a.set(l, u)), n.forEach((l, u) => {
      var d;
      return s.set(l, new Jme(u, (d = a.get(l)) !== null && d !== void 0 ? d : null));
    }), s));
  }
  recalculateAndSaveOverlays(t, n) {
    const r = l0();
    let i = new jr((a, s) => a - s), o = _n();
    return this.mutationQueue.getAllMutationBatchesAffectingDocumentKeys(t, n).next((a) => {
      for (const s of a)
        s.keys().forEach((c) => {
          const l = n.get(c);
          if (l === null)
            return;
          let u = r.get(c) || ga.empty();
          u = s.applyToLocalView(l, u), r.set(c, u);
          const d = (i.get(s.batchId) || _n()).add(c);
          i = i.insert(s.batchId, d);
        });
    }).next(() => {
      const a = [], s = i.getReverseIterator();
      for (; s.hasNext(); ) {
        const c = s.getNext(), l = c.key, u = c.value, d = hW();
        u.forEach((f) => {
          if (!o.has(f)) {
            const h = bW(n.get(f), r.get(f));
            h !== null && d.set(f, h), o = o.add(f);
          }
        }), a.push(this.documentOverlayCache.saveOverlays(t, l, d));
      }
      return Te.waitFor(a);
    }).next(() => r);
  }
  /**
   * Recalculates overlays by reading the documents from remote document cache
   * first, and saves them after they are calculated.
   */
  recalculateAndSaveOverlaysForDocumentKeys(t, n) {
    return this.remoteDocumentCache.getEntries(t, n).next((r) => this.recalculateAndSaveOverlays(t, r));
  }
  /**
   * Performs a query against the local view of all documents.
   *
   * @param transaction - The persistence transaction.
   * @param query - The query to match documents against.
   * @param offset - Read time and key to start scanning by (exclusive).
   * @param context - A optional tracker to keep a record of important details
   *   during database local query execution.
   */
  getDocumentsMatchingQuery(t, n, r, i) {
    return function(a) {
      return $t.isDocumentKey(a.path) && a.collectionGroup === null && a.filters.length === 0;
    }(n) ? this.getDocumentsMatchingDocumentQuery(t, n.path) : FO(n) ? this.getDocumentsMatchingCollectionGroupQuery(t, n, r, i) : this.getDocumentsMatchingCollectionQuery(t, n, r, i);
  }
  /**
   * Given a collection group, returns the next documents that follow the provided offset, along
   * with an updated batch ID.
   *
   * <p>The documents returned by this method are ordered by remote version from the provided
   * offset. If there are no more remote documents after the provided offset, documents with
   * mutations in order of batch id from the offset are returned. Since all documents in a batch are
   * returned together, the total number of documents returned can exceed {@code count}.
   *
   * @param transaction
   * @param collectionGroup The collection group for the documents.
   * @param offset The offset to index into.
   * @param count The number of documents to return
   * @return A LocalWriteResult with the documents that follow the provided offset and the last processed batch id.
   */
  getNextDocuments(t, n, r, i) {
    return this.remoteDocumentCache.getAllFromCollectionGroup(t, n, r, i).next((o) => {
      const a = i - o.size > 0 ? this.documentOverlayCache.getOverlaysForCollectionGroup(t, n, r.largestBatchId, i - o.size) : Te.resolve(_d());
      let s = j0, c = o;
      return a.next((l) => Te.forEach(l, (u, d) => (s < d.largestBatchId && (s = d.largestBatchId), o.get(u) ? Te.resolve() : this.remoteDocumentCache.getEntry(t, u).next((f) => {
        c = c.insert(u, f);
      }))).next(() => this.populateOverlays(t, l, o)).next(() => this.computeViews(t, c, l, _n())).next((u) => ({
        batchId: s,
        changes: fW(u)
      })));
    });
  }
  getDocumentsMatchingDocumentQuery(t, n) {
    return this.getDocument(t, new $t(n)).next((r) => {
      let i = Fm();
      return r.isFoundDocument() && (i = i.insert(r.key, r)), i;
    });
  }
  getDocumentsMatchingCollectionGroupQuery(t, n, r, i) {
    const o = n.collectionGroup;
    let a = Fm();
    return this.indexManager.getCollectionParents(t, o).next((s) => Te.forEach(s, (c) => {
      const l = function(d, f) {
        return new ju(
          f,
          /*collectionGroup=*/
          null,
          d.explicitOrderBy.slice(),
          d.filters.slice(),
          d.limit,
          d.limitType,
          d.startAt,
          d.endAt
        );
      }(n, c.child(o));
      return this.getDocumentsMatchingCollectionQuery(t, l, r, i).next((u) => {
        u.forEach((d, f) => {
          a = a.insert(d, f);
        });
      });
    }).next(() => a));
  }
  getDocumentsMatchingCollectionQuery(t, n, r, i) {
    let o;
    return this.documentOverlayCache.getOverlaysForCollection(t, n.path, r.largestBatchId).next((a) => (o = a, this.remoteDocumentCache.getDocumentsMatchingQuery(t, n, r, o, i))).next((a) => {
      o.forEach((c, l) => {
        const u = l.getKey();
        a.get(u) === null && (a = a.insert(u, io.newInvalidDocument(u)));
      });
      let s = Fm();
      return a.forEach((c, l) => {
        const u = o.get(c);
        u !== void 0 && u0(u.mutation, l, ga.empty(), qn.now()), // Finally, insert the documents that still match the query
        cx(n, l) && (s = s.insert(c, l));
      }), s;
    });
  }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class e0e {
  constructor(t) {
    this.serializer = t, this.Br = /* @__PURE__ */ new Map(), this.Lr = /* @__PURE__ */ new Map();
  }
  getBundleMetadata(t, n) {
    return Te.resolve(this.Br.get(n));
  }
  saveBundleMetadata(t, n) {
    return this.Br.set(
      n.id,
      /** Decodes a BundleMetadata proto into a BundleMetadata object. */
      function(i) {
        return {
          id: i.id,
          version: i.version,
          createTime: ic(i.createTime)
        };
      }(n)
    ), Te.resolve();
  }
  getNamedQuery(t, n) {
    return Te.resolve(this.Lr.get(n));
  }
  saveNamedQuery(t, n) {
    return this.Lr.set(n.name, function(i) {
      return {
        name: i.name,
        query: Ume(i.bundledQuery),
        readTime: ic(i.readTime)
      };
    }(n)), Te.resolve();
  }
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class t0e {
  constructor() {
    this.overlays = new jr($t.comparator), this.kr = /* @__PURE__ */ new Map();
  }
  getOverlay(t, n) {
    return Te.resolve(this.overlays.get(n));
  }
  getOverlays(t, n) {
    const r = _d();
    return Te.forEach(n, (i) => this.getOverlay(t, i).next((o) => {
      o !== null && r.set(i, o);
    })).next(() => r);
  }
  saveOverlays(t, n, r) {
    return r.forEach((i, o) => {
      this.wt(t, n, o);
    }), Te.resolve();
  }
  removeOverlaysForBatchId(t, n, r) {
    const i = this.kr.get(r);
    return i !== void 0 && (i.forEach((o) => this.overlays = this.overlays.remove(o)), this.kr.delete(r)), Te.resolve();
  }
  getOverlaysForCollection(t, n, r) {
    const i = _d(), o = n.length + 1, a = new $t(n.child("")), s = this.overlays.getIteratorFrom(a);
    for (; s.hasNext(); ) {
      const c = s.getNext().value, l = c.getKey();
      if (!n.isPrefixOf(l.path))
        break;
      l.path.length === o && c.largestBatchId > r && i.set(c.getKey(), c);
    }
    return Te.resolve(i);
  }
  getOverlaysForCollectionGroup(t, n, r, i) {
    let o = new jr((l, u) => l - u);
    const a = this.overlays.getIterator();
    for (; a.hasNext(); ) {
      const l = a.getNext().value;
      if (l.getKey().getCollectionGroup() === n && l.largestBatchId > r) {
        let u = o.get(l.largestBatchId);
        u === null && (u = _d(), o = o.insert(l.largestBatchId, u)), u.set(l.getKey(), l);
      }
    }
    const s = _d(), c = o.getIterator();
    for (; c.hasNext() && (c.getNext().value.forEach((l, u) => s.set(l, u)), !(s.size() >= i)); )
      ;
    return Te.resolve(s);
  }
  wt(t, n, r) {
    const i = this.overlays.get(r.key);
    if (i !== null) {
      const a = this.kr.get(i.largestBatchId).delete(r.key);
      this.kr.set(i.largestBatchId, a);
    }
    this.overlays = this.overlays.insert(r.key, new _me(n, r));
    let o = this.kr.get(n);
    o === void 0 && (o = _n(), this.kr.set(n, o)), this.kr.set(n, o.add(r.key));
  }
}
/**
 * @license
 * Copyright 2024 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class n0e {
  constructor() {
    this.sessionToken = Hi.EMPTY_BYTE_STRING;
  }
  getSessionToken(t) {
    return Te.resolve(this.sessionToken);
  }
  setSessionToken(t, n) {
    return this.sessionToken = n, Te.resolve();
  }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class UO {
  constructor() {
    this.qr = new Si(Ai.Qr), // A set of outstanding references to a document sorted by target id.
    this.$r = new Si(Ai.Ur);
  }
  /** Returns true if the reference set contains no references. */
  isEmpty() {
    return this.qr.isEmpty();
  }
  /** Adds a reference to the given document key for the given ID. */
  addReference(t, n) {
    const r = new Ai(t, n);
    this.qr = this.qr.add(r), this.$r = this.$r.add(r);
  }
  /** Add references to the given document keys for the given ID. */
  Kr(t, n) {
    t.forEach((r) => this.addReference(r, n));
  }
  /**
   * Removes a reference to the given document key for the given
   * ID.
   */
  removeReference(t, n) {
    this.Wr(new Ai(t, n));
  }
  Gr(t, n) {
    t.forEach((r) => this.removeReference(r, n));
  }
  /**
   * Clears all references with a given ID. Calls removeRef() for each key
   * removed.
   */
  zr(t) {
    const n = new $t(new tr([])), r = new Ai(n, t), i = new Ai(n, t + 1), o = [];
    return this.$r.forEachInRange([r, i], (a) => {
      this.Wr(a), o.push(a.key);
    }), o;
  }
  jr() {
    this.qr.forEach((t) => this.Wr(t));
  }
  Wr(t) {
    this.qr = this.qr.delete(t), this.$r = this.$r.delete(t);
  }
  Jr(t) {
    const n = new $t(new tr([])), r = new Ai(n, t), i = new Ai(n, t + 1);
    let o = _n();
    return this.$r.forEachInRange([r, i], (a) => {
      o = o.add(a.key);
    }), o;
  }
  containsKey(t) {
    const n = new Ai(t, 0), r = this.qr.firstAfterOrEqual(n);
    return r !== null && t.isEqual(r.key);
  }
}
class Ai {
  constructor(t, n) {
    this.key = t, this.Hr = n;
  }
  /** Compare by key then by ID */
  static Qr(t, n) {
    return $t.comparator(t.key, n.key) || hn(t.Hr, n.Hr);
  }
  /** Compare by ID then by key */
  static Ur(t, n) {
    return hn(t.Hr, n.Hr) || $t.comparator(t.key, n.key);
  }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class r0e {
  constructor(t, n) {
    this.indexManager = t, this.referenceDelegate = n, /**
     * The set of all mutations that have been sent but not yet been applied to
     * the backend.
     */
    this.mutationQueue = [], /** Next value to use when assigning sequential IDs to each mutation batch. */
    this.er = 1, /** An ordered mapping between documents and the mutations batch IDs. */
    this.Yr = new Si(Ai.Qr);
  }
  checkEmpty(t) {
    return Te.resolve(this.mutationQueue.length === 0);
  }
  addMutationBatch(t, n, r, i) {
    const o = this.er;
    this.er++, this.mutationQueue.length > 0 && this.mutationQueue[this.mutationQueue.length - 1];
    const a = new bme(o, n, r, i);
    this.mutationQueue.push(a);
    for (const s of i)
      this.Yr = this.Yr.add(new Ai(s.key, o)), this.indexManager.addToCollectionParentIndex(t, s.key.path.popLast());
    return Te.resolve(a);
  }
  lookupMutationBatch(t, n) {
    return Te.resolve(this.Zr(n));
  }
  getNextMutationBatchAfterBatchId(t, n) {
    const r = n + 1, i = this.Xr(r), o = i < 0 ? 0 : i;
    return Te.resolve(this.mutationQueue.length > o ? this.mutationQueue[o] : null);
  }
  getHighestUnacknowledgedBatchId() {
    return Te.resolve(this.mutationQueue.length === 0 ? NO : this.er - 1);
  }
  getAllMutationBatches(t) {
    return Te.resolve(this.mutationQueue.slice());
  }
  getAllMutationBatchesAffectingDocumentKey(t, n) {
    const r = new Ai(n, 0), i = new Ai(n, Number.POSITIVE_INFINITY), o = [];
    return this.Yr.forEachInRange([r, i], (a) => {
      const s = this.Zr(a.Hr);
      o.push(s);
    }), Te.resolve(o);
  }
  getAllMutationBatchesAffectingDocumentKeys(t, n) {
    let r = new Si(hn);
    return n.forEach((i) => {
      const o = new Ai(i, 0), a = new Ai(i, Number.POSITIVE_INFINITY);
      this.Yr.forEachInRange([o, a], (s) => {
        r = r.add(s.Hr);
      });
    }), Te.resolve(this.ei(r));
  }
  getAllMutationBatchesAffectingQuery(t, n) {
    const r = n.path, i = r.length + 1;
    let o = r;
    $t.isDocumentKey(o) || (o = o.child(""));
    const a = new Ai(new $t(o), 0);
    let s = new Si(hn);
    return this.Yr.forEachWhile((c) => {
      const l = c.key.path;
      return !!r.isPrefixOf(l) && // Rows with document keys more than one segment longer than the query
      // path can't be matches. For example, a query on 'rooms' can't match
      // the document /rooms/abc/messages/xyx.
      // TODO(mcg): we'll need a different scanner when we implement
      // ancestor queries.
      (l.length === i && (s = s.add(c.Hr)), !0);
    }, a), Te.resolve(this.ei(s));
  }
  ei(t) {
    const n = [];
    return t.forEach((r) => {
      const i = this.Zr(r);
      i !== null && n.push(i);
    }), n;
  }
  removeMutationBatch(t, n) {
    jn(this.ti(n.batchId, "removed") === 0, 55003), this.mutationQueue.shift();
    let r = this.Yr;
    return Te.forEach(n.mutations, (i) => {
      const o = new Ai(i.key, n.batchId);
      return r = r.delete(o), this.referenceDelegate.markPotentiallyOrphaned(t, i.key);
    }).next(() => {
      this.Yr = r;
    });
  }
  rr(t) {
  }
  containsKey(t, n) {
    const r = new Ai(n, 0), i = this.Yr.firstAfterOrEqual(r);
    return Te.resolve(n.isEqual(i && i.key));
  }
  performConsistencyCheck(t) {
    return this.mutationQueue.length, Te.resolve();
  }
  /**
   * Finds the index of the given batchId in the mutation queue and asserts that
   * the resulting index is within the bounds of the queue.
   *
   * @param batchId - The batchId to search for
   * @param action - A description of what the caller is doing, phrased in passive
   * form (e.g. "acknowledged" in a routine that acknowledges batches).
   */
  ti(t, n) {
    return this.Xr(t);
  }
  /**
   * Finds the index of the given batchId in the mutation queue. This operation
   * is O(1).
   *
   * @returns The computed index of the batch with the given batchId, based on
   * the state of the queue. Note this index can be negative if the requested
   * batchId has already been removed from the queue or past the end of the
   * queue if the batchId is larger than the last added batch.
   */
  Xr(t) {
    return this.mutationQueue.length === 0 ? 0 : t - this.mutationQueue[0].batchId;
  }
  /**
   * A version of lookupMutationBatch that doesn't return a promise, this makes
   * other functions that uses this code easier to read and more efficient.
   */
  Zr(t) {
    const n = this.Xr(t);
    return n < 0 || n >= this.mutationQueue.length ? null : this.mutationQueue[n];
  }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class i0e {
  /**
   * @param sizer - Used to assess the size of a document. For eager GC, this is
   * expected to just return 0 to avoid unnecessarily doing the work of
   * calculating the size.
   */
  constructor(t) {
    this.ni = t, /** Underlying cache of documents and their read times. */
    this.docs = function() {
      return new jr($t.comparator);
    }(), /** Size of all cached documents. */
    this.size = 0;
  }
  setIndexManager(t) {
    this.indexManager = t;
  }
  /**
   * Adds the supplied entry to the cache and updates the cache size as appropriate.
   *
   * All calls of `addEntry`  are required to go through the RemoteDocumentChangeBuffer
   * returned by `newChangeBuffer()`.
   */
  addEntry(t, n) {
    const r = n.key, i = this.docs.get(r), o = i ? i.size : 0, a = this.ni(n);
    return this.docs = this.docs.insert(r, {
      document: n.mutableCopy(),
      size: a
    }), this.size += a - o, this.indexManager.addToCollectionParentIndex(t, r.path.popLast());
  }
  /**
   * Removes the specified entry from the cache and updates the cache size as appropriate.
   *
   * All calls of `removeEntry` are required to go through the RemoteDocumentChangeBuffer
   * returned by `newChangeBuffer()`.
   */
  removeEntry(t) {
    const n = this.docs.get(t);
    n && (this.docs = this.docs.remove(t), this.size -= n.size);
  }
  getEntry(t, n) {
    const r = this.docs.get(n);
    return Te.resolve(r ? r.document.mutableCopy() : io.newInvalidDocument(n));
  }
  getEntries(t, n) {
    let r = al();
    return n.forEach((i) => {
      const o = this.docs.get(i);
      r = r.insert(i, o ? o.document.mutableCopy() : io.newInvalidDocument(i));
    }), Te.resolve(r);
  }
  getDocumentsMatchingQuery(t, n, r, i) {
    let o = al();
    const a = n.path, s = new $t(a.child("__id-9223372036854775808__")), c = this.docs.getIteratorFrom(s);
    for (; c.hasNext(); ) {
      const { key: l, value: { document: u } } = c.getNext();
      if (!a.isPrefixOf(l.path))
        break;
      l.path.length > a.length + 1 || kpe(Mpe(u), r) <= 0 || (i.has(u.key) || cx(n, u)) && (o = o.insert(u.key, u.mutableCopy()));
    }
    return Te.resolve(o);
  }
  getAllFromCollectionGroup(t, n, r, i) {
    Wt(9500);
  }
  ri(t, n) {
    return Te.forEach(this.docs, (r) => n(r));
  }
  newChangeBuffer(t) {
    return new o0e(this);
  }
  getSize(t) {
    return Te.resolve(this.size);
  }
}
class o0e extends Qme {
  constructor(t) {
    super(), this.Or = t;
  }
  applyChanges(t) {
    const n = [];
    return this.changes.forEach((r, i) => {
      i.isValidDocument() ? n.push(this.Or.addEntry(t, i)) : this.Or.removeEntry(r);
    }), Te.waitFor(n);
  }
  getFromCache(t, n) {
    return this.Or.getEntry(t, n);
  }
  getAllFromCache(t, n) {
    return this.Or.getEntries(t, n);
  }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class a0e {
  constructor(t) {
    this.persistence = t, /**
     * Maps a target to the data about that target
     */
    this.ii = new wf((n) => LO(n), jO), /** The last received snapshot version. */
    this.lastRemoteSnapshotVersion = Gt.min(), /** The highest numbered target ID encountered. */
    this.highestTargetId = 0, /** The highest sequence number encountered. */
    this.si = 0, /**
     * A ordered bidirectional mapping between documents and the remote target
     * IDs.
     */
    this.oi = new UO(), this.targetCount = 0, this._i = gg.ar();
  }
  forEachTarget(t, n) {
    return this.ii.forEach((r, i) => n(i)), Te.resolve();
  }
  getLastRemoteSnapshotVersion(t) {
    return Te.resolve(this.lastRemoteSnapshotVersion);
  }
  getHighestSequenceNumber(t) {
    return Te.resolve(this.si);
  }
  allocateTargetId(t) {
    return this.highestTargetId = this._i.next(), Te.resolve(this.highestTargetId);
  }
  setTargetsMetadata(t, n, r) {
    return r && (this.lastRemoteSnapshotVersion = r), n > this.si && (this.si = n), Te.resolve();
  }
  hr(t) {
    this.ii.set(t.target, t);
    const n = t.targetId;
    n > this.highestTargetId && (this._i = new gg(n), this.highestTargetId = n), t.sequenceNumber > this.si && (this.si = t.sequenceNumber);
  }
  addTargetData(t, n) {
    return this.hr(n), this.targetCount += 1, Te.resolve();
  }
  updateTargetData(t, n) {
    return this.hr(n), Te.resolve();
  }
  removeTargetData(t, n) {
    return this.ii.delete(n.target), this.oi.zr(n.targetId), this.targetCount -= 1, Te.resolve();
  }
  removeTargets(t, n, r) {
    let i = 0;
    const o = [];
    return this.ii.forEach((a, s) => {
      s.sequenceNumber <= n && r.get(s.targetId) === null && (this.ii.delete(a), o.push(this.removeMatchingKeysForTargetId(t, s.targetId)), i++);
    }), Te.waitFor(o).next(() => i);
  }
  getTargetCount(t) {
    return Te.resolve(this.targetCount);
  }
  getTargetData(t, n) {
    const r = this.ii.get(n) || null;
    return Te.resolve(r);
  }
  addMatchingKeys(t, n, r) {
    return this.oi.Kr(n, r), Te.resolve();
  }
  removeMatchingKeys(t, n, r) {
    this.oi.Gr(n, r);
    const i = this.persistence.referenceDelegate, o = [];
    return i && n.forEach((a) => {
      o.push(i.markPotentiallyOrphaned(t, a));
    }), Te.waitFor(o);
  }
  removeMatchingKeysForTargetId(t, n) {
    return this.oi.zr(n), Te.resolve();
  }
  getMatchingKeysForTargetId(t, n) {
    const r = this.oi.Jr(n);
    return Te.resolve(r);
  }
  containsKey(t, n) {
    return Te.resolve(this.oi.containsKey(n));
  }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class NW {
  /**
   * The constructor accepts a factory for creating a reference delegate. This
   * allows both the delegate and this instance to have strong references to
   * each other without having nullable fields that would then need to be
   * checked or asserted on every access.
   */
  constructor(t, n) {
    this.ai = {}, this.overlays = {}, this.ui = new nx(0), this.ci = !1, this.ci = !0, this.li = new n0e(), this.referenceDelegate = t(this), this.hi = new a0e(this), this.indexManager = new Wme(), this.remoteDocumentCache = function(i) {
      return new i0e(i);
    }((r) => this.referenceDelegate.Pi(r)), this.serializer = new Hme(n), this.Ti = new e0e(this.serializer);
  }
  start() {
    return Promise.resolve();
  }
  shutdown() {
    return this.ci = !1, Promise.resolve();
  }
  get started() {
    return this.ci;
  }
  setDatabaseDeletedListener() {
  }
  setNetworkEnabled() {
  }
  getIndexManager(t) {
    return this.indexManager;
  }
  getDocumentOverlayCache(t) {
    let n = this.overlays[t.toKey()];
    return n || (n = new t0e(), this.overlays[t.toKey()] = n), n;
  }
  getMutationQueue(t, n) {
    let r = this.ai[t.toKey()];
    return r || (r = new r0e(n, this.referenceDelegate), this.ai[t.toKey()] = r), r;
  }
  getGlobalsCache() {
    return this.li;
  }
  getTargetCache() {
    return this.hi;
  }
  getRemoteDocumentCache() {
    return this.remoteDocumentCache;
  }
  getBundleCache() {
    return this.Ti;
  }
  runTransaction(t, n, r) {
    ht("MemoryPersistence", "Starting transaction:", t);
    const i = new s0e(this.ui.next());
    return this.referenceDelegate.Ii(), r(i).next((o) => this.referenceDelegate.di(i).next(() => o)).toPromise().then((o) => (i.raiseOnCommittedEvent(), o));
  }
  Ei(t, n) {
    return Te.or(Object.values(this.ai).map((r) => () => r.containsKey(t, n)));
  }
}
class s0e extends Dpe {
  constructor(t) {
    super(), this.currentSequenceNumber = t;
  }
}
class WO {
  constructor(t) {
    this.persistence = t, /** Tracks all documents that are active in Query views. */
    this.Ai = new UO(), /** The list of documents that are potentially GCed after each transaction. */
    this.Ri = null;
  }
  static Vi(t) {
    return new WO(t);
  }
  get mi() {
    if (this.Ri)
      return this.Ri;
    throw Wt(60996);
  }
  addReference(t, n, r) {
    return this.Ai.addReference(r, n), this.mi.delete(r.toString()), Te.resolve();
  }
  removeReference(t, n, r) {
    return this.Ai.removeReference(r, n), this.mi.add(r.toString()), Te.resolve();
  }
  markPotentiallyOrphaned(t, n) {
    return this.mi.add(n.toString()), Te.resolve();
  }
  removeTarget(t, n) {
    this.Ai.zr(n.targetId).forEach((i) => this.mi.add(i.toString()));
    const r = this.persistence.getTargetCache();
    return r.getMatchingKeysForTargetId(t, n.targetId).next((i) => {
      i.forEach((o) => this.mi.add(o.toString()));
    }).next(() => r.removeTargetData(t, n));
  }
  Ii() {
    this.Ri = /* @__PURE__ */ new Set();
  }
  di(t) {
    const n = this.persistence.getRemoteDocumentCache().newChangeBuffer();
    return Te.forEach(this.mi, (r) => {
      const i = $t.fromPath(r);
      return this.fi(t, i).next((o) => {
        o || n.removeEntry(i, Gt.min());
      });
    }).next(() => (this.Ri = null, n.apply(t)));
  }
  updateLimboDocument(t, n) {
    return this.fi(t, n).next((r) => {
      r ? this.mi.delete(n.toString()) : this.mi.add(n.toString());
    });
  }
  Pi(t) {
    return 0;
  }
  fi(t, n) {
    return Te.or([() => Te.resolve(this.Ai.containsKey(n)), () => this.persistence.getTargetCache().containsKey(t, n), () => this.persistence.Ei(t, n)]);
  }
}
class P_ {
  constructor(t, n) {
    this.persistence = t, this.gi = new wf((r) => Fpe(r.path), (r, i) => r.isEqual(i)), this.garbageCollector = Xme(this, n);
  }
  static Vi(t, n) {
    return new P_(t, n);
  }
  // No-ops, present so memory persistence doesn't have to care which delegate
  // it has.
  Ii() {
  }
  di(t) {
    return Te.resolve();
  }
  forEachTarget(t, n) {
    return this.persistence.getTargetCache().forEachTarget(t, n);
  }
  mr(t) {
    const n = this.yr(t);
    return this.persistence.getTargetCache().getTargetCount(t).next((r) => n.next((i) => r + i));
  }
  yr(t) {
    let n = 0;
    return this.gr(t, (r) => {
      n++;
    }).next(() => n);
  }
  gr(t, n) {
    return Te.forEach(this.gi, (r, i) => this.Sr(t, r, i).next((o) => o ? Te.resolve() : n(i)));
  }
  removeTargets(t, n, r) {
    return this.persistence.getTargetCache().removeTargets(t, n, r);
  }
  removeOrphanedDocuments(t, n) {
    let r = 0;
    const i = this.persistence.getRemoteDocumentCache(), o = i.newChangeBuffer();
    return i.ri(t, (a) => this.Sr(t, a, n).next((s) => {
      s || (r++, o.removeEntry(a, Gt.min()));
    })).next(() => o.apply(t)).next(() => r);
  }
  markPotentiallyOrphaned(t, n) {
    return this.gi.set(n, t.currentSequenceNumber), Te.resolve();
  }
  removeTarget(t, n) {
    const r = n.withSequenceNumber(t.currentSequenceNumber);
    return this.persistence.getTargetCache().updateTargetData(t, r);
  }
  addReference(t, n, r) {
    return this.gi.set(r, t.currentSequenceNumber), Te.resolve();
  }
  removeReference(t, n, r) {
    return this.gi.set(r, t.currentSequenceNumber), Te.resolve();
  }
  updateLimboDocument(t, n) {
    return this.gi.set(n, t.currentSequenceNumber), Te.resolve();
  }
  Pi(t) {
    let n = t.key.toString().length;
    return t.isFoundDocument() && (n += O1(t.data.value)), n;
  }
  Sr(t, n, r) {
    return Te.or([() => this.persistence.Ei(t, n), () => this.persistence.getTargetCache().containsKey(t, n), () => {
      const i = this.gi.get(n);
      return Te.resolve(i !== void 0 && i > r);
    }]);
  }
  getCacheSize(t) {
    return this.persistence.getRemoteDocumentCache().getSize(t);
  }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class qO {
  constructor(t, n, r, i) {
    this.targetId = t, this.fromCache = n, this.Is = r, this.ds = i;
  }
  static Es(t, n) {
    let r = _n(), i = _n();
    for (const o of n.docChanges)
      switch (o.type) {
        case 0:
          r = r.add(o.doc.key);
          break;
        case 1:
          i = i.add(o.doc.key);
      }
    return new qO(t, n.fromCache, r, i);
  }
}
/**
 * @license
 * Copyright 2023 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class c0e {
  constructor() {
    this._documentReadCount = 0;
  }
  get documentReadCount() {
    return this._documentReadCount;
  }
  incrementDocumentReadCount(t) {
    this._documentReadCount += t;
  }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class l0e {
  constructor() {
    this.As = !1, this.Rs = !1, /**
     * SDK only decides whether it should create index when collection size is
     * larger than this.
     */
    this.Vs = 100, this.fs = /**
    * This cost represents the evaluation result of
    * (([index, docKey] + [docKey, docContent]) per document in the result set)
    * / ([docKey, docContent] per documents in full collection scan) coming from
    * experiment [enter PR experiment URL here].
    */
    function() {
      return iue() ? 8 : Lpe(co()) > 0 ? 6 : 4;
    }();
  }
  /** Sets the document view to query against. */
  initialize(t, n) {
    this.gs = t, this.indexManager = n, this.As = !0;
  }
  /** Returns all local documents matching the specified query. */
  getDocumentsMatchingQuery(t, n, r, i) {
    const o = {
      result: null
    };
    return this.ps(t, n).next((a) => {
      o.result = a;
    }).next(() => {
      if (!o.result)
        return this.ys(t, n, i, r).next((a) => {
          o.result = a;
        });
    }).next(() => {
      if (o.result)
        return;
      const a = new c0e();
      return this.ws(t, n, a).next((s) => {
        if (o.result = s, this.Rs)
          return this.Ss(t, n, a, s.size);
      });
    }).next(() => o.result);
  }
  Ss(t, n, r, i) {
    return r.documentReadCount < this.Vs ? (Sh() <= bn.DEBUG && ht("QueryEngine", "SDK will not create cache indexes for query:", wh(n), "since it only creates cache indexes for collection contains", "more than or equal to", this.Vs, "documents"), Te.resolve()) : (Sh() <= bn.DEBUG && ht("QueryEngine", "Query:", wh(n), "scans", r.documentReadCount, "local documents and returns", i, "documents as results."), r.documentReadCount > this.fs * i ? (Sh() <= bn.DEBUG && ht("QueryEngine", "The SDK decides to create cache indexes for query:", wh(n), "as using cache indexes may help improve performance."), this.indexManager.createTargetIndexes(t, nc(n))) : Te.resolve());
  }
  /**
   * Performs an indexed query that evaluates the query based on a collection's
   * persisted index values. Returns `null` if an index is not available.
   */
  ps(t, n) {
    if (u7(n))
      return Te.resolve(null);
    let r = nc(n);
    return this.indexManager.getIndexType(t, r).next((i) => i === 0 ? null : (n.limit !== null && i === 1 && // We cannot apply a limit for targets that are served using a partial
    // index. If a partial index will be used to serve the target, the
    // query may return a superset of documents that match the target
    // (e.g. if the index doesn't include all the target's filters), or
    // may return the correct set of documents in the wrong order (e.g. if
    // the index doesn't include a segment for one of the orderBys).
    // Therefore, a limit should not be applied in such cases.
    (n = A_(
      n,
      null,
      "F"
      /* LimitType.First */
    ), r = nc(n)), this.indexManager.getDocumentsMatchingTarget(t, r).next((o) => {
      const a = _n(...o);
      return this.gs.getDocuments(t, a).next((s) => this.indexManager.getMinOffset(t, r).next((c) => {
        const l = this.bs(n, s);
        return this.Ds(n, l, a, c.readTime) ? this.ps(t, A_(
          n,
          null,
          "F"
          /* LimitType.First */
        )) : this.vs(t, l, n, c);
      }));
    })));
  }
  /**
   * Performs a query based on the target's persisted query mapping. Returns
   * `null` if the mapping is not available or cannot be used.
   */
  ys(t, n, r, i) {
    return u7(n) || i.isEqual(Gt.min()) ? Te.resolve(null) : this.gs.getDocuments(t, r).next((o) => {
      const a = this.bs(n, o);
      return this.Ds(n, a, r, i) ? Te.resolve(null) : (Sh() <= bn.DEBUG && ht("QueryEngine", "Re-using previous result from %s to execute query: %s", i.toString(), wh(n)), this.vs(t, a, n, Ppe(i, j0)).next((s) => s));
    });
  }
  /** Applies the query filter and sorting to the provided documents.  */
  bs(t, n) {
    let r = new Si(uW(t));
    return n.forEach((i, o) => {
      cx(t, o) && (r = r.add(o));
    }), r;
  }
  /**
   * Determines if a limit query needs to be refilled from cache, making it
   * ineligible for index-free execution.
   *
   * @param query - The query.
   * @param sortedPreviousResults - The documents that matched the query when it
   * was last synchronized, sorted by the query's comparator.
   * @param remoteKeys - The document keys that matched the query at the last
   * snapshot.
   * @param limboFreeSnapshotVersion - The version of the snapshot when the
   * query was last synchronized.
   */
  Ds(t, n, r, i) {
    if (t.limit === null)
      return !1;
    if (r.size !== n.size)
      return !0;
    const o = t.limitType === "F" ? n.last() : n.first();
    return !!o && (o.hasPendingWrites || o.version.compareTo(i) > 0);
  }
  ws(t, n, r) {
    return Sh() <= bn.DEBUG && ht("QueryEngine", "Using full collection scan to execute query:", wh(n)), this.gs.getDocumentsMatchingQuery(t, n, vu.min(), r);
  }
  /**
   * Combines the results from an indexed execution with the remaining documents
   * that have not yet been indexed.
   */
  vs(t, n, r, i) {
    return this.gs.getDocumentsMatchingQuery(t, r, i).next((o) => (
      // Merge with existing results
      (n.forEach((a) => {
        o = o.insert(a.key, a);
      }), o)
    ));
  }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const GO = "LocalStore", u0e = 3e8;
class d0e {
  constructor(t, n, r, i) {
    this.persistence = t, this.Cs = n, this.serializer = i, /**
     * Maps a targetID to data about its target.
     *
     * PORTING NOTE: We are using an immutable data structure on Web to make re-runs
     * of `applyRemoteEvent()` idempotent.
     */
    this.Fs = new jr(hn), /** Maps a target to its targetID. */
    // TODO(wuandy): Evaluate if TargetId can be part of Target.
    this.Ms = new wf((o) => LO(o), jO), /**
     * A per collection group index of the last read time processed by
     * `getNewDocumentChanges()`.
     *
     * PORTING NOTE: This is only used for multi-tab synchronization.
     */
    this.xs = /* @__PURE__ */ new Map(), this.Os = t.getRemoteDocumentCache(), this.hi = t.getTargetCache(), this.Ti = t.getBundleCache(), this.Ns(r);
  }
  Ns(t) {
    this.documentOverlayCache = this.persistence.getDocumentOverlayCache(t), this.indexManager = this.persistence.getIndexManager(t), this.mutationQueue = this.persistence.getMutationQueue(t, this.indexManager), this.localDocuments = new Zme(this.Os, this.mutationQueue, this.documentOverlayCache, this.indexManager), this.Os.setIndexManager(this.indexManager), this.Cs.initialize(this.localDocuments, this.indexManager);
  }
  collectGarbage(t) {
    return this.persistence.runTransaction("Collect garbage", "readwrite-primary", (n) => t.collect(n, this.Fs));
  }
}
function f0e(e, t, n, r) {
  return new d0e(e, t, n, r);
}
async function DW(e, t) {
  const n = qt(e);
  return await n.persistence.runTransaction("Handle user change", "readonly", (r) => {
    let i;
    return n.mutationQueue.getAllMutationBatches(r).next((o) => (i = o, n.Ns(t), n.mutationQueue.getAllMutationBatches(r))).next((o) => {
      const a = [], s = [];
      let c = _n();
      for (const l of i) {
        a.push(l.batchId);
        for (const u of l.mutations)
          c = c.add(u.key);
      }
      for (const l of o) {
        s.push(l.batchId);
        for (const u of l.mutations)
          c = c.add(u.key);
      }
      return n.localDocuments.getDocuments(r, c).next((l) => ({
        Bs: l,
        removedBatchIds: a,
        addedBatchIds: s
      }));
    });
  });
}
function h0e(e, t) {
  const n = qt(e);
  return n.persistence.runTransaction("Acknowledge batch", "readwrite-primary", (r) => {
    const i = t.batch.keys(), o = n.Os.newChangeBuffer({
      trackRemovals: !0
    });
    return function(s, c, l, u) {
      const d = l.batch, f = d.keys();
      let h = Te.resolve();
      return f.forEach((p) => {
        h = h.next(() => u.getEntry(c, p)).next((g) => {
          const m = l.docVersions.get(p);
          jn(m !== null, 48541), g.version.compareTo(m) < 0 && (d.applyToRemoteDocument(g, l), g.isValidDocument() && // We use the commitVersion as the readTime rather than the
          // document's updateTime since the updateTime is not advanced
          // for updates that do not modify the underlying document.
          (g.setReadTime(l.commitVersion), u.addEntry(g)));
        });
      }), h.next(() => s.mutationQueue.removeMutationBatch(c, d));
    }(n, r, t, o).next(() => o.apply(r)).next(() => n.mutationQueue.performConsistencyCheck(r)).next(() => n.documentOverlayCache.removeOverlaysForBatchId(r, i, t.batch.batchId)).next(() => n.localDocuments.recalculateAndSaveOverlaysForDocumentKeys(r, function(s) {
      let c = _n();
      for (let l = 0; l < s.mutationResults.length; ++l)
        s.mutationResults[l].transformResults.length > 0 && (c = c.add(s.batch.mutations[l].key));
      return c;
    }(t))).next(() => n.localDocuments.getDocuments(r, i));
  });
}
function LW(e) {
  const t = qt(e);
  return t.persistence.runTransaction("Get last remote snapshot version", "readonly", (n) => t.hi.getLastRemoteSnapshotVersion(n));
}
function g0e(e, t) {
  const n = qt(e), r = t.snapshotVersion;
  let i = n.Fs;
  return n.persistence.runTransaction("Apply remote event", "readwrite-primary", (o) => {
    const a = n.Os.newChangeBuffer({
      trackRemovals: !0
    });
    i = n.Fs;
    const s = [];
    t.targetChanges.forEach((u, d) => {
      const f = i.get(d);
      if (!f)
        return;
      s.push(n.hi.removeMatchingKeys(o, u.removedDocuments, d).next(() => n.hi.addMatchingKeys(o, u.addedDocuments, d)));
      let h = f.withSequenceNumber(o.currentSequenceNumber);
      t.targetMismatches.get(d) !== null ? h = h.withResumeToken(Hi.EMPTY_BYTE_STRING, Gt.min()).withLastLimboFreeSnapshotVersion(Gt.min()) : u.resumeToken.approximateByteSize() > 0 && (h = h.withResumeToken(u.resumeToken, r)), i = i.insert(d, h), // Update the target data if there are target changes (or if
      // sufficient time has passed since the last update).
      /**
      * Returns true if the newTargetData should be persisted during an update of
      * an active target. TargetData should always be persisted when a target is
      * being released and should not call this function.
      *
      * While the target is active, TargetData updates can be omitted when nothing
      * about the target has changed except metadata like the resume token or
      * snapshot version. Occasionally it's worth the extra write to prevent these
      * values from getting too stale after a crash, but this doesn't have to be
      * too frequent.
      */
      function(g, m, v) {
        return g.resumeToken.approximateByteSize() === 0 || m.snapshotVersion.toMicroseconds() - g.snapshotVersion.toMicroseconds() >= u0e ? !0 : v.addedDocuments.size + v.modifiedDocuments.size + v.removedDocuments.size > 0;
      }(f, h, u) && s.push(n.hi.updateTargetData(o, h));
    });
    let c = al(), l = _n();
    if (t.documentUpdates.forEach((u) => {
      t.resolvedLimboDocuments.has(u) && s.push(n.persistence.referenceDelegate.updateLimboDocument(o, u));
    }), // Each loop iteration only affects its "own" doc, so it's safe to get all
    // the remote documents in advance in a single call.
    s.push(p0e(o, a, t.documentUpdates).next((u) => {
      c = u.Ls, l = u.ks;
    })), !r.isEqual(Gt.min())) {
      const u = n.hi.getLastRemoteSnapshotVersion(o).next((d) => n.hi.setTargetsMetadata(o, o.currentSequenceNumber, r));
      s.push(u);
    }
    return Te.waitFor(s).next(() => a.apply(o)).next(() => n.localDocuments.getLocalViewOfDocuments(o, c, l)).next(() => c);
  }).then((o) => (n.Fs = i, o));
}
function p0e(e, t, n) {
  let r = _n(), i = _n();
  return n.forEach((o) => r = r.add(o)), t.getEntries(e, r).next((o) => {
    let a = al();
    return n.forEach((s, c) => {
      const l = o.get(s);
      c.isFoundDocument() !== l.isFoundDocument() && (i = i.add(s)), // Note: The order of the steps below is important, since we want
      // to ensure that rejected limbo resolutions (which fabricate
      // NoDocuments with SnapshotVersion.min()) never add documents to
      // cache.
      c.isNoDocument() && c.version.isEqual(Gt.min()) ? (
        // NoDocuments with SnapshotVersion.min() are used in manufactured
        // events. We remove these documents from cache since we lost
        // access.
        (t.removeEntry(s, c.readTime), a = a.insert(s, c))
      ) : !l.isValidDocument() || c.version.compareTo(l.version) > 0 || c.version.compareTo(l.version) === 0 && l.hasPendingWrites ? (t.addEntry(c), a = a.insert(s, c)) : ht(GO, "Ignoring outdated watch update for ", s, ". Current version:", l.version, " Watch version:", c.version);
    }), {
      Ls: a,
      ks: i
    };
  });
}
function m0e(e, t) {
  const n = qt(e);
  return n.persistence.runTransaction("Get next mutation batch", "readonly", (r) => (t === void 0 && (t = NO), n.mutationQueue.getNextMutationBatchAfterBatchId(r, t)));
}
function v0e(e, t) {
  const n = qt(e);
  return n.persistence.runTransaction("Allocate target", "readwrite", (r) => {
    let i;
    return n.hi.getTargetData(r, t).next((o) => o ? (
      // This target has been listened to previously, so reuse the
      // previous targetID.
      // TODO(mcg): freshen last accessed date?
      (i = o, Te.resolve(i))
    ) : n.hi.allocateTargetId(r).next((a) => (i = new ql(t, a, "TargetPurposeListen", r.currentSequenceNumber), n.hi.addTargetData(r, i).next(() => i))));
  }).then((r) => {
    const i = n.Fs.get(r.targetId);
    return (i === null || r.snapshotVersion.compareTo(i.snapshotVersion) > 0) && (n.Fs = n.Fs.insert(r.targetId, r), n.Ms.set(t, r.targetId)), r;
  });
}
async function WI(e, t, n) {
  const r = qt(e), i = r.Fs.get(t), o = n ? "readwrite" : "readwrite-primary";
  try {
    n || await r.persistence.runTransaction("Release target", o, (a) => r.persistence.referenceDelegate.removeTarget(a, i));
  } catch (a) {
    if (!dp(a))
      throw a;
    ht(GO, `Failed to update sequence numbers for target ${t}: ${a}`);
  }
  r.Fs = r.Fs.remove(t), r.Ms.delete(i.target);
}
function x7(e, t, n) {
  const r = qt(e);
  let i = Gt.min(), o = _n();
  return r.persistence.runTransaction(
    "Execute query",
    "readwrite",
    // Use readwrite instead of readonly so indexes can be created
    // Use readwrite instead of readonly so indexes can be created
    (a) => function(c, l, u) {
      const d = qt(c), f = d.Ms.get(u);
      return f !== void 0 ? Te.resolve(d.Fs.get(f)) : d.hi.getTargetData(l, u);
    }(r, a, nc(t)).next((s) => {
      if (s)
        return i = s.lastLimboFreeSnapshotVersion, r.hi.getMatchingKeysForTargetId(a, s.targetId).next((c) => {
          o = c;
        });
    }).next(() => r.Cs.getDocumentsMatchingQuery(a, t, n ? i : Gt.min(), n ? o : _n())).next((s) => (y0e(r, ime(t), s), {
      documents: s,
      qs: o
    }))
  );
}
function y0e(e, t, n) {
  let r = e.xs.get(t) || Gt.min();
  n.forEach((i, o) => {
    o.readTime.compareTo(r) > 0 && (r = o.readTime);
  }), e.xs.set(t, r);
}
class E7 {
  constructor() {
    this.activeTargetIds = ume();
  }
  Gs(t) {
    this.activeTargetIds = this.activeTargetIds.add(t);
  }
  zs(t) {
    this.activeTargetIds = this.activeTargetIds.delete(t);
  }
  /**
   * Converts this entry into a JSON-encoded format we can use for WebStorage.
   * Does not encode `clientId` as it is part of the key in WebStorage.
   */
  Ws() {
    const t = {
      activeTargetIds: this.activeTargetIds.toArray(),
      updateTimeMs: Date.now()
    };
    return JSON.stringify(t);
  }
}
class b0e {
  constructor() {
    this.Fo = new E7(), this.Mo = {}, this.onlineStateHandler = null, this.sequenceNumberHandler = null;
  }
  addPendingMutation(t) {
  }
  updateMutationState(t, n, r) {
  }
  addLocalQueryTarget(t, n = !0) {
    return n && this.Fo.Gs(t), this.Mo[t] || "not-current";
  }
  updateQueryState(t, n, r) {
    this.Mo[t] = n;
  }
  removeLocalQueryTarget(t) {
    this.Fo.zs(t);
  }
  isLocalQueryTarget(t) {
    return this.Fo.activeTargetIds.has(t);
  }
  clearQueryState(t) {
    delete this.Mo[t];
  }
  getAllActiveQueryTargets() {
    return this.Fo.activeTargetIds;
  }
  isActiveQueryTarget(t) {
    return this.Fo.activeTargetIds.has(t);
  }
  start() {
    return this.Fo = new E7(), Promise.resolve();
  }
  handleUserChange(t, n, r) {
  }
  setOnlineState(t) {
  }
  shutdown() {
  }
  writeSequenceNumber(t) {
  }
  notifyBundleLoaded(t) {
  }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class _0e {
  xo(t) {
  }
  shutdown() {
  }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const C7 = "ConnectivityMonitor";
class T7 {
  constructor() {
    this.Oo = () => this.No(), this.Bo = () => this.Lo(), this.ko = [], this.qo();
  }
  xo(t) {
    this.ko.push(t);
  }
  shutdown() {
    window.removeEventListener("online", this.Oo), window.removeEventListener("offline", this.Bo);
  }
  qo() {
    window.addEventListener("online", this.Oo), window.addEventListener("offline", this.Bo);
  }
  No() {
    ht(C7, "Network connectivity changed: AVAILABLE");
    for (const t of this.ko)
      t(
        0
        /* NetworkStatus.AVAILABLE */
      );
  }
  Lo() {
    ht(C7, "Network connectivity changed: UNAVAILABLE");
    for (const t of this.ko)
      t(
        1
        /* NetworkStatus.UNAVAILABLE */
      );
  }
  // TODO(chenbrian): Consider passing in window either into this component or
  // here for testing via FakeWindow.
  /** Checks that all used attributes of window are available. */
  static C() {
    return typeof window < "u" && window.addEventListener !== void 0 && window.removeEventListener !== void 0;
  }
}
/**
 * @license
 * Copyright 2023 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
let bb = null;
function qI() {
  return bb === null ? bb = function() {
    return 268435456 + Math.round(2147483648 * Math.random());
  }() : bb++, "0x" + bb.toString(16);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const t5 = "RestConnection", S0e = {
  BatchGetDocuments: "batchGet",
  Commit: "commit",
  RunQuery: "runQuery",
  RunAggregationQuery: "runAggregationQuery"
};
class w0e {
  get Qo() {
    return !1;
  }
  constructor(t) {
    this.databaseInfo = t, this.databaseId = t.databaseId;
    const n = t.ssl ? "https" : "http", r = encodeURIComponent(this.databaseId.projectId), i = encodeURIComponent(this.databaseId.database);
    this.$o = n + "://" + t.host, this.Uo = `projects/${r}/databases/${i}`, this.Ko = this.databaseId.database === V0 ? `project_id=${r}` : `project_id=${r}&database_id=${i}`;
  }
  Wo(t, n, r, i, o) {
    const a = qI(), s = this.Go(t, n.toUriEncodedString());
    ht(t5, `Sending RPC '${t}' ${a}:`, s, r);
    const c = {
      "google-cloud-resource-prefix": this.Uo,
      "x-goog-request-params": this.Ko
    };
    this.zo(c, i, o);
    const { host: l } = new URL(s), u = ku(l);
    return this.jo(t, s, c, r, u).then((d) => (ht(t5, `Received RPC '${t}' ${a}: `, d), d), (d) => {
      throw mu(t5, `RPC '${t}' ${a} failed with error: `, d, "url: ", s, "request:", r), d;
    });
  }
  Jo(t, n, r, i, o, a) {
    return this.Wo(t, n, r, i, o);
  }
  /**
   * Modifies the headers for a request, adding any authorization token if
   * present and any additional headers for the request.
   */
  zo(t, n, r) {
    t["X-Goog-Api-Client"] = // SDK_VERSION is updated to different value at runtime depending on the entry point,
    // so we need to get its value when we need it in a function.
    function() {
      return "gl-js/ fire/" + lp;
    }(), // Content-Type: text/plain will avoid preflight requests which might
    // mess with CORS and redirects by proxies. If we add custom headers
    // we will need to change this code to potentially use the $httpOverwrite
    // parameter supported by ESF to avoid triggering preflight requests.
    t["Content-Type"] = "text/plain", this.databaseInfo.appId && (t["X-Firebase-GMPID"] = this.databaseInfo.appId), n && n.headers.forEach((i, o) => t[o] = i), r && r.headers.forEach((i, o) => t[o] = i);
  }
  Go(t, n) {
    const r = S0e[t];
    return `${this.$o}/v1/${n}:${r}`;
  }
  /**
   * Closes and cleans up any resources associated with the connection. This
   * implementation is a no-op because there are no resources associated
   * with the RestConnection that need to be cleaned up.
   */
  terminate() {
  }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class x0e {
  constructor(t) {
    this.Ho = t.Ho, this.Yo = t.Yo;
  }
  Zo(t) {
    this.Xo = t;
  }
  e_(t) {
    this.t_ = t;
  }
  n_(t) {
    this.r_ = t;
  }
  onMessage(t) {
    this.i_ = t;
  }
  close() {
    this.Yo();
  }
  send(t) {
    this.Ho(t);
  }
  s_() {
    this.Xo();
  }
  o_() {
    this.t_();
  }
  __(t) {
    this.r_(t);
  }
  a_(t) {
    this.i_(t);
  }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const Qi = "WebChannelConnection";
class E0e extends w0e {
  constructor(t) {
    super(t), /** A collection of open WebChannel instances */
    this.u_ = [], this.forceLongPolling = t.forceLongPolling, this.autoDetectLongPolling = t.autoDetectLongPolling, this.useFetchStreams = t.useFetchStreams, this.longPollingOptions = t.longPollingOptions;
  }
  jo(t, n, r, i, o) {
    const a = qI();
    return new Promise((s, c) => {
      const l = new kU();
      l.setWithCredentials(!0), l.listenOnce(NU.COMPLETE, () => {
        try {
          switch (l.getLastErrorCode()) {
            case $1.NO_ERROR:
              const d = l.getResponseJson();
              ht(Qi, `XHR for RPC '${t}' ${a} received:`, JSON.stringify(d)), s(d);
              break;
            case $1.TIMEOUT:
              ht(Qi, `RPC '${t}' ${a} timed out`), c(new Ye(Se.DEADLINE_EXCEEDED, "Request time out"));
              break;
            case $1.HTTP_ERROR:
              const f = l.getStatus();
              if (ht(Qi, `RPC '${t}' ${a} failed with status:`, f, "response text:", l.getResponseText()), f > 0) {
                let h = l.getResponseJson();
                Array.isArray(h) && (h = h[0]);
                const p = h == null ? void 0 : h.error;
                if (p && p.status && p.message) {
                  const g = function(v) {
                    const y = v.toLowerCase().replace(/_/g, "-");
                    return Object.values(Se).indexOf(y) >= 0 ? y : Se.UNKNOWN;
                  }(p.status);
                  c(new Ye(g, p.message));
                } else
                  c(new Ye(Se.UNKNOWN, "Server responded with status " + l.getStatus()));
              } else
                c(new Ye(Se.UNAVAILABLE, "Connection failed."));
              break;
            default:
              Wt(9055, {
                c_: t,
                streamId: a,
                l_: l.getLastErrorCode(),
                h_: l.getLastError()
              });
          }
        } finally {
          ht(Qi, `RPC '${t}' ${a} completed.`);
        }
      });
      const u = JSON.stringify(i);
      ht(Qi, `RPC '${t}' ${a} sending request:`, i), l.send(n, "POST", u, r, 15);
    });
  }
  P_(t, n, r) {
    const i = qI(), o = [this.$o, "/", "google.firestore.v1.Firestore", "/", t, "/channel"], a = jU(), s = LU(), c = {
      // Required for backend stickiness, routing behavior is based on this
      // parameter.
      httpSessionIdParam: "gsessionid",
      initMessageHeaders: {},
      messageUrlParams: {
        // This param is used to improve routing and project isolation by the
        // backend and must be included in every request.
        database: `projects/${this.databaseId.projectId}/databases/${this.databaseId.database}`
      },
      sendRawJson: !0,
      supportsCrossDomainXhr: !0,
      internalChannelParams: {
        // Override the default timeout (randomized between 10-20 seconds) since
        // a large write batch on a slow internet connection may take a long
        // time to send to the backend. Rather than have WebChannel impose a
        // tight timeout which could lead to infinite timeouts and retries, we
        // set it very large (5-10 minutes) and rely on the browser's builtin
        // timeouts to kick in if the request isn't working.
        forwardChannelRequestTimeoutMs: 6e5
      },
      forceLongPolling: this.forceLongPolling,
      detectBufferingProxy: this.autoDetectLongPolling
    }, l = this.longPollingOptions.timeoutSeconds;
    l !== void 0 && (c.longPollingTimeout = Math.round(1e3 * l)), this.useFetchStreams && (c.useFetchStreams = !0), this.zo(c.initMessageHeaders, n, r), // Sending the custom headers we just added to request.initMessageHeaders
    // (Authorization, etc.) will trigger the browser to make a CORS preflight
    // request because the XHR will no longer meet the criteria for a "simple"
    // CORS request:
    // https://developer.mozilla.org/en-US/docs/Web/HTTP/CORS#Simple_requests
    // Therefore to avoid the CORS preflight request (an extra network
    // roundtrip), we use the encodeInitMessageHeaders option to specify that
    // the headers should instead be encoded in the request's POST payload,
    // which is recognized by the webchannel backend.
    c.encodeInitMessageHeaders = !0;
    const u = o.join("");
    ht(Qi, `Creating RPC '${t}' stream ${i}: ${u}`, c);
    const d = a.createWebChannel(u, c);
    this.T_(d);
    let f = !1, h = !1;
    const p = new x0e({
      Ho: (m) => {
        h ? ht(Qi, `Not sending because RPC '${t}' stream ${i} is closed:`, m) : (f || (ht(Qi, `Opening RPC '${t}' stream ${i} transport.`), d.open(), f = !0), ht(Qi, `RPC '${t}' stream ${i} sending:`, m), d.send(m));
      },
      Yo: () => d.close()
    }), g = (m, v, y) => {
      m.listen(v, (S) => {
        try {
          y(S);
        } catch (_) {
          setTimeout(() => {
            throw _;
          }, 0);
        }
      });
    };
    return g(d, jm.EventType.OPEN, () => {
      h || (ht(Qi, `RPC '${t}' stream ${i} transport opened.`), p.s_());
    }), g(d, jm.EventType.CLOSE, () => {
      h || (h = !0, ht(Qi, `RPC '${t}' stream ${i} transport closed`), p.__(), this.I_(d));
    }), g(d, jm.EventType.ERROR, (m) => {
      h || (h = !0, mu(Qi, `RPC '${t}' stream ${i} transport errored. Name:`, m.name, "Message:", m.message), p.__(new Ye(Se.UNAVAILABLE, "The operation could not be completed")));
    }), g(d, jm.EventType.MESSAGE, (m) => {
      var v;
      if (!h) {
        const y = m.data[0];
        jn(!!y, 16349);
        const S = y, _ = (S == null ? void 0 : S.error) || ((v = S[0]) === null || v === void 0 ? void 0 : v.error);
        if (_) {
          ht(Qi, `RPC '${t}' stream ${i} received error:`, _);
          const w = _.status;
          let T = (
            /**
            * Maps an error Code from a GRPC status identifier like 'NOT_FOUND'.
            *
            * @returns The Code equivalent to the given status string or undefined if
            *     there is no match.
            */
            function(E) {
              const R = ii[E];
              if (R !== void 0)
                return wW(R);
            }(w)
          ), x = _.message;
          T === void 0 && (T = Se.INTERNAL, x = "Unknown error status: " + w + " with message " + _.message), // Mark closed so no further events are propagated
          h = !0, p.__(new Ye(T, x)), d.close();
        } else
          ht(Qi, `RPC '${t}' stream ${i} received:`, y), p.a_(y);
      }
    }), g(s, DU.STAT_EVENT, (m) => {
      m.stat === kI.PROXY ? ht(Qi, `RPC '${t}' stream ${i} detected buffering proxy`) : m.stat === kI.NOPROXY && ht(Qi, `RPC '${t}' stream ${i} detected no buffering proxy`);
    }), setTimeout(() => {
      p.o_();
    }, 0), p;
  }
  /**
   * Closes and cleans up any resources associated with the connection.
   */
  terminate() {
    this.u_.forEach((t) => t.close()), this.u_ = [];
  }
  /**
   * Add a WebChannel instance to the collection of open instances.
   * @param webChannel
   */
  T_(t) {
    this.u_.push(t);
  }
  /**
   * Remove a WebChannel instance from the collection of open instances.
   * @param webChannel
   */
  I_(t) {
    this.u_ = this.u_.filter((n) => n === t);
  }
}
function n5() {
  return typeof document < "u" ? document : null;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function fx(e) {
  return new Rme(
    e,
    /* useProto3Json= */
    !0
  );
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class jW {
  constructor(t, n, r = 1e3, i = 1.5, o = 6e4) {
    this.Fi = t, this.timerId = n, this.d_ = r, this.E_ = i, this.A_ = o, this.R_ = 0, this.V_ = null, /** The last backoff attempt, as epoch milliseconds. */
    this.m_ = Date.now(), this.reset();
  }
  /**
   * Resets the backoff delay.
   *
   * The very next backoffAndWait() will have no delay. If it is called again
   * (i.e. due to an error), initialDelayMs (plus jitter) will be used, and
   * subsequent ones will increase according to the backoffFactor.
   */
  reset() {
    this.R_ = 0;
  }
  /**
   * Resets the backoff delay to the maximum delay (e.g. for use after a
   * RESOURCE_EXHAUSTED error).
   */
  f_() {
    this.R_ = this.A_;
  }
  /**
   * Returns a promise that resolves after currentDelayMs, and increases the
   * delay for any subsequent attempts. If there was a pending backoff operation
   * already, it will be canceled.
   */
  g_(t) {
    this.cancel();
    const n = Math.floor(this.R_ + this.p_()), r = Math.max(0, Date.now() - this.m_), i = Math.max(0, n - r);
    i > 0 && ht("ExponentialBackoff", `Backing off for ${i} ms (base delay: ${this.R_} ms, delay with jitter: ${n} ms, last attempt: ${r} ms ago)`), this.V_ = this.Fi.enqueueAfterDelay(this.timerId, i, () => (this.m_ = Date.now(), t())), // Apply backoff factor to determine next delay and ensure it is within
    // bounds.
    this.R_ *= this.E_, this.R_ < this.d_ && (this.R_ = this.d_), this.R_ > this.A_ && (this.R_ = this.A_);
  }
  y_() {
    this.V_ !== null && (this.V_.skipDelay(), this.V_ = null);
  }
  cancel() {
    this.V_ !== null && (this.V_.cancel(), this.V_ = null);
  }
  /** Returns a random value in the range [-currentBaseMs/2, currentBaseMs/2] */
  p_() {
    return (Math.random() - 0.5) * this.R_;
  }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const I7 = "PersistentStream";
class FW {
  constructor(t, n, r, i, o, a, s, c) {
    this.Fi = t, this.w_ = r, this.S_ = i, this.connection = o, this.authCredentialsProvider = a, this.appCheckCredentialsProvider = s, this.listener = c, this.state = 0, /**
     * A close count that's incremented every time the stream is closed; used by
     * getCloseGuardedDispatcher() to invalidate callbacks that happen after
     * close.
     */
    this.b_ = 0, this.D_ = null, this.v_ = null, this.stream = null, /**
     * Count of response messages received.
     */
    this.C_ = 0, this.F_ = new jW(t, n);
  }
  /**
   * Returns true if start() has been called and no error has occurred. True
   * indicates the stream is open or in the process of opening (which
   * encompasses respecting backoff, getting auth tokens, and starting the
   * actual RPC). Use isOpen() to determine if the stream is open and ready for
   * outbound requests.
   */
  M_() {
    return this.state === 1 || this.state === 5 || this.x_();
  }
  /**
   * Returns true if the underlying RPC is open (the onOpen() listener has been
   * called) and the stream is ready for outbound requests.
   */
  x_() {
    return this.state === 2 || this.state === 3;
  }
  /**
   * Starts the RPC. Only allowed if isStarted() returns false. The stream is
   * not immediately ready for use: onOpen() will be invoked when the RPC is
   * ready for outbound requests, at which point isOpen() will return true.
   *
   * When start returns, isStarted() will return true.
   */
  start() {
    this.C_ = 0, this.state !== 4 ? this.auth() : this.O_();
  }
  /**
   * Stops the RPC. This call is idempotent and allowed regardless of the
   * current isStarted() state.
   *
   * When stop returns, isStarted() and isOpen() will both return false.
   */
  async stop() {
    this.M_() && await this.close(
      0
      /* PersistentStreamState.Initial */
    );
  }
  /**
   * After an error the stream will usually back off on the next attempt to
   * start it. If the error warrants an immediate restart of the stream, the
   * sender can use this to indicate that the receiver should not back off.
   *
   * Each error will call the onClose() listener. That function can decide to
   * inhibit backoff if required.
   */
  N_() {
    this.state = 0, this.F_.reset();
  }
  /**
   * Marks this stream as idle. If no further actions are performed on the
   * stream for one minute, the stream will automatically close itself and
   * notify the stream's onClose() handler with Status.OK. The stream will then
   * be in a !isStarted() state, requiring the caller to start the stream again
   * before further use.
   *
   * Only streams that are in state 'Open' can be marked idle, as all other
   * states imply pending network operations.
   */
  B_() {
    this.x_() && this.D_ === null && (this.D_ = this.Fi.enqueueAfterDelay(this.w_, 6e4, () => this.L_()));
  }
  /** Sends a message to the underlying stream. */
  k_(t) {
    this.q_(), this.stream.send(t);
  }
  /** Called by the idle timer when the stream should close due to inactivity. */
  async L_() {
    if (this.x_())
      return this.close(
        0
        /* PersistentStreamState.Initial */
      );
  }
  /** Marks the stream as active again. */
  q_() {
    this.D_ && (this.D_.cancel(), this.D_ = null);
  }
  /** Cancels the health check delayed operation. */
  Q_() {
    this.v_ && (this.v_.cancel(), this.v_ = null);
  }
  /**
   * Closes the stream and cleans up as necessary:
   *
   * * closes the underlying GRPC stream;
   * * calls the onClose handler with the given 'error';
   * * sets internal stream state to 'finalState';
   * * adjusts the backoff timer based on the error
   *
   * A new stream can be opened by calling start().
   *
   * @param finalState - the intended state of the stream after closing.
   * @param error - the error the connection was closed with.
   */
  async close(t, n) {
    this.q_(), this.Q_(), this.F_.cancel(), // Invalidates any stream-related callbacks (e.g. from auth or the
    // underlying stream), guaranteeing they won't execute.
    this.b_++, t !== 4 ? (
      // If this is an intentional close ensure we don't delay our next connection attempt.
      this.F_.reset()
    ) : n && n.code === Se.RESOURCE_EXHAUSTED ? (
      // Log the error. (Probably either 'quota exceeded' or 'max queue length reached'.)
      (ol(n.toString()), ol("Using maximum backoff delay to prevent overloading the backend."), this.F_.f_())
    ) : n && n.code === Se.UNAUTHENTICATED && this.state !== 3 && // "unauthenticated" error means the token was rejected. This should rarely
    // happen since both Auth and AppCheck ensure a sufficient TTL when we
    // request a token. If a user manually resets their system clock this can
    // fail, however. In this case, we should get a Code.UNAUTHENTICATED error
    // before we received the first message and we need to invalidate the token
    // to ensure that we fetch a new token.
    (this.authCredentialsProvider.invalidateToken(), this.appCheckCredentialsProvider.invalidateToken()), // Clean up the underlying stream because we are no longer interested in events.
    this.stream !== null && (this.U_(), this.stream.close(), this.stream = null), // This state must be assigned before calling onClose() to allow the callback to
    // inhibit backoff or otherwise manipulate the state in its non-started state.
    this.state = t, // Notify the listener that the stream closed.
    await this.listener.n_(n);
  }
  /**
   * Can be overridden to perform additional cleanup before the stream is closed.
   * Calling super.tearDown() is not required.
   */
  U_() {
  }
  auth() {
    this.state = 1;
    const t = this.K_(this.b_), n = this.b_;
    Promise.all([this.authCredentialsProvider.getToken(), this.appCheckCredentialsProvider.getToken()]).then(([r, i]) => {
      this.b_ === n && // Normally we'd have to schedule the callback on the AsyncQueue.
      // However, the following calls are safe to be called outside the
      // AsyncQueue since they don't chain asynchronous calls
      this.W_(r, i);
    }, (r) => {
      t(() => {
        const i = new Ye(Se.UNKNOWN, "Fetching auth token failed: " + r.message);
        return this.G_(i);
      });
    });
  }
  W_(t, n) {
    const r = this.K_(this.b_);
    this.stream = this.z_(t, n), this.stream.Zo(() => {
      r(() => this.listener.Zo());
    }), this.stream.e_(() => {
      r(() => (this.state = 2, this.v_ = this.Fi.enqueueAfterDelay(this.S_, 1e4, () => (this.x_() && (this.state = 3), Promise.resolve())), this.listener.e_()));
    }), this.stream.n_((i) => {
      r(() => this.G_(i));
    }), this.stream.onMessage((i) => {
      r(() => ++this.C_ == 1 ? this.j_(i) : this.onNext(i));
    });
  }
  O_() {
    this.state = 5, this.F_.g_(async () => {
      this.state = 0, this.start();
    });
  }
  // Visible for tests
  G_(t) {
    return ht(I7, `close with error: ${t}`), this.stream = null, this.close(4, t);
  }
  /**
   * Returns a "dispatcher" function that dispatches operations onto the
   * AsyncQueue but only runs them if closeCount remains unchanged. This allows
   * us to turn auth / stream callbacks into no-ops if the stream is closed /
   * re-opened, etc.
   */
  K_(t) {
    return (n) => {
      this.Fi.enqueueAndForget(() => this.b_ === t ? n() : (ht(I7, "stream callback skipped by getCloseGuardedDispatcher."), Promise.resolve()));
    };
  }
}
class C0e extends FW {
  constructor(t, n, r, i, o, a) {
    super(t, "listen_stream_connection_backoff", "listen_stream_idle", "health_check_timeout", n, r, i, a), this.serializer = o;
  }
  z_(t, n) {
    return this.connection.P_("Listen", t, n);
  }
  j_(t) {
    return this.onNext(t);
  }
  onNext(t) {
    this.F_.reset();
    const n = Pme(this.serializer, t), r = function(o) {
      if (!("targetChange" in o))
        return Gt.min();
      const a = o.targetChange;
      return a.targetIds && a.targetIds.length ? Gt.min() : a.readTime ? ic(a.readTime) : Gt.min();
    }(t);
    return this.listener.J_(n, r);
  }
  /**
   * Registers interest in the results of the given target. If the target
   * includes a resumeToken it will be included in the request. Results that
   * affect the target will be streamed back as WatchChange messages that
   * reference the targetId.
   */
  H_(t) {
    const n = {};
    n.database = UI(this.serializer), n.addTarget = function(o, a) {
      let s;
      const c = a.target;
      if (s = FI(c) ? {
        documents: Nme(o, c)
      } : {
        query: RW(o, c).Vt
      }, s.targetId = a.targetId, a.resumeToken.approximateByteSize() > 0) {
        s.resumeToken = CW(o, a.resumeToken);
        const l = BI(o, a.expectedCount);
        l !== null && (s.expectedCount = l);
      } else if (a.snapshotVersion.compareTo(Gt.min()) > 0) {
        s.readTime = O_(o, a.snapshotVersion.toTimestamp());
        const l = BI(o, a.expectedCount);
        l !== null && (s.expectedCount = l);
      }
      return s;
    }(this.serializer, t);
    const r = jme(this.serializer, t);
    r && (n.labels = r), this.k_(n);
  }
  /**
   * Unregisters interest in the results of the target associated with the
   * given targetId.
   */
  Y_(t) {
    const n = {};
    n.database = UI(this.serializer), n.removeTarget = t, this.k_(n);
  }
}
class T0e extends FW {
  constructor(t, n, r, i, o, a) {
    super(t, "write_stream_connection_backoff", "write_stream_idle", "health_check_timeout", n, r, i, a), this.serializer = o;
  }
  /**
   * Tracks whether or not a handshake has been successfully exchanged and
   * the stream is ready to accept mutations.
   */
  get Z_() {
    return this.C_ > 0;
  }
  // Override of PersistentStream.start
  start() {
    this.lastStreamToken = void 0, super.start();
  }
  U_() {
    this.Z_ && this.X_([]);
  }
  z_(t, n) {
    return this.connection.P_("Write", t, n);
  }
  j_(t) {
    return jn(!!t.streamToken, 31322), this.lastStreamToken = t.streamToken, // The first response is always the handshake response
    jn(!t.writeResults || t.writeResults.length === 0, 55816), this.listener.ea();
  }
  onNext(t) {
    jn(!!t.streamToken, 12678), this.lastStreamToken = t.streamToken, // A successful first write response means the stream is healthy,
    // Note, that we could consider a successful handshake healthy, however,
    // the write itself might be causing an error we want to back off from.
    this.F_.reset();
    const n = kme(t.writeResults, t.commitTime), r = ic(t.commitTime);
    return this.listener.ta(r, n);
  }
  /**
   * Sends an initial streamToken to the server, performing the handshake
   * required to make the StreamingWrite RPC work. Subsequent
   * calls should wait until onHandshakeComplete was called.
   */
  na() {
    const t = {};
    t.database = UI(this.serializer), this.k_(t);
  }
  /** Sends a group of mutations to the Firestore backend to apply. */
  X_(t) {
    const n = {
      streamToken: this.lastStreamToken,
      writes: t.map((r) => Mme(this.serializer, r))
    };
    this.k_(n);
  }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class I0e {
}
class A0e extends I0e {
  constructor(t, n, r, i) {
    super(), this.authCredentials = t, this.appCheckCredentials = n, this.connection = r, this.serializer = i, this.ra = !1;
  }
  ia() {
    if (this.ra)
      throw new Ye(Se.FAILED_PRECONDITION, "The client has already been terminated.");
  }
  /** Invokes the provided RPC with auth and AppCheck tokens. */
  Wo(t, n, r, i) {
    return this.ia(), Promise.all([this.authCredentials.getToken(), this.appCheckCredentials.getToken()]).then(([o, a]) => this.connection.Wo(t, zI(n, r), i, o, a)).catch((o) => {
      throw o.name === "FirebaseError" ? (o.code === Se.UNAUTHENTICATED && (this.authCredentials.invalidateToken(), this.appCheckCredentials.invalidateToken()), o) : new Ye(Se.UNKNOWN, o.toString());
    });
  }
  /** Invokes the provided RPC with streamed results with auth and AppCheck tokens. */
  Jo(t, n, r, i, o) {
    return this.ia(), Promise.all([this.authCredentials.getToken(), this.appCheckCredentials.getToken()]).then(([a, s]) => this.connection.Jo(t, zI(n, r), i, a, s, o)).catch((a) => {
      throw a.name === "FirebaseError" ? (a.code === Se.UNAUTHENTICATED && (this.authCredentials.invalidateToken(), this.appCheckCredentials.invalidateToken()), a) : new Ye(Se.UNKNOWN, a.toString());
    });
  }
  terminate() {
    this.ra = !0, this.connection.terminate();
  }
}
class R0e {
  constructor(t, n) {
    this.asyncQueue = t, this.onlineStateHandler = n, /** The current OnlineState. */
    this.state = "Unknown", /**
     * A count of consecutive failures to open the stream. If it reaches the
     * maximum defined by MAX_WATCH_STREAM_FAILURES, we'll set the OnlineState to
     * Offline.
     */
    this.sa = 0, /**
     * A timer that elapses after ONLINE_STATE_TIMEOUT_MS, at which point we
     * transition from OnlineState.Unknown to OnlineState.Offline without waiting
     * for the stream to actually fail (MAX_WATCH_STREAM_FAILURES times).
     */
    this.oa = null, /**
     * Whether the client should log a warning message if it fails to connect to
     * the backend (initially true, cleared after a successful stream, or if we've
     * logged the message already).
     */
    this._a = !0;
  }
  /**
   * Called by RemoteStore when a watch stream is started (including on each
   * backoff attempt).
   *
   * If this is the first attempt, it sets the OnlineState to Unknown and starts
   * the onlineStateTimer.
   */
  aa() {
    this.sa === 0 && (this.ua(
      "Unknown"
      /* OnlineState.Unknown */
    ), this.oa = this.asyncQueue.enqueueAfterDelay("online_state_timeout", 1e4, () => (this.oa = null, this.ca("Backend didn't respond within 10 seconds."), this.ua(
      "Offline"
      /* OnlineState.Offline */
    ), Promise.resolve())));
  }
  /**
   * Updates our OnlineState as appropriate after the watch stream reports a
   * failure. The first failure moves us to the 'Unknown' state. We then may
   * allow multiple failures (based on MAX_WATCH_STREAM_FAILURES) before we
   * actually transition to the 'Offline' state.
   */
  la(t) {
    this.state === "Online" ? this.ua(
      "Unknown"
      /* OnlineState.Unknown */
    ) : (this.sa++, this.sa >= 1 && (this.ha(), this.ca(`Connection failed 1 times. Most recent error: ${t.toString()}`), this.ua(
      "Offline"
      /* OnlineState.Offline */
    )));
  }
  /**
   * Explicitly sets the OnlineState to the specified state.
   *
   * Note that this resets our timers / failure counters, etc. used by our
   * Offline heuristics, so must not be used in place of
   * handleWatchStreamStart() and handleWatchStreamFailure().
   */
  set(t) {
    this.ha(), this.sa = 0, t === "Online" && // We've connected to watch at least once. Don't warn the developer
    // about being offline going forward.
    (this._a = !1), this.ua(t);
  }
  ua(t) {
    t !== this.state && (this.state = t, this.onlineStateHandler(t));
  }
  ca(t) {
    const n = `Could not reach Cloud Firestore backend. ${t}
This typically indicates that your device does not have a healthy Internet connection at the moment. The client will operate in offline mode until it is able to successfully connect to the backend.`;
    this._a ? (ol(n), this._a = !1) : ht("OnlineStateTracker", n);
  }
  ha() {
    this.oa !== null && (this.oa.cancel(), this.oa = null);
  }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const ef = "RemoteStore";
class $0e {
  constructor(t, n, r, i, o) {
    this.localStore = t, this.datastore = n, this.asyncQueue = r, this.remoteSyncer = {}, /**
     * A list of up to MAX_PENDING_WRITES writes that we have fetched from the
     * LocalStore via fillWritePipeline() and have or will send to the write
     * stream.
     *
     * Whenever writePipeline.length > 0 the RemoteStore will attempt to start or
     * restart the write stream. When the stream is established the writes in the
     * pipeline will be sent in order.
     *
     * Writes remain in writePipeline until they are acknowledged by the backend
     * and thus will automatically be re-sent if the stream is interrupted /
     * restarted before they're acknowledged.
     *
     * Write responses from the backend are linked to their originating request
     * purely based on order, and so we can just shift() writes from the front of
     * the writePipeline as we receive responses.
     */
    this.Pa = [], /**
     * A mapping of watched targets that the client cares about tracking and the
     * user has explicitly called a 'listen' for this target.
     *
     * These targets may or may not have been sent to or acknowledged by the
     * server. On re-establishing the listen stream, these targets should be sent
     * to the server. The targets removed with unlistens are removed eagerly
     * without waiting for confirmation from the listen stream.
     */
    this.Ta = /* @__PURE__ */ new Map(), /**
     * A set of reasons for why the RemoteStore may be offline. If empty, the
     * RemoteStore may start its network connections.
     */
    this.Ia = /* @__PURE__ */ new Set(), /**
     * Event handlers that get called when the network is disabled or enabled.
     *
     * PORTING NOTE: These functions are used on the Web client to create the
     * underlying streams (to support tree-shakeable streams). On Android and iOS,
     * the streams are created during construction of RemoteStore.
     */
    this.da = [], this.Ea = o, this.Ea.xo((a) => {
      r.enqueueAndForget(async () => {
        xf(this) && (ht(ef, "Restarting streams for network reachability change."), await async function(c) {
          const l = qt(c);
          l.Ia.add(
            4
            /* OfflineCause.ConnectivityChange */
          ), await Wv(l), l.Aa.set(
            "Unknown"
            /* OnlineState.Unknown */
          ), l.Ia.delete(
            4
            /* OfflineCause.ConnectivityChange */
          ), await hx(l);
        }(this));
      });
    }), this.Aa = new R0e(r, i);
  }
}
async function hx(e) {
  if (xf(e))
    for (const t of e.da)
      await t(
        /* enabled= */
        !0
      );
}
async function Wv(e) {
  for (const t of e.da)
    await t(
      /* enabled= */
      !1
    );
}
function VW(e, t) {
  const n = qt(e);
  n.Ta.has(t.targetId) || // Mark this as something the client is currently listening for.
  (n.Ta.set(t.targetId, t), QO(n) ? (
    // The listen will be sent in onWatchStreamOpen
    XO(n)
  ) : fp(n).x_() && YO(n, t));
}
function KO(e, t) {
  const n = qt(e), r = fp(n);
  n.Ta.delete(t), r.x_() && BW(n, t), n.Ta.size === 0 && (r.x_() ? r.B_() : xf(n) && // Revert to OnlineState.Unknown if the watch stream is not open and we
  // have no listeners, since without any listens to send we cannot
  // confirm if the stream is healthy and upgrade to OnlineState.Online.
  n.Aa.set(
    "Unknown"
    /* OnlineState.Unknown */
  ));
}
function YO(e, t) {
  if (e.Ra.$e(t.targetId), t.resumeToken.approximateByteSize() > 0 || t.snapshotVersion.compareTo(Gt.min()) > 0) {
    const n = e.remoteSyncer.getRemoteKeysForTarget(t.targetId).size;
    t = t.withExpectedCount(n);
  }
  fp(e).H_(t);
}
function BW(e, t) {
  e.Ra.$e(t), fp(e).Y_(t);
}
function XO(e) {
  e.Ra = new Cme({
    getRemoteKeysForTarget: (t) => e.remoteSyncer.getRemoteKeysForTarget(t),
    Et: (t) => e.Ta.get(t) || null,
    lt: () => e.datastore.serializer.databaseId
  }), fp(e).start(), e.Aa.aa();
}
function QO(e) {
  return xf(e) && !fp(e).M_() && e.Ta.size > 0;
}
function xf(e) {
  return qt(e).Ia.size === 0;
}
function zW(e) {
  e.Ra = void 0;
}
async function O0e(e) {
  e.Aa.set(
    "Online"
    /* OnlineState.Online */
  );
}
async function P0e(e) {
  e.Ta.forEach((t, n) => {
    YO(e, t);
  });
}
async function M0e(e, t) {
  zW(e), // If we still need the watch stream, retry the connection.
  QO(e) ? (e.Aa.la(t), XO(e)) : (
    // No need to restart watch stream because there are no active targets.
    // The online state is set to unknown because there is no active attempt
    // at establishing a connection
    e.Aa.set(
      "Unknown"
      /* OnlineState.Unknown */
    )
  );
}
async function k0e(e, t, n) {
  if (
    // Mark the client as online since we got a message from the server
    e.Aa.set(
      "Online"
      /* OnlineState.Online */
    ), t instanceof EW && t.state === 2 && t.cause
  )
    try {
      await async function(i, o) {
        const a = o.cause;
        for (const s of o.targetIds)
          i.Ta.has(s) && (await i.remoteSyncer.rejectListen(s, a), i.Ta.delete(s), i.Ra.removeTarget(s));
      }(e, t);
    } catch (r) {
      ht(ef, "Failed to remove targets %s: %s ", t.targetIds.join(","), r), await M_(e, r);
    }
  else if (t instanceof k1 ? e.Ra.Ye(t) : t instanceof xW ? e.Ra.it(t) : e.Ra.et(t), !n.isEqual(Gt.min()))
    try {
      const r = await LW(e.localStore);
      n.compareTo(r) >= 0 && // We have received a target change with a global snapshot if the snapshot
      // version is not equal to SnapshotVersion.min().
      /**
      * Takes a batch of changes from the Datastore, repackages them as a
      * RemoteEvent, and passes that on to the listener, which is typically the
      * SyncEngine.
      */
      await function(o, a) {
        const s = o.Ra.Pt(a);
        return s.targetChanges.forEach((c, l) => {
          if (c.resumeToken.approximateByteSize() > 0) {
            const u = o.Ta.get(l);
            u && o.Ta.set(l, u.withResumeToken(c.resumeToken, a));
          }
        }), // Re-establish listens for the targets that have been invalidated by
        // existence filter mismatches.
        s.targetMismatches.forEach((c, l) => {
          const u = o.Ta.get(c);
          if (!u)
            return;
          o.Ta.set(c, u.withResumeToken(Hi.EMPTY_BYTE_STRING, u.snapshotVersion)), // Cause a hard reset by unwatching and rewatching immediately, but
          // deliberately don't send a resume token so that we get a full update.
          BW(o, c);
          const d = new ql(u.target, c, l, u.sequenceNumber);
          YO(o, d);
        }), o.remoteSyncer.applyRemoteEvent(s);
      }(e, n);
    } catch (r) {
      ht(ef, "Failed to raise snapshot:", r), await M_(e, r);
    }
}
async function M_(e, t, n) {
  if (!dp(t))
    throw t;
  e.Ia.add(
    1
    /* OfflineCause.IndexedDbFailed */
  ), // Disable network and raise offline snapshots
  await Wv(e), e.Aa.set(
    "Offline"
    /* OnlineState.Offline */
  ), n || // Use a simple read operation to determine if IndexedDB recovered.
  // Ideally, we would expose a health check directly on SimpleDb, but
  // RemoteStore only has access to persistence through LocalStore.
  (n = () => LW(e.localStore)), // Probe IndexedDB periodically and re-enable network
  e.asyncQueue.enqueueRetryable(async () => {
    ht(ef, "Retrying IndexedDB access"), await n(), e.Ia.delete(
      1
      /* OfflineCause.IndexedDbFailed */
    ), await hx(e);
  });
}
function HW(e, t) {
  return t().catch((n) => M_(e, n, t));
}
async function gx(e) {
  const t = qt(e), n = Su(t);
  let r = t.Pa.length > 0 ? t.Pa[t.Pa.length - 1].batchId : NO;
  for (; N0e(t); )
    try {
      const i = await m0e(t.localStore, r);
      if (i === null) {
        t.Pa.length === 0 && n.B_();
        break;
      }
      r = i.batchId, D0e(t, i);
    } catch (i) {
      await M_(t, i);
    }
  UW(t) && WW(t);
}
function N0e(e) {
  return xf(e) && e.Pa.length < 10;
}
function D0e(e, t) {
  e.Pa.push(t);
  const n = Su(e);
  n.x_() && n.Z_ && n.X_(t.mutations);
}
function UW(e) {
  return xf(e) && !Su(e).M_() && e.Pa.length > 0;
}
function WW(e) {
  Su(e).start();
}
async function L0e(e) {
  Su(e).na();
}
async function j0e(e) {
  const t = Su(e);
  for (const n of e.Pa)
    t.X_(n.mutations);
}
async function F0e(e, t, n) {
  const r = e.Pa.shift(), i = BO.from(r, t, n);
  await HW(e, () => e.remoteSyncer.applySuccessfulWrite(i)), // It's possible that with the completion of this mutation another
  // slot has freed up.
  await gx(e);
}
async function V0e(e, t) {
  t && Su(e).Z_ && // This error affects the actual write.
  await async function(r, i) {
    if (function(a) {
      return xme(a) && a !== Se.ABORTED;
    }(i.code)) {
      const o = r.Pa.shift();
      Su(r).N_(), await HW(r, () => r.remoteSyncer.rejectFailedWrite(o.batchId, i)), // It's possible that with the completion of this mutation
      // another slot has freed up.
      await gx(r);
    }
  }(e, t), // The write stream might have been started by refilling the write
  // pipeline for failed writes
  UW(e) && WW(e);
}
async function A7(e, t) {
  const n = qt(e);
  n.asyncQueue.verifyOperationInProgress(), ht(ef, "RemoteStore received new credentials");
  const r = xf(n);
  n.Ia.add(
    3
    /* OfflineCause.CredentialChange */
  ), await Wv(n), r && // Don't set the network status to Unknown if we are offline.
  n.Aa.set(
    "Unknown"
    /* OnlineState.Unknown */
  ), await n.remoteSyncer.handleCredentialChange(t), n.Ia.delete(
    3
    /* OfflineCause.CredentialChange */
  ), await hx(n);
}
async function B0e(e, t) {
  const n = qt(e);
  t ? (n.Ia.delete(
    2
    /* OfflineCause.IsSecondary */
  ), await hx(n)) : t || (n.Ia.add(
    2
    /* OfflineCause.IsSecondary */
  ), await Wv(n), n.Aa.set(
    "Unknown"
    /* OnlineState.Unknown */
  ));
}
function fp(e) {
  return e.Va || // Create stream (but note that it is not started yet).
  (e.Va = function(n, r, i) {
    const o = qt(n);
    return o.ia(), new C0e(r, o.connection, o.authCredentials, o.appCheckCredentials, o.serializer, i);
  }(e.datastore, e.asyncQueue, {
    Zo: O0e.bind(null, e),
    e_: P0e.bind(null, e),
    n_: M0e.bind(null, e),
    J_: k0e.bind(null, e)
  }), e.da.push(async (t) => {
    t ? (e.Va.N_(), QO(e) ? XO(e) : e.Aa.set(
      "Unknown"
      /* OnlineState.Unknown */
    )) : (await e.Va.stop(), zW(e));
  })), e.Va;
}
function Su(e) {
  return e.ma || // Create stream (but note that it is not started yet).
  (e.ma = function(n, r, i) {
    const o = qt(n);
    return o.ia(), new T0e(r, o.connection, o.authCredentials, o.appCheckCredentials, o.serializer, i);
  }(e.datastore, e.asyncQueue, {
    Zo: () => Promise.resolve(),
    e_: L0e.bind(null, e),
    n_: V0e.bind(null, e),
    ea: j0e.bind(null, e),
    ta: F0e.bind(null, e)
  }), e.da.push(async (t) => {
    t ? (e.ma.N_(), // This will start the write stream if necessary.
    await gx(e)) : (await e.ma.stop(), e.Pa.length > 0 && (ht(ef, `Stopping write stream with ${e.Pa.length} pending writes`), e.Pa = []));
  })), e.ma;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class JO {
  constructor(t, n, r, i, o) {
    this.asyncQueue = t, this.timerId = n, this.targetTimeMs = r, this.op = i, this.removalCallback = o, this.deferred = new tc(), this.then = this.deferred.promise.then.bind(this.deferred.promise), // It's normal for the deferred promise to be canceled (due to cancellation)
    // and so we attach a dummy catch callback to avoid
    // 'UnhandledPromiseRejectionWarning' log spam.
    this.deferred.promise.catch((a) => {
    });
  }
  get promise() {
    return this.deferred.promise;
  }
  /**
   * Creates and returns a DelayedOperation that has been scheduled to be
   * executed on the provided asyncQueue after the provided delayMs.
   *
   * @param asyncQueue - The queue to schedule the operation on.
   * @param id - A Timer ID identifying the type of operation this is.
   * @param delayMs - The delay (ms) before the operation should be scheduled.
   * @param op - The operation to run.
   * @param removalCallback - A callback to be called synchronously once the
   *   operation is executed or canceled, notifying the AsyncQueue to remove it
   *   from its delayedOperations list.
   *   PORTING NOTE: This exists to prevent making removeDelayedOperation() and
   *   the DelayedOperation class public.
   */
  static createAndSchedule(t, n, r, i, o) {
    const a = Date.now() + r, s = new JO(t, n, a, i, o);
    return s.start(r), s;
  }
  /**
   * Starts the timer. This is called immediately after construction by
   * createAndSchedule().
   */
  start(t) {
    this.timerHandle = setTimeout(() => this.handleDelayElapsed(), t);
  }
  /**
   * Queues the operation to run immediately (if it hasn't already been run or
   * canceled).
   */
  skipDelay() {
    return this.handleDelayElapsed();
  }
  /**
   * Cancels the operation if it hasn't already been executed or canceled. The
   * promise will be rejected.
   *
   * As long as the operation has not yet been run, calling cancel() provides a
   * guarantee that the operation will not be run.
   */
  cancel(t) {
    this.timerHandle !== null && (this.clearTimeout(), this.deferred.reject(new Ye(Se.CANCELLED, "Operation cancelled" + (t ? ": " + t : ""))));
  }
  handleDelayElapsed() {
    this.asyncQueue.enqueueAndForget(() => this.timerHandle !== null ? (this.clearTimeout(), this.op().then((t) => this.deferred.resolve(t))) : Promise.resolve());
  }
  clearTimeout() {
    this.timerHandle !== null && (this.removalCallback(this), clearTimeout(this.timerHandle), this.timerHandle = null);
  }
}
function ZO(e, t) {
  if (ol("AsyncQueue", `${t}: ${e}`), dp(e))
    return new Ye(Se.UNAVAILABLE, `${t}: ${e}`);
  throw e;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class qh {
  /**
   * Returns an empty copy of the existing DocumentSet, using the same
   * comparator.
   */
  static emptySet(t) {
    return new qh(t.comparator);
  }
  /** The default ordering is by key if the comparator is omitted */
  constructor(t) {
    this.comparator = t ? (n, r) => t(n, r) || $t.comparator(n.key, r.key) : (n, r) => $t.comparator(n.key, r.key), this.keyedMap = Fm(), this.sortedSet = new jr(this.comparator);
  }
  has(t) {
    return this.keyedMap.get(t) != null;
  }
  get(t) {
    return this.keyedMap.get(t);
  }
  first() {
    return this.sortedSet.minKey();
  }
  last() {
    return this.sortedSet.maxKey();
  }
  isEmpty() {
    return this.sortedSet.isEmpty();
  }
  /**
   * Returns the index of the provided key in the document set, or -1 if the
   * document key is not present in the set;
   */
  indexOf(t) {
    const n = this.keyedMap.get(t);
    return n ? this.sortedSet.indexOf(n) : -1;
  }
  get size() {
    return this.sortedSet.size;
  }
  /** Iterates documents in order defined by "comparator" */
  forEach(t) {
    this.sortedSet.inorderTraversal((n, r) => (t(n), !1));
  }
  /** Inserts or updates a document with the same key */
  add(t) {
    const n = this.delete(t.key);
    return n.copy(n.keyedMap.insert(t.key, t), n.sortedSet.insert(t, null));
  }
  /** Deletes a document with a given key */
  delete(t) {
    const n = this.get(t);
    return n ? this.copy(this.keyedMap.remove(t), this.sortedSet.remove(n)) : this;
  }
  isEqual(t) {
    if (!(t instanceof qh) || this.size !== t.size)
      return !1;
    const n = this.sortedSet.getIterator(), r = t.sortedSet.getIterator();
    for (; n.hasNext(); ) {
      const i = n.getNext().key, o = r.getNext().key;
      if (!i.isEqual(o))
        return !1;
    }
    return !0;
  }
  toString() {
    const t = [];
    return this.forEach((n) => {
      t.push(n.toString());
    }), t.length === 0 ? "DocumentSet ()" : `DocumentSet (
  ` + t.join(`  
`) + `
)`;
  }
  copy(t, n) {
    const r = new qh();
    return r.comparator = this.comparator, r.keyedMap = t, r.sortedSet = n, r;
  }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class R7 {
  constructor() {
    this.fa = new jr($t.comparator);
  }
  track(t) {
    const n = t.doc.key, r = this.fa.get(n);
    r ? (
      // Merge the new change with the existing change.
      t.type !== 0 && r.type === 3 ? this.fa = this.fa.insert(n, t) : t.type === 3 && r.type !== 1 ? this.fa = this.fa.insert(n, {
        type: r.type,
        doc: t.doc
      }) : t.type === 2 && r.type === 2 ? this.fa = this.fa.insert(n, {
        type: 2,
        doc: t.doc
      }) : t.type === 2 && r.type === 0 ? this.fa = this.fa.insert(n, {
        type: 0,
        doc: t.doc
      }) : t.type === 1 && r.type === 0 ? this.fa = this.fa.remove(n) : t.type === 1 && r.type === 2 ? this.fa = this.fa.insert(n, {
        type: 1,
        doc: r.doc
      }) : t.type === 0 && r.type === 1 ? this.fa = this.fa.insert(n, {
        type: 2,
        doc: t.doc
      }) : (
        // This includes these cases, which don't make sense:
        // Added->Added
        // Removed->Removed
        // Modified->Added
        // Removed->Modified
        // Metadata->Added
        // Removed->Metadata
        Wt(63341, {
          At: t,
          ga: r
        })
      )
    ) : this.fa = this.fa.insert(n, t);
  }
  pa() {
    const t = [];
    return this.fa.inorderTraversal((n, r) => {
      t.push(r);
    }), t;
  }
}
class pg {
  constructor(t, n, r, i, o, a, s, c, l) {
    this.query = t, this.docs = n, this.oldDocs = r, this.docChanges = i, this.mutatedKeys = o, this.fromCache = a, this.syncStateChanged = s, this.excludesMetadataChanges = c, this.hasCachedResults = l;
  }
  /** Returns a view snapshot as if all documents in the snapshot were added. */
  static fromInitialDocuments(t, n, r, i, o) {
    const a = [];
    return n.forEach((s) => {
      a.push({
        type: 0,
        doc: s
      });
    }), new pg(
      t,
      n,
      qh.emptySet(n),
      a,
      r,
      i,
      /* syncStateChanged= */
      !0,
      /* excludesMetadataChanges= */
      !1,
      o
    );
  }
  get hasPendingWrites() {
    return !this.mutatedKeys.isEmpty();
  }
  isEqual(t) {
    if (!(this.fromCache === t.fromCache && this.hasCachedResults === t.hasCachedResults && this.syncStateChanged === t.syncStateChanged && this.mutatedKeys.isEqual(t.mutatedKeys) && sx(this.query, t.query) && this.docs.isEqual(t.docs) && this.oldDocs.isEqual(t.oldDocs)))
      return !1;
    const n = this.docChanges, r = t.docChanges;
    if (n.length !== r.length)
      return !1;
    for (let i = 0; i < n.length; i++)
      if (n[i].type !== r[i].type || !n[i].doc.isEqual(r[i].doc))
        return !1;
    return !0;
  }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class z0e {
  constructor() {
    this.ya = void 0, this.wa = [];
  }
  // Helper methods that checks if the query has listeners that listening to remote store
  Sa() {
    return this.wa.some((t) => t.ba());
  }
}
class H0e {
  constructor() {
    this.queries = $7(), this.onlineState = "Unknown", this.Da = /* @__PURE__ */ new Set();
  }
  terminate() {
    (function(n, r) {
      const i = qt(n), o = i.queries;
      i.queries = $7(), o.forEach((a, s) => {
        for (const c of s.wa)
          c.onError(r);
      });
    })(this, new Ye(Se.ABORTED, "Firestore shutting down"));
  }
}
function $7() {
  return new wf((e) => lW(e), sx);
}
async function eP(e, t) {
  const n = qt(e);
  let r = 3;
  const i = t.query;
  let o = n.queries.get(i);
  o ? !o.Sa() && t.ba() && // Query has been listening to local cache, and tries to add a new listener sourced from watch.
  (r = 2) : (o = new z0e(), r = t.ba() ? 0 : 1);
  try {
    switch (r) {
      case 0:
        o.ya = await n.onListen(
          i,
          /** enableRemoteListen= */
          !0
        );
        break;
      case 1:
        o.ya = await n.onListen(
          i,
          /** enableRemoteListen= */
          !1
        );
        break;
      case 2:
        await n.onFirstRemoteStoreListen(i);
    }
  } catch (a) {
    const s = ZO(a, `Initialization of query '${wh(t.query)}' failed`);
    return void t.onError(s);
  }
  n.queries.set(i, o), o.wa.push(t), // Run global snapshot listeners if a consistent snapshot has been emitted.
  t.va(n.onlineState), o.ya && t.Ca(o.ya) && nP(n);
}
async function tP(e, t) {
  const n = qt(e), r = t.query;
  let i = 3;
  const o = n.queries.get(r);
  if (o) {
    const a = o.wa.indexOf(t);
    a >= 0 && (o.wa.splice(a, 1), o.wa.length === 0 ? i = t.ba() ? 0 : 1 : !o.Sa() && t.ba() && // The removed listener is the last one that sourced from watch.
    (i = 2));
  }
  switch (i) {
    case 0:
      return n.queries.delete(r), n.onUnlisten(
        r,
        /** disableRemoteListen= */
        !0
      );
    case 1:
      return n.queries.delete(r), n.onUnlisten(
        r,
        /** disableRemoteListen= */
        !1
      );
    case 2:
      return n.onLastRemoteStoreUnlisten(r);
    default:
      return;
  }
}
function U0e(e, t) {
  const n = qt(e);
  let r = !1;
  for (const i of t) {
    const o = i.query, a = n.queries.get(o);
    if (a) {
      for (const s of a.wa)
        s.Ca(i) && (r = !0);
      a.ya = i;
    }
  }
  r && nP(n);
}
function W0e(e, t, n) {
  const r = qt(e), i = r.queries.get(t);
  if (i)
    for (const o of i.wa)
      o.onError(n);
  r.queries.delete(t);
}
function nP(e) {
  e.Da.forEach((t) => {
    t.next();
  });
}
var GI, O7;
(O7 = GI || (GI = {})).Fa = "default", /** Listen to changes in cache only */
O7.Cache = "cache";
class rP {
  constructor(t, n, r) {
    this.query = t, this.Ma = n, /**
     * Initial snapshots (e.g. from cache) may not be propagated to the wrapped
     * observer. This flag is set to true once we've actually raised an event.
     */
    this.xa = !1, this.Oa = null, this.onlineState = "Unknown", this.options = r || {};
  }
  /**
   * Applies the new ViewSnapshot to this listener, raising a user-facing event
   * if applicable (depending on what changed, whether the user has opted into
   * metadata-only changes, etc.). Returns true if a user-facing event was
   * indeed raised.
   */
  Ca(t) {
    if (!this.options.includeMetadataChanges) {
      const r = [];
      for (const i of t.docChanges)
        i.type !== 3 && r.push(i);
      t = new pg(
        t.query,
        t.docs,
        t.oldDocs,
        r,
        t.mutatedKeys,
        t.fromCache,
        t.syncStateChanged,
        /* excludesMetadataChanges= */
        !0,
        t.hasCachedResults
      );
    }
    let n = !1;
    return this.xa ? this.Na(t) && (this.Ma.next(t), n = !0) : this.Ba(t, this.onlineState) && (this.La(t), n = !0), this.Oa = t, n;
  }
  onError(t) {
    this.Ma.error(t);
  }
  /** Returns whether a snapshot was raised. */
  va(t) {
    this.onlineState = t;
    let n = !1;
    return this.Oa && !this.xa && this.Ba(this.Oa, t) && (this.La(this.Oa), n = !0), n;
  }
  Ba(t, n) {
    if (!t.fromCache || !this.ba())
      return !0;
    const r = n !== "Offline";
    return (!this.options.ka || !r) && (!t.docs.isEmpty() || t.hasCachedResults || n === "Offline");
  }
  Na(t) {
    if (t.docChanges.length > 0)
      return !0;
    const n = this.Oa && this.Oa.hasPendingWrites !== t.hasPendingWrites;
    return !(!t.syncStateChanged && !n) && this.options.includeMetadataChanges === !0;
  }
  La(t) {
    t = pg.fromInitialDocuments(t.query, t.docs, t.mutatedKeys, t.fromCache, t.hasCachedResults), this.xa = !0, this.Ma.next(t);
  }
  ba() {
    return this.options.source !== GI.Cache;
  }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class qW {
  constructor(t) {
    this.key = t;
  }
}
class GW {
  constructor(t) {
    this.key = t;
  }
}
class q0e {
  constructor(t, n) {
    this.query = t, this.Ha = n, this.Ya = null, this.hasCachedResults = !1, /**
     * A flag whether the view is current with the backend. A view is considered
     * current after it has seen the current flag from the backend and did not
     * lose consistency within the watch stream (e.g. because of an existence
     * filter mismatch).
     */
    this.current = !1, /** Documents in the view but not in the remote target */
    this.Za = _n(), /** Document Keys that have local changes */
    this.mutatedKeys = _n(), this.Xa = uW(t), this.eu = new qh(this.Xa);
  }
  /**
   * The set of remote documents that the server has told us belongs to the target associated with
   * this view.
   */
  get tu() {
    return this.Ha;
  }
  /**
   * Iterates over a set of doc changes, applies the query limit, and computes
   * what the new results should be, what the changes were, and whether we may
   * need to go back to the local cache for more results. Does not make any
   * changes to the view.
   * @param docChanges - The doc changes to apply to this view.
   * @param previousChanges - If this is being called with a refill, then start
   *        with this set of docs and changes instead of the current view.
   * @returns a new set of docs, changes, and refill flag.
   */
  nu(t, n) {
    const r = n ? n.ru : new R7(), i = n ? n.eu : this.eu;
    let o = n ? n.mutatedKeys : this.mutatedKeys, a = i, s = !1;
    const c = this.query.limitType === "F" && i.size === this.query.limit ? i.last() : null, l = this.query.limitType === "L" && i.size === this.query.limit ? i.first() : null;
    if (t.inorderTraversal((u, d) => {
      const f = i.get(u), h = cx(this.query, d) ? d : null, p = !!f && this.mutatedKeys.has(f.key), g = !!h && (h.hasLocalMutations || // We only consider committed mutations for documents that were
      // mutated during the lifetime of the view.
      this.mutatedKeys.has(h.key) && h.hasCommittedMutations);
      let m = !1;
      f && h ? f.data.isEqual(h.data) ? p !== g && (r.track({
        type: 3,
        doc: h
      }), m = !0) : this.iu(f, h) || (r.track({
        type: 2,
        doc: h
      }), m = !0, (c && this.Xa(h, c) > 0 || l && this.Xa(h, l) < 0) && // This doc moved from inside the limit to outside the limit.
      // That means there may be some other doc in the local cache
      // that should be included instead.
      (s = !0)) : !f && h ? (r.track({
        type: 0,
        doc: h
      }), m = !0) : f && !h && (r.track({
        type: 1,
        doc: f
      }), m = !0, (c || l) && // A doc was removed from a full limit query. We'll need to
      // requery from the local cache to see if we know about some other
      // doc that should be in the results.
      (s = !0)), m && (h ? (a = a.add(h), o = g ? o.add(u) : o.delete(u)) : (a = a.delete(u), o = o.delete(u)));
    }), this.query.limit !== null)
      for (; a.size > this.query.limit; ) {
        const u = this.query.limitType === "F" ? a.last() : a.first();
        a = a.delete(u.key), o = o.delete(u.key), r.track({
          type: 1,
          doc: u
        });
      }
    return {
      eu: a,
      ru: r,
      Ds: s,
      mutatedKeys: o
    };
  }
  iu(t, n) {
    return t.hasLocalMutations && n.hasCommittedMutations && !n.hasLocalMutations;
  }
  /**
   * Updates the view with the given ViewDocumentChanges and optionally updates
   * limbo docs and sync state from the provided target change.
   * @param docChanges - The set of changes to make to the view's docs.
   * @param limboResolutionEnabled - Whether to update limbo documents based on
   *        this change.
   * @param targetChange - A target change to apply for computing limbo docs and
   *        sync state.
   * @param targetIsPendingReset - Whether the target is pending to reset due to
   *        existence filter mismatch. If not explicitly specified, it is treated
   *        equivalently to `false`.
   * @returns A new ViewChange with the given docs, changes, and sync state.
   */
  // PORTING NOTE: The iOS/Android clients always compute limbo document changes.
  applyChanges(t, n, r, i) {
    const o = this.eu;
    this.eu = t.eu, this.mutatedKeys = t.mutatedKeys;
    const a = t.ru.pa();
    a.sort((u, d) => function(h, p) {
      const g = (m) => {
        switch (m) {
          case 0:
            return 1;
          case 2:
          case 3:
            return 2;
          case 1:
            return 0;
          default:
            return Wt(20277, {
              At: m
            });
        }
      };
      return g(h) - g(p);
    }(u.type, d.type) || this.Xa(u.doc, d.doc)), this.su(r), i = i != null && i;
    const s = n && !i ? this.ou() : [], c = this.Za.size === 0 && this.current && !i ? 1 : 0, l = c !== this.Ya;
    return this.Ya = c, a.length !== 0 || l ? {
      snapshot: new pg(
        this.query,
        t.eu,
        o,
        a,
        t.mutatedKeys,
        c === 0,
        l,
        /* excludesMetadataChanges= */
        !1,
        !!r && r.resumeToken.approximateByteSize() > 0
      ),
      _u: s
    } : {
      _u: s
    };
  }
  /**
   * Applies an OnlineState change to the view, potentially generating a
   * ViewChange if the view's syncState changes as a result.
   */
  va(t) {
    return this.current && t === "Offline" ? (
      // If we're offline, set `current` to false and then call applyChanges()
      // to refresh our syncState and generate a ViewChange as appropriate. We
      // are guaranteed to get a new TargetChange that sets `current` back to
      // true once the client is back online.
      (this.current = !1, this.applyChanges(
        {
          eu: this.eu,
          ru: new R7(),
          mutatedKeys: this.mutatedKeys,
          Ds: !1
        },
        /* limboResolutionEnabled= */
        !1
      ))
    ) : {
      _u: []
    };
  }
  /**
   * Returns whether the doc for the given key should be in limbo.
   */
  au(t) {
    return !this.Ha.has(t) && // The local store doesn't think it's a result, so it shouldn't be in limbo.
    !!this.eu.has(t) && !this.eu.get(t).hasLocalMutations;
  }
  /**
   * Updates syncedDocuments, current, and limbo docs based on the given change.
   * Returns the list of changes to which docs are in limbo.
   */
  su(t) {
    t && (t.addedDocuments.forEach((n) => this.Ha = this.Ha.add(n)), t.modifiedDocuments.forEach((n) => {
    }), t.removedDocuments.forEach((n) => this.Ha = this.Ha.delete(n)), this.current = t.current);
  }
  ou() {
    if (!this.current)
      return [];
    const t = this.Za;
    this.Za = _n(), this.eu.forEach((r) => {
      this.au(r.key) && (this.Za = this.Za.add(r.key));
    });
    const n = [];
    return t.forEach((r) => {
      this.Za.has(r) || n.push(new GW(r));
    }), this.Za.forEach((r) => {
      t.has(r) || n.push(new qW(r));
    }), n;
  }
  /**
   * Update the in-memory state of the current view with the state read from
   * persistence.
   *
   * We update the query view whenever a client's primary status changes:
   * - When a client transitions from primary to secondary, it can miss
   *   LocalStorage updates and its query views may temporarily not be
   *   synchronized with the state on disk.
   * - For secondary to primary transitions, the client needs to update the list
   *   of `syncedDocuments` since secondary clients update their query views
   *   based purely on synthesized RemoteEvents.
   *
   * @param queryResult.documents - The documents that match the query according
   * to the LocalStore.
   * @param queryResult.remoteKeys - The keys of the documents that match the
   * query according to the backend.
   *
   * @returns The ViewChange that resulted from this synchronization.
   */
  // PORTING NOTE: Multi-tab only.
  uu(t) {
    this.Ha = t.qs, this.Za = _n();
    const n = this.nu(t.documents);
    return this.applyChanges(
      n,
      /* limboResolutionEnabled= */
      !0
    );
  }
  /**
   * Returns a view snapshot as if this query was just listened to. Contains
   * a document add for every existing document and the `fromCache` and
   * `hasPendingWrites` status of the already established view.
   */
  // PORTING NOTE: Multi-tab only.
  cu() {
    return pg.fromInitialDocuments(this.query, this.eu, this.mutatedKeys, this.Ya === 0, this.hasCachedResults);
  }
}
const iP = "SyncEngine";
class G0e {
  constructor(t, n, r) {
    this.query = t, this.targetId = n, this.view = r;
  }
}
class K0e {
  constructor(t) {
    this.key = t, /**
     * Set to true once we've received a document. This is used in
     * getRemoteKeysForTarget() and ultimately used by WatchChangeAggregator to
     * decide whether it needs to manufacture a delete event for the target once
     * the target is CURRENT.
     */
    this.lu = !1;
  }
}
class Y0e {
  constructor(t, n, r, i, o, a) {
    this.localStore = t, this.remoteStore = n, this.eventManager = r, this.sharedClientState = i, this.currentUser = o, this.maxConcurrentLimboResolutions = a, this.hu = {}, this.Pu = new wf((s) => lW(s), sx), this.Tu = /* @__PURE__ */ new Map(), /**
     * The keys of documents that are in limbo for which we haven't yet started a
     * limbo resolution query. The strings in this set are the result of calling
     * `key.path.canonicalString()` where `key` is a `DocumentKey` object.
     *
     * The `Set` type was chosen because it provides efficient lookup and removal
     * of arbitrary elements and it also maintains insertion order, providing the
     * desired queue-like FIFO semantics.
     */
    this.Iu = /* @__PURE__ */ new Set(), /**
     * Keeps track of the target ID for each document that is in limbo with an
     * active target.
     */
    this.du = new jr($t.comparator), /**
     * Keeps track of the information about an active limbo resolution for each
     * active target ID that was started for the purpose of limbo resolution.
     */
    this.Eu = /* @__PURE__ */ new Map(), this.Au = new UO(), /** Stores user completion handlers, indexed by User and BatchId. */
    this.Ru = {}, /** Stores user callbacks waiting for all pending writes to be acknowledged. */
    this.Vu = /* @__PURE__ */ new Map(), this.mu = gg.ur(), this.onlineState = "Unknown", // The primary state is set to `true` or `false` immediately after Firestore
    // startup. In the interim, a client should only be considered primary if
    // `isPrimary` is true.
    this.fu = void 0;
  }
  get isPrimaryClient() {
    return this.fu === !0;
  }
}
async function X0e(e, t, n = !0) {
  const r = ZW(e);
  let i;
  const o = r.Pu.get(t);
  return o ? (
    // PORTING NOTE: With Multi-Tab Web, it is possible that a query view
    // already exists when EventManager calls us for the first time. This
    // happens when the primary tab is already listening to this query on
    // behalf of another tab and the user of the primary also starts listening
    // to the query. EventManager will not have an assigned target ID in this
    // case and calls `listen` to obtain this ID.
    (r.sharedClientState.addLocalQueryTarget(o.targetId), i = o.view.cu())
  ) : i = await KW(
    r,
    t,
    n,
    /** shouldInitializeView= */
    !0
  ), i;
}
async function Q0e(e, t) {
  const n = ZW(e);
  await KW(
    n,
    t,
    /** shouldListenToRemote= */
    !0,
    /** shouldInitializeView= */
    !1
  );
}
async function KW(e, t, n, r) {
  const i = await v0e(e.localStore, nc(t)), o = i.targetId, a = e.sharedClientState.addLocalQueryTarget(o, n);
  let s;
  return r && (s = await J0e(e, t, o, a === "current", i.resumeToken)), e.isPrimaryClient && n && VW(e.remoteStore, i), s;
}
async function J0e(e, t, n, r, i) {
  e.gu = (d, f, h) => async function(g, m, v, y) {
    let S = m.view.nu(v);
    S.Ds && // The query has a limit and some docs were removed, so we need
    // to re-run the query against the local store to make sure we
    // didn't lose any good docs that had been past the limit.
    (S = await x7(
      g.localStore,
      m.query,
      /* usePreviousResults= */
      !1
    ).then(({ documents: x }) => m.view.nu(x, S)));
    const _ = y && y.targetChanges.get(m.targetId), w = y && y.targetMismatches.get(m.targetId) != null, T = m.view.applyChanges(
      S,
      /* limboResolutionEnabled= */
      g.isPrimaryClient,
      _,
      w
    );
    return M7(g, m.targetId, T._u), T.snapshot;
  }(e, d, f, h);
  const o = await x7(
    e.localStore,
    t,
    /* usePreviousResults= */
    !0
  ), a = new q0e(t, o.qs), s = a.nu(o.documents), c = Uv.createSynthesizedTargetChangeForCurrentChange(n, r && e.onlineState !== "Offline", i), l = a.applyChanges(
    s,
    /* limboResolutionEnabled= */
    e.isPrimaryClient,
    c
  );
  M7(e, n, l._u);
  const u = new G0e(t, n, a);
  return e.Pu.set(t, u), e.Tu.has(n) ? e.Tu.get(n).push(t) : e.Tu.set(n, [t]), l.snapshot;
}
async function Z0e(e, t, n) {
  const r = qt(e), i = r.Pu.get(t), o = r.Tu.get(i.targetId);
  if (o.length > 1)
    return r.Tu.set(i.targetId, o.filter((a) => !sx(a, t))), void r.Pu.delete(t);
  r.isPrimaryClient ? (r.sharedClientState.removeLocalQueryTarget(i.targetId), r.sharedClientState.isActiveQueryTarget(i.targetId) || await WI(
    r.localStore,
    i.targetId,
    /*keepPersistedTargetData=*/
    !1
  ).then(() => {
    r.sharedClientState.clearQueryState(i.targetId), n && KO(r.remoteStore, i.targetId), KI(r, i.targetId);
  }).catch(up)) : (KI(r, i.targetId), await WI(
    r.localStore,
    i.targetId,
    /*keepPersistedTargetData=*/
    !0
  ));
}
async function eve(e, t) {
  const n = qt(e), r = n.Pu.get(t), i = n.Tu.get(r.targetId);
  n.isPrimaryClient && i.length === 1 && // PORTING NOTE: Unregister the target ID with local Firestore client as
  // watch target.
  (n.sharedClientState.removeLocalQueryTarget(r.targetId), KO(n.remoteStore, r.targetId));
}
async function tve(e, t, n) {
  const r = cve(e);
  try {
    const i = await function(a, s) {
      const c = qt(a), l = qn.now(), u = s.reduce((h, p) => h.add(p.key), _n());
      let d, f;
      return c.persistence.runTransaction("Locally write mutations", "readwrite", (h) => {
        let p = al(), g = _n();
        return c.Os.getEntries(h, u).next((m) => {
          p = m, p.forEach((v, y) => {
            y.isValidDocument() || (g = g.add(v));
          });
        }).next(() => c.localDocuments.getOverlayedDocuments(h, p)).next((m) => {
          d = m;
          const v = [];
          for (const y of s) {
            const S = vme(y, d.get(y.key).overlayedDocument);
            S != null && // NOTE: The base state should only be applied if there's some
            // existing document to override, so use a Precondition of
            // exists=true
            v.push(new Fu(y.key, S, tW(S.value.mapValue), rc.exists(!0)));
          }
          return c.mutationQueue.addMutationBatch(h, l, v, s);
        }).next((m) => {
          f = m;
          const v = m.applyToLocalDocumentSet(d, g);
          return c.documentOverlayCache.saveOverlays(h, m.batchId, v);
        });
      }).then(() => ({
        batchId: f.batchId,
        changes: fW(d)
      }));
    }(r.localStore, t);
    r.sharedClientState.addPendingMutation(i.batchId), function(a, s, c) {
      let l = a.Ru[a.currentUser.toKey()];
      l || (l = new jr(hn)), l = l.insert(s, c), a.Ru[a.currentUser.toKey()] = l;
    }(r, i.batchId, n), await qv(r, i.changes), await gx(r.remoteStore);
  } catch (i) {
    const o = ZO(i, "Failed to persist write");
    n.reject(o);
  }
}
async function YW(e, t) {
  const n = qt(e);
  try {
    const r = await g0e(n.localStore, t);
    t.targetChanges.forEach((i, o) => {
      const a = n.Eu.get(o);
      a && // Since this is a limbo resolution lookup, it's for a single document
      // and it could be added, modified, or removed, but not a combination.
      (jn(i.addedDocuments.size + i.modifiedDocuments.size + i.removedDocuments.size <= 1, 22616), i.addedDocuments.size > 0 ? a.lu = !0 : i.modifiedDocuments.size > 0 ? jn(a.lu, 14607) : i.removedDocuments.size > 0 && (jn(a.lu, 42227), a.lu = !1));
    }), await qv(n, r, t);
  } catch (r) {
    await up(r);
  }
}
function P7(e, t, n) {
  const r = qt(e);
  if (r.isPrimaryClient && n === 0 || !r.isPrimaryClient && n === 1) {
    const i = [];
    r.Pu.forEach((o, a) => {
      const s = a.view.va(t);
      s.snapshot && i.push(s.snapshot);
    }), function(a, s) {
      const c = qt(a);
      c.onlineState = s;
      let l = !1;
      c.queries.forEach((u, d) => {
        for (const f of d.wa)
          f.va(s) && (l = !0);
      }), l && nP(c);
    }(r.eventManager, t), i.length && r.hu.J_(i), r.onlineState = t, r.isPrimaryClient && r.sharedClientState.setOnlineState(t);
  }
}
async function nve(e, t, n) {
  const r = qt(e);
  r.sharedClientState.updateQueryState(t, "rejected", n);
  const i = r.Eu.get(t), o = i && i.key;
  if (o) {
    let a = new jr($t.comparator);
    a = a.insert(o, io.newNoDocument(o, Gt.min()));
    const s = _n().add(o), c = new dx(
      Gt.min(),
      /* targetChanges= */
      /* @__PURE__ */ new Map(),
      /* targetMismatches= */
      new jr(hn),
      a,
      s
    );
    await YW(r, c), // Since this query failed, we won't want to manually unlisten to it.
    // We only remove it from bookkeeping after we successfully applied the
    // RemoteEvent. If `applyRemoteEvent()` throws, we want to re-listen to
    // this query when the RemoteStore restarts the Watch stream, which should
    // re-trigger the target failure.
    r.du = r.du.remove(o), r.Eu.delete(t), oP(r);
  } else
    await WI(
      r.localStore,
      t,
      /* keepPersistedTargetData */
      !1
    ).then(() => KI(r, t, n)).catch(up);
}
async function rve(e, t) {
  const n = qt(e), r = t.batch.batchId;
  try {
    const i = await h0e(n.localStore, t);
    QW(
      n,
      r,
      /*error=*/
      null
    ), XW(n, r), n.sharedClientState.updateMutationState(r, "acknowledged"), await qv(n, i);
  } catch (i) {
    await up(i);
  }
}
async function ive(e, t, n) {
  const r = qt(e);
  try {
    const i = await function(a, s) {
      const c = qt(a);
      return c.persistence.runTransaction("Reject batch", "readwrite-primary", (l) => {
        let u;
        return c.mutationQueue.lookupMutationBatch(l, s).next((d) => (jn(d !== null, 37113), u = d.keys(), c.mutationQueue.removeMutationBatch(l, d))).next(() => c.mutationQueue.performConsistencyCheck(l)).next(() => c.documentOverlayCache.removeOverlaysForBatchId(l, u, s)).next(() => c.localDocuments.recalculateAndSaveOverlaysForDocumentKeys(l, u)).next(() => c.localDocuments.getDocuments(l, u));
      });
    }(r.localStore, t);
    QW(r, t, n), XW(r, t), r.sharedClientState.updateMutationState(t, "rejected", n), await qv(r, i);
  } catch (i) {
    await up(i);
  }
}
function XW(e, t) {
  (e.Vu.get(t) || []).forEach((n) => {
    n.resolve();
  }), e.Vu.delete(t);
}
function QW(e, t, n) {
  const r = qt(e);
  let i = r.Ru[r.currentUser.toKey()];
  if (i) {
    const o = i.get(t);
    o && (n ? o.reject(n) : o.resolve(), i = i.remove(t)), r.Ru[r.currentUser.toKey()] = i;
  }
}
function KI(e, t, n = null) {
  e.sharedClientState.removeLocalQueryTarget(t);
  for (const r of e.Tu.get(t))
    e.Pu.delete(r), n && e.hu.pu(r, n);
  e.Tu.delete(t), e.isPrimaryClient && e.Au.zr(t).forEach((r) => {
    e.Au.containsKey(r) || // We removed the last reference for this key
    JW(e, r);
  });
}
function JW(e, t) {
  e.Iu.delete(t.path.canonicalString());
  const n = e.du.get(t);
  n !== null && (KO(e.remoteStore, n), e.du = e.du.remove(t), e.Eu.delete(n), oP(e));
}
function M7(e, t, n) {
  for (const r of n)
    r instanceof qW ? (e.Au.addReference(r.key, t), ove(e, r)) : r instanceof GW ? (ht(iP, "Document no longer in limbo: " + r.key), e.Au.removeReference(r.key, t), e.Au.containsKey(r.key) || // We removed the last reference for this key
    JW(e, r.key)) : Wt(19791, {
      yu: r
    });
}
function ove(e, t) {
  const n = t.key, r = n.path.canonicalString();
  e.du.get(n) || e.Iu.has(r) || (ht(iP, "New document in limbo: " + n), e.Iu.add(r), oP(e));
}
function oP(e) {
  for (; e.Iu.size > 0 && e.du.size < e.maxConcurrentLimboResolutions; ) {
    const t = e.Iu.values().next().value;
    e.Iu.delete(t);
    const n = new $t(tr.fromString(t)), r = e.mu.next();
    e.Eu.set(r, new K0e(n)), e.du = e.du.insert(n, r), VW(e.remoteStore, new ql(nc(ax(n.path)), r, "TargetPurposeLimboResolution", nx.ue));
  }
}
async function qv(e, t, n) {
  const r = qt(e), i = [], o = [], a = [];
  r.Pu.isEmpty() || (r.Pu.forEach((s, c) => {
    a.push(r.gu(c, t, n).then((l) => {
      var u;
      if ((l || n) && r.isPrimaryClient) {
        const d = l ? !l.fromCache : (u = n == null ? void 0 : n.targetChanges.get(c.targetId)) === null || u === void 0 ? void 0 : u.current;
        r.sharedClientState.updateQueryState(c.targetId, d ? "current" : "not-current");
      }
      if (l) {
        i.push(l);
        const d = qO.Es(c.targetId, l);
        o.push(d);
      }
    }));
  }), await Promise.all(a), r.hu.J_(i), await async function(c, l) {
    const u = qt(c);
    try {
      await u.persistence.runTransaction("notifyLocalViewChanges", "readwrite", (d) => Te.forEach(l, (f) => Te.forEach(f.Is, (h) => u.persistence.referenceDelegate.addReference(d, f.targetId, h)).next(() => Te.forEach(f.ds, (h) => u.persistence.referenceDelegate.removeReference(d, f.targetId, h)))));
    } catch (d) {
      if (!dp(d))
        throw d;
      ht(GO, "Failed to update sequence numbers: " + d);
    }
    for (const d of l) {
      const f = d.targetId;
      if (!d.fromCache) {
        const h = u.Fs.get(f), p = h.snapshotVersion, g = h.withLastLimboFreeSnapshotVersion(p);
        u.Fs = u.Fs.insert(f, g);
      }
    }
  }(r.localStore, o));
}
async function ave(e, t) {
  const n = qt(e);
  if (!n.currentUser.isEqual(t)) {
    ht(iP, "User change. New user:", t.toKey());
    const r = await DW(n.localStore, t);
    n.currentUser = t, // Fails tasks waiting for pending writes requested by previous user.
    function(o, a) {
      o.Vu.forEach((s) => {
        s.forEach((c) => {
          c.reject(new Ye(Se.CANCELLED, a));
        });
      }), o.Vu.clear();
    }(n, "'waitForPendingWrites' promise is rejected due to a user change."), // TODO(b/114226417): Consider calling this only in the primary tab.
    n.sharedClientState.handleUserChange(t, r.removedBatchIds, r.addedBatchIds), await qv(n, r.Bs);
  }
}
function sve(e, t) {
  const n = qt(e), r = n.Eu.get(t);
  if (r && r.lu)
    return _n().add(r.key);
  {
    let i = _n();
    const o = n.Tu.get(t);
    if (!o)
      return i;
    for (const a of o) {
      const s = n.Pu.get(a);
      i = i.unionWith(s.view.tu);
    }
    return i;
  }
}
function ZW(e) {
  const t = qt(e);
  return t.remoteStore.remoteSyncer.applyRemoteEvent = YW.bind(null, t), t.remoteStore.remoteSyncer.getRemoteKeysForTarget = sve.bind(null, t), t.remoteStore.remoteSyncer.rejectListen = nve.bind(null, t), t.hu.J_ = U0e.bind(null, t.eventManager), t.hu.pu = W0e.bind(null, t.eventManager), t;
}
function cve(e) {
  const t = qt(e);
  return t.remoteStore.remoteSyncer.applySuccessfulWrite = rve.bind(null, t), t.remoteStore.remoteSyncer.rejectFailedWrite = ive.bind(null, t), t;
}
class k_ {
  constructor() {
    this.kind = "memory", this.synchronizeTabs = !1;
  }
  async initialize(t) {
    this.serializer = fx(t.databaseInfo.databaseId), this.sharedClientState = this.bu(t), this.persistence = this.Du(t), await this.persistence.start(), this.localStore = this.vu(t), this.gcScheduler = this.Cu(t, this.localStore), this.indexBackfillerScheduler = this.Fu(t, this.localStore);
  }
  Cu(t, n) {
    return null;
  }
  Fu(t, n) {
    return null;
  }
  vu(t) {
    return f0e(this.persistence, new l0e(), t.initialUser, this.serializer);
  }
  Du(t) {
    return new NW(WO.Vi, this.serializer);
  }
  bu(t) {
    return new b0e();
  }
  async terminate() {
    var t, n;
    (t = this.gcScheduler) === null || t === void 0 || t.stop(), (n = this.indexBackfillerScheduler) === null || n === void 0 || n.stop(), this.sharedClientState.shutdown(), await this.persistence.shutdown();
  }
}
k_.provider = {
  build: () => new k_()
};
class lve extends k_ {
  constructor(t) {
    super(), this.cacheSizeBytes = t;
  }
  Cu(t, n) {
    jn(this.persistence.referenceDelegate instanceof P_, 46915);
    const r = this.persistence.referenceDelegate.garbageCollector;
    return new Kme(r, t.asyncQueue, n);
  }
  Du(t) {
    const n = this.cacheSizeBytes !== void 0 ? Wo.withCacheSize(this.cacheSizeBytes) : Wo.DEFAULT;
    return new NW((r) => P_.Vi(r, n), this.serializer);
  }
}
class YI {
  async initialize(t, n) {
    this.localStore || (this.localStore = t.localStore, this.sharedClientState = t.sharedClientState, this.datastore = this.createDatastore(n), this.remoteStore = this.createRemoteStore(n), this.eventManager = this.createEventManager(n), this.syncEngine = this.createSyncEngine(
      n,
      /* startAsPrimary=*/
      !t.synchronizeTabs
    ), this.sharedClientState.onlineStateHandler = (r) => P7(
      this.syncEngine,
      r,
      1
      /* OnlineStateSource.SharedClientState */
    ), this.remoteStore.remoteSyncer.handleCredentialChange = ave.bind(null, this.syncEngine), await B0e(this.remoteStore, this.syncEngine.isPrimaryClient));
  }
  createEventManager(t) {
    return function() {
      return new H0e();
    }();
  }
  createDatastore(t) {
    const n = fx(t.databaseInfo.databaseId), r = function(o) {
      return new E0e(o);
    }(t.databaseInfo);
    return function(o, a, s, c) {
      return new A0e(o, a, s, c);
    }(t.authCredentials, t.appCheckCredentials, r, n);
  }
  createRemoteStore(t) {
    return function(r, i, o, a, s) {
      return new $0e(r, i, o, a, s);
    }(this.localStore, this.datastore, t.asyncQueue, (n) => P7(
      this.syncEngine,
      n,
      0
      /* OnlineStateSource.RemoteStore */
    ), function() {
      return T7.C() ? new T7() : new _0e();
    }());
  }
  createSyncEngine(t, n) {
    return function(i, o, a, s, c, l, u) {
      const d = new Y0e(i, o, a, s, c, l);
      return u && (d.fu = !0), d;
    }(this.localStore, this.remoteStore, this.eventManager, this.sharedClientState, t.initialUser, t.maxConcurrentLimboResolutions, n);
  }
  async terminate() {
    var t, n;
    await async function(i) {
      const o = qt(i);
      ht(ef, "RemoteStore shutting down."), o.Ia.add(
        5
        /* OfflineCause.Shutdown */
      ), await Wv(o), o.Ea.shutdown(), // Set the OnlineState to Unknown (rather than Offline) to avoid potentially
      // triggering spurious listener events with cached data, etc.
      o.Aa.set(
        "Unknown"
        /* OnlineState.Unknown */
      );
    }(this.remoteStore), (t = this.datastore) === null || t === void 0 || t.terminate(), (n = this.eventManager) === null || n === void 0 || n.terminate();
  }
}
YI.provider = {
  build: () => new YI()
};
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class aP {
  constructor(t) {
    this.observer = t, /**
     * When set to true, will not raise future events. Necessary to deal with
     * async detachment of listener.
     */
    this.muted = !1;
  }
  next(t) {
    this.muted || this.observer.next && this.xu(this.observer.next, t);
  }
  error(t) {
    this.muted || (this.observer.error ? this.xu(this.observer.error, t) : ol("Uncaught Error in snapshot listener:", t.toString()));
  }
  Ou() {
    this.muted = !0;
  }
  xu(t, n) {
    setTimeout(() => {
      this.muted || t(n);
    }, 0);
  }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const wu = "FirestoreClient";
class uve {
  constructor(t, n, r, i, o) {
    this.authCredentials = t, this.appCheckCredentials = n, this.asyncQueue = r, this.databaseInfo = i, this.user = ro.UNAUTHENTICATED, this.clientId = kO.newId(), this.authCredentialListener = () => Promise.resolve(), this.appCheckCredentialListener = () => Promise.resolve(), this._uninitializedComponentsProvider = o, this.authCredentials.start(r, async (a) => {
      ht(wu, "Received user=", a.uid), await this.authCredentialListener(a), this.user = a;
    }), this.appCheckCredentials.start(r, (a) => (ht(wu, "Received new app check token=", a), this.appCheckCredentialListener(a, this.user)));
  }
  get configuration() {
    return {
      asyncQueue: this.asyncQueue,
      databaseInfo: this.databaseInfo,
      clientId: this.clientId,
      authCredentials: this.authCredentials,
      appCheckCredentials: this.appCheckCredentials,
      initialUser: this.user,
      maxConcurrentLimboResolutions: 100
    };
  }
  setCredentialChangeListener(t) {
    this.authCredentialListener = t;
  }
  setAppCheckTokenChangeListener(t) {
    this.appCheckCredentialListener = t;
  }
  terminate() {
    this.asyncQueue.enterRestrictedMode();
    const t = new tc();
    return this.asyncQueue.enqueueAndForgetEvenWhileRestricted(async () => {
      try {
        this._onlineComponents && await this._onlineComponents.terminate(), this._offlineComponents && await this._offlineComponents.terminate(), // The credentials provider must be terminated after shutting down the
        // RemoteStore as it will prevent the RemoteStore from retrieving auth
        // tokens.
        this.authCredentials.shutdown(), this.appCheckCredentials.shutdown(), t.resolve();
      } catch (n) {
        const r = ZO(n, "Failed to shutdown persistence");
        t.reject(r);
      }
    }), t.promise;
  }
}
async function r5(e, t) {
  e.asyncQueue.verifyOperationInProgress(), ht(wu, "Initializing OfflineComponentProvider");
  const n = e.configuration;
  await t.initialize(n);
  let r = n.initialUser;
  e.setCredentialChangeListener(async (i) => {
    r.isEqual(i) || (await DW(t.localStore, i), r = i);
  }), t.persistence.setDatabaseDeletedListener(() => {
    mu("Terminating Firestore due to IndexedDb database deletion"), e.terminate().then(() => {
      ht("Terminating Firestore due to IndexedDb database deletion completed successfully");
    }).catch((i) => {
      mu("Terminating Firestore due to IndexedDb database deletion failed", i);
    });
  }), e._offlineComponents = t;
}
async function k7(e, t) {
  e.asyncQueue.verifyOperationInProgress();
  const n = await dve(e);
  ht(wu, "Initializing OnlineComponentProvider"), await t.initialize(n, e.configuration), // The CredentialChangeListener of the online component provider takes
  // precedence over the offline component provider.
  e.setCredentialChangeListener((r) => A7(t.remoteStore, r)), e.setAppCheckTokenChangeListener((r, i) => A7(t.remoteStore, i)), e._onlineComponents = t;
}
async function dve(e) {
  if (!e._offlineComponents)
    if (e._uninitializedComponentsProvider) {
      ht(wu, "Using user provided OfflineComponentProvider");
      try {
        await r5(e, e._uninitializedComponentsProvider._offline);
      } catch (t) {
        const n = t;
        if (!function(i) {
          return i.name === "FirebaseError" ? i.code === Se.FAILED_PRECONDITION || i.code === Se.UNIMPLEMENTED : !(typeof DOMException < "u" && i instanceof DOMException) || // When the browser is out of quota we could get either quota exceeded
          // or an aborted error depending on whether the error happened during
          // schema migration.
          i.code === 22 || i.code === 20 || // Firefox Private Browsing mode disables IndexedDb and returns
          // INVALID_STATE for any usage.
          i.code === 11;
        }(n))
          throw n;
        mu("Error using user provided cache. Falling back to memory cache: " + n), await r5(e, new k_());
      }
    } else
      ht(wu, "Using default OfflineComponentProvider"), await r5(e, new lve(void 0));
  return e._offlineComponents;
}
async function sP(e) {
  return e._onlineComponents || (e._uninitializedComponentsProvider ? (ht(wu, "Using user provided OnlineComponentProvider"), await k7(e, e._uninitializedComponentsProvider._online)) : (ht(wu, "Using default OnlineComponentProvider"), await k7(e, new YI()))), e._onlineComponents;
}
function fve(e) {
  return sP(e).then((t) => t.syncEngine);
}
function hve(e) {
  return sP(e).then((t) => t.datastore);
}
async function N_(e) {
  const t = await sP(e), n = t.eventManager;
  return n.onListen = X0e.bind(null, t.syncEngine), n.onUnlisten = Z0e.bind(null, t.syncEngine), n.onFirstRemoteStoreListen = Q0e.bind(null, t.syncEngine), n.onLastRemoteStoreUnlisten = eve.bind(null, t.syncEngine), n;
}
function eq(e, t, n = {}) {
  const r = new tc();
  return e.asyncQueue.enqueueAndForget(async () => function(o, a, s, c, l) {
    const u = new aP({
      next: (f) => {
        u.Ou(), a.enqueueAndForget(() => tP(o, d));
        const h = f.docs.has(s);
        !h && f.fromCache ? (
          // TODO(dimond): If we're online and the document doesn't
          // exist then we resolve with a doc.exists set to false. If
          // we're offline however, we reject the Promise in this
          // case. Two options: 1) Cache the negative response from
          // the server so we can deliver that even when you're
          // offline 2) Actually reject the Promise in the online case
          // if the document doesn't exist.
          l.reject(new Ye(Se.UNAVAILABLE, "Failed to get document because the client is offline."))
        ) : h && f.fromCache && c && c.source === "server" ? l.reject(new Ye(Se.UNAVAILABLE, 'Failed to get document from server. (However, this document does exist in the local cache. Run again without setting source to "server" to retrieve the cached document.)')) : l.resolve(f);
      },
      error: (f) => l.reject(f)
    }), d = new rP(ax(s.path), u, {
      includeMetadataChanges: !0,
      ka: !0
    });
    return eP(o, d);
  }(await N_(e), e.asyncQueue, t, n, r)), r.promise;
}
function gve(e, t, n = {}) {
  const r = new tc();
  return e.asyncQueue.enqueueAndForget(async () => function(o, a, s, c, l) {
    const u = new aP({
      next: (f) => {
        u.Ou(), a.enqueueAndForget(() => tP(o, d)), f.fromCache && c.source === "server" ? l.reject(new Ye(Se.UNAVAILABLE, 'Failed to get documents from server. (However, these documents may exist in the local cache. Run again without setting source to "server" to retrieve the cached documents.)')) : l.resolve(f);
      },
      error: (f) => l.reject(f)
    }), d = new rP(s, u, {
      includeMetadataChanges: !0,
      ka: !0
    });
    return eP(o, d);
  }(await N_(e), e.asyncQueue, t, n, r)), r.promise;
}
function pve(e, t, n) {
  const r = new tc();
  return e.asyncQueue.enqueueAndForget(async () => {
    try {
      const i = await hve(e);
      r.resolve(async function(a, s, c) {
        var l;
        const u = qt(a), { request: d, ft: f, parent: h } = Dme(u.serializer, rme(s), c);
        u.connection.Qo || delete d.parent;
        const p = (await u.Jo(
          "RunAggregationQuery",
          u.serializer.databaseId,
          h,
          d,
          /*expectedResponseCount=*/
          1
        )).filter((m) => !!m.result);
        jn(p.length === 1, 64727);
        const g = (l = p[0].result) === null || l === void 0 ? void 0 : l.aggregateFields;
        return Object.keys(g).reduce((m, v) => (m[f[v]] = g[v], m), {});
      }(i, t, n));
    } catch (i) {
      r.reject(i);
    }
  }), r.promise;
}
/**
 * @license
 * Copyright 2023 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function tq(e) {
  const t = {};
  return e.timeoutSeconds !== void 0 && (t.timeoutSeconds = e.timeoutSeconds), t;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const N7 = /* @__PURE__ */ new Map();
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const nq = "firestore.googleapis.com", D7 = !0;
class L7 {
  constructor(t) {
    var n, r;
    if (t.host === void 0) {
      if (t.ssl !== void 0)
        throw new Ye(Se.INVALID_ARGUMENT, "Can't provide ssl option if host option is not set");
      this.host = nq, this.ssl = D7;
    } else
      this.host = t.host, this.ssl = (n = t.ssl) !== null && n !== void 0 ? n : D7;
    if (this.isUsingEmulator = t.emulatorOptions !== void 0, this.credentials = t.credentials, this.ignoreUndefinedProperties = !!t.ignoreUndefinedProperties, this.localCache = t.localCache, t.cacheSizeBytes === void 0)
      this.cacheSizeBytes = MW;
    else {
      if (t.cacheSizeBytes !== -1 && t.cacheSizeBytes < kW)
        throw new Ye(Se.INVALID_ARGUMENT, "cacheSizeBytes must be at least 1048576");
      this.cacheSizeBytes = t.cacheSizeBytes;
    }
    Ope("experimentalForceLongPolling", t.experimentalForceLongPolling, "experimentalAutoDetectLongPolling", t.experimentalAutoDetectLongPolling), this.experimentalForceLongPolling = !!t.experimentalForceLongPolling, this.experimentalForceLongPolling ? this.experimentalAutoDetectLongPolling = !1 : t.experimentalAutoDetectLongPolling === void 0 ? this.experimentalAutoDetectLongPolling = !0 : (
      // For backwards compatibility, coerce the value to boolean even though
      // the TypeScript compiler has narrowed the type to boolean already.
      // noinspection PointlessBooleanExpressionJS
      this.experimentalAutoDetectLongPolling = !!t.experimentalAutoDetectLongPolling
    ), this.experimentalLongPollingOptions = tq((r = t.experimentalLongPollingOptions) !== null && r !== void 0 ? r : {}), function(o) {
      if (o.timeoutSeconds !== void 0) {
        if (isNaN(o.timeoutSeconds))
          throw new Ye(Se.INVALID_ARGUMENT, `invalid long polling timeout: ${o.timeoutSeconds} (must not be NaN)`);
        if (o.timeoutSeconds < 5)
          throw new Ye(Se.INVALID_ARGUMENT, `invalid long polling timeout: ${o.timeoutSeconds} (minimum allowed value is 5)`);
        if (o.timeoutSeconds > 30)
          throw new Ye(Se.INVALID_ARGUMENT, `invalid long polling timeout: ${o.timeoutSeconds} (maximum allowed value is 30)`);
      }
    }(this.experimentalLongPollingOptions), this.useFetchStreams = !!t.useFetchStreams;
  }
  isEqual(t) {
    return this.host === t.host && this.ssl === t.ssl && this.credentials === t.credentials && this.cacheSizeBytes === t.cacheSizeBytes && this.experimentalForceLongPolling === t.experimentalForceLongPolling && this.experimentalAutoDetectLongPolling === t.experimentalAutoDetectLongPolling && function(r, i) {
      return r.timeoutSeconds === i.timeoutSeconds;
    }(this.experimentalLongPollingOptions, t.experimentalLongPollingOptions) && this.ignoreUndefinedProperties === t.ignoreUndefinedProperties && this.useFetchStreams === t.useFetchStreams;
  }
}
class px {
  /** @hideconstructor */
  constructor(t, n, r, i) {
    this._authCredentials = t, this._appCheckCredentials = n, this._databaseId = r, this._app = i, /**
     * Whether it's a Firestore or Firestore Lite instance.
     */
    this.type = "firestore-lite", this._persistenceKey = "(lite)", this._settings = new L7({}), this._settingsFrozen = !1, this._emulatorOptions = {}, // A task that is assigned when the terminate() is invoked and resolved when
    // all components have shut down. Otherwise, Firestore is not terminated,
    // which can mean either the FirestoreClient is in the process of starting,
    // or restarting.
    this._terminateTask = "notTerminated";
  }
  /**
   * The {@link @firebase/app#FirebaseApp} associated with this `Firestore` service
   * instance.
   */
  get app() {
    if (!this._app)
      throw new Ye(Se.FAILED_PRECONDITION, "Firestore was not initialized using the Firebase SDK. 'app' is not available");
    return this._app;
  }
  get _initialized() {
    return this._settingsFrozen;
  }
  get _terminated() {
    return this._terminateTask !== "notTerminated";
  }
  _setSettings(t) {
    if (this._settingsFrozen)
      throw new Ye(Se.FAILED_PRECONDITION, "Firestore has already been started and its settings can no longer be changed. You can only modify settings before calling any other methods on a Firestore object.");
    this._settings = new L7(t), this._emulatorOptions = t.emulatorOptions || {}, t.credentials !== void 0 && (this._authCredentials = function(r) {
      if (!r)
        return new wpe();
      switch (r.type) {
        case "firstParty":
          return new Tpe(r.sessionIndex || "0", r.iamToken || null, r.authTokenFactory || null);
        case "provider":
          return r.client;
        default:
          throw new Ye(Se.INVALID_ARGUMENT, "makeAuthCredentialsProvider failed due to invalid credential type");
      }
    }(t.credentials));
  }
  _getSettings() {
    return this._settings;
  }
  _getEmulatorOptions() {
    return this._emulatorOptions;
  }
  _freezeSettings() {
    return this._settingsFrozen = !0, this._settings;
  }
  _delete() {
    return this._terminateTask === "notTerminated" && (this._terminateTask = this._terminate()), this._terminateTask;
  }
  async _restart() {
    this._terminateTask === "notTerminated" ? await this._terminate() : this._terminateTask = "notTerminated";
  }
  /** Returns a JSON-serializable representation of this `Firestore` instance. */
  toJSON() {
    return {
      app: this._app,
      databaseId: this._databaseId,
      settings: this._settings
    };
  }
  /**
   * Terminates all components used by this client. Subclasses can override
   * this method to clean up their own dependencies, but must also call this
   * method.
   *
   * Only ever called once.
   */
  _terminate() {
    return function(n) {
      const r = N7.get(n);
      r && (ht("ComponentProvider", "Removing Datastore"), N7.delete(n), r.terminate());
    }(this), Promise.resolve();
  }
}
function rq(e, t, n, r = {}) {
  var i;
  e = Oo(e, px);
  const o = ku(t), a = e._getSettings(), s = Object.assign(Object.assign({}, a), {
    emulatorOptions: e._getEmulatorOptions()
  }), c = `${t}:${n}`;
  o && (qw(`https://${c}`), pO("Firestore", !0)), a.host !== nq && a.host !== c && mu("Host has been set in both settings() and connectFirestoreEmulator(), emulator host will be used.");
  const l = Object.assign(Object.assign({}, a), {
    host: c,
    ssl: o,
    emulatorOptions: r
  });
  if (!tl(l, s) && (e._setSettings(l), r.mockUserToken)) {
    let u, d;
    if (typeof r.mockUserToken == "string")
      u = r.mockUserToken, d = ro.MOCK_USER;
    else {
      u = Xle(r.mockUserToken, (i = e._app) === null || i === void 0 ? void 0 : i.options.projectId);
      const f = r.mockUserToken.sub || r.mockUserToken.user_id;
      if (!f)
        throw new Ye(Se.INVALID_ARGUMENT, "mockUserToken must contain 'sub' or 'user_id' field!");
      d = new ro(f);
    }
    e._authCredentials = new xpe(new VU(u, d));
  }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class As {
  // This is the lite version of the Query class in the main SDK.
  /** @hideconstructor protected */
  constructor(t, n, r) {
    this.converter = n, this._query = r, /** The type of this Firestore reference. */
    this.type = "query", this.firestore = t;
  }
  withConverter(t) {
    return new As(this.firestore, t, this._query);
  }
}
class Nr {
  /** @hideconstructor */
  constructor(t, n, r) {
    this.converter = n, this._key = r, /** The type of this Firestore reference. */
    this.type = "document", this.firestore = t;
  }
  get _path() {
    return this._key.path;
  }
  /**
   * The document's identifier within its collection.
   */
  get id() {
    return this._key.path.lastSegment();
  }
  /**
   * A string representing the path of the referenced document (relative
   * to the root of the database).
   */
  get path() {
    return this._key.path.canonicalString();
  }
  /**
   * The collection this `DocumentReference` belongs to.
   */
  get parent() {
    return new au(this.firestore, this.converter, this._key.path.popLast());
  }
  withConverter(t) {
    return new Nr(this.firestore, t, this._key);
  }
  /**
   * Returns a JSON-serializable representation of this `DocumentReference` instance.
   *
   * @returns a JSON representation of this object.
   */
  toJSON() {
    return {
      type: Nr._jsonSchemaVersion,
      referencePath: this._key.toString()
    };
  }
  static fromJSON(t, n, r) {
    if (zv(n, Nr._jsonSchema))
      return new Nr(t, r || null, new $t(tr.fromString(n.referencePath)));
  }
}
Nr._jsonSchemaVersion = "firestore/documentReference/1.0", Nr._jsonSchema = {
  type: li("string", Nr._jsonSchemaVersion),
  referencePath: li("string")
};
class au extends As {
  /** @hideconstructor */
  constructor(t, n, r) {
    super(t, n, ax(r)), this._path = r, /** The type of this Firestore reference. */
    this.type = "collection";
  }
  /** The collection's identifier. */
  get id() {
    return this._query.path.lastSegment();
  }
  /**
   * A string representing the path of the referenced collection (relative
   * to the root of the database).
   */
  get path() {
    return this._query.path.canonicalString();
  }
  /**
   * A reference to the containing `DocumentReference` if this is a
   * subcollection. If this isn't a subcollection, the reference is null.
   */
  get parent() {
    const t = this._path.popLast();
    return t.isEmpty() ? null : new Nr(
      this.firestore,
      /* converter= */
      null,
      new $t(t)
    );
  }
  withConverter(t) {
    return new au(this.firestore, t, this._path);
  }
}
function Jf(e, t, ...n) {
  if (e = $r(e), zU("collection", "path", t), e instanceof px) {
    const r = tr.fromString(t, ...n);
    return QD(r), new au(
      e,
      /* converter= */
      null,
      r
    );
  }
  {
    if (!(e instanceof Nr || e instanceof au))
      throw new Ye(Se.INVALID_ARGUMENT, "Expected first argument to collection() to be a CollectionReference, a DocumentReference or FirebaseFirestore");
    const r = e._path.child(tr.fromString(t, ...n));
    return QD(r), new au(
      e.firestore,
      /* converter= */
      null,
      r
    );
  }
}
function i5(e, t, ...n) {
  if (e = $r(e), // We allow omission of 'pathString' but explicitly prohibit passing in both
  // 'undefined' and 'null'.
  arguments.length === 1 && (t = kO.newId()), zU("doc", "path", t), e instanceof px) {
    const r = tr.fromString(t, ...n);
    return XD(r), new Nr(
      e,
      /* converter= */
      null,
      new $t(r)
    );
  }
  {
    if (!(e instanceof Nr || e instanceof au))
      throw new Ye(Se.INVALID_ARGUMENT, "Expected first argument to collection() to be a CollectionReference, a DocumentReference or FirebaseFirestore");
    const r = e._path.child(tr.fromString(t, ...n));
    return XD(r), new Nr(e.firestore, e instanceof au ? e.converter : null, new $t(r));
  }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const j7 = "AsyncQueue";
class F7 {
  constructor(t = Promise.resolve()) {
    this.Zu = [], // Is this AsyncQueue being shut down? Once it is set to true, it will not
    // be changed again.
    this.Xu = !1, // Operations scheduled to be queued in the future. Operations are
    // automatically removed after they are run or canceled.
    this.ec = [], // visible for testing
    this.tc = null, // Flag set while there's an outstanding AsyncQueue operation, used for
    // assertion sanity-checks.
    this.nc = !1, // Enabled during shutdown on Safari to prevent future access to IndexedDB.
    this.rc = !1, // List of TimerIds to fast-forward delays for.
    this.sc = [], // Backoff timer used to schedule retries for retryable operations
    this.F_ = new jW(
      this,
      "async_queue_retry"
      /* TimerId.AsyncQueueRetry */
    ), // Visibility handler that triggers an immediate retry of all retryable
    // operations. Meant to speed up recovery when we regain file system access
    // after page comes into foreground.
    this.oc = () => {
      const r = n5();
      r && ht(j7, "Visibility state changed to " + r.visibilityState), this.F_.y_();
    }, this._c = t;
    const n = n5();
    n && typeof n.addEventListener == "function" && n.addEventListener("visibilitychange", this.oc);
  }
  get isShuttingDown() {
    return this.Xu;
  }
  /**
   * Adds a new operation to the queue without waiting for it to complete (i.e.
   * we ignore the Promise result).
   */
  enqueueAndForget(t) {
    this.enqueue(t);
  }
  enqueueAndForgetEvenWhileRestricted(t) {
    this.ac(), // eslint-disable-next-line @typescript-eslint/no-floating-promises
    this.uc(t);
  }
  enterRestrictedMode(t) {
    if (!this.Xu) {
      this.Xu = !0, this.rc = t || !1;
      const n = n5();
      n && typeof n.removeEventListener == "function" && n.removeEventListener("visibilitychange", this.oc);
    }
  }
  enqueue(t) {
    if (this.ac(), this.Xu)
      return new Promise(() => {
      });
    const n = new tc();
    return this.uc(() => this.Xu && this.rc ? Promise.resolve() : (t().then(n.resolve, n.reject), n.promise)).then(() => n.promise);
  }
  enqueueRetryable(t) {
    this.enqueueAndForget(() => (this.Zu.push(t), this.cc()));
  }
  /**
   * Runs the next operation from the retryable queue. If the operation fails,
   * reschedules with backoff.
   */
  async cc() {
    if (this.Zu.length !== 0) {
      try {
        await this.Zu[0](), this.Zu.shift(), this.F_.reset();
      } catch (t) {
        if (!dp(t))
          throw t;
        ht(j7, "Operation failed with retryable error: " + t);
      }
      this.Zu.length > 0 && // If there are additional operations, we re-schedule `retryNextOp()`.
      // This is necessary to run retryable operations that failed during
      // their initial attempt since we don't know whether they are already
      // enqueued. If, for example, `op1`, `op2`, `op3` are enqueued and `op1`
      // needs to  be re-run, we will run `op1`, `op1`, `op2` using the
      // already enqueued calls to `retryNextOp()`. `op3()` will then run in the
      // call scheduled here.
      // Since `backoffAndRun()` cancels an existing backoff and schedules a
      // new backoff on every call, there is only ever a single additional
      // operation in the queue.
      this.F_.g_(() => this.cc());
    }
  }
  uc(t) {
    const n = this._c.then(() => (this.nc = !0, t().catch((r) => {
      throw this.tc = r, this.nc = !1, ol("INTERNAL UNHANDLED ERROR: ", V7(r)), r;
    }).then((r) => (this.nc = !1, r))));
    return this._c = n, n;
  }
  enqueueAfterDelay(t, n, r) {
    this.ac(), // Fast-forward delays for timerIds that have been overridden.
    this.sc.indexOf(t) > -1 && (n = 0);
    const i = JO.createAndSchedule(this, t, n, r, (o) => this.lc(o));
    return this.ec.push(i), i;
  }
  ac() {
    this.tc && Wt(47125, {
      hc: V7(this.tc)
    });
  }
  verifyOperationInProgress() {
  }
  /**
   * Waits until all currently queued tasks are finished executing. Delayed
   * operations are not run.
   */
  async Pc() {
    let t;
    do
      t = this._c, await t;
    while (t !== this._c);
  }
  /**
   * For Tests: Determine if a delayed operation with a particular TimerId
   * exists.
   */
  Tc(t) {
    for (const n of this.ec)
      if (n.timerId === t)
        return !0;
    return !1;
  }
  /**
   * For Tests: Runs some or all delayed operations early.
   *
   * @param lastTimerId - Delayed operations up to and including this TimerId
   * will be drained. Pass TimerId.All to run all delayed operations.
   * @returns a Promise that resolves once all operations have been run.
   */
  Ic(t) {
    return this.Pc().then(() => {
      this.ec.sort((n, r) => n.targetTimeMs - r.targetTimeMs);
      for (const n of this.ec)
        if (n.skipDelay(), t !== "all" && n.timerId === t)
          break;
      return this.Pc();
    });
  }
  /**
   * For Tests: Skip all subsequent delays for a timer id.
   */
  dc(t) {
    this.sc.push(t);
  }
  /** Called once a DelayedOperation is run or canceled. */
  lc(t) {
    const n = this.ec.indexOf(t);
    this.ec.splice(n, 1);
  }
}
function V7(e) {
  let t = e.message || "";
  return e.stack && (t = e.stack.includes(e.message) ? e.stack : e.message + `
` + e.stack), t;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function B7(e) {
  return function(n, r) {
    if (typeof n != "object" || n === null)
      return !1;
    const i = n;
    for (const o of r)
      if (o in i && typeof i[o] == "function")
        return !0;
    return !1;
  }(e, ["next", "error", "complete"]);
}
class sl extends px {
  /** @hideconstructor */
  constructor(t, n, r, i) {
    super(t, n, r, i), /**
     * Whether it's a {@link Firestore} or Firestore Lite instance.
     */
    this.type = "firestore", this._queue = new F7(), this._persistenceKey = (i == null ? void 0 : i.name) || "[DEFAULT]";
  }
  async _terminate() {
    if (this._firestoreClient) {
      const t = this._firestoreClient.terminate();
      this._queue = new F7(t), this._firestoreClient = void 0, await t;
    }
  }
}
function mve(e, t, n) {
  n || (n = V0);
  const r = gl(e, "firestore");
  if (r.isInitialized(n)) {
    const i = r.getImmediate({
      identifier: n
    }), o = r.getOptions(n);
    if (tl(o, t))
      return i;
    throw new Ye(Se.FAILED_PRECONDITION, "initializeFirestore() has already been called with different options. To avoid this error, call initializeFirestore() with the same options as when it was originally called, or call getFirestore() to return the already initialized instance.");
  }
  if (t.cacheSizeBytes !== void 0 && t.localCache !== void 0)
    throw new Ye(Se.INVALID_ARGUMENT, "cache and cacheSizeBytes cannot be specified at the same time as cacheSizeBytes willbe deprecated. Instead, specify the cache size in the cache object");
  if (t.cacheSizeBytes !== void 0 && t.cacheSizeBytes !== -1 && t.cacheSizeBytes < kW)
    throw new Ye(Se.INVALID_ARGUMENT, "cacheSizeBytes must be at least 1048576");
  return t.host && ku(t.host) && qw(t.host), r.initialize({
    options: t,
    instanceIdentifier: n
  });
}
function vve(e, t) {
  const n = typeof e == "object" ? e : Kw(), r = typeof e == "string" ? e : t || V0, i = gl(n, "firestore").getImmediate({
    identifier: r
  });
  if (!i._initialized) {
    const o = hH("firestore");
    o && rq(i, ...o);
  }
  return i;
}
function hp(e) {
  if (e._terminated)
    throw new Ye(Se.FAILED_PRECONDITION, "The client has already been terminated.");
  return e._firestoreClient || yve(e), e._firestoreClient;
}
function yve(e) {
  var t, n, r;
  const i = e._freezeSettings(), o = function(s, c, l, u) {
    return new Hpe(s, c, l, u.host, u.ssl, u.experimentalForceLongPolling, u.experimentalAutoDetectLongPolling, tq(u.experimentalLongPollingOptions), u.useFetchStreams, u.isUsingEmulator);
  }(e._databaseId, ((t = e._app) === null || t === void 0 ? void 0 : t.options.appId) || "", e._persistenceKey, i);
  e._componentsProvider || !((n = i.localCache) === null || n === void 0) && n._offlineComponentProvider && (!((r = i.localCache) === null || r === void 0) && r._onlineComponentProvider) && (e._componentsProvider = {
    _offline: i.localCache._offlineComponentProvider,
    _online: i.localCache._onlineComponentProvider
  }), e._firestoreClient = new uve(e._authCredentials, e._appCheckCredentials, e._queue, o, e._componentsProvider && function(s) {
    const c = s == null ? void 0 : s._online.build();
    return {
      _offline: s == null ? void 0 : s._offline.build(c),
      _online: c
    };
  }(e._componentsProvider));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class bve {
  /**
   * Create a new AggregateField<T>
   * @param aggregateType Specifies the type of aggregation operation to perform.
   * @param _internalFieldPath Optionally specifies the field that is aggregated.
   * @internal
   */
  constructor(t = "count", n) {
    this._internalFieldPath = n, /** A type string to uniquely identify instances of this class. */
    this.type = "AggregateField", this.aggregateType = t;
  }
}
class _ve {
  /** @hideconstructor */
  constructor(t, n, r) {
    this._userDataWriter = n, this._data = r, /** A type string to uniquely identify instances of this class. */
    this.type = "AggregateQuerySnapshot", this.query = t;
  }
  /**
   * Returns the results of the aggregations performed over the underlying
   * query.
   *
   * The keys of the returned object will be the same as those of the
   * `AggregateSpec` object specified to the aggregation method, and the values
   * will be the corresponding aggregation result.
   *
   * @returns The results of the aggregations performed over the underlying
   * query.
   */
  data() {
    return this._userDataWriter.convertObjectMap(this._data);
  }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class Da {
  /** @hideconstructor */
  constructor(t) {
    this._byteString = t;
  }
  /**
   * Creates a new `Bytes` object from the given Base64 string, converting it to
   * bytes.
   *
   * @param base64 - The Base64 string used to create the `Bytes` object.
   */
  static fromBase64String(t) {
    try {
      return new Da(Hi.fromBase64String(t));
    } catch (n) {
      throw new Ye(Se.INVALID_ARGUMENT, "Failed to construct data from Base64 string: " + n);
    }
  }
  /**
   * Creates a new `Bytes` object from the given Uint8Array.
   *
   * @param array - The Uint8Array used to create the `Bytes` object.
   */
  static fromUint8Array(t) {
    return new Da(Hi.fromUint8Array(t));
  }
  /**
   * Returns the underlying bytes as a Base64-encoded string.
   *
   * @returns The Base64-encoded string created from the `Bytes` object.
   */
  toBase64() {
    return this._byteString.toBase64();
  }
  /**
   * Returns the underlying bytes in a new `Uint8Array`.
   *
   * @returns The Uint8Array created from the `Bytes` object.
   */
  toUint8Array() {
    return this._byteString.toUint8Array();
  }
  /**
   * Returns a string representation of the `Bytes` object.
   *
   * @returns A string representation of the `Bytes` object.
   */
  toString() {
    return "Bytes(base64: " + this.toBase64() + ")";
  }
  /**
   * Returns true if this `Bytes` object is equal to the provided one.
   *
   * @param other - The `Bytes` object to compare against.
   * @returns true if this `Bytes` object is equal to the provided one.
   */
  isEqual(t) {
    return this._byteString.isEqual(t._byteString);
  }
  /**
   * Returns a JSON-serializable representation of this `Bytes` instance.
   *
   * @returns a JSON representation of this object.
   */
  toJSON() {
    return {
      type: Da._jsonSchemaVersion,
      bytes: this.toBase64()
    };
  }
  /**
   * Builds a `Bytes` instance from a JSON object created by {@link Bytes.toJSON}.
   *
   * @param json a JSON object represention of a `Bytes` instance
   * @returns an instance of {@link Bytes} if the JSON object could be parsed. Throws a
   * {@link FirestoreError} if an error occurs.
   */
  static fromJSON(t) {
    if (zv(t, Da._jsonSchema))
      return Da.fromBase64String(t.bytes);
  }
}
Da._jsonSchemaVersion = "firestore/bytes/1.0", Da._jsonSchema = {
  type: li("string", Da._jsonSchemaVersion),
  bytes: li("string")
};
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class mx {
  /**
   * Creates a `FieldPath` from the provided field names. If more than one field
   * name is provided, the path will point to a nested field in a document.
   *
   * @param fieldNames - A list of field names.
   */
  constructor(...t) {
    for (let n = 0; n < t.length; ++n)
      if (t[n].length === 0)
        throw new Ye(Se.INVALID_ARGUMENT, "Invalid field name at argument $(i + 1). Field names must not be empty.");
    this._internalPath = new Vi(t);
  }
  /**
   * Returns true if this `FieldPath` is equal to the provided one.
   *
   * @param other - The `FieldPath` to compare against.
   * @returns true if this `FieldPath` is equal to the provided one.
   */
  isEqual(t) {
    return this._internalPath.isEqual(t._internalPath);
  }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class cP {
  /**
   * @param _methodName - The public API endpoint that returns this class.
   * @hideconstructor
   */
  constructor(t) {
    this._methodName = t;
  }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class oc {
  /**
   * Creates a new immutable `GeoPoint` object with the provided latitude and
   * longitude values.
   * @param latitude - The latitude as number between -90 and 90.
   * @param longitude - The longitude as number between -180 and 180.
   */
  constructor(t, n) {
    if (!isFinite(t) || t < -90 || t > 90)
      throw new Ye(Se.INVALID_ARGUMENT, "Latitude must be a number between -90 and 90, but was: " + t);
    if (!isFinite(n) || n < -180 || n > 180)
      throw new Ye(Se.INVALID_ARGUMENT, "Longitude must be a number between -180 and 180, but was: " + n);
    this._lat = t, this._long = n;
  }
  /**
   * The latitude of this `GeoPoint` instance.
   */
  get latitude() {
    return this._lat;
  }
  /**
   * The longitude of this `GeoPoint` instance.
   */
  get longitude() {
    return this._long;
  }
  /**
   * Returns true if this `GeoPoint` is equal to the provided one.
   *
   * @param other - The `GeoPoint` to compare against.
   * @returns true if this `GeoPoint` is equal to the provided one.
   */
  isEqual(t) {
    return this._lat === t._lat && this._long === t._long;
  }
  /**
   * Actually private to JS consumers of our API, so this function is prefixed
   * with an underscore.
   */
  _compareTo(t) {
    return hn(this._lat, t._lat) || hn(this._long, t._long);
  }
  /**
   * Returns a JSON-serializable representation of this `GeoPoint` instance.
   *
   * @returns a JSON representation of this object.
   */
  toJSON() {
    return {
      latitude: this._lat,
      longitude: this._long,
      type: oc._jsonSchemaVersion
    };
  }
  /**
   * Builds a `GeoPoint` instance from a JSON object created by {@link GeoPoint.toJSON}.
   *
   * @param json a JSON object represention of a `GeoPoint` instance
   * @returns an instance of {@link GeoPoint} if the JSON object could be parsed. Throws a
   * {@link FirestoreError} if an error occurs.
   */
  static fromJSON(t) {
    if (zv(t, oc._jsonSchema))
      return new oc(t.latitude, t.longitude);
  }
}
oc._jsonSchemaVersion = "firestore/geoPoint/1.0", oc._jsonSchema = {
  type: li("string", oc._jsonSchemaVersion),
  latitude: li("number"),
  longitude: li("number")
};
/**
 * @license
 * Copyright 2024 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class ac {
  /**
   * @private
   * @internal
   */
  constructor(t) {
    this._values = (t || []).map((n) => n);
  }
  /**
   * Returns a copy of the raw number array form of the vector.
   */
  toArray() {
    return this._values.map((t) => t);
  }
  /**
   * Returns `true` if the two `VectorValue` values have the same raw number arrays, returns `false` otherwise.
   */
  isEqual(t) {
    return function(r, i) {
      if (r.length !== i.length)
        return !1;
      for (let o = 0; o < r.length; ++o)
        if (r[o] !== i[o])
          return !1;
      return !0;
    }(this._values, t._values);
  }
  /**
   * Returns a JSON-serializable representation of this `VectorValue` instance.
   *
   * @returns a JSON representation of this object.
   */
  toJSON() {
    return {
      type: ac._jsonSchemaVersion,
      vectorValues: this._values
    };
  }
  /**
   * Builds a `VectorValue` instance from a JSON object created by {@link VectorValue.toJSON}.
   *
   * @param json a JSON object represention of a `VectorValue` instance.
   * @returns an instance of {@link VectorValue} if the JSON object could be parsed. Throws a
   * {@link FirestoreError} if an error occurs.
   */
  static fromJSON(t) {
    if (zv(t, ac._jsonSchema)) {
      if (Array.isArray(t.vectorValues) && t.vectorValues.every((n) => typeof n == "number"))
        return new ac(t.vectorValues);
      throw new Ye(Se.INVALID_ARGUMENT, "Expected 'vectorValues' field to be a number array");
    }
  }
}
ac._jsonSchemaVersion = "firestore/vectorValue/1.0", ac._jsonSchema = {
  type: li("string", ac._jsonSchemaVersion),
  vectorValues: li("object")
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const Sve = /^__.*__$/;
class wve {
  constructor(t, n, r) {
    this.data = t, this.fieldMask = n, this.fieldTransforms = r;
  }
  toMutation(t, n) {
    return this.fieldMask !== null ? new Fu(t, this.data, this.fieldMask, n, this.fieldTransforms) : new Hv(t, this.data, n, this.fieldTransforms);
  }
}
class iq {
  constructor(t, n, r) {
    this.data = t, this.fieldMask = n, this.fieldTransforms = r;
  }
  toMutation(t, n) {
    return new Fu(t, this.data, this.fieldMask, n, this.fieldTransforms);
  }
}
function oq(e) {
  switch (e) {
    case 0:
    case 2:
    case 1:
      return !0;
    case 3:
    case 4:
      return !1;
    default:
      throw Wt(40011, {
        Ec: e
      });
  }
}
class lP {
  /**
   * Initializes a ParseContext with the given source and path.
   *
   * @param settings - The settings for the parser.
   * @param databaseId - The database ID of the Firestore instance.
   * @param serializer - The serializer to use to generate the Value proto.
   * @param ignoreUndefinedProperties - Whether to ignore undefined properties
   * rather than throw.
   * @param fieldTransforms - A mutable list of field transforms encountered
   * while parsing the data.
   * @param fieldMask - A mutable list of field paths encountered while parsing
   * the data.
   *
   * TODO(b/34871131): We don't support array paths right now, so path can be
   * null to indicate the context represents any location within an array (in
   * which case certain features will not work and errors will be somewhat
   * compromised).
   */
  constructor(t, n, r, i, o, a) {
    this.settings = t, this.databaseId = n, this.serializer = r, this.ignoreUndefinedProperties = i, // Minor hack: If fieldTransforms is undefined, we assume this is an
    // external call and we need to validate the entire path.
    o === void 0 && this.Ac(), this.fieldTransforms = o || [], this.fieldMask = a || [];
  }
  get path() {
    return this.settings.path;
  }
  get Ec() {
    return this.settings.Ec;
  }
  /** Returns a new context with the specified settings overwritten. */
  Rc(t) {
    return new lP(Object.assign(Object.assign({}, this.settings), t), this.databaseId, this.serializer, this.ignoreUndefinedProperties, this.fieldTransforms, this.fieldMask);
  }
  Vc(t) {
    var n;
    const r = (n = this.path) === null || n === void 0 ? void 0 : n.child(t), i = this.Rc({
      path: r,
      mc: !1
    });
    return i.fc(t), i;
  }
  gc(t) {
    var n;
    const r = (n = this.path) === null || n === void 0 ? void 0 : n.child(t), i = this.Rc({
      path: r,
      mc: !1
    });
    return i.Ac(), i;
  }
  yc(t) {
    return this.Rc({
      path: void 0,
      mc: !0
    });
  }
  wc(t) {
    return D_(t, this.settings.methodName, this.settings.Sc || !1, this.path, this.settings.bc);
  }
  /** Returns 'true' if 'fieldPath' was traversed when creating this context. */
  contains(t) {
    return this.fieldMask.find((n) => t.isPrefixOf(n)) !== void 0 || this.fieldTransforms.find((n) => t.isPrefixOf(n.field)) !== void 0;
  }
  Ac() {
    if (this.path)
      for (let t = 0; t < this.path.length; t++)
        this.fc(this.path.get(t));
  }
  fc(t) {
    if (t.length === 0)
      throw this.wc("Document fields must not be empty");
    if (oq(this.Ec) && Sve.test(t))
      throw this.wc('Document fields cannot begin and end with "__"');
  }
}
class xve {
  constructor(t, n, r) {
    this.databaseId = t, this.ignoreUndefinedProperties = n, this.serializer = r || fx(t);
  }
  /** Creates a new top-level parse context. */
  Dc(t, n, r, i = !1) {
    return new lP({
      Ec: t,
      methodName: n,
      bc: r,
      path: Vi.emptyPath(),
      mc: !1,
      Sc: i
    }, this.databaseId, this.serializer, this.ignoreUndefinedProperties);
  }
}
function vx(e) {
  const t = e._freezeSettings(), n = fx(e._databaseId);
  return new xve(e._databaseId, !!t.ignoreUndefinedProperties, n);
}
function Eve(e, t, n, r, i, o = {}) {
  const a = e.Dc(o.merge || o.mergeFields ? 2 : 0, t, n, i);
  uP("Data must be an object, but it was:", a, r);
  const s = sq(r, a);
  let c, l;
  if (o.merge)
    c = new ga(a.fieldMask), l = a.fieldTransforms;
  else if (o.mergeFields) {
    const u = [];
    for (const d of o.mergeFields) {
      const f = XI(t, d, n);
      if (!a.contains(f))
        throw new Ye(Se.INVALID_ARGUMENT, `Field '${f}' is specified in your field mask but missing from your input data.`);
      lq(u, f) || u.push(f);
    }
    c = new ga(u), l = a.fieldTransforms.filter((d) => c.covers(d.field));
  } else
    c = null, l = a.fieldTransforms;
  return new wve(new Yo(s), c, l);
}
class Gv extends cP {
  _toFieldTransform(t) {
    if (t.Ec !== 2)
      throw t.Ec === 1 ? t.wc(`${this._methodName}() can only appear at the top level of your update data`) : t.wc(`${this._methodName}() cannot be used with set() unless you pass {merge:true}`);
    return t.fieldMask.push(t.path), null;
  }
  isEqual(t) {
    return t instanceof Gv;
  }
}
function Cve(e, t, n, r) {
  const i = e.Dc(1, t, n);
  uP("Data must be an object, but it was:", i, r);
  const o = [], a = Yo.empty();
  Lu(r, (c, l) => {
    const u = dP(t, c, n);
    l = $r(l);
    const d = i.gc(u);
    if (l instanceof Gv)
      o.push(u);
    else {
      const f = Kv(l, d);
      f != null && (o.push(u), a.set(u, f));
    }
  });
  const s = new ga(o);
  return new iq(a, s, i.fieldTransforms);
}
function Tve(e, t, n, r, i, o) {
  const a = e.Dc(1, t, n), s = [XI(t, r, n)], c = [i];
  if (o.length % 2 != 0)
    throw new Ye(Se.INVALID_ARGUMENT, `Function ${t}() needs to be called with an even number of arguments that alternate between field names and values.`);
  for (let f = 0; f < o.length; f += 2)
    s.push(XI(t, o[f])), c.push(o[f + 1]);
  const l = [], u = Yo.empty();
  for (let f = s.length - 1; f >= 0; --f)
    if (!lq(l, s[f])) {
      const h = s[f];
      let p = c[f];
      p = $r(p);
      const g = a.gc(h);
      if (p instanceof Gv)
        l.push(h);
      else {
        const m = Kv(p, g);
        m != null && (l.push(h), u.set(h, m));
      }
    }
  const d = new ga(l);
  return new iq(u, d, a.fieldTransforms);
}
function aq(e, t, n, r = !1) {
  return Kv(n, e.Dc(r ? 4 : 3, t));
}
function Kv(e, t) {
  if (cq(
    // Unwrap the API type from the Compat SDK. This will return the API type
    // from firestore-exp.
    e = $r(e)
  ))
    return uP("Unsupported field value:", t, e), sq(e, t);
  if (e instanceof cP)
    return function(r, i) {
      if (!oq(i.Ec))
        throw i.wc(`${r._methodName}() can only be used with update() and set()`);
      if (!i.path)
        throw i.wc(`${r._methodName}() is not currently supported inside arrays`);
      const o = r._toFieldTransform(i);
      o && i.fieldTransforms.push(o);
    }(e, t), null;
  if (e === void 0 && t.ignoreUndefinedProperties)
    return null;
  if (
    // If context.path is null we are inside an array and we don't support
    // field mask paths more granular than the top-level array.
    t.path && t.fieldMask.push(t.path), e instanceof Array
  ) {
    if (t.settings.mc && t.Ec !== 4)
      throw t.wc("Nested arrays are not supported");
    return function(r, i) {
      const o = [];
      let a = 0;
      for (const s of r) {
        let c = Kv(s, i.yc(a));
        c == null && // Just include nulls in the array for fields being replaced with a
        // sentinel.
        (c = {
          nullValue: "NULL_VALUE"
        }), o.push(c), a++;
      }
      return {
        arrayValue: {
          values: o
        }
      };
    }(e, t);
  }
  return function(r, i) {
    if ((r = $r(r)) === null)
      return {
        nullValue: "NULL_VALUE"
      };
    if (typeof r == "number")
      return dme(i.serializer, r);
    if (typeof r == "boolean")
      return {
        booleanValue: r
      };
    if (typeof r == "string")
      return {
        stringValue: r
      };
    if (r instanceof Date) {
      const o = qn.fromDate(r);
      return {
        timestampValue: O_(i.serializer, o)
      };
    }
    if (r instanceof qn) {
      const o = new qn(r.seconds, 1e3 * Math.floor(r.nanoseconds / 1e3));
      return {
        timestampValue: O_(i.serializer, o)
      };
    }
    if (r instanceof oc)
      return {
        geoPointValue: {
          latitude: r.latitude,
          longitude: r.longitude
        }
      };
    if (r instanceof Da)
      return {
        bytesValue: CW(i.serializer, r._byteString)
      };
    if (r instanceof Nr) {
      const o = i.databaseId, a = r.firestore._databaseId;
      if (!a.isEqual(o))
        throw i.wc(`Document reference is for database ${a.projectId}/${a.database} but should be for database ${o.projectId}/${o.database}`);
      return {
        referenceValue: HO(r.firestore._databaseId || i.databaseId, r._key.path)
      };
    }
    if (r instanceof ac)
      return function(a, s) {
        return {
          mapValue: {
            fields: {
              [JU]: {
                stringValue: eW
              },
              [T_]: {
                arrayValue: {
                  values: a.toArray().map((l) => {
                    if (typeof l != "number")
                      throw s.wc("VectorValues must only contain numeric values.");
                    return VO(s.serializer, l);
                  })
                }
              }
            }
          }
        };
      }(r, i);
    throw i.wc(`Unsupported field value: ${tx(r)}`);
  }(e, t);
}
function sq(e, t) {
  const n = {};
  return qU(e) ? (
    // If we encounter an empty object, we explicitly add it to the update
    // mask to ensure that the server creates a map entry.
    t.path && t.path.length > 0 && t.fieldMask.push(t.path)
  ) : Lu(e, (r, i) => {
    const o = Kv(i, t.Vc(r));
    o != null && (n[r] = o);
  }), {
    mapValue: {
      fields: n
    }
  };
}
function cq(e) {
  return !(typeof e != "object" || e === null || e instanceof Array || e instanceof Date || e instanceof qn || e instanceof oc || e instanceof Da || e instanceof Nr || e instanceof cP || e instanceof ac);
}
function uP(e, t, n) {
  if (!cq(n) || !HU(n)) {
    const r = tx(n);
    throw r === "an object" ? t.wc(e + " a custom object") : t.wc(e + " " + r);
  }
}
function XI(e, t, n) {
  if (
    // If required, replace the FieldPath Compat class with the firestore-exp
    // FieldPath.
    (t = $r(t)) instanceof mx
  )
    return t._internalPath;
  if (typeof t == "string")
    return dP(e, t);
  throw D_(
    "Field path arguments must be of type string or ",
    e,
    /* hasConverter= */
    !1,
    /* path= */
    void 0,
    n
  );
}
const Ive = new RegExp("[~\\*/\\[\\]]");
function dP(e, t, n) {
  if (t.search(Ive) >= 0)
    throw D_(
      `Invalid field path (${t}). Paths must not contain '~', '*', '/', '[', or ']'`,
      e,
      /* hasConverter= */
      !1,
      /* path= */
      void 0,
      n
    );
  try {
    return new mx(...t.split("."))._internalPath;
  } catch {
    throw D_(
      `Invalid field path (${t}). Paths must not be empty, begin with '.', end with '.', or contain '..'`,
      e,
      /* hasConverter= */
      !1,
      /* path= */
      void 0,
      n
    );
  }
}
function D_(e, t, n, r, i) {
  const o = r && !r.isEmpty(), a = i !== void 0;
  let s = `Function ${t}() called with invalid data`;
  n && (s += " (via `toFirestore()`)"), s += ". ";
  let c = "";
  return (o || a) && (c += " (found", o && (c += ` in field ${r}`), a && (c += ` in document ${i}`), c += ")"), new Ye(Se.INVALID_ARGUMENT, s + e + c);
}
function lq(e, t) {
  return e.some((n) => n.isEqual(t));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class fP {
  // Note: This class is stripped down version of the DocumentSnapshot in
  // the legacy SDK. The changes are:
  // - No support for SnapshotMetadata.
  // - No support for SnapshotOptions.
  /** @hideconstructor protected */
  constructor(t, n, r, i, o) {
    this._firestore = t, this._userDataWriter = n, this._key = r, this._document = i, this._converter = o;
  }
  /** Property of the `DocumentSnapshot` that provides the document's ID. */
  get id() {
    return this._key.path.lastSegment();
  }
  /**
   * The `DocumentReference` for the document included in the `DocumentSnapshot`.
   */
  get ref() {
    return new Nr(this._firestore, this._converter, this._key);
  }
  /**
   * Signals whether or not the document at the snapshot's location exists.
   *
   * @returns true if the document exists.
   */
  exists() {
    return this._document !== null;
  }
  /**
   * Retrieves all fields in the document as an `Object`. Returns `undefined` if
   * the document doesn't exist.
   *
   * @returns An `Object` containing all fields in the document or `undefined`
   * if the document doesn't exist.
   */
  data() {
    if (this._document) {
      if (this._converter) {
        const t = new Ave(
          this._firestore,
          this._userDataWriter,
          this._key,
          this._document,
          /* converter= */
          null
        );
        return this._converter.fromFirestore(t);
      }
      return this._userDataWriter.convertValue(this._document.data.value);
    }
  }
  /**
   * Retrieves the field specified by `fieldPath`. Returns `undefined` if the
   * document or field doesn't exist.
   *
   * @param fieldPath - The path (for example 'foo' or 'foo.bar') to a specific
   * field.
   * @returns The data at the specified field location or undefined if no such
   * field exists in the document.
   */
  // We are using `any` here to avoid an explicit cast by our users.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  get(t) {
    if (this._document) {
      const n = this._document.data.field(yx("DocumentSnapshot.get", t));
      if (n !== null)
        return this._userDataWriter.convertValue(n);
    }
  }
}
class Ave extends fP {
  /**
   * Retrieves all fields in the document as an `Object`.
   *
   * @override
   * @returns An `Object` containing all fields in the document.
   */
  data() {
    return super.data();
  }
}
function yx(e, t) {
  return typeof t == "string" ? dP(e, t) : t instanceof mx ? t._internalPath : t._delegate._internalPath;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function uq(e) {
  if (e.limitType === "L" && e.explicitOrderBy.length === 0)
    throw new Ye(Se.UNIMPLEMENTED, "limitToLast() queries require specifying at least one orderBy() clause");
}
class hP {
}
class Yv extends hP {
}
function ks(e, t, ...n) {
  let r = [];
  t instanceof hP && r.push(t), r = r.concat(n), function(o) {
    const a = o.filter((c) => c instanceof gP).length, s = o.filter((c) => c instanceof bx).length;
    if (a > 1 || a > 0 && s > 0)
      throw new Ye(Se.INVALID_ARGUMENT, "InvalidQuery. When using composite filters, you cannot use more than one filter at the top level. Consider nesting the multiple filters within an `and(...)` statement. For example: change `query(query, where(...), or(...))` to `query(query, and(where(...), or(...)))`.");
  }(r);
  for (const i of r)
    e = i._apply(e);
  return e;
}
class bx extends Yv {
  /**
   * @internal
   */
  constructor(t, n, r) {
    super(), this._field = t, this._op = n, this._value = r, /** The type of this query constraint */
    this.type = "where";
  }
  static _create(t, n, r) {
    return new bx(t, n, r);
  }
  _apply(t) {
    const n = this._parse(t);
    return fq(t._query, n), new As(t.firestore, t.converter, VI(t._query, n));
  }
  _parse(t) {
    const n = vx(t.firestore);
    return function(o, a, s, c, l, u, d) {
      let f;
      if (l.isKeyField()) {
        if (u === "array-contains" || u === "array-contains-any")
          throw new Ye(Se.INVALID_ARGUMENT, `Invalid Query. You can't perform '${u}' queries on documentId().`);
        if (u === "in" || u === "not-in") {
          G7(d, u);
          const p = [];
          for (const g of d)
            p.push(q7(c, o, g));
          f = {
            arrayValue: {
              values: p
            }
          };
        } else
          f = q7(c, o, d);
      } else
        u !== "in" && u !== "not-in" && u !== "array-contains-any" || G7(d, u), f = aq(
          s,
          a,
          d,
          /* allowArrays= */
          u === "in" || u === "not-in"
        );
      return ci.create(l, u, f);
    }(t._query, "where", n, t.firestore._databaseId, this._field, this._op, this._value);
  }
}
function _b(e, t, n) {
  const r = t, i = yx("where", e);
  return bx._create(i, r, n);
}
class gP extends hP {
  /**
   * @internal
   */
  constructor(t, n) {
    super(), this.type = t, this._queryConstraints = n;
  }
  static _create(t, n) {
    return new gP(t, n);
  }
  _parse(t) {
    const n = this._queryConstraints.map((r) => r._parse(t)).filter((r) => r.getFilters().length > 0);
    return n.length === 1 ? n[0] : ws.create(n, this._getOperator());
  }
  _apply(t) {
    const n = this._parse(t);
    return n.getFilters().length === 0 ? t : (function(i, o) {
      let a = i;
      const s = o.getFlattenedFilters();
      for (const c of s)
        fq(a, c), a = VI(a, c);
    }(t._query, n), new As(t.firestore, t.converter, VI(t._query, n)));
  }
  _getQueryConstraints() {
    return this._queryConstraints;
  }
  _getOperator() {
    return this.type === "and" ? "and" : "or";
  }
}
class pP extends Yv {
  /**
   * @internal
   */
  constructor(t, n) {
    super(), this._field = t, this._direction = n, /** The type of this query constraint */
    this.type = "orderBy";
  }
  static _create(t, n) {
    return new pP(t, n);
  }
  _apply(t) {
    const n = function(i, o, a) {
      if (i.startAt !== null)
        throw new Ye(Se.INVALID_ARGUMENT, "Invalid query. You must not call startAt() or startAfter() before calling orderBy().");
      if (i.endAt !== null)
        throw new Ye(Se.INVALID_ARGUMENT, "Invalid query. You must not call endAt() or endBefore() before calling orderBy().");
      return new H0(o, a);
    }(t._query, this._field, this._direction);
    return new As(t.firestore, t.converter, function(i, o) {
      const a = i.explicitOrderBy.concat([o]);
      return new ju(i.path, i.collectionGroup, a, i.filters.slice(), i.limit, i.limitType, i.startAt, i.endAt);
    }(t._query, n));
  }
}
function Cc(e, t = "asc") {
  const n = t, r = yx("orderBy", e);
  return pP._create(r, n);
}
class _x extends Yv {
  /**
   * @internal
   */
  constructor(t, n, r) {
    super(), this.type = t, this._limit = n, this._limitType = r;
  }
  static _create(t, n, r) {
    return new _x(t, n, r);
  }
  _apply(t) {
    return new As(t.firestore, t.converter, A_(t._query, this._limit, this._limitType));
  }
}
function nd(e) {
  return UU("limit", e), _x._create(
    "limit",
    e,
    "F"
    /* LimitType.First */
  );
}
function z7(e) {
  return UU("limitToLast", e), _x._create(
    "limitToLast",
    e,
    "L"
    /* LimitType.Last */
  );
}
class Sx extends Yv {
  /**
   * @internal
   */
  constructor(t, n, r) {
    super(), this.type = t, this._docOrFields = n, this._inclusive = r;
  }
  static _create(t, n, r) {
    return new Sx(t, n, r);
  }
  _apply(t) {
    const n = dq(t, this.type, this._docOrFields, this._inclusive);
    return new As(t.firestore, t.converter, function(i, o) {
      return new ju(i.path, i.collectionGroup, i.explicitOrderBy.slice(), i.filters.slice(), i.limit, i.limitType, o, i.endAt);
    }(t._query, n));
  }
}
function H7(...e) {
  return Sx._create(
    "startAt",
    e,
    /*inclusive=*/
    !0
  );
}
function U7(...e) {
  return Sx._create(
    "startAfter",
    e,
    /*inclusive=*/
    !1
  );
}
class mP extends Yv {
  /**
   * @internal
   */
  constructor(t, n, r) {
    super(), this.type = t, this._docOrFields = n, this._inclusive = r;
  }
  static _create(t, n, r) {
    return new mP(t, n, r);
  }
  _apply(t) {
    const n = dq(t, this.type, this._docOrFields, this._inclusive);
    return new As(t.firestore, t.converter, function(i, o) {
      return new ju(i.path, i.collectionGroup, i.explicitOrderBy.slice(), i.filters.slice(), i.limit, i.limitType, i.startAt, o);
    }(t._query, n));
  }
}
function W7(...e) {
  return mP._create(
    "endBefore",
    e,
    /*inclusive=*/
    !1
  );
}
function dq(e, t, n, r) {
  if (n[0] = $r(n[0]), n[0] instanceof fP)
    return function(o, a, s, c, l) {
      if (!c)
        throw new Ye(Se.NOT_FOUND, `Can't use a DocumentSnapshot that doesn't exist for ${s}().`);
      const u = [];
      for (const d of Wh(o))
        if (d.field.isKeyField())
          u.push(I_(a, c.key));
        else {
          const f = c.data.field(d.field);
          if (ix(f))
            throw new Ye(Se.INVALID_ARGUMENT, 'Invalid query. You are trying to start or end a query using a document for which the field "' + d.field + '" is an uncommitted server timestamp. (Since the value of this field is unknown, you cannot start/end a query with it.)');
          if (f === null) {
            const h = d.field.canonicalString();
            throw new Ye(Se.INVALID_ARGUMENT, `Invalid query. You are trying to start or end a query using a document for which the field '${h}' (used as the orderBy) does not exist.`);
          }
          u.push(f);
        }
      return new hg(u, l);
    }(e._query, e.firestore._databaseId, t, n[0]._document, r);
  {
    const i = vx(e.firestore);
    return function(a, s, c, l, u, d) {
      const f = a.explicitOrderBy;
      if (u.length > f.length)
        throw new Ye(Se.INVALID_ARGUMENT, `Too many arguments provided to ${l}(). The number of arguments must be less than or equal to the number of orderBy() clauses`);
      const h = [];
      for (let p = 0; p < u.length; p++) {
        const g = u[p];
        if (f[p].field.isKeyField()) {
          if (typeof g != "string")
            throw new Ye(Se.INVALID_ARGUMENT, `Invalid query. Expected a string for document ID in ${l}(), but got a ${typeof g}`);
          if (!FO(a) && g.indexOf("/") !== -1)
            throw new Ye(Se.INVALID_ARGUMENT, `Invalid query. When querying a collection and ordering by documentId(), the value passed to ${l}() must be a plain document ID, but '${g}' contains a slash.`);
          const m = a.path.child(tr.fromString(g));
          if (!$t.isDocumentKey(m))
            throw new Ye(Se.INVALID_ARGUMENT, `Invalid query. When querying a collection group and ordering by documentId(), the value passed to ${l}() must result in a valid document path, but '${m}' is not because it contains an odd number of segments.`);
          const v = new $t(m);
          h.push(I_(s, v));
        } else {
          const m = aq(c, l, g);
          h.push(m);
        }
      }
      return new hg(h, d);
    }(e._query, e.firestore._databaseId, i, t, n, r);
  }
}
function q7(e, t, n) {
  if (typeof (n = $r(n)) == "string") {
    if (n === "")
      throw new Ye(Se.INVALID_ARGUMENT, "Invalid query. When querying with documentId(), you must provide a valid document ID, but it was an empty string.");
    if (!FO(t) && n.indexOf("/") !== -1)
      throw new Ye(Se.INVALID_ARGUMENT, `Invalid query. When querying a collection by documentId(), you must provide a plain document ID, but '${n}' contains a '/' character.`);
    const r = t.path.child(tr.fromString(n));
    if (!$t.isDocumentKey(r))
      throw new Ye(Se.INVALID_ARGUMENT, `Invalid query. When querying a collection group by documentId(), the value provided must result in a valid document path, but '${r}' is not because it has an odd number of segments (${r.length}).`);
    return I_(e, new $t(r));
  }
  if (n instanceof Nr)
    return I_(e, n._key);
  throw new Ye(Se.INVALID_ARGUMENT, `Invalid query. When querying with documentId(), you must provide a valid string or a DocumentReference, but it was: ${tx(n)}.`);
}
function G7(e, t) {
  if (!Array.isArray(e) || e.length === 0)
    throw new Ye(Se.INVALID_ARGUMENT, `Invalid Query. A non-empty array is required for '${t.toString()}' filters.`);
}
function fq(e, t) {
  const n = function(i, o) {
    for (const a of i)
      for (const s of a.getFlattenedFilters())
        if (o.indexOf(s.op) >= 0)
          return s.op;
    return null;
  }(e.filters, function(i) {
    switch (i) {
      case "!=":
        return [
          "!=",
          "not-in"
          /* Operator.NOT_IN */
        ];
      case "array-contains-any":
      case "in":
        return [
          "not-in"
          /* Operator.NOT_IN */
        ];
      case "not-in":
        return [
          "array-contains-any",
          "in",
          "not-in",
          "!="
          /* Operator.NOT_EQUAL */
        ];
      default:
        return [];
    }
  }(t.op));
  if (n !== null)
    throw n === t.op ? new Ye(Se.INVALID_ARGUMENT, `Invalid query. You cannot use more than one '${t.op.toString()}' filter.`) : new Ye(Se.INVALID_ARGUMENT, `Invalid query. You cannot use '${t.op.toString()}' filters with '${n.toString()}' filters.`);
}
class Rve {
  convertValue(t, n = "none") {
    switch (_u(t)) {
      case 0:
        return null;
      case 1:
        return t.booleanValue;
      case 2:
        return ei(t.integerValue || t.doubleValue);
      case 3:
        return this.convertTimestamp(t.timestampValue);
      case 4:
        return this.convertServerTimestamp(t, n);
      case 5:
        return t.stringValue;
      case 6:
        return this.convertBytes(bu(t.bytesValue));
      case 7:
        return this.convertReference(t.referenceValue);
      case 8:
        return this.convertGeoPoint(t.geoPointValue);
      case 9:
        return this.convertArray(t.arrayValue, n);
      case 11:
        return this.convertObject(t.mapValue, n);
      case 10:
        return this.convertVectorValue(t.mapValue);
      default:
        throw Wt(62114, {
          value: t
        });
    }
  }
  convertObject(t, n) {
    return this.convertObjectMap(t.fields, n);
  }
  /**
   * @internal
   */
  convertObjectMap(t, n = "none") {
    const r = {};
    return Lu(t, (i, o) => {
      r[i] = this.convertValue(o, n);
    }), r;
  }
  /**
   * @internal
   */
  convertVectorValue(t) {
    var n, r, i;
    const o = (i = (r = (n = t.fields) === null || n === void 0 ? void 0 : n[T_].arrayValue) === null || r === void 0 ? void 0 : r.values) === null || i === void 0 ? void 0 : i.map((a) => ei(a.doubleValue));
    return new ac(o);
  }
  convertGeoPoint(t) {
    return new oc(ei(t.latitude), ei(t.longitude));
  }
  convertArray(t, n) {
    return (t.values || []).map((r) => this.convertValue(r, n));
  }
  convertServerTimestamp(t, n) {
    switch (n) {
      case "previous":
        const r = ox(t);
        return r == null ? null : this.convertValue(r, n);
      case "estimate":
        return this.convertTimestamp(F0(t));
      default:
        return null;
    }
  }
  convertTimestamp(t) {
    const n = yu(t);
    return new qn(n.seconds, n.nanos);
  }
  convertDocumentKey(t, n) {
    const r = tr.fromString(t);
    jn(PW(r), 9688, {
      name: t
    });
    const i = new B0(r.get(1), r.get(3)), o = new $t(r.popFirst(5));
    return i.isEqual(n) || // TODO(b/64130202): Somehow support foreign references.
    ol(`Document ${o} contains a document reference within a different database (${i.projectId}/${i.database}) which is not supported. It will be treated as a reference in the current database (${n.projectId}/${n.database}) instead.`), o;
  }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function $ve(e, t, n) {
  let r;
  return r = e ? n && (n.merge || n.mergeFields) ? e.toFirestore(t, n) : e.toFirestore(t) : t, r;
}
function Ove() {
  return new bve("count");
}
class Bm {
  /** @hideconstructor */
  constructor(t, n) {
    this.hasPendingWrites = t, this.fromCache = n;
  }
  /**
   * Returns true if this `SnapshotMetadata` is equal to the provided one.
   *
   * @param other - The `SnapshotMetadata` to compare against.
   * @returns true if this `SnapshotMetadata` is equal to the provided one.
   */
  isEqual(t) {
    return this.hasPendingWrites === t.hasPendingWrites && this.fromCache === t.fromCache;
  }
}
class Md extends fP {
  /** @hideconstructor protected */
  constructor(t, n, r, i, o, a) {
    super(t, n, r, i, a), this._firestore = t, this._firestoreImpl = t, this.metadata = o;
  }
  /**
   * Returns whether or not the data exists. True if the document exists.
   */
  exists() {
    return super.exists();
  }
  /**
   * Retrieves all fields in the document as an `Object`. Returns `undefined` if
   * the document doesn't exist.
   *
   * By default, `serverTimestamp()` values that have not yet been
   * set to their final value will be returned as `null`. You can override
   * this by passing an options object.
   *
   * @param options - An options object to configure how data is retrieved from
   * the snapshot (for example the desired behavior for server timestamps that
   * have not yet been set to their final value).
   * @returns An `Object` containing all fields in the document or `undefined` if
   * the document doesn't exist.
   */
  data(t = {}) {
    if (this._document) {
      if (this._converter) {
        const n = new N1(
          this._firestore,
          this._userDataWriter,
          this._key,
          this._document,
          this.metadata,
          /* converter= */
          null
        );
        return this._converter.fromFirestore(n, t);
      }
      return this._userDataWriter.convertValue(this._document.data.value, t.serverTimestamps);
    }
  }
  /**
   * Retrieves the field specified by `fieldPath`. Returns `undefined` if the
   * document or field doesn't exist.
   *
   * By default, a `serverTimestamp()` that has not yet been set to
   * its final value will be returned as `null`. You can override this by
   * passing an options object.
   *
   * @param fieldPath - The path (for example 'foo' or 'foo.bar') to a specific
   * field.
   * @param options - An options object to configure how the field is retrieved
   * from the snapshot (for example the desired behavior for server timestamps
   * that have not yet been set to their final value).
   * @returns The data at the specified field location or undefined if no such
   * field exists in the document.
   */
  // We are using `any` here to avoid an explicit cast by our users.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  get(t, n = {}) {
    if (this._document) {
      const r = this._document.data.field(yx("DocumentSnapshot.get", t));
      if (r !== null)
        return this._userDataWriter.convertValue(r, n.serverTimestamps);
    }
  }
  /**
   * Returns a JSON-serializable representation of this `DocumentSnapshot` instance.
   *
   * @returns a JSON representation of this object.  Throws a {@link FirestoreError} if this
   * `DocumentSnapshot` has pending writes.
   */
  toJSON() {
    if (this.metadata.hasPendingWrites)
      throw new Ye(Se.FAILED_PRECONDITION, "DocumentSnapshot.toJSON() attempted to serialize a document with pending writes. Await waitForPendingWrites() before invoking toJSON().");
    const t = this._document, n = {};
    return n.type = Md._jsonSchemaVersion, n.bundle = "", n.bundleSource = "DocumentSnapshot", n.bundleName = this._key.toString(), !t || !t.isValidDocument() || !t.isFoundDocument() ? n : (this._userDataWriter.convertObjectMap(t.data.value.mapValue.fields, "previous"), n.bundle = (this._firestore, this.ref.path, "NOT SUPPORTED"), n);
  }
}
Md._jsonSchemaVersion = "firestore/documentSnapshot/1.0", Md._jsonSchema = {
  type: li("string", Md._jsonSchemaVersion),
  bundleSource: li("string", "DocumentSnapshot"),
  bundleName: li("string"),
  bundle: li("string")
};
class N1 extends Md {
  /**
   * Retrieves all fields in the document as an `Object`.
   *
   * By default, `serverTimestamp()` values that have not yet been
   * set to their final value will be returned as `null`. You can override
   * this by passing an options object.
   *
   * @override
   * @param options - An options object to configure how data is retrieved from
   * the snapshot (for example the desired behavior for server timestamps that
   * have not yet been set to their final value).
   * @returns An `Object` containing all fields in the document.
   */
  data(t = {}) {
    return super.data(t);
  }
}
class kd {
  /** @hideconstructor */
  constructor(t, n, r, i) {
    this._firestore = t, this._userDataWriter = n, this._snapshot = i, this.metadata = new Bm(i.hasPendingWrites, i.fromCache), this.query = r;
  }
  /** An array of all the documents in the `QuerySnapshot`. */
  get docs() {
    const t = [];
    return this.forEach((n) => t.push(n)), t;
  }
  /** The number of documents in the `QuerySnapshot`. */
  get size() {
    return this._snapshot.docs.size;
  }
  /** True if there are no documents in the `QuerySnapshot`. */
  get empty() {
    return this.size === 0;
  }
  /**
   * Enumerates all of the documents in the `QuerySnapshot`.
   *
   * @param callback - A callback to be called with a `QueryDocumentSnapshot` for
   * each document in the snapshot.
   * @param thisArg - The `this` binding for the callback.
   */
  forEach(t, n) {
    this._snapshot.docs.forEach((r) => {
      t.call(n, new N1(this._firestore, this._userDataWriter, r.key, r, new Bm(this._snapshot.mutatedKeys.has(r.key), this._snapshot.fromCache), this.query.converter));
    });
  }
  /**
   * Returns an array of the documents changes since the last snapshot. If this
   * is the first snapshot, all documents will be in the list as 'added'
   * changes.
   *
   * @param options - `SnapshotListenOptions` that control whether metadata-only
   * changes (i.e. only `DocumentSnapshot.metadata` changed) should trigger
   * snapshot events.
   */
  docChanges(t = {}) {
    const n = !!t.includeMetadataChanges;
    if (n && this._snapshot.excludesMetadataChanges)
      throw new Ye(Se.INVALID_ARGUMENT, "To include metadata changes with your document changes, you must also pass { includeMetadataChanges:true } to onSnapshot().");
    return this._cachedChanges && this._cachedChangesIncludeMetadataChanges === n || (this._cachedChanges = /** Calculates the array of `DocumentChange`s for a given `ViewSnapshot`. */
    function(i, o) {
      if (i._snapshot.oldDocs.isEmpty()) {
        let a = 0;
        return i._snapshot.docChanges.map((s) => {
          const c = new N1(i._firestore, i._userDataWriter, s.doc.key, s.doc, new Bm(i._snapshot.mutatedKeys.has(s.doc.key), i._snapshot.fromCache), i.query.converter);
          return s.doc, {
            type: "added",
            doc: c,
            oldIndex: -1,
            newIndex: a++
          };
        });
      }
      {
        let a = i._snapshot.oldDocs;
        return i._snapshot.docChanges.filter((s) => o || s.type !== 3).map((s) => {
          const c = new N1(i._firestore, i._userDataWriter, s.doc.key, s.doc, new Bm(i._snapshot.mutatedKeys.has(s.doc.key), i._snapshot.fromCache), i.query.converter);
          let l = -1, u = -1;
          return s.type !== 0 && (l = a.indexOf(s.doc.key), a = a.delete(s.doc.key)), s.type !== 1 && (a = a.add(s.doc), u = a.indexOf(s.doc.key)), {
            type: Pve(s.type),
            doc: c,
            oldIndex: l,
            newIndex: u
          };
        });
      }
    }(this, n), this._cachedChangesIncludeMetadataChanges = n), this._cachedChanges;
  }
  /**
   * Returns a JSON-serializable representation of this `QuerySnapshot` instance.
   *
   * @returns a JSON representation of this object. Throws a {@link FirestoreError} if this
   * `QuerySnapshot` has pending writes.
   */
  toJSON() {
    if (this.metadata.hasPendingWrites)
      throw new Ye(Se.FAILED_PRECONDITION, "QuerySnapshot.toJSON() attempted to serialize a document with pending writes. Await waitForPendingWrites() before invoking toJSON().");
    const t = {};
    t.type = kd._jsonSchemaVersion, t.bundleSource = "QuerySnapshot", t.bundleName = kO.newId(), this._firestore._databaseId.database, this._firestore._databaseId.projectId;
    const n = [], r = [], i = [];
    return this.docs.forEach((o) => {
      o._document !== null && (n.push(o._document), r.push(this._userDataWriter.convertObjectMap(o._document.data.value.mapValue.fields, "previous")), i.push(o.ref.path));
    }), t.bundle = (this._firestore, this.query._query, t.bundleName, "NOT SUPPORTED"), t;
  }
}
function Pve(e) {
  switch (e) {
    case 0:
      return "added";
    case 2:
    case 3:
      return "modified";
    case 1:
      return "removed";
    default:
      return Wt(61501, {
        type: e
      });
  }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function o5(e) {
  e = Oo(e, Nr);
  const t = Oo(e.firestore, sl);
  return eq(hp(t), e._key).then((n) => vP(t, e, n));
}
kd._jsonSchemaVersion = "firestore/querySnapshot/1.0", kd._jsonSchema = {
  type: li("string", kd._jsonSchemaVersion),
  bundleSource: li("string", "QuerySnapshot"),
  bundleName: li("string"),
  bundle: li("string")
};
class wx extends Rve {
  constructor(t) {
    super(), this.firestore = t;
  }
  convertBytes(t) {
    return new Da(t);
  }
  convertReference(t) {
    const n = this.convertDocumentKey(t, this.firestore._databaseId);
    return new Nr(
      this.firestore,
      /* converter= */
      null,
      n
    );
  }
}
function a5(e) {
  e = Oo(e, Nr);
  const t = Oo(e.firestore, sl);
  return eq(hp(t), e._key, {
    source: "server"
  }).then((n) => vP(t, e, n));
}
function Sb(e) {
  e = Oo(e, As);
  const t = Oo(e.firestore, sl), n = hp(t), r = new wx(t);
  return uq(e._query), gve(n, e._query).then((i) => new kd(t, r, e, i));
}
function wb(e, t, n) {
  e = Oo(e, Nr);
  const r = Oo(e.firestore, sl), i = $ve(e.converter, t, n);
  return hq(r, [Eve(vx(r), "setDoc", e._key, i, e.converter !== null, n).toMutation(e._key, rc.none())]);
}
function Mve(e, t, n, ...r) {
  e = Oo(e, Nr);
  const i = Oo(e.firestore, sl), o = vx(i);
  let a;
  return a = typeof // For Compat types, we have to "extract" the underlying types before
  // performing validation.
  (t = $r(t)) == "string" || t instanceof mx ? Tve(o, "updateDoc", e._key, t, n, r) : Cve(o, "updateDoc", e._key, t), hq(i, [a.toMutation(e._key, rc.exists(!0))]);
}
function Zf(e, ...t) {
  var n, r, i;
  e = $r(e);
  let o = {
    includeMetadataChanges: !1,
    source: "default"
  }, a = 0;
  typeof t[a] != "object" || B7(t[a]) || (o = t[a++]);
  const s = {
    includeMetadataChanges: o.includeMetadataChanges,
    source: o.source
  };
  if (B7(t[a])) {
    const d = t[a];
    t[a] = (n = d.next) === null || n === void 0 ? void 0 : n.bind(d), t[a + 1] = (r = d.error) === null || r === void 0 ? void 0 : r.bind(d), t[a + 2] = (i = d.complete) === null || i === void 0 ? void 0 : i.bind(d);
  }
  let c, l, u;
  if (e instanceof Nr)
    l = Oo(e.firestore, sl), u = ax(e._key.path), c = {
      next: (d) => {
        t[a] && t[a](vP(l, e, d));
      },
      error: t[a + 1],
      complete: t[a + 2]
    };
  else {
    const d = Oo(e, As);
    l = Oo(d.firestore, sl), u = d._query;
    const f = new wx(l);
    c = {
      next: (h) => {
        t[a] && t[a](new kd(l, f, d, h));
      },
      error: t[a + 1],
      complete: t[a + 2]
    }, uq(e._query);
  }
  return function(f, h, p, g) {
    const m = new aP(g), v = new rP(h, m, p);
    return f.asyncQueue.enqueueAndForget(async () => eP(await N_(f), v)), () => {
      m.Ou(), f.asyncQueue.enqueueAndForget(async () => tP(await N_(f), v));
    };
  }(hp(l), u, s, c);
}
function hq(e, t) {
  return function(r, i) {
    const o = new tc();
    return r.asyncQueue.enqueueAndForget(async () => tve(await fve(r), i, o)), o.promise;
  }(hp(e), t);
}
function vP(e, t, n) {
  const r = n.docs.get(t._key), i = new wx(e);
  return new Md(e, i, t._key, r, new Bm(n.hasPendingWrites, n.fromCache), t.converter);
}
function kve(e) {
  return Nve(e, {
    count: Ove()
  });
}
function Nve(e, t) {
  const n = Oo(e.firestore, sl), r = hp(n), i = Bpe(t, (o, a) => new Sme(a, o.aggregateType, o._internalFieldPath));
  return pve(r, e._query, i).then((o) => (
    /**
    * Converts the core aggregation result to an `AggregateQuerySnapshot`
    * that can be returned to the consumer.
    * @param query
    * @param aggregateResult Core aggregation result
    * @internal
    */
    function(s, c, l) {
      const u = new wx(s);
      return new _ve(c, u, l);
    }(n, e, o)
  ));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function Dve() {
  return new Gv("deleteField");
}
(function(t, n = !0) {
  (function(i) {
    lp = i;
  })(ap), Ss(new Fa("firestore", (r, { instanceIdentifier: i, options: o }) => {
    const a = r.getProvider("app").getImmediate(), s = new sl(new Epe(r.getProvider("auth-internal")), new Ipe(a, r.getProvider("app-check-internal")), function(l, u) {
      if (!Object.prototype.hasOwnProperty.apply(l.options, ["projectId"]))
        throw new Ye(Se.INVALID_ARGUMENT, '"projectId" not provided in firebase.initializeApp.');
      return new B0(l.options.projectId, u);
    }(a, i), a);
    return o = Object.assign({
      useFetchStreams: n
    }, o), s._setSettings(o), s;
  }, "PUBLIC").setMultipleInstances(!0)), Jo(WD, qD, t), // BUILD_TARGET will be replaced by values like esm2017, cjs2017, etc during the compilation
  Jo(WD, qD, "esm2017");
})();
function gq(e, t = {}) {
  PU(
    e,
    t.hostname ?? window.location.hostname,
    t.port ?? 5001
  );
}
function Lve(e, t = {}) {
  rq(
    e,
    t.hostname ?? window.location.hostname,
    t.port ?? 8081
  );
}
function jve(e, t = {}) {
  hU(
    e,
    `http://${t.hostname ?? window.location.hostname}:${t.port ?? 9099}`,
    {
      disableWarnings: !0
    }
  );
}
class K_t extends kse {
  constructor(n, r, i, o) {
    super();
    ye(this, "functions");
    ye(this, "userSubject");
    // private initialisedUserSubject: Subject<OptionalUser> = new Subject<OptionalUser>()
    ye(this, "errorSubject", new Tz());
    ye(this, "auth");
    ye(this, "authUnsubscribe");
    ye(this, "log");
    ye(this, "provider");
    this.auth = tpe(n), this.functions = OU(n), this.log = i, this.log.info("VITE_USE_EMULATORS", r), this.log.info("VITE_AZURE_TENANT_ID", o), r && (jve(this.auth), gq(this.functions)), this.userSubject = new Vs({
      user: void 0,
      initialised: !1
    }), this.provider = new s0("microsoft.com"), this.provider.setCustomParameters({ tenant: o ?? "" });
  }
  async initialise() {
    this.log.info("FirebaseUserManagerService", "initialise"), this.authUnsubscribe = this.auth.onAuthStateChanged((n) => this.updateCurrentUser(n)), this.log.info("FirebaseUserManagerService", "initialised");
  }
  dispose() {
    this.authUnsubscribe && this.authUnsubscribe();
  }
  async updateCurrentUser(n) {
    if (this.log.info("updateCurrentUser", n), n === null)
      this.userSubject.next({
        user: void 0,
        initialised: !0
      });
    else
      try {
        const r = await n.getIdTokenResult(!0);
        this.log.info("idTokenResult", r), this.userSubject.next({
          user: this.getOptionalUserFromFirebaseUser(n, r),
          initialised: !0
        });
      } catch (r) {
        this.userSubject.error(r), this.recordError(r, "Failed to connect to Firebase  to check user token.");
      }
  }
  async updateCurrentUserFromUserRecord(n) {
    this.log.info("updateCurrentUserFromUserRecord", n), this.userSubject.next({
      user: this.getUserFromUserRecord(n),
      initialised: !0
    });
  }
  recordError(n, r) {
    this.log.error(`Auth error. ${r}`, { error: n }), this.errorSubject.next(n);
  }
  getUser() {
    if (this.log.info("getUser"), this.userSubject.value.initialised)
      return this.userSubject.value.user;
    throw new Error("User is not yet initialised");
  }
  observeUser() {
    return this.log.info("observeUser"), this.userSubject;
  }
  observeErrors() {
    return this.log.info("observeErrors"), this.errorSubject;
  }
  async login(n) {
    this.log.info("login");
    try {
      await Vhe(this.auth, n.email, n.password);
    } catch (r) {
      const i = r;
      this.log.error("Failed to log in.", { error: i }), this.errorSubject.next(i);
    }
  }
  async logout() {
    if (this.log.info("logout"), this.getUser())
      try {
        await Hhe(this.auth);
      } catch (n) {
        const r = n;
        this.log.error("Error attempting to log out.", { error: r });
      }
    else
      this.log.error("Tried to logout but no user logged in.");
  }
  async loginWithMicrosoftPopup() {
    this.log.info("loginWithMicrosoft");
    try {
      const r = await (await lge(this.auth, this.provider)).user.getIdTokenResult();
      if (typeof r.claims.admin != "boolean")
        throw new Error("Admin claim is not a boolean");
      return r.claims.admin;
    } catch (n) {
      throw this.log.error("Error logging in with Microsoft.", { context: n }), n;
    }
  }
  async loginWithMicrosoftRedirect() {
    this.log.info("loginWithMicrosoftRedirect");
    try {
      await pge(this.auth, this.provider);
    } catch (n) {
      this.recordError(n, "Error logging in with Microsoft.");
    }
  }
  getOptionalUserFromFirebaseUser(n, r) {
    return {
      id: n.uid,
      email: n.email,
      isAdmin: r ? !!r.claims.admin : !1,
      anonymous: n.isAnonymous,
      lastActive: n.metadata.lastSignInTime ? new Date(Date.parse(n.metadata.lastSignInTime)) : void 0,
      created: n.metadata.creationTime ? new Date(Date.parse(n.metadata.creationTime)) : void 0
    };
  }
  getUserFromUserRecord(n) {
    var r;
    return {
      id: n.uid,
      email: n.email ? n.email : null,
      isAdmin: (r = n.customClaims) == null ? void 0 : r.admin,
      anonymous: !1,
      lastActive: n.metadata.lastSignInTime ? new Date(Date.parse(n.metadata.lastSignInTime)) : void 0,
      created: n.metadata.creationTime ? new Date(Date.parse(n.metadata.creationTime)) : void 0
    };
  }
  // public async createUser(credentials: LoginCredentials): Promise<void> {
  //   if (credentials.password === '') {
  //     this.recordError(new Error('Password cannot be empty'), 'Password cannot be empty')
  //     return
  //   }
  //   try {
  //     await createUserWithEmailAndPassword(this.auth, credentials.email, credentials.password)
  //     const { data } = await this.assignUserRole()
  //     this.log.info('createUser', data)
  //     if (data) {
  //       this.updateCurrentUserFromUserRecord(data)
  //     }
  //   } catch (e) {
  //     this.recordError(e as Error, 'Error creating new user.')
  //   }
  // }
  // public async refreshUser(): Promise<void> {
  //   log.info('refreshUser', this.auth.currentUser)
  //   try {
  //     if (this.auth.currentUser) await this.updateCurrentUser(this.auth.currentUser)
  //   } catch (e) {
  //     this.recordError(e as Error, 'Error refreshing user')
  //   }
  // }
  async createAnonymousUser() {
    this.log.info("createAnonymousUser");
    try {
      await Nhe(this.auth);
    } catch (n) {
      this.recordError(n, "Error creating new anonymous user.");
    }
  }
  createUserProfile(n) {
  }
  // public async verifyUserEmail() {
  //   try {
  //     const user = this.auth.currentUser
  //     if (user) {
  //       await sendEmailVerification(user)
  //     } else {
  //       throw new Error('Tried to send email verification, but no user loggedn in.')
  //     }
  //   } catch (e) {
  //     this.recordError(e as Error)
  //   }
  // }
  resetPassword(n) {
    this.errorSubject.next(new Error("Password reset email sent"));
  }
  // public hasAccess(path: string | readonly string[] | undefined): boolean {
  //   if (this.userSubject.value.initialised) {
  //     const user = this.userSubject.value.user
  //     switch (path) {
  //       case adminPaths.dashboard:
  //         return !!user && !user.anonymous
  //       default:
  //         return false
  //     }
  //   }
  //   return false
  // }
}
const Fve = {
  "Amazon Silk": "amazon_silk",
  "Android Browser": "android",
  Bada: "bada",
  BlackBerry: "blackberry",
  Chrome: "chrome",
  Chromium: "chromium",
  Electron: "electron",
  Epiphany: "epiphany",
  Firefox: "firefox",
  Focus: "focus",
  Generic: "generic",
  "Google Search": "google_search",
  Googlebot: "googlebot",
  "Internet Explorer": "ie",
  "K-Meleon": "k_meleon",
  Maxthon: "maxthon",
  "Microsoft Edge": "edge",
  "MZ Browser": "mz",
  "NAVER Whale Browser": "naver",
  Opera: "opera",
  "Opera Coast": "opera_coast",
  PhantomJS: "phantomjs",
  Puffin: "puffin",
  QupZilla: "qupzilla",
  QQ: "qq",
  QQLite: "qqlite",
  Safari: "safari",
  Sailfish: "sailfish",
  "Samsung Internet for Android": "samsung_internet",
  SeaMonkey: "seamonkey",
  Sleipnir: "sleipnir",
  Swing: "swing",
  Tizen: "tizen",
  "UC Browser": "uc",
  Vivaldi: "vivaldi",
  "WebOS Browser": "webos",
  WeChat: "wechat",
  "Yandex Browser": "yandex",
  Roku: "roku"
}, pq = {
  amazon_silk: "Amazon Silk",
  android: "Android Browser",
  bada: "Bada",
  blackberry: "BlackBerry",
  chrome: "Chrome",
  chromium: "Chromium",
  electron: "Electron",
  epiphany: "Epiphany",
  firefox: "Firefox",
  focus: "Focus",
  generic: "Generic",
  googlebot: "Googlebot",
  google_search: "Google Search",
  ie: "Internet Explorer",
  k_meleon: "K-Meleon",
  maxthon: "Maxthon",
  edge: "Microsoft Edge",
  mz: "MZ Browser",
  naver: "NAVER Whale Browser",
  opera: "Opera",
  opera_coast: "Opera Coast",
  phantomjs: "PhantomJS",
  puffin: "Puffin",
  qupzilla: "QupZilla",
  qq: "QQ Browser",
  qqlite: "QQ Browser Lite",
  safari: "Safari",
  sailfish: "Sailfish",
  samsung_internet: "Samsung Internet for Android",
  seamonkey: "SeaMonkey",
  sleipnir: "Sleipnir",
  swing: "Swing",
  tizen: "Tizen",
  uc: "UC Browser",
  vivaldi: "Vivaldi",
  webos: "WebOS Browser",
  wechat: "WeChat",
  yandex: "Yandex Browser"
}, Jr = {
  tablet: "tablet",
  mobile: "mobile",
  desktop: "desktop",
  tv: "tv"
}, yo = {
  WindowsPhone: "Windows Phone",
  Windows: "Windows",
  MacOS: "macOS",
  iOS: "iOS",
  Android: "Android",
  WebOS: "WebOS",
  BlackBerry: "BlackBerry",
  Bada: "Bada",
  Tizen: "Tizen",
  Linux: "Linux",
  ChromeOS: "Chrome OS",
  PlayStation4: "PlayStation 4",
  Roku: "Roku"
}, Al = {
  EdgeHTML: "EdgeHTML",
  Blink: "Blink",
  Trident: "Trident",
  Presto: "Presto",
  Gecko: "Gecko",
  WebKit: "WebKit"
};
class Re {
  /**
   * Get first matched item for a string
   * @param {RegExp} regexp
   * @param {String} ua
   * @return {Array|{index: number, input: string}|*|boolean|string}
   */
  static getFirstMatch(t, n) {
    const r = n.match(t);
    return r && r.length > 0 && r[1] || "";
  }
  /**
   * Get second matched item for a string
   * @param regexp
   * @param {String} ua
   * @return {Array|{index: number, input: string}|*|boolean|string}
   */
  static getSecondMatch(t, n) {
    const r = n.match(t);
    return r && r.length > 1 && r[2] || "";
  }
  /**
   * Match a regexp and return a constant or undefined
   * @param {RegExp} regexp
   * @param {String} ua
   * @param {*} _const Any const that will be returned if regexp matches the string
   * @return {*}
   */
  static matchAndReturnConst(t, n, r) {
    if (t.test(n))
      return r;
  }
  static getWindowsVersionName(t) {
    switch (t) {
      case "NT":
        return "NT";
      case "XP":
        return "XP";
      case "NT 5.0":
        return "2000";
      case "NT 5.1":
        return "XP";
      case "NT 5.2":
        return "2003";
      case "NT 6.0":
        return "Vista";
      case "NT 6.1":
        return "7";
      case "NT 6.2":
        return "8";
      case "NT 6.3":
        return "8.1";
      case "NT 10.0":
        return "10";
      default:
        return;
    }
  }
  /**
   * Get macOS version name
   *    10.5 - Leopard
   *    10.6 - Snow Leopard
   *    10.7 - Lion
   *    10.8 - Mountain Lion
   *    10.9 - Mavericks
   *    10.10 - Yosemite
   *    10.11 - El Capitan
   *    10.12 - Sierra
   *    10.13 - High Sierra
   *    10.14 - Mojave
   *    10.15 - Catalina
   *
   * @example
   *   getMacOSVersionName("10.14") // 'Mojave'
   *
   * @param  {string} version
   * @return {string} versionName
   */
  static getMacOSVersionName(t) {
    const n = t.split(".").splice(0, 2).map((r) => parseInt(r, 10) || 0);
    if (n.push(0), n[0] === 10)
      switch (n[1]) {
        case 5:
          return "Leopard";
        case 6:
          return "Snow Leopard";
        case 7:
          return "Lion";
        case 8:
          return "Mountain Lion";
        case 9:
          return "Mavericks";
        case 10:
          return "Yosemite";
        case 11:
          return "El Capitan";
        case 12:
          return "Sierra";
        case 13:
          return "High Sierra";
        case 14:
          return "Mojave";
        case 15:
          return "Catalina";
        default:
          return;
      }
  }
  /**
   * Get Android version name
   *    1.5 - Cupcake
   *    1.6 - Donut
   *    2.0 - Eclair
   *    2.1 - Eclair
   *    2.2 - Froyo
   *    2.x - Gingerbread
   *    3.x - Honeycomb
   *    4.0 - Ice Cream Sandwich
   *    4.1 - Jelly Bean
   *    4.4 - KitKat
   *    5.x - Lollipop
   *    6.x - Marshmallow
   *    7.x - Nougat
   *    8.x - Oreo
   *    9.x - Pie
   *
   * @example
   *   getAndroidVersionName("7.0") // 'Nougat'
   *
   * @param  {string} version
   * @return {string} versionName
   */
  static getAndroidVersionName(t) {
    const n = t.split(".").splice(0, 2).map((r) => parseInt(r, 10) || 0);
    if (n.push(0), !(n[0] === 1 && n[1] < 5)) {
      if (n[0] === 1 && n[1] < 6)
        return "Cupcake";
      if (n[0] === 1 && n[1] >= 6)
        return "Donut";
      if (n[0] === 2 && n[1] < 2)
        return "Eclair";
      if (n[0] === 2 && n[1] === 2)
        return "Froyo";
      if (n[0] === 2 && n[1] > 2)
        return "Gingerbread";
      if (n[0] === 3)
        return "Honeycomb";
      if (n[0] === 4 && n[1] < 1)
        return "Ice Cream Sandwich";
      if (n[0] === 4 && n[1] < 4)
        return "Jelly Bean";
      if (n[0] === 4 && n[1] >= 4)
        return "KitKat";
      if (n[0] === 5)
        return "Lollipop";
      if (n[0] === 6)
        return "Marshmallow";
      if (n[0] === 7)
        return "Nougat";
      if (n[0] === 8)
        return "Oreo";
      if (n[0] === 9)
        return "Pie";
    }
  }
  /**
   * Get version precisions count
   *
   * @example
   *   getVersionPrecision("1.10.3") // 3
   *
   * @param  {string} version
   * @return {number}
   */
  static getVersionPrecision(t) {
    return t.split(".").length;
  }
  /**
   * Calculate browser version weight
   *
   * @example
   *   compareVersions('1.10.2.1',  '1.8.2.1.90')    // 1
   *   compareVersions('1.010.2.1', '1.09.2.1.90');  // 1
   *   compareVersions('1.10.2.1',  '1.10.2.1');     // 0
   *   compareVersions('1.10.2.1',  '1.0800.2');     // -1
   *   compareVersions('1.10.2.1',  '1.10',  true);  // 0
   *
   * @param {String} versionA versions versions to compare
   * @param {String} versionB versions versions to compare
   * @param {boolean} [isLoose] enable loose comparison
   * @return {Number} comparison result: -1 when versionA is lower,
   * 1 when versionA is bigger, 0 when both equal
   */
  /* eslint consistent-return: 1 */
  static compareVersions(t, n, r = !1) {
    const i = Re.getVersionPrecision(t), o = Re.getVersionPrecision(n);
    let a = Math.max(i, o), s = 0;
    const c = Re.map([t, n], (l) => {
      const u = a - Re.getVersionPrecision(l), d = l + new Array(u + 1).join(".0");
      return Re.map(d.split("."), (f) => new Array(20 - f.length).join("0") + f).reverse();
    });
    for (r && (s = a - Math.min(i, o)), a -= 1; a >= s; ) {
      if (c[0][a] > c[1][a])
        return 1;
      if (c[0][a] === c[1][a]) {
        if (a === s)
          return 0;
        a -= 1;
      } else if (c[0][a] < c[1][a])
        return -1;
    }
  }
  /**
   * Array::map polyfill
   *
   * @param  {Array} arr
   * @param  {Function} iterator
   * @return {Array}
   */
  static map(t, n) {
    const r = [];
    let i;
    if (Array.prototype.map)
      return Array.prototype.map.call(t, n);
    for (i = 0; i < t.length; i += 1)
      r.push(n(t[i]));
    return r;
  }
  /**
   * Array::find polyfill
   *
   * @param  {Array} arr
   * @param  {Function} predicate
   * @return {Array}
   */
  static find(t, n) {
    let r, i;
    if (Array.prototype.find)
      return Array.prototype.find.call(t, n);
    for (r = 0, i = t.length; r < i; r += 1) {
      const o = t[r];
      if (n(o, r))
        return o;
    }
  }
  /**
   * Object::assign polyfill
   *
   * @param  {Object} obj
   * @param  {Object} ...objs
   * @return {Object}
   */
  static assign(t, ...n) {
    const r = t;
    let i, o;
    if (Object.assign)
      return Object.assign(t, ...n);
    for (i = 0, o = n.length; i < o; i += 1) {
      const a = n[i];
      typeof a == "object" && a !== null && Object.keys(a).forEach((c) => {
        r[c] = a[c];
      });
    }
    return t;
  }
  /**
   * Get short version/alias for a browser name
   *
   * @example
   *   getBrowserAlias('Microsoft Edge') // edge
   *
   * @param  {string} browserName
   * @return {string}
   */
  static getBrowserAlias(t) {
    return Fve[t];
  }
  /**
   * Get short version/alias for a browser name
   *
   * @example
   *   getBrowserAlias('edge') // Microsoft Edge
   *
   * @param  {string} browserAlias
   * @return {string}
   */
  static getBrowserTypeByAlias(t) {
    return pq[t] || "";
  }
}
const Zn = /version\/(\d+(\.?_?\d+)+)/i, Vve = [
  /* Googlebot */
  {
    test: [/googlebot/i],
    describe(e) {
      const t = {
        name: "Googlebot"
      }, n = Re.getFirstMatch(/googlebot\/(\d+(\.\d+))/i, e) || Re.getFirstMatch(Zn, e);
      return n && (t.version = n), t;
    }
  },
  /* Opera < 13.0 */
  {
    test: [/opera/i],
    describe(e) {
      const t = {
        name: "Opera"
      }, n = Re.getFirstMatch(Zn, e) || Re.getFirstMatch(/(?:opera)[\s/](\d+(\.?_?\d+)+)/i, e);
      return n && (t.version = n), t;
    }
  },
  /* Opera > 13.0 */
  {
    test: [/opr\/|opios/i],
    describe(e) {
      const t = {
        name: "Opera"
      }, n = Re.getFirstMatch(/(?:opr|opios)[\s/](\S+)/i, e) || Re.getFirstMatch(Zn, e);
      return n && (t.version = n), t;
    }
  },
  {
    test: [/SamsungBrowser/i],
    describe(e) {
      const t = {
        name: "Samsung Internet for Android"
      }, n = Re.getFirstMatch(Zn, e) || Re.getFirstMatch(/(?:SamsungBrowser)[\s/](\d+(\.?_?\d+)+)/i, e);
      return n && (t.version = n), t;
    }
  },
  {
    test: [/Whale/i],
    describe(e) {
      const t = {
        name: "NAVER Whale Browser"
      }, n = Re.getFirstMatch(Zn, e) || Re.getFirstMatch(/(?:whale)[\s/](\d+(?:\.\d+)+)/i, e);
      return n && (t.version = n), t;
    }
  },
  {
    test: [/MZBrowser/i],
    describe(e) {
      const t = {
        name: "MZ Browser"
      }, n = Re.getFirstMatch(/(?:MZBrowser)[\s/](\d+(?:\.\d+)+)/i, e) || Re.getFirstMatch(Zn, e);
      return n && (t.version = n), t;
    }
  },
  {
    test: [/focus/i],
    describe(e) {
      const t = {
        name: "Focus"
      }, n = Re.getFirstMatch(/(?:focus)[\s/](\d+(?:\.\d+)+)/i, e) || Re.getFirstMatch(Zn, e);
      return n && (t.version = n), t;
    }
  },
  {
    test: [/swing/i],
    describe(e) {
      const t = {
        name: "Swing"
      }, n = Re.getFirstMatch(/(?:swing)[\s/](\d+(?:\.\d+)+)/i, e) || Re.getFirstMatch(Zn, e);
      return n && (t.version = n), t;
    }
  },
  {
    test: [/coast/i],
    describe(e) {
      const t = {
        name: "Opera Coast"
      }, n = Re.getFirstMatch(Zn, e) || Re.getFirstMatch(/(?:coast)[\s/](\d+(\.?_?\d+)+)/i, e);
      return n && (t.version = n), t;
    }
  },
  {
    test: [/opt\/\d+(?:.?_?\d+)+/i],
    describe(e) {
      const t = {
        name: "Opera Touch"
      }, n = Re.getFirstMatch(/(?:opt)[\s/](\d+(\.?_?\d+)+)/i, e) || Re.getFirstMatch(Zn, e);
      return n && (t.version = n), t;
    }
  },
  {
    test: [/yabrowser/i],
    describe(e) {
      const t = {
        name: "Yandex Browser"
      }, n = Re.getFirstMatch(/(?:yabrowser)[\s/](\d+(\.?_?\d+)+)/i, e) || Re.getFirstMatch(Zn, e);
      return n && (t.version = n), t;
    }
  },
  {
    test: [/ucbrowser/i],
    describe(e) {
      const t = {
        name: "UC Browser"
      }, n = Re.getFirstMatch(Zn, e) || Re.getFirstMatch(/(?:ucbrowser)[\s/](\d+(\.?_?\d+)+)/i, e);
      return n && (t.version = n), t;
    }
  },
  {
    test: [/Maxthon|mxios/i],
    describe(e) {
      const t = {
        name: "Maxthon"
      }, n = Re.getFirstMatch(Zn, e) || Re.getFirstMatch(/(?:Maxthon|mxios)[\s/](\d+(\.?_?\d+)+)/i, e);
      return n && (t.version = n), t;
    }
  },
  {
    test: [/epiphany/i],
    describe(e) {
      const t = {
        name: "Epiphany"
      }, n = Re.getFirstMatch(Zn, e) || Re.getFirstMatch(/(?:epiphany)[\s/](\d+(\.?_?\d+)+)/i, e);
      return n && (t.version = n), t;
    }
  },
  {
    test: [/puffin/i],
    describe(e) {
      const t = {
        name: "Puffin"
      }, n = Re.getFirstMatch(Zn, e) || Re.getFirstMatch(/(?:puffin)[\s/](\d+(\.?_?\d+)+)/i, e);
      return n && (t.version = n), t;
    }
  },
  {
    test: [/sleipnir/i],
    describe(e) {
      const t = {
        name: "Sleipnir"
      }, n = Re.getFirstMatch(Zn, e) || Re.getFirstMatch(/(?:sleipnir)[\s/](\d+(\.?_?\d+)+)/i, e);
      return n && (t.version = n), t;
    }
  },
  {
    test: [/k-meleon/i],
    describe(e) {
      const t = {
        name: "K-Meleon"
      }, n = Re.getFirstMatch(Zn, e) || Re.getFirstMatch(/(?:k-meleon)[\s/](\d+(\.?_?\d+)+)/i, e);
      return n && (t.version = n), t;
    }
  },
  {
    test: [/micromessenger/i],
    describe(e) {
      const t = {
        name: "WeChat"
      }, n = Re.getFirstMatch(/(?:micromessenger)[\s/](\d+(\.?_?\d+)+)/i, e) || Re.getFirstMatch(Zn, e);
      return n && (t.version = n), t;
    }
  },
  {
    test: [/qqbrowser/i],
    describe(e) {
      const t = {
        name: /qqbrowserlite/i.test(e) ? "QQ Browser Lite" : "QQ Browser"
      }, n = Re.getFirstMatch(/(?:qqbrowserlite|qqbrowser)[/](\d+(\.?_?\d+)+)/i, e) || Re.getFirstMatch(Zn, e);
      return n && (t.version = n), t;
    }
  },
  {
    test: [/msie|trident/i],
    describe(e) {
      const t = {
        name: "Internet Explorer"
      }, n = Re.getFirstMatch(/(?:msie |rv:)(\d+(\.?_?\d+)+)/i, e);
      return n && (t.version = n), t;
    }
  },
  {
    test: [/\sedg\//i],
    describe(e) {
      const t = {
        name: "Microsoft Edge"
      }, n = Re.getFirstMatch(/\sedg\/(\d+(\.?_?\d+)+)/i, e);
      return n && (t.version = n), t;
    }
  },
  {
    test: [/edg([ea]|ios)/i],
    describe(e) {
      const t = {
        name: "Microsoft Edge"
      }, n = Re.getSecondMatch(/edg([ea]|ios)\/(\d+(\.?_?\d+)+)/i, e);
      return n && (t.version = n), t;
    }
  },
  {
    test: [/vivaldi/i],
    describe(e) {
      const t = {
        name: "Vivaldi"
      }, n = Re.getFirstMatch(/vivaldi\/(\d+(\.?_?\d+)+)/i, e);
      return n && (t.version = n), t;
    }
  },
  {
    test: [/seamonkey/i],
    describe(e) {
      const t = {
        name: "SeaMonkey"
      }, n = Re.getFirstMatch(/seamonkey\/(\d+(\.?_?\d+)+)/i, e);
      return n && (t.version = n), t;
    }
  },
  {
    test: [/sailfish/i],
    describe(e) {
      const t = {
        name: "Sailfish"
      }, n = Re.getFirstMatch(/sailfish\s?browser\/(\d+(\.\d+)?)/i, e);
      return n && (t.version = n), t;
    }
  },
  {
    test: [/silk/i],
    describe(e) {
      const t = {
        name: "Amazon Silk"
      }, n = Re.getFirstMatch(/silk\/(\d+(\.?_?\d+)+)/i, e);
      return n && (t.version = n), t;
    }
  },
  {
    test: [/phantom/i],
    describe(e) {
      const t = {
        name: "PhantomJS"
      }, n = Re.getFirstMatch(/phantomjs\/(\d+(\.?_?\d+)+)/i, e);
      return n && (t.version = n), t;
    }
  },
  {
    test: [/slimerjs/i],
    describe(e) {
      const t = {
        name: "SlimerJS"
      }, n = Re.getFirstMatch(/slimerjs\/(\d+(\.?_?\d+)+)/i, e);
      return n && (t.version = n), t;
    }
  },
  {
    test: [/blackberry|\bbb\d+/i, /rim\stablet/i],
    describe(e) {
      const t = {
        name: "BlackBerry"
      }, n = Re.getFirstMatch(Zn, e) || Re.getFirstMatch(/blackberry[\d]+\/(\d+(\.?_?\d+)+)/i, e);
      return n && (t.version = n), t;
    }
  },
  {
    test: [/(web|hpw)[o0]s/i],
    describe(e) {
      const t = {
        name: "WebOS Browser"
      }, n = Re.getFirstMatch(Zn, e) || Re.getFirstMatch(/w(?:eb)?[o0]sbrowser\/(\d+(\.?_?\d+)+)/i, e);
      return n && (t.version = n), t;
    }
  },
  {
    test: [/bada/i],
    describe(e) {
      const t = {
        name: "Bada"
      }, n = Re.getFirstMatch(/dolfin\/(\d+(\.?_?\d+)+)/i, e);
      return n && (t.version = n), t;
    }
  },
  {
    test: [/tizen/i],
    describe(e) {
      const t = {
        name: "Tizen"
      }, n = Re.getFirstMatch(/(?:tizen\s?)?browser\/(\d+(\.?_?\d+)+)/i, e) || Re.getFirstMatch(Zn, e);
      return n && (t.version = n), t;
    }
  },
  {
    test: [/qupzilla/i],
    describe(e) {
      const t = {
        name: "QupZilla"
      }, n = Re.getFirstMatch(/(?:qupzilla)[\s/](\d+(\.?_?\d+)+)/i, e) || Re.getFirstMatch(Zn, e);
      return n && (t.version = n), t;
    }
  },
  {
    test: [/firefox|iceweasel|fxios/i],
    describe(e) {
      const t = {
        name: "Firefox"
      }, n = Re.getFirstMatch(/(?:firefox|iceweasel|fxios)[\s/](\d+(\.?_?\d+)+)/i, e);
      return n && (t.version = n), t;
    }
  },
  {
    test: [/electron/i],
    describe(e) {
      const t = {
        name: "Electron"
      }, n = Re.getFirstMatch(/(?:electron)\/(\d+(\.?_?\d+)+)/i, e);
      return n && (t.version = n), t;
    }
  },
  {
    test: [/MiuiBrowser/i],
    describe(e) {
      const t = {
        name: "Miui"
      }, n = Re.getFirstMatch(/(?:MiuiBrowser)[\s/](\d+(\.?_?\d+)+)/i, e);
      return n && (t.version = n), t;
    }
  },
  {
    test: [/chromium/i],
    describe(e) {
      const t = {
        name: "Chromium"
      }, n = Re.getFirstMatch(/(?:chromium)[\s/](\d+(\.?_?\d+)+)/i, e) || Re.getFirstMatch(Zn, e);
      return n && (t.version = n), t;
    }
  },
  {
    test: [/chrome|crios|crmo/i],
    describe(e) {
      const t = {
        name: "Chrome"
      }, n = Re.getFirstMatch(/(?:chrome|crios|crmo)\/(\d+(\.?_?\d+)+)/i, e);
      return n && (t.version = n), t;
    }
  },
  {
    test: [/GSA/i],
    describe(e) {
      const t = {
        name: "Google Search"
      }, n = Re.getFirstMatch(/(?:GSA)\/(\d+(\.?_?\d+)+)/i, e);
      return n && (t.version = n), t;
    }
  },
  /* Android Browser */
  {
    test(e) {
      const t = !e.test(/like android/i), n = e.test(/android/i);
      return t && n;
    },
    describe(e) {
      const t = {
        name: "Android Browser"
      }, n = Re.getFirstMatch(Zn, e);
      return n && (t.version = n), t;
    }
  },
  /* PlayStation 4 */
  {
    test: [/playstation 4/i],
    describe(e) {
      const t = {
        name: "PlayStation 4"
      }, n = Re.getFirstMatch(Zn, e);
      return n && (t.version = n), t;
    }
  },
  /* Safari */
  {
    test: [/safari|applewebkit/i],
    describe(e) {
      const t = {
        name: "Safari"
      }, n = Re.getFirstMatch(Zn, e);
      return n && (t.version = n), t;
    }
  },
  /* Something else */
  {
    test: [/.*/i],
    describe(e) {
      const t = /^(.*)\/(.*) /, n = /^(.*)\/(.*)[ \t]\((.*)/, i = e.search("\\(") !== -1 ? n : t;
      return {
        name: Re.getFirstMatch(i, e),
        version: Re.getSecondMatch(i, e)
      };
    }
  }
], Bve = [
  /* Roku */
  {
    test: [/Roku\/DVP/],
    describe(e) {
      const t = Re.getFirstMatch(/Roku\/DVP-(\d+\.\d+)/i, e);
      return {
        name: yo.Roku,
        version: t
      };
    }
  },
  /* Windows Phone */
  {
    test: [/windows phone/i],
    describe(e) {
      const t = Re.getFirstMatch(/windows phone (?:os)?\s?(\d+(\.\d+)*)/i, e);
      return {
        name: yo.WindowsPhone,
        version: t
      };
    }
  },
  /* Windows */
  {
    test: [/windows /i],
    describe(e) {
      const t = Re.getFirstMatch(/Windows ((NT|XP)( \d\d?.\d)?)/i, e), n = Re.getWindowsVersionName(t);
      return {
        name: yo.Windows,
        version: t,
        versionName: n
      };
    }
  },
  /* Firefox on iPad */
  {
    test: [/Macintosh(.*?) FxiOS(.*?)\//],
    describe(e) {
      const t = {
        name: yo.iOS
      }, n = Re.getSecondMatch(/(Version\/)(\d[\d.]+)/, e);
      return n && (t.version = n), t;
    }
  },
  /* macOS */
  {
    test: [/macintosh/i],
    describe(e) {
      const t = Re.getFirstMatch(/mac os x (\d+(\.?_?\d+)+)/i, e).replace(/[_\s]/g, "."), n = Re.getMacOSVersionName(t), r = {
        name: yo.MacOS,
        version: t
      };
      return n && (r.versionName = n), r;
    }
  },
  /* iOS */
  {
    test: [/(ipod|iphone|ipad)/i],
    describe(e) {
      const t = Re.getFirstMatch(/os (\d+([_\s]\d+)*) like mac os x/i, e).replace(/[_\s]/g, ".");
      return {
        name: yo.iOS,
        version: t
      };
    }
  },
  /* Android */
  {
    test(e) {
      const t = !e.test(/like android/i), n = e.test(/android/i);
      return t && n;
    },
    describe(e) {
      const t = Re.getFirstMatch(/android[\s/-](\d+(\.\d+)*)/i, e), n = Re.getAndroidVersionName(t), r = {
        name: yo.Android,
        version: t
      };
      return n && (r.versionName = n), r;
    }
  },
  /* WebOS */
  {
    test: [/(web|hpw)[o0]s/i],
    describe(e) {
      const t = Re.getFirstMatch(/(?:web|hpw)[o0]s\/(\d+(\.\d+)*)/i, e), n = {
        name: yo.WebOS
      };
      return t && t.length && (n.version = t), n;
    }
  },
  /* BlackBerry */
  {
    test: [/blackberry|\bbb\d+/i, /rim\stablet/i],
    describe(e) {
      const t = Re.getFirstMatch(/rim\stablet\sos\s(\d+(\.\d+)*)/i, e) || Re.getFirstMatch(/blackberry\d+\/(\d+([_\s]\d+)*)/i, e) || Re.getFirstMatch(/\bbb(\d+)/i, e);
      return {
        name: yo.BlackBerry,
        version: t
      };
    }
  },
  /* Bada */
  {
    test: [/bada/i],
    describe(e) {
      const t = Re.getFirstMatch(/bada\/(\d+(\.\d+)*)/i, e);
      return {
        name: yo.Bada,
        version: t
      };
    }
  },
  /* Tizen */
  {
    test: [/tizen/i],
    describe(e) {
      const t = Re.getFirstMatch(/tizen[/\s](\d+(\.\d+)*)/i, e);
      return {
        name: yo.Tizen,
        version: t
      };
    }
  },
  /* Linux */
  {
    test: [/linux/i],
    describe() {
      return {
        name: yo.Linux
      };
    }
  },
  /* Chrome OS */
  {
    test: [/CrOS/],
    describe() {
      return {
        name: yo.ChromeOS
      };
    }
  },
  /* Playstation 4 */
  {
    test: [/PlayStation 4/],
    describe(e) {
      const t = Re.getFirstMatch(/PlayStation 4[/\s](\d+(\.\d+)*)/i, e);
      return {
        name: yo.PlayStation4,
        version: t
      };
    }
  }
], zve = [
  /* Googlebot */
  {
    test: [/googlebot/i],
    describe() {
      return {
        type: "bot",
        vendor: "Google"
      };
    }
  },
  /* Huawei */
  {
    test: [/huawei/i],
    describe(e) {
      const t = Re.getFirstMatch(/(can-l01)/i, e) && "Nova", n = {
        type: Jr.mobile,
        vendor: "Huawei"
      };
      return t && (n.model = t), n;
    }
  },
  /* Nexus Tablet */
  {
    test: [/nexus\s*(?:7|8|9|10).*/i],
    describe() {
      return {
        type: Jr.tablet,
        vendor: "Nexus"
      };
    }
  },
  /* iPad */
  {
    test: [/ipad/i],
    describe() {
      return {
        type: Jr.tablet,
        vendor: "Apple",
        model: "iPad"
      };
    }
  },
  /* Firefox on iPad */
  {
    test: [/Macintosh(.*?) FxiOS(.*?)\//],
    describe() {
      return {
        type: Jr.tablet,
        vendor: "Apple",
        model: "iPad"
      };
    }
  },
  /* Amazon Kindle Fire */
  {
    test: [/kftt build/i],
    describe() {
      return {
        type: Jr.tablet,
        vendor: "Amazon",
        model: "Kindle Fire HD 7"
      };
    }
  },
  /* Another Amazon Tablet with Silk */
  {
    test: [/silk/i],
    describe() {
      return {
        type: Jr.tablet,
        vendor: "Amazon"
      };
    }
  },
  /* Tablet */
  {
    test: [/tablet(?! pc)/i],
    describe() {
      return {
        type: Jr.tablet
      };
    }
  },
  /* iPod/iPhone */
  {
    test(e) {
      const t = e.test(/ipod|iphone/i), n = e.test(/like (ipod|iphone)/i);
      return t && !n;
    },
    describe(e) {
      const t = Re.getFirstMatch(/(ipod|iphone)/i, e);
      return {
        type: Jr.mobile,
        vendor: "Apple",
        model: t
      };
    }
  },
  /* Nexus Mobile */
  {
    test: [/nexus\s*[0-6].*/i, /galaxy nexus/i],
    describe() {
      return {
        type: Jr.mobile,
        vendor: "Nexus"
      };
    }
  },
  /* Mobile */
  {
    test: [/[^-]mobi/i],
    describe() {
      return {
        type: Jr.mobile
      };
    }
  },
  /* BlackBerry */
  {
    test(e) {
      return e.getBrowserName(!0) === "blackberry";
    },
    describe() {
      return {
        type: Jr.mobile,
        vendor: "BlackBerry"
      };
    }
  },
  /* Bada */
  {
    test(e) {
      return e.getBrowserName(!0) === "bada";
    },
    describe() {
      return {
        type: Jr.mobile
      };
    }
  },
  /* Windows Phone */
  {
    test(e) {
      return e.getBrowserName() === "windows phone";
    },
    describe() {
      return {
        type: Jr.mobile,
        vendor: "Microsoft"
      };
    }
  },
  /* Android Tablet */
  {
    test(e) {
      const t = Number(String(e.getOSVersion()).split(".")[0]);
      return e.getOSName(!0) === "android" && t >= 3;
    },
    describe() {
      return {
        type: Jr.tablet
      };
    }
  },
  /* Android Mobile */
  {
    test(e) {
      return e.getOSName(!0) === "android";
    },
    describe() {
      return {
        type: Jr.mobile
      };
    }
  },
  /* desktop */
  {
    test(e) {
      return e.getOSName(!0) === "macos";
    },
    describe() {
      return {
        type: Jr.desktop,
        vendor: "Apple"
      };
    }
  },
  /* Windows */
  {
    test(e) {
      return e.getOSName(!0) === "windows";
    },
    describe() {
      return {
        type: Jr.desktop
      };
    }
  },
  /* Linux */
  {
    test(e) {
      return e.getOSName(!0) === "linux";
    },
    describe() {
      return {
        type: Jr.desktop
      };
    }
  },
  /* PlayStation 4 */
  {
    test(e) {
      return e.getOSName(!0) === "playstation 4";
    },
    describe() {
      return {
        type: Jr.tv
      };
    }
  },
  /* Roku */
  {
    test(e) {
      return e.getOSName(!0) === "roku";
    },
    describe() {
      return {
        type: Jr.tv
      };
    }
  }
], Hve = [
  /* EdgeHTML */
  {
    test(e) {
      return e.getBrowserName(!0) === "microsoft edge";
    },
    describe(e) {
      if (/\sedg\//i.test(e))
        return {
          name: Al.Blink
        };
      const n = Re.getFirstMatch(/edge\/(\d+(\.?_?\d+)+)/i, e);
      return {
        name: Al.EdgeHTML,
        version: n
      };
    }
  },
  /* Trident */
  {
    test: [/trident/i],
    describe(e) {
      const t = {
        name: Al.Trident
      }, n = Re.getFirstMatch(/trident\/(\d+(\.?_?\d+)+)/i, e);
      return n && (t.version = n), t;
    }
  },
  /* Presto */
  {
    test(e) {
      return e.test(/presto/i);
    },
    describe(e) {
      const t = {
        name: Al.Presto
      }, n = Re.getFirstMatch(/presto\/(\d+(\.?_?\d+)+)/i, e);
      return n && (t.version = n), t;
    }
  },
  /* Gecko */
  {
    test(e) {
      const t = e.test(/gecko/i), n = e.test(/like gecko/i);
      return t && !n;
    },
    describe(e) {
      const t = {
        name: Al.Gecko
      }, n = Re.getFirstMatch(/gecko\/(\d+(\.?_?\d+)+)/i, e);
      return n && (t.version = n), t;
    }
  },
  /* Blink */
  {
    test: [/(apple)?webkit\/537\.36/i],
    describe() {
      return {
        name: Al.Blink
      };
    }
  },
  /* WebKit */
  {
    test: [/(apple)?webkit/i],
    describe(e) {
      const t = {
        name: Al.WebKit
      }, n = Re.getFirstMatch(/webkit\/(\d+(\.?_?\d+)+)/i, e);
      return n && (t.version = n), t;
    }
  }
];
class K7 {
  /**
   * Create instance of Parser
   *
   * @param {String} UA User-Agent string
   * @param {Boolean} [skipParsing=false] parser can skip parsing in purpose of performance
   * improvements if you need to make a more particular parsing
   * like {@link Parser#parseBrowser} or {@link Parser#parsePlatform}
   *
   * @throw {Error} in case of empty UA String
   *
   * @constructor
   */
  constructor(t, n = !1) {
    if (t == null || t === "")
      throw new Error("UserAgent parameter can't be empty");
    this._ua = t, this.parsedResult = {}, n !== !0 && this.parse();
  }
  /**
   * Get UserAgent string of current Parser instance
   * @return {String} User-Agent String of the current <Parser> object
   *
   * @public
   */
  getUA() {
    return this._ua;
  }
  /**
   * Test a UA string for a regexp
   * @param {RegExp} regex
   * @return {Boolean}
   */
  test(t) {
    return t.test(this._ua);
  }
  /**
   * Get parsed browser object
   * @return {Object}
   */
  parseBrowser() {
    this.parsedResult.browser = {};
    const t = Re.find(Vve, (n) => {
      if (typeof n.test == "function")
        return n.test(this);
      if (n.test instanceof Array)
        return n.test.some((r) => this.test(r));
      throw new Error("Browser's test function is not valid");
    });
    return t && (this.parsedResult.browser = t.describe(this.getUA())), this.parsedResult.browser;
  }
  /**
   * Get parsed browser object
   * @return {Object}
   *
   * @public
   */
  getBrowser() {
    return this.parsedResult.browser ? this.parsedResult.browser : this.parseBrowser();
  }
  /**
   * Get browser's name
   * @return {String} Browser's name or an empty string
   *
   * @public
   */
  getBrowserName(t) {
    return t ? String(this.getBrowser().name).toLowerCase() || "" : this.getBrowser().name || "";
  }
  /**
   * Get browser's version
   * @return {String} version of browser
   *
   * @public
   */
  getBrowserVersion() {
    return this.getBrowser().version;
  }
  /**
   * Get OS
   * @return {Object}
   *
   * @example
   * this.getOS();
   * {
   *   name: 'macOS',
   *   version: '10.11.12'
   * }
   */
  getOS() {
    return this.parsedResult.os ? this.parsedResult.os : this.parseOS();
  }
  /**
   * Parse OS and save it to this.parsedResult.os
   * @return {*|{}}
   */
  parseOS() {
    this.parsedResult.os = {};
    const t = Re.find(Bve, (n) => {
      if (typeof n.test == "function")
        return n.test(this);
      if (n.test instanceof Array)
        return n.test.some((r) => this.test(r));
      throw new Error("Browser's test function is not valid");
    });
    return t && (this.parsedResult.os = t.describe(this.getUA())), this.parsedResult.os;
  }
  /**
   * Get OS name
   * @param {Boolean} [toLowerCase] return lower-cased value
   * @return {String} name of the OS — macOS, Windows, Linux, etc.
   */
  getOSName(t) {
    const { name: n } = this.getOS();
    return t ? String(n).toLowerCase() || "" : n || "";
  }
  /**
   * Get OS version
   * @return {String} full version with dots ('10.11.12', '5.6', etc)
   */
  getOSVersion() {
    return this.getOS().version;
  }
  /**
   * Get parsed platform
   * @return {{}}
   */
  getPlatform() {
    return this.parsedResult.platform ? this.parsedResult.platform : this.parsePlatform();
  }
  /**
   * Get platform name
   * @param {Boolean} [toLowerCase=false]
   * @return {*}
   */
  getPlatformType(t = !1) {
    const { type: n } = this.getPlatform();
    return t ? String(n).toLowerCase() || "" : n || "";
  }
  /**
   * Get parsed platform
   * @return {{}}
   */
  parsePlatform() {
    this.parsedResult.platform = {};
    const t = Re.find(zve, (n) => {
      if (typeof n.test == "function")
        return n.test(this);
      if (n.test instanceof Array)
        return n.test.some((r) => this.test(r));
      throw new Error("Browser's test function is not valid");
    });
    return t && (this.parsedResult.platform = t.describe(this.getUA())), this.parsedResult.platform;
  }
  /**
   * Get parsed engine
   * @return {{}}
   */
  getEngine() {
    return this.parsedResult.engine ? this.parsedResult.engine : this.parseEngine();
  }
  /**
   * Get engines's name
   * @return {String} Engines's name or an empty string
   *
   * @public
   */
  getEngineName(t) {
    return t ? String(this.getEngine().name).toLowerCase() || "" : this.getEngine().name || "";
  }
  /**
   * Get parsed platform
   * @return {{}}
   */
  parseEngine() {
    this.parsedResult.engine = {};
    const t = Re.find(Hve, (n) => {
      if (typeof n.test == "function")
        return n.test(this);
      if (n.test instanceof Array)
        return n.test.some((r) => this.test(r));
      throw new Error("Browser's test function is not valid");
    });
    return t && (this.parsedResult.engine = t.describe(this.getUA())), this.parsedResult.engine;
  }
  /**
   * Parse full information about the browser
   * @returns {Parser}
   */
  parse() {
    return this.parseBrowser(), this.parseOS(), this.parsePlatform(), this.parseEngine(), this;
  }
  /**
   * Get parsed result
   * @return {ParsedResult}
   */
  getResult() {
    return Re.assign({}, this.parsedResult);
  }
  /**
   * Check if parsed browser matches certain conditions
   *
   * @param {Object} checkTree It's one or two layered object,
   * which can include a platform or an OS on the first layer
   * and should have browsers specs on the bottom-laying layer
   *
   * @returns {Boolean|undefined} Whether the browser satisfies the set conditions or not.
   * Returns `undefined` when the browser is no described in the checkTree object.
   *
   * @example
   * const browser = Bowser.getParser(window.navigator.userAgent);
   * if (browser.satisfies({chrome: '>118.01.1322' }))
   * // or with os
   * if (browser.satisfies({windows: { chrome: '>118.01.1322' } }))
   * // or with platforms
   * if (browser.satisfies({desktop: { chrome: '>118.01.1322' } }))
   */
  satisfies(t) {
    const n = {};
    let r = 0;
    const i = {};
    let o = 0;
    if (Object.keys(t).forEach((s) => {
      const c = t[s];
      typeof c == "string" ? (i[s] = c, o += 1) : typeof c == "object" && (n[s] = c, r += 1);
    }), r > 0) {
      const s = Object.keys(n), c = Re.find(s, (u) => this.isOS(u));
      if (c) {
        const u = this.satisfies(n[c]);
        if (u !== void 0)
          return u;
      }
      const l = Re.find(
        s,
        (u) => this.isPlatform(u)
      );
      if (l) {
        const u = this.satisfies(n[l]);
        if (u !== void 0)
          return u;
      }
    }
    if (o > 0) {
      const s = Object.keys(i), c = Re.find(s, (l) => this.isBrowser(l, !0));
      if (c !== void 0)
        return this.compareVersion(i[c]);
    }
  }
  /**
   * Check if the browser name equals the passed string
   * @param browserName The string to compare with the browser name
   * @param [includingAlias=false] The flag showing whether alias will be included into comparison
   * @returns {boolean}
   */
  isBrowser(t, n = !1) {
    const r = this.getBrowserName().toLowerCase();
    let i = t.toLowerCase();
    const o = Re.getBrowserTypeByAlias(i);
    return n && o && (i = o.toLowerCase()), i === r;
  }
  compareVersion(t) {
    let n = [0], r = t, i = !1;
    const o = this.getBrowserVersion();
    if (typeof o == "string")
      return t[0] === ">" || t[0] === "<" ? (r = t.substr(1), t[1] === "=" ? (i = !0, r = t.substr(2)) : n = [], t[0] === ">" ? n.push(1) : n.push(-1)) : t[0] === "=" ? r = t.substr(1) : t[0] === "~" && (i = !0, r = t.substr(1)), n.indexOf(
        Re.compareVersions(o, r, i)
      ) > -1;
  }
  isOS(t) {
    return this.getOSName(!0) === String(t).toLowerCase();
  }
  isPlatform(t) {
    return this.getPlatformType(!0) === String(t).toLowerCase();
  }
  isEngine(t) {
    return this.getEngineName(!0) === String(t).toLowerCase();
  }
  /**
   * Is anything? Check if the browser is called "anything",
   * the OS called "anything" or the platform called "anything"
   * @param {String} anything
   * @param [includingAlias=false] The flag showing whether alias will be included into comparison
   * @returns {Boolean}
   */
  is(t, n = !1) {
    return this.isBrowser(t, n) || this.isOS(t) || this.isPlatform(t);
  }
  /**
   * Check if any of the given values satisfies this.is(anything)
   * @param {String[]} anythings
   * @returns {Boolean}
   */
  some(t = []) {
    return t.some((n) => this.is(n));
  }
}
/*!
 * Bowser - a browser detector
 * https://github.com/lancedikson/bowser
 * MIT License | (c) Dustin Diaz 2012-2015
 * MIT License | (c) Denis Demchenko 2015-2019
 */
class Uve {
  /**
   * Creates a {@link Parser} instance
   *
   * @param {String} UA UserAgent string
   * @param {Boolean} [skipParsing=false] Will make the Parser postpone parsing until you ask it
   * explicitly. Same as `skipParsing` for {@link Parser}.
   * @returns {Parser}
   * @throws {Error} when UA is not a String
   *
   * @example
   * const parser = Bowser.getParser(window.navigator.userAgent);
   * const result = parser.getResult();
   */
  static getParser(t, n = !1) {
    if (typeof t != "string")
      throw new Error("UserAgent should be a string");
    return new K7(t, n);
  }
  /**
   * Creates a {@link Parser} instance and runs {@link Parser.getResult} immediately
   *
   * @param UA
   * @return {ParsedResult}
   *
   * @example
   * const result = Bowser.parse(window.navigator.userAgent);
   */
  static parse(t) {
    return new K7(t).getResult();
  }
  static get BROWSER_MAP() {
    return pq;
  }
  static get ENGINE_MAP() {
    return Al;
  }
  static get OS_MAP() {
    return yo;
  }
  static get PLATFORMS_MAP() {
    return Jr;
  }
}
const mq = "%[a-f0-9]{2}", Y7 = new RegExp("(" + mq + ")|([^%]+?)", "gi"), X7 = new RegExp("(" + mq + ")+", "gi");
function QI(e, t) {
  try {
    return [decodeURIComponent(e.join(""))];
  } catch {
  }
  if (e.length === 1)
    return e;
  t = t || 1;
  const n = e.slice(0, t), r = e.slice(t);
  return Array.prototype.concat.call([], QI(n), QI(r));
}
function Wve(e) {
  try {
    return decodeURIComponent(e);
  } catch {
    let t = e.match(Y7) || [];
    for (let n = 1; n < t.length; n++)
      e = QI(t, n).join(""), t = e.match(Y7) || [];
    return e;
  }
}
function qve(e) {
  const t = {
    "%FE%FF": "��",
    "%FF%FE": "��"
  };
  let n = X7.exec(e);
  for (; n; ) {
    try {
      t[n[0]] = decodeURIComponent(n[0]);
    } catch {
      const i = Wve(n[0]);
      i !== n[0] && (t[n[0]] = i);
    }
    n = X7.exec(e);
  }
  t["%C2"] = "�";
  const r = Object.keys(t);
  for (const i of r)
    e = e.replace(new RegExp(i, "g"), t[i]);
  return e;
}
function Gve(e) {
  if (typeof e != "string")
    throw new TypeError("Expected `encodedURI` to be of type `string`, got `" + typeof e + "`");
  try {
    return decodeURIComponent(e);
  } catch {
    return qve(e);
  }
}
function Kve(e, t) {
  const n = {};
  if (Array.isArray(t))
    for (const r of t) {
      const i = Object.getOwnPropertyDescriptor(e, r);
      i != null && i.enumerable && Object.defineProperty(n, r, i);
    }
  else
    for (const r of Reflect.ownKeys(e)) {
      const i = Object.getOwnPropertyDescriptor(e, r);
      if (i.enumerable) {
        const o = e[r];
        t(r, o, e) && Object.defineProperty(n, r, i);
      }
    }
  return n;
}
function vq(e, t) {
  if (!(typeof e == "string" && typeof t == "string"))
    throw new TypeError("Expected the arguments to be of type `string`");
  if (e === "" || t === "")
    return [];
  const n = e.indexOf(t);
  return n === -1 ? [] : [
    e.slice(0, n),
    e.slice(n + t.length)
  ];
}
const Yve = (e) => e == null, Xve = (e) => encodeURIComponent(e).replaceAll(/[!'()*]/g, (t) => `%${t.charCodeAt(0).toString(16).toUpperCase()}`), JI = Symbol("encodeFragmentIdentifier");
function Qve(e) {
  switch (e.arrayFormat) {
    case "index":
      return (t) => (n, r) => {
        const i = n.length;
        return r === void 0 || e.skipNull && r === null || e.skipEmptyString && r === "" ? n : r === null ? [
          ...n,
          [ai(t, e), "[", i, "]"].join("")
        ] : [
          ...n,
          [ai(t, e), "[", ai(i, e), "]=", ai(r, e)].join("")
        ];
      };
    case "bracket":
      return (t) => (n, r) => r === void 0 || e.skipNull && r === null || e.skipEmptyString && r === "" ? n : r === null ? [
        ...n,
        [ai(t, e), "[]"].join("")
      ] : [
        ...n,
        [ai(t, e), "[]=", ai(r, e)].join("")
      ];
    case "colon-list-separator":
      return (t) => (n, r) => r === void 0 || e.skipNull && r === null || e.skipEmptyString && r === "" ? n : r === null ? [
        ...n,
        [ai(t, e), ":list="].join("")
      ] : [
        ...n,
        [ai(t, e), ":list=", ai(r, e)].join("")
      ];
    case "comma":
    case "separator":
    case "bracket-separator": {
      const t = e.arrayFormat === "bracket-separator" ? "[]=" : "=";
      return (n) => (r, i) => i === void 0 || e.skipNull && i === null || e.skipEmptyString && i === "" ? r : (i = i === null ? "" : i, r.length === 0 ? [[ai(n, e), t, ai(i, e)].join("")] : [[r, ai(i, e)].join(e.arrayFormatSeparator)]);
    }
    default:
      return (t) => (n, r) => r === void 0 || e.skipNull && r === null || e.skipEmptyString && r === "" ? n : r === null ? [
        ...n,
        ai(t, e)
      ] : [
        ...n,
        [ai(t, e), "=", ai(r, e)].join("")
      ];
  }
}
function Jve(e) {
  let t;
  switch (e.arrayFormat) {
    case "index":
      return (n, r, i) => {
        if (t = /\[(\d*)]$/.exec(n), n = n.replace(/\[\d*]$/, ""), !t) {
          i[n] = r;
          return;
        }
        i[n] === void 0 && (i[n] = {}), i[n][t[1]] = r;
      };
    case "bracket":
      return (n, r, i) => {
        if (t = /(\[])$/.exec(n), n = n.replace(/\[]$/, ""), !t) {
          i[n] = r;
          return;
        }
        if (i[n] === void 0) {
          i[n] = [r];
          return;
        }
        i[n] = [...i[n], r];
      };
    case "colon-list-separator":
      return (n, r, i) => {
        if (t = /(:list)$/.exec(n), n = n.replace(/:list$/, ""), !t) {
          i[n] = r;
          return;
        }
        if (i[n] === void 0) {
          i[n] = [r];
          return;
        }
        i[n] = [...i[n], r];
      };
    case "comma":
    case "separator":
      return (n, r, i) => {
        const o = typeof r == "string" && r.includes(e.arrayFormatSeparator), a = typeof r == "string" && !o && Vc(r, e).includes(e.arrayFormatSeparator);
        r = a ? Vc(r, e) : r;
        const s = o || a ? r.split(e.arrayFormatSeparator).map((c) => Vc(c, e)) : r === null ? r : Vc(r, e);
        i[n] = s;
      };
    case "bracket-separator":
      return (n, r, i) => {
        const o = /(\[])$/.test(n);
        if (n = n.replace(/\[]$/, ""), !o) {
          i[n] = r && Vc(r, e);
          return;
        }
        const a = r === null ? [] : Vc(r, e).split(e.arrayFormatSeparator);
        if (i[n] === void 0) {
          i[n] = a;
          return;
        }
        i[n] = [...i[n], ...a];
      };
    default:
      return (n, r, i) => {
        if (i[n] === void 0) {
          i[n] = r;
          return;
        }
        i[n] = [...[i[n]].flat(), r];
      };
  }
}
function yq(e) {
  if (typeof e != "string" || e.length !== 1)
    throw new TypeError("arrayFormatSeparator must be single character string");
}
function ai(e, t) {
  return t.encode ? t.strict ? Xve(e) : encodeURIComponent(e) : e;
}
function Vc(e, t) {
  return t.decode ? Gve(e) : e;
}
function bq(e) {
  return Array.isArray(e) ? e.sort() : typeof e == "object" ? bq(Object.keys(e)).sort((t, n) => Number(t) - Number(n)).map((t) => e[t]) : e;
}
function _q(e) {
  const t = e.indexOf("#");
  return t !== -1 && (e = e.slice(0, t)), e;
}
function Zve(e) {
  let t = "";
  const n = e.indexOf("#");
  return n !== -1 && (t = e.slice(n)), t;
}
function Q7(e, t, n) {
  return n === "string" && typeof e == "string" ? e : typeof n == "function" && typeof e == "string" ? n(e) : n === "boolean" && e === null ? !0 : n === "boolean" && e !== null && (e.toLowerCase() === "true" || e.toLowerCase() === "false") ? e.toLowerCase() === "true" : n === "boolean" && e !== null && (e.toLowerCase() === "1" || e.toLowerCase() === "0") ? e.toLowerCase() === "1" : n === "string[]" && t.arrayFormat !== "none" && typeof e == "string" ? [e] : n === "number[]" && t.arrayFormat !== "none" && !Number.isNaN(Number(e)) && typeof e == "string" && e.trim() !== "" ? [Number(e)] : n === "number" && !Number.isNaN(Number(e)) && typeof e == "string" && e.trim() !== "" ? Number(e) : t.parseBooleans && e !== null && (e.toLowerCase() === "true" || e.toLowerCase() === "false") ? e.toLowerCase() === "true" : t.parseNumbers && !Number.isNaN(Number(e)) && typeof e == "string" && e.trim() !== "" ? Number(e) : e;
}
function yP(e) {
  e = _q(e);
  const t = e.indexOf("?");
  return t === -1 ? "" : e.slice(t + 1);
}
function bP(e, t) {
  t = {
    decode: !0,
    sort: !0,
    arrayFormat: "none",
    arrayFormatSeparator: ",",
    parseNumbers: !1,
    parseBooleans: !1,
    types: /* @__PURE__ */ Object.create(null),
    ...t
  }, yq(t.arrayFormatSeparator);
  const n = Jve(t), r = /* @__PURE__ */ Object.create(null);
  if (typeof e != "string" || (e = e.trim().replace(/^[?#&]/, ""), !e))
    return r;
  for (const i of e.split("&")) {
    if (i === "")
      continue;
    const o = t.decode ? i.replaceAll("+", " ") : i;
    let [a, s] = vq(o, "=");
    a === void 0 && (a = o), s = s === void 0 ? null : ["comma", "separator", "bracket-separator"].includes(t.arrayFormat) ? s : Vc(s, t), n(Vc(a, t), s, r);
  }
  for (const [i, o] of Object.entries(r))
    if (typeof o == "object" && o !== null && t.types[i] !== "string")
      for (const [a, s] of Object.entries(o)) {
        const c = t.types[i] ? t.types[i].replace("[]", "") : void 0;
        o[a] = Q7(s, t, c);
      }
    else
      typeof o == "object" && o !== null && t.types[i] === "string" ? r[i] = Object.values(o).join(t.arrayFormatSeparator) : r[i] = Q7(o, t, t.types[i]);
  return t.sort === !1 ? r : (t.sort === !0 ? Object.keys(r).sort() : Object.keys(r).sort(t.sort)).reduce((i, o) => {
    const a = r[o];
    return i[o] = a && typeof a == "object" && !Array.isArray(a) ? bq(a) : a, i;
  }, /* @__PURE__ */ Object.create(null));
}
function Sq(e, t) {
  if (!e)
    return "";
  t = {
    encode: !0,
    strict: !0,
    arrayFormat: "none",
    arrayFormatSeparator: ",",
    ...t
  }, yq(t.arrayFormatSeparator);
  const n = (a) => t.skipNull && Yve(e[a]) || t.skipEmptyString && e[a] === "", r = Qve(t), i = {};
  for (const [a, s] of Object.entries(e))
    n(a) || (i[a] = s);
  const o = Object.keys(i);
  return t.sort !== !1 && o.sort(t.sort), o.map((a) => {
    const s = e[a];
    return s === void 0 ? "" : s === null ? ai(a, t) : Array.isArray(s) ? s.length === 0 && t.arrayFormat === "bracket-separator" ? ai(a, t) + "[]" : s.reduce(r(a), []).join("&") : ai(a, t) + "=" + ai(s, t);
  }).filter((a) => a.length > 0).join("&");
}
function wq(e, t) {
  var i;
  t = {
    decode: !0,
    ...t
  };
  let [n, r] = vq(e, "#");
  return n === void 0 && (n = e), {
    url: ((i = n == null ? void 0 : n.split("?")) == null ? void 0 : i[0]) ?? "",
    query: bP(yP(e), t),
    ...t && t.parseFragmentIdentifier && r ? { fragmentIdentifier: Vc(r, t) } : {}
  };
}
function xq(e, t) {
  t = {
    encode: !0,
    strict: !0,
    [JI]: !0,
    ...t
  };
  const n = _q(e.url).split("?")[0] || "", r = yP(e.url), i = {
    ...bP(r, { sort: !1, ...t }),
    ...e.query
  };
  let o = Sq(i, t);
  o && (o = `?${o}`);
  let a = Zve(e.url);
  if (typeof e.fragmentIdentifier == "string") {
    const s = new URL(n);
    s.hash = e.fragmentIdentifier, a = t[JI] ? s.hash : `#${e.fragmentIdentifier}`;
  }
  return `${n}${o}${a}`;
}
function Eq(e, t, n) {
  n = {
    parseFragmentIdentifier: !0,
    [JI]: !1,
    ...n
  };
  const { url: r, query: i, fragmentIdentifier: o } = wq(e, n);
  return xq({
    url: r,
    query: Kve(i, t),
    fragmentIdentifier: o
  }, n);
}
function eye(e, t, n) {
  const r = Array.isArray(t) ? (i) => !t.includes(i) : (i, o) => !t(i, o);
  return Eq(e, r, n);
}
const Cq = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  exclude: eye,
  extract: yP,
  parse: bP,
  parseUrl: wq,
  pick: Eq,
  stringify: Sq,
  stringifyUrl: xq
}, Symbol.toStringTag, { value: "Module" }));
function Y_t(e) {
  return e.map((t) => {
    const n = Object.entries(t).map(([r, i]) => [r, i.value]);
    return Object.fromEntries(n);
  });
}
function X_t(e) {
  return e.map((t) => ({
    user: t.user,
    questionId: t.questionId,
    choiceNumber: t.choiceNumber.toString(),
    choice: t.choice.toString(),
    ...tye(t.attrDiffs)
  }));
}
function tye(e) {
  return Object.fromEntries(
    e.map((t) => [t.label, t.diff.toString()])
  );
}
function s5(e, t) {
  return {
    answers: {
      //   ..._.mapValues(submission.answers, (value, key) => exportData(value, key)),
      ...e.answers
    },
    metadata: {
      userId: e.userData.uid,
      email: e.userData.email,
      urlId: e.userData.urlId,
      device: e.userData.device,
      browser: e.userData.browser,
      language: e.userData.language,
      completed: e.surveyCompleted,
      totalTime: e.timeTakenSeconds ? e.timeTakenSeconds : e.timeSoFarSeconds,
      submissionStarted: e.submissionStarted,
      submissionEnded: e.submissionEnded,
      lastAnswerTime: e.lastAnswerTime
    },
    documentId: t
  };
}
const ZI = {
  userId: "userData.uid",
  email: "userData.email",
  urlId: "userData.urlId",
  device: "userData.device",
  browser: "userData.browser",
  language: "userData.language",
  completed: "surveyCompleted",
  totalTime: "timeSoFarSeconds",
  submissionStarted: "submissionStarted",
  submissionEnded: "submissionEnded",
  lastAnswerTime: "lastAnswerTime"
};
function J7(e) {
  return e in ZI;
}
function Q_t(e, t, n) {
  return t.info("responsesFromResultData", e), {
    data: e.map((i) => nye(i, n))
  };
}
function nye(e, t) {
  const n = rye(e.answers), r = iye(e.metadata, t);
  return {
    ...n,
    ...r,
    documentId: { value: e.documentId }
  };
}
function J_t(e, t) {
  const n = [], r = {};
  r.documentId = !0, n.push("documentId");
  for (const o of e)
    for (const a in o.metadata)
      r[a] || (r[a] = !0, n.push(a));
  const i = [];
  for (const o of t.data)
    for (const a in o)
      r[a] || (r[a] = !0, i.push(a));
  return i.sort((o, a) => o > a ? 1 : -1), n.concat(i);
}
function rye(e) {
  const t = [];
  for (const n in e) {
    const r = oye(e[n]);
    if (Array.isArray(r))
      for (const i of r)
        t.push([`${n}::${i.label}`, i]);
    else
      t.push([n, r]);
  }
  return Object.fromEntries(t);
}
function iye(e, t) {
  return {
    submissionStarted: { value: c5(e.submissionStarted, t) },
    submissionEnded: {
      value: e.submissionEnded ? c5(e.submissionEnded, t) : ""
    },
    completed: { value: e.completed ? "true" : "false" },
    lastAnswerTime: {
      value: e.lastAnswerTime ? c5(e.lastAnswerTime, t) : ""
    },
    totalTime: { value: e.totalTime.toString() },
    userId: { value: e.userId },
    email: { value: e.email || "" },
    urlId: { value: e.urlId ? Nse(e.urlId, " ") : "" },
    device: { value: e.device || "" },
    browser: { value: e.browser || "" },
    language: { value: e.language || "" }
  };
}
function oye(e) {
  return e.value === null ? { value: "No response" } : Array.isArray(e.value) ? Z7(e.value, e.questionType, "") : Cz(e.value) ? { value: e4(e.value, e.questionType) } : Object.entries(e.value).flatMap(([t, n]) => Array.isArray(n) ? Z7(n, e.questionType, t) : { value: e4(n, e.questionType), label: t });
}
function Z7(e, t, n) {
  const r = n ? `${n}::` : "";
  switch (t) {
    default:
      return e.map((i) => ({ value: i.value, label: `${r}${i.id}` }));
  }
}
function e4(e, t) {
  switch (t) {
    default:
      return e.value;
  }
}
function c5(e, t) {
  return t === "excelcsv" ? e.toDate().toLocaleString().replace(",", "") : e.toDate().toLocaleString();
}
function aye(e) {
  return Bv(
    e,
    "createSurveyDocs"
  );
}
function sye(e) {
  return Bv(
    e,
    "addSurveyOwner"
  );
}
function cye(e) {
  return Bv(
    e,
    "registerCompletion"
  );
}
function lye(e) {
  return Bv(e, "subscribe");
}
function uye(e) {
  return Bv(
    e,
    "archiveSubmissions"
  );
}
class Z_t extends Dse {
  constructor(n, r, i) {
    super();
    ye(this, "firestore");
    ye(this, "functions");
    // private getResultsFirestore
    ye(this, "createSurveyDoc");
    ye(this, "addSurveyOwnerFirestore");
    ye(this, "registerCompletionMailchimpFirestore");
    ye(this, "subscribeMailchimpFirestore");
    ye(this, "archiveSubmissionsFirestore");
    ye(this, "surveyOwnersSubjects", {});
    ye(this, "surveysSubject");
    ye(this, "aggResultsSubject", {});
    ye(this, "surveyResponseCountSubject", new Vs(0));
    ye(this, "surveyResponsesSubject", new Vs(
      []
    ));
    ye(this, "surveyResponseCountSubscription");
    ye(this, "surveyResponsesSubscription");
    ye(this, "surveyResultsParamsSubject", new Vs({
      surveyName: void 0,
      pagination: { action: "start", pageSize: 10 },
      sorter: { column: "submissionStarted", direction: "desc" },
      filter: null
    }));
    ye(this, "surveyResultsParamsSubscription", null);
    ye(this, "unsubscribes", []);
    ye(this, "errorSubject", new Tz());
    ye(this, "startDoc");
    ye(this, "endDoc");
    ye(this, "log");
    this.firestore = vve(n), this.functions = OU(n), this.log = i, this.log.info("USE_FIREBASE_EMULATORS", r), r && (Lve(this.firestore), gq(this.functions)), this.createSurveyDoc = aye(this.functions), this.addSurveyOwnerFirestore = sye(this.functions), this.registerCompletionMailchimpFirestore = cye(this.functions), this.subscribeMailchimpFirestore = lye(this.functions), this.archiveSubmissionsFirestore = uye(this.functions), this.subscribeToSurveyResultsParams();
  }
  dispose() {
    this.unsubscribes.forEach((n) => {
      n();
    }), this.surveyResultsParamsSubscription && this.surveyResultsParamsSubscription.unsubscribe();
  }
  subscribeToSurveyResultsParams() {
    this.log.info("subscribeToSurveyResultsParams"), this.surveyResultsParamsSubscription = this.surveyResultsParamsSubject.subscribe(
      ({ surveyName: n, pagination: r, sorter: i, filter: o }) => {
        if (n === void 0) {
          this.surveyResponseCountSubject.next(0), this.surveyResponsesSubject.next([]);
          return;
        }
        this.updateResponseCount(n), this.updateResponses(n, r, i, o);
      }
    );
  }
  updateResponseCount(n) {
    this.surveyResponseCountSubscription && this.surveyResponseCountSubscription();
    const r = Zf(
      this.getSurveyDocRef(n),
      (i) => {
        var a;
        const o = ((a = i.data()) == null ? void 0 : a.submissionCount) ?? 0;
        this.surveyResponseCountSubject.next(o);
      },
      (i) => {
        this.recordError(new Error("Error updating survey response count"), i);
      }
    );
    this.surveyResponseCountSubscription = r;
  }
  updateResponses(n, r, i, o) {
    this.surveyResponsesSubscription && this.surveyResponsesSubscription();
    const a = this.getObserveResponsesQuery(n, r, i, o), s = Zf(
      a,
      (c) => {
        const l = c.docs;
        this.startDoc = l[0], this.endDoc = l[l.length - 1];
        const u = l.map(
          (d) => s5(d.data(), d.id)
        );
        this.surveyResponsesSubject.next(u);
      },
      (c) => {
        this.recordError(new Error("Error updating survey responses"), c);
      }
    );
    this.surveyResponsesSubscription = s;
  }
  async subscribeToStore(n, r, i, o) {
    var p;
    this.log.info("subscribeToStore");
    const a = o ?? null, s = this.getUserData(i);
    let c, l, u = !1;
    if (a !== null) {
      c = this.getExistingSubmissionDocRef(r, a);
      try {
        const g = await a5(c);
        u = g.exists(), u && (l = ((p = g.data()) == null ? void 0 : p.submissionStarted) ?? qn.now());
      } catch (g) {
        this.log.error("Error getting submission", { error: g }), u = !1;
      }
    }
    (a === null || !u) && ([c, l] = await this.createInitialSubmission(
      n,
      r,
      i
    ));
    let d, f;
    const h = () => {
      const g = d, m = f, v = n.getState().survey;
      let y;
      if (d = v.userAnswers, f = v.currentQuestionId ?? void 0, n.getState().survey.currentQuestionType === "endPage") {
        const S = qn.now(), _ = S.seconds - l.seconds;
        y = {
          submissionStarted: l,
          submissionEnded: S,
          answers: d,
          surveyCompleted: !0,
          timeTakenSeconds: _,
          userData: s,
          currentQuestionId: f,
          currentQuestionType: v.currentQuestionType ?? void 0,
          questionHistory: v.questionHistory
        }, this.updateSubmission(c, y);
      }
      if (g !== d || m !== f) {
        const S = qn.now();
        y = {
          submissionStarted: l,
          lastAnswerTime: S,
          answers: d,
          timeSoFarSeconds: S.seconds - l.seconds,
          userData: s,
          currentQuestionId: f,
          currentQuestionType: v.currentQuestionType ?? void 0,
          questionHistory: v.questionHistory,
          initialised: !0
        }, this.updateSubmission(c, y);
      }
    };
    this.log.info("Subscribing Firestore to Redux store changes"), this.unsubscribes.push(n.subscribe(h));
  }
  async createInitialSubmission(n, r, i) {
    const o = this.getUserData(i), a = qn.now(), s = this.getNewSubmissionDocRef(r);
    n.dispatch(oH(s.id));
    const c = {
      userData: o,
      answers: {},
      submissionStarted: a,
      surveyCompleted: !1,
      timeSoFarSeconds: 0
    };
    return this.log.debug("Setting initial response data in firebase", s, c), await this.initialiseSubmission(s, c), this.log.info("Finished setting initial response data"), [s, a];
  }
  getUserData(n) {
    const r = Cq.parse(window.location.search);
    let i;
    r.id && typeof r.id == "string" ? i = r.id : r.id && Array.isArray(r.id) ? i = r.id[0] ? r.id[0] : "empty" : i = "empty";
    let o = !1;
    if (r.noAgg && typeof r.noAgg == "string")
      o = r.noAgg === "true";
    else if (r.noAgg && Array.isArray(r.noAgg))
      for (const l of r.noAgg)
        l === "true" && (o = !0);
    const a = typeof r.panelId == "string" ? r.panelId : void 0, s = typeof r.lang == "string" ? r.lang : "default", c = {
      uid: n.id,
      email: null,
      lastActive: n.lastActive,
      created: n.created,
      urlId: i,
      device: Mle(),
      browser: Uve.getParser(window.navigator.userAgent).getBrowserName(),
      noAggregation: o,
      language: s
    };
    return a && (c.panelId = a), c;
  }
  async getAggregatedResults(n) {
    var o;
    this.log.info("getAggregatedResults", n);
    const r = this.getSurveyDocRef(n), i = await o5(r);
    return this.log.debug("surveyDoc", i.data()), (o = i.data()) == null ? void 0 : o.aggResults;
  }
  observeAggregatedResults(n) {
    if (!this.aggResultsSubject[n]) {
      this.aggResultsSubject[n] = new Vs({});
      const r = Zf(
        this.getSurveyDocRef(n),
        (i) => {
          var a;
          const o = (a = i.data()) == null ? void 0 : a.aggResults;
          this.aggResultsSubject[n].next(o);
        },
        (i) => {
          this.recordError(new Error("Error getting aggregate results"), i);
        }
      );
      this.unsubscribes.push(r);
    }
    return this.aggResultsSubject[n];
  }
  async addSurveyOwner(n, r) {
    await this.addSurveyOwnerFirestore({ email: n, surveyName: r });
  }
  observeSurveyOwners(n) {
    if (!this.surveyOwnersSubjects[n]) {
      this.surveyOwnersSubjects[n] = new Vs([]);
      const r = Zf(
        Jf(this.firestore, "surveys", n, "surveyOwners"),
        (i) => {
          const o = i.docs.map((a) => a.data().email);
          this.surveyOwnersSubjects[n].next(o);
        },
        (i) => {
          this.surveyOwnersSubjects[n].error(i), this.recordError(new Error("Error getting survey owners"), i);
        }
      );
      this.unsubscribes.push(r);
    }
    return this.surveyOwnersSubjects[n];
  }
  async getSurveyOwners(n) {
    throw new Error("Not implemented. Need to get value from firestore");
  }
  async isActive(n) {
    var r, i;
    this.log.info("isActive", n);
    try {
      return (i = (r = (await o5(this.getSurveyDocRef(n))).data()) == null ? void 0 : r.settings) == null ? void 0 : i.active;
    } catch (o) {
      return this.recordError(new Error("Could not find if survey active"), o), !1;
    }
  }
  observeSurveys(n) {
    if (this.log.info("observeSurveys", n), n.isAdmin) {
      if (!this.surveysSubject) {
        this.surveysSubject = new Vs([]);
        const r = Zf(
          Jf(this.firestore, "surveys"),
          (i) => {
            var a;
            const o = i.docs.map((s) => ({ id: s.id }));
            this.surveysSubject && o.length !== this.surveysSubject.value.length && ((a = this.surveysSubject) == null || a.next(o));
          },
          (i) => {
            var o;
            (o = this.surveysSubject) == null || o.error(i);
          }
        );
        this.unsubscribes.push(r);
      }
      return this.surveysSubject;
    } else {
      if (!this.surveysSubject) {
        this.surveysSubject = new Vs([]);
        const r = Zf(
          Jf(this.firestore, "users", n.id, "surveys"),
          (i) => {
            var a;
            const o = i.docs.map((s) => ({ id: s.id }));
            this.surveysSubject && o.length !== this.surveysSubject.value.length && ((a = this.surveysSubject) == null || a.next(o));
          }
        );
        this.unsubscribes.push(r);
      }
      return this.surveysSubject;
    }
  }
  async getSurveys(n) {
    if (this.log.info("getSurveys", n), n.isAdmin) {
      const r = await Sb(Jf(this.firestore, "surveys")), i = [];
      return r.forEach((o) => {
        i.push({ id: o.id });
      }), i;
    }
    return [];
  }
  async activateSurvey(n) {
    await wb(
      this.getSurveyDocRef(n),
      {
        active: !0,
        saveResults: !0,
        aggregateResults: !0
      },
      { merge: !0 }
    ), this.addQuestionsToDb(n);
  }
  // private async setRecordAnswers(value) {
  //   const { settings } = surveyDoc
  //   if (settings) {
  //     const updateSettings = {
  //       settings: {
  //         saveResults: value, // toggle value
  //       },
  //     }
  //     db.collection('surveys')
  //       .doc(surveyName)
  //       .set(updateSettings, { merge: true })
  //     setRecording(updateSettings.settings.saveResults)
  //   }
  // }
  async addQuestionsToDb(n) {
  }
  async refreshSurveys(n) {
    const r = {};
    (await Sb(Jf(this.firestore, "surveys"))).forEach((a) => {
      r[a.id] = !0;
    });
    const o = n.filter((a) => !(a.settings.surveyName in r));
    try {
      await Promise.all(
        o.map(
          (a) => wb(this.getSurveyDocRef(a.settings.surveyName), {}, { merge: !0 })
        )
      );
    } catch (a) {
      this.recordError(new Error("Error refreshing surveys"), a);
    }
  }
  observeResponseCount() {
    return this.log.info("observeResponseCounts"), this.surveyResponseCountSubject;
  }
  observeResponses() {
    return this.log.info("observeResponses"), this.surveyResponsesSubject;
  }
  getObserveResponsesQuery(n, r, i, o) {
    this.log.info("getObserveResponsesQuery", n, r, i, o), i === null && o === null && (i = { column: "submissionStarted", direction: "desc" });
    const a = [];
    switch (a.push(nd(r.pageSize)), a.push(this.getOrderByQueryConstraint(i)), a.push(...this.getFilterByQueryConstraints(o)), r.action) {
      case "start":
        break;
      case "current":
        this.startDoc && a.push(H7(this.startDoc));
        break;
      case "next":
        this.endDoc && a.push(U7(this.endDoc));
        break;
      case "previous":
        this.startDoc ? a.push(W7(this.startDoc), z7(r.pageSize)) : this.log.debug("Tried to get previous but no startDoc found");
        break;
      default:
        Kd(r.action);
    }
    return ks(this.getSurveyCollectionRef(n), ...a);
  }
  getOrderByQueryConstraint(n) {
    const r = J7(n.column) ? ZI[n.column] : "submissionStarted";
    return Cc(r, n.direction);
  }
  getFilterByQueryConstraints(n) {
    const r = [];
    if (n && J7(n.column)) {
      const i = ZI[n.column];
      switch (i) {
        case "submissionStarted":
        case "submissionEnded":
        case "lastAnswerTime":
          if (typeof n.value != "string")
            break;
          if (n.operator === "==")
            try {
              const o = new Date(n.value), a = new Date(o.getTime() + 24 * 60 * 60 * 1e3);
              r.push(_b(i, ">=", o)), r.push(_b(i, "<", a));
            } catch (o) {
              this.log.error("Error parsing date", { error: o });
            }
          else
            try {
              const o = new Date(n.value);
              r.push(_b(i, n.operator, o));
            } catch (o) {
              this.log.error("Error parsing date", { error: o });
            }
          break;
        default:
          r.push(_b(i, n.operator, n.value));
      }
    }
    return r;
  }
  async getResponses(n, r, i) {
    let o;
    return r ? o = await this.getResultData(n, r) : o = await this.getAllResultData(n), o;
  }
  async getResponseCountAggregate(n, r, i) {
    this.log.info("getResponseCountAggregate");
    const o = [];
    o.push(this.getOrderByQueryConstraint(r)), o.push(...this.getFilterByQueryConstraints(i));
    const a = ks(this.getSurveyCollectionRef(n), ...o);
    return (await kve(a)).data().count;
  }
  setCurrentSurvey(n) {
    this.log.info("setCurrentSurvey", n), this.startDoc = void 0, this.endDoc = void 0, this.surveyResultsParamsSubject.next({
      surveyName: n,
      pagination: { action: "start", pageSize: 10 },
      sorter: { column: "submissionStarted", direction: "desc" },
      filter: null
    });
  }
  setPagination(n) {
    this.log.info("setPagination", n), this.surveyResultsParamsSubject.next({ ...this.surveyResultsParamsSubject.value, pagination: n });
  }
  setOrderBy(n) {
    this.log.info("setSorter", n), this.startDoc = void 0, this.endDoc = void 0, this.surveyResultsParamsSubject.next({
      ...this.surveyResultsParamsSubject.value,
      pagination: { action: "start", pageSize: 10 },
      sorter: n
    });
  }
  setFilterBy(n) {
    this.log.info("setFilterBy", n), this.startDoc = void 0, this.endDoc = void 0, this.surveyResultsParamsSubject.next({
      ...this.surveyResultsParamsSubject.value,
      pagination: { action: "start", pageSize: 10 },
      filter: n
    });
  }
  observeSurveyResultsParams() {
    return this.log.info("observeSurveyResultsParams"), this.surveyResultsParamsSubject;
  }
  async getAllResultData(n) {
    const r = ks(
      this.getSurveyCollectionRef(n),
      Cc("submissionStarted", "desc")
    );
    try {
      return (await Sb(r)).docs.map(
        (o) => s5(o.data(), o.id)
      );
    } catch (i) {
      const o = i;
      throw this.log.error(o.message, { error: o }), i;
    }
  }
  async getResultCount(n) {
    var i;
    return this.log.info("getResultCount", n), (i = (await o5(this.getSurveyDocRef(n))).data()) == null ? void 0 : i.submissionCount;
  }
  async getResultData(n, r) {
    this.log.info("getResultData", n);
    let i;
    switch (r.action) {
      case "start":
        i = ks(
          this.getSurveyCollectionRef(n),
          Cc("submissionStarted", "desc"),
          nd(r.pageSize)
        );
        break;
      case "current":
        this.startDoc ? i = ks(
          this.getSurveyCollectionRef(n),
          Cc("submissionStarted", "desc"),
          H7(this.startDoc),
          nd(r.pageSize)
        ) : i = ks(
          this.getSurveyCollectionRef(n),
          Cc("submissionStarted", "desc"),
          nd(r.pageSize)
        );
        break;
      case "next":
        this.endDoc ? i = ks(
          this.getSurveyCollectionRef(n),
          Cc("submissionStarted", "desc"),
          U7(this.endDoc),
          nd(r.pageSize)
        ) : (this.log.debug("Tried to get next, but no endDoc found"), i = ks(
          this.getSurveyCollectionRef(n),
          Cc("submissionStarted", "desc"),
          nd(r.pageSize)
        ));
        break;
      case "previous":
        this.startDoc ? i = ks(
          this.getSurveyCollectionRef(n),
          Cc("submissionStarted", "desc"),
          W7(this.startDoc),
          z7(r.pageSize)
        ) : (this.log.debug("Tried to get previous but no startDoc found"), i = ks(
          this.getSurveyCollectionRef(n),
          Cc("submissionStarted", "desc"),
          nd(r.pageSize)
        ));
        break;
      default:
        Kd(r.action);
    }
    try {
      const o = await Sb(i);
      return this.startDoc = o.docs[0], this.endDoc = o.docs[o.docs.length - 1], this.startDoc && this.endDoc ? (this.log.debug("startDoc", this.startDoc.data().submissionStarted.toDate().toLocaleString()), this.log.debug("endDoc", this.endDoc.data().submissionStarted.toDate().toLocaleString()), o.docs.map(
        (a) => s5(a.data(), a.id)
      )) : [];
    } catch (o) {
      const a = o;
      throw this.log.error(a.message, { error: a }), o;
    }
  }
  async getChoiceData(n) {
    this.log.info("getChoiceData", n);
    const r = await this.getAllResultData(n), i = this.getChoiceResults(r);
    return [i, this.getChoiceResultColumns(i)];
  }
  getChoiceResults(n) {
    const r = { data: [] };
    return n.forEach((i) => {
      Object.keys(i.answers).forEach((o) => {
        const a = i.answers[o];
        if (a.questionType === "conjointAnalysis") {
          const s = this.getResponseChoiceResults(i, a);
          r.data = r.data.concat(s);
        }
      });
    }), r;
  }
  getResponseChoiceResults(n, r) {
    return r.value.prevChoices.map(
      (s, c) => this.getChoiceResult(s, n.metadata.userId, c, r.questionId)
    );
  }
  getChoiceResult(n, r, i, o) {
    var s, c;
    return {
      user: r,
      questionId: o,
      choiceNumber: i,
      attrDiffs: this.getAttrDiffs((s = n.info) == null ? void 0 : s.options),
      choice: (c = n.info) == null ? void 0 : c.selectedOptionIndex
    };
  }
  getAttrDiffs(n) {
    const r = [];
    return n[0].attributes.forEach((i, o) => {
      const a = {
        label: `attr:${i.attributeName ?? i.attributeId}::level:${i.levelName ?? i.levelId}`,
        diff: 1
      };
      r.push(a);
    }), n[1].attributes.forEach((i, o) => {
      const a = {
        label: `attr:${i.attributeName ?? i.attributeId}::level:${i.levelName ?? i.levelId}`,
        diff: -1
      };
      r.push(a);
    }), r;
  }
  getChoiceResultColumns(n) {
    this.log.info("getChoiceResultColumns", n);
    const r = /* @__PURE__ */ new Set(), i = [
      {
        title: "user",
        dataIndex: "user",
        key: "user"
      },
      {
        title: "questionId",
        dataIndex: "questionId",
        key: "questionId"
      },
      {
        title: "choiceNumber",
        dataIndex: "choiceNumber",
        key: "choiceNumber"
      },
      {
        title: "choice",
        dataIndex: "choice",
        key: "choice"
      }
    ], o = [];
    for (const a of n.data)
      a.attrDiffs.forEach((s) => {
        const c = {
          title: s.label,
          dataIndex: s.label,
          key: s.label
        };
        r.has(s.label) || (r.add(s.label), o.push(c));
      });
    return this.log.debug("choiceResultColumns", i), o.sort((a, s) => a.title.localeCompare(s.title)), this.log.debug("attrColumns", o), i.concat(o);
  }
  recordError(n, r) {
    this.log.error("Database error", { error: n }), this.log.error("Database actual error", { error: r }), this.errorSubject.next(n);
  }
  observeErrors() {
    return this.errorSubject;
  }
  getSurveyDocRef(n, ...r) {
    return i5(this.firestore, "surveys", n, ...r);
  }
  getSurveyCollectionRef(n) {
    const r = {
      toFirestore: (i) => i,
      fromFirestore: (i) => i.data()
    };
    return Jf(this.firestore, "surveys", n, "submissions").withConverter(r);
  }
  getNewSubmissionDocRef(n) {
    return i5(this.getSurveyCollectionRef(n));
  }
  getExistingSubmissionDocRef(n, r) {
    return i5(this.getSurveyCollectionRef(n), r);
  }
  async initialiseSubmission(n, r) {
    await wb(n, r);
  }
  async updateSubmission(n, r) {
    wb(n, r, { merge: !0 });
  }
  async clearAggregateResults(n) {
    this.log.info("clearAggregateResults", n);
    const r = this.getSurveyDocRef(n);
    await Mve(r, {
      aggResults: Dve()
    });
  }
  async registerCompletionMailchimp(n, r) {
    this.log.info("registerCompletionMailchimp");
    try {
      const i = await this.registerCompletionMailchimpFirestore({
        surveyName: n,
        panelId: r
      });
      if (!i.data.success)
        throw new Error("Error registering survey completion with Mailchimp");
      return i.data;
    } catch (i) {
      const o = i;
      throw this.log.error(
        `Error registering survey completion with Mailchimp: ${o.name} ${o.message}`,
        { error: o }
      ), new Error(
        "Error registering survey completion with Mailchimp: " + o.name + " " + o.message
      );
    }
  }
  async subscribeMailchimp(n, r, i, o) {
    this.log.info("subscribeMailchimp");
    try {
      const a = await this.subscribeMailchimpFirestore({
        email_address: n,
        merge_fields: r,
        interests: i,
        tags: o
      });
      return a.data.status === "error" && this.log.error("Error subscribing user to Mailchimp"), a.data;
    } catch (a) {
      const s = a;
      return this.log.error(`Error subscribing user to Mailchimp ${s.name} ${s.message}`, {
        error: s
      }), { status: "error" };
    }
  }
  async archiveSubmissions(n, r) {
    this.log.info("archiveSubmissions", n, r), await this.archiveSubmissionsFirestore({ surveyName: n, submissionIds: r });
  }
  /**
   * Explicitly create a brand-new submission document (used by the new public API).
   * This is largely the same logic that used to live inside `createInitialSubmission`,
   * but without any Redux interaction.
   */
  async createSubmission(n, r) {
    this.log.info("createSubmission", n);
    const i = qn.now(), o = this.getNewSubmissionDocRef(n), s = {
      userData: this.getUserData(r),
      answers: {},
      submissionStarted: i,
      surveyCompleted: !1,
      timeSoFarSeconds: 0
    };
    return await this.initialiseSubmission(o, s), { submissionId: o.id };
  }
  /**
   * Load an existing submission and convert it into the shape expected by the survey slice.
   */
  async loadSubmissionState(n, r) {
    this.log.info("loadSubmissionState", { surveyName: n, submissionId: r });
    try {
      const i = this.getExistingSubmissionDocRef(n, r), o = await a5(i);
      if (!o.exists())
        return this.log.warn("Submission does not exist", { submissionId: r }), null;
      const a = o.data();
      return {
        submissionId: r,
        userAnswers: a.answers || {},
        currentQuestionId: a.currentQuestionId ?? void 0,
        currentQuestionType: a.currentQuestionType,
        questionHistory: a.questionHistory ?? [],
        timeOnCurrentQuestion: a.timeSoFarSeconds.toString(),
        isSubmitClicked: a.surveyCompleted || !1,
        direction: "forwards",
        initialised: a.initialised ?? !1
      };
    } catch (i) {
      return this.log.error("Error loading submission state", { error: i }), null;
    }
  }
  async loadExistingState(n, r, i) {
    if (this.log.info("loadExistingState", { surveyName: n, submissionId: i }), !i)
      return null;
    try {
      const o = this.getExistingSubmissionDocRef(n, i), a = await a5(o);
      if (!a.exists())
        return this.log.warn("No existing submission found", { submissionId: i }), null;
      const s = a.data();
      return {
        submissionId: i,
        userAnswers: s.answers || {},
        // We don't store these fields in Firestore, so we'll need to reconstruct them
        currentQuestionId: null,
        currentQuestionType: void 0,
        questionHistory: [],
        timeOnCurrentQuestion: "",
        isSubmitClicked: s.surveyCompleted || !1,
        direction: "forwards"
      };
    } catch (o) {
      return this.log.error("Error loading existing state", { error: o }), null;
    }
  }
}
const Tq = Object.prototype.toString;
function Iq(e) {
  switch (Tq.call(e)) {
    case "[object Error]":
    case "[object Exception]":
    case "[object DOMException]":
      return !0;
    default:
      return cl(e, Error);
  }
}
function gp(e, t) {
  return Tq.call(e) === `[object ${t}]`;
}
function _P(e) {
  return gp(e, "ErrorEvent");
}
function t4(e) {
  return gp(e, "DOMError");
}
function dye(e) {
  return gp(e, "DOMException");
}
function sc(e) {
  return gp(e, "String");
}
function SP(e) {
  return typeof e == "object" && e !== null && "__sentry_template_string__" in e && "__sentry_template_values__" in e;
}
function wP(e) {
  return e === null || SP(e) || typeof e != "object" && typeof e != "function";
}
function mg(e) {
  return gp(e, "Object");
}
function xx(e) {
  return typeof Event < "u" && cl(e, Event);
}
function fye(e) {
  return typeof Element < "u" && cl(e, Element);
}
function hye(e) {
  return gp(e, "RegExp");
}
function Ex(e) {
  return !!(e && e.then && typeof e.then == "function");
}
function gye(e) {
  return mg(e) && "nativeEvent" in e && "preventDefault" in e && "stopPropagation" in e;
}
function Aq(e) {
  return typeof e == "number" && e !== e;
}
function cl(e, t) {
  try {
    return e instanceof t;
  } catch {
    return !1;
  }
}
function Rq(e) {
  return !!(typeof e == "object" && e !== null && (e.__isVue || e._isVue));
}
function Gh(e, t = 0) {
  return typeof e != "string" || t === 0 || e.length <= t ? e : `${e.slice(0, t)}...`;
}
function n4(e, t) {
  if (!Array.isArray(e))
    return "";
  const n = [];
  for (let r = 0; r < e.length; r++) {
    const i = e[r];
    try {
      Rq(i) ? n.push("[VueViewModel]") : n.push(String(i));
    } catch {
      n.push("[value cannot be serialized]");
    }
  }
  return n.join(t);
}
function pye(e, t, n = !1) {
  return sc(e) ? hye(t) ? t.test(e) : sc(t) ? n ? e === t : e.includes(t) : !1 : !1;
}
function pp(e, t = [], n = !1) {
  return t.some((r) => pye(e, r, n));
}
function mye(e, t, n = 250, r, i, o, a) {
  if (!o.exception || !o.exception.values || !a || !cl(a.originalException, Error))
    return;
  const s = o.exception.values.length > 0 ? o.exception.values[o.exception.values.length - 1] : void 0;
  s && (o.exception.values = vye(
    eA(
      e,
      t,
      i,
      a.originalException,
      r,
      o.exception.values,
      s,
      0
    ),
    n
  ));
}
function eA(e, t, n, r, i, o, a, s) {
  if (o.length >= n + 1)
    return o;
  let c = [...o];
  if (cl(r[i], Error)) {
    r4(a, s);
    const l = e(t, r[i]), u = c.length;
    i4(l, i, u, s), c = eA(
      e,
      t,
      n,
      r[i],
      i,
      [l, ...c],
      l,
      u
    );
  }
  return Array.isArray(r.errors) && r.errors.forEach((l, u) => {
    if (cl(l, Error)) {
      r4(a, s);
      const d = e(t, l), f = c.length;
      i4(d, `errors[${u}]`, f, s), c = eA(
        e,
        t,
        n,
        l,
        i,
        [d, ...c],
        d,
        f
      );
    }
  }), c;
}
function r4(e, t) {
  e.mechanism = e.mechanism || { type: "generic", handled: !0 }, e.mechanism = {
    ...e.mechanism,
    ...e.type === "AggregateError" && { is_exception_group: !0 },
    exception_id: t
  };
}
function i4(e, t, n, r) {
  e.mechanism = e.mechanism || { type: "generic", handled: !0 }, e.mechanism = {
    ...e.mechanism,
    type: "chained",
    source: t,
    exception_id: n,
    parent_id: r
  };
}
function vye(e, t) {
  return e.map((n) => (n.value && (n.value = Gh(n.value, t)), n));
}
function xb(e) {
  return e && e.Math == Math ? e : void 0;
}
const An = typeof globalThis == "object" && xb(globalThis) || // eslint-disable-next-line no-restricted-globals
typeof window == "object" && xb(window) || typeof self == "object" && xb(self) || typeof global == "object" && xb(global) || function() {
  return this;
}() || {};
function xP() {
  return An;
}
function $q(e, t, n) {
  const r = n || An, i = r.__SENTRY__ = r.__SENTRY__ || {};
  return i[e] || (i[e] = t());
}
const Kh = xP(), yye = 80;
function xu(e, t = {}) {
  if (!e)
    return "<unknown>";
  try {
    let n = e;
    const r = 5, i = [];
    let o = 0, a = 0;
    const s = " > ", c = s.length;
    let l;
    const u = Array.isArray(t) ? t : t.keyAttrs, d = !Array.isArray(t) && t.maxStringLength || yye;
    for (; n && o++ < r && (l = bye(n, u), !(l === "html" || o > 1 && a + i.length * c + l.length >= d)); )
      i.push(l), a += l.length, n = n.parentNode;
    return i.reverse().join(s);
  } catch {
    return "<unknown>";
  }
}
function bye(e, t) {
  const n = e, r = [];
  let i, o, a, s, c;
  if (!n || !n.tagName)
    return "";
  if (Kh.HTMLElement && n instanceof HTMLElement && n.dataset && n.dataset.sentryComponent)
    return n.dataset.sentryComponent;
  r.push(n.tagName.toLowerCase());
  const l = t && t.length ? t.filter((d) => n.getAttribute(d)).map((d) => [d, n.getAttribute(d)]) : null;
  if (l && l.length)
    l.forEach((d) => {
      r.push(`[${d[0]}="${d[1]}"]`);
    });
  else if (n.id && r.push(`#${n.id}`), i = n.className, i && sc(i))
    for (o = i.split(/\s+/), c = 0; c < o.length; c++)
      r.push(`.${o[c]}`);
  const u = ["aria-label", "type", "name", "title", "alt"];
  for (c = 0; c < u.length; c++)
    a = u[c], s = n.getAttribute(a), s && r.push(`[${a}="${s}"]`);
  return r.join("");
}
function _ye() {
  try {
    return Kh.document.location.href;
  } catch {
    return "";
  }
}
function Sye(e) {
  return Kh.document && Kh.document.querySelector ? Kh.document.querySelector(e) : null;
}
function Oq(e) {
  if (!Kh.HTMLElement)
    return null;
  let t = e;
  const n = 5;
  for (let r = 0; r < n; r++) {
    if (!t)
      return null;
    if (t instanceof HTMLElement && t.dataset.sentryComponent)
      return t.dataset.sentryComponent;
    t = t.parentNode;
  }
  return null;
}
const mp = typeof __SENTRY_DEBUG__ > "u" || __SENTRY_DEBUG__, wye = "Sentry Logger ", tA = [
  "debug",
  "info",
  "warn",
  "error",
  "log",
  "assert",
  "trace"
], L_ = {};
function tf(e) {
  if (!("console" in An))
    return e();
  const t = An.console, n = {}, r = Object.keys(L_);
  r.forEach((i) => {
    const o = L_[i];
    n[i] = t[i], t[i] = o;
  });
  try {
    return e();
  } finally {
    r.forEach((i) => {
      t[i] = n[i];
    });
  }
}
function xye() {
  let e = !1;
  const t = {
    enable: () => {
      e = !0;
    },
    disable: () => {
      e = !1;
    },
    isEnabled: () => e
  };
  return mp ? tA.forEach((n) => {
    t[n] = (...r) => {
      e && tf(() => {
        An.console[n](`${wye}[${n}]:`, ...r);
      });
    };
  }) : tA.forEach((n) => {
    t[n] = () => {
    };
  }), t;
}
const xe = xye(), Eye = /^(?:(\w+):)\/\/(?:(\w+)(?::(\w+)?)?@)([\w.-]+)(?::(\d+))?\/(.+)/;
function Cye(e) {
  return e === "http" || e === "https";
}
function vp(e, t = !1) {
  const { host: n, path: r, pass: i, port: o, projectId: a, protocol: s, publicKey: c } = e;
  return `${s}://${c}${t && i ? `:${i}` : ""}@${n}${o ? `:${o}` : ""}/${r && `${r}/`}${a}`;
}
function Tye(e) {
  const t = Eye.exec(e);
  if (!t) {
    tf(() => {
      console.error(`Invalid Sentry Dsn: ${e}`);
    });
    return;
  }
  const [n, r, i = "", o, a = "", s] = t.slice(1);
  let c = "", l = s;
  const u = l.split("/");
  if (u.length > 1 && (c = u.slice(0, -1).join("/"), l = u.pop()), l) {
    const d = l.match(/^\d+/);
    d && (l = d[0]);
  }
  return Pq({ host: o, pass: i, path: c, projectId: l, port: a, protocol: n, publicKey: r });
}
function Pq(e) {
  return {
    protocol: e.protocol,
    publicKey: e.publicKey || "",
    pass: e.pass || "",
    host: e.host,
    port: e.port || "",
    path: e.path || "",
    projectId: e.projectId
  };
}
function Iye(e) {
  if (!mp)
    return !0;
  const { port: t, projectId: n, protocol: r } = e;
  return ["protocol", "publicKey", "host", "projectId"].find((a) => e[a] ? !1 : (xe.error(`Invalid Sentry Dsn: ${a} missing`), !0)) ? !1 : n.match(/^\d+$/) ? Cye(r) ? t && isNaN(parseInt(t, 10)) ? (xe.error(`Invalid Sentry Dsn: Invalid port ${t}`), !1) : !0 : (xe.error(`Invalid Sentry Dsn: Invalid protocol ${r}`), !1) : (xe.error(`Invalid Sentry Dsn: Invalid projectId ${n}`), !1);
}
function Aye(e) {
  const t = typeof e == "string" ? Tye(e) : Pq(e);
  if (!(!t || !Iye(t)))
    return t;
}
class qs extends Error {
  /** Display name of this error instance. */
  constructor(t, n = "warn") {
    super(t), this.message = t, this.name = new.target.prototype.constructor.name, Object.setPrototypeOf(this, new.target.prototype), this.logLevel = n;
  }
}
function Oi(e, t, n) {
  if (!(t in e))
    return;
  const r = e[t], i = n(r);
  typeof i == "function" && Mq(i, r), e[t] = i;
}
function nf(e, t, n) {
  try {
    Object.defineProperty(e, t, {
      // enumerable: false, // the default, so we can save on bundle size by not explicitly setting it
      value: n,
      writable: !0,
      configurable: !0
    });
  } catch {
    mp && xe.log(`Failed to add non-enumerable property "${t}" to object`, e);
  }
}
function Mq(e, t) {
  try {
    const n = t.prototype || {};
    e.prototype = t.prototype = n, nf(e, "__sentry_original__", t);
  } catch {
  }
}
function EP(e) {
  return e.__sentry_original__;
}
function Rye(e) {
  return Object.keys(e).map((t) => `${encodeURIComponent(t)}=${encodeURIComponent(e[t])}`).join("&");
}
function kq(e) {
  if (Iq(e))
    return {
      message: e.message,
      name: e.name,
      stack: e.stack,
      ...a4(e)
    };
  if (xx(e)) {
    const t = {
      type: e.type,
      target: o4(e.target),
      currentTarget: o4(e.currentTarget),
      ...a4(e)
    };
    return typeof CustomEvent < "u" && cl(e, CustomEvent) && (t.detail = e.detail), t;
  } else
    return e;
}
function o4(e) {
  try {
    return fye(e) ? xu(e) : Object.prototype.toString.call(e);
  } catch {
    return "<unknown>";
  }
}
function a4(e) {
  if (typeof e == "object" && e !== null) {
    const t = {};
    for (const n in e)
      Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
    return t;
  } else
    return {};
}
function $ye(e, t = 40) {
  const n = Object.keys(kq(e));
  if (n.sort(), !n.length)
    return "[object has no keys]";
  if (n[0].length >= t)
    return Gh(n[0], t);
  for (let r = n.length; r > 0; r--) {
    const i = n.slice(0, r).join(", ");
    if (!(i.length > t))
      return r === n.length ? i : Gh(i, t);
  }
  return "";
}
function Ao(e) {
  return nA(e, /* @__PURE__ */ new Map());
}
function nA(e, t) {
  if (Oye(e)) {
    const n = t.get(e);
    if (n !== void 0)
      return n;
    const r = {};
    t.set(e, r);
    for (const i of Object.keys(e))
      typeof e[i] < "u" && (r[i] = nA(e[i], t));
    return r;
  }
  if (Array.isArray(e)) {
    const n = t.get(e);
    if (n !== void 0)
      return n;
    const r = [];
    return t.set(e, r), e.forEach((i) => {
      r.push(nA(i, t));
    }), r;
  }
  return e;
}
function Oye(e) {
  if (!mg(e))
    return !1;
  try {
    const t = Object.getPrototypeOf(e).constructor.name;
    return !t || t === "Object";
  } catch {
    return !0;
  }
}
const Nq = 50, s4 = /\(error: (.*)\)/, c4 = /captureMessage|captureException/;
function Dq(...e) {
  const t = e.sort((n, r) => n[0] - r[0]).map((n) => n[1]);
  return (n, r = 0) => {
    const i = [], o = n.split(`
`);
    for (let a = r; a < o.length; a++) {
      const s = o[a];
      if (s.length > 1024)
        continue;
      const c = s4.test(s) ? s.replace(s4, "$1") : s;
      if (!c.match(/\S*Error: /)) {
        for (const l of t) {
          const u = l(c);
          if (u) {
            i.push(u);
            break;
          }
        }
        if (i.length >= Nq)
          break;
      }
    }
    return Mye(i);
  };
}
function Pye(e) {
  return Array.isArray(e) ? Dq(...e) : e;
}
function Mye(e) {
  if (!e.length)
    return [];
  const t = Array.from(e);
  return /sentryWrapped/.test(t[t.length - 1].function || "") && t.pop(), t.reverse(), c4.test(t[t.length - 1].function || "") && (t.pop(), c4.test(t[t.length - 1].function || "") && t.pop()), t.slice(0, Nq).map((n) => ({
    ...n,
    filename: n.filename || t[t.length - 1].filename,
    function: n.function || "?"
  }));
}
const l5 = "<anonymous>";
function ll(e) {
  try {
    return !e || typeof e != "function" ? l5 : e.name || l5;
  } catch {
    return l5;
  }
}
const D1 = {}, l4 = {};
function Ef(e, t) {
  D1[e] = D1[e] || [], D1[e].push(t);
}
function Cf(e, t) {
  l4[e] || (t(), l4[e] = !0);
}
function ps(e, t) {
  const n = e && D1[e];
  if (n)
    for (const r of n)
      try {
        r(t);
      } catch (i) {
        mp && xe.error(
          `Error while triggering instrumentation handler.
Type: ${e}
Name: ${ll(r)}
Error:`,
          i
        );
      }
}
function kye(e) {
  const t = "console";
  Ef(t, e), Cf(t, Nye);
}
function Nye() {
  "console" in An && tA.forEach(function(e) {
    e in An.console && Oi(An.console, e, function(t) {
      return L_[e] = t, function(...n) {
        ps("console", { args: n, level: e });
        const i = L_[e];
        i && i.apply(An.console, n);
      };
    });
  });
}
function Gr() {
  const e = An, t = e.crypto || e.msCrypto;
  let n = () => Math.random() * 16;
  try {
    if (t && t.randomUUID)
      return t.randomUUID().replace(/-/g, "");
    t && t.getRandomValues && (n = () => {
      const r = new Uint8Array(1);
      return t.getRandomValues(r), r[0];
    });
  } catch {
  }
  return ([1e7] + 1e3 + 4e3 + 8e3 + 1e11).replace(
    /[018]/g,
    (r) => (
      // eslint-disable-next-line no-bitwise
      (r ^ (n() & 15) >> r / 4).toString(16)
    )
  );
}
function Lq(e) {
  return e.exception && e.exception.values ? e.exception.values[0] : void 0;
}
function Ul(e) {
  const { message: t, event_id: n } = e;
  if (t)
    return t;
  const r = Lq(e);
  return r ? r.type && r.value ? `${r.type}: ${r.value}` : r.type || r.value || n || "<unknown>" : n || "<unknown>";
}
function rA(e, t, n) {
  const r = e.exception = e.exception || {}, i = r.values = r.values || [], o = i[0] = i[0] || {};
  o.value || (o.value = t || ""), o.type || (o.type = n || "Error");
}
function q0(e, t) {
  const n = Lq(e);
  if (!n)
    return;
  const r = { type: "generic", handled: !0 }, i = n.mechanism;
  if (n.mechanism = { ...r, ...i, ...t }, t && "data" in t) {
    const o = { ...i && i.data, ...t.data };
    n.mechanism.data = o;
  }
}
function u4(e) {
  if (e && e.__sentry_captured__)
    return !0;
  try {
    nf(e, "__sentry_captured__", !0);
  } catch {
  }
  return !1;
}
function jq(e) {
  return Array.isArray(e) ? e : [e];
}
const Eh = An, Dye = 1e3;
let d4, iA, oA;
function Fq(e) {
  const t = "dom";
  Ef(t, e), Cf(t, Lye);
}
function Lye() {
  if (!Eh.document)
    return;
  const e = ps.bind(null, "dom"), t = f4(e, !0);
  Eh.document.addEventListener("click", t, !1), Eh.document.addEventListener("keypress", t, !1), ["EventTarget", "Node"].forEach((n) => {
    const r = Eh[n] && Eh[n].prototype;
    !r || !r.hasOwnProperty || !r.hasOwnProperty("addEventListener") || (Oi(r, "addEventListener", function(i) {
      return function(o, a, s) {
        if (o === "click" || o == "keypress")
          try {
            const c = this, l = c.__sentry_instrumentation_handlers__ = c.__sentry_instrumentation_handlers__ || {}, u = l[o] = l[o] || { refCount: 0 };
            if (!u.handler) {
              const d = f4(e);
              u.handler = d, i.call(this, o, d, s);
            }
            u.refCount++;
          } catch {
          }
        return i.call(this, o, a, s);
      };
    }), Oi(
      r,
      "removeEventListener",
      function(i) {
        return function(o, a, s) {
          if (o === "click" || o == "keypress")
            try {
              const c = this, l = c.__sentry_instrumentation_handlers__ || {}, u = l[o];
              u && (u.refCount--, u.refCount <= 0 && (i.call(this, o, u.handler, s), u.handler = void 0, delete l[o]), Object.keys(l).length === 0 && delete c.__sentry_instrumentation_handlers__);
            } catch {
            }
          return i.call(this, o, a, s);
        };
      }
    ));
  });
}
function jye(e) {
  if (e.type !== iA)
    return !1;
  try {
    if (!e.target || e.target._sentryId !== oA)
      return !1;
  } catch {
  }
  return !0;
}
function Fye(e, t) {
  return e !== "keypress" ? !1 : !t || !t.tagName ? !0 : !(t.tagName === "INPUT" || t.tagName === "TEXTAREA" || t.isContentEditable);
}
function f4(e, t = !1) {
  return (n) => {
    if (!n || n._sentryCaptured)
      return;
    const r = Vye(n);
    if (Fye(n.type, r))
      return;
    nf(n, "_sentryCaptured", !0), r && !r._sentryId && nf(r, "_sentryId", Gr());
    const i = n.type === "keypress" ? "input" : n.type;
    jye(n) || (e({ event: n, name: i, global: t }), iA = n.type, oA = r ? r._sentryId : void 0), clearTimeout(d4), d4 = Eh.setTimeout(() => {
      oA = void 0, iA = void 0;
    }, Dye);
  };
}
function Vye(e) {
  try {
    return e.target;
  } catch {
    return null;
  }
}
const aA = xP();
function Vq() {
  if (!("fetch" in aA))
    return !1;
  try {
    return new Headers(), new Request("http://www.example.com"), new Response(), !0;
  } catch {
    return !1;
  }
}
function sA(e) {
  return e && /^function fetch\(\)\s+\{\s+\[native code\]\s+\}$/.test(e.toString());
}
function Bye() {
  if (typeof EdgeRuntime == "string")
    return !0;
  if (!Vq())
    return !1;
  if (sA(aA.fetch))
    return !0;
  let e = !1;
  const t = aA.document;
  if (t && typeof t.createElement == "function")
    try {
      const n = t.createElement("iframe");
      n.hidden = !0, t.head.appendChild(n), n.contentWindow && n.contentWindow.fetch && (e = sA(n.contentWindow.fetch)), t.head.removeChild(n);
    } catch (n) {
      mp && xe.warn("Could not create sandbox iframe for pure fetch check, bailing to window.fetch: ", n);
    }
  return e;
}
function CP(e) {
  const t = "fetch";
  Ef(t, e), Cf(t, zye);
}
function zye() {
  Bye() && Oi(An, "fetch", function(e) {
    return function(...t) {
      const { method: n, url: r } = Hye(t), i = {
        args: t,
        fetchData: {
          method: n,
          url: r
        },
        startTimestamp: Date.now()
      };
      return ps("fetch", {
        ...i
      }), e.apply(An, t).then(
        (o) => {
          const a = {
            ...i,
            endTimestamp: Date.now(),
            response: o
          };
          return ps("fetch", a), o;
        },
        (o) => {
          const a = {
            ...i,
            endTimestamp: Date.now(),
            error: o
          };
          throw ps("fetch", a), o;
        }
      );
    };
  });
}
function cA(e, t) {
  return !!e && typeof e == "object" && !!e[t];
}
function h4(e) {
  return typeof e == "string" ? e : e ? cA(e, "url") ? e.url : e.toString ? e.toString() : "" : "";
}
function Hye(e) {
  if (e.length === 0)
    return { method: "GET", url: "" };
  if (e.length === 2) {
    const [n, r] = e;
    return {
      url: h4(n),
      method: cA(r, "method") ? String(r.method).toUpperCase() : "GET"
    };
  }
  const t = e[0];
  return {
    url: h4(t),
    method: cA(t, "method") ? String(t.method).toUpperCase() : "GET"
  };
}
let Eb = null;
function Bq(e) {
  const t = "error";
  Ef(t, e), Cf(t, Uye);
}
function Uye() {
  Eb = An.onerror, An.onerror = function(e, t, n, r, i) {
    return ps("error", {
      column: r,
      error: i,
      line: n,
      msg: e,
      url: t
    }), Eb && !Eb.__SENTRY_LOADER__ ? Eb.apply(this, arguments) : !1;
  }, An.onerror.__SENTRY_INSTRUMENTED__ = !0;
}
let Cb = null;
function zq(e) {
  const t = "unhandledrejection";
  Ef(t, e), Cf(t, Wye);
}
function Wye() {
  Cb = An.onunhandledrejection, An.onunhandledrejection = function(e) {
    return ps("unhandledrejection", e), Cb && !Cb.__SENTRY_LOADER__ ? Cb.apply(this, arguments) : !0;
  }, An.onunhandledrejection.__SENTRY_INSTRUMENTED__ = !0;
}
const Tb = xP();
function qye() {
  const e = Tb.chrome, t = e && e.app && e.app.runtime, n = "history" in Tb && !!Tb.history.pushState && !!Tb.history.replaceState;
  return !t && n;
}
const sm = An;
let Ib;
function Cx(e) {
  const t = "history";
  Ef(t, e), Cf(t, Gye);
}
function Gye() {
  if (!qye())
    return;
  const e = sm.onpopstate;
  sm.onpopstate = function(...n) {
    const r = sm.location.href, i = Ib;
    if (Ib = r, ps("history", { from: i, to: r }), e)
      try {
        return e.apply(this, n);
      } catch {
      }
  };
  function t(n) {
    return function(...r) {
      const i = r.length > 2 ? r[2] : void 0;
      if (i) {
        const o = Ib, a = String(i);
        Ib = a, ps("history", { from: o, to: a });
      }
      return n.apply(this, r);
    };
  }
  Oi(sm.history, "pushState", t), Oi(sm.history, "replaceState", t);
}
const Kye = An, Gl = "__sentry_xhr_v3__";
function TP(e) {
  const t = "xhr";
  Ef(t, e), Cf(t, Yye);
}
function Yye() {
  if (!Kye.XMLHttpRequest)
    return;
  const e = XMLHttpRequest.prototype;
  Oi(e, "open", function(t) {
    return function(...n) {
      const r = Date.now(), i = sc(n[0]) ? n[0].toUpperCase() : void 0, o = Xye(n[1]);
      if (!i || !o)
        return t.apply(this, n);
      this[Gl] = {
        method: i,
        url: o,
        request_headers: {}
      }, i === "POST" && o.match(/sentry_key/) && (this.__sentry_own_request__ = !0);
      const a = () => {
        const s = this[Gl];
        if (s && this.readyState === 4) {
          try {
            s.status_code = this.status;
          } catch {
          }
          const c = {
            args: [i, o],
            endTimestamp: Date.now(),
            startTimestamp: r,
            xhr: this
          };
          ps("xhr", c);
        }
      };
      return "onreadystatechange" in this && typeof this.onreadystatechange == "function" ? Oi(this, "onreadystatechange", function(s) {
        return function(...c) {
          return a(), s.apply(this, c);
        };
      }) : this.addEventListener("readystatechange", a), Oi(this, "setRequestHeader", function(s) {
        return function(...c) {
          const [l, u] = c, d = this[Gl];
          return d && sc(l) && sc(u) && (d.request_headers[l.toLowerCase()] = u), s.apply(this, c);
        };
      }), t.apply(this, n);
    };
  }), Oi(e, "send", function(t) {
    return function(...n) {
      const r = this[Gl];
      if (!r)
        return t.apply(this, n);
      n[0] !== void 0 && (r.body = n[0]);
      const i = {
        args: [r.method, r.url],
        startTimestamp: Date.now(),
        xhr: this
      };
      return ps("xhr", i), t.apply(this, n);
    };
  });
}
function Xye(e) {
  if (sc(e))
    return e;
  try {
    return e.toString();
  } catch {
  }
}
function Qye() {
  return typeof __SENTRY_BROWSER_BUNDLE__ < "u" && !!__SENTRY_BROWSER_BUNDLE__;
}
function Jye() {
  return "npm";
}
function Zye() {
  return !Qye() && Object.prototype.toString.call(typeof process < "u" ? process : 0) === "[object process]";
}
function g4() {
  return typeof window < "u" && (!Zye() || ebe());
}
function ebe() {
  return (
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-explicit-any
    An.process !== void 0 && An.process.type === "renderer"
  );
}
function tbe() {
  const e = typeof WeakSet == "function", t = e ? /* @__PURE__ */ new WeakSet() : [];
  function n(i) {
    if (e)
      return t.has(i) ? !0 : (t.add(i), !1);
    for (let o = 0; o < t.length; o++)
      if (t[o] === i)
        return !0;
    return t.push(i), !1;
  }
  function r(i) {
    if (e)
      t.delete(i);
    else
      for (let o = 0; o < t.length; o++)
        if (t[o] === i) {
          t.splice(o, 1);
          break;
        }
  }
  return [n, r];
}
function Us(e, t = 100, n = 1 / 0) {
  try {
    return lA("", e, t, n);
  } catch (r) {
    return { ERROR: `**non-serializable** (${r})` };
  }
}
function Hq(e, t = 3, n = 100 * 1024) {
  const r = Us(e, t);
  return obe(r) > n ? Hq(e, t - 1, n) : r;
}
function lA(e, t, n = 1 / 0, r = 1 / 0, i = tbe()) {
  const [o, a] = i;
  if (t == null || // this matches null and undefined -> eqeq not eqeqeq
  ["number", "boolean", "string"].includes(typeof t) && !Aq(t))
    return t;
  const s = nbe(e, t);
  if (!s.startsWith("[object "))
    return s;
  if (t.__sentry_skip_normalization__)
    return t;
  const c = typeof t.__sentry_override_normalization_depth__ == "number" ? t.__sentry_override_normalization_depth__ : n;
  if (c === 0)
    return s.replace("object ", "");
  if (o(t))
    return "[Circular ~]";
  const l = t;
  if (l && typeof l.toJSON == "function")
    try {
      const h = l.toJSON();
      return lA("", h, c - 1, r, i);
    } catch {
    }
  const u = Array.isArray(t) ? [] : {};
  let d = 0;
  const f = kq(t);
  for (const h in f) {
    if (!Object.prototype.hasOwnProperty.call(f, h))
      continue;
    if (d >= r) {
      u[h] = "[MaxProperties ~]";
      break;
    }
    const p = f[h];
    u[h] = lA(h, p, c - 1, r, i), d++;
  }
  return a(t), u;
}
function nbe(e, t) {
  try {
    if (e === "domain" && t && typeof t == "object" && t._events)
      return "[Domain]";
    if (e === "domainEmitter")
      return "[DomainEmitter]";
    if (typeof global < "u" && t === global)
      return "[Global]";
    if (typeof window < "u" && t === window)
      return "[Window]";
    if (typeof document < "u" && t === document)
      return "[Document]";
    if (Rq(t))
      return "[VueViewModel]";
    if (gye(t))
      return "[SyntheticEvent]";
    if (typeof t == "number" && t !== t)
      return "[NaN]";
    if (typeof t == "function")
      return `[Function: ${ll(t)}]`;
    if (typeof t == "symbol")
      return `[${String(t)}]`;
    if (typeof t == "bigint")
      return `[BigInt: ${String(t)}]`;
    const n = rbe(t);
    return /^HTML(\w*)Element$/.test(n) ? `[HTMLElement: ${n}]` : `[object ${n}]`;
  } catch (n) {
    return `**non-serializable** (${n})`;
  }
}
function rbe(e) {
  const t = Object.getPrototypeOf(e);
  return t ? t.constructor.name : "null prototype";
}
function ibe(e) {
  return ~-encodeURI(e).split(/%..|./).length;
}
function obe(e) {
  return ibe(JSON.stringify(e));
}
var Dc;
(function(e) {
  e[e.PENDING = 0] = "PENDING";
  const n = 1;
  e[e.RESOLVED = n] = "RESOLVED";
  const r = 2;
  e[e.REJECTED = r] = "REJECTED";
})(Dc || (Dc = {}));
function vg(e) {
  return new fa((t) => {
    t(e);
  });
}
function IP(e) {
  return new fa((t, n) => {
    n(e);
  });
}
class fa {
  constructor(t) {
    fa.prototype.__init.call(this), fa.prototype.__init2.call(this), fa.prototype.__init3.call(this), fa.prototype.__init4.call(this), this._state = Dc.PENDING, this._handlers = [];
    try {
      t(this._resolve, this._reject);
    } catch (n) {
      this._reject(n);
    }
  }
  /** JSDoc */
  then(t, n) {
    return new fa((r, i) => {
      this._handlers.push([
        !1,
        (o) => {
          if (!t)
            r(o);
          else
            try {
              r(t(o));
            } catch (a) {
              i(a);
            }
        },
        (o) => {
          if (!n)
            i(o);
          else
            try {
              r(n(o));
            } catch (a) {
              i(a);
            }
        }
      ]), this._executeHandlers();
    });
  }
  /** JSDoc */
  catch(t) {
    return this.then((n) => n, t);
  }
  /** JSDoc */
  finally(t) {
    return new fa((n, r) => {
      let i, o;
      return this.then(
        (a) => {
          o = !1, i = a, t && t();
        },
        (a) => {
          o = !0, i = a, t && t();
        }
      ).then(() => {
        if (o) {
          r(i);
          return;
        }
        n(i);
      });
    });
  }
  /** JSDoc */
  __init() {
    this._resolve = (t) => {
      this._setResult(Dc.RESOLVED, t);
    };
  }
  /** JSDoc */
  __init2() {
    this._reject = (t) => {
      this._setResult(Dc.REJECTED, t);
    };
  }
  /** JSDoc */
  __init3() {
    this._setResult = (t, n) => {
      if (this._state === Dc.PENDING) {
        if (Ex(n)) {
          n.then(this._resolve, this._reject);
          return;
        }
        this._state = t, this._value = n, this._executeHandlers();
      }
    };
  }
  /** JSDoc */
  __init4() {
    this._executeHandlers = () => {
      if (this._state === Dc.PENDING)
        return;
      const t = this._handlers.slice();
      this._handlers = [], t.forEach((n) => {
        n[0] || (this._state === Dc.RESOLVED && n[1](this._value), this._state === Dc.REJECTED && n[2](this._value), n[0] = !0);
      });
    };
  }
}
function abe(e) {
  const t = [];
  function n() {
    return e === void 0 || t.length < e;
  }
  function r(a) {
    return t.splice(t.indexOf(a), 1)[0];
  }
  function i(a) {
    if (!n())
      return IP(new qs("Not adding Promise because buffer limit was reached."));
    const s = a();
    return t.indexOf(s) === -1 && t.push(s), s.then(() => r(s)).then(
      null,
      () => r(s).then(null, () => {
      })
    ), s;
  }
  function o(a) {
    return new fa((s, c) => {
      let l = t.length;
      if (!l)
        return s(!0);
      const u = setTimeout(() => {
        a && a > 0 && s(!1);
      }, a);
      t.forEach((d) => {
        vg(d).then(() => {
          --l || (clearTimeout(u), s(!0));
        }, c);
      });
    });
  }
  return {
    $: t,
    add: i,
    drain: o
  };
}
function Nd(e) {
  if (!e)
    return {};
  const t = e.match(/^(([^:/?#]+):)?(\/\/([^/?#]*))?([^?#]*)(\?([^#]*))?(#(.*))?$/);
  if (!t)
    return {};
  const n = t[6] || "", r = t[8] || "";
  return {
    host: t[4],
    path: t[5],
    protocol: t[2],
    search: n,
    hash: r,
    relative: t[5] + n + r
    // everything minus origin
  };
}
const sbe = ["fatal", "error", "warning", "log", "info", "debug"];
function cbe(e) {
  return e === "warn" ? "warning" : sbe.includes(e) ? e : "log";
}
const Uq = 1e3;
function Xv() {
  return Date.now() / Uq;
}
function lbe() {
  const { performance: e } = An;
  if (!e || !e.now)
    return Xv;
  const t = Date.now() - e.now(), n = e.timeOrigin == null ? t : e.timeOrigin;
  return () => (n + e.now()) / Uq;
}
const Qv = lbe(), ba = (() => {
  const { performance: e } = An;
  if (!e || !e.now)
    return;
  const t = 3600 * 1e3, n = e.now(), r = Date.now(), i = e.timeOrigin ? Math.abs(e.timeOrigin + n - r) : t, o = i < t, a = e.timing && e.timing.navigationStart, c = typeof a == "number" ? Math.abs(a + n - r) : t, l = c < t;
  return o || l ? i <= c ? e.timeOrigin : a : r;
})(), uA = "baggage", Wq = "sentry-", ube = /^sentry-/, dbe = 8192;
function fbe(e) {
  if (!sc(e) && !Array.isArray(e))
    return;
  let t = {};
  if (Array.isArray(e))
    t = e.reduce((r, i) => {
      const o = p4(i);
      for (const a of Object.keys(o))
        r[a] = o[a];
      return r;
    }, {});
  else {
    if (!e)
      return;
    t = p4(e);
  }
  const n = Object.entries(t).reduce((r, [i, o]) => {
    if (i.match(ube)) {
      const a = i.slice(Wq.length);
      r[a] = o;
    }
    return r;
  }, {});
  if (Object.keys(n).length > 0)
    return n;
}
function qq(e) {
  if (!e)
    return;
  const t = Object.entries(e).reduce(
    (n, [r, i]) => (i && (n[`${Wq}${r}`] = i), n),
    {}
  );
  return hbe(t);
}
function p4(e) {
  return e.split(",").map((t) => t.split("=").map((n) => decodeURIComponent(n.trim()))).reduce((t, [n, r]) => (t[n] = r, t), {});
}
function hbe(e) {
  if (Object.keys(e).length !== 0)
    return Object.entries(e).reduce((t, [n, r], i) => {
      const o = `${encodeURIComponent(n)}=${encodeURIComponent(r)}`, a = i === 0 ? o : `${t},${o}`;
      return a.length > dbe ? (mp && xe.warn(
        `Not adding key: ${n} with val: ${r} to baggage header due to exceeding baggage size limits.`
      ), t) : a;
    }, "");
}
const gbe = new RegExp(
  "^[ \\t]*([0-9a-f]{32})?-?([0-9a-f]{16})?-?([01])?[ \\t]*$"
  // whitespace
);
function pbe(e) {
  if (!e)
    return;
  const t = e.match(gbe);
  if (!t)
    return;
  let n;
  return t[3] === "1" ? n = !0 : t[3] === "0" && (n = !1), {
    traceId: t[1],
    parentSampled: n,
    parentSpanId: t[2]
  };
}
function mbe(e, t) {
  const n = pbe(e), r = fbe(t), { traceId: i, parentSpanId: o, parentSampled: a } = n || {};
  return n ? {
    traceId: i || Gr(),
    parentSpanId: o || Gr().substring(16),
    spanId: Gr().substring(16),
    sampled: a,
    dsc: r || {}
    // If we have traceparent data but no DSC it means we are not head of trace and we must freeze it
  } : {
    traceId: i || Gr(),
    spanId: Gr().substring(16)
  };
}
function AP(e = Gr(), t = Gr().substring(16), n) {
  let r = "";
  return n !== void 0 && (r = n ? "-1" : "-0"), `${e}-${t}${r}`;
}
function Vu(e, t = []) {
  return [e, t];
}
function vbe(e, t) {
  const [n, r] = e;
  return [n, [...r, t]];
}
function m4(e, t) {
  const n = e[1];
  for (const r of n) {
    const i = r[0].type;
    if (t(r, i))
      return !0;
  }
  return !1;
}
function dA(e, t) {
  return (t || new TextEncoder()).encode(e);
}
function ybe(e, t) {
  const [n, r] = e;
  let i = JSON.stringify(n);
  function o(a) {
    typeof i == "string" ? i = typeof a == "string" ? i + a : [dA(i, t), a] : i.push(typeof a == "string" ? dA(a, t) : a);
  }
  for (const a of r) {
    const [s, c] = a;
    if (o(`
${JSON.stringify(s)}
`), typeof c == "string" || c instanceof Uint8Array)
      o(c);
    else {
      let l;
      try {
        l = JSON.stringify(c);
      } catch {
        l = JSON.stringify(Us(c));
      }
      o(l);
    }
  }
  return typeof i == "string" ? i : bbe(i);
}
function bbe(e) {
  const t = e.reduce((i, o) => i + o.length, 0), n = new Uint8Array(t);
  let r = 0;
  for (const i of e)
    n.set(i, r), r += i.length;
  return n;
}
function _be(e, t) {
  const n = typeof e.data == "string" ? dA(e.data, t) : e.data;
  return [
    Ao({
      type: "attachment",
      length: n.length,
      filename: e.filename,
      content_type: e.contentType,
      attachment_type: e.attachmentType
    }),
    n
  ];
}
const Sbe = {
  session: "session",
  sessions: "session",
  attachment: "attachment",
  transaction: "transaction",
  event: "error",
  client_report: "internal",
  user_report: "default",
  profile: "profile",
  replay_event: "replay",
  replay_recording: "replay",
  check_in: "monitor",
  feedback: "feedback",
  span: "span",
  statsd: "metric_bucket"
};
function v4(e) {
  return Sbe[e];
}
function RP(e) {
  if (!e || !e.sdk)
    return;
  const { name: t, version: n } = e.sdk;
  return { name: t, version: n };
}
function Gq(e, t, n, r) {
  const i = e.sdkProcessingMetadata && e.sdkProcessingMetadata.dynamicSamplingContext;
  return {
    event_id: e.event_id,
    sent_at: (/* @__PURE__ */ new Date()).toISOString(),
    ...t && { sdk: t },
    ...!!n && r && { dsn: vp(r) },
    ...i && {
      trace: Ao({ ...i })
    }
  };
}
function wbe(e, t, n) {
  const r = [
    { type: "client_report" },
    {
      timestamp: n || Xv(),
      discarded_events: e
    }
  ];
  return Vu(t ? { dsn: t } : {}, [r]);
}
const xbe = 60 * 1e3;
function Ebe(e, t = Date.now()) {
  const n = parseInt(`${e}`, 10);
  if (!isNaN(n))
    return n * 1e3;
  const r = Date.parse(`${e}`);
  return isNaN(r) ? xbe : r - t;
}
function Cbe(e, t) {
  return e[t] || e.all || 0;
}
function Kq(e, t, n = Date.now()) {
  return Cbe(e, t) > n;
}
function Yq(e, { statusCode: t, headers: n }, r = Date.now()) {
  const i = {
    ...e
  }, o = n && n["x-sentry-rate-limits"], a = n && n["retry-after"];
  if (o)
    for (const s of o.trim().split(",")) {
      const [c, l, , , u] = s.split(":", 5), d = parseInt(c, 10), f = (isNaN(d) ? 60 : d) * 1e3;
      if (!l)
        i.all = r + f;
      else
        for (const h of l.split(";"))
          h === "metric_bucket" ? (!u || u.split(";").includes("custom")) && (i[h] = r + f) : i[h] = r + f;
    }
  else
    a ? i.all = r + Ebe(a, r) : t === 429 && (i.all = r + 60 * 1e3);
  return i;
}
function Tbe(e, t) {
  return e ?? t();
}
function u5(e) {
  let t, n = e[0], r = 1;
  for (; r < e.length; ) {
    const i = e[r], o = e[r + 1];
    if (r += 2, (i === "optionalAccess" || i === "optionalCall") && n == null)
      return;
    i === "access" || i === "optionalAccess" ? (t = n, n = o(n)) : (i === "call" || i === "optionalCall") && (n = o((...a) => n.call(t, ...a)), t = void 0);
  }
  return n;
}
const Mt = typeof __SENTRY_DEBUG__ > "u" || __SENTRY_DEBUG__, Tx = "production";
function $P() {
  return $q("globalEventProcessors", () => []);
}
function Ibe(e) {
  $P().push(e);
}
function j_(e, t, n, r = 0) {
  return new fa((i, o) => {
    const a = e[r];
    if (t === null || typeof a != "function")
      i(t);
    else {
      const s = a({ ...t }, n);
      Mt && a.id && s === null && xe.log(`Event processor "${a.id}" dropped event`), Ex(s) ? s.then((c) => j_(e, c, n, r + 1).then(i)).then(null, o) : j_(e, s, n, r + 1).then(i).then(null, o);
    }
  });
}
function Xq(e) {
  const t = Qv(), n = {
    sid: Gr(),
    init: !0,
    timestamp: t,
    started: t,
    duration: 0,
    status: "ok",
    errors: 0,
    ignoreDuration: !1,
    toJSON: () => Abe(n)
  };
  return e && rf(n, e), n;
}
function rf(e, t = {}) {
  if (t.user && (!e.ipAddress && t.user.ip_address && (e.ipAddress = t.user.ip_address), !e.did && !t.did && (e.did = t.user.id || t.user.email || t.user.username)), e.timestamp = t.timestamp || Qv(), t.abnormal_mechanism && (e.abnormal_mechanism = t.abnormal_mechanism), t.ignoreDuration && (e.ignoreDuration = t.ignoreDuration), t.sid && (e.sid = t.sid.length === 32 ? t.sid : Gr()), t.init !== void 0 && (e.init = t.init), !e.did && t.did && (e.did = `${t.did}`), typeof t.started == "number" && (e.started = t.started), e.ignoreDuration)
    e.duration = void 0;
  else if (typeof t.duration == "number")
    e.duration = t.duration;
  else {
    const n = e.timestamp - e.started;
    e.duration = n >= 0 ? n : 0;
  }
  t.release && (e.release = t.release), t.environment && (e.environment = t.environment), !e.ipAddress && t.ipAddress && (e.ipAddress = t.ipAddress), !e.userAgent && t.userAgent && (e.userAgent = t.userAgent), typeof t.errors == "number" && (e.errors = t.errors), t.status && (e.status = t.status);
}
function Qq(e, t) {
  let n = {};
  t ? n = { status: t } : e.status === "ok" && (n = { status: "exited" }), rf(e, n);
}
function Abe(e) {
  return Ao({
    sid: `${e.sid}`,
    init: e.init,
    // Make sure that sec is converted to ms for date constructor
    started: new Date(e.started * 1e3).toISOString(),
    timestamp: new Date(e.timestamp * 1e3).toISOString(),
    status: e.status,
    errors: e.errors,
    did: typeof e.did == "number" || typeof e.did == "string" ? `${e.did}` : void 0,
    duration: e.duration,
    abnormal_mechanism: e.abnormal_mechanism,
    attrs: {
      release: e.release,
      environment: e.environment,
      ip_address: e.ipAddress,
      user_agent: e.userAgent
    }
  });
}
const Rbe = 0, Jq = 1;
function OP(e) {
  const { spanId: t, traceId: n } = e.spanContext(), { data: r, op: i, parent_span_id: o, status: a, tags: s, origin: c } = Ui(e);
  return Ao({
    data: r,
    op: i,
    parent_span_id: o,
    span_id: t,
    status: a,
    tags: s,
    trace_id: n,
    origin: c
  });
}
function Ix(e) {
  const { traceId: t, spanId: n } = e.spanContext(), r = PP(e);
  return AP(t, n, r);
}
function Ax(e) {
  return typeof e == "number" ? y4(e) : Array.isArray(e) ? e[0] + e[1] / 1e9 : e instanceof Date ? y4(e.getTime()) : Qv();
}
function y4(e) {
  return e > 9999999999 ? e / 1e3 : e;
}
function Ui(e) {
  return $be(e) ? e.getSpanJSON() : typeof e.toJSON == "function" ? e.toJSON() : {};
}
function $be(e) {
  return typeof e.getSpanJSON == "function";
}
function PP(e) {
  const { traceFlags: t } = e.spanContext();
  return !!(t & Jq);
}
function Zq(e, t, n, r, i, o) {
  const { normalizeDepth: a = 3, normalizeMaxBreadth: s = 1e3 } = e, c = {
    ...t,
    event_id: t.event_id || n.event_id || Gr(),
    timestamp: t.timestamp || Xv()
  }, l = n.integrations || e.integrations.map((m) => m.name);
  Obe(c, e), kbe(c, l), t.type === void 0 && Pbe(c, e.stackParser);
  const u = Dbe(r, n.captureContext);
  n.mechanism && q0(c, n.mechanism);
  const d = i && i.getEventProcessors ? i.getEventProcessors() : [], f = Ybe().getScopeData();
  if (o) {
    const m = o.getScopeData();
    w4(f, m);
  }
  if (u) {
    const m = u.getScopeData();
    w4(f, m);
  }
  const h = [...n.attachments || [], ...f.attachments];
  h.length && (n.attachments = h), rG(c, f);
  const p = [
    ...d,
    // eslint-disable-next-line deprecation/deprecation
    ...$P(),
    // Run scope event processors _after_ all other processors
    ...f.eventProcessors
  ];
  return j_(p, c, n).then((m) => (m && Mbe(m), typeof a == "number" && a > 0 ? Nbe(m, a, s) : m));
}
function Obe(e, t) {
  const { environment: n, release: r, dist: i, maxValueLength: o = 250 } = t;
  "environment" in e || (e.environment = "environment" in t ? n : Tx), e.release === void 0 && r !== void 0 && (e.release = r), e.dist === void 0 && i !== void 0 && (e.dist = i), e.message && (e.message = Gh(e.message, o));
  const a = e.exception && e.exception.values && e.exception.values[0];
  a && a.value && (a.value = Gh(a.value, o));
  const s = e.request;
  s && s.url && (s.url = Gh(s.url, o));
}
const b4 = /* @__PURE__ */ new WeakMap();
function Pbe(e, t) {
  const n = An._sentryDebugIds;
  if (!n)
    return;
  let r;
  const i = b4.get(t);
  i ? r = i : (r = /* @__PURE__ */ new Map(), b4.set(t, r));
  const o = Object.keys(n).reduce((a, s) => {
    let c;
    const l = r.get(s);
    l ? c = l : (c = t(s), r.set(s, c));
    for (let u = c.length - 1; u >= 0; u--) {
      const d = c[u];
      if (d.filename) {
        a[d.filename] = n[s];
        break;
      }
    }
    return a;
  }, {});
  try {
    e.exception.values.forEach((a) => {
      a.stacktrace.frames.forEach((s) => {
        s.filename && (s.debug_id = o[s.filename]);
      });
    });
  } catch {
  }
}
function Mbe(e) {
  const t = {};
  try {
    e.exception.values.forEach((r) => {
      r.stacktrace.frames.forEach((i) => {
        i.debug_id && (i.abs_path ? t[i.abs_path] = i.debug_id : i.filename && (t[i.filename] = i.debug_id), delete i.debug_id);
      });
    });
  } catch {
  }
  if (Object.keys(t).length === 0)
    return;
  e.debug_meta = e.debug_meta || {}, e.debug_meta.images = e.debug_meta.images || [];
  const n = e.debug_meta.images;
  Object.keys(t).forEach((r) => {
    n.push({
      type: "sourcemap",
      code_file: r,
      debug_id: t[r]
    });
  });
}
function kbe(e, t) {
  t.length > 0 && (e.sdk = e.sdk || {}, e.sdk.integrations = [...e.sdk.integrations || [], ...t]);
}
function Nbe(e, t, n) {
  if (!e)
    return null;
  const r = {
    ...e,
    ...e.breadcrumbs && {
      breadcrumbs: e.breadcrumbs.map((i) => ({
        ...i,
        ...i.data && {
          data: Us(i.data, t, n)
        }
      }))
    },
    ...e.user && {
      user: Us(e.user, t, n)
    },
    ...e.contexts && {
      contexts: Us(e.contexts, t, n)
    },
    ...e.extra && {
      extra: Us(e.extra, t, n)
    }
  };
  return e.contexts && e.contexts.trace && r.contexts && (r.contexts.trace = e.contexts.trace, e.contexts.trace.data && (r.contexts.trace.data = Us(e.contexts.trace.data, t, n))), e.spans && (r.spans = e.spans.map((i) => {
    const o = Ui(i).data;
    return o && (i.data = Us(o, t, n)), i;
  })), r;
}
function Dbe(e, t) {
  if (!t)
    return e;
  const n = e ? e.clone() : new Xc();
  return n.update(t), n;
}
function Lbe(e) {
  if (e)
    return jbe(e) ? { captureContext: e } : Vbe(e) ? {
      captureContext: e
    } : e;
}
function jbe(e) {
  return e instanceof Xc || typeof e == "function";
}
const Fbe = [
  "user",
  "level",
  "extra",
  "contexts",
  "tags",
  "fingerprint",
  "requestSession",
  "propagationContext"
];
function Vbe(e) {
  return Object.keys(e).some((t) => Fbe.includes(t));
}
function Rx(e, t) {
  return Ea().captureException(e, Lbe(t));
}
function eG(e, t) {
  return Ea().captureEvent(e, t);
}
function Eu(e, t) {
  Ea().addBreadcrumb(e, t);
}
function Bbe(e, t) {
  Ea().setContext(e, t);
}
function zbe(...e) {
  const t = Ea();
  if (e.length === 2) {
    const [n, r] = e;
    return n ? t.withScope(() => (t.getStackTop().scope = n, r(n))) : t.withScope(r);
  }
  return t.withScope(e[0]);
}
function Yn() {
  return Ea().getClient();
}
function xa() {
  return Ea().getScope();
}
function _4(e) {
  const t = Yn(), n = Bu(), r = xa(), { release: i, environment: o = Tx } = t && t.getOptions() || {}, { userAgent: a } = An.navigator || {}, s = Xq({
    release: i,
    environment: o,
    user: r.getUser() || n.getUser(),
    ...a && { userAgent: a },
    ...e
  }), c = n.getSession();
  return c && c.status === "ok" && rf(c, { status: "exited" }), tG(), n.setSession(s), r.setSession(s), s;
}
function tG() {
  const e = Bu(), t = xa(), n = t.getSession() || e.getSession();
  n && Qq(n), nG(), e.setSession(), t.setSession();
}
function nG() {
  const e = Bu(), t = xa(), n = Yn(), r = t.getSession() || e.getSession();
  r && n && n.captureSession && n.captureSession(r);
}
function S4(e = !1) {
  if (e) {
    tG();
    return;
  }
  nG();
}
function F_(e) {
  return e.transaction;
}
function $x(e, t, n) {
  const r = t.getOptions(), { publicKey: i } = t.getDsn() || {}, { segment: o } = n && n.getUser() || {}, a = Ao({
    environment: r.environment || Tx,
    release: r.release,
    user_segment: o,
    public_key: i,
    trace_id: e
  });
  return t.emit && t.emit("createDsc", a), a;
}
function yg(e) {
  const t = Yn();
  if (!t)
    return {};
  const n = $x(Ui(e).trace_id || "", t, xa()), r = F_(e);
  if (!r)
    return n;
  const i = r && r._frozenDynamicSamplingContext;
  if (i)
    return i;
  const { sampleRate: o, source: a } = r.metadata;
  o != null && (n.sample_rate = `${o}`);
  const s = Ui(r);
  return a && a !== "url" && (n.transaction = s.description), n.sampled = String(PP(r)), t.emit && t.emit("createDsc", n), n;
}
function rG(e, t) {
  const { fingerprint: n, span: r, breadcrumbs: i, sdkProcessingMetadata: o } = t;
  Hbe(e, t), r && qbe(e, r), Gbe(e, n), Ube(e, i), Wbe(e, o);
}
function w4(e, t) {
  const {
    extra: n,
    tags: r,
    user: i,
    contexts: o,
    level: a,
    sdkProcessingMetadata: s,
    breadcrumbs: c,
    fingerprint: l,
    eventProcessors: u,
    attachments: d,
    propagationContext: f,
    // eslint-disable-next-line deprecation/deprecation
    transactionName: h,
    span: p
  } = t;
  cm(e, "extra", n), cm(e, "tags", r), cm(e, "user", i), cm(e, "contexts", o), cm(e, "sdkProcessingMetadata", s), a && (e.level = a), h && (e.transactionName = h), p && (e.span = p), c.length && (e.breadcrumbs = [...e.breadcrumbs, ...c]), l.length && (e.fingerprint = [...e.fingerprint, ...l]), u.length && (e.eventProcessors = [...e.eventProcessors, ...u]), d.length && (e.attachments = [...e.attachments, ...d]), e.propagationContext = { ...e.propagationContext, ...f };
}
function cm(e, t, n) {
  if (n && Object.keys(n).length) {
    e[t] = { ...e[t] };
    for (const r in n)
      Object.prototype.hasOwnProperty.call(n, r) && (e[t][r] = n[r]);
  }
}
function Hbe(e, t) {
  const {
    extra: n,
    tags: r,
    user: i,
    contexts: o,
    level: a,
    // eslint-disable-next-line deprecation/deprecation
    transactionName: s
  } = t, c = Ao(n);
  c && Object.keys(c).length && (e.extra = { ...c, ...e.extra });
  const l = Ao(r);
  l && Object.keys(l).length && (e.tags = { ...l, ...e.tags });
  const u = Ao(i);
  u && Object.keys(u).length && (e.user = { ...u, ...e.user });
  const d = Ao(o);
  d && Object.keys(d).length && (e.contexts = { ...d, ...e.contexts }), a && (e.level = a), s && (e.transaction = s);
}
function Ube(e, t) {
  const n = [...e.breadcrumbs || [], ...t];
  e.breadcrumbs = n.length ? n : void 0;
}
function Wbe(e, t) {
  e.sdkProcessingMetadata = {
    ...e.sdkProcessingMetadata,
    ...t
  };
}
function qbe(e, t) {
  e.contexts = { trace: OP(t), ...e.contexts };
  const n = F_(t);
  if (n) {
    e.sdkProcessingMetadata = {
      dynamicSamplingContext: yg(t),
      ...e.sdkProcessingMetadata
    };
    const r = Ui(n).description;
    r && (e.tags = { transaction: r, ...e.tags });
  }
}
function Gbe(e, t) {
  e.fingerprint = e.fingerprint ? jq(e.fingerprint) : [], t && (e.fingerprint = e.fingerprint.concat(t)), e.fingerprint && !e.fingerprint.length && delete e.fingerprint;
}
const Kbe = 100;
let d5;
class Xc {
  /** Flag if notifying is happening. */
  /** Callback for client to receive scope changes. */
  /** Callback list that will be called after {@link applyToEvent}. */
  /** Array of breadcrumbs. */
  /** User */
  /** Tags */
  /** Extra */
  /** Contexts */
  /** Attachments */
  /** Propagation Context for distributed tracing */
  /**
   * A place to stash data which is needed at some point in the SDK's event processing pipeline but which shouldn't get
   * sent to Sentry
   */
  /** Fingerprint */
  /** Severity */
  // eslint-disable-next-line deprecation/deprecation
  /**
   * Transaction Name
   */
  /** Span */
  /** Session */
  /** Request Mode Session Status */
  /** The client on this scope */
  // NOTE: Any field which gets added here should get added not only to the constructor but also to the `clone` method.
  constructor() {
    this._notifyingListeners = !1, this._scopeListeners = [], this._eventProcessors = [], this._breadcrumbs = [], this._attachments = [], this._user = {}, this._tags = {}, this._extra = {}, this._contexts = {}, this._sdkProcessingMetadata = {}, this._propagationContext = x4();
  }
  /**
   * Inherit values from the parent scope.
   * @deprecated Use `scope.clone()` and `new Scope()` instead.
   */
  static clone(t) {
    return t ? t.clone() : new Xc();
  }
  /**
   * Clone this scope instance.
   */
  clone() {
    const t = new Xc();
    return t._breadcrumbs = [...this._breadcrumbs], t._tags = { ...this._tags }, t._extra = { ...this._extra }, t._contexts = { ...this._contexts }, t._user = this._user, t._level = this._level, t._span = this._span, t._session = this._session, t._transactionName = this._transactionName, t._fingerprint = this._fingerprint, t._eventProcessors = [...this._eventProcessors], t._requestSession = this._requestSession, t._attachments = [...this._attachments], t._sdkProcessingMetadata = { ...this._sdkProcessingMetadata }, t._propagationContext = { ...this._propagationContext }, t._client = this._client, t;
  }
  /** Update the client on the scope. */
  setClient(t) {
    this._client = t;
  }
  /**
   * Get the client assigned to this scope.
   *
   * It is generally recommended to use the global function `Sentry.getClient()` instead, unless you know what you are doing.
   */
  getClient() {
    return this._client;
  }
  /**
   * Add internal on change listener. Used for sub SDKs that need to store the scope.
   * @hidden
   */
  addScopeListener(t) {
    this._scopeListeners.push(t);
  }
  /**
   * @inheritDoc
   */
  addEventProcessor(t) {
    return this._eventProcessors.push(t), this;
  }
  /**
   * @inheritDoc
   */
  setUser(t) {
    return this._user = t || {
      email: void 0,
      id: void 0,
      ip_address: void 0,
      segment: void 0,
      username: void 0
    }, this._session && rf(this._session, { user: t }), this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  getUser() {
    return this._user;
  }
  /**
   * @inheritDoc
   */
  getRequestSession() {
    return this._requestSession;
  }
  /**
   * @inheritDoc
   */
  setRequestSession(t) {
    return this._requestSession = t, this;
  }
  /**
   * @inheritDoc
   */
  setTags(t) {
    return this._tags = {
      ...this._tags,
      ...t
    }, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setTag(t, n) {
    return this._tags = { ...this._tags, [t]: n }, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setExtras(t) {
    return this._extra = {
      ...this._extra,
      ...t
    }, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setExtra(t, n) {
    return this._extra = { ...this._extra, [t]: n }, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setFingerprint(t) {
    return this._fingerprint = t, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setLevel(t) {
    return this._level = t, this._notifyScopeListeners(), this;
  }
  /**
   * Sets the transaction name on the scope for future events.
   */
  setTransactionName(t) {
    return this._transactionName = t, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setContext(t, n) {
    return n === null ? delete this._contexts[t] : this._contexts[t] = n, this._notifyScopeListeners(), this;
  }
  /**
   * Sets the Span on the scope.
   * @param span Span
   * @deprecated Instead of setting a span on a scope, use `startSpan()`/`startSpanManual()` instead.
   */
  setSpan(t) {
    return this._span = t, this._notifyScopeListeners(), this;
  }
  /**
   * Returns the `Span` if there is one.
   * @deprecated Use `getActiveSpan()` instead.
   */
  getSpan() {
    return this._span;
  }
  /**
   * Returns the `Transaction` attached to the scope (if there is one).
   * @deprecated You should not rely on the transaction, but just use `startSpan()` APIs instead.
   */
  getTransaction() {
    const t = this._span;
    return t && t.transaction;
  }
  /**
   * @inheritDoc
   */
  setSession(t) {
    return t ? this._session = t : delete this._session, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  getSession() {
    return this._session;
  }
  /**
   * @inheritDoc
   */
  update(t) {
    if (!t)
      return this;
    const n = typeof t == "function" ? t(this) : t;
    if (n instanceof Xc) {
      const r = n.getScopeData();
      this._tags = { ...this._tags, ...r.tags }, this._extra = { ...this._extra, ...r.extra }, this._contexts = { ...this._contexts, ...r.contexts }, r.user && Object.keys(r.user).length && (this._user = r.user), r.level && (this._level = r.level), r.fingerprint.length && (this._fingerprint = r.fingerprint), n.getRequestSession() && (this._requestSession = n.getRequestSession()), r.propagationContext && (this._propagationContext = r.propagationContext);
    } else if (mg(n)) {
      const r = t;
      this._tags = { ...this._tags, ...r.tags }, this._extra = { ...this._extra, ...r.extra }, this._contexts = { ...this._contexts, ...r.contexts }, r.user && (this._user = r.user), r.level && (this._level = r.level), r.fingerprint && (this._fingerprint = r.fingerprint), r.requestSession && (this._requestSession = r.requestSession), r.propagationContext && (this._propagationContext = r.propagationContext);
    }
    return this;
  }
  /**
   * @inheritDoc
   */
  clear() {
    return this._breadcrumbs = [], this._tags = {}, this._extra = {}, this._user = {}, this._contexts = {}, this._level = void 0, this._transactionName = void 0, this._fingerprint = void 0, this._requestSession = void 0, this._span = void 0, this._session = void 0, this._notifyScopeListeners(), this._attachments = [], this._propagationContext = x4(), this;
  }
  /**
   * @inheritDoc
   */
  addBreadcrumb(t, n) {
    const r = typeof n == "number" ? n : Kbe;
    if (r <= 0)
      return this;
    const i = {
      timestamp: Xv(),
      ...t
    }, o = this._breadcrumbs;
    return o.push(i), this._breadcrumbs = o.length > r ? o.slice(-r) : o, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  getLastBreadcrumb() {
    return this._breadcrumbs[this._breadcrumbs.length - 1];
  }
  /**
   * @inheritDoc
   */
  clearBreadcrumbs() {
    return this._breadcrumbs = [], this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  addAttachment(t) {
    return this._attachments.push(t), this;
  }
  /**
   * @inheritDoc
   * @deprecated Use `getScopeData()` instead.
   */
  getAttachments() {
    return this.getScopeData().attachments;
  }
  /**
   * @inheritDoc
   */
  clearAttachments() {
    return this._attachments = [], this;
  }
  /** @inheritDoc */
  getScopeData() {
    const {
      _breadcrumbs: t,
      _attachments: n,
      _contexts: r,
      _tags: i,
      _extra: o,
      _user: a,
      _level: s,
      _fingerprint: c,
      _eventProcessors: l,
      _propagationContext: u,
      _sdkProcessingMetadata: d,
      _transactionName: f,
      _span: h
    } = this;
    return {
      breadcrumbs: t,
      attachments: n,
      contexts: r,
      tags: i,
      extra: o,
      user: a,
      level: s,
      fingerprint: c || [],
      eventProcessors: l,
      propagationContext: u,
      sdkProcessingMetadata: d,
      transactionName: f,
      span: h
    };
  }
  /**
   * Applies data from the scope to the event and runs all event processors on it.
   *
   * @param event Event
   * @param hint Object containing additional information about the original exception, for use by the event processors.
   * @hidden
   * @deprecated Use `applyScopeDataToEvent()` directly
   */
  applyToEvent(t, n = {}, r = []) {
    rG(t, this.getScopeData());
    const i = [
      ...r,
      // eslint-disable-next-line deprecation/deprecation
      ...$P(),
      ...this._eventProcessors
    ];
    return j_(i, t, n);
  }
  /**
   * Add data which will be accessible during event processing but won't get sent to Sentry
   */
  setSDKProcessingMetadata(t) {
    return this._sdkProcessingMetadata = { ...this._sdkProcessingMetadata, ...t }, this;
  }
  /**
   * @inheritDoc
   */
  setPropagationContext(t) {
    return this._propagationContext = t, this;
  }
  /**
   * @inheritDoc
   */
  getPropagationContext() {
    return this._propagationContext;
  }
  /**
   * Capture an exception for this scope.
   *
   * @param exception The exception to capture.
   * @param hint Optinal additional data to attach to the Sentry event.
   * @returns the id of the captured Sentry event.
   */
  captureException(t, n) {
    const r = n && n.event_id ? n.event_id : Gr();
    if (!this._client)
      return xe.warn("No client configured on scope - will not capture exception!"), r;
    const i = new Error("Sentry syntheticException");
    return this._client.captureException(
      t,
      {
        originalException: t,
        syntheticException: i,
        ...n,
        event_id: r
      },
      this
    ), r;
  }
  /**
   * Capture a message for this scope.
   *
   * @param message The message to capture.
   * @param level An optional severity level to report the message with.
   * @param hint Optional additional data to attach to the Sentry event.
   * @returns the id of the captured message.
   */
  captureMessage(t, n, r) {
    const i = r && r.event_id ? r.event_id : Gr();
    if (!this._client)
      return xe.warn("No client configured on scope - will not capture message!"), i;
    const o = new Error(t);
    return this._client.captureMessage(
      t,
      n,
      {
        originalException: t,
        syntheticException: o,
        ...r,
        event_id: i
      },
      this
    ), i;
  }
  /**
   * Captures a manually created event for this scope and sends it to Sentry.
   *
   * @param exception The event to capture.
   * @param hint Optional additional data to attach to the Sentry event.
   * @returns the id of the captured event.
   */
  captureEvent(t, n) {
    const r = n && n.event_id ? n.event_id : Gr();
    return this._client ? (this._client.captureEvent(t, { ...n, event_id: r }, this), r) : (xe.warn("No client configured on scope - will not capture event!"), r);
  }
  /**
   * This will be called on every set call.
   */
  _notifyScopeListeners() {
    this._notifyingListeners || (this._notifyingListeners = !0, this._scopeListeners.forEach((t) => {
      t(this);
    }), this._notifyingListeners = !1);
  }
}
function Ybe() {
  return d5 || (d5 = new Xc()), d5;
}
function x4() {
  return {
    traceId: Gr(),
    spanId: Gr().substring(16)
  };
}
const fA = "7.120.0", iG = parseFloat(fA), Xbe = 100;
class oG {
  /** Is a {@link Layer}[] containing the client and scope */
  /** Contains the last event id of a captured event.  */
  /**
   * Creates a new instance of the hub, will push one {@link Layer} into the
   * internal stack on creation.
   *
   * @param client bound to the hub.
   * @param scope bound to the hub.
   * @param version number, higher number means higher priority.
   *
   * @deprecated Instantiation of Hub objects is deprecated and the constructor will be removed in version 8 of the SDK.
   *
   * If you are currently using the Hub for multi-client use like so:
   *
   * ```
   * // OLD
   * const hub = new Hub();
   * hub.bindClient(client);
   * makeMain(hub)
   * ```
   *
   * instead initialize the client as follows:
   *
   * ```
   * // NEW
   * Sentry.withIsolationScope(() => {
   *    Sentry.setCurrentClient(client);
   *    client.init();
   * });
   * ```
   *
   * If you are using the Hub to capture events like so:
   *
   * ```
   * // OLD
   * const client = new Client();
   * const hub = new Hub(client);
   * hub.captureException()
   * ```
   *
   * instead capture isolated events as follows:
   *
   * ```
   * // NEW
   * const client = new Client();
   * const scope = new Scope();
   * scope.setClient(client);
   * scope.captureException();
   * ```
   */
  constructor(t, n, r, i = iG) {
    this._version = i;
    let o;
    n ? o = n : (o = new Xc(), o.setClient(t));
    let a;
    r ? a = r : (a = new Xc(), a.setClient(t)), this._stack = [{ scope: o }], t && this.bindClient(t), this._isolationScope = a;
  }
  /**
   * Checks if this hub's version is older than the given version.
   *
   * @param version A version number to compare to.
   * @return True if the given version is newer; otherwise false.
   *
   * @deprecated This will be removed in v8.
   */
  isOlderThan(t) {
    return this._version < t;
  }
  /**
   * This binds the given client to the current scope.
   * @param client An SDK client (client) instance.
   *
   * @deprecated Use `initAndBind()` directly, or `setCurrentClient()` and/or `client.init()` instead.
   */
  bindClient(t) {
    const n = this.getStackTop();
    n.client = t, n.scope.setClient(t), t && t.setupIntegrations && t.setupIntegrations();
  }
  /**
   * @inheritDoc
   *
   * @deprecated Use `withScope` instead.
   */
  pushScope() {
    const t = this.getScope().clone();
    return this.getStack().push({
      // eslint-disable-next-line deprecation/deprecation
      client: this.getClient(),
      scope: t
    }), t;
  }
  /**
   * @inheritDoc
   *
   * @deprecated Use `withScope` instead.
   */
  popScope() {
    return this.getStack().length <= 1 ? !1 : !!this.getStack().pop();
  }
  /**
   * @inheritDoc
   *
   * @deprecated Use `Sentry.withScope()` instead.
   */
  withScope(t) {
    const n = this.pushScope();
    let r;
    try {
      r = t(n);
    } catch (i) {
      throw this.popScope(), i;
    }
    return Ex(r) ? r.then(
      (i) => (this.popScope(), i),
      (i) => {
        throw this.popScope(), i;
      }
    ) : (this.popScope(), r);
  }
  /**
   * @inheritDoc
   *
   * @deprecated Use `Sentry.getClient()` instead.
   */
  getClient() {
    return this.getStackTop().client;
  }
  /**
   * Returns the scope of the top stack.
   *
   * @deprecated Use `Sentry.getCurrentScope()` instead.
   */
  getScope() {
    return this.getStackTop().scope;
  }
  /**
   * @deprecated Use `Sentry.getIsolationScope()` instead.
   */
  getIsolationScope() {
    return this._isolationScope;
  }
  /**
   * Returns the scope stack for domains or the process.
   * @deprecated This will be removed in v8.
   */
  getStack() {
    return this._stack;
  }
  /**
   * Returns the topmost scope layer in the order domain > local > process.
   * @deprecated This will be removed in v8.
   */
  getStackTop() {
    return this._stack[this._stack.length - 1];
  }
  /**
   * @inheritDoc
   *
   * @deprecated Use `Sentry.captureException()` instead.
   */
  captureException(t, n) {
    const r = this._lastEventId = n && n.event_id ? n.event_id : Gr(), i = new Error("Sentry syntheticException");
    return this.getScope().captureException(t, {
      originalException: t,
      syntheticException: i,
      ...n,
      event_id: r
    }), r;
  }
  /**
   * @inheritDoc
   *
   * @deprecated Use  `Sentry.captureMessage()` instead.
   */
  captureMessage(t, n, r) {
    const i = this._lastEventId = r && r.event_id ? r.event_id : Gr(), o = new Error(t);
    return this.getScope().captureMessage(t, n, {
      originalException: t,
      syntheticException: o,
      ...r,
      event_id: i
    }), i;
  }
  /**
   * @inheritDoc
   *
   * @deprecated Use `Sentry.captureEvent()` instead.
   */
  captureEvent(t, n) {
    const r = n && n.event_id ? n.event_id : Gr();
    return t.type || (this._lastEventId = r), this.getScope().captureEvent(t, { ...n, event_id: r }), r;
  }
  /**
   * @inheritDoc
   *
   * @deprecated This will be removed in v8.
   */
  lastEventId() {
    return this._lastEventId;
  }
  /**
   * @inheritDoc
   *
   * @deprecated Use `Sentry.addBreadcrumb()` instead.
   */
  addBreadcrumb(t, n) {
    const { scope: r, client: i } = this.getStackTop();
    if (!i)
      return;
    const { beforeBreadcrumb: o = null, maxBreadcrumbs: a = Xbe } = i.getOptions && i.getOptions() || {};
    if (a <= 0)
      return;
    const c = { timestamp: Xv(), ...t }, l = o ? tf(() => o(c, n)) : c;
    l !== null && (i.emit && i.emit("beforeAddBreadcrumb", l, n), r.addBreadcrumb(l, a));
  }
  /**
   * @inheritDoc
   * @deprecated Use `Sentry.setUser()` instead.
   */
  setUser(t) {
    this.getScope().setUser(t), this.getIsolationScope().setUser(t);
  }
  /**
   * @inheritDoc
   * @deprecated Use `Sentry.setTags()` instead.
   */
  setTags(t) {
    this.getScope().setTags(t), this.getIsolationScope().setTags(t);
  }
  /**
   * @inheritDoc
   * @deprecated Use `Sentry.setExtras()` instead.
   */
  setExtras(t) {
    this.getScope().setExtras(t), this.getIsolationScope().setExtras(t);
  }
  /**
   * @inheritDoc
   * @deprecated Use `Sentry.setTag()` instead.
   */
  setTag(t, n) {
    this.getScope().setTag(t, n), this.getIsolationScope().setTag(t, n);
  }
  /**
   * @inheritDoc
   * @deprecated Use `Sentry.setExtra()` instead.
   */
  setExtra(t, n) {
    this.getScope().setExtra(t, n), this.getIsolationScope().setExtra(t, n);
  }
  /**
   * @inheritDoc
   * @deprecated Use `Sentry.setContext()` instead.
   */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  setContext(t, n) {
    this.getScope().setContext(t, n), this.getIsolationScope().setContext(t, n);
  }
  /**
   * @inheritDoc
   *
   * @deprecated Use `getScope()` directly.
   */
  configureScope(t) {
    const { scope: n, client: r } = this.getStackTop();
    r && t(n);
  }
  /**
   * @inheritDoc
   */
  // eslint-disable-next-line deprecation/deprecation
  run(t) {
    const n = E4(this);
    try {
      t(this);
    } finally {
      E4(n);
    }
  }
  /**
   * @inheritDoc
   * @deprecated Use `Sentry.getClient().getIntegrationByName()` instead.
   */
  getIntegration(t) {
    const n = this.getClient();
    if (!n)
      return null;
    try {
      return n.getIntegration(t);
    } catch {
      return Mt && xe.warn(`Cannot retrieve integration ${t.id} from the current Hub`), null;
    }
  }
  /**
   * Starts a new `Transaction` and returns it. This is the entry point to manual tracing instrumentation.
   *
   * A tree structure can be built by adding child spans to the transaction, and child spans to other spans. To start a
   * new child span within the transaction or any span, call the respective `.startChild()` method.
   *
   * Every child span must be finished before the transaction is finished, otherwise the unfinished spans are discarded.
   *
   * The transaction must be finished with a call to its `.end()` method, at which point the transaction with all its
   * finished child spans will be sent to Sentry.
   *
   * @param context Properties of the new `Transaction`.
   * @param customSamplingContext Information given to the transaction sampling function (along with context-dependent
   * default values). See {@link Options.tracesSampler}.
   *
   * @returns The transaction which was just started
   *
   * @deprecated Use `startSpan()`, `startSpanManual()` or `startInactiveSpan()` instead.
   */
  startTransaction(t, n) {
    const r = this._callExtensionMethod("startTransaction", t, n);
    return Mt && !r && (this.getClient() ? xe.warn(`Tracing extension 'startTransaction' has not been added. Call 'addTracingExtensions' before calling 'init':
Sentry.addTracingExtensions();
Sentry.init({...});
`) : xe.warn(
      "Tracing extension 'startTransaction' is missing. You should 'init' the SDK before calling 'startTransaction'"
    )), r;
  }
  /**
   * @inheritDoc
   * @deprecated Use `spanToTraceHeader()` instead.
   */
  traceHeaders() {
    return this._callExtensionMethod("traceHeaders");
  }
  /**
   * @inheritDoc
   *
   * @deprecated Use top level `captureSession` instead.
   */
  captureSession(t = !1) {
    if (t)
      return this.endSession();
    this._sendSessionUpdate();
  }
  /**
   * @inheritDoc
   * @deprecated Use top level `endSession` instead.
   */
  endSession() {
    const n = this.getStackTop().scope, r = n.getSession();
    r && Qq(r), this._sendSessionUpdate(), n.setSession();
  }
  /**
   * @inheritDoc
   * @deprecated Use top level `startSession` instead.
   */
  startSession(t) {
    const { scope: n, client: r } = this.getStackTop(), { release: i, environment: o = Tx } = r && r.getOptions() || {}, { userAgent: a } = An.navigator || {}, s = Xq({
      release: i,
      environment: o,
      user: n.getUser(),
      ...a && { userAgent: a },
      ...t
    }), c = n.getSession && n.getSession();
    return c && c.status === "ok" && rf(c, { status: "exited" }), this.endSession(), n.setSession(s), s;
  }
  /**
   * Returns if default PII should be sent to Sentry and propagated in ourgoing requests
   * when Tracing is used.
   *
   * @deprecated Use top-level `getClient().getOptions().sendDefaultPii` instead. This function
   * only unnecessarily increased API surface but only wrapped accessing the option.
   */
  shouldSendDefaultPii() {
    const t = this.getClient(), n = t && t.getOptions();
    return !!(n && n.sendDefaultPii);
  }
  /**
   * Sends the current Session on the scope
   */
  _sendSessionUpdate() {
    const { scope: t, client: n } = this.getStackTop(), r = t.getSession();
    r && n && n.captureSession && n.captureSession(r);
  }
  /**
   * Calls global extension method and binding current instance to the function call
   */
  // @ts-expect-error Function lacks ending return statement and return type does not include 'undefined'. ts(2366)
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  _callExtensionMethod(t, ...n) {
    const i = Jv().__SENTRY__;
    if (i && i.extensions && typeof i.extensions[t] == "function")
      return i.extensions[t].apply(this, n);
    Mt && xe.warn(`Extension method ${t} couldn't be found, doing nothing.`);
  }
}
function Jv() {
  return An.__SENTRY__ = An.__SENTRY__ || {
    extensions: {},
    hub: void 0
  }, An;
}
function E4(e) {
  const t = Jv(), n = hA(t);
  return aG(t, e), n;
}
function Ea() {
  const e = Jv();
  if (e.__SENTRY__ && e.__SENTRY__.acs) {
    const t = e.__SENTRY__.acs.getCurrentHub();
    if (t)
      return t;
  }
  return Qbe(e);
}
function Bu() {
  return Ea().getIsolationScope();
}
function Qbe(e = Jv()) {
  return (!Jbe(e) || // eslint-disable-next-line deprecation/deprecation
  hA(e).isOlderThan(iG)) && aG(e, new oG()), hA(e);
}
function Jbe(e) {
  return !!(e && e.__SENTRY__ && e.__SENTRY__.hub);
}
function hA(e) {
  return $q("hub", () => new oG(), e);
}
function aG(e, t) {
  if (!e)
    return !1;
  const n = e.__SENTRY__ = e.__SENTRY__ || {};
  return n.hub = t, !0;
}
function of(e) {
  return (e || Ea()).getScope().getTransaction();
}
let C4 = !1;
function Zbe() {
  C4 || (C4 = !0, Bq(gA), zq(gA));
}
function gA() {
  const e = of();
  if (e) {
    const t = "internal_error";
    Mt && xe.log(`[Tracing] Transaction: ${t} -> Global error occured`), e.setStatus(t);
  }
}
gA.tag = "sentry_tracingErrorCallback";
var T4;
(function(e) {
  const t = "ok";
  e.Ok = t;
  const n = "deadline_exceeded";
  e.DeadlineExceeded = n;
  const r = "unauthenticated";
  e.Unauthenticated = r;
  const i = "permission_denied";
  e.PermissionDenied = i;
  const o = "not_found";
  e.NotFound = o;
  const a = "resource_exhausted";
  e.ResourceExhausted = a;
  const s = "invalid_argument";
  e.InvalidArgument = s;
  const c = "unimplemented";
  e.Unimplemented = c;
  const l = "unavailable";
  e.Unavailable = l;
  const u = "internal_error";
  e.InternalError = u;
  const d = "unknown_error";
  e.UnknownError = d;
  const f = "cancelled";
  e.Cancelled = f;
  const h = "already_exists";
  e.AlreadyExists = h;
  const p = "failed_precondition";
  e.FailedPrecondition = p;
  const g = "aborted";
  e.Aborted = g;
  const m = "out_of_range";
  e.OutOfRange = m;
  const v = "data_loss";
  e.DataLoss = v;
})(T4 || (T4 = {}));
function e1e(e) {
  if (e < 400 && e >= 100)
    return "ok";
  if (e >= 400 && e < 500)
    switch (e) {
      case 401:
        return "unauthenticated";
      case 403:
        return "permission_denied";
      case 404:
        return "not_found";
      case 409:
        return "already_exists";
      case 413:
        return "failed_precondition";
      case 429:
        return "resource_exhausted";
      default:
        return "invalid_argument";
    }
  if (e >= 500 && e < 600)
    switch (e) {
      case 501:
        return "unimplemented";
      case 503:
        return "unavailable";
      case 504:
        return "deadline_exceeded";
      default:
        return "internal_error";
    }
  return "unknown_error";
}
function MP(e, t) {
  e.setTag("http.status_code", String(t)), e.setData("http.response.status_code", t);
  const n = e1e(t);
  n !== "unknown_error" && e.setStatus(n);
}
function yp(e) {
  if (typeof __SENTRY_TRACING__ == "boolean" && !__SENTRY_TRACING__)
    return !1;
  const t = Yn(), n = e || t && t.getOptions();
  return !!n && (n.enableTracing || "tracesSampleRate" in n || "tracesSampler" in n);
}
function sG(e) {
  if (!yp())
    return;
  const t = r1e(e), n = Ea(), r = e.scope ? (
    // eslint-disable-next-line deprecation/deprecation
    e.scope.getSpan()
  ) : t1e();
  if (e.onlyIfParent && !r)
    return;
  const a = (e.scope || xa()).clone();
  return n1e(n, {
    parentSpan: r,
    spanContext: t,
    forceTransaction: e.forceTransaction,
    scope: a
  });
}
function t1e() {
  return xa().getSpan();
}
function n1e(e, {
  parentSpan: t,
  spanContext: n,
  forceTransaction: r,
  scope: i
}) {
  if (!yp())
    return;
  const o = Bu();
  let a;
  if (t && !r)
    a = t.startChild(n);
  else if (t) {
    const s = yg(t), { traceId: c, spanId: l } = t.spanContext(), u = PP(t);
    a = e.startTransaction({
      traceId: c,
      parentSpanId: l,
      parentSampled: u,
      ...n,
      metadata: {
        dynamicSamplingContext: s,
        // eslint-disable-next-line deprecation/deprecation
        ...n.metadata
      }
    });
  } else {
    const { traceId: s, dsc: c, parentSpanId: l, sampled: u } = {
      ...o.getPropagationContext(),
      ...i.getPropagationContext()
    };
    a = e.startTransaction({
      traceId: s,
      parentSpanId: l,
      parentSampled: u,
      ...n,
      metadata: {
        dynamicSamplingContext: c,
        // eslint-disable-next-line deprecation/deprecation
        ...n.metadata
      }
    });
  }
  return i.setSpan(a), i1e(a, i, o), a;
}
function r1e(e) {
  if (e.startTime) {
    const t = { ...e };
    return t.startTimestamp = Ax(e.startTime), delete t.startTime, t;
  }
  return e;
}
const cG = "_sentryScope", lG = "_sentryIsolationScope";
function i1e(e, t, n) {
  e && (nf(e, lG, n), nf(e, cG, t));
}
function o1e(e) {
  return {
    scope: e[cG],
    isolationScope: e[lG]
  };
}
const Dd = "sentry.source", Ah = "sentry.sample_rate", Ab = "sentry.op", Rh = "sentry.origin", a1e = "profile_id";
class uG {
  constructor(t = 1e3) {
    this._maxlen = t, this.spans = [];
  }
  /**
   * This is just so that we don't run out of memory while recording a lot
   * of spans. At some point we just stop and flush out the start of the
   * trace tree (i.e.the first n spans with the smallest
   * start_timestamp).
   */
  add(t) {
    this.spans.length > this._maxlen ? t.spanRecorder = void 0 : this.spans.push(t);
  }
}
class Ox {
  /**
   * Tags for the span.
   * @deprecated Use `spanToJSON(span).atttributes` instead.
   */
  /**
   * Data for the span.
   * @deprecated Use `spanToJSON(span).atttributes` instead.
   */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  /**
   * List of spans that were finalized
   *
   * @deprecated This property will no longer be public. Span recording will be handled internally.
   */
  /**
   * @inheritDoc
   * @deprecated Use top level `Sentry.getRootSpan()` instead
   */
  /**
   * The instrumenter that created this span.
   *
   * TODO (v8): This can probably be replaced by an `instanceOf` check of the span class.
   *            the instrumenter can only be sentry or otel so we can check the span instance
   *            to verify which one it is and remove this field entirely.
   *
   * @deprecated This field will be removed.
   */
  /** Epoch timestamp in seconds when the span started. */
  /** Epoch timestamp in seconds when the span ended. */
  /** Internal keeper of the status */
  /**
   * You should never call the constructor manually, always use `Sentry.startTransaction()`
   * or call `startChild()` on an existing span.
   * @internal
   * @hideconstructor
   * @hidden
   */
  constructor(t = {}) {
    this._traceId = t.traceId || Gr(), this._spanId = t.spanId || Gr().substring(16), this._startTime = t.startTimestamp || Qv(), this.tags = t.tags ? { ...t.tags } : {}, this.data = t.data ? { ...t.data } : {}, this.instrumenter = t.instrumenter || "sentry", this._attributes = {}, this.setAttributes({
      [Rh]: t.origin || "manual",
      [Ab]: t.op,
      ...t.attributes
    }), this._name = t.name || t.description, t.parentSpanId && (this._parentSpanId = t.parentSpanId), "sampled" in t && (this._sampled = t.sampled), t.status && (this._status = t.status), t.endTimestamp && (this._endTime = t.endTimestamp), t.exclusiveTime !== void 0 && (this._exclusiveTime = t.exclusiveTime), this._measurements = t.measurements ? { ...t.measurements } : {};
  }
  // This rule conflicts with another eslint rule :(
  /* eslint-disable @typescript-eslint/member-ordering */
  /**
   * An alias for `description` of the Span.
   * @deprecated Use `spanToJSON(span).description` instead.
   */
  get name() {
    return this._name || "";
  }
  /**
   * Update the name of the span.
   * @deprecated Use `spanToJSON(span).description` instead.
   */
  set name(t) {
    this.updateName(t);
  }
  /**
   * Get the description of the Span.
   * @deprecated Use `spanToJSON(span).description` instead.
   */
  get description() {
    return this._name;
  }
  /**
   * Get the description of the Span.
   * @deprecated Use `spanToJSON(span).description` instead.
   */
  set description(t) {
    this._name = t;
  }
  /**
   * The ID of the trace.
   * @deprecated Use `spanContext().traceId` instead.
   */
  get traceId() {
    return this._traceId;
  }
  /**
   * The ID of the trace.
   * @deprecated You cannot update the traceId of a span after span creation.
   */
  set traceId(t) {
    this._traceId = t;
  }
  /**
   * The ID of the span.
   * @deprecated Use `spanContext().spanId` instead.
   */
  get spanId() {
    return this._spanId;
  }
  /**
   * The ID of the span.
   * @deprecated You cannot update the spanId of a span after span creation.
   */
  set spanId(t) {
    this._spanId = t;
  }
  /**
   * @inheritDoc
   *
   * @deprecated Use `startSpan` functions instead.
   */
  set parentSpanId(t) {
    this._parentSpanId = t;
  }
  /**
   * @inheritDoc
   *
   * @deprecated Use `spanToJSON(span).parent_span_id` instead.
   */
  get parentSpanId() {
    return this._parentSpanId;
  }
  /**
   * Was this span chosen to be sent as part of the sample?
   * @deprecated Use `isRecording()` instead.
   */
  get sampled() {
    return this._sampled;
  }
  /**
   * Was this span chosen to be sent as part of the sample?
   * @deprecated You cannot update the sampling decision of a span after span creation.
   */
  set sampled(t) {
    this._sampled = t;
  }
  /**
   * Attributes for the span.
   * @deprecated Use `spanToJSON(span).atttributes` instead.
   */
  get attributes() {
    return this._attributes;
  }
  /**
   * Attributes for the span.
   * @deprecated Use `setAttributes()` instead.
   */
  set attributes(t) {
    this._attributes = t;
  }
  /**
   * Timestamp in seconds (epoch time) indicating when the span started.
   * @deprecated Use `spanToJSON()` instead.
   */
  get startTimestamp() {
    return this._startTime;
  }
  /**
   * Timestamp in seconds (epoch time) indicating when the span started.
   * @deprecated In v8, you will not be able to update the span start time after creation.
   */
  set startTimestamp(t) {
    this._startTime = t;
  }
  /**
   * Timestamp in seconds when the span ended.
   * @deprecated Use `spanToJSON()` instead.
   */
  get endTimestamp() {
    return this._endTime;
  }
  /**
   * Timestamp in seconds when the span ended.
   * @deprecated Set the end time via `span.end()` instead.
   */
  set endTimestamp(t) {
    this._endTime = t;
  }
  /**
   * The status of the span.
   *
   * @deprecated Use `spanToJSON().status` instead to get the status.
   */
  get status() {
    return this._status;
  }
  /**
   * The status of the span.
   *
   * @deprecated Use `.setStatus()` instead to set or update the status.
   */
  set status(t) {
    this._status = t;
  }
  /**
   * Operation of the span
   *
   * @deprecated Use `spanToJSON().op` to read the op instead.
   */
  get op() {
    return this._attributes[Ab];
  }
  /**
   * Operation of the span
   *
   * @deprecated Use `startSpan()` functions to set or `span.setAttribute(SEMANTIC_ATTRIBUTE_SENTRY_OP, 'op')
   *             to update the span instead.
   */
  set op(t) {
    this.setAttribute(Ab, t);
  }
  /**
   * The origin of the span, giving context about what created the span.
   *
   * @deprecated Use `spanToJSON().origin` to read the origin instead.
   */
  get origin() {
    return this._attributes[Rh];
  }
  /**
   * The origin of the span, giving context about what created the span.
   *
   * @deprecated Use `startSpan()` functions to set the origin instead.
   */
  set origin(t) {
    this.setAttribute(Rh, t);
  }
  /* eslint-enable @typescript-eslint/member-ordering */
  /** @inheritdoc */
  spanContext() {
    const { _spanId: t, _traceId: n, _sampled: r } = this;
    return {
      spanId: t,
      traceId: n,
      traceFlags: r ? Jq : Rbe
    };
  }
  /**
   * Creates a new `Span` while setting the current `Span.id` as `parentSpanId`.
   * Also the `sampled` decision will be inherited.
   *
   * @deprecated Use `startSpan()`, `startSpanManual()` or `startInactiveSpan()` instead.
   */
  startChild(t) {
    const n = new Ox({
      ...t,
      parentSpanId: this._spanId,
      sampled: this._sampled,
      traceId: this._traceId
    });
    n.spanRecorder = this.spanRecorder, n.spanRecorder && n.spanRecorder.add(n);
    const r = F_(this);
    if (n.transaction = r, Mt && r) {
      const i = t && t.op || "< unknown op >", o = Ui(n).description || "< unknown name >", a = r.spanContext().spanId, s = `[Tracing] Starting '${i}' span on transaction '${o}' (${a}).`;
      xe.log(s), this._logMessage = s;
    }
    return n;
  }
  /**
   * Sets the tag attribute on the current span.
   *
   * Can also be used to unset a tag, by passing `undefined`.
   *
   * @param key Tag key
   * @param value Tag value
   * @deprecated Use `setAttribute()` instead.
   */
  setTag(t, n) {
    return this.tags = { ...this.tags, [t]: n }, this;
  }
  /**
   * Sets the data attribute on the current span
   * @param key Data key
   * @param value Data value
   * @deprecated Use `setAttribute()` instead.
   */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  setData(t, n) {
    return this.data = { ...this.data, [t]: n }, this;
  }
  /** @inheritdoc */
  setAttribute(t, n) {
    n === void 0 ? delete this._attributes[t] : this._attributes[t] = n;
  }
  /** @inheritdoc */
  setAttributes(t) {
    Object.keys(t).forEach((n) => this.setAttribute(n, t[n]));
  }
  /**
   * @inheritDoc
   */
  setStatus(t) {
    return this._status = t, this;
  }
  /**
   * @inheritDoc
   * @deprecated Use top-level `setHttpStatus()` instead.
   */
  setHttpStatus(t) {
    return MP(this, t), this;
  }
  /**
   * @inheritdoc
   *
   * @deprecated Use `.updateName()` instead.
   */
  setName(t) {
    this.updateName(t);
  }
  /**
   * @inheritDoc
   */
  updateName(t) {
    return this._name = t, this;
  }
  /**
   * @inheritDoc
   *
   * @deprecated Use `spanToJSON(span).status === 'ok'` instead.
   */
  isSuccess() {
    return this._status === "ok";
  }
  /**
   * @inheritDoc
   *
   * @deprecated Use `.end()` instead.
   */
  finish(t) {
    return this.end(t);
  }
  /** @inheritdoc */
  end(t) {
    if (this._endTime)
      return;
    const n = F_(this);
    if (Mt && // Don't call this for transactions
    n && n.spanContext().spanId !== this._spanId) {
      const r = this._logMessage;
      r && xe.log(r.replace("Starting", "Finishing"));
    }
    this._endTime = Ax(t);
  }
  /**
   * @inheritDoc
   *
   * @deprecated Use `spanToTraceHeader()` instead.
   */
  toTraceparent() {
    return Ix(this);
  }
  /**
   * @inheritDoc
   *
   * @deprecated Use `spanToJSON()` or access the fields directly instead.
   */
  toContext() {
    return Ao({
      data: this._getData(),
      description: this._name,
      endTimestamp: this._endTime,
      // eslint-disable-next-line deprecation/deprecation
      op: this.op,
      parentSpanId: this._parentSpanId,
      sampled: this._sampled,
      spanId: this._spanId,
      startTimestamp: this._startTime,
      status: this._status,
      // eslint-disable-next-line deprecation/deprecation
      tags: this.tags,
      traceId: this._traceId
    });
  }
  /**
   * @inheritDoc
   *
   * @deprecated Update the fields directly instead.
   */
  updateWithContext(t) {
    return this.data = t.data || {}, this._name = t.name || t.description, this._endTime = t.endTimestamp, this.op = t.op, this._parentSpanId = t.parentSpanId, this._sampled = t.sampled, this._spanId = t.spanId || this._spanId, this._startTime = t.startTimestamp || this._startTime, this._status = t.status, this.tags = t.tags || {}, this._traceId = t.traceId || this._traceId, this;
  }
  /**
   * @inheritDoc
   *
   * @deprecated Use `spanToTraceContext()` util function instead.
   */
  getTraceContext() {
    return OP(this);
  }
  /**
   * Get JSON representation of this span.
   *
   * @hidden
   * @internal This method is purely for internal purposes and should not be used outside
   * of SDK code. If you need to get a JSON representation of a span,
   * use `spanToJSON(span)` instead.
   */
  getSpanJSON() {
    return Ao({
      data: this._getData(),
      description: this._name,
      op: this._attributes[Ab],
      parent_span_id: this._parentSpanId,
      span_id: this._spanId,
      start_timestamp: this._startTime,
      status: this._status,
      // eslint-disable-next-line deprecation/deprecation
      tags: Object.keys(this.tags).length > 0 ? this.tags : void 0,
      timestamp: this._endTime,
      trace_id: this._traceId,
      origin: this._attributes[Rh],
      _metrics_summary: void 0,
      profile_id: this._attributes[a1e],
      exclusive_time: this._exclusiveTime,
      measurements: Object.keys(this._measurements).length > 0 ? this._measurements : void 0
    });
  }
  /** @inheritdoc */
  isRecording() {
    return !this._endTime && !!this._sampled;
  }
  /**
   * Convert the object to JSON.
   * @deprecated Use `spanToJSON(span)` instead.
   */
  toJSON() {
    return this.getSpanJSON();
  }
  /**
   * Get the merged data for this span.
   * For now, this combines `data` and `attributes` together,
   * until eventually we can ingest `attributes` directly.
   */
  _getData() {
    const { data: t, _attributes: n } = this, r = Object.keys(t).length > 0, i = Object.keys(n).length > 0;
    if (!(!r && !i))
      return r && i ? {
        ...t,
        ...n
      } : r ? t : n;
  }
}
class dG extends Ox {
  /**
   * The reference to the current hub.
   */
  // eslint-disable-next-line deprecation/deprecation
  // DO NOT yet remove this property, it is used in a hack for v7 backwards compatibility.
  /**
   * This constructor should never be called manually. Those instrumenting tracing should use
   * `Sentry.startTransaction()`, and internal methods should use `hub.startTransaction()`.
   * @internal
   * @hideconstructor
   * @hidden
   *
   * @deprecated Transactions will be removed in v8. Use spans instead.
   */
  // eslint-disable-next-line deprecation/deprecation
  constructor(t, n) {
    super(t), this._contexts = {}, this._hub = n || Ea(), this._name = t.name || "", this._metadata = {
      // eslint-disable-next-line deprecation/deprecation
      ...t.metadata
    }, this._trimEnd = t.trimEnd, this.transaction = this;
    const r = this._metadata.dynamicSamplingContext;
    r && (this._frozenDynamicSamplingContext = { ...r });
  }
  // This sadly conflicts with the getter/setter ordering :(
  /* eslint-disable @typescript-eslint/member-ordering */
  /**
   * Getter for `name` property.
   * @deprecated Use `spanToJSON(span).description` instead.
   */
  get name() {
    return this._name;
  }
  /**
   * Setter for `name` property, which also sets `source` as custom.
   * @deprecated Use `updateName()` and `setMetadata()` instead.
   */
  set name(t) {
    this.setName(t);
  }
  /**
   * Get the metadata for this transaction.
   * @deprecated Use `spanGetMetadata(transaction)` instead.
   */
  get metadata() {
    return {
      // Defaults
      // eslint-disable-next-line deprecation/deprecation
      source: "custom",
      spanMetadata: {},
      // Legacy metadata
      ...this._metadata,
      // From attributes
      ...this._attributes[Dd] && {
        source: this._attributes[Dd]
      },
      ...this._attributes[Ah] && {
        sampleRate: this._attributes[Ah]
      }
    };
  }
  /**
   * Update the metadata for this transaction.
   * @deprecated Use `spanGetMetadata(transaction)` instead.
   */
  set metadata(t) {
    this._metadata = t;
  }
  /* eslint-enable @typescript-eslint/member-ordering */
  /**
   * Setter for `name` property, which also sets `source` on the metadata.
   *
   * @deprecated Use `.updateName()` and `.setAttribute()` instead.
   */
  setName(t, n = "custom") {
    this._name = t, this.setAttribute(Dd, n);
  }
  /** @inheritdoc */
  updateName(t) {
    return this._name = t, this;
  }
  /**
   * Attaches SpanRecorder to the span itself
   * @param maxlen maximum number of spans that can be recorded
   */
  initSpanRecorder(t = 1e3) {
    this.spanRecorder || (this.spanRecorder = new uG(t)), this.spanRecorder.add(this);
  }
  /**
   * Set the context of a transaction event.
   * @deprecated Use either `.setAttribute()`, or set the context on the scope before creating the transaction.
   */
  setContext(t, n) {
    n === null ? delete this._contexts[t] : this._contexts[t] = n;
  }
  /**
   * @inheritDoc
   *
   * @deprecated Use top-level `setMeasurement()` instead.
   */
  setMeasurement(t, n, r = "") {
    this._measurements[t] = { value: n, unit: r };
  }
  /**
   * Store metadata on this transaction.
   * @deprecated Use attributes or store data on the scope instead.
   */
  setMetadata(t) {
    this._metadata = { ...this._metadata, ...t };
  }
  /**
   * @inheritDoc
   */
  end(t) {
    const n = Ax(t), r = this._finishTransaction(n);
    if (r)
      return this._hub.captureEvent(r);
  }
  /**
   * @inheritDoc
   */
  toContext() {
    const t = super.toContext();
    return Ao({
      ...t,
      name: this._name,
      trimEnd: this._trimEnd
    });
  }
  /**
   * @inheritDoc
   */
  updateWithContext(t) {
    return super.updateWithContext(t), this._name = t.name || "", this._trimEnd = t.trimEnd, this;
  }
  /**
   * @inheritdoc
   *
   * @experimental
   *
   * @deprecated Use top-level `getDynamicSamplingContextFromSpan` instead.
   */
  getDynamicSamplingContext() {
    return yg(this);
  }
  /**
   * Override the current hub with a new one.
   * Used if you want another hub to finish the transaction.
   *
   * @internal
   */
  // eslint-disable-next-line deprecation/deprecation
  setHub(t) {
    this._hub = t;
  }
  /**
   * Get the profile id of the transaction.
   */
  getProfileId() {
    if (this._contexts !== void 0 && this._contexts.profile !== void 0)
      return this._contexts.profile.profile_id;
  }
  /**
   * Finish the transaction & prepare the event to send to Sentry.
   */
  _finishTransaction(t) {
    if (this._endTime !== void 0)
      return;
    this._name || (Mt && xe.warn("Transaction has no name, falling back to `<unlabeled transaction>`."), this._name = "<unlabeled transaction>"), super.end(t);
    const n = this._hub.getClient();
    if (n && n.emit && n.emit("finishTransaction", this), this._sampled !== !0) {
      Mt && xe.log("[Tracing] Discarding transaction because its trace was not chosen to be sampled."), n && n.recordDroppedEvent("sample_rate", "transaction");
      return;
    }
    const r = this.spanRecorder ? (
      // eslint-disable-next-line deprecation/deprecation
      this.spanRecorder.spans.filter((u) => u !== this && Ui(u).timestamp)
    ) : [];
    if (this._trimEnd && r.length > 0) {
      const u = r.map((d) => Ui(d).timestamp).filter(Boolean);
      this._endTime = u.reduce((d, f) => d > f ? d : f);
    }
    const { scope: i, isolationScope: o } = o1e(this), { metadata: a } = this, { source: s } = a, c = {
      contexts: {
        ...this._contexts,
        // We don't want to override trace context
        trace: OP(this)
      },
      // TODO: Pass spans serialized via `spanToJSON()` here instead in v8.
      spans: r,
      start_timestamp: this._startTime,
      // eslint-disable-next-line deprecation/deprecation
      tags: this.tags,
      timestamp: this._endTime,
      transaction: this._name,
      type: "transaction",
      sdkProcessingMetadata: {
        ...a,
        capturedSpanScope: i,
        capturedSpanIsolationScope: o,
        ...Ao({
          dynamicSamplingContext: yg(this)
        })
      },
      _metrics_summary: void 0,
      ...s && {
        transaction_info: {
          source: s
        }
      }
    };
    return Object.keys(this._measurements).length > 0 && (Mt && xe.log(
      "[Measurements] Adding measurements to transaction",
      JSON.stringify(this._measurements, void 0, 2)
    ), c.measurements = this._measurements), Mt && xe.log(`[Tracing] Finishing ${this.op} transaction: ${this._name}.`), c;
  }
}
const L1 = {
  idleTimeout: 1e3,
  finalTimeout: 3e4,
  heartbeatInterval: 5e3
}, s1e = "finishReason", eh = [
  "heartbeatFailed",
  "idleTimeout",
  "documentHidden",
  "finalTimeout",
  "externalFinish",
  "cancelled"
];
class c1e extends uG {
  constructor(t, n, r, i) {
    super(i), this._pushActivity = t, this._popActivity = n, this.transactionSpanId = r;
  }
  /**
   * @inheritDoc
   */
  add(t) {
    if (t.spanContext().spanId !== this.transactionSpanId) {
      const n = t.end;
      t.end = (...r) => (this._popActivity(t.spanContext().spanId), n.apply(t, r)), Ui(t).timestamp === void 0 && this._pushActivity(t.spanContext().spanId);
    }
    super.add(t);
  }
}
class l1e extends dG {
  // Activities store a list of active spans
  // Track state of activities in previous heartbeat
  // Amount of times heartbeat has counted. Will cause transaction to finish after 3 beats.
  // We should not use heartbeat if we finished a transaction
  // Idle timeout was canceled and we should finish the transaction with the last span end.
  /**
   * Timer that tracks Transaction idleTimeout
   */
  /**
   * @deprecated Transactions will be removed in v8. Use spans instead.
   */
  constructor(t, n, r = L1.idleTimeout, i = L1.finalTimeout, o = L1.heartbeatInterval, a = !1, s = !1) {
    super(t, n), this._idleHub = n, this._idleTimeout = r, this._finalTimeout = i, this._heartbeatInterval = o, this._onScope = a, this.activities = {}, this._heartbeatCounter = 0, this._finished = !1, this._idleTimeoutCanceledPermanently = !1, this._beforeFinishCallbacks = [], this._finishReason = eh[4], this._autoFinishAllowed = !s, a && (Mt && xe.log(`Setting idle transaction on scope. Span ID: ${this.spanContext().spanId}`), n.getScope().setSpan(this)), s || this._restartIdleTimeout(), setTimeout(() => {
      this._finished || (this.setStatus("deadline_exceeded"), this._finishReason = eh[3], this.end());
    }, this._finalTimeout);
  }
  /** {@inheritDoc} */
  end(t) {
    const n = Ax(t);
    if (this._finished = !0, this.activities = {}, this.op === "ui.action.click" && this.setAttribute(s1e, this._finishReason), this.spanRecorder) {
      Mt && // eslint-disable-next-line deprecation/deprecation
      xe.log("[Tracing] finishing IdleTransaction", new Date(n * 1e3).toISOString(), this.op);
      for (const r of this._beforeFinishCallbacks)
        r(this, n);
      this.spanRecorder.spans = this.spanRecorder.spans.filter((r) => {
        if (r.spanContext().spanId === this.spanContext().spanId)
          return !0;
        Ui(r).timestamp || (r.setStatus("cancelled"), r.end(n), Mt && xe.log("[Tracing] cancelling span since transaction ended early", JSON.stringify(r, void 0, 2)));
        const { start_timestamp: i, timestamp: o } = Ui(r), a = i && i < n, s = (this._finalTimeout + this._idleTimeout) / 1e3, c = o && i && o - i < s;
        if (Mt) {
          const l = JSON.stringify(r, void 0, 2);
          a ? c || xe.log("[Tracing] discarding Span since it finished after Transaction final timeout", l) : xe.log("[Tracing] discarding Span since it happened after Transaction was finished", l);
        }
        return a && c;
      }), Mt && xe.log("[Tracing] flushing IdleTransaction");
    } else
      Mt && xe.log("[Tracing] No active IdleTransaction");
    if (this._onScope) {
      const r = this._idleHub.getScope();
      r.getTransaction() === this && r.setSpan(void 0);
    }
    return super.end(t);
  }
  /**
   * Register a callback function that gets executed before the transaction finishes.
   * Useful for cleanup or if you want to add any additional spans based on current context.
   *
   * This is exposed because users have no other way of running something before an idle transaction
   * finishes.
   */
  registerBeforeFinishCallback(t) {
    this._beforeFinishCallbacks.push(t);
  }
  /**
   * @inheritDoc
   */
  initSpanRecorder(t) {
    if (!this.spanRecorder) {
      const n = (i) => {
        this._finished || this._pushActivity(i);
      }, r = (i) => {
        this._finished || this._popActivity(i);
      };
      this.spanRecorder = new c1e(n, r, this.spanContext().spanId, t), Mt && xe.log("Starting heartbeat"), this._pingHeartbeat();
    }
    this.spanRecorder.add(this);
  }
  /**
   * Cancels the existing idle timeout, if there is one.
   * @param restartOnChildSpanChange Default is `true`.
   *                                 If set to false the transaction will end
   *                                 with the last child span.
   */
  cancelIdleTimeout(t, {
    restartOnChildSpanChange: n
  } = {
    restartOnChildSpanChange: !0
  }) {
    this._idleTimeoutCanceledPermanently = n === !1, this._idleTimeoutID && (clearTimeout(this._idleTimeoutID), this._idleTimeoutID = void 0, Object.keys(this.activities).length === 0 && this._idleTimeoutCanceledPermanently && (this._finishReason = eh[5], this.end(t)));
  }
  /**
   * Temporary method used to externally set the transaction's `finishReason`
   *
   * ** WARNING**
   * This is for the purpose of experimentation only and will be removed in the near future, do not use!
   *
   * @internal
   *
   */
  setFinishReason(t) {
    this._finishReason = t;
  }
  /**
   * Permits the IdleTransaction to automatically end itself via the idle timeout and heartbeat mechanisms when the `delayAutoFinishUntilSignal` option was set to `true`.
   */
  sendAutoFinishSignal() {
    this._autoFinishAllowed || (Mt && xe.log("[Tracing] Received finish signal for idle transaction."), this._restartIdleTimeout(), this._autoFinishAllowed = !0);
  }
  /**
   * Restarts idle timeout, if there is no running idle timeout it will start one.
   */
  _restartIdleTimeout(t) {
    this.cancelIdleTimeout(), this._idleTimeoutID = setTimeout(() => {
      !this._finished && Object.keys(this.activities).length === 0 && (this._finishReason = eh[1], this.end(t));
    }, this._idleTimeout);
  }
  /**
   * Start tracking a specific activity.
   * @param spanId The span id that represents the activity
   */
  _pushActivity(t) {
    this.cancelIdleTimeout(void 0, { restartOnChildSpanChange: !this._idleTimeoutCanceledPermanently }), Mt && xe.log(`[Tracing] pushActivity: ${t}`), this.activities[t] = !0, Mt && xe.log("[Tracing] new activities count", Object.keys(this.activities).length);
  }
  /**
   * Remove an activity from usage
   * @param spanId The span id that represents the activity
   */
  _popActivity(t) {
    if (this.activities[t] && (Mt && xe.log(`[Tracing] popActivity ${t}`), delete this.activities[t], Mt && xe.log("[Tracing] new activities count", Object.keys(this.activities).length)), Object.keys(this.activities).length === 0) {
      const n = Qv();
      this._idleTimeoutCanceledPermanently ? this._autoFinishAllowed && (this._finishReason = eh[5], this.end(n)) : this._restartIdleTimeout(n + this._idleTimeout / 1e3);
    }
  }
  /**
   * Checks when entries of this.activities are not changing for 3 beats.
   * If this occurs we finish the transaction.
   */
  _beat() {
    if (this._finished)
      return;
    const t = Object.keys(this.activities).join("");
    t === this._prevHeartbeatString ? this._heartbeatCounter++ : this._heartbeatCounter = 1, this._prevHeartbeatString = t, this._heartbeatCounter >= 3 ? this._autoFinishAllowed && (Mt && xe.log("[Tracing] Transaction finished because of no change for 3 heart beats"), this.setStatus("deadline_exceeded"), this._finishReason = eh[0], this.end()) : this._pingHeartbeat();
  }
  /**
   * Pings the heartbeat
   */
  _pingHeartbeat() {
    Mt && xe.log(`pinging Heartbeat -> current counter: ${this._heartbeatCounter}`), setTimeout(() => {
      this._beat();
    }, this._heartbeatInterval);
  }
}
function fG(e, t, n) {
  if (!yp(t))
    return e.sampled = !1, e;
  if (e.sampled !== void 0)
    return e.setAttribute(Ah, Number(e.sampled)), e;
  let r;
  return typeof t.tracesSampler == "function" ? (r = t.tracesSampler(n), e.setAttribute(Ah, Number(r))) : n.parentSampled !== void 0 ? r = n.parentSampled : typeof t.tracesSampleRate < "u" ? (r = t.tracesSampleRate, e.setAttribute(Ah, Number(r))) : (r = 1, e.setAttribute(Ah, r)), hG(r) ? r ? (e.sampled = Math.random() < r, e.sampled ? (Mt && // eslint-disable-next-line deprecation/deprecation
  xe.log(`[Tracing] starting ${e.op} transaction - ${Ui(e).description}`), e) : (Mt && xe.log(
    `[Tracing] Discarding transaction because it's not included in the random sample (sampling rate = ${Number(
      r
    )})`
  ), e)) : (Mt && xe.log(
    `[Tracing] Discarding transaction because ${typeof t.tracesSampler == "function" ? "tracesSampler returned 0 or false" : "a negative sampling decision was inherited or tracesSampleRate is set to 0"}`
  ), e.sampled = !1, e) : (Mt && xe.warn("[Tracing] Discarding transaction because of invalid sample rate."), e.sampled = !1, e);
}
function hG(e) {
  return Aq(e) || !(typeof e == "number" || typeof e == "boolean") ? (Mt && xe.warn(
    `[Tracing] Given sample rate is invalid. Sample rate must be a boolean or a number between 0 and 1. Got ${JSON.stringify(
      e
    )} of type ${JSON.stringify(typeof e)}.`
  ), !1) : e < 0 || e > 1 ? (Mt && xe.warn(`[Tracing] Given sample rate is invalid. Sample rate must be between 0 and 1. Got ${e}.`), !1) : !0;
}
function u1e() {
  const t = this.getScope().getSpan();
  return t ? {
    "sentry-trace": Ix(t)
  } : {};
}
function d1e(e, t) {
  const n = this.getClient(), r = n && n.getOptions() || {}, i = r.instrumenter || "sentry", o = e.instrumenter || "sentry";
  i !== o && (Mt && xe.error(
    `A transaction was started with instrumenter=\`${o}\`, but the SDK is configured with the \`${i}\` instrumenter.
The transaction will not be sampled. Please use the ${i} instrumentation to start transactions.`
  ), e.sampled = !1);
  let a = new dG(e, this);
  return a = fG(a, r, {
    name: e.name,
    parentSampled: e.parentSampled,
    transactionContext: e,
    attributes: {
      // eslint-disable-next-line deprecation/deprecation
      ...e.data,
      ...e.attributes
    },
    ...t
  }), a.isRecording() && a.initSpanRecorder(r._experiments && r._experiments.maxSpans), n && n.emit && n.emit("startTransaction", a), a;
}
function I4(e, t, n, r, i, o, a, s = !1) {
  const c = e.getClient(), l = c && c.getOptions() || {};
  let u = new l1e(
    t,
    e,
    n,
    r,
    a,
    i,
    s
  );
  return u = fG(u, l, {
    name: t.name,
    parentSampled: t.parentSampled,
    transactionContext: t,
    attributes: {
      // eslint-disable-next-line deprecation/deprecation
      ...t.data,
      ...t.attributes
    },
    ...o
  }), u.isRecording() && u.initSpanRecorder(l._experiments && l._experiments.maxSpans), c && c.emit && c.emit("startTransaction", u), u;
}
function f1e() {
  const e = Jv();
  e.__SENTRY__ && (e.__SENTRY__.extensions = e.__SENTRY__.extensions || {}, e.__SENTRY__.extensions.startTransaction || (e.__SENTRY__.extensions.startTransaction = d1e), e.__SENTRY__.extensions.traceHeaders || (e.__SENTRY__.extensions.traceHeaders = u1e), Zbe());
}
function h1e(e, t, n) {
  const r = of();
  r && r.setMeasurement(e, t, n);
}
function g1e(e, t) {
  return t && (e.sdk = e.sdk || {}, e.sdk.name = e.sdk.name || t.name, e.sdk.version = e.sdk.version || t.version, e.sdk.integrations = [...e.sdk.integrations || [], ...t.integrations || []], e.sdk.packages = [...e.sdk.packages || [], ...t.packages || []]), e;
}
function p1e(e, t, n, r) {
  const i = RP(n), o = {
    sent_at: (/* @__PURE__ */ new Date()).toISOString(),
    ...i && { sdk: i },
    ...!!r && t && { dsn: vp(t) }
  }, a = "aggregates" in e ? [{ type: "sessions" }, e] : [{ type: "session" }, e.toJSON()];
  return Vu(o, [a]);
}
function m1e(e, t, n, r) {
  const i = RP(n), o = e.type && e.type !== "replay_event" ? e.type : "event";
  g1e(e, n && n.sdk);
  const a = Gq(e, i, r, t);
  return delete e.sdkProcessingMetadata, Vu(a, [[{ type: o }, e]]);
}
const v1e = "7";
function y1e(e) {
  const t = e.protocol ? `${e.protocol}:` : "", n = e.port ? `:${e.port}` : "";
  return `${t}//${e.host}${n}${e.path ? `/${e.path}` : ""}/api/`;
}
function b1e(e) {
  return `${y1e(e)}${e.projectId}/envelope/`;
}
function _1e(e, t) {
  return Rye({
    // We send only the minimum set of required information. See
    // https://github.com/getsentry/sentry-javascript/issues/2572.
    sentry_key: e.publicKey,
    sentry_version: v1e,
    ...t && { sentry_client: `${t.name}/${t.version}` }
  });
}
function S1e(e, t = {}) {
  const n = typeof t == "string" ? t : t.tunnel, r = typeof t == "string" || !t._metadata ? void 0 : t._metadata.sdk;
  return n || `${b1e(e)}?${_1e(e, r)}`;
}
const A4 = [];
function w1e(e) {
  const t = {};
  return e.forEach((n) => {
    const { name: r } = n, i = t[r];
    i && !i.isDefaultInstance && n.isDefaultInstance || (t[r] = n);
  }), Object.keys(t).map((n) => t[n]);
}
function x1e(e) {
  const t = e.defaultIntegrations || [], n = e.integrations;
  t.forEach((a) => {
    a.isDefaultInstance = !0;
  });
  let r;
  Array.isArray(n) ? r = [...t, ...n] : typeof n == "function" ? r = jq(n(t)) : r = t;
  const i = w1e(r), o = C1e(i, (a) => a.name === "Debug");
  if (o !== -1) {
    const [a] = i.splice(o, 1);
    i.push(a);
  }
  return i;
}
function E1e(e, t) {
  const n = {};
  return t.forEach((r) => {
    r && gG(e, r, n);
  }), n;
}
function R4(e, t) {
  for (const n of t)
    n && n.afterAllSetup && n.afterAllSetup(e);
}
function gG(e, t, n) {
  if (n[t.name]) {
    Mt && xe.log(`Integration skipped because it was already installed: ${t.name}`);
    return;
  }
  if (n[t.name] = t, A4.indexOf(t.name) === -1 && (t.setupOnce(Ibe, Ea), A4.push(t.name)), t.setup && typeof t.setup == "function" && t.setup(e), e.on && typeof t.preprocessEvent == "function") {
    const r = t.preprocessEvent.bind(t);
    e.on("preprocessEvent", (i, o) => r(i, o, e));
  }
  if (e.addEventProcessor && typeof t.processEvent == "function") {
    const r = t.processEvent.bind(t), i = Object.assign((o, a) => r(o, a, e), {
      id: t.name
    });
    e.addEventProcessor(i);
  }
  Mt && xe.log(`Integration installed: ${t.name}`);
}
function C1e(e, t) {
  for (let n = 0; n < e.length; n++)
    if (t(e[n]) === !0)
      return n;
  return -1;
}
function zu(e, t) {
  return Object.assign(
    function(...r) {
      return t(...r);
    },
    { id: e }
  );
}
function T1e(e) {
  let t = "";
  for (const n of e) {
    const r = Object.entries(n.tags), i = r.length > 0 ? `|#${r.map(([o, a]) => `${o}:${a}`).join(",")}` : "";
    t += `${n.name}@${n.unit}:${n.metric}|${n.metricType}${i}|T${n.timestamp}
`;
  }
  return t;
}
function I1e(e, t, n, r) {
  const i = {
    sent_at: (/* @__PURE__ */ new Date()).toISOString()
  };
  n && n.sdk && (i.sdk = {
    name: n.sdk.name,
    version: n.sdk.version
  }), r && t && (i.dsn = vp(t));
  const o = A1e(e);
  return Vu(i, [o]);
}
function A1e(e) {
  const t = T1e(e);
  return [{
    type: "statsd",
    length: t.length
  }, t];
}
const $4 = "Not capturing exception because it's already been captured.";
class R1e {
  /**
   * A reference to a metrics aggregator
   *
   * @experimental Note this is alpha API. It may experience breaking changes in the future.
   */
  /** Options passed to the SDK. */
  /** The client Dsn, if specified in options. Without this Dsn, the SDK will be disabled. */
  /** Array of set up integrations. */
  /** Indicates whether this client's integrations have been set up. */
  /** Number of calls being processed */
  /** Holds flushable  */
  // eslint-disable-next-line @typescript-eslint/ban-types
  /**
   * Initializes this client instance.
   *
   * @param options Options for the client.
   */
  constructor(t) {
    if (this._options = t, this._integrations = {}, this._integrationsInitialized = !1, this._numProcessing = 0, this._outcomes = {}, this._hooks = {}, this._eventProcessors = [], t.dsn ? this._dsn = Aye(t.dsn) : Mt && xe.warn("No DSN provided, client will not send events."), this._dsn) {
      const n = S1e(this._dsn, t);
      this._transport = t.transport({
        tunnel: this._options.tunnel,
        recordDroppedEvent: this.recordDroppedEvent.bind(this),
        ...t.transportOptions,
        url: n
      });
    }
  }
  /**
   * @inheritDoc
   */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
  captureException(t, n, r) {
    if (u4(t)) {
      Mt && xe.log($4);
      return;
    }
    let i = n && n.event_id;
    return this._process(
      this.eventFromException(t, n).then((o) => this._captureEvent(o, n, r)).then((o) => {
        i = o;
      })
    ), i;
  }
  /**
   * @inheritDoc
   */
  captureMessage(t, n, r, i) {
    let o = r && r.event_id;
    const a = SP(t) ? t : String(t), s = wP(t) ? this.eventFromMessage(a, n, r) : this.eventFromException(t, r);
    return this._process(
      s.then((c) => this._captureEvent(c, r, i)).then((c) => {
        o = c;
      })
    ), o;
  }
  /**
   * @inheritDoc
   */
  captureEvent(t, n, r) {
    if (n && n.originalException && u4(n.originalException)) {
      Mt && xe.log($4);
      return;
    }
    let i = n && n.event_id;
    const a = (t.sdkProcessingMetadata || {}).capturedSpanScope;
    return this._process(
      this._captureEvent(t, n, a || r).then((s) => {
        i = s;
      })
    ), i;
  }
  /**
   * @inheritDoc
   */
  captureSession(t) {
    typeof t.release != "string" ? Mt && xe.warn("Discarded session because of missing or non-string release") : (this.sendSession(t), rf(t, { init: !1 }));
  }
  /**
   * @inheritDoc
   */
  getDsn() {
    return this._dsn;
  }
  /**
   * @inheritDoc
   */
  getOptions() {
    return this._options;
  }
  /**
   * @see SdkMetadata in @sentry/types
   *
   * @return The metadata of the SDK
   */
  getSdkMetadata() {
    return this._options._metadata;
  }
  /**
   * @inheritDoc
   */
  getTransport() {
    return this._transport;
  }
  /**
   * @inheritDoc
   */
  flush(t) {
    const n = this._transport;
    return n ? (this.metricsAggregator && this.metricsAggregator.flush(), this._isClientDoneProcessing(t).then((r) => n.flush(t).then((i) => r && i))) : vg(!0);
  }
  /**
   * @inheritDoc
   */
  close(t) {
    return this.flush(t).then((n) => (this.getOptions().enabled = !1, this.metricsAggregator && this.metricsAggregator.close(), n));
  }
  /** Get all installed event processors. */
  getEventProcessors() {
    return this._eventProcessors;
  }
  /** @inheritDoc */
  addEventProcessor(t) {
    this._eventProcessors.push(t);
  }
  /**
   * This is an internal function to setup all integrations that should run on the client.
   * @deprecated Use `client.init()` instead.
   */
  setupIntegrations(t) {
    (t && !this._integrationsInitialized || this._isEnabled() && !this._integrationsInitialized) && this._setupIntegrations();
  }
  /** @inheritdoc */
  init() {
    this._isEnabled() && this._setupIntegrations();
  }
  /**
   * Gets an installed integration by its `id`.
   *
   * @returns The installed integration or `undefined` if no integration with that `id` was installed.
   * @deprecated Use `getIntegrationByName()` instead.
   */
  getIntegrationById(t) {
    return this.getIntegrationByName(t);
  }
  /**
   * Gets an installed integration by its name.
   *
   * @returns The installed integration or `undefined` if no integration with that `name` was installed.
   */
  getIntegrationByName(t) {
    return this._integrations[t];
  }
  /**
   * Returns the client's instance of the given integration class, it any.
   * @deprecated Use `getIntegrationByName()` instead.
   */
  getIntegration(t) {
    try {
      return this._integrations[t.id] || null;
    } catch {
      return Mt && xe.warn(`Cannot retrieve integration ${t.id} from the current Client`), null;
    }
  }
  /**
   * @inheritDoc
   */
  addIntegration(t) {
    const n = this._integrations[t.name];
    gG(this, t, this._integrations), n || R4(this, [t]);
  }
  /**
   * @inheritDoc
   */
  sendEvent(t, n = {}) {
    this.emit("beforeSendEvent", t, n);
    let r = m1e(t, this._dsn, this._options._metadata, this._options.tunnel);
    for (const o of n.attachments || [])
      r = vbe(
        r,
        _be(
          o,
          this._options.transportOptions && this._options.transportOptions.textEncoder
        )
      );
    const i = this._sendEnvelope(r);
    i && i.then((o) => this.emit("afterSendEvent", t, o), null);
  }
  /**
   * @inheritDoc
   */
  sendSession(t) {
    const n = p1e(t, this._dsn, this._options._metadata, this._options.tunnel);
    this._sendEnvelope(n);
  }
  /**
   * @inheritDoc
   */
  recordDroppedEvent(t, n, r) {
    if (this._options.sendClientReports) {
      const i = typeof r == "number" ? r : 1, o = `${t}:${n}`;
      Mt && xe.log(`Recording outcome: "${o}"${i > 1 ? ` (${i} times)` : ""}`), this._outcomes[o] = (this._outcomes[o] || 0) + i;
    }
  }
  /**
   * @inheritDoc
   */
  captureAggregateMetrics(t) {
    Mt && xe.log(`Flushing aggregated metrics, number of metrics: ${t.length}`);
    const n = I1e(
      t,
      this._dsn,
      this._options._metadata,
      this._options.tunnel
    );
    this._sendEnvelope(n);
  }
  // Keep on() & emit() signatures in sync with types' client.ts interface
  /* eslint-disable @typescript-eslint/unified-signatures */
  /** @inheritdoc */
  /** @inheritdoc */
  on(t, n) {
    this._hooks[t] || (this._hooks[t] = []), this._hooks[t].push(n);
  }
  /** @inheritdoc */
  /** @inheritdoc */
  emit(t, ...n) {
    this._hooks[t] && this._hooks[t].forEach((r) => r(...n));
  }
  /* eslint-enable @typescript-eslint/unified-signatures */
  /** Setup integrations for this client. */
  _setupIntegrations() {
    const { integrations: t } = this._options;
    this._integrations = E1e(this, t), R4(this, t), this._integrationsInitialized = !0;
  }
  /** Updates existing session based on the provided event */
  _updateSessionFromEvent(t, n) {
    let r = !1, i = !1;
    const o = n.exception && n.exception.values;
    if (o) {
      i = !0;
      for (const c of o) {
        const l = c.mechanism;
        if (l && l.handled === !1) {
          r = !0;
          break;
        }
      }
    }
    const a = t.status === "ok";
    (a && t.errors === 0 || a && r) && (rf(t, {
      ...r && { status: "crashed" },
      errors: t.errors || Number(i || r)
    }), this.captureSession(t));
  }
  /**
   * Determine if the client is finished processing. Returns a promise because it will wait `timeout` ms before saying
   * "no" (resolving to `false`) in order to give the client a chance to potentially finish first.
   *
   * @param timeout The time, in ms, after which to resolve to `false` if the client is still busy. Passing `0` (or not
   * passing anything) will make the promise wait as long as it takes for processing to finish before resolving to
   * `true`.
   * @returns A promise which will resolve to `true` if processing is already done or finishes before the timeout, and
   * `false` otherwise
   */
  _isClientDoneProcessing(t) {
    return new fa((n) => {
      let r = 0;
      const i = 1, o = setInterval(() => {
        this._numProcessing == 0 ? (clearInterval(o), n(!0)) : (r += i, t && r >= t && (clearInterval(o), n(!1)));
      }, i);
    });
  }
  /** Determines whether this SDK is enabled and a transport is present. */
  _isEnabled() {
    return this.getOptions().enabled !== !1 && this._transport !== void 0;
  }
  /**
   * Adds common information to events.
   *
   * The information includes release and environment from `options`,
   * breadcrumbs and context (extra, tags and user) from the scope.
   *
   * Information that is already present in the event is never overwritten. For
   * nested objects, such as the context, keys are merged.
   *
   * @param event The original event.
   * @param hint May contain additional information about the original exception.
   * @param scope A scope containing event metadata.
   * @returns A new event with more information.
   */
  _prepareEvent(t, n, r, i = Bu()) {
    const o = this.getOptions(), a = Object.keys(this._integrations);
    return !n.integrations && a.length > 0 && (n.integrations = a), this.emit("preprocessEvent", t, n), Zq(o, t, n, r, this, i).then((s) => {
      if (s === null)
        return s;
      const c = {
        ...i.getPropagationContext(),
        ...r ? r.getPropagationContext() : void 0
      };
      if (!(s.contexts && s.contexts.trace) && c) {
        const { traceId: u, spanId: d, parentSpanId: f, dsc: h } = c;
        s.contexts = {
          trace: {
            trace_id: u,
            span_id: d,
            parent_span_id: f
          },
          ...s.contexts
        };
        const p = h || $x(u, this, r);
        s.sdkProcessingMetadata = {
          dynamicSamplingContext: p,
          ...s.sdkProcessingMetadata
        };
      }
      return s;
    });
  }
  /**
   * Processes the event and logs an error in case of rejection
   * @param event
   * @param hint
   * @param scope
   */
  _captureEvent(t, n = {}, r) {
    return this._processEvent(t, n, r).then(
      (i) => i.event_id,
      (i) => {
        if (Mt) {
          const o = i;
          o.logLevel === "log" ? xe.log(o.message) : xe.warn(o);
        }
      }
    );
  }
  /**
   * Processes an event (either error or message) and sends it to Sentry.
   *
   * This also adds breadcrumbs and context information to the event. However,
   * platform specific meta data (such as the User's IP address) must be added
   * by the SDK implementor.
   *
   *
   * @param event The event to send to Sentry.
   * @param hint May contain additional information about the original exception.
   * @param scope A scope containing event metadata.
   * @returns A SyncPromise that resolves with the event or rejects in case event was/will not be send.
   */
  _processEvent(t, n, r) {
    const i = this.getOptions(), { sampleRate: o } = i, a = mG(t), s = pG(t), c = t.type || "error", l = `before send for type \`${c}\``;
    if (s && typeof o == "number" && Math.random() > o)
      return this.recordDroppedEvent("sample_rate", "error", t), IP(
        new qs(
          `Discarding event because it's not included in the random sample (sampling rate = ${o})`,
          "log"
        )
      );
    const u = c === "replay_event" ? "replay" : c, f = (t.sdkProcessingMetadata || {}).capturedSpanIsolationScope;
    return this._prepareEvent(t, n, r, f).then((h) => {
      if (h === null)
        throw this.recordDroppedEvent("event_processor", u, t), new qs("An event processor returned `null`, will not send event.", "log");
      if (n.data && n.data.__sentry__ === !0)
        return h;
      const g = O1e(i, h, n);
      return $1e(g, l);
    }).then((h) => {
      if (h === null) {
        if (this.recordDroppedEvent("before_send", u, t), a) {
          const v = 1 + (t.spans || []).length;
          this.recordDroppedEvent("before_send", "span", v);
        }
        throw new qs(`${l} returned \`null\`, will not send event.`, "log");
      }
      const p = r && r.getSession();
      if (!a && p && this._updateSessionFromEvent(p, h), a) {
        const m = h.sdkProcessingMetadata && h.sdkProcessingMetadata.spanCountBeforeProcessing || 0, v = h.spans ? h.spans.length : 0, y = m - v;
        y > 0 && this.recordDroppedEvent("before_send", "span", y);
      }
      const g = h.transaction_info;
      if (a && g && h.transaction !== t.transaction) {
        const m = "custom";
        h.transaction_info = {
          ...g,
          source: m
        };
      }
      return this.sendEvent(h, n), h;
    }).then(null, (h) => {
      throw h instanceof qs ? h : (this.captureException(h, {
        data: {
          __sentry__: !0
        },
        originalException: h
      }), new qs(
        `Event processing pipeline threw an error, original event will not be sent. Details have been sent as a new event.
Reason: ${h}`
      ));
    });
  }
  /**
   * Occupies the client with processing and event
   */
  _process(t) {
    this._numProcessing++, t.then(
      (n) => (this._numProcessing--, n),
      (n) => (this._numProcessing--, n)
    );
  }
  /**
   * @inheritdoc
   */
  _sendEnvelope(t) {
    if (this.emit("beforeEnvelope", t), this._isEnabled() && this._transport)
      return this._transport.send(t).then(null, (n) => {
        Mt && xe.error("Error while sending event:", n);
      });
    Mt && xe.error("Transport disabled");
  }
  /**
   * Clears outcomes on this client and returns them.
   */
  _clearOutcomes() {
    const t = this._outcomes;
    return this._outcomes = {}, Object.keys(t).map((n) => {
      const [r, i] = n.split(":");
      return {
        reason: r,
        category: i,
        quantity: t[n]
      };
    });
  }
  /**
   * @inheritDoc
   */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
}
function $1e(e, t) {
  const n = `${t} must return \`null\` or a valid event.`;
  if (Ex(e))
    return e.then(
      (r) => {
        if (!mg(r) && r !== null)
          throw new qs(n);
        return r;
      },
      (r) => {
        throw new qs(`${t} rejected with ${r}`);
      }
    );
  if (!mg(e) && e !== null)
    throw new qs(n);
  return e;
}
function O1e(e, t, n) {
  const { beforeSend: r, beforeSendTransaction: i } = e;
  if (pG(t) && r)
    return r(t, n);
  if (mG(t) && i) {
    if (t.spans) {
      const o = t.spans.length;
      t.sdkProcessingMetadata = {
        ...t.sdkProcessingMetadata,
        spanCountBeforeProcessing: o
      };
    }
    return i(t, n);
  }
  return t;
}
function pG(e) {
  return e.type === void 0;
}
function mG(e) {
  return e.type === "transaction";
}
function P1e(e) {
  const t = Yn();
  !t || !t.addEventProcessor || t.addEventProcessor(e);
}
function M1e(e, t) {
  t.debug === !0 && (Mt ? xe.enable() : tf(() => {
    console.warn("[Sentry] Cannot initialize SDK with `debug` option using a non-debug bundle.");
  })), xa().update(t.initialScope);
  const r = new e(t);
  k1e(r), N1e(r);
}
function k1e(e) {
  const n = Ea().getStackTop();
  n.client = e, n.scope.setClient(e);
}
function N1e(e) {
  e.init ? e.init() : e.setupIntegrations && e.setupIntegrations();
}
const D1e = 30;
function vG(e, t, n = abe(
  e.bufferSize || D1e
)) {
  let r = {};
  const i = (a) => n.drain(a);
  function o(a) {
    const s = [];
    if (m4(a, (d, f) => {
      const h = v4(f);
      if (Kq(r, h)) {
        const p = O4(d, f);
        e.recordDroppedEvent("ratelimit_backoff", h, p);
      } else
        s.push(d);
    }), s.length === 0)
      return vg();
    const c = Vu(a[0], s), l = (d) => {
      m4(c, (f, h) => {
        const p = O4(f, h);
        e.recordDroppedEvent(d, v4(h), p);
      });
    }, u = () => t({ body: ybe(c, e.textEncoder) }).then(
      (d) => (d.statusCode !== void 0 && (d.statusCode < 200 || d.statusCode >= 300) && Mt && xe.warn(`Sentry responded with status code ${d.statusCode} to sent event.`), r = Yq(r, d), d),
      (d) => {
        throw l("network_error"), d;
      }
    );
    return n.add(u).then(
      (d) => d,
      (d) => {
        if (d instanceof qs)
          return Mt && xe.error("Skipped sending event because buffer is full."), l("queue_overflow"), vg();
        throw d;
      }
    );
  }
  return o.__sentry__baseTransport__ = !0, {
    send: o,
    flush: i
  };
}
function O4(e, t) {
  if (!(t !== "event" && t !== "transaction"))
    return Array.isArray(e) ? e[1] : void 0;
}
function L1e(e, t) {
  const n = {
    sent_at: (/* @__PURE__ */ new Date()).toISOString()
  };
  t && (n.dsn = vp(t));
  const r = e.map(j1e);
  return Vu(n, r);
}
function j1e(e) {
  return [{
    type: "span"
  }, e];
}
function F1e(e, t) {
  const n = t && z1e(t) ? (
    // eslint-disable-next-line deprecation/deprecation
    t.getClient()
  ) : t, r = n && n.getDsn(), i = n && n.getOptions().tunnel;
  return B1e(e, r) || V1e(e, i);
}
function V1e(e, t) {
  return t ? P4(e) === P4(t) : !1;
}
function B1e(e, t) {
  return t ? e.includes(t.host) : !1;
}
function P4(e) {
  return e[e.length - 1] === "/" ? e.slice(0, -1) : e;
}
function z1e(e) {
  return e.getClient !== void 0;
}
function yG(e, t, n = [t], r = "npm") {
  const i = e._metadata || {};
  i.sdk || (i.sdk = {
    name: `sentry.javascript.${t}`,
    packages: n.map((o) => ({
      name: `${r}:@sentry/${o}`,
      version: fA
    })),
    version: fA
  }), e._metadata = i;
}
const H1e = [
  /^Script error\.?$/,
  /^Javascript error: Script error\.? on line 0$/,
  /^ResizeObserver loop completed with undelivered notifications.$/,
  /^Cannot redefine property: googletag$/
], U1e = [
  /^.*\/healthcheck$/,
  /^.*\/healthy$/,
  /^.*\/live$/,
  /^.*\/ready$/,
  /^.*\/heartbeat$/,
  /^.*\/health$/,
  /^.*\/healthz$/
], bG = "InboundFilters", W1e = (e = {}) => ({
  name: bG,
  // TODO v8: Remove this
  setupOnce() {
  },
  // eslint-disable-line @typescript-eslint/no-empty-function
  processEvent(t, n, r) {
    const i = r.getOptions(), o = q1e(e, i);
    return G1e(t, o) ? null : t;
  }
}), _G = W1e;
zu(
  bG,
  _G
);
function q1e(e = {}, t = {}) {
  return {
    allowUrls: [...e.allowUrls || [], ...t.allowUrls || []],
    denyUrls: [...e.denyUrls || [], ...t.denyUrls || []],
    ignoreErrors: [
      ...e.ignoreErrors || [],
      ...t.ignoreErrors || [],
      ...e.disableErrorDefaults ? [] : H1e
    ],
    ignoreTransactions: [
      ...e.ignoreTransactions || [],
      ...t.ignoreTransactions || [],
      ...e.disableTransactionDefaults ? [] : U1e
    ],
    ignoreInternal: e.ignoreInternal !== void 0 ? e.ignoreInternal : !0
  };
}
function G1e(e, t) {
  return t.ignoreInternal && Z1e(e) ? (Mt && xe.warn(`Event dropped due to being internal Sentry Error.
Event: ${Ul(e)}`), !0) : K1e(e, t.ignoreErrors) ? (Mt && xe.warn(
    `Event dropped due to being matched by \`ignoreErrors\` option.
Event: ${Ul(e)}`
  ), !0) : Y1e(e, t.ignoreTransactions) ? (Mt && xe.warn(
    `Event dropped due to being matched by \`ignoreTransactions\` option.
Event: ${Ul(e)}`
  ), !0) : X1e(e, t.denyUrls) ? (Mt && xe.warn(
    `Event dropped due to being matched by \`denyUrls\` option.
Event: ${Ul(
      e
    )}.
Url: ${V_(e)}`
  ), !0) : Q1e(e, t.allowUrls) ? !1 : (Mt && xe.warn(
    `Event dropped due to not being matched by \`allowUrls\` option.
Event: ${Ul(
      e
    )}.
Url: ${V_(e)}`
  ), !0);
}
function K1e(e, t) {
  return e.type || !t || !t.length ? !1 : J1e(e).some((n) => pp(n, t));
}
function Y1e(e, t) {
  if (e.type !== "transaction" || !t || !t.length)
    return !1;
  const n = e.transaction;
  return n ? pp(n, t) : !1;
}
function X1e(e, t) {
  if (!t || !t.length)
    return !1;
  const n = V_(e);
  return n ? pp(n, t) : !1;
}
function Q1e(e, t) {
  if (!t || !t.length)
    return !0;
  const n = V_(e);
  return n ? pp(n, t) : !0;
}
function J1e(e) {
  const t = [];
  e.message && t.push(e.message);
  let n;
  try {
    n = e.exception.values[e.exception.values.length - 1];
  } catch {
  }
  return n && n.value && (t.push(n.value), n.type && t.push(`${n.type}: ${n.value}`)), Mt && t.length === 0 && xe.error(`Could not extract message for event ${Ul(e)}`), t;
}
function Z1e(e) {
  try {
    return e.exception.values[0].type === "SentryError";
  } catch {
  }
  return !1;
}
function e_e(e = []) {
  for (let t = e.length - 1; t >= 0; t--) {
    const n = e[t];
    if (n && n.filename !== "<anonymous>" && n.filename !== "[native code]")
      return n.filename || null;
  }
  return null;
}
function V_(e) {
  try {
    let t;
    try {
      t = e.exception.values[0].stacktrace.frames;
    } catch {
    }
    return t ? e_e(t) : null;
  } catch {
    return Mt && xe.error(`Cannot extract url for event ${Ul(e)}`), null;
  }
}
let M4;
const SG = "FunctionToString", k4 = /* @__PURE__ */ new WeakMap(), t_e = () => ({
  name: SG,
  setupOnce() {
    M4 = Function.prototype.toString;
    try {
      Function.prototype.toString = function(...e) {
        const t = EP(this), n = k4.has(Yn()) && t !== void 0 ? t : this;
        return M4.apply(n, e);
      };
    } catch {
    }
  },
  setup(e) {
    k4.set(e, !0);
  }
}), wG = t_e;
zu(
  SG,
  wG
);
const dr = typeof __SENTRY_DEBUG__ > "u" || __SENTRY_DEBUG__, sn = An;
function n_e() {
  sn.document ? sn.document.addEventListener("visibilitychange", () => {
    const e = of();
    if (sn.document.hidden && e) {
      const t = "cancelled", { op: n, status: r } = Ui(e);
      dr && xe.log(`[Tracing] Transaction: ${t} -> since tab moved to the background, op: ${n}`), r || e.setStatus(t), e.setTag("visibilitychange", "document.hidden"), e.end();
    }
  }) : dr && xe.warn("[Tracing] Could not set up background tab detection due to lack of global document");
}
const Zv = (e, t, n) => {
  let r, i;
  return (o) => {
    t.value >= 0 && (o || n) && (i = t.value - (r || 0), (i || r === void 0) && (r = t.value, t.delta = i, e(t)));
  };
}, r_e = () => `v3-${Date.now()}-${Math.floor(Math.random() * (9e12 - 1)) + 1e12}`, i_e = () => {
  const e = sn.performance.timing, t = sn.performance.navigation.type, n = {
    entryType: "navigation",
    startTime: 0,
    type: t == 2 ? "back_forward" : t === 1 ? "reload" : "navigate"
  };
  for (const r in e)
    r !== "navigationStart" && r !== "toJSON" && (n[r] = Math.max(e[r] - e.navigationStart, 0));
  return n;
}, Px = () => sn.__WEB_VITALS_POLYFILL__ ? sn.performance && (performance.getEntriesByType && performance.getEntriesByType("navigation")[0] || i_e()) : sn.performance && performance.getEntriesByType && performance.getEntriesByType("navigation")[0], kP = () => {
  const e = Px();
  return e && e.activationStart || 0;
}, ey = (e, t) => {
  const n = Px();
  let r = "navigate";
  return n && (sn.document && sn.document.prerendering || kP() > 0 ? r = "prerender" : r = n.type.replace(/_/g, "-")), {
    name: e,
    value: typeof t > "u" ? -1 : t,
    rating: "good",
    // Will be updated if the value changes.
    delta: 0,
    entries: [],
    id: r_e(),
    navigationType: r
  };
}, bp = (e, t, n) => {
  try {
    if (PerformanceObserver.supportedEntryTypes.includes(e)) {
      const r = new PerformanceObserver((i) => {
        t(i.getEntries());
      });
      return r.observe(
        Object.assign(
          {
            type: e,
            buffered: !0
          },
          n || {}
        )
      ), r;
    }
  } catch {
  }
}, ty = (e, t) => {
  const n = (r) => {
    (r.type === "pagehide" || sn.document.visibilityState === "hidden") && (e(r), t && (removeEventListener("visibilitychange", n, !0), removeEventListener("pagehide", n, !0)));
  };
  sn.document && (addEventListener("visibilitychange", n, !0), addEventListener("pagehide", n, !0));
}, o_e = (e, t = {}) => {
  const n = ey("CLS", 0);
  let r, i = 0, o = [];
  const a = (c) => {
    c.forEach((l) => {
      if (!l.hadRecentInput) {
        const u = o[0], d = o[o.length - 1];
        i && o.length !== 0 && l.startTime - d.startTime < 1e3 && l.startTime - u.startTime < 5e3 ? (i += l.value, o.push(l)) : (i = l.value, o = [l]), i > n.value && (n.value = i, n.entries = o, r && r());
      }
    });
  }, s = bp("layout-shift", a);
  if (s) {
    r = Zv(e, n, t.reportAllChanges);
    const c = () => {
      a(s.takeRecords()), r(!0);
    };
    return ty(c), c;
  }
};
let B_ = -1;
const a_e = () => {
  sn.document && sn.document.visibilityState && (B_ = sn.document.visibilityState === "hidden" && !sn.document.prerendering ? 0 : 1 / 0);
}, s_e = () => {
  ty(({ timeStamp: e }) => {
    B_ = e;
  }, !0);
}, NP = () => (B_ < 0 && (a_e(), s_e()), {
  get firstHiddenTime() {
    return B_;
  }
}), c_e = (e) => {
  const t = NP(), n = ey("FID");
  let r;
  const i = (s) => {
    s.startTime < t.firstHiddenTime && (n.value = s.processingStart - s.startTime, n.entries.push(s), r(!0));
  }, o = (s) => {
    s.forEach(i);
  }, a = bp("first-input", o);
  r = Zv(e, n), a && ty(() => {
    o(a.takeRecords()), a.disconnect();
  }, !0);
};
let xG = 0, f5 = 1 / 0, Rb = 0;
const l_e = (e) => {
  e.forEach((t) => {
    t.interactionId && (f5 = Math.min(f5, t.interactionId), Rb = Math.max(Rb, t.interactionId), xG = Rb ? (Rb - f5) / 7 + 1 : 0);
  });
};
let pA;
const u_e = () => pA ? xG : performance.interactionCount || 0, d_e = () => {
  "interactionCount" in performance || pA || (pA = bp("event", l_e, {
    type: "event",
    buffered: !0,
    durationThreshold: 0
  }));
}, EG = () => u_e(), N4 = 10, Bc = [], h5 = {}, D4 = (e) => {
  const t = Bc[Bc.length - 1], n = h5[e.interactionId];
  if (n || Bc.length < N4 || e.duration > t.latency) {
    if (n)
      n.entries.push(e), n.latency = Math.max(n.latency, e.duration);
    else {
      const r = {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        id: e.interactionId,
        latency: e.duration,
        entries: [e]
      };
      h5[r.id] = r, Bc.push(r);
    }
    Bc.sort((r, i) => i.latency - r.latency), Bc.splice(N4).forEach((r) => {
      delete h5[r.id];
    });
  }
}, f_e = () => {
  const e = Math.min(
    Bc.length - 1,
    Math.floor(EG() / 50)
  );
  return Bc[e];
}, h_e = (e, t) => {
  t = t || {}, d_e();
  const n = ey("INP");
  let r;
  const i = (a) => {
    a.forEach((c) => {
      c.interactionId && D4(c), c.entryType === "first-input" && !Bc.some((u) => u.entries.some((d) => c.duration === d.duration && c.startTime === d.startTime)) && D4(c);
    });
    const s = f_e();
    s && s.latency !== n.value && (n.value = s.latency, n.entries = s.entries, r());
  }, o = bp("event", i, {
    // Event Timing entries have their durations rounded to the nearest 8ms,
    // so a duration of 40ms would be any event that spans 2.5 or more frames
    // at 60Hz. This threshold is chosen to strike a balance between usefulness
    // and performance. Running this callback for any interaction that spans
    // just one or two frames is likely not worth the insight that could be
    // gained.
    durationThreshold: t.durationThreshold || 40
  });
  r = Zv(e, n, t.reportAllChanges), o && (o.observe({ type: "first-input", buffered: !0 }), ty(() => {
    i(o.takeRecords()), n.value < 0 && EG() > 0 && (n.value = 0, n.entries = []), r(!0);
  }));
}, L4 = {}, g_e = (e) => {
  const t = NP(), n = ey("LCP");
  let r;
  const i = (a) => {
    const s = a[a.length - 1];
    if (s) {
      const c = Math.max(s.startTime - kP(), 0);
      c < t.firstHiddenTime && (n.value = c, n.entries = [s], r());
    }
  }, o = bp("largest-contentful-paint", i);
  if (o) {
    r = Zv(e, n);
    const a = () => {
      L4[n.id] || (i(o.takeRecords()), o.disconnect(), L4[n.id] = !0, r(!0));
    };
    return ["keydown", "click"].forEach((s) => {
      sn.document && addEventListener(s, a, { once: !0, capture: !0 });
    }), ty(a, !0), a;
  }
}, mA = (e) => {
  sn.document && (sn.document.prerendering ? addEventListener("prerenderingchange", () => mA(e), !0) : sn.document.readyState !== "complete" ? addEventListener("load", () => mA(e), !0) : setTimeout(e, 0));
}, p_e = (e, t) => {
  t = t || {};
  const n = ey("TTFB"), r = Zv(e, n, t.reportAllChanges);
  mA(() => {
    const i = Px();
    if (i) {
      if (n.value = Math.max(i.responseStart - kP(), 0), n.value < 0 || n.value > performance.now())
        return;
      n.entries = [i], r(!0);
    }
  });
}, d0 = {}, z_ = {};
let CG, TG, IG, AG, RG;
function m_e(e, t = !1) {
  return ny("cls", e, __e, CG, t);
}
function $G(e, t = !1) {
  return ny("lcp", e, w_e, IG, t);
}
function v_e(e) {
  return ny("ttfb", e, x_e, AG);
}
function y_e(e) {
  return ny("fid", e, S_e, TG);
}
function b_e(e) {
  return ny("inp", e, E_e, RG);
}
function bg(e, t) {
  return OG(e, t), z_[e] || (C_e(e), z_[e] = !0), PG(e, t);
}
function _p(e, t) {
  const n = d0[e];
  if (!(!n || !n.length))
    for (const r of n)
      try {
        r(t);
      } catch (i) {
        dr && xe.error(
          `Error while triggering instrumentation handler.
Type: ${e}
Name: ${ll(r)}
Error:`,
          i
        );
      }
}
function __e() {
  return o_e(
    (e) => {
      _p("cls", {
        metric: e
      }), CG = e;
    },
    { reportAllChanges: !0 }
  );
}
function S_e() {
  return c_e((e) => {
    _p("fid", {
      metric: e
    }), TG = e;
  });
}
function w_e() {
  return g_e((e) => {
    _p("lcp", {
      metric: e
    }), IG = e;
  });
}
function x_e() {
  return p_e((e) => {
    _p("ttfb", {
      metric: e
    }), AG = e;
  });
}
function E_e() {
  return h_e((e) => {
    _p("inp", {
      metric: e
    }), RG = e;
  });
}
function ny(e, t, n, r, i = !1) {
  OG(e, t);
  let o;
  return z_[e] || (o = n(), z_[e] = !0), r && t({ metric: r }), PG(e, t, i ? o : void 0);
}
function C_e(e) {
  const t = {};
  e === "event" && (t.durationThreshold = 0), bp(
    e,
    (n) => {
      _p(e, { entries: n });
    },
    t
  );
}
function OG(e, t) {
  d0[e] = d0[e] || [], d0[e].push(t);
}
function PG(e, t, n) {
  return () => {
    n && n();
    const r = d0[e];
    if (!r)
      return;
    const i = r.indexOf(t);
    i !== -1 && r.splice(i, 1);
  };
}
function g5(e) {
  return typeof e == "number" && isFinite(e);
}
function _g(e, { startTimestamp: t, ...n }) {
  return t && e.startTimestamp > t && (e.startTimestamp = t), e.startChild({
    startTimestamp: t,
    ...n
  });
}
const T_e = 2147483647;
function _i(e) {
  return e / 1e3;
}
function DP() {
  return sn && sn.addEventListener && sn.performance;
}
let j4 = 0, Ur = {}, Fs, f0;
function I_e() {
  const e = DP();
  if (e && ba) {
    e.mark && sn.performance.mark("sentry-tracing-init");
    const t = M_e(), n = O_e(), r = P_e(), i = k_e();
    return () => {
      t(), n(), r(), i();
    };
  }
  return () => {
  };
}
function A_e() {
  bg("longtask", ({ entries: e }) => {
    for (const t of e) {
      const n = of();
      if (!n)
        return;
      const r = _i(ba + t.startTime), i = _i(t.duration);
      n.startChild({
        description: "Main UI thread blocked",
        op: "ui.long-task",
        origin: "auto.ui.browser.metrics",
        startTimestamp: r,
        endTimestamp: r + i
      });
    }
  });
}
function R_e() {
  bg("event", ({ entries: e }) => {
    for (const t of e) {
      const n = of();
      if (!n)
        return;
      if (t.name === "click") {
        const r = _i(ba + t.startTime), i = _i(t.duration), o = {
          description: xu(t.target),
          op: `ui.interaction.${t.name}`,
          origin: "auto.ui.browser.metrics",
          startTimestamp: r,
          endTimestamp: r + i
        }, a = Oq(t.target);
        a && (o.attributes = { "ui.component_name": a }), n.startChild(o);
      }
    }
  });
}
function $_e(e, t) {
  if (DP() && ba) {
    const r = N_e(e, t);
    return () => {
      r();
    };
  }
  return () => {
  };
}
function O_e() {
  return m_e(({ metric: e }) => {
    const t = e.entries[e.entries.length - 1];
    t && (dr && xe.log("[Measurements] Adding CLS"), Ur.cls = { value: e.value, unit: "" }, f0 = t);
  }, !0);
}
function P_e() {
  return $G(({ metric: e }) => {
    const t = e.entries[e.entries.length - 1];
    t && (dr && xe.log("[Measurements] Adding LCP"), Ur.lcp = { value: e.value, unit: "millisecond" }, Fs = t);
  }, !0);
}
function M_e() {
  return y_e(({ metric: e }) => {
    const t = e.entries[e.entries.length - 1];
    if (!t)
      return;
    const n = _i(ba), r = _i(t.startTime);
    dr && xe.log("[Measurements] Adding FID"), Ur.fid = { value: e.value, unit: "millisecond" }, Ur["mark.fid"] = { value: n + r, unit: "second" };
  });
}
function k_e() {
  return v_e(({ metric: e }) => {
    e.entries[e.entries.length - 1] && (dr && xe.log("[Measurements] Adding TTFB"), Ur.ttfb = { value: e.value, unit: "millisecond" });
  });
}
const F4 = {
  click: "click",
  pointerdown: "click",
  pointerup: "click",
  mousedown: "click",
  mouseup: "click",
  touchstart: "click",
  touchend: "click",
  mouseover: "hover",
  mouseout: "hover",
  mouseenter: "hover",
  mouseleave: "hover",
  pointerover: "hover",
  pointerout: "hover",
  pointerenter: "hover",
  pointerleave: "hover",
  dragstart: "drag",
  dragend: "drag",
  drag: "drag",
  dragenter: "drag",
  dragleave: "drag",
  dragover: "drag",
  drop: "drag",
  keydown: "press",
  keyup: "press",
  keypress: "press",
  input: "press"
};
function N_e(e, t) {
  return b_e(({ metric: n }) => {
    if (n.value === void 0)
      return;
    const r = n.entries.find(
      (S) => S.duration === n.value && F4[S.name] !== void 0
    ), i = Yn();
    if (!r || !i)
      return;
    const o = F4[r.name], a = i.getOptions(), s = _i(ba + r.startTime), c = _i(n.value), l = r.interactionId !== void 0 ? e[r.interactionId] : void 0;
    if (l === void 0)
      return;
    const { routeName: u, parentContext: d, activeTransaction: f, user: h, replayId: p } = l, g = h !== void 0 ? h.email || h.id || h.ip_address : void 0, m = f !== void 0 ? f.getProfileId() : void 0, v = new Ox({
      startTimestamp: s,
      endTimestamp: s + c,
      op: `ui.interaction.${o}`,
      name: xu(r.target),
      attributes: {
        release: a.release,
        environment: a.environment,
        transaction: u,
        ...g !== void 0 && g !== "" ? { user: g } : {},
        ...m !== void 0 ? { profile_id: m } : {},
        ...p !== void 0 ? { replay_id: p } : {}
      },
      exclusiveTime: n.value,
      measurements: {
        inp: { value: n.value, unit: "millisecond" }
      }
    }), y = U_e(d, a, t);
    if (y && Math.random() < y) {
      const S = v ? L1e([v], i.getDsn()) : void 0, _ = i && i.getTransport();
      _ && S && _.send(S).then(null, (w) => {
        dr && xe.error("Error while sending interaction:", w);
      });
      return;
    }
  });
}
function D_e(e) {
  const t = DP();
  if (!t || !sn.performance.getEntries || !ba)
    return;
  dr && xe.log("[Tracing] Adding & adjusting spans using Performance API");
  const n = _i(ba), r = t.getEntries(), { op: i, start_timestamp: o } = Ui(e);
  if (r.slice(j4).forEach((a) => {
    const s = _i(a.startTime), c = _i(a.duration);
    if (!(e.op === "navigation" && o && n + s < o))
      switch (a.entryType) {
        case "navigation": {
          j_e(e, a, n);
          break;
        }
        case "mark":
        case "paint":
        case "measure": {
          L_e(e, a, s, c, n);
          const l = NP(), u = a.startTime < l.firstHiddenTime;
          a.name === "first-paint" && u && (dr && xe.log("[Measurements] Adding FP"), Ur.fp = { value: a.startTime, unit: "millisecond" }), a.name === "first-contentful-paint" && u && (dr && xe.log("[Measurements] Adding FCP"), Ur.fcp = { value: a.startTime, unit: "millisecond" });
          break;
        }
        case "resource": {
          V_e(e, a, a.name, s, c, n);
          break;
        }
      }
  }), j4 = Math.max(r.length - 1, 0), B_e(e), i === "pageload") {
    H_e(Ur), ["fcp", "fp", "lcp"].forEach((s) => {
      if (!Ur[s] || !o || n >= o)
        return;
      const c = Ur[s].value, l = n + _i(c), u = Math.abs((l - o) * 1e3), d = u - c;
      dr && xe.log(`[Measurements] Normalized ${s} from ${c} to ${u} (${d})`), Ur[s].value = u;
    });
    const a = Ur["mark.fid"];
    a && Ur.fid && (_g(e, {
      description: "first input delay",
      endTimestamp: a.value + _i(Ur.fid.value),
      op: "ui.action",
      origin: "auto.ui.browser.metrics",
      startTimestamp: a.value
    }), delete Ur["mark.fid"]), "fcp" in Ur || delete Ur.cls, Object.keys(Ur).forEach((s) => {
      h1e(s, Ur[s].value, Ur[s].unit);
    }), z_e(e);
  }
  Fs = void 0, f0 = void 0, Ur = {};
}
function L_e(e, t, n, r, i) {
  const o = i + n, a = o + r;
  return _g(e, {
    description: t.name,
    endTimestamp: a,
    op: t.entryType,
    origin: "auto.resource.browser.metrics",
    startTimestamp: o
  }), o;
}
function j_e(e, t, n) {
  ["unloadEvent", "redirect", "domContentLoadedEvent", "loadEvent", "connect"].forEach((r) => {
    $b(e, t, r, n);
  }), $b(e, t, "secureConnection", n, "TLS/SSL", "connectEnd"), $b(e, t, "fetch", n, "cache", "domainLookupStart"), $b(e, t, "domainLookup", n, "DNS"), F_e(e, t, n);
}
function $b(e, t, n, r, i, o) {
  const a = o ? t[o] : t[`${n}End`], s = t[`${n}Start`];
  !s || !a || _g(e, {
    op: "browser",
    origin: "auto.browser.browser.metrics",
    description: i || n,
    startTimestamp: r + _i(s),
    endTimestamp: r + _i(a)
  });
}
function F_e(e, t, n) {
  t.responseEnd && (_g(e, {
    op: "browser",
    origin: "auto.browser.browser.metrics",
    description: "request",
    startTimestamp: n + _i(t.requestStart),
    endTimestamp: n + _i(t.responseEnd)
  }), _g(e, {
    op: "browser",
    origin: "auto.browser.browser.metrics",
    description: "response",
    startTimestamp: n + _i(t.responseStart),
    endTimestamp: n + _i(t.responseEnd)
  }));
}
function V_e(e, t, n, r, i, o) {
  if (t.initiatorType === "xmlhttprequest" || t.initiatorType === "fetch")
    return;
  const a = Nd(n), s = {};
  p5(s, t, "transferSize", "http.response_transfer_size"), p5(s, t, "encodedBodySize", "http.response_content_length"), p5(s, t, "decodedBodySize", "http.decoded_response_content_length"), "renderBlockingStatus" in t && (s["resource.render_blocking_status"] = t.renderBlockingStatus), a.protocol && (s["url.scheme"] = a.protocol.split(":").pop()), a.host && (s["server.address"] = a.host), s["url.same_origin"] = n.includes(sn.location.origin);
  const c = o + r, l = c + i;
  _g(e, {
    description: n.replace(sn.location.origin, ""),
    endTimestamp: l,
    op: t.initiatorType ? `resource.${t.initiatorType}` : "resource.other",
    origin: "auto.resource.browser.metrics",
    startTimestamp: c,
    data: s
  });
}
function B_e(e) {
  const t = sn.navigator;
  if (!t)
    return;
  const n = t.connection;
  n && (n.effectiveType && e.setTag("effectiveConnectionType", n.effectiveType), n.type && e.setTag("connectionType", n.type), g5(n.rtt) && (Ur["connection.rtt"] = { value: n.rtt, unit: "millisecond" })), g5(t.deviceMemory) && e.setTag("deviceMemory", `${t.deviceMemory} GB`), g5(t.hardwareConcurrency) && e.setTag("hardwareConcurrency", String(t.hardwareConcurrency));
}
function z_e(e) {
  Fs && (dr && xe.log("[Measurements] Adding LCP Data"), Fs.element && e.setTag("lcp.element", xu(Fs.element)), Fs.id && e.setTag("lcp.id", Fs.id), Fs.url && e.setTag("lcp.url", Fs.url.trim().slice(0, 200)), e.setTag("lcp.size", Fs.size)), f0 && f0.sources && (dr && xe.log("[Measurements] Adding CLS Data"), f0.sources.forEach(
    (t, n) => (
      // TODO: Can we rewrite this to an attribute?
      // eslint-disable-next-line deprecation/deprecation
      e.setTag(`cls.source.${n + 1}`, xu(t.node))
    )
  ));
}
function p5(e, t, n, r) {
  const i = t[n];
  i != null && i < T_e && (e[r] = i);
}
function H_e(e) {
  const t = Px();
  if (!t)
    return;
  const { responseStart: n, requestStart: r } = t;
  r <= n && (dr && xe.log("[Measurements] Adding TTFB Request Time"), e["ttfb.requestTime"] = {
    value: n - r,
    unit: "millisecond"
  });
}
function U_e(e, t, n) {
  if (!yp(t))
    return !1;
  let r;
  return e !== void 0 && typeof t.tracesSampler == "function" ? r = t.tracesSampler({
    transactionContext: e,
    name: e.name,
    parentSampled: e.parentSampled,
    attributes: {
      // eslint-disable-next-line deprecation/deprecation
      ...e.data,
      ...e.attributes
    },
    location: sn.location
  }) : e !== void 0 && e.sampled !== void 0 ? r = e.sampled : typeof t.tracesSampleRate < "u" ? r = t.tracesSampleRate : r = 1, hG(r) ? r === !0 ? n : r === !1 ? 0 : r * n : (dr && xe.warn("[Tracing] Discarding interaction span because of invalid sample rate."), !1);
}
function W_e(e, t, n, r, i = "auto.http.browser") {
  if (!yp() || !e.fetchData)
    return;
  const o = t(e.fetchData.url);
  if (e.endTimestamp && o) {
    const h = e.fetchData.__span;
    if (!h)
      return;
    const p = r[h];
    p && (K_e(p, e), delete r[h]);
    return;
  }
  const a = xa(), s = Yn(), { method: c, url: l } = e.fetchData, u = G_e(l), d = u ? Nd(u).host : void 0, f = o ? sG({
    name: `${c} ${l}`,
    onlyIfParent: !0,
    attributes: {
      url: l,
      type: "fetch",
      "http.method": c,
      "http.url": u,
      "server.address": d,
      [Rh]: i
    },
    op: "http.client"
  }) : void 0;
  if (f && (e.fetchData.__span = f.spanContext().spanId, r[f.spanContext().spanId] = f), n(e.fetchData.url) && s) {
    const h = e.args[0];
    e.args[1] = e.args[1] || {};
    const p = e.args[1];
    p.headers = q_e(h, s, a, p, f);
  }
  return f;
}
function q_e(e, t, n, r, i) {
  const o = i || n.getSpan(), a = Bu(), { traceId: s, spanId: c, sampled: l, dsc: u } = {
    ...a.getPropagationContext(),
    ...n.getPropagationContext()
  }, d = o ? Ix(o) : AP(s, c, l), f = qq(
    u || (o ? yg(o) : $x(s, t, n))
  ), h = r.headers || (typeof Request < "u" && cl(e, Request) ? e.headers : void 0);
  if (h)
    if (typeof Headers < "u" && cl(h, Headers)) {
      const p = new Headers(h);
      return p.append("sentry-trace", d), f && p.append(uA, f), p;
    } else if (Array.isArray(h)) {
      const p = [...h, ["sentry-trace", d]];
      return f && p.push([uA, f]), p;
    } else {
      const p = "baggage" in h ? h.baggage : void 0, g = [];
      return Array.isArray(p) ? g.push(...p) : p && g.push(p), f && g.push(f), {
        ...h,
        "sentry-trace": d,
        baggage: g.length > 0 ? g.join(",") : void 0
      };
    }
  else
    return { "sentry-trace": d, baggage: f };
}
function G_e(e) {
  try {
    return new URL(e).href;
  } catch {
    return;
  }
}
function K_e(e, t) {
  if (t.response) {
    MP(e, t.response.status);
    const n = t.response && t.response.headers && t.response.headers.get("content-length");
    if (n) {
      const r = parseInt(n);
      r > 0 && e.setAttribute("http.response_content_length", r);
    }
  } else
    t.error && e.setStatus("internal_error");
  e.end();
}
const vA = ["localhost", /^\/(?!\/)/], yA = {
  traceFetch: !0,
  traceXHR: !0,
  enableHTTPTimings: !0,
  // TODO (v8): Remove this property
  tracingOrigins: vA,
  tracePropagationTargets: vA
};
function Y_e(e) {
  const {
    traceFetch: t,
    traceXHR: n,
    // eslint-disable-next-line deprecation/deprecation
    tracePropagationTargets: r,
    // eslint-disable-next-line deprecation/deprecation
    tracingOrigins: i,
    shouldCreateSpanForRequest: o,
    enableHTTPTimings: a
  } = {
    traceFetch: yA.traceFetch,
    traceXHR: yA.traceXHR,
    ...e
  }, s = typeof o == "function" ? o : (u) => !0, c = (u) => Z_e(u, r || i), l = {};
  t && CP((u) => {
    const d = W_e(u, s, c, l);
    if (d) {
      const f = MG(u.fetchData.url), h = f ? Nd(f).host : void 0;
      d.setAttributes({
        "http.url": f,
        "server.address": h
      });
    }
    a && d && V4(d);
  }), n && TP((u) => {
    const d = eSe(u, s, c, l);
    a && d && V4(d);
  });
}
function X_e(e) {
  return e.entryType === "resource" && "initiatorType" in e && typeof e.nextHopProtocol == "string" && (e.initiatorType === "fetch" || e.initiatorType === "xmlhttprequest");
}
function V4(e) {
  const { url: t } = Ui(e).data || {};
  if (!t || typeof t != "string")
    return;
  const n = bg("resource", ({ entries: r }) => {
    r.forEach((i) => {
      X_e(i) && i.name.endsWith(t) && (J_e(i).forEach((a) => e.setAttribute(...a)), setTimeout(n));
    });
  });
}
function Q_e(e) {
  let t = "unknown", n = "unknown", r = "";
  for (const i of e) {
    if (i === "/") {
      [t, n] = e.split("/");
      break;
    }
    if (!isNaN(Number(i))) {
      t = r === "h" ? "http" : r, n = e.split(r)[1];
      break;
    }
    r += i;
  }
  return r === e && (t = r), { name: t, version: n };
}
function Ns(e = 0) {
  return ((ba || performance.timeOrigin) + e) / 1e3;
}
function J_e(e) {
  const { name: t, version: n } = Q_e(e.nextHopProtocol), r = [];
  return r.push(["network.protocol.version", n], ["network.protocol.name", t]), ba ? [
    ...r,
    ["http.request.redirect_start", Ns(e.redirectStart)],
    ["http.request.fetch_start", Ns(e.fetchStart)],
    ["http.request.domain_lookup_start", Ns(e.domainLookupStart)],
    ["http.request.domain_lookup_end", Ns(e.domainLookupEnd)],
    ["http.request.connect_start", Ns(e.connectStart)],
    ["http.request.secure_connection_start", Ns(e.secureConnectionStart)],
    ["http.request.connection_end", Ns(e.connectEnd)],
    ["http.request.request_start", Ns(e.requestStart)],
    ["http.request.response_start", Ns(e.responseStart)],
    ["http.request.response_end", Ns(e.responseEnd)]
  ] : r;
}
function Z_e(e, t) {
  return pp(e, t || vA);
}
function eSe(e, t, n, r) {
  const i = e.xhr, o = i && i[Gl];
  if (!yp() || !i || i.__sentry_own_request__ || !o)
    return;
  const a = t(o.url);
  if (e.endTimestamp && a) {
    const h = i.__sentry_xhr_span_id__;
    if (!h)
      return;
    const p = r[h];
    p && o.status_code !== void 0 && (MP(p, o.status_code), p.end(), delete r[h]);
    return;
  }
  const s = xa(), c = Bu(), l = MG(o.url), u = l ? Nd(l).host : void 0, d = a ? sG({
    name: `${o.method} ${o.url}`,
    onlyIfParent: !0,
    attributes: {
      type: "xhr",
      "http.method": o.method,
      "http.url": l,
      url: o.url,
      "server.address": u,
      [Rh]: "auto.http.browser"
    },
    op: "http.client"
  }) : void 0;
  d && (i.__sentry_xhr_span_id__ = d.spanContext().spanId, r[i.__sentry_xhr_span_id__] = d);
  const f = Yn();
  if (i.setRequestHeader && n(o.url) && f) {
    const { traceId: h, spanId: p, sampled: g, dsc: m } = {
      ...c.getPropagationContext(),
      ...s.getPropagationContext()
    }, v = d ? Ix(d) : AP(h, p, g), y = qq(
      m || (d ? yg(d) : $x(h, f, s))
    );
    tSe(i, v, y);
  }
  return d;
}
function tSe(e, t, n) {
  try {
    e.setRequestHeader("sentry-trace", t), n && e.setRequestHeader(uA, n);
  } catch {
  }
}
function MG(e) {
  try {
    return new URL(e, sn.location.origin).href;
  } catch {
    return;
  }
}
function nSe(e, t = !0, n = !0) {
  if (!sn || !sn.location) {
    dr && xe.warn("Could not initialize routing instrumentation due to invalid location");
    return;
  }
  let r = sn.location.href, i;
  t && (i = e({
    name: sn.location.pathname,
    // pageload should always start at timeOrigin (and needs to be in s, not ms)
    startTimestamp: ba ? ba / 1e3 : void 0,
    op: "pageload",
    origin: "auto.pageload.browser",
    metadata: { source: "url" }
  })), n && Cx(({ to: o, from: a }) => {
    if (a === void 0 && r && r.indexOf(o) !== -1) {
      r = void 0;
      return;
    }
    a !== o && (r = void 0, i && (dr && xe.log(`[Tracing] Finishing current transaction with op: ${i.op}`), i.end()), i = e({
      name: sn.location.pathname,
      op: "navigation",
      origin: "auto.navigation.browser",
      metadata: { source: "url" }
    }));
  });
}
const rSe = "BrowserTracing", iSe = {
  ...L1,
  markBackgroundTransactions: !0,
  routingInstrumentation: nSe,
  startTransactionOnLocationChange: !0,
  startTransactionOnPageLoad: !0,
  enableLongTask: !0,
  enableInp: !1,
  interactionsSampleRate: 1,
  _experiments: {},
  ...yA
}, B4 = 10;
class oSe {
  // This class currently doesn't have a static `id` field like the other integration classes, because it prevented
  // @sentry/tracing from being treeshaken. Tree shakers do not like static fields, because they behave like side effects.
  // TODO: Come up with a better plan, than using static fields on integration classes, and use that plan on all
  // integrations.
  /** Browser Tracing integration options */
  /**
   * @inheritDoc
   */
  // eslint-disable-next-line deprecation/deprecation
  constructor(t) {
    this.name = rSe, this._hasSetTracePropagationTargets = !1, f1e(), dr && (this._hasSetTracePropagationTargets = !!(t && // eslint-disable-next-line deprecation/deprecation
    (t.tracePropagationTargets || t.tracingOrigins))), this.options = {
      ...iSe,
      ...t
    }, this.options._experiments.enableLongTask !== void 0 && (this.options.enableLongTask = this.options._experiments.enableLongTask), t && !t.tracePropagationTargets && t.tracingOrigins && (this.options.tracePropagationTargets = t.tracingOrigins), this._collectWebVitals = I_e(), this._interactionIdToRouteNameMapping = {}, this.options.enableInp && $_e(this._interactionIdToRouteNameMapping, this.options.interactionsSampleRate), this.options.enableLongTask && A_e(), this.options._experiments.enableInteractions && R_e(), this._latestRoute = {
      name: void 0,
      context: void 0
    };
  }
  /**
   * @inheritDoc
   */
  // eslint-disable-next-line deprecation/deprecation
  setupOnce(t, n) {
    this._getCurrentHub = n;
    const i = n().getClient(), o = i && i.getOptions(), {
      routingInstrumentation: a,
      startTransactionOnLocationChange: s,
      startTransactionOnPageLoad: c,
      markBackgroundTransactions: l,
      traceFetch: u,
      traceXHR: d,
      shouldCreateSpanForRequest: f,
      enableHTTPTimings: h,
      _experiments: p
    } = this.options, g = o && o.tracePropagationTargets, m = g || this.options.tracePropagationTargets;
    dr && this._hasSetTracePropagationTargets && g && xe.warn(
      "[Tracing] The `tracePropagationTargets` option was set in the BrowserTracing integration and top level `Sentry.init`. The top level `Sentry.init` value is being used."
    ), a(
      (v) => {
        const y = this._createRouteTransaction(v);
        return this.options._experiments.onStartRouteTransaction && this.options._experiments.onStartRouteTransaction(y, v, n), y;
      },
      c,
      s
    ), l && n_e(), p.enableInteractions && this._registerInteractionListener(), this.options.enableInp && this._registerInpInteractionListener(), Y_e({
      traceFetch: u,
      traceXHR: d,
      tracePropagationTargets: m,
      shouldCreateSpanForRequest: f,
      enableHTTPTimings: h
    });
  }
  /** Create routing idle transaction. */
  _createRouteTransaction(t) {
    if (!this._getCurrentHub) {
      dr && xe.warn(`[Tracing] Did not create ${t.op} transaction because _getCurrentHub is invalid.`);
      return;
    }
    const n = this._getCurrentHub(), { beforeNavigate: r, idleTimeout: i, finalTimeout: o, heartbeatInterval: a } = this.options, s = t.op === "pageload";
    let c;
    if (s) {
      const h = s ? z4("sentry-trace") : "", p = s ? z4("baggage") : void 0, { traceId: g, dsc: m, parentSpanId: v, sampled: y } = mbe(h, p);
      c = {
        traceId: g,
        parentSpanId: v,
        parentSampled: y,
        ...t,
        metadata: {
          // eslint-disable-next-line deprecation/deprecation
          ...t.metadata,
          dynamicSamplingContext: m
        },
        trimEnd: !0
      };
    } else
      c = {
        trimEnd: !0,
        ...t
      };
    const l = typeof r == "function" ? r(c) : c, u = l === void 0 ? { ...c, sampled: !1 } : l;
    u.metadata = u.name !== c.name ? (
      // eslint-disable-next-line deprecation/deprecation
      { ...u.metadata, source: "custom" }
    ) : (
      // eslint-disable-next-line deprecation/deprecation
      u.metadata
    ), this._latestRoute.name = u.name, this._latestRoute.context = u, u.sampled === !1 && dr && xe.log(`[Tracing] Will not send ${u.op} transaction because of beforeNavigate.`), dr && xe.log(`[Tracing] Starting ${u.op} transaction on scope`);
    const { location: d } = sn, f = I4(
      n,
      u,
      i,
      o,
      !0,
      { location: d },
      // for use in the tracesSampler
      a,
      s
      // should wait for finish signal if it's a pageload transaction
    );
    return s && sn.document && (sn.document.addEventListener("readystatechange", () => {
      ["interactive", "complete"].includes(sn.document.readyState) && f.sendAutoFinishSignal();
    }), ["interactive", "complete"].includes(sn.document.readyState) && f.sendAutoFinishSignal()), f.registerBeforeFinishCallback((h) => {
      this._collectWebVitals(), D_e(h);
    }), f;
  }
  /** Start listener for interaction transactions */
  _registerInteractionListener() {
    let t;
    const n = () => {
      const { idleTimeout: r, finalTimeout: i, heartbeatInterval: o } = this.options, a = "ui.action.click", s = of();
      if (s && s.op && ["navigation", "pageload"].includes(s.op)) {
        dr && xe.warn(
          `[Tracing] Did not create ${a} transaction because a pageload or navigation transaction is in progress.`
        );
        return;
      }
      if (t && (t.setFinishReason("interactionInterrupted"), t.end(), t = void 0), !this._getCurrentHub) {
        dr && xe.warn(`[Tracing] Did not create ${a} transaction because _getCurrentHub is invalid.`);
        return;
      }
      if (!this._latestRoute.name) {
        dr && xe.warn(`[Tracing] Did not create ${a} transaction because _latestRouteName is missing.`);
        return;
      }
      const c = this._getCurrentHub(), { location: l } = sn, u = {
        name: this._latestRoute.name,
        op: a,
        trimEnd: !0,
        data: {
          [Dd]: this._latestRoute.context ? aSe(this._latestRoute.context) : "url"
        }
      };
      t = I4(
        c,
        u,
        r,
        i,
        !0,
        { location: l },
        // for use in the tracesSampler
        o
      );
    };
    ["click"].forEach((r) => {
      sn.document && addEventListener(r, n, { once: !1, capture: !0 });
    });
  }
  /** Creates a listener on interaction entries, and maps interactionIds to the origin path of the interaction */
  _registerInpInteractionListener() {
    const t = ({ entries: n }) => {
      const r = Yn(), i = r !== void 0 && r.getIntegrationByName !== void 0 ? r.getIntegrationByName("Replay") : void 0, o = i !== void 0 ? i.getReplayId() : void 0, a = of(), s = xa(), c = s !== void 0 ? s.getUser() : void 0;
      n.forEach((l) => {
        if (sSe(l)) {
          const u = l.interactionId;
          if (u === void 0)
            return;
          const d = this._interactionIdToRouteNameMapping[u], f = l.duration, h = l.startTime, p = Object.keys(this._interactionIdToRouteNameMapping), g = p.length > 0 ? p.reduce((m, v) => this._interactionIdToRouteNameMapping[m].duration < this._interactionIdToRouteNameMapping[v].duration ? m : v) : void 0;
          if (l.entryType === "first-input" && p.map((v) => this._interactionIdToRouteNameMapping[v]).some((v) => v.duration === f && v.startTime === h) || !u)
            return;
          if (d)
            d.duration = Math.max(d.duration, f);
          else if (p.length < B4 || g === void 0 || f > this._interactionIdToRouteNameMapping[g].duration) {
            const m = this._latestRoute.name, v = this._latestRoute.context;
            m && v && (g && Object.keys(this._interactionIdToRouteNameMapping).length >= B4 && delete this._interactionIdToRouteNameMapping[g], this._interactionIdToRouteNameMapping[u] = {
              routeName: m,
              duration: f,
              parentContext: v,
              user: c,
              activeTransaction: a,
              replayId: o,
              startTime: h
            });
          }
        }
      });
    };
    bg("event", t), bg("first-input", t);
  }
}
function z4(e) {
  const t = Sye(`meta[name=${e}]`);
  return t ? t.getAttribute("content") : void 0;
}
function aSe(e) {
  const t = e.attributes && e.attributes[Dd], n = e.data && e.data[Dd], r = e.metadata && e.metadata.source;
  return t || n || r;
}
function sSe(e) {
  return "duration" in e;
}
const er = An;
let bA = 0;
function kG() {
  return bA > 0;
}
function cSe() {
  bA++, setTimeout(() => {
    bA--;
  });
}
function Sg(e, t = {}, n) {
  if (typeof e != "function")
    return e;
  try {
    const i = e.__sentry_wrapped__;
    if (i)
      return typeof i == "function" ? i : e;
    if (EP(e))
      return e;
  } catch {
    return e;
  }
  const r = function() {
    const i = Array.prototype.slice.call(arguments);
    try {
      n && typeof n == "function" && n.apply(this, arguments);
      const o = i.map((a) => Sg(a, t));
      return e.apply(this, o);
    } catch (o) {
      throw cSe(), zbe((a) => {
        a.addEventProcessor((s) => (t.mechanism && (rA(s, void 0, void 0), q0(s, t.mechanism)), s.extra = {
          ...s.extra,
          arguments: i
        }, s)), Rx(o);
      }), o;
    }
  };
  try {
    for (const i in e)
      Object.prototype.hasOwnProperty.call(e, i) && (r[i] = e[i]);
  } catch {
  }
  Mq(r, e), nf(e, "__sentry_wrapped__", r);
  try {
    Object.getOwnPropertyDescriptor(r, "name").configurable && Object.defineProperty(r, "name", {
      get() {
        return e.name;
      }
    });
  } catch {
  }
  return r;
}
const Uc = typeof __SENTRY_DEBUG__ > "u" || __SENTRY_DEBUG__;
function NG(e, t) {
  const n = LP(e, t), r = {
    type: t && t.name,
    value: fSe(t)
  };
  return n.length && (r.stacktrace = { frames: n }), r.type === void 0 && r.value === "" && (r.value = "Unrecoverable error caught"), r;
}
function lSe(e, t, n, r) {
  const i = Yn(), o = i && i.getOptions().normalizeDepth, a = {
    exception: {
      values: [
        {
          type: xx(t) ? t.constructor.name : r ? "UnhandledRejection" : "Error",
          value: pSe(t, { isUnhandledRejection: r })
        }
      ]
    },
    extra: {
      __serialized__: Hq(t, o)
    }
  };
  if (n) {
    const s = LP(e, n);
    s.length && (a.exception.values[0].stacktrace = { frames: s });
  }
  return a;
}
function m5(e, t) {
  return {
    exception: {
      values: [NG(e, t)]
    }
  };
}
function LP(e, t) {
  const n = t.stacktrace || t.stack || "", r = dSe(t);
  try {
    return e(n, r);
  } catch {
  }
  return [];
}
const uSe = /Minified React error #\d+;/i;
function dSe(e) {
  if (e) {
    if (typeof e.framesToPop == "number")
      return e.framesToPop;
    if (uSe.test(e.message))
      return 1;
  }
  return 0;
}
function fSe(e) {
  const t = e && e.message;
  return t ? t.error && typeof t.error.message == "string" ? t.error.message : t : "No error message";
}
function hSe(e, t, n, r) {
  const i = n && n.syntheticException || void 0, o = jP(e, t, i, r);
  return q0(o), o.level = "error", n && n.event_id && (o.event_id = n.event_id), vg(o);
}
function gSe(e, t, n = "info", r, i) {
  const o = r && r.syntheticException || void 0, a = _A(e, t, o, i);
  return a.level = n, r && r.event_id && (a.event_id = r.event_id), vg(a);
}
function jP(e, t, n, r, i) {
  let o;
  if (_P(t) && t.error)
    return m5(e, t.error);
  if (t4(t) || dye(t)) {
    const a = t;
    if ("stack" in t)
      o = m5(e, t);
    else {
      const s = a.name || (t4(a) ? "DOMError" : "DOMException"), c = a.message ? `${s}: ${a.message}` : s;
      o = _A(e, c, n, r), rA(o, c);
    }
    return "code" in a && (o.tags = { ...o.tags, "DOMException.code": `${a.code}` }), o;
  }
  return Iq(t) ? m5(e, t) : mg(t) || xx(t) ? (o = lSe(e, t, n, i), q0(o, {
    synthetic: !0
  }), o) : (o = _A(e, t, n, r), rA(o, `${t}`, void 0), q0(o, {
    synthetic: !0
  }), o);
}
function _A(e, t, n, r) {
  const i = {};
  if (r && n) {
    const o = LP(e, n);
    o.length && (i.exception = {
      values: [{ value: t, stacktrace: { frames: o } }]
    });
  }
  if (SP(t)) {
    const { __sentry_template_string__: o, __sentry_template_values__: a } = t;
    return i.logentry = {
      message: o,
      params: a
    }, i;
  }
  return i.message = t, i;
}
function pSe(e, { isUnhandledRejection: t }) {
  const n = $ye(e), r = t ? "promise rejection" : "exception";
  return _P(e) ? `Event \`ErrorEvent\` captured as ${r} with message \`${e.message}\`` : xx(e) ? `Event \`${mSe(e)}\` (type=${e.type}) captured as ${r}` : `Object captured as ${r} with keys: ${n}`;
}
function mSe(e) {
  try {
    const t = Object.getPrototypeOf(e);
    return t ? t.constructor.name : void 0;
  } catch {
  }
}
function vSe(e, {
  metadata: t,
  tunnel: n,
  dsn: r
}) {
  const i = {
    event_id: e.event_id,
    sent_at: (/* @__PURE__ */ new Date()).toISOString(),
    ...t && t.sdk && {
      sdk: {
        name: t.sdk.name,
        version: t.sdk.version
      }
    },
    ...!!n && !!r && { dsn: vp(r) }
  }, o = ySe(e);
  return Vu(i, [o]);
}
function ySe(e) {
  return [{
    type: "user_report"
  }, e];
}
class bSe extends R1e {
  /**
   * Creates a new Browser SDK instance.
   *
   * @param options Configuration options for this SDK.
   */
  constructor(t) {
    const n = er.SENTRY_SDK_SOURCE || Jye();
    yG(t, "browser", ["browser"], n), super(t), t.sendClientReports && er.document && er.document.addEventListener("visibilitychange", () => {
      er.document.visibilityState === "hidden" && this._flushOutcomes();
    });
  }
  /**
   * @inheritDoc
   */
  eventFromException(t, n) {
    return hSe(this._options.stackParser, t, n, this._options.attachStacktrace);
  }
  /**
   * @inheritDoc
   */
  eventFromMessage(t, n = "info", r) {
    return gSe(this._options.stackParser, t, n, r, this._options.attachStacktrace);
  }
  /**
   * Sends user feedback to Sentry.
   */
  captureUserFeedback(t) {
    if (!this._isEnabled()) {
      Uc && xe.warn("SDK not enabled, will not capture user feedback.");
      return;
    }
    const n = vSe(t, {
      metadata: this.getSdkMetadata(),
      dsn: this.getDsn(),
      tunnel: this.getOptions().tunnel
    });
    this._sendEnvelope(n);
  }
  /**
   * @inheritDoc
   */
  _prepareEvent(t, n, r) {
    return t.platform = t.platform || "javascript", super._prepareEvent(t, n, r);
  }
  /**
   * Sends client reports as an envelope.
   */
  _flushOutcomes() {
    const t = this._clearOutcomes();
    if (t.length === 0) {
      Uc && xe.log("No outcomes to send");
      return;
    }
    if (!this._dsn) {
      Uc && xe.log("No dsn provided, will not send outcomes");
      return;
    }
    Uc && xe.log("Sending outcomes:", t);
    const n = wbe(t, this._options.tunnel && vp(this._dsn));
    this._sendEnvelope(n);
  }
}
let zm;
function _Se() {
  if (zm)
    return zm;
  if (sA(er.fetch))
    return zm = er.fetch.bind(er);
  const e = er.document;
  let t = er.fetch;
  if (e && typeof e.createElement == "function")
    try {
      const n = e.createElement("iframe");
      n.hidden = !0, e.head.appendChild(n);
      const r = n.contentWindow;
      r && r.fetch && (t = r.fetch), e.head.removeChild(n);
    } catch (n) {
      Uc && xe.warn("Could not create sandbox iframe for pure fetch check, bailing to window.fetch: ", n);
    }
  return zm = t.bind(er);
}
function SSe() {
  zm = void 0;
}
function wSe(e, t = _Se()) {
  let n = 0, r = 0;
  function i(o) {
    const a = o.body.length;
    n += a, r++;
    const s = {
      body: o.body,
      method: "POST",
      referrerPolicy: "origin",
      headers: e.headers,
      // Outgoing requests are usually cancelled when navigating to a different page, causing a "TypeError: Failed to
      // fetch" error and sending a "network_error" client-outcome - in Chrome, the request status shows "(cancelled)".
      // The `keepalive` flag keeps outgoing requests alive, even when switching pages. We want this since we're
      // frequently sending events right before the user is switching pages (eg. whenfinishing navigation transactions).
      // Gotchas:
      // - `keepalive` isn't supported by Firefox
      // - As per spec (https://fetch.spec.whatwg.org/#http-network-or-cache-fetch):
      //   If the sum of contentLength and inflightKeepaliveBytes is greater than 64 kibibytes, then return a network error.
      //   We will therefore only activate the flag when we're below that limit.
      // There is also a limit of requests that can be open at the same time, so we also limit this to 15
      // See https://github.com/getsentry/sentry-javascript/pull/7553 for details
      keepalive: n <= 6e4 && r < 15,
      ...e.fetchOptions
    };
    try {
      return t(e.url, s).then((c) => (n -= a, r--, {
        statusCode: c.status,
        headers: {
          "x-sentry-rate-limits": c.headers.get("X-Sentry-Rate-Limits"),
          "retry-after": c.headers.get("Retry-After")
        }
      }));
    } catch (c) {
      return SSe(), n -= a, r--, IP(c);
    }
  }
  return vG(e, i);
}
const xSe = 4;
function ESe(e) {
  function t(n) {
    return new fa((r, i) => {
      const o = new XMLHttpRequest();
      o.onerror = i, o.onreadystatechange = () => {
        o.readyState === xSe && r({
          statusCode: o.status,
          headers: {
            "x-sentry-rate-limits": o.getResponseHeader("X-Sentry-Rate-Limits"),
            "retry-after": o.getResponseHeader("Retry-After")
          }
        });
      }, o.open("POST", e.url);
      for (const a in e.headers)
        Object.prototype.hasOwnProperty.call(e.headers, a) && o.setRequestHeader(a, e.headers[a]);
      o.send(n.body);
    });
  }
  return vG(e, t);
}
const Mx = "?", CSe = 30, TSe = 40, ISe = 50;
function FP(e, t, n, r) {
  const i = {
    filename: e,
    function: t,
    in_app: !0
    // All browser frames are considered in_app
  };
  return n !== void 0 && (i.lineno = n), r !== void 0 && (i.colno = r), i;
}
const ASe = /^\s*at (?:(.+?\)(?: \[.+\])?|.*?) ?\((?:address at )?)?(?:async )?((?:<anonymous>|[-a-z]+:|.*bundle|\/)?.*?)(?::(\d+))?(?::(\d+))?\)?\s*$/i, RSe = /\((\S*)(?::(\d+))(?::(\d+))\)/, $Se = (e) => {
  const t = ASe.exec(e);
  if (t) {
    if (t[2] && t[2].indexOf("eval") === 0) {
      const o = RSe.exec(t[2]);
      o && (t[2] = o[1], t[3] = o[2], t[4] = o[3]);
    }
    const [r, i] = DG(t[1] || Mx, t[2]);
    return FP(i, r, t[3] ? +t[3] : void 0, t[4] ? +t[4] : void 0);
  }
}, OSe = [CSe, $Se], PSe = /^\s*(.*?)(?:\((.*?)\))?(?:^|@)?((?:[-a-z]+)?:\/.*?|\[native code\]|[^@]*(?:bundle|\d+\.js)|\/[\w\-. /=]+)(?::(\d+))?(?::(\d+))?\s*$/i, MSe = /(\S+) line (\d+)(?: > eval line \d+)* > eval/i, kSe = (e) => {
  const t = PSe.exec(e);
  if (t) {
    if (t[3] && t[3].indexOf(" > eval") > -1) {
      const o = MSe.exec(t[3]);
      o && (t[1] = t[1] || "eval", t[3] = o[1], t[4] = o[2], t[5] = "");
    }
    let r = t[3], i = t[1] || Mx;
    return [i, r] = DG(i, r), FP(r, i, t[4] ? +t[4] : void 0, t[5] ? +t[5] : void 0);
  }
}, NSe = [ISe, kSe], DSe = /^\s*at (?:((?:\[object object\])?.+) )?\(?((?:[-a-z]+):.*?):(\d+)(?::(\d+))?\)?\s*$/i, LSe = (e) => {
  const t = DSe.exec(e);
  return t ? FP(t[2], t[1] || Mx, +t[3], t[4] ? +t[4] : void 0) : void 0;
}, jSe = [TSe, LSe], FSe = [OSe, NSe, jSe], VSe = Dq(...FSe), DG = (e, t) => {
  const n = e.indexOf("safari-extension") !== -1, r = e.indexOf("safari-web-extension") !== -1;
  return n || r ? [
    e.indexOf("@") !== -1 ? e.split("@")[0] : Mx,
    n ? `safari-extension:${t}` : `safari-web-extension:${t}`
  ] : [e, t];
}, Ob = 1024, LG = "Breadcrumbs", BSe = (e = {}) => {
  const t = {
    console: !0,
    dom: !0,
    fetch: !0,
    history: !0,
    sentry: !0,
    xhr: !0,
    ...e
  };
  return {
    name: LG,
    // TODO v8: Remove this
    setupOnce() {
    },
    // eslint-disable-line @typescript-eslint/no-empty-function
    setup(n) {
      t.console && kye(USe(n)), t.dom && Fq(HSe(n, t.dom)), t.xhr && TP(WSe(n)), t.fetch && CP(qSe(n)), t.history && Cx(GSe(n)), t.sentry && n.on && n.on("beforeSendEvent", zSe(n));
    }
  };
}, jG = BSe;
zu(LG, jG);
function zSe(e) {
  return function(n) {
    Yn() === e && Eu(
      {
        category: `sentry.${n.type === "transaction" ? "transaction" : "event"}`,
        event_id: n.event_id,
        level: n.level,
        message: Ul(n)
      },
      {
        event: n
      }
    );
  };
}
function HSe(e, t) {
  return function(r) {
    if (Yn() !== e)
      return;
    let i, o, a = typeof t == "object" ? t.serializeAttribute : void 0, s = typeof t == "object" && typeof t.maxStringLength == "number" ? t.maxStringLength : void 0;
    s && s > Ob && (Uc && xe.warn(
      `\`dom.maxStringLength\` cannot exceed ${Ob}, but a value of ${s} was configured. Sentry will use ${Ob} instead.`
    ), s = Ob), typeof a == "string" && (a = [a]);
    try {
      const l = r.event, u = KSe(l) ? l.target : l;
      i = xu(u, { keyAttrs: a, maxStringLength: s }), o = Oq(u);
    } catch {
      i = "<unknown>";
    }
    if (i.length === 0)
      return;
    const c = {
      category: `ui.${r.name}`,
      message: i
    };
    o && (c.data = { "ui.component_name": o }), Eu(c, {
      event: r.event,
      name: r.name,
      global: r.global
    });
  };
}
function USe(e) {
  return function(n) {
    if (Yn() !== e)
      return;
    const r = {
      category: "console",
      data: {
        arguments: n.args,
        logger: "console"
      },
      level: cbe(n.level),
      message: n4(n.args, " ")
    };
    if (n.level === "assert")
      if (n.args[0] === !1)
        r.message = `Assertion failed: ${n4(n.args.slice(1), " ") || "console.assert"}`, r.data.arguments = n.args.slice(1);
      else
        return;
    Eu(r, {
      input: n.args,
      level: n.level
    });
  };
}
function WSe(e) {
  return function(n) {
    if (Yn() !== e)
      return;
    const { startTimestamp: r, endTimestamp: i } = n, o = n.xhr[Gl];
    if (!r || !i || !o)
      return;
    const { method: a, url: s, status_code: c, body: l } = o, u = {
      method: a,
      url: s,
      status_code: c
    }, d = {
      xhr: n.xhr,
      input: l,
      startTimestamp: r,
      endTimestamp: i
    };
    Eu(
      {
        category: "xhr",
        data: u,
        type: "http"
      },
      d
    );
  };
}
function qSe(e) {
  return function(n) {
    if (Yn() !== e)
      return;
    const { startTimestamp: r, endTimestamp: i } = n;
    if (i && !(n.fetchData.url.match(/sentry_key/) && n.fetchData.method === "POST"))
      if (n.error) {
        const o = n.fetchData, a = {
          data: n.error,
          input: n.args,
          startTimestamp: r,
          endTimestamp: i
        };
        Eu(
          {
            category: "fetch",
            data: o,
            level: "error",
            type: "http"
          },
          a
        );
      } else {
        const o = n.response, a = {
          ...n.fetchData,
          status_code: o && o.status
        }, s = {
          input: n.args,
          response: o,
          startTimestamp: r,
          endTimestamp: i
        };
        Eu(
          {
            category: "fetch",
            data: a,
            type: "http"
          },
          s
        );
      }
  };
}
function GSe(e) {
  return function(n) {
    if (Yn() !== e)
      return;
    let r = n.from, i = n.to;
    const o = Nd(er.location.href);
    let a = r ? Nd(r) : void 0;
    const s = Nd(i);
    (!a || !a.path) && (a = o), o.protocol === s.protocol && o.host === s.host && (i = s.relative), o.protocol === a.protocol && o.host === a.host && (r = a.relative), Eu({
      category: "navigation",
      data: {
        from: r,
        to: i
      }
    });
  };
}
function KSe(e) {
  return !!e && !!e.target;
}
const FG = "Dedupe", YSe = () => {
  let e;
  return {
    name: FG,
    // TODO v8: Remove this
    setupOnce() {
    },
    // eslint-disable-line @typescript-eslint/no-empty-function
    processEvent(t) {
      if (t.type)
        return t;
      try {
        if (XSe(t, e))
          return Uc && xe.warn("Event dropped due to being a duplicate of previously captured event."), null;
      } catch {
      }
      return e = t;
    }
  };
}, VG = YSe;
zu(FG, VG);
function XSe(e, t) {
  return t ? !!(QSe(e, t) || JSe(e, t)) : !1;
}
function QSe(e, t) {
  const n = e.message, r = t.message;
  return !(!n && !r || n && !r || !n && r || n !== r || !zG(e, t) || !BG(e, t));
}
function JSe(e, t) {
  const n = H4(t), r = H4(e);
  return !(!n || !r || n.type !== r.type || n.value !== r.value || !zG(e, t) || !BG(e, t));
}
function BG(e, t) {
  let n = U4(e), r = U4(t);
  if (!n && !r)
    return !0;
  if (n && !r || !n && r || (n = n, r = r, r.length !== n.length))
    return !1;
  for (let i = 0; i < r.length; i++) {
    const o = r[i], a = n[i];
    if (o.filename !== a.filename || o.lineno !== a.lineno || o.colno !== a.colno || o.function !== a.function)
      return !1;
  }
  return !0;
}
function zG(e, t) {
  let n = e.fingerprint, r = t.fingerprint;
  if (!n && !r)
    return !0;
  if (n && !r || !n && r)
    return !1;
  n = n, r = r;
  try {
    return n.join("") === r.join("");
  } catch {
    return !1;
  }
}
function H4(e) {
  return e.exception && e.exception.values && e.exception.values[0];
}
function U4(e) {
  const t = e.exception;
  if (t)
    try {
      return t.values[0].stacktrace.frames;
    } catch {
      return;
    }
}
const HG = "GlobalHandlers", ZSe = (e = {}) => {
  const t = {
    onerror: !0,
    onunhandledrejection: !0,
    ...e
  };
  return {
    name: HG,
    setupOnce() {
      Error.stackTraceLimit = 50;
    },
    setup(n) {
      t.onerror && (ewe(n), W4("onerror")), t.onunhandledrejection && (twe(n), W4("onunhandledrejection"));
    }
  };
}, UG = ZSe;
zu(
  HG,
  UG
);
function ewe(e) {
  Bq((t) => {
    const { stackParser: n, attachStacktrace: r } = qG();
    if (Yn() !== e || kG())
      return;
    const { msg: i, url: o, line: a, column: s, error: c } = t, l = c === void 0 && sc(i) ? iwe(i, o, a, s) : WG(
      jP(n, c || i, void 0, r, !1),
      o,
      a,
      s
    );
    l.level = "error", eG(l, {
      originalException: c,
      mechanism: {
        handled: !1,
        type: "onerror"
      }
    });
  });
}
function twe(e) {
  zq((t) => {
    const { stackParser: n, attachStacktrace: r } = qG();
    if (Yn() !== e || kG())
      return;
    const i = nwe(t), o = wP(i) ? rwe(i) : jP(n, i, void 0, r, !0);
    o.level = "error", eG(o, {
      originalException: i,
      mechanism: {
        handled: !1,
        type: "onunhandledrejection"
      }
    });
  });
}
function nwe(e) {
  if (wP(e))
    return e;
  const t = e;
  try {
    if ("reason" in t)
      return t.reason;
    if ("detail" in t && "reason" in t.detail)
      return t.detail.reason;
  } catch {
  }
  return e;
}
function rwe(e) {
  return {
    exception: {
      values: [
        {
          type: "UnhandledRejection",
          // String() is needed because the Primitive type includes symbols (which can't be automatically stringified)
          value: `Non-Error promise rejection captured with value: ${String(e)}`
        }
      ]
    }
  };
}
function iwe(e, t, n, r) {
  const i = /^(?:[Uu]ncaught (?:exception: )?)?(?:((?:Eval|Internal|Range|Reference|Syntax|Type|URI|)Error): )?(.*)$/i;
  let o = _P(e) ? e.message : e, a = "Error";
  const s = o.match(i);
  return s && (a = s[1], o = s[2]), WG({
    exception: {
      values: [
        {
          type: a,
          value: o
        }
      ]
    }
  }, t, n, r);
}
function WG(e, t, n, r) {
  const i = e.exception = e.exception || {}, o = i.values = i.values || [], a = o[0] = o[0] || {}, s = a.stacktrace = a.stacktrace || {}, c = s.frames = s.frames || [], l = isNaN(parseInt(r, 10)) ? void 0 : r, u = isNaN(parseInt(n, 10)) ? void 0 : n, d = sc(t) && t.length > 0 ? t : _ye();
  return c.length === 0 && c.push({
    colno: l,
    filename: d,
    function: "?",
    in_app: !0,
    lineno: u
  }), e;
}
function W4(e) {
  Uc && xe.log(`Global Handler attached: ${e}`);
}
function qG() {
  const e = Yn();
  return e && e.getOptions() || {
    stackParser: () => [],
    attachStacktrace: !1
  };
}
const GG = "HttpContext", owe = () => ({
  name: GG,
  // TODO v8: Remove this
  setupOnce() {
  },
  // eslint-disable-line @typescript-eslint/no-empty-function
  preprocessEvent(e) {
    if (!er.navigator && !er.location && !er.document)
      return;
    const t = e.request && e.request.url || er.location && er.location.href, { referrer: n } = er.document || {}, { userAgent: r } = er.navigator || {}, i = {
      ...e.request && e.request.headers,
      ...n && { Referer: n },
      ...r && { "User-Agent": r }
    }, o = { ...e.request, ...t && { url: t }, headers: i };
    e.request = o;
  }
}), KG = owe;
zu(GG, KG);
const awe = "cause", swe = 5, YG = "LinkedErrors", cwe = (e = {}) => {
  const t = e.limit || swe, n = e.key || awe;
  return {
    name: YG,
    // TODO v8: Remove this
    setupOnce() {
    },
    // eslint-disable-line @typescript-eslint/no-empty-function
    preprocessEvent(r, i, o) {
      const a = o.getOptions();
      mye(
        // This differs from the LinkedErrors integration in core by using a different exceptionFromError function
        NG,
        a.stackParser,
        a.maxValueLength,
        n,
        t,
        r,
        i
      );
    }
  };
}, XG = cwe;
zu(YG, XG);
const lwe = [
  "EventTarget",
  "Window",
  "Node",
  "ApplicationCache",
  "AudioTrackList",
  "BroadcastChannel",
  "ChannelMergerNode",
  "CryptoOperation",
  "EventSource",
  "FileReader",
  "HTMLUnknownElement",
  "IDBDatabase",
  "IDBRequest",
  "IDBTransaction",
  "KeyOperation",
  "MediaController",
  "MessagePort",
  "ModalWindow",
  "Notification",
  "SVGElementInstance",
  "Screen",
  "SharedWorker",
  "TextTrack",
  "TextTrackCue",
  "TextTrackList",
  "WebSocket",
  "WebSocketWorker",
  "Worker",
  "XMLHttpRequest",
  "XMLHttpRequestEventTarget",
  "XMLHttpRequestUpload"
], QG = "TryCatch", uwe = (e = {}) => {
  const t = {
    XMLHttpRequest: !0,
    eventTarget: !0,
    requestAnimationFrame: !0,
    setInterval: !0,
    setTimeout: !0,
    ...e
  };
  return {
    name: QG,
    // TODO: This currently only works for the first client this is setup
    // We may want to adjust this to check for client etc.
    setupOnce() {
      t.setTimeout && Oi(er, "setTimeout", q4), t.setInterval && Oi(er, "setInterval", q4), t.requestAnimationFrame && Oi(er, "requestAnimationFrame", dwe), t.XMLHttpRequest && "XMLHttpRequest" in er && Oi(XMLHttpRequest.prototype, "send", fwe);
      const n = t.eventTarget;
      n && (Array.isArray(n) ? n : lwe).forEach(hwe);
    }
  };
}, JG = uwe;
zu(
  QG,
  JG
);
function q4(e) {
  return function(...t) {
    const n = t[0];
    return t[0] = Sg(n, {
      mechanism: {
        data: { function: ll(e) },
        handled: !1,
        type: "instrument"
      }
    }), e.apply(this, t);
  };
}
function dwe(e) {
  return function(t) {
    return e.apply(this, [
      Sg(t, {
        mechanism: {
          data: {
            function: "requestAnimationFrame",
            handler: ll(e)
          },
          handled: !1,
          type: "instrument"
        }
      })
    ]);
  };
}
function fwe(e) {
  return function(...t) {
    const n = this;
    return ["onload", "onerror", "onprogress", "onreadystatechange"].forEach((i) => {
      i in n && typeof n[i] == "function" && Oi(n, i, function(o) {
        const a = {
          mechanism: {
            data: {
              function: i,
              handler: ll(o)
            },
            handled: !1,
            type: "instrument"
          }
        }, s = EP(o);
        return s && (a.mechanism.data.handler = ll(s)), Sg(o, a);
      });
    }), e.apply(this, t);
  };
}
function hwe(e) {
  const t = er, n = t[e] && t[e].prototype;
  !n || !n.hasOwnProperty || !n.hasOwnProperty("addEventListener") || (Oi(n, "addEventListener", function(r) {
    return function(i, o, a) {
      try {
        typeof o.handleEvent == "function" && (o.handleEvent = Sg(o.handleEvent, {
          mechanism: {
            data: {
              function: "handleEvent",
              handler: ll(o),
              target: e
            },
            handled: !1,
            type: "instrument"
          }
        }));
      } catch {
      }
      return r.apply(this, [
        i,
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        Sg(o, {
          mechanism: {
            data: {
              function: "addEventListener",
              handler: ll(o),
              target: e
            },
            handled: !1,
            type: "instrument"
          }
        }),
        a
      ]);
    };
  }), Oi(
    n,
    "removeEventListener",
    function(r) {
      return function(i, o, a) {
        const s = o;
        try {
          const c = s && s.__sentry_wrapped__;
          c && r.call(this, i, c, a);
        } catch {
        }
        return r.call(this, i, s, a);
      };
    }
  ));
}
const gwe = [
  _G(),
  wG(),
  JG(),
  jG(),
  UG(),
  XG(),
  VG(),
  KG()
];
function pwe(e) {
  return [
    // eslint-disable-next-line deprecation/deprecation
    ...gwe
  ];
}
function mwe(e = {}) {
  e.defaultIntegrations === void 0 && (e.defaultIntegrations = pwe()), e.release === void 0 && (typeof __SENTRY_RELEASE__ == "string" && (e.release = __SENTRY_RELEASE__), er.SENTRY_RELEASE && er.SENTRY_RELEASE.id && (e.release = er.SENTRY_RELEASE.id)), e.autoSessionTracking === void 0 && (e.autoSessionTracking = !0), e.sendClientReports === void 0 && (e.sendClientReports = !0);
  const t = {
    ...e,
    stackParser: Pye(e.stackParser || VSe),
    integrations: x1e(e),
    transport: e.transport || (Vq() ? wSe : ESe)
  };
  M1e(bSe, t), e.autoSessionTracking && vwe();
}
function vwe() {
  if (typeof er.document > "u") {
    Uc && xe.warn("Session tracking in non-browser environment with @sentry/browser is not supported.");
    return;
  }
  _4({ ignoreDuration: !0 }), S4(), Cx(({ from: e, to: t }) => {
    e !== void 0 && e !== t && (_4({ ignoreDuration: !0 }), S4());
  });
}
const ur = An, VP = "sentryReplaySession", ywe = "replay_event", BP = "Unable to send Replay", bwe = 3e5, _we = 9e5, Swe = 5e3, wwe = 5500, xwe = 6e4, Ewe = 5e3, Cwe = 3, G4 = 15e4, Pb = 5e3, Twe = 3e3, Iwe = 300, zP = 2e7, Awe = 4999, Rwe = 15e3, K4 = 36e5;
function $we(e, t) {
  return e ?? t();
}
function H_(e) {
  let t, n = e[0], r = 1;
  for (; r < e.length; ) {
    const i = e[r], o = e[r + 1];
    if (r += 2, (i === "optionalAccess" || i === "optionalCall") && n == null)
      return;
    i === "access" || i === "optionalAccess" ? (t = n, n = o(n)) : (i === "call" || i === "optionalCall") && (n = o((...a) => n.call(t, ...a)), t = void 0);
  }
  return n;
}
var yi;
(function(e) {
  e[e.Document = 0] = "Document", e[e.DocumentType = 1] = "DocumentType", e[e.Element = 2] = "Element", e[e.Text = 3] = "Text", e[e.CDATA = 4] = "CDATA", e[e.Comment = 5] = "Comment";
})(yi || (yi = {}));
function Owe(e) {
  return e.nodeType === e.ELEMENT_NODE;
}
function h0(e) {
  const t = H_([e, "optionalAccess", (n) => n.host]);
  return H_([t, "optionalAccess", (n) => n.shadowRoot]) === e;
}
function g0(e) {
  return Object.prototype.toString.call(e) === "[object ShadowRoot]";
}
function Pwe(e) {
  return e.includes(" background-clip: text;") && !e.includes(" -webkit-background-clip: text;") && (e = e.replace(" background-clip: text;", " -webkit-background-clip: text; background-clip: text;")), e;
}
function Mwe(e) {
  const { cssText: t } = e;
  if (t.split('"').length < 3)
    return t;
  const n = ["@import", `url(${JSON.stringify(e.href)})`];
  return e.layerName === "" ? n.push("layer") : e.layerName && n.push(`layer(${e.layerName})`), e.supportsText && n.push(`supports(${e.supportsText})`), e.media.length && n.push(e.media.mediaText), n.join(" ") + ";";
}
function U_(e) {
  try {
    const t = e.rules || e.cssRules;
    return t ? Pwe(Array.from(t, ZG).join("")) : null;
  } catch {
    return null;
  }
}
function ZG(e) {
  let t;
  if (Nwe(e))
    try {
      t = U_(e.styleSheet) || Mwe(e);
    } catch {
    }
  else if (Dwe(e) && e.selectorText.includes(":"))
    return kwe(e.cssText);
  return t || e.cssText;
}
function kwe(e) {
  const t = /(\[(?:[\w-]+)[^\\])(:(?:[\w-]+)\])/gm;
  return e.replace(t, "$1\\$2");
}
function Nwe(e) {
  return "styleSheet" in e;
}
function Dwe(e) {
  return "selectorText" in e;
}
class eK {
  constructor() {
    this.idNodeMap = /* @__PURE__ */ new Map(), this.nodeMetaMap = /* @__PURE__ */ new WeakMap();
  }
  getId(t) {
    if (!t)
      return -1;
    const n = H_([this, "access", (r) => r.getMeta, "call", (r) => r(t), "optionalAccess", (r) => r.id]);
    return $we(n, () => -1);
  }
  getNode(t) {
    return this.idNodeMap.get(t) || null;
  }
  getIds() {
    return Array.from(this.idNodeMap.keys());
  }
  getMeta(t) {
    return this.nodeMetaMap.get(t) || null;
  }
  removeNodeFromMap(t) {
    const n = this.getId(t);
    this.idNodeMap.delete(n), t.childNodes && t.childNodes.forEach((r) => this.removeNodeFromMap(r));
  }
  has(t) {
    return this.idNodeMap.has(t);
  }
  hasNode(t) {
    return this.nodeMetaMap.has(t);
  }
  add(t, n) {
    const r = n.id;
    this.idNodeMap.set(r, t), this.nodeMetaMap.set(t, n);
  }
  replace(t, n) {
    const r = this.getNode(t);
    if (r) {
      const i = this.nodeMetaMap.get(r);
      i && this.nodeMetaMap.set(n, i);
    }
    this.idNodeMap.set(t, n);
  }
  reset() {
    this.idNodeMap = /* @__PURE__ */ new Map(), this.nodeMetaMap = /* @__PURE__ */ new WeakMap();
  }
}
function Lwe() {
  return new eK();
}
function kx({ maskInputOptions: e, tagName: t, type: n }) {
  return t === "OPTION" && (t = "SELECT"), !!(e[t.toLowerCase()] || n && e[n] || n === "password" || t === "INPUT" && !n && e.text);
}
function G0({ isMasked: e, element: t, value: n, maskInputFn: r }) {
  let i = n || "";
  return e ? (r && (i = r(i, t)), "*".repeat(i.length)) : i;
}
function wg(e) {
  return e.toLowerCase();
}
function SA(e) {
  return e.toUpperCase();
}
const Y4 = "__rrweb_original__";
function jwe(e) {
  const t = e.getContext("2d");
  if (!t)
    return !0;
  const n = 50;
  for (let r = 0; r < e.width; r += n)
    for (let i = 0; i < e.height; i += n) {
      const o = t.getImageData, a = Y4 in o ? o[Y4] : o;
      if (new Uint32Array(a.call(t, r, i, Math.min(n, e.width - r), Math.min(n, e.height - i)).data.buffer).some((c) => c !== 0))
        return !1;
    }
  return !0;
}
function HP(e) {
  const t = e.type;
  return e.hasAttribute("data-rr-is-password") ? "password" : t ? wg(t) : null;
}
function W_(e, t, n) {
  return t === "INPUT" && (n === "radio" || n === "checkbox") ? e.getAttribute("value") || "" : e.value;
}
let Fwe = 1;
const Vwe = new RegExp("[^a-z0-9-_:]"), K0 = -2;
function UP() {
  return Fwe++;
}
function Bwe(e) {
  if (e instanceof HTMLFormElement)
    return "form";
  const t = wg(e.tagName);
  return Vwe.test(t) ? "div" : t;
}
function zwe(e) {
  let t = "";
  return e.indexOf("//") > -1 ? t = e.split("/").slice(0, 3).join("/") : t = e.split("/")[0], t = t.split("?")[0], t;
}
let th, X4;
const Hwe = /url\((?:(')([^']*)'|(")(.*?)"|([^)]*))\)/gm, Uwe = /^(?:[a-z+]+:)?\/\//i, Wwe = /^www\..*/i, qwe = /^(data:)([^,]*),(.*)/i;
function q_(e, t) {
  return (e || "").replace(Hwe, (n, r, i, o, a, s) => {
    const c = i || a || s, l = r || o || "";
    if (!c)
      return n;
    if (Uwe.test(c) || Wwe.test(c))
      return `url(${l}${c}${l})`;
    if (qwe.test(c))
      return `url(${l}${c}${l})`;
    if (c[0] === "/")
      return `url(${l}${zwe(t) + c}${l})`;
    const u = t.split("/"), d = c.split("/");
    u.pop();
    for (const f of d)
      f !== "." && (f === ".." ? u.pop() : u.push(f));
    return `url(${l}${u.join("/")}${l})`;
  });
}
const Gwe = /^[^ \t\n\r\u000c]+/, Kwe = /^[, \t\n\r\u000c]+/;
function Ywe(e, t) {
  if (t.trim() === "")
    return t;
  let n = 0;
  function r(o) {
    let a;
    const s = o.exec(t.substring(n));
    return s ? (a = s[0], n += a.length, a) : "";
  }
  const i = [];
  for (; r(Kwe), !(n >= t.length); ) {
    let o = r(Gwe);
    if (o.slice(-1) === ",")
      o = $h(e, o.substring(0, o.length - 1)), i.push(o);
    else {
      let a = "";
      o = $h(e, o);
      let s = !1;
      for (; ; ) {
        const c = t.charAt(n);
        if (c === "") {
          i.push((o + a).trim());
          break;
        } else if (s)
          c === ")" && (s = !1);
        else if (c === ",") {
          n += 1, i.push((o + a).trim());
          break;
        } else
          c === "(" && (s = !0);
        a += c, n += 1;
      }
    }
  }
  return i.join(", ");
}
function $h(e, t) {
  if (!t || t.trim() === "")
    return t;
  const n = e.createElement("a");
  return n.href = t, n.href;
}
function Xwe(e) {
  return !!(e.tagName === "svg" || e.ownerSVGElement);
}
function WP() {
  const e = document.createElement("a");
  return e.href = "", e.href;
}
function tK(e, t, n, r, i, o) {
  return r && (n === "src" || n === "href" && !(t === "use" && r[0] === "#") || n === "xlink:href" && r[0] !== "#" || n === "background" && (t === "table" || t === "td" || t === "th") ? $h(e, r) : n === "srcset" ? Ywe(e, r) : n === "style" ? q_(r, WP()) : t === "object" && n === "data" ? $h(e, r) : typeof o == "function" ? o(n, r, i) : r);
}
function nK(e, t, n) {
  return (e === "video" || e === "audio") && t === "autoplay";
}
function Qwe(e, t, n, r) {
  try {
    if (r && e.matches(r))
      return !1;
    if (typeof t == "string") {
      if (e.classList.contains(t))
        return !0;
    } else
      for (let i = e.classList.length; i--; ) {
        const o = e.classList[i];
        if (t.test(o))
          return !0;
      }
    if (n)
      return e.matches(n);
  } catch {
  }
  return !1;
}
function Jwe(e, t) {
  for (let n = e.classList.length; n--; ) {
    const r = e.classList[n];
    if (t.test(r))
      return !0;
  }
  return !1;
}
function Sd(e, t, n = 1 / 0, r = 0) {
  return !e || e.nodeType !== e.ELEMENT_NODE || r > n ? -1 : t(e) ? r : Sd(e.parentNode, t, n, r + 1);
}
function Oh(e, t) {
  return (n) => {
    const r = n;
    if (r === null)
      return !1;
    try {
      if (e) {
        if (typeof e == "string") {
          if (r.matches(`.${e}`))
            return !0;
        } else if (Jwe(r, e))
          return !0;
      }
      return !!(t && r.matches(t));
    } catch {
      return !1;
    }
  };
}
function xg(e, t, n, r, i, o) {
  try {
    const a = e.nodeType === e.ELEMENT_NODE ? e : e.parentElement;
    if (a === null)
      return !1;
    if (a.tagName === "INPUT") {
      const l = a.getAttribute("autocomplete");
      if ([
        "current-password",
        "new-password",
        "cc-number",
        "cc-exp",
        "cc-exp-month",
        "cc-exp-year",
        "cc-csc"
      ].includes(l))
        return !0;
    }
    let s = -1, c = -1;
    if (o) {
      if (c = Sd(a, Oh(r, i)), c < 0)
        return !0;
      s = Sd(a, Oh(t, n), c >= 0 ? c : 1 / 0);
    } else {
      if (s = Sd(a, Oh(t, n)), s < 0)
        return !1;
      c = Sd(a, Oh(r, i), s >= 0 ? s : 1 / 0);
    }
    return s >= 0 ? c >= 0 ? s <= c : !0 : c >= 0 ? !1 : !!o;
  } catch {
  }
  return !!o;
}
function Zwe(e, t, n) {
  const r = e.contentWindow;
  if (!r)
    return;
  let i = !1, o;
  try {
    o = r.document.readyState;
  } catch {
    return;
  }
  if (o !== "complete") {
    const s = setTimeout(() => {
      i || (t(), i = !0);
    }, n);
    e.addEventListener("load", () => {
      clearTimeout(s), i = !0, t();
    });
    return;
  }
  const a = "about:blank";
  if (r.location.href !== a || e.src === a || e.src === "")
    return setTimeout(t, 0), e.addEventListener("load", t);
  e.addEventListener("load", t);
}
function exe(e, t, n) {
  let r = !1, i;
  try {
    i = e.sheet;
  } catch {
    return;
  }
  if (i)
    return;
  const o = setTimeout(() => {
    r || (t(), r = !0);
  }, n);
  e.addEventListener("load", () => {
    clearTimeout(o), r = !0, t();
  });
}
function txe(e, t) {
  const { doc: n, mirror: r, blockClass: i, blockSelector: o, unblockSelector: a, maskAllText: s, maskAttributeFn: c, maskTextClass: l, unmaskTextClass: u, maskTextSelector: d, unmaskTextSelector: f, inlineStylesheet: h, maskInputOptions: p = {}, maskTextFn: g, maskInputFn: m, dataURLOptions: v = {}, inlineImages: y, recordCanvas: S, keepIframeSrcFn: _, newlyAddedElement: w = !1 } = t, T = nxe(n, r);
  switch (e.nodeType) {
    case e.DOCUMENT_NODE:
      return e.compatMode !== "CSS1Compat" ? {
        type: yi.Document,
        childNodes: [],
        compatMode: e.compatMode
      } : {
        type: yi.Document,
        childNodes: []
      };
    case e.DOCUMENT_TYPE_NODE:
      return {
        type: yi.DocumentType,
        name: e.name,
        publicId: e.publicId,
        systemId: e.systemId,
        rootId: T
      };
    case e.ELEMENT_NODE:
      return ixe(e, {
        doc: n,
        blockClass: i,
        blockSelector: o,
        unblockSelector: a,
        inlineStylesheet: h,
        maskAttributeFn: c,
        maskInputOptions: p,
        maskInputFn: m,
        dataURLOptions: v,
        inlineImages: y,
        recordCanvas: S,
        keepIframeSrcFn: _,
        newlyAddedElement: w,
        rootId: T,
        maskAllText: s,
        maskTextClass: l,
        unmaskTextClass: u,
        maskTextSelector: d,
        unmaskTextSelector: f
      });
    case e.TEXT_NODE:
      return rxe(e, {
        maskAllText: s,
        maskTextClass: l,
        unmaskTextClass: u,
        maskTextSelector: d,
        unmaskTextSelector: f,
        maskTextFn: g,
        maskInputOptions: p,
        maskInputFn: m,
        rootId: T
      });
    case e.CDATA_SECTION_NODE:
      return {
        type: yi.CDATA,
        textContent: "",
        rootId: T
      };
    case e.COMMENT_NODE:
      return {
        type: yi.Comment,
        textContent: e.textContent || "",
        rootId: T
      };
    default:
      return !1;
  }
}
function nxe(e, t) {
  if (!t.hasNode(e))
    return;
  const n = t.getId(e);
  return n === 1 ? void 0 : n;
}
function rxe(e, t) {
  const { maskAllText: n, maskTextClass: r, unmaskTextClass: i, maskTextSelector: o, unmaskTextSelector: a, maskTextFn: s, maskInputOptions: c, maskInputFn: l, rootId: u } = t, d = e.parentNode && e.parentNode.tagName;
  let f = e.textContent;
  const h = d === "STYLE" ? !0 : void 0, p = d === "SCRIPT" ? !0 : void 0, g = d === "TEXTAREA" ? !0 : void 0;
  if (h && f) {
    try {
      e.nextSibling || e.previousSibling || H_([e, "access", (v) => v.parentNode, "access", (v) => v.sheet, "optionalAccess", (v) => v.cssRules]) && (f = U_(e.parentNode.sheet));
    } catch (v) {
      console.warn(`Cannot get CSS styles from text's parentNode. Error: ${v}`, e);
    }
    f = q_(f, WP());
  }
  p && (f = "SCRIPT_PLACEHOLDER");
  const m = xg(e, r, o, i, a, n);
  if (!h && !p && !g && f && m && (f = s ? s(f, e.parentElement) : f.replace(/[\S]/g, "*")), g && f && (c.textarea || m) && (f = l ? l(f, e.parentNode) : f.replace(/[\S]/g, "*")), d === "OPTION" && f) {
    const v = kx({
      type: null,
      tagName: d,
      maskInputOptions: c
    });
    f = G0({
      isMasked: xg(e, r, o, i, a, v),
      element: e,
      value: f,
      maskInputFn: l
    });
  }
  return {
    type: yi.Text,
    textContent: f || "",
    isStyle: h,
    rootId: u
  };
}
function ixe(e, t) {
  const { doc: n, blockClass: r, blockSelector: i, unblockSelector: o, inlineStylesheet: a, maskInputOptions: s = {}, maskAttributeFn: c, maskInputFn: l, dataURLOptions: u = {}, inlineImages: d, recordCanvas: f, keepIframeSrcFn: h, newlyAddedElement: p = !1, rootId: g, maskAllText: m, maskTextClass: v, unmaskTextClass: y, maskTextSelector: S, unmaskTextSelector: _ } = t, w = Qwe(e, r, i, o), T = Bwe(e);
  let x = {};
  const C = e.attributes.length;
  for (let R = 0; R < C; R++) {
    const A = e.attributes[R];
    A.name && !nK(T, A.name, A.value) && (x[A.name] = tK(n, T, wg(A.name), A.value, e, c));
  }
  if (T === "link" && a) {
    const R = Array.from(n.styleSheets).find((O) => O.href === e.href);
    let A = null;
    R && (A = U_(R)), A && (delete x.rel, delete x.href, x._cssText = q_(A, R.href));
  }
  if (T === "style" && e.sheet && !(e.innerText || e.textContent || "").trim().length) {
    const R = U_(e.sheet);
    R && (x._cssText = q_(R, WP()));
  }
  if (T === "input" || T === "textarea" || T === "select" || T === "option") {
    const R = e, A = HP(R), O = W_(R, SA(T), A), $ = R.checked;
    if (A !== "submit" && A !== "button" && O) {
      const N = xg(R, v, S, y, _, kx({
        type: A,
        tagName: SA(T),
        maskInputOptions: s
      }));
      x.value = G0({
        isMasked: N,
        element: R,
        value: O,
        maskInputFn: l
      });
    }
    $ && (x.checked = $);
  }
  if (T === "option" && (e.selected && !s.select ? x.selected = !0 : delete x.selected), T === "canvas" && f) {
    if (e.__context === "2d")
      jwe(e) || (x.rr_dataURL = e.toDataURL(u.type, u.quality));
    else if (!("__context" in e)) {
      const R = e.toDataURL(u.type, u.quality), A = document.createElement("canvas");
      A.width = e.width, A.height = e.height;
      const O = A.toDataURL(u.type, u.quality);
      R !== O && (x.rr_dataURL = R);
    }
  }
  if (T === "img" && d) {
    th || (th = n.createElement("canvas"), X4 = th.getContext("2d"));
    const R = e, A = R.crossOrigin;
    R.crossOrigin = "anonymous";
    const O = () => {
      R.removeEventListener("load", O);
      try {
        th.width = R.naturalWidth, th.height = R.naturalHeight, X4.drawImage(R, 0, 0), x.rr_dataURL = th.toDataURL(u.type, u.quality);
      } catch ($) {
        console.warn(`Cannot inline img src=${R.currentSrc}! Error: ${$}`);
      }
      A ? x.crossOrigin = A : R.removeAttribute("crossorigin");
    };
    R.complete && R.naturalWidth !== 0 ? O() : R.addEventListener("load", O);
  }
  if ((T === "audio" || T === "video") && (x.rr_mediaState = e.paused ? "paused" : "played", x.rr_mediaCurrentTime = e.currentTime), p || (e.scrollLeft && (x.rr_scrollLeft = e.scrollLeft), e.scrollTop && (x.rr_scrollTop = e.scrollTop)), w) {
    const { width: R, height: A } = e.getBoundingClientRect();
    x = {
      class: x.class,
      rr_width: `${R}px`,
      rr_height: `${A}px`
    };
  }
  T === "iframe" && !h(x.src) && (e.contentDocument || (x.rr_src = x.src), delete x.src);
  let E;
  try {
    customElements.get(T) && (E = !0);
  } catch {
  }
  return {
    type: yi.Element,
    tagName: T,
    attributes: x,
    childNodes: [],
    isSVG: Xwe(e) || void 0,
    needBlock: w,
    rootId: g,
    isCustom: E
  };
}
function ar(e) {
  return e == null ? "" : e.toLowerCase();
}
function oxe(e, t) {
  if (t.comment && e.type === yi.Comment)
    return !0;
  if (e.type === yi.Element) {
    if (t.script && (e.tagName === "script" || e.tagName === "link" && (e.attributes.rel === "preload" || e.attributes.rel === "modulepreload") && e.attributes.as === "script" || e.tagName === "link" && e.attributes.rel === "prefetch" && typeof e.attributes.href == "string" && e.attributes.href.endsWith(".js")))
      return !0;
    if (t.headFavicon && (e.tagName === "link" && e.attributes.rel === "shortcut icon" || e.tagName === "meta" && (ar(e.attributes.name).match(/^msapplication-tile(image|color)$/) || ar(e.attributes.name) === "application-name" || ar(e.attributes.rel) === "icon" || ar(e.attributes.rel) === "apple-touch-icon" || ar(e.attributes.rel) === "shortcut icon")))
      return !0;
    if (e.tagName === "meta") {
      if (t.headMetaDescKeywords && ar(e.attributes.name).match(/^description|keywords$/))
        return !0;
      if (t.headMetaSocial && (ar(e.attributes.property).match(/^(og|twitter|fb):/) || ar(e.attributes.name).match(/^(og|twitter):/) || ar(e.attributes.name) === "pinterest"))
        return !0;
      if (t.headMetaRobots && (ar(e.attributes.name) === "robots" || ar(e.attributes.name) === "googlebot" || ar(e.attributes.name) === "bingbot"))
        return !0;
      if (t.headMetaHttpEquiv && e.attributes["http-equiv"] !== void 0)
        return !0;
      if (t.headMetaAuthorship && (ar(e.attributes.name) === "author" || ar(e.attributes.name) === "generator" || ar(e.attributes.name) === "framework" || ar(e.attributes.name) === "publisher" || ar(e.attributes.name) === "progid" || ar(e.attributes.property).match(/^article:/) || ar(e.attributes.property).match(/^product:/)))
        return !0;
      if (t.headMetaVerification && (ar(e.attributes.name) === "google-site-verification" || ar(e.attributes.name) === "yandex-verification" || ar(e.attributes.name) === "csrf-token" || ar(e.attributes.name) === "p:domain_verify" || ar(e.attributes.name) === "verify-v1" || ar(e.attributes.name) === "verification" || ar(e.attributes.name) === "shopify-checkout-api-token"))
        return !0;
    }
  }
  return !1;
}
function Ph(e, t) {
  const { doc: n, mirror: r, blockClass: i, blockSelector: o, unblockSelector: a, maskAllText: s, maskTextClass: c, unmaskTextClass: l, maskTextSelector: u, unmaskTextSelector: d, skipChild: f = !1, inlineStylesheet: h = !0, maskInputOptions: p = {}, maskAttributeFn: g, maskTextFn: m, maskInputFn: v, slimDOMOptions: y, dataURLOptions: S = {}, inlineImages: _ = !1, recordCanvas: w = !1, onSerialize: T, onIframeLoad: x, iframeLoadTimeout: C = 5e3, onStylesheetLoad: E, stylesheetLoadTimeout: R = 5e3, keepIframeSrcFn: A = () => !1, newlyAddedElement: O = !1 } = t;
  let { preserveWhiteSpace: $ = !0 } = t;
  const N = txe(e, {
    doc: n,
    mirror: r,
    blockClass: i,
    blockSelector: o,
    maskAllText: s,
    unblockSelector: a,
    maskTextClass: c,
    unmaskTextClass: l,
    maskTextSelector: u,
    unmaskTextSelector: d,
    inlineStylesheet: h,
    maskInputOptions: p,
    maskAttributeFn: g,
    maskTextFn: m,
    maskInputFn: v,
    dataURLOptions: S,
    inlineImages: _,
    recordCanvas: w,
    keepIframeSrcFn: A,
    newlyAddedElement: O
  });
  if (!N)
    return console.warn(e, "not serialized"), null;
  let z;
  r.hasNode(e) ? z = r.getId(e) : oxe(N, y) || !$ && N.type === yi.Text && !N.isStyle && !N.textContent.replace(/^\s+|\s+$/gm, "").length ? z = K0 : z = UP();
  const k = Object.assign(N, { id: z });
  if (r.add(e, k), z === K0)
    return null;
  T && T(e);
  let F = !f;
  if (k.type === yi.Element) {
    F = F && !k.needBlock, delete k.needBlock;
    const V = e.shadowRoot;
    V && g0(V) && (k.isShadowHost = !0);
  }
  if ((k.type === yi.Document || k.type === yi.Element) && F) {
    y.headWhitespace && k.type === yi.Element && k.tagName === "head" && ($ = !1);
    const V = {
      doc: n,
      mirror: r,
      blockClass: i,
      blockSelector: o,
      maskAllText: s,
      unblockSelector: a,
      maskTextClass: c,
      unmaskTextClass: l,
      maskTextSelector: u,
      unmaskTextSelector: d,
      skipChild: f,
      inlineStylesheet: h,
      maskInputOptions: p,
      maskAttributeFn: g,
      maskTextFn: m,
      maskInputFn: v,
      slimDOMOptions: y,
      dataURLOptions: S,
      inlineImages: _,
      recordCanvas: w,
      preserveWhiteSpace: $,
      onSerialize: T,
      onIframeLoad: x,
      iframeLoadTimeout: C,
      onStylesheetLoad: E,
      stylesheetLoadTimeout: R,
      keepIframeSrcFn: A
    };
    for (const j of Array.from(e.childNodes)) {
      const B = Ph(j, V);
      B && k.childNodes.push(B);
    }
    if (Owe(e) && e.shadowRoot)
      for (const j of Array.from(e.shadowRoot.childNodes)) {
        const B = Ph(j, V);
        B && (g0(e.shadowRoot) && (B.isShadow = !0), k.childNodes.push(B));
      }
  }
  return e.parentNode && h0(e.parentNode) && g0(e.parentNode) && (k.isShadow = !0), k.type === yi.Element && k.tagName === "iframe" && Zwe(e, () => {
    const V = e.contentDocument;
    if (V && x) {
      const j = Ph(V, {
        doc: V,
        mirror: r,
        blockClass: i,
        blockSelector: o,
        unblockSelector: a,
        maskAllText: s,
        maskTextClass: c,
        unmaskTextClass: l,
        maskTextSelector: u,
        unmaskTextSelector: d,
        skipChild: !1,
        inlineStylesheet: h,
        maskInputOptions: p,
        maskAttributeFn: g,
        maskTextFn: m,
        maskInputFn: v,
        slimDOMOptions: y,
        dataURLOptions: S,
        inlineImages: _,
        recordCanvas: w,
        preserveWhiteSpace: $,
        onSerialize: T,
        onIframeLoad: x,
        iframeLoadTimeout: C,
        onStylesheetLoad: E,
        stylesheetLoadTimeout: R,
        keepIframeSrcFn: A
      });
      j && x(e, j);
    }
  }, C), k.type === yi.Element && k.tagName === "link" && k.attributes.rel === "stylesheet" && exe(e, () => {
    if (E) {
      const V = Ph(e, {
        doc: n,
        mirror: r,
        blockClass: i,
        blockSelector: o,
        unblockSelector: a,
        maskAllText: s,
        maskTextClass: c,
        unmaskTextClass: l,
        maskTextSelector: u,
        unmaskTextSelector: d,
        skipChild: !1,
        inlineStylesheet: h,
        maskInputOptions: p,
        maskAttributeFn: g,
        maskTextFn: m,
        maskInputFn: v,
        slimDOMOptions: y,
        dataURLOptions: S,
        inlineImages: _,
        recordCanvas: w,
        preserveWhiteSpace: $,
        onSerialize: T,
        onIframeLoad: x,
        iframeLoadTimeout: C,
        onStylesheetLoad: E,
        stylesheetLoadTimeout: R,
        keepIframeSrcFn: A
      });
      V && E(e, V);
    }
  }, R), k;
}
function axe(e, t) {
  const { mirror: n = new eK(), blockClass: r = "rr-block", blockSelector: i = null, unblockSelector: o = null, maskAllText: a = !1, maskTextClass: s = "rr-mask", unmaskTextClass: c = null, maskTextSelector: l = null, unmaskTextSelector: u = null, inlineStylesheet: d = !0, inlineImages: f = !1, recordCanvas: h = !1, maskAllInputs: p = !1, maskAttributeFn: g, maskTextFn: m, maskInputFn: v, slimDOM: y = !1, dataURLOptions: S, preserveWhiteSpace: _, onSerialize: w, onIframeLoad: T, iframeLoadTimeout: x, onStylesheetLoad: C, stylesheetLoadTimeout: E, keepIframeSrcFn: R = () => !1 } = t || {};
  return Ph(e, {
    doc: e,
    mirror: n,
    blockClass: r,
    blockSelector: i,
    unblockSelector: o,
    maskAllText: a,
    maskTextClass: s,
    unmaskTextClass: c,
    maskTextSelector: l,
    unmaskTextSelector: u,
    skipChild: !1,
    inlineStylesheet: d,
    maskInputOptions: p === !0 ? {
      color: !0,
      date: !0,
      "datetime-local": !0,
      email: !0,
      month: !0,
      number: !0,
      range: !0,
      search: !0,
      tel: !0,
      text: !0,
      time: !0,
      url: !0,
      week: !0,
      textarea: !0,
      select: !0
    } : p === !1 ? {} : p,
    maskAttributeFn: g,
    maskTextFn: m,
    maskInputFn: v,
    slimDOMOptions: y === !0 || y === "all" ? {
      script: !0,
      comment: !0,
      headFavicon: !0,
      headWhitespace: !0,
      headMetaDescKeywords: y === "all",
      headMetaSocial: !0,
      headMetaRobots: !0,
      headMetaHttpEquiv: !0,
      headMetaAuthorship: !0,
      headMetaVerification: !0
    } : y === !1 ? {} : y,
    dataURLOptions: S,
    inlineImages: f,
    recordCanvas: h,
    preserveWhiteSpace: _,
    onSerialize: w,
    onIframeLoad: T,
    iframeLoadTimeout: x,
    onStylesheetLoad: C,
    stylesheetLoadTimeout: E,
    keepIframeSrcFn: R,
    newlyAddedElement: !1
  });
}
function Ml(e) {
  let t, n = e[0], r = 1;
  for (; r < e.length; ) {
    const i = e[r], o = e[r + 1];
    if (r += 2, (i === "optionalAccess" || i === "optionalCall") && n == null)
      return;
    i === "access" || i === "optionalAccess" ? (t = n, n = o(n)) : (i === "call" || i === "optionalCall") && (n = o((...a) => n.call(t, ...a)), t = void 0);
  }
  return n;
}
function Co(e, t, n = document) {
  const r = { capture: !0, passive: !0 };
  return n.addEventListener(e, t, r), () => n.removeEventListener(e, t, r);
}
const Ch = `Please stop import mirror directly. Instead of that,\r
now you can use replayer.getMirror() to access the mirror instance of a replayer,\r
or you can use record.mirror to access the mirror instance during recording.`;
let Q4 = {
  map: {},
  getId() {
    return console.error(Ch), -1;
  },
  getNode() {
    return console.error(Ch), null;
  },
  removeNodeFromMap() {
    console.error(Ch);
  },
  has() {
    return console.error(Ch), !1;
  },
  reset() {
    console.error(Ch);
  }
};
typeof window < "u" && window.Proxy && window.Reflect && (Q4 = new Proxy(Q4, {
  get(e, t, n) {
    return t === "map" && console.error(Ch), Reflect.get(e, t, n);
  }
}));
function Y0(e, t, n = {}) {
  let r = null, i = 0;
  return function(...o) {
    const a = Date.now();
    !i && n.leading === !1 && (i = a);
    const s = t - (a - i), c = this;
    s <= 0 || s > t ? (r && (hxe(r), r = null), i = a, e.apply(c, o)) : !r && n.trailing !== !1 && (r = Nx(() => {
      i = n.leading === !1 ? 0 : Date.now(), r = null, e.apply(c, o);
    }, s));
  };
}
function rK(e, t, n, r, i = window) {
  const o = i.Object.getOwnPropertyDescriptor(e, t);
  return i.Object.defineProperty(e, t, r ? n : {
    set(a) {
      Nx(() => {
        n.set.call(this, a);
      }, 0), o && o.set && o.set.call(this, a);
    }
  }), () => rK(e, t, o || {}, !0);
}
function qP(e, t, n) {
  try {
    if (!(t in e))
      return () => {
      };
    const r = e[t], i = n(r);
    return typeof i == "function" && (i.prototype = i.prototype || {}, Object.defineProperties(i, {
      __rrweb_original__: {
        enumerable: !1,
        value: r
      }
    })), e[t] = i, () => {
      e[t] = r;
    };
  } catch {
    return () => {
    };
  }
}
let G_ = Date.now;
/[1-9][0-9]{12}/.test(Date.now().toString()) || (G_ = () => (/* @__PURE__ */ new Date()).getTime());
function iK(e) {
  const t = e.document;
  return {
    left: t.scrollingElement ? t.scrollingElement.scrollLeft : e.pageXOffset !== void 0 ? e.pageXOffset : Ml([t, "optionalAccess", (n) => n.documentElement, "access", (n) => n.scrollLeft]) || Ml([t, "optionalAccess", (n) => n.body, "optionalAccess", (n) => n.parentElement, "optionalAccess", (n) => n.scrollLeft]) || Ml([t, "optionalAccess", (n) => n.body, "optionalAccess", (n) => n.scrollLeft]) || 0,
    top: t.scrollingElement ? t.scrollingElement.scrollTop : e.pageYOffset !== void 0 ? e.pageYOffset : Ml([t, "optionalAccess", (n) => n.documentElement, "access", (n) => n.scrollTop]) || Ml([t, "optionalAccess", (n) => n.body, "optionalAccess", (n) => n.parentElement, "optionalAccess", (n) => n.scrollTop]) || Ml([t, "optionalAccess", (n) => n.body, "optionalAccess", (n) => n.scrollTop]) || 0
  };
}
function oK() {
  return window.innerHeight || document.documentElement && document.documentElement.clientHeight || document.body && document.body.clientHeight;
}
function aK() {
  return window.innerWidth || document.documentElement && document.documentElement.clientWidth || document.body && document.body.clientWidth;
}
function sK(e) {
  return e ? e.nodeType === e.ELEMENT_NODE ? e : e.parentElement : null;
}
function ss(e, t, n, r, i) {
  if (!e)
    return !1;
  const o = sK(e);
  if (!o)
    return !1;
  const a = Oh(t, n);
  if (!i) {
    const l = r && o.matches(r);
    return a(o) && !l;
  }
  const s = Sd(o, a);
  let c = -1;
  return s < 0 ? !1 : (r && (c = Sd(o, Oh(null, r))), s > -1 && c < 0 ? !0 : s < c);
}
function sxe(e, t) {
  return t.getId(e) !== -1;
}
function v5(e, t) {
  return t.getId(e) === K0;
}
function cK(e, t) {
  if (h0(e))
    return !1;
  const n = t.getId(e);
  return t.has(n) ? e.parentNode && e.parentNode.nodeType === e.DOCUMENT_NODE ? !1 : e.parentNode ? cK(e.parentNode, t) : !0 : !0;
}
function wA(e) {
  return !!e.changedTouches;
}
function cxe(e = window) {
  "NodeList" in e && !e.NodeList.prototype.forEach && (e.NodeList.prototype.forEach = Array.prototype.forEach), "DOMTokenList" in e && !e.DOMTokenList.prototype.forEach && (e.DOMTokenList.prototype.forEach = Array.prototype.forEach), Node.prototype.contains || (Node.prototype.contains = (...t) => {
    let n = t[0];
    if (!(0 in t))
      throw new TypeError("1 argument is required");
    do
      if (this === n)
        return !0;
    while (n = n && n.parentNode);
    return !1;
  });
}
function lK(e, t) {
  return !!(e.nodeName === "IFRAME" && t.getMeta(e));
}
function uK(e, t) {
  return !!(e.nodeName === "LINK" && e.nodeType === e.ELEMENT_NODE && e.getAttribute && e.getAttribute("rel") === "stylesheet" && t.getMeta(e));
}
function xA(e) {
  return !!Ml([e, "optionalAccess", (t) => t.shadowRoot]);
}
class lxe {
  constructor() {
    this.id = 1, this.styleIDMap = /* @__PURE__ */ new WeakMap(), this.idStyleMap = /* @__PURE__ */ new Map();
  }
  getId(t) {
    return Tbe(this.styleIDMap.get(t), () => -1);
  }
  has(t) {
    return this.styleIDMap.has(t);
  }
  add(t, n) {
    if (this.has(t))
      return this.getId(t);
    let r;
    return n === void 0 ? r = this.id++ : r = n, this.styleIDMap.set(t, r), this.idStyleMap.set(r, t), r;
  }
  getStyle(t) {
    return this.idStyleMap.get(t) || null;
  }
  reset() {
    this.styleIDMap = /* @__PURE__ */ new WeakMap(), this.idStyleMap = /* @__PURE__ */ new Map(), this.id = 1;
  }
  generateId() {
    return this.id++;
  }
}
function dK(e) {
  let t = null;
  return Ml([e, "access", (n) => n.getRootNode, "optionalCall", (n) => n(), "optionalAccess", (n) => n.nodeType]) === Node.DOCUMENT_FRAGMENT_NODE && e.getRootNode().host && (t = e.getRootNode().host), t;
}
function uxe(e) {
  let t = e, n;
  for (; n = dK(t); )
    t = n;
  return t;
}
function dxe(e) {
  const t = e.ownerDocument;
  if (!t)
    return !1;
  const n = uxe(e);
  return t.contains(n);
}
function fK(e) {
  const t = e.ownerDocument;
  return t ? t.contains(e) || dxe(e) : !1;
}
const J4 = {};
function GP(e) {
  const t = J4[e];
  if (t)
    return t;
  const n = window.document;
  let r = window[e];
  if (n && typeof n.createElement == "function")
    try {
      const i = n.createElement("iframe");
      i.hidden = !0, n.head.appendChild(i);
      const o = i.contentWindow;
      o && o[e] && (r = o[e]), n.head.removeChild(i);
    } catch {
    }
  return J4[e] = r.bind(window);
}
function fxe(...e) {
  return GP("requestAnimationFrame")(...e);
}
function Nx(...e) {
  return GP("setTimeout")(...e);
}
function hxe(...e) {
  return GP("clearTimeout")(...e);
}
var dn = /* @__PURE__ */ ((e) => (e[e.DomContentLoaded = 0] = "DomContentLoaded", e[e.Load = 1] = "Load", e[e.FullSnapshot = 2] = "FullSnapshot", e[e.IncrementalSnapshot = 3] = "IncrementalSnapshot", e[e.Meta = 4] = "Meta", e[e.Custom = 5] = "Custom", e[e.Plugin = 6] = "Plugin", e))(dn || {}), fn = /* @__PURE__ */ ((e) => (e[e.Mutation = 0] = "Mutation", e[e.MouseMove = 1] = "MouseMove", e[e.MouseInteraction = 2] = "MouseInteraction", e[e.Scroll = 3] = "Scroll", e[e.ViewportResize = 4] = "ViewportResize", e[e.Input = 5] = "Input", e[e.TouchMove = 6] = "TouchMove", e[e.MediaInteraction = 7] = "MediaInteraction", e[e.StyleSheetRule = 8] = "StyleSheetRule", e[e.CanvasMutation = 9] = "CanvasMutation", e[e.Font = 10] = "Font", e[e.Log = 11] = "Log", e[e.Drag = 12] = "Drag", e[e.StyleDeclaration = 13] = "StyleDeclaration", e[e.Selection = 14] = "Selection", e[e.AdoptedStyleSheet = 15] = "AdoptedStyleSheet", e[e.CustomElement = 16] = "CustomElement", e))(fn || {}), So = /* @__PURE__ */ ((e) => (e[e.MouseUp = 0] = "MouseUp", e[e.MouseDown = 1] = "MouseDown", e[e.Click = 2] = "Click", e[e.ContextMenu = 3] = "ContextMenu", e[e.DblClick = 4] = "DblClick", e[e.Focus = 5] = "Focus", e[e.Blur = 6] = "Blur", e[e.TouchStart = 7] = "TouchStart", e[e.TouchMove_Departed = 8] = "TouchMove_Departed", e[e.TouchEnd = 9] = "TouchEnd", e[e.TouchCancel = 10] = "TouchCancel", e))(So || {}), Ic = /* @__PURE__ */ ((e) => (e[e.Mouse = 0] = "Mouse", e[e.Pen = 1] = "Pen", e[e.Touch = 2] = "Touch", e))(Ic || {});
function gxe(e) {
  let t, n = e[0], r = 1;
  for (; r < e.length; ) {
    const i = e[r], o = e[r + 1];
    if (r += 2, (i === "optionalAccess" || i === "optionalCall") && n == null)
      return;
    i === "access" || i === "optionalAccess" ? (t = n, n = o(n)) : (i === "call" || i === "optionalCall") && (n = o((...a) => n.call(t, ...a)), t = void 0);
  }
  return n;
}
function Z4(e) {
  return "__ln" in e;
}
class pxe {
  constructor() {
    this.length = 0, this.head = null, this.tail = null;
  }
  get(t) {
    if (t >= this.length)
      throw new Error("Position outside of list range");
    let n = this.head;
    for (let r = 0; r < t; r++)
      n = gxe([n, "optionalAccess", (i) => i.next]) || null;
    return n;
  }
  addNode(t) {
    const n = {
      value: t,
      previous: null,
      next: null
    };
    if (t.__ln = n, t.previousSibling && Z4(t.previousSibling)) {
      const r = t.previousSibling.__ln.next;
      n.next = r, n.previous = t.previousSibling.__ln, t.previousSibling.__ln.next = n, r && (r.previous = n);
    } else if (t.nextSibling && Z4(t.nextSibling) && t.nextSibling.__ln.previous) {
      const r = t.nextSibling.__ln.previous;
      n.previous = r, n.next = t.nextSibling.__ln, t.nextSibling.__ln.previous = n, r && (r.next = n);
    } else
      this.head && (this.head.previous = n), n.next = this.head, this.head = n;
    n.next === null && (this.tail = n), this.length++;
  }
  removeNode(t) {
    const n = t.__ln;
    this.head && (n.previous ? (n.previous.next = n.next, n.next ? n.next.previous = n.previous : this.tail = n.previous) : (this.head = n.next, this.head ? this.head.previous = null : this.tail = null), t.__ln && delete t.__ln, this.length--);
  }
}
const e8 = (e, t) => `${e}@${t}`;
class mxe {
  constructor() {
    this.frozen = !1, this.locked = !1, this.texts = [], this.attributes = [], this.attributeMap = /* @__PURE__ */ new WeakMap(), this.removes = [], this.mapRemoves = [], this.movedMap = {}, this.addedSet = /* @__PURE__ */ new Set(), this.movedSet = /* @__PURE__ */ new Set(), this.droppedSet = /* @__PURE__ */ new Set(), this.processMutations = (t) => {
      t.forEach(this.processMutation), this.emit();
    }, this.emit = () => {
      if (this.frozen || this.locked)
        return;
      const t = [], n = /* @__PURE__ */ new Set(), r = new pxe(), i = (c) => {
        let l = c, u = K0;
        for (; u === K0; )
          l = l && l.nextSibling, u = l && this.mirror.getId(l);
        return u;
      }, o = (c) => {
        if (!c.parentNode || !fK(c))
          return;
        const l = h0(c.parentNode) ? this.mirror.getId(dK(c)) : this.mirror.getId(c.parentNode), u = i(c);
        if (l === -1 || u === -1)
          return r.addNode(c);
        const d = Ph(c, {
          doc: this.doc,
          mirror: this.mirror,
          blockClass: this.blockClass,
          blockSelector: this.blockSelector,
          maskAllText: this.maskAllText,
          unblockSelector: this.unblockSelector,
          maskTextClass: this.maskTextClass,
          unmaskTextClass: this.unmaskTextClass,
          maskTextSelector: this.maskTextSelector,
          unmaskTextSelector: this.unmaskTextSelector,
          skipChild: !0,
          newlyAddedElement: !0,
          inlineStylesheet: this.inlineStylesheet,
          maskInputOptions: this.maskInputOptions,
          maskAttributeFn: this.maskAttributeFn,
          maskTextFn: this.maskTextFn,
          maskInputFn: this.maskInputFn,
          slimDOMOptions: this.slimDOMOptions,
          dataURLOptions: this.dataURLOptions,
          recordCanvas: this.recordCanvas,
          inlineImages: this.inlineImages,
          onSerialize: (f) => {
            lK(f, this.mirror) && this.iframeManager.addIframe(f), uK(f, this.mirror) && this.stylesheetManager.trackLinkElement(f), xA(c) && this.shadowDomManager.addShadowRoot(c.shadowRoot, this.doc);
          },
          onIframeLoad: (f, h) => {
            this.iframeManager.attachIframe(f, h), this.shadowDomManager.observeAttachShadow(f);
          },
          onStylesheetLoad: (f, h) => {
            this.stylesheetManager.attachLinkElement(f, h);
          }
        });
        d && (t.push({
          parentId: l,
          nextId: u,
          node: d
        }), n.add(d.id));
      };
      for (; this.mapRemoves.length; )
        this.mirror.removeNodeFromMap(this.mapRemoves.shift());
      for (const c of this.movedSet)
        t8(this.removes, c, this.mirror) && !this.movedSet.has(c.parentNode) || o(c);
      for (const c of this.addedSet)
        !n8(this.droppedSet, c) && !t8(this.removes, c, this.mirror) || n8(this.movedSet, c) ? o(c) : this.droppedSet.add(c);
      let a = null;
      for (; r.length; ) {
        let c = null;
        if (a) {
          const l = this.mirror.getId(a.value.parentNode), u = i(a.value);
          l !== -1 && u !== -1 && (c = a);
        }
        if (!c) {
          let l = r.tail;
          for (; l; ) {
            const u = l;
            if (l = l.previous, u) {
              const d = this.mirror.getId(u.value.parentNode);
              if (i(u.value) === -1)
                continue;
              if (d !== -1) {
                c = u;
                break;
              } else {
                const h = u.value;
                if (h.parentNode && h.parentNode.nodeType === Node.DOCUMENT_FRAGMENT_NODE) {
                  const p = h.parentNode.host;
                  if (this.mirror.getId(p) !== -1) {
                    c = u;
                    break;
                  }
                }
              }
            }
          }
        }
        if (!c) {
          for (; r.head; )
            r.removeNode(r.head.value);
          break;
        }
        a = c.previous, r.removeNode(c.value), o(c.value);
      }
      const s = {
        texts: this.texts.map((c) => ({
          id: this.mirror.getId(c.node),
          value: c.value
        })).filter((c) => !n.has(c.id)).filter((c) => this.mirror.has(c.id)),
        attributes: this.attributes.map((c) => {
          const { attributes: l } = c;
          if (typeof l.style == "string") {
            const u = JSON.stringify(c.styleDiff), d = JSON.stringify(c._unchangedStyles);
            u.length < l.style.length && (u + d).split("var(").length === l.style.split("var(").length && (l.style = c.styleDiff);
          }
          return {
            id: this.mirror.getId(c.node),
            attributes: l
          };
        }).filter((c) => !n.has(c.id)).filter((c) => this.mirror.has(c.id)),
        removes: this.removes,
        adds: t
      };
      !s.texts.length && !s.attributes.length && !s.removes.length && !s.adds.length || (this.texts = [], this.attributes = [], this.attributeMap = /* @__PURE__ */ new WeakMap(), this.removes = [], this.addedSet = /* @__PURE__ */ new Set(), this.movedSet = /* @__PURE__ */ new Set(), this.droppedSet = /* @__PURE__ */ new Set(), this.movedMap = {}, this.mutationCb(s));
    }, this.processMutation = (t) => {
      if (!v5(t.target, this.mirror))
        switch (t.type) {
          case "characterData": {
            const n = t.target.textContent;
            !ss(t.target, this.blockClass, this.blockSelector, this.unblockSelector, !1) && n !== t.oldValue && this.texts.push({
              value: xg(t.target, this.maskTextClass, this.maskTextSelector, this.unmaskTextClass, this.unmaskTextSelector, this.maskAllText) && n ? this.maskTextFn ? this.maskTextFn(n, sK(t.target)) : n.replace(/[\S]/g, "*") : n,
              node: t.target
            });
            break;
          }
          case "attributes": {
            const n = t.target;
            let r = t.attributeName, i = t.target.getAttribute(r);
            if (r === "value") {
              const a = HP(n), s = n.tagName;
              i = W_(n, s, a);
              const c = kx({
                maskInputOptions: this.maskInputOptions,
                tagName: s,
                type: a
              }), l = xg(t.target, this.maskTextClass, this.maskTextSelector, this.unmaskTextClass, this.unmaskTextSelector, c);
              i = G0({
                isMasked: l,
                element: n,
                value: i,
                maskInputFn: this.maskInputFn
              });
            }
            if (ss(t.target, this.blockClass, this.blockSelector, this.unblockSelector, !1) || i === t.oldValue)
              return;
            let o = this.attributeMap.get(t.target);
            if (n.tagName === "IFRAME" && r === "src" && !this.keepIframeSrcFn(i))
              if (!n.contentDocument)
                r = "rr_src";
              else
                return;
            if (o || (o = {
              node: t.target,
              attributes: {},
              styleDiff: {},
              _unchangedStyles: {}
            }, this.attributes.push(o), this.attributeMap.set(t.target, o)), r === "type" && n.tagName === "INPUT" && (t.oldValue || "").toLowerCase() === "password" && n.setAttribute("data-rr-is-password", "true"), !nK(n.tagName, r) && (o.attributes[r] = tK(this.doc, wg(n.tagName), wg(r), i, n, this.maskAttributeFn), r === "style")) {
              if (!this.unattachedDoc)
                try {
                  this.unattachedDoc = document.implementation.createHTMLDocument();
                } catch {
                  this.unattachedDoc = this.doc;
                }
              const a = this.unattachedDoc.createElement("span");
              t.oldValue && a.setAttribute("style", t.oldValue);
              for (const s of Array.from(n.style)) {
                const c = n.style.getPropertyValue(s), l = n.style.getPropertyPriority(s);
                c !== a.style.getPropertyValue(s) || l !== a.style.getPropertyPriority(s) ? l === "" ? o.styleDiff[s] = c : o.styleDiff[s] = [c, l] : o._unchangedStyles[s] = [c, l];
              }
              for (const s of Array.from(a.style))
                n.style.getPropertyValue(s) === "" && (o.styleDiff[s] = !1);
            }
            break;
          }
          case "childList": {
            if (ss(t.target, this.blockClass, this.blockSelector, this.unblockSelector, !0))
              return;
            t.addedNodes.forEach((n) => this.genAdds(n, t.target)), t.removedNodes.forEach((n) => {
              const r = this.mirror.getId(n), i = h0(t.target) ? this.mirror.getId(t.target.host) : this.mirror.getId(t.target);
              ss(t.target, this.blockClass, this.blockSelector, this.unblockSelector, !1) || v5(n, this.mirror) || !sxe(n, this.mirror) || (this.addedSet.has(n) ? (EA(this.addedSet, n), this.droppedSet.add(n)) : this.addedSet.has(t.target) && r === -1 || cK(t.target, this.mirror) || (this.movedSet.has(n) && this.movedMap[e8(r, i)] ? EA(this.movedSet, n) : this.removes.push({
                parentId: i,
                id: r,
                isShadow: h0(t.target) && g0(t.target) ? !0 : void 0
              })), this.mapRemoves.push(n));
            });
            break;
          }
        }
    }, this.genAdds = (t, n) => {
      if (!this.processedNodeManager.inOtherBuffer(t, this) && !(this.addedSet.has(t) || this.movedSet.has(t))) {
        if (this.mirror.hasNode(t)) {
          if (v5(t, this.mirror))
            return;
          this.movedSet.add(t);
          let r = null;
          n && this.mirror.hasNode(n) && (r = this.mirror.getId(n)), r && r !== -1 && (this.movedMap[e8(this.mirror.getId(t), r)] = !0);
        } else
          this.addedSet.add(t), this.droppedSet.delete(t);
        ss(t, this.blockClass, this.blockSelector, this.unblockSelector, !1) || (t.childNodes.forEach((r) => this.genAdds(r)), xA(t) && t.shadowRoot.childNodes.forEach((r) => {
          this.processedNodeManager.add(r, this), this.genAdds(r, t);
        }));
      }
    };
  }
  init(t) {
    [
      "mutationCb",
      "blockClass",
      "blockSelector",
      "unblockSelector",
      "maskAllText",
      "maskTextClass",
      "unmaskTextClass",
      "maskTextSelector",
      "unmaskTextSelector",
      "inlineStylesheet",
      "maskInputOptions",
      "maskAttributeFn",
      "maskTextFn",
      "maskInputFn",
      "keepIframeSrcFn",
      "recordCanvas",
      "inlineImages",
      "slimDOMOptions",
      "dataURLOptions",
      "doc",
      "mirror",
      "iframeManager",
      "stylesheetManager",
      "shadowDomManager",
      "canvasManager",
      "processedNodeManager"
    ].forEach((n) => {
      this[n] = t[n];
    });
  }
  freeze() {
    this.frozen = !0, this.canvasManager.freeze();
  }
  unfreeze() {
    this.frozen = !1, this.canvasManager.unfreeze(), this.emit();
  }
  isFrozen() {
    return this.frozen;
  }
  lock() {
    this.locked = !0, this.canvasManager.lock();
  }
  unlock() {
    this.locked = !1, this.canvasManager.unlock(), this.emit();
  }
  reset() {
    this.shadowDomManager.reset(), this.canvasManager.reset();
  }
}
function EA(e, t) {
  e.delete(t), t.childNodes.forEach((n) => EA(e, n));
}
function t8(e, t, n) {
  return e.length === 0 ? !1 : hK(e, t, n);
}
function hK(e, t, n) {
  const { parentNode: r } = t;
  if (!r)
    return !1;
  const i = n.getId(r);
  return e.some((o) => o.id === i) ? !0 : hK(e, r, n);
}
function n8(e, t) {
  return e.size === 0 ? !1 : gK(e, t);
}
function gK(e, t) {
  const { parentNode: n } = t;
  return n ? e.has(n) ? !0 : gK(e, n) : !1;
}
let p0;
function vxe(e) {
  p0 = e;
}
function yxe() {
  p0 = void 0;
}
const In = (e) => p0 ? (...n) => {
  try {
    return e(...n);
  } catch (r) {
    if (p0 && p0(r) === !0)
      return () => {
      };
    throw r;
  }
} : e;
function Ws(e) {
  let t, n = e[0], r = 1;
  for (; r < e.length; ) {
    const i = e[r], o = e[r + 1];
    if (r += 2, (i === "optionalAccess" || i === "optionalCall") && n == null)
      return;
    i === "access" || i === "optionalAccess" ? (t = n, n = o(n)) : (i === "call" || i === "optionalCall") && (n = o((...a) => n.call(t, ...a)), t = void 0);
  }
  return n;
}
const Mh = [];
function ry(e) {
  try {
    if ("composedPath" in e) {
      const t = e.composedPath();
      if (t.length)
        return t[0];
    } else if ("path" in e && e.path.length)
      return e.path[0];
  } catch {
  }
  return e && e.target;
}
function pK(e, t) {
  const n = new mxe();
  Mh.push(n), n.init(e);
  let r = window.MutationObserver || window.__rrMutationObserver;
  const i = Ws([window, "optionalAccess", (a) => a.Zone, "optionalAccess", (a) => a.__symbol__, "optionalCall", (a) => a("MutationObserver")]);
  i && window[i] && (r = window[i]);
  const o = new r(In((a) => {
    e.onMutation && e.onMutation(a) === !1 || n.processMutations.bind(n)(a);
  }));
  return o.observe(t, {
    attributes: !0,
    attributeOldValue: !0,
    characterData: !0,
    characterDataOldValue: !0,
    childList: !0,
    subtree: !0
  }), o;
}
function bxe({ mousemoveCb: e, sampling: t, doc: n, mirror: r }) {
  if (t.mousemove === !1)
    return () => {
    };
  const i = typeof t.mousemove == "number" ? t.mousemove : 50, o = typeof t.mousemoveCallback == "number" ? t.mousemoveCallback : 500;
  let a = [], s;
  const c = Y0(In((d) => {
    const f = Date.now() - s;
    e(a.map((h) => (h.timeOffset -= f, h)), d), a = [], s = null;
  }), o), l = In(Y0(In((d) => {
    const f = ry(d), { clientX: h, clientY: p } = wA(d) ? d.changedTouches[0] : d;
    s || (s = G_()), a.push({
      x: h,
      y: p,
      id: r.getId(f),
      timeOffset: G_() - s
    }), c(typeof DragEvent < "u" && d instanceof DragEvent ? fn.Drag : d instanceof MouseEvent ? fn.MouseMove : fn.TouchMove);
  }), i, {
    trailing: !1
  })), u = [
    Co("mousemove", l, n),
    Co("touchmove", l, n),
    Co("drag", l, n)
  ];
  return In(() => {
    u.forEach((d) => d());
  });
}
function _xe({ mouseInteractionCb: e, doc: t, mirror: n, blockClass: r, blockSelector: i, unblockSelector: o, sampling: a }) {
  if (a.mouseInteraction === !1)
    return () => {
    };
  const s = a.mouseInteraction === !0 || a.mouseInteraction === void 0 ? {} : a.mouseInteraction, c = [];
  let l = null;
  const u = (d) => (f) => {
    const h = ry(f);
    if (ss(h, r, i, o, !0))
      return;
    let p = null, g = d;
    if ("pointerType" in f) {
      switch (f.pointerType) {
        case "mouse":
          p = Ic.Mouse;
          break;
        case "touch":
          p = Ic.Touch;
          break;
        case "pen":
          p = Ic.Pen;
          break;
      }
      p === Ic.Touch ? So[d] === So.MouseDown ? g = "TouchStart" : So[d] === So.MouseUp && (g = "TouchEnd") : Ic.Pen;
    } else
      wA(f) && (p = Ic.Touch);
    p !== null ? (l = p, (g.startsWith("Touch") && p === Ic.Touch || g.startsWith("Mouse") && p === Ic.Mouse) && (p = null)) : So[d] === So.Click && (p = l, l = null);
    const m = wA(f) ? f.changedTouches[0] : f;
    if (!m)
      return;
    const v = n.getId(h), { clientX: y, clientY: S } = m;
    In(e)({
      type: So[g],
      id: v,
      x: y,
      y: S,
      ...p !== null && { pointerType: p }
    });
  };
  return Object.keys(So).filter((d) => Number.isNaN(Number(d)) && !d.endsWith("_Departed") && s[d] !== !1).forEach((d) => {
    let f = wg(d);
    const h = u(d);
    if (window.PointerEvent)
      switch (So[d]) {
        case So.MouseDown:
        case So.MouseUp:
          f = f.replace("mouse", "pointer");
          break;
        case So.TouchStart:
        case So.TouchEnd:
          return;
      }
    c.push(Co(f, h, t));
  }), In(() => {
    c.forEach((d) => d());
  });
}
function mK({ scrollCb: e, doc: t, mirror: n, blockClass: r, blockSelector: i, unblockSelector: o, sampling: a }) {
  const s = In(Y0(In((c) => {
    const l = ry(c);
    if (!l || ss(l, r, i, o, !0))
      return;
    const u = n.getId(l);
    if (l === t && t.defaultView) {
      const d = iK(t.defaultView);
      e({
        id: u,
        x: d.left,
        y: d.top
      });
    } else
      e({
        id: u,
        x: l.scrollLeft,
        y: l.scrollTop
      });
  }), a.scroll || 100));
  return Co("scroll", s, t);
}
function Sxe({ viewportResizeCb: e }, { win: t }) {
  let n = -1, r = -1;
  const i = In(Y0(In(() => {
    const o = oK(), a = aK();
    (n !== o || r !== a) && (e({
      width: Number(a),
      height: Number(o)
    }), n = o, r = a);
  }), 200));
  return Co("resize", i, t);
}
const wxe = ["INPUT", "TEXTAREA", "SELECT"], r8 = /* @__PURE__ */ new WeakMap();
function xxe({ inputCb: e, doc: t, mirror: n, blockClass: r, blockSelector: i, unblockSelector: o, ignoreClass: a, ignoreSelector: s, maskInputOptions: c, maskInputFn: l, sampling: u, userTriggeredOnInput: d, maskTextClass: f, unmaskTextClass: h, maskTextSelector: p, unmaskTextSelector: g }) {
  function m(x) {
    let C = ry(x);
    const E = x.isTrusted, R = C && SA(C.tagName);
    if (R === "OPTION" && (C = C.parentElement), !C || !R || wxe.indexOf(R) < 0 || ss(C, r, i, o, !0))
      return;
    const A = C;
    if (A.classList.contains(a) || s && A.matches(s))
      return;
    const O = HP(C);
    let $ = W_(A, R, O), N = !1;
    const z = kx({
      maskInputOptions: c,
      tagName: R,
      type: O
    }), k = xg(C, f, p, h, g, z);
    (O === "radio" || O === "checkbox") && (N = C.checked), $ = G0({
      isMasked: k,
      element: C,
      value: $,
      maskInputFn: l
    }), v(C, d ? { text: $, isChecked: N, userTriggered: E } : { text: $, isChecked: N });
    const F = C.name;
    O === "radio" && F && N && t.querySelectorAll(`input[type="radio"][name="${F}"]`).forEach((V) => {
      if (V !== C) {
        const j = G0({
          isMasked: k,
          element: V,
          value: W_(V, R, O),
          maskInputFn: l
        });
        v(V, d ? { text: j, isChecked: !N, userTriggered: !1 } : { text: j, isChecked: !N });
      }
    });
  }
  function v(x, C) {
    const E = r8.get(x);
    if (!E || E.text !== C.text || E.isChecked !== C.isChecked) {
      r8.set(x, C);
      const R = n.getId(x);
      In(e)({
        ...C,
        id: R
      });
    }
  }
  const S = (u.input === "last" ? ["change"] : ["input", "change"]).map((x) => Co(x, In(m), t)), _ = t.defaultView;
  if (!_)
    return () => {
      S.forEach((x) => x());
    };
  const w = _.Object.getOwnPropertyDescriptor(_.HTMLInputElement.prototype, "value"), T = [
    [_.HTMLInputElement.prototype, "value"],
    [_.HTMLInputElement.prototype, "checked"],
    [_.HTMLSelectElement.prototype, "value"],
    [_.HTMLTextAreaElement.prototype, "value"],
    [_.HTMLSelectElement.prototype, "selectedIndex"],
    [_.HTMLOptionElement.prototype, "selected"]
  ];
  return w && w.set && S.push(...T.map((x) => rK(x[0], x[1], {
    set() {
      In(m)({
        target: this,
        isTrusted: !1
      });
    }
  }, !1, _))), In(() => {
    S.forEach((x) => x());
  });
}
function K_(e) {
  const t = [];
  function n(r, i) {
    if (Mb("CSSGroupingRule") && r.parentRule instanceof CSSGroupingRule || Mb("CSSMediaRule") && r.parentRule instanceof CSSMediaRule || Mb("CSSSupportsRule") && r.parentRule instanceof CSSSupportsRule || Mb("CSSConditionRule") && r.parentRule instanceof CSSConditionRule) {
      const a = Array.from(r.parentRule.cssRules).indexOf(r);
      i.unshift(a);
    } else if (r.parentStyleSheet) {
      const a = Array.from(r.parentStyleSheet.cssRules).indexOf(r);
      i.unshift(a);
    }
    return i;
  }
  return n(e, t);
}
function kl(e, t, n) {
  let r, i;
  return e ? (e.ownerNode ? r = t.getId(e.ownerNode) : i = n.getId(e), {
    styleId: i,
    id: r
  }) : {};
}
function Exe({ styleSheetRuleCb: e, mirror: t, stylesheetManager: n }, { win: r }) {
  if (!r.CSSStyleSheet || !r.CSSStyleSheet.prototype)
    return () => {
    };
  const i = r.CSSStyleSheet.prototype.insertRule;
  r.CSSStyleSheet.prototype.insertRule = new Proxy(i, {
    apply: In((u, d, f) => {
      const [h, p] = f, { id: g, styleId: m } = kl(d, t, n.styleMirror);
      return (g && g !== -1 || m && m !== -1) && e({
        id: g,
        styleId: m,
        adds: [{ rule: h, index: p }]
      }), u.apply(d, f);
    })
  });
  const o = r.CSSStyleSheet.prototype.deleteRule;
  r.CSSStyleSheet.prototype.deleteRule = new Proxy(o, {
    apply: In((u, d, f) => {
      const [h] = f, { id: p, styleId: g } = kl(d, t, n.styleMirror);
      return (p && p !== -1 || g && g !== -1) && e({
        id: p,
        styleId: g,
        removes: [{ index: h }]
      }), u.apply(d, f);
    })
  });
  let a;
  r.CSSStyleSheet.prototype.replace && (a = r.CSSStyleSheet.prototype.replace, r.CSSStyleSheet.prototype.replace = new Proxy(a, {
    apply: In((u, d, f) => {
      const [h] = f, { id: p, styleId: g } = kl(d, t, n.styleMirror);
      return (p && p !== -1 || g && g !== -1) && e({
        id: p,
        styleId: g,
        replace: h
      }), u.apply(d, f);
    })
  }));
  let s;
  r.CSSStyleSheet.prototype.replaceSync && (s = r.CSSStyleSheet.prototype.replaceSync, r.CSSStyleSheet.prototype.replaceSync = new Proxy(s, {
    apply: In((u, d, f) => {
      const [h] = f, { id: p, styleId: g } = kl(d, t, n.styleMirror);
      return (p && p !== -1 || g && g !== -1) && e({
        id: p,
        styleId: g,
        replaceSync: h
      }), u.apply(d, f);
    })
  }));
  const c = {};
  kb("CSSGroupingRule") ? c.CSSGroupingRule = r.CSSGroupingRule : (kb("CSSMediaRule") && (c.CSSMediaRule = r.CSSMediaRule), kb("CSSConditionRule") && (c.CSSConditionRule = r.CSSConditionRule), kb("CSSSupportsRule") && (c.CSSSupportsRule = r.CSSSupportsRule));
  const l = {};
  return Object.entries(c).forEach(([u, d]) => {
    l[u] = {
      insertRule: d.prototype.insertRule,
      deleteRule: d.prototype.deleteRule
    }, d.prototype.insertRule = new Proxy(l[u].insertRule, {
      apply: In((f, h, p) => {
        const [g, m] = p, { id: v, styleId: y } = kl(h.parentStyleSheet, t, n.styleMirror);
        return (v && v !== -1 || y && y !== -1) && e({
          id: v,
          styleId: y,
          adds: [
            {
              rule: g,
              index: [
                ...K_(h),
                m || 0
              ]
            }
          ]
        }), f.apply(h, p);
      })
    }), d.prototype.deleteRule = new Proxy(l[u].deleteRule, {
      apply: In((f, h, p) => {
        const [g] = p, { id: m, styleId: v } = kl(h.parentStyleSheet, t, n.styleMirror);
        return (m && m !== -1 || v && v !== -1) && e({
          id: m,
          styleId: v,
          removes: [
            { index: [...K_(h), g] }
          ]
        }), f.apply(h, p);
      })
    });
  }), In(() => {
    r.CSSStyleSheet.prototype.insertRule = i, r.CSSStyleSheet.prototype.deleteRule = o, a && (r.CSSStyleSheet.prototype.replace = a), s && (r.CSSStyleSheet.prototype.replaceSync = s), Object.entries(c).forEach(([u, d]) => {
      d.prototype.insertRule = l[u].insertRule, d.prototype.deleteRule = l[u].deleteRule;
    });
  });
}
function vK({ mirror: e, stylesheetManager: t }, n) {
  let r = null;
  n.nodeName === "#document" ? r = e.getId(n) : r = e.getId(n.host);
  const i = n.nodeName === "#document" ? Ws([n, "access", (a) => a.defaultView, "optionalAccess", (a) => a.Document]) : Ws([n, "access", (a) => a.ownerDocument, "optionalAccess", (a) => a.defaultView, "optionalAccess", (a) => a.ShadowRoot]), o = Ws([i, "optionalAccess", (a) => a.prototype]) ? Object.getOwnPropertyDescriptor(Ws([i, "optionalAccess", (a) => a.prototype]), "adoptedStyleSheets") : void 0;
  return r === null || r === -1 || !i || !o ? () => {
  } : (Object.defineProperty(n, "adoptedStyleSheets", {
    configurable: o.configurable,
    enumerable: o.enumerable,
    get() {
      return Ws([o, "access", (a) => a.get, "optionalAccess", (a) => a.call, "call", (a) => a(this)]);
    },
    set(a) {
      const s = Ws([o, "access", (c) => c.set, "optionalAccess", (c) => c.call, "call", (c) => c(this, a)]);
      if (r !== null && r !== -1)
        try {
          t.adoptStyleSheets(a, r);
        } catch {
        }
      return s;
    }
  }), In(() => {
    Object.defineProperty(n, "adoptedStyleSheets", {
      configurable: o.configurable,
      enumerable: o.enumerable,
      get: o.get,
      set: o.set
    });
  }));
}
function Cxe({ styleDeclarationCb: e, mirror: t, ignoreCSSAttributes: n, stylesheetManager: r }, { win: i }) {
  const o = i.CSSStyleDeclaration.prototype.setProperty;
  i.CSSStyleDeclaration.prototype.setProperty = new Proxy(o, {
    apply: In((s, c, l) => {
      const [u, d, f] = l;
      if (n.has(u))
        return o.apply(c, [u, d, f]);
      const { id: h, styleId: p } = kl(Ws([c, "access", (g) => g.parentRule, "optionalAccess", (g) => g.parentStyleSheet]), t, r.styleMirror);
      return (h && h !== -1 || p && p !== -1) && e({
        id: h,
        styleId: p,
        set: {
          property: u,
          value: d,
          priority: f
        },
        index: K_(c.parentRule)
      }), s.apply(c, l);
    })
  });
  const a = i.CSSStyleDeclaration.prototype.removeProperty;
  return i.CSSStyleDeclaration.prototype.removeProperty = new Proxy(a, {
    apply: In((s, c, l) => {
      const [u] = l;
      if (n.has(u))
        return a.apply(c, [u]);
      const { id: d, styleId: f } = kl(Ws([c, "access", (h) => h.parentRule, "optionalAccess", (h) => h.parentStyleSheet]), t, r.styleMirror);
      return (d && d !== -1 || f && f !== -1) && e({
        id: d,
        styleId: f,
        remove: {
          property: u
        },
        index: K_(c.parentRule)
      }), s.apply(c, l);
    })
  }), In(() => {
    i.CSSStyleDeclaration.prototype.setProperty = o, i.CSSStyleDeclaration.prototype.removeProperty = a;
  });
}
function Txe({ mediaInteractionCb: e, blockClass: t, blockSelector: n, unblockSelector: r, mirror: i, sampling: o, doc: a }) {
  const s = In((l) => Y0(In((u) => {
    const d = ry(u);
    if (!d || ss(d, t, n, r, !0))
      return;
    const { currentTime: f, volume: h, muted: p, playbackRate: g } = d;
    e({
      type: l,
      id: i.getId(d),
      currentTime: f,
      volume: h,
      muted: p,
      playbackRate: g
    });
  }), o.media || 500)), c = [
    Co("play", s(0), a),
    Co("pause", s(1), a),
    Co("seeked", s(2), a),
    Co("volumechange", s(3), a),
    Co("ratechange", s(4), a)
  ];
  return In(() => {
    c.forEach((l) => l());
  });
}
function Ixe({ fontCb: e, doc: t }) {
  const n = t.defaultView;
  if (!n)
    return () => {
    };
  const r = [], i = /* @__PURE__ */ new WeakMap(), o = n.FontFace;
  n.FontFace = function(c, l, u) {
    const d = new o(c, l, u);
    return i.set(d, {
      family: c,
      buffer: typeof l != "string",
      descriptors: u,
      fontSource: typeof l == "string" ? l : JSON.stringify(Array.from(new Uint8Array(l)))
    }), d;
  };
  const a = qP(t.fonts, "add", function(s) {
    return function(c) {
      return Nx(In(() => {
        const l = i.get(c);
        l && (e(l), i.delete(c));
      }), 0), s.apply(this, [c]);
    };
  });
  return r.push(() => {
    n.FontFace = o;
  }), r.push(a), In(() => {
    r.forEach((s) => s());
  });
}
function Axe(e) {
  const { doc: t, mirror: n, blockClass: r, blockSelector: i, unblockSelector: o, selectionCb: a } = e;
  let s = !0;
  const c = In(() => {
    const l = t.getSelection();
    if (!l || s && Ws([l, "optionalAccess", (f) => f.isCollapsed]))
      return;
    s = l.isCollapsed || !1;
    const u = [], d = l.rangeCount || 0;
    for (let f = 0; f < d; f++) {
      const h = l.getRangeAt(f), { startContainer: p, startOffset: g, endContainer: m, endOffset: v } = h;
      ss(p, r, i, o, !0) || ss(m, r, i, o, !0) || u.push({
        start: n.getId(p),
        startOffset: g,
        end: n.getId(m),
        endOffset: v
      });
    }
    a({ ranges: u });
  });
  return c(), Co("selectionchange", c);
}
function Rxe({ doc: e, customElementCb: t }) {
  const n = e.defaultView;
  return !n || !n.customElements ? () => {
  } : qP(n.customElements, "define", function(i) {
    return function(o, a, s) {
      try {
        t({
          define: {
            name: o
          }
        });
      } catch {
      }
      return i.apply(this, [o, a, s]);
    };
  });
}
function $xe(e, t = {}) {
  const n = e.doc.defaultView;
  if (!n)
    return () => {
    };
  const r = pK(e, e.doc), i = bxe(e), o = _xe(e), a = mK(e), s = Sxe(e, {
    win: n
  }), c = xxe(e), l = Txe(e), u = Exe(e, { win: n }), d = vK(e, e.doc), f = Cxe(e, {
    win: n
  }), h = e.collectFonts ? Ixe(e) : () => {
  }, p = Axe(e), g = Rxe(e), m = [];
  for (const v of e.plugins)
    m.push(v.observer(v.callback, n, v.options));
  return In(() => {
    Mh.forEach((v) => v.reset()), r.disconnect(), i(), o(), a(), s(), c(), l(), u(), d(), f(), h(), p(), g(), m.forEach((v) => v());
  });
}
function Mb(e) {
  return typeof window[e] < "u";
}
function kb(e) {
  return !!(typeof window[e] < "u" && window[e].prototype && "insertRule" in window[e].prototype && "deleteRule" in window[e].prototype);
}
class CA {
  constructor(t) {
    this.generateIdFn = t, this.iframeIdToRemoteIdMap = /* @__PURE__ */ new WeakMap(), this.iframeRemoteIdToIdMap = /* @__PURE__ */ new WeakMap();
  }
  getId(t, n, r, i) {
    const o = r || this.getIdToRemoteIdMap(t), a = i || this.getRemoteIdToIdMap(t);
    let s = o.get(n);
    return s || (s = this.generateIdFn(), o.set(n, s), a.set(s, n)), s;
  }
  getIds(t, n) {
    const r = this.getIdToRemoteIdMap(t), i = this.getRemoteIdToIdMap(t);
    return n.map((o) => this.getId(t, o, r, i));
  }
  getRemoteId(t, n, r) {
    const i = r || this.getRemoteIdToIdMap(t);
    if (typeof n != "number")
      return n;
    const o = i.get(n);
    return o || -1;
  }
  getRemoteIds(t, n) {
    const r = this.getRemoteIdToIdMap(t);
    return n.map((i) => this.getRemoteId(t, i, r));
  }
  reset(t) {
    if (!t) {
      this.iframeIdToRemoteIdMap = /* @__PURE__ */ new WeakMap(), this.iframeRemoteIdToIdMap = /* @__PURE__ */ new WeakMap();
      return;
    }
    this.iframeIdToRemoteIdMap.delete(t), this.iframeRemoteIdToIdMap.delete(t);
  }
  getIdToRemoteIdMap(t) {
    let n = this.iframeIdToRemoteIdMap.get(t);
    return n || (n = /* @__PURE__ */ new Map(), this.iframeIdToRemoteIdMap.set(t, n)), n;
  }
  getRemoteIdToIdMap(t) {
    let n = this.iframeRemoteIdToIdMap.get(t);
    return n || (n = /* @__PURE__ */ new Map(), this.iframeRemoteIdToIdMap.set(t, n)), n;
  }
}
function i8(e) {
  let t, n = e[0], r = 1;
  for (; r < e.length; ) {
    const i = e[r], o = e[r + 1];
    if (r += 2, (i === "optionalAccess" || i === "optionalCall") && n == null)
      return;
    i === "access" || i === "optionalAccess" ? (t = n, n = o(n)) : (i === "call" || i === "optionalCall") && (n = o((...a) => n.call(t, ...a)), t = void 0);
  }
  return n;
}
class Oxe {
  constructor() {
    this.crossOriginIframeMirror = new CA(UP), this.crossOriginIframeRootIdMap = /* @__PURE__ */ new WeakMap();
  }
  addIframe() {
  }
  addLoadListener() {
  }
  attachIframe() {
  }
}
class Pxe {
  constructor(t) {
    this.iframes = /* @__PURE__ */ new WeakMap(), this.crossOriginIframeMap = /* @__PURE__ */ new WeakMap(), this.crossOriginIframeMirror = new CA(UP), this.crossOriginIframeRootIdMap = /* @__PURE__ */ new WeakMap(), this.mutationCb = t.mutationCb, this.wrappedEmit = t.wrappedEmit, this.stylesheetManager = t.stylesheetManager, this.recordCrossOriginIframes = t.recordCrossOriginIframes, this.crossOriginIframeStyleMirror = new CA(this.stylesheetManager.styleMirror.generateId.bind(this.stylesheetManager.styleMirror)), this.mirror = t.mirror, this.recordCrossOriginIframes && window.addEventListener("message", this.handleMessage.bind(this));
  }
  addIframe(t) {
    this.iframes.set(t, !0), t.contentWindow && this.crossOriginIframeMap.set(t.contentWindow, t);
  }
  addLoadListener(t) {
    this.loadListener = t;
  }
  attachIframe(t, n) {
    this.mutationCb({
      adds: [
        {
          parentId: this.mirror.getId(t),
          nextId: null,
          node: n
        }
      ],
      removes: [],
      texts: [],
      attributes: [],
      isAttachIframe: !0
    }), i8([this, "access", (r) => r.loadListener, "optionalCall", (r) => r(t)]), t.contentDocument && t.contentDocument.adoptedStyleSheets && t.contentDocument.adoptedStyleSheets.length > 0 && this.stylesheetManager.adoptStyleSheets(t.contentDocument.adoptedStyleSheets, this.mirror.getId(t.contentDocument));
  }
  handleMessage(t) {
    const n = t;
    if (n.data.type !== "rrweb" || n.origin !== n.data.origin || !t.source)
      return;
    const i = this.crossOriginIframeMap.get(t.source);
    if (!i)
      return;
    const o = this.transformCrossOriginEvent(i, n.data.event);
    o && this.wrappedEmit(o, n.data.isCheckout);
  }
  transformCrossOriginEvent(t, n) {
    switch (n.type) {
      case dn.FullSnapshot: {
        this.crossOriginIframeMirror.reset(t), this.crossOriginIframeStyleMirror.reset(t), this.replaceIdOnNode(n.data.node, t);
        const r = n.data.node.id;
        return this.crossOriginIframeRootIdMap.set(t, r), this.patchRootIdOnNode(n.data.node, r), {
          timestamp: n.timestamp,
          type: dn.IncrementalSnapshot,
          data: {
            source: fn.Mutation,
            adds: [
              {
                parentId: this.mirror.getId(t),
                nextId: null,
                node: n.data.node
              }
            ],
            removes: [],
            texts: [],
            attributes: [],
            isAttachIframe: !0
          }
        };
      }
      case dn.Meta:
      case dn.Load:
      case dn.DomContentLoaded:
        return !1;
      case dn.Plugin:
        return n;
      case dn.Custom:
        return this.replaceIds(n.data.payload, t, ["id", "parentId", "previousId", "nextId"]), n;
      case dn.IncrementalSnapshot:
        switch (n.data.source) {
          case fn.Mutation:
            return n.data.adds.forEach((r) => {
              this.replaceIds(r, t, [
                "parentId",
                "nextId",
                "previousId"
              ]), this.replaceIdOnNode(r.node, t);
              const i = this.crossOriginIframeRootIdMap.get(t);
              i && this.patchRootIdOnNode(r.node, i);
            }), n.data.removes.forEach((r) => {
              this.replaceIds(r, t, ["parentId", "id"]);
            }), n.data.attributes.forEach((r) => {
              this.replaceIds(r, t, ["id"]);
            }), n.data.texts.forEach((r) => {
              this.replaceIds(r, t, ["id"]);
            }), n;
          case fn.Drag:
          case fn.TouchMove:
          case fn.MouseMove:
            return n.data.positions.forEach((r) => {
              this.replaceIds(r, t, ["id"]);
            }), n;
          case fn.ViewportResize:
            return !1;
          case fn.MediaInteraction:
          case fn.MouseInteraction:
          case fn.Scroll:
          case fn.CanvasMutation:
          case fn.Input:
            return this.replaceIds(n.data, t, ["id"]), n;
          case fn.StyleSheetRule:
          case fn.StyleDeclaration:
            return this.replaceIds(n.data, t, ["id"]), this.replaceStyleIds(n.data, t, ["styleId"]), n;
          case fn.Font:
            return n;
          case fn.Selection:
            return n.data.ranges.forEach((r) => {
              this.replaceIds(r, t, ["start", "end"]);
            }), n;
          case fn.AdoptedStyleSheet:
            return this.replaceIds(n.data, t, ["id"]), this.replaceStyleIds(n.data, t, ["styleIds"]), i8([n, "access", (r) => r.data, "access", (r) => r.styles, "optionalAccess", (r) => r.forEach, "call", (r) => r((i) => {
              this.replaceStyleIds(i, t, ["styleId"]);
            })]), n;
        }
    }
    return !1;
  }
  replace(t, n, r, i) {
    for (const o of i)
      !Array.isArray(n[o]) && typeof n[o] != "number" || (Array.isArray(n[o]) ? n[o] = t.getIds(r, n[o]) : n[o] = t.getId(r, n[o]));
    return n;
  }
  replaceIds(t, n, r) {
    return this.replace(this.crossOriginIframeMirror, t, n, r);
  }
  replaceStyleIds(t, n, r) {
    return this.replace(this.crossOriginIframeStyleMirror, t, n, r);
  }
  replaceIdOnNode(t, n) {
    this.replaceIds(t, n, ["id", "rootId"]), "childNodes" in t && t.childNodes.forEach((r) => {
      this.replaceIdOnNode(r, n);
    });
  }
  patchRootIdOnNode(t, n) {
    t.type !== yi.Document && !t.rootId && (t.rootId = n), "childNodes" in t && t.childNodes.forEach((r) => {
      this.patchRootIdOnNode(r, n);
    });
  }
}
class Mxe {
  init() {
  }
  addShadowRoot() {
  }
  observeAttachShadow() {
  }
  reset() {
  }
}
class kxe {
  constructor(t) {
    this.shadowDoms = /* @__PURE__ */ new WeakSet(), this.restoreHandlers = [], this.mutationCb = t.mutationCb, this.scrollCb = t.scrollCb, this.bypassOptions = t.bypassOptions, this.mirror = t.mirror, this.init();
  }
  init() {
    this.reset(), this.patchAttachShadow(Element, document);
  }
  addShadowRoot(t, n) {
    if (!g0(t) || this.shadowDoms.has(t))
      return;
    this.shadowDoms.add(t);
    const r = pK({
      ...this.bypassOptions,
      doc: n,
      mutationCb: this.mutationCb,
      mirror: this.mirror,
      shadowDomManager: this
    }, t);
    this.restoreHandlers.push(() => r.disconnect()), this.restoreHandlers.push(mK({
      ...this.bypassOptions,
      scrollCb: this.scrollCb,
      doc: t,
      mirror: this.mirror
    })), Nx(() => {
      t.adoptedStyleSheets && t.adoptedStyleSheets.length > 0 && this.bypassOptions.stylesheetManager.adoptStyleSheets(t.adoptedStyleSheets, this.mirror.getId(t.host)), this.restoreHandlers.push(vK({
        mirror: this.mirror,
        stylesheetManager: this.bypassOptions.stylesheetManager
      }, t));
    }, 0);
  }
  observeAttachShadow(t) {
    !t.contentWindow || !t.contentDocument || this.patchAttachShadow(t.contentWindow.Element, t.contentDocument);
  }
  patchAttachShadow(t, n) {
    const r = this;
    this.restoreHandlers.push(qP(t.prototype, "attachShadow", function(i) {
      return function(o) {
        const a = i.call(this, o);
        return this.shadowRoot && fK(this) && r.addShadowRoot(this.shadowRoot, n), a;
      };
    }));
  }
  reset() {
    this.restoreHandlers.forEach((t) => {
      try {
        t();
      } catch {
      }
    }), this.restoreHandlers = [], this.shadowDoms = /* @__PURE__ */ new WeakSet();
  }
}
class o8 {
  reset() {
  }
  freeze() {
  }
  unfreeze() {
  }
  lock() {
  }
  unlock() {
  }
  snapshot() {
  }
}
class Nxe {
  constructor(t) {
    this.trackedLinkElements = /* @__PURE__ */ new WeakSet(), this.styleMirror = new lxe(), this.mutationCb = t.mutationCb, this.adoptedStyleSheetCb = t.adoptedStyleSheetCb;
  }
  attachLinkElement(t, n) {
    "_cssText" in n.attributes && this.mutationCb({
      adds: [],
      removes: [],
      texts: [],
      attributes: [
        {
          id: n.id,
          attributes: n.attributes
        }
      ]
    }), this.trackLinkElement(t);
  }
  trackLinkElement(t) {
    this.trackedLinkElements.has(t) || (this.trackedLinkElements.add(t), this.trackStylesheetInLinkElement(t));
  }
  adoptStyleSheets(t, n) {
    if (t.length === 0)
      return;
    const r = {
      id: n,
      styleIds: []
    }, i = [];
    for (const o of t) {
      let a;
      this.styleMirror.has(o) ? a = this.styleMirror.getId(o) : (a = this.styleMirror.add(o), i.push({
        styleId: a,
        rules: Array.from(o.rules || CSSRule, (s, c) => ({
          rule: ZG(s),
          index: c
        }))
      })), r.styleIds.push(a);
    }
    i.length > 0 && (r.styles = i), this.adoptedStyleSheetCb(r);
  }
  reset() {
    this.styleMirror.reset(), this.trackedLinkElements = /* @__PURE__ */ new WeakSet();
  }
  trackStylesheetInLinkElement(t) {
  }
}
class Dxe {
  constructor() {
    this.nodeMap = /* @__PURE__ */ new WeakMap(), this.loop = !0, this.periodicallyClear();
  }
  periodicallyClear() {
    fxe(() => {
      this.clear(), this.loop && this.periodicallyClear();
    });
  }
  inOtherBuffer(t, n) {
    const r = this.nodeMap.get(t);
    return r && Array.from(r).some((i) => i !== n);
  }
  add(t, n) {
    this.nodeMap.set(t, (this.nodeMap.get(t) || /* @__PURE__ */ new Set()).add(n));
  }
  clear() {
    this.nodeMap = /* @__PURE__ */ new WeakMap();
  }
  destroy() {
    this.loop = !1;
  }
}
let Br, Y_;
const ts = Lwe();
function su(e = {}) {
  const { emit: t, checkoutEveryNms: n, checkoutEveryNth: r, blockClass: i = "rr-block", blockSelector: o = null, unblockSelector: a = null, ignoreClass: s = "rr-ignore", ignoreSelector: c = null, maskAllText: l = !1, maskTextClass: u = "rr-mask", unmaskTextClass: d = null, maskTextSelector: f = null, unmaskTextSelector: h = null, inlineStylesheet: p = !0, maskAllInputs: g, maskInputOptions: m, slimDOMOptions: v, maskAttributeFn: y, maskInputFn: S, maskTextFn: _, maxCanvasSize: w = null, packFn: T, sampling: x = {}, dataURLOptions: C = {}, mousemoveWait: E, recordCanvas: R = !1, recordCrossOriginIframes: A = !1, recordAfter: O = e.recordAfter === "DOMContentLoaded" ? e.recordAfter : "load", userTriggeredOnInput: $ = !1, collectFonts: N = !1, inlineImages: z = !1, plugins: k, keepIframeSrcFn: F = () => !1, ignoreCSSAttributes: V = /* @__PURE__ */ new Set([]), errorHandler: j, onMutation: B, getCanvasManager: U } = e;
  vxe(j);
  const Q = A ? window.parent === window : !0;
  let K = !1;
  if (!Q)
    try {
      window.parent.document && (K = !1);
    } catch {
      K = !0;
    }
  if (Q && !t)
    throw new Error("emit function is required");
  E !== void 0 && x.mousemove === void 0 && (x.mousemove = E), ts.reset();
  const q = g === !0 ? {
    color: !0,
    date: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0,
    textarea: !0,
    select: !0,
    radio: !0,
    checkbox: !0
  } : m !== void 0 ? m : {}, X = v === !0 || v === "all" ? {
    script: !0,
    comment: !0,
    headFavicon: !0,
    headWhitespace: !0,
    headMetaSocial: !0,
    headMetaRobots: !0,
    headMetaHttpEquiv: !0,
    headMetaVerification: !0,
    headMetaAuthorship: v === "all",
    headMetaDescKeywords: v === "all"
  } : v || {};
  cxe();
  let ie, te = 0;
  const J = (ue) => {
    for (const Ee of k || [])
      Ee.eventProcessor && (ue = Ee.eventProcessor(ue));
    return T && !K && (ue = T(ue)), ue;
  };
  Br = (ue, Ee) => {
    const pe = ue;
    if (pe.timestamp = G_(), u5([Mh, "access", (Oe) => Oe[0], "optionalAccess", (Oe) => Oe.isFrozen, "call", (Oe) => Oe()]) && pe.type !== dn.FullSnapshot && !(pe.type === dn.IncrementalSnapshot && pe.data.source === fn.Mutation) && Mh.forEach((Oe) => Oe.unfreeze()), Q)
      u5([t, "optionalCall", (Oe) => Oe(J(pe), Ee)]);
    else if (K) {
      const Oe = {
        type: "rrweb",
        event: J(pe),
        origin: window.location.origin,
        isCheckout: Ee
      };
      window.parent.postMessage(Oe, "*");
    }
    if (pe.type === dn.FullSnapshot)
      ie = pe, te = 0;
    else if (pe.type === dn.IncrementalSnapshot) {
      if (pe.data.source === fn.Mutation && pe.data.isAttachIframe)
        return;
      te++;
      const Oe = r && te >= r, de = n && ie && pe.timestamp - ie.timestamp > n;
      (Oe || de) && he(!0);
    }
  };
  const Y = (ue) => {
    Br({
      type: dn.IncrementalSnapshot,
      data: {
        source: fn.Mutation,
        ...ue
      }
    });
  }, ee = (ue) => Br({
    type: dn.IncrementalSnapshot,
    data: {
      source: fn.Scroll,
      ...ue
    }
  }), Z = (ue) => Br({
    type: dn.IncrementalSnapshot,
    data: {
      source: fn.CanvasMutation,
      ...ue
    }
  }), H = (ue) => Br({
    type: dn.IncrementalSnapshot,
    data: {
      source: fn.AdoptedStyleSheet,
      ...ue
    }
  }), oe = new Nxe({
    mutationCb: Y,
    adoptedStyleSheetCb: H
  }), W = typeof __RRWEB_EXCLUDE_IFRAME__ == "boolean" && __RRWEB_EXCLUDE_IFRAME__ ? new Oxe() : new Pxe({
    mirror: ts,
    mutationCb: Y,
    stylesheetManager: oe,
    recordCrossOriginIframes: A,
    wrappedEmit: Br
  });
  for (const ue of k || [])
    ue.getMirror && ue.getMirror({
      nodeMirror: ts,
      crossOriginIframeMirror: W.crossOriginIframeMirror,
      crossOriginIframeStyleMirror: W.crossOriginIframeStyleMirror
    });
  const se = new Dxe(), ce = jxe(U, {
    mirror: ts,
    win: window,
    mutationCb: (ue) => Br({
      type: dn.IncrementalSnapshot,
      data: {
        source: fn.CanvasMutation,
        ...ue
      }
    }),
    recordCanvas: R,
    blockClass: i,
    blockSelector: o,
    unblockSelector: a,
    maxCanvasSize: w,
    sampling: x.canvas,
    dataURLOptions: C,
    errorHandler: j
  }), ge = typeof __RRWEB_EXCLUDE_SHADOW_DOM__ == "boolean" && __RRWEB_EXCLUDE_SHADOW_DOM__ ? new Mxe() : new kxe({
    mutationCb: Y,
    scrollCb: ee,
    bypassOptions: {
      onMutation: B,
      blockClass: i,
      blockSelector: o,
      unblockSelector: a,
      maskAllText: l,
      maskTextClass: u,
      unmaskTextClass: d,
      maskTextSelector: f,
      unmaskTextSelector: h,
      inlineStylesheet: p,
      maskInputOptions: q,
      dataURLOptions: C,
      maskAttributeFn: y,
      maskTextFn: _,
      maskInputFn: S,
      recordCanvas: R,
      inlineImages: z,
      sampling: x,
      slimDOMOptions: X,
      iframeManager: W,
      stylesheetManager: oe,
      canvasManager: ce,
      keepIframeSrcFn: F,
      processedNodeManager: se
    },
    mirror: ts
  }), he = (ue = !1) => {
    Br({
      type: dn.Meta,
      data: {
        href: window.location.href,
        width: aK(),
        height: oK()
      }
    }, ue), oe.reset(), ge.init(), Mh.forEach((pe) => pe.lock());
    const Ee = axe(document, {
      mirror: ts,
      blockClass: i,
      blockSelector: o,
      unblockSelector: a,
      maskAllText: l,
      maskTextClass: u,
      unmaskTextClass: d,
      maskTextSelector: f,
      unmaskTextSelector: h,
      inlineStylesheet: p,
      maskAllInputs: q,
      maskAttributeFn: y,
      maskInputFn: S,
      maskTextFn: _,
      slimDOM: X,
      dataURLOptions: C,
      recordCanvas: R,
      inlineImages: z,
      onSerialize: (pe) => {
        lK(pe, ts) && W.addIframe(pe), uK(pe, ts) && oe.trackLinkElement(pe), xA(pe) && ge.addShadowRoot(pe.shadowRoot, document);
      },
      onIframeLoad: (pe, Oe) => {
        W.attachIframe(pe, Oe), ge.observeAttachShadow(pe);
      },
      onStylesheetLoad: (pe, Oe) => {
        oe.attachLinkElement(pe, Oe);
      },
      keepIframeSrcFn: F
    });
    if (!Ee)
      return console.warn("Failed to snapshot the document");
    Br({
      type: dn.FullSnapshot,
      data: {
        node: Ee,
        initialOffset: iK(window)
      }
    }), Mh.forEach((pe) => pe.unlock()), document.adoptedStyleSheets && document.adoptedStyleSheets.length > 0 && oe.adoptStyleSheets(document.adoptedStyleSheets, ts.getId(document));
  };
  Y_ = he;
  try {
    const ue = [], Ee = (Oe) => In($xe)({
      onMutation: B,
      mutationCb: Y,
      mousemoveCb: (de, be) => Br({
        type: dn.IncrementalSnapshot,
        data: {
          source: be,
          positions: de
        }
      }),
      mouseInteractionCb: (de) => Br({
        type: dn.IncrementalSnapshot,
        data: {
          source: fn.MouseInteraction,
          ...de
        }
      }),
      scrollCb: ee,
      viewportResizeCb: (de) => Br({
        type: dn.IncrementalSnapshot,
        data: {
          source: fn.ViewportResize,
          ...de
        }
      }),
      inputCb: (de) => Br({
        type: dn.IncrementalSnapshot,
        data: {
          source: fn.Input,
          ...de
        }
      }),
      mediaInteractionCb: (de) => Br({
        type: dn.IncrementalSnapshot,
        data: {
          source: fn.MediaInteraction,
          ...de
        }
      }),
      styleSheetRuleCb: (de) => Br({
        type: dn.IncrementalSnapshot,
        data: {
          source: fn.StyleSheetRule,
          ...de
        }
      }),
      styleDeclarationCb: (de) => Br({
        type: dn.IncrementalSnapshot,
        data: {
          source: fn.StyleDeclaration,
          ...de
        }
      }),
      canvasMutationCb: Z,
      fontCb: (de) => Br({
        type: dn.IncrementalSnapshot,
        data: {
          source: fn.Font,
          ...de
        }
      }),
      selectionCb: (de) => {
        Br({
          type: dn.IncrementalSnapshot,
          data: {
            source: fn.Selection,
            ...de
          }
        });
      },
      customElementCb: (de) => {
        Br({
          type: dn.IncrementalSnapshot,
          data: {
            source: fn.CustomElement,
            ...de
          }
        });
      },
      blockClass: i,
      ignoreClass: s,
      ignoreSelector: c,
      maskAllText: l,
      maskTextClass: u,
      unmaskTextClass: d,
      maskTextSelector: f,
      unmaskTextSelector: h,
      maskInputOptions: q,
      inlineStylesheet: p,
      sampling: x,
      recordCanvas: R,
      inlineImages: z,
      userTriggeredOnInput: $,
      collectFonts: N,
      doc: Oe,
      maskAttributeFn: y,
      maskInputFn: S,
      maskTextFn: _,
      keepIframeSrcFn: F,
      blockSelector: o,
      unblockSelector: a,
      slimDOMOptions: X,
      dataURLOptions: C,
      mirror: ts,
      iframeManager: W,
      stylesheetManager: oe,
      shadowDomManager: ge,
      processedNodeManager: se,
      canvasManager: ce,
      ignoreCSSAttributes: V,
      plugins: u5([
        k,
        "optionalAccess",
        (de) => de.filter,
        "call",
        (de) => de((be) => be.observer),
        "optionalAccess",
        (de) => de.map,
        "call",
        (de) => de((be) => ({
          observer: be.observer,
          options: be.options,
          callback: (Ie) => Br({
            type: dn.Plugin,
            data: {
              plugin: be.name,
              payload: Ie
            }
          })
        }))
      ]) || []
    }, {});
    W.addLoadListener((Oe) => {
      try {
        ue.push(Ee(Oe.contentDocument));
      } catch (de) {
        console.warn(de);
      }
    });
    const pe = () => {
      he(), ue.push(Ee(document));
    };
    return document.readyState === "interactive" || document.readyState === "complete" ? pe() : (ue.push(Co("DOMContentLoaded", () => {
      Br({
        type: dn.DomContentLoaded,
        data: {}
      }), O === "DOMContentLoaded" && pe();
    })), ue.push(Co("load", () => {
      Br({
        type: dn.Load,
        data: {}
      }), O === "load" && pe();
    }, window))), () => {
      ue.forEach((Oe) => Oe()), se.destroy(), Y_ = void 0, yxe();
    };
  } catch (ue) {
    console.warn(ue);
  }
}
function Lxe(e) {
  if (!Y_)
    throw new Error("please take full snapshot after start recording");
  Y_(e);
}
su.mirror = ts;
su.takeFullSnapshot = Lxe;
function jxe(e, t) {
  try {
    return e ? e(t) : new o8();
  } catch {
    return console.warn("Unable to initialize CanvasManager"), new o8();
  }
}
const Fxe = 3, Vxe = 5;
function KP(e) {
  return e > 9999999999 ? e : e * 1e3;
}
function y5(e) {
  return e > 9999999999 ? e / 1e3 : e;
}
function iy(e, t) {
  t.category !== "sentry.transaction" && (["ui.click", "ui.input"].includes(t.category) ? e.triggerUserActivity() : e.checkAndHandleExpiredSession(), e.addUpdate(() => (e.throttledAddEvent({
    type: dn.Custom,
    // TODO: We were converting from ms to seconds for breadcrumbs, spans,
    // but maybe we should just keep them as milliseconds
    timestamp: (t.timestamp || 0) * 1e3,
    data: {
      tag: "breadcrumb",
      // normalize to max. 10 depth and 1_000 properties per object
      payload: Us(t, 10, 1e3)
    }
  }), t.category === "console")));
}
const Bxe = "button,a";
function yK(e) {
  return e.closest(Bxe) || e;
}
function bK(e) {
  const t = _K(e);
  return !t || !(t instanceof Element) ? t : yK(t);
}
function _K(e) {
  return zxe(e) ? e.target : e;
}
function zxe(e) {
  return typeof e == "object" && !!e && "target" in e;
}
let Nl;
function Hxe(e) {
  return Nl || (Nl = [], Uxe()), Nl.push(e), () => {
    const t = Nl ? Nl.indexOf(e) : -1;
    t > -1 && Nl.splice(t, 1);
  };
}
function Uxe() {
  Oi(ur, "open", function(e) {
    return function(...t) {
      if (Nl)
        try {
          Nl.forEach((n) => n());
        } catch {
        }
      return e.apply(ur, t);
    };
  });
}
function Wxe(e, t, n) {
  e.handleClick(t, n);
}
class qxe {
  // protected for testing
  constructor(t, n, r = iy) {
    this._lastMutation = 0, this._lastScroll = 0, this._clicks = [], this._timeout = n.timeout / 1e3, this._threshold = n.threshold / 1e3, this._scollTimeout = n.scrollTimeout / 1e3, this._replay = t, this._ignoreSelector = n.ignoreSelector, this._addBreadcrumbEvent = r;
  }
  /** Register click detection handlers on mutation or scroll. */
  addListeners() {
    const t = Hxe(() => {
      this._lastMutation = a8();
    });
    this._teardown = () => {
      t(), this._clicks = [], this._lastMutation = 0, this._lastScroll = 0;
    };
  }
  /** Clean up listeners. */
  removeListeners() {
    this._teardown && this._teardown(), this._checkClickTimeout && clearTimeout(this._checkClickTimeout);
  }
  /** @inheritDoc */
  handleClick(t, n) {
    if (Kxe(n, this._ignoreSelector) || !Yxe(t))
      return;
    const r = {
      timestamp: y5(t.timestamp),
      clickBreadcrumb: t,
      // Set this to 0 so we know it originates from the click breadcrumb
      clickCount: 0,
      node: n
    };
    this._clicks.some((i) => i.node === r.node && Math.abs(i.timestamp - r.timestamp) < 1) || (this._clicks.push(r), this._clicks.length === 1 && this._scheduleCheckClicks());
  }
  /** @inheritDoc */
  registerMutation(t = Date.now()) {
    this._lastMutation = y5(t);
  }
  /** @inheritDoc */
  registerScroll(t = Date.now()) {
    this._lastScroll = y5(t);
  }
  /** @inheritDoc */
  registerClick(t) {
    const n = yK(t);
    this._handleMultiClick(n);
  }
  /** Count multiple clicks on elements. */
  _handleMultiClick(t) {
    this._getClicks(t).forEach((n) => {
      n.clickCount++;
    });
  }
  /** Get all pending clicks for a given node. */
  _getClicks(t) {
    return this._clicks.filter((n) => n.node === t);
  }
  /** Check the clicks that happened. */
  _checkClicks() {
    const t = [], n = a8();
    this._clicks.forEach((r) => {
      !r.mutationAfter && this._lastMutation && (r.mutationAfter = r.timestamp <= this._lastMutation ? this._lastMutation - r.timestamp : void 0), !r.scrollAfter && this._lastScroll && (r.scrollAfter = r.timestamp <= this._lastScroll ? this._lastScroll - r.timestamp : void 0), r.timestamp + this._timeout <= n && t.push(r);
    });
    for (const r of t) {
      const i = this._clicks.indexOf(r);
      i > -1 && (this._generateBreadcrumbs(r), this._clicks.splice(i, 1));
    }
    this._clicks.length && this._scheduleCheckClicks();
  }
  /** Generate matching breadcrumb(s) for the click. */
  _generateBreadcrumbs(t) {
    const n = this._replay, r = t.scrollAfter && t.scrollAfter <= this._scollTimeout, i = t.mutationAfter && t.mutationAfter <= this._threshold, o = !r && !i, { clickCount: a, clickBreadcrumb: s } = t;
    if (o) {
      const c = Math.min(t.mutationAfter || this._timeout, this._timeout) * 1e3, l = c < this._timeout * 1e3 ? "mutation" : "timeout", u = {
        type: "default",
        message: s.message,
        timestamp: s.timestamp,
        category: "ui.slowClickDetected",
        data: {
          ...s.data,
          url: ur.location.href,
          route: n.getCurrentRoute(),
          timeAfterClickMs: c,
          endReason: l,
          // If clickCount === 0, it means multiClick was not correctly captured here
          // - we still want to send 1 in this case
          clickCount: a || 1
        }
      };
      this._addBreadcrumbEvent(n, u);
      return;
    }
    if (a > 1) {
      const c = {
        type: "default",
        message: s.message,
        timestamp: s.timestamp,
        category: "ui.multiClick",
        data: {
          ...s.data,
          url: ur.location.href,
          route: n.getCurrentRoute(),
          clickCount: a,
          metric: !0
        }
      };
      this._addBreadcrumbEvent(n, c);
    }
  }
  /** Schedule to check current clicks. */
  _scheduleCheckClicks() {
    this._checkClickTimeout && clearTimeout(this._checkClickTimeout), this._checkClickTimeout = setTimeout(() => this._checkClicks(), 1e3);
  }
}
const Gxe = ["A", "BUTTON", "INPUT"];
function Kxe(e, t) {
  return !!(!Gxe.includes(e.tagName) || e.tagName === "INPUT" && !["submit", "button"].includes(e.getAttribute("type") || "") || e.tagName === "A" && (e.hasAttribute("download") || e.hasAttribute("target") && e.getAttribute("target") !== "_self") || t && e.matches(t));
}
function Yxe(e) {
  return !!(e.data && typeof e.data.nodeId == "number" && e.timestamp);
}
function a8() {
  return Date.now() / 1e3;
}
function Xxe(e, t) {
  try {
    if (!Qxe(t))
      return;
    const { source: n } = t.data;
    if (n === fn.Mutation && e.registerMutation(t.timestamp), n === fn.Scroll && e.registerScroll(t.timestamp), Jxe(t)) {
      const { type: r, id: i } = t.data, o = su.mirror.getNode(i);
      o instanceof HTMLElement && r === So.Click && e.registerClick(o);
    }
  } catch {
  }
}
function Qxe(e) {
  return e.type === Fxe;
}
function Jxe(e) {
  return e.data.source === fn.MouseInteraction;
}
function Ks(e) {
  return {
    timestamp: Date.now() / 1e3,
    type: "default",
    ...e
  };
}
var X_;
(function(e) {
  e[e.Document = 0] = "Document", e[e.DocumentType = 1] = "DocumentType", e[e.Element = 2] = "Element", e[e.Text = 3] = "Text", e[e.CDATA = 4] = "CDATA", e[e.Comment = 5] = "Comment";
})(X_ || (X_ = {}));
const Zxe = /* @__PURE__ */ new Set([
  "id",
  "class",
  "aria-label",
  "role",
  "name",
  "alt",
  "title",
  "data-test-id",
  "data-testid",
  "disabled",
  "aria-disabled",
  "data-sentry-component"
]);
function eEe(e) {
  const t = {};
  for (const n in e)
    if (Zxe.has(n)) {
      let r = n;
      (n === "data-testid" || n === "data-test-id") && (r = "testId"), t[r] = e[n];
    }
  return t;
}
const tEe = (e) => (t) => {
  if (!e.isEnabled())
    return;
  const n = nEe(t);
  if (!n)
    return;
  const r = t.name === "click", i = r ? t.event : void 0;
  r && e.clickDetector && i && i.target && !i.altKey && !i.metaKey && !i.ctrlKey && !i.shiftKey && Wxe(
    e.clickDetector,
    n,
    bK(t.event)
  ), iy(e, n);
};
function SK(e, t) {
  const n = su.mirror.getId(e), r = n && su.mirror.getNode(n), i = r && su.mirror.getMeta(r), o = i && iEe(i) ? i : null;
  return {
    message: t,
    data: o ? {
      nodeId: n,
      node: {
        id: n,
        tagName: o.tagName,
        textContent: Array.from(o.childNodes).map((a) => a.type === X_.Text && a.textContent).filter(Boolean).map((a) => a.trim()).join(""),
        attributes: eEe(o.attributes)
      }
    } : {}
  };
}
function nEe(e) {
  const { target: t, message: n } = rEe(e);
  return Ks({
    category: `ui.${e.name}`,
    ...SK(t, n)
  });
}
function rEe(e) {
  const t = e.name === "click";
  let n, r = null;
  try {
    r = t ? bK(e.event) : _K(e.event), n = xu(r, { maxStringLength: 200 }) || "<unknown>";
  } catch {
    n = "<unknown>";
  }
  return { target: r, message: n };
}
function iEe(e) {
  return e.type === X_.Element;
}
function oEe(e, t) {
  if (!e.isEnabled())
    return;
  e.updateUserActivity();
  const n = aEe(t);
  n && iy(e, n);
}
function aEe(e) {
  const { metaKey: t, shiftKey: n, ctrlKey: r, altKey: i, key: o, target: a } = e;
  if (!a || sEe(a) || !o)
    return null;
  const s = t || r || i, c = o.length === 1;
  if (!s && c)
    return null;
  const l = xu(a, { maxStringLength: 200 }) || "<unknown>", u = SK(a, l);
  return Ks({
    category: "ui.keyDown",
    message: l,
    data: {
      ...u.data,
      metaKey: t,
      shiftKey: n,
      ctrlKey: r,
      altKey: i,
      key: o
    }
  });
}
function sEe(e) {
  return e.tagName === "INPUT" || e.tagName === "TEXTAREA" || e.isContentEditable;
}
const s8 = {
  // @ts-expect-error TODO: entry type does not fit the create* functions entry type
  resource: fEe,
  paint: uEe,
  // @ts-expect-error TODO: entry type does not fit the create* functions entry type
  navigation: dEe
};
function cEe(e) {
  return e.map(lEe).filter(Boolean);
}
function lEe(e) {
  return s8[e.entryType] ? s8[e.entryType](e) : null;
}
function Eg(e) {
  return ((ba || ur.performance.timeOrigin) + e) / 1e3;
}
function uEe(e) {
  const { duration: t, entryType: n, name: r, startTime: i } = e, o = Eg(i);
  return {
    type: n,
    name: r,
    start: o,
    end: o + t,
    data: void 0
  };
}
function dEe(e) {
  const {
    entryType: t,
    name: n,
    decodedBodySize: r,
    duration: i,
    domComplete: o,
    encodedBodySize: a,
    domContentLoadedEventStart: s,
    domContentLoadedEventEnd: c,
    domInteractive: l,
    loadEventStart: u,
    loadEventEnd: d,
    redirectCount: f,
    startTime: h,
    transferSize: p,
    type: g
  } = e;
  return i === 0 ? null : {
    type: `${t}.${g}`,
    start: Eg(h),
    end: Eg(o),
    name: n,
    data: {
      size: p,
      decodedBodySize: r,
      encodedBodySize: a,
      duration: i,
      domInteractive: l,
      domContentLoadedEventStart: s,
      domContentLoadedEventEnd: c,
      loadEventStart: u,
      loadEventEnd: d,
      domComplete: o,
      redirectCount: f
    }
  };
}
function fEe(e) {
  const {
    entryType: t,
    initiatorType: n,
    name: r,
    responseEnd: i,
    startTime: o,
    decodedBodySize: a,
    encodedBodySize: s,
    responseStatus: c,
    transferSize: l
  } = e;
  return ["fetch", "xmlhttprequest"].includes(n) ? null : {
    type: `${t}.${n}`,
    start: Eg(o),
    end: Eg(i),
    name: r,
    data: {
      size: l,
      statusCode: c,
      decodedBodySize: a,
      encodedBodySize: s
    }
  };
}
function hEe(e) {
  const t = e.entries, n = t[t.length - 1], r = n ? n.element : void 0, i = e.value, o = Eg(i);
  return {
    type: "largest-contentful-paint",
    name: "largest-contentful-paint",
    start: o,
    end: o,
    data: {
      value: i,
      size: i,
      nodeId: r ? su.mirror.getId(r) : void 0
    }
  };
}
function gEe(e) {
  function t(i) {
    e.performanceEntries.includes(i) || e.performanceEntries.push(i);
  }
  function n({ entries: i }) {
    i.forEach(t);
  }
  const r = [];
  return ["navigation", "paint", "resource"].forEach((i) => {
    r.push(bg(i, n));
  }), r.push(
    $G(({ metric: i }) => {
      e.replayPerformanceEntries.push(hEe(i));
    })
  ), () => {
    r.forEach((i) => i());
  };
}
const rr = typeof __SENTRY_DEBUG__ > "u" || __SENTRY_DEBUG__, pEe = 'var t=Uint8Array,n=Uint16Array,r=Int32Array,e=new t([0,0,0,0,0,0,0,0,1,1,1,1,2,2,2,2,3,3,3,3,4,4,4,4,5,5,5,5,0,0,0,0]),i=new t([0,0,0,0,1,1,2,2,3,3,4,4,5,5,6,6,7,7,8,8,9,9,10,10,11,11,12,12,13,13,0,0]),a=new t([16,17,18,0,8,7,9,6,10,5,11,4,12,3,13,2,14,1,15]),s=function(t,e){for(var i=new n(31),a=0;a<31;++a)i[a]=e+=1<<t[a-1];var s=new r(i[30]);for(a=1;a<30;++a)for(var o=i[a];o<i[a+1];++o)s[o]=o-i[a]<<5|a;return{b:i,r:s}},o=s(e,2),f=o.b,h=o.r;f[28]=258,h[258]=28;for(var l=s(i,0).r,u=new n(32768),c=0;c<32768;++c){var v=(43690&c)>>1|(21845&c)<<1;v=(61680&(v=(52428&v)>>2|(13107&v)<<2))>>4|(3855&v)<<4,u[c]=((65280&v)>>8|(255&v)<<8)>>1}var d=function(t,r,e){for(var i=t.length,a=0,s=new n(r);a<i;++a)t[a]&&++s[t[a]-1];var o,f=new n(r);for(a=1;a<r;++a)f[a]=f[a-1]+s[a-1]<<1;if(e){o=new n(1<<r);var h=15-r;for(a=0;a<i;++a)if(t[a])for(var l=a<<4|t[a],c=r-t[a],v=f[t[a]-1]++<<c,d=v|(1<<c)-1;v<=d;++v)o[u[v]>>h]=l}else for(o=new n(i),a=0;a<i;++a)t[a]&&(o[a]=u[f[t[a]-1]++]>>15-t[a]);return o},g=new t(288);for(c=0;c<144;++c)g[c]=8;for(c=144;c<256;++c)g[c]=9;for(c=256;c<280;++c)g[c]=7;for(c=280;c<288;++c)g[c]=8;var w=new t(32);for(c=0;c<32;++c)w[c]=5;var p=d(g,9,0),y=d(w,5,0),m=function(t){return(t+7)/8|0},b=function(n,r,e){return(null==r||r<0)&&(r=0),(null==e||e>n.length)&&(e=n.length),new t(n.subarray(r,e))},M=["unexpected EOF","invalid block type","invalid length/literal","invalid distance","stream finished","no stream handler",,"no callback","invalid UTF-8 data","extra field too long","date not in range 1980-2099","filename too long","stream finishing","invalid zip data"],E=function(t,n,r){var e=new Error(n||M[t]);if(e.code=t,Error.captureStackTrace&&Error.captureStackTrace(e,E),!r)throw e;return e},z=function(t,n,r){r<<=7&n;var e=n/8|0;t[e]|=r,t[e+1]|=r>>8},A=function(t,n,r){r<<=7&n;var e=n/8|0;t[e]|=r,t[e+1]|=r>>8,t[e+2]|=r>>16},_=function(r,e){for(var i=[],a=0;a<r.length;++a)r[a]&&i.push({s:a,f:r[a]});var s=i.length,o=i.slice();if(!s)return{t:F,l:0};if(1==s){var f=new t(i[0].s+1);return f[i[0].s]=1,{t:f,l:1}}i.sort((function(t,n){return t.f-n.f})),i.push({s:-1,f:25001});var h=i[0],l=i[1],u=0,c=1,v=2;for(i[0]={s:-1,f:h.f+l.f,l:h,r:l};c!=s-1;)h=i[i[u].f<i[v].f?u++:v++],l=i[u!=c&&i[u].f<i[v].f?u++:v++],i[c++]={s:-1,f:h.f+l.f,l:h,r:l};var d=o[0].s;for(a=1;a<s;++a)o[a].s>d&&(d=o[a].s);var g=new n(d+1),w=x(i[c-1],g,0);if(w>e){a=0;var p=0,y=w-e,m=1<<y;for(o.sort((function(t,n){return g[n.s]-g[t.s]||t.f-n.f}));a<s;++a){var b=o[a].s;if(!(g[b]>e))break;p+=m-(1<<w-g[b]),g[b]=e}for(p>>=y;p>0;){var M=o[a].s;g[M]<e?p-=1<<e-g[M]++-1:++a}for(;a>=0&&p;--a){var E=o[a].s;g[E]==e&&(--g[E],++p)}w=e}return{t:new t(g),l:w}},x=function(t,n,r){return-1==t.s?Math.max(x(t.l,n,r+1),x(t.r,n,r+1)):n[t.s]=r},D=function(t){for(var r=t.length;r&&!t[--r];);for(var e=new n(++r),i=0,a=t[0],s=1,o=function(t){e[i++]=t},f=1;f<=r;++f)if(t[f]==a&&f!=r)++s;else{if(!a&&s>2){for(;s>138;s-=138)o(32754);s>2&&(o(s>10?s-11<<5|28690:s-3<<5|12305),s=0)}else if(s>3){for(o(a),--s;s>6;s-=6)o(8304);s>2&&(o(s-3<<5|8208),s=0)}for(;s--;)o(a);s=1,a=t[f]}return{c:e.subarray(0,i),n:r}},T=function(t,n){for(var r=0,e=0;e<n.length;++e)r+=t[e]*n[e];return r},k=function(t,n,r){var e=r.length,i=m(n+2);t[i]=255&e,t[i+1]=e>>8,t[i+2]=255^t[i],t[i+3]=255^t[i+1];for(var a=0;a<e;++a)t[i+a+4]=r[a];return 8*(i+4+e)},C=function(t,r,s,o,f,h,l,u,c,v,m){z(r,m++,s),++f[256];for(var b=_(f,15),M=b.t,E=b.l,x=_(h,15),C=x.t,U=x.l,F=D(M),I=F.c,S=F.n,L=D(C),O=L.c,j=L.n,q=new n(19),B=0;B<I.length;++B)++q[31&I[B]];for(B=0;B<O.length;++B)++q[31&O[B]];for(var G=_(q,7),H=G.t,J=G.l,K=19;K>4&&!H[a[K-1]];--K);var N,P,Q,R,V=v+5<<3,W=T(f,g)+T(h,w)+l,X=T(f,M)+T(h,C)+l+14+3*K+T(q,H)+2*q[16]+3*q[17]+7*q[18];if(c>=0&&V<=W&&V<=X)return k(r,m,t.subarray(c,c+v));if(z(r,m,1+(X<W)),m+=2,X<W){N=d(M,E,0),P=M,Q=d(C,U,0),R=C;var Y=d(H,J,0);z(r,m,S-257),z(r,m+5,j-1),z(r,m+10,K-4),m+=14;for(B=0;B<K;++B)z(r,m+3*B,H[a[B]]);m+=3*K;for(var Z=[I,O],$=0;$<2;++$){var tt=Z[$];for(B=0;B<tt.length;++B){var nt=31&tt[B];z(r,m,Y[nt]),m+=H[nt],nt>15&&(z(r,m,tt[B]>>5&127),m+=tt[B]>>12)}}}else N=p,P=g,Q=y,R=w;for(B=0;B<u;++B){var rt=o[B];if(rt>255){A(r,m,N[(nt=rt>>18&31)+257]),m+=P[nt+257],nt>7&&(z(r,m,rt>>23&31),m+=e[nt]);var et=31&rt;A(r,m,Q[et]),m+=R[et],et>3&&(A(r,m,rt>>5&8191),m+=i[et])}else A(r,m,N[rt]),m+=P[rt]}return A(r,m,N[256]),m+P[256]},U=new r([65540,131080,131088,131104,262176,1048704,1048832,2114560,2117632]),F=new t(0),I=function(){for(var t=new Int32Array(256),n=0;n<256;++n){for(var r=n,e=9;--e;)r=(1&r&&-306674912)^r>>>1;t[n]=r}return t}(),S=function(){var t=1,n=0;return{p:function(r){for(var e=t,i=n,a=0|r.length,s=0;s!=a;){for(var o=Math.min(s+2655,a);s<o;++s)i+=e+=r[s];e=(65535&e)+15*(e>>16),i=(65535&i)+15*(i>>16)}t=e,n=i},d:function(){return(255&(t%=65521))<<24|(65280&t)<<8|(255&(n%=65521))<<8|n>>8}}},L=function(a,s,o,f,u){if(!u&&(u={l:1},s.dictionary)){var c=s.dictionary.subarray(-32768),v=new t(c.length+a.length);v.set(c),v.set(a,c.length),a=v,u.w=c.length}return function(a,s,o,f,u,c){var v=c.z||a.length,d=new t(f+v+5*(1+Math.ceil(v/7e3))+u),g=d.subarray(f,d.length-u),w=c.l,p=7&(c.r||0);if(s){p&&(g[0]=c.r>>3);for(var y=U[s-1],M=y>>13,E=8191&y,z=(1<<o)-1,A=c.p||new n(32768),_=c.h||new n(z+1),x=Math.ceil(o/3),D=2*x,T=function(t){return(a[t]^a[t+1]<<x^a[t+2]<<D)&z},F=new r(25e3),I=new n(288),S=new n(32),L=0,O=0,j=c.i||0,q=0,B=c.w||0,G=0;j+2<v;++j){var H=T(j),J=32767&j,K=_[H];if(A[J]=K,_[H]=J,B<=j){var N=v-j;if((L>7e3||q>24576)&&(N>423||!w)){p=C(a,g,0,F,I,S,O,q,G,j-G,p),q=L=O=0,G=j;for(var P=0;P<286;++P)I[P]=0;for(P=0;P<30;++P)S[P]=0}var Q=2,R=0,V=E,W=J-K&32767;if(N>2&&H==T(j-W))for(var X=Math.min(M,N)-1,Y=Math.min(32767,j),Z=Math.min(258,N);W<=Y&&--V&&J!=K;){if(a[j+Q]==a[j+Q-W]){for(var $=0;$<Z&&a[j+$]==a[j+$-W];++$);if($>Q){if(Q=$,R=W,$>X)break;var tt=Math.min(W,$-2),nt=0;for(P=0;P<tt;++P){var rt=j-W+P&32767,et=rt-A[rt]&32767;et>nt&&(nt=et,K=rt)}}}W+=(J=K)-(K=A[J])&32767}if(R){F[q++]=268435456|h[Q]<<18|l[R];var it=31&h[Q],at=31&l[R];O+=e[it]+i[at],++I[257+it],++S[at],B=j+Q,++L}else F[q++]=a[j],++I[a[j]]}}for(j=Math.max(j,B);j<v;++j)F[q++]=a[j],++I[a[j]];p=C(a,g,w,F,I,S,O,q,G,j-G,p),w||(c.r=7&p|g[p/8|0]<<3,p-=7,c.h=_,c.p=A,c.i=j,c.w=B)}else{for(j=c.w||0;j<v+w;j+=65535){var st=j+65535;st>=v&&(g[p/8|0]=w,st=v),p=k(g,p+1,a.subarray(j,st))}c.i=v}return b(d,0,f+m(p)+u)}(a,null==s.level?6:s.level,null==s.mem?Math.ceil(1.5*Math.max(8,Math.min(13,Math.log(a.length)))):12+s.mem,o,f,u)},O=function(t,n,r){for(;r;++n)t[n]=r,r>>>=8},j=function(){function n(n,r){if("function"==typeof n&&(r=n,n={}),this.ondata=r,this.o=n||{},this.s={l:0,i:32768,w:32768,z:32768},this.b=new t(98304),this.o.dictionary){var e=this.o.dictionary.subarray(-32768);this.b.set(e,32768-e.length),this.s.i=32768-e.length}}return n.prototype.p=function(t,n){this.ondata(L(t,this.o,0,0,this.s),n)},n.prototype.push=function(n,r){this.ondata||E(5),this.s.l&&E(4);var e=n.length+this.s.z;if(e>this.b.length){if(e>2*this.b.length-32768){var i=new t(-32768&e);i.set(this.b.subarray(0,this.s.z)),this.b=i}var a=this.b.length-this.s.z;a&&(this.b.set(n.subarray(0,a),this.s.z),this.s.z=this.b.length,this.p(this.b,!1)),this.b.set(this.b.subarray(-32768)),this.b.set(n.subarray(a),32768),this.s.z=n.length-a+32768,this.s.i=32766,this.s.w=32768}else this.b.set(n,this.s.z),this.s.z+=n.length;this.s.l=1&r,(this.s.z>this.s.w+8191||r)&&(this.p(this.b,r||!1),this.s.w=this.s.i,this.s.i-=2)},n}();function q(t,n){n||(n={});var r=function(){var t=-1;return{p:function(n){for(var r=t,e=0;e<n.length;++e)r=I[255&r^n[e]]^r>>>8;t=r},d:function(){return~t}}}(),e=t.length;r.p(t);var i,a=L(t,n,10+((i=n).filename?i.filename.length+1:0),8),s=a.length;return function(t,n){var r=n.filename;if(t[0]=31,t[1]=139,t[2]=8,t[8]=n.level<2?4:9==n.level?2:0,t[9]=3,0!=n.mtime&&O(t,4,Math.floor(new Date(n.mtime||Date.now())/1e3)),r){t[3]=8;for(var e=0;e<=r.length;++e)t[e+10]=r.charCodeAt(e)}}(a,n),O(a,s-8,r.d()),O(a,s-4,e),a}var B=function(){function t(t,n){this.c=S(),this.v=1,j.call(this,t,n)}return t.prototype.push=function(t,n){this.c.p(t),j.prototype.push.call(this,t,n)},t.prototype.p=function(t,n){var r=L(t,this.o,this.v&&(this.o.dictionary?6:2),n&&4,this.s);this.v&&(function(t,n){var r=n.level,e=0==r?0:r<6?1:9==r?3:2;if(t[0]=120,t[1]=e<<6|(n.dictionary&&32),t[1]|=31-(t[0]<<8|t[1])%31,n.dictionary){var i=S();i.p(n.dictionary),O(t,2,i.d())}}(r,this.o),this.v=0),n&&O(r,r.length-4,this.c.d()),this.ondata(r,n)},t}(),G="undefined"!=typeof TextEncoder&&new TextEncoder,H="undefined"!=typeof TextDecoder&&new TextDecoder;try{H.decode(F,{stream:!0})}catch(t){}var J=function(){function t(t){this.ondata=t}return t.prototype.push=function(t,n){this.ondata||E(5),this.d&&E(4),this.ondata(K(t),this.d=n||!1)},t}();function K(n,r){if(r){for(var e=new t(n.length),i=0;i<n.length;++i)e[i]=n.charCodeAt(i);return e}if(G)return G.encode(n);var a=n.length,s=new t(n.length+(n.length>>1)),o=0,f=function(t){s[o++]=t};for(i=0;i<a;++i){if(o+5>s.length){var h=new t(o+8+(a-i<<1));h.set(s),s=h}var l=n.charCodeAt(i);l<128||r?f(l):l<2048?(f(192|l>>6),f(128|63&l)):l>55295&&l<57344?(f(240|(l=65536+(1047552&l)|1023&n.charCodeAt(++i))>>18),f(128|l>>12&63),f(128|l>>6&63),f(128|63&l)):(f(224|l>>12),f(128|l>>6&63),f(128|63&l))}return b(s,0,o)}const N=new class{constructor(){this._init()}clear(){this._init()}addEvent(t){if(!t)throw new Error("Adding invalid event");const n=this._hasEvents?",":"";this.stream.push(n+t),this._hasEvents=!0}finish(){this.stream.push("]",!0);const t=function(t){let n=0;for(let r=0,e=t.length;r<e;r++)n+=t[r].length;const r=new Uint8Array(n);for(let n=0,e=0,i=t.length;n<i;n++){const i=t[n];r.set(i,e),e+=i.length}return r}(this._deflatedData);return this._init(),t}_init(){this._hasEvents=!1,this._deflatedData=[],this.deflate=new B,this.deflate.ondata=(t,n)=>{this._deflatedData.push(t)},this.stream=new J(((t,n)=>{this.deflate.push(t,n)})),this.stream.push("[")}},P={clear:()=>{N.clear()},addEvent:t=>N.addEvent(t),finish:()=>N.finish(),compress:t=>function(t){return q(K(t))}(t)};addEventListener("message",(function(t){const n=t.data.method,r=t.data.id,e=t.data.arg;if(n in P&&"function"==typeof P[n])try{const t=P[n](e);postMessage({id:r,method:n,success:!0,response:t})}catch(t){postMessage({id:r,method:n,success:!1,response:t.message}),console.error(t)}})),postMessage({id:void 0,method:"init",success:!0,response:void 0});';
function mEe() {
  const e = new Blob([pEe]);
  return URL.createObjectURL(e);
}
function xo(e, t) {
  rr && (xe.info(e), t && wK(e));
}
function Yh(e, t) {
  rr && (xe.info(e), t && setTimeout(() => {
    wK(e);
  }, 0));
}
function wK(e) {
  Eu(
    {
      category: "console",
      data: {
        logger: "replay"
      },
      level: "info",
      message: e
    },
    { level: "info" }
  );
}
class YP extends Error {
  constructor() {
    super(`Event buffer exceeded maximum size of ${zP}.`);
  }
}
class xK {
  /** All the events that are buffered to be sent. */
  /** @inheritdoc */
  constructor() {
    this.events = [], this._totalSize = 0, this.hasCheckout = !1;
  }
  /** @inheritdoc */
  get hasEvents() {
    return this.events.length > 0;
  }
  /** @inheritdoc */
  get type() {
    return "sync";
  }
  /** @inheritdoc */
  destroy() {
    this.events = [];
  }
  /** @inheritdoc */
  async addEvent(t) {
    const n = JSON.stringify(t).length;
    if (this._totalSize += n, this._totalSize > zP)
      throw new YP();
    this.events.push(t);
  }
  /** @inheritdoc */
  finish() {
    return new Promise((t) => {
      const n = this.events;
      this.clear(), t(JSON.stringify(n));
    });
  }
  /** @inheritdoc */
  clear() {
    this.events = [], this._totalSize = 0, this.hasCheckout = !1;
  }
  /** @inheritdoc */
  getEarliestTimestamp() {
    const t = this.events.map((n) => n.timestamp).sort()[0];
    return t ? KP(t) : null;
  }
}
class vEe {
  constructor(t) {
    this._worker = t, this._id = 0;
  }
  /**
   * Ensure the worker is ready (or not).
   * This will either resolve when the worker is ready, or reject if an error occured.
   */
  ensureReady() {
    return this._ensureReadyPromise ? this._ensureReadyPromise : (this._ensureReadyPromise = new Promise((t, n) => {
      this._worker.addEventListener(
        "message",
        ({ data: r }) => {
          r.success ? t() : n();
        },
        { once: !0 }
      ), this._worker.addEventListener(
        "error",
        (r) => {
          n(r);
        },
        { once: !0 }
      );
    }), this._ensureReadyPromise);
  }
  /**
   * Destroy the worker.
   */
  destroy() {
    xo("[Replay] Destroying compression worker"), this._worker.terminate();
  }
  /**
   * Post message to worker and wait for response before resolving promise.
   */
  postMessage(t, n) {
    const r = this._getAndIncrementId();
    return new Promise((i, o) => {
      const a = ({ data: s }) => {
        const c = s;
        if (c.method === t && c.id === r) {
          if (this._worker.removeEventListener("message", a), !c.success) {
            rr && xe.error("[Replay]", c.response), o(new Error("Error in compression worker"));
            return;
          }
          i(c.response);
        }
      };
      this._worker.addEventListener("message", a), this._worker.postMessage({ id: r, method: t, arg: n });
    });
  }
  /** Get the current ID and increment it for the next call. */
  _getAndIncrementId() {
    return this._id++;
  }
}
class yEe {
  /** @inheritdoc */
  constructor(t) {
    this._worker = new vEe(t), this._earliestTimestamp = null, this._totalSize = 0, this.hasCheckout = !1;
  }
  /** @inheritdoc */
  get hasEvents() {
    return !!this._earliestTimestamp;
  }
  /** @inheritdoc */
  get type() {
    return "worker";
  }
  /**
   * Ensure the worker is ready (or not).
   * This will either resolve when the worker is ready, or reject if an error occured.
   */
  ensureReady() {
    return this._worker.ensureReady();
  }
  /**
   * Destroy the event buffer.
   */
  destroy() {
    this._worker.destroy();
  }
  /**
   * Add an event to the event buffer.
   *
   * Returns true if event was successfuly received and processed by worker.
   */
  addEvent(t) {
    const n = KP(t.timestamp);
    (!this._earliestTimestamp || n < this._earliestTimestamp) && (this._earliestTimestamp = n);
    const r = JSON.stringify(t);
    return this._totalSize += r.length, this._totalSize > zP ? Promise.reject(new YP()) : this._sendEventToWorker(r);
  }
  /**
   * Finish the event buffer and return the compressed data.
   */
  finish() {
    return this._finishRequest();
  }
  /** @inheritdoc */
  clear() {
    this._earliestTimestamp = null, this._totalSize = 0, this.hasCheckout = !1, this._worker.postMessage("clear").then(null, (t) => {
      rr && xe.warn('[Replay] Sending "clear" message to worker failed', t);
    });
  }
  /** @inheritdoc */
  getEarliestTimestamp() {
    return this._earliestTimestamp;
  }
  /**
   * Send the event to the worker.
   */
  _sendEventToWorker(t) {
    return this._worker.postMessage("addEvent", t);
  }
  /**
   * Finish the request and return the compressed data from the worker.
   */
  async _finishRequest() {
    const t = await this._worker.postMessage("finish");
    return this._earliestTimestamp = null, this._totalSize = 0, t;
  }
}
class bEe {
  constructor(t) {
    this._fallback = new xK(), this._compression = new yEe(t), this._used = this._fallback, this._ensureWorkerIsLoadedPromise = this._ensureWorkerIsLoaded();
  }
  /** @inheritdoc */
  get type() {
    return this._used.type;
  }
  /** @inheritDoc */
  get hasEvents() {
    return this._used.hasEvents;
  }
  /** @inheritdoc */
  get hasCheckout() {
    return this._used.hasCheckout;
  }
  /** @inheritdoc */
  set hasCheckout(t) {
    this._used.hasCheckout = t;
  }
  /** @inheritDoc */
  destroy() {
    this._fallback.destroy(), this._compression.destroy();
  }
  /** @inheritdoc */
  clear() {
    return this._used.clear();
  }
  /** @inheritdoc */
  getEarliestTimestamp() {
    return this._used.getEarliestTimestamp();
  }
  /**
   * Add an event to the event buffer.
   *
   * Returns true if event was successfully added.
   */
  addEvent(t) {
    return this._used.addEvent(t);
  }
  /** @inheritDoc */
  async finish() {
    return await this.ensureWorkerIsLoaded(), this._used.finish();
  }
  /** Ensure the worker has loaded. */
  ensureWorkerIsLoaded() {
    return this._ensureWorkerIsLoadedPromise;
  }
  /** Actually check if the worker has been loaded. */
  async _ensureWorkerIsLoaded() {
    try {
      await this._compression.ensureReady();
    } catch {
      xo("[Replay] Failed to load the compression worker, falling back to simple buffer");
      return;
    }
    await this._switchToCompressionWorker();
  }
  /** Switch the used buffer to the compression worker. */
  async _switchToCompressionWorker() {
    const { events: t, hasCheckout: n } = this._fallback, r = [];
    for (const i of t)
      r.push(this._compression.addEvent(i));
    this._compression.hasCheckout = n, this._used = this._compression;
    try {
      await Promise.all(r);
    } catch (i) {
      rr && xe.warn("[Replay] Failed to add events when switching buffers.", i);
    }
  }
}
function _Ee({
  useCompression: e,
  workerUrl: t
}) {
  if (e && // eslint-disable-next-line no-restricted-globals
  window.Worker) {
    const n = SEe(t);
    if (n)
      return n;
  }
  return xo("[Replay] Using simple buffer"), new xK();
}
function SEe(e) {
  try {
    const t = e || wEe();
    if (!t)
      return;
    xo(`[Replay] Using compression worker${e ? ` from ${e}` : ""}`);
    const n = new Worker(t);
    return new bEe(n);
  } catch {
    xo("[Replay] Failed to create compression worker");
  }
}
function wEe() {
  return typeof __SENTRY_EXCLUDE_REPLAY_WORKER__ > "u" || !__SENTRY_EXCLUDE_REPLAY_WORKER__ ? mEe() : "";
}
function XP() {
  try {
    return "sessionStorage" in ur && !!ur.sessionStorage;
  } catch {
    return !1;
  }
}
function xEe(e) {
  EEe(), e.session = void 0;
}
function EEe() {
  if (XP())
    try {
      ur.sessionStorage.removeItem(VP);
    } catch {
    }
}
function EK(e) {
  return e === void 0 ? !1 : Math.random() < e;
}
function CK(e) {
  const t = Date.now(), n = e.id || Gr(), r = e.started || t, i = e.lastActivity || t, o = e.segmentId || 0, a = e.sampled, s = e.previousSessionId;
  return {
    id: n,
    started: r,
    lastActivity: i,
    segmentId: o,
    sampled: a,
    previousSessionId: s
  };
}
function QP(e) {
  if (XP())
    try {
      ur.sessionStorage.setItem(VP, JSON.stringify(e));
    } catch {
    }
}
function CEe(e, t) {
  return EK(e) ? "session" : t ? "buffer" : !1;
}
function c8({ sessionSampleRate: e, allowBuffering: t, stickySession: n = !1 }, { previousSessionId: r } = {}) {
  const i = CEe(e, t), o = CK({
    sampled: i,
    previousSessionId: r
  });
  return n && QP(o), o;
}
function TEe(e) {
  if (!XP())
    return null;
  try {
    const t = ur.sessionStorage.getItem(VP);
    if (!t)
      return null;
    const n = JSON.parse(t);
    return Yh("[Replay] Loading existing session", e), CK(n);
  } catch {
    return null;
  }
}
function TA(e, t, n = +/* @__PURE__ */ new Date()) {
  return e === null || t === void 0 || t < 0 ? !0 : t === 0 ? !1 : e + t <= n;
}
function TK(e, {
  maxReplayDuration: t,
  sessionIdleExpire: n,
  targetTime: r = Date.now()
}) {
  return (
    // First, check that maximum session length has not been exceeded
    TA(e.started, t, r) || // check that the idle timeout has not been exceeded (i.e. user has
    // performed an action within the last `sessionIdleExpire` ms)
    TA(e.lastActivity, n, r)
  );
}
function IK(e, { sessionIdleExpire: t, maxReplayDuration: n }) {
  return !(!TK(e, { sessionIdleExpire: t, maxReplayDuration: n }) || e.sampled === "buffer" && e.segmentId === 0);
}
function b5({
  traceInternals: e,
  sessionIdleExpire: t,
  maxReplayDuration: n,
  previousSessionId: r
}, i) {
  const o = i.stickySession && TEe(e);
  return o ? IK(o, { sessionIdleExpire: t, maxReplayDuration: n }) ? (Yh("[Replay] Session in sessionStorage is expired, creating new one..."), c8(i, { previousSessionId: o.id })) : o : (Yh("[Replay] Creating new session", e), c8(i, { previousSessionId: r }));
}
function IEe(e) {
  return e.type === dn.Custom;
}
function JP(e, t, n) {
  return RK(e, t) ? (AK(e, t, n), !0) : !1;
}
function AEe(e, t, n) {
  return RK(e, t) ? AK(e, t, n) : Promise.resolve(null);
}
async function AK(e, t, n) {
  if (!e.eventBuffer)
    return null;
  try {
    n && e.recordingMode === "buffer" && e.eventBuffer.clear(), n && (e.eventBuffer.hasCheckout = !0);
    const r = e.getOptions(), i = REe(t, r.beforeAddRecordingEvent);
    return i ? await e.eventBuffer.addEvent(i) : void 0;
  } catch (r) {
    const i = r && r instanceof YP ? "addEventSizeExceeded" : "addEvent";
    rr && xe.error(r), await e.stop({ reason: i });
    const o = Yn();
    o && o.recordDroppedEvent("internal_sdk_error", "replay");
  }
}
function RK(e, t) {
  if (!e.eventBuffer || e.isPaused() || !e.isEnabled())
    return !1;
  const n = KP(t.timestamp);
  return n + e.timeouts.sessionIdlePause < Date.now() ? !1 : n > e.getContext().initialTimestamp + e.getOptions().maxReplayDuration ? (xo(
    `[Replay] Skipping event with timestamp ${n} because it is after maxReplayDuration`,
    e.getOptions()._experiments.traceInternals
  ), !1) : !0;
}
function REe(e, t) {
  try {
    if (typeof t == "function" && IEe(e))
      return t(e);
  } catch (n) {
    return rr && xe.error("[Replay] An error occured in the `beforeAddRecordingEvent` callback, skipping the event...", n), null;
  }
  return e;
}
function ZP(e) {
  return !e.type;
}
function IA(e) {
  return e.type === "transaction";
}
function $Ee(e) {
  return e.type === "replay_event";
}
function l8(e) {
  return e.type === "feedback";
}
function $K(e) {
  const t = MEe();
  return (n, r) => {
    if (!e.isEnabled() || !ZP(n) && !IA(n))
      return;
    const i = r && r.statusCode;
    if (!(t && (!i || i < 200 || i >= 300))) {
      if (IA(n)) {
        OEe(e, n);
        return;
      }
      PEe(e, n);
    }
  };
}
function OEe(e, t) {
  const n = e.getContext();
  t.contexts && t.contexts.trace && t.contexts.trace.trace_id && n.traceIds.size < 100 && n.traceIds.add(t.contexts.trace.trace_id);
}
function PEe(e, t) {
  const n = e.getContext();
  if (t.event_id && n.errorIds.size < 100 && n.errorIds.add(t.event_id), e.recordingMode !== "buffer" || !t.tags || !t.tags.replayId)
    return;
  const { beforeErrorSampling: r } = e.getOptions();
  typeof r == "function" && !r(t) || setTimeout(() => {
    e.sendBufferedReplayOrFlush();
  });
}
function MEe() {
  const e = Yn();
  if (!e)
    return !1;
  const t = e.getTransport();
  return t && t.send.__sentry__baseTransport__ || !1;
}
function kEe(e) {
  return (t) => {
    !e.isEnabled() || !ZP(t) || NEe(e, t);
  };
}
function NEe(e, t) {
  const n = t.exception && t.exception.values && t.exception.values[0].value;
  if (typeof n == "string" && // Only matches errors in production builds of react-dom
  // Example https://reactjs.org/docs/error-decoder.html?invariant=423
  (n.match(/reactjs\.org\/docs\/error-decoder\.html\?invariant=(418|419|422|423|425)/) || // Development builds of react-dom
  // Error 1: Hydration failed because the initial UI does not match what was rendered on the server.
  // Error 2: Text content does not match server-rendered HTML. Warning: Text content did not match.
  n.match(/(does not match server-rendered HTML|Hydration failed because)/i))) {
    const r = Ks({
      category: "replay.hydrate-error"
    });
    iy(e, r);
  }
}
function DEe(e, t) {
  return e.type || !e.exception || !e.exception.values || !e.exception.values.length ? !1 : !!(t.originalException && t.originalException.__rrweb__);
}
function LEe(e, t) {
  e.triggerUserActivity(), e.addUpdate(() => t.timestamp ? (e.throttledAddEvent({
    type: dn.Custom,
    timestamp: t.timestamp * 1e3,
    data: {
      tag: "breadcrumb",
      payload: {
        timestamp: t.timestamp,
        type: "default",
        category: "sentry.feedback",
        data: {
          feedbackId: t.event_id
        }
      }
    }
  }), !1) : !0);
}
function jEe(e, t) {
  return e.recordingMode !== "buffer" || t.message === BP || !t.exception || t.type ? !1 : EK(e.getOptions().errorSampleRate);
}
function FEe(e, t = !1) {
  const n = t ? $K(e) : void 0;
  return Object.assign(
    (r, i) => e.isEnabled() ? $Ee(r) ? (delete r.breadcrumbs, r) : !ZP(r) && !IA(r) && !l8(r) || !e.checkAndHandleExpiredSession() ? r : l8(r) ? (e.flush(), r.contexts.feedback.replay_id = e.getSessionId(), LEe(e, r), r) : DEe(r, i) && !e.getOptions()._experiments.captureExceptions ? (rr && xe.log("[Replay] Ignoring error from rrweb internals", r), null) : ((jEe(e, r) || e.recordingMode === "session") && (r.tags = { ...r.tags, replayId: e.getSessionId() }), n && n(r, { statusCode: 200 }), r) : r,
    { id: "Replay" }
  );
}
function Dx(e, t) {
  return t.map(({ type: n, start: r, end: i, name: o, data: a }) => {
    const s = e.throttledAddEvent({
      type: dn.Custom,
      timestamp: r,
      data: {
        tag: "performanceSpan",
        payload: {
          op: n,
          description: o,
          startTimestamp: r,
          endTimestamp: i,
          data: a
        }
      }
    });
    return typeof s == "string" ? Promise.resolve(null) : s;
  });
}
function VEe(e) {
  const { from: t, to: n } = e, r = Date.now() / 1e3;
  return {
    type: "navigation.push",
    start: r,
    end: r,
    name: n,
    data: {
      previous: t
    }
  };
}
function BEe(e) {
  return (t) => {
    if (!e.isEnabled())
      return;
    const n = VEe(t);
    n !== null && (e.getContext().urls.push(n.name), e.triggerUserActivity(), e.addUpdate(() => (Dx(e, [n]), !1)));
  };
}
function zEe(e, t) {
  return rr && e.getOptions()._experiments.traceInternals ? !1 : F1e(t, Yn());
}
function Lx(e, t) {
  e.isEnabled() && t !== null && (zEe(e, t.name) || e.addUpdate(() => (Dx(e, [t]), !0)));
}
function HEe(e) {
  const { startTimestamp: t, endTimestamp: n, fetchData: r, response: i } = e;
  if (!n)
    return null;
  const { method: o, url: a } = r;
  return {
    type: "resource.fetch",
    start: t / 1e3,
    end: n / 1e3,
    name: a,
    data: {
      method: o,
      statusCode: i ? i.status : void 0
    }
  };
}
function UEe(e) {
  return (t) => {
    if (!e.isEnabled())
      return;
    const n = HEe(t);
    Lx(e, n);
  };
}
function WEe(e) {
  const { startTimestamp: t, endTimestamp: n, xhr: r } = e, i = r[Gl];
  if (!t || !n || !i)
    return null;
  const { method: o, url: a, status_code: s } = i;
  return a === void 0 ? null : {
    type: "resource.xhr",
    name: a,
    start: t / 1e3,
    end: n / 1e3,
    data: {
      method: o,
      statusCode: s
    }
  };
}
function qEe(e) {
  return (t) => {
    if (!e.isEnabled())
      return;
    const n = WEe(t);
    Lx(e, n);
  };
}
function jx(e, t) {
  if (e)
    try {
      if (typeof e == "string")
        return t.encode(e).length;
      if (e instanceof URLSearchParams)
        return t.encode(e.toString()).length;
      if (e instanceof FormData) {
        const n = kK(e);
        return t.encode(n).length;
      }
      if (e instanceof Blob)
        return e.size;
      if (e instanceof ArrayBuffer)
        return e.byteLength;
    } catch {
    }
}
function OK(e) {
  if (!e)
    return;
  const t = parseInt(e, 10);
  return isNaN(t) ? void 0 : t;
}
function PK(e) {
  try {
    if (typeof e == "string")
      return [e];
    if (e instanceof URLSearchParams)
      return [e.toString()];
    if (e instanceof FormData)
      return [kK(e)];
    if (!e)
      return [void 0];
  } catch {
    return rr && xe.warn("[Replay] Failed to serialize body", e), [void 0, "BODY_PARSE_ERROR"];
  }
  return rr && xe.info("[Replay] Skipping network body because of body type", e), [void 0, "UNPARSEABLE_BODY_TYPE"];
}
function Q_(e, t) {
  if (!e)
    return {
      headers: {},
      size: void 0,
      _meta: {
        warnings: [t]
      }
    };
  const n = { ...e._meta }, r = n.warnings || [];
  return n.warnings = [...r, t], e._meta = n, e;
}
function MK(e, t) {
  if (!t)
    return null;
  const { startTimestamp: n, endTimestamp: r, url: i, method: o, statusCode: a, request: s, response: c } = t;
  return {
    type: e,
    start: n / 1e3,
    end: r / 1e3,
    name: i,
    data: Ao({
      method: o,
      statusCode: a,
      request: s,
      response: c
    })
  };
}
function X0(e) {
  return {
    headers: {},
    size: e,
    _meta: {
      warnings: ["URL_SKIPPED"]
    }
  };
}
function cu(e, t, n) {
  if (!t && Object.keys(e).length === 0)
    return;
  if (!t)
    return {
      headers: e
    };
  if (!n)
    return {
      headers: e,
      size: t
    };
  const r = {
    headers: e,
    size: t
  }, { body: i, warnings: o } = GEe(n);
  return r.body = i, o && o.length > 0 && (r._meta = {
    warnings: o
  }), r;
}
function AA(e, t) {
  return Object.keys(e).reduce((n, r) => {
    const i = r.toLowerCase();
    return t.includes(i) && e[r] && (n[i] = e[r]), n;
  }, {});
}
function kK(e) {
  return new URLSearchParams(e).toString();
}
function GEe(e) {
  if (!e || typeof e != "string")
    return {
      body: e
    };
  const t = e.length > G4, n = KEe(e);
  if (t) {
    const r = e.slice(0, G4);
    return n ? {
      body: r,
      warnings: ["MAYBE_JSON_TRUNCATED"]
    } : {
      body: `${r}…`,
      warnings: ["TEXT_TRUNCATED"]
    };
  }
  if (n)
    try {
      return {
        body: JSON.parse(e)
      };
    } catch {
    }
  return {
    body: e
  };
}
function KEe(e) {
  const t = e[0], n = e[e.length - 1];
  return t === "[" && n === "]" || t === "{" && n === "}";
}
function J_(e, t) {
  const n = YEe(e);
  return pp(n, t);
}
function YEe(e, t = ur.document.baseURI) {
  if (e.startsWith("http://") || e.startsWith("https://") || e.startsWith(ur.location.origin))
    return e;
  const n = new URL(e, t);
  if (n.origin !== new URL(t).origin)
    return e;
  const r = n.href;
  return !e.endsWith("/") && r.endsWith("/") ? r.slice(0, -1) : r;
}
async function XEe(e, t, n) {
  try {
    const r = await JEe(e, t, n), i = MK("resource.fetch", r);
    Lx(n.replay, i);
  } catch (r) {
    rr && xe.error("[Replay] Failed to capture fetch breadcrumb", r);
  }
}
function QEe(e, t, n) {
  const { input: r, response: i } = t, o = r ? NK(r) : void 0, a = jx(o, n.textEncoder), s = i ? OK(i.headers.get("content-length")) : void 0;
  a !== void 0 && (e.data.request_body_size = a), s !== void 0 && (e.data.response_body_size = s);
}
async function JEe(e, t, n) {
  const r = Date.now(), { startTimestamp: i = r, endTimestamp: o = r } = t, {
    url: a,
    method: s,
    status_code: c = 0,
    request_body_size: l,
    response_body_size: u
  } = e.data, d = J_(a, n.networkDetailAllowUrls) && !J_(a, n.networkDetailDenyUrls), f = d ? ZEe(n, t.input, l) : X0(l), h = await eCe(d, n, t.response, u);
  return {
    startTimestamp: i,
    endTimestamp: o,
    url: a,
    method: s,
    statusCode: c,
    request: f,
    response: h
  };
}
function ZEe({ networkCaptureBodies: e, networkRequestHeaders: t }, n, r) {
  const i = n ? rCe(n, t) : {};
  if (!e)
    return cu(i, r, void 0);
  const o = NK(n), [a, s] = PK(o), c = cu(i, r, a);
  return s ? Q_(c, s) : c;
}
async function eCe(e, {
  networkCaptureBodies: t,
  textEncoder: n,
  networkResponseHeaders: r
}, i, o) {
  if (!e && o !== void 0)
    return X0(o);
  const a = i ? DK(i.headers, r) : {};
  if (!i || !t && o !== void 0)
    return cu(a, o, void 0);
  const [s, c] = await nCe(i), l = tCe(s, {
    networkCaptureBodies: t,
    textEncoder: n,
    responseBodySize: o,
    captureDetails: e,
    headers: a
  });
  return c ? Q_(l, c) : l;
}
function tCe(e, {
  networkCaptureBodies: t,
  textEncoder: n,
  responseBodySize: r,
  captureDetails: i,
  headers: o
}) {
  try {
    const a = e && e.length && r === void 0 ? jx(e, n) : r;
    return i ? t ? cu(o, a, e) : cu(o, a, void 0) : X0(a);
  } catch (a) {
    return rr && xe.warn("[Replay] Failed to serialize response body", a), cu(o, r, void 0);
  }
}
async function nCe(e) {
  const t = iCe(e);
  if (!t)
    return [void 0, "BODY_PARSE_ERROR"];
  try {
    return [await oCe(t)];
  } catch (n) {
    return rr && xe.warn("[Replay] Failed to get text body from response", n), [void 0, "BODY_PARSE_ERROR"];
  }
}
function NK(e = []) {
  if (!(e.length !== 2 || typeof e[1] != "object"))
    return e[1].body;
}
function DK(e, t) {
  const n = {};
  return t.forEach((r) => {
    e.get(r) && (n[r] = e.get(r));
  }), n;
}
function rCe(e, t) {
  return e.length === 1 && typeof e[0] != "string" ? u8(e[0], t) : e.length === 2 ? u8(e[1], t) : {};
}
function u8(e, t) {
  if (!e)
    return {};
  const n = e.headers;
  return n ? n instanceof Headers ? DK(n, t) : Array.isArray(n) ? {} : AA(n, t) : {};
}
function iCe(e) {
  try {
    return e.clone();
  } catch (t) {
    rr && xe.warn("[Replay] Failed to clone response body", t);
  }
}
function oCe(e) {
  return new Promise((t, n) => {
    const r = setTimeout(() => n(new Error("Timeout while trying to read response body")), 500);
    aCe(e).then(
      (i) => t(i),
      (i) => n(i)
    ).finally(() => clearTimeout(r));
  });
}
async function aCe(e) {
  return await e.text();
}
async function sCe(e, t, n) {
  try {
    const r = lCe(e, t, n), i = MK("resource.xhr", r);
    Lx(n.replay, i);
  } catch (r) {
    rr && xe.error("[Replay] Failed to capture xhr breadcrumb", r);
  }
}
function cCe(e, t, n) {
  const { xhr: r, input: i } = t;
  if (!r)
    return;
  const o = jx(i, n.textEncoder), a = r.getResponseHeader("content-length") ? OK(r.getResponseHeader("content-length")) : hCe(r.response, r.responseType, n.textEncoder);
  o !== void 0 && (e.data.request_body_size = o), a !== void 0 && (e.data.response_body_size = a);
}
function lCe(e, t, n) {
  const r = Date.now(), { startTimestamp: i = r, endTimestamp: o = r, input: a, xhr: s } = t, {
    url: c,
    method: l,
    status_code: u = 0,
    request_body_size: d,
    response_body_size: f
  } = e.data;
  if (!c)
    return null;
  if (!s || !J_(c, n.networkDetailAllowUrls) || J_(c, n.networkDetailDenyUrls)) {
    const T = X0(d), x = X0(f);
    return {
      startTimestamp: i,
      endTimestamp: o,
      url: c,
      method: l,
      statusCode: u,
      request: T,
      response: x
    };
  }
  const h = s[Gl], p = h ? AA(h.request_headers, n.networkRequestHeaders) : {}, g = AA(uCe(s), n.networkResponseHeaders), [m, v] = n.networkCaptureBodies ? PK(a) : [void 0], [y, S] = n.networkCaptureBodies ? dCe(s) : [void 0], _ = cu(p, d, m), w = cu(g, f, y);
  return {
    startTimestamp: i,
    endTimestamp: o,
    url: c,
    method: l,
    statusCode: u,
    request: v ? Q_(_, v) : _,
    response: S ? Q_(w, S) : w
  };
}
function uCe(e) {
  const t = e.getAllResponseHeaders();
  return t ? t.split(`\r
`).reduce((n, r) => {
    const [i, o] = r.split(": ");
    return n[i.toLowerCase()] = o, n;
  }, {}) : {};
}
function dCe(e) {
  const t = [];
  try {
    return [e.responseText];
  } catch (n) {
    t.push(n);
  }
  try {
    return fCe(e.response, e.responseType);
  } catch (n) {
    t.push(n);
  }
  return rr && xe.warn("[Replay] Failed to get xhr response body", ...t), [void 0];
}
function fCe(e, t) {
  try {
    if (typeof e == "string")
      return [e];
    if (e instanceof Document)
      return [e.body.outerHTML];
    if (t === "json" && e && typeof e == "object")
      return [JSON.stringify(e)];
    if (!e)
      return [void 0];
  } catch {
    return rr && xe.warn("[Replay] Failed to serialize body", e), [void 0, "BODY_PARSE_ERROR"];
  }
  return rr && xe.info("[Replay] Skipping network body because of body type", e), [void 0, "UNPARSEABLE_BODY_TYPE"];
}
function hCe(e, t, n) {
  try {
    const r = t === "json" && e && typeof e == "object" ? JSON.stringify(e) : e;
    return jx(r, n);
  } catch {
    return;
  }
}
function gCe(e) {
  const t = Yn();
  try {
    const n = new TextEncoder(), {
      networkDetailAllowUrls: r,
      networkDetailDenyUrls: i,
      networkCaptureBodies: o,
      networkRequestHeaders: a,
      networkResponseHeaders: s
    } = e.getOptions(), c = {
      replay: e,
      textEncoder: n,
      networkDetailAllowUrls: r,
      networkDetailDenyUrls: i,
      networkCaptureBodies: o,
      networkRequestHeaders: a,
      networkResponseHeaders: s
    };
    t && t.on ? t.on("beforeAddBreadcrumb", (l, u) => pCe(c, l, u)) : (CP(UEe(e)), TP(qEe(e)));
  } catch {
  }
}
function pCe(e, t, n) {
  if (t.data)
    try {
      mCe(t) && yCe(n) && (cCe(t, n, e), sCe(t, n, e)), vCe(t) && bCe(n) && (QEe(t, n, e), XEe(t, n, e));
    } catch {
      rr && xe.warn("Error when enriching network breadcrumb");
    }
}
function mCe(e) {
  return e.category === "xhr";
}
function vCe(e) {
  return e.category === "fetch";
}
function yCe(e) {
  return e && e.xhr;
}
function bCe(e) {
  return e && e.response;
}
let d8 = null;
function _Ce(e) {
  return !!e.category;
}
const SCe = (e) => (t) => {
  if (!e.isEnabled())
    return;
  const n = wCe(t);
  n && iy(e, n);
};
function wCe(e) {
  const t = e.getLastBreadcrumb && e.getLastBreadcrumb();
  return d8 === t || !t || (d8 = t, !_Ce(t) || ["fetch", "xhr", "sentry.event", "sentry.transaction"].includes(t.category) || t.category.startsWith("ui.")) ? null : t.category === "console" ? xCe(t) : Ks(t);
}
function xCe(e) {
  const t = e.data && e.data.arguments;
  if (!Array.isArray(t) || t.length === 0)
    return Ks(e);
  let n = !1;
  const r = t.map((i) => {
    if (!i)
      return i;
    if (typeof i == "string")
      return i.length > Pb ? (n = !0, `${i.slice(0, Pb)}…`) : i;
    if (typeof i == "object")
      try {
        const o = Us(i, 7);
        return JSON.stringify(o).length > Pb ? (n = !0, `${JSON.stringify(o, null, 2).slice(0, Pb)}…`) : o;
      } catch {
      }
    return i;
  });
  return Ks({
    ...e,
    data: {
      ...e.data,
      arguments: r,
      ...n ? { _meta: { warnings: ["CONSOLE_ARG_TRUNCATED"] } } : {}
    }
  });
}
function ECe(e) {
  const t = xa(), n = Yn();
  t.addScopeListener(SCe(e)), Fq(tEe(e)), Cx(BEe(e)), gCe(e);
  const r = FEe(e, !f8(n));
  n && n.addEventProcessor ? n.addEventProcessor(r) : P1e(r), f8(n) && (n.on("beforeSendEvent", kEe(e)), n.on("afterSendEvent", $K(e)), n.on("createDsc", (i) => {
    const o = e.getSessionId();
    o && e.isEnabled() && e.recordingMode === "session" && e.checkAndHandleExpiredSession() && (i.replay_id = o);
  }), n.on("startTransaction", (i) => {
    e.lastTransaction = i;
  }), n.on("finishTransaction", (i) => {
    e.lastTransaction = i;
  }), n.on("beforeSendFeedback", (i, o) => {
    const a = e.getSessionId();
    o && o.includeReplay && e.isEnabled() && a && i.contexts && i.contexts.feedback && (i.contexts.feedback.replay_id = a);
  }));
}
function f8(e) {
  return !!(e && e.on);
}
async function CCe(e) {
  try {
    return Promise.all(
      Dx(e, [
        // @ts-expect-error memory doesn't exist on type Performance as the API is non-standard (we check that it exists above)
        TCe(ur.performance.memory)
      ])
    );
  } catch {
    return [];
  }
}
function TCe(e) {
  const { jsHeapSizeLimit: t, totalJSHeapSize: n, usedJSHeapSize: r } = e, i = Date.now() / 1e3;
  return {
    type: "memory",
    name: "memory",
    start: i,
    end: i,
    data: {
      memory: {
        jsHeapSizeLimit: t,
        totalJSHeapSize: n,
        usedJSHeapSize: r
      }
    }
  };
}
function ICe(e, t, n) {
  let r, i, o;
  const a = n && n.maxWait ? Math.max(n.maxWait, t) : 0;
  function s() {
    return c(), r = e(), r;
  }
  function c() {
    i !== void 0 && clearTimeout(i), o !== void 0 && clearTimeout(o), i = o = void 0;
  }
  function l() {
    return i !== void 0 || o !== void 0 ? s() : r;
  }
  function u() {
    return i && clearTimeout(i), i = setTimeout(s, t), a && o === void 0 && (o = setTimeout(s, a)), r;
  }
  return u.cancel = c, u.flush = l, u;
}
function ACe(e) {
  let t = !1;
  return (n, r) => {
    if (!e.checkAndHandleExpiredSession()) {
      rr && xe.warn("[Replay] Received replay event after session expired.");
      return;
    }
    const i = r || !t;
    t = !0, e.clickDetector && Xxe(e.clickDetector, n), e.addUpdate(() => {
      if (e.recordingMode === "buffer" && i && e.setInitialState(), !JP(e, n, i))
        return !0;
      if (!i)
        return !1;
      if ($Ce(e, i), e.session && e.session.previousSessionId)
        return !0;
      if (e.recordingMode === "buffer" && e.session && e.eventBuffer) {
        const o = e.eventBuffer.getEarliestTimestamp();
        o && (xo(
          `[Replay] Updating session start time to earliest event in buffer to ${new Date(o)}`,
          e.getOptions()._experiments.traceInternals
        ), e.session.started = o, e.getOptions().stickySession && QP(e.session));
      }
      return e.recordingMode === "session" && e.flush(), !0;
    });
  };
}
function RCe(e) {
  const t = e.getOptions();
  return {
    type: dn.Custom,
    timestamp: Date.now(),
    data: {
      tag: "options",
      payload: {
        shouldRecordCanvas: e.isRecordingCanvas(),
        sessionSampleRate: t.sessionSampleRate,
        errorSampleRate: t.errorSampleRate,
        useCompressionOption: t.useCompression,
        blockAllMedia: t.blockAllMedia,
        maskAllText: t.maskAllText,
        maskAllInputs: t.maskAllInputs,
        useCompression: e.eventBuffer ? e.eventBuffer.type === "worker" : !1,
        networkDetailHasUrls: t.networkDetailAllowUrls.length > 0,
        networkCaptureBodies: t.networkCaptureBodies,
        networkRequestHasHeaders: t.networkRequestHeaders.length > 0,
        networkResponseHasHeaders: t.networkResponseHeaders.length > 0
      }
    }
  };
}
function $Ce(e, t) {
  !t || !e.session || e.session.segmentId !== 0 || JP(e, RCe(e), !1);
}
function OCe(e, t, n, r) {
  return Vu(
    Gq(e, RP(e), r, n),
    [
      [{ type: "replay_event" }, e],
      [
        {
          type: "replay_recording",
          // If string then we need to encode to UTF8, otherwise will have
          // wrong size. TextEncoder has similar browser support to
          // MutationObserver, although it does not accept IE11.
          length: typeof t == "string" ? new TextEncoder().encode(t).length : t.length
        },
        t
      ]
    ]
  );
}
function PCe({
  recordingData: e,
  headers: t
}) {
  let n;
  const r = `${JSON.stringify(t)}
`;
  if (typeof e == "string")
    n = `${r}${e}`;
  else {
    const o = new TextEncoder().encode(r);
    n = new Uint8Array(o.length + e.length), n.set(o), n.set(e, o.length);
  }
  return n;
}
async function MCe({
  client: e,
  scope: t,
  replayId: n,
  event: r
}) {
  const i = typeof e._integrations == "object" && e._integrations !== null && !Array.isArray(e._integrations) ? Object.keys(e._integrations) : void 0, o = { event_id: n, integrations: i };
  e.emit && e.emit("preprocessEvent", r, o);
  const a = await Zq(
    e.getOptions(),
    r,
    o,
    t,
    e,
    Bu()
  );
  if (!a)
    return null;
  a.platform = a.platform || "javascript";
  const s = e.getSdkMetadata && e.getSdkMetadata(), { name: c, version: l } = s && s.sdk || {};
  return a.sdk = {
    ...a.sdk,
    name: c || "sentry.javascript.unknown",
    version: l || "0.0.0"
  }, a;
}
async function kCe({
  recordingData: e,
  replayId: t,
  segmentId: n,
  eventContext: r,
  timestamp: i,
  session: o
}) {
  const a = PCe({
    recordingData: e,
    headers: {
      segment_id: n
    }
  }), { urls: s, errorIds: c, traceIds: l, initialTimestamp: u } = r, d = Yn(), f = xa(), h = d && d.getTransport(), p = d && d.getDsn();
  if (!d || !h || !p || !o.sampled)
    return;
  const g = {
    type: ywe,
    replay_start_timestamp: u / 1e3,
    timestamp: i / 1e3,
    error_ids: c,
    trace_ids: l,
    urls: s,
    replay_id: t,
    segment_id: n,
    replay_type: o.sampled
  }, m = await MCe({ scope: f, client: d, replayId: t, event: g });
  if (!m) {
    d.recordDroppedEvent("event_processor", "replay", g), xo("An event processor returned `null`, will not send event.");
    return;
  }
  delete m.sdkProcessingMetadata;
  const v = OCe(m, a, p, d.getOptions().tunnel);
  let y;
  try {
    y = await h.send(v);
  } catch (_) {
    const w = new Error(BP);
    try {
      w.cause = _;
    } catch {
    }
    throw w;
  }
  if (!y)
    return y;
  if (typeof y.statusCode == "number" && (y.statusCode < 200 || y.statusCode >= 300))
    throw new LK(y.statusCode);
  const S = Yq({}, y);
  if (Kq(S, "replay"))
    throw new jK(S);
  return y;
}
class LK extends Error {
  constructor(t) {
    super(`Transport returned status code ${t}`);
  }
}
class jK extends Error {
  constructor(t) {
    super("Rate limit hit"), this.rateLimits = t;
  }
}
async function FK(e, t = {
  count: 0,
  interval: Ewe
}) {
  const { recordingData: n, options: r } = e;
  if (n.length)
    try {
      return await kCe(e), !0;
    } catch (i) {
      if (i instanceof LK || i instanceof jK)
        throw i;
      if (Bbe("Replays", {
        _retryCount: t.count
      }), rr && r._experiments && r._experiments.captureExceptions && Rx(i), t.count >= Cwe) {
        const o = new Error(`${BP} - max retries exceeded`);
        try {
          o.cause = i;
        } catch {
        }
        throw o;
      }
      return t.interval *= ++t.count, new Promise((o, a) => {
        setTimeout(async () => {
          try {
            await FK(e, t), o(!0);
          } catch (s) {
            a(s);
          }
        }, t.interval);
      });
    }
}
const VK = "__THROTTLED", NCe = "__SKIPPED";
function DCe(e, t, n) {
  const r = /* @__PURE__ */ new Map(), i = (s) => {
    const c = s - n;
    r.forEach((l, u) => {
      u < c && r.delete(u);
    });
  }, o = () => [...r.values()].reduce((s, c) => s + c, 0);
  let a = !1;
  return (...s) => {
    const c = Math.floor(Date.now() / 1e3);
    if (i(c), o() >= t) {
      const u = a;
      return a = !0, u ? NCe : VK;
    }
    a = !1;
    const l = r.get(c) || 0;
    return r.set(c, l + 1), e(...s);
  };
}
class Dl {
  /**
   * Recording can happen in one of three modes:
   *   - session: Record the whole session, sending it continuously
   *   - buffer: Always keep the last 60s of recording, requires:
   *     - having replaysOnErrorSampleRate > 0 to capture replay when an error occurs
   *     - or calling `flush()` to send the replay
   */
  /**
   * The current or last active transcation.
   * This is only available when performance is enabled.
   */
  /**
   * These are here so we can overwrite them in tests etc.
   * @hidden
   */
  /**
   * Options to pass to `rrweb.record()`
   */
  /**
   * Timestamp of the last user activity. This lives across sessions.
   */
  /**
   * Is the integration currently active?
   */
  /**
   * Paused is a state where:
   * - DOM Recording is not listening at all
   * - Nothing will be added to event buffer (e.g. core SDK events)
   */
  /**
   * Have we attached listeners to the core SDK?
   * Note we have to track this as there is no way to remove instrumentation handlers.
   */
  /**
   * Function to stop recording
   */
  /**
   * Internal use for canvas recording options
   */
  constructor({
    options: t,
    recordingOptions: n
  }) {
    Dl.prototype.__init.call(this), Dl.prototype.__init2.call(this), Dl.prototype.__init3.call(this), Dl.prototype.__init4.call(this), Dl.prototype.__init5.call(this), Dl.prototype.__init6.call(this), this.eventBuffer = null, this.performanceEntries = [], this.replayPerformanceEntries = [], this.recordingMode = "session", this.timeouts = {
      sessionIdlePause: bwe,
      sessionIdleExpire: _we
    }, this._lastActivity = Date.now(), this._isEnabled = !1, this._isPaused = !1, this._hasInitializedCoreListeners = !1, this._context = {
      errorIds: /* @__PURE__ */ new Set(),
      traceIds: /* @__PURE__ */ new Set(),
      urls: [],
      initialTimestamp: Date.now(),
      initialUrl: ""
    }, this._recordingOptions = n, this._options = t, this._debouncedFlush = ICe(() => this._flush(), this._options.flushMinDelay, {
      maxWait: this._options.flushMaxDelay
    }), this._throttledAddEvent = DCe(
      (a, s) => AEe(this, a, s),
      // Max 300 events...
      300,
      // ... per 5s
      5
    );
    const { slowClickTimeout: r, slowClickIgnoreSelectors: i } = this.getOptions(), o = r ? {
      threshold: Math.min(Twe, r),
      timeout: r,
      scrollTimeout: Iwe,
      ignoreSelector: i ? i.join(",") : ""
    } : void 0;
    o && (this.clickDetector = new qxe(this, o));
  }
  /** Get the event context. */
  getContext() {
    return this._context;
  }
  /** If recording is currently enabled. */
  isEnabled() {
    return this._isEnabled;
  }
  /** If recording is currently paused. */
  isPaused() {
    return this._isPaused;
  }
  /**
   * Determine if canvas recording is enabled
   */
  isRecordingCanvas() {
    return !!this._canvas;
  }
  /** Get the replay integration options. */
  getOptions() {
    return this._options;
  }
  /**
   * Initializes the plugin based on sampling configuration. Should not be
   * called outside of constructor.
   */
  initializeSampling(t) {
    const { errorSampleRate: n, sessionSampleRate: r } = this._options;
    if (!(n <= 0 && r <= 0)) {
      if (this._initializeSessionForSampling(t), !this.session) {
        this._handleException(new Error("Unable to initialize and create session"));
        return;
      }
      this.session.sampled !== !1 && (this.recordingMode = this.session.sampled === "buffer" && this.session.segmentId === 0 ? "buffer" : "session", Yh(
        `[Replay] Starting replay in ${this.recordingMode} mode`,
        this._options._experiments.traceInternals
      ), this._initializeRecording());
    }
  }
  /**
   * Start a replay regardless of sampling rate. Calling this will always
   * create a new session. Will throw an error if replay is already in progress.
   *
   * Creates or loads a session, attaches listeners to varying events (DOM,
   * _performanceObserver, Recording, Sentry SDK, etc)
   */
  start() {
    if (this._isEnabled && this.recordingMode === "session")
      throw new Error("Replay recording is already in progress");
    if (this._isEnabled && this.recordingMode === "buffer")
      throw new Error("Replay buffering is in progress, call `flush()` to save the replay");
    Yh("[Replay] Starting replay in session mode", this._options._experiments.traceInternals), this._updateUserActivity();
    const t = b5(
      {
        maxReplayDuration: this._options.maxReplayDuration,
        sessionIdleExpire: this.timeouts.sessionIdleExpire,
        traceInternals: this._options._experiments.traceInternals
      },
      {
        stickySession: this._options.stickySession,
        // This is intentional: create a new session-based replay when calling `start()`
        sessionSampleRate: 1,
        allowBuffering: !1
      }
    );
    this.session = t, this._initializeRecording();
  }
  /**
   * Start replay buffering. Buffers until `flush()` is called or, if
   * `replaysOnErrorSampleRate` > 0, an error occurs.
   */
  startBuffering() {
    if (this._isEnabled)
      throw new Error("Replay recording is already in progress");
    Yh("[Replay] Starting replay in buffer mode", this._options._experiments.traceInternals);
    const t = b5(
      {
        sessionIdleExpire: this.timeouts.sessionIdleExpire,
        maxReplayDuration: this._options.maxReplayDuration,
        traceInternals: this._options._experiments.traceInternals
      },
      {
        stickySession: this._options.stickySession,
        sessionSampleRate: 0,
        allowBuffering: !0
      }
    );
    this.session = t, this.recordingMode = "buffer", this._initializeRecording();
  }
  /**
   * Start recording.
   *
   * Note that this will cause a new DOM checkout
   */
  startRecording() {
    try {
      const t = this._canvas;
      this._stopRecording = su({
        ...this._recordingOptions,
        // When running in error sampling mode, we need to overwrite `checkoutEveryNms`
        // Without this, it would record forever, until an error happens, which we don't want
        // instead, we'll always keep the last 60 seconds of replay before an error happened
        ...this.recordingMode === "buffer" && { checkoutEveryNms: xwe },
        emit: ACe(this),
        onMutation: this._onMutationHandler,
        ...t ? {
          recordCanvas: t.recordCanvas,
          getCanvasManager: t.getCanvasManager,
          sampling: t.sampling,
          dataURLOptions: t.dataURLOptions
        } : {}
      });
    } catch (t) {
      this._handleException(t);
    }
  }
  /**
   * Stops the recording, if it was running.
   *
   * Returns true if it was previously stopped, or is now stopped,
   * otherwise false.
   */
  stopRecording() {
    try {
      return this._stopRecording && (this._stopRecording(), this._stopRecording = void 0), !0;
    } catch (t) {
      return this._handleException(t), !1;
    }
  }
  /**
   * Currently, this needs to be manually called (e.g. for tests). Sentry SDK
   * does not support a teardown
   */
  async stop({ forceFlush: t = !1, reason: n } = {}) {
    if (this._isEnabled) {
      this._isEnabled = !1;
      try {
        xo(
          `[Replay] Stopping Replay${n ? ` triggered by ${n}` : ""}`,
          this._options._experiments.traceInternals
        ), this._removeListeners(), this.stopRecording(), this._debouncedFlush.cancel(), t && await this._flush({ force: !0 }), this.eventBuffer && this.eventBuffer.destroy(), this.eventBuffer = null, xEe(this);
      } catch (r) {
        this._handleException(r);
      }
    }
  }
  /**
   * Pause some replay functionality. See comments for `_isPaused`.
   * This differs from stop as this only stops DOM recording, it is
   * not as thorough of a shutdown as `stop()`.
   */
  pause() {
    this._isPaused || (this._isPaused = !0, this.stopRecording(), xo("[Replay] Pausing replay", this._options._experiments.traceInternals));
  }
  /**
   * Resumes recording, see notes for `pause().
   *
   * Note that calling `startRecording()` here will cause a
   * new DOM checkout.`
   */
  resume() {
    !this._isPaused || !this._checkSession() || (this._isPaused = !1, this.startRecording(), xo("[Replay] Resuming replay", this._options._experiments.traceInternals));
  }
  /**
   * If not in "session" recording mode, flush event buffer which will create a new replay.
   * Unless `continueRecording` is false, the replay will continue to record and
   * behave as a "session"-based replay.
   *
   * Otherwise, queue up a flush.
   */
  async sendBufferedReplayOrFlush({ continueRecording: t = !0 } = {}) {
    if (this.recordingMode === "session")
      return this.flushImmediate();
    const n = Date.now();
    xo("[Replay] Converting buffer to session", this._options._experiments.traceInternals), await this.flushImmediate();
    const r = this.stopRecording();
    !t || !r || this.recordingMode !== "session" && (this.recordingMode = "session", this.session && (this._updateUserActivity(n), this._updateSessionActivity(n), this._maybeSaveSession()), this.startRecording());
  }
  /**
   * We want to batch uploads of replay events. Save events only if
   * `<flushMinDelay>` milliseconds have elapsed since the last event
   * *OR* if `<flushMaxDelay>` milliseconds have elapsed.
   *
   * Accepts a callback to perform side-effects and returns true to stop batch
   * processing and hand back control to caller.
   */
  addUpdate(t) {
    const n = t();
    this.recordingMode !== "buffer" && n !== !0 && this._debouncedFlush();
  }
  /**
   * Updates the user activity timestamp and resumes recording. This should be
   * called in an event handler for a user action that we consider as the user
   * being "active" (e.g. a mouse click).
   */
  triggerUserActivity() {
    if (this._updateUserActivity(), !this._stopRecording) {
      if (!this._checkSession())
        return;
      this.resume();
      return;
    }
    this.checkAndHandleExpiredSession(), this._updateSessionActivity();
  }
  /**
   * Updates the user activity timestamp *without* resuming
   * recording. Some user events (e.g. keydown) can be create
   * low-value replays that only contain the keypress as a
   * breadcrumb. Instead this would require other events to
   * create a new replay after a session has expired.
   */
  updateUserActivity() {
    this._updateUserActivity(), this._updateSessionActivity();
  }
  /**
   * Only flush if `this.recordingMode === 'session'`
   */
  conditionalFlush() {
    return this.recordingMode === "buffer" ? Promise.resolve() : this.flushImmediate();
  }
  /**
   * Flush using debounce flush
   */
  flush() {
    return this._debouncedFlush();
  }
  /**
   * Always flush via `_debouncedFlush` so that we do not have flushes triggered
   * from calling both `flush` and `_debouncedFlush`. Otherwise, there could be
   * cases of mulitple flushes happening closely together.
   */
  flushImmediate() {
    return this._debouncedFlush(), this._debouncedFlush.flush();
  }
  /**
   * Cancels queued up flushes.
   */
  cancelFlush() {
    this._debouncedFlush.cancel();
  }
  /** Get the current sesion (=replay) ID */
  getSessionId() {
    return this.session && this.session.id;
  }
  /**
   * Checks if recording should be stopped due to user inactivity. Otherwise
   * check if session is expired and create a new session if so. Triggers a new
   * full snapshot on new session.
   *
   * Returns true if session is not expired, false otherwise.
   * @hidden
   */
  checkAndHandleExpiredSession() {
    if (this._lastActivity && TA(this._lastActivity, this.timeouts.sessionIdlePause) && this.session && this.session.sampled === "session") {
      this.pause();
      return;
    }
    return !!this._checkSession();
  }
  /**
   * Capture some initial state that can change throughout the lifespan of the
   * replay. This is required because otherwise they would be captured at the
   * first flush.
   */
  setInitialState() {
    const t = `${ur.location.pathname}${ur.location.hash}${ur.location.search}`, n = `${ur.location.origin}${t}`;
    this.performanceEntries = [], this.replayPerformanceEntries = [], this._clearContext(), this._context.initialUrl = n, this._context.initialTimestamp = Date.now(), this._context.urls.push(n);
  }
  /**
   * Add a breadcrumb event, that may be throttled.
   * If it was throttled, we add a custom breadcrumb to indicate that.
   */
  throttledAddEvent(t, n) {
    const r = this._throttledAddEvent(t, n);
    if (r === VK) {
      const i = Ks({
        category: "replay.throttled"
      });
      this.addUpdate(() => !JP(this, {
        type: Vxe,
        timestamp: i.timestamp || 0,
        data: {
          tag: "breadcrumb",
          payload: i,
          metric: !0
        }
      }));
    }
    return r;
  }
  /**
   * This will get the parametrized route name of the current page.
   * This is only available if performance is enabled, and if an instrumented router is used.
   */
  getCurrentRoute() {
    const t = this.lastTransaction || xa().getTransaction(), r = (t && Ui(t).data || {})[Dd];
    if (!(!t || !r || !["route", "custom"].includes(r)))
      return Ui(t).description;
  }
  /**
   * Initialize and start all listeners to varying events (DOM,
   * Performance Observer, Recording, Sentry SDK, etc)
   */
  _initializeRecording() {
    this.setInitialState(), this._updateSessionActivity(), this.eventBuffer = _Ee({
      useCompression: this._options.useCompression,
      workerUrl: this._options.workerUrl
    }), this._removeListeners(), this._addListeners(), this._isEnabled = !0, this._isPaused = !1, this.startRecording();
  }
  /** A wrapper to conditionally capture exceptions. */
  _handleException(t) {
    rr && xe.error("[Replay]", t), rr && this._options._experiments && this._options._experiments.captureExceptions && Rx(t);
  }
  /**
   * Loads (or refreshes) the current session.
   */
  _initializeSessionForSampling(t) {
    const n = this._options.errorSampleRate > 0, r = b5(
      {
        sessionIdleExpire: this.timeouts.sessionIdleExpire,
        maxReplayDuration: this._options.maxReplayDuration,
        traceInternals: this._options._experiments.traceInternals,
        previousSessionId: t
      },
      {
        stickySession: this._options.stickySession,
        sessionSampleRate: this._options.sessionSampleRate,
        allowBuffering: n
      }
    );
    this.session = r;
  }
  /**
   * Checks and potentially refreshes the current session.
   * Returns false if session is not recorded.
   */
  _checkSession() {
    if (!this.session)
      return !1;
    const t = this.session;
    return IK(t, {
      sessionIdleExpire: this.timeouts.sessionIdleExpire,
      maxReplayDuration: this._options.maxReplayDuration
    }) ? (this._refreshSession(t), !1) : !0;
  }
  /**
   * Refresh a session with a new one.
   * This stops the current session (without forcing a flush, as that would never work since we are expired),
   * and then does a new sampling based on the refreshed session.
   */
  async _refreshSession(t) {
    this._isEnabled && (await this.stop({ reason: "refresh session" }), this.initializeSampling(t.id));
  }
  /**
   * Adds listeners to record events for the replay
   */
  _addListeners() {
    try {
      ur.document.addEventListener("visibilitychange", this._handleVisibilityChange), ur.addEventListener("blur", this._handleWindowBlur), ur.addEventListener("focus", this._handleWindowFocus), ur.addEventListener("keydown", this._handleKeyboardEvent), this.clickDetector && this.clickDetector.addListeners(), this._hasInitializedCoreListeners || (ECe(this), this._hasInitializedCoreListeners = !0);
    } catch (t) {
      this._handleException(t);
    }
    this._performanceCleanupCallback = gEe(this);
  }
  /**
   * Cleans up listeners that were created in `_addListeners`
   */
  _removeListeners() {
    try {
      ur.document.removeEventListener("visibilitychange", this._handleVisibilityChange), ur.removeEventListener("blur", this._handleWindowBlur), ur.removeEventListener("focus", this._handleWindowFocus), ur.removeEventListener("keydown", this._handleKeyboardEvent), this.clickDetector && this.clickDetector.removeListeners(), this._performanceCleanupCallback && this._performanceCleanupCallback();
    } catch (t) {
      this._handleException(t);
    }
  }
  /**
   * Handle when visibility of the page content changes. Opening a new tab will
   * cause the state to change to hidden because of content of current page will
   * be hidden. Likewise, moving a different window to cover the contents of the
   * page will also trigger a change to a hidden state.
   */
  __init() {
    this._handleVisibilityChange = () => {
      ur.document.visibilityState === "visible" ? this._doChangeToForegroundTasks() : this._doChangeToBackgroundTasks();
    };
  }
  /**
   * Handle when page is blurred
   */
  __init2() {
    this._handleWindowBlur = () => {
      const t = Ks({
        category: "ui.blur"
      });
      this._doChangeToBackgroundTasks(t);
    };
  }
  /**
   * Handle when page is focused
   */
  __init3() {
    this._handleWindowFocus = () => {
      const t = Ks({
        category: "ui.focus"
      });
      this._doChangeToForegroundTasks(t);
    };
  }
  /** Ensure page remains active when a key is pressed. */
  __init4() {
    this._handleKeyboardEvent = (t) => {
      oEe(this, t);
    };
  }
  /**
   * Tasks to run when we consider a page to be hidden (via blurring and/or visibility)
   */
  _doChangeToBackgroundTasks(t) {
    !this.session || TK(this.session, {
      maxReplayDuration: this._options.maxReplayDuration,
      sessionIdleExpire: this.timeouts.sessionIdleExpire
    }) || (t && this._createCustomBreadcrumb(t), this.conditionalFlush());
  }
  /**
   * Tasks to run when we consider a page to be visible (via focus and/or visibility)
   */
  _doChangeToForegroundTasks(t) {
    if (!this.session)
      return;
    if (!this.checkAndHandleExpiredSession()) {
      xo("[Replay] Document has become active, but session has expired");
      return;
    }
    t && this._createCustomBreadcrumb(t);
  }
  /**
   * Update user activity (across session lifespans)
   */
  _updateUserActivity(t = Date.now()) {
    this._lastActivity = t;
  }
  /**
   * Updates the session's last activity timestamp
   */
  _updateSessionActivity(t = Date.now()) {
    this.session && (this.session.lastActivity = t, this._maybeSaveSession());
  }
  /**
   * Helper to create (and buffer) a replay breadcrumb from a core SDK breadcrumb
   */
  _createCustomBreadcrumb(t) {
    this.addUpdate(() => {
      this.throttledAddEvent({
        type: dn.Custom,
        timestamp: t.timestamp || 0,
        data: {
          tag: "breadcrumb",
          payload: t
        }
      });
    });
  }
  /**
   * Observed performance events are added to `this.performanceEntries`. These
   * are included in the replay event before it is finished and sent to Sentry.
   */
  _addPerformanceEntries() {
    const t = cEe(this.performanceEntries).concat(this.replayPerformanceEntries);
    return this.performanceEntries = [], this.replayPerformanceEntries = [], Promise.all(Dx(this, t));
  }
  /**
   * Clear _context
   */
  _clearContext() {
    this._context.errorIds.clear(), this._context.traceIds.clear(), this._context.urls = [];
  }
  /** Update the initial timestamp based on the buffer content. */
  _updateInitialTimestampFromEventBuffer() {
    const { session: t, eventBuffer: n } = this;
    if (!t || !n || t.segmentId)
      return;
    const r = n.getEarliestTimestamp();
    r && r < this._context.initialTimestamp && (this._context.initialTimestamp = r);
  }
  /**
   * Return and clear _context
   */
  _popEventContext() {
    const t = {
      initialTimestamp: this._context.initialTimestamp,
      initialUrl: this._context.initialUrl,
      errorIds: Array.from(this._context.errorIds),
      traceIds: Array.from(this._context.traceIds),
      urls: this._context.urls
    };
    return this._clearContext(), t;
  }
  /**
   * Flushes replay event buffer to Sentry.
   *
   * Performance events are only added right before flushing - this is
   * due to the buffered performance observer events.
   *
   * Should never be called directly, only by `flush`
   */
  async _runFlush() {
    const t = this.getSessionId();
    if (!this.session || !this.eventBuffer || !t) {
      rr && xe.error("[Replay] No session or eventBuffer found to flush.");
      return;
    }
    if (await this._addPerformanceEntries(), !(!this.eventBuffer || !this.eventBuffer.hasEvents) && (await CCe(this), !!this.eventBuffer && t === this.getSessionId()))
      try {
        this._updateInitialTimestampFromEventBuffer();
        const n = Date.now();
        if (n - this._context.initialTimestamp > this._options.maxReplayDuration + 3e4)
          throw new Error("Session is too long, not sending replay");
        const r = this._popEventContext(), i = this.session.segmentId++;
        this._maybeSaveSession();
        const o = await this.eventBuffer.finish();
        await FK({
          replayId: t,
          recordingData: o,
          segmentId: i,
          eventContext: r,
          session: this.session,
          options: this.getOptions(),
          timestamp: n
        });
      } catch (n) {
        this._handleException(n), this.stop({ reason: "sendReplay" });
        const r = Yn();
        r && r.recordDroppedEvent("send_error", "replay");
      }
  }
  /**
   * Flush recording data to Sentry. Creates a lock so that only a single flush
   * can be active at a time. Do not call this directly.
   */
  __init5() {
    this._flush = async ({
      force: t = !1
    } = {}) => {
      if (!this._isEnabled && !t)
        return;
      if (!this.checkAndHandleExpiredSession()) {
        rr && xe.error("[Replay] Attempting to finish replay event after session expired.");
        return;
      }
      if (!this.session)
        return;
      const n = this.session.started, i = Date.now() - n;
      this._debouncedFlush.cancel();
      const o = i < this._options.minReplayDuration, a = i > this._options.maxReplayDuration + 5e3;
      if (o || a) {
        xo(
          `[Replay] Session duration (${Math.floor(i / 1e3)}s) is too ${o ? "short" : "long"}, not sending replay.`,
          this._options._experiments.traceInternals
        ), o && this._debouncedFlush();
        return;
      }
      const s = this.eventBuffer;
      if (s && this.session.segmentId === 0 && !s.hasCheckout && xo("[Replay] Flushing initial segment without checkout.", this._options._experiments.traceInternals), !this._flushLock) {
        this._flushLock = this._runFlush(), await this._flushLock, this._flushLock = void 0;
        return;
      }
      try {
        await this._flushLock;
      } catch (c) {
        rr && xe.error(c);
      } finally {
        this._debouncedFlush();
      }
    };
  }
  /** Save the session, if it is sticky */
  _maybeSaveSession() {
    this.session && this._options.stickySession && QP(this.session);
  }
  /** Handler for rrweb.record.onMutation */
  __init6() {
    this._onMutationHandler = (t) => {
      const n = t.length, r = this._options.mutationLimit, i = this._options.mutationBreadcrumbLimit, o = r && n > r;
      if (n > i || o) {
        const a = Ks({
          category: "replay.mutations",
          data: {
            count: n,
            limit: o
          }
        });
        this._createCustomBreadcrumb(a);
      }
      return o ? (this.stop({ reason: "mutationLimit", forceFlush: this.recordingMode === "session" }), !1) : !0;
    };
  }
}
function lm(e, t, n, r) {
  const i = typeof r == "string" ? r.split(",") : [], o = [
    ...e,
    // @deprecated
    ...i,
    // sentry defaults
    ...t
  ];
  return typeof n < "u" && (typeof n == "string" && o.push(`.${n}`), tf(() => {
    console.warn(
      "[Replay] You are using a deprecated configuration item for privacy. Read the documentation on how to use the new privacy configuration."
    );
  })), o.join(",");
}
function LCe({
  mask: e,
  unmask: t,
  block: n,
  unblock: r,
  ignore: i,
  // eslint-disable-next-line deprecation/deprecation
  blockClass: o,
  // eslint-disable-next-line deprecation/deprecation
  blockSelector: a,
  // eslint-disable-next-line deprecation/deprecation
  maskTextClass: s,
  // eslint-disable-next-line deprecation/deprecation
  maskTextSelector: c,
  // eslint-disable-next-line deprecation/deprecation
  ignoreClass: l
}) {
  const u = ['base[href="/"]'], d = lm(e, [".sentry-mask", "[data-sentry-mask]"], s, c), f = lm(t, [".sentry-unmask", "[data-sentry-unmask]"]), h = {
    // We are making the decision to make text and input selectors the same
    maskTextSelector: d,
    unmaskTextSelector: f,
    blockSelector: lm(
      n,
      [".sentry-block", "[data-sentry-block]", ...u],
      o,
      a
    ),
    unblockSelector: lm(r, [".sentry-unblock", "[data-sentry-unblock]"]),
    ignoreSelector: lm(i, [".sentry-ignore", "[data-sentry-ignore]", 'input[type="file"]'], l)
  };
  return o instanceof RegExp && (h.blockClass = o), s instanceof RegExp && (h.maskTextClass = s), h;
}
function jCe({
  el: e,
  key: t,
  maskAttributes: n,
  maskAllText: r,
  privacyOptions: i,
  value: o
}) {
  return !r || i.unmaskTextSelector && e.matches(i.unmaskTextSelector) ? o : n.includes(t) || // Need to mask `value` attribute for `<input>` if it's a button-like
  // type
  t === "value" && e.tagName === "INPUT" && ["submit", "button"].includes(e.getAttribute("type") || "") ? o.replace(/[\S]/g, "*") : o;
}
const h8 = 'img,image,svg,video,object,picture,embed,map,audio,link[rel="icon"],link[rel="apple-touch-icon"]', FCe = ["content-length", "content-type", "accept"];
let g8 = !1;
class Fx {
  /**
   * @inheritDoc
   */
  static __initStatic() {
    this.id = "Replay";
  }
  /**
   * @inheritDoc
   */
  /**
   * Options to pass to `rrweb.record()`
   */
  /**
   * Initial options passed to the replay integration, merged with default values.
   * Note: `sessionSampleRate` and `errorSampleRate` are not required here, as they
   * can only be finally set when setupOnce() is called.
   *
   * @private
   */
  constructor({
    flushMinDelay: t = Swe,
    flushMaxDelay: n = wwe,
    minReplayDuration: r = Awe,
    maxReplayDuration: i = K4,
    stickySession: o = !0,
    useCompression: a = !0,
    workerUrl: s,
    _experiments: c = {},
    sessionSampleRate: l,
    errorSampleRate: u,
    maskAllText: d = !0,
    maskAllInputs: f = !0,
    blockAllMedia: h = !0,
    mutationBreadcrumbLimit: p = 750,
    mutationLimit: g = 1e4,
    slowClickTimeout: m = 7e3,
    slowClickIgnoreSelectors: v = [],
    networkDetailAllowUrls: y = [],
    networkDetailDenyUrls: S = [],
    networkCaptureBodies: _ = !0,
    networkRequestHeaders: w = [],
    networkResponseHeaders: T = [],
    mask: x = [],
    maskAttributes: C = ["title", "placeholder"],
    unmask: E = [],
    block: R = [],
    unblock: A = [],
    ignore: O = [],
    maskFn: $,
    beforeAddRecordingEvent: N,
    beforeErrorSampling: z,
    // eslint-disable-next-line deprecation/deprecation
    blockClass: k,
    // eslint-disable-next-line deprecation/deprecation
    blockSelector: F,
    // eslint-disable-next-line deprecation/deprecation
    maskInputOptions: V,
    // eslint-disable-next-line deprecation/deprecation
    maskTextClass: j,
    // eslint-disable-next-line deprecation/deprecation
    maskTextSelector: B,
    // eslint-disable-next-line deprecation/deprecation
    ignoreClass: U
  } = {}) {
    this.name = Fx.id;
    const Q = LCe({
      mask: x,
      unmask: E,
      block: R,
      unblock: A,
      ignore: O,
      blockClass: k,
      blockSelector: F,
      maskTextClass: j,
      maskTextSelector: B,
      ignoreClass: U
    });
    if (this._recordingOptions = {
      maskAllInputs: f,
      maskAllText: d,
      maskInputOptions: { ...V || {}, password: !0 },
      maskTextFn: $,
      maskInputFn: $,
      maskAttributeFn: (K, q, X) => jCe({
        maskAttributes: C,
        maskAllText: d,
        privacyOptions: Q,
        key: K,
        value: q,
        el: X
      }),
      ...Q,
      // Our defaults
      slimDOMOptions: "all",
      inlineStylesheet: !0,
      // Disable inline images as it will increase segment/replay size
      inlineImages: !1,
      // collect fonts, but be aware that `sentry.io` needs to be an allowed
      // origin for playback
      collectFonts: !0,
      errorHandler: (K) => {
        try {
          K.__rrweb__ = !0;
        } catch {
        }
      }
    }, this._initialOptions = {
      flushMinDelay: t,
      flushMaxDelay: n,
      minReplayDuration: Math.min(r, Rwe),
      maxReplayDuration: Math.min(i, K4),
      stickySession: o,
      sessionSampleRate: l,
      errorSampleRate: u,
      useCompression: a,
      workerUrl: s,
      blockAllMedia: h,
      maskAllInputs: f,
      maskAllText: d,
      mutationBreadcrumbLimit: p,
      mutationLimit: g,
      slowClickTimeout: m,
      slowClickIgnoreSelectors: v,
      networkDetailAllowUrls: y,
      networkDetailDenyUrls: S,
      networkCaptureBodies: _,
      networkRequestHeaders: p8(w),
      networkResponseHeaders: p8(T),
      beforeAddRecordingEvent: N,
      beforeErrorSampling: z,
      _experiments: c
    }, typeof l == "number" && (console.warn(
      `[Replay] You are passing \`sessionSampleRate\` to the Replay integration.
This option is deprecated and will be removed soon.
Instead, configure \`replaysSessionSampleRate\` directly in the SDK init options, e.g.:
Sentry.init({ replaysSessionSampleRate: ${l} })`
    ), this._initialOptions.sessionSampleRate = l), typeof u == "number" && (console.warn(
      `[Replay] You are passing \`errorSampleRate\` to the Replay integration.
This option is deprecated and will be removed soon.
Instead, configure \`replaysOnErrorSampleRate\` directly in the SDK init options, e.g.:
Sentry.init({ replaysOnErrorSampleRate: ${u} })`
    ), this._initialOptions.errorSampleRate = u), this._initialOptions.blockAllMedia && (this._recordingOptions.blockSelector = this._recordingOptions.blockSelector ? `${this._recordingOptions.blockSelector},${h8}` : h8), this._isInitialized && g4())
      throw new Error("Multiple Sentry Session Replay instances are not supported");
    this._isInitialized = !0;
  }
  /** If replay has already been initialized */
  get _isInitialized() {
    return g8;
  }
  /** Update _isInitialized */
  set _isInitialized(t) {
    g8 = t;
  }
  /**
   * Setup and initialize replay container
   */
  setupOnce() {
    g4() && (this._setup(), setTimeout(() => this._initialize()));
  }
  /**
   * Start a replay regardless of sampling rate. Calling this will always
   * create a new session. Will throw an error if replay is already in progress.
   *
   * Creates or loads a session, attaches listeners to varying events (DOM,
   * PerformanceObserver, Recording, Sentry SDK, etc)
   */
  start() {
    this._replay && this._replay.start();
  }
  /**
   * Start replay buffering. Buffers until `flush()` is called or, if
   * `replaysOnErrorSampleRate` > 0, until an error occurs.
   */
  startBuffering() {
    this._replay && this._replay.startBuffering();
  }
  /**
   * Currently, this needs to be manually called (e.g. for tests). Sentry SDK
   * does not support a teardown
   */
  stop() {
    return this._replay ? this._replay.stop({ forceFlush: this._replay.recordingMode === "session" }) : Promise.resolve();
  }
  /**
   * If not in "session" recording mode, flush event buffer which will create a new replay.
   * Unless `continueRecording` is false, the replay will continue to record and
   * behave as a "session"-based replay.
   *
   * Otherwise, queue up a flush.
   */
  flush(t) {
    return !this._replay || !this._replay.isEnabled() ? Promise.resolve() : this._replay.sendBufferedReplayOrFlush(t);
  }
  /**
   * Get the current session ID.
   */
  getReplayId() {
    if (!(!this._replay || !this._replay.isEnabled()))
      return this._replay.getSessionId();
  }
  /**
   * Initializes replay.
   */
  _initialize() {
    this._replay && (this._maybeLoadFromReplayCanvasIntegration(), this._replay.initializeSampling());
  }
  /** Setup the integration. */
  _setup() {
    const t = VCe(this._initialOptions);
    this._replay = new Dl({
      options: t,
      recordingOptions: this._recordingOptions
    });
  }
  /** Get canvas options from ReplayCanvas integration, if it is also added. */
  _maybeLoadFromReplayCanvasIntegration() {
    try {
      const n = Yn().getIntegrationByName("ReplayCanvas");
      if (!n)
        return;
      this._replay._canvas = n.getOptions();
    } catch {
    }
  }
}
Fx.__initStatic();
function VCe(e) {
  const t = Yn(), n = t && t.getOptions(), r = { sessionSampleRate: 0, errorSampleRate: 0, ...Ao(e) };
  return n ? (e.sessionSampleRate == null && // TODO remove once deprecated rates are removed
  e.errorSampleRate == null && // TODO remove once deprecated rates are removed
  n.replaysSessionSampleRate == null && n.replaysOnErrorSampleRate == null && tf(() => {
    console.warn(
      "Replay is disabled because neither `replaysSessionSampleRate` nor `replaysOnErrorSampleRate` are set."
    );
  }), typeof n.replaysSessionSampleRate == "number" && (r.sessionSampleRate = n.replaysSessionSampleRate), typeof n.replaysOnErrorSampleRate == "number" && (r.errorSampleRate = n.replaysOnErrorSampleRate), r) : (tf(() => {
    console.warn("SDK client is not available.");
  }), r);
}
function p8(e) {
  return [...FCe, ...e.map((t) => t.toLowerCase())];
}
function BCe(e) {
  const t = {
    ...e
  };
  yG(t, "react"), mwe(t);
}
class eSt extends Lse {
  constructor(n, r) {
    super();
    ye(this, "log");
    ye(this, "options");
    this.log = n, this.options = r;
  }
  async initialise() {
    this.log.info("SentryCrashReportingService", "initialise"), this.options ? BCe({
      dsn: this.options.dsn,
      release: this.options.release,
      integrations: [new oSe(), new Fx()],
      // Performance Monitoring
      tracesSampleRate: this.options.tracesSampleRate ?? 0.1,
      // Capture 100% of the transactions, reduce in production!
      // Session Replay
      replaysSessionSampleRate: this.options.replaysSessionSampleRate ?? 0.1,
      // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
      replaysOnErrorSampleRate: 1
      // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
    }) : this.log.info(
      "SentryCrashReportingService",
      "initialise",
      "skipped because no Sentry options provided"
    );
  }
  dispose() {
    this.log.info("SentryCrashReportingService", "dispose");
  }
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  recordError(n, r) {
    const { local_msg: i, context: o } = r || { local_msg: void 0, context: void 0 }, a = { data: o };
    this.log.info("SentryCrashReportingService", "recordError", n, i, o), Rx(n, { tags: { local_msg: i }, extra: a });
  }
}
var BK = { exports: {} };
(function(e) {
  (function(t, n) {
    e.exports ? e.exports = n() : t.log = n();
  })(km, function() {
    var t = function() {
    }, n = "undefined", r = typeof window !== n && typeof window.navigator !== n && /Trident\/|MSIE /.test(window.navigator.userAgent), i = [
      "trace",
      "debug",
      "info",
      "warn",
      "error"
    ], o = {}, a = null;
    function s(g, m) {
      var v = g[m];
      if (typeof v.bind == "function")
        return v.bind(g);
      try {
        return Function.prototype.bind.call(v, g);
      } catch {
        return function() {
          return Function.prototype.apply.apply(v, [g, arguments]);
        };
      }
    }
    function c() {
      console.log && (console.log.apply ? console.log.apply(console, arguments) : Function.prototype.apply.apply(console.log, [console, arguments])), console.trace && console.trace();
    }
    function l(g) {
      return g === "debug" && (g = "log"), typeof console === n ? !1 : g === "trace" && r ? c : console[g] !== void 0 ? s(console, g) : console.log !== void 0 ? s(console, "log") : t;
    }
    function u() {
      for (var g = this.getLevel(), m = 0; m < i.length; m++) {
        var v = i[m];
        this[v] = m < g ? t : this.methodFactory(v, g, this.name);
      }
      if (this.log = this.debug, typeof console === n && g < this.levels.SILENT)
        return "No console available for logging";
    }
    function d(g) {
      return function() {
        typeof console !== n && (u.call(this), this[g].apply(this, arguments));
      };
    }
    function f(g, m, v) {
      return l(g) || d.apply(this, arguments);
    }
    function h(g, m) {
      var v = this, y, S, _, w = "loglevel";
      typeof g == "string" ? w += ":" + g : typeof g == "symbol" && (w = void 0);
      function T(A) {
        var O = (i[A] || "silent").toUpperCase();
        if (!(typeof window === n || !w)) {
          try {
            window.localStorage[w] = O;
            return;
          } catch {
          }
          try {
            window.document.cookie = encodeURIComponent(w) + "=" + O + ";";
          } catch {
          }
        }
      }
      function x() {
        var A;
        if (!(typeof window === n || !w)) {
          try {
            A = window.localStorage[w];
          } catch {
          }
          if (typeof A === n)
            try {
              var O = window.document.cookie, $ = encodeURIComponent(w), N = O.indexOf($ + "=");
              N !== -1 && (A = /^([^;]+)/.exec(
                O.slice(N + $.length + 1)
              )[1]);
            } catch {
            }
          return v.levels[A] === void 0 && (A = void 0), A;
        }
      }
      function C() {
        if (!(typeof window === n || !w)) {
          try {
            window.localStorage.removeItem(w);
          } catch {
          }
          try {
            window.document.cookie = encodeURIComponent(w) + "=; expires=Thu, 01 Jan 1970 00:00:00 UTC";
          } catch {
          }
        }
      }
      function E(A) {
        var O = A;
        if (typeof O == "string" && v.levels[O.toUpperCase()] !== void 0 && (O = v.levels[O.toUpperCase()]), typeof O == "number" && O >= 0 && O <= v.levels.SILENT)
          return O;
        throw new TypeError("log.setLevel() called with invalid level: " + A);
      }
      v.name = g, v.levels = {
        TRACE: 0,
        DEBUG: 1,
        INFO: 2,
        WARN: 3,
        ERROR: 4,
        SILENT: 5
      }, v.methodFactory = m || f, v.getLevel = function() {
        return _ ?? S ?? y;
      }, v.setLevel = function(A, O) {
        return _ = E(A), O !== !1 && T(_), u.call(v);
      }, v.setDefaultLevel = function(A) {
        S = E(A), x() || v.setLevel(A, !1);
      }, v.resetLevel = function() {
        _ = null, C(), u.call(v);
      }, v.enableAll = function(A) {
        v.setLevel(v.levels.TRACE, A);
      }, v.disableAll = function(A) {
        v.setLevel(v.levels.SILENT, A);
      }, v.rebuild = function() {
        if (a !== v && (y = E(a.getLevel())), u.call(v), a === v)
          for (var A in o)
            o[A].rebuild();
      }, y = E(
        a ? a.getLevel() : "WARN"
      );
      var R = x();
      R != null && (_ = E(R)), u.call(v);
    }
    a = new h(), a.getLogger = function(m) {
      if (typeof m != "symbol" && typeof m != "string" || m === "")
        throw new TypeError("You must supply a name when creating a logger.");
      var v = o[m];
      return v || (v = o[m] = new h(
        m,
        a.methodFactory
      )), v;
    };
    var p = typeof window !== n ? window.log : void 0;
    return a.noConflict = function() {
      return typeof window !== n && window.log === a && (window.log = p), a;
    }, a.getLoggers = function() {
      return o;
    }, a.default = a, a;
  });
})(BK);
var zCe = BK.exports;
const Ds = /* @__PURE__ */ pn(zCe);
class tSt extends jse {
  constructor(n) {
    Ds.setLevel(n.logLevel ?? "debug");
    super();
    ye(this, "crashReportingService");
    this.crashReportingService = new Fse(), this.debug = Ds.debug.bind(Ds), this.log = Ds.log.bind(Ds), this.info = Ds.info.bind(Ds), this.warn = Ds.warn.bind(Ds);
  }
  async initialise(n) {
    this.debug("RecorderLoggingService initialise"), this.crashReportingService = n;
  }
  dispose() {
    this.debug("RecorderLoggingService dispose");
  }
  debug(...n) {
  }
  log(...n) {
  }
  info(...n) {
  }
  warn(...n) {
  }
  error(n, r) {
    const { error: i, context: o } = r || { error: void 0, context: void 0 };
    Ds.error(n, i, o), this.crashReportingService.recordError(i ?? new Error(n), { local_msg: n, context: o });
  }
}
var zK = { exports: {} };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
(function(e) {
  (function() {
    var t = {}.hasOwnProperty;
    function n() {
      for (var o = "", a = 0; a < arguments.length; a++) {
        var s = arguments[a];
        s && (o = i(o, r(s)));
      }
      return o;
    }
    function r(o) {
      if (typeof o == "string" || typeof o == "number")
        return o;
      if (typeof o != "object")
        return "";
      if (Array.isArray(o))
        return n.apply(null, o);
      if (o.toString !== Object.prototype.toString && !o.toString.toString().includes("[native code]"))
        return o.toString();
      var a = "";
      for (var s in o)
        t.call(o, s) && o[s] && (a = i(a, s));
      return a;
    }
    function i(o, a) {
      return a ? o ? o + " " + a : o + a : o;
    }
    e.exports ? (n.default = n, e.exports = n) : window.classNames = n;
  })();
})(zK);
var Sp = zK.exports;
const we = /* @__PURE__ */ pn(Sp);
var RA = { exports: {} }, Hn = {};
/**
 * @license React
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var m8;
function HCe() {
  if (m8)
    return Hn;
  m8 = 1;
  var e = Symbol.for("react.element"), t = Symbol.for("react.portal"), n = Symbol.for("react.fragment"), r = Symbol.for("react.strict_mode"), i = Symbol.for("react.profiler"), o = Symbol.for("react.provider"), a = Symbol.for("react.context"), s = Symbol.for("react.server_context"), c = Symbol.for("react.forward_ref"), l = Symbol.for("react.suspense"), u = Symbol.for("react.suspense_list"), d = Symbol.for("react.memo"), f = Symbol.for("react.lazy"), h = Symbol.for("react.offscreen"), p;
  p = Symbol.for("react.module.reference");
  function g(m) {
    if (typeof m == "object" && m !== null) {
      var v = m.$$typeof;
      switch (v) {
        case e:
          switch (m = m.type, m) {
            case n:
            case i:
            case r:
            case l:
            case u:
              return m;
            default:
              switch (m = m && m.$$typeof, m) {
                case s:
                case a:
                case c:
                case f:
                case d:
                case o:
                  return m;
                default:
                  return v;
              }
          }
        case t:
          return v;
      }
    }
  }
  return Hn.ContextConsumer = a, Hn.ContextProvider = o, Hn.Element = e, Hn.ForwardRef = c, Hn.Fragment = n, Hn.Lazy = f, Hn.Memo = d, Hn.Portal = t, Hn.Profiler = i, Hn.StrictMode = r, Hn.Suspense = l, Hn.SuspenseList = u, Hn.isAsyncMode = function() {
    return !1;
  }, Hn.isConcurrentMode = function() {
    return !1;
  }, Hn.isContextConsumer = function(m) {
    return g(m) === a;
  }, Hn.isContextProvider = function(m) {
    return g(m) === o;
  }, Hn.isElement = function(m) {
    return typeof m == "object" && m !== null && m.$$typeof === e;
  }, Hn.isForwardRef = function(m) {
    return g(m) === c;
  }, Hn.isFragment = function(m) {
    return g(m) === n;
  }, Hn.isLazy = function(m) {
    return g(m) === f;
  }, Hn.isMemo = function(m) {
    return g(m) === d;
  }, Hn.isPortal = function(m) {
    return g(m) === t;
  }, Hn.isProfiler = function(m) {
    return g(m) === i;
  }, Hn.isStrictMode = function(m) {
    return g(m) === r;
  }, Hn.isSuspense = function(m) {
    return g(m) === l;
  }, Hn.isSuspenseList = function(m) {
    return g(m) === u;
  }, Hn.isValidElementType = function(m) {
    return typeof m == "string" || typeof m == "function" || m === n || m === i || m === r || m === l || m === u || m === h || typeof m == "object" && m !== null && (m.$$typeof === f || m.$$typeof === d || m.$$typeof === o || m.$$typeof === a || m.$$typeof === c || m.$$typeof === p || m.getModuleId !== void 0);
  }, Hn.typeOf = g, Hn;
}
var Un = {};
/**
 * @license React
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var v8;
function UCe() {
  return v8 || (v8 = 1, process.env.NODE_ENV !== "production" && function() {
    var e = Symbol.for("react.element"), t = Symbol.for("react.portal"), n = Symbol.for("react.fragment"), r = Symbol.for("react.strict_mode"), i = Symbol.for("react.profiler"), o = Symbol.for("react.provider"), a = Symbol.for("react.context"), s = Symbol.for("react.server_context"), c = Symbol.for("react.forward_ref"), l = Symbol.for("react.suspense"), u = Symbol.for("react.suspense_list"), d = Symbol.for("react.memo"), f = Symbol.for("react.lazy"), h = Symbol.for("react.offscreen"), p = !1, g = !1, m = !1, v = !1, y = !1, S;
    S = Symbol.for("react.module.reference");
    function _(W) {
      return !!(typeof W == "string" || typeof W == "function" || W === n || W === i || y || W === r || W === l || W === u || v || W === h || p || g || m || typeof W == "object" && W !== null && (W.$$typeof === f || W.$$typeof === d || W.$$typeof === o || W.$$typeof === a || W.$$typeof === c || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      W.$$typeof === S || W.getModuleId !== void 0));
    }
    function w(W) {
      if (typeof W == "object" && W !== null) {
        var se = W.$$typeof;
        switch (se) {
          case e:
            var ce = W.type;
            switch (ce) {
              case n:
              case i:
              case r:
              case l:
              case u:
                return ce;
              default:
                var ge = ce && ce.$$typeof;
                switch (ge) {
                  case s:
                  case a:
                  case c:
                  case f:
                  case d:
                  case o:
                    return ge;
                  default:
                    return se;
                }
            }
          case t:
            return se;
        }
      }
    }
    var T = a, x = o, C = e, E = c, R = n, A = f, O = d, $ = t, N = i, z = r, k = l, F = u, V = !1, j = !1;
    function B(W) {
      return V || (V = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 18+.")), !1;
    }
    function U(W) {
      return j || (j = !0, console.warn("The ReactIs.isConcurrentMode() alias has been deprecated, and will be removed in React 18+.")), !1;
    }
    function Q(W) {
      return w(W) === a;
    }
    function K(W) {
      return w(W) === o;
    }
    function q(W) {
      return typeof W == "object" && W !== null && W.$$typeof === e;
    }
    function X(W) {
      return w(W) === c;
    }
    function ie(W) {
      return w(W) === n;
    }
    function te(W) {
      return w(W) === f;
    }
    function J(W) {
      return w(W) === d;
    }
    function Y(W) {
      return w(W) === t;
    }
    function ee(W) {
      return w(W) === i;
    }
    function Z(W) {
      return w(W) === r;
    }
    function H(W) {
      return w(W) === l;
    }
    function oe(W) {
      return w(W) === u;
    }
    Un.ContextConsumer = T, Un.ContextProvider = x, Un.Element = C, Un.ForwardRef = E, Un.Fragment = R, Un.Lazy = A, Un.Memo = O, Un.Portal = $, Un.Profiler = N, Un.StrictMode = z, Un.Suspense = k, Un.SuspenseList = F, Un.isAsyncMode = B, Un.isConcurrentMode = U, Un.isContextConsumer = Q, Un.isContextProvider = K, Un.isElement = q, Un.isForwardRef = X, Un.isFragment = ie, Un.isLazy = te, Un.isMemo = J, Un.isPortal = Y, Un.isProfiler = ee, Un.isStrictMode = Z, Un.isSuspense = H, Un.isSuspenseList = oe, Un.isValidElementType = _, Un.typeOf = w;
  }()), Un;
}
process.env.NODE_ENV === "production" ? RA.exports = HCe() : RA.exports = UCe();
var Ld = RA.exports;
function af(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, n = [];
  return D.Children.forEach(e, function(r) {
    r == null && !t.keepEmpty || (Array.isArray(r) ? n = n.concat(af(r)) : Ld.isFragment(r) && r.props ? n = n.concat(af(r.props.children, t)) : n.push(r));
  }), n;
}
var $A = {}, e6 = [], WCe = function(t) {
  e6.push(t);
};
function Cu(e, t) {
  if (process.env.NODE_ENV !== "production" && !e && console !== void 0) {
    var n = e6.reduce(function(r, i) {
      return i(r ?? "", "warning");
    }, t);
    n && console.error("Warning: ".concat(n));
  }
}
function qCe(e, t) {
  if (process.env.NODE_ENV !== "production" && !e && console !== void 0) {
    var n = e6.reduce(function(r, i) {
      return i(r ?? "", "note");
    }, t);
    n && console.warn("Note: ".concat(n));
  }
}
function HK() {
  $A = {};
}
function UK(e, t, n) {
  !t && !$A[n] && (e(!1, n), $A[n] = !0);
}
function an(e, t) {
  UK(Cu, e, t);
}
function OA(e, t) {
  UK(qCe, e, t);
}
an.preMessage = WCe;
an.resetWarned = HK;
an.noteOnce = OA;
function Q0(e) {
  return e instanceof HTMLElement || e instanceof SVGElement;
}
function GCe(e) {
  return e && _t(e) === "object" && Q0(e.nativeElement) ? e.nativeElement : Q0(e) ? e : null;
}
function m0(e) {
  var t = GCe(e);
  if (t)
    return t;
  if (e instanceof D.Component) {
    var n;
    return (n = bN.findDOMNode) === null || n === void 0 ? void 0 : n.call(bN, e);
  }
  return null;
}
function oy(e, t, n) {
  var r = I.useRef({});
  return (!("value" in r.current) || n(r.current.condition, t)) && (r.current.value = e(), r.current.condition = t), r.current.value;
}
var t6 = function(t, n) {
  typeof t == "function" ? t(n) : _t(t) === "object" && t && "current" in t && (t.current = n);
}, Wa = function() {
  for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++)
    n[r] = arguments[r];
  var i = n.filter(Boolean);
  return i.length <= 1 ? i[0] : function(o) {
    n.forEach(function(a) {
      t6(a, o);
    });
  };
}, Vx = function() {
  for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++)
    n[r] = arguments[r];
  return oy(function() {
    return Wa.apply(void 0, n);
  }, n, function(i, o) {
    return i.length !== o.length || i.every(function(a, s) {
      return a !== o[s];
    });
  });
}, ay = function(t) {
  var n, r, i = Ld.isMemo(t) ? t.type.type : t.type;
  return !(typeof i == "function" && !((n = i.prototype) !== null && n !== void 0 && n.render) && i.$$typeof !== Ld.ForwardRef || typeof t == "function" && !((r = t.prototype) !== null && r !== void 0 && r.render) && t.$$typeof !== Ld.ForwardRef);
};
function y8(e) {
  return /* @__PURE__ */ eO(e) && !Ld.isFragment(e);
}
Number(Xse.split(".")[0]) >= 19;
var PA = /* @__PURE__ */ I.createContext(null);
function KCe(e) {
  var t = e.children, n = e.onBatchResize, r = I.useRef(0), i = I.useRef([]), o = I.useContext(PA), a = I.useCallback(function(s, c, l) {
    r.current += 1;
    var u = r.current;
    i.current.push({
      size: s,
      element: c,
      data: l
    }), Promise.resolve().then(function() {
      u === r.current && (n == null || n(i.current), i.current = []);
    }), o == null || o(s, c, l);
  }, [n, o]);
  return /* @__PURE__ */ I.createElement(PA.Provider, {
    value: a
  }, t);
}
var WK = function() {
  if (typeof Map < "u")
    return Map;
  function e(t, n) {
    var r = -1;
    return t.some(function(i, o) {
      return i[0] === n ? (r = o, !0) : !1;
    }), r;
  }
  return (
    /** @class */
    function() {
      function t() {
        this.__entries__ = [];
      }
      return Object.defineProperty(t.prototype, "size", {
        /**
         * @returns {boolean}
         */
        get: function() {
          return this.__entries__.length;
        },
        enumerable: !0,
        configurable: !0
      }), t.prototype.get = function(n) {
        var r = e(this.__entries__, n), i = this.__entries__[r];
        return i && i[1];
      }, t.prototype.set = function(n, r) {
        var i = e(this.__entries__, n);
        ~i ? this.__entries__[i][1] = r : this.__entries__.push([n, r]);
      }, t.prototype.delete = function(n) {
        var r = this.__entries__, i = e(r, n);
        ~i && r.splice(i, 1);
      }, t.prototype.has = function(n) {
        return !!~e(this.__entries__, n);
      }, t.prototype.clear = function() {
        this.__entries__.splice(0);
      }, t.prototype.forEach = function(n, r) {
        r === void 0 && (r = null);
        for (var i = 0, o = this.__entries__; i < o.length; i++) {
          var a = o[i];
          n.call(r, a[1], a[0]);
        }
      }, t;
    }()
  );
}(), MA = typeof window < "u" && typeof document < "u" && window.document === document, Z_ = function() {
  return typeof global < "u" && global.Math === Math ? global : typeof self < "u" && self.Math === Math ? self : typeof window < "u" && window.Math === Math ? window : Function("return this")();
}(), YCe = function() {
  return typeof requestAnimationFrame == "function" ? requestAnimationFrame.bind(Z_) : function(e) {
    return setTimeout(function() {
      return e(Date.now());
    }, 1e3 / 60);
  };
}(), XCe = 2;
function QCe(e, t) {
  var n = !1, r = !1, i = 0;
  function o() {
    n && (n = !1, e()), r && s();
  }
  function a() {
    YCe(o);
  }
  function s() {
    var c = Date.now();
    if (n) {
      if (c - i < XCe)
        return;
      r = !0;
    } else
      n = !0, r = !1, setTimeout(a, t);
    i = c;
  }
  return s;
}
var JCe = 20, ZCe = ["top", "right", "bottom", "left", "width", "height", "size", "weight"], e2e = typeof MutationObserver < "u", t2e = (
  /** @class */
  function() {
    function e() {
      this.connected_ = !1, this.mutationEventsAdded_ = !1, this.mutationsObserver_ = null, this.observers_ = [], this.onTransitionEnd_ = this.onTransitionEnd_.bind(this), this.refresh = QCe(this.refresh.bind(this), JCe);
    }
    return e.prototype.addObserver = function(t) {
      ~this.observers_.indexOf(t) || this.observers_.push(t), this.connected_ || this.connect_();
    }, e.prototype.removeObserver = function(t) {
      var n = this.observers_, r = n.indexOf(t);
      ~r && n.splice(r, 1), !n.length && this.connected_ && this.disconnect_();
    }, e.prototype.refresh = function() {
      var t = this.updateObservers_();
      t && this.refresh();
    }, e.prototype.updateObservers_ = function() {
      var t = this.observers_.filter(function(n) {
        return n.gatherActive(), n.hasActive();
      });
      return t.forEach(function(n) {
        return n.broadcastActive();
      }), t.length > 0;
    }, e.prototype.connect_ = function() {
      !MA || this.connected_ || (document.addEventListener("transitionend", this.onTransitionEnd_), window.addEventListener("resize", this.refresh), e2e ? (this.mutationsObserver_ = new MutationObserver(this.refresh), this.mutationsObserver_.observe(document, {
        attributes: !0,
        childList: !0,
        characterData: !0,
        subtree: !0
      })) : (document.addEventListener("DOMSubtreeModified", this.refresh), this.mutationEventsAdded_ = !0), this.connected_ = !0);
    }, e.prototype.disconnect_ = function() {
      !MA || !this.connected_ || (document.removeEventListener("transitionend", this.onTransitionEnd_), window.removeEventListener("resize", this.refresh), this.mutationsObserver_ && this.mutationsObserver_.disconnect(), this.mutationEventsAdded_ && document.removeEventListener("DOMSubtreeModified", this.refresh), this.mutationsObserver_ = null, this.mutationEventsAdded_ = !1, this.connected_ = !1);
    }, e.prototype.onTransitionEnd_ = function(t) {
      var n = t.propertyName, r = n === void 0 ? "" : n, i = ZCe.some(function(o) {
        return !!~r.indexOf(o);
      });
      i && this.refresh();
    }, e.getInstance = function() {
      return this.instance_ || (this.instance_ = new e()), this.instance_;
    }, e.instance_ = null, e;
  }()
), qK = function(e, t) {
  for (var n = 0, r = Object.keys(t); n < r.length; n++) {
    var i = r[n];
    Object.defineProperty(e, i, {
      value: t[i],
      enumerable: !1,
      writable: !1,
      configurable: !0
    });
  }
  return e;
}, Cg = function(e) {
  var t = e && e.ownerDocument && e.ownerDocument.defaultView;
  return t || Z_;
}, GK = Bx(0, 0, 0, 0);
function eS(e) {
  return parseFloat(e) || 0;
}
function b8(e) {
  for (var t = [], n = 1; n < arguments.length; n++)
    t[n - 1] = arguments[n];
  return t.reduce(function(r, i) {
    var o = e["border-" + i + "-width"];
    return r + eS(o);
  }, 0);
}
function n2e(e) {
  for (var t = ["top", "right", "bottom", "left"], n = {}, r = 0, i = t; r < i.length; r++) {
    var o = i[r], a = e["padding-" + o];
    n[o] = eS(a);
  }
  return n;
}
function r2e(e) {
  var t = e.getBBox();
  return Bx(0, 0, t.width, t.height);
}
function i2e(e) {
  var t = e.clientWidth, n = e.clientHeight;
  if (!t && !n)
    return GK;
  var r = Cg(e).getComputedStyle(e), i = n2e(r), o = i.left + i.right, a = i.top + i.bottom, s = eS(r.width), c = eS(r.height);
  if (r.boxSizing === "border-box" && (Math.round(s + o) !== t && (s -= b8(r, "left", "right") + o), Math.round(c + a) !== n && (c -= b8(r, "top", "bottom") + a)), !a2e(e)) {
    var l = Math.round(s + o) - t, u = Math.round(c + a) - n;
    Math.abs(l) !== 1 && (s -= l), Math.abs(u) !== 1 && (c -= u);
  }
  return Bx(i.left, i.top, s, c);
}
var o2e = function() {
  return typeof SVGGraphicsElement < "u" ? function(e) {
    return e instanceof Cg(e).SVGGraphicsElement;
  } : function(e) {
    return e instanceof Cg(e).SVGElement && typeof e.getBBox == "function";
  };
}();
function a2e(e) {
  return e === Cg(e).document.documentElement;
}
function s2e(e) {
  return MA ? o2e(e) ? r2e(e) : i2e(e) : GK;
}
function c2e(e) {
  var t = e.x, n = e.y, r = e.width, i = e.height, o = typeof DOMRectReadOnly < "u" ? DOMRectReadOnly : Object, a = Object.create(o.prototype);
  return qK(a, {
    x: t,
    y: n,
    width: r,
    height: i,
    top: n,
    right: t + r,
    bottom: i + n,
    left: t
  }), a;
}
function Bx(e, t, n, r) {
  return { x: e, y: t, width: n, height: r };
}
var l2e = (
  /** @class */
  function() {
    function e(t) {
      this.broadcastWidth = 0, this.broadcastHeight = 0, this.contentRect_ = Bx(0, 0, 0, 0), this.target = t;
    }
    return e.prototype.isActive = function() {
      var t = s2e(this.target);
      return this.contentRect_ = t, t.width !== this.broadcastWidth || t.height !== this.broadcastHeight;
    }, e.prototype.broadcastRect = function() {
      var t = this.contentRect_;
      return this.broadcastWidth = t.width, this.broadcastHeight = t.height, t;
    }, e;
  }()
), u2e = (
  /** @class */
  function() {
    function e(t, n) {
      var r = c2e(n);
      qK(this, { target: t, contentRect: r });
    }
    return e;
  }()
), d2e = (
  /** @class */
  function() {
    function e(t, n, r) {
      if (this.activeObservations_ = [], this.observations_ = new WK(), typeof t != "function")
        throw new TypeError("The callback provided as parameter 1 is not a function.");
      this.callback_ = t, this.controller_ = n, this.callbackCtx_ = r;
    }
    return e.prototype.observe = function(t) {
      if (!arguments.length)
        throw new TypeError("1 argument required, but only 0 present.");
      if (!(typeof Element > "u" || !(Element instanceof Object))) {
        if (!(t instanceof Cg(t).Element))
          throw new TypeError('parameter 1 is not of type "Element".');
        var n = this.observations_;
        n.has(t) || (n.set(t, new l2e(t)), this.controller_.addObserver(this), this.controller_.refresh());
      }
    }, e.prototype.unobserve = function(t) {
      if (!arguments.length)
        throw new TypeError("1 argument required, but only 0 present.");
      if (!(typeof Element > "u" || !(Element instanceof Object))) {
        if (!(t instanceof Cg(t).Element))
          throw new TypeError('parameter 1 is not of type "Element".');
        var n = this.observations_;
        n.has(t) && (n.delete(t), n.size || this.controller_.removeObserver(this));
      }
    }, e.prototype.disconnect = function() {
      this.clearActive(), this.observations_.clear(), this.controller_.removeObserver(this);
    }, e.prototype.gatherActive = function() {
      var t = this;
      this.clearActive(), this.observations_.forEach(function(n) {
        n.isActive() && t.activeObservations_.push(n);
      });
    }, e.prototype.broadcastActive = function() {
      if (this.hasActive()) {
        var t = this.callbackCtx_, n = this.activeObservations_.map(function(r) {
          return new u2e(r.target, r.broadcastRect());
        });
        this.callback_.call(t, n, t), this.clearActive();
      }
    }, e.prototype.clearActive = function() {
      this.activeObservations_.splice(0);
    }, e.prototype.hasActive = function() {
      return this.activeObservations_.length > 0;
    }, e;
  }()
), KK = typeof WeakMap < "u" ? /* @__PURE__ */ new WeakMap() : new WK(), YK = (
  /** @class */
  function() {
    function e(t) {
      if (!(this instanceof e))
        throw new TypeError("Cannot call a class as a function.");
      if (!arguments.length)
        throw new TypeError("1 argument required, but only 0 present.");
      var n = t2e.getInstance(), r = new d2e(t, n, this);
      KK.set(this, r);
    }
    return e;
  }()
);
[
  "observe",
  "unobserve",
  "disconnect"
].forEach(function(e) {
  YK.prototype[e] = function() {
    var t;
    return (t = KK.get(this))[e].apply(t, arguments);
  };
});
var f2e = function() {
  return typeof Z_.ResizeObserver < "u" ? Z_.ResizeObserver : YK;
}(), Wc = /* @__PURE__ */ new Map();
function XK(e) {
  e.forEach(function(t) {
    var n, r = t.target;
    (n = Wc.get(r)) === null || n === void 0 || n.forEach(function(i) {
      return i(r);
    });
  });
}
var QK = new f2e(XK);
process.env.NODE_ENV;
process.env.NODE_ENV;
function h2e(e, t) {
  Wc.has(e) || (Wc.set(e, /* @__PURE__ */ new Set()), QK.observe(e)), Wc.get(e).add(t);
}
function g2e(e, t) {
  Wc.has(e) && (Wc.get(e).delete(t), Wc.get(e).size || (QK.unobserve(e), Wc.delete(e)));
}
function Sr(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function _8(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, Uz(r.key), r);
  }
}
function wr(e, t, n) {
  return t && _8(e.prototype, t), n && _8(e, n), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function J0(e, t) {
  return J0 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, r) {
    return n.__proto__ = r, n;
  }, J0(e, t);
}
function Rs(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, {
    constructor: {
      value: e,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(e, "prototype", {
    writable: !1
  }), t && J0(e, t);
}
function sf(e) {
  return sf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, sf(e);
}
function zx() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (zx = function() {
    return !!e;
  })();
}
function nn(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function JK(e, t) {
  if (t && (_t(t) == "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return nn(e);
}
function _c(e) {
  var t = zx();
  return function() {
    var n, r = sf(e);
    if (t) {
      var i = sf(this).constructor;
      n = Reflect.construct(r, arguments, i);
    } else
      n = r.apply(this, arguments);
    return JK(this, n);
  };
}
var p2e = /* @__PURE__ */ function(e) {
  Rs(n, e);
  var t = _c(n);
  function n() {
    return Sr(this, n), t.apply(this, arguments);
  }
  return wr(n, [{
    key: "render",
    value: function() {
      return this.props.children;
    }
  }]), n;
}(I.Component);
function m2e(e, t) {
  var n = e.children, r = e.disabled, i = I.useRef(null), o = I.useRef(null), a = I.useContext(PA), s = typeof n == "function", c = s ? n(i) : n, l = I.useRef({
    width: -1,
    height: -1,
    offsetWidth: -1,
    offsetHeight: -1
  }), u = !s && /* @__PURE__ */ I.isValidElement(c) && ay(c), d = u ? c.ref : null, f = Vx(d, i), h = function() {
    var v;
    return m0(i.current) || // Support `nativeElement` format
    (i.current && _t(i.current) === "object" ? m0((v = i.current) === null || v === void 0 ? void 0 : v.nativeElement) : null) || m0(o.current);
  };
  I.useImperativeHandle(t, function() {
    return h();
  });
  var p = I.useRef(e);
  p.current = e;
  var g = I.useCallback(function(m) {
    var v = p.current, y = v.onResize, S = v.data, _ = m.getBoundingClientRect(), w = _.width, T = _.height, x = m.offsetWidth, C = m.offsetHeight, E = Math.floor(w), R = Math.floor(T);
    if (l.current.width !== E || l.current.height !== R || l.current.offsetWidth !== x || l.current.offsetHeight !== C) {
      var A = {
        width: E,
        height: R,
        offsetWidth: x,
        offsetHeight: C
      };
      l.current = A;
      var O = x === Math.round(w) ? w : x, $ = C === Math.round(T) ? T : C, N = ae(ae({}, A), {}, {
        offsetWidth: O,
        offsetHeight: $
      });
      a == null || a(N, m, S), y && Promise.resolve().then(function() {
        y(N, m);
      });
    }
  }, []);
  return I.useEffect(function() {
    var m = h();
    return m && !r && h2e(m, g), function() {
      return g2e(m, g);
    };
  }, [i.current, r]), /* @__PURE__ */ I.createElement(p2e, {
    ref: o
  }, u ? /* @__PURE__ */ I.cloneElement(c, {
    ref: f
  }) : c);
}
var ZK = /* @__PURE__ */ I.forwardRef(m2e);
process.env.NODE_ENV !== "production" && (ZK.displayName = "SingleObserver");
var v2e = "rc-observer-key";
function y2e(e, t) {
  var n = e.children, r = typeof n == "function" ? [n] : af(n);
  return process.env.NODE_ENV !== "production" && (r.length > 1 ? Cu(!1, "Find more than one child node with `children` in ResizeObserver. Please use ResizeObserver.Collection instead.") : r.length === 0 && Cu(!1, "`children` of ResizeObserver is empty. Nothing is in observe.")), r.map(function(i, o) {
    var a = (i == null ? void 0 : i.key) || "".concat(v2e, "-").concat(o);
    return /* @__PURE__ */ I.createElement(ZK, mt({}, e, {
      key: a,
      ref: o === 0 ? t : void 0
    }), i);
  });
}
var ml = /* @__PURE__ */ I.forwardRef(y2e);
process.env.NODE_ENV !== "production" && (ml.displayName = "ResizeObserver");
ml.Collection = KCe;
function Hu(e, t) {
  var n = Object.assign({}, e);
  return Array.isArray(t) && t.forEach(function(r) {
    delete n[r];
  }), n;
}
function kA(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = Array(t); n < t; n++)
    r[n] = e[n];
  return r;
}
function b2e(e) {
  if (Array.isArray(e))
    return kA(e);
}
function eY(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null)
    return Array.from(e);
}
function n6(e, t) {
  if (e) {
    if (typeof e == "string")
      return kA(e, t);
    var n = {}.toString.call(e).slice(8, -1);
    return n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set" ? Array.from(e) : n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? kA(e, t) : void 0;
  }
}
function _2e() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Je(e) {
  return b2e(e) || eY(e) || n6(e) || _2e();
}
var tY = function(t) {
  return +setTimeout(t, 16);
}, nY = function(t) {
  return clearTimeout(t);
};
typeof window < "u" && "requestAnimationFrame" in window && (tY = function(t) {
  return window.requestAnimationFrame(t);
}, nY = function(t) {
  return window.cancelAnimationFrame(t);
});
var S8 = 0, Hx = /* @__PURE__ */ new Map();
function rY(e) {
  Hx.delete(e);
}
var Ln = function(t) {
  var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1;
  S8 += 1;
  var r = S8;
  function i(o) {
    if (o === 0)
      rY(r), t();
    else {
      var a = tY(function() {
        i(o - 1);
      });
      Hx.set(r, a);
    }
  }
  return i(n), r;
};
Ln.cancel = function(e) {
  var t = Hx.get(e);
  return rY(e), nY(t);
};
process.env.NODE_ENV !== "production" && (Ln.ids = function() {
  return Hx;
});
function iY(e) {
  if (Array.isArray(e))
    return e;
}
function S2e(e, t) {
  var n = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (n != null) {
    var r, i, o, a, s = [], c = !0, l = !1;
    try {
      if (o = (n = n.call(e)).next, t === 0) {
        if (Object(n) !== n)
          return;
        c = !1;
      } else
        for (; !(c = (r = o.call(n)).done) && (s.push(r.value), s.length !== t); c = !0)
          ;
    } catch (u) {
      l = !0, i = u;
    } finally {
      try {
        if (!c && n.return != null && (a = n.return(), Object(a) !== a))
          return;
      } finally {
        if (l)
          throw i;
      }
    }
    return s;
  }
}
function oY() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function fe(e, t) {
  return iY(e) || S2e(e, t) || n6(e, t) || oY();
}
function Z0(e) {
  for (var t = 0, n, r = 0, i = e.length; i >= 4; ++r, i -= 4)
    n = e.charCodeAt(r) & 255 | (e.charCodeAt(++r) & 255) << 8 | (e.charCodeAt(++r) & 255) << 16 | (e.charCodeAt(++r) & 255) << 24, n = /* Math.imul(k, m): */
    (n & 65535) * 1540483477 + ((n >>> 16) * 59797 << 16), n ^= /* k >>> r: */
    n >>> 24, t = /* Math.imul(k, m): */
    (n & 65535) * 1540483477 + ((n >>> 16) * 59797 << 16) ^ /* Math.imul(h, m): */
    (t & 65535) * 1540483477 + ((t >>> 16) * 59797 << 16);
  switch (i) {
    case 3:
      t ^= (e.charCodeAt(r + 2) & 255) << 16;
    case 2:
      t ^= (e.charCodeAt(r + 1) & 255) << 8;
    case 1:
      t ^= e.charCodeAt(r) & 255, t = /* Math.imul(h, m): */
      (t & 65535) * 1540483477 + ((t >>> 16) * 59797 << 16);
  }
  return t ^= t >>> 13, t = /* Math.imul(h, m): */
  (t & 65535) * 1540483477 + ((t >>> 16) * 59797 << 16), ((t ^ t >>> 15) >>> 0).toString(36);
}
function ao() {
  return !!(typeof window < "u" && window.document && window.document.createElement);
}
function w2e(e, t) {
  if (!e)
    return !1;
  if (e.contains)
    return e.contains(t);
  for (var n = t; n; ) {
    if (n === e)
      return !0;
    n = n.parentNode;
  }
  return !1;
}
var w8 = "data-rc-order", x8 = "data-rc-priority", x2e = "rc-util-key", NA = /* @__PURE__ */ new Map();
function aY() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, t = e.mark;
  return t ? t.startsWith("data-") ? t : "data-".concat(t) : x2e;
}
function Ux(e) {
  if (e.attachTo)
    return e.attachTo;
  var t = document.querySelector("head");
  return t || document.body;
}
function E2e(e) {
  return e === "queue" ? "prependQueue" : e ? "prepend" : "append";
}
function r6(e) {
  return Array.from((NA.get(e) || e).children).filter(function(t) {
    return t.tagName === "STYLE";
  });
}
function sY(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  if (!ao())
    return null;
  var n = t.csp, r = t.prepend, i = t.priority, o = i === void 0 ? 0 : i, a = E2e(r), s = a === "prependQueue", c = document.createElement("style");
  c.setAttribute(w8, a), s && o && c.setAttribute(x8, "".concat(o)), n != null && n.nonce && (c.nonce = n == null ? void 0 : n.nonce), c.innerHTML = e;
  var l = Ux(t), u = l.firstChild;
  if (r) {
    if (s) {
      var d = (t.styles || r6(l)).filter(function(f) {
        if (!["prepend", "prependQueue"].includes(f.getAttribute(w8)))
          return !1;
        var h = Number(f.getAttribute(x8) || 0);
        return o >= h;
      });
      if (d.length)
        return l.insertBefore(c, d[d.length - 1].nextSibling), c;
    }
    l.insertBefore(c, u);
  } else
    l.appendChild(c);
  return c;
}
function cY(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, n = Ux(t);
  return (t.styles || r6(n)).find(function(r) {
    return r.getAttribute(aY(t)) === e;
  });
}
function Tg(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, n = cY(e, t);
  if (n) {
    var r = Ux(t);
    r.removeChild(n);
  }
}
function C2e(e, t) {
  var n = NA.get(e);
  if (!n || !w2e(document, n)) {
    var r = sY("", t), i = r.parentNode;
    NA.set(e, i), e.removeChild(r);
  }
}
function cc(e, t) {
  var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, r = Ux(n), i = r6(r), o = ae(ae({}, n), {}, {
    styles: i
  });
  C2e(r, o);
  var a = cY(t, o);
  if (a) {
    var s, c;
    if ((s = o.csp) !== null && s !== void 0 && s.nonce && a.nonce !== ((c = o.csp) === null || c === void 0 ? void 0 : c.nonce)) {
      var l;
      a.nonce = (l = o.csp) === null || l === void 0 ? void 0 : l.nonce;
    }
    return a.innerHTML !== e && (a.innerHTML = e), a;
  }
  var u = sY(e, o);
  return u.setAttribute(aY(o), t), u;
}
function xn(e, t) {
  if (e == null)
    return {};
  var n, r, i = yce(e, t);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    for (r = 0; r < o.length; r++)
      n = o[r], t.includes(n) || {}.propertyIsEnumerable.call(e, n) && (i[n] = e[n]);
  }
  return i;
}
function Ig(e, t) {
  var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1, r = /* @__PURE__ */ new Set();
  function i(o, a) {
    var s = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 1, c = r.has(o);
    if (an(!c, "Warning: There may be circular references"), c)
      return !1;
    if (o === a)
      return !0;
    if (n && s > 1)
      return !1;
    r.add(o);
    var l = s + 1;
    if (Array.isArray(o)) {
      if (!Array.isArray(a) || o.length !== a.length)
        return !1;
      for (var u = 0; u < o.length; u++)
        if (!i(o[u], a[u], l))
          return !1;
      return !0;
    }
    if (o && a && _t(o) === "object" && _t(a) === "object") {
      var d = Object.keys(o);
      return d.length !== Object.keys(a).length ? !1 : d.every(function(f) {
        return i(o[f], a[f], l);
      });
    }
    return !1;
  }
  return i(e, t);
}
var T2e = "%";
function DA(e) {
  return e.join(T2e);
}
var I2e = /* @__PURE__ */ function() {
  function e(t) {
    Sr(this, e), re(this, "instanceId", void 0), re(this, "cache", /* @__PURE__ */ new Map()), this.instanceId = t;
  }
  return wr(e, [{
    key: "get",
    value: function(n) {
      return this.opGet(DA(n));
    }
    /** A fast get cache with `get` concat. */
  }, {
    key: "opGet",
    value: function(n) {
      return this.cache.get(n) || null;
    }
  }, {
    key: "update",
    value: function(n, r) {
      return this.opUpdate(DA(n), r);
    }
    /** A fast get cache with `get` concat. */
  }, {
    key: "opUpdate",
    value: function(n, r) {
      var i = this.cache.get(n), o = r(i);
      o === null ? this.cache.delete(n) : this.cache.set(n, o);
    }
  }]), e;
}(), A2e = ["children"], Ag = "data-token-hash", ms = "data-css-hash", R2e = "data-cache-path", Kl = "__cssinjs_instance__";
function i6() {
  var e = Math.random().toString(12).slice(2);
  if (typeof document < "u" && document.head && document.body) {
    var t = document.body.querySelectorAll("style[".concat(ms, "]")) || [], n = document.head.firstChild;
    Array.from(t).forEach(function(i) {
      i[Kl] = i[Kl] || e, i[Kl] === e && document.head.insertBefore(i, n);
    });
    var r = {};
    Array.from(document.querySelectorAll("style[".concat(ms, "]"))).forEach(function(i) {
      var o = i.getAttribute(ms);
      if (r[o]) {
        if (i[Kl] === e) {
          var a;
          (a = i.parentNode) === null || a === void 0 || a.removeChild(i);
        }
      } else
        r[o] = !0;
    });
  }
  return new I2e(e);
}
var Rg = /* @__PURE__ */ I.createContext({
  hashPriority: "low",
  cache: i6(),
  defaultCache: !0
}), $2e = function(t) {
  var n = t.children, r = xn(t, A2e), i = I.useContext(Rg), o = oy(function() {
    var a = ae({}, i);
    Object.keys(r).forEach(function(c) {
      var l = r[c];
      r[c] !== void 0 && (a[c] = l);
    });
    var s = r.cache;
    return a.cache = a.cache || i6(), a.defaultCache = !s && i.defaultCache, a;
  }, [i, r], function(a, s) {
    return !Ig(a[0], s[0], !0) || !Ig(a[1], s[1], !0);
  });
  return /* @__PURE__ */ I.createElement(Rg.Provider, {
    value: o
  }, n);
}, lY = /* @__PURE__ */ wr(function e() {
  Sr(this, e);
}), uY = "CALC_UNIT", O2e = new RegExp(uY, "g");
function _5(e) {
  return typeof e == "number" ? "".concat(e).concat(uY) : e;
}
var P2e = /* @__PURE__ */ function(e) {
  Rs(n, e);
  var t = _c(n);
  function n(r, i) {
    var o;
    Sr(this, n), o = t.call(this), re(nn(o), "result", ""), re(nn(o), "unitlessCssVar", void 0), re(nn(o), "lowPriority", void 0);
    var a = _t(r);
    return o.unitlessCssVar = i, r instanceof n ? o.result = "(".concat(r.result, ")") : a === "number" ? o.result = _5(r) : a === "string" && (o.result = r), o;
  }
  return wr(n, [{
    key: "add",
    value: function(i) {
      return i instanceof n ? this.result = "".concat(this.result, " + ").concat(i.getResult()) : (typeof i == "number" || typeof i == "string") && (this.result = "".concat(this.result, " + ").concat(_5(i))), this.lowPriority = !0, this;
    }
  }, {
    key: "sub",
    value: function(i) {
      return i instanceof n ? this.result = "".concat(this.result, " - ").concat(i.getResult()) : (typeof i == "number" || typeof i == "string") && (this.result = "".concat(this.result, " - ").concat(_5(i))), this.lowPriority = !0, this;
    }
  }, {
    key: "mul",
    value: function(i) {
      return this.lowPriority && (this.result = "(".concat(this.result, ")")), i instanceof n ? this.result = "".concat(this.result, " * ").concat(i.getResult(!0)) : (typeof i == "number" || typeof i == "string") && (this.result = "".concat(this.result, " * ").concat(i)), this.lowPriority = !1, this;
    }
  }, {
    key: "div",
    value: function(i) {
      return this.lowPriority && (this.result = "(".concat(this.result, ")")), i instanceof n ? this.result = "".concat(this.result, " / ").concat(i.getResult(!0)) : (typeof i == "number" || typeof i == "string") && (this.result = "".concat(this.result, " / ").concat(i)), this.lowPriority = !1, this;
    }
  }, {
    key: "getResult",
    value: function(i) {
      return this.lowPriority || i ? "(".concat(this.result, ")") : this.result;
    }
  }, {
    key: "equal",
    value: function(i) {
      var o = this, a = i || {}, s = a.unit, c = !0;
      return typeof s == "boolean" ? c = s : Array.from(this.unitlessCssVar).some(function(l) {
        return o.result.includes(l);
      }) && (c = !1), this.result = this.result.replace(O2e, c ? "px" : ""), typeof this.lowPriority < "u" ? "calc(".concat(this.result, ")") : this.result;
    }
  }]), n;
}(lY), M2e = /* @__PURE__ */ function(e) {
  Rs(n, e);
  var t = _c(n);
  function n(r) {
    var i;
    return Sr(this, n), i = t.call(this), re(nn(i), "result", 0), r instanceof n ? i.result = r.result : typeof r == "number" && (i.result = r), i;
  }
  return wr(n, [{
    key: "add",
    value: function(i) {
      return i instanceof n ? this.result += i.result : typeof i == "number" && (this.result += i), this;
    }
  }, {
    key: "sub",
    value: function(i) {
      return i instanceof n ? this.result -= i.result : typeof i == "number" && (this.result -= i), this;
    }
  }, {
    key: "mul",
    value: function(i) {
      return i instanceof n ? this.result *= i.result : typeof i == "number" && (this.result *= i), this;
    }
  }, {
    key: "div",
    value: function(i) {
      return i instanceof n ? this.result /= i.result : typeof i == "number" && (this.result /= i), this;
    }
  }, {
    key: "equal",
    value: function() {
      return this.result;
    }
  }]), n;
}(lY), k2e = function(t, n) {
  var r = t === "css" ? P2e : M2e;
  return function(i) {
    return new r(i, n);
  };
};
function N2e(e, t) {
  if (e.length !== t.length)
    return !1;
  for (var n = 0; n < e.length; n++)
    if (e[n] !== t[n])
      return !1;
  return !0;
}
var o6 = /* @__PURE__ */ function() {
  function e() {
    Sr(this, e), re(this, "cache", void 0), re(this, "keys", void 0), re(this, "cacheCallTimes", void 0), this.cache = /* @__PURE__ */ new Map(), this.keys = [], this.cacheCallTimes = 0;
  }
  return wr(e, [{
    key: "size",
    value: function() {
      return this.keys.length;
    }
  }, {
    key: "internalGet",
    value: function(n) {
      var r, i, o = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1, a = {
        map: this.cache
      };
      return n.forEach(function(s) {
        if (!a)
          a = void 0;
        else {
          var c;
          a = (c = a) === null || c === void 0 || (c = c.map) === null || c === void 0 ? void 0 : c.get(s);
        }
      }), (r = a) !== null && r !== void 0 && r.value && o && (a.value[1] = this.cacheCallTimes++), (i = a) === null || i === void 0 ? void 0 : i.value;
    }
  }, {
    key: "get",
    value: function(n) {
      var r;
      return (r = this.internalGet(n, !0)) === null || r === void 0 ? void 0 : r[0];
    }
  }, {
    key: "has",
    value: function(n) {
      return !!this.internalGet(n);
    }
  }, {
    key: "set",
    value: function(n, r) {
      var i = this;
      if (!this.has(n)) {
        if (this.size() + 1 > e.MAX_CACHE_SIZE + e.MAX_CACHE_OFFSET) {
          var o = this.keys.reduce(function(l, u) {
            var d = fe(l, 2), f = d[1];
            return i.internalGet(u)[1] < f ? [u, i.internalGet(u)[1]] : l;
          }, [this.keys[0], this.cacheCallTimes]), a = fe(o, 1), s = a[0];
          this.delete(s);
        }
        this.keys.push(n);
      }
      var c = this.cache;
      n.forEach(function(l, u) {
        if (u === n.length - 1)
          c.set(l, {
            value: [r, i.cacheCallTimes++]
          });
        else {
          var d = c.get(l);
          d ? d.map || (d.map = /* @__PURE__ */ new Map()) : c.set(l, {
            map: /* @__PURE__ */ new Map()
          }), c = c.get(l).map;
        }
      });
    }
  }, {
    key: "deleteByPath",
    value: function(n, r) {
      var i = n.get(r[0]);
      if (r.length === 1) {
        var o;
        return i.map ? n.set(r[0], {
          map: i.map
        }) : n.delete(r[0]), (o = i.value) === null || o === void 0 ? void 0 : o[0];
      }
      var a = this.deleteByPath(i.map, r.slice(1));
      return (!i.map || i.map.size === 0) && !i.value && n.delete(r[0]), a;
    }
  }, {
    key: "delete",
    value: function(n) {
      if (this.has(n))
        return this.keys = this.keys.filter(function(r) {
          return !N2e(r, n);
        }), this.deleteByPath(this.cache, n);
    }
  }]), e;
}();
re(o6, "MAX_CACHE_SIZE", 20);
re(o6, "MAX_CACHE_OFFSET", 5);
var E8 = 0, a6 = /* @__PURE__ */ function() {
  function e(t) {
    Sr(this, e), re(this, "derivatives", void 0), re(this, "id", void 0), this.derivatives = Array.isArray(t) ? t : [t], this.id = E8, t.length === 0 && Cu(t.length > 0, "[Ant Design CSS-in-JS] Theme should have at least one derivative function."), E8 += 1;
  }
  return wr(e, [{
    key: "getDerivativeToken",
    value: function(n) {
      return this.derivatives.reduce(function(r, i) {
        return i(n, r);
      }, void 0);
    }
  }]), e;
}(), S5 = new o6();
function tS(e) {
  var t = Array.isArray(e) ? e : [e];
  return S5.has(t) || S5.set(t, new a6(t)), S5.get(t);
}
var D2e = /* @__PURE__ */ new WeakMap(), w5 = {};
function L2e(e, t) {
  for (var n = D2e, r = 0; r < t.length; r += 1) {
    var i = t[r];
    n.has(i) || n.set(i, /* @__PURE__ */ new WeakMap()), n = n.get(i);
  }
  return n.has(w5) || n.set(w5, e()), n.get(w5);
}
var C8 = /* @__PURE__ */ new WeakMap();
function v0(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1, n = C8.get(e) || "";
  return n || (Object.keys(e).forEach(function(r) {
    var i = e[r];
    n += r, i instanceof a6 ? n += i.id : i && _t(i) === "object" ? n += v0(i, t) : n += i;
  }), t && (n = Z0(n)), C8.set(e, n)), n;
}
function T8(e, t) {
  return Z0("".concat(t, "_").concat(v0(e, !0)));
}
var $g = "random-".concat(Date.now(), "-").concat(Math.random()).replace(/\./g, ""), dY = "_bAmBoO_";
function fY(e, t, n) {
  if (ao()) {
    var r, i;
    cc(e, $g);
    var o = document.createElement("div");
    o.style.position = "fixed", o.style.left = "0", o.style.top = "0", t == null || t(o), document.body.appendChild(o), process.env.NODE_ENV !== "production" && (o.innerHTML = "Test", o.style.zIndex = "9999999");
    var a = n ? n(o) : (r = getComputedStyle(o).content) === null || r === void 0 ? void 0 : r.includes(dY);
    return (i = o.parentNode) === null || i === void 0 || i.removeChild(o), Tg($g), a;
  }
  return !1;
}
var x5 = void 0;
function j2e() {
  return x5 === void 0 && (x5 = fY(":where(.".concat($g, ') { content: "').concat(dY, '"!important; }'), function(e) {
    e.className = $g;
  })), x5;
}
var E5 = void 0;
function F2e() {
  return E5 === void 0 && (E5 = fY(".".concat($g, " { inset-block: 93px !important; }"), function(e) {
    e.className = $g;
  }, function(e) {
    return getComputedStyle(e).bottom === "93px";
  })), E5;
}
var LA = ao();
function Qe(e) {
  return typeof e == "number" ? "".concat(e, "px") : e;
}
function ev(e, t, n) {
  var r = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {}, i = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : !1;
  if (i)
    return e;
  var o = ae(ae({}, r), {}, re(re({}, Ag, t), ms, n)), a = Object.keys(o).map(function(s) {
    var c = o[s];
    return c ? "".concat(s, '="').concat(c, '"') : null;
  }).filter(function(s) {
    return s;
  }).join(" ");
  return "<style ".concat(a, ">").concat(e, "</style>");
}
var y0 = function(t) {
  var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
  return "--".concat(n ? "".concat(n, "-") : "").concat(t).replace(/([a-z0-9])([A-Z])/g, "$1-$2").replace(/([A-Z]+)([A-Z][a-z0-9]+)/g, "$1-$2").replace(/([a-z])([A-Z0-9])/g, "$1-$2").toLowerCase();
}, V2e = function(t, n, r) {
  return Object.keys(t).length ? ".".concat(n).concat(r != null && r.scope ? ".".concat(r.scope) : "", "{").concat(Object.entries(t).map(function(i) {
    var o = fe(i, 2), a = o[0], s = o[1];
    return "".concat(a, ":").concat(s, ";");
  }).join(""), "}") : "";
}, hY = function(t, n, r) {
  var i = {}, o = {};
  return Object.entries(t).forEach(function(a) {
    var s, c, l = fe(a, 2), u = l[0], d = l[1];
    if (r != null && (s = r.preserve) !== null && s !== void 0 && s[u])
      o[u] = d;
    else if ((typeof d == "string" || typeof d == "number") && !(r != null && (c = r.ignore) !== null && c !== void 0 && c[u])) {
      var f, h = y0(u, r == null ? void 0 : r.prefix);
      i[h] = typeof d == "number" && !(r != null && (f = r.unitless) !== null && f !== void 0 && f[u]) ? "".concat(d, "px") : String(d), o[u] = "var(".concat(h, ")");
    }
  }), [o, V2e(i, n, {
    scope: r == null ? void 0 : r.scope
  })];
}, I8 = process.env.NODE_ENV !== "test" && ao() ? I.useLayoutEffect : I.useEffect, nr = function(t, n) {
  var r = I.useRef(!0);
  I8(function() {
    return t(r.current);
  }, n), I8(function() {
    return r.current = !1, function() {
      r.current = !0;
    };
  }, []);
}, b0 = function(t, n) {
  nr(function(r) {
    if (!r)
      return t();
  }, n);
}, B2e = ae({}, I), A8 = B2e.useInsertionEffect, z2e = function(t, n, r) {
  I.useMemo(t, r), nr(function() {
    return n(!0);
  }, r);
}, H2e = A8 ? function(e, t, n) {
  return A8(function() {
    return e(), t();
  }, n);
} : z2e, U2e = ae({}, I), W2e = U2e.useInsertionEffect, q2e = function(t) {
  var n = [], r = !1;
  function i(o) {
    if (r) {
      process.env.NODE_ENV !== "production" && Cu(!1, "[Ant Design CSS-in-JS] You are registering a cleanup function after unmount, which will not have any effect.");
      return;
    }
    n.push(o);
  }
  return I.useEffect(function() {
    return r = !1, function() {
      r = !0, n.length && n.forEach(function(o) {
        return o();
      });
    };
  }, t), i;
}, G2e = function() {
  return function(t) {
    t();
  };
}, K2e = typeof W2e < "u" ? q2e : G2e;
function Y2e() {
  return !1;
}
var jA = !1;
function X2e() {
  return jA;
}
const Q2e = process.env.NODE_ENV === "production" ? Y2e : X2e;
if (process.env.NODE_ENV !== "production" && typeof module < "u" && module && module.hot && typeof window < "u") {
  var C5 = window;
  if (typeof C5.webpackHotUpdate == "function") {
    var J2e = C5.webpackHotUpdate;
    C5.webpackHotUpdate = function() {
      return jA = !0, setTimeout(function() {
        jA = !1;
      }, 0), J2e.apply(void 0, arguments);
    };
  }
}
function s6(e, t, n, r, i) {
  var o = I.useContext(Rg), a = o.cache, s = [e].concat(Je(t)), c = DA(s), l = K2e([c]), u = Q2e(), d = function(g) {
    a.opUpdate(c, function(m) {
      var v = m || [void 0, void 0], y = fe(v, 2), S = y[0], _ = S === void 0 ? 0 : S, w = y[1], T = w;
      process.env.NODE_ENV !== "production" && w && u && (r == null || r(T, u), T = null);
      var x = T || n(), C = [_, x];
      return g ? g(C) : C;
    });
  };
  I.useMemo(
    function() {
      d();
    },
    /* eslint-disable react-hooks/exhaustive-deps */
    [c]
    /* eslint-enable */
  );
  var f = a.opGet(c);
  process.env.NODE_ENV !== "production" && !f && (d(), f = a.opGet(c));
  var h = f[1];
  return H2e(function() {
    i == null || i(h);
  }, function(p) {
    return d(function(g) {
      var m = fe(g, 2), v = m[0], y = m[1];
      return p && v === 0 && (i == null || i(h)), [v + 1, y];
    }), function() {
      a.opUpdate(c, function(g) {
        var m = g || [], v = fe(m, 2), y = v[0], S = y === void 0 ? 0 : y, _ = v[1], w = S - 1;
        return w === 0 ? (l(function() {
          (p || !a.opGet(c)) && (r == null || r(_, !1));
        }), null) : [S - 1, _];
      });
    };
  }, [c]), h;
}
var Z2e = {}, e5e = process.env.NODE_ENV !== "production" ? "css-dev-only-do-not-override" : "css", md = /* @__PURE__ */ new Map();
function t5e(e) {
  md.set(e, (md.get(e) || 0) + 1);
}
function n5e(e, t) {
  if (typeof document < "u") {
    var n = document.querySelectorAll("style[".concat(Ag, '="').concat(e, '"]'));
    n.forEach(function(r) {
      if (r[Kl] === t) {
        var i;
        (i = r.parentNode) === null || i === void 0 || i.removeChild(r);
      }
    });
  }
}
var r5e = 0;
function i5e(e, t) {
  md.set(e, (md.get(e) || 0) - 1);
  var n = Array.from(md.keys()), r = n.filter(function(i) {
    var o = md.get(i) || 0;
    return o <= 0;
  });
  n.length - r.length > r5e && r.forEach(function(i) {
    n5e(i, t), md.delete(i);
  });
}
var gY = function(t, n, r, i) {
  var o = r.getDerivativeToken(t), a = ae(ae({}, o), n);
  return i && (a = i(a)), a;
}, pY = "token";
function mY(e, t) {
  var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, r = St(Rg), i = r.cache.instanceId, o = r.container, a = n.salt, s = a === void 0 ? "" : a, c = n.override, l = c === void 0 ? Z2e : c, u = n.formatToken, d = n.getComputedToken, f = n.cssVar, h = L2e(function() {
    return Object.assign.apply(Object, [{}].concat(Je(t)));
  }, t), p = v0(h), g = v0(l), m = f ? v0(f) : "", v = s6(pY, [s, e.id, p, g, m], function() {
    var y, S = d ? d(h, l, e) : gY(h, l, e, u), _ = ae({}, S), w = "";
    if (f) {
      var T = hY(S, f.key, {
        prefix: f.prefix,
        ignore: f.ignore,
        unitless: f.unitless,
        preserve: f.preserve
      }), x = fe(T, 2);
      S = x[0], w = x[1];
    }
    var C = T8(S, s);
    S._tokenKey = C, _._tokenKey = T8(_, s);
    var E = (y = f == null ? void 0 : f.key) !== null && y !== void 0 ? y : C;
    S._themeKey = E, t5e(E);
    var R = "".concat(e5e, "-").concat(Z0(C));
    return S._hashId = R, [S, R, _, w, (f == null ? void 0 : f.key) || ""];
  }, function(y) {
    i5e(y[0]._themeKey, i);
  }, function(y) {
    var S = fe(y, 4), _ = S[0], w = S[3];
    if (f && w) {
      var T = cc(w, Z0("css-variables-".concat(_._themeKey)), {
        mark: ms,
        prepend: "queue",
        attachTo: o,
        priority: -999
      });
      T[Kl] = i, T.setAttribute(Ag, _._themeKey);
    }
  });
  return v;
}
var o5e = function(t, n, r) {
  var i = fe(t, 5), o = i[2], a = i[3], s = i[4], c = r || {}, l = c.plain;
  if (!a)
    return null;
  var u = o._tokenKey, d = -999, f = {
    "data-rc-order": "prependQueue",
    "data-rc-priority": "".concat(d)
  }, h = ev(a, s, u, f, l);
  return [d, u, h];
}, vY = {
  animationIterationCount: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  // SVG-related properties
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
}, yY = "comm", bY = "rule", _Y = "decl", a5e = "@import", s5e = "@keyframes", c5e = "@layer", SY = Math.abs, c6 = String.fromCharCode;
function wY(e) {
  return e.trim();
}
function j1(e, t, n) {
  return e.replace(t, n);
}
function l5e(e, t, n) {
  return e.indexOf(t, n);
}
function tv(e, t) {
  return e.charCodeAt(t) | 0;
}
function Og(e, t, n) {
  return e.slice(t, n);
}
function zs(e) {
  return e.length;
}
function u5e(e) {
  return e.length;
}
function Nb(e, t) {
  return t.push(e), e;
}
var Wx = 1, Pg = 1, xY = 0, Ba = 0, si = 0, wp = "";
function l6(e, t, n, r, i, o, a, s) {
  return { value: e, root: t, parent: n, type: r, props: i, children: o, line: Wx, column: Pg, length: a, return: "", siblings: s };
}
function d5e() {
  return si;
}
function f5e() {
  return si = Ba > 0 ? tv(wp, --Ba) : 0, Pg--, si === 10 && (Pg = 1, Wx--), si;
}
function vs() {
  return si = Ba < xY ? tv(wp, Ba++) : 0, Pg++, si === 10 && (Pg = 1, Wx++), si;
}
function Yl() {
  return tv(wp, Ba);
}
function F1() {
  return Ba;
}
function qx(e, t) {
  return Og(wp, e, t);
}
function nv(e) {
  switch (e) {
    case 0:
    case 9:
    case 10:
    case 13:
    case 32:
      return 5;
    case 33:
    case 43:
    case 44:
    case 47:
    case 62:
    case 64:
    case 126:
    case 59:
    case 123:
    case 125:
      return 4;
    case 58:
      return 3;
    case 34:
    case 39:
    case 40:
    case 91:
      return 2;
    case 41:
    case 93:
      return 1;
  }
  return 0;
}
function h5e(e) {
  return Wx = Pg = 1, xY = zs(wp = e), Ba = 0, [];
}
function g5e(e) {
  return wp = "", e;
}
function T5(e) {
  return wY(qx(Ba - 1, FA(e === 91 ? e + 2 : e === 40 ? e + 1 : e)));
}
function p5e(e) {
  for (; (si = Yl()) && si < 33; )
    vs();
  return nv(e) > 2 || nv(si) > 3 ? "" : " ";
}
function m5e(e, t) {
  for (; --t && vs() && !(si < 48 || si > 102 || si > 57 && si < 65 || si > 70 && si < 97); )
    ;
  return qx(e, F1() + (t < 6 && Yl() == 32 && vs() == 32));
}
function FA(e) {
  for (; vs(); )
    switch (si) {
      case e:
        return Ba;
      case 34:
      case 39:
        e !== 34 && e !== 39 && FA(si);
        break;
      case 40:
        e === 41 && FA(e);
        break;
      case 92:
        vs();
        break;
    }
  return Ba;
}
function v5e(e, t) {
  for (; vs() && e + si !== 47 + 10; )
    if (e + si === 42 + 42 && Yl() === 47)
      break;
  return "/*" + qx(t, Ba - 1) + "*" + c6(e === 47 ? e : vs());
}
function y5e(e) {
  for (; !nv(Yl()); )
    vs();
  return qx(e, Ba);
}
function b5e(e) {
  return g5e(V1("", null, null, null, [""], e = h5e(e), 0, [0], e));
}
function V1(e, t, n, r, i, o, a, s, c) {
  for (var l = 0, u = 0, d = a, f = 0, h = 0, p = 0, g = 1, m = 1, v = 1, y = 0, S = "", _ = i, w = o, T = r, x = S; m; )
    switch (p = y, y = vs()) {
      case 40:
        if (p != 108 && tv(x, d - 1) == 58) {
          l5e(x += j1(T5(y), "&", "&\f"), "&\f", SY(l ? s[l - 1] : 0)) != -1 && (v = -1);
          break;
        }
      case 34:
      case 39:
      case 91:
        x += T5(y);
        break;
      case 9:
      case 10:
      case 13:
      case 32:
        x += p5e(p);
        break;
      case 92:
        x += m5e(F1() - 1, 7);
        continue;
      case 47:
        switch (Yl()) {
          case 42:
          case 47:
            Nb(_5e(v5e(vs(), F1()), t, n, c), c), (nv(p || 1) == 5 || nv(Yl() || 1) == 5) && zs(x) && Og(x, -1, void 0) !== " " && (x += " ");
            break;
          default:
            x += "/";
        }
        break;
      case 123 * g:
        s[l++] = zs(x) * v;
      case 125 * g:
      case 59:
      case 0:
        switch (y) {
          case 0:
          case 125:
            m = 0;
          case 59 + u:
            v == -1 && (x = j1(x, /\f/g, "")), h > 0 && (zs(x) - d || g === 0 && p === 47) && Nb(h > 32 ? $8(x + ";", r, n, d - 1, c) : $8(j1(x, " ", "") + ";", r, n, d - 2, c), c);
            break;
          case 59:
            x += ";";
          default:
            if (Nb(T = R8(x, t, n, l, u, i, s, S, _ = [], w = [], d, o), o), y === 123)
              if (u === 0)
                V1(x, t, T, T, _, o, d, s, w);
              else
                switch (f === 99 && tv(x, 3) === 110 ? 100 : f) {
                  case 100:
                  case 108:
                  case 109:
                  case 115:
                    V1(e, T, T, r && Nb(R8(e, T, T, 0, 0, i, s, S, i, _ = [], d, w), w), i, w, d, s, r ? _ : w);
                    break;
                  default:
                    V1(x, T, T, T, [""], w, 0, s, w);
                }
        }
        l = u = h = 0, g = v = 1, S = x = "", d = a;
        break;
      case 58:
        d = 1 + zs(x), h = p;
      default:
        if (g < 1) {
          if (y == 123)
            --g;
          else if (y == 125 && g++ == 0 && f5e() == 125)
            continue;
        }
        switch (x += c6(y), y * g) {
          case 38:
            v = u > 0 ? 1 : (x += "\f", -1);
            break;
          case 44:
            s[l++] = (zs(x) - 1) * v, v = 1;
            break;
          case 64:
            Yl() === 45 && (x += T5(vs())), f = Yl(), u = d = zs(S = x += y5e(F1())), y++;
            break;
          case 45:
            p === 45 && zs(x) == 2 && (g = 0);
        }
    }
  return o;
}
function R8(e, t, n, r, i, o, a, s, c, l, u, d) {
  for (var f = i - 1, h = i === 0 ? o : [""], p = u5e(h), g = 0, m = 0, v = 0; g < r; ++g)
    for (var y = 0, S = Og(e, f + 1, f = SY(m = a[g])), _ = e; y < p; ++y)
      (_ = wY(m > 0 ? h[y] + " " + S : j1(S, /&\f/g, h[y]))) && (c[v++] = _);
  return l6(e, t, n, i === 0 ? bY : s, c, l, u, d);
}
function _5e(e, t, n, r) {
  return l6(e, t, n, yY, c6(d5e()), Og(e, 2, -2), 0, r);
}
function $8(e, t, n, r, i) {
  return l6(e, t, n, _Y, Og(e, 0, r), Og(e, r + 1, -1), r, i);
}
function VA(e, t) {
  for (var n = "", r = 0; r < e.length; r++)
    n += t(e[r], r, e, t) || "";
  return n;
}
function S5e(e, t, n, r) {
  switch (e.type) {
    case c5e:
      if (e.children.length)
        break;
    case a5e:
    case _Y:
      return e.return = e.return || e.value;
    case yY:
      return "";
    case s5e:
      return e.return = e.value + "{" + VA(e.children, r) + "}";
    case bY:
      if (!zs(e.value = e.props.join(",")))
        return "";
  }
  return zs(n = VA(e.children, r)) ? e.return = e.value + "{" + n + "}" : "";
}
function qc(e, t) {
  var n = t.path, r = t.parentSelectors;
  an(!1, "[Ant Design CSS-in-JS] ".concat(n ? "Error in ".concat(n, ": ") : "").concat(e).concat(r.length ? " Selector: ".concat(r.join(" | ")) : ""));
}
var w5e = function(t, n, r) {
  if (t === "content") {
    var i = /(attr|counters?|url|(((repeating-)?(linear|radial))|conic)-gradient)\(|(no-)?(open|close)-quote/, o = ["normal", "none", "initial", "inherit", "unset"];
    (typeof n != "string" || o.indexOf(n) === -1 && !i.test(n) && (n.charAt(0) !== n.charAt(n.length - 1) || n.charAt(0) !== '"' && n.charAt(0) !== "'")) && qc("You seem to be using a value for 'content' without quotes, try replacing it with `content: '\"".concat(n, "\"'`."), r);
  }
}, x5e = function(t, n, r) {
  t === "animation" && r.hashId && n !== "none" && qc("You seem to be using hashed animation '".concat(n, "', in which case 'animationName' with Keyframe as value is recommended."), r);
};
function E5e(e) {
  var t, n = ((t = e.match(/:not\(([^)]*)\)/)) === null || t === void 0 ? void 0 : t[1]) || "", r = n.split(/(\[[^[]*])|(?=[.#])/).filter(function(i) {
    return i;
  });
  return r.length > 1;
}
function C5e(e) {
  return e.parentSelectors.reduce(function(t, n) {
    return t ? n.includes("&") ? n.replace(/&/g, t) : "".concat(t, " ").concat(n) : n;
  }, "");
}
var T5e = function(t, n, r) {
  var i = C5e(r), o = i.match(/:not\([^)]*\)/g) || [];
  o.length > 0 && o.some(E5e) && qc("Concat ':not' selector not support in legacy browsers.", r);
}, I5e = function(t, n, r) {
  switch (t) {
    case "marginLeft":
    case "marginRight":
    case "paddingLeft":
    case "paddingRight":
    case "left":
    case "right":
    case "borderLeft":
    case "borderLeftWidth":
    case "borderLeftStyle":
    case "borderLeftColor":
    case "borderRight":
    case "borderRightWidth":
    case "borderRightStyle":
    case "borderRightColor":
    case "borderTopLeftRadius":
    case "borderTopRightRadius":
    case "borderBottomLeftRadius":
    case "borderBottomRightRadius":
      qc("You seem to be using non-logical property '".concat(t, "' which is not compatible with RTL mode. Please use logical properties and values instead. For more information: https://developer.mozilla.org/en-US/docs/Web/CSS/CSS_Logical_Properties."), r);
      return;
    case "margin":
    case "padding":
    case "borderWidth":
    case "borderStyle":
      if (typeof n == "string") {
        var i = n.split(" ").map(function(s) {
          return s.trim();
        });
        i.length === 4 && i[1] !== i[3] && qc("You seem to be using '".concat(t, "' property with different left ").concat(t, " and right ").concat(t, ", which is not compatible with RTL mode. Please use logical properties and values instead. For more information: https://developer.mozilla.org/en-US/docs/Web/CSS/CSS_Logical_Properties."), r);
      }
      return;
    case "clear":
    case "textAlign":
      (n === "left" || n === "right") && qc("You seem to be using non-logical value '".concat(n, "' of ").concat(t, ", which is not compatible with RTL mode. Please use logical properties and values instead. For more information: https://developer.mozilla.org/en-US/docs/Web/CSS/CSS_Logical_Properties."), r);
      return;
    case "borderRadius":
      if (typeof n == "string") {
        var o = n.split("/").map(function(s) {
          return s.trim();
        }), a = o.reduce(function(s, c) {
          if (s)
            return s;
          var l = c.split(" ").map(function(u) {
            return u.trim();
          });
          return l.length >= 2 && l[0] !== l[1] || l.length === 3 && l[1] !== l[2] || l.length === 4 && l[2] !== l[3] ? !0 : s;
        }, !1);
        a && qc("You seem to be using non-logical value '".concat(n, "' of ").concat(t, ", which is not compatible with RTL mode. Please use logical properties and values instead. For more information: https://developer.mozilla.org/en-US/docs/Web/CSS/CSS_Logical_Properties."), r);
      }
      return;
  }
}, A5e = function(t, n, r) {
  (typeof n == "string" && /NaN/g.test(n) || Number.isNaN(n)) && qc("Unexpected 'NaN' in property '".concat(t, ": ").concat(n, "'."), r);
}, R5e = function(t, n, r) {
  r.parentSelectors.some(function(i) {
    var o = i.split(",");
    return o.some(function(a) {
      return a.split("&").length > 2;
    });
  }) && qc("Should not use more than one `&` in a selector.", r);
}, _0 = "data-ant-cssinjs-cache-path", EY = "_FILE_STYLE__";
function $5e(e) {
  return Object.keys(e).map(function(t) {
    var n = e[t];
    return "".concat(t, ":").concat(n);
  }).join(";");
}
var jd, CY = !0;
function O5e() {
  if (!jd && (jd = {}, ao())) {
    var e = document.createElement("div");
    e.className = _0, e.style.position = "fixed", e.style.visibility = "hidden", e.style.top = "-9999px", document.body.appendChild(e);
    var t = getComputedStyle(e).content || "";
    t = t.replace(/^"/, "").replace(/"$/, ""), t.split(";").forEach(function(i) {
      var o = i.split(":"), a = fe(o, 2), s = a[0], c = a[1];
      jd[s] = c;
    });
    var n = document.querySelector("style[".concat(_0, "]"));
    if (n) {
      var r;
      CY = !1, (r = n.parentNode) === null || r === void 0 || r.removeChild(n);
    }
    document.body.removeChild(e);
  }
}
function P5e(e) {
  return O5e(), !!jd[e];
}
function M5e(e) {
  var t = jd[e], n = null;
  if (t && ao())
    if (CY)
      n = EY;
    else {
      var r = document.querySelector("style[".concat(ms, '="').concat(jd[e], '"]'));
      r ? n = r.innerHTML : delete jd[e];
    }
  return [n, t];
}
var TY = "_skip_check_", IY = "_multi_value_";
function B1(e) {
  var t = VA(b5e(e), S5e);
  return t.replace(/\{%%%\:[^;];}/g, ";");
}
function k5e(e) {
  return _t(e) === "object" && e && (TY in e || IY in e);
}
function O8(e, t, n) {
  if (!t)
    return e;
  var r = ".".concat(t), i = n === "low" ? ":where(".concat(r, ")") : r, o = e.split(",").map(function(a) {
    var s, c = a.trim().split(/\s+/), l = c[0] || "", u = ((s = l.match(/^\w+/)) === null || s === void 0 ? void 0 : s[0]) || "";
    return l = "".concat(u).concat(i).concat(l.slice(u.length)), [l].concat(Je(c.slice(1))).join(" ");
  });
  return o.join(",");
}
var N5e = function e(t) {
  var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {
    root: !0,
    parentSelectors: []
  }, i = r.root, o = r.injectHash, a = r.parentSelectors, s = n.hashId, c = n.layer, l = n.path, u = n.hashPriority, d = n.transformers, f = d === void 0 ? [] : d, h = n.linters, p = h === void 0 ? [] : h, g = "", m = {};
  function v(_) {
    var w = _.getName(s);
    if (!m[w]) {
      var T = e(_.style, n, {
        root: !1,
        parentSelectors: a
      }), x = fe(T, 1), C = x[0];
      m[w] = "@keyframes ".concat(_.getName(s)).concat(C);
    }
  }
  function y(_) {
    var w = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
    return _.forEach(function(T) {
      Array.isArray(T) ? y(T, w) : T && w.push(T);
    }), w;
  }
  var S = y(Array.isArray(t) ? t : [t]);
  return S.forEach(function(_) {
    var w = typeof _ == "string" && !i ? {} : _;
    if (typeof w == "string")
      g += "".concat(w, `
`);
    else if (w._keyframe)
      v(w);
    else {
      var T = f.reduce(function(x, C) {
        var E;
        return (C == null || (E = C.visit) === null || E === void 0 ? void 0 : E.call(C, x)) || x;
      }, w);
      Object.keys(T).forEach(function(x) {
        var C = T[x];
        if (_t(C) === "object" && C && (x !== "animationName" || !C._keyframe) && !k5e(C)) {
          var E = !1, R = x.trim(), A = !1;
          (i || o) && s ? R.startsWith("@") ? E = !0 : R === "&" ? R = O8("", s, u) : R = O8(x, s, u) : i && !s && (R === "&" || R === "") && (R = "", A = !0);
          var O = e(C, n, {
            root: A,
            injectHash: E,
            parentSelectors: [].concat(Je(a), [R])
          }), $ = fe(O, 2), N = $[0], z = $[1];
          m = ae(ae({}, m), z), g += "".concat(R).concat(N);
        } else {
          let V = function(j, B) {
            process.env.NODE_ENV !== "production" && (_t(C) !== "object" || !(C != null && C[TY])) && [w5e, x5e].concat(Je(p)).forEach(function(K) {
              return K(j, B, {
                path: l,
                hashId: s,
                parentSelectors: a
              });
            });
            var U = j.replace(/[A-Z]/g, function(K) {
              return "-".concat(K.toLowerCase());
            }), Q = B;
            !vY[j] && typeof Q == "number" && Q !== 0 && (Q = "".concat(Q, "px")), j === "animationName" && B !== null && B !== void 0 && B._keyframe && (v(B), Q = B.getName(s)), g += "".concat(U, ":").concat(Q, ";");
          };
          var k, F = (k = C == null ? void 0 : C.value) !== null && k !== void 0 ? k : C;
          _t(C) === "object" && C !== null && C !== void 0 && C[IY] && Array.isArray(F) ? F.forEach(function(j) {
            V(x, j);
          }) : V(x, F);
        }
      });
    }
  }), i ? c && (g = "@layer ".concat(c.name, " {").concat(g, "}"), c.dependencies && (m["@layer ".concat(c.name)] = c.dependencies.map(function(_) {
    return "@layer ".concat(_, ", ").concat(c.name, ";");
  }).join(`
`))) : g = "{".concat(g, "}"), [g, m];
};
function AY(e, t) {
  return Z0("".concat(e.join("%")).concat(t));
}
function D5e() {
  return null;
}
var RY = "style";
function nS(e, t) {
  var n = e.token, r = e.path, i = e.hashId, o = e.layer, a = e.nonce, s = e.clientOnly, c = e.order, l = c === void 0 ? 0 : c, u = I.useContext(Rg), d = u.autoClear, f = u.mock, h = u.defaultCache, p = u.hashPriority, g = u.container, m = u.ssrInline, v = u.transformers, y = u.linters, S = u.cache, _ = u.layer, w = n._tokenKey, T = [w];
  _ && T.push("layer"), T.push.apply(T, Je(r));
  var x = LA;
  process.env.NODE_ENV !== "production" && f !== void 0 && (x = f === "client");
  var C = s6(
    RY,
    T,
    // Create cache if needed
    function() {
      var $ = T.join("|");
      if (P5e($)) {
        var N = M5e($), z = fe(N, 2), k = z[0], F = z[1];
        if (k)
          return [k, w, F, {}, s, l];
      }
      var V = t(), j = N5e(V, {
        hashId: i,
        hashPriority: p,
        layer: _ ? o : void 0,
        path: r.join("-"),
        transformers: v,
        linters: y
      }), B = fe(j, 2), U = B[0], Q = B[1], K = B1(U), q = AY(T, K);
      return [K, w, q, Q, s, l];
    },
    // Remove cache if no need
    function($, N) {
      var z = fe($, 3), k = z[2];
      (N || d) && LA && Tg(k, {
        mark: ms
      });
    },
    // Effect: Inject style here
    function($) {
      var N = fe($, 4), z = N[0];
      N[1];
      var k = N[2], F = N[3];
      if (x && z !== EY) {
        var V = {
          mark: ms,
          prepend: _ ? !1 : "queue",
          attachTo: g,
          priority: l
        }, j = typeof a == "function" ? a() : a;
        j && (V.csp = {
          nonce: j
        });
        var B = [], U = [];
        Object.keys(F).forEach(function(K) {
          K.startsWith("@layer") ? B.push(K) : U.push(K);
        }), B.forEach(function(K) {
          cc(B1(F[K]), "_layer-".concat(K), ae(ae({}, V), {}, {
            prepend: !0
          }));
        });
        var Q = cc(z, k, V);
        Q[Kl] = S.instanceId, Q.setAttribute(Ag, w), process.env.NODE_ENV !== "production" && Q.setAttribute(R2e, T.join("|")), U.forEach(function(K) {
          cc(B1(F[K]), "_effect-".concat(K), V);
        });
      }
    }
  ), E = fe(C, 3), R = E[0], A = E[1], O = E[2];
  return function($) {
    var N;
    return !m || x || !h ? N = /* @__PURE__ */ I.createElement(D5e, null) : N = /* @__PURE__ */ I.createElement("style", mt({}, re(re({}, Ag, A), ms, O), {
      dangerouslySetInnerHTML: {
        __html: R
      }
    })), /* @__PURE__ */ I.createElement(I.Fragment, null, N, $);
  };
}
var L5e = function(t, n, r) {
  var i = fe(t, 6), o = i[0], a = i[1], s = i[2], c = i[3], l = i[4], u = i[5], d = r || {}, f = d.plain;
  if (l)
    return null;
  var h = o, p = {
    "data-rc-order": "prependQueue",
    "data-rc-priority": "".concat(u)
  };
  return h = ev(o, a, s, p, f), c && Object.keys(c).forEach(function(g) {
    if (!n[g]) {
      n[g] = !0;
      var m = B1(c[g]), v = ev(m, a, "_effect-".concat(g), p, f);
      g.startsWith("@layer") ? h = v + h : h += v;
    }
  }), [u, s, h];
}, $Y = "cssVar", OY = function(t, n) {
  var r = t.key, i = t.prefix, o = t.unitless, a = t.ignore, s = t.token, c = t.scope, l = c === void 0 ? "" : c, u = St(Rg), d = u.cache.instanceId, f = u.container, h = s._tokenKey, p = [].concat(Je(t.path), [r, l, h]), g = s6($Y, p, function() {
    var m = n(), v = hY(m, r, {
      prefix: i,
      unitless: o,
      ignore: a,
      scope: l
    }), y = fe(v, 2), S = y[0], _ = y[1], w = AY(p, _);
    return [S, _, w, r];
  }, function(m) {
    var v = fe(m, 3), y = v[2];
    LA && Tg(y, {
      mark: ms
    });
  }, function(m) {
    var v = fe(m, 3), y = v[1], S = v[2];
    if (y) {
      var _ = cc(y, S, {
        mark: ms,
        prepend: "queue",
        attachTo: f,
        priority: -999
      });
      _[Kl] = d, _.setAttribute(Ag, r);
    }
  });
  return g;
}, j5e = function(t, n, r) {
  var i = fe(t, 4), o = i[1], a = i[2], s = i[3], c = r || {}, l = c.plain;
  if (!o)
    return null;
  var u = -999, d = {
    "data-rc-order": "prependQueue",
    "data-rc-priority": "".concat(u)
  }, f = ev(o, s, a, d, l);
  return [u, a, f];
}, F5e = re(re(re({}, RY, L5e), pY, o5e), $Y, j5e);
function V5e(e) {
  return e !== null;
}
function B5e(e, t) {
  var n = typeof t == "boolean" ? {
    plain: t
  } : t || {}, r = n.plain, i = r === void 0 ? !1 : r, o = n.types, a = o === void 0 ? ["style", "token", "cssVar"] : o, s = new RegExp("^(".concat((typeof a == "string" ? [a] : a).join("|"), ")%")), c = Array.from(e.cache.keys()).filter(function(f) {
    return s.test(f);
  }), l = {}, u = {}, d = "";
  return c.map(function(f) {
    var h = f.replace(s, "").replace(/%/g, "|"), p = f.split("%"), g = fe(p, 1), m = g[0], v = F5e[m], y = v(e.cache.get(f)[1], l, {
      plain: i
    });
    if (!y)
      return null;
    var S = fe(y, 3), _ = S[0], w = S[1], T = S[2];
    return f.startsWith("style") && (u[h] = w), [_, T];
  }).filter(V5e).sort(function(f, h) {
    var p = fe(f, 1), g = p[0], m = fe(h, 1), v = m[0];
    return g - v;
  }).forEach(function(f) {
    var h = fe(f, 2), p = h[1];
    d += p;
  }), d += ev(".".concat(_0, '{content:"').concat($5e(u), '";}'), void 0, void 0, re({}, _0, _0), i), d;
}
var $n = /* @__PURE__ */ function() {
  function e(t, n) {
    Sr(this, e), re(this, "name", void 0), re(this, "style", void 0), re(this, "_keyframe", !0), this.name = t, this.style = n;
  }
  return wr(e, [{
    key: "getName",
    value: function() {
      var n = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
      return n ? "".concat(n, "-").concat(this.name) : this.name;
    }
  }]), e;
}();
function z5e(e) {
  if (typeof e == "number")
    return [[e], !1];
  var t = String(e).trim(), n = t.match(/(.*)(!important)/), r = (n ? n[1] : t).trim().split(/\s+/), i = [], o = 0;
  return [r.reduce(function(a, s) {
    if (s.includes("(") || s.includes(")")) {
      var c = s.split("(").length - 1, l = s.split(")").length - 1;
      o += c - l;
    }
    return o >= 0 && i.push(s), o === 0 && (a.push(i.join(" ")), i = []), a;
  }, []), !!n];
}
function nh(e) {
  return e.notSplit = !0, e;
}
var H5e = {
  // Inset
  inset: ["top", "right", "bottom", "left"],
  insetBlock: ["top", "bottom"],
  insetBlockStart: ["top"],
  insetBlockEnd: ["bottom"],
  insetInline: ["left", "right"],
  insetInlineStart: ["left"],
  insetInlineEnd: ["right"],
  // Margin
  marginBlock: ["marginTop", "marginBottom"],
  marginBlockStart: ["marginTop"],
  marginBlockEnd: ["marginBottom"],
  marginInline: ["marginLeft", "marginRight"],
  marginInlineStart: ["marginLeft"],
  marginInlineEnd: ["marginRight"],
  // Padding
  paddingBlock: ["paddingTop", "paddingBottom"],
  paddingBlockStart: ["paddingTop"],
  paddingBlockEnd: ["paddingBottom"],
  paddingInline: ["paddingLeft", "paddingRight"],
  paddingInlineStart: ["paddingLeft"],
  paddingInlineEnd: ["paddingRight"],
  // Border
  borderBlock: nh(["borderTop", "borderBottom"]),
  borderBlockStart: nh(["borderTop"]),
  borderBlockEnd: nh(["borderBottom"]),
  borderInline: nh(["borderLeft", "borderRight"]),
  borderInlineStart: nh(["borderLeft"]),
  borderInlineEnd: nh(["borderRight"]),
  // Border width
  borderBlockWidth: ["borderTopWidth", "borderBottomWidth"],
  borderBlockStartWidth: ["borderTopWidth"],
  borderBlockEndWidth: ["borderBottomWidth"],
  borderInlineWidth: ["borderLeftWidth", "borderRightWidth"],
  borderInlineStartWidth: ["borderLeftWidth"],
  borderInlineEndWidth: ["borderRightWidth"],
  // Border style
  borderBlockStyle: ["borderTopStyle", "borderBottomStyle"],
  borderBlockStartStyle: ["borderTopStyle"],
  borderBlockEndStyle: ["borderBottomStyle"],
  borderInlineStyle: ["borderLeftStyle", "borderRightStyle"],
  borderInlineStartStyle: ["borderLeftStyle"],
  borderInlineEndStyle: ["borderRightStyle"],
  // Border color
  borderBlockColor: ["borderTopColor", "borderBottomColor"],
  borderBlockStartColor: ["borderTopColor"],
  borderBlockEndColor: ["borderBottomColor"],
  borderInlineColor: ["borderLeftColor", "borderRightColor"],
  borderInlineStartColor: ["borderLeftColor"],
  borderInlineEndColor: ["borderRightColor"],
  // Border radius
  borderStartStartRadius: ["borderTopLeftRadius"],
  borderStartEndRadius: ["borderTopRightRadius"],
  borderEndStartRadius: ["borderBottomLeftRadius"],
  borderEndEndRadius: ["borderBottomRightRadius"]
};
function Db(e, t) {
  var n = e;
  return t && (n = "".concat(n, " !important")), {
    _skip_check_: !0,
    value: n
  };
}
var U5e = {
  visit: function(t) {
    var n = {};
    return Object.keys(t).forEach(function(r) {
      var i = t[r], o = H5e[r];
      if (o && (typeof i == "number" || typeof i == "string")) {
        var a = z5e(i), s = fe(a, 2), c = s[0], l = s[1];
        o.length && o.notSplit ? o.forEach(function(u) {
          n[u] = Db(i, l);
        }) : o.length === 1 ? n[o[0]] = Db(c[0], l) : o.length === 2 ? o.forEach(function(u, d) {
          var f;
          n[u] = Db((f = c[d]) !== null && f !== void 0 ? f : c[0], l);
        }) : o.length === 4 ? o.forEach(function(u, d) {
          var f, h;
          n[u] = Db((f = (h = c[d]) !== null && h !== void 0 ? h : c[d - 2]) !== null && f !== void 0 ? f : c[0], l);
        }) : n[r] = i;
      } else
        n[r] = i;
    }), n;
  }
}, I5 = /url\([^)]+\)|var\([^)]+\)|(\d*\.?\d+)px/g;
function W5e(e, t) {
  var n = Math.pow(10, t + 1), r = Math.floor(e * n);
  return Math.round(r / 10) * 10 / n;
}
var q5e = function() {
  var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, n = t.rootValue, r = n === void 0 ? 16 : n, i = t.precision, o = i === void 0 ? 5 : i, a = t.mediaQuery, s = a === void 0 ? !1 : a, c = function(d, f) {
    if (!f)
      return d;
    var h = parseFloat(f);
    if (h <= 1)
      return d;
    var p = W5e(h / r, o);
    return "".concat(p, "rem");
  }, l = function(d) {
    var f = ae({}, d);
    return Object.entries(d).forEach(function(h) {
      var p = fe(h, 2), g = p[0], m = p[1];
      if (typeof m == "string" && m.includes("px")) {
        var v = m.replace(I5, c);
        f[g] = v;
      }
      !vY[g] && typeof m == "number" && m !== 0 && (f[g] = "".concat(m, "px").replace(I5, c));
      var y = g.trim();
      if (y.startsWith("@") && y.includes("px") && s) {
        var S = g.replace(I5, c);
        f[S] = f[g], delete f[g];
      }
    }), f;
  };
  return {
    visit: l
  };
}, G5e = {
  supportModernCSS: function() {
    return j2e() && F2e();
  }
};
const K5e = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Keyframes: $n,
  NaNLinter: A5e,
  StyleProvider: $2e,
  Theme: a6,
  _experimental: G5e,
  createCache: i6,
  createTheme: tS,
  extractStyle: B5e,
  genCalc: k2e,
  getComputedToken: gY,
  legacyLogicalPropertiesTransformer: U5e,
  legacyNotSelectorLinter: T5e,
  logicalPropertiesLinter: I5e,
  parentSelectorLinter: R5e,
  px2remTransformer: q5e,
  token2CSSVar: y0,
  unit: Qe,
  useCSSVarRegister: OY,
  useCacheToken: mY,
  useStyleRegister: nS
}, Symbol.toStringTag, { value: "Module" }));
var Y5e = /* @__PURE__ */ Is({});
const u6 = Y5e;
function PY(e) {
  return iY(e) || eY(e) || n6(e) || oY();
}
function Ys(e, t) {
  for (var n = e, r = 0; r < t.length; r += 1) {
    if (n == null)
      return;
    n = n[t[r]];
  }
  return n;
}
function MY(e, t, n, r) {
  if (!t.length)
    return n;
  var i = PY(t), o = i[0], a = i.slice(1), s;
  return !e && typeof o == "number" ? s = [] : Array.isArray(e) ? s = Je(e) : s = ae({}, e), r && n === void 0 && a.length === 1 ? delete s[o][a[0]] : s[o] = MY(s[o], a, n, r), s;
}
function is(e, t, n) {
  var r = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : !1;
  return t.length && r && n === void 0 && !Ys(e, t.slice(0, -1)) ? e : MY(e, t, n, r);
}
function X5e(e) {
  return _t(e) === "object" && e !== null && Object.getPrototypeOf(e) === Object.prototype;
}
function P8(e) {
  return Array.isArray(e) ? [] : {};
}
var Q5e = typeof Reflect > "u" ? Object.keys : Reflect.ownKeys;
function kh() {
  for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
    t[n] = arguments[n];
  var r = P8(t[0]);
  return t.forEach(function(i) {
    function o(a, s) {
      var c = new Set(s), l = Ys(i, a), u = Array.isArray(l);
      if (u || X5e(l)) {
        if (!c.has(l)) {
          c.add(l);
          var d = Ys(r, a);
          u ? r = is(r, a, []) : (!d || _t(d) !== "object") && (r = is(r, a, P8(l))), Q5e(l).forEach(function(f) {
            o([].concat(Je(a), [f]), c);
          });
        }
      } else
        r = is(r, a, l);
    }
    o([]);
  }), r;
}
function kY() {
}
let Ac = null;
function J5e() {
  Ac = null, HK();
}
let d6 = kY;
process.env.NODE_ENV !== "production" && (d6 = (e, t, n) => {
  an(e, `[antd: ${t}] ${n}`), process.env.NODE_ENV === "test" && J5e();
});
const NY = /* @__PURE__ */ I.createContext({}), di = process.env.NODE_ENV !== "production" ? (e) => {
  const {
    strict: t
  } = I.useContext(NY), n = (r, i, o) => {
    if (!r)
      if (t === !1 && i === "deprecated") {
        const a = Ac;
        Ac || (Ac = {}), Ac[e] = Ac[e] || [], Ac[e].includes(o || "") || Ac[e].push(o || ""), a || console.warn("[antd] There exists deprecated usage in your code:", Ac);
      } else
        process.env.NODE_ENV !== "production" && d6(r, e, o);
  };
  return n.deprecated = (r, i, o, a) => {
    n(r, "deprecated", `\`${i}\` is deprecated. Please use \`${o}\` instead.${a ? ` ${a}` : ""}`);
  }, n;
} : () => {
  const e = () => {
  };
  return e.deprecated = kY, e;
}, Gx = d6, Z5e = /* @__PURE__ */ Is(void 0);
var eTe = {
  // Options
  items_per_page: "/ page",
  jump_to: "Go to",
  jump_to_confirm: "confirm",
  page: "Page",
  // Pagination
  prev_page: "Previous Page",
  next_page: "Next Page",
  prev_5: "Previous 5 Pages",
  next_5: "Next 5 Pages",
  prev_3: "Previous 3 Pages",
  next_3: "Next 3 Pages",
  page_size: "Page Size"
}, tTe = {
  yearFormat: "YYYY",
  dayFormat: "D",
  cellMeridiemFormat: "A",
  monthBeforeYear: !0
}, nTe = ae(ae({}, tTe), {}, {
  locale: "en_US",
  today: "Today",
  now: "Now",
  backToToday: "Back to today",
  ok: "OK",
  clear: "Clear",
  month: "Month",
  year: "Year",
  timeSelect: "select time",
  dateSelect: "select date",
  weekSelect: "Choose a week",
  monthSelect: "Choose a month",
  yearSelect: "Choose a year",
  decadeSelect: "Choose a decade",
  dateFormat: "M/D/YYYY",
  dateTimeFormat: "M/D/YYYY HH:mm:ss",
  previousMonth: "Previous month (PageUp)",
  nextMonth: "Next month (PageDown)",
  previousYear: "Last year (Control + left)",
  nextYear: "Next year (Control + right)",
  previousDecade: "Last decade",
  nextDecade: "Next decade",
  previousCentury: "Last century",
  nextCentury: "Next century"
});
const rTe = {
  placeholder: "Select time",
  rangePlaceholder: ["Start time", "End time"]
}, DY = rTe, iTe = {
  lang: Object.assign({
    placeholder: "Select date",
    yearPlaceholder: "Select year",
    quarterPlaceholder: "Select quarter",
    monthPlaceholder: "Select month",
    weekPlaceholder: "Select week",
    rangePlaceholder: ["Start date", "End date"],
    rangeYearPlaceholder: ["Start year", "End year"],
    rangeQuarterPlaceholder: ["Start quarter", "End quarter"],
    rangeMonthPlaceholder: ["Start month", "End month"],
    rangeWeekPlaceholder: ["Start week", "End week"]
  }, nTe),
  timePickerLocale: Object.assign({}, DY)
}, M8 = iTe, ia = "${label} is not a valid ${type}", oTe = {
  locale: "en",
  Pagination: eTe,
  DatePicker: M8,
  TimePicker: DY,
  Calendar: M8,
  global: {
    placeholder: "Please select"
  },
  Table: {
    filterTitle: "Filter menu",
    filterConfirm: "OK",
    filterReset: "Reset",
    filterEmptyText: "No filters",
    filterCheckall: "Select all items",
    filterSearchPlaceholder: "Search in filters",
    emptyText: "No data",
    selectAll: "Select current page",
    selectInvert: "Invert current page",
    selectNone: "Clear all data",
    selectionAll: "Select all data",
    sortTitle: "Sort",
    expand: "Expand row",
    collapse: "Collapse row",
    triggerDesc: "Click to sort descending",
    triggerAsc: "Click to sort ascending",
    cancelSort: "Click to cancel sorting"
  },
  Tour: {
    Next: "Next",
    Previous: "Previous",
    Finish: "Finish"
  },
  Modal: {
    okText: "OK",
    cancelText: "Cancel",
    justOkText: "OK"
  },
  Popconfirm: {
    okText: "OK",
    cancelText: "Cancel"
  },
  Transfer: {
    titles: ["", ""],
    searchPlaceholder: "Search here",
    itemUnit: "item",
    itemsUnit: "items",
    remove: "Remove",
    selectCurrent: "Select current page",
    removeCurrent: "Remove current page",
    selectAll: "Select all data",
    deselectAll: "Deselect all data",
    removeAll: "Remove all data",
    selectInvert: "Invert current page"
  },
  Upload: {
    uploading: "Uploading...",
    removeFile: "Remove file",
    uploadError: "Upload error",
    previewFile: "Preview file",
    downloadFile: "Download file"
  },
  Empty: {
    description: "No data"
  },
  Icon: {
    icon: "icon"
  },
  Text: {
    edit: "Edit",
    copy: "Copy",
    copied: "Copied",
    expand: "Expand",
    collapse: "Collapse"
  },
  Form: {
    optional: "(optional)",
    defaultValidateMessages: {
      default: "Field validation error for ${label}",
      required: "Please enter ${label}",
      enum: "${label} must be one of [${enum}]",
      whitespace: "${label} cannot be a blank character",
      date: {
        format: "${label} date format is invalid",
        parse: "${label} cannot be converted to a date",
        invalid: "${label} is an invalid date"
      },
      types: {
        string: ia,
        method: ia,
        array: ia,
        object: ia,
        number: ia,
        date: ia,
        boolean: ia,
        integer: ia,
        float: ia,
        regexp: ia,
        email: ia,
        url: ia,
        hex: ia
      },
      string: {
        len: "${label} must be ${len} characters",
        min: "${label} must be at least ${min} characters",
        max: "${label} must be up to ${max} characters",
        range: "${label} must be between ${min}-${max} characters"
      },
      number: {
        len: "${label} must be equal to ${len}",
        min: "${label} must be minimum ${min}",
        max: "${label} must be maximum ${max}",
        range: "${label} must be between ${min}-${max}"
      },
      array: {
        len: "Must be ${len} ${label}",
        min: "At least ${min} ${label}",
        max: "At most ${max} ${label}",
        range: "The amount of ${label} must be between ${min}-${max}"
      },
      pattern: {
        mismatch: "${label} does not match the pattern ${pattern}"
      }
    }
  },
  Image: {
    preview: "Preview"
  },
  QRCode: {
    expired: "QR code expired",
    refresh: "Refresh",
    scanned: "Scanned"
  },
  ColorPicker: {
    presetEmpty: "Empty",
    transparent: "Transparent",
    singleColor: "Single",
    gradientColor: "Gradient"
  }
}, Mg = oTe;
Object.assign({}, Mg.Modal);
let z1 = [];
const k8 = () => z1.reduce((e, t) => Object.assign(Object.assign({}, e), t), Mg.Modal);
function aTe(e) {
  if (e) {
    const t = Object.assign({}, e);
    return z1.push(t), k8(), () => {
      z1 = z1.filter((n) => n !== t), k8();
    };
  }
  Object.assign({}, Mg.Modal);
}
const sTe = /* @__PURE__ */ Is(void 0), f6 = sTe, cTe = (e, t) => {
  const n = I.useContext(f6), r = I.useMemo(() => {
    var o;
    const a = t || Mg[e], s = (o = n == null ? void 0 : n[e]) !== null && o !== void 0 ? o : {};
    return Object.assign(Object.assign({}, typeof a == "function" ? a() : a), s || {});
  }, [e, t, n]), i = I.useMemo(() => {
    const o = n == null ? void 0 : n.locale;
    return n != null && n.exist && !o ? Mg.locale : o;
  }, [n]);
  return [r, i];
}, h6 = cTe, LY = "internalMark", jY = (e) => {
  const {
    locale: t = {},
    children: n,
    _ANT_MARK__: r
  } = e;
  if (process.env.NODE_ENV !== "production") {
    const o = di("LocaleProvider");
    process.env.NODE_ENV !== "production" && o(r === LY, "deprecated", "`LocaleProvider` is deprecated. Please use `locale` with `ConfigProvider` instead: http://u.ant.design/locale");
  }
  I.useEffect(() => aTe(t == null ? void 0 : t.Modal), [t]);
  const i = I.useMemo(() => Object.assign(Object.assign({}, t), {
    exist: !0
  }), [t]);
  return /* @__PURE__ */ I.createElement(f6.Provider, {
    value: i
  }, n);
};
process.env.NODE_ENV !== "production" && (jY.displayName = "LocaleProvider");
const lTe = jY;
function zi(e, t) {
  uTe(e) && (e = "100%");
  var n = dTe(e);
  return e = t === 360 ? e : Math.min(t, Math.max(0, parseFloat(e))), n && (e = parseInt(String(e * t), 10) / 100), Math.abs(e - t) < 1e-6 ? 1 : (t === 360 ? e = (e < 0 ? e % t + t : e % t) / parseFloat(String(t)) : e = e % t / parseFloat(String(t)), e);
}
function Lb(e) {
  return Math.min(1, Math.max(0, e));
}
function uTe(e) {
  return typeof e == "string" && e.indexOf(".") !== -1 && parseFloat(e) === 1;
}
function dTe(e) {
  return typeof e == "string" && e.indexOf("%") !== -1;
}
function FY(e) {
  return e = parseFloat(e), (isNaN(e) || e < 0 || e > 1) && (e = 1), e;
}
function wd(e) {
  return e <= 1 ? "".concat(Number(e) * 100, "%") : e;
}
function us(e) {
  return e.length === 1 ? "0" + e : String(e);
}
function VY(e, t, n) {
  return {
    r: zi(e, 255) * 255,
    g: zi(t, 255) * 255,
    b: zi(n, 255) * 255
  };
}
function BA(e, t, n) {
  e = zi(e, 255), t = zi(t, 255), n = zi(n, 255);
  var r = Math.max(e, t, n), i = Math.min(e, t, n), o = 0, a = 0, s = (r + i) / 2;
  if (r === i)
    a = 0, o = 0;
  else {
    var c = r - i;
    switch (a = s > 0.5 ? c / (2 - r - i) : c / (r + i), r) {
      case e:
        o = (t - n) / c + (t < n ? 6 : 0);
        break;
      case t:
        o = (n - e) / c + 2;
        break;
      case n:
        o = (e - t) / c + 4;
        break;
    }
    o /= 6;
  }
  return { h: o, s: a, l: s };
}
function A5(e, t, n) {
  return n < 0 && (n += 1), n > 1 && (n -= 1), n < 1 / 6 ? e + (t - e) * (6 * n) : n < 1 / 2 ? t : n < 2 / 3 ? e + (t - e) * (2 / 3 - n) * 6 : e;
}
function BY(e, t, n) {
  var r, i, o;
  if (e = zi(e, 360), t = zi(t, 100), n = zi(n, 100), t === 0)
    i = n, o = n, r = n;
  else {
    var a = n < 0.5 ? n * (1 + t) : n + t - n * t, s = 2 * n - a;
    r = A5(s, a, e + 1 / 3), i = A5(s, a, e), o = A5(s, a, e - 1 / 3);
  }
  return { r: r * 255, g: i * 255, b: o * 255 };
}
function rS(e, t, n) {
  e = zi(e, 255), t = zi(t, 255), n = zi(n, 255);
  var r = Math.max(e, t, n), i = Math.min(e, t, n), o = 0, a = r, s = r - i, c = r === 0 ? 0 : s / r;
  if (r === i)
    o = 0;
  else {
    switch (r) {
      case e:
        o = (t - n) / s + (t < n ? 6 : 0);
        break;
      case t:
        o = (n - e) / s + 2;
        break;
      case n:
        o = (e - t) / s + 4;
        break;
    }
    o /= 6;
  }
  return { h: o, s: c, v: a };
}
function zY(e, t, n) {
  e = zi(e, 360) * 6, t = zi(t, 100), n = zi(n, 100);
  var r = Math.floor(e), i = e - r, o = n * (1 - t), a = n * (1 - i * t), s = n * (1 - (1 - i) * t), c = r % 6, l = [n, a, o, o, s, n][c], u = [s, n, n, a, o, o][c], d = [o, o, s, n, n, a][c];
  return { r: l * 255, g: u * 255, b: d * 255 };
}
function iS(e, t, n, r) {
  var i = [
    us(Math.round(e).toString(16)),
    us(Math.round(t).toString(16)),
    us(Math.round(n).toString(16))
  ];
  return r && i[0].startsWith(i[0].charAt(1)) && i[1].startsWith(i[1].charAt(1)) && i[2].startsWith(i[2].charAt(1)) ? i[0].charAt(0) + i[1].charAt(0) + i[2].charAt(0) : i.join("");
}
function HY(e, t, n, r, i) {
  var o = [
    us(Math.round(e).toString(16)),
    us(Math.round(t).toString(16)),
    us(Math.round(n).toString(16)),
    us(g6(r))
  ];
  return i && o[0].startsWith(o[0].charAt(1)) && o[1].startsWith(o[1].charAt(1)) && o[2].startsWith(o[2].charAt(1)) && o[3].startsWith(o[3].charAt(1)) ? o[0].charAt(0) + o[1].charAt(0) + o[2].charAt(0) + o[3].charAt(0) : o.join("");
}
function zA(e, t, n, r) {
  var i = [
    us(g6(r)),
    us(Math.round(e).toString(16)),
    us(Math.round(t).toString(16)),
    us(Math.round(n).toString(16))
  ];
  return i.join("");
}
function g6(e) {
  return Math.round(parseFloat(e) * 255).toString(16);
}
function HA(e) {
  return Ho(e) / 255;
}
function Ho(e) {
  return parseInt(e, 16);
}
function UY(e) {
  return {
    r: e >> 16,
    g: (e & 65280) >> 8,
    b: e & 255
  };
}
var oS = {
  aliceblue: "#f0f8ff",
  antiquewhite: "#faebd7",
  aqua: "#00ffff",
  aquamarine: "#7fffd4",
  azure: "#f0ffff",
  beige: "#f5f5dc",
  bisque: "#ffe4c4",
  black: "#000000",
  blanchedalmond: "#ffebcd",
  blue: "#0000ff",
  blueviolet: "#8a2be2",
  brown: "#a52a2a",
  burlywood: "#deb887",
  cadetblue: "#5f9ea0",
  chartreuse: "#7fff00",
  chocolate: "#d2691e",
  coral: "#ff7f50",
  cornflowerblue: "#6495ed",
  cornsilk: "#fff8dc",
  crimson: "#dc143c",
  cyan: "#00ffff",
  darkblue: "#00008b",
  darkcyan: "#008b8b",
  darkgoldenrod: "#b8860b",
  darkgray: "#a9a9a9",
  darkgreen: "#006400",
  darkgrey: "#a9a9a9",
  darkkhaki: "#bdb76b",
  darkmagenta: "#8b008b",
  darkolivegreen: "#556b2f",
  darkorange: "#ff8c00",
  darkorchid: "#9932cc",
  darkred: "#8b0000",
  darksalmon: "#e9967a",
  darkseagreen: "#8fbc8f",
  darkslateblue: "#483d8b",
  darkslategray: "#2f4f4f",
  darkslategrey: "#2f4f4f",
  darkturquoise: "#00ced1",
  darkviolet: "#9400d3",
  deeppink: "#ff1493",
  deepskyblue: "#00bfff",
  dimgray: "#696969",
  dimgrey: "#696969",
  dodgerblue: "#1e90ff",
  firebrick: "#b22222",
  floralwhite: "#fffaf0",
  forestgreen: "#228b22",
  fuchsia: "#ff00ff",
  gainsboro: "#dcdcdc",
  ghostwhite: "#f8f8ff",
  goldenrod: "#daa520",
  gold: "#ffd700",
  gray: "#808080",
  green: "#008000",
  greenyellow: "#adff2f",
  grey: "#808080",
  honeydew: "#f0fff0",
  hotpink: "#ff69b4",
  indianred: "#cd5c5c",
  indigo: "#4b0082",
  ivory: "#fffff0",
  khaki: "#f0e68c",
  lavenderblush: "#fff0f5",
  lavender: "#e6e6fa",
  lawngreen: "#7cfc00",
  lemonchiffon: "#fffacd",
  lightblue: "#add8e6",
  lightcoral: "#f08080",
  lightcyan: "#e0ffff",
  lightgoldenrodyellow: "#fafad2",
  lightgray: "#d3d3d3",
  lightgreen: "#90ee90",
  lightgrey: "#d3d3d3",
  lightpink: "#ffb6c1",
  lightsalmon: "#ffa07a",
  lightseagreen: "#20b2aa",
  lightskyblue: "#87cefa",
  lightslategray: "#778899",
  lightslategrey: "#778899",
  lightsteelblue: "#b0c4de",
  lightyellow: "#ffffe0",
  lime: "#00ff00",
  limegreen: "#32cd32",
  linen: "#faf0e6",
  magenta: "#ff00ff",
  maroon: "#800000",
  mediumaquamarine: "#66cdaa",
  mediumblue: "#0000cd",
  mediumorchid: "#ba55d3",
  mediumpurple: "#9370db",
  mediumseagreen: "#3cb371",
  mediumslateblue: "#7b68ee",
  mediumspringgreen: "#00fa9a",
  mediumturquoise: "#48d1cc",
  mediumvioletred: "#c71585",
  midnightblue: "#191970",
  mintcream: "#f5fffa",
  mistyrose: "#ffe4e1",
  moccasin: "#ffe4b5",
  navajowhite: "#ffdead",
  navy: "#000080",
  oldlace: "#fdf5e6",
  olive: "#808000",
  olivedrab: "#6b8e23",
  orange: "#ffa500",
  orangered: "#ff4500",
  orchid: "#da70d6",
  palegoldenrod: "#eee8aa",
  palegreen: "#98fb98",
  paleturquoise: "#afeeee",
  palevioletred: "#db7093",
  papayawhip: "#ffefd5",
  peachpuff: "#ffdab9",
  peru: "#cd853f",
  pink: "#ffc0cb",
  plum: "#dda0dd",
  powderblue: "#b0e0e6",
  purple: "#800080",
  rebeccapurple: "#663399",
  red: "#ff0000",
  rosybrown: "#bc8f8f",
  royalblue: "#4169e1",
  saddlebrown: "#8b4513",
  salmon: "#fa8072",
  sandybrown: "#f4a460",
  seagreen: "#2e8b57",
  seashell: "#fff5ee",
  sienna: "#a0522d",
  silver: "#c0c0c0",
  skyblue: "#87ceeb",
  slateblue: "#6a5acd",
  slategray: "#708090",
  slategrey: "#708090",
  snow: "#fffafa",
  springgreen: "#00ff7f",
  steelblue: "#4682b4",
  tan: "#d2b48c",
  teal: "#008080",
  thistle: "#d8bfd8",
  tomato: "#ff6347",
  turquoise: "#40e0d0",
  violet: "#ee82ee",
  wheat: "#f5deb3",
  white: "#ffffff",
  whitesmoke: "#f5f5f5",
  yellow: "#ffff00",
  yellowgreen: "#9acd32"
};
function vd(e) {
  var t = { r: 0, g: 0, b: 0 }, n = 1, r = null, i = null, o = null, a = !1, s = !1;
  return typeof e == "string" && (e = WY(e)), typeof e == "object" && (js(e.r) && js(e.g) && js(e.b) ? (t = VY(e.r, e.g, e.b), a = !0, s = String(e.r).substr(-1) === "%" ? "prgb" : "rgb") : js(e.h) && js(e.s) && js(e.v) ? (r = wd(e.s), i = wd(e.v), t = zY(e.h, r, i), a = !0, s = "hsv") : js(e.h) && js(e.s) && js(e.l) && (r = wd(e.s), o = wd(e.l), t = BY(e.h, r, o), a = !0, s = "hsl"), Object.prototype.hasOwnProperty.call(e, "a") && (n = e.a)), n = FY(n), {
    ok: a,
    format: e.format || s,
    r: Math.min(255, Math.max(t.r, 0)),
    g: Math.min(255, Math.max(t.g, 0)),
    b: Math.min(255, Math.max(t.b, 0)),
    a: n
  };
}
var fTe = "[-\\+]?\\d+%?", hTe = "[-\\+]?\\d*\\.\\d+%?", Xl = "(?:".concat(hTe, ")|(?:").concat(fTe, ")"), R5 = "[\\s|\\(]+(".concat(Xl, ")[,|\\s]+(").concat(Xl, ")[,|\\s]+(").concat(Xl, ")\\s*\\)?"), $5 = "[\\s|\\(]+(".concat(Xl, ")[,|\\s]+(").concat(Xl, ")[,|\\s]+(").concat(Xl, ")[,|\\s]+(").concat(Xl, ")\\s*\\)?"), ns = {
  CSS_UNIT: new RegExp(Xl),
  rgb: new RegExp("rgb" + R5),
  rgba: new RegExp("rgba" + $5),
  hsl: new RegExp("hsl" + R5),
  hsla: new RegExp("hsla" + $5),
  hsv: new RegExp("hsv" + R5),
  hsva: new RegExp("hsva" + $5),
  hex3: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
  hex6: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/,
  hex4: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
  hex8: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/
};
function WY(e) {
  if (e = e.trim().toLowerCase(), e.length === 0)
    return !1;
  var t = !1;
  if (oS[e])
    e = oS[e], t = !0;
  else if (e === "transparent")
    return { r: 0, g: 0, b: 0, a: 0, format: "name" };
  var n = ns.rgb.exec(e);
  return n ? { r: n[1], g: n[2], b: n[3] } : (n = ns.rgba.exec(e), n ? { r: n[1], g: n[2], b: n[3], a: n[4] } : (n = ns.hsl.exec(e), n ? { h: n[1], s: n[2], l: n[3] } : (n = ns.hsla.exec(e), n ? { h: n[1], s: n[2], l: n[3], a: n[4] } : (n = ns.hsv.exec(e), n ? { h: n[1], s: n[2], v: n[3] } : (n = ns.hsva.exec(e), n ? { h: n[1], s: n[2], v: n[3], a: n[4] } : (n = ns.hex8.exec(e), n ? {
    r: Ho(n[1]),
    g: Ho(n[2]),
    b: Ho(n[3]),
    a: HA(n[4]),
    format: t ? "name" : "hex8"
  } : (n = ns.hex6.exec(e), n ? {
    r: Ho(n[1]),
    g: Ho(n[2]),
    b: Ho(n[3]),
    format: t ? "name" : "hex"
  } : (n = ns.hex4.exec(e), n ? {
    r: Ho(n[1] + n[1]),
    g: Ho(n[2] + n[2]),
    b: Ho(n[3] + n[3]),
    a: HA(n[4] + n[4]),
    format: t ? "name" : "hex8"
  } : (n = ns.hex3.exec(e), n ? {
    r: Ho(n[1] + n[1]),
    g: Ho(n[2] + n[2]),
    b: Ho(n[3] + n[3]),
    format: t ? "name" : "hex"
  } : !1)))))))));
}
function js(e) {
  return !!ns.CSS_UNIT.exec(String(e));
}
var Pn = (
  /** @class */
  function() {
    function e(t, n) {
      t === void 0 && (t = ""), n === void 0 && (n = {});
      var r;
      if (t instanceof e)
        return t;
      typeof t == "number" && (t = UY(t)), this.originalInput = t;
      var i = vd(t);
      this.originalInput = t, this.r = i.r, this.g = i.g, this.b = i.b, this.a = i.a, this.roundA = Math.round(100 * this.a) / 100, this.format = (r = n.format) !== null && r !== void 0 ? r : i.format, this.gradientType = n.gradientType, this.r < 1 && (this.r = Math.round(this.r)), this.g < 1 && (this.g = Math.round(this.g)), this.b < 1 && (this.b = Math.round(this.b)), this.isValid = i.ok;
    }
    return e.prototype.isDark = function() {
      return this.getBrightness() < 128;
    }, e.prototype.isLight = function() {
      return !this.isDark();
    }, e.prototype.getBrightness = function() {
      var t = this.toRgb();
      return (t.r * 299 + t.g * 587 + t.b * 114) / 1e3;
    }, e.prototype.getLuminance = function() {
      var t = this.toRgb(), n, r, i, o = t.r / 255, a = t.g / 255, s = t.b / 255;
      return o <= 0.03928 ? n = o / 12.92 : n = Math.pow((o + 0.055) / 1.055, 2.4), a <= 0.03928 ? r = a / 12.92 : r = Math.pow((a + 0.055) / 1.055, 2.4), s <= 0.03928 ? i = s / 12.92 : i = Math.pow((s + 0.055) / 1.055, 2.4), 0.2126 * n + 0.7152 * r + 0.0722 * i;
    }, e.prototype.getAlpha = function() {
      return this.a;
    }, e.prototype.setAlpha = function(t) {
      return this.a = FY(t), this.roundA = Math.round(100 * this.a) / 100, this;
    }, e.prototype.isMonochrome = function() {
      var t = this.toHsl().s;
      return t === 0;
    }, e.prototype.toHsv = function() {
      var t = rS(this.r, this.g, this.b);
      return { h: t.h * 360, s: t.s, v: t.v, a: this.a };
    }, e.prototype.toHsvString = function() {
      var t = rS(this.r, this.g, this.b), n = Math.round(t.h * 360), r = Math.round(t.s * 100), i = Math.round(t.v * 100);
      return this.a === 1 ? "hsv(".concat(n, ", ").concat(r, "%, ").concat(i, "%)") : "hsva(".concat(n, ", ").concat(r, "%, ").concat(i, "%, ").concat(this.roundA, ")");
    }, e.prototype.toHsl = function() {
      var t = BA(this.r, this.g, this.b);
      return { h: t.h * 360, s: t.s, l: t.l, a: this.a };
    }, e.prototype.toHslString = function() {
      var t = BA(this.r, this.g, this.b), n = Math.round(t.h * 360), r = Math.round(t.s * 100), i = Math.round(t.l * 100);
      return this.a === 1 ? "hsl(".concat(n, ", ").concat(r, "%, ").concat(i, "%)") : "hsla(".concat(n, ", ").concat(r, "%, ").concat(i, "%, ").concat(this.roundA, ")");
    }, e.prototype.toHex = function(t) {
      return t === void 0 && (t = !1), iS(this.r, this.g, this.b, t);
    }, e.prototype.toHexString = function(t) {
      return t === void 0 && (t = !1), "#" + this.toHex(t);
    }, e.prototype.toHex8 = function(t) {
      return t === void 0 && (t = !1), HY(this.r, this.g, this.b, this.a, t);
    }, e.prototype.toHex8String = function(t) {
      return t === void 0 && (t = !1), "#" + this.toHex8(t);
    }, e.prototype.toHexShortString = function(t) {
      return t === void 0 && (t = !1), this.a === 1 ? this.toHexString(t) : this.toHex8String(t);
    }, e.prototype.toRgb = function() {
      return {
        r: Math.round(this.r),
        g: Math.round(this.g),
        b: Math.round(this.b),
        a: this.a
      };
    }, e.prototype.toRgbString = function() {
      var t = Math.round(this.r), n = Math.round(this.g), r = Math.round(this.b);
      return this.a === 1 ? "rgb(".concat(t, ", ").concat(n, ", ").concat(r, ")") : "rgba(".concat(t, ", ").concat(n, ", ").concat(r, ", ").concat(this.roundA, ")");
    }, e.prototype.toPercentageRgb = function() {
      var t = function(n) {
        return "".concat(Math.round(zi(n, 255) * 100), "%");
      };
      return {
        r: t(this.r),
        g: t(this.g),
        b: t(this.b),
        a: this.a
      };
    }, e.prototype.toPercentageRgbString = function() {
      var t = function(n) {
        return Math.round(zi(n, 255) * 100);
      };
      return this.a === 1 ? "rgb(".concat(t(this.r), "%, ").concat(t(this.g), "%, ").concat(t(this.b), "%)") : "rgba(".concat(t(this.r), "%, ").concat(t(this.g), "%, ").concat(t(this.b), "%, ").concat(this.roundA, ")");
    }, e.prototype.toName = function() {
      if (this.a === 0)
        return "transparent";
      if (this.a < 1)
        return !1;
      for (var t = "#" + iS(this.r, this.g, this.b, !1), n = 0, r = Object.entries(oS); n < r.length; n++) {
        var i = r[n], o = i[0], a = i[1];
        if (t === a)
          return o;
      }
      return !1;
    }, e.prototype.toString = function(t) {
      var n = !!t;
      t = t ?? this.format;
      var r = !1, i = this.a < 1 && this.a >= 0, o = !n && i && (t.startsWith("hex") || t === "name");
      return o ? t === "name" && this.a === 0 ? this.toName() : this.toRgbString() : (t === "rgb" && (r = this.toRgbString()), t === "prgb" && (r = this.toPercentageRgbString()), (t === "hex" || t === "hex6") && (r = this.toHexString()), t === "hex3" && (r = this.toHexString(!0)), t === "hex4" && (r = this.toHex8String(!0)), t === "hex8" && (r = this.toHex8String()), t === "name" && (r = this.toName()), t === "hsl" && (r = this.toHslString()), t === "hsv" && (r = this.toHsvString()), r || this.toHexString());
    }, e.prototype.toNumber = function() {
      return (Math.round(this.r) << 16) + (Math.round(this.g) << 8) + Math.round(this.b);
    }, e.prototype.clone = function() {
      return new e(this.toString());
    }, e.prototype.lighten = function(t) {
      t === void 0 && (t = 10);
      var n = this.toHsl();
      return n.l += t / 100, n.l = Lb(n.l), new e(n);
    }, e.prototype.brighten = function(t) {
      t === void 0 && (t = 10);
      var n = this.toRgb();
      return n.r = Math.max(0, Math.min(255, n.r - Math.round(255 * -(t / 100)))), n.g = Math.max(0, Math.min(255, n.g - Math.round(255 * -(t / 100)))), n.b = Math.max(0, Math.min(255, n.b - Math.round(255 * -(t / 100)))), new e(n);
    }, e.prototype.darken = function(t) {
      t === void 0 && (t = 10);
      var n = this.toHsl();
      return n.l -= t / 100, n.l = Lb(n.l), new e(n);
    }, e.prototype.tint = function(t) {
      return t === void 0 && (t = 10), this.mix("white", t);
    }, e.prototype.shade = function(t) {
      return t === void 0 && (t = 10), this.mix("black", t);
    }, e.prototype.desaturate = function(t) {
      t === void 0 && (t = 10);
      var n = this.toHsl();
      return n.s -= t / 100, n.s = Lb(n.s), new e(n);
    }, e.prototype.saturate = function(t) {
      t === void 0 && (t = 10);
      var n = this.toHsl();
      return n.s += t / 100, n.s = Lb(n.s), new e(n);
    }, e.prototype.greyscale = function() {
      return this.desaturate(100);
    }, e.prototype.spin = function(t) {
      var n = this.toHsl(), r = (n.h + t) % 360;
      return n.h = r < 0 ? 360 + r : r, new e(n);
    }, e.prototype.mix = function(t, n) {
      n === void 0 && (n = 50);
      var r = this.toRgb(), i = new e(t).toRgb(), o = n / 100, a = {
        r: (i.r - r.r) * o + r.r,
        g: (i.g - r.g) * o + r.g,
        b: (i.b - r.b) * o + r.b,
        a: (i.a - r.a) * o + r.a
      };
      return new e(a);
    }, e.prototype.analogous = function(t, n) {
      t === void 0 && (t = 6), n === void 0 && (n = 30);
      var r = this.toHsl(), i = 360 / n, o = [this];
      for (r.h = (r.h - (i * t >> 1) + 720) % 360; --t; )
        r.h = (r.h + i) % 360, o.push(new e(r));
      return o;
    }, e.prototype.complement = function() {
      var t = this.toHsl();
      return t.h = (t.h + 180) % 360, new e(t);
    }, e.prototype.monochromatic = function(t) {
      t === void 0 && (t = 6);
      for (var n = this.toHsv(), r = n.h, i = n.s, o = n.v, a = [], s = 1 / t; t--; )
        a.push(new e({ h: r, s: i, v: o })), o = (o + s) % 1;
      return a;
    }, e.prototype.splitcomplement = function() {
      var t = this.toHsl(), n = t.h;
      return [
        this,
        new e({ h: (n + 72) % 360, s: t.s, l: t.l }),
        new e({ h: (n + 216) % 360, s: t.s, l: t.l })
      ];
    }, e.prototype.onBackground = function(t) {
      var n = this.toRgb(), r = new e(t).toRgb(), i = n.a + r.a * (1 - n.a);
      return new e({
        r: (n.r * n.a + r.r * r.a * (1 - n.a)) / i,
        g: (n.g * n.a + r.g * r.a * (1 - n.a)) / i,
        b: (n.b * n.a + r.b * r.a * (1 - n.a)) / i,
        a: i
      });
    }, e.prototype.triad = function() {
      return this.polyad(3);
    }, e.prototype.tetrad = function() {
      return this.polyad(4);
    }, e.prototype.polyad = function(t) {
      for (var n = this.toHsl(), r = n.h, i = [this], o = 360 / t, a = 1; a < t; a++)
        i.push(new e({ h: (r + a * o) % 360, s: n.s, l: n.l }));
      return i;
    }, e.prototype.equals = function(t) {
      return this.toRgbString() === new e(t).toRgbString();
    }, e;
  }()
);
function N8(e, t) {
  return e === void 0 && (e = ""), t === void 0 && (t = {}), new Pn(e, t);
}
function p6(e, t) {
  var n = new Pn(e), r = new Pn(t);
  return (Math.max(n.getLuminance(), r.getLuminance()) + 0.05) / (Math.min(n.getLuminance(), r.getLuminance()) + 0.05);
}
function qY(e, t, n) {
  var r, i;
  n === void 0 && (n = { level: "AA", size: "small" });
  var o = p6(e, t);
  switch (((r = n.level) !== null && r !== void 0 ? r : "AA") + ((i = n.size) !== null && i !== void 0 ? i : "small")) {
    case "AAsmall":
    case "AAAlarge":
      return o >= 4.5;
    case "AAlarge":
      return o >= 3;
    case "AAAsmall":
      return o >= 7;
    default:
      return !1;
  }
}
function GY(e, t, n) {
  n === void 0 && (n = { includeFallbackColors: !1, level: "AA", size: "small" });
  for (var r = null, i = 0, o = n.includeFallbackColors, a = n.level, s = n.size, c = 0, l = t; c < l.length; c++) {
    var u = l[c], d = p6(e, u);
    d > i && (i = d, r = new Pn(u));
  }
  return qY(e, r, { level: a, size: s }) || !o ? r : (n.includeFallbackColors = !1, GY(e, ["#fff", "#000"], n));
}
function gTe(e, t) {
  var n = new Pn(e), r = "#" + zA(n.r, n.g, n.b, n.a), i = r, o = n.gradientType ? "GradientType = 1, " : "";
  if (t) {
    var a = new Pn(t);
    i = "#" + zA(a.r, a.g, a.b, a.a);
  }
  return "progid:DXImageTransform.Microsoft.gradient(".concat(o, "startColorstr=").concat(r, ",endColorstr=").concat(i, ")");
}
function pTe(e, t) {
  var n = {
    r: wd(e.r),
    g: wd(e.g),
    b: wd(e.b)
  };
  return e.a !== void 0 && (n.a = Number(e.a)), new Pn(n, t);
}
function mTe() {
  return new Pn({
    r: Math.random(),
    g: Math.random(),
    b: Math.random()
  });
}
function KY(e) {
  if (e === void 0 && (e = {}), e.count !== void 0 && e.count !== null) {
    var t = e.count, n = [];
    for (e.count = void 0; t > n.length; )
      e.count = null, e.seed && (e.seed += 1), n.push(KY(e));
    return e.count = t, n;
  }
  var r = vTe(e.hue, e.seed), i = yTe(r, e), o = bTe(r, i, e), a = { h: r, s: i, v: o };
  return e.alpha !== void 0 && (a.a = e.alpha), new Pn(a);
}
function vTe(e, t) {
  var n = STe(e), r = aS(n, t);
  return r < 0 && (r = 360 + r), r;
}
function yTe(e, t) {
  if (t.hue === "monochrome")
    return 0;
  if (t.luminosity === "random")
    return aS([0, 100], t.seed);
  var n = YY(e).saturationRange, r = n[0], i = n[1];
  switch (t.luminosity) {
    case "bright":
      r = 55;
      break;
    case "dark":
      r = i - 10;
      break;
    case "light":
      i = 55;
      break;
  }
  return aS([r, i], t.seed);
}
function bTe(e, t, n) {
  var r = _Te(e, t), i = 100;
  switch (n.luminosity) {
    case "dark":
      i = r + 20;
      break;
    case "light":
      r = (i + r) / 2;
      break;
    case "random":
      r = 0, i = 100;
      break;
  }
  return aS([r, i], n.seed);
}
function _Te(e, t) {
  for (var n = YY(e).lowerBounds, r = 0; r < n.length - 1; r++) {
    var i = n[r][0], o = n[r][1], a = n[r + 1][0], s = n[r + 1][1];
    if (t >= i && t <= a) {
      var c = (s - o) / (a - i), l = o - c * i;
      return c * t + l;
    }
  }
  return 0;
}
function STe(e) {
  var t = parseInt(e, 10);
  if (!Number.isNaN(t) && t < 360 && t > 0)
    return [t, t];
  if (typeof e == "string") {
    var n = m6.find(function(a) {
      return a.name === e;
    });
    if (n) {
      var r = XY(n);
      if (r.hueRange)
        return r.hueRange;
    }
    var i = new Pn(e);
    if (i.isValid) {
      var o = i.toHsv().h;
      return [o, o];
    }
  }
  return [0, 360];
}
function YY(e) {
  e >= 334 && e <= 360 && (e -= 360);
  for (var t = 0, n = m6; t < n.length; t++) {
    var r = n[t], i = XY(r);
    if (i.hueRange && e >= i.hueRange[0] && e <= i.hueRange[1])
      return i;
  }
  throw Error("Color not found");
}
function aS(e, t) {
  if (t === void 0)
    return Math.floor(e[0] + Math.random() * (e[1] + 1 - e[0]));
  var n = e[1] || 1, r = e[0] || 0;
  t = (t * 9301 + 49297) % 233280;
  var i = t / 233280;
  return Math.floor(r + i * (n - r));
}
function XY(e) {
  var t = e.lowerBounds[0][0], n = e.lowerBounds[e.lowerBounds.length - 1][0], r = e.lowerBounds[e.lowerBounds.length - 1][1], i = e.lowerBounds[0][1];
  return {
    name: e.name,
    hueRange: e.hueRange,
    lowerBounds: e.lowerBounds,
    saturationRange: [t, n],
    brightnessRange: [r, i]
  };
}
var m6 = [
  {
    name: "monochrome",
    hueRange: null,
    lowerBounds: [
      [0, 0],
      [100, 0]
    ]
  },
  {
    name: "red",
    hueRange: [-26, 18],
    lowerBounds: [
      [20, 100],
      [30, 92],
      [40, 89],
      [50, 85],
      [60, 78],
      [70, 70],
      [80, 60],
      [90, 55],
      [100, 50]
    ]
  },
  {
    name: "orange",
    hueRange: [19, 46],
    lowerBounds: [
      [20, 100],
      [30, 93],
      [40, 88],
      [50, 86],
      [60, 85],
      [70, 70],
      [100, 70]
    ]
  },
  {
    name: "yellow",
    hueRange: [47, 62],
    lowerBounds: [
      [25, 100],
      [40, 94],
      [50, 89],
      [60, 86],
      [70, 84],
      [80, 82],
      [90, 80],
      [100, 75]
    ]
  },
  {
    name: "green",
    hueRange: [63, 178],
    lowerBounds: [
      [30, 100],
      [40, 90],
      [50, 85],
      [60, 81],
      [70, 74],
      [80, 64],
      [90, 50],
      [100, 40]
    ]
  },
  {
    name: "blue",
    hueRange: [179, 257],
    lowerBounds: [
      [20, 100],
      [30, 86],
      [40, 80],
      [50, 74],
      [60, 60],
      [70, 52],
      [80, 44],
      [90, 39],
      [100, 35]
    ]
  },
  {
    name: "purple",
    hueRange: [258, 282],
    lowerBounds: [
      [20, 100],
      [30, 87],
      [40, 79],
      [50, 70],
      [60, 65],
      [70, 59],
      [80, 52],
      [90, 45],
      [100, 42]
    ]
  },
  {
    name: "pink",
    hueRange: [283, 334],
    lowerBounds: [
      [20, 100],
      [30, 90],
      [40, 86],
      [60, 84],
      [80, 80],
      [90, 75],
      [100, 73]
    ]
  }
];
const wTe = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  TinyColor: Pn,
  bounds: m6,
  convertDecimalToHex: g6,
  convertHexToDecimal: HA,
  default: N8,
  fromRatio: pTe,
  hslToRgb: BY,
  hsvToRgb: zY,
  inputToRGB: vd,
  isReadable: qY,
  isValidCSSUnit: js,
  legacyRandom: mTe,
  mostReadable: GY,
  names: oS,
  numberInputToObject: UY,
  parseIntFromHex: Ho,
  random: KY,
  readability: p6,
  rgbToHex: iS,
  rgbToHsl: BA,
  rgbToHsv: rS,
  rgbToRgb: VY,
  rgbaToArgbHex: zA,
  rgbaToHex: HY,
  stringInputToObject: WY,
  tinycolor: N8,
  toMsFilter: gTe
}, Symbol.toStringTag, { value: "Module" }));
var jb = 2, D8 = 0.16, xTe = 0.05, ETe = 0.05, CTe = 0.15, QY = 5, JY = 4, TTe = [{
  index: 7,
  opacity: 0.15
}, {
  index: 6,
  opacity: 0.25
}, {
  index: 5,
  opacity: 0.3
}, {
  index: 5,
  opacity: 0.45
}, {
  index: 5,
  opacity: 0.65
}, {
  index: 5,
  opacity: 0.85
}, {
  index: 4,
  opacity: 0.9
}, {
  index: 3,
  opacity: 0.95
}, {
  index: 2,
  opacity: 0.97
}, {
  index: 1,
  opacity: 0.98
}];
function L8(e) {
  var t = e.r, n = e.g, r = e.b, i = rS(t, n, r);
  return {
    h: i.h * 360,
    s: i.s,
    v: i.v
  };
}
function Fb(e) {
  var t = e.r, n = e.g, r = e.b;
  return "#".concat(iS(t, n, r, !1));
}
function ITe(e, t, n) {
  var r = n / 100, i = {
    r: (t.r - e.r) * r + e.r,
    g: (t.g - e.g) * r + e.g,
    b: (t.b - e.b) * r + e.b
  };
  return i;
}
function j8(e, t, n) {
  var r;
  return Math.round(e.h) >= 60 && Math.round(e.h) <= 240 ? r = n ? Math.round(e.h) - jb * t : Math.round(e.h) + jb * t : r = n ? Math.round(e.h) + jb * t : Math.round(e.h) - jb * t, r < 0 ? r += 360 : r >= 360 && (r -= 360), r;
}
function F8(e, t, n) {
  if (e.h === 0 && e.s === 0)
    return e.s;
  var r;
  return n ? r = e.s - D8 * t : t === JY ? r = e.s + D8 : r = e.s + xTe * t, r > 1 && (r = 1), n && t === QY && r > 0.1 && (r = 0.1), r < 0.06 && (r = 0.06), Number(r.toFixed(2));
}
function V8(e, t, n) {
  var r;
  return n ? r = e.v + ETe * t : r = e.v - CTe * t, r > 1 && (r = 1), Number(r.toFixed(2));
}
function kg(e) {
  for (var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, n = [], r = vd(e), i = QY; i > 0; i -= 1) {
    var o = L8(r), a = Fb(vd({
      h: j8(o, i, !0),
      s: F8(o, i, !0),
      v: V8(o, i, !0)
    }));
    n.push(a);
  }
  n.push(Fb(r));
  for (var s = 1; s <= JY; s += 1) {
    var c = L8(r), l = Fb(vd({
      h: j8(c, s),
      s: F8(c, s),
      v: V8(c, s)
    }));
    n.push(l);
  }
  return t.theme === "dark" ? TTe.map(function(u) {
    var d = u.index, f = u.opacity, h = Fb(ITe(vd(t.backgroundColor || "#141414"), vd(n[d]), f * 100));
    return h;
  }) : n;
}
var H1 = {
  red: "#F5222D",
  volcano: "#FA541C",
  orange: "#FA8C16",
  gold: "#FAAD14",
  yellow: "#FADB14",
  lime: "#A0D911",
  green: "#52C41A",
  cyan: "#13C2C2",
  blue: "#1677FF",
  geekblue: "#2F54EB",
  purple: "#722ED1",
  magenta: "#EB2F96",
  grey: "#666666"
}, sS = ["#fff1f0", "#ffccc7", "#ffa39e", "#ff7875", "#ff4d4f", "#f5222d", "#cf1322", "#a8071a", "#820014", "#5c0011"];
sS.primary = sS[5];
var cS = ["#fff2e8", "#ffd8bf", "#ffbb96", "#ff9c6e", "#ff7a45", "#fa541c", "#d4380d", "#ad2102", "#871400", "#610b00"];
cS.primary = cS[5];
var lS = ["#fff7e6", "#ffe7ba", "#ffd591", "#ffc069", "#ffa940", "#fa8c16", "#d46b08", "#ad4e00", "#873800", "#612500"];
lS.primary = lS[5];
var uS = ["#fffbe6", "#fff1b8", "#ffe58f", "#ffd666", "#ffc53d", "#faad14", "#d48806", "#ad6800", "#874d00", "#613400"];
uS.primary = uS[5];
var dS = ["#feffe6", "#ffffb8", "#fffb8f", "#fff566", "#ffec3d", "#fadb14", "#d4b106", "#ad8b00", "#876800", "#614700"];
dS.primary = dS[5];
var fS = ["#fcffe6", "#f4ffb8", "#eaff8f", "#d3f261", "#bae637", "#a0d911", "#7cb305", "#5b8c00", "#3f6600", "#254000"];
fS.primary = fS[5];
var hS = ["#f6ffed", "#d9f7be", "#b7eb8f", "#95de64", "#73d13d", "#52c41a", "#389e0d", "#237804", "#135200", "#092b00"];
hS.primary = hS[5];
var gS = ["#e6fffb", "#b5f5ec", "#87e8de", "#5cdbd3", "#36cfc9", "#13c2c2", "#08979c", "#006d75", "#00474f", "#002329"];
gS.primary = gS[5];
var rv = ["#e6f4ff", "#bae0ff", "#91caff", "#69b1ff", "#4096ff", "#1677ff", "#0958d9", "#003eb3", "#002c8c", "#001d66"];
rv.primary = rv[5];
var pS = ["#f0f5ff", "#d6e4ff", "#adc6ff", "#85a5ff", "#597ef7", "#2f54eb", "#1d39c4", "#10239e", "#061178", "#030852"];
pS.primary = pS[5];
var mS = ["#f9f0ff", "#efdbff", "#d3adf7", "#b37feb", "#9254de", "#722ed1", "#531dab", "#391085", "#22075e", "#120338"];
mS.primary = mS[5];
var vS = ["#fff0f6", "#ffd6e7", "#ffadd2", "#ff85c0", "#f759ab", "#eb2f96", "#c41d7f", "#9e1068", "#780650", "#520339"];
vS.primary = vS[5];
var iv = ["#a6a6a6", "#999999", "#8c8c8c", "#808080", "#737373", "#666666", "#404040", "#1a1a1a", "#000000", "#000000"];
iv.primary = iv[5];
var ATe = iv, U1 = {
  red: sS,
  volcano: cS,
  orange: lS,
  gold: uS,
  yellow: dS,
  lime: fS,
  green: hS,
  cyan: gS,
  blue: rv,
  geekblue: pS,
  purple: mS,
  magenta: vS,
  grey: iv
}, yS = ["#2a1215", "#431418", "#58181c", "#791a1f", "#a61d24", "#d32029", "#e84749", "#f37370", "#f89f9a", "#fac8c3"];
yS.primary = yS[5];
var bS = ["#2b1611", "#441d12", "#592716", "#7c3118", "#aa3e19", "#d84a1b", "#e87040", "#f3956a", "#f8b692", "#fad4bc"];
bS.primary = bS[5];
var _S = ["#2b1d11", "#442a11", "#593815", "#7c4a15", "#aa6215", "#d87a16", "#e89a3c", "#f3b765", "#f8cf8d", "#fae3b7"];
_S.primary = _S[5];
var SS = ["#2b2111", "#443111", "#594214", "#7c5914", "#aa7714", "#d89614", "#e8b339", "#f3cc62", "#f8df8b", "#faedb5"];
SS.primary = SS[5];
var wS = ["#2b2611", "#443b11", "#595014", "#7c6e14", "#aa9514", "#d8bd14", "#e8d639", "#f3ea62", "#f8f48b", "#fafab5"];
wS.primary = wS[5];
var xS = ["#1f2611", "#2e3c10", "#3e4f13", "#536d13", "#6f9412", "#8bbb11", "#a9d134", "#c9e75d", "#e4f88b", "#f0fab5"];
xS.primary = xS[5];
var ES = ["#162312", "#1d3712", "#274916", "#306317", "#3c8618", "#49aa19", "#6abe39", "#8fd460", "#b2e58b", "#d5f2bb"];
ES.primary = ES[5];
var CS = ["#112123", "#113536", "#144848", "#146262", "#138585", "#13a8a8", "#33bcb7", "#58d1c9", "#84e2d8", "#b2f1e8"];
CS.primary = CS[5];
var TS = ["#111a2c", "#112545", "#15325b", "#15417e", "#1554ad", "#1668dc", "#3c89e8", "#65a9f3", "#8dc5f8", "#b7dcfa"];
TS.primary = TS[5];
var IS = ["#131629", "#161d40", "#1c2755", "#203175", "#263ea0", "#2b4acb", "#5273e0", "#7f9ef3", "#a8c1f8", "#d2e0fa"];
IS.primary = IS[5];
var AS = ["#1a1325", "#24163a", "#301c4d", "#3e2069", "#51258f", "#642ab5", "#854eca", "#ab7ae0", "#cda8f0", "#ebd7fa"];
AS.primary = AS[5];
var RS = ["#291321", "#40162f", "#551c3b", "#75204f", "#a02669", "#cb2b83", "#e0529c", "#f37fb7", "#f8a8cc", "#fad2e3"];
RS.primary = RS[5];
var $S = ["#151515", "#1f1f1f", "#2d2d2d", "#393939", "#494949", "#5a5a5a", "#6a6a6a", "#7b7b7b", "#888888", "#969696"];
$S.primary = $S[5];
var RTe = {
  red: yS,
  volcano: bS,
  orange: _S,
  gold: SS,
  yellow: wS,
  lime: xS,
  green: ES,
  cyan: CS,
  blue: TS,
  geekblue: IS,
  purple: AS,
  magenta: RS,
  grey: $S
};
const $Te = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  blue: rv,
  blueDark: TS,
  cyan: gS,
  cyanDark: CS,
  geekblue: pS,
  geekblueDark: IS,
  generate: kg,
  gold: uS,
  goldDark: SS,
  gray: ATe,
  green: hS,
  greenDark: ES,
  grey: iv,
  greyDark: $S,
  lime: fS,
  limeDark: xS,
  magenta: vS,
  magentaDark: RS,
  orange: lS,
  orangeDark: _S,
  presetDarkPalettes: RTe,
  presetPalettes: U1,
  presetPrimaryColors: H1,
  purple: mS,
  purpleDark: AS,
  red: sS,
  redDark: yS,
  volcano: cS,
  volcanoDark: bS,
  yellow: dS,
  yellowDark: wS
}, Symbol.toStringTag, { value: "Module" })), ZY = {
  blue: "#1677FF",
  purple: "#722ED1",
  cyan: "#13C2C2",
  green: "#52C41A",
  magenta: "#EB2F96",
  /**
   * @deprecated Use magenta instead
   */
  pink: "#EB2F96",
  red: "#F5222D",
  orange: "#FA8C16",
  yellow: "#FADB14",
  volcano: "#FA541C",
  geekblue: "#2F54EB",
  gold: "#FAAD14",
  lime: "#A0D911"
}, OTe = Object.assign(Object.assign({}, ZY), {
  // Color
  colorPrimary: "#1677ff",
  colorSuccess: "#52c41a",
  colorWarning: "#faad14",
  colorError: "#ff4d4f",
  colorInfo: "#1677ff",
  colorLink: "",
  colorTextBase: "",
  colorBgBase: "",
  // Font
  fontFamily: `-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial,
'Noto Sans', sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol',
'Noto Color Emoji'`,
  fontFamilyCode: "'SFMono-Regular', Consolas, 'Liberation Mono', Menlo, Courier, monospace",
  fontSize: 14,
  // Line
  lineWidth: 1,
  lineType: "solid",
  // Motion
  motionUnit: 0.1,
  motionBase: 0,
  motionEaseOutCirc: "cubic-bezier(0.08, 0.82, 0.17, 1)",
  motionEaseInOutCirc: "cubic-bezier(0.78, 0.14, 0.15, 0.86)",
  motionEaseOut: "cubic-bezier(0.215, 0.61, 0.355, 1)",
  motionEaseInOut: "cubic-bezier(0.645, 0.045, 0.355, 1)",
  motionEaseOutBack: "cubic-bezier(0.12, 0.4, 0.29, 1.46)",
  motionEaseInBack: "cubic-bezier(0.71, -0.46, 0.88, 0.6)",
  motionEaseInQuint: "cubic-bezier(0.755, 0.05, 0.855, 0.06)",
  motionEaseOutQuint: "cubic-bezier(0.23, 1, 0.32, 1)",
  // Radius
  borderRadius: 6,
  // Size
  sizeUnit: 4,
  sizeStep: 4,
  sizePopupArrow: 16,
  // Control Base
  controlHeight: 32,
  // zIndex
  zIndexBase: 0,
  zIndexPopupBase: 1e3,
  // Image
  opacityImage: 1,
  // Wireframe
  wireframe: !1,
  // Motion
  motion: !0
}), ov = OTe;
function PTe(e, t) {
  let {
    generateColorPalettes: n,
    generateNeutralColorPalettes: r
  } = t;
  const {
    colorSuccess: i,
    colorWarning: o,
    colorError: a,
    colorInfo: s,
    colorPrimary: c,
    colorBgBase: l,
    colorTextBase: u
  } = e, d = n(c), f = n(i), h = n(o), p = n(a), g = n(s), m = r(l, u), v = e.colorLink || e.colorInfo, y = n(v), S = new Pn(p[1]).mix(new Pn(p[3]), 50).toHexString();
  return Object.assign(Object.assign({}, m), {
    colorPrimaryBg: d[1],
    colorPrimaryBgHover: d[2],
    colorPrimaryBorder: d[3],
    colorPrimaryBorderHover: d[4],
    colorPrimaryHover: d[5],
    colorPrimary: d[6],
    colorPrimaryActive: d[7],
    colorPrimaryTextHover: d[8],
    colorPrimaryText: d[9],
    colorPrimaryTextActive: d[10],
    colorSuccessBg: f[1],
    colorSuccessBgHover: f[2],
    colorSuccessBorder: f[3],
    colorSuccessBorderHover: f[4],
    colorSuccessHover: f[4],
    colorSuccess: f[6],
    colorSuccessActive: f[7],
    colorSuccessTextHover: f[8],
    colorSuccessText: f[9],
    colorSuccessTextActive: f[10],
    colorErrorBg: p[1],
    colorErrorBgHover: p[2],
    colorErrorBgFilledHover: S,
    colorErrorBgActive: p[3],
    colorErrorBorder: p[3],
    colorErrorBorderHover: p[4],
    colorErrorHover: p[5],
    colorError: p[6],
    colorErrorActive: p[7],
    colorErrorTextHover: p[8],
    colorErrorText: p[9],
    colorErrorTextActive: p[10],
    colorWarningBg: h[1],
    colorWarningBgHover: h[2],
    colorWarningBorder: h[3],
    colorWarningBorderHover: h[4],
    colorWarningHover: h[4],
    colorWarning: h[6],
    colorWarningActive: h[7],
    colorWarningTextHover: h[8],
    colorWarningText: h[9],
    colorWarningTextActive: h[10],
    colorInfoBg: g[1],
    colorInfoBgHover: g[2],
    colorInfoBorder: g[3],
    colorInfoBorderHover: g[4],
    colorInfoHover: g[4],
    colorInfo: g[6],
    colorInfoActive: g[7],
    colorInfoTextHover: g[8],
    colorInfoText: g[9],
    colorInfoTextActive: g[10],
    colorLinkHover: y[4],
    colorLink: y[6],
    colorLinkActive: y[7],
    colorBgMask: new Pn("#000").setAlpha(0.45).toRgbString(),
    colorWhite: "#fff"
  });
}
const MTe = (e) => {
  let t = e, n = e, r = e, i = e;
  return e < 6 && e >= 5 ? t = e + 1 : e < 16 && e >= 6 ? t = e + 2 : e >= 16 && (t = 16), e < 7 && e >= 5 ? n = 4 : e < 8 && e >= 7 ? n = 5 : e < 14 && e >= 8 ? n = 6 : e < 16 && e >= 14 ? n = 7 : e >= 16 && (n = 8), e < 6 && e >= 2 ? r = 1 : e >= 6 && (r = 2), e > 4 && e < 8 ? i = 4 : e >= 8 && (i = 6), {
    borderRadius: e,
    borderRadiusXS: r,
    borderRadiusSM: n,
    borderRadiusLG: t,
    borderRadiusOuter: i
  };
}, kTe = MTe;
function NTe(e) {
  const {
    motionUnit: t,
    motionBase: n,
    borderRadius: r,
    lineWidth: i
  } = e;
  return Object.assign({
    // motion
    motionDurationFast: `${(n + t).toFixed(1)}s`,
    motionDurationMid: `${(n + t * 2).toFixed(1)}s`,
    motionDurationSlow: `${(n + t * 3).toFixed(1)}s`,
    // line
    lineWidthBold: i + 1
  }, kTe(r));
}
const DTe = (e) => {
  const {
    controlHeight: t
  } = e;
  return {
    controlHeightSM: t * 0.75,
    controlHeightXS: t * 0.5,
    controlHeightLG: t * 1.25
  };
}, LTe = DTe;
function W1(e) {
  return (e + 8) / e;
}
function jTe(e) {
  const t = new Array(10).fill(null).map((n, r) => {
    const i = r - 1, o = e * Math.pow(Math.E, i / 5), a = r > 1 ? Math.floor(o) : Math.ceil(o);
    return Math.floor(a / 2) * 2;
  });
  return t[1] = e, t.map((n) => ({
    size: n,
    lineHeight: W1(n)
  }));
}
const FTe = (e) => {
  const t = jTe(e), n = t.map((u) => u.size), r = t.map((u) => u.lineHeight), i = n[1], o = n[0], a = n[2], s = r[1], c = r[0], l = r[2];
  return {
    fontSizeSM: o,
    fontSize: i,
    fontSizeLG: a,
    fontSizeXL: n[3],
    fontSizeHeading1: n[6],
    fontSizeHeading2: n[5],
    fontSizeHeading3: n[4],
    fontSizeHeading4: n[3],
    fontSizeHeading5: n[2],
    lineHeight: s,
    lineHeightLG: l,
    lineHeightSM: c,
    fontHeight: Math.round(s * i),
    fontHeightLG: Math.round(l * a),
    fontHeightSM: Math.round(c * o),
    lineHeightHeading1: r[6],
    lineHeightHeading2: r[5],
    lineHeightHeading3: r[4],
    lineHeightHeading4: r[3],
    lineHeightHeading5: r[2]
  };
}, VTe = FTe;
function BTe(e) {
  const {
    sizeUnit: t,
    sizeStep: n
  } = e;
  return {
    sizeXXL: t * (n + 8),
    // 48
    sizeXL: t * (n + 4),
    // 32
    sizeLG: t * (n + 2),
    // 24
    sizeMD: t * (n + 1),
    // 20
    sizeMS: t * n,
    // 16
    size: t * n,
    // 16
    sizeSM: t * (n - 1),
    // 12
    sizeXS: t * (n - 2),
    // 8
    sizeXXS: t * (n - 3)
    // 4
  };
}
const Ta = (e, t) => new Pn(e).setAlpha(t).toRgbString(), um = (e, t) => new Pn(e).darken(t).toHexString(), zTe = (e) => {
  const t = kg(e);
  return {
    1: t[0],
    2: t[1],
    3: t[2],
    4: t[3],
    5: t[4],
    6: t[5],
    7: t[6],
    8: t[4],
    9: t[5],
    10: t[6]
    // 8: colors[7],
    // 9: colors[8],
    // 10: colors[9],
  };
}, HTe = (e, t) => {
  const n = e || "#fff", r = t || "#000";
  return {
    colorBgBase: n,
    colorTextBase: r,
    colorText: Ta(r, 0.88),
    colorTextSecondary: Ta(r, 0.65),
    colorTextTertiary: Ta(r, 0.45),
    colorTextQuaternary: Ta(r, 0.25),
    colorFill: Ta(r, 0.15),
    colorFillSecondary: Ta(r, 0.06),
    colorFillTertiary: Ta(r, 0.04),
    colorFillQuaternary: Ta(r, 0.02),
    colorBgSolid: Ta(r, 1),
    colorBgSolidHover: Ta(r, 0.75),
    colorBgSolidActive: Ta(r, 0.95),
    colorBgLayout: um(n, 4),
    colorBgContainer: um(n, 0),
    colorBgElevated: um(n, 0),
    colorBgSpotlight: Ta(r, 0.85),
    colorBgBlur: "transparent",
    colorBorder: um(n, 15),
    colorBorderSecondary: um(n, 6)
  };
};
function UTe(e) {
  H1.pink = H1.magenta, U1.pink = U1.magenta;
  const t = Object.keys(ZY).map((n) => {
    const r = e[n] === H1[n] ? U1[n] : kg(e[n]);
    return new Array(10).fill(1).reduce((i, o, a) => (i[`${n}-${a + 1}`] = r[a], i[`${n}${a + 1}`] = r[a], i), {});
  }).reduce((n, r) => (n = Object.assign(Object.assign({}, n), r), n), {});
  return Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, e), t), PTe(e, {
    generateColorPalettes: zTe,
    generateNeutralColorPalettes: HTe
  })), VTe(e.fontSize)), BTe(e)), LTe(e)), NTe(e));
}
const eX = tS(UTe), UA = {
  token: ov,
  override: {
    override: ov
  },
  hashed: !0
}, tX = /* @__PURE__ */ D.createContext(UA), OS = "ant", v6 = "anticon", WTe = ["outlined", "borderless", "filled"], qTe = (e, t) => t || (e ? `${OS}-${e}` : OS), En = /* @__PURE__ */ I.createContext({
  // We provide a default function for Context without provider
  getPrefixCls: qTe,
  iconPrefixCls: v6
}), GTe = `-ant-${Date.now()}-${Math.random()}`;
function KTe(e, t) {
  const n = {}, r = (a, s) => {
    let c = a.clone();
    return c = (s == null ? void 0 : s(c)) || c, c.toRgbString();
  }, i = (a, s) => {
    const c = new Pn(a), l = kg(c.toRgbString());
    n[`${s}-color`] = r(c), n[`${s}-color-disabled`] = l[1], n[`${s}-color-hover`] = l[4], n[`${s}-color-active`] = l[6], n[`${s}-color-outline`] = c.clone().setAlpha(0.2).toRgbString(), n[`${s}-color-deprecated-bg`] = l[0], n[`${s}-color-deprecated-border`] = l[2];
  };
  if (t.primaryColor) {
    i(t.primaryColor, "primary");
    const a = new Pn(t.primaryColor), s = kg(a.toRgbString());
    s.forEach((l, u) => {
      n[`primary-${u + 1}`] = l;
    }), n["primary-color-deprecated-l-35"] = r(a, (l) => l.lighten(35)), n["primary-color-deprecated-l-20"] = r(a, (l) => l.lighten(20)), n["primary-color-deprecated-t-20"] = r(a, (l) => l.tint(20)), n["primary-color-deprecated-t-50"] = r(a, (l) => l.tint(50)), n["primary-color-deprecated-f-12"] = r(a, (l) => l.setAlpha(l.getAlpha() * 0.12));
    const c = new Pn(s[0]);
    n["primary-color-active-deprecated-f-30"] = r(c, (l) => l.setAlpha(l.getAlpha() * 0.3)), n["primary-color-active-deprecated-d-02"] = r(c, (l) => l.darken(2));
  }
  return t.successColor && i(t.successColor, "success"), t.warningColor && i(t.warningColor, "warning"), t.errorColor && i(t.errorColor, "error"), t.infoColor && i(t.infoColor, "info"), `
  :root {
    ${Object.keys(n).map((a) => `--${e}-${a}: ${n[a]};`).join(`
`)}
  }
  `.trim();
}
function YTe(e, t) {
  const n = KTe(e, t);
  ao() ? cc(n, `${GTe}-dynamic-theme`) : process.env.NODE_ENV !== "production" && Gx(!1, "ConfigProvider", "SSR do not support dynamic theme with css variables.");
}
const WA = /* @__PURE__ */ I.createContext(!1), XTe = (e) => {
  let {
    children: t,
    disabled: n
  } = e;
  const r = I.useContext(WA);
  return /* @__PURE__ */ I.createElement(WA.Provider, {
    value: n ?? r
  }, t);
}, Uu = WA, qA = /* @__PURE__ */ I.createContext(void 0), QTe = (e) => {
  let {
    children: t,
    size: n
  } = e;
  const r = I.useContext(qA);
  return /* @__PURE__ */ I.createElement(qA.Provider, {
    value: n || r
  }, t);
}, Kx = qA;
function JTe() {
  const e = St(Uu), t = St(Kx);
  return {
    componentDisabled: e,
    componentSize: t
  };
}
var nX = /* @__PURE__ */ wr(function e() {
  Sr(this, e);
}), rX = "CALC_UNIT", ZTe = new RegExp(rX, "g");
function O5(e) {
  return typeof e == "number" ? "".concat(e).concat(rX) : e;
}
var eIe = /* @__PURE__ */ function(e) {
  Rs(n, e);
  var t = _c(n);
  function n(r, i) {
    var o;
    Sr(this, n), o = t.call(this), re(nn(o), "result", ""), re(nn(o), "unitlessCssVar", void 0), re(nn(o), "lowPriority", void 0);
    var a = _t(r);
    return o.unitlessCssVar = i, r instanceof n ? o.result = "(".concat(r.result, ")") : a === "number" ? o.result = O5(r) : a === "string" && (o.result = r), o;
  }
  return wr(n, [{
    key: "add",
    value: function(i) {
      return i instanceof n ? this.result = "".concat(this.result, " + ").concat(i.getResult()) : (typeof i == "number" || typeof i == "string") && (this.result = "".concat(this.result, " + ").concat(O5(i))), this.lowPriority = !0, this;
    }
  }, {
    key: "sub",
    value: function(i) {
      return i instanceof n ? this.result = "".concat(this.result, " - ").concat(i.getResult()) : (typeof i == "number" || typeof i == "string") && (this.result = "".concat(this.result, " - ").concat(O5(i))), this.lowPriority = !0, this;
    }
  }, {
    key: "mul",
    value: function(i) {
      return this.lowPriority && (this.result = "(".concat(this.result, ")")), i instanceof n ? this.result = "".concat(this.result, " * ").concat(i.getResult(!0)) : (typeof i == "number" || typeof i == "string") && (this.result = "".concat(this.result, " * ").concat(i)), this.lowPriority = !1, this;
    }
  }, {
    key: "div",
    value: function(i) {
      return this.lowPriority && (this.result = "(".concat(this.result, ")")), i instanceof n ? this.result = "".concat(this.result, " / ").concat(i.getResult(!0)) : (typeof i == "number" || typeof i == "string") && (this.result = "".concat(this.result, " / ").concat(i)), this.lowPriority = !1, this;
    }
  }, {
    key: "getResult",
    value: function(i) {
      return this.lowPriority || i ? "(".concat(this.result, ")") : this.result;
    }
  }, {
    key: "equal",
    value: function(i) {
      var o = this, a = i || {}, s = a.unit, c = !0;
      return typeof s == "boolean" ? c = s : Array.from(this.unitlessCssVar).some(function(l) {
        return o.result.includes(l);
      }) && (c = !1), this.result = this.result.replace(ZTe, c ? "px" : ""), typeof this.lowPriority < "u" ? "calc(".concat(this.result, ")") : this.result;
    }
  }]), n;
}(nX), tIe = /* @__PURE__ */ function(e) {
  Rs(n, e);
  var t = _c(n);
  function n(r) {
    var i;
    return Sr(this, n), i = t.call(this), re(nn(i), "result", 0), r instanceof n ? i.result = r.result : typeof r == "number" && (i.result = r), i;
  }
  return wr(n, [{
    key: "add",
    value: function(i) {
      return i instanceof n ? this.result += i.result : typeof i == "number" && (this.result += i), this;
    }
  }, {
    key: "sub",
    value: function(i) {
      return i instanceof n ? this.result -= i.result : typeof i == "number" && (this.result -= i), this;
    }
  }, {
    key: "mul",
    value: function(i) {
      return i instanceof n ? this.result *= i.result : typeof i == "number" && (this.result *= i), this;
    }
  }, {
    key: "div",
    value: function(i) {
      return i instanceof n ? this.result /= i.result : typeof i == "number" && (this.result /= i), this;
    }
  }, {
    key: "equal",
    value: function() {
      return this.result;
    }
  }]), n;
}(nX), iX = function(t, n) {
  var r = t === "css" ? eIe : tIe;
  return function(i) {
    return new r(i, n);
  };
}, B8 = function(t, n) {
  return "".concat([n, t.replace(/([A-Z]+)([A-Z][a-z]+)/g, "$1-$2").replace(/([a-z])([A-Z])/g, "$1-$2")].filter(Boolean).join("-"));
};
function Rr(e) {
  var t = I.useRef();
  t.current = e;
  var n = I.useCallback(function() {
    for (var r, i = arguments.length, o = new Array(i), a = 0; a < i; a++)
      o[a] = arguments[a];
    return (r = t.current) === null || r === void 0 ? void 0 : r.call.apply(r, [t].concat(o));
  }, []);
  return n;
}
function av(e) {
  var t = I.useRef(!1), n = I.useState(e), r = fe(n, 2), i = r[0], o = r[1];
  I.useEffect(function() {
    return t.current = !1, function() {
      t.current = !0;
    };
  }, []);
  function a(s, c) {
    c && t.current || o(s);
  }
  return [i, a];
}
function P5(e) {
  return e !== void 0;
}
function hc(e, t) {
  var n = t || {}, r = n.defaultValue, i = n.value, o = n.onChange, a = n.postState, s = av(function() {
    return P5(i) ? i : P5(r) ? typeof r == "function" ? r() : r : typeof e == "function" ? e() : e;
  }), c = fe(s, 2), l = c[0], u = c[1], d = i !== void 0 ? i : l, f = a ? a(d) : d, h = Rr(o), p = av([d]), g = fe(p, 2), m = g[0], v = g[1];
  b0(function() {
    var S = m[0];
    l !== S && h(l, S);
  }, [m]), b0(function() {
    P5(i) || u(i);
  }, [i]);
  var y = Rr(function(S, _) {
    u(S, _), v([d], _);
  });
  return [f, y];
}
function z8(e, t, n, r) {
  var i = ae({}, t[e]);
  if (r != null && r.deprecatedTokens) {
    var o = r.deprecatedTokens;
    o.forEach(function(s) {
      var c = fe(s, 2), l = c[0], u = c[1];
      if (process.env.NODE_ENV !== "production" && an(!(i != null && i[l]), "Component Token `".concat(String(l), "` of ").concat(String(e), " is deprecated. Please use `").concat(String(u), "` instead.")), i != null && i[l] || i != null && i[u]) {
        var d;
        (d = i[u]) !== null && d !== void 0 || (i[u] = i == null ? void 0 : i[l]);
      }
    });
  }
  var a = ae(ae({}, n), i);
  return Object.keys(a).forEach(function(s) {
    a[s] === t[s] && delete a[s];
  }), a;
}
var oX = process.env.NODE_ENV !== "production" || typeof CSSINJS_STATISTIC < "u", GA = !0;
function Or() {
  for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
    t[n] = arguments[n];
  if (!oX)
    return Object.assign.apply(Object, [{}].concat(t));
  GA = !1;
  var r = {};
  return t.forEach(function(i) {
    if (_t(i) === "object") {
      var o = Object.keys(i);
      o.forEach(function(a) {
        Object.defineProperty(r, a, {
          configurable: !0,
          enumerable: !0,
          get: function() {
            return i[a];
          }
        });
      });
    }
  }), GA = !0, r;
}
var KA = {};
function nIe() {
}
var aX = function(t) {
  var n, r = t, i = nIe;
  return oX && typeof Proxy < "u" && (n = /* @__PURE__ */ new Set(), r = new Proxy(t, {
    get: function(a, s) {
      if (GA) {
        var c;
        (c = n) === null || c === void 0 || c.add(s);
      }
      return a[s];
    }
  }), i = function(a, s) {
    var c;
    KA[a] = {
      global: Array.from(n),
      component: ae(ae({}, (c = KA[a]) === null || c === void 0 ? void 0 : c.component), s)
    };
  }), {
    token: r,
    keys: n,
    flush: i
  };
};
function H8(e, t, n) {
  if (typeof n == "function") {
    var r;
    return n(Or(t, (r = t[e]) !== null && r !== void 0 ? r : {}));
  }
  return n ?? {};
}
function rIe(e) {
  return e === "js" ? {
    max: Math.max,
    min: Math.min
  } : {
    max: function() {
      for (var n = arguments.length, r = new Array(n), i = 0; i < n; i++)
        r[i] = arguments[i];
      return "max(".concat(r.map(function(o) {
        return Qe(o);
      }).join(","), ")");
    },
    min: function() {
      for (var n = arguments.length, r = new Array(n), i = 0; i < n; i++)
        r[i] = arguments[i];
      return "min(".concat(r.map(function(o) {
        return Qe(o);
      }).join(","), ")");
    }
  };
}
var iIe = 1e3 * 60 * 10, oIe = /* @__PURE__ */ function() {
  function e() {
    Sr(this, e), re(this, "map", /* @__PURE__ */ new Map()), re(this, "objectIDMap", /* @__PURE__ */ new WeakMap()), re(this, "nextID", 0), re(this, "lastAccessBeat", /* @__PURE__ */ new Map()), re(this, "accessBeat", 0);
  }
  return wr(e, [{
    key: "set",
    value: function(n, r) {
      this.clear();
      var i = this.getCompositeKey(n);
      this.map.set(i, r), this.lastAccessBeat.set(i, Date.now());
    }
  }, {
    key: "get",
    value: function(n) {
      var r = this.getCompositeKey(n), i = this.map.get(r);
      return this.lastAccessBeat.set(r, Date.now()), this.accessBeat += 1, i;
    }
  }, {
    key: "getCompositeKey",
    value: function(n) {
      var r = this, i = n.map(function(o) {
        return o && _t(o) === "object" ? "obj_".concat(r.getObjectID(o)) : "".concat(_t(o), "_").concat(o);
      });
      return i.join("|");
    }
  }, {
    key: "getObjectID",
    value: function(n) {
      if (this.objectIDMap.has(n))
        return this.objectIDMap.get(n);
      var r = this.nextID;
      return this.objectIDMap.set(n, r), this.nextID += 1, r;
    }
  }, {
    key: "clear",
    value: function() {
      var n = this;
      if (this.accessBeat > 1e4) {
        var r = Date.now();
        this.lastAccessBeat.forEach(function(i, o) {
          r - i > iIe && (n.map.delete(o), n.lastAccessBeat.delete(o));
        }), this.accessBeat = 0;
      }
    }
  }]), e;
}(), U8 = new oIe();
function aIe(e, t) {
  return D.useMemo(function() {
    var n = U8.get(t);
    if (n)
      return n;
    var r = e();
    return U8.set(t, r), r;
  }, t);
}
var sIe = function() {
  return {};
};
function sX(e) {
  var t = e.useCSP, n = t === void 0 ? sIe : t, r = e.useToken, i = e.usePrefix, o = e.getResetStyles, a = e.getCommonStyle, s = e.getCompUnitless;
  function c(f, h, p, g) {
    var m = Array.isArray(f) ? f[0] : f;
    function v(C) {
      return "".concat(String(m)).concat(C.slice(0, 1).toUpperCase()).concat(C.slice(1));
    }
    var y = (g == null ? void 0 : g.unitless) || {}, S = typeof s == "function" ? s(f) : {}, _ = ae(ae({}, S), {}, re({}, v("zIndexPopup"), !0));
    Object.keys(y).forEach(function(C) {
      _[v(C)] = y[C];
    });
    var w = ae(ae({}, g), {}, {
      unitless: _,
      prefixToken: v
    }), T = u(f, h, p, w), x = l(m, p, w);
    return function(C) {
      var E = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : C, R = T(C, E), A = fe(R, 2), O = A[1], $ = x(E), N = fe($, 2), z = N[0], k = N[1];
      return [z, O, k];
    };
  }
  function l(f, h, p) {
    var g = p.unitless, m = p.injectStyle, v = m === void 0 ? !0 : m, y = p.prefixToken, S = p.ignore, _ = function(x) {
      var C = x.rootCls, E = x.cssVar, R = E === void 0 ? {} : E, A = r(), O = A.realToken;
      return OY({
        path: [f],
        prefix: R.prefix,
        key: R.key,
        unitless: g,
        ignore: S,
        token: O,
        scope: C
      }, function() {
        var $ = H8(f, O, h), N = z8(f, O, $, {
          deprecatedTokens: p == null ? void 0 : p.deprecatedTokens
        });
        return Object.keys($).forEach(function(z) {
          N[y(z)] = N[z], delete N[z];
        }), N;
      }), null;
    }, w = function(x) {
      var C = r(), E = C.cssVar;
      return [function(R) {
        return v && E ? /* @__PURE__ */ D.createElement(D.Fragment, null, /* @__PURE__ */ D.createElement(_, {
          rootCls: x,
          cssVar: E,
          component: f
        }), R) : R;
      }, E == null ? void 0 : E.key];
    };
    return w;
  }
  function u(f, h, p) {
    var g = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {}, m = Array.isArray(f) ? f : [f, f], v = fe(m, 1), y = v[0], S = m.join("-"), _ = e.layer || {
      name: "antd"
    };
    return function(w) {
      var T = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : w, x = r(), C = x.theme, E = x.realToken, R = x.hashId, A = x.token, O = x.cssVar, $ = i(), N = $.rootPrefixCls, z = $.iconPrefixCls, k = n(), F = O ? "css" : "js", V = aIe(function() {
        var q = /* @__PURE__ */ new Set();
        return O && Object.keys(g.unitless || {}).forEach(function(X) {
          q.add(y0(X, O.prefix)), q.add(y0(X, B8(y, O.prefix)));
        }), iX(F, q);
      }, [F, y, O == null ? void 0 : O.prefix]), j = rIe(F), B = j.max, U = j.min, Q = {
        theme: C,
        token: A,
        hashId: R,
        nonce: function() {
          return k.nonce;
        },
        clientOnly: g.clientOnly,
        layer: _,
        // antd is always at top of styles
        order: g.order || -999
      };
      nS(ae(ae({}, Q), {}, {
        clientOnly: !1,
        path: ["Shared", N]
      }), function() {
        return typeof o == "function" ? o(A) : [];
      });
      var K = nS(ae(ae({}, Q), {}, {
        path: [S, w, z]
      }), function() {
        if (g.injectStyle === !1)
          return [];
        var q = aX(A), X = q.token, ie = q.flush, te = H8(y, E, p), J = ".".concat(w), Y = z8(y, E, te, {
          deprecatedTokens: g.deprecatedTokens
        });
        O && te && _t(te) === "object" && Object.keys(te).forEach(function(oe) {
          te[oe] = "var(".concat(y0(oe, B8(y, O.prefix)), ")");
        });
        var ee = Or(X, {
          componentCls: J,
          prefixCls: w,
          iconCls: ".".concat(z),
          antCls: ".".concat(N),
          calc: V,
          // @ts-ignore
          max: B,
          // @ts-ignore
          min: U
        }, O ? te : Y), Z = h(ee, {
          hashId: R,
          prefixCls: w,
          rootPrefixCls: N,
          iconPrefixCls: z
        });
        ie(y, Y);
        var H = typeof a == "function" ? a(ee, w, T, g.resetFont) : null;
        return [g.resetStyle === !1 ? null : H, Z];
      });
      return [K, R];
    };
  }
  function d(f, h, p) {
    var g = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {}, m = u(f, h, p, ae({
      resetStyle: !1,
      // Sub Style should default after root one
      order: -998
    }, g)), v = function(S) {
      var _ = S.prefixCls, w = S.rootCls, T = w === void 0 ? _ : w;
      return m(_, T), null;
    };
    return process.env.NODE_ENV !== "production" && (v.displayName = "SubStyle_".concat(String(Array.isArray(f) ? f.join(".") : f))), v;
  }
  return {
    genStyleHooks: c,
    genSubStyleComponent: d,
    genComponentStyleHook: u
  };
}
const cIe = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  genCalc: iX,
  genStyleUtils: sX,
  mergeToken: Or,
  statistic: KA,
  statisticToken: aX
}, Symbol.toStringTag, { value: "Module" })), PS = ["blue", "purple", "cyan", "green", "magenta", "pink", "red", "orange", "yellow", "volcano", "geekblue", "lime", "gold"], lIe = "5.22.1";
function M5(e) {
  return e >= 0 && e <= 255;
}
function Vb(e, t) {
  const {
    r: n,
    g: r,
    b: i,
    a: o
  } = new Pn(e).toRgb();
  if (o < 1)
    return e;
  const {
    r: a,
    g: s,
    b: c
  } = new Pn(t).toRgb();
  for (let l = 0.01; l <= 1; l += 0.01) {
    const u = Math.round((n - a * (1 - l)) / l), d = Math.round((r - s * (1 - l)) / l), f = Math.round((i - c * (1 - l)) / l);
    if (M5(u) && M5(d) && M5(f))
      return new Pn({
        r: u,
        g: d,
        b: f,
        a: Math.round(l * 100) / 100
      }).toRgbString();
  }
  return new Pn({
    r: n,
    g: r,
    b: i,
    a: 1
  }).toRgbString();
}
var uIe = globalThis && globalThis.__rest || function(e, t) {
  var n = {};
  for (var r in e)
    Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var i = 0, r = Object.getOwnPropertySymbols(e); i < r.length; i++)
      t.indexOf(r[i]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[i]) && (n[r[i]] = e[r[i]]);
  return n;
};
function cX(e) {
  const {
    override: t
  } = e, n = uIe(e, ["override"]), r = Object.assign({}, t);
  Object.keys(ov).forEach((f) => {
    delete r[f];
  });
  const i = Object.assign(Object.assign({}, n), r), o = 480, a = 576, s = 768, c = 992, l = 1200, u = 1600;
  if (i.motion === !1) {
    const f = "0s";
    i.motionDurationFast = f, i.motionDurationMid = f, i.motionDurationSlow = f;
  }
  return Object.assign(Object.assign(Object.assign({}, i), {
    // ============== Background ============== //
    colorFillContent: i.colorFillSecondary,
    colorFillContentHover: i.colorFill,
    colorFillAlter: i.colorFillQuaternary,
    colorBgContainerDisabled: i.colorFillTertiary,
    // ============== Split ============== //
    colorBorderBg: i.colorBgContainer,
    colorSplit: Vb(i.colorBorderSecondary, i.colorBgContainer),
    // ============== Text ============== //
    colorTextPlaceholder: i.colorTextQuaternary,
    colorTextDisabled: i.colorTextQuaternary,
    colorTextHeading: i.colorText,
    colorTextLabel: i.colorTextSecondary,
    colorTextDescription: i.colorTextTertiary,
    colorTextLightSolid: i.colorWhite,
    colorHighlight: i.colorError,
    colorBgTextHover: i.colorFillSecondary,
    colorBgTextActive: i.colorFill,
    colorIcon: i.colorTextTertiary,
    colorIconHover: i.colorText,
    colorErrorOutline: Vb(i.colorErrorBg, i.colorBgContainer),
    colorWarningOutline: Vb(i.colorWarningBg, i.colorBgContainer),
    // Font
    fontSizeIcon: i.fontSizeSM,
    // Line
    lineWidthFocus: i.lineWidth * 3,
    // Control
    lineWidth: i.lineWidth,
    controlOutlineWidth: i.lineWidth * 2,
    // Checkbox size and expand icon size
    controlInteractiveSize: i.controlHeight / 2,
    controlItemBgHover: i.colorFillTertiary,
    controlItemBgActive: i.colorPrimaryBg,
    controlItemBgActiveHover: i.colorPrimaryBgHover,
    controlItemBgActiveDisabled: i.colorFill,
    controlTmpOutline: i.colorFillQuaternary,
    controlOutline: Vb(i.colorPrimaryBg, i.colorBgContainer),
    lineType: i.lineType,
    borderRadius: i.borderRadius,
    borderRadiusXS: i.borderRadiusXS,
    borderRadiusSM: i.borderRadiusSM,
    borderRadiusLG: i.borderRadiusLG,
    fontWeightStrong: 600,
    opacityLoading: 0.65,
    linkDecoration: "none",
    linkHoverDecoration: "none",
    linkFocusDecoration: "none",
    controlPaddingHorizontal: 12,
    controlPaddingHorizontalSM: 8,
    paddingXXS: i.sizeXXS,
    paddingXS: i.sizeXS,
    paddingSM: i.sizeSM,
    padding: i.size,
    paddingMD: i.sizeMD,
    paddingLG: i.sizeLG,
    paddingXL: i.sizeXL,
    paddingContentHorizontalLG: i.sizeLG,
    paddingContentVerticalLG: i.sizeMS,
    paddingContentHorizontal: i.sizeMS,
    paddingContentVertical: i.sizeSM,
    paddingContentHorizontalSM: i.size,
    paddingContentVerticalSM: i.sizeXS,
    marginXXS: i.sizeXXS,
    marginXS: i.sizeXS,
    marginSM: i.sizeSM,
    margin: i.size,
    marginMD: i.sizeMD,
    marginLG: i.sizeLG,
    marginXL: i.sizeXL,
    marginXXL: i.sizeXXL,
    boxShadow: `
      0 6px 16px 0 rgba(0, 0, 0, 0.08),
      0 3px 6px -4px rgba(0, 0, 0, 0.12),
      0 9px 28px 8px rgba(0, 0, 0, 0.05)
    `,
    boxShadowSecondary: `
      0 6px 16px 0 rgba(0, 0, 0, 0.08),
      0 3px 6px -4px rgba(0, 0, 0, 0.12),
      0 9px 28px 8px rgba(0, 0, 0, 0.05)
    `,
    boxShadowTertiary: `
      0 1px 2px 0 rgba(0, 0, 0, 0.03),
      0 1px 6px -1px rgba(0, 0, 0, 0.02),
      0 2px 4px 0 rgba(0, 0, 0, 0.02)
    `,
    screenXS: o,
    screenXSMin: o,
    screenXSMax: a - 1,
    screenSM: a,
    screenSMMin: a,
    screenSMMax: s - 1,
    screenMD: s,
    screenMDMin: s,
    screenMDMax: c - 1,
    screenLG: c,
    screenLGMin: c,
    screenLGMax: l - 1,
    screenXL: l,
    screenXLMin: l,
    screenXLMax: u - 1,
    screenXXL: u,
    screenXXLMin: u,
    boxShadowPopoverArrow: "2px 2px 5px rgba(0, 0, 0, 0.05)",
    boxShadowCard: `
      0 1px 2px -2px ${new Pn("rgba(0, 0, 0, 0.16)").toRgbString()},
      0 3px 6px 0 ${new Pn("rgba(0, 0, 0, 0.12)").toRgbString()},
      0 5px 12px 4px ${new Pn("rgba(0, 0, 0, 0.09)").toRgbString()}
    `,
    boxShadowDrawerRight: `
      -6px 0 16px 0 rgba(0, 0, 0, 0.08),
      -3px 0 6px -4px rgba(0, 0, 0, 0.12),
      -9px 0 28px 8px rgba(0, 0, 0, 0.05)
    `,
    boxShadowDrawerLeft: `
      6px 0 16px 0 rgba(0, 0, 0, 0.08),
      3px 0 6px -4px rgba(0, 0, 0, 0.12),
      9px 0 28px 8px rgba(0, 0, 0, 0.05)
    `,
    boxShadowDrawerUp: `
      0 6px 16px 0 rgba(0, 0, 0, 0.08),
      0 3px 6px -4px rgba(0, 0, 0, 0.12),
      0 9px 28px 8px rgba(0, 0, 0, 0.05)
    `,
    boxShadowDrawerDown: `
      0 -6px 16px 0 rgba(0, 0, 0, 0.08),
      0 -3px 6px -4px rgba(0, 0, 0, 0.12),
      0 -9px 28px 8px rgba(0, 0, 0, 0.05)
    `,
    boxShadowTabsOverflowLeft: "inset 10px 0 8px -8px rgba(0, 0, 0, 0.08)",
    boxShadowTabsOverflowRight: "inset -10px 0 8px -8px rgba(0, 0, 0, 0.08)",
    boxShadowTabsOverflowTop: "inset 0 10px 8px -8px rgba(0, 0, 0, 0.08)",
    boxShadowTabsOverflowBottom: "inset 0 -10px 8px -8px rgba(0, 0, 0, 0.08)"
  }), r);
}
var W8 = globalThis && globalThis.__rest || function(e, t) {
  var n = {};
  for (var r in e)
    Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var i = 0, r = Object.getOwnPropertySymbols(e); i < r.length; i++)
      t.indexOf(r[i]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[i]) && (n[r[i]] = e[r[i]]);
  return n;
};
const lX = {
  lineHeight: !0,
  lineHeightSM: !0,
  lineHeightLG: !0,
  lineHeightHeading1: !0,
  lineHeightHeading2: !0,
  lineHeightHeading3: !0,
  lineHeightHeading4: !0,
  lineHeightHeading5: !0,
  opacityLoading: !0,
  fontWeightStrong: !0,
  zIndexPopupBase: !0,
  zIndexBase: !0,
  opacityImage: !0
}, dIe = {
  size: !0,
  sizeSM: !0,
  sizeLG: !0,
  sizeMD: !0,
  sizeXS: !0,
  sizeXXS: !0,
  sizeMS: !0,
  sizeXL: !0,
  sizeXXL: !0,
  sizeUnit: !0,
  sizeStep: !0,
  motionBase: !0,
  motionUnit: !0
}, fIe = {
  screenXS: !0,
  screenXSMin: !0,
  screenXSMax: !0,
  screenSM: !0,
  screenSMMin: !0,
  screenSMMax: !0,
  screenMD: !0,
  screenMDMin: !0,
  screenMDMax: !0,
  screenLG: !0,
  screenLGMin: !0,
  screenLGMax: !0,
  screenXL: !0,
  screenXLMin: !0,
  screenXLMax: !0,
  screenXXL: !0,
  screenXXLMin: !0
}, uX = (e, t, n) => {
  const r = n.getDerivativeToken(e), {
    override: i
  } = t, o = W8(t, ["override"]);
  let a = Object.assign(Object.assign({}, r), {
    override: i
  });
  return a = cX(a), o && Object.entries(o).forEach((s) => {
    let [c, l] = s;
    const {
      theme: u
    } = l, d = W8(l, ["theme"]);
    let f = d;
    u && (f = uX(Object.assign(Object.assign({}, a), d), {
      override: d
    }, u)), a[c] = f;
  }), a;
};
function $s() {
  const {
    token: e,
    hashed: t,
    theme: n,
    override: r,
    cssVar: i
  } = D.useContext(tX), o = `${lIe}-${t || ""}`, a = n || eX, [s, c, l] = mY(a, [ov, e], {
    salt: o,
    override: r,
    getComputedToken: uX,
    // formatToken will not be consumed after 1.15.0 with getComputedToken.
    // But token will break if @ant-design/cssinjs is under 1.15.0 without it
    formatToken: cX,
    cssVar: i && {
      prefix: i.prefix,
      key: i.key,
      unitless: lX,
      ignore: dIe,
      preserve: fIe
    }
  });
  return [a, l, t ? c : "", s, i];
}
const YA = {
  overflow: "hidden",
  whiteSpace: "nowrap",
  textOverflow: "ellipsis"
}, va = function(e) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
  return {
    boxSizing: "border-box",
    margin: 0,
    padding: 0,
    color: e.colorText,
    fontSize: e.fontSize,
    // font-variant: @font-variant-base;
    lineHeight: e.lineHeight,
    listStyle: "none",
    // font-feature-settings: @font-feature-settings-base;
    fontFamily: t ? "inherit" : e.fontFamily
  };
}, Yx = () => ({
  display: "inline-flex",
  alignItems: "center",
  color: "inherit",
  fontStyle: "normal",
  lineHeight: 0,
  textAlign: "center",
  textTransform: "none",
  // for SVG icon, see https://blog.prototypr.io/align-svg-icons-to-text-and-say-goodbye-to-font-icons-d44b3d7b26b4
  verticalAlign: "-0.125em",
  textRendering: "optimizeLegibility",
  "-webkit-font-smoothing": "antialiased",
  "-moz-osx-font-smoothing": "grayscale",
  "> *": {
    lineHeight: 1
  },
  svg: {
    display: "inline-block"
  }
}), hIe = () => ({
  // https://github.com/ant-design/ant-design/issues/21301#issuecomment-583955229
  "&::before": {
    display: "table",
    content: '""'
  },
  "&::after": {
    // https://github.com/ant-design/ant-design/issues/21864
    display: "table",
    clear: "both",
    content: '""'
  }
}), gIe = (e) => ({
  a: {
    color: e.colorLink,
    textDecoration: e.linkDecoration,
    backgroundColor: "transparent",
    // remove the gray background on active links in IE 10.
    outline: "none",
    cursor: "pointer",
    transition: `color ${e.motionDurationSlow}`,
    "-webkit-text-decoration-skip": "objects",
    // remove gaps in links underline in iOS 8+ and Safari 8+.
    "&:hover": {
      color: e.colorLinkHover
    },
    "&:active": {
      color: e.colorLinkActive
    },
    "&:active, &:hover": {
      textDecoration: e.linkHoverDecoration,
      outline: 0
    },
    // https://github.com/ant-design/ant-design/issues/22503
    "&:focus": {
      textDecoration: e.linkFocusDecoration,
      outline: 0
    },
    "&[disabled]": {
      color: e.colorTextDisabled,
      cursor: "not-allowed"
    }
  }
}), pIe = (e, t, n, r) => {
  const i = `[class^="${t}"], [class*=" ${t}"]`, o = n ? `.${n}` : i, a = {
    boxSizing: "border-box",
    "&::before, &::after": {
      boxSizing: "border-box"
    }
  };
  let s = {};
  return r !== !1 && (s = {
    fontFamily: e.fontFamily,
    fontSize: e.fontSize
  }), {
    [o]: Object.assign(Object.assign(Object.assign({}, s), a), {
      [i]: a
    })
  };
}, mIe = (e) => ({
  outline: `${Qe(e.lineWidthFocus)} solid ${e.colorPrimaryBorder}`,
  outlineOffset: 1,
  transition: "outline-offset 0s, outline 0s"
}), vIe = (e) => ({
  "&:focus-visible": Object.assign({}, mIe(e))
}), yIe = (e, t) => {
  const [n, r] = $s();
  return nS({
    theme: n,
    token: r,
    hashId: "",
    path: ["ant-design-icons", e],
    nonce: () => t == null ? void 0 : t.nonce,
    layer: {
      name: "antd"
    }
  }, () => [{
    [`.${e}`]: Object.assign(Object.assign({}, Yx()), {
      [`.${e} .${e}-icon`]: {
        display: "block"
      }
    })
  }]);
}, dX = yIe, {
  genStyleHooks: qa,
  genComponentStyleHook: bIe,
  genSubStyleComponent: _Ie
} = sX({
  usePrefix: () => {
    const {
      getPrefixCls: e,
      iconPrefixCls: t
    } = St(En);
    return {
      rootPrefixCls: e(),
      iconPrefixCls: t
    };
  },
  useToken: () => {
    const [e, t, n, r, i] = $s();
    return {
      theme: e,
      realToken: t,
      hashId: n,
      token: r,
      cssVar: i
    };
  },
  useCSP: () => {
    const {
      csp: e,
      iconPrefixCls: t
    } = St(En);
    return dX(t, e), e ?? {};
  },
  getResetStyles: (e) => [{
    "&": gIe(e)
  }],
  getCommonStyle: pIe,
  getCompUnitless: () => lX
});
function SIe(e, t) {
  return PS.reduce((n, r) => {
    const i = e[`${r}1`], o = e[`${r}3`], a = e[`${r}6`], s = e[`${r}7`];
    return Object.assign(Object.assign({}, n), t(r, {
      lightColor: i,
      lightBorderColor: o,
      darkColor: a,
      textColor: s
    }));
  }, {});
}
const wIe = Object.assign({}, I), {
  useId: q8
} = wIe, xIe = () => "", EIe = typeof q8 > "u" ? xIe : q8, CIe = EIe;
function TIe(e, t, n) {
  var r, i;
  const o = di("ConfigProvider"), a = e || {}, s = a.inherit === !1 || !t ? Object.assign(Object.assign({}, UA), {
    hashed: (r = t == null ? void 0 : t.hashed) !== null && r !== void 0 ? r : UA.hashed,
    cssVar: t == null ? void 0 : t.cssVar
  }) : t, c = CIe();
  if (process.env.NODE_ENV !== "production") {
    const l = a.cssVar || s.cssVar, u = !!(typeof a.cssVar == "object" && (!((i = a.cssVar) === null || i === void 0) && i.key) || c);
    process.env.NODE_ENV !== "production" && o(!l || u, "breaking", "Missing key in `cssVar` config. Please upgrade to React 18 or set `cssVar.key` manually in each ConfigProvider inside `cssVar` enabled ConfigProvider.");
  }
  return oy(() => {
    var l, u;
    if (!e)
      return t;
    const d = Object.assign({}, s.components);
    Object.keys(e.components || {}).forEach((p) => {
      d[p] = Object.assign(Object.assign({}, d[p]), e.components[p]);
    });
    const f = `css-var-${c.replace(/:/g, "")}`, h = ((l = a.cssVar) !== null && l !== void 0 ? l : s.cssVar) && Object.assign(Object.assign(Object.assign({
      prefix: n == null ? void 0 : n.prefixCls
    }, typeof s.cssVar == "object" ? s.cssVar : {}), typeof a.cssVar == "object" ? a.cssVar : {}), {
      key: typeof a.cssVar == "object" && ((u = a.cssVar) === null || u === void 0 ? void 0 : u.key) || f
    });
    return Object.assign(Object.assign(Object.assign({}, s), a), {
      token: Object.assign(Object.assign({}, s.token), a.token),
      components: d,
      cssVar: h
    });
  }, [a, s], (l, u) => l.some((d, f) => {
    const h = u[f];
    return !Ig(d, h, !0);
  }));
}
var IIe = ["children"], fX = /* @__PURE__ */ I.createContext({});
function hX(e) {
  var t = e.children, n = xn(e, IIe);
  return /* @__PURE__ */ I.createElement(fX.Provider, {
    value: n
  }, t);
}
var AIe = /* @__PURE__ */ function(e) {
  Rs(n, e);
  var t = _c(n);
  function n() {
    return Sr(this, n), t.apply(this, arguments);
  }
  return wr(n, [{
    key: "render",
    value: function() {
      return this.props.children;
    }
  }]), n;
}(I.Component);
function RIe(e) {
  var t = I.useReducer(function(s) {
    return s + 1;
  }, 0), n = fe(t, 2), r = n[1], i = I.useRef(e), o = Rr(function() {
    return i.current;
  }), a = Rr(function(s) {
    i.current = typeof s == "function" ? s(i.current) : s, r();
  });
  return [o, a];
}
var Rl = "none", Bb = "appear", zb = "enter", Hb = "leave", G8 = "none", os = "prepare", Nh = "start", Dh = "active", y6 = "end", gX = "prepared";
function K8(e, t) {
  var n = {};
  return n[e.toLowerCase()] = t.toLowerCase(), n["Webkit".concat(e)] = "webkit".concat(t), n["Moz".concat(e)] = "moz".concat(t), n["ms".concat(e)] = "MS".concat(t), n["O".concat(e)] = "o".concat(t.toLowerCase()), n;
}
function $Ie(e, t) {
  var n = {
    animationend: K8("Animation", "AnimationEnd"),
    transitionend: K8("Transition", "TransitionEnd")
  };
  return e && ("AnimationEvent" in t || delete n.animationend.animation, "TransitionEvent" in t || delete n.transitionend.transition), n;
}
var OIe = $Ie(ao(), typeof window < "u" ? window : {}), pX = {};
if (ao()) {
  var PIe = document.createElement("div");
  pX = PIe.style;
}
var Ub = {};
function mX(e) {
  if (Ub[e])
    return Ub[e];
  var t = OIe[e];
  if (t)
    for (var n = Object.keys(t), r = n.length, i = 0; i < r; i += 1) {
      var o = n[i];
      if (Object.prototype.hasOwnProperty.call(t, o) && o in pX)
        return Ub[e] = t[o], Ub[e];
    }
  return "";
}
var vX = mX("animationend"), yX = mX("transitionend"), bX = !!(vX && yX), Y8 = vX || "animationend", X8 = yX || "transitionend";
function Q8(e, t) {
  if (!e)
    return null;
  if (_t(e) === "object") {
    var n = t.replace(/-\w/g, function(r) {
      return r[1].toUpperCase();
    });
    return e[n];
  }
  return "".concat(e, "-").concat(t);
}
const MIe = function(e) {
  var t = Me();
  function n(i) {
    i && (i.removeEventListener(X8, e), i.removeEventListener(Y8, e));
  }
  function r(i) {
    t.current && t.current !== i && n(t.current), i && i !== t.current && (i.addEventListener(X8, e), i.addEventListener(Y8, e), t.current = i);
  }
  return I.useEffect(function() {
    return function() {
      n(t.current);
    };
  }, []), [r, n];
};
var _X = ao() ? Nv : gt;
const kIe = function() {
  var e = I.useRef(null);
  function t() {
    Ln.cancel(e.current);
  }
  function n(r) {
    var i = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 2;
    t();
    var o = Ln(function() {
      i <= 1 ? r({
        isCanceled: function() {
          return o !== e.current;
        }
      }) : n(r, i - 1);
    });
    e.current = o;
  }
  return I.useEffect(function() {
    return function() {
      t();
    };
  }, []), [n, t];
};
var NIe = [os, Nh, Dh, y6], DIe = [os, gX], SX = !1, LIe = !0;
function wX(e) {
  return e === Dh || e === y6;
}
const jIe = function(e, t, n) {
  var r = av(G8), i = fe(r, 2), o = i[0], a = i[1], s = kIe(), c = fe(s, 2), l = c[0], u = c[1];
  function d() {
    a(os, !0);
  }
  var f = t ? DIe : NIe;
  return _X(function() {
    if (o !== G8 && o !== y6) {
      var h = f.indexOf(o), p = f[h + 1], g = n(o);
      g === SX ? a(p, !0) : p && l(function(m) {
        function v() {
          m.isCanceled() || a(p, !0);
        }
        g === !0 ? v() : Promise.resolve(g).then(v);
      });
    }
  }, [e, o]), I.useEffect(function() {
    return function() {
      u();
    };
  }, []), [d, o];
};
function FIe(e, t, n, r) {
  var i = r.motionEnter, o = i === void 0 ? !0 : i, a = r.motionAppear, s = a === void 0 ? !0 : a, c = r.motionLeave, l = c === void 0 ? !0 : c, u = r.motionDeadline, d = r.motionLeaveImmediately, f = r.onAppearPrepare, h = r.onEnterPrepare, p = r.onLeavePrepare, g = r.onAppearStart, m = r.onEnterStart, v = r.onLeaveStart, y = r.onAppearActive, S = r.onEnterActive, _ = r.onLeaveActive, w = r.onAppearEnd, T = r.onEnterEnd, x = r.onLeaveEnd, C = r.onVisibleChanged, E = av(), R = fe(E, 2), A = R[0], O = R[1], $ = RIe(Rl), N = fe($, 2), z = N[0], k = N[1], F = av(null), V = fe(F, 2), j = V[0], B = V[1], U = z(), Q = Me(!1), K = Me(null);
  function q() {
    return n();
  }
  var X = Me(!1);
  function ie() {
    k(Rl), B(null, !0);
  }
  var te = Rr(function(Ee) {
    var pe = z();
    if (pe !== Rl) {
      var Oe = q();
      if (!(Ee && !Ee.deadline && Ee.target !== Oe)) {
        var de = X.current, be;
        pe === Bb && de ? be = w == null ? void 0 : w(Oe, Ee) : pe === zb && de ? be = T == null ? void 0 : T(Oe, Ee) : pe === Hb && de && (be = x == null ? void 0 : x(Oe, Ee)), de && be !== !1 && ie();
      }
    }
  }), J = MIe(te), Y = fe(J, 1), ee = Y[0], Z = function(pe) {
    switch (pe) {
      case Bb:
        return re(re(re({}, os, f), Nh, g), Dh, y);
      case zb:
        return re(re(re({}, os, h), Nh, m), Dh, S);
      case Hb:
        return re(re(re({}, os, p), Nh, v), Dh, _);
      default:
        return {};
    }
  }, H = I.useMemo(function() {
    return Z(U);
  }, [U]), oe = jIe(U, !e, function(Ee) {
    if (Ee === os) {
      var pe = H[os];
      return pe ? pe(q()) : SX;
    }
    if (ce in H) {
      var Oe;
      B(((Oe = H[ce]) === null || Oe === void 0 ? void 0 : Oe.call(H, q(), null)) || null);
    }
    return ce === Dh && U !== Rl && (ee(q()), u > 0 && (clearTimeout(K.current), K.current = setTimeout(function() {
      te({
        deadline: !0
      });
    }, u))), ce === gX && ie(), LIe;
  }), W = fe(oe, 2), se = W[0], ce = W[1], ge = wX(ce);
  X.current = ge, _X(function() {
    O(t);
    var Ee = Q.current;
    Q.current = !0;
    var pe;
    !Ee && t && s && (pe = Bb), Ee && t && o && (pe = zb), (Ee && !t && l || !Ee && d && !t && l) && (pe = Hb);
    var Oe = Z(pe);
    pe && (e || Oe[os]) ? (k(pe), se()) : k(Rl);
  }, [t]), gt(function() {
    // Cancel appear
    (U === Bb && !s || // Cancel enter
    U === zb && !o || // Cancel leave
    U === Hb && !l) && k(Rl);
  }, [s, o, l]), gt(function() {
    return function() {
      Q.current = !1, clearTimeout(K.current);
    };
  }, []);
  var he = I.useRef(!1);
  gt(function() {
    A && (he.current = !0), A !== void 0 && U === Rl && ((he.current || A) && (C == null || C(A)), he.current = !0);
  }, [A, U]);
  var ue = j;
  return H[os] && ce === Nh && (ue = ae({
    transition: "none"
  }, ue)), [U, ce, ue, A ?? t];
}
function VIe(e) {
  var t = e;
  _t(e) === "object" && (t = e.transitionSupport);
  function n(i, o) {
    return !!(i.motionName && t && o !== !1);
  }
  var r = /* @__PURE__ */ I.forwardRef(function(i, o) {
    var a = i.visible, s = a === void 0 ? !0 : a, c = i.removeOnLeave, l = c === void 0 ? !0 : c, u = i.forceRender, d = i.children, f = i.motionName, h = i.leavedClassName, p = i.eventProps, g = I.useContext(fX), m = g.motion, v = n(i, m), y = Me(), S = Me();
    function _() {
      try {
        return y.current instanceof HTMLElement ? y.current : m0(S.current);
      } catch {
        return null;
      }
    }
    var w = FIe(v, s, _, i), T = fe(w, 4), x = T[0], C = T[1], E = T[2], R = T[3], A = I.useRef(R);
    R && (A.current = !0);
    var O = I.useCallback(function(j) {
      y.current = j, t6(o, j);
    }, [o]), $, N = ae(ae({}, p), {}, {
      visible: s
    });
    if (!d)
      $ = null;
    else if (x === Rl)
      R ? $ = d(ae({}, N), O) : !l && A.current && h ? $ = d(ae(ae({}, N), {}, {
        className: h
      }), O) : u || !l && !h ? $ = d(ae(ae({}, N), {}, {
        style: {
          display: "none"
        }
      }), O) : $ = null;
    else {
      var z;
      C === os ? z = "prepare" : wX(C) ? z = "active" : C === Nh && (z = "start");
      var k = Q8(f, "".concat(x, "-").concat(z));
      $ = d(ae(ae({}, N), {}, {
        className: we(Q8(f, x), re(re({}, k, k && z), f, typeof f == "string")),
        style: E
      }), O);
    }
    if (/* @__PURE__ */ I.isValidElement($) && ay($)) {
      var F = $, V = F.ref;
      V || ($ = /* @__PURE__ */ I.cloneElement($, {
        ref: O
      }));
    }
    return /* @__PURE__ */ I.createElement(AIe, {
      ref: S
    }, $);
  });
  return r.displayName = "CSSMotion", r;
}
const Tf = VIe(bX);
var XA = "add", QA = "keep", JA = "remove", k5 = "removed";
function BIe(e) {
  var t;
  return e && _t(e) === "object" && "key" in e ? t = e : t = {
    key: e
  }, ae(ae({}, t), {}, {
    key: String(t.key)
  });
}
function ZA() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
  return e.map(BIe);
}
function zIe() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [], n = [], r = 0, i = t.length, o = ZA(e), a = ZA(t);
  o.forEach(function(l) {
    for (var u = !1, d = r; d < i; d += 1) {
      var f = a[d];
      if (f.key === l.key) {
        r < d && (n = n.concat(a.slice(r, d).map(function(h) {
          return ae(ae({}, h), {}, {
            status: XA
          });
        })), r = d), n.push(ae(ae({}, f), {}, {
          status: QA
        })), r += 1, u = !0;
        break;
      }
    }
    u || n.push(ae(ae({}, l), {}, {
      status: JA
    }));
  }), r < i && (n = n.concat(a.slice(r).map(function(l) {
    return ae(ae({}, l), {}, {
      status: XA
    });
  })));
  var s = {};
  n.forEach(function(l) {
    var u = l.key;
    s[u] = (s[u] || 0) + 1;
  });
  var c = Object.keys(s).filter(function(l) {
    return s[l] > 1;
  });
  return c.forEach(function(l) {
    n = n.filter(function(u) {
      var d = u.key, f = u.status;
      return d !== l || f !== JA;
    }), n.forEach(function(u) {
      u.key === l && (u.status = QA);
    });
  }), n;
}
var HIe = ["component", "children", "onVisibleChanged", "onAllRemoved"], UIe = ["status"], WIe = ["eventProps", "visible", "children", "motionName", "motionAppear", "motionEnter", "motionLeave", "motionLeaveImmediately", "motionDeadline", "removeOnLeave", "leavedClassName", "onAppearPrepare", "onAppearStart", "onAppearActive", "onAppearEnd", "onEnterStart", "onEnterActive", "onEnterEnd", "onLeaveStart", "onLeaveActive", "onLeaveEnd"];
function qIe(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Tf, n = /* @__PURE__ */ function(r) {
    Rs(o, r);
    var i = _c(o);
    function o() {
      var a;
      Sr(this, o);
      for (var s = arguments.length, c = new Array(s), l = 0; l < s; l++)
        c[l] = arguments[l];
      return a = i.call.apply(i, [this].concat(c)), re(nn(a), "state", {
        keyEntities: []
      }), re(nn(a), "removeKey", function(u) {
        a.setState(function(d) {
          var f = d.keyEntities.map(function(h) {
            return h.key !== u ? h : ae(ae({}, h), {}, {
              status: k5
            });
          });
          return {
            keyEntities: f
          };
        }, function() {
          var d = a.state.keyEntities, f = d.filter(function(h) {
            var p = h.status;
            return p !== k5;
          }).length;
          f === 0 && a.props.onAllRemoved && a.props.onAllRemoved();
        });
      }), a;
    }
    return wr(o, [{
      key: "render",
      value: function() {
        var s = this, c = this.state.keyEntities, l = this.props, u = l.component, d = l.children, f = l.onVisibleChanged;
        l.onAllRemoved;
        var h = xn(l, HIe), p = u || I.Fragment, g = {};
        return WIe.forEach(function(m) {
          g[m] = h[m], delete h[m];
        }), delete h.keys, /* @__PURE__ */ I.createElement(p, h, c.map(function(m, v) {
          var y = m.status, S = xn(m, UIe), _ = y === XA || y === QA;
          return /* @__PURE__ */ I.createElement(t, mt({}, g, {
            key: S.key,
            visible: _,
            eventProps: S,
            onVisibleChanged: function(T) {
              f == null || f(T, {
                key: S.key
              }), T || s.removeKey(S.key);
            }
          }), function(w, T) {
            return d(ae(ae({}, w), {}, {
              index: v
            }), T);
          });
        }));
      }
    }], [{
      key: "getDerivedStateFromProps",
      value: function(s, c) {
        var l = s.keys, u = c.keyEntities, d = ZA(l), f = zIe(u, d);
        return {
          keyEntities: f.filter(function(h) {
            var p = u.find(function(g) {
              var m = g.key;
              return h.key === m;
            });
            return !(p && p.status === k5 && h.status === JA);
          })
        };
      }
    }]), o;
  }(I.Component);
  return re(n, "defaultProps", {
    component: "div"
  }), n;
}
const xX = qIe(bX), GIe = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  CSSMotionList: xX,
  Provider: hX,
  default: Tf
}, Symbol.toStringTag, { value: "Module" }));
function KIe(e) {
  const {
    children: t
  } = e, [, n] = $s(), {
    motion: r
  } = n, i = I.useRef(!1);
  return i.current = i.current || r === !1, i.current ? /* @__PURE__ */ I.createElement(hX, {
    motion: r
  }, t) : t;
}
const EX = /* @__PURE__ */ I.memo((e) => {
  let {
    dropdownMatchSelectWidth: t
  } = e;
  return di("ConfigProvider").deprecated(t === void 0, "dropdownMatchSelectWidth", "popupMatchSelectWidth"), null;
});
process.env.NODE_ENV !== "production" && (EX.displayName = "PropWarning");
const YIe = process.env.NODE_ENV !== "production" ? EX : () => null;
var XIe = globalThis && globalThis.__rest || function(e, t) {
  var n = {};
  for (var r in e)
    Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var i = 0, r = Object.getOwnPropertySymbols(e); i < r.length; i++)
      t.indexOf(r[i]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[i]) && (n[r[i]] = e[r[i]]);
  return n;
};
let eR = !1;
const QIe = process.env.NODE_ENV !== "production" ? (e) => {
  process.env.NODE_ENV !== "production" && Gx(!eR, e, "Static function can not consume context like dynamic theme. Please use 'App' component instead.");
} : (
  /* istanbul ignore next */
  null
), JIe = ["getTargetContainer", "getPopupContainer", "renderEmpty", "input", "pagination", "form", "select", "button"];
let MS, CX, TX, IX;
function q1() {
  return MS || OS;
}
function ZIe() {
  return CX || v6;
}
function eAe(e) {
  return Object.keys(e).some((t) => t.endsWith("Color"));
}
const tAe = (e) => {
  const {
    prefixCls: t,
    iconPrefixCls: n,
    theme: r,
    holderRender: i
  } = e;
  t !== void 0 && (MS = t), n !== void 0 && (CX = n), "holderRender" in e && (IX = i), r && (eAe(r) ? (process.env.NODE_ENV !== "production" && Gx(!1, "ConfigProvider", "`config` of css variable theme is not work in v5. Please use new `theme` config instead."), YTe(q1(), r)) : TX = r);
}, AX = () => ({
  getPrefixCls: (e, t) => t || (e ? `${q1()}-${e}` : q1()),
  getIconPrefixCls: ZIe,
  getRootPrefixCls: () => MS || q1(),
  getTheme: () => TX,
  holderRender: IX
}), nAe = (e) => {
  const {
    children: t,
    csp: n,
    autoInsertSpaceInButton: r,
    alert: i,
    anchor: o,
    form: a,
    locale: s,
    componentSize: c,
    direction: l,
    space: u,
    splitter: d,
    virtual: f,
    dropdownMatchSelectWidth: h,
    popupMatchSelectWidth: p,
    popupOverflow: g,
    legacyLocale: m,
    parentContext: v,
    iconPrefixCls: y,
    theme: S,
    componentDisabled: _,
    segmented: w,
    statistic: T,
    spin: x,
    calendar: C,
    carousel: E,
    cascader: R,
    collapse: A,
    typography: O,
    checkbox: $,
    descriptions: N,
    divider: z,
    drawer: k,
    skeleton: F,
    steps: V,
    image: j,
    layout: B,
    list: U,
    mentions: Q,
    modal: K,
    progress: q,
    result: X,
    slider: ie,
    breadcrumb: te,
    menu: J,
    pagination: Y,
    input: ee,
    textArea: Z,
    empty: H,
    badge: oe,
    radio: W,
    rate: se,
    switch: ce,
    transfer: ge,
    avatar: he,
    message: ue,
    tag: Ee,
    table: pe,
    card: Oe,
    tabs: de,
    timeline: be,
    timePicker: Ie,
    upload: Ve,
    notification: Fe,
    tree: Pe,
    colorPicker: ot,
    datePicker: dt,
    rangePicker: ft,
    flex: wt,
    wave: Ge,
    dropdown: at,
    warning: Nt,
    tour: zt,
    floatButtonGroup: kt,
    variant: Ct,
    inputNumber: yt,
    treeSelect: Mn
  } = e, Pt = I.useCallback((Be, ze) => {
    const {
      prefixCls: it
    } = e;
    if (ze)
      return ze;
    const lt = it || v.getPrefixCls("");
    return Be ? `${lt}-${Be}` : lt;
  }, [v.getPrefixCls, e.prefixCls]), Ze = y || v.iconPrefixCls || v6, Le = n || v.csp;
  dX(Ze, Le);
  const rt = TIe(S, v.theme, {
    prefixCls: Pt("")
  });
  process.env.NODE_ENV !== "production" && (eR = eR || !!rt);
  const ut = {
    csp: Le,
    autoInsertSpaceInButton: r,
    alert: i,
    anchor: o,
    locale: s || m,
    direction: l,
    space: u,
    splitter: d,
    virtual: f,
    popupMatchSelectWidth: p ?? h,
    popupOverflow: g,
    getPrefixCls: Pt,
    iconPrefixCls: Ze,
    theme: rt,
    segmented: w,
    statistic: T,
    spin: x,
    calendar: C,
    carousel: E,
    cascader: R,
    collapse: A,
    typography: O,
    checkbox: $,
    descriptions: N,
    divider: z,
    drawer: k,
    skeleton: F,
    steps: V,
    image: j,
    input: ee,
    textArea: Z,
    layout: B,
    list: U,
    mentions: Q,
    modal: K,
    progress: q,
    result: X,
    slider: ie,
    breadcrumb: te,
    menu: J,
    pagination: Y,
    empty: H,
    badge: oe,
    radio: W,
    rate: se,
    switch: ce,
    transfer: ge,
    avatar: he,
    message: ue,
    tag: Ee,
    table: pe,
    card: Oe,
    tabs: de,
    timeline: be,
    timePicker: Ie,
    upload: Ve,
    notification: Fe,
    tree: Pe,
    colorPicker: ot,
    datePicker: dt,
    rangePicker: ft,
    flex: wt,
    wave: Ge,
    dropdown: at,
    warning: Nt,
    tour: zt,
    floatButtonGroup: kt,
    variant: Ct,
    inputNumber: yt,
    treeSelect: Mn
  };
  process.env.NODE_ENV !== "production" && di("ConfigProvider")(!("autoInsertSpaceInButton" in e), "deprecated", "`autoInsertSpaceInButton` is deprecated. Please use `{ button: { autoInsertSpace: boolean }}` instead.");
  const vt = Object.assign({}, v);
  Object.keys(ut).forEach((Be) => {
    ut[Be] !== void 0 && (vt[Be] = ut[Be]);
  }), JIe.forEach((Be) => {
    const ze = e[Be];
    ze && (vt[Be] = ze);
  }), typeof r < "u" && (vt.button = Object.assign({
    autoInsertSpace: r
  }, vt.button));
  const We = oy(() => vt, vt, (Be, ze) => {
    const it = Object.keys(Be), lt = Object.keys(ze);
    return it.length !== lt.length || it.some((Tt) => Be[Tt] !== ze[Tt]);
  }), et = I.useMemo(() => ({
    prefixCls: Ze,
    csp: Le
  }), [Ze, Le]);
  let Ne = /* @__PURE__ */ I.createElement(I.Fragment, null, /* @__PURE__ */ I.createElement(YIe, {
    dropdownMatchSelectWidth: h
  }), t);
  const Yt = I.useMemo(() => {
    var Be, ze, it, lt;
    return kh(((Be = Mg.Form) === null || Be === void 0 ? void 0 : Be.defaultValidateMessages) || {}, ((it = (ze = We.locale) === null || ze === void 0 ? void 0 : ze.Form) === null || it === void 0 ? void 0 : it.defaultValidateMessages) || {}, ((lt = We.form) === null || lt === void 0 ? void 0 : lt.validateMessages) || {}, (a == null ? void 0 : a.validateMessages) || {});
  }, [We, a == null ? void 0 : a.validateMessages]);
  Object.keys(Yt).length > 0 && (Ne = /* @__PURE__ */ I.createElement(Z5e.Provider, {
    value: Yt
  }, Ne)), s && (Ne = /* @__PURE__ */ I.createElement(lTe, {
    locale: s,
    _ANT_MARK__: LY
  }, Ne)), (Ze || Le) && (Ne = /* @__PURE__ */ I.createElement(u6.Provider, {
    value: et
  }, Ne)), c && (Ne = /* @__PURE__ */ I.createElement(QTe, {
    size: c
  }, Ne)), Ne = /* @__PURE__ */ I.createElement(KIe, null, Ne);
  const Ht = I.useMemo(() => {
    const Be = rt || {}, {
      algorithm: ze,
      token: it,
      components: lt,
      cssVar: Tt
    } = Be, jt = XIe(Be, ["algorithm", "token", "components", "cssVar"]), ne = ze && (!Array.isArray(ze) || ze.length > 0) ? tS(ze) : eX, _e = {};
    Object.entries(lt || {}).forEach((qe) => {
      let [xt, bt] = qe;
      const st = Object.assign({}, bt);
      "algorithm" in st && (st.algorithm === !0 ? st.theme = ne : (Array.isArray(st.algorithm) || typeof st.algorithm == "function") && (st.theme = tS(st.algorithm)), delete st.algorithm), _e[xt] = st;
    });
    const $e = Object.assign(Object.assign({}, ov), it);
    return Object.assign(Object.assign({}, jt), {
      theme: ne,
      token: $e,
      components: _e,
      override: Object.assign({
        override: $e
      }, _e),
      cssVar: Tt
    });
  }, [rt]);
  return S && (Ne = /* @__PURE__ */ I.createElement(tX.Provider, {
    value: Ht
  }, Ne)), We.warning && (Ne = /* @__PURE__ */ I.createElement(NY.Provider, {
    value: We.warning
  }, Ne)), _ !== void 0 && (Ne = /* @__PURE__ */ I.createElement(XTe, {
    disabled: _
  }, Ne)), /* @__PURE__ */ I.createElement(En.Provider, {
    value: We
  }, Ne);
}, lo = (e) => {
  const t = I.useContext(En), n = I.useContext(f6);
  return /* @__PURE__ */ I.createElement(nAe, Object.assign({
    parentContext: t,
    legacyLocale: n
  }, e));
};
lo.ConfigContext = En;
lo.SizeContext = Kx;
lo.config = tAe;
lo.useConfig = JTe;
Object.defineProperty(lo, "SizeContext", {
  get: () => (process.env.NODE_ENV !== "production" && Gx(!1, "ConfigProvider", "ConfigProvider.SizeContext is deprecated. Please use `ConfigProvider.useConfig().componentSize` instead."), Kx)
});
process.env.NODE_ENV !== "production" && (lo.displayName = "ConfigProvider");
var rAe = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm193.5 301.7l-210.6 292a31.8 31.8 0 01-51.7 0L318.5 484.9c-3.8-5.3 0-12.7 6.5-12.7h46.9c10.2 0 19.9 4.9 25.9 13.3l71.2 98.8 157.2-218c6-8.3 15.6-13.3 25.9-13.3H699c6.5 0 10.3 7.4 6.5 12.7z" } }] }, name: "check-circle", theme: "filled" };
const iAe = rAe;
function RX(e) {
  var t;
  return e == null || (t = e.getRootNode) === null || t === void 0 ? void 0 : t.call(e);
}
function oAe(e) {
  return RX(e) instanceof ShadowRoot;
}
function kS(e) {
  return oAe(e) ? RX(e) : null;
}
function aAe(e) {
  return e.replace(/-(.)/g, function(t, n) {
    return n.toUpperCase();
  });
}
function sAe(e, t) {
  an(e, "[@ant-design/icons] ".concat(t));
}
function J8(e) {
  return _t(e) === "object" && typeof e.name == "string" && typeof e.theme == "string" && (_t(e.icon) === "object" || typeof e.icon == "function");
}
function Z8() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
  return Object.keys(e).reduce(function(t, n) {
    var r = e[n];
    switch (n) {
      case "class":
        t.className = r, delete t.class;
        break;
      default:
        delete t[n], t[aAe(n)] = r;
    }
    return t;
  }, {});
}
function tR(e, t, n) {
  return n ? /* @__PURE__ */ D.createElement(e.tag, ae(ae({
    key: t
  }, Z8(e.attrs)), n), (e.children || []).map(function(r, i) {
    return tR(r, "".concat(t, "-").concat(e.tag, "-").concat(i));
  })) : /* @__PURE__ */ D.createElement(e.tag, ae({
    key: t
  }, Z8(e.attrs)), (e.children || []).map(function(r, i) {
    return tR(r, "".concat(t, "-").concat(e.tag, "-").concat(i));
  }));
}
function $X(e) {
  return kg(e)[0];
}
function OX(e) {
  return e ? Array.isArray(e) ? e : [e] : [];
}
var cAe = `
.anticon {
  display: inline-flex;
  align-items: center;
  color: inherit;
  font-style: normal;
  line-height: 0;
  text-align: center;
  text-transform: none;
  vertical-align: -0.125em;
  text-rendering: optimizeLegibility;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.anticon > * {
  line-height: 1;
}

.anticon svg {
  display: inline-block;
}

.anticon::before {
  display: none;
}

.anticon .anticon-icon {
  display: block;
}

.anticon[tabindex] {
  cursor: pointer;
}

.anticon-spin::before,
.anticon-spin {
  display: inline-block;
  -webkit-animation: loadingCircle 1s infinite linear;
  animation: loadingCircle 1s infinite linear;
}

@-webkit-keyframes loadingCircle {
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}

@keyframes loadingCircle {
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
`, lAe = function(t) {
  var n = St(u6), r = n.csp, i = n.prefixCls, o = cAe;
  i && (o = o.replace(/anticon/g, i)), gt(function() {
    var a = t.current, s = kS(a);
    cc(o, "@ant-design-icons", {
      prepend: !0,
      csp: r,
      attachTo: s
    });
  }, []);
}, uAe = ["icon", "className", "onClick", "style", "primaryColor", "secondaryColor"], S0 = {
  primaryColor: "#333",
  secondaryColor: "#E6E6E6",
  calculated: !1
};
function dAe(e) {
  var t = e.primaryColor, n = e.secondaryColor;
  S0.primaryColor = t, S0.secondaryColor = n || $X(t), S0.calculated = !!n;
}
function fAe() {
  return ae({}, S0);
}
var Xx = function(t) {
  var n = t.icon, r = t.className, i = t.onClick, o = t.style, a = t.primaryColor, s = t.secondaryColor, c = xn(t, uAe), l = I.useRef(), u = S0;
  if (a && (u = {
    primaryColor: a,
    secondaryColor: s || $X(a)
  }), lAe(l), sAe(J8(n), "icon should be icon definiton, but got ".concat(n)), !J8(n))
    return null;
  var d = n;
  return d && typeof d.icon == "function" && (d = ae(ae({}, d), {}, {
    icon: d.icon(u.primaryColor, u.secondaryColor)
  })), tR(d.icon, "svg-".concat(d.name), ae(ae({
    className: r,
    onClick: i,
    style: o,
    "data-icon": d.name,
    width: "1em",
    height: "1em",
    fill: "currentColor",
    "aria-hidden": "true"
  }, c), {}, {
    ref: l
  }));
};
Xx.displayName = "IconReact";
Xx.getTwoToneColors = fAe;
Xx.setTwoToneColors = dAe;
const b6 = Xx;
function PX(e) {
  var t = OX(e), n = fe(t, 2), r = n[0], i = n[1];
  return b6.setTwoToneColors({
    primaryColor: r,
    secondaryColor: i
  });
}
function hAe() {
  var e = b6.getTwoToneColors();
  return e.calculated ? [e.primaryColor, e.secondaryColor] : e.primaryColor;
}
var gAe = ["className", "icon", "spin", "rotate", "tabIndex", "onClick", "twoToneColor"];
PX(rv.primary);
var Qx = /* @__PURE__ */ I.forwardRef(function(e, t) {
  var n = e.className, r = e.icon, i = e.spin, o = e.rotate, a = e.tabIndex, s = e.onClick, c = e.twoToneColor, l = xn(e, gAe), u = I.useContext(u6), d = u.prefixCls, f = d === void 0 ? "anticon" : d, h = u.rootClassName, p = we(h, f, re(re({}, "".concat(f, "-").concat(r.name), !!r.name), "".concat(f, "-spin"), !!i || r.name === "loading"), n), g = a;
  g === void 0 && s && (g = -1);
  var m = o ? {
    msTransform: "rotate(".concat(o, "deg)"),
    transform: "rotate(".concat(o, "deg)")
  } : void 0, v = OX(c), y = fe(v, 2), S = y[0], _ = y[1];
  return /* @__PURE__ */ I.createElement("span", mt({
    role: "img",
    "aria-label": r.name
  }, l, {
    ref: t,
    tabIndex: g,
    onClick: s,
    className: p
  }), /* @__PURE__ */ I.createElement(b6, {
    icon: r,
    primaryColor: S,
    secondaryColor: _,
    style: m
  }));
});
Qx.displayName = "AntdIcon";
Qx.getTwoToneColor = hAe;
Qx.setTwoToneColor = PX;
const fo = Qx;
var pAe = function(t, n) {
  return /* @__PURE__ */ I.createElement(fo, mt({}, t, {
    ref: n,
    icon: iAe
  }));
}, MX = /* @__PURE__ */ I.forwardRef(pAe);
process.env.NODE_ENV !== "production" && (MX.displayName = "CheckCircleFilled");
const kX = MX;
var mAe = { icon: { tag: "svg", attrs: { "fill-rule": "evenodd", viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M512 64c247.4 0 448 200.6 448 448S759.4 960 512 960 64 759.4 64 512 264.6 64 512 64zm127.98 274.82h-.04l-.08.06L512 466.75 384.14 338.88c-.04-.05-.06-.06-.08-.06a.12.12 0 00-.07 0c-.03 0-.05.01-.09.05l-45.02 45.02a.2.2 0 00-.05.09.12.12 0 000 .07v.02a.27.27 0 00.06.06L466.75 512 338.88 639.86c-.05.04-.06.06-.06.08a.12.12 0 000 .07c0 .03.01.05.05.09l45.02 45.02a.2.2 0 00.09.05.12.12 0 00.07 0c.02 0 .04-.01.08-.05L512 557.25l127.86 127.87c.04.04.06.05.08.05a.12.12 0 00.07 0c.03 0 .05-.01.09-.05l45.02-45.02a.2.2 0 00.05-.09.12.12 0 000-.07v-.02a.27.27 0 00-.05-.06L557.25 512l127.87-127.86c.04-.04.05-.06.05-.08a.12.12 0 000-.07c0-.03-.01-.05-.05-.09l-45.02-45.02a.2.2 0 00-.09-.05.12.12 0 00-.07 0z" } }] }, name: "close-circle", theme: "filled" };
const vAe = mAe;
var yAe = function(t, n) {
  return /* @__PURE__ */ I.createElement(fo, mt({}, t, {
    ref: n,
    icon: vAe
  }));
}, NX = /* @__PURE__ */ I.forwardRef(yAe);
process.env.NODE_ENV !== "production" && (NX.displayName = "CloseCircleFilled");
const Jx = NX;
var bAe = { icon: { tag: "svg", attrs: { "fill-rule": "evenodd", viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M799.86 166.31c.02 0 .04.02.08.06l57.69 57.7c.04.03.05.05.06.08a.12.12 0 010 .06c0 .03-.02.05-.06.09L569.93 512l287.7 287.7c.04.04.05.06.06.09a.12.12 0 010 .07c0 .02-.02.04-.06.08l-57.7 57.69c-.03.04-.05.05-.07.06a.12.12 0 01-.07 0c-.03 0-.05-.02-.09-.06L512 569.93l-287.7 287.7c-.04.04-.06.05-.09.06a.12.12 0 01-.07 0c-.02 0-.04-.02-.08-.06l-57.69-57.7c-.04-.03-.05-.05-.06-.07a.12.12 0 010-.07c0-.03.02-.05.06-.09L454.07 512l-287.7-287.7c-.04-.04-.05-.06-.06-.09a.12.12 0 010-.07c0-.02.02-.04.06-.08l57.7-57.69c.03-.04.05-.05.07-.06a.12.12 0 01.07 0c.03 0 .05.02.09.06L512 454.07l287.7-287.7c.04-.04.06-.05.09-.06a.12.12 0 01.07 0z" } }] }, name: "close", theme: "outlined" };
const _Ae = bAe;
var SAe = function(t, n) {
  return /* @__PURE__ */ I.createElement(fo, mt({}, t, {
    ref: n,
    icon: _Ae
  }));
}, DX = /* @__PURE__ */ I.forwardRef(SAe);
process.env.NODE_ENV !== "production" && (DX.displayName = "CloseOutlined");
const Zx = DX;
var wAe = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm-32 232c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v272c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V296zm32 440a48.01 48.01 0 010-96 48.01 48.01 0 010 96z" } }] }, name: "exclamation-circle", theme: "filled" };
const xAe = wAe;
var EAe = function(t, n) {
  return /* @__PURE__ */ I.createElement(fo, mt({}, t, {
    ref: n,
    icon: xAe
  }));
}, LX = /* @__PURE__ */ I.forwardRef(EAe);
process.env.NODE_ENV !== "production" && (LX.displayName = "ExclamationCircleFilled");
const _6 = LX;
var CAe = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm32 664c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V456c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v272zm-32-344a48.01 48.01 0 010-96 48.01 48.01 0 010 96z" } }] }, name: "info-circle", theme: "filled" };
const TAe = CAe;
var IAe = function(t, n) {
  return /* @__PURE__ */ I.createElement(fo, mt({}, t, {
    ref: n,
    icon: TAe
  }));
}, jX = /* @__PURE__ */ I.forwardRef(IAe);
process.env.NODE_ENV !== "production" && (jX.displayName = "InfoCircleFilled");
const FX = jX;
var AAe = `accept acceptCharset accessKey action allowFullScreen allowTransparency
    alt async autoComplete autoFocus autoPlay capture cellPadding cellSpacing challenge
    charSet checked classID className colSpan cols content contentEditable contextMenu
    controls coords crossOrigin data dateTime default defer dir disabled download draggable
    encType form formAction formEncType formMethod formNoValidate formTarget frameBorder
    headers height hidden high href hrefLang htmlFor httpEquiv icon id inputMode integrity
    is keyParams keyType kind label lang list loop low manifest marginHeight marginWidth max maxLength media
    mediaGroup method min minLength multiple muted name noValidate nonce open
    optimum pattern placeholder poster preload radioGroup readOnly rel required
    reversed role rowSpan rows sandbox scope scoped scrolling seamless selected
    shape size sizes span spellCheck src srcDoc srcLang srcSet start step style
    summary tabIndex target title type useMap value width wmode wrap`, RAe = `onCopy onCut onPaste onCompositionEnd onCompositionStart onCompositionUpdate onKeyDown
    onKeyPress onKeyUp onFocus onBlur onChange onInput onSubmit onClick onContextMenu onDoubleClick
    onDrag onDragEnd onDragEnter onDragExit onDragLeave onDragOver onDragStart onDrop onMouseDown
    onMouseEnter onMouseLeave onMouseMove onMouseOut onMouseOver onMouseUp onSelect onTouchCancel
    onTouchEnd onTouchMove onTouchStart onScroll onWheel onAbort onCanPlay onCanPlayThrough
    onDurationChange onEmptied onEncrypted onEnded onError onLoadedData onLoadedMetadata
    onLoadStart onPause onPlay onPlaying onProgress onRateChange onSeeked onSeeking onStalled onSuspend onTimeUpdate onVolumeChange onWaiting onLoad onError`, $Ae = "".concat(AAe, " ").concat(RAe).split(/[\s\n]+/), OAe = "aria-", PAe = "data-";
function eL(e, t) {
  return e.indexOf(t) === 0;
}
function cf(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1, n;
  t === !1 ? n = {
    aria: !0,
    data: !0,
    attr: !0
  } : t === !0 ? n = {
    aria: !0
  } : n = ae({}, t);
  var r = {};
  return Object.keys(e).forEach(function(i) {
    // Aria
    (n.aria && (i === "role" || eL(i, OAe)) || // Data
    n.data && eL(i, PAe) || // Attr
    n.attr && $Ae.includes(i)) && (r[i] = e[i]);
  }), r;
}
function VX(e) {
  return e && /* @__PURE__ */ D.isValidElement(e) && e.type === D.Fragment;
}
const BX = (e, t, n) => /* @__PURE__ */ D.isValidElement(e) ? /* @__PURE__ */ D.cloneElement(e, typeof n == "function" ? n(e.props || {}) : n) : t;
function Ng(e, t) {
  return BX(e, e, t);
}
const Wb = (e, t, n, r, i) => ({
  background: e,
  border: `${Qe(r.lineWidth)} ${r.lineType} ${t}`,
  [`${i}-icon`]: {
    color: n
  }
}), MAe = (e) => {
  const {
    componentCls: t,
    motionDurationSlow: n,
    marginXS: r,
    marginSM: i,
    fontSize: o,
    fontSizeLG: a,
    lineHeight: s,
    borderRadiusLG: c,
    motionEaseInOutCirc: l,
    withDescriptionIconSize: u,
    colorText: d,
    colorTextHeading: f,
    withDescriptionPadding: h,
    defaultPadding: p
  } = e;
  return {
    [t]: Object.assign(Object.assign({}, va(e)), {
      position: "relative",
      display: "flex",
      alignItems: "center",
      padding: p,
      wordWrap: "break-word",
      borderRadius: c,
      [`&${t}-rtl`]: {
        direction: "rtl"
      },
      [`${t}-content`]: {
        flex: 1,
        minWidth: 0
      },
      [`${t}-icon`]: {
        marginInlineEnd: r,
        lineHeight: 0
      },
      "&-description": {
        display: "none",
        fontSize: o,
        lineHeight: s
      },
      "&-message": {
        color: f
      },
      [`&${t}-motion-leave`]: {
        overflow: "hidden",
        opacity: 1,
        transition: `max-height ${n} ${l}, opacity ${n} ${l},
        padding-top ${n} ${l}, padding-bottom ${n} ${l},
        margin-bottom ${n} ${l}`
      },
      [`&${t}-motion-leave-active`]: {
        maxHeight: 0,
        marginBottom: "0 !important",
        paddingTop: 0,
        paddingBottom: 0,
        opacity: 0
      }
    }),
    [`${t}-with-description`]: {
      alignItems: "flex-start",
      padding: h,
      [`${t}-icon`]: {
        marginInlineEnd: i,
        fontSize: u,
        lineHeight: 0
      },
      [`${t}-message`]: {
        display: "block",
        marginBottom: r,
        color: f,
        fontSize: a
      },
      [`${t}-description`]: {
        display: "block",
        color: d
      }
    },
    [`${t}-banner`]: {
      marginBottom: 0,
      border: "0 !important",
      borderRadius: 0
    }
  };
}, kAe = (e) => {
  const {
    componentCls: t,
    colorSuccess: n,
    colorSuccessBorder: r,
    colorSuccessBg: i,
    colorWarning: o,
    colorWarningBorder: a,
    colorWarningBg: s,
    colorError: c,
    colorErrorBorder: l,
    colorErrorBg: u,
    colorInfo: d,
    colorInfoBorder: f,
    colorInfoBg: h
  } = e;
  return {
    [t]: {
      "&-success": Wb(i, r, n, e, t),
      "&-info": Wb(h, f, d, e, t),
      "&-warning": Wb(s, a, o, e, t),
      "&-error": Object.assign(Object.assign({}, Wb(u, l, c, e, t)), {
        [`${t}-description > pre`]: {
          margin: 0,
          padding: 0
        }
      })
    }
  };
}, NAe = (e) => {
  const {
    componentCls: t,
    iconCls: n,
    motionDurationMid: r,
    marginXS: i,
    fontSizeIcon: o,
    colorIcon: a,
    colorIconHover: s
  } = e;
  return {
    [t]: {
      "&-action": {
        marginInlineStart: i
      },
      [`${t}-close-icon`]: {
        marginInlineStart: i,
        padding: 0,
        overflow: "hidden",
        fontSize: o,
        lineHeight: Qe(o),
        backgroundColor: "transparent",
        border: "none",
        outline: "none",
        cursor: "pointer",
        [`${n}-close`]: {
          color: a,
          transition: `color ${r}`,
          "&:hover": {
            color: s
          }
        }
      },
      "&-close-text": {
        color: a,
        transition: `color ${r}`,
        "&:hover": {
          color: s
        }
      }
    }
  };
}, DAe = (e) => ({
  withDescriptionIconSize: e.fontSizeHeading3,
  defaultPadding: `${e.paddingContentVerticalSM}px 12px`,
  withDescriptionPadding: `${e.paddingMD}px ${e.paddingContentHorizontalLG}px`
}), LAe = qa("Alert", (e) => [MAe(e), kAe(e), NAe(e)], DAe);
var tL = globalThis && globalThis.__rest || function(e, t) {
  var n = {};
  for (var r in e)
    Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var i = 0, r = Object.getOwnPropertySymbols(e); i < r.length; i++)
      t.indexOf(r[i]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[i]) && (n[r[i]] = e[r[i]]);
  return n;
};
const jAe = {
  success: kX,
  info: FX,
  error: Jx,
  warning: _6
}, FAe = (e) => {
  const {
    icon: t,
    prefixCls: n,
    type: r
  } = e, i = jAe[r] || null;
  return t ? BX(t, /* @__PURE__ */ I.createElement("span", {
    className: `${n}-icon`
  }, t), () => ({
    className: we(`${n}-icon`, {
      [t.props.className]: t.props.className
    })
  })) : /* @__PURE__ */ I.createElement(i, {
    className: `${n}-icon`
  });
}, VAe = (e) => {
  const {
    isClosable: t,
    prefixCls: n,
    closeIcon: r,
    handleClose: i,
    ariaProps: o
  } = e, a = r === !0 || r === void 0 ? /* @__PURE__ */ I.createElement(Zx, null) : r;
  return t ? /* @__PURE__ */ I.createElement("button", Object.assign({
    type: "button",
    onClick: i,
    className: `${n}-close-icon`,
    tabIndex: 0
  }, o), a) : null;
}, zX = /* @__PURE__ */ I.forwardRef((e, t) => {
  const {
    description: n,
    prefixCls: r,
    message: i,
    banner: o,
    className: a,
    rootClassName: s,
    style: c,
    onMouseEnter: l,
    onMouseLeave: u,
    onClick: d,
    afterClose: f,
    showIcon: h,
    closable: p,
    closeText: g,
    closeIcon: m,
    action: v,
    id: y
  } = e, S = tL(e, ["description", "prefixCls", "message", "banner", "className", "rootClassName", "style", "onMouseEnter", "onMouseLeave", "onClick", "afterClose", "showIcon", "closable", "closeText", "closeIcon", "action", "id"]), [_, w] = I.useState(!1);
  process.env.NODE_ENV !== "production" && di("Alert").deprecated(!g, "closeText", "closable.closeIcon");
  const T = I.useRef(null);
  I.useImperativeHandle(t, () => ({
    nativeElement: T.current
  }));
  const {
    getPrefixCls: x,
    direction: C,
    alert: E
  } = I.useContext(En), R = x("alert", r), [A, O, $] = LAe(R), N = (Q) => {
    var K;
    w(!0), (K = e.onClose) === null || K === void 0 || K.call(e, Q);
  }, z = I.useMemo(() => e.type !== void 0 ? e.type : o ? "warning" : "info", [e.type, o]), k = I.useMemo(() => typeof p == "object" && p.closeIcon || g ? !0 : typeof p == "boolean" ? p : m !== !1 && m !== null && m !== void 0 ? !0 : !!(E != null && E.closable), [g, m, p, E == null ? void 0 : E.closable]), F = o && h === void 0 ? !0 : h, V = we(R, `${R}-${z}`, {
    [`${R}-with-description`]: !!n,
    [`${R}-no-icon`]: !F,
    [`${R}-banner`]: !!o,
    [`${R}-rtl`]: C === "rtl"
  }, E == null ? void 0 : E.className, a, s, $, O), j = cf(S, {
    aria: !0,
    data: !0
  }), B = I.useMemo(() => {
    var Q, K;
    return typeof p == "object" && p.closeIcon ? p.closeIcon : g || (m !== void 0 ? m : typeof (E == null ? void 0 : E.closable) == "object" && (!((Q = E == null ? void 0 : E.closable) === null || Q === void 0) && Q.closeIcon) ? (K = E == null ? void 0 : E.closable) === null || K === void 0 ? void 0 : K.closeIcon : E == null ? void 0 : E.closeIcon);
  }, [m, p, g, E == null ? void 0 : E.closeIcon]), U = I.useMemo(() => {
    const Q = p ?? (E == null ? void 0 : E.closable);
    return typeof Q == "object" ? tL(Q, ["closeIcon"]) : {};
  }, [p, E == null ? void 0 : E.closable]);
  return A(/* @__PURE__ */ I.createElement(Tf, {
    visible: !_,
    motionName: `${R}-motion`,
    motionAppear: !1,
    motionEnter: !1,
    onLeaveStart: (Q) => ({
      maxHeight: Q.offsetHeight
    }),
    onLeaveEnd: f
  }, (Q, K) => {
    let {
      className: q,
      style: X
    } = Q;
    return /* @__PURE__ */ I.createElement("div", Object.assign({
      id: y,
      ref: Wa(T, K),
      "data-show": !_,
      className: we(V, q),
      style: Object.assign(Object.assign(Object.assign({}, E == null ? void 0 : E.style), c), X),
      onMouseEnter: l,
      onMouseLeave: u,
      onClick: d,
      role: "alert"
    }, j), F ? /* @__PURE__ */ I.createElement(FAe, {
      description: n,
      icon: e.icon,
      prefixCls: R,
      type: z
    }) : null, /* @__PURE__ */ I.createElement("div", {
      className: `${R}-content`
    }, i ? /* @__PURE__ */ I.createElement("div", {
      className: `${R}-message`
    }, i) : null, n ? /* @__PURE__ */ I.createElement("div", {
      className: `${R}-description`
    }, n) : null), v ? /* @__PURE__ */ I.createElement("div", {
      className: `${R}-action`
    }, v) : null, /* @__PURE__ */ I.createElement(VAe, {
      isClosable: k,
      prefixCls: R,
      closeIcon: B,
      handleClose: N,
      ariaProps: U
    }));
  }));
});
process.env.NODE_ENV !== "production" && (zX.displayName = "Alert");
const HX = zX;
function BAe(e, t, n) {
  return t = sf(t), JK(e, zx() ? Reflect.construct(t, n || [], sf(e).constructor) : t.apply(e, n));
}
let zAe = /* @__PURE__ */ function(e) {
  function t() {
    var n;
    return Sr(this, t), n = BAe(this, t, arguments), n.state = {
      error: void 0,
      info: {
        componentStack: ""
      }
    }, n;
  }
  return Rs(t, e), wr(t, [{
    key: "componentDidCatch",
    value: function(r, i) {
      this.setState({
        error: r,
        info: i
      });
    }
  }, {
    key: "render",
    value: function() {
      const {
        message: r,
        description: i,
        id: o,
        children: a
      } = this.props, {
        error: s,
        info: c
      } = this.state, l = (c == null ? void 0 : c.componentStack) || null, u = typeof r > "u" ? (s || "").toString() : r, d = typeof i > "u" ? l : i;
      return s ? /* @__PURE__ */ I.createElement(HX, {
        id: o,
        type: "error",
        message: u,
        description: /* @__PURE__ */ I.createElement("pre", {
          style: {
            fontSize: "0.9em",
            overflowX: "auto"
          }
        }, d)
      }) : a;
    }
  }]);
}(I.Component);
const HAe = zAe, UX = HX;
UX.ErrorBoundary = HAe;
const UAe = UX, WAe = (e) => {
  const [, , , , t] = $s();
  return t ? `${e}-css-var` : "";
}, If = WAe;
var Ae = {
  /**
   * MAC_ENTER
   */
  MAC_ENTER: 3,
  /**
   * BACKSPACE
   */
  BACKSPACE: 8,
  /**
   * TAB
   */
  TAB: 9,
  /**
   * NUMLOCK on FF/Safari Mac
   */
  NUM_CENTER: 12,
  // NUMLOCK on FF/Safari Mac
  /**
   * ENTER
   */
  ENTER: 13,
  /**
   * SHIFT
   */
  SHIFT: 16,
  /**
   * CTRL
   */
  CTRL: 17,
  /**
   * ALT
   */
  ALT: 18,
  /**
   * PAUSE
   */
  PAUSE: 19,
  /**
   * CAPS_LOCK
   */
  CAPS_LOCK: 20,
  /**
   * ESC
   */
  ESC: 27,
  /**
   * SPACE
   */
  SPACE: 32,
  /**
   * PAGE_UP
   */
  PAGE_UP: 33,
  // also NUM_NORTH_EAST
  /**
   * PAGE_DOWN
   */
  PAGE_DOWN: 34,
  // also NUM_SOUTH_EAST
  /**
   * END
   */
  END: 35,
  // also NUM_SOUTH_WEST
  /**
   * HOME
   */
  HOME: 36,
  // also NUM_NORTH_WEST
  /**
   * LEFT
   */
  LEFT: 37,
  // also NUM_WEST
  /**
   * UP
   */
  UP: 38,
  // also NUM_NORTH
  /**
   * RIGHT
   */
  RIGHT: 39,
  // also NUM_EAST
  /**
   * DOWN
   */
  DOWN: 40,
  // also NUM_SOUTH
  /**
   * PRINT_SCREEN
   */
  PRINT_SCREEN: 44,
  /**
   * INSERT
   */
  INSERT: 45,
  // also NUM_INSERT
  /**
   * DELETE
   */
  DELETE: 46,
  // also NUM_DELETE
  /**
   * ZERO
   */
  ZERO: 48,
  /**
   * ONE
   */
  ONE: 49,
  /**
   * TWO
   */
  TWO: 50,
  /**
   * THREE
   */
  THREE: 51,
  /**
   * FOUR
   */
  FOUR: 52,
  /**
   * FIVE
   */
  FIVE: 53,
  /**
   * SIX
   */
  SIX: 54,
  /**
   * SEVEN
   */
  SEVEN: 55,
  /**
   * EIGHT
   */
  EIGHT: 56,
  /**
   * NINE
   */
  NINE: 57,
  /**
   * QUESTION_MARK
   */
  QUESTION_MARK: 63,
  // needs localization
  /**
   * A
   */
  A: 65,
  /**
   * B
   */
  B: 66,
  /**
   * C
   */
  C: 67,
  /**
   * D
   */
  D: 68,
  /**
   * E
   */
  E: 69,
  /**
   * F
   */
  F: 70,
  /**
   * G
   */
  G: 71,
  /**
   * H
   */
  H: 72,
  /**
   * I
   */
  I: 73,
  /**
   * J
   */
  J: 74,
  /**
   * K
   */
  K: 75,
  /**
   * L
   */
  L: 76,
  /**
   * M
   */
  M: 77,
  /**
   * N
   */
  N: 78,
  /**
   * O
   */
  O: 79,
  /**
   * P
   */
  P: 80,
  /**
   * Q
   */
  Q: 81,
  /**
   * R
   */
  R: 82,
  /**
   * S
   */
  S: 83,
  /**
   * T
   */
  T: 84,
  /**
   * U
   */
  U: 85,
  /**
   * V
   */
  V: 86,
  /**
   * W
   */
  W: 87,
  /**
   * X
   */
  X: 88,
  /**
   * Y
   */
  Y: 89,
  /**
   * Z
   */
  Z: 90,
  /**
   * META
   */
  META: 91,
  // WIN_KEY_LEFT
  /**
   * WIN_KEY_RIGHT
   */
  WIN_KEY_RIGHT: 92,
  /**
   * CONTEXT_MENU
   */
  CONTEXT_MENU: 93,
  /**
   * NUM_ZERO
   */
  NUM_ZERO: 96,
  /**
   * NUM_ONE
   */
  NUM_ONE: 97,
  /**
   * NUM_TWO
   */
  NUM_TWO: 98,
  /**
   * NUM_THREE
   */
  NUM_THREE: 99,
  /**
   * NUM_FOUR
   */
  NUM_FOUR: 100,
  /**
   * NUM_FIVE
   */
  NUM_FIVE: 101,
  /**
   * NUM_SIX
   */
  NUM_SIX: 102,
  /**
   * NUM_SEVEN
   */
  NUM_SEVEN: 103,
  /**
   * NUM_EIGHT
   */
  NUM_EIGHT: 104,
  /**
   * NUM_NINE
   */
  NUM_NINE: 105,
  /**
   * NUM_MULTIPLY
   */
  NUM_MULTIPLY: 106,
  /**
   * NUM_PLUS
   */
  NUM_PLUS: 107,
  /**
   * NUM_MINUS
   */
  NUM_MINUS: 109,
  /**
   * NUM_PERIOD
   */
  NUM_PERIOD: 110,
  /**
   * NUM_DIVISION
   */
  NUM_DIVISION: 111,
  /**
   * F1
   */
  F1: 112,
  /**
   * F2
   */
  F2: 113,
  /**
   * F3
   */
  F3: 114,
  /**
   * F4
   */
  F4: 115,
  /**
   * F5
   */
  F5: 116,
  /**
   * F6
   */
  F6: 117,
  /**
   * F7
   */
  F7: 118,
  /**
   * F8
   */
  F8: 119,
  /**
   * F9
   */
  F9: 120,
  /**
   * F10
   */
  F10: 121,
  /**
   * F11
   */
  F11: 122,
  /**
   * F12
   */
  F12: 123,
  /**
   * NUMLOCK
   */
  NUMLOCK: 144,
  /**
   * SEMICOLON
   */
  SEMICOLON: 186,
  // needs localization
  /**
   * DASH
   */
  DASH: 189,
  // needs localization
  /**
   * EQUALS
   */
  EQUALS: 187,
  // needs localization
  /**
   * COMMA
   */
  COMMA: 188,
  // needs localization
  /**
   * PERIOD
   */
  PERIOD: 190,
  // needs localization
  /**
   * SLASH
   */
  SLASH: 191,
  // needs localization
  /**
   * APOSTROPHE
   */
  APOSTROPHE: 192,
  // needs localization
  /**
   * SINGLE_QUOTE
   */
  SINGLE_QUOTE: 222,
  // needs localization
  /**
   * OPEN_SQUARE_BRACKET
   */
  OPEN_SQUARE_BRACKET: 219,
  // needs localization
  /**
   * BACKSLASH
   */
  BACKSLASH: 220,
  // needs localization
  /**
   * CLOSE_SQUARE_BRACKET
   */
  CLOSE_SQUARE_BRACKET: 221,
  // needs localization
  /**
   * WIN_KEY
   */
  WIN_KEY: 224,
  /**
   * MAC_FF_META
   */
  MAC_FF_META: 224,
  // Firefox (Gecko) fires this for the meta key instead of 91
  /**
   * WIN_IME
   */
  WIN_IME: 229,
  // ======================== Function ========================
  /**
   * whether text and modified key is entered at the same time.
   */
  isTextModifyingKeyEvent: function(t) {
    var n = t.keyCode;
    if (t.altKey && !t.ctrlKey || t.metaKey || // Function keys don't generate text
    n >= Ae.F1 && n <= Ae.F12)
      return !1;
    switch (n) {
      case Ae.ALT:
      case Ae.CAPS_LOCK:
      case Ae.CONTEXT_MENU:
      case Ae.CTRL:
      case Ae.DOWN:
      case Ae.END:
      case Ae.ESC:
      case Ae.HOME:
      case Ae.INSERT:
      case Ae.LEFT:
      case Ae.MAC_FF_META:
      case Ae.META:
      case Ae.NUMLOCK:
      case Ae.NUM_CENTER:
      case Ae.PAGE_DOWN:
      case Ae.PAGE_UP:
      case Ae.PAUSE:
      case Ae.PRINT_SCREEN:
      case Ae.RIGHT:
      case Ae.SHIFT:
      case Ae.UP:
      case Ae.WIN_KEY:
      case Ae.WIN_KEY_RIGHT:
        return !1;
      default:
        return !0;
    }
  },
  /**
   * whether character is entered.
   */
  isCharacterKey: function(t) {
    if (t >= Ae.ZERO && t <= Ae.NINE || t >= Ae.NUM_ZERO && t <= Ae.NUM_MULTIPLY || t >= Ae.A && t <= Ae.Z || window.navigator.userAgent.indexOf("WebKit") !== -1 && t === 0)
      return !0;
    switch (t) {
      case Ae.SPACE:
      case Ae.QUESTION_MARK:
      case Ae.NUM_PLUS:
      case Ae.NUM_MINUS:
      case Ae.NUM_PERIOD:
      case Ae.NUM_DIVISION:
      case Ae.SEMICOLON:
      case Ae.DASH:
      case Ae.EQUALS:
      case Ae.COMMA:
      case Ae.PERIOD:
      case Ae.SLASH:
      case Ae.APOSTROPHE:
      case Ae.SINGLE_QUOTE:
      case Ae.OPEN_SQUARE_BRACKET:
      case Ae.BACKSLASH:
      case Ae.CLOSE_SQUARE_BRACKET:
        return !0;
      default:
        return !1;
    }
  }
}, WX = /* @__PURE__ */ I.forwardRef(function(e, t) {
  var n = e.prefixCls, r = e.style, i = e.className, o = e.duration, a = o === void 0 ? 4.5 : o, s = e.showProgress, c = e.pauseOnHover, l = c === void 0 ? !0 : c, u = e.eventKey, d = e.content, f = e.closable, h = e.closeIcon, p = h === void 0 ? "x" : h, g = e.props, m = e.onClick, v = e.onNoticeClose, y = e.times, S = e.hovering, _ = I.useState(!1), w = fe(_, 2), T = w[0], x = w[1], C = I.useState(0), E = fe(C, 2), R = E[0], A = E[1], O = I.useState(0), $ = fe(O, 2), N = $[0], z = $[1], k = S || T, F = a > 0 && s, V = function() {
    v(u);
  }, j = function(X) {
    (X.key === "Enter" || X.code === "Enter" || X.keyCode === Ae.ENTER) && V();
  };
  I.useEffect(function() {
    if (!k && a > 0) {
      var q = Date.now() - N, X = setTimeout(function() {
        V();
      }, a * 1e3 - N);
      return function() {
        l && clearTimeout(X), z(Date.now() - q);
      };
    }
  }, [a, k, y]), I.useEffect(function() {
    if (!k && F && (l || N === 0)) {
      var q = performance.now(), X, ie = function te() {
        cancelAnimationFrame(X), X = requestAnimationFrame(function(J) {
          var Y = J + N - q, ee = Math.min(Y / (a * 1e3), 1);
          A(ee * 100), ee < 1 && te();
        });
      };
      return ie(), function() {
        l && cancelAnimationFrame(X);
      };
    }
  }, [a, N, k, F, y]);
  var B = I.useMemo(function() {
    return _t(f) === "object" && f !== null ? f : f ? {
      closeIcon: p
    } : {};
  }, [f, p]), U = cf(B, !0), Q = 100 - (!R || R < 0 ? 0 : R > 100 ? 100 : R), K = "".concat(n, "-notice");
  return /* @__PURE__ */ I.createElement("div", mt({}, g, {
    ref: t,
    className: we(K, i, re({}, "".concat(K, "-closable"), f)),
    style: r,
    onMouseEnter: function(X) {
      var ie;
      x(!0), g == null || (ie = g.onMouseEnter) === null || ie === void 0 || ie.call(g, X);
    },
    onMouseLeave: function(X) {
      var ie;
      x(!1), g == null || (ie = g.onMouseLeave) === null || ie === void 0 || ie.call(g, X);
    },
    onClick: m
  }), /* @__PURE__ */ I.createElement("div", {
    className: "".concat(K, "-content")
  }, d), f && /* @__PURE__ */ I.createElement("a", mt({
    tabIndex: 0,
    className: "".concat(K, "-close"),
    onKeyDown: j,
    "aria-label": "Close"
  }, U, {
    onClick: function(X) {
      X.preventDefault(), X.stopPropagation(), V();
    }
  }), B.closeIcon), F && /* @__PURE__ */ I.createElement("progress", {
    className: "".concat(K, "-progress"),
    max: "100",
    value: Q
  }, Q + "%"));
}), qX = /* @__PURE__ */ D.createContext({}), qAe = function(t) {
  var n = t.children, r = t.classNames;
  return /* @__PURE__ */ D.createElement(qX.Provider, {
    value: {
      classNames: r
    }
  }, n);
}, nL = 8, rL = 3, iL = 16, GAe = function(t) {
  var n = {
    offset: nL,
    threshold: rL,
    gap: iL
  };
  if (t && _t(t) === "object") {
    var r, i, o;
    n.offset = (r = t.offset) !== null && r !== void 0 ? r : nL, n.threshold = (i = t.threshold) !== null && i !== void 0 ? i : rL, n.gap = (o = t.gap) !== null && o !== void 0 ? o : iL;
  }
  return [!!t, n];
}, KAe = ["className", "style", "classNames", "styles"], GX = function(t) {
  var n = t.configList, r = t.placement, i = t.prefixCls, o = t.className, a = t.style, s = t.motion, c = t.onAllNoticeRemoved, l = t.onNoticeClose, u = t.stack, d = St(qX), f = d.classNames, h = Me({}), p = Lt(null), g = fe(p, 2), m = g[0], v = g[1], y = Lt([]), S = fe(y, 2), _ = S[0], w = S[1], T = n.map(function(k) {
    return {
      config: k,
      key: String(k.key)
    };
  }), x = GAe(u), C = fe(x, 2), E = C[0], R = C[1], A = R.offset, O = R.threshold, $ = R.gap, N = E && (_.length > 0 || T.length <= O), z = typeof s == "function" ? s(r) : s;
  return gt(function() {
    E && _.length > 1 && w(function(k) {
      return k.filter(function(F) {
        return T.some(function(V) {
          var j = V.key;
          return F === j;
        });
      });
    });
  }, [_, T, E]), gt(function() {
    var k;
    if (E && h.current[(k = T[T.length - 1]) === null || k === void 0 ? void 0 : k.key]) {
      var F;
      v(h.current[(F = T[T.length - 1]) === null || F === void 0 ? void 0 : F.key]);
    }
  }, [T, E]), /* @__PURE__ */ D.createElement(xX, mt({
    key: r,
    className: we(i, "".concat(i, "-").concat(r), f == null ? void 0 : f.list, o, re(re({}, "".concat(i, "-stack"), !!E), "".concat(i, "-stack-expanded"), N)),
    style: a,
    keys: T,
    motionAppear: !0
  }, z, {
    onAllRemoved: function() {
      c(r);
    }
  }), function(k, F) {
    var V = k.config, j = k.className, B = k.style, U = k.index, Q = V, K = Q.key, q = Q.times, X = String(K), ie = V, te = ie.className, J = ie.style, Y = ie.classNames, ee = ie.styles, Z = xn(ie, KAe), H = T.findIndex(function(be) {
      return be.key === X;
    }), oe = {};
    if (E) {
      var W = T.length - 1 - (H > -1 ? H : U - 1), se = r === "top" || r === "bottom" ? "-50%" : "0";
      if (W > 0) {
        var ce, ge, he;
        oe.height = N ? (ce = h.current[X]) === null || ce === void 0 ? void 0 : ce.offsetHeight : m == null ? void 0 : m.offsetHeight;
        for (var ue = 0, Ee = 0; Ee < W; Ee++) {
          var pe;
          ue += ((pe = h.current[T[T.length - 1 - Ee].key]) === null || pe === void 0 ? void 0 : pe.offsetHeight) + $;
        }
        var Oe = (N ? ue : W * A) * (r.startsWith("top") ? 1 : -1), de = !N && m !== null && m !== void 0 && m.offsetWidth && (ge = h.current[X]) !== null && ge !== void 0 && ge.offsetWidth ? ((m == null ? void 0 : m.offsetWidth) - A * 2 * (W < 3 ? W : 3)) / ((he = h.current[X]) === null || he === void 0 ? void 0 : he.offsetWidth) : 1;
        oe.transform = "translate3d(".concat(se, ", ").concat(Oe, "px, 0) scaleX(").concat(de, ")");
      } else
        oe.transform = "translate3d(".concat(se, ", 0, 0)");
    }
    return /* @__PURE__ */ D.createElement("div", {
      ref: F,
      className: we("".concat(i, "-notice-wrapper"), j, Y == null ? void 0 : Y.wrapper),
      style: ae(ae(ae({}, B), oe), ee == null ? void 0 : ee.wrapper),
      onMouseEnter: function() {
        return w(function(Ie) {
          return Ie.includes(X) ? Ie : [].concat(Je(Ie), [X]);
        });
      },
      onMouseLeave: function() {
        return w(function(Ie) {
          return Ie.filter(function(Ve) {
            return Ve !== X;
          });
        });
      }
    }, /* @__PURE__ */ D.createElement(WX, mt({}, Z, {
      ref: function(Ie) {
        H > -1 ? h.current[X] = Ie : delete h.current[X];
      },
      prefixCls: i,
      classNames: Y,
      styles: ee,
      className: we(te, f == null ? void 0 : f.notice),
      style: J,
      times: q,
      key: K,
      eventKey: K,
      onNoticeClose: l,
      hovering: E && _.length > 0
    })));
  });
};
process.env.NODE_ENV !== "production" && (GX.displayName = "NoticeList");
var KX = /* @__PURE__ */ I.forwardRef(function(e, t) {
  var n = e.prefixCls, r = n === void 0 ? "rc-notification" : n, i = e.container, o = e.motion, a = e.maxCount, s = e.className, c = e.style, l = e.onAllRemoved, u = e.stack, d = e.renderNotifications, f = I.useState([]), h = fe(f, 2), p = h[0], g = h[1], m = function(E) {
    var R, A = p.find(function(O) {
      return O.key === E;
    });
    A == null || (R = A.onClose) === null || R === void 0 || R.call(A), g(function(O) {
      return O.filter(function($) {
        return $.key !== E;
      });
    });
  };
  I.useImperativeHandle(t, function() {
    return {
      open: function(E) {
        g(function(R) {
          var A = Je(R), O = A.findIndex(function(z) {
            return z.key === E.key;
          }), $ = ae({}, E);
          if (O >= 0) {
            var N;
            $.times = (((N = R[O]) === null || N === void 0 ? void 0 : N.times) || 0) + 1, A[O] = $;
          } else
            $.times = 0, A.push($);
          return a > 0 && A.length > a && (A = A.slice(-a)), A;
        });
      },
      close: function(E) {
        m(E);
      },
      destroy: function() {
        g([]);
      }
    };
  });
  var v = I.useState({}), y = fe(v, 2), S = y[0], _ = y[1];
  I.useEffect(function() {
    var C = {};
    p.forEach(function(E) {
      var R = E.placement, A = R === void 0 ? "topRight" : R;
      A && (C[A] = C[A] || [], C[A].push(E));
    }), Object.keys(S).forEach(function(E) {
      C[E] = C[E] || [];
    }), _(C);
  }, [p]);
  var w = function(E) {
    _(function(R) {
      var A = ae({}, R), O = A[E] || [];
      return O.length || delete A[E], A;
    });
  }, T = I.useRef(!1);
  if (I.useEffect(function() {
    Object.keys(S).length > 0 ? T.current = !0 : T.current && (l == null || l(), T.current = !1);
  }, [S]), !i)
    return null;
  var x = Object.keys(S);
  return /* @__PURE__ */ rO(/* @__PURE__ */ I.createElement(I.Fragment, null, x.map(function(C) {
    var E = S[C], R = /* @__PURE__ */ I.createElement(GX, {
      key: C,
      configList: E,
      placement: C,
      prefixCls: r,
      className: s == null ? void 0 : s(C),
      style: c == null ? void 0 : c(C),
      motion: o,
      onNoticeClose: m,
      onAllNoticeRemoved: w,
      stack: u
    });
    return d ? d(R, {
      prefixCls: r,
      key: C
    }) : R;
  })), i);
});
process.env.NODE_ENV !== "production" && (KX.displayName = "Notifications");
var YAe = ["getContainer", "motion", "prefixCls", "maxCount", "className", "style", "onAllRemoved", "stack", "renderNotifications"], XAe = function() {
  return document.body;
}, oL = 0;
function QAe() {
  for (var e = {}, t = arguments.length, n = new Array(t), r = 0; r < t; r++)
    n[r] = arguments[r];
  return n.forEach(function(i) {
    i && Object.keys(i).forEach(function(o) {
      var a = i[o];
      a !== void 0 && (e[o] = a);
    });
  }), e;
}
function JAe() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, t = e.getContainer, n = t === void 0 ? XAe : t, r = e.motion, i = e.prefixCls, o = e.maxCount, a = e.className, s = e.style, c = e.onAllRemoved, l = e.stack, u = e.renderNotifications, d = xn(e, YAe), f = I.useState(), h = fe(f, 2), p = h[0], g = h[1], m = I.useRef(), v = /* @__PURE__ */ I.createElement(KX, {
    container: p,
    ref: m,
    prefixCls: i,
    motion: r,
    maxCount: o,
    className: a,
    style: s,
    onAllRemoved: c,
    stack: l,
    renderNotifications: u
  }), y = I.useState([]), S = fe(y, 2), _ = S[0], w = S[1], T = I.useMemo(function() {
    return {
      open: function(C) {
        var E = QAe(d, C);
        (E.key === null || E.key === void 0) && (E.key = "rc-notification-".concat(oL), oL += 1), w(function(R) {
          return [].concat(Je(R), [{
            type: "open",
            config: E
          }]);
        });
      },
      close: function(C) {
        w(function(E) {
          return [].concat(Je(E), [{
            type: "close",
            key: C
          }]);
        });
      },
      destroy: function() {
        w(function(C) {
          return [].concat(Je(C), [{
            type: "destroy"
          }]);
        });
      }
    };
  }, []);
  return I.useEffect(function() {
    g(n());
  }), I.useEffect(function() {
    m.current && _.length && (_.forEach(function(x) {
      switch (x.type) {
        case "open":
          m.current.open(x.config);
          break;
        case "close":
          m.current.close(x.key);
          break;
        case "destroy":
          m.current.destroy();
          break;
      }
    }), w(function(x) {
      return x.filter(function(C) {
        return !_.includes(C);
      });
    }));
  }, [_]), [T, v];
}
var ZAe = { icon: { tag: "svg", attrs: { viewBox: "0 0 1024 1024", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M988 548c-19.9 0-36-16.1-36-36 0-59.4-11.6-117-34.6-171.3a440.45 440.45 0 00-94.3-139.9 437.71 437.71 0 00-139.9-94.3C629 83.6 571.4 72 512 72c-19.9 0-36-16.1-36-36s16.1-36 36-36c69.1 0 136.2 13.5 199.3 40.3C772.3 66 827 103 874 150c47 47 83.9 101.8 109.7 162.7 26.7 63.1 40.2 130.2 40.2 199.3.1 19.9-16 36-35.9 36z" } }] }, name: "loading", theme: "outlined" };
const eRe = ZAe;
var tRe = function(t, n) {
  return /* @__PURE__ */ I.createElement(fo, mt({}, t, {
    ref: n,
    icon: eRe
  }));
}, YX = /* @__PURE__ */ I.forwardRef(tRe);
process.env.NODE_ENV !== "production" && (YX.displayName = "LoadingOutlined");
const S6 = YX, XX = /* @__PURE__ */ D.createContext(void 0);
process.env.NODE_ENV !== "production" && (XX.displayName = "zIndexContext");
const QX = XX, Lc = 100, nRe = 10, JX = Lc * nRe, rRe = JX + Lc, ZX = {
  Modal: Lc,
  Drawer: Lc,
  Popover: Lc,
  Popconfirm: Lc,
  Tooltip: Lc,
  Tour: Lc,
  FloatButton: Lc
}, iRe = {
  SelectLike: 50,
  Dropdown: 50,
  DatePicker: 50,
  Menu: 50,
  ImagePreview: 1
};
function oRe(e) {
  return e in ZX;
}
const eQ = (e, t) => {
  const [, n] = $s(), r = D.useContext(QX), i = oRe(e);
  let o;
  if (t !== void 0)
    o = [t, t];
  else {
    let a = r ?? 0;
    i ? a += // Use preset token zIndex by default but not stack when has parent container
    (r ? 0 : n.zIndexPopupBase) + // Container offset
    ZX[e] : a += iRe[e], o = [r === void 0 ? t : a, a];
  }
  if (process.env.NODE_ENV !== "production") {
    const a = di(e), s = n.zIndexPopupBase + rRe, c = o[0] || 0;
    process.env.NODE_ENV !== "production" && a(t !== void 0 || c <= s, "usage", "`zIndex` is over design token `zIndexPopupBase` too much. It may cause unexpected override.");
  }
  return o;
}, aRe = (e) => {
  const {
    componentCls: t,
    iconCls: n,
    boxShadow: r,
    colorText: i,
    colorSuccess: o,
    colorError: a,
    colorWarning: s,
    colorInfo: c,
    fontSizeLG: l,
    motionEaseInOutCirc: u,
    motionDurationSlow: d,
    marginXS: f,
    paddingXS: h,
    borderRadiusLG: p,
    zIndexPopup: g,
    // Custom token
    contentPadding: m,
    contentBg: v
  } = e, y = `${t}-notice`, S = new $n("MessageMoveIn", {
    "0%": {
      padding: 0,
      transform: "translateY(-100%)",
      opacity: 0
    },
    "100%": {
      padding: h,
      transform: "translateY(0)",
      opacity: 1
    }
  }), _ = new $n("MessageMoveOut", {
    "0%": {
      maxHeight: e.height,
      padding: h,
      opacity: 1
    },
    "100%": {
      maxHeight: 0,
      padding: 0,
      opacity: 0
    }
  }), w = {
    padding: h,
    textAlign: "center",
    [`${t}-custom-content`]: {
      display: "flex",
      alignItems: "center"
    },
    [`${t}-custom-content > ${n}`]: {
      marginInlineEnd: f,
      // affected by ltr or rtl
      fontSize: l
    },
    [`${y}-content`]: {
      display: "inline-block",
      padding: m,
      background: v,
      borderRadius: p,
      boxShadow: r,
      pointerEvents: "all"
    },
    [`${t}-success > ${n}`]: {
      color: o
    },
    [`${t}-error > ${n}`]: {
      color: a
    },
    [`${t}-warning > ${n}`]: {
      color: s
    },
    [`${t}-info > ${n},
      ${t}-loading > ${n}`]: {
      color: c
    }
  };
  return [
    // ============================ Holder ============================
    {
      [t]: Object.assign(Object.assign({}, va(e)), {
        color: i,
        position: "fixed",
        top: f,
        width: "100%",
        pointerEvents: "none",
        zIndex: g,
        [`${t}-move-up`]: {
          animationFillMode: "forwards"
        },
        [`
        ${t}-move-up-appear,
        ${t}-move-up-enter
      `]: {
          animationName: S,
          animationDuration: d,
          animationPlayState: "paused",
          animationTimingFunction: u
        },
        [`
        ${t}-move-up-appear${t}-move-up-appear-active,
        ${t}-move-up-enter${t}-move-up-enter-active
      `]: {
          animationPlayState: "running"
        },
        [`${t}-move-up-leave`]: {
          animationName: _,
          animationDuration: d,
          animationPlayState: "paused",
          animationTimingFunction: u
        },
        [`${t}-move-up-leave${t}-move-up-leave-active`]: {
          animationPlayState: "running"
        },
        "&-rtl": {
          direction: "rtl",
          span: {
            direction: "rtl"
          }
        }
      })
    },
    // ============================ Notice ============================
    {
      [t]: {
        [`${y}-wrapper`]: Object.assign({}, w)
      }
    },
    // ============================= Pure =============================
    {
      [`${t}-notice-pure-panel`]: Object.assign(Object.assign({}, w), {
        padding: 0,
        textAlign: "start"
      })
    }
  ];
}, sRe = (e) => ({
  zIndexPopup: e.zIndexPopupBase + JX + 10,
  contentBg: e.colorBgElevated,
  contentPadding: `${(e.controlHeightLG - e.fontSize * e.lineHeight) / 2}px ${e.paddingSM}px`
}), tQ = qa("Message", (e) => {
  const t = Or(e, {
    height: 150
  });
  return [aRe(t)];
}, sRe);
var cRe = globalThis && globalThis.__rest || function(e, t) {
  var n = {};
  for (var r in e)
    Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var i = 0, r = Object.getOwnPropertySymbols(e); i < r.length; i++)
      t.indexOf(r[i]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[i]) && (n[r[i]] = e[r[i]]);
  return n;
};
const lRe = {
  info: /* @__PURE__ */ I.createElement(FX, null),
  success: /* @__PURE__ */ I.createElement(kX, null),
  error: /* @__PURE__ */ I.createElement(Jx, null),
  warning: /* @__PURE__ */ I.createElement(_6, null),
  loading: /* @__PURE__ */ I.createElement(S6, null)
}, nQ = (e) => {
  let {
    prefixCls: t,
    type: n,
    icon: r,
    children: i
  } = e;
  return /* @__PURE__ */ I.createElement("div", {
    className: we(`${t}-custom-content`, `${t}-${n}`)
  }, r || lRe[n], /* @__PURE__ */ I.createElement("span", null, i));
}, uRe = (e) => {
  const {
    prefixCls: t,
    className: n,
    type: r,
    icon: i,
    content: o
  } = e, a = cRe(e, ["prefixCls", "className", "type", "icon", "content"]), {
    getPrefixCls: s
  } = I.useContext(En), c = t || s("message"), l = If(c), [u, d, f] = tQ(c, l);
  return u(/* @__PURE__ */ I.createElement(WX, Object.assign({}, a, {
    prefixCls: c,
    className: we(n, d, `${c}-notice-pure-panel`, f, l),
    eventKey: "pure",
    duration: null,
    content: /* @__PURE__ */ I.createElement(nQ, {
      prefixCls: c,
      type: r,
      icon: i
    }, o)
  })));
}, dRe = uRe;
function fRe(e, t) {
  return {
    motionName: t ?? `${e}-move-up`
  };
}
function w6(e) {
  let t;
  const n = new Promise((i) => {
    t = e(() => {
      i(!0);
    });
  }), r = () => {
    t == null || t();
  };
  return r.then = (i, o) => n.then(i, o), r.promise = n, r;
}
var hRe = globalThis && globalThis.__rest || function(e, t) {
  var n = {};
  for (var r in e)
    Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var i = 0, r = Object.getOwnPropertySymbols(e); i < r.length; i++)
      t.indexOf(r[i]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[i]) && (n[r[i]] = e[r[i]]);
  return n;
};
const gRe = 8, pRe = 3, mRe = (e) => {
  let {
    children: t,
    prefixCls: n
  } = e;
  const r = If(n), [i, o, a] = tQ(n, r);
  return i(/* @__PURE__ */ I.createElement(qAe, {
    classNames: {
      list: we(o, a, r)
    }
  }, t));
}, vRe = (e, t) => {
  let {
    prefixCls: n,
    key: r
  } = t;
  return /* @__PURE__ */ I.createElement(mRe, {
    prefixCls: n,
    key: r
  }, e);
}, yRe = /* @__PURE__ */ I.forwardRef((e, t) => {
  const {
    top: n,
    prefixCls: r,
    getContainer: i,
    maxCount: o,
    duration: a = pRe,
    rtl: s,
    transitionName: c,
    onAllRemoved: l
  } = e, {
    getPrefixCls: u,
    getPopupContainer: d,
    message: f,
    direction: h
  } = I.useContext(En), p = r || u("message"), g = () => ({
    left: "50%",
    transform: "translateX(-50%)",
    top: n ?? gRe
  }), m = () => we({
    [`${p}-rtl`]: s ?? h === "rtl"
  }), v = () => fRe(p, c), y = /* @__PURE__ */ I.createElement("span", {
    className: `${p}-close-x`
  }, /* @__PURE__ */ I.createElement(Zx, {
    className: `${p}-close-icon`
  })), [S, _] = JAe({
    prefixCls: p,
    style: g,
    className: m,
    motion: v,
    closable: !1,
    closeIcon: y,
    duration: a,
    getContainer: () => (i == null ? void 0 : i()) || (d == null ? void 0 : d()) || document.body,
    maxCount: o,
    onAllRemoved: l,
    renderNotifications: vRe
  });
  return I.useImperativeHandle(t, () => Object.assign(Object.assign({}, S), {
    prefixCls: p,
    message: f
  })), _;
});
let aL = 0;
function rQ(e) {
  const t = I.useRef(null), n = di("Message");
  return [I.useMemo(() => {
    const i = (l) => {
      var u;
      (u = t.current) === null || u === void 0 || u.close(l);
    }, o = (l) => {
      if (!t.current) {
        process.env.NODE_ENV !== "production" && n(!1, "usage", "You are calling notice in render which will break in React 18 concurrent mode. Please trigger in effect instead.");
        const x = () => {
        };
        return x.then = () => {
        }, x;
      }
      const {
        open: u,
        prefixCls: d,
        message: f
      } = t.current, h = `${d}-notice`, {
        content: p,
        icon: g,
        type: m,
        key: v,
        className: y,
        style: S,
        onClose: _
      } = l, w = hRe(l, ["content", "icon", "type", "key", "className", "style", "onClose"]);
      let T = v;
      return T == null && (aL += 1, T = `antd-message-${aL}`), w6((x) => (u(Object.assign(Object.assign({}, w), {
        key: T,
        content: /* @__PURE__ */ I.createElement(nQ, {
          prefixCls: d,
          type: m,
          icon: g
        }, p),
        placement: "top",
        className: we(m && `${h}-${m}`, y, f == null ? void 0 : f.className),
        style: Object.assign(Object.assign({}, f == null ? void 0 : f.style), S),
        onClose: () => {
          _ == null || _(), x();
        }
      })), () => {
        i(T);
      }));
    }, s = {
      open: o,
      destroy: (l) => {
        var u;
        l !== void 0 ? i(l) : (u = t.current) === null || u === void 0 || u.destroy();
      }
    };
    return ["info", "success", "warning", "error", "loading"].forEach((l) => {
      const u = (d, f, h) => {
        let p;
        d && typeof d == "object" && "content" in d ? p = d : p = {
          content: d
        };
        let g, m;
        typeof f == "function" ? m = f : (g = f, m = h);
        const v = Object.assign(Object.assign({
          onClose: m,
          duration: g
        }, p), {
          type: l
        });
        return o(v);
      };
      s[l] = u;
    }), s;
  }, []), /* @__PURE__ */ I.createElement(yRe, Object.assign({
    key: "message-holder"
  }, e, {
    ref: t
  }))];
}
function bRe(e) {
  return rQ(e);
}
function Po() {
  Po = function() {
    return t;
  };
  var e, t = {}, n = Object.prototype, r = n.hasOwnProperty, i = Object.defineProperty || function(k, F, V) {
    k[F] = V.value;
  }, o = typeof Symbol == "function" ? Symbol : {}, a = o.iterator || "@@iterator", s = o.asyncIterator || "@@asyncIterator", c = o.toStringTag || "@@toStringTag";
  function l(k, F, V) {
    return Object.defineProperty(k, F, {
      value: V,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }), k[F];
  }
  try {
    l({}, "");
  } catch {
    l = function(V, j, B) {
      return V[j] = B;
    };
  }
  function u(k, F, V, j) {
    var B = F && F.prototype instanceof v ? F : v, U = Object.create(B.prototype), Q = new N(j || []);
    return i(U, "_invoke", {
      value: R(k, V, Q)
    }), U;
  }
  function d(k, F, V) {
    try {
      return {
        type: "normal",
        arg: k.call(F, V)
      };
    } catch (j) {
      return {
        type: "throw",
        arg: j
      };
    }
  }
  t.wrap = u;
  var f = "suspendedStart", h = "suspendedYield", p = "executing", g = "completed", m = {};
  function v() {
  }
  function y() {
  }
  function S() {
  }
  var _ = {};
  l(_, a, function() {
    return this;
  });
  var w = Object.getPrototypeOf, T = w && w(w(z([])));
  T && T !== n && r.call(T, a) && (_ = T);
  var x = S.prototype = v.prototype = Object.create(_);
  function C(k) {
    ["next", "throw", "return"].forEach(function(F) {
      l(k, F, function(V) {
        return this._invoke(F, V);
      });
    });
  }
  function E(k, F) {
    function V(B, U, Q, K) {
      var q = d(k[B], k, U);
      if (q.type !== "throw") {
        var X = q.arg, ie = X.value;
        return ie && _t(ie) == "object" && r.call(ie, "__await") ? F.resolve(ie.__await).then(function(te) {
          V("next", te, Q, K);
        }, function(te) {
          V("throw", te, Q, K);
        }) : F.resolve(ie).then(function(te) {
          X.value = te, Q(X);
        }, function(te) {
          return V("throw", te, Q, K);
        });
      }
      K(q.arg);
    }
    var j;
    i(this, "_invoke", {
      value: function(U, Q) {
        function K() {
          return new F(function(q, X) {
            V(U, Q, q, X);
          });
        }
        return j = j ? j.then(K, K) : K();
      }
    });
  }
  function R(k, F, V) {
    var j = f;
    return function(B, U) {
      if (j === p)
        throw Error("Generator is already running");
      if (j === g) {
        if (B === "throw")
          throw U;
        return {
          value: e,
          done: !0
        };
      }
      for (V.method = B, V.arg = U; ; ) {
        var Q = V.delegate;
        if (Q) {
          var K = A(Q, V);
          if (K) {
            if (K === m)
              continue;
            return K;
          }
        }
        if (V.method === "next")
          V.sent = V._sent = V.arg;
        else if (V.method === "throw") {
          if (j === f)
            throw j = g, V.arg;
          V.dispatchException(V.arg);
        } else
          V.method === "return" && V.abrupt("return", V.arg);
        j = p;
        var q = d(k, F, V);
        if (q.type === "normal") {
          if (j = V.done ? g : h, q.arg === m)
            continue;
          return {
            value: q.arg,
            done: V.done
          };
        }
        q.type === "throw" && (j = g, V.method = "throw", V.arg = q.arg);
      }
    };
  }
  function A(k, F) {
    var V = F.method, j = k.iterator[V];
    if (j === e)
      return F.delegate = null, V === "throw" && k.iterator.return && (F.method = "return", F.arg = e, A(k, F), F.method === "throw") || V !== "return" && (F.method = "throw", F.arg = new TypeError("The iterator does not provide a '" + V + "' method")), m;
    var B = d(j, k.iterator, F.arg);
    if (B.type === "throw")
      return F.method = "throw", F.arg = B.arg, F.delegate = null, m;
    var U = B.arg;
    return U ? U.done ? (F[k.resultName] = U.value, F.next = k.nextLoc, F.method !== "return" && (F.method = "next", F.arg = e), F.delegate = null, m) : U : (F.method = "throw", F.arg = new TypeError("iterator result is not an object"), F.delegate = null, m);
  }
  function O(k) {
    var F = {
      tryLoc: k[0]
    };
    1 in k && (F.catchLoc = k[1]), 2 in k && (F.finallyLoc = k[2], F.afterLoc = k[3]), this.tryEntries.push(F);
  }
  function $(k) {
    var F = k.completion || {};
    F.type = "normal", delete F.arg, k.completion = F;
  }
  function N(k) {
    this.tryEntries = [{
      tryLoc: "root"
    }], k.forEach(O, this), this.reset(!0);
  }
  function z(k) {
    if (k || k === "") {
      var F = k[a];
      if (F)
        return F.call(k);
      if (typeof k.next == "function")
        return k;
      if (!isNaN(k.length)) {
        var V = -1, j = function B() {
          for (; ++V < k.length; )
            if (r.call(k, V))
              return B.value = k[V], B.done = !1, B;
          return B.value = e, B.done = !0, B;
        };
        return j.next = j;
      }
    }
    throw new TypeError(_t(k) + " is not iterable");
  }
  return y.prototype = S, i(x, "constructor", {
    value: S,
    configurable: !0
  }), i(S, "constructor", {
    value: y,
    configurable: !0
  }), y.displayName = l(S, c, "GeneratorFunction"), t.isGeneratorFunction = function(k) {
    var F = typeof k == "function" && k.constructor;
    return !!F && (F === y || (F.displayName || F.name) === "GeneratorFunction");
  }, t.mark = function(k) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(k, S) : (k.__proto__ = S, l(k, c, "GeneratorFunction")), k.prototype = Object.create(x), k;
  }, t.awrap = function(k) {
    return {
      __await: k
    };
  }, C(E.prototype), l(E.prototype, s, function() {
    return this;
  }), t.AsyncIterator = E, t.async = function(k, F, V, j, B) {
    B === void 0 && (B = Promise);
    var U = new E(u(k, F, V, j), B);
    return t.isGeneratorFunction(F) ? U : U.next().then(function(Q) {
      return Q.done ? Q.value : U.next();
    });
  }, C(x), l(x, c, "Generator"), l(x, a, function() {
    return this;
  }), l(x, "toString", function() {
    return "[object Generator]";
  }), t.keys = function(k) {
    var F = Object(k), V = [];
    for (var j in F)
      V.push(j);
    return V.reverse(), function B() {
      for (; V.length; ) {
        var U = V.pop();
        if (U in F)
          return B.value = U, B.done = !1, B;
      }
      return B.done = !0, B;
    };
  }, t.values = z, N.prototype = {
    constructor: N,
    reset: function(F) {
      if (this.prev = 0, this.next = 0, this.sent = this._sent = e, this.done = !1, this.delegate = null, this.method = "next", this.arg = e, this.tryEntries.forEach($), !F)
        for (var V in this)
          V.charAt(0) === "t" && r.call(this, V) && !isNaN(+V.slice(1)) && (this[V] = e);
    },
    stop: function() {
      this.done = !0;
      var F = this.tryEntries[0].completion;
      if (F.type === "throw")
        throw F.arg;
      return this.rval;
    },
    dispatchException: function(F) {
      if (this.done)
        throw F;
      var V = this;
      function j(X, ie) {
        return Q.type = "throw", Q.arg = F, V.next = X, ie && (V.method = "next", V.arg = e), !!ie;
      }
      for (var B = this.tryEntries.length - 1; B >= 0; --B) {
        var U = this.tryEntries[B], Q = U.completion;
        if (U.tryLoc === "root")
          return j("end");
        if (U.tryLoc <= this.prev) {
          var K = r.call(U, "catchLoc"), q = r.call(U, "finallyLoc");
          if (K && q) {
            if (this.prev < U.catchLoc)
              return j(U.catchLoc, !0);
            if (this.prev < U.finallyLoc)
              return j(U.finallyLoc);
          } else if (K) {
            if (this.prev < U.catchLoc)
              return j(U.catchLoc, !0);
          } else {
            if (!q)
              throw Error("try statement without catch or finally");
            if (this.prev < U.finallyLoc)
              return j(U.finallyLoc);
          }
        }
      }
    },
    abrupt: function(F, V) {
      for (var j = this.tryEntries.length - 1; j >= 0; --j) {
        var B = this.tryEntries[j];
        if (B.tryLoc <= this.prev && r.call(B, "finallyLoc") && this.prev < B.finallyLoc) {
          var U = B;
          break;
        }
      }
      U && (F === "break" || F === "continue") && U.tryLoc <= V && V <= U.finallyLoc && (U = null);
      var Q = U ? U.completion : {};
      return Q.type = F, Q.arg = V, U ? (this.method = "next", this.next = U.finallyLoc, m) : this.complete(Q);
    },
    complete: function(F, V) {
      if (F.type === "throw")
        throw F.arg;
      return F.type === "break" || F.type === "continue" ? this.next = F.arg : F.type === "return" ? (this.rval = this.arg = F.arg, this.method = "return", this.next = "end") : F.type === "normal" && V && (this.next = V), m;
    },
    finish: function(F) {
      for (var V = this.tryEntries.length - 1; V >= 0; --V) {
        var j = this.tryEntries[V];
        if (j.finallyLoc === F)
          return this.complete(j.completion, j.afterLoc), $(j), m;
      }
    },
    catch: function(F) {
      for (var V = this.tryEntries.length - 1; V >= 0; --V) {
        var j = this.tryEntries[V];
        if (j.tryLoc === F) {
          var B = j.completion;
          if (B.type === "throw") {
            var U = B.arg;
            $(j);
          }
          return U;
        }
      }
      throw Error("illegal catch attempt");
    },
    delegateYield: function(F, V, j) {
      return this.delegate = {
        iterator: z(F),
        resultName: V,
        nextLoc: j
      }, this.method === "next" && (this.arg = e), m;
    }
  }, t;
}
function sL(e, t, n, r, i, o, a) {
  try {
    var s = e[o](a), c = s.value;
  } catch (l) {
    return void n(l);
  }
  s.done ? t(c) : Promise.resolve(c).then(r, i);
}
function Af(e) {
  return function() {
    var t = this, n = arguments;
    return new Promise(function(r, i) {
      var o = e.apply(t, n);
      function a(c) {
        sL(o, r, i, a, s, "next", c);
      }
      function s(c) {
        sL(o, r, i, a, s, "throw", c);
      }
      a(void 0);
    });
  };
}
var sy = ae({}, Zse), _Re = sy.version, SRe = sy.render, wRe = sy.unmountComponentAtNode, eE;
try {
  var xRe = Number((_Re || "").split(".")[0]);
  xRe >= 18 && (eE = sy.createRoot);
} catch {
}
function cL(e) {
  var t = sy.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
  t && _t(t) === "object" && (t.usingClientEntryPoint = e);
}
var NS = "__rc_react_root__";
function ERe(e, t) {
  cL(!0);
  var n = t[NS] || eE(t);
  cL(!1), n.render(e), t[NS] = n;
}
function CRe(e, t) {
  SRe(e, t);
}
function iQ(e, t) {
  if (eE) {
    ERe(e, t);
    return;
  }
  CRe(e, t);
}
function TRe(e) {
  return nR.apply(this, arguments);
}
function nR() {
  return nR = Af(/* @__PURE__ */ Po().mark(function e(t) {
    return Po().wrap(function(r) {
      for (; ; )
        switch (r.prev = r.next) {
          case 0:
            return r.abrupt("return", Promise.resolve().then(function() {
              var i;
              (i = t[NS]) === null || i === void 0 || i.unmount(), delete t[NS];
            }));
          case 1:
          case "end":
            return r.stop();
        }
    }, e);
  })), nR.apply(this, arguments);
}
function IRe(e) {
  wRe(e);
}
function ARe(e) {
  return rR.apply(this, arguments);
}
function rR() {
  return rR = Af(/* @__PURE__ */ Po().mark(function e(t) {
    return Po().wrap(function(r) {
      for (; ; )
        switch (r.prev = r.next) {
          case 0:
            if (eE === void 0) {
              r.next = 2;
              break;
            }
            return r.abrupt("return", TRe(t));
          case 2:
            IRe(t);
          case 3:
          case "end":
            return r.stop();
        }
    }, e);
  })), rR.apply(this, arguments);
}
const oQ = (e, t, n) => n !== void 0 ? n : `${e}-${t}`, aQ = function(e) {
  if (!e)
    return !1;
  if (e instanceof Element) {
    if (e.offsetParent)
      return !0;
    if (e.getBBox) {
      var t = e.getBBox(), n = t.width, r = t.height;
      if (n || r)
        return !0;
    }
    if (e.getBoundingClientRect) {
      var i = e.getBoundingClientRect(), o = i.width, a = i.height;
      if (o || a)
        return !0;
    }
  }
  return !1;
}, RRe = (e) => {
  const {
    componentCls: t,
    colorPrimary: n
  } = e;
  return {
    [t]: {
      position: "absolute",
      background: "transparent",
      pointerEvents: "none",
      boxSizing: "border-box",
      color: `var(--wave-color, ${n})`,
      boxShadow: "0 0 0 0 currentcolor",
      opacity: 0.2,
      // =================== Motion ===================
      "&.wave-motion-appear": {
        transition: [`box-shadow 0.4s ${e.motionEaseOutCirc}`, `opacity 2s ${e.motionEaseOutCirc}`].join(","),
        "&-active": {
          boxShadow: "0 0 0 6px currentcolor",
          opacity: 0
        },
        "&.wave-quick": {
          transition: [`box-shadow ${e.motionDurationSlow} ${e.motionEaseInOut}`, `opacity ${e.motionDurationSlow} ${e.motionEaseInOut}`].join(",")
        }
      }
    }
  };
}, $Re = bIe("Wave", (e) => [RRe(e)]), sQ = `${OS}-wave-target`;
function N5(e) {
  return e && e !== "#fff" && e !== "#ffffff" && e !== "rgb(255, 255, 255)" && e !== "rgba(255, 255, 255, 1)" && !/rgba\((?:\d*, ){3}0\)/.test(e) && // any transparent rgba color
  e !== "transparent";
}
function ORe(e) {
  const {
    borderTopColor: t,
    borderColor: n,
    backgroundColor: r
  } = getComputedStyle(e);
  return N5(t) ? t : N5(n) ? n : N5(r) ? r : null;
}
function D5(e) {
  return Number.isNaN(e) ? 0 : e;
}
const PRe = (e) => {
  const {
    className: t,
    target: n,
    component: r
  } = e, i = I.useRef(null), [o, a] = I.useState(null), [s, c] = I.useState([]), [l, u] = I.useState(0), [d, f] = I.useState(0), [h, p] = I.useState(0), [g, m] = I.useState(0), [v, y] = I.useState(!1), S = {
    left: l,
    top: d,
    width: h,
    height: g,
    borderRadius: s.map((T) => `${T}px`).join(" ")
  };
  o && (S["--wave-color"] = o);
  function _() {
    const T = getComputedStyle(n);
    a(ORe(n));
    const x = T.position === "static", {
      borderLeftWidth: C,
      borderTopWidth: E
    } = T;
    u(x ? n.offsetLeft : D5(-parseFloat(C))), f(x ? n.offsetTop : D5(-parseFloat(E))), p(n.offsetWidth), m(n.offsetHeight);
    const {
      borderTopLeftRadius: R,
      borderTopRightRadius: A,
      borderBottomLeftRadius: O,
      borderBottomRightRadius: $
    } = T;
    c([R, A, $, O].map((N) => D5(parseFloat(N))));
  }
  if (I.useEffect(() => {
    if (n) {
      const T = Ln(() => {
        _(), y(!0);
      });
      let x;
      return typeof ResizeObserver < "u" && (x = new ResizeObserver(_), x.observe(n)), () => {
        Ln.cancel(T), x == null || x.disconnect();
      };
    }
  }, []), !v)
    return null;
  const w = (r === "Checkbox" || r === "Radio") && (n == null ? void 0 : n.classList.contains(sQ));
  return /* @__PURE__ */ I.createElement(Tf, {
    visible: !0,
    motionAppear: !0,
    motionName: "wave-motion",
    motionDeadline: 5e3,
    onAppearEnd: (T, x) => {
      var C;
      if (x.deadline || x.propertyName === "opacity") {
        const E = (C = i.current) === null || C === void 0 ? void 0 : C.parentElement;
        ARe(E).then(() => {
          E == null || E.remove();
        });
      }
      return !1;
    }
  }, (T, x) => {
    let {
      className: C
    } = T;
    return /* @__PURE__ */ I.createElement("div", {
      ref: Wa(i, x),
      className: we(t, C, {
        "wave-quick": w
      }),
      style: S
    });
  });
}, MRe = (e, t) => {
  var n;
  const {
    component: r
  } = t;
  if (r === "Checkbox" && !(!((n = e.querySelector("input")) === null || n === void 0) && n.checked))
    return;
  const i = document.createElement("div");
  i.style.position = "absolute", i.style.left = "0px", i.style.top = "0px", e == null || e.insertBefore(i, e == null ? void 0 : e.firstChild), iQ(/* @__PURE__ */ I.createElement(PRe, Object.assign({}, t, {
    target: e
  })), i);
}, kRe = MRe, NRe = (e, t, n) => {
  const {
    wave: r
  } = I.useContext(En), [, i, o] = $s(), a = Rr((l) => {
    const u = e.current;
    if (r != null && r.disabled || !u)
      return;
    const d = u.querySelector(`.${sQ}`) || u, {
      showEffect: f
    } = r || {};
    (f || kRe)(d, {
      className: t,
      token: i,
      component: n,
      event: l,
      hashId: o
    });
  }), s = I.useRef();
  return (l) => {
    Ln.cancel(s.current), s.current = Ln(() => {
      a(l);
    });
  };
}, DRe = NRe, cQ = (e) => {
  const {
    children: t,
    disabled: n,
    component: r
  } = e, {
    getPrefixCls: i
  } = St(En), o = Me(null), a = i("wave"), [, s] = $Re(a), c = DRe(o, we(a, s), r);
  if (D.useEffect(() => {
    const u = o.current;
    if (!u || u.nodeType !== 1 || n)
      return;
    const d = (f) => {
      !aQ(f.target) || // No need wave
      !u.getAttribute || u.getAttribute("disabled") || u.disabled || u.className.includes("disabled") || u.className.includes("-leave") || c(f);
    };
    return u.addEventListener("click", d, !0), () => {
      u.removeEventListener("click", d, !0);
    };
  }, [n]), !/* @__PURE__ */ D.isValidElement(t))
    return t ?? null;
  const l = ay(t) ? Wa(t.ref, o) : o;
  return Ng(t, {
    ref: l
  });
};
process.env.NODE_ENV !== "production" && (cQ.displayName = "Wave");
const LRe = cQ, jRe = (e) => {
  const t = D.useContext(Kx);
  return D.useMemo(() => e ? typeof e == "string" ? e ?? t : e instanceof Function ? e(t) : t : t, [e, t]);
}, Rf = jRe;
globalThis && globalThis.__rest;
const lQ = /* @__PURE__ */ I.createContext(null), cy = (e, t) => {
  const n = I.useContext(lQ), r = I.useMemo(() => {
    if (!n)
      return "";
    const {
      compactDirection: i,
      isFirstItem: o,
      isLastItem: a
    } = n, s = i === "vertical" ? "-vertical-" : "-";
    return we(`${e}-compact${s}item`, {
      [`${e}-compact${s}first-item`]: o,
      [`${e}-compact${s}last-item`]: a,
      [`${e}-compact${s}item-rtl`]: t === "rtl"
    });
  }, [e, t, n]);
  return {
    compactSize: n == null ? void 0 : n.compactSize,
    compactDirection: n == null ? void 0 : n.compactDirection,
    compactItemClassnames: r
  };
}, FRe = (e) => {
  let {
    children: t
  } = e;
  return /* @__PURE__ */ I.createElement(lQ.Provider, {
    value: null
  }, t);
};
var VRe = globalThis && globalThis.__rest || function(e, t) {
  var n = {};
  for (var r in e)
    Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var i = 0, r = Object.getOwnPropertySymbols(e); i < r.length; i++)
      t.indexOf(r[i]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[i]) && (n[r[i]] = e[r[i]]);
  return n;
};
const uQ = /* @__PURE__ */ I.createContext(void 0), BRe = (e) => {
  const {
    getPrefixCls: t,
    direction: n
  } = I.useContext(En), {
    prefixCls: r,
    size: i,
    className: o
  } = e, a = VRe(e, ["prefixCls", "size", "className"]), s = t("btn-group", r), [, , c] = $s();
  let l = "";
  switch (i) {
    case "large":
      l = "lg";
      break;
    case "small":
      l = "sm";
      break;
  }
  if (process.env.NODE_ENV !== "production") {
    const d = di("Button.Group");
    process.env.NODE_ENV !== "production" && d(!i || ["large", "small", "middle"].includes(i), "usage", "Invalid prop `size`.");
  }
  const u = we(s, {
    [`${s}-${l}`]: l,
    [`${s}-rtl`]: n === "rtl"
  }, o, c);
  return /* @__PURE__ */ I.createElement(uQ.Provider, {
    value: i
  }, /* @__PURE__ */ I.createElement("div", Object.assign({}, a, {
    className: u
  })));
}, zRe = BRe, lL = /^[\u4E00-\u9FA5]{2}$/, iR = lL.test.bind(lL);
function uL(e) {
  return typeof e == "string";
}
function qb(e) {
  return e === "text" || e === "link";
}
function HRe(e, t) {
  if (e == null)
    return;
  const n = t ? " " : "";
  return typeof e != "string" && typeof e != "number" && uL(e.type) && iR(e.props.children) ? Ng(e, {
    children: e.props.children.split("").join(n)
  }) : uL(e) ? iR(e) ? /* @__PURE__ */ D.createElement("span", null, e.split("").join(n)) : /* @__PURE__ */ D.createElement("span", null, e) : VX(e) ? /* @__PURE__ */ D.createElement("span", null, e) : e;
}
function URe(e, t) {
  let n = !1;
  const r = [];
  return D.Children.forEach(e, (i) => {
    const o = typeof i, a = o === "string" || o === "number";
    if (n && a) {
      const s = r.length - 1, c = r[s];
      r[s] = `${c}${i}`;
    } else
      r.push(i);
    n = a;
  }), D.Children.map(r, (i) => HRe(i, t));
}
const WRe = /* @__PURE__ */ ta((e, t) => {
  const {
    className: n,
    style: r,
    children: i,
    prefixCls: o
  } = e, a = we(`${o}-icon`, n);
  return /* @__PURE__ */ D.createElement("span", {
    ref: t,
    className: a,
    style: r
  }, i);
}), dQ = WRe, dL = /* @__PURE__ */ ta((e, t) => {
  const {
    prefixCls: n,
    className: r,
    style: i,
    iconClassName: o
  } = e, a = we(`${n}-loading-icon`, r);
  return /* @__PURE__ */ D.createElement(dQ, {
    prefixCls: n,
    className: a,
    style: i,
    ref: t
  }, /* @__PURE__ */ D.createElement(S6, {
    className: o
  }));
}), L5 = () => ({
  width: 0,
  opacity: 0,
  transform: "scale(0)"
}), j5 = (e) => ({
  width: e.scrollWidth,
  opacity: 1,
  transform: "scale(1)"
}), qRe = (e) => {
  const {
    prefixCls: t,
    loading: n,
    existIcon: r,
    className: i,
    style: o
  } = e, a = !!n;
  return r ? /* @__PURE__ */ D.createElement(dL, {
    prefixCls: t,
    className: i,
    style: o
  }) : /* @__PURE__ */ D.createElement(Tf, {
    visible: a,
    // We do not really use this motionName
    motionName: `${t}-loading-icon-motion`,
    motionLeave: a,
    removeOnLeave: !0,
    onAppearStart: L5,
    onAppearActive: j5,
    onEnterStart: L5,
    onEnterActive: j5,
    onLeaveStart: j5,
    onLeaveActive: L5
  }, (s, c) => {
    let {
      className: l,
      style: u
    } = s;
    return /* @__PURE__ */ D.createElement(dL, {
      prefixCls: t,
      className: i,
      style: Object.assign(Object.assign({}, o), u),
      ref: c,
      iconClassName: l
    });
  });
}, GRe = qRe, fL = (e, t) => ({
  // Border
  [`> span, > ${e}`]: {
    "&:not(:last-child)": {
      [`&, & > ${e}`]: {
        "&:not(:disabled)": {
          borderInlineEndColor: t
        }
      }
    },
    "&:not(:first-child)": {
      [`&, & > ${e}`]: {
        "&:not(:disabled)": {
          borderInlineStartColor: t
        }
      }
    }
  }
}), KRe = (e) => {
  const {
    componentCls: t,
    fontSize: n,
    lineWidth: r,
    groupBorderColor: i,
    colorErrorHover: o
  } = e;
  return {
    [`${t}-group`]: [
      {
        position: "relative",
        display: "inline-flex",
        // Border
        [`> span, > ${t}`]: {
          "&:not(:last-child)": {
            [`&, & > ${t}`]: {
              borderStartEndRadius: 0,
              borderEndEndRadius: 0
            }
          },
          "&:not(:first-child)": {
            marginInlineStart: e.calc(r).mul(-1).equal(),
            [`&, & > ${t}`]: {
              borderStartStartRadius: 0,
              borderEndStartRadius: 0
            }
          }
        },
        [t]: {
          position: "relative",
          zIndex: 1,
          "&:hover, &:focus, &:active": {
            zIndex: 2
          },
          "&[disabled]": {
            zIndex: 0
          }
        },
        [`${t}-icon-only`]: {
          fontSize: n
        }
      },
      // Border Color
      fL(`${t}-primary`, i),
      fL(`${t}-danger`, o)
    ]
  };
}, YRe = KRe, Ii = Math.round;
function F5(e, t) {
  const n = e.replace(/^[^(]*\((.*)/, "$1").replace(/\).*/, "").match(/\d*\.?\d+%?/g) || [], r = n.map((i) => parseFloat(i));
  for (let i = 0; i < 3; i += 1)
    r[i] = t(r[i] || 0, n[i] || "", i);
  return n[3] ? r[3] = n[3].includes("%") ? r[3] / 100 : r[3] : r[3] = 1, r;
}
const hL = (e, t, n) => n === 0 ? e : e / 100;
function dm(e, t) {
  const n = t || 255;
  return e > n ? n : e < 0 ? 0 : e;
}
class tE {
  constructor(t) {
    re(this, "isValid", !0), re(this, "r", 0), re(this, "g", 0), re(this, "b", 0), re(this, "a", 1), re(this, "_h", void 0), re(this, "_s", void 0), re(this, "_l", void 0), re(this, "_v", void 0), re(this, "_max", void 0), re(this, "_min", void 0), re(this, "_brightness", void 0);
    function n(r) {
      return r[0] in t && r[1] in t && r[2] in t;
    }
    if (t)
      if (typeof t == "string") {
        let i = function(o) {
          return r.startsWith(o);
        };
        const r = t.trim();
        /^#?[A-F\d]{3,8}$/i.test(r) ? this.fromHexString(r) : i("rgb") ? this.fromRgbString(r) : i("hsl") ? this.fromHslString(r) : (i("hsv") || i("hsb")) && this.fromHsvString(r);
      } else if (t instanceof tE)
        this.r = t.r, this.g = t.g, this.b = t.b, this.a = t.a, this._h = t._h, this._s = t._s, this._l = t._l, this._v = t._v;
      else if (n("rgb"))
        this.r = dm(t.r), this.g = dm(t.g), this.b = dm(t.b), this.a = typeof t.a == "number" ? dm(t.a, 1) : 1;
      else if (n("hsl"))
        this.fromHsl(t);
      else if (n("hsv"))
        this.fromHsv(t);
      else
        throw new Error("@ant-design/fast-color: unsupported input " + JSON.stringify(t));
  }
  // ======================= Setter =======================
  setR(t) {
    return this._sc("r", t);
  }
  setG(t) {
    return this._sc("g", t);
  }
  setB(t) {
    return this._sc("b", t);
  }
  setA(t) {
    return this._sc("a", t, 1);
  }
  setHue(t) {
    const n = this.toHsv();
    return n.h = t, this._c(n);
  }
  // ======================= Getter =======================
  /**
   * Returns the perceived luminance of a color, from 0-1.
   * @see http://www.w3.org/TR/2008/REC-WCAG20-20081211/#relativeluminancedef
   */
  getLuminance() {
    function t(o) {
      const a = o / 255;
      return a <= 0.03928 ? a / 12.92 : Math.pow((a + 0.055) / 1.055, 2.4);
    }
    const n = t(this.r), r = t(this.g), i = t(this.b);
    return 0.2126 * n + 0.7152 * r + 0.0722 * i;
  }
  getHue() {
    if (typeof this._h > "u") {
      const t = this.getMax() - this.getMin();
      t === 0 ? this._h = 0 : this._h = Ii(60 * (this.r === this.getMax() ? (this.g - this.b) / t + (this.g < this.b ? 6 : 0) : this.g === this.getMax() ? (this.b - this.r) / t + 2 : (this.r - this.g) / t + 4));
    }
    return this._h;
  }
  getSaturation() {
    if (typeof this._s > "u") {
      const t = this.getMax() - this.getMin();
      t === 0 ? this._s = 0 : this._s = t / this.getMax();
    }
    return this._s;
  }
  getLightness() {
    return typeof this._l > "u" && (this._l = (this.getMax() + this.getMin()) / 510), this._l;
  }
  getValue() {
    return typeof this._v > "u" && (this._v = this.getMax() / 255), this._v;
  }
  /**
   * Returns the perceived brightness of the color, from 0-255.
   * Note: this is not the b of HSB
   * @see http://www.w3.org/TR/AERT#color-contrast
   */
  getBrightness() {
    return typeof this._brightness > "u" && (this._brightness = (this.r * 299 + this.g * 587 + this.b * 114) / 1e3), this._brightness;
  }
  // ======================== Func ========================
  darken(t = 10) {
    const n = this.getHue(), r = this.getSaturation();
    let i = this.getLightness() - t / 100;
    return i < 0 && (i = 0), this._c({
      h: n,
      s: r,
      l: i,
      a: this.a
    });
  }
  lighten(t = 10) {
    const n = this.getHue(), r = this.getSaturation();
    let i = this.getLightness() + t / 100;
    return i > 1 && (i = 1), this._c({
      h: n,
      s: r,
      l: i,
      a: this.a
    });
  }
  /**
   * Mix the current color a given amount with another color, from 0 to 100.
   * 0 means no mixing (return current color).
   */
  mix(t, n = 50) {
    const r = this._c(t), i = n / 100, o = (s) => (r[s] - this[s]) * i + this[s], a = {
      r: Ii(o("r")),
      g: Ii(o("g")),
      b: Ii(o("b")),
      a: Ii(o("a") * 100) / 100
    };
    return this._c(a);
  }
  /**
   * Mix the color with pure white, from 0 to 100.
   * Providing 0 will do nothing, providing 100 will always return white.
   */
  tint(t = 10) {
    return this.mix({
      r: 255,
      g: 255,
      b: 255,
      a: 1
    }, t);
  }
  /**
   * Mix the color with pure black, from 0 to 100.
   * Providing 0 will do nothing, providing 100 will always return black.
   */
  shade(t = 10) {
    return this.mix({
      r: 0,
      g: 0,
      b: 0,
      a: 1
    }, t);
  }
  onBackground(t) {
    const n = this._c(t), r = this.a + n.a * (1 - this.a), i = (o) => Ii((this[o] * this.a + n[o] * n.a * (1 - this.a)) / r);
    return this._c({
      r: i("r"),
      g: i("g"),
      b: i("b"),
      a: r
    });
  }
  // ======================= Status =======================
  isDark() {
    return this.getBrightness() < 128;
  }
  isLight() {
    return this.getBrightness() >= 128;
  }
  // ======================== MISC ========================
  equals(t) {
    return this.r === t.r && this.g === t.g && this.b === t.b && this.a === t.a;
  }
  clone() {
    return this._c(this);
  }
  // ======================= Format =======================
  toHexString() {
    let t = "#";
    const n = (this.r || 0).toString(16);
    t += n.length === 2 ? n : "0" + n;
    const r = (this.g || 0).toString(16);
    t += r.length === 2 ? r : "0" + r;
    const i = (this.b || 0).toString(16);
    if (t += i.length === 2 ? i : "0" + i, typeof this.a == "number" && this.a >= 0 && this.a < 1) {
      const o = Ii(this.a * 255).toString(16);
      t += o.length === 2 ? o : "0" + o;
    }
    return t;
  }
  /** CSS support color pattern */
  toHsl() {
    return {
      h: this.getHue(),
      s: this.getSaturation(),
      l: this.getLightness(),
      a: this.a
    };
  }
  /** CSS support color pattern */
  toHslString() {
    const t = this.getHue(), n = Ii(this.getSaturation() * 100), r = Ii(this.getLightness() * 100);
    return this.a !== 1 ? `hsla(${t},${n}%,${r}%,${this.a})` : `hsl(${t},${n}%,${r}%)`;
  }
  /** Same as toHsb */
  toHsv() {
    return {
      h: this.getHue(),
      s: this.getSaturation(),
      v: this.getValue(),
      a: this.a
    };
  }
  toRgb() {
    return {
      r: this.r,
      g: this.g,
      b: this.b,
      a: this.a
    };
  }
  toRgbString() {
    return this.a !== 1 ? `rgba(${this.r},${this.g},${this.b},${this.a})` : `rgb(${this.r},${this.g},${this.b})`;
  }
  toString() {
    return this.toRgbString();
  }
  // ====================== Privates ======================
  /** Return a new FastColor object with one channel changed */
  _sc(t, n, r) {
    const i = this.clone();
    return i[t] = dm(n, r), i;
  }
  _c(t) {
    return new this.constructor(t);
  }
  getMax() {
    return typeof this._max > "u" && (this._max = Math.max(this.r, this.g, this.b)), this._max;
  }
  getMin() {
    return typeof this._min > "u" && (this._min = Math.min(this.r, this.g, this.b)), this._min;
  }
  fromHexString(t) {
    const n = t.replace("#", "");
    function r(i, o) {
      return parseInt(n[i] + n[o || i], 16);
    }
    n.length < 6 ? (this.r = r(0), this.g = r(1), this.b = r(2), this.a = n[3] ? r(3) / 255 : 1) : (this.r = r(0, 1), this.g = r(2, 3), this.b = r(4, 5), this.a = n[6] ? r(6, 7) / 255 : 1);
  }
  fromHsl({
    h: t,
    s: n,
    l: r,
    a: i
  }) {
    if (this._h = t % 360, this._s = n, this._l = r, this.a = typeof i == "number" ? i : 1, n <= 0) {
      const f = Ii(r * 255);
      this.r = f, this.g = f, this.b = f;
    }
    let o = 0, a = 0, s = 0;
    const c = t / 60, l = (1 - Math.abs(2 * r - 1)) * n, u = l * (1 - Math.abs(c % 2 - 1));
    c >= 0 && c < 1 ? (o = l, a = u) : c >= 1 && c < 2 ? (o = u, a = l) : c >= 2 && c < 3 ? (a = l, s = u) : c >= 3 && c < 4 ? (a = u, s = l) : c >= 4 && c < 5 ? (o = u, s = l) : c >= 5 && c < 6 && (o = l, s = u);
    const d = r - l / 2;
    this.r = Ii((o + d) * 255), this.g = Ii((a + d) * 255), this.b = Ii((s + d) * 255);
  }
  fromHsv({
    h: t,
    s: n,
    v: r,
    a: i
  }) {
    this._h = t % 360, this._s = n, this._v = r, this.a = typeof i == "number" ? i : 1;
    const o = Ii(r * 255);
    if (this.r = o, this.g = o, this.b = o, n <= 0)
      return;
    const a = t / 60, s = Math.floor(a), c = a - s, l = Ii(r * (1 - n) * 255), u = Ii(r * (1 - n * c) * 255), d = Ii(r * (1 - n * (1 - c)) * 255);
    switch (s) {
      case 0:
        this.g = d, this.b = l;
        break;
      case 1:
        this.r = u, this.b = l;
        break;
      case 2:
        this.r = l, this.b = d;
        break;
      case 3:
        this.r = l, this.g = u;
        break;
      case 4:
        this.r = d, this.g = l;
        break;
      case 5:
      default:
        this.g = l, this.b = u;
        break;
    }
  }
  fromHsvString(t) {
    const n = F5(t, hL);
    this.fromHsv({
      h: n[0],
      s: n[1],
      v: n[2],
      a: n[3]
    });
  }
  fromHslString(t) {
    const n = F5(t, hL);
    this.fromHsl({
      h: n[0],
      s: n[1],
      l: n[2],
      a: n[3]
    });
  }
  fromRgbString(t) {
    const n = F5(t, (r, i) => (
      // Convert percentage to number. e.g. 50% -> 128
      i.includes("%") ? Ii(r / 100 * 255) : r
    ));
    this.r = n[0], this.g = n[1], this.b = n[2], this.a = n[3];
  }
}
var XRe = ["b"], QRe = ["v"], V5 = function(t) {
  return Math.round(Number(t || 0));
}, JRe = function(t) {
  if (t instanceof tE)
    return t;
  if (t && _t(t) === "object" && "h" in t && "b" in t) {
    var n = t, r = n.b, i = xn(n, XRe);
    return ae(ae({}, i), {}, {
      v: r
    });
  }
  return typeof t == "string" && /hsb/.test(t) ? t.replace(/hsb/, "hsv") : t;
}, ul = /* @__PURE__ */ function(e) {
  Rs(n, e);
  var t = _c(n);
  function n(r) {
    return Sr(this, n), t.call(this, JRe(r));
  }
  return wr(n, [{
    key: "toHsbString",
    value: function() {
      var i = this.toHsb(), o = V5(i.s * 100), a = V5(i.b * 100), s = V5(i.h), c = i.a, l = "hsb(".concat(s, ", ").concat(o, "%, ").concat(a, "%)"), u = "hsba(".concat(s, ", ").concat(o, "%, ").concat(a, "%, ").concat(c.toFixed(c === 0 ? 0 : 2), ")");
      return c === 1 ? l : u;
    }
  }, {
    key: "toHsb",
    value: function() {
      var i = this.toHsv(), o = i.v, a = xn(i, QRe);
      return ae(ae({}, a), {}, {
        b: o,
        a: this.a
      });
    }
  }]), n;
}(tE), ZRe = "rc-color-picker", Xh = function(t) {
  return t instanceof ul ? t : new ul(t);
}, e$e = Xh("#1677ff"), fQ = function(t) {
  var n = t.offset, r = t.targetRef, i = t.containerRef, o = t.color, a = t.type, s = i.current.getBoundingClientRect(), c = s.width, l = s.height, u = r.current.getBoundingClientRect(), d = u.width, f = u.height, h = d / 2, p = f / 2, g = (n.x + h) / c, m = 1 - (n.y + p) / l, v = o.toHsb(), y = g, S = (n.x + h) / c * 360;
  if (a)
    switch (a) {
      case "hue":
        return Xh(ae(ae({}, v), {}, {
          h: S <= 0 ? 0 : S
        }));
      case "alpha":
        return Xh(ae(ae({}, v), {}, {
          a: y <= 0 ? 0 : y
        }));
    }
  return Xh({
    h: v.h,
    s: g <= 0 ? 0 : g,
    b: m >= 1 ? 1 : m,
    a: v.a
  });
}, hQ = function(t, n) {
  var r = t.toHsb();
  switch (n) {
    case "hue":
      return {
        x: r.h / 360 * 100,
        y: 50
      };
    case "alpha":
      return {
        x: t.a * 100,
        y: 50
      };
    default:
      return {
        x: r.s * 100,
        y: (1 - r.b) * 100
      };
  }
}, t$e = function(t) {
  var n = t.color, r = t.prefixCls, i = t.className, o = t.style, a = t.onClick, s = "".concat(r, "-color-block");
  return /* @__PURE__ */ D.createElement("div", {
    className: we(s, i),
    style: o,
    onClick: a
  }, /* @__PURE__ */ D.createElement("div", {
    className: "".concat(s, "-inner"),
    style: {
      background: n
    }
  }));
};
function n$e(e) {
  var t = "touches" in e ? e.touches[0] : e, n = document.documentElement.scrollLeft || document.body.scrollLeft || window.pageXOffset, r = document.documentElement.scrollTop || document.body.scrollTop || window.pageYOffset;
  return {
    pageX: t.pageX - n,
    pageY: t.pageY - r
  };
}
function gQ(e) {
  var t = e.targetRef, n = e.containerRef, r = e.direction, i = e.onDragChange, o = e.onDragChangeComplete, a = e.calculate, s = e.color, c = e.disabledDrag, l = Lt({
    x: 0,
    y: 0
  }), u = fe(l, 2), d = u[0], f = u[1], h = Me(null), p = Me(null);
  gt(function() {
    f(a());
  }, [s]), gt(function() {
    return function() {
      document.removeEventListener("mousemove", h.current), document.removeEventListener("mouseup", p.current), document.removeEventListener("touchmove", h.current), document.removeEventListener("touchend", p.current), h.current = null, p.current = null;
    };
  }, []);
  var g = function(_) {
    var w = n$e(_), T = w.pageX, x = w.pageY, C = n.current.getBoundingClientRect(), E = C.x, R = C.y, A = C.width, O = C.height, $ = t.current.getBoundingClientRect(), N = $.width, z = $.height, k = N / 2, F = z / 2, V = Math.max(0, Math.min(T - E, A)) - k, j = Math.max(0, Math.min(x - R, O)) - F, B = {
      x: V,
      y: r === "x" ? d.y : j
    };
    if (N === 0 && z === 0 || N !== z)
      return !1;
    i == null || i(B);
  }, m = function(_) {
    _.preventDefault(), g(_);
  }, v = function(_) {
    _.preventDefault(), document.removeEventListener("mousemove", h.current), document.removeEventListener("mouseup", p.current), document.removeEventListener("touchmove", h.current), document.removeEventListener("touchend", p.current), h.current = null, p.current = null, o == null || o();
  }, y = function(_) {
    document.removeEventListener("mousemove", h.current), document.removeEventListener("mouseup", p.current), !c && (g(_), document.addEventListener("mousemove", m), document.addEventListener("mouseup", v), document.addEventListener("touchmove", m), document.addEventListener("touchend", v), h.current = m, p.current = v);
  };
  return [d, y];
}
var pQ = function(t) {
  var n = t.size, r = n === void 0 ? "default" : n, i = t.color, o = t.prefixCls;
  return /* @__PURE__ */ D.createElement("div", {
    className: we("".concat(o, "-handler"), re({}, "".concat(o, "-handler-sm"), r === "small")),
    style: {
      backgroundColor: i
    }
  });
}, mQ = function(t) {
  var n = t.children, r = t.style, i = t.prefixCls;
  return /* @__PURE__ */ D.createElement("div", {
    className: "".concat(i, "-palette"),
    style: ae({
      position: "relative"
    }, r)
  }, n);
}, vQ = /* @__PURE__ */ ta(function(e, t) {
  var n = e.children, r = e.x, i = e.y;
  return /* @__PURE__ */ D.createElement("div", {
    ref: t,
    style: {
      position: "absolute",
      left: "".concat(r, "%"),
      top: "".concat(i, "%"),
      zIndex: 1,
      transform: "translate(-50%, -50%)"
    }
  }, n);
}), r$e = function(t) {
  var n = t.color, r = t.onChange, i = t.prefixCls, o = t.onChangeComplete, a = t.disabled, s = Me(), c = Me(), l = Me(n), u = Rr(function(g) {
    var m = fQ({
      offset: g,
      targetRef: c,
      containerRef: s,
      color: n
    });
    l.current = m, r(m);
  }), d = gQ({
    color: n,
    containerRef: s,
    targetRef: c,
    calculate: function() {
      return hQ(n);
    },
    onDragChange: u,
    onDragChangeComplete: function() {
      return o == null ? void 0 : o(l.current);
    },
    disabledDrag: a
  }), f = fe(d, 2), h = f[0], p = f[1];
  return /* @__PURE__ */ D.createElement("div", {
    ref: s,
    className: "".concat(i, "-select"),
    onMouseDown: p,
    onTouchStart: p
  }, /* @__PURE__ */ D.createElement(mQ, {
    prefixCls: i
  }, /* @__PURE__ */ D.createElement(vQ, {
    x: h.x,
    y: h.y,
    ref: c
  }, /* @__PURE__ */ D.createElement(pQ, {
    color: n.toRgbString(),
    prefixCls: i
  })), /* @__PURE__ */ D.createElement("div", {
    className: "".concat(i, "-saturation"),
    style: {
      backgroundColor: "hsl(".concat(n.toHsb().h, ",100%, 50%)"),
      backgroundImage: "linear-gradient(0deg, #000, transparent),linear-gradient(90deg, #fff, hsla(0, 0%, 100%, 0))"
    }
  })));
}, i$e = function(t, n) {
  var r = hc(t, {
    value: n
  }), i = fe(r, 2), o = i[0], a = i[1], s = At(function() {
    return Xh(o);
  }, [o]);
  return [s, a];
}, o$e = function(t) {
  var n = t.colors, r = t.children, i = t.direction, o = i === void 0 ? "to right" : i, a = t.type, s = t.prefixCls, c = At(function() {
    return n.map(function(l, u) {
      var d = Xh(l);
      return a === "alpha" && u === n.length - 1 && (d = new ul(d.setA(1))), d.toRgbString();
    }).join(",");
  }, [n, a]);
  return /* @__PURE__ */ D.createElement("div", {
    className: "".concat(s, "-gradient"),
    style: {
      position: "absolute",
      inset: 0,
      background: "linear-gradient(".concat(o, ", ").concat(c, ")")
    }
  }, r);
}, a$e = function(t) {
  var n = t.prefixCls, r = t.colors, i = t.disabled, o = t.onChange, a = t.onChangeComplete, s = t.color, c = t.type, l = Me(), u = Me(), d = Me(s), f = function(w) {
    return c === "hue" ? w.getHue() : w.a * 100;
  }, h = Rr(function(_) {
    var w = fQ({
      offset: _,
      targetRef: u,
      containerRef: l,
      color: s,
      type: c
    });
    d.current = w, o(f(w));
  }), p = gQ({
    color: s,
    targetRef: u,
    containerRef: l,
    calculate: function() {
      return hQ(s, c);
    },
    onDragChange: h,
    onDragChangeComplete: function() {
      a(f(d.current));
    },
    direction: "x",
    disabledDrag: i
  }), g = fe(p, 2), m = g[0], v = g[1], y = D.useMemo(function() {
    if (c === "hue") {
      var _ = s.toHsb();
      _.s = 1, _.b = 1, _.a = 1;
      var w = new ul(_);
      return w;
    }
    return s;
  }, [s, c]), S = D.useMemo(function() {
    return r.map(function(_) {
      return "".concat(_.color, " ").concat(_.percent, "%");
    });
  }, [r]);
  return /* @__PURE__ */ D.createElement("div", {
    ref: l,
    className: we("".concat(n, "-slider"), "".concat(n, "-slider-").concat(c)),
    onMouseDown: v,
    onTouchStart: v
  }, /* @__PURE__ */ D.createElement(mQ, {
    prefixCls: n
  }, /* @__PURE__ */ D.createElement(vQ, {
    x: m.x,
    y: m.y,
    ref: u
  }, /* @__PURE__ */ D.createElement(pQ, {
    size: "small",
    color: y.toHexString(),
    prefixCls: n
  })), /* @__PURE__ */ D.createElement(o$e, {
    colors: S,
    type: c,
    prefixCls: n
  })));
};
function s$e(e) {
  return I.useMemo(function() {
    var t = e || {}, n = t.slider;
    return [n || a$e];
  }, [e]);
}
var c$e = [{
  color: "rgb(255, 0, 0)",
  percent: 0
}, {
  color: "rgb(255, 255, 0)",
  percent: 17
}, {
  color: "rgb(0, 255, 0)",
  percent: 33
}, {
  color: "rgb(0, 255, 255)",
  percent: 50
}, {
  color: "rgb(0, 0, 255)",
  percent: 67
}, {
  color: "rgb(255, 0, 255)",
  percent: 83
}, {
  color: "rgb(255, 0, 0)",
  percent: 100
}], l$e = /* @__PURE__ */ ta(function(e, t) {
  var n = e.value, r = e.defaultValue, i = e.prefixCls, o = i === void 0 ? ZRe : i, a = e.onChange, s = e.onChangeComplete, c = e.className, l = e.style, u = e.panelRender, d = e.disabledAlpha, f = d === void 0 ? !1 : d, h = e.disabled, p = h === void 0 ? !1 : h, g = e.components, m = s$e(g), v = fe(m, 1), y = v[0], S = i$e(r || e$e, n), _ = fe(S, 2), w = _[0], T = _[1], x = At(function() {
    return w.setA(1).toRgbString();
  }, [w]), C = function(j, B) {
    n || T(j), a == null || a(j, B);
  }, E = function(j) {
    return new ul(w.setHue(j));
  }, R = function(j) {
    return new ul(w.setA(j / 100));
  }, A = function(j) {
    C(E(j), {
      type: "hue",
      value: j
    });
  }, O = function(j) {
    C(R(j), {
      type: "alpha",
      value: j
    });
  }, $ = function(j) {
    s && s(E(j));
  }, N = function(j) {
    s && s(R(j));
  }, z = we("".concat(o, "-panel"), c, re({}, "".concat(o, "-panel-disabled"), p)), k = {
    prefixCls: o,
    disabled: p,
    color: w
  }, F = /* @__PURE__ */ D.createElement(D.Fragment, null, /* @__PURE__ */ D.createElement(r$e, mt({
    onChange: C
  }, k, {
    onChangeComplete: s
  })), /* @__PURE__ */ D.createElement("div", {
    className: "".concat(o, "-slider-container")
  }, /* @__PURE__ */ D.createElement("div", {
    className: we("".concat(o, "-slider-group"), re({}, "".concat(o, "-slider-group-disabled-alpha"), f))
  }, /* @__PURE__ */ D.createElement(y, mt({}, k, {
    type: "hue",
    colors: c$e,
    min: 0,
    max: 359,
    value: w.getHue(),
    onChange: A,
    onChangeComplete: $
  })), !f && /* @__PURE__ */ D.createElement(y, mt({}, k, {
    type: "alpha",
    colors: [{
      percent: 0,
      color: "rgba(255, 0, 4, 0)"
    }, {
      percent: 100,
      color: x
    }],
    min: 0,
    max: 100,
    value: w.a * 100,
    onChange: O,
    onChangeComplete: N
  }))), /* @__PURE__ */ D.createElement(t$e, {
    color: w.toRgbString(),
    prefixCls: o
  })));
  return /* @__PURE__ */ D.createElement("div", {
    className: z,
    style: l,
    ref: t
  }, typeof u == "function" ? u(F) : F);
});
process.env.NODE_ENV !== "production" && (l$e.displayName = "ColorPicker");
const u$e = (e, t) => (e == null ? void 0 : e.replace(/[^\w/]/g, "").slice(0, t ? 8 : 6)) || "", d$e = (e, t) => e ? u$e(e, t) : "";
let f$e = /* @__PURE__ */ function() {
  function e(t) {
    Sr(this, e);
    var n;
    if (this.cleared = !1, t instanceof e) {
      this.metaColor = t.metaColor.clone(), this.colors = (n = t.colors) === null || n === void 0 ? void 0 : n.map((i) => ({
        color: new e(i.color),
        percent: i.percent
      })), this.cleared = t.cleared;
      return;
    }
    const r = Array.isArray(t);
    r && t.length ? (this.colors = t.map((i) => {
      let {
        color: o,
        percent: a
      } = i;
      return {
        color: new e(o),
        percent: a
      };
    }), this.metaColor = new ul(this.colors[0].color.metaColor)) : this.metaColor = new ul(r ? "" : t), (!t || r && !this.colors) && (this.metaColor = this.metaColor.setA(0), this.cleared = !0);
  }
  return wr(e, [{
    key: "toHsb",
    value: function() {
      return this.metaColor.toHsb();
    }
  }, {
    key: "toHsbString",
    value: function() {
      return this.metaColor.toHsbString();
    }
  }, {
    key: "toHex",
    value: function() {
      return d$e(this.toHexString(), this.metaColor.a < 1);
    }
  }, {
    key: "toHexString",
    value: function() {
      return this.metaColor.toHexString();
    }
  }, {
    key: "toRgb",
    value: function() {
      return this.metaColor.toRgb();
    }
  }, {
    key: "toRgbString",
    value: function() {
      return this.metaColor.toRgbString();
    }
  }, {
    key: "isGradient",
    value: function() {
      return !!this.colors && !this.cleared;
    }
  }, {
    key: "getColors",
    value: function() {
      return this.colors || [{
        color: this,
        percent: 0
      }];
    }
  }, {
    key: "toCssString",
    value: function() {
      const {
        colors: n
      } = this;
      return n ? `linear-gradient(90deg, ${n.map((i) => `${i.color.toRgbString()} ${i.percent}%`).join(", ")})` : this.metaColor.toRgbString();
    }
  }, {
    key: "equals",
    value: function(n) {
      return !n || this.isGradient() !== n.isGradient() ? !1 : this.isGradient() ? this.colors.length === n.colors.length && this.colors.every((r, i) => {
        const o = n.colors[i];
        return r.percent === o.percent && r.color.equals(o.color);
      }) : this.toHexString() === n.toHexString();
    }
  }]);
}();
var h$e = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M765.7 486.8L314.9 134.7A7.97 7.97 0 00302 141v77.3c0 4.9 2.3 9.6 6.1 12.6l360 281.1-360 281.1c-3.9 3-6.1 7.7-6.1 12.6V883c0 6.7 7.7 10.4 12.9 6.3l450.8-352.1a31.96 31.96 0 000-50.4z" } }] }, name: "right", theme: "outlined" };
const g$e = h$e;
var p$e = function(t, n) {
  return /* @__PURE__ */ I.createElement(fo, mt({}, t, {
    ref: n,
    icon: g$e
  }));
}, yQ = /* @__PURE__ */ I.forwardRef(p$e);
process.env.NODE_ENV !== "production" && (yQ.displayName = "RightOutlined");
const m$e = yQ, v$e = (e) => ({
  animationDuration: e,
  animationFillMode: "both"
}), y$e = (e) => ({
  animationDuration: e,
  animationFillMode: "both"
}), x6 = function(e, t, n, r) {
  const o = (arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : !1) ? "&" : "";
  return {
    [`
      ${o}${e}-enter,
      ${o}${e}-appear
    `]: Object.assign(Object.assign({}, v$e(r)), {
      animationPlayState: "paused"
    }),
    [`${o}${e}-leave`]: Object.assign(Object.assign({}, y$e(r)), {
      animationPlayState: "paused"
    }),
    [`
      ${o}${e}-enter${e}-enter-active,
      ${o}${e}-appear${e}-appear-active
    `]: {
      animationName: t,
      animationPlayState: "running"
    },
    [`${o}${e}-leave${e}-leave-active`]: {
      animationName: n,
      animationPlayState: "running",
      pointerEvents: "none"
    }
  };
}, b$e = new $n("antMoveDownIn", {
  "0%": {
    transform: "translate3d(0, 100%, 0)",
    transformOrigin: "0 0",
    opacity: 0
  },
  "100%": {
    transform: "translate3d(0, 0, 0)",
    transformOrigin: "0 0",
    opacity: 1
  }
}), _$e = new $n("antMoveDownOut", {
  "0%": {
    transform: "translate3d(0, 0, 0)",
    transformOrigin: "0 0",
    opacity: 1
  },
  "100%": {
    transform: "translate3d(0, 100%, 0)",
    transformOrigin: "0 0",
    opacity: 0
  }
}), S$e = new $n("antMoveLeftIn", {
  "0%": {
    transform: "translate3d(-100%, 0, 0)",
    transformOrigin: "0 0",
    opacity: 0
  },
  "100%": {
    transform: "translate3d(0, 0, 0)",
    transformOrigin: "0 0",
    opacity: 1
  }
}), w$e = new $n("antMoveLeftOut", {
  "0%": {
    transform: "translate3d(0, 0, 0)",
    transformOrigin: "0 0",
    opacity: 1
  },
  "100%": {
    transform: "translate3d(-100%, 0, 0)",
    transformOrigin: "0 0",
    opacity: 0
  }
}), x$e = new $n("antMoveRightIn", {
  "0%": {
    transform: "translate3d(100%, 0, 0)",
    transformOrigin: "0 0",
    opacity: 0
  },
  "100%": {
    transform: "translate3d(0, 0, 0)",
    transformOrigin: "0 0",
    opacity: 1
  }
}), E$e = new $n("antMoveRightOut", {
  "0%": {
    transform: "translate3d(0, 0, 0)",
    transformOrigin: "0 0",
    opacity: 1
  },
  "100%": {
    transform: "translate3d(100%, 0, 0)",
    transformOrigin: "0 0",
    opacity: 0
  }
}), C$e = new $n("antMoveUpIn", {
  "0%": {
    transform: "translate3d(0, -100%, 0)",
    transformOrigin: "0 0",
    opacity: 0
  },
  "100%": {
    transform: "translate3d(0, 0, 0)",
    transformOrigin: "0 0",
    opacity: 1
  }
}), T$e = new $n("antMoveUpOut", {
  "0%": {
    transform: "translate3d(0, 0, 0)",
    transformOrigin: "0 0",
    opacity: 1
  },
  "100%": {
    transform: "translate3d(0, -100%, 0)",
    transformOrigin: "0 0",
    opacity: 0
  }
}), I$e = {
  "move-up": {
    inKeyframes: C$e,
    outKeyframes: T$e
  },
  "move-down": {
    inKeyframes: b$e,
    outKeyframes: _$e
  },
  "move-left": {
    inKeyframes: S$e,
    outKeyframes: w$e
  },
  "move-right": {
    inKeyframes: x$e,
    outKeyframes: E$e
  }
}, gL = (e, t) => {
  const {
    antCls: n
  } = e, r = `${n}-${t}`, {
    inKeyframes: i,
    outKeyframes: o
  } = I$e[t];
  return [x6(r, i, o, e.motionDurationMid), {
    [`
        ${r}-enter,
        ${r}-appear
      `]: {
      opacity: 0,
      animationTimingFunction: e.motionEaseOutCirc
    },
    [`${r}-leave`]: {
      animationTimingFunction: e.motionEaseInOutCirc
    }
  }];
}, bQ = new $n("antSlideUpIn", {
  "0%": {
    transform: "scaleY(0.8)",
    transformOrigin: "0% 0%",
    opacity: 0
  },
  "100%": {
    transform: "scaleY(1)",
    transformOrigin: "0% 0%",
    opacity: 1
  }
}), _Q = new $n("antSlideUpOut", {
  "0%": {
    transform: "scaleY(1)",
    transformOrigin: "0% 0%",
    opacity: 1
  },
  "100%": {
    transform: "scaleY(0.8)",
    transformOrigin: "0% 0%",
    opacity: 0
  }
}), SQ = new $n("antSlideDownIn", {
  "0%": {
    transform: "scaleY(0.8)",
    transformOrigin: "100% 100%",
    opacity: 0
  },
  "100%": {
    transform: "scaleY(1)",
    transformOrigin: "100% 100%",
    opacity: 1
  }
}), wQ = new $n("antSlideDownOut", {
  "0%": {
    transform: "scaleY(1)",
    transformOrigin: "100% 100%",
    opacity: 1
  },
  "100%": {
    transform: "scaleY(0.8)",
    transformOrigin: "100% 100%",
    opacity: 0
  }
}), A$e = new $n("antSlideLeftIn", {
  "0%": {
    transform: "scaleX(0.8)",
    transformOrigin: "0% 0%",
    opacity: 0
  },
  "100%": {
    transform: "scaleX(1)",
    transformOrigin: "0% 0%",
    opacity: 1
  }
}), R$e = new $n("antSlideLeftOut", {
  "0%": {
    transform: "scaleX(1)",
    transformOrigin: "0% 0%",
    opacity: 1
  },
  "100%": {
    transform: "scaleX(0.8)",
    transformOrigin: "0% 0%",
    opacity: 0
  }
}), $$e = new $n("antSlideRightIn", {
  "0%": {
    transform: "scaleX(0.8)",
    transformOrigin: "100% 0%",
    opacity: 0
  },
  "100%": {
    transform: "scaleX(1)",
    transformOrigin: "100% 0%",
    opacity: 1
  }
}), O$e = new $n("antSlideRightOut", {
  "0%": {
    transform: "scaleX(1)",
    transformOrigin: "100% 0%",
    opacity: 1
  },
  "100%": {
    transform: "scaleX(0.8)",
    transformOrigin: "100% 0%",
    opacity: 0
  }
}), P$e = {
  "slide-up": {
    inKeyframes: bQ,
    outKeyframes: _Q
  },
  "slide-down": {
    inKeyframes: SQ,
    outKeyframes: wQ
  },
  "slide-left": {
    inKeyframes: A$e,
    outKeyframes: R$e
  },
  "slide-right": {
    inKeyframes: $$e,
    outKeyframes: O$e
  }
}, pL = (e, t) => {
  const {
    antCls: n
  } = e, r = `${n}-${t}`, {
    inKeyframes: i,
    outKeyframes: o
  } = P$e[t];
  return [x6(r, i, o, e.motionDurationMid), {
    [`
      ${r}-enter,
      ${r}-appear
    `]: {
      transform: "scale(0)",
      transformOrigin: "0% 0%",
      opacity: 0,
      animationTimingFunction: e.motionEaseOutQuint,
      "&-prepare": {
        transform: "scale(1)"
      }
    },
    [`${r}-leave`]: {
      animationTimingFunction: e.motionEaseInQuint
    }
  }];
}, M$e = new $n("antZoomIn", {
  "0%": {
    transform: "scale(0.2)",
    opacity: 0
  },
  "100%": {
    transform: "scale(1)",
    opacity: 1
  }
}), k$e = new $n("antZoomOut", {
  "0%": {
    transform: "scale(1)"
  },
  "100%": {
    transform: "scale(0.2)",
    opacity: 0
  }
}), mL = new $n("antZoomBigIn", {
  "0%": {
    transform: "scale(0.8)",
    opacity: 0
  },
  "100%": {
    transform: "scale(1)",
    opacity: 1
  }
}), vL = new $n("antZoomBigOut", {
  "0%": {
    transform: "scale(1)"
  },
  "100%": {
    transform: "scale(0.8)",
    opacity: 0
  }
}), N$e = new $n("antZoomUpIn", {
  "0%": {
    transform: "scale(0.8)",
    transformOrigin: "50% 0%",
    opacity: 0
  },
  "100%": {
    transform: "scale(1)",
    transformOrigin: "50% 0%"
  }
}), D$e = new $n("antZoomUpOut", {
  "0%": {
    transform: "scale(1)",
    transformOrigin: "50% 0%"
  },
  "100%": {
    transform: "scale(0.8)",
    transformOrigin: "50% 0%",
    opacity: 0
  }
}), L$e = new $n("antZoomLeftIn", {
  "0%": {
    transform: "scale(0.8)",
    transformOrigin: "0% 50%",
    opacity: 0
  },
  "100%": {
    transform: "scale(1)",
    transformOrigin: "0% 50%"
  }
}), j$e = new $n("antZoomLeftOut", {
  "0%": {
    transform: "scale(1)",
    transformOrigin: "0% 50%"
  },
  "100%": {
    transform: "scale(0.8)",
    transformOrigin: "0% 50%",
    opacity: 0
  }
}), F$e = new $n("antZoomRightIn", {
  "0%": {
    transform: "scale(0.8)",
    transformOrigin: "100% 50%",
    opacity: 0
  },
  "100%": {
    transform: "scale(1)",
    transformOrigin: "100% 50%"
  }
}), V$e = new $n("antZoomRightOut", {
  "0%": {
    transform: "scale(1)",
    transformOrigin: "100% 50%"
  },
  "100%": {
    transform: "scale(0.8)",
    transformOrigin: "100% 50%",
    opacity: 0
  }
}), B$e = new $n("antZoomDownIn", {
  "0%": {
    transform: "scale(0.8)",
    transformOrigin: "50% 100%",
    opacity: 0
  },
  "100%": {
    transform: "scale(1)",
    transformOrigin: "50% 100%"
  }
}), z$e = new $n("antZoomDownOut", {
  "0%": {
    transform: "scale(1)",
    transformOrigin: "50% 100%"
  },
  "100%": {
    transform: "scale(0.8)",
    transformOrigin: "50% 100%",
    opacity: 0
  }
}), H$e = {
  zoom: {
    inKeyframes: M$e,
    outKeyframes: k$e
  },
  "zoom-big": {
    inKeyframes: mL,
    outKeyframes: vL
  },
  "zoom-big-fast": {
    inKeyframes: mL,
    outKeyframes: vL
  },
  "zoom-left": {
    inKeyframes: L$e,
    outKeyframes: j$e
  },
  "zoom-right": {
    inKeyframes: F$e,
    outKeyframes: V$e
  },
  "zoom-up": {
    inKeyframes: N$e,
    outKeyframes: D$e
  },
  "zoom-down": {
    inKeyframes: B$e,
    outKeyframes: z$e
  }
}, U$e = (e, t) => {
  const {
    antCls: n
  } = e, r = `${n}-${t}`, {
    inKeyframes: i,
    outKeyframes: o
  } = H$e[t];
  return [x6(r, i, o, t === "zoom-big-fast" ? e.motionDurationFast : e.motionDurationMid), {
    [`
        ${r}-enter,
        ${r}-appear
      `]: {
      transform: "scale(0)",
      opacity: 0,
      animationTimingFunction: e.motionEaseOutCirc,
      "&-prepare": {
        transform: "none"
      }
    },
    [`${r}-leave`]: {
      animationTimingFunction: e.motionEaseInOutCirc
    }
  }];
}, W$e = (e, t) => {
  const {
    r: n,
    g: r,
    b: i,
    a: o
  } = e.toRgb(), a = new ul(e.toRgbString()).onBackground(t).toHsv();
  return o <= 0.5 ? a.v > 0.5 : n * 0.299 + r * 0.587 + i * 0.114 > 192;
}, xQ = (e) => {
  const {
    paddingInline: t,
    onlyIconSize: n,
    paddingBlock: r
  } = e;
  return Or(e, {
    buttonPaddingHorizontal: t,
    buttonPaddingVertical: r,
    buttonIconOnlyFontSize: n
  });
}, EQ = (e) => {
  var t, n, r, i, o, a;
  const s = (t = e.contentFontSize) !== null && t !== void 0 ? t : e.fontSize, c = (n = e.contentFontSizeSM) !== null && n !== void 0 ? n : e.fontSize, l = (r = e.contentFontSizeLG) !== null && r !== void 0 ? r : e.fontSizeLG, u = (i = e.contentLineHeight) !== null && i !== void 0 ? i : W1(s), d = (o = e.contentLineHeightSM) !== null && o !== void 0 ? o : W1(c), f = (a = e.contentLineHeightLG) !== null && a !== void 0 ? a : W1(l), h = W$e(new f$e(e.colorBgSolid), "#fff") ? "#000" : "#fff";
  return {
    fontWeight: 400,
    defaultShadow: `0 ${e.controlOutlineWidth}px 0 ${e.controlTmpOutline}`,
    primaryShadow: `0 ${e.controlOutlineWidth}px 0 ${e.controlOutline}`,
    dangerShadow: `0 ${e.controlOutlineWidth}px 0 ${e.colorErrorOutline}`,
    primaryColor: e.colorTextLightSolid,
    dangerColor: e.colorTextLightSolid,
    borderColorDisabled: e.colorBorder,
    defaultGhostColor: e.colorBgContainer,
    ghostBg: "transparent",
    defaultGhostBorderColor: e.colorBgContainer,
    paddingInline: e.paddingContentHorizontal - e.lineWidth,
    paddingInlineLG: e.paddingContentHorizontal - e.lineWidth,
    paddingInlineSM: 8 - e.lineWidth,
    onlyIconSize: e.fontSizeLG,
    onlyIconSizeSM: e.fontSizeLG - 2,
    onlyIconSizeLG: e.fontSizeLG + 2,
    groupBorderColor: e.colorPrimaryHover,
    linkHoverBg: "transparent",
    textTextColor: e.colorText,
    textTextHoverColor: e.colorText,
    textTextActiveColor: e.colorText,
    textHoverBg: e.colorFillTertiary,
    defaultColor: e.colorText,
    defaultBg: e.colorBgContainer,
    defaultBorderColor: e.colorBorder,
    defaultBorderColorDisabled: e.colorBorder,
    defaultHoverBg: e.colorBgContainer,
    defaultHoverColor: e.colorPrimaryHover,
    defaultHoverBorderColor: e.colorPrimaryHover,
    defaultActiveBg: e.colorBgContainer,
    defaultActiveColor: e.colorPrimaryActive,
    defaultActiveBorderColor: e.colorPrimaryActive,
    solidTextColor: h,
    contentFontSize: s,
    contentFontSizeSM: c,
    contentFontSizeLG: l,
    contentLineHeight: u,
    contentLineHeightSM: d,
    contentLineHeightLG: f,
    paddingBlock: Math.max((e.controlHeight - s * u) / 2 - e.lineWidth, 0),
    paddingBlockSM: Math.max((e.controlHeightSM - c * d) / 2 - e.lineWidth, 0),
    paddingBlockLG: Math.max((e.controlHeightLG - l * f) / 2 - e.lineWidth, 0)
  };
}, q$e = (e) => {
  const {
    componentCls: t,
    iconCls: n,
    fontWeight: r
  } = e;
  return {
    [t]: {
      outline: "none",
      position: "relative",
      display: "inline-flex",
      gap: e.marginXS,
      alignItems: "center",
      justifyContent: "center",
      fontWeight: r,
      whiteSpace: "nowrap",
      textAlign: "center",
      backgroundImage: "none",
      background: "transparent",
      border: `${Qe(e.lineWidth)} ${e.lineType} transparent`,
      cursor: "pointer",
      transition: `all ${e.motionDurationMid} ${e.motionEaseInOut}`,
      userSelect: "none",
      touchAction: "manipulation",
      color: e.colorText,
      "&:disabled > *": {
        pointerEvents: "none"
      },
      "> span": {
        display: "inline-block"
      },
      [`${t}-icon`]: {
        lineHeight: 1
      },
      "> a": {
        color: "currentColor"
      },
      "&:not(:disabled)": Object.assign({}, vIe(e)),
      [`&${t}-two-chinese-chars::first-letter`]: {
        letterSpacing: "0.34em"
      },
      [`&${t}-two-chinese-chars > *:not(${n})`]: {
        marginInlineEnd: "-0.34em",
        letterSpacing: "0.34em"
      },
      // iconPosition="end"
      "&-icon-end": {
        flexDirection: "row-reverse"
      }
    }
  };
}, CQ = (e, t, n) => ({
  [`&:not(:disabled):not(${e}-disabled)`]: {
    "&:hover": t,
    "&:active": n
  }
}), G$e = (e) => ({
  minWidth: e.controlHeight,
  paddingInlineStart: 0,
  paddingInlineEnd: 0,
  borderRadius: "50%"
}), K$e = (e) => ({
  borderRadius: e.controlHeight,
  paddingInlineStart: e.calc(e.controlHeight).div(2).equal(),
  paddingInlineEnd: e.calc(e.controlHeight).div(2).equal()
}), Y$e = (e) => ({
  cursor: "not-allowed",
  borderColor: e.borderColorDisabled,
  color: e.colorTextDisabled,
  background: e.colorBgContainerDisabled,
  boxShadow: "none"
}), E6 = (e, t, n, r, i, o, a, s) => ({
  [`&${e}-background-ghost`]: Object.assign(Object.assign({
    color: n || void 0,
    background: t,
    borderColor: r || void 0,
    boxShadow: "none"
  }, CQ(e, Object.assign({
    background: t
  }, a), Object.assign({
    background: t
  }, s))), {
    "&:disabled": {
      cursor: "not-allowed",
      color: i || void 0,
      borderColor: o || void 0
    }
  })
}), X$e = (e) => ({
  [`&:disabled, &${e.componentCls}-disabled`]: Object.assign({}, Y$e(e))
}), Q$e = (e) => ({
  [`&:disabled, &${e.componentCls}-disabled`]: {
    cursor: "not-allowed",
    color: e.colorTextDisabled
  }
}), nE = (e, t, n, r) => {
  const o = r && ["link", "text"].includes(r) ? Q$e : X$e;
  return Object.assign(Object.assign({}, o(e)), CQ(e.componentCls, t, n));
}, C6 = (e, t, n, r, i) => ({
  [`&${e.componentCls}-variant-solid`]: Object.assign({
    color: t,
    background: n
  }, nE(e, r, i))
}), T6 = (e, t, n, r, i) => ({
  [`&${e.componentCls}-variant-outlined, &${e.componentCls}-variant-dashed`]: Object.assign({
    borderColor: t,
    background: n
  }, nE(e, r, i))
}), I6 = (e) => ({
  [`&${e.componentCls}-variant-dashed`]: {
    borderStyle: "dashed"
  }
}), A6 = (e, t, n, r) => ({
  [`&${e.componentCls}-variant-filled`]: Object.assign({
    boxShadow: "none",
    background: t
  }, nE(e, n, r))
}), Dg = (e, t, n, r, i) => ({
  [`&${e.componentCls}-variant-${n}`]: Object.assign({
    color: t,
    boxShadow: "none"
  }, nE(e, r, i, n))
}), J$e = (e) => Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({
  color: e.defaultColor,
  boxShadow: e.defaultShadow
}, C6(e, e.solidTextColor, e.colorBgSolid, {
  background: e.colorBgSolidHover
}, {
  background: e.colorBgSolidActive
})), I6(e)), A6(e, e.colorFillTertiary, {
  background: e.colorFillSecondary
}, {
  background: e.colorFill
})), Dg(e, e.textTextColor, "link", {
  color: e.colorLinkHover,
  background: e.linkHoverBg
}, {
  color: e.colorLinkActive
})), E6(e.componentCls, e.ghostBg, e.defaultGhostColor, e.defaultGhostBorderColor, e.colorTextDisabled, e.colorBorder)), Z$e = (e) => Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({
  color: e.colorPrimary,
  boxShadow: e.primaryShadow
}, T6(e, e.colorPrimary, e.colorBgContainer, {
  color: e.colorPrimaryTextHover,
  borderColor: e.colorPrimaryHover,
  background: e.colorBgContainer
}, {
  color: e.colorPrimaryTextActive,
  borderColor: e.colorPrimaryActive,
  background: e.colorBgContainer
})), I6(e)), A6(e, e.colorPrimaryBg, {
  background: e.colorPrimaryBgHover
}, {
  background: e.colorPrimaryBorder
})), Dg(e, e.colorLink, "text", {
  color: e.colorPrimaryTextHover,
  background: e.colorPrimaryBg
}, {
  color: e.colorPrimaryTextActive,
  background: e.colorPrimaryBorder
})), E6(e.componentCls, e.ghostBg, e.colorPrimary, e.colorPrimary, e.colorTextDisabled, e.colorBorder, {
  color: e.colorPrimaryHover,
  borderColor: e.colorPrimaryHover
}, {
  color: e.colorPrimaryActive,
  borderColor: e.colorPrimaryActive
})), eOe = (e) => Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({
  color: e.colorError,
  boxShadow: e.dangerShadow
}, C6(e, e.dangerColor, e.colorError, {
  background: e.colorErrorHover
}, {
  background: e.colorErrorActive
})), T6(e, e.colorError, e.colorBgContainer, {
  color: e.colorErrorHover,
  borderColor: e.colorErrorBorderHover
}, {
  color: e.colorErrorActive,
  borderColor: e.colorErrorActive
})), I6(e)), A6(e, e.colorErrorBg, {
  background: e.colorErrorBgFilledHover
}, {
  background: e.colorErrorBgActive
})), Dg(e, e.colorError, "text", {
  color: e.colorErrorHover,
  background: e.colorErrorBg
}, {
  color: e.colorErrorHover,
  background: e.colorErrorBgActive
})), Dg(e, e.colorError, "link", {
  color: e.colorErrorHover
}, {
  color: e.colorErrorActive
})), E6(e.componentCls, e.ghostBg, e.colorError, e.colorError, e.colorTextDisabled, e.colorBorder, {
  color: e.colorErrorHover,
  borderColor: e.colorErrorHover
}, {
  color: e.colorErrorActive,
  borderColor: e.colorErrorActive
})), tOe = (e) => {
  const {
    componentCls: t
  } = e;
  return {
    [`${t}-color-default`]: J$e(e),
    [`${t}-color-primary`]: Z$e(e),
    [`${t}-color-dangerous`]: eOe(e)
  };
}, nOe = (e) => Object.assign(Object.assign(Object.assign(Object.assign({}, T6(e, e.defaultBorderColor, e.defaultBg, {
  color: e.defaultHoverColor,
  borderColor: e.defaultHoverBorderColor,
  background: e.defaultHoverBg
}, {
  color: e.defaultActiveColor,
  borderColor: e.defaultActiveBorderColor,
  background: e.defaultActiveBg
})), Dg(e, e.textTextColor, "text", {
  color: e.textTextHoverColor,
  background: e.textHoverBg
}, {
  color: e.textTextActiveColor,
  background: e.colorBgTextActive
})), C6(e, e.primaryColor, e.colorPrimary, {
  background: e.colorPrimaryHover,
  color: e.primaryColor
}, {
  background: e.colorPrimaryActive,
  color: e.primaryColor
})), Dg(e, e.colorLink, "link", {
  color: e.colorLinkHover,
  background: e.linkHoverBg
}, {
  color: e.colorLinkActive
})), R6 = function(e) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
  const {
    componentCls: n,
    controlHeight: r,
    fontSize: i,
    lineHeight: o,
    borderRadius: a,
    buttonPaddingHorizontal: s,
    iconCls: c,
    buttonPaddingVertical: l
  } = e, u = `${n}-icon-only`;
  return [
    {
      [t]: {
        fontSize: i,
        lineHeight: o,
        height: r,
        padding: `${Qe(l)} ${Qe(s)}`,
        borderRadius: a,
        [`&${u}`]: {
          width: r,
          paddingInline: 0,
          // make `btn-icon-only` not too narrow
          [`&${n}-compact-item`]: {
            flex: "none"
          },
          [`&${n}-round`]: {
            width: "auto"
          },
          [c]: {
            fontSize: e.buttonIconOnlyFontSize
          }
        },
        // Loading
        [`&${n}-loading`]: {
          opacity: e.opacityLoading,
          cursor: "default"
        },
        [`${n}-loading-icon`]: {
          transition: `width ${e.motionDurationSlow} ${e.motionEaseInOut}, opacity ${e.motionDurationSlow} ${e.motionEaseInOut}`
        }
      }
    },
    // Shape - patch prefixCls again to override solid border radius style
    {
      [`${n}${n}-circle${t}`]: G$e(e)
    },
    {
      [`${n}${n}-round${t}`]: K$e(e)
    }
  ];
}, rOe = (e) => {
  const t = Or(e, {
    fontSize: e.contentFontSize,
    lineHeight: e.contentLineHeight
  });
  return R6(t, e.componentCls);
}, iOe = (e) => {
  const t = Or(e, {
    controlHeight: e.controlHeightSM,
    fontSize: e.contentFontSizeSM,
    lineHeight: e.contentLineHeightSM,
    padding: e.paddingXS,
    buttonPaddingHorizontal: e.paddingInlineSM,
    buttonPaddingVertical: e.paddingBlockSM,
    borderRadius: e.borderRadiusSM,
    buttonIconOnlyFontSize: e.onlyIconSizeSM
  });
  return R6(t, `${e.componentCls}-sm`);
}, oOe = (e) => {
  const t = Or(e, {
    controlHeight: e.controlHeightLG,
    fontSize: e.contentFontSizeLG,
    lineHeight: e.contentLineHeightLG,
    buttonPaddingHorizontal: e.paddingInlineLG,
    buttonPaddingVertical: e.paddingBlockLG,
    borderRadius: e.borderRadiusLG,
    buttonIconOnlyFontSize: e.onlyIconSizeLG
  });
  return R6(t, `${e.componentCls}-lg`);
}, aOe = (e) => {
  const {
    componentCls: t
  } = e;
  return {
    [t]: {
      [`&${t}-block`]: {
        width: "100%"
      }
    }
  };
}, sOe = qa("Button", (e) => {
  const t = xQ(e);
  return [
    // Shared
    q$e(t),
    // Size
    rOe(t),
    iOe(t),
    oOe(t),
    // Block
    aOe(t),
    // Color
    tOe(t),
    // https://github.com/ant-design/ant-design/issues/50969
    nOe(t),
    // Button Group
    YRe(t)
  ];
}, EQ, {
  unitless: {
    fontWeight: !0,
    contentLineHeight: !0,
    contentLineHeightSM: !0,
    contentLineHeightLG: !0
  }
});
function cOe(e, t, n) {
  const {
    focusElCls: r,
    focus: i,
    borderElCls: o
  } = n, a = o ? "> *" : "", s = ["hover", i ? "focus" : null, "active"].filter(Boolean).map((c) => `&:${c} ${a}`).join(",");
  return {
    [`&-item:not(${t}-last-item)`]: {
      marginInlineEnd: e.calc(e.lineWidth).mul(-1).equal()
    },
    "&-item": Object.assign(Object.assign({
      [s]: {
        zIndex: 2
      }
    }, r ? {
      [`&${r}`]: {
        zIndex: 2
      }
    } : {}), {
      [`&[disabled] ${a}`]: {
        zIndex: 0
      }
    })
  };
}
function lOe(e, t, n) {
  const {
    borderElCls: r
  } = n, i = r ? `> ${r}` : "";
  return {
    [`&-item:not(${t}-first-item):not(${t}-last-item) ${i}`]: {
      borderRadius: 0
    },
    [`&-item:not(${t}-last-item)${t}-first-item`]: {
      [`& ${i}, &${e}-sm ${i}, &${e}-lg ${i}`]: {
        borderStartEndRadius: 0,
        borderEndEndRadius: 0
      }
    },
    [`&-item:not(${t}-first-item)${t}-last-item`]: {
      [`& ${i}, &${e}-sm ${i}, &${e}-lg ${i}`]: {
        borderStartStartRadius: 0,
        borderEndStartRadius: 0
      }
    }
  };
}
function rE(e) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
    focus: !0
  };
  const {
    componentCls: n
  } = e, r = `${n}-compact`;
  return {
    [r]: Object.assign(Object.assign({}, cOe(e, r, t)), lOe(n, r, t))
  };
}
function uOe(e, t) {
  return {
    // border collapse
    [`&-item:not(${t}-last-item)`]: {
      marginBottom: e.calc(e.lineWidth).mul(-1).equal()
    },
    "&-item": {
      "&:hover,&:focus,&:active": {
        zIndex: 2
      },
      "&[disabled]": {
        zIndex: 0
      }
    }
  };
}
function dOe(e, t) {
  return {
    [`&-item:not(${t}-first-item):not(${t}-last-item)`]: {
      borderRadius: 0
    },
    [`&-item${t}-first-item:not(${t}-last-item)`]: {
      [`&, &${e}-sm, &${e}-lg`]: {
        borderEndEndRadius: 0,
        borderEndStartRadius: 0
      }
    },
    [`&-item${t}-last-item:not(${t}-first-item)`]: {
      [`&, &${e}-sm, &${e}-lg`]: {
        borderStartStartRadius: 0,
        borderStartEndRadius: 0
      }
    }
  };
}
function fOe(e) {
  const t = `${e.componentCls}-compact-vertical`;
  return {
    [t]: Object.assign(Object.assign({}, uOe(e, t)), dOe(e.componentCls, t))
  };
}
const hOe = (e) => {
  const {
    componentCls: t,
    calc: n
  } = e;
  return {
    [t]: {
      // Special styles for Primary Button
      [`&-compact-item${t}-primary`]: {
        [`&:not([disabled]) + ${t}-compact-item${t}-primary:not([disabled])`]: {
          position: "relative",
          "&:before": {
            position: "absolute",
            top: n(e.lineWidth).mul(-1).equal(),
            insetInlineStart: n(e.lineWidth).mul(-1).equal(),
            display: "inline-block",
            width: e.lineWidth,
            height: `calc(100% + ${Qe(e.lineWidth)} * 2)`,
            backgroundColor: e.colorPrimaryHover,
            content: '""'
          }
        }
      },
      // Special styles for Primary Button
      "&-compact-vertical-item": {
        [`&${t}-primary`]: {
          [`&:not([disabled]) + ${t}-compact-vertical-item${t}-primary:not([disabled])`]: {
            position: "relative",
            "&:before": {
              position: "absolute",
              top: n(e.lineWidth).mul(-1).equal(),
              insetInlineStart: n(e.lineWidth).mul(-1).equal(),
              display: "inline-block",
              width: `calc(100% + ${Qe(e.lineWidth)} * 2)`,
              height: e.lineWidth,
              backgroundColor: e.colorPrimaryHover,
              content: '""'
            }
          }
        }
      }
    }
  };
}, gOe = _Ie(["Button", "compact"], (e) => {
  const t = xQ(e);
  return [
    // Space Compact
    rE(t),
    fOe(t),
    hOe(t)
  ];
}, EQ);
var pOe = globalThis && globalThis.__rest || function(e, t) {
  var n = {};
  for (var r in e)
    Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var i = 0, r = Object.getOwnPropertySymbols(e); i < r.length; i++)
      t.indexOf(r[i]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[i]) && (n[r[i]] = e[r[i]]);
  return n;
};
function mOe(e) {
  if (typeof e == "object" && e) {
    let t = e == null ? void 0 : e.delay;
    return t = !Number.isNaN(t) && typeof t == "number" ? t : 0, {
      loading: t <= 0,
      delay: t
    };
  }
  return {
    loading: !!e,
    delay: 0
  };
}
const vOe = {
  default: ["default", "outlined"],
  primary: ["primary", "solid"],
  dashed: ["default", "dashed"],
  link: ["primary", "link"],
  text: ["default", "text"]
}, yOe = /* @__PURE__ */ D.forwardRef((e, t) => {
  var n, r, i, o;
  const {
    loading: a = !1,
    prefixCls: s,
    color: c,
    variant: l,
    type: u,
    danger: d = !1,
    shape: f = "default",
    size: h,
    styles: p,
    disabled: g,
    className: m,
    rootClassName: v,
    children: y,
    icon: S,
    iconPosition: _ = "start",
    ghost: w = !1,
    block: T = !1,
    // React does not recognize the `htmlType` prop on a DOM element. Here we pick it out of `rest`.
    htmlType: x = "button",
    classNames: C,
    style: E = {},
    autoInsertSpace: R
  } = e, A = pOe(e, ["loading", "prefixCls", "color", "variant", "type", "danger", "shape", "size", "styles", "disabled", "className", "rootClassName", "children", "icon", "iconPosition", "ghost", "block", "htmlType", "classNames", "style", "autoInsertSpace"]), O = u || "default", [$, N] = At(() => {
    if (c && l)
      return [c, l];
    const ft = vOe[O] || [];
    return d ? ["danger", ft[1]] : ft;
  }, [u, c, l, d]), k = $ === "danger" ? "dangerous" : $, {
    getPrefixCls: F,
    direction: V,
    button: j
  } = St(En), B = (n = R ?? (j == null ? void 0 : j.autoInsertSpace)) !== null && n !== void 0 ? n : !0, U = F("btn", s), [Q, K, q] = sOe(U), X = St(Uu), ie = g ?? X, te = St(uQ), J = At(() => mOe(a), [a]), [Y, ee] = Lt(J.loading), [Z, H] = Lt(!1), W = Wa(t, /* @__PURE__ */ Jse()), se = Qse.count(y) === 1 && !S && !qb(N);
  gt(() => {
    let ft = null;
    J.delay > 0 ? ft = setTimeout(() => {
      ft = null, ee(!0);
    }, J.delay) : ee(J.loading);
    function wt() {
      ft && (clearTimeout(ft), ft = null);
    }
    return wt;
  }, [J]), gt(() => {
    if (!W || !W.current || !B)
      return;
    const ft = W.current.textContent;
    se && iR(ft) ? Z || H(!0) : Z && H(!1);
  }, [W]);
  const ce = D.useCallback((ft) => {
    var wt;
    if (Y || ie) {
      ft.preventDefault();
      return;
    }
    (wt = e.onClick) === null || wt === void 0 || wt.call(e, ft);
  }, [e.onClick, Y, ie]);
  if (process.env.NODE_ENV !== "production") {
    const ft = di("Button");
    process.env.NODE_ENV !== "production" && ft(!(typeof S == "string" && S.length > 2), "breaking", `\`icon\` is using ReactNode instead of string naming in v4. Please check \`${S}\` at https://ant.design/components/icon`), process.env.NODE_ENV !== "production" && ft(!(w && qb(N)), "usage", "`link` or `text` button can't be a `ghost` button.");
  }
  const {
    compactSize: ge,
    compactItemClassnames: he
  } = cy(U, V), ue = {
    large: "lg",
    small: "sm",
    middle: void 0
  }, Ee = Rf((ft) => {
    var wt, Ge;
    return (Ge = (wt = h ?? ge) !== null && wt !== void 0 ? wt : te) !== null && Ge !== void 0 ? Ge : ft;
  }), pe = Ee && (r = ue[Ee]) !== null && r !== void 0 ? r : "", Oe = Y ? "loading" : S, de = Hu(A, ["navigate"]), be = we(U, K, q, {
    [`${U}-${f}`]: f !== "default" && f,
    // line(253 - 254): Compatible with versions earlier than 5.21.0
    [`${U}-${O}`]: O,
    [`${U}-dangerous`]: d,
    [`${U}-color-${k}`]: k,
    [`${U}-variant-${N}`]: N,
    [`${U}-${pe}`]: pe,
    [`${U}-icon-only`]: !y && y !== 0 && !!Oe,
    [`${U}-background-ghost`]: w && !qb(N),
    [`${U}-loading`]: Y,
    [`${U}-two-chinese-chars`]: Z && B && !Y,
    [`${U}-block`]: T,
    [`${U}-rtl`]: V === "rtl",
    [`${U}-icon-end`]: _ === "end"
  }, he, m, v, j == null ? void 0 : j.className), Ie = Object.assign(Object.assign({}, j == null ? void 0 : j.style), E), Ve = we(C == null ? void 0 : C.icon, (i = j == null ? void 0 : j.classNames) === null || i === void 0 ? void 0 : i.icon), Fe = Object.assign(Object.assign({}, (p == null ? void 0 : p.icon) || {}), ((o = j == null ? void 0 : j.styles) === null || o === void 0 ? void 0 : o.icon) || {}), Pe = S && !Y ? /* @__PURE__ */ D.createElement(dQ, {
    prefixCls: U,
    className: Ve,
    style: Fe
  }, S) : /* @__PURE__ */ D.createElement(GRe, {
    existIcon: !!S,
    prefixCls: U,
    loading: Y
  }), ot = y || y === 0 ? URe(y, se && B) : null;
  if (de.href !== void 0)
    return Q(/* @__PURE__ */ D.createElement("a", Object.assign({}, de, {
      className: we(be, {
        [`${U}-disabled`]: ie
      }),
      href: ie ? void 0 : de.href,
      style: Ie,
      onClick: ce,
      ref: W,
      tabIndex: ie ? -1 : 0
    }), Pe, ot));
  let dt = /* @__PURE__ */ D.createElement("button", Object.assign({}, A, {
    type: x,
    className: be,
    style: Ie,
    onClick: ce,
    disabled: ie,
    ref: W
  }), Pe, ot, !!he && /* @__PURE__ */ D.createElement(gOe, {
    key: "compact",
    prefixCls: U
  }));
  return qb(N) || (dt = /* @__PURE__ */ D.createElement(LRe, {
    component: "Button",
    disabled: Y
  }, dt)), Q(dt);
}), iE = yOe;
iE.Group = zRe;
iE.__ANT_BUTTON = !0;
process.env.NODE_ENV !== "production" && (iE.displayName = "Button");
const bOe = iE;
var TQ = /* @__PURE__ */ I.createContext(null), yL = [];
function _Oe(e, t) {
  var n = I.useState(function() {
    if (!ao())
      return null;
    var p = document.createElement("div");
    return process.env.NODE_ENV !== "production" && t && p.setAttribute("data-debug", t), p;
  }), r = fe(n, 1), i = r[0], o = I.useRef(!1), a = I.useContext(TQ), s = I.useState(yL), c = fe(s, 2), l = c[0], u = c[1], d = a || (o.current ? void 0 : function(p) {
    u(function(g) {
      var m = [p].concat(Je(g));
      return m;
    });
  });
  function f() {
    i.parentElement || document.body.appendChild(i), o.current = !0;
  }
  function h() {
    var p;
    (p = i.parentElement) === null || p === void 0 || p.removeChild(i), o.current = !1;
  }
  return nr(function() {
    return e ? a ? a(f) : f() : h(), h;
  }, [e]), nr(function() {
    l.length && (l.forEach(function(p) {
      return p();
    }), u(yL));
  }, [l]), [i, d];
}
function SOe(e) {
  var t = "rc-scrollbar-measure-".concat(Math.random().toString(36).substring(7)), n = document.createElement("div");
  n.id = t;
  var r = n.style;
  r.position = "absolute", r.left = "0", r.top = "0", r.width = "100px", r.height = "100px", r.overflow = "scroll";
  var i, o;
  if (e) {
    var a = getComputedStyle(e);
    r.scrollbarColor = a.scrollbarColor, r.scrollbarWidth = a.scrollbarWidth;
    var s = getComputedStyle(e, "::-webkit-scrollbar"), c = parseInt(s.width, 10), l = parseInt(s.height, 10);
    try {
      var u = c ? "width: ".concat(s.width, ";") : "", d = l ? "height: ".concat(s.height, ";") : "";
      cc(`
#`.concat(t, `::-webkit-scrollbar {
`).concat(u, `
`).concat(d, `
}`), t);
    } catch (p) {
      console.error(p), i = c, o = l;
    }
  }
  document.body.appendChild(n);
  var f = e && i && !isNaN(i) ? i : n.offsetWidth - n.clientWidth, h = e && o && !isNaN(o) ? o : n.offsetHeight - n.clientHeight;
  return document.body.removeChild(n), Tg(t), {
    width: f,
    height: h
  };
}
function wOe(e) {
  return typeof document > "u" || !e || !(e instanceof Element) ? {
    width: 0,
    height: 0
  } : SOe(e);
}
function xOe() {
  return document.body.scrollHeight > (window.innerHeight || document.documentElement.clientHeight) && window.innerWidth > document.body.offsetWidth;
}
var EOe = "rc-util-locker-".concat(Date.now()), bL = 0;
function COe(e) {
  var t = !!e, n = I.useState(function() {
    return bL += 1, "".concat(EOe, "_").concat(bL);
  }), r = fe(n, 1), i = r[0];
  nr(function() {
    if (t) {
      var o = wOe(document.body).width, a = xOe();
      cc(`
html body {
  overflow-y: hidden;
  `.concat(a ? "width: calc(100% - ".concat(o, "px);") : "", `
}`), i);
    } else
      Tg(i);
    return function() {
      Tg(i);
    };
  }, [t, i]);
}
var _L = !1;
function TOe(e) {
  return typeof e == "boolean" && (_L = e), _L;
}
var SL = function(t) {
  return t === !1 ? !1 : !ao() || !t ? null : typeof t == "string" ? document.querySelector(t) : typeof t == "function" ? t() : t;
}, $6 = /* @__PURE__ */ I.forwardRef(function(e, t) {
  var n = e.open, r = e.autoLock, i = e.getContainer, o = e.debug, a = e.autoDestroy, s = a === void 0 ? !0 : a, c = e.children, l = I.useState(n), u = fe(l, 2), d = u[0], f = u[1], h = d || n;
  process.env.NODE_ENV !== "production" && an(ao() || !n, "Portal only work in client side. Please call 'useEffect' to show Portal instead default render in SSR."), I.useEffect(function() {
    (s || n) && f(n);
  }, [n, s]);
  var p = I.useState(function() {
    return SL(i);
  }), g = fe(p, 2), m = g[0], v = g[1];
  I.useEffect(function() {
    var O = SL(i);
    v(O ?? null);
  });
  var y = _Oe(h && !m, o), S = fe(y, 2), _ = S[0], w = S[1], T = m ?? _;
  COe(r && n && ao() && (T === _ || T === document.body));
  var x = null;
  if (c && ay(c) && t) {
    var C = c;
    x = C.ref;
  }
  var E = Vx(x, t);
  if (!h || !ao() || m === void 0)
    return null;
  var R = T === !1 || TOe(), A = c;
  return t && (A = /* @__PURE__ */ I.cloneElement(c, {
    ref: E
  })), /* @__PURE__ */ I.createElement(TQ.Provider, {
    value: w
  }, R ? A : /* @__PURE__ */ rO(A, T));
});
process.env.NODE_ENV !== "production" && ($6.displayName = "Portal");
function IOe() {
  var e = ae({}, I);
  return e.useId;
}
var wL = 0, xL = IOe();
const AOe = xL ? (
  // Use React `useId`
  function(t) {
    var n = xL();
    return t || (process.env.NODE_ENV === "test" ? "test-id" : n);
  }
) : (
  // Use compatible of `useId`
  function(t) {
    var n = I.useState("ssr-id"), r = fe(n, 2), i = r[0], o = r[1];
    return I.useEffect(function() {
      var a = wL;
      wL += 1, o("rc_unique_".concat(a));
    }, []), t || (process.env.NODE_ENV === "test" ? "test-id" : i);
  }
);
var xd = "RC_FORM_INTERNAL_HOOKS", Xn = function() {
  an(!1, "Can not find FormContext. Please make sure you wrap Field under Form.");
}, lf = /* @__PURE__ */ I.createContext({
  getFieldValue: Xn,
  getFieldsValue: Xn,
  getFieldError: Xn,
  getFieldWarning: Xn,
  getFieldsError: Xn,
  isFieldsTouched: Xn,
  isFieldTouched: Xn,
  isFieldValidating: Xn,
  isFieldsValidating: Xn,
  resetFields: Xn,
  setFields: Xn,
  setFieldValue: Xn,
  setFieldsValue: Xn,
  validateFields: Xn,
  submit: Xn,
  getInternalHooks: function() {
    return Xn(), {
      dispatch: Xn,
      initEntityValue: Xn,
      registerField: Xn,
      useSubscribe: Xn,
      setInitialValues: Xn,
      destroyForm: Xn,
      setCallbacks: Xn,
      registerWatch: Xn,
      getFields: Xn,
      setValidateMessages: Xn,
      setPreserve: Xn,
      getInitialValue: Xn
    };
  }
}), sv = /* @__PURE__ */ I.createContext(null);
function oR(e) {
  return e == null ? [] : Array.isArray(e) ? e : [e];
}
function ROe(e) {
  return e && !!e._init;
}
function aR() {
  return {
    default: "Validation error on field %s",
    required: "%s is required",
    enum: "%s must be one of %s",
    whitespace: "%s cannot be empty",
    date: {
      format: "%s date %s is invalid for format %s",
      parse: "%s date could not be parsed, %s is invalid ",
      invalid: "%s date %s is invalid"
    },
    types: {
      string: "%s is not a %s",
      method: "%s is not a %s (function)",
      array: "%s is not an %s",
      object: "%s is not an %s",
      number: "%s is not a %s",
      date: "%s is not a %s",
      boolean: "%s is not a %s",
      integer: "%s is not an %s",
      float: "%s is not a %s",
      regexp: "%s is not a valid %s",
      email: "%s is not a valid %s",
      url: "%s is not a valid %s",
      hex: "%s is not a valid %s"
    },
    string: {
      len: "%s must be exactly %s characters",
      min: "%s must be at least %s characters",
      max: "%s cannot be longer than %s characters",
      range: "%s must be between %s and %s characters"
    },
    number: {
      len: "%s must equal %s",
      min: "%s cannot be less than %s",
      max: "%s cannot be greater than %s",
      range: "%s must be between %s and %s"
    },
    array: {
      len: "%s must be exactly %s in length",
      min: "%s cannot be less than %s in length",
      max: "%s cannot be greater than %s in length",
      range: "%s must be between %s and %s in length"
    },
    pattern: {
      mismatch: "%s value %s does not match pattern %s"
    },
    clone: function() {
      var t = JSON.parse(JSON.stringify(this));
      return t.clone = this.clone, t;
    }
  };
}
var sR = aR();
function $Oe(e) {
  try {
    return Function.toString.call(e).indexOf("[native code]") !== -1;
  } catch {
    return typeof e == "function";
  }
}
function OOe(e, t, n) {
  if (zx())
    return Reflect.construct.apply(null, arguments);
  var r = [null];
  r.push.apply(r, t);
  var i = new (e.bind.apply(e, r))();
  return n && J0(i, n.prototype), i;
}
function cR(e) {
  var t = typeof Map == "function" ? /* @__PURE__ */ new Map() : void 0;
  return cR = function(r) {
    if (r === null || !$Oe(r))
      return r;
    if (typeof r != "function")
      throw new TypeError("Super expression must either be null or a function");
    if (t !== void 0) {
      if (t.has(r))
        return t.get(r);
      t.set(r, i);
    }
    function i() {
      return OOe(r, arguments, sf(this).constructor);
    }
    return i.prototype = Object.create(r.prototype, {
      constructor: {
        value: i,
        enumerable: !1,
        writable: !0,
        configurable: !0
      }
    }), J0(i, r);
  }, cR(e);
}
var POe = /%[sdj%]/g, IQ = function() {
};
typeof process < "u" && process.env && process.env.NODE_ENV !== "production" && typeof window < "u" && typeof document < "u" && (IQ = function(t, n) {
  typeof console < "u" && console.warn && typeof ASYNC_VALIDATOR_NO_WARNING > "u" && n.every(function(r) {
    return typeof r == "string";
  }) && console.warn(t, n);
});
function lR(e) {
  if (!e || !e.length)
    return null;
  var t = {};
  return e.forEach(function(n) {
    var r = n.field;
    t[r] = t[r] || [], t[r].push(n);
  }), t;
}
function pa(e) {
  for (var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++)
    n[r - 1] = arguments[r];
  var i = 0, o = n.length;
  if (typeof e == "function")
    return e.apply(null, n);
  if (typeof e == "string") {
    var a = e.replace(POe, function(s) {
      if (s === "%%")
        return "%";
      if (i >= o)
        return s;
      switch (s) {
        case "%s":
          return String(n[i++]);
        case "%d":
          return Number(n[i++]);
        case "%j":
          try {
            return JSON.stringify(n[i++]);
          } catch {
            return "[Circular]";
          }
          break;
        default:
          return s;
      }
    });
    return a;
  }
  return e;
}
function MOe(e) {
  return e === "string" || e === "url" || e === "hex" || e === "email" || e === "date" || e === "pattern";
}
function xi(e, t) {
  return !!(e == null || t === "array" && Array.isArray(e) && !e.length || MOe(t) && typeof e == "string" && !e);
}
function kOe(e, t, n) {
  var r = [], i = 0, o = e.length;
  function a(s) {
    r.push.apply(r, Je(s || [])), i++, i === o && n(r);
  }
  e.forEach(function(s) {
    t(s, a);
  });
}
function EL(e, t, n) {
  var r = 0, i = e.length;
  function o(a) {
    if (a && a.length) {
      n(a);
      return;
    }
    var s = r;
    r = r + 1, s < i ? t(e[s], o) : n([]);
  }
  o([]);
}
function NOe(e) {
  var t = [];
  return Object.keys(e).forEach(function(n) {
    t.push.apply(t, Je(e[n] || []));
  }), t;
}
var CL = /* @__PURE__ */ function(e) {
  Rs(n, e);
  var t = _c(n);
  function n(r, i) {
    var o;
    return Sr(this, n), o = t.call(this, "Async Validation Error"), re(nn(o), "errors", void 0), re(nn(o), "fields", void 0), o.errors = r, o.fields = i, o;
  }
  return wr(n);
}(/* @__PURE__ */ cR(Error));
function DOe(e, t, n, r, i) {
  if (t.first) {
    var o = new Promise(function(f, h) {
      var p = function(v) {
        return r(v), v.length ? h(new CL(v, lR(v))) : f(i);
      }, g = NOe(e);
      EL(g, n, p);
    });
    return o.catch(function(f) {
      return f;
    }), o;
  }
  var a = t.firstFields === !0 ? Object.keys(e) : t.firstFields || [], s = Object.keys(e), c = s.length, l = 0, u = [], d = new Promise(function(f, h) {
    var p = function(m) {
      if (u.push.apply(u, m), l++, l === c)
        return r(u), u.length ? h(new CL(u, lR(u))) : f(i);
    };
    s.length || (r(u), f(i)), s.forEach(function(g) {
      var m = e[g];
      a.indexOf(g) !== -1 ? EL(m, n, p) : kOe(m, n, p);
    });
  });
  return d.catch(function(f) {
    return f;
  }), d;
}
function LOe(e) {
  return !!(e && e.message !== void 0);
}
function jOe(e, t) {
  for (var n = e, r = 0; r < t.length; r++) {
    if (n == null)
      return n;
    n = n[t[r]];
  }
  return n;
}
function TL(e, t) {
  return function(n) {
    var r;
    return e.fullFields ? r = jOe(t, e.fullFields) : r = t[n.field || e.fullField], LOe(n) ? (n.field = n.field || e.fullField, n.fieldValue = r, n) : {
      message: typeof n == "function" ? n() : n,
      fieldValue: r,
      field: n.field || e.fullField
    };
  };
}
function IL(e, t) {
  if (t) {
    for (var n in t)
      if (t.hasOwnProperty(n)) {
        var r = t[n];
        _t(r) === "object" && _t(e[n]) === "object" ? e[n] = ae(ae({}, e[n]), r) : e[n] = r;
      }
  }
  return e;
}
var rh = "enum", FOe = function(t, n, r, i, o) {
  t[rh] = Array.isArray(t[rh]) ? t[rh] : [], t[rh].indexOf(n) === -1 && i.push(pa(o.messages[rh], t.fullField, t[rh].join(", ")));
}, VOe = function(t, n, r, i, o) {
  if (t.pattern) {
    if (t.pattern instanceof RegExp)
      t.pattern.lastIndex = 0, t.pattern.test(n) || i.push(pa(o.messages.pattern.mismatch, t.fullField, n, t.pattern));
    else if (typeof t.pattern == "string") {
      var a = new RegExp(t.pattern);
      a.test(n) || i.push(pa(o.messages.pattern.mismatch, t.fullField, n, t.pattern));
    }
  }
}, BOe = function(t, n, r, i, o) {
  var a = typeof t.len == "number", s = typeof t.min == "number", c = typeof t.max == "number", l = /[\uD800-\uDBFF][\uDC00-\uDFFF]/g, u = n, d = null, f = typeof n == "number", h = typeof n == "string", p = Array.isArray(n);
  if (f ? d = "number" : h ? d = "string" : p && (d = "array"), !d)
    return !1;
  p && (u = n.length), h && (u = n.replace(l, "_").length), a ? u !== t.len && i.push(pa(o.messages[d].len, t.fullField, t.len)) : s && !c && u < t.min ? i.push(pa(o.messages[d].min, t.fullField, t.min)) : c && !s && u > t.max ? i.push(pa(o.messages[d].max, t.fullField, t.max)) : s && c && (u < t.min || u > t.max) && i.push(pa(o.messages[d].range, t.fullField, t.min, t.max));
}, AQ = function(t, n, r, i, o, a) {
  t.required && (!r.hasOwnProperty(t.field) || xi(n, a || t.type)) && i.push(pa(o.messages.required, t.fullField));
}, Gb;
const zOe = function() {
  if (Gb)
    return Gb;
  var e = "[a-fA-F\\d:]", t = function(T) {
    return T && T.includeBoundaries ? "(?:(?<=\\s|^)(?=".concat(e, ")|(?<=").concat(e, ")(?=\\s|$))") : "";
  }, n = "(?:25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]\\d|\\d)(?:\\.(?:25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]\\d|\\d)){3}", r = "[a-fA-F\\d]{1,4}", i = [
    "(?:".concat(r, ":){7}(?:").concat(r, "|:)"),
    // 1:2:3:4:5:6:7::  1:2:3:4:5:6:7:8
    "(?:".concat(r, ":){6}(?:").concat(n, "|:").concat(r, "|:)"),
    // 1:2:3:4:5:6::    1:2:3:4:5:6::8   1:2:3:4:5:6::8  1:2:3:4:5:6::
    "(?:".concat(r, ":){5}(?::").concat(n, "|(?::").concat(r, "){1,2}|:)"),
    // 1:2:3:4:5::      1:2:3:4:5::7:8   1:2:3:4:5::8    1:2:3:4:5::
    "(?:".concat(r, ":){4}(?:(?::").concat(r, "){0,1}:").concat(n, "|(?::").concat(r, "){1,3}|:)"),
    // 1:2:3:4::        1:2:3:4::6:7:8   1:2:3:4::8      1:2:3:4::
    "(?:".concat(r, ":){3}(?:(?::").concat(r, "){0,2}:").concat(n, "|(?::").concat(r, "){1,4}|:)"),
    // 1:2:3::          1:2:3::5:6:7:8   1:2:3::8        1:2:3::
    "(?:".concat(r, ":){2}(?:(?::").concat(r, "){0,3}:").concat(n, "|(?::").concat(r, "){1,5}|:)"),
    // 1:2::            1:2::4:5:6:7:8   1:2::8          1:2::
    "(?:".concat(r, ":){1}(?:(?::").concat(r, "){0,4}:").concat(n, "|(?::").concat(r, "){1,6}|:)"),
    // 1::              1::3:4:5:6:7:8   1::8            1::
    "(?::(?:(?::".concat(r, "){0,5}:").concat(n, "|(?::").concat(r, "){1,7}|:))")
    // ::2:3:4:5:6:7:8  ::2:3:4:5:6:7:8  ::8             ::
  ], o = "(?:%[0-9a-zA-Z]{1,})?", a = "(?:".concat(i.join("|"), ")").concat(o), s = new RegExp("(?:^".concat(n, "$)|(?:^").concat(a, "$)")), c = new RegExp("^".concat(n, "$")), l = new RegExp("^".concat(a, "$")), u = function(T) {
    return T && T.exact ? s : new RegExp("(?:".concat(t(T)).concat(n).concat(t(T), ")|(?:").concat(t(T)).concat(a).concat(t(T), ")"), "g");
  };
  u.v4 = function(w) {
    return w && w.exact ? c : new RegExp("".concat(t(w)).concat(n).concat(t(w)), "g");
  }, u.v6 = function(w) {
    return w && w.exact ? l : new RegExp("".concat(t(w)).concat(a).concat(t(w)), "g");
  };
  var d = "(?:(?:[a-z]+:)?//)", f = "(?:\\S+(?::\\S*)?@)?", h = u.v4().source, p = u.v6().source, g = "(?:(?:[a-z\\u00a1-\\uffff0-9][-_]*)*[a-z\\u00a1-\\uffff0-9]+)", m = "(?:\\.(?:[a-z\\u00a1-\\uffff0-9]-*)*[a-z\\u00a1-\\uffff0-9]+)*", v = "(?:\\.(?:[a-z\\u00a1-\\uffff]{2,}))", y = "(?::\\d{2,5})?", S = '(?:[/?#][^\\s"]*)?', _ = "(?:".concat(d, "|www\\.)").concat(f, "(?:localhost|").concat(h, "|").concat(p, "|").concat(g).concat(m).concat(v, ")").concat(y).concat(S);
  return Gb = new RegExp("(?:^".concat(_, "$)"), "i"), Gb;
};
var AL = {
  // http://emailregex.com/
  email: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+\.)+[a-zA-Z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]{2,}))$/,
  // url: new RegExp(
  //   '^(?!mailto:)(?:(?:http|https|ftp)://|//)(?:\\S+(?::\\S*)?@)?(?:(?:(?:[1-9]\\d?|1\\d\\d|2[01]\\d|22[0-3])(?:\\.(?:1?\\d{1,2}|2[0-4]\\d|25[0-5])){2}(?:\\.(?:[0-9]\\d?|1\\d\\d|2[0-4]\\d|25[0-4]))|(?:(?:[a-z\\u00a1-\\uffff0-9]+-*)*[a-z\\u00a1-\\uffff0-9]+)(?:\\.(?:[a-z\\u00a1-\\uffff0-9]+-*)*[a-z\\u00a1-\\uffff0-9]+)*(?:\\.(?:[a-z\\u00a1-\\uffff]{2,})))|localhost)(?::\\d{2,5})?(?:(/|\\?|#)[^\\s]*)?$',
  //   'i',
  // ),
  hex: /^#?([a-f0-9]{6}|[a-f0-9]{3})$/i
}, Hm = {
  integer: function(t) {
    return Hm.number(t) && parseInt(t, 10) === t;
  },
  float: function(t) {
    return Hm.number(t) && !Hm.integer(t);
  },
  array: function(t) {
    return Array.isArray(t);
  },
  regexp: function(t) {
    if (t instanceof RegExp)
      return !0;
    try {
      return !!new RegExp(t);
    } catch {
      return !1;
    }
  },
  date: function(t) {
    return typeof t.getTime == "function" && typeof t.getMonth == "function" && typeof t.getYear == "function" && !isNaN(t.getTime());
  },
  number: function(t) {
    return isNaN(t) ? !1 : typeof t == "number";
  },
  object: function(t) {
    return _t(t) === "object" && !Hm.array(t);
  },
  method: function(t) {
    return typeof t == "function";
  },
  email: function(t) {
    return typeof t == "string" && t.length <= 320 && !!t.match(AL.email);
  },
  url: function(t) {
    return typeof t == "string" && t.length <= 2048 && !!t.match(zOe());
  },
  hex: function(t) {
    return typeof t == "string" && !!t.match(AL.hex);
  }
}, HOe = function(t, n, r, i, o) {
  if (t.required && n === void 0) {
    AQ(t, n, r, i, o);
    return;
  }
  var a = ["integer", "float", "array", "regexp", "object", "method", "email", "number", "date", "url", "hex"], s = t.type;
  a.indexOf(s) > -1 ? Hm[s](n) || i.push(pa(o.messages.types[s], t.fullField, t.type)) : s && _t(n) !== t.type && i.push(pa(o.messages.types[s], t.fullField, t.type));
}, UOe = function(t, n, r, i, o) {
  (/^\s+$/.test(n) || n === "") && i.push(pa(o.messages.whitespace, t.fullField));
};
const Sn = {
  required: AQ,
  whitespace: UOe,
  type: HOe,
  range: BOe,
  enum: FOe,
  pattern: VOe
};
var WOe = function(t, n, r, i, o) {
  var a = [], s = t.required || !t.required && i.hasOwnProperty(t.field);
  if (s) {
    if (xi(n) && !t.required)
      return r();
    Sn.required(t, n, i, a, o);
  }
  r(a);
}, qOe = function(t, n, r, i, o) {
  var a = [], s = t.required || !t.required && i.hasOwnProperty(t.field);
  if (s) {
    if (n == null && !t.required)
      return r();
    Sn.required(t, n, i, a, o, "array"), n != null && (Sn.type(t, n, i, a, o), Sn.range(t, n, i, a, o));
  }
  r(a);
}, GOe = function(t, n, r, i, o) {
  var a = [], s = t.required || !t.required && i.hasOwnProperty(t.field);
  if (s) {
    if (xi(n) && !t.required)
      return r();
    Sn.required(t, n, i, a, o), n !== void 0 && Sn.type(t, n, i, a, o);
  }
  r(a);
}, KOe = function(t, n, r, i, o) {
  var a = [], s = t.required || !t.required && i.hasOwnProperty(t.field);
  if (s) {
    if (xi(n, "date") && !t.required)
      return r();
    if (Sn.required(t, n, i, a, o), !xi(n, "date")) {
      var c;
      n instanceof Date ? c = n : c = new Date(n), Sn.type(t, c, i, a, o), c && Sn.range(t, c.getTime(), i, a, o);
    }
  }
  r(a);
}, YOe = "enum", XOe = function(t, n, r, i, o) {
  var a = [], s = t.required || !t.required && i.hasOwnProperty(t.field);
  if (s) {
    if (xi(n) && !t.required)
      return r();
    Sn.required(t, n, i, a, o), n !== void 0 && Sn[YOe](t, n, i, a, o);
  }
  r(a);
}, QOe = function(t, n, r, i, o) {
  var a = [], s = t.required || !t.required && i.hasOwnProperty(t.field);
  if (s) {
    if (xi(n) && !t.required)
      return r();
    Sn.required(t, n, i, a, o), n !== void 0 && (Sn.type(t, n, i, a, o), Sn.range(t, n, i, a, o));
  }
  r(a);
}, JOe = function(t, n, r, i, o) {
  var a = [], s = t.required || !t.required && i.hasOwnProperty(t.field);
  if (s) {
    if (xi(n) && !t.required)
      return r();
    Sn.required(t, n, i, a, o), n !== void 0 && (Sn.type(t, n, i, a, o), Sn.range(t, n, i, a, o));
  }
  r(a);
}, ZOe = function(t, n, r, i, o) {
  var a = [], s = t.required || !t.required && i.hasOwnProperty(t.field);
  if (s) {
    if (xi(n) && !t.required)
      return r();
    Sn.required(t, n, i, a, o), n !== void 0 && Sn.type(t, n, i, a, o);
  }
  r(a);
}, ePe = function(t, n, r, i, o) {
  var a = [], s = t.required || !t.required && i.hasOwnProperty(t.field);
  if (s) {
    if (n === "" && (n = void 0), xi(n) && !t.required)
      return r();
    Sn.required(t, n, i, a, o), n !== void 0 && (Sn.type(t, n, i, a, o), Sn.range(t, n, i, a, o));
  }
  r(a);
}, tPe = function(t, n, r, i, o) {
  var a = [], s = t.required || !t.required && i.hasOwnProperty(t.field);
  if (s) {
    if (xi(n) && !t.required)
      return r();
    Sn.required(t, n, i, a, o), n !== void 0 && Sn.type(t, n, i, a, o);
  }
  r(a);
}, nPe = function(t, n, r, i, o) {
  var a = [], s = t.required || !t.required && i.hasOwnProperty(t.field);
  if (s) {
    if (xi(n, "string") && !t.required)
      return r();
    Sn.required(t, n, i, a, o), xi(n, "string") || Sn.pattern(t, n, i, a, o);
  }
  r(a);
}, rPe = function(t, n, r, i, o) {
  var a = [], s = t.required || !t.required && i.hasOwnProperty(t.field);
  if (s) {
    if (xi(n) && !t.required)
      return r();
    Sn.required(t, n, i, a, o), xi(n) || Sn.type(t, n, i, a, o);
  }
  r(a);
}, iPe = function(t, n, r, i, o) {
  var a = [], s = Array.isArray(n) ? "array" : _t(n);
  Sn.required(t, n, i, a, o, s), r(a);
}, oPe = function(t, n, r, i, o) {
  var a = [], s = t.required || !t.required && i.hasOwnProperty(t.field);
  if (s) {
    if (xi(n, "string") && !t.required)
      return r();
    Sn.required(t, n, i, a, o, "string"), xi(n, "string") || (Sn.type(t, n, i, a, o), Sn.range(t, n, i, a, o), Sn.pattern(t, n, i, a, o), t.whitespace === !0 && Sn.whitespace(t, n, i, a, o));
  }
  r(a);
}, B5 = function(t, n, r, i, o) {
  var a = t.type, s = [], c = t.required || !t.required && i.hasOwnProperty(t.field);
  if (c) {
    if (xi(n, a) && !t.required)
      return r();
    Sn.required(t, n, i, s, o, a), xi(n, a) || Sn.type(t, n, i, s, o);
  }
  r(s);
};
const w0 = {
  string: oPe,
  method: ZOe,
  number: ePe,
  boolean: GOe,
  regexp: rPe,
  integer: JOe,
  float: QOe,
  array: qOe,
  object: tPe,
  enum: XOe,
  pattern: nPe,
  date: KOe,
  url: B5,
  hex: B5,
  email: B5,
  required: iPe,
  any: WOe
};
var ly = /* @__PURE__ */ function() {
  function e(t) {
    Sr(this, e), re(this, "rules", null), re(this, "_messages", sR), this.define(t);
  }
  return wr(e, [{
    key: "define",
    value: function(n) {
      var r = this;
      if (!n)
        throw new Error("Cannot configure a schema with no rules");
      if (_t(n) !== "object" || Array.isArray(n))
        throw new Error("Rules must be an object");
      this.rules = {}, Object.keys(n).forEach(function(i) {
        var o = n[i];
        r.rules[i] = Array.isArray(o) ? o : [o];
      });
    }
  }, {
    key: "messages",
    value: function(n) {
      return n && (this._messages = IL(aR(), n)), this._messages;
    }
  }, {
    key: "validate",
    value: function(n) {
      var r = this, i = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, o = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : function() {
      }, a = n, s = i, c = o;
      if (typeof s == "function" && (c = s, s = {}), !this.rules || Object.keys(this.rules).length === 0)
        return c && c(null, a), Promise.resolve(a);
      function l(p) {
        var g = [], m = {};
        function v(S) {
          if (Array.isArray(S)) {
            var _;
            g = (_ = g).concat.apply(_, Je(S));
          } else
            g.push(S);
        }
        for (var y = 0; y < p.length; y++)
          v(p[y]);
        g.length ? (m = lR(g), c(g, m)) : c(null, a);
      }
      if (s.messages) {
        var u = this.messages();
        u === sR && (u = aR()), IL(u, s.messages), s.messages = u;
      } else
        s.messages = this.messages();
      var d = {}, f = s.keys || Object.keys(this.rules);
      f.forEach(function(p) {
        var g = r.rules[p], m = a[p];
        g.forEach(function(v) {
          var y = v;
          typeof y.transform == "function" && (a === n && (a = ae({}, a)), m = a[p] = y.transform(m), m != null && (y.type = y.type || (Array.isArray(m) ? "array" : _t(m)))), typeof y == "function" ? y = {
            validator: y
          } : y = ae({}, y), y.validator = r.getValidationMethod(y), y.validator && (y.field = p, y.fullField = y.fullField || p, y.type = r.getType(y), d[p] = d[p] || [], d[p].push({
            rule: y,
            value: m,
            source: a,
            field: p
          }));
        });
      });
      var h = {};
      return DOe(d, s, function(p, g) {
        var m = p.rule, v = (m.type === "object" || m.type === "array") && (_t(m.fields) === "object" || _t(m.defaultField) === "object");
        v = v && (m.required || !m.required && p.value), m.field = p.field;
        function y(x, C) {
          return ae(ae({}, C), {}, {
            fullField: "".concat(m.fullField, ".").concat(x),
            fullFields: m.fullFields ? [].concat(Je(m.fullFields), [x]) : [x]
          });
        }
        function S() {
          var x = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], C = Array.isArray(x) ? x : [x];
          !s.suppressWarning && C.length && e.warning("async-validator:", C), C.length && m.message !== void 0 && (C = [].concat(m.message));
          var E = C.map(TL(m, a));
          if (s.first && E.length)
            return h[m.field] = 1, g(E);
          if (!v)
            g(E);
          else {
            if (m.required && !p.value)
              return m.message !== void 0 ? E = [].concat(m.message).map(TL(m, a)) : s.error && (E = [s.error(m, pa(s.messages.required, m.field))]), g(E);
            var R = {};
            m.defaultField && Object.keys(p.value).map(function($) {
              R[$] = m.defaultField;
            }), R = ae(ae({}, R), p.rule.fields);
            var A = {};
            Object.keys(R).forEach(function($) {
              var N = R[$], z = Array.isArray(N) ? N : [N];
              A[$] = z.map(y.bind(null, $));
            });
            var O = new e(A);
            O.messages(s.messages), p.rule.options && (p.rule.options.messages = s.messages, p.rule.options.error = s.error), O.validate(p.value, p.rule.options || s, function($) {
              var N = [];
              E && E.length && N.push.apply(N, Je(E)), $ && $.length && N.push.apply(N, Je($)), g(N.length ? N : null);
            });
          }
        }
        var _;
        if (m.asyncValidator)
          _ = m.asyncValidator(m, p.value, S, p.source, s);
        else if (m.validator) {
          try {
            _ = m.validator(m, p.value, S, p.source, s);
          } catch (x) {
            var w, T;
            (w = (T = console).error) === null || w === void 0 || w.call(T, x), s.suppressValidatorError || setTimeout(function() {
              throw x;
            }, 0), S(x.message);
          }
          _ === !0 ? S() : _ === !1 ? S(typeof m.message == "function" ? m.message(m.fullField || m.field) : m.message || "".concat(m.fullField || m.field, " fails")) : _ instanceof Array ? S(_) : _ instanceof Error && S(_.message);
        }
        _ && _.then && _.then(function() {
          return S();
        }, function(x) {
          return S(x);
        });
      }, function(p) {
        l(p);
      }, a);
    }
  }, {
    key: "getType",
    value: function(n) {
      if (n.type === void 0 && n.pattern instanceof RegExp && (n.type = "pattern"), typeof n.validator != "function" && n.type && !w0.hasOwnProperty(n.type))
        throw new Error(pa("Unknown rule type %s", n.type));
      return n.type || "string";
    }
  }, {
    key: "getValidationMethod",
    value: function(n) {
      if (typeof n.validator == "function")
        return n.validator;
      var r = Object.keys(n), i = r.indexOf("message");
      return i !== -1 && r.splice(i, 1), r.length === 1 && r[0] === "required" ? w0.required : w0[this.getType(n)] || void 0;
    }
  }]), e;
}();
re(ly, "register", function(t, n) {
  if (typeof n != "function")
    throw new Error("Cannot register a validator by type, validator is not a function");
  w0[t] = n;
});
re(ly, "warning", IQ);
re(ly, "messages", sR);
re(ly, "validators", w0);
var oa = "'${name}' is not a valid ${type}", RQ = {
  default: "Validation error on field '${name}'",
  required: "'${name}' is required",
  enum: "'${name}' must be one of [${enum}]",
  whitespace: "'${name}' cannot be empty",
  date: {
    format: "'${name}' is invalid for format date",
    parse: "'${name}' could not be parsed as date",
    invalid: "'${name}' is invalid date"
  },
  types: {
    string: oa,
    method: oa,
    array: oa,
    object: oa,
    number: oa,
    date: oa,
    boolean: oa,
    integer: oa,
    float: oa,
    regexp: oa,
    email: oa,
    url: oa,
    hex: oa
  },
  string: {
    len: "'${name}' must be exactly ${len} characters",
    min: "'${name}' must be at least ${min} characters",
    max: "'${name}' cannot be longer than ${max} characters",
    range: "'${name}' must be between ${min} and ${max} characters"
  },
  number: {
    len: "'${name}' must equal ${len}",
    min: "'${name}' cannot be less than ${min}",
    max: "'${name}' cannot be greater than ${max}",
    range: "'${name}' must be between ${min} and ${max}"
  },
  array: {
    len: "'${name}' must be exactly ${len} in length",
    min: "'${name}' cannot be less than ${min} in length",
    max: "'${name}' cannot be greater than ${max} in length",
    range: "'${name}' must be between ${min} and ${max} in length"
  },
  pattern: {
    mismatch: "'${name}' does not match pattern ${pattern}"
  }
}, RL = ly;
function aPe(e, t) {
  return e.replace(/\\?\$\{\w+\}/g, function(n) {
    if (n.startsWith("\\"))
      return n.slice(1);
    var r = n.slice(2, -1);
    return t[r];
  });
}
var $L = "CODE_LOGIC_ERROR";
function uR(e, t, n, r, i) {
  return dR.apply(this, arguments);
}
function dR() {
  return dR = Af(/* @__PURE__ */ Po().mark(function e(t, n, r, i, o) {
    var a, s, c, l, u, d, f, h, p;
    return Po().wrap(function(m) {
      for (; ; )
        switch (m.prev = m.next) {
          case 0:
            return a = ae({}, r), delete a.ruleIndex, RL.warning = function() {
            }, a.validator && (s = a.validator, a.validator = function() {
              try {
                return s.apply(void 0, arguments);
              } catch (v) {
                return console.error(v), Promise.reject($L);
              }
            }), c = null, a && a.type === "array" && a.defaultField && (c = a.defaultField, delete a.defaultField), l = new RL(re({}, t, [a])), u = kh(RQ, i.validateMessages), l.messages(u), d = [], m.prev = 10, m.next = 13, Promise.resolve(l.validate(re({}, t, n), ae({}, i)));
          case 13:
            m.next = 18;
            break;
          case 15:
            m.prev = 15, m.t0 = m.catch(10), m.t0.errors && (d = m.t0.errors.map(function(v, y) {
              var S = v.message, _ = S === $L ? u.default : S;
              return /* @__PURE__ */ I.isValidElement(_) ? (
                // Wrap ReactNode with `key`
                /* @__PURE__ */ I.cloneElement(_, {
                  key: "error_".concat(y)
                })
              ) : _;
            }));
          case 18:
            if (!(!d.length && c)) {
              m.next = 23;
              break;
            }
            return m.next = 21, Promise.all(n.map(function(v, y) {
              return uR("".concat(t, ".").concat(y), v, c, i, o);
            }));
          case 21:
            return f = m.sent, m.abrupt("return", f.reduce(function(v, y) {
              return [].concat(Je(v), Je(y));
            }, []));
          case 23:
            return h = ae(ae({}, r), {}, {
              name: t,
              enum: (r.enum || []).join(", ")
            }, o), p = d.map(function(v) {
              return typeof v == "string" ? aPe(v, h) : v;
            }), m.abrupt("return", p);
          case 26:
          case "end":
            return m.stop();
        }
    }, e, null, [[10, 15]]);
  })), dR.apply(this, arguments);
}
function sPe(e, t, n, r, i, o) {
  var a = e.join("."), s = n.map(function(u, d) {
    var f = u.validator, h = ae(ae({}, u), {}, {
      ruleIndex: d
    });
    return f && (h.validator = function(p, g, m) {
      var v = !1, y = function() {
        for (var w = arguments.length, T = new Array(w), x = 0; x < w; x++)
          T[x] = arguments[x];
        Promise.resolve().then(function() {
          an(!v, "Your validator function has already return a promise. `callback` will be ignored."), v || m.apply(void 0, T);
        });
      }, S = f(p, g, y);
      v = S && typeof S.then == "function" && typeof S.catch == "function", an(v, "`callback` is deprecated. Please return a promise instead."), v && S.then(function() {
        m();
      }).catch(function(_) {
        m(_ || " ");
      });
    }), h;
  }).sort(function(u, d) {
    var f = u.warningOnly, h = u.ruleIndex, p = d.warningOnly, g = d.ruleIndex;
    return !!f == !!p ? h - g : f ? 1 : -1;
  }), c;
  if (i === !0)
    c = new Promise(/* @__PURE__ */ function() {
      var u = Af(/* @__PURE__ */ Po().mark(function d(f, h) {
        var p, g, m;
        return Po().wrap(function(y) {
          for (; ; )
            switch (y.prev = y.next) {
              case 0:
                p = 0;
              case 1:
                if (!(p < s.length)) {
                  y.next = 12;
                  break;
                }
                return g = s[p], y.next = 5, uR(a, t, g, r, o);
              case 5:
                if (m = y.sent, !m.length) {
                  y.next = 9;
                  break;
                }
                return h([{
                  errors: m,
                  rule: g
                }]), y.abrupt("return");
              case 9:
                p += 1, y.next = 1;
                break;
              case 12:
                f([]);
              case 13:
              case "end":
                return y.stop();
            }
        }, d);
      }));
      return function(d, f) {
        return u.apply(this, arguments);
      };
    }());
  else {
    var l = s.map(function(u) {
      return uR(a, t, u, r, o).then(function(d) {
        return {
          errors: d,
          rule: u
        };
      });
    });
    c = (i ? lPe(l) : cPe(l)).then(function(u) {
      return Promise.reject(u);
    });
  }
  return c.catch(function(u) {
    return u;
  }), c;
}
function cPe(e) {
  return fR.apply(this, arguments);
}
function fR() {
  return fR = Af(/* @__PURE__ */ Po().mark(function e(t) {
    return Po().wrap(function(r) {
      for (; ; )
        switch (r.prev = r.next) {
          case 0:
            return r.abrupt("return", Promise.all(t).then(function(i) {
              var o, a = (o = []).concat.apply(o, Je(i));
              return a;
            }));
          case 1:
          case "end":
            return r.stop();
        }
    }, e);
  })), fR.apply(this, arguments);
}
function lPe(e) {
  return hR.apply(this, arguments);
}
function hR() {
  return hR = Af(/* @__PURE__ */ Po().mark(function e(t) {
    var n;
    return Po().wrap(function(i) {
      for (; ; )
        switch (i.prev = i.next) {
          case 0:
            return n = 0, i.abrupt("return", new Promise(function(o) {
              t.forEach(function(a) {
                a.then(function(s) {
                  s.errors.length && o([s]), n += 1, n === t.length && o([]);
                });
              });
            }));
          case 2:
          case "end":
            return i.stop();
        }
    }, e);
  })), hR.apply(this, arguments);
}
function Zr(e) {
  return oR(e);
}
function OL(e, t) {
  var n = {};
  return t.forEach(function(r) {
    var i = Ys(e, r);
    n = is(n, r, i);
  }), n;
}
function Qh(e, t) {
  var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1;
  return e && e.some(function(r) {
    return $Q(t, r, n);
  });
}
function $Q(e, t) {
  var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1;
  return !e || !t || !n && e.length !== t.length ? !1 : t.every(function(r, i) {
    return e[i] === r;
  });
}
function uPe(e, t) {
  if (e === t)
    return !0;
  if (!e && t || e && !t || !e || !t || _t(e) !== "object" || _t(t) !== "object")
    return !1;
  var n = Object.keys(e), r = Object.keys(t), i = new Set([].concat(n, r));
  return Je(i).every(function(o) {
    var a = e[o], s = t[o];
    return typeof a == "function" && typeof s == "function" ? !0 : a === s;
  });
}
function dPe(e) {
  var t = arguments.length <= 1 ? void 0 : arguments[1];
  return t && t.target && _t(t.target) === "object" && e in t.target ? t.target[e] : t;
}
function PL(e, t, n) {
  var r = e.length;
  if (t < 0 || t >= r || n < 0 || n >= r)
    return e;
  var i = e[t], o = t - n;
  return o > 0 ? [].concat(Je(e.slice(0, n)), [i], Je(e.slice(n, t)), Je(e.slice(t + 1, r))) : o < 0 ? [].concat(Je(e.slice(0, t)), Je(e.slice(t + 1, n + 1)), [i], Je(e.slice(n + 1, r))) : e;
}
var fPe = ["name"], Ia = [];
function z5(e, t, n, r, i, o) {
  return typeof e == "function" ? e(t, n, "source" in o ? {
    source: o.source
  } : {}) : r !== i;
}
var O6 = /* @__PURE__ */ function(e) {
  Rs(n, e);
  var t = _c(n);
  function n(r) {
    var i;
    if (Sr(this, n), i = t.call(this, r), re(nn(i), "state", {
      resetCount: 0
    }), re(nn(i), "cancelRegisterFunc", null), re(nn(i), "mounted", !1), re(nn(i), "touched", !1), re(nn(i), "dirty", !1), re(nn(i), "validatePromise", void 0), re(nn(i), "prevValidating", void 0), re(nn(i), "errors", Ia), re(nn(i), "warnings", Ia), re(nn(i), "cancelRegister", function() {
      var c = i.props, l = c.preserve, u = c.isListField, d = c.name;
      i.cancelRegisterFunc && i.cancelRegisterFunc(u, l, Zr(d)), i.cancelRegisterFunc = null;
    }), re(nn(i), "getNamePath", function() {
      var c = i.props, l = c.name, u = c.fieldContext, d = u.prefixName, f = d === void 0 ? [] : d;
      return l !== void 0 ? [].concat(Je(f), Je(l)) : [];
    }), re(nn(i), "getRules", function() {
      var c = i.props, l = c.rules, u = l === void 0 ? [] : l, d = c.fieldContext;
      return u.map(function(f) {
        return typeof f == "function" ? f(d) : f;
      });
    }), re(nn(i), "refresh", function() {
      i.mounted && i.setState(function(c) {
        var l = c.resetCount;
        return {
          resetCount: l + 1
        };
      });
    }), re(nn(i), "metaCache", null), re(nn(i), "triggerMetaEvent", function(c) {
      var l = i.props.onMetaChange;
      if (l) {
        var u = ae(ae({}, i.getMeta()), {}, {
          destroy: c
        });
        Ig(i.metaCache, u) || l(u), i.metaCache = u;
      } else
        i.metaCache = null;
    }), re(nn(i), "onStoreChange", function(c, l, u) {
      var d = i.props, f = d.shouldUpdate, h = d.dependencies, p = h === void 0 ? [] : h, g = d.onReset, m = u.store, v = i.getNamePath(), y = i.getValue(c), S = i.getValue(m), _ = l && Qh(l, v);
      switch (u.type === "valueUpdate" && u.source === "external" && !Ig(y, S) && (i.touched = !0, i.dirty = !0, i.validatePromise = null, i.errors = Ia, i.warnings = Ia, i.triggerMetaEvent()), u.type) {
        case "reset":
          if (!l || _) {
            i.touched = !1, i.dirty = !1, i.validatePromise = void 0, i.errors = Ia, i.warnings = Ia, i.triggerMetaEvent(), g == null || g(), i.refresh();
            return;
          }
          break;
        case "remove": {
          if (f && z5(f, c, m, y, S, u)) {
            i.reRender();
            return;
          }
          break;
        }
        case "setField": {
          var w = u.data;
          if (_) {
            "touched" in w && (i.touched = w.touched), "validating" in w && !("originRCField" in w) && (i.validatePromise = w.validating ? Promise.resolve([]) : null), "errors" in w && (i.errors = w.errors || Ia), "warnings" in w && (i.warnings = w.warnings || Ia), i.dirty = !0, i.triggerMetaEvent(), i.reRender();
            return;
          } else if ("value" in w && Qh(l, v, !0)) {
            i.reRender();
            return;
          }
          if (f && !v.length && z5(f, c, m, y, S, u)) {
            i.reRender();
            return;
          }
          break;
        }
        case "dependenciesUpdate": {
          var T = p.map(Zr);
          if (T.some(function(x) {
            return Qh(u.relatedFields, x);
          })) {
            i.reRender();
            return;
          }
          break;
        }
        default:
          if (_ || (!p.length || v.length || f) && z5(f, c, m, y, S, u)) {
            i.reRender();
            return;
          }
          break;
      }
      f === !0 && i.reRender();
    }), re(nn(i), "validateRules", function(c) {
      var l = i.getNamePath(), u = i.getValue(), d = c || {}, f = d.triggerName, h = d.validateOnly, p = h === void 0 ? !1 : h, g = Promise.resolve().then(/* @__PURE__ */ Af(/* @__PURE__ */ Po().mark(function m() {
        var v, y, S, _, w, T, x;
        return Po().wrap(function(E) {
          for (; ; )
            switch (E.prev = E.next) {
              case 0:
                if (i.mounted) {
                  E.next = 2;
                  break;
                }
                return E.abrupt("return", []);
              case 2:
                if (v = i.props, y = v.validateFirst, S = y === void 0 ? !1 : y, _ = v.messageVariables, w = v.validateDebounce, T = i.getRules(), f && (T = T.filter(function(R) {
                  return R;
                }).filter(function(R) {
                  var A = R.validateTrigger;
                  if (!A)
                    return !0;
                  var O = oR(A);
                  return O.includes(f);
                })), !(w && f)) {
                  E.next = 10;
                  break;
                }
                return E.next = 8, new Promise(function(R) {
                  setTimeout(R, w);
                });
              case 8:
                if (i.validatePromise === g) {
                  E.next = 10;
                  break;
                }
                return E.abrupt("return", []);
              case 10:
                return x = sPe(l, u, T, c, S, _), x.catch(function(R) {
                  return R;
                }).then(function() {
                  var R = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : Ia;
                  if (i.validatePromise === g) {
                    var A;
                    i.validatePromise = null;
                    var O = [], $ = [];
                    (A = R.forEach) === null || A === void 0 || A.call(R, function(N) {
                      var z = N.rule.warningOnly, k = N.errors, F = k === void 0 ? Ia : k;
                      z ? $.push.apply($, Je(F)) : O.push.apply(O, Je(F));
                    }), i.errors = O, i.warnings = $, i.triggerMetaEvent(), i.reRender();
                  }
                }), E.abrupt("return", x);
              case 13:
              case "end":
                return E.stop();
            }
        }, m);
      })));
      return p || (i.validatePromise = g, i.dirty = !0, i.errors = Ia, i.warnings = Ia, i.triggerMetaEvent(), i.reRender()), g;
    }), re(nn(i), "isFieldValidating", function() {
      return !!i.validatePromise;
    }), re(nn(i), "isFieldTouched", function() {
      return i.touched;
    }), re(nn(i), "isFieldDirty", function() {
      if (i.dirty || i.props.initialValue !== void 0)
        return !0;
      var c = i.props.fieldContext, l = c.getInternalHooks(xd), u = l.getInitialValue;
      return u(i.getNamePath()) !== void 0;
    }), re(nn(i), "getErrors", function() {
      return i.errors;
    }), re(nn(i), "getWarnings", function() {
      return i.warnings;
    }), re(nn(i), "isListField", function() {
      return i.props.isListField;
    }), re(nn(i), "isList", function() {
      return i.props.isList;
    }), re(nn(i), "isPreserve", function() {
      return i.props.preserve;
    }), re(nn(i), "getMeta", function() {
      i.prevValidating = i.isFieldValidating();
      var c = {
        touched: i.isFieldTouched(),
        validating: i.prevValidating,
        errors: i.errors,
        warnings: i.warnings,
        name: i.getNamePath(),
        validated: i.validatePromise === null
      };
      return c;
    }), re(nn(i), "getOnlyChild", function(c) {
      if (typeof c == "function") {
        var l = i.getMeta();
        return ae(ae({}, i.getOnlyChild(c(i.getControlled(), l, i.props.fieldContext))), {}, {
          isFunction: !0
        });
      }
      var u = af(c);
      return u.length !== 1 || !/* @__PURE__ */ I.isValidElement(u[0]) ? {
        child: u,
        isFunction: !1
      } : {
        child: u[0],
        isFunction: !1
      };
    }), re(nn(i), "getValue", function(c) {
      var l = i.props.fieldContext.getFieldsValue, u = i.getNamePath();
      return Ys(c || l(!0), u);
    }), re(nn(i), "getControlled", function() {
      var c = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, l = i.props, u = l.name, d = l.trigger, f = l.validateTrigger, h = l.getValueFromEvent, p = l.normalize, g = l.valuePropName, m = l.getValueProps, v = l.fieldContext, y = f !== void 0 ? f : v.validateTrigger, S = i.getNamePath(), _ = v.getInternalHooks, w = v.getFieldsValue, T = _(xd), x = T.dispatch, C = i.getValue(), E = m || function(N) {
        return re({}, g, N);
      }, R = c[d], A = u !== void 0 ? E(C) : {};
      process.env.NODE_ENV !== "production" && A && Object.keys(A).forEach(function(N) {
        an(typeof A[N] != "function", "It's not recommended to generate dynamic function prop by `getValueProps`. Please pass it to child component directly (prop: ".concat(N, ")"));
      });
      var O = ae(ae({}, c), A);
      O[d] = function() {
        i.touched = !0, i.dirty = !0, i.triggerMetaEvent();
        for (var N, z = arguments.length, k = new Array(z), F = 0; F < z; F++)
          k[F] = arguments[F];
        h ? N = h.apply(void 0, k) : N = dPe.apply(void 0, [g].concat(k)), p && (N = p(N, C, w(!0))), N !== C && x({
          type: "updateValue",
          namePath: S,
          value: N
        }), R && R.apply(void 0, k);
      };
      var $ = oR(y || []);
      return $.forEach(function(N) {
        var z = O[N];
        O[N] = function() {
          z && z.apply(void 0, arguments);
          var k = i.props.rules;
          k && k.length && x({
            type: "validateField",
            namePath: S,
            triggerName: N
          });
        };
      }), O;
    }), r.fieldContext) {
      var o = r.fieldContext.getInternalHooks, a = o(xd), s = a.initEntityValue;
      s(nn(i));
    }
    return i;
  }
  return wr(n, [{
    key: "componentDidMount",
    value: function() {
      var i = this.props, o = i.shouldUpdate, a = i.fieldContext;
      if (this.mounted = !0, a) {
        var s = a.getInternalHooks, c = s(xd), l = c.registerField;
        this.cancelRegisterFunc = l(this);
      }
      o === !0 && this.reRender();
    }
  }, {
    key: "componentWillUnmount",
    value: function() {
      this.cancelRegister(), this.triggerMetaEvent(!0), this.mounted = !1;
    }
  }, {
    key: "reRender",
    value: function() {
      this.mounted && this.forceUpdate();
    }
  }, {
    key: "render",
    value: function() {
      var i = this.state.resetCount, o = this.props.children, a = this.getOnlyChild(o), s = a.child, c = a.isFunction, l;
      return c ? l = s : /* @__PURE__ */ I.isValidElement(s) ? l = /* @__PURE__ */ I.cloneElement(s, this.getControlled(s.props)) : (an(!s, "`children` of Field is not validate ReactElement."), l = s), /* @__PURE__ */ I.createElement(I.Fragment, {
        key: i
      }, l);
    }
  }]), n;
}(I.Component);
re(O6, "contextType", lf);
re(O6, "defaultProps", {
  trigger: "onChange",
  valuePropName: "value"
});
function P6(e) {
  var t = e.name, n = xn(e, fPe), r = I.useContext(lf), i = I.useContext(sv), o = t !== void 0 ? Zr(t) : void 0, a = "keep";
  return n.isListField || (a = "_".concat((o || []).join("_"))), process.env.NODE_ENV !== "production" && n.preserve === !1 && n.isListField && o.length <= 1 && an(!1, "`preserve` should not apply on Form.List fields."), /* @__PURE__ */ I.createElement(O6, mt({
    key: a,
    name: o,
    isListField: !!i
  }, n, {
    fieldContext: r
  }));
}
function OQ(e) {
  var t = e.name, n = e.initialValue, r = e.children, i = e.rules, o = e.validateTrigger, a = e.isListField, s = I.useContext(lf), c = I.useContext(sv), l = I.useRef({
    keys: [],
    id: 0
  }), u = l.current, d = I.useMemo(function() {
    var g = Zr(s.prefixName) || [];
    return [].concat(Je(g), Je(Zr(t)));
  }, [s.prefixName, t]), f = I.useMemo(function() {
    return ae(ae({}, s), {}, {
      prefixName: d
    });
  }, [s, d]), h = I.useMemo(function() {
    return {
      getKey: function(m) {
        var v = d.length, y = m[v];
        return [u.keys[y], m.slice(v + 1)];
      }
    };
  }, [d]);
  if (typeof r != "function")
    return an(!1, "Form.List only accepts function as children."), null;
  var p = function(m, v, y) {
    var S = y.source;
    return S === "internal" ? !1 : m !== v;
  };
  return /* @__PURE__ */ I.createElement(sv.Provider, {
    value: h
  }, /* @__PURE__ */ I.createElement(lf.Provider, {
    value: f
  }, /* @__PURE__ */ I.createElement(P6, {
    name: [],
    shouldUpdate: p,
    rules: i,
    validateTrigger: o,
    initialValue: n,
    isList: !0,
    isListField: a ?? !!c
  }, function(g, m) {
    var v = g.value, y = v === void 0 ? [] : v, S = g.onChange, _ = s.getFieldValue, w = function() {
      var E = _(d || []);
      return E || [];
    }, T = {
      add: function(E, R) {
        var A = w();
        R >= 0 && R <= A.length ? (u.keys = [].concat(Je(u.keys.slice(0, R)), [u.id], Je(u.keys.slice(R))), S([].concat(Je(A.slice(0, R)), [E], Je(A.slice(R))))) : (process.env.NODE_ENV !== "production" && (R < 0 || R > A.length) && an(!1, "The second parameter of the add function should be a valid positive number."), u.keys = [].concat(Je(u.keys), [u.id]), S([].concat(Je(A), [E]))), u.id += 1;
      },
      remove: function(E) {
        var R = w(), A = new Set(Array.isArray(E) ? E : [E]);
        A.size <= 0 || (u.keys = u.keys.filter(function(O, $) {
          return !A.has($);
        }), S(R.filter(function(O, $) {
          return !A.has($);
        })));
      },
      move: function(E, R) {
        if (E !== R) {
          var A = w();
          E < 0 || E >= A.length || R < 0 || R >= A.length || (u.keys = PL(u.keys, E, R), S(PL(A, E, R)));
        }
      }
    }, x = y || [];
    return Array.isArray(x) || (x = [], process.env.NODE_ENV !== "production" && an(!1, "Current value of '".concat(d.join(" > "), "' is not an array type."))), r(x.map(function(C, E) {
      var R = u.keys[E];
      return R === void 0 && (u.keys[E] = u.id, R = u.keys[E], u.id += 1), {
        name: E,
        key: R,
        isListField: !0
      };
    }), T, m);
  })));
}
function hPe(e) {
  var t = !1, n = e.length, r = [];
  return e.length ? new Promise(function(i, o) {
    e.forEach(function(a, s) {
      a.catch(function(c) {
        return t = !0, c;
      }).then(function(c) {
        n -= 1, r[s] = c, !(n > 0) && (t && o(r), i(r));
      });
    });
  }) : Promise.resolve([]);
}
var PQ = "__@field_split__";
function H5(e) {
  return e.map(function(t) {
    return "".concat(_t(t), ":").concat(t);
  }).join(PQ);
}
var ih = /* @__PURE__ */ function() {
  function e() {
    Sr(this, e), re(this, "kvs", /* @__PURE__ */ new Map());
  }
  return wr(e, [{
    key: "set",
    value: function(n, r) {
      this.kvs.set(H5(n), r);
    }
  }, {
    key: "get",
    value: function(n) {
      return this.kvs.get(H5(n));
    }
  }, {
    key: "update",
    value: function(n, r) {
      var i = this.get(n), o = r(i);
      o ? this.set(n, o) : this.delete(n);
    }
  }, {
    key: "delete",
    value: function(n) {
      this.kvs.delete(H5(n));
    }
    // Since we only use this in test, let simply realize this
  }, {
    key: "map",
    value: function(n) {
      return Je(this.kvs.entries()).map(function(r) {
        var i = fe(r, 2), o = i[0], a = i[1], s = o.split(PQ);
        return n({
          key: s.map(function(c) {
            var l = c.match(/^([^:]*):(.*)$/), u = fe(l, 3), d = u[1], f = u[2];
            return d === "number" ? Number(f) : f;
          }),
          value: a
        });
      });
    }
  }, {
    key: "toJSON",
    value: function() {
      var n = {};
      return this.map(function(r) {
        var i = r.key, o = r.value;
        return n[i.join(".")] = o, null;
      }), n;
    }
  }]), e;
}(), gPe = ["name"], pPe = /* @__PURE__ */ wr(function e(t) {
  var n = this;
  Sr(this, e), re(this, "formHooked", !1), re(this, "forceRootUpdate", void 0), re(this, "subscribable", !0), re(this, "store", {}), re(this, "fieldEntities", []), re(this, "initialValues", {}), re(this, "callbacks", {}), re(this, "validateMessages", null), re(this, "preserve", null), re(this, "lastValidatePromise", null), re(this, "getForm", function() {
    return {
      getFieldValue: n.getFieldValue,
      getFieldsValue: n.getFieldsValue,
      getFieldError: n.getFieldError,
      getFieldWarning: n.getFieldWarning,
      getFieldsError: n.getFieldsError,
      isFieldsTouched: n.isFieldsTouched,
      isFieldTouched: n.isFieldTouched,
      isFieldValidating: n.isFieldValidating,
      isFieldsValidating: n.isFieldsValidating,
      resetFields: n.resetFields,
      setFields: n.setFields,
      setFieldValue: n.setFieldValue,
      setFieldsValue: n.setFieldsValue,
      validateFields: n.validateFields,
      submit: n.submit,
      _init: !0,
      getInternalHooks: n.getInternalHooks
    };
  }), re(this, "getInternalHooks", function(r) {
    return r === xd ? (n.formHooked = !0, {
      dispatch: n.dispatch,
      initEntityValue: n.initEntityValue,
      registerField: n.registerField,
      useSubscribe: n.useSubscribe,
      setInitialValues: n.setInitialValues,
      destroyForm: n.destroyForm,
      setCallbacks: n.setCallbacks,
      setValidateMessages: n.setValidateMessages,
      getFields: n.getFields,
      setPreserve: n.setPreserve,
      getInitialValue: n.getInitialValue,
      registerWatch: n.registerWatch
    }) : (an(!1, "`getInternalHooks` is internal usage. Should not call directly."), null);
  }), re(this, "useSubscribe", function(r) {
    n.subscribable = r;
  }), re(this, "prevWithoutPreserves", null), re(this, "setInitialValues", function(r, i) {
    if (n.initialValues = r || {}, i) {
      var o, a = kh(r, n.store);
      (o = n.prevWithoutPreserves) === null || o === void 0 || o.map(function(s) {
        var c = s.key;
        a = is(a, c, Ys(r, c));
      }), n.prevWithoutPreserves = null, n.updateStore(a);
    }
  }), re(this, "destroyForm", function(r) {
    if (r)
      n.updateStore({});
    else {
      var i = new ih();
      n.getFieldEntities(!0).forEach(function(o) {
        n.isMergedPreserve(o.isPreserve()) || i.set(o.getNamePath(), !0);
      }), n.prevWithoutPreserves = i;
    }
  }), re(this, "getInitialValue", function(r) {
    var i = Ys(n.initialValues, r);
    return r.length ? kh(i) : i;
  }), re(this, "setCallbacks", function(r) {
    n.callbacks = r;
  }), re(this, "setValidateMessages", function(r) {
    n.validateMessages = r;
  }), re(this, "setPreserve", function(r) {
    n.preserve = r;
  }), re(this, "watchList", []), re(this, "registerWatch", function(r) {
    return n.watchList.push(r), function() {
      n.watchList = n.watchList.filter(function(i) {
        return i !== r;
      });
    };
  }), re(this, "notifyWatch", function() {
    var r = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
    if (n.watchList.length) {
      var i = n.getFieldsValue(), o = n.getFieldsValue(!0);
      n.watchList.forEach(function(a) {
        a(i, o, r);
      });
    }
  }), re(this, "timeoutId", null), re(this, "warningUnhooked", function() {
    process.env.NODE_ENV !== "production" && !n.timeoutId && typeof window < "u" && (n.timeoutId = setTimeout(function() {
      n.timeoutId = null, n.formHooked || an(!1, "Instance created by `useForm` is not connected to any Form element. Forget to pass `form` prop?");
    }));
  }), re(this, "updateStore", function(r) {
    n.store = r;
  }), re(this, "getFieldEntities", function() {
    var r = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !1;
    return r ? n.fieldEntities.filter(function(i) {
      return i.getNamePath().length;
    }) : n.fieldEntities;
  }), re(this, "getFieldsMap", function() {
    var r = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !1, i = new ih();
    return n.getFieldEntities(r).forEach(function(o) {
      var a = o.getNamePath();
      i.set(a, o);
    }), i;
  }), re(this, "getFieldEntitiesForNamePathList", function(r) {
    if (!r)
      return n.getFieldEntities(!0);
    var i = n.getFieldsMap(!0);
    return r.map(function(o) {
      var a = Zr(o);
      return i.get(a) || {
        INVALIDATE_NAME_PATH: Zr(o)
      };
    });
  }), re(this, "getFieldsValue", function(r, i) {
    n.warningUnhooked();
    var o, a, s;
    if (r === !0 || Array.isArray(r) ? (o = r, a = i) : r && _t(r) === "object" && (s = r.strict, a = r.filter), o === !0 && !a)
      return n.store;
    var c = n.getFieldEntitiesForNamePathList(Array.isArray(o) ? o : null), l = [];
    return c.forEach(function(u) {
      var d, f, h = "INVALIDATE_NAME_PATH" in u ? u.INVALIDATE_NAME_PATH : u.getNamePath();
      if (s) {
        var p, g;
        if ((p = (g = u).isList) !== null && p !== void 0 && p.call(g))
          return;
      } else if (!o && (d = (f = u).isListField) !== null && d !== void 0 && d.call(f))
        return;
      if (!a)
        l.push(h);
      else {
        var m = "getMeta" in u ? u.getMeta() : null;
        a(m) && l.push(h);
      }
    }), OL(n.store, l.map(Zr));
  }), re(this, "getFieldValue", function(r) {
    n.warningUnhooked();
    var i = Zr(r);
    return Ys(n.store, i);
  }), re(this, "getFieldsError", function(r) {
    n.warningUnhooked();
    var i = n.getFieldEntitiesForNamePathList(r);
    return i.map(function(o, a) {
      return o && !("INVALIDATE_NAME_PATH" in o) ? {
        name: o.getNamePath(),
        errors: o.getErrors(),
        warnings: o.getWarnings()
      } : {
        name: Zr(r[a]),
        errors: [],
        warnings: []
      };
    });
  }), re(this, "getFieldError", function(r) {
    n.warningUnhooked();
    var i = Zr(r), o = n.getFieldsError([i])[0];
    return o.errors;
  }), re(this, "getFieldWarning", function(r) {
    n.warningUnhooked();
    var i = Zr(r), o = n.getFieldsError([i])[0];
    return o.warnings;
  }), re(this, "isFieldsTouched", function() {
    n.warningUnhooked();
    for (var r = arguments.length, i = new Array(r), o = 0; o < r; o++)
      i[o] = arguments[o];
    var a = i[0], s = i[1], c, l = !1;
    i.length === 0 ? c = null : i.length === 1 ? Array.isArray(a) ? (c = a.map(Zr), l = !1) : (c = null, l = a) : (c = a.map(Zr), l = s);
    var u = n.getFieldEntities(!0), d = function(m) {
      return m.isFieldTouched();
    };
    if (!c)
      return l ? u.every(function(g) {
        return d(g) || g.isList();
      }) : u.some(d);
    var f = new ih();
    c.forEach(function(g) {
      f.set(g, []);
    }), u.forEach(function(g) {
      var m = g.getNamePath();
      c.forEach(function(v) {
        v.every(function(y, S) {
          return m[S] === y;
        }) && f.update(v, function(y) {
          return [].concat(Je(y), [g]);
        });
      });
    });
    var h = function(m) {
      return m.some(d);
    }, p = f.map(function(g) {
      var m = g.value;
      return m;
    });
    return l ? p.every(h) : p.some(h);
  }), re(this, "isFieldTouched", function(r) {
    return n.warningUnhooked(), n.isFieldsTouched([r]);
  }), re(this, "isFieldsValidating", function(r) {
    n.warningUnhooked();
    var i = n.getFieldEntities();
    if (!r)
      return i.some(function(a) {
        return a.isFieldValidating();
      });
    var o = r.map(Zr);
    return i.some(function(a) {
      var s = a.getNamePath();
      return Qh(o, s) && a.isFieldValidating();
    });
  }), re(this, "isFieldValidating", function(r) {
    return n.warningUnhooked(), n.isFieldsValidating([r]);
  }), re(this, "resetWithFieldInitialValue", function() {
    var r = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, i = new ih(), o = n.getFieldEntities(!0);
    o.forEach(function(c) {
      var l = c.props.initialValue, u = c.getNamePath();
      if (l !== void 0) {
        var d = i.get(u) || /* @__PURE__ */ new Set();
        d.add({
          entity: c,
          value: l
        }), i.set(u, d);
      }
    });
    var a = function(l) {
      l.forEach(function(u) {
        var d = u.props.initialValue;
        if (d !== void 0) {
          var f = u.getNamePath(), h = n.getInitialValue(f);
          if (h !== void 0)
            an(!1, "Form already set 'initialValues' with path '".concat(f.join("."), "'. Field can not overwrite it."));
          else {
            var p = i.get(f);
            if (p && p.size > 1)
              an(!1, "Multiple Field with path '".concat(f.join("."), "' set 'initialValue'. Can not decide which one to pick."));
            else if (p) {
              var g = n.getFieldValue(f), m = u.isListField();
              !m && (!r.skipExist || g === void 0) && n.updateStore(is(n.store, f, Je(p)[0].value));
            }
          }
        }
      });
    }, s;
    r.entities ? s = r.entities : r.namePathList ? (s = [], r.namePathList.forEach(function(c) {
      var l = i.get(c);
      if (l) {
        var u;
        (u = s).push.apply(u, Je(Je(l).map(function(d) {
          return d.entity;
        })));
      }
    })) : s = o, a(s);
  }), re(this, "resetFields", function(r) {
    n.warningUnhooked();
    var i = n.store;
    if (!r) {
      n.updateStore(kh(n.initialValues)), n.resetWithFieldInitialValue(), n.notifyObservers(i, null, {
        type: "reset"
      }), n.notifyWatch();
      return;
    }
    var o = r.map(Zr);
    o.forEach(function(a) {
      var s = n.getInitialValue(a);
      n.updateStore(is(n.store, a, s));
    }), n.resetWithFieldInitialValue({
      namePathList: o
    }), n.notifyObservers(i, o, {
      type: "reset"
    }), n.notifyWatch(o);
  }), re(this, "setFields", function(r) {
    n.warningUnhooked();
    var i = n.store, o = [];
    r.forEach(function(a) {
      var s = a.name, c = xn(a, gPe), l = Zr(s);
      o.push(l), "value" in c && n.updateStore(is(n.store, l, c.value)), n.notifyObservers(i, [l], {
        type: "setField",
        data: a
      });
    }), n.notifyWatch(o);
  }), re(this, "getFields", function() {
    var r = n.getFieldEntities(!0), i = r.map(function(o) {
      var a = o.getNamePath(), s = o.getMeta(), c = ae(ae({}, s), {}, {
        name: a,
        value: n.getFieldValue(a)
      });
      return Object.defineProperty(c, "originRCField", {
        value: !0
      }), c;
    });
    return i;
  }), re(this, "initEntityValue", function(r) {
    var i = r.props.initialValue;
    if (i !== void 0) {
      var o = r.getNamePath(), a = Ys(n.store, o);
      a === void 0 && n.updateStore(is(n.store, o, i));
    }
  }), re(this, "isMergedPreserve", function(r) {
    var i = r !== void 0 ? r : n.preserve;
    return i ?? !0;
  }), re(this, "registerField", function(r) {
    n.fieldEntities.push(r);
    var i = r.getNamePath();
    if (n.notifyWatch([i]), r.props.initialValue !== void 0) {
      var o = n.store;
      n.resetWithFieldInitialValue({
        entities: [r],
        skipExist: !0
      }), n.notifyObservers(o, [r.getNamePath()], {
        type: "valueUpdate",
        source: "internal"
      });
    }
    return function(a, s) {
      var c = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : [];
      if (n.fieldEntities = n.fieldEntities.filter(function(d) {
        return d !== r;
      }), !n.isMergedPreserve(s) && (!a || c.length > 1)) {
        var l = a ? void 0 : n.getInitialValue(i);
        if (i.length && n.getFieldValue(i) !== l && n.fieldEntities.every(function(d) {
          return (
            // Only reset when no namePath exist
            !$Q(d.getNamePath(), i)
          );
        })) {
          var u = n.store;
          n.updateStore(is(u, i, l, !0)), n.notifyObservers(u, [i], {
            type: "remove"
          }), n.triggerDependenciesUpdate(u, i);
        }
      }
      n.notifyWatch([i]);
    };
  }), re(this, "dispatch", function(r) {
    switch (r.type) {
      case "updateValue": {
        var i = r.namePath, o = r.value;
        n.updateValue(i, o);
        break;
      }
      case "validateField": {
        var a = r.namePath, s = r.triggerName;
        n.validateFields([a], {
          triggerName: s
        });
        break;
      }
    }
  }), re(this, "notifyObservers", function(r, i, o) {
    if (n.subscribable) {
      var a = ae(ae({}, o), {}, {
        store: n.getFieldsValue(!0)
      });
      n.getFieldEntities().forEach(function(s) {
        var c = s.onStoreChange;
        c(r, i, a);
      });
    } else
      n.forceRootUpdate();
  }), re(this, "triggerDependenciesUpdate", function(r, i) {
    var o = n.getDependencyChildrenFields(i);
    return o.length && n.validateFields(o), n.notifyObservers(r, o, {
      type: "dependenciesUpdate",
      relatedFields: [i].concat(Je(o))
    }), o;
  }), re(this, "updateValue", function(r, i) {
    var o = Zr(r), a = n.store;
    n.updateStore(is(n.store, o, i)), n.notifyObservers(a, [o], {
      type: "valueUpdate",
      source: "internal"
    }), n.notifyWatch([o]);
    var s = n.triggerDependenciesUpdate(a, o), c = n.callbacks.onValuesChange;
    if (c) {
      var l = OL(n.store, [o]);
      c(l, n.getFieldsValue());
    }
    n.triggerOnFieldsChange([o].concat(Je(s)));
  }), re(this, "setFieldsValue", function(r) {
    n.warningUnhooked();
    var i = n.store;
    if (r) {
      var o = kh(n.store, r);
      n.updateStore(o);
    }
    n.notifyObservers(i, null, {
      type: "valueUpdate",
      source: "external"
    }), n.notifyWatch();
  }), re(this, "setFieldValue", function(r, i) {
    n.setFields([{
      name: r,
      value: i
    }]);
  }), re(this, "getDependencyChildrenFields", function(r) {
    var i = /* @__PURE__ */ new Set(), o = [], a = new ih();
    n.getFieldEntities().forEach(function(c) {
      var l = c.props.dependencies;
      (l || []).forEach(function(u) {
        var d = Zr(u);
        a.update(d, function() {
          var f = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : /* @__PURE__ */ new Set();
          return f.add(c), f;
        });
      });
    });
    var s = function c(l) {
      var u = a.get(l) || /* @__PURE__ */ new Set();
      u.forEach(function(d) {
        if (!i.has(d)) {
          i.add(d);
          var f = d.getNamePath();
          d.isFieldDirty() && f.length && (o.push(f), c(f));
        }
      });
    };
    return s(r), o;
  }), re(this, "triggerOnFieldsChange", function(r, i) {
    var o = n.callbacks.onFieldsChange;
    if (o) {
      var a = n.getFields();
      if (i) {
        var s = new ih();
        i.forEach(function(l) {
          var u = l.name, d = l.errors;
          s.set(u, d);
        }), a.forEach(function(l) {
          l.errors = s.get(l.name) || l.errors;
        });
      }
      var c = a.filter(function(l) {
        var u = l.name;
        return Qh(r, u);
      });
      c.length && o(c, a);
    }
  }), re(this, "validateFields", function(r, i) {
    n.warningUnhooked();
    var o, a;
    Array.isArray(r) || typeof r == "string" || typeof i == "string" ? (o = r, a = i) : a = r;
    var s = !!o, c = s ? o.map(Zr) : [], l = [], u = String(Date.now()), d = /* @__PURE__ */ new Set(), f = a || {}, h = f.recursive, p = f.dirty;
    n.getFieldEntities(!0).forEach(function(y) {
      if (s || c.push(y.getNamePath()), !(!y.props.rules || !y.props.rules.length) && !(p && !y.isFieldDirty())) {
        var S = y.getNamePath();
        if (d.add(S.join(u)), !s || Qh(c, S, h)) {
          var _ = y.validateRules(ae({
            validateMessages: ae(ae({}, RQ), n.validateMessages)
          }, a));
          l.push(_.then(function() {
            return {
              name: S,
              errors: [],
              warnings: []
            };
          }).catch(function(w) {
            var T, x = [], C = [];
            return (T = w.forEach) === null || T === void 0 || T.call(w, function(E) {
              var R = E.rule.warningOnly, A = E.errors;
              R ? C.push.apply(C, Je(A)) : x.push.apply(x, Je(A));
            }), x.length ? Promise.reject({
              name: S,
              errors: x,
              warnings: C
            }) : {
              name: S,
              errors: x,
              warnings: C
            };
          }));
        }
      }
    });
    var g = hPe(l);
    n.lastValidatePromise = g, g.catch(function(y) {
      return y;
    }).then(function(y) {
      var S = y.map(function(_) {
        var w = _.name;
        return w;
      });
      n.notifyObservers(n.store, S, {
        type: "validateFinish"
      }), n.triggerOnFieldsChange(S, y);
    });
    var m = g.then(function() {
      return n.lastValidatePromise === g ? Promise.resolve(n.getFieldsValue(c)) : Promise.reject([]);
    }).catch(function(y) {
      var S = y.filter(function(_) {
        return _ && _.errors.length;
      });
      return Promise.reject({
        values: n.getFieldsValue(c),
        errorFields: S,
        outOfDate: n.lastValidatePromise !== g
      });
    });
    m.catch(function(y) {
      return y;
    });
    var v = c.filter(function(y) {
      return d.has(y.join(u));
    });
    return n.triggerOnFieldsChange(v), m;
  }), re(this, "submit", function() {
    n.warningUnhooked(), n.validateFields().then(function(r) {
      var i = n.callbacks.onFinish;
      if (i)
        try {
          i(r);
        } catch (o) {
          console.error(o);
        }
    }).catch(function(r) {
      var i = n.callbacks.onFinishFailed;
      i && i(r);
    });
  }), this.forceRootUpdate = t;
});
function M6(e) {
  var t = I.useRef(), n = I.useState({}), r = fe(n, 2), i = r[1];
  if (!t.current)
    if (e)
      t.current = e;
    else {
      var o = function() {
        i({});
      }, a = new pPe(o);
      t.current = a.getForm();
    }
  return [t.current];
}
var gR = /* @__PURE__ */ I.createContext({
  triggerFormChange: function() {
  },
  triggerFormFinish: function() {
  },
  registerForm: function() {
  },
  unregisterForm: function() {
  }
}), MQ = function(t) {
  var n = t.validateMessages, r = t.onFormChange, i = t.onFormFinish, o = t.children, a = I.useContext(gR), s = I.useRef({});
  return /* @__PURE__ */ I.createElement(gR.Provider, {
    value: ae(ae({}, a), {}, {
      validateMessages: ae(ae({}, a.validateMessages), n),
      // =========================================================
      // =                  Global Form Control                  =
      // =========================================================
      triggerFormChange: function(l, u) {
        r && r(l, {
          changedFields: u,
          forms: s.current
        }), a.triggerFormChange(l, u);
      },
      triggerFormFinish: function(l, u) {
        i && i(l, {
          values: u,
          forms: s.current
        }), a.triggerFormFinish(l, u);
      },
      registerForm: function(l, u) {
        l && (s.current = ae(ae({}, s.current), {}, re({}, l, u))), a.registerForm(l, u);
      },
      unregisterForm: function(l) {
        var u = ae({}, s.current);
        delete u[l], s.current = u, a.unregisterForm(l);
      }
    })
  }, o);
}, mPe = ["name", "initialValues", "fields", "form", "preserve", "children", "component", "validateMessages", "validateTrigger", "onValuesChange", "onFieldsChange", "onFinish", "onFinishFailed", "clearOnDestroy"], vPe = function(t, n) {
  var r = t.name, i = t.initialValues, o = t.fields, a = t.form, s = t.preserve, c = t.children, l = t.component, u = l === void 0 ? "form" : l, d = t.validateMessages, f = t.validateTrigger, h = f === void 0 ? "onChange" : f, p = t.onValuesChange, g = t.onFieldsChange, m = t.onFinish, v = t.onFinishFailed, y = t.clearOnDestroy, S = xn(t, mPe), _ = I.useRef(null), w = I.useContext(gR), T = M6(a), x = fe(T, 1), C = x[0], E = C.getInternalHooks(xd), R = E.useSubscribe, A = E.setInitialValues, O = E.setCallbacks, $ = E.setValidateMessages, N = E.setPreserve, z = E.destroyForm;
  I.useImperativeHandle(n, function() {
    return ae(ae({}, C), {}, {
      nativeElement: _.current
    });
  }), I.useEffect(function() {
    return w.registerForm(r, C), function() {
      w.unregisterForm(r);
    };
  }, [w, C, r]), $(ae(ae({}, w.validateMessages), d)), O({
    onValuesChange: p,
    onFieldsChange: function(q) {
      if (w.triggerFormChange(r, q), g) {
        for (var X = arguments.length, ie = new Array(X > 1 ? X - 1 : 0), te = 1; te < X; te++)
          ie[te - 1] = arguments[te];
        g.apply(void 0, [q].concat(ie));
      }
    },
    onFinish: function(q) {
      w.triggerFormFinish(r, q), m && m(q);
    },
    onFinishFailed: v
  }), N(s);
  var k = I.useRef(null);
  A(i, !k.current), k.current || (k.current = !0), I.useEffect(
    function() {
      return function() {
        return z(y);
      };
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );
  var F, V = typeof c == "function";
  if (V) {
    var j = C.getFieldsValue(!0);
    F = c(j, C);
  } else
    F = c;
  R(!V);
  var B = I.useRef();
  I.useEffect(function() {
    uPe(B.current || [], o || []) || C.setFields(o || []), B.current = o;
  }, [o, C]);
  var U = I.useMemo(function() {
    return ae(ae({}, C), {}, {
      validateTrigger: h
    });
  }, [C, h]), Q = /* @__PURE__ */ I.createElement(sv.Provider, {
    value: null
  }, /* @__PURE__ */ I.createElement(lf.Provider, {
    value: U
  }, F));
  return u === !1 ? Q : /* @__PURE__ */ I.createElement(u, mt({}, S, {
    ref: _,
    onSubmit: function(q) {
      q.preventDefault(), q.stopPropagation(), C.submit();
    },
    onReset: function(q) {
      var X;
      q.preventDefault(), C.resetFields(), (X = S.onReset) === null || X === void 0 || X.call(S, q);
    }
  }), Q);
};
function ML(e) {
  try {
    return JSON.stringify(e);
  } catch {
    return Math.random();
  }
}
var yPe = process.env.NODE_ENV !== "production" ? function(e) {
  var t = e.join("__RC_FIELD_FORM_SPLIT__"), n = Me(t);
  an(n.current === t, "`useWatch` is not support dynamic `namePath`. Please provide static instead.");
} : function() {
};
function kQ() {
  for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
    t[n] = arguments[n];
  var r = t[0], i = t[1], o = i === void 0 ? {} : i, a = ROe(o) ? {
    form: o
  } : o, s = a.form, c = Lt(), l = fe(c, 2), u = l[0], d = l[1], f = At(function() {
    return ML(u);
  }, [u]), h = Me(f);
  h.current = f;
  var p = St(lf), g = s || p, m = g && g._init;
  process.env.NODE_ENV !== "production" && an(t.length === 2 ? s ? m : !0 : m, "useWatch requires a form instance since it can not auto detect from context.");
  var v = Zr(r), y = Me(v);
  return y.current = v, yPe(v), gt(
    function() {
      if (m) {
        var S = g.getFieldsValue, _ = g.getInternalHooks, w = _(xd), T = w.registerWatch, x = function(A, O) {
          var $ = a.preserve ? O : A;
          return typeof r == "function" ? r($) : Ys($, y.current);
        }, C = T(function(R, A) {
          var O = x(R, A), $ = ML(O);
          h.current !== $ && (h.current = $, d(O));
        }), E = x(S(), S(!0));
        return u !== E && d(E), C;
      }
    },
    // We do not need re-register since namePath content is the same
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [m]
  ), u;
}
var bPe = /* @__PURE__ */ I.forwardRef(vPe), xp = bPe;
xp.FormProvider = MQ;
xp.Field = P6;
xp.List = OQ;
xp.useForm = M6;
xp.useWatch = kQ;
const _Pe = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Field: P6,
  FieldContext: lf,
  FormProvider: MQ,
  List: OQ,
  ListContext: sv,
  default: xp,
  useForm: M6,
  useWatch: kQ
}, Symbol.toStringTag, { value: "Module" })), xs = /* @__PURE__ */ I.createContext({});
process.env.NODE_ENV !== "production" && (xs.displayName = "FormItemInputContext");
const SPe = (e) => {
  let {
    children: t,
    status: n,
    override: r
  } = e;
  const i = St(xs), o = At(() => {
    const a = Object.assign({}, i);
    return r && delete a.isFormItemInput, n && (delete a.status, delete a.hasFeedback, delete a.feedbackIcon), a;
  }, [n, r, i]);
  return /* @__PURE__ */ I.createElement(xs.Provider, {
    value: o
  }, t);
}, wPe = /* @__PURE__ */ Is(void 0), xPe = (e) => {
  const {
    space: t,
    form: n,
    children: r
  } = e;
  if (r == null)
    return null;
  let i = r;
  return n && (i = /* @__PURE__ */ D.createElement(SPe, {
    override: !0,
    status: !0
  }, i)), t && (i = /* @__PURE__ */ D.createElement(FRe, null, i)), i;
}, cv = xPe, EPe = (e) => {
  const {
    prefixCls: t,
    className: n,
    style: r,
    size: i,
    shape: o
  } = e, a = we({
    [`${t}-lg`]: i === "large",
    [`${t}-sm`]: i === "small"
  }), s = we({
    [`${t}-circle`]: o === "circle",
    [`${t}-square`]: o === "square",
    [`${t}-round`]: o === "round"
  }), c = I.useMemo(() => typeof i == "number" ? {
    width: i,
    height: i,
    lineHeight: `${i}px`
  } : {}, [i]);
  return /* @__PURE__ */ I.createElement("span", {
    className: we(t, a, s, n),
    style: Object.assign(Object.assign({}, c), r)
  });
}, oE = EPe, CPe = new $n("ant-skeleton-loading", {
  "0%": {
    backgroundPosition: "100% 50%"
  },
  "100%": {
    backgroundPosition: "0 50%"
  }
}), aE = (e) => ({
  height: e,
  lineHeight: Qe(e)
}), Jh = (e) => Object.assign({
  width: e
}, aE(e)), TPe = (e) => ({
  background: e.skeletonLoadingBackground,
  backgroundSize: "400% 100%",
  animationName: CPe,
  animationDuration: e.skeletonLoadingMotionDuration,
  animationTimingFunction: "ease",
  animationIterationCount: "infinite"
}), U5 = (e, t) => Object.assign({
  width: t(e).mul(5).equal(),
  minWidth: t(e).mul(5).equal()
}, aE(e)), IPe = (e) => {
  const {
    skeletonAvatarCls: t,
    gradientFromColor: n,
    controlHeight: r,
    controlHeightLG: i,
    controlHeightSM: o
  } = e;
  return {
    [t]: Object.assign({
      display: "inline-block",
      verticalAlign: "top",
      background: n
    }, Jh(r)),
    [`${t}${t}-circle`]: {
      borderRadius: "50%"
    },
    [`${t}${t}-lg`]: Object.assign({}, Jh(i)),
    [`${t}${t}-sm`]: Object.assign({}, Jh(o))
  };
}, APe = (e) => {
  const {
    controlHeight: t,
    borderRadiusSM: n,
    skeletonInputCls: r,
    controlHeightLG: i,
    controlHeightSM: o,
    gradientFromColor: a,
    calc: s
  } = e;
  return {
    [r]: Object.assign({
      display: "inline-block",
      verticalAlign: "top",
      background: a,
      borderRadius: n
    }, U5(t, s)),
    [`${r}-lg`]: Object.assign({}, U5(i, s)),
    [`${r}-sm`]: Object.assign({}, U5(o, s))
  };
}, kL = (e) => Object.assign({
  width: e
}, aE(e)), RPe = (e) => {
  const {
    skeletonImageCls: t,
    imageSizeBase: n,
    gradientFromColor: r,
    borderRadiusSM: i,
    calc: o
  } = e;
  return {
    [t]: Object.assign(Object.assign({
      display: "inline-flex",
      alignItems: "center",
      justifyContent: "center",
      verticalAlign: "middle",
      background: r,
      borderRadius: i
    }, kL(o(n).mul(2).equal())), {
      [`${t}-path`]: {
        fill: "#bfbfbf"
      },
      [`${t}-svg`]: Object.assign(Object.assign({}, kL(n)), {
        maxWidth: o(n).mul(4).equal(),
        maxHeight: o(n).mul(4).equal()
      }),
      [`${t}-svg${t}-svg-circle`]: {
        borderRadius: "50%"
      }
    }),
    [`${t}${t}-circle`]: {
      borderRadius: "50%"
    }
  };
}, W5 = (e, t, n) => {
  const {
    skeletonButtonCls: r
  } = e;
  return {
    [`${n}${r}-circle`]: {
      width: t,
      minWidth: t,
      borderRadius: "50%"
    },
    [`${n}${r}-round`]: {
      borderRadius: t
    }
  };
}, q5 = (e, t) => Object.assign({
  width: t(e).mul(2).equal(),
  minWidth: t(e).mul(2).equal()
}, aE(e)), $Pe = (e) => {
  const {
    borderRadiusSM: t,
    skeletonButtonCls: n,
    controlHeight: r,
    controlHeightLG: i,
    controlHeightSM: o,
    gradientFromColor: a,
    calc: s
  } = e;
  return Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({
    [n]: Object.assign({
      display: "inline-block",
      verticalAlign: "top",
      background: a,
      borderRadius: t,
      width: s(r).mul(2).equal(),
      minWidth: s(r).mul(2).equal()
    }, q5(r, s))
  }, W5(e, r, n)), {
    [`${n}-lg`]: Object.assign({}, q5(i, s))
  }), W5(e, i, `${n}-lg`)), {
    [`${n}-sm`]: Object.assign({}, q5(o, s))
  }), W5(e, o, `${n}-sm`));
}, OPe = (e) => {
  const {
    componentCls: t,
    skeletonAvatarCls: n,
    skeletonTitleCls: r,
    skeletonParagraphCls: i,
    skeletonButtonCls: o,
    skeletonInputCls: a,
    skeletonImageCls: s,
    controlHeight: c,
    controlHeightLG: l,
    controlHeightSM: u,
    gradientFromColor: d,
    padding: f,
    marginSM: h,
    borderRadius: p,
    titleHeight: g,
    blockRadius: m,
    paragraphLiHeight: v,
    controlHeightXS: y,
    paragraphMarginTop: S
  } = e;
  return {
    [t]: {
      display: "table",
      width: "100%",
      [`${t}-header`]: {
        display: "table-cell",
        paddingInlineEnd: f,
        verticalAlign: "top",
        // Avatar
        [n]: Object.assign({
          display: "inline-block",
          verticalAlign: "top",
          background: d
        }, Jh(c)),
        [`${n}-circle`]: {
          borderRadius: "50%"
        },
        [`${n}-lg`]: Object.assign({}, Jh(l)),
        [`${n}-sm`]: Object.assign({}, Jh(u))
      },
      [`${t}-content`]: {
        display: "table-cell",
        width: "100%",
        verticalAlign: "top",
        // Title
        [r]: {
          width: "100%",
          height: g,
          background: d,
          borderRadius: m,
          [`+ ${i}`]: {
            marginBlockStart: u
          }
        },
        // paragraph
        [i]: {
          padding: 0,
          "> li": {
            width: "100%",
            height: v,
            listStyle: "none",
            background: d,
            borderRadius: m,
            "+ li": {
              marginBlockStart: y
            }
          }
        },
        [`${i}> li:last-child:not(:first-child):not(:nth-child(2))`]: {
          width: "61%"
        }
      },
      [`&-round ${t}-content`]: {
        [`${r}, ${i} > li`]: {
          borderRadius: p
        }
      }
    },
    [`${t}-with-avatar ${t}-content`]: {
      // Title
      [r]: {
        marginBlockStart: h,
        [`+ ${i}`]: {
          marginBlockStart: S
        }
      }
    },
    // Skeleton element
    [`${t}${t}-element`]: Object.assign(Object.assign(Object.assign(Object.assign({
      display: "inline-block",
      width: "auto"
    }, $Pe(e)), IPe(e)), APe(e)), RPe(e)),
    // Skeleton Block Button, Input
    [`${t}${t}-block`]: {
      width: "100%",
      [o]: {
        width: "100%"
      },
      [a]: {
        width: "100%"
      }
    },
    // With active animation
    [`${t}${t}-active`]: {
      [`
        ${r},
        ${i} > li,
        ${n},
        ${o},
        ${a},
        ${s}
      `]: Object.assign({}, TPe(e))
    }
  };
}, PPe = (e) => {
  const {
    colorFillContent: t,
    colorFill: n
  } = e, r = t, i = n;
  return {
    color: r,
    colorGradientEnd: i,
    gradientFromColor: r,
    gradientToColor: i,
    titleHeight: e.controlHeight / 2,
    blockRadius: e.borderRadiusSM,
    paragraphMarginTop: e.marginLG + e.marginXXS,
    paragraphLiHeight: e.controlHeight / 2
  };
}, Ep = qa("Skeleton", (e) => {
  const {
    componentCls: t,
    calc: n
  } = e, r = Or(e, {
    skeletonAvatarCls: `${t}-avatar`,
    skeletonTitleCls: `${t}-title`,
    skeletonParagraphCls: `${t}-paragraph`,
    skeletonButtonCls: `${t}-button`,
    skeletonInputCls: `${t}-input`,
    skeletonImageCls: `${t}-image`,
    imageSizeBase: n(e.controlHeight).mul(1.5).equal(),
    borderRadius: 100,
    // Large number to make capsule shape
    skeletonLoadingBackground: `linear-gradient(90deg, ${e.gradientFromColor} 25%, ${e.gradientToColor} 37%, ${e.gradientFromColor} 63%)`,
    skeletonLoadingMotionDuration: "1.4s"
  });
  return [OPe(r)];
}, PPe, {
  deprecatedTokens: [["color", "gradientFromColor"], ["colorGradientEnd", "gradientToColor"]]
}), MPe = (e) => {
  const {
    prefixCls: t,
    className: n,
    rootClassName: r,
    active: i,
    shape: o = "circle",
    size: a = "default"
  } = e, {
    getPrefixCls: s
  } = I.useContext(En), c = s("skeleton", t), [l, u, d] = Ep(c), f = Hu(e, ["prefixCls", "className"]), h = we(c, `${c}-element`, {
    [`${c}-active`]: i
  }, n, r, u, d);
  return l(/* @__PURE__ */ I.createElement("div", {
    className: h
  }, /* @__PURE__ */ I.createElement(oE, Object.assign({
    prefixCls: `${c}-avatar`,
    shape: o,
    size: a
  }, f))));
}, kPe = MPe, NPe = (e) => {
  const {
    prefixCls: t,
    className: n,
    rootClassName: r,
    active: i,
    block: o = !1,
    size: a = "default"
  } = e, {
    getPrefixCls: s
  } = I.useContext(En), c = s("skeleton", t), [l, u, d] = Ep(c), f = Hu(e, ["prefixCls"]), h = we(c, `${c}-element`, {
    [`${c}-active`]: i,
    [`${c}-block`]: o
  }, n, r, u, d);
  return l(/* @__PURE__ */ I.createElement("div", {
    className: h
  }, /* @__PURE__ */ I.createElement(oE, Object.assign({
    prefixCls: `${c}-button`,
    size: a
  }, f))));
}, DPe = NPe, LPe = "M365.714286 329.142857q0 45.714286-32.036571 77.677714t-77.677714 32.036571-77.677714-32.036571-32.036571-77.677714 32.036571-77.677714 77.677714-32.036571 77.677714 32.036571 32.036571 77.677714zM950.857143 548.571429l0 256-804.571429 0 0-109.714286 182.857143-182.857143 91.428571 91.428571 292.571429-292.571429zM1005.714286 146.285714l-914.285714 0q-7.460571 0-12.873143 5.412571t-5.412571 12.873143l0 694.857143q0 7.460571 5.412571 12.873143t12.873143 5.412571l914.285714 0q7.460571 0 12.873143-5.412571t5.412571-12.873143l0-694.857143q0-7.460571-5.412571-12.873143t-12.873143-5.412571zM1097.142857 164.571429l0 694.857143q0 37.741714-26.843429 64.585143t-64.585143 26.843429l-914.285714 0q-37.741714 0-64.585143-26.843429t-26.843429-64.585143l0-694.857143q0-37.741714 26.843429-64.585143t64.585143-26.843429l914.285714 0q37.741714 0 64.585143 26.843429t26.843429 64.585143z", jPe = (e) => {
  const {
    prefixCls: t,
    className: n,
    rootClassName: r,
    style: i,
    active: o
  } = e, {
    getPrefixCls: a
  } = I.useContext(En), s = a("skeleton", t), [c, l, u] = Ep(s), d = we(s, `${s}-element`, {
    [`${s}-active`]: o
  }, n, r, l, u);
  return c(/* @__PURE__ */ I.createElement("div", {
    className: d
  }, /* @__PURE__ */ I.createElement("div", {
    className: we(`${s}-image`, n),
    style: i
  }, /* @__PURE__ */ I.createElement("svg", {
    viewBox: "0 0 1098 1024",
    xmlns: "http://www.w3.org/2000/svg",
    className: `${s}-image-svg`
  }, /* @__PURE__ */ I.createElement("title", null, "Image placeholder"), /* @__PURE__ */ I.createElement("path", {
    d: LPe,
    className: `${s}-image-path`
  })))));
}, FPe = jPe, VPe = (e) => {
  const {
    prefixCls: t,
    className: n,
    rootClassName: r,
    active: i,
    block: o,
    size: a = "default"
  } = e, {
    getPrefixCls: s
  } = I.useContext(En), c = s("skeleton", t), [l, u, d] = Ep(c), f = Hu(e, ["prefixCls"]), h = we(c, `${c}-element`, {
    [`${c}-active`]: i,
    [`${c}-block`]: o
  }, n, r, u, d);
  return l(/* @__PURE__ */ I.createElement("div", {
    className: h
  }, /* @__PURE__ */ I.createElement(oE, Object.assign({
    prefixCls: `${c}-input`,
    size: a
  }, f))));
}, BPe = VPe, zPe = (e) => {
  const {
    prefixCls: t,
    className: n,
    rootClassName: r,
    style: i,
    active: o,
    children: a
  } = e, {
    getPrefixCls: s
  } = I.useContext(En), c = s("skeleton", t), [l, u, d] = Ep(c), f = we(c, `${c}-element`, {
    [`${c}-active`]: o
  }, u, n, r, d);
  return l(/* @__PURE__ */ I.createElement("div", {
    className: f
  }, /* @__PURE__ */ I.createElement("div", {
    className: we(`${c}-image`, n),
    style: i
  }, a)));
}, HPe = zPe, UPe = (e, t) => {
  const {
    width: n,
    rows: r = 2
  } = t;
  if (Array.isArray(n))
    return n[e];
  if (r - 1 === e)
    return n;
}, WPe = (e) => {
  const {
    prefixCls: t,
    className: n,
    style: r,
    rows: i
  } = e, o = Je(new Array(i)).map((a, s) => (
    // eslint-disable-next-line react/no-array-index-key
    /* @__PURE__ */ I.createElement("li", {
      key: s,
      style: {
        width: UPe(s, e)
      }
    })
  ));
  return /* @__PURE__ */ I.createElement("ul", {
    className: we(t, n),
    style: r
  }, o);
}, qPe = WPe, GPe = (e) => {
  let {
    prefixCls: t,
    className: n,
    width: r,
    style: i
  } = e;
  return (
    // biome-ignore lint/a11y/useHeadingContent: HOC here
    /* @__PURE__ */ I.createElement("h3", {
      className: we(t, n),
      style: Object.assign({
        width: r
      }, i)
    })
  );
}, KPe = GPe;
function G5(e) {
  return e && typeof e == "object" ? e : {};
}
function YPe(e, t) {
  return e && !t ? {
    size: "large",
    shape: "square"
  } : {
    size: "large",
    shape: "circle"
  };
}
function XPe(e, t) {
  return !e && t ? {
    width: "38%"
  } : e && t ? {
    width: "50%"
  } : {};
}
function QPe(e, t) {
  const n = {};
  return (!e || !t) && (n.width = "61%"), !e && t ? n.rows = 3 : n.rows = 2, n;
}
const $f = (e) => {
  const {
    prefixCls: t,
    loading: n,
    className: r,
    rootClassName: i,
    style: o,
    children: a,
    avatar: s = !1,
    title: c = !0,
    paragraph: l = !0,
    active: u,
    round: d
  } = e, {
    getPrefixCls: f,
    direction: h,
    skeleton: p
  } = I.useContext(En), g = f("skeleton", t), [m, v, y] = Ep(g);
  if (n || !("loading" in e)) {
    const S = !!s, _ = !!c, w = !!l;
    let T;
    if (S) {
      const E = Object.assign(Object.assign({
        prefixCls: `${g}-avatar`
      }, YPe(_, w)), G5(s));
      T = /* @__PURE__ */ I.createElement("div", {
        className: `${g}-header`
      }, /* @__PURE__ */ I.createElement(oE, Object.assign({}, E)));
    }
    let x;
    if (_ || w) {
      let E;
      if (_) {
        const A = Object.assign(Object.assign({
          prefixCls: `${g}-title`
        }, XPe(S, w)), G5(c));
        E = /* @__PURE__ */ I.createElement(KPe, Object.assign({}, A));
      }
      let R;
      if (w) {
        const A = Object.assign(Object.assign({
          prefixCls: `${g}-paragraph`
        }, QPe(S, _)), G5(l));
        R = /* @__PURE__ */ I.createElement(qPe, Object.assign({}, A));
      }
      x = /* @__PURE__ */ I.createElement("div", {
        className: `${g}-content`
      }, E, R);
    }
    const C = we(g, {
      [`${g}-with-avatar`]: S,
      [`${g}-active`]: u,
      [`${g}-rtl`]: h === "rtl",
      [`${g}-round`]: d
    }, p == null ? void 0 : p.className, r, i, v, y);
    return m(/* @__PURE__ */ I.createElement("div", {
      className: C,
      style: Object.assign(Object.assign({}, p == null ? void 0 : p.style), o)
    }, T, x));
  }
  return a ?? null;
};
$f.Button = DPe;
$f.Avatar = kPe;
$f.Input = BPe;
$f.Image = FPe;
$f.Node = HPe;
process.env.NODE_ENV !== "production" && ($f.displayName = "Skeleton");
const NL = $f, JPe = /* @__PURE__ */ D.createContext({});
function ZPe(e) {
  return (t) => /* @__PURE__ */ I.createElement(lo, {
    theme: {
      token: {
        motion: !1,
        zIndexPopupBase: 0
      }
    }
  }, /* @__PURE__ */ I.createElement(e, Object.assign({}, t)));
}
const e6e = (e, t, n, r) => ZPe((o) => {
  const {
    prefixCls: a,
    style: s
  } = o, c = I.useRef(null), [l, u] = I.useState(0), [d, f] = I.useState(0), [h, p] = hc(!1, {
    value: o.open
  }), {
    getPrefixCls: g
  } = I.useContext(En), m = g(t || "select", a);
  I.useEffect(() => {
    if (p(!0), typeof ResizeObserver < "u") {
      const S = new ResizeObserver((w) => {
        const T = w[0].target;
        u(T.offsetHeight + 8), f(T.offsetWidth);
      }), _ = setInterval(() => {
        var w;
        const T = n ? `.${n(m)}` : `.${m}-dropdown`, x = (w = c.current) === null || w === void 0 ? void 0 : w.querySelector(T);
        x && (clearInterval(_), S.observe(x));
      }, 10);
      return () => {
        clearInterval(_), S.disconnect();
      };
    }
  }, []);
  let v = Object.assign(Object.assign({}, o), {
    style: Object.assign(Object.assign({}, s), {
      margin: 0
    }),
    open: h,
    visible: h,
    getPopupContainer: () => c.current
  });
  r && (v = r(v));
  const y = {
    paddingBottom: l,
    position: "relative",
    minWidth: d
  };
  return /* @__PURE__ */ I.createElement("div", {
    ref: c,
    style: y
  }, /* @__PURE__ */ I.createElement(e, Object.assign({}, v)));
}), t6e = e6e, k6 = function() {
  if (typeof navigator > "u" || typeof window > "u")
    return !1;
  var e = navigator.userAgent || navigator.vendor || window.opera;
  return /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(e) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw-(n|u)|c55\/|capi|ccwa|cdm-|cell|chtm|cldc|cmd-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc-s|devi|dica|dmob|do(c|p)o|ds(12|-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(-|_)|g1 u|g560|gene|gf-5|g-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd-(m|p|t)|hei-|hi(pt|ta)|hp( i|ip)|hs-c|ht(c(-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i-(20|go|ma)|i230|iac( |-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|-[a-w])|libw|lynx|m1-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|-([1-8]|c))|phil|pire|pl(ay|uc)|pn-2|po(ck|rt|se)|prox|psio|pt-g|qa-a|qc(07|12|21|32|60|-[2-7]|i-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h-|oo|p-)|sdk\/|se(c(-|0|1)|47|mc|nd|ri)|sgh-|shar|sie(-|m)|sk-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h-|v-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl-|tdg-|tel(i|m)|tim-|t-mo|to(pl|sh)|ts(70|m-|m3|m5)|tx-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas-|your|zeto|zte-/i.test(e == null ? void 0 : e.substr(0, 4));
};
var sE = function(t) {
  var n = t.className, r = t.customizeIcon, i = t.customizeIconProps, o = t.children, a = t.onMouseDown, s = t.onClick, c = typeof r == "function" ? r(i) : r;
  return /* @__PURE__ */ I.createElement("span", {
    className: n,
    onMouseDown: function(u) {
      u.preventDefault(), a == null || a(u);
    },
    style: {
      userSelect: "none",
      WebkitUserSelect: "none"
    },
    unselectable: "on",
    onClick: s,
    "aria-hidden": !0
  }, c !== void 0 ? c : /* @__PURE__ */ I.createElement("span", {
    className: we(n.split(/\s+/).map(function(l) {
      return "".concat(l, "-icon");
    }))
  }, o));
}, n6e = function(t, n, r, i, o) {
  var a = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : !1, s = arguments.length > 6 ? arguments[6] : void 0, c = arguments.length > 7 ? arguments[7] : void 0, l = D.useMemo(function() {
    if (_t(i) === "object")
      return i.clearIcon;
    if (o)
      return o;
  }, [i, o]), u = D.useMemo(function() {
    return !!(!a && i && (r.length || s) && !(c === "combobox" && s === ""));
  }, [i, a, r.length, s, c]);
  return {
    allowClear: u,
    clearIcon: /* @__PURE__ */ D.createElement(sE, {
      className: "".concat(t, "-clear"),
      onMouseDown: n,
      customizeIcon: l
    }, "×")
  };
}, NQ = /* @__PURE__ */ I.createContext(null);
function r6e() {
  return I.useContext(NQ);
}
function i6e() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 10, t = I.useState(!1), n = fe(t, 2), r = n[0], i = n[1], o = I.useRef(null), a = function() {
    window.clearTimeout(o.current);
  };
  I.useEffect(function() {
    return a;
  }, []);
  var s = function(l, u) {
    a(), o.current = window.setTimeout(function() {
      i(l), u && u();
    }, e);
  };
  return [r, s, a];
}
function DQ() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 250, t = I.useRef(null), n = I.useRef(null);
  I.useEffect(function() {
    return function() {
      window.clearTimeout(n.current);
    };
  }, []);
  function r(i) {
    (i || t.current === null) && (t.current = i), window.clearTimeout(n.current), n.current = window.setTimeout(function() {
      t.current = null;
    }, e);
  }
  return [function() {
    return t.current;
  }, r];
}
function o6e(e, t, n, r) {
  var i = I.useRef(null);
  i.current = {
    open: t,
    triggerOpen: n,
    customizedTrigger: r
  }, I.useEffect(function() {
    function o(a) {
      var s;
      if (!((s = i.current) !== null && s !== void 0 && s.customizedTrigger)) {
        var c = a.target;
        c.shadowRoot && a.composed && (c = a.composedPath()[0] || c), i.current.open && e().filter(function(l) {
          return l;
        }).every(function(l) {
          return !l.contains(c) && l !== c;
        }) && i.current.triggerOpen(!1);
      }
    }
    return window.addEventListener("mousedown", o), function() {
      return window.removeEventListener("mousedown", o);
    };
  }, []);
}
function a6e(e) {
  return ![
    // System function button
    Ae.ESC,
    Ae.SHIFT,
    Ae.BACKSPACE,
    Ae.TAB,
    Ae.WIN_KEY,
    Ae.ALT,
    Ae.META,
    Ae.WIN_KEY_RIGHT,
    Ae.CTRL,
    Ae.SEMICOLON,
    Ae.EQUALS,
    Ae.CAPS_LOCK,
    Ae.CONTEXT_MENU,
    // F1-F12
    Ae.F1,
    Ae.F2,
    Ae.F3,
    Ae.F4,
    Ae.F5,
    Ae.F6,
    Ae.F7,
    Ae.F8,
    Ae.F9,
    Ae.F10,
    Ae.F11,
    Ae.F12
  ].includes(e);
}
var s6e = ["prefixCls", "invalidate", "item", "renderItem", "responsive", "responsiveDisabled", "registerSize", "itemKey", "className", "style", "children", "display", "order", "component"], oh = void 0;
function c6e(e, t) {
  var n = e.prefixCls, r = e.invalidate, i = e.item, o = e.renderItem, a = e.responsive, s = e.responsiveDisabled, c = e.registerSize, l = e.itemKey, u = e.className, d = e.style, f = e.children, h = e.display, p = e.order, g = e.component, m = g === void 0 ? "div" : g, v = xn(e, s6e), y = a && !h;
  function S(C) {
    c(l, C);
  }
  I.useEffect(function() {
    return function() {
      S(null);
    };
  }, []);
  var _ = o && i !== oh ? o(i) : f, w;
  r || (w = {
    opacity: y ? 0 : 1,
    height: y ? 0 : oh,
    overflowY: y ? "hidden" : oh,
    order: a ? p : oh,
    pointerEvents: y ? "none" : oh,
    position: y ? "absolute" : oh
  });
  var T = {};
  y && (T["aria-hidden"] = !0);
  var x = /* @__PURE__ */ I.createElement(m, mt({
    className: we(!r && n, u),
    style: ae(ae({}, w), d)
  }, T, v, {
    ref: t
  }), _);
  return a && (x = /* @__PURE__ */ I.createElement(ml, {
    onResize: function(E) {
      var R = E.offsetWidth;
      S(R);
    },
    disabled: s
  }, x)), x;
}
var x0 = /* @__PURE__ */ I.forwardRef(c6e);
x0.displayName = "Item";
function l6e(e) {
  if (typeof MessageChannel > "u")
    Ln(e);
  else {
    var t = new MessageChannel();
    t.port1.onmessage = function() {
      return e();
    }, t.port2.postMessage(void 0);
  }
}
function u6e() {
  var e = I.useRef(null), t = function(r) {
    e.current || (e.current = [], l6e(function() {
      nO(function() {
        e.current.forEach(function(i) {
          i();
        }), e.current = null;
      });
    })), e.current.push(r);
  };
  return t;
}
function fm(e, t) {
  var n = I.useState(t), r = fe(n, 2), i = r[0], o = r[1], a = Rr(function(s) {
    e(function() {
      o(s);
    });
  });
  return [i, a];
}
var DS = /* @__PURE__ */ D.createContext(null), d6e = ["component"], f6e = ["className"], h6e = ["className"], g6e = function(t, n) {
  var r = I.useContext(DS);
  if (!r) {
    var i = t.component, o = i === void 0 ? "div" : i, a = xn(t, d6e);
    return /* @__PURE__ */ I.createElement(o, mt({}, a, {
      ref: n
    }));
  }
  var s = r.className, c = xn(r, f6e), l = t.className, u = xn(t, h6e);
  return /* @__PURE__ */ I.createElement(DS.Provider, {
    value: null
  }, /* @__PURE__ */ I.createElement(x0, mt({
    ref: n,
    className: we(s, l)
  }, c, u)));
}, LQ = /* @__PURE__ */ I.forwardRef(g6e);
LQ.displayName = "RawItem";
var p6e = ["prefixCls", "data", "renderItem", "renderRawItem", "itemKey", "itemWidth", "ssr", "style", "className", "maxCount", "renderRest", "renderRawRest", "suffix", "component", "itemComponent", "onVisibleChange"], jQ = "responsive", FQ = "invalidate";
function m6e(e) {
  return "+ ".concat(e.length, " ...");
}
function v6e(e, t) {
  var n = e.prefixCls, r = n === void 0 ? "rc-overflow" : n, i = e.data, o = i === void 0 ? [] : i, a = e.renderItem, s = e.renderRawItem, c = e.itemKey, l = e.itemWidth, u = l === void 0 ? 10 : l, d = e.ssr, f = e.style, h = e.className, p = e.maxCount, g = e.renderRest, m = e.renderRawRest, v = e.suffix, y = e.component, S = y === void 0 ? "div" : y, _ = e.itemComponent, w = e.onVisibleChange, T = xn(e, p6e), x = d === "full", C = u6e(), E = fm(C, null), R = fe(E, 2), A = R[0], O = R[1], $ = A || 0, N = fm(C, /* @__PURE__ */ new Map()), z = fe(N, 2), k = z[0], F = z[1], V = fm(C, 0), j = fe(V, 2), B = j[0], U = j[1], Q = fm(C, 0), K = fe(Q, 2), q = K[0], X = K[1], ie = fm(C, 0), te = fe(ie, 2), J = te[0], Y = te[1], ee = Lt(null), Z = fe(ee, 2), H = Z[0], oe = Z[1], W = Lt(null), se = fe(W, 2), ce = se[0], ge = se[1], he = I.useMemo(function() {
    return ce === null && x ? Number.MAX_SAFE_INTEGER : ce || 0;
  }, [ce, A]), ue = Lt(!1), Ee = fe(ue, 2), pe = Ee[0], Oe = Ee[1], de = "".concat(r, "-item"), be = Math.max(B, q), Ie = p === jQ, Ve = o.length && Ie, Fe = p === FQ, Pe = Ve || typeof p == "number" && o.length > p, ot = At(function() {
    var We = o;
    return Ve ? A === null && x ? We = o : We = o.slice(0, Math.min(o.length, $ / u)) : typeof p == "number" && (We = o.slice(0, p)), We;
  }, [o, u, A, p, Ve]), dt = At(function() {
    return Ve ? o.slice(he + 1) : o.slice(ot.length);
  }, [o, ot, Ve, he]), ft = mn(function(We, et) {
    var Ne;
    return typeof c == "function" ? c(We) : (Ne = c && (We == null ? void 0 : We[c])) !== null && Ne !== void 0 ? Ne : et;
  }, [c]), wt = mn(a || function(We) {
    return We;
  }, [a]);
  function Ge(We, et, Ne) {
    ce === We && (et === void 0 || et === H) || (ge(We), Ne || (Oe(We < o.length - 1), w == null || w(We)), et !== void 0 && oe(et));
  }
  function at(We, et) {
    O(et.clientWidth);
  }
  function Nt(We, et) {
    F(function(Ne) {
      var Yt = new Map(Ne);
      return et === null ? Yt.delete(We) : Yt.set(We, et), Yt;
    });
  }
  function zt(We, et) {
    X(et), U(q);
  }
  function kt(We, et) {
    Y(et);
  }
  function Ct(We) {
    return k.get(ft(ot[We], We));
  }
  nr(function() {
    if ($ && typeof be == "number" && ot) {
      var We = J, et = ot.length, Ne = et - 1;
      if (!et) {
        Ge(0, null);
        return;
      }
      for (var Yt = 0; Yt < et; Yt += 1) {
        var Ht = Ct(Yt);
        if (x && (Ht = Ht || 0), Ht === void 0) {
          Ge(Yt - 1, void 0, !0);
          break;
        }
        if (We += Ht, // Only one means `totalWidth` is the final width
        Ne === 0 && We <= $ || // Last two width will be the final width
        Yt === Ne - 1 && We + Ct(Ne) <= $) {
          Ge(Ne, null);
          break;
        } else if (We + be > $) {
          Ge(Yt - 1, We - Ht - J + q);
          break;
        }
      }
      v && Ct(0) + J > $ && oe(null);
    }
  }, [$, k, q, J, ft, ot]);
  var yt = pe && !!dt.length, Mn = {};
  H !== null && Ve && (Mn = {
    position: "absolute",
    left: H,
    top: 0
  });
  var Pt = {
    prefixCls: de,
    responsive: Ve,
    component: _,
    invalidate: Fe
  }, Ze = s ? function(We, et) {
    var Ne = ft(We, et);
    return /* @__PURE__ */ I.createElement(DS.Provider, {
      key: Ne,
      value: ae(ae({}, Pt), {}, {
        order: et,
        item: We,
        itemKey: Ne,
        registerSize: Nt,
        display: et <= he
      })
    }, s(We, et));
  } : function(We, et) {
    var Ne = ft(We, et);
    return /* @__PURE__ */ I.createElement(x0, mt({}, Pt, {
      order: et,
      key: Ne,
      item: We,
      renderItem: wt,
      itemKey: Ne,
      registerSize: Nt,
      display: et <= he
    }));
  }, Le, rt = {
    order: yt ? he : Number.MAX_SAFE_INTEGER,
    className: "".concat(de, "-rest"),
    registerSize: zt,
    display: yt
  };
  if (m)
    m && (Le = /* @__PURE__ */ I.createElement(DS.Provider, {
      value: ae(ae({}, Pt), rt)
    }, m(dt)));
  else {
    var ut = g || m6e;
    Le = /* @__PURE__ */ I.createElement(x0, mt({}, Pt, rt), typeof ut == "function" ? ut(dt) : ut);
  }
  var vt = /* @__PURE__ */ I.createElement(S, mt({
    className: we(!Fe && r, h),
    style: f,
    ref: t
  }, T), ot.map(Ze), Pe ? Le : null, v && /* @__PURE__ */ I.createElement(x0, mt({}, Pt, {
    responsive: Ie,
    responsiveDisabled: !Ve,
    order: he,
    className: "".concat(de, "-suffix"),
    registerSize: kt,
    display: !0,
    style: Mn
  }), v));
  return Ie && (vt = /* @__PURE__ */ I.createElement(ml, {
    onResize: at,
    disabled: !Ve
  }, vt)), vt;
}
var uy = /* @__PURE__ */ I.forwardRef(v6e);
uy.displayName = "Overflow";
uy.Item = LQ;
uy.RESPONSIVE = jQ;
uy.INVALIDATE = FQ;
var y6e = function(t, n) {
  var r, i = t.prefixCls, o = t.id, a = t.inputElement, s = t.disabled, c = t.tabIndex, l = t.autoFocus, u = t.autoComplete, d = t.editable, f = t.activeDescendantId, h = t.value, p = t.maxLength, g = t.onKeyDown, m = t.onMouseDown, v = t.onChange, y = t.onPaste, S = t.onCompositionStart, _ = t.onCompositionEnd, w = t.open, T = t.attrs, x = a || /* @__PURE__ */ I.createElement("input", null), C = x, E = C.ref, R = C.props, A = R.onKeyDown, O = R.onChange, $ = R.onMouseDown, N = R.onCompositionStart, z = R.onCompositionEnd, k = R.style;
  return Cu(!("maxLength" in x.props), "Passing 'maxLength' to input element directly may not work because input in BaseSelect is controlled."), x = /* @__PURE__ */ I.cloneElement(x, ae(ae(ae({
    type: "search"
  }, R), {}, {
    // Override over origin props
    id: o,
    ref: Wa(n, E),
    disabled: s,
    tabIndex: c,
    autoComplete: u || "off",
    autoFocus: l,
    className: we("".concat(i, "-selection-search-input"), (r = x) === null || r === void 0 || (r = r.props) === null || r === void 0 ? void 0 : r.className),
    role: "combobox",
    "aria-expanded": w || !1,
    "aria-haspopup": "listbox",
    "aria-owns": "".concat(o, "_list"),
    "aria-autocomplete": "list",
    "aria-controls": "".concat(o, "_list"),
    "aria-activedescendant": w ? f : void 0
  }, T), {}, {
    value: d ? h : "",
    maxLength: p,
    readOnly: !d,
    unselectable: d ? null : "on",
    style: ae(ae({}, k), {}, {
      opacity: d ? null : 0
    }),
    onKeyDown: function(V) {
      g(V), A && A(V);
    },
    onMouseDown: function(V) {
      m(V), $ && $(V);
    },
    onChange: function(V) {
      v(V), O && O(V);
    },
    onCompositionStart: function(V) {
      S(V), N && N(V);
    },
    onCompositionEnd: function(V) {
      _(V), z && z(V);
    },
    onPaste: y
  })), x;
}, N6 = /* @__PURE__ */ I.forwardRef(y6e);
process.env.NODE_ENV !== "production" && (N6.displayName = "Input");
function D6(e) {
  return Array.isArray(e) ? e : e !== void 0 ? [e] : [];
}
var b6e = typeof window < "u" && window.document && window.document.documentElement, _6e = process.env.NODE_ENV !== "test" && b6e;
function S6e(e) {
  return e != null;
}
function w6e(e) {
  return !e && e !== 0;
}
function DL(e) {
  return ["string", "number"].includes(_t(e));
}
function VQ(e) {
  var t = void 0;
  return e && (DL(e.title) ? t = e.title.toString() : DL(e.label) && (t = e.label.toString())), t;
}
function x6e(e, t) {
  _6e ? I.useLayoutEffect(e, t) : I.useEffect(e, t);
}
function E6e(e) {
  var t;
  return (t = e.key) !== null && t !== void 0 ? t : e.value;
}
var LL = function(t) {
  t.preventDefault(), t.stopPropagation();
}, C6e = function(t) {
  var n = t.id, r = t.prefixCls, i = t.values, o = t.open, a = t.searchValue, s = t.autoClearSearchValue, c = t.inputRef, l = t.placeholder, u = t.disabled, d = t.mode, f = t.showSearch, h = t.autoFocus, p = t.autoComplete, g = t.activeDescendantId, m = t.tabIndex, v = t.removeIcon, y = t.maxTagCount, S = t.maxTagTextLength, _ = t.maxTagPlaceholder, w = _ === void 0 ? function(oe) {
    return "+ ".concat(oe.length, " ...");
  } : _, T = t.tagRender, x = t.onToggleOpen, C = t.onRemove, E = t.onInputChange, R = t.onInputPaste, A = t.onInputKeyDown, O = t.onInputMouseDown, $ = t.onInputCompositionStart, N = t.onInputCompositionEnd, z = I.useRef(null), k = Lt(0), F = fe(k, 2), V = F[0], j = F[1], B = Lt(!1), U = fe(B, 2), Q = U[0], K = U[1], q = "".concat(r, "-selection"), X = o || d === "multiple" && s === !1 || d === "tags" ? a : "", ie = d === "tags" || d === "multiple" && s === !1 || f && (o || Q);
  x6e(function() {
    j(z.current.scrollWidth);
  }, [X]);
  var te = function(W, se, ce, ge, he) {
    return /* @__PURE__ */ I.createElement("span", {
      title: VQ(W),
      className: we("".concat(q, "-item"), re({}, "".concat(q, "-item-disabled"), ce))
    }, /* @__PURE__ */ I.createElement("span", {
      className: "".concat(q, "-item-content")
    }, se), ge && /* @__PURE__ */ I.createElement(sE, {
      className: "".concat(q, "-item-remove"),
      onMouseDown: LL,
      onClick: he,
      customizeIcon: v
    }, "×"));
  }, J = function(W, se, ce, ge, he, ue) {
    var Ee = function(Oe) {
      LL(Oe), x(!o);
    };
    return /* @__PURE__ */ I.createElement("span", {
      onMouseDown: Ee
    }, T({
      label: se,
      value: W,
      disabled: ce,
      closable: ge,
      onClose: he,
      isMaxTag: !!ue
    }));
  }, Y = function(W) {
    var se = W.disabled, ce = W.label, ge = W.value, he = !u && !se, ue = ce;
    if (typeof S == "number" && (typeof ce == "string" || typeof ce == "number")) {
      var Ee = String(ue);
      Ee.length > S && (ue = "".concat(Ee.slice(0, S), "..."));
    }
    var pe = function(de) {
      de && de.stopPropagation(), C(W);
    };
    return typeof T == "function" ? J(ge, ue, se, he, pe) : te(W, ue, se, he, pe);
  }, ee = function(W) {
    var se = typeof w == "function" ? w(W) : w;
    return typeof T == "function" ? J(void 0, se, !1, !1, void 0, !0) : te({
      title: se
    }, se, !1);
  }, Z = /* @__PURE__ */ I.createElement("div", {
    className: "".concat(q, "-search"),
    style: {
      width: V
    },
    onFocus: function() {
      K(!0);
    },
    onBlur: function() {
      K(!1);
    }
  }, /* @__PURE__ */ I.createElement(N6, {
    ref: c,
    open: o,
    prefixCls: r,
    id: n,
    inputElement: null,
    disabled: u,
    autoFocus: h,
    autoComplete: p,
    editable: ie,
    activeDescendantId: g,
    value: X,
    onKeyDown: A,
    onMouseDown: O,
    onChange: E,
    onPaste: R,
    onCompositionStart: $,
    onCompositionEnd: N,
    tabIndex: m,
    attrs: cf(t, !0)
  }), /* @__PURE__ */ I.createElement("span", {
    ref: z,
    className: "".concat(q, "-search-mirror"),
    "aria-hidden": !0
  }, X, " ")), H = /* @__PURE__ */ I.createElement(uy, {
    prefixCls: "".concat(q, "-overflow"),
    data: i,
    renderItem: Y,
    renderRest: ee,
    suffix: Z,
    itemKey: E6e,
    maxCount: y
  });
  return /* @__PURE__ */ I.createElement("span", {
    className: "".concat(q, "-wrap")
  }, H, !i.length && !X && /* @__PURE__ */ I.createElement("span", {
    className: "".concat(q, "-placeholder")
  }, l));
}, T6e = function(t) {
  var n = t.inputElement, r = t.prefixCls, i = t.id, o = t.inputRef, a = t.disabled, s = t.autoFocus, c = t.autoComplete, l = t.activeDescendantId, u = t.mode, d = t.open, f = t.values, h = t.placeholder, p = t.tabIndex, g = t.showSearch, m = t.searchValue, v = t.activeValue, y = t.maxLength, S = t.onInputKeyDown, _ = t.onInputMouseDown, w = t.onInputChange, T = t.onInputPaste, x = t.onInputCompositionStart, C = t.onInputCompositionEnd, E = t.title, R = I.useState(!1), A = fe(R, 2), O = A[0], $ = A[1], N = u === "combobox", z = N || g, k = f[0], F = m || "";
  N && v && !O && (F = v), I.useEffect(function() {
    N && $(!1);
  }, [N, v]);
  var V = u !== "combobox" && !d && !g ? !1 : !!F, j = E === void 0 ? VQ(k) : E, B = I.useMemo(function() {
    return k ? null : /* @__PURE__ */ I.createElement("span", {
      className: "".concat(r, "-selection-placeholder"),
      style: V ? {
        visibility: "hidden"
      } : void 0
    }, h);
  }, [k, V, h, r]);
  return /* @__PURE__ */ I.createElement("span", {
    className: "".concat(r, "-selection-wrap")
  }, /* @__PURE__ */ I.createElement("span", {
    className: "".concat(r, "-selection-search")
  }, /* @__PURE__ */ I.createElement(N6, {
    ref: o,
    prefixCls: r,
    id: i,
    open: d,
    inputElement: n,
    disabled: a,
    autoFocus: s,
    autoComplete: c,
    editable: z,
    activeDescendantId: l,
    value: F,
    onKeyDown: S,
    onMouseDown: _,
    onChange: function(Q) {
      $(!0), w(Q);
    },
    onPaste: T,
    onCompositionStart: x,
    onCompositionEnd: C,
    tabIndex: p,
    attrs: cf(t, !0),
    maxLength: N ? y : void 0
  })), !N && k ? /* @__PURE__ */ I.createElement("span", {
    className: "".concat(r, "-selection-item"),
    title: j,
    style: V ? {
      visibility: "hidden"
    } : void 0
  }, k.label) : null, B);
}, I6e = function(t, n) {
  var r = Me(null), i = Me(!1), o = t.prefixCls, a = t.open, s = t.mode, c = t.showSearch, l = t.tokenWithEnter, u = t.disabled, d = t.prefix, f = t.autoClearSearchValue, h = t.onSearch, p = t.onSearchSubmit, g = t.onToggleOpen, m = t.onInputKeyDown, v = t.domRef;
  I.useImperativeHandle(n, function() {
    return {
      focus: function(j) {
        r.current.focus(j);
      },
      blur: function() {
        r.current.blur();
      }
    };
  });
  var y = DQ(0), S = fe(y, 2), _ = S[0], w = S[1], T = function(j) {
    var B = j.which, U = r.current instanceof HTMLTextAreaElement;
    !U && a && (B === Ae.UP || B === Ae.DOWN) && j.preventDefault(), m && m(j), B === Ae.ENTER && s === "tags" && !i.current && !a && (p == null || p(j.target.value)), !(U && !a && ~[Ae.UP, Ae.DOWN, Ae.LEFT, Ae.RIGHT].indexOf(B)) && a6e(B) && g(!0);
  }, x = function() {
    w(!0);
  }, C = Me(null), E = function(j) {
    h(j, !0, i.current) !== !1 && g(!0);
  }, R = function() {
    i.current = !0;
  }, A = function(j) {
    i.current = !1, s !== "combobox" && E(j.target.value);
  }, O = function(j) {
    var B = j.target.value;
    if (l && C.current && /[\r\n]/.test(C.current)) {
      var U = C.current.replace(/[\r\n]+$/, "").replace(/\r\n/g, " ").replace(/[\r\n]/g, " ");
      B = B.replace(U, C.current);
    }
    C.current = null, E(B);
  }, $ = function(j) {
    var B = j.clipboardData, U = B == null ? void 0 : B.getData("text");
    C.current = U || "";
  }, N = function(j) {
    var B = j.target;
    if (B !== r.current) {
      var U = document.body.style.msTouchAction !== void 0;
      U ? setTimeout(function() {
        r.current.focus();
      }) : r.current.focus();
    }
  }, z = function(j) {
    var B = _();
    j.target !== r.current && !B && !(s === "combobox" && u) && j.preventDefault(), (s !== "combobox" && (!c || !B) || !a) && (a && f !== !1 && h("", !0, !1), g());
  }, k = {
    inputRef: r,
    onInputKeyDown: T,
    onInputMouseDown: x,
    onInputChange: O,
    onInputPaste: $,
    onInputCompositionStart: R,
    onInputCompositionEnd: A
  }, F = s === "multiple" || s === "tags" ? /* @__PURE__ */ I.createElement(C6e, mt({}, t, k)) : /* @__PURE__ */ I.createElement(T6e, mt({}, t, k));
  return /* @__PURE__ */ I.createElement("div", {
    ref: v,
    className: "".concat(o, "-selector"),
    onClick: N,
    onMouseDown: z
  }, d && /* @__PURE__ */ I.createElement("div", {
    className: "".concat(o, "-prefix")
  }, d), F);
}, BQ = /* @__PURE__ */ I.forwardRef(I6e);
process.env.NODE_ENV !== "production" && (BQ.displayName = "Selector");
function A6e(e) {
  var t = e.prefixCls, n = e.align, r = e.arrow, i = e.arrowPos, o = r || {}, a = o.className, s = o.content, c = i.x, l = c === void 0 ? 0 : c, u = i.y, d = u === void 0 ? 0 : u, f = I.useRef();
  if (!n || !n.points)
    return null;
  var h = {
    position: "absolute"
  };
  if (n.autoArrow !== !1) {
    var p = n.points[0], g = n.points[1], m = p[0], v = p[1], y = g[0], S = g[1];
    m === y || !["t", "b"].includes(m) ? h.top = d : m === "t" ? h.top = 0 : h.bottom = 0, v === S || !["l", "r"].includes(v) ? h.left = l : v === "l" ? h.left = 0 : h.right = 0;
  }
  return /* @__PURE__ */ I.createElement("div", {
    ref: f,
    className: we("".concat(t, "-arrow"), a),
    style: h
  }, s);
}
function R6e(e) {
  var t = e.prefixCls, n = e.open, r = e.zIndex, i = e.mask, o = e.motion;
  return i ? /* @__PURE__ */ I.createElement(Tf, mt({}, o, {
    motionAppear: !0,
    visible: n,
    removeOnLeave: !0
  }), function(a) {
    var s = a.className;
    return /* @__PURE__ */ I.createElement("div", {
      style: {
        zIndex: r
      },
      className: we("".concat(t, "-mask"), s)
    });
  }) : null;
}
var zQ = /* @__PURE__ */ I.memo(function(e) {
  var t = e.children;
  return t;
}, function(e, t) {
  return t.cache;
});
process.env.NODE_ENV !== "production" && (zQ.displayName = "PopupContent");
var HQ = /* @__PURE__ */ I.forwardRef(function(e, t) {
  var n = e.popup, r = e.className, i = e.prefixCls, o = e.style, a = e.target, s = e.onVisibleChanged, c = e.open, l = e.keepDom, u = e.fresh, d = e.onClick, f = e.mask, h = e.arrow, p = e.arrowPos, g = e.align, m = e.motion, v = e.maskMotion, y = e.forceRender, S = e.getPopupContainer, _ = e.autoDestroy, w = e.portal, T = e.zIndex, x = e.onMouseEnter, C = e.onMouseLeave, E = e.onPointerEnter, R = e.onPointerDownCapture, A = e.ready, O = e.offsetX, $ = e.offsetY, N = e.offsetR, z = e.offsetB, k = e.onAlign, F = e.onPrepare, V = e.stretch, j = e.targetWidth, B = e.targetHeight, U = typeof n == "function" ? n() : n, Q = c || l, K = (S == null ? void 0 : S.length) > 0, q = I.useState(!S || !K), X = fe(q, 2), ie = X[0], te = X[1];
  if (nr(function() {
    !ie && K && a && te(!0);
  }, [ie, K, a]), !ie)
    return null;
  var J = "auto", Y = {
    left: "-1000vw",
    top: "-1000vh",
    right: J,
    bottom: J
  };
  if (A || !c) {
    var ee, Z = g.points, H = g.dynamicInset || ((ee = g._experimental) === null || ee === void 0 ? void 0 : ee.dynamicInset), oe = H && Z[0][1] === "r", W = H && Z[0][0] === "b";
    oe ? (Y.right = N, Y.left = J) : (Y.left = O, Y.right = J), W ? (Y.bottom = z, Y.top = J) : (Y.top = $, Y.bottom = J);
  }
  var se = {};
  return V && (V.includes("height") && B ? se.height = B : V.includes("minHeight") && B && (se.minHeight = B), V.includes("width") && j ? se.width = j : V.includes("minWidth") && j && (se.minWidth = j)), c || (se.pointerEvents = "none"), /* @__PURE__ */ I.createElement(w, {
    open: y || Q,
    getContainer: S && function() {
      return S(a);
    },
    autoDestroy: _
  }, /* @__PURE__ */ I.createElement(R6e, {
    prefixCls: i,
    open: c,
    zIndex: T,
    mask: f,
    motion: v
  }), /* @__PURE__ */ I.createElement(ml, {
    onResize: k,
    disabled: !c
  }, function(ce) {
    return /* @__PURE__ */ I.createElement(Tf, mt({
      motionAppear: !0,
      motionEnter: !0,
      motionLeave: !0,
      removeOnLeave: !1,
      forceRender: y,
      leavedClassName: "".concat(i, "-hidden")
    }, m, {
      onAppearPrepare: F,
      onEnterPrepare: F,
      visible: c,
      onVisibleChanged: function(he) {
        var ue;
        m == null || (ue = m.onVisibleChanged) === null || ue === void 0 || ue.call(m, he), s(he);
      }
    }), function(ge, he) {
      var ue = ge.className, Ee = ge.style, pe = we(i, ue, r);
      return /* @__PURE__ */ I.createElement("div", {
        ref: Wa(ce, t, he),
        className: pe,
        style: ae(ae(ae(ae({
          "--arrow-x": "".concat(p.x || 0, "px"),
          "--arrow-y": "".concat(p.y || 0, "px")
        }, Y), se), Ee), {}, {
          boxSizing: "border-box",
          zIndex: T
        }, o),
        onMouseEnter: x,
        onMouseLeave: C,
        onPointerEnter: E,
        onClick: d,
        onPointerDownCapture: R
      }, h && /* @__PURE__ */ I.createElement(A6e, {
        prefixCls: i,
        arrow: h,
        arrowPos: p,
        align: g
      }), /* @__PURE__ */ I.createElement(zQ, {
        cache: !c && !u
      }, U));
    });
  }));
});
process.env.NODE_ENV !== "production" && (HQ.displayName = "Popup");
var UQ = /* @__PURE__ */ I.forwardRef(function(e, t) {
  var n = e.children, r = e.getTriggerDOMNode, i = ay(n), o = I.useCallback(function(s) {
    t6(t, r ? r(s) : s);
  }, [r]), a = Vx(o, n.ref);
  return i ? /* @__PURE__ */ I.cloneElement(n, {
    ref: a
  }) : n;
});
process.env.NODE_ENV !== "production" && (UQ.displayName = "TriggerWrapper");
var jL = /* @__PURE__ */ I.createContext(null);
function FL(e) {
  return e ? Array.isArray(e) ? e : [e] : [];
}
function $6e(e, t, n, r) {
  return I.useMemo(function() {
    var i = FL(n ?? t), o = FL(r ?? t), a = new Set(i), s = new Set(o);
    return e && (a.has("hover") && (a.delete("hover"), a.add("click")), s.has("hover") && (s.delete("hover"), s.add("click"))), [a, s];
  }, [e, t, n, r]);
}
function O6e() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [], n = arguments.length > 2 ? arguments[2] : void 0;
  return n ? e[0] === t[0] : e[0] === t[0] && e[1] === t[1];
}
function P6e(e, t, n, r) {
  for (var i = n.points, o = Object.keys(e), a = 0; a < o.length; a += 1) {
    var s, c = o[a];
    if (O6e((s = e[c]) === null || s === void 0 ? void 0 : s.points, i, r))
      return "".concat(t, "-placement-").concat(c);
  }
  return "";
}
function VL(e, t, n, r) {
  return t || (n ? {
    motionName: "".concat(e, "-").concat(n)
  } : r ? {
    motionName: r
  } : null);
}
function dy(e) {
  return e.ownerDocument.defaultView;
}
function pR(e) {
  for (var t = [], n = e == null ? void 0 : e.parentElement, r = ["hidden", "scroll", "clip", "auto"]; n; ) {
    var i = dy(n).getComputedStyle(n), o = i.overflowX, a = i.overflowY, s = i.overflow;
    [o, a, s].some(function(c) {
      return r.includes(c);
    }) && t.push(n), n = n.parentElement;
  }
  return t;
}
function lv(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1;
  return Number.isNaN(e) ? t : e;
}
function hm(e) {
  return lv(parseFloat(e), 0);
}
function BL(e, t) {
  var n = ae({}, e);
  return (t || []).forEach(function(r) {
    if (!(r instanceof HTMLBodyElement || r instanceof HTMLHtmlElement)) {
      var i = dy(r).getComputedStyle(r), o = i.overflow, a = i.overflowClipMargin, s = i.borderTopWidth, c = i.borderBottomWidth, l = i.borderLeftWidth, u = i.borderRightWidth, d = r.getBoundingClientRect(), f = r.offsetHeight, h = r.clientHeight, p = r.offsetWidth, g = r.clientWidth, m = hm(s), v = hm(c), y = hm(l), S = hm(u), _ = lv(Math.round(d.width / p * 1e3) / 1e3), w = lv(Math.round(d.height / f * 1e3) / 1e3), T = (p - g - y - S) * _, x = (f - h - m - v) * w, C = m * w, E = v * w, R = y * _, A = S * _, O = 0, $ = 0;
      if (o === "clip") {
        var N = hm(a);
        O = N * _, $ = N * w;
      }
      var z = d.x + R - O, k = d.y + C - $, F = z + d.width + 2 * O - R - A - T, V = k + d.height + 2 * $ - C - E - x;
      n.left = Math.max(n.left, z), n.top = Math.max(n.top, k), n.right = Math.min(n.right, F), n.bottom = Math.min(n.bottom, V);
    }
  }), n;
}
function zL(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, n = "".concat(t), r = n.match(/^(.*)\%$/);
  return r ? e * (parseFloat(r[1]) / 100) : parseFloat(n);
}
function HL(e, t) {
  var n = t || [], r = fe(n, 2), i = r[0], o = r[1];
  return [zL(e.width, i), zL(e.height, o)];
}
function UL() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
  return [e[0], e[1]];
}
function ah(e, t) {
  var n = t[0], r = t[1], i, o;
  return n === "t" ? o = e.y : n === "b" ? o = e.y + e.height : o = e.y + e.height / 2, r === "l" ? i = e.x : r === "r" ? i = e.x + e.width : i = e.x + e.width / 2, {
    x: i,
    y: o
  };
}
function Tl(e, t) {
  var n = {
    t: "b",
    b: "t",
    l: "r",
    r: "l"
  };
  return e.map(function(r, i) {
    return i === t ? n[r] || "c" : r;
  }).join("");
}
function M6e(e, t, n, r, i, o, a) {
  var s = I.useState({
    ready: !1,
    offsetX: 0,
    offsetY: 0,
    offsetR: 0,
    offsetB: 0,
    arrowX: 0,
    arrowY: 0,
    scaleX: 1,
    scaleY: 1,
    align: i[r] || {}
  }), c = fe(s, 2), l = c[0], u = c[1], d = I.useRef(0), f = I.useMemo(function() {
    return t ? pR(t) : [];
  }, [t]), h = I.useRef({}), p = function() {
    h.current = {};
  };
  e || p();
  var g = Rr(function() {
    if (t && n && e) {
      let Lo = function(wl, jo) {
        var ki = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : be, xl = q.x + wl, ed = q.y + jo, Yf = xl + oe, Ps = ed + H, Zp = Math.max(xl, ki.left), pt = Math.max(ed, ki.top), Bt = Math.min(Yf, ki.right), On = Math.min(Ps, ki.bottom);
        return Math.max(0, (Bt - Zp) * (On - pt));
      }, Kf = function() {
        xt = q.y + Ne, bt = xt + H, st = q.x + et, Rt = st + oe;
      };
      var y, S, _, w, T = t, x = T.ownerDocument, C = dy(T), E = C.getComputedStyle(T), R = E.width, A = E.height, O = E.position, $ = T.style.left, N = T.style.top, z = T.style.right, k = T.style.bottom, F = T.style.overflow, V = ae(ae({}, i[r]), o), j = x.createElement("div");
      (y = T.parentElement) === null || y === void 0 || y.appendChild(j), j.style.left = "".concat(T.offsetLeft, "px"), j.style.top = "".concat(T.offsetTop, "px"), j.style.position = O, j.style.height = "".concat(T.offsetHeight, "px"), j.style.width = "".concat(T.offsetWidth, "px"), T.style.left = "0", T.style.top = "0", T.style.right = "auto", T.style.bottom = "auto", T.style.overflow = "hidden";
      var B;
      if (Array.isArray(n))
        B = {
          x: n[0],
          y: n[1],
          width: 0,
          height: 0
        };
      else {
        var U, Q, K = n.getBoundingClientRect();
        K.x = (U = K.x) !== null && U !== void 0 ? U : K.left, K.y = (Q = K.y) !== null && Q !== void 0 ? Q : K.top, B = {
          x: K.x,
          y: K.y,
          width: K.width,
          height: K.height
        };
      }
      var q = T.getBoundingClientRect();
      q.x = (S = q.x) !== null && S !== void 0 ? S : q.left, q.y = (_ = q.y) !== null && _ !== void 0 ? _ : q.top;
      var X = x.documentElement, ie = X.clientWidth, te = X.clientHeight, J = X.scrollWidth, Y = X.scrollHeight, ee = X.scrollTop, Z = X.scrollLeft, H = q.height, oe = q.width, W = B.height, se = B.width, ce = {
        left: 0,
        top: 0,
        right: ie,
        bottom: te
      }, ge = {
        left: -Z,
        top: -ee,
        right: J - Z,
        bottom: Y - ee
      }, he = V.htmlRegion, ue = "visible", Ee = "visibleFirst";
      he !== "scroll" && he !== Ee && (he = ue);
      var pe = he === Ee, Oe = BL(ge, f), de = BL(ce, f), be = he === ue ? de : Oe, Ie = pe ? de : be;
      T.style.left = "auto", T.style.top = "auto", T.style.right = "0", T.style.bottom = "0";
      var Ve = T.getBoundingClientRect();
      T.style.left = $, T.style.top = N, T.style.right = z, T.style.bottom = k, T.style.overflow = F, (w = T.parentElement) === null || w === void 0 || w.removeChild(j);
      var Fe = lv(Math.round(oe / parseFloat(R) * 1e3) / 1e3), Pe = lv(Math.round(H / parseFloat(A) * 1e3) / 1e3);
      if (Fe === 0 || Pe === 0 || Q0(n) && !aQ(n))
        return;
      var ot = V.offset, dt = V.targetOffset, ft = HL(q, ot), wt = fe(ft, 2), Ge = wt[0], at = wt[1], Nt = HL(B, dt), zt = fe(Nt, 2), kt = zt[0], Ct = zt[1];
      B.x -= kt, B.y -= Ct;
      var yt = V.points || [], Mn = fe(yt, 2), Pt = Mn[0], Ze = Mn[1], Le = UL(Ze), rt = UL(Pt), ut = ah(B, Le), vt = ah(q, rt), We = ae({}, V), et = ut.x - vt.x + Ge, Ne = ut.y - vt.y + at, Yt = Lo(et, Ne), Ht = Lo(et, Ne, de), Be = ah(B, ["t", "l"]), ze = ah(q, ["t", "l"]), it = ah(B, ["b", "r"]), lt = ah(q, ["b", "r"]), Tt = V.overflow || {}, jt = Tt.adjustX, ne = Tt.adjustY, _e = Tt.shiftX, $e = Tt.shiftY, qe = function(jo) {
        return typeof jo == "boolean" ? jo : jo >= 0;
      }, xt, bt, st, Rt;
      Kf();
      var Ke = qe(ne), ke = rt[0] === Le[0];
      if (Ke && rt[0] === "t" && (bt > Ie.bottom || h.current.bt)) {
        var Xe = Ne;
        ke ? Xe -= H - W : Xe = Be.y - lt.y - at;
        var ct = Lo(et, Xe), Ue = Lo(et, Xe, de);
        // Of course use larger one
        ct > Yt || ct === Yt && (!pe || // Choose recommend one
        Ue >= Ht) ? (h.current.bt = !0, Ne = Xe, at = -at, We.points = [Tl(rt, 0), Tl(Le, 0)]) : h.current.bt = !1;
      }
      if (Ke && rt[0] === "b" && (xt < Ie.top || h.current.tb)) {
        var Dt = Ne;
        ke ? Dt += H - W : Dt = it.y - ze.y - at;
        var It = Lo(et, Dt), wn = Lo(et, Dt, de);
        // Of course use larger one
        It > Yt || It === Yt && (!pe || // Choose recommend one
        wn >= Ht) ? (h.current.tb = !0, Ne = Dt, at = -at, We.points = [Tl(rt, 0), Tl(Le, 0)]) : h.current.tb = !1;
      }
      var gr = qe(jt), Gn = rt[1] === Le[1];
      if (gr && rt[1] === "l" && (Rt > Ie.right || h.current.rl)) {
        var Cn = et;
        Gn ? Cn -= oe - se : Cn = Be.x - lt.x - Ge;
        var Fr = Lo(Cn, Ne), Kr = Lo(Cn, Ne, de);
        // Of course use larger one
        Fr > Yt || Fr === Yt && (!pe || // Choose recommend one
        Kr >= Ht) ? (h.current.rl = !0, et = Cn, Ge = -Ge, We.points = [Tl(rt, 1), Tl(Le, 1)]) : h.current.rl = !1;
      }
      if (gr && rt[1] === "r" && (st < Ie.left || h.current.lr)) {
        var pr = et;
        Gn ? pr += oe - se : pr = it.x - ze.x - Ge;
        var xr = Lo(pr, Ne), Yr = Lo(pr, Ne, de);
        // Of course use larger one
        xr > Yt || xr === Yt && (!pe || // Choose recommend one
        Yr >= Ht) ? (h.current.lr = !0, et = pr, Ge = -Ge, We.points = [Tl(rt, 1), Tl(Le, 1)]) : h.current.lr = !1;
      }
      Kf();
      var Er = _e === !0 ? 0 : _e;
      typeof Er == "number" && (st < de.left && (et -= st - de.left - Ge, B.x + se < de.left + Er && (et += B.x - de.left + se - Er)), Rt > de.right && (et -= Rt - de.right - Ge, B.x > de.right - Er && (et += B.x - de.right + Er)));
      var Xr = $e === !0 ? 0 : $e;
      typeof Xr == "number" && (xt < de.top && (Ne -= xt - de.top - at, B.y + W < de.top + Xr && (Ne += B.y - de.top + W - Xr)), bt > de.bottom && (Ne -= bt - de.bottom - at, B.y > de.bottom - Xr && (Ne += B.y - de.bottom + Xr)));
      var Ci = q.x + et, Ti = Ci + oe, Mi = q.y + Ne, Qn = Mi + H, Xt = B.x, Vt = Xt + se, tn = B.y, Qt = tn + W, Jt = Math.max(Ci, Xt), vn = Math.min(Ti, Vt), Cr = (Jt + vn) / 2, pi = Cr - Ci, ln = Math.max(Mi, tn), ni = Math.min(Qn, Qt), ri = (ln + ni) / 2, Ki = ri - Mi;
      a == null || a(t, We);
      var Do = Ve.right - q.x - (et + q.width), po = Ve.bottom - q.y - (Ne + q.height);
      Fe === 1 && (et = Math.round(et), Do = Math.round(Do)), Pe === 1 && (Ne = Math.round(Ne), po = Math.round(po));
      var mo = {
        ready: !0,
        offsetX: et / Fe,
        offsetY: Ne / Pe,
        offsetR: Do / Fe,
        offsetB: po / Pe,
        arrowX: pi / Fe,
        arrowY: Ki / Pe,
        scaleX: Fe,
        scaleY: Pe,
        align: We
      };
      u(mo);
    }
  }), m = function() {
    d.current += 1;
    var S = d.current;
    Promise.resolve().then(function() {
      d.current === S && g();
    });
  }, v = function() {
    u(function(S) {
      return ae(ae({}, S), {}, {
        ready: !1
      });
    });
  };
  return nr(v, [r]), nr(function() {
    e || v();
  }, [e]), [l.ready, l.offsetX, l.offsetY, l.offsetR, l.offsetB, l.arrowX, l.arrowY, l.scaleX, l.scaleY, l.align, m];
}
function k6e(e, t, n, r, i) {
  nr(function() {
    if (e && t && n) {
      let d = function() {
        r(), i();
      };
      var o = t, a = n, s = pR(o), c = pR(a), l = dy(a), u = new Set([l].concat(Je(s), Je(c)));
      return u.forEach(function(f) {
        f.addEventListener("scroll", d, {
          passive: !0
        });
      }), l.addEventListener("resize", d, {
        passive: !0
      }), r(), function() {
        u.forEach(function(f) {
          f.removeEventListener("scroll", d), l.removeEventListener("resize", d);
        });
      };
    }
  }, [e, t, n]);
}
function N6e(e, t, n, r, i, o, a, s) {
  var c = I.useRef(e);
  c.current = e;
  var l = I.useRef(!1);
  I.useEffect(function() {
    if (t && r && (!i || o)) {
      var d = function() {
        l.current = !1;
      }, f = function(_) {
        var w;
        c.current && !a(((w = _.composedPath) === null || w === void 0 || (w = w.call(_)) === null || w === void 0 ? void 0 : w[0]) || _.target) && !l.current && s(!1);
      }, h = dy(r);
      h.addEventListener("pointerdown", d, !0), h.addEventListener("mousedown", f, !0), h.addEventListener("contextmenu", f, !0);
      var p = kS(n);
      if (p && (p.addEventListener("mousedown", f, !0), p.addEventListener("contextmenu", f, !0)), process.env.NODE_ENV !== "production") {
        var g, m, v = n == null || (g = n.getRootNode) === null || g === void 0 ? void 0 : g.call(n), y = (m = r.getRootNode) === null || m === void 0 ? void 0 : m.call(r);
        Cu(v === y, "trigger element and popup element should in same shadow root.");
      }
      return function() {
        h.removeEventListener("pointerdown", d, !0), h.removeEventListener("mousedown", f, !0), h.removeEventListener("contextmenu", f, !0), p && (p.removeEventListener("mousedown", f, !0), p.removeEventListener("contextmenu", f, !0));
      };
    }
  }, [t, n, r, i, o]);
  function u() {
    l.current = !0;
  }
  return u;
}
var D6e = ["prefixCls", "children", "action", "showAction", "hideAction", "popupVisible", "defaultPopupVisible", "onPopupVisibleChange", "afterPopupVisibleChange", "mouseEnterDelay", "mouseLeaveDelay", "focusDelay", "blurDelay", "mask", "maskClosable", "getPopupContainer", "forceRender", "autoDestroy", "destroyPopupOnHide", "popup", "popupClassName", "popupStyle", "popupPlacement", "builtinPlacements", "popupAlign", "zIndex", "stretch", "getPopupClassNameFromAlign", "fresh", "alignPoint", "onPopupClick", "onPopupAlign", "arrow", "popupMotion", "maskMotion", "popupTransitionName", "popupAnimation", "maskTransitionName", "maskAnimation", "className", "getTriggerDOMNode"];
function L6e() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : $6, t = /* @__PURE__ */ I.forwardRef(function(n, r) {
    var i = n.prefixCls, o = i === void 0 ? "rc-trigger-popup" : i, a = n.children, s = n.action, c = s === void 0 ? "hover" : s, l = n.showAction, u = n.hideAction, d = n.popupVisible, f = n.defaultPopupVisible, h = n.onPopupVisibleChange, p = n.afterPopupVisibleChange, g = n.mouseEnterDelay, m = n.mouseLeaveDelay, v = m === void 0 ? 0.1 : m, y = n.focusDelay, S = n.blurDelay, _ = n.mask, w = n.maskClosable, T = w === void 0 ? !0 : w, x = n.getPopupContainer, C = n.forceRender, E = n.autoDestroy, R = n.destroyPopupOnHide, A = n.popup, O = n.popupClassName, $ = n.popupStyle, N = n.popupPlacement, z = n.builtinPlacements, k = z === void 0 ? {} : z, F = n.popupAlign, V = n.zIndex, j = n.stretch, B = n.getPopupClassNameFromAlign, U = n.fresh, Q = n.alignPoint, K = n.onPopupClick, q = n.onPopupAlign, X = n.arrow, ie = n.popupMotion, te = n.maskMotion, J = n.popupTransitionName, Y = n.popupAnimation, ee = n.maskTransitionName, Z = n.maskAnimation, H = n.className, oe = n.getTriggerDOMNode, W = xn(n, D6e), se = E || R || !1, ce = I.useState(!1), ge = fe(ce, 2), he = ge[0], ue = ge[1];
    nr(function() {
      ue(k6());
    }, []);
    var Ee = I.useRef({}), pe = I.useContext(jL), Oe = I.useMemo(function() {
      return {
        registerSubPopup: function(Bt, On) {
          Ee.current[Bt] = On, pe == null || pe.registerSubPopup(Bt, On);
        }
      };
    }, [pe]), de = AOe(), be = I.useState(null), Ie = fe(be, 2), Ve = Ie[0], Fe = Ie[1], Pe = I.useRef(null), ot = Rr(function(pt) {
      Pe.current = pt, Q0(pt) && Ve !== pt && Fe(pt), pe == null || pe.registerSubPopup(de, pt);
    }), dt = I.useState(null), ft = fe(dt, 2), wt = ft[0], Ge = ft[1], at = I.useRef(null), Nt = Rr(function(pt) {
      Q0(pt) && wt !== pt && (Ge(pt), at.current = pt);
    }), zt = I.Children.only(a), kt = (zt == null ? void 0 : zt.props) || {}, Ct = {}, yt = Rr(function(pt) {
      var Bt, On, Qr = wt;
      return (Qr == null ? void 0 : Qr.contains(pt)) || ((Bt = kS(Qr)) === null || Bt === void 0 ? void 0 : Bt.host) === pt || pt === Qr || (Ve == null ? void 0 : Ve.contains(pt)) || ((On = kS(Ve)) === null || On === void 0 ? void 0 : On.host) === pt || pt === Ve || Object.values(Ee.current).some(function(Tr) {
        return (Tr == null ? void 0 : Tr.contains(pt)) || pt === Tr;
      });
    }), Mn = VL(o, ie, Y, J), Pt = VL(o, te, Z, ee), Ze = I.useState(f || !1), Le = fe(Ze, 2), rt = Le[0], ut = Le[1], vt = d ?? rt, We = Rr(function(pt) {
      d === void 0 && ut(pt);
    });
    nr(function() {
      ut(d || !1);
    }, [d]);
    var et = I.useRef(vt);
    et.current = vt;
    var Ne = I.useRef([]);
    Ne.current = [];
    var Yt = Rr(function(pt) {
      var Bt;
      We(pt), ((Bt = Ne.current[Ne.current.length - 1]) !== null && Bt !== void 0 ? Bt : vt) !== pt && (Ne.current.push(pt), h == null || h(pt));
    }), Ht = I.useRef(), Be = function() {
      clearTimeout(Ht.current);
    }, ze = function(Bt) {
      var On = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
      Be(), On === 0 ? Yt(Bt) : Ht.current = setTimeout(function() {
        Yt(Bt);
      }, On * 1e3);
    };
    I.useEffect(function() {
      return Be;
    }, []);
    var it = I.useState(!1), lt = fe(it, 2), Tt = lt[0], jt = lt[1];
    nr(function(pt) {
      (!pt || vt) && jt(!0);
    }, [vt]);
    var ne = I.useState(null), _e = fe(ne, 2), $e = _e[0], qe = _e[1], xt = I.useState(null), bt = fe(xt, 2), st = bt[0], Rt = bt[1], Ke = function(Bt) {
      Rt([Bt.clientX, Bt.clientY]);
    }, ke = M6e(vt, Ve, Q && st !== null ? st : wt, N, k, F, q), Xe = fe(ke, 11), ct = Xe[0], Ue = Xe[1], Dt = Xe[2], It = Xe[3], wn = Xe[4], gr = Xe[5], Gn = Xe[6], Cn = Xe[7], Fr = Xe[8], Kr = Xe[9], pr = Xe[10], xr = $6e(he, c, l, u), Yr = fe(xr, 2), Er = Yr[0], Xr = Yr[1], Ci = Er.has("click"), Ti = Xr.has("click") || Xr.has("contextMenu"), Mi = Rr(function() {
      Tt || pr();
    }), Qn = function() {
      et.current && Q && Ti && ze(!1);
    };
    k6e(vt, wt, Ve, Mi, Qn), nr(function() {
      Mi();
    }, [st, N]), nr(function() {
      vt && !(k != null && k[N]) && Mi();
    }, [JSON.stringify(F)]);
    var Xt = I.useMemo(function() {
      var pt = P6e(k, o, Kr, Q);
      return we(pt, B == null ? void 0 : B(Kr));
    }, [Kr, B, k, o, Q]);
    I.useImperativeHandle(r, function() {
      return {
        nativeElement: at.current,
        popupElement: Pe.current,
        forceAlign: Mi
      };
    });
    var Vt = I.useState(0), tn = fe(Vt, 2), Qt = tn[0], Jt = tn[1], vn = I.useState(0), Cr = fe(vn, 2), pi = Cr[0], ln = Cr[1], ni = function() {
      if (j && wt) {
        var Bt = wt.getBoundingClientRect();
        Jt(Bt.width), ln(Bt.height);
      }
    }, ri = function() {
      ni(), Mi();
    }, Ki = function(Bt) {
      jt(!1), pr(), p == null || p(Bt);
    }, Do = function() {
      return new Promise(function(Bt) {
        ni(), qe(function() {
          return Bt;
        });
      });
    };
    nr(function() {
      $e && (pr(), $e(), qe(null));
    }, [$e]);
    function po(pt, Bt, On, Qr) {
      Ct[pt] = function(Tr) {
        var xc;
        Qr == null || Qr(Tr), ze(Bt, On);
        for (var El = arguments.length, em = new Array(El > 1 ? El - 1 : 0), Ms = 1; Ms < El; Ms++)
          em[Ms - 1] = arguments[Ms];
        (xc = kt[pt]) === null || xc === void 0 || xc.call.apply(xc, [kt, Tr].concat(em));
      };
    }
    (Ci || Ti) && (Ct.onClick = function(pt) {
      var Bt;
      et.current && Ti ? ze(!1) : !et.current && Ci && (Ke(pt), ze(!0));
      for (var On = arguments.length, Qr = new Array(On > 1 ? On - 1 : 0), Tr = 1; Tr < On; Tr++)
        Qr[Tr - 1] = arguments[Tr];
      (Bt = kt.onClick) === null || Bt === void 0 || Bt.call.apply(Bt, [kt, pt].concat(Qr));
    });
    var mo = N6e(vt, Ti, wt, Ve, _, T, yt, ze), Lo = Er.has("hover"), Kf = Xr.has("hover"), wl, jo;
    Lo && (po("onMouseEnter", !0, g, function(pt) {
      Ke(pt);
    }), po("onPointerEnter", !0, g, function(pt) {
      Ke(pt);
    }), wl = function(Bt) {
      (vt || Tt) && Ve !== null && Ve !== void 0 && Ve.contains(Bt.target) && ze(!0, g);
    }, Q && (Ct.onMouseMove = function(pt) {
      var Bt;
      (Bt = kt.onMouseMove) === null || Bt === void 0 || Bt.call(kt, pt);
    })), Kf && (po("onMouseLeave", !1, v), po("onPointerLeave", !1, v), jo = function() {
      ze(!1, v);
    }), Er.has("focus") && po("onFocus", !0, y), Xr.has("focus") && po("onBlur", !1, S), Er.has("contextMenu") && (Ct.onContextMenu = function(pt) {
      var Bt;
      et.current && Xr.has("contextMenu") ? ze(!1) : (Ke(pt), ze(!0)), pt.preventDefault();
      for (var On = arguments.length, Qr = new Array(On > 1 ? On - 1 : 0), Tr = 1; Tr < On; Tr++)
        Qr[Tr - 1] = arguments[Tr];
      (Bt = kt.onContextMenu) === null || Bt === void 0 || Bt.call.apply(Bt, [kt, pt].concat(Qr));
    }), H && (Ct.className = we(kt.className, H));
    var ki = ae(ae({}, kt), Ct), xl = {}, ed = ["onContextMenu", "onClick", "onMouseDown", "onTouchStart", "onMouseEnter", "onMouseLeave", "onFocus", "onBlur"];
    ed.forEach(function(pt) {
      W[pt] && (xl[pt] = function() {
        for (var Bt, On = arguments.length, Qr = new Array(On), Tr = 0; Tr < On; Tr++)
          Qr[Tr] = arguments[Tr];
        (Bt = ki[pt]) === null || Bt === void 0 || Bt.call.apply(Bt, [ki].concat(Qr)), W[pt].apply(W, Qr);
      });
    });
    var Yf = /* @__PURE__ */ I.cloneElement(zt, ae(ae({}, ki), xl)), Ps = {
      x: gr,
      y: Gn
    }, Zp = X ? ae({}, X !== !0 ? X : {}) : null;
    return /* @__PURE__ */ I.createElement(I.Fragment, null, /* @__PURE__ */ I.createElement(ml, {
      disabled: !vt,
      ref: Nt,
      onResize: ri
    }, /* @__PURE__ */ I.createElement(UQ, {
      getTriggerDOMNode: oe
    }, Yf)), /* @__PURE__ */ I.createElement(jL.Provider, {
      value: Oe
    }, /* @__PURE__ */ I.createElement(HQ, {
      portal: e,
      ref: ot,
      prefixCls: o,
      popup: A,
      className: we(O, Xt),
      style: $,
      target: wt,
      onMouseEnter: wl,
      onMouseLeave: jo,
      onPointerEnter: wl,
      zIndex: V,
      open: vt,
      keepDom: Tt,
      fresh: U,
      onClick: K,
      onPointerDownCapture: mo,
      mask: _,
      motion: Mn,
      maskMotion: Pt,
      onVisibleChanged: Ki,
      onPrepare: Do,
      forceRender: C,
      autoDestroy: se,
      getPopupContainer: x,
      align: Kr,
      arrow: Zp,
      arrowPos: Ps,
      ready: ct,
      offsetX: Ue,
      offsetY: Dt,
      offsetR: It,
      offsetB: wn,
      onAlign: Mi,
      stretch: j,
      targetWidth: Qt / Cn,
      targetHeight: pi / Fr
    })));
  });
  return process.env.NODE_ENV !== "production" && (t.displayName = "Trigger"), t;
}
const WQ = L6e($6);
var j6e = ["prefixCls", "disabled", "visible", "children", "popupElement", "animation", "transitionName", "dropdownStyle", "dropdownClassName", "direction", "placement", "builtinPlacements", "dropdownMatchSelectWidth", "dropdownRender", "dropdownAlign", "getPopupContainer", "empty", "getTriggerDOMNode", "onPopupVisibleChange", "onPopupMouseEnter"], F6e = function(t) {
  var n = t === !0 ? 0 : 1;
  return {
    bottomLeft: {
      points: ["tl", "bl"],
      offset: [0, 4],
      overflow: {
        adjustX: n,
        adjustY: 1
      },
      htmlRegion: "scroll"
    },
    bottomRight: {
      points: ["tr", "br"],
      offset: [0, 4],
      overflow: {
        adjustX: n,
        adjustY: 1
      },
      htmlRegion: "scroll"
    },
    topLeft: {
      points: ["bl", "tl"],
      offset: [0, -4],
      overflow: {
        adjustX: n,
        adjustY: 1
      },
      htmlRegion: "scroll"
    },
    topRight: {
      points: ["br", "tr"],
      offset: [0, -4],
      overflow: {
        adjustX: n,
        adjustY: 1
      },
      htmlRegion: "scroll"
    }
  };
}, V6e = function(t, n) {
  var r = t.prefixCls;
  t.disabled;
  var i = t.visible, o = t.children, a = t.popupElement, s = t.animation, c = t.transitionName, l = t.dropdownStyle, u = t.dropdownClassName, d = t.direction, f = d === void 0 ? "ltr" : d, h = t.placement, p = t.builtinPlacements, g = t.dropdownMatchSelectWidth, m = t.dropdownRender, v = t.dropdownAlign, y = t.getPopupContainer, S = t.empty, _ = t.getTriggerDOMNode, w = t.onPopupVisibleChange, T = t.onPopupMouseEnter, x = xn(t, j6e), C = "".concat(r, "-dropdown"), E = a;
  m && (E = m(a));
  var R = I.useMemo(function() {
    return p || F6e(g);
  }, [p, g]), A = s ? "".concat(C, "-").concat(s) : c, O = typeof g == "number", $ = I.useMemo(function() {
    return O ? null : g === !1 ? "minWidth" : "width";
  }, [g, O]), N = l;
  O && (N = ae(ae({}, N), {}, {
    width: g
  }));
  var z = I.useRef(null);
  return I.useImperativeHandle(n, function() {
    return {
      getPopupElement: function() {
        var F;
        return (F = z.current) === null || F === void 0 ? void 0 : F.popupElement;
      }
    };
  }), /* @__PURE__ */ I.createElement(WQ, mt({}, x, {
    showAction: w ? ["click"] : [],
    hideAction: w ? ["click"] : [],
    popupPlacement: h || (f === "rtl" ? "bottomRight" : "bottomLeft"),
    builtinPlacements: R,
    prefixCls: C,
    popupTransitionName: A,
    popup: /* @__PURE__ */ I.createElement("div", {
      onMouseEnter: T
    }, E),
    ref: z,
    stretch: $,
    popupAlign: v,
    popupVisible: i,
    getPopupContainer: y,
    popupClassName: we(u, re({}, "".concat(C, "-empty"), S)),
    popupStyle: N,
    getTriggerDOMNode: _,
    onPopupVisibleChange: w
  }), o);
}, qQ = /* @__PURE__ */ I.forwardRef(V6e);
process.env.NODE_ENV !== "production" && (qQ.displayName = "SelectTrigger");
function WL(e, t) {
  var n = e.key, r;
  return "value" in e && (r = e.value), n ?? (r !== void 0 ? r : "rc-index-key-".concat(t));
}
function mR(e) {
  return typeof e < "u" && !Number.isNaN(e);
}
function GQ(e, t) {
  var n = e || {}, r = n.label, i = n.value, o = n.options, a = n.groupLabel, s = r || (t ? "children" : "label");
  return {
    label: s,
    value: i || "value",
    options: o || "options",
    groupLabel: a || s
  };
}
function B6e(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, n = t.fieldNames, r = t.childrenAsData, i = [], o = GQ(n, !1), a = o.label, s = o.value, c = o.options, l = o.groupLabel;
  function u(d, f) {
    Array.isArray(d) && d.forEach(function(h) {
      if (f || !(c in h)) {
        var p = h[s];
        i.push({
          key: WL(h, i.length),
          groupOption: f,
          data: h,
          label: h[a],
          value: p
        });
      } else {
        var g = h[l];
        g === void 0 && r && (g = h.label), i.push({
          key: WL(h, i.length),
          group: !0,
          data: h,
          label: g
        }), u(h[c], !0);
      }
    });
  }
  return u(e, !1), i;
}
function vR(e) {
  var t = ae({}, e);
  return "props" in t || Object.defineProperty(t, "props", {
    get: function() {
      return an(!1, "Return type is option instead of Option instance. Please read value directly instead of reading from `props`."), t;
    }
  }), t;
}
var z6e = function(t, n, r) {
  if (!n || !n.length)
    return null;
  var i = !1, o = function s(c, l) {
    var u = PY(l), d = u[0], f = u.slice(1);
    if (!d)
      return [c];
    var h = c.split(d);
    return i = i || h.length > 1, h.reduce(function(p, g) {
      return [].concat(Je(p), Je(s(g, f)));
    }, []).filter(Boolean);
  }, a = o(t, n);
  return i ? typeof r < "u" ? a.slice(0, r) : a : null;
}, L6 = /* @__PURE__ */ I.createContext(null);
function H6e(e) {
  var t = e.visible, n = e.values;
  if (!t)
    return null;
  var r = 50;
  return /* @__PURE__ */ I.createElement("span", {
    "aria-live": "polite",
    style: {
      width: 0,
      height: 0,
      position: "absolute",
      overflow: "hidden",
      opacity: 0
    }
  }, "".concat(n.slice(0, r).map(function(i) {
    var o = i.label, a = i.value;
    return ["number", "string"].includes(_t(o)) ? o : a;
  }).join(", ")), n.length > r ? ", ..." : null);
}
var U6e = ["id", "prefixCls", "className", "showSearch", "tagRender", "direction", "omitDomProps", "displayValues", "onDisplayValuesChange", "emptyOptions", "notFoundContent", "onClear", "mode", "disabled", "loading", "getInputElement", "getRawInputElement", "open", "defaultOpen", "onDropdownVisibleChange", "activeValue", "onActiveValueChange", "activeDescendantId", "searchValue", "autoClearSearchValue", "onSearch", "onSearchSplit", "tokenSeparators", "allowClear", "prefix", "suffixIcon", "clearIcon", "OptionList", "animation", "transitionName", "dropdownStyle", "dropdownClassName", "dropdownMatchSelectWidth", "dropdownRender", "dropdownAlign", "placement", "builtinPlacements", "getPopupContainer", "showAction", "onFocus", "onBlur", "onKeyUp", "onKeyDown", "onMouseDown"], W6e = ["value", "onChange", "removeIcon", "placeholder", "autoFocus", "maxTagCount", "maxTagTextLength", "maxTagPlaceholder", "choiceTransitionName", "onInputKeyDown", "onPopupScroll", "tabIndex"], LS = function(t) {
  return t === "tags" || t === "multiple";
}, KQ = /* @__PURE__ */ I.forwardRef(function(e, t) {
  var n, r = e.id, i = e.prefixCls, o = e.className, a = e.showSearch, s = e.tagRender, c = e.direction, l = e.omitDomProps, u = e.displayValues, d = e.onDisplayValuesChange, f = e.emptyOptions, h = e.notFoundContent, p = h === void 0 ? "Not Found" : h, g = e.onClear, m = e.mode, v = e.disabled, y = e.loading, S = e.getInputElement, _ = e.getRawInputElement, w = e.open, T = e.defaultOpen, x = e.onDropdownVisibleChange, C = e.activeValue, E = e.onActiveValueChange, R = e.activeDescendantId, A = e.searchValue, O = e.autoClearSearchValue, $ = e.onSearch, N = e.onSearchSplit, z = e.tokenSeparators, k = e.allowClear, F = e.prefix, V = e.suffixIcon, j = e.clearIcon, B = e.OptionList, U = e.animation, Q = e.transitionName, K = e.dropdownStyle, q = e.dropdownClassName, X = e.dropdownMatchSelectWidth, ie = e.dropdownRender, te = e.dropdownAlign, J = e.placement, Y = e.builtinPlacements, ee = e.getPopupContainer, Z = e.showAction, H = Z === void 0 ? [] : Z, oe = e.onFocus, W = e.onBlur, se = e.onKeyUp, ce = e.onKeyDown, ge = e.onMouseDown, he = xn(e, U6e), ue = LS(m), Ee = (a !== void 0 ? a : ue) || m === "combobox", pe = ae({}, he);
  W6e.forEach(function(Xt) {
    delete pe[Xt];
  }), l == null || l.forEach(function(Xt) {
    delete pe[Xt];
  });
  var Oe = I.useState(!1), de = fe(Oe, 2), be = de[0], Ie = de[1];
  I.useEffect(function() {
    Ie(k6());
  }, []);
  var Ve = I.useRef(null), Fe = I.useRef(null), Pe = I.useRef(null), ot = I.useRef(null), dt = I.useRef(null), ft = I.useRef(!1), wt = i6e(), Ge = fe(wt, 3), at = Ge[0], Nt = Ge[1], zt = Ge[2];
  I.useImperativeHandle(t, function() {
    var Xt, Vt;
    return {
      focus: (Xt = ot.current) === null || Xt === void 0 ? void 0 : Xt.focus,
      blur: (Vt = ot.current) === null || Vt === void 0 ? void 0 : Vt.blur,
      scrollTo: function(Qt) {
        var Jt;
        return (Jt = dt.current) === null || Jt === void 0 ? void 0 : Jt.scrollTo(Qt);
      },
      nativeElement: Ve.current || Fe.current
    };
  });
  var kt = I.useMemo(function() {
    var Xt;
    if (m !== "combobox")
      return A;
    var Vt = (Xt = u[0]) === null || Xt === void 0 ? void 0 : Xt.value;
    return typeof Vt == "string" || typeof Vt == "number" ? String(Vt) : "";
  }, [A, m, u]), Ct = m === "combobox" && typeof S == "function" && S() || null, yt = typeof _ == "function" && _(), Mn = Vx(Fe, yt == null || (n = yt.props) === null || n === void 0 ? void 0 : n.ref), Pt = I.useState(!1), Ze = fe(Pt, 2), Le = Ze[0], rt = Ze[1];
  nr(function() {
    rt(!0);
  }, []);
  var ut = hc(!1, {
    defaultValue: T,
    value: w
  }), vt = fe(ut, 2), We = vt[0], et = vt[1], Ne = Le ? We : !1, Yt = !p && f;
  (v || Yt && Ne && m === "combobox") && (Ne = !1);
  var Ht = Yt ? !1 : Ne, Be = I.useCallback(function(Xt) {
    var Vt = Xt !== void 0 ? Xt : !Ne;
    v || (et(Vt), Ne !== Vt && (x == null || x(Vt)));
  }, [v, Ne, et, x]), ze = I.useMemo(function() {
    return (z || []).some(function(Xt) {
      return [`
`, `\r
`].includes(Xt);
    });
  }, [z]), it = I.useContext(L6) || {}, lt = it.maxCount, Tt = it.rawValues, jt = function(Vt, tn, Qt) {
    if (!(ue && mR(lt) && (Tt == null ? void 0 : Tt.size) >= lt)) {
      var Jt = !0, vn = Vt;
      E == null || E(null);
      var Cr = z6e(Vt, z, mR(lt) ? lt - Tt.size : void 0), pi = Qt ? null : Cr;
      return m !== "combobox" && pi && (vn = "", N == null || N(pi), Be(!1), Jt = !1), $ && kt !== vn && $(vn, {
        source: tn ? "typing" : "effect"
      }), Jt;
    }
  }, ne = function(Vt) {
    !Vt || !Vt.trim() || $(Vt, {
      source: "submit"
    });
  };
  I.useEffect(function() {
    !Ne && !ue && m !== "combobox" && jt("", !1, !1);
  }, [Ne]), I.useEffect(function() {
    We && v && et(!1), v && !ft.current && Nt(!1);
  }, [v]);
  var _e = DQ(), $e = fe(_e, 2), qe = $e[0], xt = $e[1], bt = I.useRef(!1), st = function(Vt) {
    var tn = qe(), Qt = Vt.key, Jt = Qt === "Enter";
    if (Jt && (m !== "combobox" && Vt.preventDefault(), Ne || Be(!0)), xt(!!kt), Qt === "Backspace" && !tn && ue && !kt && u.length) {
      for (var vn = Je(u), Cr = null, pi = vn.length - 1; pi >= 0; pi -= 1) {
        var ln = vn[pi];
        if (!ln.disabled) {
          vn.splice(pi, 1), Cr = ln;
          break;
        }
      }
      Cr && d(vn, {
        type: "remove",
        values: [Cr]
      });
    }
    for (var ni = arguments.length, ri = new Array(ni > 1 ? ni - 1 : 0), Ki = 1; Ki < ni; Ki++)
      ri[Ki - 1] = arguments[Ki];
    if (Ne && (!Jt || !bt.current)) {
      var Do;
      (Do = dt.current) === null || Do === void 0 || Do.onKeyDown.apply(Do, [Vt].concat(ri));
    }
    Jt && (bt.current = !0), ce == null || ce.apply(void 0, [Vt].concat(ri));
  }, Rt = function(Vt) {
    for (var tn = arguments.length, Qt = new Array(tn > 1 ? tn - 1 : 0), Jt = 1; Jt < tn; Jt++)
      Qt[Jt - 1] = arguments[Jt];
    if (Ne) {
      var vn;
      (vn = dt.current) === null || vn === void 0 || vn.onKeyUp.apply(vn, [Vt].concat(Qt));
    }
    Vt.key === "Enter" && (bt.current = !1), se == null || se.apply(void 0, [Vt].concat(Qt));
  }, Ke = function(Vt) {
    var tn = u.filter(function(Qt) {
      return Qt !== Vt;
    });
    d(tn, {
      type: "remove",
      values: [Vt]
    });
  }, ke = I.useRef(!1), Xe = function() {
    Nt(!0), v || (oe && !ke.current && oe.apply(void 0, arguments), H.includes("focus") && Be(!0)), ke.current = !0;
  }, ct = function() {
    ft.current = !0, Nt(!1, function() {
      ke.current = !1, ft.current = !1, Be(!1);
    }), !v && (kt && (m === "tags" ? $(kt, {
      source: "submit"
    }) : m === "multiple" && $("", {
      source: "blur"
    })), W && W.apply(void 0, arguments));
  }, Ue = [];
  I.useEffect(function() {
    return function() {
      Ue.forEach(function(Xt) {
        return clearTimeout(Xt);
      }), Ue.splice(0, Ue.length);
    };
  }, []);
  var Dt = function(Vt) {
    var tn, Qt = Vt.target, Jt = (tn = Pe.current) === null || tn === void 0 ? void 0 : tn.getPopupElement();
    if (Jt && Jt.contains(Qt)) {
      var vn = setTimeout(function() {
        var ni = Ue.indexOf(vn);
        if (ni !== -1 && Ue.splice(ni, 1), zt(), !be && !Jt.contains(document.activeElement)) {
          var ri;
          (ri = ot.current) === null || ri === void 0 || ri.focus();
        }
      });
      Ue.push(vn);
    }
    for (var Cr = arguments.length, pi = new Array(Cr > 1 ? Cr - 1 : 0), ln = 1; ln < Cr; ln++)
      pi[ln - 1] = arguments[ln];
    ge == null || ge.apply(void 0, [Vt].concat(pi));
  }, It = I.useState({}), wn = fe(It, 2), gr = wn[1];
  function Gn() {
    gr({});
  }
  var Cn;
  yt && (Cn = function(Vt) {
    Be(Vt);
  }), o6e(function() {
    var Xt;
    return [Ve.current, (Xt = Pe.current) === null || Xt === void 0 ? void 0 : Xt.getPopupElement()];
  }, Ht, Be, !!yt);
  var Fr = I.useMemo(function() {
    return ae(ae({}, e), {}, {
      notFoundContent: p,
      open: Ne,
      triggerOpen: Ht,
      id: r,
      showSearch: Ee,
      multiple: ue,
      toggleOpen: Be
    });
  }, [e, p, Ht, Ne, r, Ee, ue, Be]), Kr = !!V || y, pr;
  Kr && (pr = /* @__PURE__ */ I.createElement(sE, {
    className: we("".concat(i, "-arrow"), re({}, "".concat(i, "-arrow-loading"), y)),
    customizeIcon: V,
    customizeIconProps: {
      loading: y,
      searchValue: kt,
      open: Ne,
      focused: at,
      showSearch: Ee
    }
  }));
  var xr = function() {
    var Vt;
    g == null || g(), (Vt = ot.current) === null || Vt === void 0 || Vt.focus(), d([], {
      type: "clear",
      values: u
    }), jt("", !1, !1);
  }, Yr = n6e(i, xr, u, k, j, v, kt, m), Er = Yr.allowClear, Xr = Yr.clearIcon, Ci = /* @__PURE__ */ I.createElement(B, {
    ref: dt
  }), Ti = we(i, o, re(re(re(re(re(re(re(re(re(re({}, "".concat(i, "-focused"), at), "".concat(i, "-multiple"), ue), "".concat(i, "-single"), !ue), "".concat(i, "-allow-clear"), k), "".concat(i, "-show-arrow"), Kr), "".concat(i, "-disabled"), v), "".concat(i, "-loading"), y), "".concat(i, "-open"), Ne), "".concat(i, "-customize-input"), Ct), "".concat(i, "-show-search"), Ee)), Mi = /* @__PURE__ */ I.createElement(qQ, {
    ref: Pe,
    disabled: v,
    prefixCls: i,
    visible: Ht,
    popupElement: Ci,
    animation: U,
    transitionName: Q,
    dropdownStyle: K,
    dropdownClassName: q,
    direction: c,
    dropdownMatchSelectWidth: X,
    dropdownRender: ie,
    dropdownAlign: te,
    placement: J,
    builtinPlacements: Y,
    getPopupContainer: ee,
    empty: f,
    getTriggerDOMNode: function(Vt) {
      return (
        // TODO: This is workaround and should be removed in `rc-select`
        // And use new standard `nativeElement` for ref.
        // But we should update `rc-resize-observer` first.
        Fe.current || Vt
      );
    },
    onPopupVisibleChange: Cn,
    onPopupMouseEnter: Gn
  }, yt ? /* @__PURE__ */ I.cloneElement(yt, {
    ref: Mn
  }) : /* @__PURE__ */ I.createElement(BQ, mt({}, e, {
    domRef: Fe,
    prefixCls: i,
    inputElement: Ct,
    ref: ot,
    id: r,
    prefix: F,
    showSearch: Ee,
    autoClearSearchValue: O,
    mode: m,
    activeDescendantId: R,
    tagRender: s,
    values: u,
    open: Ne,
    onToggleOpen: Be,
    activeValue: C,
    searchValue: kt,
    onSearch: jt,
    onSearchSubmit: ne,
    onRemove: Ke,
    tokenWithEnter: ze
  }))), Qn;
  return yt ? Qn = Mi : Qn = /* @__PURE__ */ I.createElement("div", mt({
    className: Ti
  }, pe, {
    ref: Ve,
    onMouseDown: Dt,
    onKeyDown: st,
    onKeyUp: Rt,
    onFocus: Xe,
    onBlur: ct
  }), /* @__PURE__ */ I.createElement(H6e, {
    visible: at && !Ne,
    values: u
  }), Mi, pr, Er && Xr), /* @__PURE__ */ I.createElement(NQ.Provider, {
    value: Fr
  }, Qn);
});
process.env.NODE_ENV !== "production" && (KQ.displayName = "BaseSelect");
var j6 = function() {
  return null;
};
j6.isSelectOptGroup = !0;
var F6 = function() {
  return null;
};
F6.isSelectOption = !0;
var YQ = /* @__PURE__ */ I.forwardRef(function(e, t) {
  var n = e.height, r = e.offsetY, i = e.offsetX, o = e.children, a = e.prefixCls, s = e.onInnerResize, c = e.innerProps, l = e.rtl, u = e.extra, d = {}, f = {
    display: "flex",
    flexDirection: "column"
  };
  return r !== void 0 && (d = {
    height: n,
    position: "relative",
    overflow: "hidden"
  }, f = ae(ae({}, f), {}, re(re(re(re(re({
    transform: "translateY(".concat(r, "px)")
  }, l ? "marginRight" : "marginLeft", -i), "position", "absolute"), "left", 0), "right", 0), "top", 0))), /* @__PURE__ */ I.createElement("div", {
    style: d
  }, /* @__PURE__ */ I.createElement(ml, {
    onResize: function(p) {
      var g = p.offsetHeight;
      g && s && s();
    }
  }, /* @__PURE__ */ I.createElement("div", mt({
    style: f,
    className: we(re({}, "".concat(a, "-holder-inner"), a)),
    ref: t
  }, c), o, u)));
});
YQ.displayName = "Filler";
function q6e(e) {
  var t = e.children, n = e.setRef, r = I.useCallback(function(i) {
    n(i);
  }, []);
  return /* @__PURE__ */ I.cloneElement(t, {
    ref: r
  });
}
function G6e(e, t, n, r, i, o, a, s) {
  var c = s.getKey;
  return e.slice(t, n + 1).map(function(l, u) {
    var d = t + u, f = a(l, d, {
      style: {
        width: r
      },
      offsetX: i
    }), h = c(l);
    return /* @__PURE__ */ I.createElement(q6e, {
      key: h,
      setRef: function(g) {
        return o(l, g);
      }
    }, f);
  });
}
function K6e(e, t, n) {
  var r = e.length, i = t.length, o, a;
  if (r === 0 && i === 0)
    return null;
  r < i ? (o = e, a = t) : (o = t, a = e);
  var s = {
    __EMPTY_ITEM__: !0
  };
  function c(p) {
    return p !== void 0 ? n(p) : s;
  }
  for (var l = null, u = Math.abs(r - i) !== 1, d = 0; d < a.length; d += 1) {
    var f = c(o[d]), h = c(a[d]);
    if (f !== h) {
      l = d, u = u || f !== c(a[d + 1]);
      break;
    }
  }
  return l === null ? null : {
    index: l,
    multiple: u
  };
}
function Y6e(e, t, n) {
  var r = I.useState(e), i = fe(r, 2), o = i[0], a = i[1], s = I.useState(null), c = fe(s, 2), l = c[0], u = c[1];
  return I.useEffect(function() {
    var d = K6e(o || [], e || [], t);
    (d == null ? void 0 : d.index) !== void 0 && (n == null || n(d.index), u(e[d.index])), a(e);
  }, [e]), [l];
}
var qL = (typeof navigator > "u" ? "undefined" : _t(navigator)) === "object" && /Firefox/i.test(navigator.userAgent);
const XQ = function(e, t, n, r) {
  var i = Me(!1), o = Me(null);
  function a() {
    clearTimeout(o.current), i.current = !0, o.current = setTimeout(function() {
      i.current = !1;
    }, 50);
  }
  var s = Me({
    top: e,
    bottom: t,
    left: n,
    right: r
  });
  return s.current.top = e, s.current.bottom = t, s.current.left = n, s.current.right = r, function(c, l) {
    var u = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1, d = c ? (
      // Pass origin wheel when on the left
      l < 0 && s.current.left || // Pass origin wheel when on the right
      l > 0 && s.current.right
    ) : l < 0 && s.current.top || // Pass origin wheel when on the bottom
    l > 0 && s.current.bottom;
    return u && d ? (clearTimeout(o.current), i.current = !1) : (!d || i.current) && a(), !i.current && d;
  };
};
function X6e(e, t, n, r, i, o, a) {
  var s = Me(0), c = Me(null), l = Me(null), u = Me(!1), d = XQ(t, n, r, i);
  function f(y, S) {
    if (Ln.cancel(c.current), !d(!1, S)) {
      var _ = y;
      if (!_._virtualHandled)
        _._virtualHandled = !0;
      else
        return;
      s.current += S, l.current = S, qL || _.preventDefault(), c.current = Ln(function() {
        var w = u.current ? 10 : 1;
        a(s.current * w, !1), s.current = 0;
      });
    }
  }
  function h(y, S) {
    a(S, !0), qL || y.preventDefault();
  }
  var p = Me(null), g = Me(null);
  function m(y) {
    if (e) {
      Ln.cancel(g.current), g.current = Ln(function() {
        p.current = null;
      }, 2);
      var S = y.deltaX, _ = y.deltaY, w = y.shiftKey, T = S, x = _;
      (p.current === "sx" || !p.current && w && _ && !S) && (T = _, x = 0, p.current = "sx");
      var C = Math.abs(T), E = Math.abs(x);
      p.current === null && (p.current = o && C > E ? "x" : "y"), p.current === "y" ? f(y, x) : h(y, T);
    }
  }
  function v(y) {
    e && (u.current = y.detail === l.current);
  }
  return [m, v];
}
function Q6e(e, t, n, r) {
  var i = I.useMemo(function() {
    return [/* @__PURE__ */ new Map(), []];
  }, [e, n.id, r]), o = fe(i, 2), a = o[0], s = o[1], c = function(u) {
    var d = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : u, f = a.get(u), h = a.get(d);
    if (f === void 0 || h === void 0)
      for (var p = e.length, g = s.length; g < p; g += 1) {
        var m, v = e[g], y = t(v);
        a.set(y, g);
        var S = (m = n.get(y)) !== null && m !== void 0 ? m : r;
        if (s[g] = (s[g - 1] || 0) + S, y === u && (f = g), y === d && (h = g), f !== void 0 && h !== void 0)
          break;
      }
    return {
      top: s[f - 1] || 0,
      bottom: s[h]
    };
  };
  return c;
}
var J6e = /* @__PURE__ */ function() {
  function e() {
    Sr(this, e), re(this, "maps", void 0), re(this, "id", 0), this.maps = /* @__PURE__ */ Object.create(null);
  }
  return wr(e, [{
    key: "set",
    value: function(n, r) {
      this.maps[n] = r, this.id += 1;
    }
  }, {
    key: "get",
    value: function(n) {
      return this.maps[n];
    }
  }]), e;
}();
function GL(e) {
  var t = parseFloat(e);
  return isNaN(t) ? 0 : t;
}
function Z6e(e, t, n) {
  var r = I.useState(0), i = fe(r, 2), o = i[0], a = i[1], s = Me(/* @__PURE__ */ new Map()), c = Me(new J6e()), l = Me();
  function u() {
    Ln.cancel(l.current);
  }
  function d() {
    var h = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !1;
    u();
    var p = function() {
      s.current.forEach(function(m, v) {
        if (m && m.offsetParent) {
          var y = m0(m), S = y.offsetHeight, _ = getComputedStyle(y), w = _.marginTop, T = _.marginBottom, x = GL(w), C = GL(T), E = S + x + C;
          c.current.get(v) !== E && c.current.set(v, E);
        }
      }), a(function(m) {
        return m + 1;
      });
    };
    h ? p() : l.current = Ln(p);
  }
  function f(h, p) {
    var g = e(h), m = s.current.get(g);
    p ? (s.current.set(g, p), d()) : s.current.delete(g), !m != !p && (p ? t == null || t(h) : n == null || n(h));
  }
  return gt(function() {
    return u;
  }, []), [f, d, c.current, o];
}
var KL = 14 / 15;
function eMe(e, t, n) {
  var r = Me(!1), i = Me(0), o = Me(0), a = Me(null), s = Me(null), c, l = function(h) {
    if (r.current) {
      var p = Math.ceil(h.touches[0].pageX), g = Math.ceil(h.touches[0].pageY), m = i.current - p, v = o.current - g, y = Math.abs(m) > Math.abs(v);
      y ? i.current = p : o.current = g;
      var S = n(y, y ? m : v, !1, h);
      S && h.preventDefault(), clearInterval(s.current), S && (s.current = setInterval(function() {
        y ? m *= KL : v *= KL;
        var _ = Math.floor(y ? m : v);
        (!n(y, _, !0) || Math.abs(_) <= 0.1) && clearInterval(s.current);
      }, 16));
    }
  }, u = function() {
    r.current = !1, c();
  }, d = function(h) {
    c(), h.touches.length === 1 && !r.current && (r.current = !0, i.current = Math.ceil(h.touches[0].pageX), o.current = Math.ceil(h.touches[0].pageY), a.current = h.target, a.current.addEventListener("touchmove", l, {
      passive: !1
    }), a.current.addEventListener("touchend", u, {
      passive: !0
    }));
  };
  c = function() {
    a.current && (a.current.removeEventListener("touchmove", l), a.current.removeEventListener("touchend", u));
  }, nr(function() {
    return e && t.current.addEventListener("touchstart", d, {
      passive: !0
    }), function() {
      var f;
      (f = t.current) === null || f === void 0 || f.removeEventListener("touchstart", d), c(), clearInterval(s.current);
    };
  }, [e]);
}
var YL = 10;
function tMe(e, t, n, r, i, o, a, s) {
  var c = I.useRef(), l = I.useState(null), u = fe(l, 2), d = u[0], f = u[1];
  return nr(function() {
    if (d && d.times < YL) {
      if (!e.current) {
        f(function(j) {
          return ae({}, j);
        });
        return;
      }
      o();
      var h = d.targetAlign, p = d.originAlign, g = d.index, m = d.offset, v = e.current.clientHeight, y = !1, S = h, _ = null;
      if (v) {
        for (var w = h || p, T = 0, x = 0, C = 0, E = Math.min(t.length - 1, g), R = 0; R <= E; R += 1) {
          var A = i(t[R]);
          x = T;
          var O = n.get(A);
          C = x + (O === void 0 ? r : O), T = C;
        }
        for (var $ = w === "top" ? m : v - m, N = E; N >= 0; N -= 1) {
          var z = i(t[N]), k = n.get(z);
          if (k === void 0) {
            y = !0;
            break;
          }
          if ($ -= k, $ <= 0)
            break;
        }
        switch (w) {
          case "top":
            _ = x - m;
            break;
          case "bottom":
            _ = C - v + m;
            break;
          default: {
            var F = e.current.scrollTop, V = F + v;
            x < F ? S = "top" : C > V && (S = "bottom");
          }
        }
        _ !== null && a(_), _ !== d.lastTop && (y = !0);
      }
      y && f(ae(ae({}, d), {}, {
        times: d.times + 1,
        targetAlign: S,
        lastTop: _
      }));
    } else
      process.env.NODE_ENV !== "production" && (d == null ? void 0 : d.times) === YL && an(!1, "Seems `scrollTo` with `rc-virtual-list` reach the max limitation. Please fire issue for us. Thanks.");
  }, [d, e.current]), function(h) {
    if (h == null) {
      s();
      return;
    }
    if (Ln.cancel(c.current), typeof h == "number")
      a(h);
    else if (h && _t(h) === "object") {
      var p, g = h.align;
      "index" in h ? p = h.index : p = t.findIndex(function(y) {
        return i(y) === h.key;
      });
      var m = h.offset, v = m === void 0 ? 0 : m;
      f({
        times: 0,
        index: p,
        offset: v,
        originAlign: g
      });
    }
  };
}
function XL(e, t) {
  var n = "touches" in e ? e.touches[0] : e;
  return n[t ? "pageX" : "pageY"];
}
var yR = /* @__PURE__ */ I.forwardRef(function(e, t) {
  var n = e.prefixCls, r = e.rtl, i = e.scrollOffset, o = e.scrollRange, a = e.onStartMove, s = e.onStopMove, c = e.onScroll, l = e.horizontal, u = e.spinSize, d = e.containerSize, f = e.style, h = e.thumbStyle, p = I.useState(!1), g = fe(p, 2), m = g[0], v = g[1], y = I.useState(null), S = fe(y, 2), _ = S[0], w = S[1], T = I.useState(null), x = fe(T, 2), C = x[0], E = x[1], R = !r, A = I.useRef(), O = I.useRef(), $ = I.useState(!1), N = fe($, 2), z = N[0], k = N[1], F = I.useRef(), V = function() {
    clearTimeout(F.current), k(!0), F.current = setTimeout(function() {
      k(!1);
    }, 3e3);
  }, j = o - d || 0, B = d - u || 0, U = I.useMemo(function() {
    if (i === 0 || j === 0)
      return 0;
    var ee = i / j;
    return ee * B;
  }, [i, j, B]), Q = function(Z) {
    Z.stopPropagation(), Z.preventDefault();
  }, K = I.useRef({
    top: U,
    dragging: m,
    pageY: _,
    startTop: C
  });
  K.current = {
    top: U,
    dragging: m,
    pageY: _,
    startTop: C
  };
  var q = function(Z) {
    v(!0), w(XL(Z, l)), E(K.current.top), a(), Z.stopPropagation(), Z.preventDefault();
  };
  I.useEffect(function() {
    var ee = function(W) {
      W.preventDefault();
    }, Z = A.current, H = O.current;
    return Z.addEventListener("touchstart", ee, {
      passive: !1
    }), H.addEventListener("touchstart", q, {
      passive: !1
    }), function() {
      Z.removeEventListener("touchstart", ee), H.removeEventListener("touchstart", q);
    };
  }, []);
  var X = I.useRef();
  X.current = j;
  var ie = I.useRef();
  ie.current = B, I.useEffect(function() {
    if (m) {
      var ee, Z = function(W) {
        var se = K.current, ce = se.dragging, ge = se.pageY, he = se.startTop;
        Ln.cancel(ee);
        var ue = A.current.getBoundingClientRect(), Ee = d / (l ? ue.width : ue.height);
        if (ce) {
          var pe = (XL(W, l) - ge) * Ee, Oe = he;
          !R && l ? Oe -= pe : Oe += pe;
          var de = X.current, be = ie.current, Ie = be ? Oe / be : 0, Ve = Math.ceil(Ie * de);
          Ve = Math.max(Ve, 0), Ve = Math.min(Ve, de), ee = Ln(function() {
            c(Ve, l);
          });
        }
      }, H = function() {
        v(!1), s();
      };
      return window.addEventListener("mousemove", Z, {
        passive: !0
      }), window.addEventListener("touchmove", Z, {
        passive: !0
      }), window.addEventListener("mouseup", H, {
        passive: !0
      }), window.addEventListener("touchend", H, {
        passive: !0
      }), function() {
        window.removeEventListener("mousemove", Z), window.removeEventListener("touchmove", Z), window.removeEventListener("mouseup", H), window.removeEventListener("touchend", H), Ln.cancel(ee);
      };
    }
  }, [m]), I.useEffect(function() {
    return V(), function() {
      clearTimeout(F.current);
    };
  }, [i]), I.useImperativeHandle(t, function() {
    return {
      delayHidden: V
    };
  });
  var te = "".concat(n, "-scrollbar"), J = {
    position: "absolute",
    visibility: z ? null : "hidden"
  }, Y = {
    position: "absolute",
    background: "rgba(0, 0, 0, 0.5)",
    borderRadius: 99,
    cursor: "pointer",
    userSelect: "none"
  };
  return l ? (J.height = 8, J.left = 0, J.right = 0, J.bottom = 0, Y.height = "100%", Y.width = u, R ? Y.left = U : Y.right = U) : (J.width = 8, J.top = 0, J.bottom = 0, R ? J.right = 0 : J.left = 0, Y.width = "100%", Y.height = u, Y.top = U), /* @__PURE__ */ I.createElement("div", {
    ref: A,
    className: we(te, re(re(re({}, "".concat(te, "-horizontal"), l), "".concat(te, "-vertical"), !l), "".concat(te, "-visible"), z)),
    style: ae(ae({}, J), f),
    onMouseDown: Q,
    onMouseMove: V
  }, /* @__PURE__ */ I.createElement("div", {
    ref: O,
    className: we("".concat(te, "-thumb"), re({}, "".concat(te, "-thumb-moving"), m)),
    style: ae(ae({}, Y), h),
    onMouseDown: q
  }));
});
process.env.NODE_ENV !== "production" && (yR.displayName = "ScrollBar");
var nMe = 20;
function QL() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0, t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, n = e / t * e;
  return isNaN(n) && (n = 0), n = Math.max(n, nMe), Math.floor(n);
}
var rMe = ["prefixCls", "className", "height", "itemHeight", "fullHeight", "style", "data", "children", "itemKey", "virtual", "direction", "scrollWidth", "component", "onScroll", "onVirtualScroll", "onVisibleChange", "innerProps", "extraRender", "styles"], iMe = [], oMe = {
  overflowY: "auto",
  overflowAnchor: "none"
};
function aMe(e, t) {
  var n = e.prefixCls, r = n === void 0 ? "rc-virtual-list" : n, i = e.className, o = e.height, a = e.itemHeight, s = e.fullHeight, c = s === void 0 ? !0 : s, l = e.style, u = e.data, d = e.children, f = e.itemKey, h = e.virtual, p = e.direction, g = e.scrollWidth, m = e.component, v = m === void 0 ? "div" : m, y = e.onScroll, S = e.onVirtualScroll, _ = e.onVisibleChange, w = e.innerProps, T = e.extraRender, x = e.styles, C = xn(e, rMe), E = I.useCallback(function(Ke) {
    return typeof f == "function" ? f(Ke) : Ke == null ? void 0 : Ke[f];
  }, [f]), R = Z6e(E, null, null), A = fe(R, 4), O = A[0], $ = A[1], N = A[2], z = A[3], k = !!(h !== !1 && o && a), F = I.useMemo(function() {
    return Object.values(N.maps).reduce(function(Ke, ke) {
      return Ke + ke;
    }, 0);
  }, [N.id, N.maps]), V = k && u && (Math.max(a * u.length, F) > o || !!g), j = p === "rtl", B = we(r, re({}, "".concat(r, "-rtl"), j), i), U = u || iMe, Q = Me(), K = Me(), q = Me(), X = Lt(0), ie = fe(X, 2), te = ie[0], J = ie[1], Y = Lt(0), ee = fe(Y, 2), Z = ee[0], H = ee[1], oe = Lt(!1), W = fe(oe, 2), se = W[0], ce = W[1], ge = function() {
    ce(!0);
  }, he = function() {
    ce(!1);
  }, ue = {
    getKey: E
  };
  function Ee(Ke) {
    J(function(ke) {
      var Xe;
      typeof Ke == "function" ? Xe = Ke(ke) : Xe = Ke;
      var ct = Ze(Xe);
      return Q.current.scrollTop = ct, ct;
    });
  }
  var pe = Me({
    start: 0,
    end: U.length
  }), Oe = Me(), de = Y6e(U, E), be = fe(de, 1), Ie = be[0];
  Oe.current = Ie;
  var Ve = I.useMemo(function() {
    if (!k)
      return {
        scrollHeight: void 0,
        start: 0,
        end: U.length - 1,
        offset: void 0
      };
    if (!V) {
      var Ke;
      return {
        scrollHeight: ((Ke = K.current) === null || Ke === void 0 ? void 0 : Ke.offsetHeight) || 0,
        start: 0,
        end: U.length - 1,
        offset: void 0
      };
    }
    for (var ke = 0, Xe, ct, Ue, Dt = U.length, It = 0; It < Dt; It += 1) {
      var wn = U[It], gr = E(wn), Gn = N.get(gr), Cn = ke + (Gn === void 0 ? a : Gn);
      Cn >= te && Xe === void 0 && (Xe = It, ct = ke), Cn > te + o && Ue === void 0 && (Ue = It), ke = Cn;
    }
    return Xe === void 0 && (Xe = 0, ct = 0, Ue = Math.ceil(o / a)), Ue === void 0 && (Ue = U.length - 1), Ue = Math.min(Ue + 1, U.length - 1), {
      scrollHeight: ke,
      start: Xe,
      end: Ue,
      offset: ct
    };
  }, [V, k, te, U, z, o]), Fe = Ve.scrollHeight, Pe = Ve.start, ot = Ve.end, dt = Ve.offset;
  pe.current.start = Pe, pe.current.end = ot;
  var ft = I.useState({
    width: 0,
    height: o
  }), wt = fe(ft, 2), Ge = wt[0], at = wt[1], Nt = function(ke) {
    at({
      width: ke.offsetWidth,
      height: ke.offsetHeight
    });
  }, zt = Me(), kt = Me(), Ct = I.useMemo(function() {
    return QL(Ge.width, g);
  }, [Ge.width, g]), yt = I.useMemo(function() {
    return QL(Ge.height, Fe);
  }, [Ge.height, Fe]), Mn = Fe - o, Pt = Me(Mn);
  Pt.current = Mn;
  function Ze(Ke) {
    var ke = Ke;
    return Number.isNaN(Pt.current) || (ke = Math.min(ke, Pt.current)), ke = Math.max(ke, 0), ke;
  }
  var Le = te <= 0, rt = te >= Mn, ut = Z <= 0, vt = Z >= g, We = XQ(Le, rt, ut, vt), et = function() {
    return {
      x: j ? -Z : Z,
      y: te
    };
  }, Ne = Me(et()), Yt = Rr(function(Ke) {
    if (S) {
      var ke = ae(ae({}, et()), Ke);
      (Ne.current.x !== ke.x || Ne.current.y !== ke.y) && (S(ke), Ne.current = ke);
    }
  });
  function Ht(Ke, ke) {
    var Xe = Ke;
    ke ? (fI(function() {
      H(Xe);
    }), Yt()) : Ee(Xe);
  }
  function Be(Ke) {
    var ke = Ke.currentTarget.scrollTop;
    ke !== te && Ee(ke), y == null || y(Ke), Yt();
  }
  var ze = function(ke) {
    var Xe = ke, ct = g ? g - Ge.width : 0;
    return Xe = Math.max(Xe, 0), Xe = Math.min(Xe, ct), Xe;
  }, it = Rr(function(Ke, ke) {
    ke ? (fI(function() {
      H(function(Xe) {
        var ct = Xe + (j ? -Ke : Ke);
        return ze(ct);
      });
    }), Yt()) : Ee(function(Xe) {
      var ct = Xe + Ke;
      return ct;
    });
  }), lt = X6e(k, Le, rt, ut, vt, !!g, it), Tt = fe(lt, 2), jt = Tt[0], ne = Tt[1];
  eMe(k, Q, function(Ke, ke, Xe, ct) {
    var Ue = ct;
    return We(Ke, ke, Xe) ? !1 : !Ue || !Ue._virtualHandled ? (Ue && (Ue._virtualHandled = !0), jt({
      preventDefault: function() {
      },
      deltaX: Ke ? ke : 0,
      deltaY: Ke ? 0 : ke
    }), !0) : !1;
  }), nr(function() {
    function Ke(Xe) {
      var ct = Le && Xe.detail < 0, Ue = rt && Xe.detail > 0;
      k && !ct && !Ue && Xe.preventDefault();
    }
    var ke = Q.current;
    return ke.addEventListener("wheel", jt, {
      passive: !1
    }), ke.addEventListener("DOMMouseScroll", ne, {
      passive: !0
    }), ke.addEventListener("MozMousePixelScroll", Ke, {
      passive: !1
    }), function() {
      ke.removeEventListener("wheel", jt), ke.removeEventListener("DOMMouseScroll", ne), ke.removeEventListener("MozMousePixelScroll", Ke);
    };
  }, [k, Le, rt]), nr(function() {
    if (g) {
      var Ke = ze(Z);
      H(Ke), Yt({
        x: Ke
      });
    }
  }, [Ge.width, g]);
  var _e = function() {
    var ke, Xe;
    (ke = zt.current) === null || ke === void 0 || ke.delayHidden(), (Xe = kt.current) === null || Xe === void 0 || Xe.delayHidden();
  }, $e = tMe(Q, U, N, a, E, function() {
    return $(!0);
  }, Ee, _e);
  I.useImperativeHandle(t, function() {
    return {
      nativeElement: q.current,
      getScrollInfo: et,
      scrollTo: function(ke) {
        function Xe(ct) {
          return ct && _t(ct) === "object" && ("left" in ct || "top" in ct);
        }
        Xe(ke) ? (ke.left !== void 0 && H(ze(ke.left)), $e(ke.top)) : $e(ke);
      }
    };
  }), nr(function() {
    if (_) {
      var Ke = U.slice(Pe, ot + 1);
      _(Ke, U);
    }
  }, [Pe, ot, U]);
  var qe = Q6e(U, E, N, a), xt = T == null ? void 0 : T({
    start: Pe,
    end: ot,
    virtual: V,
    offsetX: Z,
    offsetY: dt,
    rtl: j,
    getSize: qe
  }), bt = G6e(U, Pe, ot, g, Z, O, d, ue), st = null;
  o && (st = ae(re({}, c ? "height" : "maxHeight", o), oMe), k && (st.overflowY = "hidden", g && (st.overflowX = "hidden"), se && (st.pointerEvents = "none")));
  var Rt = {};
  return j && (Rt.dir = "rtl"), /* @__PURE__ */ I.createElement("div", mt({
    ref: q,
    style: ae(ae({}, l), {}, {
      position: "relative"
    }),
    className: B
  }, Rt, C), /* @__PURE__ */ I.createElement(ml, {
    onResize: Nt
  }, /* @__PURE__ */ I.createElement(v, {
    className: "".concat(r, "-holder"),
    style: st,
    ref: Q,
    onScroll: Be,
    onMouseEnter: _e
  }, /* @__PURE__ */ I.createElement(YQ, {
    prefixCls: r,
    height: Fe,
    offsetX: Z,
    offsetY: dt,
    scrollWidth: g,
    onInnerResize: $,
    ref: K,
    innerProps: w,
    rtl: j,
    extra: xt
  }, bt))), V && Fe > o && /* @__PURE__ */ I.createElement(yR, {
    ref: zt,
    prefixCls: r,
    scrollOffset: te,
    scrollRange: Fe,
    rtl: j,
    onScroll: Ht,
    onStartMove: ge,
    onStopMove: he,
    spinSize: yt,
    containerSize: Ge.height,
    style: x == null ? void 0 : x.verticalScrollBar,
    thumbStyle: x == null ? void 0 : x.verticalScrollBarThumb
  }), V && g > Ge.width && /* @__PURE__ */ I.createElement(yR, {
    ref: kt,
    prefixCls: r,
    scrollOffset: Z,
    scrollRange: g,
    rtl: j,
    onScroll: Ht,
    onStartMove: ge,
    onStopMove: he,
    spinSize: Ct,
    containerSize: Ge.width,
    horizontal: !0,
    style: x == null ? void 0 : x.horizontalScrollBar,
    thumbStyle: x == null ? void 0 : x.horizontalScrollBarThumb
  }));
}
var QQ = /* @__PURE__ */ I.forwardRef(aMe);
QQ.displayName = "List";
function sMe() {
  return /(mac\sos|macintosh)/i.test(navigator.appVersion);
}
var cMe = ["disabled", "title", "children", "style", "className"];
function JL(e) {
  return typeof e == "string" || typeof e == "number";
}
var lMe = function(t, n) {
  var r = r6e(), i = r.prefixCls, o = r.id, a = r.open, s = r.multiple, c = r.mode, l = r.searchValue, u = r.toggleOpen, d = r.notFoundContent, f = r.onPopupScroll, h = I.useContext(L6), p = h.maxCount, g = h.flattenOptions, m = h.onActiveValue, v = h.defaultActiveFirstOption, y = h.onSelect, S = h.menuItemSelectedIcon, _ = h.rawValues, w = h.fieldNames, T = h.virtual, x = h.direction, C = h.listHeight, E = h.listItemHeight, R = h.optionRender, A = "".concat(i, "-item"), O = oy(function() {
    return g;
  }, [a, g], function(Z, H) {
    return H[0] && Z[1] !== H[1];
  }), $ = I.useRef(null), N = I.useMemo(function() {
    return s && mR(p) && (_ == null ? void 0 : _.size) >= p;
  }, [s, p, _ == null ? void 0 : _.size]), z = function(H) {
    H.preventDefault();
  }, k = function(H) {
    var oe;
    (oe = $.current) === null || oe === void 0 || oe.scrollTo(typeof H == "number" ? {
      index: H
    } : H);
  }, F = function(H) {
    for (var oe = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1, W = O.length, se = 0; se < W; se += 1) {
      var ce = (H + se * oe + W) % W, ge = O[ce] || {}, he = ge.group, ue = ge.data;
      if (!he && !(ue != null && ue.disabled) && !N)
        return ce;
    }
    return -1;
  }, V = I.useState(function() {
    return F(0);
  }), j = fe(V, 2), B = j[0], U = j[1], Q = function(H) {
    var oe = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
    U(H);
    var W = {
      source: oe ? "keyboard" : "mouse"
    }, se = O[H];
    if (!se) {
      m(null, -1, W);
      return;
    }
    m(se.value, H, W);
  };
  gt(function() {
    Q(v !== !1 ? F(0) : -1);
  }, [O.length, l]);
  var K = I.useCallback(function(Z) {
    return c === "combobox" ? !1 : _.has(Z);
  }, [c, Je(_).toString(), _.size]), q = I.useCallback(function(Z) {
    return c === "combobox" ? String(Z).toLowerCase() === l.toLowerCase() : _.has(Z);
  }, [c, l, Je(_).toString(), _.size]);
  gt(function() {
    var Z = setTimeout(function() {
      if (!s && a && _.size === 1) {
        var oe = Array.from(_)[0], W = O.findIndex(function(se) {
          var ce = se.data;
          return ce.value === oe;
        });
        W !== -1 && (Q(W), k(W));
      }
    });
    if (a) {
      var H;
      (H = $.current) === null || H === void 0 || H.scrollTo(void 0);
    }
    return function() {
      return clearTimeout(Z);
    };
  }, [a, l]);
  var X = function(H) {
    H !== void 0 && y(H, {
      selected: !_.has(H)
    }), s || u(!1);
  };
  if (I.useImperativeHandle(n, function() {
    return {
      onKeyDown: function(H) {
        var oe = H.which, W = H.ctrlKey;
        switch (oe) {
          case Ae.N:
          case Ae.P:
          case Ae.UP:
          case Ae.DOWN: {
            var se = 0;
            if (oe === Ae.UP ? se = -1 : oe === Ae.DOWN ? se = 1 : sMe() && W && (oe === Ae.N ? se = 1 : oe === Ae.P && (se = -1)), se !== 0) {
              var ce = F(B + se, se);
              k(ce), Q(ce, !0);
            }
            break;
          }
          case Ae.TAB:
          case Ae.ENTER: {
            var ge, he = O[B];
            he && !(he != null && (ge = he.data) !== null && ge !== void 0 && ge.disabled) && !N ? X(he.value) : X(void 0), a && H.preventDefault();
            break;
          }
          case Ae.ESC:
            u(!1), a && H.stopPropagation();
        }
      },
      onKeyUp: function() {
      },
      scrollTo: function(H) {
        k(H);
      }
    };
  }), O.length === 0)
    return /* @__PURE__ */ I.createElement("div", {
      role: "listbox",
      id: "".concat(o, "_list"),
      className: "".concat(A, "-empty"),
      onMouseDown: z
    }, d);
  var ie = Object.keys(w).map(function(Z) {
    return w[Z];
  }), te = function(H) {
    return H.label;
  };
  function J(Z, H) {
    var oe = Z.group;
    return {
      role: oe ? "presentation" : "option",
      id: "".concat(o, "_list_").concat(H)
    };
  }
  var Y = function(H) {
    var oe = O[H];
    if (!oe)
      return null;
    var W = oe.data || {}, se = W.value, ce = oe.group, ge = cf(W, !0), he = te(oe);
    return oe ? /* @__PURE__ */ I.createElement("div", mt({
      "aria-label": typeof he == "string" && !ce ? he : null
    }, ge, {
      key: H
    }, J(oe, H), {
      "aria-selected": q(se)
    }), se) : null;
  }, ee = {
    role: "listbox",
    id: "".concat(o, "_list")
  };
  return /* @__PURE__ */ I.createElement(I.Fragment, null, T && /* @__PURE__ */ I.createElement("div", mt({}, ee, {
    style: {
      height: 0,
      width: 0,
      overflow: "hidden"
    }
  }), Y(B - 1), Y(B), Y(B + 1)), /* @__PURE__ */ I.createElement(QQ, {
    itemKey: "key",
    ref: $,
    data: O,
    height: C,
    itemHeight: E,
    fullHeight: !1,
    onMouseDown: z,
    onScroll: f,
    virtual: T,
    direction: x,
    innerProps: T ? null : ee
  }, function(Z, H) {
    var oe = Z.group, W = Z.groupOption, se = Z.data, ce = Z.label, ge = Z.value, he = se.key;
    if (oe) {
      var ue, Ee = (ue = se.title) !== null && ue !== void 0 ? ue : JL(ce) ? ce.toString() : void 0;
      return /* @__PURE__ */ I.createElement("div", {
        className: we(A, "".concat(A, "-group"), se.className),
        title: Ee
      }, ce !== void 0 ? ce : he);
    }
    var pe = se.disabled, Oe = se.title;
    se.children;
    var de = se.style, be = se.className, Ie = xn(se, cMe), Ve = Hu(Ie, ie), Fe = K(ge), Pe = pe || !Fe && N, ot = "".concat(A, "-option"), dt = we(A, ot, be, re(re(re(re({}, "".concat(ot, "-grouped"), W), "".concat(ot, "-active"), B === H && !Pe), "".concat(ot, "-disabled"), Pe), "".concat(ot, "-selected"), Fe)), ft = te(Z), wt = !S || typeof S == "function" || Fe, Ge = typeof ft == "number" ? ft : ft || ge, at = JL(Ge) ? Ge.toString() : void 0;
    return Oe !== void 0 && (at = Oe), /* @__PURE__ */ I.createElement("div", mt({}, cf(Ve), T ? {} : J(Z, H), {
      "aria-selected": q(ge),
      className: dt,
      title: at,
      onMouseMove: function() {
        B === H || Pe || Q(H);
      },
      onClick: function() {
        Pe || X(ge);
      },
      style: de
    }), /* @__PURE__ */ I.createElement("div", {
      className: "".concat(ot, "-content")
    }, typeof R == "function" ? R(Z, {
      index: H
    }) : Ge), /* @__PURE__ */ I.isValidElement(S) || Fe, wt && /* @__PURE__ */ I.createElement(sE, {
      className: "".concat(A, "-option-state"),
      customizeIcon: S,
      customizeIconProps: {
        value: ge,
        disabled: Pe,
        isSelected: Fe
      }
    }, Fe ? "✓" : null));
  }));
}, JQ = /* @__PURE__ */ I.forwardRef(lMe);
process.env.NODE_ENV !== "production" && (JQ.displayName = "OptionList");
const uMe = function(e, t) {
  var n = I.useRef({
    values: /* @__PURE__ */ new Map(),
    options: /* @__PURE__ */ new Map()
  }), r = I.useMemo(function() {
    var o = n.current, a = o.values, s = o.options, c = e.map(function(d) {
      if (d.label === void 0) {
        var f;
        return ae(ae({}, d), {}, {
          label: (f = a.get(d.value)) === null || f === void 0 ? void 0 : f.label
        });
      }
      return d;
    }), l = /* @__PURE__ */ new Map(), u = /* @__PURE__ */ new Map();
    return c.forEach(function(d) {
      l.set(d.value, d), u.set(d.value, t.get(d.value) || s.get(d.value));
    }), n.current.values = l, n.current.options = u, c;
  }, [e, t]), i = I.useCallback(function(o) {
    return t.get(o) || n.current.options.get(o);
  }, [t]);
  return [r, i];
};
function K5(e, t) {
  return D6(e).join("").toUpperCase().includes(t);
}
const dMe = function(e, t, n, r, i) {
  return I.useMemo(function() {
    if (!n || r === !1)
      return e;
    var o = t.options, a = t.label, s = t.value, c = [], l = typeof r == "function", u = n.toUpperCase(), d = l ? r : function(h, p) {
      return i ? K5(p[i], u) : p[o] ? K5(p[a !== "children" ? a : "label"], u) : K5(p[s], u);
    }, f = l ? function(h) {
      return vR(h);
    } : function(h) {
      return h;
    };
    return e.forEach(function(h) {
      if (h[o]) {
        var p = d(n, f(h));
        if (p)
          c.push(h);
        else {
          var g = h[o].filter(function(m) {
            return d(n, f(m));
          });
          g.length && c.push(ae(ae({}, h), {}, re({}, o, g)));
        }
        return;
      }
      d(n, f(h)) && c.push(h);
    }), c;
  }, [e, r, i, n, t]);
};
var ZL = 0, fMe = process.env.NODE_ENV !== "test" && ao();
function hMe() {
  var e;
  return fMe ? (e = ZL, ZL += 1) : e = "TEST_OR_SSR", e;
}
function gMe(e) {
  var t = I.useState(), n = fe(t, 2), r = n[0], i = n[1];
  return I.useEffect(function() {
    i("rc_select_".concat(hMe()));
  }, []), e || r;
}
var pMe = ["children", "value"], mMe = ["children"];
function vMe(e) {
  var t = e, n = t.key, r = t.props, i = r.children, o = r.value, a = xn(r, pMe);
  return ae({
    key: n,
    value: o !== void 0 ? o : n,
    children: i
  }, a);
}
function V6(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
  return af(e).map(function(n, r) {
    if (!/* @__PURE__ */ I.isValidElement(n) || !n.type)
      return null;
    var i = n, o = i.type.isSelectOptGroup, a = i.key, s = i.props, c = s.children, l = xn(s, mMe);
    return t || !o ? vMe(n) : ae(ae({
      key: "__RC_SELECT_GRP__".concat(a === null ? r : a, "__"),
      label: a
    }, l), {}, {
      options: V6(c)
    });
  }).filter(function(n) {
    return n;
  });
}
var yMe = function(t, n, r, i, o) {
  return I.useMemo(function() {
    var a = t, s = !t;
    s && (a = V6(n));
    var c = /* @__PURE__ */ new Map(), l = /* @__PURE__ */ new Map(), u = function(h, p, g) {
      g && typeof g == "string" && h.set(p[g], p);
    }, d = function f(h) {
      for (var p = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1, g = 0; g < h.length; g += 1) {
        var m = h[g];
        !m[r.options] || p ? (c.set(m[r.value], m), u(l, m, r.label), u(l, m, i), u(l, m, o)) : f(m[r.options], !0);
      }
    };
    return d(a), {
      options: a,
      valueOptions: c,
      labelOptions: l
    };
  }, [t, n, r, i, o]);
};
function ej(e) {
  var t = I.useRef();
  t.current = e;
  var n = I.useCallback(function() {
    return t.current.apply(t, arguments);
  }, []);
  return n;
}
function bMe(e) {
  var t = e.mode, n = e.options, r = e.children, i = e.backfill, o = e.allowClear, a = e.placeholder, s = e.getInputElement, c = e.showSearch, l = e.onSearch, u = e.defaultOpen, d = e.autoFocus, f = e.labelInValue, h = e.value, p = e.inputValue, g = e.optionLabelProp, m = LS(t), v = c !== void 0 ? c : m || t === "combobox", y = n || V6(r);
  if (an(t !== "tags" || y.every(function(T) {
    return !T.disabled;
  }), "Please avoid setting option to disabled in tags mode since user can always type text as tag."), t === "tags" || t === "combobox") {
    var S = y.some(function(T) {
      return T.options ? T.options.some(function(x) {
        return typeof ("value" in x ? x.value : x.key) == "number";
      }) : typeof ("value" in T ? T.value : T.key) == "number";
    });
    an(!S, "`value` of Option should not use number type when `mode` is `tags` or `combobox`.");
  }
  if (an(t !== "combobox" || !g, "`combobox` mode not support `optionLabelProp`. Please set `value` on Option directly."), an(t === "combobox" || !i, "`backfill` only works with `combobox` mode."), an(t === "combobox" || !s, "`getInputElement` only work with `combobox` mode."), OA(t !== "combobox" || !s || !o || !a, "Customize `getInputElement` should customize clear and placeholder logic instead of configuring `allowClear` and `placeholder`."), l && !v && t !== "combobox" && t !== "tags" && an(!1, "`onSearch` should work with `showSearch` instead of use alone."), OA(!u || d, "`defaultOpen` makes Select open without focus which means it will not close by click outside. You can set `autoFocus` if needed."), h != null) {
    var _ = D6(h);
    an(!f || _.every(function(T) {
      return _t(T) === "object" && ("key" in T || "value" in T);
    }), "`value` should in shape of `{ value: string | number, label?: ReactNode }` when you set `labelInValue` to `true`"), an(!m || Array.isArray(h), "`value` should be array when `mode` is `multiple` or `tags`");
  }
  if (r) {
    var w = null;
    af(r).some(function(T) {
      if (!/* @__PURE__ */ I.isValidElement(T) || !T.type)
        return !1;
      var x = T, C = x.type;
      if (C.isSelectOption)
        return !1;
      if (C.isSelectOptGroup) {
        var E = af(T.props.children).every(function(R) {
          return !/* @__PURE__ */ I.isValidElement(R) || !T.type || R.type.isSelectOption ? !0 : (w = R.type, !1);
        });
        return !E;
      }
      return w = C, !0;
    }), w && an(!1, "`children` should be `Select.Option` or `Select.OptGroup` instead of `".concat(w.displayName || w.name || w, "`.")), an(p === void 0, "`inputValue` is deprecated, please use `searchValue` instead.");
  }
}
function _Me(e, t) {
  if (e) {
    var n = function r(i) {
      for (var o = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1, a = 0; a < i.length; a++) {
        var s = i[a];
        if (s[t == null ? void 0 : t.value] === null)
          return an(!1, "`value` in Select options should not be `null`."), !0;
        if (!o && Array.isArray(s[t == null ? void 0 : t.options]) && r(s[t == null ? void 0 : t.options], !0))
          break;
      }
    };
    n(e);
  }
}
var SMe = ["id", "mode", "prefixCls", "backfill", "fieldNames", "inputValue", "searchValue", "onSearch", "autoClearSearchValue", "onSelect", "onDeselect", "dropdownMatchSelectWidth", "filterOption", "filterSort", "optionFilterProp", "optionLabelProp", "options", "optionRender", "children", "defaultActiveFirstOption", "menuItemSelectedIcon", "virtual", "direction", "listHeight", "listItemHeight", "labelRender", "value", "defaultValue", "labelInValue", "onChange", "maxCount"], wMe = ["inputValue"];
function xMe(e) {
  return !e || _t(e) !== "object";
}
var ZQ = /* @__PURE__ */ I.forwardRef(function(e, t) {
  var n = e.id, r = e.mode, i = e.prefixCls, o = i === void 0 ? "rc-select" : i, a = e.backfill, s = e.fieldNames, c = e.inputValue, l = e.searchValue, u = e.onSearch, d = e.autoClearSearchValue, f = d === void 0 ? !0 : d, h = e.onSelect, p = e.onDeselect, g = e.dropdownMatchSelectWidth, m = g === void 0 ? !0 : g, v = e.filterOption, y = e.filterSort, S = e.optionFilterProp, _ = e.optionLabelProp, w = e.options, T = e.optionRender, x = e.children, C = e.defaultActiveFirstOption, E = e.menuItemSelectedIcon, R = e.virtual, A = e.direction, O = e.listHeight, $ = O === void 0 ? 200 : O, N = e.listItemHeight, z = N === void 0 ? 20 : N, k = e.labelRender, F = e.value, V = e.defaultValue, j = e.labelInValue, B = e.onChange, U = e.maxCount, Q = xn(e, SMe), K = gMe(n), q = LS(r), X = !!(!w && x), ie = I.useMemo(function() {
    return v === void 0 && r === "combobox" ? !1 : v;
  }, [v, r]), te = I.useMemo(
    function() {
      return GQ(s, X);
    },
    /* eslint-disable react-hooks/exhaustive-deps */
    [
      // We stringify fieldNames to avoid unnecessary re-renders.
      JSON.stringify(s),
      X
    ]
    /* eslint-enable react-hooks/exhaustive-deps */
  ), J = hc("", {
    value: l !== void 0 ? l : c,
    postState: function(ze) {
      return ze || "";
    }
  }), Y = fe(J, 2), ee = Y[0], Z = Y[1], H = yMe(w, x, te, S, _), oe = H.valueOptions, W = H.labelOptions, se = H.options, ce = I.useCallback(function(Be) {
    var ze = D6(Be);
    return ze.map(function(it) {
      var lt, Tt, jt, ne, _e;
      if (xMe(it))
        lt = it;
      else {
        var $e;
        jt = it.key, Tt = it.label, lt = ($e = it.value) !== null && $e !== void 0 ? $e : jt;
      }
      var qe = oe.get(lt);
      if (qe) {
        var xt;
        if (Tt === void 0 && (Tt = qe == null ? void 0 : qe[_ || te.label]), jt === void 0 && (jt = (xt = qe == null ? void 0 : qe.key) !== null && xt !== void 0 ? xt : lt), ne = qe == null ? void 0 : qe.disabled, _e = qe == null ? void 0 : qe.title, process.env.NODE_ENV !== "production" && !_) {
          var bt = qe == null ? void 0 : qe[te.label];
          bt !== void 0 && !/* @__PURE__ */ I.isValidElement(bt) && !/* @__PURE__ */ I.isValidElement(Tt) && bt !== Tt && an(!1, "`label` of `value` is not same as `label` in Select options.");
        }
      }
      return {
        label: Tt,
        value: lt,
        key: jt,
        disabled: ne,
        title: _e
      };
    });
  }, [te, _, oe]), ge = hc(V, {
    value: F
  }), he = fe(ge, 2), ue = he[0], Ee = he[1], pe = I.useMemo(function() {
    var Be, ze = q && ue === null ? [] : ue, it = ce(ze);
    return r === "combobox" && w6e((Be = it[0]) === null || Be === void 0 ? void 0 : Be.value) ? [] : it;
  }, [ue, ce, r, q]), Oe = uMe(pe, oe), de = fe(Oe, 2), be = de[0], Ie = de[1], Ve = I.useMemo(function() {
    if (!r && be.length === 1) {
      var Be = be[0];
      if (Be.value === null && (Be.label === null || Be.label === void 0))
        return [];
    }
    return be.map(function(ze) {
      var it;
      return ae(ae({}, ze), {}, {
        label: (it = typeof k == "function" ? k(ze) : ze.label) !== null && it !== void 0 ? it : ze.value
      });
    });
  }, [r, be, k]), Fe = I.useMemo(function() {
    return new Set(be.map(function(Be) {
      return Be.value;
    }));
  }, [be]);
  I.useEffect(function() {
    if (r === "combobox") {
      var Be, ze = (Be = be[0]) === null || Be === void 0 ? void 0 : Be.value;
      Z(S6e(ze) ? String(ze) : "");
    }
  }, [be]);
  var Pe = ej(function(Be, ze) {
    var it = ze ?? Be;
    return re(re({}, te.value, Be), te.label, it);
  }), ot = I.useMemo(function() {
    if (r !== "tags")
      return se;
    var Be = Je(se), ze = function(lt) {
      return oe.has(lt);
    };
    return Je(be).sort(function(it, lt) {
      return it.value < lt.value ? -1 : 1;
    }).forEach(function(it) {
      var lt = it.value;
      ze(lt) || Be.push(Pe(lt, it.label));
    }), Be;
  }, [Pe, se, oe, be, r]), dt = dMe(ot, te, ee, ie, S), ft = I.useMemo(function() {
    return r !== "tags" || !ee || dt.some(function(Be) {
      return Be[S || "value"] === ee;
    }) || dt.some(function(Be) {
      return Be[te.value] === ee;
    }) ? dt : [Pe(ee)].concat(Je(dt));
  }, [Pe, S, r, dt, ee, te]), wt = function Be(ze) {
    var it = Je(ze).sort(function(lt, Tt) {
      return y(lt, Tt, {
        searchValue: ee
      });
    });
    return it.map(function(lt) {
      return Array.isArray(lt.options) ? ae(ae({}, lt), {}, {
        options: lt.options.length > 0 ? Be(lt.options) : lt.options
      }) : lt;
    });
  }, Ge = I.useMemo(function() {
    return y ? wt(ft) : ft;
  }, [ft, y, ee]), at = I.useMemo(function() {
    return B6e(Ge, {
      fieldNames: te,
      childrenAsData: X
    });
  }, [Ge, te, X]), Nt = function(ze) {
    var it = ce(ze);
    if (Ee(it), B && // Trigger event only when value changed
    (it.length !== be.length || it.some(function(jt, ne) {
      var _e;
      return ((_e = be[ne]) === null || _e === void 0 ? void 0 : _e.value) !== (jt == null ? void 0 : jt.value);
    }))) {
      var lt = j ? it : it.map(function(jt) {
        return jt.value;
      }), Tt = it.map(function(jt) {
        return vR(Ie(jt.value));
      });
      B(
        // Value
        q ? lt : lt[0],
        // Option
        q ? Tt : Tt[0]
      );
    }
  }, zt = I.useState(null), kt = fe(zt, 2), Ct = kt[0], yt = kt[1], Mn = I.useState(0), Pt = fe(Mn, 2), Ze = Pt[0], Le = Pt[1], rt = C !== void 0 ? C : r !== "combobox", ut = I.useCallback(function(Be, ze) {
    var it = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, lt = it.source, Tt = lt === void 0 ? "keyboard" : lt;
    Le(ze), a && r === "combobox" && Be !== null && Tt === "keyboard" && yt(String(Be));
  }, [a, r]), vt = function(ze, it, lt) {
    var Tt = function() {
      var Ke, ke = Ie(ze);
      return [j ? {
        label: ke == null ? void 0 : ke[te.label],
        value: ze,
        key: (Ke = ke == null ? void 0 : ke.key) !== null && Ke !== void 0 ? Ke : ze
      } : ze, vR(ke)];
    };
    if (it && h) {
      var jt = Tt(), ne = fe(jt, 2), _e = ne[0], $e = ne[1];
      h(_e, $e);
    } else if (!it && p && lt !== "clear") {
      var qe = Tt(), xt = fe(qe, 2), bt = xt[0], st = xt[1];
      p(bt, st);
    }
  }, We = ej(function(Be, ze) {
    var it, lt = q ? ze.selected : !0;
    lt ? it = q ? [].concat(Je(be), [Be]) : [Be] : it = be.filter(function(Tt) {
      return Tt.value !== Be;
    }), Nt(it), vt(Be, lt), r === "combobox" ? yt("") : (!LS || f) && (Z(""), yt(""));
  }), et = function(ze, it) {
    Nt(ze);
    var lt = it.type, Tt = it.values;
    (lt === "remove" || lt === "clear") && Tt.forEach(function(jt) {
      vt(jt.value, !1, lt);
    });
  }, Ne = function(ze, it) {
    if (Z(ze), yt(null), it.source === "submit") {
      var lt = (ze || "").trim();
      if (lt) {
        var Tt = Array.from(new Set([].concat(Je(Fe), [lt])));
        Nt(Tt), vt(lt, !0), Z("");
      }
      return;
    }
    it.source !== "blur" && (r === "combobox" && Nt(ze), u == null || u(ze));
  }, Yt = function(ze) {
    var it = ze;
    r !== "tags" && (it = ze.map(function(Tt) {
      var jt = W.get(Tt);
      return jt == null ? void 0 : jt.value;
    }).filter(function(Tt) {
      return Tt !== void 0;
    }));
    var lt = Array.from(new Set([].concat(Je(Fe), Je(it))));
    Nt(lt), lt.forEach(function(Tt) {
      vt(Tt, !0);
    });
  }, Ht = I.useMemo(function() {
    var Be = R !== !1 && m !== !1;
    return ae(ae({}, H), {}, {
      flattenOptions: at,
      onActiveValue: ut,
      defaultActiveFirstOption: rt,
      onSelect: We,
      menuItemSelectedIcon: E,
      rawValues: Fe,
      fieldNames: te,
      virtual: Be,
      direction: A,
      listHeight: $,
      listItemHeight: z,
      childrenAsData: X,
      maxCount: U,
      optionRender: T
    });
  }, [U, H, at, ut, rt, We, E, Fe, te, R, m, A, $, z, X, T]);
  return process.env.NODE_ENV !== "production" && (bMe(e), _Me(se, te)), /* @__PURE__ */ I.createElement(L6.Provider, {
    value: Ht
  }, /* @__PURE__ */ I.createElement(KQ, mt({}, Q, {
    // >>> MISC
    id: K,
    prefixCls: o,
    ref: t,
    omitDomProps: wMe,
    mode: r,
    displayValues: Ve,
    onDisplayValuesChange: et,
    direction: A,
    searchValue: ee,
    onSearch: Ne,
    autoClearSearchValue: f,
    onSearchSplit: Yt,
    dropdownMatchSelectWidth: m,
    OptionList: JQ,
    emptyOptions: !at.length,
    activeValue: Ct,
    activeDescendantId: "".concat(K, "_list_").concat(Ze)
  })));
});
process.env.NODE_ENV !== "production" && (ZQ.displayName = "Select");
var B6 = ZQ;
B6.Option = F6;
B6.OptGroup = j6;
function Lg(e, t, n) {
  return we({
    [`${e}-status-success`]: t === "success",
    [`${e}-status-warning`]: t === "warning",
    [`${e}-status-error`]: t === "error",
    [`${e}-status-validating`]: t === "validating",
    [`${e}-has-feedback`]: n
  });
}
const fy = (e, t) => t || e, eJ = () => {
  const [, e] = $s(), [t] = h6("Empty"), r = new Pn(e.colorBgBase).toHsl().l < 0.5 ? {
    opacity: 0.65
  } : {};
  return /* @__PURE__ */ I.createElement("svg", {
    style: r,
    width: "184",
    height: "152",
    viewBox: "0 0 184 152",
    xmlns: "http://www.w3.org/2000/svg"
  }, /* @__PURE__ */ I.createElement("title", null, (t == null ? void 0 : t.description) || "Empty"), /* @__PURE__ */ I.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /* @__PURE__ */ I.createElement("g", {
    transform: "translate(24 31.67)"
  }, /* @__PURE__ */ I.createElement("ellipse", {
    fillOpacity: ".8",
    fill: "#F5F5F7",
    cx: "67.797",
    cy: "106.89",
    rx: "67.797",
    ry: "12.668"
  }), /* @__PURE__ */ I.createElement("path", {
    d: "M122.034 69.674L98.109 40.229c-1.148-1.386-2.826-2.225-4.593-2.225h-51.44c-1.766 0-3.444.839-4.592 2.225L13.56 69.674v15.383h108.475V69.674z",
    fill: "#AEB8C2"
  }), /* @__PURE__ */ I.createElement("path", {
    d: "M101.537 86.214L80.63 61.102c-1.001-1.207-2.507-1.867-4.048-1.867H31.724c-1.54 0-3.047.66-4.048 1.867L6.769 86.214v13.792h94.768V86.214z",
    fill: "url(#linearGradient-1)",
    transform: "translate(13.56)"
  }), /* @__PURE__ */ I.createElement("path", {
    d: "M33.83 0h67.933a4 4 0 0 1 4 4v93.344a4 4 0 0 1-4 4H33.83a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4z",
    fill: "#F5F5F7"
  }), /* @__PURE__ */ I.createElement("path", {
    d: "M42.678 9.953h50.237a2 2 0 0 1 2 2V36.91a2 2 0 0 1-2 2H42.678a2 2 0 0 1-2-2V11.953a2 2 0 0 1 2-2zM42.94 49.767h49.713a2.262 2.262 0 1 1 0 4.524H42.94a2.262 2.262 0 0 1 0-4.524zM42.94 61.53h49.713a2.262 2.262 0 1 1 0 4.525H42.94a2.262 2.262 0 0 1 0-4.525zM121.813 105.032c-.775 3.071-3.497 5.36-6.735 5.36H20.515c-3.238 0-5.96-2.29-6.734-5.36a7.309 7.309 0 0 1-.222-1.79V69.675h26.318c2.907 0 5.25 2.448 5.25 5.42v.04c0 2.971 2.37 5.37 5.277 5.37h34.785c2.907 0 5.277-2.421 5.277-5.393V75.1c0-2.972 2.343-5.426 5.25-5.426h26.318v33.569c0 .617-.077 1.216-.221 1.789z",
    fill: "#DCE0E6"
  })), /* @__PURE__ */ I.createElement("path", {
    d: "M149.121 33.292l-6.83 2.65a1 1 0 0 1-1.317-1.23l1.937-6.207c-2.589-2.944-4.109-6.534-4.109-10.408C138.802 8.102 148.92 0 161.402 0 173.881 0 184 8.102 184 18.097c0 9.995-10.118 18.097-22.599 18.097-4.528 0-8.744-1.066-12.28-2.902z",
    fill: "#DCE0E6"
  }), /* @__PURE__ */ I.createElement("g", {
    transform: "translate(149.65 15.383)",
    fill: "#FFF"
  }, /* @__PURE__ */ I.createElement("ellipse", {
    cx: "20.654",
    cy: "3.167",
    rx: "2.849",
    ry: "2.815"
  }), /* @__PURE__ */ I.createElement("path", {
    d: "M5.698 5.63H0L2.898.704zM9.259.704h4.985V5.63H9.259z"
  }))));
};
process.env.NODE_ENV !== "production" && (eJ.displayName = "EmptyImage");
const EMe = eJ, tJ = () => {
  const [, e] = $s(), [t] = h6("Empty"), {
    colorFill: n,
    colorFillTertiary: r,
    colorFillQuaternary: i,
    colorBgContainer: o
  } = e, {
    borderColor: a,
    shadowColor: s,
    contentColor: c
  } = At(() => ({
    borderColor: new Pn(n).onBackground(o).toHexShortString(),
    shadowColor: new Pn(r).onBackground(o).toHexShortString(),
    contentColor: new Pn(i).onBackground(o).toHexShortString()
  }), [n, r, i, o]);
  return /* @__PURE__ */ I.createElement("svg", {
    width: "64",
    height: "41",
    viewBox: "0 0 64 41",
    xmlns: "http://www.w3.org/2000/svg"
  }, /* @__PURE__ */ I.createElement("title", null, (t == null ? void 0 : t.description) || "Empty"), /* @__PURE__ */ I.createElement("g", {
    transform: "translate(0 1)",
    fill: "none",
    fillRule: "evenodd"
  }, /* @__PURE__ */ I.createElement("ellipse", {
    fill: s,
    cx: "32",
    cy: "33",
    rx: "32",
    ry: "7"
  }), /* @__PURE__ */ I.createElement("g", {
    fillRule: "nonzero",
    stroke: a
  }, /* @__PURE__ */ I.createElement("path", {
    d: "M55 12.76L44.854 1.258C44.367.474 43.656 0 42.907 0H21.093c-.749 0-1.46.474-1.947 1.257L9 12.761V22h46v-9.24z"
  }), /* @__PURE__ */ I.createElement("path", {
    d: "M41.613 15.931c0-1.605.994-2.93 2.227-2.931H55v18.137C55 33.26 53.68 35 52.05 35h-40.1C10.32 35 9 33.259 9 31.137V13h11.16c1.233 0 2.227 1.323 2.227 2.928v.022c0 1.605 1.005 2.901 2.237 2.901h14.752c1.232 0 2.237-1.308 2.237-2.913v-.007z",
    fill: c
  }))));
};
process.env.NODE_ENV !== "production" && (tJ.displayName = "SimpleImage");
const CMe = tJ, TMe = (e) => {
  const {
    componentCls: t,
    margin: n,
    marginXS: r,
    marginXL: i,
    fontSize: o,
    lineHeight: a
  } = e;
  return {
    [t]: {
      marginInline: r,
      fontSize: o,
      lineHeight: a,
      textAlign: "center",
      // 原来 &-image 没有父子结构，现在为了外层承担我们的 hashId，改成父子结构
      [`${t}-image`]: {
        height: e.emptyImgHeight,
        marginBottom: r,
        opacity: e.opacityImage,
        img: {
          height: "100%"
        },
        svg: {
          maxWidth: "100%",
          height: "100%",
          margin: "auto"
        }
      },
      [`${t}-description`]: {
        color: e.colorTextDescription
      },
      // 原来 &-footer 没有父子结构，现在为了外层承担我们的 hashId，改成父子结构
      [`${t}-footer`]: {
        marginTop: n
      },
      "&-normal": {
        marginBlock: i,
        color: e.colorTextDescription,
        [`${t}-description`]: {
          color: e.colorTextDescription
        },
        [`${t}-image`]: {
          height: e.emptyImgHeightMD
        }
      },
      "&-small": {
        marginBlock: r,
        color: e.colorTextDescription,
        [`${t}-image`]: {
          height: e.emptyImgHeightSM
        }
      }
    }
  };
}, IMe = qa("Empty", (e) => {
  const {
    componentCls: t,
    controlHeightLG: n,
    calc: r
  } = e, i = Or(e, {
    emptyImgCls: `${t}-img`,
    emptyImgHeight: r(n).mul(2.5).equal(),
    emptyImgHeightMD: n,
    emptyImgHeightSM: r(n).mul(0.875).equal()
  });
  return [TMe(i)];
});
var AMe = globalThis && globalThis.__rest || function(e, t) {
  var n = {};
  for (var r in e)
    Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var i = 0, r = Object.getOwnPropertySymbols(e); i < r.length; i++)
      t.indexOf(r[i]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[i]) && (n[r[i]] = e[r[i]]);
  return n;
};
const nJ = /* @__PURE__ */ I.createElement(EMe, null), rJ = /* @__PURE__ */ I.createElement(CMe, null), cE = (e) => {
  var {
    className: t,
    rootClassName: n,
    prefixCls: r,
    image: i = nJ,
    description: o,
    children: a,
    imageStyle: s,
    style: c
  } = e, l = AMe(e, ["className", "rootClassName", "prefixCls", "image", "description", "children", "imageStyle", "style"]);
  const {
    getPrefixCls: u,
    direction: d,
    empty: f
  } = I.useContext(En), h = u("empty", r), [p, g, m] = IMe(h), [v] = h6("Empty"), y = typeof o < "u" ? o : v == null ? void 0 : v.description, S = typeof y == "string" ? y : "empty";
  let _ = null;
  return typeof i == "string" ? _ = /* @__PURE__ */ I.createElement("img", {
    alt: S,
    src: i
  }) : _ = i, p(/* @__PURE__ */ I.createElement("div", Object.assign({
    className: we(g, m, h, f == null ? void 0 : f.className, {
      [`${h}-normal`]: i === rJ,
      [`${h}-rtl`]: d === "rtl"
    }, t, n),
    style: Object.assign(Object.assign({}, f == null ? void 0 : f.style), c)
  }, l), /* @__PURE__ */ I.createElement("div", {
    className: `${h}-image`,
    style: s
  }, _), y && /* @__PURE__ */ I.createElement("div", {
    className: `${h}-description`
  }, y), a && /* @__PURE__ */ I.createElement("div", {
    className: `${h}-footer`
  }, a)));
};
cE.PRESENTED_IMAGE_DEFAULT = nJ;
cE.PRESENTED_IMAGE_SIMPLE = rJ;
process.env.NODE_ENV !== "production" && (cE.displayName = "Empty");
const gm = cE, RMe = (e) => {
  const {
    componentName: t
  } = e, {
    getPrefixCls: n
  } = St(En), r = n("empty");
  switch (t) {
    case "Table":
    case "List":
      return /* @__PURE__ */ D.createElement(gm, {
        image: gm.PRESENTED_IMAGE_SIMPLE
      });
    case "Select":
    case "TreeSelect":
    case "Cascader":
    case "Transfer":
    case "Mentions":
      return /* @__PURE__ */ D.createElement(gm, {
        image: gm.PRESENTED_IMAGE_SIMPLE,
        className: `${r}-small`
      });
    case "Table.filter":
      return null;
    default:
      return /* @__PURE__ */ D.createElement(gm, null);
  }
}, $Me = RMe, OMe = function(e, t) {
  let n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : void 0;
  var r, i;
  const {
    variant: o,
    [e]: a
  } = St(En), s = St(wPe), c = a == null ? void 0 : a.variant;
  let l;
  typeof t < "u" ? l = t : n === !1 ? l = "borderless" : l = (i = (r = s ?? c) !== null && r !== void 0 ? r : o) !== null && i !== void 0 ? i : "outlined";
  const u = WTe.includes(l);
  return [l, u];
}, lE = OMe, PMe = (e) => {
  const n = {
    overflow: {
      adjustX: !0,
      adjustY: !0,
      shiftY: !0
    },
    htmlRegion: e === "scroll" ? "scroll" : "visible",
    dynamicInset: !0
  };
  return {
    bottomLeft: Object.assign(Object.assign({}, n), {
      points: ["tl", "bl"],
      offset: [0, 4]
    }),
    bottomRight: Object.assign(Object.assign({}, n), {
      points: ["tr", "br"],
      offset: [0, 4]
    }),
    topLeft: Object.assign(Object.assign({}, n), {
      points: ["bl", "tl"],
      offset: [0, -4]
    }),
    topRight: Object.assign(Object.assign({}, n), {
      points: ["br", "tr"],
      offset: [0, -4]
    })
  };
};
function MMe(e, t) {
  return e || PMe(t);
}
const tj = (e) => {
  const {
    optionHeight: t,
    optionFontSize: n,
    optionLineHeight: r,
    optionPadding: i
  } = e;
  return {
    position: "relative",
    display: "block",
    minHeight: t,
    padding: i,
    color: e.colorText,
    fontWeight: "normal",
    fontSize: n,
    lineHeight: r,
    boxSizing: "border-box"
  };
}, kMe = (e) => {
  const {
    antCls: t,
    componentCls: n
  } = e, r = `${n}-item`, i = `&${t}-slide-up-enter${t}-slide-up-enter-active`, o = `&${t}-slide-up-appear${t}-slide-up-appear-active`, a = `&${t}-slide-up-leave${t}-slide-up-leave-active`, s = `${n}-dropdown-placement-`;
  return [
    {
      [`${n}-dropdown`]: Object.assign(Object.assign({}, va(e)), {
        position: "absolute",
        top: -9999,
        zIndex: e.zIndexPopup,
        boxSizing: "border-box",
        padding: e.paddingXXS,
        overflow: "hidden",
        fontSize: e.fontSize,
        // Fix select render lag of long text in chrome
        // https://github.com/ant-design/ant-design/issues/11456
        // https://github.com/ant-design/ant-design/issues/11843
        fontVariant: "initial",
        backgroundColor: e.colorBgElevated,
        borderRadius: e.borderRadiusLG,
        outline: "none",
        boxShadow: e.boxShadowSecondary,
        [`
          ${i}${s}bottomLeft,
          ${o}${s}bottomLeft
        `]: {
          animationName: bQ
        },
        [`
          ${i}${s}topLeft,
          ${o}${s}topLeft,
          ${i}${s}topRight,
          ${o}${s}topRight
        `]: {
          animationName: SQ
        },
        [`${a}${s}bottomLeft`]: {
          animationName: _Q
        },
        [`
          ${a}${s}topLeft,
          ${a}${s}topRight
        `]: {
          animationName: wQ
        },
        "&-hidden": {
          display: "none"
        },
        [r]: Object.assign(Object.assign({}, tj(e)), {
          cursor: "pointer",
          transition: `background ${e.motionDurationSlow} ease`,
          borderRadius: e.borderRadiusSM,
          // =========== Group ============
          "&-group": {
            color: e.colorTextDescription,
            fontSize: e.fontSizeSM,
            cursor: "default"
          },
          // =========== Option ===========
          "&-option": {
            display: "flex",
            "&-content": Object.assign({
              flex: "auto"
            }, YA),
            "&-state": {
              flex: "none",
              display: "flex",
              alignItems: "center"
            },
            [`&-active:not(${r}-option-disabled)`]: {
              backgroundColor: e.optionActiveBg
            },
            [`&-selected:not(${r}-option-disabled)`]: {
              color: e.optionSelectedColor,
              fontWeight: e.optionSelectedFontWeight,
              backgroundColor: e.optionSelectedBg,
              [`${r}-option-state`]: {
                color: e.colorPrimary
              },
              [`&:has(+ ${r}-option-selected:not(${r}-option-disabled))`]: {
                borderEndStartRadius: 0,
                borderEndEndRadius: 0,
                [`& + ${r}-option-selected:not(${r}-option-disabled)`]: {
                  borderStartStartRadius: 0,
                  borderStartEndRadius: 0
                }
              }
            },
            "&-disabled": {
              [`&${r}-option-selected`]: {
                backgroundColor: e.colorBgContainerDisabled
              },
              color: e.colorTextDisabled,
              cursor: "not-allowed"
            },
            "&-grouped": {
              paddingInlineStart: e.calc(e.controlPaddingHorizontal).mul(2).equal()
            }
          },
          "&-empty": Object.assign(Object.assign({}, tj(e)), {
            color: e.colorTextDisabled
          })
        }),
        // =========================== RTL ===========================
        "&-rtl": {
          direction: "rtl"
        }
      })
    },
    // Follow code may reuse in other components
    pL(e, "slide-up"),
    pL(e, "slide-down"),
    gL(e, "move-up"),
    gL(e, "move-down")
  ];
}, NMe = kMe, DMe = (e) => {
  const {
    multipleSelectItemHeight: t,
    paddingXXS: n,
    lineWidth: r,
    INTERNAL_FIXED_ITEM_MARGIN: i
  } = e, o = e.max(e.calc(n).sub(r).equal(), 0), a = e.max(e.calc(o).sub(i).equal(), 0);
  return {
    basePadding: o,
    containerPadding: a,
    itemHeight: Qe(t),
    itemLineHeight: Qe(e.calc(t).sub(e.calc(e.lineWidth).mul(2)).equal())
  };
}, LMe = (e) => {
  const {
    multipleSelectItemHeight: t,
    selectHeight: n,
    lineWidth: r
  } = e;
  return e.calc(n).sub(t).div(2).sub(r).equal();
}, jMe = (e) => {
  const {
    componentCls: t,
    iconCls: n,
    borderRadiusSM: r,
    motionDurationSlow: i,
    paddingXS: o,
    multipleItemColorDisabled: a,
    multipleItemBorderColorDisabled: s,
    colorIcon: c,
    colorIconHover: l,
    INTERNAL_FIXED_ITEM_MARGIN: u
  } = e;
  return {
    /**
     * Do not merge `height` & `line-height` under style with `selection` & `search`, since chrome
     * may update to redesign with its align logic.
     */
    // =========================== Overflow ===========================
    [`${t}-selection-overflow`]: {
      position: "relative",
      display: "flex",
      flex: "auto",
      flexWrap: "wrap",
      maxWidth: "100%",
      "&-item": {
        flex: "none",
        alignSelf: "center",
        maxWidth: "100%",
        display: "inline-flex"
      },
      // ======================== Selections ==========================
      [`${t}-selection-item`]: {
        display: "flex",
        alignSelf: "center",
        flex: "none",
        boxSizing: "border-box",
        maxWidth: "100%",
        marginBlock: u,
        borderRadius: r,
        cursor: "default",
        transition: `font-size ${i}, line-height ${i}, height ${i}`,
        marginInlineEnd: e.calc(u).mul(2).equal(),
        paddingInlineStart: o,
        paddingInlineEnd: e.calc(o).div(2).equal(),
        [`${t}-disabled&`]: {
          color: a,
          borderColor: s,
          cursor: "not-allowed"
        },
        // It's ok not to do this, but 24px makes bottom narrow in view should adjust
        "&-content": {
          display: "inline-block",
          marginInlineEnd: e.calc(o).div(2).equal(),
          overflow: "hidden",
          whiteSpace: "pre",
          // fix whitespace wrapping. custom tags display all whitespace within.
          textOverflow: "ellipsis"
        },
        "&-remove": Object.assign(Object.assign({}, Yx()), {
          display: "inline-flex",
          alignItems: "center",
          color: c,
          fontWeight: "bold",
          fontSize: 10,
          lineHeight: "inherit",
          cursor: "pointer",
          [`> ${n}`]: {
            verticalAlign: "-0.2em"
          },
          "&:hover": {
            color: l
          }
        })
      }
    }
  };
}, FMe = (e, t) => {
  const {
    componentCls: n,
    INTERNAL_FIXED_ITEM_MARGIN: r
  } = e, i = `${n}-selection-overflow`, o = e.multipleSelectItemHeight, a = LMe(e), s = t ? `${n}-${t}` : "", c = DMe(e);
  return {
    [`${n}-multiple${s}`]: Object.assign(Object.assign({}, jMe(e)), {
      // ========================= Selector =========================
      [`${n}-selector`]: {
        display: "flex",
        alignItems: "center",
        width: "100%",
        height: "100%",
        // Multiple is little different that horizontal is follow the vertical
        paddingInline: c.basePadding,
        paddingBlock: c.containerPadding,
        borderRadius: e.borderRadius,
        [`${n}-disabled&`]: {
          background: e.multipleSelectorBgDisabled,
          cursor: "not-allowed"
        },
        "&:after": {
          display: "inline-block",
          width: 0,
          margin: `${Qe(r)} 0`,
          lineHeight: Qe(o),
          visibility: "hidden",
          content: '"\\a0"'
        }
      },
      [`${n}-selection-wrap`]: {
        width: "100%",
        overflow: "hidden"
      },
      // ======================== Selections ========================
      [`${n}-selection-item`]: {
        height: c.itemHeight,
        lineHeight: Qe(c.itemLineHeight)
      },
      // ========================== Input ==========================
      [`${i}-item + ${i}-item`]: {
        [`${n}-selection-search`]: {
          marginInlineStart: 0
        }
      },
      // https://github.com/ant-design/ant-design/issues/44754
      [`${i}-item-suffix`]: {
        height: "100%"
      },
      [`${n}-selection-search`]: {
        display: "inline-flex",
        position: "relative",
        maxWidth: "100%",
        marginInlineStart: e.calc(e.inputPaddingHorizontalBase).sub(a).equal(),
        "\n          &-input,\n          &-mirror\n        ": {
          height: o,
          fontFamily: e.fontFamily,
          lineHeight: Qe(o),
          transition: `all ${e.motionDurationSlow}`
        },
        "&-input": {
          width: "100%",
          minWidth: 4.1
          // fix search cursor missing
        },
        "&-mirror": {
          position: "absolute",
          top: 0,
          insetInlineStart: 0,
          insetInlineEnd: "auto",
          zIndex: 999,
          whiteSpace: "pre",
          // fix whitespace wrapping caused width calculation bug
          visibility: "hidden"
        }
      },
      // ======================= Placeholder =======================
      [`${n}-selection-placeholder`]: {
        position: "absolute",
        top: "50%",
        insetInlineStart: e.inputPaddingHorizontalBase,
        insetInlineEnd: e.inputPaddingHorizontalBase,
        transform: "translateY(-50%)",
        transition: `all ${e.motionDurationSlow}`
      },
      [`${n}-prefix`]: {
        height: c.itemHeight,
        lineHeight: Qe(c.itemLineHeight),
        marginInlineStart: `calc(${Qe(e.inputPaddingHorizontalBase)} - ${Qe(c.basePadding)})`,
        marginInlineEnd: e.selectAffixPadding
      }
    })
  };
};
function Y5(e, t) {
  const {
    componentCls: n
  } = e, r = t ? `${n}-${t}` : "", i = {
    [`${n}-multiple${r}`]: {
      fontSize: e.fontSize,
      // ========================= Selector =========================
      [`${n}-selector`]: {
        [`${n}-show-search&`]: {
          cursor: "text"
        }
      },
      [`
        &${n}-show-arrow ${n}-selector,
        &${n}-allow-clear ${n}-selector
      `]: {
        paddingInlineEnd: e.calc(e.fontSizeIcon).add(e.controlPaddingHorizontal).equal()
      }
    }
  };
  return [FMe(e, t), i];
}
const VMe = (e) => {
  const {
    componentCls: t
  } = e, n = Or(e, {
    selectHeight: e.controlHeightSM,
    multipleSelectItemHeight: e.multipleItemHeightSM,
    borderRadius: e.borderRadiusSM,
    borderRadiusSM: e.borderRadiusXS
  }), r = Or(e, {
    fontSize: e.fontSizeLG,
    selectHeight: e.controlHeightLG,
    multipleSelectItemHeight: e.multipleItemHeightLG,
    borderRadius: e.borderRadiusLG,
    borderRadiusSM: e.borderRadius
  });
  return [
    Y5(e),
    // ======================== Small ========================
    Y5(n, "sm"),
    // Padding
    {
      [`${t}-multiple${t}-sm`]: {
        [`${t}-selection-placeholder`]: {
          insetInline: e.calc(e.controlPaddingHorizontalSM).sub(e.lineWidth).equal()
        },
        // https://github.com/ant-design/ant-design/issues/29559
        [`${t}-selection-search`]: {
          marginInlineStart: 2
          // Magic Number
        }
      }
    },
    // ======================== Large ========================
    Y5(r, "lg")
  ];
}, BMe = VMe;
function X5(e, t) {
  const {
    componentCls: n,
    inputPaddingHorizontalBase: r,
    borderRadius: i,
    selectAffixPadding: o
  } = e, a = e.calc(e.controlHeight).sub(e.calc(e.lineWidth).mul(2)).equal(), s = t ? `${n}-${t}` : "";
  return {
    [`${n}-single${s}`]: {
      fontSize: e.fontSize,
      height: e.controlHeight,
      // ========================= Selector =========================
      [`${n}-selector`]: Object.assign(Object.assign({}, va(e, !0)), {
        display: "flex",
        borderRadius: i,
        flex: "1 1 auto",
        [`${n}-selection-wrap`]: {
          display: "flex",
          width: "100%",
          position: "relative"
        },
        [`${n}-selection-search`]: {
          position: "absolute",
          inset: 0,
          width: "100%",
          "&-input": {
            width: "100%",
            WebkitAppearance: "textfield"
          }
        },
        [`
          ${n}-selection-item,
          ${n}-selection-placeholder,
          ${n}-prefix
        `]: {
          display: "block",
          padding: 0,
          lineHeight: Qe(a),
          transition: `all ${e.motionDurationSlow}, visibility 0s`,
          alignSelf: "center"
        },
        [`${n}-selection-placeholder`]: {
          transition: "none",
          pointerEvents: "none"
        },
        [`${n}-prefix`]: {
          marginInlineEnd: o
        },
        // For common baseline align
        [[
          "&:after",
          /* For '' value baseline align */
          `${n}-selection-item:empty:after`,
          /* For undefined value baseline align */
          `${n}-selection-placeholder:empty:after`
        ].join(",")]: {
          display: "inline-block",
          width: 0,
          visibility: "hidden",
          content: '"\\a0"'
        }
      }),
      [`
        &${n}-show-arrow ${n}-selection-item,
        &${n}-show-arrow ${n}-selection-search,
        &${n}-show-arrow ${n}-selection-placeholder
      `]: {
        paddingInlineEnd: e.showArrowPaddingInlineEnd
      },
      // Opacity selection if open
      [`&${n}-open ${n}-selection-item`]: {
        color: e.colorTextPlaceholder
      },
      // ========================== Input ==========================
      // We only change the style of non-customize input which is only support by `combobox` mode.
      // Not customize
      [`&:not(${n}-customize-input)`]: {
        [`${n}-selector`]: {
          width: "100%",
          height: "100%",
          padding: `0 ${Qe(r)}`,
          [`${n}-selection-search-input`]: {
            height: a
          },
          "&:after": {
            lineHeight: Qe(a)
          }
        }
      },
      [`&${n}-customize-input`]: {
        [`${n}-selector`]: {
          "&:after": {
            display: "none"
          },
          [`${n}-selection-search`]: {
            position: "static",
            width: "100%"
          },
          [`${n}-selection-placeholder`]: {
            position: "absolute",
            insetInlineStart: 0,
            insetInlineEnd: 0,
            padding: `0 ${Qe(r)}`,
            "&:after": {
              display: "none"
            }
          }
        }
      }
    }
  };
}
function zMe(e) {
  const {
    componentCls: t
  } = e, n = e.calc(e.controlPaddingHorizontalSM).sub(e.lineWidth).equal();
  return [
    X5(e),
    // ======================== Small ========================
    // Shared
    X5(Or(e, {
      controlHeight: e.controlHeightSM,
      borderRadius: e.borderRadiusSM
    }), "sm"),
    // padding
    {
      [`${t}-single${t}-sm`]: {
        [`&:not(${t}-customize-input)`]: {
          [`${t}-selector`]: {
            padding: `0 ${Qe(n)}`
          },
          // With arrow should provides `padding-right` to show the arrow
          [`&${t}-show-arrow ${t}-selection-search`]: {
            insetInlineEnd: e.calc(n).add(e.calc(e.fontSize).mul(1.5)).equal()
          },
          [`
            &${t}-show-arrow ${t}-selection-item,
            &${t}-show-arrow ${t}-selection-placeholder
          `]: {
            paddingInlineEnd: e.calc(e.fontSize).mul(1.5).equal()
          }
        }
      }
    },
    // ======================== Large ========================
    // Shared
    X5(Or(e, {
      controlHeight: e.singleItemHeightLG,
      fontSize: e.fontSizeLG,
      borderRadius: e.borderRadiusLG
    }), "lg")
  ];
}
const HMe = (e) => {
  const {
    fontSize: t,
    lineHeight: n,
    lineWidth: r,
    controlHeight: i,
    controlHeightSM: o,
    controlHeightLG: a,
    paddingXXS: s,
    controlPaddingHorizontal: c,
    zIndexPopupBase: l,
    colorText: u,
    fontWeightStrong: d,
    controlItemBgActive: f,
    controlItemBgHover: h,
    colorBgContainer: p,
    colorFillSecondary: g,
    colorBgContainerDisabled: m,
    colorTextDisabled: v,
    colorPrimaryHover: y,
    colorPrimary: S,
    controlOutline: _
  } = e, w = s * 2, T = r * 2, x = Math.min(i - w, i - T), C = Math.min(o - w, o - T), E = Math.min(a - w, a - T);
  return {
    INTERNAL_FIXED_ITEM_MARGIN: Math.floor(s / 2),
    zIndexPopup: l + 50,
    optionSelectedColor: u,
    optionSelectedFontWeight: d,
    optionSelectedBg: f,
    optionActiveBg: h,
    optionPadding: `${(i - t * n) / 2}px ${c}px`,
    optionFontSize: t,
    optionLineHeight: n,
    optionHeight: i,
    selectorBg: p,
    clearBg: p,
    singleItemHeightLG: a,
    multipleItemBg: g,
    multipleItemBorderColor: "transparent",
    multipleItemHeight: x,
    multipleItemHeightSM: C,
    multipleItemHeightLG: E,
    multipleSelectorBgDisabled: m,
    multipleItemColorDisabled: v,
    multipleItemBorderColorDisabled: "transparent",
    showArrowPaddingInlineEnd: Math.ceil(e.fontSize * 1.25),
    hoverBorderColor: y,
    activeBorderColor: S,
    activeOutlineColor: _,
    selectAffixPadding: s
  };
}, iJ = (e, t) => {
  const {
    componentCls: n,
    antCls: r,
    controlOutlineWidth: i
  } = e;
  return {
    [`&:not(${n}-customize-input) ${n}-selector`]: {
      border: `${Qe(e.lineWidth)} ${e.lineType} ${t.borderColor}`,
      background: e.selectorBg
    },
    [`&:not(${n}-disabled):not(${n}-customize-input):not(${r}-pagination-size-changer)`]: {
      [`&:hover ${n}-selector`]: {
        borderColor: t.hoverBorderHover
      },
      [`${n}-focused& ${n}-selector`]: {
        borderColor: t.activeBorderColor,
        boxShadow: `0 0 0 ${Qe(i)} ${t.activeOutlineColor}`,
        outline: 0
      }
    }
  };
}, nj = (e, t) => ({
  [`&${e.componentCls}-status-${t.status}`]: Object.assign({}, iJ(e, t))
}), UMe = (e) => ({
  "&-outlined": Object.assign(Object.assign(Object.assign(Object.assign({}, iJ(e, {
    borderColor: e.colorBorder,
    hoverBorderHover: e.hoverBorderColor,
    activeBorderColor: e.activeBorderColor,
    activeOutlineColor: e.activeOutlineColor
  })), nj(e, {
    status: "error",
    borderColor: e.colorError,
    hoverBorderHover: e.colorErrorHover,
    activeBorderColor: e.colorError,
    activeOutlineColor: e.colorErrorOutline
  })), nj(e, {
    status: "warning",
    borderColor: e.colorWarning,
    hoverBorderHover: e.colorWarningHover,
    activeBorderColor: e.colorWarning,
    activeOutlineColor: e.colorWarningOutline
  })), {
    [`&${e.componentCls}-disabled`]: {
      [`&:not(${e.componentCls}-customize-input) ${e.componentCls}-selector`]: {
        background: e.colorBgContainerDisabled,
        color: e.colorTextDisabled
      }
    },
    [`&${e.componentCls}-multiple ${e.componentCls}-selection-item`]: {
      background: e.multipleItemBg,
      border: `${Qe(e.lineWidth)} ${e.lineType} ${e.multipleItemBorderColor}`
    }
  })
}), oJ = (e, t) => {
  const {
    componentCls: n,
    antCls: r
  } = e;
  return {
    [`&:not(${n}-customize-input) ${n}-selector`]: {
      background: t.bg,
      border: `${Qe(e.lineWidth)} ${e.lineType} transparent`,
      color: t.color
    },
    [`&:not(${n}-disabled):not(${n}-customize-input):not(${r}-pagination-size-changer)`]: {
      [`&:hover ${n}-selector`]: {
        background: t.hoverBg
      },
      [`${n}-focused& ${n}-selector`]: {
        background: e.selectorBg,
        borderColor: t.activeBorderColor,
        outline: 0
      }
    }
  };
}, rj = (e, t) => ({
  [`&${e.componentCls}-status-${t.status}`]: Object.assign({}, oJ(e, t))
}), WMe = (e) => ({
  "&-filled": Object.assign(Object.assign(Object.assign(Object.assign({}, oJ(e, {
    bg: e.colorFillTertiary,
    hoverBg: e.colorFillSecondary,
    activeBorderColor: e.activeBorderColor,
    color: e.colorText
  })), rj(e, {
    status: "error",
    bg: e.colorErrorBg,
    hoverBg: e.colorErrorBgHover,
    activeBorderColor: e.colorError,
    color: e.colorError
  })), rj(e, {
    status: "warning",
    bg: e.colorWarningBg,
    hoverBg: e.colorWarningBgHover,
    activeBorderColor: e.colorWarning,
    color: e.colorWarning
  })), {
    [`&${e.componentCls}-disabled`]: {
      [`&:not(${e.componentCls}-customize-input) ${e.componentCls}-selector`]: {
        borderColor: e.colorBorder,
        background: e.colorBgContainerDisabled,
        color: e.colorTextDisabled
      }
    },
    [`&${e.componentCls}-multiple ${e.componentCls}-selection-item`]: {
      background: e.colorBgContainer,
      border: `${Qe(e.lineWidth)} ${e.lineType} ${e.colorSplit}`
    }
  })
}), qMe = (e) => ({
  "&-borderless": {
    [`${e.componentCls}-selector`]: {
      background: "transparent",
      borderColor: "transparent"
    },
    [`&${e.componentCls}-disabled`]: {
      [`&:not(${e.componentCls}-customize-input) ${e.componentCls}-selector`]: {
        color: e.colorTextDisabled
      }
    },
    [`&${e.componentCls}-multiple ${e.componentCls}-selection-item`]: {
      background: e.multipleItemBg,
      border: `${Qe(e.lineWidth)} ${e.lineType} ${e.multipleItemBorderColor}`
    },
    // Status
    [`&${e.componentCls}-status-error`]: {
      [`${e.componentCls}-selection-item`]: {
        color: e.colorError
      }
    },
    [`&${e.componentCls}-status-warning`]: {
      [`${e.componentCls}-selection-item`]: {
        color: e.colorWarning
      }
    }
  }
}), GMe = (e) => ({
  [e.componentCls]: Object.assign(Object.assign(Object.assign({}, UMe(e)), WMe(e)), qMe(e))
}), KMe = GMe, YMe = (e) => {
  const {
    componentCls: t
  } = e;
  return {
    position: "relative",
    transition: `all ${e.motionDurationMid} ${e.motionEaseInOut}`,
    input: {
      cursor: "pointer"
    },
    [`${t}-show-search&`]: {
      cursor: "text",
      input: {
        cursor: "auto",
        color: "inherit",
        height: "100%"
      }
    },
    [`${t}-disabled&`]: {
      cursor: "not-allowed",
      input: {
        cursor: "not-allowed"
      }
    }
  };
}, XMe = (e) => {
  const {
    componentCls: t
  } = e;
  return {
    [`${t}-selection-search-input`]: {
      margin: 0,
      padding: 0,
      background: "transparent",
      border: "none",
      outline: "none",
      appearance: "none",
      fontFamily: "inherit",
      "&::-webkit-search-cancel-button": {
        display: "none",
        "-webkit-appearance": "none"
      }
    }
  };
}, QMe = (e) => {
  const {
    antCls: t,
    componentCls: n,
    inputPaddingHorizontalBase: r,
    iconCls: i
  } = e;
  return {
    [n]: Object.assign(Object.assign({}, va(e)), {
      position: "relative",
      display: "inline-flex",
      cursor: "pointer",
      [`&:not(${n}-customize-input) ${n}-selector`]: Object.assign(Object.assign({}, YMe(e)), XMe(e)),
      // ======================== Selection ========================
      [`${n}-selection-item`]: Object.assign(Object.assign({
        flex: 1,
        fontWeight: "normal",
        position: "relative",
        userSelect: "none"
      }, YA), {
        // https://github.com/ant-design/ant-design/issues/40421
        [`> ${t}-typography`]: {
          display: "inline"
        }
      }),
      // ======================= Placeholder =======================
      [`${n}-selection-placeholder`]: Object.assign(Object.assign({}, YA), {
        flex: 1,
        color: e.colorTextPlaceholder,
        pointerEvents: "none"
      }),
      // ========================== Arrow ==========================
      [`${n}-arrow`]: Object.assign(Object.assign({}, Yx()), {
        position: "absolute",
        top: "50%",
        insetInlineStart: "auto",
        insetInlineEnd: r,
        height: e.fontSizeIcon,
        marginTop: e.calc(e.fontSizeIcon).mul(-1).div(2).equal(),
        color: e.colorTextQuaternary,
        fontSize: e.fontSizeIcon,
        lineHeight: 1,
        textAlign: "center",
        pointerEvents: "none",
        display: "flex",
        alignItems: "center",
        transition: `opacity ${e.motionDurationSlow} ease`,
        [i]: {
          verticalAlign: "top",
          transition: `transform ${e.motionDurationSlow}`,
          "> svg": {
            verticalAlign: "top"
          },
          [`&:not(${n}-suffix)`]: {
            pointerEvents: "auto"
          }
        },
        [`${n}-disabled &`]: {
          cursor: "not-allowed"
        },
        "> *:not(:last-child)": {
          marginInlineEnd: 8
          // FIXME: magic
        }
      }),
      // ========================== Clear ==========================
      [`${n}-clear`]: {
        position: "absolute",
        top: "50%",
        insetInlineStart: "auto",
        insetInlineEnd: r,
        zIndex: 1,
        display: "inline-block",
        width: e.fontSizeIcon,
        height: e.fontSizeIcon,
        marginTop: e.calc(e.fontSizeIcon).mul(-1).div(2).equal(),
        color: e.colorTextQuaternary,
        fontSize: e.fontSizeIcon,
        fontStyle: "normal",
        lineHeight: 1,
        textAlign: "center",
        textTransform: "none",
        cursor: "pointer",
        opacity: 0,
        transition: `color ${e.motionDurationMid} ease, opacity ${e.motionDurationSlow} ease`,
        textRendering: "auto",
        "&:before": {
          display: "block"
        },
        "&:hover": {
          color: e.colorTextTertiary
        }
      },
      [`&:hover ${n}-clear`]: {
        opacity: 1,
        background: e.colorBgBase,
        borderRadius: "50%"
      }
    }),
    // ========================= Feedback ==========================
    [`${n}-has-feedback`]: {
      [`${n}-clear`]: {
        insetInlineEnd: e.calc(r).add(e.fontSize).add(e.paddingXS).equal()
      }
    }
  };
}, JMe = (e) => {
  const {
    componentCls: t
  } = e;
  return [
    {
      [t]: {
        // ==================== In Form ====================
        [`&${t}-in-form-item`]: {
          width: "100%"
        }
      }
    },
    // =====================================================
    // ==                       LTR                       ==
    // =====================================================
    // Base
    QMe(e),
    // Single
    zMe(e),
    // Multiple
    BMe(e),
    // Dropdown
    NMe(e),
    // =====================================================
    // ==                       RTL                       ==
    // =====================================================
    {
      [`${t}-rtl`]: {
        direction: "rtl"
      }
    },
    // =====================================================
    // ==             Space Compact                       ==
    // =====================================================
    rE(e, {
      borderElCls: `${t}-selector`,
      focusElCls: `${t}-focused`
    })
  ];
}, ZMe = qa("Select", (e, t) => {
  let {
    rootPrefixCls: n
  } = t;
  const r = Or(e, {
    rootPrefixCls: n,
    inputPaddingHorizontalBase: e.calc(e.paddingSM).sub(1).equal(),
    multipleSelectItemHeight: e.multipleItemHeight,
    selectHeight: e.controlHeight
  });
  return [JMe(r), KMe(r)];
}, HMe, {
  unitless: {
    optionLineHeight: !0,
    optionSelectedFontWeight: !0
  }
});
var e3e = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M912 190h-69.9c-9.8 0-19.1 4.5-25.1 12.2L404.7 724.5 207 474a32 32 0 00-25.1-12.2H112c-6.7 0-10.4 7.7-6.3 12.9l273.9 347c12.8 16.2 37.4 16.2 50.3 0l488.4-618.9c4.1-5.1.4-12.8-6.3-12.8z" } }] }, name: "check", theme: "outlined" };
const t3e = e3e;
var n3e = function(t, n) {
  return /* @__PURE__ */ I.createElement(fo, mt({}, t, {
    ref: n,
    icon: t3e
  }));
}, aJ = /* @__PURE__ */ I.forwardRef(n3e);
process.env.NODE_ENV !== "production" && (aJ.displayName = "CheckOutlined");
const r3e = aJ;
var i3e = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M884 256h-75c-5.1 0-9.9 2.5-12.9 6.6L512 654.2 227.9 262.6c-3-4.1-7.8-6.6-12.9-6.6h-75c-6.5 0-10.3 7.4-6.5 12.7l352.6 486.1c12.8 17.6 39 17.6 51.7 0l352.6-486.1c3.9-5.3.1-12.7-6.4-12.7z" } }] }, name: "down", theme: "outlined" };
const o3e = i3e;
var a3e = function(t, n) {
  return /* @__PURE__ */ I.createElement(fo, mt({}, t, {
    ref: n,
    icon: o3e
  }));
}, sJ = /* @__PURE__ */ I.forwardRef(a3e);
process.env.NODE_ENV !== "production" && (sJ.displayName = "DownOutlined");
const cJ = sJ;
var s3e = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M909.6 854.5L649.9 594.8C690.2 542.7 712 479 712 412c0-80.2-31.3-155.4-87.9-212.1-56.6-56.7-132-87.9-212.1-87.9s-155.5 31.3-212.1 87.9C143.2 256.5 112 331.8 112 412c0 80.1 31.3 155.5 87.9 212.1C256.5 680.8 331.8 712 412 712c67 0 130.6-21.8 182.7-62l259.7 259.6a8.2 8.2 0 0011.6 0l43.6-43.5a8.2 8.2 0 000-11.6zM570.4 570.4C528 612.7 471.8 636 412 636s-116-23.3-158.4-65.6C211.3 528 188 471.8 188 412s23.3-116.1 65.6-158.4C296 211.3 352.2 188 412 188s116.1 23.2 158.4 65.6S636 352.2 636 412s-23.3 116.1-65.6 158.4z" } }] }, name: "search", theme: "outlined" };
const c3e = s3e;
var l3e = function(t, n) {
  return /* @__PURE__ */ I.createElement(fo, mt({}, t, {
    ref: n,
    icon: c3e
  }));
}, lJ = /* @__PURE__ */ I.forwardRef(l3e);
process.env.NODE_ENV !== "production" && (lJ.displayName = "SearchOutlined");
const uJ = lJ;
function u3e(e) {
  let {
    suffixIcon: t,
    clearIcon: n,
    menuItemSelectedIcon: r,
    removeIcon: i,
    loading: o,
    multiple: a,
    hasFeedback: s,
    prefixCls: c,
    showSuffixIcon: l,
    feedbackIcon: u,
    showArrow: d,
    componentName: f
  } = e;
  process.env.NODE_ENV !== "production" && di(f).deprecated(!n, "clearIcon", "allowClear={{ clearIcon: React.ReactNode }}");
  const h = n ?? /* @__PURE__ */ I.createElement(Jx, null), p = (y) => t === null && !s && !d ? null : /* @__PURE__ */ I.createElement(I.Fragment, null, l !== !1 && y, s && u);
  let g = null;
  if (t !== void 0)
    g = p(t);
  else if (o)
    g = p(/* @__PURE__ */ I.createElement(S6, {
      spin: !0
    }));
  else {
    const y = `${c}-suffix`;
    g = (S) => {
      let {
        open: _,
        showSearch: w
      } = S;
      return p(_ && w ? /* @__PURE__ */ I.createElement(uJ, {
        className: y
      }) : /* @__PURE__ */ I.createElement(cJ, {
        className: y
      }));
    };
  }
  let m = null;
  r !== void 0 ? m = r : a ? m = /* @__PURE__ */ I.createElement(r3e, null) : m = null;
  let v = null;
  return i !== void 0 ? v = i : v = /* @__PURE__ */ I.createElement(Zx, null), {
    clearIcon: h,
    suffixIcon: g,
    itemIcon: m,
    removeIcon: v
  };
}
function d3e(e, t) {
  return t !== void 0 ? t : e !== null;
}
var f3e = globalThis && globalThis.__rest || function(e, t) {
  var n = {};
  for (var r in e)
    Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var i = 0, r = Object.getOwnPropertySymbols(e); i < r.length; i++)
      t.indexOf(r[i]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[i]) && (n[r[i]] = e[r[i]]);
  return n;
};
const dJ = "SECRET_COMBOBOX_MODE_DO_NOT_USE", fJ = (e, t) => {
  var n;
  const {
    prefixCls: r,
    bordered: i,
    className: o,
    rootClassName: a,
    getPopupContainer: s,
    popupClassName: c,
    dropdownClassName: l,
    listHeight: u = 256,
    placement: d,
    listItemHeight: f,
    size: h,
    disabled: p,
    notFoundContent: g,
    status: m,
    builtinPlacements: v,
    dropdownMatchSelectWidth: y,
    popupMatchSelectWidth: S,
    direction: _,
    style: w,
    allowClear: T,
    variant: x,
    dropdownStyle: C,
    transitionName: E,
    tagRender: R,
    maxCount: A,
    prefix: O
  } = e, $ = f3e(e, ["prefixCls", "bordered", "className", "rootClassName", "getPopupContainer", "popupClassName", "dropdownClassName", "listHeight", "placement", "listItemHeight", "size", "disabled", "notFoundContent", "status", "builtinPlacements", "dropdownMatchSelectWidth", "popupMatchSelectWidth", "direction", "style", "allowClear", "variant", "dropdownStyle", "transitionName", "tagRender", "maxCount", "prefix"]), {
    getPopupContainer: N,
    getPrefixCls: z,
    renderEmpty: k,
    direction: F,
    virtual: V,
    popupMatchSelectWidth: j,
    popupOverflow: B,
    select: U
  } = I.useContext(En), [, Q] = $s(), K = f ?? (Q == null ? void 0 : Q.controlHeight), q = z("select", r), X = z(), ie = _ ?? F, {
    compactSize: te,
    compactItemClassnames: J
  } = cy(q, ie), [Y, ee] = lE("select", x, i), Z = If(q), [H, oe, W] = ZMe(q, Z), se = I.useMemo(() => {
    const {
      mode: Ct
    } = e;
    if (Ct !== "combobox")
      return Ct === dJ ? "combobox" : Ct;
  }, [e.mode]), ce = se === "multiple" || se === "tags", ge = d3e(e.suffixIcon, e.showArrow), he = (n = S ?? y) !== null && n !== void 0 ? n : j, {
    status: ue,
    hasFeedback: Ee,
    isFormItemInput: pe,
    feedbackIcon: Oe
  } = I.useContext(xs), de = fy(ue, m);
  let be;
  g !== void 0 ? be = g : se === "combobox" ? be = null : be = (k == null ? void 0 : k("Select")) || /* @__PURE__ */ I.createElement($Me, {
    componentName: "Select"
  });
  const {
    suffixIcon: Ie,
    itemIcon: Ve,
    removeIcon: Fe,
    clearIcon: Pe
  } = u3e(Object.assign(Object.assign({}, $), {
    multiple: ce,
    hasFeedback: Ee,
    feedbackIcon: Oe,
    showSuffixIcon: ge,
    prefixCls: q,
    componentName: "Select"
  })), ot = T === !0 ? {
    clearIcon: Pe
  } : T, dt = Hu($, ["suffixIcon", "itemIcon"]), ft = we(c || l, {
    [`${q}-dropdown-${ie}`]: ie === "rtl"
  }, a, W, Z, oe), wt = Rf((Ct) => {
    var yt;
    return (yt = h ?? te) !== null && yt !== void 0 ? yt : Ct;
  }), Ge = I.useContext(Uu), at = p ?? Ge, Nt = we({
    [`${q}-lg`]: wt === "large",
    [`${q}-sm`]: wt === "small",
    [`${q}-rtl`]: ie === "rtl",
    [`${q}-${Y}`]: ee,
    [`${q}-in-form-item`]: pe
  }, Lg(q, de, Ee), J, U == null ? void 0 : U.className, o, a, W, Z, oe), zt = I.useMemo(() => d !== void 0 ? d : ie === "rtl" ? "bottomRight" : "bottomLeft", [d, ie]);
  if (process.env.NODE_ENV !== "production") {
    const Ct = di("Select");
    Ct.deprecated(!l, "dropdownClassName", "popupClassName"), Ct.deprecated(y === void 0, "dropdownMatchSelectWidth", "popupMatchSelectWidth"), process.env.NODE_ENV !== "production" && Ct(!("showArrow" in e), "deprecated", "`showArrow` is deprecated which will be removed in next major version. It will be a default behavior, you can hide it by setting `suffixIcon` to null."), Ct.deprecated(!("bordered" in e), "bordered", "variant"), process.env.NODE_ENV !== "production" && Ct(!(typeof A < "u" && !ce), "usage", "`maxCount` only works with mode `multiple` or `tags`");
  }
  const [kt] = eQ("SelectLike", C == null ? void 0 : C.zIndex);
  return H(/* @__PURE__ */ I.createElement(B6, Object.assign({
    ref: t,
    virtual: V,
    showSearch: U == null ? void 0 : U.showSearch
  }, dt, {
    style: Object.assign(Object.assign({}, U == null ? void 0 : U.style), w),
    dropdownMatchSelectWidth: he,
    transitionName: oQ(X, "slide-up", E),
    builtinPlacements: MMe(v, B),
    listHeight: u,
    listItemHeight: K,
    mode: se,
    prefixCls: q,
    placement: zt,
    direction: ie,
    prefix: O,
    suffixIcon: Ie,
    menuItemSelectedIcon: Ve,
    removeIcon: Fe,
    allowClear: ot,
    notFoundContent: be,
    className: Nt,
    getPopupContainer: s || N,
    dropdownClassName: ft,
    disabled: at,
    dropdownStyle: Object.assign(Object.assign({}, C), {
      zIndex: kt
    }),
    maxCount: ce ? A : void 0,
    tagRender: ce ? R : void 0
  })));
};
process.env.NODE_ENV !== "production" && (fJ.displayName = "Select");
const Of = /* @__PURE__ */ I.forwardRef(fJ), h3e = t6e(Of);
Of.SECRET_COMBOBOX_MODE_DO_NOT_USE = dJ;
Of.Option = F6;
Of.OptGroup = j6;
Of._InternalPanelDoNotUseOrYouWillBeFired = h3e;
process.env.NODE_ENV !== "production" && (Of.displayName = "Select");
const g3e = Of;
function hJ(e) {
  var t = e.children, n = e.prefixCls, r = e.id, i = e.overlayInnerStyle, o = e.className, a = e.style;
  return /* @__PURE__ */ I.createElement("div", {
    className: we("".concat(n, "-content"), o),
    style: a
  }, /* @__PURE__ */ I.createElement("div", {
    className: "".concat(n, "-inner"),
    id: r,
    role: "tooltip",
    style: i
  }, typeof t == "function" ? t() : t));
}
var sh = {
  shiftX: 64,
  adjustY: 1
}, ch = {
  adjustX: 1,
  shiftY: !0
}, Aa = [0, 0], p3e = {
  left: {
    points: ["cr", "cl"],
    overflow: ch,
    offset: [-4, 0],
    targetOffset: Aa
  },
  right: {
    points: ["cl", "cr"],
    overflow: ch,
    offset: [4, 0],
    targetOffset: Aa
  },
  top: {
    points: ["bc", "tc"],
    overflow: sh,
    offset: [0, -4],
    targetOffset: Aa
  },
  bottom: {
    points: ["tc", "bc"],
    overflow: sh,
    offset: [0, 4],
    targetOffset: Aa
  },
  topLeft: {
    points: ["bl", "tl"],
    overflow: sh,
    offset: [0, -4],
    targetOffset: Aa
  },
  leftTop: {
    points: ["tr", "tl"],
    overflow: ch,
    offset: [-4, 0],
    targetOffset: Aa
  },
  topRight: {
    points: ["br", "tr"],
    overflow: sh,
    offset: [0, -4],
    targetOffset: Aa
  },
  rightTop: {
    points: ["tl", "tr"],
    overflow: ch,
    offset: [4, 0],
    targetOffset: Aa
  },
  bottomRight: {
    points: ["tr", "br"],
    overflow: sh,
    offset: [0, 4],
    targetOffset: Aa
  },
  rightBottom: {
    points: ["bl", "br"],
    overflow: ch,
    offset: [4, 0],
    targetOffset: Aa
  },
  bottomLeft: {
    points: ["tl", "bl"],
    overflow: sh,
    offset: [0, 4],
    targetOffset: Aa
  },
  leftBottom: {
    points: ["br", "bl"],
    overflow: ch,
    offset: [-4, 0],
    targetOffset: Aa
  }
}, m3e = ["overlayClassName", "trigger", "mouseEnterDelay", "mouseLeaveDelay", "overlayStyle", "prefixCls", "children", "onVisibleChange", "afterVisibleChange", "transitionName", "animation", "motion", "placement", "align", "destroyTooltipOnHide", "defaultVisible", "getTooltipContainer", "overlayInnerStyle", "arrowContent", "overlay", "id", "showArrow"], v3e = function(t, n) {
  var r = t.overlayClassName, i = t.trigger, o = i === void 0 ? ["hover"] : i, a = t.mouseEnterDelay, s = a === void 0 ? 0 : a, c = t.mouseLeaveDelay, l = c === void 0 ? 0.1 : c, u = t.overlayStyle, d = t.prefixCls, f = d === void 0 ? "rc-tooltip" : d, h = t.children, p = t.onVisibleChange, g = t.afterVisibleChange, m = t.transitionName, v = t.animation, y = t.motion, S = t.placement, _ = S === void 0 ? "right" : S, w = t.align, T = w === void 0 ? {} : w, x = t.destroyTooltipOnHide, C = x === void 0 ? !1 : x, E = t.defaultVisible, R = t.getTooltipContainer, A = t.overlayInnerStyle;
  t.arrowContent;
  var O = t.overlay, $ = t.id, N = t.showArrow, z = N === void 0 ? !0 : N, k = xn(t, m3e), F = Me(null);
  tO(n, function() {
    return F.current;
  });
  var V = ae({}, k);
  "visible" in t && (V.popupVisible = t.visible);
  var j = function() {
    return /* @__PURE__ */ I.createElement(hJ, {
      key: "content",
      prefixCls: f,
      id: $,
      overlayInnerStyle: A
    }, O);
  };
  return /* @__PURE__ */ I.createElement(WQ, mt({
    popupClassName: r,
    prefixCls: f,
    popup: j,
    action: o,
    builtinPlacements: p3e,
    popupPlacement: _,
    ref: F,
    popupAlign: T,
    getPopupContainer: R,
    onPopupVisibleChange: p,
    afterPopupVisibleChange: g,
    popupTransitionName: m,
    popupAnimation: v,
    popupMotion: y,
    defaultPopupVisible: E,
    autoDestroy: C,
    mouseLeaveDelay: l,
    popupStyle: u,
    mouseEnterDelay: s,
    arrow: z
  }, V), h);
};
const y3e = /* @__PURE__ */ ta(v3e);
function b3e(e) {
  const {
    sizePopupArrow: t,
    borderRadiusXS: n,
    borderRadiusOuter: r
  } = e, i = t / 2, o = 0, a = i, s = r * 1 / Math.sqrt(2), c = i - r * (1 - 1 / Math.sqrt(2)), l = i - n * (1 / Math.sqrt(2)), u = r * (Math.sqrt(2) - 1) + n * (1 / Math.sqrt(2)), d = 2 * i - l, f = u, h = 2 * i - s, p = c, g = 2 * i - o, m = a, v = i * Math.sqrt(2) + r * (Math.sqrt(2) - 2), y = r * (Math.sqrt(2) - 1), S = `polygon(${y}px 100%, 50% ${y}px, ${2 * i - y}px 100%, ${y}px 100%)`, _ = `path('M ${o} ${a} A ${r} ${r} 0 0 0 ${s} ${c} L ${l} ${u} A ${n} ${n} 0 0 1 ${d} ${f} L ${h} ${p} A ${r} ${r} 0 0 0 ${g} ${m} Z')`;
  return {
    arrowShadowWidth: v,
    arrowPath: _,
    arrowPolygon: S
  };
}
const _3e = (e, t, n) => {
  const {
    sizePopupArrow: r,
    arrowPolygon: i,
    arrowPath: o,
    arrowShadowWidth: a,
    borderRadiusXS: s,
    calc: c
  } = e;
  return {
    pointerEvents: "none",
    width: r,
    height: r,
    overflow: "hidden",
    "&::before": {
      position: "absolute",
      bottom: 0,
      insetInlineStart: 0,
      width: r,
      height: c(r).div(2).equal(),
      background: t,
      clipPath: {
        _multi_value_: !0,
        value: [i, o]
      },
      content: '""'
    },
    "&::after": {
      content: '""',
      position: "absolute",
      width: a,
      height: a,
      bottom: 0,
      insetInline: 0,
      margin: "auto",
      borderRadius: {
        _skip_check_: !0,
        value: `0 0 ${Qe(s)} 0`
      },
      transform: "translateY(50%) rotate(-135deg)",
      boxShadow: n,
      zIndex: 0,
      background: "transparent"
    }
  };
}, gJ = 8;
function pJ(e) {
  const {
    contentRadius: t,
    limitVerticalRadius: n
  } = e, r = t > 12 ? t + 2 : 12;
  return {
    arrowOffsetHorizontal: r,
    arrowOffsetVertical: n ? gJ : r
  };
}
function Kb(e, t) {
  return e ? t : {};
}
function S3e(e, t, n) {
  const {
    componentCls: r,
    boxShadowPopoverArrow: i,
    arrowOffsetVertical: o,
    arrowOffsetHorizontal: a
  } = e, {
    arrowDistance: s = 0,
    arrowPlacement: c = {
      left: !0,
      right: !0,
      top: !0,
      bottom: !0
    }
  } = n || {};
  return {
    [r]: Object.assign(Object.assign(Object.assign(Object.assign({
      // ============================ Basic ============================
      [`${r}-arrow`]: [Object.assign(Object.assign({
        position: "absolute",
        zIndex: 1,
        display: "block"
      }, _3e(e, t, i)), {
        "&:before": {
          background: t
        }
      })]
    }, Kb(!!c.top, {
      [[`&-placement-top > ${r}-arrow`, `&-placement-topLeft > ${r}-arrow`, `&-placement-topRight > ${r}-arrow`].join(",")]: {
        bottom: s,
        transform: "translateY(100%) rotate(180deg)"
      },
      [`&-placement-top > ${r}-arrow`]: {
        left: {
          _skip_check_: !0,
          value: "50%"
        },
        transform: "translateX(-50%) translateY(100%) rotate(180deg)"
      },
      "&-placement-topLeft": {
        "--arrow-offset-horizontal": a,
        [`> ${r}-arrow`]: {
          left: {
            _skip_check_: !0,
            value: a
          }
        }
      },
      "&-placement-topRight": {
        "--arrow-offset-horizontal": `calc(100% - ${Qe(a)})`,
        [`> ${r}-arrow`]: {
          right: {
            _skip_check_: !0,
            value: a
          }
        }
      }
    })), Kb(!!c.bottom, {
      [[`&-placement-bottom > ${r}-arrow`, `&-placement-bottomLeft > ${r}-arrow`, `&-placement-bottomRight > ${r}-arrow`].join(",")]: {
        top: s,
        transform: "translateY(-100%)"
      },
      [`&-placement-bottom > ${r}-arrow`]: {
        left: {
          _skip_check_: !0,
          value: "50%"
        },
        transform: "translateX(-50%) translateY(-100%)"
      },
      "&-placement-bottomLeft": {
        "--arrow-offset-horizontal": a,
        [`> ${r}-arrow`]: {
          left: {
            _skip_check_: !0,
            value: a
          }
        }
      },
      "&-placement-bottomRight": {
        "--arrow-offset-horizontal": `calc(100% - ${Qe(a)})`,
        [`> ${r}-arrow`]: {
          right: {
            _skip_check_: !0,
            value: a
          }
        }
      }
    })), Kb(!!c.left, {
      [[`&-placement-left > ${r}-arrow`, `&-placement-leftTop > ${r}-arrow`, `&-placement-leftBottom > ${r}-arrow`].join(",")]: {
        right: {
          _skip_check_: !0,
          value: s
        },
        transform: "translateX(100%) rotate(90deg)"
      },
      [`&-placement-left > ${r}-arrow`]: {
        top: {
          _skip_check_: !0,
          value: "50%"
        },
        transform: "translateY(-50%) translateX(100%) rotate(90deg)"
      },
      [`&-placement-leftTop > ${r}-arrow`]: {
        top: o
      },
      [`&-placement-leftBottom > ${r}-arrow`]: {
        bottom: o
      }
    })), Kb(!!c.right, {
      [[`&-placement-right > ${r}-arrow`, `&-placement-rightTop > ${r}-arrow`, `&-placement-rightBottom > ${r}-arrow`].join(",")]: {
        left: {
          _skip_check_: !0,
          value: s
        },
        transform: "translateX(-100%) rotate(-90deg)"
      },
      [`&-placement-right > ${r}-arrow`]: {
        top: {
          _skip_check_: !0,
          value: "50%"
        },
        transform: "translateY(-50%) translateX(-100%) rotate(-90deg)"
      },
      [`&-placement-rightTop > ${r}-arrow`]: {
        top: o
      },
      [`&-placement-rightBottom > ${r}-arrow`]: {
        bottom: o
      }
    }))
  };
}
function w3e(e, t, n, r) {
  if (r === !1)
    return {
      adjustX: !1,
      adjustY: !1
    };
  const i = r && typeof r == "object" ? r : {}, o = {};
  switch (e) {
    case "top":
    case "bottom":
      o.shiftX = t.arrowOffsetHorizontal * 2 + n, o.shiftY = !0, o.adjustY = !0;
      break;
    case "left":
    case "right":
      o.shiftY = t.arrowOffsetVertical * 2 + n, o.shiftX = !0, o.adjustX = !0;
      break;
  }
  const a = Object.assign(Object.assign({}, o), i);
  return a.shiftX || (a.adjustX = !0), a.shiftY || (a.adjustY = !0), a;
}
const ij = {
  left: {
    points: ["cr", "cl"]
  },
  right: {
    points: ["cl", "cr"]
  },
  top: {
    points: ["bc", "tc"]
  },
  bottom: {
    points: ["tc", "bc"]
  },
  topLeft: {
    points: ["bl", "tl"]
  },
  leftTop: {
    points: ["tr", "tl"]
  },
  topRight: {
    points: ["br", "tr"]
  },
  rightTop: {
    points: ["tl", "tr"]
  },
  bottomRight: {
    points: ["tr", "br"]
  },
  rightBottom: {
    points: ["bl", "br"]
  },
  bottomLeft: {
    points: ["tl", "bl"]
  },
  leftBottom: {
    points: ["br", "bl"]
  }
}, x3e = {
  topLeft: {
    points: ["bl", "tc"]
  },
  leftTop: {
    points: ["tr", "cl"]
  },
  topRight: {
    points: ["br", "tc"]
  },
  rightTop: {
    points: ["tl", "cr"]
  },
  bottomRight: {
    points: ["tr", "bc"]
  },
  rightBottom: {
    points: ["bl", "cr"]
  },
  bottomLeft: {
    points: ["tl", "bc"]
  },
  leftBottom: {
    points: ["br", "cl"]
  }
}, E3e = /* @__PURE__ */ new Set(["topLeft", "topRight", "bottomLeft", "bottomRight", "leftTop", "leftBottom", "rightTop", "rightBottom"]);
function C3e(e) {
  const {
    arrowWidth: t,
    autoAdjustOverflow: n,
    arrowPointAtCenter: r,
    offset: i,
    borderRadius: o,
    visibleFirst: a
  } = e, s = t / 2, c = {};
  return Object.keys(ij).forEach((l) => {
    const u = r && x3e[l] || ij[l], d = Object.assign(Object.assign({}, u), {
      offset: [0, 0],
      dynamicInset: !0
    });
    switch (c[l] = d, E3e.has(l) && (d.autoArrow = !1), l) {
      case "top":
      case "topLeft":
      case "topRight":
        d.offset[1] = -s - i;
        break;
      case "bottom":
      case "bottomLeft":
      case "bottomRight":
        d.offset[1] = s + i;
        break;
      case "left":
      case "leftTop":
      case "leftBottom":
        d.offset[0] = -s - i;
        break;
      case "right":
      case "rightTop":
      case "rightBottom":
        d.offset[0] = s + i;
        break;
    }
    const f = pJ({
      contentRadius: o,
      limitVerticalRadius: !0
    });
    if (r)
      switch (l) {
        case "topLeft":
        case "bottomLeft":
          d.offset[0] = -f.arrowOffsetHorizontal - s;
          break;
        case "topRight":
        case "bottomRight":
          d.offset[0] = f.arrowOffsetHorizontal + s;
          break;
        case "leftTop":
        case "rightTop":
          d.offset[1] = -f.arrowOffsetHorizontal * 2 + s;
          break;
        case "leftBottom":
        case "rightBottom":
          d.offset[1] = f.arrowOffsetHorizontal * 2 - s;
          break;
      }
    d.overflow = w3e(l, f, t, n), a && (d.htmlRegion = "visibleFirst");
  }), c;
}
const T3e = (e) => {
  const {
    componentCls: t,
    // ant-tooltip
    tooltipMaxWidth: n,
    tooltipColor: r,
    tooltipBg: i,
    tooltipBorderRadius: o,
    zIndexPopup: a,
    controlHeight: s,
    boxShadowSecondary: c,
    paddingSM: l,
    paddingXS: u
  } = e;
  return [
    {
      [t]: Object.assign(Object.assign(Object.assign(Object.assign({}, va(e)), {
        position: "absolute",
        zIndex: a,
        display: "block",
        width: "max-content",
        maxWidth: n,
        visibility: "visible",
        // When use `autoArrow`, origin will follow the arrow position
        "--valid-offset-x": "var(--arrow-offset-horizontal, var(--arrow-x))",
        transformOrigin: ["var(--valid-offset-x, 50%)", "var(--arrow-y, 50%)"].join(" "),
        "&-hidden": {
          display: "none"
        },
        "--antd-arrow-background-color": i,
        // Wrapper for the tooltip content
        [`${t}-inner`]: {
          minWidth: "1em",
          minHeight: s,
          padding: `${Qe(e.calc(l).div(2).equal())} ${Qe(u)}`,
          color: r,
          textAlign: "start",
          textDecoration: "none",
          wordWrap: "break-word",
          backgroundColor: i,
          borderRadius: o,
          boxShadow: c,
          boxSizing: "border-box"
        },
        // Limit left and right placement radius
        [["&-placement-left", "&-placement-leftTop", "&-placement-leftBottom", "&-placement-right", "&-placement-rightTop", "&-placement-rightBottom"].join(",")]: {
          [`${t}-inner`]: {
            borderRadius: e.min(o, gJ)
          }
        },
        [`${t}-content`]: {
          position: "relative"
        }
      }), SIe(e, (d, f) => {
        let {
          darkColor: h
        } = f;
        return {
          [`&${t}-${d}`]: {
            [`${t}-inner`]: {
              backgroundColor: h
            },
            [`${t}-arrow`]: {
              "--antd-arrow-background-color": h
            }
          }
        };
      })), {
        // RTL
        "&-rtl": {
          direction: "rtl"
        }
      })
    },
    // Arrow Style
    S3e(e, "var(--antd-arrow-background-color)"),
    // Pure Render
    {
      [`${t}-pure`]: {
        position: "relative",
        maxWidth: "none",
        margin: e.sizePopupArrow
      }
    }
  ];
}, I3e = (e) => Object.assign(Object.assign({
  zIndexPopup: e.zIndexPopupBase + 70
}, pJ({
  contentRadius: e.borderRadius,
  limitVerticalRadius: !0
})), b3e(Or(e, {
  borderRadiusOuter: Math.min(e.borderRadiusOuter, 4)
}))), mJ = function(e) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !0;
  return qa("Tooltip", (r) => {
    const {
      borderRadius: i,
      colorTextLightSolid: o,
      colorBgSpotlight: a
    } = r, s = Or(r, {
      // default variables
      tooltipMaxWidth: 250,
      tooltipColor: o,
      tooltipBorderRadius: i,
      tooltipBg: a
    });
    return [T3e(s), U$e(r, "zoom-big-fast")];
  }, I3e, {
    resetStyle: !1,
    // Popover use Tooltip as internal component. We do not need to handle this.
    injectStyle: t
  })(e);
}, A3e = PS.map((e) => `${e}-inverse`);
function R3e(e) {
  return (arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !0) ? [].concat(Je(A3e), Je(PS)).includes(e) : PS.includes(e);
}
function vJ(e, t) {
  const n = R3e(t), r = we({
    [`${e}-${t}`]: t && n
  }), i = {}, o = {};
  return t && !n && (i.background = t, o["--antd-arrow-background-color"] = t), {
    className: r,
    overlayStyle: i,
    arrowStyle: o
  };
}
const $3e = (e) => {
  const {
    prefixCls: t,
    className: n,
    placement: r = "top",
    title: i,
    color: o,
    overlayInnerStyle: a
  } = e, {
    getPrefixCls: s
  } = I.useContext(En), c = s("tooltip", t), [l, u, d] = mJ(c), f = vJ(c, o), h = f.arrowStyle, p = Object.assign(Object.assign({}, a), f.overlayStyle), g = we(u, d, c, `${c}-pure`, `${c}-placement-${r}`, n, f.className);
  return l(/* @__PURE__ */ I.createElement("div", {
    className: g,
    style: h
  }, /* @__PURE__ */ I.createElement("div", {
    className: `${c}-arrow`
  }), /* @__PURE__ */ I.createElement(hJ, Object.assign({}, e, {
    className: u,
    prefixCls: c,
    overlayInnerStyle: p
  }), i)));
}, O3e = $3e;
var P3e = globalThis && globalThis.__rest || function(e, t) {
  var n = {};
  for (var r in e)
    Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var i = 0, r = Object.getOwnPropertySymbols(e); i < r.length; i++)
      t.indexOf(r[i]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[i]) && (n[r[i]] = e[r[i]]);
  return n;
};
const M3e = /* @__PURE__ */ I.forwardRef((e, t) => {
  var n, r;
  const {
    prefixCls: i,
    openClassName: o,
    getTooltipContainer: a,
    overlayClassName: s,
    color: c,
    overlayInnerStyle: l,
    children: u,
    afterOpenChange: d,
    afterVisibleChange: f,
    destroyTooltipOnHide: h,
    arrow: p = !0,
    title: g,
    overlay: m,
    builtinPlacements: v,
    arrowPointAtCenter: y = !1,
    autoAdjustOverflow: S = !0
  } = e, _ = !!p, [, w] = $s(), {
    getPopupContainer: T,
    getPrefixCls: x,
    direction: C
  } = I.useContext(En), E = di("Tooltip"), R = I.useRef(null), A = () => {
    var de;
    (de = R.current) === null || de === void 0 || de.forceAlign();
  };
  I.useImperativeHandle(t, () => {
    var de;
    return {
      forceAlign: A,
      forcePopupAlign: () => {
        E.deprecated(!1, "forcePopupAlign", "forceAlign"), A();
      },
      nativeElement: (de = R.current) === null || de === void 0 ? void 0 : de.nativeElement
    };
  }), process.env.NODE_ENV !== "production" && ([["visible", "open"], ["defaultVisible", "defaultOpen"], ["onVisibleChange", "onOpenChange"], ["afterVisibleChange", "afterOpenChange"], ["arrowPointAtCenter", "arrow={{ pointAtCenter: true }}"]].forEach((de) => {
    let [be, Ie] = de;
    E.deprecated(!(be in e), be, Ie);
  }), process.env.NODE_ENV !== "production" && E(!h || typeof h == "boolean", "usage", "`destroyTooltipOnHide` no need config `keepParent` anymore. Please use `boolean` value directly."), process.env.NODE_ENV !== "production" && E(!p || typeof p == "boolean" || !("arrowPointAtCenter" in p), "deprecated", "`arrowPointAtCenter` in `arrow` is deprecated. Please use `pointAtCenter` instead."));
  const [O, $] = hc(!1, {
    value: (n = e.open) !== null && n !== void 0 ? n : e.visible,
    defaultValue: (r = e.defaultOpen) !== null && r !== void 0 ? r : e.defaultVisible
  }), N = !g && !m && g !== 0, z = (de) => {
    var be, Ie;
    $(N ? !1 : de), N || ((be = e.onOpenChange) === null || be === void 0 || be.call(e, de), (Ie = e.onVisibleChange) === null || Ie === void 0 || Ie.call(e, de));
  }, k = I.useMemo(() => {
    var de, be;
    let Ie = y;
    return typeof p == "object" && (Ie = (be = (de = p.pointAtCenter) !== null && de !== void 0 ? de : p.arrowPointAtCenter) !== null && be !== void 0 ? be : y), v || C3e({
      arrowPointAtCenter: Ie,
      autoAdjustOverflow: S,
      arrowWidth: _ ? w.sizePopupArrow : 0,
      borderRadius: w.borderRadius,
      offset: w.marginXXS,
      visibleFirst: !0
    });
  }, [y, p, v, w]), F = I.useMemo(() => g === 0 ? g : m || g || "", [m, g]), V = /* @__PURE__ */ I.createElement(cv, {
    space: !0
  }, typeof F == "function" ? F() : F), {
    getPopupContainer: j,
    placement: B = "top",
    mouseEnterDelay: U = 0.1,
    mouseLeaveDelay: Q = 0.1,
    overlayStyle: K,
    rootClassName: q
  } = e, X = P3e(e, ["getPopupContainer", "placement", "mouseEnterDelay", "mouseLeaveDelay", "overlayStyle", "rootClassName"]), ie = x("tooltip", i), te = x(), J = e["data-popover-inject"];
  let Y = O;
  !("open" in e) && !("visible" in e) && N && (Y = !1);
  const ee = /* @__PURE__ */ I.isValidElement(u) && !VX(u) ? u : /* @__PURE__ */ I.createElement("span", null, u), Z = ee.props, H = !Z.className || typeof Z.className == "string" ? we(Z.className, o || `${ie}-open`) : Z.className, [oe, W, se] = mJ(ie, !J), ce = vJ(ie, c), ge = ce.arrowStyle, he = Object.assign(Object.assign({}, l), ce.overlayStyle), ue = we(s, {
    [`${ie}-rtl`]: C === "rtl"
  }, ce.className, q, W, se), [Ee, pe] = eQ("Tooltip", X.zIndex), Oe = /* @__PURE__ */ I.createElement(y3e, Object.assign({}, X, {
    zIndex: Ee,
    showArrow: _,
    placement: B,
    mouseEnterDelay: U,
    mouseLeaveDelay: Q,
    prefixCls: ie,
    overlayClassName: ue,
    overlayStyle: Object.assign(Object.assign({}, ge), K),
    getTooltipContainer: j || a || T,
    ref: R,
    builtinPlacements: k,
    overlay: V,
    visible: Y,
    onVisibleChange: z,
    afterVisibleChange: d ?? f,
    overlayInnerStyle: he,
    arrowContent: /* @__PURE__ */ I.createElement("span", {
      className: `${ie}-arrow-content`
    }),
    motion: {
      motionName: oQ(te, "zoom-big-fast", e.transitionName),
      motionDeadline: 1e3
    },
    destroyTooltipOnHide: !!h
  }), Y ? Ng(ee, {
    className: H
  }) : ee);
  return oe(/* @__PURE__ */ I.createElement(QX.Provider, {
    value: pe
  }, Oe));
}), z6 = M3e;
process.env.NODE_ENV !== "production" && (z6.displayName = "Tooltip");
z6._InternalPanelDoNotUseOrYouWillBeFired = O3e;
const Pf = z6;
var k3e = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M724 218.3V141c0-6.7-7.7-10.4-12.9-6.3L260.3 486.8a31.86 31.86 0 000 50.3l450.8 352.1c5.3 4.1 12.9.4 12.9-6.3v-77.3c0-4.9-2.3-9.6-6.1-12.6l-360-281 360-281.1c3.8-3 6.1-7.7 6.1-12.6z" } }] }, name: "left", theme: "outlined" };
const N3e = k3e;
var D3e = function(t, n) {
  return /* @__PURE__ */ I.createElement(fo, mt({}, t, {
    ref: n,
    icon: N3e
  }));
}, yJ = /* @__PURE__ */ I.forwardRef(D3e);
process.env.NODE_ENV !== "production" && (yJ.displayName = "LeftOutlined");
const L3e = yJ;
function H6(e) {
  return Or(e, {
    inputAffixPadding: e.paddingXXS
  });
}
const U6 = (e) => {
  const {
    controlHeight: t,
    fontSize: n,
    lineHeight: r,
    lineWidth: i,
    controlHeightSM: o,
    controlHeightLG: a,
    fontSizeLG: s,
    lineHeightLG: c,
    paddingSM: l,
    controlPaddingHorizontalSM: u,
    controlPaddingHorizontal: d,
    colorFillAlter: f,
    colorPrimaryHover: h,
    colorPrimary: p,
    controlOutlineWidth: g,
    controlOutline: m,
    colorErrorOutline: v,
    colorWarningOutline: y,
    colorBgContainer: S
  } = e;
  return {
    paddingBlock: Math.max(Math.round((t - n * r) / 2 * 10) / 10 - i, 0),
    paddingBlockSM: Math.max(Math.round((o - n * r) / 2 * 10) / 10 - i, 0),
    paddingBlockLG: Math.ceil((a - s * c) / 2 * 10) / 10 - i,
    paddingInline: l - i,
    paddingInlineSM: u - i,
    paddingInlineLG: d - i,
    addonBg: f,
    activeBorderColor: p,
    hoverBorderColor: h,
    activeShadow: `0 0 0 ${g}px ${m}`,
    errorActiveShadow: `0 0 0 ${g}px ${v}`,
    warningActiveShadow: `0 0 0 ${g}px ${y}`,
    hoverBg: S,
    activeBg: S,
    inputFontSize: n,
    inputFontSizeLG: s,
    inputFontSizeSM: n
  };
}, j3e = (e) => ({
  borderColor: e.hoverBorderColor,
  backgroundColor: e.hoverBg
}), W6 = (e) => ({
  color: e.colorTextDisabled,
  backgroundColor: e.colorBgContainerDisabled,
  borderColor: e.colorBorder,
  boxShadow: "none",
  cursor: "not-allowed",
  opacity: 1,
  "input[disabled], textarea[disabled]": {
    cursor: "not-allowed"
  },
  "&:hover:not([disabled])": Object.assign({}, j3e(Or(e, {
    hoverBorderColor: e.colorBorder,
    hoverBg: e.colorBgContainerDisabled
  })))
}), bJ = (e, t) => ({
  background: e.colorBgContainer,
  borderWidth: e.lineWidth,
  borderStyle: e.lineType,
  borderColor: t.borderColor,
  "&:hover": {
    borderColor: t.hoverBorderColor,
    backgroundColor: e.hoverBg
  },
  "&:focus, &:focus-within": {
    borderColor: t.activeBorderColor,
    boxShadow: t.activeShadow,
    outline: 0,
    backgroundColor: e.activeBg
  }
}), oj = (e, t) => ({
  [`&${e.componentCls}-status-${t.status}:not(${e.componentCls}-disabled)`]: Object.assign(Object.assign({}, bJ(e, t)), {
    [`${e.componentCls}-prefix, ${e.componentCls}-suffix`]: {
      color: t.affixColor
    }
  }),
  [`&${e.componentCls}-status-${t.status}${e.componentCls}-disabled`]: {
    borderColor: t.borderColor
  }
}), _J = (e, t) => ({
  "&-outlined": Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, bJ(e, {
    borderColor: e.colorBorder,
    hoverBorderColor: e.hoverBorderColor,
    activeBorderColor: e.activeBorderColor,
    activeShadow: e.activeShadow
  })), {
    [`&${e.componentCls}-disabled, &[disabled]`]: Object.assign({}, W6(e))
  }), oj(e, {
    status: "error",
    borderColor: e.colorError,
    hoverBorderColor: e.colorErrorBorderHover,
    activeBorderColor: e.colorError,
    activeShadow: e.errorActiveShadow,
    affixColor: e.colorError
  })), oj(e, {
    status: "warning",
    borderColor: e.colorWarning,
    hoverBorderColor: e.colorWarningBorderHover,
    activeBorderColor: e.colorWarning,
    activeShadow: e.warningActiveShadow,
    affixColor: e.colorWarning
  })), t)
}), aj = (e, t) => ({
  [`&${e.componentCls}-group-wrapper-status-${t.status}`]: {
    [`${e.componentCls}-group-addon`]: {
      borderColor: t.addonBorderColor,
      color: t.addonColor
    }
  }
}), SJ = (e) => ({
  "&-outlined": Object.assign(Object.assign(Object.assign({
    [`${e.componentCls}-group`]: {
      "&-addon": {
        background: e.addonBg,
        border: `${Qe(e.lineWidth)} ${e.lineType} ${e.colorBorder}`
      },
      "&-addon:first-child": {
        borderInlineEnd: 0
      },
      "&-addon:last-child": {
        borderInlineStart: 0
      }
    }
  }, aj(e, {
    status: "error",
    addonBorderColor: e.colorError,
    addonColor: e.colorErrorText
  })), aj(e, {
    status: "warning",
    addonBorderColor: e.colorWarning,
    addonColor: e.colorWarningText
  })), {
    [`&${e.componentCls}-group-wrapper-disabled`]: {
      [`${e.componentCls}-group-addon`]: Object.assign({}, W6(e))
    }
  })
}), wJ = (e, t) => {
  const {
    componentCls: n
  } = e;
  return {
    "&-borderless": Object.assign({
      background: "transparent",
      border: "none",
      "&:focus, &:focus-within": {
        outline: "none"
      },
      // >>>>> Disabled
      [`&${n}-disabled, &[disabled]`]: {
        color: e.colorTextDisabled,
        cursor: "not-allowed"
      },
      // >>>>> Status
      [`&${n}-status-error`]: {
        "&, & input, & textarea": {
          color: e.colorError
        }
      },
      [`&${n}-status-warning`]: {
        "&, & input, & textarea": {
          color: e.colorWarning
        }
      }
    }, t)
  };
}, xJ = (e, t) => ({
  background: t.bg,
  borderWidth: e.lineWidth,
  borderStyle: e.lineType,
  borderColor: "transparent",
  "input&, & input, textarea&, & textarea": {
    color: t == null ? void 0 : t.inputColor
  },
  "&:hover": {
    background: t.hoverBg
  },
  "&:focus, &:focus-within": {
    outline: 0,
    borderColor: t.activeBorderColor,
    backgroundColor: e.activeBg
  }
}), sj = (e, t) => ({
  [`&${e.componentCls}-status-${t.status}:not(${e.componentCls}-disabled)`]: Object.assign(Object.assign({}, xJ(e, t)), {
    [`${e.componentCls}-prefix, ${e.componentCls}-suffix`]: {
      color: t.affixColor
    }
  })
}), EJ = (e, t) => ({
  "&-filled": Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, xJ(e, {
    bg: e.colorFillTertiary,
    hoverBg: e.colorFillSecondary,
    activeBorderColor: e.activeBorderColor
  })), {
    [`&${e.componentCls}-disabled, &[disabled]`]: Object.assign({}, W6(e))
  }), sj(e, {
    status: "error",
    bg: e.colorErrorBg,
    hoverBg: e.colorErrorBgHover,
    activeBorderColor: e.colorError,
    inputColor: e.colorErrorText,
    affixColor: e.colorError
  })), sj(e, {
    status: "warning",
    bg: e.colorWarningBg,
    hoverBg: e.colorWarningBgHover,
    activeBorderColor: e.colorWarning,
    inputColor: e.colorWarningText,
    affixColor: e.colorWarning
  })), t)
}), cj = (e, t) => ({
  [`&${e.componentCls}-group-wrapper-status-${t.status}`]: {
    [`${e.componentCls}-group-addon`]: {
      background: t.addonBg,
      color: t.addonColor
    }
  }
}), CJ = (e) => ({
  "&-filled": Object.assign(Object.assign(Object.assign({
    [`${e.componentCls}-group`]: {
      "&-addon": {
        background: e.colorFillTertiary
      },
      [`${e.componentCls}-filled:not(:focus):not(:focus-within)`]: {
        "&:not(:first-child)": {
          borderInlineStart: `${Qe(e.lineWidth)} ${e.lineType} ${e.colorSplit}`
        },
        "&:not(:last-child)": {
          borderInlineEnd: `${Qe(e.lineWidth)} ${e.lineType} ${e.colorSplit}`
        }
      }
    }
  }, cj(e, {
    status: "error",
    addonBg: e.colorErrorBg,
    addonColor: e.colorErrorText
  })), cj(e, {
    status: "warning",
    addonBg: e.colorWarningBg,
    addonColor: e.colorWarningText
  })), {
    [`&${e.componentCls}-group-wrapper-disabled`]: {
      [`${e.componentCls}-group`]: {
        "&-addon": {
          background: e.colorFillTertiary,
          color: e.colorTextDisabled
        },
        "&-addon:first-child": {
          borderInlineStart: `${Qe(e.lineWidth)} ${e.lineType} ${e.colorBorder}`,
          borderTop: `${Qe(e.lineWidth)} ${e.lineType} ${e.colorBorder}`,
          borderBottom: `${Qe(e.lineWidth)} ${e.lineType} ${e.colorBorder}`
        },
        "&-addon:last-child": {
          borderInlineEnd: `${Qe(e.lineWidth)} ${e.lineType} ${e.colorBorder}`,
          borderTop: `${Qe(e.lineWidth)} ${e.lineType} ${e.colorBorder}`,
          borderBottom: `${Qe(e.lineWidth)} ${e.lineType} ${e.colorBorder}`
        }
      }
    }
  })
}), TJ = (e) => ({
  // Firefox
  "&::-moz-placeholder": {
    opacity: 1
  },
  "&::placeholder": {
    color: e,
    userSelect: "none"
    // https://github.com/ant-design/ant-design/pull/32639
  },
  "&:placeholder-shown": {
    textOverflow: "ellipsis"
  }
}), IJ = (e) => {
  const {
    paddingBlockLG: t,
    lineHeightLG: n,
    borderRadiusLG: r,
    paddingInlineLG: i
  } = e;
  return {
    padding: `${Qe(t)} ${Qe(i)}`,
    fontSize: e.inputFontSizeLG,
    lineHeight: n,
    borderRadius: r
  };
}, AJ = (e) => ({
  padding: `${Qe(e.paddingBlockSM)} ${Qe(e.paddingInlineSM)}`,
  fontSize: e.inputFontSizeSM,
  borderRadius: e.borderRadiusSM
}), uE = (e) => Object.assign(Object.assign({
  position: "relative",
  display: "inline-block",
  width: "100%",
  minWidth: 0,
  padding: `${Qe(e.paddingBlock)} ${Qe(e.paddingInline)}`,
  color: e.colorText,
  fontSize: e.inputFontSize,
  lineHeight: e.lineHeight,
  borderRadius: e.borderRadius,
  transition: `all ${e.motionDurationMid}`
}, TJ(e.colorTextPlaceholder)), {
  // Reset height for `textarea`s
  "textarea&": {
    maxWidth: "100%",
    // prevent textarea resize from coming out of its container
    height: "auto",
    minHeight: e.controlHeight,
    lineHeight: e.lineHeight,
    verticalAlign: "bottom",
    transition: `all ${e.motionDurationSlow}, height 0s`,
    resize: "vertical"
  },
  // Size
  "&-lg": Object.assign({}, IJ(e)),
  "&-sm": Object.assign({}, AJ(e)),
  // RTL
  "&-rtl, &-textarea-rtl": {
    direction: "rtl"
  }
}), RJ = (e) => {
  const {
    componentCls: t,
    antCls: n
  } = e;
  return {
    position: "relative",
    display: "table",
    width: "100%",
    borderCollapse: "separate",
    borderSpacing: 0,
    // Undo padding and float of grid classes
    "&[class*='col-']": {
      paddingInlineEnd: e.paddingXS,
      "&:last-child": {
        paddingInlineEnd: 0
      }
    },
    // Sizing options
    [`&-lg ${t}, &-lg > ${t}-group-addon`]: Object.assign({}, IJ(e)),
    [`&-sm ${t}, &-sm > ${t}-group-addon`]: Object.assign({}, AJ(e)),
    // Fix https://github.com/ant-design/ant-design/issues/5754
    [`&-lg ${n}-select-single ${n}-select-selector`]: {
      height: e.controlHeightLG
    },
    [`&-sm ${n}-select-single ${n}-select-selector`]: {
      height: e.controlHeightSM
    },
    [`> ${t}`]: {
      display: "table-cell",
      "&:not(:first-child):not(:last-child)": {
        borderRadius: 0
      }
    },
    [`${t}-group`]: {
      "&-addon, &-wrap": {
        display: "table-cell",
        width: 1,
        whiteSpace: "nowrap",
        verticalAlign: "middle",
        "&:not(:first-child):not(:last-child)": {
          borderRadius: 0
        }
      },
      "&-wrap > *": {
        display: "block !important"
      },
      "&-addon": {
        position: "relative",
        padding: `0 ${Qe(e.paddingInline)}`,
        color: e.colorText,
        fontWeight: "normal",
        fontSize: e.inputFontSize,
        textAlign: "center",
        borderRadius: e.borderRadius,
        transition: `all ${e.motionDurationSlow}`,
        lineHeight: 1,
        // Reset Select's style in addon
        [`${n}-select`]: {
          margin: `${Qe(e.calc(e.paddingBlock).add(1).mul(-1).equal())} ${Qe(e.calc(e.paddingInline).mul(-1).equal())}`,
          [`&${n}-select-single:not(${n}-select-customize-input):not(${n}-pagination-size-changer)`]: {
            [`${n}-select-selector`]: {
              backgroundColor: "inherit",
              border: `${Qe(e.lineWidth)} ${e.lineType} transparent`,
              boxShadow: "none"
            }
          }
        },
        // https://github.com/ant-design/ant-design/issues/31333
        [`${n}-cascader-picker`]: {
          margin: `-9px ${Qe(e.calc(e.paddingInline).mul(-1).equal())}`,
          backgroundColor: "transparent",
          [`${n}-cascader-input`]: {
            textAlign: "start",
            border: 0,
            boxShadow: "none"
          }
        }
      }
    },
    [t]: {
      width: "100%",
      marginBottom: 0,
      textAlign: "inherit",
      "&:focus": {
        zIndex: 1,
        // Fix https://gw.alipayobjects.com/zos/rmsportal/DHNpoqfMXSfrSnlZvhsJ.png
        borderInlineEndWidth: 1
      },
      "&:hover": {
        zIndex: 1,
        borderInlineEndWidth: 1,
        [`${t}-search-with-button &`]: {
          zIndex: 0
        }
      }
    },
    // Reset rounded corners
    [`> ${t}:first-child, ${t}-group-addon:first-child`]: {
      borderStartEndRadius: 0,
      borderEndEndRadius: 0,
      // Reset Select's style in addon
      [`${n}-select ${n}-select-selector`]: {
        borderStartEndRadius: 0,
        borderEndEndRadius: 0
      }
    },
    [`> ${t}-affix-wrapper`]: {
      [`&:not(:first-child) ${t}`]: {
        borderStartStartRadius: 0,
        borderEndStartRadius: 0
      },
      [`&:not(:last-child) ${t}`]: {
        borderStartEndRadius: 0,
        borderEndEndRadius: 0
      }
    },
    [`> ${t}:last-child, ${t}-group-addon:last-child`]: {
      borderStartStartRadius: 0,
      borderEndStartRadius: 0,
      // Reset Select's style in addon
      [`${n}-select ${n}-select-selector`]: {
        borderStartStartRadius: 0,
        borderEndStartRadius: 0
      }
    },
    [`${t}-affix-wrapper`]: {
      "&:not(:last-child)": {
        borderStartEndRadius: 0,
        borderEndEndRadius: 0,
        [`${t}-search &`]: {
          borderStartStartRadius: e.borderRadius,
          borderEndStartRadius: e.borderRadius
        }
      },
      [`&:not(:first-child), ${t}-search &:not(:first-child)`]: {
        borderStartStartRadius: 0,
        borderEndStartRadius: 0
      }
    },
    [`&${t}-group-compact`]: Object.assign(Object.assign({
      display: "block"
    }, hIe()), {
      [`${t}-group-addon, ${t}-group-wrap, > ${t}`]: {
        "&:not(:first-child):not(:last-child)": {
          borderInlineEndWidth: e.lineWidth,
          "&:hover, &:focus": {
            zIndex: 1
          }
        }
      },
      "& > *": {
        display: "inline-flex",
        float: "none",
        verticalAlign: "top",
        // https://github.com/ant-design/ant-design-pro/issues/139
        borderRadius: 0
      },
      [`
        & > ${t}-affix-wrapper,
        & > ${t}-number-affix-wrapper,
        & > ${n}-picker-range
      `]: {
        display: "inline-flex"
      },
      "& > *:not(:last-child)": {
        marginInlineEnd: e.calc(e.lineWidth).mul(-1).equal(),
        borderInlineEndWidth: e.lineWidth
      },
      // Undo float for .ant-input-group .ant-input
      [t]: {
        float: "none"
      },
      // reset border for Select, DatePicker, AutoComplete, Cascader, Mention, TimePicker, Input
      [`& > ${n}-select > ${n}-select-selector,
      & > ${n}-select-auto-complete ${t},
      & > ${n}-cascader-picker ${t},
      & > ${t}-group-wrapper ${t}`]: {
        borderInlineEndWidth: e.lineWidth,
        borderRadius: 0,
        "&:hover, &:focus": {
          zIndex: 1
        }
      },
      [`& > ${n}-select-focused`]: {
        zIndex: 1
      },
      // update z-index for arrow icon
      [`& > ${n}-select > ${n}-select-arrow`]: {
        zIndex: 1
        // https://github.com/ant-design/ant-design/issues/20371
      },
      [`& > *:first-child,
      & > ${n}-select:first-child > ${n}-select-selector,
      & > ${n}-select-auto-complete:first-child ${t},
      & > ${n}-cascader-picker:first-child ${t}`]: {
        borderStartStartRadius: e.borderRadius,
        borderEndStartRadius: e.borderRadius
      },
      [`& > *:last-child,
      & > ${n}-select:last-child > ${n}-select-selector,
      & > ${n}-cascader-picker:last-child ${t},
      & > ${n}-cascader-picker-focused:last-child ${t}`]: {
        borderInlineEndWidth: e.lineWidth,
        borderStartEndRadius: e.borderRadius,
        borderEndEndRadius: e.borderRadius
      },
      // https://github.com/ant-design/ant-design/issues/12493
      [`& > ${n}-select-auto-complete ${t}`]: {
        verticalAlign: "top"
      },
      [`${t}-group-wrapper + ${t}-group-wrapper`]: {
        marginInlineStart: e.calc(e.lineWidth).mul(-1).equal(),
        [`${t}-affix-wrapper`]: {
          borderRadius: 0
        }
      },
      [`${t}-group-wrapper:not(:last-child)`]: {
        [`&${t}-search > ${t}-group`]: {
          [`& > ${t}-group-addon > ${t}-search-button`]: {
            borderRadius: 0
          },
          [`& > ${t}`]: {
            borderStartStartRadius: e.borderRadius,
            borderStartEndRadius: 0,
            borderEndEndRadius: 0,
            borderEndStartRadius: e.borderRadius
          }
        }
      }
    })
  };
}, F3e = (e) => {
  const {
    componentCls: t,
    controlHeightSM: n,
    lineWidth: r,
    calc: i
  } = e, o = 16, a = i(n).sub(i(r).mul(2)).sub(o).div(2).equal();
  return {
    [t]: Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, va(e)), uE(e)), _J(e)), EJ(e)), wJ(e)), {
      '&[type="color"]': {
        height: e.controlHeight,
        [`&${t}-lg`]: {
          height: e.controlHeightLG
        },
        [`&${t}-sm`]: {
          height: n,
          paddingTop: a,
          paddingBottom: a
        }
      },
      '&[type="search"]::-webkit-search-cancel-button, &[type="search"]::-webkit-search-decoration': {
        "-webkit-appearance": "none"
      }
    })
  };
}, V3e = (e) => {
  const {
    componentCls: t
  } = e;
  return {
    // ========================= Input =========================
    [`${t}-clear-icon`]: {
      margin: 0,
      color: e.colorTextQuaternary,
      fontSize: e.fontSizeIcon,
      verticalAlign: -1,
      // https://github.com/ant-design/ant-design/pull/18151
      // https://codesandbox.io/s/wizardly-sun-u10br
      cursor: "pointer",
      transition: `color ${e.motionDurationSlow}`,
      "&:hover": {
        color: e.colorTextTertiary
      },
      "&:active": {
        color: e.colorText
      },
      "&-hidden": {
        visibility: "hidden"
      },
      "&-has-suffix": {
        margin: `0 ${Qe(e.inputAffixPadding)}`
      }
    }
  };
}, B3e = (e) => {
  const {
    componentCls: t,
    inputAffixPadding: n,
    colorTextDescription: r,
    motionDurationSlow: i,
    colorIcon: o,
    colorIconHover: a,
    iconCls: s
  } = e, c = `${t}-affix-wrapper`, l = `${t}-affix-wrapper-disabled`;
  return {
    [c]: Object.assign(Object.assign(Object.assign(Object.assign({}, uE(e)), {
      display: "inline-flex",
      [`&:not(${t}-disabled):hover`]: {
        zIndex: 1,
        [`${t}-search-with-button &`]: {
          zIndex: 0
        }
      },
      "&-focused, &:focus": {
        zIndex: 1
      },
      [`> input${t}`]: {
        padding: 0
      },
      [`> input${t}, > textarea${t}`]: {
        fontSize: "inherit",
        border: "none",
        borderRadius: 0,
        outline: "none",
        background: "transparent",
        color: "inherit",
        "&::-ms-reveal": {
          display: "none"
        },
        "&:focus": {
          boxShadow: "none !important"
        }
      },
      "&::before": {
        display: "inline-block",
        width: 0,
        visibility: "hidden",
        content: '"\\a0"'
      },
      [t]: {
        "&-prefix, &-suffix": {
          display: "flex",
          flex: "none",
          alignItems: "center",
          "> *:not(:last-child)": {
            marginInlineEnd: e.paddingXS
          }
        },
        "&-show-count-suffix": {
          color: r
        },
        "&-show-count-has-suffix": {
          marginInlineEnd: e.paddingXXS
        },
        "&-prefix": {
          marginInlineEnd: n
        },
        "&-suffix": {
          marginInlineStart: n
        }
      }
    }), V3e(e)), {
      // password
      [`${s}${t}-password-icon`]: {
        color: o,
        cursor: "pointer",
        transition: `all ${i}`,
        "&:hover": {
          color: a
        }
      }
    }),
    [l]: {
      // password disabled
      [`${s}${t}-password-icon`]: {
        color: o,
        cursor: "not-allowed",
        "&:hover": {
          color: o
        }
      }
    }
  };
}, z3e = (e) => {
  const {
    componentCls: t,
    borderRadiusLG: n,
    borderRadiusSM: r
  } = e;
  return {
    [`${t}-group`]: Object.assign(Object.assign(Object.assign({}, va(e)), RJ(e)), {
      "&-rtl": {
        direction: "rtl"
      },
      "&-wrapper": Object.assign(Object.assign(Object.assign({
        display: "inline-block",
        width: "100%",
        textAlign: "start",
        verticalAlign: "top",
        "&-rtl": {
          direction: "rtl"
        },
        // Size
        "&-lg": {
          [`${t}-group-addon`]: {
            borderRadius: n,
            fontSize: e.inputFontSizeLG
          }
        },
        "&-sm": {
          [`${t}-group-addon`]: {
            borderRadius: r
          }
        }
      }, SJ(e)), CJ(e)), {
        // '&-disabled': {
        //   [`${componentCls}-group-addon`]: {
        //     ...genDisabledStyle(token),
        //   },
        // },
        // Fix the issue of using icons in Space Compact mode
        // https://github.com/ant-design/ant-design/issues/42122
        [`&:not(${t}-compact-first-item):not(${t}-compact-last-item)${t}-compact-item`]: {
          [`${t}, ${t}-group-addon`]: {
            borderRadius: 0
          }
        },
        [`&:not(${t}-compact-last-item)${t}-compact-first-item`]: {
          [`${t}, ${t}-group-addon`]: {
            borderStartEndRadius: 0,
            borderEndEndRadius: 0
          }
        },
        [`&:not(${t}-compact-first-item)${t}-compact-last-item`]: {
          [`${t}, ${t}-group-addon`]: {
            borderStartStartRadius: 0,
            borderEndStartRadius: 0
          }
        },
        // Fix the issue of input use show-count param in space compact mode
        // https://github.com/ant-design/ant-design/issues/46872
        [`&:not(${t}-compact-last-item)${t}-compact-item`]: {
          [`${t}-affix-wrapper`]: {
            borderStartEndRadius: 0,
            borderEndEndRadius: 0
          }
        }
      })
    })
  };
}, H3e = (e) => {
  const {
    componentCls: t,
    antCls: n
  } = e, r = `${t}-search`;
  return {
    [r]: {
      [t]: {
        "&:hover, &:focus": {
          [`+ ${t}-group-addon ${r}-button:not(${n}-btn-primary)`]: {
            borderInlineStartColor: e.colorPrimaryHover
          }
        }
      },
      [`${t}-affix-wrapper`]: {
        height: e.controlHeight,
        borderRadius: 0
      },
      // fix slight height diff in Firefox:
      // https://ant.design/components/auto-complete-cn/#auto-complete-demo-certain-category
      [`${t}-lg`]: {
        lineHeight: e.calc(e.lineHeightLG).sub(2e-4).equal()
      },
      [`> ${t}-group`]: {
        [`> ${t}-group-addon:last-child`]: {
          insetInlineStart: -1,
          padding: 0,
          border: 0,
          [`${r}-button`]: {
            // Fix https://github.com/ant-design/ant-design/issues/47150
            marginInlineEnd: -1,
            paddingTop: 0,
            paddingBottom: 0,
            borderStartStartRadius: 0,
            borderEndStartRadius: 0,
            boxShadow: "none"
          },
          [`${r}-button:not(${n}-btn-primary)`]: {
            color: e.colorTextDescription,
            "&:hover": {
              color: e.colorPrimaryHover
            },
            "&:active": {
              color: e.colorPrimaryActive
            },
            [`&${n}-btn-loading::before`]: {
              insetInlineStart: 0,
              insetInlineEnd: 0,
              insetBlockStart: 0,
              insetBlockEnd: 0
            }
          }
        }
      },
      [`${r}-button`]: {
        height: e.controlHeight,
        "&:hover, &:focus": {
          zIndex: 1
        }
      },
      "&-large": {
        [`${t}-affix-wrapper, ${r}-button`]: {
          height: e.controlHeightLG
        }
      },
      "&-small": {
        [`${t}-affix-wrapper, ${r}-button`]: {
          height: e.controlHeightSM
        }
      },
      "&-rtl": {
        direction: "rtl"
      },
      // ===================== Compact Item Customized Styles =====================
      [`&${t}-compact-item`]: {
        [`&:not(${t}-compact-last-item)`]: {
          [`${t}-group-addon`]: {
            [`${t}-search-button`]: {
              marginInlineEnd: e.calc(e.lineWidth).mul(-1).equal(),
              borderRadius: 0
            }
          }
        },
        [`&:not(${t}-compact-first-item)`]: {
          [`${t},${t}-affix-wrapper`]: {
            borderRadius: 0
          }
        },
        [`> ${t}-group-addon ${t}-search-button,
        > ${t},
        ${t}-affix-wrapper`]: {
          "&:hover, &:focus, &:active": {
            zIndex: 2
          }
        },
        [`> ${t}-affix-wrapper-focused`]: {
          zIndex: 2
        }
      }
    }
  };
}, U3e = (e) => {
  const {
    componentCls: t,
    paddingLG: n
  } = e, r = `${t}-textarea`;
  return {
    [r]: {
      position: "relative",
      "&-show-count": {
        // https://github.com/ant-design/ant-design/issues/33049
        [`> ${t}`]: {
          height: "100%"
        },
        [`${t}-data-count`]: {
          position: "absolute",
          bottom: e.calc(e.fontSize).mul(e.lineHeight).mul(-1).equal(),
          insetInlineEnd: 0,
          color: e.colorTextDescription,
          whiteSpace: "nowrap",
          pointerEvents: "none"
        }
      },
      [`
        &-allow-clear > ${t},
        &-affix-wrapper${r}-has-feedback ${t}
      `]: {
        paddingInlineEnd: n
      },
      [`&-affix-wrapper${t}-affix-wrapper`]: {
        padding: 0,
        [`> textarea${t}`]: {
          fontSize: "inherit",
          border: "none",
          outline: "none",
          background: "transparent",
          "&:focus": {
            boxShadow: "none !important"
          }
        },
        [`${t}-suffix`]: {
          margin: 0,
          "> *:not(:last-child)": {
            marginInline: 0
          },
          // Clear Icon
          [`${t}-clear-icon`]: {
            position: "absolute",
            insetInlineEnd: e.paddingInline,
            insetBlockStart: e.paddingXS
          },
          // Feedback Icon
          [`${r}-suffix`]: {
            position: "absolute",
            top: 0,
            insetInlineEnd: e.paddingInline,
            bottom: 0,
            zIndex: 1,
            display: "inline-flex",
            alignItems: "center",
            margin: "auto",
            pointerEvents: "none"
          }
        }
      },
      [`&-affix-wrapper${t}-affix-wrapper-sm`]: {
        [`${t}-suffix`]: {
          [`${t}-clear-icon`]: {
            insetInlineEnd: e.paddingInlineSM
          }
        }
      }
    }
  };
}, W3e = (e) => {
  const {
    componentCls: t
  } = e;
  return {
    [`${t}-out-of-range`]: {
      [`&, & input, & textarea, ${t}-show-count-suffix, ${t}-data-count`]: {
        color: e.colorError
      }
    }
  };
}, q6 = qa("Input", (e) => {
  const t = Or(e, H6(e));
  return [
    F3e(t),
    U3e(t),
    B3e(t),
    z3e(t),
    H3e(t),
    W3e(t),
    // =====================================================
    // ==             Space Compact                       ==
    // =====================================================
    rE(t)
  ];
}, U6, {
  resetFont: !1
});
function q3e(e, t, n) {
  var r = n || {}, i = r.noTrailing, o = i === void 0 ? !1 : i, a = r.noLeading, s = a === void 0 ? !1 : a, c = r.debounceMode, l = c === void 0 ? void 0 : c, u, d = !1, f = 0;
  function h() {
    u && clearTimeout(u);
  }
  function p(m) {
    var v = m || {}, y = v.upcomingOnly, S = y === void 0 ? !1 : y;
    h(), d = !S;
  }
  function g() {
    for (var m = arguments.length, v = new Array(m), y = 0; y < m; y++)
      v[y] = arguments[y];
    var S = this, _ = Date.now() - f;
    if (d)
      return;
    function w() {
      f = Date.now(), t.apply(S, v);
    }
    function T() {
      u = void 0;
    }
    !s && l && !u && w(), h(), l === void 0 && _ > e ? s ? (f = Date.now(), o || (u = setTimeout(l ? T : w, e))) : w() : o !== !0 && (u = setTimeout(l ? T : w, l === void 0 ? e - _ : e));
  }
  return g.cancel = p, g;
}
function G3e(e, t, n) {
  var r = n || {}, i = r.atBegin, o = i === void 0 ? !1 : i;
  return q3e(e, t, {
    debounceMode: o !== !1
  });
}
var K3e = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M890.5 755.3L537.9 269.2c-12.8-17.6-39-17.6-51.7 0L133.5 755.3A8 8 0 00140 768h75c5.1 0 9.9-2.5 12.9-6.6L512 369.8l284.1 391.6c3 4.1 7.8 6.6 12.9 6.6h75c6.5 0 10.3-7.4 6.5-12.7z" } }] }, name: "up", theme: "outlined" };
const Y3e = K3e;
var X3e = function(t, n) {
  return /* @__PURE__ */ I.createElement(fo, mt({}, t, {
    ref: n,
    icon: Y3e
  }));
}, $J = /* @__PURE__ */ I.forwardRef(X3e);
process.env.NODE_ENV !== "production" && ($J.displayName = "UpOutlined");
const Q3e = $J;
function bR() {
  return typeof BigInt == "function";
}
function OJ(e) {
  return !e && e !== 0 && !Number.isNaN(e) || !String(e).trim();
}
function Fd(e) {
  var t = e.trim(), n = t.startsWith("-");
  n && (t = t.slice(1)), t = t.replace(/(\.\d*[^0])0*$/, "$1").replace(/\.0*$/, "").replace(/^0+/, ""), t.startsWith(".") && (t = "0".concat(t));
  var r = t || "0", i = r.split("."), o = i[0] || "0", a = i[1] || "0";
  o === "0" && a === "0" && (n = !1);
  var s = n ? "-" : "";
  return {
    negative: n,
    negativeStr: s,
    trimStr: r,
    integerStr: o,
    decimalStr: a,
    fullStr: "".concat(s).concat(r)
  };
}
function G6(e) {
  var t = String(e);
  return !Number.isNaN(Number(t)) && t.includes("e");
}
function Ed(e) {
  var t = String(e);
  if (G6(e)) {
    var n = Number(t.slice(t.indexOf("e-") + 2)), r = t.match(/\.(\d+)/);
    return r != null && r[1] && (n += r[1].length), n;
  }
  return t.includes(".") && K6(t) ? t.length - t.indexOf(".") - 1 : 0;
}
function dE(e) {
  var t = String(e);
  if (G6(e)) {
    if (e > Number.MAX_SAFE_INTEGER)
      return String(bR() ? BigInt(e).toString() : Number.MAX_SAFE_INTEGER);
    if (e < Number.MIN_SAFE_INTEGER)
      return String(bR() ? BigInt(e).toString() : Number.MIN_SAFE_INTEGER);
    t = e.toFixed(Ed(t));
  }
  return Fd(t).fullStr;
}
function K6(e) {
  return typeof e == "number" ? !Number.isNaN(e) : e ? (
    // Normal type: 11.28
    /^\s*-?\d+(\.\d+)?\s*$/.test(e) || // Pre-number: 1.
    /^\s*-?\d+\.\s*$/.test(e) || // Post-number: .1
    /^\s*-?\.\d+\s*$/.test(e)
  ) : !1;
}
var J3e = /* @__PURE__ */ function() {
  function e(t) {
    if (Sr(this, e), re(this, "origin", ""), re(this, "negative", void 0), re(this, "integer", void 0), re(this, "decimal", void 0), re(this, "decimalLen", void 0), re(this, "empty", void 0), re(this, "nan", void 0), OJ(t)) {
      this.empty = !0;
      return;
    }
    if (this.origin = String(t), t === "-" || Number.isNaN(t)) {
      this.nan = !0;
      return;
    }
    var n = t;
    if (G6(n) && (n = Number(n)), n = typeof n == "string" ? n : dE(n), K6(n)) {
      var r = Fd(n);
      this.negative = r.negative;
      var i = r.trimStr.split(".");
      this.integer = BigInt(i[0]);
      var o = i[1] || "0";
      this.decimal = BigInt(o), this.decimalLen = o.length;
    } else
      this.nan = !0;
  }
  return wr(e, [{
    key: "getMark",
    value: function() {
      return this.negative ? "-" : "";
    }
  }, {
    key: "getIntegerStr",
    value: function() {
      return this.integer.toString();
    }
    /**
     * @private get decimal string
     */
  }, {
    key: "getDecimalStr",
    value: function() {
      return this.decimal.toString().padStart(this.decimalLen, "0");
    }
    /**
     * @private Align BigIntDecimal with same decimal length. e.g. 12.3 + 5 = 1230000
     * This is used for add function only.
     */
  }, {
    key: "alignDecimal",
    value: function(n) {
      var r = "".concat(this.getMark()).concat(this.getIntegerStr()).concat(this.getDecimalStr().padEnd(n, "0"));
      return BigInt(r);
    }
  }, {
    key: "negate",
    value: function() {
      var n = new e(this.toString());
      return n.negative = !n.negative, n;
    }
  }, {
    key: "cal",
    value: function(n, r, i) {
      var o = Math.max(this.getDecimalStr().length, n.getDecimalStr().length), a = this.alignDecimal(o), s = n.alignDecimal(o), c = r(a, s).toString(), l = i(o), u = Fd(c), d = u.negativeStr, f = u.trimStr, h = "".concat(d).concat(f.padStart(l + 1, "0"));
      return new e("".concat(h.slice(0, -l), ".").concat(h.slice(-l)));
    }
  }, {
    key: "add",
    value: function(n) {
      if (this.isInvalidate())
        return new e(n);
      var r = new e(n);
      return r.isInvalidate() ? this : this.cal(r, function(i, o) {
        return i + o;
      }, function(i) {
        return i;
      });
    }
  }, {
    key: "multi",
    value: function(n) {
      var r = new e(n);
      return this.isInvalidate() || r.isInvalidate() ? new e(NaN) : this.cal(r, function(i, o) {
        return i * o;
      }, function(i) {
        return i * 2;
      });
    }
  }, {
    key: "isEmpty",
    value: function() {
      return this.empty;
    }
  }, {
    key: "isNaN",
    value: function() {
      return this.nan;
    }
  }, {
    key: "isInvalidate",
    value: function() {
      return this.isEmpty() || this.isNaN();
    }
  }, {
    key: "equals",
    value: function(n) {
      return this.toString() === (n == null ? void 0 : n.toString());
    }
  }, {
    key: "lessEquals",
    value: function(n) {
      return this.add(n.negate().toString()).toNumber() <= 0;
    }
  }, {
    key: "toNumber",
    value: function() {
      return this.isNaN() ? NaN : Number(this.toString());
    }
  }, {
    key: "toString",
    value: function() {
      var n = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !0;
      return n ? this.isInvalidate() ? "" : Fd("".concat(this.getMark()).concat(this.getIntegerStr(), ".").concat(this.getDecimalStr())).fullStr : this.origin;
    }
  }]), e;
}(), Z3e = /* @__PURE__ */ function() {
  function e(t) {
    if (Sr(this, e), re(this, "origin", ""), re(this, "number", void 0), re(this, "empty", void 0), OJ(t)) {
      this.empty = !0;
      return;
    }
    this.origin = String(t), this.number = Number(t);
  }
  return wr(e, [{
    key: "negate",
    value: function() {
      return new e(-this.toNumber());
    }
  }, {
    key: "add",
    value: function(n) {
      if (this.isInvalidate())
        return new e(n);
      var r = Number(n);
      if (Number.isNaN(r))
        return this;
      var i = this.number + r;
      if (i > Number.MAX_SAFE_INTEGER)
        return new e(Number.MAX_SAFE_INTEGER);
      if (i < Number.MIN_SAFE_INTEGER)
        return new e(Number.MIN_SAFE_INTEGER);
      var o = Math.max(Ed(this.number), Ed(r));
      return new e(i.toFixed(o));
    }
  }, {
    key: "multi",
    value: function(n) {
      var r = Number(n);
      if (this.isInvalidate() || Number.isNaN(r))
        return new e(NaN);
      var i = this.number * r;
      if (i > Number.MAX_SAFE_INTEGER)
        return new e(Number.MAX_SAFE_INTEGER);
      if (i < Number.MIN_SAFE_INTEGER)
        return new e(Number.MIN_SAFE_INTEGER);
      var o = Math.max(Ed(this.number), Ed(r));
      return new e(i.toFixed(o));
    }
  }, {
    key: "isEmpty",
    value: function() {
      return this.empty;
    }
  }, {
    key: "isNaN",
    value: function() {
      return Number.isNaN(this.number);
    }
  }, {
    key: "isInvalidate",
    value: function() {
      return this.isEmpty() || this.isNaN();
    }
  }, {
    key: "equals",
    value: function(n) {
      return this.toNumber() === (n == null ? void 0 : n.toNumber());
    }
  }, {
    key: "lessEquals",
    value: function(n) {
      return this.add(n.negate().toString()).toNumber() <= 0;
    }
  }, {
    key: "toNumber",
    value: function() {
      return this.number;
    }
  }, {
    key: "toString",
    value: function() {
      var n = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !0;
      return n ? this.isInvalidate() ? "" : dE(this.number) : this.origin;
    }
  }]), e;
}();
function rs(e) {
  return bR() ? new J3e(e) : new Z3e(e);
}
function G1(e, t, n) {
  var r = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : !1;
  if (e === "")
    return "";
  var i = Fd(e), o = i.negativeStr, a = i.integerStr, s = i.decimalStr, c = "".concat(t).concat(s), l = "".concat(o).concat(a);
  if (n >= 0) {
    var u = Number(s[n]);
    if (u >= 5 && !r) {
      var d = rs(e).add("".concat(o, "0.").concat("0".repeat(n)).concat(10 - u));
      return G1(d.toString(), t, n, r);
    }
    return n === 0 ? l : "".concat(l).concat(t).concat(s.padEnd(n, "0").slice(0, n));
  }
  return c === ".0" ? l : "".concat(l).concat(c);
}
function eke(e) {
  return !!(e.addonBefore || e.addonAfter);
}
function tke(e) {
  return !!(e.prefix || e.suffix || e.allowClear);
}
function lj(e, t, n) {
  var r = t.cloneNode(!0), i = Object.create(e, {
    target: {
      value: r
    },
    currentTarget: {
      value: r
    }
  });
  return r.value = n, typeof t.selectionStart == "number" && typeof t.selectionEnd == "number" && (r.selectionStart = t.selectionStart, r.selectionEnd = t.selectionEnd), r.setSelectionRange = function() {
    t.setSelectionRange.apply(t, arguments);
  }, i;
}
function jS(e, t, n, r) {
  if (n) {
    var i = t;
    if (t.type === "click") {
      i = lj(t, e, ""), n(i);
      return;
    }
    if (e.type !== "file" && r !== void 0) {
      i = lj(t, e, r), n(i);
      return;
    }
    n(i);
  }
}
function Y6(e, t) {
  if (e) {
    e.focus(t);
    var n = t || {}, r = n.cursor;
    if (r) {
      var i = e.value.length;
      switch (r) {
        case "start":
          e.setSelectionRange(0, 0);
          break;
        case "end":
          e.setSelectionRange(i, i);
          break;
        default:
          e.setSelectionRange(0, i);
      }
    }
  }
}
var fE = /* @__PURE__ */ D.forwardRef(function(e, t) {
  var n, r, i = e.inputElement, o = e.children, a = e.prefixCls, s = e.prefix, c = e.suffix, l = e.addonBefore, u = e.addonAfter, d = e.className, f = e.style, h = e.disabled, p = e.readOnly, g = e.focused, m = e.triggerFocus, v = e.allowClear, y = e.value, S = e.handleReset, _ = e.hidden, w = e.classes, T = e.classNames, x = e.dataAttrs, C = e.styles, E = e.components, R = e.onClear, A = o ?? i, O = (E == null ? void 0 : E.affixWrapper) || "span", $ = (E == null ? void 0 : E.groupWrapper) || "span", N = (E == null ? void 0 : E.wrapper) || "span", z = (E == null ? void 0 : E.groupAddon) || "span", k = Me(null), F = function(W) {
    var se;
    (se = k.current) !== null && se !== void 0 && se.contains(W.target) && (m == null || m());
  }, V = tke(e), j = /* @__PURE__ */ $z(A, {
    value: y,
    className: we(A.props.className, !V && (T == null ? void 0 : T.variant)) || null
  }), B = Me(null);
  if (D.useImperativeHandle(t, function() {
    return {
      nativeElement: B.current || k.current
    };
  }), V) {
    var U = null;
    if (v) {
      var Q = !h && !p && y, K = "".concat(a, "-clear-icon"), q = _t(v) === "object" && v !== null && v !== void 0 && v.clearIcon ? v.clearIcon : "✖";
      U = /* @__PURE__ */ D.createElement("span", {
        onClick: function(W) {
          S == null || S(W), R == null || R();
        },
        onMouseDown: function(W) {
          return W.preventDefault();
        },
        className: we(K, re(re({}, "".concat(K, "-hidden"), !Q), "".concat(K, "-has-suffix"), !!c)),
        role: "button",
        tabIndex: -1
      }, q);
    }
    var X = "".concat(a, "-affix-wrapper"), ie = we(X, re(re(re(re(re({}, "".concat(a, "-disabled"), h), "".concat(X, "-disabled"), h), "".concat(X, "-focused"), g), "".concat(X, "-readonly"), p), "".concat(X, "-input-with-clear-btn"), c && v && y), w == null ? void 0 : w.affixWrapper, T == null ? void 0 : T.affixWrapper, T == null ? void 0 : T.variant), te = (c || v) && /* @__PURE__ */ D.createElement("span", {
      className: we("".concat(a, "-suffix"), T == null ? void 0 : T.suffix),
      style: C == null ? void 0 : C.suffix
    }, U, c);
    j = /* @__PURE__ */ D.createElement(O, mt({
      className: ie,
      style: C == null ? void 0 : C.affixWrapper,
      onClick: F
    }, x == null ? void 0 : x.affixWrapper, {
      ref: k
    }), s && /* @__PURE__ */ D.createElement("span", {
      className: we("".concat(a, "-prefix"), T == null ? void 0 : T.prefix),
      style: C == null ? void 0 : C.prefix
    }, s), j, te);
  }
  if (eke(e)) {
    var J = "".concat(a, "-group"), Y = "".concat(J, "-addon"), ee = "".concat(J, "-wrapper"), Z = we("".concat(a, "-wrapper"), J, w == null ? void 0 : w.wrapper, T == null ? void 0 : T.wrapper), H = we(ee, re({}, "".concat(ee, "-disabled"), h), w == null ? void 0 : w.group, T == null ? void 0 : T.groupWrapper);
    j = /* @__PURE__ */ D.createElement($, {
      className: H,
      ref: B
    }, /* @__PURE__ */ D.createElement(N, {
      className: Z
    }, l && /* @__PURE__ */ D.createElement(z, {
      className: Y
    }, l), j, u && /* @__PURE__ */ D.createElement(z, {
      className: Y
    }, u)));
  }
  return /* @__PURE__ */ D.cloneElement(j, {
    className: we((n = j.props) === null || n === void 0 ? void 0 : n.className, d) || null,
    style: ae(ae({}, (r = j.props) === null || r === void 0 ? void 0 : r.style), f),
    hidden: _
  });
}), nke = ["show"];
function PJ(e, t) {
  return I.useMemo(function() {
    var n = {};
    t && (n.show = _t(t) === "object" && t.formatter ? t.formatter : !!t), n = ae(ae({}, n), e);
    var r = n, i = r.show, o = xn(r, nke);
    return ae(ae({}, o), {}, {
      show: !!i,
      showFormatter: typeof i == "function" ? i : void 0,
      strategy: o.strategy || function(a) {
        return a.length;
      }
    });
  }, [e, t]);
}
var rke = ["autoComplete", "onChange", "onFocus", "onBlur", "onPressEnter", "onKeyDown", "onKeyUp", "prefixCls", "disabled", "htmlSize", "className", "maxLength", "suffix", "showCount", "count", "type", "classes", "classNames", "styles", "onCompositionStart", "onCompositionEnd"], MJ = /* @__PURE__ */ ta(function(e, t) {
  var n = e.autoComplete, r = e.onChange, i = e.onFocus, o = e.onBlur, a = e.onPressEnter, s = e.onKeyDown, c = e.onKeyUp, l = e.prefixCls, u = l === void 0 ? "rc-input" : l, d = e.disabled, f = e.htmlSize, h = e.className, p = e.maxLength, g = e.suffix, m = e.showCount, v = e.count, y = e.type, S = y === void 0 ? "text" : y, _ = e.classes, w = e.classNames, T = e.styles, x = e.onCompositionStart, C = e.onCompositionEnd, E = xn(e, rke), R = Lt(!1), A = fe(R, 2), O = A[0], $ = A[1], N = Me(!1), z = Me(!1), k = Me(null), F = Me(null), V = function(be) {
    k.current && Y6(k.current, be);
  }, j = hc(e.defaultValue, {
    value: e.value
  }), B = fe(j, 2), U = B[0], Q = B[1], K = U == null ? "" : String(U), q = Lt(null), X = fe(q, 2), ie = X[0], te = X[1], J = PJ(v, m), Y = J.max || p, ee = J.strategy(K), Z = !!Y && ee > Y;
  tO(t, function() {
    var de;
    return {
      focus: V,
      blur: function() {
        var Ie;
        (Ie = k.current) === null || Ie === void 0 || Ie.blur();
      },
      setSelectionRange: function(Ie, Ve, Fe) {
        var Pe;
        (Pe = k.current) === null || Pe === void 0 || Pe.setSelectionRange(Ie, Ve, Fe);
      },
      select: function() {
        var Ie;
        (Ie = k.current) === null || Ie === void 0 || Ie.select();
      },
      input: k.current,
      nativeElement: ((de = F.current) === null || de === void 0 ? void 0 : de.nativeElement) || k.current
    };
  }), gt(function() {
    $(function(de) {
      return de && d ? !1 : de;
    });
  }, [d]);
  var H = function(be, Ie, Ve) {
    var Fe = Ie;
    if (!N.current && J.exceedFormatter && J.max && J.strategy(Ie) > J.max) {
      if (Fe = J.exceedFormatter(Ie, {
        max: J.max
      }), Ie !== Fe) {
        var Pe, ot;
        te([((Pe = k.current) === null || Pe === void 0 ? void 0 : Pe.selectionStart) || 0, ((ot = k.current) === null || ot === void 0 ? void 0 : ot.selectionEnd) || 0]);
      }
    } else if (Ve.source === "compositionEnd")
      return;
    Q(Fe), k.current && jS(k.current, be, r, Fe);
  };
  gt(function() {
    if (ie) {
      var de;
      (de = k.current) === null || de === void 0 || de.setSelectionRange.apply(de, Je(ie));
    }
  }, [ie]);
  var oe = function(be) {
    H(be, be.target.value, {
      source: "change"
    });
  }, W = function(be) {
    N.current = !1, H(be, be.currentTarget.value, {
      source: "compositionEnd"
    }), C == null || C(be);
  }, se = function(be) {
    a && be.key === "Enter" && !z.current && (z.current = !0, a(be)), s == null || s(be);
  }, ce = function(be) {
    be.key === "Enter" && (z.current = !1), c == null || c(be);
  }, ge = function(be) {
    $(!0), i == null || i(be);
  }, he = function(be) {
    $(!1), o == null || o(be);
  }, ue = function(be) {
    Q(""), V(), k.current && jS(k.current, be, r);
  }, Ee = Z && "".concat(u, "-out-of-range"), pe = function() {
    var be = Hu(e, [
      "prefixCls",
      "onPressEnter",
      "addonBefore",
      "addonAfter",
      "prefix",
      "suffix",
      "allowClear",
      // Input elements must be either controlled or uncontrolled,
      // specify either the value prop, or the defaultValue prop, but not both.
      "defaultValue",
      "showCount",
      "count",
      "classes",
      "htmlSize",
      "styles",
      "classNames",
      "onClear"
    ]);
    return /* @__PURE__ */ D.createElement("input", mt({
      autoComplete: n
    }, be, {
      onChange: oe,
      onFocus: ge,
      onBlur: he,
      onKeyDown: se,
      onKeyUp: ce,
      className: we(u, re({}, "".concat(u, "-disabled"), d), w == null ? void 0 : w.input),
      style: T == null ? void 0 : T.input,
      ref: k,
      size: f,
      type: S,
      onCompositionStart: function(Ve) {
        N.current = !0, x == null || x(Ve);
      },
      onCompositionEnd: W
    }));
  }, Oe = function() {
    var be = Number(Y) > 0;
    if (g || J.show) {
      var Ie = J.showFormatter ? J.showFormatter({
        value: K,
        count: ee,
        maxLength: Y
      }) : "".concat(ee).concat(be ? " / ".concat(Y) : "");
      return /* @__PURE__ */ D.createElement(D.Fragment, null, J.show && /* @__PURE__ */ D.createElement("span", {
        className: we("".concat(u, "-show-count-suffix"), re({}, "".concat(u, "-show-count-has-suffix"), !!g), w == null ? void 0 : w.count),
        style: ae({}, T == null ? void 0 : T.count)
      }, Ie), g);
    }
    return null;
  };
  return /* @__PURE__ */ D.createElement(fE, mt({}, E, {
    prefixCls: u,
    className: we(h, Ee),
    handleReset: ue,
    value: K,
    focused: O,
    triggerFocus: V,
    suffix: Oe(),
    disabled: d,
    classes: _,
    classNames: w,
    styles: T
  }), pe());
});
const ike = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  BaseInput: fE,
  default: MJ
}, Symbol.toStringTag, { value: "Module" }));
function oke(e, t) {
  return typeof Proxy < "u" && e ? new Proxy(e, {
    get: function(r, i) {
      if (t[i])
        return t[i];
      var o = r[i];
      return typeof o == "function" ? o.bind(r) : o;
    }
  }) : e;
}
function ake(e, t) {
  var n = Me(null);
  function r() {
    try {
      var o = e.selectionStart, a = e.selectionEnd, s = e.value, c = s.substring(0, o), l = s.substring(a);
      n.current = {
        start: o,
        end: a,
        value: s,
        beforeTxt: c,
        afterTxt: l
      };
    } catch {
    }
  }
  function i() {
    if (e && n.current && t)
      try {
        var o = e.value, a = n.current, s = a.beforeTxt, c = a.afterTxt, l = a.start, u = o.length;
        if (o.startsWith(s))
          u = s.length;
        else if (o.endsWith(c))
          u = o.length - n.current.afterTxt.length;
        else {
          var d = s[l - 1], f = o.indexOf(d, l - 1);
          f !== -1 && (u = f + 1);
        }
        e.setSelectionRange(u, u);
      } catch (h) {
        an(!1, "Something warning of cursor restore. Please fire issue about this: ".concat(h.message));
      }
  }
  return [r, i];
}
var ske = function() {
  var t = Lt(!1), n = fe(t, 2), r = n[0], i = n[1];
  return nr(function() {
    i(k6());
  }, []), r;
}, cke = 200, lke = 600;
function uke(e) {
  var t = e.prefixCls, n = e.upNode, r = e.downNode, i = e.upDisabled, o = e.downDisabled, a = e.onStep, s = I.useRef(), c = I.useRef([]), l = I.useRef();
  l.current = a;
  var u = function() {
    clearTimeout(s.current);
  }, d = function(S, _) {
    S.preventDefault(), u(), l.current(_);
    function w() {
      l.current(_), s.current = setTimeout(w, cke);
    }
    s.current = setTimeout(w, lke);
  };
  I.useEffect(function() {
    return function() {
      u(), c.current.forEach(function(y) {
        return Ln.cancel(y);
      });
    };
  }, []);
  var f = ske();
  if (f)
    return null;
  var h = "".concat(t, "-handler"), p = we(h, "".concat(h, "-up"), re({}, "".concat(h, "-up-disabled"), i)), g = we(h, "".concat(h, "-down"), re({}, "".concat(h, "-down-disabled"), o)), m = function() {
    return c.current.push(Ln(u));
  }, v = {
    unselectable: "on",
    role: "button",
    onMouseUp: m,
    onMouseLeave: m
  };
  return /* @__PURE__ */ I.createElement("div", {
    className: "".concat(h, "-wrap")
  }, /* @__PURE__ */ I.createElement("span", mt({}, v, {
    onMouseDown: function(S) {
      d(S, !0);
    },
    "aria-label": "Increase Value",
    "aria-disabled": i,
    className: p
  }), n || /* @__PURE__ */ I.createElement("span", {
    unselectable: "on",
    className: "".concat(t, "-handler-up-inner")
  })), /* @__PURE__ */ I.createElement("span", mt({}, v, {
    onMouseDown: function(S) {
      d(S, !1);
    },
    "aria-label": "Decrease Value",
    "aria-disabled": o,
    className: g
  }), r || /* @__PURE__ */ I.createElement("span", {
    unselectable: "on",
    className: "".concat(t, "-handler-down-inner")
  })));
}
function uj(e) {
  var t = typeof e == "number" ? dE(e) : Fd(e).fullStr, n = t.includes(".");
  return n ? Fd(t.replace(/(\d)\.(\d)/g, "$1$2.")).fullStr : e + "0";
}
const dke = function() {
  var e = Me(0), t = function() {
    Ln.cancel(e.current);
  };
  return gt(function() {
    return t;
  }, []), function(n) {
    t(), e.current = Ln(function() {
      n();
    });
  };
};
var fke = ["prefixCls", "className", "style", "min", "max", "step", "defaultValue", "value", "disabled", "readOnly", "upHandler", "downHandler", "keyboard", "changeOnWheel", "controls", "classNames", "stringMode", "parser", "formatter", "precision", "decimalSeparator", "onChange", "onInput", "onPressEnter", "onStep", "changeOnBlur", "domRef"], hke = ["disabled", "style", "prefixCls", "value", "prefix", "suffix", "addonBefore", "addonAfter", "className", "classNames"], dj = function(t, n) {
  return t || n.isEmpty() ? n.toString() : n.toNumber();
}, fj = function(t) {
  var n = rs(t);
  return n.isInvalidate() ? null : n;
}, gke = /* @__PURE__ */ I.forwardRef(function(e, t) {
  var n = e.prefixCls, r = e.className, i = e.style, o = e.min, a = e.max, s = e.step, c = s === void 0 ? 1 : s, l = e.defaultValue, u = e.value, d = e.disabled, f = e.readOnly, h = e.upHandler, p = e.downHandler, g = e.keyboard, m = e.changeOnWheel, v = m === void 0 ? !1 : m, y = e.controls, S = y === void 0 ? !0 : y;
  e.classNames;
  var _ = e.stringMode, w = e.parser, T = e.formatter, x = e.precision, C = e.decimalSeparator, E = e.onChange, R = e.onInput, A = e.onPressEnter, O = e.onStep, $ = e.changeOnBlur, N = $ === void 0 ? !0 : $, z = e.domRef, k = xn(e, fke), F = "".concat(n, "-input"), V = I.useRef(null), j = I.useState(!1), B = fe(j, 2), U = B[0], Q = B[1], K = I.useRef(!1), q = I.useRef(!1), X = I.useRef(!1), ie = I.useState(function() {
    return rs(u ?? l);
  }), te = fe(ie, 2), J = te[0], Y = te[1];
  function ee(Ze) {
    u === void 0 && Y(Ze);
  }
  var Z = I.useCallback(function(Ze, Le) {
    if (!Le)
      return x >= 0 ? x : Math.max(Ed(Ze), Ed(c));
  }, [x, c]), H = I.useCallback(function(Ze) {
    var Le = String(Ze);
    if (w)
      return w(Le);
    var rt = Le;
    return C && (rt = rt.replace(C, ".")), rt.replace(/[^\w.-]+/g, "");
  }, [w, C]), oe = I.useRef(""), W = I.useCallback(function(Ze, Le) {
    if (T)
      return T(Ze, {
        userTyping: Le,
        input: String(oe.current)
      });
    var rt = typeof Ze == "number" ? dE(Ze) : Ze;
    if (!Le) {
      var ut = Z(rt, Le);
      if (K6(rt) && (C || ut >= 0)) {
        var vt = C || ".";
        rt = G1(rt, vt, ut);
      }
    }
    return rt;
  }, [T, Z, C]), se = I.useState(function() {
    var Ze = l ?? u;
    return J.isInvalidate() && ["string", "number"].includes(_t(Ze)) ? Number.isNaN(Ze) ? "" : Ze : W(J.toString(), !1);
  }), ce = fe(se, 2), ge = ce[0], he = ce[1];
  oe.current = ge;
  function ue(Ze, Le) {
    he(W(
      // Invalidate number is sometime passed by external control, we should let it go
      // Otherwise is controlled by internal interactive logic which check by userTyping
      // You can ref 'show limited value when input is not focused' test for more info.
      Ze.isInvalidate() ? Ze.toString(!1) : Ze.toString(!Le),
      Le
    ));
  }
  var Ee = I.useMemo(function() {
    return fj(a);
  }, [a, x]), pe = I.useMemo(function() {
    return fj(o);
  }, [o, x]), Oe = I.useMemo(function() {
    return !Ee || !J || J.isInvalidate() ? !1 : Ee.lessEquals(J);
  }, [Ee, J]), de = I.useMemo(function() {
    return !pe || !J || J.isInvalidate() ? !1 : J.lessEquals(pe);
  }, [pe, J]), be = ake(V.current, U), Ie = fe(be, 2), Ve = Ie[0], Fe = Ie[1], Pe = function(Le) {
    return Ee && !Le.lessEquals(Ee) ? Ee : pe && !pe.lessEquals(Le) ? pe : null;
  }, ot = function(Le) {
    return !Pe(Le);
  }, dt = function(Le, rt) {
    var ut = Le, vt = ot(ut) || ut.isEmpty();
    if (!ut.isEmpty() && !rt && (ut = Pe(ut) || ut, vt = !0), !f && !d && vt) {
      var We = ut.toString(), et = Z(We, rt);
      return et >= 0 && (ut = rs(G1(We, ".", et)), ot(ut) || (ut = rs(G1(We, ".", et, !0)))), ut.equals(J) || (ee(ut), E == null || E(ut.isEmpty() ? null : dj(_, ut)), u === void 0 && ue(ut, rt)), ut;
    }
    return J;
  }, ft = dke(), wt = function Ze(Le) {
    if (Ve(), oe.current = Le, he(Le), !q.current) {
      var rt = H(Le), ut = rs(rt);
      ut.isNaN() || dt(ut, !0);
    }
    R == null || R(Le), ft(function() {
      var vt = Le;
      w || (vt = Le.replace(/。/g, ".")), vt !== Le && Ze(vt);
    });
  }, Ge = function() {
    q.current = !0;
  }, at = function() {
    q.current = !1, wt(V.current.value);
  }, Nt = function(Le) {
    wt(Le.target.value);
  }, zt = function(Le) {
    var rt;
    if (!(Le && Oe || !Le && de)) {
      K.current = !1;
      var ut = rs(X.current ? uj(c) : c);
      Le || (ut = ut.negate());
      var vt = (J || rs(0)).add(ut.toString()), We = dt(vt, !1);
      O == null || O(dj(_, We), {
        offset: X.current ? uj(c) : c,
        type: Le ? "up" : "down"
      }), (rt = V.current) === null || rt === void 0 || rt.focus();
    }
  }, kt = function(Le) {
    var rt = rs(H(ge)), ut;
    rt.isNaN() ? ut = dt(J, Le) : ut = dt(rt, Le), u !== void 0 ? ue(J, !1) : ut.isNaN() || ue(ut, !1);
  }, Ct = function() {
    K.current = !0;
  }, yt = function(Le) {
    var rt = Le.key, ut = Le.shiftKey;
    K.current = !0, X.current = ut, rt === "Enter" && (q.current || (K.current = !1), kt(!1), A == null || A(Le)), g !== !1 && !q.current && ["Up", "ArrowUp", "Down", "ArrowDown"].includes(rt) && (zt(rt === "Up" || rt === "ArrowUp"), Le.preventDefault());
  }, Mn = function() {
    K.current = !1, X.current = !1;
  };
  I.useEffect(function() {
    if (v && U) {
      var Ze = function(ut) {
        zt(ut.deltaY < 0), ut.preventDefault();
      }, Le = V.current;
      if (Le)
        return Le.addEventListener("wheel", Ze, {
          passive: !1
        }), function() {
          return Le.removeEventListener("wheel", Ze);
        };
    }
  });
  var Pt = function() {
    N && kt(!1), Q(!1), K.current = !1;
  };
  return b0(function() {
    J.isInvalidate() || ue(J, !1);
  }, [x, T]), b0(function() {
    var Ze = rs(u);
    Y(Ze);
    var Le = rs(H(ge));
    (!Ze.equals(Le) || !K.current || T) && ue(Ze, K.current);
  }, [u]), b0(function() {
    T && Fe();
  }, [ge]), /* @__PURE__ */ I.createElement("div", {
    ref: z,
    className: we(n, r, re(re(re(re(re({}, "".concat(n, "-focused"), U), "".concat(n, "-disabled"), d), "".concat(n, "-readonly"), f), "".concat(n, "-not-a-number"), J.isNaN()), "".concat(n, "-out-of-range"), !J.isInvalidate() && !ot(J))),
    style: i,
    onFocus: function() {
      Q(!0);
    },
    onBlur: Pt,
    onKeyDown: yt,
    onKeyUp: Mn,
    onCompositionStart: Ge,
    onCompositionEnd: at,
    onBeforeInput: Ct
  }, S && /* @__PURE__ */ I.createElement(uke, {
    prefixCls: n,
    upNode: h,
    downNode: p,
    upDisabled: Oe,
    downDisabled: de,
    onStep: zt
  }), /* @__PURE__ */ I.createElement("div", {
    className: "".concat(F, "-wrap")
  }, /* @__PURE__ */ I.createElement("input", mt({
    autoComplete: "off",
    role: "spinbutton",
    "aria-valuemin": o,
    "aria-valuemax": a,
    "aria-valuenow": J.isInvalidate() ? null : J.toString(),
    step: c
  }, k, {
    ref: Wa(V, t),
    className: F,
    value: ge,
    onChange: Nt,
    disabled: d,
    readOnly: f
  }))));
}), kJ = /* @__PURE__ */ I.forwardRef(function(e, t) {
  var n = e.disabled, r = e.style, i = e.prefixCls, o = i === void 0 ? "rc-input-number" : i, a = e.value, s = e.prefix, c = e.suffix, l = e.addonBefore, u = e.addonAfter, d = e.className, f = e.classNames, h = xn(e, hke), p = I.useRef(null), g = I.useRef(null), m = I.useRef(null), v = function(S) {
    m.current && Y6(m.current, S);
  };
  return I.useImperativeHandle(t, function() {
    return oke(m.current, {
      focus: v,
      nativeElement: p.current.nativeElement || g.current
    });
  }), /* @__PURE__ */ I.createElement(fE, {
    className: d,
    triggerFocus: v,
    prefixCls: o,
    value: a,
    disabled: n,
    style: r,
    prefix: s,
    suffix: c,
    addonAfter: u,
    addonBefore: l,
    classNames: f,
    components: {
      affixWrapper: "div",
      groupWrapper: "div",
      wrapper: "div",
      groupAddon: "div"
    },
    ref: p
  }, /* @__PURE__ */ I.createElement(gke, mt({
    prefixCls: o,
    disabled: n,
    ref: m,
    domRef: g,
    className: f == null ? void 0 : f.input
  }, h)));
});
process.env.NODE_ENV !== "production" && (kJ.displayName = "InputNumber");
const pke = (e) => {
  var t;
  const n = (t = e.handleVisible) !== null && t !== void 0 ? t : "auto";
  return Object.assign(Object.assign({}, U6(e)), {
    controlWidth: 90,
    handleWidth: e.controlHeightSM - e.lineWidth * 2,
    handleFontSize: e.fontSize / 2,
    handleVisible: n,
    handleActiveBg: e.colorFillAlter,
    handleBg: e.colorBgContainer,
    filledHandleBg: new Pn(e.colorFillSecondary).onBackground(e.colorBgContainer).toHexString(),
    handleHoverColor: e.colorPrimary,
    handleBorderColor: e.colorBorder,
    handleOpacity: n === !0 ? 1 : 0
  });
}, hj = (e, t) => {
  let {
    componentCls: n,
    borderRadiusSM: r,
    borderRadiusLG: i
  } = e;
  const o = t === "lg" ? i : r;
  return {
    [`&-${t}`]: {
      [`${n}-handler-wrap`]: {
        borderStartEndRadius: o,
        borderEndEndRadius: o
      },
      [`${n}-handler-up`]: {
        borderStartEndRadius: o
      },
      [`${n}-handler-down`]: {
        borderEndEndRadius: o
      }
    }
  };
}, mke = (e) => {
  const {
    componentCls: t,
    lineWidth: n,
    lineType: r,
    borderRadius: i,
    inputFontSizeSM: o,
    inputFontSizeLG: a,
    controlHeightLG: s,
    controlHeightSM: c,
    colorError: l,
    paddingInlineSM: u,
    paddingBlockSM: d,
    paddingBlockLG: f,
    paddingInlineLG: h,
    colorTextDescription: p,
    motionDurationMid: g,
    handleHoverColor: m,
    handleOpacity: v,
    paddingInline: y,
    paddingBlock: S,
    handleBg: _,
    handleActiveBg: w,
    colorTextDisabled: T,
    borderRadiusSM: x,
    borderRadiusLG: C,
    controlWidth: E,
    handleBorderColor: R,
    filledHandleBg: A,
    lineHeightLG: O,
    calc: $
  } = e;
  return [
    {
      [t]: Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, va(e)), uE(e)), {
        display: "inline-block",
        width: E,
        margin: 0,
        padding: 0,
        borderRadius: i
      }), _J(e, {
        [`${t}-handler-wrap`]: {
          background: _,
          [`${t}-handler-down`]: {
            borderBlockStart: `${Qe(n)} ${r} ${R}`
          }
        }
      })), EJ(e, {
        [`${t}-handler-wrap`]: {
          background: A,
          [`${t}-handler-down`]: {
            borderBlockStart: `${Qe(n)} ${r} ${R}`
          }
        },
        "&:focus-within": {
          [`${t}-handler-wrap`]: {
            background: _
          }
        }
      })), wJ(e)), {
        "&-rtl": {
          direction: "rtl",
          [`${t}-input`]: {
            direction: "rtl"
          }
        },
        "&-lg": {
          padding: 0,
          fontSize: a,
          lineHeight: O,
          borderRadius: C,
          [`input${t}-input`]: {
            height: $(s).sub($(n).mul(2)).equal(),
            padding: `${Qe(f)} ${Qe(h)}`
          }
        },
        "&-sm": {
          padding: 0,
          fontSize: o,
          borderRadius: x,
          [`input${t}-input`]: {
            height: $(c).sub($(n).mul(2)).equal(),
            padding: `${Qe(d)} ${Qe(u)}`
          }
        },
        // ===================== Out Of Range =====================
        "&-out-of-range": {
          [`${t}-input-wrap`]: {
            input: {
              color: l
            }
          }
        },
        // Style for input-group: input with label, with button or dropdown...
        "&-group": Object.assign(Object.assign(Object.assign({}, va(e)), RJ(e)), {
          "&-wrapper": Object.assign(Object.assign(Object.assign({
            display: "inline-block",
            textAlign: "start",
            verticalAlign: "top",
            [`${t}-affix-wrapper`]: {
              width: "100%"
            },
            // Size
            "&-lg": {
              [`${t}-group-addon`]: {
                borderRadius: C,
                fontSize: e.fontSizeLG
              }
            },
            "&-sm": {
              [`${t}-group-addon`]: {
                borderRadius: x
              }
            }
          }, SJ(e)), CJ(e)), {
            // Fix the issue of using icons in Space Compact mode
            // https://github.com/ant-design/ant-design/issues/45764
            [`&:not(${t}-compact-first-item):not(${t}-compact-last-item)${t}-compact-item`]: {
              [`${t}, ${t}-group-addon`]: {
                borderRadius: 0
              }
            },
            [`&:not(${t}-compact-last-item)${t}-compact-first-item`]: {
              [`${t}, ${t}-group-addon`]: {
                borderStartEndRadius: 0,
                borderEndEndRadius: 0
              }
            },
            [`&:not(${t}-compact-first-item)${t}-compact-last-item`]: {
              [`${t}, ${t}-group-addon`]: {
                borderStartStartRadius: 0,
                borderEndStartRadius: 0
              }
            }
          })
        }),
        [`&-disabled ${t}-input`]: {
          cursor: "not-allowed"
        },
        [t]: {
          "&-input": Object.assign(Object.assign(Object.assign(Object.assign({}, va(e)), {
            width: "100%",
            padding: `${Qe(S)} ${Qe(y)}`,
            textAlign: "start",
            backgroundColor: "transparent",
            border: 0,
            borderRadius: i,
            outline: 0,
            transition: `all ${g} linear`,
            appearance: "textfield",
            fontSize: "inherit"
          }), TJ(e.colorTextPlaceholder)), {
            '&[type="number"]::-webkit-inner-spin-button, &[type="number"]::-webkit-outer-spin-button': {
              margin: 0,
              webkitAppearance: "none",
              appearance: "none"
            }
          })
        },
        [`&:hover ${t}-handler-wrap, &-focused ${t}-handler-wrap`]: {
          width: e.handleWidth,
          opacity: 1
        }
      })
    },
    // Handler
    {
      [t]: Object.assign(Object.assign(Object.assign({
        [`${t}-handler-wrap`]: {
          position: "absolute",
          insetBlockStart: 0,
          insetInlineEnd: 0,
          width: 0,
          opacity: v,
          height: "100%",
          borderStartStartRadius: 0,
          borderStartEndRadius: i,
          borderEndEndRadius: i,
          borderEndStartRadius: 0,
          display: "flex",
          flexDirection: "column",
          alignItems: "stretch",
          transition: `all ${g}`,
          overflow: "hidden",
          // Fix input number inside Menu makes icon too large
          // We arise the selector priority by nest selector here
          // https://github.com/ant-design/ant-design/issues/14367
          [`${t}-handler`]: {
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flex: "auto",
            height: "40%",
            [`
              ${t}-handler-up-inner,
              ${t}-handler-down-inner
            `]: {
              marginInlineEnd: 0,
              fontSize: e.handleFontSize
            }
          }
        },
        [`${t}-handler`]: {
          height: "50%",
          overflow: "hidden",
          color: p,
          fontWeight: "bold",
          lineHeight: 0,
          textAlign: "center",
          cursor: "pointer",
          borderInlineStart: `${Qe(n)} ${r} ${R}`,
          transition: `all ${g} linear`,
          "&:active": {
            background: w
          },
          // Hover
          "&:hover": {
            height: "60%",
            [`
              ${t}-handler-up-inner,
              ${t}-handler-down-inner
            `]: {
              color: m
            }
          },
          "&-up-inner, &-down-inner": Object.assign(Object.assign({}, Yx()), {
            color: p,
            transition: `all ${g} linear`,
            userSelect: "none"
          })
        },
        [`${t}-handler-up`]: {
          borderStartEndRadius: i
        },
        [`${t}-handler-down`]: {
          borderEndEndRadius: i
        }
      }, hj(e, "lg")), hj(e, "sm")), {
        // Disabled
        "&-disabled, &-readonly": {
          [`${t}-handler-wrap`]: {
            display: "none"
          },
          [`${t}-input`]: {
            color: "inherit"
          }
        },
        [`
          ${t}-handler-up-disabled,
          ${t}-handler-down-disabled
        `]: {
          cursor: "not-allowed"
        },
        [`
          ${t}-handler-up-disabled:hover &-handler-up-inner,
          ${t}-handler-down-disabled:hover &-handler-down-inner
        `]: {
          color: T
        }
      })
    }
  ];
}, vke = (e) => {
  const {
    componentCls: t,
    paddingBlock: n,
    paddingInline: r,
    inputAffixPadding: i,
    controlWidth: o,
    borderRadiusLG: a,
    borderRadiusSM: s,
    paddingInlineLG: c,
    paddingInlineSM: l,
    paddingBlockLG: u,
    paddingBlockSM: d,
    motionDurationMid: f
  } = e;
  return {
    [`${t}-affix-wrapper`]: Object.assign(Object.assign({
      [`input${t}-input`]: {
        padding: `${Qe(n)} 0`
      }
    }, uE(e)), {
      // or number handler will cover form status
      position: "relative",
      display: "inline-flex",
      alignItems: "center",
      width: o,
      padding: 0,
      paddingInlineStart: r,
      "&-lg": {
        borderRadius: a,
        paddingInlineStart: c,
        [`input${t}-input`]: {
          padding: `${Qe(u)} 0`
        }
      },
      "&-sm": {
        borderRadius: s,
        paddingInlineStart: l,
        [`input${t}-input`]: {
          padding: `${Qe(d)} 0`
        }
      },
      [`&:not(${t}-disabled):hover`]: {
        zIndex: 1
      },
      "&-focused, &:focus": {
        zIndex: 1
      },
      [`&-disabled > ${t}-disabled`]: {
        background: "transparent"
      },
      [`> div${t}`]: {
        width: "100%",
        border: "none",
        outline: "none",
        [`&${t}-focused`]: {
          boxShadow: "none !important"
        }
      },
      "&::before": {
        display: "inline-block",
        width: 0,
        visibility: "hidden",
        content: '"\\a0"'
      },
      [`${t}-handler-wrap`]: {
        zIndex: 2
      },
      [t]: {
        position: "static",
        color: "inherit",
        "&-prefix, &-suffix": {
          display: "flex",
          flex: "none",
          alignItems: "center",
          pointerEvents: "none"
        },
        "&-prefix": {
          marginInlineEnd: i
        },
        "&-suffix": {
          insetBlockStart: 0,
          insetInlineEnd: 0,
          height: "100%",
          marginInlineEnd: r,
          marginInlineStart: i,
          transition: `margin ${f}`
        }
      },
      [`&:hover ${t}-handler-wrap, &-focused ${t}-handler-wrap`]: {
        width: e.handleWidth,
        opacity: 1
      },
      [`&:not(${t}-affix-wrapper-without-controls):hover ${t}-suffix`]: {
        marginInlineEnd: e.calc(e.handleWidth).add(r).equal()
      }
    })
  };
}, yke = qa("InputNumber", (e) => {
  const t = Or(e, H6(e));
  return [
    mke(t),
    vke(t),
    // =====================================================
    // ==             Space Compact                       ==
    // =====================================================
    rE(t)
  ];
}, pke, {
  unitless: {
    handleOpacity: !0
  }
});
var bke = globalThis && globalThis.__rest || function(e, t) {
  var n = {};
  for (var r in e)
    Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var i = 0, r = Object.getOwnPropertySymbols(e); i < r.length; i++)
      t.indexOf(r[i]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[i]) && (n[r[i]] = e[r[i]]);
  return n;
};
const NJ = /* @__PURE__ */ I.forwardRef((e, t) => {
  if (process.env.NODE_ENV !== "production") {
    const J = di("InputNumber");
    J.deprecated(!("bordered" in e), "bordered", "variant"), J(!(e.type === "number" && e.changeOnWheel), "usage", "When `type=number` is used together with `changeOnWheel`, changeOnWheel may not work properly. Please delete `type=number` if it is not necessary.");
  }
  const {
    getPrefixCls: n,
    direction: r
  } = I.useContext(En), i = I.useRef(null);
  I.useImperativeHandle(t, () => i.current);
  const {
    className: o,
    rootClassName: a,
    size: s,
    disabled: c,
    prefixCls: l,
    addonBefore: u,
    addonAfter: d,
    prefix: f,
    suffix: h,
    bordered: p,
    readOnly: g,
    status: m,
    controls: v,
    variant: y
  } = e, S = bke(e, ["className", "rootClassName", "size", "disabled", "prefixCls", "addonBefore", "addonAfter", "prefix", "suffix", "bordered", "readOnly", "status", "controls", "variant"]), _ = n("input-number", l), w = If(_), [T, x, C] = yke(_, w), {
    compactSize: E,
    compactItemClassnames: R
  } = cy(_, r);
  let A = /* @__PURE__ */ I.createElement(Q3e, {
    className: `${_}-handler-up-inner`
  }), O = /* @__PURE__ */ I.createElement(cJ, {
    className: `${_}-handler-down-inner`
  });
  const $ = typeof v == "boolean" ? v : void 0;
  typeof v == "object" && (A = typeof v.upIcon > "u" ? A : /* @__PURE__ */ I.createElement("span", {
    className: `${_}-handler-up-inner`
  }, v.upIcon), O = typeof v.downIcon > "u" ? O : /* @__PURE__ */ I.createElement("span", {
    className: `${_}-handler-down-inner`
  }, v.downIcon));
  const {
    hasFeedback: N,
    status: z,
    isFormItemInput: k,
    feedbackIcon: F
  } = I.useContext(xs), V = fy(z, m), j = Rf((J) => {
    var Y;
    return (Y = s ?? E) !== null && Y !== void 0 ? Y : J;
  }), B = I.useContext(Uu), U = c ?? B, [Q, K] = lE("inputNumber", y, p), q = N && /* @__PURE__ */ I.createElement(I.Fragment, null, F), X = we({
    [`${_}-lg`]: j === "large",
    [`${_}-sm`]: j === "small",
    [`${_}-rtl`]: r === "rtl",
    [`${_}-in-form-item`]: k
  }, x), ie = `${_}-group`, te = /* @__PURE__ */ I.createElement(kJ, Object.assign({
    ref: i,
    disabled: U,
    className: we(C, w, o, a, R),
    upHandler: A,
    downHandler: O,
    prefixCls: _,
    readOnly: g,
    controls: $,
    prefix: f,
    suffix: q || h,
    addonBefore: u && /* @__PURE__ */ I.createElement(cv, {
      form: !0,
      space: !0
    }, u),
    addonAfter: d && /* @__PURE__ */ I.createElement(cv, {
      form: !0,
      space: !0
    }, d),
    classNames: {
      input: X,
      variant: we({
        [`${_}-${Q}`]: K
      }, Lg(_, V, N)),
      affixWrapper: we({
        [`${_}-affix-wrapper-sm`]: j === "small",
        [`${_}-affix-wrapper-lg`]: j === "large",
        [`${_}-affix-wrapper-rtl`]: r === "rtl",
        [`${_}-affix-wrapper-without-controls`]: v === !1
      }, x),
      wrapper: we({
        [`${ie}-rtl`]: r === "rtl"
      }, x),
      groupWrapper: we({
        [`${_}-group-wrapper-sm`]: j === "small",
        [`${_}-group-wrapper-lg`]: j === "large",
        [`${_}-group-wrapper-rtl`]: r === "rtl",
        [`${_}-group-wrapper-${Q}`]: K
      }, Lg(`${_}-group-wrapper`, V, N), x)
    }
  }, S));
  return T(te);
}), X6 = NJ, _ke = (e) => /* @__PURE__ */ I.createElement(lo, {
  theme: {
    components: {
      InputNumber: {
        handleVisible: !0
      }
    }
  }
}, /* @__PURE__ */ I.createElement(NJ, Object.assign({}, e)));
process.env.NODE_ENV !== "production" && (X6.displayName = "InputNumber");
X6._InternalPanelDoNotUseOrYouWillBeFired = _ke;
const Ske = X6, wke = (e) => {
  const {
    getPrefixCls: t,
    direction: n
  } = St(En), {
    prefixCls: r,
    className: i
  } = e, o = t("input-group", r), a = t("input"), [s, c] = q6(a), l = we(o, {
    [`${o}-lg`]: e.size === "large",
    [`${o}-sm`]: e.size === "small",
    [`${o}-compact`]: e.compact,
    [`${o}-rtl`]: n === "rtl"
  }, c, i), u = St(xs), d = At(() => Object.assign(Object.assign({}, u), {
    isFormItemInput: !1
  }), [u]);
  return process.env.NODE_ENV !== "production" && di("Input.Group").deprecated(!1, "Input.Group", "Space.Compact"), s(/* @__PURE__ */ I.createElement("span", {
    className: l,
    style: e.style,
    onMouseEnter: e.onMouseEnter,
    onMouseLeave: e.onMouseLeave,
    onFocus: e.onFocus,
    onBlur: e.onBlur
  }, /* @__PURE__ */ I.createElement(xs.Provider, {
    value: d
  }, e.children)));
}, xke = wke, Eke = (e) => {
  let t;
  return typeof e == "object" && (e != null && e.clearIcon) ? t = e : e && (t = {
    clearIcon: /* @__PURE__ */ D.createElement(Jx, null)
  }), t;
}, DJ = Eke;
function LJ(e, t) {
  const n = Me([]), r = () => {
    n.current.push(setTimeout(() => {
      var i, o, a, s;
      !((i = e.current) === null || i === void 0) && i.input && ((o = e.current) === null || o === void 0 ? void 0 : o.input.getAttribute("type")) === "password" && (!((a = e.current) === null || a === void 0) && a.input.hasAttribute("value")) && ((s = e.current) === null || s === void 0 || s.input.removeAttribute("value"));
    }));
  };
  return gt(() => (t && r(), () => n.current.forEach((i) => {
    i && clearTimeout(i);
  })), []), r;
}
function Cke(e) {
  return !!(e.prefix || e.suffix || e.allowClear || e.showCount);
}
var Tke = globalThis && globalThis.__rest || function(e, t) {
  var n = {};
  for (var r in e)
    Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var i = 0, r = Object.getOwnPropertySymbols(e); i < r.length; i++)
      t.indexOf(r[i]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[i]) && (n[r[i]] = e[r[i]]);
  return n;
};
const jJ = /* @__PURE__ */ ta((e, t) => {
  var n;
  const {
    prefixCls: r,
    bordered: i = !0,
    status: o,
    size: a,
    disabled: s,
    onBlur: c,
    onFocus: l,
    suffix: u,
    allowClear: d,
    addonAfter: f,
    addonBefore: h,
    className: p,
    style: g,
    styles: m,
    rootClassName: v,
    onChange: y,
    classNames: S,
    variant: _
  } = e, w = Tke(e, ["prefixCls", "bordered", "status", "size", "disabled", "onBlur", "onFocus", "suffix", "allowClear", "addonAfter", "addonBefore", "className", "style", "styles", "rootClassName", "onChange", "classNames", "variant"]);
  if (process.env.NODE_ENV !== "production") {
    const {
      deprecated: W
    } = di("Input");
    W(!("bordered" in e), "bordered", "variant");
  }
  const {
    getPrefixCls: T,
    direction: x,
    input: C
  } = D.useContext(En), E = T("input", r), R = Me(null), A = If(E), [O, $, N] = q6(E, A), {
    compactSize: z,
    compactItemClassnames: k
  } = cy(E, x), F = Rf((W) => {
    var se;
    return (se = a ?? z) !== null && se !== void 0 ? se : W;
  }), V = D.useContext(Uu), j = s ?? V, {
    status: B,
    hasFeedback: U,
    feedbackIcon: Q
  } = St(xs), K = fy(B, o), q = Cke(e) || !!U, X = Me(q);
  if (process.env.NODE_ENV !== "production") {
    const W = di("Input");
    gt(() => {
      var se;
      q && !X.current && process.env.NODE_ENV !== "production" && W(document.activeElement === ((se = R.current) === null || se === void 0 ? void 0 : se.input), "usage", "When Input is focused, dynamic add or remove prefix / suffix will make it lose focus caused by dom structure change. Read more: https://ant.design/components/input/#FAQ"), X.current = q;
    }, [q]);
  }
  const ie = LJ(R, !0), te = (W) => {
    ie(), c == null || c(W);
  }, J = (W) => {
    ie(), l == null || l(W);
  }, Y = (W) => {
    ie(), y == null || y(W);
  }, ee = (U || u) && /* @__PURE__ */ D.createElement(D.Fragment, null, u, U && Q), Z = DJ(d ?? (C == null ? void 0 : C.allowClear)), [H, oe] = lE("input", _, i);
  return O(/* @__PURE__ */ D.createElement(MJ, Object.assign({
    ref: Wa(t, R),
    prefixCls: E,
    autoComplete: C == null ? void 0 : C.autoComplete
  }, w, {
    disabled: j,
    onBlur: te,
    onFocus: J,
    style: Object.assign(Object.assign({}, C == null ? void 0 : C.style), g),
    styles: Object.assign(Object.assign({}, C == null ? void 0 : C.styles), m),
    suffix: ee,
    allowClear: Z,
    className: we(p, v, N, A, k, C == null ? void 0 : C.className),
    onChange: Y,
    addonBefore: h && /* @__PURE__ */ D.createElement(cv, {
      form: !0,
      space: !0
    }, h),
    addonAfter: f && /* @__PURE__ */ D.createElement(cv, {
      form: !0,
      space: !0
    }, f),
    classNames: Object.assign(Object.assign(Object.assign({}, S), C == null ? void 0 : C.classNames), {
      input: we({
        [`${E}-sm`]: F === "small",
        [`${E}-lg`]: F === "large",
        [`${E}-rtl`]: x === "rtl"
      }, S == null ? void 0 : S.input, (n = C == null ? void 0 : C.classNames) === null || n === void 0 ? void 0 : n.input, $),
      variant: we({
        [`${E}-${H}`]: oe
      }, Lg(E, K)),
      affixWrapper: we({
        [`${E}-affix-wrapper-sm`]: F === "small",
        [`${E}-affix-wrapper-lg`]: F === "large",
        [`${E}-affix-wrapper-rtl`]: x === "rtl"
      }, $),
      wrapper: we({
        [`${E}-group-rtl`]: x === "rtl"
      }, $),
      groupWrapper: we({
        [`${E}-group-wrapper-sm`]: F === "small",
        [`${E}-group-wrapper-lg`]: F === "large",
        [`${E}-group-wrapper-rtl`]: x === "rtl",
        [`${E}-group-wrapper-${H}`]: oe
      }, Lg(`${E}-group-wrapper`, K, U), $)
    })
  })));
});
process.env.NODE_ENV !== "production" && (jJ.displayName = "Input");
const hE = jJ, Ike = (e) => {
  const {
    componentCls: t,
    paddingXS: n
  } = e;
  return {
    [t]: {
      display: "inline-flex",
      alignItems: "center",
      flexWrap: "nowrap",
      columnGap: n,
      "&-rtl": {
        direction: "rtl"
      },
      [`${t}-input`]: {
        textAlign: "center",
        paddingInline: e.paddingXXS
      },
      // ================= Size =================
      [`&${t}-sm ${t}-input`]: {
        paddingInline: e.calc(e.paddingXXS).div(2).equal()
      },
      [`&${t}-lg ${t}-input`]: {
        paddingInline: e.paddingXS
      }
    }
  };
}, Ake = qa(["Input", "OTP"], (e) => {
  const t = Or(e, H6(e));
  return [Ike(t)];
}, U6);
var Rke = globalThis && globalThis.__rest || function(e, t) {
  var n = {};
  for (var r in e)
    Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var i = 0, r = Object.getOwnPropertySymbols(e); i < r.length; i++)
      t.indexOf(r[i]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[i]) && (n[r[i]] = e[r[i]]);
  return n;
};
const $ke = /* @__PURE__ */ I.forwardRef((e, t) => {
  const {
    value: n,
    onChange: r,
    onActiveChange: i,
    index: o,
    mask: a
  } = e, s = Rke(e, ["value", "onChange", "onActiveChange", "index", "mask"]), c = n && typeof a == "string" ? a : n, l = (p) => {
    r(o, p.target.value);
  }, u = I.useRef(null);
  I.useImperativeHandle(t, () => u.current);
  const d = () => {
    Ln(() => {
      var p;
      const g = (p = u.current) === null || p === void 0 ? void 0 : p.input;
      document.activeElement === g && g && g.select();
    });
  }, f = (p) => {
    const {
      key: g,
      ctrlKey: m,
      metaKey: v
    } = p;
    g === "ArrowLeft" ? i(o - 1) : g === "ArrowRight" ? i(o + 1) : g === "z" && (m || v) && p.preventDefault(), d();
  }, h = (p) => {
    p.key === "Backspace" && !n && i(o - 1), d();
  };
  return /* @__PURE__ */ I.createElement(hE, Object.assign({
    type: a === !0 ? "password" : "text"
  }, s, {
    ref: u,
    value: c,
    onInput: l,
    onFocus: d,
    onKeyDown: f,
    onKeyUp: h,
    onMouseDown: d,
    onMouseUp: d
  }));
}), Oke = $ke;
var Pke = globalThis && globalThis.__rest || function(e, t) {
  var n = {};
  for (var r in e)
    Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var i = 0, r = Object.getOwnPropertySymbols(e); i < r.length; i++)
      t.indexOf(r[i]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[i]) && (n[r[i]] = e[r[i]]);
  return n;
};
function Yb(e) {
  return (e || "").split("");
}
const Mke = /* @__PURE__ */ I.forwardRef((e, t) => {
  const {
    prefixCls: n,
    length: r = 6,
    size: i,
    defaultValue: o,
    value: a,
    onChange: s,
    formatter: c,
    variant: l,
    disabled: u,
    status: d,
    autoFocus: f,
    mask: h,
    type: p,
    onInput: g,
    inputMode: m
  } = e, v = Pke(e, ["prefixCls", "length", "size", "defaultValue", "value", "onChange", "formatter", "variant", "disabled", "status", "autoFocus", "mask", "type", "onInput", "inputMode"]);
  if (process.env.NODE_ENV !== "production") {
    const q = di("Input.OTP");
    process.env.NODE_ENV !== "production" && q(!(typeof h == "string" && h.length > 1), "usage", "`mask` prop should be a single character.");
  }
  const {
    getPrefixCls: y,
    direction: S
  } = I.useContext(En), _ = y("otp", n), w = cf(v, {
    aria: !0,
    data: !0,
    attr: !0
  }), T = If(_), [x, C, E] = Ake(_, T), R = Rf((q) => i ?? q), A = I.useContext(xs), O = fy(A.status, d), $ = I.useMemo(() => Object.assign(Object.assign({}, A), {
    status: O,
    hasFeedback: !1,
    feedbackIcon: null
  }), [A, O]), N = I.useRef(null), z = I.useRef({});
  I.useImperativeHandle(t, () => ({
    focus: () => {
      var q;
      (q = z.current[0]) === null || q === void 0 || q.focus();
    },
    blur: () => {
      var q;
      for (let X = 0; X < r; X += 1)
        (q = z.current[X]) === null || q === void 0 || q.blur();
    },
    nativeElement: N.current
  }));
  const k = (q) => c ? c(q) : q, [F, V] = I.useState(Yb(k(o || "")));
  I.useEffect(() => {
    a !== void 0 && V(Yb(a));
  }, [a]);
  const j = Rr((q) => {
    V(q), g && g(q), s && q.length === r && q.every((X) => X) && q.some((X, ie) => F[ie] !== X) && s(q.join(""));
  }), B = Rr((q, X) => {
    let ie = Je(F);
    for (let J = 0; J < q; J += 1)
      ie[J] || (ie[J] = "");
    X.length <= 1 ? ie[q] = X : ie = ie.slice(0, q).concat(Yb(X)), ie = ie.slice(0, r);
    for (let J = ie.length - 1; J >= 0 && !ie[J]; J -= 1)
      ie.pop();
    const te = k(ie.map((J) => J || " ").join(""));
    return ie = Yb(te).map((J, Y) => J === " " && !ie[Y] ? ie[Y] : J), ie;
  }), U = (q, X) => {
    var ie;
    const te = B(q, X), J = Math.min(q + X.length, r - 1);
    J !== q && ((ie = z.current[J]) === null || ie === void 0 || ie.focus()), j(te);
  }, Q = (q) => {
    var X;
    (X = z.current[q]) === null || X === void 0 || X.focus();
  }, K = {
    variant: l,
    disabled: u,
    status: O,
    mask: h,
    type: p,
    inputMode: m
  };
  return x(/* @__PURE__ */ I.createElement("div", Object.assign({}, w, {
    ref: N,
    className: we(_, {
      [`${_}-sm`]: R === "small",
      [`${_}-lg`]: R === "large",
      [`${_}-rtl`]: S === "rtl"
    }, E, C)
  }), /* @__PURE__ */ I.createElement(xs.Provider, {
    value: $
  }, Array.from({
    length: r
  }).map((q, X) => {
    const ie = `otp-${X}`, te = F[X] || "";
    return /* @__PURE__ */ I.createElement(Oke, Object.assign({
      ref: (J) => {
        z.current[X] = J;
      },
      key: ie,
      index: X,
      size: R,
      htmlSize: 1,
      className: `${_}-input`,
      onChange: U,
      value: te,
      onActiveChange: Q,
      autoFocus: X === 0 && f
    }, K));
  }))));
}), kke = Mke;
var Nke = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M942.2 486.2Q889.47 375.11 816.7 305l-50.88 50.88C807.31 395.53 843.45 447.4 874.7 512 791.5 684.2 673.4 766 512 766q-72.67 0-133.87-22.38L323 798.75Q408 838 512 838q288.3 0 430.2-300.3a60.29 60.29 0 000-51.5zm-63.57-320.64L836 122.88a8 8 0 00-11.32 0L715.31 232.2Q624.86 186 512 186q-288.3 0-430.2 300.3a60.3 60.3 0 000 51.5q56.69 119.4 136.5 191.41L112.48 835a8 8 0 000 11.31L155.17 889a8 8 0 0011.31 0l712.15-712.12a8 8 0 000-11.32zM149.3 512C232.6 339.8 350.7 258 512 258c54.54 0 104.13 9.36 149.12 28.39l-70.3 70.3a176 176 0 00-238.13 238.13l-83.42 83.42C223.1 637.49 183.3 582.28 149.3 512zm246.7 0a112.11 112.11 0 01146.2-106.69L401.31 546.2A112 112 0 01396 512z" } }, { tag: "path", attrs: { d: "M508 624c-3.46 0-6.87-.16-10.25-.47l-52.82 52.82a176.09 176.09 0 00227.42-227.42l-52.82 52.82c.31 3.38.47 6.79.47 10.25a111.94 111.94 0 01-112 112z" } }] }, name: "eye-invisible", theme: "outlined" };
const Dke = Nke;
var Lke = function(t, n) {
  return /* @__PURE__ */ I.createElement(fo, mt({}, t, {
    ref: n,
    icon: Dke
  }));
}, FJ = /* @__PURE__ */ I.forwardRef(Lke);
process.env.NODE_ENV !== "production" && (FJ.displayName = "EyeInvisibleOutlined");
const jke = FJ;
var Fke = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M942.2 486.2C847.4 286.5 704.1 186 512 186c-192.2 0-335.4 100.5-430.2 300.3a60.3 60.3 0 000 51.5C176.6 737.5 319.9 838 512 838c192.2 0 335.4-100.5 430.2-300.3 7.7-16.2 7.7-35 0-51.5zM512 766c-161.3 0-279.4-81.8-362.7-254C232.6 339.8 350.7 258 512 258c161.3 0 279.4 81.8 362.7 254C791.5 684.2 673.4 766 512 766zm-4-430c-97.2 0-176 78.8-176 176s78.8 176 176 176 176-78.8 176-176-78.8-176-176-176zm0 288c-61.9 0-112-50.1-112-112s50.1-112 112-112 112 50.1 112 112-50.1 112-112 112z" } }] }, name: "eye", theme: "outlined" };
const Vke = Fke;
var Bke = function(t, n) {
  return /* @__PURE__ */ I.createElement(fo, mt({}, t, {
    ref: n,
    icon: Vke
  }));
}, VJ = /* @__PURE__ */ I.forwardRef(Bke);
process.env.NODE_ENV !== "production" && (VJ.displayName = "EyeOutlined");
const zke = VJ;
var Hke = globalThis && globalThis.__rest || function(e, t) {
  var n = {};
  for (var r in e)
    Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var i = 0, r = Object.getOwnPropertySymbols(e); i < r.length; i++)
      t.indexOf(r[i]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[i]) && (n[r[i]] = e[r[i]]);
  return n;
};
const Uke = (e) => e ? /* @__PURE__ */ I.createElement(zke, null) : /* @__PURE__ */ I.createElement(jke, null), Wke = {
  click: "onClick",
  hover: "onMouseOver"
}, BJ = /* @__PURE__ */ I.forwardRef((e, t) => {
  const {
    disabled: n,
    action: r = "click",
    visibilityToggle: i = !0,
    iconRender: o = Uke
  } = e, a = I.useContext(Uu), s = n ?? a, c = typeof i == "object" && i.visible !== void 0, [l, u] = Lt(() => c ? i.visible : !1), d = Me(null);
  I.useEffect(() => {
    c && u(i.visible);
  }, [c, i]);
  const f = LJ(d), h = () => {
    s || (l && f(), u((R) => {
      var A;
      const O = !R;
      return typeof i == "object" && ((A = i.onVisibleChange) === null || A === void 0 || A.call(i, O)), O;
    }));
  }, p = (R) => {
    const A = Wke[r] || "", O = o(l), $ = {
      [A]: h,
      className: `${R}-icon`,
      key: "passwordIcon",
      onMouseDown: (N) => {
        N.preventDefault();
      },
      onMouseUp: (N) => {
        N.preventDefault();
      }
    };
    return /* @__PURE__ */ I.cloneElement(/* @__PURE__ */ I.isValidElement(O) ? O : /* @__PURE__ */ I.createElement("span", null, O), $);
  }, {
    className: g,
    prefixCls: m,
    inputPrefixCls: v,
    size: y
  } = e, S = Hke(e, ["className", "prefixCls", "inputPrefixCls", "size"]), {
    getPrefixCls: _
  } = I.useContext(En), w = _("input", v), T = _("input-password", m), x = i && p(T), C = we(T, g, {
    [`${T}-${y}`]: !!y
  }), E = Object.assign(Object.assign({}, Hu(S, ["suffix", "iconRender", "visibilityToggle"])), {
    type: l ? "text" : "password",
    className: C,
    prefixCls: w,
    suffix: x
  });
  return y && (E.size = y), /* @__PURE__ */ I.createElement(hE, Object.assign({
    ref: Wa(t, d)
  }, E));
});
process.env.NODE_ENV !== "production" && (BJ.displayName = "Input.Password");
const qke = BJ;
var Gke = globalThis && globalThis.__rest || function(e, t) {
  var n = {};
  for (var r in e)
    Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var i = 0, r = Object.getOwnPropertySymbols(e); i < r.length; i++)
      t.indexOf(r[i]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[i]) && (n[r[i]] = e[r[i]]);
  return n;
};
const zJ = /* @__PURE__ */ I.forwardRef((e, t) => {
  const {
    prefixCls: n,
    inputPrefixCls: r,
    className: i,
    size: o,
    suffix: a,
    enterButton: s = !1,
    addonAfter: c,
    loading: l,
    disabled: u,
    onSearch: d,
    onChange: f,
    onCompositionStart: h,
    onCompositionEnd: p
  } = e, g = Gke(e, ["prefixCls", "inputPrefixCls", "className", "size", "suffix", "enterButton", "addonAfter", "loading", "disabled", "onSearch", "onChange", "onCompositionStart", "onCompositionEnd"]), {
    getPrefixCls: m,
    direction: v
  } = I.useContext(En), y = I.useRef(!1), S = m("input-search", n), _ = m("input", r), {
    compactSize: w
  } = cy(S, v), T = Rf((B) => {
    var U;
    return (U = o ?? w) !== null && U !== void 0 ? U : B;
  }), x = I.useRef(null), C = (B) => {
    B != null && B.target && B.type === "click" && d && d(B.target.value, B, {
      source: "clear"
    }), f == null || f(B);
  }, E = (B) => {
    var U;
    document.activeElement === ((U = x.current) === null || U === void 0 ? void 0 : U.input) && B.preventDefault();
  }, R = (B) => {
    var U, Q;
    d && d((Q = (U = x.current) === null || U === void 0 ? void 0 : U.input) === null || Q === void 0 ? void 0 : Q.value, B, {
      source: "input"
    });
  }, A = (B) => {
    y.current || l || R(B);
  }, O = typeof s == "boolean" ? /* @__PURE__ */ I.createElement(uJ, null) : null, $ = `${S}-button`;
  let N;
  const z = s || {}, k = z.type && z.type.__ANT_BUTTON === !0;
  k || z.type === "button" ? N = Ng(z, Object.assign({
    onMouseDown: E,
    onClick: (B) => {
      var U, Q;
      (Q = (U = z == null ? void 0 : z.props) === null || U === void 0 ? void 0 : U.onClick) === null || Q === void 0 || Q.call(U, B), R(B);
    },
    key: "enterButton"
  }, k ? {
    className: $,
    size: T
  } : {})) : N = /* @__PURE__ */ I.createElement(bOe, {
    className: $,
    type: s ? "primary" : void 0,
    size: T,
    disabled: u,
    key: "enterButton",
    onMouseDown: E,
    onClick: R,
    loading: l,
    icon: O
  }, s), c && (N = [N, Ng(c, {
    key: "addonAfter"
  })]);
  const F = we(S, {
    [`${S}-rtl`]: v === "rtl",
    [`${S}-${T}`]: !!T,
    [`${S}-with-button`]: !!s
  }, i), V = (B) => {
    y.current = !0, h == null || h(B);
  }, j = (B) => {
    y.current = !1, p == null || p(B);
  };
  return /* @__PURE__ */ I.createElement(hE, Object.assign({
    ref: Wa(x, t),
    onPressEnter: A
  }, g, {
    size: T,
    onCompositionStart: V,
    onCompositionEnd: j,
    prefixCls: _,
    addonAfter: N,
    suffix: a,
    onChange: C,
    className: F,
    disabled: u
  }));
});
process.env.NODE_ENV !== "production" && (zJ.displayName = "Search");
const Kke = zJ;
var Yke = `
  min-height:0 !important;
  max-height:none !important;
  height:0 !important;
  visibility:hidden !important;
  overflow:hidden !important;
  position:absolute !important;
  z-index:-1000 !important;
  top:0 !important;
  right:0 !important;
  pointer-events: none !important;
`, Xke = ["letter-spacing", "line-height", "padding-top", "padding-bottom", "font-family", "font-weight", "font-size", "font-variant", "text-rendering", "text-transform", "width", "text-indent", "padding-left", "padding-right", "border-width", "box-sizing", "word-break", "white-space"], Q5 = {}, aa;
function Qke(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1, n = e.getAttribute("id") || e.getAttribute("data-reactid") || e.getAttribute("name");
  if (t && Q5[n])
    return Q5[n];
  var r = window.getComputedStyle(e), i = r.getPropertyValue("box-sizing") || r.getPropertyValue("-moz-box-sizing") || r.getPropertyValue("-webkit-box-sizing"), o = parseFloat(r.getPropertyValue("padding-bottom")) + parseFloat(r.getPropertyValue("padding-top")), a = parseFloat(r.getPropertyValue("border-bottom-width")) + parseFloat(r.getPropertyValue("border-top-width")), s = Xke.map(function(l) {
    return "".concat(l, ":").concat(r.getPropertyValue(l));
  }).join(";"), c = {
    sizingStyle: s,
    paddingSize: o,
    borderSize: a,
    boxSizing: i
  };
  return t && n && (Q5[n] = c), c;
}
function Jke(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1, n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null, r = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : null;
  aa || (aa = document.createElement("textarea"), aa.setAttribute("tab-index", "-1"), aa.setAttribute("aria-hidden", "true"), aa.setAttribute("name", "hiddenTextarea"), document.body.appendChild(aa)), e.getAttribute("wrap") ? aa.setAttribute("wrap", e.getAttribute("wrap")) : aa.removeAttribute("wrap");
  var i = Qke(e, t), o = i.paddingSize, a = i.borderSize, s = i.boxSizing, c = i.sizingStyle;
  aa.setAttribute("style", "".concat(c, ";").concat(Yke)), aa.value = e.value || e.placeholder || "";
  var l = void 0, u = void 0, d, f = aa.scrollHeight;
  if (s === "border-box" ? f += a : s === "content-box" && (f -= o), n !== null || r !== null) {
    aa.value = " ";
    var h = aa.scrollHeight - o;
    n !== null && (l = h * n, s === "border-box" && (l = l + o + a), f = Math.max(l, f)), r !== null && (u = h * r, s === "border-box" && (u = u + o + a), d = f > u ? "" : "hidden", f = Math.min(u, f));
  }
  var p = {
    height: f,
    overflowY: d,
    resize: "none"
  };
  return l && (p.minHeight = l), u && (p.maxHeight = u), p;
}
var Zke = ["prefixCls", "defaultValue", "value", "autoSize", "onResize", "className", "style", "disabled", "onChange", "onInternalAutoSize"], J5 = 0, Z5 = 1, eT = 2, HJ = /* @__PURE__ */ I.forwardRef(function(e, t) {
  var n = e, r = n.prefixCls, i = n.defaultValue, o = n.value, a = n.autoSize, s = n.onResize, c = n.className, l = n.style, u = n.disabled, d = n.onChange, f = n.onInternalAutoSize, h = xn(n, Zke), p = hc(i, {
    value: o,
    postState: function(X) {
      return X ?? "";
    }
  }), g = fe(p, 2), m = g[0], v = g[1], y = function(X) {
    v(X.target.value), d == null || d(X);
  }, S = I.useRef();
  I.useImperativeHandle(t, function() {
    return {
      textArea: S.current
    };
  });
  var _ = I.useMemo(function() {
    return a && _t(a) === "object" ? [a.minRows, a.maxRows] : [];
  }, [a]), w = fe(_, 2), T = w[0], x = w[1], C = !!a, E = function() {
    try {
      if (document.activeElement === S.current) {
        var X = S.current, ie = X.selectionStart, te = X.selectionEnd, J = X.scrollTop;
        S.current.setSelectionRange(ie, te), S.current.scrollTop = J;
      }
    } catch {
    }
  }, R = I.useState(eT), A = fe(R, 2), O = A[0], $ = A[1], N = I.useState(), z = fe(N, 2), k = z[0], F = z[1], V = function() {
    $(J5), process.env.NODE_ENV === "test" && (f == null || f());
  };
  nr(function() {
    C && V();
  }, [o, T, x, C]), nr(function() {
    if (O === J5)
      $(Z5);
    else if (O === Z5) {
      var q = Jke(S.current, !1, T, x);
      $(eT), F(q);
    } else
      E();
  }, [O]);
  var j = I.useRef(), B = function() {
    Ln.cancel(j.current);
  }, U = function(X) {
    O === eT && (s == null || s(X), a && (B(), j.current = Ln(function() {
      V();
    })));
  };
  I.useEffect(function() {
    return B;
  }, []);
  var Q = C ? k : null, K = ae(ae({}, l), Q);
  return (O === J5 || O === Z5) && (K.overflowY = "hidden", K.overflowX = "hidden"), /* @__PURE__ */ I.createElement(ml, {
    onResize: U,
    disabled: !(a || s)
  }, /* @__PURE__ */ I.createElement("textarea", mt({}, h, {
    ref: S,
    style: K,
    className: we(r, c, re({}, "".concat(r, "-disabled"), u)),
    disabled: u,
    value: m,
    onChange: y
  })));
}), eNe = ["defaultValue", "value", "onFocus", "onBlur", "onChange", "allowClear", "maxLength", "onCompositionStart", "onCompositionEnd", "suffix", "prefixCls", "showCount", "count", "className", "style", "disabled", "hidden", "classNames", "styles", "onResize", "onClear", "onPressEnter", "readOnly", "autoSize", "onKeyDown"], UJ = /* @__PURE__ */ D.forwardRef(function(e, t) {
  var n, r = e.defaultValue, i = e.value, o = e.onFocus, a = e.onBlur, s = e.onChange, c = e.allowClear, l = e.maxLength, u = e.onCompositionStart, d = e.onCompositionEnd, f = e.suffix, h = e.prefixCls, p = h === void 0 ? "rc-textarea" : h, g = e.showCount, m = e.count, v = e.className, y = e.style, S = e.disabled, _ = e.hidden, w = e.classNames, T = e.styles, x = e.onResize, C = e.onClear, E = e.onPressEnter, R = e.readOnly, A = e.autoSize, O = e.onKeyDown, $ = xn(e, eNe), N = hc(r, {
    value: i,
    defaultValue: r
  }), z = fe(N, 2), k = z[0], F = z[1], V = k == null ? "" : String(k), j = D.useState(!1), B = fe(j, 2), U = B[0], Q = B[1], K = D.useRef(!1), q = D.useState(null), X = fe(q, 2), ie = X[0], te = X[1], J = Me(null), Y = Me(null), ee = function() {
    var at;
    return (at = Y.current) === null || at === void 0 ? void 0 : at.textArea;
  }, Z = function() {
    ee().focus();
  };
  tO(t, function() {
    var Ge;
    return {
      resizableTextArea: Y.current,
      focus: Z,
      blur: function() {
        ee().blur();
      },
      nativeElement: ((Ge = J.current) === null || Ge === void 0 ? void 0 : Ge.nativeElement) || ee()
    };
  }), gt(function() {
    Q(function(Ge) {
      return !S && Ge;
    });
  }, [S]);
  var H = D.useState(null), oe = fe(H, 2), W = oe[0], se = oe[1];
  D.useEffect(function() {
    if (W) {
      var Ge;
      (Ge = ee()).setSelectionRange.apply(Ge, Je(W));
    }
  }, [W]);
  var ce = PJ(m, g), ge = (n = ce.max) !== null && n !== void 0 ? n : l, he = Number(ge) > 0, ue = ce.strategy(V), Ee = !!ge && ue > ge, pe = function(at, Nt) {
    var zt = Nt;
    !K.current && ce.exceedFormatter && ce.max && ce.strategy(Nt) > ce.max && (zt = ce.exceedFormatter(Nt, {
      max: ce.max
    }), Nt !== zt && se([ee().selectionStart || 0, ee().selectionEnd || 0])), F(zt), jS(at.currentTarget, at, s, zt);
  }, Oe = function(at) {
    K.current = !0, u == null || u(at);
  }, de = function(at) {
    K.current = !1, pe(at, at.currentTarget.value), d == null || d(at);
  }, be = function(at) {
    pe(at, at.target.value);
  }, Ie = function(at) {
    at.key === "Enter" && E && E(at), O == null || O(at);
  }, Ve = function(at) {
    Q(!0), o == null || o(at);
  }, Fe = function(at) {
    Q(!1), a == null || a(at);
  }, Pe = function(at) {
    F(""), Z(), jS(ee(), at, s);
  }, ot = f, dt;
  ce.show && (ce.showFormatter ? dt = ce.showFormatter({
    value: V,
    count: ue,
    maxLength: ge
  }) : dt = "".concat(ue).concat(he ? " / ".concat(ge) : ""), ot = /* @__PURE__ */ D.createElement(D.Fragment, null, ot, /* @__PURE__ */ D.createElement("span", {
    className: we("".concat(p, "-data-count"), w == null ? void 0 : w.count),
    style: T == null ? void 0 : T.count
  }, dt)));
  var ft = function(at) {
    var Nt;
    x == null || x(at), (Nt = ee()) !== null && Nt !== void 0 && Nt.style.height && te(!0);
  }, wt = !A && !g && !c;
  return /* @__PURE__ */ D.createElement(fE, {
    ref: J,
    value: V,
    allowClear: c,
    handleReset: Pe,
    suffix: ot,
    prefixCls: p,
    classNames: ae(ae({}, w), {}, {
      affixWrapper: we(w == null ? void 0 : w.affixWrapper, re(re({}, "".concat(p, "-show-count"), g), "".concat(p, "-textarea-allow-clear"), c))
    }),
    disabled: S,
    focused: U,
    className: we(v, Ee && "".concat(p, "-out-of-range")),
    style: ae(ae({}, y), ie && !wt ? {
      height: "auto"
    } : {}),
    dataAttrs: {
      affixWrapper: {
        "data-count": typeof dt == "string" ? dt : void 0
      }
    },
    hidden: _,
    readOnly: R,
    onClear: C
  }, /* @__PURE__ */ D.createElement(HJ, mt({}, $, {
    autoSize: A,
    maxLength: l,
    onKeyDown: Ie,
    onChange: be,
    onFocus: Ve,
    onBlur: Fe,
    onCompositionStart: Oe,
    onCompositionEnd: de,
    className: we(w == null ? void 0 : w.textarea),
    style: ae(ae({}, T == null ? void 0 : T.textarea), {}, {
      resize: y == null ? void 0 : y.resize
    }),
    disabled: S,
    prefixCls: p,
    onResize: ft,
    ref: Y,
    readOnly: R
  })));
});
const tNe = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  ResizableTextArea: HJ,
  default: UJ
}, Symbol.toStringTag, { value: "Module" }));
var nNe = globalThis && globalThis.__rest || function(e, t) {
  var n = {};
  for (var r in e)
    Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var i = 0, r = Object.getOwnPropertySymbols(e); i < r.length; i++)
      t.indexOf(r[i]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[i]) && (n[r[i]] = e[r[i]]);
  return n;
};
const rNe = /* @__PURE__ */ ta((e, t) => {
  var n, r;
  const {
    prefixCls: i,
    bordered: o = !0,
    size: a,
    disabled: s,
    status: c,
    allowClear: l,
    classNames: u,
    rootClassName: d,
    className: f,
    style: h,
    styles: p,
    variant: g
  } = e, m = nNe(e, ["prefixCls", "bordered", "size", "disabled", "status", "allowClear", "classNames", "rootClassName", "className", "style", "styles", "variant"]);
  if (process.env.NODE_ENV !== "production") {
    const {
      deprecated: B
    } = di("TextArea");
    B(!("bordered" in e), "bordered", "variant");
  }
  const {
    getPrefixCls: v,
    direction: y,
    textArea: S
  } = I.useContext(En), _ = Rf(a), w = I.useContext(Uu), T = s ?? w, {
    status: x,
    hasFeedback: C,
    feedbackIcon: E
  } = I.useContext(xs), R = fy(x, c), A = I.useRef(null);
  I.useImperativeHandle(t, () => {
    var B;
    return {
      resizableTextArea: (B = A.current) === null || B === void 0 ? void 0 : B.resizableTextArea,
      focus: (U) => {
        var Q, K;
        Y6((K = (Q = A.current) === null || Q === void 0 ? void 0 : Q.resizableTextArea) === null || K === void 0 ? void 0 : K.textArea, U);
      },
      blur: () => {
        var U;
        return (U = A.current) === null || U === void 0 ? void 0 : U.blur();
      }
    };
  });
  const O = v("input", i), $ = If(O), [N, z, k] = q6(O, $), [F, V] = lE("textArea", g, o), j = DJ(l ?? (S == null ? void 0 : S.allowClear));
  return N(/* @__PURE__ */ I.createElement(UJ, Object.assign({
    autoComplete: S == null ? void 0 : S.autoComplete
  }, m, {
    style: Object.assign(Object.assign({}, S == null ? void 0 : S.style), h),
    styles: Object.assign(Object.assign({}, S == null ? void 0 : S.styles), p),
    disabled: T,
    allowClear: j,
    className: we(k, $, f, d, S == null ? void 0 : S.className),
    classNames: Object.assign(Object.assign(Object.assign({}, u), S == null ? void 0 : S.classNames), {
      textarea: we({
        [`${O}-sm`]: _ === "small",
        [`${O}-lg`]: _ === "large"
      }, z, u == null ? void 0 : u.textarea, (n = S == null ? void 0 : S.classNames) === null || n === void 0 ? void 0 : n.textarea),
      variant: we({
        [`${O}-${F}`]: V
      }, Lg(O, R)),
      affixWrapper: we(`${O}-textarea-affix-wrapper`, {
        [`${O}-affix-wrapper-rtl`]: y === "rtl",
        [`${O}-affix-wrapper-sm`]: _ === "small",
        [`${O}-affix-wrapper-lg`]: _ === "large",
        [`${O}-textarea-show-count`]: e.showCount || ((r = e.count) === null || r === void 0 ? void 0 : r.show)
      }, z)
    }),
    prefixCls: O,
    suffix: C && /* @__PURE__ */ I.createElement("span", {
      className: `${O}-textarea-suffix`
    }, E),
    ref: A
  })));
}), iNe = rNe, Cp = hE;
Cp.Group = xke;
Cp.Search = Kke;
Cp.TextArea = iNe;
Cp.Password = qke;
Cp.OTP = kke;
const oNe = Cp;
function _R(e, t, n) {
  return (e - t) / (n - t);
}
function Q6(e, t, n, r) {
  var i = _R(t, n, r), o = {};
  switch (e) {
    case "rtl":
      o.right = "".concat(i * 100, "%"), o.transform = "translateX(50%)";
      break;
    case "btt":
      o.bottom = "".concat(i * 100, "%"), o.transform = "translateY(50%)";
      break;
    case "ttb":
      o.top = "".concat(i * 100, "%"), o.transform = "translateY(-50%)";
      break;
    default:
      o.left = "".concat(i * 100, "%"), o.transform = "translateX(-50%)";
      break;
  }
  return o;
}
function Lh(e, t) {
  return Array.isArray(e) ? e[t] : e;
}
var Mf = /* @__PURE__ */ I.createContext({
  min: 0,
  max: 0,
  direction: "ltr",
  step: 1,
  includedStart: 0,
  includedEnd: 0,
  tabIndex: 0,
  keyboard: !0,
  styles: {},
  classNames: {}
}), aNe = /* @__PURE__ */ I.createContext({}), sNe = ["prefixCls", "value", "valueIndex", "onStartMove", "onDelete", "style", "render", "dragging", "draggingDelete", "onOffsetChange", "onChangeComplete", "onFocus", "onMouseEnter"], SR = /* @__PURE__ */ I.forwardRef(function(e, t) {
  var n = e.prefixCls, r = e.value, i = e.valueIndex, o = e.onStartMove, a = e.onDelete, s = e.style, c = e.render, l = e.dragging, u = e.draggingDelete, d = e.onOffsetChange, f = e.onChangeComplete, h = e.onFocus, p = e.onMouseEnter, g = xn(e, sNe), m = I.useContext(Mf), v = m.min, y = m.max, S = m.direction, _ = m.disabled, w = m.keyboard, T = m.range, x = m.tabIndex, C = m.ariaLabelForHandle, E = m.ariaLabelledByForHandle, R = m.ariaValueTextFormatterForHandle, A = m.styles, O = m.classNames, $ = "".concat(n, "-handle"), N = function(q) {
    _ || o(q, i);
  }, z = function(q) {
    h == null || h(q, i);
  }, k = function(q) {
    p(q, i);
  }, F = function(q) {
    if (!_ && w) {
      var X = null;
      switch (q.which || q.keyCode) {
        case Ae.LEFT:
          X = S === "ltr" || S === "btt" ? -1 : 1;
          break;
        case Ae.RIGHT:
          X = S === "ltr" || S === "btt" ? 1 : -1;
          break;
        case Ae.UP:
          X = S !== "ttb" ? 1 : -1;
          break;
        case Ae.DOWN:
          X = S !== "ttb" ? -1 : 1;
          break;
        case Ae.HOME:
          X = "min";
          break;
        case Ae.END:
          X = "max";
          break;
        case Ae.PAGE_UP:
          X = 2;
          break;
        case Ae.PAGE_DOWN:
          X = -2;
          break;
        case Ae.BACKSPACE:
        case Ae.DELETE:
          a(i);
          break;
      }
      X !== null && (q.preventDefault(), d(X, i));
    }
  }, V = function(q) {
    switch (q.which || q.keyCode) {
      case Ae.LEFT:
      case Ae.RIGHT:
      case Ae.UP:
      case Ae.DOWN:
      case Ae.HOME:
      case Ae.END:
      case Ae.PAGE_UP:
      case Ae.PAGE_DOWN:
        f == null || f();
        break;
    }
  }, j = Q6(S, r, v, y), B = {};
  if (i !== null) {
    var U;
    B = {
      tabIndex: _ ? null : Lh(x, i),
      role: "slider",
      "aria-valuemin": v,
      "aria-valuemax": y,
      "aria-valuenow": r,
      "aria-disabled": _,
      "aria-label": Lh(C, i),
      "aria-labelledby": Lh(E, i),
      "aria-valuetext": (U = Lh(R, i)) === null || U === void 0 ? void 0 : U(r),
      "aria-orientation": S === "ltr" || S === "rtl" ? "horizontal" : "vertical",
      onMouseDown: N,
      onTouchStart: N,
      onFocus: z,
      onMouseEnter: k,
      onKeyDown: F,
      onKeyUp: V
    };
  }
  var Q = /* @__PURE__ */ I.createElement("div", mt({
    ref: t,
    className: we($, re(re(re({}, "".concat($, "-").concat(i + 1), i !== null && T), "".concat($, "-dragging"), l), "".concat($, "-dragging-delete"), u), O.handle),
    style: ae(ae(ae({}, j), s), A.handle)
  }, B, g));
  return c && (Q = c(Q, {
    index: i,
    prefixCls: n,
    value: r,
    dragging: l,
    draggingDelete: u
  })), Q;
});
process.env.NODE_ENV !== "production" && (SR.displayName = "Handle");
var cNe = ["prefixCls", "style", "onStartMove", "onOffsetChange", "values", "handleRender", "activeHandleRender", "draggingIndex", "draggingDelete", "onFocus"], WJ = /* @__PURE__ */ I.forwardRef(function(e, t) {
  var n = e.prefixCls, r = e.style, i = e.onStartMove, o = e.onOffsetChange, a = e.values, s = e.handleRender, c = e.activeHandleRender, l = e.draggingIndex, u = e.draggingDelete, d = e.onFocus, f = xn(e, cNe), h = I.useRef({}), p = I.useState(!1), g = fe(p, 2), m = g[0], v = g[1], y = I.useState(-1), S = fe(y, 2), _ = S[0], w = S[1], T = function(A) {
    w(A), v(!0);
  }, x = function(A, O) {
    T(O), d == null || d(A);
  }, C = function(A, O) {
    T(O);
  };
  I.useImperativeHandle(t, function() {
    return {
      focus: function(A) {
        var O;
        (O = h.current[A]) === null || O === void 0 || O.focus();
      },
      hideHelp: function() {
        fI(function() {
          v(!1);
        });
      }
    };
  });
  var E = ae({
    prefixCls: n,
    onStartMove: i,
    onOffsetChange: o,
    render: s,
    onFocus: x,
    onMouseEnter: C
  }, f);
  return /* @__PURE__ */ I.createElement(I.Fragment, null, a.map(function(R, A) {
    var O = l === A;
    return /* @__PURE__ */ I.createElement(SR, mt({
      ref: function(N) {
        N ? h.current[A] = N : delete h.current[A];
      },
      dragging: O,
      draggingDelete: O && u,
      style: Lh(r, A),
      key: A,
      value: R,
      valueIndex: A
    }, E));
  }), c && m && /* @__PURE__ */ I.createElement(SR, mt({
    key: "a11y"
  }, E, {
    value: a[_],
    valueIndex: null,
    dragging: l !== -1,
    draggingDelete: u,
    render: c,
    style: {
      pointerEvents: "none"
    },
    tabIndex: null,
    "aria-hidden": !0
  })));
});
process.env.NODE_ENV !== "production" && (WJ.displayName = "Handles");
var lNe = function(t) {
  var n = t.prefixCls, r = t.style, i = t.children, o = t.value, a = t.onClick, s = I.useContext(Mf), c = s.min, l = s.max, u = s.direction, d = s.includedStart, f = s.includedEnd, h = s.included, p = "".concat(n, "-text"), g = Q6(u, o, c, l);
  return /* @__PURE__ */ I.createElement("span", {
    className: we(p, re({}, "".concat(p, "-active"), h && d <= o && o <= f)),
    style: ae(ae({}, g), r),
    onMouseDown: function(v) {
      v.stopPropagation();
    },
    onClick: function() {
      a(o);
    }
  }, i);
}, uNe = function(t) {
  var n = t.prefixCls, r = t.marks, i = t.onClick, o = "".concat(n, "-mark");
  return r.length ? /* @__PURE__ */ I.createElement("div", {
    className: o
  }, r.map(function(a) {
    var s = a.value, c = a.style, l = a.label;
    return /* @__PURE__ */ I.createElement(lNe, {
      key: s,
      prefixCls: o,
      style: c,
      value: s,
      onClick: i
    }, l);
  })) : null;
}, dNe = function(t) {
  var n = t.prefixCls, r = t.value, i = t.style, o = t.activeStyle, a = I.useContext(Mf), s = a.min, c = a.max, l = a.direction, u = a.included, d = a.includedStart, f = a.includedEnd, h = "".concat(n, "-dot"), p = u && d <= r && r <= f, g = ae(ae({}, Q6(l, r, s, c)), typeof i == "function" ? i(r) : i);
  return p && (g = ae(ae({}, g), typeof o == "function" ? o(r) : o)), /* @__PURE__ */ I.createElement("span", {
    className: we(h, re({}, "".concat(h, "-active"), p)),
    style: g
  });
}, fNe = function(t) {
  var n = t.prefixCls, r = t.marks, i = t.dots, o = t.style, a = t.activeStyle, s = I.useContext(Mf), c = s.min, l = s.max, u = s.step, d = I.useMemo(function() {
    var f = /* @__PURE__ */ new Set();
    if (r.forEach(function(p) {
      f.add(p.value);
    }), i && u !== null)
      for (var h = c; h <= l; )
        f.add(h), h += u;
    return Array.from(f);
  }, [c, l, u, i, r]);
  return /* @__PURE__ */ I.createElement("div", {
    className: "".concat(n, "-step")
  }, d.map(function(f) {
    return /* @__PURE__ */ I.createElement(dNe, {
      prefixCls: n,
      key: f,
      value: f,
      style: o,
      activeStyle: a
    });
  }));
}, gj = function(t) {
  var n = t.prefixCls, r = t.style, i = t.start, o = t.end, a = t.index, s = t.onStartMove, c = t.replaceCls, l = I.useContext(Mf), u = l.direction, d = l.min, f = l.max, h = l.disabled, p = l.range, g = l.classNames, m = "".concat(n, "-track"), v = _R(i, d, f), y = _R(o, d, f), S = function(x) {
    !h && s && s(x, -1);
  }, _ = {};
  switch (u) {
    case "rtl":
      _.right = "".concat(v * 100, "%"), _.width = "".concat(y * 100 - v * 100, "%");
      break;
    case "btt":
      _.bottom = "".concat(v * 100, "%"), _.height = "".concat(y * 100 - v * 100, "%");
      break;
    case "ttb":
      _.top = "".concat(v * 100, "%"), _.height = "".concat(y * 100 - v * 100, "%");
      break;
    default:
      _.left = "".concat(v * 100, "%"), _.width = "".concat(y * 100 - v * 100, "%");
  }
  var w = c || we(m, re(re({}, "".concat(m, "-").concat(a + 1), a !== null && p), "".concat(n, "-track-draggable"), s), g.track);
  return /* @__PURE__ */ I.createElement("div", {
    className: w,
    style: ae(ae({}, _), r),
    onMouseDown: S,
    onTouchStart: S
  });
}, hNe = function(t) {
  var n = t.prefixCls, r = t.style, i = t.values, o = t.startPoint, a = t.onStartMove, s = I.useContext(Mf), c = s.included, l = s.range, u = s.min, d = s.styles, f = s.classNames, h = I.useMemo(function() {
    if (!l) {
      if (i.length === 0)
        return [];
      var g = o ?? u, m = i[0];
      return [{
        start: Math.min(g, m),
        end: Math.max(g, m)
      }];
    }
    for (var v = [], y = 0; y < i.length - 1; y += 1)
      v.push({
        start: i[y],
        end: i[y + 1]
      });
    return v;
  }, [i, l, o, u]);
  if (!c)
    return null;
  var p = f.tracks || d.tracks ? /* @__PURE__ */ I.createElement(gj, {
    index: null,
    prefixCls: n,
    start: h[0].start,
    end: h[h.length - 1].end,
    replaceCls: we(f.tracks, "".concat(n, "-tracks")),
    style: d.tracks
  }) : null;
  return /* @__PURE__ */ I.createElement(I.Fragment, null, p, h.map(function(g, m) {
    var v = g.start, y = g.end;
    return /* @__PURE__ */ I.createElement(gj, {
      index: m,
      prefixCls: n,
      style: ae(ae({}, Lh(r, m)), d.track),
      start: v,
      end: y,
      key: m,
      onStartMove: a
    });
  }));
}, gNe = 130;
function pj(e) {
  var t = "targetTouches" in e ? e.targetTouches[0] : e;
  return {
    pageX: t.pageX,
    pageY: t.pageY
  };
}
function pNe(e, t, n, r, i, o, a, s, c, l, u) {
  var d = I.useState(null), f = fe(d, 2), h = f[0], p = f[1], g = I.useState(-1), m = fe(g, 2), v = m[0], y = m[1], S = I.useState(!1), _ = fe(S, 2), w = _[0], T = _[1], x = I.useState(n), C = fe(x, 2), E = C[0], R = C[1], A = I.useState(n), O = fe(A, 2), $ = O[0], N = O[1], z = I.useRef(null), k = I.useRef(null), F = I.useRef(null), V = I.useContext(aNe), j = V.onDragStart, B = V.onDragChange;
  nr(function() {
    v === -1 && R(n);
  }, [n, v]), I.useEffect(function() {
    return function() {
      document.removeEventListener("mousemove", z.current), document.removeEventListener("mouseup", k.current), F.current && (F.current.removeEventListener("touchmove", z.current), F.current.removeEventListener("touchend", k.current));
    };
  }, []);
  var U = function(ie, te, J) {
    te !== void 0 && p(te), R(ie);
    var Y = ie;
    J && (Y = ie.filter(function(ee, Z) {
      return Z !== v;
    })), a(Y), B && B({
      rawValues: ie,
      deleteIndex: J ? v : -1,
      draggingIndex: v,
      draggingValue: te
    });
  }, Q = Rr(function(X, ie, te) {
    if (X === -1) {
      var J = $[0], Y = $[$.length - 1], ee = r - J, Z = i - Y, H = ie * (i - r);
      H = Math.max(H, ee), H = Math.min(H, Z);
      var oe = o(J + H);
      H = oe - J;
      var W = $.map(function(he) {
        return he + H;
      });
      U(W);
    } else {
      var se = (i - r) * ie, ce = Je(E);
      ce[X] = $[X];
      var ge = c(ce, se, X, "dist");
      U(ge.values, ge.value, te);
    }
  }), K = function(ie, te, J) {
    ie.stopPropagation();
    var Y = J || n, ee = Y[te];
    y(te), p(ee), N(Y), R(Y), T(!1);
    var Z = pj(ie), H = Z.pageX, oe = Z.pageY, W = !1;
    j && j({
      rawValues: Y,
      draggingIndex: te,
      draggingValue: ee
    });
    var se = function(he) {
      he.preventDefault();
      var ue = pj(he), Ee = ue.pageX, pe = ue.pageY, Oe = Ee - H, de = pe - oe, be = e.current.getBoundingClientRect(), Ie = be.width, Ve = be.height, Fe, Pe;
      switch (t) {
        case "btt":
          Fe = -de / Ve, Pe = Oe;
          break;
        case "ttb":
          Fe = de / Ve, Pe = Oe;
          break;
        case "rtl":
          Fe = -Oe / Ie, Pe = de;
          break;
        default:
          Fe = Oe / Ie, Pe = de;
      }
      W = l ? Math.abs(Pe) > gNe && u < E.length : !1, T(W), Q(te, Fe, W);
    }, ce = function ge(he) {
      he.preventDefault(), document.removeEventListener("mouseup", ge), document.removeEventListener("mousemove", se), F.current && (F.current.removeEventListener("touchmove", z.current), F.current.removeEventListener("touchend", k.current)), z.current = null, k.current = null, F.current = null, s(W), y(-1), T(!1);
    };
    document.addEventListener("mouseup", ce), document.addEventListener("mousemove", se), ie.currentTarget.addEventListener("touchend", ce), ie.currentTarget.addEventListener("touchmove", se), z.current = se, k.current = ce, F.current = ie.currentTarget;
  }, q = I.useMemo(function() {
    var X = Je(n).sort(function(ee, Z) {
      return ee - Z;
    }), ie = Je(E).sort(function(ee, Z) {
      return ee - Z;
    }), te = {};
    ie.forEach(function(ee) {
      te[ee] = (te[ee] || 0) + 1;
    }), X.forEach(function(ee) {
      te[ee] = (te[ee] || 0) - 1;
    });
    var J = l ? 1 : 0, Y = Object.values(te).reduce(function(ee, Z) {
      return ee + Math.abs(Z);
    }, 0);
    return Y <= J ? E : n;
  }, [n, E, l]);
  return [v, h, w, q, K];
}
function mNe(e, t, n, r, i, o) {
  var a = I.useCallback(function(h) {
    return Math.max(e, Math.min(t, h));
  }, [e, t]), s = I.useCallback(function(h) {
    if (n !== null) {
      var p = e + Math.round((a(h) - e) / n) * n, g = function(S) {
        return (String(S).split(".")[1] || "").length;
      }, m = Math.max(g(n), g(t), g(e)), v = Number(p.toFixed(m));
      return e <= v && v <= t ? v : null;
    }
    return null;
  }, [n, e, t, a]), c = I.useCallback(function(h) {
    var p = a(h), g = r.map(function(y) {
      return y.value;
    });
    n !== null && g.push(s(h)), g.push(e, t);
    var m = g[0], v = t - e;
    return g.forEach(function(y) {
      var S = Math.abs(p - y);
      S <= v && (m = y, v = S);
    }), m;
  }, [e, t, r, n, a, s]), l = function h(p, g, m) {
    var v = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "unit";
    if (typeof g == "number") {
      var y, S = p[m], _ = S + g, w = [];
      r.forEach(function(R) {
        w.push(R.value);
      }), w.push(e, t), w.push(s(S));
      var T = g > 0 ? 1 : -1;
      v === "unit" ? w.push(s(S + T * n)) : w.push(s(_)), w = w.filter(function(R) {
        return R !== null;
      }).filter(function(R) {
        return g < 0 ? R <= S : R >= S;
      }), v === "unit" && (w = w.filter(function(R) {
        return R !== S;
      }));
      var x = v === "unit" ? S : _;
      y = w[0];
      var C = Math.abs(y - x);
      if (w.forEach(function(R) {
        var A = Math.abs(R - x);
        A < C && (y = R, C = A);
      }), y === void 0)
        return g < 0 ? e : t;
      if (v === "dist")
        return y;
      if (Math.abs(g) > 1) {
        var E = Je(p);
        return E[m] = y, h(E, g - T, m, v);
      }
      return y;
    } else {
      if (g === "min")
        return e;
      if (g === "max")
        return t;
    }
  }, u = function(p, g, m) {
    var v = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "unit", y = p[m], S = l(p, g, m, v);
    return {
      value: S,
      changed: S !== y
    };
  }, d = function(p) {
    return o === null && p === 0 || typeof o == "number" && p < o;
  }, f = function(p, g, m) {
    var v = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "unit", y = p.map(c), S = y[m], _ = l(y, g, m, v);
    if (y[m] = _, i === !1) {
      var w = o || 0;
      m > 0 && y[m - 1] !== S && (y[m] = Math.max(y[m], y[m - 1] + w)), m < y.length - 1 && y[m + 1] !== S && (y[m] = Math.min(y[m], y[m + 1] - w));
    } else if (typeof o == "number" || o === null) {
      for (var T = m + 1; T < y.length; T += 1)
        for (var x = !0; d(y[T] - y[T - 1]) && x; ) {
          var C = u(y, 1, T);
          y[T] = C.value, x = C.changed;
        }
      for (var E = m; E > 0; E -= 1)
        for (var R = !0; d(y[E] - y[E - 1]) && R; ) {
          var A = u(y, -1, E - 1);
          y[E - 1] = A.value, R = A.changed;
        }
      for (var O = y.length - 1; O > 0; O -= 1)
        for (var $ = !0; d(y[O] - y[O - 1]) && $; ) {
          var N = u(y, -1, O - 1);
          y[O - 1] = N.value, $ = N.changed;
        }
      for (var z = 0; z < y.length - 1; z += 1)
        for (var k = !0; d(y[z + 1] - y[z]) && k; ) {
          var F = u(y, 1, z + 1);
          y[z + 1] = F.value, k = F.changed;
        }
    }
    return {
      value: y[m],
      values: y
    };
  };
  return [c, f];
}
function vNe(e) {
  return At(function() {
    if (e === !0 || !e)
      return [!!e, !1, !1, 0];
    var t = e.editable, n = e.draggableTrack, r = e.minCount, i = e.maxCount;
    return process.env.NODE_ENV !== "production" && Cu(!t || !n, "`editable` can not work with `draggableTrack`."), [!0, t, !t && n, r || 0, i];
  }, [e]);
}
var qJ = /* @__PURE__ */ I.forwardRef(function(e, t) {
  var n = e.prefixCls, r = n === void 0 ? "rc-slider" : n, i = e.className, o = e.style, a = e.classNames, s = e.styles, c = e.id, l = e.disabled, u = l === void 0 ? !1 : l, d = e.keyboard, f = d === void 0 ? !0 : d, h = e.autoFocus, p = e.onFocus, g = e.onBlur, m = e.min, v = m === void 0 ? 0 : m, y = e.max, S = y === void 0 ? 100 : y, _ = e.step, w = _ === void 0 ? 1 : _, T = e.value, x = e.defaultValue, C = e.range, E = e.count, R = e.onChange, A = e.onBeforeChange, O = e.onAfterChange, $ = e.onChangeComplete, N = e.allowCross, z = N === void 0 ? !0 : N, k = e.pushable, F = k === void 0 ? !1 : k, V = e.reverse, j = e.vertical, B = e.included, U = B === void 0 ? !0 : B, Q = e.startPoint, K = e.trackStyle, q = e.handleStyle, X = e.railStyle, ie = e.dotStyle, te = e.activeDotStyle, J = e.marks, Y = e.dots, ee = e.handleRender, Z = e.activeHandleRender, H = e.track, oe = e.tabIndex, W = oe === void 0 ? 0 : oe, se = e.ariaLabelForHandle, ce = e.ariaLabelledByForHandle, ge = e.ariaValueTextFormatterForHandle, he = I.useRef(null), ue = I.useRef(null), Ee = I.useMemo(function() {
    return j ? V ? "ttb" : "btt" : V ? "rtl" : "ltr";
  }, [V, j]), pe = vNe(C), Oe = fe(pe, 5), de = Oe[0], be = Oe[1], Ie = Oe[2], Ve = Oe[3], Fe = Oe[4], Pe = I.useMemo(function() {
    return isFinite(v) ? v : 0;
  }, [v]), ot = I.useMemo(function() {
    return isFinite(S) ? S : 100;
  }, [S]), dt = I.useMemo(function() {
    return w !== null && w <= 0 ? 1 : w;
  }, [w]), ft = I.useMemo(function() {
    return typeof F == "boolean" ? F ? dt : !1 : F >= 0 ? F : !1;
  }, [F, dt]), wt = I.useMemo(function() {
    return Object.keys(J || {}).map(function(ct) {
      var Ue = J[ct], Dt = {
        value: Number(ct)
      };
      return Ue && _t(Ue) === "object" && !/* @__PURE__ */ I.isValidElement(Ue) && ("label" in Ue || "style" in Ue) ? (Dt.style = Ue.style, Dt.label = Ue.label) : Dt.label = Ue, Dt;
    }).filter(function(ct) {
      var Ue = ct.label;
      return Ue || typeof Ue == "number";
    }).sort(function(ct, Ue) {
      return ct.value - Ue.value;
    });
  }, [J]), Ge = mNe(Pe, ot, dt, wt, z, ft), at = fe(Ge, 2), Nt = at[0], zt = at[1], kt = hc(x, {
    value: T
  }), Ct = fe(kt, 2), yt = Ct[0], Mn = Ct[1], Pt = I.useMemo(function() {
    var ct = yt == null ? [] : Array.isArray(yt) ? yt : [yt], Ue = fe(ct, 1), Dt = Ue[0], It = Dt === void 0 ? Pe : Dt, wn = yt === null ? [] : [It];
    if (de) {
      if (wn = Je(ct), E || yt === void 0) {
        var gr = E >= 0 ? E + 1 : 2;
        for (wn = wn.slice(0, gr); wn.length < gr; ) {
          var Gn;
          wn.push((Gn = wn[wn.length - 1]) !== null && Gn !== void 0 ? Gn : Pe);
        }
      }
      wn.sort(function(Cn, Fr) {
        return Cn - Fr;
      });
    }
    return wn.forEach(function(Cn, Fr) {
      wn[Fr] = Nt(Cn);
    }), wn;
  }, [yt, de, Pe, E, Nt]), Ze = function(Ue) {
    return de ? Ue : Ue[0];
  }, Le = Rr(function(ct) {
    var Ue = Je(ct).sort(function(Dt, It) {
      return Dt - It;
    });
    R && !Ig(Ue, Pt, !0) && R(Ze(Ue)), Mn(Ue);
  }), rt = Rr(function(ct) {
    ct && he.current.hideHelp();
    var Ue = Ze(Pt);
    O == null || O(Ue), an(!O, "[rc-slider] `onAfterChange` is deprecated. Please use `onChangeComplete` instead."), $ == null || $(Ue);
  }), ut = function(Ue) {
    if (!(u || !be || Pt.length <= Ve)) {
      var Dt = Je(Pt);
      Dt.splice(Ue, 1), A == null || A(Ze(Dt)), Le(Dt);
      var It = Math.max(0, Ue - 1);
      he.current.hideHelp(), he.current.focus(It);
    }
  }, vt = pNe(ue, Ee, Pt, Pe, ot, Nt, Le, rt, zt, be, Ve), We = fe(vt, 5), et = We[0], Ne = We[1], Yt = We[2], Ht = We[3], Be = We[4], ze = function(Ue, Dt) {
    if (!u) {
      var It = Je(Pt), wn = 0, gr = 0, Gn = ot - Pe;
      Pt.forEach(function(xr, Yr) {
        var Er = Math.abs(Ue - xr);
        Er <= Gn && (Gn = Er, wn = Yr), xr < Ue && (gr = Yr);
      });
      var Cn = wn;
      be && Gn !== 0 && (!Fe || Pt.length < Fe) ? (It.splice(gr + 1, 0, Ue), Cn = gr + 1) : It[wn] = Ue, de && !Pt.length && E === void 0 && It.push(Ue);
      var Fr = Ze(It);
      if (A == null || A(Fr), Le(It), Dt) {
        var Kr, pr;
        (Kr = document.activeElement) === null || Kr === void 0 || (pr = Kr.blur) === null || pr === void 0 || pr.call(Kr), he.current.focus(Cn), Be(Dt, Cn, It);
      } else
        O == null || O(Fr), an(!O, "[rc-slider] `onAfterChange` is deprecated. Please use `onChangeComplete` instead."), $ == null || $(Fr);
    }
  }, it = function(Ue) {
    Ue.preventDefault();
    var Dt = ue.current.getBoundingClientRect(), It = Dt.width, wn = Dt.height, gr = Dt.left, Gn = Dt.top, Cn = Dt.bottom, Fr = Dt.right, Kr = Ue.clientX, pr = Ue.clientY, xr;
    switch (Ee) {
      case "btt":
        xr = (Cn - pr) / wn;
        break;
      case "ttb":
        xr = (pr - Gn) / wn;
        break;
      case "rtl":
        xr = (Fr - Kr) / It;
        break;
      default:
        xr = (Kr - gr) / It;
    }
    var Yr = Pe + xr * (ot - Pe);
    ze(Nt(Yr), Ue);
  }, lt = I.useState(null), Tt = fe(lt, 2), jt = Tt[0], ne = Tt[1], _e = function(Ue, Dt) {
    if (!u) {
      var It = zt(Pt, Ue, Dt);
      A == null || A(Ze(Pt)), Le(It.values), ne(It.value);
    }
  };
  I.useEffect(function() {
    if (jt !== null) {
      var ct = Pt.indexOf(jt);
      ct >= 0 && he.current.focus(ct);
    }
    ne(null);
  }, [jt]);
  var $e = I.useMemo(function() {
    return Ie && dt === null ? (process.env.NODE_ENV !== "production" && an(!1, "`draggableTrack` is not supported when `step` is `null`."), !1) : Ie;
  }, [Ie, dt]), qe = Rr(function(ct, Ue) {
    Be(ct, Ue), A == null || A(Ze(Pt));
  }), xt = et !== -1;
  I.useEffect(function() {
    if (!xt) {
      var ct = Pt.lastIndexOf(Ne);
      he.current.focus(ct);
    }
  }, [xt]);
  var bt = I.useMemo(function() {
    return Je(Ht).sort(function(ct, Ue) {
      return ct - Ue;
    });
  }, [Ht]), st = I.useMemo(function() {
    return de ? [bt[0], bt[bt.length - 1]] : [Pe, bt[0]];
  }, [bt, de, Pe]), Rt = fe(st, 2), Ke = Rt[0], ke = Rt[1];
  I.useImperativeHandle(t, function() {
    return {
      focus: function() {
        he.current.focus(0);
      },
      blur: function() {
        var Ue, Dt = document, It = Dt.activeElement;
        (Ue = ue.current) !== null && Ue !== void 0 && Ue.contains(It) && (It == null || It.blur());
      }
    };
  }), I.useEffect(function() {
    h && he.current.focus(0);
  }, []);
  var Xe = I.useMemo(function() {
    return {
      min: Pe,
      max: ot,
      direction: Ee,
      disabled: u,
      keyboard: f,
      step: dt,
      included: U,
      includedStart: Ke,
      includedEnd: ke,
      range: de,
      tabIndex: W,
      ariaLabelForHandle: se,
      ariaLabelledByForHandle: ce,
      ariaValueTextFormatterForHandle: ge,
      styles: s || {},
      classNames: a || {}
    };
  }, [Pe, ot, Ee, u, f, dt, U, Ke, ke, de, W, se, ce, ge, s, a]);
  return /* @__PURE__ */ I.createElement(Mf.Provider, {
    value: Xe
  }, /* @__PURE__ */ I.createElement("div", {
    ref: ue,
    className: we(r, i, re(re(re(re({}, "".concat(r, "-disabled"), u), "".concat(r, "-vertical"), j), "".concat(r, "-horizontal"), !j), "".concat(r, "-with-marks"), wt.length)),
    style: o,
    onMouseDown: it,
    id: c
  }, /* @__PURE__ */ I.createElement("div", {
    className: we("".concat(r, "-rail"), a == null ? void 0 : a.rail),
    style: ae(ae({}, X), s == null ? void 0 : s.rail)
  }), H !== !1 && /* @__PURE__ */ I.createElement(hNe, {
    prefixCls: r,
    style: K,
    values: Pt,
    startPoint: Q,
    onStartMove: $e ? qe : void 0
  }), /* @__PURE__ */ I.createElement(fNe, {
    prefixCls: r,
    marks: wt,
    dots: Y,
    style: ie,
    activeStyle: te
  }), /* @__PURE__ */ I.createElement(WJ, {
    ref: he,
    prefixCls: r,
    style: q,
    values: Ht,
    draggingIndex: et,
    draggingDelete: Yt,
    onStartMove: qe,
    onOffsetChange: _e,
    onFocus: p,
    onBlur: g,
    handleRender: ee,
    activeHandleRender: Z,
    onChangeComplete: rt,
    onDelete: be ? ut : void 0
  }), /* @__PURE__ */ I.createElement(uNe, {
    prefixCls: r,
    marks: wt,
    onClick: ze
  })));
});
process.env.NODE_ENV !== "production" && (qJ.displayName = "Slider");
const GJ = /* @__PURE__ */ I.forwardRef((e, t) => {
  const {
    open: n,
    draggingDelete: r
  } = e, i = Me(null), o = n && !r, a = Me(null);
  function s() {
    Ln.cancel(a.current), a.current = null;
  }
  function c() {
    a.current = Ln(() => {
      var l;
      (l = i.current) === null || l === void 0 || l.forceAlign(), a.current = null;
    });
  }
  return I.useEffect(() => (o ? c() : s(), s), [o, e.title]), /* @__PURE__ */ I.createElement(Pf, Object.assign({
    ref: Wa(i, t)
  }, e, {
    open: o
  }));
});
process.env.NODE_ENV !== "production" && (GJ.displayName = "SliderTooltip");
const mj = GJ, yNe = (e) => {
  const {
    componentCls: t,
    antCls: n,
    controlSize: r,
    dotSize: i,
    marginFull: o,
    marginPart: a,
    colorFillContentHover: s,
    handleColorDisabled: c,
    calc: l,
    handleSize: u,
    handleSizeHover: d,
    handleActiveColor: f,
    handleActiveOutlineColor: h,
    handleLineWidth: p,
    handleLineWidthHover: g,
    motionDurationMid: m
  } = e;
  return {
    [t]: Object.assign(Object.assign({}, va(e)), {
      position: "relative",
      height: r,
      margin: `${Qe(a)} ${Qe(o)}`,
      padding: 0,
      cursor: "pointer",
      touchAction: "none",
      "&-vertical": {
        margin: `${Qe(o)} ${Qe(a)}`
      },
      [`${t}-rail`]: {
        position: "absolute",
        backgroundColor: e.railBg,
        borderRadius: e.borderRadiusXS,
        transition: `background-color ${m}`
      },
      [`${t}-track,${t}-tracks`]: {
        position: "absolute",
        transition: `background-color ${m}`
      },
      [`${t}-track`]: {
        backgroundColor: e.trackBg,
        borderRadius: e.borderRadiusXS
      },
      [`${t}-track-draggable`]: {
        boxSizing: "content-box",
        backgroundClip: "content-box",
        border: "solid rgba(0,0,0,0)"
      },
      "&:hover": {
        [`${t}-rail`]: {
          backgroundColor: e.railHoverBg
        },
        [`${t}-track`]: {
          backgroundColor: e.trackHoverBg
        },
        [`${t}-dot`]: {
          borderColor: s
        },
        [`${t}-handle::after`]: {
          boxShadow: `0 0 0 ${Qe(p)} ${e.colorPrimaryBorderHover}`
        },
        [`${t}-dot-active`]: {
          borderColor: e.dotActiveBorderColor
        }
      },
      [`${t}-handle`]: {
        position: "absolute",
        width: u,
        height: u,
        outline: "none",
        userSelect: "none",
        // Dragging status
        "&-dragging-delete": {
          opacity: 0
        },
        // 扩大选区
        "&::before": {
          content: '""',
          position: "absolute",
          insetInlineStart: l(p).mul(-1).equal(),
          insetBlockStart: l(p).mul(-1).equal(),
          width: l(u).add(l(p).mul(2)).equal(),
          height: l(u).add(l(p).mul(2)).equal(),
          backgroundColor: "transparent"
        },
        "&::after": {
          content: '""',
          position: "absolute",
          insetBlockStart: 0,
          insetInlineStart: 0,
          width: u,
          height: u,
          backgroundColor: e.colorBgElevated,
          boxShadow: `0 0 0 ${Qe(p)} ${e.handleColor}`,
          outline: "0px solid transparent",
          borderRadius: "50%",
          cursor: "pointer",
          transition: `
            inset-inline-start ${m},
            inset-block-start ${m},
            width ${m},
            height ${m},
            box-shadow ${m},
            outline ${m}
          `
        },
        "&:hover, &:active, &:focus": {
          "&::before": {
            insetInlineStart: l(d).sub(u).div(2).add(g).mul(-1).equal(),
            insetBlockStart: l(d).sub(u).div(2).add(g).mul(-1).equal(),
            width: l(d).add(l(g).mul(2)).equal(),
            height: l(d).add(l(g).mul(2)).equal()
          },
          "&::after": {
            boxShadow: `0 0 0 ${Qe(g)} ${f}`,
            outline: `6px solid ${h}`,
            width: d,
            height: d,
            insetInlineStart: e.calc(u).sub(d).div(2).equal(),
            insetBlockStart: e.calc(u).sub(d).div(2).equal()
          }
        }
      },
      [`&-lock ${t}-handle`]: {
        "&::before, &::after": {
          transition: "none"
        }
      },
      [`${t}-mark`]: {
        position: "absolute",
        fontSize: e.fontSize
      },
      [`${t}-mark-text`]: {
        position: "absolute",
        display: "inline-block",
        color: e.colorTextDescription,
        textAlign: "center",
        wordBreak: "keep-all",
        cursor: "pointer",
        userSelect: "none",
        "&-active": {
          color: e.colorText
        }
      },
      [`${t}-step`]: {
        position: "absolute",
        background: "transparent",
        pointerEvents: "none"
      },
      [`${t}-dot`]: {
        position: "absolute",
        width: i,
        height: i,
        backgroundColor: e.colorBgElevated,
        border: `${Qe(p)} solid ${e.dotBorderColor}`,
        borderRadius: "50%",
        cursor: "pointer",
        transition: `border-color ${e.motionDurationSlow}`,
        pointerEvents: "auto",
        "&-active": {
          borderColor: e.dotActiveBorderColor
        }
      },
      [`&${t}-disabled`]: {
        cursor: "not-allowed",
        [`${t}-rail`]: {
          backgroundColor: `${e.railBg} !important`
        },
        [`${t}-track`]: {
          backgroundColor: `${e.trackBgDisabled} !important`
        },
        [`
          ${t}-dot
        `]: {
          backgroundColor: e.colorBgElevated,
          borderColor: e.trackBgDisabled,
          boxShadow: "none",
          cursor: "not-allowed"
        },
        [`${t}-handle::after`]: {
          backgroundColor: e.colorBgElevated,
          cursor: "not-allowed",
          width: u,
          height: u,
          boxShadow: `0 0 0 ${Qe(p)} ${c}`,
          insetInlineStart: 0,
          insetBlockStart: 0
        },
        [`
          ${t}-mark-text,
          ${t}-dot
        `]: {
          cursor: "not-allowed !important"
        }
      },
      [`&-tooltip ${n}-tooltip-inner`]: {
        minWidth: "unset"
      }
    })
  };
}, KJ = (e, t) => {
  const {
    componentCls: n,
    railSize: r,
    handleSize: i,
    dotSize: o,
    marginFull: a,
    calc: s
  } = e, c = t ? "paddingBlock" : "paddingInline", l = t ? "width" : "height", u = t ? "height" : "width", d = t ? "insetBlockStart" : "insetInlineStart", f = t ? "top" : "insetInlineStart", h = s(r).mul(3).sub(i).div(2).equal(), p = s(i).sub(r).div(2).equal(), g = t ? {
    borderWidth: `${Qe(p)} 0`,
    transform: `translateY(${Qe(s(p).mul(-1).equal())})`
  } : {
    borderWidth: `0 ${Qe(p)}`,
    transform: `translateX(${Qe(e.calc(p).mul(-1).equal())})`
  };
  return {
    [c]: r,
    [u]: s(r).mul(3).equal(),
    [`${n}-rail`]: {
      [l]: "100%",
      [u]: r
    },
    [`${n}-track,${n}-tracks`]: {
      [u]: r
    },
    [`${n}-track-draggable`]: Object.assign({}, g),
    [`${n}-handle`]: {
      [d]: h
    },
    [`${n}-mark`]: {
      // Reset all
      insetInlineStart: 0,
      top: 0,
      // https://github.com/ant-design/ant-design/issues/43731
      [f]: s(r).mul(3).add(t ? 0 : a).equal(),
      [l]: "100%"
    },
    [`${n}-step`]: {
      // Reset all
      insetInlineStart: 0,
      top: 0,
      [f]: r,
      [l]: "100%",
      [u]: r
    },
    [`${n}-dot`]: {
      position: "absolute",
      [d]: s(r).sub(o).div(2).equal()
    }
  };
}, bNe = (e) => {
  const {
    componentCls: t,
    marginPartWithMark: n
  } = e;
  return {
    [`${t}-horizontal`]: Object.assign(Object.assign({}, KJ(e, !0)), {
      [`&${t}-with-marks`]: {
        marginBottom: n
      }
    })
  };
}, _Ne = (e) => {
  const {
    componentCls: t
  } = e;
  return {
    [`${t}-vertical`]: Object.assign(Object.assign({}, KJ(e, !1)), {
      height: "100%"
    })
  };
}, SNe = (e) => {
  const n = e.controlHeightLG / 4, r = e.controlHeightSM / 2, i = e.lineWidth + 1, o = e.lineWidth + 1 * 1.5, a = e.colorPrimary, s = new Pn(a).setAlpha(0.2).toRgbString();
  return {
    controlSize: n,
    railSize: 4,
    handleSize: n,
    handleSizeHover: r,
    dotSize: 8,
    handleLineWidth: i,
    handleLineWidthHover: o,
    railBg: e.colorFillTertiary,
    railHoverBg: e.colorFillSecondary,
    trackBg: e.colorPrimaryBorder,
    trackHoverBg: e.colorPrimaryBorderHover,
    handleColor: e.colorPrimaryBorder,
    handleActiveColor: a,
    handleActiveOutlineColor: s,
    handleColorDisabled: new Pn(e.colorTextDisabled).onBackground(e.colorBgContainer).toHexShortString(),
    dotBorderColor: e.colorBorderSecondary,
    dotActiveBorderColor: e.colorPrimaryBorder,
    trackBgDisabled: e.colorBgContainerDisabled
  };
}, wNe = qa("Slider", (e) => {
  const t = Or(e, {
    marginPart: e.calc(e.controlHeight).sub(e.controlSize).div(2).equal(),
    marginFull: e.calc(e.controlSize).div(2).equal(),
    marginPartWithMark: e.calc(e.controlHeightLG).sub(e.controlSize).equal()
  });
  return [yNe(t), bNe(t), _Ne(t)];
}, SNe), xNe = /* @__PURE__ */ Is({}), ENe = xNe;
function tT() {
  const [e, t] = I.useState(!1), n = I.useRef(), r = () => {
    Ln.cancel(n.current);
  }, i = (o) => {
    r(), o ? t(o) : n.current = Ln(() => {
      t(o);
    });
  };
  return I.useEffect(() => r, []), [e, i];
}
var CNe = globalThis && globalThis.__rest || function(e, t) {
  var n = {};
  for (var r in e)
    Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var i = 0, r = Object.getOwnPropertySymbols(e); i < r.length; i++)
      t.indexOf(r[i]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[i]) && (n[r[i]] = e[r[i]]);
  return n;
};
function TNe(e, t) {
  return e || e === null ? e : t || t === null ? t : (n) => typeof n == "number" ? n.toString() : "";
}
const YJ = /* @__PURE__ */ D.forwardRef((e, t) => {
  const {
    prefixCls: n,
    range: r,
    className: i,
    rootClassName: o,
    style: a,
    disabled: s,
    // Deprecated Props
    tooltipPrefixCls: c,
    tipFormatter: l,
    tooltipVisible: u,
    getTooltipPopupContainer: d,
    tooltipPlacement: f,
    tooltip: h = {},
    onChangeComplete: p
  } = e, g = CNe(e, ["prefixCls", "range", "className", "rootClassName", "style", "disabled", "tooltipPrefixCls", "tipFormatter", "tooltipVisible", "getTooltipPopupContainer", "tooltipPlacement", "tooltip", "onChangeComplete"]), {
    vertical: m
  } = e, {
    direction: v,
    slider: y,
    getPrefixCls: S,
    getPopupContainer: _
  } = D.useContext(En), w = D.useContext(Uu), T = s ?? w, {
    handleRender: x,
    direction: C
  } = D.useContext(ENe), R = (C || v) === "rtl", [A, O] = tT(), [$, N] = tT(), z = Object.assign({}, h), {
    open: k,
    placement: F,
    getPopupContainer: V,
    prefixCls: j,
    formatter: B
  } = z, U = k ?? u, Q = (A || $) && U !== !1, K = TNe(B, l), [q, X] = tT(), ie = (ge) => {
    p == null || p(ge), X(!1);
  }, te = (ge, he) => ge || (he ? R ? "left" : "right" : "top"), J = S("slider", n), [Y, ee, Z] = wNe(J), H = we(i, y == null ? void 0 : y.className, o, {
    [`${J}-rtl`]: R,
    [`${J}-lock`]: q
  }, ee, Z);
  if (R && !g.vertical && (g.reverse = !g.reverse), process.env.NODE_ENV !== "production") {
    const ge = di("Slider");
    [["tooltipPrefixCls", "prefixCls"], ["getTooltipPopupContainer", "getPopupContainer"], ["tipFormatter", "formatter"], ["tooltipPlacement", "placement"], ["tooltipVisible", "open"]].forEach((he) => {
      let [ue, Ee] = he;
      ge.deprecated(!(ue in e), ue, `tooltip.${Ee}`);
    });
  }
  D.useEffect(() => {
    const ge = () => {
      Ln(() => {
        N(!1);
      }, 1);
    };
    return document.addEventListener("mouseup", ge), () => {
      document.removeEventListener("mouseup", ge);
    };
  }, []);
  const oe = r && !U, W = x || ((ge, he) => {
    const {
      index: ue
    } = he, Ee = ge.props;
    function pe(Ie, Ve, Fe) {
      var Pe, ot, dt, ft;
      Fe && ((ot = (Pe = g)[Ie]) === null || ot === void 0 || ot.call(Pe, Ve)), (ft = (dt = Ee)[Ie]) === null || ft === void 0 || ft.call(dt, Ve);
    }
    const Oe = Object.assign(Object.assign({}, Ee), {
      onMouseEnter: (Ie) => {
        O(!0), pe("onMouseEnter", Ie);
      },
      onMouseLeave: (Ie) => {
        O(!1), pe("onMouseLeave", Ie);
      },
      onMouseDown: (Ie) => {
        N(!0), X(!0), pe("onMouseDown", Ie);
      },
      onFocus: (Ie) => {
        var Ve;
        N(!0), (Ve = g.onFocus) === null || Ve === void 0 || Ve.call(g, Ie), pe("onFocus", Ie, !0);
      },
      onBlur: (Ie) => {
        var Ve;
        N(!1), (Ve = g.onBlur) === null || Ve === void 0 || Ve.call(g, Ie), pe("onBlur", Ie, !0);
      }
    }), de = /* @__PURE__ */ D.cloneElement(ge, Oe), be = (!!U || Q) && K !== null;
    return oe ? de : /* @__PURE__ */ D.createElement(mj, Object.assign({}, z, {
      prefixCls: S("tooltip", j ?? c),
      title: K ? K(he.value) : "",
      open: be,
      placement: te(F ?? f, m),
      key: ue,
      overlayClassName: `${J}-tooltip`,
      getPopupContainer: V || d || _
    }), de);
  }), se = oe ? (ge, he) => {
    const ue = /* @__PURE__ */ D.cloneElement(ge, {
      style: Object.assign(Object.assign({}, ge.props.style), {
        visibility: "hidden"
      })
    });
    return /* @__PURE__ */ D.createElement(mj, Object.assign({}, z, {
      prefixCls: S("tooltip", j ?? c),
      title: K ? K(he.value) : "",
      open: K !== null && Q,
      placement: te(F ?? f, m),
      key: "tooltip",
      overlayClassName: `${J}-tooltip`,
      getPopupContainer: V || d || _,
      draggingDelete: he.draggingDelete
    }), ue);
  } : void 0, ce = Object.assign(Object.assign({}, y == null ? void 0 : y.style), a);
  return Y(
    // @ts-ignore
    /* @__PURE__ */ D.createElement(qJ, Object.assign({}, g, {
      step: g.step,
      range: r,
      className: H,
      style: ce,
      disabled: T,
      ref: t,
      prefixCls: J,
      handleRender: W,
      activeHandleRender: se,
      onChangeComplete: ie
    }))
  );
});
process.env.NODE_ENV !== "production" && (YJ.displayName = "Slider");
const wR = YJ, FS = 100, XJ = FS / 5, QJ = FS / 2 - XJ / 2, nT = QJ * 2 * Math.PI, vj = 50, yj = (e) => {
  const {
    dotClassName: t,
    style: n,
    hasCircleCls: r
  } = e;
  return /* @__PURE__ */ I.createElement("circle", {
    className: we(`${t}-circle`, {
      [`${t}-circle-bg`]: r
    }),
    r: QJ,
    cx: vj,
    cy: vj,
    strokeWidth: XJ,
    style: n
  });
}, INe = (e) => {
  let {
    percent: t,
    prefixCls: n
  } = e;
  const r = `${n}-dot`, i = `${r}-holder`, o = `${i}-hidden`, [a, s] = I.useState(!1);
  nr(() => {
    t !== 0 && s(!0);
  }, [t !== 0]);
  const c = Math.max(Math.min(t, 100), 0);
  if (!a)
    return null;
  const l = {
    strokeDashoffset: `${nT / 4}`,
    strokeDasharray: `${nT * c / 100} ${nT * (100 - c) / 100}`
  };
  return /* @__PURE__ */ I.createElement("span", {
    className: we(i, `${r}-progress`, c <= 0 && o)
  }, /* @__PURE__ */ I.createElement("svg", {
    viewBox: `0 0 ${FS} ${FS}`,
    // biome-ignore lint/a11y/noNoninteractiveElementToInteractiveRole: progressbar could be readonly
    role: "progressbar",
    "aria-valuemin": 0,
    "aria-valuemax": 100,
    "aria-valuenow": c
  }, /* @__PURE__ */ I.createElement(yj, {
    dotClassName: r,
    hasCircleCls: !0
  }), /* @__PURE__ */ I.createElement(yj, {
    dotClassName: r,
    style: l
  })));
}, ANe = INe;
function RNe(e) {
  const {
    prefixCls: t,
    percent: n = 0
  } = e, r = `${t}-dot`, i = `${r}-holder`, o = `${i}-hidden`;
  return /* @__PURE__ */ I.createElement(I.Fragment, null, /* @__PURE__ */ I.createElement("span", {
    className: we(i, n > 0 && o)
  }, /* @__PURE__ */ I.createElement("span", {
    className: we(r, `${t}-dot-spin`)
  }, [1, 2, 3, 4].map((a) => /* @__PURE__ */ I.createElement("i", {
    className: `${t}-dot-item`,
    key: a
  })))), /* @__PURE__ */ I.createElement(ANe, {
    prefixCls: t,
    percent: n
  }));
}
function $Ne(e) {
  const {
    prefixCls: t,
    indicator: n,
    percent: r
  } = e, i = `${t}-dot`;
  return n && /* @__PURE__ */ I.isValidElement(n) ? Ng(n, {
    className: we(n.props.className, i),
    percent: r
  }) : /* @__PURE__ */ I.createElement(RNe, {
    prefixCls: t,
    percent: r
  });
}
const ONe = new $n("antSpinMove", {
  to: {
    opacity: 1
  }
}), PNe = new $n("antRotate", {
  to: {
    transform: "rotate(405deg)"
  }
}), MNe = (e) => {
  const {
    componentCls: t,
    calc: n
  } = e;
  return {
    [t]: Object.assign(Object.assign({}, va(e)), {
      position: "absolute",
      display: "none",
      color: e.colorPrimary,
      fontSize: 0,
      textAlign: "center",
      verticalAlign: "middle",
      opacity: 0,
      transition: `transform ${e.motionDurationSlow} ${e.motionEaseInOutCirc}`,
      "&-spinning": {
        position: "relative",
        display: "inline-block",
        opacity: 1
      },
      [`${t}-text`]: {
        fontSize: e.fontSize,
        paddingTop: n(n(e.dotSize).sub(e.fontSize)).div(2).add(2).equal()
      },
      "&-fullscreen": {
        position: "fixed",
        width: "100vw",
        height: "100vh",
        backgroundColor: e.colorBgMask,
        zIndex: e.zIndexPopupBase,
        inset: 0,
        display: "flex",
        alignItems: "center",
        flexDirection: "column",
        justifyContent: "center",
        opacity: 0,
        visibility: "hidden",
        transition: `all ${e.motionDurationMid}`,
        "&-show": {
          opacity: 1,
          visibility: "visible"
        },
        [t]: {
          [`${t}-dot-holder`]: {
            color: e.colorWhite
          },
          [`${t}-text`]: {
            color: e.colorTextLightSolid
          }
        }
      },
      "&-nested-loading": {
        position: "relative",
        [`> div > ${t}`]: {
          position: "absolute",
          top: 0,
          insetInlineStart: 0,
          zIndex: 4,
          display: "block",
          width: "100%",
          height: "100%",
          maxHeight: e.contentHeight,
          [`${t}-dot`]: {
            position: "absolute",
            top: "50%",
            insetInlineStart: "50%",
            margin: n(e.dotSize).mul(-1).div(2).equal()
          },
          [`${t}-text`]: {
            position: "absolute",
            top: "50%",
            width: "100%",
            textShadow: `0 1px 2px ${e.colorBgContainer}`
            // FIXME: shadow
          },
          [`&${t}-show-text ${t}-dot`]: {
            marginTop: n(e.dotSize).div(2).mul(-1).sub(10).equal()
          },
          "&-sm": {
            [`${t}-dot`]: {
              margin: n(e.dotSizeSM).mul(-1).div(2).equal()
            },
            [`${t}-text`]: {
              paddingTop: n(n(e.dotSizeSM).sub(e.fontSize)).div(2).add(2).equal()
            },
            [`&${t}-show-text ${t}-dot`]: {
              marginTop: n(e.dotSizeSM).div(2).mul(-1).sub(10).equal()
            }
          },
          "&-lg": {
            [`${t}-dot`]: {
              margin: n(e.dotSizeLG).mul(-1).div(2).equal()
            },
            [`${t}-text`]: {
              paddingTop: n(n(e.dotSizeLG).sub(e.fontSize)).div(2).add(2).equal()
            },
            [`&${t}-show-text ${t}-dot`]: {
              marginTop: n(e.dotSizeLG).div(2).mul(-1).sub(10).equal()
            }
          }
        },
        [`${t}-container`]: {
          position: "relative",
          transition: `opacity ${e.motionDurationSlow}`,
          "&::after": {
            position: "absolute",
            top: 0,
            insetInlineEnd: 0,
            bottom: 0,
            insetInlineStart: 0,
            zIndex: 10,
            width: "100%",
            height: "100%",
            background: e.colorBgContainer,
            opacity: 0,
            transition: `all ${e.motionDurationSlow}`,
            content: '""',
            pointerEvents: "none"
          }
        },
        [`${t}-blur`]: {
          clear: "both",
          opacity: 0.5,
          userSelect: "none",
          pointerEvents: "none",
          "&::after": {
            opacity: 0.4,
            pointerEvents: "auto"
          }
        }
      },
      // tip
      // ------------------------------
      "&-tip": {
        color: e.spinDotDefault
      },
      // holder
      // ------------------------------
      [`${t}-dot-holder`]: {
        width: "1em",
        height: "1em",
        fontSize: e.dotSize,
        display: "inline-block",
        transition: `transform ${e.motionDurationSlow} ease, opacity ${e.motionDurationSlow} ease`,
        transformOrigin: "50% 50%",
        lineHeight: 1,
        color: e.colorPrimary,
        "&-hidden": {
          transform: "scale(0.3)",
          opacity: 0
        }
      },
      // progress
      // ------------------------------
      [`${t}-dot-progress`]: {
        position: "absolute",
        top: "50%",
        transform: "translate(-50%, -50%)",
        insetInlineStart: "50%"
      },
      // dots
      // ------------------------------
      [`${t}-dot`]: {
        position: "relative",
        display: "inline-block",
        fontSize: e.dotSize,
        width: "1em",
        height: "1em",
        "&-item": {
          position: "absolute",
          display: "block",
          width: n(e.dotSize).sub(n(e.marginXXS).div(2)).div(2).equal(),
          height: n(e.dotSize).sub(n(e.marginXXS).div(2)).div(2).equal(),
          background: "currentColor",
          borderRadius: "100%",
          transform: "scale(0.75)",
          transformOrigin: "50% 50%",
          opacity: 0.3,
          animationName: ONe,
          animationDuration: "1s",
          animationIterationCount: "infinite",
          animationTimingFunction: "linear",
          animationDirection: "alternate",
          "&:nth-child(1)": {
            top: 0,
            insetInlineStart: 0,
            animationDelay: "0s"
          },
          "&:nth-child(2)": {
            top: 0,
            insetInlineEnd: 0,
            animationDelay: "0.4s"
          },
          "&:nth-child(3)": {
            insetInlineEnd: 0,
            bottom: 0,
            animationDelay: "0.8s"
          },
          "&:nth-child(4)": {
            bottom: 0,
            insetInlineStart: 0,
            animationDelay: "1.2s"
          }
        },
        "&-spin": {
          transform: "rotate(45deg)",
          animationName: PNe,
          animationDuration: "1.2s",
          animationIterationCount: "infinite",
          animationTimingFunction: "linear"
        },
        "&-circle": {
          strokeLinecap: "round",
          transition: ["stroke-dashoffset", "stroke-dasharray", "stroke", "stroke-width", "opacity"].map((r) => `${r} ${e.motionDurationSlow} ease`).join(","),
          fillOpacity: 0,
          stroke: "currentcolor"
        },
        "&-circle-bg": {
          stroke: e.colorFillSecondary
        }
      },
      // small
      [`&-sm ${t}-dot`]: {
        "&, &-holder": {
          fontSize: e.dotSizeSM
        }
      },
      [`&-sm ${t}-dot-holder`]: {
        i: {
          width: n(n(e.dotSizeSM).sub(n(e.marginXXS).div(2))).div(2).equal(),
          height: n(n(e.dotSizeSM).sub(n(e.marginXXS).div(2))).div(2).equal()
        }
      },
      // large
      [`&-lg ${t}-dot`]: {
        "&, &-holder": {
          fontSize: e.dotSizeLG
        }
      },
      [`&-lg ${t}-dot-holder`]: {
        i: {
          width: n(n(e.dotSizeLG).sub(e.marginXXS)).div(2).equal(),
          height: n(n(e.dotSizeLG).sub(e.marginXXS)).div(2).equal()
        }
      },
      [`&${t}-show-text ${t}-text`]: {
        display: "block"
      }
    })
  };
}, kNe = (e) => {
  const {
    controlHeightLG: t,
    controlHeight: n
  } = e;
  return {
    contentHeight: 400,
    dotSize: t / 2,
    dotSizeSM: t * 0.35,
    dotSizeLG: n
  };
}, NNe = qa("Spin", (e) => {
  const t = Or(e, {
    spinDotDefault: e.colorTextDescription
  });
  return [MNe(t)];
}, kNe), DNe = 200, bj = [[30, 0.05], [70, 0.03], [96, 0.01]];
function LNe(e, t) {
  const [n, r] = I.useState(0), i = I.useRef(), o = t === "auto";
  return I.useEffect(() => (o && e && (r(0), i.current = setInterval(() => {
    r((a) => {
      const s = 100 - a;
      for (let c = 0; c < bj.length; c += 1) {
        const [l, u] = bj[c];
        if (a <= l)
          return a + s * u;
      }
      return a;
    });
  }, DNe)), () => {
    clearInterval(i.current);
  }), [o, e]), o ? n : t;
}
var jNe = globalThis && globalThis.__rest || function(e, t) {
  var n = {};
  for (var r in e)
    Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var i = 0, r = Object.getOwnPropertySymbols(e); i < r.length; i++)
      t.indexOf(r[i]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[i]) && (n[r[i]] = e[r[i]]);
  return n;
};
let JJ;
function FNe(e, t) {
  return !!e && !!t && !isNaN(Number(t));
}
const J6 = (e) => {
  var t;
  const {
    prefixCls: n,
    spinning: r = !0,
    delay: i = 0,
    className: o,
    rootClassName: a,
    size: s = "default",
    tip: c,
    wrapperClassName: l,
    style: u,
    children: d,
    fullscreen: f = !1,
    indicator: h,
    percent: p
  } = e, g = jNe(e, ["prefixCls", "spinning", "delay", "className", "rootClassName", "size", "tip", "wrapperClassName", "style", "children", "fullscreen", "indicator", "percent"]), {
    getPrefixCls: m,
    direction: v,
    spin: y
  } = I.useContext(En), S = m("spin", n), [_, w, T] = NNe(S), [x, C] = I.useState(() => r && !FNe(r, i)), E = LNe(x, p);
  I.useEffect(() => {
    if (r) {
      const k = G3e(i, () => {
        C(!0);
      });
      return k(), () => {
        var F;
        (F = k == null ? void 0 : k.cancel) === null || F === void 0 || F.call(k);
      };
    }
    C(!1);
  }, [i, r]);
  const R = I.useMemo(() => typeof d < "u" && !f, [d, f]);
  if (process.env.NODE_ENV !== "production") {
    const k = di("Spin");
    process.env.NODE_ENV !== "production" && k(!c || R || f, "usage", "`tip` only work in nest or fullscreen pattern.");
  }
  const A = we(S, y == null ? void 0 : y.className, {
    [`${S}-sm`]: s === "small",
    [`${S}-lg`]: s === "large",
    [`${S}-spinning`]: x,
    [`${S}-show-text`]: !!c,
    [`${S}-rtl`]: v === "rtl"
  }, o, !f && a, w, T), O = we(`${S}-container`, {
    [`${S}-blur`]: x
  }), $ = (t = h ?? (y == null ? void 0 : y.indicator)) !== null && t !== void 0 ? t : JJ, N = Object.assign(Object.assign({}, y == null ? void 0 : y.style), u), z = /* @__PURE__ */ I.createElement("div", Object.assign({}, g, {
    style: N,
    className: A,
    "aria-live": "polite",
    "aria-busy": x
  }), /* @__PURE__ */ I.createElement($Ne, {
    prefixCls: S,
    indicator: $,
    percent: E
  }), c && (R || f) ? /* @__PURE__ */ I.createElement("div", {
    className: `${S}-text`
  }, c) : null);
  return _(R ? /* @__PURE__ */ I.createElement("div", Object.assign({}, g, {
    className: we(`${S}-nested-loading`, l, w, T)
  }), x && /* @__PURE__ */ I.createElement("div", {
    key: "loading"
  }, z), /* @__PURE__ */ I.createElement("div", {
    className: O,
    key: "container"
  }, d)) : f ? /* @__PURE__ */ I.createElement("div", {
    className: we(`${S}-fullscreen`, {
      [`${S}-fullscreen-show`]: x
    }, a, w, T)
  }, z) : z);
};
J6.setDefaultIndicator = (e) => {
  JJ = e;
};
process.env.NODE_ENV !== "production" && (J6.displayName = "Spin");
const uv = J6;
let Ma = null, Cd = (e) => e(), dv = [], fv = {};
function _j() {
  const {
    getContainer: e,
    duration: t,
    rtl: n,
    maxCount: r,
    top: i
  } = fv, o = (e == null ? void 0 : e()) || document.body;
  return {
    getContainer: () => o,
    duration: t,
    rtl: n,
    maxCount: r,
    top: i
  };
}
const VNe = /* @__PURE__ */ D.forwardRef((e, t) => {
  const {
    messageConfig: n,
    sync: r
  } = e, {
    getPrefixCls: i
  } = St(En), o = fv.prefixCls || i("message"), a = St(JPe), [s, c] = rQ(Object.assign(Object.assign(Object.assign({}, n), {
    prefixCls: o
  }), a.message));
  return D.useImperativeHandle(t, () => {
    const l = Object.assign({}, s);
    return Object.keys(l).forEach((u) => {
      l[u] = function() {
        return r(), s[u].apply(s, arguments);
      };
    }), {
      instance: l,
      sync: r
    };
  }), c;
}), BNe = /* @__PURE__ */ D.forwardRef((e, t) => {
  const [n, r] = D.useState(_j), i = () => {
    r(_j);
  };
  D.useEffect(i, []);
  const o = AX(), a = o.getRootPrefixCls(), s = o.getIconPrefixCls(), c = o.getTheme(), l = /* @__PURE__ */ D.createElement(VNe, {
    ref: t,
    sync: i,
    messageConfig: n
  });
  return /* @__PURE__ */ D.createElement(lo, {
    prefixCls: a,
    iconPrefixCls: s,
    theme: c
  }, o.holderRender ? o.holderRender(l) : l);
});
function gE() {
  if (!Ma) {
    const e = document.createDocumentFragment(), t = {
      fragment: e
    };
    Ma = t, Cd(() => {
      iQ(/* @__PURE__ */ D.createElement(BNe, {
        ref: (n) => {
          const {
            instance: r,
            sync: i
          } = n || {};
          Promise.resolve().then(() => {
            !t.instance && r && (t.instance = r, t.sync = i, gE());
          });
        }
      }), e);
    });
    return;
  }
  Ma.instance && (dv.forEach((e) => {
    const {
      type: t,
      skipped: n
    } = e;
    if (!n)
      switch (t) {
        case "open": {
          Cd(() => {
            const r = Ma.instance.open(Object.assign(Object.assign({}, fv), e.config));
            r == null || r.then(e.resolve), e.setCloseFn(r);
          });
          break;
        }
        case "destroy":
          Cd(() => {
            Ma == null || Ma.instance.destroy(e.key);
          });
          break;
        default:
          Cd(() => {
            var r;
            const i = (r = Ma.instance)[t].apply(r, Je(e.args));
            i == null || i.then(e.resolve), e.setCloseFn(i);
          });
      }
  }), dv = []);
}
function zNe(e) {
  fv = Object.assign(Object.assign({}, fv), e), Cd(() => {
    var t;
    (t = Ma == null ? void 0 : Ma.sync) === null || t === void 0 || t.call(Ma);
  });
}
function HNe(e) {
  const t = w6((n) => {
    let r;
    const i = {
      type: "open",
      config: e,
      resolve: n,
      setCloseFn: (o) => {
        r = o;
      }
    };
    return dv.push(i), () => {
      r ? Cd(() => {
        r();
      }) : i.skipped = !0;
    };
  });
  return gE(), t;
}
function UNe(e, t) {
  const n = AX();
  process.env.NODE_ENV !== "production" && !n.holderRender && QIe("message");
  const r = w6((i) => {
    let o;
    const a = {
      type: e,
      args: t,
      resolve: i,
      setCloseFn: (s) => {
        o = s;
      }
    };
    return dv.push(a), () => {
      o ? Cd(() => {
        o();
      }) : a.skipped = !0;
    };
  });
  return gE(), r;
}
const WNe = (e) => {
  dv.push({
    type: "destroy",
    key: e
  }), gE();
}, qNe = ["success", "info", "warning", "error", "loading"], GNe = {
  open: HNe,
  destroy: WNe,
  config: zNe,
  useMessage: bRe,
  _InternalPanelDoNotUseOrYouWillBeFired: dRe
}, ZJ = GNe;
qNe.forEach((e) => {
  ZJ[e] = function() {
    for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++)
      n[r] = arguments[r];
    return UNe(e, n);
  };
});
process.env.NODE_ENV;
process.env.NODE_ENV;
const KNe = ZJ;
var YNe = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M300 276.5a56 56 0 1056-97 56 56 0 00-56 97zm0 284a56 56 0 1056-97 56 56 0 00-56 97zM640 228a56 56 0 10112 0 56 56 0 00-112 0zm0 284a56 56 0 10112 0 56 56 0 00-112 0zM300 844.5a56 56 0 1056-97 56 56 0 00-56 97zM640 796a56 56 0 10112 0 56 56 0 00-112 0z" } }] }, name: "holder", theme: "outlined" };
const XNe = YNe;
var QNe = function(t, n) {
  return /* @__PURE__ */ I.createElement(fo, mt({}, t, {
    ref: n,
    icon: XNe
  }));
}, eZ = /* @__PURE__ */ I.forwardRef(QNe);
process.env.NODE_ENV !== "production" && (eZ.displayName = "HolderOutlined");
const tZ = eZ;
var JNe = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z" } }, { tag: "path", attrs: { d: "M464 336a48 48 0 1096 0 48 48 0 10-96 0zm72 112h-48c-4.4 0-8 3.6-8 8v272c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V456c0-4.4-3.6-8-8-8z" } }] }, name: "info-circle", theme: "outlined" };
const ZNe = JNe;
var eDe = function(t, n) {
  return /* @__PURE__ */ I.createElement(fo, mt({}, t, {
    ref: n,
    icon: ZNe
  }));
}, nZ = /* @__PURE__ */ I.forwardRef(eDe);
process.env.NODE_ENV !== "production" && (nZ.displayName = "InfoCircleOutlined");
const tDe = nZ;
class nDe extends Vse {
  constructor() {
    super();
    ye(this, "antdMessage");
    ye(this, "index", 0);
    this.antdMessage = KNe, this.antdMessage.config({ prefixCls: "prefix-survey-message", maxCount: 2, duration: 4 });
  }
  info(n) {
    this.addMessage(n, "info");
  }
  success(n) {
    this.addMessage(n, "success");
  }
  warning(n) {
    this.addMessage(n, "warning");
  }
  error(n) {
    this.addMessage(n, "error", /* @__PURE__ */ M.jsx(_6, { style: { color: "var(--error)" } }));
  }
  addMessage(n, r, i) {
    const o = this.index;
    this.antdMessage.open({
      key: o,
      content: /* @__PURE__ */ M.jsx(
        rDe,
        {
          type: r,
          message: n,
          closable: !0,
          closeIcon: /* @__PURE__ */ M.jsx(Zx, {}),
          onClose: () => this.destroy(o),
          icon: i,
          showIcon: !0
        }
      ),
      className: "survey-message"
    }), this.index++;
  }
  destroy(n) {
    this.antdMessage.destroy(n);
  }
  destroyAll() {
    this.antdMessage.destroy();
  }
  config(n) {
    this.antdMessage.config({ ...n, prefixCls: "prefix-survey-message" });
  }
  setContainer(n) {
    this.antdMessage.config({ getContainer: () => n });
  }
}
const rDe = Ce(UAe)`
  font-family: 'Rethink Sans', sans-serif;
  background-color: #ffffff;
  text-align: start;
  border: 0;
  width: 100%;

  > .ant-alert-icon {
    margin-right: 11px;
  }

  > .ant-alert-close-icon {
    margin-left: 11px;
  }
`;
class iDe extends Bse {
  constructor() {
    super(...arguments);
    ye(this, "helpPopup", new Vs({ content: null }));
  }
  setPopup(n, r, i, o) {
    if (i === !1 || o !== void 0 && !o.includes(r) || !Object.keys(n).includes(r))
      return;
    const a = n[r];
    this.helpPopup.next(a);
  }
  clearPopup() {
    this.helpPopup.next({ content: null });
  }
  observePopup() {
    return this.helpPopup;
  }
}
const pE = Is({
  surveyName: ""
});
var oDe = "firebase", aDe = "11.10.0";
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
Jo(oDe, aDe, "app");
function nSt(e) {
  const t = wH(e);
  return mve(t, { experimentalAutoDetectLongPolling: !0 }), t;
}
function Dn(e, t) {
  const { loggingService: n } = St(ir), [r, i] = Lt(), o = Wn.isObject(t) ? Object.values(t) : [t];
  return gt(() => {
    n.info("useOptionallyAsyncValue useEffect", e, t);
    let a = !0;
    const s = async (c, l) => {
      const u = await c(t);
      a && i(u);
    };
    return Wn.isFunction(e) ? s(e) : i(e), () => {
      a = !1;
    };
  }, [e, n, ...o]), r;
}
function hy(e, t) {
  const { currentAnswer: n, answers: r, aggregateAnswers: i } = t, o = At(
    () => ({ currentAnswer: n, answers: r, aggregateAnswers: i }),
    [n, r, i]
  );
  return Dn(e, o);
}
function gc(e, t) {
  const { loggingService: n } = St(ir), [r, i] = Lt([]);
  return gt(() => {
    n.info("useChoices useEffect", e, t);
    const o = { answers: t };
    let a = !0;
    const s = async (c) => {
      const l = await c(o);
      a && i(l);
    };
    return Wn.isFunction(e) ? s(e) : i(e), () => {
      a = !1;
    };
  }, [t, e, n]), r;
}
function hr() {
  const e = St(pE);
  return At(() => zse(e), [e]);
}
function Z6() {
  const e = St(pE);
  return e.font === void 0 ? "'Rethink Sans', sans-serif" : `${e.font.family}, 'Rethink Sans', sans-serif;`;
}
function ho() {
  return St(pE).borderRadius || "4px";
}
function kf(e, t, n, r, i) {
  const { loggingService: o } = St(ir);
  gt(() => {
    if (o.info("Running default value useEffect", t, n), !n || n.getValue(t.type) || t.id in r.raw())
      return;
    const a = e();
    o.debug("Default values in useEffect", a), a !== void 0 && i({
      value: a
    });
  }, [e, t, n, r, i, o]);
}
function hv(e) {
  return Dr(e);
}
function Dr(e) {
  const n = new URLSearchParams(window.location.search).get("lang") || "default";
  return Iz(e) ? e[n] || e.default : e;
}
const sDe = (e, t, n) => {
  if (e.constraint) {
    const r = e.constraint.func({ currentAnswer: t });
    if (console.log("constraint", r), console.log("currentAnswer", t), !r)
      return n.error(e.constraint.message), !1;
  }
  if (!e.required)
    return !0;
  switch (e.type) {
    case "singleSelect":
      return cDe(e, t, n);
    case "multiSelect":
      return lDe(e, t, n);
    case "matrix":
      return uDe(e, t, n);
    case "multiDropdown":
      return dDe(e, t, n);
    case "conjointAnalysis":
      return fDe();
    case "slider":
      return hDe(e, t, n);
    case "multiInput":
      return gDe(e, t, n);
    case "dropdown":
      return pDe(e, t, n);
    case "choiceExperiment":
      return bDe();
    case "ranking":
      return mDe();
    case "commentBox":
      return vDe(e, t, n);
    case "responsiveSlider":
      return yDe();
    case "choiceRank":
      return _De();
    case "compareSlider":
      return SDe();
    case "shift":
      return wDe();
    case "shiftContinuous":
      return xDe();
    case "match":
      return EDe(e, t, n);
    case "loggingTestPage":
    case "welcomePage":
    case "infoPage":
    case "endPage":
    case "hidden":
      return !0;
    default:
      return Kd();
  }
};
function cDe(e, t, n) {
  return console.log("checkSingleSelect", e, t), Az(t.getValue(e.type)) === null ? (n.error("This question requires an answer"), !1) : !0;
}
function lDe(e, t, n) {
  const r = Hse(t.getValue(e.type));
  return r === null || r.length === 0 ? (n.error("This question requires an answer"), !1) : e.min && r.length < e.min ? (n.error(`Please select at least ${e.min} options`), !1) : e.max && r.length > e.max ? (n.error(`Please select no more than ${e.max} options`), !1) : !0;
}
function uDe(e, t, n) {
  const r = t.isValid(e.type);
  if (!r)
    for (const i of t.invalidMessages(e.type))
      n.error(i);
  return r;
}
function dDe(e, t, n) {
  const r = t.getValue(e.type) ?? [];
  return r.length === 0 ? (n.error("This question requires an answer"), !1) : e.max && r.length > e.max ? (n.error(`Please select no more than ${e.max} options`), !1) : !0;
}
function fDe(e, t, n) {
  throw new Error("Function not implemented.");
}
function hDe(e, t, n) {
  const r = t.getValue(e.type);
  if (r === null)
    return n.error("This question requires an answer"), !1;
  const i = parseFloat(r.value);
  return isNaN(i) ? (n.error("Please enter a number"), !1) : e.min && i < e.min ? (n.error("Please enter a number greater than or equal to " + e.min), !1) : !0;
}
function gDe(e, t, n) {
  const r = t.isValid(e.type);
  if (!r)
    for (const i of t.invalidMessages(e.type))
      n.error(i);
  return r;
}
function pDe(e, t, n) {
  return t.getValue(e.type) === null ? (n.error("This question requires an answer"), !1) : !0;
}
function mDe(e, t, n) {
  return !0;
}
function vDe(e, t, n) {
  const r = t.getValue(e.type);
  return r === null || r.value.length === 0 ? (n.error("This question requires an answer"), !1) : !0;
}
function yDe(e, t, n) {
  throw new Error("Function not implemented.");
}
function bDe(e, t, n) {
  throw new Error("Function not implemented.");
}
function _De(e, t, n) {
  throw new Error("Function not implemented.");
}
function SDe(e, t, n) {
  throw new Error("Function not implemented.");
}
function wDe(e, t, n) {
  throw new Error("Function not implemented.");
}
function xDe(e, t, n) {
  throw new Error("Function not implemented.");
}
function EDe(e, t, n) {
  return (t.getValue(e.type) ?? []).length !== e.leftChoices.length ? (n.error("This question requires an answer"), !1) : !0;
}
function CDe(e) {
  var t = /* @__PURE__ */ Object.create(null);
  return function(n) {
    return t[n] === void 0 && (t[n] = e(n)), t[n];
  };
}
var TDe = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|disableRemotePlayback|download|draggable|encType|enterKeyHint|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/, IDe = /* @__PURE__ */ CDe(
  function(e) {
    return TDe.test(e) || e.charCodeAt(0) === 111 && e.charCodeAt(1) === 110 && e.charCodeAt(2) < 91;
  }
  /* Z+1 */
);
const mE = Is({
  survey: {},
  currentQuestion: void 0,
  currentSurveyQuestions: [],
  interactionDisabled: !1,
  loading: !0,
  currentPercentage: 0,
  submitAnswer: async () => {
  },
  goToPreviousQuestion: () => {
  },
  updateSurveyControls: (e) => {
  },
  setNextButtonBehaviour: (e) => {
  },
  setPreviousButtonBehaviour: (e) => {
  },
  displayBackButton: () => !0,
  displayNextButton: () => !0,
  displaySubmitButton: () => !0,
  previousQuestion: () => {
  },
  nextQuestion: () => {
  },
  onSubmitSurvey: () => {
  },
  surveyControlsState: {
    nextDisabled: !1,
    prevDisabled: !1
  },
  nextButtonText: void 0,
  hideSurveyControls: () => !1
});
function rSt() {
  return St(mE);
}
const ADe = ({
  survey: e,
  submissionId: t,
  startFrom: n,
  initialState: r,
  children: i,
  onSubmitAnswer: o,
  onComplete: a,
  storeManager: s,
  databaseService: c,
  userService: l,
  onReady: u,
  onError: d,
  currentQuestionId: f,
  currentAnswerTransformer: h,
  isSubmitClicked: p,
  loggingService: g
}) => {
  const m = new nDe(), v = new iDe(), [y, S] = Lt(!0), [_, w] = Lt(void 0), [T, x] = Lt(!1), [C, E] = Lt(e.questions), [R, A] = Lt({
    nextDisabled: !1,
    prevDisabled: !1
  }), [O, $] = Lt(
    void 0
  ), N = mn(
    (he) => {
      $(he === void 0 ? he : () => he);
    },
    [$]
  ), [z, k] = Lt(
    void 0
  ), F = mn(
    (he) => {
      k(he === void 0 ? he : () => he);
    },
    [k]
  ), V = cH(), j = C.find((he) => he.id === f), B = Me(h), U = Me(j), Q = Me(C);
  gt(() => {
    B.current = h, U.current = j, Q.current = C;
  }, [h, j, C]);
  function K() {
    return !B.current || !U.current ? !0 : sDe(U.current, B.current, m);
  }
  function q() {
    K() && (m.destroyAll(), v.clearPopup(), o == null || o({
      question: U.current,
      answer: B.current
    }), V(tD()), V(Nle(Q.current)), V(nD(Q.current)));
  }
  async function X() {
    x(!0), await new Promise((he) => setTimeout(he, 300)), q(), x(!1);
  }
  function ie() {
    m.destroyAll(), v.clearPopup(), V(tD()), V(Dle()), V(nD(C));
  }
  const te = mn((he) => {
    A((ue) => ({
      ...ue,
      ...he
    }));
  }, []);
  function J() {
    return !(C.findIndex((ue) => ue.id === f) === 0 || j != null && j.hidePreviousButton) && !(j != null && j.hideUi);
  }
  function Y() {
    return (j == null ? void 0 : j.type) !== "endPage";
  }
  function ee() {
    return (j == null ? void 0 : j.type) === "endPage" && !e.settings.hideSubmit;
  }
  function Z() {
    if ((j == null ? void 0 : j.type) === "endPage" && j.contentAfterSubmit || m.success("Thanks for completing the survey!"), !h)
      throw new Error("Missing CurrentAnswer");
    Promise.all([
      V(
        aH({
          ...h.getAnswer()
        })
      ),
      V(sH()),
      V(jle())
    ]).then(a);
  }
  function H() {
    return (j == null ? void 0 : j.type) === "endPage" && j.contentAfterSubmit && p ? !0 : (j == null ? void 0 : j.hideUi) ?? !1;
  }
  function oe() {
    var ue;
    const he = e.settings.primaryColour;
    he && ((ue = document.querySelector('meta[name="theme-color"]')) == null || ue.setAttribute("content", he));
  }
  function W(he) {
    return he.map((ue) => {
      if ("shuffle" in ue && ue.shuffle && Wn.isArray(ue.choices)) {
        const [Ee, pe] = Wn.partition(
          ue.choices,
          ({ type: Oe, submit: de }) => Oe === "input" || de
        );
        return { ...ue, choices: Wn.shuffle(pe).concat(Ee) };
      }
      return ue;
    });
  }
  function se() {
    return Math.round(
      C.findIndex((he) => he.id === f) * 100 / (C.length - 1)
    );
  }
  gt(() => {
    const he = s.observeReady().subscribe({
      next: (ue) => {
        console.log("storeReadySubscription ready", ue), ue && (console.log("storeReadySubscription ready"), S(!1), u == null || u());
      },
      error: (ue) => {
        w(ue), d == null || d(ue);
      }
    });
    return s.initialise(
      e,
      c,
      l,
      t,
      n,
      r
    ), oe(), () => {
      he.unsubscribe();
    };
  }, [s, c, l]), gt(() => {
    const he = W(e.questions);
    E(he);
  }, [e.questions]);
  const { crashReportingService: ce, analyticsService: ge } = St(ir);
  return /* @__PURE__ */ M.jsx(
    ir.Provider,
    {
      value: {
        loggingService: g,
        messagerService: m,
        popupService: v,
        userService: l,
        databaseService: c,
        crashReportingService: ce,
        analyticsService: ge
      },
      children: /* @__PURE__ */ M.jsx(pE.Provider, { value: e.settings, children: /* @__PURE__ */ M.jsx(ece, { shouldForwardProp: $De, enableVendorPrefixes: !0, children: /* @__PURE__ */ M.jsx(
        mE.Provider,
        {
          value: {
            survey: e,
            loading: y,
            error: _,
            interactionDisabled: T,
            currentPercentage: se(),
            submitAnswer: X,
            currentQuestion: j,
            currentSurveyQuestions: C,
            goToPreviousQuestion: ie,
            updateSurveyControls: te,
            setNextButtonBehaviour: N,
            setPreviousButtonBehaviour: F,
            displayBackButton: J,
            displayNextButton: Y,
            displaySubmitButton: ee,
            previousQuestion: z ?? ie,
            nextQuestion: O ?? q,
            onSubmitSurvey: Z,
            surveyControlsState: R,
            nextButtonText: j == null ? void 0 : j.nextButtonText,
            hideSurveyControls: H
          },
          children: i
        }
      ) }) })
    }
  );
}, RDe = ({
  survey: e,
  submissionId: t,
  startFrom: n,
  initialState: r,
  children: i,
  onSubmitAnswer: o,
  onComplete: a,
  storeManager: s,
  databaseService: c,
  userService: l,
  onReady: u,
  onError: d,
  loggingService: f
}) => {
  const { currentAnswer: h, currentQuestionId: p, isSubmitClicked: g } = f_(
    (v) => v.survey
  ), m = h ? new Dv(h, f) : void 0;
  return /* @__PURE__ */ M.jsx(
    ADe,
    {
      survey: e,
      submissionId: t,
      startFrom: n,
      initialState: r,
      children: i,
      onSubmitAnswer: o,
      onComplete: a,
      storeManager: s,
      databaseService: c,
      userService: l,
      onReady: u,
      onError: d,
      loggingService: f,
      currentQuestionId: p,
      currentAnswerTransformer: m,
      isSubmitClicked: g
    }
  );
}, iSt = ({
  survey: e,
  children: t,
  onSubmitAnswer: n,
  onComplete: r,
  onReady: i,
  onError: o,
  databaseService: a,
  userService: s,
  submissionId: c,
  startFrom: l,
  initialState: u
}) => {
  const { loggingService: d } = St(ir), f = new Vle(d), h = f.getStore();
  return /* @__PURE__ */ M.jsx(Rce, { store: h, children: /* @__PURE__ */ M.jsx(
    RDe,
    {
      survey: e,
      submissionId: c,
      startFrom: l,
      initialState: u,
      storeManager: f,
      onSubmitAnswer: n,
      onComplete: r,
      databaseService: a,
      userService: s,
      onReady: i,
      onError: o,
      loggingService: d,
      children: t
    }
  ) });
};
function $De(e, t) {
  return typeof t == "string" ? IDe(e) : !0;
}
const ODe = ({ question: e, answers: t }) => {
  const { primaryColour: n } = hr(), r = ho(), i = wa(), o = Dn(e.text, { answers: t }), a = hv(o);
  let s = typeof a < "u" ? /* @__PURE__ */ M.jsx(MDe, { children: a }) : /* @__PURE__ */ M.jsx(NL, { active: !0, paragraph: { rows: 4 }, title: !1 });
  const c = Dn(e.header, { answers: t }), l = hv(c);
  let u = l ? /* @__PURE__ */ M.jsx(PDe, { children: l }) : e.header ? /* @__PURE__ */ M.jsx(NL, { active: !0, paragraph: { rows: 1, width: "40%" }, title: !1 }) : null;
  const d = aO(({ survey: h }) => h.isSubmitClicked);
  return e.type === "endPage" && e.contentAfterSubmit && d && (s = null, u = null), i === ui.MOBILE && e.type === "welcomePage" ? /* @__PURE__ */ M.jsxs(
    Sj,
    {
      style: {
        // background: 'var(--dark)',
        background: n,
        opacity: 0.9,
        color: "white",
        borderRadius: r,
        padding: "1rem"
      },
      children: [
        u,
        s
      ]
    }
  ) : /* @__PURE__ */ M.jsxs(Sj, { children: [
    u,
    s
  ] });
}, Sj = Ce.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  z-index: 1;
  align-items: baseline;
  gap: 1rem;
`, PDe = Ce.h1`
  font-size: var(--question-header-font-size);
  font-weight: 500;
  margin-top: 0;
`, MDe = Ce.div`
  display: flex;
  align-self: 'baseline';
  margin-bottom: 0;
  width: 100%;
  font-size: var(--question-text-font-size);
`, kDe = { top: 0.5, left: 0.5, side: "left" }, NDe = (e) => {
  var h;
  const { container: t } = e, { popupService: n } = St(ir), r = Me(null), [i, o] = Lt(kDe), a = Rz(n.observePopup());
  if (gt(() => {
    if (r.current) {
      const { height: p, width: g } = r.current.getBoundingClientRect(), m = jDe(t, p, g, a == null ? void 0 : a.position);
      o(m);
    }
  }, [r.current, a == null ? void 0 : a.position, t, (h = r.current) == null ? void 0 : h.offsetWidth]), a === void 0 || a.content === null)
    return null;
  const { content: s } = a, { top: c, left: l, side: u } = i, d = DDe(t, u), f = LDe(t, u);
  return /* @__PURE__ */ M.jsx("div", { children: rO(
    /* @__PURE__ */ M.jsx(
      UDe,
      {
        top: c,
        left: l,
        maxWidth: d,
        maxHeight: f,
        ref: r,
        children: /* @__PURE__ */ M.jsx("span", { children: s })
      },
      s == null ? void 0 : s.toString()
    ),
    document.body
  ) });
};
function DDe(e, t) {
  switch (t) {
    case "left":
      return e.left - 20;
    case "right":
      return document.body.offsetWidth - e.right - 20;
    case "top":
    case "bottom":
      return e.width;
    default:
      Kd();
  }
}
function LDe(e, t) {
  switch (t) {
    case "left":
    case "right":
      return e.height;
    case "top":
      return e.top;
    case "bottom":
      return document.body.offsetHeight - e.bottom;
    default:
      Kd();
  }
}
function jDe(e, t, n, r) {
  const i = { top: 0, left: 0.5, side: "left" }, o = { ...i, ...r }, { top: a, left: s } = o;
  return a < 0 || a > 1 || s < 0 || s > 1 ? (console.error("Invalid popup position out of bounds", e.top, e.left, o), i) : FDe(e, t, n, o);
}
function FDe(e, t, n, r) {
  const { side: i } = r;
  switch (i) {
    case "left":
      return VDe(e, t, n, r);
    case "right":
      return BDe(e, t, n, r);
    case "top":
      return zDe(e, t, n, r);
    case "bottom":
      return HDe(e, t, n, r);
    default:
      Kd();
  }
}
function VDe(e, t, n, r) {
  const { top: i, left: o, side: a } = r, s = n / 2, l = (e.left - n / 2 - s) * o + s, u = e.top;
  return { top: (e.top + e.height - t - u) * i + u, left: l, side: a };
}
function BDe(e, t, n, r) {
  const { top: i, left: o, side: a } = r, s = e.right + n / 2, l = (document.body.offsetWidth - n / 2 - s) * o + s, u = e.top;
  return { top: (e.top + e.height - t - u) * i + u, left: l, side: a };
}
function zDe(e, t, n, r) {
  const { top: i, left: o, side: a } = r, s = e.left + n / 2, l = (e.right - n / 2 - s) * o + s, u = 0;
  return { top: (e.top - t - u) * i + u, left: l, side: a };
}
function HDe(e, t, n, r) {
  const { top: i, left: o, side: a } = r, s = e.left + n / 2, l = (e.right - n / 2 - s) * o + s, u = e.bottom;
  return { top: (document.body.offsetHeight - t - u) * i + u, left: l, side: a };
}
const UDe = Ce.div`
  position: absolute;
  background: var(--light);
  border: 1px solid var(--light);
  box-shadow: 2px 2px 4.1px 2px rgba(17, 17, 17, 0.1);
  padding: var(--spacing-sm);
  max-width: ${(e) => e.maxWidth}px;
  max-height: ${(e) => e.maxHeight}px;
  z-index: 3;
  transform: translateX(-50%);
  top: ${(e) => e.top}px;
  left: ${(e) => e.left}px;
  animation: fade-in 0.4s ease-in;
  @keyframes fade-in {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }
  overflow: auto;
`, WDe = (e) => +e;
function qDe(e) {
  return e * e;
}
function GDe(e) {
  return e * (2 - e);
}
function wj(e) {
  return ((e *= 2) <= 1 ? e * e : --e * (2 - e) + 1) / 2;
}
function KDe(e) {
  return e * e * e;
}
function YDe(e) {
  return --e * e * e + 1;
}
function xj(e) {
  return ((e *= 2) <= 1 ? e * e * e : (e -= 2) * e * e + 2) / 2;
}
var eM = 3, XDe = function e(t) {
  t = +t;
  function n(r) {
    return Math.pow(r, t);
  }
  return n.exponent = e, n;
}(eM), QDe = function e(t) {
  t = +t;
  function n(r) {
    return 1 - Math.pow(1 - r, t);
  }
  return n.exponent = e, n;
}(eM), Ej = function e(t) {
  t = +t;
  function n(r) {
    return ((r *= 2) <= 1 ? Math.pow(r, t) : 2 - Math.pow(2 - r, t)) / 2;
  }
  return n.exponent = e, n;
}(eM), rZ = Math.PI, iZ = rZ / 2;
function JDe(e) {
  return +e == 1 ? 1 : 1 - Math.cos(e * iZ);
}
function ZDe(e) {
  return Math.sin(e * iZ);
}
function Cj(e) {
  return (1 - Math.cos(rZ * e)) / 2;
}
function Tu(e) {
  return (Math.pow(2, -10 * e) - 9765625e-10) * 1.0009775171065494;
}
function e7e(e) {
  return Tu(1 - +e);
}
function t7e(e) {
  return 1 - Tu(e);
}
function Tj(e) {
  return ((e *= 2) <= 1 ? Tu(1 - e) : 2 - Tu(e - 1)) / 2;
}
function n7e(e) {
  return 1 - Math.sqrt(1 - e * e);
}
function r7e(e) {
  return Math.sqrt(1 - --e * e);
}
function Ij(e) {
  return ((e *= 2) <= 1 ? 1 - Math.sqrt(1 - e * e) : Math.sqrt(1 - (e -= 2) * e) + 1) / 2;
}
var xR = 4 / 11, i7e = 6 / 11, o7e = 8 / 11, a7e = 3 / 4, s7e = 9 / 11, c7e = 10 / 11, l7e = 15 / 16, u7e = 21 / 22, d7e = 63 / 64, Xb = 1 / xR / xR;
function f7e(e) {
  return 1 - gv(1 - e);
}
function gv(e) {
  return (e = +e) < xR ? Xb * e * e : e < o7e ? Xb * (e -= i7e) * e + a7e : e < c7e ? Xb * (e -= s7e) * e + l7e : Xb * (e -= u7e) * e + d7e;
}
function h7e(e) {
  return ((e *= 2) <= 1 ? 1 - gv(1 - e) : gv(e - 1) + 1) / 2;
}
var tM = 1.70158, g7e = function e(t) {
  t = +t;
  function n(r) {
    return (r = +r) * r * (t * (r - 1) + r);
  }
  return n.overshoot = e, n;
}(tM), p7e = function e(t) {
  t = +t;
  function n(r) {
    return --r * r * ((r + 1) * t + r) + 1;
  }
  return n.overshoot = e, n;
}(tM), Aj = function e(t) {
  t = +t;
  function n(r) {
    return ((r *= 2) < 1 ? r * r * ((t + 1) * r - t) : (r -= 2) * r * ((t + 1) * r + t) + 2) / 2;
  }
  return n.overshoot = e, n;
}(tM), jg = 2 * Math.PI, nM = 1, rM = 0.3, m7e = function e(t, n) {
  var r = Math.asin(1 / (t = Math.max(1, t))) * (n /= jg);
  function i(o) {
    return t * Tu(- --o) * Math.sin((r - o) / n);
  }
  return i.amplitude = function(o) {
    return e(o, n * jg);
  }, i.period = function(o) {
    return e(t, o);
  }, i;
}(nM, rM), Rj = function e(t, n) {
  var r = Math.asin(1 / (t = Math.max(1, t))) * (n /= jg);
  function i(o) {
    return 1 - t * Tu(o = +o) * Math.sin((o + r) / n);
  }
  return i.amplitude = function(o) {
    return e(o, n * jg);
  }, i.period = function(o) {
    return e(t, o);
  }, i;
}(nM, rM), v7e = function e(t, n) {
  var r = Math.asin(1 / (t = Math.max(1, t))) * (n /= jg);
  function i(o) {
    return ((o = o * 2 - 1) < 0 ? t * Tu(-o) * Math.sin((r - o) / n) : 2 - t * Tu(o) * Math.sin((r + o) / n)) / 2;
  }
  return i.amplitude = function(o) {
    return e(o, n * jg);
  }, i.period = function(o) {
    return e(t, o);
  }, i;
}(nM, rM);
const y7e = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  easeBack: Aj,
  easeBackIn: g7e,
  easeBackInOut: Aj,
  easeBackOut: p7e,
  easeBounce: gv,
  easeBounceIn: f7e,
  easeBounceInOut: h7e,
  easeBounceOut: gv,
  easeCircle: Ij,
  easeCircleIn: n7e,
  easeCircleInOut: Ij,
  easeCircleOut: r7e,
  easeCubic: xj,
  easeCubicIn: KDe,
  easeCubicInOut: xj,
  easeCubicOut: YDe,
  easeElastic: Rj,
  easeElasticIn: m7e,
  easeElasticInOut: v7e,
  easeElasticOut: Rj,
  easeExp: Tj,
  easeExpIn: e7e,
  easeExpInOut: Tj,
  easeExpOut: t7e,
  easeLinear: WDe,
  easePoly: Ej,
  easePolyIn: XDe,
  easePolyInOut: Ej,
  easePolyOut: QDe,
  easeQuad: wj,
  easeQuadIn: qDe,
  easeQuadInOut: wj,
  easeQuadOut: GDe,
  easeSin: Cj,
  easeSinIn: JDe,
  easeSinInOut: Cj,
  easeSinOut: ZDe
}, Symbol.toStringTag, { value: "Module" }));
var b7e = typeof km == "object" && km && km.Object === Object && km, oZ = b7e, _7e = oZ, S7e = typeof self == "object" && self && self.Object === Object && self, w7e = _7e || S7e || Function("return this")(), Sc = w7e, x7e = Sc, E7e = x7e.Symbol, Tp = E7e, $j = Tp, aZ = Object.prototype, C7e = aZ.hasOwnProperty, T7e = aZ.toString, pm = $j ? $j.toStringTag : void 0;
function I7e(e) {
  var t = C7e.call(e, pm), n = e[pm];
  try {
    e[pm] = void 0;
    var r = !0;
  } catch {
  }
  var i = T7e.call(e);
  return r && (t ? e[pm] = n : delete e[pm]), i;
}
var A7e = I7e, R7e = Object.prototype, $7e = R7e.toString;
function O7e(e) {
  return $7e.call(e);
}
var P7e = O7e, Oj = Tp, M7e = A7e, k7e = P7e, N7e = "[object Null]", D7e = "[object Undefined]", Pj = Oj ? Oj.toStringTag : void 0;
function L7e(e) {
  return e == null ? e === void 0 ? D7e : N7e : Pj && Pj in Object(e) ? M7e(e) : k7e(e);
}
var vl = L7e;
function j7e(e, t) {
  return function(n) {
    return e(t(n));
  };
}
var sZ = j7e, F7e = sZ, V7e = F7e(Object.getPrototypeOf, Object), iM = V7e;
function B7e(e) {
  return e != null && typeof e == "object";
}
var Ga = B7e, z7e = vl, H7e = iM, U7e = Ga, W7e = "[object Object]", q7e = Function.prototype, G7e = Object.prototype, cZ = q7e.toString, K7e = G7e.hasOwnProperty, Y7e = cZ.call(Object);
function X7e(e) {
  if (!U7e(e) || z7e(e) != W7e)
    return !1;
  var t = H7e(e);
  if (t === null)
    return !0;
  var n = K7e.call(t, "constructor") && t.constructor;
  return typeof n == "function" && n instanceof n && cZ.call(n) == Y7e;
}
var oM = X7e;
const ti = /* @__PURE__ */ pn(oM);
function Q7e(e, t) {
  for (var n = -1, r = e == null ? 0 : e.length, i = Array(r); ++n < r; )
    i[n] = t(e[n], n, e);
  return i;
}
var gy = Q7e, J7e = Array.isArray, Gi = J7e, Z7e = vl, e4e = Ga, t4e = "[object Symbol]";
function n4e(e) {
  return typeof e == "symbol" || e4e(e) && Z7e(e) == t4e;
}
var py = n4e, r4e = Gi, i4e = py, o4e = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, a4e = /^\w*$/;
function s4e(e, t) {
  if (r4e(e))
    return !1;
  var n = typeof e;
  return n == "number" || n == "symbol" || n == "boolean" || e == null || i4e(e) ? !0 : a4e.test(e) || !o4e.test(e) || t != null && e in Object(t);
}
var aM = s4e;
function c4e(e) {
  var t = typeof e;
  return e != null && (t == "object" || t == "function");
}
var Ka = c4e;
const ER = /* @__PURE__ */ pn(Ka);
var l4e = vl, u4e = Ka, d4e = "[object AsyncFunction]", f4e = "[object Function]", h4e = "[object GeneratorFunction]", g4e = "[object Proxy]";
function p4e(e) {
  if (!u4e(e))
    return !1;
  var t = l4e(e);
  return t == f4e || t == h4e || t == d4e || t == g4e;
}
var vE = p4e;
const m4e = /* @__PURE__ */ pn(vE);
var v4e = Sc, y4e = v4e["__core-js_shared__"], b4e = y4e, rT = b4e, Mj = function() {
  var e = /[^.]+$/.exec(rT && rT.keys && rT.keys.IE_PROTO || "");
  return e ? "Symbol(src)_1." + e : "";
}();
function _4e(e) {
  return !!Mj && Mj in e;
}
var S4e = _4e, w4e = Function.prototype, x4e = w4e.toString;
function E4e(e) {
  if (e != null) {
    try {
      return x4e.call(e);
    } catch {
    }
    try {
      return e + "";
    } catch {
    }
  }
  return "";
}
var lZ = E4e, C4e = vE, T4e = S4e, I4e = Ka, A4e = lZ, R4e = /[\\^$.*+?()[\]{}|]/g, $4e = /^\[object .+?Constructor\]$/, O4e = Function.prototype, P4e = Object.prototype, M4e = O4e.toString, k4e = P4e.hasOwnProperty, N4e = RegExp(
  "^" + M4e.call(k4e).replace(R4e, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
);
function D4e(e) {
  if (!I4e(e) || T4e(e))
    return !1;
  var t = C4e(e) ? N4e : $4e;
  return t.test(A4e(e));
}
var L4e = D4e;
function j4e(e, t) {
  return e == null ? void 0 : e[t];
}
var F4e = j4e, V4e = L4e, B4e = F4e;
function z4e(e, t) {
  var n = B4e(e, t);
  return V4e(n) ? n : void 0;
}
var Nf = z4e, H4e = Nf, U4e = H4e(Object, "create"), yE = U4e, kj = yE;
function W4e() {
  this.__data__ = kj ? kj(null) : {}, this.size = 0;
}
var q4e = W4e;
function G4e(e) {
  var t = this.has(e) && delete this.__data__[e];
  return this.size -= t ? 1 : 0, t;
}
var K4e = G4e, Y4e = yE, X4e = "__lodash_hash_undefined__", Q4e = Object.prototype, J4e = Q4e.hasOwnProperty;
function Z4e(e) {
  var t = this.__data__;
  if (Y4e) {
    var n = t[e];
    return n === X4e ? void 0 : n;
  }
  return J4e.call(t, e) ? t[e] : void 0;
}
var e8e = Z4e, t8e = yE, n8e = Object.prototype, r8e = n8e.hasOwnProperty;
function i8e(e) {
  var t = this.__data__;
  return t8e ? t[e] !== void 0 : r8e.call(t, e);
}
var o8e = i8e, a8e = yE, s8e = "__lodash_hash_undefined__";
function c8e(e, t) {
  var n = this.__data__;
  return this.size += this.has(e) ? 0 : 1, n[e] = a8e && t === void 0 ? s8e : t, this;
}
var l8e = c8e, u8e = q4e, d8e = K4e, f8e = e8e, h8e = o8e, g8e = l8e;
function Ip(e) {
  var t = -1, n = e == null ? 0 : e.length;
  for (this.clear(); ++t < n; ) {
    var r = e[t];
    this.set(r[0], r[1]);
  }
}
Ip.prototype.clear = u8e;
Ip.prototype.delete = d8e;
Ip.prototype.get = f8e;
Ip.prototype.has = h8e;
Ip.prototype.set = g8e;
var p8e = Ip;
function m8e() {
  this.__data__ = [], this.size = 0;
}
var v8e = m8e;
function y8e(e, t) {
  return e === t || e !== e && t !== t;
}
var Df = y8e, b8e = Df;
function _8e(e, t) {
  for (var n = e.length; n--; )
    if (b8e(e[n][0], t))
      return n;
  return -1;
}
var bE = _8e, S8e = bE, w8e = Array.prototype, x8e = w8e.splice;
function E8e(e) {
  var t = this.__data__, n = S8e(t, e);
  if (n < 0)
    return !1;
  var r = t.length - 1;
  return n == r ? t.pop() : x8e.call(t, n, 1), --this.size, !0;
}
var C8e = E8e, T8e = bE;
function I8e(e) {
  var t = this.__data__, n = T8e(t, e);
  return n < 0 ? void 0 : t[n][1];
}
var A8e = I8e, R8e = bE;
function $8e(e) {
  return R8e(this.__data__, e) > -1;
}
var O8e = $8e, P8e = bE;
function M8e(e, t) {
  var n = this.__data__, r = P8e(n, e);
  return r < 0 ? (++this.size, n.push([e, t])) : n[r][1] = t, this;
}
var k8e = M8e, N8e = v8e, D8e = C8e, L8e = A8e, j8e = O8e, F8e = k8e;
function Ap(e) {
  var t = -1, n = e == null ? 0 : e.length;
  for (this.clear(); ++t < n; ) {
    var r = e[t];
    this.set(r[0], r[1]);
  }
}
Ap.prototype.clear = N8e;
Ap.prototype.delete = D8e;
Ap.prototype.get = L8e;
Ap.prototype.has = j8e;
Ap.prototype.set = F8e;
var _E = Ap, V8e = Nf, B8e = Sc, z8e = V8e(B8e, "Map"), sM = z8e, Nj = p8e, H8e = _E, U8e = sM;
function W8e() {
  this.size = 0, this.__data__ = {
    hash: new Nj(),
    map: new (U8e || H8e)(),
    string: new Nj()
  };
}
var q8e = W8e;
function G8e(e) {
  var t = typeof e;
  return t == "string" || t == "number" || t == "symbol" || t == "boolean" ? e !== "__proto__" : e === null;
}
var K8e = G8e, Y8e = K8e;
function X8e(e, t) {
  var n = e.__data__;
  return Y8e(t) ? n[typeof t == "string" ? "string" : "hash"] : n.map;
}
var SE = X8e, Q8e = SE;
function J8e(e) {
  var t = Q8e(this, e).delete(e);
  return this.size -= t ? 1 : 0, t;
}
var Z8e = J8e, eLe = SE;
function tLe(e) {
  return eLe(this, e).get(e);
}
var nLe = tLe, rLe = SE;
function iLe(e) {
  return rLe(this, e).has(e);
}
var oLe = iLe, aLe = SE;
function sLe(e, t) {
  var n = aLe(this, e), r = n.size;
  return n.set(e, t), this.size += n.size == r ? 0 : 1, this;
}
var cLe = sLe, lLe = q8e, uLe = Z8e, dLe = nLe, fLe = oLe, hLe = cLe;
function Rp(e) {
  var t = -1, n = e == null ? 0 : e.length;
  for (this.clear(); ++t < n; ) {
    var r = e[t];
    this.set(r[0], r[1]);
  }
}
Rp.prototype.clear = lLe;
Rp.prototype.delete = uLe;
Rp.prototype.get = dLe;
Rp.prototype.has = fLe;
Rp.prototype.set = hLe;
var cM = Rp, uZ = cM, gLe = "Expected a function";
function lM(e, t) {
  if (typeof e != "function" || t != null && typeof t != "function")
    throw new TypeError(gLe);
  var n = function() {
    var r = arguments, i = t ? t.apply(this, r) : r[0], o = n.cache;
    if (o.has(i))
      return o.get(i);
    var a = e.apply(this, r);
    return n.cache = o.set(i, a) || o, a;
  };
  return n.cache = new (lM.Cache || uZ)(), n;
}
lM.Cache = uZ;
var dZ = lM;
const fZ = /* @__PURE__ */ pn(dZ);
var pLe = dZ, mLe = 500;
function vLe(e) {
  var t = pLe(e, function(r) {
    return n.size === mLe && n.clear(), r;
  }), n = t.cache;
  return t;
}
var yLe = vLe, bLe = yLe, _Le = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, SLe = /\\(\\)?/g, wLe = bLe(function(e) {
  var t = [];
  return e.charCodeAt(0) === 46 && t.push(""), e.replace(_Le, function(n, r, i, o) {
    t.push(i ? o.replace(SLe, "$1") : r || n);
  }), t;
}), xLe = wLe, Dj = Tp, ELe = gy, CLe = Gi, TLe = py, ILe = 1 / 0, Lj = Dj ? Dj.prototype : void 0, jj = Lj ? Lj.toString : void 0;
function hZ(e) {
  if (typeof e == "string")
    return e;
  if (CLe(e))
    return ELe(e, hZ) + "";
  if (TLe(e))
    return jj ? jj.call(e) : "";
  var t = e + "";
  return t == "0" && 1 / e == -ILe ? "-0" : t;
}
var ALe = hZ, RLe = ALe;
function $Le(e) {
  return e == null ? "" : RLe(e);
}
var gZ = $Le, OLe = Gi, PLe = aM, MLe = xLe, kLe = gZ;
function NLe(e, t) {
  return OLe(e) ? e : PLe(e, t) ? [e] : MLe(kLe(e));
}
var $p = NLe, DLe = py, LLe = 1 / 0;
function jLe(e) {
  if (typeof e == "string" || DLe(e))
    return e;
  var t = e + "";
  return t == "0" && 1 / e == -LLe ? "-0" : t;
}
var Op = jLe, FLe = $p, VLe = Op;
function BLe(e, t) {
  t = FLe(t, e);
  for (var n = 0, r = t.length; e != null && n < r; )
    e = e[VLe(t[n++])];
  return n && n == r ? e : void 0;
}
var my = BLe, zLe = _E;
function HLe() {
  this.__data__ = new zLe(), this.size = 0;
}
var ULe = HLe;
function WLe(e) {
  var t = this.__data__, n = t.delete(e);
  return this.size = t.size, n;
}
var qLe = WLe;
function GLe(e) {
  return this.__data__.get(e);
}
var KLe = GLe;
function YLe(e) {
  return this.__data__.has(e);
}
var XLe = YLe, QLe = _E, JLe = sM, ZLe = cM, eje = 200;
function tje(e, t) {
  var n = this.__data__;
  if (n instanceof QLe) {
    var r = n.__data__;
    if (!JLe || r.length < eje - 1)
      return r.push([e, t]), this.size = ++n.size, this;
    n = this.__data__ = new ZLe(r);
  }
  return n.set(e, t), this.size = n.size, this;
}
var nje = tje, rje = _E, ije = ULe, oje = qLe, aje = KLe, sje = XLe, cje = nje;
function Pp(e) {
  var t = this.__data__ = new rje(e);
  this.size = t.size;
}
Pp.prototype.clear = ije;
Pp.prototype.delete = oje;
Pp.prototype.get = aje;
Pp.prototype.has = sje;
Pp.prototype.set = cje;
var wE = Pp, lje = "__lodash_hash_undefined__";
function uje(e) {
  return this.__data__.set(e, lje), this;
}
var dje = uje;
function fje(e) {
  return this.__data__.has(e);
}
var hje = fje, gje = cM, pje = dje, mje = hje;
function VS(e) {
  var t = -1, n = e == null ? 0 : e.length;
  for (this.__data__ = new gje(); ++t < n; )
    this.add(e[t]);
}
VS.prototype.add = VS.prototype.push = pje;
VS.prototype.has = mje;
var uM = VS;
function vje(e, t) {
  for (var n = -1, r = e == null ? 0 : e.length; ++n < r; )
    if (t(e[n], n, e))
      return !0;
  return !1;
}
var yje = vje;
function bje(e, t) {
  return e.has(t);
}
var dM = bje, _je = uM, Sje = yje, wje = dM, xje = 1, Eje = 2;
function Cje(e, t, n, r, i, o) {
  var a = n & xje, s = e.length, c = t.length;
  if (s != c && !(a && c > s))
    return !1;
  var l = o.get(e), u = o.get(t);
  if (l && u)
    return l == t && u == e;
  var d = -1, f = !0, h = n & Eje ? new _je() : void 0;
  for (o.set(e, t), o.set(t, e); ++d < s; ) {
    var p = e[d], g = t[d];
    if (r)
      var m = a ? r(g, p, d, t, e, o) : r(p, g, d, e, t, o);
    if (m !== void 0) {
      if (m)
        continue;
      f = !1;
      break;
    }
    if (h) {
      if (!Sje(t, function(v, y) {
        if (!wje(h, y) && (p === v || i(p, v, n, r, o)))
          return h.push(y);
      })) {
        f = !1;
        break;
      }
    } else if (!(p === g || i(p, g, n, r, o))) {
      f = !1;
      break;
    }
  }
  return o.delete(e), o.delete(t), f;
}
var pZ = Cje, Tje = Sc, Ije = Tje.Uint8Array, mZ = Ije;
function Aje(e) {
  var t = -1, n = Array(e.size);
  return e.forEach(function(r, i) {
    n[++t] = [i, r];
  }), n;
}
var Rje = Aje;
function $je(e) {
  var t = -1, n = Array(e.size);
  return e.forEach(function(r) {
    n[++t] = r;
  }), n;
}
var fM = $je, Fj = Tp, Vj = mZ, Oje = Df, Pje = pZ, Mje = Rje, kje = fM, Nje = 1, Dje = 2, Lje = "[object Boolean]", jje = "[object Date]", Fje = "[object Error]", Vje = "[object Map]", Bje = "[object Number]", zje = "[object RegExp]", Hje = "[object Set]", Uje = "[object String]", Wje = "[object Symbol]", qje = "[object ArrayBuffer]", Gje = "[object DataView]", Bj = Fj ? Fj.prototype : void 0, iT = Bj ? Bj.valueOf : void 0;
function Kje(e, t, n, r, i, o, a) {
  switch (n) {
    case Gje:
      if (e.byteLength != t.byteLength || e.byteOffset != t.byteOffset)
        return !1;
      e = e.buffer, t = t.buffer;
    case qje:
      return !(e.byteLength != t.byteLength || !o(new Vj(e), new Vj(t)));
    case Lje:
    case jje:
    case Bje:
      return Oje(+e, +t);
    case Fje:
      return e.name == t.name && e.message == t.message;
    case zje:
    case Uje:
      return e == t + "";
    case Vje:
      var s = Mje;
    case Hje:
      var c = r & Nje;
      if (s || (s = kje), e.size != t.size && !c)
        return !1;
      var l = a.get(e);
      if (l)
        return l == t;
      r |= Dje, a.set(e, t);
      var u = Pje(s(e), s(t), r, i, o, a);
      return a.delete(e), u;
    case Wje:
      if (iT)
        return iT.call(e) == iT.call(t);
  }
  return !1;
}
var Yje = Kje;
function Xje(e, t) {
  for (var n = -1, r = t.length, i = e.length; ++n < r; )
    e[i + n] = t[n];
  return e;
}
var hM = Xje, Qje = hM, Jje = Gi;
function Zje(e, t, n) {
  var r = t(e);
  return Jje(e) ? r : Qje(r, n(e));
}
var vZ = Zje;
function eFe(e, t) {
  for (var n = -1, r = e == null ? 0 : e.length, i = 0, o = []; ++n < r; ) {
    var a = e[n];
    t(a, n, e) && (o[i++] = a);
  }
  return o;
}
var yZ = eFe;
function tFe() {
  return [];
}
var bZ = tFe, nFe = yZ, rFe = bZ, iFe = Object.prototype, oFe = iFe.propertyIsEnumerable, zj = Object.getOwnPropertySymbols, aFe = zj ? function(e) {
  return e == null ? [] : (e = Object(e), nFe(zj(e), function(t) {
    return oFe.call(e, t);
  }));
} : rFe, gM = aFe;
function sFe(e, t) {
  for (var n = -1, r = Array(e); ++n < e; )
    r[n] = t(n);
  return r;
}
var cFe = sFe, lFe = vl, uFe = Ga, dFe = "[object Arguments]";
function fFe(e) {
  return uFe(e) && lFe(e) == dFe;
}
var hFe = fFe, Hj = hFe, gFe = Ga, _Z = Object.prototype, pFe = _Z.hasOwnProperty, mFe = _Z.propertyIsEnumerable, vFe = Hj(function() {
  return arguments;
}()) ? Hj : function(e) {
  return gFe(e) && pFe.call(e, "callee") && !mFe.call(e, "callee");
}, vy = vFe, BS = { exports: {} };
function yFe() {
  return !1;
}
var bFe = yFe;
BS.exports;
(function(e, t) {
  var n = Sc, r = bFe, i = t && !t.nodeType && t, o = i && !0 && e && !e.nodeType && e, a = o && o.exports === i, s = a ? n.Buffer : void 0, c = s ? s.isBuffer : void 0, l = c || r;
  e.exports = l;
})(BS, BS.exports);
var yy = BS.exports, _Fe = 9007199254740991, SFe = /^(?:0|[1-9]\d*)$/;
function wFe(e, t) {
  var n = typeof e;
  return t = t ?? _Fe, !!t && (n == "number" || n != "symbol" && SFe.test(e)) && e > -1 && e % 1 == 0 && e < t;
}
var xE = wFe, xFe = 9007199254740991;
function EFe(e) {
  return typeof e == "number" && e > -1 && e % 1 == 0 && e <= xFe;
}
var pM = EFe, CFe = vl, TFe = pM, IFe = Ga, AFe = "[object Arguments]", RFe = "[object Array]", $Fe = "[object Boolean]", OFe = "[object Date]", PFe = "[object Error]", MFe = "[object Function]", kFe = "[object Map]", NFe = "[object Number]", DFe = "[object Object]", LFe = "[object RegExp]", jFe = "[object Set]", FFe = "[object String]", VFe = "[object WeakMap]", BFe = "[object ArrayBuffer]", zFe = "[object DataView]", HFe = "[object Float32Array]", UFe = "[object Float64Array]", WFe = "[object Int8Array]", qFe = "[object Int16Array]", GFe = "[object Int32Array]", KFe = "[object Uint8Array]", YFe = "[object Uint8ClampedArray]", XFe = "[object Uint16Array]", QFe = "[object Uint32Array]", mr = {};
mr[HFe] = mr[UFe] = mr[WFe] = mr[qFe] = mr[GFe] = mr[KFe] = mr[YFe] = mr[XFe] = mr[QFe] = !0;
mr[AFe] = mr[RFe] = mr[BFe] = mr[$Fe] = mr[zFe] = mr[OFe] = mr[PFe] = mr[MFe] = mr[kFe] = mr[NFe] = mr[DFe] = mr[LFe] = mr[jFe] = mr[FFe] = mr[VFe] = !1;
function JFe(e) {
  return IFe(e) && TFe(e.length) && !!mr[CFe(e)];
}
var ZFe = JFe;
function e9e(e) {
  return function(t) {
    return e(t);
  };
}
var Mp = e9e, zS = { exports: {} };
zS.exports;
(function(e, t) {
  var n = oZ, r = t && !t.nodeType && t, i = r && !0 && e && !e.nodeType && e, o = i && i.exports === r, a = o && n.process, s = function() {
    try {
      var c = i && i.require && i.require("util").types;
      return c || a && a.binding && a.binding("util");
    } catch {
    }
  }();
  e.exports = s;
})(zS, zS.exports);
var EE = zS.exports, t9e = ZFe, n9e = Mp, Uj = EE, Wj = Uj && Uj.isTypedArray, r9e = Wj ? n9e(Wj) : t9e, CE = r9e, i9e = cFe, o9e = vy, a9e = Gi, s9e = yy, c9e = xE, l9e = CE, u9e = Object.prototype, d9e = u9e.hasOwnProperty;
function f9e(e, t) {
  var n = a9e(e), r = !n && o9e(e), i = !n && !r && s9e(e), o = !n && !r && !i && l9e(e), a = n || r || i || o, s = a ? i9e(e.length, String) : [], c = s.length;
  for (var l in e)
    (t || d9e.call(e, l)) && !(a && // Safari 9 has enumerable `arguments.length` in strict mode.
    (l == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    i && (l == "offset" || l == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    o && (l == "buffer" || l == "byteLength" || l == "byteOffset") || // Skip index properties.
    c9e(l, c))) && s.push(l);
  return s;
}
var SZ = f9e, h9e = Object.prototype;
function g9e(e) {
  var t = e && e.constructor, n = typeof t == "function" && t.prototype || h9e;
  return e === n;
}
var by = g9e, p9e = sZ, m9e = p9e(Object.keys, Object), v9e = m9e, y9e = by, b9e = v9e, _9e = Object.prototype, S9e = _9e.hasOwnProperty;
function w9e(e) {
  if (!y9e(e))
    return b9e(e);
  var t = [];
  for (var n in Object(e))
    S9e.call(e, n) && n != "constructor" && t.push(n);
  return t;
}
var wZ = w9e, x9e = vE, E9e = pM;
function C9e(e) {
  return e != null && E9e(e.length) && !x9e(e);
}
var Wu = C9e, T9e = SZ, I9e = wZ, A9e = Wu;
function R9e(e) {
  return A9e(e) ? T9e(e) : I9e(e);
}
var kp = R9e, $9e = vZ, O9e = gM, P9e = kp;
function M9e(e) {
  return $9e(e, P9e, O9e);
}
var xZ = M9e, qj = xZ, k9e = 1, N9e = Object.prototype, D9e = N9e.hasOwnProperty;
function L9e(e, t, n, r, i, o) {
  var a = n & k9e, s = qj(e), c = s.length, l = qj(t), u = l.length;
  if (c != u && !a)
    return !1;
  for (var d = c; d--; ) {
    var f = s[d];
    if (!(a ? f in t : D9e.call(t, f)))
      return !1;
  }
  var h = o.get(e), p = o.get(t);
  if (h && p)
    return h == t && p == e;
  var g = !0;
  o.set(e, t), o.set(t, e);
  for (var m = a; ++d < c; ) {
    f = s[d];
    var v = e[f], y = t[f];
    if (r)
      var S = a ? r(y, v, f, t, e, o) : r(v, y, f, e, t, o);
    if (!(S === void 0 ? v === y || i(v, y, n, r, o) : S)) {
      g = !1;
      break;
    }
    m || (m = f == "constructor");
  }
  if (g && !m) {
    var _ = e.constructor, w = t.constructor;
    _ != w && "constructor" in e && "constructor" in t && !(typeof _ == "function" && _ instanceof _ && typeof w == "function" && w instanceof w) && (g = !1);
  }
  return o.delete(e), o.delete(t), g;
}
var j9e = L9e, F9e = Nf, V9e = Sc, B9e = F9e(V9e, "DataView"), z9e = B9e, H9e = Nf, U9e = Sc, W9e = H9e(U9e, "Promise"), q9e = W9e, G9e = Nf, K9e = Sc, Y9e = G9e(K9e, "Set"), EZ = Y9e, X9e = Nf, Q9e = Sc, J9e = X9e(Q9e, "WeakMap"), Z9e = J9e, CR = z9e, TR = sM, IR = q9e, AR = EZ, RR = Z9e, CZ = vl, Np = lZ, Gj = "[object Map]", eVe = "[object Object]", Kj = "[object Promise]", Yj = "[object Set]", Xj = "[object WeakMap]", Qj = "[object DataView]", tVe = Np(CR), nVe = Np(TR), rVe = Np(IR), iVe = Np(AR), oVe = Np(RR), dd = CZ;
(CR && dd(new CR(new ArrayBuffer(1))) != Qj || TR && dd(new TR()) != Gj || IR && dd(IR.resolve()) != Kj || AR && dd(new AR()) != Yj || RR && dd(new RR()) != Xj) && (dd = function(e) {
  var t = CZ(e), n = t == eVe ? e.constructor : void 0, r = n ? Np(n) : "";
  if (r)
    switch (r) {
      case tVe:
        return Qj;
      case nVe:
        return Gj;
      case rVe:
        return Kj;
      case iVe:
        return Yj;
      case oVe:
        return Xj;
    }
  return t;
});
var _y = dd, oT = wE, aVe = pZ, sVe = Yje, cVe = j9e, Jj = _y, Zj = Gi, eF = yy, lVe = CE, uVe = 1, tF = "[object Arguments]", nF = "[object Array]", Qb = "[object Object]", dVe = Object.prototype, rF = dVe.hasOwnProperty;
function fVe(e, t, n, r, i, o) {
  var a = Zj(e), s = Zj(t), c = a ? nF : Jj(e), l = s ? nF : Jj(t);
  c = c == tF ? Qb : c, l = l == tF ? Qb : l;
  var u = c == Qb, d = l == Qb, f = c == l;
  if (f && eF(e)) {
    if (!eF(t))
      return !1;
    a = !0, u = !1;
  }
  if (f && !u)
    return o || (o = new oT()), a || lVe(e) ? aVe(e, t, n, r, i, o) : sVe(e, t, c, n, r, i, o);
  if (!(n & uVe)) {
    var h = u && rF.call(e, "__wrapped__"), p = d && rF.call(t, "__wrapped__");
    if (h || p) {
      var g = h ? e.value() : e, m = p ? t.value() : t;
      return o || (o = new oT()), i(g, m, n, r, o);
    }
  }
  return f ? (o || (o = new oT()), cVe(e, t, n, r, i, o)) : !1;
}
var hVe = fVe, gVe = hVe, iF = Ga;
function TZ(e, t, n, r, i) {
  return e === t ? !0 : e == null || t == null || !iF(e) && !iF(t) ? e !== e && t !== t : gVe(e, t, n, r, TZ, i);
}
var mM = TZ, pVe = wE, mVe = mM, vVe = 1, yVe = 2;
function bVe(e, t, n, r) {
  var i = n.length, o = i, a = !r;
  if (e == null)
    return !o;
  for (e = Object(e); i--; ) {
    var s = n[i];
    if (a && s[2] ? s[1] !== e[s[0]] : !(s[0] in e))
      return !1;
  }
  for (; ++i < o; ) {
    s = n[i];
    var c = s[0], l = e[c], u = s[1];
    if (a && s[2]) {
      if (l === void 0 && !(c in e))
        return !1;
    } else {
      var d = new pVe();
      if (r)
        var f = r(l, u, c, e, t, d);
      if (!(f === void 0 ? mVe(u, l, vVe | yVe, r, d) : f))
        return !1;
    }
  }
  return !0;
}
var _Ve = bVe, SVe = Ka;
function wVe(e) {
  return e === e && !SVe(e);
}
var IZ = wVe, xVe = IZ, EVe = kp;
function CVe(e) {
  for (var t = EVe(e), n = t.length; n--; ) {
    var r = t[n], i = e[r];
    t[n] = [r, i, xVe(i)];
  }
  return t;
}
var TVe = CVe;
function IVe(e, t) {
  return function(n) {
    return n == null ? !1 : n[e] === t && (t !== void 0 || e in Object(n));
  };
}
var AZ = IVe, AVe = _Ve, RVe = TVe, $Ve = AZ;
function OVe(e) {
  var t = RVe(e);
  return t.length == 1 && t[0][2] ? $Ve(t[0][0], t[0][1]) : function(n) {
    return n === e || AVe(n, e, t);
  };
}
var PVe = OVe, MVe = my;
function kVe(e, t, n) {
  var r = e == null ? void 0 : MVe(e, t);
  return r === void 0 ? n : r;
}
var RZ = kVe;
const uf = /* @__PURE__ */ pn(RZ);
function NVe(e, t) {
  return e != null && t in Object(e);
}
var DVe = NVe, LVe = $p, jVe = vy, FVe = Gi, VVe = xE, BVe = pM, zVe = Op;
function HVe(e, t, n) {
  t = LVe(t, e);
  for (var r = -1, i = t.length, o = !1; ++r < i; ) {
    var a = zVe(t[r]);
    if (!(o = e != null && n(e, a)))
      break;
    e = e[a];
  }
  return o || ++r != i ? o : (i = e == null ? 0 : e.length, !!i && BVe(i) && VVe(a, i) && (FVe(e) || jVe(e)));
}
var UVe = HVe, WVe = DVe, qVe = UVe;
function GVe(e, t) {
  return e != null && qVe(e, t, WVe);
}
var $Z = GVe, KVe = mM, YVe = RZ, XVe = $Z, QVe = aM, JVe = IZ, ZVe = AZ, eBe = Op, tBe = 1, nBe = 2;
function rBe(e, t) {
  return QVe(e) && JVe(t) ? ZVe(eBe(e), t) : function(n) {
    var r = YVe(n, e);
    return r === void 0 && r === t ? XVe(n, e) : KVe(t, r, tBe | nBe);
  };
}
var iBe = rBe;
function oBe(e) {
  return e;
}
var Sy = oBe;
const Dp = /* @__PURE__ */ pn(Sy);
function aBe(e) {
  return function(t) {
    return t == null ? void 0 : t[e];
  };
}
var sBe = aBe, cBe = my;
function lBe(e) {
  return function(t) {
    return cBe(t, e);
  };
}
var uBe = lBe, dBe = sBe, fBe = uBe, hBe = aM, gBe = Op;
function pBe(e) {
  return hBe(e) ? dBe(gBe(e)) : fBe(e);
}
var OZ = pBe;
const PZ = /* @__PURE__ */ pn(OZ);
var mBe = PVe, vBe = iBe, yBe = Sy, bBe = Gi, _Be = OZ;
function SBe(e) {
  return typeof e == "function" ? e : e == null ? yBe : typeof e == "object" ? bBe(e) ? vBe(e[0], e[1]) : mBe(e) : _Be(e);
}
var Lp = SBe;
function wBe(e) {
  return function(t, n, r) {
    for (var i = -1, o = Object(t), a = r(t), s = a.length; s--; ) {
      var c = a[e ? s : ++i];
      if (n(o[c], c, o) === !1)
        break;
    }
    return t;
  };
}
var xBe = wBe, EBe = xBe, CBe = EBe(), MZ = CBe, TBe = MZ, IBe = kp;
function ABe(e, t) {
  return e && TBe(e, t, IBe);
}
var RBe = ABe, $Be = Wu;
function OBe(e, t) {
  return function(n, r) {
    if (n == null)
      return n;
    if (!$Be(n))
      return e(n, r);
    for (var i = n.length, o = t ? i : -1, a = Object(n); (t ? o-- : ++o < i) && r(a[o], o, a) !== !1; )
      ;
    return n;
  };
}
var PBe = OBe, MBe = RBe, kBe = PBe, NBe = kBe(MBe), vM = NBe, DBe = vM, LBe = Wu;
function jBe(e, t) {
  var n = -1, r = LBe(e) ? Array(e.length) : [];
  return DBe(e, function(i, o, a) {
    r[++n] = t(i, o, a);
  }), r;
}
var FBe = jBe;
function VBe(e, t) {
  var n = e.length;
  for (e.sort(t); n--; )
    e[n] = e[n].value;
  return e;
}
var BBe = VBe, oF = py;
function zBe(e, t) {
  if (e !== t) {
    var n = e !== void 0, r = e === null, i = e === e, o = oF(e), a = t !== void 0, s = t === null, c = t === t, l = oF(t);
    if (!s && !l && !o && e > t || o && a && c && !s && !l || r && a && c || !n && c || !i)
      return 1;
    if (!r && !o && !l && e < t || l && n && i && !r && !o || s && n && i || !a && i || !c)
      return -1;
  }
  return 0;
}
var HBe = zBe, UBe = HBe;
function WBe(e, t, n) {
  for (var r = -1, i = e.criteria, o = t.criteria, a = i.length, s = n.length; ++r < a; ) {
    var c = UBe(i[r], o[r]);
    if (c) {
      if (r >= s)
        return c;
      var l = n[r];
      return c * (l == "desc" ? -1 : 1);
    }
  }
  return e.index - t.index;
}
var qBe = WBe, aT = gy, GBe = my, KBe = Lp, YBe = FBe, XBe = BBe, QBe = Mp, JBe = qBe, ZBe = Sy, eze = Gi;
function tze(e, t, n) {
  t.length ? t = aT(t, function(o) {
    return eze(o) ? function(a) {
      return GBe(a, o.length === 1 ? o[0] : o);
    } : o;
  }) : t = [ZBe];
  var r = -1;
  t = aT(t, QBe(KBe));
  var i = YBe(e, function(o, a, s) {
    var c = aT(t, function(l) {
      return l(o);
    });
    return { criteria: c, index: ++r, value: o };
  });
  return XBe(i, function(o, a) {
    return JBe(o, a, n);
  });
}
var kZ = tze, nze = kZ, aF = Gi;
function rze(e, t, n, r) {
  return e == null ? [] : (aF(t) || (t = t == null ? [] : [t]), n = r ? void 0 : n, aF(n) || (n = n == null ? [] : [n]), nze(e, t, n));
}
var ize = rze;
const wy = /* @__PURE__ */ pn(ize);
function TE(e, t, n) {
  e.prototype = t.prototype = n, n.constructor = e;
}
function yM(e, t) {
  var n = Object.create(e.prototype);
  for (var r in t)
    n[r] = t[r];
  return n;
}
function jp() {
}
var df = 0.7, Fg = 1 / df, Zh = "\\s*([+-]?\\d+)\\s*", pv = "\\s*([+-]?(?:\\d*\\.)?\\d+(?:[eE][+-]?\\d+)?)\\s*", lc = "\\s*([+-]?(?:\\d*\\.)?\\d+(?:[eE][+-]?\\d+)?)%\\s*", oze = /^#([0-9a-f]{3,8})$/, aze = new RegExp(`^rgb\\(${Zh},${Zh},${Zh}\\)$`), sze = new RegExp(`^rgb\\(${lc},${lc},${lc}\\)$`), cze = new RegExp(`^rgba\\(${Zh},${Zh},${Zh},${pv}\\)$`), lze = new RegExp(`^rgba\\(${lc},${lc},${lc},${pv}\\)$`), uze = new RegExp(`^hsl\\(${pv},${lc},${lc}\\)$`), dze = new RegExp(`^hsla\\(${pv},${lc},${lc},${pv}\\)$`), sF = {
  aliceblue: 15792383,
  antiquewhite: 16444375,
  aqua: 65535,
  aquamarine: 8388564,
  azure: 15794175,
  beige: 16119260,
  bisque: 16770244,
  black: 0,
  blanchedalmond: 16772045,
  blue: 255,
  blueviolet: 9055202,
  brown: 10824234,
  burlywood: 14596231,
  cadetblue: 6266528,
  chartreuse: 8388352,
  chocolate: 13789470,
  coral: 16744272,
  cornflowerblue: 6591981,
  cornsilk: 16775388,
  crimson: 14423100,
  cyan: 65535,
  darkblue: 139,
  darkcyan: 35723,
  darkgoldenrod: 12092939,
  darkgray: 11119017,
  darkgreen: 25600,
  darkgrey: 11119017,
  darkkhaki: 12433259,
  darkmagenta: 9109643,
  darkolivegreen: 5597999,
  darkorange: 16747520,
  darkorchid: 10040012,
  darkred: 9109504,
  darksalmon: 15308410,
  darkseagreen: 9419919,
  darkslateblue: 4734347,
  darkslategray: 3100495,
  darkslategrey: 3100495,
  darkturquoise: 52945,
  darkviolet: 9699539,
  deeppink: 16716947,
  deepskyblue: 49151,
  dimgray: 6908265,
  dimgrey: 6908265,
  dodgerblue: 2003199,
  firebrick: 11674146,
  floralwhite: 16775920,
  forestgreen: 2263842,
  fuchsia: 16711935,
  gainsboro: 14474460,
  ghostwhite: 16316671,
  gold: 16766720,
  goldenrod: 14329120,
  gray: 8421504,
  green: 32768,
  greenyellow: 11403055,
  grey: 8421504,
  honeydew: 15794160,
  hotpink: 16738740,
  indianred: 13458524,
  indigo: 4915330,
  ivory: 16777200,
  khaki: 15787660,
  lavender: 15132410,
  lavenderblush: 16773365,
  lawngreen: 8190976,
  lemonchiffon: 16775885,
  lightblue: 11393254,
  lightcoral: 15761536,
  lightcyan: 14745599,
  lightgoldenrodyellow: 16448210,
  lightgray: 13882323,
  lightgreen: 9498256,
  lightgrey: 13882323,
  lightpink: 16758465,
  lightsalmon: 16752762,
  lightseagreen: 2142890,
  lightskyblue: 8900346,
  lightslategray: 7833753,
  lightslategrey: 7833753,
  lightsteelblue: 11584734,
  lightyellow: 16777184,
  lime: 65280,
  limegreen: 3329330,
  linen: 16445670,
  magenta: 16711935,
  maroon: 8388608,
  mediumaquamarine: 6737322,
  mediumblue: 205,
  mediumorchid: 12211667,
  mediumpurple: 9662683,
  mediumseagreen: 3978097,
  mediumslateblue: 8087790,
  mediumspringgreen: 64154,
  mediumturquoise: 4772300,
  mediumvioletred: 13047173,
  midnightblue: 1644912,
  mintcream: 16121850,
  mistyrose: 16770273,
  moccasin: 16770229,
  navajowhite: 16768685,
  navy: 128,
  oldlace: 16643558,
  olive: 8421376,
  olivedrab: 7048739,
  orange: 16753920,
  orangered: 16729344,
  orchid: 14315734,
  palegoldenrod: 15657130,
  palegreen: 10025880,
  paleturquoise: 11529966,
  palevioletred: 14381203,
  papayawhip: 16773077,
  peachpuff: 16767673,
  peru: 13468991,
  pink: 16761035,
  plum: 14524637,
  powderblue: 11591910,
  purple: 8388736,
  rebeccapurple: 6697881,
  red: 16711680,
  rosybrown: 12357519,
  royalblue: 4286945,
  saddlebrown: 9127187,
  salmon: 16416882,
  sandybrown: 16032864,
  seagreen: 3050327,
  seashell: 16774638,
  sienna: 10506797,
  silver: 12632256,
  skyblue: 8900331,
  slateblue: 6970061,
  slategray: 7372944,
  slategrey: 7372944,
  snow: 16775930,
  springgreen: 65407,
  steelblue: 4620980,
  tan: 13808780,
  teal: 32896,
  thistle: 14204888,
  tomato: 16737095,
  turquoise: 4251856,
  violet: 15631086,
  wheat: 16113331,
  white: 16777215,
  whitesmoke: 16119285,
  yellow: 16776960,
  yellowgreen: 10145074
};
TE(jp, mv, {
  copy(e) {
    return Object.assign(new this.constructor(), this, e);
  },
  displayable() {
    return this.rgb().displayable();
  },
  hex: cF,
  // Deprecated! Use color.formatHex.
  formatHex: cF,
  formatHex8: fze,
  formatHsl: hze,
  formatRgb: lF,
  toString: lF
});
function cF() {
  return this.rgb().formatHex();
}
function fze() {
  return this.rgb().formatHex8();
}
function hze() {
  return DZ(this).formatHsl();
}
function lF() {
  return this.rgb().formatRgb();
}
function mv(e) {
  var t, n;
  return e = (e + "").trim().toLowerCase(), (t = oze.exec(e)) ? (n = t[1].length, t = parseInt(t[1], 16), n === 6 ? uF(t) : n === 3 ? new oo(t >> 8 & 15 | t >> 4 & 240, t >> 4 & 15 | t & 240, (t & 15) << 4 | t & 15, 1) : n === 8 ? Jb(t >> 24 & 255, t >> 16 & 255, t >> 8 & 255, (t & 255) / 255) : n === 4 ? Jb(t >> 12 & 15 | t >> 8 & 240, t >> 8 & 15 | t >> 4 & 240, t >> 4 & 15 | t & 240, ((t & 15) << 4 | t & 15) / 255) : null) : (t = aze.exec(e)) ? new oo(t[1], t[2], t[3], 1) : (t = sze.exec(e)) ? new oo(t[1] * 255 / 100, t[2] * 255 / 100, t[3] * 255 / 100, 1) : (t = cze.exec(e)) ? Jb(t[1], t[2], t[3], t[4]) : (t = lze.exec(e)) ? Jb(t[1] * 255 / 100, t[2] * 255 / 100, t[3] * 255 / 100, t[4]) : (t = uze.exec(e)) ? hF(t[1], t[2] / 100, t[3] / 100, 1) : (t = dze.exec(e)) ? hF(t[1], t[2] / 100, t[3] / 100, t[4]) : sF.hasOwnProperty(e) ? uF(sF[e]) : e === "transparent" ? new oo(NaN, NaN, NaN, 0) : null;
}
function uF(e) {
  return new oo(e >> 16 & 255, e >> 8 & 255, e & 255, 1);
}
function Jb(e, t, n, r) {
  return r <= 0 && (e = t = n = NaN), new oo(e, t, n, r);
}
function NZ(e) {
  return e instanceof jp || (e = mv(e)), e ? (e = e.rgb(), new oo(e.r, e.g, e.b, e.opacity)) : new oo();
}
function Vg(e, t, n, r) {
  return arguments.length === 1 ? NZ(e) : new oo(e, t, n, r ?? 1);
}
function oo(e, t, n, r) {
  this.r = +e, this.g = +t, this.b = +n, this.opacity = +r;
}
TE(oo, Vg, yM(jp, {
  brighter(e) {
    return e = e == null ? Fg : Math.pow(Fg, e), new oo(this.r * e, this.g * e, this.b * e, this.opacity);
  },
  darker(e) {
    return e = e == null ? df : Math.pow(df, e), new oo(this.r * e, this.g * e, this.b * e, this.opacity);
  },
  rgb() {
    return this;
  },
  clamp() {
    return new oo(Vd(this.r), Vd(this.g), Vd(this.b), HS(this.opacity));
  },
  displayable() {
    return -0.5 <= this.r && this.r < 255.5 && -0.5 <= this.g && this.g < 255.5 && -0.5 <= this.b && this.b < 255.5 && 0 <= this.opacity && this.opacity <= 1;
  },
  hex: dF,
  // Deprecated! Use color.formatHex.
  formatHex: dF,
  formatHex8: gze,
  formatRgb: fF,
  toString: fF
}));
function dF() {
  return `#${Td(this.r)}${Td(this.g)}${Td(this.b)}`;
}
function gze() {
  return `#${Td(this.r)}${Td(this.g)}${Td(this.b)}${Td((isNaN(this.opacity) ? 1 : this.opacity) * 255)}`;
}
function fF() {
  const e = HS(this.opacity);
  return `${e === 1 ? "rgb(" : "rgba("}${Vd(this.r)}, ${Vd(this.g)}, ${Vd(this.b)}${e === 1 ? ")" : `, ${e})`}`;
}
function HS(e) {
  return isNaN(e) ? 1 : Math.max(0, Math.min(1, e));
}
function Vd(e) {
  return Math.max(0, Math.min(255, Math.round(e) || 0));
}
function Td(e) {
  return e = Vd(e), (e < 16 ? "0" : "") + e.toString(16);
}
function hF(e, t, n, r) {
  return r <= 0 ? e = t = n = NaN : n <= 0 || n >= 1 ? e = t = NaN : t <= 0 && (e = NaN), new cs(e, t, n, r);
}
function DZ(e) {
  if (e instanceof cs)
    return new cs(e.h, e.s, e.l, e.opacity);
  if (e instanceof jp || (e = mv(e)), !e)
    return new cs();
  if (e instanceof cs)
    return e;
  e = e.rgb();
  var t = e.r / 255, n = e.g / 255, r = e.b / 255, i = Math.min(t, n, r), o = Math.max(t, n, r), a = NaN, s = o - i, c = (o + i) / 2;
  return s ? (t === o ? a = (n - r) / s + (n < r) * 6 : n === o ? a = (r - t) / s + 2 : a = (t - n) / s + 4, s /= c < 0.5 ? o + i : 2 - o - i, a *= 60) : s = c > 0 && c < 1 ? 0 : a, new cs(a, s, c, e.opacity);
}
function pze(e, t, n, r) {
  return arguments.length === 1 ? DZ(e) : new cs(e, t, n, r ?? 1);
}
function cs(e, t, n, r) {
  this.h = +e, this.s = +t, this.l = +n, this.opacity = +r;
}
TE(cs, pze, yM(jp, {
  brighter(e) {
    return e = e == null ? Fg : Math.pow(Fg, e), new cs(this.h, this.s, this.l * e, this.opacity);
  },
  darker(e) {
    return e = e == null ? df : Math.pow(df, e), new cs(this.h, this.s, this.l * e, this.opacity);
  },
  rgb() {
    var e = this.h % 360 + (this.h < 0) * 360, t = isNaN(e) || isNaN(this.s) ? 0 : this.s, n = this.l, r = n + (n < 0.5 ? n : 1 - n) * t, i = 2 * n - r;
    return new oo(
      sT(e >= 240 ? e - 240 : e + 120, i, r),
      sT(e, i, r),
      sT(e < 120 ? e + 240 : e - 120, i, r),
      this.opacity
    );
  },
  clamp() {
    return new cs(gF(this.h), Zb(this.s), Zb(this.l), HS(this.opacity));
  },
  displayable() {
    return (0 <= this.s && this.s <= 1 || isNaN(this.s)) && 0 <= this.l && this.l <= 1 && 0 <= this.opacity && this.opacity <= 1;
  },
  formatHsl() {
    const e = HS(this.opacity);
    return `${e === 1 ? "hsl(" : "hsla("}${gF(this.h)}, ${Zb(this.s) * 100}%, ${Zb(this.l) * 100}%${e === 1 ? ")" : `, ${e})`}`;
  }
}));
function gF(e) {
  return e = (e || 0) % 360, e < 0 ? e + 360 : e;
}
function Zb(e) {
  return Math.max(0, Math.min(1, e || 0));
}
function sT(e, t, n) {
  return (e < 60 ? t + (n - t) * e / 60 : e < 180 ? n : e < 240 ? t + (n - t) * (240 - e) / 60 : t) * 255;
}
const mze = Math.PI / 180, vze = 180 / Math.PI;
var LZ = -0.14861, bM = 1.78277, _M = -0.29227, IE = -0.90649, vv = 1.97294, pF = vv * IE, mF = vv * bM, vF = bM * _M - IE * LZ;
function yze(e) {
  if (e instanceof Bd)
    return new Bd(e.h, e.s, e.l, e.opacity);
  e instanceof oo || (e = NZ(e));
  var t = e.r / 255, n = e.g / 255, r = e.b / 255, i = (vF * r + pF * t - mF * n) / (vF + pF - mF), o = r - i, a = (vv * (n - i) - _M * o) / IE, s = Math.sqrt(a * a + o * o) / (vv * i * (1 - i)), c = s ? Math.atan2(a, o) * vze - 120 : NaN;
  return new Bd(c < 0 ? c + 360 : c, s, i, e.opacity);
}
function pc(e, t, n, r) {
  return arguments.length === 1 ? yze(e) : new Bd(e, t, n, r ?? 1);
}
function Bd(e, t, n, r) {
  this.h = +e, this.s = +t, this.l = +n, this.opacity = +r;
}
TE(Bd, pc, yM(jp, {
  brighter(e) {
    return e = e == null ? Fg : Math.pow(Fg, e), new Bd(this.h, this.s, this.l * e, this.opacity);
  },
  darker(e) {
    return e = e == null ? df : Math.pow(df, e), new Bd(this.h, this.s, this.l * e, this.opacity);
  },
  rgb() {
    var e = isNaN(this.h) ? 0 : (this.h + 120) * mze, t = +this.l, n = isNaN(this.s) ? 0 : this.s * t * (1 - t), r = Math.cos(e), i = Math.sin(e);
    return new oo(
      255 * (t + n * (LZ * r + bM * i)),
      255 * (t + n * (_M * r + IE * i)),
      255 * (t + n * (vv * r)),
      this.opacity
    );
  }
}));
function bze(e, t, n, r, i) {
  var o = e * e, a = o * e;
  return ((1 - 3 * e + 3 * o - a) * t + (4 - 6 * o + 3 * a) * n + (1 + 3 * e + 3 * o - 3 * a) * r + a * i) / 6;
}
function _ze(e) {
  var t = e.length - 1;
  return function(n) {
    var r = n <= 0 ? n = 0 : n >= 1 ? (n = 1, t - 1) : Math.floor(n * t), i = e[r], o = e[r + 1], a = r > 0 ? e[r - 1] : 2 * i - o, s = r < t - 1 ? e[r + 2] : 2 * o - i;
    return bze((n - r / t) * t, a, i, o, s);
  };
}
const AE = (e) => () => e;
function jZ(e, t) {
  return function(n) {
    return e + n * t;
  };
}
function Sze(e, t, n) {
  return e = Math.pow(e, n), t = Math.pow(t, n) - e, n = 1 / n, function(r) {
    return Math.pow(e + r * t, n);
  };
}
function wze(e, t) {
  var n = t - e;
  return n ? jZ(e, n > 180 || n < -180 ? n - 360 * Math.round(n / 360) : n) : AE(isNaN(e) ? t : e);
}
function xze(e) {
  return (e = +e) == 1 ? eg : function(t, n) {
    return n - t ? Sze(t, n, e) : AE(isNaN(t) ? n : t);
  };
}
function eg(e, t) {
  var n = t - e;
  return n ? jZ(e, n) : AE(isNaN(e) ? t : e);
}
const yF = function e(t) {
  var n = xze(t);
  function r(i, o) {
    var a = n((i = Vg(i)).r, (o = Vg(o)).r), s = n(i.g, o.g), c = n(i.b, o.b), l = eg(i.opacity, o.opacity);
    return function(u) {
      return i.r = a(u), i.g = s(u), i.b = c(u), i.opacity = l(u), i + "";
    };
  }
  return r.gamma = e, r;
}(1);
function Eze(e) {
  return function(t) {
    var n = t.length, r = new Array(n), i = new Array(n), o = new Array(n), a, s;
    for (a = 0; a < n; ++a)
      s = Vg(t[a]), r[a] = s.r || 0, i[a] = s.g || 0, o[a] = s.b || 0;
    return r = e(r), i = e(i), o = e(o), s.opacity = 1, function(c) {
      return s.r = r(c), s.g = i(c), s.b = o(c), s + "";
    };
  };
}
var Cze = Eze(_ze);
function Tze(e, t) {
  t || (t = []);
  var n = e ? Math.min(t.length, e.length) : 0, r = t.slice(), i;
  return function(o) {
    for (i = 0; i < n; ++i)
      r[i] = e[i] * (1 - o) + t[i] * o;
    return r;
  };
}
function Ize(e) {
  return ArrayBuffer.isView(e) && !(e instanceof DataView);
}
function Aze(e, t) {
  var n = t ? t.length : 0, r = e ? Math.min(n, e.length) : 0, i = new Array(r), o = new Array(n), a;
  for (a = 0; a < r; ++a)
    i[a] = wc(e[a], t[a]);
  for (; a < n; ++a)
    o[a] = t[a];
  return function(s) {
    for (a = 0; a < r; ++a)
      o[a] = i[a](s);
    return o;
  };
}
function Rze(e, t) {
  var n = /* @__PURE__ */ new Date();
  return e = +e, t = +t, function(r) {
    return n.setTime(e * (1 - r) + t * r), n;
  };
}
function US(e, t) {
  return e = +e, t = +t, function(n) {
    return e * (1 - n) + t * n;
  };
}
function $ze(e, t) {
  var n = {}, r = {}, i;
  (e === null || typeof e != "object") && (e = {}), (t === null || typeof t != "object") && (t = {});
  for (i in t)
    i in e ? n[i] = wc(e[i], t[i]) : r[i] = t[i];
  return function(o) {
    for (i in n)
      r[i] = n[i](o);
    return r;
  };
}
var $R = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g, cT = new RegExp($R.source, "g");
function Oze(e) {
  return function() {
    return e;
  };
}
function Pze(e) {
  return function(t) {
    return e(t) + "";
  };
}
function FZ(e, t) {
  var n = $R.lastIndex = cT.lastIndex = 0, r, i, o, a = -1, s = [], c = [];
  for (e = e + "", t = t + ""; (r = $R.exec(e)) && (i = cT.exec(t)); )
    (o = i.index) > n && (o = t.slice(n, o), s[a] ? s[a] += o : s[++a] = o), (r = r[0]) === (i = i[0]) ? s[a] ? s[a] += i : s[++a] = i : (s[++a] = null, c.push({ i: a, x: US(r, i) })), n = cT.lastIndex;
  return n < t.length && (o = t.slice(n), s[a] ? s[a] += o : s[++a] = o), s.length < 2 ? c[0] ? Pze(c[0].x) : Oze(t) : (t = c.length, function(l) {
    for (var u = 0, d; u < t; ++u)
      s[(d = c[u]).i] = d.x(l);
    return s.join("");
  });
}
function wc(e, t) {
  var n = typeof t, r;
  return t == null || n === "boolean" ? AE(t) : (n === "number" ? US : n === "string" ? (r = mv(t)) ? (t = r, yF) : FZ : t instanceof mv ? yF : t instanceof Date ? Rze : Ize(t) ? Tze : Array.isArray(t) ? Aze : typeof t.valueOf != "function" && typeof t.toString != "function" || isNaN(t) ? $ze : US)(e, t);
}
function SM(e, t) {
  return e = +e, t = +t, function(n) {
    return Math.round(e * (1 - n) + t * n);
  };
}
function VZ(e) {
  return function t(n) {
    n = +n;
    function r(i, o) {
      var a = e((i = pc(i)).h, (o = pc(o)).h), s = eg(i.s, o.s), c = eg(i.l, o.l), l = eg(i.opacity, o.opacity);
      return function(u) {
        return i.h = a(u), i.s = s(u), i.l = c(Math.pow(u, n)), i.opacity = l(u), i + "";
      };
    }
    return r.gamma = t, r;
  }(1);
}
VZ(wze);
var wM = VZ(eg);
function Mze(e, t) {
  t === void 0 && (t = e, e = wc);
  for (var n = 0, r = t.length - 1, i = t[0], o = new Array(r < 0 ? 0 : r); n < r; )
    o[n] = e(i, i = t[++n]);
  return function(a) {
    var s = Math.max(0, Math.min(r - 1, Math.floor(a *= r)));
    return o[s](a - s);
  };
}
const WS = function(e) {
  if (e !== null)
    switch (typeof e) {
      case "undefined":
        return !1;
      case "number":
        return !isNaN(e) && e !== Number.POSITIVE_INFINITY && e !== Number.NEGATIVE_INFINITY;
      case "string":
        return !0;
      case "boolean":
        return !1;
      case "object":
        return e instanceof Date || Array.isArray(e) || ti(e);
      case "function":
        return !0;
    }
  return !1;
}, BZ = function(e, t, n) {
  return n === void 0 && (n = 0), function(r) {
    return r < n ? e : t;
  };
}, zZ = function(e, t) {
  return function(n) {
    return n >= 1 ? t : function() {
      const r = typeof e == "function" ? e.apply(this, arguments) : e, i = typeof t == "function" ? t.apply(this, arguments) : t;
      return wc(r, i)(n);
    };
  };
}, HZ = function(e, t) {
  const n = (l, u) => l === u || !WS(l) || !WS(u) ? BZ(l, u) : typeof l == "function" || typeof u == "function" ? zZ(l, u) : typeof l == "object" && ti(l) || typeof u == "object" && ti(u) ? HZ(l, u) : wc(l, u), r = (l) => Array.isArray(l) ? wy(l, "key") : l, i = {}, o = {};
  let a = e, s = t, c;
  (a === null || typeof a != "object") && (a = {}), (s === null || typeof s != "object") && (s = {});
  for (c in s)
    c in a ? i[c] = n(r(a[c]), r(s[c])) : o[c] = s[c];
  return function(l) {
    for (c in i)
      o[c] = i[c](l);
    return o;
  };
}, kze = function(e, t) {
  const n = (r) => typeof r == "string" ? r.replace(/,/g, "") : r;
  return wc(n(e), n(t));
}, Nze = function(e, t) {
  return e === t || !WS(e) || !WS(t) ? BZ(e, t) : typeof e == "function" || typeof t == "function" ? zZ(e, t) : ti(e) || ti(t) ? HZ(e, t) : typeof e == "string" || typeof t == "string" ? kze(e, t) : wc(e, t);
};
var Bg = 0, Um = 0, mm = 0, UZ = 1e3, qS, Wm, GS = 0, ff = 0, RE = 0, yv = typeof performance == "object" && performance.now ? performance : Date, WZ = typeof window == "object" && window.requestAnimationFrame ? window.requestAnimationFrame.bind(window) : function(e) {
  setTimeout(e, 17);
};
function KS() {
  return ff || (WZ(Dze), ff = yv.now() + RE);
}
function Dze() {
  ff = 0;
}
function OR() {
  this._call = this._time = this._next = null;
}
OR.prototype = qZ.prototype = {
  constructor: OR,
  restart: function(e, t, n) {
    if (typeof e != "function")
      throw new TypeError("callback is not a function");
    n = (n == null ? KS() : +n) + (t == null ? 0 : +t), !this._next && Wm !== this && (Wm ? Wm._next = this : qS = this, Wm = this), this._call = e, this._time = n, PR();
  },
  stop: function() {
    this._call && (this._call = null, this._time = 1 / 0, PR());
  }
};
function qZ(e, t, n) {
  var r = new OR();
  return r.restart(e, t, n), r;
}
function Lze() {
  KS(), ++Bg;
  for (var e = qS, t; e; )
    (t = ff - e._time) >= 0 && e._call.call(void 0, t), e = e._next;
  --Bg;
}
function bF() {
  ff = (GS = yv.now()) + RE, Bg = Um = 0;
  try {
    Lze();
  } finally {
    Bg = 0, Fze(), ff = 0;
  }
}
function jze() {
  var e = yv.now(), t = e - GS;
  t > UZ && (RE -= t, GS = e);
}
function Fze() {
  for (var e, t = qS, n, r = 1 / 0; t; )
    t._call ? (r > t._time && (r = t._time), e = t, t = t._next) : (n = t._next, t._next = null, t = e ? e._next = n : qS = n);
  Wm = e, PR(r);
}
function PR(e) {
  if (!Bg) {
    Um && (Um = clearTimeout(Um));
    var t = e - ff;
    t > 24 ? (e < 1 / 0 && (Um = setTimeout(bF, e - yv.now() - RE)), mm && (mm = clearInterval(mm))) : (mm || (GS = yv.now(), mm = setInterval(jze, UZ)), Bg = 1, WZ(bF));
  }
}
let _F = class {
  constructor() {
    ye(this, "loop", () => {
      this.subscribers.forEach((t) => {
        t.callback(KS() - t.startTime, t.duration);
      });
    });
    this.shouldAnimate = !0, this.subscribers = [], this.timer = null, this.activeSubscriptions = 0;
  }
  bypassAnimation() {
    this.shouldAnimate = !1;
  }
  resumeAnimation() {
    this.shouldAnimate = !0;
  }
  start() {
    this.timer || (this.timer = qZ(this.loop));
  }
  stop() {
    this.timer && (this.timer.stop(), this.timer = null);
  }
  subscribe(t, n) {
    const r = this.subscribers.push({
      startTime: KS(),
      callback: t,
      duration: this.shouldAnimate ? n : 0
    });
    return this.activeSubscriptions++, this.start(), r;
  }
  unsubscribe(t) {
    t !== null && this.subscribers[t - 1] && (delete this.subscribers[t - 1], this.activeSubscriptions--), this.activeSubscriptions === 0 && this.stop();
  }
};
const GZ = /* @__PURE__ */ D.createContext({
  transitionTimer: new _F(),
  animationTimer: new _F()
});
GZ.displayName = "TimerContext";
const xM = GZ, Vze = (e) => `ease${e.charAt(0).toUpperCase() + e.slice(1)}`, Bze = 1e3, zze = (e) => {
  let {
    duration: t = Bze,
    easing: n = "quadInOut",
    delay: r = 0,
    data: i,
    children: o,
    onEnd: a
  } = e;
  const [s, c] = D.useState({
    data: Array.isArray(i) ? i[0] : i,
    animationInfo: {
      progress: 0,
      animating: !1
    }
  }), l = D.useContext(xM).animationTimer, u = D.useRef(Array.isArray(i) ? i.slice(1) : []), d = D.useRef(null), f = D.useRef(void 0), h = y7e[Vze(n)];
  D.useEffect(() => (u.current.length && p(), () => {
    f.current ? l.unsubscribe(f.current) : l.stop();
  }), []), D.useEffect(() => {
    d.current && s.animationInfo && s.animationInfo.progress < 1 ? c({
      data: d.current(1),
      animationInfo: {
        progress: 1,
        animating: !1,
        terminating: !0
      }
    }) : (l.unsubscribe(f.current), u.current = Array.isArray(i) ? i : [i], p());
  }, [i]);
  const p = () => {
    if (u.current.length) {
      const m = u.current[0];
      d.current = Nze(s.data, m), r ? setTimeout(() => {
        f.current = l.subscribe(g, t);
      }, r) : f.current = l.subscribe(g, t);
    } else
      a && a();
  }, g = (m) => {
    if (!d.current)
      return;
    const v = t ? m / t : 1;
    if (v >= 1) {
      c({
        data: d.current(1),
        animationInfo: {
          progress: 1,
          animating: !1,
          terminating: !0
        }
      }), f.current && l.unsubscribe(f.current), u.current.shift(), p();
      return;
    }
    c({
      data: d.current(h(v)),
      animationInfo: {
        progress: v,
        animating: v < 1
      }
    });
  };
  return o(s.data, s.animationInfo);
};
var Hze = gZ, Uze = 0;
function Wze(e) {
  var t = ++Uze;
  return Hze(e) + t;
}
var qze = Wze;
const $E = /* @__PURE__ */ pn(qze);
function MR() {
  return MR = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, MR.apply(this, arguments);
}
const Gze = /* @__PURE__ */ D.forwardRef((e, t) => /* @__PURE__ */ D.createElement("svg", MR({
  ref: t
}, e)));
function Kze(e, t, n) {
  switch (n.length) {
    case 0:
      return e.call(t);
    case 1:
      return e.call(t, n[0]);
    case 2:
      return e.call(t, n[0], n[1]);
    case 3:
      return e.call(t, n[0], n[1], n[2]);
  }
  return e.apply(t, n);
}
var Yze = Kze, Xze = Yze, SF = Math.max;
function Qze(e, t, n) {
  return t = SF(t === void 0 ? e.length - 1 : t, 0), function() {
    for (var r = arguments, i = -1, o = SF(r.length - t, 0), a = Array(o); ++i < o; )
      a[i] = r[t + i];
    i = -1;
    for (var s = Array(t + 1); ++i < t; )
      s[i] = r[i];
    return s[t] = n(a), Xze(e, this, s);
  };
}
var KZ = Qze;
function Jze(e) {
  return function() {
    return e;
  };
}
var Zze = Jze, eHe = Nf, tHe = function() {
  try {
    var e = eHe(Object, "defineProperty");
    return e({}, "", {}), e;
  } catch {
  }
}(), YZ = tHe, nHe = Zze, wF = YZ, rHe = Sy, iHe = wF ? function(e, t) {
  return wF(e, "toString", {
    configurable: !0,
    enumerable: !1,
    value: nHe(t),
    writable: !0
  });
} : rHe, oHe = iHe, aHe = 800, sHe = 16, cHe = Date.now;
function lHe(e) {
  var t = 0, n = 0;
  return function() {
    var r = cHe(), i = sHe - (r - n);
    if (n = r, i > 0) {
      if (++t >= aHe)
        return arguments[0];
    } else
      t = 0;
    return e.apply(void 0, arguments);
  };
}
var uHe = lHe, dHe = oHe, fHe = uHe, hHe = fHe(dHe), XZ = hHe, gHe = Sy, pHe = KZ, mHe = XZ;
function vHe(e, t) {
  return mHe(pHe(e, t, gHe), e + "");
}
var OE = vHe, yHe = Df, bHe = Wu, _He = xE, SHe = Ka;
function wHe(e, t, n) {
  if (!SHe(n))
    return !1;
  var r = typeof t;
  return (r == "number" ? bHe(n) && _He(t, n.length) : r == "string" && t in n) ? yHe(n[t], e) : !1;
}
var PE = wHe;
function xHe(e) {
  var t = [];
  if (e != null)
    for (var n in Object(e))
      t.push(n);
  return t;
}
var EHe = xHe, CHe = Ka, THe = by, IHe = EHe, AHe = Object.prototype, RHe = AHe.hasOwnProperty;
function $He(e) {
  if (!CHe(e))
    return IHe(e);
  var t = THe(e), n = [];
  for (var r in e)
    r == "constructor" && (t || !RHe.call(e, r)) || n.push(r);
  return n;
}
var OHe = $He, PHe = SZ, MHe = OHe, kHe = Wu;
function NHe(e) {
  return kHe(e) ? PHe(e, !0) : MHe(e);
}
var Fp = NHe, DHe = OE, LHe = Df, jHe = PE, FHe = Fp, QZ = Object.prototype, VHe = QZ.hasOwnProperty, BHe = DHe(function(e, t) {
  e = Object(e);
  var n = -1, r = t.length, i = r > 2 ? t[2] : void 0;
  for (i && jHe(t[0], t[1], i) && (r = 1); ++n < r; )
    for (var o = t[n], a = FHe(o), s = -1, c = a.length; ++s < c; ) {
      var l = a[s], u = e[l];
      (u === void 0 || LHe(u, QZ[l]) && !VHe.call(e, l)) && (e[l] = o[l]);
    }
  return e;
}), zHe = BHe;
const He = /* @__PURE__ */ pn(zHe);
var xF = YZ;
function HHe(e, t, n) {
  t == "__proto__" && xF ? xF(e, t, {
    configurable: !0,
    enumerable: !0,
    value: n,
    writable: !0
  }) : e[t] = n;
}
var ME = HHe, UHe = ME, WHe = Df, qHe = Object.prototype, GHe = qHe.hasOwnProperty;
function KHe(e, t, n) {
  var r = e[t];
  (!(GHe.call(e, t) && WHe(r, n)) || n === void 0 && !(t in e)) && UHe(e, t, n);
}
var kE = KHe, YHe = kE, XHe = $p, QHe = xE, EF = Ka, JHe = Op;
function ZHe(e, t, n, r) {
  if (!EF(e))
    return e;
  t = XHe(t, e);
  for (var i = -1, o = t.length, a = o - 1, s = e; s != null && ++i < o; ) {
    var c = JHe(t[i]), l = n;
    if (c === "__proto__" || c === "constructor" || c === "prototype")
      return e;
    if (i != a) {
      var u = s[c];
      l = r ? r(u, c, s) : void 0, l === void 0 && (l = EF(u) ? u : QHe(t[i + 1]) ? [] : {});
    }
    YHe(s, c, l), s = s[c];
  }
  return e;
}
var JZ = ZHe, eUe = my, tUe = JZ, nUe = $p;
function rUe(e, t, n) {
  for (var r = -1, i = t.length, o = {}; ++r < i; ) {
    var a = t[r], s = eUe(e, a);
    n(s, a) && tUe(o, nUe(a, e), s);
  }
  return o;
}
var ZZ = rUe, iUe = ZZ, oUe = $Z;
function aUe(e, t) {
  return iUe(e, t, function(n, r) {
    return oUe(e, r);
  });
}
var sUe = aUe, CF = Tp, cUe = vy, lUe = Gi, TF = CF ? CF.isConcatSpreadable : void 0;
function uUe(e) {
  return lUe(e) || cUe(e) || !!(TF && e && e[TF]);
}
var dUe = uUe, fUe = hM, hUe = dUe;
function eee(e, t, n, r, i) {
  var o = -1, a = e.length;
  for (n || (n = hUe), i || (i = []); ++o < a; ) {
    var s = e[o];
    t > 0 && n(s) ? t > 1 ? eee(s, t - 1, n, r, i) : fUe(i, s) : r || (i[i.length] = s);
  }
  return i;
}
var tee = eee, gUe = tee;
function pUe(e) {
  var t = e == null ? 0 : e.length;
  return t ? gUe(e, 1) : [];
}
var mUe = pUe, vUe = mUe, yUe = KZ, bUe = XZ;
function _Ue(e) {
  return bUe(yUe(e, void 0, vUe), e + "");
}
var nee = _Ue, SUe = sUe, wUe = nee, xUe = wUe(function(e, t) {
  return e == null ? {} : SUe(e, t);
}), EUe = xUe;
const YS = /* @__PURE__ */ pn(EUe);
function CUe(e) {
  return e.axis !== "x" ? [e.height - e.padding.bottom, e.padding.top] : [e.padding.left, e.width - e.padding.right];
}
function TUe(e) {
  if (e.axis === "x") {
    const t = fr(e.startAngle || 0), n = fr(e.endAngle || 360);
    return [t, n];
  }
  return [e.innerRadius || 0, kR({
    height: e.height,
    width: e.width,
    padding: e.padding
  })];
}
function ree(e) {
  return Object.entries(e).reduce((t, n) => (t[n[1]] = n[0], t), {});
}
function Lf(e, t) {
  t === void 0 && (t = []);
  const n = {};
  for (const r in e)
    t.indexOf(r) >= 0 || Object.prototype.hasOwnProperty.call(e, r) && (n[r] = e[r]);
  return n;
}
function iee(e) {
  const {
    _x: t,
    _x1: n,
    _x0: r,
    _voronoiX: i,
    _y: o,
    _y1: a,
    _y0: s,
    _voronoiY: c
  } = e;
  return He({}, {
    x: i ?? (n ?? t),
    x0: r ?? t,
    y: c ?? (a ?? o),
    y0: s ?? o
  }, e);
}
function xy(e, t) {
  const {
    scale: n,
    polar: r,
    horizontal: i
  } = e, o = iee(t), a = e.origin || {
    x: 0,
    y: 0
  }, s = i ? n.y(o.y) : n.x(o.x), c = i ? n.y(o.y0) : n.x(o.x0), l = i ? n.x(o.x) : n.y(o.y), u = i ? n.x(o.x0) : n.y(o.y0);
  return {
    x: r ? l * Math.cos(s) + a.x : s,
    x0: r ? u * Math.cos(c) + a.x : c,
    y: r ? -l * Math.sin(s) + a.y : l,
    y0: r ? -u * Math.sin(c) + a.x : u
  };
}
function Wi(e) {
  const t = typeof e == "number" ? e : 0, n = typeof e == "object" ? e : {};
  return {
    top: n.top || t,
    bottom: n.bottom || t,
    left: n.left || t,
    right: n.right || t
  };
}
function NE(e) {
  return (e && e.type && e.type.role) === "tooltip";
}
function Ey(e, t) {
  const {
    theme: n = {},
    labelComponent: r
  } = e, i = n[t] && n[t].style || {};
  if (!NE(r))
    return i;
  const o = n.tooltip && n.tooltip.style || {}, a = He({}, o, i.labels);
  return He({}, {
    labels: a
  }, i);
}
function Vp(e, t) {
  const n = "100%", r = "100%";
  if (!e)
    return He({
      parent: {
        height: r,
        width: n
      }
    }, t);
  const {
    data: i,
    labels: o,
    parent: a
  } = e, s = t && t.parent || {}, c = t && t.labels || {}, l = t && t.data || {};
  return {
    parent: He({}, a, s, {
      width: n,
      height: r
    }),
    labels: He({}, o, c),
    data: He({}, i, l)
  };
}
function De(e, t) {
  return Rn(e) ? e(t) : e;
}
function br(e, t) {
  return t.disableInlineStyles ? {} : !e || !Object.keys(e).some((n) => Rn(e[n])) ? e : Object.keys(e).reduce((n, r) => (n[r] = De(e[r], t), n), {});
}
function fr(e) {
  return typeof e == "number" ? e * (Math.PI / 180) : e;
}
function Qc(e) {
  return typeof e == "number" ? e / (Math.PI / 180) : e;
}
function kR(e) {
  const {
    width: t,
    height: n,
    padding: r
  } = e, {
    left: i,
    right: o,
    top: a,
    bottom: s
  } = r;
  return Math.min(t - i - o, n - a - s) / 2;
}
function jf(e) {
  const {
    width: t,
    height: n
  } = e, {
    top: r,
    bottom: i,
    left: o,
    right: a
  } = Wi(e.padding), s = Math.min(t - o - a, n - r - i) / 2, c = t / 2 + o - a, l = n / 2 + r - i;
  return {
    x: c + s > t ? s + o - a : c,
    y: l + s > n ? s + r - i : l
  };
}
function Pr(e, t) {
  return e.range && e.range[t] ? e.range[t] : e.range && Array.isArray(e.range) ? e.range : e.polar ? TUe({
    axis: t,
    innerRadius: e.innerRadius,
    startAngle: e.startAngle,
    endAngle: e.endAngle,
    height: e.height,
    width: e.width,
    padding: Wi(e.padding)
  }) : CUe({
    axis: t,
    height: e.height,
    width: e.width,
    padding: Wi(e.padding)
  });
}
function za(e) {
  return e == null;
}
function Rn(e) {
  return typeof e == "function";
}
function DE(e) {
  return Rn(e) ? e : e == null ? (t) => t : PZ(e);
}
function _r(e, t, n) {
  const r = e.theme && e.theme[n] ? e.theme[n] : {}, i = Lf(r, ["style"]), o = IUe(e);
  return He(o === void 0 ? {} : {
    horizontal: o
  }, e, i, t);
}
function oee(e, t) {
  return t ? e === "x" ? "y" : "x" : e;
}
function EM(e, t, n) {
  const r = t ? e : 0;
  let i = t || e;
  i || (i = 0);
  const o = i - r, a = Math.abs(o), s = o / a || 1, c = n || 1, l = Math.max(Math.ceil(a / c), 0);
  return Array.from(Array(l), (u, d) => r + d * s * c);
}
function Bp(e, t, n, r, i) {
  n === void 0 && (n = {}), r === void 0 && (r = []), i === void 0 && (i = (l, u) => (
    // @ts-expect-error These defaults are hard to type
    l.concat(u)
  ));
  const o = ["data", "domain", "categories", "polar", "startAngle", "endAngle", "minDomain", "maxDomain", "horizontal"], a = (l, u, d) => l.reduce((f, h, p) => {
    let g = f;
    const m = h.type && h.type.role, v = h.props.name || `${m}-${u[p]}`;
    if (h.props && h.props.children) {
      const y = Object.assign({}, h.props, YS(n, o)), S = h.type && h.type.role === "stack" && Rn(h.type.getChildren) ? h.type.getChildren(y) : D.Children.toArray(h.props.children).map((T) => {
        const x = Object.assign({}, T.props, YS(y, o));
        return /* @__PURE__ */ D.cloneElement(T, x);
      }), _ = S.map((T, x) => `${v}-${x}`), w = a(S, _, h);
      g = i(g, w);
    } else {
      const y = t(h, v, d);
      y && (g = i(g, y));
    }
    return g;
  }, r), s = e.filter(eO), c = s.map((l, u) => u);
  return a(s, c);
}
function IUe(e) {
  if (e.horizontal !== void 0 || !e.children)
    return e.horizontal;
  const t = (n) => n.reduce((r, i) => {
    const o = i.props || {};
    return r || o.horizontal || !o.children ? r || o.horizontal : t(D.Children.toArray(o.children));
  }, !1);
  return t(D.Children.toArray(e.children));
}
const aee = {
  startsWith: ["data-", "aria-"],
  exactMatch: []
}, AUe = (e) => {
  let t = !1;
  return aee.startsWith.forEach((n) => {
    new RegExp(`\\b(${n})(\\w|-)+`, "g").test(e) && (t = !0);
  }), t;
}, RUe = (e) => aee.exactMatch.includes(e), $Ue = (e) => !!(AUe(e) || RUe(e));
function e1(e, t) {
  if (e == null)
    throw new Error(t);
}
const Ya = (e) => {
  const t = {
    ...e
  };
  return Object.fromEntries(Object.entries(t).filter((n) => {
    let [r] = n;
    return $Ue(r);
  }).map((n) => {
    let [r, i] = n;
    return [r, De(i, e)];
  }));
}, Cy = (e, t) => /* @__PURE__ */ I.cloneElement(e, Ya(t));
var OUe = wZ, PUe = _y, MUe = vy, kUe = Gi, NUe = Wu, DUe = yy, LUe = by, jUe = CE, FUe = "[object Map]", VUe = "[object Set]", BUe = Object.prototype, zUe = BUe.hasOwnProperty;
function HUe(e) {
  if (e == null)
    return !0;
  if (NUe(e) && (kUe(e) || typeof e == "string" || typeof e.splice == "function" || DUe(e) || jUe(e) || MUe(e)))
    return !e.length;
  var t = PUe(e);
  if (t == FUe || t == VUe)
    return !e.size;
  if (LUe(e))
    return !OUe(e).length;
  for (var n in e)
    if (zUe.call(e, n))
      return !1;
  return !0;
}
var UUe = HUe;
const Lr = /* @__PURE__ */ pn(UUe);
var WUe = typeof Element < "u", qUe = typeof Map == "function", GUe = typeof Set == "function", KUe = typeof ArrayBuffer == "function" && !!ArrayBuffer.isView;
function K1(e, t) {
  if (e === t)
    return !0;
  if (e && t && typeof e == "object" && typeof t == "object") {
    if (e.constructor !== t.constructor)
      return !1;
    var n, r, i;
    if (Array.isArray(e)) {
      if (n = e.length, n != t.length)
        return !1;
      for (r = n; r-- !== 0; )
        if (!K1(e[r], t[r]))
          return !1;
      return !0;
    }
    var o;
    if (qUe && e instanceof Map && t instanceof Map) {
      if (e.size !== t.size)
        return !1;
      for (o = e.entries(); !(r = o.next()).done; )
        if (!t.has(r.value[0]))
          return !1;
      for (o = e.entries(); !(r = o.next()).done; )
        if (!K1(r.value[1], t.get(r.value[0])))
          return !1;
      return !0;
    }
    if (GUe && e instanceof Set && t instanceof Set) {
      if (e.size !== t.size)
        return !1;
      for (o = e.entries(); !(r = o.next()).done; )
        if (!t.has(r.value[0]))
          return !1;
      return !0;
    }
    if (KUe && ArrayBuffer.isView(e) && ArrayBuffer.isView(t)) {
      if (n = e.length, n != t.length)
        return !1;
      for (r = n; r-- !== 0; )
        if (e[r] !== t[r])
          return !1;
      return !0;
    }
    if (e.constructor === RegExp)
      return e.source === t.source && e.flags === t.flags;
    if (e.valueOf !== Object.prototype.valueOf && typeof e.valueOf == "function" && typeof t.valueOf == "function")
      return e.valueOf() === t.valueOf();
    if (e.toString !== Object.prototype.toString && typeof e.toString == "function" && typeof t.toString == "function")
      return e.toString() === t.toString();
    if (i = Object.keys(e), n = i.length, n !== Object.keys(t).length)
      return !1;
    for (r = n; r-- !== 0; )
      if (!Object.prototype.hasOwnProperty.call(t, i[r]))
        return !1;
    if (WUe && e instanceof Element)
      return !1;
    for (r = n; r-- !== 0; )
      if (!((i[r] === "_owner" || i[r] === "__v" || i[r] === "__o") && e.$$typeof) && !K1(e[i[r]], t[i[r]]))
        return !1;
    return !0;
  }
  return e !== e && t !== t;
}
var YUe = function(t, n) {
  try {
    return K1(t, n);
  } catch (r) {
    if ((r.message || "").match(/stack|recursion/i))
      return console.warn("react-fast-compare cannot handle circular refs"), !1;
    throw r;
  }
};
const ys = /* @__PURE__ */ pn(YUe);
function see(e) {
  return Array.isArray(e) && e.length > 0;
}
function XS(e) {
  return Array.isArray(e) && e.some((t) => typeof t == "string");
}
function Iu(e) {
  return Array.isArray(e) && e.some((t) => t instanceof Date);
}
function XUe(e) {
  return see(e) && e.every((t) => typeof t == "string");
}
function QS(e, t) {
  return e && t ? e.filter((n) => !t.includes(n)) : [];
}
function IF(e) {
  return see(e) && e.every(Array.isArray);
}
function QUe(e) {
  return e.filter((t) => t !== void 0);
}
function _a(e) {
  for (var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++)
    n[r - 1] = arguments[r];
  const i = e.concat(n);
  return Iu(i) ? new Date(Math.max(...i)) : Math.max(...i);
}
function Sa(e) {
  for (var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++)
    n[r - 1] = arguments[r];
  const i = e.concat(n);
  return Iu(i) ? new Date(Math.min(...i)) : Math.min(...i);
}
function cee(e, t) {
  return (e.key || t).toString();
}
function AF(e) {
  return e.reduce((t, n, r) => {
    const i = cee(n, r);
    return t[i] = n, t;
  }, {});
}
function RF(e, t) {
  let n = !1;
  const r = Object.keys(e).reduce((i, o) => (o in t || (n = !0, i[o] = !0), i), {});
  return n && r;
}
function JUe(e, t) {
  const n = e && AF(e), r = t && AF(t);
  return {
    entering: n && RF(r, n),
    exiting: r && RF(n, r)
  };
}
function NR(e) {
  return e.type && e.type.getData ? e.type.getData(e.props) : e.props && e.props.data || !1;
}
function lee(e, t) {
  let n = !1, r = !1;
  const i = (s, c) => {
    if (!c || s.type !== c.type)
      return {};
    const {
      entering: l,
      exiting: u
    } = JUe(NR(s), NR(c)) || {};
    return n = n || !!u, r = r || !!l, {
      entering: l || !1,
      exiting: u || !1
    };
  }, o = (s, c) => s.map((l, u) => l && l.props && l.props.children && c[u] ? o(D.Children.toArray(s[u].props.children), D.Children.toArray(c[u].props.children)) : i(l, c[u])), a = o(D.Children.toArray(e), D.Children.toArray(t));
  return {
    nodesWillExit: n,
    nodesWillEnter: r,
    childrenTransitions: a,
    // TODO: This may need to be refactored for the following situation.
    //       The component receives new props, and the data provided
    //       is a perfect match for the previous data and domain except
    //       for new nodes. In this case, we wouldn't want a delay before
    //       the new nodes appear.
    nodesShouldEnter: !1
  };
}
function ZUe(e, t) {
  const n = e.onEnter && e.onEnter.after ? e.onEnter.after : Dp;
  return {
    data: t.map((r, i) => Object.assign({}, r, n(r, i, t)))
  };
}
function eWe(e, t, n, r) {
  const i = Object.assign({}, e, {
    onEnd: r
  });
  if (i && i.onLoad && !i.onLoad.duration)
    return {
      animate: i,
      data: n
    };
  const o = i.onLoad && i.onLoad.before ? i.onLoad.before : Dp, a = n.map((s, c) => Object.assign({}, s, o(s, c, n)));
  return {
    animate: i,
    data: a,
    clipWidth: 0
  };
}
function tWe(e, t, n) {
  const r = Object.assign({}, e, {
    onEnd: n
  });
  let i = t;
  if (r && r.onLoad && !r.onLoad.duration)
    return {
      animate: e,
      data: t
    };
  const o = e.onLoad && e.onLoad.after ? e.onLoad.after : Dp;
  return i = t.map((a, s) => Object.assign({}, a, o(a, s, t))), {
    animate: r,
    data: i
  };
}
function nWe(e, t, n, r, i) {
  const o = e && e.onExit, a = Object.assign({}, e, o);
  let s = n;
  if (r) {
    e.onEnd = i;
    const c = e.onExit && e.onExit.before ? e.onExit.before : Dp;
    s = n.map((l, u) => {
      const d = (l.key || u).toString();
      return r[d] ? Object.assign({}, l, c(l, u, n)) : l;
    });
  }
  return {
    animate: a,
    data: s
  };
}
function rWe(e, t, n, r, i) {
  let o = e, a = n;
  if (r) {
    o = Object.assign({}, e, {
      onEnd: i
    });
    const s = e.onEnter && e.onEnter.before ? e.onEnter.before : Dp;
    a = n.map((c, l) => {
      const u = (c.key || l).toString();
      return r[u] ? Object.assign({}, c, s(c, l, n)) : c;
    });
  }
  return {
    animate: o,
    data: a
  };
}
function iWe(e, t, n, r) {
  const i = e && e.onEnter, o = Object.assign({}, e, i);
  let a = t;
  if (n) {
    o.onEnd = r;
    const s = o.onEnter && o.onEnter.after ? o.onEnter.after : Dp;
    a = t.map((c, l) => {
      const u = cee(c, l);
      return n[u] ? Object.assign({}, c, s(c, l, t)) : c;
    });
  }
  return {
    animate: o,
    data: a
  };
}
function uee(e, t, n) {
  const r = t && t.nodesWillExit, i = t && t.nodesWillEnter, o = t && t.nodesShouldEnter, a = t && t.nodesShouldLoad, s = t && t.nodesDoneLoad, c = t && t.childrenTransitions || [], l = {
    enter: e.animate && e.animate.onEnter && e.animate.onEnter.duration,
    exit: e.animate && e.animate.onExit && e.animate.onExit.duration,
    load: e.animate && e.animate.onLoad && e.animate.onLoad.duration,
    move: e.animate && e.animate.duration
  }, u = (p, g, m) => a ? tWe(m, g, () => {
    n({
      nodesShouldLoad: !1,
      nodesDoneLoad: !0
    });
  }) : eWe(m, p, g, () => {
    n({
      nodesDoneLoad: !0
    });
  }), d = (p, g, m, v) => nWe(v, g, m, p, () => {
    n({
      nodesWillExit: !1
    });
  }), f = (p, g, m, v) => o ? iWe(v, m, p, () => {
    n({
      nodesWillEnter: !1
    });
  }) : rWe(v, g, m, p, () => {
    n({
      nodesShouldEnter: !0
    });
  }), h = function(p, g) {
    const m = p.props.animate;
    if (!p.type)
      return {};
    const v = p.props && p.props.polar && p.type.defaultPolarTransitions || p.type.defaultTransitions;
    if (v) {
      const y = m[g] && m[g].duration;
      return y !== void 0 ? y : v[g] && v[g].duration;
    }
    return {};
  };
  return function(g, m) {
    const v = NR(g) || [], y = He({}, e.animate, g.props.animate), S = g.props.polar && g.type.defaultPolarTransitions || g.type.defaultTransitions;
    y.onExit = He({}, y.onExit, S && S.onExit), y.onEnter = He({}, y.onEnter, S && S.onEnter), y.onLoad = He({}, y.onLoad, S && S.onLoad);
    const _ = c[m] || c[0];
    if (s) {
      if (r) {
        const w = _ && _.exiting, T = l.exit !== void 0 ? l.exit : h(g, "onExit");
        return d(w, g, v, Object.assign({}, y, w ? {
          duration: T
        } : {
          delay: T
        }));
      } else if (i) {
        const w = _ && _.entering, T = l.enter !== void 0 ? l.enter : h(g, "onEnter"), x = l.move !== void 0 ? l.move : g.props.animate && g.props.animate.duration;
        return f(w, g, v, Object.assign({}, y, {
          duration: o && w ? T : x
        }));
      } else if (!t && y && y.onExit)
        return ZUe(y, v);
    } else {
      const T = {
        duration: l.load !== void 0 ? l.load : h(g, "onLoad")
      };
      return u(g, v, Object.assign({}, y, T));
    }
    return {
      animate: y,
      data: v
    };
  };
}
function DR() {
  return DR = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, DR.apply(this, arguments);
}
class LR extends D.Component {
  constructor(t, n) {
    super(t, n), this.state = {
      nodesShouldLoad: !1,
      nodesDoneLoad: !1
    };
    const r = this.props.children, i = r.props.polar;
    this.continuous = !i && r.type && r.type.continuous === !0, this.timer = this.context.transitionTimer;
  }
  componentDidMount() {
    this.setState({
      nodesShouldLoad: !0
    });
  }
  shouldComponentUpdate(t) {
    return ys(this.props, t) || (this.timer.bypassAnimation(), this.setState(this.getTransitionState(this.props, t), () => this.timer.resumeAnimation())), !0;
  }
  componentWillUnmount() {
    this.timer.stop();
  }
  getTransitionState(t, n) {
    const {
      animate: r
    } = t;
    if (r) {
      if (r.parentState)
        return {
          oldProps: r.parentState.nodesWillExit ? t : null,
          nextProps: n
        };
    } else
      return {};
    const i = D.Children.toArray(t.children), o = D.Children.toArray(n.children), {
      nodesWillExit: a,
      nodesWillEnter: s,
      childrenTransitions: c,
      nodesShouldEnter: l
    } = lee(i, o);
    return {
      nodesWillExit: a,
      nodesWillEnter: s,
      childrenTransitions: c,
      nodesShouldEnter: l,
      oldProps: a ? t : null,
      nextProps: n
    };
  }
  getDomainFromChildren(t, n) {
    const r = (c) => c.reduce((l, u) => {
      if (u.type && Rn(u.type.getDomain)) {
        const d = u.props && u.type.getDomain(u.props, n);
        return d ? l.concat(d) : l;
      } else if (u.props && u.props.children)
        return l.concat(r(D.Children.toArray(u.props.children)));
      return l;
    }, []), i = D.Children.toArray(t.children)[0], o = i.props || {}, a = Array.isArray(o.domain) ? o.domain : o.domain && o.domain[n];
    if (!o.children && a)
      return a;
    const s = r([i]);
    return s.length === 0 ? [0, 1] : [Sa(s), _a(s)];
  }
  pickProps() {
    return this.state ? this.state.nodesWillExit ? this.state.oldProps || this.props : this.props : this.props;
  }
  pickDomainProps(t) {
    var r;
    const n = (r = t.animate) == null ? void 0 : r.parentState;
    return n && n.nodesWillExit ? (this.continuous || n.continuous) && (n.nextProps || this.state.nextProps) || t : this.continuous && this.state.nodesWillExit && this.state.nextProps || t;
  }
  getClipWidth(t, n) {
    const r = () => {
      const o = Pr(n.props, "x");
      return o ? Math.abs(o[1] - o[0]) : t.width;
    }, i = this.transitionProps ? this.transitionProps.clipWidth : void 0;
    return i !== void 0 ? i : r();
  }
  render() {
    var d;
    const t = this.pickProps(), n = (d = this.props.animate) != null && d.getTransitions ? this.props.animate.getTransitions : uee(t, this.state, (f) => this.setState(f)), r = D.Children.toArray(t.children)[0], i = n(r);
    this.transitionProps = i;
    const o = {
      x: this.getDomainFromChildren(this.pickDomainProps(t), "x"),
      y: this.getDomainFromChildren(t, "y")
    }, a = this.getClipWidth(t, r), s = He({
      domain: o,
      clipWidth: a
    }, i, r.props), l = (t.animationWhitelist || []).concat(["clipWidth"]), u = l.length ? YS(s, l) : s;
    return /* @__PURE__ */ D.createElement(zze, DR({}, s.animate, {
      data: u
    }), (f) => {
      if (r.props.groupComponent) {
        const h = this.continuous ? /* @__PURE__ */ D.cloneElement(r.props.groupComponent, {
          clipWidth: f.clipWidth || 0
        }) : r.props.groupComponent;
        return /* @__PURE__ */ D.cloneElement(r, He({
          animate: null,
          animating: !0,
          groupComponent: h
        }, f, s));
      }
      return /* @__PURE__ */ D.cloneElement(r, He({
        animate: null,
        animating: !0
      }, f, s));
    });
  }
}
ye(LR, "displayName", "VictoryTransition"), ye(LR, "contextType", xM);
var oWe = hM, aWe = iM, sWe = gM, cWe = bZ, lWe = Object.getOwnPropertySymbols, uWe = lWe ? function(e) {
  for (var t = []; e; )
    oWe(t, sWe(e)), e = aWe(e);
  return t;
} : cWe, dee = uWe, dWe = vZ, fWe = dee, hWe = Fp;
function gWe(e) {
  return dWe(e, hWe, fWe);
}
var CM = gWe, pWe = gy, mWe = Lp, vWe = ZZ, yWe = CM;
function bWe(e, t) {
  if (e == null)
    return {};
  var n = pWe(yWe(e), function(r) {
    return [r];
  });
  return t = mWe(t), vWe(e, n, function(r, i) {
    return t(r, i[0]);
  });
}
var fee = bWe;
const JS = /* @__PURE__ */ pn(fee);
var _We = "Expected a function";
function SWe(e) {
  if (typeof e != "function")
    throw new TypeError(_We);
  return function() {
    var t = arguments;
    switch (t.length) {
      case 0:
        return !e.call(this);
      case 1:
        return !e.call(this, t[0]);
      case 2:
        return !e.call(this, t[0], t[1]);
      case 3:
        return !e.call(this, t[0], t[1], t[2]);
    }
    return !e.apply(this, t);
  };
}
var wWe = SWe, xWe = Lp, EWe = wWe, CWe = fee;
function TWe(e, t) {
  return CWe(e, EWe(xWe(t)));
}
var IWe = TWe;
const hee = /* @__PURE__ */ pn(IWe);
function AWe(e, t, n, r) {
  for (var i = e.length, o = n + (r ? 1 : -1); r ? o-- : ++o < i; )
    if (t(e[o], o, e))
      return o;
  return -1;
}
var RWe = AWe;
function $We(e) {
  return e !== e;
}
var OWe = $We;
function PWe(e, t, n) {
  for (var r = n - 1, i = e.length; ++r < i; )
    if (e[r] === t)
      return r;
  return -1;
}
var MWe = PWe, kWe = RWe, NWe = OWe, DWe = MWe;
function LWe(e, t, n) {
  return t === t ? DWe(e, t, n) : kWe(e, NWe, n);
}
var jWe = LWe, FWe = jWe;
function VWe(e, t) {
  var n = e == null ? 0 : e.length;
  return !!n && FWe(e, t, 0) > -1;
}
var gee = VWe;
function BWe(e, t, n) {
  for (var r = -1, i = e == null ? 0 : e.length; ++r < i; )
    if (n(t, e[r]))
      return !0;
  return !1;
}
var pee = BWe;
function zWe() {
}
var HWe = zWe, lT = EZ, UWe = HWe, WWe = fM, qWe = 1 / 0, GWe = lT && 1 / WWe(new lT([, -0]))[1] == qWe ? function(e) {
  return new lT(e);
} : UWe, KWe = GWe, YWe = uM, XWe = gee, QWe = pee, JWe = dM, ZWe = KWe, eqe = fM, tqe = 200;
function nqe(e, t, n) {
  var r = -1, i = XWe, o = e.length, a = !0, s = [], c = s;
  if (n)
    a = !1, i = QWe;
  else if (o >= tqe) {
    var l = t ? null : ZWe(e);
    if (l)
      return eqe(l);
    a = !1, i = JWe, c = new YWe();
  } else
    c = t ? [] : s;
  e:
    for (; ++r < o; ) {
      var u = e[r], d = t ? t(u) : u;
      if (u = n || u !== 0 ? u : 0, a && d === d) {
        for (var f = c.length; f--; )
          if (c[f] === d)
            continue e;
        t && c.push(d), s.push(u);
      } else
        i(c, d, n) || (c !== s && c.push(d), s.push(u));
    }
  return s;
}
var mee = nqe, rqe = mee;
function iqe(e) {
  return e && e.length ? rqe(e) : [];
}
var oqe = iqe;
const dl = /* @__PURE__ */ pn(oqe), TM = /^onGlobal(.*)$/;
function vee(e, t, n, r) {
  const i = (u) => {
    const f = (() => {
      const h = u.reduce((p, g) => g.target !== void 0 ? (Array.isArray(g.target) ? g.target.includes(t) : `${g.target}` == `${t}`) ? p.concat(g) : p : p.concat(g), []);
      return n !== void 0 && t !== "parent" ? h.filter((p) => {
        const g = p.eventKey, m = (v) => v ? `${v}` == `${n}` : !0;
        return Array.isArray(g) ? g.some((v) => m(v)) : m(g);
      }) : h;
    })();
    return Array.isArray(f) && f.reduce((h, p) => p ? Object.assign(h, p.eventHandlers) : h, {});
  }, a = (() => Array.isArray(this.componentEvents) ? Array.isArray(e.events) ? this.componentEvents.concat(...e.events) : this.componentEvents : e.events)(), s = a && Rn(r) ? r(i(a), t) : void 0;
  if (!e.sharedEvents)
    return s;
  const c = e.sharedEvents.getEvents, l = e.sharedEvents.events && c(i(e.sharedEvents.events), t);
  return Object.assign({}, l, s);
}
function yee(e, t, n, r) {
  if (Lr(e))
    return {};
  const i = r || this.baseProps, o = (u, d) => {
    const {
      childName: f,
      target: h,
      key: p
    } = u, g = d === "props" ? i : this.state || {}, m = f == null || !g[f] ? g : g[f];
    return p === "parent" ? m.parent : m[p] && m[p][h];
  }, a = (u, d) => {
    const f = t === "parent" ? u.childName : u.childName || n, h = u.target || t, p = (y) => h === "parent" ? "parent" : u.eventKey === "all" ? i[y] ? Object.keys(i[y]).filter((S) => S !== "parent") : Object.keys(i).filter((S) => S !== "parent") : u.eventKey === void 0 && d === "parent" ? i[y] ? Object.keys(i[y]) : Object.keys(i) : u.eventKey !== void 0 ? u.eventKey : d, g = (y, S) => {
      const _ = this.state || {};
      if (!Rn(u.mutation))
        return _;
      const w = o({
        childName: S,
        key: y,
        target: h
      }, "props"), T = o({
        childName: S,
        key: y,
        target: h
      }, "state"), x = u.mutation(Object.assign({}, w, T), i), C = _[S] || {}, E = (O) => (O[y] && O[y][h] && delete O[y][h], O[y] && !Object.keys(O[y]).length && delete O[y], O), R = (O) => h === "parent" ? Object.assign(O, {
        [y]: Object.assign(O[y] || {}, x)
      }) : Object.assign(O, {
        [y]: Object.assign(O[y] || {}, {
          [h]: x
        })
      }), A = (O) => x ? R(O) : E(O);
      return S != null ? Object.assign(_, {
        [S]: A(C)
      }) : A(_);
    }, m = (y) => {
      const S = p(y);
      return Array.isArray(S) ? S.reduce((_, w) => Object.assign(_, g(w, y)), {}) : g(S, y);
    }, v = f === "all" ? Object.keys(i).filter((y) => y !== "parent") : f;
    return Array.isArray(v) ? v.reduce((y, S) => Object.assign(y, m(S)), {}) : m(v);
  }, s = (u, d) => Array.isArray(u) ? u.reduce((f, h) => Object.assign({}, f, a(h, d)), {}) : a(u, d), c = (u) => {
    const d = (p) => Rn(p.callback) && p.callback, h = (Array.isArray(u) ? u.map((p) => d(p)) : [d(u)]).filter((p) => p !== !1);
    return h.length ? () => h.forEach((p) => p()) : void 0;
  }, l = (u, d, f, h) => {
    const p = e[h](u, d, f, this);
    if (!Lr(p)) {
      const g = c(p);
      this.setState(s(p, f), g);
    }
  };
  return Object.keys(e).reduce((u, d) => (u[d] = l, u), {});
}
function bee(e, t, n) {
  return e ? Object.keys(e).reduce((r, i) => {
    const o = (a) => e[i](a, n, t, i);
    return r[i] = o, r;
  }, {}) : {};
}
function _ee(e, t, n) {
  const r = this.state || {};
  return n ? r[n] && r[n][e] && r[n][e][t] : e === "parent" ? r[e] && r[e][t] || r[e] : r[e] && r[e][t];
}
function aqe(e, t, n, r) {
  return t === void 0 && (t = {}), n === void 0 && (n = {}), r.reduce((i, o) => {
    const a = n[o], s = See(e, t[o], n[o], o);
    return i[o] = s || a, JS(i, (c) => !Lr(c));
  }, {});
}
function See(e, t, n, r) {
  return t === void 0 && (t = {}), n === void 0 && (n = {}), Object.keys(t).reduce((o, a) => {
    const s = n[a] || {}, c = t[a] || {};
    if (a === "parent") {
      const u = $F(e, c, s, {
        eventKey: a,
        target: "parent"
      });
      o[a] = u !== void 0 ? Object.assign({}, s, u) : s;
    } else {
      const l = dl(Object.keys(c).concat(Object.keys(s)));
      o[a] = l.reduce((u, d) => {
        const f = {
          eventKey: a,
          target: d,
          childName: r
        }, h = $F(e, c[d], s[d], f);
        return u[d] = h !== void 0 ? Object.assign({}, s[d], h) : s[d], JS(u, (p) => !Lr(p));
      }, {});
    }
    return JS(o, (l) => !Lr(l));
  }, {});
}
function $F(e, t, n, r) {
  const i = (c, l) => typeof c[l] == "string" ? c[l] === "all" || c[l] === r[l] : Array.isArray(c[l]) ? c[l].map((d) => `${d}`).includes(r[l]) : !1;
  let o = Array.isArray(e) ? e : [e];
  r.childName && (o = e.filter((c) => i(c, "childName")));
  const a = o.filter((c) => i(c, "target"));
  if (Lr(a))
    return;
  const s = a.filter((c) => i(c, "eventKey"));
  if (!Lr(s))
    return s.reduce((c, l) => {
      const d = (l && Rn(l.mutation) ? l.mutation : () => {
      })(Object.assign({}, t, n));
      return Object.assign({}, c, d);
    }, {});
}
function IM(e, t) {
  const n = Array.isArray(t) && t.reduce((r, i) => {
    const o = e[i], a = o && o.type && o.type.defaultEvents, s = Rn(a) ? a(o.props) : a;
    return Array.isArray(s) ? r.concat(...s) : r;
  }, []);
  return n && n.length ? n : void 0;
}
function ZS(e) {
  const t = e.match(TM);
  return t && t[1] && t[1].toLowerCase();
}
const wee = (e) => JS(e, (t, n) => TM.test(n)), xee = (e) => hee(e, (t, n) => TM.test(n)), Eee = (e) => Object.assign(e, {
  nativeEvent: e
}), sqe = (e) => !za(e._x) && !za(e._y), cqe = [{
  name: "parent",
  index: "parent"
}, {
  name: "data"
}, {
  name: "labels"
}];
function qu(e, t) {
  t === void 0 && (t = {});
  class n extends e {
    constructor(o) {
      super(o);
      ye(this, "state", {});
      ye(this, "getEventState", _ee.bind(this));
      ye(this, "getScopedEvents", yee.bind(this));
      ye(this, "getEvents", (o, a, s) => vee.call(this, o, a, s, this.getScopedEvents));
      ye(this, "externalMutations", this.getExternalMutations(this.props));
      ye(this, "calculatedState", this.getStateChanges(this.props));
      ye(this, "globalEvents", {});
      ye(this, "prevGlobalEventKeys", []);
      ye(this, "boundGlobalEvents", {});
      this.cacheValues(this.getCalculatedValues(o));
    }
    shouldComponentUpdate(o) {
      const a = this.getExternalMutations(o), s = this.props.animating || this.props.animate, c = !ys(a, this.externalMutations);
      if (s || c)
        return this.cacheValues(this.getCalculatedValues(o)), this.externalMutations = a, this.applyExternalMutations(o, a), !0;
      const l = this.getStateChanges(o);
      return ys(this.calculatedState, l) ? ys(this.props, o) ? !1 : (this.cacheValues(this.getCalculatedValues(o)), !0) : (this.cacheValues(this.getCalculatedValues(o)), !0);
    }
    componentDidMount() {
      const o = Object.keys(this.globalEvents);
      o.forEach((a) => this.addGlobalListener(a)), this.prevGlobalEventKeys = o;
    }
    componentDidUpdate(o) {
      const a = this.getStateChanges(o);
      this.calculatedState = a;
      const s = Object.keys(this.globalEvents);
      QS(this.prevGlobalEventKeys, s).forEach((u) => this.removeGlobalListener(u)), QS(s, this.prevGlobalEventKeys).forEach((u) => this.addGlobalListener(u)), this.prevGlobalEventKeys = s;
    }
    componentWillUnmount() {
      this.prevGlobalEventKeys.forEach((o) => this.removeGlobalListener(o));
    }
    addGlobalListener(o) {
      const a = (s) => {
        const c = this.globalEvents[o];
        return c && c(Eee(s));
      };
      this.boundGlobalEvents[o] = a, window.addEventListener(ZS(o), a);
    }
    removeGlobalListener(o) {
      window.removeEventListener(ZS(o), this.boundGlobalEvents[o]);
    }
    // compile all state changes from own and parent state. Order doesn't matter, as any state
    // state change should trigger a re-render
    getStateChanges(o) {
      if (!this.hasEvents)
        return {};
      const a = (l, u) => {
        const d = He({}, this.getEventState(l, u), this.getSharedEventState(l, u));
        return Lr(d) ? void 0 : d;
      };
      return (t.components || cqe).map((l) => {
        if (!(!o.standalone && l.name === "parent"))
          return l.index !== void 0 ? a(l.index, l.name) : this.dataKeys.map((u) => a(u, l.name)).filter(Boolean);
      }).filter(Boolean);
    }
    applyExternalMutations(o, a) {
      if (!Lr(a)) {
        const s = o.externalEventMutations.reduce((l, u) => Rn(u.callback) ? l.concat(u.callback) : l, []), c = s.length ? () => {
          s.forEach((l) => l());
        } : void 0;
        this.setState(a, c);
      }
    }
    getCalculatedValues(o) {
      const {
        sharedEvents: a
      } = o, s = e.expectedComponents, c = IM(o, s), l = a && Rn(a.getEventState) ? a.getEventState : () => {
      }, u = this.getBaseProps(o, l), d = Object.keys(u).filter((p) => p !== "parent"), f = o.events || o.sharedEvents || c, h = this.getAllEvents(o);
      return {
        componentEvents: c,
        getSharedEventState: l,
        baseProps: u,
        dataKeys: d,
        hasEvents: f,
        events: h
      };
    }
    getExternalMutations(o) {
      const {
        sharedEvents: a,
        externalEventMutations: s
      } = o;
      return Lr(s) || a ? void 0 : See(s, this.baseProps, this.state);
    }
    cacheValues(o) {
      Object.keys(o).forEach((a) => {
        this[a] = o[a];
      });
    }
    getBaseProps(o, a) {
      const c = (a || this.getSharedEventState.bind(this))("parent", "parent"), l = this.getEventState("parent", "parent"), u = He({}, l, c), d = u.parentControlledProps, f = d ? YS(u, d) : {}, h = He({}, f, o);
      return typeof e.getBaseProps == "function" ? e.getBaseProps(h) : {};
    }
    getAllEvents(o) {
      return Array.isArray(this.componentEvents) ? Array.isArray(o.events) ? this.componentEvents.concat(...o.events) : this.componentEvents : o.events;
    }
    getComponentProps(o, a, s) {
      const c = this.props.name || e.role, l = this.dataKeys && this.dataKeys[s] || s, u = `${c}-${a}-${l}`, d = this.baseProps[l] && this.baseProps[l][a] || this.baseProps[l];
      if (!d && !this.hasEvents)
        return;
      const f = o && typeof o == "object" && "props" in o ? o.props : void 0;
      if (this.hasEvents) {
        const h = this.getEvents(this.props, a, l), p = He({
          index: s,
          key: u
        }, this.getEventState(l, a), this.getSharedEventState(l, a), f, d, {
          id: u
        }), g = He({}, bee(h, l, p), p.events);
        return Object.assign({}, p, {
          events: g
        });
      }
      return He({
        index: s,
        key: u
      }, f, d, {
        id: u
      });
    }
    renderContainer(o, a) {
      const c = o.type && o.type.role === "container" ? this.getComponentProps(o, "parent", "parent") : {};
      return c.events && (this.globalEvents = wee(c.events), c.events = xee(c.events)), /* @__PURE__ */ D.cloneElement(o, c, a);
    }
    animateComponent(o, a) {
      var l;
      const s = typeof o.animate == "object" && ((l = o.animate) == null ? void 0 : l.animationWhitelist) || a, c = this.constructor;
      return /* @__PURE__ */ D.createElement(LR, {
        animate: o.animate,
        animationWhitelist: s
      }, /* @__PURE__ */ D.createElement(c, o));
    }
    // Used by `VictoryLine` and `VictoryArea`
    renderContinuousData(o) {
      const {
        dataComponent: a,
        labelComponent: s,
        groupComponent: c
      } = o, u = this.dataKeys.filter((h) => h !== "all").reduce((h, p) => {
        let g = h;
        const m = this.getComponentProps(s, "labels", p);
        return m && m.text !== void 0 && m.text !== null && (g = g.concat(/* @__PURE__ */ D.cloneElement(s, m))), g;
      }, []), d = this.getComponentProps(a, "data", "all"), f = [/* @__PURE__ */ D.cloneElement(a, d), ...u];
      return this.renderContainer(c, f);
    }
    renderData(o, a) {
      a === void 0 && (a = sqe);
      const {
        dataComponent: s,
        labelComponent: c,
        groupComponent: l
      } = o, u = this.dataKeys.reduce((h, p, g) => {
        const m = this.getComponentProps(s, "data", g);
        return a(m.datum) && h.push(/* @__PURE__ */ D.cloneElement(s, m)), h;
      }, []), d = this.dataKeys.map((h, p) => {
        const g = this.getComponentProps(c, "labels", p);
        if (g.text !== void 0 && g.text !== null)
          return /* @__PURE__ */ D.cloneElement(c, g);
      }).filter(Boolean), f = [...u, ...d];
      return this.renderContainer(l, f);
    }
  }
  return n;
}
function lqe(e) {
  return (t) => {
    e.forEach((n) => {
      Rn(n) ? n(t) : n != null && (n.current = t);
    });
  };
}
var uqe = vl, dqe = Ga, fqe = "[object Date]";
function hqe(e) {
  return dqe(e) && uqe(e) == fqe;
}
var gqe = hqe, pqe = gqe, mqe = Mp, OF = EE, PF = OF && OF.isDate, vqe = PF ? mqe(PF) : pqe, yqe = vqe;
const Cee = /* @__PURE__ */ pn(yqe);
var bqe = Df;
function _qe(e, t) {
  for (var n = -1, r = e.length, i = 0, o = []; ++n < r; ) {
    var a = e[n], s = t ? t(a) : a;
    if (!n || !bqe(s, c)) {
      var c = s;
      o[i++] = a === 0 ? 0 : a;
    }
  }
  return o;
}
var Sqe = _qe, wqe = Sqe;
function xqe(e) {
  return e && e.length ? wqe(e) : [];
}
var Eqe = xqe;
const Cqe = /* @__PURE__ */ pn(Eqe);
var Tqe = mM;
function Iqe(e, t) {
  return Tqe(e, t);
}
var Aqe = Iqe;
const Rqe = /* @__PURE__ */ pn(Aqe);
function $qe(e) {
  return e === void 0;
}
var Oqe = $qe;
const Pqe = /* @__PURE__ */ pn(Oqe);
function lu(e, t) {
  return e == null || t == null ? NaN : e < t ? -1 : e > t ? 1 : e >= t ? 0 : NaN;
}
function Mqe(e, t) {
  return e == null || t == null ? NaN : t < e ? -1 : t > e ? 1 : t >= e ? 0 : NaN;
}
function AM(e) {
  let t, n, r;
  e.length !== 2 ? (t = lu, n = (s, c) => lu(e(s), c), r = (s, c) => e(s) - c) : (t = e === lu || e === Mqe ? e : kqe, n = e, r = e);
  function i(s, c, l = 0, u = s.length) {
    if (l < u) {
      if (t(c, c) !== 0)
        return u;
      do {
        const d = l + u >>> 1;
        n(s[d], c) < 0 ? l = d + 1 : u = d;
      } while (l < u);
    }
    return l;
  }
  function o(s, c, l = 0, u = s.length) {
    if (l < u) {
      if (t(c, c) !== 0)
        return u;
      do {
        const d = l + u >>> 1;
        n(s[d], c) <= 0 ? l = d + 1 : u = d;
      } while (l < u);
    }
    return l;
  }
  function a(s, c, l = 0, u = s.length) {
    const d = i(s, c, l, u - 1);
    return d > l && r(s[d - 1], c) > -r(s[d], c) ? d - 1 : d;
  }
  return { left: i, center: a, right: o };
}
function kqe() {
  return 0;
}
function Tee(e) {
  return e === null ? NaN : +e;
}
function* Nqe(e, t) {
  if (t === void 0)
    for (let n of e)
      n != null && (n = +n) >= n && (yield n);
  else {
    let n = -1;
    for (let r of e)
      (r = t(r, ++n, e)) != null && (r = +r) >= r && (yield r);
  }
}
const Dqe = AM(lu), Lqe = Dqe.right;
AM(Tee).center;
const Ty = Lqe;
class MF extends Map {
  constructor(t, n = Vqe) {
    if (super(), Object.defineProperties(this, { _intern: { value: /* @__PURE__ */ new Map() }, _key: { value: n } }), t != null)
      for (const [r, i] of t)
        this.set(r, i);
  }
  get(t) {
    return super.get(kF(this, t));
  }
  has(t) {
    return super.has(kF(this, t));
  }
  set(t, n) {
    return super.set(jqe(this, t), n);
  }
  delete(t) {
    return super.delete(Fqe(this, t));
  }
}
function kF({ _intern: e, _key: t }, n) {
  const r = t(n);
  return e.has(r) ? e.get(r) : n;
}
function jqe({ _intern: e, _key: t }, n) {
  const r = t(n);
  return e.has(r) ? e.get(r) : (e.set(r, n), n);
}
function Fqe({ _intern: e, _key: t }, n) {
  const r = t(n);
  return e.has(r) && (n = e.get(n), e.delete(r)), n;
}
function Vqe(e) {
  return e !== null && typeof e == "object" ? e.valueOf() : e;
}
function Bqe(e = lu) {
  if (e === lu)
    return Iee;
  if (typeof e != "function")
    throw new TypeError("compare is not a function");
  return (t, n) => {
    const r = e(t, n);
    return r || r === 0 ? r : (e(n, n) === 0) - (e(t, t) === 0);
  };
}
function Iee(e, t) {
  return (e == null || !(e >= e)) - (t == null || !(t >= t)) || (e < t ? -1 : e > t ? 1 : 0);
}
const zqe = Math.sqrt(50), Hqe = Math.sqrt(10), Uqe = Math.sqrt(2);
function ew(e, t, n) {
  const r = (t - e) / Math.max(0, n), i = Math.floor(Math.log10(r)), o = r / Math.pow(10, i), a = o >= zqe ? 10 : o >= Hqe ? 5 : o >= Uqe ? 2 : 1;
  let s, c, l;
  return i < 0 ? (l = Math.pow(10, -i) / a, s = Math.round(e * l), c = Math.round(t * l), s / l < e && ++s, c / l > t && --c, l = -l) : (l = Math.pow(10, i) * a, s = Math.round(e / l), c = Math.round(t / l), s * l < e && ++s, c * l > t && --c), c < s && 0.5 <= n && n < 2 ? ew(e, t, n * 2) : [s, c, l];
}
function jR(e, t, n) {
  if (t = +t, e = +e, n = +n, !(n > 0))
    return [];
  if (e === t)
    return [e];
  const r = t < e, [i, o, a] = r ? ew(t, e, n) : ew(e, t, n);
  if (!(o >= i))
    return [];
  const s = o - i + 1, c = new Array(s);
  if (r)
    if (a < 0)
      for (let l = 0; l < s; ++l)
        c[l] = (o - l) / -a;
    else
      for (let l = 0; l < s; ++l)
        c[l] = (o - l) * a;
  else if (a < 0)
    for (let l = 0; l < s; ++l)
      c[l] = (i + l) / -a;
  else
    for (let l = 0; l < s; ++l)
      c[l] = (i + l) * a;
  return c;
}
function FR(e, t, n) {
  return t = +t, e = +e, n = +n, ew(e, t, n)[2];
}
function VR(e, t, n) {
  t = +t, e = +e, n = +n;
  const r = t < e, i = r ? FR(t, e, n) : FR(e, t, n);
  return (r ? -1 : 1) * (i < 0 ? 1 / -i : i);
}
function NF(e, t) {
  let n;
  if (t === void 0)
    for (const r of e)
      r != null && (n < r || n === void 0 && r >= r) && (n = r);
  else {
    let r = -1;
    for (let i of e)
      (i = t(i, ++r, e)) != null && (n < i || n === void 0 && i >= i) && (n = i);
  }
  return n;
}
function DF(e, t) {
  let n;
  if (t === void 0)
    for (const r of e)
      r != null && (n > r || n === void 0 && r >= r) && (n = r);
  else {
    let r = -1;
    for (let i of e)
      (i = t(i, ++r, e)) != null && (n > i || n === void 0 && i >= i) && (n = i);
  }
  return n;
}
function Aee(e, t, n = 0, r = 1 / 0, i) {
  if (t = Math.floor(t), n = Math.floor(Math.max(0, n)), r = Math.floor(Math.min(e.length - 1, r)), !(n <= t && t <= r))
    return e;
  for (i = i === void 0 ? Iee : Bqe(i); r > n; ) {
    if (r - n > 600) {
      const c = r - n + 1, l = t - n + 1, u = Math.log(c), d = 0.5 * Math.exp(2 * u / 3), f = 0.5 * Math.sqrt(u * d * (c - d) / c) * (l - c / 2 < 0 ? -1 : 1), h = Math.max(n, Math.floor(t - l * d / c + f)), p = Math.min(r, Math.floor(t + (c - l) * d / c + f));
      Aee(e, t, h, p, i);
    }
    const o = e[t];
    let a = n, s = r;
    for (vm(e, n, t), i(e[r], o) > 0 && vm(e, n, r); a < s; ) {
      for (vm(e, a, s), ++a, --s; i(e[a], o) < 0; )
        ++a;
      for (; i(e[s], o) > 0; )
        --s;
    }
    i(e[n], o) === 0 ? vm(e, n, s) : (++s, vm(e, s, r)), s <= t && (n = s + 1), t <= s && (r = s - 1);
  }
  return e;
}
function vm(e, t, n) {
  const r = e[t];
  e[t] = e[n], e[n] = r;
}
function Wqe(e, t, n) {
  if (e = Float64Array.from(Nqe(e, n)), !(!(r = e.length) || isNaN(t = +t))) {
    if (t <= 0 || r < 2)
      return DF(e);
    if (t >= 1)
      return NF(e);
    var r, i = (r - 1) * t, o = Math.floor(i), a = NF(Aee(e, o).subarray(0, o + 1)), s = DF(e.subarray(o + 1));
    return a + (s - a) * (i - o);
  }
}
function qqe(e, t, n = Tee) {
  if (!(!(r = e.length) || isNaN(t = +t))) {
    if (t <= 0 || r < 2)
      return +n(e[0], 0, e);
    if (t >= 1)
      return +n(e[r - 1], r - 1, e);
    var r, i = (r - 1) * t, o = Math.floor(i), a = +n(e[o], o, e), s = +n(e[o + 1], o + 1, e);
    return a + (s - a) * (i - o);
  }
}
function Gqe(e, t, n) {
  e = +e, t = +t, n = (i = arguments.length) < 2 ? (t = e, e = 0, 1) : i < 3 ? 1 : +n;
  for (var r = -1, i = Math.max(0, Math.ceil((t - e) / n)) | 0, o = new Array(i); ++r < i; )
    o[r] = e + r * n;
  return o;
}
function Xa(e, t) {
  switch (arguments.length) {
    case 0:
      break;
    case 1:
      this.range(e);
      break;
    default:
      this.range(t).domain(e);
      break;
  }
  return this;
}
function yl(e, t) {
  switch (arguments.length) {
    case 0:
      break;
    case 1: {
      typeof e == "function" ? this.interpolator(e) : this.range(e);
      break;
    }
    default: {
      this.domain(e), typeof t == "function" ? this.interpolator(t) : this.range(t);
      break;
    }
  }
  return this;
}
const BR = Symbol("implicit");
function Gc() {
  var e = new MF(), t = [], n = [], r = BR;
  function i(o) {
    let a = e.get(o);
    if (a === void 0) {
      if (r !== BR)
        return r;
      e.set(o, a = t.push(o) - 1);
    }
    return n[a % n.length];
  }
  return i.domain = function(o) {
    if (!arguments.length)
      return t.slice();
    t = [], e = new MF();
    for (const a of o)
      e.has(a) || e.set(a, t.push(a) - 1);
    return i;
  }, i.range = function(o) {
    return arguments.length ? (n = Array.from(o), i) : n.slice();
  }, i.unknown = function(o) {
    return arguments.length ? (r = o, i) : r;
  }, i.copy = function() {
    return Gc(t, n).unknown(r);
  }, Xa.apply(i, arguments), i;
}
function LE() {
  var e = Gc().unknown(void 0), t = e.domain, n = e.range, r = 0, i = 1, o, a, s = !1, c = 0, l = 0, u = 0.5;
  delete e.unknown;
  function d() {
    var f = t().length, h = i < r, p = h ? i : r, g = h ? r : i;
    o = (g - p) / Math.max(1, f - c + l * 2), s && (o = Math.floor(o)), p += (g - p - o * (f - c)) * u, a = o * (1 - c), s && (p = Math.round(p), a = Math.round(a));
    var m = Gqe(f).map(function(v) {
      return p + o * v;
    });
    return n(h ? m.reverse() : m);
  }
  return e.domain = function(f) {
    return arguments.length ? (t(f), d()) : t();
  }, e.range = function(f) {
    return arguments.length ? ([r, i] = f, r = +r, i = +i, d()) : [r, i];
  }, e.rangeRound = function(f) {
    return [r, i] = f, r = +r, i = +i, s = !0, d();
  }, e.bandwidth = function() {
    return a;
  }, e.step = function() {
    return o;
  }, e.round = function(f) {
    return arguments.length ? (s = !!f, d()) : s;
  }, e.padding = function(f) {
    return arguments.length ? (c = Math.min(1, l = +f), d()) : c;
  }, e.paddingInner = function(f) {
    return arguments.length ? (c = Math.min(1, f), d()) : c;
  }, e.paddingOuter = function(f) {
    return arguments.length ? (l = +f, d()) : l;
  }, e.align = function(f) {
    return arguments.length ? (u = Math.max(0, Math.min(1, f)), d()) : u;
  }, e.copy = function() {
    return LE(t(), [r, i]).round(s).paddingInner(c).paddingOuter(l).align(u);
  }, Xa.apply(d(), arguments);
}
function Ree(e) {
  var t = e.copy;
  return e.padding = e.paddingOuter, delete e.paddingInner, delete e.paddingOuter, e.copy = function() {
    return Ree(t());
  }, e;
}
function $ee() {
  return Ree(LE.apply(null, arguments).paddingInner(1));
}
function Kqe(e) {
  return function() {
    return e;
  };
}
function tw(e) {
  return +e;
}
var LF = [0, 1];
function Ro(e) {
  return e;
}
function zR(e, t) {
  return (t -= e = +e) ? function(n) {
    return (n - e) / t;
  } : Kqe(isNaN(t) ? NaN : 0.5);
}
function Yqe(e, t) {
  var n;
  return e > t && (n = e, e = t, t = n), function(r) {
    return Math.max(e, Math.min(t, r));
  };
}
function Xqe(e, t, n) {
  var r = e[0], i = e[1], o = t[0], a = t[1];
  return i < r ? (r = zR(i, r), o = n(a, o)) : (r = zR(r, i), o = n(o, a)), function(s) {
    return o(r(s));
  };
}
function Qqe(e, t, n) {
  var r = Math.min(e.length, t.length) - 1, i = new Array(r), o = new Array(r), a = -1;
  for (e[r] < e[0] && (e = e.slice().reverse(), t = t.slice().reverse()); ++a < r; )
    i[a] = zR(e[a], e[a + 1]), o[a] = n(t[a], t[a + 1]);
  return function(s) {
    var c = Ty(e, s, 1, r) - 1;
    return o[c](i[c](s));
  };
}
function Iy(e, t) {
  return t.domain(e.domain()).range(e.range()).interpolate(e.interpolate()).clamp(e.clamp()).unknown(e.unknown());
}
function jE() {
  var e = LF, t = LF, n = wc, r, i, o, a = Ro, s, c, l;
  function u() {
    var f = Math.min(e.length, t.length);
    return a !== Ro && (a = Yqe(e[0], e[f - 1])), s = f > 2 ? Qqe : Xqe, c = l = null, d;
  }
  function d(f) {
    return f == null || isNaN(f = +f) ? o : (c || (c = s(e.map(r), t, n)))(r(a(f)));
  }
  return d.invert = function(f) {
    return a(i((l || (l = s(t, e.map(r), US)))(f)));
  }, d.domain = function(f) {
    return arguments.length ? (e = Array.from(f, tw), u()) : e.slice();
  }, d.range = function(f) {
    return arguments.length ? (t = Array.from(f), u()) : t.slice();
  }, d.rangeRound = function(f) {
    return t = Array.from(f), n = SM, u();
  }, d.clamp = function(f) {
    return arguments.length ? (a = f ? !0 : Ro, u()) : a !== Ro;
  }, d.interpolate = function(f) {
    return arguments.length ? (n = f, u()) : n;
  }, d.unknown = function(f) {
    return arguments.length ? (o = f, d) : o;
  }, function(f, h) {
    return r = f, i = h, u();
  };
}
function RM() {
  return jE()(Ro, Ro);
}
function Jqe(e) {
  return Math.abs(e = Math.round(e)) >= 1e21 ? e.toLocaleString("en").replace(/,/g, "") : e.toString(10);
}
function nw(e, t) {
  if ((n = (e = t ? e.toExponential(t - 1) : e.toExponential()).indexOf("e")) < 0)
    return null;
  var n, r = e.slice(0, n);
  return [
    r.length > 1 ? r[0] + r.slice(2) : r,
    +e.slice(n + 1)
  ];
}
function zg(e) {
  return e = nw(Math.abs(e)), e ? e[1] : NaN;
}
function Zqe(e, t) {
  return function(n, r) {
    for (var i = n.length, o = [], a = 0, s = e[0], c = 0; i > 0 && s > 0 && (c + s + 1 > r && (s = Math.max(1, r - c)), o.push(n.substring(i -= s, i + s)), !((c += s + 1) > r)); )
      s = e[a = (a + 1) % e.length];
    return o.reverse().join(t);
  };
}
function eGe(e) {
  return function(t) {
    return t.replace(/[0-9]/g, function(n) {
      return e[+n];
    });
  };
}
var tGe = /^(?:(.)?([<>=^]))?([+\-( ])?([$#])?(0)?(\d+)?(,)?(\.\d+)?(~)?([a-z%])?$/i;
function bv(e) {
  if (!(t = tGe.exec(e)))
    throw new Error("invalid format: " + e);
  var t;
  return new $M({
    fill: t[1],
    align: t[2],
    sign: t[3],
    symbol: t[4],
    zero: t[5],
    width: t[6],
    comma: t[7],
    precision: t[8] && t[8].slice(1),
    trim: t[9],
    type: t[10]
  });
}
bv.prototype = $M.prototype;
function $M(e) {
  this.fill = e.fill === void 0 ? " " : e.fill + "", this.align = e.align === void 0 ? ">" : e.align + "", this.sign = e.sign === void 0 ? "-" : e.sign + "", this.symbol = e.symbol === void 0 ? "" : e.symbol + "", this.zero = !!e.zero, this.width = e.width === void 0 ? void 0 : +e.width, this.comma = !!e.comma, this.precision = e.precision === void 0 ? void 0 : +e.precision, this.trim = !!e.trim, this.type = e.type === void 0 ? "" : e.type + "";
}
$M.prototype.toString = function() {
  return this.fill + this.align + this.sign + this.symbol + (this.zero ? "0" : "") + (this.width === void 0 ? "" : Math.max(1, this.width | 0)) + (this.comma ? "," : "") + (this.precision === void 0 ? "" : "." + Math.max(0, this.precision | 0)) + (this.trim ? "~" : "") + this.type;
};
function nGe(e) {
  e:
    for (var t = e.length, n = 1, r = -1, i; n < t; ++n)
      switch (e[n]) {
        case ".":
          r = i = n;
          break;
        case "0":
          r === 0 && (r = n), i = n;
          break;
        default:
          if (!+e[n])
            break e;
          r > 0 && (r = 0);
          break;
      }
  return r > 0 ? e.slice(0, r) + e.slice(i + 1) : e;
}
var Oee;
function rGe(e, t) {
  var n = nw(e, t);
  if (!n)
    return e + "";
  var r = n[0], i = n[1], o = i - (Oee = Math.max(-8, Math.min(8, Math.floor(i / 3))) * 3) + 1, a = r.length;
  return o === a ? r : o > a ? r + new Array(o - a + 1).join("0") : o > 0 ? r.slice(0, o) + "." + r.slice(o) : "0." + new Array(1 - o).join("0") + nw(e, Math.max(0, t + o - 1))[0];
}
function jF(e, t) {
  var n = nw(e, t);
  if (!n)
    return e + "";
  var r = n[0], i = n[1];
  return i < 0 ? "0." + new Array(-i).join("0") + r : r.length > i + 1 ? r.slice(0, i + 1) + "." + r.slice(i + 1) : r + new Array(i - r.length + 2).join("0");
}
const FF = {
  "%": function(e, t) {
    return (e * 100).toFixed(t);
  },
  b: function(e) {
    return Math.round(e).toString(2);
  },
  c: function(e) {
    return e + "";
  },
  d: Jqe,
  e: function(e, t) {
    return e.toExponential(t);
  },
  f: function(e, t) {
    return e.toFixed(t);
  },
  g: function(e, t) {
    return e.toPrecision(t);
  },
  o: function(e) {
    return Math.round(e).toString(8);
  },
  p: function(e, t) {
    return jF(e * 100, t);
  },
  r: jF,
  s: rGe,
  X: function(e) {
    return Math.round(e).toString(16).toUpperCase();
  },
  x: function(e) {
    return Math.round(e).toString(16);
  }
};
function VF(e) {
  return e;
}
var BF = Array.prototype.map, zF = ["y", "z", "a", "f", "p", "n", "µ", "m", "", "k", "M", "G", "T", "P", "E", "Z", "Y"];
function iGe(e) {
  var t = e.grouping === void 0 || e.thousands === void 0 ? VF : Zqe(BF.call(e.grouping, Number), e.thousands + ""), n = e.currency === void 0 ? "" : e.currency[0] + "", r = e.currency === void 0 ? "" : e.currency[1] + "", i = e.decimal === void 0 ? "." : e.decimal + "", o = e.numerals === void 0 ? VF : eGe(BF.call(e.numerals, String)), a = e.percent === void 0 ? "%" : e.percent + "", s = e.minus === void 0 ? "-" : e.minus + "", c = e.nan === void 0 ? "NaN" : e.nan + "";
  function l(d) {
    d = bv(d);
    var f = d.fill, h = d.align, p = d.sign, g = d.symbol, m = d.zero, v = d.width, y = d.comma, S = d.precision, _ = d.trim, w = d.type;
    w === "n" ? (y = !0, w = "g") : FF[w] || (S === void 0 && (S = 12), _ = !0, w = "g"), (m || f === "0" && h === "=") && (m = !0, f = "0", h = "=");
    var T = g === "$" ? n : g === "#" && /[boxX]/.test(w) ? "0" + w.toLowerCase() : "", x = g === "$" ? r : /[%p]/.test(w) ? a : "", C = FF[w], E = /[defgprs%]/.test(w);
    S = S === void 0 ? 6 : /[gprs]/.test(w) ? Math.max(1, Math.min(21, S)) : Math.max(0, Math.min(20, S));
    function R(A) {
      var O = T, $ = x, N, z, k;
      if (w === "c")
        $ = C(A) + $, A = "";
      else {
        A = +A;
        var F = A < 0 || 1 / A < 0;
        if (A = isNaN(A) ? c : C(Math.abs(A), S), _ && (A = nGe(A)), F && +A == 0 && p !== "+" && (F = !1), O = (F ? p === "(" ? p : s : p === "-" || p === "(" ? "" : p) + O, $ = (w === "s" ? zF[8 + Oee / 3] : "") + $ + (F && p === "(" ? ")" : ""), E) {
          for (N = -1, z = A.length; ++N < z; )
            if (k = A.charCodeAt(N), 48 > k || k > 57) {
              $ = (k === 46 ? i + A.slice(N + 1) : A.slice(N)) + $, A = A.slice(0, N);
              break;
            }
        }
      }
      y && !m && (A = t(A, 1 / 0));
      var V = O.length + A.length + $.length, j = V < v ? new Array(v - V + 1).join(f) : "";
      switch (y && m && (A = t(j + A, j.length ? v - $.length : 1 / 0), j = ""), h) {
        case "<":
          A = O + A + $ + j;
          break;
        case "=":
          A = O + j + A + $;
          break;
        case "^":
          A = j.slice(0, V = j.length >> 1) + O + A + $ + j.slice(V);
          break;
        default:
          A = j + O + A + $;
          break;
      }
      return o(A);
    }
    return R.toString = function() {
      return d + "";
    }, R;
  }
  function u(d, f) {
    var h = l((d = bv(d), d.type = "f", d)), p = Math.max(-8, Math.min(8, Math.floor(zg(f) / 3))) * 3, g = Math.pow(10, -p), m = zF[8 + p / 3];
    return function(v) {
      return h(g * v) + m;
    };
  }
  return {
    format: l,
    formatPrefix: u
  };
}
var t1, Ay, Pee;
oGe({
  decimal: ".",
  thousands: ",",
  grouping: [3],
  currency: ["$", ""],
  minus: "-"
});
function oGe(e) {
  return t1 = iGe(e), Ay = t1.format, Pee = t1.formatPrefix, t1;
}
function aGe(e) {
  return Math.max(0, -zg(Math.abs(e)));
}
function sGe(e, t) {
  return Math.max(0, Math.max(-8, Math.min(8, Math.floor(zg(t) / 3))) * 3 - zg(Math.abs(e)));
}
function cGe(e, t) {
  return e = Math.abs(e), t = Math.abs(t) - e, Math.max(0, zg(t) - zg(e)) + 1;
}
function Mee(e, t, n, r) {
  var i = VR(e, t, n), o;
  switch (r = bv(r ?? ",f"), r.type) {
    case "s": {
      var a = Math.max(Math.abs(e), Math.abs(t));
      return r.precision == null && !isNaN(o = sGe(i, a)) && (r.precision = o), Pee(r, a);
    }
    case "":
    case "e":
    case "g":
    case "p":
    case "r": {
      r.precision == null && !isNaN(o = cGe(i, Math.max(Math.abs(e), Math.abs(t)))) && (r.precision = o - (r.type === "e"));
      break;
    }
    case "f":
    case "%": {
      r.precision == null && !isNaN(o = aGe(i)) && (r.precision = o - (r.type === "%") * 2);
      break;
    }
  }
  return Ay(r);
}
function Gu(e) {
  var t = e.domain;
  return e.ticks = function(n) {
    var r = t();
    return jR(r[0], r[r.length - 1], n ?? 10);
  }, e.tickFormat = function(n, r) {
    var i = t();
    return Mee(i[0], i[i.length - 1], n ?? 10, r);
  }, e.nice = function(n) {
    n == null && (n = 10);
    var r = t(), i = 0, o = r.length - 1, a = r[i], s = r[o], c, l, u = 10;
    for (s < a && (l = a, a = s, s = l, l = i, i = o, o = l); u-- > 0; ) {
      if (l = FR(a, s, n), l === c)
        return r[i] = a, r[o] = s, t(r);
      if (l > 0)
        a = Math.floor(a / l) * l, s = Math.ceil(s / l) * l;
      else if (l < 0)
        a = Math.ceil(a * l) / l, s = Math.floor(s * l) / l;
      else
        break;
      c = l;
    }
    return e;
  }, e;
}
function Ry() {
  var e = RM();
  return e.copy = function() {
    return Iy(e, Ry());
  }, Xa.apply(e, arguments), Gu(e);
}
function kee(e) {
  var t;
  function n(r) {
    return r == null || isNaN(r = +r) ? t : r;
  }
  return n.invert = n, n.domain = n.range = function(r) {
    return arguments.length ? (e = Array.from(r, tw), n) : e.slice();
  }, n.unknown = function(r) {
    return arguments.length ? (t = r, n) : t;
  }, n.copy = function() {
    return kee(e).unknown(t);
  }, e = arguments.length ? Array.from(e, tw) : [0, 1], Gu(n);
}
function Nee(e, t) {
  e = e.slice();
  var n = 0, r = e.length - 1, i = e[n], o = e[r], a;
  return o < i && (a = n, n = r, r = a, a = i, i = o, o = a), e[n] = t.floor(i), e[r] = t.ceil(o), e;
}
function HF(e) {
  return Math.log(e);
}
function UF(e) {
  return Math.exp(e);
}
function lGe(e) {
  return -Math.log(-e);
}
function uGe(e) {
  return -Math.exp(-e);
}
function dGe(e) {
  return isFinite(e) ? +("1e" + e) : e < 0 ? 0 : e;
}
function fGe(e) {
  return e === 10 ? dGe : e === Math.E ? Math.exp : (t) => Math.pow(e, t);
}
function hGe(e) {
  return e === Math.E ? Math.log : e === 10 && Math.log10 || e === 2 && Math.log2 || (e = Math.log(e), (t) => Math.log(t) / e);
}
function WF(e) {
  return (t, n) => -e(-t, n);
}
function OM(e) {
  const t = e(HF, UF), n = t.domain;
  let r = 10, i, o;
  function a() {
    return i = hGe(r), o = fGe(r), n()[0] < 0 ? (i = WF(i), o = WF(o), e(lGe, uGe)) : e(HF, UF), t;
  }
  return t.base = function(s) {
    return arguments.length ? (r = +s, a()) : r;
  }, t.domain = function(s) {
    return arguments.length ? (n(s), a()) : n();
  }, t.ticks = (s) => {
    const c = n();
    let l = c[0], u = c[c.length - 1];
    const d = u < l;
    d && ([l, u] = [u, l]);
    let f = i(l), h = i(u), p, g;
    const m = s == null ? 10 : +s;
    let v = [];
    if (!(r % 1) && h - f < m) {
      if (f = Math.floor(f), h = Math.ceil(h), l > 0) {
        for (; f <= h; ++f)
          for (p = 1; p < r; ++p)
            if (g = f < 0 ? p / o(-f) : p * o(f), !(g < l)) {
              if (g > u)
                break;
              v.push(g);
            }
      } else
        for (; f <= h; ++f)
          for (p = r - 1; p >= 1; --p)
            if (g = f > 0 ? p / o(-f) : p * o(f), !(g < l)) {
              if (g > u)
                break;
              v.push(g);
            }
      v.length * 2 < m && (v = jR(l, u, m));
    } else
      v = jR(f, h, Math.min(h - f, m)).map(o);
    return d ? v.reverse() : v;
  }, t.tickFormat = (s, c) => {
    if (s == null && (s = 10), c == null && (c = r === 10 ? "s" : ","), typeof c != "function" && (!(r % 1) && (c = bv(c)).precision == null && (c.trim = !0), c = Ay(c)), s === 1 / 0)
      return c;
    const l = Math.max(1, r * s / t.ticks().length);
    return (u) => {
      let d = u / o(Math.round(i(u)));
      return d * r < r - 0.5 && (d *= r), d <= l ? c(u) : "";
    };
  }, t.nice = () => n(Nee(n(), {
    floor: (s) => o(Math.floor(i(s))),
    ceil: (s) => o(Math.ceil(i(s)))
  })), t;
}
function PM() {
  const e = OM(jE()).domain([1, 10]);
  return e.copy = () => Iy(e, PM()).base(e.base()), Xa.apply(e, arguments), e;
}
function qF(e) {
  return function(t) {
    return Math.sign(t) * Math.log1p(Math.abs(t / e));
  };
}
function GF(e) {
  return function(t) {
    return Math.sign(t) * Math.expm1(Math.abs(t)) * e;
  };
}
function MM(e) {
  var t = 1, n = e(qF(t), GF(t));
  return n.constant = function(r) {
    return arguments.length ? e(qF(t = +r), GF(t)) : t;
  }, Gu(n);
}
function kM() {
  var e = MM(jE());
  return e.copy = function() {
    return Iy(e, kM()).constant(e.constant());
  }, Xa.apply(e, arguments);
}
function KF(e) {
  return function(t) {
    return t < 0 ? -Math.pow(-t, e) : Math.pow(t, e);
  };
}
function gGe(e) {
  return e < 0 ? -Math.sqrt(-e) : Math.sqrt(e);
}
function pGe(e) {
  return e < 0 ? -e * e : e * e;
}
function NM(e) {
  var t = e(Ro, Ro), n = 1;
  function r() {
    return n === 1 ? e(Ro, Ro) : n === 0.5 ? e(gGe, pGe) : e(KF(n), KF(1 / n));
  }
  return t.exponent = function(i) {
    return arguments.length ? (n = +i, r()) : n;
  }, Gu(t);
}
function DM() {
  var e = NM(jE());
  return e.copy = function() {
    return Iy(e, DM()).exponent(e.exponent());
  }, Xa.apply(e, arguments), e;
}
function mGe() {
  return DM.apply(null, arguments).exponent(0.5);
}
function YF(e) {
  return Math.sign(e) * e * e;
}
function vGe(e) {
  return Math.sign(e) * Math.sqrt(Math.abs(e));
}
function Dee() {
  var e = RM(), t = [0, 1], n = !1, r;
  function i(o) {
    var a = vGe(e(o));
    return isNaN(a) ? r : n ? Math.round(a) : a;
  }
  return i.invert = function(o) {
    return e.invert(YF(o));
  }, i.domain = function(o) {
    return arguments.length ? (e.domain(o), i) : e.domain();
  }, i.range = function(o) {
    return arguments.length ? (e.range((t = Array.from(o, tw)).map(YF)), i) : t.slice();
  }, i.rangeRound = function(o) {
    return i.range(o).round(!0);
  }, i.round = function(o) {
    return arguments.length ? (n = !!o, i) : n;
  }, i.clamp = function(o) {
    return arguments.length ? (e.clamp(o), i) : e.clamp();
  }, i.unknown = function(o) {
    return arguments.length ? (r = o, i) : r;
  }, i.copy = function() {
    return Dee(e.domain(), t).round(n).clamp(e.clamp()).unknown(r);
  }, Xa.apply(i, arguments), Gu(i);
}
function Lee() {
  var e = [], t = [], n = [], r;
  function i() {
    var a = 0, s = Math.max(1, t.length);
    for (n = new Array(s - 1); ++a < s; )
      n[a - 1] = qqe(e, a / s);
    return o;
  }
  function o(a) {
    return a == null || isNaN(a = +a) ? r : t[Ty(n, a)];
  }
  return o.invertExtent = function(a) {
    var s = t.indexOf(a);
    return s < 0 ? [NaN, NaN] : [
      s > 0 ? n[s - 1] : e[0],
      s < n.length ? n[s] : e[e.length - 1]
    ];
  }, o.domain = function(a) {
    if (!arguments.length)
      return e.slice();
    e = [];
    for (let s of a)
      s != null && !isNaN(s = +s) && e.push(s);
    return e.sort(lu), i();
  }, o.range = function(a) {
    return arguments.length ? (t = Array.from(a), i()) : t.slice();
  }, o.unknown = function(a) {
    return arguments.length ? (r = a, o) : r;
  }, o.quantiles = function() {
    return n.slice();
  }, o.copy = function() {
    return Lee().domain(e).range(t).unknown(r);
  }, Xa.apply(o, arguments);
}
function jee() {
  var e = 0, t = 1, n = 1, r = [0.5], i = [0, 1], o;
  function a(c) {
    return c != null && c <= c ? i[Ty(r, c, 0, n)] : o;
  }
  function s() {
    var c = -1;
    for (r = new Array(n); ++c < n; )
      r[c] = ((c + 1) * t - (c - n) * e) / (n + 1);
    return a;
  }
  return a.domain = function(c) {
    return arguments.length ? ([e, t] = c, e = +e, t = +t, s()) : [e, t];
  }, a.range = function(c) {
    return arguments.length ? (n = (i = Array.from(c)).length - 1, s()) : i.slice();
  }, a.invertExtent = function(c) {
    var l = i.indexOf(c);
    return l < 0 ? [NaN, NaN] : l < 1 ? [e, r[0]] : l >= n ? [r[n - 1], t] : [r[l - 1], r[l]];
  }, a.unknown = function(c) {
    return arguments.length && (o = c), a;
  }, a.thresholds = function() {
    return r.slice();
  }, a.copy = function() {
    return jee().domain([e, t]).range(i).unknown(o);
  }, Xa.apply(Gu(a), arguments);
}
function Fee() {
  var e = [0.5], t = [0, 1], n, r = 1;
  function i(o) {
    return o != null && o <= o ? t[Ty(e, o, 0, r)] : n;
  }
  return i.domain = function(o) {
    return arguments.length ? (e = Array.from(o), r = Math.min(e.length, t.length - 1), i) : e.slice();
  }, i.range = function(o) {
    return arguments.length ? (t = Array.from(o), r = Math.min(e.length, t.length - 1), i) : t.slice();
  }, i.invertExtent = function(o) {
    var a = t.indexOf(o);
    return [e[a - 1], e[a]];
  }, i.unknown = function(o) {
    return arguments.length ? (n = o, i) : n;
  }, i.copy = function() {
    return Fee().domain(e).range(t).unknown(n);
  }, Xa.apply(i, arguments);
}
const uT = /* @__PURE__ */ new Date(), dT = /* @__PURE__ */ new Date();
function Ei(e, t, n, r) {
  function i(o) {
    return e(o = arguments.length === 0 ? /* @__PURE__ */ new Date() : /* @__PURE__ */ new Date(+o)), o;
  }
  return i.floor = (o) => (e(o = /* @__PURE__ */ new Date(+o)), o), i.ceil = (o) => (e(o = new Date(o - 1)), t(o, 1), e(o), o), i.round = (o) => {
    const a = i(o), s = i.ceil(o);
    return o - a < s - o ? a : s;
  }, i.offset = (o, a) => (t(o = /* @__PURE__ */ new Date(+o), a == null ? 1 : Math.floor(a)), o), i.range = (o, a, s) => {
    const c = [];
    if (o = i.ceil(o), s = s == null ? 1 : Math.floor(s), !(o < a) || !(s > 0))
      return c;
    let l;
    do
      c.push(l = /* @__PURE__ */ new Date(+o)), t(o, s), e(o);
    while (l < o && o < a);
    return c;
  }, i.filter = (o) => Ei((a) => {
    if (a >= a)
      for (; e(a), !o(a); )
        a.setTime(a - 1);
  }, (a, s) => {
    if (a >= a)
      if (s < 0)
        for (; ++s <= 0; )
          for (; t(a, -1), !o(a); )
            ;
      else
        for (; --s >= 0; )
          for (; t(a, 1), !o(a); )
            ;
  }), n && (i.count = (o, a) => (uT.setTime(+o), dT.setTime(+a), e(uT), e(dT), Math.floor(n(uT, dT))), i.every = (o) => (o = Math.floor(o), !isFinite(o) || !(o > 0) ? null : o > 1 ? i.filter(r ? (a) => r(a) % o === 0 : (a) => i.count(0, a) % o === 0) : i)), i;
}
const rw = Ei(() => {
}, (e, t) => {
  e.setTime(+e + t);
}, (e, t) => t - e);
rw.every = (e) => (e = Math.floor(e), !isFinite(e) || !(e > 0) ? null : e > 1 ? Ei((t) => {
  t.setTime(Math.floor(t / e) * e);
}, (t, n) => {
  t.setTime(+t + n * e);
}, (t, n) => (n - t) / e) : rw);
rw.range;
const Kc = 1e3, ja = Kc * 60, Yc = ja * 60, fl = Yc * 24, LM = fl * 7, XF = fl * 30, fT = fl * 365, Id = Ei((e) => {
  e.setTime(e - e.getMilliseconds());
}, (e, t) => {
  e.setTime(+e + t * Kc);
}, (e, t) => (t - e) / Kc, (e) => e.getUTCSeconds());
Id.range;
const jM = Ei((e) => {
  e.setTime(e - e.getMilliseconds() - e.getSeconds() * Kc);
}, (e, t) => {
  e.setTime(+e + t * ja);
}, (e, t) => (t - e) / ja, (e) => e.getMinutes());
jM.range;
const FM = Ei((e) => {
  e.setUTCSeconds(0, 0);
}, (e, t) => {
  e.setTime(+e + t * ja);
}, (e, t) => (t - e) / ja, (e) => e.getUTCMinutes());
FM.range;
const VM = Ei((e) => {
  e.setTime(e - e.getMilliseconds() - e.getSeconds() * Kc - e.getMinutes() * ja);
}, (e, t) => {
  e.setTime(+e + t * Yc);
}, (e, t) => (t - e) / Yc, (e) => e.getHours());
VM.range;
const BM = Ei((e) => {
  e.setUTCMinutes(0, 0, 0);
}, (e, t) => {
  e.setTime(+e + t * Yc);
}, (e, t) => (t - e) / Yc, (e) => e.getUTCHours());
BM.range;
const zM = Ei(
  (e) => e.setHours(0, 0, 0, 0),
  (e, t) => e.setDate(e.getDate() + t),
  (e, t) => (t - e - (t.getTimezoneOffset() - e.getTimezoneOffset()) * ja) / fl,
  (e) => e.getDate() - 1
);
zM.range;
const Vee = Ei((e) => {
  e.setUTCHours(0, 0, 0, 0);
}, (e, t) => {
  e.setUTCDate(e.getUTCDate() + t);
}, (e, t) => (t - e) / fl, (e) => e.getUTCDate() - 1);
Vee.range;
const Bee = Ei((e) => {
  e.setUTCHours(0, 0, 0, 0);
}, (e, t) => {
  e.setUTCDate(e.getUTCDate() + t);
}, (e, t) => (t - e) / fl, (e) => Math.floor(e / fl));
Bee.range;
function Ff(e) {
  return Ei((t) => {
    t.setDate(t.getDate() - (t.getDay() + 7 - e) % 7), t.setHours(0, 0, 0, 0);
  }, (t, n) => {
    t.setDate(t.getDate() + n * 7);
  }, (t, n) => (n - t - (n.getTimezoneOffset() - t.getTimezoneOffset()) * ja) / LM);
}
const HM = Ff(0), yGe = Ff(1), bGe = Ff(2), _Ge = Ff(3), SGe = Ff(4), wGe = Ff(5), xGe = Ff(6);
HM.range;
yGe.range;
bGe.range;
_Ge.range;
SGe.range;
wGe.range;
xGe.range;
function Vf(e) {
  return Ei((t) => {
    t.setUTCDate(t.getUTCDate() - (t.getUTCDay() + 7 - e) % 7), t.setUTCHours(0, 0, 0, 0);
  }, (t, n) => {
    t.setUTCDate(t.getUTCDate() + n * 7);
  }, (t, n) => (n - t) / LM);
}
const UM = Vf(0), EGe = Vf(1), CGe = Vf(2), TGe = Vf(3), IGe = Vf(4), AGe = Vf(5), RGe = Vf(6);
UM.range;
EGe.range;
CGe.range;
TGe.range;
IGe.range;
AGe.range;
RGe.range;
const WM = Ei((e) => {
  e.setDate(1), e.setHours(0, 0, 0, 0);
}, (e, t) => {
  e.setMonth(e.getMonth() + t);
}, (e, t) => t.getMonth() - e.getMonth() + (t.getFullYear() - e.getFullYear()) * 12, (e) => e.getMonth());
WM.range;
const qM = Ei((e) => {
  e.setUTCDate(1), e.setUTCHours(0, 0, 0, 0);
}, (e, t) => {
  e.setUTCMonth(e.getUTCMonth() + t);
}, (e, t) => t.getUTCMonth() - e.getUTCMonth() + (t.getUTCFullYear() - e.getUTCFullYear()) * 12, (e) => e.getUTCMonth());
qM.range;
const FE = Ei((e) => {
  e.setMonth(0, 1), e.setHours(0, 0, 0, 0);
}, (e, t) => {
  e.setFullYear(e.getFullYear() + t);
}, (e, t) => t.getFullYear() - e.getFullYear(), (e) => e.getFullYear());
FE.every = (e) => !isFinite(e = Math.floor(e)) || !(e > 0) ? null : Ei((t) => {
  t.setFullYear(Math.floor(t.getFullYear() / e) * e), t.setMonth(0, 1), t.setHours(0, 0, 0, 0);
}, (t, n) => {
  t.setFullYear(t.getFullYear() + n * e);
});
FE.range;
const VE = Ei((e) => {
  e.setUTCMonth(0, 1), e.setUTCHours(0, 0, 0, 0);
}, (e, t) => {
  e.setUTCFullYear(e.getUTCFullYear() + t);
}, (e, t) => t.getUTCFullYear() - e.getUTCFullYear(), (e) => e.getUTCFullYear());
VE.every = (e) => !isFinite(e = Math.floor(e)) || !(e > 0) ? null : Ei((t) => {
  t.setUTCFullYear(Math.floor(t.getUTCFullYear() / e) * e), t.setUTCMonth(0, 1), t.setUTCHours(0, 0, 0, 0);
}, (t, n) => {
  t.setUTCFullYear(t.getUTCFullYear() + n * e);
});
VE.range;
function zee(e, t, n, r, i, o) {
  const a = [
    [Id, 1, Kc],
    [Id, 5, 5 * Kc],
    [Id, 15, 15 * Kc],
    [Id, 30, 30 * Kc],
    [o, 1, ja],
    [o, 5, 5 * ja],
    [o, 15, 15 * ja],
    [o, 30, 30 * ja],
    [i, 1, Yc],
    [i, 3, 3 * Yc],
    [i, 6, 6 * Yc],
    [i, 12, 12 * Yc],
    [r, 1, fl],
    [r, 2, 2 * fl],
    [n, 1, LM],
    [t, 1, XF],
    [t, 3, 3 * XF],
    [e, 1, fT]
  ];
  function s(l, u, d) {
    const f = u < l;
    f && ([l, u] = [u, l]);
    const h = d && typeof d.range == "function" ? d : c(l, u, d), p = h ? h.range(l, +u + 1) : [];
    return f ? p.reverse() : p;
  }
  function c(l, u, d) {
    const f = Math.abs(u - l) / d, h = AM(([, , m]) => m).right(a, f);
    if (h === a.length)
      return e.every(VR(l / fT, u / fT, d));
    if (h === 0)
      return rw.every(Math.max(VR(l, u, d), 1));
    const [p, g] = a[f / a[h - 1][2] < a[h][2] / f ? h - 1 : h];
    return p.every(g);
  }
  return [s, c];
}
const [$Ge, OGe] = zee(VE, qM, UM, Bee, BM, FM), [PGe, MGe] = zee(FE, WM, HM, zM, VM, jM);
var hT = /* @__PURE__ */ new Date(), gT = /* @__PURE__ */ new Date();
function fi(e, t, n, r) {
  function i(o) {
    return e(o = arguments.length === 0 ? /* @__PURE__ */ new Date() : /* @__PURE__ */ new Date(+o)), o;
  }
  return i.floor = function(o) {
    return e(o = /* @__PURE__ */ new Date(+o)), o;
  }, i.ceil = function(o) {
    return e(o = new Date(o - 1)), t(o, 1), e(o), o;
  }, i.round = function(o) {
    var a = i(o), s = i.ceil(o);
    return o - a < s - o ? a : s;
  }, i.offset = function(o, a) {
    return t(o = /* @__PURE__ */ new Date(+o), a == null ? 1 : Math.floor(a)), o;
  }, i.range = function(o, a, s) {
    var c = [], l;
    if (o = i.ceil(o), s = s == null ? 1 : Math.floor(s), !(o < a) || !(s > 0))
      return c;
    do
      c.push(l = /* @__PURE__ */ new Date(+o)), t(o, s), e(o);
    while (l < o && o < a);
    return c;
  }, i.filter = function(o) {
    return fi(function(a) {
      if (a >= a)
        for (; e(a), !o(a); )
          a.setTime(a - 1);
    }, function(a, s) {
      if (a >= a)
        if (s < 0)
          for (; ++s <= 0; )
            for (; t(a, -1), !o(a); )
              ;
        else
          for (; --s >= 0; )
            for (; t(a, 1), !o(a); )
              ;
    });
  }, n && (i.count = function(o, a) {
    return hT.setTime(+o), gT.setTime(+a), e(hT), e(gT), Math.floor(n(hT, gT));
  }, i.every = function(o) {
    return o = Math.floor(o), !isFinite(o) || !(o > 0) ? null : o > 1 ? i.filter(r ? function(a) {
      return r(a) % o === 0;
    } : function(a) {
      return i.count(0, a) % o === 0;
    }) : i;
  }), i;
}
var iw = fi(function() {
}, function(e, t) {
  e.setTime(+e + t);
}, function(e, t) {
  return t - e;
});
iw.every = function(e) {
  return e = Math.floor(e), !isFinite(e) || !(e > 0) ? null : e > 1 ? fi(function(t) {
    t.setTime(Math.floor(t / e) * e);
  }, function(t, n) {
    t.setTime(+t + n * e);
  }, function(t, n) {
    return (n - t) / e;
  }) : iw;
};
const QF = iw;
iw.range;
var ow = 1e3, hf = 6e4, aw = 36e5, Hee = 864e5, Uee = 6048e5, Wee = fi(function(e) {
  e.setTime(e - e.getMilliseconds());
}, function(e, t) {
  e.setTime(+e + t * ow);
}, function(e, t) {
  return (t - e) / ow;
}, function(e) {
  return e.getUTCSeconds();
});
const JF = Wee;
Wee.range;
var qee = fi(function(e) {
  e.setTime(e - e.getMilliseconds() - e.getSeconds() * ow);
}, function(e, t) {
  e.setTime(+e + t * hf);
}, function(e, t) {
  return (t - e) / hf;
}, function(e) {
  return e.getMinutes();
});
const kGe = qee;
qee.range;
var Gee = fi(function(e) {
  e.setTime(e - e.getMilliseconds() - e.getSeconds() * ow - e.getMinutes() * hf);
}, function(e, t) {
  e.setTime(+e + t * aw);
}, function(e, t) {
  return (t - e) / aw;
}, function(e) {
  return e.getHours();
});
const NGe = Gee;
Gee.range;
var Kee = fi(function(e) {
  e.setHours(0, 0, 0, 0);
}, function(e, t) {
  e.setDate(e.getDate() + t);
}, function(e, t) {
  return (t - e - (t.getTimezoneOffset() - e.getTimezoneOffset()) * hf) / Hee;
}, function(e) {
  return e.getDate() - 1;
});
const Yee = Kee;
Kee.range;
function Bf(e) {
  return fi(function(t) {
    t.setDate(t.getDate() - (t.getDay() + 7 - e) % 7), t.setHours(0, 0, 0, 0);
  }, function(t, n) {
    t.setDate(t.getDate() + n * 7);
  }, function(t, n) {
    return (n - t - (n.getTimezoneOffset() - t.getTimezoneOffset()) * hf) / Uee;
  });
}
var sw = Bf(0), _v = Bf(1), Xee = Bf(2), Qee = Bf(3), gf = Bf(4), Jee = Bf(5), Zee = Bf(6);
sw.range;
_v.range;
Xee.range;
Qee.range;
gf.range;
Jee.range;
Zee.range;
var ete = fi(function(e) {
  e.setDate(1), e.setHours(0, 0, 0, 0);
}, function(e, t) {
  e.setMonth(e.getMonth() + t);
}, function(e, t) {
  return t.getMonth() - e.getMonth() + (t.getFullYear() - e.getFullYear()) * 12;
}, function(e) {
  return e.getMonth();
});
const DGe = ete;
ete.range;
var GM = fi(function(e) {
  e.setMonth(0, 1), e.setHours(0, 0, 0, 0);
}, function(e, t) {
  e.setFullYear(e.getFullYear() + t);
}, function(e, t) {
  return t.getFullYear() - e.getFullYear();
}, function(e) {
  return e.getFullYear();
});
GM.every = function(e) {
  return !isFinite(e = Math.floor(e)) || !(e > 0) ? null : fi(function(t) {
    t.setFullYear(Math.floor(t.getFullYear() / e) * e), t.setMonth(0, 1), t.setHours(0, 0, 0, 0);
  }, function(t, n) {
    t.setFullYear(t.getFullYear() + n * e);
  });
};
const Hg = GM;
GM.range;
var tte = fi(function(e) {
  e.setUTCSeconds(0, 0);
}, function(e, t) {
  e.setTime(+e + t * hf);
}, function(e, t) {
  return (t - e) / hf;
}, function(e) {
  return e.getUTCMinutes();
});
const LGe = tte;
tte.range;
var nte = fi(function(e) {
  e.setUTCMinutes(0, 0, 0);
}, function(e, t) {
  e.setTime(+e + t * aw);
}, function(e, t) {
  return (t - e) / aw;
}, function(e) {
  return e.getUTCHours();
});
const jGe = nte;
nte.range;
var rte = fi(function(e) {
  e.setUTCHours(0, 0, 0, 0);
}, function(e, t) {
  e.setUTCDate(e.getUTCDate() + t);
}, function(e, t) {
  return (t - e) / Hee;
}, function(e) {
  return e.getUTCDate() - 1;
});
const ite = rte;
rte.range;
function zf(e) {
  return fi(function(t) {
    t.setUTCDate(t.getUTCDate() - (t.getUTCDay() + 7 - e) % 7), t.setUTCHours(0, 0, 0, 0);
  }, function(t, n) {
    t.setUTCDate(t.getUTCDate() + n * 7);
  }, function(t, n) {
    return (n - t) / Uee;
  });
}
var cw = zf(0), Sv = zf(1), ote = zf(2), ate = zf(3), pf = zf(4), ste = zf(5), cte = zf(6);
cw.range;
Sv.range;
ote.range;
ate.range;
pf.range;
ste.range;
cte.range;
var lte = fi(function(e) {
  e.setUTCDate(1), e.setUTCHours(0, 0, 0, 0);
}, function(e, t) {
  e.setUTCMonth(e.getUTCMonth() + t);
}, function(e, t) {
  return t.getUTCMonth() - e.getUTCMonth() + (t.getUTCFullYear() - e.getUTCFullYear()) * 12;
}, function(e) {
  return e.getUTCMonth();
});
const FGe = lte;
lte.range;
var KM = fi(function(e) {
  e.setUTCMonth(0, 1), e.setUTCHours(0, 0, 0, 0);
}, function(e, t) {
  e.setUTCFullYear(e.getUTCFullYear() + t);
}, function(e, t) {
  return t.getUTCFullYear() - e.getUTCFullYear();
}, function(e) {
  return e.getUTCFullYear();
});
KM.every = function(e) {
  return !isFinite(e = Math.floor(e)) || !(e > 0) ? null : fi(function(t) {
    t.setUTCFullYear(Math.floor(t.getUTCFullYear() / e) * e), t.setUTCMonth(0, 1), t.setUTCHours(0, 0, 0, 0);
  }, function(t, n) {
    t.setUTCFullYear(t.getUTCFullYear() + n * e);
  });
};
const Ug = KM;
KM.range;
function pT(e) {
  if (0 <= e.y && e.y < 100) {
    var t = new Date(-1, e.m, e.d, e.H, e.M, e.S, e.L);
    return t.setFullYear(e.y), t;
  }
  return new Date(e.y, e.m, e.d, e.H, e.M, e.S, e.L);
}
function mT(e) {
  if (0 <= e.y && e.y < 100) {
    var t = new Date(Date.UTC(-1, e.m, e.d, e.H, e.M, e.S, e.L));
    return t.setUTCFullYear(e.y), t;
  }
  return new Date(Date.UTC(e.y, e.m, e.d, e.H, e.M, e.S, e.L));
}
function ym(e, t, n) {
  return { y: e, m: t, d: n, H: 0, M: 0, S: 0, L: 0 };
}
function VGe(e) {
  var t = e.dateTime, n = e.date, r = e.time, i = e.periods, o = e.days, a = e.shortDays, s = e.months, c = e.shortMonths, l = bm(i), u = _m(i), d = bm(o), f = _m(o), h = bm(a), p = _m(a), g = bm(s), m = _m(s), v = bm(c), y = _m(c), S = {
    a: F,
    A: V,
    b: j,
    B,
    c: null,
    d: i9,
    e: i9,
    f: lKe,
    g: bKe,
    G: SKe,
    H: aKe,
    I: sKe,
    j: cKe,
    L: ute,
    m: uKe,
    M: dKe,
    p: U,
    q: Q,
    Q: s9,
    s: c9,
    S: fKe,
    u: hKe,
    U: gKe,
    V: pKe,
    w: mKe,
    W: vKe,
    x: null,
    X: null,
    y: yKe,
    Y: _Ke,
    Z: wKe,
    "%": a9
  }, _ = {
    a: K,
    A: q,
    b: X,
    B: ie,
    c: null,
    d: o9,
    e: o9,
    f: TKe,
    g: DKe,
    G: jKe,
    H: xKe,
    I: EKe,
    j: CKe,
    L: fte,
    m: IKe,
    M: AKe,
    p: te,
    q: J,
    Q: s9,
    s: c9,
    S: RKe,
    u: $Ke,
    U: OKe,
    V: PKe,
    w: MKe,
    W: kKe,
    x: null,
    X: null,
    y: NKe,
    Y: LKe,
    Z: FKe,
    "%": a9
  }, w = {
    a: R,
    A,
    b: O,
    B: $,
    c: N,
    d: n9,
    e: n9,
    f: nKe,
    g: t9,
    G: e9,
    H: r9,
    I: r9,
    j: JGe,
    L: tKe,
    m: QGe,
    M: ZGe,
    p: E,
    q: XGe,
    Q: iKe,
    s: oKe,
    S: eKe,
    u: WGe,
    U: qGe,
    V: GGe,
    w: UGe,
    W: KGe,
    x: z,
    X: k,
    y: t9,
    Y: e9,
    Z: YGe,
    "%": rKe
  };
  S.x = T(n, S), S.X = T(r, S), S.c = T(t, S), _.x = T(n, _), _.X = T(r, _), _.c = T(t, _);
  function T(Y, ee) {
    return function(Z) {
      var H = [], oe = -1, W = 0, se = Y.length, ce, ge, he;
      for (Z instanceof Date || (Z = /* @__PURE__ */ new Date(+Z)); ++oe < se; )
        Y.charCodeAt(oe) === 37 && (H.push(Y.slice(W, oe)), (ge = ZF[ce = Y.charAt(++oe)]) != null ? ce = Y.charAt(++oe) : ge = ce === "e" ? " " : "0", (he = ee[ce]) && (ce = he(Z, ge)), H.push(ce), W = oe + 1);
      return H.push(Y.slice(W, oe)), H.join("");
    };
  }
  function x(Y, ee) {
    return function(Z) {
      var H = ym(1900, void 0, 1), oe = C(H, Y, Z += "", 0), W, se;
      if (oe != Z.length)
        return null;
      if ("Q" in H)
        return new Date(H.Q);
      if ("s" in H)
        return new Date(H.s * 1e3 + ("L" in H ? H.L : 0));
      if (ee && !("Z" in H) && (H.Z = 0), "p" in H && (H.H = H.H % 12 + H.p * 12), H.m === void 0 && (H.m = "q" in H ? H.q : 0), "V" in H) {
        if (H.V < 1 || H.V > 53)
          return null;
        "w" in H || (H.w = 1), "Z" in H ? (W = mT(ym(H.y, 0, 1)), se = W.getUTCDay(), W = se > 4 || se === 0 ? Sv.ceil(W) : Sv(W), W = ite.offset(W, (H.V - 1) * 7), H.y = W.getUTCFullYear(), H.m = W.getUTCMonth(), H.d = W.getUTCDate() + (H.w + 6) % 7) : (W = pT(ym(H.y, 0, 1)), se = W.getDay(), W = se > 4 || se === 0 ? _v.ceil(W) : _v(W), W = Yee.offset(W, (H.V - 1) * 7), H.y = W.getFullYear(), H.m = W.getMonth(), H.d = W.getDate() + (H.w + 6) % 7);
      } else
        ("W" in H || "U" in H) && ("w" in H || (H.w = "u" in H ? H.u % 7 : "W" in H ? 1 : 0), se = "Z" in H ? mT(ym(H.y, 0, 1)).getUTCDay() : pT(ym(H.y, 0, 1)).getDay(), H.m = 0, H.d = "W" in H ? (H.w + 6) % 7 + H.W * 7 - (se + 5) % 7 : H.w + H.U * 7 - (se + 6) % 7);
      return "Z" in H ? (H.H += H.Z / 100 | 0, H.M += H.Z % 100, mT(H)) : pT(H);
    };
  }
  function C(Y, ee, Z, H) {
    for (var oe = 0, W = ee.length, se = Z.length, ce, ge; oe < W; ) {
      if (H >= se)
        return -1;
      if (ce = ee.charCodeAt(oe++), ce === 37) {
        if (ce = ee.charAt(oe++), ge = w[ce in ZF ? ee.charAt(oe++) : ce], !ge || (H = ge(Y, Z, H)) < 0)
          return -1;
      } else if (ce != Z.charCodeAt(H++))
        return -1;
    }
    return H;
  }
  function E(Y, ee, Z) {
    var H = l.exec(ee.slice(Z));
    return H ? (Y.p = u.get(H[0].toLowerCase()), Z + H[0].length) : -1;
  }
  function R(Y, ee, Z) {
    var H = h.exec(ee.slice(Z));
    return H ? (Y.w = p.get(H[0].toLowerCase()), Z + H[0].length) : -1;
  }
  function A(Y, ee, Z) {
    var H = d.exec(ee.slice(Z));
    return H ? (Y.w = f.get(H[0].toLowerCase()), Z + H[0].length) : -1;
  }
  function O(Y, ee, Z) {
    var H = v.exec(ee.slice(Z));
    return H ? (Y.m = y.get(H[0].toLowerCase()), Z + H[0].length) : -1;
  }
  function $(Y, ee, Z) {
    var H = g.exec(ee.slice(Z));
    return H ? (Y.m = m.get(H[0].toLowerCase()), Z + H[0].length) : -1;
  }
  function N(Y, ee, Z) {
    return C(Y, t, ee, Z);
  }
  function z(Y, ee, Z) {
    return C(Y, n, ee, Z);
  }
  function k(Y, ee, Z) {
    return C(Y, r, ee, Z);
  }
  function F(Y) {
    return a[Y.getDay()];
  }
  function V(Y) {
    return o[Y.getDay()];
  }
  function j(Y) {
    return c[Y.getMonth()];
  }
  function B(Y) {
    return s[Y.getMonth()];
  }
  function U(Y) {
    return i[+(Y.getHours() >= 12)];
  }
  function Q(Y) {
    return 1 + ~~(Y.getMonth() / 3);
  }
  function K(Y) {
    return a[Y.getUTCDay()];
  }
  function q(Y) {
    return o[Y.getUTCDay()];
  }
  function X(Y) {
    return c[Y.getUTCMonth()];
  }
  function ie(Y) {
    return s[Y.getUTCMonth()];
  }
  function te(Y) {
    return i[+(Y.getUTCHours() >= 12)];
  }
  function J(Y) {
    return 1 + ~~(Y.getUTCMonth() / 3);
  }
  return {
    format: function(Y) {
      var ee = T(Y += "", S);
      return ee.toString = function() {
        return Y;
      }, ee;
    },
    parse: function(Y) {
      var ee = x(Y += "", !1);
      return ee.toString = function() {
        return Y;
      }, ee;
    },
    utcFormat: function(Y) {
      var ee = T(Y += "", _);
      return ee.toString = function() {
        return Y;
      }, ee;
    },
    utcParse: function(Y) {
      var ee = x(Y += "", !0);
      return ee.toString = function() {
        return Y;
      }, ee;
    }
  };
}
var ZF = { "-": "", _: " ", 0: "0" }, Pi = /^\s*\d+/, BGe = /^%/, zGe = /[\\^$*+?|[\]().{}]/g;
function Nn(e, t, n) {
  var r = e < 0 ? "-" : "", i = (r ? -e : e) + "", o = i.length;
  return r + (o < n ? new Array(n - o + 1).join(t) + i : i);
}
function HGe(e) {
  return e.replace(zGe, "\\$&");
}
function bm(e) {
  return new RegExp("^(?:" + e.map(HGe).join("|") + ")", "i");
}
function _m(e) {
  return new Map(e.map((t, n) => [t.toLowerCase(), n]));
}
function UGe(e, t, n) {
  var r = Pi.exec(t.slice(n, n + 1));
  return r ? (e.w = +r[0], n + r[0].length) : -1;
}
function WGe(e, t, n) {
  var r = Pi.exec(t.slice(n, n + 1));
  return r ? (e.u = +r[0], n + r[0].length) : -1;
}
function qGe(e, t, n) {
  var r = Pi.exec(t.slice(n, n + 2));
  return r ? (e.U = +r[0], n + r[0].length) : -1;
}
function GGe(e, t, n) {
  var r = Pi.exec(t.slice(n, n + 2));
  return r ? (e.V = +r[0], n + r[0].length) : -1;
}
function KGe(e, t, n) {
  var r = Pi.exec(t.slice(n, n + 2));
  return r ? (e.W = +r[0], n + r[0].length) : -1;
}
function e9(e, t, n) {
  var r = Pi.exec(t.slice(n, n + 4));
  return r ? (e.y = +r[0], n + r[0].length) : -1;
}
function t9(e, t, n) {
  var r = Pi.exec(t.slice(n, n + 2));
  return r ? (e.y = +r[0] + (+r[0] > 68 ? 1900 : 2e3), n + r[0].length) : -1;
}
function YGe(e, t, n) {
  var r = /^(Z)|([+-]\d\d)(?::?(\d\d))?/.exec(t.slice(n, n + 6));
  return r ? (e.Z = r[1] ? 0 : -(r[2] + (r[3] || "00")), n + r[0].length) : -1;
}
function XGe(e, t, n) {
  var r = Pi.exec(t.slice(n, n + 1));
  return r ? (e.q = r[0] * 3 - 3, n + r[0].length) : -1;
}
function QGe(e, t, n) {
  var r = Pi.exec(t.slice(n, n + 2));
  return r ? (e.m = r[0] - 1, n + r[0].length) : -1;
}
function n9(e, t, n) {
  var r = Pi.exec(t.slice(n, n + 2));
  return r ? (e.d = +r[0], n + r[0].length) : -1;
}
function JGe(e, t, n) {
  var r = Pi.exec(t.slice(n, n + 3));
  return r ? (e.m = 0, e.d = +r[0], n + r[0].length) : -1;
}
function r9(e, t, n) {
  var r = Pi.exec(t.slice(n, n + 2));
  return r ? (e.H = +r[0], n + r[0].length) : -1;
}
function ZGe(e, t, n) {
  var r = Pi.exec(t.slice(n, n + 2));
  return r ? (e.M = +r[0], n + r[0].length) : -1;
}
function eKe(e, t, n) {
  var r = Pi.exec(t.slice(n, n + 2));
  return r ? (e.S = +r[0], n + r[0].length) : -1;
}
function tKe(e, t, n) {
  var r = Pi.exec(t.slice(n, n + 3));
  return r ? (e.L = +r[0], n + r[0].length) : -1;
}
function nKe(e, t, n) {
  var r = Pi.exec(t.slice(n, n + 6));
  return r ? (e.L = Math.floor(r[0] / 1e3), n + r[0].length) : -1;
}
function rKe(e, t, n) {
  var r = BGe.exec(t.slice(n, n + 1));
  return r ? n + r[0].length : -1;
}
function iKe(e, t, n) {
  var r = Pi.exec(t.slice(n));
  return r ? (e.Q = +r[0], n + r[0].length) : -1;
}
function oKe(e, t, n) {
  var r = Pi.exec(t.slice(n));
  return r ? (e.s = +r[0], n + r[0].length) : -1;
}
function i9(e, t) {
  return Nn(e.getDate(), t, 2);
}
function aKe(e, t) {
  return Nn(e.getHours(), t, 2);
}
function sKe(e, t) {
  return Nn(e.getHours() % 12 || 12, t, 2);
}
function cKe(e, t) {
  return Nn(1 + Yee.count(Hg(e), e), t, 3);
}
function ute(e, t) {
  return Nn(e.getMilliseconds(), t, 3);
}
function lKe(e, t) {
  return ute(e, t) + "000";
}
function uKe(e, t) {
  return Nn(e.getMonth() + 1, t, 2);
}
function dKe(e, t) {
  return Nn(e.getMinutes(), t, 2);
}
function fKe(e, t) {
  return Nn(e.getSeconds(), t, 2);
}
function hKe(e) {
  var t = e.getDay();
  return t === 0 ? 7 : t;
}
function gKe(e, t) {
  return Nn(sw.count(Hg(e) - 1, e), t, 2);
}
function dte(e) {
  var t = e.getDay();
  return t >= 4 || t === 0 ? gf(e) : gf.ceil(e);
}
function pKe(e, t) {
  return e = dte(e), Nn(gf.count(Hg(e), e) + (Hg(e).getDay() === 4), t, 2);
}
function mKe(e) {
  return e.getDay();
}
function vKe(e, t) {
  return Nn(_v.count(Hg(e) - 1, e), t, 2);
}
function yKe(e, t) {
  return Nn(e.getFullYear() % 100, t, 2);
}
function bKe(e, t) {
  return e = dte(e), Nn(e.getFullYear() % 100, t, 2);
}
function _Ke(e, t) {
  return Nn(e.getFullYear() % 1e4, t, 4);
}
function SKe(e, t) {
  var n = e.getDay();
  return e = n >= 4 || n === 0 ? gf(e) : gf.ceil(e), Nn(e.getFullYear() % 1e4, t, 4);
}
function wKe(e) {
  var t = e.getTimezoneOffset();
  return (t > 0 ? "-" : (t *= -1, "+")) + Nn(t / 60 | 0, "0", 2) + Nn(t % 60, "0", 2);
}
function o9(e, t) {
  return Nn(e.getUTCDate(), t, 2);
}
function xKe(e, t) {
  return Nn(e.getUTCHours(), t, 2);
}
function EKe(e, t) {
  return Nn(e.getUTCHours() % 12 || 12, t, 2);
}
function CKe(e, t) {
  return Nn(1 + ite.count(Ug(e), e), t, 3);
}
function fte(e, t) {
  return Nn(e.getUTCMilliseconds(), t, 3);
}
function TKe(e, t) {
  return fte(e, t) + "000";
}
function IKe(e, t) {
  return Nn(e.getUTCMonth() + 1, t, 2);
}
function AKe(e, t) {
  return Nn(e.getUTCMinutes(), t, 2);
}
function RKe(e, t) {
  return Nn(e.getUTCSeconds(), t, 2);
}
function $Ke(e) {
  var t = e.getUTCDay();
  return t === 0 ? 7 : t;
}
function OKe(e, t) {
  return Nn(cw.count(Ug(e) - 1, e), t, 2);
}
function hte(e) {
  var t = e.getUTCDay();
  return t >= 4 || t === 0 ? pf(e) : pf.ceil(e);
}
function PKe(e, t) {
  return e = hte(e), Nn(pf.count(Ug(e), e) + (Ug(e).getUTCDay() === 4), t, 2);
}
function MKe(e) {
  return e.getUTCDay();
}
function kKe(e, t) {
  return Nn(Sv.count(Ug(e) - 1, e), t, 2);
}
function NKe(e, t) {
  return Nn(e.getUTCFullYear() % 100, t, 2);
}
function DKe(e, t) {
  return e = hte(e), Nn(e.getUTCFullYear() % 100, t, 2);
}
function LKe(e, t) {
  return Nn(e.getUTCFullYear() % 1e4, t, 4);
}
function jKe(e, t) {
  var n = e.getUTCDay();
  return e = n >= 4 || n === 0 ? pf(e) : pf.ceil(e), Nn(e.getUTCFullYear() % 1e4, t, 4);
}
function FKe() {
  return "+0000";
}
function a9() {
  return "%";
}
function s9(e) {
  return +e;
}
function c9(e) {
  return Math.floor(+e / 1e3);
}
var lh, BE, gte, pte, mte;
VKe({
  dateTime: "%x, %X",
  date: "%-m/%-d/%Y",
  time: "%-I:%M:%S %p",
  periods: ["AM", "PM"],
  days: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
  shortDays: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  months: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
  shortMonths: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]
});
function VKe(e) {
  return lh = VGe(e), BE = lh.format, gte = lh.parse, pte = lh.utcFormat, mte = lh.utcParse, lh;
}
function BKe(e) {
  return new Date(e);
}
function zKe(e) {
  return e instanceof Date ? +e : +/* @__PURE__ */ new Date(+e);
}
function YM(e, t, n, r, i, o, a, s, c, l) {
  var u = RM(), d = u.invert, f = u.domain, h = l(".%L"), p = l(":%S"), g = l("%I:%M"), m = l("%I %p"), v = l("%a %d"), y = l("%b %d"), S = l("%B"), _ = l("%Y");
  function w(T) {
    return (c(T) < T ? h : s(T) < T ? p : a(T) < T ? g : o(T) < T ? m : r(T) < T ? i(T) < T ? v : y : n(T) < T ? S : _)(T);
  }
  return u.invert = function(T) {
    return new Date(d(T));
  }, u.domain = function(T) {
    return arguments.length ? f(Array.from(T, zKe)) : f().map(BKe);
  }, u.ticks = function(T) {
    var x = f();
    return e(x[0], x[x.length - 1], T ?? 10);
  }, u.tickFormat = function(T, x) {
    return x == null ? w : l(x);
  }, u.nice = function(T) {
    var x = f();
    return (!T || typeof T.range != "function") && (T = t(x[0], x[x.length - 1], T ?? 10)), T ? f(Nee(x, T)) : u;
  }, u.copy = function() {
    return Iy(u, YM(e, t, n, r, i, o, a, s, c, l));
  }, u;
}
function vte() {
  return Xa.apply(YM(PGe, MGe, FE, WM, HM, zM, VM, jM, Id, BE).domain([new Date(2e3, 0, 1), new Date(2e3, 0, 2)]), arguments);
}
function yte() {
  return Xa.apply(YM($Ge, OGe, VE, qM, UM, Vee, BM, FM, Id, pte).domain([Date.UTC(2e3, 0, 1), Date.UTC(2e3, 0, 2)]), arguments);
}
function zE() {
  var e = 0, t = 1, n, r, i, o, a = Ro, s = !1, c;
  function l(d) {
    return d == null || isNaN(d = +d) ? c : a(i === 0 ? 0.5 : (d = (o(d) - n) * i, s ? Math.max(0, Math.min(1, d)) : d));
  }
  l.domain = function(d) {
    return arguments.length ? ([e, t] = d, n = o(e = +e), r = o(t = +t), i = n === r ? 0 : 1 / (r - n), l) : [e, t];
  }, l.clamp = function(d) {
    return arguments.length ? (s = !!d, l) : s;
  }, l.interpolator = function(d) {
    return arguments.length ? (a = d, l) : a;
  };
  function u(d) {
    return function(f) {
      var h, p;
      return arguments.length ? ([h, p] = f, a = d(h, p), l) : [a(0), a(1)];
    };
  }
  return l.range = u(wc), l.rangeRound = u(SM), l.unknown = function(d) {
    return arguments.length ? (c = d, l) : c;
  }, function(d) {
    return o = d, n = d(e), r = d(t), i = n === r ? 0 : 1 / (r - n), l;
  };
}
function Ku(e, t) {
  return t.domain(e.domain()).interpolator(e.interpolator()).clamp(e.clamp()).unknown(e.unknown());
}
function bte() {
  var e = Gu(zE()(Ro));
  return e.copy = function() {
    return Ku(e, bte());
  }, yl.apply(e, arguments);
}
function _te() {
  var e = OM(zE()).domain([1, 10]);
  return e.copy = function() {
    return Ku(e, _te()).base(e.base());
  }, yl.apply(e, arguments);
}
function Ste() {
  var e = MM(zE());
  return e.copy = function() {
    return Ku(e, Ste()).constant(e.constant());
  }, yl.apply(e, arguments);
}
function XM() {
  var e = NM(zE());
  return e.copy = function() {
    return Ku(e, XM()).exponent(e.exponent());
  }, yl.apply(e, arguments);
}
function HKe() {
  return XM.apply(null, arguments).exponent(0.5);
}
function wte() {
  var e = [], t = Ro;
  function n(r) {
    if (r != null && !isNaN(r = +r))
      return t((Ty(e, r, 1) - 1) / (e.length - 1));
  }
  return n.domain = function(r) {
    if (!arguments.length)
      return e.slice();
    e = [];
    for (let i of r)
      i != null && !isNaN(i = +i) && e.push(i);
    return e.sort(lu), n;
  }, n.interpolator = function(r) {
    return arguments.length ? (t = r, n) : t;
  }, n.range = function() {
    return e.map((r, i) => t(i / (e.length - 1)));
  }, n.quantiles = function(r) {
    return Array.from({ length: r + 1 }, (i, o) => Wqe(e, o / r));
  }, n.copy = function() {
    return wte(t).domain(e);
  }, yl.apply(n, arguments);
}
function HE() {
  var e = 0, t = 0.5, n = 1, r = 1, i, o, a, s, c, l = Ro, u, d = !1, f;
  function h(g) {
    return isNaN(g = +g) ? f : (g = 0.5 + ((g = +u(g)) - o) * (r * g < r * o ? s : c), l(d ? Math.max(0, Math.min(1, g)) : g));
  }
  h.domain = function(g) {
    return arguments.length ? ([e, t, n] = g, i = u(e = +e), o = u(t = +t), a = u(n = +n), s = i === o ? 0 : 0.5 / (o - i), c = o === a ? 0 : 0.5 / (a - o), r = o < i ? -1 : 1, h) : [e, t, n];
  }, h.clamp = function(g) {
    return arguments.length ? (d = !!g, h) : d;
  }, h.interpolator = function(g) {
    return arguments.length ? (l = g, h) : l;
  };
  function p(g) {
    return function(m) {
      var v, y, S;
      return arguments.length ? ([v, y, S] = m, l = Mze(g, [v, y, S]), h) : [l(0), l(0.5), l(1)];
    };
  }
  return h.range = p(wc), h.rangeRound = p(SM), h.unknown = function(g) {
    return arguments.length ? (f = g, h) : f;
  }, function(g) {
    return u = g, i = g(e), o = g(t), a = g(n), s = i === o ? 0 : 0.5 / (o - i), c = o === a ? 0 : 0.5 / (a - o), r = o < i ? -1 : 1, h;
  };
}
function xte() {
  var e = Gu(HE()(Ro));
  return e.copy = function() {
    return Ku(e, xte());
  }, yl.apply(e, arguments);
}
function Ete() {
  var e = OM(HE()).domain([0.1, 1, 10]);
  return e.copy = function() {
    return Ku(e, Ete()).base(e.base());
  }, yl.apply(e, arguments);
}
function Cte() {
  var e = MM(HE());
  return e.copy = function() {
    return Ku(e, Cte()).constant(e.constant());
  }, yl.apply(e, arguments);
}
function QM() {
  var e = NM(HE());
  return e.copy = function() {
    return Ku(e, QM()).exponent(e.exponent());
  }, yl.apply(e, arguments);
}
function UKe() {
  return QM.apply(null, arguments).exponent(0.5);
}
const WKe = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  scaleBand: LE,
  scaleDiverging: xte,
  scaleDivergingLog: Ete,
  scaleDivergingPow: QM,
  scaleDivergingSqrt: UKe,
  scaleDivergingSymlog: Cte,
  scaleIdentity: kee,
  scaleImplicit: BR,
  scaleLinear: Ry,
  scaleLog: PM,
  scaleOrdinal: Gc,
  scalePoint: $ee,
  scalePow: DM,
  scaleQuantile: Lee,
  scaleQuantize: jee,
  scaleRadial: Dee,
  scaleSequential: bte,
  scaleSequentialLog: _te,
  scaleSequentialPow: XM,
  scaleSequentialQuantile: wte,
  scaleSequentialSqrt: HKe,
  scaleSequentialSymlog: Ste,
  scaleSqrt: mGe,
  scaleSymlog: kM,
  scaleThreshold: Fee,
  scaleTime: vte,
  scaleUtc: yte,
  tickFormat: Mee
}, Symbol.toStringTag, { value: "Module" })), qKe = ["linear", "time", "log", "sqrt"];
function GKe(e) {
  return `scale${((n) => n && n[0].toUpperCase() + n.slice(1))(e)}`;
}
function Tte(e) {
  return typeof e == "function" ? Rn(e.copy) && Rn(e.domain) && Rn(e.range) : typeof e == "string" ? qKe.includes(e) : !1;
}
function Ite(e, t) {
  if (e.scale) {
    if (e.scale.x || e.scale.y)
      return !!e.scale[t];
  } else
    return !1;
  return !0;
}
function KKe(e, t) {
  if (!Ite(e, t))
    return;
  const n = e.scale[t] || e.scale;
  return typeof n == "string" ? n : Rte(n);
}
function YKe(e, t) {
  let n;
  if (e.domain && e.domain[t] ? n = e.domain[t] : e.domain && Array.isArray(e.domain) && (n = e.domain), !!n)
    return Iu(n) ? "time" : "linear";
}
function Ate(e, t) {
  if (!e.data)
    return "linear";
  const n = DE(e[t]), r = e.data.map((i) => {
    const o = ti(n(i)) ? n(i)[t] : n(i);
    return o !== void 0 ? o : i[t];
  });
  return Iu(r) ? "time" : "linear";
}
function wv(e) {
  if (Tte(e)) {
    const t = GKe(e);
    return WKe[t]();
  }
  return Ry();
}
function ea(e, t) {
  const n = mf(e, t);
  if (n)
    return typeof n == "string" ? wv(n) : n;
  const r = YKe(e, t) || Ate(e, t);
  return wv(r);
}
function mf(e, t) {
  if (!Ite(e, t))
    return;
  const n = e.scale[t] || e.scale;
  if (Tte(n))
    return Rn(n) ? n : wv(n);
}
function lw(e, t) {
  return KKe(e, t) || Ate(e, t);
}
const XKe = [
  {
    name: "quantile",
    method: "quantiles"
  },
  {
    name: "log",
    method: "base"
  }
  // TODO(2214): Re-evaluate (1) duck typing approach, and (2) if duck typing,
  //   do we need a different approach? (Multiple keys? Stringifying functions?)
  // https://github.com/FormidableLabs/victory/issues/2214
  // Below are matches that don't seem to otherwise occur in Victory code base.
  // { name: "ordinal", method: "unknown" },
  // { name: "pow-sqrt", method: "exponent" },
  // { name: "quantize-threshold", method: "invertExtent" }
];
function Rte(e) {
  if (typeof e == "string")
    return e;
  const t = XKe.filter((n) => e[n.method] !== void 0)[0];
  return t ? t.name : void 0;
}
const QKe = "@@__IMMUTABLE_ITERABLE__@@", JKe = "@@__IMMUTABLE_RECORD__@@", ZKe = "@@__IMMUTABLE_LIST__@@";
function $y(e) {
  return !!(e && e[QKe]);
}
function eYe(e) {
  return !!(e && e[JKe]);
}
function tYe(e) {
  return $y(e) || eYe(e);
}
function nYe(e) {
  return !!(e && e[ZKe]);
}
function $te(e, t) {
  return $y(e) ? e.reduce((n, r, i) => {
    let o = r;
    return t && t[i] && (o = $te(r)), n[i] = o, n;
  }, nYe(e) ? [] : {}) : e;
}
function HR(e) {
  const t = {
    errorX: !0,
    errorY: !0
  };
  return tYe(e) ? $te(e, t) : e;
}
function rYe(e) {
  return $y(e) ? e.size : e.length;
}
function l9(e, t) {
  const r = (ti(e.domain) ? e.domain[t] : e.domain) || ea(e, t).domain(), i = e.samples || 1, o = Math.max(...r), a = Math.min(...r), s = (o - a) / i, c = EM(a, o, s);
  return c[c.length - 1] === o ? c : c.concat(o);
}
function Ote(e, t, n) {
  if (n === void 0 && (n = "ascending"), !t)
    return e;
  let r = t;
  return (t === "x" || t === "y") && (r = `_${t}`), wy(e, r, n === "ascending" ? "asc" : "desc");
}
function iYe(e, t) {
  const n = 1 / Number.MAX_SAFE_INTEGER, r = {
    x: lw(t, "x"),
    y: lw(t, "y")
  };
  if (r.x !== "log" && r.y !== "log")
    return e;
  const i = (a, s) => r[s] === "log" ? a[`_${s}`] !== 0 : !0, o = (a) => {
    const s = i(a, "x") ? a._x : n, c = i(a, "y") ? a._y : n, l = i(a, "y0") ? a._y0 : n;
    return Object.assign({}, a, {
      _x: s,
      _y: c,
      _y0: l
    });
  };
  return e.map((a) => i(a, "x") && i(a, "y") && i(a, "y0") ? a : o(a));
}
function oYe(e) {
  return Rn(e) ? e : e == null ? () => {
  } : PZ(e);
}
function aYe(e, t) {
  const n = !!e.eventKey, r = oYe(e.eventKey);
  return t.map((i, o) => {
    if (i.eventKey !== void 0)
      return i;
    if (n) {
      const a = r(i, o);
      return a !== void 0 ? Object.assign({
        eventKey: a
      }, i) : i;
    }
    return i;
  });
}
function Pte(e, t, n) {
  const r = (p) => p !== void 0, i = Sa(t.x), o = _a(t.x), a = Sa(t.y), s = _a(t.y), c = (p) => (g) => r(g) && g < p, l = (p) => (g) => r(g) && g > p, u = c(i), d = c(a), f = l(o), h = l(s);
  return e.map((p) => {
    let {
      _x: g,
      _y: m,
      _y0: v,
      _y1: y
    } = p;
    (u(g) || f(g)) && (g = null);
    const S = r(v) ? v : n, _ = r(y) ? y : m;
    return r(_) ? (!r(S) && (d(_) || h(_)) && (m = null), (d(S) && d(_) || h(S) && h(_)) && (m = v = y = null), d(S) && !d(_) && (v = a), h(S) && !h(_) && (v = s), Object.assign({}, p, hee({
      _x: g,
      _y: m,
      _y0: v,
      _y1: y
    }, Pqe))) : p;
  });
}
function vT(e, t) {
  const n = kte(e, t), r = Wg(e, t), i = sYe(e, t), o = dl([...n, ...r, ...i]);
  return o.length === 0 ? null : o.reduce((a, s, c) => (a[s] = c + 1, a), {});
}
function uw(e, t, n) {
  if (!(Array.isArray(e) || $y(e)) || rYe(e) < 1)
    return [];
  const i = ["x", "y", "y0"];
  n = Array.isArray(n) ? n : i;
  const o = (f) => DE(t[f] !== void 0 ? t[f] : f), a = n.reduce((f, h) => (f[h] = o(h), f), {}), s = Rqe(n, i) && t.x === "_x" && t.y === "_y" && t.y0 === "_y0";
  let c;
  s === !1 && (c = {
    x: n.indexOf("x") !== -1 ? vT(t, "x") : void 0,
    y: n.indexOf("y") !== -1 ? vT(t, "y") : void 0,
    y0: n.indexOf("y0") !== -1 ? vT(t, "y") : void 0
  });
  const l = s ? e : e.reduce((f, h, p) => {
    const g = HR(h), m = {
      x: p,
      y: g
    }, v = n.reduce((S, _) => {
      const w = a[_](g), T = w !== void 0 ? w : m[_];
      return T !== void 0 && (typeof T == "string" && c[_] ? (S[`${_}Name`] = T, S[`_${_}`] = c[_][T]) : S[`_${_}`] = T), S;
    }, {}), y = Object.assign({}, v, g);
    return Lr(y) || f.push(y), f;
  }, []), u = Ote(l, t.sortKey, t.sortOrder), d = iYe(u, t);
  return aYe(t, d);
}
function Mte(e) {
  const t = l9(e, "x"), n = l9(e, "y");
  return t.map((i, o) => ({
    x: i,
    y: n[o]
  }));
}
function JM(e, t) {
  return e.categories && !Array.isArray(e.categories) ? e.categories[t] : e.categories;
}
function Mo(e) {
  return e.data ? uw(e.data, e) : uw(Mte(e), e);
}
function kte(e, t) {
  const {
    tickValues: n,
    tickFormat: r
  } = e;
  let i;
  return !n || !Array.isArray(n) && !n[t] ? i = r && Array.isArray(r) ? r : [] : i = n[t] || n, i.filter((o) => typeof o == "string");
}
function Wg(e, t) {
  if (!e.categories)
    return [];
  const n = JM(e, t), r = n && n.filter((i) => typeof i == "string");
  return r ? QUe(r) : [];
}
function sYe(e, t) {
  if (!(Array.isArray(e.data) || $y(e.data)))
    return [];
  const r = e[t] === void 0 ? t : e[t], i = DE(r), o = e.data.reduce((c, l) => (c.push(HR(l)), c), []);
  return Ote(o, e.sortKey, e.sortOrder).reduce((c, l) => {
    const u = HR(l);
    return c.push(i(u)), c;
  }, []).filter((c) => typeof c == "string").reduce((c, l) => (l != null && c.indexOf(l) === -1 && c.push(l), c), []);
}
function Nte(e) {
  const t = (i) => i && i.type ? i.type.role : "";
  let n = t(e);
  if (n === "portal") {
    const i = D.Children.toArray(e.props.children);
    n = i.length ? t(i[0]) : "";
  }
  return ["area", "bar", "boxplot", "candlestick", "errorbar", "group", "histogram", "line", "pie", "scatter", "stack", "voronoi"].includes(n);
}
function cYe(e, t, n) {
  return lw(t, n) !== "log" ? e : ((o) => {
    const a = o[0] < 0 || o[1] < 0 ? -1 / Number.MAX_SAFE_INTEGER : 1 / Number.MAX_SAFE_INTEGER, s = o[0] === 0 ? a : o[0], c = o[1] === 0 ? a : o[1];
    return [s, c];
  })(e);
}
function lYe(e, t) {
  const n = (r) => Array.isArray(r) ? {
    left: r[0],
    right: r[1]
  } : {
    left: r,
    right: r
  };
  return ti(e.domainPadding) ? n(e.domainPadding[t]) : n(e.domainPadding);
}
function uYe(e, t) {
  const n = `_${t}`;
  return e.flat().map((r) => r[n] && r[n][1] !== void 0 ? r[n][1] : r[n]);
}
function u9(e, t, n) {
  n === void 0 && (n = "min");
  const r = (s) => n === "max" ? Math.max(...s) : Math.min(...s), i = n === "max" ? -1 / 0 : 1 / 0;
  let o = !1;
  const a = e.flat().reduce((s, c) => {
    const l = c[`_${t}0`] !== void 0 ? c[`_${t}0`] : c[`_${t}`], u = c[`_${t}1`] !== void 0 ? c[`_${t}1`] : c[`_${t}`], d = r([l, u]);
    return o = o || l instanceof Date || u instanceof Date, r([s, d]);
  }, i);
  return o ? new Date(a) : a;
}
function dYe(e, t, n) {
  if (!t.domainPadding)
    return e;
  const r = Xu(t, n), i = Yu(t, n), o = lYe(t, n);
  if (!o.left && !o.right)
    return e;
  const a = Sa(e), s = _a(e), c = oee(n, t.horizontal), l = Pr(t, c), u = Math.abs(l[0] - l[1]), d = Math.max(u - o.left - o.right, 1), f = Math.abs(s.valueOf() - a.valueOf()) / d * u, h = {
    left: f * o.left / u,
    right: f * o.right / u
  };
  let p = {
    min: a.valueOf() - h.left,
    max: s.valueOf() + h.right
  };
  const g = ti(t.singleQuadrantDomainPadding) ? t.singleQuadrantDomainPadding[n] : t.singleQuadrantDomainPadding, m = a.valueOf() >= 0 && p.min <= 0 || s.valueOf() <= 0 && p.max >= 0, v = (S, _) => _ === "min" && a.valueOf() >= 0 && S <= 0 || _ === "max" && s.valueOf() <= 0 && S >= 0 ? 0 : S;
  if (m && g !== !1) {
    const S = {
      // @ts-expect-error `max/min` might be dates
      left: Math.abs(s - a) * o.left / u,
      // @ts-expect-error `max/min` might be dates
      right: Math.abs(s - a) * o.right / u
    }, _ = {
      min: v(a.valueOf() - S.left, "min"),
      max: v(s.valueOf() + S.right, "max")
    }, w = {
      left: Math.abs(_.max - _.min) * o.left / u,
      right: Math.abs(_.max - _.min) * o.right / u
    };
    p = {
      min: v(a.valueOf() - w.left, "min"),
      max: v(s.valueOf() + w.right, "max")
    };
  }
  const y = {
    min: r !== void 0 ? r : p.min,
    max: i !== void 0 ? i : p.max
  };
  return a instanceof Date || s instanceof Date ? Es(new Date(y.min), new Date(y.max)) : Es(y.min, y.max);
}
function UE(e, t) {
  const n = Rn(e) ? e : e3, r = Rn(t) ? t : ZM;
  return (i, o) => {
    const a = t3(i, o);
    if (a)
      return r(a, i, o);
    const s = JM(i, o), c = s ? fYe(i, o, s) : n(i, o);
    return c ? r(c, i, o) : void 0;
  };
}
function ZM(e, t, n) {
  return cYe(dYe(e, t, n), t, n);
}
function vf(e, t) {
  return UE()(e, t);
}
function fYe(e, t, n) {
  const r = n || JM(e, t), {
    polar: i,
    startAngle: o = 0,
    endAngle: a = 360
  } = e;
  if (!r)
    return;
  const s = Xu(e, t), c = Yu(e, t), l = XS(r) ? Wg(e, t) : [], u = l.length === 0 ? null : l.reduce((g, m, v) => (g[m] = v + 1, g), {}), d = u ? r.map((g) => u[g]) : r, f = s !== void 0 ? s : Sa(d), h = c !== void 0 ? c : _a(d), p = Es(f, h);
  return i && t === "x" && Math.abs(o - a) === 360 ? n3(p, d) : p;
}
function e3(e, t, n) {
  const r = n || Mo(e), {
    polar: i,
    startAngle: o = 0,
    endAngle: a = 360
  } = e, s = Xu(e, t), c = Yu(e, t);
  if (r.length < 1)
    return s !== void 0 && c !== void 0 ? Es(s, c) : void 0;
  const l = s !== void 0 ? s : u9(r, t, "min"), u = c !== void 0 ? c : u9(r, t, "max"), d = Es(l, u);
  return i && t === "x" && Math.abs(o - a) === 360 ? n3(d, uYe(r, t)) : d;
}
function Es(e, t) {
  const n = (r) => {
    const i = (
      // eslint-disable-next-line no-magic-numbers
      r === 0 ? 2 * Math.pow(10, -10) : Math.pow(10, -10)
    ), o = 1, a = r instanceof Date ? new Date(Number(r) - o) : Number(r) - i, s = r instanceof Date ? new Date(Number(r) + o) : Number(r) + i;
    return r === 0 ? [0, s] : [a, s];
  };
  return Number(e) === Number(t) ? n(t) : [e, t];
}
function t3(e, t) {
  const n = Xu(e, t), r = Yu(e, t);
  if (ti(e.domain) && e.domain[t])
    return e.domain[t];
  if (Array.isArray(e.domain))
    return e.domain;
  if (n !== void 0 && r !== void 0)
    return Es(n, r);
}
function UR(e, t) {
  const n = t3(e, t);
  if (n)
    return n;
  const r = Mo(e), i = r.reduce((c, l) => l._y0 < c ? l._y0 : c, 1 / 0), o = (c) => {
    if (t === "x")
      return c;
    const l = i !== 1 / 0 ? i : 0, u = Yu(e, t), d = Xu(e, t), f = u !== void 0 ? u : _a(c, l), h = d !== void 0 ? d : Sa(c, l);
    return Es(h, f);
  };
  return UE(() => e3(e, t, r), (c) => ZM(o(c), e, t))(e, t);
}
function Yu(e, t) {
  return ti(e.maxDomain) && e.maxDomain[t] !== void 0 ? e.maxDomain[t] : typeof e.maxDomain == "number" || Cee(e.maxDomain) ? e.maxDomain : void 0;
}
function Xu(e, t) {
  return ti(e.minDomain) && e.minDomain[t] !== void 0 ? e.minDomain[t] : typeof e.minDomain == "number" || Cee(e.minDomain) ? e.minDomain : void 0;
}
function n3(e, t) {
  const n = Cqe(t.sort((i, o) => i - o)), r = n[1] - n[0];
  return [e[0], e[1] + r];
}
function Dte(e) {
  const t = (i) => i && i.type ? i.type.role : "";
  let n = t(e);
  if (n === "portal") {
    const i = D.Children.toArray(e.props.children);
    n = i.length ? t(i[0]) : "";
  }
  return ["area", "axis", "bar", "boxplot", "candlestick", "errorbar", "group", "histogram", "line", "pie", "scatter", "stack", "voronoi"].includes(n);
}
function hYe(e) {
  return e;
}
function Qa(e) {
  const {
    dependentAxis: t
  } = e;
  return t ? "y" : "x";
}
function Lte(e, t) {
  const n = t || hYe, r = (i) => i.reduce((o, a) => a.type && a.type.role === "axis" && n(a) ? o.concat(a) : a.props && a.props.children ? o.concat(r(D.Children.toArray(a.props.children))) : o, []);
  return r(e);
}
function jte(e, t) {
  return Lte(e, (r) => r.type.getAxis(r.props) === t)[0];
}
function d9(e, t) {
  const n = (i) => t === "dependent" ? i.props.dependentAxis : !i.props.dependentAxis, r = (i) => i.reduce((o, a) => a.type && a.type.role === "axis" && n(a) || a.props && a.props.children && r(D.Children.toArray(a.props.children)).length > 0 ? o.concat(a) : o, []);
  return r(e);
}
function Fte(e) {
  const t = (n) => {
    const r = Math.min(...n), i = Math.max(...n);
    return i < 0 ? i : Math.max(0, r);
  };
  return {
    x: Iu(e.x) ? new Date(Math.min(...e.x)) : t(e.x),
    y: Iu(e.y) ? new Date(Math.min(...e.y)) : t(e.y)
  };
}
function f9(e, t) {
  const n = () => e <= 0 && Math.max(...t) <= 0 ? "negative" : "positive";
  return Iu(t) ? "positive" : n();
}
function WE(e) {
  const t = e.orientation || (e.dependentAxis ? "left" : "bottom");
  return {
    top: !1,
    bottom: !1,
    left: !0,
    right: !0
  }[t];
}
function qE(e) {
  return e.tickValues !== void 0 && XS(e.tickValues);
}
function gYe(e) {
  const {
    tickValues: t
  } = e, n = Qa(e), r = e.stringMap && e.stringMap[n], i = t && !Iu(t) ? (l) => l : void 0;
  if (!r)
    return qE(e) ? (l, u) => t[u] : i;
  const o = r && ree(r), c = ["", ...wy(Object.values(r), (l) => l).map((l) => o[l]), ""];
  return (l) => c[l];
}
function pYe(e) {
  const t = Qa(e), n = e.stringMap && e.stringMap[t], r = Array.isArray(e.categories) ? e.categories : e.categories && e.categories[t], i = r && XUe(r) ? r.map((a) => n[a]) : void 0, o = n && Object.values(n);
  return i && i.length !== 0 ? i : o;
}
function r3(e) {
  const {
    tickValues: t,
    tickFormat: n
  } = e;
  if ((t == null ? void 0 : t.length) === 0)
    return [];
  const r = Qa(e), i = e.stringMap && e.stringMap[r], o = () => {
    if (!(!n || !Array.isArray(n)))
      return XS(n) ? n.map((l, u) => u) : n;
  };
  let a = t;
  i && (a = pYe(e)), t && XS(t) && (a = i ? t.map((l) => i[l]) : EM(1, t.length + 1));
  const s = a ? dl(a) : o(), c = (l) => {
    const u = [], d = e.domain && e.domain[r] || e.domain;
    if (l)
      return l.forEach((f, h) => {
        Array.isArray(d) ? f >= Sa(d).valueOf() && f <= _a(d).valueOf() && u.push({
          value: f,
          index: h
        }) : u.push({
          value: f,
          index: h
        });
      }), u;
  };
  return Array.isArray(s) && s.length ? c(s) : void 0;
}
function Vte(e, t) {
  const {
    tickFormat: n
  } = e, r = Qa(e), i = e.stringMap && e.stringMap[r];
  if (n) {
    if (n && Array.isArray(n)) {
      const o = r3(e), a = o == null ? void 0 : o.map((c) => c.index), s = n.filter((c, l) => a == null ? void 0 : a.includes(l));
      return (c, l) => s[l];
    } else if (n && Rn(n))
      return i ? (a, s, c) => {
        const l = ree(i), u = c.map((d) => l[d]);
        return e.tickFormat(l[a], s, u);
      } : n;
  } else {
    const o = gYe(e), a = t.tickFormat && Rn(t.tickFormat) ? t.tickFormat() : (s) => s;
    return o || a;
  }
  return (o) => o;
}
function h9(e, t) {
  if (!t || !Array.isArray(e) || e.length <= t)
    return e;
  const n = Math.floor(e.length / t);
  return e.filter((r, i) => i % n === 0);
}
function Bte(e, t, n) {
  n === void 0 && (n = !1);
  const {
    tickCount: r
  } = e, i = r3(e);
  if ((i == null ? void 0 : i.length) === 0)
    return [""];
  const o = i ? i.map((a) => a.value) : void 0;
  if (o)
    return h9(o, r);
  if (t.ticks && Rn(t.ticks)) {
    const a = r || 5, s = t.ticks(a), c = Array.isArray(s) && s.length ? s : t.domain(), l = h9(c, r);
    if (n) {
      const u = l.filter((d) => d !== 0);
      return u.length ? u : l;
    }
    return l;
  }
  return t.domain();
}
function mYe(e, t) {
  const {
    polar: n,
    startAngle: r = 0,
    endAngle: i = 360
  } = e, o = r3(e), a = o && (o == null ? void 0 : o.length) !== 0 ? o.map((v) => v.value) : void 0;
  if (!Array.isArray(a))
    return;
  const s = Xu(e, t), c = Yu(e, t), l = qE(e), u = a.map((v) => Number(v)), d = l ? 1 : Sa(u), f = l ? a.length : _a(u), g = Es(s !== void 0 ? s : d, c !== void 0 ? c : f), m = n && t === "x" && Math.abs(r - i) === 360 ? n3(g, u) : g;
  return WE(e) && !n && m.reverse(), m;
}
function zp(e, t) {
  const n = Qa(e);
  if (!(t && t !== n))
    return UE(mYe)(e, n);
}
function zte(e, t) {
  if (!e.axisValue)
    return;
  const n = t === "x" ? "y" : "x", r = ER(e.scale) && Rn(e.scale[n]) ? e.scale[n] : void 0;
  if (!r)
    return;
  const i = t === "x" ? "y" : "x", o = ER(e.stringMap) && e.stringMap[i], a = o && typeof e.axisValue == "string" ? o[e.axisValue] : e.axisValue;
  return r(a);
}
function GE(e, t) {
  if (!ER(e.theme))
    return _r(e, t, "axis");
  let n = "axis";
  if (e.dependentAxis && e.theme.dependentAxis ? n = "dependentAxis" : !e.dependentAxis && e.theme.independentAxis && (n = "independentAxis"), n === "axis")
    return _r(e, t, "axis");
  const r = He({}, e.theme[n], e.theme.axis), i = Object.assign({}, e.theme, {
    axis: r
  });
  return _r(Object.assign({}, e, {
    theme: i
  }), t, "axis");
}
function vYe() {
  return {
    onLoad: {
      duration: 2e3
    },
    onExit: {
      duration: 500
    },
    onEnter: {
      duration: 500
    }
  };
}
function yYe() {
  return {
    onLoad: {
      duration: 2e3,
      before: () => ({
        _y: 0,
        _y1: 0,
        _y0: 0
      }),
      after: (e) => ({
        _y: e._y,
        _y1: e._y1,
        _y0: e._y0
      })
    },
    onExit: {
      duration: 500,
      before: (e, t, n) => {
        const r = (i) => (t === 0 ? n[t + 1] : n[t - 1])[i];
        return {
          _x: r("_x"),
          _y: r("_y"),
          _y0: r("_y0")
        };
      }
    },
    onEnter: {
      duration: 500,
      before: (e, t, n) => {
        const r = (i) => (t === 0 ? n[t + 1] : n[t - 1])[i];
        return {
          _x: r("_x"),
          _y: r("_y"),
          _y0: r("_y0")
        };
      },
      after: (e) => ({
        _x: e._x,
        _y: e._y,
        _y1: e._y1,
        _y0: e._y0
      })
    }
  };
}
function Hte() {
  return {
    onLoad: {
      duration: 2e3,
      before: () => ({
        opacity: 0
      }),
      after: (e) => e
    },
    onExit: {
      duration: 600,
      before: () => ({
        opacity: 0
      })
    },
    onEnter: {
      duration: 600,
      before: () => ({
        opacity: 0
      }),
      after: (e) => e
    }
  };
}
function i3(e) {
  const t = D.useRef();
  return D.useEffect(() => {
    t.current = e;
  }), t.current;
}
const bYe = {
  nodesShouldLoad: !1,
  nodesDoneLoad: !1,
  animating: !0
}, o3 = function(e) {
  e === void 0 && (e = bYe);
  const [t, n] = D.useState(e), r = D.useCallback((s) => {
    n((c) => ({
      ...c,
      ...s
    }));
  }, [n]), i = D.useCallback((s, c, l) => {
    if (!(s != null && s.animate))
      return c.props.animate;
    const u = () => {
      let p = t && t.childrenTransitions;
      return p = IF(p) ? p[l] : p, He({
        childrenTransitions: p
      }, t);
    };
    let d = s.animate && s.animate.getTransitions;
    const f = u(), h = s.animate && s.animate.parentState || f;
    if (!d) {
      const p = uee(s, f, (g) => r(g));
      d = (g) => p(g, l);
    }
    return He({
      getTransitions: d,
      parentState: h
    }, s.animate, c.props.animate);
  }, [t, r]), o = D.useCallback((s, c) => {
    if (s != null && s.animate)
      if (s.animate.parentState) {
        const u = s.animate.parentState.nodesWillExit ? s : null, d = He({
          oldProps: u,
          nextProps: c
        }, s.animate.parentState);
        r(d);
      } else {
        const l = D.Children.toArray(s.children), u = D.Children.toArray(c.children), d = (v) => {
          const y = (S) => S.type && S.type.continuous;
          return Array.isArray(v) ? v.some(y) : y(v);
        }, f = !s.polar && l.some((v) => {
          var y;
          return d(v) || ((y = v == null ? void 0 : v.props) == null ? void 0 : y.children) && d(v.props.children);
        }), {
          nodesWillExit: h,
          nodesWillEnter: p,
          childrenTransitions: g,
          nodesShouldEnter: m
        } = lee(l, u);
        r({
          nodesWillExit: h,
          nodesWillEnter: p,
          nodesShouldEnter: m,
          childrenTransitions: IF(g) ? g[0] : g,
          oldProps: h ? s : void 0,
          nextProps: c,
          continuous: f
        });
      }
  }, [r]), a = D.useCallback((s) => t && t.nodesWillExit && t.oldProps || s, [t]);
  return {
    state: t,
    setState: r,
    getAnimationProps: i,
    setAnimationState: o,
    getProps: a
  };
};
function _Ye(e, t) {
  t === void 0 && (t = {});
  const n = t._y >= 0 ? 1 : -1, r = e.style && e.style.labels || {};
  return t.verticalAnchor || r.verticalAnchor ? t.verticalAnchor || r.verticalAnchor : e.horizontal ? "middle" : n >= 0 ? "end" : "start";
}
function SYe(e, t) {
  t === void 0 && (t = {});
  const {
    style: n,
    horizontal: r
  } = e, i = t._y >= 0 ? 1 : -1, o = n && n.labels || {};
  return t.verticalAnchor || o.verticalAnchor ? t.verticalAnchor || o.verticalAnchor : r ? i >= 0 ? "start" : "end" : "middle";
}
function wYe(e, t) {
  t === void 0 && (t = {});
  const n = e.style && e.style.labels || {};
  return t.angle === void 0 ? n.angle : t.angle;
}
function xYe(e, t) {
  t === void 0 && (t = {});
  const {
    horizontal: n,
    style: r
  } = e, i = r.labels || {}, o = De(i.padding, e) || 0, a = t._y < 0 ? -1 : 1;
  return {
    x: n ? a * o : 0,
    y: n ? 0 : -1 * a * o
  };
}
function EYe(e, t) {
  if (e.polar)
    return {};
  const n = xYe(e, t);
  return {
    dx: n.x,
    dy: n.y
  };
}
function CYe(e, t) {
  const {
    polar: n
  } = e, {
    x: r,
    y: i
  } = xy(e, t);
  if (!n)
    return {
      x: r,
      y: i
    };
  const o = TYe(e, t);
  return {
    x: r + o.x,
    y: i + o.y
  };
}
function TYe(e, t) {
  const {
    style: n
  } = e, r = xv(e, t), i = n.labels || {}, o = De(i.padding, e) || 0, a = fr(r);
  return {
    x: o * Math.cos(a),
    y: -o * Math.sin(a)
  };
}
function a3(e) {
  const {
    labelComponent: t,
    labelPlacement: n,
    polar: r
  } = e, i = r ? "perpendicular" : "vertical";
  return n || t.props && t.props.labelPlacement || i;
}
function IYe(e) {
  return e < 45 || e > 315 ? "right" : e >= 45 && e <= 135 ? "top" : e > 135 && e < 225 ? "left" : "bottom";
}
function Oy(e, t, n) {
  return t === void 0 && (t = {}), t.label !== void 0 ? t.label : Array.isArray(e.labels) ? e.labels[n] : e.labels;
}
function s3(e, t) {
  const n = a3(e);
  return n === "perpendicular" || n === "vertical" && (t === 90 || t === 270) ? "middle" : t <= 90 || t > 270 ? "start" : "end";
}
function Ute(e, t) {
  const n = a3(e), r = IYe(t);
  return n === "parallel" || r === "left" || r === "right" ? "middle" : r === "top" ? "end" : "start";
}
function c3(e, t) {
  const {
    labelPlacement: n,
    datum: r
  } = e;
  if (!n || n === "vertical")
    return 0;
  const i = t !== void 0 ? t % 360 : xv(e, r), o = i > 90 && i < 180 || i > 270 ? 1 : -1;
  let a = 0;
  return i === 0 || i === 180 ? a = 90 : i > 0 && i < 180 ? a = 90 - i : i > 180 && i < 360 && (a = 270 - i), a + o * (n === "perpendicular" ? 0 : 90);
}
function xv(e, t) {
  const {
    x: n
  } = iee(t);
  return Qc(e.scale.x(n)) % 360;
}
function l3(e, t) {
  const {
    scale: n,
    data: r,
    style: i,
    horizontal: o,
    polar: a,
    width: s,
    height: c,
    theme: l,
    labelComponent: u,
    disableInlineStyles: d
  } = e, f = r[t], h = xv(e, f), p = a ? s3(e, h) : SYe(e, f), g = a ? Ute(e, h) : _Ye(e, f), m = wYe(e, f), v = Oy(e, f, t), y = a3(e), {
    x: S,
    y: _
  } = CYe(e, f), {
    dx: w,
    dy: T
  } = EYe(e, f), x = {
    angle: m,
    data: r,
    datum: f,
    disableInlineStyles: d,
    horizontal: o,
    index: t,
    polar: a,
    scale: n,
    labelPlacement: y,
    text: v,
    textAnchor: p,
    verticalAnchor: g,
    x: S,
    y: _,
    dx: w,
    dy: T,
    width: s,
    height: c,
    style: i.labels
  };
  if (!NE(u))
    return x;
  const C = l && l.tooltip || {};
  return He({}, x, Lf(C, ["style"]));
}
function rn(e) {
  return function() {
    return e;
  };
}
const g9 = Math.abs, Ji = Math.atan2, jc = Math.cos, AYe = Math.max, tg = Math.min, Uo = Math.sin, yr = Math.sqrt, to = 1e-12, Au = Math.PI, dw = Au / 2, uu = 2 * Au;
function RYe(e) {
  return e > 1 ? 0 : e < -1 ? Au : Math.acos(e);
}
function p9(e) {
  return e >= 1 ? dw : e <= -1 ? -dw : Math.asin(e);
}
const WR = Math.PI, qR = 2 * WR, fd = 1e-6, $Ye = qR - fd;
function Wte(e) {
  this._ += e[0];
  for (let t = 1, n = e.length; t < n; ++t)
    this._ += arguments[t] + e[t];
}
function OYe(e) {
  let t = Math.floor(e);
  if (!(t >= 0))
    throw new Error(`invalid digits: ${e}`);
  if (t > 15)
    return Wte;
  const n = 10 ** t;
  return function(r) {
    this._ += r[0];
    for (let i = 1, o = r.length; i < o; ++i)
      this._ += Math.round(arguments[i] * n) / n + r[i];
  };
}
let PYe = class {
  constructor(t) {
    this._x0 = this._y0 = // start of current subpath
    this._x1 = this._y1 = null, this._ = "", this._append = t == null ? Wte : OYe(t);
  }
  moveTo(t, n) {
    this._append`M${this._x0 = this._x1 = +t},${this._y0 = this._y1 = +n}`;
  }
  closePath() {
    this._x1 !== null && (this._x1 = this._x0, this._y1 = this._y0, this._append`Z`);
  }
  lineTo(t, n) {
    this._append`L${this._x1 = +t},${this._y1 = +n}`;
  }
  quadraticCurveTo(t, n, r, i) {
    this._append`Q${+t},${+n},${this._x1 = +r},${this._y1 = +i}`;
  }
  bezierCurveTo(t, n, r, i, o, a) {
    this._append`C${+t},${+n},${+r},${+i},${this._x1 = +o},${this._y1 = +a}`;
  }
  arcTo(t, n, r, i, o) {
    if (t = +t, n = +n, r = +r, i = +i, o = +o, o < 0)
      throw new Error(`negative radius: ${o}`);
    let a = this._x1, s = this._y1, c = r - t, l = i - n, u = a - t, d = s - n, f = u * u + d * d;
    if (this._x1 === null)
      this._append`M${this._x1 = t},${this._y1 = n}`;
    else if (f > fd)
      if (!(Math.abs(d * c - l * u) > fd) || !o)
        this._append`L${this._x1 = t},${this._y1 = n}`;
      else {
        let h = r - a, p = i - s, g = c * c + l * l, m = h * h + p * p, v = Math.sqrt(g), y = Math.sqrt(f), S = o * Math.tan((WR - Math.acos((g + f - m) / (2 * v * y))) / 2), _ = S / y, w = S / v;
        Math.abs(_ - 1) > fd && this._append`L${t + _ * u},${n + _ * d}`, this._append`A${o},${o},0,0,${+(d * h > u * p)},${this._x1 = t + w * c},${this._y1 = n + w * l}`;
      }
  }
  arc(t, n, r, i, o, a) {
    if (t = +t, n = +n, r = +r, a = !!a, r < 0)
      throw new Error(`negative radius: ${r}`);
    let s = r * Math.cos(i), c = r * Math.sin(i), l = t + s, u = n + c, d = 1 ^ a, f = a ? i - o : o - i;
    this._x1 === null ? this._append`M${l},${u}` : (Math.abs(this._x1 - l) > fd || Math.abs(this._y1 - u) > fd) && this._append`L${l},${u}`, r && (f < 0 && (f = f % qR + qR), f > $Ye ? this._append`A${r},${r},0,1,${d},${t - s},${n - c}A${r},${r},0,1,${d},${this._x1 = l},${this._y1 = u}` : f > fd && this._append`A${r},${r},0,${+(f >= WR)},${d},${this._x1 = t + r * Math.cos(o)},${this._y1 = n + r * Math.sin(o)}`);
  }
  rect(t, n, r, i) {
    this._append`M${this._x0 = this._x1 = +t},${this._y0 = this._y1 = +n}h${r = +r}v${+i}h${-r}Z`;
  }
  toString() {
    return this._;
  }
};
function Py(e) {
  let t = 3;
  return e.digits = function(n) {
    if (!arguments.length)
      return t;
    if (n == null)
      t = null;
    else {
      const r = Math.floor(n);
      if (!(r >= 0))
        throw new RangeError(`invalid digits: ${n}`);
      t = r;
    }
    return e;
  }, () => new PYe(t);
}
function MYe(e) {
  return e.innerRadius;
}
function kYe(e) {
  return e.outerRadius;
}
function NYe(e) {
  return e.startAngle;
}
function DYe(e) {
  return e.endAngle;
}
function LYe(e) {
  return e && e.padAngle;
}
function jYe(e, t, n, r, i, o, a, s) {
  var c = n - e, l = r - t, u = a - i, d = s - o, f = d * c - u * l;
  if (!(f * f < to))
    return f = (u * (t - o) - d * (e - i)) / f, [e + f * c, t + f * l];
}
function n1(e, t, n, r, i, o, a) {
  var s = e - n, c = t - r, l = (a ? o : -o) / yr(s * s + c * c), u = l * c, d = -l * s, f = e + u, h = t + d, p = n + u, g = r + d, m = (f + p) / 2, v = (h + g) / 2, y = p - f, S = g - h, _ = y * y + S * S, w = i - o, T = f * g - p * h, x = (S < 0 ? -1 : 1) * yr(AYe(0, w * w * _ - T * T)), C = (T * S - y * x) / _, E = (-T * y - S * x) / _, R = (T * S + y * x) / _, A = (-T * y + S * x) / _, O = C - m, $ = E - v, N = R - m, z = A - v;
  return O * O + $ * $ > N * N + z * z && (C = R, E = A), {
    cx: C,
    cy: E,
    x01: -u,
    y01: -d,
    x11: C * (i / w - 1),
    y11: E * (i / w - 1)
  };
}
function KE() {
  var e = MYe, t = kYe, n = rn(0), r = null, i = NYe, o = DYe, a = LYe, s = null, c = Py(l);
  function l() {
    var u, d, f = +e.apply(this, arguments), h = +t.apply(this, arguments), p = i.apply(this, arguments) - dw, g = o.apply(this, arguments) - dw, m = g9(g - p), v = g > p;
    if (s || (s = u = c()), h < f && (d = h, h = f, f = d), !(h > to))
      s.moveTo(0, 0);
    else if (m > uu - to)
      s.moveTo(h * jc(p), h * Uo(p)), s.arc(0, 0, h, p, g, !v), f > to && (s.moveTo(f * jc(g), f * Uo(g)), s.arc(0, 0, f, g, p, v));
    else {
      var y = p, S = g, _ = p, w = g, T = m, x = m, C = a.apply(this, arguments) / 2, E = C > to && (r ? +r.apply(this, arguments) : yr(f * f + h * h)), R = tg(g9(h - f) / 2, +n.apply(this, arguments)), A = R, O = R, $, N;
      if (E > to) {
        var z = p9(E / f * Uo(C)), k = p9(E / h * Uo(C));
        (T -= z * 2) > to ? (z *= v ? 1 : -1, _ += z, w -= z) : (T = 0, _ = w = (p + g) / 2), (x -= k * 2) > to ? (k *= v ? 1 : -1, y += k, S -= k) : (x = 0, y = S = (p + g) / 2);
      }
      var F = h * jc(y), V = h * Uo(y), j = f * jc(w), B = f * Uo(w);
      if (R > to) {
        var U = h * jc(S), Q = h * Uo(S), K = f * jc(_), q = f * Uo(_), X;
        if (m < Au)
          if (X = jYe(F, V, K, q, U, Q, j, B)) {
            var ie = F - X[0], te = V - X[1], J = U - X[0], Y = Q - X[1], ee = 1 / Uo(RYe((ie * J + te * Y) / (yr(ie * ie + te * te) * yr(J * J + Y * Y))) / 2), Z = yr(X[0] * X[0] + X[1] * X[1]);
            A = tg(R, (f - Z) / (ee - 1)), O = tg(R, (h - Z) / (ee + 1));
          } else
            A = O = 0;
      }
      x > to ? O > to ? ($ = n1(K, q, F, V, h, O, v), N = n1(U, Q, j, B, h, O, v), s.moveTo($.cx + $.x01, $.cy + $.y01), O < R ? s.arc($.cx, $.cy, O, Ji($.y01, $.x01), Ji(N.y01, N.x01), !v) : (s.arc($.cx, $.cy, O, Ji($.y01, $.x01), Ji($.y11, $.x11), !v), s.arc(0, 0, h, Ji($.cy + $.y11, $.cx + $.x11), Ji(N.cy + N.y11, N.cx + N.x11), !v), s.arc(N.cx, N.cy, O, Ji(N.y11, N.x11), Ji(N.y01, N.x01), !v))) : (s.moveTo(F, V), s.arc(0, 0, h, y, S, !v)) : s.moveTo(F, V), !(f > to) || !(T > to) ? s.lineTo(j, B) : A > to ? ($ = n1(j, B, U, Q, f, -A, v), N = n1(F, V, K, q, f, -A, v), s.lineTo($.cx + $.x01, $.cy + $.y01), A < R ? s.arc($.cx, $.cy, A, Ji($.y01, $.x01), Ji(N.y01, N.x01), !v) : (s.arc($.cx, $.cy, A, Ji($.y01, $.x01), Ji($.y11, $.x11), !v), s.arc(0, 0, f, Ji($.cy + $.y11, $.cx + $.x11), Ji(N.cy + N.y11, N.cx + N.x11), v), s.arc(N.cx, N.cy, A, Ji(N.y11, N.x11), Ji(N.y01, N.x01), !v))) : s.arc(0, 0, f, w, _, v);
    }
    if (s.closePath(), u)
      return s = null, u + "" || null;
  }
  return l.centroid = function() {
    var u = (+e.apply(this, arguments) + +t.apply(this, arguments)) / 2, d = (+i.apply(this, arguments) + +o.apply(this, arguments)) / 2 - Au / 2;
    return [jc(d) * u, Uo(d) * u];
  }, l.innerRadius = function(u) {
    return arguments.length ? (e = typeof u == "function" ? u : rn(+u), l) : e;
  }, l.outerRadius = function(u) {
    return arguments.length ? (t = typeof u == "function" ? u : rn(+u), l) : t;
  }, l.cornerRadius = function(u) {
    return arguments.length ? (n = typeof u == "function" ? u : rn(+u), l) : n;
  }, l.padRadius = function(u) {
    return arguments.length ? (r = u == null ? null : typeof u == "function" ? u : rn(+u), l) : r;
  }, l.startAngle = function(u) {
    return arguments.length ? (i = typeof u == "function" ? u : rn(+u), l) : i;
  }, l.endAngle = function(u) {
    return arguments.length ? (o = typeof u == "function" ? u : rn(+u), l) : o;
  }, l.padAngle = function(u) {
    return arguments.length ? (a = typeof u == "function" ? u : rn(+u), l) : a;
  }, l.context = function(u) {
    return arguments.length ? (s = u ?? null, l) : s;
  }, l;
}
var FYe = Array.prototype.slice;
function YE(e) {
  return typeof e == "object" && "length" in e ? e : Array.from(e);
}
function qte(e) {
  this._context = e;
}
qte.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._point = 0;
  },
  lineEnd: function() {
    (this._line || this._line !== 0 && this._point === 1) && this._context.closePath(), this._line = 1 - this._line;
  },
  point: function(e, t) {
    switch (e = +e, t = +t, this._point) {
      case 0:
        this._point = 1, this._line ? this._context.lineTo(e, t) : this._context.moveTo(e, t);
        break;
      case 1:
        this._point = 2;
      default:
        this._context.lineTo(e, t);
        break;
    }
  }
};
function Hp(e) {
  return new qte(e);
}
function u3(e) {
  return e[0];
}
function d3(e) {
  return e[1];
}
function XE(e, t) {
  var n = rn(!0), r = null, i = Hp, o = null, a = Py(s);
  e = typeof e == "function" ? e : e === void 0 ? u3 : rn(e), t = typeof t == "function" ? t : t === void 0 ? d3 : rn(t);
  function s(c) {
    var l, u = (c = YE(c)).length, d, f = !1, h;
    for (r == null && (o = i(h = a())), l = 0; l <= u; ++l)
      !(l < u && n(d = c[l], l, c)) === f && ((f = !f) ? o.lineStart() : o.lineEnd()), f && o.point(+e(d, l, c), +t(d, l, c));
    if (h)
      return o = null, h + "" || null;
  }
  return s.x = function(c) {
    return arguments.length ? (e = typeof c == "function" ? c : rn(+c), s) : e;
  }, s.y = function(c) {
    return arguments.length ? (t = typeof c == "function" ? c : rn(+c), s) : t;
  }, s.defined = function(c) {
    return arguments.length ? (n = typeof c == "function" ? c : rn(!!c), s) : n;
  }, s.curve = function(c) {
    return arguments.length ? (i = c, r != null && (o = i(r)), s) : i;
  }, s.context = function(c) {
    return arguments.length ? (c == null ? r = o = null : o = i(r = c), s) : r;
  }, s;
}
function Gte(e, t, n) {
  var r = null, i = rn(!0), o = null, a = Hp, s = null, c = Py(l);
  e = typeof e == "function" ? e : e === void 0 ? u3 : rn(+e), t = typeof t == "function" ? t : rn(t === void 0 ? 0 : +t), n = typeof n == "function" ? n : n === void 0 ? d3 : rn(+n);
  function l(d) {
    var f, h, p, g = (d = YE(d)).length, m, v = !1, y, S = new Array(g), _ = new Array(g);
    for (o == null && (s = a(y = c())), f = 0; f <= g; ++f) {
      if (!(f < g && i(m = d[f], f, d)) === v)
        if (v = !v)
          h = f, s.areaStart(), s.lineStart();
        else {
          for (s.lineEnd(), s.lineStart(), p = f - 1; p >= h; --p)
            s.point(S[p], _[p]);
          s.lineEnd(), s.areaEnd();
        }
      v && (S[f] = +e(m, f, d), _[f] = +t(m, f, d), s.point(r ? +r(m, f, d) : S[f], n ? +n(m, f, d) : _[f]));
    }
    if (y)
      return s = null, y + "" || null;
  }
  function u() {
    return XE().defined(i).curve(a).context(o);
  }
  return l.x = function(d) {
    return arguments.length ? (e = typeof d == "function" ? d : rn(+d), r = null, l) : e;
  }, l.x0 = function(d) {
    return arguments.length ? (e = typeof d == "function" ? d : rn(+d), l) : e;
  }, l.x1 = function(d) {
    return arguments.length ? (r = d == null ? null : typeof d == "function" ? d : rn(+d), l) : r;
  }, l.y = function(d) {
    return arguments.length ? (t = typeof d == "function" ? d : rn(+d), n = null, l) : t;
  }, l.y0 = function(d) {
    return arguments.length ? (t = typeof d == "function" ? d : rn(+d), l) : t;
  }, l.y1 = function(d) {
    return arguments.length ? (n = d == null ? null : typeof d == "function" ? d : rn(+d), l) : n;
  }, l.lineX0 = l.lineY0 = function() {
    return u().x(e).y(t);
  }, l.lineY1 = function() {
    return u().x(e).y(n);
  }, l.lineX1 = function() {
    return u().x(r).y(t);
  }, l.defined = function(d) {
    return arguments.length ? (i = typeof d == "function" ? d : rn(!!d), l) : i;
  }, l.curve = function(d) {
    return arguments.length ? (a = d, o != null && (s = a(o)), l) : a;
  }, l.context = function(d) {
    return arguments.length ? (d == null ? o = s = null : s = a(o = d), l) : o;
  }, l;
}
function VYe(e, t) {
  return t < e ? -1 : t > e ? 1 : t >= e ? 0 : NaN;
}
function BYe(e) {
  return e;
}
function Kte() {
  var e = BYe, t = VYe, n = null, r = rn(0), i = rn(uu), o = rn(0);
  function a(s) {
    var c, l = (s = YE(s)).length, u, d, f = 0, h = new Array(l), p = new Array(l), g = +r.apply(this, arguments), m = Math.min(uu, Math.max(-uu, i.apply(this, arguments) - g)), v, y = Math.min(Math.abs(m) / l, o.apply(this, arguments)), S = y * (m < 0 ? -1 : 1), _;
    for (c = 0; c < l; ++c)
      (_ = p[h[c] = c] = +e(s[c], c, s)) > 0 && (f += _);
    for (t != null ? h.sort(function(w, T) {
      return t(p[w], p[T]);
    }) : n != null && h.sort(function(w, T) {
      return n(s[w], s[T]);
    }), c = 0, d = f ? (m - l * S) / f : 0; c < l; ++c, g = v)
      u = h[c], _ = p[u], v = g + (_ > 0 ? _ * d : 0) + S, p[u] = {
        data: s[u],
        index: c,
        value: _,
        startAngle: g,
        endAngle: v,
        padAngle: y
      };
    return p;
  }
  return a.value = function(s) {
    return arguments.length ? (e = typeof s == "function" ? s : rn(+s), a) : e;
  }, a.sortValues = function(s) {
    return arguments.length ? (t = s, n = null, a) : t;
  }, a.sort = function(s) {
    return arguments.length ? (n = s, t = null, a) : n;
  }, a.startAngle = function(s) {
    return arguments.length ? (r = typeof s == "function" ? s : rn(+s), a) : r;
  }, a.endAngle = function(s) {
    return arguments.length ? (i = typeof s == "function" ? s : rn(+s), a) : i;
  }, a.padAngle = function(s) {
    return arguments.length ? (o = typeof s == "function" ? s : rn(+s), a) : o;
  }, a;
}
var Yte = f3(Hp);
function Xte(e) {
  this._curve = e;
}
Xte.prototype = {
  areaStart: function() {
    this._curve.areaStart();
  },
  areaEnd: function() {
    this._curve.areaEnd();
  },
  lineStart: function() {
    this._curve.lineStart();
  },
  lineEnd: function() {
    this._curve.lineEnd();
  },
  point: function(e, t) {
    this._curve.point(t * Math.sin(e), t * -Math.cos(e));
  }
};
function f3(e) {
  function t(n) {
    return new Xte(e(n));
  }
  return t._curve = e, t;
}
function qm(e) {
  var t = e.curve;
  return e.angle = e.x, delete e.x, e.radius = e.y, delete e.y, e.curve = function(n) {
    return arguments.length ? t(f3(n)) : t()._curve;
  }, e;
}
function GR() {
  return qm(XE().curve(Yte));
}
function m9() {
  var e = Gte().curve(Yte), t = e.curve, n = e.lineX0, r = e.lineX1, i = e.lineY0, o = e.lineY1;
  return e.angle = e.x, delete e.x, e.startAngle = e.x0, delete e.x0, e.endAngle = e.x1, delete e.x1, e.radius = e.y, delete e.y, e.innerRadius = e.y0, delete e.y0, e.outerRadius = e.y1, delete e.y1, e.lineStartAngle = function() {
    return qm(n());
  }, delete e.lineX0, e.lineEndAngle = function() {
    return qm(r());
  }, delete e.lineX1, e.lineInnerRadius = function() {
    return qm(i());
  }, delete e.lineY0, e.lineOuterRadius = function() {
    return qm(o());
  }, delete e.lineY1, e.curve = function(a) {
    return arguments.length ? t(f3(a)) : t()._curve;
  }, e;
}
function Gm(e, t) {
  return [(t = +t) * Math.cos(e -= Math.PI / 2), t * Math.sin(e)];
}
class Qte {
  constructor(t, n) {
    this._context = t, this._x = n;
  }
  areaStart() {
    this._line = 0;
  }
  areaEnd() {
    this._line = NaN;
  }
  lineStart() {
    this._point = 0;
  }
  lineEnd() {
    (this._line || this._line !== 0 && this._point === 1) && this._context.closePath(), this._line = 1 - this._line;
  }
  point(t, n) {
    switch (t = +t, n = +n, this._point) {
      case 0: {
        this._point = 1, this._line ? this._context.lineTo(t, n) : this._context.moveTo(t, n);
        break;
      }
      case 1:
        this._point = 2;
      default: {
        this._x ? this._context.bezierCurveTo(this._x0 = (this._x0 + t) / 2, this._y0, this._x0, n, t, n) : this._context.bezierCurveTo(this._x0, this._y0 = (this._y0 + n) / 2, t, this._y0, t, n);
        break;
      }
    }
    this._x0 = t, this._y0 = n;
  }
}
class zYe {
  constructor(t) {
    this._context = t;
  }
  lineStart() {
    this._point = 0;
  }
  lineEnd() {
  }
  point(t, n) {
    if (t = +t, n = +n, this._point === 0)
      this._point = 1;
    else {
      const r = Gm(this._x0, this._y0), i = Gm(this._x0, this._y0 = (this._y0 + n) / 2), o = Gm(t, this._y0), a = Gm(t, n);
      this._context.moveTo(...r), this._context.bezierCurveTo(...i, ...o, ...a);
    }
    this._x0 = t, this._y0 = n;
  }
}
function Jte(e) {
  return new Qte(e, !0);
}
function Zte(e) {
  return new Qte(e, !1);
}
function HYe(e) {
  return new zYe(e);
}
function UYe(e) {
  return e.source;
}
function WYe(e) {
  return e.target;
}
function QE(e) {
  let t = UYe, n = WYe, r = u3, i = d3, o = null, a = null, s = Py(c);
  function c() {
    let l;
    const u = FYe.call(arguments), d = t.apply(this, u), f = n.apply(this, u);
    if (o == null && (a = e(l = s())), a.lineStart(), u[0] = d, a.point(+r.apply(this, u), +i.apply(this, u)), u[0] = f, a.point(+r.apply(this, u), +i.apply(this, u)), a.lineEnd(), l)
      return a = null, l + "" || null;
  }
  return c.source = function(l) {
    return arguments.length ? (t = l, c) : t;
  }, c.target = function(l) {
    return arguments.length ? (n = l, c) : n;
  }, c.x = function(l) {
    return arguments.length ? (r = typeof l == "function" ? l : rn(+l), c) : r;
  }, c.y = function(l) {
    return arguments.length ? (i = typeof l == "function" ? l : rn(+l), c) : i;
  }, c.context = function(l) {
    return arguments.length ? (l == null ? o = a = null : a = e(o = l), c) : o;
  }, c;
}
function qYe() {
  return QE(Jte);
}
function GYe() {
  return QE(Zte);
}
function KYe() {
  const e = QE(HYe);
  return e.angle = e.x, delete e.x, e.radius = e.y, delete e.y, e;
}
const YYe = yr(3), ene = {
  draw(e, t) {
    const n = yr(t + tg(t / 28, 0.75)) * 0.59436, r = n / 2, i = r * YYe;
    e.moveTo(0, n), e.lineTo(0, -n), e.moveTo(-i, -r), e.lineTo(i, r), e.moveTo(-i, r), e.lineTo(i, -r);
  }
}, JE = {
  draw(e, t) {
    const n = yr(t / Au);
    e.moveTo(n, 0), e.arc(0, 0, n, 0, uu);
  }
}, tne = {
  draw(e, t) {
    const n = yr(t / 5) / 2;
    e.moveTo(-3 * n, -n), e.lineTo(-n, -n), e.lineTo(-n, -3 * n), e.lineTo(n, -3 * n), e.lineTo(n, -n), e.lineTo(3 * n, -n), e.lineTo(3 * n, n), e.lineTo(n, n), e.lineTo(n, 3 * n), e.lineTo(-n, 3 * n), e.lineTo(-n, n), e.lineTo(-3 * n, n), e.closePath();
  }
}, nne = yr(1 / 3), XYe = nne * 2, rne = {
  draw(e, t) {
    const n = yr(t / XYe), r = n * nne;
    e.moveTo(0, -n), e.lineTo(r, 0), e.lineTo(0, n), e.lineTo(-r, 0), e.closePath();
  }
}, ine = {
  draw(e, t) {
    const n = yr(t) * 0.62625;
    e.moveTo(0, -n), e.lineTo(n, 0), e.lineTo(0, n), e.lineTo(-n, 0), e.closePath();
  }
}, one = {
  draw(e, t) {
    const n = yr(t - tg(t / 7, 2)) * 0.87559;
    e.moveTo(-n, 0), e.lineTo(n, 0), e.moveTo(0, n), e.lineTo(0, -n);
  }
}, ane = {
  draw(e, t) {
    const n = yr(t), r = -n / 2;
    e.rect(r, r, n, n);
  }
}, sne = {
  draw(e, t) {
    const n = yr(t) * 0.4431;
    e.moveTo(n, n), e.lineTo(n, -n), e.lineTo(-n, -n), e.lineTo(-n, n), e.closePath();
  }
}, QYe = 0.8908130915292852, cne = Uo(Au / 10) / Uo(7 * Au / 10), JYe = Uo(uu / 10) * cne, ZYe = -jc(uu / 10) * cne, lne = {
  draw(e, t) {
    const n = yr(t * QYe), r = JYe * n, i = ZYe * n;
    e.moveTo(0, -n), e.lineTo(r, i);
    for (let o = 1; o < 5; ++o) {
      const a = uu * o / 5, s = jc(a), c = Uo(a);
      e.lineTo(c * n, -s * n), e.lineTo(s * r - c * i, c * r + s * i);
    }
    e.closePath();
  }
}, yT = yr(3), une = {
  draw(e, t) {
    const n = -yr(t / (yT * 3));
    e.moveTo(0, n * 2), e.lineTo(-yT * n, -n), e.lineTo(yT * n, -n), e.closePath();
  }
}, eXe = yr(3), dne = {
  draw(e, t) {
    const n = yr(t) * 0.6824, r = n / 2, i = n * eXe / 2;
    e.moveTo(0, -n), e.lineTo(i, r), e.lineTo(-i, r), e.closePath();
  }
}, Ra = -0.5, $a = yr(3) / 2, KR = 1 / yr(12), tXe = (KR / 2 + 1) * 3, fne = {
  draw(e, t) {
    const n = yr(t / tXe), r = n / 2, i = n * KR, o = r, a = n * KR + n, s = -o, c = a;
    e.moveTo(r, i), e.lineTo(o, a), e.lineTo(s, c), e.lineTo(Ra * r - $a * i, $a * r + Ra * i), e.lineTo(Ra * o - $a * a, $a * o + Ra * a), e.lineTo(Ra * s - $a * c, $a * s + Ra * c), e.lineTo(Ra * r + $a * i, Ra * i - $a * r), e.lineTo(Ra * o + $a * a, Ra * a - $a * o), e.lineTo(Ra * s + $a * c, Ra * c - $a * s), e.closePath();
  }
}, YR = {
  draw(e, t) {
    const n = yr(t - tg(t / 6, 1.7)) * 0.6189;
    e.moveTo(-n, -n), e.lineTo(n, n), e.moveTo(-n, n), e.lineTo(n, -n);
  }
}, v9 = [
  JE,
  tne,
  rne,
  ane,
  lne,
  une,
  fne
], nXe = [
  JE,
  one,
  YR,
  dne,
  ene,
  sne,
  ine
];
function rXe(e, t) {
  let n = null, r = Py(i);
  e = typeof e == "function" ? e : rn(e || JE), t = typeof t == "function" ? t : rn(t === void 0 ? 64 : +t);
  function i() {
    let o;
    if (n || (n = o = r()), e.apply(this, arguments).draw(n, +t.apply(this, arguments)), o)
      return n = null, o + "" || null;
  }
  return i.type = function(o) {
    return arguments.length ? (e = typeof o == "function" ? o : rn(o), i) : e;
  }, i.size = function(o) {
    return arguments.length ? (t = typeof o == "function" ? o : rn(+o), i) : t;
  }, i.context = function(o) {
    return arguments.length ? (n = o ?? null, i) : n;
  }, i;
}
function Ru() {
}
function fw(e, t, n) {
  e._context.bezierCurveTo(
    (2 * e._x0 + e._x1) / 3,
    (2 * e._y0 + e._y1) / 3,
    (e._x0 + 2 * e._x1) / 3,
    (e._y0 + 2 * e._y1) / 3,
    (e._x0 + 4 * e._x1 + t) / 6,
    (e._y0 + 4 * e._y1 + n) / 6
  );
}
function ZE(e) {
  this._context = e;
}
ZE.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 = this._y0 = this._y1 = NaN, this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 3:
        fw(this, this._x1, this._y1);
      case 2:
        this._context.lineTo(this._x1, this._y1);
        break;
    }
    (this._line || this._line !== 0 && this._point === 1) && this._context.closePath(), this._line = 1 - this._line;
  },
  point: function(e, t) {
    switch (e = +e, t = +t, this._point) {
      case 0:
        this._point = 1, this._line ? this._context.lineTo(e, t) : this._context.moveTo(e, t);
        break;
      case 1:
        this._point = 2;
        break;
      case 2:
        this._point = 3, this._context.lineTo((5 * this._x0 + this._x1) / 6, (5 * this._y0 + this._y1) / 6);
      default:
        fw(this, e, t);
        break;
    }
    this._x0 = this._x1, this._x1 = e, this._y0 = this._y1, this._y1 = t;
  }
};
function hne(e) {
  return new ZE(e);
}
function gne(e) {
  this._context = e;
}
gne.prototype = {
  areaStart: Ru,
  areaEnd: Ru,
  lineStart: function() {
    this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = NaN, this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 1: {
        this._context.moveTo(this._x2, this._y2), this._context.closePath();
        break;
      }
      case 2: {
        this._context.moveTo((this._x2 + 2 * this._x3) / 3, (this._y2 + 2 * this._y3) / 3), this._context.lineTo((this._x3 + 2 * this._x2) / 3, (this._y3 + 2 * this._y2) / 3), this._context.closePath();
        break;
      }
      case 3: {
        this.point(this._x2, this._y2), this.point(this._x3, this._y3), this.point(this._x4, this._y4);
        break;
      }
    }
  },
  point: function(e, t) {
    switch (e = +e, t = +t, this._point) {
      case 0:
        this._point = 1, this._x2 = e, this._y2 = t;
        break;
      case 1:
        this._point = 2, this._x3 = e, this._y3 = t;
        break;
      case 2:
        this._point = 3, this._x4 = e, this._y4 = t, this._context.moveTo((this._x0 + 4 * this._x1 + e) / 6, (this._y0 + 4 * this._y1 + t) / 6);
        break;
      default:
        fw(this, e, t);
        break;
    }
    this._x0 = this._x1, this._x1 = e, this._y0 = this._y1, this._y1 = t;
  }
};
function pne(e) {
  return new gne(e);
}
function mne(e) {
  this._context = e;
}
mne.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 = this._y0 = this._y1 = NaN, this._point = 0;
  },
  lineEnd: function() {
    (this._line || this._line !== 0 && this._point === 3) && this._context.closePath(), this._line = 1 - this._line;
  },
  point: function(e, t) {
    switch (e = +e, t = +t, this._point) {
      case 0:
        this._point = 1;
        break;
      case 1:
        this._point = 2;
        break;
      case 2:
        this._point = 3;
        var n = (this._x0 + 4 * this._x1 + e) / 6, r = (this._y0 + 4 * this._y1 + t) / 6;
        this._line ? this._context.lineTo(n, r) : this._context.moveTo(n, r);
        break;
      case 3:
        this._point = 4;
      default:
        fw(this, e, t);
        break;
    }
    this._x0 = this._x1, this._x1 = e, this._y0 = this._y1, this._y1 = t;
  }
};
function vne(e) {
  return new mne(e);
}
function yne(e, t) {
  this._basis = new ZE(e), this._beta = t;
}
yne.prototype = {
  lineStart: function() {
    this._x = [], this._y = [], this._basis.lineStart();
  },
  lineEnd: function() {
    var e = this._x, t = this._y, n = e.length - 1;
    if (n > 0)
      for (var r = e[0], i = t[0], o = e[n] - r, a = t[n] - i, s = -1, c; ++s <= n; )
        c = s / n, this._basis.point(
          this._beta * e[s] + (1 - this._beta) * (r + c * o),
          this._beta * t[s] + (1 - this._beta) * (i + c * a)
        );
    this._x = this._y = null, this._basis.lineEnd();
  },
  point: function(e, t) {
    this._x.push(+e), this._y.push(+t);
  }
};
const bne = function e(t) {
  function n(r) {
    return t === 1 ? new ZE(r) : new yne(r, t);
  }
  return n.beta = function(r) {
    return e(+r);
  }, n;
}(0.85);
function hw(e, t, n) {
  e._context.bezierCurveTo(
    e._x1 + e._k * (e._x2 - e._x0),
    e._y1 + e._k * (e._y2 - e._y0),
    e._x2 + e._k * (e._x1 - t),
    e._y2 + e._k * (e._y1 - n),
    e._x2,
    e._y2
  );
}
function h3(e, t) {
  this._context = e, this._k = (1 - t) / 6;
}
h3.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN, this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 2:
        this._context.lineTo(this._x2, this._y2);
        break;
      case 3:
        hw(this, this._x1, this._y1);
        break;
    }
    (this._line || this._line !== 0 && this._point === 1) && this._context.closePath(), this._line = 1 - this._line;
  },
  point: function(e, t) {
    switch (e = +e, t = +t, this._point) {
      case 0:
        this._point = 1, this._line ? this._context.lineTo(e, t) : this._context.moveTo(e, t);
        break;
      case 1:
        this._point = 2, this._x1 = e, this._y1 = t;
        break;
      case 2:
        this._point = 3;
      default:
        hw(this, e, t);
        break;
    }
    this._x0 = this._x1, this._x1 = this._x2, this._x2 = e, this._y0 = this._y1, this._y1 = this._y2, this._y2 = t;
  }
};
const _ne = function e(t) {
  function n(r) {
    return new h3(r, t);
  }
  return n.tension = function(r) {
    return e(+r);
  }, n;
}(0);
function g3(e, t) {
  this._context = e, this._k = (1 - t) / 6;
}
g3.prototype = {
  areaStart: Ru,
  areaEnd: Ru,
  lineStart: function() {
    this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._x5 = this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = this._y5 = NaN, this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 1: {
        this._context.moveTo(this._x3, this._y3), this._context.closePath();
        break;
      }
      case 2: {
        this._context.lineTo(this._x3, this._y3), this._context.closePath();
        break;
      }
      case 3: {
        this.point(this._x3, this._y3), this.point(this._x4, this._y4), this.point(this._x5, this._y5);
        break;
      }
    }
  },
  point: function(e, t) {
    switch (e = +e, t = +t, this._point) {
      case 0:
        this._point = 1, this._x3 = e, this._y3 = t;
        break;
      case 1:
        this._point = 2, this._context.moveTo(this._x4 = e, this._y4 = t);
        break;
      case 2:
        this._point = 3, this._x5 = e, this._y5 = t;
        break;
      default:
        hw(this, e, t);
        break;
    }
    this._x0 = this._x1, this._x1 = this._x2, this._x2 = e, this._y0 = this._y1, this._y1 = this._y2, this._y2 = t;
  }
};
const Sne = function e(t) {
  function n(r) {
    return new g3(r, t);
  }
  return n.tension = function(r) {
    return e(+r);
  }, n;
}(0);
function p3(e, t) {
  this._context = e, this._k = (1 - t) / 6;
}
p3.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN, this._point = 0;
  },
  lineEnd: function() {
    (this._line || this._line !== 0 && this._point === 3) && this._context.closePath(), this._line = 1 - this._line;
  },
  point: function(e, t) {
    switch (e = +e, t = +t, this._point) {
      case 0:
        this._point = 1;
        break;
      case 1:
        this._point = 2;
        break;
      case 2:
        this._point = 3, this._line ? this._context.lineTo(this._x2, this._y2) : this._context.moveTo(this._x2, this._y2);
        break;
      case 3:
        this._point = 4;
      default:
        hw(this, e, t);
        break;
    }
    this._x0 = this._x1, this._x1 = this._x2, this._x2 = e, this._y0 = this._y1, this._y1 = this._y2, this._y2 = t;
  }
};
const wne = function e(t) {
  function n(r) {
    return new p3(r, t);
  }
  return n.tension = function(r) {
    return e(+r);
  }, n;
}(0);
function m3(e, t, n) {
  var r = e._x1, i = e._y1, o = e._x2, a = e._y2;
  if (e._l01_a > to) {
    var s = 2 * e._l01_2a + 3 * e._l01_a * e._l12_a + e._l12_2a, c = 3 * e._l01_a * (e._l01_a + e._l12_a);
    r = (r * s - e._x0 * e._l12_2a + e._x2 * e._l01_2a) / c, i = (i * s - e._y0 * e._l12_2a + e._y2 * e._l01_2a) / c;
  }
  if (e._l23_a > to) {
    var l = 2 * e._l23_2a + 3 * e._l23_a * e._l12_a + e._l12_2a, u = 3 * e._l23_a * (e._l23_a + e._l12_a);
    o = (o * l + e._x1 * e._l23_2a - t * e._l12_2a) / u, a = (a * l + e._y1 * e._l23_2a - n * e._l12_2a) / u;
  }
  e._context.bezierCurveTo(r, i, o, a, e._x2, e._y2);
}
function xne(e, t) {
  this._context = e, this._alpha = t;
}
xne.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN, this._l01_a = this._l12_a = this._l23_a = this._l01_2a = this._l12_2a = this._l23_2a = this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 2:
        this._context.lineTo(this._x2, this._y2);
        break;
      case 3:
        this.point(this._x2, this._y2);
        break;
    }
    (this._line || this._line !== 0 && this._point === 1) && this._context.closePath(), this._line = 1 - this._line;
  },
  point: function(e, t) {
    if (e = +e, t = +t, this._point) {
      var n = this._x2 - e, r = this._y2 - t;
      this._l23_a = Math.sqrt(this._l23_2a = Math.pow(n * n + r * r, this._alpha));
    }
    switch (this._point) {
      case 0:
        this._point = 1, this._line ? this._context.lineTo(e, t) : this._context.moveTo(e, t);
        break;
      case 1:
        this._point = 2;
        break;
      case 2:
        this._point = 3;
      default:
        m3(this, e, t);
        break;
    }
    this._l01_a = this._l12_a, this._l12_a = this._l23_a, this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a, this._x0 = this._x1, this._x1 = this._x2, this._x2 = e, this._y0 = this._y1, this._y1 = this._y2, this._y2 = t;
  }
};
const Ene = function e(t) {
  function n(r) {
    return t ? new xne(r, t) : new h3(r, 0);
  }
  return n.alpha = function(r) {
    return e(+r);
  }, n;
}(0.5);
function Cne(e, t) {
  this._context = e, this._alpha = t;
}
Cne.prototype = {
  areaStart: Ru,
  areaEnd: Ru,
  lineStart: function() {
    this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._x5 = this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = this._y5 = NaN, this._l01_a = this._l12_a = this._l23_a = this._l01_2a = this._l12_2a = this._l23_2a = this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 1: {
        this._context.moveTo(this._x3, this._y3), this._context.closePath();
        break;
      }
      case 2: {
        this._context.lineTo(this._x3, this._y3), this._context.closePath();
        break;
      }
      case 3: {
        this.point(this._x3, this._y3), this.point(this._x4, this._y4), this.point(this._x5, this._y5);
        break;
      }
    }
  },
  point: function(e, t) {
    if (e = +e, t = +t, this._point) {
      var n = this._x2 - e, r = this._y2 - t;
      this._l23_a = Math.sqrt(this._l23_2a = Math.pow(n * n + r * r, this._alpha));
    }
    switch (this._point) {
      case 0:
        this._point = 1, this._x3 = e, this._y3 = t;
        break;
      case 1:
        this._point = 2, this._context.moveTo(this._x4 = e, this._y4 = t);
        break;
      case 2:
        this._point = 3, this._x5 = e, this._y5 = t;
        break;
      default:
        m3(this, e, t);
        break;
    }
    this._l01_a = this._l12_a, this._l12_a = this._l23_a, this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a, this._x0 = this._x1, this._x1 = this._x2, this._x2 = e, this._y0 = this._y1, this._y1 = this._y2, this._y2 = t;
  }
};
const Tne = function e(t) {
  function n(r) {
    return t ? new Cne(r, t) : new g3(r, 0);
  }
  return n.alpha = function(r) {
    return e(+r);
  }, n;
}(0.5);
function Ine(e, t) {
  this._context = e, this._alpha = t;
}
Ine.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN, this._l01_a = this._l12_a = this._l23_a = this._l01_2a = this._l12_2a = this._l23_2a = this._point = 0;
  },
  lineEnd: function() {
    (this._line || this._line !== 0 && this._point === 3) && this._context.closePath(), this._line = 1 - this._line;
  },
  point: function(e, t) {
    if (e = +e, t = +t, this._point) {
      var n = this._x2 - e, r = this._y2 - t;
      this._l23_a = Math.sqrt(this._l23_2a = Math.pow(n * n + r * r, this._alpha));
    }
    switch (this._point) {
      case 0:
        this._point = 1;
        break;
      case 1:
        this._point = 2;
        break;
      case 2:
        this._point = 3, this._line ? this._context.lineTo(this._x2, this._y2) : this._context.moveTo(this._x2, this._y2);
        break;
      case 3:
        this._point = 4;
      default:
        m3(this, e, t);
        break;
    }
    this._l01_a = this._l12_a, this._l12_a = this._l23_a, this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a, this._x0 = this._x1, this._x1 = this._x2, this._x2 = e, this._y0 = this._y1, this._y1 = this._y2, this._y2 = t;
  }
};
const Ane = function e(t) {
  function n(r) {
    return t ? new Ine(r, t) : new p3(r, 0);
  }
  return n.alpha = function(r) {
    return e(+r);
  }, n;
}(0.5);
function Rne(e) {
  this._context = e;
}
Rne.prototype = {
  areaStart: Ru,
  areaEnd: Ru,
  lineStart: function() {
    this._point = 0;
  },
  lineEnd: function() {
    this._point && this._context.closePath();
  },
  point: function(e, t) {
    e = +e, t = +t, this._point ? this._context.lineTo(e, t) : (this._point = 1, this._context.moveTo(e, t));
  }
};
function $ne(e) {
  return new Rne(e);
}
function y9(e) {
  return e < 0 ? -1 : 1;
}
function b9(e, t, n) {
  var r = e._x1 - e._x0, i = t - e._x1, o = (e._y1 - e._y0) / (r || i < 0 && -0), a = (n - e._y1) / (i || r < 0 && -0), s = (o * i + a * r) / (r + i);
  return (y9(o) + y9(a)) * Math.min(Math.abs(o), Math.abs(a), 0.5 * Math.abs(s)) || 0;
}
function _9(e, t) {
  var n = e._x1 - e._x0;
  return n ? (3 * (e._y1 - e._y0) / n - t) / 2 : t;
}
function bT(e, t, n) {
  var r = e._x0, i = e._y0, o = e._x1, a = e._y1, s = (o - r) / 3;
  e._context.bezierCurveTo(r + s, i + s * t, o - s, a - s * n, o, a);
}
function gw(e) {
  this._context = e;
}
gw.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 = this._y0 = this._y1 = this._t0 = NaN, this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 2:
        this._context.lineTo(this._x1, this._y1);
        break;
      case 3:
        bT(this, this._t0, _9(this, this._t0));
        break;
    }
    (this._line || this._line !== 0 && this._point === 1) && this._context.closePath(), this._line = 1 - this._line;
  },
  point: function(e, t) {
    var n = NaN;
    if (e = +e, t = +t, !(e === this._x1 && t === this._y1)) {
      switch (this._point) {
        case 0:
          this._point = 1, this._line ? this._context.lineTo(e, t) : this._context.moveTo(e, t);
          break;
        case 1:
          this._point = 2;
          break;
        case 2:
          this._point = 3, bT(this, _9(this, n = b9(this, e, t)), n);
          break;
        default:
          bT(this, this._t0, n = b9(this, e, t));
          break;
      }
      this._x0 = this._x1, this._x1 = e, this._y0 = this._y1, this._y1 = t, this._t0 = n;
    }
  }
};
function One(e) {
  this._context = new Pne(e);
}
(One.prototype = Object.create(gw.prototype)).point = function(e, t) {
  gw.prototype.point.call(this, t, e);
};
function Pne(e) {
  this._context = e;
}
Pne.prototype = {
  moveTo: function(e, t) {
    this._context.moveTo(t, e);
  },
  closePath: function() {
    this._context.closePath();
  },
  lineTo: function(e, t) {
    this._context.lineTo(t, e);
  },
  bezierCurveTo: function(e, t, n, r, i, o) {
    this._context.bezierCurveTo(t, e, r, n, o, i);
  }
};
function Mne(e) {
  return new gw(e);
}
function kne(e) {
  return new One(e);
}
function Nne(e) {
  this._context = e;
}
Nne.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x = [], this._y = [];
  },
  lineEnd: function() {
    var e = this._x, t = this._y, n = e.length;
    if (n)
      if (this._line ? this._context.lineTo(e[0], t[0]) : this._context.moveTo(e[0], t[0]), n === 2)
        this._context.lineTo(e[1], t[1]);
      else
        for (var r = S9(e), i = S9(t), o = 0, a = 1; a < n; ++o, ++a)
          this._context.bezierCurveTo(r[0][o], i[0][o], r[1][o], i[1][o], e[a], t[a]);
    (this._line || this._line !== 0 && n === 1) && this._context.closePath(), this._line = 1 - this._line, this._x = this._y = null;
  },
  point: function(e, t) {
    this._x.push(+e), this._y.push(+t);
  }
};
function S9(e) {
  var t, n = e.length - 1, r, i = new Array(n), o = new Array(n), a = new Array(n);
  for (i[0] = 0, o[0] = 2, a[0] = e[0] + 2 * e[1], t = 1; t < n - 1; ++t)
    i[t] = 1, o[t] = 4, a[t] = 4 * e[t] + 2 * e[t + 1];
  for (i[n - 1] = 2, o[n - 1] = 7, a[n - 1] = 8 * e[n - 1] + e[n], t = 1; t < n; ++t)
    r = i[t] / o[t - 1], o[t] -= r, a[t] -= r * a[t - 1];
  for (i[n - 1] = a[n - 1] / o[n - 1], t = n - 2; t >= 0; --t)
    i[t] = (a[t] - i[t + 1]) / o[t];
  for (o[n - 1] = (e[n] + i[n - 1]) / 2, t = 0; t < n - 1; ++t)
    o[t] = 2 * e[t + 1] - i[t + 1];
  return [i, o];
}
function Dne(e) {
  return new Nne(e);
}
function eC(e, t) {
  this._context = e, this._t = t;
}
eC.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x = this._y = NaN, this._point = 0;
  },
  lineEnd: function() {
    0 < this._t && this._t < 1 && this._point === 2 && this._context.lineTo(this._x, this._y), (this._line || this._line !== 0 && this._point === 1) && this._context.closePath(), this._line >= 0 && (this._t = 1 - this._t, this._line = 1 - this._line);
  },
  point: function(e, t) {
    switch (e = +e, t = +t, this._point) {
      case 0:
        this._point = 1, this._line ? this._context.lineTo(e, t) : this._context.moveTo(e, t);
        break;
      case 1:
        this._point = 2;
      default: {
        if (this._t <= 0)
          this._context.lineTo(this._x, t), this._context.lineTo(e, t);
        else {
          var n = this._x * (1 - this._t) + e * this._t;
          this._context.lineTo(n, this._y), this._context.lineTo(n, t);
        }
        break;
      }
    }
    this._x = e, this._y = t;
  }
};
function Lne(e) {
  return new eC(e, 0.5);
}
function jne(e) {
  return new eC(e, 0);
}
function Fne(e) {
  return new eC(e, 1);
}
function qg(e, t) {
  if ((a = e.length) > 1)
    for (var n = 1, r, i, o = e[t[0]], a, s = o.length; n < a; ++n)
      for (i = o, o = e[t[n]], r = 0; r < s; ++r)
        o[r][1] += o[r][0] = isNaN(i[r][1]) ? i[r][0] : i[r][1];
}
function Gg(e) {
  for (var t = e.length, n = new Array(t); --t >= 0; )
    n[t] = t;
  return n;
}
function iXe(e, t) {
  return e[t];
}
function oXe(e) {
  const t = [];
  return t.key = e, t;
}
function aXe() {
  var e = rn([]), t = Gg, n = qg, r = iXe;
  function i(o) {
    var a = Array.from(e.apply(this, arguments), oXe), s, c = a.length, l = -1, u;
    for (const d of o)
      for (s = 0, ++l; s < c; ++s)
        (a[s][l] = [0, +r(d, a[s].key, l, o)]).data = d;
    for (s = 0, u = YE(t(a)); s < c; ++s)
      a[u[s]].index = s;
    return n(a, u), a;
  }
  return i.keys = function(o) {
    return arguments.length ? (e = typeof o == "function" ? o : rn(Array.from(o)), i) : e;
  }, i.value = function(o) {
    return arguments.length ? (r = typeof o == "function" ? o : rn(+o), i) : r;
  }, i.order = function(o) {
    return arguments.length ? (t = o == null ? Gg : typeof o == "function" ? o : rn(Array.from(o)), i) : t;
  }, i.offset = function(o) {
    return arguments.length ? (n = o ?? qg, i) : n;
  }, i;
}
function sXe(e, t) {
  if ((r = e.length) > 0) {
    for (var n, r, i = 0, o = e[0].length, a; i < o; ++i) {
      for (a = n = 0; n < r; ++n)
        a += e[n][i][1] || 0;
      if (a)
        for (n = 0; n < r; ++n)
          e[n][i][1] /= a;
    }
    qg(e, t);
  }
}
function cXe(e, t) {
  if ((c = e.length) > 0)
    for (var n, r = 0, i, o, a, s, c, l = e[t[0]].length; r < l; ++r)
      for (a = s = 0, n = 0; n < c; ++n)
        (o = (i = e[t[n]][r])[1] - i[0]) > 0 ? (i[0] = a, i[1] = a += o) : o < 0 ? (i[1] = s, i[0] = s += o) : (i[0] = 0, i[1] = o);
}
function lXe(e, t) {
  if ((i = e.length) > 0) {
    for (var n = 0, r = e[t[0]], i, o = r.length; n < o; ++n) {
      for (var a = 0, s = 0; a < i; ++a)
        s += e[a][n][1] || 0;
      r[n][1] += r[n][0] = -s / 2;
    }
    qg(e, t);
  }
}
function uXe(e, t) {
  if (!(!((a = e.length) > 0) || !((o = (i = e[t[0]]).length) > 0))) {
    for (var n = 0, r = 1, i, o, a; r < o; ++r) {
      for (var s = 0, c = 0, l = 0; s < a; ++s) {
        for (var u = e[t[s]], d = u[r][1] || 0, f = u[r - 1][1] || 0, h = (d - f) / 2, p = 0; p < s; ++p) {
          var g = e[t[p]], m = g[r][1] || 0, v = g[r - 1][1] || 0;
          h += m - v;
        }
        c += d, l += h * d;
      }
      i[r - 1][1] += i[r - 1][0] = n, c && (n -= l / c);
    }
    i[r - 1][1] += i[r - 1][0] = n, qg(e, t);
  }
}
function Vne(e) {
  var t = e.map(dXe);
  return Gg(e).sort(function(n, r) {
    return t[n] - t[r];
  });
}
function dXe(e) {
  for (var t = -1, n = 0, r = e.length, i, o = -1 / 0; ++t < r; )
    (i = +e[t][1]) > o && (o = i, n = t);
  return n;
}
function Bne(e) {
  var t = e.map(zne);
  return Gg(e).sort(function(n, r) {
    return t[n] - t[r];
  });
}
function zne(e) {
  for (var t = 0, n = -1, r = e.length, i; ++n < r; )
    (i = +e[n][1]) && (t += i);
  return t;
}
function fXe(e) {
  return Bne(e).reverse();
}
function hXe(e) {
  var t = e.length, n, r, i = e.map(zne), o = Vne(e), a = 0, s = 0, c = [], l = [];
  for (n = 0; n < t; ++n)
    r = o[n], a < s ? (a += i[r], c.push(r)) : (s += i[r], l.push(r));
  return l.reverse().concat(c);
}
function gXe(e) {
  return Gg(e).reverse();
}
const pXe = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  arc: KE,
  area: Gte,
  areaRadial: m9,
  curveBasis: hne,
  curveBasisClosed: pne,
  curveBasisOpen: vne,
  curveBumpX: Jte,
  curveBumpY: Zte,
  curveBundle: bne,
  curveCardinal: _ne,
  curveCardinalClosed: Sne,
  curveCardinalOpen: wne,
  curveCatmullRom: Ene,
  curveCatmullRomClosed: Tne,
  curveCatmullRomOpen: Ane,
  curveLinear: Hp,
  curveLinearClosed: $ne,
  curveMonotoneX: Mne,
  curveMonotoneY: kne,
  curveNatural: Dne,
  curveStep: Lne,
  curveStepAfter: Fne,
  curveStepBefore: jne,
  line: XE,
  lineRadial: GR,
  link: QE,
  linkHorizontal: qYe,
  linkRadial: KYe,
  linkVertical: GYe,
  pie: Kte,
  pointRadial: Gm,
  radialArea: m9,
  radialLine: GR,
  stack: aXe,
  stackOffsetDiverging: cXe,
  stackOffsetExpand: sXe,
  stackOffsetNone: qg,
  stackOffsetSilhouette: lXe,
  stackOffsetWiggle: uXe,
  stackOrderAppearance: Vne,
  stackOrderAscending: Bne,
  stackOrderDescending: fXe,
  stackOrderInsideOut: hXe,
  stackOrderNone: Gg,
  stackOrderReverse: gXe,
  symbol: rXe,
  symbolAsterisk: ene,
  symbolCircle: JE,
  symbolCross: tne,
  symbolDiamond: rne,
  symbolDiamond2: ine,
  symbolPlus: one,
  symbolSquare: ane,
  symbolSquare2: sne,
  symbolStar: lne,
  symbolTimes: YR,
  symbolTriangle: une,
  symbolTriangle2: dne,
  symbolWye: fne,
  symbolX: YR,
  symbols: v9,
  symbolsFill: v9,
  symbolsStroke: nXe
}, Symbol.toStringTag, { value: "Module" })), w9 = (e) => {
  const t = e._y1 !== void 0 ? e._y1 : e._y;
  return t != null && e._y0 !== null;
}, x9 = (e) => (t) => e.x(t._x1 !== void 0 ? t._x1 : t._x), _T = (e) => (t) => e.y(t._y1 !== void 0 ? t._y1 : t._y), mXe = (e) => (t) => -1 * e.x(t._x1 !== void 0 ? t._x1 : t._x) + Math.PI / 2, Hne = (e) => `curve${((n) => n && n[0].toUpperCase() + n.slice(1))(e)}`, vXe = (e) => `${Hne(e)}Closed`, E9 = (e) => {
  const {
    interpolation: t
  } = e;
  if (typeof t == "function")
    return t;
  if (typeof t == "string") {
    const {
      polar: n,
      openCurve: r = !n
    } = e, i = r ? Hne(t) : vXe(t);
    return pXe[i];
  }
  return Hp;
}, yXe = (e) => {
  const {
    polar: t,
    scale: n,
    horizontal: r
  } = e;
  return t ? GR().defined(w9).curve(E9(e)).angle(mXe(n)).radius(_T(n)) : XE().defined(w9).curve(E9(e)).x(r ? _T(n) : x9(n)).y(r ? x9(n) : _T(n));
};
function v3(e) {
  process.env.NODE_ENV !== "production" && console && console.warn && console.warn(e);
}
function bXe(e, t, n) {
  return `M ${e}, ${t}
      m ${-n}, 0
      a ${n}, ${n} 0 1,0 ${n * 2},0
      a ${n}, ${n} 0 1,0 ${-n * 2},0`;
}
function _Xe(e, t, n) {
  const r = 0.87 * n, i = e - r, o = t + r, a = e + r - i;
  return `M ${i}, ${o}
      h${a}
      v-${a}
      h-${a}
      z`;
}
function SXe(e, t, n) {
  const r = 0.87 * n, i = Math.sqrt(2 * (r * r));
  return `M ${e}, ${t + i}
      l ${i}, -${i}
      l -${i}, -${i}
      l -${i}, ${i}
      l ${i}, ${i}
      z`;
}
function wXe(e, t, n) {
  const r = n / 2 * Math.sqrt(3), i = e - n, o = e + n, a = t - n, s = t + r;
  return `M ${i}, ${a}
      L ${o}, ${a}
      L ${e}, ${s}
      z`;
}
function xXe(e, t, n) {
  const r = n / 2 * Math.sqrt(3), i = e - n, o = e + n, a = t - r, s = t + n;
  return `M ${i}, ${s}
      L ${o}, ${s}
      L ${e}, ${a}
      z`;
}
function EXe(e, t, n) {
  const r = 1.1 * n, i = r / 1.5;
  return `
      M ${e - i / 2}, ${t + r}
      v-${i}
      h-${i}
      v-${i}
      h${i}
      v-${i}
      h${i}
      v${i}
      h${i}
      v${i}
      h-${i}
      v${i}
      z`;
}
function CXe(e, t, n) {
  const r = 0.8 * n, i = r / 1.5;
  return `
      M ${e - i / 2}, ${t + r + i}
      v-${i * 2}
      h-${i}
      v-${i}
      h${i}
      v-${i}
      h${i}
      v${i}
      h${i}
      v${i}
      h-${i}
      v${i * 2}
      z`;
}
function TXe(e, t, n) {
  const r = 1.1 * n, i = r - r * 0.3, o = e - r, a = t + i / 2, s = e + r - o;
  return `M ${o}, ${a}
      h${s}
      v-${i}
      h-${s}
      z`;
}
function IXe(e, t, n) {
  const r = 1.35 * n, i = Math.PI / 5;
  return `M ${EM(10).map((a) => {
    const s = a % 2 === 0 ? r : r / 2;
    return `${s * Math.sin(i * (a + 1)) + e},
        ${s * Math.cos(i * (a + 1)) + t}`;
  }).join("L")} z`;
}
const AXe = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  circle: bXe,
  cross: CXe,
  diamond: SXe,
  minus: TXe,
  plus: EXe,
  square: _Xe,
  star: IXe,
  triangleDown: wXe,
  triangleUp: xXe
}, Symbol.toStringTag, { value: "Module" })), RXe = {
  blue: "#4F7DA1",
  pink: "#E2A37F",
  teal: "#00796B",
  purple: "#DF948A",
  green: "#8BC34A",
  orange: "#F4511E",
  cyan: "#006064",
  red: "#DF5A49",
  yellow: "#FFF59D"
}, Th = ["#252525", "#525252", "#737373", "#969696", "#bdbdbd", "#d9d9d9", "#f0f0f0"], bo = "#252525", ST = "#969696", $Xe = ["#334D5C", "#45B29D", "#EFC94C", "#E27A3F", "#DF5A49", "#4F7DA1", "#55DBC1", "#EFDA97", "#E2A37F", "#DF948A"], OXe = ["#428517", "#77D200", "#D6D305", "#EC8E19", "#C92B05"], PXe = ["#940031", "#C43343", "#DC5429", "#FF821D", "#FFAF55"], MXe = ["#2746B9", "#0B69D4", "#2794DB", "#31BB76", "#60E83B"], kXe = ["#FCAE91", "#FB6A4A", "#DE2D26", "#A50F15", "#750B0E"], NXe = ["#354722", "#466631", "#649146", "#8AB25C", "#A9C97E"], DXe = ["#002C61", "#004B8F", "#006BC9", "#3795E5", "#65B4F4"], LXe = "'Gill Sans', 'Seravek', 'Trebuchet MS', sans-serif", jXe = "normal", FXe = 14, sa = {
  width: 450,
  height: 300,
  padding: 50,
  colorScale: Th
}, mi = {
  fontFamily: LXe,
  fontSize: FXe,
  letterSpacing: jXe,
  padding: 10,
  fill: bo,
  stroke: "transparent"
}, VXe = Object.assign({
  textAnchor: "middle"
}, mi), BXe = "round", zXe = "round", HXe = {
  palette: {
    colors: RXe,
    grayscale: Th,
    qualitative: $Xe,
    heatmap: OXe,
    warm: PXe,
    cool: MXe,
    red: kXe,
    green: NXe,
    blue: DXe
  },
  area: Object.assign({
    style: {
      data: {
        fill: bo
      },
      labels: mi
    }
  }, sa),
  axis: Object.assign({
    style: {
      axis: {
        fill: "transparent",
        stroke: bo,
        strokeWidth: 1,
        strokeLinecap: BXe,
        strokeLinejoin: zXe
      },
      axisLabel: Object.assign({}, VXe, {
        padding: 25
      }),
      grid: {
        fill: "none",
        stroke: "none",
        pointerEvents: "painted"
      },
      ticks: {
        fill: "transparent",
        size: 1,
        stroke: "transparent"
      },
      tickLabels: mi
    }
  }, sa),
  bar: Object.assign({
    style: {
      data: {
        fill: bo,
        padding: 8,
        strokeWidth: 0
      },
      labels: mi
    }
  }, sa),
  boxplot: Object.assign({
    style: {
      max: {
        padding: 8,
        stroke: bo,
        strokeWidth: 1
      },
      maxLabels: Object.assign({}, mi, {
        padding: 3
      }),
      median: {
        padding: 8,
        stroke: bo,
        strokeWidth: 1
      },
      medianLabels: Object.assign({}, mi, {
        padding: 3
      }),
      min: {
        padding: 8,
        stroke: bo,
        strokeWidth: 1
      },
      minLabels: Object.assign({}, mi, {
        padding: 3
      }),
      q1: {
        padding: 8,
        fill: ST
      },
      q1Labels: Object.assign({}, mi, {
        padding: 3
      }),
      q3: {
        padding: 8,
        fill: ST
      },
      q3Labels: Object.assign({}, mi, {
        padding: 3
      })
    },
    boxWidth: 20
  }, sa),
  candlestick: Object.assign({
    style: {
      data: {
        stroke: bo,
        strokeWidth: 1
      },
      labels: Object.assign({}, mi, {
        padding: 5
      })
    },
    candleColors: {
      positive: "#ffffff",
      negative: bo
    }
  }, sa),
  chart: sa,
  errorbar: Object.assign({
    borderWidth: 8,
    style: {
      data: {
        fill: "transparent",
        stroke: bo,
        strokeWidth: 2
      },
      labels: mi
    }
  }, sa),
  group: Object.assign({
    colorScale: Th
  }, sa),
  histogram: Object.assign({
    style: {
      data: {
        fill: ST,
        stroke: bo,
        strokeWidth: 2
      },
      labels: mi
    }
  }, sa),
  legend: {
    colorScale: Th,
    gutter: 10,
    orientation: "vertical",
    titleOrientation: "top",
    style: {
      data: {
        type: "circle"
      },
      labels: mi,
      title: Object.assign({}, mi, {
        padding: 5
      })
    }
  },
  line: Object.assign({
    style: {
      data: {
        fill: "transparent",
        stroke: bo,
        strokeWidth: 2
      },
      labels: mi
    }
  }, sa),
  pie: {
    style: {
      data: {
        padding: 10,
        stroke: "transparent",
        strokeWidth: 1
      },
      labels: Object.assign({}, mi, {
        padding: 20
      })
    },
    colorScale: Th,
    width: 400,
    height: 400,
    padding: 50
  },
  scatter: Object.assign({
    style: {
      data: {
        fill: bo,
        stroke: "transparent",
        strokeWidth: 0
      },
      labels: mi
    }
  }, sa),
  stack: Object.assign({
    colorScale: Th
  }, sa),
  tooltip: {
    style: Object.assign({}, mi, {
      padding: 0,
      pointerEvents: "none"
    }),
    flyoutStyle: {
      stroke: bo,
      strokeWidth: 1,
      fill: "#f0f0f0",
      pointerEvents: "none"
    },
    flyoutPadding: 5,
    cornerRadius: 5,
    pointerLength: 10
  },
  voronoi: Object.assign({
    style: {
      data: {
        fill: "transparent",
        stroke: "transparent",
        strokeWidth: 0
      },
      labels: Object.assign({}, mi, {
        padding: 5,
        pointerEvents: "none"
      }),
      flyout: {
        stroke: bo,
        strokeWidth: 1,
        fill: "#f0f0f0",
        pointerEvents: "none"
      }
    }
  }, sa)
}, Une = "#FFF59D", Wne = "#F4511E", UXe = "#DCE775", qne = "#8BC34A", Gne = "#00796B", Kne = "#006064", r1 = [Wne, Une, UXe, qne, Gne, Kne], XR = "#ECEFF1", QR = "#90A4AE", wo = "#455A64", Km = "#212121", WXe = {
  blue: "#4F7DA1",
  pink: "#E2A37F",
  teal: Gne,
  purple: "#DF948A",
  green: qne,
  orange: Wne,
  cyan: Kne,
  red: "#DF5A49",
  yellow: Une
}, qXe = [XR, QR, wo, Km], GXe = ["#334D5C", "#45B29D", "#EFC94C", "#E27A3F", "#DF5A49", "#4F7DA1", "#55DBC1", "#EFDA97", "#E2A37F", "#DF948A"], KXe = ["#428517", "#77D200", "#D6D305", "#EC8E19", "#C92B05"], YXe = ["#940031", "#C43343", "#DC5429", "#FF821D", "#FFAF55"], XXe = ["#2746B9", "#0B69D4", "#2794DB", "#31BB76", "#60E83B"], QXe = ["#FCAE91", "#FB6A4A", "#DE2D26", "#A50F15", "#750B0E"], JXe = ["#354722", "#466631", "#649146", "#8AB25C", "#A9C97E"], ZXe = ["#002C61", "#004B8F", "#006BC9", "#3795E5", "#65B4F4"], eQe = "'Helvetica Neue', 'Helvetica', sans-serif", tQe = "normal", nQe = 12, Rc = 8, Fo = {
  width: 350,
  height: 350,
  padding: 50
}, vi = {
  fontFamily: eQe,
  fontSize: nQe,
  letterSpacing: tQe,
  padding: Rc,
  fill: wo,
  stroke: "transparent",
  strokeWidth: 0
}, rQe = Object.assign({
  textAnchor: "middle"
}, vi), iQe = "10, 5", wT = "round", xT = "round", oQe = {
  palette: {
    colors: WXe,
    grayscale: qXe,
    qualitative: GXe,
    heatmap: KXe,
    warm: YXe,
    cool: XXe,
    red: QXe,
    green: JXe,
    blue: ZXe
  },
  area: Object.assign({
    style: {
      data: {
        fill: Km
      },
      labels: vi
    }
  }, Fo),
  axis: Object.assign({
    style: {
      axis: {
        fill: "transparent",
        stroke: QR,
        strokeWidth: 2,
        strokeLinecap: wT,
        strokeLinejoin: xT
      },
      axisLabel: Object.assign({}, rQe, {
        padding: Rc,
        stroke: "transparent"
      }),
      grid: {
        fill: "none",
        stroke: XR,
        strokeDasharray: iQe,
        strokeLinecap: wT,
        strokeLinejoin: xT,
        pointerEvents: "painted"
      },
      ticks: {
        fill: "transparent",
        size: 5,
        stroke: QR,
        strokeWidth: 1,
        strokeLinecap: wT,
        strokeLinejoin: xT
      },
      tickLabels: Object.assign({}, vi, {
        fill: wo
      })
    }
  }, Fo),
  polarDependentAxis: Object.assign({
    style: {
      ticks: {
        fill: "transparent",
        size: 1,
        stroke: "transparent"
      }
    }
  }),
  bar: Object.assign({
    style: {
      data: {
        fill: wo,
        padding: Rc,
        strokeWidth: 0
      },
      labels: vi
    }
  }, Fo),
  boxplot: Object.assign({
    style: {
      max: {
        padding: Rc,
        stroke: wo,
        strokeWidth: 1
      },
      maxLabels: Object.assign({}, vi, {
        padding: 3
      }),
      median: {
        padding: Rc,
        stroke: wo,
        strokeWidth: 1
      },
      medianLabels: Object.assign({}, vi, {
        padding: 3
      }),
      min: {
        padding: Rc,
        stroke: wo,
        strokeWidth: 1
      },
      minLabels: Object.assign({}, vi, {
        padding: 3
      }),
      q1: {
        padding: Rc,
        fill: wo
      },
      q1Labels: Object.assign({}, vi, {
        padding: 3
      }),
      q3: {
        padding: Rc,
        fill: wo
      },
      q3Labels: Object.assign({}, vi, {
        padding: 3
      })
    },
    boxWidth: 20
  }, Fo),
  candlestick: Object.assign({
    style: {
      data: {
        stroke: wo
      },
      labels: Object.assign({}, vi, {
        padding: 5
      })
    },
    candleColors: {
      positive: "#ffffff",
      negative: wo
    }
  }, Fo),
  chart: Fo,
  errorbar: Object.assign({
    borderWidth: 8,
    style: {
      data: {
        fill: "transparent",
        opacity: 1,
        stroke: wo,
        strokeWidth: 2
      },
      labels: vi
    }
  }, Fo),
  group: Object.assign({
    colorScale: r1
  }, Fo),
  histogram: Object.assign({
    style: {
      data: {
        fill: wo,
        stroke: Km,
        strokeWidth: 2
      },
      labels: vi
    }
  }, Fo),
  legend: {
    colorScale: r1,
    gutter: 10,
    orientation: "vertical",
    titleOrientation: "top",
    style: {
      data: {
        type: "circle"
      },
      labels: vi,
      title: Object.assign({}, vi, {
        padding: 5
      })
    }
  },
  line: Object.assign({
    style: {
      data: {
        fill: "transparent",
        opacity: 1,
        stroke: wo,
        strokeWidth: 2
      },
      labels: vi
    }
  }, Fo),
  pie: Object.assign({
    colorScale: r1,
    style: {
      data: {
        padding: Rc,
        stroke: XR,
        strokeWidth: 1
      },
      labels: Object.assign({}, vi, {
        padding: 20
      })
    }
  }, Fo),
  scatter: Object.assign({
    style: {
      data: {
        fill: wo,
        opacity: 1,
        stroke: "transparent",
        strokeWidth: 0
      },
      labels: vi
    }
  }, Fo),
  stack: Object.assign({
    colorScale: r1
  }, Fo),
  tooltip: {
    style: Object.assign({}, vi, {
      padding: 0,
      pointerEvents: "none"
    }),
    flyoutStyle: {
      stroke: Km,
      strokeWidth: 1,
      fill: "#f0f0f0",
      pointerEvents: "none"
    },
    flyoutPadding: 5,
    cornerRadius: 5,
    pointerLength: 10
  },
  voronoi: Object.assign({
    style: {
      data: {
        fill: "transparent",
        stroke: "transparent",
        strokeWidth: 0
      },
      labels: Object.assign({}, vi, {
        padding: 5,
        pointerEvents: "none"
      }),
      flyout: {
        stroke: Km,
        strokeWidth: 1,
        fill: "#f0f0f0",
        pointerEvents: "none"
      }
    }
  }, Fo)
}, lr = {
  white: "#FFFFFF",
  50: "#FAFAFA",
  100: "#F2F2F2",
  200: "#E8E8E8",
  300: "#E0E0E0",
  400: "#D1D1D1",
  500: "#757575",
  600: "#5C5C5C",
  700: "#424242",
  800: "#333333",
  900: "#292929",
  black: "#0F0F0F"
}, pw = {
  100: "#FFEAB6",
  300: "#FFD66E",
  500: "#FCB400",
  900: "#B87503"
}, mw = {
  100: "#FEE2D5",
  300: "#FFA981",
  500: "#FF6F2C",
  700: "#FF4E1B",
  900: "#D74D26"
}, My = {
  100: "#FFDCE5",
  300: "#FF9EB7",
  500: "#F82B60",
  700: "#D31A3D",
  900: "#BA1E45"
}, Yne = {
  100: "#EDE3FE",
  300: "#CDB0FF",
  500: "#8B46FF",
  900: "#6B1CB0"
}, ky = {
  100: "#CFDFFF",
  300: "#9CC7FF",
  500: "#2D7FF9",
  700: "#0056B3",
  900: "#2750AE"
}, y3 = {
  100: "#D0F0FD",
  300: "#77D1F3",
  500: "#18BFFF",
  900: "#0B76B7"
}, Xne = {
  100: "#C2F5E9",
  300: "#72DDC3",
  500: "#20D9D2",
  900: "#06A09B"
}, Kg = {
  100: "#D1F7C4",
  300: "#93E088",
  500: "#20C933",
  700: "#1B9B2A",
  900: "#338A17"
}, Qne = {
  blue: ky[500],
  cyan: y3[500],
  green: Kg[500],
  yellow: pw[500],
  orange: mw[500],
  red: My[500],
  purple: Yne[500],
  teal: Xne[500]
}, $l = Object.values(Qne), aQe = [lr[100], lr[300], lr[500], lr[700], lr[900]], sQe = [pw[300], pw[500], mw[500], mw[900], My[500]], cQe = [Yne[500], ky[500], y3[500], Xne[500], Kg[500]], lQe = [Kg[900], Kg[500], pw[500], mw[500], My[500]], uQe = Object.values(My), dQe = Object.values(Kg), fQe = Object.values(ky), Sm = ky[500], hQe = "'Inter', 'Helvetica Neue', 'Seravek', 'Helvetica', sans-serif", gQe = "normal", pQe = 12, $c = 8, Vo = {
  width: 450,
  height: 300,
  padding: 60,
  colorScale: $l
}, zr = {
  fontFamily: hQe,
  fontSize: pQe,
  fontWeight: 300,
  letterSpacing: gQe,
  padding: $c,
  fill: lr[900],
  stroke: "transparent"
}, mQe = Object.assign({
  textAnchor: "middle"
}, zr), C9 = "10, 5", rd = "round", uh = "round", id = 1, vQe = {
  palette: {
    colors: Qne,
    grayscale: aQe,
    qualitative: $l,
    heatmap: lQe,
    warm: sQe,
    cool: cQe,
    red: uQe,
    green: dQe,
    blue: fQe
  },
  area: Object.assign({
    style: {
      data: {
        fill: Sm,
        strokeWidth: 2,
        fillOpacity: 0.5
      },
      labels: zr
    }
  }, Vo),
  axis: Object.assign({
    style: {
      axis: {
        fill: "transparent",
        stroke: lr[500],
        strokeWidth: 1,
        strokeLinecap: rd,
        strokeLinejoin: uh
      },
      axisLabel: Object.assign({}, mQe, {
        padding: 35,
        stroke: "transparent"
      }),
      grid: {
        fill: "none",
        stroke: "none",
        painterEvents: "painted"
      },
      ticks: {
        fill: "transparent",
        size: 5,
        stroke: "transparent"
      },
      tickLabels: zr
    }
  }, Vo),
  polarAxis: Object.assign({
    style: {
      axis: {
        stroke: lr[500]
      },
      grid: {
        stroke: lr[400],
        strokeDasharray: C9,
        strokeLinecap: rd,
        strokeLinejoin: uh,
        pointerEvents: "painted"
      },
      ticks: {
        fill: "transparent",
        size: 5,
        stroke: lr[400],
        strokeWidth: 1,
        strokeLinecap: rd,
        strokeLinejoin: uh
      },
      tickLabels: zr
    }
  }),
  polarDependentAxis: Object.assign({
    style: {
      axis: {
        stroke: lr[500]
      },
      grid: {
        stroke: lr[400],
        strokeDasharray: C9,
        strokeLinecap: rd,
        strokeLinejoin: uh,
        pointerEvents: "painted"
      },
      ticks: {
        fill: "transparent",
        size: 5,
        stroke: lr[300],
        strokeWidth: 1,
        strokeLinecap: rd,
        strokeLinejoin: uh
      },
      tickLabels: zr
    }
  }),
  bar: Object.assign({
    style: {
      data: {
        fill: Sm,
        padding: $c,
        strokeWidth: 1,
        fillOpacity: 0.5
      },
      labels: zr
    },
    cornerRadius: {
      top: id
    }
  }, Vo),
  boxplot: Object.assign({
    style: {
      max: {
        padding: $c,
        stroke: lr[400],
        strokeWidth: 2
      },
      maxLabels: Object.assign({}, zr, {
        padding: 3
      }),
      median: {
        padding: $c,
        stroke: lr.white,
        strokeWidth: 2
      },
      medianLabels: Object.assign({}, zr, {
        padding: 3
      }),
      min: {
        padding: $c,
        stroke: lr[400],
        strokeWidth: 2
      },
      minLabels: Object.assign({}, zr, {
        padding: 3
      }),
      q1: {
        padding: $c,
        fill: $l[0],
        rx: id,
        strokeWidth: 2
      },
      q1Labels: Object.assign({}, zr, {
        padding: 3
      }),
      q3: {
        padding: $c,
        fill: $l[1],
        rx: id
      },
      q3Labels: Object.assign({}, zr, {
        padding: 3
      })
    },
    boxWidth: 20
  }, Vo),
  candlestick: Object.assign({
    style: {
      data: {
        stroke: lr[300],
        strokeWidth: 0,
        rx: id
      },
      labels: Object.assign({}, zr, {
        padding: 5
      })
    },
    candleColors: {
      positive: Kg[500],
      negative: My[500]
    },
    wickStrokeWidth: 2
  }, Vo),
  chart: Vo,
  errorbar: Object.assign({
    borderWidth: 8,
    style: {
      data: {
        fill: "transparent",
        opacity: 1,
        stroke: lr[700],
        strokeWidth: 2,
        strokeLinecap: rd
      },
      labels: zr
    }
  }, Vo),
  group: Object.assign({
    colorScale: $l
  }, Vo),
  histogram: Object.assign({
    style: {
      data: {
        fill: y3[500],
        fillOpacity: 0.5
      },
      labels: zr
    },
    binSpacing: 4,
    cornerRadius: {
      top: id
    }
  }, Vo),
  label: zr,
  legend: {
    colorScale: $l,
    gutter: 24,
    borderPadding: 10,
    orientation: "horizontal",
    titleOrientation: "top",
    centerTitle: !0,
    style: {
      data: {
        type: "circle"
      },
      labels: {
        ...zr,
        fontSize: 12
      },
      title: Object.assign({}, zr, {
        padding: $c,
        fontSize: 16
      }),
      border: {
        stroke: lr[200],
        strokeWidth: 2,
        padding: 16
      }
    }
  },
  line: Object.assign({
    style: {
      data: {
        fill: "transparent",
        opacity: 1,
        stroke: Sm,
        strokeWidth: 2,
        strokeLinecap: rd,
        strokeLinejoin: uh
      },
      labels: zr
    }
  }, Vo),
  pie: Object.assign({
    style: {
      parent: {
        backgroundColor: lr.white
      },
      data: {
        padding: $c,
        stroke: lr.white,
        strokeWidth: 1
      },
      labels: {
        ...zr,
        padding: 20,
        fill: lr[600],
        fontSize: 10
      }
    },
    colorScale: $l,
    cornerRadius: id
  }, Vo),
  scatter: Object.assign({
    style: {
      data: {
        fill: Sm,
        opacity: 1,
        stroke: "transparent",
        strokeWidth: 0
      },
      labels: {
        ...zr,
        padding: 20
      }
    }
  }, Vo),
  stack: Object.assign({
    colorScale: $l
  }, Vo),
  tooltip: {
    style: Object.assign({}, zr, {
      padding: 0,
      pointerEvents: "none"
    }),
    flyoutStyle: {
      stroke: lr[300],
      strokeWidth: 2,
      fill: lr.white,
      pointerEvents: "none"
    },
    flyoutPadding: {
      top: 8,
      bottom: 8,
      left: 16,
      right: 16
    },
    cornerRadius: id,
    pointerLength: 4
  },
  voronoi: Object.assign({
    style: {
      data: {
        fill: ky[100],
        stroke: Sm,
        strokeWidth: 2
      },
      labels: Object.assign({}, zr, {
        padding: 5,
        pointerEvents: "none"
      }),
      flyout: {
        stroke: lr[900],
        strokeWidth: 1,
        fill: lr[100],
        pointerEvents: "none"
      },
      padding: {
        left: 2,
        bottom: 2
      }
    }
  }, Vo)
}, Ca = {
  grayscale: HXe,
  material: oQe,
  clean: vQe
}, JR = function(e) {
  for (var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++)
    n[r - 1] = arguments[r];
  if (n.length > 0)
    return n.reduce((o, a) => [o, JR(a)].join(" "), JR(e)).trim();
  if (e == null || typeof e == "string")
    return e;
  const i = [];
  for (const o in e)
    if (e.hasOwnProperty(o)) {
      const a = e[o];
      i.push(`${o}(${a})`);
    }
  return i.join(" ").trim();
};
function b3(e, t) {
  var f;
  t === void 0 && (t = Ca.material);
  const {
    palette: {
      grayscale: n = ["#cccccc", "#969696", "#636363", "#252525"],
      qualitative: r = [],
      heatmap: i = [],
      warm: o = [],
      cool: a = [],
      red: s = [],
      blue: c = [],
      green: l = []
    } = {}
  } = t, u = {
    grayscale: n,
    qualitative: r,
    heatmap: i,
    warm: o,
    cool: a,
    red: s,
    blue: c,
    green: l
  };
  return e && ((f = u[e]) != null && f.length) ? u[e] : u.grayscale;
}
const T9 = {
  "American Typewriter": {
    widths: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0.25, 0.4203125, 0.3296875, 0.6, 0.6375, 0.8015625, 0.8203125, 0.1875, 0.45625, 0.45625, 0.6375, 0.5, 0.2734375, 0.309375, 0.2734375, 0.4390625, 0.6375, 0.6375, 0.6375, 0.6375, 0.6375, 0.6375, 0.6375, 0.6375, 0.6375, 0.6375, 0.2734375, 0.2734375, 0.5, 0.5, 0.5, 0.6, 0.6921875, 0.7640625, 0.6921875, 0.6375, 0.728125, 0.6734375, 0.6203125, 0.7109375, 0.784375, 0.3828125, 0.6421875, 0.7859375, 0.6375, 0.9484375, 0.7640625, 0.65625, 0.6375, 0.65625, 0.7296875, 0.6203125, 0.6375, 0.7109375, 0.740625, 0.940625, 0.784375, 0.7578125, 0.6203125, 0.4375, 0.5, 0.4375, 0.5, 0.5, 0.4921875, 0.5734375, 0.5890625, 0.5109375, 0.6, 0.528125, 0.43125, 0.5578125, 0.6375, 0.3109375, 0.40625, 0.6234375, 0.309375, 0.928125, 0.6375, 0.546875, 0.6, 0.58125, 0.4921875, 0.4921875, 0.4, 0.6203125, 0.625, 0.825, 0.6375, 0.640625, 0.528125, 0.5, 0.5, 0.5, 0.6671875],
    avg: 0.5793421052631578
  },
  Arial: {
    widths: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0.278125, 0.278125, 0.35625, 0.55625, 0.55625, 0.890625, 0.6671875, 0.1921875, 0.334375, 0.334375, 0.390625, 0.584375, 0.278125, 0.334375, 0.278125, 0.278125, 0.55625, 0.55625, 0.55625, 0.55625, 0.55625, 0.55625, 0.55625, 0.55625, 0.55625, 0.55625, 0.278125, 0.278125, 0.584375, 0.584375, 0.584375, 0.55625, 1.015625, 0.6703125, 0.6671875, 0.7234375, 0.7234375, 0.6671875, 0.6109375, 0.778125, 0.7234375, 0.278125, 0.5, 0.6671875, 0.55625, 0.834375, 0.7234375, 0.778125, 0.6671875, 0.778125, 0.7234375, 0.6671875, 0.6109375, 0.7234375, 0.6671875, 0.9453125, 0.6671875, 0.6671875, 0.6109375, 0.278125, 0.278125, 0.278125, 0.4703125, 0.584375, 0.334375, 0.55625, 0.55625, 0.5, 0.55625, 0.55625, 0.3125, 0.55625, 0.55625, 0.2234375, 0.2703125, 0.5, 0.2234375, 0.834375, 0.55625, 0.55625, 0.55625, 0.55625, 0.346875, 0.5, 0.278125, 0.55625, 0.5, 0.7234375, 0.5, 0.5, 0.5, 0.334375, 0.2609375, 0.334375, 0.584375],
    avg: 0.528733552631579
  },
  "Arial Black": {
    widths: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0.33125, 0.334375, 0.5, 0.6609375, 0.6671875, 1, 0.890625, 0.278125, 0.390625, 0.390625, 0.55625, 0.6609375, 0.334375, 0.334375, 0.334375, 0.28125, 0.6671875, 0.6671875, 0.6671875, 0.6671875, 0.6671875, 0.6671875, 0.6671875, 0.6671875, 0.6671875, 0.6671875, 0.334375, 0.334375, 0.6609375, 0.6609375, 0.6609375, 0.6109375, 0.7453125, 0.78125, 0.778125, 0.778125, 0.778125, 0.7234375, 0.6671875, 0.834375, 0.834375, 0.390625, 0.6671875, 0.834375, 0.6671875, 0.9453125, 0.834375, 0.834375, 0.7234375, 0.834375, 0.78125, 0.7234375, 0.7234375, 0.834375, 0.7796875, 1.003125, 0.78125, 0.78125, 0.7234375, 0.390625, 0.28125, 0.390625, 0.6609375, 0.5125, 0.334375, 0.6671875, 0.6671875, 0.6671875, 0.6671875, 0.6671875, 0.41875, 0.6671875, 0.6671875, 0.334375, 0.384375, 0.6671875, 0.334375, 1, 0.6671875, 0.6671875, 0.6671875, 0.6671875, 0.4703125, 0.6109375, 0.4453125, 0.6671875, 0.6140625, 0.946875, 0.6671875, 0.615625, 0.55625, 0.390625, 0.278125, 0.390625, 0.6609375],
    avg: 0.6213157894736842
  },
  Baskerville: {
    widths: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0.25, 0.25, 0.40625, 0.6671875, 0.490625, 0.875, 0.7015625, 0.178125, 0.2453125, 0.246875, 0.4171875, 0.6671875, 0.25, 0.3125, 0.25, 0.521875, 0.5, 0.5, 0.5, 0.5, 0.5, 0.5, 0.5, 0.5, 0.5, 0.5, 0.25, 0.25, 0.6671875, 0.6671875, 0.6671875, 0.396875, 0.9171875, 0.684375, 0.615625, 0.71875, 0.7609375, 0.625, 0.553125, 0.771875, 0.803125, 0.3546875, 0.515625, 0.78125, 0.6046875, 0.928125, 0.75, 0.8234375, 0.5625, 0.96875, 0.7296875, 0.5421875, 0.6984375, 0.771875, 0.7296875, 0.9484375, 0.771875, 0.678125, 0.6359375, 0.3640625, 0.521875, 0.3640625, 0.46875, 0.5125, 0.334375, 0.46875, 0.521875, 0.428125, 0.521875, 0.4375, 0.3890625, 0.4765625, 0.53125, 0.25, 0.359375, 0.4640625, 0.240625, 0.803125, 0.53125, 0.5, 0.521875, 0.521875, 0.365625, 0.334375, 0.2921875, 0.521875, 0.4640625, 0.678125, 0.4796875, 0.465625, 0.428125, 0.4796875, 0.5109375, 0.4796875, 0.6671875],
    avg: 0.5323519736842108
  },
  Courier: {
    widths: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0.5984375, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6078125, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.61875, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.615625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6140625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625],
    avg: 0.6020559210526316
  },
  "Courier New": {
    widths: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0.5984375, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625],
    avg: 0.6015296052631579
  },
  cursive: {
    widths: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0.1921875, 0.24375, 0.40625, 0.5671875, 0.3984375, 0.721875, 0.909375, 0.2328125, 0.434375, 0.365625, 0.4734375, 0.5578125, 0.19375, 0.3484375, 0.19375, 0.7734375, 0.503125, 0.4171875, 0.5453125, 0.45, 0.6046875, 0.4703125, 0.5984375, 0.55625, 0.503125, 0.5546875, 0.20625, 0.2, 0.5625, 0.5546875, 0.546875, 0.403125, 0.70625, 0.734375, 0.7078125, 0.64375, 0.85, 0.753125, 0.75, 0.6484375, 1.0765625, 0.44375, 0.5359375, 0.8359375, 0.653125, 1.0109375, 1.1515625, 0.6796875, 0.6984375, 1.0625, 0.8234375, 0.5125, 0.9234375, 0.8546875, 0.70625, 0.9109375, 0.7421875, 0.715625, 0.6015625, 0.4640625, 0.3359375, 0.4109375, 0.5421875, 0.5421875, 0.4328125, 0.5125, 0.5, 0.3859375, 0.7375, 0.359375, 0.75625, 0.540625, 0.5328125, 0.3203125, 0.5296875, 0.5015625, 0.484375, 0.7890625, 0.5640625, 0.4203125, 0.703125, 0.471875, 0.4734375, 0.35, 0.4125, 0.5640625, 0.471875, 0.6484375, 0.5296875, 0.575, 0.4140625, 0.415625, 0.20625, 0.3796875, 0.5421875],
    avg: 0.5604440789473684
  },
  fantasy: {
    widths: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0.215625, 0.2625, 0.3265625, 0.6109375, 0.534375, 0.7625, 0.7828125, 0.2, 0.4359375, 0.4359375, 0.3765625, 0.5109375, 0.2796875, 0.4609375, 0.2796875, 0.5296875, 0.6640625, 0.253125, 0.521875, 0.4765625, 0.6640625, 0.490625, 0.528125, 0.5546875, 0.496875, 0.5421875, 0.2796875, 0.2796875, 0.5625, 0.4609375, 0.5625, 0.4828125, 0.609375, 0.740625, 0.7234375, 0.740625, 0.8265625, 0.7234375, 0.6171875, 0.7359375, 0.765625, 0.240625, 0.5453125, 0.715625, 0.6078125, 0.8640625, 0.653125, 0.9125, 0.6484375, 0.946875, 0.6921875, 0.653125, 0.6953125, 0.8015625, 0.58125, 0.784375, 0.671875, 0.6265625, 0.690625, 0.4359375, 0.5296875, 0.4359375, 0.53125, 0.5, 0.2875, 0.5375, 0.603125, 0.4984375, 0.60625, 0.53125, 0.434375, 0.6421875, 0.56875, 0.209375, 0.4671875, 0.5484375, 0.2203125, 0.709375, 0.55, 0.5984375, 0.6140625, 0.5765625, 0.40625, 0.4734375, 0.3734375, 0.559375, 0.4421875, 0.6421875, 0.4890625, 0.578125, 0.4484375, 0.2546875, 0.2203125, 0.2546875, 0.55],
    avg: 0.536496710526316
  },
  Geneva: {
    widths: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0.3328125, 0.3046875, 0.5, 0.6671875, 0.6671875, 0.90625, 0.728125, 0.3046875, 0.446875, 0.446875, 0.5078125, 0.6671875, 0.3046875, 0.3796875, 0.3046875, 0.5390625, 0.6671875, 0.6671875, 0.6671875, 0.6671875, 0.6671875, 0.6671875, 0.6671875, 0.6671875, 0.6671875, 0.6671875, 0.3046875, 0.3046875, 0.6671875, 0.6671875, 0.6671875, 0.56875, 0.871875, 0.728125, 0.6375, 0.6515625, 0.7015625, 0.5765625, 0.5546875, 0.675, 0.690625, 0.2421875, 0.4921875, 0.6640625, 0.584375, 0.7890625, 0.709375, 0.7359375, 0.584375, 0.78125, 0.60625, 0.60625, 0.640625, 0.6671875, 0.728125, 0.946875, 0.6109375, 0.6109375, 0.5765625, 0.446875, 0.5390625, 0.446875, 0.6671875, 0.6671875, 0.5921875, 0.5546875, 0.6109375, 0.546875, 0.603125, 0.5765625, 0.390625, 0.6109375, 0.584375, 0.2359375, 0.334375, 0.5390625, 0.2359375, 0.8953125, 0.584375, 0.60625, 0.603125, 0.603125, 0.3875, 0.509375, 0.44375, 0.584375, 0.565625, 0.78125, 0.53125, 0.571875, 0.5546875, 0.4515625, 0.246875, 0.4515625, 0.6671875],
    avg: 0.5762664473684211
  },
  Georgia: {
    widths: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0.2421875, 0.33125, 0.4125, 0.64375, 0.6109375, 0.81875, 0.7109375, 0.215625, 0.375, 0.375, 0.4734375, 0.64375, 0.2703125, 0.375, 0.2703125, 0.46875, 0.6140625, 0.4296875, 0.559375, 0.553125, 0.565625, 0.5296875, 0.5671875, 0.503125, 0.596875, 0.5671875, 0.3125, 0.3125, 0.64375, 0.64375, 0.64375, 0.4796875, 0.9296875, 0.715625, 0.6546875, 0.6421875, 0.75, 0.6546875, 0.6, 0.7265625, 0.815625, 0.390625, 0.51875, 0.7203125, 0.6046875, 0.928125, 0.7671875, 0.7453125, 0.6109375, 0.7453125, 0.7234375, 0.5625, 0.61875, 0.7578125, 0.70625, 0.99375, 0.7125, 0.6640625, 0.6015625, 0.375, 0.46875, 0.375, 0.64375, 0.65, 0.5, 0.5046875, 0.56875, 0.4546875, 0.575, 0.484375, 0.39375, 0.509375, 0.5828125, 0.29375, 0.3671875, 0.546875, 0.2875, 0.88125, 0.5921875, 0.5390625, 0.571875, 0.5640625, 0.4109375, 0.4328125, 0.3453125, 0.5765625, 0.5203125, 0.75625, 0.50625, 0.5171875, 0.4453125, 0.43125, 0.375, 0.43125, 0.64375],
    avg: 0.5551809210526316
  },
  "Gill Sans": {
    widths: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0.2765625, 0.271875, 0.3546875, 0.584375, 0.5421875, 0.6765625, 0.625, 0.1890625, 0.3234375, 0.3234375, 0.4171875, 0.584375, 0.2203125, 0.3234375, 0.2203125, 0.28125, 0.5, 0.5, 0.5, 0.5, 0.5, 0.5, 0.5, 0.5, 0.5, 0.5, 0.2203125, 0.2296875, 0.584375, 0.584375, 0.584375, 0.334375, 1.0109375, 0.6671875, 0.5640625, 0.709375, 0.75, 0.5, 0.4703125, 0.740625, 0.7296875, 0.25, 0.3125, 0.65625, 0.490625, 0.78125, 0.78125, 0.8234375, 0.5109375, 0.8234375, 0.6046875, 0.459375, 0.6046875, 0.709375, 0.6046875, 1.0421875, 0.709375, 0.6046875, 0.646875, 0.334375, 0.28125, 0.334375, 0.4703125, 0.5828125, 0.334375, 0.428125, 0.5, 0.4390625, 0.5109375, 0.4796875, 0.296875, 0.428125, 0.5, 0.2203125, 0.2265625, 0.5, 0.2203125, 0.771875, 0.5, 0.553125, 0.5, 0.5, 0.3984375, 0.3859375, 0.334375, 0.5, 0.4390625, 0.7203125, 0.5, 0.4390625, 0.4171875, 0.334375, 0.2609375, 0.334375, 0.584375],
    avg: 0.4933717105263159
  },
  Helvetica: {
    widths: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0.2796875, 0.2765625, 0.3546875, 0.5546875, 0.5546875, 0.8890625, 0.665625, 0.190625, 0.3328125, 0.3328125, 0.3890625, 0.5828125, 0.2765625, 0.3328125, 0.2765625, 0.3015625, 0.5546875, 0.5546875, 0.5546875, 0.5546875, 0.5546875, 0.5546875, 0.5546875, 0.5546875, 0.5546875, 0.5546875, 0.2765625, 0.2765625, 0.584375, 0.5828125, 0.584375, 0.5546875, 1.0140625, 0.665625, 0.665625, 0.721875, 0.721875, 0.665625, 0.609375, 0.7765625, 0.721875, 0.2765625, 0.5, 0.665625, 0.5546875, 0.8328125, 0.721875, 0.7765625, 0.665625, 0.7765625, 0.721875, 0.665625, 0.609375, 0.721875, 0.665625, 0.94375, 0.665625, 0.665625, 0.609375, 0.2765625, 0.3546875, 0.2765625, 0.4765625, 0.5546875, 0.3328125, 0.5546875, 0.5546875, 0.5, 0.5546875, 0.5546875, 0.2765625, 0.5546875, 0.5546875, 0.221875, 0.240625, 0.5, 0.221875, 0.8328125, 0.5546875, 0.5546875, 0.5546875, 0.5546875, 0.3328125, 0.5, 0.2765625, 0.5546875, 0.5, 0.721875, 0.5, 0.5, 0.5, 0.3546875, 0.259375, 0.353125, 0.5890625],
    avg: 0.5279276315789471
  },
  "Helvetica Neue": {
    widths: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0.278125, 0.259375, 0.4265625, 0.55625, 0.55625, 1, 0.6453125, 0.278125, 0.2703125, 0.26875, 0.353125, 0.6, 0.278125, 0.3890625, 0.278125, 0.36875, 0.55625, 0.55625, 0.55625, 0.55625, 0.55625, 0.55625, 0.55625, 0.55625, 0.55625, 0.55625, 0.278125, 0.278125, 0.6, 0.6, 0.6, 0.55625, 0.8, 0.6625, 0.6859375, 0.7234375, 0.7046875, 0.6125, 0.575, 0.759375, 0.7234375, 0.259375, 0.5203125, 0.6703125, 0.55625, 0.871875, 0.7234375, 0.7609375, 0.6484375, 0.7609375, 0.6859375, 0.6484375, 0.575, 0.7234375, 0.6140625, 0.9265625, 0.6125, 0.6484375, 0.6125, 0.259375, 0.36875, 0.259375, 0.6, 0.5, 0.25625, 0.5375, 0.59375, 0.5375, 0.59375, 0.5375, 0.2984375, 0.575, 0.55625, 0.2234375, 0.2375, 0.5203125, 0.2234375, 0.853125, 0.55625, 0.575, 0.59375, 0.59375, 0.334375, 0.5, 0.315625, 0.55625, 0.5, 0.759375, 0.51875, 0.5, 0.48125, 0.334375, 0.2234375, 0.334375, 0.6],
    avg: 0.5279440789473684
  },
  "Hoefler Text": {
    widths: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0.2359375, 0.2234375, 0.3921875, 0.7125, 0.49375, 0.8859375, 0.771875, 0.2125, 0.3078125, 0.309375, 0.375, 0.4234375, 0.234375, 0.3125, 0.234375, 0.3, 0.5828125, 0.365625, 0.434375, 0.3921875, 0.5234375, 0.3984375, 0.5125, 0.4328125, 0.46875, 0.5125, 0.234375, 0.234375, 0.515625, 0.4234375, 0.515625, 0.340625, 0.7609375, 0.7359375, 0.6359375, 0.721875, 0.8125, 0.6375, 0.5875, 0.8078125, 0.853125, 0.4296875, 0.503125, 0.78125, 0.609375, 0.9609375, 0.8515625, 0.8140625, 0.6125, 0.8140625, 0.71875, 0.49375, 0.7125, 0.76875, 0.771875, 1.125, 0.7765625, 0.7734375, 0.65625, 0.321875, 0.3078125, 0.321875, 0.3546875, 0.5, 0.3375, 0.446875, 0.5359375, 0.45, 0.5296875, 0.4546875, 0.425, 0.4921875, 0.54375, 0.2671875, 0.240625, 0.5390625, 0.25, 0.815625, 0.5375, 0.5234375, 0.5390625, 0.5421875, 0.365625, 0.36875, 0.35625, 0.5171875, 0.5015625, 0.75, 0.5, 0.509375, 0.44375, 0.2421875, 0.14375, 0.2421875, 0.35],
    avg: 0.5116447368421051
  },
  Inter: {
    widths: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0.2796875, 0.2890625, 0.4671875, 0.634375, 0.6421875, 0.9828125, 0.6453125, 0.3, 0.365625, 0.365625, 0.5015625, 0.6625, 0.2890625, 0.4609375, 0.2890625, 0.3609375, 0.63125, 0.4078125, 0.6109375, 0.61875, 0.646875, 0.59375, 0.6203125, 0.5671875, 0.61875, 0.6203125, 0.2890625, 0.303125, 0.6625, 0.6625, 0.6625, 0.5125, 0.9671875, 0.690625, 0.6546875, 0.73125, 0.721875, 0.6015625, 0.590625, 0.746875, 0.74375, 0.26875, 0.571875, 0.671875, 0.565625, 0.9046875, 0.7546875, 0.765625, 0.6390625, 0.765625, 0.64375, 0.6421875, 0.646875, 0.7453125, 0.690625, 0.9859375, 0.6828125, 0.6796875, 0.6296875, 0.365625, 0.3609375, 0.365625, 0.471875, 0.45625, 0.3234375, 0.5625, 0.6125, 0.571875, 0.6125, 0.584375, 0.3703125, 0.6140625, 0.5921875, 0.2421875, 0.2548828125, 0.55, 0.2421875, 0.8765625, 0.5921875, 0.6, 0.6125, 0.6125, 0.3765625, 0.528125, 0.328125, 0.5921875, 0.5625, 0.81875, 0.546875, 0.5625, 0.553125, 0.4265625, 0.3328125, 0.4265625, 0.6625],
    avg: 0.5624362664473683
  },
  Montserrat: {
    widths: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0.2625, 0.2609375, 0.3734375, 0.696875, 0.615625, 0.8296875, 0.6703125, 0.203125, 0.3296875, 0.3296875, 0.3875, 0.575, 0.2125, 0.3828125, 0.2125, 0.3953125, 0.6625, 0.3625, 0.56875, 0.5640625, 0.6625, 0.5671875, 0.609375, 0.5890625, 0.6390625, 0.609375, 0.2125, 0.2125, 0.575, 0.575, 0.575, 0.5671875, 1.034375, 0.7171875, 0.7546875, 0.7203125, 0.8265625, 0.6703125, 0.634375, 0.7734375, 0.8140625, 0.303125, 0.5078125, 0.7125, 0.5890625, 0.95625, 0.8140625, 0.8390625, 0.71875, 0.8390625, 0.7234375, 0.615625, 0.575, 0.7921875, 0.6984375, 1.1125, 0.65625, 0.6359375, 0.6515625, 0.31875, 0.396875, 0.31875, 0.5765625, 0.5, 0.6, 0.590625, 0.678125, 0.5640625, 0.678125, 0.6046875, 0.375, 0.6875, 0.678125, 0.2703125, 0.365625, 0.6015625, 0.2703125, 1.0625, 0.678125, 0.628125, 0.678125, 0.678125, 0.4015625, 0.4890625, 0.40625, 0.6734375, 0.5421875, 0.8796875, 0.534375, 0.5671875, 0.5125, 0.334375, 0.2953125, 0.334375, 0.575],
    avg: 0.571792763157895
  },
  monospace: {
    widths: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0.5984375, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6078125, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.61875, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.615625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6140625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625],
    avg: 0.6020559210526316
  },
  Overpass: {
    widths: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0.2296875, 0.2765625, 0.4203125, 0.68125, 0.584375, 0.8515625, 0.7015625, 0.2203125, 0.3453125, 0.3453125, 0.53125, 0.63125, 0.2234375, 0.3953125, 0.2234375, 0.509375, 0.65, 0.4046875, 0.6171875, 0.60625, 0.6484375, 0.60625, 0.6015625, 0.5375, 0.615625, 0.6015625, 0.2234375, 0.2234375, 0.63125, 0.63125, 0.63125, 0.5015625, 0.8203125, 0.696875, 0.6671875, 0.65, 0.6859375, 0.6015625, 0.559375, 0.690625, 0.7078125, 0.2953125, 0.565625, 0.678125, 0.58125, 0.8046875, 0.7109375, 0.740625, 0.6421875, 0.740625, 0.6765625, 0.6046875, 0.590625, 0.696875, 0.6640625, 0.853125, 0.65, 0.6671875, 0.6625, 0.3734375, 0.509375, 0.3734375, 0.63125, 0.5125, 0.4, 0.5328125, 0.5625, 0.51875, 0.5625, 0.546875, 0.3359375, 0.5625, 0.565625, 0.25625, 0.3203125, 0.55, 0.265625, 0.85, 0.565625, 0.5671875, 0.5625, 0.5625, 0.4046875, 0.4765625, 0.3796875, 0.565625, 0.521875, 0.7265625, 0.53125, 0.5390625, 0.5125, 0.3671875, 0.275, 0.3671875, 0.63125],
    avg: 0.5430756578947369
  },
  Palatino: {
    widths: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0.25, 0.278125, 0.371875, 0.60625, 0.5, 0.840625, 0.778125, 0.209375, 0.334375, 0.334375, 0.390625, 0.60625, 0.2578125, 0.334375, 0.25, 0.60625, 0.5, 0.5, 0.5, 0.5, 0.5, 0.5, 0.5, 0.5, 0.5, 0.5, 0.25, 0.25, 0.60625, 0.60625, 0.60625, 0.4453125, 0.7484375, 0.778125, 0.6109375, 0.709375, 0.775, 0.6109375, 0.55625, 0.7640625, 0.8328125, 0.3375, 0.346875, 0.7265625, 0.6109375, 0.946875, 0.83125, 0.7875, 0.6046875, 0.7875, 0.66875, 0.525, 0.6140625, 0.778125, 0.7234375, 1, 0.6671875, 0.6671875, 0.6671875, 0.334375, 0.60625, 0.334375, 0.60625, 0.5, 0.334375, 0.5, 0.565625, 0.4453125, 0.6109375, 0.4796875, 0.340625, 0.55625, 0.5828125, 0.2921875, 0.2671875, 0.5640625, 0.2921875, 0.8828125, 0.5828125, 0.546875, 0.6015625, 0.5609375, 0.3953125, 0.425, 0.3265625, 0.603125, 0.565625, 0.834375, 0.5171875, 0.55625, 0.5, 0.334375, 0.60625, 0.334375, 0.60625],
    avg: 0.5408552631578947
  },
  RedHatText: {
    widths: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0.2328125, 0.2203125, 0.35625, 0.6890625, 0.55, 0.7390625, 0.6703125, 0.2140625, 0.4015625, 0.4015625, 0.4546875, 0.53125, 0.2203125, 0.45625, 0.2203125, 0.515625, 0.6609375, 0.3078125, 0.5484375, 0.5875, 0.61875, 0.5703125, 0.6203125, 0.559375, 0.6140625, 0.6203125, 0.2203125, 0.2234375, 0.465625, 0.534375, 0.465625, 0.5125, 0.7671875, 0.6609375, 0.6703125, 0.7265625, 0.728125, 0.6203125, 0.6109375, 0.8, 0.73125, 0.253125, 0.6, 0.6125, 0.6078125, 0.8625, 0.7390625, 0.8109375, 0.6546875, 0.809375, 0.6484375, 0.6234375, 0.6171875, 0.7125, 0.6609375, 0.8984375, 0.6546875, 0.646875, 0.60625, 0.3625, 0.5203125, 0.3625, 0.540625, 0.4609375, 0.5234375, 0.5265625, 0.584375, 0.509375, 0.5828125, 0.5578125, 0.3703125, 0.5828125, 0.553125, 0.2234375, 0.24375, 0.4890625, 0.2234375, 0.8453125, 0.553125, 0.58125, 0.584375, 0.5828125, 0.353125, 0.453125, 0.378125, 0.553125, 0.5015625, 0.6984375, 0.4875, 0.4984375, 0.459375, 0.3953125, 0.2921875, 0.3953125, 0.58125],
    avg: 0.5341940789473685
  },
  "sans-serif": {
    widths: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0.278125, 0.278125, 0.35625, 0.55625, 0.55625, 0.890625, 0.6671875, 0.1921875, 0.334375, 0.334375, 0.390625, 0.584375, 0.278125, 0.334375, 0.278125, 0.303125, 0.55625, 0.55625, 0.55625, 0.55625, 0.55625, 0.55625, 0.55625, 0.55625, 0.55625, 0.55625, 0.278125, 0.278125, 0.5859375, 0.584375, 0.5859375, 0.55625, 1.015625, 0.6671875, 0.6671875, 0.7234375, 0.7234375, 0.6671875, 0.6109375, 0.778125, 0.7234375, 0.278125, 0.5, 0.6671875, 0.55625, 0.834375, 0.7234375, 0.778125, 0.6671875, 0.778125, 0.7234375, 0.6671875, 0.6109375, 0.7234375, 0.6671875, 0.9453125, 0.6671875, 0.6671875, 0.6109375, 0.278125, 0.35625, 0.278125, 0.478125, 0.55625, 0.334375, 0.55625, 0.55625, 0.5, 0.55625, 0.55625, 0.278125, 0.55625, 0.55625, 0.2234375, 0.2421875, 0.5, 0.2234375, 0.834375, 0.55625, 0.55625, 0.55625, 0.55625, 0.334375, 0.5, 0.278125, 0.55625, 0.5, 0.7234375, 0.5, 0.5, 0.5, 0.35625, 0.2609375, 0.3546875, 0.590625],
    avg: 0.5293256578947368
  },
  Seravek: {
    widths: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0.215625, 0.296875, 0.4171875, 0.6734375, 0.4953125, 0.9125, 0.740625, 0.2421875, 0.3375, 0.3375, 0.409375, 0.60625, 0.2609375, 0.35625, 0.25625, 0.41875, 0.5921875, 0.3515625, 0.475, 0.4875, 0.5375, 0.509375, 0.5484375, 0.4546875, 0.5421875, 0.5484375, 0.25625, 0.2546875, 0.5875, 0.6171875, 0.5875, 0.4578125, 0.8140625, 0.6765625, 0.5703125, 0.6109375, 0.684375, 0.5109375, 0.4953125, 0.678125, 0.6859375, 0.2625, 0.2625, 0.5859375, 0.4734375, 0.846875, 0.709375, 0.740625, 0.509375, 0.740625, 0.584375, 0.5015625, 0.528125, 0.675, 0.5953125, 0.9453125, 0.596875, 0.540625, 0.540625, 0.359375, 0.4203125, 0.359375, 0.5109375, 0.421875, 0.4046875, 0.5015625, 0.5421875, 0.446875, 0.5453125, 0.484375, 0.38125, 0.5140625, 0.5546875, 0.240625, 0.2640625, 0.490625, 0.2765625, 0.8625, 0.5546875, 0.546875, 0.5453125, 0.5453125, 0.3625, 0.41875, 0.3890625, 0.5453125, 0.4703125, 0.7546875, 0.4921875, 0.4609375, 0.453125, 0.4015625, 0.2640625, 0.4015625, 0.58125],
    avg: 0.5044078947368421
  },
  serif: {
    widths: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0.2484375, 0.334375, 0.409375, 0.5, 0.5, 0.834375, 0.778125, 0.18125, 0.334375, 0.334375, 0.5, 0.5640625, 0.25, 0.334375, 0.25, 0.278125, 0.5, 0.5, 0.5, 0.5, 0.5, 0.5, 0.5, 0.5, 0.5, 0.5, 0.278125, 0.278125, 0.5640625, 0.5640625, 0.5640625, 0.4453125, 0.921875, 0.7234375, 0.6671875, 0.6671875, 0.7234375, 0.6109375, 0.55625, 0.7234375, 0.7234375, 0.334375, 0.390625, 0.7234375, 0.6109375, 0.890625, 0.7234375, 0.7234375, 0.55625, 0.7234375, 0.6671875, 0.55625, 0.6109375, 0.7234375, 0.7234375, 0.9453125, 0.7234375, 0.7234375, 0.6109375, 0.334375, 0.340625, 0.334375, 0.4703125, 0.5, 0.3453125, 0.4453125, 0.5, 0.4453125, 0.5, 0.4453125, 0.3828125, 0.5, 0.5, 0.278125, 0.3359375, 0.5, 0.278125, 0.778125, 0.5, 0.5, 0.5, 0.5, 0.3375, 0.390625, 0.2796875, 0.5, 0.5, 0.7234375, 0.5, 0.5, 0.4453125, 0.48125, 0.2015625, 0.48125, 0.5421875],
    avg: 0.5126315789473684
  },
  Tahoma: {
    widths: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0.3109375, 0.3328125, 0.4015625, 0.728125, 0.546875, 0.9765625, 0.70625, 0.2109375, 0.3828125, 0.3828125, 0.546875, 0.728125, 0.303125, 0.3640625, 0.303125, 0.3953125, 0.546875, 0.546875, 0.546875, 0.546875, 0.546875, 0.546875, 0.546875, 0.546875, 0.546875, 0.546875, 0.3546875, 0.3546875, 0.728125, 0.728125, 0.728125, 0.475, 0.909375, 0.6109375, 0.590625, 0.6015625, 0.6796875, 0.5625, 0.521875, 0.66875, 0.6765625, 0.3734375, 0.4171875, 0.6046875, 0.4984375, 0.771875, 0.66875, 0.7078125, 0.5515625, 0.7078125, 0.6375, 0.5578125, 0.5875, 0.65625, 0.60625, 0.903125, 0.58125, 0.5890625, 0.559375, 0.3828125, 0.39375, 0.3828125, 0.728125, 0.5625, 0.546875, 0.525, 0.553125, 0.4625, 0.553125, 0.5265625, 0.3546875, 0.553125, 0.5578125, 0.2296875, 0.328125, 0.51875, 0.2296875, 0.840625, 0.5578125, 0.54375, 0.553125, 0.553125, 0.3609375, 0.446875, 0.3359375, 0.5578125, 0.4984375, 0.7421875, 0.4953125, 0.4984375, 0.4453125, 0.48125, 0.3828125, 0.48125, 0.728125],
    avg: 0.5384374999999998
  },
  "Times New Roman": {
    widths: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0.2484375, 0.334375, 0.409375, 0.5, 0.5, 0.834375, 0.778125, 0.18125, 0.334375, 0.334375, 0.5, 0.5640625, 0.25, 0.334375, 0.25, 0.28125, 0.5, 0.5, 0.5, 0.5, 0.5, 0.5, 0.5, 0.5, 0.5, 0.5, 0.278125, 0.278125, 0.5640625, 0.5640625, 0.5640625, 0.4453125, 0.921875, 0.7234375, 0.6671875, 0.6671875, 0.7234375, 0.6109375, 0.55625, 0.7234375, 0.7234375, 0.334375, 0.390625, 0.73125, 0.6109375, 0.890625, 0.7375, 0.7234375, 0.55625, 0.7234375, 0.6765625, 0.55625, 0.6109375, 0.7234375, 0.7234375, 0.9453125, 0.7234375, 0.7234375, 0.6109375, 0.334375, 0.28125, 0.334375, 0.4703125, 0.51875, 0.334375, 0.4453125, 0.503125, 0.4453125, 0.503125, 0.4453125, 0.4359375, 0.5, 0.5, 0.278125, 0.35625, 0.50625, 0.278125, 0.778125, 0.5, 0.5, 0.5046875, 0.5, 0.340625, 0.390625, 0.2796875, 0.5, 0.5, 0.7234375, 0.5, 0.5, 0.4453125, 0.48125, 0.2015625, 0.48125, 0.5421875],
    avg: 0.5134375
  },
  "Trebuchet MS": {
    widths: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0.3015625, 0.3671875, 0.325, 0.53125, 0.525, 0.6015625, 0.70625, 0.1609375, 0.3671875, 0.3671875, 0.3671875, 0.525, 0.3671875, 0.3671875, 0.3671875, 0.525, 0.525, 0.525, 0.525, 0.525, 0.525, 0.525, 0.525, 0.525, 0.525, 0.525, 0.3671875, 0.3671875, 0.525, 0.525, 0.525, 0.3671875, 0.771875, 0.590625, 0.5671875, 0.5984375, 0.6140625, 0.5359375, 0.525, 0.6765625, 0.6546875, 0.2796875, 0.4765625, 0.5765625, 0.5078125, 0.7109375, 0.6390625, 0.675, 0.5578125, 0.7421875, 0.5828125, 0.48125, 0.58125, 0.6484375, 0.5875, 0.853125, 0.5578125, 0.5703125, 0.5515625, 0.3671875, 0.3578125, 0.3671875, 0.525, 0.53125, 0.525, 0.5265625, 0.5578125, 0.4953125, 0.5578125, 0.546875, 0.375, 0.503125, 0.546875, 0.2859375, 0.3671875, 0.5046875, 0.2953125, 0.83125, 0.546875, 0.5375, 0.5578125, 0.5578125, 0.3890625, 0.40625, 0.396875, 0.546875, 0.490625, 0.7453125, 0.5015625, 0.49375, 0.475, 0.3671875, 0.525, 0.3671875, 0.525],
    avg: 0.5085197368421052
  },
  Verdana: {
    widths: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0.35, 0.39375, 0.459375, 0.81875, 0.6359375, 1.0765625, 0.759375, 0.26875, 0.4546875, 0.4546875, 0.6359375, 0.81875, 0.3640625, 0.4546875, 0.3640625, 0.4703125, 0.6359375, 0.6359375, 0.6359375, 0.6359375, 0.6359375, 0.6359375, 0.6359375, 0.6359375, 0.6359375, 0.6359375, 0.4546875, 0.4546875, 0.81875, 0.81875, 0.81875, 0.546875, 1, 0.684375, 0.6859375, 0.6984375, 0.771875, 0.6328125, 0.575, 0.7765625, 0.7515625, 0.421875, 0.4546875, 0.69375, 0.5578125, 0.84375, 0.7484375, 0.7875, 0.603125, 0.7875, 0.7, 0.684375, 0.6171875, 0.7328125, 0.684375, 0.9890625, 0.6859375, 0.615625, 0.6859375, 0.4546875, 0.46875, 0.4546875, 0.81875, 0.6421875, 0.6359375, 0.6015625, 0.6234375, 0.521875, 0.6234375, 0.596875, 0.384375, 0.6234375, 0.6328125, 0.275, 0.3765625, 0.5921875, 0.275, 0.9734375, 0.6328125, 0.6078125, 0.6234375, 0.6234375, 0.43125, 0.521875, 0.3953125, 0.6328125, 0.5921875, 0.81875, 0.5921875, 0.5921875, 0.5265625, 0.6359375, 0.4546875, 0.6359375, 0.81875],
    avg: 0.6171875000000003
  }
}, I9 = {
  mm: 3.8,
  sm: 38,
  pt: 1.33,
  pc: 16,
  in: 96,
  px: 1
}, A9 = {
  em: 1,
  ex: 0.5
}, Jne = {
  heightOverlapCoef: 1.05,
  // Coefficient for height value to prevent overlap.
  lineCapitalCoef: 1.15
  // Coefficient for height value. Reserve space for capital chars.
}, Zne = {
  lineHeight: 1,
  letterSpacing: "0px",
  fontSize: 0,
  angle: 0,
  fontFamily: ""
}, yQe = (e) => e * Math.PI / 180, bQe = (e) => {
  const n = e.split(",").map((r) => r.replace(/'|"/g, "")).find((r) => T9[r]) || "Helvetica";
  return T9[n];
}, _3 = (e) => Array.isArray(e) ? e : e.toString().split(/\r\n|\r|\n/g), vw = (e, t, n) => {
  const r = yQe(n);
  return Math.abs(Math.cos(r) * e) + Math.abs(Math.sin(r) * t);
}, ZR = (e, t) => {
  var o;
  const n = (o = e.match(/[a-zA-Z%]+/)) == null ? void 0 : o[0], r = Number(e.match(/[0-9.,]+/));
  let i;
  return n ? I9.hasOwnProperty(n) ? i = r * I9[n] : A9.hasOwnProperty(n) ? i = (t ? r * t : r * Zne.fontSize) * A9[n] : i = r : i = r || 0, i;
}, S3 = (e, t) => {
  const n = Array.isArray(e) ? e[t] : e, r = He({}, n, Zne);
  return Object.assign({}, r, {
    fontFamily: r.fontFamily,
    letterSpacing: typeof r.letterSpacing == "number" ? r.letterSpacing : ZR(String(r.letterSpacing), r.fontSize),
    fontSize: typeof r.fontSize == "number" ? r.fontSize : ZR(String(r.fontSize))
  });
}, _Qe = (e, t) => {
  if (e === void 0 || e === "" || e === null)
    return 0;
  const n = _3(e).map((r, i) => {
    const o = r.toString().length, {
      fontSize: a,
      letterSpacing: s,
      fontFamily: c
    } = S3(t, i), l = bQe(c);
    return r.toString().split("").map((d) => d.charCodeAt(0) < l.widths.length ? l.widths[d.charCodeAt(0)] : l.avg).reduce((d, f) => f + d, 0) * a + s * Math.max(o - 1, 0);
  });
  return Math.max(...n);
}, SQe = (e, t) => e === void 0 || e === "" || e === null ? 0 : _3(e).reduce((n, r, i) => {
  const o = S3(t, i), s = r.toString().match(/[(A-Z)(0-9)]/) ? o.fontSize * Jne.lineCapitalCoef : o.fontSize;
  return n + o.lineHeight * s;
}, 0), wQe = (e, t) => {
  const n = Array.isArray(t) ? t[0] && t[0].angle : t && t.angle, r = SQe(e, t), i = _Qe(e, t), o = n ? vw(i, r, n) : i, a = n ? vw(r, i, n) : r;
  return {
    width: o,
    height: a * Jne.heightOverlapCoef
  };
}, ET = fZ(() => {
  const e = document.createElementNS("http://www.w3.org/2000/svg", "svg");
  e.setAttribute("xlink", "http://www.w3.org/1999/xlink"), e.setAttribute("width", "300"), e.setAttribute("height", "300"), e.setAttribute("viewBox", "0 0 300 300"), e.setAttribute("aria-hidden", "true");
  const t = document.createElementNS("http://www.w3.org/2000/svg", "text");
  return e.appendChild(t), e.style.position = "fixed", e.style.top = "-9999px", e.style.left = "-9999px", document.body.appendChild(e), t;
}), R9 = (e) => e ? `${e.angle}:${e.fontFamily}:${e.fontSize}:${e.letterSpacing}:${e.lineHeight}` : "null", xQe = fZ((e, t) => {
  var a, s;
  let n = ET();
  n.isConnected || ((s = (a = ET.cache).clear) == null || s.call(a), n = ET());
  const r = _3(e);
  let i = 0;
  for (const [c, l] of r.entries()) {
    const u = document.createElementNS("http://www.w3.org/2000/svg", "tspan"), d = S3(t, c);
    u.style.fontFamily = d.fontFamily, u.style.fontSize = `${d.fontSize}px`, u.style.lineHeight = d.lineHeight, u.style.fontFamily = d.fontFamily, u.style.letterSpacing = d.letterSpacing, u.textContent = l, u.setAttribute("x", "0"), u.setAttribute("y", `${i}`), n.appendChild(u), i += d.lineHeight * u.getBoundingClientRect().height;
  }
  const {
    width: o
  } = n.getBoundingClientRect();
  return n.innerHTML = "", {
    width: t != null && t.angle ? vw(o, i, t == null ? void 0 : t.angle) : o,
    height: t != null && t.angle ? vw(i, o, t == null ? void 0 : t.angle) : i
  };
}, (e, t) => {
  const n = Array.isArray(e) ? e.join() : e, r = Array.isArray(t) ? t.map(R9).join() : R9(t);
  return `${n}::${r}`;
}), EQe = {
  impl: function(e, t, n) {
    return n === void 0 && (n = !1), !(typeof window < "u" && typeof window.document < "u" && typeof window.document.createElement < "u") || n ? wQe(e, t) : xQe(e, t);
  }
}, Yg = (e, t) => EQe.impl(e, t);
function CQe(e, t, n, r) {
  for (var i = -1, o = e == null ? 0 : e.length; ++i < o; ) {
    var a = e[i];
    t(r, a, n(a), e);
  }
  return r;
}
var TQe = CQe, IQe = vM;
function AQe(e, t, n, r) {
  return IQe(e, function(i, o, a) {
    t(r, i, n(i), a);
  }), r;
}
var RQe = AQe, $Qe = TQe, OQe = RQe, PQe = Lp, MQe = Gi;
function kQe(e, t) {
  return function(n, r) {
    var i = MQe(n) ? $Qe : OQe, o = t ? t() : {};
    return i(n, e, PQe(r), o);
  };
}
var NQe = kQe, DQe = ME, LQe = NQe, jQe = Object.prototype, FQe = jQe.hasOwnProperty, VQe = LQe(function(e, t, n) {
  FQe.call(e, n) ? e[n].push(t) : DQe(e, n, [t]);
}), BQe = VQe;
const w3 = /* @__PURE__ */ pn(BQe);
var zQe = Lp, HQe = mee;
function UQe(e, t) {
  return e && e.length ? HQe(e, zQe(t)) : [];
}
var WQe = UQe;
const x3 = /* @__PURE__ */ pn(WQe);
function qQe(e) {
  let {
    children: t,
    props: n,
    childComponents: r,
    parentProps: i
  } = e;
  const o = t.some((c) => c.type && c.type.role === "histogram"), a = o && t.length && t.every((c) => c.type && c.type.role === "histogram");
  if (o && !a && v3("VictoryHistogram only supports being stacked with other VictoryHistogram components. Check to make sure that you are only passing VictoryHistogram components to VictoryStack"), !a)
    return i;
  let s = n.bins || r[0].props.bins;
  if (!Array.isArray(s)) {
    const c = t.reduce((u, d) => {
      const f = DE(d.props.x || "x");
      return u.concat(d.props.data.map((h) => ({
        x: f(h)
      })));
    }, []), l = t[0].type.getFormattedData;
    s = l({
      data: c,
      bins: s
    }).reduce((u, d, f) => {
      let {
        x0: h,
        x1: p
      } = d;
      return f === 0 ? u.concat([h, p]) : u.concat(p);
    }, []);
  }
  return {
    ...i,
    bins: s
  };
}
function ere(e, t) {
  const {
    polar: n,
    startAngle: r,
    endAngle: i,
    categories: o,
    minDomain: a,
    maxDomain: s
  } = e;
  let c = {
    polar: n,
    startAngle: r,
    endAngle: i,
    categories: o,
    minDomain: a,
    maxDomain: s
  }, l = 0;
  const u = t ? t.slice(0) : D.Children.toArray(e.children);
  c = qQe({
    children: u,
    props: e,
    childComponents: t,
    parentProps: c
  });
  const d = (m, v, y) => {
    const S = Object.assign({}, m.props, c);
    let _, w = m;
    if (Nte(m))
      m.type && Rn(m.type.getData) ? (w = y ? /* @__PURE__ */ D.cloneElement(m, y.props) : m, _ = w.type.getData(S)) : _ = Mo(S);
    else
      return null;
    return l += 1, _.map((T, x) => Object.assign({
      _stack: l,
      _group: x
    }, T));
  }, f = u.filter((m) => m.type && m.type.role === "stack").length, p = Bp(u, d, e, [], (m, v) => m.concat(x3(v, "_group")));
  return Object.values(w3(p, f ? "_group" : "_stack"));
}
function tre(e, t, n) {
  const {
    datasets: r,
    horizontal: i
  } = e, o = i ? Pr(e, "y") : Pr(e, "x"), a = Math.abs(o[1] - o[0]), s = n !== void 0 ? n : Array.isArray(r[0]) && r[0].length || 1, l = (t || r.length) * s;
  return Math.round(0.5 * a / l);
}
function GQe(e, t, n) {
  if (e.polar || t !== "x")
    return;
  const r = n.filter((u) => u.type && u.type.role && u.type.role === "group");
  if (r.length < 1)
    return;
  const {
    offset: i,
    children: o
  } = r[0].props;
  if (!i)
    return;
  const a = Array.isArray(o) && o[0];
  if (!a)
    return;
  let s = a.props.barWidth, c = a.props.data && a.props.data.length || 1;
  if (a && a.type.role === "stack") {
    const u = a.props.children && a.props.children[0];
    if (!u)
      return;
    s = u.props.barWidth, c = a.props.children.length;
  }
  const l = s || tre(e, o.length, c);
  return {
    x: l * o.length / 2 + (i - l * ((o.length - 1) / 2))
  };
}
function KQe(e, t, n) {
  const r = n ? n.slice(0) : D.Children.toArray(e.children), i = e.data ? Mo(e) : void 0, {
    polar: o,
    startAngle: a,
    endAngle: s,
    categories: c,
    minDomain: l,
    maxDomain: u,
    horizontal: d
  } = e, f = {
    horizontal: d,
    polar: o,
    startAngle: a,
    endAngle: s,
    minDomain: l,
    maxDomain: u,
    categories: c
  }, h = i ? Object.assign(f, {
    data: i
  }) : f, g = Bp(r, (y) => {
    const S = Object.assign({}, y.props, h);
    if (Dte(y)) {
      if (y.type && Rn(y.type.getDomain))
        return y.props && y.type.getDomain(S, t);
    } else
      return null;
    return vf(S, t);
  }, e), m = g.length === 0 ? 0 : Sa(g), v = g.length === 0 ? 1 : _a(g);
  return [m, v];
}
function Ev(e, t, n) {
  const r = n || D.Children.toArray(e.children), i = t3(e, t), o = GQe(e, t, r);
  let a;
  if (i)
    a = i;
  else {
    const s = Xu(e, t), c = Yu(e, t), l = (e.data || e.y) && Mo(e), u = l ? e3(e, t, l) : [], d = KQe(e, t, r), f = s || Sa([...u, ...d]), h = c || _a([...u, ...d]);
    a = Es(f, h);
  }
  return ZM(a, Object.assign({
    domainPadding: o
  }, e), t);
}
function Xg(e, t, n) {
  if (e.data)
    return ea(e, t);
  const r = n ? n.slice(0) : D.Children.toArray(e.children), o = dl(Bp(r, (a) => {
    const s = Object.assign({}, a.props, {
      horizontal: e.horizontal
    });
    return lw(s, t);
  }, e));
  return o.length > 1 ? wv("linear") : wv(o[0]);
}
function E3(e) {
  const n = IM(e, ["groupComponent", "containerComponent", "labelComponent"]);
  let r = e.events;
  return Array.isArray(n) && (r = Array.isArray(e.events) ? n.concat(...e.events) : n), r || [];
}
function YQe(e, t, n, r) {
  const {
    style: i
  } = e;
  let {
    colorScale: o,
    color: a
  } = e;
  if (i && i.data && i.data.fill)
    return i.data.fill;
  if (o = t.props && t.props.colorScale ? t.props.colorScale : o, a = t.props && t.props.color ? t.props.color : a, !o && !a)
    return;
  const s = Array.isArray(o) ? o : b3(o, r);
  return a || s[n % s.length];
}
function nre(e, t, n) {
  const r = e && e[n] && e[n].style ? e[n].style : {};
  return Vp(t, r);
}
function rre(e, t, n, r) {
  const {
    style: i,
    role: o
  } = n, a = e.props.style || {};
  if (Array.isArray(a))
    return a;
  const s = e.type && e.type.role, c = s === "stack" ? void 0 : YQe(n, e, t, r), l = s === "line" ? {
    fill: "none",
    stroke: c
  } : {
    fill: c
  }, u = o === "stack" ? {} : {
    width: tre(n)
  }, d = He({}, a.data, Object.assign({}, u, i.data, l)), f = He({}, a.labels, i.labels);
  return {
    ...a,
    parent: i.parent,
    data: d,
    labels: f
  };
}
function XQe(e, t) {
  const n = (r) => {
    if (!Dte(r))
      return null;
    const i = r.props || {};
    return Wg(i, t);
  };
  return Bp(e.slice(0), n);
}
function QQe(e) {
  const t = (i) => {
    const o = i.props || {};
    let a;
    if (Nte(i))
      i.type && Rn(i.type.getData) ? a = i.type.getData(o) : a = Mo(o);
    else
      return null;
    return a.map((s) => ({
      x: s.xName,
      y: s.yName
    }));
  }, n = {
    x: [],
    y: []
  }, r = (i, o) => {
    const a = Array.isArray(o) ? o.map((c) => c.x).filter(Boolean) : o.x, s = Array.isArray(o) ? o.map((c) => c.y).filter(Boolean) : o.y;
    return {
      x: a !== void 0 ? i.x.concat(a) : i.x,
      y: s !== void 0 ? i.y.concat(s) : i.y
    };
  };
  return Bp(e.slice(0), t, {}, n, r);
}
function $9(e, t, n) {
  const r = Wg(e, t), i = jte(n, t), o = i ? kte(i.props, t) : [], a = r.length ? r : XQe(n, t);
  return dl([...a, ...o].flat());
}
function ire(e, t) {
  const n = t || D.Children.toArray(e.children), r = $9(e, "x", n), i = $9(e, "y", n), o = QQe(n);
  return {
    x: dl([...r, ...o.x].flat()),
    y: dl([...i, ...o.y].flat())
  };
}
function C3(e, t, n) {
  const r = e.categories && Wg(e, "x"), i = e.categories && Wg(e, "y"), a = !r || !i ? n || ire(e, t) : {}, s = r || a.x, c = i || a.y;
  return {
    x: s.length > 0 ? s : void 0,
    y: c.length > 0 ? c : void 0
  };
}
const T3 = /* @__PURE__ */ D.createContext(void 0);
T3.displayName = "PortalContext";
const ore = () => D.useContext(T3), JQe = (e) => {
  let {
    children: t
  } = e;
  const [n, r] = D.useState(/* @__PURE__ */ new Map()), i = D.useCallback((s, c) => {
    r((l) => {
      const u = new Map(l);
      return u.set(s, c), u;
    });
  }, [r]), o = D.useCallback((s) => {
    r((c) => {
      const l = new Map(c);
      return l.delete(s), l;
    });
  }, [r]), a = D.useMemo(() => ({
    addChild: i,
    removeChild: o,
    children: n
  }), [i, o, n]);
  return /* @__PURE__ */ D.createElement(T3.Provider, {
    value: a
  }, t);
}, ZQe = (e) => {
  let {
    as: t,
    ...n
  } = e;
  const r = ore();
  if (!r)
    return null;
  const i = Array.from(r.children.values());
  return /* @__PURE__ */ D.cloneElement(t, n, i);
};
function e$() {
  return e$ = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, e$.apply(this, arguments);
}
const eJe = {
  className: "VictoryContainer",
  portalComponent: /* @__PURE__ */ D.createElement(Gze, null),
  portalZIndex: 99,
  responsive: !0,
  role: "img"
};
function tJe(e) {
  const t = {
    ...eJe,
    ...e
  }, {
    title: n,
    desc: r,
    width: i,
    height: o,
    responsive: a
  } = t, s = Me(null), c = Me($E("victory-container-")), l = t.containerId ?? c.current, u = (S) => `${l}-${S}`, d = Ya(t), f = a ? {
    width: "100%",
    height: "100%"
  } : {
    width: i,
    height: o
  }, h = a ? `0 0 ${i} ${o}` : void 0, p = a ? t.preserveAspectRatio : void 0, g = [n && u("title"), t["aria-labelledby"]].filter(Boolean).join(" ") || void 0, m = [r && u("desc"), t["aria-describedby"]].filter(Boolean).join(" ") || void 0, v = u("title"), y = u("desc");
  return {
    ...t,
    titleId: v,
    descId: y,
    dimensions: f,
    viewBox: h,
    preserveAspectRatio: p,
    ariaLabelledBy: g,
    ariaDescribedBy: m,
    userProps: d,
    localContainerRef: s
  };
}
const ko = (e) => {
  const {
    role: t,
    title: n,
    desc: r,
    children: i,
    className: o,
    portalZIndex: a,
    portalComponent: s,
    width: c,
    height: l,
    style: u,
    tabIndex: d,
    responsive: f,
    events: h,
    ouiaId: p,
    ouiaSafe: g,
    ouiaType: m,
    dimensions: v,
    ariaDescribedBy: y,
    ariaLabelledBy: S,
    viewBox: _,
    preserveAspectRatio: w,
    userProps: T,
    titleId: x,
    descId: C,
    containerRef: E,
    localContainerRef: R
  } = tJe(e);
  return D.useEffect(() => {
    if (!(h != null && h.onWheel))
      return;
    const A = ($) => $.preventDefault(), O = R == null ? void 0 : R.current;
    return O == null || O.addEventListener("wheel", A), () => {
      O == null || O.removeEventListener("wheel", A);
    };
  }, []), /* @__PURE__ */ D.createElement("div", {
    className: o,
    style: {
      ...u,
      width: f ? u == null ? void 0 : u.width : v.width,
      height: f ? u == null ? void 0 : u.height : v.height,
      pointerEvents: (u == null ? void 0 : u.pointerEvents) ?? "none",
      touchAction: (u == null ? void 0 : u.touchAction) ?? "none",
      position: (u == null ? void 0 : u.position) ?? "relative"
    },
    "data-ouia-component-id": p,
    "data-ouia-component-type": m,
    "data-ouia-safe": g,
    ref: lqe([R, E])
  }, /* @__PURE__ */ D.createElement(JQe, null, /* @__PURE__ */ D.createElement("svg", e$({
    width: c,
    height: l,
    tabIndex: d,
    role: t,
    "aria-labelledby": S,
    "aria-describedby": y,
    viewBox: _,
    preserveAspectRatio: w,
    style: {
      ...v,
      pointerEvents: "all"
    }
  }, T, h), n ? /* @__PURE__ */ D.createElement("title", {
    id: x
  }, n) : null, r ? /* @__PURE__ */ D.createElement("desc", {
    id: C
  }, r) : null, i), /* @__PURE__ */ D.createElement("div", {
    style: {
      ...v,
      zIndex: a,
      position: "absolute",
      top: 0,
      left: 0
    }
  }, /* @__PURE__ */ D.createElement(ZQe, {
    as: s,
    width: c,
    height: l,
    viewBox: _,
    preserveAspectRatio: w,
    style: {
      ...v,
      overflow: "visible"
    }
  }))));
};
ko.role = "container";
const nJe = {
  groupComponent: /* @__PURE__ */ D.createElement("g", null)
}, yw = (e) => {
  const t = {
    ...nJe,
    ...e
  }, [n] = Lt($E()), r = ore();
  r || v3("`renderInPortal` is not supported outside of `VictoryContainer`. Component will be rendered in place");
  const i = Array.isArray(t.children) ? t.children[0] : t.children, {
    groupComponent: o
  } = t, a = i && i.props || {}, s = a.groupComponent ? {
    groupComponent: o,
    standalone: !1
  } : {}, c = He(s, a, Lf(t, ["children", "groupComponent"]), {
    key: a.key ?? n
  }), l = i && /* @__PURE__ */ D.cloneElement(i, c);
  return D.useEffect(() => {
    r == null || r.addChild(n, l);
  }, [t.children]), D.useEffect(() => () => r == null ? void 0 : r.removeChild(n), []), r ? null : l;
};
yw.role = "portal";
function bw() {
  return bw = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, bw.apply(this, arguments);
}
const tC = /* @__PURE__ */ ta((e, t) => {
  var c;
  const {
    desc: n,
    id: r,
    tabIndex: i,
    origin: o,
    ...a
  } = e, s = {
    vectorEffect: "non-scaling-stroke",
    id: (c = De(r, e)) == null ? void 0 : c.toString(),
    tabIndex: De(i, e),
    ...a
  };
  return n ? /* @__PURE__ */ D.createElement("rect", bw({}, s, {
    ref: t
  }), /* @__PURE__ */ D.createElement("desc", null, n)) : /* @__PURE__ */ D.createElement("rect", bw({}, s, {
    ref: t
  }));
}), rJe = (e) => {
  var l;
  const {
    children: t,
    desc: n,
    id: r,
    origin: i,
    tabIndex: o,
    title: a,
    ...s
  } = e, c = {
    id: (l = De(r, e)) == null ? void 0 : l.toString(),
    tabIndex: De(o, e),
    ...s
  };
  return /* @__PURE__ */ D.createElement("text", c, a && /* @__PURE__ */ D.createElement("title", null, a), n && /* @__PURE__ */ D.createElement("desc", null, n), t);
}, iJe = (e) => {
  var s;
  const {
    desc: t,
    id: n,
    tabIndex: r,
    origin: i,
    ...o
  } = e, a = {
    id: (s = De(n, e)) == null ? void 0 : s.toString(),
    tabIndex: De(r, e),
    ...o
  };
  return /* @__PURE__ */ D.createElement("tspan", a);
}, zd = {
  fill: "#252525",
  fontSize: 14,
  fontFamily: "'Gill Sans', 'Gill Sans MT', 'Ser­avek', 'Trebuchet MS', sans-serif",
  stroke: "transparent"
}, O9 = (e, t) => e.datum ? xy(e, e.datum)[t] : 0, P9 = (e) => {
  const t = e && e.fontSize;
  if (typeof t == "number")
    return t;
  if (t == null)
    return zd.fontSize;
  if (typeof t == "string") {
    const n = Number(t.replace("px", ""));
    return isNaN(n) ? (v3("fontSize should be expressed as a number of pixels"), zd.fontSize) : n;
  }
  return zd.fontSize;
}, To = function(e, t) {
  return t === void 0 && (t = 0), Array.isArray(e) ? e[t] || e[0] : e;
}, are = (e) => {
  const {
    backgroundStyle: t,
    backgroundPadding: n
  } = e;
  return Array.isArray(t) && !Lr(t) || Array.isArray(n) && !Lr(n);
}, oJe = (e, t) => {
  if (t.disableInlineStyles) {
    const r = br(e, t);
    return {
      // Font size is necessary to calculate the y position of the label
      fontSize: P9(r)
    };
  }
  const n = (r) => {
    const i = br(r ? He({}, r, zd) : zd, t);
    return Object.assign({}, i, {
      fontSize: P9(i)
    });
  };
  return Array.isArray(e) && !Lr(e) ? e.map((r) => n(r)) : n(e);
}, aJe = (e, t) => {
  if (e)
    return Array.isArray(e) && !Lr(e) ? e.map((n) => br(n, t)) : br(e, t);
}, sJe = (e) => {
  if (e.backgroundPadding && Array.isArray(e.backgroundPadding))
    return e.backgroundPadding.map((n) => {
      const r = De(n, e);
      return Wi(r);
    });
  const t = De(e.backgroundPadding, e);
  return Wi(t);
}, cJe = (e) => {
  const t = De(e.lineHeight, e);
  return Array.isArray(t) && Lr(t) ? [1] : t;
}, lJe = (e, t) => {
  if (e == null)
    return;
  if (Array.isArray(e))
    return e.map((r) => De(r, t));
  const n = De(e, t);
  if (n != null)
    return Array.isArray(n) ? n : `${n}`.split(`
`);
}, uJe = (e, t, n) => {
  const r = e.dy ? De(e.dy, e) : 0, i = e.inline ? 1 : e.text.length, o = De(e.capHeight, e), a = t ? De(t, e) : "middle", s = [...Array(i).keys()].map((u) => To(e.style, u).fontSize), c = [...Array(i).keys()].map((u) => To(n, u));
  if (a === "start")
    return r + (o / 2 + c[0] / 2) * s[0];
  if (e.inline)
    return a === "end" ? r + (o / 2 - c[0] / 2) * s[0] : r + o / 2 * s[0];
  if (i === 1)
    return a === "end" ? r + (o / 2 + (0.5 - i) * c[0]) * s[0] : r + (o / 2 + (0.5 - i / 2) * c[0]) * s[0];
  const l = [...Array(i).keys()].reduce((u, d) => u + (o / 2 + (0.5 - i) * c[d]) * s[d] / i, 0);
  return a === "end" ? r + l : r + l / 2 + o / 2 * c[i - 1] * s[i - 1];
}, dJe = (e, t, n) => {
  const {
    polar: r
  } = e, i = To(e.style), o = r ? c3(e) : 0, a = i.angle === void 0 ? De(e.angle, e) : i.angle, s = a === void 0 ? o : a, c = e.transform || i.transform, l = c && De(c, e);
  return l || s ? JR(l, s && {
    rotate: [s, t, n]
  }) : void 0;
}, sre = (e, t) => {
  const {
    direction: n,
    textAnchor: r,
    x: i,
    dx: o
  } = e;
  if (n === "rtl")
    return i - t;
  switch (r) {
    case "middle":
      return Math.round(i - t / 2);
    case "end":
      return Math.round(i - t);
    default:
      return i + (o || 0);
  }
}, cre = (e, t) => {
  const {
    verticalAnchor: n,
    y: r,
    originalDy: i = 0
  } = e, o = r + i;
  switch (n) {
    case "start":
      return Math.floor(o);
    case "end":
      return Math.ceil(o - t);
    default:
      return Math.floor(o - t / 2);
  }
}, fJe = (e, t) => {
  const {
    dx: n = 0,
    transform: r,
    backgroundComponent: i,
    backgroundStyle: o,
    inline: a,
    backgroundPadding: s,
    capHeight: c
  } = e, l = t.map((g) => g.textSize), u = a ? Math.max(...l.map((g) => g.height)) : l.reduce((g, m, v) => {
    const y = v ? 0 : c / 2;
    return g + m.height * (t[v].lineHeight - y);
  }, 0), d = a ? l.reduce((g, m, v) => {
    const y = v ? n : 0;
    return g + m.width + y;
  }, 0) : Math.max(...l.map((g) => g.width)), f = sre(e, d), h = cre(e, u), p = {
    key: "background",
    height: u + s.top + s.bottom,
    style: o,
    transform: r,
    width: d + s.left + s.right,
    x: a ? f - s.left : f + n - s.left,
    y: h
  };
  return /* @__PURE__ */ D.cloneElement(i, He({}, i.props, p));
}, hJe = (e, t, n) => {
  const {
    textAnchor: r
  } = e, i = t.map((s) => s.widthWithPadding), a = -i.reduce((s, c) => s + c, 0) / 2;
  switch (r) {
    case "start":
      return i.reduce((s, c, l) => l < n ? s + c : s, 0);
    case "end":
      return i.reduce((s, c, l) => l > n ? s - c : s, 0);
    default:
      return i.reduce((s, c, l) => {
        const u = l < n ? c : 0;
        return l === n ? s + c / 2 : s + u;
      }, a);
  }
}, gJe = (e, t) => {
  const {
    dy: n,
    dx: r,
    transform: i,
    backgroundStyle: o,
    backgroundPadding: a,
    backgroundComponent: s,
    inline: c,
    y: l
  } = e, u = t.map((d, f) => {
    const h = To(t, f - 1), p = d.textSize, g = d.fontSize * d.lineHeight, m = Math.ceil(g), v = To(a, f), y = To(a, f - 1), S = c && r || 0, _ = f && !c ? h.fontSize * h.lineHeight + y.top + y.bottom : n - g * 0.5 - (d.fontSize - d.capHeight);
    return {
      textHeight: m,
      labelSize: p,
      heightWithPadding: m + v.top + v.bottom,
      widthWithPadding: p.width + v.left + v.right + S,
      y: l,
      fontSize: d.fontSize,
      dy: _
    };
  });
  return u.map((d, f) => {
    const h = sre(e, d.labelSize.width), p = u.slice(0, f + 1).reduce((_, w) => _ + w.dy, l), g = To(a, f), m = d.heightWithPadding, v = c ? hJe(e, u, f) + h - g.left : h, y = c ? cre(e, m) - g.top : p, S = {
      key: `tspan-background-${f}`,
      height: m,
      style: To(o, f),
      width: d.widthWithPadding,
      transform: i,
      x: v - g.left,
      y
    };
    return /* @__PURE__ */ D.cloneElement(s, He({}, s.props, S));
  });
}, pJe = (e, t) => are(e) ? gJe(e, t) : fJe(e, t), mJe = (e, t, n) => {
  const r = To(e, t), i = To(e, t - 1), o = i.fontSize * i.lineHeight, a = r.fontSize * r.lineHeight, s = i.fontSize - i.capHeight, c = r.fontSize - r.capHeight, l = o - i.fontSize / 2 + r.fontSize / 2 - o / 2 + a / 2 - c / 2 + s / 2;
  return are(n) ? l + r.backgroundPadding.top + i.backgroundPadding.bottom : l;
}, vJe = (e, t, n) => {
  const {
    inline: r
  } = t, i = To(e, n);
  return n && !r ? mJe(e, n, t) : r ? n === 0 ? i.backgroundPadding.top : void 0 : i.backgroundPadding.top;
}, yJe = (e) => {
  const t = lJe(e.text, e), n = oJe(e.style, Object.assign({}, e, {
    text: t
  })), r = aJe(e.backgroundStyle, Object.assign({}, e, {
    text: t,
    style: n
  })), i = sJe(Object.assign({}, e, {
    text: t,
    style: n,
    backgroundStyle: r
  })), o = De(e.id, e);
  return Object.assign({}, e, {
    backgroundStyle: r,
    backgroundPadding: i,
    style: n,
    text: t,
    id: o
  });
}, bJe = (e) => {
  const t = De(e.ariaLabel, e), n = To(e.style), r = cJe(e), i = e.direction ? De(e.direction, e) : "inherit", o = e.textAnchor ? De(e.textAnchor, e) : n.textAnchor || "start", a = e.verticalAnchor ? De(e.verticalAnchor, e) : n.verticalAnchor || "middle", s = e.dx ? De(e.dx, e) : 0, c = uJe(e, a, r), l = e.x !== void 0 ? e.x : O9(e, "x"), u = e.y !== void 0 ? e.y : O9(e, "y"), d = dJe(e, l, u);
  return Object.assign({}, e, {
    ariaLabel: t,
    lineHeight: r,
    direction: i,
    textAnchor: o,
    verticalAnchor: a,
    dx: s,
    dy: c,
    originalDy: De(e.dy, e),
    transform: d,
    x: l,
    y: u
  });
}, _Je = (e, t) => {
  const {
    ariaLabel: n,
    inline: r,
    className: i,
    title: o,
    events: a,
    direction: s,
    text: c,
    textAnchor: l,
    dx: u,
    dy: d,
    transform: f,
    x: h,
    y: p,
    desc: g,
    id: m,
    tabIndex: v,
    tspanComponent: y,
    textComponent: S
  } = e, _ = Ya(e), w = {
    "aria-label": n,
    key: "text",
    ...a,
    direction: s,
    dx: u,
    x: h,
    y: p + d,
    transform: f,
    className: i,
    title: o,
    desc: De(g, e),
    tabIndex: De(v, e),
    id: m,
    ..._
  }, T = c.map((x, C) => {
    const E = t[C].style, R = {
      key: `${m}-key-${C}`,
      x: r ? void 0 : h,
      dx: r ? u + t[C].backgroundPadding.left : u,
      dy: vJe(t, e, C),
      textAnchor: E.textAnchor || l,
      style: E,
      children: x
    };
    return /* @__PURE__ */ D.cloneElement(y, R);
  });
  return /* @__PURE__ */ D.cloneElement(S, w, T);
}, SJe = {
  backgroundComponent: /* @__PURE__ */ D.createElement(tC, null),
  groupComponent: /* @__PURE__ */ D.createElement("g", null),
  direction: "inherit",
  textComponent: /* @__PURE__ */ D.createElement(rJe, null),
  tspanComponent: /* @__PURE__ */ D.createElement(iJe, null),
  capHeight: 0.71,
  // Magic number from d3.
  lineHeight: 1
}, qi = (e) => {
  const t = yJe(He({}, e, SJe));
  if (t.text === null || t.text === void 0)
    return null;
  const n = bJe(t), {
    text: r,
    style: i,
    capHeight: o,
    backgroundPadding: a,
    lineHeight: s
  } = n, c = r.map((u, d) => {
    const f = To(i, d), h = ZR(`${o}em`, f.fontSize), p = To(s, d);
    return {
      style: f,
      fontSize: f.fontSize || zd.fontSize,
      capHeight: h,
      text: u,
      // TODO: This looks like a bug:
      textSize: Yg(u, f),
      lineHeight: p,
      backgroundPadding: To(a, d)
    };
  }), l = _Je(n, c);
  if (t.backgroundStyle) {
    const d = [pJe(n, c), l], f = /* @__PURE__ */ D.cloneElement(t.groupComponent, {}, d);
    return t.renderInPortal ? /* @__PURE__ */ D.createElement(yw, null, f) : f;
  }
  return t.renderInPortal ? /* @__PURE__ */ D.createElement(yw, null, l) : l;
};
qi.displayName = "VictoryLabel";
qi.role = "label";
qi.defaultStyles = zd;
const wJe = (e) => {
  var t;
  return /* @__PURE__ */ D.createElement("defs", null, /* @__PURE__ */ D.createElement("clipPath", {
    id: (t = e.clipId) == null ? void 0 : t.toString()
  }, e.children));
};
function _w() {
  return _w = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, _w.apply(this, arguments);
}
const lre = /* @__PURE__ */ ta((e, t) => {
  var c;
  const {
    desc: n,
    id: r,
    tabIndex: i,
    origin: o,
    ...a
  } = e, s = {
    vectorEffect: "non-scaling-stroke",
    id: (c = De(r, e)) == null ? void 0 : c.toString(),
    tabIndex: De(i, e),
    ...a
  };
  return n ? /* @__PURE__ */ D.createElement("circle", _w({}, s, {
    ref: t
  }), /* @__PURE__ */ D.createElement("desc", null, n)) : /* @__PURE__ */ D.createElement("circle", _w({}, s, {
    ref: t
  }));
});
class ng extends D.Component {
  constructor(t) {
    super(t), this.state = {
      clipId: t == null ? void 0 : t.clipId
    };
  }
  // The clipId state is used to prevent hydration mismatches between the server and client (issue #2941).
  // A better alternative would be to utilize React 18's useId hook instead of uniqueId, which would avoid needing state for this purpose.
  // However, this component currently supports React 16 at the time of writing, so this workaround is necessary.
  componentDidMount() {
    this.state.clipId || this.setState({
      clipId: $E("victory-clip-")
    });
  }
  calculateAttributes(t) {
    const {
      polar: n,
      origin: r,
      clipWidth: i = 0,
      clipHeight: o = 0,
      translateX: a = 0,
      translateY: s = 0
    } = t, c = Wi(t.clipPadding), l = t.radius || kR(t);
    return {
      x: (n ? r.x : a) - c.left,
      y: (n ? r.y : s) - c.top,
      width: Math.max((n ? l : i) + c.left + c.right, 0),
      height: Math.max((n ? l : o) + c.top + c.bottom, 0)
    };
  }
  renderClippedGroup(t, n) {
    const r = Ya(t), {
      style: i,
      events: o,
      transform: a,
      children: s,
      className: c,
      groupComponent: l,
      tabIndex: u
    } = t, d = this.renderClipComponent(t, n), f = Object.assign({
      className: c,
      style: i,
      transform: a,
      key: `clipped-group-${n}`,
      clipPath: `url(#${n})`
    }, o);
    return /* @__PURE__ */ D.cloneElement(l, {
      ...f,
      tabIndex: u,
      ...r
    }, [d, ...D.Children.toArray(s)]);
  }
  renderGroup(t) {
    const {
      style: n,
      events: r,
      transform: i,
      children: o,
      className: a,
      groupComponent: s,
      tabIndex: c
    } = t;
    return /* @__PURE__ */ D.cloneElement(s, Object.assign({
      className: a,
      style: n,
      transform: i,
      "aria-label": t["aria-label"],
      tabIndex: c
    }, r), o);
  }
  renderClipComponent(t, n) {
    const {
      polar: r,
      origin: i,
      clipWidth: o = 0,
      clipHeight: a = 0,
      translateX: s = 0,
      translateY: c = 0,
      circleComponent: l,
      rectComponent: u,
      clipPathComponent: d
    } = t, {
      top: f,
      bottom: h,
      left: p,
      right: g
    } = Wi(t.clipPadding);
    let m;
    if (r) {
      const v = t.radius || kR(t), y = {
        r: Math.max(v + p + g, v + f + h, 0),
        cx: i.x - p,
        cy: i.y - f
      };
      m = /* @__PURE__ */ D.cloneElement(l, y);
    } else {
      const v = {
        x: s - p,
        y: c - f,
        width: Math.max(o + p + g, 0),
        height: Math.max(a + f + h, 0)
      };
      m = /* @__PURE__ */ D.cloneElement(u, v);
    }
    return /* @__PURE__ */ D.cloneElement(d, Object.assign({
      key: `clip-path-${n}`
    }, t, {
      clipId: n
    }), m);
  }
  getClipValue(t, n) {
    const r = {
      x: t.clipWidth,
      y: t.clipHeight
    };
    if (r[n] !== void 0)
      return r[n];
    const i = Pr(t, n);
    return i && Math.abs(i[0] - i[1]) || void 0;
  }
  getTranslateValue(t, n) {
    const r = {
      x: t.translateX,
      y: t.translateY
    };
    if (r[n] !== void 0)
      return r[n];
    const i = Pr(t, n);
    return i ? Math.min(...i) : void 0;
  }
  render() {
    const t = this.getClipValue(this.props, "y"), n = this.getClipValue(this.props, "x");
    if (n === void 0 || t === void 0)
      return this.renderGroup(this.props);
    const r = this.getTranslateValue(this.props, "x"), i = this.getTranslateValue(this.props, "y"), o = He({}, this.props, {
      clipHeight: t,
      clipWidth: n,
      translateX: r,
      translateY: i
    });
    return this.renderClippedGroup(o, this.state.clipId);
  }
}
ye(ng, "displayName", "VictoryClipContainer"), ye(ng, "role", "container"), ye(ng, "defaultProps", {
  circleComponent: /* @__PURE__ */ D.createElement(lre, null),
  rectComponent: /* @__PURE__ */ D.createElement(tC, null),
  clipPathComponent: /* @__PURE__ */ D.createElement(wJe, null),
  groupComponent: /* @__PURE__ */ D.createElement("g", null)
});
function Sw() {
  return Sw = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Sw.apply(this, arguments);
}
const Up = /* @__PURE__ */ ta((e, t) => {
  var c;
  const {
    desc: n,
    id: r,
    tabIndex: i,
    origin: o,
    ...a
  } = e, s = {
    id: (c = De(r, e)) == null ? void 0 : c.toString(),
    tabIndex: De(i, e),
    ...a
  };
  return n ? /* @__PURE__ */ D.createElement("path", Sw({}, s, {
    ref: t
  }), /* @__PURE__ */ D.createElement("desc", null, n)) : /* @__PURE__ */ D.createElement("path", Sw({}, s, {
    ref: t
  }));
}), xJe = (e) => {
  const {
    cx: t,
    cy: n,
    r,
    startAngle: i,
    endAngle: o,
    closedPath: a
  } = e, s = Math.abs(o - i) / 2 + i, c = t + r * Math.cos(fr(i)), l = n - r * Math.sin(fr(i)), u = t + r * Math.cos(fr(s)), d = n - r * Math.sin(fr(s)), f = t + r * Math.cos(fr(o)), h = n - r * Math.sin(fr(o)), p = s - i <= 180 ? 0 : 1, g = o - s <= 180 ? 0 : 1, m = a ? ` M ${t}, ${n} L ${c}, ${l}` : `M ${c}, ${l}`, v = `A ${r}, ${r}, 0, ${p}, 0, ${u}, ${d}`, y = `A ${r}, ${r}, 0, ${g}, 0, ${f}, ${h}`;
  return `${m} ${v} ${y} ${a ? "Z" : ""}`;
}, EJe = (e) => {
  const t = De(e.ariaLabel, e), n = De(e.desc, e), r = De(e.id, e), i = br(Object.assign({
    stroke: "black",
    fill: "none"
  }, e.style), e), o = De(e.tabIndex, e);
  return Object.assign({}, e, {
    ariaLabel: t,
    desc: n,
    id: r,
    style: i,
    tabIndex: o
  });
}, CJe = {
  pathComponent: /* @__PURE__ */ D.createElement(Up, null),
  role: "presentation",
  shapeRendering: "auto"
}, M9 = (e) => {
  const t = EJe(He({}, e, CJe));
  return /* @__PURE__ */ D.cloneElement(t.pathComponent, {
    ...t.events,
    "aria-label": t.ariaLabel,
    d: xJe(t),
    style: t.style,
    desc: t.desc,
    tabIndex: t.tabIndex,
    className: t.className,
    role: t.role,
    shapeRendering: t.shapeRendering,
    transform: t.transform,
    clipPath: t.clipPath
  });
}, TJe = (e) => {
  const t = De(e.id, e);
  return Object.assign({}, e, {
    id: t
  });
}, IJe = {
  circleComponent: /* @__PURE__ */ D.createElement(lre, null),
  rectComponent: /* @__PURE__ */ D.createElement(tC, null),
  role: "presentation",
  shapeRendering: "auto"
}, AJe = (e) => {
  const t = TJe(He({}, e, IJe));
  return t.polar ? /* @__PURE__ */ D.cloneElement(t.circleComponent, {
    ...t.events,
    style: t.style,
    role: t.role,
    shapeRendering: t.shapeRendering,
    cx: t.x,
    cy: t.y,
    r: t.height,
    className: t.className
  }) : /* @__PURE__ */ D.cloneElement(t.rectComponent, {
    ...t.events,
    style: t.style,
    role: t.role,
    shapeRendering: t.shapeRendering,
    x: t.x,
    y: t.y,
    rx: t.rx,
    ry: t.ry,
    width: t.width,
    height: t.height,
    className: t.className
  });
}, RJe = (e) => {
  const t = De(e.ariaLabel, e), n = De(e.desc, e), r = De(e.id, e), i = br(Object.assign({
    fill: "none"
  }, e.style), e), o = De(e.tabIndex, e);
  return Object.assign({}, e, {
    ariaLabel: t,
    desc: n,
    id: r,
    style: i,
    tabIndex: o
  });
}, $Je = {
  rectComponent: /* @__PURE__ */ D.createElement(tC, null),
  role: "presentation",
  shapeRendering: "auto"
}, OJe = (e) => {
  const t = RJe(He({}, e, $Je));
  return /* @__PURE__ */ D.cloneElement(t.rectComponent, {
    ...t.events,
    "aria-label": t.ariaLabel,
    style: t.style,
    desc: t.desc,
    tabIndex: t.tabIndex,
    transform: t.transform,
    className: t.className,
    role: t.role,
    shapeRendering: t.shapeRendering,
    x: t.x,
    y: t.y,
    width: t.width,
    height: t.height,
    clipPath: t.clipPath
  });
};
function ww() {
  return ww = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, ww.apply(this, arguments);
}
const ure = /* @__PURE__ */ ta((e, t) => {
  var c;
  const {
    desc: n,
    id: r,
    tabIndex: i,
    origin: o,
    ...a
  } = e, s = {
    vectorEffect: "non-scaling-stroke",
    id: (c = De(r, e)) == null ? void 0 : c.toString(),
    tabIndex: De(i, e),
    ...a
  };
  return n ? /* @__PURE__ */ D.createElement("line", ww({}, s, {
    ref: t
  }), /* @__PURE__ */ D.createElement("desc", null, n)) : /* @__PURE__ */ D.createElement("line", ww({}, s, {
    ref: t
  }));
}), PJe = (e) => {
  const t = De(e.ariaLabel, e), n = De(e.desc, e), r = De(e.id, e), i = br(Object.assign({
    stroke: "black"
  }, e.style), e), o = De(e.tabIndex, e);
  return Object.assign({}, e, {
    ariaLabel: t,
    desc: n,
    id: r,
    style: i,
    tabIndex: o
  });
}, MJe = {
  lineComponent: /* @__PURE__ */ D.createElement(ure, null),
  role: "presentation",
  shapeRendering: "auto"
}, Hd = (e) => {
  const t = PJe(He({}, e, MJe));
  return /* @__PURE__ */ D.cloneElement(t.lineComponent, {
    ...t.events,
    "aria-label": t.ariaLabel,
    style: t.style,
    desc: t.desc,
    tabIndex: t.tabIndex,
    className: t.className,
    role: t.role,
    shapeRendering: t.shapeRendering,
    x1: t.x1,
    x2: t.x2,
    y1: t.y1,
    y2: t.y2,
    transform: t.transform,
    clipPath: t.clipPath
  });
}, kJe = (e) => {
  const {
    x: t,
    y: n,
    size: r,
    symbol: i
  } = e;
  if (e.getPath)
    return e.getPath(t, n, r);
  const o = AXe;
  return (typeof o[i] == "function" ? o[i] : o.circle)(t, n, r);
}, NJe = (e) => {
  const t = De(e.ariaLabel, e), n = De(e.desc, e), r = De(e.id, e), i = De(e.size, e), o = br(e.style, e), a = De(e.symbol, e), s = De(e.tabIndex, e);
  return Object.assign({}, e, {
    ariaLabel: t,
    desc: n,
    id: r,
    size: i,
    style: o,
    symbol: a,
    tabIndex: s
  });
}, DJe = {
  pathComponent: /* @__PURE__ */ D.createElement(Up, null),
  role: "presentation",
  shapeRendering: "auto"
}, dre = (e) => {
  const t = NJe(He({}, e, DJe)), n = Ya(t);
  return /* @__PURE__ */ D.cloneElement(t.pathComponent, {
    ...t.events,
    "aria-label": t.ariaLabel,
    d: kJe(t),
    style: t.style,
    desc: t.desc,
    tabIndex: t.tabIndex,
    role: t.role,
    shapeRendering: t.shapeRendering,
    className: t.className,
    transform: t.transform,
    clipPath: t.clipPath,
    ...n
  });
}, I3 = {
  top: -1,
  left: -1,
  right: 1,
  bottom: 1
}, xw = (e) => e != null, LJe = (e, t) => {
  const {
    orientation: n,
    horizontal: r
  } = e;
  return n ? {
    top: "x",
    bottom: "x",
    left: "y",
    right: "y"
  }[n] : r ? t === "x" ? "y" : "x" : t;
}, jJe = (e) => {
  const t = Qa(e), n = LJe(e, t), r = ea(e, t), o = e.domain && e.domain[t] || zp(e) || r.domain();
  return r.range(Pr(e, n)), r.domain(o), r;
}, FJe = (e) => {
  const {
    theme: t,
    dependentAxis: n
  } = e, r = t && t.axis && t.axis.style, i = n ? "dependentAxis" : "independentAxis", o = t && t[i] && t[i].style;
  return r && o ? (() => ["axis", "axisLabel", "grid", "parent", "tickLabels", "ticks"].reduce((c, l) => (c[l] = He({}, o[l], r[l]), c), {}))() : o || r;
}, fre = function(e, t) {
  t === void 0 && (t = {});
  const n = e.style || {}, r = {
    height: "100%",
    width: "100%"
  };
  return {
    parent: He(n.parent, t.parent, r),
    axis: He({}, n.axis, t.axis),
    axisLabel: He({}, n.axisLabel, t.axisLabel),
    grid: He({}, n.grid, t.grid),
    ticks: He({}, n.ticks, t.ticks),
    tickLabels: He({}, n.tickLabels, t.tickLabels)
  };
}, VJe = (e, t, n) => {
  const {
    position: r,
    transform: i
  } = e;
  return {
    x1: i.x,
    y1: i.y,
    x2: i.x + r.x2,
    y2: i.y + r.y2,
    style: t,
    datum: n
  };
}, BJe = (e, t, n, r, i) => {
  const {
    position: o,
    transform: a
  } = e;
  return {
    style: t,
    x: a.x + o.x,
    y: a.y + o.y,
    verticalAnchor: n.verticalAnchor,
    textAnchor: n.textAnchor,
    angle: t.angle,
    text: i,
    datum: r
  };
}, zJe = (e, t, n) => {
  const {
    edge: r,
    transform: i
  } = e;
  return {
    x1: i.x,
    y1: i.y,
    x2: r.x + i.x,
    y2: r.y + i.y,
    style: t,
    datum: n
  };
}, HJe = (e, t, n) => {
  const {
    style: r,
    padding: i,
    isVertical: o
  } = t, {
    width: a,
    height: s
  } = e;
  return {
    style: r.axis,
    x1: o ? n.x : i.left + n.x,
    x2: o ? n.x : a - i.right + n.x,
    y1: o ? i.top + n.y : n.y,
    y2: o ? s - i.bottom + n.y : n.y
  };
}, UJe = (e, t) => ({
  tickStyle: br(e.ticks, t),
  labelStyle: br(e.tickLabels, t),
  gridStyle: br(e.grid, t)
}), WJe = (e, t, n) => {
  const {
    style: r,
    orientation: i,
    padding: o,
    labelPadding: a,
    isVertical: s
  } = t, c = I3[i], l = o.left + o.right, u = o.top + o.bottom, d = c < 0 ? "end" : "start", f = r.axisLabel, h = s ? -90 : 0, p = s ? n.x + c * a : (e.width - l) / 2 + o.left + n.x, g = s ? (e.height - u) / 2 + o.top + n.y : c * a + n.y;
  return {
    x: p,
    y: g,
    verticalAnchor: f.verticalAnchor || d,
    textAnchor: f.textAnchor || "middle",
    angle: f.angle === void 0 ? h : f.angle,
    style: f,
    text: e.label
  };
}, qJe = (e, t) => {
  const r = {
    top: "end",
    left: "end",
    right: "start",
    bottom: "start"
  }[e];
  return {
    textAnchor: t ? r : "middle",
    verticalAnchor: t ? "middle" : r
  };
}, GJe = (e, t) => {
  const n = t.axisLabel || {};
  if (n.padding !== void 0 && n.padding !== null)
    return n.padding;
  const r = WE(e), i = n.fontSize || 14;
  return e.label ? i * (r ? 2.3 : 1.6) : 0;
}, k9 = (e, t, n) => {
  const r = t || "positive";
  return n ? {
    positive: {
      x: "left",
      y: "bottom"
    },
    negative: {
      x: "right",
      y: "top"
    }
  }[r][e] : {
    positive: {
      x: "bottom",
      y: "left"
    },
    negative: {
      x: "top",
      y: "right"
    }
  }[r][e];
}, KJe = (e, t) => {
  const {
    style: n,
    scale: r,
    orientation: i,
    padding: o,
    axis: a,
    ticks: s,
    stringTicks: c,
    isVertical: l,
    labelPadding: u
  } = t, {
    polar: d,
    horizontal: f
  } = e, h = {
    scale: {
      [a]: r
    },
    polar: d,
    horizontal: f,
    ticks: s,
    stringTicks: c
  }, p = i === "right" ? o.right : o.left, g = i === "top" ? o.top : o.bottom, m = e.offsetX !== null && e.offsetX !== void 0 ? e.offsetX : p, v = e.offsetY !== null && e.offsetY !== void 0 ? e.offsetY : g, y = n.axisLabel.fontSize || 14, S = s.map((C, E) => {
    const R = c ? e.tickValues[C - 1] : C;
    return br(n.ticks, Object.assign({}, h, {
      tick: R,
      index: E
    })).size || 0;
  }), _ = y + 2 * Math.max(...S) + u, w = 1.2 * y;
  return {
    x: m ?? (l ? _ : w),
    y: v ?? (l ? w : _)
  };
}, Ql = (e, t) => e instanceof Date && t instanceof Date ? e.getTime() === t.getTime() : e === t, YJe = (e, t) => {
  const {
    scale: n,
    origin: r,
    orientation: i,
    orientations: o,
    domain: a,
    padding: s
  } = t, {
    top: c,
    bottom: l,
    left: u,
    right: d
  } = s, f = {
    x: i === "bottom" || i === "top" ? i : o.x,
    y: i === "left" || i === "right" ? i : o.y
  }, h = {
    x: f.y === "left" ? u : d,
    y: f.x === "bottom" ? l : c
  }, p = {
    x: f.y === "left" ? 0 : e.width,
    y: f.x === "bottom" ? e.height : 0
  }, g = {
    x: Ql(r.x, a.x[0]) || Ql(r.x, a.x[1]) ? 0 : n.x(r.x),
    y: Ql(r.y, a.y[0]) || Ql(r.y, a.y[1]) ? 0 : n.y(r.y)
  }, m = g.x ? Math.abs(p.x - g.x) : h.x, v = g.y ? Math.abs(p.y - g.y) : h.y, y = xw(e.offsetX) ? e.offsetX : m, S = xw(e.offsetY) ? e.offsetY : v;
  return {
    x: y,
    y: S
  };
}, XJe = (e, t) => {
  const {
    scale: n,
    origin: r,
    orientation: i,
    orientations: o,
    domain: a,
    padding: s
  } = t, {
    top: c,
    bottom: l,
    left: u,
    right: d
  } = s, f = {
    y: i === "bottom" || i === "top" ? i : o.x,
    x: i === "left" || i === "right" ? i : o.y
  }, h = {
    x: f.y === "bottom" ? l : c,
    y: f.x === "left" ? u : d
  }, p = {
    y: f.x === "left" ? 0 : e.width,
    x: f.y === "bottom" ? e.height : 0
  }, g = {
    x: Ql(r.x, a.x[0]) || Ql(r.x, a.x[1]) ? 0 : n.x(r.x),
    y: Ql(r.y, a.y[0]) || Ql(r.y, a.y[1]) ? 0 : n.y(r.y)
  }, m = g.x ? Math.abs(p.x - g.x) : h.x, v = g.y ? Math.abs(p.y - g.y) : h.y, y = xw(e.offsetX) ? e.offsetX : v, S = xw(e.offsetY) ? e.offsetY : m;
  return {
    x: y,
    y: S
  };
}, QJe = (e, t, n) => {
  const {
    orientation: r,
    axis: i
  } = t, o = zte(e, i);
  return {
    top: {
      x: 0,
      y: o !== void 0 ? o : n.y
    },
    bottom: {
      x: 0,
      y: o !== void 0 ? o : e.height - n.y
    },
    left: {
      x: o !== void 0 ? o : n.x,
      y: 0
    },
    right: {
      x: o !== void 0 ? o : e.width - n.x,
      y: 0
    }
  }[r];
}, JJe = (e, t, n) => {
  const {
    tickStyle: r,
    labelStyle: i
  } = e, o = r.size || 0, a = r.padding || 0, s = i.padding || 0, c = o + a + s, l = I3[t];
  return {
    x: n ? l * c : 0,
    x2: n ? l * o : 0,
    y: n ? 0 : l * c,
    y2: n ? 0 : l * o
  };
}, ZJe = (e, t, n) => ({
  x: n ? t.x : e + t.x,
  y: n ? e + t.y : t.y
}), eZe = (e, t) => {
  const {
    orientation: n,
    padding: r,
    isVertical: i
  } = t, o = -I3[n], a = i ? o * (e.width - (r.left + r.right)) : 0, s = i ? 0 : o * (e.height - (r.top + r.bottom));
  return {
    x: a,
    y: s
  };
}, tZe = (e, t) => {
  const {
    padding: n,
    orientation: r,
    crossAxis: i
  } = e, o = r === "right" ? n.right : n.left, a = r === "top" ? n.top : n.bottom;
  return {
    x: i ? t.x - o : 0,
    y: i ? t.y - a : 0
  };
}, nZe = (e, t) => {
  let n;
  return t.domain.x && t.domain.y ? n = e.horizontal ? XJe(e, t) : YJe(e, t) : n = KJe(e, t), {
    globalTransform: QJe(e, t, n),
    gridOffset: tZe(t, n),
    gridEdge: eZe(e, t)
  };
}, rZe = (e) => {
  if (e.orientation)
    return e.orientation;
  const t = {
    dependent: e.horizontal ? "bottom" : "left",
    independent: e.horizontal ? "left" : "bottom"
  };
  return e.dependentAxis ? t.dependent : t.independent;
}, iZe = (e) => {
  const t = FJe(e), n = fre(e, t), r = Wi(e.padding), i = GJe(e, n), o = qE(e) ? e.tickValues : void 0, a = Qa(e), s = zp(e), c = jJe(e), l = a === "x" ? s : void 0, u = a === "y" ? s : void 0, d = a === "x" ? c : void 0, f = a === "y" ? c : void 0, h = !(e.crossAxis === !1 || e.standalone === !0), p = Bte(e, c, h), g = Vte(e, c), m = {
    x: Pr(e, "x"),
    y: Pr(e, "y")
  }, v = {
    x: e.domain && e.domain.x ? e.domain.x : l,
    y: e.domain && e.domain.y ? e.domain.y : u
  }, y = {
    x: e.domain && e.domain.x ? ea(e, "x").domain(e.domain.x).range(e.horizontal ? m.y : m.x) : d,
    y: e.domain && e.domain.y ? ea(e, "y").domain(e.domain.y).range(e.horizontal ? m.x : m.y) : f
  }, S = v.x && v.y ? Fte(v) : void 0, _ = S ? {
    x: f9(S.x, v.x),
    y: f9(S.y, v.y)
  } : void 0, w = _ ? {
    x: k9("x", _.y, e.horizontal),
    y: k9("y", _.x, e.horizontal)
  } : void 0, T = w ? e.orientation || w[a] : rZe(e), x = WE(Object.assign({}, e, {
    orientation: T
  }));
  return {
    anchors: qJe(T, x),
    axis: a,
    crossAxis: h,
    domain: v,
    isVertical: x,
    labelPadding: i,
    orientation: T,
    orientations: w,
    origin: S,
    padding: r,
    scale: y,
    stringTicks: o,
    style: n,
    tickFormat: g,
    ticks: p
  };
}, oZe = (e, t) => {
  const n = GE(e, t), r = iZe(n), {
    axis: i,
    style: o,
    orientation: a,
    isVertical: s,
    scale: c,
    ticks: l,
    tickFormat: u,
    anchors: d,
    domain: f,
    stringTicks: h
  } = r, p = i === "x" ? "y" : "x", {
    width: g,
    height: m,
    standalone: v,
    theme: y,
    polar: S,
    padding: _,
    horizontal: w
  } = n, {
    globalTransform: T,
    gridOffset: x,
    gridEdge: C
  } = nZe(n, r), E = {
    scale: {
      [i]: c[i]
    },
    polar: S,
    horizontal: w,
    ticks: l,
    stringTicks: h
  }, R = HJe(n, r, T), A = WJe(n, r, T), O = {
    parent: Object.assign({
      style: o.parent,
      ticks: l,
      standalone: v,
      theme: y,
      width: g,
      height: m,
      padding: _,
      domain: f
    }, E)
  }, $ = {
    dimension: p,
    range: {
      [p]: Pr(n, p)
    },
    scale: n.scale && n.scale[p] ? {
      [p]: n.scale[p]
    } : void 0
  };
  return l.reduce((N, z, k) => {
    var Q, K, q;
    const F = h ? h[k] : z, V = u(z, k, l), j = UJe(o, Object.assign({}, E, {
      tick: F,
      tickValue: z,
      index: k,
      text: V
    })), B = {
      position: JJe(j, a, s),
      transform: ZJe((Q = c[i]) == null ? void 0 : Q.call(c, z), T, s)
    }, U = {
      edge: C,
      transform: {
        x: s ? -x.x + T.x : ((K = c[i]) == null ? void 0 : K.call(c, z)) + T.x,
        y: s ? ((q = c[i]) == null ? void 0 : q.call(c, z)) + T.y : x.y + T.y
      }
    };
    return N[k] = {
      axis: Object.assign({
        dimension: i
      }, E, R),
      axisLabel: Object.assign({}, E, A),
      ticks: Object.assign({}, E, VJe(B, j.tickStyle, z)),
      tickLabels: Object.assign({}, E, BJe(B, j.labelStyle, d, z, V)),
      grid: Object.assign({}, E, $, zJe(U, j.gridStyle, z))
    }, N;
  }, O);
}, N9 = {
  width: 450,
  height: 300,
  padding: 50
}, aZe = {
  components: [{
    name: "axis",
    index: 0
  }, {
    name: "axisLabel",
    index: 0
  }, {
    name: "grid"
  }, {
    name: "parent",
    index: "parent"
  }, {
    name: "ticks"
  }, {
    name: "tickLabels"
  }]
};
class Oc extends D.Component {
  static getStyles(t) {
    return fre(t);
  }
  static getBaseProps(t) {
    return oZe(t, N9);
  }
  renderLine(t) {
    const {
      axisComponent: n
    } = t, r = this.getComponentProps(n, "axis", 0);
    return /* @__PURE__ */ D.cloneElement(n, r);
  }
  renderLabel(t) {
    const {
      axisLabelComponent: n,
      label: r
    } = t;
    if (!r)
      return null;
    const i = this.getComponentProps(n, "axisLabel", 0);
    return /* @__PURE__ */ D.cloneElement(n, i);
  }
  renderGridAndTicks(t) {
    const {
      tickComponent: n,
      tickLabelComponent: r,
      gridComponent: i,
      name: o
    } = t, a = (s) => {
      const {
        style: c = {},
        events: l = {}
      } = s;
      return c.stroke !== "transparent" && c.stroke !== "none" && c.strokeWidth !== 0 || !Lr(l);
    };
    return this.dataKeys.map((s, c) => {
      const l = this.getComponentProps(n, "ticks", c), u = /* @__PURE__ */ D.cloneElement(n, l), d = a(u.props) ? u : void 0, f = this.getComponentProps(i, "grid", c), h = /* @__PURE__ */ D.cloneElement(i, f), p = a(h.props) ? h : void 0, g = this.getComponentProps(r, "tickLabels", c), v = [p, d, /* @__PURE__ */ D.cloneElement(r, g)].filter(Boolean);
      return /* @__PURE__ */ D.cloneElement(t.groupComponent, {
        key: `${o}-tick-group-${s}`
      }, v);
    });
  }
  fixLabelOverlap(t, n) {
    const r = WE(n), i = r ? n.height : n.width, o = (h) => h.type && h.type.role === "label", a = t.map((h) => h.props.children).reduce((h, p) => h.concat(p), []).filter(o).map((h) => h.props), s = (h) => typeof h == "object" ? Object.assign({}, {
      top: 0,
      right: 0,
      bottom: 0,
      left: 0
    }, h) : {
      top: h,
      right: h,
      bottom: h,
      left: h
    }, c = a.reduce((h, p) => {
      const g = s(p.style.padding), m = Yg(p.text, {
        angle: p.angle,
        fontSize: p.style.fontSize,
        letterSpacing: p.style.letterSpacing,
        fontFamily: p.style.fontFamily
      });
      return h + (r ? m.height + g.top + g.bottom : m.width + g.right + g.left);
    }, 0), l = Math.floor(i * t.length / c), u = Math.ceil(t.length / l) || 1, d = (h) => h.props.children.filter(o).reduce((p, g) => (r ? g.props.y : g.props.x) || 0, 0);
    return t.sort(
      (h, p) => r ? d(p) - d(h) : d(h) - d(p)
      // ordinary axis has left-right orientation
    ).filter((h, p) => p % u === 0);
  }
  // Overridden in native versions
  shouldAnimate() {
    return !!this.props.animate;
  }
  render() {
    const {
      animationWhitelist: t
    } = ds, n = GE(this.props, N9), r = Ya(this.props);
    if (this.shouldAnimate())
      return this.animateComponent(n, t);
    const i = this.renderGridAndTicks(n), o = n.fixLabelOverlap ? this.fixLabelOverlap(i, n) : i, a = [this.renderLine(n), this.renderLabel(n), ...o], s = /* @__PURE__ */ D.cloneElement(n.containerComponent, r);
    return n.standalone ? this.renderContainer(s, a) : /* @__PURE__ */ D.cloneElement(n.groupComponent, r, a);
  }
}
ye(Oc, "animationWhitelist", ["style", "domain", "range", "tickCount", "tickValues", "offsetX", "offsetY", "padding", "width", "height"]), ye(Oc, "displayName", "VictoryAxis"), ye(Oc, "role", "axis"), ye(Oc, "defaultTransitions", {
  onExit: {
    duration: 500
  },
  onEnter: {
    duration: 500
  }
}), ye(Oc, "defaultProps", {
  axisComponent: /* @__PURE__ */ D.createElement(Hd, null),
  axisLabelComponent: /* @__PURE__ */ D.createElement(qi, null),
  tickLabelComponent: /* @__PURE__ */ D.createElement(qi, null),
  tickComponent: /* @__PURE__ */ D.createElement(Hd, null),
  gridComponent: /* @__PURE__ */ D.createElement(Hd, null),
  standalone: !0,
  theme: Ca.grayscale,
  containerComponent: /* @__PURE__ */ D.createElement(ko, null),
  groupComponent: /* @__PURE__ */ D.createElement("g", {
    role: "presentation"
  }),
  fixLabelOverlap: !1
}), ye(Oc, "getDomain", zp), ye(Oc, "getAxis", Qa), ye(Oc, "expectedComponents", ["axisComponent", "axisLabelComponent", "groupComponent", "containerComponent", "tickComponent", "tickLabelComponent", "gridComponent"]);
const ds = qu(Oc, aZe), sZe = (e, t) => {
  const n = (o) => {
    let s = Rte(e.scale[o]) === "log" ? 1 / Number.MAX_SAFE_INTEGER : 0;
    const c = Sa(e.domain[o]), l = _a(e.domain[o]);
    return c < 0 && l <= 0 ? s = l : c >= 0 && l > 0 && (s = c), t[`_${o}`] instanceof Date ? new Date(s) : s;
  }, r = t._y0 !== void 0 ? t._y0 : n("y"), i = t._x0 !== void 0 ? t._x0 : n("x");
  return xy(e, Object.assign({}, t, {
    _y0: r,
    _x0: i
  }));
}, cZe = (e) => {
  var l;
  const {
    polar: t
  } = e, n = Ey(e, "bar"), r = e.disableInlineStyles ? {} : Vp(e.style, n), i = e.range || {
    x: Pr(e, "x"),
    y: Pr(e, "y")
  }, o = {
    x: UR(e, "x"),
    y: UR(e, "y")
  }, a = {
    x: ea(e, "x").domain(o.x).range(e.horizontal ? i.y : i.x),
    y: ea(e, "y").domain(o.y).range(e.horizontal ? i.x : i.y)
  }, s = t ? e.origin || jf(e) : void 0;
  let c = Mo(e);
  return c = Pte(c, o, 0), ((l = e.groupComponent) == null ? void 0 : l.type) === ng && (c = c.map((u) => ({
    ...u,
    _x: u.x,
    _y: u.y
  }))), {
    style: r,
    data: c,
    scale: a,
    domain: o,
    origin: s
  };
}, lZe = (e, t) => {
  const n = _r(e, t, "bar"), r = Object.assign({}, n, cZe(n)), {
    alignment: i,
    barRatio: o,
    cornerRadius: a,
    data: s,
    disableInlineStyles: c,
    domain: l,
    events: u,
    height: d,
    horizontal: f,
    origin: h,
    padding: p,
    polar: g,
    scale: m,
    sharedEvents: v,
    standalone: y,
    style: S,
    theme: _,
    width: w,
    labels: T,
    name: x,
    barWidth: C,
    getPath: E
  } = r, R = {
    parent: {
      horizontal: f,
      domain: l,
      scale: m,
      width: w,
      height: d,
      data: s,
      standalone: y,
      name: x,
      theme: _,
      polar: g,
      origin: h,
      padding: p,
      style: S.parent
    }
  };
  return s.reduce((A, O, $) => {
    const N = za(O.eventKey) ? $ : O.eventKey, {
      x: z,
      y: k,
      y0: F,
      x0: V
    } = sZe(r, O), j = {
      alignment: i,
      barRatio: o,
      barWidth: C,
      cornerRadius: a,
      data: s,
      datum: O,
      disableInlineStyles: c,
      getPath: E,
      horizontal: f,
      index: $,
      polar: g,
      origin: h,
      scale: m,
      style: S.data,
      width: w,
      height: d,
      x: z,
      y: k,
      y0: F,
      x0: V
    };
    A[N] = {
      data: j
    };
    const B = Oy(r, O, $);
    return (B != null || T && (u || v)) && (A[N].labels = l3(r, $)), A;
  }, R);
}, uZe = 8, dZe = (e, t) => {
  const {
    scale: n,
    data: r,
    style: i
  } = t;
  if (e)
    return De(e, t);
  if (i.width)
    return i.width;
  const o = n.x.range(), a = Math.abs(o[1] - o[0]), s = r.length + 2, l = (t.barRatio || 0.5) * (r.length < 2 ? uZe : a / s);
  return Math.max(1, l);
}, fZe = (e, t) => {
  const n = {
    topLeft: 0,
    topRight: 0,
    bottomLeft: 0,
    bottomRight: 0
  }, r = (i, o) => {
    za(e[i]) ? za(e[o]) || (n[i] = De(e[o], t)) : n[i] = De(e[i], t);
  };
  return r("topLeft", "top"), r("topRight", "top"), r("bottomLeft", "bottom"), r("bottomRight", "bottom"), n;
};
function hZe(e) {
  return ti(e);
}
const gZe = (e, t) => {
  const n = {
    topLeft: 0,
    topRight: 0,
    bottomLeft: 0,
    bottomRight: 0
  };
  return e ? hZe(e) ? fZe(e, t) : (n.topLeft = De(e, t), n.topRight = De(e, t), n) : n;
}, pZe = function(e, t) {
  if (e === void 0 && (e = {}), t.disableInlineStyles)
    return {};
  const r = {
    fill: "black",
    stroke: e.fill || "black"
  };
  return br(Object.assign(r, e), t);
}, Xs = (e, t) => ({
  x: e,
  y: t,
  distance(n) {
    return Math.sqrt(Math.pow(this.x - n.x, 2) + Math.pow(this.y - n.y, 2));
  },
  // vector addition in 2d plane
  add(n) {
    return Xs(this.x + n.x, this.y + n.y);
  },
  // vector subtraction in 2d
  // returns p0 - p1
  subtract(n) {
    return Xs(this.x - n.x, this.y - n.y);
  },
  // multiply a 2d point by a scalar
  scalarMult(n) {
    return Xs(this.x * n, this.y * n);
  },
  scalarDivide(n) {
    if (n === 0)
      throw new Error("Division by 0 error");
    return Xs(this.x / n, this.y / n);
  },
  equals(n) {
    return this.x === n.x && this.y === n.y;
  }
}), Ew = (e, t) => ({
  center: e,
  radius: t,
  hasIntersection(n) {
    const r = this.center, i = n.center, o = this.radius, a = n.radius, s = r.distance(i);
    return !(s > o + a || s < Math.abs(o - a));
  },
  equals(n) {
    const r = this.center, i = n.center, o = this.radius, a = n.radius;
    return o === a && r.equals(i);
  },
  // Source: http://paulbourke.net/geometry/circlesphere/
  // "Intersection of two circles" by Paul Bourke
  // Left-most point is returned as 0th element of array
  // Right-most point is returned as 1st elemennt of array
  intersection(n) {
    const r = this.center, i = n.center, o = this.radius, a = n.radius, s = r.distance(i);
    if (!this.hasIntersection(n) || this.equals(n))
      return [];
    const c = (Math.pow(o, 2) - Math.pow(a, 2) + Math.pow(s, 2)) / (2 * s), l = Math.sqrt(Math.pow(o, 2) - Math.pow(c, 2)), u = r.add(i.subtract(r).scalarMult(c).scalarDivide(s)), {
      x: d,
      y: f
    } = r, {
      x: h,
      y: p
    } = i, {
      x: g,
      y: m
    } = u, v = [Xs(g - l * (p - f) / s, m + l * (h - d) / s), Xs(g + l * (p - f) / s, m - l * (h - d) / s)];
    return v.sort((y, S) => y.x - S.x), v;
  },
  solveX(n) {
    const r = Math.sqrt(Math.pow(this.radius, 2) - Math.pow(n - this.center.y, 2));
    return [this.center.x - r, this.center.x + r];
  },
  solveY(n) {
    const r = Math.sqrt(Math.pow(this.radius, 2) - Math.pow(n - this.center.x, 2));
    return [this.center.y - r, this.center.y + r];
  }
}), A3 = (e, t) => {
  const {
    x: n,
    x0: r,
    y: i,
    y0: o,
    horizontal: a
  } = e, s = e.alignment || "middle", c = s === "middle" ? t / 2 : t, l = a ? -1 : 1;
  return a ? {
    x0: r,
    x1: n,
    y0: s === "start" ? i : i - l * c,
    y1: s === "end" ? i : i + l * c
  } : {
    x0: s === "start" ? n : n - l * c,
    x1: s === "end" ? n : n + l * c,
    y0: o,
    y1: i
  };
}, Ad = (e, t) => {
  const {
    data: n,
    scale: r
  } = e, i = n[t]._x1 === void 0 ? "_x" : "_x1";
  return r.x(n[t][i]);
}, mZe = (e, t) => {
  const {
    scale: n
  } = e, r = n.y.range(), i = Math.max(...r), o = Math.abs(n.x.range()[1] - n.x.range()[0]);
  return t / (2 * Math.PI * i) * o;
}, D9 = (e) => -1 * e + Math.PI / 2, vZe = (e, t) => {
  const {
    getPath: n
  } = e;
  if (typeof n == "function") {
    const r = {
      ...e,
      ...A3(e, t)
    };
    return n(r);
  }
}, yZe = (e, t) => {
  const {
    data: n,
    scale: r,
    alignment: i
  } = e, o = Ad(e, t), a = Math.abs(r.x.range()[1] - r.x.range()[0]), s = t === 0 ? Ad(e, n.length - 1) - Math.PI * 2 : Ad(e, t - 1);
  return t === 0 && a < 2 * Math.PI ? r.x.range()[0] : i === "start" || i === "end" ? i === "start" ? s : o : (o + s) / 2;
}, bZe = (e, t) => {
  const {
    data: n,
    scale: r,
    alignment: i
  } = e, o = Ad(e, t), a = Math.abs(r.x.range()[1] - r.x.range()[0]), s = r.x.range()[1] === 2 * Math.PI ? Ad(e, 0) + Math.PI * 2 : r.x.range()[1], c = t === n.length - 1 ? Ad(e, 0) + Math.PI * 2 : Ad(e, t + 1);
  return t === n.length - 1 && a < 2 * Math.PI ? s : i === "start" || i === "end" ? i === "start" ? o : c : (o + c) / 2;
}, hre = (e, t, n) => {
  const r = `${t.topLeft} ${t.topLeft} ${n}`, i = `${t.topRight} ${t.topRight} ${n}`, o = `${t.bottomLeft} ${t.bottomLeft} ${n}`, a = `${t.bottomRight} ${t.bottomRight} ${n}`;
  return `${["M", `A ${o},`, "L", `A ${r},`, "L", `A ${i},`, "L", `A ${a},`].reduce((l, u, d) => `${l}${u} ${e[d].x}, ${e[d].y} 
`, "")} z`;
}, _Ze = (e, t, n) => {
  const {
    x0: r,
    x1: i,
    y0: o,
    y1: a
  } = e, s = (c) => {
    const l = c === "Left", u = l ? 1 : -1, d = l ? r : i;
    let f = {
      x: d + u * n[`bottom${c}`],
      y: o
    }, h = {
      x: d,
      y: o - t * n[`bottom${c}`]
    }, p = {
      x: d,
      y: a + t * n[`top${c}`]
    }, g = {
      x: d + u * n[`top${c}`],
      y: a
    };
    if (t === 1 ? o - n[`bottom${c}`] < a + n[`top${c}`] : o + n[`bottom${c}`] > a - n[`top${c}`]) {
      const y = Xs(d + u * n[`top${c}`], a + t * n[`top${c}`]), S = Ew(y, n[`top${c}`]), _ = Xs(d + u * n[`bottom${c}`], o - t * n[`bottom${c}`]), w = Ew(_, n[`bottom${c}`]), T = S.intersection(w);
      if (T.length > 0) {
        const C = T[l ? 0 : 1];
        h = {
          x: C.x,
          y: C.y
        }, p = {
          x: C.x,
          y: C.y
        };
      } else if (n[`top${c}`] > n[`bottom${c}`]) {
        const E = S.solveX(o)[l ? 0 : 1];
        f = {
          x: E,
          y: o
        }, h = {
          x: E,
          y: o
        }, p = {
          x: E,
          y: o
        };
      } else {
        const E = w.solveX(a)[l ? 0 : 1];
        h = {
          x: E,
          y: a
        }, p = {
          x: E,
          y: a
        }, g = {
          x: E,
          y: a
        };
      }
    }
    const v = [f, h, p, g];
    return l ? v : v.reverse();
  };
  return s("Left").concat(s("Right"));
}, SZe = (e, t, n) => {
  const {
    y0: r,
    y1: i
  } = e, o = e.x0 < e.x1 ? e.x0 : e.x1, a = e.x0 < e.x1 ? e.x1 : e.x0, s = (u) => {
    const d = u === "top", f = d ? -1 : 1, h = d ? i : r;
    let p = {
      x: o,
      y: h - f * n[`${u}Left`]
    }, g = {
      x: o + n[`${u}Left`],
      y: h
    }, m = {
      x: a - n[`${u}Right`],
      y: h
    }, v = {
      x: a,
      y: h - f * n[`${u}Right`]
    };
    if (g.x > m.x) {
      const S = Xs(o + n[`${u}Left`], h - f * n[`${u}Left`]), _ = Ew(S, n[`${u}Left`]), w = Xs(a - n[`${u}Right`], h - f * n[`${u}Right`]), T = Ew(w, n[`${u}Right`]), x = _.intersection(T);
      if (x.length > 0) {
        const E = x[t > 0 ? 1 : 0];
        g = {
          x: E.x,
          y: E.y
        }, m = {
          x: E.x,
          y: E.y
        };
      } else if (n[`${u}Right`] > n[`${u}Left`]) {
        const R = T.solveY(o)[d ? 0 : 1];
        p = {
          x: o,
          y: R
        }, g = {
          x: o,
          y: R
        }, m = {
          x: o,
          y: R
        };
      } else {
        const R = _.solveY(a)[d ? 0 : 1];
        v = {
          x: a,
          y: R
        }, m = {
          x: a,
          y: R
        }, g = {
          x: a,
          y: R
        };
      }
    }
    return [p, g, m, v];
  }, c = s("top"), l = s("bottom");
  return [
    l[1],
    l[0],
    ...c,
    // eslint-disable-next-line no-magic-numbers
    l[3],
    l[2]
  ];
}, wZe = (e, t, n) => {
  const r = A3(e, t), i = r.y0 > r.y1 ? 1 : -1, o = i > 0 ? "0 0 1" : "0 0 0", a = _Ze(r, i, n);
  return hre(a, n, o);
}, xZe = (e, t, n) => {
  const r = A3(e, t), i = r.x0 < r.x1 ? 1 : -1, o = "0 0 1", a = {
    topRight: i > 0 ? n.topLeft : n.bottomLeft,
    bottomRight: i > 0 ? n.topRight : n.bottomRight,
    bottomLeft: i > 0 ? n.bottomRight : n.topRight,
    topLeft: i > 0 ? n.bottomLeft : n.topLeft
  }, s = SZe(r, i, a);
  return hre(s, a, o);
}, EZe = (e, t) => {
  const {
    datum: n,
    scale: r,
    index: i,
    alignment: o,
    style: a
  } = e, s = r.y(n._y0 || 0), c = r.y(n._y1 !== void 0 ? n._y1 : n._y), l = r.x(n._x1 !== void 0 ? n._x1 : n._x);
  let u, d;
  if (a.width) {
    const _ = mZe(e, a.width), w = o === "middle" ? _ / 2 : _;
    u = o === "start" ? l : l - w, d = o === "end" ? l : l + w;
  } else
    u = yZe(e, Number(i)), d = bZe(e, Number(i));
  const f = (_) => KE().innerRadius(s).outerRadius(c).startAngle(D9(u)).endAngle(D9(d)).cornerRadius(t[_])(), h = (_) => {
    const w = f(`${_}Right`), T = w.match(/[A-Z]/g) || [], x = w.split(/[A-Z]/).slice(1), C = T.indexOf("L"), E = f(`${_}Left`), R = E.match(/[A-Z]/g) || [], A = E.split(/[A-Z]/).slice(1), O = R.indexOf("L");
    return {
      rightMoves: T,
      rightCoords: x,
      rightMiddle: C,
      leftMoves: R,
      leftCoords: A,
      leftMiddle: O
    };
  }, p = () => {
    const {
      topRight: _,
      topLeft: w
    } = t, T = c * Math.abs(d - u), {
      rightMoves: x,
      rightCoords: C,
      rightMiddle: E,
      leftMoves: R,
      leftCoords: A,
      leftMiddle: O
    } = h("top");
    let $, N;
    if (_ === w || T < 2 * _ + 2 * w)
      $ = _ > w ? x : R, N = _ > w ? C : A;
    else {
      const V = (U) => U < 3, j = w > _ && V(E) ? 1 : 2;
      let B;
      if (_ > w) {
        const U = V(E) ? O : O - 2;
        B = V(O) ? O - 1 : U;
      } else {
        const U = V(O) ? 1 : 2;
        B = V(E) ? U : O - 2;
      }
      $ = [...x.slice(0, j), ...R.slice(B)], N = [...C.slice(0, j), ...A.slice(B)];
    }
    const z = $.indexOf("L"), k = $.slice(0, z), F = N.slice(0, z);
    return k.map((V, j) => ({
      command: V,
      coords: F[j].split(",")
    }));
  }, g = () => {
    const {
      bottomRight: _,
      bottomLeft: w
    } = t, T = s * Math.abs(d - u), {
      rightMoves: x,
      rightCoords: C,
      rightMiddle: E,
      leftMoves: R,
      leftCoords: A,
      leftMiddle: O
    } = h("bottom");
    let $, N;
    if (_ === w || T < 2 * _ + 2 * w)
      $ = _ > w ? x : R, N = _ > w ? C : A;
    else {
      const V = (U, Q) => U.length - Q < 4, B = (_ > w ? V(x, E) : V(R, O)) ? -1 : -3;
      $ = [...R.slice(0, O + 2), ...x.slice(B)], N = [...A.slice(0, O + 2), ...C.slice(B)];
    }
    const z = $.indexOf("L"), k = $.slice(z, -1), F = N.slice(z, -1);
    return k.map((V, j) => ({
      command: V,
      coords: F[j].split(",")
    }));
  }, m = p(), v = g();
  return `${[...m, ...v].reduce((_, w) => `${_}${w.command} ${w.coords.join()}`, "")} z`;
}, CZe = (e, t, n) => e.getPath ? vZe(e, t) : e.horizontal ? xZe(e, t, n) : wZe(e, t, n), TZe = (e, t) => EZe(e, t), IZe = (e) => {
  const t = pZe(e.style, e), n = dZe(e.barWidth, Object.assign({}, e, {
    style: t
  })), r = gZe(e.cornerRadius, Object.assign({}, e, {
    style: t,
    barWidth: n
  })), i = De(e.ariaLabel, e), o = De(e.desc, e), a = De(e.id, e), s = De(e.tabIndex, e);
  return Object.assign({}, e, {
    ariaLabel: i,
    style: t,
    barWidth: n,
    cornerRadius: r,
    desc: o,
    id: a,
    tabIndex: s
  });
}, AZe = {
  pathComponent: /* @__PURE__ */ D.createElement(Up, null),
  role: "presentation",
  shapeRendering: "auto"
}, RZe = /* @__PURE__ */ ta(
  // eslint-disable-next-line prefer-arrow-callback
  function(t, n) {
    const r = IZe(He({}, t, AZe)), {
      polar: i,
      origin: o,
      style: a,
      barWidth: s,
      cornerRadius: c
    } = r, l = i ? TZe(r, c) : CZe(r, s, c), u = i && o ? `translate(${o.x}, ${o.y})` : void 0;
    return r.pathComponent ? /* @__PURE__ */ D.cloneElement(r.pathComponent, {
      ...r.events,
      "aria-label": r.ariaLabel,
      style: a,
      d: l,
      className: r.className,
      clipPath: r.clipPath,
      desc: r.desc,
      index: r.index,
      role: r.role,
      shapeRendering: r.shapeRendering,
      transform: r.transform || u,
      tabIndex: r.tabIndex,
      ref: n
    }) : null;
  }
), L9 = {
  width: 450,
  height: 300,
  padding: 50
}, $Ze = [{
  x: 1,
  y: 1
}, {
  x: 2,
  y: 2
}, {
  x: 3,
  y: 3
}, {
  x: 4,
  y: 4
}], Pa = class Pa extends D.Component {
  static getBaseProps(t) {
    return lZe(t, L9);
  }
  // Overridden in native versions
  shouldAnimate() {
    return !!this.props.animate;
  }
  render() {
    var a;
    const {
      animationWhitelist: t,
      role: n
    } = n$, r = _r(this.props, L9, n);
    if (this.shouldAnimate())
      return this.animateComponent(r, t);
    let i;
    ((a = r.groupComponent) == null ? void 0 : a.type) === ng ? i = this.renderData(r, Pa.shouldRenderDatum) : i = this.renderData(r);
    const o = r.standalone ? this.renderContainer(r.containerComponent, i) : i;
    return Cy(o, r);
  }
};
ye(Pa, "animationWhitelist", ["data", "domain", "height", "padding", "style", "width"]), ye(Pa, "displayName", "VictoryBar"), ye(Pa, "role", "bar"), ye(Pa, "defaultTransitions", {
  onLoad: {
    duration: 2e3,
    before: () => ({
      _y: 0,
      _y1: 0,
      _y0: 0
    }),
    after: (t) => ({
      _y: t._y,
      _y1: t._y1,
      _y0: t._y0
    })
  },
  onExit: {
    duration: 500,
    before: () => ({
      _y: 0,
      yOffset: 0
    })
  },
  onEnter: {
    duration: 500,
    before: () => ({
      _y: 0,
      _y1: 0,
      _y0: 0
    }),
    after: (t) => ({
      _y: t._y,
      _y1: t._y1,
      _y0: t._y0
    })
  }
}), ye(Pa, "defaultProps", {
  containerComponent: /* @__PURE__ */ D.createElement(ko, null),
  data: $Ze,
  dataComponent: /* @__PURE__ */ D.createElement(RZe, null),
  groupComponent: /* @__PURE__ */ D.createElement("g", {
    role: "presentation"
  }),
  labelComponent: /* @__PURE__ */ D.createElement(qi, null),
  samples: 50,
  sortOrder: "ascending",
  standalone: !0,
  theme: Ca.grayscale
}), ye(Pa, "getDomain", UR), ye(Pa, "getData", Mo), ye(Pa, "expectedComponents", ["dataComponent", "labelComponent", "groupComponent", "containerComponent"]), // passed to addEvents.renderData to prevent data props with undefined _x or _y from excluding data from render.
// used when inside of VictoryZoomContainer
ye(Pa, "shouldRenderDatum", () => !0);
let t$ = Pa;
const n$ = qu(t$);
var OZe = /\s/;
function PZe(e) {
  for (var t = e.length; t-- && OZe.test(e.charAt(t)); )
    ;
  return t;
}
var MZe = PZe, kZe = MZe, NZe = /^\s+/;
function DZe(e) {
  return e && e.slice(0, kZe(e) + 1).replace(NZe, "");
}
var LZe = DZe, jZe = LZe, j9 = Ka, FZe = py, F9 = 0 / 0, VZe = /^[-+]0x[0-9a-f]+$/i, BZe = /^0b[01]+$/i, zZe = /^0o[0-7]+$/i, HZe = parseInt;
function UZe(e) {
  if (typeof e == "number")
    return e;
  if (FZe(e))
    return F9;
  if (j9(e)) {
    var t = typeof e.valueOf == "function" ? e.valueOf() : e;
    e = j9(t) ? t + "" : t;
  }
  if (typeof e != "string")
    return e === 0 ? e : +e;
  e = jZe(e);
  var n = BZe.test(e);
  return n || zZe.test(e) ? HZe(e.slice(2), n ? 2 : 8) : VZe.test(e) ? F9 : +e;
}
var WZe = UZe;
function qZe(e) {
  for (var t = -1, n = e == null ? 0 : e.length, r = {}; ++t < n; ) {
    var i = e[t];
    r[i[0]] = i[1];
  }
  return r;
}
var GZe = qZe;
const KZe = /* @__PURE__ */ pn(GZe);
var r$ = { exports: {} };
(function(e, t) {
  t = e.exports = n, t.getSerialize = r;
  function n(i, o, a, s) {
    return JSON.stringify(i, r(o, s), a);
  }
  function r(i, o) {
    var a = [], s = [];
    return o == null && (o = function(c, l) {
      return a[0] === l ? "[Circular ~]" : "[Circular ~." + s.slice(0, a.indexOf(l)).join(".") + "]";
    }), function(c, l) {
      if (a.length > 0) {
        var u = a.indexOf(this);
        ~u ? a.splice(u + 1) : a.push(this), ~u ? s.splice(u, 1 / 0, c) : s.push(c), ~a.indexOf(l) && (l = o.call(this, c, l));
      } else
        a.push(l);
      return i == null ? l : i.call(this, c, l);
    };
  }
})(r$, r$.exports);
var YZe = r$.exports;
const XZe = /* @__PURE__ */ pn(YZe);
class Rd extends D.Component {
  constructor(t) {
    super(t), this.getScopedEvents = yee.bind(this), this.getEventState = _ee.bind(this), this.state = this.state || {}, this.sharedEventsCache = {}, this.globalEvents = {}, this.prevGlobalEventKeys = [], this.boundGlobalEvents = {}, this.baseProps = this.getBaseProps(t);
  }
  shouldComponentUpdate(t) {
    if (!ys(this.props, t)) {
      this.baseProps = this.getBaseProps(t);
      const n = this.getExternalMutations(t, this.baseProps);
      this.applyExternalMutations(t, n);
    }
    return !0;
  }
  componentDidMount() {
    const t = Object.keys(this.globalEvents);
    t.forEach((n) => this.addGlobalListener(n)), this.prevGlobalEventKeys = t;
  }
  componentDidUpdate() {
    const t = Object.keys(this.globalEvents);
    QS(this.prevGlobalEventKeys, t).forEach((i) => this.removeGlobalListener(i)), QS(t, this.prevGlobalEventKeys).forEach((i) => this.addGlobalListener(i)), this.prevGlobalEventKeys = t;
  }
  componentWillUnmount() {
    this.prevGlobalEventKeys.forEach((t) => this.removeGlobalListener(t));
  }
  addGlobalListener(t) {
    const n = (r) => {
      const i = this.globalEvents[t];
      return i && i(Eee(r));
    };
    this.boundGlobalEvents[t] = n, window.addEventListener(ZS(t), n);
  }
  removeGlobalListener(t) {
    window.removeEventListener(ZS(t), this.boundGlobalEvents[t]);
  }
  getAllEvents(t) {
    const r = IM(t, ["container", "groupComponent"]);
    return Array.isArray(r) ? Array.isArray(t.events) ? r.concat(...t.events) : r : t.events;
  }
  applyExternalMutations(t, n) {
    if (!Lr(n)) {
      const r = t.externalEventMutations.reduce((o, a) => Rn(a.callback) ? o.concat(a.callback) : o, []), i = r.length ? () => {
        r.forEach((o) => o());
      } : void 0;
      this.setState(n, i);
    }
  }
  getExternalMutations(t, n) {
    return Lr(t.externalEventMutations) ? void 0 : aqe(t.externalEventMutations, n, this.state, Object.keys(n));
  }
  cacheSharedEvents(t, n, r) {
    this.sharedEventsCache[t] = [n, r];
  }
  getCachedSharedEvents(t, n) {
    const [r, i] = this.sharedEventsCache[t] || [];
    if (r && ys(n, i))
      return r;
  }
  getBaseProps(t) {
    const {
      container: n
    } = t, r = D.Children.toArray(this.props.children), i = this.getBasePropsFromChildren(r), o = n ? n.props : {};
    return Object.assign({}, i, {
      parent: o
    });
  }
  getBasePropsFromChildren(t) {
    const r = Bp(t, (i, o) => {
      if (i.type && Rn(i.type.getBaseProps)) {
        const a = i.props && i.type.getBaseProps(i.props);
        return a ? [[o, a]] : null;
      }
      return null;
    });
    return KZe(r);
  }
  getNewChildren(t, n) {
    const {
      events: r,
      eventKey: i
    } = t, o = (c, l) => c.reduce((u, d, f) => {
      if (d.props.children) {
        const h = D.Children.toArray(d.props.children), p = l.slice(f, f + h.length), g = /* @__PURE__ */ D.cloneElement(d, d.props, o(h, p));
        return u.concat(g);
      } else if (l[f] !== "parent" && d.type && Rn(d.type.getBaseProps)) {
        const h = d.props.name || l[f], p = Array.isArray(r) && r.filter((v) => v.target === "parent" ? !1 : Array.isArray(v.childName) ? v.childName.indexOf(h) > -1 : v.childName === h || v.childName === "all"), g = [h, n, p, XZe(this.state[h])], m = this.getCachedSharedEvents(h, g) || {
          events: p,
          // partially apply child name and baseProps,
          getEvents: (v, y) => this.getScopedEvents(v, y, h, n),
          // partially apply child name
          getEventState: (v, y) => this.getEventState(v, y, h)
        };
        return this.cacheSharedEvents(h, m, g), u.concat(/* @__PURE__ */ D.cloneElement(d, Object.assign({
          key: `events-${h}`,
          sharedEvents: m,
          eventKey: i,
          name: h
        }, d.props)));
      }
      return u.concat(d);
    }, []), a = Object.keys(n), s = D.Children.toArray(t.children);
    return o(s, a);
  }
  getContainer(t, n, r) {
    const i = this.getNewChildren(t, n), o = Array.isArray(r) ? r.filter((g) => g.target === "parent") : [], a = o.length > 0 ? {
      events: o,
      // partially apply childName (null) and baseProps,
      getEvents: (g, m) => this.getScopedEvents(g, m, null, n),
      getEventState: this.getEventState
    } : null, s = t.container || t.groupComponent, c = s.type && s.type.role, l = s.props || {}, u = vee.bind(this), d = a && u({
      sharedEvents: a
    }, "parent"), f = He({}, this.getEventState("parent", "parent"), l, n.parent, {
      children: i
    }), h = He({}, bee(d, "parent", f), l.events);
    this.globalEvents = wee(h);
    const p = xee(h);
    return c === "container" ? /* @__PURE__ */ D.cloneElement(s, Object.assign({}, f, {
      events: p
    })) : /* @__PURE__ */ D.cloneElement(s, p, i);
  }
  render() {
    const t = this.getAllEvents(this.props);
    return t ? this.getContainer(this.props, this.baseProps, t) : /* @__PURE__ */ D.cloneElement(this.props.container, {
      children: this.props.children
    });
  }
}
ye(Rd, "displayName", "VictorySharedEvents"), ye(Rd, "role", "shared-event-wrapper"), ye(Rd, "contextType", xM), ye(Rd, "defaultProps", {
  groupComponent: /* @__PURE__ */ D.createElement("g", null)
});
const Qo = (e, t, n) => n === "x" ? e * Math.cos(t) : -e * Math.sin(t), gre = (e) => {
  const t = e.dependentAxis ? "radial" : "angular", n = t === "angular" ? "radial" : "angular";
  return e.horizontal ? n : t;
}, QZe = (e, t) => x3(e, (r) => t(r) % (2 * Math.PI)), R3 = (e, t) => ({
  tickStyle: br(e.ticks, t),
  labelStyle: br(e.tickLabels, t),
  gridStyle: br(e.grid, t)
}), JZe = (e) => {
  var c, l;
  const {
    theme: t = {},
    dependentAxis: n
  } = e, r = t.polarAxis && t.polarAxis.style || t.axis && t.axis.style, i = n ? "polarDependentAxis" : "polarIndependentAxis", o = n ? "dependentAxis" : "independentAxis", a = ((c = t == null ? void 0 : t[i]) == null ? void 0 : c.style) || ((l = t == null ? void 0 : t[o]) == null ? void 0 : l.style);
  return r && a ? (() => ["axis", "axisLabel", "grid", "parent", "tickLabels", "ticks"].reduce((d, f) => (d[f] = He({}, a == null ? void 0 : a[f], r == null ? void 0 : r[f]), d), {}))() : a || r;
}, pre = (e) => {
  const {
    left: t,
    right: n,
    top: r,
    bottom: i
  } = Wi(e.padding), {
    width: o,
    height: a
  } = e;
  if (o === void 0 || a === void 0)
    throw new Error("VictoryPolarAxis: width and height properties are required for standalone axes.");
  return Math.min(o - t - n, a - r - i) / 2;
}, mre = (e, t) => {
  if (e.range && e.range[t])
    return e.range[t];
  if (e.range && Array.isArray(e.range))
    return e.range;
  if (gre(e) === "angular") {
    const i = fr(e.startAngle), o = fr(e.endAngle);
    return [i, o];
  }
  const r = pre(e);
  return [e.innerRadius || 0, r];
}, vre = (e) => {
  const t = Qa(e), n = ea(e, t), r = zp(e, t) || n.domain(), i = mre(e, t);
  return n.range(i), n.domain(r), n;
}, yre = function(e, t) {
  if (t === void 0 && (t = {}), e.disableInlineStyles)
    return {};
  const n = e.style || {};
  return {
    parent: He({
      height: "auto",
      width: "100%"
    }, n.parent, t.parent),
    axis: He({}, n.axis, t.axis),
    axisLabel: He({}, n.axisLabel, t.axisLabel),
    grid: He({}, n.grid, t.grid),
    ticks: He({}, n.ticks, t.ticks),
    tickLabels: He({}, n.tickLabels, t.tickLabels)
  };
}, nC = (e) => {
  const {
    axisAngle: t,
    startAngle: n,
    dependentAxis: r
  } = e, i = Qa(e), o = zte(e, i);
  return o === void 0 || !r ? t === void 0 ? n : t : Qc(o);
}, ZZe = (e, t, n, r) => {
  const {
    axisType: i,
    radius: o,
    scale: a,
    style: s,
    stringTicks: c,
    ticks: l,
    tickFormat: u,
    origin: d
  } = t, f = u(n, r, l), h = c ? c[r] : n, {
    tickStyle: p
  } = R3(s, {
    tick: h,
    tickValue: n,
    index: r,
    ticks: l,
    stringTicks: c,
    radius: o,
    scale: a,
    axisType: i,
    text: f
  }), g = i === "radial" ? nC(e) : void 0, m = p.padding || p.size || 0, v = fr(90 - g), y = i === "angular" ? a(n) : fr(-1 * g), S = i === "angular" ? o : a(n);
  return i === "angular" ? {
    index: r,
    datum: h,
    style: p,
    x1: Qo(S, y, "x") + d.x,
    y1: Qo(S, y, "y") + d.y,
    x2: Qo(S + m, y, "x") + d.x,
    y2: Qo(S + m, y, "y") + d.y
  } : {
    index: r,
    datum: h,
    style: p,
    x1: S * Math.cos(y) + Math.cos(v) * m + d.x,
    x2: S * Math.cos(y) - Math.cos(v) * m + d.x,
    y1: S * Math.sin(y) + Math.sin(v) * m + d.y,
    y2: S * Math.sin(y) - Math.sin(v) * m + d.y
  };
}, eet = (e, t, n, r) => {
  const {
    axisType: i,
    radius: o,
    tickFormat: a,
    style: s,
    scale: c,
    ticks: l,
    stringTicks: u,
    origin: d
  } = t, f = a(n, r, l), h = u ? u[r] : n, {
    labelStyle: p
  } = R3(s, {
    text: f,
    tick: h,
    tickValue: n,
    index: r,
    ticks: l,
    stringTicks: u,
    radius: o,
    scale: c,
    axisType: i
  }), {
    tickLabelComponent: g
  } = e, m = g != null && g.props.labelPlacement ? g.props.labelPlacement : e.labelPlacement, v = p.padding || 0, y = 0, S = i === "radial" ? nC(e) : void 0, _ = i === "angular" ? Qc(c(n)) : S + y, w = p.angle === void 0 ? c3(Object.assign({}, e, {
    labelPlacement: m
  }), _) : p.angle, T = i === "angular" ? o + v : c(n), x = p.textAnchor || s3(Object.assign({}, e, {
    labelPlacement: m
  }), _);
  return {
    index: r,
    datum: h,
    style: p,
    angle: w,
    textAnchor: x,
    text: f,
    x: T * Math.cos(fr(_)) + d.x,
    y: -T * Math.sin(fr(_)) + d.y
  };
}, tet = (e, t, n, r) => {
  const {
    axisType: i,
    radius: o,
    style: a,
    scale: s,
    stringTicks: c,
    ticks: l,
    tickFormat: u,
    origin: d
  } = t, f = u(n, r, l), {
    startAngle: h,
    endAngle: p,
    innerRadius: g = 0
  } = e, m = c ? c[r] : n, {
    gridStyle: v
  } = R3(a, {
    tick: m,
    tickValue: n,
    index: r,
    ticks: l,
    stringTicks: c,
    radius: o,
    scale: s,
    axisType: i,
    text: f
  }), y = s(n);
  return i === "angular" ? {
    index: r,
    datum: m,
    style: v,
    x1: Qo(o, y, "x") + d.x,
    y1: Qo(o, y, "y") + d.y,
    x2: Qo(g, y, "x") + d.x,
    y2: Qo(g, y, "y") + d.y
  } : {
    style: v,
    index: r,
    datum: m,
    cx: d.x,
    cy: d.y,
    r: s(n),
    startAngle: h,
    endAngle: p
  };
}, net = (e, t) => {
  const {
    axisType: n,
    radius: r,
    style: i,
    origin: o
  } = t, {
    axisLabelComponent: a
  } = e;
  if (n !== "radial")
    return {};
  const s = a != null && a.props.labelPlacement ? a.props.labelPlacement : e.labelPlacement, c = i && i.axisLabel || {}, l = n === "radial" ? nC(e) : void 0, u = c.angle === void 0 ? c3(Object.assign({}, e, {
    labelPlacement: s
  }), l) : c.angle, d = r + (c.padding || 0), f = c.textAnchor || s3(Object.assign({}, e, {
    labelPlacement: s
  }), l), h = c.verticalAnchor || Ute(Object.assign({}, e, {
    labelPlacement: s
  }), l);
  return {
    style: c,
    angle: u,
    textAnchor: f,
    verticalAnchor: h,
    text: e.label,
    x: Qo(d, fr(l), "x") + o.x,
    y: Qo(d, fr(l), "y") + o.y
  };
}, ret = (e, t) => {
  const {
    style: n,
    axisType: r,
    radius: i,
    origin: o
  } = t, {
    startAngle: a,
    endAngle: s,
    innerRadius: c = 0
  } = e, l = r === "radial" ? fr(nC(e)) : void 0;
  return r === "radial" ? {
    style: n.axis,
    x1: Qo(c, l, "x") + o.x,
    x2: Qo(i, l, "x") + o.x,
    y1: Qo(c, l, "y") + o.y,
    y2: Qo(i, l, "y") + o.y
  } : {
    style: n.axis,
    cx: o.x,
    cy: o.y,
    r: i,
    startAngle: a,
    endAngle: s
  };
}, iet = (e) => {
  const t = Object.assign({
    polar: !0
  }, e), n = JZe(t), r = yre(t, n), i = Wi(t.padding), o = Qa(t), a = gre(t), s = qE(t) ? t.tickValues : void 0, c = zp(t, o), l = mre(t, o), u = vre(t), d = Bte(t, u), f = a === "angular" ? QZe(d, u) : d, h = Vte(t, u), p = pre(t), g = jf(t);
  return {
    axis: o,
    style: r,
    padding: i,
    stringTicks: s,
    axisType: a,
    scale: u,
    ticks: f,
    tickFormat: h,
    domain: c,
    range: l,
    radius: p,
    origin: g
  };
}, oet = (e, t) => {
  const n = GE(e, t), r = iet(n), {
    style: i,
    scale: o,
    ticks: a,
    domain: s
  } = r, {
    width: c,
    height: l,
    standalone: u,
    theme: d,
    name: f
  } = n, h = ret(n, r), p = net(n, r), g = {
    parent: {
      style: i.parent,
      ticks: a,
      scale: o,
      width: c,
      height: l,
      domain: s,
      standalone: u,
      theme: d,
      name: f
    }
  };
  return a.reduce((m, v, y) => (m[y] = {
    axis: h,
    axisLabel: p,
    ticks: ZZe(n, r, v, y),
    tickLabels: eet(n, r, v, y),
    grid: tet(n, r, v, y)
  }, m), g);
}, CT = {
  width: 450,
  height: 300,
  padding: 50
};
class Pc extends D.Component {
  static getScale(t) {
    return vre(t);
  }
  static getStyles(t) {
    return yre(t, CT.style);
  }
  static getBaseProps(t) {
    return oet(t, CT);
  }
  renderAxisLine(t) {
    const {
      dependentAxis: n
    } = t, r = n ? t.axisComponent : t.circularAxisComponent, i = this.getComponentProps(r, "axis", 0);
    return /* @__PURE__ */ D.cloneElement(r, i);
  }
  renderLabel(t) {
    const {
      axisLabelComponent: n,
      dependentAxis: r,
      label: i
    } = t;
    if (!i || !r)
      return null;
    const o = this.getComponentProps(n, "axisLabel", 0);
    return /* @__PURE__ */ D.cloneElement(n, o);
  }
  renderAxis(t) {
    const {
      tickComponent: n,
      tickLabelComponent: r,
      name: i
    } = t, o = (p) => {
      const {
        style: g = {},
        events: m = {}
      } = p;
      return g.stroke !== "transparent" && g.stroke !== "none" && g.strokeWidth !== 0 || !Lr(m);
    }, s = (t.dependentAxis ? "radial" : "angular") === "radial" ? t.circularGridComponent : t.gridComponent, c = this.dataKeys.map((p, g) => {
      const m = Object.assign({
        key: `${i}-tick-${p}`
      }, this.getComponentProps(n, "ticks", g)), v = /* @__PURE__ */ D.cloneElement(n, m);
      return o(v.props) ? v : void 0;
    }).filter(Boolean), l = this.dataKeys.map((p, g) => {
      const m = Object.assign({
        key: `${i}-grid-${p}`
      }, this.getComponentProps(s, "grid", g)), v = /* @__PURE__ */ D.cloneElement(s, m);
      return o(v.props) ? v : void 0;
    }).filter(Boolean), u = this.dataKeys.map((p, g) => {
      const m = Object.assign({
        key: `${i}-tick-${p}`
      }, this.getComponentProps(r, "tickLabels", g));
      return /* @__PURE__ */ D.cloneElement(r, m);
    }), d = this.renderAxisLine(t), f = this.renderLabel(t), h = [d, f, ...c, ...l, ...u];
    return this.renderGroup(t, h);
  }
  // Overridden in victory-native
  renderGroup(t, n) {
    const {
      groupComponent: r
    } = t;
    return /* @__PURE__ */ D.cloneElement(r, {}, n);
  }
  shouldAnimate() {
    return !!this.props.animate;
  }
  render() {
    const {
      animationWhitelist: t
    } = i$, n = GE(this.props, CT);
    if (this.shouldAnimate())
      return this.animateComponent(n, t);
    const r = this.renderAxis(n);
    return n.standalone ? this.renderContainer(n.containerComponent, r) : r;
  }
}
ye(Pc, "animationWhitelist", ["style", "domain", "range", "tickCount", "tickValues", "padding", "width", "height"]), ye(Pc, "displayName", "VictoryAxis"), ye(Pc, "role", "axis"), ye(Pc, "defaultTransitions", {
  onExit: {
    duration: 500
  },
  onEnter: {
    duration: 500
  }
}), ye(Pc, "defaultProps", {
  axisComponent: /* @__PURE__ */ D.createElement(Hd, null),
  axisLabelComponent: /* @__PURE__ */ D.createElement(qi, null),
  circularAxisComponent: /* @__PURE__ */ D.createElement(M9, null),
  circularGridComponent: /* @__PURE__ */ D.createElement(M9, null),
  containerComponent: /* @__PURE__ */ D.createElement(ko, null),
  endAngle: 360,
  gridComponent: /* @__PURE__ */ D.createElement(Hd, null),
  groupComponent: /* @__PURE__ */ D.createElement("g", {
    role: "presentation"
  }),
  labelPlacement: "parallel",
  startAngle: 0,
  standalone: !0,
  theme: Ca.grayscale,
  tickComponent: /* @__PURE__ */ D.createElement(Hd, null),
  tickLabelComponent: /* @__PURE__ */ D.createElement(qi, null)
}), ye(Pc, "getDomain", zp), ye(Pc, "getAxis", Qa), ye(Pc, "expectedComponents", ["axisComponent", "circularAxisComponent", "groupComponent", "containerComponent", "tickComponent", "tickLabelComponent", "gridComponent", "circularGridComponent"]);
const aet = {
  components: [{
    name: "axis",
    index: 0
  }, {
    name: "axisLabel",
    index: 0
  }, {
    name: "grid"
  }, {
    name: "parent",
    index: "parent"
  }, {
    name: "ticks"
  }, {
    name: "tickLabels"
  }]
}, i$ = qu(Pc, aet), set = {
  width: 450,
  height: 300,
  padding: 50
};
function cet(e, t, n) {
  const {
    domain: r,
    scale: i,
    stringMap: o,
    categories: a,
    horizontal: s
  } = n;
  return {
    stringMap: o,
    horizontal: s,
    categories: a,
    startAngle: t.startAngle,
    endAngle: t.endAngle,
    innerRadius: t.innerRadius,
    domain: r,
    scale: i
  };
}
function uet(e, t) {
  const n = e.backgroundComponent, r = e.polar ? t.range.y[1] : t.range.y[0] - t.range.y[1], i = t.range.x[1] - t.range.x[0], o = e.horizontal ? t.scale.y.range()[0] : t.scale.x.range()[0], a = e.horizontal ? t.scale.x.range()[1] : t.scale.y.range()[1], s = e.polar ? t.origin.x : o, c = e.polar ? t.origin.y : a, l = e.name || "chart", u = {
    height: r,
    polar: e.polar,
    scale: t.scale,
    style: e.style.background,
    x: s,
    y: c,
    key: `${l}-background`,
    width: i
  };
  return /* @__PURE__ */ D.cloneElement(n, He({}, n.props, u));
}
function det(e, t, n) {
  const r = Lte([e]);
  if (r.length > 0)
    return cet(r[0], t, n);
  const {
    categories: i,
    domain: o,
    range: a,
    scale: s,
    stringMap: c,
    horizontal: l
  } = n;
  return {
    categories: i,
    domain: o,
    range: a,
    scale: s,
    stringMap: c,
    horizontal: l
  };
}
function fet(e) {
  const t = e.style && e.style.parent;
  return {
    parent: He({}, t, {
      height: "100%",
      width: "100%",
      userSelect: "none"
    })
  };
}
function bre(e, t) {
  const n = fet(e), r = _r(e, set, "chart"), {
    horizontal: i,
    polar: o
  } = r, a = ire(r, t), s = C3(r, t, a), c = get(r, t, a), l = {
    x: V9(Object.assign({}, r, {
      categories: s
    }), "x", t),
    y: V9(Object.assign({}, r, {
      categories: s
    }), "y", t)
  }, u = {
    x: Pr(r, "x"),
    y: Pr(r, "y")
  }, d = {
    x: mf(r, "x") || Xg(r, "x"),
    y: mf(r, "y") || Xg(r, "y")
  }, f = {
    x: d.x.domain(l.x).range(i ? u.y : u.x),
    y: d.y.domain(l.y).range(i ? u.x : u.y)
  }, h = o ? jf(r) : Fte(l), p = Wi(r.padding);
  return {
    categories: s,
    domain: l,
    range: u,
    horizontal: i,
    scale: f,
    stringMap: c,
    style: n,
    origin: h,
    padding: p
  };
}
function het(e, t, n) {
  const r = t || _re(e), i = n || bre(e, r), o = i.style.parent, {
    height: a,
    polar: s,
    theme: c,
    width: l
  } = e, {
    origin: u,
    horizontal: d
  } = i, f = e.name || "chart";
  return r.filter(D.isValidElement).map((h, p) => {
    const g = h.type && h.type.role, m = Array.isArray(h.props.style) ? h.props.style : He({}, h.props.style, {
      parent: o
    }), v = det(h, e, i), y = h.props.name || `${f}-${g}-${p}`, S = He({
      horizontal: d,
      height: a,
      polar: s,
      theme: c,
      width: l,
      style: m,
      name: y,
      origin: s ? u : void 0,
      padding: i.padding,
      key: `${y}-key-${p}`,
      standalone: !1
    }, v);
    return /* @__PURE__ */ D.cloneElement(h, S);
  });
}
const _re = (e, t) => {
  let n = D.Children.toArray(e.children);
  if (n.length === 0)
    n.push(t.independent, t.dependent);
  else {
    const r = {
      dependent: d9(n, "dependent"),
      independent: d9(n, "independent")
    };
    r.dependent.length === 0 && r.independent.length === 0 && (n = e.prependDefaultAxes ? [t.independent, t.dependent].concat(n) : n.concat([t.independent, t.dependent]));
  }
  return n;
}, V9 = (e, t, n) => {
  const r = n || D.Children.toArray(e.children), i = Ev(e, t, r), o = jte(r, t);
  return o && o.props && o.props.invertAxis ? i.concat().reverse() : i;
}, get = (e, t, n) => {
  const r = !n.x || n.x.length === 0 ? null : n.x.reduce((o, a, s) => (o[a] = s + 1, o), {}), i = !n.y || n.y.length === 0 ? null : n.y.reduce((o, a, s) => (o[a] = s + 1, o), {});
  return {
    x: r,
    y: i
  };
}, pet = {
  width: 450,
  height: 300,
  padding: 50
}, met = {
  backgroundComponent: /* @__PURE__ */ D.createElement(AJe, null),
  containerComponent: /* @__PURE__ */ D.createElement(ko, null),
  defaultAxes: {
    independent: /* @__PURE__ */ D.createElement(ds, null),
    dependent: /* @__PURE__ */ D.createElement(ds, {
      dependentAxis: !0
    })
  },
  defaultPolarAxes: {
    independent: /* @__PURE__ */ D.createElement(i$, null),
    dependent: /* @__PURE__ */ D.createElement(i$, {
      dependentAxis: !0
    })
  },
  groupComponent: /* @__PURE__ */ D.createElement("g", null),
  standalone: !0,
  theme: Ca.grayscale
}, vet = (e) => {
  const t = D.useMemo(() => He({}, e, met), [e]), n = "chart", {
    getAnimationProps: r,
    setAnimationState: i,
    getProps: o
  } = o3(), a = o(t), s = _r(a, pet, n), {
    desc: c,
    eventKey: l,
    containerComponent: u,
    standalone: d,
    groupComponent: f,
    externalEventMutations: h,
    width: p,
    height: g,
    theme: m,
    polar: v,
    name: y,
    title: S
  } = s, _ = a.polar ? s.defaultPolarAxes : s.defaultAxes, w = D.useMemo(() => _re(s, _), [s, _]), T = D.useMemo(() => bre(s, w), [s, w]), {
    domain: x,
    scale: C,
    style: E,
    origin: R,
    horizontal: A
  } = T, O = D.useMemo(() => {
    const V = het(a, w, T).map((j, B) => {
      const U = Object.assign({
        animate: r(a, j, B)
      }, j.props);
      return /* @__PURE__ */ D.cloneElement(j, U);
    });
    if (a.style && a.style.background) {
      const j = uet(a, T);
      V.unshift(j);
    }
    return V;
  }, [r, w, a, T]), $ = D.useMemo(() => d ? {
    desc: c,
    domain: x,
    width: p,
    height: g,
    horizontal: A,
    name: y,
    origin: v ? R : void 0,
    polar: v,
    theme: m,
    title: S,
    scale: C,
    standalone: d,
    style: E.parent
  } : {}, [c, x, g, A, y, R, v, C, d, E, S, m, p]), N = D.useMemo(() => {
    if (d) {
      const F = He({}, u.props, $, Ya(t));
      return /* @__PURE__ */ D.cloneElement(u, F);
    }
    return f;
  }, [f, d, u, $, t]), z = D.useMemo(() => E3(a), [a]), k = i3(t);
  return D.useEffect(() => () => {
    t.animate && i(k, t);
  }, [i, k, t]), Lr(z) ? /* @__PURE__ */ D.cloneElement(N, N.props, O) : /* @__PURE__ */ D.createElement(Rd, {
    container: N,
    eventKey: l,
    events: z,
    externalEventMutations: h
  }, O);
}, Qg = /* @__PURE__ */ D.memo(vet, ys);
Qg.displayName = "VictoryChart";
Qg.expectedComponents = ["groupComponent", "containerComponent"];
const yet = (e) => {
  const {
    pointerWidth: t,
    cornerRadius: n,
    orientation: r,
    width: i,
    height: o,
    center: a
  } = e, s = r === "bottom" ? 1 : -1, c = e.x + (e.dx || 0), l = e.y + (e.dy || 0), u = a.x, d = a.y, f = d + s * (o / 2), h = d - s * (o / 2), p = u + i / 2, g = u - i / 2, m = s * (l - f) < 0 ? 0 : e.pointerLength, y = `${n} ${n} ${r === "bottom" ? "0 0 0" : "0 0 1"}`;
  return `M ${u - t / 2}, ${f}
    L ${m ? c : u + t / 2}, ${m ? l : f}
    L ${u + t / 2}, ${f}
    L ${p - n}, ${f}
    A ${y} ${p}, ${f - s * n}
    L ${p}, ${h + s * n}
    A ${y} ${p - n}, ${h}
    L ${g + n}, ${h}
    A ${y} ${g}, ${h + s * n}
    L ${g}, ${f - s * n}
    A ${y} ${g + n}, ${f}
    z`;
}, bet = (e) => {
  const {
    pointerWidth: t,
    cornerRadius: n,
    orientation: r,
    width: i,
    height: o,
    center: a
  } = e, s = r === "left" ? 1 : -1, c = e.x + (e.dx || 0), l = e.y + (e.dy || 0), u = a.x, d = a.y, f = u - s * (i / 2), h = u + s * (i / 2), p = d + o / 2, g = d - o / 2, m = s * (c - f) > 0 ? 0 : e.pointerLength, y = `${n} ${n} ${r === "left" ? "0 0 0" : "0 0 1"}`;
  return `M ${f}, ${d - t / 2}
    L ${m ? c : f}, ${m ? l : d + t / 2}
    L ${f}, ${d + t / 2}
    L ${f}, ${p - n}
    A ${y} ${f + s * n}, ${p}
    L ${h - s * n}, ${p}
    A ${y} ${h}, ${p - n}
    L ${h}, ${g + n}
    A ${y} ${h - s * n}, ${g}
    L ${f + s * n}, ${g}
    A ${y} ${f}, ${g + n}
    z`;
}, _et = (e) => {
  const t = e.orientation || "top";
  return t === "left" || t === "right" ? bet(e) : yet(e);
}, wet = (e) => {
  const t = De(e.id, e), n = br(e.style, e);
  return {
    ...e,
    id: t,
    style: n
  };
}, xet = {
  pathComponent: /* @__PURE__ */ D.createElement(Up, null),
  role: "presentation",
  shapeRendering: "auto"
}, Eet = (e) => {
  const t = wet(He({}, e, xet)), n = Ya(t);
  e1(t.height, "Flyout props[height] is undefined"), e1(t.width, "Flyout props[width] is undefined"), e1(t.x, "Flyout props[x] is undefined"), e1(t.y, "Flyout props[y] is undefined");
  const r = {
    center: t.center || {
      x: 0,
      y: 0
    },
    cornerRadius: t.cornerRadius || 0,
    dx: t.dx,
    dy: t.dy,
    height: t.height,
    orientation: t.orientation || "top",
    pointerLength: t.pointerLength || 0,
    pointerWidth: t.pointerWidth || 0,
    width: t.width,
    x: t.x,
    y: t.y
  };
  return /* @__PURE__ */ D.cloneElement(t.pathComponent, {
    ...t.events,
    ...n,
    style: t.style,
    d: _et(r),
    className: t.className,
    shapeRendering: t.shapeRendering,
    role: t.role,
    transform: t.transform,
    clipPath: t.clipPath
  });
}, Cet = {
  cornerRadius: 5,
  pointerLength: 10,
  pointerWidth: 10
};
class rg extends D.Component {
  static defaultEvents(t) {
    const n = t.activateData ? [{
      target: "labels",
      mutation: () => ({
        active: !0
      })
    }, {
      target: "data",
      mutation: () => ({
        active: !0
      })
    }] : [{
      target: "labels",
      mutation: () => ({
        active: !0
      })
    }], r = t.activateData ? [{
      target: "labels",
      mutation: () => ({
        active: void 0
      })
    }, {
      target: "data",
      mutation: () => ({
        active: void 0
      })
    }] : [{
      target: "labels",
      mutation: () => ({
        active: void 0
      })
    }];
    return [{
      target: "data",
      eventHandlers: {
        onMouseOver: () => n,
        onFocus: () => n,
        onTouchStart: () => n,
        onMouseOut: () => r,
        onBlur: () => r,
        onTouchEnd: () => r
      }
    }];
  }
  constructor(t) {
    super(t), this.id = t.id === void 0 ? $E("tooltip-") : t.id;
  }
  getDefaultOrientation(t) {
    const {
      datum: n,
      horizontal: r,
      polar: i
    } = t;
    if (!i) {
      const o = r ? "right" : "top", a = r ? "left" : "bottom";
      return n && n.y < 0 ? a : o;
    }
    return this.getPolarOrientation(t);
  }
  getPolarOrientation(t) {
    const n = xv(t, t.datum), r = t.labelPlacement || "vertical";
    return r === "vertical" ? this.getVerticalOrientations(n) : r === "parallel" ? n < 90 || n > 270 ? "right" : "left" : n > 180 ? "bottom" : "top";
  }
  getVerticalOrientations(t) {
    return t < 45 || t > 315 ? "right" : t >= 45 && t <= 135 ? "top" : t > 135 && t < 225 ? "left" : "bottom";
  }
  getStyles(t) {
    const n = t.theme || Ca.grayscale, r = n && n.tooltip && n.tooltip.style ? n.tooltip.style : {}, i = Array.isArray(t.style) ? t.style.map((l) => He({}, l, r)) : He({}, t.style, r), o = n && n.tooltip && n.tooltip.flyoutStyle ? n.tooltip.flyoutStyle : {}, a = t.flyoutStyle ? He({}, t.flyoutStyle, o) : o, s = Array.isArray(i) ? i.map((l) => br(l, t)) : br(i, t), c = br(a, Object.assign({}, t, {
      style: s
    }));
    return {
      style: s,
      flyoutStyle: c
    };
  }
  getEvaluatedProps(t) {
    const {
      cornerRadius: n,
      centerOffset: r,
      dx: i,
      dy: o
    } = t, a = De(t.active, t);
    let s = De(t.text, Object.assign({}, t, {
      active: a
    }));
    s == null && (s = ""), typeof s == "number" && (s = s.toString());
    const {
      style: c,
      flyoutStyle: l
    } = this.getStyles(Object.assign({}, t, {
      active: a,
      text: s
    })), u = De(t.orientation, Object.assign({}, t, {
      active: a,
      text: s,
      style: c,
      flyoutStyle: l
    })) || this.getDefaultOrientation(t), d = De(t.flyoutPadding, Object.assign({}, t, {
      active: a,
      text: s,
      style: c,
      flyoutStyle: l,
      orientation: u
    })) || this.getLabelPadding(c), f = Wi(d), h = De(t.pointerWidth, Object.assign({}, t, {
      active: a,
      text: s,
      style: c,
      flyoutStyle: l,
      orientation: u
    })), p = De(t.pointerLength, Object.assign({}, t, {
      active: a,
      text: s,
      style: c,
      flyoutStyle: l,
      orientation: u
    })), g = Yg(s, c), {
      flyoutHeight: m,
      flyoutWidth: v
    } = this.getDimensions(Object.assign({}, t, {
      style: c,
      flyoutStyle: l,
      active: a,
      text: s,
      orientation: u,
      flyoutPadding: f,
      pointerWidth: h,
      pointerLength: p
    }), g), y = Object.assign({}, t, {
      active: a,
      text: s,
      style: c,
      flyoutStyle: l,
      orientation: u,
      flyoutHeight: m,
      flyoutWidth: v,
      flyoutPadding: f,
      pointerWidth: h,
      pointerLength: p
    }), S = ti(r) && (r == null ? void 0 : r.x) !== void 0 ? De(r.x, y) : 0, _ = ti(r) && (r == null ? void 0 : r.y) !== void 0 ? De(r.y, y) : 0;
    return {
      ...y,
      centerOffset: {
        x: S,
        y: _
      },
      dx: i !== void 0 ? De(i, y) : 0,
      dy: o !== void 0 ? De(o, y) : 0,
      cornerRadius: De(n, y)
    };
  }
  getCalculatedValues(t) {
    const {
      style: n,
      text: r,
      flyoutStyle: i,
      flyoutHeight: o,
      flyoutWidth: a
    } = t, s = Yg(r, n), c = {
      height: o,
      width: a
    }, l = this.getFlyoutCenter(t, c), u = this.getTransform(t);
    return {
      style: n,
      flyoutStyle: i,
      labelSize: s,
      flyoutDimensions: c,
      flyoutCenter: l,
      transform: u
    };
  }
  getTransform(t) {
    const {
      x: n,
      y: r,
      style: i
    } = t, a = (i || {}).angle || t.angle || this.getDefaultAngle(t);
    return a ? `rotate(${a} ${n} ${r})` : void 0;
  }
  getDefaultAngle(t) {
    const {
      polar: n,
      labelPlacement: r,
      orientation: i,
      datum: o
    } = t;
    if (!n || !r || r === "vertical")
      return 0;
    const a = xv(t, o), s = a > 90 && a < 180 || a > 270 ? 1 : -1, c = r === "perpendicular" ? 0 : 90;
    let l = 0;
    return a === 0 || a === 180 ? l = i === "top" && a === 180 ? 270 : 90 : a > 0 && a < 180 ? l = 90 - a : a > 180 && a < 360 && (l = 270 - a), l + s * c;
  }
  constrainTooltip(t, n, r) {
    const {
      x: i,
      y: o
    } = t, {
      width: a,
      height: s
    } = r, c = {
      x: [0, n.width],
      y: [0, n.height]
    }, l = {
      x: [i - a / 2, i + a / 2],
      y: [o - s / 2, o + s / 2]
    }, u = {
      x: [l.x[0] < c.x[0] ? c.x[0] - l.x[0] : 0, l.x[1] > c.x[1] ? l.x[1] - c.x[1] : 0],
      y: [l.y[0] < c.y[0] ? c.y[0] - l.y[0] : 0, l.y[1] > c.y[1] ? l.y[1] - c.y[1] : 0]
    };
    return {
      x: Math.round(i + u.x[0] - u.x[1]),
      y: Math.round(o + u.y[0] - u.y[1])
    };
  }
  getFlyoutCenter(t, n) {
    const {
      x: r,
      y: i,
      dx: o,
      dy: a,
      pointerLength: s,
      orientation: c,
      constrainToVisibleArea: l,
      centerOffset: u
    } = t, {
      height: d,
      width: f
    } = n, h = c === "left" ? -1 : 1, p = c === "bottom" ? -1 : 1, g = {
      x: c === "left" || c === "right" ? r + h * (s + f / 2 + h * o) : r + o,
      y: c === "top" || c === "bottom" ? i - p * (s + d / 2 - p * a) : i + a
    }, m = {
      x: ti(t.center) && t.center.x !== void 0 ? t.center.x : g.x,
      y: ti(t.center) && t.center.y !== void 0 ? t.center.y : g.y
    }, v = {
      x: m.x + u.x,
      y: m.y + u.y
    };
    return l ? this.constrainTooltip(v, t, n) : v;
  }
  getLabelPadding(t) {
    if (!t)
      return 0;
    const n = Array.isArray(t) ? t.map((r) => r.padding) : [t.padding];
    return Math.max(...n, 0);
  }
  getDimensions(t, n) {
    const {
      orientation: r,
      pointerLength: i,
      pointerWidth: o,
      flyoutHeight: a,
      flyoutWidth: s,
      flyoutPadding: c
    } = t, l = De(t.cornerRadius, t), u = () => {
      const f = n.height + c.top + c.bottom, h = r === "top" || r === "bottom" ? 2 * l : 2 * l + o;
      return Math.max(h, f);
    }, d = () => {
      const f = n.width + c.left + c.right, h = r === "left" || r === "right" ? 2 * l + i : 2 * l;
      return Math.max(h, f);
    };
    return {
      flyoutHeight: a ? De(a, t) : u(),
      flyoutWidth: s ? De(s, t) : d()
    };
  }
  getLabelProps(t, n) {
    const {
      flyoutCenter: r,
      style: i,
      labelSize: o,
      dy: a = 0,
      dx: s = 0
    } = n, {
      text: c,
      datum: l,
      activePoints: u,
      labelComponent: d,
      index: f,
      flyoutPadding: h
    } = t, p = (Array.isArray(i) && i.length ? i[0].textAnchor : i.textAnchor) || "middle", g = () => {
      if (!p || p === "middle")
        return r.x;
      const m = p === "end" ? -1 : 1;
      return r.x - m * (o.width / 2);
    };
    return He({}, d.props, {
      key: `${this.id}-label-${f}`,
      text: c,
      datum: l,
      activePoints: u,
      textAnchor: p,
      dy: a,
      dx: s,
      style: i,
      x: g() + (h.left - h.right) / 2,
      y: r.y + (h.top - h.bottom) / 2,
      verticalAnchor: "middle",
      angle: i.angle
    });
  }
  getPointerOrientation(t, n, r) {
    const i = {
      bottom: n.y + r.height / 2,
      top: n.y - r.height / 2,
      left: n.x - r.width / 2,
      right: n.x + r.width / 2
    }, o = [{
      side: "top",
      val: i.top > t.y ? i.top - t.y : -1
    }, {
      side: "bottom",
      val: i.bottom < t.y ? t.y - i.bottom : -1
    }, {
      side: "right",
      val: i.right < t.x ? t.x - i.right : -1
    }, {
      side: "left",
      val: i.left > t.x ? i.left - t.x : -1
    }];
    return wy(o, "val", "desc")[0].side;
  }
  getFlyoutProps(t, n) {
    const {
      flyoutDimensions: r,
      flyoutStyle: i,
      flyoutCenter: o
    } = n, {
      x: a,
      y: s,
      dx: c,
      dy: l,
      datum: u,
      activePoints: d,
      index: f,
      pointerLength: h,
      pointerWidth: p,
      cornerRadius: g,
      events: m,
      flyoutComponent: v
    } = t, y = De(t.pointerOrientation, t);
    return He({}, v.props, {
      x: a,
      y: s,
      dx: c,
      dy: l,
      datum: u,
      activePoints: d,
      index: f,
      pointerLength: h,
      pointerWidth: p,
      cornerRadius: g,
      events: m,
      orientation: y || this.getPointerOrientation({
        x: a,
        y: s
      }, o, r),
      key: `${this.id}-tooltip-${f}`,
      width: r.width,
      height: r.height,
      style: i,
      center: o
    });
  }
  // Overridden in victory-core-native
  renderTooltip(t) {
    const n = De(t.active, t), {
      renderInPortal: r
    } = t;
    if (!n)
      return null;
    const i = this.getEvaluatedProps(t), {
      flyoutComponent: o,
      labelComponent: a,
      groupComponent: s
    } = i, c = this.getCalculatedValues(i), l = [/* @__PURE__ */ D.cloneElement(o, this.getFlyoutProps(i, c)), /* @__PURE__ */ D.cloneElement(a, this.getLabelProps(i, c))], u = /* @__PURE__ */ D.cloneElement(s, {
      role: "presentation",
      transform: c.transform
    }, l);
    return r ? /* @__PURE__ */ D.createElement(yw, null, u) : u;
  }
  render() {
    const t = _r(this.props, Cet, "tooltip");
    return this.renderTooltip(t);
  }
}
ye(rg, "displayName", "VictoryTooltip"), ye(rg, "role", "tooltip"), ye(rg, "defaultProps", {
  active: !1,
  renderInPortal: !0,
  labelComponent: /* @__PURE__ */ D.createElement(qi, null),
  flyoutComponent: /* @__PURE__ */ D.createElement(Eet, null),
  groupComponent: /* @__PURE__ */ D.createElement("g", null)
});
const i1 = (e, t, n) => {
  const r = n === "right" || n === "left";
  return /* @__PURE__ */ D.cloneElement(e.lineComponent, {
    ...e.events,
    role: e.role,
    shapeRendering: e.shapeRendering,
    className: e.className,
    style: e.style,
    transform: e.transform,
    key: `${e.id}-border-${n}`,
    x1: r ? t[n] : e.x - e.borderWidth,
    x2: r ? t[n] : e.x + e.borderWidth,
    y1: r ? e.y - e.borderWidth : t[n],
    y2: r ? e.y + e.borderWidth : t[n],
    "data-type": `border-${n}`
  });
}, o1 = (e, t, n) => {
  const r = n === "top" || n === "bottom";
  return /* @__PURE__ */ D.cloneElement(e.lineComponent, {
    ...e.events,
    role: e.role,
    shapeRendering: e.shapeRendering,
    className: e.className,
    style: e.style,
    transform: e.transform,
    key: `${e.id}-cross-${n}`,
    x1: e.x,
    x2: r ? e.x : t[n],
    y1: e.y,
    y2: r ? t[n] : e.y,
    "data-type": `cross-${n}`
  });
}, Tet = (e) => {
  const {
    errorX: t,
    errorY: n
  } = e, r = {
    right: {
      error: t,
      errorIndex: 0
    },
    left: {
      error: t,
      errorIndex: 1
    },
    top: {
      error: n,
      errorIndex: 1
    },
    bottom: {
      error: n,
      errorIndex: 0
    }
  }, i = (a) => {
    const {
      error: s,
      errorIndex: c
    } = r[a];
    return s ? s[c] : void 0;
  };
  return ["right", "left", "top", "bottom"].reduce((a, s) => (a[s] = i(s), a), {});
}, Iet = (e) => {
  const t = De(e.ariaLabel, e), n = De(e.id, e), r = br(Object.assign({
    stroke: "black"
  }, e.style), e), i = De(e.tabIndex, e);
  return Object.assign({}, e, {
    ariaLabel: t,
    id: n,
    style: r,
    tabIndex: i
  });
}, Aet = {
  groupComponent: /* @__PURE__ */ D.createElement("g", null),
  lineComponent: /* @__PURE__ */ D.createElement(ure, null),
  role: "presentation",
  shapeRendering: "auto"
}, Ret = (e) => {
  const t = Iet(He({}, e, Aet)), {
    groupComponent: n
  } = t, r = Ya(t), {
    tabIndex: i,
    ariaLabel: o
  } = t, a = Tet(t), s = [a.right ? i1(t, a, "right") : null, a.left ? i1(t, a, "left") : null, a.bottom ? i1(t, a, "bottom") : null, a.top ? i1(t, a, "top") : null, a.right ? o1(t, a, "right") : null, a.left ? o1(t, a, "left") : null, a.bottom ? o1(t, a, "bottom") : null, a.top ? o1(t, a, "top") : null].filter(Boolean);
  return /* @__PURE__ */ D.cloneElement(n, {
    tabIndex: i,
    "aria-label": o,
    ...r
  }, s);
};
var $et = kE, Oet = ME;
function Pet(e, t, n, r) {
  var i = !n;
  n || (n = {});
  for (var o = -1, a = t.length; ++o < a; ) {
    var s = t[o], c = r ? r(n[s], e[s], s, n, e) : void 0;
    c === void 0 && (c = e[s]), i ? Oet(n, s, c) : $et(n, s, c);
  }
  return n;
}
var Hf = Pet, Met = OE, ket = PE;
function Net(e) {
  return Met(function(t, n) {
    var r = -1, i = n.length, o = i > 1 ? n[i - 1] : void 0, a = i > 2 ? n[2] : void 0;
    for (o = e.length > 3 && typeof o == "function" ? (i--, o) : void 0, a && ket(n[0], n[1], a) && (o = i < 3 ? void 0 : o, i = 1), t = Object(t); ++r < i; ) {
      var s = n[r];
      s && e(t, s, r, o);
    }
    return t;
  });
}
var Sre = Net, Det = kE, Let = Hf, jet = Sre, Fet = Wu, Vet = by, Bet = kp, zet = Object.prototype, Het = zet.hasOwnProperty, Uet = jet(function(e, t) {
  if (Vet(t) || Fet(t)) {
    Let(t, Bet(t), e);
    return;
  }
  for (var n in t)
    Het.call(t, n) && Det(e, n, t[n]);
}), Wet = Uet;
const qet = /* @__PURE__ */ pn(Wet), B9 = (e, t, n) => {
  const i = t[{
    x: "_errorX",
    y: "_errorY"
  }[n]];
  if (i === 0)
    return !1;
  const o = e.scale[n];
  return Array.isArray(i) ? [i[0] === 0 ? !1 : o(i[0] + t[`_${n}`]), i[1] === 0 ? !1 : o(t[`_${n}`] - i[1])] : [o(i + t[`_${n}`]), o(t[`_${n}`] - i)];
}, $3 = (e) => {
  const t = ["x", "y", "errorX", "errorY"];
  if (e.data)
    return uw(e.data, e, t);
  const n = e.errorX || e.errorY ? Mte(e) : [];
  return uw(n, e, t);
}, Get = (e, t) => {
  const n = Xu(e, t), r = Yu(e, t), i = $3(e);
  if (i.length < 1)
    return n !== void 0 && r !== void 0 ? Es(n, r) : void 0;
  const o = t === "x" ? "_errorX" : "_errorY", a = (l) => {
    const u = l === "min" ? 1 / 0 : -1 / 0, d = l === "min" ? 1 : 0, f = l === "min" ? -1 : 1;
    return i.reduce((h, p) => {
      const g = Array.isArray(p[o]) ? p[o][d] : p[o], m = p[`_${t}`] + f * (g || 0);
      return h < m && l === "min" || h > m && l === "max" ? h : m;
    }, u);
  }, s = n !== void 0 ? n : a("min"), c = r !== void 0 ? r : a("max");
  return Es(s, c);
}, o$ = (e, t) => UE(Get)(e, t), Ket = (e, t) => {
  const n = Sa(t.x), r = _a(t.x), i = Sa(t.y), o = _a(t.y);
  let {
    _x: a,
    _y: s
  } = e;
  return (a < n || a > r || s < i || s > o) && (a = s = null), Object.assign({}, e, {
    _x: a,
    _y: s
  });
}, Yet = (e) => {
  const t = Ey(e, "errorbar"), n = Vp(e.style, t) || {}, r = $3(e), i = {
    x: Pr(e, "x"),
    y: Pr(e, "y")
  }, o = {
    x: o$(e, "x"),
    y: o$(e, "y")
  }, a = {
    x: ea(e, "x").domain(o.x).range(e.horizontal ? i.y : i.x),
    y: ea(e, "y").domain(o.y).range(e.horizontal ? i.x : i.y)
  }, s = e.polar ? e.origin || jf(e) : void 0;
  return {
    domain: o,
    data: r,
    scale: a,
    style: n,
    origin: s
  };
}, Xet = (e, t, n) => {
  const {
    x: r,
    y: i,
    index: o,
    scale: a,
    errorY: s,
    errorX: c,
    horizontal: l,
    labelComponent: u,
    theme: d,
    disableInlineStyles: f
  } = e, h = function(_) {
    _ === void 0 && (_ = "x");
    const w = _ === "y" ? s : c;
    return (w && Array.isArray(w) ? w[0] : w) || e[_];
  }, p = n.labels || {}, g = p.padding || 0, m = l ? "start" : "middle", v = l ? "middle" : "end", y = {
    style: p,
    y: l ? i : h("y"),
    x: l ? h("x") : r,
    dy: l ? 0 : -g,
    dx: l ? g : 0,
    text: t,
    index: o,
    scale: a,
    datum: e.datum,
    data: e.data,
    textAnchor: p.textAnchor || m,
    verticalAnchor: p.verticalAnchor || v,
    angle: p.angle,
    horizontal: l,
    disableInlineStyles: f
  };
  if (!NE(u))
    return y;
  const S = d && d.tooltip || {};
  return He({}, y, Lf(S, ["style"]));
}, Qet = (e, t) => {
  const n = _r(e, t, "errorbar"), r = Object.assign({}, n, Yet(n)), {
    borderWidth: i,
    data: o,
    domain: a,
    events: s,
    groupComponent: c,
    height: l,
    horizontal: u,
    labels: d,
    name: f,
    origin: h,
    padding: p,
    polar: g,
    scale: m,
    sharedEvents: v,
    standalone: y,
    style: S,
    theme: _,
    width: w,
    disableInlineStyles: T
  } = r, x = {
    parent: {
      data: o,
      domain: a,
      height: l,
      horizontal: u,
      name: f,
      origin: h,
      padding: p,
      polar: g,
      scale: m,
      standalone: y,
      style: S.parent,
      theme: _,
      width: w
    }
  };
  return o.reduce((C, E, R) => {
    const A = za(E.eventKey) ? R : E.eventKey, {
      x: O,
      y: $
    } = xy(qet({}, r, {
      scale: m
    }), E), N = Ket(E, a), z = B9(r, N, "x"), k = B9(r, N, "y"), F = {
      borderWidth: i,
      data: o,
      datum: N,
      errorX: u ? k : z,
      errorY: u ? z : k,
      groupComponent: c,
      horizontal: u,
      index: R,
      scale: m,
      style: T ? {} : S.data,
      x: O,
      y: $,
      disableInlineStyles: T
    };
    C[A] = {
      data: F
    };
    const V = Oy(r, E, R);
    return (V != null || d && (s || v)) && (C[A].labels = Xet(Object.assign({}, r, F), V, S)), C;
  }, x);
}, z9 = {
  width: 450,
  height: 300,
  padding: 50
}, Jet = [{
  x: 1,
  y: 1,
  errorX: 0.1,
  errorY: 0.1
}, {
  x: 2,
  y: 2,
  errorX: 0.2,
  errorY: 0.2
}, {
  x: 3,
  y: 3,
  errorX: 0.3,
  errorY: 0.3
}, {
  x: 4,
  y: 4,
  errorX: 0.4,
  errorY: 0.4
}];
class hd extends D.Component {
  static getDomain(t, n) {
    return o$(t, n);
  }
  static getData(t) {
    return $3(t);
  }
  static getBaseProps(t) {
    return Qet(t, z9);
  }
  // Overridden in native versions
  shouldAnimate() {
    return !!this.props.animate;
  }
  render() {
    const {
      animationWhitelist: t,
      role: n
    } = wre, r = _r(this.props, z9, n);
    if (this.shouldAnimate())
      return this.animateComponent(r, t);
    const i = this.renderData(r), o = r.standalone ? this.renderContainer(r.containerComponent, i) : i;
    return Cy(o, r);
  }
}
ye(hd, "animationWhitelist", ["data", "domain", "height", "padding", "samples", "style", "width", "errorX", "errorY", "borderWidth"]), ye(hd, "displayName", "VictoryErrorBar"), ye(hd, "role", "errorbar"), ye(hd, "defaultTransitions", Hte()), ye(hd, "defaultProps", {
  containerComponent: /* @__PURE__ */ D.createElement(ko, null),
  data: Jet,
  dataComponent: /* @__PURE__ */ D.createElement(Ret, null),
  labelComponent: /* @__PURE__ */ D.createElement(qi, null),
  groupComponent: /* @__PURE__ */ D.createElement("g", {
    role: "presentation"
  }),
  samples: 50,
  sortOrder: "ascending",
  standalone: !0,
  theme: Ca.grayscale
}), ye(hd, "expectedComponents", ["dataComponent", "labelComponent", "groupComponent", "containerComponent"]);
const wre = qu(hd), xre = {
  width: 450,
  height: 300,
  padding: 50,
  offset: 0
};
function Ere(e, t) {
  const n = "group", r = _r(e, xre, n), i = nre(r.theme, r.style, n), {
    offset: o,
    colorScale: a,
    color: s,
    polar: c,
    horizontal: l
  } = r, u = r.categories || C3(r, t, null), d = r.datasets || ere(r, null), f = {
    x: Ev(Object.assign({}, r, {
      categories: u
    }), "x", t),
    y: Ev(Object.assign({}, r, {
      categories: u
    }), "y", t)
  }, h = r.range || {
    x: Pr(r, "x"),
    y: Pr(r, "y")
  }, p = {
    x: mf(r, "x") || Xg(r, "x"),
    y: mf(r, "y") || Xg(r, "y")
  }, g = {
    x: p.x.domain(f.x).range(r.horizontal ? h.y : h.x),
    y: p.y.domain(f.y).range(r.horizontal ? h.x : h.y)
  }, m = c ? r.origin : jf(r), v = Wi(r.padding);
  return {
    datasets: d,
    categories: u,
    range: h,
    domain: f,
    horizontal: l,
    scale: g,
    style: i,
    colorScale: a,
    color: s,
    offset: o,
    origin: m,
    padding: v
  };
}
const Zet = (e) => {
  const {
    children: t
  } = e, n = D.Children.toArray(t).map((r) => ({
    ...r,
    props: Lf(r.props, ["sharedEvents"])
  }));
  return e.children = n, e;
};
function ett(e) {
  const t = Zet(e), [n, r] = D.useState(t);
  return D.useEffect(() => {
    ys(t, n) || r(t);
  }, [n, r, t]), D.useMemo(() => Ere(n, n.children), [n]);
}
function ttt(e, t, n) {
  if (!e.offset)
    return 0;
  const r = oee(t, e.horizontal), i = n.domain[t], o = n.range[r], a = Math.max(...i) - Math.min(...i), s = Math.max(...o) - Math.min(...o);
  return a / s * e.offset;
}
function ntt(e, t, n, r) {
  const o = ((r === "stack" ? t.datasets[0].length : t.datasets.length) - 1) / 2, a = ttt(e, "x", t);
  return (n - o) * a;
}
function rtt(e, t, n, r) {
  const o = ((r === "stack" ? t.datasets[0].length : t.datasets.length) - 1) / 2, a = itt(e, t);
  return (n - o) * a;
}
function itt(e, t) {
  const {
    range: n
  } = t, r = Math.abs(n.x[1] - n.x[0]), i = Math.max(...n.y);
  return e.offset / (2 * Math.PI * i) * r;
}
function ott(e, t, n) {
  if (e.labels)
    return Math.floor(t.length / 2) === n ? e.labels : void 0;
}
function att(e, t) {
  const {
    categories: n,
    domain: r,
    range: i,
    scale: o,
    horizontal: a,
    origin: s,
    padding: c
  } = t, {
    width: l,
    height: u,
    theme: d,
    polar: f
  } = e;
  return {
    height: u,
    width: l,
    theme: d,
    polar: f,
    origin: s,
    categories: n,
    domain: r,
    range: i,
    scale: o,
    horizontal: a,
    padding: c,
    standalone: !1
  };
}
function stt(e, t) {
  const n = t.type && t.type.role, r = t.props.colorScale || e.colorScale;
  if (!(n !== "group" && n !== "stack"))
    return e.theme && e.theme.group ? r || e.theme.group.colorScale : r;
}
function ctt(e, t, n) {
  t === void 0 && (t = []);
  const r = e.data || e.y ? Mo(e) : t, i = n || 0;
  return r.map((o) => {
    const a = o._x instanceof Date ? new Date(o._x.getTime() + i) : o._x + i;
    return Object.assign({}, o, {
      _x1: a
    });
  });
}
function Cre(e, t, n) {
  const r = _r(e, xre, "stack"), i = t || D.Children.toArray(r.children), o = n || Ere(r, i), {
    datasets: a
  } = o, {
    labelComponent: s,
    polar: c,
    theme: l
  } = r, u = att(r, o), d = r.name || "group";
  return i.map((f, h) => {
    const p = f.type && f.type.role, g = c ? rtt(r, o, h, p) : ntt(r, o, h, p), m = p === "voronoi" || p === "tooltip" || p === "label" ? f.props.style : rre(f, h, o, l), v = r.labels ? ott(r, a, h) : f.props.labels, y = f.props.name || `${d}-${p}-${h}`;
    return /* @__PURE__ */ D.cloneElement(f, Object.assign({
      labels: v,
      style: m,
      key: `${y}-key-${h}`,
      name: y,
      data: ctt(r, a[h], g),
      colorScale: stt(r, f),
      labelComponent: s || f.props.labelComponent,
      xOffset: g
    }, u));
  });
}
const ltt = {
  width: 450,
  height: 300,
  padding: 50,
  offset: 0
}, utt = {
  containerComponent: /* @__PURE__ */ D.createElement(ko, null),
  groupComponent: /* @__PURE__ */ D.createElement("g", null),
  samples: 50,
  standalone: !0,
  theme: Ca.grayscale
}, dtt = (e) => {
  const t = ig == null ? void 0 : ig.role, {
    getAnimationProps: n,
    setAnimationState: r,
    getProps: i
  } = o3(), o = D.useMemo(() => He({}, e, utt), [e]), a = i(o), s = _r(a, ltt, t), {
    eventKey: c,
    containerComponent: l,
    standalone: u,
    groupComponent: d,
    externalEventMutations: f,
    width: h,
    height: p,
    theme: g,
    polar: m,
    horizontal: v,
    name: y
  } = s, S = D.Children.toArray(s.children), _ = ett(s), {
    domain: w,
    scale: T,
    style: x,
    origin: C
  } = _, E = D.useMemo(() => Cre(a, S, _).map((k, F) => {
    const V = Object.assign({
      animate: n(a, k, F)
    }, k.props);
    return /* @__PURE__ */ D.cloneElement(k, V);
  }), [a, S, _, n]), R = D.useMemo(() => u ? {
    domain: w,
    scale: T,
    width: h,
    height: p,
    standalone: u,
    theme: g,
    style: x.parent,
    horizontal: v,
    polar: m,
    origin: C,
    name: y
  } : {}, [u, w, T, h, p, g, x, v, m, C, y]), A = D.useMemo(() => Ya(o), [o]), O = D.useMemo(() => {
    if (u) {
      const z = He({}, l.props, R, A);
      return /* @__PURE__ */ D.cloneElement(l, z);
    }
    return /* @__PURE__ */ D.cloneElement(d, A);
  }, [d, u, l, R, A]), $ = D.useMemo(() => E3(a), [a]), N = i3(o);
  return D.useEffect(() => () => {
    o.animate && r(N, a);
  }, [r, N, o, a]), Lr($) ? /* @__PURE__ */ D.cloneElement(O, O.props, E) : /* @__PURE__ */ D.createElement(Rd, {
    container: O,
    eventKey: c,
    events: $,
    externalEventMutations: f
  }, E);
}, ftt = {
  role: "group",
  expectedComponents: ["groupComponent", "containerComponent", "labelComponent"],
  getChildren: Cre
}, ig = Object.assign(/* @__PURE__ */ D.memo(dtt, ys), ftt);
ig.displayName = "VictoryGroup";
var htt = Math.ceil, gtt = Math.max;
function ptt(e, t, n, r) {
  for (var i = -1, o = gtt(htt((t - e) / (n || 1)), 0), a = Array(o); o--; )
    a[r ? o : ++i] = e, e += n;
  return a;
}
var mtt = ptt, vtt = WZe, H9 = 1 / 0, ytt = 17976931348623157e292;
function btt(e) {
  if (!e)
    return e === 0 ? e : 0;
  if (e = vtt(e), e === H9 || e === -H9) {
    var t = e < 0 ? -1 : 1;
    return t * ytt;
  }
  return e === e ? e : 0;
}
var _tt = btt, Stt = mtt, wtt = PE, TT = _tt;
function xtt(e) {
  return function(t, n, r) {
    return r && typeof r != "number" && wtt(t, n, r) && (n = r = void 0), t = TT(t), n === void 0 ? (n = t, t = 0) : n = TT(n), r = r === void 0 ? t < n ? 1 : -1 : TT(r), Stt(t, n, r, e);
  };
}
var Ett = xtt, Ctt = Ett, Ttt = Ctt(), Itt = Ttt;
const U9 = /* @__PURE__ */ pn(Itt), Att = (e) => {
  const {
    colorScale: t,
    theme: n
  } = e;
  return typeof t == "string" ? b3(t, n) : t || [];
}, Tre = (e) => {
  const {
    data: t,
    style: n
  } = e;
  return t.map((r, i) => {
    const o = He({}, r.labels, n.labels);
    return br(o, {
      datum: r,
      index: i,
      data: t
    });
  });
}, Rtt = function(e, t) {
  t === void 0 && (t = {});
  const n = e.style || {}, r = {
    height: "100%",
    width: "100%"
  };
  return {
    parent: He(n.parent, t.parent, r),
    data: He({}, n.data, t.data),
    labels: He({}, n.labels, t.labels),
    border: He({}, n.border, t.border),
    title: He({}, n.title, t.title)
  };
}, Ire = (e) => {
  const {
    orientation: t,
    theme: n
  } = e, r = n && n.legend && n.legend.style ? n.legend.style : {}, i = Rtt(e, r), o = Att(e), a = t === "horizontal", s = Wi(e.borderPadding);
  return Object.assign({}, e, {
    style: i,
    isHorizontal: a,
    colorScale: o,
    borderPadding: s
  });
}, $tt = (e, t) => {
  const {
    itemsPerRow: n,
    isHorizontal: r
  } = e;
  return n ? r ? t % n : Math.floor(t / n) : r ? t : 0;
}, Ott = (e, t) => {
  const {
    itemsPerRow: n,
    isHorizontal: r
  } = e;
  return n ? r ? Math.floor(t / n) : t % n : r ? 0 : t;
}, Are = (e) => {
  const {
    data: t
  } = e, n = e.style && e.style.data || {}, r = Tre(e);
  return t.map((i, o) => {
    const a = i.symbol || {}, {
      fontSize: s
    } = r[o], c = a.size || n.size || s / 2.5, l = e.symbolSpacer || Math.max(c, s);
    return {
      ...i,
      size: c,
      symbolSpacer: l,
      fontSize: s,
      textSize: Yg(i.name, r[o]),
      column: $tt(e, o),
      row: Ott(e, o)
    };
  });
}, Rre = (e, t) => {
  const n = e.gutter || {}, r = typeof n == "object" ? (n.left || 0) + (n.right || 0) : n || 0, i = w3(t, "column");
  return Object.keys(i).reduce((a, s, c) => {
    const l = i[s].map((u) => u.textSize.width + u.size + u.symbolSpacer + r);
    return a[c] = Math.max(...l), a;
  }, []);
}, $re = (e, t) => {
  const n = e.rowGutter || {}, r = typeof n == "object" ? (n.top || 0) + (n.bottom || 0) : n || 0, i = w3(t, "row");
  return Object.keys(i).reduce((o, a, s) => {
    const l = i[a].map((u) => u.textSize.height + u.symbolSpacer + r);
    return o[s] = Math.max(...l), o;
  }, []);
}, Ore = (e) => {
  const t = e.style && e.style.title || {}, n = Yg(e.title, t), r = t.padding || 0;
  return {
    height: n.height + 2 * r || 0,
    width: n.width + 2 * r || 0
  };
}, Ptt = (e, t, n) => {
  const {
    column: r,
    row: i
  } = e;
  return {
    x: U9(r).reduce((o, a) => o + n[a], 0),
    y: U9(i).reduce((o, a) => o + t[a], 0)
  };
}, Mtt = (e, t) => {
  const n = {
    textAnchor: e === "right" ? "end" : "start",
    verticalAnchor: e === "bottom" ? "end" : "start"
  };
  if (t) {
    const r = e === "top" || e === "bottom";
    return {
      textAnchor: r ? "middle" : n.textAnchor,
      verticalAnchor: r ? n.verticalAnchor : "middle"
    };
  }
  return n;
}, ktt = (e) => {
  const {
    titleOrientation: t,
    centerTitle: n,
    titleComponent: r
  } = e, i = e.style && e.style.title || {}, o = r.props && r.props.style || {}, a = Mtt(t, n);
  return Array.isArray(o) ? o.map((s) => He({}, s, i, a)) : He({}, o, i, a);
}, Ntt = (e, t) => {
  const {
    title: n,
    titleOrientation: r,
    centerTitle: i,
    borderPadding: o
  } = e, {
    height: a,
    width: s
  } = t, c = ktt(e), l = Array.isArray(c) ? c[0].padding : c.padding, u = r === "top" || r === "bottom", d = r === "bottom" ? "bottom" : "top", f = r === "right" ? "right" : "left", h = {
    x: i ? s / 2 : o[d] + (l || 0),
    y: i ? a / 2 : o[f] + (l || 0)
  }, p = () => o[r] + (l || 0), g = u ? h.x : p(), m = u ? p() : h.y;
  return {
    x: r === "right" ? e.x + s - g : e.x + g,
    y: r === "bottom" ? e.y + a - m : e.y + m,
    style: c,
    text: n
  };
}, Dtt = (e, t, n) => {
  const {
    x: r,
    y: i,
    borderPadding: o,
    style: a
  } = e, s = (t || 0) + o.top + o.bottom, c = (n || 0) + o.left + o.right;
  return {
    x: r,
    y: i,
    height: s,
    width: c,
    style: Object.assign({
      fill: "none"
    }, a.border)
  };
}, Pre = (e, t) => {
  const n = _r(e, t, "legend"), r = Object.assign({}, n, Ire(n)), {
    title: i,
    titleOrientation: o
  } = r, a = Are(r), s = Rre(r, a), c = $re(r, a), l = i ? Ore(r) : {
    height: 0,
    width: 0
  };
  return {
    height: o === "left" || o === "right" ? Math.max(a1(c), l.height) : a1(c) + l.height,
    width: o === "left" || o === "right" ? a1(s) + l.width : Math.max(a1(s), l.width)
  };
}, Ltt = (e, t) => {
  const n = _r(e, t, "legend"), r = Object.assign({}, n, Ire(n)), {
    data: i,
    standalone: o,
    theme: a,
    padding: s,
    style: c,
    colorScale: l,
    gutter: u,
    rowGutter: d,
    borderPadding: f,
    title: h,
    titleOrientation: p,
    name: g,
    x: m = 0,
    y: v = 0
  } = r, y = Are(r), S = Rre(r, y), _ = $re(r, y), w = Tre(r), T = h ? Ore(r) : {
    height: 0,
    width: 0
  }, x = {
    x: p === "left" ? T.width : 0,
    y: p === "top" ? T.height : 0
  }, C = {
    x: u && typeof u == "object" && u.left || 0,
    y: d && typeof d == "object" && d.top || 0
  }, {
    height: E,
    width: R
  } = Pre(r, t), A = Dtt(r, E, R), O = Ntt(r, A), $ = {
    parent: {
      data: i,
      standalone: o,
      theme: a,
      padding: s,
      name: g,
      height: r.height,
      width: r.width,
      style: c.parent
    },
    all: {
      border: A,
      title: O
    }
  };
  return y.reduce((N, z, k) => {
    const F = l[k % l.length], V = He({}, z.symbol, c.data, {
      fill: F
    }), j = za(z.eventKey) ? k : z.eventKey, B = Ptt(z, _, S), U = v + f.top + z.symbolSpacer, Q = m + f.left + z.symbolSpacer, K = {
      index: k,
      data: i,
      datum: z,
      symbol: V.type || V.symbol || "circle",
      size: z.size,
      style: V,
      y: U + B.y + x.y + C.y,
      x: Q + B.x + x.x + C.x
    }, q = {
      datum: z,
      data: i,
      text: z.name,
      style: w[k],
      y: K.y,
      x: K.x + z.symbolSpacer + z.size / 2
    };
    return N[j] = {
      data: K,
      labels: q
    }, N;
  }, $);
};
function a1(e) {
  if (e && e.length) {
    let t = 0;
    for (let n = 0; n < e.length; n++)
      t += e[n];
    return t;
  }
  return 0;
}
const IT = {
  orientation: "vertical",
  titleOrientation: "top",
  width: 450,
  height: 300,
  x: 0,
  y: 0
}, jtt = [{
  name: "Series 1"
}, {
  name: "Series 2"
}];
class Ym extends D.Component {
  static getBaseProps(t) {
    return Ltt(t, IT);
  }
  static getDimensions(t) {
    return Pre(t, IT);
  }
  renderChildren(t) {
    const {
      dataComponent: n,
      labelComponent: r,
      title: i
    } = t, o = [];
    if (t.borderComponent) {
      const a = this.getComponentProps(t.borderComponent, "border", "all"), s = /* @__PURE__ */ D.cloneElement(t.borderComponent, a);
      o.push(s);
    }
    if (n) {
      const a = this.dataKeys.map((s, c) => {
        if (s === "all")
          return;
        const l = this.getComponentProps(n, "data", c);
        return /* @__PURE__ */ D.cloneElement(n, l);
      }).filter((s) => s !== void 0);
      o.push(...a);
    }
    if (i && t.titleComponent) {
      const a = this.getComponentProps(i, "title", "all"), s = /* @__PURE__ */ D.cloneElement(t.titleComponent, a);
      o.push(s);
    }
    if (r) {
      const a = this.dataKeys.map((s, c) => {
        if (s === "all")
          return;
        const l = this.getComponentProps(r, "labels", c);
        if (l.text !== void 0 && l.text !== null)
          return /* @__PURE__ */ D.cloneElement(r, l);
      }).filter((s) => s !== void 0);
      o.push(...a);
    }
    return o;
  }
  render() {
    const {
      role: t
    } = this.constructor, n = _r(this.props, IT, t), r = this.renderChildren(n);
    return n.standalone ? this.renderContainer(n.containerComponent, r) : /* @__PURE__ */ D.cloneElement(n.groupComponent, {}, r);
  }
}
ye(Ym, "displayName", "VictoryLegend"), ye(Ym, "role", "legend"), ye(Ym, "defaultProps", {
  borderComponent: /* @__PURE__ */ D.createElement(OJe, null),
  data: jtt,
  containerComponent: /* @__PURE__ */ D.createElement(ko, null),
  dataComponent: /* @__PURE__ */ D.createElement(dre, null),
  groupComponent: /* @__PURE__ */ D.createElement("g", null),
  labelComponent: /* @__PURE__ */ D.createElement(qi, null),
  standalone: !0,
  theme: Ca.grayscale,
  titleComponent: /* @__PURE__ */ D.createElement(qi, null)
}), ye(Ym, "expectedComponents", ["borderComponent", "containerComponent", "dataComponent", "groupComponent", "labelComponent", "titleComponent"]);
const Cw = qu(Ym), Ftt = (e) => {
  let t = Mo(e);
  t.length < 2 && (t = []);
  const n = {
    x: Pr(e, "x"),
    y: Pr(e, "y")
  }, r = {
    x: vf(e, "x"),
    y: vf(e, "y")
  }, i = {
    x: ea(e, "x").domain(r.x).range(e.horizontal ? n.y : n.x),
    y: ea(e, "y").domain(r.y).range(e.horizontal ? n.x : n.y)
  }, o = e.polar ? e.origin || jf(e) : void 0, a = Ey(e, "line"), s = Vp(e.style, a);
  return {
    domain: r,
    data: t,
    scale: i,
    style: s,
    origin: o
  };
}, Vtt = (e, t) => {
  const n = _r(e, t, "line"), r = Object.assign({}, n, Ftt(n)), {
    data: i,
    domain: o,
    events: a,
    groupComponent: s,
    height: c,
    horizontal: l,
    interpolation: u,
    origin: d,
    padding: f,
    polar: h,
    scale: p,
    sharedEvents: g,
    standalone: m,
    style: v,
    theme: y,
    width: S,
    labels: _,
    name: w,
    disableInlineStyles: T
  } = r, x = {
    parent: {
      style: v.parent,
      scale: p,
      data: i,
      height: c,
      width: S,
      name: w,
      domain: o,
      standalone: m,
      polar: h,
      origin: d,
      padding: f,
      horizontal: l
    },
    all: {
      data: {
        horizontal: l,
        polar: h,
        origin: d,
        scale: p,
        data: i,
        interpolation: u,
        groupComponent: s,
        style: T ? {} : v.data,
        theme: y,
        disableInlineStyles: T
      }
    }
  };
  return i.reduce((C, E, R) => {
    const A = Oy(r, E, R);
    if (A != null || _ && (a || g)) {
      const O = za(E.eventKey) ? R : E.eventKey;
      C[O] = {
        labels: l3(r, R)
      };
    }
    return C;
  }, x);
}, Btt = (e) => {
  const t = De(e.ariaLabel, e), n = De(e.id, e), r = br(Object.assign({
    fill: "none",
    stroke: "black",
    pointerEvents: "stroke"
  }, e.style), e), i = De(e.tabIndex, e);
  return Object.assign({}, e, {
    ariaLabel: t,
    id: n,
    style: r,
    tabIndex: i
  });
}, ztt = {
  pathComponent: /* @__PURE__ */ D.createElement(Up, null),
  role: "presentation",
  shapeRendering: "auto"
}, Htt = (e) => {
  const t = Btt(He({}, e, ztt)), n = Ya(t), {
    polar: r,
    origin: i
  } = t, o = yXe(t), a = r && i ? `translate(${i.x}, ${i.y})` : void 0, s = o(t.data);
  return /* @__PURE__ */ D.cloneElement(t.pathComponent, {
    ...t.events,
    ...n,
    "aria-label": t.ariaLabel,
    d: s,
    style: t.style,
    transform: t.transform || a,
    className: t.className,
    role: t.role,
    shapeRendering: t.shapeRendering,
    clipPath: t.clipPath,
    tabIndex: t.tabIndex
  });
}, W9 = {
  width: 450,
  height: 300,
  padding: 50,
  interpolation: "linear"
}, Utt = {
  components: [{
    name: "parent",
    index: "parent"
  }, {
    name: "data",
    index: "all"
  }, {
    name: "labels"
  }]
}, da = class da extends D.Component {
  constructor(t) {
    super(t);
  }
  static getBaseProps(t) {
    return Vtt(t, W9);
  }
  // Overridden in native versions
  shouldAnimate() {
    return !!this.props.animate;
  }
  render() {
    const {
      animationWhitelist: t,
      role: n
    } = da, r = _r(this.props, W9, n);
    if (this.shouldAnimate())
      return this.animateComponent(r, t);
    const i = this.renderContinuousData(r), o = r.standalone ? this.renderContainer(r.containerComponent, i) : i;
    return Cy(o, r);
  }
};
ye(da, "animationWhitelist", ["data", "domain", "height", "padding", "samples", "style", "width"]), ye(da, "displayName", "VictoryLine"), ye(da, "role", "line"), ye(da, "defaultTransitions", vYe()), ye(da, "defaultPolarTransitions", yYe()), ye(da, "continuous", !0), ye(da, "defaultProps", {
  containerComponent: /* @__PURE__ */ D.createElement(ko, null),
  dataComponent: /* @__PURE__ */ D.createElement(Htt, null),
  labelComponent: /* @__PURE__ */ D.createElement(qi, {
    renderInPortal: !0
  }),
  groupComponent: /* @__PURE__ */ D.createElement(ng, null),
  samples: 50,
  sortKey: "x",
  sortOrder: "ascending",
  standalone: !0,
  theme: Ca.grayscale
}), ye(da, "getDomain", vf), ye(da, "getData", Mo), ye(da, "expectedComponents", ["dataComponent", "labelComponent", "groupComponent", "containerComponent"]);
let a$ = da;
const Wtt = qu(a$, Utt), qtt = (e) => e == null || Rn(e) ? e : `${e}`, Gtt = (e, t, n) => e && e.data && e.data.fill ? e.data.fill : t && t[n % t.length], Ktt = (e, t) => typeof e.radius == "number" ? e.radius : Math.min(e.width - t.left - t.right, e.height - t.top - t.bottom) / 2, Ytt = (e, t) => {
  const {
    width: n,
    height: r
  } = e, i = ti(e.origin) ? e.origin : {};
  return {
    x: i.x !== void 0 ? i.x : (t.left - t.right + n) / 2,
    y: i.y !== void 0 ? i.y : (t.top - t.bottom + r) / 2
  };
}, Xtt = (e, t) => {
  const n = Rn(e.padAngle) ? 0 : e.padAngle;
  return Kte().sort(null).startAngle(fr(e.startAngle)).endAngle(fr(e.endAngle)).padAngle(fr(n)).value((i) => i._y)(t);
}, Qtt = (e) => {
  var t;
  return Array.isArray(e.categories) ? e.categories : ((t = e == null ? void 0 : e.categories) == null ? void 0 : t.x) ?? [];
}, Jtt = (e, t) => {
  const n = [];
  return Qtt(e).forEach((r) => {
    const i = t.findIndex((o) => {
      let {
        x: a
      } = o;
      return a === r;
    });
    if (i >= 0) {
      const o = t.splice(i, 1)[0];
      n.push(o);
    }
  }), [...n, ...t];
}, Ztt = (e) => {
  const {
    colorScale: t,
    theme: n
  } = e, r = Ey(e, "pie"), i = Vp(e.style, r), o = Array.isArray(t) ? t : b3(t, n), a = Wi(e.padding), s = Ktt(e, a), c = Ytt(e, a), l = Jtt(e, Mo(e)), u = Xtt(e, l);
  return Object.assign({}, e, {
    style: i,
    colors: o,
    padding: a,
    defaultRadius: s,
    data: l,
    slices: u,
    origin: c
  });
}, ent = (e, t) => {
  const {
    style: n,
    colors: r
  } = t, i = Gtt(n, r, e);
  return Object.assign({
    fill: i
  }, n.data);
}, tnt = (e, t, n) => {
  let r;
  return t.label ? r = t.label : Array.isArray(e.labels) ? r = e.labels[n] : r = Rn(e.labels) ? e.labels : t.xName || t._x, qtt(r);
}, nnt = (e) => KE().outerRadius(e).innerRadius(e), rnt = (e, t, n) => {
  const r = n && n.padding || 0;
  return t || e + r;
}, int = (e, t, n) => {
  const r = {
    startAngle: n === "startAngle" ? t.startAngle : t.endAngle,
    endAngle: n === "endAngle" ? t.endAngle : t.startAngle
  }, i = Object.assign({}, t, r);
  return e.centroid(i);
}, ont = (e, t) => t === "perpendicular" ? e > 90 && e < 270 ? "bottom" : "top" : t === "parallel" ? e >= 0 && e <= 180 ? "right" : "left" : e < 45 || e > 315 ? "top" : e >= 45 && e < 135 ? "right" : e >= 135 && e < 225 ? "bottom" : "left", ant = (e) => e === "top" || e === "bottom" ? "middle" : e === "right" ? "start" : "end", snt = (e) => e === "left" || e === "right" ? "middle" : e === "bottom" ? "start" : "end", cnt = (e, t, n) => {
  let r = 0;
  return t.angle !== void 0 ? r = n.angle : t === "centroid" ? r = Qc((e.startAngle + e.endAngle) / 2) : r = Qc(t === "startAngle" ? e.startAngle : e.endAngle), (r < 0 ? 360 - r : r) % 360;
}, lnt = (e, t) => t === "vertical" ? 0 : t === "parallel" ? e > 180 && e < 360 ? e + 90 : e - 90 : e > 90 && e < 270 ? e - 180 : e, unt = (e, t, n) => {
  const {
    index: r,
    datum: i,
    data: o,
    slice: a,
    labelComponent: s,
    theme: c
  } = t, {
    style: l,
    defaultRadius: u,
    origin: d,
    width: f,
    height: h
  } = n, p = De(n.labelRadius, Object.assign({
    text: e
  }, t)), g = De(n.labelPosition, Object.assign({
    text: e
  }, t)) || "centroid", m = De(n.labelPlacement, Object.assign({
    text: e
  }, t)) || "vertical", v = Object.assign({
    padding: 0
  }, l.labels), y = br(v, Object.assign({
    labelRadius: p,
    text: e
  }, t)), S = rnt(u, p, y), _ = nnt(S), w = int(_, a, g), T = cnt(a, g, v), x = lnt(T, m), C = ont(T, m), E = v.textAnchor || ant(C), R = v.verticalAnchor || snt(C), A = {
    width: f,
    height: h,
    index: r,
    datum: i,
    data: o,
    slice: a,
    orientation: C,
    text: e,
    style: v,
    x: Math.round(w[0]) + d.x,
    y: Math.round(w[1]) + d.y,
    textAnchor: E,
    verticalAnchor: R,
    angle: x,
    calculatedLabelRadius: S
  };
  if (!NE(s))
    return A;
  const O = c && c.tooltip || {};
  return He({}, A, Lf(O, ["style"]));
}, dnt = (e) => Math.cos(e - fr(90)), fnt = (e) => Math.sin(e - fr(90)), q9 = (e, t) => e * dnt(t), G9 = (e, t) => e * fnt(t), K9 = (e) => e.reduce((t, n) => t + n, 0) / e.length, hnt = (e, t, n) => {
  const {
    innerRadius: r,
    radius: i,
    slice: {
      startAngle: o,
      endAngle: a
    },
    labelIndicatorInnerOffset: s,
    labelIndicatorOuterOffset: c,
    index: l
  } = e, {
    height: u,
    width: d
  } = t, {
    calculatedLabelRadius: f
  } = n, h = K9([r, i]), p = K9([a, o]), g = d / 2, m = u / 2, v = h + s, y = f - c, S = g + q9(v, p), _ = m + G9(v, p), w = g + q9(y, p), T = m + G9(y, p);
  return He({}, {
    x1: S,
    y1: _,
    x2: w,
    y2: T,
    index: l
  });
}, gnt = (e, t) => {
  const n = _r(e, t, "pie"), r = Ztt(n), {
    slices: i,
    style: o,
    data: a,
    origin: s,
    defaultRadius: c,
    labels: l,
    events: u,
    sharedEvents: d,
    height: f,
    width: h,
    standalone: p,
    name: g,
    innerRadius: m,
    cornerRadius: v,
    padAngle: y,
    disableInlineStyles: S,
    labelIndicator: _
  } = r, w = n.radius || c, T = {
    parent: {
      standalone: p,
      height: f,
      width: h,
      slices: i,
      name: g,
      style: o.parent
    }
  };
  return i.reduce((x, C, E) => {
    const R = He({}, a[E], {
      startAngle: Qc(C.startAngle),
      endAngle: Qc(C.endAngle),
      padAngle: Qc(C.padAngle)
    }), A = za(R.eventKey) ? E : R.eventKey, O = {
      index: E,
      slice: C,
      datum: R,
      data: a,
      origin: s,
      innerRadius: m,
      radius: w,
      cornerRadius: v,
      padAngle: y,
      style: S ? {} : ent(E, r),
      disableInlineStyles: S
    };
    x[A] = {
      data: O
    };
    const $ = tnt(n, R, E);
    if ($ != null || l && (u || d)) {
      const N = De($, O);
      if (x[A].labels = unt(N, Object.assign({}, n, O), r), _) {
        const z = x[A].labels;
        z.calculatedLabelRadius > w && (x[A].labelIndicators = hnt(Object.assign({}, n, O), r, z));
      }
    }
    return x;
  }, T);
}, pnt = (e) => {
  const {
    slice: t,
    radius: n,
    innerRadius: r,
    cornerRadius: i
  } = e;
  if (Rn(e.pathFunction))
    return e.pathFunction(t);
  const o = fr(e.padAngle), a = fr(e.sliceStartAngle), s = fr(e.sliceEndAngle);
  return KE().cornerRadius(i).outerRadius(n).innerRadius(r || 0)(He({
    startAngle: a,
    endAngle: s,
    padAngle: o
  }, t));
}, mnt = (e) => {
  const t = br(e.style, e), n = De(e.radius, Object.assign({}, e, {
    style: t
  })), r = De(e.innerRadius, Object.assign({}, e, {
    style: t,
    radius: n
  })), i = De(e.ariaLabel, e), o = De(e.id, e), a = De(e.cornerRadius, e), s = De(e.padAngle, e), c = De(e.sliceStartAngle, e), l = De(e.sliceEndAngle, e), u = De(e.tabIndex, e);
  return Object.assign({}, e, {
    ariaLabel: i,
    style: t,
    radius: n,
    innerRadius: r,
    id: o,
    cornerRadius: a,
    padAngle: s,
    sliceStartAngle: c,
    sliceEndAngle: l,
    tabIndex: u
  });
}, vnt = {
  pathComponent: /* @__PURE__ */ D.createElement(Up, null),
  role: "presentation",
  shapeRendering: "auto"
}, ynt = (e) => {
  const t = mnt(He({}, e, vnt)), n = t.origin ? `translate(${t.origin.x}, ${t.origin.y})` : void 0;
  return /* @__PURE__ */ D.cloneElement(t.pathComponent, {
    ...t.events,
    "aria-label": t.ariaLabel,
    d: pnt(t),
    style: t.style,
    transform: t.transform || n,
    className: t.className,
    role: t.role,
    shapeRendering: t.shapeRendering,
    clipPath: t.clipPath,
    tabIndex: t.tabIndex
  });
}, Y9 = {
  endAngle: 360,
  height: 400,
  innerRadius: 0,
  cornerRadius: 0,
  padAngle: 0,
  padding: 30,
  width: 400,
  startAngle: 0,
  colorScale: ["#ffffff", "#f0f0f0", "#d9d9d9", "#bdbdbd", "#969696", "#737373", "#525252", "#252525", "#000000"],
  labelPosition: "centroid",
  labelIndicatorInnerOffset: 15,
  labelIndicatorOuterOffset: 5
}, bnt = (e) => !za(e._x) && !za(e._y);
class Ol extends D.Component {
  static getBaseProps(t) {
    return gnt(t, Y9);
  }
  // Overridden in victory-native
  shouldAnimate() {
    return !!this.props.animate;
  }
  renderComponents(t, n) {
    n === void 0 && (n = bnt);
    const {
      dataComponent: r,
      labelComponent: i,
      groupComponent: o,
      labelIndicator: a,
      labelPosition: s
    } = t;
    if (!o)
      throw new Error("VictoryPie expects a groupComponent prop");
    const c = a && s === "centroid", l = [];
    if (r) {
      const u = this.dataKeys.reduce((d, f, h) => {
        const p = this.getComponentProps(r, "data", h);
        return n(p.datum) && d.push(/* @__PURE__ */ D.cloneElement(r, p)), d;
      }, []);
      l.push(...u);
    }
    if (i) {
      const u = this.dataKeys.map((d, f) => {
        const h = this.getComponentProps(i, "labels", f);
        if (h.text !== void 0 && h.text !== null)
          return /* @__PURE__ */ D.cloneElement(i, h);
      }).filter((d) => d !== void 0);
      l.push(...u);
    }
    if (c && a) {
      let u = /* @__PURE__ */ D.createElement(Hd, null);
      typeof a == "object" && (u = a);
      const d = this.dataKeys.map((f, h) => {
        const p = this.getComponentProps(u, "labelIndicators", h);
        return /* @__PURE__ */ D.cloneElement(u, p);
      });
      l.push(...d);
    }
    return this.renderContainer(o, l);
  }
  render() {
    const {
      animationWhitelist: t,
      role: n
    } = Mre, r = _r(this.props, Y9, n);
    if (this.shouldAnimate())
      return this.animateComponent(r, t);
    const i = this.renderComponents(r), o = r.standalone ? this.renderContainer(r.containerComponent, i) : i;
    return Cy(o, r);
  }
}
ye(Ol, "animationWhitelist", ["data", "endAngle", "height", "innerRadius", "cornerRadius", "padAngle", "padding", "colorScale", "startAngle", "style", "width"]), ye(Ol, "displayName", "VictoryPie"), ye(Ol, "role", "pie"), ye(Ol, "defaultTransitions", {
  onExit: {
    duration: 500,
    before: () => ({
      _y: 0,
      label: " "
    })
  },
  onEnter: {
    duration: 500,
    before: () => ({
      _y: 0,
      label: " "
    }),
    after: (t) => ({
      y_: t._y,
      label: t.label
    })
  }
}), ye(Ol, "defaultProps", {
  data: [{
    x: "A",
    y: 1
  }, {
    x: "B",
    y: 2
  }, {
    x: "C",
    y: 3
  }, {
    x: "D",
    y: 1
  }, {
    x: "E",
    y: 2
  }],
  standalone: !0,
  dataComponent: /* @__PURE__ */ D.createElement(ynt, null),
  labelComponent: /* @__PURE__ */ D.createElement(qi, null),
  containerComponent: /* @__PURE__ */ D.createElement(ko, null),
  groupComponent: /* @__PURE__ */ D.createElement("g", null),
  sortOrder: "ascending",
  theme: Ca.grayscale
}), ye(Ol, "getData", Mo), ye(Ol, "expectedComponents", ["dataComponent", "labelComponent", "groupComponent", "containerComponent", "labelIndicatorComponent"]);
const Mre = qu(Ol), _nt = (e, t) => t.bubbleProperty ? "circle" : e.symbol || t.symbol, Snt = (e, t) => {
  const {
    data: n,
    z: r,
    maxBubbleSize: i,
    minBubbleSize: o
  } = t, a = n.map((v) => v[r]), s = Math.min(...a), c = Math.max(...a), u = i || (() => {
    const v = Math.min(...Object.values(Wi(t.padding)));
    return Math.max(v, 5);
  })(), d = o || u * 0.1;
  if (c === s)
    return Math.max(d, 1);
  const f = Math.PI * Math.pow(u, 2), h = Math.PI * Math.pow(d, 2), p = (e[r] - s) / (c - s) * f, g = Math.max(p, h), m = Math.sqrt(g / Math.PI);
  return Math.max(m, 1);
}, wnt = (e, t) => {
  const {
    size: n,
    z: r
  } = t;
  return e.size ? typeof e.size == "function" ? e.size : Math.max(e.size, 1) : typeof t.size == "function" ? n : e[r] ? Snt(e, t) : Math.max(n || 0, 1);
}, xnt = (e) => {
  const t = Ey(e, "scatter"), n = Vp(e.style, t), r = {
    x: Pr(e, "x"),
    y: Pr(e, "y")
  }, i = {
    x: vf(e, "x"),
    y: vf(e, "y")
  }, o = {
    x: ea(e, "x").domain(i.x).range(e.horizontal ? r.y : r.x),
    y: ea(e, "y").domain(i.y).range(e.horizontal ? r.x : r.y)
  }, a = e.polar ? e.origin || jf(e) : void 0, s = e.bubbleProperty || "z";
  let c = Mo(e);
  return c = Pte(c, i), {
    domain: i,
    data: c,
    scale: o,
    style: n,
    origin: a,
    z: s
  };
}, Ent = (e, t) => {
  const n = _r(e, t, "scatter"), r = Object.assign({}, n, xnt(n)), {
    data: i,
    domain: o,
    events: a,
    height: s,
    origin: c,
    padding: l,
    polar: u,
    scale: d,
    name: f,
    sharedEvents: h,
    standalone: p,
    style: g,
    theme: m,
    width: v,
    labels: y,
    horizontal: S,
    disableInlineStyles: _
  } = r, w = {
    parent: {
      style: g.parent,
      scale: d,
      domain: o,
      data: i,
      height: s,
      width: v,
      standalone: p,
      theme: m,
      origin: c,
      polar: u,
      padding: l,
      name: f,
      horizontal: S
    }
  };
  return i.reduce((T, x, C) => {
    const E = za(x.eventKey) ? C : x.eventKey, {
      x: R,
      y: A
    } = xy(r, x), O = {
      x: R,
      y: A,
      datum: x,
      data: i,
      index: C,
      scale: d,
      polar: u,
      origin: c,
      horizontal: S,
      size: wnt(x, r),
      symbol: _nt(x, r),
      style: _ ? {} : g.data,
      disableInlineStyles: _
    };
    T[E] = {
      data: O
    };
    const $ = Oy(r, x, C);
    return ($ != null || y && (a || h)) && (T[E].labels = l3(r, C)), T;
  }, w);
}, X9 = {
  width: 450,
  height: 300,
  padding: 50,
  size: 3,
  symbol: "circle"
};
class Mc extends D.Component {
  static getBaseProps(t) {
    return Ent(t, X9);
  }
  // Overridden in native versions
  shouldAnimate() {
    return !!this.props.animate;
  }
  render() {
    const {
      animationWhitelist: t,
      role: n
    } = kre, r = _r(this.props, X9, n);
    if (this.shouldAnimate())
      return this.animateComponent(r, t);
    const i = this.renderData(r), o = r.standalone ? this.renderContainer(r.containerComponent, i) : i;
    return Cy(o, r);
  }
}
ye(Mc, "animationWhitelist", ["data", "domain", "height", "maxBubbleSize", "padding", "samples", "size", "style", "width"]), ye(Mc, "displayName", "VictoryScatter"), ye(Mc, "role", "scatter"), ye(Mc, "defaultTransitions", Hte()), ye(Mc, "defaultProps", {
  containerComponent: /* @__PURE__ */ D.createElement(ko, null),
  dataComponent: /* @__PURE__ */ D.createElement(dre, null),
  labelComponent: /* @__PURE__ */ D.createElement(qi, null),
  groupComponent: /* @__PURE__ */ D.createElement("g", null),
  samples: 50,
  sortOrder: "ascending",
  standalone: !0,
  theme: Ca.grayscale
}), ye(Mc, "getDomain", vf), ye(Mc, "getData", Mo), ye(Mc, "expectedComponents", ["dataComponent", "labelComponent", "groupComponent", "containerComponent"]);
const kre = qu(Mc), Nre = {
  width: 450,
  height: 300,
  padding: 50
};
function Cnt(e, t) {
  const {
    fillInMissingData: n
  } = e, r = t.reduce((a, s) => (s.forEach((c) => {
    a[c._x instanceof Date ? c._x.getTime() : c._x] = !0;
  }), a), {}), i = Object.keys(r).map((a) => Number(a)), o = wy(i);
  return t.map((a) => {
    let s = 0;
    const c = a[0] && a[0]._x instanceof Date;
    return o.map((u, d) => {
      let f = Number(u);
      const h = a[d - s];
      if (h) {
        if ((c ? h._x.getTime() : h._x) === f)
          return h;
        s++;
        const m = n ? 0 : null;
        return f = c ? new Date(f) : f, {
          x: f,
          y: m,
          _x: f,
          _y: m
        };
      }
      const p = n ? 0 : null;
      return f = c ? new Date(f) : f, {
        x: f,
        y: p,
        _x: f,
        _y: p
      };
    });
  });
}
function Tnt(e, t, n) {
  if (e.y0)
    return e.y0;
  const r = e._y, i = e._group, o = n[0].map((l) => l.y0), s = n.slice(0, t).reduce((l, u) => l.concat(u.filter((d) => e._x instanceof Date ? d._x.getTime() === e._x.getTime() : d._x === e._x).map((d) => d._y || 0)), []), c = s.length && s.reduce((l, u) => r < 0 && u < 0 || r >= 0 && u >= 0 ? Number(u) + l : l, o[i] || 0);
  return s.some((l) => l instanceof Date) ? new Date(c) : c;
}
function Int(e, t, n) {
  const r = e.xOffset || 0;
  return t[n].map((i) => {
    const o = Tnt(i, n, t) || 0;
    return Object.assign({}, i, {
      _y0: i._y instanceof Date ? o ? new Date(o) : i._y : o,
      _y1: i._y === null ? null : i._y instanceof Date ? new Date(Number(i._y) + Number(o)) : i._y + o,
      _x1: i._x === null ? null : i._x instanceof Date ? new Date(Number(i._x) + Number(r)) : i._x + r
    });
  });
}
function Ant(e, t) {
  const n = ere(e, t), r = Cnt(e, n);
  return r.map((o) => o.filter((a) => a._x !== null && a._y !== null)).map((o, a) => Int(e, r, a));
}
function Dre(e, t) {
  const n = t || D.Children.toArray(e.children), r = "stack", i = _r(e, Nre, r), o = nre(i.theme, i.style, r), a = i.categories || C3(i, n), s = i.datasets || Ant(i, n), c = n.map((g, m) => /* @__PURE__ */ D.cloneElement(g, {
    data: s[m]
  })), l = {
    x: Ev(Object.assign({}, i, {
      categories: a
    }), "x", c),
    y: Ev(Object.assign({}, i, {
      categories: a
    }), "y", c)
  }, u = i.range || {
    x: Pr(i, "x"),
    y: Pr(i, "y")
  }, d = {
    x: mf(i, "x") || Xg(i, "x"),
    y: mf(i, "y") || Xg(i, "y")
  }, f = {
    x: d.x.domain(l.x).range(i.horizontal ? u.y : u.x),
    y: d.y.domain(l.y).range(i.horizontal ? u.x : u.y)
  }, {
    colorScale: h,
    horizontal: p
  } = i;
  return {
    datasets: s,
    categories: a,
    range: u,
    domain: l,
    horizontal: p,
    scale: f,
    style: o,
    colorScale: h,
    role: r
  };
}
const Rnt = (e) => {
  const {
    children: t
  } = e, n = D.Children.toArray(t).map((r) => {
    const i = r;
    return {
      ...i,
      props: Lf(i.props, ["sharedEvents"])
    };
  });
  return e.children = n, e;
};
function $nt(e) {
  const t = Rnt(e), [n, r] = D.useState(t);
  return D.useEffect(() => {
    ys(t, n) || r(t);
  }, [n, r, t]), D.useMemo(() => Dre(n, n.children), [n]);
}
function Ont(e, t, n) {
  if (e.labels)
    return t.length === n + 1 ? e.labels : void 0;
}
function Pnt(e, t) {
  const {
    categories: n,
    domain: r,
    range: i,
    scale: o,
    horizontal: a
  } = t;
  return {
    height: e.height,
    width: e.width,
    padding: Wi(e.padding),
    standalone: !1,
    theme: e.theme,
    categories: n,
    domain: r,
    range: i,
    scale: o,
    horizontal: a
  };
}
function Mnt(e, t) {
  const n = t.type && t.type.role, r = t.props.colorScale || e.colorScale;
  if (!(n !== "group" && n !== "stack"))
    return e.theme ? r || e.theme.props.colorScale : r;
}
function Lre(e, t, n) {
  const r = _r(e, Nre, "stack"), i = t || D.Children.toArray(r.children), o = n || Dre(r, i), {
    datasets: a
  } = o, s = Pnt(r, o), c = r.name || "stack", {
    theme: l
  } = r;
  return i.map((u, d) => {
    const f = u.type && u.type.role, h = a[d], p = rre(u, d, o, l), g = r.labels ? Ont(r, a, d) : u.props.labels, m = u.props.name || `${c}-${f}-${d}`;
    return /* @__PURE__ */ D.cloneElement(u, Object.assign({
      key: `${m}-key-${d}`,
      labels: g,
      name: m,
      domainPadding: u.props.domainPadding || r.domainPadding,
      theme: r.theme,
      labelComponent: r.labelComponent || u.props.labelComponent,
      style: p,
      colorScale: Mnt(r, u),
      data: h,
      polar: r.polar
    }, s));
  });
}
const knt = {
  width: 450,
  height: 300,
  padding: 50
}, Nnt = {
  containerComponent: /* @__PURE__ */ D.createElement(ko, null),
  groupComponent: /* @__PURE__ */ D.createElement("g", null),
  standalone: !0,
  theme: Ca.grayscale,
  fillInMissingData: !0
}, Dnt = (e) => {
  const {
    role: t
  } = O3, n = D.useMemo(() => He({}, e, Nnt), [e]), {
    setAnimationState: r,
    getAnimationProps: i,
    getProps: o
  } = o3(), a = o(n), s = _r(a, knt, t), {
    eventKey: c,
    containerComponent: l,
    standalone: u,
    groupComponent: d,
    externalEventMutations: f,
    width: h,
    height: p,
    theme: g,
    polar: m,
    horizontal: v,
    name: y
  } = s, S = D.Children.toArray(s.children), _ = $nt(s), {
    domain: w,
    scale: T,
    style: x
  } = _, C = D.useMemo(() => Lre(a, S, _).map((k, F) => {
    const V = Object.assign({
      animate: i(a, k, F)
    }, k.props);
    return /* @__PURE__ */ D.cloneElement(k, V);
  }).reverse(), [a, S, _, i]), E = D.useMemo(() => u ? {
    domain: w,
    scale: T,
    width: h,
    height: p,
    standalone: u,
    theme: g,
    style: x.parent,
    horizontal: v,
    polar: m,
    name: y
  } : {}, [u, w, T, h, p, g, x, v, m, y]), R = D.useMemo(() => Ya(n), [n]), A = D.useMemo(() => {
    if (u) {
      const N = He({}, l.props, E, R);
      return /* @__PURE__ */ D.cloneElement(l, N);
    }
    return /* @__PURE__ */ D.cloneElement(d, R);
  }, [d, u, l, E, R]), O = D.useMemo(() => E3(a), [a]), $ = i3(n);
  return D.useEffect(() => () => {
    n.animate && r($, n);
  }, [r, $, n]), Lr(O) ? /* @__PURE__ */ D.cloneElement(A, A.props, C) : /* @__PURE__ */ D.createElement(Rd, {
    container: A,
    eventKey: c,
    events: O,
    externalEventMutations: f
  }, C);
}, Lnt = {
  role: "stack",
  expectedComponents: ["groupComponent", "containerComponent", "labelComponent"],
  getChildren: Lre
}, O3 = Object.assign(/* @__PURE__ */ D.memo(Dnt, ys), Lnt);
O3.displayName = "VictoryStack";
const AT = (e) => {
  const { loggingService: t } = St(ir), n = Me(null);
  return gt(() => {
    n.current && t.debug("SizedVictoryLabel ref", n.current.getBBox());
  }, [t]), /* @__PURE__ */ M.jsx("g", { role: "presentation", ref: n, children: /* @__PURE__ */ M.jsx(
    qi,
    {
      ...e,
      // dy: labelRef.current?.getBBox().height ? -labelRef.current.getBBox().height / 2 : 0,
      dy: -20
    }
  ) });
};
function P3(e, t) {
  const n = t.colours ?? [
    e.primaryColour || "#252525",
    e.contrastColour || "#737373",
    "#969696",
    "#bdbdbd",
    "#d9d9d9",
    "#f0f0f0",
    "#525252"
  ], r = "#252525", i = "#969696", o = "inherit", a = "normal", s = 16, c = {
    // animate: { duration: 2000 },
    width: 450,
    height: 300,
    padding: { left: 75, top: 25, right: 50, bottom: 50 },
    colorScale: n
  }, l = {
    fontFamily: o,
    fontSize: s,
    letterSpacing: a,
    padding: 10,
    fill: r,
    stroke: "transparent"
  }, u = Object.assign({ textAnchor: "middle" }, l), d = "round", f = "round";
  return {
    area: Object.assign(
      {
        style: {
          data: {
            fill: r
          },
          labels: l
        }
      },
      c
    ),
    axis: Object.assign(
      {
        style: {
          axis: {
            fill: "transparent",
            stroke: r,
            strokeWidth: 1,
            strokeLinecap: d,
            strokeLinejoin: f
          },
          axisLabel: Object.assign({}, u, { padding: 35 }),
          grid: {
            fill: "none",
            stroke: "none",
            pointerEvents: "painted"
          },
          ticks: {
            fill: "transparent",
            size: 1,
            stroke: "transparent"
          },
          tickLabels: l
        }
      },
      c
    ),
    dependentAxis: Object.assign(
      {
        style: {
          axis: {
            fill: "transparent",
            stroke: r,
            strokeWidth: 1,
            strokeLinecap: d,
            strokeLinejoin: f
          },
          axisLabel: Object.assign({}, u, {
            padding: 35
          }),
          grid: {
            fill: "none",
            stroke: "none",
            pointerEvents: "painted"
          },
          ticks: {
            fill: "transparent",
            size: 1,
            stroke: "transparent"
          },
          tickLabels: l
        }
      },
      c
    ),
    bar: Object.assign(
      {
        style: {
          data: {
            fill: r,
            padding: 8,
            strokeWidth: 0
          },
          labels: l
        }
      },
      c
    ),
    boxplot: Object.assign(
      {
        style: {
          max: { padding: 8, stroke: r, strokeWidth: 1 },
          maxLabels: Object.assign({}, l, { padding: 3 }),
          median: { padding: 8, stroke: r, strokeWidth: 1 },
          medianLabels: Object.assign({}, l, { padding: 3 }),
          min: { padding: 8, stroke: r, strokeWidth: 1 },
          minLabels: Object.assign({}, l, { padding: 3 }),
          q1: { padding: 8, fill: i },
          q1Labels: Object.assign({}, l, { padding: 3 }),
          q3: { padding: 8, fill: i },
          q3Labels: Object.assign({}, l, { padding: 3 })
        },
        boxWidth: 20
      },
      c
    ),
    candlestick: Object.assign(
      {
        style: {
          data: {
            stroke: r,
            strokeWidth: 1
          },
          labels: Object.assign({}, l, { padding: 5 })
        },
        candleColors: {
          positive: "#ffffff",
          negative: r
        }
      },
      c
    ),
    chart: c,
    errorbar: Object.assign(
      {
        borderWidth: 8,
        style: {
          data: {
            fill: "transparent",
            stroke: r,
            strokeWidth: 2
          },
          labels: l
        }
      },
      c
    ),
    group: Object.assign(
      {
        colorScale: n
      },
      c
    ),
    histogram: Object.assign(
      {
        style: {
          data: {
            fill: i,
            stroke: r,
            strokeWidth: 2
          },
          labels: l
        }
      },
      c
    ),
    legend: {
      colorScale: n,
      gutter: 10,
      orientation: "vertical",
      titleOrientation: "top",
      style: {
        data: {
          type: "circle"
        },
        labels: l,
        title: Object.assign({}, l, { padding: 5 })
      }
    },
    line: Object.assign(
      {
        style: {
          data: {
            fill: "transparent",
            stroke: r,
            strokeWidth: 2
          },
          labels: l
        }
      },
      c
    ),
    pie: {
      style: {
        data: {
          padding: 10,
          stroke: "transparent",
          strokeWidth: 1
        },
        labels: Object.assign({}, l, { padding: 20 })
      },
      colorScale: n,
      width: 400,
      height: 400,
      padding: 50
    },
    scatter: Object.assign(
      {
        style: {
          data: {
            fill: r,
            stroke: "transparent",
            strokeWidth: 0
          },
          labels: l
        }
      },
      c
    ),
    stack: Object.assign(
      {
        colorScale: n
      },
      c
    ),
    tooltip: {
      style: Object.assign({}, l, { padding: 0, pointerEvents: "none" }),
      flyoutStyle: {
        stroke: r,
        strokeWidth: 1,
        fill: "#f0f0f0",
        pointerEvents: "none"
      },
      flyoutPadding: 5,
      cornerRadius: 5,
      pointerLength: 10
    },
    voronoi: Object.assign(
      {
        style: {
          data: {
            fill: "transparent",
            stroke: "transparent",
            strokeWidth: 0
          },
          labels: Object.assign({}, l, { padding: 5, pointerEvents: "none" }),
          flyout: {
            stroke: r,
            strokeWidth: 1,
            fill: "#f0f0f0",
            pointerEvents: "none"
          }
        }
      },
      c
    )
  };
}
const Ud = (e) => /* @__PURE__ */ M.jsx(jnt, { style: e.style, children: e.children }), jnt = Ce.div`
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  justify-content: center;
  padding: 0;
  overflow: visible;
`, Fnt = ({
  output: e,
  currentAnswer: t,
  answers: n,
  settings: r,
  aggregateAnswers: i
}) => {
  var S, _;
  const { loggingService: o } = St(ir), a = wa(), s = hy(e.data, { currentAnswer: t, answers: n, aggregateAnswers: i }), c = Dn(e.text, { currentAnswer: t, answers: n, aggregateAnswers: i }), l = Dn(e.legendOptions, { currentAnswer: t, answers: n, aggregateAnswers: i }) ?? {}, u = Dn(e.chartOptions, { currentAnswer: t, answers: n, aggregateAnswers: i }) ?? {}, d = Dn(e.xAxisOptions, {
    currentAnswer: t,
    answers: n,
    aggregateAnswers: i
  }), f = Dn(e.yAxisOptions, {
    currentAnswer: t,
    answers: n,
    aggregateAnswers: i
  }), { colourShades: h } = hr(), p = P3(r, { colours: u.colours ?? h });
  if (o.debug("data", s), s === "loading")
    return /* @__PURE__ */ M.jsx(Ud, { style: e.style, children: /* @__PURE__ */ M.jsx(uv, {}) });
  const g = s == null ? void 0 : s.map((w) => w.label), m = {
    theme: p,
    containerComponent: /* @__PURE__ */ M.jsx(ko, { style: { touchAction: "auto" } }),
    ...u
  };
  a === ui.MOBILE && (m.width = 400);
  const v = g == null ? void 0 : g.map((w) => ({ name: w })), y = {
    theme: p,
    orientation: l.orientation,
    x: Vnt(l.position, m.width || ((S = p.chart) == null ? void 0 : S.width)),
    y: Bnt(l.position, m.height || ((_ = p.chart) == null ? void 0 : _.height)),
    data: v,
    gutter: l.gutter,
    colorScale: l.colorScale ?? void 0
  };
  switch (e.barType) {
    case "grouped":
      return /* @__PURE__ */ M.jsxs(Ud, { style: e.style, children: [
        e.title ? /* @__PURE__ */ M.jsx(Q9, { children: e.title }) : void 0,
        c && /* @__PURE__ */ M.jsx(J9, { children: c }),
        /* @__PURE__ */ M.jsxs(Qg, { horizontal: e.orientation === "horizontal", ...m, children: [
          /* @__PURE__ */ M.jsx(ig, { offset: 21, colorScale: e.groupColours, children: s && s.map((w, T) => /* @__PURE__ */ M.jsx(
            n$,
            {
              categories: e.categories ? { x: e.categories } : void 0,
              barWidth: u.barWidth ?? 25,
              labelComponent: u.tooltips ? /* @__PURE__ */ M.jsx(rg, {}) : void 0,
              labels: w.dataset.map((x) => x.annotation ?? ""),
              data: w.dataset.map((x, C) => ({
                x: x.label,
                y: x.value,
                fill: x.fill,
                stroke: x.stroke
              })),
              style: {
                data: {
                  fill: ({ datum: x }) => {
                    var C, E;
                    return x.fill ?? ((E = (C = p.bar) == null ? void 0 : C.colorScale) == null ? void 0 : E[T]);
                  },
                  stroke: ({ datum: x }) => x.stroke,
                  strokeWidth: ({ datum: x }) => x.stroke ? 2 : 0
                }
              }
            },
            T
          )).toReversed() }),
          /* @__PURE__ */ M.jsx(ig, { offset: 21, children: s && s.map((w, T) => /* @__PURE__ */ M.jsx(
            wre,
            {
              data: w.dataset.map((x) => ({
                x: x.label,
                y: x.value,
                errorY: x.error
              }))
            },
            `${T}-error`
          )).toReversed() }),
          /* @__PURE__ */ M.jsx(
            ds,
            {
              label: e.xLabel,
              axisLabelComponent: /* @__PURE__ */ M.jsx(AT, {}),
              tickFormat: d == null ? void 0 : d.tickFormat,
              tickValues: d == null ? void 0 : d.tickValues
            }
          ),
          /* @__PURE__ */ M.jsx(
            ds,
            {
              dependentAxis: !0,
              label: e.yLabel,
              axisLabelComponent: /* @__PURE__ */ M.jsx(AT, {}),
              style: { axisLabel: { padding: 50 } },
              tickValues: f == null ? void 0 : f.tickValues,
              tickFormat: f == null ? void 0 : f.tickFormat
            }
          ),
          e.legendOptions && /* @__PURE__ */ M.jsx(Cw, { ...y })
        ] })
      ] });
    case "stacked":
      return /* @__PURE__ */ M.jsxs(Ud, { style: e.style, children: [
        e.title ? /* @__PURE__ */ M.jsx(Q9, { children: e.title }) : void 0,
        c && /* @__PURE__ */ M.jsx(J9, { children: c }),
        /* @__PURE__ */ M.jsxs(
          Qg,
          {
            domainPadding: { x: [50, 50] },
            horizontal: e.orientation === "horizontal",
            ...m,
            children: [
              /* @__PURE__ */ M.jsx(O3, { children: s && s.map((w, T) => /* @__PURE__ */ M.jsx(
                n$,
                {
                  categories: e.categories ? { x: e.categories } : void 0,
                  data: w.dataset.map((x, C) => ({
                    x: x.label,
                    y: x.value,
                    fill: x.fill,
                    stroke: x.stroke
                  })),
                  labels: w.dataset.map((x) => x.annotation ?? ""),
                  labelComponent: u.tooltips ? /* @__PURE__ */ M.jsx(rg, {}) : void 0,
                  barWidth: u.barWidth ?? 25,
                  barRatio: e.categories ? void 0 : 0.7,
                  style: {
                    data: {
                      fill: ({ datum: x }) => {
                        var C, E;
                        return x.fill ?? ((E = (C = p.bar) == null ? void 0 : C.colorScale) == null ? void 0 : E[T]);
                      },
                      stroke: ({ datum: x }) => x.stroke,
                      strokeWidth: ({ datum: x }) => x.stroke ? 2 : 0
                    }
                  }
                },
                T
              )) }),
              /* @__PURE__ */ M.jsx(
                ds,
                {
                  label: e.xLabel,
                  tickFormat: d == null ? void 0 : d.tickFormat,
                  tickValues: d == null ? void 0 : d.tickValues
                }
              ),
              /* @__PURE__ */ M.jsx(
                ds,
                {
                  dependentAxis: !0,
                  label: e.yLabel,
                  axisLabelComponent: /* @__PURE__ */ M.jsx(AT, {}),
                  tickFormat: f == null ? void 0 : f.tickFormat,
                  tickValues: f == null ? void 0 : f.tickValues
                }
              ),
              e.legendOptions && /* @__PURE__ */ M.jsx(Cw, { ...y })
            ]
          }
        )
      ] });
  }
};
function Vnt(e, t) {
  if (!(e === void 0 || t === void 0) && typeof e != "string")
    return (e == null ? void 0 : e.x) * t;
}
function Bnt(e, t) {
  if (!(e === void 0 || t === void 0) && typeof e != "string")
    return (e == null ? void 0 : e.y) * t;
}
const Q9 = Ce.div`
  display: flex;
  justify-content: center;
`, J9 = Ce.div`
  display: flex;
  flex-direction: column;
`, znt = (e) => /* @__PURE__ */ M.jsx(Fnt, { ...e }), Hnt = ({
  output: e,
  currentAnswer: t,
  answers: n,
  aggregateAnswers: r
}) => {
  const i = hy(e.value, { currentAnswer: t, answers: n, aggregateAnswers: r });
  return /* @__PURE__ */ M.jsxs(Ud, { style: e.style, children: [
    /* @__PURE__ */ M.jsx("div", { children: e.header }),
    /* @__PURE__ */ M.jsx(Unt, { children: i }),
    /* @__PURE__ */ M.jsx("div", { children: e.text })
  ] });
}, Unt = Ce.div`
  font-size: 5rem;
`, Wnt = ({
  output: e,
  currentAnswer: t,
  answers: n,
  aggregateAnswers: r
}) => {
  const i = hy(e.content, { currentAnswer: t, answers: n, aggregateAnswers: r });
  return /* @__PURE__ */ M.jsx(Ud, { style: e.style, children: i });
}, qnt = ({
  output: e,
  currentAnswer: t,
  answers: n,
  settings: r,
  aggregateAnswers: i
}) => {
  var g, m, v;
  const o = hy(e.data, { currentAnswer: t, answers: n, aggregateAnswers: i }), a = o == null ? void 0 : o.map((y) => y.label), s = [];
  o == null || o.forEach((y) => {
    Wn.isUndefined(y.scatter) || s.push(...y.scatter);
  });
  const c = Dn(e.legendOptions, { currentAnswer: t, answers: n, aggregateAnswers: i }) ?? {}, l = Dn(e.chartOptions, { currentAnswer: t, answers: n, aggregateAnswers: i }) ?? {}, u = P3(r, { colours: l.colours }), d = {
    theme: u,
    containerComponent: /* @__PURE__ */ M.jsx(ko, { style: { touchAction: "auto" } }),
    ...l
  }, f = {
    theme: u,
    orientation: c.orientation,
    x: Knt(c.position, d.width || ((g = u.chart) == null ? void 0 : g.width)),
    y: Ynt(c.position, d.height || ((m = u.chart) == null ? void 0 : m.height)),
    data: ((v = Dn(c.labels, {
      currentAnswer: t,
      answers: n,
      aggregateAnswers: i
    })) == null ? void 0 : v.map((y) => ({ name: y.text }))) ?? (a == null ? void 0 : a.map((y) => ({ name: y })))
  }, h = {
    label: e.xLabel,
    ...Dn(e.xAxisOptions, { currentAnswer: t, answers: n, aggregateAnswers: i })
  }, p = Dn(e.yAxisOptions, {
    currentAnswer: t,
    answers: n,
    aggregateAnswers: i
  });
  return /* @__PURE__ */ M.jsxs(Ud, { style: { alignItems: "center" }, children: [
    e.title ? /* @__PURE__ */ M.jsx(Gnt, { children: e.title }) : void 0,
    /* @__PURE__ */ M.jsx("div", { children: /* @__PURE__ */ M.jsxs(Qg, { ...d, children: [
      o && o.map((y, S) => {
        var _, w;
        return /* @__PURE__ */ M.jsx(
          Wtt,
          {
            data: y.dataset,
            interpolation: y.interpolation,
            style: {
              data: {
                stroke: (_ = u.line) != null && _.colorScale ? (w = u.line) == null ? void 0 : w.colorScale[S] : void 0
              }
            }
          },
          S
        );
      }),
      /* @__PURE__ */ M.jsx(kre, { data: s }),
      o && o.length > 1 && /* @__PURE__ */ M.jsx(Cw, { centerTitle: !0, theme: u, ...f }),
      /* @__PURE__ */ M.jsx(ds, { ...h }),
      /* @__PURE__ */ M.jsx(
        ds,
        {
          dependentAxis: !0,
          label: e.yLabel,
          axisLabelComponent: /* @__PURE__ */ M.jsx(qi, { dy: -((p == null ? void 0 : p.shiftLabel) ?? 0) }),
          domain: (p == null ? void 0 : p.min) !== void 0 || (p == null ? void 0 : p.max) !== void 0 ? [p.min ?? 0, p.max ?? 1] : void 0
        }
      )
    ] }) })
  ] });
}, Gnt = Ce.div`
  display: flex;
  justify-content: center;
`;
function Knt(e, t) {
  if (!(e === void 0 || t === void 0) && typeof e != "string")
    return (e == null ? void 0 : e.x) * t;
}
function Ynt(e, t) {
  if (!(e === void 0 || t === void 0) && typeof e != "string")
    return (e == null ? void 0 : e.y) * t;
}
const Xnt = (e) => /* @__PURE__ */ M.jsx(qnt, { ...e }), Qnt = ({
  output: e,
  currentAnswer: t,
  answers: n,
  settings: r,
  aggregateAnswers: i
}) => {
  var y, S;
  const { loggingService: o } = St(ir), a = hy(e.data, { currentAnswer: t, answers: n, aggregateAnswers: i }), s = Dn(e.legendOptions, { currentAnswer: t, answers: n, aggregateAnswers: i }) ?? {}, c = Dn(e.chartOptions, { currentAnswer: t, answers: n, aggregateAnswers: i }) ?? {}, l = P3(r, { colours: c.colours });
  o.debug("data", a);
  const u = {
    theme: l,
    containerComponent: /* @__PURE__ */ M.jsx(ko, { style: { touchAction: "auto" } }),
    ...c
  }, d = Dn(s.labels, {
    currentAnswer: t,
    answers: n,
    aggregateAnswers: i
  }), f = d ? d.map((_) => ({ name: _.text })) : a == null ? void 0 : a.map(({ label: _ }) => ({ name: _ })), h = (d == null ? void 0 : d.filter((_) => _.icon !== void 0)) ?? [], p = h.length > 0;
  class g extends D.Component {
    render() {
      const w = this.props, { x: T, y: x } = w, C = w.index, E = h[C].icon;
      if (T === void 0 || x === void 0 || E === void 0) {
        o.error("Error: x or y or icon is undefined. It was not passed to CustomComponent");
        return;
      }
      const R = E.component, A = E.size, O = T - A / 2, $ = x - A / 2;
      return /* @__PURE__ */ M.jsx(R, { x: O, y: $, width: A, height: A });
    }
  }
  const m = {
    theme: l,
    orientation: s.orientation,
    x: Jnt(s.position, c.width || ((y = l.chart) == null ? void 0 : y.width)),
    y: Znt(s.position, c.height || ((S = l.chart) == null ? void 0 : S.height)),
    data: f,
    height: s.height,
    width: s.width,
    dataComponent: p ? /* @__PURE__ */ M.jsx(g, {}) : void 0
  }, v = e.showTooltips ? /* @__PURE__ */ M.jsx(rg, { active: e.tooltipsOpen }) : void 0;
  return /* @__PURE__ */ M.jsxs(Ud, { style: { ...e.style, alignItems: "center" }, children: [
    e.title && /* @__PURE__ */ M.jsx(ert, { children: e.title }),
    /* @__PURE__ */ M.jsx(trt, { children: a && /* @__PURE__ */ M.jsxs(Qg, { ...u, children: [
      /* @__PURE__ */ M.jsx(ds, { style: { axis: { visibility: "hidden" } }, tickFormat: () => "" }),
      /* @__PURE__ */ M.jsx(
        ds,
        {
          dependentAxis: !0,
          style: { axis: { visibility: "hidden" } },
          tickFormat: () => ""
        }
      ),
      /* @__PURE__ */ M.jsx(
        Mre,
        {
          data: a.map((_, w) => ({
            x: _.label,
            y: _.value
          })),
          labels: ({ datum: _ }) => e.labels ? e.labels({ label: _.x, value: _.y }) : _.x,
          labelComponent: v
        }
      ),
      /* @__PURE__ */ M.jsx(Cw, { ...m })
    ] }) })
  ] });
};
function Jnt(e, t) {
  if (!(e === void 0 || t === void 0) && typeof e != "string")
    return (e == null ? void 0 : e.x) * t;
}
function Znt(e, t) {
  if (!(e === void 0 || t === void 0) && typeof e != "string")
    return (e == null ? void 0 : e.y) * t;
}
const ert = Ce.div`
  display: flex;
  justify-content: center;
`, trt = Ce.div`
  /* display: flex;
  flex: 1 1 100%; */
`, nrt = (e) => /* @__PURE__ */ M.jsx(Qnt, { ...e });
var s$ = { exports: {} };
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var RT, Z9;
function rrt() {
  if (Z9)
    return RT;
  Z9 = 1;
  var e = Object.getOwnPropertySymbols, t = Object.prototype.hasOwnProperty, n = Object.prototype.propertyIsEnumerable;
  function r(o) {
    if (o == null)
      throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(o);
  }
  function i() {
    try {
      if (!Object.assign)
        return !1;
      var o = new String("abc");
      if (o[5] = "de", Object.getOwnPropertyNames(o)[0] === "5")
        return !1;
      for (var a = {}, s = 0; s < 10; s++)
        a["_" + String.fromCharCode(s)] = s;
      var c = Object.getOwnPropertyNames(a).map(function(u) {
        return a[u];
      });
      if (c.join("") !== "0123456789")
        return !1;
      var l = {};
      return "abcdefghijklmnopqrst".split("").forEach(function(u) {
        l[u] = u;
      }), Object.keys(Object.assign({}, l)).join("") === "abcdefghijklmnopqrst";
    } catch {
      return !1;
    }
  }
  return RT = i() ? Object.assign : function(o, a) {
    for (var s, c = r(o), l, u = 1; u < arguments.length; u++) {
      s = Object(arguments[u]);
      for (var d in s)
        t.call(s, d) && (c[d] = s[d]);
      if (e) {
        l = e(s);
        for (var f = 0; f < l.length; f++)
          n.call(s, l[f]) && (c[l[f]] = s[l[f]]);
      }
    }
    return c;
  }, RT;
}
var $T, eV;
function M3() {
  if (eV)
    return $T;
  eV = 1;
  var e = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  return $T = e, $T;
}
var OT, tV;
function jre() {
  return tV || (tV = 1, OT = Function.call.bind(Object.prototype.hasOwnProperty)), OT;
}
var PT, nV;
function irt() {
  if (nV)
    return PT;
  nV = 1;
  var e = function() {
  };
  if (process.env.NODE_ENV !== "production") {
    var t = M3(), n = {}, r = jre();
    e = function(o) {
      var a = "Warning: " + o;
      typeof console < "u" && console.error(a);
      try {
        throw new Error(a);
      } catch {
      }
    };
  }
  function i(o, a, s, c, l) {
    if (process.env.NODE_ENV !== "production") {
      for (var u in o)
        if (r(o, u)) {
          var d;
          try {
            if (typeof o[u] != "function") {
              var f = Error(
                (c || "React class") + ": " + s + " type `" + u + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof o[u] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`."
              );
              throw f.name = "Invariant Violation", f;
            }
            d = o[u](a, u, c, s, null, t);
          } catch (p) {
            d = p;
          }
          if (d && !(d instanceof Error) && e(
            (c || "React class") + ": type specification of " + s + " `" + u + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof d + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."
          ), d instanceof Error && !(d.message in n)) {
            n[d.message] = !0;
            var h = l ? l() : "";
            e(
              "Failed " + s + " type: " + d.message + (h ?? "")
            );
          }
        }
    }
  }
  return i.resetWarningCache = function() {
    process.env.NODE_ENV !== "production" && (n = {});
  }, PT = i, PT;
}
var MT, rV;
function ort() {
  if (rV)
    return MT;
  rV = 1;
  var e = sO, t = rrt(), n = M3(), r = jre(), i = irt(), o = function() {
  };
  process.env.NODE_ENV !== "production" && (o = function(s) {
    var c = "Warning: " + s;
    typeof console < "u" && console.error(c);
    try {
      throw new Error(c);
    } catch {
    }
  });
  function a() {
    return null;
  }
  return MT = function(s, c) {
    var l = typeof Symbol == "function" && Symbol.iterator, u = "@@iterator";
    function d(B) {
      var U = B && (l && B[l] || B[u]);
      if (typeof U == "function")
        return U;
    }
    var f = "<<anonymous>>", h = {
      array: v("array"),
      bigint: v("bigint"),
      bool: v("boolean"),
      func: v("function"),
      number: v("number"),
      object: v("object"),
      string: v("string"),
      symbol: v("symbol"),
      any: y(),
      arrayOf: S,
      element: _(),
      elementType: w(),
      instanceOf: T,
      node: R(),
      objectOf: C,
      oneOf: x,
      oneOfType: E,
      shape: O,
      exact: $
    };
    function p(B, U) {
      return B === U ? B !== 0 || 1 / B === 1 / U : B !== B && U !== U;
    }
    function g(B, U) {
      this.message = B, this.data = U && typeof U == "object" ? U : {}, this.stack = "";
    }
    g.prototype = Error.prototype;
    function m(B) {
      if (process.env.NODE_ENV !== "production")
        var U = {}, Q = 0;
      function K(X, ie, te, J, Y, ee, Z) {
        if (J = J || f, ee = ee || te, Z !== n) {
          if (c) {
            var H = new Error(
              "Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types"
            );
            throw H.name = "Invariant Violation", H;
          } else if (process.env.NODE_ENV !== "production" && typeof console < "u") {
            var oe = J + ":" + te;
            !U[oe] && // Avoid spamming the console because they are often not actionable except for lib authors
            Q < 3 && (o(
              "You are manually calling a React.PropTypes validation function for the `" + ee + "` prop on `" + J + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."
            ), U[oe] = !0, Q++);
          }
        }
        return ie[te] == null ? X ? ie[te] === null ? new g("The " + Y + " `" + ee + "` is marked as required " + ("in `" + J + "`, but its value is `null`.")) : new g("The " + Y + " `" + ee + "` is marked as required in " + ("`" + J + "`, but its value is `undefined`.")) : null : B(ie, te, J, Y, ee);
      }
      var q = K.bind(null, !1);
      return q.isRequired = K.bind(null, !0), q;
    }
    function v(B) {
      function U(Q, K, q, X, ie, te) {
        var J = Q[K], Y = k(J);
        if (Y !== B) {
          var ee = F(J);
          return new g(
            "Invalid " + X + " `" + ie + "` of type " + ("`" + ee + "` supplied to `" + q + "`, expected ") + ("`" + B + "`."),
            { expectedType: B }
          );
        }
        return null;
      }
      return m(U);
    }
    function y() {
      return m(a);
    }
    function S(B) {
      function U(Q, K, q, X, ie) {
        if (typeof B != "function")
          return new g("Property `" + ie + "` of component `" + q + "` has invalid PropType notation inside arrayOf.");
        var te = Q[K];
        if (!Array.isArray(te)) {
          var J = k(te);
          return new g("Invalid " + X + " `" + ie + "` of type " + ("`" + J + "` supplied to `" + q + "`, expected an array."));
        }
        for (var Y = 0; Y < te.length; Y++) {
          var ee = B(te, Y, q, X, ie + "[" + Y + "]", n);
          if (ee instanceof Error)
            return ee;
        }
        return null;
      }
      return m(U);
    }
    function _() {
      function B(U, Q, K, q, X) {
        var ie = U[Q];
        if (!s(ie)) {
          var te = k(ie);
          return new g("Invalid " + q + " `" + X + "` of type " + ("`" + te + "` supplied to `" + K + "`, expected a single ReactElement."));
        }
        return null;
      }
      return m(B);
    }
    function w() {
      function B(U, Q, K, q, X) {
        var ie = U[Q];
        if (!e.isValidElementType(ie)) {
          var te = k(ie);
          return new g("Invalid " + q + " `" + X + "` of type " + ("`" + te + "` supplied to `" + K + "`, expected a single ReactElement type."));
        }
        return null;
      }
      return m(B);
    }
    function T(B) {
      function U(Q, K, q, X, ie) {
        if (!(Q[K] instanceof B)) {
          var te = B.name || f, J = j(Q[K]);
          return new g("Invalid " + X + " `" + ie + "` of type " + ("`" + J + "` supplied to `" + q + "`, expected ") + ("instance of `" + te + "`."));
        }
        return null;
      }
      return m(U);
    }
    function x(B) {
      if (!Array.isArray(B))
        return process.env.NODE_ENV !== "production" && (arguments.length > 1 ? o(
          "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])."
        ) : o("Invalid argument supplied to oneOf, expected an array.")), a;
      function U(Q, K, q, X, ie) {
        for (var te = Q[K], J = 0; J < B.length; J++)
          if (p(te, B[J]))
            return null;
        var Y = JSON.stringify(B, function(Z, H) {
          var oe = F(H);
          return oe === "symbol" ? String(H) : H;
        });
        return new g("Invalid " + X + " `" + ie + "` of value `" + String(te) + "` " + ("supplied to `" + q + "`, expected one of " + Y + "."));
      }
      return m(U);
    }
    function C(B) {
      function U(Q, K, q, X, ie) {
        if (typeof B != "function")
          return new g("Property `" + ie + "` of component `" + q + "` has invalid PropType notation inside objectOf.");
        var te = Q[K], J = k(te);
        if (J !== "object")
          return new g("Invalid " + X + " `" + ie + "` of type " + ("`" + J + "` supplied to `" + q + "`, expected an object."));
        for (var Y in te)
          if (r(te, Y)) {
            var ee = B(te, Y, q, X, ie + "." + Y, n);
            if (ee instanceof Error)
              return ee;
          }
        return null;
      }
      return m(U);
    }
    function E(B) {
      if (!Array.isArray(B))
        return process.env.NODE_ENV !== "production" && o("Invalid argument supplied to oneOfType, expected an instance of array."), a;
      for (var U = 0; U < B.length; U++) {
        var Q = B[U];
        if (typeof Q != "function")
          return o(
            "Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + V(Q) + " at index " + U + "."
          ), a;
      }
      function K(q, X, ie, te, J) {
        for (var Y = [], ee = 0; ee < B.length; ee++) {
          var Z = B[ee], H = Z(q, X, ie, te, J, n);
          if (H == null)
            return null;
          H.data && r(H.data, "expectedType") && Y.push(H.data.expectedType);
        }
        var oe = Y.length > 0 ? ", expected one of type [" + Y.join(", ") + "]" : "";
        return new g("Invalid " + te + " `" + J + "` supplied to " + ("`" + ie + "`" + oe + "."));
      }
      return m(K);
    }
    function R() {
      function B(U, Q, K, q, X) {
        return N(U[Q]) ? null : new g("Invalid " + q + " `" + X + "` supplied to " + ("`" + K + "`, expected a ReactNode."));
      }
      return m(B);
    }
    function A(B, U, Q, K, q) {
      return new g(
        (B || "React class") + ": " + U + " type `" + Q + "." + K + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + q + "`."
      );
    }
    function O(B) {
      function U(Q, K, q, X, ie) {
        var te = Q[K], J = k(te);
        if (J !== "object")
          return new g("Invalid " + X + " `" + ie + "` of type `" + J + "` " + ("supplied to `" + q + "`, expected `object`."));
        for (var Y in B) {
          var ee = B[Y];
          if (typeof ee != "function")
            return A(q, X, ie, Y, F(ee));
          var Z = ee(te, Y, q, X, ie + "." + Y, n);
          if (Z)
            return Z;
        }
        return null;
      }
      return m(U);
    }
    function $(B) {
      function U(Q, K, q, X, ie) {
        var te = Q[K], J = k(te);
        if (J !== "object")
          return new g("Invalid " + X + " `" + ie + "` of type `" + J + "` " + ("supplied to `" + q + "`, expected `object`."));
        var Y = t({}, Q[K], B);
        for (var ee in Y) {
          var Z = B[ee];
          if (r(B, ee) && typeof Z != "function")
            return A(q, X, ie, ee, F(Z));
          if (!Z)
            return new g(
              "Invalid " + X + " `" + ie + "` key `" + ee + "` supplied to `" + q + "`.\nBad object: " + JSON.stringify(Q[K], null, "  ") + `
Valid keys: ` + JSON.stringify(Object.keys(B), null, "  ")
            );
          var H = Z(te, ee, q, X, ie + "." + ee, n);
          if (H)
            return H;
        }
        return null;
      }
      return m(U);
    }
    function N(B) {
      switch (typeof B) {
        case "number":
        case "string":
        case "undefined":
          return !0;
        case "boolean":
          return !B;
        case "object":
          if (Array.isArray(B))
            return B.every(N);
          if (B === null || s(B))
            return !0;
          var U = d(B);
          if (U) {
            var Q = U.call(B), K;
            if (U !== B.entries) {
              for (; !(K = Q.next()).done; )
                if (!N(K.value))
                  return !1;
            } else
              for (; !(K = Q.next()).done; ) {
                var q = K.value;
                if (q && !N(q[1]))
                  return !1;
              }
          } else
            return !1;
          return !0;
        default:
          return !1;
      }
    }
    function z(B, U) {
      return B === "symbol" ? !0 : U ? U["@@toStringTag"] === "Symbol" || typeof Symbol == "function" && U instanceof Symbol : !1;
    }
    function k(B) {
      var U = typeof B;
      return Array.isArray(B) ? "array" : B instanceof RegExp ? "object" : z(U, B) ? "symbol" : U;
    }
    function F(B) {
      if (typeof B > "u" || B === null)
        return "" + B;
      var U = k(B);
      if (U === "object") {
        if (B instanceof Date)
          return "date";
        if (B instanceof RegExp)
          return "regexp";
      }
      return U;
    }
    function V(B) {
      var U = F(B);
      switch (U) {
        case "array":
        case "object":
          return "an " + U;
        case "boolean":
        case "date":
        case "regexp":
          return "a " + U;
        default:
          return U;
      }
    }
    function j(B) {
      return !B.constructor || !B.constructor.name ? f : B.constructor.name;
    }
    return h.checkPropTypes = i, h.resetWarningCache = i.resetWarningCache, h.PropTypes = h, h;
  }, MT;
}
var kT, iV;
function art() {
  if (iV)
    return kT;
  iV = 1;
  var e = M3();
  function t() {
  }
  function n() {
  }
  return n.resetWarningCache = t, kT = function() {
    function r(a, s, c, l, u, d) {
      if (d !== e) {
        var f = new Error(
          "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types"
        );
        throw f.name = "Invariant Violation", f;
      }
    }
    r.isRequired = r;
    function i() {
      return r;
    }
    var o = {
      array: r,
      bigint: r,
      bool: r,
      func: r,
      number: r,
      object: r,
      string: r,
      symbol: r,
      any: r,
      arrayOf: i,
      element: r,
      elementType: r,
      instanceOf: i,
      node: r,
      objectOf: i,
      oneOf: i,
      oneOfType: i,
      shape: i,
      exact: i,
      checkPropTypes: n,
      resetWarningCache: t
    };
    return o.PropTypes = o, o;
  }, kT;
}
if (process.env.NODE_ENV !== "production") {
  var srt = sO, crt = !0;
  s$.exports = ort()(srt.isElement, crt);
} else
  s$.exports = art()();
var lrt = s$.exports;
const me = /* @__PURE__ */ pn(lrt);
var k3 = Dy(), on = (e) => Ny(e, k3), N3 = Dy();
on.write = (e) => Ny(e, N3);
var rC = Dy();
on.onStart = (e) => Ny(e, rC);
var D3 = Dy();
on.onFrame = (e) => Ny(e, D3);
var L3 = Dy();
on.onFinish = (e) => Ny(e, L3);
var og = [];
on.setTimeout = (e, t) => {
  const n = on.now() + t, r = () => {
    const o = og.findIndex((a) => a.cancel == r);
    ~o && og.splice(o, 1), Zl -= ~o ? 1 : 0;
  }, i = { time: n, handler: e, cancel: r };
  return og.splice(Fre(n), 0, i), Zl += 1, Vre(), i;
};
var Fre = (e) => ~(~og.findIndex((t) => t.time > e) || ~og.length);
on.cancel = (e) => {
  rC.delete(e), D3.delete(e), L3.delete(e), k3.delete(e), N3.delete(e);
};
on.sync = (e) => {
  c$ = !0, on.batchedUpdates(e), c$ = !1;
};
on.throttle = (e) => {
  let t;
  function n() {
    try {
      e(...t);
    } finally {
      t = null;
    }
  }
  function r(...i) {
    t = i, on.onStart(n);
  }
  return r.handler = e, r.cancel = () => {
    rC.delete(n), t = null;
  }, r;
};
var j3 = typeof window < "u" ? window.requestAnimationFrame : (
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  () => {
  }
);
on.use = (e) => j3 = e;
on.now = typeof performance < "u" ? () => performance.now() : Date.now;
on.batchedUpdates = (e) => e();
on.catch = console.error;
on.frameLoop = "always";
on.advance = () => {
  on.frameLoop !== "demand" ? console.warn(
    "Cannot call the manual advancement of rafz whilst frameLoop is not set as demand"
  ) : zre();
};
var Jl = -1, Zl = 0, c$ = !1;
function Ny(e, t) {
  c$ ? (t.delete(e), e(0)) : (t.add(e), Vre());
}
function Vre() {
  Jl < 0 && (Jl = 0, on.frameLoop !== "demand" && j3(Bre));
}
function urt() {
  Jl = -1;
}
function Bre() {
  ~Jl && (j3(Bre), on.batchedUpdates(zre));
}
function zre() {
  const e = Jl;
  Jl = on.now();
  const t = Fre(Jl);
  if (t && (Hre(og.splice(0, t), (n) => n.handler()), Zl -= t), !Zl) {
    urt();
    return;
  }
  rC.flush(), k3.flush(e ? Math.min(64, Jl - e) : 16.667), D3.flush(), N3.flush(), L3.flush();
}
function Dy() {
  let e = /* @__PURE__ */ new Set(), t = e;
  return {
    add(n) {
      Zl += t == e && !e.has(n) ? 1 : 0, e.add(n);
    },
    delete(n) {
      return Zl -= t == e && e.has(n) ? 1 : 0, e.delete(n);
    },
    flush(n) {
      t.size && (e = /* @__PURE__ */ new Set(), Zl -= t.size, Hre(t, (r) => r(n) && e.add(r)), Zl += e.size, t = e);
    }
  };
}
function Hre(e, t) {
  e.forEach((n) => {
    try {
      t(n);
    } catch (r) {
      on.catch(r);
    }
  });
}
var drt = Object.defineProperty, frt = (e, t) => {
  for (var n in t)
    drt(e, n, { get: t[n], enumerable: !0 });
}, Cs = {};
frt(Cs, {
  assign: () => grt,
  colors: () => du,
  createStringInterpolator: () => V3,
  skipAnimation: () => Wre,
  to: () => Ure,
  willAdvance: () => B3
});
function l$() {
}
var hrt = (e, t, n) => Object.defineProperty(e, t, { value: n, writable: !0, configurable: !0 }), je = {
  arr: Array.isArray,
  obj: (e) => !!e && e.constructor.name === "Object",
  fun: (e) => typeof e == "function",
  str: (e) => typeof e == "string",
  num: (e) => typeof e == "number",
  und: (e) => e === void 0
};
function Fc(e, t) {
  if (je.arr(e)) {
    if (!je.arr(t) || e.length !== t.length)
      return !1;
    for (let n = 0; n < e.length; n++)
      if (e[n] !== t[n])
        return !1;
    return !0;
  }
  return e === t;
}
var Kt = (e, t) => e.forEach(t);
function mc(e, t, n) {
  if (je.arr(e)) {
    for (let r = 0; r < e.length; r++)
      t.call(n, e[r], `${r}`);
    return;
  }
  for (const r in e)
    e.hasOwnProperty(r) && t.call(n, e[r], r);
}
var $o = (e) => je.und(e) ? [] : je.arr(e) ? e : [e];
function E0(e, t) {
  if (e.size) {
    const n = Array.from(e);
    e.clear(), Kt(n, t);
  }
}
var Xm = (e, ...t) => E0(e, (n) => n(...t)), F3 = () => typeof window > "u" || !window.navigator || /ServerSideRendering|^Deno\//.test(window.navigator.userAgent), V3, Ure, du = null, Wre = !1, B3 = l$, grt = (e) => {
  e.to && (Ure = e.to), e.now && (on.now = e.now), e.colors !== void 0 && (du = e.colors), e.skipAnimation != null && (Wre = e.skipAnimation), e.createStringInterpolator && (V3 = e.createStringInterpolator), e.requestAnimationFrame && on.use(e.requestAnimationFrame), e.batchedUpdates && (on.batchedUpdates = e.batchedUpdates), e.willAdvance && (B3 = e.willAdvance), e.frameLoop && (on.frameLoop = e.frameLoop);
}, C0 = /* @__PURE__ */ new Set(), La = [], NT = [], Tw = 0, iC = {
  get idle() {
    return !C0.size && !La.length;
  },
  /** Advance the given animation on every frame until idle. */
  start(e) {
    Tw > e.priority ? (C0.add(e), on.onStart(prt)) : (qre(e), on(u$));
  },
  /** Advance all animations by the given time. */
  advance: u$,
  /** Call this when an animation's priority changes. */
  sort(e) {
    if (Tw)
      on.onFrame(() => iC.sort(e));
    else {
      const t = La.indexOf(e);
      ~t && (La.splice(t, 1), Gre(e));
    }
  },
  /**
   * Clear all animations. For testing purposes.
   *
   * ☠️ Never call this from within the frameloop.
   */
  clear() {
    La = [], C0.clear();
  }
};
function prt() {
  C0.forEach(qre), C0.clear(), on(u$);
}
function qre(e) {
  La.includes(e) || Gre(e);
}
function Gre(e) {
  La.splice(
    mrt(La, (t) => t.priority > e.priority),
    0,
    e
  );
}
function u$(e) {
  const t = NT;
  for (let n = 0; n < La.length; n++) {
    const r = La[n];
    Tw = r.priority, r.idle || (B3(r), r.advance(e), r.idle || t.push(r));
  }
  return Tw = 0, NT = La, NT.length = 0, La = t, La.length > 0;
}
function mrt(e, t) {
  const n = e.findIndex(t);
  return n < 0 ? e.length : n;
}
var vrt = (e, t, n) => Math.min(Math.max(n, e), t), yrt = {
  transparent: 0,
  aliceblue: 4042850303,
  antiquewhite: 4209760255,
  aqua: 16777215,
  aquamarine: 2147472639,
  azure: 4043309055,
  beige: 4126530815,
  bisque: 4293182719,
  black: 255,
  blanchedalmond: 4293643775,
  blue: 65535,
  blueviolet: 2318131967,
  brown: 2771004159,
  burlywood: 3736635391,
  burntsienna: 3934150143,
  cadetblue: 1604231423,
  chartreuse: 2147418367,
  chocolate: 3530104575,
  coral: 4286533887,
  cornflowerblue: 1687547391,
  cornsilk: 4294499583,
  crimson: 3692313855,
  cyan: 16777215,
  darkblue: 35839,
  darkcyan: 9145343,
  darkgoldenrod: 3095792639,
  darkgray: 2846468607,
  darkgreen: 6553855,
  darkgrey: 2846468607,
  darkkhaki: 3182914559,
  darkmagenta: 2332068863,
  darkolivegreen: 1433087999,
  darkorange: 4287365375,
  darkorchid: 2570243327,
  darkred: 2332033279,
  darksalmon: 3918953215,
  darkseagreen: 2411499519,
  darkslateblue: 1211993087,
  darkslategray: 793726975,
  darkslategrey: 793726975,
  darkturquoise: 13554175,
  darkviolet: 2483082239,
  deeppink: 4279538687,
  deepskyblue: 12582911,
  dimgray: 1768516095,
  dimgrey: 1768516095,
  dodgerblue: 512819199,
  firebrick: 2988581631,
  floralwhite: 4294635775,
  forestgreen: 579543807,
  fuchsia: 4278255615,
  gainsboro: 3705462015,
  ghostwhite: 4177068031,
  gold: 4292280575,
  goldenrod: 3668254975,
  gray: 2155905279,
  green: 8388863,
  greenyellow: 2919182335,
  grey: 2155905279,
  honeydew: 4043305215,
  hotpink: 4285117695,
  indianred: 3445382399,
  indigo: 1258324735,
  ivory: 4294963455,
  khaki: 4041641215,
  lavender: 3873897215,
  lavenderblush: 4293981695,
  lawngreen: 2096890111,
  lemonchiffon: 4294626815,
  lightblue: 2916673279,
  lightcoral: 4034953471,
  lightcyan: 3774873599,
  lightgoldenrodyellow: 4210742015,
  lightgray: 3553874943,
  lightgreen: 2431553791,
  lightgrey: 3553874943,
  lightpink: 4290167295,
  lightsalmon: 4288707327,
  lightseagreen: 548580095,
  lightskyblue: 2278488831,
  lightslategray: 2005441023,
  lightslategrey: 2005441023,
  lightsteelblue: 2965692159,
  lightyellow: 4294959359,
  lime: 16711935,
  limegreen: 852308735,
  linen: 4210091775,
  magenta: 4278255615,
  maroon: 2147483903,
  mediumaquamarine: 1724754687,
  mediumblue: 52735,
  mediumorchid: 3126187007,
  mediumpurple: 2473647103,
  mediumseagreen: 1018393087,
  mediumslateblue: 2070474495,
  mediumspringgreen: 16423679,
  mediumturquoise: 1221709055,
  mediumvioletred: 3340076543,
  midnightblue: 421097727,
  mintcream: 4127193855,
  mistyrose: 4293190143,
  moccasin: 4293178879,
  navajowhite: 4292783615,
  navy: 33023,
  oldlace: 4260751103,
  olive: 2155872511,
  olivedrab: 1804477439,
  orange: 4289003775,
  orangered: 4282712319,
  orchid: 3664828159,
  palegoldenrod: 4008225535,
  palegreen: 2566625535,
  paleturquoise: 2951671551,
  palevioletred: 3681588223,
  papayawhip: 4293907967,
  peachpuff: 4292524543,
  peru: 3448061951,
  pink: 4290825215,
  plum: 3718307327,
  powderblue: 2967529215,
  purple: 2147516671,
  rebeccapurple: 1714657791,
  red: 4278190335,
  rosybrown: 3163525119,
  royalblue: 1097458175,
  saddlebrown: 2336560127,
  salmon: 4202722047,
  sandybrown: 4104413439,
  seagreen: 780883967,
  seashell: 4294307583,
  sienna: 2689740287,
  silver: 3233857791,
  skyblue: 2278484991,
  slateblue: 1784335871,
  slategray: 1887473919,
  slategrey: 1887473919,
  snow: 4294638335,
  springgreen: 16744447,
  steelblue: 1182971135,
  tan: 3535047935,
  teal: 8421631,
  thistle: 3636451583,
  tomato: 4284696575,
  turquoise: 1088475391,
  violet: 4001558271,
  wheat: 4125012991,
  white: 4294967295,
  whitesmoke: 4126537215,
  yellow: 4294902015,
  yellowgreen: 2597139199
}, fs = "[-+]?\\d*\\.?\\d+", Iw = fs + "%";
function oC(...e) {
  return "\\(\\s*(" + e.join(")\\s*,\\s*(") + ")\\s*\\)";
}
var brt = new RegExp("rgb" + oC(fs, fs, fs)), _rt = new RegExp("rgba" + oC(fs, fs, fs, fs)), Srt = new RegExp("hsl" + oC(fs, Iw, Iw)), wrt = new RegExp(
  "hsla" + oC(fs, Iw, Iw, fs)
), xrt = /^#([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/, Ert = /^#([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/, Crt = /^#([0-9a-fA-F]{6})$/, Trt = /^#([0-9a-fA-F]{8})$/;
function Irt(e) {
  let t;
  return typeof e == "number" ? e >>> 0 === e && e >= 0 && e <= 4294967295 ? e : null : (t = Crt.exec(e)) ? parseInt(t[1] + "ff", 16) >>> 0 : du && du[e] !== void 0 ? du[e] : (t = brt.exec(e)) ? (dh(t[1]) << 24 | // r
  dh(t[2]) << 16 | // g
  dh(t[3]) << 8 | // b
  255) >>> // a
  0 : (t = _rt.exec(e)) ? (dh(t[1]) << 24 | // r
  dh(t[2]) << 16 | // g
  dh(t[3]) << 8 | // b
  sV(t[4])) >>> // a
  0 : (t = xrt.exec(e)) ? parseInt(
    t[1] + t[1] + // r
    t[2] + t[2] + // g
    t[3] + t[3] + // b
    "ff",
    // a
    16
  ) >>> 0 : (t = Trt.exec(e)) ? parseInt(t[1], 16) >>> 0 : (t = Ert.exec(e)) ? parseInt(
    t[1] + t[1] + // r
    t[2] + t[2] + // g
    t[3] + t[3] + // b
    t[4] + t[4],
    // a
    16
  ) >>> 0 : (t = Srt.exec(e)) ? (oV(
    aV(t[1]),
    // h
    s1(t[2]),
    // s
    s1(t[3])
    // l
  ) | 255) >>> // a
  0 : (t = wrt.exec(e)) ? (oV(
    aV(t[1]),
    // h
    s1(t[2]),
    // s
    s1(t[3])
    // l
  ) | sV(t[4])) >>> // a
  0 : null;
}
function DT(e, t, n) {
  return n < 0 && (n += 1), n > 1 && (n -= 1), n < 1 / 6 ? e + (t - e) * 6 * n : n < 1 / 2 ? t : n < 2 / 3 ? e + (t - e) * (2 / 3 - n) * 6 : e;
}
function oV(e, t, n) {
  const r = n < 0.5 ? n * (1 + t) : n + t - n * t, i = 2 * n - r, o = DT(i, r, e + 1 / 3), a = DT(i, r, e), s = DT(i, r, e - 1 / 3);
  return Math.round(o * 255) << 24 | Math.round(a * 255) << 16 | Math.round(s * 255) << 8;
}
function dh(e) {
  const t = parseInt(e, 10);
  return t < 0 ? 0 : t > 255 ? 255 : t;
}
function aV(e) {
  return (parseFloat(e) % 360 + 360) % 360 / 360;
}
function sV(e) {
  const t = parseFloat(e);
  return t < 0 ? 0 : t > 1 ? 255 : Math.round(t * 255);
}
function s1(e) {
  const t = parseFloat(e);
  return t < 0 ? 0 : t > 100 ? 1 : t / 100;
}
function cV(e) {
  let t = Irt(e);
  if (t === null)
    return e;
  t = t || 0;
  const n = (t & 4278190080) >>> 24, r = (t & 16711680) >>> 16, i = (t & 65280) >>> 8, o = (t & 255) / 255;
  return `rgba(${n}, ${r}, ${i}, ${o})`;
}
var Cv = (e, t, n) => {
  if (je.fun(e))
    return e;
  if (je.arr(e))
    return Cv({
      range: e,
      output: t,
      extrapolate: n
    });
  if (je.str(e.output[0]))
    return V3(e);
  const r = e, i = r.output, o = r.range || [0, 1], a = r.extrapolateLeft || r.extrapolate || "extend", s = r.extrapolateRight || r.extrapolate || "extend", c = r.easing || ((l) => l);
  return (l) => {
    const u = Rrt(l, o);
    return Art(
      l,
      o[u],
      o[u + 1],
      i[u],
      i[u + 1],
      c,
      a,
      s,
      r.map
    );
  };
};
function Art(e, t, n, r, i, o, a, s, c) {
  let l = c ? c(e) : e;
  if (l < t) {
    if (a === "identity")
      return l;
    a === "clamp" && (l = t);
  }
  if (l > n) {
    if (s === "identity")
      return l;
    s === "clamp" && (l = n);
  }
  return r === i ? r : t === n ? e <= t ? r : i : (t === -1 / 0 ? l = -l : n === 1 / 0 ? l = l - t : l = (l - t) / (n - t), l = o(l), r === -1 / 0 ? l = -l : i === 1 / 0 ? l = l + r : l = l * (i - r) + r, l);
}
function Rrt(e, t) {
  for (var n = 1; n < t.length - 1 && !(t[n] >= e); ++n)
    ;
  return n - 1;
}
var $rt = (e, t = "end") => (n) => {
  n = t === "end" ? Math.min(n, 0.999) : Math.max(n, 1e-3);
  const r = n * e, i = t === "end" ? Math.floor(r) : Math.ceil(r);
  return vrt(0, 1, i / e);
}, Aw = 1.70158, c1 = Aw * 1.525, lV = Aw + 1, uV = 2 * Math.PI / 3, dV = 2 * Math.PI / 4.5, l1 = (e) => e < 1 / 2.75 ? 7.5625 * e * e : e < 2 / 2.75 ? 7.5625 * (e -= 1.5 / 2.75) * e + 0.75 : e < 2.5 / 2.75 ? 7.5625 * (e -= 2.25 / 2.75) * e + 0.9375 : 7.5625 * (e -= 2.625 / 2.75) * e + 0.984375, Ort = {
  linear: (e) => e,
  easeInQuad: (e) => e * e,
  easeOutQuad: (e) => 1 - (1 - e) * (1 - e),
  easeInOutQuad: (e) => e < 0.5 ? 2 * e * e : 1 - Math.pow(-2 * e + 2, 2) / 2,
  easeInCubic: (e) => e * e * e,
  easeOutCubic: (e) => 1 - Math.pow(1 - e, 3),
  easeInOutCubic: (e) => e < 0.5 ? 4 * e * e * e : 1 - Math.pow(-2 * e + 2, 3) / 2,
  easeInQuart: (e) => e * e * e * e,
  easeOutQuart: (e) => 1 - Math.pow(1 - e, 4),
  easeInOutQuart: (e) => e < 0.5 ? 8 * e * e * e * e : 1 - Math.pow(-2 * e + 2, 4) / 2,
  easeInQuint: (e) => e * e * e * e * e,
  easeOutQuint: (e) => 1 - Math.pow(1 - e, 5),
  easeInOutQuint: (e) => e < 0.5 ? 16 * e * e * e * e * e : 1 - Math.pow(-2 * e + 2, 5) / 2,
  easeInSine: (e) => 1 - Math.cos(e * Math.PI / 2),
  easeOutSine: (e) => Math.sin(e * Math.PI / 2),
  easeInOutSine: (e) => -(Math.cos(Math.PI * e) - 1) / 2,
  easeInExpo: (e) => e === 0 ? 0 : Math.pow(2, 10 * e - 10),
  easeOutExpo: (e) => e === 1 ? 1 : 1 - Math.pow(2, -10 * e),
  easeInOutExpo: (e) => e === 0 ? 0 : e === 1 ? 1 : e < 0.5 ? Math.pow(2, 20 * e - 10) / 2 : (2 - Math.pow(2, -20 * e + 10)) / 2,
  easeInCirc: (e) => 1 - Math.sqrt(1 - Math.pow(e, 2)),
  easeOutCirc: (e) => Math.sqrt(1 - Math.pow(e - 1, 2)),
  easeInOutCirc: (e) => e < 0.5 ? (1 - Math.sqrt(1 - Math.pow(2 * e, 2))) / 2 : (Math.sqrt(1 - Math.pow(-2 * e + 2, 2)) + 1) / 2,
  easeInBack: (e) => lV * e * e * e - Aw * e * e,
  easeOutBack: (e) => 1 + lV * Math.pow(e - 1, 3) + Aw * Math.pow(e - 1, 2),
  easeInOutBack: (e) => e < 0.5 ? Math.pow(2 * e, 2) * ((c1 + 1) * 2 * e - c1) / 2 : (Math.pow(2 * e - 2, 2) * ((c1 + 1) * (e * 2 - 2) + c1) + 2) / 2,
  easeInElastic: (e) => e === 0 ? 0 : e === 1 ? 1 : -Math.pow(2, 10 * e - 10) * Math.sin((e * 10 - 10.75) * uV),
  easeOutElastic: (e) => e === 0 ? 0 : e === 1 ? 1 : Math.pow(2, -10 * e) * Math.sin((e * 10 - 0.75) * uV) + 1,
  easeInOutElastic: (e) => e === 0 ? 0 : e === 1 ? 1 : e < 0.5 ? -(Math.pow(2, 20 * e - 10) * Math.sin((20 * e - 11.125) * dV)) / 2 : Math.pow(2, -20 * e + 10) * Math.sin((20 * e - 11.125) * dV) / 2 + 1,
  easeInBounce: (e) => 1 - l1(1 - e),
  easeOutBounce: l1,
  easeInOutBounce: (e) => e < 0.5 ? (1 - l1(1 - 2 * e)) / 2 : (1 + l1(2 * e - 1)) / 2,
  steps: $rt
}, Tv = Symbol.for("FluidValue.get"), Jg = Symbol.for("FluidValue.observers"), Na = (e) => !!(e && e[Tv]), qo = (e) => e && e[Tv] ? e[Tv]() : e, fV = (e) => e[Jg] || null;
function Prt(e, t) {
  e.eventObserved ? e.eventObserved(t) : e(t);
}
function Iv(e, t) {
  const n = e[Jg];
  n && n.forEach((r) => {
    Prt(r, t);
  });
}
var Kre = class {
  constructor(e) {
    if (!e && !(e = this.get))
      throw Error("Unknown getter");
    Mrt(this, e);
  }
}, Mrt = (e, t) => Yre(e, Tv, t);
function Wp(e, t) {
  if (e[Tv]) {
    let n = e[Jg];
    n || Yre(e, Jg, n = /* @__PURE__ */ new Set()), n.has(t) || (n.add(t), e.observerAdded && e.observerAdded(n.size, t));
  }
  return t;
}
function Av(e, t) {
  const n = e[Jg];
  if (n && n.has(t)) {
    const r = n.size - 1;
    r ? n.delete(t) : e[Jg] = null, e.observerRemoved && e.observerRemoved(r, t);
  }
}
var Yre = (e, t, n) => Object.defineProperty(e, t, {
  value: n,
  writable: !0,
  configurable: !0
}), Y1 = /[+\-]?(?:0|[1-9]\d*)(?:\.\d*)?(?:[eE][+\-]?\d+)?/g, krt = /(#(?:[0-9a-f]{2}){2,4}|(#[0-9a-f]{3})|(rgb|hsl)a?\((-?\d+%?[,\s]+){2,3}\s*[\d\.]+%?\))/gi, hV = new RegExp(`(${Y1.source})(%|[a-z]+)`, "i"), Nrt = /rgba\(([0-9\.-]+), ([0-9\.-]+), ([0-9\.-]+), ([0-9\.-]+)\)/gi, aC = /var\((--[a-zA-Z0-9-_]+),? ?([a-zA-Z0-9 ()%#.,-]+)?\)/, Xre = (e) => {
  const [t, n] = Drt(e);
  if (!t || F3())
    return e;
  const r = window.getComputedStyle(document.documentElement).getPropertyValue(t);
  if (r)
    return r.trim();
  if (n && n.startsWith("--")) {
    const i = window.getComputedStyle(document.documentElement).getPropertyValue(n);
    return i || e;
  } else {
    if (n && aC.test(n))
      return Xre(n);
    if (n)
      return n;
  }
  return e;
}, Drt = (e) => {
  const t = aC.exec(e);
  if (!t)
    return [,];
  const [, n, r] = t;
  return [n, r];
}, LT, Lrt = (e, t, n, r, i) => `rgba(${Math.round(t)}, ${Math.round(n)}, ${Math.round(r)}, ${i})`, Qre = (e) => {
  LT || (LT = du ? (
    // match color names, ignore partial matches
    new RegExp(`(${Object.keys(du).join("|")})(?!\\w)`, "g")
  ) : (
    // never match
    /^\b$/
  ));
  const t = e.output.map((o) => qo(o).replace(aC, Xre).replace(krt, cV).replace(LT, cV)), n = t.map((o) => o.match(Y1).map(Number)), i = n[0].map(
    (o, a) => n.map((s) => {
      if (!(a in s))
        throw Error('The arity of each "output" value must be equal');
      return s[a];
    })
  ).map(
    (o) => Cv({ ...e, output: o })
  );
  return (o) => {
    var c;
    const a = !hV.test(t[0]) && ((c = t.find((l) => hV.test(l))) == null ? void 0 : c.replace(Y1, ""));
    let s = 0;
    return t[0].replace(
      Y1,
      () => `${i[s++](o)}${a || ""}`
    ).replace(Nrt, Lrt);
  };
}, z3 = "react-spring: ", Jre = (e) => {
  const t = e;
  let n = !1;
  if (typeof t != "function")
    throw new TypeError(`${z3}once requires a function parameter`);
  return (...r) => {
    n || (t(...r), n = !0);
  };
}, jrt = Jre(console.warn);
function Frt() {
  jrt(
    `${z3}The "interpolate" function is deprecated in v9 (use "to" instead)`
  );
}
var Vrt = Jre(console.warn);
function Brt() {
  Vrt(
    `${z3}Directly calling start instead of using the api object is deprecated in v9 (use ".start" instead), this will be removed in later 0.X.0 versions`
  );
}
function sC(e) {
  return je.str(e) && (e[0] == "#" || /\d/.test(e) || // Do not identify a CSS variable as an AnimatedString if its SSR
  !F3() && aC.test(e) || e in (du || {}));
}
var $d = F3() ? gt : Nv, zrt = () => {
  const e = Me(!1);
  return $d(() => (e.current = !0, () => {
    e.current = !1;
  }), []), e;
};
function H3() {
  const e = Lt()[1], t = zrt();
  return () => {
    t.current && e(Math.random());
  };
}
function Hrt(e, t) {
  const [n] = Lt(
    () => ({
      inputs: t,
      result: e()
    })
  ), r = Me(), i = r.current;
  let o = i;
  return o ? t && o.inputs && Urt(t, o.inputs) || (o = {
    inputs: t,
    result: e()
  }) : o = n, gt(() => {
    r.current = o, i == n && (n.inputs = n.result = void 0);
  }, [o]), o.result;
}
function Urt(e, t) {
  if (e.length !== t.length)
    return !1;
  for (let n = 0; n < e.length; n++)
    if (e[n] !== t[n])
      return !1;
  return !0;
}
var U3 = (e) => gt(e, Wrt), Wrt = [];
function d$(e) {
  const t = Me();
  return gt(() => {
    t.current = e;
  }), t.current;
}
var Rv = Symbol.for("Animated:node"), qrt = (e) => !!e && e[Rv] === e, Hs = (e) => e && e[Rv], W3 = (e, t) => hrt(e, Rv, t), cC = (e) => e && e[Rv] && e[Rv].getPayload(), Zre = class {
  constructor() {
    W3(this, this);
  }
  /** Get every `AnimatedValue` used by this node. */
  getPayload() {
    return this.payload || [];
  }
}, Ly = class extends Zre {
  constructor(e) {
    super(), this._value = e, this.done = !0, this.durationProgress = 0, je.num(this._value) && (this.lastPosition = this._value);
  }
  /** @internal */
  static create(e) {
    return new Ly(e);
  }
  getPayload() {
    return [this];
  }
  getValue() {
    return this._value;
  }
  setValue(e, t) {
    return je.num(e) && (this.lastPosition = e, t && (e = Math.round(e / t) * t, this.done && (this.lastPosition = e))), this._value === e ? !1 : (this._value = e, !0);
  }
  reset() {
    const { done: e } = this;
    this.done = !1, je.num(this._value) && (this.elapsedTime = 0, this.durationProgress = 0, this.lastPosition = this._value, e && (this.lastVelocity = null), this.v0 = null);
  }
}, $v = class extends Ly {
  constructor(e) {
    super(0), this._string = null, this._toString = Cv({
      output: [e, e]
    });
  }
  /** @internal */
  static create(e) {
    return new $v(e);
  }
  getValue() {
    const e = this._string;
    return e ?? (this._string = this._toString(this._value));
  }
  setValue(e) {
    if (je.str(e)) {
      if (e == this._string)
        return !1;
      this._string = e, this._value = 1;
    } else if (super.setValue(e))
      this._string = null;
    else
      return !1;
    return !0;
  }
  reset(e) {
    e && (this._toString = Cv({
      output: [this.getValue(), e]
    })), this._value = 0, super.reset();
  }
}, Rw = { dependencies: null }, lC = class extends Zre {
  constructor(e) {
    super(), this.source = e, this.setValue(e);
  }
  getValue(e) {
    const t = {};
    return mc(this.source, (n, r) => {
      qrt(n) ? t[r] = n.getValue(e) : Na(n) ? t[r] = qo(n) : e || (t[r] = n);
    }), t;
  }
  /** Replace the raw object data */
  setValue(e) {
    this.source = e, this.payload = this._makePayload(e);
  }
  reset() {
    this.payload && Kt(this.payload, (e) => e.reset());
  }
  /** Create a payload set. */
  _makePayload(e) {
    if (e) {
      const t = /* @__PURE__ */ new Set();
      return mc(e, this._addToPayload, t), Array.from(t);
    }
  }
  /** Add to a payload set. */
  _addToPayload(e) {
    Rw.dependencies && Na(e) && Rw.dependencies.add(e);
    const t = cC(e);
    t && Kt(t, (n) => this.add(n));
  }
}, eie = class extends lC {
  constructor(e) {
    super(e);
  }
  /** @internal */
  static create(e) {
    return new eie(e);
  }
  getValue() {
    return this.source.map((e) => e.getValue());
  }
  setValue(e) {
    const t = this.getPayload();
    return e.length == t.length ? t.map((n, r) => n.setValue(e[r])).some(Boolean) : (super.setValue(e.map(Grt)), !0);
  }
};
function Grt(e) {
  return (sC(e) ? $v : Ly).create(e);
}
function f$(e) {
  const t = Hs(e);
  return t ? t.constructor : je.arr(e) ? eie : sC(e) ? $v : Ly;
}
var gV = (e, t) => {
  const n = (
    // Function components must use "forwardRef" to avoid being
    // re-rendered on every animation frame.
    !je.fun(e) || e.prototype && e.prototype.isReactComponent
  );
  return ta((r, i) => {
    const o = Me(null), a = n && // eslint-disable-next-line react-hooks/rules-of-hooks
    mn(
      (p) => {
        o.current = Xrt(i, p);
      },
      [i]
    ), [s, c] = Yrt(r, t), l = H3(), u = () => {
      const p = o.current;
      if (n && !p)
        return;
      (p ? t.applyAnimatedValues(p, s.getValue(!0)) : !1) === !1 && l();
    }, d = new Krt(u, c), f = Me();
    $d(() => (f.current = d, Kt(c, (p) => Wp(p, d)), () => {
      f.current && (Kt(
        f.current.deps,
        (p) => Av(p, f.current)
      ), on.cancel(f.current.update));
    })), gt(u, []), U3(() => () => {
      const p = f.current;
      Kt(p.deps, (g) => Av(g, p));
    });
    const h = t.getComponentProps(s.getValue());
    return /* @__PURE__ */ I.createElement(e, { ...h, ref: a });
  });
}, Krt = class {
  constructor(e, t) {
    this.update = e, this.deps = t;
  }
  eventObserved(e) {
    e.type == "change" && on.write(this.update);
  }
};
function Yrt(e, t) {
  const n = /* @__PURE__ */ new Set();
  return Rw.dependencies = n, e.style && (e = {
    ...e,
    style: t.createAnimatedStyle(e.style)
  }), e = new lC(e), Rw.dependencies = null, [e, n];
}
function Xrt(e, t) {
  return e && (je.fun(e) ? e(t) : e.current = t), t;
}
var pV = Symbol.for("AnimatedComponent"), Qrt = (e, {
  applyAnimatedValues: t = () => !1,
  createAnimatedStyle: n = (i) => new lC(i),
  getComponentProps: r = (i) => i
} = {}) => {
  const i = {
    applyAnimatedValues: t,
    createAnimatedStyle: n,
    getComponentProps: r
  }, o = (a) => {
    const s = mV(a) || "Anonymous";
    return je.str(a) ? a = o[a] || (o[a] = gV(a, i)) : a = a[pV] || (a[pV] = gV(a, i)), a.displayName = `Animated(${s})`, a;
  };
  return mc(e, (a, s) => {
    je.arr(e) && (s = mV(a)), o[s] = o(a);
  }), {
    animated: o
  };
}, mV = (e) => je.str(e) ? e : e && je.str(e.displayName) ? e.displayName : je.fun(e) && e.name || null;
function Go(e, ...t) {
  return je.fun(e) ? e(...t) : e;
}
var T0 = (e, t) => e === !0 || !!(t && e && (je.fun(e) ? e(t) : $o(e).includes(t))), tie = (e, t) => je.obj(e) ? t && e[t] : e, nie = (e, t) => e.default === !0 ? e[t] : e.default ? e.default[t] : void 0, Jrt = (e) => e, uC = (e, t = Jrt) => {
  let n = Zrt;
  e.default && e.default !== !0 && (e = e.default, n = Object.keys(e));
  const r = {};
  for (const i of n) {
    const o = t(e[i], i);
    je.und(o) || (r[i] = o);
  }
  return r;
}, Zrt = [
  "config",
  "onProps",
  "onStart",
  "onChange",
  "onPause",
  "onResume",
  "onRest"
], eit = {
  config: 1,
  from: 1,
  to: 1,
  ref: 1,
  loop: 1,
  reset: 1,
  pause: 1,
  cancel: 1,
  reverse: 1,
  immediate: 1,
  default: 1,
  delay: 1,
  onProps: 1,
  onStart: 1,
  onChange: 1,
  onPause: 1,
  onResume: 1,
  onRest: 1,
  onResolve: 1,
  // Transition props
  items: 1,
  trail: 1,
  sort: 1,
  expires: 1,
  initial: 1,
  enter: 1,
  update: 1,
  leave: 1,
  children: 1,
  onDestroyed: 1,
  // Internal props
  keys: 1,
  callId: 1,
  parentId: 1
};
function tit(e) {
  const t = {};
  let n = 0;
  if (mc(e, (r, i) => {
    eit[i] || (t[i] = r, n++);
  }), n)
    return t;
}
function q3(e) {
  const t = tit(e);
  if (t) {
    const n = { to: t };
    return mc(e, (r, i) => i in t || (n[i] = r)), n;
  }
  return { ...e };
}
function Ov(e) {
  return e = qo(e), je.arr(e) ? e.map(Ov) : sC(e) ? Cs.createStringInterpolator({
    range: [0, 1],
    output: [e, e]
  })(1) : e;
}
function rie(e) {
  for (const t in e)
    return !0;
  return !1;
}
function h$(e) {
  return je.fun(e) || je.arr(e) && je.obj(e[0]);
}
function g$(e, t) {
  var n;
  (n = e.ref) == null || n.delete(e), t == null || t.delete(e);
}
function iie(e, t) {
  var n;
  t && e.ref !== t && ((n = e.ref) == null || n.delete(e), t.add(e), e.ref = t);
}
var G3 = {
  default: { tension: 170, friction: 26 },
  gentle: { tension: 120, friction: 14 },
  wobbly: { tension: 180, friction: 12 },
  stiff: { tension: 210, friction: 20 },
  slow: { tension: 280, friction: 60 },
  molasses: { tension: 280, friction: 120 }
}, p$ = {
  ...G3.default,
  mass: 1,
  damping: 1,
  easing: Ort.linear,
  clamp: !1
}, nit = class {
  constructor() {
    this.velocity = 0, Object.assign(this, p$);
  }
};
function rit(e, t, n) {
  n && (n = { ...n }, vV(n, t), t = { ...n, ...t }), vV(e, t), Object.assign(e, t);
  for (const a in p$)
    e[a] == null && (e[a] = p$[a]);
  let { frequency: r, damping: i } = e;
  const { mass: o } = e;
  return je.und(r) || (r < 0.01 && (r = 0.01), i < 0 && (i = 0), e.tension = Math.pow(2 * Math.PI / r, 2) * o, e.friction = 4 * Math.PI * i * o / r), e;
}
function vV(e, t) {
  if (!je.und(t.decay))
    e.duration = void 0;
  else {
    const n = !je.und(t.tension) || !je.und(t.friction);
    (n || !je.und(t.frequency) || !je.und(t.damping) || !je.und(t.mass)) && (e.duration = void 0, e.decay = void 0), n && (e.frequency = void 0);
  }
}
var yV = [], iit = class {
  constructor() {
    this.changed = !1, this.values = yV, this.toValues = null, this.fromValues = yV, this.config = new nit(), this.immediate = !1;
  }
};
function oie(e, { key: t, props: n, defaultProps: r, state: i, actions: o }) {
  return new Promise((a, s) => {
    let c, l, u = T0(n.cancel ?? (r == null ? void 0 : r.cancel), t);
    if (u)
      h();
    else {
      je.und(n.pause) || (i.paused = T0(n.pause, t));
      let p = r == null ? void 0 : r.pause;
      p !== !0 && (p = i.paused || T0(p, t)), c = Go(n.delay || 0, t), p ? (i.resumeQueue.add(f), o.pause()) : (o.resume(), f());
    }
    function d() {
      i.resumeQueue.add(f), i.timeouts.delete(l), l.cancel(), c = l.time - on.now();
    }
    function f() {
      c > 0 && !Cs.skipAnimation ? (i.delayed = !0, l = on.setTimeout(h, c), i.pauseQueue.add(d), i.timeouts.add(l)) : h();
    }
    function h() {
      i.delayed && (i.delayed = !1), i.pauseQueue.delete(d), i.timeouts.delete(l), e <= (i.cancelId || 0) && (u = !0);
      try {
        o.start({ ...n, callId: e, cancel: u }, a);
      } catch (p) {
        s(p);
      }
    }
  });
}
var K3 = (e, t) => t.length == 1 ? t[0] : t.some((n) => n.cancelled) ? ag(e.get()) : t.every((n) => n.noop) ? aie(e.get()) : as(
  e.get(),
  t.every((n) => n.finished)
), aie = (e) => ({
  value: e,
  noop: !0,
  finished: !0,
  cancelled: !1
}), as = (e, t, n = !1) => ({
  value: e,
  finished: t,
  cancelled: n
}), ag = (e) => ({
  value: e,
  cancelled: !0,
  finished: !1
});
function sie(e, t, n, r) {
  const { callId: i, parentId: o, onRest: a } = t, { asyncTo: s, promise: c } = n;
  return !o && e === s && !t.reset ? c : n.promise = (async () => {
    n.asyncId = i, n.asyncTo = e;
    const l = uC(
      t,
      (m, v) => (
        // The `onRest` prop is only called when the `runAsync` promise is resolved.
        v === "onRest" ? void 0 : m
      )
    );
    let u, d;
    const f = new Promise(
      (m, v) => (u = m, d = v)
    ), h = (m) => {
      const v = (
        // The `cancel` prop or `stop` method was used.
        i <= (n.cancelId || 0) && ag(r) || // The async `to` prop was replaced.
        i !== n.asyncId && as(r, !1)
      );
      if (v)
        throw m.result = v, d(m), m;
    }, p = (m, v) => {
      const y = new bV(), S = new _V();
      return (async () => {
        if (Cs.skipAnimation)
          throw Pv(n), S.result = as(r, !1), d(S), S;
        h(y);
        const _ = je.obj(m) ? { ...m } : { ...v, to: m };
        _.parentId = i, mc(l, (T, x) => {
          je.und(_[x]) && (_[x] = T);
        });
        const w = await r.start(_);
        return h(y), n.paused && await new Promise((T) => {
          n.resumeQueue.add(T);
        }), w;
      })();
    };
    let g;
    if (Cs.skipAnimation)
      return Pv(n), as(r, !1);
    try {
      let m;
      je.arr(e) ? m = (async (v) => {
        for (const y of v)
          await p(y);
      })(e) : m = Promise.resolve(e(p, r.stop.bind(r))), await Promise.all([m.then(u), f]), g = as(r.get(), !0, !1);
    } catch (m) {
      if (m instanceof bV)
        g = m.result;
      else if (m instanceof _V)
        g = m.result;
      else
        throw m;
    } finally {
      i == n.asyncId && (n.asyncId = o, n.asyncTo = o ? s : void 0, n.promise = o ? c : void 0);
    }
    return je.fun(a) && on.batchedUpdates(() => {
      a(g, r, r.item);
    }), g;
  })();
}
function Pv(e, t) {
  E0(e.timeouts, (n) => n.cancel()), e.pauseQueue.clear(), e.resumeQueue.clear(), e.asyncId = e.asyncTo = e.promise = void 0, t && (e.cancelId = t);
}
var bV = class extends Error {
  constructor() {
    super(
      "An async animation has been interrupted. You see this error because you forgot to use `await` or `.catch(...)` on its returned promise."
    );
  }
}, _V = class extends Error {
  constructor() {
    super("SkipAnimationSignal");
  }
}, m$ = (e) => e instanceof Y3, oit = 1, Y3 = class extends Kre {
  constructor() {
    super(...arguments), this.id = oit++, this._priority = 0;
  }
  get priority() {
    return this._priority;
  }
  set priority(e) {
    this._priority != e && (this._priority = e, this._onPriorityChange(e));
  }
  /** Get the current value */
  get() {
    const e = Hs(this);
    return e && e.getValue();
  }
  /** Create a spring that maps our value to another value */
  to(...e) {
    return Cs.to(this, e);
  }
  /** @deprecated Use the `to` method instead. */
  interpolate(...e) {
    return Frt(), Cs.to(this, e);
  }
  toJSON() {
    return this.get();
  }
  observerAdded(e) {
    e == 1 && this._attach();
  }
  observerRemoved(e) {
    e == 0 && this._detach();
  }
  /** Called when the first child is added. */
  _attach() {
  }
  /** Called when the last child is removed. */
  _detach() {
  }
  /** Tell our children about our new value */
  _onChange(e, t = !1) {
    Iv(this, {
      type: "change",
      parent: this,
      value: e,
      idle: t
    });
  }
  /** Tell our children about our new priority */
  _onPriorityChange(e) {
    this.idle || iC.sort(this), Iv(this, {
      type: "priority",
      parent: this,
      priority: e
    });
  }
}, yf = Symbol.for("SpringPhase"), cie = 1, v$ = 2, y$ = 4, jT = (e) => (e[yf] & cie) > 0, Il = (e) => (e[yf] & v$) > 0, wm = (e) => (e[yf] & y$) > 0, SV = (e, t) => t ? e[yf] |= v$ | cie : e[yf] &= ~v$, wV = (e, t) => t ? e[yf] |= y$ : e[yf] &= ~y$, ait = class extends Y3 {
  constructor(e, t) {
    if (super(), this.animation = new iit(), this.defaultProps = {}, this._state = {
      paused: !1,
      delayed: !1,
      pauseQueue: /* @__PURE__ */ new Set(),
      resumeQueue: /* @__PURE__ */ new Set(),
      timeouts: /* @__PURE__ */ new Set()
    }, this._pendingCalls = /* @__PURE__ */ new Set(), this._lastCallId = 0, this._lastToId = 0, this._memoizedDuration = 0, !je.und(e) || !je.und(t)) {
      const n = je.obj(e) ? { ...e } : { ...t, from: e };
      je.und(n.default) && (n.default = !0), this.start(n);
    }
  }
  /** Equals true when not advancing on each frame. */
  get idle() {
    return !(Il(this) || this._state.asyncTo) || wm(this);
  }
  get goal() {
    return qo(this.animation.to);
  }
  get velocity() {
    const e = Hs(this);
    return e instanceof Ly ? e.lastVelocity || 0 : e.getPayload().map((t) => t.lastVelocity || 0);
  }
  /**
   * When true, this value has been animated at least once.
   */
  get hasAnimated() {
    return jT(this);
  }
  /**
   * When true, this value has an unfinished animation,
   * which is either active or paused.
   */
  get isAnimating() {
    return Il(this);
  }
  /**
   * When true, all current and future animations are paused.
   */
  get isPaused() {
    return wm(this);
  }
  /**
   *
   *
   */
  get isDelayed() {
    return this._state.delayed;
  }
  /** Advance the current animation by a number of milliseconds */
  advance(e) {
    let t = !0, n = !1;
    const r = this.animation;
    let { toValues: i } = r;
    const { config: o } = r, a = cC(r.to);
    !a && Na(r.to) && (i = $o(qo(r.to))), r.values.forEach((l, u) => {
      if (l.done)
        return;
      const d = (
        // Animated strings always go from 0 to 1.
        l.constructor == $v ? 1 : a ? a[u].lastPosition : i[u]
      );
      let f = r.immediate, h = d;
      if (!f) {
        if (h = l.lastPosition, o.tension <= 0) {
          l.done = !0;
          return;
        }
        let p = l.elapsedTime += e;
        const g = r.fromValues[u], m = l.v0 != null ? l.v0 : l.v0 = je.arr(o.velocity) ? o.velocity[u] : o.velocity;
        let v;
        const y = o.precision || (g == d ? 5e-3 : Math.min(1, Math.abs(d - g) * 1e-3));
        if (je.und(o.duration))
          if (o.decay) {
            const S = o.decay === !0 ? 0.998 : o.decay, _ = Math.exp(-(1 - S) * p);
            h = g + m / (1 - S) * (1 - _), f = Math.abs(l.lastPosition - h) <= y, v = m * _;
          } else {
            v = l.lastVelocity == null ? m : l.lastVelocity;
            const S = o.restVelocity || y / 10, _ = o.clamp ? 0 : o.bounce, w = !je.und(_), T = g == d ? l.v0 > 0 : g < d;
            let x, C = !1;
            const E = 1, R = Math.ceil(e / E);
            for (let A = 0; A < R && (x = Math.abs(v) > S, !(!x && (f = Math.abs(d - h) <= y, f))); ++A) {
              w && (C = h == d || h > d == T, C && (v = -v * _, h = d));
              const O = -o.tension * 1e-6 * (h - d), $ = -o.friction * 1e-3 * v, N = (O + $) / o.mass;
              v = v + N * E, h = h + v * E;
            }
          }
        else {
          let S = 1;
          o.duration > 0 && (this._memoizedDuration !== o.duration && (this._memoizedDuration = o.duration, l.durationProgress > 0 && (l.elapsedTime = o.duration * l.durationProgress, p = l.elapsedTime += e)), S = (o.progress || 0) + p / this._memoizedDuration, S = S > 1 ? 1 : S < 0 ? 0 : S, l.durationProgress = S), h = g + o.easing(S) * (d - g), v = (h - l.lastPosition) / e, f = S == 1;
        }
        l.lastVelocity = v, Number.isNaN(h) && (console.warn("Got NaN while animating:", this), f = !0);
      }
      a && !a[u].done && (f = !1), f ? l.done = !0 : t = !1, l.setValue(h, o.round) && (n = !0);
    });
    const s = Hs(this), c = s.getValue();
    if (t) {
      const l = qo(r.to);
      (c !== l || n) && !o.decay ? (s.setValue(l), this._onChange(l)) : n && o.decay && this._onChange(c), this._stop();
    } else
      n && this._onChange(c);
  }
  /** Set the current value, while stopping the current animation */
  set(e) {
    return on.batchedUpdates(() => {
      this._stop(), this._focus(e), this._set(e);
    }), this;
  }
  /**
   * Freeze the active animation in time, as well as any updates merged
   * before `resume` is called.
   */
  pause() {
    this._update({ pause: !0 });
  }
  /** Resume the animation if paused. */
  resume() {
    this._update({ pause: !1 });
  }
  /** Skip to the end of the current animation. */
  finish() {
    if (Il(this)) {
      const { to: e, config: t } = this.animation;
      on.batchedUpdates(() => {
        this._onStart(), t.decay || this._set(e, !1), this._stop();
      });
    }
    return this;
  }
  /** Push props into the pending queue. */
  update(e) {
    return (this.queue || (this.queue = [])).push(e), this;
  }
  start(e, t) {
    let n;
    return je.und(e) ? (n = this.queue || [], this.queue = []) : n = [je.obj(e) ? e : { ...t, to: e }], Promise.all(
      n.map((r) => this._update(r))
    ).then((r) => K3(this, r));
  }
  /**
   * Stop the current animation, and cancel any delayed updates.
   *
   * Pass `true` to call `onRest` with `cancelled: true`.
   */
  stop(e) {
    const { to: t } = this.animation;
    return this._focus(this.get()), Pv(this._state, e && this._lastCallId), on.batchedUpdates(() => this._stop(t, e)), this;
  }
  /** Restart the animation. */
  reset() {
    this._update({ reset: !0 });
  }
  /** @internal */
  eventObserved(e) {
    e.type == "change" ? this._start() : e.type == "priority" && (this.priority = e.priority + 1);
  }
  /**
   * Parse the `to` and `from` range from the given `props` object.
   *
   * This also ensures the initial value is available to animated components
   * during the render phase.
   */
  _prepareNode(e) {
    const t = this.key || "";
    let { to: n, from: r } = e;
    n = je.obj(n) ? n[t] : n, (n == null || h$(n)) && (n = void 0), r = je.obj(r) ? r[t] : r, r == null && (r = void 0);
    const i = { to: n, from: r };
    return jT(this) || (e.reverse && ([n, r] = [r, n]), r = qo(r), je.und(r) ? Hs(this) || this._set(n) : this._set(r)), i;
  }
  /** Every update is processed by this method before merging. */
  _update({ ...e }, t) {
    const { key: n, defaultProps: r } = this;
    e.default && Object.assign(
      r,
      uC(
        e,
        (a, s) => /^on/.test(s) ? tie(a, n) : a
      )
    ), EV(this, e, "onProps"), Em(this, "onProps", e, this);
    const i = this._prepareNode(e);
    if (Object.isFrozen(this))
      throw Error(
        "Cannot animate a `SpringValue` object that is frozen. Did you forget to pass your component to `animated(...)` before animating its props?"
      );
    const o = this._state;
    return oie(++this._lastCallId, {
      key: n,
      props: e,
      defaultProps: r,
      state: o,
      actions: {
        pause: () => {
          wm(this) || (wV(this, !0), Xm(o.pauseQueue), Em(
            this,
            "onPause",
            as(this, xm(this, this.animation.to)),
            this
          ));
        },
        resume: () => {
          wm(this) && (wV(this, !1), Il(this) && this._resume(), Xm(o.resumeQueue), Em(
            this,
            "onResume",
            as(this, xm(this, this.animation.to)),
            this
          ));
        },
        start: this._merge.bind(this, i)
      }
    }).then((a) => {
      if (e.loop && a.finished && !(t && a.noop)) {
        const s = lie(e);
        if (s)
          return this._update(s, !0);
      }
      return a;
    });
  }
  /** Merge props into the current animation */
  _merge(e, t, n) {
    if (t.cancel)
      return this.stop(!0), n(ag(this));
    const r = !je.und(e.to), i = !je.und(e.from);
    if (r || i)
      if (t.callId > this._lastToId)
        this._lastToId = t.callId;
      else
        return n(ag(this));
    const { key: o, defaultProps: a, animation: s } = this, { to: c, from: l } = s;
    let { to: u = c, from: d = l } = e;
    i && !r && (!t.default || je.und(u)) && (u = d), t.reverse && ([u, d] = [d, u]);
    const f = !Fc(d, l);
    f && (s.from = d), d = qo(d);
    const h = !Fc(u, c);
    h && this._focus(u);
    const p = h$(t.to), { config: g } = s, { decay: m, velocity: v } = g;
    (r || i) && (g.velocity = 0), t.config && !p && rit(
      g,
      Go(t.config, o),
      // Avoid calling the same "config" prop twice.
      t.config !== a.config ? Go(a.config, o) : void 0
    );
    let y = Hs(this);
    if (!y || je.und(u))
      return n(as(this, !0));
    const S = (
      // When `reset` is undefined, the `from` prop implies `reset: true`,
      // except for declarative updates. When `reset` is defined, there
      // must exist a value to animate from.
      je.und(t.reset) ? i && !t.default : !je.und(d) && T0(t.reset, o)
    ), _ = S ? d : this.get(), w = Ov(u), T = je.num(w) || je.arr(w) || sC(w), x = !p && (!T || T0(a.immediate || t.immediate, o));
    if (h) {
      const A = f$(u);
      if (A !== y.constructor)
        if (x)
          y = this._set(w);
        else
          throw Error(
            `Cannot animate between ${y.constructor.name} and ${A.name}, as the "to" prop suggests`
          );
    }
    const C = y.constructor;
    let E = Na(u), R = !1;
    if (!E) {
      const A = S || !jT(this) && f;
      (h || A) && (R = Fc(Ov(_), w), E = !R), (!Fc(s.immediate, x) && !x || !Fc(g.decay, m) || !Fc(g.velocity, v)) && (E = !0);
    }
    if (R && Il(this) && (s.changed && !S ? E = !0 : E || this._stop(c)), !p && ((E || Na(c)) && (s.values = y.getPayload(), s.toValues = Na(u) ? null : C == $v ? [1] : $o(w)), s.immediate != x && (s.immediate = x, !x && !S && this._set(c)), E)) {
      const { onRest: A } = s;
      Kt(cit, ($) => EV(this, t, $));
      const O = as(this, xm(this, c));
      Xm(this._pendingCalls, O), this._pendingCalls.add(n), s.changed && on.batchedUpdates(() => {
        var $;
        s.changed = !S, A == null || A(O, this), S ? Go(a.onRest, O) : ($ = s.onStart) == null || $.call(s, O, this);
      });
    }
    S && this._set(_), p ? n(sie(t.to, t, this._state, this)) : E ? this._start() : Il(this) && !h ? this._pendingCalls.add(n) : n(aie(_));
  }
  /** Update the `animation.to` value, which might be a `FluidValue` */
  _focus(e) {
    const t = this.animation;
    e !== t.to && (fV(this) && this._detach(), t.to = e, fV(this) && this._attach());
  }
  _attach() {
    let e = 0;
    const { to: t } = this.animation;
    Na(t) && (Wp(t, this), m$(t) && (e = t.priority + 1)), this.priority = e;
  }
  _detach() {
    const { to: e } = this.animation;
    Na(e) && Av(e, this);
  }
  /**
   * Update the current value from outside the frameloop,
   * and return the `Animated` node.
   */
  _set(e, t = !0) {
    const n = qo(e);
    if (!je.und(n)) {
      const r = Hs(this);
      if (!r || !Fc(n, r.getValue())) {
        const i = f$(n);
        !r || r.constructor != i ? W3(this, i.create(n)) : r.setValue(n), r && on.batchedUpdates(() => {
          this._onChange(n, t);
        });
      }
    }
    return Hs(this);
  }
  _onStart() {
    const e = this.animation;
    e.changed || (e.changed = !0, Em(
      this,
      "onStart",
      as(this, xm(this, e.to)),
      this
    ));
  }
  _onChange(e, t) {
    t || (this._onStart(), Go(this.animation.onChange, e, this)), Go(this.defaultProps.onChange, e, this), super._onChange(e, t);
  }
  // This method resets the animation state (even if already animating) to
  // ensure the latest from/to range is used, and it also ensures this spring
  // is added to the frameloop.
  _start() {
    const e = this.animation;
    Hs(this).reset(qo(e.to)), e.immediate || (e.fromValues = e.values.map((t) => t.lastPosition)), Il(this) || (SV(this, !0), wm(this) || this._resume());
  }
  _resume() {
    Cs.skipAnimation ? this.finish() : iC.start(this);
  }
  /**
   * Exit the frameloop and notify `onRest` listeners.
   *
   * Always wrap `_stop` calls with `batchedUpdates`.
   */
  _stop(e, t) {
    if (Il(this)) {
      SV(this, !1);
      const n = this.animation;
      Kt(n.values, (i) => {
        i.done = !0;
      }), n.toValues && (n.onChange = n.onPause = n.onResume = void 0), Iv(this, {
        type: "idle",
        parent: this
      });
      const r = t ? ag(this.get()) : as(this.get(), xm(this, e ?? n.to));
      Xm(this._pendingCalls, r), n.changed && (n.changed = !1, Em(this, "onRest", r, this));
    }
  }
};
function xm(e, t) {
  const n = Ov(t), r = Ov(e.get());
  return Fc(r, n);
}
function lie(e, t = e.loop, n = e.to) {
  const r = Go(t);
  if (r) {
    const i = r !== !0 && q3(r), o = (i || e).reverse, a = !i || i.reset;
    return Mv({
      ...e,
      loop: t,
      // Avoid updating default props when looping.
      default: !1,
      // Never loop the `pause` prop.
      pause: void 0,
      // For the "reverse" prop to loop as expected, the "to" prop
      // must be undefined. The "reverse" prop is ignored when the
      // "to" prop is an array or function.
      to: !o || h$(n) ? n : void 0,
      // Ignore the "from" prop except on reset.
      from: a ? e.from : void 0,
      reset: a,
      // The "loop" prop can return a "useSpring" props object to
      // override any of the original props.
      ...i
    });
  }
}
function Mv(e) {
  const { to: t, from: n } = e = q3(e), r = /* @__PURE__ */ new Set();
  return je.obj(t) && xV(t, r), je.obj(n) && xV(n, r), e.keys = r.size ? Array.from(r) : null, e;
}
function sit(e) {
  const t = Mv(e);
  return je.und(t.default) && (t.default = uC(t)), t;
}
function xV(e, t) {
  mc(e, (n, r) => n != null && t.add(r));
}
var cit = [
  "onStart",
  "onRest",
  "onChange",
  "onPause",
  "onResume"
];
function EV(e, t, n) {
  e.animation[n] = t[n] !== nie(t, n) ? tie(t[n], e.key) : void 0;
}
function Em(e, t, ...n) {
  var r, i, o, a;
  (i = (r = e.animation)[t]) == null || i.call(r, ...n), (a = (o = e.defaultProps)[t]) == null || a.call(o, ...n);
}
var lit = ["onStart", "onChange", "onRest"], uit = 1, uie = class {
  constructor(e, t) {
    this.id = uit++, this.springs = {}, this.queue = [], this._lastAsyncId = 0, this._active = /* @__PURE__ */ new Set(), this._changed = /* @__PURE__ */ new Set(), this._started = !1, this._state = {
      paused: !1,
      pauseQueue: /* @__PURE__ */ new Set(),
      resumeQueue: /* @__PURE__ */ new Set(),
      timeouts: /* @__PURE__ */ new Set()
    }, this._events = {
      onStart: /* @__PURE__ */ new Map(),
      onChange: /* @__PURE__ */ new Map(),
      onRest: /* @__PURE__ */ new Map()
    }, this._onFrame = this._onFrame.bind(this), t && (this._flush = t), e && this.start({ default: !0, ...e });
  }
  /**
   * Equals `true` when no spring values are in the frameloop, and
   * no async animation is currently active.
   */
  get idle() {
    return !this._state.asyncTo && Object.values(this.springs).every((e) => e.idle && !e.isDelayed && !e.isPaused);
  }
  get item() {
    return this._item;
  }
  set item(e) {
    this._item = e;
  }
  /** Get the current values of our springs */
  get() {
    const e = {};
    return this.each((t, n) => e[n] = t.get()), e;
  }
  /** Set the current values without animating. */
  set(e) {
    for (const t in e) {
      const n = e[t];
      je.und(n) || this.springs[t].set(n);
    }
  }
  /** Push an update onto the queue of each value. */
  update(e) {
    return e && this.queue.push(Mv(e)), this;
  }
  /**
   * Start the queued animations for every spring, and resolve the returned
   * promise once all queued animations have finished or been cancelled.
   *
   * When you pass a queue (instead of nothing), that queue is used instead of
   * the queued animations added with the `update` method, which are left alone.
   */
  start(e) {
    let { queue: t } = this;
    return e ? t = $o(e).map(Mv) : this.queue = [], this._flush ? this._flush(this, t) : (pie(this, t), b$(this, t));
  }
  /** @internal */
  stop(e, t) {
    if (e !== !!e && (t = e), t) {
      const n = this.springs;
      Kt($o(t), (r) => n[r].stop(!!e));
    } else
      Pv(this._state, this._lastAsyncId), this.each((n) => n.stop(!!e));
    return this;
  }
  /** Freeze the active animation in time */
  pause(e) {
    if (je.und(e))
      this.start({ pause: !0 });
    else {
      const t = this.springs;
      Kt($o(e), (n) => t[n].pause());
    }
    return this;
  }
  /** Resume the animation if paused. */
  resume(e) {
    if (je.und(e))
      this.start({ pause: !1 });
    else {
      const t = this.springs;
      Kt($o(e), (n) => t[n].resume());
    }
    return this;
  }
  /** Call a function once per spring value */
  each(e) {
    mc(this.springs, e);
  }
  /** @internal Called at the end of every animation frame */
  _onFrame() {
    const { onStart: e, onChange: t, onRest: n } = this._events, r = this._active.size > 0, i = this._changed.size > 0;
    (r && !this._started || i && !this._started) && (this._started = !0, E0(e, ([s, c]) => {
      c.value = this.get(), s(c, this, this._item);
    }));
    const o = !r && this._started, a = i || o && n.size ? this.get() : null;
    i && t.size && E0(t, ([s, c]) => {
      c.value = a, s(c, this, this._item);
    }), o && (this._started = !1, E0(n, ([s, c]) => {
      c.value = a, s(c, this, this._item);
    }));
  }
  /** @internal */
  eventObserved(e) {
    if (e.type == "change")
      this._changed.add(e.parent), e.idle || this._active.add(e.parent);
    else if (e.type == "idle")
      this._active.delete(e.parent);
    else
      return;
    on.onFrame(this._onFrame);
  }
};
function b$(e, t) {
  return Promise.all(t.map((n) => die(e, n))).then(
    (n) => K3(e, n)
  );
}
async function die(e, t, n) {
  const { keys: r, to: i, from: o, loop: a, onRest: s, onResolve: c } = t, l = je.obj(t.default) && t.default;
  a && (t.loop = !1), i === !1 && (t.to = null), o === !1 && (t.from = null);
  const u = je.arr(i) || je.fun(i) ? i : void 0;
  u ? (t.to = void 0, t.onRest = void 0, l && (l.onRest = void 0)) : Kt(lit, (g) => {
    const m = t[g];
    if (je.fun(m)) {
      const v = e._events[g];
      t[g] = ({ finished: y, cancelled: S }) => {
        const _ = v.get(m);
        _ ? (y || (_.finished = !1), S && (_.cancelled = !0)) : v.set(m, {
          value: null,
          finished: y || !1,
          cancelled: S || !1
        });
      }, l && (l[g] = t[g]);
    }
  });
  const d = e._state;
  t.pause === !d.paused ? (d.paused = t.pause, Xm(t.pause ? d.pauseQueue : d.resumeQueue)) : d.paused && (t.pause = !0);
  const f = (r || Object.keys(e.springs)).map(
    (g) => e.springs[g].start(t)
  ), h = t.cancel === !0 || nie(t, "cancel") === !0;
  (u || h && d.asyncId) && f.push(
    oie(++e._lastAsyncId, {
      props: t,
      state: d,
      actions: {
        pause: l$,
        resume: l$,
        start(g, m) {
          h ? (Pv(d, e._lastAsyncId), m(ag(e))) : (g.onRest = s, m(
            sie(
              u,
              g,
              d,
              e
            )
          ));
        }
      }
    })
  ), d.paused && await new Promise((g) => {
    d.resumeQueue.add(g);
  });
  const p = K3(e, await Promise.all(f));
  if (a && p.finished && !(n && p.noop)) {
    const g = lie(t, a, i);
    if (g)
      return pie(e, [g]), die(e, g, !0);
  }
  return c && on.batchedUpdates(() => c(p, e, e.item)), p;
}
function _$(e, t) {
  const n = { ...e.springs };
  return t && Kt($o(t), (r) => {
    je.und(r.keys) && (r = Mv(r)), je.obj(r.to) || (r = { ...r, to: void 0 }), gie(n, r, (i) => hie(i));
  }), fie(e, n), n;
}
function fie(e, t) {
  mc(t, (n, r) => {
    e.springs[r] || (e.springs[r] = n, Wp(n, e));
  });
}
function hie(e, t) {
  const n = new ait();
  return n.key = e, t && Wp(n, t), n;
}
function gie(e, t, n) {
  t.keys && Kt(t.keys, (r) => {
    (e[r] || (e[r] = n(r)))._prepareNode(t);
  });
}
function pie(e, t) {
  Kt(t, (n) => {
    gie(e.springs, n, (r) => hie(r, e));
  });
}
var jy = ({
  children: e,
  ...t
}) => {
  const n = St($w), r = t.pause || !!n.pause, i = t.immediate || !!n.immediate;
  t = Hrt(() => ({ pause: r, immediate: i }), [r, i]);
  const { Provider: o } = $w;
  return /* @__PURE__ */ I.createElement(o, { value: t }, e);
}, $w = dit(jy, {});
jy.Provider = $w.Provider;
jy.Consumer = $w.Consumer;
function dit(e, t) {
  return Object.assign(e, I.createContext(t)), e.Provider._context = e, e.Consumer._context = e, e;
}
var mie = () => {
  const e = [], t = function(r) {
    Brt();
    const i = [];
    return Kt(e, (o, a) => {
      if (je.und(r))
        i.push(o.start());
      else {
        const s = n(r, o, a);
        s && i.push(o.start(s));
      }
    }), i;
  };
  t.current = e, t.add = function(r) {
    e.includes(r) || e.push(r);
  }, t.delete = function(r) {
    const i = e.indexOf(r);
    ~i && e.splice(i, 1);
  }, t.pause = function() {
    return Kt(e, (r) => r.pause(...arguments)), this;
  }, t.resume = function() {
    return Kt(e, (r) => r.resume(...arguments)), this;
  }, t.set = function(r) {
    Kt(e, (i, o) => {
      const a = je.fun(r) ? r(o, i) : r;
      a && i.set(a);
    });
  }, t.start = function(r) {
    const i = [];
    return Kt(e, (o, a) => {
      if (je.und(r))
        i.push(o.start());
      else {
        const s = this._getProps(r, o, a);
        s && i.push(o.start(s));
      }
    }), i;
  }, t.stop = function() {
    return Kt(e, (r) => r.stop(...arguments)), this;
  }, t.update = function(r) {
    return Kt(e, (i, o) => i.update(this._getProps(r, i, o))), this;
  };
  const n = function(r, i, o) {
    return je.fun(r) ? r(o, i) : r;
  };
  return t._getProps = n, t;
};
function fit(e, t, n) {
  const r = je.fun(t) && t;
  r && !n && (n = []);
  const i = At(
    () => r || arguments.length == 3 ? mie() : void 0,
    []
  ), o = Me(0), a = H3(), s = At(
    () => ({
      ctrls: [],
      queue: [],
      flush(v, y) {
        const S = _$(v, y);
        return o.current > 0 && !s.queue.length && !Object.keys(S).some((w) => !v.springs[w]) ? b$(v, y) : new Promise((w) => {
          fie(v, S), s.queue.push(() => {
            w(b$(v, y));
          }), a();
        });
      }
    }),
    []
  ), c = Me([...s.ctrls]), l = [], u = d$(e) || 0;
  At(() => {
    Kt(c.current.slice(e, u), (v) => {
      g$(v, i), v.stop(!0);
    }), c.current.length = e, d(u, e);
  }, [e]), At(() => {
    d(0, Math.min(u, e));
  }, n);
  function d(v, y) {
    for (let S = v; S < y; S++) {
      const _ = c.current[S] || (c.current[S] = new uie(null, s.flush)), w = r ? r(S, _) : t[S];
      w && (l[S] = sit(w));
    }
  }
  const f = c.current.map((v, y) => _$(v, l[y])), h = St(jy), p = d$(h), g = h !== p && rie(h);
  $d(() => {
    o.current++, s.ctrls = c.current;
    const { queue: v } = s;
    v.length && (s.queue = [], Kt(v, (y) => y())), Kt(c.current, (y, S) => {
      i == null || i.add(y), g && y.start({ default: h });
      const _ = l[S];
      _ && (iie(y, _.ref), y.ref ? y.queue.push(_) : y.start(_));
    });
  }), U3(() => () => {
    Kt(s.ctrls, (v) => v.stop(!0));
  });
  const m = f.map((v) => ({ ...v }));
  return i ? [m, i] : m;
}
function bl(e, t) {
  const n = je.fun(e), [[r], i] = fit(
    1,
    n ? e : [e],
    n ? t || [] : t
  );
  return n || arguments.length == 2 ? [r, i] : r;
}
function X3(e, t, n) {
  const r = je.fun(t) && t, {
    reset: i,
    sort: o,
    trail: a = 0,
    expires: s = !0,
    exitBeforeEnter: c = !1,
    onDestroyed: l,
    ref: u,
    config: d
  } = r ? r() : t, f = At(
    () => r || arguments.length == 3 ? mie() : void 0,
    []
  ), h = $o(e), p = [], g = Me(null), m = i ? null : g.current;
  $d(() => {
    g.current = p;
  }), U3(() => (Kt(p, (N) => {
    f == null || f.add(N.ctrl), N.ctrl.ref = f;
  }), () => {
    Kt(g.current, (N) => {
      N.expired && clearTimeout(N.expirationId), g$(N.ctrl, f), N.ctrl.stop(!0);
    });
  }));
  const v = git(h, r ? r() : t, m), y = i && g.current || [];
  $d(
    () => Kt(y, ({ ctrl: N, item: z, key: k }) => {
      g$(N, f), Go(l, z, k);
    })
  );
  const S = [];
  if (m && Kt(m, (N, z) => {
    N.expired ? (clearTimeout(N.expirationId), y.push(N)) : (z = S[z] = v.indexOf(N.key), ~z && (p[z] = N));
  }), Kt(h, (N, z) => {
    p[z] || (p[z] = {
      key: v[z],
      item: N,
      phase: "mount",
      ctrl: new uie()
    }, p[z].ctrl.item = N);
  }), S.length) {
    let N = -1;
    const { leave: z } = r ? r() : t;
    Kt(S, (k, F) => {
      const V = m[F];
      ~k ? (N = p.indexOf(V), p[N] = { ...V, item: h[k] }) : z && p.splice(++N, 0, V);
    });
  }
  je.fun(o) && p.sort((N, z) => o(N.item, z.item));
  let _ = -a;
  const w = H3(), T = uC(t), x = /* @__PURE__ */ new Map(), C = Me(/* @__PURE__ */ new Map()), E = Me(!1);
  Kt(p, (N, z) => {
    const k = N.key, F = N.phase, V = r ? r() : t;
    let j, B;
    const U = Go(V.delay || 0, k);
    if (F == "mount")
      j = V.enter, B = "enter";
    else {
      const X = v.indexOf(k) < 0;
      if (F != "leave")
        if (X)
          j = V.leave, B = "leave";
        else if (j = V.update)
          B = "update";
        else
          return;
      else if (!X)
        j = V.enter, B = "enter";
      else
        return;
    }
    if (j = Go(j, N.item, z), j = je.obj(j) ? q3(j) : { to: j }, !j.config) {
      const X = d || T.config;
      j.config = Go(X, N.item, z, B);
    }
    _ += a;
    const Q = {
      ...T,
      // we need to add our props.delay value you here.
      delay: U + _,
      ref: u,
      immediate: V.immediate,
      // This prevents implied resets.
      reset: !1,
      // Merge any phase-specific props.
      ...j
    };
    if (B == "enter" && je.und(Q.from)) {
      const X = r ? r() : t, ie = je.und(X.initial) || m ? X.from : X.initial;
      Q.from = Go(ie, N.item, z);
    }
    const { onResolve: K } = Q;
    Q.onResolve = (X) => {
      Go(K, X);
      const ie = g.current, te = ie.find((J) => J.key === k);
      if (te && !(X.cancelled && te.phase != "update") && te.ctrl.idle) {
        const J = ie.every((Y) => Y.ctrl.idle);
        if (te.phase == "leave") {
          const Y = Go(s, te.item);
          if (Y !== !1) {
            const ee = Y === !0 ? 0 : Y;
            if (te.expired = !0, !J && ee > 0) {
              ee <= 2147483647 && (te.expirationId = setTimeout(w, ee));
              return;
            }
          }
        }
        J && ie.some((Y) => Y.expired) && (C.current.delete(te), c && (E.current = !0), w());
      }
    };
    const q = _$(N.ctrl, Q);
    B === "leave" && c ? C.current.set(N, { phase: B, springs: q, payload: Q }) : x.set(N, { phase: B, springs: q, payload: Q });
  });
  const R = St(jy), A = d$(R), O = R !== A && rie(R);
  $d(() => {
    O && Kt(p, (N) => {
      N.ctrl.start({ default: R });
    });
  }, [R]), Kt(x, (N, z) => {
    if (C.current.size) {
      const k = p.findIndex((F) => F.key === z.key);
      p.splice(k, 1);
    }
  }), $d(
    () => {
      Kt(
        C.current.size ? C.current : x,
        ({ phase: N, payload: z }, k) => {
          const { ctrl: F } = k;
          k.phase = N, f == null || f.add(F), O && N == "enter" && F.start({ default: R }), z && (iie(F, z.ref), (F.ref || f) && !E.current ? F.update(z) : (F.start(z), E.current && (E.current = !1)));
        }
      );
    },
    i ? void 0 : n
  );
  const $ = (N) => /* @__PURE__ */ I.createElement(I.Fragment, null, p.map((z, k) => {
    const { springs: F } = x.get(z) || z.ctrl, V = N({ ...F }, z.item, z, k);
    return V && V.type ? /* @__PURE__ */ I.createElement(
      V.type,
      {
        ...V.props,
        key: je.str(z.key) || je.num(z.key) ? z.key : z.ctrl.id,
        ref: V.ref
      }
    ) : V;
  }));
  return f ? [$, f] : $;
}
var hit = 1;
function git(e, { key: t, keys: n = t }, r) {
  if (n === null) {
    const i = /* @__PURE__ */ new Set();
    return e.map((o) => {
      const a = r && r.find(
        (s) => s.item === o && s.phase !== "leave" && !i.has(s)
      );
      return a ? (i.add(a), a.key) : hit++;
    });
  }
  return je.und(n) ? e : je.fun(n) ? e.map(n) : $o(n);
}
var vie = class extends Y3 {
  constructor(e, t) {
    super(), this.source = e, this.idle = !0, this._active = /* @__PURE__ */ new Set(), this.calc = Cv(...t);
    const n = this._get(), r = f$(n);
    W3(this, r.create(n));
  }
  advance(e) {
    const t = this._get(), n = this.get();
    Fc(t, n) || (Hs(this).setValue(t), this._onChange(t, this.idle)), !this.idle && CV(this._active) && FT(this);
  }
  _get() {
    const e = je.arr(this.source) ? this.source.map(qo) : $o(qo(this.source));
    return this.calc(...e);
  }
  _start() {
    this.idle && !CV(this._active) && (this.idle = !1, Kt(cC(this), (e) => {
      e.done = !1;
    }), Cs.skipAnimation ? (on.batchedUpdates(() => this.advance()), FT(this)) : iC.start(this));
  }
  // Observe our sources only when we're observed.
  _attach() {
    let e = 1;
    Kt($o(this.source), (t) => {
      Na(t) && Wp(t, this), m$(t) && (t.idle || this._active.add(t), e = Math.max(e, t.priority + 1));
    }), this.priority = e, this._start();
  }
  // Stop observing our sources once we have no observers.
  _detach() {
    Kt($o(this.source), (e) => {
      Na(e) && Av(e, this);
    }), this._active.clear(), FT(this);
  }
  /** @internal */
  eventObserved(e) {
    e.type == "change" ? e.idle ? this.advance() : (this._active.add(e.parent), this._start()) : e.type == "idle" ? this._active.delete(e.parent) : e.type == "priority" && (this.priority = $o(this.source).reduce(
      (t, n) => Math.max(t, (m$(n) ? n.priority : 0) + 1),
      0
    ));
  }
};
function pit(e) {
  return e.idle !== !1;
}
function CV(e) {
  return !e.size || Array.from(e).every(pit);
}
function FT(e) {
  e.idle || (e.idle = !0, Kt(cC(e), (t) => {
    t.done = !0;
  }), Iv(e, {
    type: "idle",
    parent: e
  }));
}
var yie = (e, ...t) => new vie(e, t);
Cs.assign({
  createStringInterpolator: Qre,
  to: (e, t) => new vie(e, t)
});
var bie = /^--/;
function mit(e, t) {
  return t == null || typeof t == "boolean" || t === "" ? "" : typeof t == "number" && t !== 0 && !bie.test(e) && !(I0.hasOwnProperty(e) && I0[e]) ? t + "px" : ("" + t).trim();
}
var TV = {};
function vit(e, t) {
  if (!e.nodeType || !e.setAttribute)
    return !1;
  const n = e.nodeName === "filter" || e.parentNode && e.parentNode.nodeName === "filter", {
    className: r,
    style: i,
    children: o,
    scrollTop: a,
    scrollLeft: s,
    viewBox: c,
    ...l
  } = t, u = Object.values(l), d = Object.keys(l).map(
    (f) => n || e.hasAttribute(f) ? f : TV[f] || (TV[f] = f.replace(
      /([A-Z])/g,
      // Attributes are written in dash case
      (h) => "-" + h.toLowerCase()
    ))
  );
  o !== void 0 && (e.textContent = o);
  for (const f in i)
    if (i.hasOwnProperty(f)) {
      const h = mit(f, i[f]);
      bie.test(f) ? e.style.setProperty(f, h) : e.style[f] = h;
    }
  d.forEach((f, h) => {
    e.setAttribute(f, u[h]);
  }), r !== void 0 && (e.className = r), a !== void 0 && (e.scrollTop = a), s !== void 0 && (e.scrollLeft = s), c !== void 0 && e.setAttribute("viewBox", c);
}
var I0 = {
  animationIterationCount: !0,
  borderImageOutset: !0,
  borderImageSlice: !0,
  borderImageWidth: !0,
  boxFlex: !0,
  boxFlexGroup: !0,
  boxOrdinalGroup: !0,
  columnCount: !0,
  columns: !0,
  flex: !0,
  flexGrow: !0,
  flexPositive: !0,
  flexShrink: !0,
  flexNegative: !0,
  flexOrder: !0,
  gridRow: !0,
  gridRowEnd: !0,
  gridRowSpan: !0,
  gridRowStart: !0,
  gridColumn: !0,
  gridColumnEnd: !0,
  gridColumnSpan: !0,
  gridColumnStart: !0,
  fontWeight: !0,
  lineClamp: !0,
  lineHeight: !0,
  opacity: !0,
  order: !0,
  orphans: !0,
  tabSize: !0,
  widows: !0,
  zIndex: !0,
  zoom: !0,
  // SVG-related properties
  fillOpacity: !0,
  floodOpacity: !0,
  stopOpacity: !0,
  strokeDasharray: !0,
  strokeDashoffset: !0,
  strokeMiterlimit: !0,
  strokeOpacity: !0,
  strokeWidth: !0
}, yit = (e, t) => e + t.charAt(0).toUpperCase() + t.substring(1), bit = ["Webkit", "Ms", "Moz", "O"];
I0 = Object.keys(I0).reduce((e, t) => (bit.forEach((n) => e[yit(n, t)] = e[t]), e), I0);
var _it = /^(matrix|translate|scale|rotate|skew)/, Sit = /^(translate)/, wit = /^(rotate|skew)/, VT = (e, t) => je.num(e) && e !== 0 ? e + t : e, X1 = (e, t) => je.arr(e) ? e.every((n) => X1(n, t)) : je.num(e) ? e === t : parseFloat(e) === t, xit = class extends lC {
  constructor({ x: e, y: t, z: n, ...r }) {
    const i = [], o = [];
    (e || t || n) && (i.push([e || 0, t || 0, n || 0]), o.push((a) => [
      `translate3d(${a.map((s) => VT(s, "px")).join(",")})`,
      // prettier-ignore
      X1(a, 0)
    ])), mc(r, (a, s) => {
      if (s === "transform")
        i.push([a || ""]), o.push((c) => [c, c === ""]);
      else if (_it.test(s)) {
        if (delete r[s], je.und(a))
          return;
        const c = Sit.test(s) ? "px" : wit.test(s) ? "deg" : "";
        i.push($o(a)), o.push(
          s === "rotate3d" ? ([l, u, d, f]) => [
            `rotate3d(${l},${u},${d},${VT(f, c)})`,
            X1(f, 0)
          ] : (l) => [
            `${s}(${l.map((u) => VT(u, c)).join(",")})`,
            X1(l, s.startsWith("scale") ? 1 : 0)
          ]
        );
      }
    }), i.length && (r.transform = new Eit(i, o)), super(r);
  }
}, Eit = class extends Kre {
  constructor(e, t) {
    super(), this.inputs = e, this.transforms = t, this._value = null;
  }
  get() {
    return this._value || (this._value = this._get());
  }
  _get() {
    let e = "", t = !0;
    return Kt(this.inputs, (n, r) => {
      const i = qo(n[0]), [o, a] = this.transforms[r](
        je.arr(i) ? i : n.map(qo)
      );
      e += " " + o, t = t && a;
    }), t ? "none" : e;
  }
  // Start observing our inputs once we have an observer.
  observerAdded(e) {
    e == 1 && Kt(
      this.inputs,
      (t) => Kt(
        t,
        (n) => Na(n) && Wp(n, this)
      )
    );
  }
  // Stop observing our inputs once we have no observers.
  observerRemoved(e) {
    e == 0 && Kt(
      this.inputs,
      (t) => Kt(
        t,
        (n) => Na(n) && Av(n, this)
      )
    );
  }
  eventObserved(e) {
    e.type == "change" && (this._value = null), Iv(this, e);
  }
}, Cit = [
  "a",
  "abbr",
  "address",
  "area",
  "article",
  "aside",
  "audio",
  "b",
  "base",
  "bdi",
  "bdo",
  "big",
  "blockquote",
  "body",
  "br",
  "button",
  "canvas",
  "caption",
  "cite",
  "code",
  "col",
  "colgroup",
  "data",
  "datalist",
  "dd",
  "del",
  "details",
  "dfn",
  "dialog",
  "div",
  "dl",
  "dt",
  "em",
  "embed",
  "fieldset",
  "figcaption",
  "figure",
  "footer",
  "form",
  "h1",
  "h2",
  "h3",
  "h4",
  "h5",
  "h6",
  "head",
  "header",
  "hgroup",
  "hr",
  "html",
  "i",
  "iframe",
  "img",
  "input",
  "ins",
  "kbd",
  "keygen",
  "label",
  "legend",
  "li",
  "link",
  "main",
  "map",
  "mark",
  "menu",
  "menuitem",
  "meta",
  "meter",
  "nav",
  "noscript",
  "object",
  "ol",
  "optgroup",
  "option",
  "output",
  "p",
  "param",
  "picture",
  "pre",
  "progress",
  "q",
  "rp",
  "rt",
  "ruby",
  "s",
  "samp",
  "script",
  "section",
  "select",
  "small",
  "source",
  "span",
  "strong",
  "style",
  "sub",
  "summary",
  "sup",
  "table",
  "tbody",
  "td",
  "textarea",
  "tfoot",
  "th",
  "thead",
  "time",
  "title",
  "tr",
  "track",
  "u",
  "ul",
  "var",
  "video",
  "wbr",
  // SVG
  "circle",
  "clipPath",
  "defs",
  "ellipse",
  "foreignObject",
  "g",
  "image",
  "line",
  "linearGradient",
  "mask",
  "path",
  "pattern",
  "polygon",
  "polyline",
  "radialGradient",
  "rect",
  "stop",
  "svg",
  "text",
  "tspan"
];
Cs.assign({
  batchedUpdates: nO,
  createStringInterpolator: Qre,
  colors: yrt
});
var Tit = Qrt(Cit, {
  applyAnimatedValues: vit,
  createAnimatedStyle: (e) => new xit(e),
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  getComponentProps: ({ scrollTop: e, scrollLeft: t, ...n }) => n
}), wi = Tit.animated;
function bf() {
  return bf = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, bf.apply(this, arguments);
}
var Iit = { pointerEvents: "none", position: "absolute", zIndex: 10, top: 0, left: 0 }, IV = function(e, t) {
  return "translate(" + e + "px, " + t + "px)";
}, _ie = hi(function(e) {
  var t, n = e.position, r = e.anchor, i = e.children, o = go(), a = Os(), s = a.animate, c = a.config, l = Wie(), u = l[0], d = l[1], f = Me(!1), h = void 0, p = !1, g = d.width > 0 && d.height > 0, m = Math.round(n[0]), v = Math.round(n[1]);
  g && (r === "top" ? (m -= d.width / 2, v -= d.height + 14) : r === "right" ? (m += 14, v -= d.height / 2) : r === "bottom" ? (m -= d.width / 2, v += 14) : r === "left" ? (m -= d.width + 14, v -= d.height / 2) : r === "center" && (m -= d.width / 2, v -= d.height / 2), h = { transform: IV(m, v) }, f.current || (p = !0), f.current = [m, v]);
  var y = bl({ to: h, config: c, immediate: !s || p }), S = bf({}, Iit, o.tooltip.wrapper, { transform: (t = y.transform) != null ? t : IV(m, v), opacity: y.transform ? 1 : 0 });
  return M.jsx(wi.div, { ref: u, style: S, children: i });
});
_ie.displayName = "TooltipWrapper";
var Ait = hi(function(e) {
  var t = e.size, n = t === void 0 ? 12 : t, r = e.color, i = e.style;
  return M.jsx("span", { style: bf({ display: "block", width: n, height: n, background: r }, i === void 0 ? {} : i) });
}), Rit = hi(function(e) {
  var t, n = e.id, r = e.value, i = e.format, o = e.enableChip, a = o !== void 0 && o, s = e.color, c = e.renderContent, l = go(), u = qie(i);
  if (typeof c == "function")
    t = c();
  else {
    var d = r;
    u !== void 0 && d !== void 0 && (d = u(d)), t = M.jsxs("div", { style: l.tooltip.basic, children: [a && M.jsx(Ait, { color: s, style: l.tooltip.chip }), d !== void 0 ? M.jsxs("span", { children: [n, ": ", M.jsx("strong", { children: "" + d })] }) : n] });
  }
  return M.jsx("div", { style: l.tooltip.container, children: t });
}), $it = { width: "100%", borderCollapse: "collapse" }, Oit = hi(function(e) {
  var t, n = e.title, r = e.rows, i = r === void 0 ? [] : r, o = e.renderContent, a = go();
  return i.length ? (t = typeof o == "function" ? o() : M.jsxs("div", { children: [n && n, M.jsx("table", { style: bf({}, $it, a.tooltip.table), children: M.jsx("tbody", { children: i.map(function(s, c) {
    return M.jsx("tr", { children: s.map(function(l, u) {
      return M.jsx("td", { style: a.tooltip.tableCell, children: l }, u);
    }) }, c);
  }) }) })] }), M.jsx("div", { style: a.tooltip.container, children: t })) : null;
});
Oit.displayName = "TableTooltip";
var S$ = hi(function(e) {
  var t = e.x0, n = e.x1, r = e.y0, i = e.y1, o = go(), a = Os(), s = a.animate, c = a.config, l = At(function() {
    return bf({}, o.crosshair.line, { pointerEvents: "none" });
  }, [o.crosshair.line]), u = bl({ x1: t, x2: n, y1: r, y2: i, config: c, immediate: !s });
  return M.jsx(wi.line, bf({}, u, { fill: "none", style: l }));
});
S$.displayName = "CrosshairLine";
var Pit = hi(function(e) {
  var t, n, r = e.width, i = e.height, o = e.type, a = e.x, s = e.y;
  return o === "cross" ? (t = { x0: a, x1: a, y0: 0, y1: i }, n = { x0: 0, x1: r, y0: s, y1: s }) : o === "top-left" ? (t = { x0: a, x1: a, y0: 0, y1: s }, n = { x0: 0, x1: a, y0: s, y1: s }) : o === "top" ? t = { x0: a, x1: a, y0: 0, y1: s } : o === "top-right" ? (t = { x0: a, x1: a, y0: 0, y1: s }, n = { x0: a, x1: r, y0: s, y1: s }) : o === "right" ? n = { x0: a, x1: r, y0: s, y1: s } : o === "bottom-right" ? (t = { x0: a, x1: a, y0: s, y1: i }, n = { x0: a, x1: r, y0: s, y1: s }) : o === "bottom" ? t = { x0: a, x1: a, y0: s, y1: i } : o === "bottom-left" ? (t = { x0: a, x1: a, y0: s, y1: i }, n = { x0: 0, x1: a, y0: s, y1: s }) : o === "left" ? n = { x0: 0, x1: a, y0: s, y1: s } : o === "x" ? t = { x0: a, x1: a, y0: 0, y1: i } : o === "y" && (n = { x0: 0, x1: r, y0: s, y1: s }), M.jsxs(M.Fragment, { children: [t && M.jsx(S$, { x0: t.x0, x1: t.x1, y0: t.y0, y1: t.y1 }), n && M.jsx(S$, { x0: n.x0, x1: n.x1, y0: n.y0, y1: n.y1 })] });
});
Pit.displayName = "Crosshair";
var Sie = Is({ showTooltipAt: function() {
}, showTooltipFromEvent: function() {
}, hideTooltip: function() {
} }), w$ = { isVisible: !1, position: [null, null], content: null, anchor: null }, wie = Is(w$), Mit = function(e) {
  var t = Lt(w$), n = t[0], r = t[1], i = mn(function(s, c, l) {
    var u = c[0], d = c[1];
    l === void 0 && (l = "top"), r({ isVisible: !0, position: [u, d], anchor: l, content: s });
  }, [r]), o = mn(function(s, c, l) {
    l === void 0 && (l = "top");
    var u = e.current.getBoundingClientRect(), d = e.current.offsetWidth, f = d === u.width ? 1 : d / u.width, h = "touches" in c ? c.touches[0] : c, p = h.clientX, g = h.clientY, m = (p - u.left) * f, v = (g - u.top) * f;
    l !== "left" && l !== "right" || (l = m < u.width / 2 ? "right" : "left"), r({ isVisible: !0, position: [m, v], anchor: l, content: s });
  }, [e, r]), a = mn(function() {
    r(w$);
  }, [r]);
  return { actions: At(function() {
    return { showTooltipAt: i, showTooltipFromEvent: o, hideTooltip: a };
  }, [i, o, a]), state: n };
}, Q3 = function() {
  var e = St(Sie);
  if (e === void 0)
    throw new Error("useTooltip must be used within a TooltipProvider");
  return e;
}, kit = function() {
  var e = St(wie);
  if (e === void 0)
    throw new Error("useTooltipState must be used within a TooltipProvider");
  return e;
}, Nit = function(e) {
  return e.isVisible;
}, Dit = function() {
  var e = kit();
  return Nit(e) ? M.jsx(_ie, { position: e.position, anchor: e.anchor, children: e.content }) : null;
}, Lit = function(e) {
  var t = e.container, n = e.children, r = Mit(t), i = r.actions, o = r.state;
  return M.jsx(Sie.Provider, { value: i, children: M.jsx(wie.Provider, { value: o, children: n }) });
}, jit = ME, Fit = Df;
function Vit(e, t, n) {
  (n !== void 0 && !Fit(e[t], n) || n === void 0 && !(t in e)) && jit(e, t, n);
}
var xie = Vit, Ow = { exports: {} };
Ow.exports;
(function(e, t) {
  var n = Sc, r = t && !t.nodeType && t, i = r && !0 && e && !e.nodeType && e, o = i && i.exports === r, a = o ? n.Buffer : void 0, s = a ? a.allocUnsafe : void 0;
  function c(l, u) {
    if (u)
      return l.slice();
    var d = l.length, f = s ? s(d) : new l.constructor(d);
    return l.copy(f), f;
  }
  e.exports = c;
})(Ow, Ow.exports);
var Eie = Ow.exports, AV = mZ;
function Bit(e) {
  var t = new e.constructor(e.byteLength);
  return new AV(t).set(new AV(e)), t;
}
var J3 = Bit, zit = J3;
function Hit(e, t) {
  var n = t ? zit(e.buffer) : e.buffer;
  return new e.constructor(n, e.byteOffset, e.length);
}
var Cie = Hit;
function Uit(e, t) {
  var n = -1, r = e.length;
  for (t || (t = Array(r)); ++n < r; )
    t[n] = e[n];
  return t;
}
var Tie = Uit, Wit = Ka, RV = Object.create, qit = function() {
  function e() {
  }
  return function(t) {
    if (!Wit(t))
      return {};
    if (RV)
      return RV(t);
    e.prototype = t;
    var n = new e();
    return e.prototype = void 0, n;
  };
}(), Git = qit, Kit = Git, Yit = iM, Xit = by;
function Qit(e) {
  return typeof e.constructor == "function" && !Xit(e) ? Kit(Yit(e)) : {};
}
var Iie = Qit, Jit = Wu, Zit = Ga;
function eot(e) {
  return Zit(e) && Jit(e);
}
var Aie = eot;
function tot(e, t) {
  if (!(t === "constructor" && typeof e[t] == "function") && t != "__proto__")
    return e[t];
}
var Rie = tot, not = Hf, rot = Fp;
function iot(e) {
  return not(e, rot(e));
}
var oot = iot, $V = xie, aot = Eie, sot = Cie, cot = Tie, lot = Iie, OV = vy, PV = Gi, uot = Aie, dot = yy, fot = vE, hot = Ka, got = oM, pot = CE, MV = Rie, mot = oot;
function vot(e, t, n, r, i, o, a) {
  var s = MV(e, n), c = MV(t, n), l = a.get(c);
  if (l) {
    $V(e, n, l);
    return;
  }
  var u = o ? o(s, c, n + "", e, t, a) : void 0, d = u === void 0;
  if (d) {
    var f = PV(c), h = !f && dot(c), p = !f && !h && pot(c);
    u = c, f || h || p ? PV(s) ? u = s : uot(s) ? u = cot(s) : h ? (d = !1, u = aot(c, !0)) : p ? (d = !1, u = sot(c, !0)) : u = [] : got(c) || OV(c) ? (u = s, OV(s) ? u = mot(s) : (!hot(s) || fot(s)) && (u = lot(c))) : d = !1;
  }
  d && (a.set(c, u), i(u, c, r, o, a), a.delete(c)), $V(e, n, u);
}
var yot = vot, bot = wE, _ot = xie, Sot = MZ, wot = yot, xot = Ka, Eot = Fp, Cot = Rie;
function $ie(e, t, n, r, i) {
  e !== t && Sot(t, function(o, a) {
    if (i || (i = new bot()), xot(o))
      wot(e, t, a, n, $ie, r, i);
    else {
      var s = r ? r(Cot(e, a), o, a + "", e, t, i) : void 0;
      s === void 0 && (s = o), _ot(e, a, s);
    }
  }, Eot);
}
var Tot = $ie, Iot = Tot, Aot = Sre, Rot = Aot(function(e, t, n) {
  Iot(e, t, n);
}), $ot = Rot;
const Oot = /* @__PURE__ */ pn($ot);
var Pot = JZ;
function Mot(e, t, n) {
  return e == null ? e : Pot(e, t, n);
}
var kot = Mot;
const Not = /* @__PURE__ */ pn(kot);
var Dot = vl, Lot = Gi, jot = Ga, Fot = "[object String]";
function Vot(e) {
  return typeof e == "string" || !Lot(e) && jot(e) && Dot(e) == Fot;
}
var Bot = Vot;
const Oie = /* @__PURE__ */ pn(Bot);
function zot(e) {
  var t = e == null ? 0 : e.length;
  return t ? e[t - 1] : void 0;
}
var Pie = zot;
const Ot = /* @__PURE__ */ pn(Pie);
function cn(e) {
  for (var t = e.length / 6 | 0, n = new Array(t), r = 0; r < t; )
    n[r] = "#" + e.slice(r * 6, ++r * 6);
  return n;
}
const Mie = cn("1f77b4ff7f0e2ca02cd627289467bd8c564be377c27f7f7fbcbd2217becf"), kie = cn("7fc97fbeaed4fdc086ffff99386cb0f0027fbf5b17666666"), Nie = cn("1b9e77d95f027570b3e7298a66a61ee6ab02a6761d666666"), Die = cn("a6cee31f78b4b2df8a33a02cfb9a99e31a1cfdbf6fff7f00cab2d66a3d9affff99b15928"), Lie = cn("fbb4aeb3cde3ccebc5decbe4fed9a6ffffcce5d8bdfddaecf2f2f2"), jie = cn("b3e2cdfdcdaccbd5e8f4cae4e6f5c9fff2aef1e2cccccccc"), Fie = cn("e41a1c377eb84daf4a984ea3ff7f00ffff33a65628f781bf999999"), Vie = cn("66c2a5fc8d628da0cbe78ac3a6d854ffd92fe5c494b3b3b3"), Z3 = cn("8dd3c7ffffb3bebadafb807280b1d3fdb462b3de69fccde5d9d9d9bc80bdccebc5ffed6f"), Hot = cn("4e79a7f28e2ce1575976b7b259a14fedc949af7aa1ff9da79c755fbab0ab"), or = (e) => Cze(e[e.length - 1]);
var dC = new Array(3).concat(
  "d8b365f5f5f55ab4ac",
  "a6611adfc27d80cdc1018571",
  "a6611adfc27df5f5f580cdc1018571",
  "8c510ad8b365f6e8c3c7eae55ab4ac01665e",
  "8c510ad8b365f6e8c3f5f5f5c7eae55ab4ac01665e",
  "8c510abf812ddfc27df6e8c3c7eae580cdc135978f01665e",
  "8c510abf812ddfc27df6e8c3f5f5f5c7eae580cdc135978f01665e",
  "5430058c510abf812ddfc27df6e8c3c7eae580cdc135978f01665e003c30",
  "5430058c510abf812ddfc27df6e8c3f5f5f5c7eae580cdc135978f01665e003c30"
).map(cn);
const Uot = or(dC);
var fC = new Array(3).concat(
  "af8dc3f7f7f77fbf7b",
  "7b3294c2a5cfa6dba0008837",
  "7b3294c2a5cff7f7f7a6dba0008837",
  "762a83af8dc3e7d4e8d9f0d37fbf7b1b7837",
  "762a83af8dc3e7d4e8f7f7f7d9f0d37fbf7b1b7837",
  "762a839970abc2a5cfe7d4e8d9f0d3a6dba05aae611b7837",
  "762a839970abc2a5cfe7d4e8f7f7f7d9f0d3a6dba05aae611b7837",
  "40004b762a839970abc2a5cfe7d4e8d9f0d3a6dba05aae611b783700441b",
  "40004b762a839970abc2a5cfe7d4e8f7f7f7d9f0d3a6dba05aae611b783700441b"
).map(cn);
const Wot = or(fC);
var hC = new Array(3).concat(
  "e9a3c9f7f7f7a1d76a",
  "d01c8bf1b6dab8e1864dac26",
  "d01c8bf1b6daf7f7f7b8e1864dac26",
  "c51b7de9a3c9fde0efe6f5d0a1d76a4d9221",
  "c51b7de9a3c9fde0eff7f7f7e6f5d0a1d76a4d9221",
  "c51b7dde77aef1b6dafde0efe6f5d0b8e1867fbc414d9221",
  "c51b7dde77aef1b6dafde0eff7f7f7e6f5d0b8e1867fbc414d9221",
  "8e0152c51b7dde77aef1b6dafde0efe6f5d0b8e1867fbc414d9221276419",
  "8e0152c51b7dde77aef1b6dafde0eff7f7f7e6f5d0b8e1867fbc414d9221276419"
).map(cn);
const qot = or(hC);
var gC = new Array(3).concat(
  "998ec3f7f7f7f1a340",
  "5e3c99b2abd2fdb863e66101",
  "5e3c99b2abd2f7f7f7fdb863e66101",
  "542788998ec3d8daebfee0b6f1a340b35806",
  "542788998ec3d8daebf7f7f7fee0b6f1a340b35806",
  "5427888073acb2abd2d8daebfee0b6fdb863e08214b35806",
  "5427888073acb2abd2d8daebf7f7f7fee0b6fdb863e08214b35806",
  "2d004b5427888073acb2abd2d8daebfee0b6fdb863e08214b358067f3b08",
  "2d004b5427888073acb2abd2d8daebf7f7f7fee0b6fdb863e08214b358067f3b08"
).map(cn);
const Got = or(gC);
var pC = new Array(3).concat(
  "ef8a62f7f7f767a9cf",
  "ca0020f4a58292c5de0571b0",
  "ca0020f4a582f7f7f792c5de0571b0",
  "b2182bef8a62fddbc7d1e5f067a9cf2166ac",
  "b2182bef8a62fddbc7f7f7f7d1e5f067a9cf2166ac",
  "b2182bd6604df4a582fddbc7d1e5f092c5de4393c32166ac",
  "b2182bd6604df4a582fddbc7f7f7f7d1e5f092c5de4393c32166ac",
  "67001fb2182bd6604df4a582fddbc7d1e5f092c5de4393c32166ac053061",
  "67001fb2182bd6604df4a582fddbc7f7f7f7d1e5f092c5de4393c32166ac053061"
).map(cn);
const Kot = or(pC);
var mC = new Array(3).concat(
  "ef8a62ffffff999999",
  "ca0020f4a582bababa404040",
  "ca0020f4a582ffffffbababa404040",
  "b2182bef8a62fddbc7e0e0e09999994d4d4d",
  "b2182bef8a62fddbc7ffffffe0e0e09999994d4d4d",
  "b2182bd6604df4a582fddbc7e0e0e0bababa8787874d4d4d",
  "b2182bd6604df4a582fddbc7ffffffe0e0e0bababa8787874d4d4d",
  "67001fb2182bd6604df4a582fddbc7e0e0e0bababa8787874d4d4d1a1a1a",
  "67001fb2182bd6604df4a582fddbc7ffffffe0e0e0bababa8787874d4d4d1a1a1a"
).map(cn);
const Yot = or(mC);
var vC = new Array(3).concat(
  "fc8d59ffffbf91bfdb",
  "d7191cfdae61abd9e92c7bb6",
  "d7191cfdae61ffffbfabd9e92c7bb6",
  "d73027fc8d59fee090e0f3f891bfdb4575b4",
  "d73027fc8d59fee090ffffbfe0f3f891bfdb4575b4",
  "d73027f46d43fdae61fee090e0f3f8abd9e974add14575b4",
  "d73027f46d43fdae61fee090ffffbfe0f3f8abd9e974add14575b4",
  "a50026d73027f46d43fdae61fee090e0f3f8abd9e974add14575b4313695",
  "a50026d73027f46d43fdae61fee090ffffbfe0f3f8abd9e974add14575b4313695"
).map(cn);
const Xot = or(vC);
var yC = new Array(3).concat(
  "fc8d59ffffbf91cf60",
  "d7191cfdae61a6d96a1a9641",
  "d7191cfdae61ffffbfa6d96a1a9641",
  "d73027fc8d59fee08bd9ef8b91cf601a9850",
  "d73027fc8d59fee08bffffbfd9ef8b91cf601a9850",
  "d73027f46d43fdae61fee08bd9ef8ba6d96a66bd631a9850",
  "d73027f46d43fdae61fee08bffffbfd9ef8ba6d96a66bd631a9850",
  "a50026d73027f46d43fdae61fee08bd9ef8ba6d96a66bd631a9850006837",
  "a50026d73027f46d43fdae61fee08bffffbfd9ef8ba6d96a66bd631a9850006837"
).map(cn);
const Qot = or(yC);
var bC = new Array(3).concat(
  "fc8d59ffffbf99d594",
  "d7191cfdae61abdda42b83ba",
  "d7191cfdae61ffffbfabdda42b83ba",
  "d53e4ffc8d59fee08be6f59899d5943288bd",
  "d53e4ffc8d59fee08bffffbfe6f59899d5943288bd",
  "d53e4ff46d43fdae61fee08be6f598abdda466c2a53288bd",
  "d53e4ff46d43fdae61fee08bffffbfe6f598abdda466c2a53288bd",
  "9e0142d53e4ff46d43fdae61fee08be6f598abdda466c2a53288bd5e4fa2",
  "9e0142d53e4ff46d43fdae61fee08bffffbfe6f598abdda466c2a53288bd5e4fa2"
).map(cn);
const Jot = or(bC);
var _C = new Array(3).concat(
  "e5f5f999d8c92ca25f",
  "edf8fbb2e2e266c2a4238b45",
  "edf8fbb2e2e266c2a42ca25f006d2c",
  "edf8fbccece699d8c966c2a42ca25f006d2c",
  "edf8fbccece699d8c966c2a441ae76238b45005824",
  "f7fcfde5f5f9ccece699d8c966c2a441ae76238b45005824",
  "f7fcfde5f5f9ccece699d8c966c2a441ae76238b45006d2c00441b"
).map(cn);
const Zot = or(_C);
var SC = new Array(3).concat(
  "e0ecf49ebcda8856a7",
  "edf8fbb3cde38c96c688419d",
  "edf8fbb3cde38c96c68856a7810f7c",
  "edf8fbbfd3e69ebcda8c96c68856a7810f7c",
  "edf8fbbfd3e69ebcda8c96c68c6bb188419d6e016b",
  "f7fcfde0ecf4bfd3e69ebcda8c96c68c6bb188419d6e016b",
  "f7fcfde0ecf4bfd3e69ebcda8c96c68c6bb188419d810f7c4d004b"
).map(cn);
const eat = or(SC);
var wC = new Array(3).concat(
  "e0f3dba8ddb543a2ca",
  "f0f9e8bae4bc7bccc42b8cbe",
  "f0f9e8bae4bc7bccc443a2ca0868ac",
  "f0f9e8ccebc5a8ddb57bccc443a2ca0868ac",
  "f0f9e8ccebc5a8ddb57bccc44eb3d32b8cbe08589e",
  "f7fcf0e0f3dbccebc5a8ddb57bccc44eb3d32b8cbe08589e",
  "f7fcf0e0f3dbccebc5a8ddb57bccc44eb3d32b8cbe0868ac084081"
).map(cn);
const tat = or(wC);
var xC = new Array(3).concat(
  "fee8c8fdbb84e34a33",
  "fef0d9fdcc8afc8d59d7301f",
  "fef0d9fdcc8afc8d59e34a33b30000",
  "fef0d9fdd49efdbb84fc8d59e34a33b30000",
  "fef0d9fdd49efdbb84fc8d59ef6548d7301f990000",
  "fff7ecfee8c8fdd49efdbb84fc8d59ef6548d7301f990000",
  "fff7ecfee8c8fdd49efdbb84fc8d59ef6548d7301fb300007f0000"
).map(cn);
const nat = or(xC);
var EC = new Array(3).concat(
  "ece2f0a6bddb1c9099",
  "f6eff7bdc9e167a9cf02818a",
  "f6eff7bdc9e167a9cf1c9099016c59",
  "f6eff7d0d1e6a6bddb67a9cf1c9099016c59",
  "f6eff7d0d1e6a6bddb67a9cf3690c002818a016450",
  "fff7fbece2f0d0d1e6a6bddb67a9cf3690c002818a016450",
  "fff7fbece2f0d0d1e6a6bddb67a9cf3690c002818a016c59014636"
).map(cn);
const rat = or(EC);
var CC = new Array(3).concat(
  "ece7f2a6bddb2b8cbe",
  "f1eef6bdc9e174a9cf0570b0",
  "f1eef6bdc9e174a9cf2b8cbe045a8d",
  "f1eef6d0d1e6a6bddb74a9cf2b8cbe045a8d",
  "f1eef6d0d1e6a6bddb74a9cf3690c00570b0034e7b",
  "fff7fbece7f2d0d1e6a6bddb74a9cf3690c00570b0034e7b",
  "fff7fbece7f2d0d1e6a6bddb74a9cf3690c00570b0045a8d023858"
).map(cn);
const iat = or(CC);
var TC = new Array(3).concat(
  "e7e1efc994c7dd1c77",
  "f1eef6d7b5d8df65b0ce1256",
  "f1eef6d7b5d8df65b0dd1c77980043",
  "f1eef6d4b9dac994c7df65b0dd1c77980043",
  "f1eef6d4b9dac994c7df65b0e7298ace125691003f",
  "f7f4f9e7e1efd4b9dac994c7df65b0e7298ace125691003f",
  "f7f4f9e7e1efd4b9dac994c7df65b0e7298ace125698004367001f"
).map(cn);
const oat = or(TC);
var IC = new Array(3).concat(
  "fde0ddfa9fb5c51b8a",
  "feebe2fbb4b9f768a1ae017e",
  "feebe2fbb4b9f768a1c51b8a7a0177",
  "feebe2fcc5c0fa9fb5f768a1c51b8a7a0177",
  "feebe2fcc5c0fa9fb5f768a1dd3497ae017e7a0177",
  "fff7f3fde0ddfcc5c0fa9fb5f768a1dd3497ae017e7a0177",
  "fff7f3fde0ddfcc5c0fa9fb5f768a1dd3497ae017e7a017749006a"
).map(cn);
const aat = or(IC);
var AC = new Array(3).concat(
  "edf8b17fcdbb2c7fb8",
  "ffffcca1dab441b6c4225ea8",
  "ffffcca1dab441b6c42c7fb8253494",
  "ffffccc7e9b47fcdbb41b6c42c7fb8253494",
  "ffffccc7e9b47fcdbb41b6c41d91c0225ea80c2c84",
  "ffffd9edf8b1c7e9b47fcdbb41b6c41d91c0225ea80c2c84",
  "ffffd9edf8b1c7e9b47fcdbb41b6c41d91c0225ea8253494081d58"
).map(cn);
const sat = or(AC);
var RC = new Array(3).concat(
  "f7fcb9addd8e31a354",
  "ffffccc2e69978c679238443",
  "ffffccc2e69978c67931a354006837",
  "ffffccd9f0a3addd8e78c67931a354006837",
  "ffffccd9f0a3addd8e78c67941ab5d238443005a32",
  "ffffe5f7fcb9d9f0a3addd8e78c67941ab5d238443005a32",
  "ffffe5f7fcb9d9f0a3addd8e78c67941ab5d238443006837004529"
).map(cn);
const cat = or(RC);
var $C = new Array(3).concat(
  "fff7bcfec44fd95f0e",
  "ffffd4fed98efe9929cc4c02",
  "ffffd4fed98efe9929d95f0e993404",
  "ffffd4fee391fec44ffe9929d95f0e993404",
  "ffffd4fee391fec44ffe9929ec7014cc4c028c2d04",
  "ffffe5fff7bcfee391fec44ffe9929ec7014cc4c028c2d04",
  "ffffe5fff7bcfee391fec44ffe9929ec7014cc4c02993404662506"
).map(cn);
const lat = or($C);
var OC = new Array(3).concat(
  "ffeda0feb24cf03b20",
  "ffffb2fecc5cfd8d3ce31a1c",
  "ffffb2fecc5cfd8d3cf03b20bd0026",
  "ffffb2fed976feb24cfd8d3cf03b20bd0026",
  "ffffb2fed976feb24cfd8d3cfc4e2ae31a1cb10026",
  "ffffccffeda0fed976feb24cfd8d3cfc4e2ae31a1cb10026",
  "ffffccffeda0fed976feb24cfd8d3cfc4e2ae31a1cbd0026800026"
).map(cn);
const uat = or(OC);
var PC = new Array(3).concat(
  "deebf79ecae13182bd",
  "eff3ffbdd7e76baed62171b5",
  "eff3ffbdd7e76baed63182bd08519c",
  "eff3ffc6dbef9ecae16baed63182bd08519c",
  "eff3ffc6dbef9ecae16baed64292c62171b5084594",
  "f7fbffdeebf7c6dbef9ecae16baed64292c62171b5084594",
  "f7fbffdeebf7c6dbef9ecae16baed64292c62171b508519c08306b"
).map(cn);
const dat = or(PC);
var MC = new Array(3).concat(
  "e5f5e0a1d99b31a354",
  "edf8e9bae4b374c476238b45",
  "edf8e9bae4b374c47631a354006d2c",
  "edf8e9c7e9c0a1d99b74c47631a354006d2c",
  "edf8e9c7e9c0a1d99b74c47641ab5d238b45005a32",
  "f7fcf5e5f5e0c7e9c0a1d99b74c47641ab5d238b45005a32",
  "f7fcf5e5f5e0c7e9c0a1d99b74c47641ab5d238b45006d2c00441b"
).map(cn);
const fat = or(MC);
var kC = new Array(3).concat(
  "f0f0f0bdbdbd636363",
  "f7f7f7cccccc969696525252",
  "f7f7f7cccccc969696636363252525",
  "f7f7f7d9d9d9bdbdbd969696636363252525",
  "f7f7f7d9d9d9bdbdbd969696737373525252252525",
  "fffffff0f0f0d9d9d9bdbdbd969696737373525252252525",
  "fffffff0f0f0d9d9d9bdbdbd969696737373525252252525000000"
).map(cn);
const hat = or(kC);
var NC = new Array(3).concat(
  "efedf5bcbddc756bb1",
  "f2f0f7cbc9e29e9ac86a51a3",
  "f2f0f7cbc9e29e9ac8756bb154278f",
  "f2f0f7dadaebbcbddc9e9ac8756bb154278f",
  "f2f0f7dadaebbcbddc9e9ac8807dba6a51a34a1486",
  "fcfbfdefedf5dadaebbcbddc9e9ac8807dba6a51a34a1486",
  "fcfbfdefedf5dadaebbcbddc9e9ac8807dba6a51a354278f3f007d"
).map(cn);
const gat = or(NC);
var DC = new Array(3).concat(
  "fee0d2fc9272de2d26",
  "fee5d9fcae91fb6a4acb181d",
  "fee5d9fcae91fb6a4ade2d26a50f15",
  "fee5d9fcbba1fc9272fb6a4ade2d26a50f15",
  "fee5d9fcbba1fc9272fb6a4aef3b2ccb181d99000d",
  "fff5f0fee0d2fcbba1fc9272fb6a4aef3b2ccb181d99000d",
  "fff5f0fee0d2fcbba1fc9272fb6a4aef3b2ccb181da50f1567000d"
).map(cn);
const pat = or(DC);
var LC = new Array(3).concat(
  "fee6cefdae6be6550d",
  "feeddefdbe85fd8d3cd94701",
  "feeddefdbe85fd8d3ce6550da63603",
  "feeddefdd0a2fdae6bfd8d3ce6550da63603",
  "feeddefdd0a2fdae6bfd8d3cf16913d948018c2d04",
  "fff5ebfee6cefdd0a2fdae6bfd8d3cf16913d948018c2d04",
  "fff5ebfee6cefdd0a2fdae6bfd8d3cf16913d94801a636037f2704"
).map(cn);
const mat = or(LC);
function vat(e) {
  return e = Math.max(0, Math.min(1, e)), "rgb(" + Math.max(0, Math.min(255, Math.round(-4.54 - e * (35.34 - e * (2381.73 - e * (6402.7 - e * (7024.72 - e * 2710.57))))))) + ", " + Math.max(0, Math.min(255, Math.round(32.49 + e * (170.73 + e * (52.82 - e * (131.46 - e * (176.58 - e * 67.37))))))) + ", " + Math.max(0, Math.min(255, Math.round(81.24 + e * (442.36 - e * (2482.43 - e * (6167.24 - e * (6614.94 - e * 2475.67))))))) + ")";
}
const yat = wM(pc(300, 0.5, 0), pc(-240, 0.5, 1));
var bat = wM(pc(-100, 0.75, 0.35), pc(80, 1.5, 0.8)), _at = wM(pc(260, 0.75, 0.35), pc(80, 1.5, 0.8)), u1 = pc();
function Sat(e) {
  (e < 0 || e > 1) && (e -= Math.floor(e));
  var t = Math.abs(e - 0.5);
  return u1.h = 360 * e - 100, u1.s = 1.5 - 1.5 * t, u1.l = 0.8 - 0.9 * t, u1 + "";
}
var d1 = Vg(), wat = Math.PI / 3, xat = Math.PI * 2 / 3;
function Eat(e) {
  var t;
  return e = (0.5 - e) * Math.PI, d1.r = 255 * (t = Math.sin(e)) * t, d1.g = 255 * (t = Math.sin(e + wat)) * t, d1.b = 255 * (t = Math.sin(e + xat)) * t, d1 + "";
}
function Cat(e) {
  return e = Math.max(0, Math.min(1, e)), "rgb(" + Math.max(0, Math.min(255, Math.round(34.61 + e * (1172.33 - e * (10793.56 - e * (33300.12 - e * (38394.49 - e * 14825.05))))))) + ", " + Math.max(0, Math.min(255, Math.round(23.31 + e * (557.33 + e * (1225.33 - e * (3574.96 - e * (1073.77 + e * 707.56))))))) + ", " + Math.max(0, Math.min(255, Math.round(27.2 + e * (3211.1 - e * (15327.97 - e * (27814 - e * (22569.18 - e * 6838.66))))))) + ")";
}
function jC(e) {
  var t = e.length;
  return function(n) {
    return e[Math.max(0, Math.min(t - 1, Math.floor(n * t)))];
  };
}
const Tat = jC(cn("44015444025645045745055946075a46085c460a5d460b5e470d60470e6147106347116447136548146748166848176948186a481a6c481b6d481c6e481d6f481f70482071482173482374482475482576482677482878482979472a7a472c7a472d7b472e7c472f7d46307e46327e46337f463480453581453781453882443983443a83443b84433d84433e85423f854240864241864142874144874045884046883f47883f48893e49893e4a893e4c8a3d4d8a3d4e8a3c4f8a3c508b3b518b3b528b3a538b3a548c39558c39568c38588c38598c375a8c375b8d365c8d365d8d355e8d355f8d34608d34618d33628d33638d32648e32658e31668e31678e31688e30698e306a8e2f6b8e2f6c8e2e6d8e2e6e8e2e6f8e2d708e2d718e2c718e2c728e2c738e2b748e2b758e2a768e2a778e2a788e29798e297a8e297b8e287c8e287d8e277e8e277f8e27808e26818e26828e26828e25838e25848e25858e24868e24878e23888e23898e238a8d228b8d228c8d228d8d218e8d218f8d21908d21918c20928c20928c20938c1f948c1f958b1f968b1f978b1f988b1f998a1f9a8a1e9b8a1e9c891e9d891f9e891f9f881fa0881fa1881fa1871fa28720a38620a48621a58521a68522a78522a88423a98324aa8325ab8225ac8226ad8127ad8128ae8029af7f2ab07f2cb17e2db27d2eb37c2fb47c31b57b32b67a34b67935b77937b87838b9773aba763bbb753dbc743fbc7340bd7242be7144bf7046c06f48c16e4ac16d4cc26c4ec36b50c46a52c56954c56856c66758c7655ac8645cc8635ec96260ca6063cb5f65cb5e67cc5c69cd5b6ccd5a6ece5870cf5773d05675d05477d1537ad1517cd2507fd34e81d34d84d44b86d54989d5488bd6468ed64590d74393d74195d84098d83e9bd93c9dd93ba0da39a2da37a5db36a8db34aadc32addc30b0dd2fb2dd2db5de2bb8de29bade28bddf26c0df25c2df23c5e021c8e020cae11fcde11dd0e11cd2e21bd5e21ad8e219dae319dde318dfe318e2e418e5e419e7e419eae51aece51befe51cf1e51df4e61ef6e620f8e621fbe723fde725"));
var Iat = jC(cn("00000401000501010601010802010902020b02020d03030f03031204041405041606051806051a07061c08071e0907200a08220b09240c09260d0a290e0b2b100b2d110c2f120d31130d34140e36150e38160f3b180f3d19103f1a10421c10441d11471e114920114b21114e22115024125325125527125829115a2a115c2c115f2d11612f116331116533106734106936106b38106c390f6e3b0f703d0f713f0f72400f74420f75440f764510774710784910784a10794c117a4e117b4f127b51127c52137c54137d56147d57157e59157e5a167e5c167f5d177f5f187f601880621980641a80651a80671b80681c816a1c816b1d816d1d816e1e81701f81721f817320817521817621817822817922827b23827c23827e24828025828125818326818426818627818827818928818b29818c29818e2a81902a81912b81932b80942c80962c80982d80992d809b2e7f9c2e7f9e2f7fa02f7fa1307ea3307ea5317ea6317da8327daa337dab337cad347cae347bb0357bb2357bb3367ab5367ab73779b83779ba3878bc3978bd3977bf3a77c03a76c23b75c43c75c53c74c73d73c83e73ca3e72cc3f71cd4071cf4070d0416fd2426fd3436ed5446dd6456cd8456cd9466bdb476adc4869de4968df4a68e04c67e24d66e34e65e44f64e55064e75263e85362e95462ea5661eb5760ec5860ed5a5fee5b5eef5d5ef05f5ef1605df2625df2645cf3655cf4675cf4695cf56b5cf66c5cf66e5cf7705cf7725cf8745cf8765cf9785df9795df97b5dfa7d5efa7f5efa815ffb835ffb8560fb8761fc8961fc8a62fc8c63fc8e64fc9065fd9266fd9467fd9668fd9869fd9a6afd9b6bfe9d6cfe9f6dfea16efea36ffea571fea772fea973feaa74feac76feae77feb078feb27afeb47bfeb67cfeb77efeb97ffebb81febd82febf84fec185fec287fec488fec68afec88cfeca8dfecc8ffecd90fecf92fed194fed395fed597fed799fed89afdda9cfddc9efddea0fde0a1fde2a3fde3a5fde5a7fde7a9fde9aafdebacfcecaefceeb0fcf0b2fcf2b4fcf4b6fcf6b8fcf7b9fcf9bbfcfbbdfcfdbf")), Aat = jC(cn("00000401000501010601010802010a02020c02020e03021004031204031405041706041907051b08051d09061f0a07220b07240c08260d08290e092b10092d110a30120a32140b34150b37160b39180c3c190c3e1b0c411c0c431e0c451f0c48210c4a230c4c240c4f260c51280b53290b552b0b572d0b592f0a5b310a5c320a5e340a5f3609613809623909633b09643d09653e0966400a67420a68440a68450a69470b6a490b6a4a0c6b4c0c6b4d0d6c4f0d6c510e6c520e6d540f6d550f6d57106e59106e5a116e5c126e5d126e5f136e61136e62146e64156e65156e67166e69166e6a176e6c186e6d186e6f196e71196e721a6e741a6e751b6e771c6d781c6d7a1d6d7c1d6d7d1e6d7f1e6c801f6c82206c84206b85216b87216b88226a8a226a8c23698d23698f24699025689225689326679526679727669827669a28659b29649d29649f2a63a02a63a22b62a32c61a52c60a62d60a82e5fa92e5eab2f5ead305dae305cb0315bb1325ab3325ab43359b63458b73557b93556ba3655bc3754bd3853bf3952c03a51c13a50c33b4fc43c4ec63d4dc73e4cc83f4bca404acb4149cc4248ce4347cf4446d04545d24644d34743d44842d54a41d74b3fd84c3ed94d3dda4e3cdb503bdd513ade5238df5337e05536e15635e25734e35933e45a31e55c30e65d2fe75e2ee8602de9612bea632aeb6429eb6628ec6726ed6925ee6a24ef6c23ef6e21f06f20f1711ff1731df2741cf3761bf37819f47918f57b17f57d15f67e14f68013f78212f78410f8850ff8870ef8890cf98b0bf98c0af98e09fa9008fa9207fa9407fb9606fb9706fb9906fb9b06fb9d07fc9f07fca108fca309fca50afca60cfca80dfcaa0ffcac11fcae12fcb014fcb216fcb418fbb61afbb81dfbba1ffbbc21fbbe23fac026fac228fac42afac62df9c72ff9c932f9cb35f8cd37f8cf3af7d13df7d340f6d543f6d746f5d949f5db4cf4dd4ff4df53f4e156f3e35af3e55df2e661f2e865f2ea69f1ec6df1ed71f1ef75f1f179f2f27df2f482f3f586f3f68af4f88ef5f992f6fa96f8fb9af9fc9dfafda1fcffa4")), Rat = jC(cn("0d088710078813078916078a19068c1b068d1d068e20068f2206902406912605912805922a05932c05942e05952f059631059733059735049837049938049a3a049a3c049b3e049c3f049c41049d43039e44039e46039f48039f4903a04b03a14c02a14e02a25002a25102a35302a35502a45601a45801a45901a55b01a55c01a65e01a66001a66100a76300a76400a76600a76700a86900a86a00a86c00a86e00a86f00a87100a87201a87401a87501a87701a87801a87a02a87b02a87d03a87e03a88004a88104a78305a78405a78606a68707a68808a68a09a58b0aa58d0ba58e0ca48f0da4910ea3920fa39410a29511a19613a19814a099159f9a169f9c179e9d189d9e199da01a9ca11b9ba21d9aa31e9aa51f99a62098a72197a82296aa2395ab2494ac2694ad2793ae2892b02991b12a90b22b8fb32c8eb42e8db52f8cb6308bb7318ab83289ba3388bb3488bc3587bd3786be3885bf3984c03a83c13b82c23c81c33d80c43e7fc5407ec6417dc7427cc8437bc9447aca457acb4679cc4778cc4977cd4a76ce4b75cf4c74d04d73d14e72d24f71d35171d45270d5536fd5546ed6556dd7566cd8576bd9586ada5a6ada5b69db5c68dc5d67dd5e66de5f65de6164df6263e06363e16462e26561e26660e3685fe4695ee56a5de56b5de66c5ce76e5be76f5ae87059e97158e97257ea7457eb7556eb7655ec7754ed7953ed7a52ee7b51ef7c51ef7e50f07f4ff0804ef1814df1834cf2844bf3854bf3874af48849f48948f58b47f58c46f68d45f68f44f79044f79143f79342f89441f89540f9973ff9983ef99a3efa9b3dfa9c3cfa9e3bfb9f3afba139fba238fca338fca537fca636fca835fca934fdab33fdac33fdae32fdaf31fdb130fdb22ffdb42ffdb52efeb72dfeb82cfeba2cfebb2bfebd2afebe2afec029fdc229fdc328fdc527fdc627fdc827fdca26fdcb26fccd25fcce25fcd025fcd225fbd324fbd524fbd724fad824fada24f9dc24f9dd25f8df25f8e125f7e225f7e425f6e626f6e826f5e926f5eb27f4ed27f3ee27f3f027f2f227f1f426f1f525f0f724f0f921")), $at = uM, Oat = gee, Pat = pee, Mat = gy, kat = Mp, Nat = dM, Dat = 200;
function Lat(e, t, n, r) {
  var i = -1, o = Oat, a = !0, s = e.length, c = [], l = t.length;
  if (!s)
    return c;
  n && (t = Mat(t, kat(n))), r ? (o = Pat, a = !1) : t.length >= Dat && (o = Nat, a = !1, t = new $at(t));
  e:
    for (; ++i < s; ) {
      var u = e[i], d = n == null ? u : n(u);
      if (u = r || u !== 0 ? u : 0, a && d === d) {
        for (var f = l; f--; )
          if (t[f] === d)
            continue e;
        c.push(u);
      } else
        o(t, d, r) || c.push(u);
    }
  return c;
}
var jat = Lat, Fat = jat, Vat = OE, Bat = Aie, zat = Vat(function(e, t) {
  return Bat(e) ? Fat(e, t) : [];
}), Hat = zat;
const Bie = /* @__PURE__ */ pn(Hat);
var Uat = { background: "transparent", text: { fontFamily: "sans-serif", fontSize: 11, fill: "#333333", outlineWidth: 0, outlineColor: "transparent", outlineOpacity: 1 }, axis: { domain: { line: { stroke: "transparent", strokeWidth: 1 } }, ticks: { line: { stroke: "#777777", strokeWidth: 1 }, text: {} }, legend: { text: { fontSize: 12 } } }, grid: { line: { stroke: "#dddddd", strokeWidth: 1 } }, legends: { hidden: { symbol: { fill: "#333333", opacity: 0.6 }, text: { fill: "#333333", opacity: 0.6 } }, text: {}, ticks: { line: { stroke: "#777777", strokeWidth: 1 }, text: { fontSize: 10 } }, title: { text: {} } }, labels: { text: {} }, markers: { lineColor: "#000000", lineStrokeWidth: 1, text: {} }, dots: { text: {} }, tooltip: { container: { background: "white", color: "inherit", fontSize: "inherit", borderRadius: "2px", boxShadow: "0 1px 2px rgba(0, 0, 0, 0.25)", padding: "5px 9px" }, basic: { whiteSpace: "pre", display: "flex", alignItems: "center" }, chip: { marginRight: 7 }, table: {}, tableCell: { padding: "3px 5px" }, tableCellValue: { fontWeight: "bold" } }, crosshair: { line: { stroke: "#000000", strokeWidth: 1, strokeOpacity: 0.75, strokeDasharray: "6 6" } }, annotations: { text: { fontSize: 13, outlineWidth: 2, outlineColor: "#ffffff", outlineOpacity: 1 }, link: { stroke: "#000000", strokeWidth: 1, outlineWidth: 2, outlineColor: "#ffffff", outlineOpacity: 1 }, outline: { fill: "none", stroke: "#000000", strokeWidth: 2, outlineWidth: 2, outlineColor: "#ffffff", outlineOpacity: 1 }, symbol: { fill: "#000000", outlineWidth: 2, outlineColor: "#ffffff", outlineOpacity: 1 } } };
function $u() {
  return $u = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, $u.apply(this, arguments);
}
function ek(e, t) {
  if (e == null)
    return {};
  var n, r, i = {}, o = Object.keys(e);
  for (r = 0; r < o.length; r++)
    n = o[r], t.indexOf(n) >= 0 || (i[n] = e[n]);
  return i;
}
var Wat = ["axis.ticks.text", "axis.legend.text", "legends.title.text", "legends.text", "legends.ticks.text", "legends.title.text", "labels.text", "dots.text", "markers.text", "annotations.text"], qat = function(e, t) {
  return $u({}, t, e);
}, Gat = function(e, t) {
  var n = Oot({}, e, t);
  return Wat.forEach(function(r) {
    Not(n, r, qat(uf(n, r), n.text));
  }), n;
}, zie = Is(), Hie = function(e) {
  var t = e.children, n = e.animate, r = n === void 0 || n, i = e.config, o = i === void 0 ? "default" : i, a = At(function() {
    var s = Oie(o) ? G3[o] : o;
    return { animate: r, config: s };
  }, [r, o]);
  return M.jsx(zie.Provider, { value: a, children: t });
}, kV = { animate: me.bool, motionConfig: me.oneOfType([me.oneOf(Object.keys(G3)), me.shape({ mass: me.number, tension: me.number, friction: me.number, clamp: me.bool, precision: me.number, velocity: me.number, duration: me.number, easing: me.func })]) };
Hie.propTypes = { children: me.node.isRequired, animate: kV.animate, config: kV.motionConfig };
var Os = function() {
  return St(zie);
}, Kat = function(e) {
  var t = Os(), n = t.animate, r = t.config, i = function(s) {
    var c = Me();
    return gt(function() {
      c.current = s;
    }, [s]), c.current;
  }(e), o = At(function() {
    return FZ(i, e);
  }, [i, e]), a = bl({ from: { value: 0 }, to: { value: 1 }, reset: !0, config: r, immediate: !n }).value;
  return yie(a, o);
}, Yat = { nivo: ["#d76445", "#f47560", "#e8c1a0", "#97e3d5", "#61cdbb", "#00b0a7"], BrBG: Ot(dC), PRGn: Ot(fC), PiYG: Ot(hC), PuOr: Ot(gC), RdBu: Ot(pC), RdGy: Ot(mC), RdYlBu: Ot(vC), RdYlGn: Ot(yC), spectral: Ot(bC), blues: Ot(PC), greens: Ot(MC), greys: Ot(kC), oranges: Ot(LC), purples: Ot(NC), reds: Ot(DC), BuGn: Ot(_C), BuPu: Ot(SC), GnBu: Ot(wC), OrRd: Ot(xC), PuBuGn: Ot(EC), PuBu: Ot(CC), PuRd: Ot(TC), RdPu: Ot(IC), YlGnBu: Ot(AC), YlGn: Ot(RC), YlOrBr: Ot($C), YlOrRd: Ot(OC) }, Xat = Object.keys(Yat);
Ot(dC), Ot(fC), Ot(hC), Ot(gC), Ot(pC), Ot(mC), Ot(vC), Ot(yC), Ot(bC), Ot(PC), Ot(MC), Ot(kC), Ot(LC), Ot(NC), Ot(DC), Ot(_C), Ot(SC), Ot(wC), Ot(xC), Ot(EC), Ot(CC), Ot(TC), Ot(IC), Ot(AC), Ot(RC), Ot($C), Ot(OC);
me.oneOfType([me.oneOf(Xat), me.func, me.arrayOf(me.string)]);
var Qat = { basis: hne, basisClosed: pne, basisOpen: vne, bundle: bne, cardinal: _ne, cardinalClosed: Sne, cardinalOpen: wne, catmullRom: Ene, catmullRomClosed: Tne, catmullRomOpen: Ane, linear: Hp, linearClosed: $ne, monotoneX: Mne, monotoneY: kne, natural: Dne, step: Lne, stepAfter: Fne, stepBefore: jne }, tk = Object.keys(Qat);
tk.filter(function(e) {
  return e.endsWith("Closed");
});
Bie(tk, "bundle", "basisClosed", "basisOpen", "cardinalClosed", "cardinalOpen", "catmullRomClosed", "catmullRomOpen", "linearClosed");
Bie(tk, "bundle", "basisClosed", "basisOpen", "cardinalClosed", "cardinalOpen", "catmullRomClosed", "catmullRomOpen", "linearClosed");
me.shape({ top: me.number, right: me.number, bottom: me.number, left: me.number }).isRequired;
var Jat = ["normal", "multiply", "screen", "overlay", "darken", "lighten", "color-dodge", "color-burn", "hard-light", "soft-light", "difference", "exclusion", "hue", "saturation", "color", "luminosity"];
me.oneOf(Jat);
Gc(Z3);
var Uie = { top: 0, right: 0, bottom: 0, left: 0 }, Zat = function(e, t, n) {
  return n === void 0 && (n = {}), At(function() {
    var r = $u({}, Uie, n);
    return { margin: r, innerWidth: e - r.left - r.right, innerHeight: t - r.top - r.bottom, outerWidth: e, outerHeight: t };
  }, [e, t, n.top, n.right, n.bottom, n.left]);
}, Wie = function() {
  var e = Me(null), t = Lt({ left: 0, top: 0, width: 0, height: 0 }), n = t[0], r = t[1], i = Lt(function() {
    return typeof ResizeObserver > "u" ? null : new ResizeObserver(function(o) {
      var a = o[0];
      return r(a.contentRect);
    });
  })[0];
  return gt(function() {
    return e.current && i !== null && i.observe(e.current), function() {
      i !== null && i.disconnect();
    };
  }, []), [e, n];
}, est = function(e) {
  return At(function() {
    return Gat(Uat, e);
  }, [e]);
}, tst = function(e) {
  return typeof e == "function" ? e : typeof e == "string" ? e.indexOf("time:") === 0 ? BE(e.slice("5")) : Ay(e) : function(t) {
    return "" + t;
  };
}, qie = function(e) {
  return At(function() {
    return tst(e);
  }, [e]);
}, Gie = Is(), nst = {}, Kie = function(e) {
  var t = e.theme, n = t === void 0 ? nst : t, r = e.children, i = est(n);
  return M.jsx(Gie.Provider, { value: i, children: r });
};
Kie.propTypes = { children: me.node.isRequired, theme: me.object };
var go = function() {
  return St(Gie);
}, rst = ["outlineWidth", "outlineColor", "outlineOpacity"], Yie = function(e) {
  return e.outlineWidth, e.outlineColor, e.outlineOpacity, ek(e, rst);
}, Xie = function(e) {
  var t = e.children, n = e.condition, r = e.wrapper;
  return n ? $z(r, {}, t) : t;
};
Xie.propTypes = { children: me.node.isRequired, condition: me.bool.isRequired, wrapper: me.element.isRequired };
var ist = { position: "relative" }, Qie = function(e) {
  var t = e.children, n = e.theme, r = e.renderWrapper, i = r === void 0 || r, o = e.isInteractive, a = o === void 0 || o, s = e.animate, c = e.motionConfig, l = Me(null);
  return M.jsx(Kie, { theme: n, children: M.jsx(Hie, { animate: s, config: c, children: M.jsx(Lit, { container: l, children: M.jsxs(Xie, { condition: i, wrapper: M.jsx("div", { style: ist, ref: l }), children: [t, a && M.jsx(Dit, {})] }) }) }) });
};
Qie.propTypes = { children: me.element.isRequired, isInteractive: me.bool, renderWrapper: me.bool, theme: me.object, animate: me.bool, motionConfig: me.string };
me.func.isRequired, me.bool, me.bool, me.object.isRequired, me.bool.isRequired, me.string;
var Jie = function(e) {
  var t = e.children, n = Wie(), r = n[0], i = n[1], o = i.width > 0 && i.height > 0;
  return M.jsx("div", { ref: r, style: { width: "100%", height: "100%" }, children: o && t({ width: i.width, height: i.height }) });
};
Jie.propTypes = { children: me.func.isRequired };
var ost = ["id", "colors"], Zie = function(e) {
  var t = e.id, n = e.colors, r = ek(e, ost);
  return M.jsx("linearGradient", $u({ id: t, x1: 0, x2: 0, y1: 0, y2: 1 }, r, { children: n.map(function(i) {
    var o = i.offset, a = i.color, s = i.opacity;
    return M.jsx("stop", { offset: o + "%", stopColor: a, stopOpacity: s !== void 0 ? s : 1 }, o);
  }) }));
};
Zie.propTypes = { id: me.string.isRequired, colors: me.arrayOf(me.shape({ offset: me.number.isRequired, color: me.string.isRequired, opacity: me.number })).isRequired, gradientTransform: me.string };
var ast = { linearGradient: Zie }, Cm = { color: "#000000", background: "#ffffff", size: 4, padding: 4, stagger: !1 }, x$ = hi(function(e) {
  var t = e.id, n = e.background, r = n === void 0 ? Cm.background : n, i = e.color, o = i === void 0 ? Cm.color : i, a = e.size, s = a === void 0 ? Cm.size : a, c = e.padding, l = c === void 0 ? Cm.padding : c, u = e.stagger, d = u === void 0 ? Cm.stagger : u, f = s + l, h = s / 2, p = l / 2;
  return d === !0 && (f = 2 * s + 2 * l), M.jsxs("pattern", { id: t, width: f, height: f, patternUnits: "userSpaceOnUse", children: [M.jsx("rect", { width: f, height: f, fill: r }), M.jsx("circle", { cx: p + h, cy: p + h, r: h, fill: o }), d && M.jsx("circle", { cx: 1.5 * l + s + h, cy: 1.5 * l + s + h, r: h, fill: o })] });
});
x$.displayName = "PatternDots", x$.propTypes = { id: me.string.isRequired, color: me.string.isRequired, background: me.string.isRequired, size: me.number.isRequired, padding: me.number.isRequired, stagger: me.bool.isRequired };
var E$ = function(e) {
  return e * Math.PI / 180;
}, sst = function(e) {
  return 180 * e / Math.PI;
}, cst = function(e, t) {
  return { x: Math.cos(e) * t, y: Math.sin(e) * t };
}, lst = function(e) {
  var t = e % 360;
  return t < 0 && (t += 360), t;
}, ust = { svg: { align: { left: "start", center: "middle", right: "end", start: "start", middle: "middle", end: "end" }, baseline: { top: "text-before-edge", center: "central", bottom: "alphabetic" } }, canvas: { align: { left: "left", center: "center", right: "right", start: "left", middle: "center", end: "right" }, baseline: { top: "top", center: "middle", bottom: "bottom" } } }, Tm = { spacing: 5, rotation: 0, background: "#000000", color: "#ffffff", lineWidth: 2 }, C$ = hi(function(e) {
  var t = e.id, n = e.spacing, r = n === void 0 ? Tm.spacing : n, i = e.rotation, o = i === void 0 ? Tm.rotation : i, a = e.background, s = a === void 0 ? Tm.background : a, c = e.color, l = c === void 0 ? Tm.color : c, u = e.lineWidth, d = u === void 0 ? Tm.lineWidth : u, f = Math.round(o) % 360, h = Math.abs(r);
  f > 180 ? f -= 360 : f > 90 ? f -= 180 : f < -180 ? f += 360 : f < -90 && (f += 180);
  var p, g = h, m = h;
  return f === 0 ? p = `
                M 0 0 L ` + g + ` 0
                M 0 ` + m + " L " + g + " " + m + `
            ` : f === 90 ? p = `
                M 0 0 L 0 ` + m + `
                M ` + g + " 0 L " + g + " " + m + `
            ` : (g = Math.abs(h / Math.sin(E$(f))), m = h / Math.sin(E$(90 - f)), p = f > 0 ? `
                    M 0 ` + -m + " L " + 2 * g + " " + m + `
                    M ` + -g + " " + -m + " L " + g + " " + m + `
                    M ` + -g + " 0 L " + g + " " + 2 * m + `
                ` : `
                    M ` + -g + " " + m + " L " + g + " " + -m + `
                    M ` + -g + " " + 2 * m + " L " + 2 * g + " " + -m + `
                    M 0 ` + 2 * m + " L " + 2 * g + ` 0
                `), M.jsxs("pattern", { id: t, width: g, height: m, patternUnits: "userSpaceOnUse", children: [M.jsx("rect", { width: g, height: m, fill: s, stroke: "rgba(255, 0, 0, 0.1)", strokeWidth: 0 }), M.jsx("path", { d: p, strokeWidth: d, stroke: l, strokeLinecap: "square" })] });
});
C$.displayName = "PatternLines", C$.propTypes = { id: me.string.isRequired, spacing: me.number.isRequired, rotation: me.number.isRequired, background: me.string.isRequired, color: me.string.isRequired, lineWidth: me.number.isRequired };
var Im = { color: "#000000", background: "#ffffff", size: 4, padding: 4, stagger: !1 }, T$ = hi(function(e) {
  var t = e.id, n = e.color, r = n === void 0 ? Im.color : n, i = e.background, o = i === void 0 ? Im.background : i, a = e.size, s = a === void 0 ? Im.size : a, c = e.padding, l = c === void 0 ? Im.padding : c, u = e.stagger, d = u === void 0 ? Im.stagger : u, f = s + l, h = l / 2;
  return d === !0 && (f = 2 * s + 2 * l), M.jsxs("pattern", { id: t, width: f, height: f, patternUnits: "userSpaceOnUse", children: [M.jsx("rect", { width: f, height: f, fill: o }), M.jsx("rect", { x: h, y: h, width: s, height: s, fill: r }), d && M.jsx("rect", { x: 1.5 * l + s, y: 1.5 * l + s, width: s, height: s, fill: r })] });
});
T$.displayName = "PatternSquares", T$.propTypes = { id: me.string.isRequired, color: me.string.isRequired, background: me.string.isRequired, size: me.number.isRequired, padding: me.number.isRequired, stagger: me.bool.isRequired };
var dst = { patternDots: x$, patternLines: C$, patternSquares: T$ }, fst = ["type"], I$ = $u({}, ast, dst), eoe = function(e) {
  var t = e.defs;
  return !t || t.length < 1 ? null : M.jsx("defs", { "aria-hidden": !0, children: t.map(function(n) {
    var r = n.type, i = ek(n, fst);
    return I$[r] ? Yd(I$[r], $u({ key: i.id }, i)) : null;
  }) });
};
eoe.propTypes = { defs: me.arrayOf(me.shape({ type: me.oneOf(Object.keys(I$)).isRequired, id: me.string.isRequired })) };
var hst = hi(eoe), toe = function(e) {
  var t = e.width, n = e.height, r = e.margin, i = e.defs, o = e.children, a = e.role, s = e.ariaLabel, c = e.ariaLabelledBy, l = e.ariaDescribedBy, u = e.isFocusable, d = go();
  return M.jsxs("svg", { xmlns: "http://www.w3.org/2000/svg", width: t, height: n, role: a, "aria-label": s, "aria-labelledby": c, "aria-describedby": l, focusable: u, tabIndex: u ? 0 : void 0, children: [M.jsx(hst, { defs: i }), M.jsx("rect", { width: t, height: n, fill: d.background }), M.jsx("g", { transform: "translate(" + r.left + "," + r.top + ")", children: o })] });
};
toe.propTypes = { width: me.number.isRequired, height: me.number.isRequired, margin: me.shape({ top: me.number.isRequired, left: me.number.isRequired }).isRequired, defs: me.array, children: me.oneOfType([me.arrayOf(me.node), me.node]).isRequired, role: me.string, isFocusable: me.bool, ariaLabel: me.string, ariaLabelledBy: me.string, ariaDescribedBy: me.string };
var noe = function(e) {
  var t = e.size, n = e.color, r = e.borderWidth, i = e.borderColor;
  return M.jsx("circle", { r: t / 2, fill: n, stroke: i, strokeWidth: r, style: { pointerEvents: "none" } });
};
noe.propTypes = { size: me.number.isRequired, color: me.string.isRequired, borderWidth: me.number.isRequired, borderColor: me.string.isRequired };
var gst = hi(noe), roe = function(e) {
  var t = e.x, n = e.y, r = e.symbol, i = r === void 0 ? gst : r, o = e.size, a = e.datum, s = e.color, c = e.borderWidth, l = e.borderColor, u = e.label, d = e.labelTextAnchor, f = d === void 0 ? "middle" : d, h = e.labelYOffset, p = h === void 0 ? -12 : h, g = go(), m = Os(), v = m.animate, y = m.config, S = bl({ transform: "translate(" + t + ", " + n + ")", config: y, immediate: !v });
  return M.jsxs(wi.g, { transform: S.transform, style: { pointerEvents: "none" }, children: [Yd(i, { size: o, color: s, datum: a, borderWidth: c, borderColor: l }), u && M.jsx("text", { textAnchor: f, y: p, style: Yie(g.dots.text), children: u })] });
};
roe.propTypes = { x: me.number.isRequired, y: me.number.isRequired, datum: me.object.isRequired, size: me.number.isRequired, color: me.string.isRequired, borderWidth: me.number.isRequired, borderColor: me.string.isRequired, symbol: me.oneOfType([me.func, me.object]), label: me.oneOfType([me.string, me.number]), labelTextAnchor: me.oneOf(["start", "middle", "end"]), labelYOffset: me.number };
hi(roe);
var ioe = function(e) {
  var t = e.width, n = e.height, r = e.axis, i = e.scale, o = e.value, a = e.lineStyle, s = e.textStyle, c = e.legend, l = e.legendPosition, u = l === void 0 ? "top-right" : l, d = e.legendOffsetX, f = d === void 0 ? 14 : d, h = e.legendOffsetY, p = h === void 0 ? 14 : h, g = e.legendOrientation, m = g === void 0 ? "horizontal" : g, v = go(), y = 0, S = 0, _ = 0, w = 0;
  r === "y" ? (_ = i(o), S = t) : (y = i(o), w = n);
  var T = null;
  if (c) {
    var x = function(C) {
      var E = C.axis, R = C.width, A = C.height, O = C.position, $ = C.offsetX, N = C.offsetY, z = C.orientation, k = 0, F = 0, V = z === "vertical" ? -90 : 0, j = "start";
      if (E === "x")
        switch (O) {
          case "top-left":
            k = -$, F = N, j = "end";
            break;
          case "top":
            F = -N, j = z === "horizontal" ? "middle" : "start";
            break;
          case "top-right":
            k = $, F = N, j = z === "horizontal" ? "start" : "end";
            break;
          case "right":
            k = $, F = A / 2, j = z === "horizontal" ? "start" : "middle";
            break;
          case "bottom-right":
            k = $, F = A - N, j = "start";
            break;
          case "bottom":
            F = A + N, j = z === "horizontal" ? "middle" : "end";
            break;
          case "bottom-left":
            F = A - N, k = -$, j = z === "horizontal" ? "end" : "start";
            break;
          case "left":
            k = -$, F = A / 2, j = z === "horizontal" ? "end" : "middle";
        }
      else
        switch (O) {
          case "top-left":
            k = $, F = -N, j = "start";
            break;
          case "top":
            k = R / 2, F = -N, j = z === "horizontal" ? "middle" : "start";
            break;
          case "top-right":
            k = R - $, F = -N, j = z === "horizontal" ? "end" : "start";
            break;
          case "right":
            k = R + $, j = z === "horizontal" ? "start" : "middle";
            break;
          case "bottom-right":
            k = R - $, F = N, j = "end";
            break;
          case "bottom":
            k = R / 2, F = N, j = z === "horizontal" ? "middle" : "end";
            break;
          case "bottom-left":
            k = $, F = N, j = z === "horizontal" ? "start" : "end";
            break;
          case "left":
            k = -$, j = z === "horizontal" ? "end" : "middle";
        }
      return { x: k, y: F, rotation: V, textAnchor: j };
    }({ axis: r, width: t, height: n, position: u, offsetX: f, offsetY: p, orientation: m });
    T = M.jsx("text", { transform: "translate(" + x.x + ", " + x.y + ") rotate(" + x.rotation + ")", textAnchor: x.textAnchor, dominantBaseline: "central", style: s, children: c });
  }
  return M.jsxs("g", { transform: "translate(" + y + ", " + _ + ")", children: [M.jsx("line", { x1: 0, x2: S, y1: 0, y2: w, stroke: v.markers.lineColor, strokeWidth: v.markers.lineStrokeWidth, style: a }), T] });
};
ioe.propTypes = { width: me.number.isRequired, height: me.number.isRequired, axis: me.oneOf(["x", "y"]).isRequired, scale: me.func.isRequired, value: me.oneOfType([me.number, me.string, me.instanceOf(Date)]).isRequired, lineStyle: me.object, textStyle: me.object, legend: me.string, legendPosition: me.oneOf(["top-left", "top", "top-right", "right", "bottom-right", "bottom", "bottom-left", "left"]), legendOffsetX: me.number.isRequired, legendOffsetY: me.number.isRequired, legendOrientation: me.oneOf(["horizontal", "vertical"]).isRequired };
var pst = hi(ioe), ooe = function(e) {
  var t = e.markers, n = e.width, r = e.height, i = e.xScale, o = e.yScale;
  return t && t.length !== 0 ? t.map(function(a, s) {
    return M.jsx(pst, $u({}, a, { width: n, height: r, scale: a.axis === "y" ? o : i }), s);
  }) : null;
};
ooe.propTypes = { width: me.number.isRequired, height: me.number.isRequired, xScale: me.func.isRequired, yScale: me.func.isRequired, markers: me.arrayOf(me.shape({ axis: me.oneOf(["x", "y"]).isRequired, value: me.oneOfType([me.number, me.string, me.instanceOf(Date)]).isRequired, lineStyle: me.object, textStyle: me.object })) };
hi(ooe);
var mst = function(e) {
  return m4e(e) ? e : function(t) {
    return uf(t, e);
  };
}, f1 = function(e) {
  return At(function() {
    return mst(e);
  }, [e]);
}, vst = function(e, t, n, r) {
  var i = n - e, o = r - t;
  return i *= i, o *= o, Math.sqrt(i + o);
}, yst = function(e, t) {
  var n, r = "touches" in t ? t.touches[0] : t, i = r.clientX, o = r.clientY, a = e.getBoundingClientRect(), s = (n = e.getBBox !== void 0 ? e.getBBox() : { width: e.offsetWidth || 0, height: e.offsetHeight || 0 }).width === a.width ? 1 : n.width / a.width;
  return [(i - a.left) * s, (o - a.top) * s];
}, bst = tee, _st = kZ, Sst = OE, NV = PE, wst = Sst(function(e, t) {
  if (e == null)
    return [];
  var n = t.length;
  return n > 1 && NV(e, t[0], t[1]) ? t = [] : n > 2 && NV(t[0], t[1], t[2]) && (t = [t[0]]), _st(e, bst(t, 1), []);
}), xst = wst;
const Est = /* @__PURE__ */ pn(xst);
var fh = [function(e) {
  return e.setMilliseconds(0);
}, function(e) {
  return e.setSeconds(0);
}, function(e) {
  return e.setMinutes(0);
}, function(e) {
  return e.setHours(0);
}, function(e) {
  return e.setDate(1);
}, function(e) {
  return e.setMonth(0);
}], Cst = { millisecond: [], second: fh.slice(0, 1), minute: fh.slice(0, 2), hour: fh.slice(0, 3), day: fh.slice(0, 4), month: fh.slice(0, 5), year: fh.slice(0, 6) }, Tst = function(e) {
  return function(t) {
    return Cst[e].forEach(function(n) {
      n(t);
    }), t;
  };
}, nk = function(e) {
  var t = e.format, n = t === void 0 ? "native" : t, r = e.precision, i = r === void 0 ? "millisecond" : r, o = e.useUTC, a = o === void 0 || o, s = Tst(i);
  return function(c) {
    if (c === void 0)
      return c;
    if (n === "native" || c instanceof Date)
      return s(c);
    var l = a ? mte(n) : gte(n);
    return s(l(c));
  };
}, Ist = function(e, t, n, r) {
  var i, o, a, s, c = e.min, l = c === void 0 ? 0 : c, u = e.max, d = u === void 0 ? "auto" : u, f = e.stacked, h = f !== void 0 && f, p = e.reverse, g = p !== void 0 && p, m = e.clamp, v = m !== void 0 && m, y = e.nice, S = y !== void 0 && y;
  l === "auto" ? i = h === !0 ? (o = t.minStacked) != null ? o : 0 : t.min : i = l, d === "auto" ? a = h === !0 ? (s = t.maxStacked) != null ? s : 0 : t.max : a = d;
  var _ = Ry().rangeRound(r === "x" ? [0, n] : [n, 0]).domain(g ? [a, i] : [i, a]).clamp(v);
  return S === !0 ? _.nice() : typeof S == "number" && _.nice(S), Ast(_, h);
}, Ast = function(e, t) {
  t === void 0 && (t = !1);
  var n = e;
  return n.type = "linear", n.stacked = t, n;
}, Rst = function(e, t, n) {
  var r = $ee().range([0, n]).domain(t.all);
  return r.type = "point", r;
}, $st = function(e, t, n, r) {
  var i = e.round, o = i === void 0 || i, a = LE().range(r === "x" ? [0, n] : [n, 0]).domain(t.all).round(o);
  return Ost(a);
}, Ost = function(e) {
  var t = e;
  return t.type = "band", t;
}, Pst = function(e, t, n) {
  var r, i, o = e.format, a = o === void 0 ? "native" : o, s = e.precision, c = s === void 0 ? "millisecond" : s, l = e.min, u = l === void 0 ? "auto" : l, d = e.max, f = d === void 0 ? "auto" : d, h = e.useUTC, p = h === void 0 || h, g = e.nice, m = g !== void 0 && g, v = nk({ format: a, precision: c, useUTC: p });
  r = u === "auto" ? v(t.min) : a !== "native" ? v(u) : u, i = f === "auto" ? v(t.max) : a !== "native" ? v(f) : f;
  var y = p ? yte() : vte();
  y.range([0, n]), r && i && y.domain([r, i]), m === !0 ? y.nice() : typeof m != "object" && typeof m != "number" || y.nice(m);
  var S = y;
  return S.type = "time", S.useUTC = p, S;
}, Mst = function(e, t, n, r) {
  var i, o = e.base, a = o === void 0 ? 10 : o, s = e.min, c = s === void 0 ? "auto" : s, l = e.max, u = l === void 0 ? "auto" : l;
  if (t.all.some(function(g) {
    return g === 0;
  }))
    throw new Error("a log scale domain must not include or cross zero");
  var d, f, h = !1;
  if (t.all.filter(function(g) {
    return g != null;
  }).forEach(function(g) {
    h || (i === void 0 ? i = Math.sign(g) : Math.sign(g) !== i && (h = !0));
  }), h)
    throw new Error("a log scale domain must be strictly-positive or strictly-negative");
  d = c === "auto" ? t.min : c, f = u === "auto" ? t.max : u;
  var p = PM().domain([d, f]).rangeRound(r === "x" ? [0, n] : [n, 0]).base(a).nice();
  return p.type = "log", p;
}, kst = function(e, t, n, r) {
  var i, o, a = e.constant, s = a === void 0 ? 1 : a, c = e.min, l = c === void 0 ? "auto" : c, u = e.max, d = u === void 0 ? "auto" : u, f = e.reverse, h = f !== void 0 && f;
  i = l === "auto" ? t.min : l, o = d === "auto" ? t.max : d;
  var p = kM().constant(s).rangeRound(r === "x" ? [0, n] : [n, 0]).nice();
  h === !0 ? p.domain([o, i]) : p.domain([i, o]);
  var g = p;
  return g.type = "symlog", g;
};
function DV(e, t, n, r) {
  switch (e.type) {
    case "linear":
      return Ist(e, t, n, r);
    case "point":
      return Rst(e, t, n);
    case "band":
      return $st(e, t, n, r);
    case "time":
      return Pst(e, t, n);
    case "log":
      return Mst(e, t, n, r);
    case "symlog":
      return kst(e, t, n, r);
    default:
      throw new Error("invalid scale spec");
  }
}
var Nst = function(e, t, n, r) {
  var i = r === void 0 ? {} : r, o = i.getValue, a = o === void 0 ? function(p) {
    return p.data[t];
  } : o, s = i.setValue, c = s === void 0 ? function(p, g) {
    p.data[t] = g;
  } : s;
  if (n.type === "linear")
    e.forEach(function(p) {
      p.data.forEach(function(g) {
        var m = a(g);
        m && c(g, parseFloat(String(m)));
      });
    });
  else if (n.type === "time" && n.format !== "native") {
    var l = nk(n);
    e.forEach(function(p) {
      p.data.forEach(function(g) {
        var m = a(g);
        m && c(g, l(m));
      });
    });
  }
  var u = [];
  switch (e.forEach(function(p) {
    p.data.forEach(function(g) {
      u.push(a(g));
    });
  }), n.type) {
    case "linear":
      var d = Est(dl(u).filter(function(p) {
        return p !== null;
      }), function(p) {
        return p;
      });
      return { all: d, min: Math.min.apply(Math, d), max: Math.max.apply(Math, d) };
    case "time":
      var f = x3(u, function(p) {
        return p.getTime();
      }).slice(0).sort(function(p, g) {
        return g.getTime() - p.getTime();
      }).reverse();
      return { all: f, min: f[0], max: Ot(f) };
    default:
      var h = dl(u);
      return { all: h, min: h[0], max: Ot(h) };
  }
}, aoe = function(e) {
  var t = e.bandwidth();
  if (t === 0)
    return e;
  var n = t / 2;
  return e.round() && (n = Math.round(n)), function(r) {
    var i;
    return ((i = e(r)) != null ? i : 0) + n;
  };
}, soe = { millisecond: [QF, QF], second: [JF, JF], minute: [kGe, LGe], hour: [NGe, jGe], day: [fi(function(e) {
  return e.setHours(0, 0, 0, 0);
}, function(e, t) {
  return e.setDate(e.getDate() + t);
}, function(e, t) {
  return (t.getTime() - e.getTime()) / 864e5;
}, function(e) {
  return Math.floor(e.getTime() / 864e5);
}), fi(function(e) {
  return e.setUTCHours(0, 0, 0, 0);
}, function(e, t) {
  return e.setUTCDate(e.getUTCDate() + t);
}, function(e, t) {
  return (t.getTime() - e.getTime()) / 864e5;
}, function(e) {
  return Math.floor(e.getTime() / 864e5);
})], week: [sw, cw], sunday: [sw, cw], monday: [_v, Sv], tuesday: [Xee, ote], wednesday: [Qee, ate], thursday: [gf, pf], friday: [Jee, ste], saturday: [Zee, cte], month: [DGe, FGe], year: [Hg, Ug] }, Dst = Object.keys(soe), Lst = new RegExp("^every\\s*(\\d+)?\\s*(" + Dst.join("|") + ")s?$", "i"), coe = function(e, t) {
  if (Array.isArray(t))
    return t;
  if (typeof t == "string" && "useUTC" in e) {
    var n = t.match(Lst);
    if (n) {
      var r = n[1], i = n[2], o = soe[i][e.useUTC ? 1 : 0];
      if (i === "day") {
        var a, s, c = e.domain(), l = c[0], u = c[1], d = new Date(u);
        return d.setDate(d.getDate() + 1), (a = (s = o.every(Number(r ?? 1))) == null ? void 0 : s.range(l, d)) != null ? a : [];
      }
      if (r === void 0)
        return e.ticks(o);
      var f = o.every(Number(r));
      if (f)
        return e.ticks(f);
    }
    throw new Error("Invalid tickValues: " + t);
  }
  if ("ticks" in e) {
    if (t === void 0)
      return e.ticks();
    if (typeof (h = t) == "number" && isFinite(h) && Math.floor(h) === h)
      return e.ticks(t);
  }
  var h;
  return e.domain();
};
function bs() {
  return bs = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, bs.apply(this, arguments);
}
var jst = function(e) {
  var t, n = e.axis, r = e.scale, i = e.ticksPosition, o = e.tickValues, a = e.tickSize, s = e.tickPadding, c = e.tickRotation, l = e.truncateTickAt, u = e.engine, d = u === void 0 ? "svg" : u, f = coe(r, o), h = ust[d], p = "bandwidth" in r ? aoe(r) : r, g = { lineX: 0, lineY: 0 }, m = { textX: 0, textY: 0 }, v = typeof document == "object" && document.dir === "rtl", y = h.align.center, S = h.baseline.center;
  return n === "x" ? (t = function(_) {
    var w;
    return { x: (w = p(_)) != null ? w : 0, y: 0 };
  }, g.lineY = a * (i === "after" ? 1 : -1), m.textY = (a + s) * (i === "after" ? 1 : -1), S = i === "after" ? h.baseline.top : h.baseline.bottom, c === 0 ? y = h.align.center : i === "after" && c < 0 || i === "before" && c > 0 ? (y = h.align[v ? "left" : "right"], S = h.baseline.center) : (i === "after" && c > 0 || i === "before" && c < 0) && (y = h.align[v ? "right" : "left"], S = h.baseline.center)) : (t = function(_) {
    var w;
    return { x: 0, y: (w = p(_)) != null ? w : 0 };
  }, g.lineX = a * (i === "after" ? 1 : -1), m.textX = (a + s) * (i === "after" ? 1 : -1), y = i === "after" ? h.align.left : h.align.right), { ticks: f.map(function(_) {
    var w = typeof _ == "string" ? function(T) {
      var x = String(T).length;
      return l && l > 0 && x > l ? "" + String(T).slice(0, l).concat("...") : "" + T;
    }(_) : _;
    return bs({ key: _ instanceof Date ? "" + _.valueOf() : "" + _, value: w }, t(_), g, m);
  }), textAlign: y, textBaseline: S };
}, Fst = function(e, t) {
  if (e === void 0 || typeof e == "function")
    return e;
  if (t.type === "time") {
    var n = BE(e);
    return function(r) {
      return n(r instanceof Date ? r : new Date(r));
    };
  }
  return Ay(e);
}, LV = function(e) {
  var t, n = e.width, r = e.height, i = e.scale, o = e.axis, a = e.values, s = (t = a, (Array.isArray(t) ? a : void 0) || coe(i, a)), c = "bandwidth" in i ? aoe(i) : i, l = o === "x" ? s.map(function(u) {
    var d, f;
    return { key: u instanceof Date ? "" + u.valueOf() : "" + u, x1: (d = c(u)) != null ? d : 0, x2: (f = c(u)) != null ? f : 0, y1: 0, y2: r };
  }) : s.map(function(u) {
    var d, f;
    return { key: u instanceof Date ? "" + u.valueOf() : "" + u, x1: 0, x2: n, y1: (d = c(u)) != null ? d : 0, y2: (f = c(u)) != null ? f : 0 };
  });
  return l;
}, Vst = hi(function(e) {
  var t, n = e.value, r = e.format, i = e.lineX, o = e.lineY, a = e.onClick, s = e.textBaseline, c = e.textAnchor, l = e.animatedProps, u = go(), d = u.axis.ticks.line, f = u.axis.ticks.text, h = (t = r == null ? void 0 : r(n)) != null ? t : n, p = At(function() {
    var g = { opacity: l.opacity };
    return a ? { style: bs({}, g, { cursor: "pointer" }), onClick: function(m) {
      return a(m, h);
    } } : { style: g };
  }, [l.opacity, a, h]);
  return M.jsxs(wi.g, bs({ transform: l.transform }, p, { children: [M.jsx("line", { x1: 0, x2: i, y1: 0, y2: o, style: d }), f.outlineWidth > 0 && M.jsx(wi.text, { dominantBaseline: s, textAnchor: c, transform: l.textTransform, style: f, strokeWidth: 2 * f.outlineWidth, stroke: f.outlineColor, strokeLinejoin: "round", children: "" + h }), M.jsx(wi.text, { dominantBaseline: s, textAnchor: c, transform: l.textTransform, style: Yie(f), children: "" + h })] }));
}), Bst = function(e) {
  var t = e.axis, n = e.scale, r = e.x, i = r === void 0 ? 0 : r, o = e.y, a = o === void 0 ? 0 : o, s = e.length, c = e.ticksPosition, l = e.tickValues, u = e.tickSize, d = u === void 0 ? 5 : u, f = e.tickPadding, h = f === void 0 ? 5 : f, p = e.tickRotation, g = p === void 0 ? 0 : p, m = e.format, v = e.renderTick, y = v === void 0 ? Vst : v, S = e.truncateTickAt, _ = e.legend, w = e.legendPosition, T = w === void 0 ? "end" : w, x = e.legendOffset, C = x === void 0 ? 0 : x, E = e.onClick, R = e.ariaHidden, A = go(), O = A.axis.legend.text, $ = At(function() {
    return Fst(m, n);
  }, [m, n]), N = jst({ axis: t, scale: n, ticksPosition: c, tickValues: l, tickSize: d, tickPadding: h, tickRotation: g, truncateTickAt: S }), z = N.ticks, k = N.textAlign, F = N.textBaseline, V = null;
  if (_ !== void 0) {
    var j, B = 0, U = 0, Q = 0;
    t === "y" ? (Q = -90, B = C, T === "start" ? (j = "start", U = s) : T === "middle" ? (j = "middle", U = s / 2) : T === "end" && (j = "end")) : (U = C, T === "start" ? j = "start" : T === "middle" ? (j = "middle", B = s / 2) : T === "end" && (j = "end", B = s)), V = M.jsxs(M.Fragment, { children: [O.outlineWidth > 0 && M.jsx("text", { transform: "translate(" + B + ", " + U + ") rotate(" + Q + ")", textAnchor: j, style: bs({ dominantBaseline: "central" }, O), strokeWidth: 2 * O.outlineWidth, stroke: O.outlineColor, strokeLinejoin: "round", children: _ }), M.jsx("text", { transform: "translate(" + B + ", " + U + ") rotate(" + Q + ")", textAnchor: j, style: bs({ dominantBaseline: "central" }, O), children: _ })] });
  }
  var K = Os(), q = K.animate, X = K.config, ie = bl({ transform: "translate(" + i + "," + a + ")", lineX2: t === "x" ? s : 0, lineY2: t === "x" ? 0 : s, config: X, immediate: !q }), te = mn(function(ee) {
    return { opacity: 1, transform: "translate(" + ee.x + "," + ee.y + ")", textTransform: "translate(" + ee.textX + "," + ee.textY + ") rotate(" + g + ")" };
  }, [g]), J = mn(function(ee) {
    return { opacity: 0, transform: "translate(" + ee.x + "," + ee.y + ")", textTransform: "translate(" + ee.textX + "," + ee.textY + ") rotate(" + g + ")" };
  }, [g]), Y = X3(z, { keys: function(ee) {
    return ee.key;
  }, initial: te, from: J, enter: te, update: te, leave: { opacity: 0 }, config: X, immediate: !q });
  return M.jsxs(wi.g, { transform: ie.transform, "aria-hidden": R, children: [Y(function(ee, Z, H, oe) {
    return I.createElement(y, bs({ tickIndex: oe, format: $, rotate: g, textBaseline: F, textAnchor: k, truncateTickAt: S, animatedProps: ee }, Z, E ? { onClick: E } : {}));
  }), M.jsx(wi.line, { style: A.axis.domain.line, x1: 0, x2: ie.lineX2, y1: 0, y2: ie.lineY2 }), V] });
}, zst = hi(Bst), Hst = ["top", "right", "bottom", "left"], Ust = hi(function(e) {
  var t = e.xScale, n = e.yScale, r = e.width, i = e.height, o = { top: e.top, right: e.right, bottom: e.bottom, left: e.left };
  return M.jsx(M.Fragment, { children: Hst.map(function(a) {
    var s = o[a];
    if (!s)
      return null;
    var c = a === "top" || a === "bottom";
    return M.jsx(zst, bs({}, s, { axis: c ? "x" : "y", x: a === "right" ? r : 0, y: a === "bottom" ? i : 0, scale: c ? t : n, length: c ? r : i, ticksPosition: a === "top" || a === "left" ? "before" : "after", truncateTickAt: s.truncateTickAt }), a);
  }) });
}), Wst = hi(function(e) {
  var t = e.animatedProps, n = go();
  return M.jsx(wi.line, bs({}, t, n.grid.line));
}), jV = hi(function(e) {
  var t = e.lines, n = Os(), r = n.animate, i = n.config, o = X3(t, { keys: function(a) {
    return a.key;
  }, initial: function(a) {
    return { opacity: 1, x1: a.x1, x2: a.x2, y1: a.y1, y2: a.y2 };
  }, from: function(a) {
    return { opacity: 0, x1: a.x1, x2: a.x2, y1: a.y1, y2: a.y2 };
  }, enter: function(a) {
    return { opacity: 1, x1: a.x1, x2: a.x2, y1: a.y1, y2: a.y2 };
  }, update: function(a) {
    return { opacity: 1, x1: a.x1, x2: a.x2, y1: a.y1, y2: a.y2 };
  }, leave: { opacity: 0 }, config: i, immediate: !r });
  return M.jsx("g", { children: o(function(a, s) {
    return Yd(Wst, bs({}, s, { key: s.key, animatedProps: a }));
  }) });
}), qst = hi(function(e) {
  var t = e.width, n = e.height, r = e.xScale, i = e.yScale, o = e.xValues, a = e.yValues, s = At(function() {
    return !!r && LV({ width: t, height: n, scale: r, axis: "x", values: o });
  }, [r, o, t, n]), c = At(function() {
    return !!i && LV({ width: t, height: n, scale: i, axis: "y", values: a });
  }, [n, t, i, a]);
  return M.jsxs(M.Fragment, { children: [s && M.jsx(jV, { lines: s }), c && M.jsx(jV, { lines: c })] });
});
const Jc = 11102230246251565e-32, Zi = 134217729, Gst = (3 + 8 * Jc) * Jc;
function BT(e, t, n, r, i) {
  let o, a, s, c, l = t[0], u = r[0], d = 0, f = 0;
  u > l == u > -l ? (o = l, l = t[++d]) : (o = u, u = r[++f]);
  let h = 0;
  if (d < e && f < n)
    for (u > l == u > -l ? (a = l + o, s = o - (a - l), l = t[++d]) : (a = u + o, s = o - (a - u), u = r[++f]), o = a, s !== 0 && (i[h++] = s); d < e && f < n; )
      u > l == u > -l ? (a = o + l, c = a - o, s = o - (a - c) + (l - c), l = t[++d]) : (a = o + u, c = a - o, s = o - (a - c) + (u - c), u = r[++f]), o = a, s !== 0 && (i[h++] = s);
  for (; d < e; )
    a = o + l, c = a - o, s = o - (a - c) + (l - c), l = t[++d], o = a, s !== 0 && (i[h++] = s);
  for (; f < n; )
    a = o + u, c = a - o, s = o - (a - c) + (u - c), u = r[++f], o = a, s !== 0 && (i[h++] = s);
  return (o !== 0 || h === 0) && (i[h++] = o), h;
}
function Kst(e, t) {
  let n = t[0];
  for (let r = 1; r < e; r++)
    n += t[r];
  return n;
}
function Fy(e) {
  return new Float64Array(e);
}
const Yst = (3 + 16 * Jc) * Jc, Xst = (2 + 12 * Jc) * Jc, Qst = (9 + 64 * Jc) * Jc * Jc, hh = Fy(4), FV = Fy(8), VV = Fy(12), BV = Fy(16), vo = Fy(4);
function Jst(e, t, n, r, i, o, a) {
  let s, c, l, u, d, f, h, p, g, m, v, y, S, _, w, T, x, C;
  const E = e - i, R = n - i, A = t - o, O = r - o;
  _ = E * O, f = Zi * E, h = f - (f - E), p = E - h, f = Zi * O, g = f - (f - O), m = O - g, w = p * m - (_ - h * g - p * g - h * m), T = A * R, f = Zi * A, h = f - (f - A), p = A - h, f = Zi * R, g = f - (f - R), m = R - g, x = p * m - (T - h * g - p * g - h * m), v = w - x, d = w - v, hh[0] = w - (v + d) + (d - x), y = _ + v, d = y - _, S = _ - (y - d) + (v - d), v = S - T, d = S - v, hh[1] = S - (v + d) + (d - T), C = y + v, d = C - y, hh[2] = y - (C - d) + (v - d), hh[3] = C;
  let $ = Kst(4, hh), N = Xst * a;
  if ($ >= N || -$ >= N || (d = e - E, s = e - (E + d) + (d - i), d = n - R, l = n - (R + d) + (d - i), d = t - A, c = t - (A + d) + (d - o), d = r - O, u = r - (O + d) + (d - o), s === 0 && c === 0 && l === 0 && u === 0) || (N = Qst * a + Gst * Math.abs($), $ += E * u + O * s - (A * l + R * c), $ >= N || -$ >= N))
    return $;
  _ = s * O, f = Zi * s, h = f - (f - s), p = s - h, f = Zi * O, g = f - (f - O), m = O - g, w = p * m - (_ - h * g - p * g - h * m), T = c * R, f = Zi * c, h = f - (f - c), p = c - h, f = Zi * R, g = f - (f - R), m = R - g, x = p * m - (T - h * g - p * g - h * m), v = w - x, d = w - v, vo[0] = w - (v + d) + (d - x), y = _ + v, d = y - _, S = _ - (y - d) + (v - d), v = S - T, d = S - v, vo[1] = S - (v + d) + (d - T), C = y + v, d = C - y, vo[2] = y - (C - d) + (v - d), vo[3] = C;
  const z = BT(4, hh, 4, vo, FV);
  _ = E * u, f = Zi * E, h = f - (f - E), p = E - h, f = Zi * u, g = f - (f - u), m = u - g, w = p * m - (_ - h * g - p * g - h * m), T = A * l, f = Zi * A, h = f - (f - A), p = A - h, f = Zi * l, g = f - (f - l), m = l - g, x = p * m - (T - h * g - p * g - h * m), v = w - x, d = w - v, vo[0] = w - (v + d) + (d - x), y = _ + v, d = y - _, S = _ - (y - d) + (v - d), v = S - T, d = S - v, vo[1] = S - (v + d) + (d - T), C = y + v, d = C - y, vo[2] = y - (C - d) + (v - d), vo[3] = C;
  const k = BT(z, FV, 4, vo, VV);
  _ = s * u, f = Zi * s, h = f - (f - s), p = s - h, f = Zi * u, g = f - (f - u), m = u - g, w = p * m - (_ - h * g - p * g - h * m), T = c * l, f = Zi * c, h = f - (f - c), p = c - h, f = Zi * l, g = f - (f - l), m = l - g, x = p * m - (T - h * g - p * g - h * m), v = w - x, d = w - v, vo[0] = w - (v + d) + (d - x), y = _ + v, d = y - _, S = _ - (y - d) + (v - d), v = S - T, d = S - v, vo[1] = S - (v + d) + (d - T), C = y + v, d = C - y, vo[2] = y - (C - d) + (v - d), vo[3] = C;
  const F = BT(k, VV, 4, vo, BV);
  return BV[F - 1];
}
function h1(e, t, n, r, i, o) {
  const a = (t - o) * (n - i), s = (e - i) * (r - o), c = a - s, l = Math.abs(a + s);
  return Math.abs(c) >= Yst * l ? c : -Jst(e, t, n, r, i, o, l);
}
const zV = Math.pow(2, -52), g1 = new Uint32Array(512);
class Pw {
  static from(t, n = rct, r = ict) {
    const i = t.length, o = new Float64Array(i * 2);
    for (let a = 0; a < i; a++) {
      const s = t[a];
      o[2 * a] = n(s), o[2 * a + 1] = r(s);
    }
    return new Pw(o);
  }
  constructor(t) {
    const n = t.length >> 1;
    if (n > 0 && typeof t[0] != "number")
      throw new Error("Expected coords to contain numbers.");
    this.coords = t;
    const r = Math.max(2 * n - 5, 0);
    this._triangles = new Uint32Array(r * 3), this._halfedges = new Int32Array(r * 3), this._hashSize = Math.ceil(Math.sqrt(n)), this._hullPrev = new Uint32Array(n), this._hullNext = new Uint32Array(n), this._hullTri = new Uint32Array(n), this._hullHash = new Int32Array(this._hashSize), this._ids = new Uint32Array(n), this._dists = new Float64Array(n), this.update();
  }
  update() {
    const { coords: t, _hullPrev: n, _hullNext: r, _hullTri: i, _hullHash: o } = this, a = t.length >> 1;
    let s = 1 / 0, c = 1 / 0, l = -1 / 0, u = -1 / 0;
    for (let E = 0; E < a; E++) {
      const R = t[2 * E], A = t[2 * E + 1];
      R < s && (s = R), A < c && (c = A), R > l && (l = R), A > u && (u = A), this._ids[E] = E;
    }
    const d = (s + l) / 2, f = (c + u) / 2;
    let h, p, g;
    for (let E = 0, R = 1 / 0; E < a; E++) {
      const A = zT(d, f, t[2 * E], t[2 * E + 1]);
      A < R && (h = E, R = A);
    }
    const m = t[2 * h], v = t[2 * h + 1];
    for (let E = 0, R = 1 / 0; E < a; E++) {
      if (E === h)
        continue;
      const A = zT(m, v, t[2 * E], t[2 * E + 1]);
      A < R && A > 0 && (p = E, R = A);
    }
    let y = t[2 * p], S = t[2 * p + 1], _ = 1 / 0;
    for (let E = 0; E < a; E++) {
      if (E === h || E === p)
        continue;
      const R = tct(m, v, y, S, t[2 * E], t[2 * E + 1]);
      R < _ && (g = E, _ = R);
    }
    let w = t[2 * g], T = t[2 * g + 1];
    if (_ === 1 / 0) {
      for (let A = 0; A < a; A++)
        this._dists[A] = t[2 * A] - t[0] || t[2 * A + 1] - t[1];
      jh(this._ids, this._dists, 0, a - 1);
      const E = new Uint32Array(a);
      let R = 0;
      for (let A = 0, O = -1 / 0; A < a; A++) {
        const $ = this._ids[A], N = this._dists[$];
        N > O && (E[R++] = $, O = N);
      }
      this.hull = E.subarray(0, R), this.triangles = new Uint32Array(0), this.halfedges = new Uint32Array(0);
      return;
    }
    if (h1(m, v, y, S, w, T) < 0) {
      const E = p, R = y, A = S;
      p = g, y = w, S = T, g = E, w = R, T = A;
    }
    const x = nct(m, v, y, S, w, T);
    this._cx = x.x, this._cy = x.y;
    for (let E = 0; E < a; E++)
      this._dists[E] = zT(t[2 * E], t[2 * E + 1], x.x, x.y);
    jh(this._ids, this._dists, 0, a - 1), this._hullStart = h;
    let C = 3;
    r[h] = n[g] = p, r[p] = n[h] = g, r[g] = n[p] = h, i[h] = 0, i[p] = 1, i[g] = 2, o.fill(-1), o[this._hashKey(m, v)] = h, o[this._hashKey(y, S)] = p, o[this._hashKey(w, T)] = g, this.trianglesLen = 0, this._addTriangle(h, p, g, -1, -1, -1);
    for (let E = 0, R, A; E < this._ids.length; E++) {
      const O = this._ids[E], $ = t[2 * O], N = t[2 * O + 1];
      if (E > 0 && Math.abs($ - R) <= zV && Math.abs(N - A) <= zV || (R = $, A = N, O === h || O === p || O === g))
        continue;
      let z = 0;
      for (let B = 0, U = this._hashKey($, N); B < this._hashSize && (z = o[(U + B) % this._hashSize], !(z !== -1 && z !== r[z])); B++)
        ;
      z = n[z];
      let k = z, F;
      for (; F = r[k], h1($, N, t[2 * k], t[2 * k + 1], t[2 * F], t[2 * F + 1]) >= 0; )
        if (k = F, k === z) {
          k = -1;
          break;
        }
      if (k === -1)
        continue;
      let V = this._addTriangle(k, O, r[k], -1, -1, i[k]);
      i[O] = this._legalize(V + 2), i[k] = V, C++;
      let j = r[k];
      for (; F = r[j], h1($, N, t[2 * j], t[2 * j + 1], t[2 * F], t[2 * F + 1]) < 0; )
        V = this._addTriangle(j, O, F, i[O], -1, i[j]), i[O] = this._legalize(V + 2), r[j] = j, C--, j = F;
      if (k === z)
        for (; F = n[k], h1($, N, t[2 * F], t[2 * F + 1], t[2 * k], t[2 * k + 1]) < 0; )
          V = this._addTriangle(F, O, k, -1, i[k], i[F]), this._legalize(V + 2), i[F] = V, r[k] = k, C--, k = F;
      this._hullStart = n[O] = k, r[k] = n[j] = O, r[O] = j, o[this._hashKey($, N)] = O, o[this._hashKey(t[2 * k], t[2 * k + 1])] = k;
    }
    this.hull = new Uint32Array(C);
    for (let E = 0, R = this._hullStart; E < C; E++)
      this.hull[E] = R, R = r[R];
    this.triangles = this._triangles.subarray(0, this.trianglesLen), this.halfedges = this._halfedges.subarray(0, this.trianglesLen);
  }
  _hashKey(t, n) {
    return Math.floor(Zst(t - this._cx, n - this._cy) * this._hashSize) % this._hashSize;
  }
  _legalize(t) {
    const { _triangles: n, _halfedges: r, coords: i } = this;
    let o = 0, a = 0;
    for (; ; ) {
      const s = r[t], c = t - t % 3;
      if (a = c + (t + 2) % 3, s === -1) {
        if (o === 0)
          break;
        t = g1[--o];
        continue;
      }
      const l = s - s % 3, u = c + (t + 1) % 3, d = l + (s + 2) % 3, f = n[a], h = n[t], p = n[u], g = n[d];
      if (ect(
        i[2 * f],
        i[2 * f + 1],
        i[2 * h],
        i[2 * h + 1],
        i[2 * p],
        i[2 * p + 1],
        i[2 * g],
        i[2 * g + 1]
      )) {
        n[t] = g, n[s] = f;
        const v = r[d];
        if (v === -1) {
          let S = this._hullStart;
          do {
            if (this._hullTri[S] === d) {
              this._hullTri[S] = t;
              break;
            }
            S = this._hullPrev[S];
          } while (S !== this._hullStart);
        }
        this._link(t, v), this._link(s, r[a]), this._link(a, d);
        const y = l + (s + 1) % 3;
        o < g1.length && (g1[o++] = y);
      } else {
        if (o === 0)
          break;
        t = g1[--o];
      }
    }
    return a;
  }
  _link(t, n) {
    this._halfedges[t] = n, n !== -1 && (this._halfedges[n] = t);
  }
  // add a new triangle given vertex indices and adjacent half-edge ids
  _addTriangle(t, n, r, i, o, a) {
    const s = this.trianglesLen;
    return this._triangles[s] = t, this._triangles[s + 1] = n, this._triangles[s + 2] = r, this._link(s, i), this._link(s + 1, o), this._link(s + 2, a), this.trianglesLen += 3, s;
  }
}
function Zst(e, t) {
  const n = e / (Math.abs(e) + Math.abs(t));
  return (t > 0 ? 3 - n : 1 + n) / 4;
}
function zT(e, t, n, r) {
  const i = e - n, o = t - r;
  return i * i + o * o;
}
function ect(e, t, n, r, i, o, a, s) {
  const c = e - a, l = t - s, u = n - a, d = r - s, f = i - a, h = o - s, p = c * c + l * l, g = u * u + d * d, m = f * f + h * h;
  return c * (d * m - g * h) - l * (u * m - g * f) + p * (u * h - d * f) < 0;
}
function tct(e, t, n, r, i, o) {
  const a = n - e, s = r - t, c = i - e, l = o - t, u = a * a + s * s, d = c * c + l * l, f = 0.5 / (a * l - s * c), h = (l * u - s * d) * f, p = (a * d - c * u) * f;
  return h * h + p * p;
}
function nct(e, t, n, r, i, o) {
  const a = n - e, s = r - t, c = i - e, l = o - t, u = a * a + s * s, d = c * c + l * l, f = 0.5 / (a * l - s * c), h = e + (l * u - s * d) * f, p = t + (a * d - c * u) * f;
  return { x: h, y: p };
}
function jh(e, t, n, r) {
  if (r - n <= 20)
    for (let i = n + 1; i <= r; i++) {
      const o = e[i], a = t[o];
      let s = i - 1;
      for (; s >= n && t[e[s]] > a; )
        e[s + 1] = e[s--];
      e[s + 1] = o;
    }
  else {
    const i = n + r >> 1;
    let o = n + 1, a = r;
    Am(e, i, o), t[e[n]] > t[e[r]] && Am(e, n, r), t[e[o]] > t[e[r]] && Am(e, o, r), t[e[n]] > t[e[o]] && Am(e, n, o);
    const s = e[o], c = t[s];
    for (; ; ) {
      do
        o++;
      while (t[e[o]] < c);
      do
        a--;
      while (t[e[a]] > c);
      if (a < o)
        break;
      Am(e, o, a);
    }
    e[n + 1] = e[a], e[a] = s, r - o + 1 >= a - n ? (jh(e, t, o, r), jh(e, t, n, a - 1)) : (jh(e, t, n, a - 1), jh(e, t, o, r));
  }
}
function Am(e, t, n) {
  const r = e[t];
  e[t] = e[n], e[n] = r;
}
function rct(e) {
  return e[0];
}
function ict(e) {
  return e[1];
}
const HV = 1e-6;
class Od {
  constructor() {
    this._x0 = this._y0 = // start of current subpath
    this._x1 = this._y1 = null, this._ = "";
  }
  moveTo(t, n) {
    this._ += `M${this._x0 = this._x1 = +t},${this._y0 = this._y1 = +n}`;
  }
  closePath() {
    this._x1 !== null && (this._x1 = this._x0, this._y1 = this._y0, this._ += "Z");
  }
  lineTo(t, n) {
    this._ += `L${this._x1 = +t},${this._y1 = +n}`;
  }
  arc(t, n, r) {
    t = +t, n = +n, r = +r;
    const i = t + r, o = n;
    if (r < 0)
      throw new Error("negative radius");
    this._x1 === null ? this._ += `M${i},${o}` : (Math.abs(this._x1 - i) > HV || Math.abs(this._y1 - o) > HV) && (this._ += "L" + i + "," + o), r && (this._ += `A${r},${r},0,1,1,${t - r},${n}A${r},${r},0,1,1,${this._x1 = i},${this._y1 = o}`);
  }
  rect(t, n, r, i) {
    this._ += `M${this._x0 = this._x1 = +t},${this._y0 = this._y1 = +n}h${+r}v${+i}h${-r}Z`;
  }
  value() {
    return this._ || null;
  }
}
class A$ {
  constructor() {
    this._ = [];
  }
  moveTo(t, n) {
    this._.push([t, n]);
  }
  closePath() {
    this._.push(this._[0].slice());
  }
  lineTo(t, n) {
    this._.push([t, n]);
  }
  value() {
    return this._.length ? this._ : null;
  }
}
class oct {
  constructor(t, [n, r, i, o] = [0, 0, 960, 500]) {
    if (!((i = +i) >= (n = +n)) || !((o = +o) >= (r = +r)))
      throw new Error("invalid bounds");
    this.delaunay = t, this._circumcenters = new Float64Array(t.points.length * 2), this.vectors = new Float64Array(t.points.length * 2), this.xmax = i, this.xmin = n, this.ymax = o, this.ymin = r, this._init();
  }
  update() {
    return this.delaunay.update(), this._init(), this;
  }
  _init() {
    const { delaunay: { points: t, hull: n, triangles: r }, vectors: i } = this;
    let o, a;
    const s = this.circumcenters = this._circumcenters.subarray(0, r.length / 3 * 2);
    for (let g = 0, m = 0, v = r.length, y, S; g < v; g += 3, m += 2) {
      const _ = r[g] * 2, w = r[g + 1] * 2, T = r[g + 2] * 2, x = t[_], C = t[_ + 1], E = t[w], R = t[w + 1], A = t[T], O = t[T + 1], $ = E - x, N = R - C, z = A - x, k = O - C, F = ($ * k - N * z) * 2;
      if (Math.abs(F) < 1e-9) {
        if (o === void 0) {
          o = a = 0;
          for (const j of n)
            o += t[j * 2], a += t[j * 2 + 1];
          o /= n.length, a /= n.length;
        }
        const V = 1e9 * Math.sign((o - x) * k - (a - C) * z);
        y = (x + A) / 2 - V * k, S = (C + O) / 2 + V * z;
      } else {
        const V = 1 / F, j = $ * $ + N * N, B = z * z + k * k;
        y = x + (k * j - N * B) * V, S = C + ($ * B - z * j) * V;
      }
      s[m] = y, s[m + 1] = S;
    }
    let c = n[n.length - 1], l, u = c * 4, d, f = t[2 * c], h, p = t[2 * c + 1];
    i.fill(0);
    for (let g = 0; g < n.length; ++g)
      c = n[g], l = u, d = f, h = p, u = c * 4, f = t[2 * c], p = t[2 * c + 1], i[l + 2] = i[u] = h - p, i[l + 3] = i[u + 1] = f - d;
  }
  render(t) {
    const n = t == null ? t = new Od() : void 0, { delaunay: { halfedges: r, inedges: i, hull: o }, circumcenters: a, vectors: s } = this;
    if (o.length <= 1)
      return null;
    for (let u = 0, d = r.length; u < d; ++u) {
      const f = r[u];
      if (f < u)
        continue;
      const h = Math.floor(u / 3) * 2, p = Math.floor(f / 3) * 2, g = a[h], m = a[h + 1], v = a[p], y = a[p + 1];
      this._renderSegment(g, m, v, y, t);
    }
    let c, l = o[o.length - 1];
    for (let u = 0; u < o.length; ++u) {
      c = l, l = o[u];
      const d = Math.floor(i[l] / 3) * 2, f = a[d], h = a[d + 1], p = c * 4, g = this._project(f, h, s[p + 2], s[p + 3]);
      g && this._renderSegment(f, h, g[0], g[1], t);
    }
    return n && n.value();
  }
  renderBounds(t) {
    const n = t == null ? t = new Od() : void 0;
    return t.rect(this.xmin, this.ymin, this.xmax - this.xmin, this.ymax - this.ymin), n && n.value();
  }
  renderCell(t, n) {
    const r = n == null ? n = new Od() : void 0, i = this._clip(t);
    if (i === null || !i.length)
      return;
    n.moveTo(i[0], i[1]);
    let o = i.length;
    for (; i[0] === i[o - 2] && i[1] === i[o - 1] && o > 1; )
      o -= 2;
    for (let a = 2; a < o; a += 2)
      (i[a] !== i[a - 2] || i[a + 1] !== i[a - 1]) && n.lineTo(i[a], i[a + 1]);
    return n.closePath(), r && r.value();
  }
  *cellPolygons() {
    const { delaunay: { points: t } } = this;
    for (let n = 0, r = t.length / 2; n < r; ++n) {
      const i = this.cellPolygon(n);
      i && (i.index = n, yield i);
    }
  }
  cellPolygon(t) {
    const n = new A$();
    return this.renderCell(t, n), n.value();
  }
  _renderSegment(t, n, r, i, o) {
    let a;
    const s = this._regioncode(t, n), c = this._regioncode(r, i);
    s === 0 && c === 0 ? (o.moveTo(t, n), o.lineTo(r, i)) : (a = this._clipSegment(t, n, r, i, s, c)) && (o.moveTo(a[0], a[1]), o.lineTo(a[2], a[3]));
  }
  contains(t, n, r) {
    return n = +n, n !== n || (r = +r, r !== r) ? !1 : this.delaunay._step(t, n, r) === t;
  }
  *neighbors(t) {
    const n = this._clip(t);
    if (n)
      for (const r of this.delaunay.neighbors(t)) {
        const i = this._clip(r);
        if (i) {
          e:
            for (let o = 0, a = n.length; o < a; o += 2)
              for (let s = 0, c = i.length; s < c; s += 2)
                if (n[o] === i[s] && n[o + 1] === i[s + 1] && n[(o + 2) % a] === i[(s + c - 2) % c] && n[(o + 3) % a] === i[(s + c - 1) % c]) {
                  yield r;
                  break e;
                }
        }
      }
  }
  _cell(t) {
    const { circumcenters: n, delaunay: { inedges: r, halfedges: i, triangles: o } } = this, a = r[t];
    if (a === -1)
      return null;
    const s = [];
    let c = a;
    do {
      const l = Math.floor(c / 3);
      if (s.push(n[l * 2], n[l * 2 + 1]), c = c % 3 === 2 ? c - 2 : c + 1, o[c] !== t)
        break;
      c = i[c];
    } while (c !== a && c !== -1);
    return s;
  }
  _clip(t) {
    if (t === 0 && this.delaunay.hull.length === 1)
      return [this.xmax, this.ymin, this.xmax, this.ymax, this.xmin, this.ymax, this.xmin, this.ymin];
    const n = this._cell(t);
    if (n === null)
      return null;
    const { vectors: r } = this, i = t * 4;
    return this._simplify(r[i] || r[i + 1] ? this._clipInfinite(t, n, r[i], r[i + 1], r[i + 2], r[i + 3]) : this._clipFinite(t, n));
  }
  _clipFinite(t, n) {
    const r = n.length;
    let i = null, o, a, s = n[r - 2], c = n[r - 1], l, u = this._regioncode(s, c), d, f = 0;
    for (let h = 0; h < r; h += 2)
      if (o = s, a = c, s = n[h], c = n[h + 1], l = u, u = this._regioncode(s, c), l === 0 && u === 0)
        d = f, f = 0, i ? i.push(s, c) : i = [s, c];
      else {
        let p, g, m, v, y;
        if (l === 0) {
          if ((p = this._clipSegment(o, a, s, c, l, u)) === null)
            continue;
          [g, m, v, y] = p;
        } else {
          if ((p = this._clipSegment(s, c, o, a, u, l)) === null)
            continue;
          [v, y, g, m] = p, d = f, f = this._edgecode(g, m), d && f && this._edge(t, d, f, i, i.length), i ? i.push(g, m) : i = [g, m];
        }
        d = f, f = this._edgecode(v, y), d && f && this._edge(t, d, f, i, i.length), i ? i.push(v, y) : i = [v, y];
      }
    if (i)
      d = f, f = this._edgecode(i[0], i[1]), d && f && this._edge(t, d, f, i, i.length);
    else if (this.contains(t, (this.xmin + this.xmax) / 2, (this.ymin + this.ymax) / 2))
      return [this.xmax, this.ymin, this.xmax, this.ymax, this.xmin, this.ymax, this.xmin, this.ymin];
    return i;
  }
  _clipSegment(t, n, r, i, o, a) {
    const s = o < a;
    for (s && ([t, n, r, i, o, a] = [r, i, t, n, a, o]); ; ) {
      if (o === 0 && a === 0)
        return s ? [r, i, t, n] : [t, n, r, i];
      if (o & a)
        return null;
      let c, l, u = o || a;
      u & 8 ? (c = t + (r - t) * (this.ymax - n) / (i - n), l = this.ymax) : u & 4 ? (c = t + (r - t) * (this.ymin - n) / (i - n), l = this.ymin) : u & 2 ? (l = n + (i - n) * (this.xmax - t) / (r - t), c = this.xmax) : (l = n + (i - n) * (this.xmin - t) / (r - t), c = this.xmin), o ? (t = c, n = l, o = this._regioncode(t, n)) : (r = c, i = l, a = this._regioncode(r, i));
    }
  }
  _clipInfinite(t, n, r, i, o, a) {
    let s = Array.from(n), c;
    if ((c = this._project(s[0], s[1], r, i)) && s.unshift(c[0], c[1]), (c = this._project(s[s.length - 2], s[s.length - 1], o, a)) && s.push(c[0], c[1]), s = this._clipFinite(t, s))
      for (let l = 0, u = s.length, d, f = this._edgecode(s[u - 2], s[u - 1]); l < u; l += 2)
        d = f, f = this._edgecode(s[l], s[l + 1]), d && f && (l = this._edge(t, d, f, s, l), u = s.length);
    else
      this.contains(t, (this.xmin + this.xmax) / 2, (this.ymin + this.ymax) / 2) && (s = [this.xmin, this.ymin, this.xmax, this.ymin, this.xmax, this.ymax, this.xmin, this.ymax]);
    return s;
  }
  _edge(t, n, r, i, o) {
    for (; n !== r; ) {
      let a, s;
      switch (n) {
        case 5:
          n = 4;
          continue;
        case 4:
          n = 6, a = this.xmax, s = this.ymin;
          break;
        case 6:
          n = 2;
          continue;
        case 2:
          n = 10, a = this.xmax, s = this.ymax;
          break;
        case 10:
          n = 8;
          continue;
        case 8:
          n = 9, a = this.xmin, s = this.ymax;
          break;
        case 9:
          n = 1;
          continue;
        case 1:
          n = 5, a = this.xmin, s = this.ymin;
          break;
      }
      (i[o] !== a || i[o + 1] !== s) && this.contains(t, a, s) && (i.splice(o, 0, a, s), o += 2);
    }
    return o;
  }
  _project(t, n, r, i) {
    let o = 1 / 0, a, s, c;
    if (i < 0) {
      if (n <= this.ymin)
        return null;
      (a = (this.ymin - n) / i) < o && (c = this.ymin, s = t + (o = a) * r);
    } else if (i > 0) {
      if (n >= this.ymax)
        return null;
      (a = (this.ymax - n) / i) < o && (c = this.ymax, s = t + (o = a) * r);
    }
    if (r > 0) {
      if (t >= this.xmax)
        return null;
      (a = (this.xmax - t) / r) < o && (s = this.xmax, c = n + (o = a) * i);
    } else if (r < 0) {
      if (t <= this.xmin)
        return null;
      (a = (this.xmin - t) / r) < o && (s = this.xmin, c = n + (o = a) * i);
    }
    return [s, c];
  }
  _edgecode(t, n) {
    return (t === this.xmin ? 1 : t === this.xmax ? 2 : 0) | (n === this.ymin ? 4 : n === this.ymax ? 8 : 0);
  }
  _regioncode(t, n) {
    return (t < this.xmin ? 1 : t > this.xmax ? 2 : 0) | (n < this.ymin ? 4 : n > this.ymax ? 8 : 0);
  }
  _simplify(t) {
    if (t && t.length > 4) {
      for (let n = 0; n < t.length; n += 2) {
        const r = (n + 2) % t.length, i = (n + 4) % t.length;
        (t[n] === t[r] && t[r] === t[i] || t[n + 1] === t[r + 1] && t[r + 1] === t[i + 1]) && (t.splice(r, 2), n -= 2);
      }
      t.length || (t = null);
    }
    return t;
  }
}
const act = 2 * Math.PI, gh = Math.pow;
function sct(e) {
  return e[0];
}
function cct(e) {
  return e[1];
}
function lct(e) {
  const { triangles: t, coords: n } = e;
  for (let r = 0; r < t.length; r += 3) {
    const i = 2 * t[r], o = 2 * t[r + 1], a = 2 * t[r + 2];
    if ((n[a] - n[i]) * (n[o + 1] - n[i + 1]) - (n[o] - n[i]) * (n[a + 1] - n[i + 1]) > 1e-10)
      return !1;
  }
  return !0;
}
function uct(e, t, n) {
  return [e + Math.sin(e + t) * n, t + Math.cos(e - t) * n];
}
class rk {
  static from(t, n = sct, r = cct, i) {
    return new rk("length" in t ? dct(t, n, r, i) : Float64Array.from(fct(t, n, r, i)));
  }
  constructor(t) {
    this._delaunator = new Pw(t), this.inedges = new Int32Array(t.length / 2), this._hullIndex = new Int32Array(t.length / 2), this.points = this._delaunator.coords, this._init();
  }
  update() {
    return this._delaunator.update(), this._init(), this;
  }
  _init() {
    const t = this._delaunator, n = this.points;
    if (t.hull && t.hull.length > 2 && lct(t)) {
      this.collinear = Int32Array.from({ length: n.length / 2 }, (f, h) => h).sort((f, h) => n[2 * f] - n[2 * h] || n[2 * f + 1] - n[2 * h + 1]);
      const c = this.collinear[0], l = this.collinear[this.collinear.length - 1], u = [n[2 * c], n[2 * c + 1], n[2 * l], n[2 * l + 1]], d = 1e-8 * Math.hypot(u[3] - u[1], u[2] - u[0]);
      for (let f = 0, h = n.length / 2; f < h; ++f) {
        const p = uct(n[2 * f], n[2 * f + 1], d);
        n[2 * f] = p[0], n[2 * f + 1] = p[1];
      }
      this._delaunator = new Pw(n);
    } else
      delete this.collinear;
    const r = this.halfedges = this._delaunator.halfedges, i = this.hull = this._delaunator.hull, o = this.triangles = this._delaunator.triangles, a = this.inedges.fill(-1), s = this._hullIndex.fill(-1);
    for (let c = 0, l = r.length; c < l; ++c) {
      const u = o[c % 3 === 2 ? c - 2 : c + 1];
      (r[c] === -1 || a[u] === -1) && (a[u] = c);
    }
    for (let c = 0, l = i.length; c < l; ++c)
      s[i[c]] = c;
    i.length <= 2 && i.length > 0 && (this.triangles = new Int32Array(3).fill(-1), this.halfedges = new Int32Array(3).fill(-1), this.triangles[0] = i[0], a[i[0]] = 1, i.length === 2 && (a[i[1]] = 0, this.triangles[1] = i[1], this.triangles[2] = i[1]));
  }
  voronoi(t) {
    return new oct(this, t);
  }
  *neighbors(t) {
    const { inedges: n, hull: r, _hullIndex: i, halfedges: o, triangles: a, collinear: s } = this;
    if (s) {
      const d = s.indexOf(t);
      d > 0 && (yield s[d - 1]), d < s.length - 1 && (yield s[d + 1]);
      return;
    }
    const c = n[t];
    if (c === -1)
      return;
    let l = c, u = -1;
    do {
      if (yield u = a[l], l = l % 3 === 2 ? l - 2 : l + 1, a[l] !== t)
        return;
      if (l = o[l], l === -1) {
        const d = r[(i[t] + 1) % r.length];
        d !== u && (yield d);
        return;
      }
    } while (l !== c);
  }
  find(t, n, r = 0) {
    if (t = +t, t !== t || (n = +n, n !== n))
      return -1;
    const i = r;
    let o;
    for (; (o = this._step(r, t, n)) >= 0 && o !== r && o !== i; )
      r = o;
    return o;
  }
  _step(t, n, r) {
    const { inedges: i, hull: o, _hullIndex: a, halfedges: s, triangles: c, points: l } = this;
    if (i[t] === -1 || !l.length)
      return (t + 1) % (l.length >> 1);
    let u = t, d = gh(n - l[t * 2], 2) + gh(r - l[t * 2 + 1], 2);
    const f = i[t];
    let h = f;
    do {
      let p = c[h];
      const g = gh(n - l[p * 2], 2) + gh(r - l[p * 2 + 1], 2);
      if (g < d && (d = g, u = p), h = h % 3 === 2 ? h - 2 : h + 1, c[h] !== t)
        break;
      if (h = s[h], h === -1) {
        if (h = o[(a[t] + 1) % o.length], h !== p && gh(n - l[h * 2], 2) + gh(r - l[h * 2 + 1], 2) < d)
          return h;
        break;
      }
    } while (h !== f);
    return u;
  }
  render(t) {
    const n = t == null ? t = new Od() : void 0, { points: r, halfedges: i, triangles: o } = this;
    for (let a = 0, s = i.length; a < s; ++a) {
      const c = i[a];
      if (c < a)
        continue;
      const l = o[a] * 2, u = o[c] * 2;
      t.moveTo(r[l], r[l + 1]), t.lineTo(r[u], r[u + 1]);
    }
    return this.renderHull(t), n && n.value();
  }
  renderPoints(t, n) {
    n === void 0 && (!t || typeof t.moveTo != "function") && (n = t, t = null), n = n == null ? 2 : +n;
    const r = t == null ? t = new Od() : void 0, { points: i } = this;
    for (let o = 0, a = i.length; o < a; o += 2) {
      const s = i[o], c = i[o + 1];
      t.moveTo(s + n, c), t.arc(s, c, n, 0, act);
    }
    return r && r.value();
  }
  renderHull(t) {
    const n = t == null ? t = new Od() : void 0, { hull: r, points: i } = this, o = r[0] * 2, a = r.length;
    t.moveTo(i[o], i[o + 1]);
    for (let s = 1; s < a; ++s) {
      const c = 2 * r[s];
      t.lineTo(i[c], i[c + 1]);
    }
    return t.closePath(), n && n.value();
  }
  hullPolygon() {
    const t = new A$();
    return this.renderHull(t), t.value();
  }
  renderTriangle(t, n) {
    const r = n == null ? n = new Od() : void 0, { points: i, triangles: o } = this, a = o[t *= 3] * 2, s = o[t + 1] * 2, c = o[t + 2] * 2;
    return n.moveTo(i[a], i[a + 1]), n.lineTo(i[s], i[s + 1]), n.lineTo(i[c], i[c + 1]), n.closePath(), r && r.value();
  }
  *trianglePolygons() {
    const { triangles: t } = this;
    for (let n = 0, r = t.length / 3; n < r; ++n)
      yield this.trianglePolygon(n);
  }
  trianglePolygon(t) {
    const n = new A$();
    return this.renderTriangle(t, n), n.value();
  }
}
function dct(e, t, n, r) {
  const i = e.length, o = new Float64Array(i * 2);
  for (let a = 0; a < i; ++a) {
    const s = e[a];
    o[a * 2] = t.call(r, s, a, e), o[a * 2 + 1] = n.call(r, s, a, e);
  }
  return o;
}
function* fct(e, t, n, r) {
  let i = 0;
  for (const o of e)
    yield t.call(r, o, i, e), yield n.call(r, o, i, e), ++i;
}
var ik = function(e) {
  return [e.x, e.y];
}, Vy = Uie, loe = "cursor", uoe = "top", hct = function(e) {
  var t = e.points, n = e.getNodePosition, r = n === void 0 ? ik : n, i = e.margin, o = i === void 0 ? Vy : i;
  return t.map(function(a) {
    var s = r(a), c = s[0], l = s[1];
    return [c + o.left, l + o.top];
  });
}, gct = function(e) {
  var t = e.points, n = e.width, r = e.height, i = e.margin, o = i === void 0 ? Vy : i, a = e.debug, s = rk.from(t), c = a ? s.voronoi([0, 0, o.left + n + o.right, o.top + r + o.bottom]) : void 0;
  return { points: t, delaunay: s, voronoi: c };
}, pct = function(e) {
  var t = e.points, n = e.getNodePosition, r = n === void 0 ? ik : n, i = e.width, o = e.height, a = e.margin, s = a === void 0 ? Vy : a, c = e.debug;
  return At(function() {
    return gct({ points: hct({ points: t, margin: s, getNodePosition: r }), width: i, height: o, margin: s, debug: c });
  }, [t, i, o, s, c]);
}, mct = function(e) {
  var t = e.elementRef, n = e.nodes, r = e.getNodePosition, i = r === void 0 ? ik : r, o = e.delaunay, a = e.setCurrent, s = e.margin, c = s === void 0 ? Vy : s, l = e.detectionRadius, u = l === void 0 ? 1 / 0 : l, d = e.isInteractive, f = d === void 0 || d, h = e.onMouseEnter, p = e.onMouseMove, g = e.onMouseLeave, m = e.onClick, v = e.onTouchStart, y = e.onTouchMove, S = e.onTouchEnd, _ = e.enableTouchCrosshair, w = _ !== void 0 && _, T = e.tooltip, x = e.tooltipPosition, C = x === void 0 ? loe : x, E = e.tooltipAnchor, R = E === void 0 ? uoe : E, A = Lt(null), O = A[0], $ = A[1], N = Me(null);
  gt(function() {
    N.current = O;
  }, [N, O]);
  var z = mn(function(J) {
    if (!t.current)
      return null;
    var Y = yst(t.current, J), ee = Y[0], Z = Y[1], H = o.find(ee, Z), oe = H !== void 0 ? n[H] : null;
    if (oe && u !== 1 / 0) {
      var W = i(oe), se = W[0], ce = W[1];
      vst(ee, Z, se + c.left, ce + c.top) > u && (H = null, oe = null);
    }
    return H === null || oe === null ? null : [H, oe];
  }, [t, o, n, i, c, u]), k = Q3(), F = k.showTooltipAt, V = k.showTooltipFromEvent, j = k.hideTooltip, B = At(function() {
    if (T)
      return C === "cursor" ? function(J, Y) {
        V(T(J), Y, R);
      } : function(J) {
        var Y = i(J), ee = Y[0], Z = Y[1];
        F(T(J), [ee + c.left, Z + c.top], R);
      };
  }, [F, V, T, C, R, i, c]), U = mn(function(J) {
    var Y = z(J);
    if ($(Y), a == null || a(Y ? Y[1] : null), Y) {
      var ee = Y[1];
      B == null || B(ee, J), h == null || h(Y[1], J);
    }
  }, [z, $, a, B, h]), Q = mn(function(J) {
    var Y = z(J);
    if ($(Y), Y) {
      var ee = Y[0], Z = Y[1];
      if (a == null || a(Z), B == null || B(Z, J), N.current) {
        var H = N.current, oe = H[0], W = H[1];
        ee !== oe ? g == null || g(W, J) : p == null || p(Z, J);
      } else
        h == null || h(Z, J);
    } else
      a == null || a(null), j == null || j(), N.current && (g == null || g(N.current[1], J));
  }, [z, $, N, h, p, g, B, j]), K = mn(function(J) {
    $(null), a == null || a(null), j(), g && N.current && g(N.current[1], J);
  }, [$, a, N, j, g]), q = mn(function(J) {
    var Y = z(J);
    $(Y), Y && (m == null || m(Y[1], J));
  }, [z, $, m]), X = mn(function(J) {
    var Y = z(J);
    w && ($(Y), a == null || a(Y ? Y[1] : null)), Y && (v == null || v(Y[1], J));
  }, [z, $, a, w, v]), ie = mn(function(J) {
    var Y = z(J);
    w && ($(Y), a == null || a(Y ? Y[1] : null)), Y && (y == null || y(Y[1], J));
  }, [z, $, a, w, y]), te = mn(function(J) {
    w && ($(null), a == null || a(null)), S && N.current && S(N.current[1], J);
  }, [w, $, a, S, N]);
  return { current: O, handleMouseEnter: f ? U : void 0, handleMouseMove: f ? Q : void 0, handleMouseLeave: f ? K : void 0, handleClick: f ? q : void 0, handleTouchStart: f ? X : void 0, handleTouchMove: f ? ie : void 0, handleTouchEnd: f ? te : void 0 };
}, vct = function(e) {
  var t = e.nodes, n = e.width, r = e.height, i = e.margin, o = i === void 0 ? Vy : i, a = e.getNodePosition, s = e.setCurrent, c = e.onMouseEnter, l = e.onMouseMove, u = e.onMouseLeave, d = e.onClick, f = e.onTouchStart, h = e.onTouchMove, p = e.onTouchEnd, g = e.enableTouchCrosshair, m = g !== void 0 && g, v = e.detectionRadius, y = v === void 0 ? 1 / 0 : v, S = e.tooltip, _ = e.tooltipPosition, w = _ === void 0 ? loe : _, T = e.tooltipAnchor, x = T === void 0 ? uoe : T, C = e.debug, E = Me(null), R = pct({ points: t, getNodePosition: a, width: n, height: r, margin: o, debug: C }), A = R.delaunay, O = R.voronoi, $ = mct({ elementRef: E, nodes: t, delaunay: A, margin: o, detectionRadius: y, setCurrent: s, onMouseEnter: c, onMouseMove: l, onMouseLeave: u, onClick: d, onTouchStart: f, onTouchMove: h, onTouchEnd: p, enableTouchCrosshair: m, tooltip: S, tooltipPosition: w, tooltipAnchor: x }), N = $.current, z = $.handleMouseEnter, k = $.handleMouseMove, F = $.handleMouseLeave, V = $.handleClick, j = $.handleTouchStart, B = $.handleTouchMove, U = $.handleTouchEnd, Q = At(function() {
    if (C && O)
      return O.render();
  }, [C, O]);
  return M.jsxs("g", { ref: E, transform: "translate(" + -o.left + "," + -o.top + ")", children: [C && O && M.jsxs(M.Fragment, { children: [M.jsx("path", { d: Q, stroke: "red", strokeWidth: 1, opacity: 0.75 }), y < 1 / 0 && M.jsx("path", { stroke: "red", strokeWidth: 0.35, fill: "none", d: A.renderPoints(void 0, y) }), N && M.jsx("path", { fill: "pink", opacity: 0.35, d: O.renderCell(N[0]) })] }), M.jsx("rect", { "data-ref": "mesh-interceptor", width: o.left + n + o.right, height: o.top + r + o.bottom, fill: "red", opacity: 0, style: { cursor: "auto" }, onMouseEnter: z, onMouseMove: k, onMouseLeave: F, onTouchStart: j, onTouchMove: B, onTouchEnd: U, onClick: V })] });
};
function Mw() {
  return Mw = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Mw.apply(this, arguments);
}
function UV(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++)
    r[n] = e[n];
  return r;
}
function yct(e, t) {
  var n = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (n)
    return (n = n.call(e)).next.bind(n);
  if (Array.isArray(e) || (n = function(i, o) {
    if (i) {
      if (typeof i == "string")
        return UV(i, o);
      var a = Object.prototype.toString.call(i).slice(8, -1);
      return a === "Object" && i.constructor && (a = i.constructor.name), a === "Map" || a === "Set" ? Array.from(i) : a === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(a) ? UV(i, o) : void 0;
    }
  }(e)) || t && e && typeof e.length == "number") {
    n && (e = n);
    var r = 0;
    return function() {
      return r >= e.length ? { done: !0 } : { done: !1, value: e[r++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
var doe = { nivo: ["#e8c1a0", "#f47560", "#f1e15b", "#e8a838", "#61cdbb", "#97e3d5"], category10: Mie, accent: kie, dark2: Nie, paired: Die, pastel1: Lie, pastel2: jie, set1: Fie, set2: Vie, set3: Z3, tableau10: Hot }, bct = Object.keys(doe), foe = { brown_blueGreen: dC, purpleRed_green: fC, pink_yellowGreen: hC, purple_orange: gC, red_blue: pC, red_grey: mC, red_yellow_blue: vC, red_yellow_green: yC, spectral: bC }, _ct = Object.keys(foe), Sct = { brown_blueGreen: Uot, purpleRed_green: Wot, pink_yellowGreen: qot, purple_orange: Got, red_blue: Kot, red_grey: Yot, red_yellow_blue: Xot, red_yellow_green: Qot, spectral: Jot }, hoe = { blues: PC, greens: MC, greys: kC, oranges: LC, purples: NC, reds: DC, blue_green: _C, blue_purple: SC, green_blue: wC, orange_red: xC, purple_blue_green: EC, purple_blue: CC, purple_red: TC, red_purple: IC, yellow_green_blue: AC, yellow_green: RC, yellow_orange_brown: $C, yellow_orange_red: OC }, wct = Object.keys(hoe), xct = { blues: dat, greens: fat, greys: hat, oranges: mat, purples: gat, reds: pat, turbo: Cat, viridis: Tat, inferno: Aat, magma: Iat, plasma: Rat, cividis: vat, warm: bat, cool: _at, cubehelixDefault: yat, blue_green: Zot, blue_purple: eat, green_blue: tat, orange_red: nat, purple_blue_green: rat, purple_blue: iat, purple_red: oat, red_purple: aat, yellow_green_blue: sat, yellow_green: cat, yellow_orange_brown: lat, yellow_orange_red: uat }, HT = Mw({}, doe, foe, hoe), Ect = function(e) {
  return bct.includes(e);
}, Cct = function(e) {
  return _ct.includes(e);
}, Tct = function(e) {
  return wct.includes(e);
}, Ict = { rainbow: Sat, sinebow: Eat };
Mw({}, Sct, xct, Ict);
var Act = function(e, t) {
  if (typeof e == "function")
    return e;
  if (ti(e)) {
    if (function(c) {
      return c.theme !== void 0;
    }(e)) {
      if (t === void 0)
        throw new Error("Unable to use color from theme as no theme was provided");
      var n = uf(t, e.theme);
      if (n === void 0)
        throw new Error("Color from theme is undefined at path: '" + e.theme + "'");
      return function() {
        return n;
      };
    }
    if (function(c) {
      return c.from !== void 0;
    }(e)) {
      var r = function(c) {
        return uf(c, e.from);
      };
      if (Array.isArray(e.modifiers)) {
        for (var i, o = [], a = function() {
          var c = i.value, l = c[0], u = c[1];
          if (l === "brighter")
            o.push(function(d) {
              return d.brighter(u);
            });
          else if (l === "darker")
            o.push(function(d) {
              return d.darker(u);
            });
          else {
            if (l !== "opacity")
              throw new Error("Invalid color modifier: '" + l + "', must be one of: 'brighter', 'darker', 'opacity'");
            o.push(function(d) {
              return d.opacity = u, d;
            });
          }
        }, s = yct(e.modifiers); !(i = s()).done; )
          a();
        return o.length === 0 ? r : function(c) {
          return o.reduce(function(l, u) {
            return u(l);
          }, Vg(r(c))).toString();
        };
      }
      return r;
    }
    throw new Error("Invalid color spec, you should either specify 'theme' or 'from' when using a config object");
  }
  return function() {
    return e;
  };
}, Rct = function(e, t) {
  return At(function() {
    return Act(e, t);
  }, [e, t]);
};
me.oneOfType([me.string, me.func, me.shape({ theme: me.string.isRequired }), me.shape({ from: me.string.isRequired, modifiers: me.arrayOf(me.array) })]);
var $ct = function(e, t) {
  if (typeof e == "function")
    return e;
  var n = typeof t == "function" ? t : function(d) {
    return uf(d, t);
  };
  if (Array.isArray(e)) {
    var r = Gc(e), i = function(d) {
      return r(n(d));
    };
    return i.scale = r, i;
  }
  if (ti(e)) {
    if (function(d) {
      return d.datum !== void 0;
    }(e))
      return function(d) {
        return uf(d, e.datum);
      };
    if (function(d) {
      return d.scheme !== void 0;
    }(e)) {
      if (Ect(e.scheme)) {
        var o = Gc(HT[e.scheme]), a = function(d) {
          return o(n(d));
        };
        return a.scale = o, a;
      }
      if (Cct(e.scheme)) {
        if (e.size !== void 0 && (e.size < 3 || e.size > 11))
          throw new Error("Invalid size '" + e.size + "' for diverging color scheme '" + e.scheme + "', must be between 3~11");
        var s = Gc(HT[e.scheme][e.size || 11]), c = function(d) {
          return s(n(d));
        };
        return c.scale = s, c;
      }
      if (Tct(e.scheme)) {
        if (e.size !== void 0 && (e.size < 3 || e.size > 9))
          throw new Error("Invalid size '" + e.size + "' for sequential color scheme '" + e.scheme + "', must be between 3~9");
        var l = Gc(HT[e.scheme][e.size || 9]), u = function(d) {
          return l(n(d));
        };
        return u.scale = l, u;
      }
    }
    throw new Error("Invalid colors, when using an object, you should either pass a 'datum' or a 'scheme' property");
  }
  return function() {
    return e;
  };
}, Oct = function(e, t) {
  return At(function() {
    return $ct(e, t);
  }, [e, t]);
}, Pct = vM;
function Mct(e, t) {
  var n = [];
  return Pct(e, function(r, i, o) {
    t(r, i, o) && n.push(r);
  }), n;
}
var kct = Mct, Nct = yZ, Dct = kct, Lct = Lp, jct = Gi;
function Fct(e, t) {
  var n = jct(e) ? Nct : Dct;
  return n(e, Lct(t));
}
var Vct = Fct;
const Bct = /* @__PURE__ */ pn(Vct);
var zct = vl, Hct = Ga, Uct = "[object Number]";
function Wct(e) {
  return typeof e == "number" || Hct(e) && zct(e) == Uct;
}
var qct = Wct;
const R$ = /* @__PURE__ */ pn(qct);
function Gct(e, t) {
  for (var n = -1, r = e == null ? 0 : e.length; ++n < r && t(e[n], n, e) !== !1; )
    ;
  return e;
}
var Kct = Gct, Yct = Hf, Xct = kp;
function Qct(e, t) {
  return e && Yct(t, Xct(t), e);
}
var Jct = Qct, Zct = Hf, elt = Fp;
function tlt(e, t) {
  return e && Zct(t, elt(t), e);
}
var nlt = tlt, rlt = Hf, ilt = gM;
function olt(e, t) {
  return rlt(e, ilt(e), t);
}
var alt = olt, slt = Hf, clt = dee;
function llt(e, t) {
  return slt(e, clt(e), t);
}
var ult = llt, dlt = Object.prototype, flt = dlt.hasOwnProperty;
function hlt(e) {
  var t = e.length, n = new e.constructor(t);
  return t && typeof e[0] == "string" && flt.call(e, "index") && (n.index = e.index, n.input = e.input), n;
}
var glt = hlt, plt = J3;
function mlt(e, t) {
  var n = t ? plt(e.buffer) : e.buffer;
  return new e.constructor(n, e.byteOffset, e.byteLength);
}
var vlt = mlt, ylt = /\w*$/;
function blt(e) {
  var t = new e.constructor(e.source, ylt.exec(e));
  return t.lastIndex = e.lastIndex, t;
}
var _lt = blt, WV = Tp, qV = WV ? WV.prototype : void 0, GV = qV ? qV.valueOf : void 0;
function Slt(e) {
  return GV ? Object(GV.call(e)) : {};
}
var wlt = Slt, xlt = J3, Elt = vlt, Clt = _lt, Tlt = wlt, Ilt = Cie, Alt = "[object Boolean]", Rlt = "[object Date]", $lt = "[object Map]", Olt = "[object Number]", Plt = "[object RegExp]", Mlt = "[object Set]", klt = "[object String]", Nlt = "[object Symbol]", Dlt = "[object ArrayBuffer]", Llt = "[object DataView]", jlt = "[object Float32Array]", Flt = "[object Float64Array]", Vlt = "[object Int8Array]", Blt = "[object Int16Array]", zlt = "[object Int32Array]", Hlt = "[object Uint8Array]", Ult = "[object Uint8ClampedArray]", Wlt = "[object Uint16Array]", qlt = "[object Uint32Array]";
function Glt(e, t, n) {
  var r = e.constructor;
  switch (t) {
    case Dlt:
      return xlt(e);
    case Alt:
    case Rlt:
      return new r(+e);
    case Llt:
      return Elt(e, n);
    case jlt:
    case Flt:
    case Vlt:
    case Blt:
    case zlt:
    case Hlt:
    case Ult:
    case Wlt:
    case qlt:
      return Ilt(e, n);
    case $lt:
      return new r();
    case Olt:
    case klt:
      return new r(e);
    case Plt:
      return Clt(e);
    case Mlt:
      return new r();
    case Nlt:
      return Tlt(e);
  }
}
var Klt = Glt, Ylt = _y, Xlt = Ga, Qlt = "[object Map]";
function Jlt(e) {
  return Xlt(e) && Ylt(e) == Qlt;
}
var Zlt = Jlt, eut = Zlt, tut = Mp, KV = EE, YV = KV && KV.isMap, nut = YV ? tut(YV) : eut, rut = nut, iut = _y, out = Ga, aut = "[object Set]";
function sut(e) {
  return out(e) && iut(e) == aut;
}
var cut = sut, lut = cut, uut = Mp, XV = EE, QV = XV && XV.isSet, dut = QV ? uut(QV) : lut, fut = dut, hut = wE, gut = Kct, put = kE, mut = Jct, vut = nlt, yut = Eie, but = Tie, _ut = alt, Sut = ult, wut = xZ, xut = CM, Eut = _y, Cut = glt, Tut = Klt, Iut = Iie, Aut = Gi, Rut = yy, $ut = rut, Out = Ka, Put = fut, Mut = kp, kut = Fp, Nut = 1, Dut = 2, Lut = 4, goe = "[object Arguments]", jut = "[object Array]", Fut = "[object Boolean]", Vut = "[object Date]", But = "[object Error]", poe = "[object Function]", zut = "[object GeneratorFunction]", Hut = "[object Map]", Uut = "[object Number]", moe = "[object Object]", Wut = "[object RegExp]", qut = "[object Set]", Gut = "[object String]", Kut = "[object Symbol]", Yut = "[object WeakMap]", Xut = "[object ArrayBuffer]", Qut = "[object DataView]", Jut = "[object Float32Array]", Zut = "[object Float64Array]", edt = "[object Int8Array]", tdt = "[object Int16Array]", ndt = "[object Int32Array]", rdt = "[object Uint8Array]", idt = "[object Uint8ClampedArray]", odt = "[object Uint16Array]", adt = "[object Uint32Array]", cr = {};
cr[goe] = cr[jut] = cr[Xut] = cr[Qut] = cr[Fut] = cr[Vut] = cr[Jut] = cr[Zut] = cr[edt] = cr[tdt] = cr[ndt] = cr[Hut] = cr[Uut] = cr[moe] = cr[Wut] = cr[qut] = cr[Gut] = cr[Kut] = cr[rdt] = cr[idt] = cr[odt] = cr[adt] = !0;
cr[But] = cr[poe] = cr[Yut] = !1;
function Q1(e, t, n, r, i, o) {
  var a, s = t & Nut, c = t & Dut, l = t & Lut;
  if (n && (a = i ? n(e, r, i, o) : n(e)), a !== void 0)
    return a;
  if (!Out(e))
    return e;
  var u = Aut(e);
  if (u) {
    if (a = Cut(e), !s)
      return but(e, a);
  } else {
    var d = Eut(e), f = d == poe || d == zut;
    if (Rut(e))
      return yut(e, s);
    if (d == moe || d == goe || f && !i) {
      if (a = c || f ? {} : Iut(e), !s)
        return c ? Sut(e, vut(a, e)) : _ut(e, mut(a, e));
    } else {
      if (!cr[d])
        return i ? e : {};
      a = Tut(e, d, s);
    }
  }
  o || (o = new hut());
  var h = o.get(e);
  if (h)
    return h;
  o.set(e, a), Put(e) ? e.forEach(function(m) {
    a.add(Q1(m, t, n, m, e, o));
  }) : $ut(e) && e.forEach(function(m, v) {
    a.set(v, Q1(m, t, n, v, e, o));
  });
  var p = l ? c ? xut : wut : c ? kut : Mut, g = u ? void 0 : p(e);
  return gut(g || e, function(m, v) {
    g && (v = m, m = e[v]), put(a, v, Q1(m, t, n, v, e, o));
  }), a;
}
var sdt = Q1;
function cdt(e, t, n) {
  var r = -1, i = e.length;
  t < 0 && (t = -t > i ? 0 : i + t), n = n > i ? i : n, n < 0 && (n += i), i = t > n ? 0 : n - t >>> 0, t >>>= 0;
  for (var o = Array(i); ++r < i; )
    o[r] = e[r + t];
  return o;
}
var ldt = cdt, udt = my, ddt = ldt;
function fdt(e, t) {
  return t.length < 2 ? e : udt(e, ddt(t, 0, -1));
}
var hdt = fdt, gdt = $p, pdt = Pie, mdt = hdt, vdt = Op;
function ydt(e, t) {
  return t = gdt(t, e), e = mdt(e, t), e == null || delete e[vdt(pdt(t))];
}
var bdt = ydt, _dt = oM;
function Sdt(e) {
  return _dt(e) ? void 0 : e;
}
var wdt = Sdt, xdt = gy, Edt = sdt, Cdt = bdt, Tdt = $p, Idt = Hf, Adt = wdt, Rdt = nee, $dt = CM, Odt = 1, Pdt = 2, Mdt = 4, kdt = Rdt(function(e, t) {
  var n = {};
  if (e == null)
    return n;
  var r = !1;
  t = xdt(t, function(o) {
    return o = Tdt(o, e), r || (r = o.length > 1), o;
  }), Idt(e, $dt(e), n), r && (n = Edt(n, Odt | Pdt | Mdt, Adt));
  for (var i = t.length; i--; )
    Cdt(n, t[i]);
  return n;
}), Ndt = kdt;
const voe = /* @__PURE__ */ pn(Ndt);
function Ou() {
  return Ou = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Ou.apply(this, arguments);
}
var $$ = { dotSize: 4, noteWidth: 120, noteTextOffset: 8, animate: !0 }, Ddt = function(e) {
  var t = typeof e;
  return eO(e) || t === "string" || t === "function" || t === "object";
}, ok = function(e) {
  return e.type === "circle";
}, Ldt = function(e) {
  return e.type === "dot";
}, ak = function(e) {
  return e.type === "rect";
}, jdt = function(e) {
  var t = e.data, n = e.annotations, r = e.getPosition, i = e.getDimensions;
  return n.reduce(function(o, a) {
    var s = a.offset || 0;
    return [].concat(o, Bct(t, a.match).map(function(c) {
      var l = r(c), u = i(c);
      return (ok(a) || ak(a)) && (u.size = u.size + 2 * s, u.width = u.width + 2 * s, u.height = u.height + 2 * s), Ou({}, voe(a, ["match", "offset"]), l, u, { size: a.size || u.size, datum: c });
    }));
  }, []);
}, Fdt = function(e, t, n, r) {
  var i = Math.atan2(r - t, n - e);
  return lst(sst(i));
}, Vdt = function(e) {
  var t, n, r = e.x, i = e.y, o = e.noteX, a = e.noteY, s = e.noteWidth, c = s === void 0 ? $$.noteWidth : s, l = e.noteTextOffset, u = l === void 0 ? $$.noteTextOffset : l;
  if (R$(o))
    t = r + o;
  else {
    if (o.abs === void 0)
      throw new Error("noteX should be either a number or an object containing an 'abs' property");
    t = o.abs;
  }
  if (R$(a))
    n = i + a;
  else {
    if (a.abs === void 0)
      throw new Error("noteY should be either a number or an object containing an 'abs' property");
    n = a.abs;
  }
  var d = r, f = i, h = Fdt(r, i, t, n);
  if (ok(e)) {
    var p = cst(E$(h), e.size / 2);
    d += p.x, f += p.y;
  }
  if (ak(e)) {
    var g = Math.round((h + 90) / 45) % 8;
    g === 0 && (f -= e.height / 2), g === 1 && (d += e.width / 2, f -= e.height / 2), g === 2 && (d += e.width / 2), g === 3 && (d += e.width / 2, f += e.height / 2), g === 4 && (f += e.height / 2), g === 5 && (d -= e.width / 2, f += e.height / 2), g === 6 && (d -= e.width / 2), g === 7 && (d -= e.width / 2, f -= e.height / 2);
  }
  var m = t, v = t;
  return (h + 90) % 360 > 180 ? (m -= c, v -= c) : v += c, { points: [[d, f], [t, n], [v, n]], text: [m, n - u], angle: h + 90 };
}, Bdt = function(e) {
  var t = e.data, n = e.annotations, r = e.getPosition, i = e.getDimensions;
  return At(function() {
    return jdt({ data: t, annotations: n, getPosition: r, getDimensions: i });
  }, [t, n, r, i]);
}, zdt = function(e) {
  return At(function() {
    return Vdt(e);
  }, [e]);
}, Hdt = function(e) {
  var t = e.datum, n = e.x, r = e.y, i = e.note, o = go(), a = Os(), s = a.animate, c = a.config, l = bl({ x: n, y: r, config: c, immediate: !s });
  return typeof i == "function" ? Yd(i, { x: n, y: r, datum: t }) : M.jsxs(M.Fragment, { children: [o.annotations.text.outlineWidth > 0 && M.jsx(wi.text, { x: l.x, y: l.y, style: Ou({}, o.annotations.text, { strokeLinejoin: "round", strokeWidth: 2 * o.annotations.text.outlineWidth, stroke: o.annotations.text.outlineColor }), children: i }), M.jsx(wi.text, { x: l.x, y: l.y, style: voe(o.annotations.text, ["outlineWidth", "outlineColor"]), children: i })] });
}, JV = function(e) {
  var t = e.points, n = e.isOutline, r = n !== void 0 && n, i = go(), o = At(function() {
    var c = t[0];
    return t.slice(1).reduce(function(l, u) {
      return l + " L" + u[0] + "," + u[1];
    }, "M" + c[0] + "," + c[1]);
  }, [t]), a = Kat(o);
  if (r && i.annotations.link.outlineWidth <= 0)
    return null;
  var s = Ou({}, i.annotations.link);
  return r && (s.strokeLinecap = "square", s.strokeWidth = i.annotations.link.strokeWidth + 2 * i.annotations.link.outlineWidth, s.stroke = i.annotations.link.outlineColor, s.opacity = i.annotations.link.outlineOpacity), M.jsx(wi.path, { fill: "none", d: a, style: s });
}, Udt = function(e) {
  var t = e.x, n = e.y, r = e.size, i = go(), o = Os(), a = o.animate, s = o.config, c = bl({ x: t, y: n, radius: r / 2, config: s, immediate: !a });
  return M.jsxs(M.Fragment, { children: [i.annotations.outline.outlineWidth > 0 && M.jsx(wi.circle, { cx: c.x, cy: c.y, r: c.radius, style: Ou({}, i.annotations.outline, { fill: "none", strokeWidth: i.annotations.outline.strokeWidth + 2 * i.annotations.outline.outlineWidth, stroke: i.annotations.outline.outlineColor, opacity: i.annotations.outline.outlineOpacity }) }), M.jsx(wi.circle, { cx: c.x, cy: c.y, r: c.radius, style: i.annotations.outline })] });
}, Wdt = function(e) {
  var t = e.x, n = e.y, r = e.size, i = r === void 0 ? $$.dotSize : r, o = go(), a = Os(), s = a.animate, c = a.config, l = bl({ x: t, y: n, radius: i / 2, config: c, immediate: !s });
  return M.jsxs(M.Fragment, { children: [o.annotations.outline.outlineWidth > 0 && M.jsx(wi.circle, { cx: l.x, cy: l.y, r: l.radius, style: Ou({}, o.annotations.outline, { fill: "none", strokeWidth: 2 * o.annotations.outline.outlineWidth, stroke: o.annotations.outline.outlineColor, opacity: o.annotations.outline.outlineOpacity }) }), M.jsx(wi.circle, { cx: l.x, cy: l.y, r: l.radius, style: o.annotations.symbol })] });
}, qdt = function(e) {
  var t = e.x, n = e.y, r = e.width, i = e.height, o = e.borderRadius, a = o === void 0 ? 6 : o, s = go(), c = Os(), l = c.animate, u = c.config, d = bl({ x: t - r / 2, y: n - i / 2, width: r, height: i, config: u, immediate: !l });
  return M.jsxs(M.Fragment, { children: [s.annotations.outline.outlineWidth > 0 && M.jsx(wi.rect, { x: d.x, y: d.y, rx: a, ry: a, width: d.width, height: d.height, style: Ou({}, s.annotations.outline, { fill: "none", strokeWidth: s.annotations.outline.strokeWidth + 2 * s.annotations.outline.outlineWidth, stroke: s.annotations.outline.outlineColor, opacity: s.annotations.outline.outlineOpacity }) }), M.jsx(wi.rect, { x: d.x, y: d.y, rx: a, ry: a, width: d.width, height: d.height, style: s.annotations.outline })] });
}, Gdt = function(e) {
  var t = e.datum, n = e.x, r = e.y, i = e.note, o = zdt(e);
  if (!Ddt(i))
    throw new Error("note should be a valid react element");
  return M.jsxs(M.Fragment, { children: [M.jsx(JV, { points: o.points, isOutline: !0 }), ok(e) && M.jsx(Udt, { x: n, y: r, size: e.size }), Ldt(e) && M.jsx(Wdt, { x: n, y: r, size: e.size }), ak(e) && M.jsx(qdt, { x: n, y: r, width: e.width, height: e.height, borderRadius: e.borderRadius }), M.jsx(JV, { points: o.points }), M.jsx(Hdt, { datum: t, x: o.text[0], y: o.text[1], note: i })] });
};
function Kdt(e) {
  const t = +this._x.call(null, e), n = +this._y.call(null, e);
  return yoe(this.cover(t, n), t, n, e);
}
function yoe(e, t, n, r) {
  if (isNaN(t) || isNaN(n))
    return e;
  var i, o = e._root, a = { data: r }, s = e._x0, c = e._y0, l = e._x1, u = e._y1, d, f, h, p, g, m, v, y;
  if (!o)
    return e._root = a, e;
  for (; o.length; )
    if ((g = t >= (d = (s + l) / 2)) ? s = d : l = d, (m = n >= (f = (c + u) / 2)) ? c = f : u = f, i = o, !(o = o[v = m << 1 | g]))
      return i[v] = a, e;
  if (h = +e._x.call(null, o.data), p = +e._y.call(null, o.data), t === h && n === p)
    return a.next = o, i ? i[v] = a : e._root = a, e;
  do
    i = i ? i[v] = new Array(4) : e._root = new Array(4), (g = t >= (d = (s + l) / 2)) ? s = d : l = d, (m = n >= (f = (c + u) / 2)) ? c = f : u = f;
  while ((v = m << 1 | g) === (y = (p >= f) << 1 | h >= d));
  return i[y] = o, i[v] = a, e;
}
function Ydt(e) {
  var t, n, r = e.length, i, o, a = new Array(r), s = new Array(r), c = 1 / 0, l = 1 / 0, u = -1 / 0, d = -1 / 0;
  for (n = 0; n < r; ++n)
    isNaN(i = +this._x.call(null, t = e[n])) || isNaN(o = +this._y.call(null, t)) || (a[n] = i, s[n] = o, i < c && (c = i), i > u && (u = i), o < l && (l = o), o > d && (d = o));
  if (c > u || l > d)
    return this;
  for (this.cover(c, l).cover(u, d), n = 0; n < r; ++n)
    yoe(this, a[n], s[n], e[n]);
  return this;
}
function Xdt(e, t) {
  if (isNaN(e = +e) || isNaN(t = +t))
    return this;
  var n = this._x0, r = this._y0, i = this._x1, o = this._y1;
  if (isNaN(n))
    i = (n = Math.floor(e)) + 1, o = (r = Math.floor(t)) + 1;
  else {
    for (var a = i - n || 1, s = this._root, c, l; n > e || e >= i || r > t || t >= o; )
      switch (l = (t < r) << 1 | e < n, c = new Array(4), c[l] = s, s = c, a *= 2, l) {
        case 0:
          i = n + a, o = r + a;
          break;
        case 1:
          n = i - a, o = r + a;
          break;
        case 2:
          i = n + a, r = o - a;
          break;
        case 3:
          n = i - a, r = o - a;
          break;
      }
    this._root && this._root.length && (this._root = s);
  }
  return this._x0 = n, this._y0 = r, this._x1 = i, this._y1 = o, this;
}
function Qdt() {
  var e = [];
  return this.visit(function(t) {
    if (!t.length)
      do
        e.push(t.data);
      while (t = t.next);
  }), e;
}
function Jdt(e) {
  return arguments.length ? this.cover(+e[0][0], +e[0][1]).cover(+e[1][0], +e[1][1]) : isNaN(this._x0) ? void 0 : [[this._x0, this._y0], [this._x1, this._y1]];
}
function Io(e, t, n, r, i) {
  this.node = e, this.x0 = t, this.y0 = n, this.x1 = r, this.y1 = i;
}
function Zdt(e, t, n) {
  var r, i = this._x0, o = this._y0, a, s, c, l, u = this._x1, d = this._y1, f = [], h = this._root, p, g;
  for (h && f.push(new Io(h, i, o, u, d)), n == null ? n = 1 / 0 : (i = e - n, o = t - n, u = e + n, d = t + n, n *= n); p = f.pop(); )
    if (!(!(h = p.node) || (a = p.x0) > u || (s = p.y0) > d || (c = p.x1) < i || (l = p.y1) < o))
      if (h.length) {
        var m = (a + c) / 2, v = (s + l) / 2;
        f.push(
          new Io(h[3], m, v, c, l),
          new Io(h[2], a, v, m, l),
          new Io(h[1], m, s, c, v),
          new Io(h[0], a, s, m, v)
        ), (g = (t >= v) << 1 | e >= m) && (p = f[f.length - 1], f[f.length - 1] = f[f.length - 1 - g], f[f.length - 1 - g] = p);
      } else {
        var y = e - +this._x.call(null, h.data), S = t - +this._y.call(null, h.data), _ = y * y + S * S;
        if (_ < n) {
          var w = Math.sqrt(n = _);
          i = e - w, o = t - w, u = e + w, d = t + w, r = h.data;
        }
      }
  return r;
}
function eft(e) {
  if (isNaN(u = +this._x.call(null, e)) || isNaN(d = +this._y.call(null, e)))
    return this;
  var t, n = this._root, r, i, o, a = this._x0, s = this._y0, c = this._x1, l = this._y1, u, d, f, h, p, g, m, v;
  if (!n)
    return this;
  if (n.length)
    for (; ; ) {
      if ((p = u >= (f = (a + c) / 2)) ? a = f : c = f, (g = d >= (h = (s + l) / 2)) ? s = h : l = h, t = n, !(n = n[m = g << 1 | p]))
        return this;
      if (!n.length)
        break;
      (t[m + 1 & 3] || t[m + 2 & 3] || t[m + 3 & 3]) && (r = t, v = m);
    }
  for (; n.data !== e; )
    if (i = n, !(n = n.next))
      return this;
  return (o = n.next) && delete n.next, i ? (o ? i.next = o : delete i.next, this) : t ? (o ? t[m] = o : delete t[m], (n = t[0] || t[1] || t[2] || t[3]) && n === (t[3] || t[2] || t[1] || t[0]) && !n.length && (r ? r[v] = n : this._root = n), this) : (this._root = o, this);
}
function tft(e) {
  for (var t = 0, n = e.length; t < n; ++t)
    this.remove(e[t]);
  return this;
}
function nft() {
  return this._root;
}
function rft() {
  var e = 0;
  return this.visit(function(t) {
    if (!t.length)
      do
        ++e;
      while (t = t.next);
  }), e;
}
function ift(e) {
  var t = [], n, r = this._root, i, o, a, s, c;
  for (r && t.push(new Io(r, this._x0, this._y0, this._x1, this._y1)); n = t.pop(); )
    if (!e(r = n.node, o = n.x0, a = n.y0, s = n.x1, c = n.y1) && r.length) {
      var l = (o + s) / 2, u = (a + c) / 2;
      (i = r[3]) && t.push(new Io(i, l, u, s, c)), (i = r[2]) && t.push(new Io(i, o, u, l, c)), (i = r[1]) && t.push(new Io(i, l, a, s, u)), (i = r[0]) && t.push(new Io(i, o, a, l, u));
    }
  return this;
}
function oft(e) {
  var t = [], n = [], r;
  for (this._root && t.push(new Io(this._root, this._x0, this._y0, this._x1, this._y1)); r = t.pop(); ) {
    var i = r.node;
    if (i.length) {
      var o, a = r.x0, s = r.y0, c = r.x1, l = r.y1, u = (a + c) / 2, d = (s + l) / 2;
      (o = i[0]) && t.push(new Io(o, a, s, u, d)), (o = i[1]) && t.push(new Io(o, u, s, c, d)), (o = i[2]) && t.push(new Io(o, a, d, u, l)), (o = i[3]) && t.push(new Io(o, u, d, c, l));
    }
    n.push(r);
  }
  for (; r = n.pop(); )
    e(r.node, r.x0, r.y0, r.x1, r.y1);
  return this;
}
function aft(e) {
  return e[0];
}
function sft(e) {
  return arguments.length ? (this._x = e, this) : this._x;
}
function cft(e) {
  return e[1];
}
function lft(e) {
  return arguments.length ? (this._y = e, this) : this._y;
}
function boe(e, t, n) {
  var r = new sk(t ?? aft, n ?? cft, NaN, NaN, NaN, NaN);
  return e == null ? r : r.addAll(e);
}
function sk(e, t, n, r, i, o) {
  this._x = e, this._y = t, this._x0 = n, this._y0 = r, this._x1 = i, this._y1 = o, this._root = void 0;
}
function ZV(e) {
  for (var t = { data: e.data }, n = t; e = e.next; )
    n = n.next = { data: e.data };
  return t;
}
var No = boe.prototype = sk.prototype;
No.copy = function() {
  var e = new sk(this._x, this._y, this._x0, this._y0, this._x1, this._y1), t = this._root, n, r;
  if (!t)
    return e;
  if (!t.length)
    return e._root = ZV(t), e;
  for (n = [{ source: t, target: e._root = new Array(4) }]; t = n.pop(); )
    for (var i = 0; i < 4; ++i)
      (r = t.source[i]) && (r.length ? n.push({ source: r, target: t.target[i] = new Array(4) }) : t.target[i] = ZV(r));
  return e;
};
No.add = Kdt;
No.addAll = Ydt;
No.cover = Xdt;
No.data = Qdt;
No.extent = Jdt;
No.find = Zdt;
No.remove = eft;
No.removeAll = tft;
No.root = nft;
No.size = rft;
No.visit = ift;
No.visitAfter = oft;
No.x = sft;
No.y = lft;
function Qs(e) {
  return function() {
    return e;
  };
}
function eB(e) {
  return (e() - 0.5) * 1e-6;
}
function uft(e) {
  return e.x + e.vx;
}
function dft(e) {
  return e.y + e.vy;
}
function fft(e) {
  var t, n, r, i = 1, o = 1;
  typeof e != "function" && (e = Qs(e == null ? 1 : +e));
  function a() {
    for (var l, u = t.length, d, f, h, p, g, m, v = 0; v < o; ++v)
      for (d = boe(t, uft, dft).visitAfter(s), l = 0; l < u; ++l)
        f = t[l], g = n[f.index], m = g * g, h = f.x + f.vx, p = f.y + f.vy, d.visit(y);
    function y(S, _, w, T, x) {
      var C = S.data, E = S.r, R = g + E;
      if (C) {
        if (C.index > f.index) {
          var A = h - C.x - C.vx, O = p - C.y - C.vy, $ = A * A + O * O;
          $ < R * R && (A === 0 && (A = eB(r), $ += A * A), O === 0 && (O = eB(r), $ += O * O), $ = (R - ($ = Math.sqrt($))) / $ * i, f.vx += (A *= $) * (R = (E *= E) / (m + E)), f.vy += (O *= $) * R, C.vx -= A * (R = 1 - R), C.vy -= O * R);
        }
        return;
      }
      return _ > h + R || T < h - R || w > p + R || x < p - R;
    }
  }
  function s(l) {
    if (l.data)
      return l.r = n[l.data.index];
    for (var u = l.r = 0; u < 4; ++u)
      l[u] && l[u].r > l.r && (l.r = l[u].r);
  }
  function c() {
    if (t) {
      var l, u = t.length, d;
      for (n = new Array(u), l = 0; l < u; ++l)
        d = t[l], n[d.index] = +e(d, l, t);
    }
  }
  return a.initialize = function(l, u) {
    t = l, r = u, c();
  }, a.iterations = function(l) {
    return arguments.length ? (o = +l, a) : o;
  }, a.strength = function(l) {
    return arguments.length ? (i = +l, a) : i;
  }, a.radius = function(l) {
    return arguments.length ? (e = typeof l == "function" ? l : Qs(+l), c(), a) : e;
  }, a;
}
var hft = { value: () => {
} };
function _oe() {
  for (var e = 0, t = arguments.length, n = {}, r; e < t; ++e) {
    if (!(r = arguments[e] + "") || r in n || /[\s.]/.test(r))
      throw new Error("illegal type: " + r);
    n[r] = [];
  }
  return new J1(n);
}
function J1(e) {
  this._ = e;
}
function gft(e, t) {
  return e.trim().split(/^|\s+/).map(function(n) {
    var r = "", i = n.indexOf(".");
    if (i >= 0 && (r = n.slice(i + 1), n = n.slice(0, i)), n && !t.hasOwnProperty(n))
      throw new Error("unknown type: " + n);
    return { type: n, name: r };
  });
}
J1.prototype = _oe.prototype = {
  constructor: J1,
  on: function(e, t) {
    var n = this._, r = gft(e + "", n), i, o = -1, a = r.length;
    if (arguments.length < 2) {
      for (; ++o < a; )
        if ((i = (e = r[o]).type) && (i = pft(n[i], e.name)))
          return i;
      return;
    }
    if (t != null && typeof t != "function")
      throw new Error("invalid callback: " + t);
    for (; ++o < a; )
      if (i = (e = r[o]).type)
        n[i] = tB(n[i], e.name, t);
      else if (t == null)
        for (i in n)
          n[i] = tB(n[i], e.name, null);
    return this;
  },
  copy: function() {
    var e = {}, t = this._;
    for (var n in t)
      e[n] = t[n].slice();
    return new J1(e);
  },
  call: function(e, t) {
    if ((i = arguments.length - 2) > 0)
      for (var n = new Array(i), r = 0, i, o; r < i; ++r)
        n[r] = arguments[r + 2];
    if (!this._.hasOwnProperty(e))
      throw new Error("unknown type: " + e);
    for (o = this._[e], r = 0, i = o.length; r < i; ++r)
      o[r].value.apply(t, n);
  },
  apply: function(e, t, n) {
    if (!this._.hasOwnProperty(e))
      throw new Error("unknown type: " + e);
    for (var r = this._[e], i = 0, o = r.length; i < o; ++i)
      r[i].value.apply(t, n);
  }
};
function pft(e, t) {
  for (var n = 0, r = e.length, i; n < r; ++n)
    if ((i = e[n]).name === t)
      return i.value;
}
function tB(e, t, n) {
  for (var r = 0, i = e.length; r < i; ++r)
    if (e[r].name === t) {
      e[r] = hft, e = e.slice(0, r).concat(e.slice(r + 1));
      break;
    }
  return n != null && e.push({ name: t, value: n }), e;
}
var Zg = 0, Qm = 0, Rm = 0, Soe = 1e3, kw, Jm, Nw = 0, _f = 0, FC = 0, kv = typeof performance == "object" && performance.now ? performance : Date, woe = typeof window == "object" && window.requestAnimationFrame ? window.requestAnimationFrame.bind(window) : function(e) {
  setTimeout(e, 17);
};
function xoe() {
  return _f || (woe(mft), _f = kv.now() + FC);
}
function mft() {
  _f = 0;
}
function O$() {
  this._call = this._time = this._next = null;
}
O$.prototype = Eoe.prototype = {
  constructor: O$,
  restart: function(e, t, n) {
    if (typeof e != "function")
      throw new TypeError("callback is not a function");
    n = (n == null ? xoe() : +n) + (t == null ? 0 : +t), !this._next && Jm !== this && (Jm ? Jm._next = this : kw = this, Jm = this), this._call = e, this._time = n, P$();
  },
  stop: function() {
    this._call && (this._call = null, this._time = 1 / 0, P$());
  }
};
function Eoe(e, t, n) {
  var r = new O$();
  return r.restart(e, t, n), r;
}
function vft() {
  xoe(), ++Zg;
  for (var e = kw, t; e; )
    (t = _f - e._time) >= 0 && e._call.call(null, t), e = e._next;
  --Zg;
}
function nB() {
  _f = (Nw = kv.now()) + FC, Zg = Qm = 0;
  try {
    vft();
  } finally {
    Zg = 0, bft(), _f = 0;
  }
}
function yft() {
  var e = kv.now(), t = e - Nw;
  t > Soe && (FC -= t, Nw = e);
}
function bft() {
  for (var e, t = kw, n, r = 1 / 0; t; )
    t._call ? (r > t._time && (r = t._time), e = t, t = t._next) : (n = t._next, t._next = null, t = e ? e._next = n : kw = n);
  Jm = e, P$(r);
}
function P$(e) {
  if (!Zg) {
    Qm && (Qm = clearTimeout(Qm));
    var t = e - _f;
    t > 24 ? (e < 1 / 0 && (Qm = setTimeout(nB, e - kv.now() - FC)), Rm && (Rm = clearInterval(Rm))) : (Rm || (Nw = kv.now(), Rm = setInterval(yft, Soe)), Zg = 1, woe(nB));
  }
}
const _ft = 1664525, Sft = 1013904223, rB = 4294967296;
function wft() {
  let e = 1;
  return () => (e = (_ft * e + Sft) % rB) / rB;
}
var xft = 10, Eft = Math.PI * (3 - Math.sqrt(5));
function Cft(e) {
  var t, n = 1, r = 1e-3, i = 1 - Math.pow(r, 1 / 300), o = 0, a = 0.6, s = /* @__PURE__ */ new Map(), c = Eoe(d), l = _oe("tick", "end"), u = wft();
  e == null && (e = []);
  function d() {
    f(), l.call("tick", t), n < r && (c.stop(), l.call("end", t));
  }
  function f(g) {
    var m, v = e.length, y;
    g === void 0 && (g = 1);
    for (var S = 0; S < g; ++S)
      for (n += (o - n) * i, s.forEach(function(_) {
        _(n);
      }), m = 0; m < v; ++m)
        y = e[m], y.fx == null ? y.x += y.vx *= a : (y.x = y.fx, y.vx = 0), y.fy == null ? y.y += y.vy *= a : (y.y = y.fy, y.vy = 0);
    return t;
  }
  function h() {
    for (var g = 0, m = e.length, v; g < m; ++g) {
      if (v = e[g], v.index = g, v.fx != null && (v.x = v.fx), v.fy != null && (v.y = v.fy), isNaN(v.x) || isNaN(v.y)) {
        var y = xft * Math.sqrt(0.5 + g), S = g * Eft;
        v.x = y * Math.cos(S), v.y = y * Math.sin(S);
      }
      (isNaN(v.vx) || isNaN(v.vy)) && (v.vx = v.vy = 0);
    }
  }
  function p(g) {
    return g.initialize && g.initialize(e, u), g;
  }
  return h(), t = {
    tick: f,
    restart: function() {
      return c.restart(d), t;
    },
    stop: function() {
      return c.stop(), t;
    },
    nodes: function(g) {
      return arguments.length ? (e = g, h(), s.forEach(p), t) : e;
    },
    alpha: function(g) {
      return arguments.length ? (n = +g, t) : n;
    },
    alphaMin: function(g) {
      return arguments.length ? (r = +g, t) : r;
    },
    alphaDecay: function(g) {
      return arguments.length ? (i = +g, t) : +i;
    },
    alphaTarget: function(g) {
      return arguments.length ? (o = +g, t) : o;
    },
    velocityDecay: function(g) {
      return arguments.length ? (a = 1 - g, t) : 1 - a;
    },
    randomSource: function(g) {
      return arguments.length ? (u = g, s.forEach(p), t) : u;
    },
    force: function(g, m) {
      return arguments.length > 1 ? (m == null ? s.delete(g) : s.set(g, p(m)), t) : s.get(g);
    },
    find: function(g, m, v) {
      var y = 0, S = e.length, _, w, T, x, C;
      for (v == null ? v = 1 / 0 : v *= v, y = 0; y < S; ++y)
        x = e[y], _ = g - x.x, w = m - x.y, T = _ * _ + w * w, T < v && (C = x, v = T);
      return C;
    },
    on: function(g, m) {
      return arguments.length > 1 ? (l.on(g, m), t) : l.on(g);
    }
  };
}
function iB(e) {
  var t = Qs(0.1), n, r, i;
  typeof e != "function" && (e = Qs(e == null ? 0 : +e));
  function o(s) {
    for (var c = 0, l = n.length, u; c < l; ++c)
      u = n[c], u.vx += (i[c] - u.x) * r[c] * s;
  }
  function a() {
    if (n) {
      var s, c = n.length;
      for (r = new Array(c), i = new Array(c), s = 0; s < c; ++s)
        r[s] = isNaN(i[s] = +e(n[s], s, n)) ? 0 : +t(n[s], s, n);
    }
  }
  return o.initialize = function(s) {
    n = s, a();
  }, o.strength = function(s) {
    return arguments.length ? (t = typeof s == "function" ? s : Qs(+s), a(), o) : t;
  }, o.x = function(s) {
    return arguments.length ? (e = typeof s == "function" ? s : Qs(+s), a(), o) : e;
  }, o;
}
function oB(e) {
  var t = Qs(0.1), n, r, i;
  typeof e != "function" && (e = Qs(e == null ? 0 : +e));
  function o(s) {
    for (var c = 0, l = n.length, u; c < l; ++c)
      u = n[c], u.vy += (i[c] - u.y) * r[c] * s;
  }
  function a() {
    if (n) {
      var s, c = n.length;
      for (r = new Array(c), i = new Array(c), s = 0; s < c; ++s)
        r[s] = isNaN(i[s] = +e(n[s], s, n)) ? 0 : +t(n[s], s, n);
    }
  }
  return o.initialize = function(s) {
    n = s, a();
  }, o.strength = function(s) {
    return arguments.length ? (t = typeof s == "function" ? s : Qs(+s), a(), o) : t;
  }, o.y = function(s) {
    return arguments.length ? (e = typeof s == "function" ? s : Qs(+s), a(), o) : e;
  }, o;
}
function Pu() {
  return Pu = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Pu.apply(this, arguments);
}
function Coe(e, t) {
  if (e == null)
    return {};
  var n, r, i = {}, o = Object.keys(e);
  for (r = 0; r < o.length; r++)
    n = o[r], t.indexOf(n) >= 0 || (i[n] = e[n]);
  return i;
}
var aB, Tft = function(e) {
  var t = e.id, n = e.formattedValue, r = e.color;
  return M.jsx(Rit, { id: t, value: n, enableChip: !0, color: r });
}, Kn = { id: "id", value: "value", valueScale: { type: "linear", min: 0, max: "auto" }, groupBy: "group", size: 6, spacing: 2, layout: "vertical", gap: 0, forceStrength: 1, simulationIterations: 120, colors: { scheme: "nivo" }, colorBy: "group", borderWidth: 0, borderColor: "rgba(0, 0, 0, 0)", layers: ["grid", "axes", "circles", "annotations", "mesh"], enableGridX: !0, enableGridY: !0, axisTop: {}, axisRight: {}, axisBottom: {}, axisLeft: {}, isInteractive: !0, useMesh: !1, debugMesh: !1, tooltip: Tft, animate: !0, motionConfig: "gentle", annotations: [], role: "img", pixelRatio: typeof window < "u" && (aB = window.devicePixelRatio) != null ? aB : 1 }, Ift = function(e) {
  var t = e.width, n = e.height, r = e.axis, i = e.groups, o = e.gap;
  if (!Array.isArray(i) || i.length === 0)
    throw new Error("'groups' should be an array containing at least one item");
  var a, s = i.length;
  r === "x" ? a = (n - o * (s - 1)) / s : r === "y" && (a = (t - o * (s - 1)) / s);
  var c = i.map(function(l, u) {
    return u * (a + o) + a / 2;
  });
  return Gc(c).domain(i);
}, Aft = function(e) {
  var t = e.width, n = e.height, r = e.axis, i = e.getValue, o = e.scale, a = e.data.map(i);
  if (o.type === "time") {
    var s = [{ data: a.map(function(d) {
      var f;
      return { data: (f = { x: null, y: null }, f[r] = d, f) };
    }) }], c = Nst(s, r, o);
    return DV(o, c, r === "x" ? t : n, r);
  }
  var l = Math.min.apply(Math, a), u = Math.max.apply(Math, a);
  return DV(o, { all: a, min: l, max: u }, r === "x" ? t : n, r);
}, Rft = function(e) {
  if (typeof e == "function")
    return e;
  if (R$(e))
    return function() {
      return e;
    };
  if (ti(e)) {
    if (!Oie(e.key))
      throw new Error("Size is invalid, key should be a string pointing to the property to use to determine node size");
    if (!Array.isArray(e.values) || e.values.length !== 2)
      throw new Error("Size is invalid, values spec should be an array containing two values, min and max");
    if (!Array.isArray(e.sizes) || e.sizes.length !== 2)
      throw new Error("Size is invalid, sizes spec should be an array containing two values, min and max");
    var t = Ry().domain([e.values[0], e.values[1]]).range([e.sizes[0], e.sizes[1]]);
    return function(n) {
      return t(uf(n, e.key));
    };
  }
  throw new Error("Size is invalid, it should be either a function, a number or an object");
}, $ft = function(e) {
  var t, n, r = e.axis, i = e.valueScale, o = e.ordinalScale, a = e.spacing, s = e.forceStrength, c = fft(function(l) {
    return l.size / 2 + a / 2;
  });
  if (r === "x")
    t = iB(function(l) {
      return i(l.value);
    }).strength(s), n = oB(function(l) {
      return o(l.group);
    });
  else {
    if (r !== "y")
      throw new Error("Invalid axis provided: " + r);
    t = iB(function(l) {
      return o(l.group);
    }), n = oB(function(l) {
      return i(l.value);
    }).strength(s);
  }
  return { x: t, y: n, collision: c };
}, Oft = function(e) {
  var t, n, r = e.data, i = e.getId, o = e.layout, a = e.getValue, s = e.valueScale, c = e.getGroup, l = e.ordinalScale, u = e.getSize, d = e.forces, f = e.simulationIterations, h = e.valueScaleConfig, p = { horizontal: ["x", "y"], vertical: ["y", "x"] }, g = (n = h).type === "time" && n.format !== "native" ? nk(n) : function(y) {
    return y;
  }, m = r.map(function(y) {
    return { id: i(y), group: c(y), value: g(a(y)), size: u(y), data: Pu({}, y) };
  }), v = Cft(m).force("x", d.x).force("y", d.y).force("collide", d.collision).stop();
  return v.tick(f), (t = {})[p[o][0] + "Scale"] = s, t[p[o][1] + "Scale"] = l, t.nodes = v.nodes(), t;
}, Pft = function(e) {
  var t = e.width, n = e.height, r = e.axis, i = e.getValue, o = e.scale, a = e.data;
  return At(function() {
    return Aft({ width: t, height: n, axis: r, getValue: i, scale: o, data: a });
  }, [t, n, r, i, o, a]);
}, Mft = function(e) {
  var t = e.width, n = e.height, r = e.axis, i = e.groups, o = e.gap;
  return At(function() {
    return Ift({ width: t, height: n, axis: r, groups: i, gap: o });
  }, [t, n, r, i, o]);
}, kft = function(e) {
  var t = e.axis, n = e.valueScale, r = e.ordinalScale, i = e.spacing, o = e.forceStrength;
  return At(function() {
    return $ft({ axis: t, valueScale: n, ordinalScale: r, spacing: i, forceStrength: o });
  }, [t, n, r, i, o]);
}, Nft = function(e) {
  var t = e.data, n = e.width, r = e.height, i = e.id, o = e.value, a = e.valueFormat, s = e.valueScale, c = e.groups, l = e.groupBy, u = e.size, d = e.spacing, f = e.layout, h = e.gap, p = e.forceStrength, g = e.simulationIterations, m = e.colors, v = e.colorBy, y = f === "horizontal" ? "x" : "y", S = f1(i), _ = f1(o), w = qie(a), T = f1(l), x = function(F) {
    return At(function() {
      return Rft(F);
    }, [F]);
  }(u), C = f1(v), E = Oct(m, C), R = Pft({ width: n, height: r, axis: y, getValue: _, scale: s, data: t }), A = Mft({ width: n, height: r, axis: y, groups: c, gap: h }), O = kft({ axis: y, valueScale: R, ordinalScale: A, spacing: d, forceStrength: p }), $ = At(function() {
    return Oft({ data: t, getId: S, layout: f, getValue: _, valueScale: R, getGroup: T, ordinalScale: A, getSize: x, forces: O, simulationIterations: g, valueScaleConfig: s });
  }, [t, S, f, _, R, T, A, x, O, g, s]), N = $.nodes, z = $.xScale, k = $.yScale;
  return { nodes: At(function() {
    return N.map(function(F) {
      return Pu({}, F, { formattedValue: w(F.value), color: E(F) });
    });
  }, [N, w, E]), xScale: z, yScale: k, getColor: E };
}, Dft = function(e) {
  return At(function() {
    return typeof e == "function" ? e : function() {
      return e;
    };
  }, [e]);
}, Lft = function(e) {
  var t = e.isInteractive, n = e.onClick, r = e.onMouseEnter, i = e.onMouseLeave, o = e.onMouseMove, a = e.tooltip, s = Q3(), c = s.showTooltipFromEvent, l = s.hideTooltip;
  return { onMouseEnter: mn(function(u, d) {
    t && (c(a(u), d), r == null || r(u, d));
  }, [t, r, c, a]), onMouseMove: mn(function(u, d) {
    t && (c(a(u), d), o == null || o(u, d));
  }, [t, o, c, a]), onMouseLeave: mn(function(u, d) {
    t && (l(), i == null || i(u, d));
  }, [t, l, i]), onClick: mn(function(u, d) {
    t && (n == null || n(u, d));
  }, [t, n]) };
}, jft = function(e) {
  return { x: e.x, y: e.y };
}, Fft = function(e) {
  return { size: e.size, width: e.size, height: e.size };
}, Vft = function(e, t) {
  return Bdt({ data: e, annotations: t, getPosition: jft, getDimensions: Fft });
}, Bft = function(e) {
  var t = e.nodes, n = e.xScale, r = e.yScale, i = e.innerWidth, o = e.innerHeight, a = e.outerWidth, s = e.outerHeight, c = e.margin;
  return At(function() {
    return { nodes: t, xScale: n, yScale: r, innerWidth: i, innerHeight: o, outerWidth: a, outerHeight: s, margin: c };
  }, [t, n, r, i, o, a, s, c]);
}, zft = function(e) {
  var t = e.nodes, n = e.borderWidth, r = e.borderColor, i = e.component, o = e.isInteractive, a = e.onMouseEnter, s = e.onMouseMove, c = e.onMouseLeave, l = e.onClick, u = e.tooltip, d = Q3(), f = d.showTooltipFromEvent, h = d.hideTooltip, p = At(function() {
    if (o)
      return function(R, A) {
        f(Yd(u, R), A), a == null || a(R, A);
      };
  }, [o, f, u, a]), g = At(function() {
    if (o)
      return function(R, A) {
        f(Yd(u, R), A), s == null || s(R, A);
      };
  }, [o, f, u, s]), m = At(function() {
    if (o)
      return function(R, A) {
        h(), c == null || c(R, A);
      };
  }, [o, h, c]), v = At(function() {
    if (o)
      return function(R, A) {
        l == null || l(R, A);
      };
  }, [o, l]), y = Os(), S = y.animate, _ = y.config, w = go(), T = Dft(n), x = Rct(r, w), C = At(function() {
    return function(R) {
      return { enter: function(A) {
        return { x: A.x, y: A.y, radius: 0, color: A.color, borderColor: R(A), opacity: 0 };
      }, update: function(A) {
        return { x: A.x, y: A.y, radius: A.size / 2, color: A.color, borderColor: R(A), opacity: 1 };
      }, leave: function(A) {
        return { x: A.x, y: A.y, radius: 0, color: A.color, borderColor: R(A), opacity: 0 };
      } };
    }(x);
  }, [x]), E = X3(t, { keys: function(R) {
    return R.id;
  }, initial: C.update, from: C.enter, enter: C.update, update: C.update, leave: C.leave, config: _, immediate: !S });
  return M.jsx(M.Fragment, { children: E(function(R, A) {
    return I.createElement(i, { key: A.id, node: A, style: Pu({}, R, { radius: (O = R.radius, yie([O], function($) {
      return Math.max(0, $);
    })), borderWidth: T(A) }), onMouseEnter: p, onMouseMove: g, onMouseLeave: m, onClick: v });
    var O;
  }) });
}, Hft = function(e) {
  var t = e.node, n = e.style, r = e.onMouseEnter, i = e.onMouseMove, o = e.onMouseLeave, a = e.onClick;
  return M.jsx(wi.circle, { cx: n.x, cy: n.y, r: n.radius, fill: n.color, stroke: n.borderColor, strokeWidth: n.borderWidth, opacity: n.opacity, onMouseEnter: function(s) {
    return r == null ? void 0 : r(t, s);
  }, onMouseMove: function(s) {
    return i == null ? void 0 : i(t, s);
  }, onMouseLeave: function(s) {
    return o == null ? void 0 : o(t, s);
  }, onClick: function(s) {
    return a == null ? void 0 : a(t, s);
  } }, t.id);
}, Uft = function(e) {
  var t = e.nodes, n = e.annotations, r = Vft(t, n);
  return M.jsx(M.Fragment, { children: r.map(function(i, o) {
    return M.jsx(Gdt, Pu({}, i), o);
  }) });
}, Wft = ["nodes"], qft = ["theme", "isInteractive", "animate", "motionConfig", "renderWrapper"], Gft = function(e) {
  var t = e.data, n = e.width, r = e.height, i = e.margin, o = e.id, a = o === void 0 ? Kn.id : o, s = e.value, c = s === void 0 ? Kn.value : s, l = e.valueScale, u = l === void 0 ? Kn.valueScale : l, d = e.valueFormat, f = e.groups, h = e.groupBy, p = h === void 0 ? Kn.groupBy : h, g = e.size, m = g === void 0 ? Kn.size : g, v = e.forceStrength, y = v === void 0 ? Kn.forceStrength : v, S = e.simulationIterations, _ = S === void 0 ? Kn.simulationIterations : S, w = e.colors, T = w === void 0 ? Kn.colors : w, x = e.colorBy, C = x === void 0 ? Kn.colorBy : x, E = e.borderColor, R = E === void 0 ? Kn.borderColor : E, A = e.borderWidth, O = A === void 0 ? Kn.borderWidth : A, $ = e.layout, N = $ === void 0 ? Kn.layout : $, z = e.spacing, k = z === void 0 ? Kn.spacing : z, F = e.gap, V = F === void 0 ? Kn.gap : F, j = e.layers, B = j === void 0 ? Kn.layers : j, U = e.circleComponent, Q = U === void 0 ? Hft : U, K = e.useMesh, q = K === void 0 ? Kn.useMesh : K, X = e.debugMesh, ie = X === void 0 ? Kn.debugMesh : X, te = e.enableGridX, J = te === void 0 ? Kn.enableGridX : te, Y = e.gridXValues, ee = e.enableGridY, Z = ee === void 0 ? Kn.enableGridY : ee, H = e.gridYValues, oe = e.axisTop, W = oe === void 0 ? Kn.axisTop : oe, se = e.axisRight, ce = se === void 0 ? Kn.axisRight : se, ge = e.axisBottom, he = ge === void 0 ? Kn.axisBottom : ge, ue = e.axisLeft, Ee = ue === void 0 ? Kn.axisLeft : ue, pe = e.isInteractive, Oe = e.onMouseEnter, de = e.onMouseMove, be = e.onMouseLeave, Ie = e.onClick, Ve = e.tooltip, Fe = Ve === void 0 ? Kn.tooltip : Ve, Pe = e.annotations, ot = Pe === void 0 ? Kn.annotations : Pe, dt = e.role, ft = dt === void 0 ? Kn.role : dt, wt = Zat(n, r, i), Ge = wt.outerWidth, at = wt.outerHeight, Nt = wt.margin, zt = wt.innerWidth, kt = wt.innerHeight, Ct = Nft({ width: zt, height: kt, data: t, id: a, value: c, valueFormat: d, valueScale: u, groups: f, groupBy: p, size: m, spacing: k, layout: N, gap: V, colors: T, colorBy: C, forceStrength: y, simulationIterations: _ }), yt = Ct.nodes, Mn = Coe(Ct, Wft), Pt = Mn.xScale, Ze = Mn.yScale, Le = Lft({ isInteractive: pe, onClick: Ie, onMouseEnter: Oe, onMouseLeave: be, onMouseMove: de, tooltip: Fe }), rt = { grid: null, axes: null, circles: null, annotations: null, mesh: null };
  B.includes("grid") && (rt.grid = M.jsx(qst, { width: zt, height: kt, xScale: J ? Pt : null, xValues: Y, yScale: Z ? Ze : null, yValues: H }, "grid")), B.includes("axes") && (rt.axes = M.jsx(Ust, { xScale: Pt, yScale: Ze, width: zt, height: kt, top: W ?? void 0, right: ce ?? void 0, bottom: he ?? void 0, left: Ee ?? void 0 }, "axes")), B.includes("circles") && (rt.circles = M.jsx(zft, { nodes: yt, borderWidth: O, borderColor: R, isInteractive: pe, tooltip: Fe, component: Q, onMouseEnter: Oe, onMouseMove: de, onMouseLeave: be, onClick: Ie }, "circles")), B.includes("annotations") && (rt.annotations = M.jsx(Uft, { nodes: yt, annotations: ot }, "annotations")), pe && q && (rt.mesh = M.jsx(vct, { nodes: yt, width: zt, height: kt, onMouseEnter: Le.onMouseEnter, onMouseMove: Le.onMouseMove, onMouseLeave: Le.onMouseLeave, onClick: Le.onClick, debug: ie }, "mesh"));
  var ut = Bft({ nodes: yt, xScale: Pt, yScale: Ze, innerWidth: zt, innerHeight: kt, outerWidth: Ge, outerHeight: at, margin: Nt });
  return M.jsx(toe, { width: Ge, height: at, margin: Nt, role: ft, children: B.map(function(vt, We) {
    return rt[vt] !== void 0 ? rt[vt] : typeof vt == "function" ? M.jsx(Oz, { children: Yd(vt, ut) }, We) : null;
  }) });
}, Kft = function(e) {
  var t = e.theme, n = e.isInteractive, r = n === void 0 ? Kn.isInteractive : n, i = e.animate, o = i === void 0 ? Kn.animate : i, a = e.motionConfig, s = a === void 0 ? Kn.motionConfig : a, c = e.renderWrapper, l = Coe(e, qft);
  return M.jsx(Qie, { isInteractive: r, animate: o, motionConfig: s, theme: t, renderWrapper: c, children: M.jsx(Gft, Pu({ isInteractive: r }, l)) });
}, Yft = function(e) {
  return M.jsx(Jie, { children: function(t) {
    var n = t.width, r = t.height;
    return M.jsx(Kft, Pu({ width: n, height: r }, e));
  } });
};
const Xft = {
  text: {
    fontSize: 16,
    fontFamily: "Inter, sans-serif"
  }
}, Qft = (e) => {
  const { primaryColour: t } = hr(), n = Dn(e.output.data, {
    currentAnswer: e.currentAnswer,
    answers: e.answers,
    aggregateAnswers: e.aggregateAnswers
  }), r = Dn(e.output.xAxisOptions, {
    currentAnswer: e.currentAnswer,
    answers: e.answers,
    aggregateAnswers: e.aggregateAnswers
  }), i = Dn(e.output.chartOptions, {
    currentAnswer: e.currentAnswer,
    answers: e.answers,
    aggregateAnswers: e.aggregateAnswers
  }), o = Jft(n), a = Zft(n);
  return !o || o.length === 0 ? null : /* @__PURE__ */ M.jsx(
    tht,
    {
      height: i != null && i.height ? `${i == null ? void 0 : i.height}px` : void 0,
      width: i != null && i.width ? `${i.width}px` : void 0,
      children: /* @__PURE__ */ M.jsx(
        Yft,
        {
          data: o,
          groups: a,
          colors: t,
          valueFormat: e.output.hoverFormat,
          valueScale: {
            type: "linear",
            min: r == null ? void 0 : r.min,
            max: r == null ? void 0 : r.max,
            reverse: !1
          },
          size: (s) => eht(s, e.output.defaultSize),
          layout: e.output.layout ?? "horizontal",
          forceStrength: 4,
          simulationIterations: 100,
          borderColor: {
            from: "color",
            modifiers: [
              ["darker", 0.6],
              ["opacity", 0.5]
            ]
          },
          enableGridX: !1,
          gridXValues: r == null ? void 0 : r.tickValues,
          margin: { top: 80, right: 100, bottom: 80, left: 100 },
          theme: Xft,
          axisTop: {
            tickValues: r == null ? void 0 : r.tickValues
          },
          axisBottom: {
            tickValues: r == null ? void 0 : r.tickValues
          },
          axisLeft: e.output.leftAxisLabel ? {
            legend: /* @__PURE__ */ M.jsx("tspan", { style: { fontSize: "1rem" }, children: e.output.leftAxisLabel }),
            legendPosition: "middle",
            legendOffset: -60
          } : void 0,
          axisRight: e.output.rightAxisLabel ? {
            legend: /* @__PURE__ */ M.jsx("tspan", { style: { fontSize: "1rem" }, children: e.output.rightAxisLabel }),
            legendPosition: "middle",
            legendOffset: 60
          } : void 0,
          circleComponent: e.output.showPointLabels ? ({ node: s, style: c }) => /* @__PURE__ */ M.jsxs("g", { transform: `translate(${s.x},${s.y})`, children: [
            /* @__PURE__ */ M.jsx("text", { transform: `translate(${s.size / 2 + 5}, 0) rotate(-45)`, children: s.data.label }),
            /* @__PURE__ */ M.jsx(
              "circle",
              {
                r: s.size / 2,
                fill: c.color.get(),
                stroke: c.borderColor.get(),
                strokeWidth: c.borderWidth
              }
            )
          ] }) : void 0,
          tooltip: (s) => /* @__PURE__ */ M.jsx(
            "div",
            {
              style: {
                padding: "0.3rem",
                background: "white",
                border: "1px solid #ccc",
                borderRadius: "0.3rem",
                boxShadow: "0 1px 2px rgba(0, 0, 0, 0.25)"
              },
              children: /* @__PURE__ */ M.jsx("div", { children: s.data.label ? `${s.data.label}: ${s.value.toLocaleString()}` : s.value.toLocaleString() })
            }
          )
        }
      )
    }
  );
};
function Jft(e) {
  if (!e)
    return;
  const t = [];
  return e.forEach((n) => {
    n.dataset.forEach((r) => {
      t.push({
        id: r.id,
        group: n.label,
        value: r.value,
        size: r.size,
        label: r.label
      });
    });
  }), t;
}
function Zft(e) {
  return e ? e.map((n) => n.label) : [];
}
function eht(e, t = 10) {
  return e.size ?? t;
}
const tht = Ce.div`
  display: flex;
  flex: 1 1 auto;
  height: ${(e) => e.height || "30rem"};
  width: ${(e) => e.width || "100%"};
`, nht = (e) => /* @__PURE__ */ M.jsx(Qft, { ...e }), sB = ({
  outputs: e,
  currentAnswer: t,
  answers: n,
  settings: r,
  direction: i,
  style: o,
  location: a
}) => /* @__PURE__ */ M.jsx(rht, { direction: i, location: a ?? "right", style: o, children: e ? e.map((s, c) => /* @__PURE__ */ M.jsx(iht, { output: s, currentAnswer: t, answers: n, settings: r }, c)) : void 0 }), rht = Ce.div`
  display: flex;
  flex-direction: ${(e) => e.direction || "column"};
  flex-wrap: ${(e) => e.direction === "row" ? "wrap" : "nowrap"};
  gap: 0.5rem;
  flex: 1 1;
  flex-basis: ${(e) => e.location === "right" ? "32rem" : "auto"};
  /* width: ${(e) => e.location === "right" ? "unset" : "40rem"}; */
  /* max-width: 32rem; */
  /* flex: 1 1; */
  position: sticky;
  top: 1rem;
  /* margin: 1rem; */
`, iht = ({ output: e, currentAnswer: t, answers: n, settings: r }) => {
  const { databaseService: i } = St(ir), o = e.getAggregateAnswers ? i.observeAggregatedResults(r.surveyName) : Ple, a = Rz(o);
  switch (e.type) {
    case "card":
      return /* @__PURE__ */ M.jsx(Hnt, { output: e, currentAnswer: t, answers: n, settings: r, aggregateAnswers: a });
    case "line-chart":
      return /* @__PURE__ */ M.jsx(Xnt, { output: e, currentAnswer: t, answers: n, settings: r, aggregateAnswers: a });
    case "bar-chart":
      return /* @__PURE__ */ M.jsx(znt, { output: e, currentAnswer: t, answers: n, settings: r, aggregateAnswers: a });
    case "generic":
      return /* @__PURE__ */ M.jsx(Wnt, { output: e, currentAnswer: t, answers: n, settings: r, aggregateAnswers: a });
    case "swarm-chart":
      return /* @__PURE__ */ M.jsx(nht, { output: e, currentAnswer: t, answers: n, settings: r, aggregateAnswers: a });
    case "pie-chart":
      return /* @__PURE__ */ M.jsx(nrt, { output: e, currentAnswer: t, answers: n, settings: r, aggregateAnswers: a });
  }
}, VC = Ce.div`
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
  max-width: 40rem;
  gap: 1rem;
  align-items: stretch;
  /* margin: ${(e) => e.device === ui.MOBILE ? "1rem 30px" : "1rem"}; */
`, Wd = (e) => {
  const t = e.currentTarget, n = document.createElement("span"), r = Math.max(t.clientWidth, t.clientHeight), i = r / 2;
  n.style.width = n.style.height = `${r}px`, n.style.left = `${e.clientX - (t.offsetLeft + i)}px`, n.style.top = `${e.clientY - (t.offsetTop + i)}px`, n.classList.add("ripple");
  const o = t.getElementsByClassName("ripple")[0];
  o && o.remove(), t.appendChild(n);
}, oht = iO`
   0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
`, ck = Ce.button`
  position: relative;
  overflow: hidden;
  display: flex;
  align-items: center;
  border-radius: ${(e) => e.borderRadius};
  cursor: pointer;
  border: ${(e) => e.active ? `2px solid ${e.primaryColour}` : "1px solid var(--mid)"};
  color: var(--dark);
  min-height: var(--button-height);
  padding: var(--spacing-sm) var(--spacing-sm);
  justify-content: space-between;
  transition:
    background-color 150ms ease-in-out,
    color 150ms ease-in-out;
  background-color: ${(e) => e.active ? "var(--light)" : e.shadeColour ? e.shadeColour : "var(--light)"};

  @media (hover: hover) {
    &:hover {
      border-color: ${(e) => e.primaryColour};
      box-shadow: 0 0 5px 0px rgba(0, 0, 0, 0.3);
    }
  }

  span.ripple {
    position: absolute;
    border-radius: 50%;
    transform: scale(0);
    animation: ripple 500ms linear;
    background-color: ${(e) => e.primaryColour};
    opacity: 0.5;
  }

  @keyframes ripple {
    to {
      transform: scale(4);
      opacity: 0;
    }
  }
`, aht = (e) => {
  const t = ho();
  return /* @__PURE__ */ M.jsx(sht, { ...e, borderRadius: t, children: e.children });
}, sht = Ce(ck)`
  flex-direction: column;
  align-items: flex-start;
  flex: 1;
  cursor: ${(e) => e.disabled ? "wait" : "pointer"};
  animation: 0.5s ${oht} ease;
  background-color: ${(e) => e.active ? e.primaryColour : e.shadeColour ? e.shadeColour : "var(--light)"};
  color: ${(e) => e.active ? "var(--light)" : "var(--dark)"};
`, cht = ({ primaryColour: e, active: t, showInactive: n }) => /* @__PURE__ */ M.jsx(lht, { primaryColour: e, active: t, showInactive: n, children: /* @__PURE__ */ M.jsx(uht, { colour: e, active: t }) }), lht = Ce.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 26px;
  height: 26px;
  flex-shrink: 0;
  /* padding: 2px; */
  border-radius: 26px;
  border: ${(e) => e.active ? "1px solid var(--dark)" : e.showInactive ? "1px solid var(--mid)" : "none"};

  background-color: ${(e) => e.active || e.showInactive ? "var(--light)" : "transparent"};
`, uht = Ce.div`
  width: ${(e) => e.active ? "12px" : "0px"};
  height: ${(e) => e.active ? "12px" : "0px"};
  border-radius: ${(e) => e.active ? "12px" : "0px"};
  background-color: ${(e) => e.active ? e.colour : "transparent"};
  transition: all 150ms ease-in-out;
`, Dw = (e) => {
  const {
    onClick: t,
    buttonText: n,
    ButtonIcon: r,
    active: i,
    colour: o,
    shadeColour: a,
    fill: s,
    showInactiveCircle: c,
    onFocus: l,
    onMouseEnter: u,
    onMouseLeave: d,
    onPointerEnter: f,
    onPointerLeave: h
  } = e, p = ho();
  return /* @__PURE__ */ M.jsxs(
    Toe,
    {
      onClick: t,
      borderRadius: p,
      active: i,
      primaryColour: o,
      shadeColour: a,
      role: "button",
      "aria-pressed": i,
      onFocus: l,
      onMouseEnter: u,
      onMouseLeave: d,
      onPointerEnter: f,
      onPointerLeave: h,
      children: [
        /* @__PURE__ */ M.jsxs(ght, { children: [
          r ? /* @__PURE__ */ M.jsx(fht, { active: i, fill: s || o, children: /* @__PURE__ */ M.jsx(r, {}) }) : void 0,
          /* @__PURE__ */ M.jsx(hht, { children: n })
        ] }),
        /* @__PURE__ */ M.jsx(cht, { active: i, primaryColour: o, showInactive: c })
      ]
    }
  );
}, dht = (e) => iO`
  0% {
    box-shadow: 0 0 1px ${e}, 0 0 2px ${e}, 0 0 3px ${e}, 0 0 4px ${e};
  }
  30% {
    box-shadow: 0 0 2px ${e}, 0 0 4px ${e}, 0 0 5px ${e}, 0 0 5px ${e};
  }
  70% {
    box-shadow: 0 0 2px ${e}, 0 0 4px ${e}, 0 0 5px ${e}, 0 0 5px ${e};
  }
  100% {
    box-shadow: 0 0 1px ${e}, 0 0 2px ${e}, 0 0 3px ${e}, 0 0 4px ${e};
  }
`, Toe = Ce(ck)`
  @media (hover: hover) {
    &:hover {
      animation: none;
    }
  }
  animation: ${(e) => e.glow ? tce`
          ${dht(e.primaryColour)} 2s infinite
        ` : "none"};
`, fht = Ce.span`
  margin-right: 1rem;
  display: flex;
  align-content: center;
  justify-content: center;
  align-items: center;
  svg {
    fill: ${(e) => e.active ? e.primaryColour : e.fill};
    width: 2rem;
    height: auto;
  }
`, hht = Ce.span`
  font-weight: 400;
  font-size: var(--choice-text-font-size);
  text-align: left;
  text-overflow: ellipsis;
  word-wrap: break-word;
  word-break: break-word;
  margin-bottom: 0rem;
  /* line-height: 1.5; */
`, ght = Ce.div`
  display: flex;
  align-content: baseline;
  align-items: center;
  margin-right: 0.5rem;
  flex-grow: 1;

  background-color: transparent;
`;
function BC(e) {
  const { title: t, children: n, primaryColour: r, placement: i } = e;
  return /* @__PURE__ */ M.jsx(
    lo,
    {
      theme: r ? {
        token: {
          colorPrimary: r
        }
      } : void 0,
      children: /* @__PURE__ */ M.jsx(Pf, { title: t, placement: i, trigger: ["hover", "contextMenu"], children: n })
    }
  );
}
const M$ = "prevChoices", Ioe = ({
  question: e,
  currentAnswer: t,
  injectCurrent: n,
  submitAnswer: r,
  recordAnswer: i,
  answers: o,
  settings: a,
  updateSurveyControls: s,
  setNextButtonBehaviour: c,
  setPreviousButtonBehaviour: l
}) => {
  const { loggingService: u, messagerService: d, popupService: f } = St(ir), [h, p] = D.useState(null), [g, m] = D.useState(!1), [v, y] = D.useState(!1), { primaryColour: S, shadeColour: _ } = hr(), w = t.getValue(e.type), T = bht(w), [x, C] = D.useState(T.length), [E, R] = D.useState(null), A = wa();
  u.debug("ChoiceExperimentQuestion: prevChoices", T);
  const O = mn(async () => {
    y(!0), s({ nextDisabled: !0, prevDisabled: !0 });
    const K = await Use(
      e.choiceGenerator(T.slice(0, x)),
      500
    );
    return s({ nextDisabled: !1, prevDisabled: !1 }), y(!1), x === T.length ? p(null) : x < T.length && p(T[x].selectedOptionIndex), R(x), K;
  }, [T.length, x, s]), $ = Wse(O);
  u.debug("ChoiceExperimentQuestion: profiles", $), gt(() => (x > 0 ? l(() => {
    m(!1), C((K) => K - 1);
  }) : l(void 0), () => {
    l(void 0);
  }), [x, l]), gt(() => ($ !== null && (!e.maxChoices || x < e.maxChoices) ? c(() => {
    if (x === T.length) {
      d.error("Please select an option");
      return;
    }
    m(!0), C((K) => K + 1);
  }) : c(void 0), () => {
    c(void 0);
  }), [x, $, T.length, e.maxChoices, c]);
  function N(K, q, X) {
    if (Wn.isUndefined($))
      return;
    const ie = [
      ...T.slice(0, x),
      {
        options: $,
        selectedOption: q,
        selectedOptionIndex: X
      }
    ], te = {
      ...w,
      [M$]: ie.map((J) => ({
        id: J.options ? J.options.map((Y, ee) => Sht(Y, ee, e.attributes)).join(" OR ") : "",
        value: `Selected option ${J.selectedOptionIndex}`,
        info: J
      }))
    };
    u.debug("ChoiceExperimentQuestion: newAnswer", te), n({ value: te }), i(), p(X), Wd(K), m(!0), C((J) => J + 1);
  }
  gt(() => {
    u.debug("ChoiceExperimentQuestion: useEffect", $), Wn.isNull($) && g && r();
  }, [g, $, r, u]);
  const k = Ts({
    default: { content: "Click the option you prefer", position: { side: "bottom" } },
    goingBack: {
      content: "All choices have been made. Click Next to go to the next question, or Previous to change your answers",
      position: { side: "bottom" }
    },
    firstChoice: {
      content: "Click the option you prefer",
      position: { side: "right" }
    }
  }, e.helpPopups), F = e.showHelpPopups ?? !1, V = e.helpPopupsToShow;
  gt(() => {
    $ ? x === 0 ? f.setPopup(k, "firstChoice", F, V) : f.setPopup(k, "default", F, V) : g || x === 0 || f.setPopup(k, "goingBack", F, V);
  }, [k, F, V, $, g, x]);
  const [j, B] = Lt(!1);
  function U(K) {
    Wd(K), B(!0), r();
  }
  function Q(K) {
    N(K, null, -1);
  }
  return /* @__PURE__ */ M.jsxs(xht, { children: [
    /* @__PURE__ */ M.jsx(Cht, { device: A, "data-testid": "choice-experiment-container", children: $ ? $.map((K, q) => /* @__PURE__ */ M.jsx(
      pht,
      {
        profile: K,
        character: e.characterGenerator ? e.characterGenerator(K, T) : void 0,
        attributes: e.attributes,
        onClick: v ? () => {
        } : N,
        index: q,
        primaryColour: S,
        shadeColour: e.shade ? _ : void 0,
        active: h === q,
        disabled: v,
        profilePosition: q === 0 ? "first" : q === $.length - 1 ? "last" : "middle"
      },
      _ht(K, q, E ?? 0)
    )) : g || x === 0 ? /* @__PURE__ */ M.jsx(uv, {}) : /* @__PURE__ */ M.jsx("div", { children: "All choices have been made. Click Next to go to the next question, or Previous to change your answers." }) }),
    e.neitherOption && /* @__PURE__ */ M.jsx(
      Dw,
      {
        onClick: Q,
        buttonText: typeof e.neitherOption == "object" ? e.neitherOption.label ?? "No preference" : "No preference",
        active: h === -1,
        colour: S
      }
    ),
    e.allowSkip && /* @__PURE__ */ M.jsx(
      Dw,
      {
        onClick: U,
        buttonText: typeof e.allowSkip == "object" ? e.allowSkip.label ?? "Skip remaining choices" : "Skip remaining choices",
        active: j,
        colour: S
      }
    ),
    e.maxChoices && E !== null && E < e.maxChoices && /* @__PURE__ */ M.jsx(Eht, { children: /* @__PURE__ */ M.jsxs("i", { children: [
      "Choice ",
      E + 1,
      " of ",
      e.maxChoices
    ] }) })
  ] });
}, pht = (e) => /* @__PURE__ */ M.jsxs(
  aht,
  {
    ...e,
    primaryColour: e.primaryColour,
    shadeColour: e.shadeColour,
    onClick: (t) => e.onClick(t, e.profile, e.index),
    active: e.active,
    disabled: e.disabled,
    children: [
      e.character && /* @__PURE__ */ M.jsx(mht, { character: e.character }),
      /* @__PURE__ */ M.jsx(Tht, { "data-testid": "attributes-wrapper", children: /* @__PURE__ */ M.jsx(
        vht,
        {
          profile: e.profile,
          attributes: e.attributes,
          active: e.active,
          profilePosition: e.profilePosition
        }
      ) })
    ]
  }
), mht = (e) => {
  var t, n, r, i;
  return /* @__PURE__ */ M.jsxs(Iht, { children: [
    /* @__PURE__ */ M.jsx(
      "img",
      {
        src: (t = e.character) == null ? void 0 : t.image,
        alt: ((n = e.character) == null ? void 0 : n.description) || ((r = e.character) == null ? void 0 : r.name)
      }
    ),
    /* @__PURE__ */ M.jsx("div", { children: (i = e.character) == null ? void 0 : i.name })
  ] });
}, vht = (e) => /* @__PURE__ */ M.jsx(Aht, { "data-testid": "attributes-card", children: e.profile.attributes.map((t) => /* @__PURE__ */ M.jsx(
  yht,
  {
    attributeLevel: t,
    attributes: e.attributes,
    active: e.active,
    profilePosition: e.profilePosition
  },
  t.attributeId
)) }), yht = (e) => {
  const t = e.attributes.find((s) => s.id === e.attributeLevel.attributeId), n = t == null ? void 0 : t.levels.find((s) => s.rank === e.attributeLevel.levelId);
  if (n != null && n.hideLevel)
    return null;
  const r = n != null && n.hideName ? void 0 : (t == null ? void 0 : t.name) || e.attributeLevel.attributeId, i = t != null && t.hideName ? void 0 : (n == null ? void 0 : n.description) || (n == null ? void 0 : n.value) || e.attributeLevel.levelId, o = t == null ? void 0 : t.icon, a = e.profilePosition === "first" ? "left" : e.profilePosition === "last" ? "right" : "top";
  return console.log("tooltipPlacement", a, e.profilePosition, n == null ? void 0 : n.value), /* @__PURE__ */ M.jsx(BC, { title: wht(t, n), placement: a, children: /* @__PURE__ */ M.jsxs(Rht, { children: [
    /* @__PURE__ */ M.jsx($ht, { children: o !== void 0 ? /* @__PURE__ */ M.jsx(o, { height: 64, width: 64, fill: e.active ? "white" : "black" }) : (t == null ? void 0 : t.image) !== void 0 && /* @__PURE__ */ M.jsx("img", { src: t == null ? void 0 : t.image, alt: t.name, height: 64, width: 64 }) }),
    (n == null ? void 0 : n.image) !== void 0 && /* @__PURE__ */ M.jsx(Oht, { children: typeof (n == null ? void 0 : n.image) == "string" ? /* @__PURE__ */ M.jsx("img", { src: n == null ? void 0 : n.image, alt: n == null ? void 0 : n.value.toString() }) : n == null ? void 0 : n.image }),
    /* @__PURE__ */ M.jsxs(Pht, { children: [
      /* @__PURE__ */ M.jsx(Mht, { active: e.active, children: r }),
      /* @__PURE__ */ M.jsx(kht, { active: e.active, tooltip: !!(n != null && n.tooltip), children: i })
    ] })
  ] }) });
};
function bht(e) {
  return e && M$ in e ? e[M$].map((t) => t.info) : [];
}
function _ht(e, t, n) {
  return `${e.attributes.map((r) => `${r.attributeId}:${r.levelId}`).join("-")}#${t}#${n}`;
}
function Sht(e, t, n) {
  const r = e.attributes.map((i) => {
    var o, a, s;
    return [
      ((o = n.find((c) => c.id === i.attributeId)) == null ? void 0 : o.name) || i.attributeId,
      ((s = (a = n.find((c) => c.id === i.attributeId)) == null ? void 0 : a.levels.find((c) => c.id === i.levelId)) == null ? void 0 : s.value) || i.levelId
    ];
  });
  return `Option ${t}: ${r.map((i) => i.join(":")).join(" AND ")}`;
}
function wht(e, t) {
  const n = [];
  return e && e.tooltip && n.push(e.tooltip), t && t.tooltip && n.push(t.tooltip), n.join(`
`);
}
const xht = Ce.div`
  display: flex;
  flex-direction: column;
  gap: var(--spacing-sm);
`, Eht = Ce.div``, Cht = Ce.div`
  display: flex;
  flex-direction: ${(e) => e.device === ui.MOBILE ? "column" : "row"};
  justify-content: space-between;
  align-items: stretch;
  gap: 1rem;
`, Tht = Ce.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`, Iht = Ce.div`
  display: flex;
  flex-direction: column;
`, Aht = Ce.div`
  display: flex;
  flex-direction: column;
  gap: var(--spacing-sm);
`, Rht = Ce.div`
  display: flex;
  flex-direction: row;
  gap: var(--spacing-sm);
`, $ht = Ce.div`
  display: flex;
  flex: 0 1;
`, Oht = Ce.div`
  display: flex;
  flex: 0 1;
`, Pht = Ce.div`
  display: flex;
  flex-direction: column;
  flex: 4 1 auto;
  gap: var(--spacing-xs);
  align-self: center;
  text-align: left;
`, Mht = Ce.div`
  display: flex;
  color: ${(e) => e.active ? "var(--light)" : "var(--dark)"};
  font-size: var(--choice-text-font-size);
`, kht = Ce.div`
  display: flex;
  color: ${(e) => e.active ? "var(--light);" : "var(--dark);"};
  font-weight: ${(e) => e.active ? "bold" : "normal"};
  font-size: var(--question-text-font-size);
  ${(e) => e.tooltip && "text-decoration: underline; text-decoration-color: var(--mid); text-decoration-style: dashed;"}
  &:hover {
    ${(e) => e.tooltip && "text-decoration-color: var(--dark);"}
  }
`, Nht = Ce(VC)`
  max-width: 40rem;
`, Dht = ({
  question: e,
  updateCurrent: t,
  currentAnswer: n,
  submitAnswer: r,
  settings: i
}) => {
  const { primaryColour: o } = hr(), { popupService: a } = St(ir), s = wa(), c = e.attributes[0].levels, l = e.attributes[1].levels, u = c.length * l.length, d = Math.random() > 0.5 ? e.characters.filter((j) => j.gender === "female") : e.characters.filter((j) => j.gender === "male"), f = [
    {
      id: 1,
      attr_1_index: 1,
      attr_1: c[1].value,
      attr_1_text: c[1].text,
      attr_2: l[0].value,
      attr_2_text: l[0].text
    },
    {
      id: 2,
      attr_1_index: 0,
      attr_1: c[0].value,
      attr_1_text: c[0].text,
      attr_2: l[1].value,
      attr_2_text: l[1].text
    }
  ], h = {
    id: 0,
    attr_1_index: 0,
    attr_1: c[0].value,
    attr_1_text: c[0].text,
    attr_2: l[0].value,
    attr_2_text: l[0].text
  }, p = {
    id: u - 1,
    attr_1_index: c.length - 1,
    attr_1: c[c.length - 1].value,
    attr_1_text: c[c.length - 1].text,
    attr_2: l[1].value,
    attr_2_text: l[1].text
  }, [g, m] = Lt(f[0]), [v, y] = Lt(f[1]), [S, _] = Lt(3), [w, T] = Lt([h]), [x, C] = Lt(!1), E = (j, B, U, Q = w) => {
    const K = Q.concat(j);
    if (T(K), j.attr_1_index === c.length - 1) {
      C(!0), j.attr_2 ? R(K.concat([p])) : R(Lht(K, B, c));
      return;
    }
    _(U + 1);
    const q = {
      id: U,
      attr_1_index: j.attr_1_index + 1,
      attr_1: c[j.attr_1_index + 1].value,
      attr_1_text: c[j.attr_1_index + 1].text,
      attr_2: j.attr_2,
      attr_2_text: j.attr_2 ? l[1].text : l[0].text
    };
    q.attr_2 ? (y(q), q.attr_1 === B.attr_1 && E(B, q, U + 1, K)) : m(q);
  }, R = (j) => {
    const B = j.map((U) => jht(U));
    t({
      ...n.getAnswer(),
      value: B
    }), r();
  }, A = (j) => {
    const B = j.attr_2 ? g : v, U = j.attr_2 ? v : g;
    E(B, U, S);
  }, O = (j) => x ? /* @__PURE__ */ M.jsxs(uB, { disabled: !0, primaryColor: o, device: s, children: [
    /* @__PURE__ */ M.jsx(cB, { src: d[0].portrait, device: s }),
    /* @__PURE__ */ M.jsxs(lB, { children: [
      /* @__PURE__ */ M.jsx(ph, { children: "loading" }),
      /* @__PURE__ */ M.jsx(ph, { children: j.attr_1_text }),
      /* @__PURE__ */ M.jsx(ph, { children: j.attr_2_text })
    ] })
  ] }, j.id) : /* @__PURE__ */ M.jsxs(
    uB,
    {
      onClick: () => A(j),
      primaryColor: o,
      device: s,
      children: [
        /* @__PURE__ */ M.jsx(
          cB,
          {
            src: d[j.id % d.length] ? d[j.id % d.length].portrait : d[0].portrait,
            device: s
          }
        ),
        /* @__PURE__ */ M.jsxs(lB, { children: [
          /* @__PURE__ */ M.jsx(ph, { children: d[j.id % d.length] ? d[j.id % d.length].name : "loading" }),
          /* @__PURE__ */ M.jsx(ph, { children: j.attr_1_text }),
          /* @__PURE__ */ M.jsx(ph, { children: j.attr_2_text })
        ] })
      ]
    },
    j.id
  );
  console.log("storeAns", w);
  let $, N;
  d[g.id % d.length] && ($ = d[g.id % d.length].name), d[v.id % d.length] && (N = d[v.id % d.length].name);
  const z = {
    default: { content: `Click to choose between ${$} and ${N}` }
  }, k = Ts(z, e.helpPopups), F = e.showHelpPopups ?? !1, V = e.helpPopupsToShow;
  return gt(() => {
    if ($ === void 0 || N === void 0) {
      a.clearPopup();
      return;
    }
    a.setPopup(k, "default", F, V);
  }, [k, F, V, $, N]), /* @__PURE__ */ M.jsxs(Vht, { device: s, children: [
    O(g),
    O(v)
  ] });
};
function Lht(e, t, n) {
  const r = n.slice(t.attr_1_index).map((i, o) => ({
    id: e.length + 1 + o,
    attr_1_index: t.attr_1_index + o,
    attr_1: i.value,
    attr_1_text: i.text,
    attr_2: t.attr_2,
    attr_2_text: t.attr_2_text
  }));
  return console.log("remainingPeople", r), e.concat(r);
}
function jht(e) {
  return {
    id: e.id,
    value: `${e.attr_1} - ${e.attr_2}`,
    info: {
      attr_1_index: e.attr_1_index,
      attr_1: e.attr_1,
      attr_2: e.attr_2
    }
  };
}
const cB = Ce.img`
  max-height: ${(e) => e.device === ui.MOBILE ? "10rem" : "15rem"};
  display: flex;
  align-self: center;
`, lB = Ce.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: baseline;
  text-align: left;
  gap: 0.5rem;
`, ph = Ce.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`, Fht = iO`
   0% {
    opacity: 0;
    // transform: translateY(20px);
  }
  100% {
    opacity: 1;
    // transform: translateY(0);
  }
`, uB = Ce.button`
  display: flex;
  flex-direction: ${(e) => e.device === ui.MOBILE ? "row" : "column"};
  animation: 0.5s ${Fht} ease;
  padding: 1rem 1rem;
  cursor: pointer;
  text-align: center;
  text-decoration: none;
  outline: none;
  color: #000;
  background-color: #fff;
  border: 1px solid rgba(0, 0, 0, 0.3);
  border-radius: 0.2rem;
  @media (hover: hover) {
    &:hover {
      background-color: ${(e) => e.primaryColor};
      color: #fff;
    }
  }
  &:active {
    background-color: ${(e) => e.primaryColor};
    box-shadow: 0 5px #666;
    border: 3px solid rgba(0, 0, 0, 0.3);
    // transform: translateY(4px);
  }
`, Vht = Ce.div`
  display: flex;
  flex-direction: ${(e) => e.device === ui.MOBILE ? "column" : "row"};
  justify-content: ${(e) => e.device === ui.MOBILE ? "flex-start" : "space-between"};
  align-items: ${(e) => e.device === ui.MOBILE ? "baseline" : "stretch"};
  gap: 1rem;
`;
var lk = {}, Aoe = { exports: {} };
(function(e) {
  function t(n) {
    return n && n.__esModule ? n : {
      default: n
    };
  }
  e.exports = t, e.exports.__esModule = !0, e.exports.default = e.exports;
})(Aoe);
var un = Aoe.exports, Roe = { exports: {} }, $oe = { exports: {} };
(function(e) {
  function t(n) {
    "@babel/helpers - typeof";
    return e.exports = t = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(r) {
      return typeof r;
    } : function(r) {
      return r && typeof Symbol == "function" && r.constructor === Symbol && r !== Symbol.prototype ? "symbol" : typeof r;
    }, e.exports.__esModule = !0, e.exports.default = e.exports, t(n);
  }
  e.exports = t, e.exports.__esModule = !0, e.exports.default = e.exports;
})($oe);
var Uf = $oe.exports;
(function(e) {
  var t = Uf.default;
  function n(i) {
    if (typeof WeakMap != "function")
      return null;
    var o = /* @__PURE__ */ new WeakMap(), a = /* @__PURE__ */ new WeakMap();
    return (n = function(c) {
      return c ? a : o;
    })(i);
  }
  function r(i, o) {
    if (!o && i && i.__esModule)
      return i;
    if (i === null || t(i) != "object" && typeof i != "function")
      return {
        default: i
      };
    var a = n(o);
    if (a && a.has(i))
      return a.get(i);
    var s = {
      __proto__: null
    }, c = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for (var l in i)
      if (l !== "default" && {}.hasOwnProperty.call(i, l)) {
        var u = c ? Object.getOwnPropertyDescriptor(i, l) : null;
        u && (u.get || u.set) ? Object.defineProperty(s, l, u) : s[l] = i[l];
      }
    return s.default = i, a && a.set(i, s), s;
  }
  e.exports = r, e.exports.__esModule = !0, e.exports.default = e.exports;
})(Roe);
var gi = Roe.exports;
const Bht = /* @__PURE__ */ bc(tNe);
var By = {}, k$ = { exports: {} }, zC = {}, Ooe = { exports: {} };
(function(e) {
  function t() {
    return e.exports = t = Object.assign ? Object.assign.bind() : function(n) {
      for (var r = 1; r < arguments.length; r++) {
        var i = arguments[r];
        for (var o in i)
          ({}).hasOwnProperty.call(i, o) && (n[o] = i[o]);
      }
      return n;
    }, e.exports.__esModule = !0, e.exports.default = e.exports, t.apply(null, arguments);
  }
  e.exports = t, e.exports.__esModule = !0, e.exports.default = e.exports;
})(Ooe);
var Poe = Ooe.exports, uk = {};
Object.defineProperty(uk, "__esModule", { value: !0 });
var zht = { icon: { tag: "svg", attrs: { "fill-rule": "evenodd", viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M512 64c247.4 0 448 200.6 448 448S759.4 960 512 960 64 759.4 64 512 264.6 64 512 64zm127.98 274.82h-.04l-.08.06L512 466.75 384.14 338.88c-.04-.05-.06-.06-.08-.06a.12.12 0 00-.07 0c-.03 0-.05.01-.09.05l-45.02 45.02a.2.2 0 00-.05.09.12.12 0 000 .07v.02a.27.27 0 00.06.06L466.75 512 338.88 639.86c-.05.04-.06.06-.06.08a.12.12 0 000 .07c0 .03.01.05.05.09l45.02 45.02a.2.2 0 00.09.05.12.12 0 00.07 0c.02 0 .04-.01.08-.05L512 557.25l127.86 127.87c.04.04.06.05.08.05a.12.12 0 00.07 0c.03 0 .05-.01.09-.05l45.02-45.02a.2.2 0 00.05-.09.12.12 0 000-.07v-.02a.27.27 0 00-.05-.06L557.25 512l127.87-127.86c.04-.04.05-.06.05-.08a.12.12 0 000-.07c0-.03-.01-.05-.05-.09l-45.02-45.02a.2.2 0 00-.09-.05.12.12 0 00-.07 0z" } }] }, name: "close-circle", theme: "filled" };
uk.default = zht;
var HC = {}, Moe = { exports: {} }, koe = { exports: {} };
(function(e) {
  function t(n) {
    if (Array.isArray(n))
      return n;
  }
  e.exports = t, e.exports.__esModule = !0, e.exports.default = e.exports;
})(koe);
var Noe = koe.exports, Doe = { exports: {} };
(function(e) {
  function t(n, r) {
    var i = n == null ? null : typeof Symbol < "u" && n[Symbol.iterator] || n["@@iterator"];
    if (i != null) {
      var o, a, s, c, l = [], u = !0, d = !1;
      try {
        if (s = (i = i.call(n)).next, r === 0) {
          if (Object(i) !== i)
            return;
          u = !1;
        } else
          for (; !(u = (o = s.call(i)).done) && (l.push(o.value), l.length !== r); u = !0)
            ;
      } catch (f) {
        d = !0, a = f;
      } finally {
        try {
          if (!u && i.return != null && (c = i.return(), Object(c) !== c))
            return;
        } finally {
          if (d)
            throw a;
        }
      }
      return l;
    }
  }
  e.exports = t, e.exports.__esModule = !0, e.exports.default = e.exports;
})(Doe);
var Hht = Doe.exports, Loe = { exports: {} }, joe = { exports: {} };
(function(e) {
  function t(n, r) {
    (r == null || r > n.length) && (r = n.length);
    for (var i = 0, o = Array(r); i < r; i++)
      o[i] = n[i];
    return o;
  }
  e.exports = t, e.exports.__esModule = !0, e.exports.default = e.exports;
})(joe);
var Foe = joe.exports;
(function(e) {
  var t = Foe;
  function n(r, i) {
    if (r) {
      if (typeof r == "string")
        return t(r, i);
      var o = {}.toString.call(r).slice(8, -1);
      return o === "Object" && r.constructor && (o = r.constructor.name), o === "Map" || o === "Set" ? Array.from(r) : o === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(o) ? t(r, i) : void 0;
    }
  }
  e.exports = n, e.exports.__esModule = !0, e.exports.default = e.exports;
})(Loe);
var dk = Loe.exports, Voe = { exports: {} };
(function(e) {
  function t() {
    throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  e.exports = t, e.exports.__esModule = !0, e.exports.default = e.exports;
})(Voe);
var Boe = Voe.exports;
(function(e) {
  var t = Noe, n = Hht, r = dk, i = Boe;
  function o(a, s) {
    return t(a) || n(a, s) || r(a, s) || i();
  }
  e.exports = o, e.exports.__esModule = !0, e.exports.default = e.exports;
})(Moe);
var zoe = Moe.exports, Hoe = { exports: {} }, Uoe = { exports: {} }, Woe = { exports: {} };
(function(e) {
  var t = Uf.default;
  function n(r, i) {
    if (t(r) != "object" || !r)
      return r;
    var o = r[Symbol.toPrimitive];
    if (o !== void 0) {
      var a = o.call(r, i || "default");
      if (t(a) != "object")
        return a;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (i === "string" ? String : Number)(r);
  }
  e.exports = n, e.exports.__esModule = !0, e.exports.default = e.exports;
})(Woe);
var Uht = Woe.exports;
(function(e) {
  var t = Uf.default, n = Uht;
  function r(i) {
    var o = n(i, "string");
    return t(o) == "symbol" ? o : o + "";
  }
  e.exports = r, e.exports.__esModule = !0, e.exports.default = e.exports;
})(Uoe);
var Wht = Uoe.exports;
(function(e) {
  var t = Wht;
  function n(r, i, o) {
    return (i = t(i)) in r ? Object.defineProperty(r, i, {
      value: o,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : r[i] = o, r;
  }
  e.exports = n, e.exports.__esModule = !0, e.exports.default = e.exports;
})(Hoe);
var qoe = Hoe.exports, Goe = { exports: {} }, Koe = { exports: {} };
(function(e) {
  function t(n, r) {
    if (n == null)
      return {};
    var i = {};
    for (var o in n)
      if ({}.hasOwnProperty.call(n, o)) {
        if (r.includes(o))
          continue;
        i[o] = n[o];
      }
    return i;
  }
  e.exports = t, e.exports.__esModule = !0, e.exports.default = e.exports;
})(Koe);
var qht = Koe.exports;
(function(e) {
  var t = qht;
  function n(r, i) {
    if (r == null)
      return {};
    var o, a, s = t(r, i);
    if (Object.getOwnPropertySymbols) {
      var c = Object.getOwnPropertySymbols(r);
      for (a = 0; a < c.length; a++)
        o = c[a], i.includes(o) || {}.propertyIsEnumerable.call(r, o) && (s[o] = r[o]);
    }
    return s;
  }
  e.exports = n, e.exports.__esModule = !0, e.exports.default = e.exports;
})(Goe);
var Yoe = Goe.exports;
const zy = /* @__PURE__ */ bc($Te);
var qp = {};
Object.defineProperty(qp, "__esModule", {
  value: !0
});
qp.default = void 0;
var Ght = D, Kht = /* @__PURE__ */ (0, Ght.createContext)({});
qp.default = Kht;
var Hy = {}, Xoe = { exports: {} };
(function(e) {
  var t = qoe;
  function n(i, o) {
    var a = Object.keys(i);
    if (Object.getOwnPropertySymbols) {
      var s = Object.getOwnPropertySymbols(i);
      o && (s = s.filter(function(c) {
        return Object.getOwnPropertyDescriptor(i, c).enumerable;
      })), a.push.apply(a, s);
    }
    return a;
  }
  function r(i) {
    for (var o = 1; o < arguments.length; o++) {
      var a = arguments[o] != null ? arguments[o] : {};
      o % 2 ? n(Object(a), !0).forEach(function(s) {
        t(i, s, a[s]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(i, Object.getOwnPropertyDescriptors(a)) : n(Object(a)).forEach(function(s) {
        Object.defineProperty(i, s, Object.getOwnPropertyDescriptor(a, s));
      });
    }
    return i;
  }
  e.exports = r, e.exports.__esModule = !0, e.exports.default = e.exports;
})(Xoe);
var Uy = Xoe.exports, uo = {}, Wf = {}, UC = {};
Object.defineProperty(UC, "__esModule", {
  value: !0
});
UC.default = Yht;
function Yht() {
  return !!(typeof window < "u" && window.document && window.document.createElement);
}
var fk = {};
Object.defineProperty(fk, "__esModule", {
  value: !0
});
fk.default = Xht;
function Xht(e, t) {
  if (!e)
    return !1;
  if (e.contains)
    return e.contains(t);
  for (var n = t; n; ) {
    if (n === e)
      return !0;
    n = n.parentNode;
  }
  return !1;
}
var hk = un.default;
Object.defineProperty(Wf, "__esModule", {
  value: !0
});
Wf.clearContainerCache = rgt;
Wf.injectCSS = pk;
Wf.removeCSS = tgt;
Wf.updateCSS = igt;
var dB = hk(Uy), Qht = hk(UC), Jht = hk(fk), fB = "data-rc-order", hB = "data-rc-priority", Zht = "rc-util-key", Lw = /* @__PURE__ */ new Map();
function Qoe() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, t = e.mark;
  return t ? t.startsWith("data-") ? t : "data-".concat(t) : Zht;
}
function WC(e) {
  if (e.attachTo)
    return e.attachTo;
  var t = document.querySelector("head");
  return t || document.body;
}
function egt(e) {
  return e === "queue" ? "prependQueue" : e ? "prepend" : "append";
}
function gk(e) {
  return Array.from((Lw.get(e) || e).children).filter(function(t) {
    return t.tagName === "STYLE";
  });
}
function pk(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  if (!(0, Qht.default)())
    return null;
  var n = t.csp, r = t.prepend, i = t.priority, o = i === void 0 ? 0 : i, a = egt(r), s = a === "prependQueue", c = document.createElement("style");
  c.setAttribute(fB, a), s && o && c.setAttribute(hB, "".concat(o)), n != null && n.nonce && (c.nonce = n == null ? void 0 : n.nonce), c.innerHTML = e;
  var l = WC(t), u = l.firstChild;
  if (r) {
    if (s) {
      var d = (t.styles || gk(l)).filter(function(f) {
        if (!["prepend", "prependQueue"].includes(f.getAttribute(fB)))
          return !1;
        var h = Number(f.getAttribute(hB) || 0);
        return o >= h;
      });
      if (d.length)
        return l.insertBefore(c, d[d.length - 1].nextSibling), c;
    }
    l.insertBefore(c, u);
  } else
    l.appendChild(c);
  return c;
}
function Joe(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, n = WC(t);
  return (t.styles || gk(n)).find(function(r) {
    return r.getAttribute(Qoe(t)) === e;
  });
}
function tgt(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, n = Joe(e, t);
  if (n) {
    var r = WC(t);
    r.removeChild(n);
  }
}
function ngt(e, t) {
  var n = Lw.get(e);
  if (!n || !(0, Jht.default)(document, n)) {
    var r = pk("", t), i = r.parentNode;
    Lw.set(e, i), e.removeChild(r);
  }
}
function rgt() {
  Lw.clear();
}
function igt(e, t) {
  var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, r = WC(n), i = gk(r), o = (0, dB.default)((0, dB.default)({}, n), {}, {
    styles: i
  });
  ngt(r, o);
  var a = Joe(t, o);
  if (a) {
    var s, c;
    if ((s = o.csp) !== null && s !== void 0 && s.nonce && a.nonce !== ((c = o.csp) === null || c === void 0 ? void 0 : c.nonce)) {
      var l;
      a.nonce = (l = o.csp) === null || l === void 0 ? void 0 : l.nonce;
    }
    return a.innerHTML !== e && (a.innerHTML = e), a;
  }
  var u = pk(e, o);
  return u.setAttribute(Qoe(o), t), u;
}
var qC = {};
Object.defineProperty(qC, "__esModule", {
  value: !0
});
qC.getShadowRoot = ogt;
qC.inShadow = eae;
function Zoe(e) {
  var t;
  return e == null || (t = e.getRootNode) === null || t === void 0 ? void 0 : t.call(e);
}
function eae(e) {
  return Zoe(e) instanceof ShadowRoot;
}
function ogt(e) {
  return eae(e) ? Zoe(e) : null;
}
var na = {};
Object.defineProperty(na, "__esModule", {
  value: !0
});
na.call = vk;
na.default = void 0;
na.note = nae;
na.noteOnce = iae;
na.preMessage = void 0;
na.resetWarned = rae;
na.warning = tae;
na.warningOnce = Wy;
var N$ = {}, mk = [], agt = na.preMessage = function(t) {
  mk.push(t);
};
function tae(e, t) {
  if (process.env.NODE_ENV !== "production" && !e && console !== void 0) {
    var n = mk.reduce(function(r, i) {
      return i(r ?? "", "warning");
    }, t);
    n && console.error("Warning: ".concat(n));
  }
}
function nae(e, t) {
  if (process.env.NODE_ENV !== "production" && !e && console !== void 0) {
    var n = mk.reduce(function(r, i) {
      return i(r ?? "", "note");
    }, t);
    n && console.warn("Note: ".concat(n));
  }
}
function rae() {
  N$ = {};
}
function vk(e, t, n) {
  !t && !N$[n] && (e(!1, n), N$[n] = !0);
}
function Wy(e, t) {
  vk(tae, e, t);
}
function iae(e, t) {
  vk(nae, e, t);
}
Wy.preMessage = agt;
Wy.resetWarned = rae;
Wy.noteOnce = iae;
na.default = Wy;
var sgt = gi.default, GC = un.default;
Object.defineProperty(uo, "__esModule", {
  value: !0
});
uo.generate = L$;
uo.getSecondaryColor = mgt;
uo.iconStyles = void 0;
uo.isIconDefinition = pgt;
uo.normalizeAttrs = D$;
uo.normalizeTwoToneColors = vgt;
uo.useInsertStyles = uo.svgBaseProps = void 0;
uo.warning = ggt;
var UT = GC(Uy), gB = GC(Uf), cgt = zy, lgt = Wf, ugt = qC, dgt = GC(na), jw = sgt(D), fgt = GC(qp);
function hgt(e) {
  return e.replace(/-(.)/g, function(t, n) {
    return n.toUpperCase();
  });
}
function ggt(e, t) {
  (0, dgt.default)(e, "[@ant-design/icons] ".concat(t));
}
function pgt(e) {
  return (0, gB.default)(e) === "object" && typeof e.name == "string" && typeof e.theme == "string" && ((0, gB.default)(e.icon) === "object" || typeof e.icon == "function");
}
function D$() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
  return Object.keys(e).reduce(function(t, n) {
    var r = e[n];
    switch (n) {
      case "class":
        t.className = r, delete t.class;
        break;
      default:
        delete t[n], t[hgt(n)] = r;
    }
    return t;
  }, {});
}
function L$(e, t, n) {
  return n ? /* @__PURE__ */ jw.default.createElement(e.tag, (0, UT.default)((0, UT.default)({
    key: t
  }, D$(e.attrs)), n), (e.children || []).map(function(r, i) {
    return L$(r, "".concat(t, "-").concat(e.tag, "-").concat(i));
  })) : /* @__PURE__ */ jw.default.createElement(e.tag, (0, UT.default)({
    key: t
  }, D$(e.attrs)), (e.children || []).map(function(r, i) {
    return L$(r, "".concat(t, "-").concat(e.tag, "-").concat(i));
  }));
}
function mgt(e) {
  return (0, cgt.generate)(e)[0];
}
function vgt(e) {
  return e ? Array.isArray(e) ? e : [e] : [];
}
uo.svgBaseProps = {
  width: "1em",
  height: "1em",
  fill: "currentColor",
  "aria-hidden": "true",
  focusable: "false"
};
var ygt = uo.iconStyles = `
.anticon {
  display: inline-flex;
  align-items: center;
  color: inherit;
  font-style: normal;
  line-height: 0;
  text-align: center;
  text-transform: none;
  vertical-align: -0.125em;
  text-rendering: optimizeLegibility;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.anticon > * {
  line-height: 1;
}

.anticon svg {
  display: inline-block;
}

.anticon::before {
  display: none;
}

.anticon .anticon-icon {
  display: block;
}

.anticon[tabindex] {
  cursor: pointer;
}

.anticon-spin::before,
.anticon-spin {
  display: inline-block;
  -webkit-animation: loadingCircle 1s infinite linear;
  animation: loadingCircle 1s infinite linear;
}

@-webkit-keyframes loadingCircle {
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}

@keyframes loadingCircle {
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
`;
uo.useInsertStyles = function(t) {
  var n = (0, jw.useContext)(fgt.default), r = n.csp, i = n.prefixCls, o = ygt;
  i && (o = o.replace(/anticon/g, i)), (0, jw.useEffect)(function() {
    var a = t.current, s = (0, ugt.getShadowRoot)(a);
    (0, lgt.updateCSS)(o, "@ant-design-icons", {
      prepend: !0,
      csp: r,
      attachTo: s
    });
  }, []);
};
var oae = un.default, bgt = gi.default;
Object.defineProperty(Hy, "__esModule", {
  value: !0
});
Hy.default = void 0;
var _gt = oae(Yoe), Zm = oae(Uy), Sgt = bgt(D), gd = uo, wgt = ["icon", "className", "onClick", "style", "primaryColor", "secondaryColor"], A0 = {
  primaryColor: "#333",
  secondaryColor: "#E6E6E6",
  calculated: !1
};
function xgt(e) {
  var t = e.primaryColor, n = e.secondaryColor;
  A0.primaryColor = t, A0.secondaryColor = n || (0, gd.getSecondaryColor)(t), A0.calculated = !!n;
}
function Egt() {
  return (0, Zm.default)({}, A0);
}
var KC = function(t) {
  var n = t.icon, r = t.className, i = t.onClick, o = t.style, a = t.primaryColor, s = t.secondaryColor, c = (0, _gt.default)(t, wgt), l = Sgt.useRef(), u = A0;
  if (a && (u = {
    primaryColor: a,
    secondaryColor: s || (0, gd.getSecondaryColor)(a)
  }), (0, gd.useInsertStyles)(l), (0, gd.warning)((0, gd.isIconDefinition)(n), "icon should be icon definiton, but got ".concat(n)), !(0, gd.isIconDefinition)(n))
    return null;
  var d = n;
  return d && typeof d.icon == "function" && (d = (0, Zm.default)((0, Zm.default)({}, d), {}, {
    icon: d.icon(u.primaryColor, u.secondaryColor)
  })), (0, gd.generate)(d.icon, "svg-".concat(d.name), (0, Zm.default)((0, Zm.default)({
    className: r,
    onClick: i,
    style: o,
    "data-icon": d.name,
    width: "1em",
    height: "1em",
    fill: "currentColor",
    "aria-hidden": "true"
  }, c), {}, {
    ref: l
  }));
};
KC.displayName = "IconReact";
KC.getTwoToneColors = Egt;
KC.setTwoToneColors = xgt;
Hy.default = KC;
var YC = {}, aae = un.default;
Object.defineProperty(YC, "__esModule", {
  value: !0
});
YC.getTwoToneColor = Agt;
YC.setTwoToneColor = Igt;
var Cgt = aae(zoe), sae = aae(Hy), Tgt = uo;
function Igt(e) {
  var t = (0, Tgt.normalizeTwoToneColors)(e), n = (0, Cgt.default)(t, 2), r = n[0], i = n[1];
  return sae.default.setTwoToneColors({
    primaryColor: r,
    secondaryColor: i
  });
}
function Agt() {
  var e = sae.default.getTwoToneColors();
  return e.calculated ? [e.primaryColor, e.secondaryColor] : e.primaryColor;
}
var qf = un.default, Rgt = gi.default;
Object.defineProperty(HC, "__esModule", {
  value: !0
});
HC.default = void 0;
var $gt = qf(Poe), Ogt = qf(zoe), pB = qf(qoe), Pgt = qf(Yoe), p1 = Rgt(D), Mgt = qf(Sp), kgt = zy, Ngt = qf(qp), Dgt = qf(Hy), yk = YC, Lgt = uo, jgt = ["className", "icon", "spin", "rotate", "tabIndex", "onClick", "twoToneColor"];
(0, yk.setTwoToneColor)(kgt.blue.primary);
var XC = /* @__PURE__ */ p1.forwardRef(function(e, t) {
  var n = e.className, r = e.icon, i = e.spin, o = e.rotate, a = e.tabIndex, s = e.onClick, c = e.twoToneColor, l = (0, Pgt.default)(e, jgt), u = p1.useContext(Ngt.default), d = u.prefixCls, f = d === void 0 ? "anticon" : d, h = u.rootClassName, p = (0, Mgt.default)(h, f, (0, pB.default)((0, pB.default)({}, "".concat(f, "-").concat(r.name), !!r.name), "".concat(f, "-spin"), !!i || r.name === "loading"), n), g = a;
  g === void 0 && s && (g = -1);
  var m = o ? {
    msTransform: "rotate(".concat(o, "deg)"),
    transform: "rotate(".concat(o, "deg)")
  } : void 0, v = (0, Lgt.normalizeTwoToneColors)(c), y = (0, Ogt.default)(v, 2), S = y[0], _ = y[1];
  return /* @__PURE__ */ p1.createElement("span", (0, $gt.default)({
    role: "img",
    "aria-label": r.name
  }, l, {
    ref: t,
    tabIndex: g,
    onClick: s,
    className: p
  }), /* @__PURE__ */ p1.createElement(Dgt.default, {
    icon: r,
    primaryColor: S,
    secondaryColor: _,
    style: m
  }));
});
XC.displayName = "AntdIcon";
XC.getTwoToneColor = yk.getTwoToneColor;
XC.setTwoToneColor = yk.setTwoToneColor;
HC.default = XC;
var Fgt = gi.default, bk = un.default;
Object.defineProperty(zC, "__esModule", {
  value: !0
});
zC.default = void 0;
var Vgt = bk(Poe), cae = Fgt(D), Bgt = bk(uk), zgt = bk(HC), Hgt = function(t, n) {
  return /* @__PURE__ */ cae.createElement(zgt.default, (0, Vgt.default)({}, t, {
    ref: n,
    icon: Bgt.default
  }));
}, lae = /* @__PURE__ */ cae.forwardRef(Hgt);
process.env.NODE_ENV !== "production" && (lae.displayName = "CloseCircleFilled");
zC.default = lae;
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = void 0;
  const n = r(zC);
  function r(o) {
    return o && o.__esModule ? o : { default: o };
  }
  const i = n;
  t.default = i, e.exports = i;
})(k$, k$.exports);
var Ugt = k$.exports, uae = un.default;
Object.defineProperty(By, "__esModule", {
  value: !0
});
By.default = void 0;
var Wgt = uae(D), qgt = uae(Ugt);
const Ggt = (e) => {
  let t;
  return typeof e == "object" && (e != null && e.clearIcon) ? t = e : e && (t = {
    clearIcon: /* @__PURE__ */ Wgt.default.createElement(qgt.default, null)
  }), t;
};
By.default = Ggt;
var Gp = {}, Kgt = un.default;
Object.defineProperty(Gp, "__esModule", {
  value: !0
});
Gp.getMergedStatus = void 0;
Gp.getStatusClassNames = Xgt;
var Ygt = Kgt(Sp);
function Xgt(e, t, n) {
  return (0, Ygt.default)({
    [`${e}-status-success`]: t === "success",
    [`${e}-status-warning`]: t === "warning",
    [`${e}-status-error`]: t === "error",
    [`${e}-status-validating`]: t === "validating",
    [`${e}-has-feedback`]: n
  });
}
const Qgt = (e, t) => t || e;
Gp.getMergedStatus = Qgt;
var so = {}, dae = gi.default;
Object.defineProperty(so, "__esModule", {
  value: !0
});
so.devUseWarning = so.default = so.WarningContext = void 0;
so.noop = _k;
so.resetWarned = gae;
var fae = dae(D), hae = dae(na);
function _k() {
}
let kc = null;
function gae() {
  kc = null, (0, hae.resetWarned)();
}
let Sk = _k;
process.env.NODE_ENV !== "production" && (Sk = (e, t, n) => {
  (0, hae.default)(e, `[antd: ${t}] ${n}`), process.env.NODE_ENV === "test" && gae();
});
const Jgt = so.WarningContext = /* @__PURE__ */ fae.createContext({});
so.devUseWarning = process.env.NODE_ENV !== "production" ? (e) => {
  const {
    strict: t
  } = fae.useContext(Jgt), n = (r, i, o) => {
    if (!r)
      if (t === !1 && i === "deprecated") {
        const a = kc;
        kc || (kc = {}), kc[e] = kc[e] || [], kc[e].includes(o || "") || kc[e].push(o || ""), a || console.warn("[antd] There exists deprecated usage in your code:", kc);
      } else
        process.env.NODE_ENV !== "production" && Sk(r, e, o);
  };
  return n.deprecated = (r, i, o, a) => {
    n(r, "deprecated", `\`${i}\` is deprecated. Please use \`${o}\` instead.${a ? ` ${a}` : ""}`);
  }, n;
} : () => {
  const e = () => {
  };
  return e.deprecated = _k, e;
};
so.default = Sk;
var qy = {};
const Qu = /* @__PURE__ */ bc(K5e);
var Gy = {}, Zgt = gi.default;
Object.defineProperty(Gy, "__esModule", {
  value: !0
});
Gy.default = tpt;
var ept = Zgt(D);
function tpt(e, t, n) {
  var r = ept.useRef({});
  return (!("value" in r.current) || n(r.current.condition, t)) && (r.current.value = e(), r.current.condition = t), r.current.value;
}
var QC = {}, pae = { exports: {} }, mae = { exports: {} };
(function(e) {
  var t = Foe;
  function n(r) {
    if (Array.isArray(r))
      return t(r);
  }
  e.exports = n, e.exports.__esModule = !0, e.exports.default = e.exports;
})(mae);
var npt = mae.exports, vae = { exports: {} };
(function(e) {
  function t(n) {
    if (typeof Symbol < "u" && n[Symbol.iterator] != null || n["@@iterator"] != null)
      return Array.from(n);
  }
  e.exports = t, e.exports.__esModule = !0, e.exports.default = e.exports;
})(vae);
var yae = vae.exports, bae = { exports: {} };
(function(e) {
  function t() {
    throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  e.exports = t, e.exports.__esModule = !0, e.exports.default = e.exports;
})(bae);
var rpt = bae.exports;
(function(e) {
  var t = npt, n = yae, r = dk, i = rpt;
  function o(a) {
    return t(a) || n(a) || r(a) || i();
  }
  e.exports = o, e.exports.__esModule = !0, e.exports.default = e.exports;
})(pae);
var ipt = pae.exports, _ae = { exports: {} };
(function(e) {
  var t = Noe, n = yae, r = dk, i = Boe;
  function o(a) {
    return t(a) || n(a) || r(a) || i();
  }
  e.exports = o, e.exports.__esModule = !0, e.exports.default = e.exports;
})(_ae);
var opt = _ae.exports, wk = {};
Object.defineProperty(wk, "__esModule", {
  value: !0
});
wk.default = apt;
function apt(e, t) {
  for (var n = e, r = 0; r < t.length; r += 1) {
    if (n == null)
      return;
    n = n[t[r]];
  }
  return n;
}
var Ky = un.default;
Object.defineProperty(QC, "__esModule", {
  value: !0
});
QC.default = Z1;
QC.merge = dpt;
var Sae = Ky(Uf), spt = Ky(Uy), wae = Ky(ipt), cpt = Ky(opt), j$ = Ky(wk);
function xae(e, t, n, r) {
  if (!t.length)
    return n;
  var i = (0, cpt.default)(t), o = i[0], a = i.slice(1), s;
  return !e && typeof o == "number" ? s = [] : Array.isArray(e) ? s = (0, wae.default)(e) : s = (0, spt.default)({}, e), r && n === void 0 && a.length === 1 ? delete s[o][a[0]] : s[o] = xae(s[o], a, n, r), s;
}
function Z1(e, t, n) {
  var r = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : !1;
  return t.length && r && n === void 0 && !(0, j$.default)(e, t.slice(0, -1)) ? e : xae(e, t, n, r);
}
function lpt(e) {
  return (0, Sae.default)(e) === "object" && e !== null && Object.getPrototypeOf(e) === Object.prototype;
}
function mB(e) {
  return Array.isArray(e) ? [] : {};
}
var upt = typeof Reflect > "u" ? Object.keys : Reflect.ownKeys;
function dpt() {
  for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
    t[n] = arguments[n];
  var r = mB(t[0]);
  return t.forEach(function(i) {
    function o(a, s) {
      var c = new Set(s), l = (0, j$.default)(i, a), u = Array.isArray(l);
      if (u || lpt(l)) {
        if (!c.has(l)) {
          c.add(l);
          var d = (0, j$.default)(r, a);
          u ? r = Z1(r, a, []) : (!d || (0, Sae.default)(d) !== "object") && (r = Z1(r, a, mB(l))), upt(l).forEach(function(f) {
            o([].concat((0, wae.default)(a), [f]), c);
          });
        }
      } else
        r = Z1(r, a, l);
    }
    o([]);
  }), r;
}
var JC = {};
Object.defineProperty(JC, "__esModule", {
  value: !0
});
JC.default = void 0;
var fpt = D;
JC.default = /* @__PURE__ */ (0, fpt.createContext)(void 0);
var Eae = {}, ZC = {}, Kp = {}, e2 = {};
Object.defineProperty(e2, "__esModule", {
  value: !0
});
e2.default = void 0;
var hpt = {
  // Options
  items_per_page: "/ page",
  jump_to: "Go to",
  jump_to_confirm: "confirm",
  page: "Page",
  // Pagination
  prev_page: "Previous Page",
  next_page: "Next Page",
  prev_5: "Previous 5 Pages",
  next_5: "Next 5 Pages",
  prev_3: "Previous 3 Pages",
  next_3: "Next 3 Pages",
  page_size: "Page Size"
};
e2.default = hpt;
var t2 = {}, Yy = {}, n2 = {}, r2 = {};
Object.defineProperty(r2, "__esModule", {
  value: !0
});
r2.commonLocale = void 0;
r2.commonLocale = {
  yearFormat: "YYYY",
  dayFormat: "D",
  cellMeridiemFormat: "A",
  monthBeforeYear: !0
};
var gpt = un.default;
Object.defineProperty(n2, "__esModule", {
  value: !0
});
n2.default = void 0;
var vB = gpt(Uy), ppt = r2, mpt = (0, vB.default)((0, vB.default)({}, ppt.commonLocale), {}, {
  locale: "en_US",
  today: "Today",
  now: "Now",
  backToToday: "Back to today",
  ok: "OK",
  clear: "Clear",
  month: "Month",
  year: "Year",
  timeSelect: "select time",
  dateSelect: "select date",
  weekSelect: "Choose a week",
  monthSelect: "Choose a month",
  yearSelect: "Choose a year",
  decadeSelect: "Choose a decade",
  dateFormat: "M/D/YYYY",
  dateTimeFormat: "M/D/YYYY HH:mm:ss",
  previousMonth: "Previous month (PageUp)",
  nextMonth: "Next month (PageDown)",
  previousYear: "Last year (Control + left)",
  nextYear: "Next year (Control + right)",
  previousDecade: "Last decade",
  nextDecade: "Next decade",
  previousCentury: "Last century",
  nextCentury: "Next century"
});
n2.default = mpt;
var Xy = {};
Object.defineProperty(Xy, "__esModule", {
  value: !0
});
Xy.default = void 0;
const vpt = {
  placeholder: "Select time",
  rangePlaceholder: ["Start time", "End time"]
};
Xy.default = vpt;
var Cae = un.default;
Object.defineProperty(Yy, "__esModule", {
  value: !0
});
Yy.default = void 0;
var ypt = Cae(n2), bpt = Cae(Xy);
const _pt = {
  lang: Object.assign({
    placeholder: "Select date",
    yearPlaceholder: "Select year",
    quarterPlaceholder: "Select quarter",
    monthPlaceholder: "Select month",
    weekPlaceholder: "Select week",
    rangePlaceholder: ["Start date", "End date"],
    rangeYearPlaceholder: ["Start year", "End year"],
    rangeQuarterPlaceholder: ["Start quarter", "End quarter"],
    rangeMonthPlaceholder: ["Start month", "End month"],
    rangeWeekPlaceholder: ["Start week", "End week"]
  }, ypt.default),
  timePickerLocale: Object.assign({}, bpt.default)
};
Yy.default = _pt;
var Spt = un.default;
Object.defineProperty(t2, "__esModule", {
  value: !0
});
t2.default = void 0;
var wpt = Spt(Yy);
t2.default = wpt.default;
var i2 = un.default;
Object.defineProperty(Kp, "__esModule", {
  value: !0
});
Kp.default = void 0;
var xpt = i2(e2), Ept = i2(t2), Cpt = i2(Yy), Tpt = i2(Xy);
const ca = "${label} is not a valid ${type}", Ipt = {
  locale: "en",
  Pagination: xpt.default,
  DatePicker: Cpt.default,
  TimePicker: Tpt.default,
  Calendar: Ept.default,
  global: {
    placeholder: "Please select"
  },
  Table: {
    filterTitle: "Filter menu",
    filterConfirm: "OK",
    filterReset: "Reset",
    filterEmptyText: "No filters",
    filterCheckall: "Select all items",
    filterSearchPlaceholder: "Search in filters",
    emptyText: "No data",
    selectAll: "Select current page",
    selectInvert: "Invert current page",
    selectNone: "Clear all data",
    selectionAll: "Select all data",
    sortTitle: "Sort",
    expand: "Expand row",
    collapse: "Collapse row",
    triggerDesc: "Click to sort descending",
    triggerAsc: "Click to sort ascending",
    cancelSort: "Click to cancel sorting"
  },
  Tour: {
    Next: "Next",
    Previous: "Previous",
    Finish: "Finish"
  },
  Modal: {
    okText: "OK",
    cancelText: "Cancel",
    justOkText: "OK"
  },
  Popconfirm: {
    okText: "OK",
    cancelText: "Cancel"
  },
  Transfer: {
    titles: ["", ""],
    searchPlaceholder: "Search here",
    itemUnit: "item",
    itemsUnit: "items",
    remove: "Remove",
    selectCurrent: "Select current page",
    removeCurrent: "Remove current page",
    selectAll: "Select all data",
    deselectAll: "Deselect all data",
    removeAll: "Remove all data",
    selectInvert: "Invert current page"
  },
  Upload: {
    uploading: "Uploading...",
    removeFile: "Remove file",
    uploadError: "Upload error",
    previewFile: "Preview file",
    downloadFile: "Download file"
  },
  Empty: {
    description: "No data"
  },
  Icon: {
    icon: "icon"
  },
  Text: {
    edit: "Edit",
    copy: "Copy",
    copied: "Copied",
    expand: "Expand",
    collapse: "Collapse"
  },
  Form: {
    optional: "(optional)",
    defaultValidateMessages: {
      default: "Field validation error for ${label}",
      required: "Please enter ${label}",
      enum: "${label} must be one of [${enum}]",
      whitespace: "${label} cannot be a blank character",
      date: {
        format: "${label} date format is invalid",
        parse: "${label} cannot be converted to a date",
        invalid: "${label} is an invalid date"
      },
      types: {
        string: ca,
        method: ca,
        array: ca,
        object: ca,
        number: ca,
        date: ca,
        boolean: ca,
        integer: ca,
        float: ca,
        regexp: ca,
        email: ca,
        url: ca,
        hex: ca
      },
      string: {
        len: "${label} must be ${len} characters",
        min: "${label} must be at least ${min} characters",
        max: "${label} must be up to ${max} characters",
        range: "${label} must be between ${min}-${max} characters"
      },
      number: {
        len: "${label} must be equal to ${len}",
        min: "${label} must be minimum ${min}",
        max: "${label} must be maximum ${max}",
        range: "${label} must be between ${min}-${max}"
      },
      array: {
        len: "Must be ${len} ${label}",
        min: "At least ${min} ${label}",
        max: "At most ${max} ${label}",
        range: "The amount of ${label} must be between ${min}-${max}"
      },
      pattern: {
        mismatch: "${label} does not match the pattern ${pattern}"
      }
    }
  },
  Image: {
    preview: "Preview"
  },
  QRCode: {
    expired: "QR code expired",
    refresh: "Refresh",
    scanned: "Scanned"
  },
  ColorPicker: {
    presetEmpty: "Empty",
    transparent: "Transparent",
    singleColor: "Single",
    gradientColor: "Gradient"
  }
};
Kp.default = Ipt;
var Apt = un.default;
Object.defineProperty(ZC, "__esModule", {
  value: !0
});
ZC.changeConfirmLocale = Rpt;
ZC.getConfirmLocale = $pt;
var xk = Apt(Kp);
let e_ = Object.assign({}, xk.default.Modal), t_ = [];
const yB = () => t_.reduce((e, t) => Object.assign(Object.assign({}, e), t), xk.default.Modal);
function Rpt(e) {
  if (e) {
    const t = Object.assign({}, e);
    return t_.push(t), e_ = yB(), () => {
      t_ = t_.filter((n) => n !== t), e_ = yB();
    };
  }
  e_ = Object.assign({}, xk.default.Modal);
}
function $pt() {
  return e_;
}
var Yp = {};
Object.defineProperty(Yp, "__esModule", {
  value: !0
});
Yp.default = void 0;
var Opt = D;
const Ppt = /* @__PURE__ */ (0, Opt.createContext)(void 0);
Yp.default = Ppt;
var o2 = {}, Tae = un.default, Mpt = gi.default;
Object.defineProperty(o2, "__esModule", {
  value: !0
});
o2.default = void 0;
var WT = Mpt(D), kpt = Tae(Yp), bB = Tae(Kp);
const Npt = (e, t) => {
  const n = WT.useContext(kpt.default), r = WT.useMemo(() => {
    var o;
    const a = t || bB.default[e], s = (o = n == null ? void 0 : n[e]) !== null && o !== void 0 ? o : {};
    return Object.assign(Object.assign({}, typeof a == "function" ? a() : a), s || {});
  }, [e, t, n]), i = WT.useMemo(() => {
    const o = n == null ? void 0 : n.locale;
    return n != null && n.exist && !o ? bB.default.locale : o;
  }, [n]);
  return [r, i];
};
o2.default = Npt;
(function(e) {
  "use client";
  var t = un.default, n = gi.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = e.ANT_MARK = void 0, Object.defineProperty(e, "useLocale", {
    enumerable: !0,
    get: function() {
      return s.default;
    }
  });
  var r = n(D), i = so, o = ZC, a = t(Yp), s = t(o2);
  const c = e.ANT_MARK = "internalMark", l = (u) => {
    const {
      locale: d = {},
      children: f,
      _ANT_MARK__: h
    } = u;
    if (process.env.NODE_ENV !== "production") {
      const g = (0, i.devUseWarning)("LocaleProvider");
      process.env.NODE_ENV !== "production" && g(h === c, "deprecated", "`LocaleProvider` is deprecated. Please use `locale` with `ConfigProvider` instead: http://u.ant.design/locale");
    }
    r.useEffect(() => (0, o.changeConfirmLocale)(d == null ? void 0 : d.Modal), [d]);
    const p = r.useMemo(() => Object.assign(Object.assign({}, d), {
      exist: !0
    }), [d]);
    return /* @__PURE__ */ r.createElement(a.default.Provider, {
      value: p
    }, f);
  };
  process.env.NODE_ENV !== "production" && (l.displayName = "LocaleProvider"), e.default = l;
})(Eae);
var uc = {}, Ek = {}, vc = {};
Object.defineProperty(vc, "__esModule", {
  value: !0
});
vc.defaultPresetColors = vc.default = void 0;
const Dpt = vc.defaultPresetColors = {
  blue: "#1677FF",
  purple: "#722ED1",
  cyan: "#13C2C2",
  green: "#52C41A",
  magenta: "#EB2F96",
  /**
   * @deprecated Use magenta instead
   */
  pink: "#EB2F96",
  red: "#F5222D",
  orange: "#FA8C16",
  yellow: "#FADB14",
  volcano: "#FA541C",
  geekblue: "#2F54EB",
  gold: "#FAAD14",
  lime: "#A0D911"
}, Lpt = Object.assign(Object.assign({}, Dpt), {
  // Color
  colorPrimary: "#1677ff",
  colorSuccess: "#52c41a",
  colorWarning: "#faad14",
  colorError: "#ff4d4f",
  colorInfo: "#1677ff",
  colorLink: "",
  colorTextBase: "",
  colorBgBase: "",
  // Font
  fontFamily: `-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial,
'Noto Sans', sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol',
'Noto Color Emoji'`,
  fontFamilyCode: "'SFMono-Regular', Consolas, 'Liberation Mono', Menlo, Courier, monospace",
  fontSize: 14,
  // Line
  lineWidth: 1,
  lineType: "solid",
  // Motion
  motionUnit: 0.1,
  motionBase: 0,
  motionEaseOutCirc: "cubic-bezier(0.08, 0.82, 0.17, 1)",
  motionEaseInOutCirc: "cubic-bezier(0.78, 0.14, 0.15, 0.86)",
  motionEaseOut: "cubic-bezier(0.215, 0.61, 0.355, 1)",
  motionEaseInOut: "cubic-bezier(0.645, 0.045, 0.355, 1)",
  motionEaseOutBack: "cubic-bezier(0.12, 0.4, 0.29, 1.46)",
  motionEaseInBack: "cubic-bezier(0.71, -0.46, 0.88, 0.6)",
  motionEaseInQuint: "cubic-bezier(0.755, 0.05, 0.855, 0.06)",
  motionEaseOutQuint: "cubic-bezier(0.23, 1, 0.32, 1)",
  // Radius
  borderRadius: 6,
  // Size
  sizeUnit: 4,
  sizeStep: 4,
  sizePopupArrow: 16,
  // Control Base
  controlHeight: 32,
  // zIndex
  zIndexBase: 0,
  zIndexPopupBase: 1e3,
  // Image
  opacityImage: 1,
  // Wireframe
  wireframe: !1,
  // Motion
  motion: !0
});
vc.default = Lpt;
var Ck = {};
const Qy = /* @__PURE__ */ bc(wTe);
Object.defineProperty(Ck, "__esModule", {
  value: !0
});
Ck.default = jpt;
var qT = Qy;
function jpt(e, t) {
  let {
    generateColorPalettes: n,
    generateNeutralColorPalettes: r
  } = t;
  const {
    colorSuccess: i,
    colorWarning: o,
    colorError: a,
    colorInfo: s,
    colorPrimary: c,
    colorBgBase: l,
    colorTextBase: u
  } = e, d = n(c), f = n(i), h = n(o), p = n(a), g = n(s), m = r(l, u), v = e.colorLink || e.colorInfo, y = n(v), S = new qT.TinyColor(p[1]).mix(new qT.TinyColor(p[3]), 50).toHexString();
  return Object.assign(Object.assign({}, m), {
    colorPrimaryBg: d[1],
    colorPrimaryBgHover: d[2],
    colorPrimaryBorder: d[3],
    colorPrimaryBorderHover: d[4],
    colorPrimaryHover: d[5],
    colorPrimary: d[6],
    colorPrimaryActive: d[7],
    colorPrimaryTextHover: d[8],
    colorPrimaryText: d[9],
    colorPrimaryTextActive: d[10],
    colorSuccessBg: f[1],
    colorSuccessBgHover: f[2],
    colorSuccessBorder: f[3],
    colorSuccessBorderHover: f[4],
    colorSuccessHover: f[4],
    colorSuccess: f[6],
    colorSuccessActive: f[7],
    colorSuccessTextHover: f[8],
    colorSuccessText: f[9],
    colorSuccessTextActive: f[10],
    colorErrorBg: p[1],
    colorErrorBgHover: p[2],
    colorErrorBgFilledHover: S,
    colorErrorBgActive: p[3],
    colorErrorBorder: p[3],
    colorErrorBorderHover: p[4],
    colorErrorHover: p[5],
    colorError: p[6],
    colorErrorActive: p[7],
    colorErrorTextHover: p[8],
    colorErrorText: p[9],
    colorErrorTextActive: p[10],
    colorWarningBg: h[1],
    colorWarningBgHover: h[2],
    colorWarningBorder: h[3],
    colorWarningBorderHover: h[4],
    colorWarningHover: h[4],
    colorWarning: h[6],
    colorWarningActive: h[7],
    colorWarningTextHover: h[8],
    colorWarningText: h[9],
    colorWarningTextActive: h[10],
    colorInfoBg: g[1],
    colorInfoBgHover: g[2],
    colorInfoBorder: g[3],
    colorInfoBorderHover: g[4],
    colorInfoHover: g[4],
    colorInfo: g[6],
    colorInfoActive: g[7],
    colorInfoTextHover: g[8],
    colorInfoText: g[9],
    colorInfoTextActive: g[10],
    colorLinkHover: y[4],
    colorLink: y[6],
    colorLinkActive: y[7],
    colorBgMask: new qT.TinyColor("#000").setAlpha(0.45).toRgbString(),
    colorWhite: "#fff"
  });
}
var Tk = {}, a2 = {};
Object.defineProperty(a2, "__esModule", {
  value: !0
});
a2.default = void 0;
const Fpt = (e) => {
  let t = e, n = e, r = e, i = e;
  return e < 6 && e >= 5 ? t = e + 1 : e < 16 && e >= 6 ? t = e + 2 : e >= 16 && (t = 16), e < 7 && e >= 5 ? n = 4 : e < 8 && e >= 7 ? n = 5 : e < 14 && e >= 8 ? n = 6 : e < 16 && e >= 14 ? n = 7 : e >= 16 && (n = 8), e < 6 && e >= 2 ? r = 1 : e >= 6 && (r = 2), e > 4 && e < 8 ? i = 4 : e >= 8 && (i = 6), {
    borderRadius: e,
    borderRadiusXS: r,
    borderRadiusSM: n,
    borderRadiusLG: t,
    borderRadiusOuter: i
  };
};
a2.default = Fpt;
var Vpt = un.default;
Object.defineProperty(Tk, "__esModule", {
  value: !0
});
Tk.default = zpt;
var Bpt = Vpt(a2);
function zpt(e) {
  const {
    motionUnit: t,
    motionBase: n,
    borderRadius: r,
    lineWidth: i
  } = e;
  return Object.assign({
    // motion
    motionDurationFast: `${(n + t).toFixed(1)}s`,
    motionDurationMid: `${(n + t * 2).toFixed(1)}s`,
    motionDurationSlow: `${(n + t * 3).toFixed(1)}s`,
    // line
    lineWidthBold: i + 1
  }, (0, Bpt.default)(r));
}
var s2 = {};
Object.defineProperty(s2, "__esModule", {
  value: !0
});
s2.default = void 0;
const Hpt = (e) => {
  const {
    controlHeight: t
  } = e;
  return {
    controlHeightSM: t * 0.75,
    controlHeightXS: t * 0.5,
    controlHeightLG: t * 1.25
  };
};
s2.default = Hpt;
var c2 = {}, Jy = {};
Object.defineProperty(Jy, "__esModule", {
  value: !0
});
Jy.default = Upt;
Jy.getLineHeight = Iae;
function Iae(e) {
  return (e + 8) / e;
}
function Upt(e) {
  const t = new Array(10).fill(null).map((n, r) => {
    const i = r - 1, o = e * Math.pow(Math.E, i / 5), a = r > 1 ? Math.floor(o) : Math.ceil(o);
    return Math.floor(a / 2) * 2;
  });
  return t[1] = e, t.map((n) => ({
    size: n,
    lineHeight: Iae(n)
  }));
}
var Wpt = un.default;
Object.defineProperty(c2, "__esModule", {
  value: !0
});
c2.default = void 0;
var qpt = Wpt(Jy);
const Gpt = (e) => {
  const t = (0, qpt.default)(e), n = t.map((u) => u.size), r = t.map((u) => u.lineHeight), i = n[1], o = n[0], a = n[2], s = r[1], c = r[0], l = r[2];
  return {
    fontSizeSM: o,
    fontSize: i,
    fontSizeLG: a,
    fontSizeXL: n[3],
    fontSizeHeading1: n[6],
    fontSizeHeading2: n[5],
    fontSizeHeading3: n[4],
    fontSizeHeading4: n[3],
    fontSizeHeading5: n[2],
    lineHeight: s,
    lineHeightLG: l,
    lineHeightSM: c,
    fontHeight: Math.round(s * i),
    fontHeightLG: Math.round(l * a),
    fontHeightSM: Math.round(c * o),
    lineHeightHeading1: r[6],
    lineHeightHeading2: r[5],
    lineHeightHeading3: r[4],
    lineHeightHeading4: r[3],
    lineHeightHeading5: r[2]
  };
};
c2.default = Gpt;
var Ik = {};
Object.defineProperty(Ik, "__esModule", {
  value: !0
});
Ik.default = Kpt;
function Kpt(e) {
  const {
    sizeUnit: t,
    sizeStep: n
  } = e;
  return {
    sizeXXL: t * (n + 8),
    // 48
    sizeXL: t * (n + 4),
    // 32
    sizeLG: t * (n + 2),
    // 24
    sizeMD: t * (n + 1),
    // 20
    sizeMS: t * n,
    // 16
    size: t * n,
    // 16
    sizeSM: t * (n - 1),
    // 12
    sizeXS: t * (n - 2),
    // 8
    sizeXXS: t * (n - 3)
    // 4
  };
}
var ep = {}, tp = {};
Object.defineProperty(tp, "__esModule", {
  value: !0
});
tp.getSolidColor = tp.getAlphaColor = void 0;
var Aae = Qy;
const Ypt = (e, t) => new Aae.TinyColor(e).setAlpha(t).toRgbString();
tp.getAlphaColor = Ypt;
const Xpt = (e, t) => new Aae.TinyColor(e).darken(t).toHexString();
tp.getSolidColor = Xpt;
Object.defineProperty(ep, "__esModule", {
  value: !0
});
ep.generateNeutralColorPalettes = ep.generateColorPalettes = void 0;
var Qpt = zy, Di = tp;
const Jpt = (e) => {
  const t = (0, Qpt.generate)(e);
  return {
    1: t[0],
    2: t[1],
    3: t[2],
    4: t[3],
    5: t[4],
    6: t[5],
    7: t[6],
    8: t[4],
    9: t[5],
    10: t[6]
    // 8: colors[7],
    // 9: colors[8],
    // 10: colors[9],
  };
};
ep.generateColorPalettes = Jpt;
const Zpt = (e, t) => {
  const n = e || "#fff", r = t || "#000";
  return {
    colorBgBase: n,
    colorTextBase: r,
    colorText: (0, Di.getAlphaColor)(r, 0.88),
    colorTextSecondary: (0, Di.getAlphaColor)(r, 0.65),
    colorTextTertiary: (0, Di.getAlphaColor)(r, 0.45),
    colorTextQuaternary: (0, Di.getAlphaColor)(r, 0.25),
    colorFill: (0, Di.getAlphaColor)(r, 0.15),
    colorFillSecondary: (0, Di.getAlphaColor)(r, 0.06),
    colorFillTertiary: (0, Di.getAlphaColor)(r, 0.04),
    colorFillQuaternary: (0, Di.getAlphaColor)(r, 0.02),
    colorBgSolid: (0, Di.getAlphaColor)(r, 1),
    colorBgSolidHover: (0, Di.getAlphaColor)(r, 0.75),
    colorBgSolidActive: (0, Di.getAlphaColor)(r, 0.95),
    colorBgLayout: (0, Di.getSolidColor)(n, 4),
    colorBgContainer: (0, Di.getSolidColor)(n, 0),
    colorBgElevated: (0, Di.getSolidColor)(n, 0),
    colorBgSpotlight: (0, Di.getAlphaColor)(r, 0.85),
    colorBgBlur: "transparent",
    colorBorder: (0, Di.getSolidColor)(n, 15),
    colorBorderSecondary: (0, Di.getSolidColor)(n, 6)
  };
};
ep.generateNeutralColorPalettes = Zpt;
var Zy = un.default;
Object.defineProperty(Ek, "__esModule", {
  value: !0
});
Ek.default = amt;
var od = zy, emt = vc, tmt = Zy(Ck), nmt = Zy(Tk), rmt = Zy(s2), imt = Zy(c2), omt = Zy(Ik), _B = ep;
function amt(e) {
  od.presetPrimaryColors.pink = od.presetPrimaryColors.magenta, od.presetPalettes.pink = od.presetPalettes.magenta;
  const t = Object.keys(emt.defaultPresetColors).map((n) => {
    const r = e[n] === od.presetPrimaryColors[n] ? od.presetPalettes[n] : (0, od.generate)(e[n]);
    return new Array(10).fill(1).reduce((i, o, a) => (i[`${n}-${a + 1}`] = r[a], i[`${n}${a + 1}`] = r[a], i), {});
  }).reduce((n, r) => (n = Object.assign(Object.assign({}, n), r), n), {});
  return Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, e), t), (0, tmt.default)(e, {
    generateColorPalettes: _B.generateColorPalettes,
    generateNeutralColorPalettes: _B.generateNeutralColorPalettes
  })), (0, imt.default)(e.fontSize)), (0, omt.default)(e)), (0, rmt.default)(e)), (0, nmt.default)(e));
}
var Ak = un.default;
Object.defineProperty(uc, "__esModule", {
  value: !0
});
uc.defaultTheme = uc.defaultConfig = uc.DesignTokenContext = void 0;
var smt = Ak(D), cmt = Qu, lmt = Ak(Ek), SB = Ak(vc);
uc.defaultTheme = (0, cmt.createTheme)(lmt.default);
const umt = uc.defaultConfig = {
  token: SB.default,
  override: {
    override: SB.default
  },
  hashed: !0
};
uc.DesignTokenContext = /* @__PURE__ */ smt.default.createContext(umt);
var ha = {}, dmt = gi.default;
Object.defineProperty(ha, "__esModule", {
  value: !0
});
ha.defaultPrefixCls = ha.defaultIconPrefixCls = ha.Variants = ha.ConfigContext = ha.ConfigConsumer = void 0;
var fmt = dmt(D);
const wB = ha.defaultPrefixCls = "ant", hmt = ha.defaultIconPrefixCls = "anticon";
ha.Variants = ["outlined", "borderless", "filled"];
const gmt = (e, t) => t || (e ? `${wB}-${e}` : wB), pmt = ha.ConfigContext = /* @__PURE__ */ fmt.createContext({
  // We provide a default function for Context without provider
  getPrefixCls: gmt,
  iconPrefixCls: hmt
}), {
  Consumer: mmt
} = pmt;
ha.ConfigConsumer = mmt;
var l2 = {}, Rae = un.default;
Object.defineProperty(l2, "__esModule", {
  value: !0
});
l2.getStyle = $ae;
l2.registerTheme = Smt;
var xB = zy, GT = Qy, vmt = Rae(UC), ymt = Wf, bmt = Rae(so);
const _mt = `-ant-${Date.now()}-${Math.random()}`;
function $ae(e, t) {
  const n = {}, r = (a, s) => {
    let c = a.clone();
    return c = (s == null ? void 0 : s(c)) || c, c.toRgbString();
  }, i = (a, s) => {
    const c = new GT.TinyColor(a), l = (0, xB.generate)(c.toRgbString());
    n[`${s}-color`] = r(c), n[`${s}-color-disabled`] = l[1], n[`${s}-color-hover`] = l[4], n[`${s}-color-active`] = l[6], n[`${s}-color-outline`] = c.clone().setAlpha(0.2).toRgbString(), n[`${s}-color-deprecated-bg`] = l[0], n[`${s}-color-deprecated-border`] = l[2];
  };
  if (t.primaryColor) {
    i(t.primaryColor, "primary");
    const a = new GT.TinyColor(t.primaryColor), s = (0, xB.generate)(a.toRgbString());
    s.forEach((l, u) => {
      n[`primary-${u + 1}`] = l;
    }), n["primary-color-deprecated-l-35"] = r(a, (l) => l.lighten(35)), n["primary-color-deprecated-l-20"] = r(a, (l) => l.lighten(20)), n["primary-color-deprecated-t-20"] = r(a, (l) => l.tint(20)), n["primary-color-deprecated-t-50"] = r(a, (l) => l.tint(50)), n["primary-color-deprecated-f-12"] = r(a, (l) => l.setAlpha(l.getAlpha() * 0.12));
    const c = new GT.TinyColor(s[0]);
    n["primary-color-active-deprecated-f-30"] = r(c, (l) => l.setAlpha(l.getAlpha() * 0.3)), n["primary-color-active-deprecated-d-02"] = r(c, (l) => l.darken(2));
  }
  return t.successColor && i(t.successColor, "success"), t.warningColor && i(t.warningColor, "warning"), t.errorColor && i(t.errorColor, "error"), t.infoColor && i(t.infoColor, "info"), `
  :root {
    ${Object.keys(n).map((a) => `--${e}-${a}: ${n[a]};`).join(`
`)}
  }
  `.trim();
}
function Smt(e, t) {
  const n = $ae(e, t);
  (0, vmt.default)() ? (0, ymt.updateCSS)(n, `${_mt}-dynamic-theme`) : process.env.NODE_ENV !== "production" && (0, bmt.default)(!1, "ConfigProvider", "SSR do not support dynamic theme with css variables.");
}
var hl = {}, wmt = gi.default;
Object.defineProperty(hl, "__esModule", {
  value: !0
});
hl.default = hl.DisabledContextProvider = void 0;
var F$ = wmt(D);
const V$ = /* @__PURE__ */ F$.createContext(!1), xmt = (e) => {
  let {
    children: t,
    disabled: n
  } = e;
  const r = F$.useContext(V$);
  return /* @__PURE__ */ F$.createElement(V$.Provider, {
    value: n ?? r
  }, t);
};
hl.DisabledContextProvider = xmt;
hl.default = V$;
var u2 = {}, Mu = {}, Emt = gi.default;
Object.defineProperty(Mu, "__esModule", {
  value: !0
});
Mu.default = Mu.SizeContextProvider = void 0;
var B$ = Emt(D);
const z$ = /* @__PURE__ */ B$.createContext(void 0), Cmt = (e) => {
  let {
    children: t,
    size: n
  } = e;
  const r = B$.useContext(z$);
  return /* @__PURE__ */ B$.createElement(z$.Provider, {
    value: n || r
  }, t);
};
Mu.SizeContextProvider = Cmt;
Mu.default = z$;
var Oae = un.default;
Object.defineProperty(u2, "__esModule", {
  value: !0
});
u2.default = void 0;
var EB = D, Tmt = Oae(hl), Imt = Oae(Mu);
function Amt() {
  const e = (0, EB.useContext)(Tmt.default), t = (0, EB.useContext)(Imt.default);
  return {
    componentDisabled: e,
    componentSize: t
  };
}
u2.default = Amt;
var Rk = {}, d2 = {}, Pae = un.default;
Object.defineProperty(d2, "__esModule", {
  value: !0
});
d2.default = void 0;
var CB = Pae(Uf), Rmt = Pae(na);
function $mt(e, t) {
  var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1, r = /* @__PURE__ */ new Set();
  function i(o, a) {
    var s = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 1, c = r.has(o);
    if ((0, Rmt.default)(!c, "Warning: There may be circular references"), c)
      return !1;
    if (o === a)
      return !0;
    if (n && s > 1)
      return !1;
    r.add(o);
    var l = s + 1;
    if (Array.isArray(o)) {
      if (!Array.isArray(a) || o.length !== a.length)
        return !1;
      for (var u = 0; u < o.length; u++)
        if (!i(o[u], a[u], l))
          return !1;
      return !0;
    }
    if (o && a && (0, CB.default)(o) === "object" && (0, CB.default)(a) === "object") {
      var d = Object.keys(o);
      return d.length !== Object.keys(a).length ? !1 : d.every(function(f) {
        return i(o[f], a[f], l);
      });
    }
    return !1;
  }
  return i(e, t);
}
d2.default = $mt;
var _l = {};
const Mae = /* @__PURE__ */ bc(cIe);
var $k = {}, f2 = {};
Object.defineProperty(f2, "__esModule", {
  value: !0
});
f2.PresetColors = void 0;
f2.PresetColors = ["blue", "purple", "cyan", "green", "magenta", "pink", "red", "orange", "yellow", "volcano", "geekblue", "lime", "gold"];
(function(e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), Object.defineProperty(e, "PresetColors", {
    enumerable: !0,
    get: function() {
      return t.PresetColors;
    }
  });
  var t = f2;
})($k);
var _s = {}, h2 = {}, g2 = {};
Object.defineProperty(g2, "__esModule", {
  value: !0
});
g2.default = void 0;
g2.default = "5.22.1";
var Omt = un.default;
Object.defineProperty(h2, "__esModule", {
  value: !0
});
h2.default = void 0;
var Pmt = Omt(g2);
h2.default = Pmt.default;
var Ok = {}, p2 = {};
Object.defineProperty(p2, "__esModule", {
  value: !0
});
p2.default = void 0;
var m1 = Qy;
function KT(e) {
  return e >= 0 && e <= 255;
}
function Mmt(e, t) {
  const {
    r: n,
    g: r,
    b: i,
    a: o
  } = new m1.TinyColor(e).toRgb();
  if (o < 1)
    return e;
  const {
    r: a,
    g: s,
    b: c
  } = new m1.TinyColor(t).toRgb();
  for (let l = 0.01; l <= 1; l += 0.01) {
    const u = Math.round((n - a * (1 - l)) / l), d = Math.round((r - s * (1 - l)) / l), f = Math.round((i - c * (1 - l)) / l);
    if (KT(u) && KT(d) && KT(f))
      return new m1.TinyColor({
        r: u,
        g: d,
        b: f,
        a: Math.round(l * 100) / 100
      }).toRgbString();
  }
  return new m1.TinyColor({
    r: n,
    g: r,
    b: i,
    a: 1
  }).toRgbString();
}
p2.default = Mmt;
var kae = un.default;
Object.defineProperty(Ok, "__esModule", {
  value: !0
});
Ok.default = Dmt;
var YT = Qy, kmt = kae(vc), v1 = kae(p2), Nmt = function(e, t) {
  var n = {};
  for (var r in e)
    Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var i = 0, r = Object.getOwnPropertySymbols(e); i < r.length; i++)
      t.indexOf(r[i]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[i]) && (n[r[i]] = e[r[i]]);
  return n;
};
function Dmt(e) {
  const {
    override: t
  } = e, n = Nmt(e, ["override"]), r = Object.assign({}, t);
  Object.keys(kmt.default).forEach((f) => {
    delete r[f];
  });
  const i = Object.assign(Object.assign({}, n), r), o = 480, a = 576, s = 768, c = 992, l = 1200, u = 1600;
  if (i.motion === !1) {
    const f = "0s";
    i.motionDurationFast = f, i.motionDurationMid = f, i.motionDurationSlow = f;
  }
  return Object.assign(Object.assign(Object.assign({}, i), {
    // ============== Background ============== //
    colorFillContent: i.colorFillSecondary,
    colorFillContentHover: i.colorFill,
    colorFillAlter: i.colorFillQuaternary,
    colorBgContainerDisabled: i.colorFillTertiary,
    // ============== Split ============== //
    colorBorderBg: i.colorBgContainer,
    colorSplit: (0, v1.default)(i.colorBorderSecondary, i.colorBgContainer),
    // ============== Text ============== //
    colorTextPlaceholder: i.colorTextQuaternary,
    colorTextDisabled: i.colorTextQuaternary,
    colorTextHeading: i.colorText,
    colorTextLabel: i.colorTextSecondary,
    colorTextDescription: i.colorTextTertiary,
    colorTextLightSolid: i.colorWhite,
    colorHighlight: i.colorError,
    colorBgTextHover: i.colorFillSecondary,
    colorBgTextActive: i.colorFill,
    colorIcon: i.colorTextTertiary,
    colorIconHover: i.colorText,
    colorErrorOutline: (0, v1.default)(i.colorErrorBg, i.colorBgContainer),
    colorWarningOutline: (0, v1.default)(i.colorWarningBg, i.colorBgContainer),
    // Font
    fontSizeIcon: i.fontSizeSM,
    // Line
    lineWidthFocus: i.lineWidth * 3,
    // Control
    lineWidth: i.lineWidth,
    controlOutlineWidth: i.lineWidth * 2,
    // Checkbox size and expand icon size
    controlInteractiveSize: i.controlHeight / 2,
    controlItemBgHover: i.colorFillTertiary,
    controlItemBgActive: i.colorPrimaryBg,
    controlItemBgActiveHover: i.colorPrimaryBgHover,
    controlItemBgActiveDisabled: i.colorFill,
    controlTmpOutline: i.colorFillQuaternary,
    controlOutline: (0, v1.default)(i.colorPrimaryBg, i.colorBgContainer),
    lineType: i.lineType,
    borderRadius: i.borderRadius,
    borderRadiusXS: i.borderRadiusXS,
    borderRadiusSM: i.borderRadiusSM,
    borderRadiusLG: i.borderRadiusLG,
    fontWeightStrong: 600,
    opacityLoading: 0.65,
    linkDecoration: "none",
    linkHoverDecoration: "none",
    linkFocusDecoration: "none",
    controlPaddingHorizontal: 12,
    controlPaddingHorizontalSM: 8,
    paddingXXS: i.sizeXXS,
    paddingXS: i.sizeXS,
    paddingSM: i.sizeSM,
    padding: i.size,
    paddingMD: i.sizeMD,
    paddingLG: i.sizeLG,
    paddingXL: i.sizeXL,
    paddingContentHorizontalLG: i.sizeLG,
    paddingContentVerticalLG: i.sizeMS,
    paddingContentHorizontal: i.sizeMS,
    paddingContentVertical: i.sizeSM,
    paddingContentHorizontalSM: i.size,
    paddingContentVerticalSM: i.sizeXS,
    marginXXS: i.sizeXXS,
    marginXS: i.sizeXS,
    marginSM: i.sizeSM,
    margin: i.size,
    marginMD: i.sizeMD,
    marginLG: i.sizeLG,
    marginXL: i.sizeXL,
    marginXXL: i.sizeXXL,
    boxShadow: `
      0 6px 16px 0 rgba(0, 0, 0, 0.08),
      0 3px 6px -4px rgba(0, 0, 0, 0.12),
      0 9px 28px 8px rgba(0, 0, 0, 0.05)
    `,
    boxShadowSecondary: `
      0 6px 16px 0 rgba(0, 0, 0, 0.08),
      0 3px 6px -4px rgba(0, 0, 0, 0.12),
      0 9px 28px 8px rgba(0, 0, 0, 0.05)
    `,
    boxShadowTertiary: `
      0 1px 2px 0 rgba(0, 0, 0, 0.03),
      0 1px 6px -1px rgba(0, 0, 0, 0.02),
      0 2px 4px 0 rgba(0, 0, 0, 0.02)
    `,
    screenXS: o,
    screenXSMin: o,
    screenXSMax: a - 1,
    screenSM: a,
    screenSMMin: a,
    screenSMMax: s - 1,
    screenMD: s,
    screenMDMin: s,
    screenMDMax: c - 1,
    screenLG: c,
    screenLGMin: c,
    screenLGMax: l - 1,
    screenXL: l,
    screenXLMin: l,
    screenXLMax: u - 1,
    screenXXL: u,
    screenXXLMin: u,
    boxShadowPopoverArrow: "2px 2px 5px rgba(0, 0, 0, 0.05)",
    boxShadowCard: `
      0 1px 2px -2px ${new YT.TinyColor("rgba(0, 0, 0, 0.16)").toRgbString()},
      0 3px 6px 0 ${new YT.TinyColor("rgba(0, 0, 0, 0.12)").toRgbString()},
      0 5px 12px 4px ${new YT.TinyColor("rgba(0, 0, 0, 0.09)").toRgbString()}
    `,
    boxShadowDrawerRight: `
      -6px 0 16px 0 rgba(0, 0, 0, 0.08),
      -3px 0 6px -4px rgba(0, 0, 0, 0.12),
      -9px 0 28px 8px rgba(0, 0, 0, 0.05)
    `,
    boxShadowDrawerLeft: `
      6px 0 16px 0 rgba(0, 0, 0, 0.08),
      3px 0 6px -4px rgba(0, 0, 0, 0.12),
      9px 0 28px 8px rgba(0, 0, 0, 0.05)
    `,
    boxShadowDrawerUp: `
      0 6px 16px 0 rgba(0, 0, 0, 0.08),
      0 3px 6px -4px rgba(0, 0, 0, 0.12),
      0 9px 28px 8px rgba(0, 0, 0, 0.05)
    `,
    boxShadowDrawerDown: `
      0 -6px 16px 0 rgba(0, 0, 0, 0.08),
      0 -3px 6px -4px rgba(0, 0, 0, 0.12),
      0 -9px 28px 8px rgba(0, 0, 0, 0.05)
    `,
    boxShadowTabsOverflowLeft: "inset 10px 0 8px -8px rgba(0, 0, 0, 0.08)",
    boxShadowTabsOverflowRight: "inset -10px 0 8px -8px rgba(0, 0, 0, 0.08)",
    boxShadowTabsOverflowTop: "inset 0 10px 8px -8px rgba(0, 0, 0, 0.08)",
    boxShadowTabsOverflowBottom: "inset 0 -10px 8px -8px rgba(0, 0, 0, 0.08)"
  }), r);
}
var m2 = un.default;
Object.defineProperty(_s, "__esModule", {
  value: !0
});
_s.default = Umt;
_s.unitless = _s.ignore = _s.getComputedToken = void 0;
var Lmt = m2(D), jmt = Qu, Fmt = m2(h2), TB = uc, Vmt = m2(vc), Nae = m2(Ok), IB = function(e, t) {
  var n = {};
  for (var r in e)
    Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var i = 0, r = Object.getOwnPropertySymbols(e); i < r.length; i++)
      t.indexOf(r[i]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[i]) && (n[r[i]] = e[r[i]]);
  return n;
};
const Bmt = _s.unitless = {
  lineHeight: !0,
  lineHeightSM: !0,
  lineHeightLG: !0,
  lineHeightHeading1: !0,
  lineHeightHeading2: !0,
  lineHeightHeading3: !0,
  lineHeightHeading4: !0,
  lineHeightHeading5: !0,
  opacityLoading: !0,
  fontWeightStrong: !0,
  zIndexPopupBase: !0,
  zIndexBase: !0,
  opacityImage: !0
}, zmt = _s.ignore = {
  size: !0,
  sizeSM: !0,
  sizeLG: !0,
  sizeMD: !0,
  sizeXS: !0,
  sizeXXS: !0,
  sizeMS: !0,
  sizeXL: !0,
  sizeXXL: !0,
  sizeUnit: !0,
  sizeStep: !0,
  motionBase: !0,
  motionUnit: !0
}, Hmt = {
  screenXS: !0,
  screenXSMin: !0,
  screenXSMax: !0,
  screenSM: !0,
  screenSMMin: !0,
  screenSMMax: !0,
  screenMD: !0,
  screenMDMin: !0,
  screenMDMax: !0,
  screenLG: !0,
  screenLGMin: !0,
  screenLGMax: !0,
  screenXL: !0,
  screenXLMin: !0,
  screenXLMax: !0,
  screenXXL: !0,
  screenXXLMin: !0
}, Pk = (e, t, n) => {
  const r = n.getDerivativeToken(e), {
    override: i
  } = t, o = IB(t, ["override"]);
  let a = Object.assign(Object.assign({}, r), {
    override: i
  });
  return a = (0, Nae.default)(a), o && Object.entries(o).forEach((s) => {
    let [c, l] = s;
    const {
      theme: u
    } = l, d = IB(l, ["theme"]);
    let f = d;
    u && (f = Pk(Object.assign(Object.assign({}, a), d), {
      override: d
    }, u)), a[c] = f;
  }), a;
};
_s.getComputedToken = Pk;
function Umt() {
  const {
    token: e,
    hashed: t,
    theme: n,
    override: r,
    cssVar: i
  } = Lmt.default.useContext(TB.DesignTokenContext), o = `${Fmt.default}-${t || ""}`, a = n || TB.defaultTheme, [s, c, l] = (0, jmt.useCacheToken)(a, [Vmt.default, e], {
    salt: o,
    override: r,
    getComputedToken: Pk,
    // formatToken will not be consumed after 1.15.0 with getComputedToken.
    // But token will break if @ant-design/cssinjs is under 1.15.0 without it
    formatToken: Nae.default,
    cssVar: i && {
      prefix: i.prefix,
      key: i.key,
      unitless: Bmt,
      ignore: zmt,
      preserve: Hmt
    }
  });
  return [a, l, t ? c : "", s, i];
}
var fu = {}, Wr = {};
Object.defineProperty(Wr, "__esModule", {
  value: !0
});
Wr.textEllipsis = Wr.resetIcon = Wr.resetComponent = Wr.operationUnit = Wr.genLinkStyle = Wr.genFocusStyle = Wr.genFocusOutline = Wr.genCommonStyle = Wr.clearFix = void 0;
var Wmt = Qu;
Wr.textEllipsis = {
  overflow: "hidden",
  whiteSpace: "nowrap",
  textOverflow: "ellipsis"
};
const qmt = function(e) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
  return {
    boxSizing: "border-box",
    margin: 0,
    padding: 0,
    color: e.colorText,
    fontSize: e.fontSize,
    // font-variant: @font-variant-base;
    lineHeight: e.lineHeight,
    listStyle: "none",
    // font-feature-settings: @font-feature-settings-base;
    fontFamily: t ? "inherit" : e.fontFamily
  };
};
Wr.resetComponent = qmt;
const Gmt = () => ({
  display: "inline-flex",
  alignItems: "center",
  color: "inherit",
  fontStyle: "normal",
  lineHeight: 0,
  textAlign: "center",
  textTransform: "none",
  // for SVG icon, see https://blog.prototypr.io/align-svg-icons-to-text-and-say-goodbye-to-font-icons-d44b3d7b26b4
  verticalAlign: "-0.125em",
  textRendering: "optimizeLegibility",
  "-webkit-font-smoothing": "antialiased",
  "-moz-osx-font-smoothing": "grayscale",
  "> *": {
    lineHeight: 1
  },
  svg: {
    display: "inline-block"
  }
});
Wr.resetIcon = Gmt;
const Kmt = () => ({
  // https://github.com/ant-design/ant-design/issues/21301#issuecomment-583955229
  "&::before": {
    display: "table",
    content: '""'
  },
  "&::after": {
    // https://github.com/ant-design/ant-design/issues/21864
    display: "table",
    clear: "both",
    content: '""'
  }
});
Wr.clearFix = Kmt;
const Ymt = (e) => ({
  a: {
    color: e.colorLink,
    textDecoration: e.linkDecoration,
    backgroundColor: "transparent",
    // remove the gray background on active links in IE 10.
    outline: "none",
    cursor: "pointer",
    transition: `color ${e.motionDurationSlow}`,
    "-webkit-text-decoration-skip": "objects",
    // remove gaps in links underline in iOS 8+ and Safari 8+.
    "&:hover": {
      color: e.colorLinkHover
    },
    "&:active": {
      color: e.colorLinkActive
    },
    "&:active, &:hover": {
      textDecoration: e.linkHoverDecoration,
      outline: 0
    },
    // https://github.com/ant-design/ant-design/issues/22503
    "&:focus": {
      textDecoration: e.linkFocusDecoration,
      outline: 0
    },
    "&[disabled]": {
      color: e.colorTextDisabled,
      cursor: "not-allowed"
    }
  }
});
Wr.genLinkStyle = Ymt;
const Xmt = (e, t, n, r) => {
  const i = `[class^="${t}"], [class*=" ${t}"]`, o = n ? `.${n}` : i, a = {
    boxSizing: "border-box",
    "&::before, &::after": {
      boxSizing: "border-box"
    }
  };
  let s = {};
  return r !== !1 && (s = {
    fontFamily: e.fontFamily,
    fontSize: e.fontSize
  }), {
    [o]: Object.assign(Object.assign(Object.assign({}, s), a), {
      [i]: a
    })
  };
};
Wr.genCommonStyle = Xmt;
const Dae = (e) => ({
  outline: `${(0, Wmt.unit)(e.lineWidthFocus)} solid ${e.colorPrimaryBorder}`,
  outlineOffset: 1,
  transition: "outline-offset 0s, outline 0s"
});
Wr.genFocusOutline = Dae;
const Lae = (e) => ({
  "&:focus-visible": Object.assign({}, Dae(e))
});
Wr.genFocusStyle = Lae;
const Qmt = (e) => Object.assign(Object.assign({
  // FIXME: This use link but is a operation unit. Seems should be a colorPrimary.
  // And Typography use this to generate link style which should not do this.
  color: e.colorLink,
  textDecoration: e.linkDecoration,
  outline: "none",
  cursor: "pointer",
  transition: `all ${e.motionDurationSlow}`,
  border: 0,
  padding: 0,
  background: "none",
  userSelect: "none"
}, Lae(e)), {
  "&:focus, &:hover": {
    color: e.colorLinkHover
  },
  "&:active": {
    color: e.colorLinkActive
  }
});
Wr.operationUnit = Qmt;
var eb = {}, Jmt = un.default;
Object.defineProperty(eb, "__esModule", {
  value: !0
});
eb.default = void 0;
var Zmt = Qu, e0t = Wr, t0t = Jmt(_s);
const n0t = (e, t) => {
  const [n, r] = (0, t0t.default)();
  return (0, Zmt.useStyleRegister)({
    theme: n,
    token: r,
    hashId: "",
    path: ["ant-design-icons", e],
    nonce: () => t == null ? void 0 : t.nonce,
    layer: {
      name: "antd"
    }
  }, () => [{
    [`.${e}`]: Object.assign(Object.assign({}, (0, e0t.resetIcon)()), {
      [`.${e} .${e}-icon`]: {
        display: "block"
      }
    })
  }]);
};
eb.default = n0t;
var r0t = un.default, i0t = gi.default;
Object.defineProperty(fu, "__esModule", {
  value: !0
});
fu.genSubStyleComponent = fu.genStyleHooks = fu.genComponentStyleHook = void 0;
var AB = D, o0t = Mae, RB = ha, $B = Wr, OB = i0t(_s), a0t = r0t(eb);
const {
  genStyleHooks: s0t,
  genComponentStyleHook: c0t,
  genSubStyleComponent: l0t
} = (0, o0t.genStyleUtils)({
  usePrefix: () => {
    const {
      getPrefixCls: e,
      iconPrefixCls: t
    } = (0, AB.useContext)(RB.ConfigContext);
    return {
      rootPrefixCls: e(),
      iconPrefixCls: t
    };
  },
  useToken: () => {
    const [e, t, n, r, i] = (0, OB.default)();
    return {
      theme: e,
      realToken: t,
      hashId: n,
      token: r,
      cssVar: i
    };
  },
  useCSP: () => {
    const {
      csp: e,
      iconPrefixCls: t
    } = (0, AB.useContext)(RB.ConfigContext);
    return (0, a0t.default)(t, e), e ?? {};
  },
  getResetStyles: (e) => [{
    "&": (0, $B.genLinkStyle)(e)
  }],
  getCommonStyle: $B.genCommonStyle,
  getCompUnitless: () => OB.unitless
});
fu.genSubStyleComponent = l0t;
fu.genComponentStyleHook = c0t;
fu.genStyleHooks = s0t;
var Mk = {};
Object.defineProperty(Mk, "__esModule", {
  value: !0
});
Mk.default = d0t;
var u0t = $k;
function d0t(e, t) {
  return u0t.PresetColors.reduce((n, r) => {
    const i = e[`${r}1`], o = e[`${r}3`], a = e[`${r}6`], s = e[`${r}7`];
    return Object.assign(Object.assign({}, n), t(r, {
      lightColor: i,
      lightBorderColor: o,
      darkColor: a,
      textColor: s
    }));
  }, {});
}
(function(e) {
  var t = un.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), Object.defineProperty(e, "DesignTokenContext", {
    enumerable: !0,
    get: function() {
      return u.DesignTokenContext;
    }
  }), Object.defineProperty(e, "PresetColors", {
    enumerable: !0,
    get: function() {
      return i.PresetColors;
    }
  }), Object.defineProperty(e, "calc", {
    enumerable: !0,
    get: function() {
      return r.genCalc;
    }
  }), Object.defineProperty(e, "defaultConfig", {
    enumerable: !0,
    get: function() {
      return u.defaultConfig;
    }
  }), Object.defineProperty(e, "genComponentStyleHook", {
    enumerable: !0,
    get: function() {
      return s.genComponentStyleHook;
    }
  }), Object.defineProperty(e, "genPresetColor", {
    enumerable: !0,
    get: function() {
      return c.default;
    }
  }), Object.defineProperty(e, "genStyleHooks", {
    enumerable: !0,
    get: function() {
      return s.genStyleHooks;
    }
  }), Object.defineProperty(e, "genSubStyleComponent", {
    enumerable: !0,
    get: function() {
      return s.genSubStyleComponent;
    }
  }), Object.defineProperty(e, "getLineHeight", {
    enumerable: !0,
    get: function() {
      return o.getLineHeight;
    }
  }), Object.defineProperty(e, "mergeToken", {
    enumerable: !0,
    get: function() {
      return r.mergeToken;
    }
  }), Object.defineProperty(e, "statistic", {
    enumerable: !0,
    get: function() {
      return r.statistic;
    }
  }), Object.defineProperty(e, "statisticToken", {
    enumerable: !0,
    get: function() {
      return r.statisticToken;
    }
  }), Object.defineProperty(e, "useResetIconStyle", {
    enumerable: !0,
    get: function() {
      return l.default;
    }
  }), Object.defineProperty(e, "useStyleRegister", {
    enumerable: !0,
    get: function() {
      return n.useStyleRegister;
    }
  }), Object.defineProperty(e, "useToken", {
    enumerable: !0,
    get: function() {
      return a.default;
    }
  });
  var n = Qu, r = Mae, i = $k, o = Jy, a = t(_s), s = fu, c = t(Mk), l = t(eb), u = uc;
})(_l);
var v2 = {}, f0t = gi.default;
Object.defineProperty(v2, "__esModule", {
  value: !0
});
v2.default = void 0;
var h0t = f0t(D);
const g0t = Object.assign({}, h0t), {
  useId: PB
} = g0t, p0t = () => "", m0t = typeof PB > "u" ? p0t : PB;
v2.default = m0t;
var kk = un.default;
Object.defineProperty(Rk, "__esModule", {
  value: !0
});
Rk.default = S0t;
var v0t = kk(Gy), y0t = kk(d2), b0t = so, MB = _l, _0t = kk(v2);
function S0t(e, t, n) {
  var r, i;
  const o = (0, b0t.devUseWarning)("ConfigProvider"), a = e || {}, s = a.inherit === !1 || !t ? Object.assign(Object.assign({}, MB.defaultConfig), {
    hashed: (r = t == null ? void 0 : t.hashed) !== null && r !== void 0 ? r : MB.defaultConfig.hashed,
    cssVar: t == null ? void 0 : t.cssVar
  }) : t, c = (0, _0t.default)();
  if (process.env.NODE_ENV !== "production") {
    const l = a.cssVar || s.cssVar, u = !!(typeof a.cssVar == "object" && (!((i = a.cssVar) === null || i === void 0) && i.key) || c);
    process.env.NODE_ENV !== "production" && o(!l || u, "breaking", "Missing key in `cssVar` config. Please upgrade to React 18 or set `cssVar.key` manually in each ConfigProvider inside `cssVar` enabled ConfigProvider.");
  }
  return (0, v0t.default)(() => {
    var l, u;
    if (!e)
      return t;
    const d = Object.assign({}, s.components);
    Object.keys(e.components || {}).forEach((p) => {
      d[p] = Object.assign(Object.assign({}, d[p]), e.components[p]);
    });
    const f = `css-var-${c.replace(/:/g, "")}`, h = ((l = a.cssVar) !== null && l !== void 0 ? l : s.cssVar) && Object.assign(Object.assign(Object.assign({
      prefix: n == null ? void 0 : n.prefixCls
    }, typeof s.cssVar == "object" ? s.cssVar : {}), typeof a.cssVar == "object" ? a.cssVar : {}), {
      key: typeof a.cssVar == "object" && ((u = a.cssVar) === null || u === void 0 ? void 0 : u.key) || f
    });
    return Object.assign(Object.assign(Object.assign({}, s), a), {
      token: Object.assign(Object.assign({}, s.token), a.token),
      components: d,
      cssVar: h
    });
  }, [a, s], (l, u) => l.some((d, f) => {
    const h = u[f];
    return !(0, y0t.default)(d, h, !0);
  }));
}
var Nk = {};
const w0t = /* @__PURE__ */ bc(GIe);
var x0t = gi.default;
Object.defineProperty(Nk, "__esModule", {
  value: !0
});
Nk.default = T0t;
var kB = x0t(D), E0t = w0t, C0t = _l;
function T0t(e) {
  const {
    children: t
  } = e, [, n] = (0, C0t.useToken)(), {
    motion: r
  } = n, i = kB.useRef(!1);
  return i.current = i.current || r === !1, i.current ? /* @__PURE__ */ kB.createElement(E0t.Provider, {
    motion: r
  }, t) : t;
}
var y2 = {}, I0t = gi.default;
Object.defineProperty(y2, "__esModule", {
  value: !0
});
y2.default = void 0;
var A0t = I0t(D), R0t = so;
const jae = /* @__PURE__ */ A0t.memo((e) => {
  let {
    dropdownMatchSelectWidth: t
  } = e;
  return (0, R0t.devUseWarning)("ConfigProvider").deprecated(t === void 0, "dropdownMatchSelectWidth", "popupMatchSelectWidth"), null;
});
process.env.NODE_ENV !== "production" && (jae.displayName = "PropWarning");
y2.default = process.env.NODE_ENV !== "production" ? jae : () => null;
var Fae = {};
(function(e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), Object.defineProperty(e, "default", {
    enumerable: !0,
    get: function() {
      return t.useResetIconStyle;
    }
  });
  var t = _l;
})(Fae);
(function(e) {
  "use client";
  var t = un.default, n = gi.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), Object.defineProperty(e, "ConfigConsumer", {
    enumerable: !0,
    get: function() {
      return g.ConfigConsumer;
    }
  }), Object.defineProperty(e, "ConfigContext", {
    enumerable: !0,
    get: function() {
      return g.ConfigContext;
    }
  }), Object.defineProperty(e, "Variants", {
    enumerable: !0,
    get: function() {
      return g.Variants;
    }
  }), e.default = e.configConsumerProps = void 0, Object.defineProperty(e, "defaultIconPrefixCls", {
    enumerable: !0,
    get: function() {
      return g.defaultIconPrefixCls;
    }
  }), Object.defineProperty(e, "defaultPrefixCls", {
    enumerable: !0,
    get: function() {
      return g.defaultPrefixCls;
    }
  }), e.warnContext = e.globalConfig = void 0;
  var r = n(D), i = Qu, o = t(qp), a = t(Gy), s = QC, c = n(so), l = t(JC), u = n(Eae), d = t(Yp), f = t(Kp), h = uc, p = t(vc), g = ha, m = l2, v = hl, y = t(u2), S = t(Rk), _ = t(Nk), w = t(y2), T = n(Mu), x = t(Fae), C = function(Q, K) {
    var q = {};
    for (var X in Q)
      Object.prototype.hasOwnProperty.call(Q, X) && K.indexOf(X) < 0 && (q[X] = Q[X]);
    if (Q != null && typeof Object.getOwnPropertySymbols == "function")
      for (var ie = 0, X = Object.getOwnPropertySymbols(Q); ie < X.length; ie++)
        K.indexOf(X[ie]) < 0 && Object.prototype.propertyIsEnumerable.call(Q, X[ie]) && (q[X[ie]] = Q[X[ie]]);
    return q;
  };
  let E = !1;
  e.warnContext = process.env.NODE_ENV !== "production" ? (Q) => {
    process.env.NODE_ENV !== "production" && (0, c.default)(!E, Q, "Static function can not consume context like dynamic theme. Please use 'App' component instead.");
  } : (
    /* istanbul ignore next */
    null
  ), e.configConsumerProps = ["getTargetContainer", "getPopupContainer", "rootPrefixCls", "getPrefixCls", "renderEmpty", "csp", "autoInsertSpaceInButton", "locale"];
  const R = ["getTargetContainer", "getPopupContainer", "renderEmpty", "input", "pagination", "form", "select", "button"];
  let A, O, $, N;
  function z() {
    return A || g.defaultPrefixCls;
  }
  function k() {
    return O || g.defaultIconPrefixCls;
  }
  function F(Q) {
    return Object.keys(Q).some((K) => K.endsWith("Color"));
  }
  const V = (Q) => {
    const {
      prefixCls: K,
      iconPrefixCls: q,
      theme: X,
      holderRender: ie
    } = Q;
    K !== void 0 && (A = K), q !== void 0 && (O = q), "holderRender" in Q && (N = ie), X && (F(X) ? (process.env.NODE_ENV !== "production" && (0, c.default)(!1, "ConfigProvider", "`config` of css variable theme is not work in v5. Please use new `theme` config instead."), (0, m.registerTheme)(z(), X)) : $ = X);
  }, j = () => ({
    getPrefixCls: (Q, K) => K || (Q ? `${z()}-${Q}` : z()),
    getIconPrefixCls: k,
    getRootPrefixCls: () => A || z(),
    getTheme: () => $,
    holderRender: N
  });
  e.globalConfig = j;
  const B = (Q) => {
    const {
      children: K,
      csp: q,
      autoInsertSpaceInButton: X,
      alert: ie,
      anchor: te,
      form: J,
      locale: Y,
      componentSize: ee,
      direction: Z,
      space: H,
      splitter: oe,
      virtual: W,
      dropdownMatchSelectWidth: se,
      popupMatchSelectWidth: ce,
      popupOverflow: ge,
      legacyLocale: he,
      parentContext: ue,
      iconPrefixCls: Ee,
      theme: pe,
      componentDisabled: Oe,
      segmented: de,
      statistic: be,
      spin: Ie,
      calendar: Ve,
      carousel: Fe,
      cascader: Pe,
      collapse: ot,
      typography: dt,
      checkbox: ft,
      descriptions: wt,
      divider: Ge,
      drawer: at,
      skeleton: Nt,
      steps: zt,
      image: kt,
      layout: Ct,
      list: yt,
      mentions: Mn,
      modal: Pt,
      progress: Ze,
      result: Le,
      slider: rt,
      breadcrumb: ut,
      menu: vt,
      pagination: We,
      input: et,
      textArea: Ne,
      empty: Yt,
      badge: Ht,
      radio: Be,
      rate: ze,
      switch: it,
      transfer: lt,
      avatar: Tt,
      message: jt,
      tag: ne,
      table: _e,
      card: $e,
      tabs: qe,
      timeline: xt,
      timePicker: bt,
      upload: st,
      notification: Rt,
      tree: Ke,
      colorPicker: ke,
      datePicker: Xe,
      rangePicker: ct,
      flex: Ue,
      wave: Dt,
      dropdown: It,
      warning: wn,
      tour: gr,
      floatButtonGroup: Gn,
      variant: Cn,
      inputNumber: Fr,
      treeSelect: Kr
    } = Q, pr = r.useCallback((tn, Qt) => {
      const {
        prefixCls: Jt
      } = Q;
      if (Qt)
        return Qt;
      const vn = Jt || ue.getPrefixCls("");
      return tn ? `${vn}-${tn}` : vn;
    }, [ue.getPrefixCls, Q.prefixCls]), xr = Ee || ue.iconPrefixCls || g.defaultIconPrefixCls, Yr = q || ue.csp;
    (0, x.default)(xr, Yr);
    const Er = (0, S.default)(pe, ue.theme, {
      prefixCls: pr("")
    });
    process.env.NODE_ENV !== "production" && (E = E || !!Er);
    const Xr = {
      csp: Yr,
      autoInsertSpaceInButton: X,
      alert: ie,
      anchor: te,
      locale: Y || he,
      direction: Z,
      space: H,
      splitter: oe,
      virtual: W,
      popupMatchSelectWidth: ce ?? se,
      popupOverflow: ge,
      getPrefixCls: pr,
      iconPrefixCls: xr,
      theme: Er,
      segmented: de,
      statistic: be,
      spin: Ie,
      calendar: Ve,
      carousel: Fe,
      cascader: Pe,
      collapse: ot,
      typography: dt,
      checkbox: ft,
      descriptions: wt,
      divider: Ge,
      drawer: at,
      skeleton: Nt,
      steps: zt,
      image: kt,
      input: et,
      textArea: Ne,
      layout: Ct,
      list: yt,
      mentions: Mn,
      modal: Pt,
      progress: Ze,
      result: Le,
      slider: rt,
      breadcrumb: ut,
      menu: vt,
      pagination: We,
      empty: Yt,
      badge: Ht,
      radio: Be,
      rate: ze,
      switch: it,
      transfer: lt,
      avatar: Tt,
      message: jt,
      tag: ne,
      table: _e,
      card: $e,
      tabs: qe,
      timeline: xt,
      timePicker: bt,
      upload: st,
      notification: Rt,
      tree: Ke,
      colorPicker: ke,
      datePicker: Xe,
      rangePicker: ct,
      flex: Ue,
      wave: Dt,
      dropdown: It,
      warning: wn,
      tour: gr,
      floatButtonGroup: Gn,
      variant: Cn,
      inputNumber: Fr,
      treeSelect: Kr
    };
    process.env.NODE_ENV !== "production" && (0, c.devUseWarning)("ConfigProvider")(!("autoInsertSpaceInButton" in Q), "deprecated", "`autoInsertSpaceInButton` is deprecated. Please use `{ button: { autoInsertSpace: boolean }}` instead.");
    const Ci = Object.assign({}, ue);
    Object.keys(Xr).forEach((tn) => {
      Xr[tn] !== void 0 && (Ci[tn] = Xr[tn]);
    }), R.forEach((tn) => {
      const Qt = Q[tn];
      Qt && (Ci[tn] = Qt);
    }), typeof X < "u" && (Ci.button = Object.assign({
      autoInsertSpace: X
    }, Ci.button));
    const Ti = (0, a.default)(() => Ci, Ci, (tn, Qt) => {
      const Jt = Object.keys(tn), vn = Object.keys(Qt);
      return Jt.length !== vn.length || Jt.some((Cr) => tn[Cr] !== Qt[Cr]);
    }), Mi = r.useMemo(() => ({
      prefixCls: xr,
      csp: Yr
    }), [xr, Yr]);
    let Qn = /* @__PURE__ */ r.createElement(r.Fragment, null, /* @__PURE__ */ r.createElement(w.default, {
      dropdownMatchSelectWidth: se
    }), K);
    const Xt = r.useMemo(() => {
      var tn, Qt, Jt, vn;
      return (0, s.merge)(((tn = f.default.Form) === null || tn === void 0 ? void 0 : tn.defaultValidateMessages) || {}, ((Jt = (Qt = Ti.locale) === null || Qt === void 0 ? void 0 : Qt.Form) === null || Jt === void 0 ? void 0 : Jt.defaultValidateMessages) || {}, ((vn = Ti.form) === null || vn === void 0 ? void 0 : vn.validateMessages) || {}, (J == null ? void 0 : J.validateMessages) || {});
    }, [Ti, J == null ? void 0 : J.validateMessages]);
    Object.keys(Xt).length > 0 && (Qn = /* @__PURE__ */ r.createElement(l.default.Provider, {
      value: Xt
    }, Qn)), Y && (Qn = /* @__PURE__ */ r.createElement(u.default, {
      locale: Y,
      _ANT_MARK__: u.ANT_MARK
    }, Qn)), (xr || Yr) && (Qn = /* @__PURE__ */ r.createElement(o.default.Provider, {
      value: Mi
    }, Qn)), ee && (Qn = /* @__PURE__ */ r.createElement(T.SizeContextProvider, {
      size: ee
    }, Qn)), Qn = /* @__PURE__ */ r.createElement(_.default, null, Qn);
    const Vt = r.useMemo(() => {
      const tn = Er || {}, {
        algorithm: Qt,
        token: Jt,
        components: vn,
        cssVar: Cr
      } = tn, pi = C(tn, ["algorithm", "token", "components", "cssVar"]), ln = Qt && (!Array.isArray(Qt) || Qt.length > 0) ? (0, i.createTheme)(Qt) : h.defaultTheme, ni = {};
      Object.entries(vn || {}).forEach((Ki) => {
        let [Do, po] = Ki;
        const mo = Object.assign({}, po);
        "algorithm" in mo && (mo.algorithm === !0 ? mo.theme = ln : (Array.isArray(mo.algorithm) || typeof mo.algorithm == "function") && (mo.theme = (0, i.createTheme)(mo.algorithm)), delete mo.algorithm), ni[Do] = mo;
      });
      const ri = Object.assign(Object.assign({}, p.default), Jt);
      return Object.assign(Object.assign({}, pi), {
        theme: ln,
        token: ri,
        components: ni,
        override: Object.assign({
          override: ri
        }, ni),
        cssVar: Cr
      });
    }, [Er]);
    return pe && (Qn = /* @__PURE__ */ r.createElement(h.DesignTokenContext.Provider, {
      value: Vt
    }, Qn)), Ti.warning && (Qn = /* @__PURE__ */ r.createElement(c.WarningContext.Provider, {
      value: Ti.warning
    }, Qn)), Oe !== void 0 && (Qn = /* @__PURE__ */ r.createElement(v.DisabledContextProvider, {
      disabled: Oe
    }, Qn)), /* @__PURE__ */ r.createElement(g.ConfigContext.Provider, {
      value: Ti
    }, Qn);
  }, U = (Q) => {
    const K = r.useContext(g.ConfigContext), q = r.useContext(d.default);
    return /* @__PURE__ */ r.createElement(B, Object.assign({
      parentContext: K,
      legacyLocale: q
    }, Q));
  };
  U.ConfigContext = g.ConfigContext, U.SizeContext = T.default, U.config = V, U.useConfig = y.default, Object.defineProperty(U, "SizeContext", {
    get: () => (process.env.NODE_ENV !== "production" && (0, c.default)(!1, "ConfigProvider", "ConfigProvider.SizeContext is deprecated. Please use `ConfigProvider.useConfig().componentSize` instead."), T.default)
  }), process.env.NODE_ENV !== "production" && (U.displayName = "ConfigProvider"), e.default = U;
})(qy);
var tb = {};
Object.defineProperty(tb, "__esModule", {
  value: !0
});
tb.default = void 0;
var $0t = _l;
const O0t = (e) => {
  const [, , , , t] = (0, $0t.useToken)();
  return t ? `${e}-css-var` : "";
};
tb.default = O0t;
var Xp = {}, Vae = un.default;
Object.defineProperty(Xp, "__esModule", {
  value: !0
});
Xp.default = void 0;
var NB = Vae(D), P0t = Vae(Mu);
const M0t = (e) => {
  const t = NB.default.useContext(P0t.default);
  return NB.default.useMemo(() => e ? typeof e == "string" ? e ?? t : e instanceof Function ? e(t) : t : t, [e, t]);
};
Xp.default = M0t;
var bi = {};
const k0t = /* @__PURE__ */ bc(_Pe);
var Dk = {};
Object.defineProperty(Dk, "__esModule", {
  value: !0
});
Dk.default = N0t;
function N0t(e, t) {
  var n = Object.assign({}, e);
  return Array.isArray(t) && t.forEach(function(r) {
    delete n[r];
  }), n;
}
var D0t = un.default, L0t = gi.default;
Object.defineProperty(bi, "__esModule", {
  value: !0
});
bi.VariantContext = bi.NoStyleItemContext = bi.NoFormStyle = bi.FormProvider = bi.FormItemPrefixContext = bi.FormItemInputContext = bi.FormContext = void 0;
var Fw = L0t(D), Qp = Fw, j0t = k0t, F0t = D0t(Dk);
bi.FormContext = /* @__PURE__ */ Qp.createContext({
  labelAlign: "right",
  vertical: !1,
  itemRef: () => {
  }
});
bi.NoStyleItemContext = /* @__PURE__ */ Qp.createContext(null);
const V0t = (e) => {
  const t = (0, F0t.default)(e, ["prefixCls"]);
  return /* @__PURE__ */ Qp.createElement(j0t.FormProvider, Object.assign({}, t));
};
bi.FormProvider = V0t;
bi.FormItemPrefixContext = /* @__PURE__ */ Qp.createContext({
  prefixCls: ""
});
const H$ = bi.FormItemInputContext = /* @__PURE__ */ Qp.createContext({});
process.env.NODE_ENV !== "production" && (H$.displayName = "FormItemInputContext");
const B0t = (e) => {
  let {
    children: t,
    status: n,
    override: r
  } = e;
  const i = (0, Fw.useContext)(H$), o = (0, Fw.useMemo)(() => {
    const a = Object.assign({}, i);
    return r && delete a.isFormItemInput, n && (delete a.status, delete a.hasFeedback, delete a.feedbackIcon), a;
  }, [n, r, i]);
  return /* @__PURE__ */ Qp.createElement(H$.Provider, {
    value: o
  }, t);
};
bi.NoFormStyle = B0t;
bi.VariantContext = /* @__PURE__ */ (0, Fw.createContext)(void 0);
var nb = {};
Object.defineProperty(nb, "__esModule", {
  value: !0
});
nb.default = void 0;
var DB = D, z0t = bi, LB = qy;
const H0t = function(e, t) {
  let n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : void 0;
  var r, i;
  const {
    variant: o,
    [e]: a
  } = (0, DB.useContext)(LB.ConfigContext), s = (0, DB.useContext)(z0t.VariantContext), c = a == null ? void 0 : a.variant;
  let l;
  typeof t < "u" ? l = t : n === !1 ? l = "borderless" : l = (i = (r = s ?? c) !== null && r !== void 0 ? r : o) !== null && i !== void 0 ? i : "outlined";
  const u = LB.Variants.includes(l);
  return [l, u];
};
nb.default = H0t;
var Bae = {};
const U0t = /* @__PURE__ */ bc(ike);
var Jp = {};
Object.defineProperty(Jp, "__esModule", {
  value: !0
});
Jp.hasAddon = W0t;
Jp.hasPrefixSuffix = q0t;
Jp.resolveOnChange = G0t;
Jp.triggerFocus = K0t;
function W0t(e) {
  return !!(e.addonBefore || e.addonAfter);
}
function q0t(e) {
  return !!(e.prefix || e.suffix || e.allowClear);
}
function jB(e, t, n) {
  var r = t.cloneNode(!0), i = Object.create(e, {
    target: {
      value: r
    },
    currentTarget: {
      value: r
    }
  });
  return r.value = n, typeof t.selectionStart == "number" && typeof t.selectionEnd == "number" && (r.selectionStart = t.selectionStart, r.selectionEnd = t.selectionEnd), r.setSelectionRange = function() {
    t.setSelectionRange.apply(t, arguments);
  }, i;
}
function G0t(e, t, n, r) {
  if (n) {
    var i = t;
    if (t.type === "click") {
      i = jB(t, e, ""), n(i);
      return;
    }
    if (e.type !== "file" && r !== void 0) {
      i = jB(t, e, r), n(i);
      return;
    }
    n(i);
  }
}
function K0t(e, t) {
  if (e) {
    e.focus(t);
    var n = t || {}, r = n.cursor;
    if (r) {
      var i = e.value.length;
      switch (r) {
        case "start":
          e.setSelectionRange(0, 0);
          break;
        case "end":
          e.setSelectionRange(i, i);
          break;
        default:
          e.setSelectionRange(0, i);
      }
    }
  }
}
var Ko = {}, zae = un.default;
Object.defineProperty(Ko, "__esModule", {
  value: !0
});
Ko.useComposeRef = Ko.supportRef = Ko.supportNodeRef = Ko.getNodeRef = Ko.fillRef = Ko.composeRef = void 0;
var Y0t = zae(Uf), Hae = D, n_ = Ld, X0t = zae(Gy), Q0t = Ko.fillRef = function(t, n) {
  typeof t == "function" ? t(n) : (0, Y0t.default)(t) === "object" && t && "current" in t && (t.current = n);
}, J0t = Ko.composeRef = function() {
  for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++)
    n[r] = arguments[r];
  var i = n.filter(Boolean);
  return i.length <= 1 ? i[0] : function(o) {
    n.forEach(function(a) {
      Q0t(a, o);
    });
  };
};
Ko.useComposeRef = function() {
  for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++)
    n[r] = arguments[r];
  return (0, X0t.default)(function() {
    return J0t.apply(void 0, n);
  }, n, function(i, o) {
    return i.length !== o.length || i.every(function(a, s) {
      return a !== o[s];
    });
  });
};
var Z0t = Ko.supportRef = function(t) {
  var n, r, i = (0, n_.isMemo)(t) ? t.type.type : t.type;
  return !(typeof i == "function" && !((n = i.prototype) !== null && n !== void 0 && n.render) && i.$$typeof !== n_.ForwardRef || typeof t == "function" && !((r = t.prototype) !== null && r !== void 0 && r.render) && t.$$typeof !== n_.ForwardRef);
};
function U$(e) {
  return /* @__PURE__ */ (0, Hae.isValidElement)(e) && !(0, n_.isFragment)(e);
}
Ko.supportNodeRef = function(t) {
  return U$(t) && Z0t(t);
};
Ko.getNodeRef = Number(Hae.version.split(".")[0]) >= 19 ? (
  // >= React 19
  function(e) {
    return U$(e) ? e.props.ref : null;
  }
) : (
  // < React 19
  function(e) {
    return U$(e) ? e.ref : null;
  }
);
var b2 = {}, hs = {}, Lk = {}, evt = un.default;
Object.defineProperty(Lk, "__esModule", {
  value: !0
});
Lk.default = W$;
var tvt = evt(D), nvt = Ld;
function W$(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, n = [];
  return tvt.default.Children.forEach(e, function(r) {
    r == null && !t.keepEmpty || (Array.isArray(r) ? n = n.concat(W$(r)) : (0, nvt.isFragment)(r) && r.props ? n = n.concat(W$(r.props.children, t)) : n.push(r));
  }), n;
}
var np = {}, _2 = {};
Object.defineProperty(_2, "__esModule", {
  value: !0
});
_2.default = void 0;
const rvt = (e) => {
  const {
    componentCls: t
  } = e;
  return {
    [t]: {
      "&-block": {
        display: "flex",
        width: "100%"
      },
      "&-vertical": {
        flexDirection: "column"
      }
    }
  };
};
_2.default = rvt;
var ivt = un.default;
Object.defineProperty(np, "__esModule", {
  value: !0
});
np.prepareComponentToken = np.default = void 0;
var FB = _l, ovt = ivt(_2);
const avt = (e) => {
  const {
    componentCls: t,
    antCls: n
  } = e;
  return {
    [t]: {
      display: "inline-flex",
      "&-rtl": {
        direction: "rtl"
      },
      "&-vertical": {
        flexDirection: "column"
      },
      "&-align": {
        flexDirection: "column",
        "&-center": {
          alignItems: "center"
        },
        "&-start": {
          alignItems: "flex-start"
        },
        "&-end": {
          alignItems: "flex-end"
        },
        "&-baseline": {
          alignItems: "baseline"
        }
      },
      [`${t}-item:empty`]: {
        display: "none"
      },
      // https://github.com/ant-design/ant-design/issues/47875
      [`${t}-item > ${n}-badge-not-a-wrapper:only-child`]: {
        display: "block"
      }
    }
  };
}, svt = (e) => {
  const {
    componentCls: t
  } = e;
  return {
    [t]: {
      "&-gap-row-small": {
        rowGap: e.spaceGapSmallSize
      },
      "&-gap-row-middle": {
        rowGap: e.spaceGapMiddleSize
      },
      "&-gap-row-large": {
        rowGap: e.spaceGapLargeSize
      },
      "&-gap-col-small": {
        columnGap: e.spaceGapSmallSize
      },
      "&-gap-col-middle": {
        columnGap: e.spaceGapMiddleSize
      },
      "&-gap-col-large": {
        columnGap: e.spaceGapLargeSize
      }
    }
  };
}, cvt = () => ({});
np.prepareComponentToken = cvt;
np.default = (0, FB.genStyleHooks)("Space", (e) => {
  const t = (0, FB.mergeToken)(e, {
    spaceGapSmallSize: e.paddingXS,
    spaceGapMiddleSize: e.padding,
    spaceGapLargeSize: e.paddingLG
  });
  return [avt(t), svt(t), (0, ovt.default)(t)];
}, () => ({}), {
  // Space component don't apply extra font style
  // https://github.com/ant-design/ant-design/issues/40315
  resetStyle: !1
});
var S2 = un.default, lvt = gi.default;
Object.defineProperty(hs, "__esModule", {
  value: !0
});
hs.useCompactItemContext = hs.default = hs.SpaceCompactItemContext = hs.NoCompactStyle = void 0;
var Gs = lvt(D), Uae = S2(Sp), uvt = S2(Lk), dvt = qy, fvt = S2(Xp), hvt = S2(np), Wae = function(e, t) {
  var n = {};
  for (var r in e)
    Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var i = 0, r = Object.getOwnPropertySymbols(e); i < r.length; i++)
      t.indexOf(r[i]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[i]) && (n[r[i]] = e[r[i]]);
  return n;
};
const w2 = hs.SpaceCompactItemContext = /* @__PURE__ */ Gs.createContext(null), gvt = (e, t) => {
  const n = Gs.useContext(w2), r = Gs.useMemo(() => {
    if (!n)
      return "";
    const {
      compactDirection: i,
      isFirstItem: o,
      isLastItem: a
    } = n, s = i === "vertical" ? "-vertical-" : "-";
    return (0, Uae.default)(`${e}-compact${s}item`, {
      [`${e}-compact${s}first-item`]: o,
      [`${e}-compact${s}last-item`]: a,
      [`${e}-compact${s}item-rtl`]: t === "rtl"
    });
  }, [e, t, n]);
  return {
    compactSize: n == null ? void 0 : n.compactSize,
    compactDirection: n == null ? void 0 : n.compactDirection,
    compactItemClassnames: r
  };
};
hs.useCompactItemContext = gvt;
const pvt = (e) => {
  let {
    children: t
  } = e;
  return /* @__PURE__ */ Gs.createElement(w2.Provider, {
    value: null
  }, t);
};
hs.NoCompactStyle = pvt;
const mvt = (e) => {
  var {
    children: t
  } = e, n = Wae(e, ["children"]);
  return /* @__PURE__ */ Gs.createElement(w2.Provider, {
    value: n
  }, t);
}, vvt = (e) => {
  const {
    getPrefixCls: t,
    direction: n
  } = Gs.useContext(dvt.ConfigContext), {
    size: r,
    direction: i,
    block: o,
    prefixCls: a,
    className: s,
    rootClassName: c,
    children: l
  } = e, u = Wae(e, ["size", "direction", "block", "prefixCls", "className", "rootClassName", "children"]), d = (0, fvt.default)((S) => r ?? S), f = t("space-compact", a), [h, p] = (0, hvt.default)(f), g = (0, Uae.default)(f, p, {
    [`${f}-rtl`]: n === "rtl",
    [`${f}-block`]: o,
    [`${f}-vertical`]: i === "vertical"
  }, s, c), m = Gs.useContext(w2), v = (0, uvt.default)(l), y = Gs.useMemo(() => v.map((S, _) => {
    const w = (S == null ? void 0 : S.key) || `${f}-item-${_}`;
    return /* @__PURE__ */ Gs.createElement(mvt, {
      key: w,
      compactSize: d,
      compactDirection: i,
      isFirstItem: _ === 0 && (!m || (m == null ? void 0 : m.isFirstItem)),
      isLastItem: _ === v.length - 1 && (!m || (m == null ? void 0 : m.isLastItem))
    }, S);
  }), [r, v, m]);
  return v.length === 0 ? null : h(/* @__PURE__ */ Gs.createElement("div", Object.assign({
    className: g
  }, u), y));
};
hs.default = vvt;
var yvt = un.default;
Object.defineProperty(b2, "__esModule", {
  value: !0
});
b2.default = void 0;
var VB = yvt(D), bvt = bi, _vt = hs;
const Svt = (e) => {
  const {
    space: t,
    form: n,
    children: r
  } = e;
  if (r == null)
    return null;
  let i = r;
  return n && (i = /* @__PURE__ */ VB.default.createElement(bvt.NoFormStyle, {
    override: !0,
    status: !0
  }, i)), t && (i = /* @__PURE__ */ VB.default.createElement(_vt.NoCompactStyle, null, i)), i;
};
b2.default = Svt;
var jk = {};
Object.defineProperty(jk, "__esModule", {
  value: !0
});
jk.default = wvt;
var BB = D;
function wvt(e, t) {
  const n = (0, BB.useRef)([]), r = () => {
    n.current.push(setTimeout(() => {
      var i, o, a, s;
      !((i = e.current) === null || i === void 0) && i.input && ((o = e.current) === null || o === void 0 ? void 0 : o.input.getAttribute("type")) === "password" && (!((a = e.current) === null || a === void 0) && a.input.hasAttribute("value")) && ((s = e.current) === null || s === void 0 || s.input.removeAttribute("value"));
    }));
  };
  return (0, BB.useEffect)(() => (t && r(), () => n.current.forEach((i) => {
    i && clearTimeout(i);
  })), []), r;
}
var Fk = {}, Vk = {};
Object.defineProperty(Vk, "__esModule", {
  value: !0
});
Vk.genCompactItemStyle = Cvt;
function xvt(e, t, n) {
  const {
    focusElCls: r,
    focus: i,
    borderElCls: o
  } = n, a = o ? "> *" : "", s = ["hover", i ? "focus" : null, "active"].filter(Boolean).map((c) => `&:${c} ${a}`).join(",");
  return {
    [`&-item:not(${t}-last-item)`]: {
      marginInlineEnd: e.calc(e.lineWidth).mul(-1).equal()
    },
    "&-item": Object.assign(Object.assign({
      [s]: {
        zIndex: 2
      }
    }, r ? {
      [`&${r}`]: {
        zIndex: 2
      }
    } : {}), {
      [`&[disabled] ${a}`]: {
        zIndex: 0
      }
    })
  };
}
function Evt(e, t, n) {
  const {
    borderElCls: r
  } = n, i = r ? `> ${r}` : "";
  return {
    [`&-item:not(${t}-first-item):not(${t}-last-item) ${i}`]: {
      borderRadius: 0
    },
    [`&-item:not(${t}-last-item)${t}-first-item`]: {
      [`& ${i}, &${e}-sm ${i}, &${e}-lg ${i}`]: {
        borderStartEndRadius: 0,
        borderEndEndRadius: 0
      }
    },
    [`&-item:not(${t}-first-item)${t}-last-item`]: {
      [`& ${i}, &${e}-sm ${i}, &${e}-lg ${i}`]: {
        borderStartStartRadius: 0,
        borderEndStartRadius: 0
      }
    }
  };
}
function Cvt(e) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
    focus: !0
  };
  const {
    componentCls: n
  } = e, r = `${n}-compact`;
  return {
    [r]: Object.assign(Object.assign({}, xvt(e, r, t)), Evt(n, r, t))
  };
}
var rb = {};
Object.defineProperty(rb, "__esModule", {
  value: !0
});
rb.initComponentToken = void 0;
rb.initInputToken = Ivt;
var Tvt = _l;
function Ivt(e) {
  return (0, Tvt.mergeToken)(e, {
    inputAffixPadding: e.paddingXXS
  });
}
const Avt = (e) => {
  const {
    controlHeight: t,
    fontSize: n,
    lineHeight: r,
    lineWidth: i,
    controlHeightSM: o,
    controlHeightLG: a,
    fontSizeLG: s,
    lineHeightLG: c,
    paddingSM: l,
    controlPaddingHorizontalSM: u,
    controlPaddingHorizontal: d,
    colorFillAlter: f,
    colorPrimaryHover: h,
    colorPrimary: p,
    controlOutlineWidth: g,
    controlOutline: m,
    colorErrorOutline: v,
    colorWarningOutline: y,
    colorBgContainer: S
  } = e;
  return {
    paddingBlock: Math.max(Math.round((t - n * r) / 2 * 10) / 10 - i, 0),
    paddingBlockSM: Math.max(Math.round((o - n * r) / 2 * 10) / 10 - i, 0),
    paddingBlockLG: Math.ceil((a - s * c) / 2 * 10) / 10 - i,
    paddingInline: l - i,
    paddingInlineSM: u - i,
    paddingInlineLG: d - i,
    addonBg: f,
    activeBorderColor: p,
    hoverBorderColor: h,
    activeShadow: `0 0 0 ${g}px ${m}`,
    errorActiveShadow: `0 0 0 ${g}px ${v}`,
    warningActiveShadow: `0 0 0 ${g}px ${y}`,
    hoverBg: S,
    activeBg: S,
    inputFontSize: n,
    inputFontSizeLG: s,
    inputFontSizeSM: n
  };
};
rb.initComponentToken = Avt;
var Ri = {};
Object.defineProperty(Ri, "__esModule", {
  value: !0
});
Ri.genOutlinedStyle = Ri.genOutlinedGroupStyle = Ri.genHoverStyle = Ri.genFilledStyle = Ri.genFilledGroupStyle = Ri.genDisabledStyle = Ri.genBorderlessStyle = Ri.genBaseOutlinedStyle = void 0;
var Nc = Qu, Rvt = _l;
const qae = (e) => ({
  borderColor: e.hoverBorderColor,
  backgroundColor: e.hoverBg
});
Ri.genHoverStyle = qae;
const x2 = (e) => ({
  color: e.colorTextDisabled,
  backgroundColor: e.colorBgContainerDisabled,
  borderColor: e.colorBorder,
  boxShadow: "none",
  cursor: "not-allowed",
  opacity: 1,
  "input[disabled], textarea[disabled]": {
    cursor: "not-allowed"
  },
  "&:hover:not([disabled])": Object.assign({}, qae((0, Rvt.mergeToken)(e, {
    hoverBorderColor: e.colorBorder,
    hoverBg: e.colorBgContainerDisabled
  })))
});
Ri.genDisabledStyle = x2;
const Bk = (e, t) => ({
  background: e.colorBgContainer,
  borderWidth: e.lineWidth,
  borderStyle: e.lineType,
  borderColor: t.borderColor,
  "&:hover": {
    borderColor: t.hoverBorderColor,
    backgroundColor: e.hoverBg
  },
  "&:focus, &:focus-within": {
    borderColor: t.activeBorderColor,
    boxShadow: t.activeShadow,
    outline: 0,
    backgroundColor: e.activeBg
  }
});
Ri.genBaseOutlinedStyle = Bk;
const zB = (e, t) => ({
  [`&${e.componentCls}-status-${t.status}:not(${e.componentCls}-disabled)`]: Object.assign(Object.assign({}, Bk(e, t)), {
    [`${e.componentCls}-prefix, ${e.componentCls}-suffix`]: {
      color: t.affixColor
    }
  }),
  [`&${e.componentCls}-status-${t.status}${e.componentCls}-disabled`]: {
    borderColor: t.borderColor
  }
}), $vt = (e, t) => ({
  "&-outlined": Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, Bk(e, {
    borderColor: e.colorBorder,
    hoverBorderColor: e.hoverBorderColor,
    activeBorderColor: e.activeBorderColor,
    activeShadow: e.activeShadow
  })), {
    [`&${e.componentCls}-disabled, &[disabled]`]: Object.assign({}, x2(e))
  }), zB(e, {
    status: "error",
    borderColor: e.colorError,
    hoverBorderColor: e.colorErrorBorderHover,
    activeBorderColor: e.colorError,
    activeShadow: e.errorActiveShadow,
    affixColor: e.colorError
  })), zB(e, {
    status: "warning",
    borderColor: e.colorWarning,
    hoverBorderColor: e.colorWarningBorderHover,
    activeBorderColor: e.colorWarning,
    activeShadow: e.warningActiveShadow,
    affixColor: e.colorWarning
  })), t)
});
Ri.genOutlinedStyle = $vt;
const HB = (e, t) => ({
  [`&${e.componentCls}-group-wrapper-status-${t.status}`]: {
    [`${e.componentCls}-group-addon`]: {
      borderColor: t.addonBorderColor,
      color: t.addonColor
    }
  }
}), Ovt = (e) => ({
  "&-outlined": Object.assign(Object.assign(Object.assign({
    [`${e.componentCls}-group`]: {
      "&-addon": {
        background: e.addonBg,
        border: `${(0, Nc.unit)(e.lineWidth)} ${e.lineType} ${e.colorBorder}`
      },
      "&-addon:first-child": {
        borderInlineEnd: 0
      },
      "&-addon:last-child": {
        borderInlineStart: 0
      }
    }
  }, HB(e, {
    status: "error",
    addonBorderColor: e.colorError,
    addonColor: e.colorErrorText
  })), HB(e, {
    status: "warning",
    addonBorderColor: e.colorWarning,
    addonColor: e.colorWarningText
  })), {
    [`&${e.componentCls}-group-wrapper-disabled`]: {
      [`${e.componentCls}-group-addon`]: Object.assign({}, x2(e))
    }
  })
});
Ri.genOutlinedGroupStyle = Ovt;
const Pvt = (e, t) => {
  const {
    componentCls: n
  } = e;
  return {
    "&-borderless": Object.assign({
      background: "transparent",
      border: "none",
      "&:focus, &:focus-within": {
        outline: "none"
      },
      // >>>>> Disabled
      [`&${n}-disabled, &[disabled]`]: {
        color: e.colorTextDisabled,
        cursor: "not-allowed"
      },
      // >>>>> Status
      [`&${n}-status-error`]: {
        "&, & input, & textarea": {
          color: e.colorError
        }
      },
      [`&${n}-status-warning`]: {
        "&, & input, & textarea": {
          color: e.colorWarning
        }
      }
    }, t)
  };
};
Ri.genBorderlessStyle = Pvt;
const Gae = (e, t) => ({
  background: t.bg,
  borderWidth: e.lineWidth,
  borderStyle: e.lineType,
  borderColor: "transparent",
  "input&, & input, textarea&, & textarea": {
    color: t == null ? void 0 : t.inputColor
  },
  "&:hover": {
    background: t.hoverBg
  },
  "&:focus, &:focus-within": {
    outline: 0,
    borderColor: t.activeBorderColor,
    backgroundColor: e.activeBg
  }
}), UB = (e, t) => ({
  [`&${e.componentCls}-status-${t.status}:not(${e.componentCls}-disabled)`]: Object.assign(Object.assign({}, Gae(e, t)), {
    [`${e.componentCls}-prefix, ${e.componentCls}-suffix`]: {
      color: t.affixColor
    }
  })
}), Mvt = (e, t) => ({
  "&-filled": Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, Gae(e, {
    bg: e.colorFillTertiary,
    hoverBg: e.colorFillSecondary,
    activeBorderColor: e.activeBorderColor
  })), {
    [`&${e.componentCls}-disabled, &[disabled]`]: Object.assign({}, x2(e))
  }), UB(e, {
    status: "error",
    bg: e.colorErrorBg,
    hoverBg: e.colorErrorBgHover,
    activeBorderColor: e.colorError,
    inputColor: e.colorErrorText,
    affixColor: e.colorError
  })), UB(e, {
    status: "warning",
    bg: e.colorWarningBg,
    hoverBg: e.colorWarningBgHover,
    activeBorderColor: e.colorWarning,
    inputColor: e.colorWarningText,
    affixColor: e.colorWarning
  })), t)
});
Ri.genFilledStyle = Mvt;
const WB = (e, t) => ({
  [`&${e.componentCls}-group-wrapper-status-${t.status}`]: {
    [`${e.componentCls}-group-addon`]: {
      background: t.addonBg,
      color: t.addonColor
    }
  }
}), kvt = (e) => ({
  "&-filled": Object.assign(Object.assign(Object.assign({
    [`${e.componentCls}-group`]: {
      "&-addon": {
        background: e.colorFillTertiary
      },
      [`${e.componentCls}-filled:not(:focus):not(:focus-within)`]: {
        "&:not(:first-child)": {
          borderInlineStart: `${(0, Nc.unit)(e.lineWidth)} ${e.lineType} ${e.colorSplit}`
        },
        "&:not(:last-child)": {
          borderInlineEnd: `${(0, Nc.unit)(e.lineWidth)} ${e.lineType} ${e.colorSplit}`
        }
      }
    }
  }, WB(e, {
    status: "error",
    addonBg: e.colorErrorBg,
    addonColor: e.colorErrorText
  })), WB(e, {
    status: "warning",
    addonBg: e.colorWarningBg,
    addonColor: e.colorWarningText
  })), {
    [`&${e.componentCls}-group-wrapper-disabled`]: {
      [`${e.componentCls}-group`]: {
        "&-addon": {
          background: e.colorFillTertiary,
          color: e.colorTextDisabled
        },
        "&-addon:first-child": {
          borderInlineStart: `${(0, Nc.unit)(e.lineWidth)} ${e.lineType} ${e.colorBorder}`,
          borderTop: `${(0, Nc.unit)(e.lineWidth)} ${e.lineType} ${e.colorBorder}`,
          borderBottom: `${(0, Nc.unit)(e.lineWidth)} ${e.lineType} ${e.colorBorder}`
        },
        "&-addon:last-child": {
          borderInlineEnd: `${(0, Nc.unit)(e.lineWidth)} ${e.lineType} ${e.colorBorder}`,
          borderTop: `${(0, Nc.unit)(e.lineWidth)} ${e.lineType} ${e.colorBorder}`,
          borderBottom: `${(0, Nc.unit)(e.lineWidth)} ${e.lineType} ${e.colorBorder}`
        }
      }
    }
  })
});
Ri.genFilledGroupStyle = kvt;
(function(e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.genPlaceholderStyle = e.genInputSmallStyle = e.genInputGroupStyle = e.genBasicInputStyle = e.genActiveStyle = e.default = void 0, Object.defineProperty(e, "initComponentToken", {
    enumerable: !0,
    get: function() {
      return o.initComponentToken;
    }
  }), Object.defineProperty(e, "initInputToken", {
    enumerable: !0,
    get: function() {
      return o.initInputToken;
    }
  });
  var t = Qu, n = Wr, r = Vk, i = _l, o = rb, a = Ri;
  const s = (_) => ({
    // Firefox
    "&::-moz-placeholder": {
      opacity: 1
    },
    "&::placeholder": {
      color: _,
      userSelect: "none"
      // https://github.com/ant-design/ant-design/pull/32639
    },
    "&:placeholder-shown": {
      textOverflow: "ellipsis"
    }
  });
  e.genPlaceholderStyle = s;
  const c = (_) => ({
    borderColor: _.activeBorderColor,
    boxShadow: _.activeShadow,
    outline: 0,
    backgroundColor: _.activeBg
  });
  e.genActiveStyle = c;
  const l = (_) => {
    const {
      paddingBlockLG: w,
      lineHeightLG: T,
      borderRadiusLG: x,
      paddingInlineLG: C
    } = _;
    return {
      padding: `${(0, t.unit)(w)} ${(0, t.unit)(C)}`,
      fontSize: _.inputFontSizeLG,
      lineHeight: T,
      borderRadius: x
    };
  }, u = (_) => ({
    padding: `${(0, t.unit)(_.paddingBlockSM)} ${(0, t.unit)(_.paddingInlineSM)}`,
    fontSize: _.inputFontSizeSM,
    borderRadius: _.borderRadiusSM
  });
  e.genInputSmallStyle = u;
  const d = (_) => Object.assign(Object.assign({
    position: "relative",
    display: "inline-block",
    width: "100%",
    minWidth: 0,
    padding: `${(0, t.unit)(_.paddingBlock)} ${(0, t.unit)(_.paddingInline)}`,
    color: _.colorText,
    fontSize: _.inputFontSize,
    lineHeight: _.lineHeight,
    borderRadius: _.borderRadius,
    transition: `all ${_.motionDurationMid}`
  }, s(_.colorTextPlaceholder)), {
    // Reset height for `textarea`s
    "textarea&": {
      maxWidth: "100%",
      // prevent textarea resize from coming out of its container
      height: "auto",
      minHeight: _.controlHeight,
      lineHeight: _.lineHeight,
      verticalAlign: "bottom",
      transition: `all ${_.motionDurationSlow}, height 0s`,
      resize: "vertical"
    },
    // Size
    "&-lg": Object.assign({}, l(_)),
    "&-sm": Object.assign({}, u(_)),
    // RTL
    "&-rtl, &-textarea-rtl": {
      direction: "rtl"
    }
  });
  e.genBasicInputStyle = d;
  const f = (_) => {
    const {
      componentCls: w,
      antCls: T
    } = _;
    return {
      position: "relative",
      display: "table",
      width: "100%",
      borderCollapse: "separate",
      borderSpacing: 0,
      // Undo padding and float of grid classes
      "&[class*='col-']": {
        paddingInlineEnd: _.paddingXS,
        "&:last-child": {
          paddingInlineEnd: 0
        }
      },
      // Sizing options
      [`&-lg ${w}, &-lg > ${w}-group-addon`]: Object.assign({}, l(_)),
      [`&-sm ${w}, &-sm > ${w}-group-addon`]: Object.assign({}, u(_)),
      // Fix https://github.com/ant-design/ant-design/issues/5754
      [`&-lg ${T}-select-single ${T}-select-selector`]: {
        height: _.controlHeightLG
      },
      [`&-sm ${T}-select-single ${T}-select-selector`]: {
        height: _.controlHeightSM
      },
      [`> ${w}`]: {
        display: "table-cell",
        "&:not(:first-child):not(:last-child)": {
          borderRadius: 0
        }
      },
      [`${w}-group`]: {
        "&-addon, &-wrap": {
          display: "table-cell",
          width: 1,
          whiteSpace: "nowrap",
          verticalAlign: "middle",
          "&:not(:first-child):not(:last-child)": {
            borderRadius: 0
          }
        },
        "&-wrap > *": {
          display: "block !important"
        },
        "&-addon": {
          position: "relative",
          padding: `0 ${(0, t.unit)(_.paddingInline)}`,
          color: _.colorText,
          fontWeight: "normal",
          fontSize: _.inputFontSize,
          textAlign: "center",
          borderRadius: _.borderRadius,
          transition: `all ${_.motionDurationSlow}`,
          lineHeight: 1,
          // Reset Select's style in addon
          [`${T}-select`]: {
            margin: `${(0, t.unit)(_.calc(_.paddingBlock).add(1).mul(-1).equal())} ${(0, t.unit)(_.calc(_.paddingInline).mul(-1).equal())}`,
            [`&${T}-select-single:not(${T}-select-customize-input):not(${T}-pagination-size-changer)`]: {
              [`${T}-select-selector`]: {
                backgroundColor: "inherit",
                border: `${(0, t.unit)(_.lineWidth)} ${_.lineType} transparent`,
                boxShadow: "none"
              }
            }
          },
          // https://github.com/ant-design/ant-design/issues/31333
          [`${T}-cascader-picker`]: {
            margin: `-9px ${(0, t.unit)(_.calc(_.paddingInline).mul(-1).equal())}`,
            backgroundColor: "transparent",
            [`${T}-cascader-input`]: {
              textAlign: "start",
              border: 0,
              boxShadow: "none"
            }
          }
        }
      },
      [w]: {
        width: "100%",
        marginBottom: 0,
        textAlign: "inherit",
        "&:focus": {
          zIndex: 1,
          // Fix https://gw.alipayobjects.com/zos/rmsportal/DHNpoqfMXSfrSnlZvhsJ.png
          borderInlineEndWidth: 1
        },
        "&:hover": {
          zIndex: 1,
          borderInlineEndWidth: 1,
          [`${w}-search-with-button &`]: {
            zIndex: 0
          }
        }
      },
      // Reset rounded corners
      [`> ${w}:first-child, ${w}-group-addon:first-child`]: {
        borderStartEndRadius: 0,
        borderEndEndRadius: 0,
        // Reset Select's style in addon
        [`${T}-select ${T}-select-selector`]: {
          borderStartEndRadius: 0,
          borderEndEndRadius: 0
        }
      },
      [`> ${w}-affix-wrapper`]: {
        [`&:not(:first-child) ${w}`]: {
          borderStartStartRadius: 0,
          borderEndStartRadius: 0
        },
        [`&:not(:last-child) ${w}`]: {
          borderStartEndRadius: 0,
          borderEndEndRadius: 0
        }
      },
      [`> ${w}:last-child, ${w}-group-addon:last-child`]: {
        borderStartStartRadius: 0,
        borderEndStartRadius: 0,
        // Reset Select's style in addon
        [`${T}-select ${T}-select-selector`]: {
          borderStartStartRadius: 0,
          borderEndStartRadius: 0
        }
      },
      [`${w}-affix-wrapper`]: {
        "&:not(:last-child)": {
          borderStartEndRadius: 0,
          borderEndEndRadius: 0,
          [`${w}-search &`]: {
            borderStartStartRadius: _.borderRadius,
            borderEndStartRadius: _.borderRadius
          }
        },
        [`&:not(:first-child), ${w}-search &:not(:first-child)`]: {
          borderStartStartRadius: 0,
          borderEndStartRadius: 0
        }
      },
      [`&${w}-group-compact`]: Object.assign(Object.assign({
        display: "block"
      }, (0, n.clearFix)()), {
        [`${w}-group-addon, ${w}-group-wrap, > ${w}`]: {
          "&:not(:first-child):not(:last-child)": {
            borderInlineEndWidth: _.lineWidth,
            "&:hover, &:focus": {
              zIndex: 1
            }
          }
        },
        "& > *": {
          display: "inline-flex",
          float: "none",
          verticalAlign: "top",
          // https://github.com/ant-design/ant-design-pro/issues/139
          borderRadius: 0
        },
        [`
        & > ${w}-affix-wrapper,
        & > ${w}-number-affix-wrapper,
        & > ${T}-picker-range
      `]: {
          display: "inline-flex"
        },
        "& > *:not(:last-child)": {
          marginInlineEnd: _.calc(_.lineWidth).mul(-1).equal(),
          borderInlineEndWidth: _.lineWidth
        },
        // Undo float for .ant-input-group .ant-input
        [w]: {
          float: "none"
        },
        // reset border for Select, DatePicker, AutoComplete, Cascader, Mention, TimePicker, Input
        [`& > ${T}-select > ${T}-select-selector,
      & > ${T}-select-auto-complete ${w},
      & > ${T}-cascader-picker ${w},
      & > ${w}-group-wrapper ${w}`]: {
          borderInlineEndWidth: _.lineWidth,
          borderRadius: 0,
          "&:hover, &:focus": {
            zIndex: 1
          }
        },
        [`& > ${T}-select-focused`]: {
          zIndex: 1
        },
        // update z-index for arrow icon
        [`& > ${T}-select > ${T}-select-arrow`]: {
          zIndex: 1
          // https://github.com/ant-design/ant-design/issues/20371
        },
        [`& > *:first-child,
      & > ${T}-select:first-child > ${T}-select-selector,
      & > ${T}-select-auto-complete:first-child ${w},
      & > ${T}-cascader-picker:first-child ${w}`]: {
          borderStartStartRadius: _.borderRadius,
          borderEndStartRadius: _.borderRadius
        },
        [`& > *:last-child,
      & > ${T}-select:last-child > ${T}-select-selector,
      & > ${T}-cascader-picker:last-child ${w},
      & > ${T}-cascader-picker-focused:last-child ${w}`]: {
          borderInlineEndWidth: _.lineWidth,
          borderStartEndRadius: _.borderRadius,
          borderEndEndRadius: _.borderRadius
        },
        // https://github.com/ant-design/ant-design/issues/12493
        [`& > ${T}-select-auto-complete ${w}`]: {
          verticalAlign: "top"
        },
        [`${w}-group-wrapper + ${w}-group-wrapper`]: {
          marginInlineStart: _.calc(_.lineWidth).mul(-1).equal(),
          [`${w}-affix-wrapper`]: {
            borderRadius: 0
          }
        },
        [`${w}-group-wrapper:not(:last-child)`]: {
          [`&${w}-search > ${w}-group`]: {
            [`& > ${w}-group-addon > ${w}-search-button`]: {
              borderRadius: 0
            },
            [`& > ${w}`]: {
              borderStartStartRadius: _.borderRadius,
              borderStartEndRadius: 0,
              borderEndEndRadius: 0,
              borderEndStartRadius: _.borderRadius
            }
          }
        }
      })
    };
  };
  e.genInputGroupStyle = f;
  const h = (_) => {
    const {
      componentCls: w,
      controlHeightSM: T,
      lineWidth: x,
      calc: C
    } = _, E = 16, R = C(T).sub(C(x).mul(2)).sub(E).div(2).equal();
    return {
      [w]: Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, (0, n.resetComponent)(_)), d(_)), (0, a.genOutlinedStyle)(_)), (0, a.genFilledStyle)(_)), (0, a.genBorderlessStyle)(_)), {
        '&[type="color"]': {
          height: _.controlHeight,
          [`&${w}-lg`]: {
            height: _.controlHeightLG
          },
          [`&${w}-sm`]: {
            height: T,
            paddingTop: R,
            paddingBottom: R
          }
        },
        '&[type="search"]::-webkit-search-cancel-button, &[type="search"]::-webkit-search-decoration': {
          "-webkit-appearance": "none"
        }
      })
    };
  }, p = (_) => {
    const {
      componentCls: w
    } = _;
    return {
      // ========================= Input =========================
      [`${w}-clear-icon`]: {
        margin: 0,
        color: _.colorTextQuaternary,
        fontSize: _.fontSizeIcon,
        verticalAlign: -1,
        // https://github.com/ant-design/ant-design/pull/18151
        // https://codesandbox.io/s/wizardly-sun-u10br
        cursor: "pointer",
        transition: `color ${_.motionDurationSlow}`,
        "&:hover": {
          color: _.colorTextTertiary
        },
        "&:active": {
          color: _.colorText
        },
        "&-hidden": {
          visibility: "hidden"
        },
        "&-has-suffix": {
          margin: `0 ${(0, t.unit)(_.inputAffixPadding)}`
        }
      }
    };
  }, g = (_) => {
    const {
      componentCls: w,
      inputAffixPadding: T,
      colorTextDescription: x,
      motionDurationSlow: C,
      colorIcon: E,
      colorIconHover: R,
      iconCls: A
    } = _, O = `${w}-affix-wrapper`, $ = `${w}-affix-wrapper-disabled`;
    return {
      [O]: Object.assign(Object.assign(Object.assign(Object.assign({}, d(_)), {
        display: "inline-flex",
        [`&:not(${w}-disabled):hover`]: {
          zIndex: 1,
          [`${w}-search-with-button &`]: {
            zIndex: 0
          }
        },
        "&-focused, &:focus": {
          zIndex: 1
        },
        [`> input${w}`]: {
          padding: 0
        },
        [`> input${w}, > textarea${w}`]: {
          fontSize: "inherit",
          border: "none",
          borderRadius: 0,
          outline: "none",
          background: "transparent",
          color: "inherit",
          "&::-ms-reveal": {
            display: "none"
          },
          "&:focus": {
            boxShadow: "none !important"
          }
        },
        "&::before": {
          display: "inline-block",
          width: 0,
          visibility: "hidden",
          content: '"\\a0"'
        },
        [w]: {
          "&-prefix, &-suffix": {
            display: "flex",
            flex: "none",
            alignItems: "center",
            "> *:not(:last-child)": {
              marginInlineEnd: _.paddingXS
            }
          },
          "&-show-count-suffix": {
            color: x
          },
          "&-show-count-has-suffix": {
            marginInlineEnd: _.paddingXXS
          },
          "&-prefix": {
            marginInlineEnd: T
          },
          "&-suffix": {
            marginInlineStart: T
          }
        }
      }), p(_)), {
        // password
        [`${A}${w}-password-icon`]: {
          color: E,
          cursor: "pointer",
          transition: `all ${C}`,
          "&:hover": {
            color: R
          }
        }
      }),
      [$]: {
        // password disabled
        [`${A}${w}-password-icon`]: {
          color: E,
          cursor: "not-allowed",
          "&:hover": {
            color: E
          }
        }
      }
    };
  }, m = (_) => {
    const {
      componentCls: w,
      borderRadiusLG: T,
      borderRadiusSM: x
    } = _;
    return {
      [`${w}-group`]: Object.assign(Object.assign(Object.assign({}, (0, n.resetComponent)(_)), f(_)), {
        "&-rtl": {
          direction: "rtl"
        },
        "&-wrapper": Object.assign(Object.assign(Object.assign({
          display: "inline-block",
          width: "100%",
          textAlign: "start",
          verticalAlign: "top",
          "&-rtl": {
            direction: "rtl"
          },
          // Size
          "&-lg": {
            [`${w}-group-addon`]: {
              borderRadius: T,
              fontSize: _.inputFontSizeLG
            }
          },
          "&-sm": {
            [`${w}-group-addon`]: {
              borderRadius: x
            }
          }
        }, (0, a.genOutlinedGroupStyle)(_)), (0, a.genFilledGroupStyle)(_)), {
          // '&-disabled': {
          //   [`${componentCls}-group-addon`]: {
          //     ...genDisabledStyle(token),
          //   },
          // },
          // Fix the issue of using icons in Space Compact mode
          // https://github.com/ant-design/ant-design/issues/42122
          [`&:not(${w}-compact-first-item):not(${w}-compact-last-item)${w}-compact-item`]: {
            [`${w}, ${w}-group-addon`]: {
              borderRadius: 0
            }
          },
          [`&:not(${w}-compact-last-item)${w}-compact-first-item`]: {
            [`${w}, ${w}-group-addon`]: {
              borderStartEndRadius: 0,
              borderEndEndRadius: 0
            }
          },
          [`&:not(${w}-compact-first-item)${w}-compact-last-item`]: {
            [`${w}, ${w}-group-addon`]: {
              borderStartStartRadius: 0,
              borderEndStartRadius: 0
            }
          },
          // Fix the issue of input use show-count param in space compact mode
          // https://github.com/ant-design/ant-design/issues/46872
          [`&:not(${w}-compact-last-item)${w}-compact-item`]: {
            [`${w}-affix-wrapper`]: {
              borderStartEndRadius: 0,
              borderEndEndRadius: 0
            }
          }
        })
      })
    };
  }, v = (_) => {
    const {
      componentCls: w,
      antCls: T
    } = _, x = `${w}-search`;
    return {
      [x]: {
        [w]: {
          "&:hover, &:focus": {
            [`+ ${w}-group-addon ${x}-button:not(${T}-btn-primary)`]: {
              borderInlineStartColor: _.colorPrimaryHover
            }
          }
        },
        [`${w}-affix-wrapper`]: {
          height: _.controlHeight,
          borderRadius: 0
        },
        // fix slight height diff in Firefox:
        // https://ant.design/components/auto-complete-cn/#auto-complete-demo-certain-category
        [`${w}-lg`]: {
          lineHeight: _.calc(_.lineHeightLG).sub(2e-4).equal()
        },
        [`> ${w}-group`]: {
          [`> ${w}-group-addon:last-child`]: {
            insetInlineStart: -1,
            padding: 0,
            border: 0,
            [`${x}-button`]: {
              // Fix https://github.com/ant-design/ant-design/issues/47150
              marginInlineEnd: -1,
              paddingTop: 0,
              paddingBottom: 0,
              borderStartStartRadius: 0,
              borderEndStartRadius: 0,
              boxShadow: "none"
            },
            [`${x}-button:not(${T}-btn-primary)`]: {
              color: _.colorTextDescription,
              "&:hover": {
                color: _.colorPrimaryHover
              },
              "&:active": {
                color: _.colorPrimaryActive
              },
              [`&${T}-btn-loading::before`]: {
                insetInlineStart: 0,
                insetInlineEnd: 0,
                insetBlockStart: 0,
                insetBlockEnd: 0
              }
            }
          }
        },
        [`${x}-button`]: {
          height: _.controlHeight,
          "&:hover, &:focus": {
            zIndex: 1
          }
        },
        "&-large": {
          [`${w}-affix-wrapper, ${x}-button`]: {
            height: _.controlHeightLG
          }
        },
        "&-small": {
          [`${w}-affix-wrapper, ${x}-button`]: {
            height: _.controlHeightSM
          }
        },
        "&-rtl": {
          direction: "rtl"
        },
        // ===================== Compact Item Customized Styles =====================
        [`&${w}-compact-item`]: {
          [`&:not(${w}-compact-last-item)`]: {
            [`${w}-group-addon`]: {
              [`${w}-search-button`]: {
                marginInlineEnd: _.calc(_.lineWidth).mul(-1).equal(),
                borderRadius: 0
              }
            }
          },
          [`&:not(${w}-compact-first-item)`]: {
            [`${w},${w}-affix-wrapper`]: {
              borderRadius: 0
            }
          },
          [`> ${w}-group-addon ${w}-search-button,
        > ${w},
        ${w}-affix-wrapper`]: {
            "&:hover, &:focus, &:active": {
              zIndex: 2
            }
          },
          [`> ${w}-affix-wrapper-focused`]: {
            zIndex: 2
          }
        }
      }
    };
  }, y = (_) => {
    const {
      componentCls: w,
      paddingLG: T
    } = _, x = `${w}-textarea`;
    return {
      [x]: {
        position: "relative",
        "&-show-count": {
          // https://github.com/ant-design/ant-design/issues/33049
          [`> ${w}`]: {
            height: "100%"
          },
          [`${w}-data-count`]: {
            position: "absolute",
            bottom: _.calc(_.fontSize).mul(_.lineHeight).mul(-1).equal(),
            insetInlineEnd: 0,
            color: _.colorTextDescription,
            whiteSpace: "nowrap",
            pointerEvents: "none"
          }
        },
        [`
        &-allow-clear > ${w},
        &-affix-wrapper${x}-has-feedback ${w}
      `]: {
          paddingInlineEnd: T
        },
        [`&-affix-wrapper${w}-affix-wrapper`]: {
          padding: 0,
          [`> textarea${w}`]: {
            fontSize: "inherit",
            border: "none",
            outline: "none",
            background: "transparent",
            "&:focus": {
              boxShadow: "none !important"
            }
          },
          [`${w}-suffix`]: {
            margin: 0,
            "> *:not(:last-child)": {
              marginInline: 0
            },
            // Clear Icon
            [`${w}-clear-icon`]: {
              position: "absolute",
              insetInlineEnd: _.paddingInline,
              insetBlockStart: _.paddingXS
            },
            // Feedback Icon
            [`${x}-suffix`]: {
              position: "absolute",
              top: 0,
              insetInlineEnd: _.paddingInline,
              bottom: 0,
              zIndex: 1,
              display: "inline-flex",
              alignItems: "center",
              margin: "auto",
              pointerEvents: "none"
            }
          }
        },
        [`&-affix-wrapper${w}-affix-wrapper-sm`]: {
          [`${w}-suffix`]: {
            [`${w}-clear-icon`]: {
              insetInlineEnd: _.paddingInlineSM
            }
          }
        }
      }
    };
  }, S = (_) => {
    const {
      componentCls: w
    } = _;
    return {
      [`${w}-out-of-range`]: {
        [`&, & input, & textarea, ${w}-show-count-suffix, ${w}-data-count`]: {
          color: _.colorError
        }
      }
    };
  };
  e.default = (0, i.genStyleHooks)("Input", (_) => {
    const w = (0, i.mergeToken)(_, (0, o.initInputToken)(_));
    return [
      h(w),
      y(w),
      g(w),
      m(w),
      v(w),
      S(w),
      // =====================================================
      // ==             Space Compact                       ==
      // =====================================================
      (0, r.genCompactItemStyle)(w)
    ];
  }, o.initComponentToken, {
    resetFont: !1
  });
})(Fk);
var zk = {};
Object.defineProperty(zk, "__esModule", {
  value: !0
});
zk.hasPrefixSuffix = Nvt;
function Nvt(e) {
  return !!(e.prefix || e.suffix || e.allowClear || e.showCount);
}
(function(e) {
  "use client";
  var t = un.default, n = gi.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0, Object.defineProperty(e, "triggerFocus", {
    enumerable: !0,
    get: function() {
      return a.triggerFocus;
    }
  });
  var r = n(D), i = t(Sp), o = t(U0t), a = Jp, s = Ko, c = t(b2), l = t(By), u = Gp, d = so, f = qy, h = t(hl), p = t(tb), g = t(Xp), m = bi, v = t(nb), y = hs, S = t(jk), _ = t(Fk), w = zk, T = function(C, E) {
    var R = {};
    for (var A in C)
      Object.prototype.hasOwnProperty.call(C, A) && E.indexOf(A) < 0 && (R[A] = C[A]);
    if (C != null && typeof Object.getOwnPropertySymbols == "function")
      for (var O = 0, A = Object.getOwnPropertySymbols(C); O < A.length; O++)
        E.indexOf(A[O]) < 0 && Object.prototype.propertyIsEnumerable.call(C, A[O]) && (R[A[O]] = C[A[O]]);
    return R;
  };
  const x = /* @__PURE__ */ (0, r.forwardRef)((C, E) => {
    var R;
    const {
      prefixCls: A,
      bordered: O = !0,
      status: $,
      size: N,
      disabled: z,
      onBlur: k,
      onFocus: F,
      suffix: V,
      allowClear: j,
      addonAfter: B,
      addonBefore: U,
      className: Q,
      style: K,
      styles: q,
      rootClassName: X,
      onChange: ie,
      classNames: te,
      variant: J
    } = C, Y = T(C, ["prefixCls", "bordered", "status", "size", "disabled", "onBlur", "onFocus", "suffix", "allowClear", "addonAfter", "addonBefore", "className", "style", "styles", "rootClassName", "onChange", "classNames", "variant"]);
    if (process.env.NODE_ENV !== "production") {
      const {
        deprecated: Ct
      } = (0, d.devUseWarning)("Input");
      Ct(!("bordered" in C), "bordered", "variant");
    }
    const {
      getPrefixCls: ee,
      direction: Z,
      input: H
    } = r.default.useContext(f.ConfigContext), oe = ee("input", A), W = (0, r.useRef)(null), se = (0, p.default)(oe), [ce, ge, he] = (0, _.default)(oe, se), {
      compactSize: ue,
      compactItemClassnames: Ee
    } = (0, y.useCompactItemContext)(oe, Z), pe = (0, g.default)((Ct) => {
      var yt;
      return (yt = N ?? ue) !== null && yt !== void 0 ? yt : Ct;
    }), Oe = r.default.useContext(h.default), de = z ?? Oe, {
      status: be,
      hasFeedback: Ie,
      feedbackIcon: Ve
    } = (0, r.useContext)(m.FormItemInputContext), Fe = (0, u.getMergedStatus)(be, $), Pe = (0, w.hasPrefixSuffix)(C) || !!Ie, ot = (0, r.useRef)(Pe);
    if (process.env.NODE_ENV !== "production") {
      const Ct = (0, d.devUseWarning)("Input");
      (0, r.useEffect)(() => {
        var yt;
        Pe && !ot.current && process.env.NODE_ENV !== "production" && Ct(document.activeElement === ((yt = W.current) === null || yt === void 0 ? void 0 : yt.input), "usage", "When Input is focused, dynamic add or remove prefix / suffix will make it lose focus caused by dom structure change. Read more: https://ant.design/components/input/#FAQ"), ot.current = Pe;
      }, [Pe]);
    }
    const dt = (0, S.default)(W, !0), ft = (Ct) => {
      dt(), k == null || k(Ct);
    }, wt = (Ct) => {
      dt(), F == null || F(Ct);
    }, Ge = (Ct) => {
      dt(), ie == null || ie(Ct);
    }, at = (Ie || V) && /* @__PURE__ */ r.default.createElement(r.default.Fragment, null, V, Ie && Ve), Nt = (0, l.default)(j ?? (H == null ? void 0 : H.allowClear)), [zt, kt] = (0, v.default)("input", J, O);
    return ce(/* @__PURE__ */ r.default.createElement(o.default, Object.assign({
      ref: (0, s.composeRef)(E, W),
      prefixCls: oe,
      autoComplete: H == null ? void 0 : H.autoComplete
    }, Y, {
      disabled: de,
      onBlur: ft,
      onFocus: wt,
      style: Object.assign(Object.assign({}, H == null ? void 0 : H.style), K),
      styles: Object.assign(Object.assign({}, H == null ? void 0 : H.styles), q),
      suffix: at,
      allowClear: Nt,
      className: (0, i.default)(Q, X, he, se, Ee, H == null ? void 0 : H.className),
      onChange: Ge,
      addonBefore: U && /* @__PURE__ */ r.default.createElement(c.default, {
        form: !0,
        space: !0
      }, U),
      addonAfter: B && /* @__PURE__ */ r.default.createElement(c.default, {
        form: !0,
        space: !0
      }, B),
      classNames: Object.assign(Object.assign(Object.assign({}, te), H == null ? void 0 : H.classNames), {
        input: (0, i.default)({
          [`${oe}-sm`]: pe === "small",
          [`${oe}-lg`]: pe === "large",
          [`${oe}-rtl`]: Z === "rtl"
        }, te == null ? void 0 : te.input, (R = H == null ? void 0 : H.classNames) === null || R === void 0 ? void 0 : R.input, ge),
        variant: (0, i.default)({
          [`${oe}-${zt}`]: kt
        }, (0, u.getStatusClassNames)(oe, Fe)),
        affixWrapper: (0, i.default)({
          [`${oe}-affix-wrapper-sm`]: pe === "small",
          [`${oe}-affix-wrapper-lg`]: pe === "large",
          [`${oe}-affix-wrapper-rtl`]: Z === "rtl"
        }, ge),
        wrapper: (0, i.default)({
          [`${oe}-group-rtl`]: Z === "rtl"
        }, ge),
        groupWrapper: (0, i.default)({
          [`${oe}-group-wrapper-sm`]: pe === "small",
          [`${oe}-group-wrapper-lg`]: pe === "large",
          [`${oe}-group-wrapper-rtl`]: Z === "rtl",
          [`${oe}-group-wrapper-${zt}`]: kt
        }, (0, u.getStatusClassNames)(`${oe}-group-wrapper`, Fe, Ie), ge)
      })
    })));
  });
  process.env.NODE_ENV !== "production" && (x.displayName = "Input"), e.default = x;
})(Bae);
var Ju = un.default, Dvt = gi.default;
Object.defineProperty(lk, "__esModule", {
  value: !0
});
var Kae = lk.default = void 0, Yae = Dvt(D), ad = Yae, y1 = Ju(Sp), Lvt = Ju(Bht), jvt = Ju(By), qB = Gp, Fvt = so, Vvt = qy, Bvt = Ju(hl), zvt = Ju(tb), Hvt = Ju(Xp), Uvt = bi, Wvt = Ju(nb), qvt = Bae, Gvt = Ju(Fk), Kvt = function(e, t) {
  var n = {};
  for (var r in e)
    Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var i = 0, r = Object.getOwnPropertySymbols(e); i < r.length; i++)
      t.indexOf(r[i]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[i]) && (n[r[i]] = e[r[i]]);
  return n;
};
const Yvt = /* @__PURE__ */ (0, Yae.forwardRef)((e, t) => {
  var n, r;
  const {
    prefixCls: i,
    bordered: o = !0,
    size: a,
    disabled: s,
    status: c,
    allowClear: l,
    classNames: u,
    rootClassName: d,
    className: f,
    style: h,
    styles: p,
    variant: g
  } = e, m = Kvt(e, ["prefixCls", "bordered", "size", "disabled", "status", "allowClear", "classNames", "rootClassName", "className", "style", "styles", "variant"]);
  if (process.env.NODE_ENV !== "production") {
    const {
      deprecated: B
    } = (0, Fvt.devUseWarning)("TextArea");
    B(!("bordered" in e), "bordered", "variant");
  }
  const {
    getPrefixCls: v,
    direction: y,
    textArea: S
  } = ad.useContext(Vvt.ConfigContext), _ = (0, Hvt.default)(a), w = ad.useContext(Bvt.default), T = s ?? w, {
    status: x,
    hasFeedback: C,
    feedbackIcon: E
  } = ad.useContext(Uvt.FormItemInputContext), R = (0, qB.getMergedStatus)(x, c), A = ad.useRef(null);
  ad.useImperativeHandle(t, () => {
    var B;
    return {
      resizableTextArea: (B = A.current) === null || B === void 0 ? void 0 : B.resizableTextArea,
      focus: (U) => {
        var Q, K;
        (0, qvt.triggerFocus)((K = (Q = A.current) === null || Q === void 0 ? void 0 : Q.resizableTextArea) === null || K === void 0 ? void 0 : K.textArea, U);
      },
      blur: () => {
        var U;
        return (U = A.current) === null || U === void 0 ? void 0 : U.blur();
      }
    };
  });
  const O = v("input", i), $ = (0, zvt.default)(O), [N, z, k] = (0, Gvt.default)(O, $), [F, V] = (0, Wvt.default)("textArea", g, o), j = (0, jvt.default)(l ?? (S == null ? void 0 : S.allowClear));
  return N(/* @__PURE__ */ ad.createElement(Lvt.default, Object.assign({
    autoComplete: S == null ? void 0 : S.autoComplete
  }, m, {
    style: Object.assign(Object.assign({}, S == null ? void 0 : S.style), h),
    styles: Object.assign(Object.assign({}, S == null ? void 0 : S.styles), p),
    disabled: T,
    allowClear: j,
    className: (0, y1.default)(k, $, f, d, S == null ? void 0 : S.className),
    classNames: Object.assign(Object.assign(Object.assign({}, u), S == null ? void 0 : S.classNames), {
      textarea: (0, y1.default)({
        [`${O}-sm`]: _ === "small",
        [`${O}-lg`]: _ === "large"
      }, z, u == null ? void 0 : u.textarea, (n = S == null ? void 0 : S.classNames) === null || n === void 0 ? void 0 : n.textarea),
      variant: (0, y1.default)({
        [`${O}-${F}`]: V
      }, (0, qB.getStatusClassNames)(O, R)),
      affixWrapper: (0, y1.default)(`${O}-textarea-affix-wrapper`, {
        [`${O}-affix-wrapper-rtl`]: y === "rtl",
        [`${O}-affix-wrapper-sm`]: _ === "small",
        [`${O}-affix-wrapper-lg`]: _ === "large",
        [`${O}-textarea-show-count`]: e.showCount || ((r = e.count) === null || r === void 0 ? void 0 : r.show)
      }, z)
    }),
    prefixCls: O,
    suffix: C && /* @__PURE__ */ ad.createElement("span", {
      className: `${O}-textarea-suffix`
    }, E),
    ref: A
  })));
});
Kae = lk.default = Yvt;
function Hk() {
  const { primaryColour: e, primary25: t } = hr(), n = Z6(), r = ho(), i = O2(
    getComputedStyle(document.documentElement).getPropertyValue("--button-height").trim()
  ), o = getComputedStyle(document.documentElement).getPropertyValue("--error").trim(), a = getComputedStyle(document.documentElement).getPropertyValue("--dark").trim(), s = O2(
    getComputedStyle(document.documentElement).getPropertyValue("--choice-text-font-size").trim()
  );
  return {
    token: {
      colorPrimary: e,
      borderRadius: O2(r),
      colorError: o,
      fontFamily: n,
      fontSize: s
    },
    components: {
      Select: {
        optionSelectedBg: t,
        controlHeight: i
      },
      Slider: {
        handleSize: 28,
        handleSizeHover: 28,
        railSize: 12,
        dotSize: 18,
        dotBorderColor: a,
        handleLineWidth: 1,
        handleColor: e,
        railHoverBg: "#A2A2A2",
        railBg: "#C2C2C2"
      }
    }
  };
}
const Uk = ({
  value: e,
  onChange: t,
  label: n,
  allowClear: r,
  placeholder: i,
  autoSize: o,
  dynamicColour: a
}) => {
  const s = ho(), c = Hk(), l = Z6();
  return /* @__PURE__ */ M.jsx(lo, { theme: c, children: /* @__PURE__ */ M.jsx(
    Xvt,
    {
      value: e,
      allowClear: r,
      placeholder: i,
      autoSize: o,
      onChange: t,
      colour: a,
      fontFamily: l,
      style: { borderRadius: s }
    }
  ) });
}, Xvt = Ce(Kae)`
  width: 100%;
  font-size: var(--choice-text-font-size);
  padding: var(--spacing-sm);
  background-color: var(--light);
  border: 1px solid var(--mid);
  font-family: ${(e) => e.fontFamily};

  * {
    font-family: ${(e) => e.fontFamily};
  }

  @media (hover: hover) {
    &:hover {
      border: 1px solid ${(e) => e.colour};
      box-shadow: 0 0 5px 0px rgba(0, 0, 0, 0.3);
    }
  }
  &:focus {
    border: 2px solid ${(e) => e.colour};
    animation: none;
  }
`, Qvt = ({
  currentAnswer: e,
  settings: t,
  injectCurrent: n,
  question: r
}) => {
  const i = e.getValue(r.type), { primaryColour: o } = hr();
  return /* @__PURE__ */ M.jsx(
    Uk,
    {
      value: (i == null ? void 0 : i.value) || "",
      onChange: (a) => {
        n({ value: { id: r.id, value: a.target.value } });
      },
      placeholder: r.placeholder,
      dynamicColour: o
    }
  );
};
const Jvt = ({
  currentAnswer: e,
  updateCurrent: t,
  injectCurrent: n,
  submitAnswer: r,
  answers: i,
  question: o
}) => {
  var K, q, X, ie;
  const { loggingService: a, popupService: s } = St(ir), c = 600;
  let l = o.max;
  const u = 1;
  let d = o.convertStep, f = o.convertValue, h = {
    0: "$0",
    [d(l * 0.02, c, l)]: "$" + l * 0.02,
    [d(l * 0.05, c, l)]: "$" + l * 0.05,
    [d(l * 0.1, c, l)]: "$" + l * 0.1,
    [d(l * 0.2, c, l)]: "$" + l * 0.2,
    [d(l * 0.5, c, l)]: "$" + l * 0.5,
    [c]: "$" + l
  };
  const p = o.attributes[0].levels, g = o.attributes[1].levels, m = o.ranking({ answers: i }), v = o.pairSet(m.length);
  if (v.length === 0)
    throw new Error("invalid pair set");
  const y = v.map((te) => te.pair), [S, _] = Lt(0), [w, T] = Lt(
    o.default ? d(o.default, c, l) : 0
  ), [x, C] = Lt(
    Math.random() > 0.5 ? o.characters.filter((te) => te.gender === "female") : o.characters.filter((te) => te.gender === "male")
  ), E = (te, J) => {
    if (!te)
      return /* @__PURE__ */ M.jsx(QB, { children: /* @__PURE__ */ M.jsxs(XB, { children: [
        /* @__PURE__ */ M.jsx(GB, {}),
        /* @__PURE__ */ M.jsxs(KB, { children: [
          /* @__PURE__ */ M.jsx(mh, { children: "None" }),
          /* @__PURE__ */ M.jsx(mh, { children: "None" }),
          /* @__PURE__ */ M.jsx(mh, { children: "None" })
        ] })
      ] }) });
    const Y = p.find((Z) => Z.value === te.attr_1), ee = Y ? Y.text : "";
    return (
      // <AnimatedDiv key={person.id + text}>
      /* @__PURE__ */ M.jsx(QB, { children: /* @__PURE__ */ M.jsxs(XB, { children: [
        /* @__PURE__ */ M.jsx(
          GB,
          {
            src: x[te.id % x.length] ? x[te.id % x.length].portrait : x[0].portrait
          }
        ),
        /* @__PURE__ */ M.jsxs(KB, { children: [
          /* @__PURE__ */ M.jsx(mh, { children: x[te.id % x.length] ? x[te.id % x.length].name : "loading..." }),
          /* @__PURE__ */ M.jsx(mh, { children: ee }),
          /* @__PURE__ */ M.jsx(mh, { children: te.attr_2 ? g[1].text : g[0].text })
        ] })
      ] }) })
    );
  };
  let R, A;
  if (S < y.length) {
    const te = m[y[S][0]], J = m[y[S][1]];
    x[te.id % x.length] && (R = x[te.id % x.length].name), x[J.id % x.length] && (A = x[J.id % x.length].name);
  }
  const O = {
    default: {
      content: `Click and drag the amount you would pay extra per hour for ${A} over ${R}, and click the next button`
    }
  }, $ = Ts(O, o.helpPopups), N = o.showHelpPopups ?? !1, z = o.helpPopupsToShow;
  if (gt(() => {
    if (R === void 0 || A === void 0) {
      s.clearPopup();
      return;
    }
    s.setPopup($, "default", N, z);
  }, [$, N, z, R, A]), S >= y.length)
    return /* @__PURE__ */ M.jsx("div", { children: /* @__PURE__ */ M.jsxs(ez, { children: [
      E(null),
      /* @__PURE__ */ M.jsx(JB, { children: "Loading" }),
      E(null)
    ] }) });
  const k = [m[y[S][0]], m[y[S][1]]];
  if (v[S].intermediate) {
    f = (Y, ee, Z) => (Y / ee * Z).toFixed(2), d = (Y, ee, Z) => Y === 0 ? 0 : Math.round(Y / Z * ee);
    const te = (K = e.getValue(o.type)) == null ? void 0 : K.findLast(
      (Y) => {
        var ee, Z;
        return Number((ee = Y.info) == null ? void 0 : ee.rank) < k[1].rank && Wn.isNumber((Z = Y.info) == null ? void 0 : Z.absVal);
      }
    ), J = (q = e.getValue(o.type)) == null ? void 0 : q.find(
      (Y) => {
        var ee, Z;
        return Number((ee = Y.info) == null ? void 0 : ee.rank) > k[1].rank && Wn.isNumber((Z = Y.info) == null ? void 0 : Z.absVal);
      }
    );
    l = Number((X = J == null ? void 0 : J.info) == null ? void 0 : X.absVal) - Number((ie = te == null ? void 0 : te.info) == null ? void 0 : ie.absVal), h = {
      0: "$0",
      // [maxStep * 0.5]: '$' + maxAbs * 0.5,
      [c]: "$" + l.toFixed(2)
    };
  }
  const F = () => {
    C(
      Math.random() > 0.5 ? o.characters.filter((Z) => Z.gender === "female") : o.characters.filter((Z) => Z.gender === "male")
    );
    let te = e.getValue(o.type);
    te === null && (te = [$m(k[0], 0)]);
    const J = te.find((Z) => Z.id === Xae(k[0])), Y = te.concat(
      $m(
        k[1],
        parseFloat(f(w, c, l)) + Number(J == null ? void 0 : J.value)
      )
    );
    n({
      // value: _.sortBy(answerVal, 'rank'),
      value: Wn.sortBy(Y, (Z) => {
        var H;
        return (H = Z.info) == null ? void 0 : H.rank;
      })
    });
    let ee = typeof o.default == "number" ? d(o.default, c, l) : c / 2;
    ee > c && (ee = c), a.debug("newInputVal", ee), T(ee), S === y.length - 1 ? (r(), _(S + y.length)) : _(S + 1);
  }, V = (te) => {
    var J;
    return ((J = e.getValue(o.type)) == null ? void 0 : J.filter((Y) => {
      var ee;
      return ((ee = Y.info) == null ? void 0 : ee.rank) === te.rank;
    }).length) === 0;
  }, j = () => {
    var H;
    const te = Wn.sortBy(
      m.filter((oe) => V(oe)),
      "rank"
    ), J = Wn.sortBy(e.getValue(o.type), (oe) => {
      var W;
      return (W = oe.info) == null ? void 0 : W.rank;
    }), Y = te.map((oe) => {
      var ce, ge, he;
      const W = J.findLast((ue) => {
        var Ee;
        return Number((Ee = ue.info) == null ? void 0 : Ee.rank) < oe.rank;
      }), se = J.find((ue) => {
        var Ee;
        return Number((Ee = ue.info) == null ? void 0 : Ee.rank) > oe.rank;
      });
      return Wn.isUndefined(W) ? $m(oe, Number(se == null ? void 0 : se.value) / 2) : Wn.isUndefined(se) ? $m(oe, Number(W.value)) : $m(
        oe,
        Number(W.value) + (Number(se.value) - Number(W.value)) / (Number((ce = se.info) == null ? void 0 : ce.rank) - Number((ge = W.info) == null ? void 0 : ge.rank)) * (oe.rank - Number((he = W.info) == null ? void 0 : he.rank))
      );
    }), ee = Wn.uniqBy(
      (H = e.getValue(o.type)) == null ? void 0 : H.concat(Y),
      "id"
    ), Z = Wn.sortBy(ee, (oe) => {
      var W;
      return (W = oe.info) == null ? void 0 : W.rank;
    });
    n({
      value: Z
    });
  }, B = () => {
    j(), r(), _(S + y.length);
  }, U = o.intermediateSkippable && v[S].intermediate ? "visible" : "hidden", Q = (te) => {
    T(te);
  };
  return /* @__PURE__ */ M.jsxs(Zvt, { children: [
    /* @__PURE__ */ M.jsxs(tyt, { children: [
      /* @__PURE__ */ M.jsx("div", { children: "Your rank:" }),
      m.map((te) => {
        let J = "white";
        return (te.rank === k[0].rank || te.rank === k[1].rank) && (J = "#4cb8d2"), /* @__PURE__ */ M.jsxs(nyt, { style: { backgroundColor: J }, children: [
          /* @__PURE__ */ M.jsxs("div", { style: { textAlign: "center" }, children: [
            te.attr_1,
            "-year"
          ] }),
          /* @__PURE__ */ M.jsx("div", { children: te.attr_2 ? /* @__PURE__ */ M.jsx(ZB, { children: /* @__PURE__ */ M.jsx("img", { src: g[1].icon, alt: "Tick", height: "20" }) }) : /* @__PURE__ */ M.jsx(ZB, { children: /* @__PURE__ */ M.jsx("img", { src: g[0].icon, alt: "Cross", height: "20" }) }) })
        ] }, te.rank);
      })
    ] }),
    /* @__PURE__ */ M.jsxs(ez, { children: [
      E(k[0]),
      /* @__PURE__ */ M.jsxs(JB, { children: [
        /* @__PURE__ */ M.jsx("div", { style: { marginBottom: "0", fontSize: "1rem", width: "100%" }, children: "I would pay an extra" }),
        /* @__PURE__ */ M.jsx("div", { children: Object.keys(h).filter((te) => parseInt(te) === w).length !== 0 ? h[w] : "$" + f(w, c, l) }),
        /* @__PURE__ */ M.jsxs("div", { style: { marginBottom: "0", fontSize: "1rem", width: "100%" }, children: [
          "per hour for ",
          x[k[1].id % x.length].name,
          " over",
          " ",
          x[k[0].id % x.length].name,
          "."
        ] })
      ] }),
      E(k[1])
    ] }),
    /* @__PURE__ */ M.jsx(YB, { children: /* @__PURE__ */ M.jsx(
      wR,
      {
        marks: h,
        min: 0,
        max: c,
        onChange: Q,
        value: w,
        step: u,
        tooltip: { open: !1 }
      }
    ) }),
    /* @__PURE__ */ M.jsx(eyt, {}),
    /* @__PURE__ */ M.jsxs(YB, { children: [
      /* @__PURE__ */ M.jsx(tz, { color: "#4cb8d2", onClick: F, children: "Next" }),
      /* @__PURE__ */ M.jsx(
        tz,
        {
          color: "#4cb8d2",
          style: {
            marginLeft: "2.5rem ",
            visibility: U
          },
          onClick: B,
          children: "Skip"
        }
      )
    ] })
  ] });
};
function $m(e, t) {
  return {
    id: Xae(e),
    value: t.toFixed(2),
    info: {
      absVal: t,
      rank: e.rank,
      attr_1: e.attr_1,
      attr_2: e.attr_2,
      attr_1_index: e.attr_1_index
    }
  };
}
function Xae(e) {
  return `${e.attr_1}-${e.attr_2}`;
}
const Zvt = Ce.div`
  display: flex;
  flex-direction: column;
`, GB = Ce.img`
  max-height: 10rem;
`, KB = Ce.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: baseline;
  text-align: left;
`, mh = Ce.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  padding-bottom: 0.5rem;
`, eyt = Ce.div`
  display: flex;
  height: 3rem;
`, YB = Ce.div`
  // margin: auto;
  display: flex;
  // width: 49rem;

  align-items: baseline;
  justify-content: center;
  // margin-bottom: 3rem;
  .ant-slider {
    width: 90%;
    margin: auto;
  }
  .button {
    display: inline-block;
    padding: 1rem 1.5rem;
    font-size: 1rem;
    cursor: pointer;
    text-align: center;
    text-decoration: none;
    outline: none;
    color: #fff;
    background-color: #8fd9e8;
    border: none;
    border-radius: 1rem;
    box-shadow: 0 5px #999;
  }
  @media (hover: hover) {
    .button:hover {
      background-color: #4cb8d2;
    }
  }
  .button:active {
    background-color: #4cb8d2;
    box-shadow: 0 5px #666;
    transform: translateY(4px);
  }

  @media (min-width: 0px) and (max-width: 479px) {
    /* small viewport  */
    width: 80vw;
    margin-top: 1rem;
    h1 {
      margin-left: 1rem;
    }
  }
  @media (min-width: 480px) and (max-width: 768px) {
    /* medium viewport  */
    width: 80vw;
    h1 {
      margin-left: 1rem;
    }
  }
  @media (min-width: 769px) and (max-width: 1025px) {
    width: 80vw;
  }
`, XB = Ce.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 1rem;
  font-size: 1rem;
  // width: 300px;
  color: #000;
  background-color: transparent;
  border: 1px solid rgba(0, 0, 0, 0.3);
  border-radius: 0.2rem;
  text-align: center;
`, QB = Ce.div`
  display: flex;
  flex-direction: row;
`, JB = Ce.div`
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
  justify-content: center;
  align-items: center;
  width: 10rem;
  margin: 0.5rem;
  font-size: 3rem;
`, tyt = Ce.div`
  display: flex;
  justify-content: space-between;
  margin: 0 0 1rem 0;
  align-items: stretch;
  font-size: 0.8rem;
  p {
    margin-right: 1rem;
  }
`, nyt = Ce.div`
  display: flex;
  flex-direction: column;
  flex-shrink: 1;
  justify-content: space-between;
  border: 1px solid rgba(0, 0, 0, 0.3);
  border-radius: 0.2rem;
  // margin: 0.2rem;
  // box-shadow: 5px 5px 5px lightblue;
  padding: 0.2rem;
`, ZB = Ce.div`
  display: flex;
  width: 50px;
  align-items: center;
  justify-content: center;
`, ez = Ce.div`
  display: flex;
  flex-direction: row;
  // flex-wrap: wrap;
  justify-content: space-between;
  align-items: stretch;
  grid-gap: auto;
  margin-bottom: 2rem;

  @media (min-width: 0px) and (max-width: 900px) {
    /* small viewport  */
    flex-direction: column;
    width: 80vw;
    grid-gap: 3rem;
  }
`, tz = Ce.button`
  display: flex;
  justify-content: center;
  align-items: center;
  border: none;
  text-transform: uppercase;
  letter-spacing: 0.1rem;
  height: 2rem;
  width: 160px;
  font-weight: 501;

  background-color: ${(e) => e.color ? e.color : "#E82D7C"};
  /* background-color: #7398ff; */
  /* background-color: #ffffff; */
  cursor: pointer;
  transition:
    background 250ms ease-in-out,
    transform 150ms ease;
  color: white;
  border-radius: 3px;
  i {
    margin-left: 1rem;
  }
  user-select: none;
  @media (min-width: 0px) and (max-width: 479px) {
    /* width: 90vw;
    height: 3.125rem;
    margin-bottom: 1rem; */
    width: 45%;
    height: 3.125rem;
  }
  /* color: #5d5d5de8; */
`, ryt = Ce(VC)`
  max-width: 45rem;
`;
let b1;
const iyt = new Uint8Array(16);
function oyt() {
  if (!b1 && (b1 = typeof crypto < "u" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto), !b1))
    throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
  return b1(iyt);
}
const Li = [];
for (let e = 0; e < 256; ++e)
  Li.push((e + 256).toString(16).slice(1));
function ayt(e, t = 0) {
  return Li[e[t + 0]] + Li[e[t + 1]] + Li[e[t + 2]] + Li[e[t + 3]] + "-" + Li[e[t + 4]] + Li[e[t + 5]] + "-" + Li[e[t + 6]] + Li[e[t + 7]] + "-" + Li[e[t + 8]] + Li[e[t + 9]] + "-" + Li[e[t + 10]] + Li[e[t + 11]] + Li[e[t + 12]] + Li[e[t + 13]] + Li[e[t + 14]] + Li[e[t + 15]];
}
const syt = typeof crypto < "u" && crypto.randomUUID && crypto.randomUUID.bind(crypto), nz = {
  randomUUID: syt
};
function cyt(e, t, n) {
  if (nz.randomUUID && !t && !e)
    return nz.randomUUID();
  e = e || {};
  const r = e.random || (e.rng || oyt)();
  if (r[6] = r[6] & 15 | 64, r[8] = r[8] & 63 | 128, t) {
    n = n || 0;
    for (let i = 0; i < 16; ++i)
      t[n + i] = r[i];
    return t;
  }
  return ayt(r);
}
const lyt = "https://conjoint-backend-4.confer.online/get_question", Qae = cyt(), uyt = (e) => {
  const { loggingService: t } = St(ir), n = Dn(
    e.question.attributes,
    { answers: e.answers }
  ), r = Dn(
    e.question.maxChoices,
    { answers: e.answers }
  );
  if (n === void 0 || r === void 0)
    return /* @__PURE__ */ M.jsx("div", { children: "Loading conjoint questions" });
  if (n.length === 0)
    return /* @__PURE__ */ M.jsx("div", { children: "No conjoint questions" });
  vyt(n);
  const i = e.currentAnswer.getValue(e.question.type);
  function o(l) {
    if (t.info("injectPartworths", l), t.info("injectCurrent attributes", n), n === void 0)
      return;
    const u = l.flatMap((f) => f.partworth_value.map((h) => {
      const p = n.find((m) => m.id === f.attribute_id), g = p == null ? void 0 : p.levels.find((m) => m.rank === h.level_id);
      return {
        id: `${p == null ? void 0 : p.name}-${g == null ? void 0 : g.value}`,
        value: h.partworth.toString(),
        info: {
          error: h.error ?? null
        }
      };
    })), d = {
      ...i,
      partworths: u
    };
    e.injectCurrent({
      value: d
    });
  }
  async function a(l) {
    if (n === void 0 || r === void 0)
      return null;
    let u, d = [];
    e.question.presetChoices ? d = e.question.presetChoices.concat(l) : d = l, d.length === 0 ? u = fyt(n) : u = dyt(n, d), e.question.expectedCorrectProbability !== void 0 && (u.settings = {
      alpha: e.question.expectedCorrectProbability
    }), t.info("ChoiceExperimentQuestion: body", u);
    const h = await (await fetch(lyt, {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify(u)
    })).json();
    return t.debug("ChoiceExperimentQuestion: json", h), h.partworths && o(h.partworths), Wn.isNull(h.new_profile_set) || l.length >= r ? null : h.new_profile_set.map((p) => gyt(p, n));
  }
  const s = {
    ...e.question,
    type: "choiceExperiment",
    attributes: n,
    maxChoices: r,
    choiceGenerator: a
  }, c = {
    ...e,
    question: s,
    currentAnswer: e.currentAnswer.convertedToQuestionType("choiceExperiment")
  };
  return /* @__PURE__ */ M.jsx(Ioe, { ...c });
};
function dyt(e, t) {
  return {
    id: Qae,
    attributes: e.map(Jae),
    choicePair: myt(t[t.length - 1]),
    answer: t[t.length - 1].selectedOptionIndex,
    previous_questions: t.map(hyt)
  };
}
function fyt(e) {
  return {
    id: Qae,
    attributes: e.map(Jae),
    choicePair: null,
    answer: null,
    previous_questions: []
  };
}
function hyt(e) {
  return {
    options: e.options.map((t, n) => ({
      id: n,
      attributes_and_levels: t.attributes.map((r) => ({
        attribute_id: r.attributeId,
        level_id: r.levelRank
      }))
    })),
    choice_id: e.selectedOptionIndex
  };
}
function gyt(e, t) {
  return {
    // id: profile.id,
    attributes: e.attributes_and_levels.map((n) => {
      var r, i, o;
      return {
        attributeId: n.attribute_id,
        attributeName: ((r = t.find((a) => a.id === n.attribute_id)) == null ? void 0 : r.name) ?? n.attribute_id.toString(),
        levelId: n.level_id,
        levelName: (((o = (i = t.find((a) => a.id === n.attribute_id)) == null ? void 0 : i.levels.find((a) => a.rank === n.level_id)) == null ? void 0 : o.value) ?? n.level_id).toString(),
        levelRank: n.level_id
      };
    })
  };
}
function Jae(e) {
  return {
    id: e.id,
    value: e.name,
    levels: e.levels.map(pyt),
    attribute_represents_a_cost: !!e.isCost
  };
}
function pyt(e) {
  return {
    id: e.rank,
    value: e.value.toString()
  };
}
function myt(e) {
  return e.options.length === 0 ? null : e.options.map((t, n) => ({
    id: n,
    attributes_and_levels: t.attributes.map((r) => ({
      attribute_id: r.attributeId,
      level_id: r.levelRank
    }))
  }));
}
function vyt(e) {
  yyt(e);
  for (const t of e)
    byt(t.levels);
}
function yyt(e) {
  dI(
    e.map((t) => t.id),
    "Conjoint attribute ids must be unique"
  );
}
function byt(e) {
  dI(
    e.map((t) => t.rank),
    "Conjoint level ranks must be unique"
  ), dI(
    e.map((t) => t.id),
    "Conjoint level ids must be unique"
  );
}
const Wk = ({ options: e, value: t, onChange: n, searchable: r, multiple: i }) => {
  let o;
  const a = i ? "multiple" : void 0;
  r && (o = (c, l) => l === void 0 ? !1 : qse(c, l.value));
  const s = Hk();
  return /* @__PURE__ */ M.jsx(lo, { theme: s, children: /* @__PURE__ */ M.jsx(_yt, { children: /* @__PURE__ */ M.jsx(
    g3e,
    {
      options: e,
      value: t,
      onChange: (c) => n(c),
      showSearch: r,
      filterOption: o,
      mode: a
    }
  ) }) });
}, _yt = Ce.div`
  display: flex;
  flex-direction: column;
  align-items: stretch;
  /* max-width: 90vw; */
`, Syt = ({
  question: e,
  currentAnswer: t,
  injectCurrent: n,
  submitAnswer: r,
  answers: i,
  settings: o
}) => {
  var v;
  const { loggingService: a, popupService: s } = St(ir), c = gc(e.choices, i), l = mn(() => {
    if (!e.defaultValues)
      return;
    const y = e.defaultValues({ answers: i, choices: c }), S = c.find((_) => _.id === y);
    if (S)
      return {
        id: S.id,
        value: S.value
      };
  }, [e, i, c]);
  kf(l, e, t, i, n);
  const u = (y) => {
    if (Wn.isArray(y))
      throw new Error("Dropdown question received an array as a current answer value");
    {
      const S = c.find((_) => _.value === y);
      if (S) {
        const _ = {
          id: S.id,
          value: S.value
        };
        n({
          value: _
        });
      }
    }
  };
  a.debug("DropdownQuestion: currentAnswer", t);
  const d = (v = t.getValue(e.type)) == null ? void 0 : v.value, { searchable: f } = e;
  a.debug(
    "options as string",
    c.map((y) => String(Dr(y.text) || y.value))
  );
  const p = Ts({
    noneSelected: { content: "Please select an option" },
    selected: { content: "Click next to continue" },
    notRequired: { content: "Please select an option or click next to continue" }
  }, e.helpPopups), g = e.showHelpPopups ?? !1, m = e.helpPopupsToShow;
  return gt(() => {
    e.required ? d === void 0 ? s.setPopup(p, "noneSelected", g, m) : s.setPopup(p, "selected", g, m) : s.setPopup(p, "notRequired", g, m);
  }, [p, g, m, e.required, d]), /* @__PURE__ */ M.jsx(
    Wk,
    {
      options: c.map((y) => ({
        id: y.id,
        value: y.value,
        label: y.text ? Dr(y.text) : y.value
      })),
      value: d,
      onChange: u,
      searchable: f
    }
  );
};
class Zae extends Error {
  constructor(t, n) {
    super(`Question of type ${t} received incorrect input of type ${n}`);
  }
}
const wyt = ({
  question: e,
  currentAnswer: t,
  answers: n,
  settings: r
}) => {
  var m, v, y, S, _;
  const {
    analyticsService: i,
    databaseService: o,
    loggingService: a,
    messagerService: s
  } = St(ir);
  if (e.type !== "endPage")
    throw new Zae("endPage", e.type);
  gt(() => {
    i.logCompletion(r.surveyName);
  }, [i, r.surveyName]);
  const [c, l] = Lt("loading");
  gt(() => {
    async function w() {
      var C;
      const x = Cq.parse(window.location.search).panelId;
      if (((C = e.panelOptions) == null ? void 0 : C.action) === "registerCompletion" && typeof x == "string")
        try {
          await o.registerCompletionMailchimp(r.surveyName, x), l("success");
        } catch (E) {
          const R = E;
          a.error("Error registering survey completion with Mailchimp", { error: R }), s.error("Error registering survey completion with Mailchimp"), l("error");
        }
      else
        l("error");
    }
    w();
  }, [o, a, r.surveyName, (m = e.panelOptions) == null ? void 0 : m.action]);
  const [u, d] = Lt("loading"), [f, h] = Lt(""), p = Dn((v = e.panelOptions) == null ? void 0 : v.subscribeInputs, {
    answers: n
  });
  if (gt(() => {
    async function w() {
      var T, x;
      if (((T = e.panelOptions) == null ? void 0 : T.action) === "subscribe" && p)
        try {
          a.debug("subscribeInputs", p);
          const { email_address: C, merge_fields: E, interests: R, tags: A } = p, O = await o.subscribeMailchimp(
            C,
            E,
            R,
            A
          );
          if (O.status === "subscribed")
            d("success");
          else if (O.status === "resubscribed")
            d("resubscribed");
          else {
            d("error");
            const $ = ((x = O.error) == null ? void 0 : x.title) ?? "Error subscribing to Mailchimp";
            a.error($, { context: O }), s.error($), h(
              $ === "Member Exists" ? /* @__PURE__ */ M.jsx("div", { children: /* @__PURE__ */ M.jsx("p", { children: "You are already subscribed to our mailing list." }) }) : /* @__PURE__ */ M.jsx("div", { children: /* @__PURE__ */ M.jsx("p", { children: $ }) })
            );
          }
        } catch (C) {
          const E = C;
          a.error("Error subscribing to Mailchimp", { error: E }), s.error("Error subscribing to Mailchimp"), d("error");
        }
    }
    w();
  }, [o, a, p, (y = e.panelOptions) == null ? void 0 : y.action]), ((S = e.panelOptions) == null ? void 0 : S.action) === "registerCompletion")
    switch (c) {
      case "loading":
        return /* @__PURE__ */ M.jsxs(Tc, { children: [
          /* @__PURE__ */ M.jsx("div", { children: e.panelOptions.loadingContent }),
          /* @__PURE__ */ M.jsx(uv, {})
        ] });
      case "success":
        return /* @__PURE__ */ M.jsx(Tc, { children: e.panelOptions.successContent });
      case "error":
        return /* @__PURE__ */ M.jsx(Tc, { children: e.panelOptions.errorContent });
    }
  if (((_ = e.panelOptions) == null ? void 0 : _.action) === "subscribe")
    switch (u) {
      case "loading":
        return /* @__PURE__ */ M.jsxs(Tc, { children: [
          /* @__PURE__ */ M.jsx("div", { children: e.panelOptions.loadingContent }),
          /* @__PURE__ */ M.jsx(uv, {})
        ] });
      case "success":
        return /* @__PURE__ */ M.jsx(Tc, { children: e.panelOptions.successContent });
      case "resubscribed":
        return e.panelOptions.resubscribedContent ? /* @__PURE__ */ M.jsx(Tc, { children: e.panelOptions.resubscribedContent }) : /* @__PURE__ */ M.jsx(Tc, { children: "You are already subscribed. We have sent you an email if you would like to update your details." });
      case "error":
        return /* @__PURE__ */ M.jsxs(Tc, { children: [
          e.panelOptions.errorContent,
          f
        ] });
    }
  const g = aO(({ survey: w }) => w.isSubmitClicked);
  return e.contentAfterSubmit && g ? /* @__PURE__ */ M.jsx(Tc, { children: Dr(e.contentAfterSubmit) }) : null;
}, Tc = Ce.div`
  display: flex;
  flex-direction: column;
  // width: 800px;
  justify-content: center;
  align-items: baseline;
  @media (min-width: 0px) and (max-width: 479px) {
    margin: 10px;
  }
`, xyt = ({
  question: e,
  injectCurrent: t,
  submitAnswer: n,
  answers: r,
  updateSurveyControls: i,
  goToPreviousQuestion: o
}) => {
  const a = f_((s) => s.survey.direction);
  return gt(() => {
    a === "backwards" && o();
  }, [a]), Nv(() => (i({
    nextDisabled: !0,
    prevDisabled: !0
  }), () => {
    i({
      nextDisabled: !1,
      prevDisabled: !1
    });
  }), []), gt(() => {
    let s = !0;
    const c = async (l, u) => {
      const d = await l(u);
      s && (t({ value: d ?? null }), n());
    };
    return Wn.isFunction(e.answerValue) ? c(e.answerValue, { answers: r }) : (t({ value: e.answerValue ?? null }), n()), () => {
      s = !1;
    };
  }, []), /* @__PURE__ */ M.jsx(uv, {});
}, Eyt = ({
  question: e,
  currentAnswer: t,
  injectCurrent: n,
  submitAnswer: r,
  answers: i,
  settings: o
}) => (gt(() => {
  const a = e.answerValue ? e.answerValue({ answers: i }) : null;
  n({ value: a });
}, []), null), Cyt = (e) => {
  const { question: t, settings: n } = e, { loggingService: r } = St(ir);
  if (t.type !== "loggingTestPage")
    throw new Zae("loggingTestPage", t.type);
  switch (t.loggingType) {
    case "debug":
      return r.debug(n.surveyName, "debug"), /* @__PURE__ */ M.jsx(vh, { children: "debug" });
    case "log":
      return r.log(n.surveyName, "log"), /* @__PURE__ */ M.jsx(vh, { children: "log" });
    case "info":
      return r.info(n.surveyName, "info"), /* @__PURE__ */ M.jsx(vh, { children: "info" });
    case "warn":
      return r.warn(n.surveyName, "warn"), /* @__PURE__ */ M.jsx(vh, { children: "warn" });
    case "error":
      return r.error("error", {
        error: new Error("Test error"),
        context: n.surveyName
      }), /* @__PURE__ */ M.jsx(vh, { children: "error" });
    default:
      return /* @__PURE__ */ M.jsx(vh, { children: "no logging type set" });
  }
}, vh = Ce.div`
  display: flex;
  flex-direction: column;
  // width: 800px;
  justify-content: center;
  align-items: baseline;
  @media (min-width: 0px) and (max-width: 479px) {
    margin: 10px;
  }
`, q$ = D.forwardRef(
  ({ onClick: e, text: t, active: n, colour: r, contrastColour: i, glow: o, shadeColour: a }, s) => {
    const c = ho();
    return /* @__PURE__ */ M.jsx(
      Tyt,
      {
        onClick: e,
        borderRadius: c,
        active: n,
        primaryColour: r,
        glow: o,
        ref: s,
        children: /* @__PURE__ */ M.jsx(Iyt, { children: t })
      }
    );
  }
);
q$.displayName = "UiMatchButton";
const Tyt = Ce(Toe)`
  background-color: ${(e) => e.active ? e.primaryColour : e.shadeColour ? e.shadeColour : "var(--light)"};
  color: ${(e) => e.active ? "var(--light)" : "var(--dark)"};
`, Iyt = Ce.div`
  font-weight: 400;
  font-size: var(--choice-text-font-size);
  text-align: left;
  text-overflow: ellipsis;
  word-wrap: break-word;
  word-break: break-word;
  margin-bottom: 0rem;
`, Ayt = ({
  question: e,
  currentAnswer: t,
  injectCurrent: n,
  submitAnswer: r,
  answers: i,
  settings: o
}) => {
  const { loggingService: a, popupService: s } = St(ir), c = Me(null), [l, u] = Lt(null), [d, f] = Lt([]), { primaryColour: h, contrastColour: p, colourShades: g } = hr(), m = gc(e.leftChoices, i), v = gc(e.rightChoices, i), y = At(() => v.sort((A, O) => Math.random() - 0.5), [v]), S = t.getValue(e.type), _ = (A) => {
    a.debug("startMatch", A), l && l.id === A.id ? u(null) : u(A);
  }, w = (A) => {
    if (a.debug("completeMatch", A, l), l) {
      let O;
      S ? O = S.filter(($) => $.id !== l.value && $.value !== A.value).concat({
        id: l.value,
        value: A.value
      }) : O = [
        {
          id: l.value,
          value: A.value
        }
      ], n({ value: O }), u(null);
    }
  }, T = mn(
    (A) => {
      const O = c.current;
      if (!O)
        return;
      const $ = O.getBoundingClientRect(), N = A.map((z) => {
        const k = iz(z.left, $), F = iz(z.right, $), V = k.x + k.width, j = k.y + k.height / 2, B = F.x, U = F.y + F.height / 2;
        return [V, j, B, U];
      });
      console.log("newCoords", N), f(N);
    },
    [f]
  ), C = Ts({
    selectLeft: { content: "Click on a left option", position: { left: 0, top: 0 } },
    selectRight: { content: "Click on a right option to match", position: { left: 1, top: 0 } },
    allMatched: { content: "Click next to continue" }
  }, e.helpPopups), E = e.showHelpPopups ?? !1, R = e.helpPopupsToShow;
  return gt(() => {
    S !== null && S.length === m.length ? s.setPopup(C, "allMatched", E, R) : l === null ? s.setPopup(C, "selectLeft", E, R) : s.setPopup(C, "selectRight", E, R);
  }, [C, E, R, S, m, l]), /* @__PURE__ */ M.jsxs(Pyt, { children: [
    /* @__PURE__ */ M.jsxs(Myt, { ref: c, children: [
      /* @__PURE__ */ M.jsx(Ryt, { leftHeader: e.leftLabel, rightHeader: e.rightLabel }),
      /* @__PURE__ */ M.jsx(
        $yt,
        {
          leftChoices: m,
          rightChoices: y,
          currentLeft: l,
          startMatch: _,
          completeMatch: w,
          currentAnswerValue: S,
          primaryColour: h,
          colourShades: g,
          onDOMRects: T
        }
      )
    ] }),
    /* @__PURE__ */ M.jsx(Oyt, { lineCoords: d, matchGridRef: c })
  ] });
}, Ryt = ({ leftHeader: e, rightHeader: t }) => !e && !t ? null : /* @__PURE__ */ M.jsxs(M.Fragment, { children: [
  /* @__PURE__ */ M.jsx(rz, { children: e }),
  /* @__PURE__ */ M.jsx(rz, { children: t })
] }), rz = Ce.div`
  /* font-size: 1.5rem; */
  font-weight: bold;
  text-align: center;
`, $yt = ({
  leftChoices: e,
  rightChoices: t,
  currentLeft: n,
  primaryColour: r,
  startMatch: i,
  completeMatch: o,
  currentAnswerValue: a,
  onDOMRects: s,
  colourShades: c
}) => {
  const l = Me([]), u = Me([]);
  return gt(() => {
    const d = [];
    a == null || a.forEach((f) => {
      const h = e.findIndex((g) => g.value === f.id), p = t.findIndex((g) => g.value === f.value);
      h !== -1 && p !== -1 && d.push({
        left: l.current[h].getBoundingClientRect(),
        right: u.current[p].getBoundingClientRect()
      });
    }), s(d);
  }, [a, e, t, s]), /* @__PURE__ */ M.jsx(M.Fragment, { children: e.map((d, f) => {
    const h = t[f], p = a !== null && a.find((m) => m.value === h.value), g = p ? e.findIndex((m) => m.value === p.id) : null;
    return /* @__PURE__ */ M.jsxs(Oz, { children: [
      /* @__PURE__ */ M.jsx(
        q$,
        {
          onClick: () => i(d),
          text: d.text ? Dr(d.text) : d.value,
          active: a !== null && a.findIndex((m) => m.id === d.value) !== -1 || (n == null ? void 0 : n.id) === d.id,
          colour: c[f],
          contrastColour: "black",
          glow: n !== null && n.id === d.id,
          ref: (m) => {
            m && (l.current[f] = m);
          }
        },
        `${d.id}-left`
      ),
      /* @__PURE__ */ M.jsx(
        q$,
        {
          onClick: () => o(h),
          text: h.text ? Dr(h.text) : h.value,
          active: a !== null && a.findIndex((m) => m.value === h.value) !== -1,
          colour: g !== null ? c[g] : r,
          contrastColour: "black",
          glow: n !== null,
          ref: (m) => {
            m && (u.current[f] = m);
          }
        },
        `${h.id}-right`
      )
    ] }, d.id);
  }) });
}, Oyt = ({ lineCoords: e, matchGridRef: t }) => {
  var i;
  const { width: n, height: r } = ((i = t.current) == null ? void 0 : i.getBoundingClientRect()) ?? { width: 0, height: 0 };
  return console.log("lineCoords", e, n, r), /* @__PURE__ */ M.jsx(
    kyt,
    {
      width: "100%",
      height: "100%",
      viewBox: `0 0 ${n} ${r}`,
      xmlns: "http://www.w3.org/2000/svg",
      preserveAspectRatio: "none",
      children: e.map(([o, a, s, c], l) => /* @__PURE__ */ M.jsx(
        Nyt,
        {
          x1: o * n,
          y1: a * r,
          x2: s * n,
          y2: c * r,
          stroke: "#3C4142",
          strokeWidth: "2",
          strokeLinecap: "round"
        },
        c.toString() + a.toString()
      ))
    }
  );
};
function iz(e, t) {
  return {
    x: (e.x - t.x) / t.width,
    y: (e.y - t.y) / t.height,
    height: e.height / t.height,
    width: e.width / t.width
  };
}
const Pyt = Ce.div`
  position: relative;
  /* display: flex;
  flex-direction: column; */
`, Myt = Ce.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  column-gap: 5rem;
  row-gap: 1rem;
`, kyt = Ce.svg`
  position: absolute;
  top: 0;
  pointer-events: none;
  /* flex: 1 1; */
`, Nyt = Ce.line`
  @keyframes grow {
    from {
      stroke-dashoffset: 500;
    }
    to {
      stroke-dashoffset: 0;
    }
  }
  stroke-dasharray: 500;
  animation: grow 1s ease-out forwards;
`, ese = (e) => {
  const t = ho(), n = {
    ...e,
    borderRadius: t
  };
  return /* @__PURE__ */ M.jsx(Dyt, { ...n, type: "button" });
}, Dyt = Ce(ck)`
  flex: 1;
  justify-content: center;
  text-align: center;
  border: 1px solid var(--mid);
  background-color: ${(e) => e.active ? e.primaryColour : e.shadeColour ? e.shadeColour : "var(--light)"};
  font-size: var(--choice-text-font-size);
  /* font-weight: ${(e) => e.active ? "500" : "400"}; */
  color: ${(e) => e.active ? "var(--light)" : "var(--dark)"};
`, Lyt = ({
  answers: e,
  question: t,
  currentAnswer: n,
  injectCurrent: r,
  submitAnswer: i,
  settings: o
}) => {
  const a = Dn(t.statements, { answers: e }), s = At(() => a || [], [a]), c = gc(t.choices, e), { primaryColour: l, contrastColour: u, shadeColour: d } = hr(), f = n.getValue(t.type) || {}, h = mn(() => {
    if (!t.defaultValues)
      return;
    const g = t.defaultValues({
      answers: e,
      choices: c,
      statements: s
    }), m = {};
    for (const [v, y] of Object.entries(g)) {
      const S = c.find((w) => w.id === y), _ = s.find((w) => w.id === v);
      S && _ && (m[_.id] = {
        id: S.id,
        value: S.value,
        info: { statementValue: _.value }
      });
    }
    if (Object.keys(m).length > 0)
      return m;
  }, [t, e, c, s]);
  kf(h, t, n, e, r);
  const p = (g, m) => {
    const v = n.getValue(t.type) || {}, y = {
      ...v,
      [g.id]: {
        id: m.id,
        value: m.value,
        info: { statementValue: g.value }
      }
    }, S = s.length, _ = Object.keys(y).length, w = Object.keys(v).length, T = {
      valid: _ === S,
      messages: _ === S ? [] : ["This question requires an answer for every row"]
    };
    t.autoNext && _ === S && w === S - 1 ? (r({ value: y, validity: T }), i()) : r({ value: y, validity: T });
  };
  return /* @__PURE__ */ M.jsx(Byt, { children: s.map((g, m) => /* @__PURE__ */ M.jsx(
    jyt,
    {
      statement: g,
      choices: c,
      currentValue: f,
      primaryColour: l,
      contrastColour: u,
      shadeColour: t.shade ? d : void 0,
      updateMatrixAnswer: p
    },
    g.id
  )) });
}, jyt = ({
  statement: e,
  choices: t,
  currentValue: n,
  primaryColour: r,
  contrastColour: i,
  shadeColour: o,
  updateMatrixAnswer: a
}) => {
  const s = wa(), c = e.toolTip ? /* @__PURE__ */ M.jsx(Pf, { placement: "topLeft", title: e.toolTip, children: /* @__PURE__ */ M.jsx(oz, { children: e.text ? Dr(e.text) : e.value }) }) : /* @__PURE__ */ M.jsx(oz, { children: e.text ? Dr(e.text) : e.value });
  return /* @__PURE__ */ M.jsxs(zyt, { children: [
    c,
    /* @__PURE__ */ M.jsx(Hyt, { device: s, children: t.map((l) => /* @__PURE__ */ M.jsx(
      Vyt,
      {
        choice: l,
        primaryColour: r,
        contrastColour: i,
        shadeColour: l.fill ?? o,
        active: Fyt(e, l, n),
        onClick: () => a(e, l)
      },
      `${e.id}-${l.id}`
    )) })
  ] });
};
function Fyt(e, t, n) {
  if (!(e.id in n))
    return !1;
  const r = Az(n[e.id]);
  return r ? r.id === t.id : !1;
}
const Vyt = ({
  choice: e,
  primaryColour: t,
  contrastColour: n,
  shadeColour: r,
  active: i,
  onClick: o
}) => {
  let a = /* @__PURE__ */ M.jsx(
    ese,
    {
      primaryColour: t,
      contrastColour: n,
      shadeColour: r,
      active: i,
      onClick: o,
      children: e.text ? Dr(e.text) : e.value
    }
  );
  return e.toolTip && (a = /* @__PURE__ */ M.jsx(Pf, { placement: "topLeft", title: e.toolTip, children: a })), a;
}, Byt = Ce.div`
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 1rem;
`, zyt = Ce.div`
  word-wrap: break-word;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`, oz = Ce.div`
  font-weight: 500;
  font-size: var(--question-text-font-size);
`, Hyt = Ce.div`
  display: flex;
  justify-content: space-between;
  gap: 0.5rem;
  flex-direction: ${({ device: e }) => e === ui.MOBILE ? "column" : "row"};
`, Uyt = Ce(VC)`
  max-width: 40rem;
`, Wyt = ({
  question: e,
  currentAnswer: t,
  injectCurrent: n,
  submitAnswer: r,
  answers: i,
  settings: o
}) => {
  var _;
  const { loggingService: a, messagerService: s, popupService: c } = St(ir), l = gc(e.choices, i);
  a.info("getDefaultChoices", l);
  const u = mn(() => {
    if (!e.defaultValues)
      return;
    const w = e.defaultValues({ answers: i, choices: l }), T = l.filter(
      (x) => w.some((C) => C === x.id)
    );
    if (T.length !== 0)
      return a.debug("MultiDropdown defaults", w, l, T), T.map((x) => ({
        id: x.id,
        value: x.value
      }));
  }, [e, i, l, a]);
  kf(u, e, t, i, n);
  const d = () => {
    s.error(
      `Oops, looks like you have tried to select more than ${e.max} answers. To choose another answer, please deselect one of your current choices.`
    );
  }, f = (w) => {
    if (Wn.isArray(w)) {
      if (e.max && w.length > e.max) {
        d();
        return;
      }
      const T = l.filter((x) => w.includes(x.value)).map((x) => ({ id: x.id, value: x.value }));
      n({
        value: T
      });
    } else
      throw new Error("Dropdown question did not receive an array as a current answer value");
  };
  a.debug("MultiDropdownQuestion: currentAnswer", t);
  const h = (_ = t.getValue(e.type)) == null ? void 0 : _.map((w) => w.value);
  a.debug(
    "options as string",
    l.map((w) => String(w.text || w.value))
  );
  const p = e.max ?? l.length, g = {
    notSatisfied: {
      content: `Please select up to ${p} options`,
      position: { top: 1 }
    },
    satisfied: { content: "Click next to continue", position: { top: 1 } },
    notRequired: {
      content: `Please select up to ${p} options or click next to continue`,
      position: { top: 1 }
    }
  }, m = Ts(g, e.helpPopups), v = e.showHelpPopups ?? !1, y = e.helpPopupsToShow, S = h ?? [];
  return gt(() => {
    e.required ? S.length === 0 || S.length > p ? c.setPopup(m, "notSatisfied", v, y) : c.setPopup(m, "satisfied", v, y) : c.setPopup(m, "notRequired", v, y);
  }, [m, v, y, e.required, S]), /* @__PURE__ */ M.jsx(
    Wk,
    {
      options: l.map((w) => {
        const T = w.text ? Dr(w.text) : w.value;
        return {
          id: w.id,
          value: w.value,
          label: T
        };
      }),
      value: h,
      onChange: f,
      multiple: !0
    }
  );
}, qyt = Ce.input.attrs({ type: "checkbox" })`
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;

  &:checked ~ span {
    background-color: ${(e) => e.primaryColour};
  }

  &:checked ~ span:after {
    display: block;
  }
`, Gyt = Ce.label`
  display: flex;
  align-items: center;
  height: 32px;
  position: relative;
  padding-left: 40px;
  cursor: pointer;
  user-select: none;

  @media (hover: hover) {
    &:hover input ~ span {
      border: 1px solid ${(e) => e.primaryColour};
      box-shadow: 0 0 5px 0px rgba(0, 0, 0, 0.3);
    }
  }
`, Kyt = Ce.span`
  position: absolute;
  top: 0;
  left: 0;
  height: 32px;
  width: 32px;
  background-color: var(--light);
  border: 1px solid var(--mid);
  border-radius: ${(e) => e.borderRadius};
  transition: all 300ms ease;

  &:after {
    content: '';
    position: absolute;
    display: none;

    left: 11px;
    top: 6px;
    width: 6px;
    height: 12px;
    border: solid var(--light);
    border-width: 0 3px 3px 0;
    transform: rotate(45deg);
  }
`, Yyt = ({ label: e, checked: t, onChange: n, primaryColour: r }) => {
  const i = ho();
  return /* @__PURE__ */ M.jsxs(Gyt, { primaryColour: r, borderRadius: i, children: [
    e,
    /* @__PURE__ */ M.jsx(
      qyt,
      {
        primaryColour: r,
        borderRadius: i,
        checked: t,
        onChange: n
      }
    ),
    /* @__PURE__ */ M.jsx(Kyt, { primaryColour: r, borderRadius: i })
  ] });
};
function Xyt(e) {
  const { value: t, onChange: n, primaryColour: r, step: i, min: o, max: a, suffix: s } = e;
  return /* @__PURE__ */ M.jsx(
    lo,
    {
      theme: r ? {
        token: {
          colorPrimary: r
        }
      } : void 0,
      children: /* @__PURE__ */ M.jsx(
        Ske,
        {
          value: t,
          onChange: (c) => {
            n(c);
          },
          step: i,
          min: o,
          max: a,
          addonAfter: s
        }
      )
    }
  );
}
const tse = ({
  value: e,
  marks: t,
  max: n,
  min: r,
  step: i,
  tipFormatter: o,
  onChange: a,
  vertical: s,
  primaryColor: c,
  sliderStyle: l,
  tooltipPlacement: u
}) => {
  const d = Me(null), [f, h] = D.useState(null), p = wa(), g = Hk(), m = (y) => {
    typeof y == "number" && a && a(y);
  };
  let v;
  return o == null ? v = o : v = (y) => {
    if (y !== void 0)
      return o(y);
  }, Nv(() => {
    const y = d.current;
    if (y) {
      const S = y.querySelectorAll(".ant-slider-mark-text");
      if (S.length > 0) {
        let _ = 0;
        S.forEach((w) => {
          const T = w.getBoundingClientRect();
          T.height > _ && (_ = T.height);
        }), h(_);
      }
    }
  }, [f, h, t]), s ? /* @__PURE__ */ M.jsx(lo, { theme: g, children: /* @__PURE__ */ M.jsx(Qyt, { children: /* @__PURE__ */ M.jsx(
    wR,
    {
      value: e ?? r ?? 0,
      vertical: s,
      marks: t,
      max: n,
      min: r,
      step: i,
      tooltip: { formatter: v, placement: u },
      onChange: m,
      reverse: !0
    }
  ) }) }) : /* @__PURE__ */ M.jsx(lo, { theme: g, children: /* @__PURE__ */ M.jsx(Jyt, { device: p, marksHeight: f, ref: d, children: /* @__PURE__ */ M.jsx(
    wR,
    {
      value: e ?? r ?? 0,
      vertical: s,
      marks: t,
      max: n,
      min: r,
      step: i,
      tooltip: { formatter: v, placement: u },
      onChange: m
    }
  ) }) });
}, Qyt = Ce.div`
  height: 50vh;
  margin: 3rem;
  align-self: center;
`, Jyt = Ce.div`
  width: 100%;
  padding-bottom: ${(e) => e.marksHeight ?? 0}px;
  align-self: center;
  padding-left: ${(e) => e.device === ui.MOBILE ? "var(--spacing-sm)" : "0"};
  padding-right: ${(e) => e.device === ui.MOBILE ? "var(--spacing-sm)" : "0"};
`;
function Zyt(e) {
  const { value: t, onChange: n, type: r, placeholder: i, primaryColour: o } = e;
  return /* @__PURE__ */ M.jsx(
    lo,
    {
      theme: o ? {
        token: {
          colorPrimary: o
        }
      } : void 0,
      children: /* @__PURE__ */ M.jsx(
        oNe,
        {
          value: t,
          onChange: (a) => {
            n(a.target.value);
          },
          type: r,
          placeholder: i
        }
      )
    }
  );
}
const nse = ({
  question: e,
  currentAnswer: t,
  answers: n,
  injectCurrent: r,
  updateCurrent: i,
  settings: o,
  setNextButtonBehaviour: a
}) => {
  const { popupService: s, messagerService: c } = St(ir), { primaryColour: l } = hr(), u = t.getValue(e.type);
  let d = Dn(e.max, { answers: n }) ?? 100, f = e.min ?? 0, h = e.step ?? 1;
  d = XT(d, e.scaleType), f = XT(f, e.scaleType), h = tbt(h, f, d, e.steps, e.scaleType);
  const p = u != null && u.value ? XT(Number(u.value), e.scaleType) : void 0, g = rse(
    e.tooltipFormatter,
    e.hideTooltip,
    e.scaleType
  ), m = nbt(e.marks, e.scaleType), v = mn(() => {
    if (!e.defaultValues)
      return;
    const x = e.defaultValues({ answers: n });
    return { id: x, value: x.toString() };
  }, [e, n]);
  kf(v, e, t, n, r);
  const y = (x) => {
    const C = ebt(x, e.scaleType), E = {
      id: C,
      value: C.toString()
    };
    r({ value: E });
  };
  gt(() => {
    const x = t.getValue(e.type);
    if (!e.required)
      return;
    a(x !== null ? void 0 : () => {
      const E = { id: e.id, value: (e.min ?? 0).toString() };
      r({ value: E }), c.warning(
        `It looks like you haven't made any changes to the slider. If you're happy with the placement value, please click "Next" again.`
      );
    });
  }, [e.required, e.type, t, r, a]);
  const _ = Ts({
    default: {
      content: "Click and drag the slider to select a value, and click next to continue"
    },
    notRequired: {
      content: "Please click and drag the slider to select a value, or click next to continue "
    }
  }, e.helpPopups), w = e.showHelpPopups ?? !1, T = e.helpPopupsToShow;
  return gt(() => {
    e.required ? s.setPopup(_, "default", w, T) : s.setPopup(_, "notRequired", w, T);
  }, [_, w, T, e.required]), /* @__PURE__ */ M.jsx(
    tse,
    {
      value: p,
      vertical: e.vertical,
      marks: m,
      max: d,
      min: f,
      step: h,
      tipFormatter: g,
      onChange: y,
      primaryColor: l,
      tooltipPlacement: e.tooltipPlacement
    }
  );
};
function XT(e, t) {
  if (!t || e === void 0)
    return e;
  switch (t) {
    case "log":
      return Math.log(e);
    case "linear":
      return e;
  }
}
function ebt(e, t) {
  if (!t)
    return e;
  switch (t) {
    case "log":
      return Math.exp(e);
    case "linear":
      return e;
  }
}
function tbt(e, t, n, r = 100, i) {
  if (!i)
    return e;
  switch (i) {
    case "log":
      return (n - t) / r;
    case "linear":
      return e;
  }
}
function rse(e, t, n) {
  if (t)
    return null;
  if (!n)
    return e;
  switch (n) {
    case "log":
      return (r) => e ? e(Math.exp(r)) : Gse(Math.exp(r), 2);
    case "linear":
      return e;
  }
}
function nbt(e, t) {
  if (!e)
    return {};
  switch (t) {
    case "log":
      return Object.fromEntries(
        Object.entries(e).map(([n, r]) => [Math.log(Number(n)), r])
      );
    case "linear":
    default:
      return Object.fromEntries(Object.entries(e).map(([n, r]) => [parseInt(n), r]));
  }
}
const rbt = ({
  question: e,
  currentAnswer: t,
  injectCurrent: n,
  submitAnswer: r,
  answers: i,
  settings: o
}) => {
  const { primaryColour: a } = hr(), s = Dn(e.inputs, { answers: i }) ?? [], c = mn(() => {
    if (e.defaultValues)
      return e.defaultValues({ answers: i });
  }, [e, i]);
  kf(c, e, t, i, n);
  function l(d) {
    var f;
    if (!(t.getValue(e.type) === null || !Wn.isArray(t.getValue(e.type))))
      return (f = t.getValue(e.type)) == null ? void 0 : f.find((h) => h.id === d);
  }
  function u(d, f) {
    var h;
    if (t.getValue(e.type)) {
      const p = ((h = t.getValue(e.type)) == null ? void 0 : h.filter((g) => g.id !== f.id)) || [];
      if (Wn.isNull(d))
        n({ value: p, validity: QT(p, s) });
      else {
        let g = p.concat([
          { id: f.id, value: d }
        ]);
        e.answerModifier && (g = e.answerModifier({ id: f.id, value: d }, g)), n({ value: g, validity: QT(g, s) });
      }
    } else {
      if (Wn.isNull(d))
        return;
      {
        let p = [{ id: f.id, value: d }];
        e.answerModifier && (p = e.answerModifier({ id: f.id, value: d }, p)), n({ value: p, validity: QT(p, s) });
      }
    }
  }
  return /* @__PURE__ */ M.jsx(hbt, { children: s.map((d) => /* @__PURE__ */ M.jsx(
    ibt,
    {
      input: d,
      getAnswerValue: l,
      updateAnswerValue: u,
      currentAnswer: t,
      answers: i,
      primaryColour: a,
      question: e
    },
    d.id
  )) });
};
function ibt({
  input: e,
  getAnswerValue: t,
  updateAnswerValue: n,
  currentAnswer: r,
  answers: i,
  primaryColour: o,
  question: a
}) {
  const { shadeColour: s } = hr();
  switch (e.type) {
    case "slider":
      return /* @__PURE__ */ M.jsx(Ls, { children: /* @__PURE__ */ M.jsx(
        obt,
        {
          input: e,
          getAnswerValue: t,
          updateAnswerValue: n,
          currentAnswer: r,
          answers: i,
          primaryColour: o,
          sliderStyle: e.sliderStyle
        }
      ) }, e.id);
    case "number":
      return /* @__PURE__ */ M.jsx(Ls, { layout: a.layout, children: /* @__PURE__ */ M.jsx(
        abt,
        {
          input: e,
          getAnswerValue: t,
          updateAnswerValue: n,
          currentAnswer: r,
          answers: i,
          primaryColour: o
        }
      ) }, e.id);
    case "text":
      return /* @__PURE__ */ M.jsx(Ls, { layout: a.layout, children: /* @__PURE__ */ M.jsx(
        az,
        {
          input: e,
          getAnswerValue: t,
          updateAnswerValue: n,
          currentAnswer: r,
          answers: i,
          primaryColour: o
        }
      ) }, e.id);
    case "email":
      return /* @__PURE__ */ M.jsx(Ls, { layout: a.layout, children: /* @__PURE__ */ M.jsx(
        az,
        {
          input: e,
          getAnswerValue: t,
          updateAnswerValue: n,
          currentAnswer: r,
          answers: i,
          textInputType: "email",
          primaryColour: o
        }
      ) }, e.id);
    case "dropdown":
      return /* @__PURE__ */ M.jsx(Ls, { layout: a.layout, children: /* @__PURE__ */ M.jsx(
        sbt,
        {
          input: e,
          getAnswerValue: t,
          updateAnswerValue: n,
          currentAnswer: r,
          answers: i,
          primaryColour: o,
          shadeColour: a.shade ? s : void 0
        }
      ) }, e.id);
    case "commentBox":
      return /* @__PURE__ */ M.jsx(Ls, { layout: a.layout, children: /* @__PURE__ */ M.jsx(
        cbt,
        {
          input: e,
          getAnswerValue: t,
          updateAnswerValue: n,
          currentAnswer: r,
          answers: i,
          primaryColour: o
        }
      ) }, e.id);
    case "checkbox":
      return /* @__PURE__ */ M.jsx(Ls, { layout: a.layout, children: /* @__PURE__ */ M.jsx(
        lbt,
        {
          input: e,
          getAnswerValue: t,
          updateAnswerValue: n,
          currentAnswer: r,
          answers: i,
          primaryColour: o
        }
      ) }, e.id);
    case "label-only":
      return /* @__PURE__ */ M.jsx(Ls, { layout: a.layout, children: /* @__PURE__ */ M.jsx(Gf, { ...e }) }, e.id);
    case "matrix-row":
      return /* @__PURE__ */ M.jsx(Ls, { layout: a.layout, children: /* @__PURE__ */ M.jsx(
        ubt,
        {
          input: e,
          getAnswerValue: t,
          updateAnswerValue: n,
          currentAnswer: r,
          answers: i,
          primaryColour: o
        }
      ) }, e.id);
    default:
      return /* @__PURE__ */ M.jsxs(Ls, { layout: a.layout, children: [
        "Input type ",
        e.type,
        " not implemented"
      ] }, e.id);
  }
}
function obt({
  input: e,
  getAnswerValue: t,
  updateAnswerValue: n,
  primaryColour: r
}) {
  var u;
  const i = (u = t(e.id)) == null ? void 0 : u.value, o = i ? parseFloat(i) : void 0, a = Dn(e.marks, void 0);
  function s(d) {
    return Iz(d) && !("label" in d) && !("style" in d);
  }
  let c;
  a && (c = Object.fromEntries(
    Object.entries(a).map(([d, f]) => s(f) ? [d, hv(f)] : f.label === void 0 ? [d, f] : [d, { label: hv(f.label), style: f.style }])
  ));
  const l = rse(e.tooltipFormatter, e.hideTooltip, e.scaleType);
  return /* @__PURE__ */ M.jsxs(M.Fragment, { children: [
    /* @__PURE__ */ M.jsx(Gf, { ...e }),
    /* @__PURE__ */ M.jsx(
      tse,
      {
        value: o,
        min: e.min,
        max: e.max,
        step: e.step,
        marks: c,
        onChange: (d) => n(d.toString(), e),
        primaryColor: r,
        tipFormatter: l,
        sliderStyle: e.sliderStyle
      }
    ),
    e.displayValue && /* @__PURE__ */ M.jsx("div", { children: e.displayValue(o) })
  ] });
}
function abt({
  input: e,
  getAnswerValue: t,
  updateAnswerValue: n,
  currentAnswer: r,
  answers: i,
  primaryColour: o
}) {
  var l;
  const a = (l = t(e.id)) == null ? void 0 : l.value, s = a ? parseFloat(a) : void 0;
  let c;
  return typeof e.suffix == "function" ? c = e.suffix({ inputValue: s, currentAnswer: r, answers: i }) : c = e.suffix || "", /* @__PURE__ */ M.jsxs(M.Fragment, { children: [
    /* @__PURE__ */ M.jsx(Gf, { ...e }),
    /* @__PURE__ */ M.jsx(
      Xyt,
      {
        value: s,
        step: e.step,
        min: e.min,
        max: e.max,
        onChange: (u) => {
          const d = Wn.isUndefined(u) || Wn.isNull(u) ? null : u.toString();
          return n(d, e);
        },
        suffix: c,
        primaryColour: o
      }
    )
  ] });
}
function az({
  input: e,
  textInputType: t,
  getAnswerValue: n,
  updateAnswerValue: r,
  primaryColour: i
}) {
  var a;
  const o = (a = n(e.id)) == null ? void 0 : a.value;
  return /* @__PURE__ */ M.jsxs(M.Fragment, { children: [
    /* @__PURE__ */ M.jsx(Gf, { ...e }),
    /* @__PURE__ */ M.jsx(
      Zyt,
      {
        value: o,
        onChange: (s) => r(s, e),
        type: t,
        primaryColour: i
      }
    )
  ] });
}
function sbt({
  input: e,
  answers: t,
  updateAnswerValue: n,
  getAnswerValue: r,
  primaryColour: i,
  shadeColour: o
}) {
  var l;
  const a = gc(e.choices ?? [], t), s = (u) => {
    if (Wn.isArray(u))
      throw new Error("Dropdown question received an array as a current answer value");
    return n(u.toString(), e);
  }, c = (l = r(e.id)) == null ? void 0 : l.value;
  return /* @__PURE__ */ M.jsxs(M.Fragment, { children: [
    /* @__PURE__ */ M.jsx(Gf, { ...e }),
    /* @__PURE__ */ M.jsx(
      Wk,
      {
        value: c,
        options: a.map((u) => {
          const d = u.text ? Dr(u.text) : u.value;
          return {
            id: u.id,
            value: u.value,
            label: d
          };
        }),
        onChange: (u) => s(u)
      }
    )
  ] });
}
function cbt({
  input: e,
  textInputType: t,
  getAnswerValue: n,
  updateAnswerValue: r,
  primaryColour: i,
  currentAnswer: o
}) {
  var s;
  const a = ((s = n(e.id)) == null ? void 0 : s.value) ?? "";
  return /* @__PURE__ */ M.jsxs(M.Fragment, { children: [
    /* @__PURE__ */ M.jsx(Gf, { ...e }),
    /* @__PURE__ */ M.jsx(
      Uk,
      {
        dynamicColour: i,
        value: a,
        onChange: (c) => {
          const l = c.target.value;
          r(l, e);
        }
      }
    )
  ] });
}
function lbt({
  input: e,
  textInputType: t,
  getAnswerValue: n,
  updateAnswerValue: r,
  primaryColour: i,
  currentAnswer: o
}) {
  var s;
  const a = ((s = n(e.id)) == null ? void 0 : s.value) ?? "";
  return /* @__PURE__ */ M.jsx(M.Fragment, { children: /* @__PURE__ */ M.jsx(
    Yyt,
    {
      label: Dr(e.label),
      checked: a === "true",
      onChange: (c) => r(c.target.checked.toString(), e),
      primaryColour: i
    }
  ) });
}
function ubt({
  input: e,
  getAnswerValue: t,
  updateAnswerValue: n,
  answers: r,
  primaryColour: i,
  shadeColour: o
}) {
  const a = wa(), s = gc(e.choices ?? [], r);
  return /* @__PURE__ */ M.jsxs(M.Fragment, { children: [
    /* @__PURE__ */ M.jsx(Gf, { ...e }),
    /* @__PURE__ */ M.jsx(gbt, { children: /* @__PURE__ */ M.jsx(pbt, { device: a, children: s.map((c) => {
      var l;
      return /* @__PURE__ */ M.jsx(
        dbt,
        {
          choice: c,
          primaryColour: i,
          shadeColour: c.fill ?? o,
          active: ((l = t(e.id)) == null ? void 0 : l.value) === c.value,
          onClick: () => n(c.value, e)
        },
        c.id
      );
    }) }) })
  ] });
}
const dbt = ({
  choice: e,
  primaryColour: t,
  shadeColour: n,
  active: r,
  onClick: i
}) => {
  let o = /* @__PURE__ */ M.jsx(
    ese,
    {
      primaryColour: t,
      shadeColour: n,
      active: r,
      onClick: i,
      children: e.text ? Dr(e.text) : e.value
    }
  );
  return e.toolTip && (o = /* @__PURE__ */ M.jsx(BC, { placement: "topLeft", title: e.toolTip, children: o })), o;
};
function Gf(e) {
  const t = Dn(e.tooltip, void 0), n = hv(e.label);
  return t ? /* @__PURE__ */ M.jsx(sz, { children: /* @__PURE__ */ M.jsx(BC, { title: t, children: n }) }) : /* @__PURE__ */ M.jsx(sz, { children: n });
}
function QT(e, t) {
  return Wn.isNull(e) ? { valid: !1, messages: ["This question requires an answer"] } : e.every((n) => n.value.length > 0) && e.length === t.length ? fbt(e, t) : {
    valid: !1,
    messages: ["All questions on this page require an answer"]
  };
}
function fbt(e, t) {
  const n = [];
  return { valid: t.every((i) => {
    const o = e.find((a) => a.id === i.id);
    switch (i.type) {
      case "text":
      case "number":
      case "slider":
        break;
      case "email":
        if (!o || !Kse(o.value))
          return n.push("Please enter a valid email address"), !1;
    }
    return !0;
  }), messages: n };
}
const hbt = Ce.div`
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 1rem;
`, Ls = Ce.div`
  display: flex;
  gap: 0.5rem;
  flex-direction: ${(e) => e.layout === "beside" ? "row" : "column"};
  align-items: stretch;
`, sz = Ce.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`, gbt = Ce.div`
  word-wrap: break-word;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`, pbt = Ce.div`
  display: flex;
  justify-content: space-between;
  gap: 0.5rem;
  flex-direction: ${({ device: e }) => e === ui.MOBILE ? "column" : "row"};
`, qk = (e) => {
  const {
    inputValue: t,
    onValueChange: n,
    label: r,
    placeholder: i,
    type: o,
    shadeColour: a,
    primaryColour: s,
    active: c,
    noBorder: l
  } = e, u = ho();
  return /* @__PURE__ */ M.jsxs(
    mbt,
    {
      dynamicColour: s,
      shadeColour: a,
      borderRadius: u,
      active: c,
      noBorder: l,
      children: [
        /* @__PURE__ */ M.jsx(
          "input",
          {
            type: o ?? "text",
            placeholder: i,
            value: t,
            onChange: (d) => n(d)
          }
        ),
        /* @__PURE__ */ M.jsx("hr", {}),
        /* @__PURE__ */ M.jsx("label", { children: r })
      ]
    }
  );
}, mbt = Ce.fieldset`
  height: var(--text-input-height);
  width: 100%;
  position: relative;
  padding: 0;
  border: none;
  overflow: visible;

  input {
    box-sizing: border-box;
    width: inherit;
    height: inherit;
    border-radius: ${(e) => e.borderRadius};
    padding: var(--spacing-sm) var(--spacing-sm) var(--spacing-xs);
    box-shadow: none;
    border-style: ${(e) => e.noBorder ? "none" : "solid"};
    border-width: ${(e) => e.active ? "2px" : "1px"};
    border-color: ${(e) => e.active ? e.dynamicColour : "var(--mid)"};
    background-color: ${(e) => e.active ? "var(--light)" : e.shadeColour ? e.shadeColour : "var(--light)"};
    font-size: var(--choice-text-font-size);
    outline: none;
    cursor: text;

    @media (hover: hover) {
      &:hover {
        border-color: ${(e) => e.dynamicColour};
        box-shadow: 0 0 5px 0px rgba(0, 0, 0, 0.3);
        animation: none;
      }
    }
    &:focus {
      border-color: ${(e) => e.dynamicColour};
      border-width: 2px;
    }

    &::-moz-placeholder {
      transition: color 300ms ease;
    }
    &:not(:focus)::-moz-input-placeholder {
      color: transparent;
    }

    &::-webkit-input-placeholder {
      transition: color 300ms ease;
    }
    &:not(:focus)::-webkit-input-placeholder {
      color: transparent;
    }
  }

  hr {
    content: '';
    display: block;
    position: absolute;
    bottom: var(--spacing-sm);
    left: ${(e) => e.borderRadius};
    margin: 0;
    padding: 0;
    width: calc(100% - 2 * ${(e) => e.borderRadius});
    height: 2px;
    border: none;
    /* background: ${(e) => e.dynamicColour}; */
    background: var(--mid);
    font-size: 1px;
    will-change: transform, visibility;
    transition: all 200ms ease-out;
    transform: scaleX(0);
    visibility: hidden;
    z-index: 10;
  }
  input:focus ~ hr {
    transform: scaleX(1);
    visibility: visible;
  }

  label {
    position: absolute;
    top: var(--spacing-xxs);
    left: var(--spacing-sm);
    font-size: var(--text-input-label-font-size);
    color: var(--dark);
    pointer-events: none;
  }
`;
function vbt(e) {
  return Array(e).fill(`${100 / e}%`).join(" ");
}
function ybt(e, t) {
  return t === ui.MOBILE ? 1 : e || 1;
}
const bbt = Ce.div`
  display: grid;
  grid-template-columns: ${(e) => vbt(e.numColumns)};
  column-gap: 0.5rem;
  row-gap: 0.5rem;
`, ise = (e) => {
  const { children: t, numColumns: n } = e, r = wa(), i = ybt(n, r), o = (t == null ? void 0 : t.length) || 1, a = Math.ceil(o / i);
  return /* @__PURE__ */ M.jsx(bbt, { numColumns: i, numRows: a, children: t });
}, _bt = ({
  question: e,
  answers: t,
  currentAnswer: n,
  settings: r,
  submitAnswer: i,
  updateCurrent: o,
  injectCurrent: a
}) => {
  const { loggingService: s, messagerService: c, popupService: l } = St(ir), u = n == null ? void 0 : n.getValue(e.type), d = gc(e.choices, t), f = mn(() => {
    if (s.info("getDefaultChoices", d), !e.defaultValues)
      return;
    const _ = e.defaultValues({ answers: t, choices: d }), w = d.filter(
      (T) => _.some((x) => x === T.id)
    );
    if (w.length !== 0)
      return s.debug("MultiSelect defaults", _, d, w), w.map((T) => ({
        id: T.id,
        value: T.value
      }));
  }, [e, t, d, s]);
  kf(f, e, n, t, a);
  const h = () => {
    c.error(
      `Oops, looks like you have tried to select more than ${e.max} answers. Clicking a selected answer again removes it from selection.`
    );
  }, p = e.min ?? 1, g = e.max ?? d.length, m = {
    notSatisfied: { content: `Please select between ${p} to ${g} options` },
    satisfied: { content: "Click next to continue" },
    notRequired: {
      content: `Please select between ${p} to ${g} options or click next to continue`
    }
  }, v = Ts(m, e.helpPopups), y = e.showHelpPopups ?? !1, S = e.helpPopupsToShow;
  return gt(() => {
    e.required ? u === null || u.length < p || u.length > g ? l.setPopup(v, "notSatisfied", y, S) : l.setPopup(v, "satisfied", y, S) : l.setPopup(v, "notRequired", y, S);
  }, [v, y, S, e.required, u, p, g]), /* @__PURE__ */ M.jsx(ise, { settings: r, numColumns: e.numColumns, children: d.map((_) => /* @__PURE__ */ M.jsx(
    Sbt,
    {
      choice: _,
      currentAnswerValue: u,
      injectCurrent: a,
      submitAnswer: i,
      maxChoices: e.max,
      onTooMany: h,
      shadeButton: e.shade ?? !1
    },
    _.id
  )) });
};
function Sbt(e) {
  switch (e.choice.type) {
    case "input":
      return /* @__PURE__ */ M.jsx(wbt, { ...e });
    default:
      return /* @__PURE__ */ M.jsx(xbt, { ...e });
  }
}
function wbt({
  choice: e,
  currentAnswerValue: t,
  injectCurrent: n,
  onTooMany: r,
  maxChoices: i,
  shadeButton: o
}) {
  const { primaryColour: a, shadeColour: s } = hr(), c = (l, u) => {
    const d = l.target.value, f = t ?? [], h = f.some((g) => g.id === u.id);
    let p;
    d === "" ? (p = f.filter((g) => g.id !== u.id), n({ value: p })) : i && i === f.length && !h ? r() : (p = [
      ...f.filter((g) => {
        var m;
        return !((m = g.info) != null && m.submit);
      }).filter((g) => g.id !== u.id),
      {
        id: u.id,
        value: `${u.value}: ${d}`,
        info: { rawValue: d }
      }
    ], n({ value: p }));
  };
  return /* @__PURE__ */ M.jsx(
    qk,
    {
      type: "text",
      active: ose(e, t),
      inputValue: Ebt(e, t),
      onValueChange: (l) => c(l, e),
      label: e.text ? Dr(e.text) : e.value,
      placeholder: e.placeholder,
      primaryColour: a,
      shadeColour: o ? s : void 0
    },
    e.id
  );
}
function xbt({
  choice: e,
  currentAnswerValue: t,
  injectCurrent: n,
  submitAnswer: r,
  maxChoices: i,
  onTooMany: o,
  shadeButton: a
}) {
  var d;
  const { primaryColour: s, shadeColour: c } = hr(), l = (f) => {
    const h = t || [];
    let p;
    f.submit ? (p = [{ id: f.id, value: f.value, info: { submit: !0 } }], n({ value: p }), r()) : h.some((g) => g.id === f.id) ? (p = h.filter((g) => g.id !== f.id), n({ value: p })) : i && h.length >= i ? o() : (p = h.filter((g) => {
      var m;
      return !((m = g.info) != null && m.submit);
    }).concat([{ id: f.id, value: f.value }]), n({ value: p }));
  };
  let u = a ? c : void 0;
  return (d = e.style) != null && d.backgroundColor && (u = e.style.backgroundColor), /* @__PURE__ */ M.jsx(BC, { title: e.toolTip, children: /* @__PURE__ */ M.jsx(
    Dw,
    {
      active: ose(e, t),
      colour: s,
      shadeColour: u,
      buttonText: e.text ? Dr(e.text) : e.value,
      ButtonIcon: e.icon,
      fill: e.fill,
      onClick: (f) => {
        l(e), Wd(f);
      },
      showInactiveCircle: !e.submit
    },
    e.id
  ) });
}
function ose(e, t) {
  return !!t && t.some((n) => n.id === e.id);
}
function Ebt(e, t) {
  var r, i;
  const n = t ? (i = (r = t.find((o) => o.id === e.id)) == null ? void 0 : r.info) == null ? void 0 : i.rawValue : "";
  return n ? n.toString() : "";
}
var ase = { exports: {} };
/**!
 * Sortable 1.15.3
 * @author	RubaXa   <trash@rubaxa.org>
 * @author	owenm    <owen23355@gmail.com>
 * @license MIT
 */
function cz(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function yc(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? cz(Object(n), !0).forEach(function(r) {
      Cbt(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : cz(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function r_(e) {
  "@babel/helpers - typeof";
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? r_ = function(t) {
    return typeof t;
  } : r_ = function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, r_(e);
}
function Cbt(e, t, n) {
  return t in e ? Object.defineProperty(e, t, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = n, e;
}
function Ha() {
  return Ha = Object.assign || function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Ha.apply(this, arguments);
}
function Tbt(e, t) {
  if (e == null)
    return {};
  var n = {}, r = Object.keys(e), i, o;
  for (o = 0; o < r.length; o++)
    i = r[o], !(t.indexOf(i) >= 0) && (n[i] = e[i]);
  return n;
}
function Ibt(e, t) {
  if (e == null)
    return {};
  var n = Tbt(e, t), r, i;
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    for (i = 0; i < o.length; i++)
      r = o[i], !(t.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(e, r) && (n[r] = e[r]);
  }
  return n;
}
function Abt(e) {
  return Rbt(e) || $bt(e) || Obt(e) || Pbt();
}
function Rbt(e) {
  if (Array.isArray(e))
    return G$(e);
}
function $bt(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null)
    return Array.from(e);
}
function Obt(e, t) {
  if (e) {
    if (typeof e == "string")
      return G$(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set")
      return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
      return G$(e, t);
  }
}
function G$(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++)
    r[n] = e[n];
  return r;
}
function Pbt() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
var Mbt = "1.15.3";
function Zc(e) {
  if (typeof window < "u" && window.navigator)
    return !!/* @__PURE__ */ navigator.userAgent.match(e);
}
var Sl = Zc(/(?:Trident.*rv[ :]?11\.|msie|iemobile|Windows Phone)/i), ib = Zc(/Edge/i), lz = Zc(/firefox/i), R0 = Zc(/safari/i) && !Zc(/chrome/i) && !Zc(/android/i), sse = Zc(/iP(ad|od|hone)/i), cse = Zc(/chrome/i) && Zc(/android/i), lse = {
  capture: !1,
  passive: !1
};
function yn(e, t, n) {
  e.addEventListener(t, n, !Sl && lse);
}
function gn(e, t, n) {
  e.removeEventListener(t, n, !Sl && lse);
}
function Vw(e, t) {
  if (t) {
    if (t[0] === ">" && (t = t.substring(1)), e)
      try {
        if (e.matches)
          return e.matches(t);
        if (e.msMatchesSelector)
          return e.msMatchesSelector(t);
        if (e.webkitMatchesSelector)
          return e.webkitMatchesSelector(t);
      } catch {
        return !1;
      }
    return !1;
  }
}
function use(e) {
  return e.host && e !== document && e.host.nodeType ? e.host : e.parentNode;
}
function ka(e, t, n, r) {
  if (e) {
    n = n || document;
    do {
      if (t != null && (t[0] === ">" ? e.parentNode === n && Vw(e, t) : Vw(e, t)) || r && e === n)
        return e;
      if (e === n)
        break;
    } while (e = use(e));
  }
  return null;
}
var uz = /\s+/g;
function kr(e, t, n) {
  if (e && t)
    if (e.classList)
      e.classList[n ? "add" : "remove"](t);
    else {
      var r = (" " + e.className + " ").replace(uz, " ").replace(" " + t + " ", " ");
      e.className = (r + (n ? " " + t : "")).replace(uz, " ");
    }
}
function Et(e, t, n) {
  var r = e && e.style;
  if (r) {
    if (n === void 0)
      return document.defaultView && document.defaultView.getComputedStyle ? n = document.defaultView.getComputedStyle(e, "") : e.currentStyle && (n = e.currentStyle), t === void 0 ? n : n[t];
    !(t in r) && t.indexOf("webkit") === -1 && (t = "-webkit-" + t), r[t] = n + (typeof n == "string" ? "" : "px");
  }
}
function qd(e, t) {
  var n = "";
  if (typeof e == "string")
    n = e;
  else
    do {
      var r = Et(e, "transform");
      r && r !== "none" && (n = r + " " + n);
    } while (!t && (e = e.parentNode));
  var i = window.DOMMatrix || window.WebKitCSSMatrix || window.CSSMatrix || window.MSCSSMatrix;
  return i && new i(n);
}
function dse(e, t, n) {
  if (e) {
    var r = e.getElementsByTagName(t), i = 0, o = r.length;
    if (n)
      for (; i < o; i++)
        n(r[i], i);
    return r;
  }
  return [];
}
function dc() {
  var e = document.scrollingElement;
  return e || document.documentElement;
}
function vr(e, t, n, r, i) {
  if (!(!e.getBoundingClientRect && e !== window)) {
    var o, a, s, c, l, u, d;
    if (e !== window && e.parentNode && e !== dc() ? (o = e.getBoundingClientRect(), a = o.top, s = o.left, c = o.bottom, l = o.right, u = o.height, d = o.width) : (a = 0, s = 0, c = window.innerHeight, l = window.innerWidth, u = window.innerHeight, d = window.innerWidth), (t || n) && e !== window && (i = i || e.parentNode, !Sl))
      do
        if (i && i.getBoundingClientRect && (Et(i, "transform") !== "none" || n && Et(i, "position") !== "static")) {
          var f = i.getBoundingClientRect();
          a -= f.top + parseInt(Et(i, "border-top-width")), s -= f.left + parseInt(Et(i, "border-left-width")), c = a + o.height, l = s + o.width;
          break;
        }
      while (i = i.parentNode);
    if (r && e !== window) {
      var h = qd(i || e), p = h && h.a, g = h && h.d;
      h && (a /= g, s /= p, d /= p, u /= g, c = a + u, l = s + d);
    }
    return {
      top: a,
      left: s,
      bottom: c,
      right: l,
      width: d,
      height: u
    };
  }
}
function dz(e, t, n) {
  for (var r = eu(e, !0), i = vr(e)[t]; r; ) {
    var o = vr(r)[n], a = void 0;
    if (n === "top" || n === "left" ? a = i >= o : a = i <= o, !a)
      return r;
    if (r === dc())
      break;
    r = eu(r, !1);
  }
  return !1;
}
function rp(e, t, n, r) {
  for (var i = 0, o = 0, a = e.children; o < a.length; ) {
    if (a[o].style.display !== "none" && a[o] !== Ut.ghost && (r || a[o] !== Ut.dragged) && ka(a[o], n.draggable, e, !1)) {
      if (i === t)
        return a[o];
      i++;
    }
    o++;
  }
  return null;
}
function Gk(e, t) {
  for (var n = e.lastElementChild; n && (n === Ut.ghost || Et(n, "display") === "none" || t && !Vw(n, t)); )
    n = n.previousElementSibling;
  return n || null;
}
function qr(e, t) {
  var n = 0;
  if (!e || !e.parentNode)
    return -1;
  for (; e = e.previousElementSibling; )
    e.nodeName.toUpperCase() !== "TEMPLATE" && e !== Ut.clone && (!t || Vw(e, t)) && n++;
  return n;
}
function fz(e) {
  var t = 0, n = 0, r = dc();
  if (e)
    do {
      var i = qd(e), o = i.a, a = i.d;
      t += e.scrollLeft * o, n += e.scrollTop * a;
    } while (e !== r && (e = e.parentNode));
  return [t, n];
}
function kbt(e, t) {
  for (var n in e)
    if (e.hasOwnProperty(n)) {
      for (var r in t)
        if (t.hasOwnProperty(r) && t[r] === e[n][r])
          return Number(n);
    }
  return -1;
}
function eu(e, t) {
  if (!e || !e.getBoundingClientRect)
    return dc();
  var n = e, r = !1;
  do
    if (n.clientWidth < n.scrollWidth || n.clientHeight < n.scrollHeight) {
      var i = Et(n);
      if (n.clientWidth < n.scrollWidth && (i.overflowX == "auto" || i.overflowX == "scroll") || n.clientHeight < n.scrollHeight && (i.overflowY == "auto" || i.overflowY == "scroll")) {
        if (!n.getBoundingClientRect || n === document.body)
          return dc();
        if (r || t)
          return n;
        r = !0;
      }
    }
  while (n = n.parentNode);
  return dc();
}
function Nbt(e, t) {
  if (e && t)
    for (var n in t)
      t.hasOwnProperty(n) && (e[n] = t[n]);
  return e;
}
function JT(e, t) {
  return Math.round(e.top) === Math.round(t.top) && Math.round(e.left) === Math.round(t.left) && Math.round(e.height) === Math.round(t.height) && Math.round(e.width) === Math.round(t.width);
}
var $0;
function fse(e, t) {
  return function() {
    if (!$0) {
      var n = arguments, r = this;
      n.length === 1 ? e.call(r, n[0]) : e.apply(r, n), $0 = setTimeout(function() {
        $0 = void 0;
      }, t);
    }
  };
}
function Dbt() {
  clearTimeout($0), $0 = void 0;
}
function hse(e, t, n) {
  e.scrollLeft += t, e.scrollTop += n;
}
function Kk(e) {
  var t = window.Polymer, n = window.jQuery || window.Zepto;
  return t && t.dom ? t.dom(e).cloneNode(!0) : n ? n(e).clone(!0)[0] : e.cloneNode(!0);
}
function hz(e, t) {
  Et(e, "position", "absolute"), Et(e, "top", t.top), Et(e, "left", t.left), Et(e, "width", t.width), Et(e, "height", t.height);
}
function ZT(e) {
  Et(e, "position", ""), Et(e, "top", ""), Et(e, "left", ""), Et(e, "width", ""), Et(e, "height", "");
}
function gse(e, t, n) {
  var r = {};
  return Array.from(e.children).forEach(function(i) {
    var o, a, s, c;
    if (!(!ka(i, t.draggable, e, !1) || i.animated || i === n)) {
      var l = vr(i);
      r.left = Math.min((o = r.left) !== null && o !== void 0 ? o : 1 / 0, l.left), r.top = Math.min((a = r.top) !== null && a !== void 0 ? a : 1 / 0, l.top), r.right = Math.max((s = r.right) !== null && s !== void 0 ? s : -1 / 0, l.right), r.bottom = Math.max((c = r.bottom) !== null && c !== void 0 ? c : -1 / 0, l.bottom);
    }
  }), r.width = r.right - r.left, r.height = r.bottom - r.top, r.x = r.left, r.y = r.top, r;
}
var Bi = "Sortable" + (/* @__PURE__ */ new Date()).getTime();
function Lbt() {
  var e = [], t;
  return {
    captureAnimationState: function() {
      if (e = [], !!this.options.animation) {
        var r = [].slice.call(this.el.children);
        r.forEach(function(i) {
          if (!(Et(i, "display") === "none" || i === Ut.ghost)) {
            e.push({
              target: i,
              rect: vr(i)
            });
            var o = yc({}, e[e.length - 1].rect);
            if (i.thisAnimationDuration) {
              var a = qd(i, !0);
              a && (o.top -= a.f, o.left -= a.e);
            }
            i.fromRect = o;
          }
        });
      }
    },
    addAnimationState: function(r) {
      e.push(r);
    },
    removeAnimationState: function(r) {
      e.splice(kbt(e, {
        target: r
      }), 1);
    },
    animateAll: function(r) {
      var i = this;
      if (!this.options.animation) {
        clearTimeout(t), typeof r == "function" && r();
        return;
      }
      var o = !1, a = 0;
      e.forEach(function(s) {
        var c = 0, l = s.target, u = l.fromRect, d = vr(l), f = l.prevFromRect, h = l.prevToRect, p = s.rect, g = qd(l, !0);
        g && (d.top -= g.f, d.left -= g.e), l.toRect = d, l.thisAnimationDuration && JT(f, d) && !JT(u, d) && // Make sure animatingRect is on line between toRect & fromRect
        (p.top - d.top) / (p.left - d.left) === (u.top - d.top) / (u.left - d.left) && (c = Fbt(p, f, h, i.options)), JT(d, u) || (l.prevFromRect = u, l.prevToRect = d, c || (c = i.options.animation), i.animate(l, p, d, c)), c && (o = !0, a = Math.max(a, c), clearTimeout(l.animationResetTimer), l.animationResetTimer = setTimeout(function() {
          l.animationTime = 0, l.prevFromRect = null, l.fromRect = null, l.prevToRect = null, l.thisAnimationDuration = null;
        }, c), l.thisAnimationDuration = c);
      }), clearTimeout(t), o ? t = setTimeout(function() {
        typeof r == "function" && r();
      }, a) : typeof r == "function" && r(), e = [];
    },
    animate: function(r, i, o, a) {
      if (a) {
        Et(r, "transition", ""), Et(r, "transform", "");
        var s = qd(this.el), c = s && s.a, l = s && s.d, u = (i.left - o.left) / (c || 1), d = (i.top - o.top) / (l || 1);
        r.animatingX = !!u, r.animatingY = !!d, Et(r, "transform", "translate3d(" + u + "px," + d + "px,0)"), this.forRepaintDummy = jbt(r), Et(r, "transition", "transform " + a + "ms" + (this.options.easing ? " " + this.options.easing : "")), Et(r, "transform", "translate3d(0,0,0)"), typeof r.animated == "number" && clearTimeout(r.animated), r.animated = setTimeout(function() {
          Et(r, "transition", ""), Et(r, "transform", ""), r.animated = !1, r.animatingX = !1, r.animatingY = !1;
        }, a);
      }
    }
  };
}
function jbt(e) {
  return e.offsetWidth;
}
function Fbt(e, t, n, r) {
  return Math.sqrt(Math.pow(t.top - e.top, 2) + Math.pow(t.left - e.left, 2)) / Math.sqrt(Math.pow(t.top - n.top, 2) + Math.pow(t.left - n.left, 2)) * r.animation;
}
var yh = [], eI = {
  initializeByDefault: !0
}, ob = {
  mount: function(t) {
    for (var n in eI)
      eI.hasOwnProperty(n) && !(n in t) && (t[n] = eI[n]);
    yh.forEach(function(r) {
      if (r.pluginName === t.pluginName)
        throw "Sortable: Cannot mount plugin ".concat(t.pluginName, " more than once");
    }), yh.push(t);
  },
  pluginEvent: function(t, n, r) {
    var i = this;
    this.eventCanceled = !1, r.cancel = function() {
      i.eventCanceled = !0;
    };
    var o = t + "Global";
    yh.forEach(function(a) {
      n[a.pluginName] && (n[a.pluginName][o] && n[a.pluginName][o](yc({
        sortable: n
      }, r)), n.options[a.pluginName] && n[a.pluginName][t] && n[a.pluginName][t](yc({
        sortable: n
      }, r)));
    });
  },
  initializePlugins: function(t, n, r, i) {
    yh.forEach(function(s) {
      var c = s.pluginName;
      if (!(!t.options[c] && !s.initializeByDefault)) {
        var l = new s(t, n, t.options);
        l.sortable = t, l.options = t.options, t[c] = l, Ha(r, l.defaults);
      }
    });
    for (var o in t.options)
      if (t.options.hasOwnProperty(o)) {
        var a = this.modifyOption(t, o, t.options[o]);
        typeof a < "u" && (t.options[o] = a);
      }
  },
  getEventProperties: function(t, n) {
    var r = {};
    return yh.forEach(function(i) {
      typeof i.eventProperties == "function" && Ha(r, i.eventProperties.call(n[i.pluginName], t));
    }), r;
  },
  modifyOption: function(t, n, r) {
    var i;
    return yh.forEach(function(o) {
      t[o.pluginName] && o.optionListeners && typeof o.optionListeners[n] == "function" && (i = o.optionListeners[n].call(t[o.pluginName], r));
    }), i;
  }
};
function e0(e) {
  var t = e.sortable, n = e.rootEl, r = e.name, i = e.targetEl, o = e.cloneEl, a = e.toEl, s = e.fromEl, c = e.oldIndex, l = e.newIndex, u = e.oldDraggableIndex, d = e.newDraggableIndex, f = e.originalEvent, h = e.putSortable, p = e.extraEventProperties;
  if (t = t || n && n[Bi], !!t) {
    var g, m = t.options, v = "on" + r.charAt(0).toUpperCase() + r.substr(1);
    window.CustomEvent && !Sl && !ib ? g = new CustomEvent(r, {
      bubbles: !0,
      cancelable: !0
    }) : (g = document.createEvent("Event"), g.initEvent(r, !0, !0)), g.to = a || n, g.from = s || n, g.item = i || n, g.clone = o, g.oldIndex = c, g.newIndex = l, g.oldDraggableIndex = u, g.newDraggableIndex = d, g.originalEvent = f, g.pullMode = h ? h.lastPutMode : void 0;
    var y = yc(yc({}, p), ob.getEventProperties(r, t));
    for (var S in y)
      g[S] = y[S];
    n && n.dispatchEvent(g), m[v] && m[v].call(t, g);
  }
}
var Vbt = ["evt"], Bo = function(t, n) {
  var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, i = r.evt, o = Ibt(r, Vbt);
  ob.pluginEvent.bind(Ut)(t, n, yc({
    dragEl: tt,
    parentEl: Hr,
    ghostEl: en,
    rootEl: Ir,
    nextEl: pd,
    lastDownEl: i_,
    cloneEl: Mr,
    cloneHidden: Wl,
    dragStarted: t0,
    putSortable: ji,
    activeSortable: Ut.active,
    originalEvent: i,
    oldIndex: Fh,
    oldDraggableIndex: O0,
    newIndex: ua,
    newDraggableIndex: Ll,
    hideGhostForTarget: yse,
    unhideGhostForTarget: bse,
    cloneNowHidden: function() {
      Wl = !0;
    },
    cloneNowShown: function() {
      Wl = !1;
    },
    dispatchSortableEvent: function(s) {
      _o({
        sortable: n,
        name: s,
        originalEvent: i
      });
    }
  }, o));
};
function _o(e) {
  e0(yc({
    putSortable: ji,
    cloneEl: Mr,
    targetEl: tt,
    rootEl: Ir,
    oldIndex: Fh,
    oldDraggableIndex: O0,
    newIndex: ua,
    newDraggableIndex: Ll
  }, e));
}
var tt, Hr, en, Ir, pd, i_, Mr, Wl, Fh, ua, O0, Ll, _1, ji, Ih = !1, Bw = !1, zw = [], sd, Za, tI, nI, gz, pz, t0, bh, P0, M0 = !1, S1 = !1, o_, eo, rI = [], K$ = !1, Hw = [], E2 = typeof document < "u", w1 = sse, mz = ib || Sl ? "cssFloat" : "float", Bbt = E2 && !cse && !sse && "draggable" in document.createElement("div"), pse = function() {
  if (E2) {
    if (Sl)
      return !1;
    var e = document.createElement("x");
    return e.style.cssText = "pointer-events:auto", e.style.pointerEvents === "auto";
  }
}(), mse = function(t, n) {
  var r = Et(t), i = parseInt(r.width) - parseInt(r.paddingLeft) - parseInt(r.paddingRight) - parseInt(r.borderLeftWidth) - parseInt(r.borderRightWidth), o = rp(t, 0, n), a = rp(t, 1, n), s = o && Et(o), c = a && Et(a), l = s && parseInt(s.marginLeft) + parseInt(s.marginRight) + vr(o).width, u = c && parseInt(c.marginLeft) + parseInt(c.marginRight) + vr(a).width;
  if (r.display === "flex")
    return r.flexDirection === "column" || r.flexDirection === "column-reverse" ? "vertical" : "horizontal";
  if (r.display === "grid")
    return r.gridTemplateColumns.split(" ").length <= 1 ? "vertical" : "horizontal";
  if (o && s.float && s.float !== "none") {
    var d = s.float === "left" ? "left" : "right";
    return a && (c.clear === "both" || c.clear === d) ? "vertical" : "horizontal";
  }
  return o && (s.display === "block" || s.display === "flex" || s.display === "table" || s.display === "grid" || l >= i && r[mz] === "none" || a && r[mz] === "none" && l + u > i) ? "vertical" : "horizontal";
}, zbt = function(t, n, r) {
  var i = r ? t.left : t.top, o = r ? t.right : t.bottom, a = r ? t.width : t.height, s = r ? n.left : n.top, c = r ? n.right : n.bottom, l = r ? n.width : n.height;
  return i === s || o === c || i + a / 2 === s + l / 2;
}, Hbt = function(t, n) {
  var r;
  return zw.some(function(i) {
    var o = i[Bi].options.emptyInsertThreshold;
    if (!(!o || Gk(i))) {
      var a = vr(i), s = t >= a.left - o && t <= a.right + o, c = n >= a.top - o && n <= a.bottom + o;
      if (s && c)
        return r = i;
    }
  }), r;
}, vse = function(t) {
  function n(o, a) {
    return function(s, c, l, u) {
      var d = s.options.group.name && c.options.group.name && s.options.group.name === c.options.group.name;
      if (o == null && (a || d))
        return !0;
      if (o == null || o === !1)
        return !1;
      if (a && o === "clone")
        return o;
      if (typeof o == "function")
        return n(o(s, c, l, u), a)(s, c, l, u);
      var f = (a ? s : c).options.group.name;
      return o === !0 || typeof o == "string" && o === f || o.join && o.indexOf(f) > -1;
    };
  }
  var r = {}, i = t.group;
  (!i || r_(i) != "object") && (i = {
    name: i
  }), r.name = i.name, r.checkPull = n(i.pull, !0), r.checkPut = n(i.put), r.revertClone = i.revertClone, t.group = r;
}, yse = function() {
  !pse && en && Et(en, "display", "none");
}, bse = function() {
  !pse && en && Et(en, "display", "");
};
E2 && !cse && document.addEventListener("click", function(e) {
  if (Bw)
    return e.preventDefault(), e.stopPropagation && e.stopPropagation(), e.stopImmediatePropagation && e.stopImmediatePropagation(), Bw = !1, !1;
}, !0);
var cd = function(t) {
  if (tt) {
    t = t.touches ? t.touches[0] : t;
    var n = Hbt(t.clientX, t.clientY);
    if (n) {
      var r = {};
      for (var i in t)
        t.hasOwnProperty(i) && (r[i] = t[i]);
      r.target = r.rootEl = n, r.preventDefault = void 0, r.stopPropagation = void 0, n[Bi]._onDragOver(r);
    }
  }
}, Ubt = function(t) {
  tt && tt.parentNode[Bi]._isOutsideThisEl(t.target);
};
function Ut(e, t) {
  if (!(e && e.nodeType && e.nodeType === 1))
    throw "Sortable: `el` must be an HTMLElement, not ".concat({}.toString.call(e));
  this.el = e, this.options = t = Ha({}, t), e[Bi] = this;
  var n = {
    group: null,
    sort: !0,
    disabled: !1,
    store: null,
    handle: null,
    draggable: /^[uo]l$/i.test(e.nodeName) ? ">li" : ">*",
    swapThreshold: 1,
    // percentage; 0 <= x <= 1
    invertSwap: !1,
    // invert always
    invertedSwapThreshold: null,
    // will be set to same as swapThreshold if default
    removeCloneOnHide: !0,
    direction: function() {
      return mse(e, this.options);
    },
    ghostClass: "sortable-ghost",
    chosenClass: "sortable-chosen",
    dragClass: "sortable-drag",
    ignore: "a, img",
    filter: null,
    preventOnFilter: !0,
    animation: 0,
    easing: null,
    setData: function(a, s) {
      a.setData("Text", s.textContent);
    },
    dropBubble: !1,
    dragoverBubble: !1,
    dataIdAttr: "data-id",
    delay: 0,
    delayOnTouchOnly: !1,
    touchStartThreshold: (Number.parseInt ? Number : window).parseInt(window.devicePixelRatio, 10) || 1,
    forceFallback: !1,
    fallbackClass: "sortable-fallback",
    fallbackOnBody: !1,
    fallbackTolerance: 0,
    fallbackOffset: {
      x: 0,
      y: 0
    },
    supportPointer: Ut.supportPointer !== !1 && "PointerEvent" in window && !R0,
    emptyInsertThreshold: 5
  };
  ob.initializePlugins(this, e, n);
  for (var r in n)
    !(r in t) && (t[r] = n[r]);
  vse(t);
  for (var i in this)
    i.charAt(0) === "_" && typeof this[i] == "function" && (this[i] = this[i].bind(this));
  this.nativeDraggable = t.forceFallback ? !1 : Bbt, this.nativeDraggable && (this.options.touchStartThreshold = 1), t.supportPointer ? yn(e, "pointerdown", this._onTapStart) : (yn(e, "mousedown", this._onTapStart), yn(e, "touchstart", this._onTapStart)), this.nativeDraggable && (yn(e, "dragover", this), yn(e, "dragenter", this)), zw.push(this.el), t.store && t.store.get && this.sort(t.store.get(this) || []), Ha(this, Lbt());
}
Ut.prototype = /** @lends Sortable.prototype */
{
  constructor: Ut,
  _isOutsideThisEl: function(t) {
    !this.el.contains(t) && t !== this.el && (bh = null);
  },
  _getDirection: function(t, n) {
    return typeof this.options.direction == "function" ? this.options.direction.call(this, t, n, tt) : this.options.direction;
  },
  _onTapStart: function(t) {
    if (t.cancelable) {
      var n = this, r = this.el, i = this.options, o = i.preventOnFilter, a = t.type, s = t.touches && t.touches[0] || t.pointerType && t.pointerType === "touch" && t, c = (s || t).target, l = t.target.shadowRoot && (t.path && t.path[0] || t.composedPath && t.composedPath()[0]) || c, u = i.filter;
      if (Jbt(r), !tt && !(/mousedown|pointerdown/.test(a) && t.button !== 0 || i.disabled) && !l.isContentEditable && !(!this.nativeDraggable && R0 && c && c.tagName.toUpperCase() === "SELECT") && (c = ka(c, i.draggable, r, !1), !(c && c.animated) && i_ !== c)) {
        if (Fh = qr(c), O0 = qr(c, i.draggable), typeof u == "function") {
          if (u.call(this, t, c, this)) {
            _o({
              sortable: n,
              rootEl: l,
              name: "filter",
              targetEl: c,
              toEl: r,
              fromEl: r
            }), Bo("filter", n, {
              evt: t
            }), o && t.cancelable && t.preventDefault();
            return;
          }
        } else if (u && (u = u.split(",").some(function(d) {
          if (d = ka(l, d.trim(), r, !1), d)
            return _o({
              sortable: n,
              rootEl: d,
              name: "filter",
              targetEl: c,
              fromEl: r,
              toEl: r
            }), Bo("filter", n, {
              evt: t
            }), !0;
        }), u)) {
          o && t.cancelable && t.preventDefault();
          return;
        }
        i.handle && !ka(l, i.handle, r, !1) || this._prepareDragStart(t, s, c);
      }
    }
  },
  _prepareDragStart: function(t, n, r) {
    var i = this, o = i.el, a = i.options, s = o.ownerDocument, c;
    if (r && !tt && r.parentNode === o) {
      var l = vr(r);
      if (Ir = o, tt = r, Hr = tt.parentNode, pd = tt.nextSibling, i_ = r, _1 = a.group, Ut.dragged = tt, sd = {
        target: tt,
        clientX: (n || t).clientX,
        clientY: (n || t).clientY
      }, gz = sd.clientX - l.left, pz = sd.clientY - l.top, this._lastX = (n || t).clientX, this._lastY = (n || t).clientY, tt.style["will-change"] = "all", c = function() {
        if (Bo("delayEnded", i, {
          evt: t
        }), Ut.eventCanceled) {
          i._onDrop();
          return;
        }
        i._disableDelayedDragEvents(), !lz && i.nativeDraggable && (tt.draggable = !0), i._triggerDragStart(t, n), _o({
          sortable: i,
          name: "choose",
          originalEvent: t
        }), kr(tt, a.chosenClass, !0);
      }, a.ignore.split(",").forEach(function(u) {
        dse(tt, u.trim(), iI);
      }), yn(s, "dragover", cd), yn(s, "mousemove", cd), yn(s, "touchmove", cd), yn(s, "mouseup", i._onDrop), yn(s, "touchend", i._onDrop), yn(s, "touchcancel", i._onDrop), lz && this.nativeDraggable && (this.options.touchStartThreshold = 4, tt.draggable = !0), Bo("delayStart", this, {
        evt: t
      }), a.delay && (!a.delayOnTouchOnly || n) && (!this.nativeDraggable || !(ib || Sl))) {
        if (Ut.eventCanceled) {
          this._onDrop();
          return;
        }
        yn(s, "mouseup", i._disableDelayedDrag), yn(s, "touchend", i._disableDelayedDrag), yn(s, "touchcancel", i._disableDelayedDrag), yn(s, "mousemove", i._delayedDragTouchMoveHandler), yn(s, "touchmove", i._delayedDragTouchMoveHandler), a.supportPointer && yn(s, "pointermove", i._delayedDragTouchMoveHandler), i._dragStartTimer = setTimeout(c, a.delay);
      } else
        c();
    }
  },
  _delayedDragTouchMoveHandler: function(t) {
    var n = t.touches ? t.touches[0] : t;
    Math.max(Math.abs(n.clientX - this._lastX), Math.abs(n.clientY - this._lastY)) >= Math.floor(this.options.touchStartThreshold / (this.nativeDraggable && window.devicePixelRatio || 1)) && this._disableDelayedDrag();
  },
  _disableDelayedDrag: function() {
    tt && iI(tt), clearTimeout(this._dragStartTimer), this._disableDelayedDragEvents();
  },
  _disableDelayedDragEvents: function() {
    var t = this.el.ownerDocument;
    gn(t, "mouseup", this._disableDelayedDrag), gn(t, "touchend", this._disableDelayedDrag), gn(t, "touchcancel", this._disableDelayedDrag), gn(t, "mousemove", this._delayedDragTouchMoveHandler), gn(t, "touchmove", this._delayedDragTouchMoveHandler), gn(t, "pointermove", this._delayedDragTouchMoveHandler);
  },
  _triggerDragStart: function(t, n) {
    n = n || t.pointerType == "touch" && t, !this.nativeDraggable || n ? this.options.supportPointer ? yn(document, "pointermove", this._onTouchMove) : n ? yn(document, "touchmove", this._onTouchMove) : yn(document, "mousemove", this._onTouchMove) : (yn(tt, "dragend", this), yn(Ir, "dragstart", this._onDragStart));
    try {
      document.selection ? a_(function() {
        document.selection.empty();
      }) : window.getSelection().removeAllRanges();
    } catch {
    }
  },
  _dragStarted: function(t, n) {
    if (Ih = !1, Ir && tt) {
      Bo("dragStarted", this, {
        evt: n
      }), this.nativeDraggable && yn(document, "dragover", Ubt);
      var r = this.options;
      !t && kr(tt, r.dragClass, !1), kr(tt, r.ghostClass, !0), Ut.active = this, t && this._appendGhost(), _o({
        sortable: this,
        name: "start",
        originalEvent: n
      });
    } else
      this._nulling();
  },
  _emulateDragOver: function() {
    if (Za) {
      this._lastX = Za.clientX, this._lastY = Za.clientY, yse();
      for (var t = document.elementFromPoint(Za.clientX, Za.clientY), n = t; t && t.shadowRoot && (t = t.shadowRoot.elementFromPoint(Za.clientX, Za.clientY), t !== n); )
        n = t;
      if (tt.parentNode[Bi]._isOutsideThisEl(t), n)
        do {
          if (n[Bi]) {
            var r = void 0;
            if (r = n[Bi]._onDragOver({
              clientX: Za.clientX,
              clientY: Za.clientY,
              target: t,
              rootEl: n
            }), r && !this.options.dragoverBubble)
              break;
          }
          t = n;
        } while (n = use(n));
      bse();
    }
  },
  _onTouchMove: function(t) {
    if (sd) {
      var n = this.options, r = n.fallbackTolerance, i = n.fallbackOffset, o = t.touches ? t.touches[0] : t, a = en && qd(en, !0), s = en && a && a.a, c = en && a && a.d, l = w1 && eo && fz(eo), u = (o.clientX - sd.clientX + i.x) / (s || 1) + (l ? l[0] - rI[0] : 0) / (s || 1), d = (o.clientY - sd.clientY + i.y) / (c || 1) + (l ? l[1] - rI[1] : 0) / (c || 1);
      if (!Ut.active && !Ih) {
        if (r && Math.max(Math.abs(o.clientX - this._lastX), Math.abs(o.clientY - this._lastY)) < r)
          return;
        this._onDragStart(t, !0);
      }
      if (en) {
        a ? (a.e += u - (tI || 0), a.f += d - (nI || 0)) : a = {
          a: 1,
          b: 0,
          c: 0,
          d: 1,
          e: u,
          f: d
        };
        var f = "matrix(".concat(a.a, ",").concat(a.b, ",").concat(a.c, ",").concat(a.d, ",").concat(a.e, ",").concat(a.f, ")");
        Et(en, "webkitTransform", f), Et(en, "mozTransform", f), Et(en, "msTransform", f), Et(en, "transform", f), tI = u, nI = d, Za = o;
      }
      t.cancelable && t.preventDefault();
    }
  },
  _appendGhost: function() {
    if (!en) {
      var t = this.options.fallbackOnBody ? document.body : Ir, n = vr(tt, !0, w1, !0, t), r = this.options;
      if (w1) {
        for (eo = t; Et(eo, "position") === "static" && Et(eo, "transform") === "none" && eo !== document; )
          eo = eo.parentNode;
        eo !== document.body && eo !== document.documentElement ? (eo === document && (eo = dc()), n.top += eo.scrollTop, n.left += eo.scrollLeft) : eo = dc(), rI = fz(eo);
      }
      en = tt.cloneNode(!0), kr(en, r.ghostClass, !1), kr(en, r.fallbackClass, !0), kr(en, r.dragClass, !0), Et(en, "transition", ""), Et(en, "transform", ""), Et(en, "box-sizing", "border-box"), Et(en, "margin", 0), Et(en, "top", n.top), Et(en, "left", n.left), Et(en, "width", n.width), Et(en, "height", n.height), Et(en, "opacity", "0.8"), Et(en, "position", w1 ? "absolute" : "fixed"), Et(en, "zIndex", "100000"), Et(en, "pointerEvents", "none"), Ut.ghost = en, t.appendChild(en), Et(en, "transform-origin", gz / parseInt(en.style.width) * 100 + "% " + pz / parseInt(en.style.height) * 100 + "%");
    }
  },
  _onDragStart: function(t, n) {
    var r = this, i = t.dataTransfer, o = r.options;
    if (Bo("dragStart", this, {
      evt: t
    }), Ut.eventCanceled) {
      this._onDrop();
      return;
    }
    Bo("setupClone", this), Ut.eventCanceled || (Mr = Kk(tt), Mr.removeAttribute("id"), Mr.draggable = !1, Mr.style["will-change"] = "", this._hideClone(), kr(Mr, this.options.chosenClass, !1), Ut.clone = Mr), r.cloneId = a_(function() {
      Bo("clone", r), !Ut.eventCanceled && (r.options.removeCloneOnHide || Ir.insertBefore(Mr, tt), r._hideClone(), _o({
        sortable: r,
        name: "clone"
      }));
    }), !n && kr(tt, o.dragClass, !0), n ? (Bw = !0, r._loopId = setInterval(r._emulateDragOver, 50)) : (gn(document, "mouseup", r._onDrop), gn(document, "touchend", r._onDrop), gn(document, "touchcancel", r._onDrop), i && (i.effectAllowed = "move", o.setData && o.setData.call(r, i, tt)), yn(document, "drop", r), Et(tt, "transform", "translateZ(0)")), Ih = !0, r._dragStartId = a_(r._dragStarted.bind(r, n, t)), yn(document, "selectstart", r), t0 = !0, R0 && Et(document.body, "user-select", "none");
  },
  // Returns true - if no further action is needed (either inserted or another condition)
  _onDragOver: function(t) {
    var n = this.el, r = t.target, i, o, a, s = this.options, c = s.group, l = Ut.active, u = _1 === c, d = s.sort, f = ji || l, h, p = this, g = !1;
    if (K$)
      return;
    function m(V, j) {
      Bo(V, p, yc({
        evt: t,
        isOwner: u,
        axis: h ? "vertical" : "horizontal",
        revert: a,
        dragRect: i,
        targetRect: o,
        canSort: d,
        fromSortable: f,
        target: r,
        completed: y,
        onMove: function(U, Q) {
          return x1(Ir, n, tt, i, U, vr(U), t, Q);
        },
        changed: S
      }, j));
    }
    function v() {
      m("dragOverAnimationCapture"), p.captureAnimationState(), p !== f && f.captureAnimationState();
    }
    function y(V) {
      return m("dragOverCompleted", {
        insertion: V
      }), V && (u ? l._hideClone() : l._showClone(p), p !== f && (kr(tt, ji ? ji.options.ghostClass : l.options.ghostClass, !1), kr(tt, s.ghostClass, !0)), ji !== p && p !== Ut.active ? ji = p : p === Ut.active && ji && (ji = null), f === p && (p._ignoreWhileAnimating = r), p.animateAll(function() {
        m("dragOverAnimationComplete"), p._ignoreWhileAnimating = null;
      }), p !== f && (f.animateAll(), f._ignoreWhileAnimating = null)), (r === tt && !tt.animated || r === n && !r.animated) && (bh = null), !s.dragoverBubble && !t.rootEl && r !== document && (tt.parentNode[Bi]._isOutsideThisEl(t.target), !V && cd(t)), !s.dragoverBubble && t.stopPropagation && t.stopPropagation(), g = !0;
    }
    function S() {
      ua = qr(tt), Ll = qr(tt, s.draggable), _o({
        sortable: p,
        name: "change",
        toEl: n,
        newIndex: ua,
        newDraggableIndex: Ll,
        originalEvent: t
      });
    }
    if (t.preventDefault !== void 0 && t.cancelable && t.preventDefault(), r = ka(r, s.draggable, n, !0), m("dragOver"), Ut.eventCanceled)
      return g;
    if (tt.contains(t.target) || r.animated && r.animatingX && r.animatingY || p._ignoreWhileAnimating === r)
      return y(!1);
    if (Bw = !1, l && !s.disabled && (u ? d || (a = Hr !== Ir) : ji === this || (this.lastPutMode = _1.checkPull(this, l, tt, t)) && c.checkPut(this, l, tt, t))) {
      if (h = this._getDirection(t, r) === "vertical", i = vr(tt), m("dragOverValid"), Ut.eventCanceled)
        return g;
      if (a)
        return Hr = Ir, v(), this._hideClone(), m("revert"), Ut.eventCanceled || (pd ? Ir.insertBefore(tt, pd) : Ir.appendChild(tt)), y(!0);
      var _ = Gk(n, s.draggable);
      if (!_ || Kbt(t, h, this) && !_.animated) {
        if (_ === tt)
          return y(!1);
        if (_ && n === t.target && (r = _), r && (o = vr(r)), x1(Ir, n, tt, i, r, o, t, !!r) !== !1)
          return v(), _ && _.nextSibling ? n.insertBefore(tt, _.nextSibling) : n.appendChild(tt), Hr = n, S(), y(!0);
      } else if (_ && Gbt(t, h, this)) {
        var w = rp(n, 0, s, !0);
        if (w === tt)
          return y(!1);
        if (r = w, o = vr(r), x1(Ir, n, tt, i, r, o, t, !1) !== !1)
          return v(), n.insertBefore(tt, w), Hr = n, S(), y(!0);
      } else if (r.parentNode === n) {
        o = vr(r);
        var T = 0, x, C = tt.parentNode !== n, E = !zbt(tt.animated && tt.toRect || i, r.animated && r.toRect || o, h), R = h ? "top" : "left", A = dz(r, "top", "top") || dz(tt, "top", "top"), O = A ? A.scrollTop : void 0;
        bh !== r && (x = o[R], M0 = !1, S1 = !E && s.invertSwap || C), T = Ybt(t, r, o, h, E ? 1 : s.swapThreshold, s.invertedSwapThreshold == null ? s.swapThreshold : s.invertedSwapThreshold, S1, bh === r);
        var $;
        if (T !== 0) {
          var N = qr(tt);
          do
            N -= T, $ = Hr.children[N];
          while ($ && (Et($, "display") === "none" || $ === en));
        }
        if (T === 0 || $ === r)
          return y(!1);
        bh = r, P0 = T;
        var z = r.nextElementSibling, k = !1;
        k = T === 1;
        var F = x1(Ir, n, tt, i, r, o, t, k);
        if (F !== !1)
          return (F === 1 || F === -1) && (k = F === 1), K$ = !0, setTimeout(qbt, 30), v(), k && !z ? n.appendChild(tt) : r.parentNode.insertBefore(tt, k ? z : r), A && hse(A, 0, O - A.scrollTop), Hr = tt.parentNode, x !== void 0 && !S1 && (o_ = Math.abs(x - vr(r)[R])), S(), y(!0);
      }
      if (n.contains(tt))
        return y(!1);
    }
    return !1;
  },
  _ignoreWhileAnimating: null,
  _offMoveEvents: function() {
    gn(document, "mousemove", this._onTouchMove), gn(document, "touchmove", this._onTouchMove), gn(document, "pointermove", this._onTouchMove), gn(document, "dragover", cd), gn(document, "mousemove", cd), gn(document, "touchmove", cd);
  },
  _offUpEvents: function() {
    var t = this.el.ownerDocument;
    gn(t, "mouseup", this._onDrop), gn(t, "touchend", this._onDrop), gn(t, "pointerup", this._onDrop), gn(t, "touchcancel", this._onDrop), gn(document, "selectstart", this);
  },
  _onDrop: function(t) {
    var n = this.el, r = this.options;
    if (ua = qr(tt), Ll = qr(tt, r.draggable), Bo("drop", this, {
      evt: t
    }), Hr = tt && tt.parentNode, ua = qr(tt), Ll = qr(tt, r.draggable), Ut.eventCanceled) {
      this._nulling();
      return;
    }
    Ih = !1, S1 = !1, M0 = !1, clearInterval(this._loopId), clearTimeout(this._dragStartTimer), Y$(this.cloneId), Y$(this._dragStartId), this.nativeDraggable && (gn(document, "drop", this), gn(n, "dragstart", this._onDragStart)), this._offMoveEvents(), this._offUpEvents(), R0 && Et(document.body, "user-select", ""), Et(tt, "transform", ""), t && (t0 && (t.cancelable && t.preventDefault(), !r.dropBubble && t.stopPropagation()), en && en.parentNode && en.parentNode.removeChild(en), (Ir === Hr || ji && ji.lastPutMode !== "clone") && Mr && Mr.parentNode && Mr.parentNode.removeChild(Mr), tt && (this.nativeDraggable && gn(tt, "dragend", this), iI(tt), tt.style["will-change"] = "", t0 && !Ih && kr(tt, ji ? ji.options.ghostClass : this.options.ghostClass, !1), kr(tt, this.options.chosenClass, !1), _o({
      sortable: this,
      name: "unchoose",
      toEl: Hr,
      newIndex: null,
      newDraggableIndex: null,
      originalEvent: t
    }), Ir !== Hr ? (ua >= 0 && (_o({
      rootEl: Hr,
      name: "add",
      toEl: Hr,
      fromEl: Ir,
      originalEvent: t
    }), _o({
      sortable: this,
      name: "remove",
      toEl: Hr,
      originalEvent: t
    }), _o({
      rootEl: Hr,
      name: "sort",
      toEl: Hr,
      fromEl: Ir,
      originalEvent: t
    }), _o({
      sortable: this,
      name: "sort",
      toEl: Hr,
      originalEvent: t
    })), ji && ji.save()) : ua !== Fh && ua >= 0 && (_o({
      sortable: this,
      name: "update",
      toEl: Hr,
      originalEvent: t
    }), _o({
      sortable: this,
      name: "sort",
      toEl: Hr,
      originalEvent: t
    })), Ut.active && ((ua == null || ua === -1) && (ua = Fh, Ll = O0), _o({
      sortable: this,
      name: "end",
      toEl: Hr,
      originalEvent: t
    }), this.save()))), this._nulling();
  },
  _nulling: function() {
    Bo("nulling", this), Ir = tt = Hr = en = pd = Mr = i_ = Wl = sd = Za = t0 = ua = Ll = Fh = O0 = bh = P0 = ji = _1 = Ut.dragged = Ut.ghost = Ut.clone = Ut.active = null, Hw.forEach(function(t) {
      t.checked = !0;
    }), Hw.length = tI = nI = 0;
  },
  handleEvent: function(t) {
    switch (t.type) {
      case "drop":
      case "dragend":
        this._onDrop(t);
        break;
      case "dragenter":
      case "dragover":
        tt && (this._onDragOver(t), Wbt(t));
        break;
      case "selectstart":
        t.preventDefault();
        break;
    }
  },
  /**
   * Serializes the item into an array of string.
   * @returns {String[]}
   */
  toArray: function() {
    for (var t = [], n, r = this.el.children, i = 0, o = r.length, a = this.options; i < o; i++)
      n = r[i], ka(n, a.draggable, this.el, !1) && t.push(n.getAttribute(a.dataIdAttr) || Qbt(n));
    return t;
  },
  /**
   * Sorts the elements according to the array.
   * @param  {String[]}  order  order of the items
   */
  sort: function(t, n) {
    var r = {}, i = this.el;
    this.toArray().forEach(function(o, a) {
      var s = i.children[a];
      ka(s, this.options.draggable, i, !1) && (r[o] = s);
    }, this), n && this.captureAnimationState(), t.forEach(function(o) {
      r[o] && (i.removeChild(r[o]), i.appendChild(r[o]));
    }), n && this.animateAll();
  },
  /**
   * Save the current sorting
   */
  save: function() {
    var t = this.options.store;
    t && t.set && t.set(this);
  },
  /**
   * For each element in the set, get the first element that matches the selector by testing the element itself and traversing up through its ancestors in the DOM tree.
   * @param   {HTMLElement}  el
   * @param   {String}       [selector]  default: `options.draggable`
   * @returns {HTMLElement|null}
   */
  closest: function(t, n) {
    return ka(t, n || this.options.draggable, this.el, !1);
  },
  /**
   * Set/get option
   * @param   {string} name
   * @param   {*}      [value]
   * @returns {*}
   */
  option: function(t, n) {
    var r = this.options;
    if (n === void 0)
      return r[t];
    var i = ob.modifyOption(this, t, n);
    typeof i < "u" ? r[t] = i : r[t] = n, t === "group" && vse(r);
  },
  /**
   * Destroy
   */
  destroy: function() {
    Bo("destroy", this);
    var t = this.el;
    t[Bi] = null, gn(t, "mousedown", this._onTapStart), gn(t, "touchstart", this._onTapStart), gn(t, "pointerdown", this._onTapStart), this.nativeDraggable && (gn(t, "dragover", this), gn(t, "dragenter", this)), Array.prototype.forEach.call(t.querySelectorAll("[draggable]"), function(n) {
      n.removeAttribute("draggable");
    }), this._onDrop(), this._disableDelayedDragEvents(), zw.splice(zw.indexOf(this.el), 1), this.el = t = null;
  },
  _hideClone: function() {
    if (!Wl) {
      if (Bo("hideClone", this), Ut.eventCanceled)
        return;
      Et(Mr, "display", "none"), this.options.removeCloneOnHide && Mr.parentNode && Mr.parentNode.removeChild(Mr), Wl = !0;
    }
  },
  _showClone: function(t) {
    if (t.lastPutMode !== "clone") {
      this._hideClone();
      return;
    }
    if (Wl) {
      if (Bo("showClone", this), Ut.eventCanceled)
        return;
      tt.parentNode == Ir && !this.options.group.revertClone ? Ir.insertBefore(Mr, tt) : pd ? Ir.insertBefore(Mr, pd) : Ir.appendChild(Mr), this.options.group.revertClone && this.animate(tt, Mr), Et(Mr, "display", ""), Wl = !1;
    }
  }
};
function Wbt(e) {
  e.dataTransfer && (e.dataTransfer.dropEffect = "move"), e.cancelable && e.preventDefault();
}
function x1(e, t, n, r, i, o, a, s) {
  var c, l = e[Bi], u = l.options.onMove, d;
  return window.CustomEvent && !Sl && !ib ? c = new CustomEvent("move", {
    bubbles: !0,
    cancelable: !0
  }) : (c = document.createEvent("Event"), c.initEvent("move", !0, !0)), c.to = t, c.from = e, c.dragged = n, c.draggedRect = r, c.related = i || t, c.relatedRect = o || vr(t), c.willInsertAfter = s, c.originalEvent = a, e.dispatchEvent(c), u && (d = u.call(l, c, a)), d;
}
function iI(e) {
  e.draggable = !1;
}
function qbt() {
  K$ = !1;
}
function Gbt(e, t, n) {
  var r = vr(rp(n.el, 0, n.options, !0)), i = gse(n.el, n.options, en), o = 10;
  return t ? e.clientX < i.left - o || e.clientY < r.top && e.clientX < r.right : e.clientY < i.top - o || e.clientY < r.bottom && e.clientX < r.left;
}
function Kbt(e, t, n) {
  var r = vr(Gk(n.el, n.options.draggable)), i = gse(n.el, n.options, en), o = 10;
  return t ? e.clientX > i.right + o || e.clientY > r.bottom && e.clientX > r.left : e.clientY > i.bottom + o || e.clientX > r.right && e.clientY > r.top;
}
function Ybt(e, t, n, r, i, o, a, s) {
  var c = r ? e.clientY : e.clientX, l = r ? n.height : n.width, u = r ? n.top : n.left, d = r ? n.bottom : n.right, f = !1;
  if (!a) {
    if (s && o_ < l * i) {
      if (!M0 && (P0 === 1 ? c > u + l * o / 2 : c < d - l * o / 2) && (M0 = !0), M0)
        f = !0;
      else if (P0 === 1 ? c < u + o_ : c > d - o_)
        return -P0;
    } else if (c > u + l * (1 - i) / 2 && c < d - l * (1 - i) / 2)
      return Xbt(t);
  }
  return f = f || a, f && (c < u + l * o / 2 || c > d - l * o / 2) ? c > u + l / 2 ? 1 : -1 : 0;
}
function Xbt(e) {
  return qr(tt) < qr(e) ? 1 : -1;
}
function Qbt(e) {
  for (var t = e.tagName + e.className + e.src + e.href + e.textContent, n = t.length, r = 0; n--; )
    r += t.charCodeAt(n);
  return r.toString(36);
}
function Jbt(e) {
  Hw.length = 0;
  for (var t = e.getElementsByTagName("input"), n = t.length; n--; ) {
    var r = t[n];
    r.checked && Hw.push(r);
  }
}
function a_(e) {
  return setTimeout(e, 0);
}
function Y$(e) {
  return clearTimeout(e);
}
E2 && yn(document, "touchmove", function(e) {
  (Ut.active || Ih) && e.cancelable && e.preventDefault();
});
Ut.utils = {
  on: yn,
  off: gn,
  css: Et,
  find: dse,
  is: function(t, n) {
    return !!ka(t, n, t, !1);
  },
  extend: Nbt,
  throttle: fse,
  closest: ka,
  toggleClass: kr,
  clone: Kk,
  index: qr,
  nextTick: a_,
  cancelNextTick: Y$,
  detectDirection: mse,
  getChild: rp,
  expando: Bi
};
Ut.get = function(e) {
  return e[Bi];
};
Ut.mount = function() {
  for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
    t[n] = arguments[n];
  t[0].constructor === Array && (t = t[0]), t.forEach(function(r) {
    if (!r.prototype || !r.prototype.constructor)
      throw "Sortable: Mounted plugin must be a constructor function, not ".concat({}.toString.call(r));
    r.utils && (Ut.utils = yc(yc({}, Ut.utils), r.utils)), ob.mount(r);
  });
};
Ut.create = function(e, t) {
  return new Ut(e, t);
};
Ut.version = Mbt;
var oi = [], n0, X$, Q$ = !1, oI, aI, Uw, r0;
function Zbt() {
  function e() {
    this.defaults = {
      scroll: !0,
      forceAutoScrollFallback: !1,
      scrollSensitivity: 30,
      scrollSpeed: 10,
      bubbleScroll: !0
    };
    for (var t in this)
      t.charAt(0) === "_" && typeof this[t] == "function" && (this[t] = this[t].bind(this));
  }
  return e.prototype = {
    dragStarted: function(n) {
      var r = n.originalEvent;
      this.sortable.nativeDraggable ? yn(document, "dragover", this._handleAutoScroll) : this.options.supportPointer ? yn(document, "pointermove", this._handleFallbackAutoScroll) : r.touches ? yn(document, "touchmove", this._handleFallbackAutoScroll) : yn(document, "mousemove", this._handleFallbackAutoScroll);
    },
    dragOverCompleted: function(n) {
      var r = n.originalEvent;
      !this.options.dragOverBubble && !r.rootEl && this._handleAutoScroll(r);
    },
    drop: function() {
      this.sortable.nativeDraggable ? gn(document, "dragover", this._handleAutoScroll) : (gn(document, "pointermove", this._handleFallbackAutoScroll), gn(document, "touchmove", this._handleFallbackAutoScroll), gn(document, "mousemove", this._handleFallbackAutoScroll)), vz(), s_(), Dbt();
    },
    nulling: function() {
      Uw = X$ = n0 = Q$ = r0 = oI = aI = null, oi.length = 0;
    },
    _handleFallbackAutoScroll: function(n) {
      this._handleAutoScroll(n, !0);
    },
    _handleAutoScroll: function(n, r) {
      var i = this, o = (n.touches ? n.touches[0] : n).clientX, a = (n.touches ? n.touches[0] : n).clientY, s = document.elementFromPoint(o, a);
      if (Uw = n, r || this.options.forceAutoScrollFallback || ib || Sl || R0) {
        sI(n, this.options, s, r);
        var c = eu(s, !0);
        Q$ && (!r0 || o !== oI || a !== aI) && (r0 && vz(), r0 = setInterval(function() {
          var l = eu(document.elementFromPoint(o, a), !0);
          l !== c && (c = l, s_()), sI(n, i.options, l, r);
        }, 10), oI = o, aI = a);
      } else {
        if (!this.options.bubbleScroll || eu(s, !0) === dc()) {
          s_();
          return;
        }
        sI(n, this.options, eu(s, !1), !1);
      }
    }
  }, Ha(e, {
    pluginName: "scroll",
    initializeByDefault: !0
  });
}
function s_() {
  oi.forEach(function(e) {
    clearInterval(e.pid);
  }), oi = [];
}
function vz() {
  clearInterval(r0);
}
var sI = fse(function(e, t, n, r) {
  if (t.scroll) {
    var i = (e.touches ? e.touches[0] : e).clientX, o = (e.touches ? e.touches[0] : e).clientY, a = t.scrollSensitivity, s = t.scrollSpeed, c = dc(), l = !1, u;
    X$ !== n && (X$ = n, s_(), n0 = t.scroll, u = t.scrollFn, n0 === !0 && (n0 = eu(n, !0)));
    var d = 0, f = n0;
    do {
      var h = f, p = vr(h), g = p.top, m = p.bottom, v = p.left, y = p.right, S = p.width, _ = p.height, w = void 0, T = void 0, x = h.scrollWidth, C = h.scrollHeight, E = Et(h), R = h.scrollLeft, A = h.scrollTop;
      h === c ? (w = S < x && (E.overflowX === "auto" || E.overflowX === "scroll" || E.overflowX === "visible"), T = _ < C && (E.overflowY === "auto" || E.overflowY === "scroll" || E.overflowY === "visible")) : (w = S < x && (E.overflowX === "auto" || E.overflowX === "scroll"), T = _ < C && (E.overflowY === "auto" || E.overflowY === "scroll"));
      var O = w && (Math.abs(y - i) <= a && R + S < x) - (Math.abs(v - i) <= a && !!R), $ = T && (Math.abs(m - o) <= a && A + _ < C) - (Math.abs(g - o) <= a && !!A);
      if (!oi[d])
        for (var N = 0; N <= d; N++)
          oi[N] || (oi[N] = {});
      (oi[d].vx != O || oi[d].vy != $ || oi[d].el !== h) && (oi[d].el = h, oi[d].vx = O, oi[d].vy = $, clearInterval(oi[d].pid), (O != 0 || $ != 0) && (l = !0, oi[d].pid = setInterval((function() {
        r && this.layer === 0 && Ut.active._onTouchMove(Uw);
        var z = oi[this.layer].vy ? oi[this.layer].vy * s : 0, k = oi[this.layer].vx ? oi[this.layer].vx * s : 0;
        typeof u == "function" && u.call(Ut.dragged.parentNode[Bi], k, z, e, Uw, oi[this.layer].el) !== "continue" || hse(oi[this.layer].el, k, z);
      }).bind({
        layer: d
      }), 24))), d++;
    } while (t.bubbleScroll && f !== c && (f = eu(f, !1)));
    Q$ = l;
  }
}, 30), _se = function(t) {
  var n = t.originalEvent, r = t.putSortable, i = t.dragEl, o = t.activeSortable, a = t.dispatchSortableEvent, s = t.hideGhostForTarget, c = t.unhideGhostForTarget;
  if (n) {
    var l = r || o;
    s();
    var u = n.changedTouches && n.changedTouches.length ? n.changedTouches[0] : n, d = document.elementFromPoint(u.clientX, u.clientY);
    c(), l && !l.el.contains(d) && (a("spill"), this.onSpill({
      dragEl: i,
      putSortable: r
    }));
  }
};
function Yk() {
}
Yk.prototype = {
  startIndex: null,
  dragStart: function(t) {
    var n = t.oldDraggableIndex;
    this.startIndex = n;
  },
  onSpill: function(t) {
    var n = t.dragEl, r = t.putSortable;
    this.sortable.captureAnimationState(), r && r.captureAnimationState();
    var i = rp(this.sortable.el, this.startIndex, this.options);
    i ? this.sortable.el.insertBefore(n, i) : this.sortable.el.appendChild(n), this.sortable.animateAll(), r && r.animateAll();
  },
  drop: _se
};
Ha(Yk, {
  pluginName: "revertOnSpill"
});
function Xk() {
}
Xk.prototype = {
  onSpill: function(t) {
    var n = t.dragEl, r = t.putSortable, i = r || this.sortable;
    i.captureAnimationState(), n.parentNode && n.parentNode.removeChild(n), i.animateAll();
  },
  drop: _se
};
Ha(Xk, {
  pluginName: "removeOnSpill"
});
var Oa;
function e1t() {
  function e() {
    this.defaults = {
      swapClass: "sortable-swap-highlight"
    };
  }
  return e.prototype = {
    dragStart: function(n) {
      var r = n.dragEl;
      Oa = r;
    },
    dragOverValid: function(n) {
      var r = n.completed, i = n.target, o = n.onMove, a = n.activeSortable, s = n.changed, c = n.cancel;
      if (a.options.swap) {
        var l = this.sortable.el, u = this.options;
        if (i && i !== l) {
          var d = Oa;
          o(i) !== !1 ? (kr(i, u.swapClass, !0), Oa = i) : Oa = null, d && d !== Oa && kr(d, u.swapClass, !1);
        }
        s(), r(!0), c();
      }
    },
    drop: function(n) {
      var r = n.activeSortable, i = n.putSortable, o = n.dragEl, a = i || this.sortable, s = this.options;
      Oa && kr(Oa, s.swapClass, !1), Oa && (s.swap || i && i.options.swap) && o !== Oa && (a.captureAnimationState(), a !== r && r.captureAnimationState(), t1t(o, Oa), a.animateAll(), a !== r && r.animateAll());
    },
    nulling: function() {
      Oa = null;
    }
  }, Ha(e, {
    pluginName: "swap",
    eventProperties: function() {
      return {
        swapItem: Oa
      };
    }
  });
}
function t1t(e, t) {
  var n = e.parentNode, r = t.parentNode, i, o;
  !n || !r || n.isEqualNode(t) || r.isEqualNode(e) || (i = qr(e), o = qr(t), n.isEqualNode(r) && i < o && o++, n.insertBefore(t, n.children[i]), r.insertBefore(e, r.children[o]));
}
var Zt = [], la = [], Om, es, Pm = !1, zo = !1, _h = !1, sr, Mm, E1;
function n1t() {
  function e(t) {
    for (var n in this)
      n.charAt(0) === "_" && typeof this[n] == "function" && (this[n] = this[n].bind(this));
    t.options.avoidImplicitDeselect || (t.options.supportPointer ? yn(document, "pointerup", this._deselectMultiDrag) : (yn(document, "mouseup", this._deselectMultiDrag), yn(document, "touchend", this._deselectMultiDrag))), yn(document, "keydown", this._checkKeyDown), yn(document, "keyup", this._checkKeyUp), this.defaults = {
      selectedClass: "sortable-selected",
      multiDragKey: null,
      avoidImplicitDeselect: !1,
      setData: function(i, o) {
        var a = "";
        Zt.length && es === t ? Zt.forEach(function(s, c) {
          a += (c ? ", " : "") + s.textContent;
        }) : a = o.textContent, i.setData("Text", a);
      }
    };
  }
  return e.prototype = {
    multiDragKeyDown: !1,
    isMultiDrag: !1,
    delayStartGlobal: function(n) {
      var r = n.dragEl;
      sr = r;
    },
    delayEnded: function() {
      this.isMultiDrag = ~Zt.indexOf(sr);
    },
    setupClone: function(n) {
      var r = n.sortable, i = n.cancel;
      if (this.isMultiDrag) {
        for (var o = 0; o < Zt.length; o++)
          la.push(Kk(Zt[o])), la[o].sortableIndex = Zt[o].sortableIndex, la[o].draggable = !1, la[o].style["will-change"] = "", kr(la[o], this.options.selectedClass, !1), Zt[o] === sr && kr(la[o], this.options.chosenClass, !1);
        r._hideClone(), i();
      }
    },
    clone: function(n) {
      var r = n.sortable, i = n.rootEl, o = n.dispatchSortableEvent, a = n.cancel;
      this.isMultiDrag && (this.options.removeCloneOnHide || Zt.length && es === r && (yz(!0, i), o("clone"), a()));
    },
    showClone: function(n) {
      var r = n.cloneNowShown, i = n.rootEl, o = n.cancel;
      this.isMultiDrag && (yz(!1, i), la.forEach(function(a) {
        Et(a, "display", "");
      }), r(), E1 = !1, o());
    },
    hideClone: function(n) {
      var r = this;
      n.sortable;
      var i = n.cloneNowHidden, o = n.cancel;
      this.isMultiDrag && (la.forEach(function(a) {
        Et(a, "display", "none"), r.options.removeCloneOnHide && a.parentNode && a.parentNode.removeChild(a);
      }), i(), E1 = !0, o());
    },
    dragStartGlobal: function(n) {
      n.sortable, !this.isMultiDrag && es && es.multiDrag._deselectMultiDrag(), Zt.forEach(function(r) {
        r.sortableIndex = qr(r);
      }), Zt = Zt.sort(function(r, i) {
        return r.sortableIndex - i.sortableIndex;
      }), _h = !0;
    },
    dragStarted: function(n) {
      var r = this, i = n.sortable;
      if (this.isMultiDrag) {
        if (this.options.sort && (i.captureAnimationState(), this.options.animation)) {
          Zt.forEach(function(a) {
            a !== sr && Et(a, "position", "absolute");
          });
          var o = vr(sr, !1, !0, !0);
          Zt.forEach(function(a) {
            a !== sr && hz(a, o);
          }), zo = !0, Pm = !0;
        }
        i.animateAll(function() {
          zo = !1, Pm = !1, r.options.animation && Zt.forEach(function(a) {
            ZT(a);
          }), r.options.sort && C1();
        });
      }
    },
    dragOver: function(n) {
      var r = n.target, i = n.completed, o = n.cancel;
      zo && ~Zt.indexOf(r) && (i(!1), o());
    },
    revert: function(n) {
      var r = n.fromSortable, i = n.rootEl, o = n.sortable, a = n.dragRect;
      Zt.length > 1 && (Zt.forEach(function(s) {
        o.addAnimationState({
          target: s,
          rect: zo ? vr(s) : a
        }), ZT(s), s.fromRect = a, r.removeAnimationState(s);
      }), zo = !1, r1t(!this.options.removeCloneOnHide, i));
    },
    dragOverCompleted: function(n) {
      var r = n.sortable, i = n.isOwner, o = n.insertion, a = n.activeSortable, s = n.parentEl, c = n.putSortable, l = this.options;
      if (o) {
        if (i && a._hideClone(), Pm = !1, l.animation && Zt.length > 1 && (zo || !i && !a.options.sort && !c)) {
          var u = vr(sr, !1, !0, !0);
          Zt.forEach(function(f) {
            f !== sr && (hz(f, u), s.appendChild(f));
          }), zo = !0;
        }
        if (!i)
          if (zo || C1(), Zt.length > 1) {
            var d = E1;
            a._showClone(r), a.options.animation && !E1 && d && la.forEach(function(f) {
              a.addAnimationState({
                target: f,
                rect: Mm
              }), f.fromRect = Mm, f.thisAnimationDuration = null;
            });
          } else
            a._showClone(r);
      }
    },
    dragOverAnimationCapture: function(n) {
      var r = n.dragRect, i = n.isOwner, o = n.activeSortable;
      if (Zt.forEach(function(s) {
        s.thisAnimationDuration = null;
      }), o.options.animation && !i && o.multiDrag.isMultiDrag) {
        Mm = Ha({}, r);
        var a = qd(sr, !0);
        Mm.top -= a.f, Mm.left -= a.e;
      }
    },
    dragOverAnimationComplete: function() {
      zo && (zo = !1, C1());
    },
    drop: function(n) {
      var r = n.originalEvent, i = n.rootEl, o = n.parentEl, a = n.sortable, s = n.dispatchSortableEvent, c = n.oldIndex, l = n.putSortable, u = l || this.sortable;
      if (r) {
        var d = this.options, f = o.children;
        if (!_h)
          if (d.multiDragKey && !this.multiDragKeyDown && this._deselectMultiDrag(), kr(sr, d.selectedClass, !~Zt.indexOf(sr)), ~Zt.indexOf(sr))
            Zt.splice(Zt.indexOf(sr), 1), Om = null, e0({
              sortable: a,
              rootEl: i,
              name: "deselect",
              targetEl: sr,
              originalEvent: r
            });
          else {
            if (Zt.push(sr), e0({
              sortable: a,
              rootEl: i,
              name: "select",
              targetEl: sr,
              originalEvent: r
            }), r.shiftKey && Om && a.el.contains(Om)) {
              var h = qr(Om), p = qr(sr);
              if (~h && ~p && h !== p) {
                var g, m;
                for (p > h ? (m = h, g = p) : (m = p, g = h + 1); m < g; m++)
                  ~Zt.indexOf(f[m]) || (kr(f[m], d.selectedClass, !0), Zt.push(f[m]), e0({
                    sortable: a,
                    rootEl: i,
                    name: "select",
                    targetEl: f[m],
                    originalEvent: r
                  }));
              }
            } else
              Om = sr;
            es = u;
          }
        if (_h && this.isMultiDrag) {
          if (zo = !1, (o[Bi].options.sort || o !== i) && Zt.length > 1) {
            var v = vr(sr), y = qr(sr, ":not(." + this.options.selectedClass + ")");
            if (!Pm && d.animation && (sr.thisAnimationDuration = null), u.captureAnimationState(), !Pm && (d.animation && (sr.fromRect = v, Zt.forEach(function(_) {
              if (_.thisAnimationDuration = null, _ !== sr) {
                var w = zo ? vr(_) : v;
                _.fromRect = w, u.addAnimationState({
                  target: _,
                  rect: w
                });
              }
            })), C1(), Zt.forEach(function(_) {
              f[y] ? o.insertBefore(_, f[y]) : o.appendChild(_), y++;
            }), c === qr(sr))) {
              var S = !1;
              Zt.forEach(function(_) {
                if (_.sortableIndex !== qr(_)) {
                  S = !0;
                  return;
                }
              }), S && (s("update"), s("sort"));
            }
            Zt.forEach(function(_) {
              ZT(_);
            }), u.animateAll();
          }
          es = u;
        }
        (i === o || l && l.lastPutMode !== "clone") && la.forEach(function(_) {
          _.parentNode && _.parentNode.removeChild(_);
        });
      }
    },
    nullingGlobal: function() {
      this.isMultiDrag = _h = !1, la.length = 0;
    },
    destroyGlobal: function() {
      this._deselectMultiDrag(), gn(document, "pointerup", this._deselectMultiDrag), gn(document, "mouseup", this._deselectMultiDrag), gn(document, "touchend", this._deselectMultiDrag), gn(document, "keydown", this._checkKeyDown), gn(document, "keyup", this._checkKeyUp);
    },
    _deselectMultiDrag: function(n) {
      if (!(typeof _h < "u" && _h) && es === this.sortable && !(n && ka(n.target, this.options.draggable, this.sortable.el, !1)) && !(n && n.button !== 0))
        for (; Zt.length; ) {
          var r = Zt[0];
          kr(r, this.options.selectedClass, !1), Zt.shift(), e0({
            sortable: this.sortable,
            rootEl: this.sortable.el,
            name: "deselect",
            targetEl: r,
            originalEvent: n
          });
        }
    },
    _checkKeyDown: function(n) {
      n.key === this.options.multiDragKey && (this.multiDragKeyDown = !0);
    },
    _checkKeyUp: function(n) {
      n.key === this.options.multiDragKey && (this.multiDragKeyDown = !1);
    }
  }, Ha(e, {
    // Static methods & properties
    pluginName: "multiDrag",
    utils: {
      /**
       * Selects the provided multi-drag item
       * @param  {HTMLElement} el    The element to be selected
       */
      select: function(n) {
        var r = n.parentNode[Bi];
        !r || !r.options.multiDrag || ~Zt.indexOf(n) || (es && es !== r && (es.multiDrag._deselectMultiDrag(), es = r), kr(n, r.options.selectedClass, !0), Zt.push(n));
      },
      /**
       * Deselects the provided multi-drag item
       * @param  {HTMLElement} el    The element to be deselected
       */
      deselect: function(n) {
        var r = n.parentNode[Bi], i = Zt.indexOf(n);
        !r || !r.options.multiDrag || !~i || (kr(n, r.options.selectedClass, !1), Zt.splice(i, 1));
      }
    },
    eventProperties: function() {
      var n = this, r = [], i = [];
      return Zt.forEach(function(o) {
        r.push({
          multiDragElement: o,
          index: o.sortableIndex
        });
        var a;
        zo && o !== sr ? a = -1 : zo ? a = qr(o, ":not(." + n.options.selectedClass + ")") : a = qr(o), i.push({
          multiDragElement: o,
          index: a
        });
      }), {
        items: Abt(Zt),
        clones: [].concat(la),
        oldIndicies: r,
        newIndicies: i
      };
    },
    optionListeners: {
      multiDragKey: function(n) {
        return n = n.toLowerCase(), n === "ctrl" ? n = "Control" : n.length > 1 && (n = n.charAt(0).toUpperCase() + n.substr(1)), n;
      }
    }
  });
}
function r1t(e, t) {
  Zt.forEach(function(n, r) {
    var i = t.children[n.sortableIndex + (e ? Number(r) : 0)];
    i ? t.insertBefore(n, i) : t.appendChild(n);
  });
}
function yz(e, t) {
  la.forEach(function(n, r) {
    var i = t.children[n.sortableIndex + (e ? Number(r) : 0)];
    i ? t.insertBefore(n, i) : t.appendChild(n);
  });
}
function C1() {
  Zt.forEach(function(e) {
    e !== sr && e.parentNode && e.parentNode.removeChild(e);
  });
}
Ut.mount(new Zbt());
Ut.mount(Xk, Yk);
const i1t = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  MultiDrag: n1t,
  Sortable: Ut,
  Swap: e1t,
  default: Ut
}, Symbol.toStringTag, { value: "Module" })), o1t = /* @__PURE__ */ bc(i1t);
var Sse = { exports: {} };
/*!
  Copyright (c) 2018 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
(function(e) {
  (function() {
    var t = {}.hasOwnProperty;
    function n() {
      for (var r = [], i = 0; i < arguments.length; i++) {
        var o = arguments[i];
        if (o) {
          var a = typeof o;
          if (a === "string" || a === "number")
            r.push(o);
          else if (Array.isArray(o)) {
            if (o.length) {
              var s = n.apply(null, o);
              s && r.push(s);
            }
          } else if (a === "object")
            if (o.toString === Object.prototype.toString)
              for (var c in o)
                t.call(o, c) && o[c] && r.push(c);
            else
              r.push(o.toString());
        }
      }
      return r.join(" ");
    }
    e.exports ? (n.default = n, e.exports = n) : window.classNames = n;
  })();
})(Sse);
var a1t = Sse.exports, s1t = process.env.NODE_ENV === "production", cI = "Invariant failed";
function c1t(e, t) {
  if (!e) {
    if (s1t)
      throw new Error(cI);
    var n = typeof t == "function" ? t() : t, r = n ? cI + ": " + n : cI;
    throw new Error(r);
  }
}
const l1t = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: c1t
}, Symbol.toStringTag, { value: "Module" })), u1t = /* @__PURE__ */ bc(l1t);
(function(e) {
  var t = o1t, n = a1t, r = D, i = u1t;
  function o(T) {
    return T && T.__esModule ? T.default : T;
  }
  function a(T, x, C, E) {
    Object.defineProperty(T, x, { get: C, set: E, enumerable: !0, configurable: !0 });
  }
  function s(T, x) {
    return Object.keys(x).forEach(function(C) {
      C === "default" || C === "__esModule" || T.hasOwnProperty(C) || Object.defineProperty(T, C, {
        enumerable: !0,
        get: function() {
          return x[C];
        }
      });
    }), T;
  }
  a(e.exports, "Sortable", () => $882b6d93070905b3$re_export$Sortable), a(e.exports, "Direction", () => $882b6d93070905b3$re_export$Direction), a(e.exports, "DOMRect", () => $882b6d93070905b3$re_export$DOMRect), a(e.exports, "GroupOptions", () => $882b6d93070905b3$re_export$GroupOptions), a(e.exports, "MoveEvent", () => $882b6d93070905b3$re_export$MoveEvent), a(e.exports, "Options", () => $882b6d93070905b3$re_export$Options), a(e.exports, "PullResult", () => $882b6d93070905b3$re_export$PullResult), a(e.exports, "PutResult", () => $882b6d93070905b3$re_export$PutResult), a(e.exports, "SortableEvent", () => $882b6d93070905b3$re_export$SortableEvent), a(e.exports, "SortableOptions", () => $882b6d93070905b3$re_export$SortableOptions), a(e.exports, "Utils", () => $882b6d93070905b3$re_export$Utils), a(e.exports, "ReactSortable", () => _);
  function c(T) {
    T.parentElement !== null && T.parentElement.removeChild(T);
  }
  function l(T, x, C) {
    const E = T.children[C] || null;
    T.insertBefore(x, E);
  }
  function u(T) {
    T.forEach((x) => c(x.element));
  }
  function d(T) {
    T.forEach((x) => {
      l(x.parentElement, x.element, x.oldIndex);
    });
  }
  function f(T, x) {
    const C = m(T), E = {
      parentElement: T.from
    };
    let R = [];
    switch (C) {
      case "normal":
        R = [
          {
            element: T.item,
            newIndex: T.newIndex,
            oldIndex: T.oldIndex,
            parentElement: T.from
          }
        ];
        break;
      case "swap":
        const $ = {
          element: T.item,
          oldIndex: T.oldIndex,
          newIndex: T.newIndex,
          ...E
        }, N = {
          element: T.swapItem,
          oldIndex: T.newIndex,
          newIndex: T.oldIndex,
          ...E
        };
        R = [
          $,
          N
        ];
        break;
      case "multidrag":
        R = T.oldIndicies.map((z, k) => ({
          element: z.multiDragElement,
          oldIndex: z.index,
          newIndex: T.newIndicies[k].index,
          ...E
        }));
        break;
    }
    return v(R, x);
  }
  function h(T, x) {
    const C = p(T, x);
    return g(T, C);
  }
  function p(T, x) {
    const C = [
      ...x
    ];
    return T.concat().reverse().forEach((E) => C.splice(E.oldIndex, 1)), C;
  }
  function g(T, x, C, E) {
    const R = [
      ...x
    ];
    return T.forEach((A) => {
      const O = E && C && E(A.item, C);
      R.splice(A.newIndex, 0, O || A.item);
    }), R;
  }
  function m(T) {
    return T.oldIndicies && T.oldIndicies.length > 0 ? "multidrag" : T.swapItem ? "swap" : "normal";
  }
  function v(T, x) {
    return T.map((E) => ({
      ...E,
      item: x[E.oldIndex]
    })).sort((E, R) => E.oldIndex - R.oldIndex);
  }
  function y(T) {
    const { list: x, setList: C, children: E, tag: R, style: A, className: O, clone: $, onAdd: N, onChange: z, onChoose: k, onClone: F, onEnd: V, onFilter: j, onRemove: B, onSort: U, onStart: Q, onUnchoose: K, onUpdate: q, onMove: X, onSpill: ie, onSelect: te, onDeselect: J, ...Y } = T;
    return Y;
  }
  const S = {
    dragging: null
  };
  class _ extends r.Component {
    constructor(x) {
      super(x), this.ref = /* @__PURE__ */ (0, r.createRef)();
      const C = [
        ...x.list
      ].map((E) => Object.assign(E, {
        chosen: !1,
        selected: !1
      }));
      x.setList(C, this.sortable, S), o(i)(
        //@ts-expect-error: Doesn't exist. Will deprecate soon.
        !x.plugins,
        `
Plugins prop is no longer supported.
Instead, mount it with "Sortable.mount(new MultiDrag())"
Please read the updated README.md at https://github.com/SortableJS/react-sortablejs.
      `
      );
    }
    componentDidMount() {
      if (this.ref.current === null)
        return;
      const x = this.makeOptions();
      o(t).create(this.ref.current, x);
    }
    componentDidUpdate(x) {
      x.disabled !== this.props.disabled && this.sortable && this.sortable.option("disabled", this.props.disabled);
    }
    render() {
      const { tag: x, style: C, className: E, id: R } = this.props, A = {
        style: C,
        className: E,
        id: R
      }, O = !x || x === null ? "div" : x;
      return /* @__PURE__ */ (0, r.createElement)(O, {
        // @todo - find a way (perhaps with the callback) to allow AntD components to work
        ref: this.ref,
        ...A
      }, this.getChildren());
    }
    getChildren() {
      const { children: x, dataIdAttr: C, selectedClass: E = "sortable-selected", chosenClass: R = "sortable-chosen", dragClass: A = "sortable-drag", fallbackClass: O = "sortable-falback", ghostClass: $ = "sortable-ghost", swapClass: N = "sortable-swap-highlight", filter: z = "sortable-filter", list: k } = this.props;
      if (!x || x == null)
        return null;
      const F = C || "data-id";
      return r.Children.map(x, (V, j) => {
        if (V === void 0)
          return;
        const B = k[j] || {}, { className: U } = V.props, Q = typeof z == "string" && {
          [z.replace(".", "")]: !!B.filtered
        }, K = o(n)(U, {
          [E]: B.selected,
          [R]: B.chosen,
          ...Q
        });
        return /* @__PURE__ */ (0, r.cloneElement)(V, {
          [F]: V.key,
          className: K
        });
      });
    }
    /** Appends the `sortable` property to this component */
    get sortable() {
      const x = this.ref.current;
      if (x === null)
        return null;
      const C = Object.keys(x).find((E) => E.includes("Sortable"));
      return C ? x[C] : null;
    }
    /** Converts all the props from `ReactSortable` into the `options` object that `Sortable.create(el, [options])` can use. */
    makeOptions() {
      const x = [
        "onAdd",
        "onChoose",
        "onDeselect",
        "onEnd",
        "onRemove",
        "onSelect",
        "onSpill",
        "onStart",
        "onUnchoose",
        "onUpdate"
      ], C = [
        "onChange",
        "onClone",
        "onFilter",
        "onSort"
      ], E = y(this.props);
      return x.forEach((A) => E[A] = this.prepareOnHandlerPropAndDOM(A)), C.forEach((A) => E[A] = this.prepareOnHandlerProp(A)), {
        ...E,
        onMove: (A, O) => {
          const { onMove: $ } = this.props, N = A.willInsertAfter || -1;
          if (!$)
            return N;
          const z = $(A, O, this.sortable, S);
          return typeof z > "u" ? !1 : z;
        }
      };
    }
    /** Prepares a method that will be used in the sortable options to call an `on[Handler]` prop & an `on[Handler]` ReactSortable method.  */
    prepareOnHandlerPropAndDOM(x) {
      return (C) => {
        this.callOnHandlerProp(C, x), this[x](C);
      };
    }
    /** Prepares a method that will be used in the sortable options to call an `on[Handler]` prop */
    prepareOnHandlerProp(x) {
      return (C) => {
        this.callOnHandlerProp(C, x);
      };
    }
    /** Calls the `props.on[Handler]` function */
    callOnHandlerProp(x, C) {
      const E = this.props[C];
      E && E(x, this.sortable, S);
    }
    // SORTABLE DOM HANDLING
    onAdd(x) {
      const { list: C, setList: E, clone: R } = this.props, A = [
        ...S.dragging.props.list
      ], O = f(x, A);
      u(O);
      const $ = g(O, C, x, R).map((N) => Object.assign(N, {
        selected: !1
      }));
      E($, this.sortable, S);
    }
    onRemove(x) {
      const { list: C, setList: E } = this.props, R = m(x), A = f(x, C);
      d(A);
      let O = [
        ...C
      ];
      if (x.pullMode !== "clone")
        O = p(A, O);
      else {
        let $ = A;
        switch (R) {
          case "multidrag":
            $ = A.map((N, z) => ({
              ...N,
              element: x.clones[z]
            }));
            break;
          case "normal":
            $ = A.map((N) => ({
              ...N,
              element: x.clone
            }));
            break;
          case "swap":
          default:
            o(i)(!0, `mode "${R}" cannot clone. Please remove "props.clone" from <ReactSortable/> when using the "${R}" plugin`);
        }
        u($), A.forEach((N) => {
          const z = N.oldIndex, k = this.props.clone(N.item, x);
          O.splice(z, 1, k);
        });
      }
      O = O.map(($) => Object.assign($, {
        selected: !1
      })), E(O, this.sortable, S);
    }
    onUpdate(x) {
      const { list: C, setList: E } = this.props, R = f(x, C);
      u(R), d(R);
      const A = h(R, C);
      return E(A, this.sortable, S);
    }
    onStart() {
      S.dragging = this;
    }
    onEnd() {
      S.dragging = null;
    }
    onChoose(x) {
      const { list: C, setList: E } = this.props, R = C.map((A, O) => {
        let $ = A;
        return O === x.oldIndex && ($ = Object.assign(A, {
          chosen: !0
        })), $;
      });
      E(R, this.sortable, S);
    }
    onUnchoose(x) {
      const { list: C, setList: E } = this.props, R = C.map((A, O) => {
        let $ = A;
        return O === x.oldIndex && ($ = Object.assign($, {
          chosen: !1
        })), $;
      });
      E(R, this.sortable, S);
    }
    onSpill(x) {
      const { removeOnSpill: C, revertOnSpill: E } = this.props;
      C && !E && c(x.item);
    }
    onSelect(x) {
      const { list: C, setList: E } = this.props, R = C.map((A) => Object.assign(A, {
        selected: !1
      }));
      x.newIndicies.forEach((A) => {
        const O = A.index;
        if (O === -1) {
          console.log(`"${x.type}" had indice of "${A.index}", which is probably -1 and doesn't usually happen here.`), console.log(x);
          return;
        }
        R[O].selected = !0;
      }), E(R, this.sortable, S);
    }
    onDeselect(x) {
      const { list: C, setList: E } = this.props, R = C.map((A) => Object.assign(A, {
        selected: !1
      }));
      x.newIndicies.forEach((A) => {
        const O = A.index;
        O !== -1 && (R[O].selected = !0);
      }), E(R, this.sortable, S);
    }
  }
  /* eslint-disable-next-line */
  ye(_, "defaultProps", {
    clone: (x) => x
  });
  var w = {};
  s(e.exports, w);
})(ase);
var d1t = ase.exports;
const f1t = (e) => {
  const t = ho(), { primaryColour: n } = hr();
  return /* @__PURE__ */ M.jsxs(
    h1t,
    {
      primaryColour: n,
      borderRadius: t,
      disabled: e.disabled,
      children: [
        /* @__PURE__ */ M.jsx(tZ, { style: { fontSize: 26 } }),
        e.children
      ]
    }
  );
}, h1t = Ce.div`
  display: flex;
  flex-grow: 1;
  gap: var(--spacing-sm);
  min-height: var(--button-height);
  cursor: ${(e) => e.disabled ? "default" : "grab"};
  user-select: none;
  align-items: center;
  padding: var(--spacing-xxs) var(--spacing-sm);
  background-color: var(--light);

  border: 1px solid var(--mid);

  border-radius: ${(e) => e.borderRadius};

  @media (hover: hover) {
    &:hover {
      border-color: ${(e) => e.primaryColour};
      box-shadow: 0 0 5px 0px rgba(0, 0, 0, 0.3);
    }
  }

  span {
    /* width: 100%; */
    font-size: var(--choice-text-font-size);
    text-align: left;
    text-overflow: ellipsis;
    word-wrap: break-word;
    word-break: break-word;
    color: var(--dark);
  }
`, g1t = ({ item: e, onChange: t }) => {
  const { primaryColour: n } = hr(), r = ho();
  return /* @__PURE__ */ M.jsxs(p1t, { borderRadius: r, primaryColour: n, children: [
    /* @__PURE__ */ M.jsx(tZ, { style: { fontSize: 26 } }),
    /* @__PURE__ */ M.jsx(
      qk,
      {
        inputValue: e.value,
        onValueChange: t,
        placeholder: e.placeholder,
        label: e.text ? Dr(e.text) : "",
        primaryColour: n,
        noBorder: !0
      }
    )
  ] });
}, p1t = Ce.div`
  display: flex;
  flex-grow: 1;
  /* gap: var(--spacing-sm); */

  min-height: var(--button-height);
  cursor: grab;
  user-select: none;
  align-items: center;
  padding: var(--spacing-xxs) var(--spacing-sm);
  border: 1px solid var(--mid);
  border-radius: ${(e) => e.borderRadius};
  background-color: var(--light);
  @media (hover: hover) {
    &:hover {
      border-color: ${(e) => e.primaryColour};
      box-shadow: 0 0 5px 0px rgba(0, 0, 0, 0.3);
    }
  }
`, m1t = ({
  updateCurrent: e,
  currentAnswer: t,
  settings: n,
  question: r,
  submitAnswer: i,
  injectCurrent: o,
  answers: a,
  setNextButtonBehaviour: s
}) => {
  const { loggingService: c, messagerService: l, popupService: u } = St(ir), d = gc(r.choices, a), f = t.getValue(r.type), h = _1t(f, d), { primaryColour: p } = hr(), g = ho(), m = (w) => {
    if (c.info("onListChange", w), w.length > 0) {
      const T = lI(w);
      o({ value: T });
    }
  };
  gt(() => {
    const w = t.getValue(r.type);
    if (w !== null && d.length !== 0 && d.length !== w.length) {
      const T = w.filter(
        (R) => d.find((A) => A.id === R.id)
      ), x = d.filter((R) => !w.find((A) => A.id === R.id)), C = lI(x) ?? [], E = [...T, ...C];
      o({ value: E });
    }
  }, [d, t, o, r.type]), gt(() => {
    const w = t.getValue(r.type);
    if (r.required)
      if (w && w.length > 0)
        s(void 0);
      else
        return s(() => {
          const x = lI(d);
          o({ value: x }), l.warning(
            `It looks like you haven't made any changes to the ranking. If you're happy with the ranking, please click "Next" again.`
          );
        }), () => {
          s(void 0);
        };
  }, [
    r.required,
    r.type,
    t,
    d,
    o,
    i,
    s
  ]);
  const y = Ts({
    default: {
      content: "Drag and drop to rank the options. Once you are happy with your ranking, click next to continue"
    },
    notRequired: { content: "Please drag and drop to rank the options, or click next to continue" }
  }, r.helpPopups), S = r.showHelpPopups ?? !1, _ = r.helpPopupsToShow;
  return gt(() => {
    r.required ? u.setPopup(y, "default", S, _) : u.setPopup(y, "notRequired", S, _);
  }, [y, S, _, r.required]), /* @__PURE__ */ M.jsx(S1t, { dynamicColour: p, borderRadius: g, children: /* @__PURE__ */ M.jsx(
    d1t.ReactSortable,
    {
      className: "sortableContainer",
      animation: 200,
      ghostClass: "ghost",
      list: h,
      setList: m,
      filter: "input",
      preventOnFilter: !1,
      delay: 100,
      delayOnTouchOnly: !0,
      touchStartThreshold: 4,
      disabled: r.disabled,
      children: h.map((w, T) => /* @__PURE__ */ M.jsxs(w1t, { children: [
        /* @__PURE__ */ M.jsxs(x1t, { dynamicColour: p, children: [
          T + 1,
          "."
        ] }),
        /* @__PURE__ */ M.jsx(
          v1t,
          {
            item: w,
            settings: n,
            listState: h,
            onListChange: m,
            disabled: r.disabled,
            colour: r.shade ? p : void 0
          }
        )
      ] }, w.id))
    }
  ) });
}, v1t = (e) => e.item.type === "input" ? /* @__PURE__ */ M.jsx(b1t, { ...e }) : /* @__PURE__ */ M.jsx(y1t, { ...e }), y1t = ({ item: e, disabled: t }) => /* @__PURE__ */ M.jsx(M.Fragment, { children: /* @__PURE__ */ M.jsx(f1t, { disabled: t, children: /* @__PURE__ */ M.jsx("span", { children: e.text ? Dr(e.text) : e.value }) }, e.id) }), b1t = ({ item: e, settings: t, listState: n, onListChange: r }) => {
  const i = (o) => {
    const a = n.map((s, c) => s.id === e.id ? { ...s, value: o.target.value } : s);
    r(a);
  };
  return /* @__PURE__ */ M.jsx(g1t, { item: e, onChange: i });
};
function _1t(e, t) {
  let n = [];
  return e && e.length > 0 && t.length > 0 ? n = e.filter((r) => t.find((i) => i.id === r.id)).map((r) => {
    const i = t.find((o) => o.id === r.id);
    if (i === void 0)
      throw new Error("Ranking question choice not found");
    return { ...i, value: r.info ? r.info.itemValue : i == null ? void 0 : i.value };
  }) : n = t, n;
}
function lI(e) {
  return e.map((n, r) => ({ id: n.id, value: (r + 1).toFixed(0), info: { itemValue: n.value } }));
}
const S1t = Ce.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: stretch;

  .sortableContainer {
    display: flex;
    flex-direction: column;
    align-items: stretch;
    gap: 0.5rem;
    cursor: grab;
  }

  .ghost {
    opacity: 0.5;
    background: ${(e) => e.dynamicColour};
    border-radius: ${(e) => e.borderRadius};
    cursor: grabbing;
  }
`, w1t = Ce.div`
  display: flex;
  flex-direction: row;
  align-items: stretch;
  gap: 0.5rem;
`, x1t = Ce.div`
  font-size: 1.5rem;
  display: flex;
  flex: 0 0 var(--spacing-lg);
  align-items: center;
  color: ${(e) => e.dynamicColour};
  pointer-events: none;
`, E1t = (e) => {
  const t = wa();
  let n = { ...e.question, type: "slider", vertical: !0 };
  t !== ui.MOBILE && (n = { ...e.question, type: "slider", vertical: !1 });
  const r = {
    ...e,
    question: n,
    currentAnswer: e.currentAnswer.convertedToQuestionType("slider")
  };
  return /* @__PURE__ */ M.jsx(nse, { ...r });
}, C1t = ({
  question: e,
  currentAnswer: t,
  injectCurrent: n,
  submitAnswer: r,
  answers: i,
  settings: o
}) => {
  const { primaryColour: a, contrastColour: s } = hr(), c = t == null ? void 0 : t.getValue(e.type), l = Dn(e.buckets, { answers: i }), u = Dn(e.initialStates, { answers: i }), d = Me(null), [f, h] = D.useState(null), [p, g] = D.useState(null), [m, v] = D.useState(null), [y, S] = D.useState(null), _ = At(
    () => ({
      canvasWidth: 400,
      canvasHeight: 300,
      paddingTop: 50,
      paddingBottom: 20,
      paddingLeft: 10,
      paddingRight: 10,
      circleRadius: 7,
      tickHeight: 10,
      primaryColour: a
    }),
    [a]
  ), w = mn(
    (O) => {
      O.clearRect(0, 0, _.canvasWidth, _.canvasHeight), T1t(O, u, l, f, m, y, _), A1t(O, c, u, l, _), I1t(O, u, l, p, f, _);
    },
    [
      l,
      y,
      _,
      c,
      u,
      p,
      m,
      f
    ]
  ), T = (O) => {
    const $ = window.devicePixelRatio || 1, N = O.getBoundingClientRect();
    O.width = N.width * $, O.height = N.height * $;
    const z = O.getContext("2d");
    return z ? (z.scale($, $), z) : null;
  };
  gt(() => {
    const O = d.current;
    if (!O)
      return;
    const $ = T(O);
    $ && w($);
  }, [w]);
  const x = (O, $) => {
    const N = {
      id: `${O.id}::final`,
      value: $.id
    };
    if (c) {
      const z = c.filter((k) => k.id !== `${O.id}::final`);
      z.push(N), n({ value: z });
    } else
      n({ value: [N] });
  }, C = (O, $) => {
    const z = C2(u, l, _).find((k) => {
      const F = O - k.x, V = $ - k.y;
      return Math.sqrt(F * F + V * V) < k.radius;
    });
    return z ? (u == null ? void 0 : u.find((k) => k.id === z.id)) ?? null : null;
  }, E = (O, $) => (l == null ? void 0 : l.find((z) => O > z.lower * _.canvasWidth && O < z.upper * _.canvasWidth && $ > 0.5 * _.canvasHeight)) ?? null, R = (O) => {
    const $ = d.current;
    if (!$)
      return;
    const N = $.getBoundingClientRect(), z = O.clientX - N.left, k = O.clientY - N.top;
    if (f === null) {
      const F = C(z, k);
      F && h(F.id);
    } else {
      const F = E(z, k);
      if (F) {
        const V = u == null ? void 0 : u.find((j) => j.id === f);
        if (!V)
          return;
        x(V, F), h(null);
      }
    }
  }, A = (O) => {
    const $ = d.current;
    if (!$)
      return;
    const N = $.getBoundingClientRect(), z = O.clientX - N.left, k = O.clientY - N.top;
    g([z, k]);
    const F = C(z, k);
    v(F ? F.id : null);
    const V = E(z, k);
    S(V ? V.id : null);
  };
  return /* @__PURE__ */ M.jsx(N1t, { children: /* @__PURE__ */ M.jsx(
    "canvas",
    {
      id: "shiftCanvas",
      width: _.canvasWidth,
      height: _.canvasHeight,
      ref: d,
      onClick: R,
      onMouseMove: A
    }
  ) });
}, T1t = (e, t, n, r, i, o, a) => {
  M1t(e, t, n, r, i, a), k1t(e, n, r, o, a);
}, I1t = (e, t, n, r, i, o) => {
  if (!r)
    return;
  const a = C2(t, n, o);
  if (!a)
    return;
  const s = a.find((u) => u.id === i);
  if (!s)
    return;
  const [c, l] = r;
  ip(e, s.x, s.y, c, l, o.primaryColour);
}, A1t = (e, t, n, r, i) => {
  if (!t)
    return;
  const o = C2(n, r, i);
  if (!o)
    return;
  const a = ab(i);
  t.forEach((s) => {
    const c = o.find((u) => `${u.id}::final` === s.id);
    if (!c)
      return;
    const l = r == null ? void 0 : r.find((u) => u.id === s.value);
    l && ip(
      e,
      c.x,
      c.y,
      (l.lower + l.upper) / 2 * a + i.paddingLeft,
      i.canvasHeight - i.paddingBottom
    );
  });
}, C2 = (e, t, n) => {
  if (!e)
    return [];
  const r = {};
  return e.forEach((o) => {
    r[o.bucketId] || (r[o.bucketId] = []), r[o.bucketId].push(o);
  }), Object.entries(r).map(([o, a]) => {
    const s = t == null ? void 0 : t.find((d) => d.id === o);
    if (!s)
      return [];
    const c = n.paddingTop, l = n.circleRadius, u = ab(n);
    return a.map((d, f) => ({
      x: (s.lower + (s.upper - s.lower) * (f + 1) / (a.length + 1)) * u + n.paddingLeft,
      y: c,
      id: d.id,
      radius: l,
      state: d
    }));
  }).flat();
}, wse = (e, t, n, r) => {
  if (!n)
    return;
  const i = ab(r);
  n.forEach((o, a) => {
    const s = o.lower * i + r.paddingLeft, c = o.upper * i + r.paddingLeft;
    ip(e, s, t - r.tickHeight / 2, s, t + r.tickHeight / 2), ip(e, c, t - r.tickHeight / 2, c, t + r.tickHeight / 2);
  });
}, R1t = (e, t, n) => {
  if (!t)
    return;
  const r = ab(n);
  t.forEach((i, o) => {
    const a = i.lower * r + n.paddingLeft, s = i.upper * r + n.paddingLeft;
    e.font = "1rem Inter", e.fillStyle = "black", e.textAlign = "center", e.fillText(
      i.label,
      (a + s) / 2,
      n.canvasHeight - n.paddingBottom + 20,
      s - a
    );
  });
}, $1t = (e, t, n, r, i) => {
  if (!t || !n || !r)
    return;
  const o = ab(i), a = t.find((l) => l.id === r);
  if (!a)
    return;
  const s = a.lower * o + i.paddingLeft, c = a.upper * o + i.paddingLeft;
  e.fillStyle = "rgba(0, 0, 0, 0.1)", e.fillRect(
    s,
    i.canvasHeight - i.paddingBottom,
    c - s,
    -(i.canvasHeight - i.paddingTop - i.paddingBottom)
  );
}, O1t = (e, t, n, r, i) => {
  e.save(), e.translate(t, n), e.rotate(-Math.PI / 4), e.translate(-t, -n), e.font = "1rem Inter", e.fillStyle = "black", e.textAlign = "center", e.fillText(r, t + i + 25, n + i), e.restore();
}, P1t = (e, t, n, r, i, o) => {
  C2(t, n, o).forEach((s, c) => {
    O1t(e, s.x, s.y, s.state.label, s.radius), e.beginPath(), e.arc(s.x, s.y, s.radius, 0, 2 * Math.PI), r === s.id || i === s.id ? (e.fillStyle = o.primaryColour, e.fill()) : (e.strokeStyle = "black", e.stroke());
  });
}, M1t = (e, t, n, r, i, o) => {
  ip(
    e,
    o.paddingLeft,
    o.paddingTop,
    o.canvasWidth - o.paddingRight,
    o.paddingTop
  ), wse(e, o.paddingTop, n, o), P1t(e, t, n, r, i, o);
}, k1t = (e, t, n, r, i) => {
  ip(
    e,
    i.paddingLeft,
    i.canvasHeight - i.paddingBottom,
    i.canvasWidth - i.paddingRight,
    i.canvasHeight - i.paddingBottom
  ), wse(e, i.canvasHeight - i.paddingBottom, t, i), R1t(e, t, i), $1t(e, t, n, r, i);
};
function ab(e) {
  return e.canvasWidth - e.paddingLeft - e.paddingRight;
}
const ip = (e, t, n, r, i, o = "black") => {
  e.beginPath(), e.strokeStyle = o, e.moveTo(t, n), e.lineTo(r, i), e.stroke();
}, N1t = Ce.div`
  display: flex;
  flex-direction: column;
`, bz = 0.01, D1t = ({
  question: e,
  currentAnswer: t,
  injectCurrent: n,
  submitAnswer: r,
  answers: i,
  settings: o
}) => {
  const { messagerService: a, popupService: s } = St(ir), { primaryColour: c, primary50: l } = hr(), u = t == null ? void 0 : t.getValue(e.type);
  let d = Z6();
  d.endsWith(";") && (d = d.slice(0, -1));
  const f = Dn(e.initialStates, { answers: i }), h = Me(null), p = Me(null), [g, m] = D.useState(null), [v, y] = D.useState(null), [S, _] = D.useState(null), [w, T] = D.useState(null), [x, C] = D.useState([]), [E, R] = D.useState(512), [A, O] = D.useState(300), [$, N] = D.useState(20), z = At(
    () => ({
      canvasWidth: 512,
      canvasHeight: 300,
      paddingTop: 20,
      paddingBottom: 40,
      paddingLeft: 15,
      paddingRight: 15,
      circleRadius: 10,
      tickHeight: 10,
      primaryColour: c,
      secondaryColour: l,
      fontFamily: d
    }),
    [c, d]
  ), k = {
    ...z,
    canvasWidth: E,
    canvasHeight: A,
    paddingTop: $
  };
  Nv(() => {
    const Z = _z(h.current);
    let H = [];
    Z && f && (H = Sz(
      Z.context,
      f,
      k
    ));
    const oe = j1t(H), W = {
      ...k,
      paddingTop: oe ?? z.paddingTop
    };
    Z && f && oe !== null && (H = Sz(
      Z.context,
      f,
      W
    )), C(H), N(W.paddingTop);
  }, [f, z, k.canvasWidth, k.canvasHeight]), gt(() => {
    const Z = h.current;
    if (!Z)
      return;
    L1t(Z);
    const H = _z(Z);
    if (!H)
      return;
    const { context: oe, width: W, height: se } = H, ce = se;
    R(W), O(ce);
    const ge = {
      ...k,
      canvasWidth: W,
      canvasHeight: ce
    };
    oe.clearRect(0, 0, ge.canvasWidth, ge.canvasHeight), F1t(oe, ge), B1t(oe, u, f, g, S, ge), W1t(
      oe,
      f,
      g,
      S,
      u,
      x,
      ge
    ), Q1t(oe, g, f, w, ge, e.onlyAllowForwards), V1t(oe, f, v, g, ge);
  }, [
    f,
    g,
    S,
    w,
    u,
    z,
    $,
    v,
    x,
    e.onlyAllowForwards
  ]);
  const F = (Z, H) => {
    const oe = {
      id: `${Z.id}::final`,
      value: H.value.toPrecision(3)
    };
    if (u) {
      const W = u.filter((se) => se.id !== `${Z.id}::final`);
      W.push(oe), n({ value: W });
    } else
      n({ value: [oe] });
  }, V = (Z, H) => {
    if (!f)
      return null;
    let oe = f.find((W) => {
      const [se, ce, ge] = Qk(W, k), he = Z - se, ue = H - ce;
      return Math.sqrt(he * he + ue * ue) < ge;
    });
    if (!oe) {
      const W = x.find((se) => Z > se.left && Z < se.right && H > se.top && H < se.bottom);
      if (!W)
        return null;
      oe = W.state;
    }
    return oe ?? null;
  }, j = (Z, H) => {
    if (H < k.paddingTop + 0.6 * (k.canvasHeight - k.paddingTop - k.paddingBottom))
      return null;
    const oe = Zu(k), W = (Z - k.paddingLeft) / oe;
    return W < 0 || W > 1 ? null : {
      value: W
    };
  }, B = (Z) => {
    const H = h.current;
    if (!H)
      return;
    const oe = H.getBoundingClientRect(), W = Z.clientX - oe.left, se = Z.clientY - oe.top;
    if (g === null) {
      const ce = V(W, se);
      ce && m(ce.id);
    } else {
      const ce = j(W, se);
      if (ce) {
        const he = f == null ? void 0 : f.find((ue) => ue.id === g);
        if (!he)
          return;
        if (e.onlyAllowForwards && he.value > ce.value + bz) {
          a.error("Final value must be greater than initial value");
          return;
        }
        F(he, ce), m(null);
        return;
      }
      const ge = V(W, se);
      if (ge)
        if (ge.id === g) {
          m(null);
          return;
        } else {
          m(ge.id);
          return;
        }
    }
  }, U = (Z) => {
    const H = h.current;
    if (!H)
      return;
    const oe = H.getBoundingClientRect(), W = Z.clientX - oe.left, se = Z.clientY - oe.top;
    y([W, se]);
    const ce = V(W, se);
    _(ce ? ce.id : null);
    const ge = j(W, se);
    T(ge ? ge.value : null);
  }, Q = (Z) => {
    Z.preventDefault(), g && m(null);
  }, K = (Z) => {
    Z.preventDefault();
    const H = h.current;
    if (!H)
      return;
    const oe = H.getBoundingClientRect(), W = Z.touches[0].clientX - oe.left, se = Z.touches[0].clientY - oe.top, ce = V(W, se);
    ce && m(ce.id);
  }, q = (Z) => {
    const H = h.current;
    if (!H)
      return;
    const oe = H.getBoundingClientRect(), W = Z.changedTouches[0].clientX - oe.left, se = Z.changedTouches[0].clientY - oe.top, ce = j(W, se);
    if (ce) {
      const ge = f == null ? void 0 : f.find((he) => he.id === g);
      if (!ge)
        return;
      if (e.onlyAllowForwards && ge.value > ce.value + bz) {
        a.error("Final value must be greater than initial value"), m(null);
        return;
      }
      F(ge, ce), m(null);
      return;
    }
    m(null);
  }, X = (Z) => {
    Z.preventDefault();
    const H = h.current;
    if (!H)
      return;
    const oe = H.getBoundingClientRect(), W = Z.touches[0].clientX - oe.left, se = Z.touches[0].clientY - oe.top;
    y([W, se]);
    const ce = j(W, se);
    T(ce ? ce.value : null);
  }, ie = window.devicePixelRatio || 1, J = Ts({
    selectInitial: {
      content: "Click an initial state at the top",
      position: { left: 1, top: 0 }
    },
    shiftSelected: {
      content: "Click the desired state along the bottom",
      position: { left: 1, top: 1 }
    },
    allShifted: { content: "Once you are happy with the shifts, click next to continue" }
  }, e.helpPopups), Y = e.showHelpPopups ?? !1, ee = e.helpPopupsToShow;
  return gt(() => {
    u && f && u.length === f.length ? s.setPopup(J, "allShifted", Y, ee) : g === null ? s.setPopup(J, "selectInitial", Y, ee) : s.setPopup(J, "shiftSelected", Y, ee);
  }, [J, Y, ee, f, u, g]), /* @__PURE__ */ M.jsx(t_t, { ref: p, children: /* @__PURE__ */ M.jsx(
    n_t,
    {
      id: "shiftCanvas",
      width: z.canvasWidth,
      height: (1 + k.paddingTop / k.canvasHeight) * z.canvasHeight * ie,
      ref: h,
      onClick: B,
      onAuxClick: Q,
      onContextMenu: (Z) => Z.preventDefault(),
      onMouseMove: U,
      onTouchStart: K,
      onTouchMove: X,
      onTouchEnd: q
    }
  ) });
}, _z = (e) => {
  if (!e)
    return null;
  const t = window.devicePixelRatio || 1, n = e.getContext("2d");
  return n ? (n.scale(t, t), {
    context: n,
    width: e.width / t,
    height: e.height / t
  }) : null;
};
function L1t(e) {
  const t = window.devicePixelRatio || 1, n = e.getBoundingClientRect();
  e.width = n.width * t, e.height = n.height * t;
}
function j1t(e) {
  if (e.length === 0)
    return null;
  const t = e.sort((r, i) => r.y - i.y);
  return t[t.length - 1].y - t[0].y + t[0].height + 50;
}
function Qk(e, t) {
  return [
    e.value * Zu(t) + t.paddingLeft,
    t.paddingTop,
    t.circleRadius
  ];
}
const F1t = (e, t) => {
  z1t(e, t), H1t(e, t), Gd(
    e,
    t.paddingLeft,
    t.canvasHeight - t.paddingBottom,
    t.canvasWidth - t.paddingRight,
    t.canvasHeight - t.paddingBottom
  );
}, V1t = (e, t, n, r, i) => {
  if (!n || !t)
    return;
  const o = t.find((c) => c.id === r);
  if (!o)
    return;
  const [a, s] = n;
  e.lineWidth = 2, e_t(
    e,
    o.value * Zu(i) + i.paddingLeft,
    i.paddingTop,
    a,
    s,
    "black"
  ), e.lineWidth = 1;
}, B1t = (e, t, n, r, i, o) => {
  if (!t || !n)
    return;
  const a = Zu(o);
  t.forEach((s) => {
    const c = n.find((d) => `${d.id}::final` === s.id);
    if (!c)
      return;
    let l = "black", u = 1;
    r === c.id ? l = "rgba(0, 0, 0, 0.3)" : i === c.id && (u = 2), Gd(
      e,
      c.value * a + o.paddingLeft,
      o.paddingTop,
      Number(s.value) * a + o.paddingLeft,
      o.canvasHeight - o.paddingBottom,
      l,
      u
    ), e.beginPath(), e.arc(
      Number(s.value) * a + o.paddingLeft,
      o.canvasHeight - o.paddingBottom,
      o.circleRadius,
      0,
      2 * Math.PI
    ), e.fillStyle = o.secondaryColour, e.fill(), e.fillStyle = "white", e.font = `0.5rem ${o.fontFamily}`, e.fillText(
      (Number(s.value) * 100).toFixed(0) + "%",
      Number(s.value) * a + o.paddingLeft,
      o.canvasHeight - o.paddingBottom + o.circleRadius / 4
    );
  });
};
function z1t(e, t) {
  e.fillStyle = "rgba(0, 0, 0, 0.05)", e.fillRect(
    t.paddingLeft,
    t.paddingTop,
    t.canvasWidth - t.paddingLeft - t.paddingRight,
    t.canvasHeight - t.paddingBottom - t.paddingTop
  );
}
const H1t = (e, t) => {
  const n = Zu(t), r = [0, 0.2, 0.4, 0.6, 0.8, 1], i = t.paddingTop, o = t.canvasHeight - t.paddingBottom;
  r.forEach((a, s) => {
    const c = a * n + t.paddingLeft;
    Gd(e, c, i - t.tickHeight / 2, c, i + t.tickHeight / 2), Gd(e, c, o - t.tickHeight / 2, c, o + t.tickHeight / 2), Gd(e, c, i, c, o, "rgba(0, 0, 0, 0.2)");
  }), r.forEach((a, s) => {
    const c = a * n + t.paddingLeft;
    e.font = `1rem ${t.fontFamily}`, e.fillStyle = "black", e.textAlign = "center", e.fillText((a * 100).toFixed(0), c, o + t.tickHeight + 20);
  });
}, U1t = (e, t, n, r, i, o) => {
  if (!t)
    return;
  const a = o.paddingTop;
  t.forEach((s, c) => {
    const l = s.value * Zu(o) + o.paddingLeft, u = i == null ? void 0 : i.find((d) => d.id === `${s.id}::final`);
    e.beginPath(), e.arc(l, a, o.circleRadius, 0, 2 * Math.PI), n === s.id || r === s.id ? (e.fillStyle = "black", e.fill(), e.strokeStyle = o.secondaryColour, e.lineWidth = 5, e.stroke(), e.lineWidth = 1) : u ? (e.fillStyle = o.primaryColour, e.fill(), e.strokeStyle = o.secondaryColour, e.lineWidth = 5, e.stroke(), e.lineWidth = 1) : (e.fillStyle = o.primaryColour, e.fill());
  });
}, W1t = (e, t, n, r, i, o, a) => {
  Gd(
    e,
    a.paddingLeft,
    a.paddingTop,
    a.canvasWidth - a.paddingRight,
    a.paddingTop
  ), U1t(e, t, n, r, i, a), q1t(e, n, r, i, o, a);
};
function q1t(e, t, n, r, i, o) {
  G1t(e, i, t, n, r, o);
}
function G1t(e, t, n, r, i, o) {
  t.forEach((s) => {
    const c = i == null ? void 0 : i.find((l) => l.id === `${s.state.id}::final`);
    K1t(e, s, n, r, c, o);
  });
  let a = null;
  if (n ? a = t.find((s) => s.state.id === n) ?? null : r && (a = t.find((s) => s.state.id === r) ?? null), a) {
    const [s, c] = Qk(a.state, o);
    e.lineWidth = 2, Gd(e, a.x, a.y, s, c, "black"), e.lineWidth = 1;
  }
}
function K1t(e, t, n, r, i, o) {
  i ? e.fillStyle = o.secondaryColour : e.fillStyle = o.primaryColour, e.fillRect(
    t.left - 7,
    t.top - 7,
    t.width + 2 * 7,
    t.height + 2 * 7
  ), n === t.state.id || r === t.state.id ? e.font = `bold 1rem ${o.fontFamily}` : e.font = `1rem ${o.fontFamily}`, e.textAlign = "left", e.fillStyle = "white", e.fillText(t.state.label, t.x, t.y), (n === t.state.id || r === t.state.id) && (e.font = `bold 1rem ${o.fontFamily}`, e.strokeStyle = "white", e.lineWidth = 3, e.strokeText((t.state.value * 100).toFixed(0) + "%", t.x - 40, t.y), e.fillStyle = "black", e.fillText((t.state.value * 100).toFixed(0) + "%", t.x - 40, t.y));
}
function Sz(e, t, n) {
  const r = [];
  for (const i of t) {
    const [o, a] = Qk(i, n);
    xse(e, o, a - n.circleRadius - 10, i, r, n);
  }
  return r;
}
function xse(e, t, n, r, i, o) {
  const a = Y1t(e, t, n, r, o);
  i.some((s) => X1t(s, a)) ? xse(e, t, n - 20, r, i, o) : i.push(a);
}
function Y1t(e, t, n, r, i) {
  e.font = `1rem ${i.fontFamily}`, e.textAlign = "left";
  const o = e.measureText(r.label);
  return {
    x: t,
    y: n,
    width: o.width,
    height: o.actualBoundingBoxAscent + o.actualBoundingBoxDescent,
    left: t - o.actualBoundingBoxLeft,
    right: t + o.actualBoundingBoxRight,
    top: n - o.actualBoundingBoxAscent,
    bottom: n + o.actualBoundingBoxDescent,
    state: r
  };
}
function X1t(e, t, n = 10, r = 0) {
  return e.x < t.x + t.width + n && e.x + e.width > t.x - n && e.y < t.y + t.height + r && e.y + e.height > t.y - r;
}
const Q1t = (e, t, n, r, i, o = !1) => {
  o && J1t(e, r, n, t, i), Z1t(e, r, t, i);
};
function J1t(e, t, n, r, i) {
  if (!t || !n || !r)
    return;
  const o = n.find((l) => l.id === r);
  if (!o || o.value < t)
    return;
  const a = Zu(i), s = i.paddingLeft, c = o.value * a + i.paddingLeft;
  e.fillStyle = "rgba(139, 0, 0, 0.1)", e.fillRect(
    s,
    i.canvasHeight - i.paddingBottom,
    c,
    -(i.canvasHeight - i.paddingTop - i.paddingBottom)
  );
}
function Z1t(e, t, n, r) {
  if (!t || !n)
    return;
  const i = Zu(r), o = t * i + r.paddingLeft - r.circleRadius, a = t * i + r.paddingLeft + r.circleRadius;
  e.fillStyle = "rgba(0, 0, 0, 0.1)", e.fillRect(
    o,
    r.canvasHeight - r.paddingBottom,
    a - o,
    -(r.canvasHeight - r.paddingTop - r.paddingBottom)
  ), e.font = `1rem ${r.fontFamily}`, e.textAlign = "center", e.fillStyle = "black", e.fillText(
    (t * 100).toFixed(0) + "%",
    t * i + r.paddingLeft,
    r.canvasHeight - r.paddingBottom + 20
  );
}
function Zu(e) {
  return e.canvasWidth - e.paddingLeft - e.paddingRight;
}
function e_t(e, t, n, r, i, o = "black", a = 1) {
  const c = r - t, l = i - n, u = Math.atan2(l, c);
  e.beginPath(), e.strokeStyle = o, e.lineWidth = a, e.moveTo(t, n), e.lineTo(r, i), e.lineTo(
    r - 10 * Math.cos(u - Math.PI / 6),
    i - 10 * Math.sin(u - Math.PI / 6)
  ), e.moveTo(r, i), e.lineTo(
    r - 10 * Math.cos(u + Math.PI / 6),
    i - 10 * Math.sin(u + Math.PI / 6)
  ), e.stroke();
}
const Gd = (e, t, n, r, i, o = "black", a = 1) => {
  e.beginPath(), e.lineWidth = a, e.strokeStyle = o, e.moveTo(t, n), e.lineTo(r, i), e.stroke();
}, t_t = Ce.div`
  display: flex;
  flex-direction: column;
`, n_t = Ce.canvas`
  display: flex;
  width: 100%;
  touch-action: none;
`, r_t = ({
  question: e,
  currentAnswer: t,
  injectCurrent: n,
  submitAnswer: r,
  answers: i,
  settings: o
}) => {
  const { loggingService: a, popupService: s } = St(ir);
  a.info("SingleSelectQuestion");
  const c = t.getValue(e.type);
  if (c && Wn.isArray(c))
    throw new Error("SingleSelect question received an array as a current answer value");
  const l = gc(e.choices, i), u = mn(() => {
    if (!e.defaultValues)
      return;
    const m = e.defaultValues({ answers: i, choices: l }), v = l.find((y) => y.id === m);
    if (v)
      return {
        id: v.id,
        value: v.value
      };
  }, [e, i, l]);
  kf(u, e, t, i, n);
  const d = {
    noneSelected: { content: "Please select an option" },
    selected: { content: "Click next to continue" },
    notRequired: { content: "Please select an option or click next to continue" }
  }, f = Dn(e.helpPopups, { answers: i }), h = Ts(d, f), p = e.showHelpPopups ?? !1, g = e.helpPopupsToShow;
  return gt(() => {
    e.required ? c === null ? s.setPopup(h, "noneSelected", p, g) : s.setPopup(h, "selected", p, g) : s.setPopup(h, "notRequired", p, g);
  }, [h, p, g, e.required, c]), /* @__PURE__ */ M.jsx(ise, { settings: o, numColumns: e.numColumns, children: l.map((m) => /* @__PURE__ */ M.jsx(
    i_t,
    {
      choice: m,
      currentAnswerValue: c,
      noAutoNext: e.noAutoNext ?? !1,
      injectCurrent: n,
      submitAnswer: r,
      shadeButton: e.shade ?? !1
    },
    m.id
  )) });
};
function i_t({
  choice: e,
  currentAnswerValue: t,
  injectCurrent: n,
  submitAnswer: r,
  noAutoNext: i,
  shadeButton: o
}) {
  switch (e.type) {
    case "input":
      return /* @__PURE__ */ M.jsx(
        o_t,
        {
          choice: e,
          currentAnswerValue: t,
          injectCurrent: n,
          submitAnswer: r,
          noAutoNext: i,
          shadeButton: o
        }
      );
    case "commentBox":
      return /* @__PURE__ */ M.jsx(
        a_t,
        {
          choice: e,
          currentAnswerValue: t,
          injectCurrent: n,
          submitAnswer: r,
          noAutoNext: i,
          shadeButton: o
        }
      );
    default:
      return /* @__PURE__ */ M.jsx(
        s_t,
        {
          choice: e,
          currentAnswerValue: t,
          injectCurrent: n,
          submitAnswer: r,
          noAutoNext: i,
          shadeButton: o
        }
      );
  }
}
function o_t({
  choice: e,
  currentAnswerValue: t,
  injectCurrent: n
}) {
  const r = (t == null ? void 0 : t.id) === e.id && (t == null ? void 0 : t.value), { primaryColour: i } = hr(), o = /* @__PURE__ */ M.jsx(
    qk,
    {
      type: "text",
      placeholder: e.placeholder || "",
      inputValue: r || "",
      active: !!t && e.id === t.id,
      onValueChange: (a) => {
        const s = {
          id: e.id,
          value: a.target.value
        };
        n({
          value: s
        });
      },
      label: e.text ? Dr(e.text) : e.value,
      primaryColour: i
    }
  );
  return e.toolTip ? /* @__PURE__ */ M.jsx(Pf, { title: e.toolTip, children: /* @__PURE__ */ M.jsx("div", { children: o }) }) : o;
}
function a_t({
  choice: e,
  currentAnswerValue: t,
  injectCurrent: n
}) {
  const r = (t == null ? void 0 : t.id) === e.id && (t == null ? void 0 : t.value), { primaryColour: i } = hr(), o = e.minRows !== void 0 && { minRows: e.minRows }, a = /* @__PURE__ */ M.jsx(
    Uk,
    {
      type: "text",
      allowClear: !0,
      dynamicColour: i,
      placeholder: e.placeholder,
      label: e.value,
      value: r || "",
      onChange: (s) => {
        const c = {
          id: e.id,
          value: s.target.value
        };
        n({
          value: c
        });
      },
      autoSize: o
    },
    e.id
  );
  return e.toolTip ? /* @__PURE__ */ M.jsx(Pf, { title: e.toolTip, children: /* @__PURE__ */ M.jsx("div", { children: a }) }) : a;
}
function s_t({
  choice: e,
  currentAnswerValue: t,
  injectCurrent: n,
  noAutoNext: r,
  submitAnswer: i,
  shadeButton: o
}) {
  const { primaryColour: a, shadeColour: s } = hr(), c = (u) => {
    const d = { id: u.id, value: u.value };
    r ? n({ value: d }) : (n({ value: d }), i());
  }, l = /* @__PURE__ */ M.jsx(
    Dw,
    {
      active: !!t && e.id === t.id,
      colour: a,
      shadeColour: o ? s : void 0,
      buttonText: e.text ? Dr(e.text) : e.value,
      ButtonIcon: e.icon,
      fill: e.icon && e.fill ? e.fill : "",
      onClick: (u) => {
        c(e), Wd(u);
      }
    }
  );
  return e.toolTip ? /* @__PURE__ */ M.jsx(Pf, { title: e.toolTip, placement: "topLeft", children: l }, e.id) : l;
}
const c_t = (e) => null, l_t = (e) => {
  const { question: t } = e;
  switch (t.type) {
    case "welcomePage":
      return /* @__PURE__ */ M.jsx(c_t, { ...e, question: t });
    case "infoPage":
      return /* @__PURE__ */ M.jsx(Eyt, { ...e, question: t });
    case "endPage":
      return /* @__PURE__ */ M.jsx(wyt, { ...e, question: t });
    case "singleSelect":
      return /* @__PURE__ */ M.jsx(r_t, { ...e, question: t });
    case "multiSelect":
      return /* @__PURE__ */ M.jsx(_bt, { ...e, question: t });
    case "multiInput":
      return /* @__PURE__ */ M.jsx(rbt, { ...e, question: t });
    case "slider":
      return /* @__PURE__ */ M.jsx(nse, { ...e, question: t });
    case "responsiveSlider":
      return /* @__PURE__ */ M.jsx(E1t, { ...e, question: t });
    case "matrix":
      return /* @__PURE__ */ M.jsx(Lyt, { ...e, question: t });
    case "ranking":
      return /* @__PURE__ */ M.jsx(m1t, { ...e, question: t });
    case "dropdown":
      return /* @__PURE__ */ M.jsx(Syt, { ...e, question: t });
    case "multiDropdown":
      return /* @__PURE__ */ M.jsx(Wyt, { ...e, question: t });
    case "choiceExperiment":
      return /* @__PURE__ */ M.jsx(Ioe, { ...e, question: t });
    case "conjointAnalysis":
      return /* @__PURE__ */ M.jsx(uyt, { ...e, question: t });
    case "commentBox":
      return /* @__PURE__ */ M.jsx(Qvt, { ...e, question: t });
    case "choiceRank":
      return /* @__PURE__ */ M.jsx(Dht, { ...e, question: t });
    case "compareSlider":
      return /* @__PURE__ */ M.jsx(Jvt, { ...e, question: t });
    case "loggingTestPage":
      return /* @__PURE__ */ M.jsx(Cyt, { ...e, question: t });
    case "hidden":
      return /* @__PURE__ */ M.jsx(xyt, { ...e, question: t });
    case "shift":
      return /* @__PURE__ */ M.jsx(C1t, { ...e, question: t });
    case "shiftContinuous":
      return /* @__PURE__ */ M.jsx(D1t, { ...e, question: t });
    case "match":
      return /* @__PURE__ */ M.jsx(Ayt, { ...e, question: t });
    default:
      Kd();
  }
}, u_t = ({ question: e, children: t }) => {
  const n = wa();
  switch (e.type) {
    case "matrix":
      return /* @__PURE__ */ M.jsx(Uyt, { device: n, style: e.style, children: t });
    case "compareSlider":
      return /* @__PURE__ */ M.jsx(ryt, { device: n, children: t });
    case "conjointAnalysis":
    case "choiceExperiment":
      return /* @__PURE__ */ M.jsx(Nht, { device: n, style: e.style, children: t });
    default:
      return /* @__PURE__ */ M.jsx(VC, { device: n, style: e.style, children: t });
  }
}, d_t = () => {
  const { messagerService: e } = St(ir), t = Me(null), n = Me(null), r = ho();
  return gt(() => {
    const i = t.current, o = n.current;
    if (i && o) {
      e.setContainer(o);
      const a = new ResizeObserver((s) => {
        for (const c of s)
          o.style.width = `${c.contentRect.width}px`;
      });
      return a.observe(i), () => a.disconnect();
    }
  }, []), /* @__PURE__ */ M.jsx(f_t, { ref: t, children: /* @__PURE__ */ M.jsx(h_t, { ref: n, borderRadius: r }) });
}, f_t = Ce.div`
  position: relative;
`, h_t = Ce.div`
  position: fixed;
  z-index: 2;

  > .prefix-survey-message-top {
    position: unset;
    transform: unset !important;

    > .prefix-survey-message-notice-wrapper {
      padding: 0;
    }
  }

  .survey-message > .prefix-survey-message-notice-content {
    background: none;
    padding: 0;
    display: flex;
    flex-direction: column;
    gap: 1rem;
    box-shadow: 2px 2px 4.1px 2px rgba(17, 17, 17, 0.1);
    width: 100%;
    border-radius: ${({ borderRadius: e }) => e};
    .ant-alert {
      border-radius: ${({ borderRadius: e }) => e};
    }
  }

  .survey-message
    > .prefix-survey-message-notice-content
    > .prefix-survey-message-custom-content
    > span {
    width: 100%;
  }
`, g_t = (e) => {
  const t = cH(), n = wa(), { loggingService: r } = St(ir), i = mn(
    (T) => {
      t(Lle(T));
    },
    [t]
  ), o = mn(() => {
    t(sH());
  }, [t]), a = mn(
    (T) => {
      t(aH(T));
    },
    [t]
  ), [s, c] = Lt({
    left: 0,
    right: 0,
    top: 0,
    bottom: 0,
    width: 0,
    height: 0
  }), l = Me(null);
  gt(() => {
    const T = () => {
      const x = l.current;
      if (x === null)
        return;
      const { left: C, right: E, top: R, bottom: A, width: O, height: $ } = x.getBoundingClientRect();
      c({ left: C, right: E, top: R, bottom: A, width: O, height: $ });
    };
    return T(), window.addEventListener("resize", T), () => {
      window.removeEventListener("resize", T);
    };
  }, []);
  const u = new ResizeObserver((T) => {
    const x = l.current;
    if (x === null)
      return;
    const { left: C, right: E, top: R, bottom: A, width: O, height: $ } = x.getBoundingClientRect();
    c({ left: C, right: E, top: R, bottom: A, width: O, height: $ });
  });
  gt(() => {
    const T = l.current;
    return T && u.observe(T), () => {
      u.disconnect();
    };
  }, [l.current]);
  const { left: d, right: f, top: h, bottom: p, width: g, height: m } = s, v = f_((T) => T.survey.currentAnswer), y = At(() => {
    if (v)
      return new Dv(v, r);
  }, [v]), S = f_((T) => T.survey.userAnswers), _ = At(() => new xI(S, r), [S]);
  if (!y)
    return null;
  const w = {
    ...e,
    currentAnswer: y,
    answers: _,
    injectCurrent: i,
    updateCurrent: a,
    recordAnswer: o
  };
  return /* @__PURE__ */ M.jsxs(p_t, { direction: "row", device: n, children: [
    /* @__PURE__ */ M.jsxs(m_t, { style: e.question.containerStyle, children: [
      /* @__PURE__ */ M.jsxs("div", { ref: l, children: [
        /* @__PURE__ */ M.jsx(NDe, { container: { left: d, right: f, top: h, bottom: p, width: g, height: m } }),
        /* @__PURE__ */ M.jsxs(u_t, { question: e.question, children: [
          /* @__PURE__ */ M.jsx(d_t, {}),
          /* @__PURE__ */ M.jsx(ODe, { ...w }),
          /* @__PURE__ */ M.jsx(l_t, { ...w })
        ] })
      ] }),
      e.question.outputs && wz(e.question, n) === "column" && /* @__PURE__ */ M.jsx(
        sB,
        {
          outputs: e.question.outputs,
          currentAnswer: y,
          answers: _,
          settings: e.settings,
          direction: e.question.outputDirection,
          location: e.question.outputLocation,
          style: e.question.outputStyle
        }
      )
    ] }),
    e.question.outputs && wz(e.question, n) === "row" && /* @__PURE__ */ M.jsx(
      sB,
      {
        outputs: e.question.outputs,
        currentAnswer: y,
        answers: _,
        settings: e.settings,
        direction: e.question.outputDirection,
        location: e.question.outputLocation,
        style: e.question.outputStyle
      }
    )
  ] });
};
function wz(e, t) {
  return t === ui.MOBILE || t === ui.TABLET || e.outputLocation === "below" ? "column" : "row";
}
const p_t = Ce.div`
  display: flex;
  flex-direction: ${(e) => e.direction || "row"};
  align-items: ${(e) => e.direction === "column" ? "stretch" : "flex-start"};
  justify-content: center;
  width: 100%;
  /* padding: 0 30px; */
  padding: ${(e) => e.device === ui.MOBILE ? "0 16px" : "0 1rem"};
`, m_t = Ce.div`
  display: flex;
  flex-direction: column;
  align-items: stretch;
  flex: 0 1 40rem;
  padding-bottom: 10px;
  /* width: 40rem; */
`, sSt = () => {
  const {
    survey: e,
    currentQuestion: t,
    currentSurveyQuestions: n,
    submitAnswer: r,
    goToPreviousQuestion: i,
    updateSurveyControls: o,
    setNextButtonBehaviour: a,
    setPreviousButtonBehaviour: s,
    interactionDisabled: c
  } = St(mE);
  return t ? (
    // <DisableInteractionWrapper active={interactionDisabled}>
    /* @__PURE__ */ M.jsx(
      g_t,
      {
        question: t,
        settings: e.settings,
        currentSurveyQuestions: n,
        submitAnswer: r,
        goToPreviousQuestion: i,
        updateSurveyControls: o,
        setNextButtonBehaviour: a,
        setPreviousButtonBehaviour: s
      }
    )
  ) : null;
};
nce.div`
  z-index: ${({ active: e }) => e ? 9999 : -1};
  opacity: 0;
`;
const v_t = Ce.span`
  margin: auto;
`, uI = ({
  onClick: e,
  fill: t,
  stroke: n,
  hoverFill: r,
  disabled: i,
  text: o,
  arrow: a,
  compactNavButtons: s
}) => {
  const c = wa(), l = ho();
  return /* @__PURE__ */ M.jsxs(
    y_t,
    {
      borderRadius: l,
      disabled: i,
      fill: t,
      stroke: n,
      hoverFill: r,
      type: "button",
      onClick: e,
      device: c,
      compactNavButtons: s,
      children: [
        a === "left" ? /* @__PURE__ */ M.jsx(L3e, {}) : null,
        /* @__PURE__ */ M.jsx(v_t, { children: o }),
        a === "right" ? /* @__PURE__ */ M.jsx(m$e, {}) : null
      ]
    }
  );
}, y_t = Ce.button`
  position: relative;
  display: flex;
  flex: 1 1 50%;
  justify-content: space-between;
  align-items: center;
  border: none;
  height: ${(e) => e.device === ui.MOBILE && e.compactNavButtons ? "var(--compact-button-height)" : "var(--button-height)"};
  padding-left: var(--spacing-md);
  padding-right: var(--spacing-md);
  font-size: 18px;

  background-color: ${(e) => e.fill};
  border: 1px solid ${(e) => e.stroke};

  cursor: ${(e) => e.disabled ? "not-allowed" : "pointer"};

  color: white;
  border-radius: ${(e) => e.borderRadius};

  user-select: none;
  overflow: hidden;

  @media (hover: hover) and (pointer: fine) {
    &:hover {
      background-color: ${(e) => e.hoverFill};
    }
  }

  span.ripple {
    position: absolute;
    border-radius: 50%;
    transform: scale(0);
    animation: ripple 500ms linear;
    background-color: rgba(255, 255, 255, 0.7);
  }

  @keyframes ripple {
    to {
      transform: scale(4);
      opacity: 0;
    }
  }
`, b_t = {
  default: "Previous",
  mi: "O mua",
  fr: "Précédent",
  es: "Anterior",
  de: "Zurück",
  nl: "Vorige",
  it: "Indietro",
  pt: "Anterior",
  pl: "Poprzedni",
  ru: "Назад",
  ja: "前へ",
  zh: "上一页",
  tr: "Önceki",
  ko: "이전",
  ar: "السابق",
  hi: "पिछला",
  bn: "পূর্ববর্তী",
  pa: "ਪਿਛਲਾ",
  gu: "પાછળનું",
  fil: "Nakaraan",
  sm: "talu ai"
}, __t = {
  default: "Next",
  mi: "Panuku",
  fr: "Suivant",
  es: "Siguiente",
  de: "Weiter",
  nl: "Volgende",
  it: "Avanti",
  pt: "Próximo",
  pl: "Dalej",
  ru: "Далее",
  ja: "次へ",
  zh: "下一页",
  tr: "Sonraki",
  ko: "다음",
  ar: "التالي",
  hi: "अगला",
  bn: "পরবর্তী",
  pa: "ਅਗਲਾ",
  gu: "આગળ વધો",
  fil: "Susunod",
  sm: "le isi"
}, S_t = {
  default: "Submit",
  mi: "Tukuna",
  fr: "Soumettre",
  es: "Enviar",
  de: "Einreichen",
  nl: "Indienen",
  it: "Invia",
  pt: "Enviar",
  pl: "Prześlij",
  ru: "Отправить",
  ja: "提出する",
  zh: "提交",
  tr: "Gönder",
  ko: "제출",
  ar: "إرسال",
  hi: "जमा करें",
  bn: "জমা দিন",
  pa: "ਜਮਾ ਕਰੋ",
  gu: "સબમિટ કરો",
  fil: "Ipasa",
  sm: "tuʻu"
};
function cSt() {
  const {
    survey: e,
    displayBackButton: t,
    displayNextButton: n,
    displaySubmitButton: r,
    previousQuestion: i,
    nextQuestion: o,
    onSubmitSurvey: a,
    surveyControlsState: s,
    nextButtonText: c,
    hideSurveyControls: l
  } = St(mE), { primaryColour: u, primary50: d } = hr(), f = wa();
  return /* @__PURE__ */ M.jsx(w_t, { settings: e.settings, visible: !l(), children: /* @__PURE__ */ M.jsxs(x_t, { device: f, children: [
    t() ? /* @__PURE__ */ M.jsx(
      uI,
      {
        text: Dr(b_t),
        arrow: "left",
        disabled: s.prevDisabled,
        fill: u,
        stroke: u,
        hoverFill: d,
        onClick: (h) => {
          Wd(h), i();
        },
        compactNavButtons: e.settings.compactNavButtons
      }
    ) : null,
    n() ? /* @__PURE__ */ M.jsx(
      uI,
      {
        arrow: "right",
        disabled: s.nextDisabled,
        onClick: (h) => {
          Wd(h), o();
        },
        fill: u,
        stroke: u,
        hoverFill: d,
        text: c ?? Dr(__t),
        compactNavButtons: e.settings.compactNavButtons
      }
    ) : null,
    r() ? /* @__PURE__ */ M.jsx(
      uI,
      {
        text: Dr(S_t),
        fill: u,
        onClick: (h) => {
          Wd(h), a();
        },
        stroke: u,
        hoverFill: d,
        compactNavButtons: e.settings.compactNavButtons
      }
    ) : null
  ] }) });
}
const w_t = Ce.div`
  display: flex;
  margin-top: auto;
  flex-direction: row;
  justify-content: center;
  align-items: center;

  z-index: ${(e) => e.visible ? "99" : "-1"};
  visibility: ${(e) => e.visible ? "visible" : "hidden"};
  min-height: ${(e) => e.visible ? "auto" : "0"};
  flex-shrink: ${(e) => e.visible ? "0" : "100"};
`, x_t = Ce.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  gap: 2rem;
  margin: ${(e) => e.device === ui.MOBILE ? "0.5rem 30px 0.5rem" : "0.5rem 2rem var(--spacing-lg)"};

  max-width: 40rem;
  flex-grow: 1;
`;
function E_t(e) {
  return /* @__PURE__ */ M.jsx(C_t, { colour: e.colour || "black", children: /* @__PURE__ */ M.jsx(tDe, {}) });
}
const C_t = Ce.span`
  color: ${(e) => e.colour};
  font-size: 1.2em;
`, T_t = ({ children: e, isOpen: t, onClose: n }) => {
  const [r, i] = Lt({ top: 0, left: 0 }), o = Me(null), a = Me(null);
  return gt(() => {
    if (o.current && a.current && t) {
      const s = o.current.getBoundingClientRect(), c = a.current.getBoundingClientRect();
      let l = 0;
      const u = window.innerWidth - c.right;
      u < s.width && (l = u - s.width - 25), i({
        top: (c == null ? void 0 : c.height) ?? 0,
        left: l
      });
    }
  }, [t]), t ? /* @__PURE__ */ M.jsxs(M.Fragment, { children: [
    /* @__PURE__ */ M.jsx(I_t, { onClick: n }),
    /* @__PURE__ */ M.jsx(A_t, { ref: a, children: /* @__PURE__ */ M.jsxs(R_t, { ref: o, style: { top: r.top, left: r.left }, children: [
      /* @__PURE__ */ M.jsx($_t, { onClick: n, children: "×" }),
      e
    ] }) })
  ] }) : null;
}, I_t = Ce.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0);
  z-index: 1000;
`, A_t = Ce.span`
  position: relative;
  top: 0;
  left: 0;
  height: 0;
  width: 0;
`, R_t = Ce.div`
  position: absolute;
  background-color: white;
  padding: 20px;
  border-radius: 5px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  z-index: 1001;
  width: 300px;
  color: var(--dark);
  // max-width: 300px;
`, $_t = Ce.button`
  position: absolute;
  top: 5px;
  right: 5px;
  background: none;
  border: none;
  font-size: 30px;
  cursor: pointer;
  color: #333;
`, lSt = ({ children: e, startOpen: t = !1, colour: n }) => {
  const [r, i] = Lt(t), { primaryColour: o } = hr();
  return /* @__PURE__ */ M.jsxs(M.Fragment, { children: [
    /* @__PURE__ */ M.jsx(O_t, { onClick: () => i(!r), children: /* @__PURE__ */ M.jsx(E_t, { colour: n ?? o }) }),
    /* @__PURE__ */ M.jsx(T_t, { isOpen: r, onClose: () => i(!1), children: e })
  ] });
}, O_t = Ce.span`
  cursor: pointer;
`, P_t = {
  default: "complete",
  mi: "kua oti",
  fr: "complété",
  es: "completado",
  de: "abgeschlossen",
  nl: "voltooid",
  it: "completato",
  pt: "concluído",
  pl: "zakończony",
  ru: "завершено",
  ja: "完了",
  zh: "完成",
  tr: "tamamlandı",
  ko: "완료",
  ar: "مكتمل",
  hi: "पूरा",
  bn: "সম্পন্ন",
  pa: "ਮੁਕੰਮਲ",
  gu: "પૂરું",
  fil: "kumpleto",
  sm: "uma"
}, uSt = ({ percentage: e, settings: t, hide: n }) => {
  const { primaryColour: r, backgroundColour: i } = hr(), o = ho(), a = Dr(P_t);
  return n ? null : e === 0 ? /* @__PURE__ */ M.jsx(xz, { children: /* @__PURE__ */ M.jsx(Ez, { borderRadius: o, backgroundColour: i, children: /* @__PURE__ */ M.jsxs(J$, { children: [
    "0% ",
    a
  ] }) }) }) : /* @__PURE__ */ M.jsx(xz, { children: /* @__PURE__ */ M.jsxs(Ez, { borderRadius: o, backgroundColour: i, children: [
    /* @__PURE__ */ M.jsx(Ese, { children: /* @__PURE__ */ M.jsx(Cse, { percentage: e, primaryColour: r }) }),
    /* @__PURE__ */ M.jsxs(J$, { children: [
      e.toFixed(0),
      "%"
    ] })
  ] }) });
}, xz = Ce.div`
  position: absolute;
  left: 0;
  bottom: 0;
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  padding-left: var(--spacing-lg);
  padding-right: var(--spacing-lg);
  padding-bottom: var(--spacing-lg);
`, Ez = Ce.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  flex-grow: 1;
  gap: 1rem;
  height: 58px;
  background: ${(e) => e.backgroundColour};
  padding-left: 25px;
  padding-right: 25px;
  border-radius: ${(e) => e.borderRadius};
`, J$ = Ce.div`
  display: flex;
  justify-content: flex-end;
  // width: 350px;
  font-size: 0.75rem;
  text-transform: uppercase;
  letter-spacing: 0.1rem;
  min-width: 2.5rem;
  .filler {
    background: ${(e) => e.color ? e.color : "#E82D7C"};
  }
`, Ese = Ce.div`
  position: relative;
  flex-grow: 1;
  height: 8px;
  border-radius: 4px;
  background: var(--mid-light);
`, Cse = Ce.div`
  width: ${(e) => `${e.percentage}%`};
  background: ${(e) => e.primaryColour}; /* fallback for old browsers */

  height: 100%;
  border-radius: inherit;
  transition: width 0.3s ease-in;
`, dSt = ({
  percentage: e,
  settings: t,
  hide: n,
  compact: r
}) => {
  const { primaryColour: i, backgroundColour: o } = hr(), a = ho();
  return /* @__PURE__ */ M.jsx(M_t, { hide: n, children: /* @__PURE__ */ M.jsxs(
    k_t,
    {
      compact: r,
      borderRadius: a,
      backgroundColour: o,
      children: [
        /* @__PURE__ */ M.jsx(Ese, { children: /* @__PURE__ */ M.jsx(Cse, { percentage: e, primaryColour: i }) }),
        /* @__PURE__ */ M.jsxs(J$, { children: [
          e.toFixed(0),
          "%"
        ] })
      ]
    }
  ) });
}, M_t = Ce.div`
  display: flex;
  flex-direction: column;
  visibility: ${(e) => e.hide ? "hidden" : "visible"};
`, k_t = Ce.div`
  display: flex;
  margin-left: 20px;
  margin-right: 20px;
  padding-left: var(--spacing-sm);
  padding-right: var(--spacing-sm);
  height: ${(e) => e.compact ? "20px" : "var(--button-height)"};
  align-items: center;
  border-top-left-radius: ${(e) => e.borderRadius};
  border-top-right-radius: ${(e) => e.borderRadius};
  box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.25);
  transition: height 0.5s;
  overflow: hidden;
`;
export {
  Mse as AnalyticsService,
  Lse as CrashReportingService,
  Dse as DatabaseManagerService,
  ui as Device,
  W_t as FirebaseAnalyticsService,
  Z_t as FirebaseDatabaseManagerService,
  K_t as FirebaseUserManagerService,
  lSt as InfoCallout,
  E_t as InfoSymbol,
  jse as LoggingService,
  nDe as MessageMessagerService,
  Vse as MessagerService,
  dSt as MobileProgressBar,
  gSt as MockAnalyticsService,
  Fse as MockCrashReportingService,
  pSt as MockDatabaseManagerService,
  yN as MockLoggingService,
  mSt as MockMessagerService,
  vSt as MockPopupService,
  ySt as MockUserManagerService,
  Bse as PopupService,
  uSt as ProgressBar,
  iDe as RealPopupService,
  tSt as RecorderLoggingService,
  Vle as ReduxStoreManager,
  eSt as SentryCrashReportingService,
  ir as ServiceContext,
  pE as SettingsContext,
  cSt as SurveyControls,
  sSt as SurveyQuestion,
  iSt as SurveyWrapper,
  kse as UserManagerService,
  z_t as checkAtLength,
  H_t as checkEmailPattern,
  X_t as csvDataFromChoiceData,
  Y_t as csvDataFromResponses,
  bSt as getEntries,
  JN as getSecondsBetween,
  Mle as getUserDeviceType,
  nSt as initializeFirebase,
  J7 as isKeyOfResultDataMetadata,
  _St as newUser,
  B_t as parseLength,
  V_t as parseOnlyLetterAndSpace,
  s5 as processSubmission,
  Q_t as responsesFromResultData,
  ZI as resultDataMetadataMap,
  J_t as resultHeadersFromResultData,
  oH as setSubmissionId,
  hr as useColours,
  wa as useDevice,
  Z6 as useFont,
  rSt as useSurveyContext
};
//# sourceMappingURL=index.es.js.map
